
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea3c6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea3c6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $jN4Ph = parcelRequire("jN4Ph");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $jN4Ph.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $jN4Ph.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $jN4Ph.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $jN4Ph.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $jN4Ph.unstable_now, $0b2e6adb871a3b94$var$ec = $jN4Ph.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $jN4Ph.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $jN4Ph.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $jN4Ph.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $jN4Ph.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $jN4Ph.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $jN4Ph.unstable_scheduleCallback($jN4Ph.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("jN4Ph", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2ZUhe"));

});
parcelRegister("2ZUhe", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $22eceeba251b2de5$export$c4744153514ff05d, (v) => $22eceeba251b2de5$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $22eceeba251b2de5$export$3e506c1ccc9cc1a7, (v) => $22eceeba251b2de5$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $22eceeba251b2de5$export$e26fe2ed2fa76875, (v) => $22eceeba251b2de5$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $22eceeba251b2de5$export$502329bbf4b505b1, (v) => $22eceeba251b2de5$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $22eceeba251b2de5$export$6e3807111c4874c4, (v) => $22eceeba251b2de5$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $22eceeba251b2de5$export$c27134553091fb3a, (v) => $22eceeba251b2de5$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $22eceeba251b2de5$export$33ee1acdc04fd2a2, (v) => $22eceeba251b2de5$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $22eceeba251b2de5$export$b00a404bbd5edef2, (v) => $22eceeba251b2de5$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $22eceeba251b2de5$export$8352ce38b91d0c62, (v) => $22eceeba251b2de5$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $22eceeba251b2de5$export$d66a1c1c77bd778b, (v) => $22eceeba251b2de5$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $22eceeba251b2de5$export$d3dfb8e4810cb555, (v) => $22eceeba251b2de5$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $22eceeba251b2de5$export$839f9183b0465a69, (v) => $22eceeba251b2de5$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $22eceeba251b2de5$export$72fdf0e06517287b, (v) => $22eceeba251b2de5$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $22eceeba251b2de5$export$4b844e58a3e414b4, (v) => $22eceeba251b2de5$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $22eceeba251b2de5$export$816d2913ae6b83b1, (v) => $22eceeba251b2de5$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $22eceeba251b2de5$export$61bcfe829111a1d0, (v) => $22eceeba251b2de5$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $22eceeba251b2de5$export$7ee8c9beb337bc3f, (v) => $22eceeba251b2de5$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $22eceeba251b2de5$export$b5836b71941fa3ed, (v) => $22eceeba251b2de5$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $22eceeba251b2de5$export$cf845f2c119da08a, (v) => $22eceeba251b2de5$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $22eceeba251b2de5$export$c4744153514ff05d;
var $22eceeba251b2de5$export$3e506c1ccc9cc1a7;
var $22eceeba251b2de5$export$e26fe2ed2fa76875;
var $22eceeba251b2de5$export$502329bbf4b505b1;
var $22eceeba251b2de5$export$6e3807111c4874c4;
var $22eceeba251b2de5$export$c27134553091fb3a;
var $22eceeba251b2de5$export$33ee1acdc04fd2a2;
var $22eceeba251b2de5$export$b00a404bbd5edef2;
var $22eceeba251b2de5$export$8352ce38b91d0c62;
var $22eceeba251b2de5$export$d66a1c1c77bd778b;
var $22eceeba251b2de5$export$d3dfb8e4810cb555;
var $22eceeba251b2de5$export$839f9183b0465a69;
var $22eceeba251b2de5$export$72fdf0e06517287b;
var $22eceeba251b2de5$export$4b844e58a3e414b4;
var $22eceeba251b2de5$export$816d2913ae6b83b1;
var $22eceeba251b2de5$export$61bcfe829111a1d0;
var $22eceeba251b2de5$export$7ee8c9beb337bc3f;
var $22eceeba251b2de5$export$b5836b71941fa3ed;
var $22eceeba251b2de5$export$cf845f2c119da08a;
"use strict";
function $22eceeba251b2de5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $22eceeba251b2de5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $22eceeba251b2de5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $22eceeba251b2de5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $22eceeba251b2de5$var$g(C, c)) n < e && 0 > $22eceeba251b2de5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $22eceeba251b2de5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $22eceeba251b2de5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $22eceeba251b2de5$var$l = performance;
    $22eceeba251b2de5$export$c4744153514ff05d = function() {
        return $22eceeba251b2de5$var$l.now();
    };
} else {
    var $22eceeba251b2de5$var$p = Date, $22eceeba251b2de5$var$q = $22eceeba251b2de5$var$p.now();
    $22eceeba251b2de5$export$c4744153514ff05d = function() {
        return $22eceeba251b2de5$var$p.now() - $22eceeba251b2de5$var$q;
    };
}
var $22eceeba251b2de5$var$r = [], $22eceeba251b2de5$var$t = [], $22eceeba251b2de5$var$u = 1, $22eceeba251b2de5$var$v = null, $22eceeba251b2de5$var$y = 3, $22eceeba251b2de5$var$z = !1, $22eceeba251b2de5$var$A = !1, $22eceeba251b2de5$var$B = !1, $22eceeba251b2de5$var$D = "function" === typeof setTimeout ? setTimeout : null, $22eceeba251b2de5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $22eceeba251b2de5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $22eceeba251b2de5$var$G(a) {
    for(var b = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t); null !== b;){
        if (null === b.callback) $22eceeba251b2de5$var$k($22eceeba251b2de5$var$t);
        else if (b.startTime <= a) $22eceeba251b2de5$var$k($22eceeba251b2de5$var$t), b.sortIndex = b.expirationTime, $22eceeba251b2de5$var$f($22eceeba251b2de5$var$r, b);
        else break;
        b = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t);
    }
}
function $22eceeba251b2de5$var$H(a) {
    $22eceeba251b2de5$var$B = !1;
    $22eceeba251b2de5$var$G(a);
    if (!$22eceeba251b2de5$var$A) {
        if (null !== $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r)) $22eceeba251b2de5$var$A = !0, $22eceeba251b2de5$var$I($22eceeba251b2de5$var$J);
        else {
            var b = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t);
            null !== b && $22eceeba251b2de5$var$K($22eceeba251b2de5$var$H, b.startTime - a);
        }
    }
}
function $22eceeba251b2de5$var$J(a, b) {
    $22eceeba251b2de5$var$A = !1;
    $22eceeba251b2de5$var$B && ($22eceeba251b2de5$var$B = !1, $22eceeba251b2de5$var$E($22eceeba251b2de5$var$L), $22eceeba251b2de5$var$L = -1);
    $22eceeba251b2de5$var$z = !0;
    var c = $22eceeba251b2de5$var$y;
    try {
        $22eceeba251b2de5$var$G(b);
        for($22eceeba251b2de5$var$v = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r); null !== $22eceeba251b2de5$var$v && (!($22eceeba251b2de5$var$v.expirationTime > b) || a && !$22eceeba251b2de5$var$M());){
            var d = $22eceeba251b2de5$var$v.callback;
            if ("function" === typeof d) {
                $22eceeba251b2de5$var$v.callback = null;
                $22eceeba251b2de5$var$y = $22eceeba251b2de5$var$v.priorityLevel;
                var e = d($22eceeba251b2de5$var$v.expirationTime <= b);
                b = $22eceeba251b2de5$export$c4744153514ff05d();
                "function" === typeof e ? $22eceeba251b2de5$var$v.callback = e : $22eceeba251b2de5$var$v === $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r) && $22eceeba251b2de5$var$k($22eceeba251b2de5$var$r);
                $22eceeba251b2de5$var$G(b);
            } else $22eceeba251b2de5$var$k($22eceeba251b2de5$var$r);
            $22eceeba251b2de5$var$v = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r);
        }
        if (null !== $22eceeba251b2de5$var$v) var w = !0;
        else {
            var m = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t);
            null !== m && $22eceeba251b2de5$var$K($22eceeba251b2de5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $22eceeba251b2de5$var$v = null, $22eceeba251b2de5$var$y = c, $22eceeba251b2de5$var$z = !1;
    }
}
var $22eceeba251b2de5$var$N = !1, $22eceeba251b2de5$var$O = null, $22eceeba251b2de5$var$L = -1, $22eceeba251b2de5$var$P = 5, $22eceeba251b2de5$var$Q = -1;
function $22eceeba251b2de5$var$M() {
    return $22eceeba251b2de5$export$c4744153514ff05d() - $22eceeba251b2de5$var$Q < $22eceeba251b2de5$var$P ? !1 : !0;
}
function $22eceeba251b2de5$var$R() {
    if (null !== $22eceeba251b2de5$var$O) {
        var a = $22eceeba251b2de5$export$c4744153514ff05d();
        $22eceeba251b2de5$var$Q = a;
        var b = !0;
        try {
            b = $22eceeba251b2de5$var$O(!0, a);
        } finally{
            b ? $22eceeba251b2de5$var$S() : ($22eceeba251b2de5$var$N = !1, $22eceeba251b2de5$var$O = null);
        }
    } else $22eceeba251b2de5$var$N = !1;
}
var $22eceeba251b2de5$var$S;
if ("function" === typeof $22eceeba251b2de5$var$F) $22eceeba251b2de5$var$S = function() {
    $22eceeba251b2de5$var$F($22eceeba251b2de5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $22eceeba251b2de5$var$T = new MessageChannel, $22eceeba251b2de5$var$U = $22eceeba251b2de5$var$T.port2;
    $22eceeba251b2de5$var$T.port1.onmessage = $22eceeba251b2de5$var$R;
    $22eceeba251b2de5$var$S = function() {
        $22eceeba251b2de5$var$U.postMessage(null);
    };
} else $22eceeba251b2de5$var$S = function() {
    $22eceeba251b2de5$var$D($22eceeba251b2de5$var$R, 0);
};
function $22eceeba251b2de5$var$I(a) {
    $22eceeba251b2de5$var$O = a;
    $22eceeba251b2de5$var$N || ($22eceeba251b2de5$var$N = !0, $22eceeba251b2de5$var$S());
}
function $22eceeba251b2de5$var$K(a, b) {
    $22eceeba251b2de5$var$L = $22eceeba251b2de5$var$D(function() {
        a($22eceeba251b2de5$export$c4744153514ff05d());
    }, b);
}
$22eceeba251b2de5$export$3e506c1ccc9cc1a7 = 5;
$22eceeba251b2de5$export$e26fe2ed2fa76875 = 1;
$22eceeba251b2de5$export$502329bbf4b505b1 = 4;
$22eceeba251b2de5$export$6e3807111c4874c4 = 3;
$22eceeba251b2de5$export$c27134553091fb3a = null;
$22eceeba251b2de5$export$33ee1acdc04fd2a2 = 2;
$22eceeba251b2de5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$22eceeba251b2de5$export$8352ce38b91d0c62 = function() {
    $22eceeba251b2de5$var$A || $22eceeba251b2de5$var$z || ($22eceeba251b2de5$var$A = !0, $22eceeba251b2de5$var$I($22eceeba251b2de5$var$J));
};
$22eceeba251b2de5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $22eceeba251b2de5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$22eceeba251b2de5$export$d3dfb8e4810cb555 = function() {
    return $22eceeba251b2de5$var$y;
};
$22eceeba251b2de5$export$839f9183b0465a69 = function() {
    return $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r);
};
$22eceeba251b2de5$export$72fdf0e06517287b = function(a) {
    switch($22eceeba251b2de5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $22eceeba251b2de5$var$y;
    }
    var c = $22eceeba251b2de5$var$y;
    $22eceeba251b2de5$var$y = b;
    try {
        return a();
    } finally{
        $22eceeba251b2de5$var$y = c;
    }
};
$22eceeba251b2de5$export$4b844e58a3e414b4 = function() {};
$22eceeba251b2de5$export$816d2913ae6b83b1 = function() {};
$22eceeba251b2de5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $22eceeba251b2de5$var$y;
    $22eceeba251b2de5$var$y = a;
    try {
        return b();
    } finally{
        $22eceeba251b2de5$var$y = c;
    }
};
$22eceeba251b2de5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $22eceeba251b2de5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $22eceeba251b2de5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $22eceeba251b2de5$var$f($22eceeba251b2de5$var$t, a), null === $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r) && a === $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t) && ($22eceeba251b2de5$var$B ? ($22eceeba251b2de5$var$E($22eceeba251b2de5$var$L), $22eceeba251b2de5$var$L = -1) : $22eceeba251b2de5$var$B = !0, $22eceeba251b2de5$var$K($22eceeba251b2de5$var$H, c - d))) : (a.sortIndex = e, $22eceeba251b2de5$var$f($22eceeba251b2de5$var$r, a), $22eceeba251b2de5$var$A || $22eceeba251b2de5$var$z || ($22eceeba251b2de5$var$A = !0, $22eceeba251b2de5$var$I($22eceeba251b2de5$var$J)));
    return a;
};
$22eceeba251b2de5$export$b5836b71941fa3ed = $22eceeba251b2de5$var$M;
$22eceeba251b2de5$export$cf845f2c119da08a = function(a) {
    var b = $22eceeba251b2de5$var$y;
    return function() {
        var c = $22eceeba251b2de5$var$y;
        $22eceeba251b2de5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $22eceeba251b2de5$var$y = c;
        }
    };
};

});



parcelRegister("i9V5k", function(module, exports) {




(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "./core-browser",
        "./msg/en",
        "./blocks",
        "./javascript"
    ], factory);
    else module.exports = factory((parcelRequire("d9riD")), (parcelRequire("cWmWX")), (parcelRequire("94GXq")), (parcelRequire("1FOTS")));
})(module.exports, function(Blockly, En, BlocklyBlocks, BlocklyJS) {
    /**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @fileoverview Blockly module for the browser. This includes Blockly core
 * and built in blocks, the JavaScript code generator and the English block
 * localization files.
 */ /* eslint-disable */ "use strict";
    // Include the EN Locale by default.
    Blockly.setLocale(En);
    return Blockly;
});

});
parcelRegister("d9riD", function(module, exports) {

(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "./blockly"
    ], factory);
    else module.exports = factory((parcelRequire("fdn00")));
})(module.exports, function(Blockly) {
    /**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @fileoverview Blockly core module for the browser. It includes blockly.js
 *               and adds a helper method for setting the locale.
 */ /* eslint-disable */ "use strict";
    return Blockly;
});

});
parcelRegister("fdn00", function(module, exports) {

(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "./blockly_compressed"
    ], factory);
    else module.exports = factory((parcelRequire("97Mr6")));
})(module.exports, function(Blockly) {
    /**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @fileoverview Blockly module; just a wrapper for blockly_compressed.js.
 */ return Blockly;
});

});
parcelRegister("97Mr6", function(module, exports) {
// Do not edit this file; automatically generated.
(function(root1, factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else {
        var factoryExports;
        module.exports = factory();
    }
})(module.exports, function() {
    var $ = {};
    /*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ var warn$$module$build$src$core$utils$deprecation, register$$module$build$src$core$registry, validate$$module$build$src$core$registry, unregister$$module$build$src$core$registry, getItem$$module$build$src$core$registry, hasItem$$module$build$src$core$registry, getClass$$module$build$src$core$registry, getObject$$module$build$src$core$registry, getAllItems$$module$build$src$core$registry, getClassFromOptions$$module$build$src$core$registry, getWorkspaceById$$module$build$src$core$common, getAllWorkspaces$$module$build$src$core$common, registerWorkspace$$module$build$src$core$common, unregisterWorkpace$$module$build$src$core$common, getMainWorkspace$$module$build$src$core$common, setMainWorkspace$$module$build$src$core$common, getSelected$$module$build$src$core$common, setSelected$$module$build$src$core$common, getParentContainer$$module$build$src$core$common, setParentContainer$$module$build$src$core$common, svgResize$$module$build$src$core$common, getBlockTypeCounts$$module$build$src$core$common, jsonInitFactory$$module$build$src$core$common, defineBlocksWithJsonArray$$module$build$src$core$common, defineBlocksWithJsonArrayInternal$$module$build$src$core$common, getNextUniqueId$$module$build$src$core$utils$idgenerator, genUid$$module$build$src$core$utils$idgenerator, setRecordUndo$$module$build$src$core$events$utils, getRecordUndo$$module$build$src$core$events$utils, fire$$module$build$src$core$events$utils, fireInternal$$module$build$src$core$events$utils, fireNow$$module$build$src$core$events$utils, filter$$module$build$src$core$events$utils, clearPendingUndo$$module$build$src$core$events$utils, disable$$module$build$src$core$events$utils, enable$$module$build$src$core$events$utils, isEnabled$$module$build$src$core$events$utils, getGroup$$module$build$src$core$events$utils, setGroup$$module$build$src$core$events$utils, setGroupInternal$$module$build$src$core$events$utils, getDescendantIds$$module$build$src$core$events$utils, fromJson$$module$build$src$core$events$utils, eventClassHasStaticFromJson$$module$build$src$core$events$utils, get$$module$build$src$core$events$utils, disableOrphans$$module$build$src$core$events$utils, injectDependencies$$module$build$src$core$utils$xml, getDocument$$module$build$src$core$utils$xml, setDocument$$module$build$src$core$utils$xml, createTextNode$$module$build$src$core$utils$xml, textToDom$$module$build$src$core$utils$xml, textToDomDocument$$module$build$src$core$utils$xml, domToText$$module$build$src$core$utils$xml, createSvgElement$$module$build$src$core$utils$dom, addClass$$module$build$src$core$utils$dom, removeClasses$$module$build$src$core$utils$dom, removeClass$$module$build$src$core$utils$dom, hasClass$$module$build$src$core$utils$dom, removeNode$$module$build$src$core$utils$dom, insertAfter$$module$build$src$core$utils$dom, containsNode$$module$build$src$core$utils$dom, setCssTransform$$module$build$src$core$utils$dom, startTextWidthCache$$module$build$src$core$utils$dom, stopTextWidthCache$$module$build$src$core$utils$dom, getTextWidth$$module$build$src$core$utils$dom, getFastTextWidth$$module$build$src$core$utils$dom, getFastTextWidthWithSizeString$$module$build$src$core$utils$dom, measureFontMetrics$$module$build$src$core$utils$dom, alert$$module$build$src$core$dialog, setAlert$$module$build$src$core$dialog, confirm$$module$build$src$core$dialog, confirmInternal$$module$build$src$core$dialog, setConfirm$$module$build$src$core$dialog, prompt$$module$build$src$core$dialog, setPrompt$$module$build$src$core$dialog, isVariableBackedParameterModel$$module$build$src$core$interfaces$i_variable_backed_parameter_model, isLegacyProcedureDefBlock$$module$build$src$core$interfaces$i_legacy_procedure_blocks, isLegacyProcedureCallBlock$$module$build$src$core$interfaces$i_legacy_procedure_blocks, allUsedVarModels$$module$build$src$core$variables, allDeveloperVariables$$module$build$src$core$variables, flyoutCategory$$module$build$src$core$variables, flyoutCategoryBlocks$$module$build$src$core$variables, generateUniqueName$$module$build$src$core$variables, generateUniqueNameInternal$$module$build$src$core$variables, generateUniqueNameFromOptions$$module$build$src$core$variables, createVariableButtonHandler$$module$build$src$core$variables, renameVariable$$module$build$src$core$variables, promptName$$module$build$src$core$variables, nameUsedWithOtherType$$module$build$src$core$variables, nameUsedWithAnyType$$module$build$src$core$variables, nameUsedWithConflictingParam$$module$build$src$core$variables, checkForConflictingParamWithProcedureModels$$module$build$src$core$variables, checkForConflictingParamWithLegacyProcedures$$module$build$src$core$variables, generateVariableFieldDom$$module$build$src$core$variables, getOrCreateVariablePackage$$module$build$src$core$variables, getVariable$$module$build$src$core$variables, createVariable$$module$build$src$core$variables, getAddedVariables$$module$build$src$core$variables, longStart$$module$build$src$core$touch, longStop$$module$build$src$core$touch, clearTouchIdentifier$$module$build$src$core$touch, shouldHandleEvent$$module$build$src$core$touch, getTouchIdentifierFromEvent$$module$build$src$core$touch, checkTouchIdentifier$$module$build$src$core$touch, setClientFromTouch$$module$build$src$core$touch, isMouseOrTouchEvent$$module$build$src$core$touch, isTouchEvent$$module$build$src$core$touch, splitEventByTouches$$module$build$src$core$touch, conditionalBind$$module$build$src$core$browser_events, bind$$module$build$src$core$browser_events, unbind$$module$build$src$core$browser_events, isTargetInput$$module$build$src$core$browser_events, isRightButton$$module$build$src$core$browser_events, mouseToSvg$$module$build$src$core$browser_events, getScrollDeltaPixels$$module$build$src$core$browser_events, register$$module$build$src$core$css, inject$$module$build$src$core$css, getSize$$module$build$src$core$utils$style, getSizeInternal$$module$build$src$core$utils$style, getSizeWithDisplay$$module$build$src$core$utils$style, getComputedStyle$$module$build$src$core$utils$style, getCascadedStyle$$module$build$src$core$utils$style, getPageOffset$$module$build$src$core$utils$style, getViewportPageOffset$$module$build$src$core$utils$style, getBorderBox$$module$build$src$core$utils$style, scrollIntoContainerView$$module$build$src$core$utils$style, getContainerOffsetToScrollInto$$module$build$src$core$utils$style, getRelativeXY$$module$build$src$core$utils$svg_math, getInjectionDivXY$$module$build$src$core$utils$svg_math, is3dSupported$$module$build$src$core$utils$svg_math, getViewportBBox$$module$build$src$core$utils$svg_math, getDocumentScroll$$module$build$src$core$utils$svg_math, screenToWsCoordinates$$module$build$src$core$utils$svg_math, workspaceToDom$$module$build$src$core$xml, variablesToDom$$module$build$src$core$xml, blockToDomWithXY$$module$build$src$core$xml, fieldToDom$$module$build$src$core$xml, allFieldsToDom$$module$build$src$core$xml, blockToDom$$module$build$src$core$xml, cloneShadow$$module$build$src$core$xml, domToText$$module$build$src$core$xml, domToPrettyText$$module$build$src$core$xml, textToDom$$module$build$src$core$xml, clearWorkspaceAndLoadFromXml$$module$build$src$core$xml, domToWorkspace$$module$build$src$core$xml, appendDomToWorkspace$$module$build$src$core$xml, domToBlock$$module$build$src$core$xml, domToVariables$$module$build$src$core$xml, mapSupportedXmlTags$$module$build$src$core$xml, applyMutationTagNodes$$module$build$src$core$xml, applyCommentTagNodes$$module$build$src$core$xml, applyDataTagNodes$$module$build$src$core$xml, applyFieldTagNodes$$module$build$src$core$xml, findChildBlocks$$module$build$src$core$xml, applyInputTagNodes$$module$build$src$core$xml, applyNextTagNodes$$module$build$src$core$xml, domToBlockHeadless$$module$build$src$core$xml, domToField$$module$build$src$core$xml, deleteNext$$module$build$src$core$xml, isElement$$module$build$src$core$xml, register$$module$build$src$core$serialization$registry, unregister$$module$build$src$core$serialization$registry, save$$module$build$src$core$serialization$blocks, saveAttributes$$module$build$src$core$serialization$blocks, saveCoords$$module$build$src$core$serialization$blocks, saveExtraState$$module$build$src$core$serialization$blocks, saveIcons$$module$build$src$core$serialization$blocks, saveFields$$module$build$src$core$serialization$blocks, saveInputBlocks$$module$build$src$core$serialization$blocks, saveNextBlocks$$module$build$src$core$serialization$blocks, saveConnection$$module$build$src$core$serialization$blocks, append$$module$build$src$core$serialization$blocks, appendInternal$$module$build$src$core$serialization$blocks, appendPrivate$$module$build$src$core$serialization$blocks, loadCoords$$module$build$src$core$serialization$blocks, loadAttributes$$module$build$src$core$serialization$blocks, loadExtraState$$module$build$src$core$serialization$blocks, tryToConnectParent$$module$build$src$core$serialization$blocks, loadIcons$$module$build$src$core$serialization$blocks, loadFields$$module$build$src$core$serialization$blocks, loadInputBlocks$$module$build$src$core$serialization$blocks, loadNextBlocks$$module$build$src$core$serialization$blocks, loadConnection$$module$build$src$core$serialization$blocks, initBlock$$module$build$src$core$serialization$blocks, connectReciprocally$$module$build$src$core$connection, getSingleConnection$$module$build$src$core$connection, getConnectionForOrphanedOutput$$module$build$src$core$connection, toRadians$$module$build$src$core$utils$math, toDegrees$$module$build$src$core$utils$math, clamp$$module$build$src$core$utils$math, createDom$$module$build$src$core$dropdowndiv, setBoundsElement$$module$build$src$core$dropdowndiv, getOwner$$module$build$src$core$dropdowndiv, getContentDiv$$module$build$src$core$dropdowndiv, clearContent$$module$build$src$core$dropdowndiv, setColour$$module$build$src$core$dropdowndiv, showPositionedByBlock$$module$build$src$core$dropdowndiv, showPositionedByField$$module$build$src$core$dropdowndiv, getScaledBboxOfBlock$$module$build$src$core$dropdowndiv, getScaledBboxOfField$$module$build$src$core$dropdowndiv, showPositionedByRect$$module$build$src$core$dropdowndiv, show$$module$build$src$core$dropdowndiv, getPositionBelowMetrics$$module$build$src$core$dropdowndiv, getPositionAboveMetrics$$module$build$src$core$dropdowndiv, getPositionTopOfPageMetrics$$module$build$src$core$dropdowndiv, getPositionX$$module$build$src$core$dropdowndiv, isVisible$$module$build$src$core$dropdowndiv, hideIfOwner$$module$build$src$core$dropdowndiv, hide$$module$build$src$core$dropdowndiv, hideWithoutAnimation$$module$build$src$core$dropdowndiv, positionInternal$$module$build$src$core$dropdowndiv, repositionForWindowResize$$module$build$src$core$dropdowndiv, startsWith$$module$build$src$core$utils$string, shortestStringLength$$module$build$src$core$utils$string, commonWordPrefix$$module$build$src$core$utils$string, commonWordSuffix$$module$build$src$core$utils$string, wrap$$module$build$src$core$utils$string, wrapLine$$module$build$src$core$utils$string, wrapScore$$module$build$src$core$utils$string, wrapMutate$$module$build$src$core$utils$string, wrapToText$$module$build$src$core$utils$string, isNumber$$module$build$src$core$utils$string, setCustomTooltip$$module$build$src$core$tooltip, getCustomTooltip$$module$build$src$core$tooltip, isVisible$$module$build$src$core$tooltip, getDiv$$module$build$src$core$tooltip, getTooltipOfObject$$module$build$src$core$tooltip, getTargetObject$$module$build$src$core$tooltip, createDom$$module$build$src$core$tooltip, bindMouseEvents$$module$build$src$core$tooltip, unbindMouseEvents$$module$build$src$core$tooltip, onMouseOver$$module$build$src$core$tooltip, onMouseOut$$module$build$src$core$tooltip, onMouseMove$$module$build$src$core$tooltip, dispose$$module$build$src$core$tooltip, hide$$module$build$src$core$tooltip, block$$module$build$src$core$tooltip, unblock$$module$build$src$core$tooltip, renderContent$$module$build$src$core$tooltip, renderDefaultContent$$module$build$src$core$tooltip, getPosition$$module$build$src$core$tooltip, show$$module$build$src$core$tooltip, getHsvSaturation$$module$build$src$core$utils$colour, setHsvSaturation$$module$build$src$core$utils$colour, getHsvValue$$module$build$src$core$utils$colour, setHsvValue$$module$build$src$core$utils$colour, parse$$module$build$src$core$utils$colour, rgbToHex$$module$build$src$core$utils$colour, hexToRgb$$module$build$src$core$utils$colour, hsvToHex$$module$build$src$core$utils$colour, blend$$module$build$src$core$utils$colour, hueToHex$$module$build$src$core$utils$colour, tokenizeInterpolationInternal$$module$build$src$core$utils$parsing, tokenizeInterpolation$$module$build$src$core$utils$parsing, replaceMessageReferences$$module$build$src$core$utils$parsing, checkMessageReferences$$module$build$src$core$utils$parsing, parseBlockColour$$module$build$src$core$utils$parsing, getDiv$$module$build$src$core$widgetdiv, testOnly_setDiv$$module$build$src$core$widgetdiv, createDom$$module$build$src$core$widgetdiv, show$$module$build$src$core$widgetdiv, hide$$module$build$src$core$widgetdiv, isVisible$$module$build$src$core$widgetdiv, hideIfOwner$$module$build$src$core$widgetdiv, positionInternal$$module$build$src$core$widgetdiv, positionWithAnchor$$module$build$src$core$widgetdiv, calculateX$$module$build$src$core$widgetdiv, calculateY$$module$build$src$core$widgetdiv, register$$module$build$src$core$field_registry, unregister$$module$build$src$core$field_registry, fromJson$$module$build$src$core$field_registry, fromJsonInternal$$module$build$src$core$field_registry, setRole$$module$build$src$core$utils$aria, setState$$module$build$src$core$utils$aria, trimOptions$$module$build$src$core$field_dropdown, applyTrim$$module$build$src$core$field_dropdown, validateOptions$$module$build$src$core$field_dropdown, inherits$$module$build$src$core$utils$object, mixin$$module$build$src$core$utils$object, deepMerge$$module$build$src$core$utils$object, values$$module$build$src$core$utils$object, convertToolboxDefToJson$$module$build$src$core$utils$toolbox, validateToolbox$$module$build$src$core$utils$toolbox, convertFlyoutDefToJsonArray$$module$build$src$core$utils$toolbox, hasCategories$$module$build$src$core$utils$toolbox, hasCategoriesInternal$$module$build$src$core$utils$toolbox, isCategoryCollapsible$$module$build$src$core$utils$toolbox, convertToToolboxJson$$module$build$src$core$utils$toolbox, xmlToJsonArray$$module$build$src$core$utils$toolbox, addAttributes$$module$build$src$core$utils$toolbox, parseToolboxTree$$module$build$src$core$utils$toolbox, registerMixin$$module$build$src$core$extensions, unregister$$module$build$src$core$extensions, isRegistered$$module$build$src$core$extensions, apply$$module$build$src$core$extensions, checkNoMutatorProperties$$module$build$src$core$extensions, checkXmlHooks$$module$build$src$core$extensions, checkJsonHooks$$module$build$src$core$extensions, checkMutatorDialog$$module$build$src$core$extensions, checkHasFunctionPair$$module$build$src$core$extensions, checkHasMutatorProperties$$module$build$src$core$extensions, getMutatorProperties$$module$build$src$core$extensions, mutatorPropertiesMatch$$module$build$src$core$extensions, runAfterPageLoad$$module$build$src$core$extensions, checkDropdownOptionsInTable$$module$build$src$core$extensions, extensionParentTooltip$$module$build$src$core$extensions, removeElem$$module$build$src$core$utils$array, disposeUiEffect$$module$build$src$core$block_animations, disposeUiStep$$module$build$src$core$block_animations, connectionUiEffect$$module$build$src$core$block_animations, connectionUiStep$$module$build$src$core$block_animations, disconnectUiEffect$$module$build$src$core$block_animations, disconnectUiStep$$module$build$src$core$block_animations, disconnectUiStop$$module$build$src$core$block_animations, bumpObjectIntoBounds$$module$build$src$core$bump_objects, bumpIntoBoundsHandler$$module$build$src$core$bump_objects, extractObjectFromEvent$$module$build$src$core$bump_objects, bumpTopObjectsIntoBounds$$module$build$src$core$bump_objects, initIconData$$module$build$src$core$block_dragger, copy$$module$build$src$core$clipboard, copyInternal$$module$build$src$core$clipboard, paste$$module$build$src$core$clipboard, duplicate$$module$build$src$core$clipboard, duplicateInternal$$module$build$src$core$clipboard, getCurrentBlock$$module$build$src$core$contextmenu, setCurrentBlock$$module$build$src$core$contextmenu, show$$module$build$src$core$contextmenu, populate_$$module$build$src$core$contextmenu, position_$$module$build$src$core$contextmenu, createWidget_$$module$build$src$core$contextmenu, haltPropagation$$module$build$src$core$contextmenu, hide$$module$build$src$core$contextmenu, dispose$$module$build$src$core$contextmenu, callbackFactory$$module$build$src$core$contextmenu, commentDeleteOption$$module$build$src$core$contextmenu, commentDuplicateOption$$module$build$src$core$contextmenu, workspaceCommentOption$$module$build$src$core$contextmenu, getParentConnection$$module$build$src$core$keyboard_nav$ast_node, point$$module$build$src$core$utils$svg_paths, curve$$module$build$src$core$utils$svg_paths, moveTo$$module$build$src$core$utils$svg_paths, moveBy$$module$build$src$core$utils$svg_paths, lineTo$$module$build$src$core$utils$svg_paths, line$$module$build$src$core$utils$svg_paths, lineOnAxis$$module$build$src$core$utils$svg_paths, arc$$module$build$src$core$utils$svg_paths, queueRender$$module$build$src$core$render_management, queueBlock$$module$build$src$core$render_management, doRenders$$module$build$src$core$render_management, renderBlock$$module$build$src$core$render_management, updateConnectionLocations$$module$build$src$core$render_management, updateIconLocations$$module$build$src$core$render_management, registerUndo$$module$build$src$core$contextmenu_items, registerRedo$$module$build$src$core$contextmenu_items, registerCleanup$$module$build$src$core$contextmenu_items, toggleOption_$$module$build$src$core$contextmenu_items, registerCollapse$$module$build$src$core$contextmenu_items, registerExpand$$module$build$src$core$contextmenu_items, addDeletableBlocks_$$module$build$src$core$contextmenu_items, getDeletableBlocks_$$module$build$src$core$contextmenu_items, deleteNext_$$module$build$src$core$contextmenu_items, registerDeleteAll$$module$build$src$core$contextmenu_items, registerWorkspaceOptions_$$module$build$src$core$contextmenu_items, registerDuplicate$$module$build$src$core$contextmenu_items, registerComment$$module$build$src$core$contextmenu_items, registerInline$$module$build$src$core$contextmenu_items, registerCollapseExpandBlock$$module$build$src$core$contextmenu_items, registerDisable$$module$build$src$core$contextmenu_items, registerDelete$$module$build$src$core$contextmenu_items, registerHelp$$module$build$src$core$contextmenu_items, registerBlockOptions_$$module$build$src$core$contextmenu_items, registerDefaultOptions$$module$build$src$core$contextmenu_items, isProcedureBlock$$module$build$src$core$interfaces$i_procedure_block, isObservable$$module$build$src$core$interfaces$i_observable, allProcedures$$module$build$src$core$procedures, procTupleComparator$$module$build$src$core$procedures, findLegalName$$module$build$src$core$procedures, isLegalName$$module$build$src$core$procedures, isNameUsed$$module$build$src$core$procedures, rename$$module$build$src$core$procedures, flyoutCategory$$module$build$src$core$procedures, updateMutatorFlyout$$module$build$src$core$procedures, mutatorOpenListener$$module$build$src$core$procedures, mutatorChangeListener$$module$build$src$core$procedures, getCallers$$module$build$src$core$procedures, blockIsModernCallerFor$$module$build$src$core$procedures, mutateCallers$$module$build$src$core$procedures, getDefinition$$module$build$src$core$procedures, isDynamicShape$$module$build$src$core$renderers$common$constants, isDebuggerEnabled$$module$build$src$core$renderers$common$debug, startDebugger$$module$build$src$core$renderers$common$debug, stopDebugger$$module$build$src$core$renderers$common$debug, register$$module$build$src$core$renderers$common$block_rendering, unregister$$module$build$src$core$renderers$common$block_rendering, stopDebugger$$module$build$src$core$renderers$common$block_rendering, init$$module$build$src$core$renderers$common$block_rendering, stringButtonClickHandler$$module$build$src$core$variables_dynamic, numberButtonClickHandler$$module$build$src$core$variables_dynamic, colourButtonClickHandler$$module$build$src$core$variables_dynamic, flyoutCategory$$module$build$src$core$variables_dynamic, flyoutCategoryBlocks$$module$build$src$core$variables_dynamic, getStartPositionRect$$module$build$src$core$positionable_helpers, getCornerOppositeToolbox$$module$build$src$core$positionable_helpers, bumpPositionRect$$module$build$src$core$positionable_helpers, resizeSvgContents$$module$build$src$core$workspace_svg, inject$$module$build$src$core$inject, createDom$$module$build$src$core$inject, createMainWorkspace$$module$build$src$core$inject, init$$module$build$src$core$inject, onKeyDown$$module$build$src$core$inject, bindDocumentEvents$$module$build$src$core$inject, loadSounds$$module$build$src$core$inject, saveProcedure$$module$build$src$core$serialization$procedures, saveParameter$$module$build$src$core$serialization$procedures, loadProcedure$$module$build$src$core$serialization$procedures, loadParameter$$module$build$src$core$serialization$procedures, save$$module$build$src$core$serialization$workspaces, load$$module$build$src$core$serialization$workspaces, registerEscape$$module$build$src$core$shortcut_items, registerDelete$$module$build$src$core$shortcut_items, registerCopy$$module$build$src$core$shortcut_items, registerCut$$module$build$src$core$shortcut_items, registerPaste$$module$build$src$core$shortcut_items, registerUndo$$module$build$src$core$shortcut_items, registerRedo$$module$build$src$core$shortcut_items, registerDefaultShortcuts$$module$build$src$core$shortcut_items, isSelectableToolboxItem$$module$build$src$core$interfaces$i_selectable_toolbox_item, getRelativeXY$$module$build$src$core$utils, getInjectionDivXY$$module$build$src$core$utils, tokenizeInterpolation$$module$build$src$core$utils, replaceMessageReferences$$module$build$src$core$utils, checkMessageReferences$$module$build$src$core$utils, is3dSupported$$module$build$src$core$utils, getViewportBBox$$module$build$src$core$utils, arrayRemove$$module$build$src$core$utils, getDocumentScroll$$module$build$src$core$utils, getBlockTypeCounts$$module$build$src$core$utils, screenToWsCoordinates$$module$build$src$core$utils, parseBlockColour$$module$build$src$core$utils, runAfterPageLoad$$module$build$src$core$utils, hideChaff$$module$build$src$core$blockly, resizeSvgContentsLocal$$module$build$src$core$blockly, copy$$module$build$src$core$blockly, paste$$module$build$src$core$blockly, duplicate$$module$build$src$core$blockly, isNumber$$module$build$src$core$blockly, hueToHex$$module$build$src$core$blockly, bindEvent_$$module$build$src$core$blockly, unbindEvent_$$module$build$src$core$blockly, bindEventWithChecks_$$module$build$src$core$blockly, $jscomp;
    warn$$module$build$src$core$utils$deprecation = function(a, b, c, d) {
        a = a + " was deprecated in " + b + " and will be deleted in " + c + ".";
        d && (a += "\nUse " + d + " instead.");
        console.warn(a);
    };
    register$$module$build$src$core$registry = function(a, b, c, d) {
        if (!(a instanceof Type$$module$build$src$core$registry) && "string" !== typeof a || "" === `${a}`.trim()) throw Error('Invalid type "' + a + '". The type must be a non-empty string or a Blockly.registry.Type.');
        a = `${a}`.toLowerCase();
        if ("string" !== typeof b || "" === b.trim()) throw Error('Invalid name "' + b + '". The name must be a non-empty string.');
        const e = b.toLowerCase();
        if (!c) throw Error("Can not register a null value");
        let f = typeMap$$module$build$src$core$registry[a], g = nameMap$$module$build$src$core$registry[a];
        f || (f = typeMap$$module$build$src$core$registry[a] = Object.create(null), g = nameMap$$module$build$src$core$registry[a] = Object.create(null));
        validate$$module$build$src$core$registry(a, c);
        if (!d && f[e]) throw Error('Name "' + e + '" with type "' + a + '" already registered.');
        f[e] = c;
        g[e] = b;
    };
    validate$$module$build$src$core$registry = function(a, b) {
        switch(a){
            case String(Type$$module$build$src$core$registry.FIELD):
                if ("function" !== typeof b.fromJson) throw Error('Type "' + a + '" must have a fromJson function');
        }
    };
    unregister$$module$build$src$core$registry = function(a, b) {
        a = `${a}`.toLowerCase();
        b = b.toLowerCase();
        const c = typeMap$$module$build$src$core$registry[a];
        c && c[b] ? (delete typeMap$$module$build$src$core$registry[a][b], delete nameMap$$module$build$src$core$registry[a][b]) : console.warn("Unable to unregister [" + b + "][" + a + "] from the registry.");
    };
    getItem$$module$build$src$core$registry = function(a, b, c) {
        a = `${a}`.toLowerCase();
        b = b.toLowerCase();
        const d = typeMap$$module$build$src$core$registry[a];
        if (!d || !d[b]) {
            b = "Unable to find [" + b + "][" + a + "] in the registry.";
            if (c) throw Error(b + " You must require or register a " + a + " plugin.");
            console.warn(b);
            return null;
        }
        return d[b];
    };
    hasItem$$module$build$src$core$registry = function(a, b) {
        a = `${a}`.toLowerCase();
        b = b.toLowerCase();
        return (a = typeMap$$module$build$src$core$registry[a]) ? !!a[b] : !1;
    };
    getClass$$module$build$src$core$registry = function(a, b, c) {
        return getItem$$module$build$src$core$registry(a, b, c);
    };
    getObject$$module$build$src$core$registry = function(a, b, c) {
        return getItem$$module$build$src$core$registry(a, b, c);
    };
    getAllItems$$module$build$src$core$registry = function(a, b, c) {
        a = `${a}`.toLowerCase();
        var d = typeMap$$module$build$src$core$registry[a];
        if (!d) {
            d = `Unable to find [${a}] in the registry.`;
            if (c) throw Error(`${d} You must require or register a ${a} plugin.`);
            console.warn(d);
            return null;
        }
        if (!b) return d;
        a = nameMap$$module$build$src$core$registry[a];
        c = Object.create(null);
        for (const e of Object.keys(d))c[a[e]] = d[e];
        return c;
    };
    getClassFromOptions$$module$build$src$core$registry = function(a, b, c) {
        b = b.plugins[String(a)] || DEFAULT$$module$build$src$core$registry;
        return "function" === typeof b ? b : getClass$$module$build$src$core$registry(a, b, c);
    };
    getWorkspaceById$$module$build$src$core$common = function(a) {
        return WorkspaceDB_$$module$build$src$core$common[a] || null;
    };
    getAllWorkspaces$$module$build$src$core$common = function() {
        const a = [];
        for(const b in WorkspaceDB_$$module$build$src$core$common)a.push(WorkspaceDB_$$module$build$src$core$common[b]);
        return a;
    };
    registerWorkspace$$module$build$src$core$common = function(a) {
        WorkspaceDB_$$module$build$src$core$common[a.id] = a;
    };
    unregisterWorkpace$$module$build$src$core$common = function(a) {
        delete WorkspaceDB_$$module$build$src$core$common[a.id];
    };
    getMainWorkspace$$module$build$src$core$common = function() {
        return mainWorkspace$$module$build$src$core$common;
    };
    setMainWorkspace$$module$build$src$core$common = function(a) {
        mainWorkspace$$module$build$src$core$common = a;
    };
    getSelected$$module$build$src$core$common = function() {
        return selected$$module$build$src$core$common;
    };
    setSelected$$module$build$src$core$common = function(a) {
        selected$$module$build$src$core$common = a;
    };
    getParentContainer$$module$build$src$core$common = function() {
        return parentContainer$$module$build$src$core$common;
    };
    setParentContainer$$module$build$src$core$common = function(a) {
        parentContainer$$module$build$src$core$common = a;
    };
    svgResize$$module$build$src$core$common = function(a) {
        for(; a.options.parentWorkspace;)a = a.options.parentWorkspace;
        const b = a.getParentSvg(), c = a.getCachedParentSvgSize();
        var d = b.parentElement;
        if (d instanceof HTMLElement) {
            var e = d.offsetWidth;
            d = d.offsetHeight;
            c.width !== e && (b.setAttribute("width", e + "px"), a.setCachedParentSvgSize(e, null));
            c.height !== d && (b.setAttribute("height", d + "px"), a.setCachedParentSvgSize(null, d));
            a.resize();
        }
    };
    getBlockTypeCounts$$module$build$src$core$common = function(a, b) {
        const c = Object.create(null), d = a.getDescendants(!0);
        b && (a = a.getNextBlock()) && (a = d.indexOf(a), d.splice(a, d.length - a));
        for(let e = 0, f; f = d[e]; e++)c[f.type] ? c[f.type]++ : c[f.type] = 1;
        return c;
    };
    jsonInitFactory$$module$build$src$core$common = function(a) {
        return function() {
            this.jsonInit(a);
        };
    };
    defineBlocksWithJsonArray$$module$build$src$core$common = function(a) {
        TEST_ONLY$$module$build$src$core$common.defineBlocksWithJsonArrayInternal(a);
    };
    defineBlocksWithJsonArrayInternal$$module$build$src$core$common = function(a) {
        $.defineBlocks$$module$build$src$core$common($.createBlockDefinitionsFromJsonArray$$module$build$src$core$common(a));
    };
    $.createBlockDefinitionsFromJsonArray$$module$build$src$core$common = function(a) {
        const b = {};
        for(let c = 0; c < a.length; c++){
            const d = a[c];
            if (!d) {
                console.warn(`Block definition #${c} in JSON array is ${d}. Skipping`);
                continue;
            }
            const e = d.type;
            e ? b[e] = {
                init: jsonInitFactory$$module$build$src$core$common(d)
            } : console.warn(`Block definition #${c} in JSON array is missing a type attribute. ` + "Skipping.");
        }
        return b;
    };
    $.defineBlocks$$module$build$src$core$common = function(a) {
        for (const b of Object.keys(a)){
            const c = a[b];
            b in Blocks$$module$build$src$core$blocks && console.warn(`Block definiton "${b}" overwrites previous definition.`);
            Blocks$$module$build$src$core$blocks[b] = c;
        }
    };
    getNextUniqueId$$module$build$src$core$utils$idgenerator = function() {
        return "blockly-" + (nextId$$module$build$src$core$utils$idgenerator++).toString(36);
    };
    genUid$$module$build$src$core$utils$idgenerator = function() {
        return internal$$module$build$src$core$utils$idgenerator.genUid();
    };
    setRecordUndo$$module$build$src$core$events$utils = function(a) {
        recordUndo$$module$build$src$core$events$utils = a;
    };
    getRecordUndo$$module$build$src$core$events$utils = function() {
        return recordUndo$$module$build$src$core$events$utils;
    };
    fire$$module$build$src$core$events$utils = function(a) {
        TEST_ONLY$$module$build$src$core$events$utils.fireInternal(a);
    };
    fireInternal$$module$build$src$core$events$utils = function(a) {
        if (isEnabled$$module$build$src$core$events$utils()) {
            if (!FIRE_QUEUE$$module$build$src$core$events$utils.length) try {
                requestAnimationFrame(()=>{
                    setTimeout(fireNow$$module$build$src$core$events$utils, 0);
                });
            } catch (b) {
                setTimeout(fireNow$$module$build$src$core$events$utils, 0);
            }
            FIRE_QUEUE$$module$build$src$core$events$utils.push(a);
        }
    };
    fireNow$$module$build$src$core$events$utils = function() {
        const a = filter$$module$build$src$core$events$utils(FIRE_QUEUE$$module$build$src$core$events$utils, !0);
        FIRE_QUEUE$$module$build$src$core$events$utils.length = 0;
        for(let b = 0, c; c = a[b]; b++){
            if (!c.workspaceId) continue;
            const d = getWorkspaceById$$module$build$src$core$common(c.workspaceId);
            d && d.fireChangeListener(c);
        }
    };
    filter$$module$build$src$core$events$utils = function(a, b) {
        a = a.slice();
        b || a.reverse();
        const c = [], d = Object.create(null);
        for(let g = 0, h; h = a[g]; g++)if (!h.isNull()) {
            var e = [
                h.isUiEvent ? UI$$module$build$src$core$events$utils : h.type,
                h.blockId,
                h.workspaceId
            ].join(" "), f = d[e];
            const k = f ? f.event : null;
            if (!f) d[e] = {
                event: h,
                index: g
            }, c.push(h);
            else if (h.type === MOVE$$module$build$src$core$events$utils && f.index === g - 1) e = h, k.newParentId = e.newParentId, k.newInputName = e.newInputName, k.newCoordinate = e.newCoordinate, f.index = g;
            else if (h.type === CHANGE$$module$build$src$core$events$utils && h.element === k.element && h.name === k.name) k.newValue = h.newValue;
            else if (h.type === VIEWPORT_CHANGE$$module$build$src$core$events$utils) f = h, k.viewTop = f.viewTop, k.viewLeft = f.viewLeft, k.scale = f.scale, k.oldScale = f.oldScale;
            else if (h.type !== CLICK$$module$build$src$core$events$utils || k.type !== BUBBLE_OPEN$$module$build$src$core$events$utils) d[e] = {
                event: h,
                index: g
            }, c.push(h);
        }
        a = c.filter(function(g) {
            return !g.isNull();
        });
        b || a.reverse();
        for(let g = 1, h; h = a[g]; g++)h.type === CHANGE$$module$build$src$core$events$utils && "mutation" === h.element && a.unshift(a.splice(g, 1)[0]);
        return a;
    };
    clearPendingUndo$$module$build$src$core$events$utils = function() {
        for(let a = 0, b; b = FIRE_QUEUE$$module$build$src$core$events$utils[a]; a++)b.recordUndo = !1;
    };
    disable$$module$build$src$core$events$utils = function() {
        disabled$$module$build$src$core$events$utils++;
    };
    enable$$module$build$src$core$events$utils = function() {
        disabled$$module$build$src$core$events$utils--;
    };
    isEnabled$$module$build$src$core$events$utils = function() {
        return 0 === disabled$$module$build$src$core$events$utils;
    };
    getGroup$$module$build$src$core$events$utils = function() {
        return group$$module$build$src$core$events$utils;
    };
    setGroup$$module$build$src$core$events$utils = function(a) {
        TEST_ONLY$$module$build$src$core$events$utils.setGroupInternal(a);
    };
    setGroupInternal$$module$build$src$core$events$utils = function(a) {
        group$$module$build$src$core$events$utils = "boolean" === typeof a ? a ? genUid$$module$build$src$core$utils$idgenerator() : "" : a;
    };
    getDescendantIds$$module$build$src$core$events$utils = function(a) {
        const b = [];
        a = a.getDescendants(!1);
        for(let c = 0, d; d = a[c]; c++)b[c] = d.id;
        return b;
    };
    fromJson$$module$build$src$core$events$utils = function(a, b) {
        var c = get$$module$build$src$core$events$utils(a.type);
        if (!c) throw Error("Unknown event type.");
        if (eventClassHasStaticFromJson$$module$build$src$core$events$utils(c)) return c.fromJson(a, b);
        c = new c;
        c.fromJson(a);
        c.workspaceId = b.id;
        return c;
    };
    eventClassHasStaticFromJson$$module$build$src$core$events$utils = function(a) {
        return Object.getOwnPropertyDescriptors(a).fromJson && "function" === typeof a.fromJson;
    };
    get$$module$build$src$core$events$utils = function(a) {
        const b = getClass$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, a);
        if (!b) throw Error(`Event type ${a} not found in registry.`);
        return b;
    };
    disableOrphans$$module$build$src$core$events$utils = function(a) {
        if ((a.type === MOVE$$module$build$src$core$events$utils || a.type === CREATE$$module$build$src$core$events$utils) && a.workspaceId) {
            var b = getWorkspaceById$$module$build$src$core$common(a.workspaceId);
            if (!a.blockId) throw Error("Encountered a blockEvent without a proper blockId");
            if (a = b.getBlockById(a.blockId)) {
                const c = recordUndo$$module$build$src$core$events$utils;
                try {
                    recordUndo$$module$build$src$core$events$utils = !1;
                    const d = a.getParent();
                    if (d && d.isEnabled()) {
                        const e = a.getDescendants(!1);
                        for(let f = 0, g; g = e[f]; f++)g.setEnabled(!0);
                    } else if ((a.outputConnection || a.previousConnection) && !b.isDragging()) do a.setEnabled(!1), a = a.getNextBlock();
                    while (a);
                } finally{
                    recordUndo$$module$build$src$core$events$utils = c;
                }
            }
        }
    };
    injectDependencies$$module$build$src$core$utils$xml = function(a) {
        ({ document: document$$module$build$src$core$utils$xml = document$$module$build$src$core$utils$xml, DOMParser: DOMParser$$module$build$src$core$utils$xml = DOMParser$$module$build$src$core$utils$xml, XMLSerializer: XMLSerializer$$module$build$src$core$utils$xml = XMLSerializer$$module$build$src$core$utils$xml } = a);
    };
    getDocument$$module$build$src$core$utils$xml = function() {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.xml.getDocument", "version 9", "version 10");
        return document$$module$build$src$core$utils$xml;
    };
    setDocument$$module$build$src$core$utils$xml = function(a) {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.xml.setDocument", "version 9", "version 10");
        document$$module$build$src$core$utils$xml = a;
    };
    $.createElement$$module$build$src$core$utils$xml = function(a) {
        return document$$module$build$src$core$utils$xml.createElementNS(NAME_SPACE$$module$build$src$core$utils$xml, a);
    };
    createTextNode$$module$build$src$core$utils$xml = function(a) {
        return document$$module$build$src$core$utils$xml.createTextNode(a);
    };
    textToDom$$module$build$src$core$utils$xml = function(a) {
        const b = textToDomDocument$$module$build$src$core$utils$xml(a);
        if (!b || !b.documentElement || b.getElementsByTagName("parsererror").length) throw Error("textToDom was unable to parse: " + a);
        return b.documentElement;
    };
    textToDomDocument$$module$build$src$core$utils$xml = function(a) {
        return (new DOMParser$$module$build$src$core$utils$xml).parseFromString(a, "text/xml");
    };
    domToText$$module$build$src$core$utils$xml = function(a) {
        return (new XMLSerializer$$module$build$src$core$utils$xml).serializeToString(a);
    };
    createSvgElement$$module$build$src$core$utils$dom = function(a, b, c) {
        a = document.createElementNS(SVG_NS$$module$build$src$core$utils$dom, `${a}`);
        for(const d in b)a.setAttribute(d, `${b[d]}`);
        c && c.appendChild(a);
        return a;
    };
    addClass$$module$build$src$core$utils$dom = function(a, b) {
        b = b.split(" ");
        if (b.every((c)=>a.classList.contains(c))) return !1;
        a.classList.add(...b);
        return !0;
    };
    removeClasses$$module$build$src$core$utils$dom = function(a, b) {
        a.classList.remove(...b.split(" "));
    };
    removeClass$$module$build$src$core$utils$dom = function(a, b) {
        b = b.split(" ");
        if (b.every((c)=>!a.classList.contains(c))) return !1;
        a.classList.remove(...b);
        return !0;
    };
    hasClass$$module$build$src$core$utils$dom = function(a, b) {
        return a.classList.contains(b);
    };
    removeNode$$module$build$src$core$utils$dom = function(a) {
        return a && a.parentNode ? a.parentNode.removeChild(a) : null;
    };
    insertAfter$$module$build$src$core$utils$dom = function(a, b) {
        const c = b.nextSibling;
        b = b.parentNode;
        if (!b) throw Error("Reference node has no parent.");
        c ? b.insertBefore(a, c) : b.appendChild(a);
    };
    containsNode$$module$build$src$core$utils$dom = function(a, b) {
        return !!(a.compareDocumentPosition(b) & NodeType$$module$build$src$core$utils$dom.DOCUMENT_POSITION_CONTAINED_BY);
    };
    setCssTransform$$module$build$src$core$utils$dom = function(a, b) {
        a.style.transform = b;
        a.style["-webkit-transform"] = b;
    };
    startTextWidthCache$$module$build$src$core$utils$dom = function() {
        cacheReference$$module$build$src$core$utils$dom++;
        cacheWidths$$module$build$src$core$utils$dom || (cacheWidths$$module$build$src$core$utils$dom = Object.create(null));
    };
    stopTextWidthCache$$module$build$src$core$utils$dom = function() {
        cacheReference$$module$build$src$core$utils$dom--;
        cacheReference$$module$build$src$core$utils$dom || (cacheWidths$$module$build$src$core$utils$dom = null);
    };
    getTextWidth$$module$build$src$core$utils$dom = function(a) {
        const b = a.textContent + "\n" + a.className.baseVal;
        let c;
        if (cacheWidths$$module$build$src$core$utils$dom && (c = cacheWidths$$module$build$src$core$utils$dom[b])) return c;
        try {
            c = a.getComputedTextLength();
        } catch (d) {
            return 8 * a.textContent.length;
        }
        cacheWidths$$module$build$src$core$utils$dom && (cacheWidths$$module$build$src$core$utils$dom[b] = c);
        return c;
    };
    getFastTextWidth$$module$build$src$core$utils$dom = function(a, b, c, d) {
        return getFastTextWidthWithSizeString$$module$build$src$core$utils$dom(a, b + "pt", c, d);
    };
    getFastTextWidthWithSizeString$$module$build$src$core$utils$dom = function(a, b, c, d) {
        const e = a.textContent;
        a = e + "\n" + a.className.baseVal;
        var f;
        if (cacheWidths$$module$build$src$core$utils$dom && (f = cacheWidths$$module$build$src$core$utils$dom[a])) return f;
        canvasContext$$module$build$src$core$utils$dom || (f = document.createElement("canvas"), f.className = "blocklyComputeCanvas", document.body.appendChild(f), canvasContext$$module$build$src$core$utils$dom = f.getContext("2d"));
        canvasContext$$module$build$src$core$utils$dom.font = c + " " + b + " " + d;
        f = e ? canvasContext$$module$build$src$core$utils$dom.measureText(e).width : 0;
        cacheWidths$$module$build$src$core$utils$dom && (cacheWidths$$module$build$src$core$utils$dom[a] = f);
        return f;
    };
    measureFontMetrics$$module$build$src$core$utils$dom = function(a, b, c, d) {
        const e = document.createElement("span");
        e.style.font = c + " " + b + " " + d;
        e.textContent = a;
        a = document.createElement("div");
        a.style.width = "1px";
        a.style.height = "0";
        b = document.createElement("div");
        b.setAttribute("style", "position: fixed; top: 0; left: 0; display: flex;");
        b.appendChild(e);
        b.appendChild(a);
        document.body.appendChild(b);
        c = {
            height: 0,
            baseline: 0
        };
        try {
            b.style.alignItems = "baseline", c.baseline = a.offsetTop - e.offsetTop, b.style.alignItems = "flex-end", c.height = a.offsetTop - e.offsetTop;
        } finally{
            document.body.removeChild(b);
        }
        return c;
    };
    alert$$module$build$src$core$dialog = function(a, b) {
        alertImplementation$$module$build$src$core$dialog(a, b);
    };
    setAlert$$module$build$src$core$dialog = function(a) {
        alertImplementation$$module$build$src$core$dialog = a;
    };
    confirm$$module$build$src$core$dialog = function(a, b) {
        TEST_ONLY$$module$build$src$core$dialog.confirmInternal(a, b);
    };
    confirmInternal$$module$build$src$core$dialog = function(a, b) {
        confirmImplementation$$module$build$src$core$dialog(a, b);
    };
    setConfirm$$module$build$src$core$dialog = function(a) {
        confirmImplementation$$module$build$src$core$dialog = a;
    };
    prompt$$module$build$src$core$dialog = function(a, b, c) {
        promptImplementation$$module$build$src$core$dialog(a, b, c);
    };
    setPrompt$$module$build$src$core$dialog = function(a) {
        promptImplementation$$module$build$src$core$dialog = a;
    };
    isVariableBackedParameterModel$$module$build$src$core$interfaces$i_variable_backed_parameter_model = function(a) {
        return void 0 !== a.getVariableModel;
    };
    isLegacyProcedureDefBlock$$module$build$src$core$interfaces$i_legacy_procedure_blocks = function(a) {
        return void 0 !== a.getProcedureDef;
    };
    isLegacyProcedureCallBlock$$module$build$src$core$interfaces$i_legacy_procedure_blocks = function(a) {
        return void 0 !== a.getProcedureCall && void 0 !== a.renameProcedure;
    };
    allUsedVarModels$$module$build$src$core$variables = function(a) {
        a = a.getAllBlocks(!1);
        const b = new Set;
        for(let c = 0; c < a.length; c++){
            const d = a[c].getVarModels();
            if (d) for(let e = 0; e < d.length; e++){
                const f = d[e];
                f.getId() && b.add(f);
            }
        }
        return Array.from(b.values());
    };
    allDeveloperVariables$$module$build$src$core$variables = function(a) {
        a = a.getAllBlocks(!1);
        const b = new Set;
        for(let d = 0, e; e = a[d]; d++){
            var c = e.getDeveloperVariables;
            if (c) {
                c = c();
                for(let f = 0; f < c.length; f++)b.add(c[f]);
            }
        }
        return Array.from(b.values());
    };
    flyoutCategory$$module$build$src$core$variables = function(a) {
        let b = [];
        const c = document.createElement("button");
        c.setAttribute("text", "%{BKY_NEW_VARIABLE}");
        c.setAttribute("callbackKey", "CREATE_VARIABLE");
        a.registerButtonCallback("CREATE_VARIABLE", function(d) {
            createVariableButtonHandler$$module$build$src$core$variables(d.getTargetWorkspace());
        });
        b.push(c);
        a = flyoutCategoryBlocks$$module$build$src$core$variables(a);
        return b = b.concat(a);
    };
    flyoutCategoryBlocks$$module$build$src$core$variables = function(a) {
        a = a.getVariablesOfType("");
        const b = [];
        if (0 < a.length) {
            var c = a[a.length - 1];
            if (Blocks$$module$build$src$core$blocks.variables_set) {
                var d = $.createElement$$module$build$src$core$utils$xml("block");
                d.setAttribute("type", "variables_set");
                d.setAttribute("gap", Blocks$$module$build$src$core$blocks.math_change ? "8" : "24");
                d.appendChild(generateVariableFieldDom$$module$build$src$core$variables(c));
                b.push(d);
            }
            Blocks$$module$build$src$core$blocks.math_change && (d = $.createElement$$module$build$src$core$utils$xml("block"), d.setAttribute("type", "math_change"), d.setAttribute("gap", Blocks$$module$build$src$core$blocks.variables_get ? "20" : "8"), d.appendChild(generateVariableFieldDom$$module$build$src$core$variables(c)), c = textToDom$$module$build$src$core$utils$xml('<value name="DELTA"><shadow type="math_number"><field name="NUM">1</field></shadow></value>'), d.appendChild(c), b.push(d));
            if (Blocks$$module$build$src$core$blocks.variables_get) {
                a.sort(VariableModel$$module$build$src$core$variable_model.compareByName);
                for(let e = 0, f; f = a[e]; e++)c = $.createElement$$module$build$src$core$utils$xml("block"), c.setAttribute("type", "variables_get"), c.setAttribute("gap", "8"), c.appendChild(generateVariableFieldDom$$module$build$src$core$variables(f)), b.push(c);
            }
        }
        return b;
    };
    generateUniqueName$$module$build$src$core$variables = function(a) {
        return TEST_ONLY$$module$build$src$core$variables.generateUniqueNameInternal(a);
    };
    generateUniqueNameInternal$$module$build$src$core$variables = function(a) {
        return generateUniqueNameFromOptions$$module$build$src$core$variables(VAR_LETTER_OPTIONS$$module$build$src$core$variables.charAt(0), a.getAllVariableNames());
    };
    generateUniqueNameFromOptions$$module$build$src$core$variables = function(a, b) {
        if (!b.length) return a;
        const c = VAR_LETTER_OPTIONS$$module$build$src$core$variables;
        let d = "", e = c.indexOf(a);
        for(;;){
            let f = !1;
            for(let g = 0; g < b.length; g++)if (b[g].toLowerCase() === a) {
                f = !0;
                break;
            }
            if (!f) break;
            e++;
            e === c.length && (e = 0, d = `${Number(d) + 1}`);
            a = c.charAt(e) + d;
        }
        return a;
    };
    createVariableButtonHandler$$module$build$src$core$variables = function(a, b, c) {
        function d(f) {
            promptName$$module$build$src$core$variables(Msg$$module$build$src$core$msg.NEW_VARIABLE_TITLE, f, function(g) {
                if (g) {
                    var h = nameUsedWithAnyType$$module$build$src$core$variables(g, a);
                    if (h) {
                        if (h.type === e) var k = Msg$$module$build$src$core$msg.VARIABLE_ALREADY_EXISTS.replace("%1", h.name);
                        else k = Msg$$module$build$src$core$msg.VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE, k = k.replace("%1", h.name).replace("%2", h.type);
                        alert$$module$build$src$core$dialog(k, function() {
                            d(g);
                        });
                    } else a.createVariable(g, e), b && b(g);
                } else b && b(null);
            });
        }
        const e = c || "";
        d("");
    };
    renameVariable$$module$build$src$core$variables = function(a, b, c) {
        function d(e) {
            const f = Msg$$module$build$src$core$msg.RENAME_VARIABLE_TITLE.replace("%1", b.name);
            promptName$$module$build$src$core$variables(f, e, function(g) {
                if (g) {
                    var h = nameUsedWithOtherType$$module$build$src$core$variables(g, b.type, a), k = nameUsedWithConflictingParam$$module$build$src$core$variables(b.name, g, a);
                    if (h || k) {
                        var l = "";
                        h ? l = Msg$$module$build$src$core$msg.VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE.replace("%1", h.name).replace("%2", h.type) : k && (l = Msg$$module$build$src$core$msg.VARIABLE_ALREADY_EXISTS_FOR_A_PARAMETER.replace("%1", g).replace("%2", k));
                        alert$$module$build$src$core$dialog(l, function() {
                            d(g);
                        });
                    } else a.renameVariableById(b.getId(), g), c && c(g);
                } else c && c(null);
            });
        }
        d("");
    };
    promptName$$module$build$src$core$variables = function(a, b, c) {
        prompt$$module$build$src$core$dialog(a, b, function(d) {
            d && (d = d.replace(/[\s\xa0]+/g, " ").trim(), d === Msg$$module$build$src$core$msg.RENAME_VARIABLE || d === Msg$$module$build$src$core$msg.NEW_VARIABLE) && (d = null);
            c(d);
        });
    };
    nameUsedWithOtherType$$module$build$src$core$variables = function(a, b, c) {
        c = c.getVariableMap().getAllVariables();
        a = a.toLowerCase();
        for(let d = 0, e; e = c[d]; d++)if (e.name.toLowerCase() === a && e.type !== b) return e;
        return null;
    };
    nameUsedWithAnyType$$module$build$src$core$variables = function(a, b) {
        b = b.getVariableMap().getAllVariables();
        a = a.toLowerCase();
        for(let c = 0, d; d = b[c]; c++)if (d.name.toLowerCase() === a) return d;
        return null;
    };
    nameUsedWithConflictingParam$$module$build$src$core$variables = function(a, b, c) {
        return c.getProcedureMap().getProcedures().length ? checkForConflictingParamWithProcedureModels$$module$build$src$core$variables(a, b, c) : checkForConflictingParamWithLegacyProcedures$$module$build$src$core$variables(a, b, c);
    };
    checkForConflictingParamWithProcedureModels$$module$build$src$core$variables = function(a, b, c) {
        a = a.toLowerCase();
        b = b.toLowerCase();
        c = c.getProcedureMap().getProcedures();
        for (const e of c){
            var d = e.getParameters().filter(isVariableBackedParameterModel$$module$build$src$core$interfaces$i_variable_backed_parameter_model).map((f)=>f.getVariableModel().name);
            if (d && (c = d.some((f)=>f.toLowerCase() === a), d = d.some((f)=>f.toLowerCase() === b), c && d)) return e.getName();
        }
        return null;
    };
    checkForConflictingParamWithLegacyProcedures$$module$build$src$core$variables = function(a, b, c) {
        a = a.toLowerCase();
        b = b.toLowerCase();
        c = c.getAllBlocks(!1);
        for (const e of c){
            if (!isLegacyProcedureDefBlock$$module$build$src$core$interfaces$i_legacy_procedure_blocks(e)) continue;
            c = e.getProcedureDef();
            var d = c[1];
            const f = d.some((g)=>g.toLowerCase() === a);
            d = d.some((g)=>g.toLowerCase() === b);
            if (f && d) return c[0];
        }
        return null;
    };
    generateVariableFieldDom$$module$build$src$core$variables = function(a) {
        const b = $.createElement$$module$build$src$core$utils$xml("field");
        b.setAttribute("name", "VAR");
        b.setAttribute("id", a.getId());
        b.setAttribute("variabletype", a.type);
        a = createTextNode$$module$build$src$core$utils$xml(a.name);
        b.appendChild(a);
        return b;
    };
    getOrCreateVariablePackage$$module$build$src$core$variables = function(a, b, c, d) {
        let e = getVariable$$module$build$src$core$variables(a, b, c, d);
        e || (e = createVariable$$module$build$src$core$variables(a, b, c, d));
        return e;
    };
    getVariable$$module$build$src$core$variables = function(a, b, c, d) {
        const e = a.getPotentialVariableMap();
        let f = null;
        if (b && (f = a.getVariableById(b), !f && e && (f = e.getVariableById(b)), f)) return f;
        if (c) {
            if (void 0 === d) throw Error("Tried to look up a variable by name without a type");
            f = a.getVariable(c, d);
            !f && e && (f = e.getVariable(c, d));
        }
        return f;
    };
    createVariable$$module$build$src$core$variables = function(a, b, c, d) {
        const e = a.getPotentialVariableMap();
        c || (c = generateUniqueName$$module$build$src$core$variables(a.isFlyout ? a.targetWorkspace : a));
        return e ? e.createVariable(c, d, b) : a.createVariable(c, d, b);
    };
    getAddedVariables$$module$build$src$core$variables = function(a, b) {
        a = a.getAllVariables();
        const c = [];
        if (b.length !== a.length) for(let d = 0; d < a.length; d++){
            const e = a[d];
            -1 === b.indexOf(e) && c.push(e);
        }
        return c;
    };
    longStart$$module$build$src$core$touch = function(a, b) {
        longStop$$module$build$src$core$touch();
        longPid_$$module$build$src$core$touch = setTimeout(function() {
            b && b.handleRightClick(a);
        }, LONGPRESS$$module$build$src$core$touch);
    };
    longStop$$module$build$src$core$touch = function() {
        longPid_$$module$build$src$core$touch && (clearTimeout(longPid_$$module$build$src$core$touch), longPid_$$module$build$src$core$touch = 0);
    };
    clearTouchIdentifier$$module$build$src$core$touch = function() {
        touchIdentifier_$$module$build$src$core$touch = null;
    };
    shouldHandleEvent$$module$build$src$core$touch = function(a) {
        return !a.type.startsWith("pointer") || a instanceof PointerEvent && checkTouchIdentifier$$module$build$src$core$touch(a);
    };
    getTouchIdentifierFromEvent$$module$build$src$core$touch = function(a) {
        return `${a.pointerId}`;
    };
    checkTouchIdentifier$$module$build$src$core$touch = function(a) {
        const b = getTouchIdentifierFromEvent$$module$build$src$core$touch(a);
        return touchIdentifier_$$module$build$src$core$touch ? touchIdentifier_$$module$build$src$core$touch === b : "pointerdown" === a.type ? (touchIdentifier_$$module$build$src$core$touch = b, !0) : !1;
    };
    setClientFromTouch$$module$build$src$core$touch = function(a) {
        warn$$module$build$src$core$utils$deprecation("setClientFromTouch()", "version 9", "version 10");
        if (a.type.startsWith("touch") && a.changedTouches) {
            const b = a.changedTouches[0];
            a.clientX = b.clientX;
            a.clientY = b.clientY;
        }
    };
    isMouseOrTouchEvent$$module$build$src$core$touch = function(a) {
        warn$$module$build$src$core$utils$deprecation("isMouseOrTouchEvent()", "version 9", "version 10");
        return a.type.startsWith("touch") || a.type.startsWith("mouse") || a.type.startsWith("pointer");
    };
    isTouchEvent$$module$build$src$core$touch = function(a) {
        warn$$module$build$src$core$utils$deprecation("isTouchEvent()", "version 9", "version 10");
        return a.type.startsWith("touch") || a.type.startsWith("pointer");
    };
    splitEventByTouches$$module$build$src$core$touch = function(a) {
        warn$$module$build$src$core$utils$deprecation("splitEventByTouches()", "version 9", "version 10");
        const b = [];
        if (a.changedTouches) for(let c = 0; c < a.changedTouches.length; c++)b[c] = {
            type: a.type,
            changedTouches: [
                a.changedTouches[c]
            ],
            target: a.target,
            stopPropagation () {
                a.stopPropagation();
            },
            preventDefault () {
                a.preventDefault();
            }
        };
        else b.push(a);
        return b;
    };
    conditionalBind$$module$build$src$core$browser_events = function(a, b, c, d, e, f) {
        function g(h) {
            if (e || shouldHandleEvent$$module$build$src$core$touch(h)) c ? d.call(c, h) : d(h);
        }
        void 0 !== f && warn$$module$build$src$core$utils$deprecation("The opt_noPreventDefault argument of conditionalBind", "version 9", "version 10");
        f = [];
        if (b in TOUCH_MAP$$module$build$src$core$touch) for(let h = 0; h < TOUCH_MAP$$module$build$src$core$touch[b].length; h++){
            const k = TOUCH_MAP$$module$build$src$core$touch[b][h];
            a.addEventListener(k, g, !1);
            f.push([
                a,
                k,
                g
            ]);
        }
        else a.addEventListener(b, g, !1), f.push([
            a,
            b,
            g
        ]);
        return f;
    };
    bind$$module$build$src$core$browser_events = function(a, b, c, d) {
        function e(g) {
            c ? d.call(c, g) : d(g);
        }
        const f = [];
        if (b in TOUCH_MAP$$module$build$src$core$touch) for(let g = 0; g < TOUCH_MAP$$module$build$src$core$touch[b].length; g++){
            const h = TOUCH_MAP$$module$build$src$core$touch[b][g];
            a.addEventListener(h, e, !1);
            f.push([
                a,
                h,
                e
            ]);
        }
        else a.addEventListener(b, e, !1), f.push([
            a,
            b,
            e
        ]);
        return f;
    };
    unbind$$module$build$src$core$browser_events = function(a) {
        const b = a[a.length - 1][2];
        for(; a.length;){
            const [c, d, e] = a.pop();
            c.removeEventListener(d, e, !1);
        }
        return b;
    };
    isTargetInput$$module$build$src$core$browser_events = function(a) {
        if (a.target instanceof HTMLElement) {
            if (a.target.isContentEditable || "true" === a.target.getAttribute("data-is-text-input")) return !0;
            if (a.target instanceof HTMLInputElement) return a = a.target, "text" === a.type || "number" === a.type || "email" === a.type || "password" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type;
            if (a.target instanceof HTMLTextAreaElement) return !0;
        }
        return !1;
    };
    isRightButton$$module$build$src$core$browser_events = function(a) {
        return a.ctrlKey && MAC$$module$build$src$core$utils$useragent ? !0 : 2 === a.button;
    };
    mouseToSvg$$module$build$src$core$browser_events = function(a, b, c) {
        const d = b.createSVGPoint();
        d.x = a.clientX;
        d.y = a.clientY;
        c || (c = b.getScreenCTM().inverse());
        return d.matrixTransform(c);
    };
    getScrollDeltaPixels$$module$build$src$core$browser_events = function(a) {
        switch(a.deltaMode){
            default:
                return {
                    x: a.deltaX,
                    y: a.deltaY
                };
            case 1:
                return {
                    x: a.deltaX * LINE_MODE_MULTIPLIER$$module$build$src$core$browser_events,
                    y: a.deltaY * LINE_MODE_MULTIPLIER$$module$build$src$core$browser_events
                };
            case 2:
                return {
                    x: a.deltaX * PAGE_MODE_MULTIPLIER$$module$build$src$core$browser_events,
                    y: a.deltaY * PAGE_MODE_MULTIPLIER$$module$build$src$core$browser_events
                };
        }
    };
    register$$module$build$src$core$css = function(a) {
        if (injected$$module$build$src$core$css) throw Error("CSS already injected");
        content$$module$build$src$core$css += "\n" + a;
    };
    inject$$module$build$src$core$css = function(a, b) {
        injected$$module$build$src$core$css || (injected$$module$build$src$core$css = !0, a && (a = b.replace(/[\\/]$/, ""), b = content$$module$build$src$core$css.replace(/<<<PATH>>>/g, a), content$$module$build$src$core$css = "", a = document.createElement("style"), a.id = "blockly-common-style", b = document.createTextNode(b), a.appendChild(b), document.head.insertBefore(a, document.head.firstChild)));
    };
    getSize$$module$build$src$core$utils$style = function(a) {
        return TEST_ONLY$$module$build$src$core$utils$style.getSizeInternal(a);
    };
    getSizeInternal$$module$build$src$core$utils$style = function(a) {
        if ("none" !== getComputedStyle$$module$build$src$core$utils$style(a, "display")) return getSizeWithDisplay$$module$build$src$core$utils$style(a);
        const b = a.style, c = b.display, d = b.visibility, e = b.position;
        b.visibility = "hidden";
        b.position = "absolute";
        b.display = "inline";
        const f = a.offsetWidth;
        a = a.offsetHeight;
        b.display = c;
        b.position = e;
        b.visibility = d;
        return new Size$$module$build$src$core$utils$size(f, a);
    };
    getSizeWithDisplay$$module$build$src$core$utils$style = function(a) {
        return new Size$$module$build$src$core$utils$size(a.offsetWidth, a.offsetHeight);
    };
    getComputedStyle$$module$build$src$core$utils$style = function(a, b) {
        a = window.getComputedStyle(a);
        return a[b] || a.getPropertyValue(b);
    };
    getCascadedStyle$$module$build$src$core$utils$style = function(a, b) {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.style.getCascadedStyle", "version 9", "version 10");
        return a.currentStyle ? a.currentStyle[b] : "";
    };
    getPageOffset$$module$build$src$core$utils$style = function(a) {
        const b = new Coordinate$$module$build$src$core$utils$coordinate(0, 0);
        a = a.getBoundingClientRect();
        var c = document.documentElement;
        c = new Coordinate$$module$build$src$core$utils$coordinate(window.pageXOffset || c.scrollLeft, window.pageYOffset || c.scrollTop);
        b.x = a.left + c.x;
        b.y = a.top + c.y;
        return b;
    };
    getViewportPageOffset$$module$build$src$core$utils$style = function() {
        const a = document.body, b = document.documentElement;
        return new Coordinate$$module$build$src$core$utils$coordinate(a.scrollLeft || b.scrollLeft, a.scrollTop || b.scrollTop);
    };
    getBorderBox$$module$build$src$core$utils$style = function(a) {
        const b = parseFloat(getComputedStyle$$module$build$src$core$utils$style(a, "borderLeftWidth")), c = parseFloat(getComputedStyle$$module$build$src$core$utils$style(a, "borderRightWidth")), d = parseFloat(getComputedStyle$$module$build$src$core$utils$style(a, "borderTopWidth"));
        a = parseFloat(getComputedStyle$$module$build$src$core$utils$style(a, "borderBottomWidth"));
        return new Rect$$module$build$src$core$utils$rect(d, a, b, c);
    };
    scrollIntoContainerView$$module$build$src$core$utils$style = function(a, b, c) {
        a = getContainerOffsetToScrollInto$$module$build$src$core$utils$style(a, b, c);
        b.scrollLeft = a.x;
        b.scrollTop = a.y;
    };
    getContainerOffsetToScrollInto$$module$build$src$core$utils$style = function(a, b, c) {
        var d = getPageOffset$$module$build$src$core$utils$style(a), e = getPageOffset$$module$build$src$core$utils$style(b), f = getBorderBox$$module$build$src$core$utils$style(b);
        const g = d.x - e.x - f.left;
        d = d.y - e.y - f.top;
        e = getSizeWithDisplay$$module$build$src$core$utils$style(a);
        a = b.clientWidth - e.width;
        e = b.clientHeight - e.height;
        f = b.scrollLeft;
        b = b.scrollTop;
        c ? (f += g - a / 2, b += d - e / 2) : (f += Math.min(g, Math.max(g - a, 0)), b += Math.min(d, Math.max(d - e, 0)));
        return new Coordinate$$module$build$src$core$utils$coordinate(f, b);
    };
    getRelativeXY$$module$build$src$core$utils$svg_math = function(a) {
        const b = new Coordinate$$module$build$src$core$utils$coordinate(0, 0);
        var c = a.x && a.getAttribute("x");
        const d = a.y && a.getAttribute("y");
        c && (b.x = parseInt(c));
        d && (b.y = parseInt(d));
        if (c = (c = a.getAttribute("transform")) && c.match(XY_REGEX$$module$build$src$core$utils$svg_math)) b.x += Number(c[1]), c[3] && (b.y += Number(c[3]));
        (a = a.getAttribute("style")) && -1 < a.indexOf("translate") && (a = a.match(XY_STYLE_REGEX$$module$build$src$core$utils$svg_math)) && (b.x += Number(a[1]), a[3] && (b.y += Number(a[3])));
        return b;
    };
    getInjectionDivXY$$module$build$src$core$utils$svg_math = function(a) {
        let b = 0, c = 0;
        for(; a;){
            const d = getRelativeXY$$module$build$src$core$utils$svg_math(a);
            b += d.x;
            c += d.y;
            if (-1 !== (" " + (a.getAttribute("class") || "") + " ").indexOf(" injectionDiv ")) break;
            a = a.parentNode;
        }
        return new Coordinate$$module$build$src$core$utils$coordinate(b, c);
    };
    is3dSupported$$module$build$src$core$utils$svg_math = function() {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.svgMath.is3dSupported", "version 9", "version 10");
        return !0;
    };
    getViewportBBox$$module$build$src$core$utils$svg_math = function() {
        const a = getViewportPageOffset$$module$build$src$core$utils$style();
        return new Rect$$module$build$src$core$utils$rect(a.y, document.documentElement.clientHeight + a.y, a.x, document.documentElement.clientWidth + a.x);
    };
    getDocumentScroll$$module$build$src$core$utils$svg_math = function() {
        const a = document.documentElement, b = window;
        return new Coordinate$$module$build$src$core$utils$coordinate(b.pageXOffset || a.scrollLeft, b.pageYOffset || a.scrollTop);
    };
    screenToWsCoordinates$$module$build$src$core$utils$svg_math = function(a, b) {
        var c = b.x;
        b = b.y;
        const d = a.getInjectionDiv().getBoundingClientRect();
        c = new Coordinate$$module$build$src$core$utils$coordinate(c - d.left, b - d.top);
        b = a.getOriginOffsetInPixels();
        return Coordinate$$module$build$src$core$utils$coordinate.difference(c, b).scale(1 / a.scale);
    };
    workspaceToDom$$module$build$src$core$xml = function(a, b) {
        const c = $.createElement$$module$build$src$core$utils$xml("xml");
        var d = variablesToDom$$module$build$src$core$xml(allUsedVarModels$$module$build$src$core$variables(a));
        d.hasChildNodes() && c.appendChild(d);
        d = a.getTopComments(!0);
        for(let e = 0; e < d.length; e++)c.appendChild(d[e].toXmlWithXY(b));
        a = a.getTopBlocks(!0);
        for(d = 0; d < a.length; d++)c.appendChild(blockToDomWithXY$$module$build$src$core$xml(a[d], b));
        return c;
    };
    variablesToDom$$module$build$src$core$xml = function(a) {
        const b = $.createElement$$module$build$src$core$utils$xml("variables");
        for(let c = 0; c < a.length; c++){
            const d = a[c], e = $.createElement$$module$build$src$core$utils$xml("variable");
            e.appendChild(createTextNode$$module$build$src$core$utils$xml(d.name));
            d.type && e.setAttribute("type", d.type);
            e.id = d.getId();
            b.appendChild(e);
        }
        return b;
    };
    blockToDomWithXY$$module$build$src$core$xml = function(a, b) {
        if (a.isInsertionMarker() && (a = a.getChildren(!1)[0], !a)) return new DocumentFragment;
        let c = 0;
        a.workspace.RTL && (c = a.workspace.getWidth());
        b = blockToDom$$module$build$src$core$xml(a, b);
        if (isElement$$module$build$src$core$xml(b)) {
            const d = a.getRelativeToSurfaceXY();
            b.setAttribute("x", String(Math.round(a.workspace.RTL ? c - d.x : d.x)));
            b.setAttribute("y", String(Math.round(d.y)));
        }
        return b;
    };
    fieldToDom$$module$build$src$core$xml = function(a) {
        if (a.isSerializable()) {
            const b = $.createElement$$module$build$src$core$utils$xml("field");
            b.setAttribute("name", a.name || "");
            return a.toXml(b);
        }
        return null;
    };
    allFieldsToDom$$module$build$src$core$xml = function(a, b) {
        for(let c = 0; c < a.inputList.length; c++){
            const d = a.inputList[c];
            for(let e = 0; e < d.fieldRow.length; e++){
                const f = fieldToDom$$module$build$src$core$xml(d.fieldRow[e]);
                f && b.appendChild(f);
            }
        }
    };
    blockToDom$$module$build$src$core$xml = function(a, b) {
        if (a.isInsertionMarker()) return (b = a.getChildren(!1)[0]) ? blockToDom$$module$build$src$core$xml(b) : new DocumentFragment;
        const c = $.createElement$$module$build$src$core$utils$xml(a.isShadow() ? "shadow" : "block");
        c.setAttribute("type", a.type);
        b || (c.id = a.id);
        if (a.mutationToDom) {
            var d = a.mutationToDom();
            d && (d.hasChildNodes() || d.hasAttributes()) && c.appendChild(d);
        }
        allFieldsToDom$$module$build$src$core$xml(a, c);
        if (d = a.getCommentText()) {
            var e = a.commentModel.size, f = a.commentModel.pinned, g = $.createElement$$module$build$src$core$utils$xml("comment");
            g.appendChild(createTextNode$$module$build$src$core$utils$xml(d));
            g.setAttribute("pinned", `${f}`);
            g.setAttribute("h", String(e.height));
            g.setAttribute("w", String(e.width));
            c.appendChild(g);
        }
        a.data && (d = $.createElement$$module$build$src$core$utils$xml("data"), d.appendChild(createTextNode$$module$build$src$core$utils$xml(a.data)), c.appendChild(d));
        for(d = 0; d < a.inputList.length; d++){
            e = a.inputList[d];
            var h = void 0;
            f = !0;
            if (e.type !== inputTypes$$module$build$src$core$input_types.DUMMY) {
                g = e.connection.targetBlock();
                e.type === inputTypes$$module$build$src$core$input_types.VALUE ? h = $.createElement$$module$build$src$core$utils$xml("value") : e.type === inputTypes$$module$build$src$core$input_types.STATEMENT && (h = $.createElement$$module$build$src$core$utils$xml("statement"));
                const l = e.connection.getShadowDom();
                !l || g && g.isShadow() || h.appendChild(cloneShadow$$module$build$src$core$xml(l, b));
                g && (g = blockToDom$$module$build$src$core$xml(g, b), g.nodeType === NodeType$$module$build$src$core$utils$dom.ELEMENT_NODE && (h.appendChild(g), f = !1));
                h.setAttribute("name", e.name);
                f || c.appendChild(h);
            }
        }
        void 0 !== a.inputsInline && a.inputsInline !== a.inputsInlineDefault && c.setAttribute("inline", String(a.inputsInline));
        a.isCollapsed() && c.setAttribute("collapsed", "true");
        a.isEnabled() || c.setAttribute("disabled", "true");
        a.isDeletable() || a.isShadow() || c.setAttribute("deletable", "false");
        a.isMovable() || a.isShadow() || c.setAttribute("movable", "false");
        a.isEditable() || c.setAttribute("editable", "false");
        h = a.getNextBlock();
        let k;
        h && (d = blockToDom$$module$build$src$core$xml(h, b), d.nodeType === NodeType$$module$build$src$core$utils$dom.ELEMENT_NODE && (k = $.createElement$$module$build$src$core$utils$xml("next"), k.appendChild(d), c.appendChild(k)));
        a = a.nextConnection && a.nextConnection.getShadowDom();
        !a || h && h.isShadow() || k.appendChild(cloneShadow$$module$build$src$core$xml(a, b));
        return c;
    };
    cloneShadow$$module$build$src$core$xml = function(a, b) {
        let c = a = a.cloneNode(!0), d;
        for(; c;)if (b && "shadow" === c.nodeName && c.removeAttribute("id"), c.firstChild) c = c.firstChild;
        else {
            for(; c && !c.nextSibling;){
                d = c;
                c = c.parentNode;
                let e;
                d.nodeType === NodeType$$module$build$src$core$utils$dom.TEXT_NODE && "" === d.data.trim() && (null == (e = c) ? void 0 : e.firstChild) !== d && removeNode$$module$build$src$core$utils$dom(d);
            }
            c && (d = c, c = c.nextSibling, d.nodeType === NodeType$$module$build$src$core$utils$dom.TEXT_NODE && "" === d.data.trim() && removeNode$$module$build$src$core$utils$dom(d));
        }
        return a;
    };
    domToText$$module$build$src$core$xml = function(a) {
        return domToText$$module$build$src$core$utils$xml(a).replace(/<(\w+)([^<]*)\/>/g, "<$1$2></$1>");
    };
    domToPrettyText$$module$build$src$core$xml = function(a) {
        a = domToText$$module$build$src$core$xml(a).split("<");
        let b = "";
        for(let c = 1; c < a.length; c++){
            const d = a[c];
            "/" === d[0] && (b = b.substring(2));
            a[c] = b + "<" + d;
            "/" !== d[0] && "/>" !== d.slice(-2) && (b += "  ");
        }
        a = a.join("\n");
        a = a.replace(/(<(\w+)\b[^>]*>[^\n]*)\n *<\/\2>/g, "$1</$2>");
        return a.replace(/^\n/, "");
    };
    textToDom$$module$build$src$core$xml = function(a) {
        warn$$module$build$src$core$utils$deprecation("Blockly.Xml.textToDom", "version 9", "version 10", "Use Blockly.utils.xml.textToDom instead");
        return textToDom$$module$build$src$core$utils$xml(a);
    };
    clearWorkspaceAndLoadFromXml$$module$build$src$core$xml = function(a, b) {
        b.setResizesEnabled(!1);
        b.clear();
        a = domToWorkspace$$module$build$src$core$xml(a, b);
        b.setResizesEnabled(!0);
        return a;
    };
    domToWorkspace$$module$build$src$core$xml = function(a, b) {
        let c = 0;
        b.RTL && (c = b.getWidth());
        const d = [];
        startTextWidthCache$$module$build$src$core$utils$dom();
        const e = getGroup$$module$build$src$core$events$utils();
        e || setGroup$$module$build$src$core$events$utils(!0);
        b.setResizesEnabled && b.setResizesEnabled(!1);
        let f = !0;
        try {
            for(let g = 0, h; h = a.childNodes[g]; g++){
                const k = h.nodeName.toLowerCase(), l = h;
                if ("block" === k || "shadow" === k && !getRecordUndo$$module$build$src$core$events$utils()) {
                    const m = domToBlock$$module$build$src$core$xml(l, b);
                    d.push(m.id);
                    let n;
                    const p = parseInt(null != (n = l.getAttribute("x")) ? n : "10", 10);
                    let q;
                    const r = parseInt(null != (q = l.getAttribute("y")) ? q : "10", 10);
                    isNaN(p) || isNaN(r) || m.moveBy(b.RTL ? c - p : p, r);
                    f = !1;
                } else {
                    if ("shadow" === k) throw TypeError("Shadow block cannot be a top-level block.");
                    if ("comment" === k) b.rendered ? WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg.fromXmlRendered(l, b, c) : WorkspaceComment$$module$build$src$core$workspace_comment.fromXml(l, b);
                    else if ("variables" === k) {
                        if (f) domToVariables$$module$build$src$core$xml(l, b);
                        else throw Error("'variables' tag must exist once before block and shadow tag elements in the workspace XML, but it was found in another location.");
                        f = !1;
                    }
                }
            }
        } finally{
            setGroup$$module$build$src$core$events$utils(e), stopTextWidthCache$$module$build$src$core$utils$dom();
        }
        b.setResizesEnabled && b.setResizesEnabled(!0);
        fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(FINISHED_LOADING$$module$build$src$core$events$utils))(b));
        return d;
    };
    appendDomToWorkspace$$module$build$src$core$xml = function(a, b) {
        if (!b.getBlocksBoundingBox) return domToWorkspace$$module$build$src$core$xml(a, b);
        var c = b.getBlocksBoundingBox();
        a = domToWorkspace$$module$build$src$core$xml(a, b);
        if (c && c.top !== c.bottom) {
            var d = c.bottom;
            c = b.RTL ? c.right : c.left;
            var e = Infinity;
            let f = -Infinity, g = Infinity;
            for(let h = 0; h < a.length; h++){
                const k = b.getBlockById(a[h]).getRelativeToSurfaceXY();
                k.y < g && (g = k.y);
                k.x < e && (e = k.x);
                k.x > f && (f = k.x);
            }
            d = d - g + 10;
            c = b.RTL ? c - f : c - e;
            for(e = 0; e < a.length; e++)b.getBlockById(a[e]).moveBy(c, d);
        }
        return a;
    };
    domToBlock$$module$build$src$core$xml = function(a, b) {
        disable$$module$build$src$core$events$utils();
        var c = b.getAllVariables();
        let d;
        try {
            if (d = domToBlockHeadless$$module$build$src$core$xml(a, b), b.rendered) {
                const e = d, f = d.getDescendants(!1);
                e.setConnectionTracking(!1);
                for(let g = f.length - 1; 0 <= g; g--)f[g].initSvg();
                for(let g = f.length - 1; 0 <= g; g--)f[g].render(!1);
                setTimeout(function() {
                    e.disposed || e.setConnectionTracking(!0);
                }, 1);
                e.updateDisabled();
                b.resizeContents();
            } else {
                const e = d.getDescendants(!1);
                for(let f = e.length - 1; 0 <= f; f--)e[f].initModel();
            }
        } finally{
            enable$$module$build$src$core$events$utils();
        }
        if (isEnabled$$module$build$src$core$events$utils()) {
            a = getAddedVariables$$module$build$src$core$variables(b, c);
            for(b = 0; b < a.length; b++)c = a[b], fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(VAR_CREATE$$module$build$src$core$events$utils))(c));
            fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(CREATE$$module$build$src$core$events$utils))(d));
        }
        return d;
    };
    domToVariables$$module$build$src$core$xml = function(a, b) {
        for(let d = 0; d < a.children.length; d++){
            var c = a.children[d];
            const e = c.getAttribute("type"), f = c.getAttribute("id");
            c = c.textContent;
            if (!c) break;
            b.createVariable(c, e, f);
        }
    };
    mapSupportedXmlTags$$module$build$src$core$xml = function(a) {
        const b = {
            mutation: [],
            comment: [],
            data: [],
            field: [],
            input: [],
            next: []
        };
        for(let c = 0; c < a.children.length; c++){
            const d = a.children[c];
            if (d.nodeType !== NodeType$$module$build$src$core$utils$dom.TEXT_NODE) switch(d.nodeName.toLowerCase()){
                case "mutation":
                    b.mutation.push(d);
                    break;
                case "comment":
                    b.comment.push(d);
                    break;
                case "data":
                    b.data.push(d);
                    break;
                case "title":
                case "field":
                    b.field.push(d);
                    break;
                case "value":
                case "statement":
                    b.input.push(d);
                    break;
                case "next":
                    b.next.push(d);
                    break;
                default:
                    console.warn("Ignoring unknown tag: " + d.nodeName);
            }
        }
        return b;
    };
    applyMutationTagNodes$$module$build$src$core$xml = function(a, b) {
        let c = !1;
        for(let d = 0; d < a.length; d++){
            const e = a[d];
            b.domToMutation && (b.domToMutation(e), b.initSvg && (c = !0));
        }
        return c;
    };
    applyCommentTagNodes$$module$build$src$core$xml = function(a, b) {
        for(let d = 0; d < a.length; d++){
            var c = a[d];
            const e = c.textContent, f = "true" === c.getAttribute("pinned");
            let g;
            const h = parseInt(null != (g = c.getAttribute("w")) ? g : "50", 10);
            let k;
            c = parseInt(null != (k = c.getAttribute("h")) ? k : "50", 10);
            b.setCommentText(e);
            b.commentModel.pinned = f;
            isNaN(h) || isNaN(c) || (b.commentModel.size = new Size$$module$build$src$core$utils$size(h, c));
            if (f && b.getCommentIcon && !b.isInFlyout) {
                const l = b;
                setTimeout(function() {
                    l.getCommentIcon().setVisible(!0);
                }, 1);
            }
        }
    };
    applyDataTagNodes$$module$build$src$core$xml = function(a, b) {
        for(let c = 0; c < a.length; c++)b.data = a[c].textContent;
    };
    applyFieldTagNodes$$module$build$src$core$xml = function(a, b) {
        for(let c = 0; c < a.length; c++){
            const d = a[c], e = d.getAttribute("name");
            e ? domToField$$module$build$src$core$xml(b, e, d) : console.warn(`Ignoring unnamed field in block ${b.type}`);
        }
    };
    findChildBlocks$$module$build$src$core$xml = function(a) {
        let b = null, c = null;
        for(let d = 0; d < a.childNodes.length; d++){
            const e = a.childNodes[d];
            isElement$$module$build$src$core$xml(e) && ("block" === e.nodeName.toLowerCase() ? b = e : "shadow" === e.nodeName.toLowerCase() && (c = e));
        }
        return {
            childBlockElement: b,
            childShadowElement: c
        };
    };
    applyInputTagNodes$$module$build$src$core$xml = function(a, b, c, d) {
        for(let f = 0; f < a.length; f++){
            var e = a[f];
            const g = e.getAttribute("name"), h = g ? c.getInput(g) : null;
            if (!h) {
                console.warn("Ignoring non-existent input " + g + " in block " + d);
                break;
            }
            e = findChildBlocks$$module$build$src$core$xml(e);
            if (e.childBlockElement) {
                if (!h.connection) throw TypeError("Input connection does not exist.");
                domToBlockHeadless$$module$build$src$core$xml(e.childBlockElement, b, h.connection, !1);
            }
            if (e.childShadowElement) {
                let k;
                null == (k = h.connection) || k.setShadowDom(e.childShadowElement);
            }
        }
    };
    applyNextTagNodes$$module$build$src$core$xml = function(a, b, c) {
        for(let d = 0; d < a.length; d++){
            const e = findChildBlocks$$module$build$src$core$xml(a[d]);
            if (e.childBlockElement) {
                if (!c.nextConnection) throw TypeError("Next statement does not exist.");
                if (c.nextConnection.isConnected()) throw TypeError("Next statement is already connected.");
                domToBlockHeadless$$module$build$src$core$xml(e.childBlockElement, b, c.nextConnection, !0);
            }
            e.childShadowElement && c.nextConnection && c.nextConnection.setShadowDom(e.childShadowElement);
        }
    };
    domToBlockHeadless$$module$build$src$core$xml = function(a, b, c, d) {
        var e;
        const f = a.getAttribute("type");
        if (!f) throw TypeError("Block type unspecified: " + a.outerHTML);
        var g = null != (e = a.getAttribute("id")) ? e : void 0;
        e = b.newBlock(f, g);
        g = mapSupportedXmlTags$$module$build$src$core$xml(a);
        const h = applyMutationTagNodes$$module$build$src$core$xml(g.mutation, e);
        applyCommentTagNodes$$module$build$src$core$xml(g.comment, e);
        applyDataTagNodes$$module$build$src$core$xml(g.data, e);
        if (c) {
            if (d) {
                if (e.previousConnection) c.connect(e.previousConnection);
                else throw TypeError("Next block does not have previous statement.");
            } else if (e.outputConnection) c.connect(e.outputConnection);
            else if (e.previousConnection) c.connect(e.previousConnection);
            else throw TypeError("Child block does not have output or previous statement.");
        }
        applyFieldTagNodes$$module$build$src$core$xml(g.field, e);
        applyInputTagNodes$$module$build$src$core$xml(g.input, b, e, f);
        applyNextTagNodes$$module$build$src$core$xml(g.next, b, e);
        h && e.initSvg();
        (b = a.getAttribute("inline")) && e.setInputsInline("true" === b);
        (b = a.getAttribute("disabled")) && e.setEnabled("true" !== b && "disabled" !== b);
        (b = a.getAttribute("deletable")) && e.setDeletable("true" === b);
        (b = a.getAttribute("movable")) && e.setMovable("true" === b);
        (b = a.getAttribute("editable")) && e.setEditable("true" === b);
        (b = a.getAttribute("collapsed")) && e.setCollapsed("true" === b);
        if ("shadow" === a.nodeName.toLowerCase()) {
            a = e.getChildren(!1);
            for(b = 0; b < a.length; b++)if (!a[b].isShadow()) throw TypeError("Shadow block not allowed non-shadow child.");
            if (e.getVarModels().length) throw TypeError("Shadow blocks cannot have variable references.");
            e.setShadow(!0);
        }
        return e;
    };
    domToField$$module$build$src$core$xml = function(a, b, c) {
        const d = a.getField(b);
        d ? d.fromXml(c) : console.warn("Ignoring non-existent field " + b + " in block " + a.type);
    };
    deleteNext$$module$build$src$core$xml = function(a) {
        for(let b = 0; b < a.childNodes.length; b++){
            const c = a.childNodes[b];
            if ("next" === c.nodeName.toLowerCase()) {
                a.removeChild(c);
                break;
            }
        }
    };
    isElement$$module$build$src$core$xml = function(a) {
        return a.nodeType === NodeType$$module$build$src$core$utils$dom.ELEMENT_NODE;
    };
    register$$module$build$src$core$serialization$registry = function(a, b) {
        register$$module$build$src$core$registry(Type$$module$build$src$core$registry.SERIALIZER, a, b);
    };
    unregister$$module$build$src$core$serialization$registry = function(a) {
        unregister$$module$build$src$core$registry(Type$$module$build$src$core$registry.SERIALIZER, a);
    };
    save$$module$build$src$core$serialization$blocks = function(a, { addCoordinates: b = !1, addInputBlocks: c = !0, addNextBlocks: d = !0, doFullSerialization: e = !0 } = {}) {
        if (a.isInsertionMarker()) return null;
        const f = {
            type: a.type,
            id: a.id
        };
        b && saveCoords$$module$build$src$core$serialization$blocks(a, f);
        saveAttributes$$module$build$src$core$serialization$blocks(a, f);
        saveExtraState$$module$build$src$core$serialization$blocks(a, f);
        saveIcons$$module$build$src$core$serialization$blocks(a, f);
        saveFields$$module$build$src$core$serialization$blocks(a, f, e);
        c && saveInputBlocks$$module$build$src$core$serialization$blocks(a, f, e);
        d && saveNextBlocks$$module$build$src$core$serialization$blocks(a, f, e);
        return f;
    };
    saveAttributes$$module$build$src$core$serialization$blocks = function(a, b) {
        a.isCollapsed() && (b.collapsed = !0);
        a.isEnabled() || (b.enabled = !1);
        a.isOwnDeletable() || (b.deletable = !1);
        a.isOwnMovable() || (b.movable = !1);
        a.isOwnEditable() || (b.editable = !1);
        void 0 !== a.inputsInline && a.inputsInline !== a.inputsInlineDefault && (b.inline = a.inputsInline);
        a.data && (b.data = a.data);
    };
    saveCoords$$module$build$src$core$serialization$blocks = function(a, b) {
        const c = a.workspace;
        a = a.getRelativeToSurfaceXY();
        b.x = Math.round(c.RTL ? c.getWidth() - a.x : a.x);
        b.y = Math.round(a.y);
    };
    saveExtraState$$module$build$src$core$serialization$blocks = function(a, b) {
        a.saveExtraState ? (a = a.saveExtraState(), null !== a && (b.extraState = a)) : a.mutationToDom && (a = a.mutationToDom(), null !== a && (b.extraState = domToText$$module$build$src$core$xml(a).replace(' xmlns="https://developers.google.com/blockly/xml"', "")));
    };
    saveIcons$$module$build$src$core$serialization$blocks = function(a, b) {
        a.getCommentText() && (b.icons = {
            comment: {
                text: a.getCommentText(),
                pinned: a.commentModel.pinned,
                height: Math.round(a.commentModel.size.height),
                width: Math.round(a.commentModel.size.width)
            }
        });
    };
    saveFields$$module$build$src$core$serialization$blocks = function(a, b, c) {
        const d = Object.create(null);
        for(let e = 0; e < a.inputList.length; e++){
            const f = a.inputList[e];
            for(let g = 0; g < f.fieldRow.length; g++){
                const h = f.fieldRow[g];
                h.isSerializable() && (d[h.name] = h.saveState(c));
            }
        }
        Object.keys(d).length && (b.fields = d);
    };
    saveInputBlocks$$module$build$src$core$serialization$blocks = function(a, b, c) {
        const d = Object.create(null);
        for(let e = 0; e < a.inputList.length; e++){
            const f = a.inputList[e];
            if (f.type === inputTypes$$module$build$src$core$input_types.DUMMY) continue;
            const g = saveConnection$$module$build$src$core$serialization$blocks(f.connection, c);
            g && (d[f.name] = g);
        }
        Object.keys(d).length && (b.inputs = d);
    };
    saveNextBlocks$$module$build$src$core$serialization$blocks = function(a, b, c) {
        a.nextConnection && (a = saveConnection$$module$build$src$core$serialization$blocks(a.nextConnection, c)) && (b.next = a);
    };
    saveConnection$$module$build$src$core$serialization$blocks = function(a, b) {
        const c = a.getShadowState(!0);
        a = a.targetBlock();
        if (!c && !a) return null;
        const d = Object.create(null);
        c && (d.shadow = c);
        a && !a.isShadow() && (d.block = save$$module$build$src$core$serialization$blocks(a, {
            doFullSerialization: b
        }));
        return d;
    };
    append$$module$build$src$core$serialization$blocks = function(a, b, { recordUndo: c = !1 } = {}) {
        return appendInternal$$module$build$src$core$serialization$blocks(a, b, {
            recordUndo: c
        });
    };
    appendInternal$$module$build$src$core$serialization$blocks = function(a, b, { parentConnection: c, isShadow: d = !1, recordUndo: e = !1 } = {}) {
        const f = getRecordUndo$$module$build$src$core$events$utils();
        setRecordUndo$$module$build$src$core$events$utils(e);
        (e = getGroup$$module$build$src$core$events$utils()) || setGroup$$module$build$src$core$events$utils(!0);
        disable$$module$build$src$core$events$utils();
        const g = appendPrivate$$module$build$src$core$serialization$blocks(a, b, {
            parentConnection: c,
            isShadow: d
        });
        enable$$module$build$src$core$events$utils();
        fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(CREATE$$module$build$src$core$events$utils))(g));
        setGroup$$module$build$src$core$events$utils(e);
        setRecordUndo$$module$build$src$core$events$utils(f);
        b.rendered && setTimeout(()=>{
            g.disposed || g.setConnectionTracking(!0);
        }, 1);
        return g;
    };
    appendPrivate$$module$build$src$core$serialization$blocks = function(a, b, { parentConnection: c, isShadow: d = !1 } = {}) {
        if (!a.type) throw new MissingBlockType$$module$build$src$core$serialization$exceptions(a);
        const e = b.newBlock(a.type, a.id);
        e.setShadow(d);
        loadCoords$$module$build$src$core$serialization$blocks(e, a);
        loadAttributes$$module$build$src$core$serialization$blocks(e, a);
        loadExtraState$$module$build$src$core$serialization$blocks(e, a);
        tryToConnectParent$$module$build$src$core$serialization$blocks(c, e, a);
        loadIcons$$module$build$src$core$serialization$blocks(e, a);
        loadFields$$module$build$src$core$serialization$blocks(e, a);
        loadInputBlocks$$module$build$src$core$serialization$blocks(e, a);
        loadNextBlocks$$module$build$src$core$serialization$blocks(e, a);
        initBlock$$module$build$src$core$serialization$blocks(e, b.rendered);
        return e;
    };
    loadCoords$$module$build$src$core$serialization$blocks = function(a, b) {
        let c = void 0 === b.x ? 0 : b.x;
        b = void 0 === b.y ? 0 : b.y;
        const d = a.workspace;
        c = d.RTL ? d.getWidth() - c : c;
        a.moveBy(c, b);
    };
    loadAttributes$$module$build$src$core$serialization$blocks = function(a, b) {
        b.collapsed && a.setCollapsed(!0);
        !1 === b.deletable && a.setDeletable(!1);
        !1 === b.movable && a.setMovable(!1);
        !1 === b.editable && a.setEditable(!1);
        !1 === b.enabled && a.setEnabled(!1);
        void 0 !== b.inline && a.setInputsInline(b.inline);
        void 0 !== b.data && (a.data = b.data);
    };
    loadExtraState$$module$build$src$core$serialization$blocks = function(a, b) {
        b.extraState && (a.loadExtraState ? a.loadExtraState(b.extraState) : a.domToMutation && a.domToMutation(textToDom$$module$build$src$core$utils$xml(b.extraState)));
    };
    tryToConnectParent$$module$build$src$core$serialization$blocks = function(a, b, c) {
        if (a) {
            if (a.getSourceBlock().isShadow() && !b.isShadow()) throw new RealChildOfShadow$$module$build$src$core$serialization$exceptions(c);
            if (a.type === inputTypes$$module$build$src$core$input_types.VALUE) {
                var d = b.outputConnection;
                if (!d) throw new MissingConnection$$module$build$src$core$serialization$exceptions("output", b, c);
            } else if (d = b.previousConnection, !d) throw new MissingConnection$$module$build$src$core$serialization$exceptions("previous", b, c);
            if (!a.connect(d)) {
                const e = b.workspace.connectionChecker;
                throw new BadConnectionCheck$$module$build$src$core$serialization$exceptions(e.getErrorMessage(e.canConnectWithReason(d, a, !1), d, a), a.type === inputTypes$$module$build$src$core$input_types.VALUE ? "output connection" : "previous connection", b, c);
            }
        }
    };
    loadIcons$$module$build$src$core$serialization$blocks = function(a, b) {
        b.icons && (b = b.icons.comment) && (a.setCommentText(b.text), "pinned" in b && (a.commentModel.pinned = b.pinned), "width" in b && "height" in b && (a.commentModel.size = new Size$$module$build$src$core$utils$size(b.width, b.height)), b.pinned && a.rendered && !a.isInFlyout && setTimeout(()=>a.getCommentIcon().setVisible(!0), 1));
    };
    loadFields$$module$build$src$core$serialization$blocks = function(a, b) {
        if (b.fields) {
            var c = Object.keys(b.fields);
            for(let d = 0; d < c.length; d++){
                const e = c[d], f = b.fields[e], g = a.getField(e);
                g ? g.loadState(f) : console.warn(`Ignoring non-existant field ${e} in block ${a.type}`);
            }
        }
    };
    loadInputBlocks$$module$build$src$core$serialization$blocks = function(a, b) {
        if (b.inputs) {
            var c = Object.keys(b.inputs);
            for(let d = 0; d < c.length; d++){
                const e = c[d], f = a.getInput(e);
                if (!f || !f.connection) throw new MissingConnection$$module$build$src$core$serialization$exceptions(e, a, b);
                loadConnection$$module$build$src$core$serialization$blocks(f.connection, b.inputs[e]);
            }
        }
    };
    loadNextBlocks$$module$build$src$core$serialization$blocks = function(a, b) {
        if (b.next) {
            if (!a.nextConnection) throw new MissingConnection$$module$build$src$core$serialization$exceptions("next", a, b);
            loadConnection$$module$build$src$core$serialization$blocks(a.nextConnection, b.next);
        }
    };
    loadConnection$$module$build$src$core$serialization$blocks = function(a, b) {
        b.shadow && a.setShadowState(b.shadow);
        b.block && appendPrivate$$module$build$src$core$serialization$blocks(b.block, a.getSourceBlock().workspace, {
            parentConnection: a
        });
    };
    initBlock$$module$build$src$core$serialization$blocks = function(a, b) {
        if (b) for(a.setConnectionTracking(!1), a.initSvg(), a.render(!1), a = a.getIcons(), b = 0; b < a.length; b++)a[b].computeIconLocation();
        else a.initModel();
    };
    connectReciprocally$$module$build$src$core$connection = function(a, b) {
        if (!a || !b) throw Error("Cannot connect null connections.");
        a.targetConnection = b;
        b.targetConnection = a;
    };
    getSingleConnection$$module$build$src$core$connection = function(a, b) {
        let c = null;
        b = b.outputConnection;
        const d = null == b ? void 0 : b.getConnectionChecker();
        for(let e = 0, f; f = a.inputList[e]; e++){
            const g = f.connection;
            let h;
            if (g && (null == (h = d) ? 0 : h.canConnect(b, g, !1))) {
                if (c) return null;
                c = g;
            }
        }
        return c;
    };
    getConnectionForOrphanedOutput$$module$build$src$core$connection = function(a, b) {
        let c;
        for(; c = getSingleConnection$$module$build$src$core$connection(a, b);)if (a = c.targetBlock(), !a || a.isShadow()) return c;
        return null;
    };
    toRadians$$module$build$src$core$utils$math = function(a) {
        return a * Math.PI / 180;
    };
    toDegrees$$module$build$src$core$utils$math = function(a) {
        return 180 * a / Math.PI;
    };
    clamp$$module$build$src$core$utils$math = function(a, b, c) {
        if (c < a) {
            const d = c;
            c = a;
            a = d;
        }
        return Math.max(a, Math.min(b, c));
    };
    createDom$$module$build$src$core$dropdowndiv = function() {
        div$$module$build$src$core$dropdowndiv || (div$$module$build$src$core$dropdowndiv = document.createElement("div"), div$$module$build$src$core$dropdowndiv.className = "blocklyDropDownDiv", (getParentContainer$$module$build$src$core$common() || document.body).appendChild(div$$module$build$src$core$dropdowndiv), content$$module$build$src$core$dropdowndiv = document.createElement("div"), content$$module$build$src$core$dropdowndiv.className = "blocklyDropDownContent", div$$module$build$src$core$dropdowndiv.appendChild(content$$module$build$src$core$dropdowndiv), arrow$$module$build$src$core$dropdowndiv = document.createElement("div"), arrow$$module$build$src$core$dropdowndiv.className = "blocklyDropDownArrow", div$$module$build$src$core$dropdowndiv.appendChild(arrow$$module$build$src$core$dropdowndiv), div$$module$build$src$core$dropdowndiv.style.opacity = "0", div$$module$build$src$core$dropdowndiv.style.transition = "transform " + ANIMATION_TIME$$module$build$src$core$dropdowndiv + "s, opacity " + ANIMATION_TIME$$module$build$src$core$dropdowndiv + "s", div$$module$build$src$core$dropdowndiv.addEventListener("focusin", function() {
            addClass$$module$build$src$core$utils$dom(div$$module$build$src$core$dropdowndiv, "blocklyFocused");
        }), div$$module$build$src$core$dropdowndiv.addEventListener("focusout", function() {
            removeClass$$module$build$src$core$utils$dom(div$$module$build$src$core$dropdowndiv, "blocklyFocused");
        }));
    };
    setBoundsElement$$module$build$src$core$dropdowndiv = function(a) {
        boundsElement$$module$build$src$core$dropdowndiv = a;
    };
    getOwner$$module$build$src$core$dropdowndiv = function() {
        return owner$$module$build$src$core$dropdowndiv;
    };
    getContentDiv$$module$build$src$core$dropdowndiv = function() {
        return content$$module$build$src$core$dropdowndiv;
    };
    clearContent$$module$build$src$core$dropdowndiv = function() {
        content$$module$build$src$core$dropdowndiv.textContent = "";
        content$$module$build$src$core$dropdowndiv.style.width = "";
    };
    setColour$$module$build$src$core$dropdowndiv = function(a, b) {
        div$$module$build$src$core$dropdowndiv.style.backgroundColor = a;
        div$$module$build$src$core$dropdowndiv.style.borderColor = b;
    };
    showPositionedByBlock$$module$build$src$core$dropdowndiv = function(a, b, c, d) {
        return showPositionedByRect$$module$build$src$core$dropdowndiv(getScaledBboxOfBlock$$module$build$src$core$dropdowndiv(b), a, c, d);
    };
    showPositionedByField$$module$build$src$core$dropdowndiv = function(a, b, c) {
        positionToField$$module$build$src$core$dropdowndiv = !0;
        return showPositionedByRect$$module$build$src$core$dropdowndiv(getScaledBboxOfField$$module$build$src$core$dropdowndiv(a), a, b, c);
    };
    getScaledBboxOfBlock$$module$build$src$core$dropdowndiv = function(a) {
        var b = a.getSvgRoot();
        const c = a.workspace.scale, d = a.height * c;
        a = a.width * c;
        b = getPageOffset$$module$build$src$core$utils$style(b);
        return new Rect$$module$build$src$core$utils$rect(b.y, b.y + d, b.x, b.x + a);
    };
    getScaledBboxOfField$$module$build$src$core$dropdowndiv = function(a) {
        a = a.getScaledBBox();
        return new Rect$$module$build$src$core$utils$rect(a.top, a.bottom, a.left, a.right);
    };
    showPositionedByRect$$module$build$src$core$dropdowndiv = function(a, b, c, d) {
        const e = a.left + (a.right - a.left) / 2, f = a.bottom;
        a = a.top;
        d && (a += d);
        d = b.getSourceBlock();
        let g = d.workspace;
        for(; g.options.parentWorkspace;)g = g.options.parentWorkspace;
        setBoundsElement$$module$build$src$core$dropdowndiv(g.getParentSvg().parentNode);
        return show$$module$build$src$core$dropdowndiv(b, d.RTL, e, f, e, a, c);
    };
    show$$module$build$src$core$dropdowndiv = function(a, b, c, d, e, f, g) {
        owner$$module$build$src$core$dropdowndiv = a;
        onHide$$module$build$src$core$dropdowndiv = g || null;
        div$$module$build$src$core$dropdowndiv.style.direction = b ? "rtl" : "ltr";
        a = getMainWorkspace$$module$build$src$core$common();
        renderedClassName$$module$build$src$core$dropdowndiv = a.getRenderer().getClassName();
        themeClassName$$module$build$src$core$dropdowndiv = a.getTheme().getClassName();
        renderedClassName$$module$build$src$core$dropdowndiv && addClass$$module$build$src$core$utils$dom(div$$module$build$src$core$dropdowndiv, renderedClassName$$module$build$src$core$dropdowndiv);
        themeClassName$$module$build$src$core$dropdowndiv && addClass$$module$build$src$core$utils$dom(div$$module$build$src$core$dropdowndiv, themeClassName$$module$build$src$core$dropdowndiv);
        return positionInternal$$module$build$src$core$dropdowndiv(c, d, e, f);
    };
    getPositionBelowMetrics$$module$build$src$core$dropdowndiv = function(a, b, c, d) {
        a = getPositionX$$module$build$src$core$dropdowndiv(a, c.left, c.right, d.width);
        return {
            initialX: a.divX,
            initialY: b,
            finalX: a.divX,
            finalY: b + PADDING_Y$$module$build$src$core$dropdowndiv,
            arrowX: a.arrowX,
            arrowY: -(ARROW_SIZE$$module$build$src$core$dropdowndiv / 2 + BORDER_SIZE$$module$build$src$core$dropdowndiv),
            arrowAtTop: !0,
            arrowVisible: !0
        };
    };
    getPositionAboveMetrics$$module$build$src$core$dropdowndiv = function(a, b, c, d) {
        a = getPositionX$$module$build$src$core$dropdowndiv(a, c.left, c.right, d.width);
        return {
            initialX: a.divX,
            initialY: b - d.height,
            finalX: a.divX,
            finalY: b - d.height - PADDING_Y$$module$build$src$core$dropdowndiv,
            arrowX: a.arrowX,
            arrowY: d.height - 2 * BORDER_SIZE$$module$build$src$core$dropdowndiv - ARROW_SIZE$$module$build$src$core$dropdowndiv / 2,
            arrowAtTop: !1,
            arrowVisible: !0
        };
    };
    getPositionTopOfPageMetrics$$module$build$src$core$dropdowndiv = function(a, b, c) {
        a = getPositionX$$module$build$src$core$dropdowndiv(a, b.left, b.right, c.width);
        return {
            initialX: a.divX,
            initialY: 0,
            finalX: a.divX,
            finalY: 0,
            arrowAtTop: null,
            arrowX: null,
            arrowY: null,
            arrowVisible: !1
        };
    };
    getPositionX$$module$build$src$core$dropdowndiv = function(a, b, c, d) {
        b = clamp$$module$build$src$core$utils$math(b, a - d / 2, c - d);
        a = a - ARROW_SIZE$$module$build$src$core$dropdowndiv / 2 - b;
        c = ARROW_HORIZONTAL_PADDING$$module$build$src$core$dropdowndiv;
        a = clamp$$module$build$src$core$utils$math(c, a, d - c - ARROW_SIZE$$module$build$src$core$dropdowndiv);
        return {
            arrowX: a,
            divX: b
        };
    };
    isVisible$$module$build$src$core$dropdowndiv = function() {
        return !!owner$$module$build$src$core$dropdowndiv;
    };
    hideIfOwner$$module$build$src$core$dropdowndiv = function(a, b) {
        return owner$$module$build$src$core$dropdowndiv === a ? (b ? hideWithoutAnimation$$module$build$src$core$dropdowndiv() : hide$$module$build$src$core$dropdowndiv(), !0) : !1;
    };
    hide$$module$build$src$core$dropdowndiv = function() {
        div$$module$build$src$core$dropdowndiv.style.transform = "translate(0, 0)";
        div$$module$build$src$core$dropdowndiv.style.opacity = "0";
        animateOutTimer$$module$build$src$core$dropdowndiv = setTimeout(function() {
            hideWithoutAnimation$$module$build$src$core$dropdowndiv();
        }, 1E3 * ANIMATION_TIME$$module$build$src$core$dropdowndiv);
        onHide$$module$build$src$core$dropdowndiv && (onHide$$module$build$src$core$dropdowndiv(), onHide$$module$build$src$core$dropdowndiv = null);
    };
    hideWithoutAnimation$$module$build$src$core$dropdowndiv = function() {
        isVisible$$module$build$src$core$dropdowndiv() && (animateOutTimer$$module$build$src$core$dropdowndiv && clearTimeout(animateOutTimer$$module$build$src$core$dropdowndiv), div$$module$build$src$core$dropdowndiv.style.transform = "", div$$module$build$src$core$dropdowndiv.style.left = "", div$$module$build$src$core$dropdowndiv.style.top = "", div$$module$build$src$core$dropdowndiv.style.opacity = "0", div$$module$build$src$core$dropdowndiv.style.display = "none", div$$module$build$src$core$dropdowndiv.style.backgroundColor = "", div$$module$build$src$core$dropdowndiv.style.borderColor = "", onHide$$module$build$src$core$dropdowndiv && (onHide$$module$build$src$core$dropdowndiv(), onHide$$module$build$src$core$dropdowndiv = null), clearContent$$module$build$src$core$dropdowndiv(), owner$$module$build$src$core$dropdowndiv = null, renderedClassName$$module$build$src$core$dropdowndiv && (removeClass$$module$build$src$core$utils$dom(div$$module$build$src$core$dropdowndiv, renderedClassName$$module$build$src$core$dropdowndiv), renderedClassName$$module$build$src$core$dropdowndiv = ""), themeClassName$$module$build$src$core$dropdowndiv && (removeClass$$module$build$src$core$utils$dom(div$$module$build$src$core$dropdowndiv, themeClassName$$module$build$src$core$dropdowndiv), themeClassName$$module$build$src$core$dropdowndiv = ""), getMainWorkspace$$module$build$src$core$common().markFocused());
    };
    positionInternal$$module$build$src$core$dropdowndiv = function(a, b, c, d) {
        a = internal$$module$build$src$core$dropdowndiv.getPositionMetrics(a, b, c, d);
        a.arrowVisible ? (arrow$$module$build$src$core$dropdowndiv.style.display = "", arrow$$module$build$src$core$dropdowndiv.style.transform = "translate(" + a.arrowX + "px," + a.arrowY + "px) rotate(45deg)", arrow$$module$build$src$core$dropdowndiv.setAttribute("class", a.arrowAtTop ? "blocklyDropDownArrow blocklyArrowTop" : "blocklyDropDownArrow blocklyArrowBottom")) : arrow$$module$build$src$core$dropdowndiv.style.display = "none";
        b = Math.floor(a.initialX);
        c = Math.floor(a.initialY);
        d = Math.floor(a.finalX);
        const e = Math.floor(a.finalY);
        div$$module$build$src$core$dropdowndiv.style.left = b + "px";
        div$$module$build$src$core$dropdowndiv.style.top = c + "px";
        div$$module$build$src$core$dropdowndiv.style.display = "block";
        div$$module$build$src$core$dropdowndiv.style.opacity = "1";
        div$$module$build$src$core$dropdowndiv.style.transform = "translate(" + (d - b) + "px," + (e - c) + "px)";
        return !!a.arrowAtTop;
    };
    repositionForWindowResize$$module$build$src$core$dropdowndiv = function() {
        if (owner$$module$build$src$core$dropdowndiv) {
            var a = owner$$module$build$src$core$dropdowndiv.getSourceBlock();
            a = positionToField$$module$build$src$core$dropdowndiv ? getScaledBboxOfField$$module$build$src$core$dropdowndiv(owner$$module$build$src$core$dropdowndiv) : getScaledBboxOfBlock$$module$build$src$core$dropdowndiv(a);
            const b = a.left + (a.right - a.left) / 2;
            positionInternal$$module$build$src$core$dropdowndiv(b, a.bottom, b, a.top);
        } else hide$$module$build$src$core$dropdowndiv();
    };
    startsWith$$module$build$src$core$utils$string = function(a, b) {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.string.startsWith()", "April 2022", "April 2023", "Use built-in string.startsWith");
        return a.startsWith(b);
    };
    shortestStringLength$$module$build$src$core$utils$string = function(a) {
        return a.length ? a.reduce(function(b, c) {
            return b.length < c.length ? b : c;
        }).length : 0;
    };
    commonWordPrefix$$module$build$src$core$utils$string = function(a, b) {
        if (!a.length) return 0;
        if (1 === a.length) return a[0].length;
        let c = 0;
        b = b || shortestStringLength$$module$build$src$core$utils$string(a);
        let d;
        for(d = 0; d < b; d++){
            var e = a[0][d];
            for(var f = 1; f < a.length; f++)if (e !== a[f][d]) return c;
            " " === e && (c = d + 1);
        }
        for(e = 1; e < a.length; e++)if ((f = a[e][d]) && " " !== f) return c;
        return b;
    };
    commonWordSuffix$$module$build$src$core$utils$string = function(a, b) {
        if (!a.length) return 0;
        if (1 === a.length) return a[0].length;
        let c = 0;
        b = b || shortestStringLength$$module$build$src$core$utils$string(a);
        let d;
        for(d = 0; d < b; d++){
            var e = a[0].substr(-d - 1, 1);
            for(var f = 1; f < a.length; f++)if (e !== a[f].substr(-d - 1, 1)) return c;
            " " === e && (c = d + 1);
        }
        for(e = 1; e < a.length; e++)if ((f = a[e].charAt(a[e].length - d - 1)) && " " !== f) return c;
        return b;
    };
    wrap$$module$build$src$core$utils$string = function(a, b) {
        a = a.split("\n");
        for(let c = 0; c < a.length; c++)a[c] = wrapLine$$module$build$src$core$utils$string(a[c], b);
        return a.join("\n");
    };
    wrapLine$$module$build$src$core$utils$string = function(a, b) {
        if (a.length <= b) return a;
        const c = a.trim().split(/\s+/);
        for(var d = 0; d < c.length; d++)c[d].length > b && (b = c[d].length);
        var e = -Infinity;
        let f, g = 1;
        do {
            d = e;
            f = a;
            a = [];
            e = c.length / g;
            let h = 1;
            for(let k = 0; k < c.length - 1; k++)h < (k + 1.5) / e ? (h++, a[k] = !0) : a[k] = !1;
            a = wrapMutate$$module$build$src$core$utils$string(c, a, b);
            e = wrapScore$$module$build$src$core$utils$string(c, a, b);
            a = wrapToText$$module$build$src$core$utils$string(c, a);
            g++;
        }while (e > d);
        return f;
    };
    wrapScore$$module$build$src$core$utils$string = function(a, b, c) {
        const d = [
            0
        ], e = [];
        for(var f = 0; f < a.length; f++)d[d.length - 1] += a[f].length, !0 === b[f] ? (d.push(0), e.push(a[f].charAt(a[f].length - 1))) : !1 === b[f] && d[d.length - 1]++;
        a = Math.max(...d);
        b = 0;
        for(f = 0; f < d.length; f++)b -= 2 * Math.pow(Math.abs(c - d[f]), 1.5), b -= Math.pow(a - d[f], 1.5), -1 !== ".?!".indexOf(e[f]) ? b += c / 3 : -1 !== ",;)]}".indexOf(e[f]) && (b += c / 4);
        1 < d.length && d[d.length - 1] <= d[d.length - 2] && (b += .5);
        return b;
    };
    wrapMutate$$module$build$src$core$utils$string = function(a, b, c) {
        let d = wrapScore$$module$build$src$core$utils$string(a, b, c), e;
        for(let f = 0; f < b.length - 1; f++){
            if (b[f] === b[f + 1]) continue;
            const g = [].concat(b);
            g[f] = !g[f];
            g[f + 1] = !g[f + 1];
            const h = wrapScore$$module$build$src$core$utils$string(a, g, c);
            h > d && (d = h, e = g);
        }
        return e ? wrapMutate$$module$build$src$core$utils$string(a, e, c) : b;
    };
    wrapToText$$module$build$src$core$utils$string = function(a, b) {
        const c = [];
        for(let d = 0; d < a.length; d++)c.push(a[d]), void 0 !== b[d] && c.push(b[d] ? "\n" : " ");
        return c.join("");
    };
    isNumber$$module$build$src$core$utils$string = function(a) {
        return /^\s*-?\d+(\.\d+)?\s*$/.test(a);
    };
    setCustomTooltip$$module$build$src$core$tooltip = function(a) {
        customTooltip$$module$build$src$core$tooltip = a;
    };
    getCustomTooltip$$module$build$src$core$tooltip = function() {
        return customTooltip$$module$build$src$core$tooltip;
    };
    isVisible$$module$build$src$core$tooltip = function() {
        return visible$$module$build$src$core$tooltip;
    };
    getDiv$$module$build$src$core$tooltip = function() {
        return containerDiv$$module$build$src$core$tooltip;
    };
    getTooltipOfObject$$module$build$src$core$tooltip = function(a) {
        if (a = getTargetObject$$module$build$src$core$tooltip(a)) {
            for(a = a.tooltip; "function" === typeof a;)a = a();
            if ("string" !== typeof a) throw Error("Tooltip function must return a string.");
            return a;
        }
        return "";
    };
    getTargetObject$$module$build$src$core$tooltip = function(a) {
        for(; a && a.tooltip;){
            if ("string" === typeof a.tooltip || "function" === typeof a.tooltip) return a;
            a = a.tooltip;
        }
        return null;
    };
    createDom$$module$build$src$core$tooltip = function() {
        containerDiv$$module$build$src$core$tooltip || (containerDiv$$module$build$src$core$tooltip = document.createElement("div"), containerDiv$$module$build$src$core$tooltip.className = "blocklyTooltipDiv", (getParentContainer$$module$build$src$core$common() || document.body).appendChild(containerDiv$$module$build$src$core$tooltip));
    };
    bindMouseEvents$$module$build$src$core$tooltip = function(a) {
        a.mouseOverWrapper_ = bind$$module$build$src$core$browser_events(a, "pointerover", null, onMouseOver$$module$build$src$core$tooltip);
        a.mouseOutWrapper_ = bind$$module$build$src$core$browser_events(a, "pointerout", null, onMouseOut$$module$build$src$core$tooltip);
        a.addEventListener("pointermove", onMouseMove$$module$build$src$core$tooltip, !1);
    };
    unbindMouseEvents$$module$build$src$core$tooltip = function(a) {
        a && (unbind$$module$build$src$core$browser_events(a.mouseOverWrapper_), unbind$$module$build$src$core$browser_events(a.mouseOutWrapper_), a.removeEventListener("pointermove", onMouseMove$$module$build$src$core$tooltip));
    };
    onMouseOver$$module$build$src$core$tooltip = function(a) {
        blocked$$module$build$src$core$tooltip || (a = getTargetObject$$module$build$src$core$tooltip(a.currentTarget), element$$module$build$src$core$tooltip !== a && (hide$$module$build$src$core$tooltip(), poisonedElement$$module$build$src$core$tooltip = null, element$$module$build$src$core$tooltip = a), clearTimeout(mouseOutPid$$module$build$src$core$tooltip));
    };
    onMouseOut$$module$build$src$core$tooltip = function(a) {
        blocked$$module$build$src$core$tooltip || (mouseOutPid$$module$build$src$core$tooltip = setTimeout(function() {
            poisonedElement$$module$build$src$core$tooltip = element$$module$build$src$core$tooltip = null;
            hide$$module$build$src$core$tooltip();
        }, 1), clearTimeout(showPid$$module$build$src$core$tooltip), showPid$$module$build$src$core$tooltip = 0);
    };
    onMouseMove$$module$build$src$core$tooltip = function(a) {
        if (element$$module$build$src$core$tooltip && element$$module$build$src$core$tooltip.tooltip && !blocked$$module$build$src$core$tooltip) {
            if (visible$$module$build$src$core$tooltip) {
                const b = lastX$$module$build$src$core$tooltip - a.pageX;
                a = lastY$$module$build$src$core$tooltip - a.pageY;
                Math.sqrt(b * b + a * a) > RADIUS_OK$$module$build$src$core$tooltip && hide$$module$build$src$core$tooltip();
            } else poisonedElement$$module$build$src$core$tooltip !== element$$module$build$src$core$tooltip && (clearTimeout(showPid$$module$build$src$core$tooltip), lastX$$module$build$src$core$tooltip = a.pageX, lastY$$module$build$src$core$tooltip = a.pageY, showPid$$module$build$src$core$tooltip = setTimeout(show$$module$build$src$core$tooltip, HOVER_MS$$module$build$src$core$tooltip));
        }
    };
    dispose$$module$build$src$core$tooltip = function() {
        poisonedElement$$module$build$src$core$tooltip = element$$module$build$src$core$tooltip = null;
        hide$$module$build$src$core$tooltip();
    };
    hide$$module$build$src$core$tooltip = function() {
        visible$$module$build$src$core$tooltip && (visible$$module$build$src$core$tooltip = !1, containerDiv$$module$build$src$core$tooltip && (containerDiv$$module$build$src$core$tooltip.style.display = "none"));
        showPid$$module$build$src$core$tooltip && (clearTimeout(showPid$$module$build$src$core$tooltip), showPid$$module$build$src$core$tooltip = 0);
    };
    block$$module$build$src$core$tooltip = function() {
        hide$$module$build$src$core$tooltip();
        blocked$$module$build$src$core$tooltip = !0;
    };
    unblock$$module$build$src$core$tooltip = function() {
        blocked$$module$build$src$core$tooltip = !1;
    };
    renderContent$$module$build$src$core$tooltip = function() {
        containerDiv$$module$build$src$core$tooltip && element$$module$build$src$core$tooltip && ("function" === typeof customTooltip$$module$build$src$core$tooltip ? customTooltip$$module$build$src$core$tooltip(containerDiv$$module$build$src$core$tooltip, element$$module$build$src$core$tooltip) : renderDefaultContent$$module$build$src$core$tooltip());
    };
    renderDefaultContent$$module$build$src$core$tooltip = function() {
        var a = getTooltipOfObject$$module$build$src$core$tooltip(element$$module$build$src$core$tooltip);
        a = wrap$$module$build$src$core$utils$string(a, LIMIT$$module$build$src$core$tooltip);
        a = a.split("\n");
        for(let b = 0; b < a.length; b++){
            const c = document.createElement("div");
            c.appendChild(document.createTextNode(a[b]));
            containerDiv$$module$build$src$core$tooltip.appendChild(c);
        }
    };
    getPosition$$module$build$src$core$tooltip = function(a) {
        const b = document.documentElement.clientWidth, c = document.documentElement.clientHeight;
        let d = lastX$$module$build$src$core$tooltip;
        d = a ? d - (OFFSET_X$$module$build$src$core$tooltip + containerDiv$$module$build$src$core$tooltip.offsetWidth) : d + OFFSET_X$$module$build$src$core$tooltip;
        let e = lastY$$module$build$src$core$tooltip + OFFSET_Y$$module$build$src$core$tooltip;
        e + containerDiv$$module$build$src$core$tooltip.offsetHeight > c + window.scrollY && (e -= containerDiv$$module$build$src$core$tooltip.offsetHeight + 2 * OFFSET_Y$$module$build$src$core$tooltip);
        a ? d = Math.max(MARGINS$$module$build$src$core$tooltip - window.scrollX, d) : d + containerDiv$$module$build$src$core$tooltip.offsetWidth > b + window.scrollX - 2 * MARGINS$$module$build$src$core$tooltip && (d = b - containerDiv$$module$build$src$core$tooltip.offsetWidth - 2 * MARGINS$$module$build$src$core$tooltip);
        return {
            x: d,
            y: e
        };
    };
    show$$module$build$src$core$tooltip = function() {
        if (!blocked$$module$build$src$core$tooltip && (poisonedElement$$module$build$src$core$tooltip = element$$module$build$src$core$tooltip, containerDiv$$module$build$src$core$tooltip)) {
            containerDiv$$module$build$src$core$tooltip.textContent = "";
            renderContent$$module$build$src$core$tooltip();
            var a = element$$module$build$src$core$tooltip.RTL;
            containerDiv$$module$build$src$core$tooltip.style.direction = a ? "rtl" : "ltr";
            containerDiv$$module$build$src$core$tooltip.style.display = "block";
            visible$$module$build$src$core$tooltip = !0;
            var { x: b, y: c } = getPosition$$module$build$src$core$tooltip(a);
            containerDiv$$module$build$src$core$tooltip.style.left = b + "px";
            containerDiv$$module$build$src$core$tooltip.style.top = c + "px";
        }
    };
    getHsvSaturation$$module$build$src$core$utils$colour = function() {
        return hsvSaturation$$module$build$src$core$utils$colour;
    };
    setHsvSaturation$$module$build$src$core$utils$colour = function(a) {
        hsvSaturation$$module$build$src$core$utils$colour = a;
    };
    getHsvValue$$module$build$src$core$utils$colour = function() {
        return hsvValue$$module$build$src$core$utils$colour;
    };
    setHsvValue$$module$build$src$core$utils$colour = function(a) {
        hsvValue$$module$build$src$core$utils$colour = a;
    };
    parse$$module$build$src$core$utils$colour = function(a) {
        a = `${a}`.toLowerCase().trim();
        var b = names$$module$build$src$core$utils$colour[a];
        if (b) return b;
        b = "0x" === a.substring(0, 2) ? "#" + a.substring(2) : a;
        b = "#" === b[0] ? b : "#" + b;
        if (/^#[0-9a-f]{6}$/.test(b)) return b;
        if (/^#[0-9a-f]{3}$/.test(b)) return [
            "#",
            b[1],
            b[1],
            b[2],
            b[2],
            b[3],
            b[3]
        ].join("");
        var c = a.match(/^(?:rgb)?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/);
        return c && (a = Number(c[1]), b = Number(c[2]), c = Number(c[3]), 0 <= a && 256 > a && 0 <= b && 256 > b && 0 <= c && 256 > c) ? rgbToHex$$module$build$src$core$utils$colour(a, b, c) : null;
    };
    rgbToHex$$module$build$src$core$utils$colour = function(a, b, c) {
        b = a << 16 | b << 8 | c;
        return 16 > a ? "#" + (16777216 | b).toString(16).substr(1) : "#" + b.toString(16);
    };
    hexToRgb$$module$build$src$core$utils$colour = function(a) {
        a = parse$$module$build$src$core$utils$colour(a);
        if (!a) return [
            0,
            0,
            0
        ];
        a = parseInt(a.substr(1), 16);
        return [
            a >> 16,
            a >> 8 & 255,
            a & 255
        ];
    };
    hsvToHex$$module$build$src$core$utils$colour = function(a, b, c) {
        let d = 0, e = 0, f = 0;
        if (0 === b) f = e = d = c;
        else {
            const g = Math.floor(a / 60), h = a / 60 - g;
            a = c * (1 - b);
            const k = c * (1 - b * h);
            b = c * (1 - b * (1 - h));
            switch(g){
                case 1:
                    d = k;
                    e = c;
                    f = a;
                    break;
                case 2:
                    d = a;
                    e = c;
                    f = b;
                    break;
                case 3:
                    d = a;
                    e = k;
                    f = c;
                    break;
                case 4:
                    d = b;
                    e = a;
                    f = c;
                    break;
                case 5:
                    d = c;
                    e = a;
                    f = k;
                    break;
                case 6:
                case 0:
                    d = c, e = b, f = a;
            }
        }
        return rgbToHex$$module$build$src$core$utils$colour(Math.floor(d), Math.floor(e), Math.floor(f));
    };
    blend$$module$build$src$core$utils$colour = function(a, b, c) {
        a = parse$$module$build$src$core$utils$colour(a);
        if (!a) return null;
        b = parse$$module$build$src$core$utils$colour(b);
        if (!b) return null;
        a = hexToRgb$$module$build$src$core$utils$colour(a);
        b = hexToRgb$$module$build$src$core$utils$colour(b);
        return rgbToHex$$module$build$src$core$utils$colour(Math.round(b[0] + c * (a[0] - b[0])), Math.round(b[1] + c * (a[1] - b[1])), Math.round(b[2] + c * (a[2] - b[2])));
    };
    hueToHex$$module$build$src$core$utils$colour = function(a) {
        return hsvToHex$$module$build$src$core$utils$colour(a, hsvSaturation$$module$build$src$core$utils$colour, 255 * hsvValue$$module$build$src$core$utils$colour);
    };
    tokenizeInterpolationInternal$$module$build$src$core$utils$parsing = function(a, b) {
        const c = [];
        var d = a.split("");
        d.push("");
        var e = 0;
        a = [];
        let f = null;
        for(let k = 0; k < d.length; k++){
            var g = d[k];
            if (0 === e) "%" === g ? ((e = a.join("")) && c.push(e), a.length = 0, e = 1) : a.push(g);
            else if (1 === e) "%" === g ? (a.push(g), e = 0) : b && "0" <= g && "9" >= g ? (e = 2, f = g, (g = a.join("")) && c.push(g), a.length = 0) : "{" === g ? e = 3 : (a.push("%", g), e = 0);
            else if (2 === e) {
                if ("0" <= g && "9" >= g) f += g;
                else {
                    var h = void 0;
                    c.push(parseInt(null != (h = f) ? h : "", 10));
                    k--;
                    e = 0;
                }
            } else 3 === e && ("" === g ? (a.splice(0, 0, "%{"), k--, e = 0) : "}" !== g ? a.push(g) : (e = a.join(""), /[A-Z]\w*/i.test(e) ? (g = e.toUpperCase(), (g = g.startsWith("BKY_") ? g.substring(4) : null) && g in Msg$$module$build$src$core$msg ? (e = Msg$$module$build$src$core$msg[g], "string" === typeof e ? Array.prototype.push.apply(c, tokenizeInterpolationInternal$$module$build$src$core$utils$parsing(e, b)) : b ? c.push(`${e}`) : c.push(e)) : c.push("%{" + e + "}")) : c.push("%{" + e + "}"), e = a.length = 0));
        }
        (b = a.join("")) && c.push(b);
        h = [];
        a.length = 0;
        for(d = 0; d < c.length; d++)"string" === typeof c[d] ? a.push(c[d]) : ((b = a.join("")) && h.push(b), a.length = 0, h.push(c[d]));
        (b = a.join("")) && h.push(b);
        a.length = 0;
        return h;
    };
    tokenizeInterpolation$$module$build$src$core$utils$parsing = function(a) {
        return tokenizeInterpolationInternal$$module$build$src$core$utils$parsing(a, !0);
    };
    replaceMessageReferences$$module$build$src$core$utils$parsing = function(a) {
        if ("string" !== typeof a) return a;
        a = tokenizeInterpolationInternal$$module$build$src$core$utils$parsing(a, !1);
        return a.length ? String(a[0]) : "";
    };
    checkMessageReferences$$module$build$src$core$utils$parsing = function(a) {
        let b = !0;
        const c = Msg$$module$build$src$core$msg, d = a.match(/%{BKY_[A-Z]\w*}/ig);
        if (d) for(let e = 0; e < d.length; e++){
            const f = d[e].toUpperCase();
            void 0 === c[f.slice(6, -1)] && (console.warn("No message string for " + d[e] + " in " + a), b = !1);
        }
        return b;
    };
    parseBlockColour$$module$build$src$core$utils$parsing = function(a) {
        const b = "string" === typeof a ? replaceMessageReferences$$module$build$src$core$utils$parsing(a) : a;
        var c = Number(b);
        if (!isNaN(c) && 0 <= c && 360 >= c) return {
            hue: c,
            hex: hsvToHex$$module$build$src$core$utils$colour(c, getHsvSaturation$$module$build$src$core$utils$colour(), 255 * getHsvValue$$module$build$src$core$utils$colour())
        };
        if (c = parse$$module$build$src$core$utils$colour(b)) return {
            hue: null,
            hex: c
        };
        c = 'Invalid colour: "' + b + '"';
        a !== b && (c += ' (from "' + a + '")');
        throw Error(c);
    };
    getDiv$$module$build$src$core$widgetdiv = function() {
        return containerDiv$$module$build$src$core$widgetdiv;
    };
    testOnly_setDiv$$module$build$src$core$widgetdiv = function(a) {
        containerDiv$$module$build$src$core$widgetdiv = a;
    };
    createDom$$module$build$src$core$widgetdiv = function() {
        containerDiv$$module$build$src$core$widgetdiv || (containerDiv$$module$build$src$core$widgetdiv = document.createElement("div"), containerDiv$$module$build$src$core$widgetdiv.className = "blocklyWidgetDiv", (getParentContainer$$module$build$src$core$common() || document.body).appendChild(containerDiv$$module$build$src$core$widgetdiv));
    };
    show$$module$build$src$core$widgetdiv = function(a, b, c) {
        hide$$module$build$src$core$widgetdiv();
        owner$$module$build$src$core$widgetdiv = a;
        dispose$$module$build$src$core$widgetdiv = c;
        if (a = containerDiv$$module$build$src$core$widgetdiv) a.style.direction = b ? "rtl" : "ltr", a.style.display = "block", b = getMainWorkspace$$module$build$src$core$common(), rendererClassName$$module$build$src$core$widgetdiv = b.getRenderer().getClassName(), themeClassName$$module$build$src$core$widgetdiv = b.getTheme().getClassName(), rendererClassName$$module$build$src$core$widgetdiv && addClass$$module$build$src$core$utils$dom(a, rendererClassName$$module$build$src$core$widgetdiv), themeClassName$$module$build$src$core$widgetdiv && addClass$$module$build$src$core$utils$dom(a, themeClassName$$module$build$src$core$widgetdiv);
    };
    hide$$module$build$src$core$widgetdiv = function() {
        if (isVisible$$module$build$src$core$widgetdiv()) {
            owner$$module$build$src$core$widgetdiv = null;
            var a = containerDiv$$module$build$src$core$widgetdiv;
            a && (a.style.display = "none", a.style.left = "", a.style.top = "", dispose$$module$build$src$core$widgetdiv && dispose$$module$build$src$core$widgetdiv(), dispose$$module$build$src$core$widgetdiv = null, a.textContent = "", rendererClassName$$module$build$src$core$widgetdiv && (removeClass$$module$build$src$core$utils$dom(a, rendererClassName$$module$build$src$core$widgetdiv), rendererClassName$$module$build$src$core$widgetdiv = ""), themeClassName$$module$build$src$core$widgetdiv && (removeClass$$module$build$src$core$utils$dom(a, themeClassName$$module$build$src$core$widgetdiv), themeClassName$$module$build$src$core$widgetdiv = ""), getMainWorkspace$$module$build$src$core$common().markFocused());
        }
    };
    isVisible$$module$build$src$core$widgetdiv = function() {
        return !!owner$$module$build$src$core$widgetdiv;
    };
    hideIfOwner$$module$build$src$core$widgetdiv = function(a) {
        owner$$module$build$src$core$widgetdiv === a && hide$$module$build$src$core$widgetdiv();
    };
    positionInternal$$module$build$src$core$widgetdiv = function(a, b, c) {
        containerDiv$$module$build$src$core$widgetdiv.style.left = a + "px";
        containerDiv$$module$build$src$core$widgetdiv.style.top = b + "px";
        containerDiv$$module$build$src$core$widgetdiv.style.height = c + "px";
    };
    positionWithAnchor$$module$build$src$core$widgetdiv = function(a, b, c, d) {
        const e = calculateY$$module$build$src$core$widgetdiv(a, b, c);
        a = calculateX$$module$build$src$core$widgetdiv(a, b, c, d);
        0 > e ? positionInternal$$module$build$src$core$widgetdiv(a, 0, c.height + e) : positionInternal$$module$build$src$core$widgetdiv(a, e, c.height);
    };
    calculateX$$module$build$src$core$widgetdiv = function(a, b, c, d) {
        return d ? Math.min(Math.max(b.right - c.width, a.left), a.right - c.width) : Math.max(Math.min(b.left, a.right - c.width), a.left);
    };
    calculateY$$module$build$src$core$widgetdiv = function(a, b, c) {
        return b.bottom + c.height >= a.bottom ? b.top - c.height : b.bottom;
    };
    register$$module$build$src$core$field_registry = function(a, b) {
        register$$module$build$src$core$registry(Type$$module$build$src$core$registry.FIELD, a, b);
    };
    unregister$$module$build$src$core$field_registry = function(a) {
        unregister$$module$build$src$core$registry(Type$$module$build$src$core$registry.FIELD, a);
    };
    fromJson$$module$build$src$core$field_registry = function(a) {
        return TEST_ONLY$$module$build$src$core$field_registry.fromJsonInternal(a);
    };
    fromJsonInternal$$module$build$src$core$field_registry = function(a) {
        const b = getObject$$module$build$src$core$registry(Type$$module$build$src$core$registry.FIELD, a.type);
        if (b) {
            if ("function" !== typeof b.fromJson) throw new TypeError("returned Field was not a IRegistrableField");
            return b.fromJson(a);
        }
        console.warn("Blockly could not create a field of type " + a.type + ". The field is probably not being registered. This could be because the file is not loaded, the field does not register itself (Issue #1584), or the registration is not being reached.");
        return null;
    };
    setRole$$module$build$src$core$utils$aria = function(a, b) {
        a.setAttribute(ROLE_ATTRIBUTE$$module$build$src$core$utils$aria, b);
    };
    setState$$module$build$src$core$utils$aria = function(a, b, c) {
        Array.isArray(c) && (c = c.join(" "));
        a.setAttribute(ARIA_PREFIX$$module$build$src$core$utils$aria + b, `${c}`);
    };
    trimOptions$$module$build$src$core$field_dropdown = function(a) {
        let b = !1;
        const c = a.map(([g, h])=>{
            if ("string" === typeof g) return [
                replaceMessageReferences$$module$build$src$core$utils$parsing(g),
                h
            ];
            b = !0;
            return [
                null !== g.alt ? Object.assign({}, g, {
                    alt: replaceMessageReferences$$module$build$src$core$utils$parsing(g.alt)
                }) : Object.assign({}, g),
                h
            ];
        });
        if (b || 2 > a.length) return {
            options: c
        };
        var d = c.map(([g])=>g), e = shortestStringLength$$module$build$src$core$utils$string(d);
        a = commonWordPrefix$$module$build$src$core$utils$string(d, e);
        const f = commonWordSuffix$$module$build$src$core$utils$string(d, e);
        if (!a && !f || e <= a + f) return {
            options: c
        };
        e = a ? d[0].substring(0, a - 1) : void 0;
        d = f ? d[0].substr(1 - f) : void 0;
        return {
            options: applyTrim$$module$build$src$core$field_dropdown(c, a, f),
            prefix: e,
            suffix: d
        };
    };
    applyTrim$$module$build$src$core$field_dropdown = function(a, b, c) {
        return a.map(([d, e])=>[
                d.substring(b, d.length - c),
                e
            ]);
    };
    validateOptions$$module$build$src$core$field_dropdown = function(a) {
        if (!Array.isArray(a)) throw TypeError("FieldDropdown options must be an array.");
        if (!a.length) throw TypeError("FieldDropdown options must not be an empty array.");
        let b = !1;
        for(let c = 0; c < a.length; c++){
            const d = a[c];
            Array.isArray(d) ? "string" !== typeof d[1] ? (b = !0, console.error("Invalid option[" + c + "]: Each FieldDropdown option id must be a string. Found " + d[1] + " in: ", d)) : d[0] && "string" !== typeof d[0] && "string" !== typeof d[0].src && (b = !0, console.error("Invalid option[" + c + "]: Each FieldDropdown option must have a string label or image description. Found" + d[0] + " in: ", d)) : (b = !0, console.error("Invalid option[" + c + "]: Each FieldDropdown option must be an array. Found: ", d));
        }
        if (b) throw TypeError("Found invalid FieldDropdown options.");
    };
    inherits$$module$build$src$core$utils$object = function(a, b) {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.object.inherits", "version 9", "version 10");
        a.superClass_ = b.prototype;
        Object.setPrototypeOf(a, b);
        a.prototype = Object.create(b.prototype);
        a.prototype.constructor = a;
    };
    mixin$$module$build$src$core$utils$object = function(a, b) {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.object.mixin", "May 2022", "May 2023", "Object.assign");
        for(const c in b)a[c] = b[c];
    };
    deepMerge$$module$build$src$core$utils$object = function(a, b) {
        for(const c in b)a[c] = null !== b[c] && "object" === typeof b[c] ? deepMerge$$module$build$src$core$utils$object(a[c] || Object.create(null), b[c]) : b[c];
        return a;
    };
    values$$module$build$src$core$utils$object = function(a) {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.object.values", "version 9", "version 10", "Object.values");
        return Object.values(a);
    };
    convertToolboxDefToJson$$module$build$src$core$utils$toolbox = function(a) {
        if (!a) return null;
        if (a instanceof Element || "string" === typeof a) a = parseToolboxTree$$module$build$src$core$utils$toolbox(a), a = convertToToolboxJson$$module$build$src$core$utils$toolbox(a);
        validateToolbox$$module$build$src$core$utils$toolbox(a);
        return a;
    };
    validateToolbox$$module$build$src$core$utils$toolbox = function(a) {
        const b = a.kind;
        a = a.contents;
        if (b && b !== FLYOUT_TOOLBOX_KIND$$module$build$src$core$utils$toolbox && b !== CATEGORY_TOOLBOX_KIND$$module$build$src$core$utils$toolbox) throw Error("Invalid toolbox kind " + b + ". Please supply either " + FLYOUT_TOOLBOX_KIND$$module$build$src$core$utils$toolbox + " or " + CATEGORY_TOOLBOX_KIND$$module$build$src$core$utils$toolbox);
        if (!a) throw Error("Toolbox must have a contents attribute.");
    };
    convertFlyoutDefToJsonArray$$module$build$src$core$utils$toolbox = function(a) {
        return a ? a.contents ? a.contents : Array.isArray(a) && 0 < a.length && !a[0].nodeType ? a : xmlToJsonArray$$module$build$src$core$utils$toolbox(a) : [];
    };
    hasCategories$$module$build$src$core$utils$toolbox = function(a) {
        return TEST_ONLY$$module$build$src$core$utils$toolbox.hasCategoriesInternal(a);
    };
    hasCategoriesInternal$$module$build$src$core$utils$toolbox = function(a) {
        if (!a) return !1;
        const b = a.kind;
        return b ? b === CATEGORY_TOOLBOX_KIND$$module$build$src$core$utils$toolbox : !!a.contents.filter(function(c) {
            return "CATEGORY" === c.kind.toUpperCase();
        }).length;
    };
    isCategoryCollapsible$$module$build$src$core$utils$toolbox = function(a) {
        return a && a.contents ? !!a.contents.filter(function(b) {
            return "CATEGORY" === b.kind.toUpperCase();
        }).length : !1;
    };
    convertToToolboxJson$$module$build$src$core$utils$toolbox = function(a) {
        const b = {
            contents: xmlToJsonArray$$module$build$src$core$utils$toolbox(a)
        };
        a instanceof Node && addAttributes$$module$build$src$core$utils$toolbox(a, b);
        return b;
    };
    xmlToJsonArray$$module$build$src$core$utils$toolbox = function(a) {
        const b = [];
        let c = a.childNodes;
        c || (c = a);
        for(let d = 0, e; e = c[d]; d++){
            if (!e.tagName) continue;
            a = {};
            const f = e.tagName.toUpperCase();
            a.kind = f;
            "BLOCK" === f ? a.blockxml = e : e.childNodes && 0 < e.childNodes.length && (a.contents = xmlToJsonArray$$module$build$src$core$utils$toolbox(e));
            addAttributes$$module$build$src$core$utils$toolbox(e, a);
            b.push(a);
        }
        return b;
    };
    addAttributes$$module$build$src$core$utils$toolbox = function(a, b) {
        for(let c = 0; c < a.attributes.length; c++){
            const d = a.attributes[c];
            -1 < d.nodeName.indexOf("css-") ? (b.cssconfig = b.cssconfig || {}, b.cssconfig[d.nodeName.replace("css-", "")] = d.value) : b[d.nodeName] = d.value;
        }
    };
    parseToolboxTree$$module$build$src$core$utils$toolbox = function(a) {
        let b = null;
        if (a) {
            if ("string" === typeof a) {
                if (b = textToDom$$module$build$src$core$utils$xml(a), "xml" !== b.nodeName.toLowerCase()) throw TypeError("Toolbox should be an <xml> document.");
            } else a instanceof Element && (b = a);
        }
        return b;
    };
    $.register$$module$build$src$core$extensions = function(a, b) {
        if ("string" !== typeof a || "" === a.trim()) throw Error('Error: Invalid extension name "' + a + '"');
        if (allExtensions$$module$build$src$core$extensions[a]) throw Error('Error: Extension "' + a + '" is already registered.');
        if ("function" !== typeof b) throw Error('Error: Extension "' + a + '" must be a function');
        allExtensions$$module$build$src$core$extensions[a] = b;
    };
    registerMixin$$module$build$src$core$extensions = function(a, b) {
        if (!b || "object" !== typeof b) throw Error('Error: Mixin "' + a + '" must be a object');
        $.register$$module$build$src$core$extensions(a, function() {
            this.mixin(b);
        });
    };
    $.registerMutator$$module$build$src$core$extensions = function(a, b, c, d) {
        const e = 'Error when registering mutator "' + a + '": ';
        checkHasMutatorProperties$$module$build$src$core$extensions(e, b);
        const f = checkMutatorDialog$$module$build$src$core$extensions(b, e);
        if (c && "function" !== typeof c) throw Error(e + 'Extension "' + a + '" is not a function');
        $.register$$module$build$src$core$extensions(a, function() {
            f && this.setMutator(new $.Mutator$$module$build$src$core$mutator(d || [], this));
            this.mixin(b);
            c && c.apply(this);
        });
    };
    unregister$$module$build$src$core$extensions = function(a) {
        isRegistered$$module$build$src$core$extensions(a) ? delete allExtensions$$module$build$src$core$extensions[a] : console.warn('No extension mapping for name "' + a + '" found to unregister');
    };
    isRegistered$$module$build$src$core$extensions = function(a) {
        return !!allExtensions$$module$build$src$core$extensions[a];
    };
    apply$$module$build$src$core$extensions = function(a, b, c) {
        const d = allExtensions$$module$build$src$core$extensions[a];
        if ("function" !== typeof d) throw Error('Error: Extension "' + a + '" not found.');
        let e;
        c ? checkNoMutatorProperties$$module$build$src$core$extensions(a, b) : e = getMutatorProperties$$module$build$src$core$extensions(b);
        d.apply(b);
        if (c) checkHasMutatorProperties$$module$build$src$core$extensions('Error after applying mutator "' + a + '": ', b);
        else if (!mutatorPropertiesMatch$$module$build$src$core$extensions(e, b)) throw Error('Error when applying extension "' + a + '": mutation properties changed when applying a non-mutator extension.');
    };
    checkNoMutatorProperties$$module$build$src$core$extensions = function(a, b) {
        if (getMutatorProperties$$module$build$src$core$extensions(b).length) throw Error('Error: tried to apply mutation "' + a + '" to a block that already has mutator functions.  Block id: ' + b.id);
    };
    checkXmlHooks$$module$build$src$core$extensions = function(a, b) {
        return checkHasFunctionPair$$module$build$src$core$extensions(a.mutationToDom, a.domToMutation, b + " mutationToDom/domToMutation");
    };
    checkJsonHooks$$module$build$src$core$extensions = function(a, b) {
        return checkHasFunctionPair$$module$build$src$core$extensions(a.saveExtraState, a.loadExtraState, b + " saveExtraState/loadExtraState");
    };
    checkMutatorDialog$$module$build$src$core$extensions = function(a, b) {
        return checkHasFunctionPair$$module$build$src$core$extensions(a.compose, a.decompose, b + " compose/decompose");
    };
    checkHasFunctionPair$$module$build$src$core$extensions = function(a, b, c) {
        if (a && b) {
            if ("function" !== typeof a || "function" !== typeof b) throw Error(c + " must be a function");
            return !0;
        }
        if (!a && !b) return !1;
        throw Error(c + "Must have both or neither functions");
    };
    checkHasMutatorProperties$$module$build$src$core$extensions = function(a, b) {
        const c = checkXmlHooks$$module$build$src$core$extensions(b, a), d = checkJsonHooks$$module$build$src$core$extensions(b, a);
        if (!c && !d) throw Error(a + "Mutations must contain either XML hooks, or JSON hooks, or both");
        checkMutatorDialog$$module$build$src$core$extensions(b, a);
    };
    getMutatorProperties$$module$build$src$core$extensions = function(a) {
        const b = [];
        void 0 !== a.domToMutation && b.push(a.domToMutation);
        void 0 !== a.mutationToDom && b.push(a.mutationToDom);
        void 0 !== a.saveExtraState && b.push(a.saveExtraState);
        void 0 !== a.loadExtraState && b.push(a.loadExtraState);
        void 0 !== a.compose && b.push(a.compose);
        void 0 !== a.decompose && b.push(a.decompose);
        return b;
    };
    mutatorPropertiesMatch$$module$build$src$core$extensions = function(a, b) {
        b = getMutatorProperties$$module$build$src$core$extensions(b);
        if (b.length !== a.length) return !1;
        for(let c = 0; c < b.length; c++)if (a[c] !== b[c]) return !1;
        return !0;
    };
    runAfterPageLoad$$module$build$src$core$extensions = function(a) {
        if ("object" !== typeof document) throw Error("runAfterPageLoad() requires browser document.");
        if ("complete" === document.readyState) a();
        else {
            const b = setInterval(function() {
                "complete" === document.readyState && (clearInterval(b), a());
            }, 10);
        }
    };
    $.buildTooltipForDropdown$$module$build$src$core$extensions = function(a, b) {
        const c = [];
        "object" === typeof document && runAfterPageLoad$$module$build$src$core$extensions(function() {
            for(const d in b)checkMessageReferences$$module$build$src$core$utils$parsing(b[d]);
        });
        return function() {
            this.type && -1 === c.indexOf(this.type) && (checkDropdownOptionsInTable$$module$build$src$core$extensions(this, a, b), c.push(this.type));
            this.setTooltip((function() {
                var d = String(this.getFieldValue(a));
                let e = b[d];
                null === e ? -1 === c.indexOf(this.type) && (d = "No tooltip mapping for value " + d + " of field " + a, null !== this.type && (d += " of block type " + this.type), console.warn(d + ".")) : e = replaceMessageReferences$$module$build$src$core$utils$parsing(e);
                return e;
            }).bind(this));
        };
    };
    checkDropdownOptionsInTable$$module$build$src$core$extensions = function(a, b, c) {
        var d = a.getField(b);
        if (d instanceof FieldDropdown$$module$build$src$core$field_dropdown && !d.isOptionListDynamic()) {
            d = d.getOptions();
            for(let e = 0; e < d.length; e++){
                const f = d[e][1];
                null === c[f] && console.warn("No tooltip mapping for value " + f + " of field " + b + " of block type " + a.type);
            }
        }
    };
    $.buildTooltipWithFieldText$$module$build$src$core$extensions = function(a, b) {
        "object" === typeof document && runAfterPageLoad$$module$build$src$core$extensions(function() {
            checkMessageReferences$$module$build$src$core$utils$parsing(a);
        });
        return function() {
            this.setTooltip((function() {
                const c = this.getField(b);
                return replaceMessageReferences$$module$build$src$core$utils$parsing(a).replace("%1", c ? c.getText() : "");
            }).bind(this));
        };
    };
    extensionParentTooltip$$module$build$src$core$extensions = function() {
        const a = this.tooltip;
        this.setTooltip((function() {
            const b = this.getParent();
            return b && b.getInputsInline() && b.tooltip || a;
        }).bind(this));
    };
    removeElem$$module$build$src$core$utils$array = function(a, b) {
        b = a.indexOf(b);
        if (-1 === b) return !1;
        a.splice(b, 1);
        return !0;
    };
    disposeUiEffect$$module$build$src$core$block_animations = function(a) {
        if (!(100 < a.getDescendants(!1).length)) {
            var b = a.workspace, c = a.getSvgRoot();
            b.getAudioManager().play("delete");
            var d = b.getSvgXY(c);
            c = c.cloneNode(!0);
            c.setAttribute("transform", "translate(" + d.x + "," + d.y + ")");
            b.getParentSvg().appendChild(c);
            disposeUiStep$$module$build$src$core$block_animations(c, {
                x: d.x,
                y: d.y,
                width: a.width,
                height: a.height
            }, b.RTL, new Date, b.scale);
        }
    };
    disposeUiStep$$module$build$src$core$block_animations = function(a, b, c, d, e) {
        const f = ((new Date).getTime() - d.getTime()) / 150;
        1 < f ? removeNode$$module$build$src$core$utils$dom(a) : (a.setAttribute("transform", "translate(" + (b.x + (c ? -1 : 1) * b.width * e / 2 * f) + "," + (b.y + b.height * e * f) + ") scale(" + (1 - f) * e + ")"), setTimeout(disposeUiStep$$module$build$src$core$block_animations, 10, a, b, c, d, e));
    };
    connectionUiEffect$$module$build$src$core$block_animations = function(a) {
        const b = a.workspace, c = b.scale;
        b.getAudioManager().play("click");
        if (!(1 > c)) {
            var d = b.getSvgXY(a.getSvgRoot());
            a.outputConnection ? (d.x += (a.RTL ? 3 : -3) * c, d.y += 13 * c) : a.previousConnection && (d.x += (a.RTL ? -23 : 23) * c, d.y += 3 * c);
            a = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.CIRCLE, {
                cx: d.x,
                cy: d.y,
                r: 0,
                fill: "none",
                stroke: "#888",
                "stroke-width": 10
            }, b.getParentSvg());
            connectionUiStep$$module$build$src$core$block_animations(a, new Date, c);
        }
    };
    connectionUiStep$$module$build$src$core$block_animations = function(a, b, c) {
        const d = ((new Date).getTime() - b.getTime()) / 150;
        1 < d ? removeNode$$module$build$src$core$utils$dom(a) : (a.setAttribute("r", String(25 * d * c)), a.style.opacity = String(1 - d), disconnectPid$$module$build$src$core$block_animations = setTimeout(connectionUiStep$$module$build$src$core$block_animations, 10, a, b, c));
    };
    disconnectUiEffect$$module$build$src$core$block_animations = function(a) {
        disconnectUiStop$$module$build$src$core$block_animations();
        a.workspace.getAudioManager().play("disconnect");
        if (!(1 > a.workspace.scale)) {
            var b = a.getHeightWidth().height;
            b = Math.atan(10 / b) / Math.PI * 180;
            a.RTL || (b *= -1);
            wobblingBlock$$module$build$src$core$block_animations = a;
            disconnectUiStep$$module$build$src$core$block_animations(a, b, new Date);
        }
    };
    disconnectUiStep$$module$build$src$core$block_animations = function(a, b, c) {
        const d = ((new Date).getTime() - c.getTime()) / 200;
        let e = "";
        1 >= d && (e = `skewX(${Math.round(Math.sin(d * Math.PI * 3) * (1 - d) * b)})`, disconnectPid$$module$build$src$core$block_animations = setTimeout(disconnectUiStep$$module$build$src$core$block_animations, 10, a, b, c));
        a.getSvgRoot().setAttribute("transform", `${a.getTranslation()} ${e}`);
    };
    disconnectUiStop$$module$build$src$core$block_animations = function() {
        wobblingBlock$$module$build$src$core$block_animations && (disconnectPid$$module$build$src$core$block_animations && (clearTimeout(disconnectPid$$module$build$src$core$block_animations), disconnectPid$$module$build$src$core$block_animations = null), wobblingBlock$$module$build$src$core$block_animations.getSvgRoot().setAttribute("transform", wobblingBlock$$module$build$src$core$block_animations.getTranslation()), wobblingBlock$$module$build$src$core$block_animations = null);
    };
    bumpObjectIntoBounds$$module$build$src$core$bump_objects = function(a, b, c) {
        const d = c.getBoundingRectangle(), e = d.right - d.left, f = clamp$$module$build$src$core$utils$math(b.top, d.top, b.top + b.height - (d.bottom - d.top)) - d.top;
        let g = b.left;
        b = b.left + b.width - e;
        a.RTL ? g = Math.min(b, g) : b = Math.max(g, b);
        return (a = clamp$$module$build$src$core$utils$math(g, d.left, b) - d.left) || f ? (c.moveBy(a, f), !0) : !1;
    };
    bumpIntoBoundsHandler$$module$build$src$core$bump_objects = function(a) {
        return (b)=>{
            var c = a.getMetricsManager();
            if (c.hasFixedEdges() && !a.isDragging()) {
                var d;
                if (-1 !== BUMP_EVENTS$$module$build$src$core$events$utils.indexOf(null != (d = b.type) ? d : "")) {
                    d = c.getScrollMetrics(!0);
                    const e = extractObjectFromEvent$$module$build$src$core$bump_objects(a, b);
                    e && (c = getGroup$$module$build$src$core$events$utils() || !1, setGroup$$module$build$src$core$events$utils(b.group), bumpObjectIntoBounds$$module$build$src$core$bump_objects(a, d, e) && !b.group && console.warn("Moved object in bounds but there was no event group. This may break undo."), setGroup$$module$build$src$core$events$utils(c));
                } else b.type === VIEWPORT_CHANGE$$module$build$src$core$events$utils && b.scale && b.oldScale && b.scale > b.oldScale && bumpTopObjectsIntoBounds$$module$build$src$core$bump_objects(a);
            }
        };
    };
    extractObjectFromEvent$$module$build$src$core$bump_objects = function(a, b) {
        let c = null;
        switch(b.type){
            case CREATE$$module$build$src$core$events$utils:
            case MOVE$$module$build$src$core$events$utils:
                (c = a.getBlockById(b.blockId)) && (c = c.getRootBlock());
                break;
            case COMMENT_CREATE$$module$build$src$core$events$utils:
            case COMMENT_MOVE$$module$build$src$core$events$utils:
                c = a.getCommentById(b.commentId);
        }
        return c;
    };
    bumpTopObjectsIntoBounds$$module$build$src$core$bump_objects = function(a) {
        var b = a.getMetricsManager();
        if (b.hasFixedEdges() && !a.isDragging()) {
            b = b.getScrollMetrics(!0);
            var c = a.getTopBoundedElements();
            for(let d = 0, e; e = c[d]; d++)bumpObjectIntoBounds$$module$build$src$core$bump_objects(a, b, e);
        }
    };
    initIconData$$module$build$src$core$block_dragger = function(a) {
        const b = [];
        a = a.getDescendants(!1);
        for(let c = 0, d; d = a[c]; c++){
            const e = d.getIcons();
            for(let f = 0; f < e.length; f++){
                const g = {
                    location: e[f].getIconLocation(),
                    icon: e[f]
                };
                b.push(g);
            }
        }
        return b;
    };
    copy$$module$build$src$core$clipboard = function(a) {
        TEST_ONLY$$module$build$src$core$clipboard.copyInternal(a);
    };
    copyInternal$$module$build$src$core$clipboard = function(a) {
        copyData$$module$build$src$core$clipboard = a.toCopyData();
    };
    paste$$module$build$src$core$clipboard = function() {
        if (!copyData$$module$build$src$core$clipboard) return null;
        let a = copyData$$module$build$src$core$clipboard.source;
        a.isFlyout && (a = a.targetWorkspace);
        return copyData$$module$build$src$core$clipboard.typeCounts && a.isCapacityAvailable(copyData$$module$build$src$core$clipboard.typeCounts) ? a.paste(copyData$$module$build$src$core$clipboard.saveInfo) : null;
    };
    duplicate$$module$build$src$core$clipboard = function(a) {
        return TEST_ONLY$$module$build$src$core$clipboard.duplicateInternal(a);
    };
    duplicateInternal$$module$build$src$core$clipboard = function(a) {
        const b = copyData$$module$build$src$core$clipboard;
        copy$$module$build$src$core$clipboard(a);
        let c, d, e;
        a = null != (e = null == (c = a.toCopyData()) ? void 0 : null == (d = c.source) ? void 0 : d.paste(copyData$$module$build$src$core$clipboard.saveInfo)) ? e : null;
        copyData$$module$build$src$core$clipboard = b;
        return a;
    };
    getCurrentBlock$$module$build$src$core$contextmenu = function() {
        return currentBlock$$module$build$src$core$contextmenu;
    };
    setCurrentBlock$$module$build$src$core$contextmenu = function(a) {
        currentBlock$$module$build$src$core$contextmenu = a;
    };
    show$$module$build$src$core$contextmenu = function(a, b, c) {
        show$$module$build$src$core$widgetdiv(dummyOwner$$module$build$src$core$contextmenu, c, dispose$$module$build$src$core$contextmenu);
        if (b.length) {
            var d = populate_$$module$build$src$core$contextmenu(b, c);
            menu_$$module$build$src$core$contextmenu = d;
            position_$$module$build$src$core$contextmenu(d, a, c);
            setTimeout(function() {
                d.focus();
            }, 1);
            currentBlock$$module$build$src$core$contextmenu = null;
        } else hide$$module$build$src$core$contextmenu();
    };
    populate_$$module$build$src$core$contextmenu = function(a, b) {
        const c = new Menu$$module$build$src$core$menu;
        c.setRole(Role$$module$build$src$core$utils$aria.MENU);
        for(let d = 0; d < a.length; d++){
            const e = a[d], f = new MenuItem$$module$build$src$core$menuitem(e.text);
            f.setRightToLeft(b);
            f.setRole(Role$$module$build$src$core$utils$aria.MENUITEM);
            c.addChild(f);
            f.setEnabled(e.enabled);
            if (e.enabled) f.onAction(function() {
                hide$$module$build$src$core$contextmenu();
                requestAnimationFrame(()=>{
                    setTimeout(()=>{
                        e.callback(e.scope);
                    }, 0);
                });
            }, {});
        }
        return c;
    };
    position_$$module$build$src$core$contextmenu = function(a, b, c) {
        const d = getViewportBBox$$module$build$src$core$utils$svg_math();
        b = new Rect$$module$build$src$core$utils$rect(b.clientY + d.top, b.clientY + d.top, b.clientX + d.left, b.clientX + d.left);
        createWidget_$$module$build$src$core$contextmenu(a);
        const e = a.getSize();
        c && (b.left += e.width, b.right += e.width, d.left += e.width, d.right += e.width);
        positionWithAnchor$$module$build$src$core$widgetdiv(d, b, e, c);
        a.focus();
    };
    createWidget_$$module$build$src$core$contextmenu = function(a) {
        var b = getDiv$$module$build$src$core$widgetdiv();
        if (!b) throw Error("Attempting to create a context menu when widget div is null");
        b = a.render(b);
        addClass$$module$build$src$core$utils$dom(b, "blocklyContextMenu");
        conditionalBind$$module$build$src$core$browser_events(b, "contextmenu", null, haltPropagation$$module$build$src$core$contextmenu);
        a.focus();
    };
    haltPropagation$$module$build$src$core$contextmenu = function(a) {
        a.preventDefault();
        a.stopPropagation();
    };
    hide$$module$build$src$core$contextmenu = function() {
        hideIfOwner$$module$build$src$core$widgetdiv(dummyOwner$$module$build$src$core$contextmenu);
        currentBlock$$module$build$src$core$contextmenu = null;
    };
    dispose$$module$build$src$core$contextmenu = function() {
        menu_$$module$build$src$core$contextmenu && (menu_$$module$build$src$core$contextmenu.dispose(), menu_$$module$build$src$core$contextmenu = null);
    };
    callbackFactory$$module$build$src$core$contextmenu = function(a, b) {
        return ()=>{
            disable$$module$build$src$core$events$utils();
            let c;
            try {
                c = domToBlock$$module$build$src$core$xml(b, a.workspace);
                const d = a.getRelativeToSurfaceXY();
                d.x = a.RTL ? d.x - $.config$$module$build$src$core$config.snapRadius : d.x + $.config$$module$build$src$core$config.snapRadius;
                d.y += 2 * $.config$$module$build$src$core$config.snapRadius;
                c.moveBy(d.x, d.y);
            } finally{
                enable$$module$build$src$core$events$utils();
            }
            isEnabled$$module$build$src$core$events$utils() && !c.isShadow() && fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(CREATE$$module$build$src$core$events$utils))(c));
            c.select();
        };
    };
    commentDeleteOption$$module$build$src$core$contextmenu = function(a) {
        return {
            text: Msg$$module$build$src$core$msg.REMOVE_COMMENT,
            enabled: !0,
            callback: function() {
                setGroup$$module$build$src$core$events$utils(!0);
                a.dispose();
                setGroup$$module$build$src$core$events$utils(!1);
            }
        };
    };
    commentDuplicateOption$$module$build$src$core$contextmenu = function(a) {
        return {
            text: Msg$$module$build$src$core$msg.DUPLICATE_COMMENT,
            enabled: !0,
            callback: function() {
                duplicate$$module$build$src$core$clipboard(a);
            }
        };
    };
    workspaceCommentOption$$module$build$src$core$contextmenu = function(a, b) {
        const c = {
            enabled: !0
        };
        c.text = Msg$$module$build$src$core$msg.ADD_COMMENT;
        c.callback = function() {
            const d = new WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg(a, Msg$$module$build$src$core$msg.WORKSPACE_COMMENT_DEFAULT_TEXT, WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg.DEFAULT_SIZE, WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg.DEFAULT_SIZE);
            var e = a.getInjectionDiv().getBoundingClientRect();
            e = new Coordinate$$module$build$src$core$utils$coordinate(b.clientX - e.left, b.clientY - e.top);
            const f = a.getOriginOffsetInPixels();
            e = Coordinate$$module$build$src$core$utils$coordinate.difference(e, f);
            e.scale(1 / a.scale);
            d.moveBy(e.x, e.y);
            a.rendered && (d.initSvg(), d.render(), d.select());
        };
        return c;
    };
    getParentConnection$$module$build$src$core$keyboard_nav$ast_node = function(a) {
        let b = a.outputConnection;
        if (!b || a.previousConnection && a.previousConnection.isConnected()) b = a.previousConnection;
        return b;
    };
    point$$module$build$src$core$utils$svg_paths = function(a, b) {
        return " " + a + "," + b + " ";
    };
    curve$$module$build$src$core$utils$svg_paths = function(a, b) {
        return " " + a + b.join("");
    };
    moveTo$$module$build$src$core$utils$svg_paths = function(a, b) {
        return " M " + a + "," + b + " ";
    };
    moveBy$$module$build$src$core$utils$svg_paths = function(a, b) {
        return " m " + a + "," + b + " ";
    };
    lineTo$$module$build$src$core$utils$svg_paths = function(a, b) {
        return " l " + a + "," + b + " ";
    };
    line$$module$build$src$core$utils$svg_paths = function(a) {
        return " l" + a.join("");
    };
    lineOnAxis$$module$build$src$core$utils$svg_paths = function(a, b) {
        return " " + a + " " + b + " ";
    };
    arc$$module$build$src$core$utils$svg_paths = function(a, b, c, d) {
        return a + " " + c + " " + c + " " + b + d;
    };
    queueRender$$module$build$src$core$render_management = function(a) {
        queueBlock$$module$build$src$core$render_management(a);
        pid$$module$build$src$core$render_management || (pid$$module$build$src$core$render_management = window.requestAnimationFrame(doRenders$$module$build$src$core$render_management));
    };
    queueBlock$$module$build$src$core$render_management = function(a) {
        dirtyBlocks$$module$build$src$core$render_management.add(a);
        const b = a.getParent();
        b ? queueBlock$$module$build$src$core$render_management(b) : rootBlocks$$module$build$src$core$render_management.add(a);
    };
    doRenders$$module$build$src$core$render_management = function() {
        const a = new Set([
            ...rootBlocks$$module$build$src$core$render_management
        ].map((b)=>b.workspace));
        for (const b of rootBlocks$$module$build$src$core$render_management)b.isDisposed() || b.getParent() || (renderBlock$$module$build$src$core$render_management(b), updateConnectionLocations$$module$build$src$core$render_management(b, b.getRelativeToSurfaceXY()), updateIconLocations$$module$build$src$core$render_management(b));
        for (const b of a)b.resizeContents();
        rootBlocks$$module$build$src$core$render_management.clear();
        dirtyBlocks$$module$build$src$core$render_management = new Set;
        pid$$module$build$src$core$render_management = 0;
    };
    renderBlock$$module$build$src$core$render_management = function(a) {
        if (dirtyBlocks$$module$build$src$core$render_management.has(a)) {
            for (const b of a.getChildren(!1))renderBlock$$module$build$src$core$render_management(b);
            a.renderEfficiently();
        }
    };
    updateConnectionLocations$$module$build$src$core$render_management = function(a, b) {
        for (const c of a.getConnections_(!1)){
            a = c.moveToOffset(b);
            const d = c.targetBlock();
            c.isSuperior() && d && (a || dirtyBlocks$$module$build$src$core$render_management.has(d)) && updateConnectionLocations$$module$build$src$core$render_management(d, Coordinate$$module$build$src$core$utils$coordinate.sum(b, d.relativeCoords));
        }
    };
    updateIconLocations$$module$build$src$core$render_management = function(a) {
        if (a.getIcons) {
            for (const b of a.getIcons())b.computeIconLocation();
            for (const b of a.getChildren(!1))updateIconLocations$$module$build$src$core$render_management(b);
        }
    };
    registerUndo$$module$build$src$core$contextmenu_items = function() {
        ContextMenuRegistry$$module$build$src$core$contextmenu_registry.registry.register({
            displayText () {
                return Msg$$module$build$src$core$msg.UNDO;
            },
            preconditionFn (a) {
                return 0 < a.workspace.getUndoStack().length ? "enabled" : "disabled";
            },
            callback (a) {
                a.workspace.undo(!1);
            },
            scopeType: ContextMenuRegistry$$module$build$src$core$contextmenu_registry.ScopeType.WORKSPACE,
            id: "undoWorkspace",
            weight: 1
        });
    };
    registerRedo$$module$build$src$core$contextmenu_items = function() {
        ContextMenuRegistry$$module$build$src$core$contextmenu_registry.registry.register({
            displayText () {
                return Msg$$module$build$src$core$msg.REDO;
            },
            preconditionFn (a) {
                return 0 < a.workspace.getRedoStack().length ? "enabled" : "disabled";
            },
            callback (a) {
                a.workspace.undo(!0);
            },
            scopeType: ContextMenuRegistry$$module$build$src$core$contextmenu_registry.ScopeType.WORKSPACE,
            id: "redoWorkspace",
            weight: 2
        });
    };
    registerCleanup$$module$build$src$core$contextmenu_items = function() {
        ContextMenuRegistry$$module$build$src$core$contextmenu_registry.registry.register({
            displayText () {
                return Msg$$module$build$src$core$msg.CLEAN_UP;
            },
            preconditionFn (a) {
                return a.workspace.isMovable() ? 1 < a.workspace.getTopBlocks(!1).length ? "enabled" : "disabled" : "hidden";
            },
            callback (a) {
                a.workspace.cleanUp();
            },
            scopeType: ContextMenuRegistry$$module$build$src$core$contextmenu_registry.ScopeType.WORKSPACE,
            id: "cleanWorkspace",
            weight: 3
        });
    };
    toggleOption_$$module$build$src$core$contextmenu_items = function(a, b) {
        function c(f) {
            e--;
            f.setCollapsed(a);
            0 === e && setGroup$$module$build$src$core$events$utils(!1);
        }
        let d = 0, e = 0;
        setGroup$$module$build$src$core$events$utils(!0);
        for(let f = 0; f < b.length; f++){
            let g = b[f];
            for(; g;)e++, setTimeout(c.bind(null, g), d), g = g.getNextBlock(), d += 10;
        }
    };
    registerCollapse$$module$build$src$core$contextmenu_items = function() {
        ContextMenuRegistry$$module$build$src$core$contextmenu_registry.registry.register({
            displayText () {
                return Msg$$module$build$src$core$msg.COLLAPSE_ALL;
            },
            preconditionFn (a) {
                if (a.workspace.options.collapse) {
                    a = a.workspace.getTopBlocks(!1);
                    for(let b = 0; b < a.length; b++){
                        let c = a[b];
                        for(; c;){
                            if (!c.isCollapsed()) return "enabled";
                            c = c.getNextBlock();
                        }
                    }
                    return "disabled";
                }
                return "hidden";
            },
            callback (a) {
                toggleOption_$$module$build$src$core$contextmenu_items(!0, a.workspace.getTopBlocks(!0));
            },
            scopeType: ContextMenuRegistry$$module$build$src$core$contextmenu_registry.ScopeType.WORKSPACE,
            id: "collapseWorkspace",
            weight: 4
        });
    };
    registerExpand$$module$build$src$core$contextmenu_items = function() {
        ContextMenuRegistry$$module$build$src$core$contextmenu_registry.registry.register({
            displayText () {
                return Msg$$module$build$src$core$msg.EXPAND_ALL;
            },
            preconditionFn (a) {
                if (a.workspace.options.collapse) {
                    a = a.workspace.getTopBlocks(!1);
                    for(let b = 0; b < a.length; b++){
                        let c = a[b];
                        for(; c;){
                            if (c.isCollapsed()) return "enabled";
                            c = c.getNextBlock();
                        }
                    }
                    return "disabled";
                }
                return "hidden";
            },
            callback (a) {
                toggleOption_$$module$build$src$core$contextmenu_items(!1, a.workspace.getTopBlocks(!0));
            },
            scopeType: ContextMenuRegistry$$module$build$src$core$contextmenu_registry.ScopeType.WORKSPACE,
            id: "expandWorkspace",
            weight: 5
        });
    };
    addDeletableBlocks_$$module$build$src$core$contextmenu_items = function(a, b) {
        if (a.isDeletable()) Array.prototype.push.apply(b, a.getDescendants(!1));
        else {
            a = a.getChildren(!1);
            for(let c = 0; c < a.length; c++)addDeletableBlocks_$$module$build$src$core$contextmenu_items(a[c], b);
        }
    };
    getDeletableBlocks_$$module$build$src$core$contextmenu_items = function(a) {
        const b = [];
        a = a.getTopBlocks(!0);
        for(let c = 0; c < a.length; c++)addDeletableBlocks_$$module$build$src$core$contextmenu_items(a[c], b);
        return b;
    };
    deleteNext_$$module$build$src$core$contextmenu_items = function(a, b) {
        b ? setGroup$$module$build$src$core$events$utils(b) : (setGroup$$module$build$src$core$events$utils(!0), b = getGroup$$module$build$src$core$events$utils());
        const c = a.shift();
        c && (c.isDeadOrDying() ? deleteNext_$$module$build$src$core$contextmenu_items(a, b) : (c.dispose(!1, !0), setTimeout(deleteNext_$$module$build$src$core$contextmenu_items, 10, a, b)));
        setGroup$$module$build$src$core$events$utils(!1);
    };
    registerDeleteAll$$module$build$src$core$contextmenu_items = function() {
        ContextMenuRegistry$$module$build$src$core$contextmenu_registry.registry.register({
            displayText (a) {
                if (!a.workspace) return "";
                a = getDeletableBlocks_$$module$build$src$core$contextmenu_items(a.workspace).length;
                return 1 === a ? Msg$$module$build$src$core$msg.DELETE_BLOCK : Msg$$module$build$src$core$msg.DELETE_X_BLOCKS.replace("%1", `${a}`);
            },
            preconditionFn (a) {
                return a.workspace ? 0 < getDeletableBlocks_$$module$build$src$core$contextmenu_items(a.workspace).length ? "enabled" : "disabled" : "disabled";
            },
            callback (a) {
                if (a.workspace) {
                    a.workspace.cancelCurrentGesture();
                    var b = getDeletableBlocks_$$module$build$src$core$contextmenu_items(a.workspace);
                    2 > b.length ? deleteNext_$$module$build$src$core$contextmenu_items(b) : confirm$$module$build$src$core$dialog(Msg$$module$build$src$core$msg.DELETE_ALL_BLOCKS.replace("%1", String(b.length)), function(c) {
                        c && deleteNext_$$module$build$src$core$contextmenu_items(b);
                    });
                }
            },
            scopeType: ContextMenuRegistry$$module$build$src$core$contextmenu_registry.ScopeType.WORKSPACE,
            id: "workspaceDelete",
            weight: 6
        });
    };
    registerWorkspaceOptions_$$module$build$src$core$contextmenu_items = function() {
        registerUndo$$module$build$src$core$contextmenu_items();
        registerRedo$$module$build$src$core$contextmenu_items();
        registerCleanup$$module$build$src$core$contextmenu_items();
        registerCollapse$$module$build$src$core$contextmenu_items();
        registerExpand$$module$build$src$core$contextmenu_items();
        registerDeleteAll$$module$build$src$core$contextmenu_items();
    };
    registerDuplicate$$module$build$src$core$contextmenu_items = function() {
        ContextMenuRegistry$$module$build$src$core$contextmenu_registry.registry.register({
            displayText () {
                return Msg$$module$build$src$core$msg.DUPLICATE_BLOCK;
            },
            preconditionFn (a) {
                a = a.block;
                return !a.isInFlyout && a.isDeletable() && a.isMovable() ? a.isDuplicatable() ? "enabled" : "disabled" : "hidden";
            },
            callback (a) {
                a.block && duplicate$$module$build$src$core$clipboard(a.block);
            },
            scopeType: ContextMenuRegistry$$module$build$src$core$contextmenu_registry.ScopeType.BLOCK,
            id: "blockDuplicate",
            weight: 1
        });
    };
    registerComment$$module$build$src$core$contextmenu_items = function() {
        ContextMenuRegistry$$module$build$src$core$contextmenu_registry.registry.register({
            displayText (a) {
                return a.block.getCommentIcon() ? Msg$$module$build$src$core$msg.REMOVE_COMMENT : Msg$$module$build$src$core$msg.ADD_COMMENT;
            },
            preconditionFn (a) {
                a = a.block;
                return !a.isInFlyout && a.workspace.options.comments && !a.isCollapsed() && a.isEditable() ? "enabled" : "hidden";
            },
            callback (a) {
                a = a.block;
                a.getCommentIcon() ? a.setCommentText(null) : a.setCommentText("");
            },
            scopeType: ContextMenuRegistry$$module$build$src$core$contextmenu_registry.ScopeType.BLOCK,
            id: "blockComment",
            weight: 2
        });
    };
    registerInline$$module$build$src$core$contextmenu_items = function() {
        ContextMenuRegistry$$module$build$src$core$contextmenu_registry.registry.register({
            displayText (a) {
                return a.block.getInputsInline() ? Msg$$module$build$src$core$msg.EXTERNAL_INPUTS : Msg$$module$build$src$core$msg.INLINE_INPUTS;
            },
            preconditionFn (a) {
                a = a.block;
                if (!a.isInFlyout && a.isMovable() && !a.isCollapsed()) {
                    for(let b = 1; b < a.inputList.length; b++)if (a.inputList[b - 1].type !== inputTypes$$module$build$src$core$input_types.STATEMENT && a.inputList[b].type !== inputTypes$$module$build$src$core$input_types.STATEMENT) return "enabled";
                }
                return "hidden";
            },
            callback (a) {
                a.block.setInputsInline(!a.block.getInputsInline());
            },
            scopeType: ContextMenuRegistry$$module$build$src$core$contextmenu_registry.ScopeType.BLOCK,
            id: "blockInline",
            weight: 3
        });
    };
    registerCollapseExpandBlock$$module$build$src$core$contextmenu_items = function() {
        ContextMenuRegistry$$module$build$src$core$contextmenu_registry.registry.register({
            displayText (a) {
                return a.block.isCollapsed() ? Msg$$module$build$src$core$msg.EXPAND_BLOCK : Msg$$module$build$src$core$msg.COLLAPSE_BLOCK;
            },
            preconditionFn (a) {
                a = a.block;
                return !a.isInFlyout && a.isMovable() && a.workspace.options.collapse ? "enabled" : "hidden";
            },
            callback (a) {
                a.block.setCollapsed(!a.block.isCollapsed());
            },
            scopeType: ContextMenuRegistry$$module$build$src$core$contextmenu_registry.ScopeType.BLOCK,
            id: "blockCollapseExpand",
            weight: 4
        });
    };
    registerDisable$$module$build$src$core$contextmenu_items = function() {
        ContextMenuRegistry$$module$build$src$core$contextmenu_registry.registry.register({
            displayText (a) {
                return a.block.isEnabled() ? Msg$$module$build$src$core$msg.DISABLE_BLOCK : Msg$$module$build$src$core$msg.ENABLE_BLOCK;
            },
            preconditionFn (a) {
                a = a.block;
                return !a.isInFlyout && a.workspace.options.disable && a.isEditable() ? a.getInheritedDisabled() ? "disabled" : "enabled" : "hidden";
            },
            callback (a) {
                a = a.block;
                const b = getGroup$$module$build$src$core$events$utils();
                b || setGroup$$module$build$src$core$events$utils(!0);
                a.setEnabled(!a.isEnabled());
                setGroup$$module$build$src$core$events$utils(b);
            },
            scopeType: ContextMenuRegistry$$module$build$src$core$contextmenu_registry.ScopeType.BLOCK,
            id: "blockDisable",
            weight: 5
        });
    };
    registerDelete$$module$build$src$core$contextmenu_items = function() {
        ContextMenuRegistry$$module$build$src$core$contextmenu_registry.registry.register({
            displayText (a) {
                var b = a.block;
                a = b.getDescendants(!1).length;
                (b = b.getNextBlock()) && (a -= b.getDescendants(!1).length);
                return 1 === a ? Msg$$module$build$src$core$msg.DELETE_BLOCK : Msg$$module$build$src$core$msg.DELETE_X_BLOCKS.replace("%1", `${a}`);
            },
            preconditionFn (a) {
                return !a.block.isInFlyout && a.block.isDeletable() ? "enabled" : "hidden";
            },
            callback (a) {
                a.block && a.block.checkAndDelete();
            },
            scopeType: ContextMenuRegistry$$module$build$src$core$contextmenu_registry.ScopeType.BLOCK,
            id: "blockDelete",
            weight: 6
        });
    };
    registerHelp$$module$build$src$core$contextmenu_items = function() {
        ContextMenuRegistry$$module$build$src$core$contextmenu_registry.registry.register({
            displayText () {
                return Msg$$module$build$src$core$msg.HELP;
            },
            preconditionFn (a) {
                a = a.block;
                return ("function" === typeof a.helpUrl ? a.helpUrl() : a.helpUrl) ? "enabled" : "hidden";
            },
            callback (a) {
                a.block.showHelp();
            },
            scopeType: ContextMenuRegistry$$module$build$src$core$contextmenu_registry.ScopeType.BLOCK,
            id: "blockHelp",
            weight: 7
        });
    };
    registerBlockOptions_$$module$build$src$core$contextmenu_items = function() {
        registerDuplicate$$module$build$src$core$contextmenu_items();
        registerComment$$module$build$src$core$contextmenu_items();
        registerInline$$module$build$src$core$contextmenu_items();
        registerCollapseExpandBlock$$module$build$src$core$contextmenu_items();
        registerDisable$$module$build$src$core$contextmenu_items();
        registerDelete$$module$build$src$core$contextmenu_items();
        registerHelp$$module$build$src$core$contextmenu_items();
    };
    registerDefaultOptions$$module$build$src$core$contextmenu_items = function() {
        registerWorkspaceOptions_$$module$build$src$core$contextmenu_items();
        registerBlockOptions_$$module$build$src$core$contextmenu_items();
    };
    isProcedureBlock$$module$build$src$core$interfaces$i_procedure_block = function(a) {
        return void 0 !== a.getProcedureModel && void 0 !== a.doProcedureUpdate && void 0 !== a.isProcedureDef;
    };
    isObservable$$module$build$src$core$interfaces$i_observable = function(a) {
        return void 0 !== a.startPublishing && void 0 !== a.stopPublishing;
    };
    allProcedures$$module$build$src$core$procedures = function(a) {
        const b = a.getProcedureMap().getProcedures().filter((d)=>!d.getReturnTypes()).map((d)=>[
                d.getName(),
                d.getParameters().map((e)=>e.getName()),
                !1
            ]);
        a.getBlocksByType("procedures_defnoreturn", !1).forEach((d)=>{
            !isProcedureBlock$$module$build$src$core$interfaces$i_procedure_block(d) && isLegacyProcedureDefBlock$$module$build$src$core$interfaces$i_legacy_procedure_blocks(d) && b.push(d.getProcedureDef());
        });
        const c = a.getProcedureMap().getProcedures().filter((d)=>!!d.getReturnTypes()).map((d)=>[
                d.getName(),
                d.getParameters().map((e)=>e.getName()),
                !0
            ]);
        a.getBlocksByType("procedures_defreturn", !1).forEach((d)=>{
            !isProcedureBlock$$module$build$src$core$interfaces$i_procedure_block(d) && isLegacyProcedureDefBlock$$module$build$src$core$interfaces$i_legacy_procedure_blocks(d) && c.push(d.getProcedureDef());
        });
        b.sort(procTupleComparator$$module$build$src$core$procedures);
        c.sort(procTupleComparator$$module$build$src$core$procedures);
        return [
            b,
            c
        ];
    };
    procTupleComparator$$module$build$src$core$procedures = function(a, b) {
        return a[0].localeCompare(b[0], void 0, {
            sensitivity: "base"
        });
    };
    findLegalName$$module$build$src$core$procedures = function(a, b) {
        if (b.isInFlyout) return a;
        for(a = a || Msg$$module$build$src$core$msg.UNNAMED_KEY || "unnamed"; !isLegalName$$module$build$src$core$procedures(a, b.workspace, b);){
            const c = a.match(/^(.*?)(\d+)$/);
            a = c ? c[1] + (parseInt(c[2]) + 1) : a + "2";
        }
        return a;
    };
    isLegalName$$module$build$src$core$procedures = function(a, b, c) {
        return !isNameUsed$$module$build$src$core$procedures(a, b, c);
    };
    isNameUsed$$module$build$src$core$procedures = function(a, b, c) {
        for (const d of b.getAllBlocks(!1))if (d !== c && isLegacyProcedureDefBlock$$module$build$src$core$interfaces$i_legacy_procedure_blocks(d) && Names$$module$build$src$core$names.equals(d.getProcedureDef()[0], a)) return !0;
        c = c && isProcedureBlock$$module$build$src$core$interfaces$i_procedure_block(c) ? null == c ? void 0 : c.getProcedureModel() : void 0;
        for (const d of b.getProcedureMap().getProcedures())if (d !== c && Names$$module$build$src$core$names.equals(d.getName(), a)) return !0;
        return !1;
    };
    rename$$module$build$src$core$procedures = function(a) {
        var b = this.getSourceBlock();
        if (!b) throw new UnattachedFieldError$$module$build$src$core$field;
        a = a.trim();
        const c = findLegalName$$module$build$src$core$procedures(a, b);
        isProcedureBlock$$module$build$src$core$interfaces$i_procedure_block(b) && !b.isInsertionMarker() && b.getProcedureModel().setName(c);
        const d = this.getValue();
        if (d !== a && d !== c) for(a = b.workspace.getAllBlocks(!1), b = 0; b < a.length; b++){
            const e = a[b];
            e.renameProcedure && e.renameProcedure(d, c);
        }
        return c;
    };
    flyoutCategory$$module$build$src$core$procedures = function(a) {
        function b(f, g) {
            for(let k = 0; k < f.length; k++){
                var h = f[k][0];
                const l = f[k][1], m = $.createElement$$module$build$src$core$utils$xml("block");
                m.setAttribute("type", g);
                m.setAttribute("gap", "16");
                const n = $.createElement$$module$build$src$core$utils$xml("mutation");
                n.setAttribute("name", h);
                m.appendChild(n);
                for(h = 0; h < l.length; h++){
                    const p = $.createElement$$module$build$src$core$utils$xml("arg");
                    p.setAttribute("name", l[h]);
                    n.appendChild(p);
                }
                c.push(m);
            }
        }
        const c = [];
        if (Blocks$$module$build$src$core$blocks.procedures_defnoreturn) {
            var d = $.createElement$$module$build$src$core$utils$xml("block");
            d.setAttribute("type", "procedures_defnoreturn");
            d.setAttribute("gap", "16");
            var e = $.createElement$$module$build$src$core$utils$xml("field");
            e.setAttribute("name", "NAME");
            e.appendChild(createTextNode$$module$build$src$core$utils$xml(Msg$$module$build$src$core$msg.PROCEDURES_DEFNORETURN_PROCEDURE));
            d.appendChild(e);
            c.push(d);
        }
        Blocks$$module$build$src$core$blocks.procedures_defreturn && (d = $.createElement$$module$build$src$core$utils$xml("block"), d.setAttribute("type", "procedures_defreturn"), d.setAttribute("gap", "16"), e = $.createElement$$module$build$src$core$utils$xml("field"), e.setAttribute("name", "NAME"), e.appendChild(createTextNode$$module$build$src$core$utils$xml(Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_PROCEDURE)), d.appendChild(e), c.push(d));
        Blocks$$module$build$src$core$blocks.procedures_ifreturn && (d = $.createElement$$module$build$src$core$utils$xml("block"), d.setAttribute("type", "procedures_ifreturn"), d.setAttribute("gap", "16"), c.push(d));
        c.length && c[c.length - 1].setAttribute("gap", "24");
        a = allProcedures$$module$build$src$core$procedures(a);
        b(a[0], "procedures_callnoreturn");
        b(a[1], "procedures_callreturn");
        return c;
    };
    updateMutatorFlyout$$module$build$src$core$procedures = function(a) {
        var b = [], c = a.getBlocksByType("procedures_mutatorarg", !1);
        for(let f = 0, g; g = c[f]; f++)b.push(g.getFieldValue("NAME"));
        c = $.createElement$$module$build$src$core$utils$xml("xml");
        const d = $.createElement$$module$build$src$core$utils$xml("block");
        d.setAttribute("type", "procedures_mutatorarg");
        const e = $.createElement$$module$build$src$core$utils$xml("field");
        e.setAttribute("name", "NAME");
        b = generateUniqueNameFromOptions$$module$build$src$core$variables(DEFAULT_ARG$$module$build$src$core$procedures, b);
        b = createTextNode$$module$build$src$core$utils$xml(b);
        e.appendChild(b);
        d.appendChild(e);
        c.appendChild(d);
        a.updateToolbox(c);
    };
    mutatorOpenListener$$module$build$src$core$procedures = function(a) {
        if (a.type === BUBBLE_OPEN$$module$build$src$core$events$utils && "mutator" === a.bubbleType && a.isOpen && a.blockId) {
            a = getWorkspaceById$$module$build$src$core$common(a.workspaceId).getBlockById(a.blockId);
            var b = a.type;
            if ("procedures_defnoreturn" === b || "procedures_defreturn" === b) a = a.mutator.getWorkspace(), updateMutatorFlyout$$module$build$src$core$procedures(a), a.addChangeListener(mutatorChangeListener$$module$build$src$core$procedures);
        }
    };
    mutatorChangeListener$$module$build$src$core$procedures = function(a) {
        if (a.type === CREATE$$module$build$src$core$events$utils || a.type === DELETE$$module$build$src$core$events$utils || a.type === CHANGE$$module$build$src$core$events$utils) a = getWorkspaceById$$module$build$src$core$common(a.workspaceId), updateMutatorFlyout$$module$build$src$core$procedures(a);
    };
    getCallers$$module$build$src$core$procedures = function(a, b) {
        return b.getAllBlocks(!1).filter((c)=>blockIsModernCallerFor$$module$build$src$core$procedures(c, a) || isLegacyProcedureCallBlock$$module$build$src$core$interfaces$i_legacy_procedure_blocks(c) && Names$$module$build$src$core$names.equals(c.getProcedureCall(), a));
    };
    blockIsModernCallerFor$$module$build$src$core$procedures = function(a, b) {
        return isProcedureBlock$$module$build$src$core$interfaces$i_procedure_block(a) && !a.isProcedureDef() && a.getProcedureModel() && Names$$module$build$src$core$names.equals(a.getProcedureModel().getName(), b);
    };
    mutateCallers$$module$build$src$core$procedures = function(a) {
        const b = getRecordUndo$$module$build$src$core$events$utils();
        var c = a.getProcedureDef()[0];
        const d = a.mutationToDom(!0);
        a = getCallers$$module$build$src$core$procedures(c, a.workspace);
        for(let f = 0, g; g = a[f]; f++){
            c = (c = g.mutationToDom()) && domToText$$module$build$src$core$utils$xml(c);
            g.domToMutation && g.domToMutation(d);
            var e = g.mutationToDom();
            e = e && domToText$$module$build$src$core$utils$xml(e);
            c !== e && (setRecordUndo$$module$build$src$core$events$utils(!1), fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(CHANGE$$module$build$src$core$events$utils))(g, "mutation", null, c, e)), setRecordUndo$$module$build$src$core$events$utils(b));
        }
    };
    getDefinition$$module$build$src$core$procedures = function(a, b) {
        for (const c of b.getAllBlocks(!1))if (isProcedureBlock$$module$build$src$core$interfaces$i_procedure_block(c) && c.isProcedureDef() && Names$$module$build$src$core$names.equals(c.getProcedureModel().getName(), a) || isLegacyProcedureDefBlock$$module$build$src$core$interfaces$i_legacy_procedure_blocks(c) && Names$$module$build$src$core$names.equals(c.getProcedureDef()[0], a)) return c;
        return null;
    };
    isDynamicShape$$module$build$src$core$renderers$common$constants = function(a) {
        return a.isDynamic;
    };
    isDebuggerEnabled$$module$build$src$core$renderers$common$debug = function() {
        return useDebugger$$module$build$src$core$renderers$common$debug;
    };
    startDebugger$$module$build$src$core$renderers$common$debug = function() {
        warn$$module$build$src$core$utils$deprecation("Blockly.blockRendering.debug.startDebugger()", "version 8", "version 10", "the debug renderer in @blockly/dev-tools (See https://www.npmjs.com/package/@blockly/dev-tools.)");
        useDebugger$$module$build$src$core$renderers$common$debug = !0;
    };
    stopDebugger$$module$build$src$core$renderers$common$debug = function() {
        warn$$module$build$src$core$utils$deprecation("Blockly.blockRendering.debug.stopDebugger()", "version 8", "version 10", "the debug renderer in @blockly/dev-tools (See https://www.npmjs.com/package/@blockly/dev-tools.)");
        useDebugger$$module$build$src$core$renderers$common$debug = !1;
    };
    register$$module$build$src$core$renderers$common$block_rendering = function(a, b) {
        register$$module$build$src$core$registry(Type$$module$build$src$core$registry.RENDERER, a, b);
    };
    unregister$$module$build$src$core$renderers$common$block_rendering = function(a) {
        unregister$$module$build$src$core$registry(Type$$module$build$src$core$registry.RENDERER, a);
    };
    stopDebugger$$module$build$src$core$renderers$common$block_rendering = function() {
        warn$$module$build$src$core$utils$deprecation("Blockly.blockRendering.stopDebugger()", "September 2021", "September 2022", "the debug renderer in @blockly/dev-tools (See https://www.npmjs.com/package/@blockly/dev-tools.)");
        stopDebugger$$module$build$src$core$renderers$common$debug();
    };
    init$$module$build$src$core$renderers$common$block_rendering = function(a, b, c) {
        a = new (getClass$$module$build$src$core$registry(Type$$module$build$src$core$registry.RENDERER, a))(a);
        a.init(b, c);
        return a;
    };
    stringButtonClickHandler$$module$build$src$core$variables_dynamic = function(a) {
        createVariableButtonHandler$$module$build$src$core$variables(a.getTargetWorkspace(), void 0, "String");
    };
    numberButtonClickHandler$$module$build$src$core$variables_dynamic = function(a) {
        createVariableButtonHandler$$module$build$src$core$variables(a.getTargetWorkspace(), void 0, "Number");
    };
    colourButtonClickHandler$$module$build$src$core$variables_dynamic = function(a) {
        createVariableButtonHandler$$module$build$src$core$variables(a.getTargetWorkspace(), void 0, "Colour");
    };
    flyoutCategory$$module$build$src$core$variables_dynamic = function(a) {
        let b = [], c = document.createElement("button");
        c.setAttribute("text", Msg$$module$build$src$core$msg.NEW_STRING_VARIABLE);
        c.setAttribute("callbackKey", "CREATE_VARIABLE_STRING");
        b.push(c);
        c = document.createElement("button");
        c.setAttribute("text", Msg$$module$build$src$core$msg.NEW_NUMBER_VARIABLE);
        c.setAttribute("callbackKey", "CREATE_VARIABLE_NUMBER");
        b.push(c);
        c = document.createElement("button");
        c.setAttribute("text", Msg$$module$build$src$core$msg.NEW_COLOUR_VARIABLE);
        c.setAttribute("callbackKey", "CREATE_VARIABLE_COLOUR");
        b.push(c);
        a.registerButtonCallback("CREATE_VARIABLE_STRING", stringButtonClickHandler$$module$build$src$core$variables_dynamic);
        a.registerButtonCallback("CREATE_VARIABLE_NUMBER", numberButtonClickHandler$$module$build$src$core$variables_dynamic);
        a.registerButtonCallback("CREATE_VARIABLE_COLOUR", colourButtonClickHandler$$module$build$src$core$variables_dynamic);
        a = flyoutCategoryBlocks$$module$build$src$core$variables_dynamic(a);
        return b = b.concat(a);
    };
    flyoutCategoryBlocks$$module$build$src$core$variables_dynamic = function(a) {
        a = a.getAllVariables();
        const b = [];
        if (0 < a.length) {
            if (Blocks$$module$build$src$core$blocks.variables_set_dynamic) {
                var c = a[a.length - 1];
                const d = $.createElement$$module$build$src$core$utils$xml("block");
                d.setAttribute("type", "variables_set_dynamic");
                d.setAttribute("gap", "24");
                d.appendChild(generateVariableFieldDom$$module$build$src$core$variables(c));
                b.push(d);
            }
            if (Blocks$$module$build$src$core$blocks.variables_get_dynamic) {
                a.sort(VariableModel$$module$build$src$core$variable_model.compareByName);
                for(let d = 0, e; e = a[d]; d++)c = $.createElement$$module$build$src$core$utils$xml("block"), c.setAttribute("type", "variables_get_dynamic"), c.setAttribute("gap", "8"), c.appendChild(generateVariableFieldDom$$module$build$src$core$variables(e)), b.push(c);
            }
        }
        return b;
    };
    getStartPositionRect$$module$build$src$core$positionable_helpers = function(a, b, c, d, e, f) {
        const g = f.scrollbar && f.scrollbar.canScrollVertically();
        a.horizontal === horizontalPosition$$module$build$src$core$positionable_helpers.LEFT ? (c = e.absoluteMetrics.left + c, g && f.RTL && (c += Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness)) : (c = e.absoluteMetrics.left + e.viewMetrics.width - b.width - c, g && !f.RTL && (c -= Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness));
        a.vertical === verticalPosition$$module$build$src$core$positionable_helpers.TOP ? a = e.absoluteMetrics.top + d : (a = e.absoluteMetrics.top + e.viewMetrics.height - b.height - d, f.scrollbar && f.scrollbar.canScrollHorizontally() && (a -= Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness));
        return new Rect$$module$build$src$core$utils$rect(a, a + b.height, c, c + b.width);
    };
    getCornerOppositeToolbox$$module$build$src$core$positionable_helpers = function(a, b) {
        return {
            horizontal: b.toolboxMetrics.position === Position$$module$build$src$core$utils$toolbox.LEFT || a.horizontalLayout && !a.RTL ? horizontalPosition$$module$build$src$core$positionable_helpers.RIGHT : horizontalPosition$$module$build$src$core$positionable_helpers.LEFT,
            vertical: b.toolboxMetrics.position === Position$$module$build$src$core$utils$toolbox.BOTTOM ? verticalPosition$$module$build$src$core$positionable_helpers.TOP : verticalPosition$$module$build$src$core$positionable_helpers.BOTTOM
        };
    };
    bumpPositionRect$$module$build$src$core$positionable_helpers = function(a, b, c, d) {
        const e = a.left, f = a.right - a.left, g = a.bottom - a.top;
        for(let h = 0; h < d.length; h++){
            const k = d[h];
            a.intersects(k) && (a = c === bumpDirection$$module$build$src$core$positionable_helpers.UP ? k.top - g - b : k.bottom + b, a = new Rect$$module$build$src$core$utils$rect(a, a + g, e, e + f), h = -1);
        }
        return a;
    };
    resizeSvgContents$$module$build$src$core$workspace_svg = function(a) {
        a.resizeContents();
    };
    inject$$module$build$src$core$inject = function(a, b) {
        "string" === typeof a && (a = document.getElementById(a) || document.querySelector(a));
        if (!a || !containsNode$$module$build$src$core$utils$dom(document, a)) throw Error("Error: container is not in current document.");
        b = new Options$$module$build$src$core$options(b || {});
        const c = document.createElement("div");
        c.className = "injectionDiv";
        c.tabIndex = 0;
        setState$$module$build$src$core$utils$aria(c, State$$module$build$src$core$utils$aria.LABEL, Msg$$module$build$src$core$msg.WORKSPACE_ARIA_LABEL);
        a.appendChild(c);
        a = createDom$$module$build$src$core$inject(c, b);
        const d = new BlockDragSurfaceSvg$$module$build$src$core$block_drag_surface(c), e = new WorkspaceDragSurfaceSvg$$module$build$src$core$workspace_drag_surface_svg(c), f = createMainWorkspace$$module$build$src$core$inject(a, b, d, e);
        init$$module$build$src$core$inject(f);
        setMainWorkspace$$module$build$src$core$common(f);
        svgResize$$module$build$src$core$common(f);
        c.addEventListener("focusin", function() {
            setMainWorkspace$$module$build$src$core$common(f);
        });
        return f;
    };
    createDom$$module$build$src$core$inject = function(a, b) {
        a.setAttribute("dir", "LTR");
        inject$$module$build$src$core$css(b.hasCss, b.pathToMedia);
        a = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.SVG, {
            xmlns: SVG_NS$$module$build$src$core$utils$dom,
            "xmlns:html": HTML_NS$$module$build$src$core$utils$dom,
            "xmlns:xlink": XLINK_NS$$module$build$src$core$utils$dom,
            version: "1.1",
            "class": "blocklySvg",
            tabindex: "0"
        }, a);
        const c = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.DEFS, {}, a), d = String(Math.random()).substring(2);
        b.gridPattern = Grid$$module$build$src$core$grid.createDom(d, b.gridOptions, c);
        return a;
    };
    createMainWorkspace$$module$build$src$core$inject = function(a, b, c, d) {
        b.parentWorkspace = null;
        b = new WorkspaceSvg$$module$build$src$core$workspace_svg(b, c, d);
        c = b.options;
        b.scale = c.zoomOptions.startScale;
        a.appendChild(b.createDom("blocklyMainBackground"));
        d = b.getInjectionDiv();
        var e = b.getRenderer().getClassName();
        e && addClass$$module$build$src$core$utils$dom(d, e);
        (e = b.getTheme().getClassName()) && addClass$$module$build$src$core$utils$dom(d, e);
        !c.hasCategories && c.languageTree && (d = b.addFlyout(Svg$$module$build$src$core$utils$svg.SVG), insertAfter$$module$build$src$core$utils$dom(d, a));
        c.hasTrashcan && b.addTrashcan();
        c.zoomOptions && c.zoomOptions.controls && b.addZoomControls();
        b.getThemeManager().subscribe(a, "workspaceBackgroundColour", "background-color");
        b.translate(0, 0);
        b.addChangeListener(bumpIntoBoundsHandler$$module$build$src$core$bump_objects(b));
        svgResize$$module$build$src$core$common(b);
        createDom$$module$build$src$core$widgetdiv();
        createDom$$module$build$src$core$dropdowndiv();
        createDom$$module$build$src$core$tooltip();
        return b;
    };
    init$$module$build$src$core$inject = function(a) {
        const b = a.options;
        var c = a.getParentSvg();
        conditionalBind$$module$build$src$core$browser_events(c.parentNode, "contextmenu", null, function(d) {
            isTargetInput$$module$build$src$core$browser_events(d) || d.preventDefault();
        });
        c = conditionalBind$$module$build$src$core$browser_events(window, "resize", null, function() {
            a.hideChaff(!0);
            svgResize$$module$build$src$core$common(a);
            bumpTopObjectsIntoBounds$$module$build$src$core$bump_objects(a);
        });
        a.setResizeHandlerWrapper(c);
        bindDocumentEvents$$module$build$src$core$inject();
        if (b.languageTree) {
            c = a.getToolbox();
            const d = a.getFlyout(!0);
            c ? c.init() : d && (d.init(a), d.show(b.languageTree), "function" === typeof d.scrollToStart && d.scrollToStart());
        }
        b.hasTrashcan && a.trashcan.init();
        b.zoomOptions && b.zoomOptions.controls && a.zoomControls_.init();
        b.moveOptions && b.moveOptions.scrollbars ? (a.scrollbar = new ScrollbarPair$$module$build$src$core$scrollbar_pair(a, !0 === b.moveOptions.scrollbars || !!b.moveOptions.scrollbars.horizontal, !0 === b.moveOptions.scrollbars || !!b.moveOptions.scrollbars.vertical, "blocklyMainWorkspaceScrollbar"), a.scrollbar.resize()) : a.setMetrics({
            x: .5,
            y: .5
        });
        b.hasSounds && loadSounds$$module$build$src$core$inject(b.pathToMedia, a);
    };
    onKeyDown$$module$build$src$core$inject = function(a) {
        const b = getMainWorkspace$$module$build$src$core$common();
        if (b && !(isTargetInput$$module$build$src$core$browser_events(a) || b.rendered && !b.isVisible())) ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.onKeyDown(b, a);
    };
    bindDocumentEvents$$module$build$src$core$inject = function() {
        documentEventsBound$$module$build$src$core$inject || (conditionalBind$$module$build$src$core$browser_events(document, "scroll", null, function() {
            const a = getAllWorkspaces$$module$build$src$core$common();
            for(let b = 0, c; c = a[b]; b++)c instanceof WorkspaceSvg$$module$build$src$core$workspace_svg && c.updateInverseScreenCTM();
        }), conditionalBind$$module$build$src$core$browser_events(document, "keydown", null, onKeyDown$$module$build$src$core$inject), bind$$module$build$src$core$browser_events(document, "touchend", null, longStop$$module$build$src$core$touch), bind$$module$build$src$core$browser_events(document, "touchcancel", null, longStop$$module$build$src$core$touch), IPAD$$module$build$src$core$utils$useragent && conditionalBind$$module$build$src$core$browser_events(window, "orientationchange", document, function() {
            svgResize$$module$build$src$core$common(getMainWorkspace$$module$build$src$core$common());
        }));
        documentEventsBound$$module$build$src$core$inject = !0;
    };
    loadSounds$$module$build$src$core$inject = function(a, b) {
        function c() {
            for(; e.length;)unbind$$module$build$src$core$browser_events(e.pop());
            d.preload();
        }
        const d = b.getAudioManager();
        d.load([
            a + "click.mp3",
            a + "click.wav",
            a + "click.ogg"
        ], "click");
        d.load([
            a + "disconnect.wav",
            a + "disconnect.mp3",
            a + "disconnect.ogg"
        ], "disconnect");
        d.load([
            a + "delete.mp3",
            a + "delete.ogg",
            a + "delete.wav"
        ], "delete");
        const e = [];
        e.push(conditionalBind$$module$build$src$core$browser_events(document, "pointermove", null, c, !0));
        e.push(conditionalBind$$module$build$src$core$browser_events(document, "touchstart", null, c, !0));
    };
    saveProcedure$$module$build$src$core$serialization$procedures = function(a) {
        const b = {
            id: a.getId(),
            name: a.getName(),
            returnTypes: a.getReturnTypes()
        };
        if (!a.getParameters().length) return b;
        b.parameters = a.getParameters().map((c)=>saveParameter$$module$build$src$core$serialization$procedures(c));
        return b;
    };
    saveParameter$$module$build$src$core$serialization$procedures = function(a) {
        const b = {
            id: a.getId(),
            name: a.getName()
        };
        if (!a.getTypes().length) return b;
        b.types = a.getTypes();
        return b;
    };
    loadProcedure$$module$build$src$core$serialization$procedures = function(a, b, c, d) {
        a = new a(d, c.name, c.id).setReturnTypes(c.returnTypes);
        if (!c.parameters) return a;
        for (const [e, f] of c.parameters.entries())a.insertParameter(loadParameter$$module$build$src$core$serialization$procedures(b, f, d), e);
        return a;
    };
    loadParameter$$module$build$src$core$serialization$procedures = function(a, b, c) {
        a = new a(c, b.name, b.id);
        b.types && a.setTypes(b.types);
        return a;
    };
    save$$module$build$src$core$serialization$workspaces = function(a) {
        const b = Object.create(null), c = getAllItems$$module$build$src$core$registry(Type$$module$build$src$core$registry.SERIALIZER, !0);
        for(const d in c){
            let e;
            const f = null == (e = c[d]) ? void 0 : e.save(a);
            f && (b[d] = f);
        }
        return b;
    };
    load$$module$build$src$core$serialization$workspaces = function(a, b, { recordUndo: c = !1 } = {}) {
        var d = getAllItems$$module$build$src$core$registry(Type$$module$build$src$core$registry.SERIALIZER, !0);
        if (d) {
            d = Object.entries(d).sort((f, g)=>g[1].priority - f[1].priority);
            var e = getRecordUndo$$module$build$src$core$events$utils();
            setRecordUndo$$module$build$src$core$events$utils(c);
            (c = getGroup$$module$build$src$core$events$utils()) || setGroup$$module$build$src$core$events$utils(!0);
            startTextWidthCache$$module$build$src$core$utils$dom();
            b instanceof WorkspaceSvg$$module$build$src$core$workspace_svg && b.setResizesEnabled(!1);
            for (const [, f] of d.reverse()){
                let g;
                null == (g = f) || g.clear(b);
            }
            for (let [f, g] of d.reverse())if (a[f]) {
                let h;
                null == (h = g) || h.load(a[f], b);
            }
            b instanceof WorkspaceSvg$$module$build$src$core$workspace_svg && b.setResizesEnabled(!0);
            stopTextWidthCache$$module$build$src$core$utils$dom();
            fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(FINISHED_LOADING$$module$build$src$core$events$utils))(b));
            setGroup$$module$build$src$core$events$utils(c);
            setRecordUndo$$module$build$src$core$events$utils(e);
        }
    };
    registerEscape$$module$build$src$core$shortcut_items = function() {
        ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.register({
            name: names$$module$build$src$core$shortcut_items.ESCAPE,
            preconditionFn (a) {
                return !a.options.readOnly;
            },
            callback (a) {
                a.hideChaff();
                return !0;
            },
            keyCodes: [
                KeyCodes$$module$build$src$core$utils$keycodes.ESC
            ]
        });
    };
    registerDelete$$module$build$src$core$shortcut_items = function() {
        ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.register({
            name: names$$module$build$src$core$shortcut_items.DELETE,
            preconditionFn (a) {
                const b = getSelected$$module$build$src$core$common();
                return !a.options.readOnly && null != b && b.isDeletable();
            },
            callback (a, b) {
                b.preventDefault();
                if (Gesture$$module$build$src$core$gesture.inProgress()) return !1;
                getSelected$$module$build$src$core$common().checkAndDelete();
                return !0;
            },
            keyCodes: [
                KeyCodes$$module$build$src$core$utils$keycodes.DELETE,
                KeyCodes$$module$build$src$core$utils$keycodes.BACKSPACE
            ]
        });
    };
    registerCopy$$module$build$src$core$shortcut_items = function() {
        const a = ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.createSerializedKey(KeyCodes$$module$build$src$core$utils$keycodes.C, [
            KeyCodes$$module$build$src$core$utils$keycodes.CTRL
        ]), b = ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.createSerializedKey(KeyCodes$$module$build$src$core$utils$keycodes.C, [
            KeyCodes$$module$build$src$core$utils$keycodes.ALT
        ]), c = ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.createSerializedKey(KeyCodes$$module$build$src$core$utils$keycodes.C, [
            KeyCodes$$module$build$src$core$utils$keycodes.META
        ]);
        ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.register({
            name: names$$module$build$src$core$shortcut_items.COPY,
            preconditionFn (d) {
                const e = getSelected$$module$build$src$core$common();
                return !d.options.readOnly && !Gesture$$module$build$src$core$gesture.inProgress() && null != e && e.isDeletable() && e.isMovable();
            },
            callback (d, e) {
                e.preventDefault();
                d.hideChaff();
                copy$$module$build$src$core$clipboard(getSelected$$module$build$src$core$common());
                return !0;
            },
            keyCodes: [
                a,
                b,
                c
            ]
        });
    };
    registerCut$$module$build$src$core$shortcut_items = function() {
        const a = ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.createSerializedKey(KeyCodes$$module$build$src$core$utils$keycodes.X, [
            KeyCodes$$module$build$src$core$utils$keycodes.CTRL
        ]), b = ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.createSerializedKey(KeyCodes$$module$build$src$core$utils$keycodes.X, [
            KeyCodes$$module$build$src$core$utils$keycodes.ALT
        ]), c = ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.createSerializedKey(KeyCodes$$module$build$src$core$utils$keycodes.X, [
            KeyCodes$$module$build$src$core$utils$keycodes.META
        ]);
        ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.register({
            name: names$$module$build$src$core$shortcut_items.CUT,
            preconditionFn (d) {
                const e = getSelected$$module$build$src$core$common();
                return !d.options.readOnly && !Gesture$$module$build$src$core$gesture.inProgress() && null != e && e instanceof BlockSvg$$module$build$src$core$block_svg && e.isDeletable() && e.isMovable() && !e.workspace.isFlyout;
            },
            callback () {
                const d = getSelected$$module$build$src$core$common();
                if (!d) return !1;
                copy$$module$build$src$core$clipboard(d);
                d.checkAndDelete();
                return !0;
            },
            keyCodes: [
                a,
                b,
                c
            ]
        });
    };
    registerPaste$$module$build$src$core$shortcut_items = function() {
        const a = ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.createSerializedKey(KeyCodes$$module$build$src$core$utils$keycodes.V, [
            KeyCodes$$module$build$src$core$utils$keycodes.CTRL
        ]), b = ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.createSerializedKey(KeyCodes$$module$build$src$core$utils$keycodes.V, [
            KeyCodes$$module$build$src$core$utils$keycodes.ALT
        ]), c = ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.createSerializedKey(KeyCodes$$module$build$src$core$utils$keycodes.V, [
            KeyCodes$$module$build$src$core$utils$keycodes.META
        ]);
        ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.register({
            name: names$$module$build$src$core$shortcut_items.PASTE,
            preconditionFn (d) {
                return !d.options.readOnly && !Gesture$$module$build$src$core$gesture.inProgress();
            },
            callback () {
                return !!paste$$module$build$src$core$clipboard();
            },
            keyCodes: [
                a,
                b,
                c
            ]
        });
    };
    registerUndo$$module$build$src$core$shortcut_items = function() {
        const a = ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.createSerializedKey(KeyCodes$$module$build$src$core$utils$keycodes.Z, [
            KeyCodes$$module$build$src$core$utils$keycodes.CTRL
        ]), b = ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.createSerializedKey(KeyCodes$$module$build$src$core$utils$keycodes.Z, [
            KeyCodes$$module$build$src$core$utils$keycodes.ALT
        ]), c = ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.createSerializedKey(KeyCodes$$module$build$src$core$utils$keycodes.Z, [
            KeyCodes$$module$build$src$core$utils$keycodes.META
        ]);
        ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.register({
            name: names$$module$build$src$core$shortcut_items.UNDO,
            preconditionFn (d) {
                return !d.options.readOnly && !Gesture$$module$build$src$core$gesture.inProgress();
            },
            callback (d) {
                d.hideChaff();
                d.undo(!1);
                return !0;
            },
            keyCodes: [
                a,
                b,
                c
            ]
        });
    };
    registerRedo$$module$build$src$core$shortcut_items = function() {
        const a = ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.createSerializedKey(KeyCodes$$module$build$src$core$utils$keycodes.Z, [
            KeyCodes$$module$build$src$core$utils$keycodes.SHIFT,
            KeyCodes$$module$build$src$core$utils$keycodes.CTRL
        ]), b = ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.createSerializedKey(KeyCodes$$module$build$src$core$utils$keycodes.Z, [
            KeyCodes$$module$build$src$core$utils$keycodes.SHIFT,
            KeyCodes$$module$build$src$core$utils$keycodes.ALT
        ]), c = ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.createSerializedKey(KeyCodes$$module$build$src$core$utils$keycodes.Z, [
            KeyCodes$$module$build$src$core$utils$keycodes.SHIFT,
            KeyCodes$$module$build$src$core$utils$keycodes.META
        ]), d = ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.createSerializedKey(KeyCodes$$module$build$src$core$utils$keycodes.Y, [
            KeyCodes$$module$build$src$core$utils$keycodes.CTRL
        ]);
        ShortcutRegistry$$module$build$src$core$shortcut_registry.registry.register({
            name: names$$module$build$src$core$shortcut_items.REDO,
            preconditionFn (e) {
                return !Gesture$$module$build$src$core$gesture.inProgress() && !e.options.readOnly;
            },
            callback (e) {
                e.hideChaff();
                e.undo(!0);
                return !0;
            },
            keyCodes: [
                a,
                b,
                c,
                d
            ]
        });
    };
    registerDefaultShortcuts$$module$build$src$core$shortcut_items = function() {
        registerEscape$$module$build$src$core$shortcut_items();
        registerDelete$$module$build$src$core$shortcut_items();
        registerCopy$$module$build$src$core$shortcut_items();
        registerCut$$module$build$src$core$shortcut_items();
        registerPaste$$module$build$src$core$shortcut_items();
        registerUndo$$module$build$src$core$shortcut_items();
        registerRedo$$module$build$src$core$shortcut_items();
    };
    isSelectableToolboxItem$$module$build$src$core$interfaces$i_selectable_toolbox_item = function(a) {
        return a.isSelectable();
    };
    getRelativeXY$$module$build$src$core$utils = function(a) {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.getRelativeXY", "December 2021", "December 2022", "Blockly.utils.svgMath.getRelativeXY");
        return getRelativeXY$$module$build$src$core$utils$svg_math(a);
    };
    getInjectionDivXY$$module$build$src$core$utils = function(a) {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.getInjectionDivXY_", "December 2021", "December 2022", "Blockly.utils.svgMath.getInjectionDivXY");
        return getInjectionDivXY$$module$build$src$core$utils$svg_math(a);
    };
    tokenizeInterpolation$$module$build$src$core$utils = function(a) {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.tokenizeInterpolation", "December 2021", "December 2022", "Blockly.utils.parsing.tokenizeInterpolation");
        return tokenizeInterpolation$$module$build$src$core$utils$parsing(a);
    };
    replaceMessageReferences$$module$build$src$core$utils = function(a) {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.replaceMessageReferences", "December 2021", "December 2022", "Blockly.utils.parsing.replaceMessageReferences");
        return replaceMessageReferences$$module$build$src$core$utils$parsing(a);
    };
    checkMessageReferences$$module$build$src$core$utils = function(a) {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.checkMessageReferences", "December 2021", "December 2022", "Blockly.utils.parsing.checkMessageReferences");
        return checkMessageReferences$$module$build$src$core$utils$parsing(a);
    };
    is3dSupported$$module$build$src$core$utils = function() {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.is3dSupported", "December 2021", "December 2022", "Blockly.utils.svgMath.is3dSupported");
        return is3dSupported$$module$build$src$core$utils$svg_math();
    };
    getViewportBBox$$module$build$src$core$utils = function() {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.getViewportBBox", "December 2021", "December 2022", "Blockly.utils.svgMath.getViewportBBox");
        return getViewportBBox$$module$build$src$core$utils$svg_math();
    };
    arrayRemove$$module$build$src$core$utils = function(a, b) {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.arrayRemove", "December 2021", "December 2022", "Blockly.array.removeElem");
        return removeElem$$module$build$src$core$utils$array(a, b);
    };
    getDocumentScroll$$module$build$src$core$utils = function() {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.getDocumentScroll", "December 2021", "December 2022", "Blockly.utils.svgMath.getDocumentScroll");
        return getDocumentScroll$$module$build$src$core$utils$svg_math();
    };
    getBlockTypeCounts$$module$build$src$core$utils = function(a, b) {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.getBlockTypeCounts", "December 2021", "December 2022", "Blockly.common.getBlockTypeCounts");
        return getBlockTypeCounts$$module$build$src$core$common(a, b);
    };
    screenToWsCoordinates$$module$build$src$core$utils = function(a, b) {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.screenToWsCoordinates", "December 2021", "December 2022", "Blockly.utils.svgMath.screenToWsCoordinates");
        return screenToWsCoordinates$$module$build$src$core$utils$svg_math(a, b);
    };
    parseBlockColour$$module$build$src$core$utils = function(a) {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.parseBlockColour", "December 2021", "December 2022", "Blockly.utils.parsing.parseBlockColour");
        return parseBlockColour$$module$build$src$core$utils$parsing(a);
    };
    runAfterPageLoad$$module$build$src$core$utils = function(a) {
        warn$$module$build$src$core$utils$deprecation("Blockly.utils.runAfterPageLoad", "December 2021", "December 2022");
        runAfterPageLoad$$module$build$src$core$extensions(a);
    };
    hideChaff$$module$build$src$core$blockly = function(a) {
        getMainWorkspace$$module$build$src$core$common().hideChaff(a);
    };
    resizeSvgContentsLocal$$module$build$src$core$blockly = function(a) {
        warn$$module$build$src$core$utils$deprecation("Blockly.resizeSvgContents", "December 2021", "December 2022", "Blockly.WorkspaceSvg.resizeSvgContents");
        resizeSvgContents$$module$build$src$core$workspace_svg(a);
    };
    copy$$module$build$src$core$blockly = function(a) {
        warn$$module$build$src$core$utils$deprecation("Blockly.copy", "December 2021", "December 2022", "Blockly.clipboard.copy");
        copy$$module$build$src$core$clipboard(a);
    };
    paste$$module$build$src$core$blockly = function() {
        warn$$module$build$src$core$utils$deprecation("Blockly.paste", "December 2021", "December 2022", "Blockly.clipboard.paste");
        return !!paste$$module$build$src$core$clipboard();
    };
    duplicate$$module$build$src$core$blockly = function(a) {
        warn$$module$build$src$core$utils$deprecation("Blockly.duplicate", "December 2021", "December 2022", "Blockly.clipboard.duplicate");
        duplicate$$module$build$src$core$clipboard(a);
    };
    isNumber$$module$build$src$core$blockly = function(a) {
        warn$$module$build$src$core$utils$deprecation("Blockly.isNumber", "December 2021", "December 2022", "Blockly.utils.string.isNumber");
        return isNumber$$module$build$src$core$utils$string(a);
    };
    hueToHex$$module$build$src$core$blockly = function(a) {
        warn$$module$build$src$core$utils$deprecation("Blockly.hueToHex", "December 2021", "December 2022", "Blockly.utils.colour.hueToHex");
        return hueToHex$$module$build$src$core$utils$colour(a);
    };
    bindEvent_$$module$build$src$core$blockly = function(a, b, c, d) {
        warn$$module$build$src$core$utils$deprecation("Blockly.bindEvent_", "December 2021", "December 2022", "Blockly.browserEvents.bind");
        return bind$$module$build$src$core$browser_events(a, b, c, d);
    };
    unbindEvent_$$module$build$src$core$blockly = function(a) {
        warn$$module$build$src$core$utils$deprecation("Blockly.unbindEvent_", "December 2021", "December 2022", "Blockly.browserEvents.unbind");
        return unbind$$module$build$src$core$browser_events(a);
    };
    bindEventWithChecks_$$module$build$src$core$blockly = function(a, b, c, d, e, f) {
        warn$$module$build$src$core$utils$deprecation("Blockly.bindEventWithChecks_", "December 2021", "December 2022", "Blockly.browserEvents.conditionalBind");
        return conditionalBind$$module$build$src$core$browser_events(a, b, c, d, e);
    };
    $jscomp = $jscomp || {};
    $jscomp.scope = {};
    $jscomp.ASSUME_ES5 = !1;
    $jscomp.ASSUME_NO_NATIVE_MAP = !1;
    $jscomp.ASSUME_NO_NATIVE_SET = !1;
    $jscomp.SIMPLE_FROUND_POLYFILL = !1;
    $jscomp.ISOLATE_POLYFILLS = !1;
    $jscomp.FORCE_POLYFILL_PROMISE = !1;
    $jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1;
    $jscomp.defineProperty = $jscomp.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        if (a == Array.prototype || a == Object.prototype) return a;
        a[b] = c.value;
        return a;
    };
    $jscomp.getGlobal = function(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $parcel$global && $parcel$global
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    };
    $jscomp.global = $jscomp.getGlobal(this);
    $jscomp.IS_SYMBOL_NATIVE = "function" === typeof Symbol && "symbol" === typeof Symbol("x");
    $jscomp.TRUST_ES6_POLYFILLS = !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE;
    $jscomp.polyfills = {};
    $jscomp.propertyToPolyfillSymbol = {};
    $jscomp.POLYFILL_PREFIX = "$jscp$";
    var $jscomp$lookupPolyfilledValue = function(a, b) {
        var c = $jscomp.propertyToPolyfillSymbol[b];
        if (null == c) return a[b];
        c = a[c];
        return void 0 !== c ? c : a[b];
    };
    $jscomp.polyfill = function(a, b, c, d) {
        b && ($jscomp.ISOLATE_POLYFILLS ? $jscomp.polyfillIsolated(a, b, c, d) : $jscomp.polyfillUnisolated(a, b, c, d));
    };
    $jscomp.polyfillUnisolated = function(a, b, c, d) {
        c = $jscomp.global;
        a = a.split(".");
        for(d = 0; d < a.length - 1; d++){
            var e = a[d];
            if (!(e in c)) return;
            c = c[e];
        }
        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && null != b && $jscomp.defineProperty(c, a, {
            configurable: !0,
            writable: !0,
            value: b
        });
    };
    $jscomp.polyfillIsolated = function(a, b, c, d) {
        var e = a.split(".");
        a = 1 === e.length;
        d = e[0];
        d = !a && d in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global;
        for(var f = 0; f < e.length - 1; f++){
            var g = e[f];
            if (!(g in d)) return;
            d = d[g];
        }
        e = e[e.length - 1];
        c = $jscomp.IS_SYMBOL_NATIVE && "es6" === c ? d[e] : null;
        b = b(c);
        null != b && (a ? $jscomp.defineProperty($jscomp.polyfills, e, {
            configurable: !0,
            writable: !0,
            value: b
        }) : b !== c && (void 0 === $jscomp.propertyToPolyfillSymbol[e] && (c = 1E9 * Math.random() >>> 0, $jscomp.propertyToPolyfillSymbol[e] = $jscomp.IS_SYMBOL_NATIVE ? $jscomp.global.Symbol(e) : $jscomp.POLYFILL_PREFIX + c + "$" + e), $jscomp.defineProperty(d, $jscomp.propertyToPolyfillSymbol[e], {
            configurable: !0,
            writable: !0,
            value: b
        })));
    };
    $jscomp.polyfill("globalThis", function(a) {
        return a || $jscomp.global;
    }, "es_2020", "es3");
    $jscomp.polyfill("Object.getOwnPropertyDescriptors", function(a) {
        return a ? a : function(b) {
            for(var c = {}, d = Reflect.ownKeys(b), e = 0; e < d.length; e++)c[d[e]] = Object.getOwnPropertyDescriptor(b, d[e]);
            return c;
        };
    }, "es8", "es5");
    $jscomp.arrayIteratorImpl = function(a) {
        var b = 0;
        return function() {
            return b < a.length ? {
                done: !1,
                value: a[b++]
            } : {
                done: !0
            };
        };
    };
    $jscomp.arrayIterator = function(a) {
        return {
            next: $jscomp.arrayIteratorImpl(a)
        };
    };
    $jscomp.initSymbol = function() {};
    $jscomp.iteratorPrototype = function(a) {
        a = {
            next: a
        };
        a[Symbol.iterator] = function() {
            return this;
        };
        return a;
    };
    $jscomp.iteratorFromArray = function(a, b) {
        a instanceof String && (a += "");
        var c = 0, d = !1, e = {
            next: function() {
                if (!d && c < a.length) {
                    var f = c++;
                    return {
                        value: b(f, a[f]),
                        done: !1
                    };
                }
                d = !0;
                return {
                    done: !0,
                    value: void 0
                };
            }
        };
        e[Symbol.iterator] = function() {
            return e;
        };
        return e;
    };
    $jscomp.polyfill("Array.prototype.values", function(a) {
        return a ? a : function() {
            return $jscomp.iteratorFromArray(this, function(b, c) {
                return c;
            });
        };
    }, "es8", "es3");
    $jscomp.owns = function(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    };
    $jscomp.polyfill("Object.values", function(a) {
        return a ? a : function(b) {
            var c = [], d;
            for(d in b)$jscomp.owns(b, d) && c.push(b[d]);
            return c;
        };
    }, "es8", "es3");
    $jscomp.polyfill("Array.prototype.flat", function(a) {
        return a ? a : function(b) {
            b = void 0 === b ? 1 : b;
            for(var c = [], d = 0; d < this.length; d++){
                var e = this[d];
                Array.isArray(e) && 0 < b ? (e = Array.prototype.flat.call(e, b - 1), c.push.apply(c, e)) : c.push(e);
            }
            return c;
        };
    }, "es9", "es5");
    $jscomp.polyfill("Object.entries", function(a) {
        return a ? a : function(b) {
            var c = [], d;
            for(d in b)$jscomp.owns(b, d) && c.push([
                d,
                b[d]
            ]);
            return c;
        };
    }, "es8", "es3");
    var COMPILED = !0, goog = goog || {};
    goog.global = globalThis || root;
    goog.define = function(a, b) {
        return b;
    };
    goog.DEBUG = !1;
    goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG;
    goog.provide = function(a) {};
    goog.module = function(a) {};
    goog.module.get = function(a) {};
    goog.module.declareLegacyNamespace = function() {};
    goog.setTestOnly = function(a) {
        if (goog.DISALLOW_TEST_ONLY_CODE) throw a = a || "", Error("Importing test-only code into non-debug environment" + (a ? ": " + a : "."));
    };
    goog.require = function(a) {};
    goog.requireType = function(a) {};
    var global$$module$build$src$closure$goog$goog = globalThis, declareModuleId$$module$build$src$closure$goog$goog = function(a) {
        window.goog && window.goog.declareModuleId && window.goog.declareModuleId.call(this, a);
    }, module$build$src$closure$goog$goog = {};
    module$build$src$closure$goog$goog.declareModuleId = declareModuleId$$module$build$src$closure$goog$goog;
    module$build$src$closure$goog$goog.global = global$$module$build$src$closure$goog$goog;
    var module$build$src$core$utils$deprecation = {};
    module$build$src$core$utils$deprecation.warn = warn$$module$build$src$core$utils$deprecation;
    var typeMap$$module$build$src$core$registry = Object.create(null), TEST_ONLY$$module$build$src$core$registry = {
        typeMap: typeMap$$module$build$src$core$registry
    }, nameMap$$module$build$src$core$registry = Object.create(null), DEFAULT$$module$build$src$core$registry = "default", Type$$module$build$src$core$registry = class {
        constructor(a){
            this.name = a;
        }
        toString() {
            return this.name;
        }
    };
    Type$$module$build$src$core$registry.CONNECTION_CHECKER = new Type$$module$build$src$core$registry("connectionChecker");
    Type$$module$build$src$core$registry.CURSOR = new Type$$module$build$src$core$registry("cursor");
    Type$$module$build$src$core$registry.EVENT = new Type$$module$build$src$core$registry("event");
    Type$$module$build$src$core$registry.FIELD = new Type$$module$build$src$core$registry("field");
    Type$$module$build$src$core$registry.RENDERER = new Type$$module$build$src$core$registry("renderer");
    Type$$module$build$src$core$registry.TOOLBOX = new Type$$module$build$src$core$registry("toolbox");
    Type$$module$build$src$core$registry.THEME = new Type$$module$build$src$core$registry("theme");
    Type$$module$build$src$core$registry.TOOLBOX_ITEM = new Type$$module$build$src$core$registry("toolboxItem");
    Type$$module$build$src$core$registry.FLYOUTS_VERTICAL_TOOLBOX = new Type$$module$build$src$core$registry("flyoutsVerticalToolbox");
    Type$$module$build$src$core$registry.FLYOUTS_HORIZONTAL_TOOLBOX = new Type$$module$build$src$core$registry("flyoutsHorizontalToolbox");
    Type$$module$build$src$core$registry.METRICS_MANAGER = new Type$$module$build$src$core$registry("metricsManager");
    Type$$module$build$src$core$registry.BLOCK_DRAGGER = new Type$$module$build$src$core$registry("blockDragger");
    Type$$module$build$src$core$registry.SERIALIZER = new Type$$module$build$src$core$registry("serializer");
    var module$build$src$core$registry = {};
    module$build$src$core$registry.DEFAULT = DEFAULT$$module$build$src$core$registry;
    module$build$src$core$registry.TEST_ONLY = TEST_ONLY$$module$build$src$core$registry;
    module$build$src$core$registry.Type = Type$$module$build$src$core$registry;
    module$build$src$core$registry.getAllItems = getAllItems$$module$build$src$core$registry;
    module$build$src$core$registry.getClass = getClass$$module$build$src$core$registry;
    module$build$src$core$registry.getClassFromOptions = getClassFromOptions$$module$build$src$core$registry;
    module$build$src$core$registry.getObject = getObject$$module$build$src$core$registry;
    module$build$src$core$registry.hasItem = hasItem$$module$build$src$core$registry;
    module$build$src$core$registry.register = register$$module$build$src$core$registry;
    module$build$src$core$registry.unregister = unregister$$module$build$src$core$registry;
    var Blocks$$module$build$src$core$blocks = Object.create(null), module$build$src$core$blocks = {};
    module$build$src$core$blocks.Blocks = Blocks$$module$build$src$core$blocks;
    var WorkspaceDB_$$module$build$src$core$common, mainWorkspace$$module$build$src$core$common, selected$$module$build$src$core$common, parentContainer$$module$build$src$core$common, draggingConnections$$module$build$src$core$common, TEST_ONLY$$module$build$src$core$common;
    WorkspaceDB_$$module$build$src$core$common = Object.create(null);
    selected$$module$build$src$core$common = null;
    draggingConnections$$module$build$src$core$common = [];
    TEST_ONLY$$module$build$src$core$common = {
        defineBlocksWithJsonArrayInternal: defineBlocksWithJsonArrayInternal$$module$build$src$core$common
    };
    $.module$build$src$core$common = {};
    $.module$build$src$core$common.TEST_ONLY = TEST_ONLY$$module$build$src$core$common;
    $.module$build$src$core$common.createBlockDefinitionsFromJsonArray = $.createBlockDefinitionsFromJsonArray$$module$build$src$core$common;
    $.module$build$src$core$common.defineBlocks = $.defineBlocks$$module$build$src$core$common;
    $.module$build$src$core$common.defineBlocksWithJsonArray = defineBlocksWithJsonArray$$module$build$src$core$common;
    $.module$build$src$core$common.draggingConnections = draggingConnections$$module$build$src$core$common;
    $.module$build$src$core$common.getAllWorkspaces = getAllWorkspaces$$module$build$src$core$common;
    $.module$build$src$core$common.getBlockTypeCounts = getBlockTypeCounts$$module$build$src$core$common;
    $.module$build$src$core$common.getMainWorkspace = getMainWorkspace$$module$build$src$core$common;
    $.module$build$src$core$common.getParentContainer = getParentContainer$$module$build$src$core$common;
    $.module$build$src$core$common.getSelected = getSelected$$module$build$src$core$common;
    $.module$build$src$core$common.getWorkspaceById = getWorkspaceById$$module$build$src$core$common;
    $.module$build$src$core$common.registerWorkspace = registerWorkspace$$module$build$src$core$common;
    $.module$build$src$core$common.setMainWorkspace = setMainWorkspace$$module$build$src$core$common;
    $.module$build$src$core$common.setParentContainer = setParentContainer$$module$build$src$core$common;
    $.module$build$src$core$common.setSelected = setSelected$$module$build$src$core$common;
    $.module$build$src$core$common.svgResize = svgResize$$module$build$src$core$common;
    $.module$build$src$core$common.unregisterWorkpace = unregisterWorkpace$$module$build$src$core$common;
    var soup$$module$build$src$core$utils$idgenerator = "!#$%()*+,-./:;=?@[]^_`{|}~ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", internal$$module$build$src$core$utils$idgenerator = {
        genUid: ()=>{
            const a = soup$$module$build$src$core$utils$idgenerator.length, b = [];
            for(let c = 0; 20 > c; c++)b[c] = soup$$module$build$src$core$utils$idgenerator.charAt(Math.random() * a);
            return b.join("");
        }
    }, TEST_ONLY$$module$build$src$core$utils$idgenerator = internal$$module$build$src$core$utils$idgenerator, nextId$$module$build$src$core$utils$idgenerator = 0, module$build$src$core$utils$idgenerator = {};
    module$build$src$core$utils$idgenerator.TEST_ONLY = internal$$module$build$src$core$utils$idgenerator;
    module$build$src$core$utils$idgenerator.genUid = genUid$$module$build$src$core$utils$idgenerator;
    module$build$src$core$utils$idgenerator.getNextUniqueId = getNextUniqueId$$module$build$src$core$utils$idgenerator;
    var group$$module$build$src$core$events$utils = "", recordUndo$$module$build$src$core$events$utils = !0, disabled$$module$build$src$core$events$utils = 0, CREATE$$module$build$src$core$events$utils = "create", BLOCK_CREATE$$module$build$src$core$events$utils = CREATE$$module$build$src$core$events$utils, DELETE$$module$build$src$core$events$utils = "delete", BLOCK_DELETE$$module$build$src$core$events$utils = DELETE$$module$build$src$core$events$utils, CHANGE$$module$build$src$core$events$utils = "change", BLOCK_CHANGE$$module$build$src$core$events$utils = CHANGE$$module$build$src$core$events$utils, MOVE$$module$build$src$core$events$utils = "move", BLOCK_MOVE$$module$build$src$core$events$utils = MOVE$$module$build$src$core$events$utils, VAR_CREATE$$module$build$src$core$events$utils = "var_create", VAR_DELETE$$module$build$src$core$events$utils = "var_delete", VAR_RENAME$$module$build$src$core$events$utils = "var_rename", UI$$module$build$src$core$events$utils = "ui", BLOCK_DRAG$$module$build$src$core$events$utils = "drag", SELECTED$$module$build$src$core$events$utils = "selected", CLICK$$module$build$src$core$events$utils = "click", MARKER_MOVE$$module$build$src$core$events$utils = "marker_move", BUBBLE_OPEN$$module$build$src$core$events$utils = "bubble_open", TRASHCAN_OPEN$$module$build$src$core$events$utils = "trashcan_open", TOOLBOX_ITEM_SELECT$$module$build$src$core$events$utils = "toolbox_item_select", THEME_CHANGE$$module$build$src$core$events$utils = "theme_change", VIEWPORT_CHANGE$$module$build$src$core$events$utils = "viewport_change", COMMENT_CREATE$$module$build$src$core$events$utils = "comment_create", COMMENT_DELETE$$module$build$src$core$events$utils = "comment_delete", COMMENT_CHANGE$$module$build$src$core$events$utils = "comment_change", COMMENT_MOVE$$module$build$src$core$events$utils = "comment_move", FINISHED_LOADING$$module$build$src$core$events$utils = "finished_loading", BUMP_EVENTS$$module$build$src$core$events$utils = [
        CREATE$$module$build$src$core$events$utils,
        MOVE$$module$build$src$core$events$utils,
        COMMENT_CREATE$$module$build$src$core$events$utils,
        COMMENT_MOVE$$module$build$src$core$events$utils
    ], FIRE_QUEUE$$module$build$src$core$events$utils = [], TEST_ONLY$$module$build$src$core$events$utils = {
        FIRE_QUEUE: FIRE_QUEUE$$module$build$src$core$events$utils,
        fireNow: fireNow$$module$build$src$core$events$utils,
        fireInternal: fireInternal$$module$build$src$core$events$utils,
        setGroupInternal: setGroupInternal$$module$build$src$core$events$utils
    }, module$build$src$core$events$utils = {};
    module$build$src$core$events$utils.BLOCK_CHANGE = CHANGE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.BLOCK_CREATE = CREATE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.BLOCK_DELETE = DELETE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.BLOCK_DRAG = BLOCK_DRAG$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.BLOCK_MOVE = MOVE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.BUBBLE_OPEN = BUBBLE_OPEN$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.BUMP_EVENTS = BUMP_EVENTS$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.CHANGE = CHANGE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.CLICK = CLICK$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.COMMENT_CHANGE = COMMENT_CHANGE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.COMMENT_CREATE = COMMENT_CREATE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.COMMENT_DELETE = COMMENT_DELETE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.COMMENT_MOVE = COMMENT_MOVE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.CREATE = CREATE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.DELETE = DELETE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.FINISHED_LOADING = FINISHED_LOADING$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.MARKER_MOVE = MARKER_MOVE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.MOVE = MOVE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.SELECTED = SELECTED$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.TEST_ONLY = TEST_ONLY$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.THEME_CHANGE = THEME_CHANGE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.TOOLBOX_ITEM_SELECT = TOOLBOX_ITEM_SELECT$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.TRASHCAN_OPEN = TRASHCAN_OPEN$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.UI = UI$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.VAR_CREATE = VAR_CREATE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.VAR_DELETE = VAR_DELETE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.VAR_RENAME = VAR_RENAME$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.VIEWPORT_CHANGE = VIEWPORT_CHANGE$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.clearPendingUndo = clearPendingUndo$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.disable = disable$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.disableOrphans = disableOrphans$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.enable = enable$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.filter = filter$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.fire = fire$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.fromJson = fromJson$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.get = get$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.getDescendantIds = getDescendantIds$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.getGroup = getGroup$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.getRecordUndo = getRecordUndo$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.isEnabled = isEnabled$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.setGroup = setGroup$$module$build$src$core$events$utils;
    module$build$src$core$events$utils.setRecordUndo = setRecordUndo$$module$build$src$core$events$utils;
    var inputTypes$$module$build$src$core$input_types;
    (function(a) {
        a[a.VALUE = 1] = "VALUE";
        a[a.STATEMENT = 3] = "STATEMENT";
        a[a.DUMMY = 5] = "DUMMY";
    })(inputTypes$$module$build$src$core$input_types || (inputTypes$$module$build$src$core$input_types = {}));
    $.module$build$src$core$input_types = {};
    $.module$build$src$core$input_types.inputTypes = inputTypes$$module$build$src$core$input_types;
    var Size$$module$build$src$core$utils$size = class {
        constructor(a, b){
            this.width = a;
            this.height = b;
        }
        static equals(a, b) {
            return a === b ? !0 : a && b ? a.width === b.width && a.height === b.height : !1;
        }
    }, module$build$src$core$utils$size = {};
    module$build$src$core$utils$size.Size = Size$$module$build$src$core$utils$size;
    var document$$module$build$src$core$utils$xml, DOMParser$$module$build$src$core$utils$xml, XMLSerializer$$module$build$src$core$utils$xml, NAME_SPACE$$module$build$src$core$utils$xml;
    ({ document: document$$module$build$src$core$utils$xml, DOMParser: DOMParser$$module$build$src$core$utils$xml, XMLSerializer: XMLSerializer$$module$build$src$core$utils$xml } = globalThis);
    NAME_SPACE$$module$build$src$core$utils$xml = "https://developers.google.com/blockly/xml";
    $.module$build$src$core$utils$xml = {};
    $.module$build$src$core$utils$xml.NAME_SPACE = NAME_SPACE$$module$build$src$core$utils$xml;
    $.module$build$src$core$utils$xml.createElement = $.createElement$$module$build$src$core$utils$xml;
    $.module$build$src$core$utils$xml.createTextNode = createTextNode$$module$build$src$core$utils$xml;
    $.module$build$src$core$utils$xml.domToText = domToText$$module$build$src$core$utils$xml;
    $.module$build$src$core$utils$xml.getDocument = getDocument$$module$build$src$core$utils$xml;
    $.module$build$src$core$utils$xml.injectDependencies = injectDependencies$$module$build$src$core$utils$xml;
    $.module$build$src$core$utils$xml.setDocument = setDocument$$module$build$src$core$utils$xml;
    $.module$build$src$core$utils$xml.textToDom = textToDom$$module$build$src$core$utils$xml;
    $.module$build$src$core$utils$xml.textToDomDocument = textToDomDocument$$module$build$src$core$utils$xml;
    var SVG_NS$$module$build$src$core$utils$dom = "http://www.w3.org/2000/svg", HTML_NS$$module$build$src$core$utils$dom = "http://www.w3.org/1999/xhtml", XLINK_NS$$module$build$src$core$utils$dom = "http://www.w3.org/1999/xlink", NodeType$$module$build$src$core$utils$dom;
    (function(a) {
        a[a.ELEMENT_NODE = 1] = "ELEMENT_NODE";
        a[a.TEXT_NODE = 3] = "TEXT_NODE";
        a[a.COMMENT_NODE = 8] = "COMMENT_NODE";
        a[a.DOCUMENT_POSITION_CONTAINED_BY = 16] = "DOCUMENT_POSITION_CONTAINED_BY";
    })(NodeType$$module$build$src$core$utils$dom || (NodeType$$module$build$src$core$utils$dom = {}));
    var cacheWidths$$module$build$src$core$utils$dom = null, cacheReference$$module$build$src$core$utils$dom = 0, canvasContext$$module$build$src$core$utils$dom = null, module$build$src$core$utils$dom = {};
    module$build$src$core$utils$dom.HTML_NS = HTML_NS$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.NodeType = NodeType$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.SVG_NS = SVG_NS$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.XLINK_NS = XLINK_NS$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.addClass = addClass$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.containsNode = containsNode$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.createSvgElement = createSvgElement$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.getFastTextWidth = getFastTextWidth$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.getFastTextWidthWithSizeString = getFastTextWidthWithSizeString$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.getTextWidth = getTextWidth$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.hasClass = hasClass$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.insertAfter = insertAfter$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.measureFontMetrics = measureFontMetrics$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.removeClass = removeClass$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.removeClasses = removeClasses$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.removeNode = removeNode$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.setCssTransform = setCssTransform$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.startTextWidthCache = startTextWidthCache$$module$build$src$core$utils$dom;
    module$build$src$core$utils$dom.stopTextWidthCache = stopTextWidthCache$$module$build$src$core$utils$dom;
    var alertImplementation$$module$build$src$core$dialog = function(a, b) {
        window.alert(a);
        b && b();
    }, confirmImplementation$$module$build$src$core$dialog = function(a, b) {
        b(window.confirm(a));
    }, promptImplementation$$module$build$src$core$dialog = function(a, b, c) {
        c(window.prompt(a, b));
    }, TEST_ONLY$$module$build$src$core$dialog = {
        confirmInternal: confirmInternal$$module$build$src$core$dialog
    }, module$build$src$core$dialog = {};
    module$build$src$core$dialog.TEST_ONLY = TEST_ONLY$$module$build$src$core$dialog;
    module$build$src$core$dialog.alert = alert$$module$build$src$core$dialog;
    module$build$src$core$dialog.confirm = confirm$$module$build$src$core$dialog;
    module$build$src$core$dialog.prompt = prompt$$module$build$src$core$dialog;
    module$build$src$core$dialog.setAlert = setAlert$$module$build$src$core$dialog;
    module$build$src$core$dialog.setConfirm = setConfirm$$module$build$src$core$dialog;
    module$build$src$core$dialog.setPrompt = setPrompt$$module$build$src$core$dialog;
    var module$build$src$core$interfaces$i_variable_backed_parameter_model = {};
    module$build$src$core$interfaces$i_variable_backed_parameter_model.isVariableBackedParameterModel = isVariableBackedParameterModel$$module$build$src$core$interfaces$i_variable_backed_parameter_model;
    var Msg$$module$build$src$core$msg, setLocale$$module$build$src$core$msg;
    Msg$$module$build$src$core$msg = Object.create(null);
    setLocale$$module$build$src$core$msg = function(a) {
        Object.keys(a).forEach(function(b) {
            Msg$$module$build$src$core$msg[b] = a[b];
        });
    };
    $.module$build$src$core$msg = {};
    $.module$build$src$core$msg.Msg = Msg$$module$build$src$core$msg;
    $.module$build$src$core$msg.setLocale = setLocale$$module$build$src$core$msg;
    var module$build$src$core$interfaces$i_legacy_procedure_blocks = {};
    module$build$src$core$interfaces$i_legacy_procedure_blocks.isLegacyProcedureCallBlock = isLegacyProcedureCallBlock$$module$build$src$core$interfaces$i_legacy_procedure_blocks;
    module$build$src$core$interfaces$i_legacy_procedure_blocks.isLegacyProcedureDefBlock = isLegacyProcedureDefBlock$$module$build$src$core$interfaces$i_legacy_procedure_blocks;
    var Abstract$$module$build$src$core$events$events_abstract = class {
        constructor(){
            this.workspaceId = void 0;
            this.isUiEvent = !1;
            this.type = "";
            this.group = getGroup$$module$build$src$core$events$utils();
            this.recordUndo = getRecordUndo$$module$build$src$core$events$utils();
        }
        toJson() {
            return {
                type: this.type,
                group: this.group
            };
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.Abstract.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            this.isBlank = !1;
            this.group = a.group || "";
        }
        static fromJson(a, b, c) {
            c.isBlank = !1;
            c.group = a.group || "";
            c.workspaceId = b.id;
            return c;
        }
        isNull() {
            return !1;
        }
        run(a) {}
        getEventWorkspace_() {
            let a;
            this.workspaceId && (a = getWorkspaceById$$module$build$src$core$common(this.workspaceId));
            if (!a) throw Error("Workspace is null. Event must have been generated from real Blockly events.");
            return a;
        }
    }, module$build$src$core$events$events_abstract = {};
    module$build$src$core$events$events_abstract.Abstract = Abstract$$module$build$src$core$events$events_abstract;
    var VarBase$$module$build$src$core$events$events_var_base = class extends Abstract$$module$build$src$core$events$events_abstract {
        constructor(a){
            super();
            this.isBlank = "undefined" === typeof a;
            a && (this.varId = a.getId(), this.workspaceId = a.workspace.id);
        }
        toJson() {
            const a = super.toJson();
            if (!this.varId) throw Error("The var ID is undefined. Either pass a variable to the constructor, or call fromJson");
            a.varId = this.varId;
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.VarBase.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.varId = a.varId;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new VarBase$$module$build$src$core$events$events_var_base);
            b.varId = a.varId;
            return b;
        }
    }, module$build$src$core$events$events_var_base = {};
    module$build$src$core$events$events_var_base.VarBase = VarBase$$module$build$src$core$events$events_var_base;
    var VarCreate$$module$build$src$core$events$events_var_create = class extends VarBase$$module$build$src$core$events$events_var_base {
        constructor(a){
            super(a);
            this.type = VAR_CREATE$$module$build$src$core$events$utils;
            a && (this.varType = a.type, this.varName = a.name);
        }
        toJson() {
            const a = super.toJson();
            if (void 0 === this.varType) throw Error("The var type is undefined. Either pass a variable to the constructor, or call fromJson");
            if (!this.varName) throw Error("The var name is undefined. Either pass a variable to the constructor, or call fromJson");
            a.varType = this.varType;
            a.varName = this.varName;
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.VarCreate.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.varType = a.varType;
            this.varName = a.varName;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new VarCreate$$module$build$src$core$events$events_var_create);
            b.varType = a.varType;
            b.varName = a.varName;
            return b;
        }
        run(a) {
            const b = this.getEventWorkspace_();
            if (!this.varId) throw Error("The var ID is undefined. Either pass a variable to the constructor, or call fromJson");
            if (!this.varName) throw Error("The var name is undefined. Either pass a variable to the constructor, or call fromJson");
            a ? b.createVariable(this.varName, this.varType, this.varId) : b.deleteVariableById(this.varId);
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, VAR_CREATE$$module$build$src$core$events$utils, VarCreate$$module$build$src$core$events$events_var_create);
    var module$build$src$core$events$events_var_create = {};
    module$build$src$core$events$events_var_create.VarCreate = VarCreate$$module$build$src$core$events$events_var_create;
    var VariableModel$$module$build$src$core$variable_model = class {
        constructor(a, b, c, d){
            this.workspace = a;
            this.name = b;
            this.type = c || "";
            this.id_ = d || genUid$$module$build$src$core$utils$idgenerator();
        }
        getId() {
            return this.id_;
        }
        static compareByName(a, b) {
            return a.name.localeCompare(b.name, void 0, {
                sensitivity: "base"
            });
        }
    }, module$build$src$core$variable_model = {};
    module$build$src$core$variable_model.VariableModel = VariableModel$$module$build$src$core$variable_model;
    var CATEGORY_NAME$$module$build$src$core$variables, VAR_LETTER_OPTIONS$$module$build$src$core$variables, TEST_ONLY$$module$build$src$core$variables;
    CATEGORY_NAME$$module$build$src$core$variables = "VARIABLE";
    VAR_LETTER_OPTIONS$$module$build$src$core$variables = "ijkmnopqrstuvwxyzabcdefgh";
    TEST_ONLY$$module$build$src$core$variables = {
        generateUniqueNameInternal: generateUniqueNameInternal$$module$build$src$core$variables
    };
    $.module$build$src$core$variables = {};
    $.module$build$src$core$variables.CATEGORY_NAME = CATEGORY_NAME$$module$build$src$core$variables;
    $.module$build$src$core$variables.TEST_ONLY = TEST_ONLY$$module$build$src$core$variables;
    $.module$build$src$core$variables.VAR_LETTER_OPTIONS = VAR_LETTER_OPTIONS$$module$build$src$core$variables;
    $.module$build$src$core$variables.allDeveloperVariables = allDeveloperVariables$$module$build$src$core$variables;
    $.module$build$src$core$variables.allUsedVarModels = allUsedVarModels$$module$build$src$core$variables;
    $.module$build$src$core$variables.createVariableButtonHandler = createVariableButtonHandler$$module$build$src$core$variables;
    $.module$build$src$core$variables.flyoutCategory = flyoutCategory$$module$build$src$core$variables;
    $.module$build$src$core$variables.flyoutCategoryBlocks = flyoutCategoryBlocks$$module$build$src$core$variables;
    $.module$build$src$core$variables.generateUniqueName = generateUniqueName$$module$build$src$core$variables;
    $.module$build$src$core$variables.generateUniqueNameFromOptions = generateUniqueNameFromOptions$$module$build$src$core$variables;
    $.module$build$src$core$variables.generateVariableFieldDom = generateVariableFieldDom$$module$build$src$core$variables;
    $.module$build$src$core$variables.getAddedVariables = getAddedVariables$$module$build$src$core$variables;
    $.module$build$src$core$variables.getOrCreateVariablePackage = getOrCreateVariablePackage$$module$build$src$core$variables;
    $.module$build$src$core$variables.getVariable = getVariable$$module$build$src$core$variables;
    $.module$build$src$core$variables.nameUsedWithAnyType = nameUsedWithAnyType$$module$build$src$core$variables;
    $.module$build$src$core$variables.nameUsedWithConflictingParam = nameUsedWithConflictingParam$$module$build$src$core$variables;
    $.module$build$src$core$variables.promptName = promptName$$module$build$src$core$variables;
    $.module$build$src$core$variables.renameVariable = renameVariable$$module$build$src$core$variables;
    var Coordinate$$module$build$src$core$utils$coordinate = class {
        constructor(a, b){
            this.x = a;
            this.y = b;
        }
        clone() {
            return new Coordinate$$module$build$src$core$utils$coordinate(this.x, this.y);
        }
        scale(a) {
            this.x *= a;
            this.y *= a;
            return this;
        }
        translate(a, b) {
            this.x += a;
            this.y += b;
            return this;
        }
        static equals(a, b) {
            return a === b ? !0 : a && b ? a.x === b.x && a.y === b.y : !1;
        }
        static distance(a, b) {
            const c = a.x - b.x;
            a = a.y - b.y;
            return Math.sqrt(c * c + a * a);
        }
        static magnitude(a) {
            return Math.sqrt(a.x * a.x + a.y * a.y);
        }
        static difference(a, b) {
            return new Coordinate$$module$build$src$core$utils$coordinate(a.x - b.x, a.y - b.y);
        }
        static sum(a, b) {
            return new Coordinate$$module$build$src$core$utils$coordinate(a.x + b.x, a.y + b.y);
        }
    }, module$build$src$core$utils$coordinate = {};
    module$build$src$core$utils$coordinate.Coordinate = Coordinate$$module$build$src$core$utils$coordinate;
    var WorkspaceComment$$module$build$src$core$workspace_comment = class {
        constructor(a, b, c, d, e){
            this.workspace = a;
            this.editable_ = this.movable_ = this.deletable_ = !0;
            this.disposed_ = !1;
            this.isComment = !0;
            this.id = e && !a.getCommentById(e) ? e : genUid$$module$build$src$core$utils$idgenerator();
            a.addTopComment(this);
            this.xy_ = new Coordinate$$module$build$src$core$utils$coordinate(0, 0);
            this.height_ = c;
            this.width_ = d;
            this.RTL = a.RTL;
            this.content_ = b;
            WorkspaceComment$$module$build$src$core$workspace_comment.fireCreateEvent(this);
        }
        dispose() {
            this.disposed_ || (isEnabled$$module$build$src$core$events$utils() && fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(COMMENT_DELETE$$module$build$src$core$events$utils))(this)), this.workspace.removeTopComment(this), this.disposed_ = !0);
        }
        getHeight() {
            return this.height_;
        }
        setHeight(a) {
            this.height_ = a;
        }
        getWidth() {
            return this.width_;
        }
        setWidth(a) {
            this.width_ = a;
        }
        getRelativeToSurfaceXY() {
            return new Coordinate$$module$build$src$core$utils$coordinate(this.xy_.x, this.xy_.y);
        }
        moveBy(a, b) {
            const c = new (get$$module$build$src$core$events$utils(COMMENT_MOVE$$module$build$src$core$events$utils))(this);
            this.xy_.translate(a, b);
            c.recordNew();
            fire$$module$build$src$core$events$utils(c);
        }
        isDeletable() {
            return this.deletable_ && !(this.workspace && this.workspace.options.readOnly);
        }
        setDeletable(a) {
            this.deletable_ = a;
        }
        isMovable() {
            return this.movable_ && !(this.workspace && this.workspace.options.readOnly);
        }
        setMovable(a) {
            this.movable_ = a;
        }
        isEditable() {
            return this.editable_ && !(this.workspace && this.workspace.options.readOnly);
        }
        setEditable(a) {
            this.editable_ = a;
        }
        getContent() {
            return this.content_;
        }
        setContent(a) {
            this.content_ !== a && (fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(COMMENT_CHANGE$$module$build$src$core$events$utils))(this, this.content_, a)), this.content_ = a);
        }
        toXmlWithXY(a) {
            a = this.toXml(a);
            a.setAttribute("x", String(Math.round(this.xy_.x)));
            a.setAttribute("y", String(Math.round(this.xy_.y)));
            a.setAttribute("h", String(this.height_));
            a.setAttribute("w", String(this.width_));
            return a;
        }
        toXml(a) {
            const b = $.createElement$$module$build$src$core$utils$xml("comment");
            a || (b.id = this.id);
            b.textContent = this.getContent();
            return b;
        }
        static fireCreateEvent(a) {
            if (isEnabled$$module$build$src$core$events$utils()) {
                const b = getGroup$$module$build$src$core$events$utils();
                b || setGroup$$module$build$src$core$events$utils(!0);
                try {
                    fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(COMMENT_CREATE$$module$build$src$core$events$utils))(a));
                } finally{
                    setGroup$$module$build$src$core$events$utils(b);
                }
            }
        }
        static fromXml(a, b) {
            var c = WorkspaceComment$$module$build$src$core$workspace_comment.parseAttributes(a);
            b = new WorkspaceComment$$module$build$src$core$workspace_comment(b, c.content, c.h, c.w, c.id);
            c = a.getAttribute("x");
            a = a.getAttribute("y");
            c = c ? parseInt(c, 10) : NaN;
            a = a ? parseInt(a, 10) : NaN;
            isNaN(c) || isNaN(a) || b.moveBy(c, a);
            WorkspaceComment$$module$build$src$core$workspace_comment.fireCreateEvent(b);
            return b;
        }
        static parseAttributes(a) {
            const b = a.getAttribute("h"), c = a.getAttribute("w"), d = a.getAttribute("x"), e = a.getAttribute("y"), f = a.getAttribute("id");
            if (!f) throw Error("No ID present in XML comment definition.");
            let g;
            return {
                id: f,
                h: b ? parseInt(b) : 100,
                w: c ? parseInt(c) : 100,
                x: d ? parseInt(d) : NaN,
                y: e ? parseInt(e) : NaN,
                content: null != (g = a.textContent) ? g : ""
            };
        }
    }, module$build$src$core$workspace_comment = {};
    module$build$src$core$workspace_comment.WorkspaceComment = WorkspaceComment$$module$build$src$core$workspace_comment;
    var UiBase$$module$build$src$core$events$events_ui_base = class extends Abstract$$module$build$src$core$events$events_abstract {
        constructor(a){
            super();
            this.isBlank = !0;
            this.recordUndo = !1;
            this.isUiEvent = !0;
            this.isBlank = "undefined" === typeof a;
            this.workspaceId = a ? a : "";
        }
    }, module$build$src$core$events$events_ui_base = {};
    module$build$src$core$events$events_ui_base.UiBase = UiBase$$module$build$src$core$events$events_ui_base;
    var Selected$$module$build$src$core$events$events_selected = class extends UiBase$$module$build$src$core$events$events_ui_base {
        constructor(a, b, c){
            super(c);
            this.type = SELECTED$$module$build$src$core$events$utils;
            this.oldElementId = null != a ? a : void 0;
            this.newElementId = null != b ? b : void 0;
        }
        toJson() {
            const a = super.toJson();
            a.oldElementId = this.oldElementId;
            a.newElementId = this.newElementId;
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.Selected.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.oldElementId = a.oldElementId;
            this.newElementId = a.newElementId;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new Selected$$module$build$src$core$events$events_selected);
            b.oldElementId = a.oldElementId;
            b.newElementId = a.newElementId;
            return b;
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, SELECTED$$module$build$src$core$events$utils, Selected$$module$build$src$core$events$events_selected);
    var module$build$src$core$events$events_selected = {};
    module$build$src$core$events$events_selected.Selected = Selected$$module$build$src$core$events$events_selected;
    var LONGPRESS$$module$build$src$core$touch = 750, TOUCH_ENABLED$$module$build$src$core$touch = "ontouchstart" in globalThis || !!(globalThis.document && document.documentElement && "ontouchstart" in document.documentElement) || !(!globalThis.navigator || !globalThis.navigator.maxTouchPoints && !globalThis.navigator.msMaxTouchPoints), touchIdentifier_$$module$build$src$core$touch = null, TOUCH_MAP$$module$build$src$core$touch = {
        mousedown: [
            "pointerdown"
        ],
        mouseenter: [
            "pointerenter"
        ],
        mouseleave: [
            "pointerleave"
        ],
        mousemove: [
            "pointermove"
        ],
        mouseout: [
            "pointerout"
        ],
        mouseover: [
            "pointerover"
        ],
        mouseup: [
            "pointerup",
            "pointercancel"
        ],
        touchend: [
            "pointerup"
        ],
        touchcancel: [
            "pointercancel"
        ]
    }, longPid_$$module$build$src$core$touch = 0, module$build$src$core$touch = {};
    module$build$src$core$touch.TOUCH_ENABLED = TOUCH_ENABLED$$module$build$src$core$touch;
    module$build$src$core$touch.TOUCH_MAP = TOUCH_MAP$$module$build$src$core$touch;
    module$build$src$core$touch.checkTouchIdentifier = checkTouchIdentifier$$module$build$src$core$touch;
    module$build$src$core$touch.clearTouchIdentifier = clearTouchIdentifier$$module$build$src$core$touch;
    module$build$src$core$touch.getTouchIdentifierFromEvent = getTouchIdentifierFromEvent$$module$build$src$core$touch;
    module$build$src$core$touch.isMouseOrTouchEvent = isMouseOrTouchEvent$$module$build$src$core$touch;
    module$build$src$core$touch.isTouchEvent = isTouchEvent$$module$build$src$core$touch;
    module$build$src$core$touch.longStart = longStart$$module$build$src$core$touch;
    module$build$src$core$touch.longStop = longStop$$module$build$src$core$touch;
    module$build$src$core$touch.setClientFromTouch = setClientFromTouch$$module$build$src$core$touch;
    module$build$src$core$touch.shouldHandleEvent = shouldHandleEvent$$module$build$src$core$touch;
    module$build$src$core$touch.splitEventByTouches = splitEventByTouches$$module$build$src$core$touch;
    var rawUserAgent$$module$build$src$core$utils$useragent, isJavaFx$$module$build$src$core$utils$useragent, isWebKit$$module$build$src$core$utils$useragent, isGecko$$module$build$src$core$utils$useragent, isAndroid$$module$build$src$core$utils$useragent, isIPad$$module$build$src$core$utils$useragent, isIPhone$$module$build$src$core$utils$useragent, isMac$$module$build$src$core$utils$useragent, isTablet$$module$build$src$core$utils$useragent, isMobile$$module$build$src$core$utils$useragent;
    (function(a) {
        function b(d) {
            return -1 !== c.indexOf(d.toUpperCase());
        }
        rawUserAgent$$module$build$src$core$utils$useragent = a;
        const c = rawUserAgent$$module$build$src$core$utils$useragent.toUpperCase();
        isJavaFx$$module$build$src$core$utils$useragent = b("JavaFX");
        isWebKit$$module$build$src$core$utils$useragent = b("WebKit");
        isGecko$$module$build$src$core$utils$useragent = b("Gecko") && !isWebKit$$module$build$src$core$utils$useragent;
        isAndroid$$module$build$src$core$utils$useragent = b("Android");
        a = globalThis.navigator && globalThis.navigator.maxTouchPoints;
        isIPad$$module$build$src$core$utils$useragent = b("iPad") || b("Macintosh") && 0 < a;
        isIPhone$$module$build$src$core$utils$useragent = b("iPhone") && !isIPad$$module$build$src$core$utils$useragent;
        isMac$$module$build$src$core$utils$useragent = b("Macintosh");
        isTablet$$module$build$src$core$utils$useragent = isIPad$$module$build$src$core$utils$useragent || isAndroid$$module$build$src$core$utils$useragent && !b("Mobile") || b("Silk");
        isMobile$$module$build$src$core$utils$useragent = !isTablet$$module$build$src$core$utils$useragent && (isIPhone$$module$build$src$core$utils$useragent || isAndroid$$module$build$src$core$utils$useragent);
    })(globalThis.navigator && globalThis.navigator.userAgent || "");
    var raw$$module$build$src$core$utils$useragent = rawUserAgent$$module$build$src$core$utils$useragent, JavaFx$$module$build$src$core$utils$useragent = isJavaFx$$module$build$src$core$utils$useragent, GECKO$$module$build$src$core$utils$useragent = isGecko$$module$build$src$core$utils$useragent, ANDROID$$module$build$src$core$utils$useragent = isAndroid$$module$build$src$core$utils$useragent, IPAD$$module$build$src$core$utils$useragent = isIPad$$module$build$src$core$utils$useragent, IPHONE$$module$build$src$core$utils$useragent = isIPhone$$module$build$src$core$utils$useragent, MAC$$module$build$src$core$utils$useragent = isMac$$module$build$src$core$utils$useragent, MOBILE$$module$build$src$core$utils$useragent = isMobile$$module$build$src$core$utils$useragent, module$build$src$core$utils$useragent = {};
    module$build$src$core$utils$useragent.ANDROID = ANDROID$$module$build$src$core$utils$useragent;
    module$build$src$core$utils$useragent.GECKO = GECKO$$module$build$src$core$utils$useragent;
    module$build$src$core$utils$useragent.IPAD = IPAD$$module$build$src$core$utils$useragent;
    module$build$src$core$utils$useragent.IPHONE = IPHONE$$module$build$src$core$utils$useragent;
    module$build$src$core$utils$useragent.JavaFx = JavaFx$$module$build$src$core$utils$useragent;
    module$build$src$core$utils$useragent.MAC = MAC$$module$build$src$core$utils$useragent;
    module$build$src$core$utils$useragent.MOBILE = MOBILE$$module$build$src$core$utils$useragent;
    module$build$src$core$utils$useragent.raw = raw$$module$build$src$core$utils$useragent;
    var LINE_MODE_MULTIPLIER$$module$build$src$core$browser_events = 40, PAGE_MODE_MULTIPLIER$$module$build$src$core$browser_events = 125, module$build$src$core$browser_events = {};
    module$build$src$core$browser_events.bind = bind$$module$build$src$core$browser_events;
    module$build$src$core$browser_events.conditionalBind = conditionalBind$$module$build$src$core$browser_events;
    module$build$src$core$browser_events.getScrollDeltaPixels = getScrollDeltaPixels$$module$build$src$core$browser_events;
    module$build$src$core$browser_events.isRightButton = isRightButton$$module$build$src$core$browser_events;
    module$build$src$core$browser_events.isTargetInput = isTargetInput$$module$build$src$core$browser_events;
    module$build$src$core$browser_events.mouseToSvg = mouseToSvg$$module$build$src$core$browser_events;
    module$build$src$core$browser_events.unbind = unbind$$module$build$src$core$browser_events;
    var injected$$module$build$src$core$css = !1, content$$module$build$src$core$css = '\n.blocklySvg {\n  background-color: #fff;\n  outline: none;\n  overflow: hidden;  /* IE overflows by default. */\n  position: absolute;\n  display: block;\n}\n\n.blocklyWidgetDiv {\n  display: none;\n  position: absolute;\n  z-index: 99999;  /* big value for bootstrap3 compatibility */\n}\n\n.injectionDiv {\n  height: 100%;\n  position: relative;\n  overflow: hidden;  /* So blocks in drag surface disappear at edges */\n  touch-action: none;\n}\n\n.blocklyNonSelectable {\n  user-select: none;\n  -ms-user-select: none;\n  -webkit-user-select: none;\n}\n\n.blocklyWsDragSurface {\n  display: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n/* Added as a separate rule with multiple classes to make it more specific\n   than a bootstrap rule that selects svg:root. See issue #1275 for context.\n*/\n.blocklyWsDragSurface.blocklyOverflowVisible {\n  overflow: visible;\n}\n\n.blocklyBlockDragSurface {\n  display: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: visible !important;\n  z-index: 50;  /* Display below toolbox, but above everything else. */\n}\n\n.blocklyBlockCanvas.blocklyCanvasTransitioning,\n.blocklyBubbleCanvas.blocklyCanvasTransitioning {\n  transition: transform .5s;\n}\n\n.blocklyTooltipDiv {\n  background-color: #ffffc7;\n  border: 1px solid #ddc;\n  box-shadow: 4px 4px 20px 1px rgba(0,0,0,.15);\n  color: #000;\n  display: none;\n  font: 9pt sans-serif;\n  opacity: .9;\n  padding: 2px;\n  position: absolute;\n  z-index: 100000;  /* big value for bootstrap3 compatibility */\n}\n\n.blocklyDropDownDiv {\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 1000;\n  display: none;\n  border: 1px solid;\n  border-color: #dadce0;\n  background-color: #fff;\n  border-radius: 2px;\n  padding: 4px;\n  box-shadow: 0 0 3px 1px rgba(0,0,0,.3);\n}\n\n.blocklyDropDownDiv.blocklyFocused {\n  box-shadow: 0 0 6px 1px rgba(0,0,0,.3);\n}\n\n.blocklyDropDownContent {\n  max-height: 300px;  /* @todo: spec for maximum height. */\n  overflow: auto;\n  overflow-x: hidden;\n  position: relative;\n}\n\n.blocklyDropDownArrow {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 16px;\n  height: 16px;\n  z-index: -1;\n  background-color: inherit;\n  border-color: inherit;\n}\n\n.blocklyDropDownButton {\n  display: inline-block;\n  float: left;\n  padding: 0;\n  margin: 4px;\n  border-radius: 4px;\n  outline: none;\n  border: 1px solid;\n  transition: box-shadow .1s;\n  cursor: pointer;\n}\n\n.blocklyArrowTop {\n  border-top: 1px solid;\n  border-left: 1px solid;\n  border-top-left-radius: 4px;\n  border-color: inherit;\n}\n\n.blocklyArrowBottom {\n  border-bottom: 1px solid;\n  border-right: 1px solid;\n  border-bottom-right-radius: 4px;\n  border-color: inherit;\n}\n\n.blocklyResizeSE {\n  cursor: se-resize;\n  fill: #aaa;\n}\n\n.blocklyResizeSW {\n  cursor: sw-resize;\n  fill: #aaa;\n}\n\n.blocklyResizeLine {\n  stroke: #515A5A;\n  stroke-width: 1;\n}\n\n.blocklyHighlightedConnectionPath {\n  fill: none;\n  stroke: #fc3;\n  stroke-width: 4px;\n}\n\n.blocklyPathLight {\n  fill: none;\n  stroke-linecap: round;\n  stroke-width: 1;\n}\n\n.blocklySelected>.blocklyPathLight {\n  display: none;\n}\n\n.blocklyDraggable {\n  cursor: grab;\n  cursor: -webkit-grab;\n}\n\n.blocklyDragging {\n  cursor: grabbing;\n  cursor: -webkit-grabbing;\n}\n\n  /* Changes cursor on mouse down. Not effective in Firefox because of\n     https://bugzilla.mozilla.org/show_bug.cgi?id=771241 */\n.blocklyDraggable:active {\n  cursor: grabbing;\n  cursor: -webkit-grabbing;\n}\n\n/* Change the cursor on the whole drag surface in case the mouse gets\n   ahead of block during a drag. This way the cursor is still a closed hand.\n  */\n.blocklyBlockDragSurface .blocklyDraggable {\n  cursor: grabbing;\n  cursor: -webkit-grabbing;\n}\n\n.blocklyDragging.blocklyDraggingDelete {\n  cursor: url("<<<PATH>>>/handdelete.cur"), auto;\n}\n\n.blocklyDragging>.blocklyPath,\n.blocklyDragging>.blocklyPathLight {\n  fill-opacity: .8;\n  stroke-opacity: .8;\n}\n\n.blocklyDragging>.blocklyPathDark {\n  display: none;\n}\n\n.blocklyDisabled>.blocklyPath {\n  fill-opacity: .5;\n  stroke-opacity: .5;\n}\n\n.blocklyDisabled>.blocklyPathLight,\n.blocklyDisabled>.blocklyPathDark {\n  display: none;\n}\n\n.blocklyInsertionMarker>.blocklyPath,\n.blocklyInsertionMarker>.blocklyPathLight,\n.blocklyInsertionMarker>.blocklyPathDark {\n  fill-opacity: .2;\n  stroke: none;\n}\n\n.blocklyMultilineText {\n  font-family: monospace;\n}\n\n.blocklyNonEditableText>text {\n  pointer-events: none;\n}\n\n.blocklyFlyout {\n  position: absolute;\n  z-index: 20;\n}\n\n.blocklyText text {\n  cursor: default;\n}\n\n/*\n  Don\'t allow users to select text.  It gets annoying when trying to\n  drag a block and selected text moves instead.\n*/\n.blocklySvg text,\n.blocklyBlockDragSurface text {\n  user-select: none;\n  -ms-user-select: none;\n  -webkit-user-select: none;\n  cursor: inherit;\n}\n\n.blocklyHidden {\n  display: none;\n}\n\n.blocklyFieldDropdown:not(.blocklyHidden) {\n  display: block;\n}\n\n.blocklyIconGroup {\n  cursor: default;\n}\n\n.blocklyIconGroup:not(:hover),\n.blocklyIconGroupReadonly {\n  opacity: .6;\n}\n\n.blocklyIconShape {\n  fill: #00f;\n  stroke: #fff;\n  stroke-width: 1px;\n}\n\n.blocklyIconSymbol {\n  fill: #fff;\n}\n\n.blocklyMinimalBody {\n  margin: 0;\n  padding: 0;\n}\n\n.blocklyHtmlInput {\n  border: none;\n  border-radius: 4px;\n  height: 100%;\n  margin: 0;\n  outline: none;\n  padding: 0;\n  width: 100%;\n  text-align: center;\n  display: block;\n  box-sizing: border-box;\n}\n\n/* Remove the increase and decrease arrows on the field number editor */\ninput.blocklyHtmlInput[type=number]::-webkit-inner-spin-button,\ninput.blocklyHtmlInput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.blocklyMainBackground {\n  stroke-width: 1;\n  stroke: #c6c6c6;  /* Equates to #ddd due to border being off-pixel. */\n}\n\n.blocklyMutatorBackground {\n  fill: #fff;\n  stroke: #ddd;\n  stroke-width: 1;\n}\n\n.blocklyFlyoutBackground {\n  fill: #ddd;\n  fill-opacity: .8;\n}\n\n.blocklyMainWorkspaceScrollbar {\n  z-index: 20;\n}\n\n.blocklyFlyoutScrollbar {\n  z-index: 30;\n}\n\n.blocklyScrollbarHorizontal,\n.blocklyScrollbarVertical {\n  position: absolute;\n  outline: none;\n}\n\n.blocklyScrollbarBackground {\n  opacity: 0;\n}\n\n.blocklyScrollbarHandle {\n  fill: #ccc;\n}\n\n.blocklyScrollbarBackground:hover+.blocklyScrollbarHandle,\n.blocklyScrollbarHandle:hover {\n  fill: #bbb;\n}\n\n/* Darken flyout scrollbars due to being on a grey background. */\n/* By contrast, workspace scrollbars are on a white background. */\n.blocklyFlyout .blocklyScrollbarHandle {\n  fill: #bbb;\n}\n\n.blocklyFlyout .blocklyScrollbarBackground:hover+.blocklyScrollbarHandle,\n.blocklyFlyout .blocklyScrollbarHandle:hover {\n  fill: #aaa;\n}\n\n.blocklyInvalidInput {\n  background: #faa;\n}\n\n.blocklyVerticalMarker {\n  stroke-width: 3px;\n  fill: rgba(255,255,255,.5);\n  pointer-events: none;\n}\n\n.blocklyComputeCanvas {\n  position: absolute;\n  width: 0;\n  height: 0;\n}\n\n.blocklyNoPointerEvents {\n  pointer-events: none;\n}\n\n.blocklyContextMenu {\n  border-radius: 4px;\n  max-height: 100%;\n}\n\n.blocklyDropdownMenu {\n  border-radius: 2px;\n  padding: 0 !important;\n}\n\n.blocklyDropdownMenu .blocklyMenuItem {\n  /* 28px on the left for icon or checkbox. */\n  padding-left: 28px;\n}\n\n/* BiDi override for the resting state. */\n.blocklyDropdownMenu .blocklyMenuItemRtl {\n  /* Flip left/right padding for BiDi. */\n  padding-left: 5px;\n  padding-right: 28px;\n}\n\n.blocklyWidgetDiv .blocklyMenu {\n  background: #fff;\n  border: 1px solid transparent;\n  box-shadow: 0 0 3px 1px rgba(0,0,0,.3);\n  font: normal 13px Arial, sans-serif;\n  margin: 0;\n  outline: none;\n  padding: 4px 0;\n  position: absolute;\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 100%;\n  z-index: 20000;  /* Arbitrary, but some apps depend on it... */\n}\n\n.blocklyWidgetDiv .blocklyMenu.blocklyFocused {\n  box-shadow: 0 0 6px 1px rgba(0,0,0,.3);\n}\n\n.blocklyDropDownDiv .blocklyMenu {\n  background: inherit;  /* Compatibility with gapi, reset from goog-menu */\n  border: inherit;  /* Compatibility with gapi, reset from goog-menu */\n  font: normal 13px "Helvetica Neue", Helvetica, sans-serif;\n  outline: none;\n  position: relative;  /* Compatibility with gapi, reset from goog-menu */\n  z-index: 20000;  /* Arbitrary, but some apps depend on it... */\n}\n\n/* State: resting. */\n.blocklyMenuItem {\n  border: none;\n  color: #000;\n  cursor: pointer;\n  list-style: none;\n  margin: 0;\n  /* 7em on the right for shortcut. */\n  min-width: 7em;\n  padding: 6px 15px;\n  white-space: nowrap;\n}\n\n/* State: disabled. */\n.blocklyMenuItemDisabled {\n  color: #ccc;\n  cursor: inherit;\n}\n\n/* State: hover. */\n.blocklyMenuItemHighlight {\n  background-color: rgba(0,0,0,.1);\n}\n\n/* State: selected/checked. */\n.blocklyMenuItemCheckbox {\n  height: 16px;\n  position: absolute;\n  width: 16px;\n}\n\n.blocklyMenuItemSelected .blocklyMenuItemCheckbox {\n  background: url(<<<PATH>>>/sprites.png) no-repeat -48px -16px;\n  float: left;\n  margin-left: -24px;\n  position: static;  /* Scroll with the menu. */\n}\n\n.blocklyMenuItemRtl .blocklyMenuItemCheckbox {\n  float: right;\n  margin-right: -24px;\n}\n', module$build$src$core$css = {};
    module$build$src$core$css.inject = inject$$module$build$src$core$css;
    module$build$src$core$css.register = register$$module$build$src$core$css;
    var Rect$$module$build$src$core$utils$rect = class {
        constructor(a, b, c, d){
            this.top = a;
            this.bottom = b;
            this.left = c;
            this.right = d;
        }
        contains(a, b) {
            return a >= this.left && a <= this.right && b >= this.top && b <= this.bottom;
        }
        intersects(a) {
            return !(this.left > a.right || this.right < a.left || this.top > a.bottom || this.bottom < a.top);
        }
    }, module$build$src$core$utils$rect = {};
    module$build$src$core$utils$rect.Rect = Rect$$module$build$src$core$utils$rect;
    var Svg$$module$build$src$core$utils$svg = class {
        constructor(a){
            this.tagName = a;
        }
        toString() {
            return this.tagName;
        }
    };
    Svg$$module$build$src$core$utils$svg.ANIMATE = new Svg$$module$build$src$core$utils$svg("animate");
    Svg$$module$build$src$core$utils$svg.CIRCLE = new Svg$$module$build$src$core$utils$svg("circle");
    Svg$$module$build$src$core$utils$svg.CLIPPATH = new Svg$$module$build$src$core$utils$svg("clipPath");
    Svg$$module$build$src$core$utils$svg.DEFS = new Svg$$module$build$src$core$utils$svg("defs");
    Svg$$module$build$src$core$utils$svg.FECOMPOSITE = new Svg$$module$build$src$core$utils$svg("feComposite");
    Svg$$module$build$src$core$utils$svg.FECOMPONENTTRANSFER = new Svg$$module$build$src$core$utils$svg("feComponentTransfer");
    Svg$$module$build$src$core$utils$svg.FEFLOOD = new Svg$$module$build$src$core$utils$svg("feFlood");
    Svg$$module$build$src$core$utils$svg.FEFUNCA = new Svg$$module$build$src$core$utils$svg("feFuncA");
    Svg$$module$build$src$core$utils$svg.FEGAUSSIANBLUR = new Svg$$module$build$src$core$utils$svg("feGaussianBlur");
    Svg$$module$build$src$core$utils$svg.FEPOINTLIGHT = new Svg$$module$build$src$core$utils$svg("fePointLight");
    Svg$$module$build$src$core$utils$svg.FESPECULARLIGHTING = new Svg$$module$build$src$core$utils$svg("feSpecularLighting");
    Svg$$module$build$src$core$utils$svg.FILTER = new Svg$$module$build$src$core$utils$svg("filter");
    Svg$$module$build$src$core$utils$svg.FOREIGNOBJECT = new Svg$$module$build$src$core$utils$svg("foreignObject");
    Svg$$module$build$src$core$utils$svg.G = new Svg$$module$build$src$core$utils$svg("g");
    Svg$$module$build$src$core$utils$svg.IMAGE = new Svg$$module$build$src$core$utils$svg("image");
    Svg$$module$build$src$core$utils$svg.LINE = new Svg$$module$build$src$core$utils$svg("line");
    Svg$$module$build$src$core$utils$svg.PATH = new Svg$$module$build$src$core$utils$svg("path");
    Svg$$module$build$src$core$utils$svg.PATTERN = new Svg$$module$build$src$core$utils$svg("pattern");
    Svg$$module$build$src$core$utils$svg.POLYGON = new Svg$$module$build$src$core$utils$svg("polygon");
    Svg$$module$build$src$core$utils$svg.RECT = new Svg$$module$build$src$core$utils$svg("rect");
    Svg$$module$build$src$core$utils$svg.SVG = new Svg$$module$build$src$core$utils$svg("svg");
    Svg$$module$build$src$core$utils$svg.TEXT = new Svg$$module$build$src$core$utils$svg("text");
    Svg$$module$build$src$core$utils$svg.TSPAN = new Svg$$module$build$src$core$utils$svg("tspan");
    var module$build$src$core$utils$svg = {};
    module$build$src$core$utils$svg.Svg = Svg$$module$build$src$core$utils$svg;
    var TEST_ONLY$$module$build$src$core$utils$style = {
        getSizeInternal: getSizeInternal$$module$build$src$core$utils$style
    }, module$build$src$core$utils$style = {};
    module$build$src$core$utils$style.TEST_ONLY = TEST_ONLY$$module$build$src$core$utils$style;
    module$build$src$core$utils$style.getBorderBox = getBorderBox$$module$build$src$core$utils$style;
    module$build$src$core$utils$style.getCascadedStyle = getCascadedStyle$$module$build$src$core$utils$style;
    module$build$src$core$utils$style.getComputedStyle = getComputedStyle$$module$build$src$core$utils$style;
    module$build$src$core$utils$style.getContainerOffsetToScrollInto = getContainerOffsetToScrollInto$$module$build$src$core$utils$style;
    module$build$src$core$utils$style.getPageOffset = getPageOffset$$module$build$src$core$utils$style;
    module$build$src$core$utils$style.getSize = getSize$$module$build$src$core$utils$style;
    module$build$src$core$utils$style.getViewportPageOffset = getViewportPageOffset$$module$build$src$core$utils$style;
    module$build$src$core$utils$style.scrollIntoContainerView = scrollIntoContainerView$$module$build$src$core$utils$style;
    var XY_REGEX$$module$build$src$core$utils$svg_math = /translate\(\s*([-+\d.e]+)([ ,]\s*([-+\d.e]+)\s*)?/, XY_STYLE_REGEX$$module$build$src$core$utils$svg_math = /transform:\s*translate(?:3d)?\(\s*([-+\d.e]+)\s*px([ ,]\s*([-+\d.e]+)\s*px)?/, TEST_ONLY$$module$build$src$core$utils$svg_math = {
        XY_REGEX: XY_REGEX$$module$build$src$core$utils$svg_math,
        XY_STYLE_REGEX: XY_STYLE_REGEX$$module$build$src$core$utils$svg_math
    }, module$build$src$core$utils$svg_math = {};
    module$build$src$core$utils$svg_math.TEST_ONLY = TEST_ONLY$$module$build$src$core$utils$svg_math;
    module$build$src$core$utils$svg_math.getDocumentScroll = getDocumentScroll$$module$build$src$core$utils$svg_math;
    module$build$src$core$utils$svg_math.getInjectionDivXY = getInjectionDivXY$$module$build$src$core$utils$svg_math;
    module$build$src$core$utils$svg_math.getRelativeXY = getRelativeXY$$module$build$src$core$utils$svg_math;
    module$build$src$core$utils$svg_math.getViewportBBox = getViewportBBox$$module$build$src$core$utils$svg_math;
    module$build$src$core$utils$svg_math.is3dSupported = is3dSupported$$module$build$src$core$utils$svg_math;
    module$build$src$core$utils$svg_math.screenToWsCoordinates = screenToWsCoordinates$$module$build$src$core$utils$svg_math;
    var RESIZE_SIZE$$module$build$src$core$workspace_comment_svg = 8, BORDER_RADIUS$$module$build$src$core$workspace_comment_svg = 3, TEXTAREA_OFFSET$$module$build$src$core$workspace_comment_svg = 2, WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg = class extends WorkspaceComment$$module$build$src$core$workspace_comment {
        constructor(a, b, c, d, e){
            super(a, b, c, d, e);
            this.onMouseMoveWrapper_ = this.onMouseUpWrapper_ = null;
            this.eventsInit_ = !1;
            this.deleteIconBorder_ = this.deleteGroup_ = this.resizeGroup_ = this.foreignObject_ = this.svgHandleTarget_ = this.svgRectTarget_ = this.textarea_ = null;
            this.rendered_ = this.autoLayout_ = this.focused_ = !1;
            this.svgGroup_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {
                "class": "blocklyComment"
            });
            this.workspace = a;
            this.svgRect_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                "class": "blocklyCommentRect",
                x: 0,
                y: 0,
                rx: BORDER_RADIUS$$module$build$src$core$workspace_comment_svg,
                ry: BORDER_RADIUS$$module$build$src$core$workspace_comment_svg
            });
            this.svgGroup_.appendChild(this.svgRect_);
            this.useDragSurface_ = !!a.getBlockDragSurface();
            this.render();
        }
        dispose() {
            this.disposed_ || (getSelected$$module$build$src$core$common() === this && (this.unselect(), this.workspace.cancelCurrentGesture()), isEnabled$$module$build$src$core$events$utils() && fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(COMMENT_DELETE$$module$build$src$core$events$utils))(this)), removeNode$$module$build$src$core$utils$dom(this.svgGroup_), this.disposeInternal_(), disable$$module$build$src$core$events$utils(), super.dispose(), enable$$module$build$src$core$events$utils());
        }
        initSvg(a) {
            if (!this.workspace.rendered) throw TypeError("Workspace is headless.");
            this.workspace.options.readOnly || this.eventsInit_ || (conditionalBind$$module$build$src$core$browser_events(this.svgRectTarget_, "pointerdown", this, this.pathMouseDown_), conditionalBind$$module$build$src$core$browser_events(this.svgHandleTarget_, "pointerdown", this, this.pathMouseDown_));
            this.eventsInit_ = !0;
            this.updateMovable();
            this.getSvgRoot().parentNode || this.workspace.getBubbleCanvas().appendChild(this.getSvgRoot());
            !a && this.textarea_ && this.textarea_.select();
        }
        pathMouseDown_(a) {
            const b = this.workspace.getGesture(a);
            b && b.handleBubbleStart(a, this);
        }
        showContextMenu(a) {
            throw Error("The implementation of showContextMenu should be monkey-patched in by blockly.ts");
        }
        select() {
            if (getSelected$$module$build$src$core$common() !== this) {
                var a = null;
                if (getSelected$$module$build$src$core$common()) {
                    a = getSelected$$module$build$src$core$common().id;
                    disable$$module$build$src$core$events$utils();
                    try {
                        getSelected$$module$build$src$core$common().unselect();
                    } finally{
                        enable$$module$build$src$core$events$utils();
                    }
                }
                a = new (get$$module$build$src$core$events$utils(SELECTED$$module$build$src$core$events$utils))(a, this.id, this.workspace.id);
                fire$$module$build$src$core$events$utils(a);
                setSelected$$module$build$src$core$common(this);
                this.addSelect();
            }
        }
        unselect() {
            if (getSelected$$module$build$src$core$common() === this) {
                var a = new (get$$module$build$src$core$events$utils(SELECTED$$module$build$src$core$events$utils))(this.id, null, this.workspace.id);
                fire$$module$build$src$core$events$utils(a);
                setSelected$$module$build$src$core$common(null);
                this.removeSelect();
                this.blurFocus();
            }
        }
        addSelect() {
            addClass$$module$build$src$core$utils$dom(this.svgGroup_, "blocklySelected");
            this.setFocus();
        }
        removeSelect() {
            addClass$$module$build$src$core$utils$dom(this.svgGroup_, "blocklySelected");
            this.blurFocus();
        }
        addFocus() {
            addClass$$module$build$src$core$utils$dom(this.svgGroup_, "blocklyFocused");
        }
        removeFocus() {
            removeClass$$module$build$src$core$utils$dom(this.svgGroup_, "blocklyFocused");
        }
        getRelativeToSurfaceXY() {
            let a = 0, b = 0;
            const c = this.useDragSurface_ ? this.workspace.getBlockDragSurface().getGroup() : null;
            let d = this.getSvgRoot();
            if (d) do {
                var e = getRelativeXY$$module$build$src$core$utils$svg_math(d);
                a += e.x;
                b += e.y;
                this.useDragSurface_ && this.workspace.getBlockDragSurface().getCurrentBlock() === d && (e = this.workspace.getBlockDragSurface().getSurfaceTranslation(), a += e.x, b += e.y);
                d = d.parentNode;
            }while (d && d !== this.workspace.getBubbleCanvas() && d !== c);
            return this.xy_ = new Coordinate$$module$build$src$core$utils$coordinate(a, b);
        }
        moveBy(a, b) {
            const c = new (get$$module$build$src$core$events$utils(COMMENT_MOVE$$module$build$src$core$events$utils))(this), d = this.getRelativeToSurfaceXY();
            this.translate(d.x + a, d.y + b);
            this.xy_ = new Coordinate$$module$build$src$core$utils$coordinate(d.x + a, d.y + b);
            c.recordNew();
            fire$$module$build$src$core$events$utils(c);
            this.workspace.resizeContents();
        }
        translate(a, b) {
            this.xy_ = new Coordinate$$module$build$src$core$utils$coordinate(a, b);
            this.getSvgRoot().setAttribute("transform", "translate(" + a + "," + b + ")");
        }
        moveToDragSurface() {
            if (this.useDragSurface_) {
                var a = this.getRelativeToSurfaceXY();
                this.clearTransformAttributes_();
                this.workspace.getBlockDragSurface().translateSurface(a.x, a.y);
                this.workspace.getBlockDragSurface().setBlocksAndShow(this.getSvgRoot());
            }
        }
        moveDuringDrag(a, b) {
            a ? a.translateSurface(b.x, b.y) : (a = `translate(${b.x}, ${b.y})`, this.getSvgRoot().setAttribute("transform", a));
        }
        moveTo(a, b) {
            this.translate(a, b);
        }
        clearTransformAttributes_() {
            this.getSvgRoot().removeAttribute("transform");
        }
        getBoundingRectangle() {
            var a = this.getRelativeToSurfaceXY();
            const b = this.getHeightWidth(), c = a.y, d = a.y + b.height;
            let e;
            this.RTL ? (e = a.x - b.width, a = a.x) : (e = a.x, a = a.x + b.width);
            return new Rect$$module$build$src$core$utils$rect(c, d, e, a);
        }
        updateMovable() {
            this.isMovable() ? addClass$$module$build$src$core$utils$dom(this.svgGroup_, "blocklyDraggable") : removeClass$$module$build$src$core$utils$dom(this.svgGroup_, "blocklyDraggable");
        }
        setMovable(a) {
            super.setMovable(a);
            this.updateMovable();
        }
        setEditable(a) {
            super.setEditable(a);
            this.textarea_ && (this.textarea_.readOnly = !a);
        }
        setDragging(a) {
            a ? addClass$$module$build$src$core$utils$dom(this.getSvgRoot(), "blocklyDragging") : removeClass$$module$build$src$core$utils$dom(this.getSvgRoot(), "blocklyDragging");
        }
        getSvgRoot() {
            return this.svgGroup_;
        }
        getContent() {
            return this.textarea_ ? this.textarea_.value : this.content_;
        }
        setContent(a) {
            super.setContent(a);
            this.textarea_ && (this.textarea_.value = a);
        }
        setDeleteStyle(a) {
            a ? addClass$$module$build$src$core$utils$dom(this.svgGroup_, "blocklyDraggingDelete") : removeClass$$module$build$src$core$utils$dom(this.svgGroup_, "blocklyDraggingDelete");
        }
        setAutoLayout(a) {}
        toXmlWithXY(a) {
            let b = 0;
            this.workspace.RTL && (b = this.workspace.getWidth());
            a = this.toXml(a);
            const c = this.getRelativeToSurfaceXY();
            a.setAttribute("x", String(Math.round(this.workspace.RTL ? b - c.x : c.x)));
            a.setAttribute("y", String(Math.round(c.y)));
            a.setAttribute("h", String(this.getHeight()));
            a.setAttribute("w", String(this.getWidth()));
            return a;
        }
        toCopyData() {
            return {
                saveInfo: this.toXmlWithXY(),
                source: this.workspace,
                typeCounts: null
            };
        }
        getHeightWidth() {
            return {
                width: this.getWidth(),
                height: this.getHeight()
            };
        }
        render() {
            if (!this.rendered_) {
                var a = this.getHeightWidth(), b = this.createEditor_();
                this.svgGroup_.appendChild(b);
                this.svgHandleTarget_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                    "class": "blocklyCommentHandleTarget",
                    x: 0,
                    y: 0
                });
                this.svgGroup_.appendChild(this.svgHandleTarget_);
                this.svgRectTarget_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                    "class": "blocklyCommentTarget",
                    x: 0,
                    y: 0,
                    rx: BORDER_RADIUS$$module$build$src$core$workspace_comment_svg,
                    ry: BORDER_RADIUS$$module$build$src$core$workspace_comment_svg
                });
                this.svgGroup_.appendChild(this.svgRectTarget_);
                this.addResizeDom_();
                this.isDeletable() && this.addDeleteDom_();
                this.setSize_(a.width, a.height);
                this.textarea_.value = this.content_;
                this.rendered_ = !0;
                this.resizeGroup_ && conditionalBind$$module$build$src$core$browser_events(this.resizeGroup_, "pointerdown", this, this.resizeMouseDown_);
                this.isDeletable() && (conditionalBind$$module$build$src$core$browser_events(this.deleteGroup_, "pointerdown", this, this.deleteMouseDown_), conditionalBind$$module$build$src$core$browser_events(this.deleteGroup_, "pointerout", this, this.deleteMouseOut_), conditionalBind$$module$build$src$core$browser_events(this.deleteGroup_, "pointerup", this, this.deleteMouseUp_));
            }
        }
        createEditor_() {
            this.foreignObject_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FOREIGNOBJECT, {
                x: 0,
                y: WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg.TOP_OFFSET,
                "class": "blocklyCommentForeignObject"
            });
            const a = document.createElementNS(HTML_NS$$module$build$src$core$utils$dom, "body");
            a.setAttribute("xmlns", HTML_NS$$module$build$src$core$utils$dom);
            a.className = "blocklyMinimalBody";
            const b = document.createElementNS(HTML_NS$$module$build$src$core$utils$dom, "textarea");
            b.className = "blocklyCommentTextarea";
            b.setAttribute("dir", this.RTL ? "RTL" : "LTR");
            b.readOnly = !this.isEditable();
            a.appendChild(b);
            this.textarea_ = b;
            this.foreignObject_.appendChild(a);
            conditionalBind$$module$build$src$core$browser_events(b, "wheel", this, function(c) {
                c.stopPropagation();
            });
            conditionalBind$$module$build$src$core$browser_events(b, "change", this, function(c) {
                this.setContent(b.value);
            });
            return this.foreignObject_;
        }
        addResizeDom_() {
            this.resizeGroup_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {
                "class": this.RTL ? "blocklyResizeSW" : "blocklyResizeSE"
            }, this.svgGroup_);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.POLYGON, {
                points: `0,${RESIZE_SIZE$$module$build$src$core$workspace_comment_svg} ${RESIZE_SIZE$$module$build$src$core$workspace_comment_svg},${RESIZE_SIZE$$module$build$src$core$workspace_comment_svg} ${RESIZE_SIZE$$module$build$src$core$workspace_comment_svg},0`
            }, this.resizeGroup_);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.LINE, {
                "class": "blocklyResizeLine",
                x1: RESIZE_SIZE$$module$build$src$core$workspace_comment_svg / 3,
                y1: RESIZE_SIZE$$module$build$src$core$workspace_comment_svg - 1,
                x2: RESIZE_SIZE$$module$build$src$core$workspace_comment_svg - 1,
                y2: RESIZE_SIZE$$module$build$src$core$workspace_comment_svg / 3
            }, this.resizeGroup_);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.LINE, {
                "class": "blocklyResizeLine",
                x1: 2 * RESIZE_SIZE$$module$build$src$core$workspace_comment_svg / 3,
                y1: RESIZE_SIZE$$module$build$src$core$workspace_comment_svg - 1,
                x2: RESIZE_SIZE$$module$build$src$core$workspace_comment_svg - 1,
                y2: 2 * RESIZE_SIZE$$module$build$src$core$workspace_comment_svg / 3
            }, this.resizeGroup_);
        }
        addDeleteDom_() {
            this.deleteGroup_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {
                "class": "blocklyCommentDeleteIcon"
            }, this.svgGroup_);
            this.deleteIconBorder_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.CIRCLE, {
                "class": "blocklyDeleteIconShape",
                r: "7",
                cx: "7.5",
                cy: "7.5"
            }, this.deleteGroup_);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.LINE, {
                x1: "5",
                y1: "10",
                x2: "10",
                y2: "5",
                stroke: "#fff",
                "stroke-width": "2"
            }, this.deleteGroup_);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.LINE, {
                x1: "5",
                y1: "5",
                x2: "10",
                y2: "10",
                stroke: "#fff",
                "stroke-width": "2"
            }, this.deleteGroup_);
        }
        resizeMouseDown_(a) {
            this.unbindDragEvents_();
            isRightButton$$module$build$src$core$browser_events(a) || (this.workspace.startDrag(a, new Coordinate$$module$build$src$core$utils$coordinate(this.workspace.RTL ? -this.width_ : this.width_, this.height_)), this.onMouseUpWrapper_ = conditionalBind$$module$build$src$core$browser_events(document, "pointerup", this, this.resizeMouseUp_), this.onMouseMoveWrapper_ = conditionalBind$$module$build$src$core$browser_events(document, "pointermove", this, this.resizeMouseMove_), this.workspace.hideChaff());
            a.stopPropagation();
        }
        deleteMouseDown_(a) {
            this.deleteIconBorder_ && addClass$$module$build$src$core$utils$dom(this.deleteIconBorder_, "blocklyDeleteIconHighlighted");
            a.stopPropagation();
        }
        deleteMouseOut_(a) {
            this.deleteIconBorder_ && removeClass$$module$build$src$core$utils$dom(this.deleteIconBorder_, "blocklyDeleteIconHighlighted");
        }
        deleteMouseUp_(a) {
            this.dispose();
            a.stopPropagation();
        }
        unbindDragEvents_() {
            this.onMouseUpWrapper_ && (unbind$$module$build$src$core$browser_events(this.onMouseUpWrapper_), this.onMouseUpWrapper_ = null);
            this.onMouseMoveWrapper_ && (unbind$$module$build$src$core$browser_events(this.onMouseMoveWrapper_), this.onMouseMoveWrapper_ = null);
        }
        resizeMouseUp_(a) {
            clearTouchIdentifier$$module$build$src$core$touch();
            this.unbindDragEvents_();
        }
        resizeMouseMove_(a) {
            this.autoLayout_ = !1;
            a = this.workspace.moveDrag(a);
            this.setSize_(this.RTL ? -a.x : a.x, a.y);
        }
        resizeComment_() {
            const a = this.getHeightWidth(), b = WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg.TOP_OFFSET, c = 2 * TEXTAREA_OFFSET$$module$build$src$core$workspace_comment_svg;
            let d;
            null == (d = this.foreignObject_) || d.setAttribute("width", String(a.width));
            let e;
            null == (e = this.foreignObject_) || e.setAttribute("height", String(a.height - b));
            if (this.RTL) {
                let f;
                null == (f = this.foreignObject_) || f.setAttribute("x", String(-a.width));
            }
            this.textarea_ && (this.textarea_.style.width = a.width - c + "px", this.textarea_.style.height = a.height - c - b + "px");
        }
        setSize_(a, b) {
            a = Math.max(a, 45);
            b = Math.max(b, 20 + WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg.TOP_OFFSET);
            this.width_ = a;
            this.height_ = b;
            this.svgRect_.setAttribute("width", `${a}`);
            this.svgRect_.setAttribute("height", `${b}`);
            let c;
            null == (c = this.svgRectTarget_) || c.setAttribute("width", `${a}`);
            let d;
            null == (d = this.svgRectTarget_) || d.setAttribute("height", `${b}`);
            let e;
            null == (e = this.svgHandleTarget_) || e.setAttribute("width", `${a}`);
            let f;
            null == (f = this.svgHandleTarget_) || f.setAttribute("height", String(WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg.TOP_OFFSET));
            if (this.RTL) {
                this.svgRect_.setAttribute("transform", "scale(-1 1)");
                let g;
                null == (g = this.svgRectTarget_) || g.setAttribute("transform", "scale(-1 1)");
            }
            if (this.resizeGroup_) {
                if (this.RTL) {
                    this.resizeGroup_.setAttribute("transform", "translate(" + (-a + RESIZE_SIZE$$module$build$src$core$workspace_comment_svg) + "," + (b - RESIZE_SIZE$$module$build$src$core$workspace_comment_svg) + ") scale(-1 1)");
                    let g;
                    null == (g = this.deleteGroup_) || g.setAttribute("transform", "translate(" + (-a + RESIZE_SIZE$$module$build$src$core$workspace_comment_svg) + "," + -RESIZE_SIZE$$module$build$src$core$workspace_comment_svg + ") scale(-1 1)");
                } else {
                    this.resizeGroup_.setAttribute("transform", "translate(" + (a - RESIZE_SIZE$$module$build$src$core$workspace_comment_svg) + "," + (b - RESIZE_SIZE$$module$build$src$core$workspace_comment_svg) + ")");
                    let g;
                    null == (g = this.deleteGroup_) || g.setAttribute("transform", "translate(" + (a - RESIZE_SIZE$$module$build$src$core$workspace_comment_svg) + "," + -RESIZE_SIZE$$module$build$src$core$workspace_comment_svg + ")");
                }
            }
            this.resizeComment_();
        }
        disposeInternal_() {
            this.svgHandleTarget_ = this.svgRectTarget_ = this.foreignObject_ = this.textarea_ = null;
            this.disposed_ = !0;
        }
        setFocus() {
            this.focused_ = !0;
            setTimeout(()=>{
                this.disposed_ || (this.textarea_.focus(), this.addFocus(), this.svgRectTarget_ && addClass$$module$build$src$core$utils$dom(this.svgRectTarget_, "blocklyCommentTargetFocused"), this.svgHandleTarget_ && addClass$$module$build$src$core$utils$dom(this.svgHandleTarget_, "blocklyCommentHandleTargetFocused"));
            }, 0);
        }
        blurFocus() {
            this.focused_ = !1;
            setTimeout(()=>{
                this.disposed_ || (this.textarea_.blur(), this.removeFocus(), this.svgRectTarget_ && removeClass$$module$build$src$core$utils$dom(this.svgRectTarget_, "blocklyCommentTargetFocused"), this.svgHandleTarget_ && removeClass$$module$build$src$core$utils$dom(this.svgHandleTarget_, "blocklyCommentHandleTargetFocused"));
            }, 0);
        }
        static fromXmlRendered(a, b, c) {
            disable$$module$build$src$core$events$utils();
            let d;
            try {
                const e = WorkspaceComment$$module$build$src$core$workspace_comment.parseAttributes(a);
                d = new WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg(b, e.content, e.h, e.w, e.id);
                b.rendered && (d.initSvg(!0), d.render());
                if (!isNaN(e.x) && !isNaN(e.y)) {
                    if (b.RTL) {
                        const f = c || b.getWidth();
                        d.moveBy(f - e.x, e.y);
                    } else d.moveBy(e.x, e.y);
                }
            } finally{
                enable$$module$build$src$core$events$utils();
            }
            WorkspaceComment$$module$build$src$core$workspace_comment.fireCreateEvent(d);
            return d;
        }
    };
    WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg.DEFAULT_SIZE = 100;
    WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg.TOP_OFFSET = 10;
    register$$module$build$src$core$css("\n.blocklyCommentForeignObject {\n  position: relative;\n  z-index: 0;\n}\n\n.blocklyCommentRect {\n  fill: #E7DE8E;\n  stroke: #bcA903;\n  stroke-width: 1px;\n}\n\n.blocklyCommentTarget {\n  fill: transparent;\n  stroke: #bcA903;\n}\n\n.blocklyCommentTargetFocused {\n  fill: none;\n}\n\n.blocklyCommentHandleTarget {\n  fill: none;\n}\n\n.blocklyCommentHandleTargetFocused {\n  fill: transparent;\n}\n\n.blocklyFocused>.blocklyCommentRect {\n  fill: #B9B272;\n  stroke: #B9B272;\n}\n\n.blocklySelected>.blocklyCommentTarget {\n  stroke: #fc3;\n  stroke-width: 3px;\n}\n\n.blocklyCommentDeleteIcon {\n  cursor: pointer;\n  fill: #000;\n  display: none;\n}\n\n.blocklySelected > .blocklyCommentDeleteIcon {\n  display: block;\n}\n\n.blocklyDeleteIconShape {\n  fill: #000;\n  stroke: #000;\n  stroke-width: 1px;\n}\n\n.blocklyDeleteIconShape.blocklyDeleteIconHighlighted {\n  stroke: #fc3;\n}\n");
    var module$build$src$core$workspace_comment_svg = {};
    module$build$src$core$workspace_comment_svg.WorkspaceCommentSvg = WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg;
    $.module$build$src$core$xml = {};
    $.module$build$src$core$xml.appendDomToWorkspace = appendDomToWorkspace$$module$build$src$core$xml;
    $.module$build$src$core$xml.blockToDom = blockToDom$$module$build$src$core$xml;
    $.module$build$src$core$xml.blockToDomWithXY = blockToDomWithXY$$module$build$src$core$xml;
    $.module$build$src$core$xml.clearWorkspaceAndLoadFromXml = clearWorkspaceAndLoadFromXml$$module$build$src$core$xml;
    $.module$build$src$core$xml.deleteNext = deleteNext$$module$build$src$core$xml;
    $.module$build$src$core$xml.domToBlock = domToBlock$$module$build$src$core$xml;
    $.module$build$src$core$xml.domToPrettyText = domToPrettyText$$module$build$src$core$xml;
    $.module$build$src$core$xml.domToText = domToText$$module$build$src$core$xml;
    $.module$build$src$core$xml.domToVariables = domToVariables$$module$build$src$core$xml;
    $.module$build$src$core$xml.domToWorkspace = domToWorkspace$$module$build$src$core$xml;
    $.module$build$src$core$xml.textToDom = textToDom$$module$build$src$core$xml;
    $.module$build$src$core$xml.variablesToDom = variablesToDom$$module$build$src$core$xml;
    $.module$build$src$core$xml.workspaceToDom = workspaceToDom$$module$build$src$core$xml;
    var DeserializationError$$module$build$src$core$serialization$exceptions = class extends Error {
    }, MissingBlockType$$module$build$src$core$serialization$exceptions = class extends DeserializationError$$module$build$src$core$serialization$exceptions {
        constructor(a){
            super("Expected to find a 'type' property, defining the block type");
            this.state = a;
        }
    }, MissingConnection$$module$build$src$core$serialization$exceptions = class extends DeserializationError$$module$build$src$core$serialization$exceptions {
        constructor(a, b, c){
            super(`The block ${b.toDevString()} is missing a(n) ${a}
connection`);
            this.block = b;
            this.state = c;
        }
    }, BadConnectionCheck$$module$build$src$core$serialization$exceptions = class extends DeserializationError$$module$build$src$core$serialization$exceptions {
        constructor(a, b, c, d){
            super(`The block ${c.toDevString()} could not connect its
${b} to its parent, because: ${a}`);
            this.childBlock = c;
            this.childState = d;
        }
    }, RealChildOfShadow$$module$build$src$core$serialization$exceptions = class extends DeserializationError$$module$build$src$core$serialization$exceptions {
        constructor(a){
            super("Encountered a real block which is defined as a child of a shadow\nblock. It is an invariant of Blockly that shadow blocks only have shadow\nchildren");
            this.state = a;
        }
    }, module$build$src$core$serialization$exceptions = {};
    module$build$src$core$serialization$exceptions.BadConnectionCheck = BadConnectionCheck$$module$build$src$core$serialization$exceptions;
    module$build$src$core$serialization$exceptions.DeserializationError = DeserializationError$$module$build$src$core$serialization$exceptions;
    module$build$src$core$serialization$exceptions.MissingBlockType = MissingBlockType$$module$build$src$core$serialization$exceptions;
    module$build$src$core$serialization$exceptions.MissingConnection = MissingConnection$$module$build$src$core$serialization$exceptions;
    module$build$src$core$serialization$exceptions.RealChildOfShadow = RealChildOfShadow$$module$build$src$core$serialization$exceptions;
    var VARIABLES$$module$build$src$core$serialization$priorities = 100, PROCEDURES$$module$build$src$core$serialization$priorities = 75, BLOCKS$$module$build$src$core$serialization$priorities = 50, module$build$src$core$serialization$priorities = {};
    module$build$src$core$serialization$priorities.BLOCKS = BLOCKS$$module$build$src$core$serialization$priorities;
    module$build$src$core$serialization$priorities.PROCEDURES = PROCEDURES$$module$build$src$core$serialization$priorities;
    module$build$src$core$serialization$priorities.VARIABLES = VARIABLES$$module$build$src$core$serialization$priorities;
    var module$build$src$core$serialization$registry = {};
    module$build$src$core$serialization$registry.register = register$$module$build$src$core$serialization$registry;
    module$build$src$core$serialization$registry.unregister = unregister$$module$build$src$core$serialization$registry;
    var saveBlock$$module$build$src$core$serialization$blocks = save$$module$build$src$core$serialization$blocks, BlockSerializer$$module$build$src$core$serialization$blocks = class {
        constructor(){
            this.priority = BLOCKS$$module$build$src$core$serialization$priorities;
        }
        save(a) {
            const b = [];
            for (const c of a.getTopBlocks(!1))(a = save$$module$build$src$core$serialization$blocks(c, {
                addCoordinates: !0,
                doFullSerialization: !1
            })) && b.push(a);
            return b.length ? {
                languageVersion: 0,
                blocks: b
            } : null;
        }
        load(a, b) {
            a = a.blocks;
            for (const c of a)append$$module$build$src$core$serialization$blocks(c, b, {
                recordUndo: getRecordUndo$$module$build$src$core$events$utils()
            });
        }
        clear(a) {
            for (const b of a.getTopBlocks(!1))b.dispose(!1);
        }
    };
    register$$module$build$src$core$serialization$registry("blocks", new BlockSerializer$$module$build$src$core$serialization$blocks);
    var module$build$src$core$serialization$blocks = {};
    module$build$src$core$serialization$blocks.BlockSerializer = BlockSerializer$$module$build$src$core$serialization$blocks;
    module$build$src$core$serialization$blocks.append = append$$module$build$src$core$serialization$blocks;
    module$build$src$core$serialization$blocks.appendInternal = appendInternal$$module$build$src$core$serialization$blocks;
    module$build$src$core$serialization$blocks.save = save$$module$build$src$core$serialization$blocks;
    var BlockBase$$module$build$src$core$events$events_block_base = class extends Abstract$$module$build$src$core$events$events_abstract {
        constructor(a){
            super();
            this.isBlank = !a;
            a && (this.blockId = a.id, this.workspaceId = a.workspace.id);
        }
        toJson() {
            const a = super.toJson();
            if (!this.blockId) throw Error("The block ID is undefined. Either pass a block to the constructor, or call fromJson");
            a.blockId = this.blockId;
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.BlockBase.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.blockId = a.blockId;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new BlockBase$$module$build$src$core$events$events_block_base);
            b.blockId = a.blockId;
            return b;
        }
    }, module$build$src$core$events$events_block_base = {};
    module$build$src$core$events$events_block_base.BlockBase = BlockBase$$module$build$src$core$events$events_block_base;
    var BlockCreate$$module$build$src$core$events$events_block_create = class extends BlockBase$$module$build$src$core$events$events_block_base {
        constructor(a){
            super(a);
            this.type = CREATE$$module$build$src$core$events$utils;
            a && (a.isShadow() && (this.recordUndo = !1), this.xml = blockToDomWithXY$$module$build$src$core$xml(a), this.ids = getDescendantIds$$module$build$src$core$events$utils(a), this.json = save$$module$build$src$core$serialization$blocks(a, {
                addCoordinates: !0
            }));
        }
        toJson() {
            const a = super.toJson();
            if (!this.xml) throw Error("The block XML is undefined. Either pass a block to the constructor, or call fromJson");
            if (!this.ids) throw Error("The block IDs are undefined. Either pass a block to the constructor, or call fromJson");
            if (!this.json) throw Error("The block JSON is undefined. Either pass a block to the constructor, or call fromJson");
            a.xml = domToText$$module$build$src$core$xml(this.xml);
            a.ids = this.ids;
            a.json = this.json;
            this.recordUndo || (a.recordUndo = this.recordUndo);
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.BlockCreate.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.xml = textToDom$$module$build$src$core$utils$xml(a.xml);
            this.ids = a.ids;
            this.json = a.json;
            void 0 !== a.recordUndo && (this.recordUndo = a.recordUndo);
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new BlockCreate$$module$build$src$core$events$events_block_create);
            b.xml = textToDom$$module$build$src$core$utils$xml(a.xml);
            b.ids = a.ids;
            b.json = a.json;
            void 0 !== a.recordUndo && (b.recordUndo = a.recordUndo);
            return b;
        }
        run(a) {
            const b = this.getEventWorkspace_();
            if (!this.json) throw Error("The block JSON is undefined. Either pass a block to the constructor, or call fromJson");
            if (!this.ids) throw Error("The block IDs are undefined. Either pass a block to the constructor, or call fromJson");
            if (a) append$$module$build$src$core$serialization$blocks(this.json, b);
            else for(a = 0; a < this.ids.length; a++){
                const c = this.ids[a], d = b.getBlockById(c);
                d ? d.dispose(!1) : c === this.blockId && console.warn("Can't uncreate non-existent block: " + c);
            }
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, CREATE$$module$build$src$core$events$utils, BlockCreate$$module$build$src$core$events$events_block_create);
    var module$build$src$core$events$events_block_create = {};
    module$build$src$core$events$events_block_create.BlockCreate = BlockCreate$$module$build$src$core$events$events_block_create;
    var FinishedLoading$$module$build$src$core$events$workspace_events = class extends Abstract$$module$build$src$core$events$events_abstract {
        constructor(a){
            super();
            this.isBlank = !0;
            this.recordUndo = !1;
            this.type = FINISHED_LOADING$$module$build$src$core$events$utils;
            this.isBlank = !!a;
            a && (this.workspaceId = a.id);
        }
        toJson() {
            const a = super.toJson();
            if (!this.workspaceId) throw Error("The workspace ID is undefined. Either pass a workspace to the constructor, or call fromJson");
            a.workspaceId = this.workspaceId;
            return a;
        }
        fromJson(a) {
            super.fromJson(a);
            this.workspaceId = a.workspaceId;
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, FINISHED_LOADING$$module$build$src$core$events$utils, FinishedLoading$$module$build$src$core$events$workspace_events);
    var module$build$src$core$events$workspace_events = {};
    module$build$src$core$events$workspace_events.FinishedLoading = FinishedLoading$$module$build$src$core$events$workspace_events;
    var Ui$$module$build$src$core$events$events_ui = class extends UiBase$$module$build$src$core$events$events_ui_base {
        constructor(a, b, c, d){
            super(a ? a.workspace.id : void 0);
            this.type = UI$$module$build$src$core$events$utils;
            this.blockId = a ? a.id : null;
            this.element = "undefined" === typeof b ? "" : b;
            this.oldValue = "undefined" === typeof c ? "" : c;
            this.newValue = "undefined" === typeof d ? "" : d;
        }
        toJson() {
            const a = super.toJson();
            a.element = this.element;
            void 0 !== this.newValue && (a.newValue = this.newValue);
            this.blockId && (a.blockId = this.blockId);
            return a;
        }
        fromJson(a) {
            super.fromJson(a);
            this.element = a.element;
            this.newValue = a.newValue;
            this.blockId = a.blockId;
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, UI$$module$build$src$core$events$utils, Ui$$module$build$src$core$events$events_ui);
    var module$build$src$core$events$events_ui = {};
    module$build$src$core$events$events_ui.Ui = Ui$$module$build$src$core$events$events_ui;
    var BlockChange$$module$build$src$core$events$events_block_change = class extends BlockBase$$module$build$src$core$events$events_block_base {
        constructor(a, b, c, d, e){
            super(a);
            this.type = CHANGE$$module$build$src$core$events$utils;
            a && (this.element = b, this.name = c || void 0, this.oldValue = d, this.newValue = e);
        }
        toJson() {
            const a = super.toJson();
            if (!this.element) throw Error("The changed element is undefined. Either pass an element to the constructor, or call fromJson");
            a.element = this.element;
            a.name = this.name;
            a.oldValue = this.oldValue;
            a.newValue = this.newValue;
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.BlockChange.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.element = a.element;
            this.name = a.name;
            this.oldValue = a.oldValue;
            this.newValue = a.newValue;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new BlockChange$$module$build$src$core$events$events_block_change);
            b.element = a.element;
            b.name = a.name;
            b.oldValue = a.oldValue;
            b.newValue = a.newValue;
            return b;
        }
        isNull() {
            return this.oldValue === this.newValue;
        }
        run(a) {
            var b = this.getEventWorkspace_();
            if (!this.blockId) throw Error("The block ID is undefined. Either pass a block to the constructor, or call fromJson");
            b = b.getBlockById(this.blockId);
            if (!b) throw Error("The associated block is undefined. Either pass a block to the constructor, or call fromJson");
            b.mutator && b.mutator.setVisible(!1);
            a = a ? this.newValue : this.oldValue;
            switch(this.element){
                case "field":
                    (b = b.getField(this.name)) ? b.setValue(a) : console.warn("Can't set non-existent field: " + this.name);
                    break;
                case "comment":
                    b.setCommentText(a || null);
                    break;
                case "collapsed":
                    b.setCollapsed(!!a);
                    break;
                case "disabled":
                    b.setEnabled(!a);
                    break;
                case "inline":
                    b.setInputsInline(!!a);
                    break;
                case "mutation":
                    const c = BlockChange$$module$build$src$core$events$events_block_change.getExtraBlockState_(b);
                    b.loadExtraState ? b.loadExtraState(JSON.parse(a || "{}")) : b.domToMutation && b.domToMutation(textToDom$$module$build$src$core$utils$xml(a || "<mutation/>"));
                    fire$$module$build$src$core$events$utils(new BlockChange$$module$build$src$core$events$events_block_change(b, "mutation", null, c, a));
                    break;
                default:
                    console.warn("Unknown change type: " + this.element);
            }
        }
        static getExtraBlockState_(a) {
            return a.saveExtraState ? (a = a.saveExtraState()) ? JSON.stringify(a) : "" : a.mutationToDom ? (a = a.mutationToDom()) ? domToText$$module$build$src$core$xml(a) : "" : "";
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, CHANGE$$module$build$src$core$events$utils, BlockChange$$module$build$src$core$events$events_block_change);
    var module$build$src$core$events$events_block_change = {};
    module$build$src$core$events$events_block_change.BlockChange = BlockChange$$module$build$src$core$events$events_block_change;
    var BlockDelete$$module$build$src$core$events$events_block_delete = class extends BlockBase$$module$build$src$core$events$events_block_base {
        constructor(a){
            super(a);
            this.type = DELETE$$module$build$src$core$events$utils;
            if (a) {
                if (a.getParent()) throw Error("Connected blocks cannot be deleted.");
                a.isShadow() && (this.recordUndo = !1);
                this.oldXml = blockToDomWithXY$$module$build$src$core$xml(a);
                this.ids = getDescendantIds$$module$build$src$core$events$utils(a);
                this.wasShadow = a.isShadow();
                this.oldJson = save$$module$build$src$core$serialization$blocks(a, {
                    addCoordinates: !0
                });
            }
        }
        toJson() {
            const a = super.toJson();
            if (!this.oldXml) throw Error("The old block XML is undefined. Either pass a block to the constructor, or call fromJson");
            if (!this.ids) throw Error("The block IDs are undefined. Either pass a block to the constructor, or call fromJson");
            if (void 0 === this.wasShadow) throw Error("Whether the block was a shadow is undefined. Either pass a block to the constructor, or call fromJson");
            if (!this.oldJson) throw Error("The old block JSON is undefined. Either pass a block to the constructor, or call fromJson");
            a.oldXml = domToText$$module$build$src$core$xml(this.oldXml);
            a.ids = this.ids;
            a.wasShadow = this.wasShadow;
            a.oldJson = this.oldJson;
            this.recordUndo || (a.recordUndo = this.recordUndo);
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.BlockDelete.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.oldXml = textToDom$$module$build$src$core$utils$xml(a.oldXml);
            this.ids = a.ids;
            this.wasShadow = a.wasShadow || "shadow" === this.oldXml.tagName.toLowerCase();
            this.oldJson = a.oldJson;
            void 0 !== a.recordUndo && (this.recordUndo = a.recordUndo);
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new BlockDelete$$module$build$src$core$events$events_block_delete);
            b.oldXml = textToDom$$module$build$src$core$utils$xml(a.oldXml);
            b.ids = a.ids;
            b.wasShadow = a.wasShadow || "shadow" === b.oldXml.tagName.toLowerCase();
            b.oldJson = a.oldJson;
            void 0 !== a.recordUndo && (b.recordUndo = a.recordUndo);
            return b;
        }
        run(a) {
            const b = this.getEventWorkspace_();
            if (!this.ids) throw Error("The block IDs are undefined. Either pass a block to the constructor, or call fromJson");
            if (!this.oldJson) throw Error("The old block JSON is undefined. Either pass a block to the constructor, or call fromJson");
            if (a) for(a = 0; a < this.ids.length; a++){
                const c = this.ids[a], d = b.getBlockById(c);
                d ? d.dispose(!1) : c === this.blockId && console.warn("Can't delete non-existent block: " + c);
            }
            else append$$module$build$src$core$serialization$blocks(this.oldJson, b);
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, DELETE$$module$build$src$core$events$utils, BlockDelete$$module$build$src$core$events$events_block_delete);
    var module$build$src$core$events$events_block_delete = {};
    module$build$src$core$events$events_block_delete.BlockDelete = BlockDelete$$module$build$src$core$events$events_block_delete;
    var ConnectionType$$module$build$src$core$connection_type;
    (function(a) {
        a[a.INPUT_VALUE = 1] = "INPUT_VALUE";
        a[a.OUTPUT_VALUE = 2] = "OUTPUT_VALUE";
        a[a.NEXT_STATEMENT = 3] = "NEXT_STATEMENT";
        a[a.PREVIOUS_STATEMENT = 4] = "PREVIOUS_STATEMENT";
    })(ConnectionType$$module$build$src$core$connection_type || (ConnectionType$$module$build$src$core$connection_type = {}));
    $.module$build$src$core$connection_type = {};
    $.module$build$src$core$connection_type.ConnectionType = ConnectionType$$module$build$src$core$connection_type;
    var Connection$$module$build$src$core$connection = class {
        constructor(a, b){
            this.type = b;
            this.targetConnection = null;
            this.disposed = !1;
            this.shadowDom_ = this.check_ = null;
            this.y = this.x = 0;
            this.shadowState_ = null;
            this.sourceBlock_ = a;
        }
        connect_(a) {
            const b = ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE, c = this.getSourceBlock();
            var d = a.getSourceBlock();
            a.isConnected() && a.disconnectInternal(!1);
            let e;
            if (this.isConnected()) {
                const g = this.stashShadowState_(), h = this.targetBlock();
                h.isShadow() ? h.dispose(!1) : (this.disconnectInternal(), e = h);
                this.applyShadowState_(g);
            }
            let f;
            isEnabled$$module$build$src$core$events$utils() && (f = new (get$$module$build$src$core$events$utils(MOVE$$module$build$src$core$events$utils))(d));
            connectReciprocally$$module$build$src$core$connection(this, a);
            d.setParent(c);
            f && (f.recordNew(), fire$$module$build$src$core$events$utils(f));
            if (e && (a = this.type === b ? e.outputConnection : e.previousConnection)) {
                if (d = Connection$$module$build$src$core$connection.getConnectionForOrphanedConnection(d, a)) a.connect(d);
                else a.onFailedConnect(this);
            }
        }
        dispose() {
            if (this.isConnected()) {
                this.setShadowStateInternal_();
                const a = this.targetBlock();
                a && !a.isDeadOrDying() && a.unplug();
            }
            this.disposed = !0;
        }
        getSourceBlock() {
            return this.sourceBlock_;
        }
        isSuperior() {
            return this.type === ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE || this.type === ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT;
        }
        isConnected() {
            return !!this.targetConnection;
        }
        getConnectionChecker() {
            return this.sourceBlock_.workspace.connectionChecker;
        }
        onFailedConnect(a) {}
        connect(a) {
            if (this.targetConnection === a) return !0;
            if (this.getConnectionChecker().canConnect(this, a, !1)) {
                const b = getGroup$$module$build$src$core$events$utils();
                b || setGroup$$module$build$src$core$events$utils(!0);
                this.isSuperior() ? this.connect_(a) : a.connect_(this);
                setGroup$$module$build$src$core$events$utils(b);
            }
            return this.isConnected();
        }
        disconnect() {
            this.disconnectInternal();
        }
        disconnectInternal(a = !0) {
            const { parentConnection: b, childConnection: c } = this.getParentAndChildConnections();
            if (!b || !c) throw Error("Source connection not connected.");
            const d = getGroup$$module$build$src$core$events$utils();
            d || setGroup$$module$build$src$core$events$utils(!0);
            let e;
            isEnabled$$module$build$src$core$events$utils() && (e = new (get$$module$build$src$core$events$utils(MOVE$$module$build$src$core$events$utils))(c.getSourceBlock()));
            const f = this.targetConnection;
            f && (f.targetConnection = null);
            this.targetConnection = null;
            a && c.getSourceBlock().setParent(null);
            e && (e.recordNew(), fire$$module$build$src$core$events$utils(e));
            c.getSourceBlock().isShadow() || b.respawnShadow_();
            setGroup$$module$build$src$core$events$utils(d);
        }
        getParentAndChildConnections() {
            return this.targetConnection ? this.isSuperior() ? {
                parentConnection: this,
                childConnection: this.targetConnection
            } : {
                parentConnection: this.targetConnection,
                childConnection: this
            } : {};
        }
        respawnShadow_() {
            this.createShadowBlock_(!0);
        }
        targetBlock() {
            if (this.isConnected()) {
                let a, b;
                return null != (b = null == (a = this.targetConnection) ? void 0 : a.getSourceBlock()) ? b : null;
            }
            return null;
        }
        onCheckChanged_() {
            !this.isConnected() || this.targetConnection && this.getConnectionChecker().canConnect(this, this.targetConnection, !1) || (this.isSuperior() ? this.targetBlock() : this.sourceBlock_).unplug();
        }
        setCheck(a) {
            a ? (Array.isArray(a) || (a = [
                a
            ]), this.check_ = a, this.onCheckChanged_()) : this.check_ = null;
            return this;
        }
        getCheck() {
            return this.check_;
        }
        setShadowDom(a) {
            this.setShadowStateInternal_({
                shadowDom: a
            });
        }
        getShadowDom(a) {
            return a && this.targetBlock().isShadow() ? blockToDom$$module$build$src$core$xml(this.targetBlock()) : this.shadowDom_;
        }
        setShadowState(a) {
            this.setShadowStateInternal_({
                shadowState: a
            });
        }
        getShadowState(a) {
            return a && this.targetBlock() && this.targetBlock().isShadow() ? save$$module$build$src$core$serialization$blocks(this.targetBlock()) : this.shadowState_;
        }
        neighbours(a) {
            return [];
        }
        getParentInput() {
            let a = null;
            const b = this.sourceBlock_.inputList;
            for(let c = 0; c < b.length; c++)if (b[c].connection === this) {
                a = b[c];
                break;
            }
            return a;
        }
        toString() {
            const a = this.sourceBlock_;
            if (!a) return "Orphan Connection";
            if (a.outputConnection === this) var b = "Output Connection of ";
            else if (a.previousConnection === this) b = "Previous Connection of ";
            else if (a.nextConnection === this) b = "Next Connection of ";
            else {
                b = null;
                for(let c = 0, d; d = a.inputList[c]; c++)if (d.connection === this) {
                    b = d;
                    break;
                }
                if (b) b = 'Input "' + b.name + '" connection on ';
                else return console.warn("Connection not actually connected to sourceBlock_"), "Orphan Connection";
            }
            return b + a.toDevString();
        }
        stashShadowState_() {
            const a = this.getShadowDom(!0), b = this.getShadowState(!0);
            this.shadowState_ = this.shadowDom_ = null;
            return {
                shadowDom: a,
                shadowState: b
            };
        }
        applyShadowState_({ shadowDom: a, shadowState: b }) {
            this.shadowDom_ = a;
            this.shadowState_ = b;
        }
        setShadowStateInternal_({ shadowDom: a = null, shadowState: b = null } = {}) {
            this.shadowDom_ = a;
            this.shadowState_ = b;
            (a = this.targetBlock()) ? a.isShadow() ? (a.dispose(!1), this.getSourceBlock().isDeadOrDying() || (this.respawnShadow_(), this.targetBlock() && this.targetBlock().isShadow() && this.serializeShadow_(this.targetBlock()))) : (a = this.createShadowBlock_(!1), this.serializeShadow_(a), a && a.dispose(!1)) : (this.respawnShadow_(), this.targetBlock() && this.targetBlock().isShadow() && this.serializeShadow_(this.targetBlock()));
        }
        createShadowBlock_(a) {
            var b = this.getSourceBlock();
            const c = this.getShadowState(), d = this.getShadowDom();
            if (b.isDeadOrDying() || !c && !d) return null;
            if (c) return b = appendInternal$$module$build$src$core$serialization$blocks(c, b.workspace, {
                parentConnection: a ? this : void 0,
                isShadow: !0,
                recordUndo: !1
            });
            if (d) {
                b = domToBlock$$module$build$src$core$xml(d, b.workspace);
                if (a) {
                    if (this.type === ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE) {
                        if (!b.outputConnection) throw Error("Shadow block is missing an output connection");
                        if (!this.connect(b.outputConnection)) throw Error("Could not connect shadow block to connection");
                    } else if (this.type === ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT) {
                        if (!b.previousConnection) throw Error("Shadow block is missing previous connection");
                        if (!this.connect(b.previousConnection)) throw Error("Could not connect shadow block to connection");
                    } else throw Error("Cannot connect a shadow block to a previous/output connection");
                }
                return b;
            }
            return null;
        }
        serializeShadow_(a) {
            a && (this.shadowDom_ = blockToDom$$module$build$src$core$xml(a), this.shadowState_ = save$$module$build$src$core$serialization$blocks(a));
        }
        static getConnectionForOrphanedConnection(a, b) {
            if (b.type === ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE) return getConnectionForOrphanedOutput$$module$build$src$core$connection(a, b.getSourceBlock());
            a = a.lastConnectionInStack(!0);
            const c = b.getConnectionChecker();
            return a && c.canConnect(b, a, !1) ? a : null;
        }
    };
    Connection$$module$build$src$core$connection.CAN_CONNECT = 0;
    Connection$$module$build$src$core$connection.REASON_SELF_CONNECTION = 1;
    Connection$$module$build$src$core$connection.REASON_WRONG_TYPE = 2;
    Connection$$module$build$src$core$connection.REASON_TARGET_NULL = 3;
    Connection$$module$build$src$core$connection.REASON_CHECKS_FAILED = 4;
    Connection$$module$build$src$core$connection.REASON_DIFFERENT_WORKSPACES = 5;
    Connection$$module$build$src$core$connection.REASON_SHADOW_PARENT = 6;
    Connection$$module$build$src$core$connection.REASON_DRAG_CHECKS_FAILED = 7;
    Connection$$module$build$src$core$connection.REASON_PREVIOUS_AND_OUTPUT = 8;
    var module$build$src$core$connection = {};
    module$build$src$core$connection.Connection = Connection$$module$build$src$core$connection;
    var COLLAPSED_INPUT_NAME$$module$build$src$core$constants = "_TEMP_COLLAPSED_INPUT", COLLAPSED_FIELD_NAME$$module$build$src$core$constants = "_TEMP_COLLAPSED_FIELD", module$build$src$core$constants = {};
    module$build$src$core$constants.COLLAPSED_FIELD_NAME = COLLAPSED_FIELD_NAME$$module$build$src$core$constants;
    module$build$src$core$constants.COLLAPSED_INPUT_NAME = COLLAPSED_INPUT_NAME$$module$build$src$core$constants;
    var module$build$src$core$utils$math = {};
    module$build$src$core$utils$math.clamp = clamp$$module$build$src$core$utils$math;
    module$build$src$core$utils$math.toDegrees = toDegrees$$module$build$src$core$utils$math;
    module$build$src$core$utils$math.toRadians = toRadians$$module$build$src$core$utils$math;
    var ARROW_SIZE$$module$build$src$core$dropdowndiv = 16, BORDER_SIZE$$module$build$src$core$dropdowndiv = 1, ARROW_HORIZONTAL_PADDING$$module$build$src$core$dropdowndiv = 12, PADDING_Y$$module$build$src$core$dropdowndiv = 16, ANIMATION_TIME$$module$build$src$core$dropdowndiv = .25, animateOutTimer$$module$build$src$core$dropdowndiv = null, onHide$$module$build$src$core$dropdowndiv = null, renderedClassName$$module$build$src$core$dropdowndiv = "", themeClassName$$module$build$src$core$dropdowndiv = "", div$$module$build$src$core$dropdowndiv, content$$module$build$src$core$dropdowndiv, arrow$$module$build$src$core$dropdowndiv, boundsElement$$module$build$src$core$dropdowndiv = null, owner$$module$build$src$core$dropdowndiv = null, positionToField$$module$build$src$core$dropdowndiv = null, internal$$module$build$src$core$dropdowndiv = {
        getBoundsInfo: function() {
            const a = getPageOffset$$module$build$src$core$utils$style(boundsElement$$module$build$src$core$dropdowndiv), b = getSize$$module$build$src$core$utils$style(boundsElement$$module$build$src$core$dropdowndiv);
            return {
                left: a.x,
                right: a.x + b.width,
                top: a.y,
                bottom: a.y + b.height,
                width: b.width,
                height: b.height
            };
        },
        getPositionMetrics: function(a, b, c, d) {
            const e = internal$$module$build$src$core$dropdowndiv.getBoundsInfo(), f = getSize$$module$build$src$core$utils$style(div$$module$build$src$core$dropdowndiv);
            return b + f.height < e.bottom ? getPositionBelowMetrics$$module$build$src$core$dropdowndiv(a, b, e, f) : d - f.height > e.top ? getPositionAboveMetrics$$module$build$src$core$dropdowndiv(c, d, e, f) : b + f.height < document.documentElement.clientHeight ? getPositionBelowMetrics$$module$build$src$core$dropdowndiv(a, b, e, f) : d - f.height > document.documentElement.clientTop ? getPositionAboveMetrics$$module$build$src$core$dropdowndiv(c, d, e, f) : getPositionTopOfPageMetrics$$module$build$src$core$dropdowndiv(a, e, f);
        }
    }, TEST_ONLY$$module$build$src$core$dropdowndiv = internal$$module$build$src$core$dropdowndiv, module$build$src$core$dropdowndiv = {};
    module$build$src$core$dropdowndiv.ANIMATION_TIME = ANIMATION_TIME$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.ARROW_HORIZONTAL_PADDING = ARROW_HORIZONTAL_PADDING$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.ARROW_SIZE = ARROW_SIZE$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.BORDER_SIZE = BORDER_SIZE$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.PADDING_Y = PADDING_Y$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.TEST_ONLY = internal$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.clearContent = clearContent$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.createDom = createDom$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.getContentDiv = getContentDiv$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.getOwner = getOwner$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.getPositionX = getPositionX$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.hide = hide$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.hideIfOwner = hideIfOwner$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.hideWithoutAnimation = hideWithoutAnimation$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.isVisible = isVisible$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.repositionForWindowResize = repositionForWindowResize$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.setBoundsElement = setBoundsElement$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.setColour = setColour$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.show = show$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.showPositionedByBlock = showPositionedByBlock$$module$build$src$core$dropdowndiv;
    module$build$src$core$dropdowndiv.showPositionedByField = showPositionedByField$$module$build$src$core$dropdowndiv;
    var MarkerManager$$module$build$src$core$marker_manager = class {
        constructor(a){
            this.workspace = a;
            this.cursorSvg_ = this.cursor_ = null;
            this.markers = new Map;
            this.markerSvg_ = null;
        }
        registerMarker(a, b) {
            this.markers.has(a) && this.unregisterMarker(a);
            b.setDrawer(this.workspace.getRenderer().makeMarkerDrawer(this.workspace, b));
            this.setMarkerSvg(b.getDrawer().createDom());
            this.markers.set(a, b);
        }
        unregisterMarker(a) {
            const b = this.markers.get(a);
            if (b) b.dispose(), this.markers.delete(a);
            else throw Error("Marker with ID " + a + " does not exist. Can only unregister markers that exist.");
        }
        getCursor() {
            return this.cursor_;
        }
        getMarker(a) {
            return this.markers.get(a) || null;
        }
        setCursor(a) {
            this.cursor_ && this.cursor_.getDrawer() && this.cursor_.getDrawer().dispose();
            if (this.cursor_ = a) a = this.workspace.getRenderer().makeMarkerDrawer(this.workspace, this.cursor_), this.cursor_.setDrawer(a), this.setCursorSvg(this.cursor_.getDrawer().createDom());
        }
        setCursorSvg(a) {
            a ? (this.workspace.getBlockCanvas().appendChild(a), this.cursorSvg_ = a) : this.cursorSvg_ = null;
        }
        setMarkerSvg(a) {
            a ? this.workspace.getBlockCanvas() && (this.cursorSvg_ ? this.workspace.getBlockCanvas().insertBefore(a, this.cursorSvg_) : this.workspace.getBlockCanvas().appendChild(a)) : this.markerSvg_ = null;
        }
        updateMarkers() {
            this.workspace.keyboardAccessibilityMode && this.cursorSvg_ && this.workspace.getCursor().draw();
        }
        dispose() {
            const a = Object.keys(this.markers);
            for(let b = 0, c; c = a[b]; b++)this.unregisterMarker(c);
            this.markers.clear();
            this.cursor_ && (this.cursor_.dispose(), this.cursor_ = null);
        }
    };
    MarkerManager$$module$build$src$core$marker_manager.LOCAL_MARKER = "local_marker_1";
    var module$build$src$core$marker_manager = {};
    module$build$src$core$marker_manager.MarkerManager = MarkerManager$$module$build$src$core$marker_manager;
    $.module$build$src$core$utils$string = {};
    $.module$build$src$core$utils$string.commonWordPrefix = commonWordPrefix$$module$build$src$core$utils$string;
    $.module$build$src$core$utils$string.commonWordSuffix = commonWordSuffix$$module$build$src$core$utils$string;
    $.module$build$src$core$utils$string.isNumber = isNumber$$module$build$src$core$utils$string;
    $.module$build$src$core$utils$string.shortestStringLength = shortestStringLength$$module$build$src$core$utils$string;
    $.module$build$src$core$utils$string.startsWith = startsWith$$module$build$src$core$utils$string;
    $.module$build$src$core$utils$string.wrap = wrap$$module$build$src$core$utils$string;
    var customTooltip$$module$build$src$core$tooltip = void 0, visible$$module$build$src$core$tooltip = !1, blocked$$module$build$src$core$tooltip = !1, LIMIT$$module$build$src$core$tooltip = 50, mouseOutPid$$module$build$src$core$tooltip = 0, showPid$$module$build$src$core$tooltip = 0, lastX$$module$build$src$core$tooltip = 0, lastY$$module$build$src$core$tooltip = 0, element$$module$build$src$core$tooltip = null, poisonedElement$$module$build$src$core$tooltip = null, OFFSET_X$$module$build$src$core$tooltip = 0, OFFSET_Y$$module$build$src$core$tooltip = 10, RADIUS_OK$$module$build$src$core$tooltip = 10, HOVER_MS$$module$build$src$core$tooltip = 750, MARGINS$$module$build$src$core$tooltip = 5, containerDiv$$module$build$src$core$tooltip = null, module$build$src$core$tooltip = {};
    module$build$src$core$tooltip.HOVER_MS = HOVER_MS$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.LIMIT = LIMIT$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.MARGINS = MARGINS$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.OFFSET_X = OFFSET_X$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.OFFSET_Y = OFFSET_Y$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.RADIUS_OK = RADIUS_OK$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.bindMouseEvents = bindMouseEvents$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.block = block$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.createDom = createDom$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.dispose = dispose$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.getCustomTooltip = getCustomTooltip$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.getDiv = getDiv$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.getTooltipOfObject = getTooltipOfObject$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.hide = hide$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.isVisible = isVisible$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.setCustomTooltip = setCustomTooltip$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.unbindMouseEvents = unbindMouseEvents$$module$build$src$core$tooltip;
    module$build$src$core$tooltip.unblock = unblock$$module$build$src$core$tooltip;
    var hsvSaturation$$module$build$src$core$utils$colour = .45, hsvValue$$module$build$src$core$utils$colour = .65, names$$module$build$src$core$utils$colour = {
        aqua: "#00ffff",
        black: "#000000",
        blue: "#0000ff",
        fuchsia: "#ff00ff",
        gray: "#808080",
        green: "#008000",
        lime: "#00ff00",
        maroon: "#800000",
        navy: "#000080",
        olive: "#808000",
        purple: "#800080",
        red: "#ff0000",
        silver: "#c0c0c0",
        teal: "#008080",
        white: "#ffffff",
        yellow: "#ffff00"
    }, module$build$src$core$utils$colour = {};
    module$build$src$core$utils$colour.blend = blend$$module$build$src$core$utils$colour;
    module$build$src$core$utils$colour.getHsvSaturation = getHsvSaturation$$module$build$src$core$utils$colour;
    module$build$src$core$utils$colour.getHsvValue = getHsvValue$$module$build$src$core$utils$colour;
    module$build$src$core$utils$colour.hexToRgb = hexToRgb$$module$build$src$core$utils$colour;
    module$build$src$core$utils$colour.hsvToHex = hsvToHex$$module$build$src$core$utils$colour;
    module$build$src$core$utils$colour.hueToHex = hueToHex$$module$build$src$core$utils$colour;
    module$build$src$core$utils$colour.names = names$$module$build$src$core$utils$colour;
    module$build$src$core$utils$colour.parse = parse$$module$build$src$core$utils$colour;
    module$build$src$core$utils$colour.rgbToHex = rgbToHex$$module$build$src$core$utils$colour;
    module$build$src$core$utils$colour.setHsvSaturation = setHsvSaturation$$module$build$src$core$utils$colour;
    module$build$src$core$utils$colour.setHsvValue = setHsvValue$$module$build$src$core$utils$colour;
    var module$build$src$core$utils$parsing = {};
    module$build$src$core$utils$parsing.checkMessageReferences = checkMessageReferences$$module$build$src$core$utils$parsing;
    module$build$src$core$utils$parsing.parseBlockColour = parseBlockColour$$module$build$src$core$utils$parsing;
    module$build$src$core$utils$parsing.replaceMessageReferences = replaceMessageReferences$$module$build$src$core$utils$parsing;
    module$build$src$core$utils$parsing.tokenizeInterpolation = tokenizeInterpolation$$module$build$src$core$utils$parsing;
    var owner$$module$build$src$core$widgetdiv = null, dispose$$module$build$src$core$widgetdiv = null, rendererClassName$$module$build$src$core$widgetdiv = "", themeClassName$$module$build$src$core$widgetdiv = "", containerDiv$$module$build$src$core$widgetdiv, module$build$src$core$widgetdiv = {};
    module$build$src$core$widgetdiv.createDom = createDom$$module$build$src$core$widgetdiv;
    module$build$src$core$widgetdiv.getDiv = getDiv$$module$build$src$core$widgetdiv;
    module$build$src$core$widgetdiv.hide = hide$$module$build$src$core$widgetdiv;
    module$build$src$core$widgetdiv.hideIfOwner = hideIfOwner$$module$build$src$core$widgetdiv;
    module$build$src$core$widgetdiv.isVisible = isVisible$$module$build$src$core$widgetdiv;
    module$build$src$core$widgetdiv.positionWithAnchor = positionWithAnchor$$module$build$src$core$widgetdiv;
    module$build$src$core$widgetdiv.show = show$$module$build$src$core$widgetdiv;
    module$build$src$core$widgetdiv.testOnly_setDiv = testOnly_setDiv$$module$build$src$core$widgetdiv;
    var Field$$module$build$src$core$field = class {
        constructor(a, b, c){
            this.DEFAULT_VALUE = null;
            this.name = void 0;
            this.constants_ = this.mouseDownWrapper_ = this.textContent_ = this.textElement_ = this.borderRect_ = this.fieldGroup_ = this.markerSvg_ = this.cursorSvg_ = this.tooltip_ = this.validator_ = null;
            this.disposed = !1;
            this.maxDisplayLength = 50;
            this.sourceBlock_ = null;
            this.enabled_ = this.visible_ = this.isDirty_ = !0;
            this.suffixField = this.prefixField = this.clickTarget_ = null;
            this.EDITABLE = !0;
            this.SERIALIZABLE = !1;
            this.CURSOR = "";
            this.value_ = "DEFAULT_VALUE" in new.target.prototype ? new.target.prototype.DEFAULT_VALUE : this.DEFAULT_VALUE;
            this.size_ = new Size$$module$build$src$core$utils$size(0, 0);
            a !== Field$$module$build$src$core$field.SKIP_SETUP && (c && this.configure_(c), this.setValue(a), b && this.setValidator(b));
        }
        configure_(a) {
            a.tooltip && this.setTooltip(replaceMessageReferences$$module$build$src$core$utils$parsing(a.tooltip));
        }
        setSourceBlock(a) {
            if (this.sourceBlock_) throw Error("Field already bound to a block");
            this.sourceBlock_ = a;
        }
        getConstants() {
            !this.constants_ && this.sourceBlock_ && !this.sourceBlock_.isDeadOrDying() && this.sourceBlock_.workspace.rendered && (this.constants_ = this.sourceBlock_.workspace.getRenderer().getConstants());
            return this.constants_;
        }
        getSourceBlock() {
            return this.sourceBlock_;
        }
        init() {
            this.fieldGroup_ || (this.fieldGroup_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {}), this.isVisible() || (this.fieldGroup_.style.display = "none"), this.sourceBlock_.getSvgRoot().appendChild(this.fieldGroup_), this.initView(), this.updateEditable(), this.setTooltip(this.tooltip_), this.bindEvents_(), this.initModel());
        }
        initView() {
            this.createBorderRect_();
            this.createTextElement_();
        }
        initModel() {}
        createBorderRect_() {
            this.borderRect_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                rx: this.getConstants().FIELD_BORDER_RECT_RADIUS,
                ry: this.getConstants().FIELD_BORDER_RECT_RADIUS,
                x: 0,
                y: 0,
                height: this.size_.height,
                width: this.size_.width,
                "class": "blocklyFieldRect"
            }, this.fieldGroup_);
        }
        createTextElement_() {
            this.textElement_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.TEXT, {
                "class": "blocklyText"
            }, this.fieldGroup_);
            this.getConstants().FIELD_TEXT_BASELINE_CENTER && this.textElement_.setAttribute("dominant-baseline", "central");
            this.textContent_ = document.createTextNode("");
            this.textElement_.appendChild(this.textContent_);
        }
        bindEvents_() {
            const a = this.getClickTarget_();
            if (!a) throw Error("A click target has not been set.");
            bindMouseEvents$$module$build$src$core$tooltip(a);
            this.mouseDownWrapper_ = conditionalBind$$module$build$src$core$browser_events(a, "pointerdown", this, this.onMouseDown_);
        }
        fromXml(a) {
            this.setValue(a.textContent);
        }
        toXml(a) {
            a.textContent = this.getValue();
            return a;
        }
        saveState(a) {
            a = this.saveLegacyState(Field$$module$build$src$core$field);
            return null !== a ? a : this.getValue();
        }
        loadState(a) {
            this.loadLegacyState(Field$$module$build$src$core$field, a) || this.setValue(a);
        }
        saveLegacyState(a) {
            return a.prototype.saveState === this.saveState && a.prototype.toXml !== this.toXml ? (a = $.createElement$$module$build$src$core$utils$xml("field"), a.setAttribute("name", this.name || ""), domToText$$module$build$src$core$utils$xml(this.toXml(a)).replace(' xmlns="https://developers.google.com/blockly/xml"', "")) : null;
        }
        loadLegacyState(a, b) {
            return a.prototype.loadState === this.loadState && a.prototype.fromXml !== this.fromXml ? (this.fromXml(textToDom$$module$build$src$core$utils$xml(b)), !0) : !1;
        }
        dispose() {
            hideIfOwner$$module$build$src$core$dropdowndiv(this);
            hideIfOwner$$module$build$src$core$widgetdiv(this);
            let a;
            (null == (a = this.getSourceBlock()) ? 0 : a.isDeadOrDying()) || removeNode$$module$build$src$core$utils$dom(this.fieldGroup_);
            this.disposed = !0;
        }
        updateEditable() {
            const a = this.fieldGroup_, b = this.getSourceBlock();
            this.EDITABLE && a && b && (this.enabled_ && b.isEditable() ? (addClass$$module$build$src$core$utils$dom(a, "blocklyEditableText"), removeClass$$module$build$src$core$utils$dom(a, "blocklyNonEditableText"), a.style.cursor = this.CURSOR) : (addClass$$module$build$src$core$utils$dom(a, "blocklyNonEditableText"), removeClass$$module$build$src$core$utils$dom(a, "blocklyEditableText"), a.style.cursor = ""));
        }
        setEnabled(a) {
            this.enabled_ = a;
            this.updateEditable();
        }
        isEnabled() {
            return this.enabled_;
        }
        isClickable() {
            return this.enabled_ && !!this.sourceBlock_ && this.sourceBlock_.isEditable() && this.showEditor_ !== Field$$module$build$src$core$field.prototype.showEditor_;
        }
        isCurrentlyEditable() {
            return this.enabled_ && this.EDITABLE && !!this.sourceBlock_ && this.sourceBlock_.isEditable();
        }
        isSerializable() {
            let a = !1;
            this.name && (this.SERIALIZABLE ? a = !0 : this.EDITABLE && (console.warn("Detected an editable field that was not serializable. Please define SERIALIZABLE property as true on all editable custom fields. Proceeding with serialization."), a = !0));
            return a;
        }
        isVisible() {
            return this.visible_;
        }
        setVisible(a) {
            if (this.visible_ !== a) {
                this.visible_ = a;
                var b = this.fieldGroup_;
                b && (b.style.display = a ? "block" : "none");
            }
        }
        setValidator(a) {
            this.validator_ = a;
        }
        getValidator() {
            return this.validator_;
        }
        getSvgRoot() {
            return this.fieldGroup_;
        }
        getBorderRect() {
            if (!this.borderRect_) throw Error(`The border rectangle is ${this.borderRect_}.`);
            return this.borderRect_;
        }
        getTextElement() {
            if (!this.textElement_) throw Error(`The text element is ${this.textElement_}.`);
            return this.textElement_;
        }
        getTextContent() {
            if (!this.textContent_) throw Error(`The text content is ${this.textContent_}.`);
            return this.textContent_;
        }
        applyColour() {}
        render_() {
            this.textContent_ && (this.textContent_.nodeValue = this.getDisplayText_());
            this.updateSize_();
        }
        showEditor(a) {
            this.isClickable() && this.showEditor_(a);
        }
        showEditor_(a) {}
        updateSize_(a) {
            const b = this.getConstants();
            a = void 0 !== a ? a : this.borderRect_ ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
            let c = 2 * a, d = b.FIELD_TEXT_HEIGHT, e = 0;
            this.textElement_ && (e = getFastTextWidth$$module$build$src$core$utils$dom(this.textElement_, b.FIELD_TEXT_FONTSIZE, b.FIELD_TEXT_FONTWEIGHT, b.FIELD_TEXT_FONTFAMILY), c += e);
            this.borderRect_ && (d = Math.max(d, b.FIELD_BORDER_RECT_HEIGHT));
            this.size_.height = d;
            this.size_.width = c;
            this.positionTextElement_(a, e);
            this.positionBorderRect_();
        }
        positionTextElement_(a, b) {
            if (this.textElement_) {
                var c = this.getConstants(), d = this.size_.height / 2, e;
                this.textElement_.setAttribute("x", String((null == (e = this.getSourceBlock()) ? 0 : e.RTL) ? this.size_.width - b - a : a));
                this.textElement_.setAttribute("y", String(c.FIELD_TEXT_BASELINE_CENTER ? d : d - c.FIELD_TEXT_HEIGHT / 2 + c.FIELD_TEXT_BASELINE));
            }
        }
        positionBorderRect_() {
            this.borderRect_ && (this.borderRect_.setAttribute("width", String(this.size_.width)), this.borderRect_.setAttribute("height", String(this.size_.height)), this.borderRect_.setAttribute("rx", String(this.getConstants().FIELD_BORDER_RECT_RADIUS)), this.borderRect_.setAttribute("ry", String(this.getConstants().FIELD_BORDER_RECT_RADIUS)));
        }
        getSize() {
            if (!this.isVisible()) return new Size$$module$build$src$core$utils$size(0, 0);
            this.isDirty_ ? (this.render_(), this.isDirty_ = !1) : this.visible_ && 0 === this.size_.width && (this.render_(), 0 !== this.size_.width && console.warn("Deprecated use of setting size_.width to 0 to rerender a field. Set field.isDirty_ to true instead."));
            return this.size_;
        }
        getScaledBBox() {
            let a;
            var b = this.getSourceBlock();
            if (!b) throw new UnattachedFieldError$$module$build$src$core$field;
            if (this.borderRect_) {
                var c = this.borderRect_.getBoundingClientRect();
                a = getPageOffset$$module$build$src$core$utils$style(this.borderRect_);
                b = c.width;
                c = c.height;
            } else {
                c = this.sourceBlock_.getHeightWidth();
                const d = b.workspace.scale;
                a = this.getAbsoluteXY_();
                b = (c.width + 1) * d;
                c = (c.height + 1) * d;
                GECKO$$module$build$src$core$utils$useragent ? (a.x += 1.5 * d, a.y += 1.5 * d) : (a.x -= .5 * d, a.y -= .5 * d);
            }
            return new Rect$$module$build$src$core$utils$rect(a.y, a.y + c, a.x, a.x + b);
        }
        getDisplayText_() {
            let a = this.getText();
            if (!a) return Field$$module$build$src$core$field.NBSP;
            a.length > this.maxDisplayLength && (a = a.substring(0, this.maxDisplayLength - 2) + "\u2026");
            a = a.replace(/\s/g, Field$$module$build$src$core$field.NBSP);
            this.sourceBlock_ && this.sourceBlock_.RTL && (a += "\u200F");
            return a;
        }
        getText() {
            const a = this.getText_();
            return null !== a ? String(a) : String(this.getValue());
        }
        getText_() {
            return null;
        }
        markDirty() {
            this.isDirty_ = !0;
            this.constants_ = null;
        }
        forceRerender() {
            this.isDirty_ = !0;
            this.sourceBlock_ && this.sourceBlock_.rendered && (this.sourceBlock_.queueRender(), this.sourceBlock_.bumpNeighbours());
        }
        setValue(a) {
            if (null !== a) {
                var b = this.doClassValidation_(a);
                a = this.processValidation_(a, b);
                if (!(a instanceof Error)) {
                    var c;
                    b = null == (c = this.getValidator()) ? void 0 : c.call(this, a);
                    c = this.processValidation_(a, b);
                    c instanceof Error || (a = this.sourceBlock_, a && a.disposed || (b = this.getValue(), b === c ? this.doValueUpdate_(c) : (this.doValueUpdate_(c), a && isEnabled$$module$build$src$core$events$utils() && fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(CHANGE$$module$build$src$core$events$utils))(a, "field", this.name || null, b, c)), this.isDirty_ && this.forceRerender())));
                }
            }
        }
        processValidation_(a, b) {
            return null === b ? (this.doValueInvalid_(a), this.isDirty_ && this.forceRerender(), Error()) : void 0 === b ? a : b;
        }
        getValue() {
            return this.value_;
        }
        doClassValidation_(a) {
            return null === a || void 0 === a ? null : a;
        }
        doValueUpdate_(a) {
            this.value_ = a;
            this.isDirty_ = !0;
        }
        doValueInvalid_(a) {}
        onMouseDown_(a) {
            this.sourceBlock_ && !this.sourceBlock_.isDeadOrDying() && (a = this.sourceBlock_.workspace.getGesture(a)) && a.setStartField(this);
        }
        setTooltip(a) {
            a || "" === a || (a = this.sourceBlock_);
            const b = this.getClickTarget_();
            b ? b.tooltip = a : this.tooltip_ = a;
        }
        getTooltip() {
            const a = this.getClickTarget_();
            return a ? getTooltipOfObject$$module$build$src$core$tooltip(a) : getTooltipOfObject$$module$build$src$core$tooltip({
                tooltip: this.tooltip_
            });
        }
        getClickTarget_() {
            return this.clickTarget_ || this.getSvgRoot();
        }
        getAbsoluteXY_() {
            return getPageOffset$$module$build$src$core$utils$style(this.getClickTarget_());
        }
        referencesVariables() {
            return !1;
        }
        refreshVariableName() {}
        getParentInput() {
            let a = null;
            const b = this.getSourceBlock();
            if (!b) throw new UnattachedFieldError$$module$build$src$core$field;
            const c = b.inputList;
            for(let d = 0; d < b.inputList.length; d++){
                const e = c[d], f = e.fieldRow;
                for(let g = 0; g < f.length; g++)if (f[g] === this) {
                    a = e;
                    break;
                }
            }
            return a;
        }
        getFlipRtl() {
            return !1;
        }
        isTabNavigable() {
            return !1;
        }
        onShortcut(a) {
            return !1;
        }
        setCursorSvg(a) {
            if (a) {
                if (!this.fieldGroup_) throw Error(`The field group is ${this.fieldGroup_}.`);
                this.fieldGroup_.appendChild(a);
                this.cursorSvg_ = a;
            } else this.cursorSvg_ = null;
        }
        setMarkerSvg(a) {
            if (a) {
                if (!this.fieldGroup_) throw Error(`The field group is ${this.fieldGroup_}.`);
                this.fieldGroup_.appendChild(a);
                this.markerSvg_ = a;
            } else this.markerSvg_ = null;
        }
        updateMarkers_() {
            var a = this.getSourceBlock();
            if (!a) throw new UnattachedFieldError$$module$build$src$core$field;
            a = a.workspace;
            a.keyboardAccessibilityMode && this.cursorSvg_ && a.getCursor().draw();
            a.keyboardAccessibilityMode && this.markerSvg_ && a.getMarker(MarkerManager$$module$build$src$core$marker_manager.LOCAL_MARKER).draw();
        }
    };
    Field$$module$build$src$core$field.NBSP = "\xa0";
    Field$$module$build$src$core$field.SKIP_SETUP = Symbol("SKIP_SETUP");
    var UnattachedFieldError$$module$build$src$core$field = class extends Error {
        constructor(){
            super("The field has not yet been attached to its input. Call appendField to attach it.");
        }
    }, module$build$src$core$field = {};
    module$build$src$core$field.Field = Field$$module$build$src$core$field;
    module$build$src$core$field.UnattachedFieldError = UnattachedFieldError$$module$build$src$core$field;
    var TEST_ONLY$$module$build$src$core$field_registry;
    TEST_ONLY$$module$build$src$core$field_registry = {
        fromJsonInternal: fromJsonInternal$$module$build$src$core$field_registry
    };
    $.module$build$src$core$field_registry = {};
    $.module$build$src$core$field_registry.TEST_ONLY = TEST_ONLY$$module$build$src$core$field_registry;
    $.module$build$src$core$field_registry.fromJson = fromJson$$module$build$src$core$field_registry;
    $.module$build$src$core$field_registry.register = register$$module$build$src$core$field_registry;
    $.module$build$src$core$field_registry.unregister = unregister$$module$build$src$core$field_registry;
    var ARIA_PREFIX$$module$build$src$core$utils$aria = "aria-", ROLE_ATTRIBUTE$$module$build$src$core$utils$aria = "role", Role$$module$build$src$core$utils$aria;
    (function(a) {
        a.GRID = "grid";
        a.GRIDCELL = "gridcell";
        a.GROUP = "group";
        a.LISTBOX = "listbox";
        a.MENU = "menu";
        a.MENUITEM = "menuitem";
        a.MENUITEMCHECKBOX = "menuitemcheckbox";
        a.OPTION = "option";
        a.PRESENTATION = "presentation";
        a.ROW = "row";
        a.TREE = "tree";
        a.TREEITEM = "treeitem";
    })(Role$$module$build$src$core$utils$aria || (Role$$module$build$src$core$utils$aria = {}));
    var State$$module$build$src$core$utils$aria;
    (function(a) {
        a.ACTIVEDESCENDANT = "activedescendant";
        a.COLCOUNT = "colcount";
        a.DISABLED = "disabled";
        a.EXPANDED = "expanded";
        a.INVALID = "invalid";
        a.LABEL = "label";
        a.LABELLEDBY = "labelledby";
        a.LEVEL = "level";
        a.ORIENTATION = "orientation";
        a.POSINSET = "posinset";
        a.ROWCOUNT = "rowcount";
        a.SELECTED = "selected";
        a.SETSIZE = "setsize";
        a.VALUEMAX = "valuemax";
        a.VALUEMIN = "valuemin";
    })(State$$module$build$src$core$utils$aria || (State$$module$build$src$core$utils$aria = {}));
    var module$build$src$core$utils$aria = {};
    module$build$src$core$utils$aria.Role = Role$$module$build$src$core$utils$aria;
    module$build$src$core$utils$aria.State = State$$module$build$src$core$utils$aria;
    module$build$src$core$utils$aria.setRole = setRole$$module$build$src$core$utils$aria;
    module$build$src$core$utils$aria.setState = setState$$module$build$src$core$utils$aria;
    var Menu$$module$build$src$core$menu = class {
        constructor(){
            this.menuItems = [];
            this.roleName = this.element = this.onKeyDownHandler = this.mouseLeaveHandler = this.mouseEnterHandler = this.clickHandler = this.mouseOverHandler = this.highlightedItem = this.openingCoords = null;
        }
        addChild(a) {
            this.menuItems.push(a);
        }
        render(a) {
            const b = document.createElement("div");
            b.className = "blocklyMenu goog-menu blocklyNonSelectable";
            b.tabIndex = 0;
            this.roleName && setRole$$module$build$src$core$utils$aria(b, this.roleName);
            this.element = b;
            for(let c = 0, d; d = this.menuItems[c]; c++)b.appendChild(d.createDom());
            this.mouseOverHandler = conditionalBind$$module$build$src$core$browser_events(b, "pointerover", this, this.handleMouseOver, !0);
            this.clickHandler = conditionalBind$$module$build$src$core$browser_events(b, "pointerup", this, this.handleClick, !0);
            this.mouseEnterHandler = conditionalBind$$module$build$src$core$browser_events(b, "pointerenter", this, this.handleMouseEnter, !0);
            this.mouseLeaveHandler = conditionalBind$$module$build$src$core$browser_events(b, "pointerleave", this, this.handleMouseLeave, !0);
            this.onKeyDownHandler = conditionalBind$$module$build$src$core$browser_events(b, "keydown", this, this.handleKeyEvent);
            a.appendChild(b);
            return b;
        }
        getElement() {
            return this.element;
        }
        focus() {
            const a = this.getElement();
            a && (a.focus({
                preventScroll: !0
            }), addClass$$module$build$src$core$utils$dom(a, "blocklyFocused"));
        }
        blur() {
            const a = this.getElement();
            a && (a.blur(), removeClass$$module$build$src$core$utils$dom(a, "blocklyFocused"));
        }
        setRole(a) {
            this.roleName = a;
        }
        dispose() {
            this.mouseOverHandler && (unbind$$module$build$src$core$browser_events(this.mouseOverHandler), this.mouseOverHandler = null);
            this.clickHandler && (unbind$$module$build$src$core$browser_events(this.clickHandler), this.clickHandler = null);
            this.mouseEnterHandler && (unbind$$module$build$src$core$browser_events(this.mouseEnterHandler), this.mouseEnterHandler = null);
            this.mouseLeaveHandler && (unbind$$module$build$src$core$browser_events(this.mouseLeaveHandler), this.mouseLeaveHandler = null);
            this.onKeyDownHandler && (unbind$$module$build$src$core$browser_events(this.onKeyDownHandler), this.onKeyDownHandler = null);
            for(let a = 0, b; b = this.menuItems[a]; a++)b.dispose();
            this.element = null;
        }
        getMenuItem(a) {
            const b = this.getElement();
            for(; a && a !== b;){
                if (a.classList.contains("blocklyMenuItem")) {
                    for(let c = 0, d; d = this.menuItems[c]; c++)if (d.getElement() === a) return d;
                }
                a = a.parentElement;
            }
            return null;
        }
        setHighlighted(a) {
            var b = this.highlightedItem;
            b && (b.setHighlighted(!1), this.highlightedItem = null);
            a && (a.setHighlighted(!0), this.highlightedItem = a, b = this.getElement(), scrollIntoContainerView$$module$build$src$core$utils$style(a.getElement(), b), setState$$module$build$src$core$utils$aria(b, State$$module$build$src$core$utils$aria.ACTIVEDESCENDANT, a.getId()));
        }
        highlightNext() {
            const a = this.highlightedItem ? this.menuItems.indexOf(this.highlightedItem) : -1;
            this.highlightHelper(a, 1);
        }
        highlightPrevious() {
            const a = this.highlightedItem ? this.menuItems.indexOf(this.highlightedItem) : -1;
            this.highlightHelper(0 > a ? this.menuItems.length : a, -1);
        }
        highlightFirst() {
            this.highlightHelper(-1, 1);
        }
        highlightLast() {
            this.highlightHelper(this.menuItems.length, -1);
        }
        highlightHelper(a, b) {
            a += b;
            let c;
            for(; c = this.menuItems[a];){
                if (c.isEnabled()) {
                    this.setHighlighted(c);
                    break;
                }
                a += b;
            }
        }
        handleMouseOver(a) {
            (a = this.getMenuItem(a.target)) && (a.isEnabled() ? this.highlightedItem !== a && this.setHighlighted(a) : this.setHighlighted(null));
        }
        handleClick(a) {
            const b = this.openingCoords;
            this.openingCoords = null;
            if (b && "number" === typeof a.clientX) {
                const c = new Coordinate$$module$build$src$core$utils$coordinate(a.clientX, a.clientY);
                if (1 > Coordinate$$module$build$src$core$utils$coordinate.distance(b, c)) return;
            }
            (a = this.getMenuItem(a.target)) && a.performAction();
        }
        handleMouseEnter(a) {
            this.focus();
        }
        handleMouseLeave(a) {
            this.getElement() && (this.blur(), this.setHighlighted(null));
        }
        handleKeyEvent(a) {
            if (this.menuItems.length && !(a.shiftKey || a.ctrlKey || a.metaKey || a.altKey)) {
                var b = this.highlightedItem;
                switch(a.key){
                    case "Enter":
                    case " ":
                        b && b.performAction();
                        break;
                    case "ArrowUp":
                        this.highlightPrevious();
                        break;
                    case "ArrowDown":
                        this.highlightNext();
                        break;
                    case "PageUp":
                    case "Home":
                        this.highlightFirst();
                        break;
                    case "PageDown":
                    case "End":
                        this.highlightLast();
                        break;
                    default:
                        return;
                }
                a.preventDefault();
                a.stopPropagation();
            }
        }
        getSize() {
            const a = this.getElement(), b = getSize$$module$build$src$core$utils$style(a);
            b.height = a.scrollHeight;
            return b;
        }
    }, module$build$src$core$menu = {};
    module$build$src$core$menu.Menu = Menu$$module$build$src$core$menu;
    var MenuItem$$module$build$src$core$menuitem = class {
        constructor(a, b){
            this.content = a;
            this.opt_value = b;
            this.enabled = !0;
            this.element = null;
            this.rightToLeft = !1;
            this.roleName = null;
            this.highlight = this.checked = this.checkable = !1;
            this.actionHandler = null;
        }
        createDom() {
            const a = document.createElement("div");
            a.id = getNextUniqueId$$module$build$src$core$utils$idgenerator();
            this.element = a;
            a.className = "blocklyMenuItem goog-menuitem " + (this.enabled ? "" : "blocklyMenuItemDisabled goog-menuitem-disabled ") + (this.checked ? "blocklyMenuItemSelected goog-option-selected " : "") + (this.highlight ? "blocklyMenuItemHighlight goog-menuitem-highlight " : "") + (this.rightToLeft ? "blocklyMenuItemRtl goog-menuitem-rtl " : "");
            const b = document.createElement("div");
            b.className = "blocklyMenuItemContent goog-menuitem-content";
            if (this.checkable) {
                var c = document.createElement("div");
                c.className = "blocklyMenuItemCheckbox goog-menuitem-checkbox";
                b.appendChild(c);
            }
            c = this.content;
            "string" === typeof this.content && (c = document.createTextNode(this.content));
            b.appendChild(c);
            a.appendChild(b);
            this.roleName && setRole$$module$build$src$core$utils$aria(a, this.roleName);
            setState$$module$build$src$core$utils$aria(a, State$$module$build$src$core$utils$aria.SELECTED, this.checkable && this.checked || !1);
            setState$$module$build$src$core$utils$aria(a, State$$module$build$src$core$utils$aria.DISABLED, !this.enabled);
            return a;
        }
        dispose() {
            this.element = null;
        }
        getElement() {
            return this.element;
        }
        getId() {
            return this.element.id;
        }
        getValue() {
            let a;
            return null != (a = this.opt_value) ? a : null;
        }
        setRightToLeft(a) {
            this.rightToLeft = a;
        }
        setRole(a) {
            this.roleName = a;
        }
        setCheckable(a) {
            this.checkable = a;
        }
        setChecked(a) {
            this.checked = a;
        }
        setHighlighted(a) {
            this.highlight = a;
            const b = this.getElement();
            b && this.isEnabled() && (a ? (addClass$$module$build$src$core$utils$dom(b, "blocklyMenuItemHighlight"), addClass$$module$build$src$core$utils$dom(b, "goog-menuitem-highlight")) : (removeClass$$module$build$src$core$utils$dom(b, "blocklyMenuItemHighlight"), removeClass$$module$build$src$core$utils$dom(b, "goog-menuitem-highlight")));
        }
        isEnabled() {
            return this.enabled;
        }
        setEnabled(a) {
            this.enabled = a;
        }
        performAction() {
            this.isEnabled() && this.actionHandler && this.actionHandler(this);
        }
        onAction(a, b) {
            this.actionHandler = a.bind(b);
        }
    }, module$build$src$core$menuitem = {};
    module$build$src$core$menuitem.MenuItem = MenuItem$$module$build$src$core$menuitem;
    var FieldDropdown$$module$build$src$core$field_dropdown = class extends Field$$module$build$src$core$field {
        constructor(a, b, c){
            super(Field$$module$build$src$core$field.SKIP_SETUP);
            this.svgArrow_ = this.arrow_ = this.imageElement_ = this.menu_ = this.selectedMenuItem_ = null;
            this.SERIALIZABLE = !0;
            this.CURSOR = "default";
            this.clickTarget_ = this.suffixField = this.prefixField = this.generatedOptions_ = null;
            a !== Field$$module$build$src$core$field.SKIP_SETUP && (Array.isArray(a) ? (validateOptions$$module$build$src$core$field_dropdown(a), a = trimOptions$$module$build$src$core$field_dropdown(a), this.menuGenerator_ = a.options, this.prefixField = a.prefix || null, this.suffixField = a.suffix || null) : this.menuGenerator_ = a, this.selectedOption_ = this.getOptions(!1)[0], c && this.configure_(c), this.setValue(this.selectedOption_[1]), b && this.setValidator(b));
        }
        fromXml(a) {
            this.isOptionListDynamic() && this.getOptions(!1);
            this.setValue(a.textContent);
        }
        loadState(a) {
            this.loadLegacyState(FieldDropdown$$module$build$src$core$field_dropdown, a) || (this.isOptionListDynamic() && this.getOptions(!1), this.setValue(a));
        }
        initView() {
            this.shouldAddBorderRect_() ? this.createBorderRect_() : this.clickTarget_ = this.sourceBlock_.getSvgRoot();
            this.createTextElement_();
            this.imageElement_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.IMAGE, {}, this.fieldGroup_);
            this.getConstants().FIELD_DROPDOWN_SVG_ARROW ? this.createSVGArrow_() : this.createTextArrow_();
            this.borderRect_ && addClass$$module$build$src$core$utils$dom(this.borderRect_, "blocklyDropdownRect");
        }
        shouldAddBorderRect_() {
            let a;
            return !this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW || this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW && !(null == (a = this.getSourceBlock()) ? 0 : a.isShadow());
        }
        createTextArrow_() {
            this.arrow_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.TSPAN, {}, this.textElement_);
            let a;
            this.arrow_.appendChild(document.createTextNode((null == (a = this.getSourceBlock()) ? 0 : a.RTL) ? FieldDropdown$$module$build$src$core$field_dropdown.ARROW_CHAR + " " : " " + FieldDropdown$$module$build$src$core$field_dropdown.ARROW_CHAR));
            let b;
            (null == (b = this.getSourceBlock()) ? 0 : b.RTL) ? this.getTextElement().insertBefore(this.arrow_, this.textContent_) : this.getTextElement().appendChild(this.arrow_);
        }
        createSVGArrow_() {
            this.svgArrow_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.IMAGE, {
                height: this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE + "px",
                width: this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE + "px"
            }, this.fieldGroup_);
            this.svgArrow_.setAttributeNS(XLINK_NS$$module$build$src$core$utils$dom, "xlink:href", this.getConstants().FIELD_DROPDOWN_SVG_ARROW_DATAURI);
        }
        showEditor_(a) {
            var b = this.getSourceBlock();
            if (!b) throw new UnattachedFieldError$$module$build$src$core$field;
            this.dropdownCreate_();
            this.menu_.openingCoords = a && "number" === typeof a.clientX ? new Coordinate$$module$build$src$core$utils$coordinate(a.clientX, a.clientY) : null;
            clearContent$$module$build$src$core$dropdowndiv();
            a = this.menu_.render(getContentDiv$$module$build$src$core$dropdowndiv());
            addClass$$module$build$src$core$utils$dom(a, "blocklyDropdownMenu");
            this.getConstants().FIELD_DROPDOWN_COLOURED_DIV && (a = b.isShadow() ? b.getParent().getColour() : b.getColour(), b = b.isShadow() ? b.getParent().style.colourTertiary : this.sourceBlock_.style.colourTertiary, setColour$$module$build$src$core$dropdowndiv(a, b));
            showPositionedByField$$module$build$src$core$dropdowndiv(this, this.dropdownDispose_.bind(this));
            this.menu_.focus();
            this.selectedMenuItem_ && (this.menu_.setHighlighted(this.selectedMenuItem_), scrollIntoContainerView$$module$build$src$core$utils$style(this.selectedMenuItem_.getElement(), getContentDiv$$module$build$src$core$dropdowndiv(), !0));
            this.applyColour();
        }
        dropdownCreate_() {
            const a = this.getSourceBlock();
            if (!a) throw new UnattachedFieldError$$module$build$src$core$field;
            const b = new Menu$$module$build$src$core$menu;
            b.setRole(Role$$module$build$src$core$utils$aria.LISTBOX);
            this.menu_ = b;
            const c = this.getOptions(!1);
            this.selectedMenuItem_ = null;
            for(let e = 0; e < c.length; e++){
                const [f, g] = c[e];
                if ("object" === typeof f) {
                    var d = new Image(f.width, f.height);
                    d.src = f.src;
                    d.alt = f.alt || "";
                } else d = f;
                d = new MenuItem$$module$build$src$core$menuitem(d, g);
                d.setRole(Role$$module$build$src$core$utils$aria.OPTION);
                d.setRightToLeft(a.RTL);
                d.setCheckable(!0);
                b.addChild(d);
                d.setChecked(g === this.value_);
                g === this.value_ && (this.selectedMenuItem_ = d);
                d.onAction(this.handleMenuActionEvent_, this);
            }
        }
        dropdownDispose_() {
            this.menu_ && this.menu_.dispose();
            this.selectedMenuItem_ = this.menu_ = null;
            this.applyColour();
        }
        handleMenuActionEvent_(a) {
            hideIfOwner$$module$build$src$core$dropdowndiv(this, !0);
            this.onItemSelected_(this.menu_, a);
        }
        onItemSelected_(a, b) {
            this.setValue(b.getValue());
        }
        isOptionListDynamic() {
            return "function" === typeof this.menuGenerator_;
        }
        getOptions(a) {
            if (!this.menuGenerator_) throw TypeError("A menu generator was never defined.");
            if (Array.isArray(this.menuGenerator_)) return this.menuGenerator_;
            if (a && this.generatedOptions_) return this.generatedOptions_;
            this.generatedOptions_ = this.menuGenerator_();
            validateOptions$$module$build$src$core$field_dropdown(this.generatedOptions_);
            return this.generatedOptions_;
        }
        doClassValidation_(a) {
            return this.getOptions(!0).some((b)=>b[1] === a) ? a : (this.sourceBlock_ && console.warn("Cannot set the dropdown's value to an unavailable option. Block type: " + this.sourceBlock_.type + ", Field name: " + this.name + ", Value: " + a), null);
        }
        doValueUpdate_(a) {
            super.doValueUpdate_(a);
            a = this.getOptions(!0);
            for(let b = 0, c; c = a[b]; b++)c[1] === this.value_ && (this.selectedOption_ = c);
        }
        applyColour() {
            const a = this.sourceBlock_.style;
            this.borderRect_ && (this.borderRect_.setAttribute("stroke", a.colourTertiary), this.menu_ ? this.borderRect_.setAttribute("fill", a.colourTertiary) : this.borderRect_.setAttribute("fill", "transparent"));
            this.sourceBlock_ && this.arrow_ && (this.sourceBlock_.isShadow() ? this.arrow_.style.fill = a.colourSecondary : this.arrow_.style.fill = a.colourPrimary);
        }
        render_() {
            this.getTextContent().nodeValue = "";
            this.imageElement_.style.display = "none";
            const a = this.selectedOption_ && this.selectedOption_[0];
            a && "object" === typeof a ? this.renderSelectedImage_(a) : this.renderSelectedText_();
            this.positionBorderRect_();
        }
        renderSelectedImage_(a) {
            const b = this.getSourceBlock();
            if (!b) throw new UnattachedFieldError$$module$build$src$core$field;
            this.imageElement_.style.display = "";
            this.imageElement_.setAttributeNS(XLINK_NS$$module$build$src$core$utils$dom, "xlink:href", a.src);
            this.imageElement_.setAttribute("height", String(a.height));
            this.imageElement_.setAttribute("width", String(a.width));
            const c = Number(a.height);
            a = Number(a.width);
            var d = !!this.borderRect_;
            const e = Math.max(d ? this.getConstants().FIELD_DROPDOWN_BORDER_RECT_HEIGHT : 0, c + IMAGE_Y_PADDING$$module$build$src$core$field_dropdown);
            d = d ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
            let f;
            f = this.svgArrow_ ? this.positionSVGArrow_(a + d, e / 2 - this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE / 2) : getFastTextWidth$$module$build$src$core$utils$dom(this.arrow_, this.getConstants().FIELD_TEXT_FONTSIZE, this.getConstants().FIELD_TEXT_FONTWEIGHT, this.getConstants().FIELD_TEXT_FONTFAMILY);
            this.size_.width = a + f + 2 * d;
            this.size_.height = e;
            let g = 0;
            b.RTL ? this.imageElement_.setAttribute("x", `${d + f}`) : (g = a + f, this.getTextElement().setAttribute("text-anchor", "end"), this.imageElement_.setAttribute("x", `${d}`));
            this.imageElement_.setAttribute("y", String(e / 2 - c / 2));
            this.positionTextElement_(g + d, a + f);
        }
        renderSelectedText_() {
            this.getTextContent().nodeValue = this.getDisplayText_();
            var a = this.getTextElement();
            addClass$$module$build$src$core$utils$dom(a, "blocklyDropdownText");
            a.setAttribute("text-anchor", "start");
            var b = !!this.borderRect_;
            a = Math.max(b ? this.getConstants().FIELD_DROPDOWN_BORDER_RECT_HEIGHT : 0, this.getConstants().FIELD_TEXT_HEIGHT);
            const c = getFastTextWidth$$module$build$src$core$utils$dom(this.getTextElement(), this.getConstants().FIELD_TEXT_FONTSIZE, this.getConstants().FIELD_TEXT_FONTWEIGHT, this.getConstants().FIELD_TEXT_FONTFAMILY);
            b = b ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
            let d = 0;
            this.svgArrow_ && (d = this.positionSVGArrow_(c + b, a / 2 - this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE / 2));
            this.size_.width = c + d + 2 * b;
            this.size_.height = a;
            this.positionTextElement_(b, c);
        }
        positionSVGArrow_(a, b) {
            if (!this.svgArrow_) return 0;
            const c = this.getSourceBlock();
            if (!c) throw new UnattachedFieldError$$module$build$src$core$field;
            const d = this.borderRect_ ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0, e = this.getConstants().FIELD_DROPDOWN_SVG_ARROW_PADDING, f = this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE;
            this.svgArrow_.setAttribute("transform", "translate(" + (c.RTL ? d : a + e) + "," + b + ")");
            return f + e;
        }
        getText_() {
            if (!this.selectedOption_) return null;
            const a = this.selectedOption_[0];
            return "object" === typeof a ? a.alt : a;
        }
        static fromJson(a) {
            if (!a.options) throw Error("options are required for the dropdown field. The options property must be assigned an array of [humanReadableValue, languageNeutralValue] tuples.");
            return new this(a.options, void 0, a);
        }
    };
    FieldDropdown$$module$build$src$core$field_dropdown.CHECKMARK_OVERHANG = 25;
    FieldDropdown$$module$build$src$core$field_dropdown.MAX_MENU_HEIGHT_VH = .45;
    FieldDropdown$$module$build$src$core$field_dropdown.ARROW_CHAR = "\u25BE";
    var IMAGE_Y_OFFSET$$module$build$src$core$field_dropdown = 5, IMAGE_Y_PADDING$$module$build$src$core$field_dropdown = 2 * IMAGE_Y_OFFSET$$module$build$src$core$field_dropdown;
    register$$module$build$src$core$field_registry("field_dropdown", FieldDropdown$$module$build$src$core$field_dropdown);
    var module$build$src$core$field_dropdown = {};
    module$build$src$core$field_dropdown.FieldDropdown = FieldDropdown$$module$build$src$core$field_dropdown;
    var BubbleOpen$$module$build$src$core$events$events_bubble_open = class extends UiBase$$module$build$src$core$events$events_ui_base {
        constructor(a, b, c){
            super(a ? a.workspace.id : void 0);
            this.type = BUBBLE_OPEN$$module$build$src$core$events$utils;
            a && (this.blockId = a.id, this.isOpen = b, this.bubbleType = c);
        }
        toJson() {
            const a = super.toJson();
            if (void 0 === this.isOpen) throw Error("Whether this event is for opening the bubble is undefined. Either pass the value to the constructor, or call fromJson");
            if (!this.bubbleType) throw Error("The type of bubble is undefined. Either pass the value to the constructor, or call fromJson");
            a.isOpen = this.isOpen;
            a.bubbleType = this.bubbleType;
            a.blockId = this.blockId || "";
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.BubbleOpen.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.isOpen = a.isOpen;
            this.bubbleType = a.bubbleType;
            this.blockId = a.blockId;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new BubbleOpen$$module$build$src$core$events$events_bubble_open);
            b.isOpen = a.isOpen;
            b.bubbleType = a.bubbleType;
            b.blockId = a.blockId;
            return b;
        }
    }, BubbleType$$module$build$src$core$events$events_bubble_open;
    (function(a) {
        a.MUTATOR = "mutator";
        a.COMMENT = "comment";
        a.WARNING = "warning";
    })(BubbleType$$module$build$src$core$events$events_bubble_open || (BubbleType$$module$build$src$core$events$events_bubble_open = {}));
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, BUBBLE_OPEN$$module$build$src$core$events$utils, BubbleOpen$$module$build$src$core$events$events_bubble_open);
    var module$build$src$core$events$events_bubble_open = {};
    module$build$src$core$events$events_bubble_open.BubbleOpen = BubbleOpen$$module$build$src$core$events$events_bubble_open;
    module$build$src$core$events$events_bubble_open.BubbleType = BubbleType$$module$build$src$core$events$events_bubble_open;
    var Scrollbar$$module$build$src$core$scrollbar = class {
        constructor(a, b, c, d, e){
            this.workspace = a;
            this.horizontal = b;
            this.oldHostMetrics = null;
            this.ratio = 1;
            this.origin = new Coordinate$$module$build$src$core$utils$coordinate(0, 0);
            this.startDragHandle = this.handlePosition = this.handleLength = this.scrollbarLength = this.startDragMouse = 0;
            this.containerVisible = this.isHandleVisible = !0;
            this.position = new Coordinate$$module$build$src$core$utils$coordinate(0, 0);
            this.onMouseMoveWrapper_ = this.onMouseUpWrapper_ = null;
            this.pair = c || !1;
            this.margin = void 0 !== e ? e : Scrollbar$$module$build$src$core$scrollbar.DEFAULT_SCROLLBAR_MARGIN;
            a = "blocklyScrollbar" + (this.horizontal ? "Horizontal" : "Vertical");
            d && (a += " " + d);
            this.outerSvg = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.SVG, {
                "class": a
            });
            d = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {}, this.outerSvg);
            this.svgBackground = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                "class": "blocklyScrollbarBackground"
            }, d);
            a = Math.floor((Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness - 5) / 2);
            this.svgHandle = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                "class": "blocklyScrollbarHandle",
                rx: a,
                ry: a
            }, d);
            this.workspace.getThemeManager().subscribe(this.svgHandle, "scrollbarColour", "fill");
            this.workspace.getThemeManager().subscribe(this.svgHandle, "scrollbarOpacity", "fill-opacity");
            insertAfter$$module$build$src$core$utils$dom(this.outerSvg, this.workspace.getParentSvg());
            this.setInitialThickness();
            b ? (this.lengthAttribute_ = "width", this.positionAttribute_ = "x") : (this.lengthAttribute_ = "height", this.positionAttribute_ = "y");
            this.onMouseDownBarWrapper_ = conditionalBind$$module$build$src$core$browser_events(this.svgBackground, "pointerdown", this, this.onMouseDownBar);
            this.onMouseDownHandleWrapper_ = conditionalBind$$module$build$src$core$browser_events(this.svgHandle, "pointerdown", this, this.onMouseDownHandle);
        }
        setInitialThickness() {
            const a = Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness;
            this.horizontal ? (this.svgBackground.setAttribute("height", String(a)), this.outerSvg.setAttribute("height", String(a)), this.svgHandle.setAttribute("height", String(a - 5)), this.svgHandle.setAttribute("y", "2.5")) : (this.svgBackground.setAttribute("width", String(a)), this.outerSvg.setAttribute("width", String(a)), this.svgHandle.setAttribute("width", String(a - 5)), this.svgHandle.setAttribute("x", "2.5"));
        }
        dispose() {
            this.cleanUp();
            unbind$$module$build$src$core$browser_events(this.onMouseDownBarWrapper_);
            unbind$$module$build$src$core$browser_events(this.onMouseDownHandleWrapper_);
            removeNode$$module$build$src$core$utils$dom(this.outerSvg);
            this.workspace.getThemeManager().unsubscribe(this.svgHandle);
        }
        constrainHandleLength(a) {
            return a = 0 >= a || isNaN(a) ? 0 : Math.min(a, this.scrollbarLength);
        }
        setHandleLength(a) {
            this.handleLength = a;
            this.svgHandle.setAttribute(this.lengthAttribute_, String(this.handleLength));
        }
        constrainHandlePosition(a) {
            return a = 0 >= a || isNaN(a) ? 0 : Math.min(a, this.scrollbarLength - this.handleLength);
        }
        setHandlePosition(a) {
            this.handlePosition = a;
            this.svgHandle.setAttribute(this.positionAttribute_, String(this.handlePosition));
        }
        setScrollbarLength(a) {
            this.scrollbarLength = a;
            this.outerSvg.setAttribute(this.lengthAttribute_, String(this.scrollbarLength));
            this.svgBackground.setAttribute(this.lengthAttribute_, String(this.scrollbarLength));
        }
        setPosition(a, b) {
            this.position.x = a;
            this.position.y = b;
            setCssTransform$$module$build$src$core$utils$dom(this.outerSvg, "translate(" + (this.position.x + this.origin.x) + "px," + (this.position.y + this.origin.y) + "px)");
        }
        resize(a) {
            if (!a && (a = this.workspace.getMetrics(), !a)) return;
            this.oldHostMetrics && Scrollbar$$module$build$src$core$scrollbar.metricsAreEquivalent(a, this.oldHostMetrics) || (this.horizontal ? this.resizeHorizontal(a) : this.resizeVertical(a), this.oldHostMetrics = a, this.updateMetrics());
        }
        requiresViewResize(a) {
            return this.oldHostMetrics ? this.oldHostMetrics.viewWidth !== a.viewWidth || this.oldHostMetrics.viewHeight !== a.viewHeight || this.oldHostMetrics.absoluteLeft !== a.absoluteLeft || this.oldHostMetrics.absoluteTop !== a.absoluteTop : !0;
        }
        resizeHorizontal(a) {
            this.requiresViewResize(a) ? this.resizeViewHorizontal(a) : this.resizeContentHorizontal(a);
        }
        resizeViewHorizontal(a) {
            var b = a.viewWidth - 2 * this.margin;
            this.pair && (b -= Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness);
            this.setScrollbarLength(Math.max(0, b));
            b = a.absoluteLeft + this.margin;
            this.pair && this.workspace.RTL && (b += Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness);
            this.setPosition(b, a.absoluteTop + a.viewHeight - Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness - this.margin);
            this.resizeContentHorizontal(a);
        }
        resizeContentHorizontal(a) {
            if (a.viewWidth >= a.scrollWidth) this.setHandleLength(this.scrollbarLength), this.setHandlePosition(0), this.pair || this.setVisible(!1);
            else {
                this.pair || this.setVisible(!0);
                var b = this.scrollbarLength * a.viewWidth / a.scrollWidth;
                b = this.constrainHandleLength(b);
                this.setHandleLength(b);
                b = a.scrollWidth - a.viewWidth;
                var c = this.scrollbarLength - this.handleLength;
                a = (a.viewLeft - a.scrollLeft) / b * c;
                a = this.constrainHandlePosition(a);
                this.setHandlePosition(a);
                this.ratio = c / b;
            }
        }
        resizeVertical(a) {
            this.requiresViewResize(a) ? this.resizeViewVertical(a) : this.resizeContentVertical(a);
        }
        resizeViewVertical(a) {
            let b = a.viewHeight - 2 * this.margin;
            this.pair && (b -= Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness);
            this.setScrollbarLength(Math.max(0, b));
            this.setPosition(this.workspace.RTL ? a.absoluteLeft + this.margin : a.absoluteLeft + a.viewWidth - Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness - this.margin, a.absoluteTop + this.margin);
            this.resizeContentVertical(a);
        }
        resizeContentVertical(a) {
            if (a.viewHeight >= a.scrollHeight) this.setHandleLength(this.scrollbarLength), this.setHandlePosition(0), this.pair || this.setVisible(!1);
            else {
                this.pair || this.setVisible(!0);
                var b = this.scrollbarLength * a.viewHeight / a.scrollHeight;
                b = this.constrainHandleLength(b);
                this.setHandleLength(b);
                b = a.scrollHeight - a.viewHeight;
                var c = this.scrollbarLength - this.handleLength;
                a = (a.viewTop - a.scrollTop) / b * c;
                a = this.constrainHandlePosition(a);
                this.setHandlePosition(a);
                this.ratio = c / b;
            }
        }
        isVisible() {
            return this.isHandleVisible;
        }
        setContainerVisible(a) {
            const b = a !== this.containerVisible;
            this.containerVisible = a;
            b && this.updateDisplay_();
        }
        setVisible(a) {
            const b = a !== this.isVisible();
            if (this.pair) throw Error("Unable to toggle visibility of paired scrollbars.");
            this.isHandleVisible = a;
            b && this.updateDisplay_();
        }
        updateDisplay_() {
            this.containerVisible && this.isVisible() ? this.outerSvg.setAttribute("display", "block") : this.outerSvg.setAttribute("display", "none");
        }
        onMouseDownBar(a) {
            this.workspace.markFocused();
            clearTouchIdentifier$$module$build$src$core$touch();
            this.cleanUp();
            if (isRightButton$$module$build$src$core$browser_events(a)) a.stopPropagation();
            else {
                var b = mouseToSvg$$module$build$src$core$browser_events(a, this.workspace.getParentSvg(), this.workspace.getInverseScreenCTM());
                b = this.horizontal ? b.x : b.y;
                var c = getInjectionDivXY$$module$build$src$core$utils$svg_math(this.svgHandle);
                c = this.horizontal ? c.x : c.y;
                var d = this.handlePosition, e = .95 * this.handleLength;
                b <= c ? d -= e : b >= c + this.handleLength && (d += e);
                this.setHandlePosition(this.constrainHandlePosition(d));
                this.updateMetrics();
                a.stopPropagation();
                a.preventDefault();
            }
        }
        onMouseDownHandle(a) {
            this.workspace.markFocused();
            this.cleanUp();
            isRightButton$$module$build$src$core$browser_events(a) ? a.stopPropagation() : (this.startDragHandle = this.handlePosition, this.workspace.setupDragSurface(), this.startDragMouse = this.horizontal ? a.clientX : a.clientY, this.onMouseUpWrapper_ = conditionalBind$$module$build$src$core$browser_events(document, "pointerup", this, this.onMouseUpHandle), this.onMouseMoveWrapper_ = conditionalBind$$module$build$src$core$browser_events(document, "pointermove", this, this.onMouseMoveHandle), a.stopPropagation(), a.preventDefault());
        }
        onMouseMoveHandle(a) {
            this.setHandlePosition(this.constrainHandlePosition(this.startDragHandle + ((this.horizontal ? a.clientX : a.clientY) - this.startDragMouse)));
            this.updateMetrics();
        }
        onMouseUpHandle() {
            this.workspace.resetDragSurface();
            clearTouchIdentifier$$module$build$src$core$touch();
            this.cleanUp();
        }
        cleanUp() {
            this.workspace.hideChaff(!0);
            this.onMouseUpWrapper_ && (unbind$$module$build$src$core$browser_events(this.onMouseUpWrapper_), this.onMouseUpWrapper_ = null);
            this.onMouseMoveWrapper_ && (unbind$$module$build$src$core$browser_events(this.onMouseMoveWrapper_), this.onMouseMoveWrapper_ = null);
        }
        getRatio_() {
            let a = this.handlePosition / (this.scrollbarLength - this.handleLength);
            isNaN(a) && (a = 0);
            return a;
        }
        updateMetrics() {
            const a = this.getRatio_();
            this.horizontal ? this.workspace.setMetrics({
                x: a
            }) : this.workspace.setMetrics({
                y: a
            });
        }
        set(a, b) {
            this.setHandlePosition(this.constrainHandlePosition(a * this.ratio));
            (b || void 0 === b) && this.updateMetrics();
        }
        setOrigin(a, b) {
            this.origin = new Coordinate$$module$build$src$core$utils$coordinate(a, b);
        }
        static metricsAreEquivalent(a, b) {
            return a.viewWidth === b.viewWidth && a.viewHeight === b.viewHeight && a.viewLeft === b.viewLeft && a.viewTop === b.viewTop && a.absoluteTop === b.absoluteTop && a.absoluteLeft === b.absoluteLeft && a.scrollWidth === b.scrollWidth && a.scrollHeight === b.scrollHeight && a.scrollLeft === b.scrollLeft && a.scrollTop === b.scrollTop;
        }
    };
    Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness = TOUCH_ENABLED$$module$build$src$core$touch ? 25 : 15;
    Scrollbar$$module$build$src$core$scrollbar.DEFAULT_SCROLLBAR_MARGIN = .5;
    var module$build$src$core$scrollbar = {};
    module$build$src$core$scrollbar.Scrollbar = Scrollbar$$module$build$src$core$scrollbar;
    var Bubble$$module$build$src$core$bubble = class {
        constructor(a, b, c, d, e, f){
            this.resizeGroup = this.bubbleBack = this.bubbleArrow = this.bubbleGroup = null;
            this.height = this.width = this.relativeTop = this.relativeLeft = 0;
            this.autoLayout = !0;
            this.onMouseDownResizeWrapper = this.onMouseDownBubbleWrapper = this.moveCallback = this.resizeCallback = null;
            this.rendered = this.disposed = !1;
            this.workspace_ = a;
            this.content_ = b;
            this.shape_ = c;
            c = Bubble$$module$build$src$core$bubble.ARROW_ANGLE;
            this.workspace_.RTL && (c = -c);
            this.arrowRadians = toRadians$$module$build$src$core$utils$math(c);
            a.getBubbleCanvas().appendChild(this.createDom(b, !(!e || !f)));
            this.setAnchorLocation(d);
            e && f || (a = this.content_.getBBox(), e = a.width + 2 * Bubble$$module$build$src$core$bubble.BORDER_WIDTH, f = a.height + 2 * Bubble$$module$build$src$core$bubble.BORDER_WIDTH);
            this.setBubbleSize(e, f);
            this.positionBubble();
            this.renderArrow();
            this.rendered = !0;
        }
        createDom(a, b) {
            this.bubbleGroup = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {});
            var c = {
                filter: "url(#" + this.workspace_.getRenderer().getConstants().embossFilterId + ")"
            };
            JavaFx$$module$build$src$core$utils$useragent && (c = {});
            c = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, c, this.bubbleGroup);
            this.bubbleArrow = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATH, {}, c);
            this.bubbleBack = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                "class": "blocklyDraggable",
                x: 0,
                y: 0,
                rx: Bubble$$module$build$src$core$bubble.BORDER_WIDTH,
                ry: Bubble$$module$build$src$core$bubble.BORDER_WIDTH
            }, c);
            b ? (this.resizeGroup = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {
                "class": this.workspace_.RTL ? "blocklyResizeSW" : "blocklyResizeSE"
            }, this.bubbleGroup), b = 2 * Bubble$$module$build$src$core$bubble.BORDER_WIDTH, createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.POLYGON, {
                points: `0,${b} ${b},${b} ${b},0`
            }, this.resizeGroup), createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.LINE, {
                "class": "blocklyResizeLine",
                x1: b / 3,
                y1: b - 1,
                x2: b - 1,
                y2: b / 3
            }, this.resizeGroup), createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.LINE, {
                "class": "blocklyResizeLine",
                x1: 2 * b / 3,
                y1: b - 1,
                x2: b - 1,
                y2: 2 * b / 3
            }, this.resizeGroup)) : this.resizeGroup = null;
            this.workspace_.options.readOnly || (this.onMouseDownBubbleWrapper = conditionalBind$$module$build$src$core$browser_events(this.bubbleBack, "pointerdown", this, this.bubbleMouseDown), this.resizeGroup && (this.onMouseDownResizeWrapper = conditionalBind$$module$build$src$core$browser_events(this.resizeGroup, "pointerdown", this, this.resizeMouseDown)));
            this.bubbleGroup.appendChild(a);
            return this.bubbleGroup;
        }
        getSvgRoot() {
            return this.bubbleGroup;
        }
        setSvgId(a) {
            let b;
            null == (b = this.bubbleGroup) || b.setAttribute("data-block-id", a);
        }
        bubbleMouseDown(a) {
            const b = this.workspace_.getGesture(a);
            b && b.handleBubbleStart(a, this);
        }
        showContextMenu(a) {}
        isDeletable() {
            return !1;
        }
        setDeleteStyle(a) {}
        resizeMouseDown(a) {
            this.promote();
            Bubble$$module$build$src$core$bubble.unbindDragEvents();
            isRightButton$$module$build$src$core$browser_events(a) || (this.workspace_.startDrag(a, new Coordinate$$module$build$src$core$utils$coordinate(this.workspace_.RTL ? -this.width : this.width, this.height)), Bubble$$module$build$src$core$bubble.onMouseUpWrapper = conditionalBind$$module$build$src$core$browser_events(document, "pointerup", this, Bubble$$module$build$src$core$bubble.bubbleMouseUp), Bubble$$module$build$src$core$bubble.onMouseMoveWrapper = conditionalBind$$module$build$src$core$browser_events(document, "pointermove", this, this.resizeMouseMove), this.workspace_.hideChaff());
            a.stopPropagation();
        }
        resizeMouseMove(a) {
            this.autoLayout = !1;
            a = this.workspace_.moveDrag(a);
            this.setBubbleSize(this.workspace_.RTL ? -a.x : a.x, a.y);
            this.workspace_.RTL && this.positionBubble();
        }
        registerResizeEvent(a) {
            this.resizeCallback = a;
        }
        registerMoveEvent(a) {
            this.moveCallback = a;
        }
        promote() {
            let a;
            const b = null == (a = this.bubbleGroup) ? void 0 : a.parentNode;
            return (null == b ? void 0 : b.lastChild) !== this.bubbleGroup && this.bubbleGroup ? (null == b || b.appendChild(this.bubbleGroup), !0) : !1;
        }
        setAnchorLocation(a) {
            this.anchorXY = a;
            this.rendered && this.positionBubble();
        }
        layoutBubble() {
            var a = this.workspace_.getMetricsManager().getViewMetrics(!0), b = this.getOptimalRelativeLeft(a), c = this.getOptimalRelativeTop(a), d = this.shape_.getBBox();
            const e = {
                x: b,
                y: -this.height - this.workspace_.getRenderer().getConstants().MIN_BLOCK_HEIGHT
            }, f = {
                x: -this.width - 30,
                y: c
            };
            c = {
                x: d.width,
                y: c
            };
            var g = {
                x: b,
                y: d.height
            };
            b = d.width < d.height ? c : g;
            d = d.width < d.height ? g : c;
            c = this.getOverlap(e, a);
            g = this.getOverlap(f, a);
            const h = this.getOverlap(b, a);
            a = this.getOverlap(d, a);
            a = Math.max(c, g, h, a);
            c === a ? (this.relativeLeft = e.x, this.relativeTop = e.y) : g === a ? (this.relativeLeft = f.x, this.relativeTop = f.y) : h === a ? (this.relativeLeft = b.x, this.relativeTop = b.y) : (this.relativeLeft = d.x, this.relativeTop = d.y);
        }
        getOverlap(a, b) {
            var c = this.workspace_.RTL ? this.anchorXY.x - a.x - this.width : a.x + this.anchorXY.x;
            a = a.y + this.anchorXY.y;
            return Math.max(0, Math.min(1, (Math.min(c + this.width, b.left + b.width) - Math.max(c, b.left)) * (Math.min(a + this.height, b.top + b.height) - Math.max(a, b.top)) / (this.width * this.height)));
        }
        getOptimalRelativeLeft(a) {
            let b = -this.width / 4;
            if (this.width > a.width) return b;
            if (this.workspace_.RTL) {
                var c = this.anchorXY.x - b, d = a.left + a.width;
                a = a.left + Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness / this.workspace_.scale;
                c - this.width < a ? b = -(a - this.anchorXY.x + this.width) : c > d && (b = -(d - this.anchorXY.x));
            } else {
                c = b + this.anchorXY.x;
                d = c + this.width;
                const e = a.left;
                a = a.left + a.width - Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness / this.workspace_.scale;
                c < e ? b = e - this.anchorXY.x : d > a && (b = a - this.anchorXY.x - this.width);
            }
            return b;
        }
        getOptimalRelativeTop(a) {
            let b = -this.height / 4;
            if (this.height > a.height) return b;
            const c = this.anchorXY.y + b, d = c + this.height, e = a.top;
            a = a.top + a.height - Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness / this.workspace_.scale;
            const f = this.anchorXY.y;
            c < e ? b = e - f : d > a && (b = a - f - this.height);
            return b;
        }
        positionBubble() {
            let a = this.anchorXY.x;
            a = this.workspace_.RTL ? a - (this.relativeLeft + this.width) : a + this.relativeLeft;
            this.moveTo(a, this.relativeTop + this.anchorXY.y);
        }
        moveTo(a, b) {
            let c;
            null == (c = this.bubbleGroup) || c.setAttribute("transform", "translate(" + a + "," + b + ")");
        }
        setDragging(a) {
            !a && this.moveCallback && this.moveCallback();
        }
        getBubbleSize() {
            return new Size$$module$build$src$core$utils$size(this.width, this.height);
        }
        setBubbleSize(a, b) {
            const c = 2 * Bubble$$module$build$src$core$bubble.BORDER_WIDTH;
            a = Math.max(a, c + 45);
            b = Math.max(b, c + 20);
            this.width = a;
            this.height = b;
            let d;
            null == (d = this.bubbleBack) || d.setAttribute("width", `${a}`);
            let e;
            null == (e = this.bubbleBack) || e.setAttribute("height", `${b}`);
            this.resizeGroup && (this.workspace_.RTL ? this.resizeGroup.setAttribute("transform", "translate(" + 2 * Bubble$$module$build$src$core$bubble.BORDER_WIDTH + "," + (b - c) + ") scale(-1 1)") : this.resizeGroup.setAttribute("transform", "translate(" + (a - c) + "," + (b - c) + ")"));
            this.autoLayout && this.layoutBubble();
            this.positionBubble();
            this.renderArrow();
            this.resizeCallback && this.resizeCallback();
        }
        renderArrow() {
            const a = [];
            var b = this.width / 2, c = this.height / 2, d = -this.relativeLeft, e = -this.relativeTop;
            if (b === d && c === e) a.push("M " + b + "," + c);
            else {
                e -= c;
                d -= b;
                this.workspace_.RTL && (d *= -1);
                var f = Math.sqrt(e * e + d * d), g = Math.acos(d / f);
                0 > e && (g = 2 * Math.PI - g);
                var h = g + Math.PI / 2;
                h > 2 * Math.PI && (h -= 2 * Math.PI);
                var k = Math.sin(h);
                const n = Math.cos(h);
                var l = this.getBubbleSize();
                h = (l.width + l.height) / Bubble$$module$build$src$core$bubble.ARROW_THICKNESS;
                h = Math.min(h, l.width, l.height) / 4;
                l = 1 - Bubble$$module$build$src$core$bubble.ANCHOR_RADIUS / f;
                d = b + l * d;
                e = c + l * e;
                l = b + h * n;
                const p = c + h * k;
                b -= h * n;
                c -= h * k;
                k = g + this.arrowRadians;
                k > 2 * Math.PI && (k -= 2 * Math.PI);
                g = Math.sin(k) * f / Bubble$$module$build$src$core$bubble.ARROW_BEND;
                f = Math.cos(k) * f / Bubble$$module$build$src$core$bubble.ARROW_BEND;
                a.push("M" + l + "," + p);
                a.push("C" + (l + f) + "," + (p + g) + " " + d + "," + e + " " + d + "," + e);
                a.push("C" + d + "," + e + " " + (b + f) + "," + (c + g) + " " + b + "," + c);
            }
            a.push("z");
            let m;
            null == (m = this.bubbleArrow) || m.setAttribute("d", a.join(" "));
        }
        setColour(a) {
            let b;
            null == (b = this.bubbleBack) || b.setAttribute("fill", a);
            let c;
            null == (c = this.bubbleArrow) || c.setAttribute("fill", a);
        }
        dispose() {
            this.onMouseDownBubbleWrapper && unbind$$module$build$src$core$browser_events(this.onMouseDownBubbleWrapper);
            this.onMouseDownResizeWrapper && unbind$$module$build$src$core$browser_events(this.onMouseDownResizeWrapper);
            Bubble$$module$build$src$core$bubble.unbindDragEvents();
            removeNode$$module$build$src$core$utils$dom(this.bubbleGroup);
            this.disposed = !0;
        }
        moveDuringDrag(a, b) {
            a ? a.translateSurface(b.x, b.y) : this.moveTo(b.x, b.y);
            this.relativeLeft = this.workspace_.RTL ? this.anchorXY.x - b.x - this.width : b.x - this.anchorXY.x;
            this.relativeTop = b.y - this.anchorXY.y;
            this.renderArrow();
        }
        getRelativeToSurfaceXY() {
            return new Coordinate$$module$build$src$core$utils$coordinate(this.workspace_.RTL ? -this.relativeLeft + this.anchorXY.x - this.width : this.anchorXY.x + this.relativeLeft, this.anchorXY.y + this.relativeTop);
        }
        setAutoLayout(a) {
            this.autoLayout = a;
        }
        static unbindDragEvents() {
            Bubble$$module$build$src$core$bubble.onMouseUpWrapper && (unbind$$module$build$src$core$browser_events(Bubble$$module$build$src$core$bubble.onMouseUpWrapper), Bubble$$module$build$src$core$bubble.onMouseUpWrapper = null);
            Bubble$$module$build$src$core$bubble.onMouseMoveWrapper && (unbind$$module$build$src$core$browser_events(Bubble$$module$build$src$core$bubble.onMouseMoveWrapper), Bubble$$module$build$src$core$bubble.onMouseMoveWrapper = null);
        }
        static bubbleMouseUp(a) {
            clearTouchIdentifier$$module$build$src$core$touch();
            Bubble$$module$build$src$core$bubble.unbindDragEvents();
        }
        static textToDom(a) {
            const b = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.TEXT, {
                "class": "blocklyText blocklyBubbleText blocklyNoPointerEvents",
                y: Bubble$$module$build$src$core$bubble.BORDER_WIDTH
            });
            a = a.split("\n");
            for(let c = 0; c < a.length; c++){
                const d = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.TSPAN, {
                    dy: "1em",
                    x: Bubble$$module$build$src$core$bubble.BORDER_WIDTH
                }, b), e = document.createTextNode(a[c]);
                d.appendChild(e);
            }
            return b;
        }
        static createNonEditableBubble(a, b, c) {
            c = new Bubble$$module$build$src$core$bubble(b.workspace, a, b.pathObject.svgPath, c, null, null);
            c.setSvgId(b.id);
            if (b.RTL) {
                b = a.getBBox().width;
                for(let d = 0, e; e = a.childNodes[d]; d++)e.setAttribute("text-anchor", "end"), e.setAttribute("x", String(b + Bubble$$module$build$src$core$bubble.BORDER_WIDTH));
            }
            return c;
        }
    };
    Bubble$$module$build$src$core$bubble.BORDER_WIDTH = 6;
    Bubble$$module$build$src$core$bubble.ARROW_THICKNESS = 5;
    Bubble$$module$build$src$core$bubble.ARROW_ANGLE = 20;
    Bubble$$module$build$src$core$bubble.ARROW_BEND = 4;
    Bubble$$module$build$src$core$bubble.ANCHOR_RADIUS = 8;
    Bubble$$module$build$src$core$bubble.onMouseUpWrapper = null;
    Bubble$$module$build$src$core$bubble.onMouseMoveWrapper = null;
    var module$build$src$core$bubble = {};
    module$build$src$core$bubble.Bubble = Bubble$$module$build$src$core$bubble;
    var DEFAULT_SNAP_RADIUS$$module$build$src$core$config, module$build$src$core$config;
    DEFAULT_SNAP_RADIUS$$module$build$src$core$config = 28;
    $.config$$module$build$src$core$config = {
        dragRadius: 5,
        flyoutDragRadius: 10,
        snapRadius: DEFAULT_SNAP_RADIUS$$module$build$src$core$config,
        connectingSnapRadius: DEFAULT_SNAP_RADIUS$$module$build$src$core$config,
        currentConnectionPreference: 8,
        bumpDelay: 250
    };
    module$build$src$core$config = {};
    module$build$src$core$config.config = $.config$$module$build$src$core$config;
    var Icon$$module$build$src$core$icon = class {
        constructor(a){
            this.iconGroup_ = null;
            this.collapseHidden = !0;
            this.SIZE = 17;
            this.iconXY_ = this.bubble_ = null;
            a || warn$$module$build$src$core$utils$deprecation("Calling the Icon constructor with a null block", "version 9", "version 10", "a non-null block");
            this.block_ = a;
        }
        createIcon() {
            this.iconGroup_ || (this.iconGroup_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {
                "class": "blocklyIconGroup"
            }), this.getBlock().isInFlyout && addClass$$module$build$src$core$utils$dom(this.iconGroup_, "blocklyIconGroupReadonly"), this.drawIcon_(this.iconGroup_), this.getBlock().getSvgRoot().appendChild(this.iconGroup_), conditionalBind$$module$build$src$core$browser_events(this.iconGroup_, "pointerup", this, this.iconClick_), this.updateEditable());
        }
        dispose() {
            this.getBlock().isDeadOrDying() || removeNode$$module$build$src$core$utils$dom(this.iconGroup_);
            this.setVisible(!1);
        }
        updateEditable() {}
        isVisible() {
            return !!this.bubble_;
        }
        iconClick_(a) {
            this.getBlock().workspace.isDragging() || this.getBlock().isInFlyout || isRightButton$$module$build$src$core$browser_events(a) || this.setVisible(!this.isVisible());
        }
        applyColour() {
            this.bubble_ && this.isVisible() && this.bubble_.setColour(this.getBlock().style.colourPrimary);
        }
        setIconLocation(a) {
            this.iconXY_ = a;
            this.bubble_ && this.isVisible() && this.bubble_.setAnchorLocation(a);
        }
        computeIconLocation() {
            var a = this.getBlock().getRelativeToSurfaceXY();
            const b = getRelativeXY$$module$build$src$core$utils$svg_math(this.iconGroup_);
            a = new Coordinate$$module$build$src$core$utils$coordinate(a.x + b.x + this.SIZE / 2, a.y + b.y + this.SIZE / 2);
            Coordinate$$module$build$src$core$utils$coordinate.equals(this.getIconLocation(), a) || this.setIconLocation(a);
        }
        getIconLocation() {
            return this.iconXY_;
        }
        getCorrectedSize() {
            return new Size$$module$build$src$core$utils$size(this.SIZE, this.SIZE - 2);
        }
        drawIcon_(a) {}
        setVisible(a) {}
        getBlock() {
            if (!this.block_) throw Error("Block is not set for this icon.");
            return this.block_;
        }
    }, module$build$src$core$icon = {};
    module$build$src$core$icon.Icon = Icon$$module$build$src$core$icon;
    var module$build$src$core$utils$object = {};
    module$build$src$core$utils$object.deepMerge = deepMerge$$module$build$src$core$utils$object;
    module$build$src$core$utils$object.inherits = inherits$$module$build$src$core$utils$object;
    module$build$src$core$utils$object.mixin = mixin$$module$build$src$core$utils$object;
    module$build$src$core$utils$object.values = values$$module$build$src$core$utils$object;
    var Theme$$module$build$src$core$theme = class {
        constructor(a, b, c, d){
            this.name = a;
            this.startHats = !1;
            this.blockStyles = b || Object.create(null);
            this.categoryStyles = c || Object.create(null);
            this.componentStyles = d || Object.create(null);
            this.fontStyle = Object.create(null);
            register$$module$build$src$core$registry(Type$$module$build$src$core$registry.THEME, a, this);
        }
        getClassName() {
            return this.name + "-theme";
        }
        setBlockStyle(a, b) {
            this.blockStyles[a] = b;
        }
        setCategoryStyle(a, b) {
            this.categoryStyles[a] = b;
        }
        getComponentStyle(a) {
            a = this.componentStyles[a];
            if (!a) return null;
            if ("string" === typeof a) {
                const b = this.getComponentStyle(a);
                if (b) return b;
            }
            return `${a}`;
        }
        setComponentStyle(a, b) {
            this.componentStyles[a] = b;
        }
        setFontStyle(a) {
            this.fontStyle = a;
        }
        setStartHats(a) {
            this.startHats = a;
        }
        static defineTheme(a, b) {
            a = a.toLowerCase();
            const c = new Theme$$module$build$src$core$theme(a);
            let d = b.base;
            if (d) {
                if ("string" === typeof d) {
                    let e;
                    d = null != (e = getObject$$module$build$src$core$registry(Type$$module$build$src$core$registry.THEME, d)) ? e : void 0;
                }
                d instanceof Theme$$module$build$src$core$theme && (deepMerge$$module$build$src$core$utils$object(c, d), c.name = a);
            }
            deepMerge$$module$build$src$core$utils$object(c.blockStyles, b.blockStyles);
            deepMerge$$module$build$src$core$utils$object(c.categoryStyles, b.categoryStyles);
            deepMerge$$module$build$src$core$utils$object(c.componentStyles, b.componentStyles);
            deepMerge$$module$build$src$core$utils$object(c.fontStyle, b.fontStyle);
            null !== b.startHats && (c.startHats = b.startHats);
            return c;
        }
    }, module$build$src$core$theme = {};
    module$build$src$core$theme.Theme = Theme$$module$build$src$core$theme;
    var defaultBlockStyles$$module$build$src$core$theme$classic = {
        colour_blocks: {
            colourPrimary: "20"
        },
        list_blocks: {
            colourPrimary: "260"
        },
        logic_blocks: {
            colourPrimary: "210"
        },
        loop_blocks: {
            colourPrimary: "120"
        },
        math_blocks: {
            colourPrimary: "230"
        },
        procedure_blocks: {
            colourPrimary: "290"
        },
        text_blocks: {
            colourPrimary: "160"
        },
        variable_blocks: {
            colourPrimary: "330"
        },
        variable_dynamic_blocks: {
            colourPrimary: "310"
        },
        hat_blocks: {
            colourPrimary: "330",
            hat: "cap"
        }
    }, categoryStyles$$module$build$src$core$theme$classic = {
        colour_category: {
            colour: "20"
        },
        list_category: {
            colour: "260"
        },
        logic_category: {
            colour: "210"
        },
        loop_category: {
            colour: "120"
        },
        math_category: {
            colour: "230"
        },
        procedure_category: {
            colour: "290"
        },
        text_category: {
            colour: "160"
        },
        variable_category: {
            colour: "330"
        },
        variable_dynamic_category: {
            colour: "310"
        }
    }, Classic$$module$build$src$core$theme$classic = new Theme$$module$build$src$core$theme("classic", defaultBlockStyles$$module$build$src$core$theme$classic, categoryStyles$$module$build$src$core$theme$classic), module$build$src$core$theme$classic = {};
    module$build$src$core$theme$classic.Classic = Classic$$module$build$src$core$theme$classic;
    var CATEGORY_TOOLBOX_KIND$$module$build$src$core$utils$toolbox = "categoryToolbox", FLYOUT_TOOLBOX_KIND$$module$build$src$core$utils$toolbox = "flyoutToolbox", Position$$module$build$src$core$utils$toolbox;
    (function(a) {
        a[a.TOP = 0] = "TOP";
        a[a.BOTTOM = 1] = "BOTTOM";
        a[a.LEFT = 2] = "LEFT";
        a[a.RIGHT = 3] = "RIGHT";
    })(Position$$module$build$src$core$utils$toolbox || (Position$$module$build$src$core$utils$toolbox = {}));
    var TEST_ONLY$$module$build$src$core$utils$toolbox = {
        hasCategoriesInternal: hasCategoriesInternal$$module$build$src$core$utils$toolbox
    }, module$build$src$core$utils$toolbox = {};
    module$build$src$core$utils$toolbox.Position = Position$$module$build$src$core$utils$toolbox;
    module$build$src$core$utils$toolbox.TEST_ONLY = TEST_ONLY$$module$build$src$core$utils$toolbox;
    module$build$src$core$utils$toolbox.convertFlyoutDefToJsonArray = convertFlyoutDefToJsonArray$$module$build$src$core$utils$toolbox;
    module$build$src$core$utils$toolbox.convertToolboxDefToJson = convertToolboxDefToJson$$module$build$src$core$utils$toolbox;
    module$build$src$core$utils$toolbox.hasCategories = hasCategories$$module$build$src$core$utils$toolbox;
    module$build$src$core$utils$toolbox.isCategoryCollapsible = isCategoryCollapsible$$module$build$src$core$utils$toolbox;
    module$build$src$core$utils$toolbox.parseToolboxTree = parseToolboxTree$$module$build$src$core$utils$toolbox;
    var Options$$module$build$src$core$options = class {
        constructor(a){
            this.gridPattern = null;
            this.getMetrics = this.setMetrics = void 0;
            let b = null, c = !1;
            var d = !1, e = !1, f = !1, g = !1, h = !1;
            const k = !!a.readOnly;
            if (!k) {
                var l;
                b = convertToolboxDefToJson$$module$build$src$core$utils$toolbox(null != (l = a.toolbox) ? l : null);
                c = hasCategories$$module$build$src$core$utils$toolbox(b);
                d = a.trashcan;
                d = void 0 === d ? c : d;
                e = a.collapse;
                e = void 0 === e ? c : e;
                f = a.comments;
                f = void 0 === f ? c : f;
                g = a.disable;
                g = void 0 === g ? c : g;
                h = a.sounds;
                h = void 0 === h ? !0 : h;
            }
            l = a.maxTrashcanContents;
            d ? void 0 === l && (l = 32) : l = 0;
            const m = !!a.rtl;
            let n = a.horizontalLayout;
            void 0 === n && (n = !1);
            var p = "end" !== a.toolboxPosition;
            p = n ? p ? Position$$module$build$src$core$utils$toolbox.TOP : Position$$module$build$src$core$utils$toolbox.BOTTOM : p === m ? Position$$module$build$src$core$utils$toolbox.RIGHT : Position$$module$build$src$core$utils$toolbox.LEFT;
            let q = a.css;
            void 0 === q && (q = !0);
            let r = "https://blockly-demo.appspot.com/static/media/";
            a.media ? r = a.media.endsWith("/") ? a.media : a.media + "/" : "path" in a && (warn$$module$build$src$core$utils$deprecation("path", "Nov 2014", "Jul 2023", "media"), r = a.path + "media/");
            const u = a.oneBasedIndex, y = a.renderer || "geras", z = a.plugins || {};
            let t = a.modalInputs;
            void 0 === t && (t = !0);
            this.RTL = m;
            this.oneBasedIndex = void 0 === u ? !0 : u;
            this.collapse = e;
            this.comments = f;
            this.disable = g;
            this.readOnly = k;
            this.maxBlocks = a.maxBlocks || Infinity;
            let v;
            this.maxInstances = null != (v = a.maxInstances) ? v : null;
            this.modalInputs = t;
            this.pathToMedia = r;
            this.hasCategories = c;
            this.moveOptions = Options$$module$build$src$core$options.parseMoveOptions_(a, c);
            this.hasScrollbars = !!this.moveOptions.scrollbars;
            this.hasTrashcan = d;
            this.maxTrashcanContents = l;
            this.hasSounds = h;
            this.hasCss = q;
            this.horizontalLayout = n;
            this.languageTree = b;
            this.gridOptions = Options$$module$build$src$core$options.parseGridOptions_(a);
            this.zoomOptions = Options$$module$build$src$core$options.parseZoomOptions_(a);
            this.toolboxPosition = p;
            this.theme = Options$$module$build$src$core$options.parseThemeOptions_(a);
            this.renderer = y;
            let w;
            this.rendererOverrides = null != (w = a.rendererOverrides) ? w : null;
            let x;
            this.parentWorkspace = null != (x = a.parentWorkspace) ? x : null;
            this.plugins = z;
        }
        static parseMoveOptions_(a, b) {
            const c = a.move || {}, d = {};
            void 0 === c.scrollbars && void 0 === a.scrollbars ? d.scrollbars = b : "object" === typeof c.scrollbars ? (d.scrollbars = {
                horizontal: !!c.scrollbars.horizontal,
                vertical: !!c.scrollbars.vertical
            }, d.scrollbars.horizontal && d.scrollbars.vertical ? d.scrollbars = !0 : d.scrollbars.horizontal || d.scrollbars.vertical || (d.scrollbars = !1)) : d.scrollbars = !!c.scrollbars || !!a.scrollbars;
            d.wheel = d.scrollbars && void 0 !== c.wheel ? !!c.wheel : "object" === typeof d.scrollbars;
            d.drag = d.scrollbars ? void 0 === c.drag ? !0 : !!c.drag : !1;
            return d;
        }
        static parseZoomOptions_(a) {
            a = a.zoom || {};
            const b = {};
            b.controls = void 0 === a.controls ? !1 : !!a.controls;
            b.wheel = void 0 === a.wheel ? !1 : !!a.wheel;
            b.startScale = void 0 === a.startScale ? 1 : Number(a.startScale);
            b.maxScale = void 0 === a.maxScale ? 3 : Number(a.maxScale);
            b.minScale = void 0 === a.minScale ? .3 : Number(a.minScale);
            b.scaleSpeed = void 0 === a.scaleSpeed ? 1.2 : Number(a.scaleSpeed);
            b.pinch = void 0 === a.pinch ? b.wheel || b.controls : !!a.pinch;
            return b;
        }
        static parseGridOptions_(a) {
            a = a.grid || {};
            const b = {};
            b.spacing = Number(a.spacing) || 0;
            b.colour = a.colour || "#888";
            b.length = void 0 === a.length ? 1 : Number(a.length);
            b.snap = 0 < b.spacing && !!a.snap;
            return b;
        }
        static parseThemeOptions_(a) {
            a = a.theme || Classic$$module$build$src$core$theme$classic;
            return "string" === typeof a ? getObject$$module$build$src$core$registry(Type$$module$build$src$core$registry.THEME, a) : a instanceof Theme$$module$build$src$core$theme ? a : Theme$$module$build$src$core$theme.defineTheme(a.name || "builtin" + getNextUniqueId$$module$build$src$core$utils$idgenerator(), a);
        }
    }, module$build$src$core$options = {};
    module$build$src$core$options.Options = Options$$module$build$src$core$options;
    var module$build$src$core$mutator;
    $.Mutator$$module$build$src$core$mutator = class extends Icon$$module$build$src$core$icon {
        constructor(a, b){
            b || warn$$module$build$src$core$utils$deprecation("Calling the Mutator constructor without passing the block it is attached to", "version 9", "version 10", "the constructor by passing the list of subblocks and the block instance to attach the mutator to");
            super(null != b ? b : null);
            this.workspace_ = null;
            this.workspaceHeight = this.workspaceWidth = 0;
            this.updateWorkspacePid = this.sourceListener = this.rootBlock = this.svgDialog = null;
            this.quarkNames = a;
        }
        setBlock(a) {
            this.block_ = a;
        }
        getWorkspace() {
            return this.workspace_;
        }
        drawIcon_(a) {
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                "class": "blocklyIconShape",
                rx: "4",
                ry: "4",
                height: "16",
                width: "16"
            }, a);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATH, {
                "class": "blocklyIconSymbol",
                d: "m4.203,7.296 0,1.368 -0.92,0.677 -0.11,0.41 0.9,1.559 0.41,0.11 1.043,-0.457 1.187,0.683 0.127,1.134 0.3,0.3 1.8,0 0.3,-0.299 0.127,-1.138 1.185,-0.682 1.046,0.458 0.409,-0.11 0.9,-1.559 -0.11,-0.41 -0.92,-0.677 0,-1.366 0.92,-0.677 0.11,-0.41 -0.9,-1.559 -0.409,-0.109 -1.046,0.458 -1.185,-0.682 -0.127,-1.138 -0.3,-0.299 -1.8,0 -0.3,0.3 -0.126,1.135 -1.187,0.682 -1.043,-0.457 -0.41,0.11 -0.899,1.559 0.108,0.409z"
            }, a);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.CIRCLE, {
                "class": "blocklyIconShape",
                r: "2.7",
                cx: "8",
                cy: "8"
            }, a);
        }
        iconClick_(a) {
            this.getBlock().isEditable() && super.iconClick_(a);
        }
        createEditor() {
            this.svgDialog = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.SVG, {
                x: Bubble$$module$build$src$core$bubble.BORDER_WIDTH,
                y: Bubble$$module$build$src$core$bubble.BORDER_WIDTH
            });
            if (this.quarkNames.length) {
                var a = $.createElement$$module$build$src$core$utils$xml("xml");
                for(let d = 0, e; e = this.quarkNames[d]; d++){
                    var b = $.createElement$$module$build$src$core$utils$xml("block");
                    b.setAttribute("type", e);
                    a.appendChild(b);
                }
            } else a = null;
            var c = this.getBlock();
            b = new Options$$module$build$src$core$options({
                disable: !1,
                parentWorkspace: c.workspace,
                media: c.workspace.options.pathToMedia,
                rtl: c.RTL,
                horizontalLayout: !1,
                renderer: c.workspace.options.renderer,
                rendererOverrides: c.workspace.options.rendererOverrides
            });
            b.toolboxPosition = c.RTL ? Position$$module$build$src$core$utils$toolbox.RIGHT : Position$$module$build$src$core$utils$toolbox.LEFT;
            if (c = !!a) b.languageTree = convertToolboxDefToJson$$module$build$src$core$utils$toolbox(a);
            this.workspace_ = this.newWorkspaceSvg(b);
            this.workspace_.internalIsMutator = !0;
            this.workspace_.addChangeListener(disableOrphans$$module$build$src$core$events$utils);
            a = c ? this.workspace_.addFlyout(Svg$$module$build$src$core$utils$svg.G) : null;
            b = this.workspace_.createDom("blocklyMutatorBackground");
            a && b.insertBefore(a, this.workspace_.svgBlockCanvas_);
            this.svgDialog.appendChild(b);
            return this.svgDialog;
        }
        newWorkspaceSvg(a) {
            throw Error("The implementation of newWorkspaceSvg should be monkey-patched in by blockly.ts");
        }
        updateEditable() {
            super.updateEditable();
            this.getBlock().isInFlyout || (this.getBlock().isEditable() ? this.iconGroup_ && removeClass$$module$build$src$core$utils$dom(this.iconGroup_, "blocklyIconGroupReadonly") : (this.setVisible(!1), this.iconGroup_ && addClass$$module$build$src$core$utils$dom(this.iconGroup_, "blocklyIconGroupReadonly")));
        }
        resizeBubble() {
            if (this.workspace_) {
                var a = 2 * Bubble$$module$build$src$core$bubble.BORDER_WIDTH, b = this.workspace_.getCanvas(), c = b.getBBox(), d = c.width + c.x, e = c.height + 3 * a, f = this.workspace_.getFlyout();
                if (f) {
                    const g = f.getWorkspace().getMetricsManager().getScrollMetrics();
                    e = Math.max(e, g.height + 20);
                    d += f.getWidth();
                }
                (f = this.getBlock().RTL) && (d = -c.x);
                d += 3 * a;
                if (Math.abs(this.workspaceWidth - d) > a || Math.abs(this.workspaceHeight - e) > a) this.workspaceWidth = d, this.workspaceHeight = e, this.bubble_.setBubbleSize(d + a, e + a), this.svgDialog.setAttribute("width", `${d}`), this.svgDialog.setAttribute("height", `${e}`), this.workspace_.setCachedParentSvgSize(d, e);
                f && b.setAttribute("transform", `translate(${this.workspaceWidth}, 0)`);
                this.workspace_.resize();
            }
        }
        onBubbleMove() {
            this.workspace_ && this.workspace_.recordDragTargets();
        }
        setVisible(a) {
            if (a !== this.isVisible()) {
                var b = this.getBlock();
                if (a) {
                    this.bubble_ = new Bubble$$module$build$src$core$bubble(b.workspace, this.createEditor(), b.pathObject.svgPath, this.iconXY_, null, null);
                    var c = this.workspace_;
                    this.bubble_.setSvgId(b.id);
                    this.bubble_.registerMoveEvent(this.onBubbleMove.bind(this));
                    var d = c.options.languageTree;
                    const e = c.getFlyout();
                    d && (e.init(c), e.show(d));
                    this.rootBlock = b.decompose(c);
                    d = this.rootBlock.getDescendants(!1);
                    for(let g = 0, h; h = d[g]; g++)h.render();
                    this.rootBlock.setMovable(!1);
                    this.rootBlock.setDeletable(!1);
                    let f;
                    e ? (d = 2 * e.CORNER_RADIUS, f = this.rootBlock.RTL ? e.getWidth() + d : d) : f = d = 16;
                    b.RTL && (f = -f);
                    this.rootBlock.moveBy(f, d);
                    if (b.saveConnections) {
                        const g = this.rootBlock;
                        b.saveConnections(g);
                        this.sourceListener = ()=>{
                            const h = this.getBlock();
                            h.saveConnections && h.saveConnections(g);
                        };
                        b.workspace.addChangeListener(this.sourceListener);
                    }
                    this.resizeBubble();
                    d = this.workspaceChanged.bind(this);
                    c.addChangeListener(d);
                    e && e.getWorkspace().addChangeListener(d);
                    this.updateWorkspace();
                    this.applyColour();
                } else this.svgDialog = null, this.workspace_.dispose(), this.rootBlock = this.workspace_ = null, null == (c = this.bubble_) || c.dispose(), this.bubble_ = null, this.workspaceHeight = this.workspaceWidth = 0, this.sourceListener && (b.workspace.removeChangeListener(this.sourceListener), this.sourceListener = null);
                fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(BUBBLE_OPEN$$module$build$src$core$events$utils))(b, a, "mutator"));
            }
        }
        workspaceChanged(a) {
            this.shouldIgnoreMutatorEvent_(a) || this.updateWorkspacePid || (this.updateWorkspacePid = setTimeout(()=>{
                this.updateWorkspacePid = null;
                this.updateWorkspace();
            }, 0));
        }
        shouldIgnoreMutatorEvent_(a) {
            return a.isUiEvent || a.type === CREATE$$module$build$src$core$events$utils || a.type === CHANGE$$module$build$src$core$events$utils && "disabled" === a.element;
        }
        updateWorkspace() {
            if (!this.workspace_.isDragging()) {
                var a = this.workspace_.getTopBlocks(!1);
                for(let d = 0, e; e = a[d]; d++){
                    var b = e.getRelativeToSurfaceXY();
                    20 > b.y && e.moveBy(0, 20 - b.y);
                    if (e.RTL) {
                        var c = -20;
                        const f = this.workspace_.getFlyout();
                        f && (c -= f.getWidth());
                        b.x > c && e.moveBy(c - b.x, 0);
                    } else 20 > b.x && e.moveBy(20 - b.x, 0);
                }
            }
            if (this.rootBlock && this.rootBlock.workspace === this.workspace_) {
                (a = getGroup$$module$build$src$core$events$utils()) || setGroup$$module$build$src$core$events$utils(!0);
                const d = this.getBlock();
                b = BlockChange$$module$build$src$core$events$events_block_change.getExtraBlockState_(d);
                d.compose(this.rootBlock);
                c = BlockChange$$module$build$src$core$events$events_block_change.getExtraBlockState_(d);
                if (b !== c) {
                    fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(CHANGE$$module$build$src$core$events$utils))(d, "mutation", null, b, c));
                    const e = getGroup$$module$build$src$core$events$utils();
                    setTimeout(function() {
                        const f = getGroup$$module$build$src$core$events$utils();
                        setGroup$$module$build$src$core$events$utils(e);
                        d.bumpNeighbours();
                        setGroup$$module$build$src$core$events$utils(f);
                    }, $.config$$module$build$src$core$config.bumpDelay);
                }
                this.workspace_.isDragging() || setTimeout(()=>this.resizeBubble(), 0);
                setGroup$$module$build$src$core$events$utils(a);
            }
        }
        dispose() {
            this.getBlock().mutator = null;
            super.dispose();
        }
        updateBlockStyle() {
            var a = this.workspace_;
            if (a && a.getAllBlocks(!1)) {
                const b = a.getAllBlocks(!1);
                for(let c = 0, d; d = b[c]; c++)d.setStyle(d.getStyleName());
                if (a = a.getFlyout()) {
                    a = a.getWorkspace().getAllBlocks(!1);
                    for(let c = 0, d; d = a[c]; c++)d.setStyle(d.getStyleName());
                }
            }
        }
        static reconnect(a, b, c) {
            if (!a || !a.getSourceBlock().workspace) return !1;
            c = b.getInput(c).connection;
            const d = a.targetBlock();
            return d && d !== b || !c || c.targetConnection === a ? !1 : (c.isConnected() && c.disconnect(), c.connect(a), !0);
        }
        static findParentWs(a) {
            let b = null;
            if (a && a.options) {
                const c = a.options.parentWorkspace;
                a.isFlyout ? c && c.options && (b = c.options.parentWorkspace) : c && (b = c);
            }
            return b;
        }
    };
    module$build$src$core$mutator = {};
    module$build$src$core$mutator.Mutator = $.Mutator$$module$build$src$core$mutator;
    var allExtensions$$module$build$src$core$extensions = Object.create(null), TEST_ONLY$$module$build$src$core$extensions = {
        allExtensions: allExtensions$$module$build$src$core$extensions
    };
    $.register$$module$build$src$core$extensions("parent_tooltip_when_inline", extensionParentTooltip$$module$build$src$core$extensions);
    $.module$build$src$core$extensions = {};
    $.module$build$src$core$extensions.TEST_ONLY = TEST_ONLY$$module$build$src$core$extensions;
    $.module$build$src$core$extensions.apply = apply$$module$build$src$core$extensions;
    $.module$build$src$core$extensions.buildTooltipForDropdown = $.buildTooltipForDropdown$$module$build$src$core$extensions;
    $.module$build$src$core$extensions.buildTooltipWithFieldText = $.buildTooltipWithFieldText$$module$build$src$core$extensions;
    $.module$build$src$core$extensions.isRegistered = isRegistered$$module$build$src$core$extensions;
    $.module$build$src$core$extensions.register = $.register$$module$build$src$core$extensions;
    $.module$build$src$core$extensions.registerMixin = registerMixin$$module$build$src$core$extensions;
    $.module$build$src$core$extensions.registerMutator = $.registerMutator$$module$build$src$core$extensions;
    $.module$build$src$core$extensions.runAfterPageLoad = runAfterPageLoad$$module$build$src$core$extensions;
    $.module$build$src$core$extensions.unregister = unregister$$module$build$src$core$extensions;
    var FieldLabel$$module$build$src$core$field_label = class extends Field$$module$build$src$core$field {
        constructor(a, b, c){
            super(Field$$module$build$src$core$field.SKIP_SETUP);
            this.class_ = null;
            this.EDITABLE = !1;
            a !== Field$$module$build$src$core$field.SKIP_SETUP && (c ? this.configure_(c) : this.class_ = b || null, this.setValue(a));
        }
        configure_(a) {
            super.configure_(a);
            a.class && (this.class_ = a.class);
        }
        initView() {
            this.createTextElement_();
            this.class_ && addClass$$module$build$src$core$utils$dom(this.getTextElement(), this.class_);
        }
        doClassValidation_(a) {
            return null === a || void 0 === a ? null : `${a}`;
        }
        setClass(a) {
            this.textElement_ && (this.class_ && removeClass$$module$build$src$core$utils$dom(this.textElement_, this.class_), a && addClass$$module$build$src$core$utils$dom(this.textElement_, a));
            this.class_ = a;
        }
        static fromJson(a) {
            return new this(replaceMessageReferences$$module$build$src$core$utils$parsing(a.text), void 0, a);
        }
    };
    register$$module$build$src$core$field_registry("field_label", FieldLabel$$module$build$src$core$field_label);
    FieldLabel$$module$build$src$core$field_label.prototype.DEFAULT_VALUE = "";
    var module$build$src$core$field_label = {};
    module$build$src$core$field_label.FieldLabel = FieldLabel$$module$build$src$core$field_label;
    var Input$$module$build$src$core$input = class {
        constructor(a, b, c, d){
            this.type = a;
            this.name = b;
            this.connection = d;
            this.fieldRow = [];
            this.align = $.Align$$module$build$src$core$input.LEFT;
            this.visible = !0;
            if (a !== inputTypes$$module$build$src$core$input_types.DUMMY && !b) throw Error("Value inputs and statement inputs must have non-empty name.");
            this.sourceBlock = c;
        }
        getSourceBlock() {
            return this.sourceBlock;
        }
        appendField(a, b) {
            this.insertFieldAt(this.fieldRow.length, a, b);
            return this;
        }
        insertFieldAt(a, b, c) {
            if (0 > a || a > this.fieldRow.length) throw Error("index " + a + " out of bounds.");
            if (!(b || "" === b && c)) return a;
            "string" === typeof b && (b = fromJson$$module$build$src$core$field_registry({
                type: "field_label",
                text: b
            }));
            b.setSourceBlock(this.sourceBlock);
            this.sourceBlock.rendered && (b.init(), b.applyColour());
            b.name = c;
            b.setVisible(this.isVisible());
            b.prefixField && (a = this.insertFieldAt(a, b.prefixField));
            this.fieldRow.splice(a, 0, b);
            a++;
            b.suffixField && (a = this.insertFieldAt(a, b.suffixField));
            this.sourceBlock.rendered && (this.sourceBlock.queueRender(), this.sourceBlock.bumpNeighbours());
            return a;
        }
        removeField(a, b) {
            for(let c = 0, d; d = this.fieldRow[c]; c++)if (d.name === a) return d.dispose(), this.fieldRow.splice(c, 1), this.sourceBlock.rendered && (this.sourceBlock.queueRender(), this.sourceBlock.bumpNeighbours()), !0;
            if (b) return !1;
            throw Error('Field "' + a + '" not found.');
        }
        isVisible() {
            return this.visible;
        }
        setVisible(a) {
            let b = [];
            if (this.visible === a) return b;
            this.visible = a;
            for(let d = 0, e; e = this.fieldRow[d]; d++)e.setVisible(a);
            if (this.connection) {
                var c = this.connection;
                a ? b = c.startTrackingAll() : c.stopTrackingAll();
                if (c = c.targetBlock()) c.getSvgRoot().style.display = a ? "block" : "none";
            }
            return b;
        }
        markDirty() {
            for(let a = 0, b; b = this.fieldRow[a]; a++)b.markDirty();
        }
        setCheck(a) {
            if (!this.connection) throw Error("This input does not have a connection.");
            this.connection.setCheck(a);
            return this;
        }
        setAlign(a) {
            this.align = a;
            this.sourceBlock.rendered && this.sourceBlock.queueRender();
            return this;
        }
        setShadowDom(a) {
            if (!this.connection) throw Error("This input does not have a connection.");
            this.connection.setShadowDom(a);
            return this;
        }
        getShadowDom() {
            if (!this.connection) throw Error("This input does not have a connection.");
            return this.connection.getShadowDom();
        }
        init() {
            if (this.sourceBlock.workspace.rendered) for(let a = 0; a < this.fieldRow.length; a++)this.fieldRow[a].init();
        }
        dispose() {
            for(let a = 0, b; b = this.fieldRow[a]; a++)b.dispose();
            this.connection && this.connection.dispose();
        }
    }, module$build$src$core$input;
    (function(a) {
        a = a.Align || (a.Align = {});
        a[a.LEFT = -1] = "LEFT";
        a[a.CENTRE = 0] = "CENTRE";
        a[a.RIGHT = 1] = "RIGHT";
    })(Input$$module$build$src$core$input || (Input$$module$build$src$core$input = {}));
    $.Align$$module$build$src$core$input = Input$$module$build$src$core$input.Align;
    module$build$src$core$input = {};
    module$build$src$core$input.Align = $.Align$$module$build$src$core$input;
    module$build$src$core$input.Input = Input$$module$build$src$core$input;
    var module$build$src$core$utils$array = {};
    module$build$src$core$utils$array.removeElem = removeElem$$module$build$src$core$utils$array;
    var Block$$module$build$src$core$block = class {
        constructor(a, b, c){
            this.data = null;
            this.disposed = !1;
            this.hue_ = null;
            this.colour_ = "#000000";
            this.styleName_ = "";
            this.suppressPrefixSuffix = !1;
            this.previousConnection = this.nextConnection = this.outputConnection = null;
            this.inputList = [];
            this.disabled = !1;
            this.tooltip = "";
            this.contextMenu = !0;
            this.parentBlock_ = null;
            this.childBlocks_ = [];
            this.editable_ = this.movable_ = this.deletable_ = !0;
            this.collapsed_ = this.isShadow_ = !1;
            this.outputShape_ = null;
            this.disposing = !1;
            this.comment = null;
            this.isInsertionMarker_ = !1;
            this.onchangeWrapper_ = this.helpUrl = this.rendered = null;
            this.statementInputCount = 0;
            this.workspace = a;
            this.id = c && !a.getBlockById(c) ? c : genUid$$module$build$src$core$utils$idgenerator();
            a.setBlockById(this.id, this);
            this.commentModel = {
                text: null,
                pinned: !1,
                size: new Size$$module$build$src$core$utils$size(160, 80)
            };
            this.xy_ = new Coordinate$$module$build$src$core$utils$coordinate(0, 0);
            this.isInFlyout = a.isFlyout;
            this.isInMutator = a.isMutator;
            this.RTL = a.RTL;
            if (b) {
                this.type = b;
                c = Blocks$$module$build$src$core$blocks[b];
                if (!c || "object" !== typeof c) throw TypeError("Invalid block definition for type: " + b);
                Object.assign(this, c);
            }
            a.addTopBlock(this);
            a.addTypedBlock(this);
            new.target === Block$$module$build$src$core$block && this.doInit_();
        }
        doInit_() {
            const a = getGroup$$module$build$src$core$events$utils();
            a || setGroup$$module$build$src$core$events$utils(!0);
            const b = getRecordUndo$$module$build$src$core$events$utils();
            try {
                "function" === typeof this.init && (setRecordUndo$$module$build$src$core$events$utils(!1), this.init(), setRecordUndo$$module$build$src$core$events$utils(b)), isEnabled$$module$build$src$core$events$utils() && fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(CREATE$$module$build$src$core$events$utils))(this));
            } finally{
                setGroup$$module$build$src$core$events$utils(a), setRecordUndo$$module$build$src$core$events$utils(b);
            }
            this.inputsInlineDefault = this.inputsInline;
            "function" === typeof this.onchange && this.setOnChange(this.onchange);
        }
        dispose(a) {
            this.isDeadOrDying() || (this.onchangeWrapper_ && this.workspace.removeChangeListener(this.onchangeWrapper_), this.unplug(a), isEnabled$$module$build$src$core$events$utils() && fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(DELETE$$module$build$src$core$events$utils))(this)), this.workspace.removeTopBlock(this), this.disposeInternal());
        }
        disposeInternal() {
            if (!this.isDeadOrDying()) {
                this.onchangeWrapper_ && this.workspace.removeChangeListener(this.onchangeWrapper_);
                disable$$module$build$src$core$events$utils();
                try {
                    this.workspace.removeTypedBlock(this), this.workspace.removeBlockById(this.id), this.disposing = !0, this.childBlocks_.forEach((a)=>a.disposeInternal()), this.inputList.forEach((a)=>a.dispose()), this.inputList.length = 0, this.getConnections_(!0).forEach((a)=>a.dispose());
                } finally{
                    enable$$module$build$src$core$events$utils(), "function" === typeof this.destroy && this.destroy(), this.disposed = !0;
                }
            }
        }
        isDeadOrDying() {
            return this.disposing || this.disposed;
        }
        initModel() {
            for(let a = 0, b; b = this.inputList[a]; a++)for(let c = 0, d; d = b.fieldRow[c]; c++)d.initModel && d.initModel();
        }
        unplug(a) {
            this.outputConnection && this.unplugFromRow_(a);
            this.previousConnection && this.unplugFromStack_(a);
        }
        unplugFromRow_(a) {
            let b = null, c;
            if (null == (c = this.outputConnection) ? 0 : c.isConnected()) b = this.outputConnection.targetConnection, this.outputConnection.disconnect();
            b && a && (a = this.getOnlyValueConnection_()) && a.isConnected() && !a.targetBlock().isShadow() && (a = a.targetConnection, null == a || a.disconnect(), this.workspace.connectionChecker.canConnect(a, b, !1) ? b.connect(a) : null == a || a.onFailedConnect(b));
        }
        getOnlyValueConnection_() {
            let a = null;
            for(let b = 0; b < this.inputList.length; b++){
                const c = this.inputList[b].connection;
                if (c && c.type === ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE && c.targetConnection) {
                    if (a) return null;
                    a = c;
                }
            }
            return a;
        }
        unplugFromStack_(a) {
            let b = null;
            var c;
            if (null == (c = this.previousConnection) ? 0 : c.isConnected()) b = this.previousConnection.targetConnection, this.previousConnection.disconnect();
            c = this.getNextBlock();
            if (a && c && !c.isShadow()) {
                let d, e;
                a = null != (e = null == (d = this.nextConnection) ? void 0 : d.targetConnection) ? e : null;
                null == a || a.disconnect();
                b && this.workspace.connectionChecker.canConnect(b, a, !1) && b.connect(a);
            }
        }
        getConnections_(a) {
            a = [];
            this.outputConnection && a.push(this.outputConnection);
            this.previousConnection && a.push(this.previousConnection);
            this.nextConnection && a.push(this.nextConnection);
            for(let b = 0, c; c = this.inputList[b]; b++)c.connection && a.push(c.connection);
            return a;
        }
        lastConnectionInStack(a) {
            let b = this.nextConnection;
            for(; b;){
                const c = b.targetBlock();
                if (!c || a && c.isShadow()) return b;
                b = c.nextConnection;
            }
            return null;
        }
        bumpNeighbours() {}
        getParent() {
            return this.parentBlock_;
        }
        getInputWithBlock(a) {
            for(let b = 0, c; c = this.inputList[b]; b++)if (c.connection && c.connection.targetBlock() === a) return c;
            return null;
        }
        getSurroundParent() {
            let a = this, b;
            do if (b = a, a = a.getParent(), !a) return null;
            while (a.getNextBlock() === b);
            return a;
        }
        getNextBlock() {
            return this.nextConnection && this.nextConnection.targetBlock();
        }
        getPreviousBlock() {
            return this.previousConnection && this.previousConnection.targetBlock();
        }
        getFirstStatementConnection() {
            for(let a = 0, b; b = this.inputList[a]; a++)if (b.connection && b.connection.type === ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT) return b.connection;
            return null;
        }
        getRootBlock() {
            let a, b = this;
            do a = b, b = a.parentBlock_;
            while (b);
            return a;
        }
        getTopStackBlock() {
            let a = this, b;
            do b = a.getPreviousBlock();
            while (b && b.getNextBlock() === a && (a = b));
            return a;
        }
        getChildren(a) {
            if (!a) return this.childBlocks_;
            a = [];
            for(let c = 0, d; d = this.inputList[c]; c++)if (d.connection) {
                var b = d.connection.targetBlock();
                b && a.push(b);
            }
            (b = this.getNextBlock()) && a.push(b);
            return a;
        }
        setParent(a) {
            if (a !== this.parentBlock_) {
                var b = this.previousConnection && this.previousConnection.targetBlock() || this.outputConnection && this.outputConnection.targetBlock(), c = !!b;
                if (c && a && b !== a) throw Error("Block connected to superior one that is not new parent.");
                if (!c && a) throw Error("Block not connected to new parent.");
                if (c && !a) throw Error("Cannot set parent to null while block is still connected to superior block.");
                this.parentBlock_ ? removeElem$$module$build$src$core$utils$array(this.parentBlock_.childBlocks_, this) : this.workspace.removeTopBlock(this);
                (this.parentBlock_ = a) ? a.childBlocks_.push(this) : this.workspace.addTopBlock(this);
            }
        }
        getDescendants(a) {
            const b = [
                this
            ], c = this.getChildren(a);
            for(let d, e = 0; d = c[e]; e++)b.push(...d.getDescendants(a));
            return b;
        }
        isDeletable() {
            return this.deletable_ && !this.isShadow_ && !this.isDeadOrDying() && !this.workspace.options.readOnly;
        }
        isOwnDeletable() {
            return this.deletable_;
        }
        setDeletable(a) {
            this.deletable_ = a;
        }
        isMovable() {
            return this.movable_ && !this.isShadow_ && !this.isDeadOrDying() && !this.workspace.options.readOnly;
        }
        isOwnMovable() {
            return this.movable_;
        }
        setMovable(a) {
            this.movable_ = a;
        }
        isDuplicatable() {
            return this.workspace.hasBlockLimits() ? this.workspace.isCapacityAvailable(getBlockTypeCounts$$module$build$src$core$common(this, !0)) : !0;
        }
        isShadow() {
            return this.isShadow_;
        }
        setShadow(a) {
            this.isShadow_ = a;
        }
        isInsertionMarker() {
            return this.isInsertionMarker_;
        }
        setInsertionMarker(a) {
            this.isInsertionMarker_ = a;
        }
        isEditable() {
            return this.editable_ && !this.isDeadOrDying() && !this.workspace.options.readOnly;
        }
        isOwnEditable() {
            return this.editable_;
        }
        setEditable(a) {
            this.editable_ = a;
            for(let b = 0, c; c = this.inputList[b]; b++)for(let d = 0, e; e = c.fieldRow[d]; d++)e.updateEditable();
        }
        isDisposed() {
            return this.disposed;
        }
        getMatchingConnection(a, b) {
            const c = this.getConnections_(!0);
            a = a.getConnections_(!0);
            if (c.length !== a.length) throw Error("Connection lists did not match in length.");
            for(let d = 0; d < a.length; d++)if (a[d] === b) return c[d];
            return null;
        }
        setHelpUrl(a) {
            this.helpUrl = a;
        }
        setTooltip(a) {
            this.tooltip = a;
        }
        getTooltip() {
            return getTooltipOfObject$$module$build$src$core$tooltip(this);
        }
        getColour() {
            return this.colour_;
        }
        getStyleName() {
            return this.styleName_;
        }
        getHue() {
            return this.hue_;
        }
        setColour(a) {
            a = parseBlockColour$$module$build$src$core$utils$parsing(a);
            this.hue_ = a.hue;
            this.colour_ = a.hex;
        }
        setStyle(a) {
            this.styleName_ = a;
        }
        setOnChange(a) {
            if (a && "function" !== typeof a) throw Error("onchange must be a function.");
            this.onchangeWrapper_ && this.workspace.removeChangeListener(this.onchangeWrapper_);
            this.onchange = a;
            this.onchangeWrapper_ = a.bind(this);
            this.workspace.addChangeListener(this.onchangeWrapper_);
        }
        getField(a) {
            if ("string" !== typeof a) throw TypeError("Block.prototype.getField expects a string with the field name but received " + (void 0 === a ? "nothing" : a + " of type " + typeof a) + " instead");
            for(let b = 0, c; c = this.inputList[b]; b++)for(let d = 0, e; e = c.fieldRow[d]; d++)if (e.name === a) return e;
            return null;
        }
        getVars() {
            const a = [];
            for(let b = 0, c; c = this.inputList[b]; b++)for(let d = 0, e; e = c.fieldRow[d]; d++)e.referencesVariables() && a.push(e.getValue());
            return a;
        }
        getVarModels() {
            const a = [];
            for(let b = 0, c; c = this.inputList[b]; b++)for(let d = 0, e; e = c.fieldRow[d]; d++)if (e.referencesVariables()) {
                const f = this.workspace.getVariableById(e.getValue());
                f && a.push(f);
            }
            return a;
        }
        updateVarName(a) {
            for(let b = 0, c; c = this.inputList[b]; b++)for(let d = 0, e; e = c.fieldRow[d]; d++)e.referencesVariables() && a.getId() === e.getValue() && e.refreshVariableName();
        }
        renameVarById(a, b) {
            for(let c = 0, d; d = this.inputList[c]; c++)for(let e = 0, f; f = d.fieldRow[e]; e++)f.referencesVariables() && a === f.getValue() && f.setValue(b);
        }
        getFieldValue(a) {
            return (a = this.getField(a)) ? a.getValue() : null;
        }
        setFieldValue(a, b) {
            const c = this.getField(b);
            if (!c) throw Error('Field "' + b + '" not found.');
            c.setValue(a);
        }
        setPreviousStatement(a, b) {
            if (a) void 0 === b && (b = null), this.previousConnection || (this.previousConnection = this.makeConnection_(ConnectionType$$module$build$src$core$connection_type.PREVIOUS_STATEMENT)), this.previousConnection.setCheck(b);
            else if (this.previousConnection) {
                if (this.previousConnection.isConnected()) throw Error("Must disconnect previous statement before removing connection.");
                this.previousConnection.dispose();
                this.previousConnection = null;
            }
        }
        setNextStatement(a, b) {
            if (a) void 0 === b && (b = null), this.nextConnection || (this.nextConnection = this.makeConnection_(ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT)), this.nextConnection.setCheck(b);
            else if (this.nextConnection) {
                if (this.nextConnection.isConnected()) throw Error("Must disconnect next statement before removing connection.");
                this.nextConnection.dispose();
                this.nextConnection = null;
            }
        }
        setOutput(a, b) {
            if (a) void 0 === b && (b = null), this.outputConnection || (this.outputConnection = this.makeConnection_(ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE)), this.outputConnection.setCheck(b);
            else if (this.outputConnection) {
                if (this.outputConnection.isConnected()) throw Error("Must disconnect output value before removing connection.");
                this.outputConnection.dispose();
                this.outputConnection = null;
            }
        }
        setInputsInline(a) {
            this.inputsInline !== a && (fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(CHANGE$$module$build$src$core$events$utils))(this, "inline", null, this.inputsInline, a)), this.inputsInline = a);
        }
        getInputsInline() {
            if (void 0 !== this.inputsInline) return this.inputsInline;
            for(var a = 1; a < this.inputList.length; a++)if (this.inputList[a - 1].type === inputTypes$$module$build$src$core$input_types.DUMMY && this.inputList[a].type === inputTypes$$module$build$src$core$input_types.DUMMY) return !1;
            for(a = 1; a < this.inputList.length; a++)if (this.inputList[a - 1].type === inputTypes$$module$build$src$core$input_types.VALUE && this.inputList[a].type === inputTypes$$module$build$src$core$input_types.DUMMY) return !0;
            return !1;
        }
        setOutputShape(a) {
            this.outputShape_ = a;
        }
        getOutputShape() {
            return this.outputShape_;
        }
        isEnabled() {
            return !this.disabled;
        }
        setEnabled(a) {
            if (this.isEnabled() !== a) {
                const b = this.disabled;
                this.disabled = !a;
                fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(CHANGE$$module$build$src$core$events$utils))(this, "disabled", null, b, !a));
            }
        }
        getInheritedDisabled() {
            let a = this.getSurroundParent();
            for(; a;){
                if (a.disabled) return !0;
                a = a.getSurroundParent();
            }
            return !1;
        }
        isCollapsed() {
            return this.collapsed_;
        }
        setCollapsed(a) {
            this.collapsed_ !== a && (fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(CHANGE$$module$build$src$core$events$utils))(this, "collapsed", null, this.collapsed_, a)), this.collapsed_ = a);
        }
        toString(a, b) {
            b = this.toTokens(b);
            for(let d = 2; d < b.length; d++)"(" === b[d - 2] && ")" === b[d] && (b[d - 2] = b[d - 1], b.splice(d - 1, 2));
            let c = "";
            b = b.reduce((d, e)=>{
                d = d + ("(" === c || ")" === e ? "" : " ") + e;
                c = e[e.length - 1];
                return d;
            }, "");
            b = b.trim() || "???";
            a && b.length > a && (b = b.substring(0, a - 3) + "...");
            return b;
        }
        toTokens(a = "?") {
            const b = [];
            for (const d of this.inputList)if (d.name != COLLAPSED_INPUT_NAME$$module$build$src$core$constants) {
                for (const e of d.fieldRow)b.push(e.getText());
                if (d.connection) {
                    const e = d.connection.targetBlock();
                    if (e) {
                        var c = d.connection;
                        let f = c.getCheck();
                        !f && c.targetConnection && (f = c.targetConnection.getCheck());
                        (c = !!f && (-1 !== f.indexOf("Boolean") || -1 !== f.indexOf("Number"))) && b.push("(");
                        b.push(...e.toTokens(a));
                        c && b.push(")");
                    } else b.push(a);
                }
            }
            return b;
        }
        appendValueInput(a) {
            return this.appendInput_(inputTypes$$module$build$src$core$input_types.VALUE, a);
        }
        appendStatementInput(a) {
            return this.appendInput_(inputTypes$$module$build$src$core$input_types.STATEMENT, a);
        }
        appendDummyInput(a) {
            return this.appendInput_(inputTypes$$module$build$src$core$input_types.DUMMY, a || "");
        }
        jsonInit(a) {
            var b = a.type ? 'Block "' + a.type + '": ' : "";
            if (a.output && a.previousStatement) throw Error(b + "Must not have both an output and a previousStatement.");
            a.style && a.style.hat && (this.hat = a.style.hat, a.style = null);
            if (a.style && a.colour) throw Error(b + "Must not have both a colour and a style.");
            a.style ? this.jsonInitStyle_(a, b) : this.jsonInitColour_(a, b);
            for(var c = 0; void 0 !== a["message" + c];)this.interpolate_(a["message" + c], a["args" + c] || [], a["lastDummyAlign" + c], b), c++;
            void 0 !== a.inputsInline && this.setInputsInline(a.inputsInline);
            void 0 !== a.output && this.setOutput(!0, a.output);
            void 0 !== a.outputShape && this.setOutputShape(a.outputShape);
            void 0 !== a.previousStatement && this.setPreviousStatement(!0, a.previousStatement);
            void 0 !== a.nextStatement && this.setNextStatement(!0, a.nextStatement);
            void 0 !== a.tooltip && (c = replaceMessageReferences$$module$build$src$core$utils$parsing(a.tooltip), this.setTooltip(c));
            void 0 !== a.enableContextMenu && (this.contextMenu = !!a.enableContextMenu);
            void 0 !== a.suppressPrefixSuffix && (this.suppressPrefixSuffix = !!a.suppressPrefixSuffix);
            void 0 !== a.helpUrl && (c = replaceMessageReferences$$module$build$src$core$utils$parsing(a.helpUrl), this.setHelpUrl(c));
            "string" === typeof a.extensions && (console.warn(b + "JSON attribute 'extensions' should be an array of strings. Found raw string in JSON for '" + a.type + "' block."), a.extensions = [
                a.extensions
            ]);
            void 0 !== a.mutator && apply$$module$build$src$core$extensions(a.mutator, this, !0);
            a = a.extensions;
            if (Array.isArray(a)) for(b = 0; b < a.length; b++)apply$$module$build$src$core$extensions(a[b], this, !1);
        }
        jsonInitColour_(a, b) {
            if ("colour" in a) {
                if (void 0 === a.colour) console.warn(b + "Undefined colour value.");
                else {
                    a = a.colour;
                    try {
                        this.setColour(a);
                    } catch (c) {
                        console.warn(b + "Illegal colour value: ", a);
                    }
                }
            }
        }
        jsonInitStyle_(a, b) {
            a = a.style;
            try {
                this.setStyle(a);
            } catch (c) {
                console.warn(b + "Style does not exist: ", a);
            }
        }
        mixin(a, b) {
            if (void 0 !== b && "boolean" !== typeof b) throw Error("opt_disableCheck must be a boolean if provided");
            if (!b) {
                b = [];
                for(const c in a)void 0 !== this[c] && b.push(c);
                if (b.length) throw Error("Mixin will overwrite block members: " + JSON.stringify(b));
            }
            Object.assign(this, a);
        }
        interpolate_(a, b, c, d) {
            a = tokenizeInterpolation$$module$build$src$core$utils$parsing(a);
            this.validateTokens_(a, b.length);
            b = this.interpolateArguments_(a, b, c);
            c = [];
            for(let e = 0, f; f = b[e]; e++)if (this.isInputKeyword_(f.type)) {
                if (a = this.inputFromJson_(f, d)) {
                    for(let g = 0, h; h = c[g]; g++)a.appendField(h[0], h[1]);
                    c.length = 0;
                }
            } else (a = this.fieldFromJson_(f)) && c.push([
                a,
                f.name
            ]);
        }
        validateTokens_(a, b) {
            const c = [];
            let d = 0;
            for(let e = 0; e < a.length; e++){
                const f = a[e];
                if ("number" === typeof f) {
                    if (1 > f || f > b) throw Error('Block "' + this.type + '": Message index %' + f + " out of range.");
                    if (c[f]) throw Error('Block "' + this.type + '": Message index %' + f + " duplicated.");
                    c[f] = !0;
                    d++;
                }
            }
            if (d !== b) throw Error('Block "' + this.type + '": Message does not reference all ' + b + " arg(s).");
        }
        interpolateArguments_(a, b, c) {
            const d = [];
            for(let e = 0; e < a.length; e++){
                let f = a[e];
                "number" === typeof f && (f = b[f - 1]);
                if ("string" === typeof f && (f = this.stringToFieldJson_(f), !f)) continue;
                d.push(f);
            }
            (a = d.length) && !this.isInputKeyword_(d[a - 1].type) && (a = {
                type: "input_dummy"
            }, c && (a.align = c), d.push(a));
            return d;
        }
        fieldFromJson_(a) {
            const b = fromJson$$module$build$src$core$field_registry(a);
            return !b && a.alt ? "string" === typeof a.alt ? (a = this.stringToFieldJson_(a.alt)) ? this.fieldFromJson_(a) : null : this.fieldFromJson_(a.alt) : b;
        }
        inputFromJson_(a, b) {
            var c = {
                LEFT: $.Align$$module$build$src$core$input.LEFT,
                RIGHT: $.Align$$module$build$src$core$input.RIGHT,
                CENTRE: $.Align$$module$build$src$core$input.CENTRE,
                CENTER: $.Align$$module$build$src$core$input.CENTRE
            };
            let d = null;
            switch(a.type){
                case "input_value":
                    d = this.appendValueInput(a.name);
                    break;
                case "input_statement":
                    d = this.appendStatementInput(a.name);
                    break;
                case "input_dummy":
                    d = this.appendDummyInput(a.name);
            }
            if (!d) return null;
            a.check && d.setCheck(a.check);
            a.align && (c = c[a.align.toUpperCase()], void 0 === c ? console.warn(b + "Illegal align value: ", a.align) : d.setAlign(c));
            return d;
        }
        isInputKeyword_(a) {
            return "input_value" === a || "input_statement" === a || "input_dummy" === a;
        }
        stringToFieldJson_(a) {
            return (a = a.trim()) ? {
                type: "field_label",
                text: a
            } : null;
        }
        appendInput_(a, b) {
            let c = null;
            if (a === inputTypes$$module$build$src$core$input_types.VALUE || a === inputTypes$$module$build$src$core$input_types.STATEMENT) c = this.makeConnection_(a);
            a === inputTypes$$module$build$src$core$input_types.STATEMENT && this.statementInputCount++;
            a = new Input$$module$build$src$core$input(a, b, this, c);
            this.inputList.push(a);
            return a;
        }
        moveInputBefore(a, b) {
            if (a !== b) {
                var c = -1, d = b ? -1 : this.inputList.length;
                for(let e = 0, f; f = this.inputList[e]; e++)if (f.name === a) {
                    if (c = e, -1 !== d) break;
                } else if (b && f.name === b && (d = e, -1 !== c)) break;
                if (-1 === c) throw Error('Named input "' + a + '" not found.');
                if (-1 === d) throw Error('Reference input "' + b + '" not found.');
                this.moveNumberedInputBefore(c, d);
            }
        }
        moveNumberedInputBefore(a, b) {
            if (a === b) throw Error("Can't move input to itself.");
            if (a >= this.inputList.length) throw RangeError("Input index " + a + " out of bounds.");
            if (b > this.inputList.length) throw RangeError("Reference input " + b + " out of bounds.");
            const c = this.inputList[a];
            this.inputList.splice(a, 1);
            a < b && b--;
            this.inputList.splice(b, 0, c);
        }
        removeInput(a, b) {
            for(let c = 0, d; d = this.inputList[c]; c++)if (d.name === a) return d.type === inputTypes$$module$build$src$core$input_types.STATEMENT && this.statementInputCount--, d.dispose(), this.inputList.splice(c, 1), !0;
            if (b) return !1;
            throw Error("Input not found: " + a);
        }
        getInput(a) {
            for(let b = 0, c; c = this.inputList[b]; b++)if (c.name === a) return c;
            return null;
        }
        getInputTargetBlock(a) {
            return (a = this.getInput(a)) && a.connection && a.connection.targetBlock();
        }
        getCommentText() {
            return this.commentModel.text;
        }
        setCommentText(a) {
            this.commentModel.text !== a && (fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(CHANGE$$module$build$src$core$events$utils))(this, "comment", null, this.commentModel.text, a)), this.comment = this.commentModel.text = a);
        }
        setWarningText(a, b) {}
        setMutator(a) {}
        getRelativeToSurfaceXY() {
            return this.xy_;
        }
        moveBy(a, b) {
            if (this.parentBlock_) throw Error("Block has parent.");
            const c = new (get$$module$build$src$core$events$utils(MOVE$$module$build$src$core$events$utils))(this);
            this.xy_.translate(a, b);
            c.recordNew();
            fire$$module$build$src$core$events$utils(c);
        }
        makeConnection_(a) {
            return new Connection$$module$build$src$core$connection(this, a);
        }
        allInputsFilled(a) {
            void 0 === a && (a = !0);
            if (!a && this.isShadow()) return !1;
            for(let c = 0, d; d = this.inputList[c]; c++)if (d.connection) {
                var b = d.connection.targetBlock();
                if (!b || !b.allInputsFilled(a)) return !1;
            }
            return (b = this.getNextBlock()) ? b.allInputsFilled(a) : !0;
        }
        toDevString() {
            let a = this.type ? '"' + this.type + '" block' : "Block";
            this.id && (a += ' (id="' + this.id + '")');
            return a;
        }
    };
    Block$$module$build$src$core$block.COLLAPSED_INPUT_NAME = COLLAPSED_INPUT_NAME$$module$build$src$core$constants;
    Block$$module$build$src$core$block.COLLAPSED_FIELD_NAME = COLLAPSED_FIELD_NAME$$module$build$src$core$constants;
    var module$build$src$core$block = {};
    module$build$src$core$block.Block = Block$$module$build$src$core$block;
    var disconnectPid$$module$build$src$core$block_animations = null, wobblingBlock$$module$build$src$core$block_animations = null, module$build$src$core$block_animations = {};
    module$build$src$core$block_animations.connectionUiEffect = connectionUiEffect$$module$build$src$core$block_animations;
    module$build$src$core$block_animations.disconnectUiEffect = disconnectUiEffect$$module$build$src$core$block_animations;
    module$build$src$core$block_animations.disconnectUiStop = disconnectUiStop$$module$build$src$core$block_animations;
    module$build$src$core$block_animations.disposeUiEffect = disposeUiEffect$$module$build$src$core$block_animations;
    var BlockDragSurfaceSvg$$module$build$src$core$block_drag_surface = class {
        constructor(a){
            this.container = a;
            this.scale = 1;
            this.surfaceXY = new Coordinate$$module$build$src$core$utils$coordinate(0, 0);
            this.childSurfaceXY = new Coordinate$$module$build$src$core$utils$coordinate(0, 0);
            this.svg = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.SVG, {
                xmlns: SVG_NS$$module$build$src$core$utils$dom,
                "xmlns:html": HTML_NS$$module$build$src$core$utils$dom,
                "xmlns:xlink": XLINK_NS$$module$build$src$core$utils$dom,
                version: "1.1",
                "class": "blocklyBlockDragSurface"
            }, this.container);
            this.dragGroup = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {}, this.svg);
        }
        createDom() {
            warn$$module$build$src$core$utils$deprecation("BlockDragSurfaceSvg createDom", "June 2022", "June 2023");
        }
        setBlocksAndShow(a) {
            if (this.dragGroup.childNodes.length) throw Error("Already dragging a block.");
            this.dragGroup.appendChild(a);
            this.svg.style.display = "block";
            this.surfaceXY = new Coordinate$$module$build$src$core$utils$coordinate(0, 0);
        }
        translateAndScaleGroup(a, b, c) {
            this.scale = c;
            a = Math.round(a);
            b = Math.round(b);
            this.childSurfaceXY.x = a;
            this.childSurfaceXY.y = b;
            this.dragGroup.setAttribute("transform", "translate(" + a + "," + b + ") scale(" + c + ")");
        }
        translateSurfaceInternal_() {
            const a = Math.round(this.surfaceXY.x), b = Math.round(this.surfaceXY.y);
            this.svg.style.display = "block";
            setCssTransform$$module$build$src$core$utils$dom(this.svg, "translate3d(" + a + "px, " + b + "px, 0)");
        }
        translateBy(a, b) {
            this.surfaceXY = new Coordinate$$module$build$src$core$utils$coordinate(this.surfaceXY.x + a, this.surfaceXY.y + b);
            this.translateSurfaceInternal_();
        }
        translateSurface(a, b) {
            this.surfaceXY = new Coordinate$$module$build$src$core$utils$coordinate(a * this.scale, b * this.scale);
            this.translateSurfaceInternal_();
        }
        getSurfaceTranslation() {
            const a = getRelativeXY$$module$build$src$core$utils$svg_math(this.svg);
            return new Coordinate$$module$build$src$core$utils$coordinate(a.x / this.scale, a.y / this.scale);
        }
        getGroup() {
            return this.dragGroup;
        }
        getSvgRoot() {
            return this.svg;
        }
        getCurrentBlock() {
            return this.dragGroup.firstChild;
        }
        getWsTranslation() {
            return this.childSurfaceXY.clone();
        }
        clearAndHide(a) {
            const b = this.getCurrentBlock();
            b && (a ? a.appendChild(b) : this.dragGroup.removeChild(b));
            this.svg.style.display = "none";
            if (this.dragGroup.childNodes.length) throw Error("Drag group was not cleared.");
            this.surfaceXY = new Coordinate$$module$build$src$core$utils$coordinate(0, 0);
        }
    }, module$build$src$core$block_drag_surface = {};
    module$build$src$core$block_drag_surface.BlockDragSurfaceSvg = BlockDragSurfaceSvg$$module$build$src$core$block_drag_surface;
    var BlockDrag$$module$build$src$core$events$events_block_drag = class extends UiBase$$module$build$src$core$events$events_ui_base {
        constructor(a, b, c){
            super(a ? a.workspace.id : void 0);
            this.type = BLOCK_DRAG$$module$build$src$core$events$utils;
            a && (this.blockId = a.id, this.isStart = b, this.blocks = c);
        }
        toJson() {
            const a = super.toJson();
            if (void 0 === this.isStart) throw Error("Whether this event is the start of a drag is undefined. Either pass the value to the constructor, or call fromJson");
            if (void 0 === this.blockId) throw Error("The block ID is undefined. Either pass a block to the constructor, or call fromJson");
            a.isStart = this.isStart;
            a.blockId = this.blockId;
            a.blocks = this.blocks;
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.BlockDrag.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.isStart = a.isStart;
            this.blockId = a.blockId;
            this.blocks = a.blocks;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new BlockDrag$$module$build$src$core$events$events_block_drag);
            b.isStart = a.isStart;
            b.blockId = a.blockId;
            b.blocks = a.blocks;
            return b;
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, BLOCK_DRAG$$module$build$src$core$events$utils, BlockDrag$$module$build$src$core$events$events_block_drag);
    var module$build$src$core$events$events_block_drag = {};
    module$build$src$core$events$events_block_drag.BlockDrag = BlockDrag$$module$build$src$core$events$events_block_drag;
    var bumpIntoBounds$$module$build$src$core$bump_objects = bumpObjectIntoBounds$$module$build$src$core$bump_objects, module$build$src$core$bump_objects = {};
    module$build$src$core$bump_objects.bumpIntoBounds = bumpObjectIntoBounds$$module$build$src$core$bump_objects;
    module$build$src$core$bump_objects.bumpIntoBoundsHandler = bumpIntoBoundsHandler$$module$build$src$core$bump_objects;
    module$build$src$core$bump_objects.bumpTopObjectsIntoBounds = bumpTopObjectsIntoBounds$$module$build$src$core$bump_objects;
    var Capability$$module$build$src$core$component_manager = class {
        constructor(a){
            this.name_ = a;
        }
        toString() {
            return this.name_;
        }
    };
    Capability$$module$build$src$core$component_manager.POSITIONABLE = new Capability$$module$build$src$core$component_manager("positionable");
    Capability$$module$build$src$core$component_manager.DRAG_TARGET = new Capability$$module$build$src$core$component_manager("drag_target");
    Capability$$module$build$src$core$component_manager.DELETE_AREA = new Capability$$module$build$src$core$component_manager("delete_area");
    Capability$$module$build$src$core$component_manager.AUTOHIDEABLE = new Capability$$module$build$src$core$component_manager("autohideable");
    var ComponentManager$$module$build$src$core$component_manager = class {
        constructor(){
            this.componentData = new Map;
            this.capabilityToComponentIds = new Map;
        }
        addComponent(a, b) {
            const c = a.component.id;
            if (!b && this.componentData.has(c)) {
                var d;
                throw Error('Plugin "' + c + '" with capabilities "' + (null == (d = this.componentData.get(c)) ? void 0 : d.capabilities) + '" already added.');
            }
            this.componentData.set(c, a);
            b = [];
            for(d = 0; d < a.capabilities.length; d++){
                const e = String(a.capabilities[d]).toLowerCase();
                b.push(e);
                if (this.capabilityToComponentIds.has(e)) {
                    let f;
                    null == (f = this.capabilityToComponentIds.get(e)) || f.push(c);
                } else this.capabilityToComponentIds.set(e, [
                    c
                ]);
            }
            this.componentData.get(c).capabilities = b;
        }
        removeComponent(a) {
            const b = this.componentData.get(a);
            if (b) {
                for(let c = 0; c < b.capabilities.length; c++){
                    const d = String(b.capabilities[c]).toLowerCase();
                    removeElem$$module$build$src$core$utils$array(this.capabilityToComponentIds.get(d), a);
                }
                this.componentData.delete(a);
            }
        }
        addCapability(a, b) {
            if (!this.getComponent(a)) throw Error('Cannot add capability, "' + b + '". Plugin "' + a + '" has not been added to the ComponentManager');
            if (this.hasCapability(a, b)) console.warn('Plugin "' + a + 'already has capability "' + b + '"');
            else {
                b = `${b}`.toLowerCase();
                var c;
                null == (c = this.componentData.get(a)) || c.capabilities.push(b);
                var d;
                null == (d = this.capabilityToComponentIds.get(b)) || d.push(a);
            }
        }
        removeCapability(a, b) {
            if (!this.getComponent(a)) throw Error('Cannot remove capability, "' + b + '". Plugin "' + a + '" has not been added to the ComponentManager');
            this.hasCapability(a, b) ? (b = `${b}`.toLowerCase(), removeElem$$module$build$src$core$utils$array(this.componentData.get(a).capabilities, b), removeElem$$module$build$src$core$utils$array(this.capabilityToComponentIds.get(b), a)) : console.warn('Plugin "' + a + "doesn't have capability \"" + b + '" to remove');
        }
        hasCapability(a, b) {
            b = `${b}`.toLowerCase();
            return this.componentData.has(a) && -1 !== this.componentData.get(a).capabilities.indexOf(b);
        }
        getComponent(a) {
            let b;
            return null == (b = this.componentData.get(a)) ? void 0 : b.component;
        }
        getComponents(a, b) {
            a = `${a}`.toLowerCase();
            a = this.capabilityToComponentIds.get(a);
            if (!a) return [];
            const c = [];
            if (b) {
                const d = [];
                a.forEach((e)=>{
                    d.push(this.componentData.get(e));
                });
                d.sort(function(e, f) {
                    return e.weight - f.weight;
                });
                d.forEach(function(e) {
                    c.push(e.component);
                });
            } else a.forEach((d)=>{
                c.push(this.componentData.get(d).component);
            });
            return c;
        }
    };
    ComponentManager$$module$build$src$core$component_manager.Capability = Capability$$module$build$src$core$component_manager;
    var module$build$src$core$component_manager = {};
    module$build$src$core$component_manager.ComponentManager = ComponentManager$$module$build$src$core$component_manager;
    var DUPLICATE_BLOCK_ERROR$$module$build$src$core$insertion_marker_manager = "The insertion marker manager tried to create a marker but the result is missing %1. If you are using a mutator, make sure your domToMutation method is properly defined.", InsertionMarkerManager$$module$build$src$core$insertion_marker_manager = class {
        constructor(a){
            this.activeCandidate = this.lastMarker = this.lastOnStack = null;
            this.wouldDeleteBlock = !1;
            this.fadedBlock = this.highlightedBlock = this.markerConnection = null;
            setSelected$$module$build$src$core$common(a);
            this.topBlock = a;
            this.workspace = a.workspace;
            this.firstMarker = this.createMarkerBlock(this.topBlock);
            this.availableConnections = this.initAvailableConnections();
            this.lastOnStack && (this.lastMarker = this.createMarkerBlock(this.lastOnStack.getSourceBlock()));
        }
        dispose() {
            this.availableConnections.length = 0;
            this.disposeInsertionMarker(this.firstMarker);
            this.disposeInsertionMarker(this.lastMarker);
        }
        updateAvailableConnections() {
            this.availableConnections = this.initAvailableConnections();
        }
        wouldConnectBlock() {
            return !!this.activeCandidate;
        }
        applyConnections() {
            if (this.activeCandidate) {
                disable$$module$build$src$core$events$utils();
                this.hidePreview();
                enable$$module$build$src$core$events$utils();
                var { local: a, closest: b } = this.activeCandidate;
                a.connect(b);
                if (this.topBlock.rendered) {
                    const c = a.isSuperior() ? b : a, d = this.topBlock.getRootBlock();
                    requestAnimationFrame(()=>{
                        connectionUiEffect$$module$build$src$core$block_animations(c.getSourceBlock());
                        setTimeout(()=>{
                            d.bringToFront();
                        }, 0);
                    });
                }
            }
        }
        update(a, b) {
            const c = this.getCandidate(a);
            if ((this.wouldDeleteBlock = this.shouldDelete(!!c, b)) || this.shouldUpdatePreviews(c, a)) disable$$module$build$src$core$events$utils(), this.maybeHidePreview(c), this.maybeShowPreview(c), enable$$module$build$src$core$events$utils();
        }
        createMarkerBlock(a) {
            var b = a.type;
            disable$$module$build$src$core$events$utils();
            let c;
            try {
                c = this.workspace.newBlock(b);
                c.setInsertionMarker(!0);
                if (a.saveExtraState) {
                    var d = a.saveExtraState();
                    d && c.loadExtraState && c.loadExtraState(d);
                } else if (a.mutationToDom) {
                    const e = a.mutationToDom();
                    e && c.domToMutation && c.domToMutation(e);
                }
                for(b = 0; b < a.inputList.length; b++){
                    const e = a.inputList[b];
                    if (e.name === COLLAPSED_INPUT_NAME$$module$build$src$core$constants) continue;
                    const f = c.inputList[b];
                    if (!f) throw Error(DUPLICATE_BLOCK_ERROR$$module$build$src$core$insertion_marker_manager.replace("%1", "an input"));
                    for(d = 0; d < e.fieldRow.length; d++){
                        const g = e.fieldRow[d], h = f.fieldRow[d];
                        if (!h) throw Error(DUPLICATE_BLOCK_ERROR$$module$build$src$core$insertion_marker_manager.replace("%1", "a field"));
                        h.setValue(g.getValue());
                    }
                }
                c.setCollapsed(a.isCollapsed());
                c.setInputsInline(a.getInputsInline());
                c.initSvg();
                c.getSvgRoot().setAttribute("visibility", "hidden");
            } finally{
                enable$$module$build$src$core$events$utils();
            }
            return c;
        }
        initAvailableConnections() {
            const a = this.topBlock.getConnections_(!1), b = this.topBlock.lastConnectionInStack(!0);
            b && b !== this.topBlock.nextConnection && (a.push(b), this.lastOnStack = b);
            return a;
        }
        shouldUpdatePreviews(a, b) {
            if (!a) return !!this.activeCandidate;
            if (!this.activeCandidate) return !0;
            const { local: c, closest: d } = this.activeCandidate;
            if (d === a.closest && c === a.local) return !1;
            const e = c.x + b.x - d.x;
            b = c.y + b.y - d.y;
            return a.radius < Math.sqrt(e * e + b * b) - $.config$$module$build$src$core$config.currentConnectionPreference;
        }
        getCandidate(a) {
            this.markerConnection && this.markerConnection.isConnected() || this.updateAvailableConnections();
            let b = this.getStartRadius(), c = null;
            for(let d = 0; d < this.availableConnections.length; d++){
                const e = this.availableConnections[d], f = e.closest(b, a);
                f.connection && (c = {
                    closest: f.connection,
                    local: e,
                    radius: f.radius
                }, b = f.radius);
            }
            return c;
        }
        getStartRadius() {
            return this.activeCandidate ? $.config$$module$build$src$core$config.connectingSnapRadius : $.config$$module$build$src$core$config.snapRadius;
        }
        shouldDelete(a, b) {
            return b && this.workspace.getComponentManager().hasCapability(b.id, ComponentManager$$module$build$src$core$component_manager.Capability.DELETE_AREA) ? b.wouldDelete(this.topBlock, a) : !1;
        }
        maybeShowPreview(a) {
            if (!this.wouldDeleteBlock && a) {
                var b = a.closest, c;
                b === (null == (c = this.activeCandidate) ? void 0 : c.closest) || b.getSourceBlock().isInsertionMarker() ? console.log("Trying to connect to an insertion marker") : (this.activeCandidate = a, this.showPreview(this.activeCandidate));
            }
        }
        showPreview(a) {
            const b = this.workspace.getRenderer();
            switch(b.getConnectionPreviewMethod(a.closest, a.local, this.topBlock)){
                case InsertionMarkerManager$$module$build$src$core$insertion_marker_manager.PREVIEW_TYPE.INPUT_OUTLINE:
                    this.showInsertionInputOutline(a);
                    break;
                case InsertionMarkerManager$$module$build$src$core$insertion_marker_manager.PREVIEW_TYPE.INSERTION_MARKER:
                    this.showInsertionMarker(a);
                    break;
                case InsertionMarkerManager$$module$build$src$core$insertion_marker_manager.PREVIEW_TYPE.REPLACEMENT_FADE:
                    this.showReplacementFade(a);
            }
            b.shouldHighlightConnection(a.closest) && a.closest.highlight();
        }
        maybeHidePreview(a) {
            if (!a) this.hidePreview();
            else if (this.activeCandidate) {
                const b = this.activeCandidate.local !== a.local;
                (this.activeCandidate.closest !== a.closest || b || this.wouldDeleteBlock) && this.hidePreview();
            }
            this.activeCandidate = this.markerConnection = null;
        }
        hidePreview() {
            let a;
            const b = null == (a = this.activeCandidate) ? void 0 : a.closest;
            b && b.targetBlock() && this.workspace.getRenderer().shouldHighlightConnection(b) && b.unhighlight();
            this.hideReplacementFade();
            this.hideInsertionInputOutline();
            this.hideInsertionMarker();
        }
        showInsertionMarker(a) {
            const { local: b, closest: c } = a;
            let d = (a = this.lastOnStack && b === this.lastOnStack) ? this.lastMarker : this.firstMarker;
            if (!d) throw Error("Cannot show the insertion marker because there is no insertion marker block");
            let e;
            try {
                e = d.getMatchingConnection(b.getSourceBlock(), b);
            } catch (f) {
                a && this.lastOnStack ? (this.disposeInsertionMarker(this.lastMarker), d = this.lastMarker = this.createMarkerBlock(this.lastOnStack.getSourceBlock())) : (this.disposeInsertionMarker(this.firstMarker), d = this.firstMarker = this.createMarkerBlock(this.topBlock));
                if (!d) throw Error("Cannot show the insertion marker because there is no insertion marker block");
                e = d.getMatchingConnection(b.getSourceBlock(), b);
            }
            if (!e) throw Error("Cannot show the insertion marker because there is no associated connection");
            if (e === this.markerConnection) throw Error("Made it to showInsertionMarker_ even though the marker isn't changing");
            d.render();
            d.rendered = !0;
            d.getSvgRoot().setAttribute("visibility", "visible");
            e && c && d.positionNearConnection(e, c);
            c && e.connect(c);
            this.markerConnection = e;
        }
        hideInsertionMarker() {
            if (this.markerConnection) {
                var a = this.markerConnection, b = a.getSourceBlock(), c = b.outputConnection, d;
                if ((null == (d = b.previousConnection) ? 0 : d.targetConnection) || (null == c ? 0 : c.targetConnection)) b.unplug(!0);
                else {
                    let e;
                    null == (e = a.targetBlock()) || e.unplug(!1);
                }
                if (a.targetConnection) throw Error("markerConnection still connected at the end of disconnectInsertionMarker");
                this.markerConnection = null;
                (a = b.getSvgRoot()) && a.setAttribute("visibility", "hidden");
            }
        }
        showInsertionInputOutline(a) {
            a = a.closest;
            this.highlightedBlock = a.getSourceBlock();
            this.highlightedBlock.highlightShapeForInput(a, !0);
        }
        hideInsertionInputOutline() {
            if (this.highlightedBlock) {
                if (!this.activeCandidate) throw Error("Cannot hide the insertion marker outline because there is no active candidate");
                this.highlightedBlock.highlightShapeForInput(this.activeCandidate.closest, !1);
                this.highlightedBlock = null;
            }
        }
        showReplacementFade(a) {
            this.fadedBlock = a.closest.targetBlock();
            if (!this.fadedBlock) throw Error("Cannot show the replacement fade because the closest connection does not have a target block");
            this.fadedBlock.fadeForReplacement(!0);
        }
        hideReplacementFade() {
            this.fadedBlock && (this.fadedBlock.fadeForReplacement(!1), this.fadedBlock = null);
        }
        getInsertionMarkers() {
            const a = [];
            this.firstMarker && a.push(this.firstMarker);
            this.lastMarker && a.push(this.lastMarker);
            return a;
        }
        disposeInsertionMarker(a) {
            if (a) {
                disable$$module$build$src$core$events$utils();
                try {
                    a.dispose();
                } finally{
                    enable$$module$build$src$core$events$utils();
                }
            }
        }
    };
    (function(a) {
        a = a.PREVIEW_TYPE || (a.PREVIEW_TYPE = {});
        a[a.INSERTION_MARKER = 0] = "INSERTION_MARKER";
        a[a.INPUT_OUTLINE = 1] = "INPUT_OUTLINE";
        a[a.REPLACEMENT_FADE = 2] = "REPLACEMENT_FADE";
    })(InsertionMarkerManager$$module$build$src$core$insertion_marker_manager || (InsertionMarkerManager$$module$build$src$core$insertion_marker_manager = {}));
    var PreviewType$$module$build$src$core$insertion_marker_manager = InsertionMarkerManager$$module$build$src$core$insertion_marker_manager.PREVIEW_TYPE, module$build$src$core$insertion_marker_manager = {};
    module$build$src$core$insertion_marker_manager.InsertionMarkerManager = InsertionMarkerManager$$module$build$src$core$insertion_marker_manager;
    module$build$src$core$insertion_marker_manager.PreviewType = PreviewType$$module$build$src$core$insertion_marker_manager;
    var BlockDragger$$module$build$src$core$block_dragger = class {
        constructor(a, b){
            this.dragTarget_ = null;
            this.wouldDeleteBlock_ = !1;
            this.draggingBlock_ = a;
            this.draggedConnectionManager_ = new InsertionMarkerManager$$module$build$src$core$insertion_marker_manager(this.draggingBlock_);
            this.workspace_ = b;
            this.startXY_ = this.draggingBlock_.getRelativeToSurfaceXY();
            this.dragIconData_ = initIconData$$module$build$src$core$block_dragger(a);
        }
        dispose() {
            this.dragIconData_.length = 0;
            this.draggedConnectionManager_ && this.draggedConnectionManager_.dispose();
        }
        startDrag(a, b) {
            getGroup$$module$build$src$core$events$utils() || setGroup$$module$build$src$core$events$utils(!0);
            this.fireDragStartEvent_();
            this.workspace_.isMutator && this.draggingBlock_.bringToFront();
            startTextWidthCache$$module$build$src$core$utils$dom();
            this.workspace_.setResizesEnabled(!1);
            disconnectUiStop$$module$build$src$core$block_animations();
            this.shouldDisconnect_(b) && this.disconnectBlock_(b, a);
            this.draggingBlock_.setDragging(!0);
            this.draggingBlock_.moveToDragSurface();
        }
        shouldDisconnect_(a) {
            return !!(this.draggingBlock_.getParent() || a && this.draggingBlock_.nextConnection && this.draggingBlock_.nextConnection.targetBlock());
        }
        disconnectBlock_(a, b) {
            this.draggingBlock_.unplug(a);
            a = this.pixelsToWorkspaceUnits_(b);
            a = Coordinate$$module$build$src$core$utils$coordinate.sum(this.startXY_, a);
            this.draggingBlock_.translate(a.x, a.y);
            disconnectUiEffect$$module$build$src$core$block_animations(this.draggingBlock_);
            this.draggedConnectionManager_.updateAvailableConnections();
        }
        fireDragStartEvent_() {
            const a = new (get$$module$build$src$core$events$utils(BLOCK_DRAG$$module$build$src$core$events$utils))(this.draggingBlock_, !0, this.draggingBlock_.getDescendants(!1));
            fire$$module$build$src$core$events$utils(a);
        }
        drag(a, b) {
            b = this.pixelsToWorkspaceUnits_(b);
            var c = Coordinate$$module$build$src$core$utils$coordinate.sum(this.startXY_, b);
            this.draggingBlock_.moveDuringDrag(c);
            this.dragIcons_(b);
            c = this.dragTarget_;
            this.dragTarget_ = this.workspace_.getDragTarget(a);
            this.draggedConnectionManager_.update(b, this.dragTarget_);
            a = this.wouldDeleteBlock_;
            this.wouldDeleteBlock_ = this.draggedConnectionManager_.wouldDeleteBlock;
            a !== this.wouldDeleteBlock_ && this.updateCursorDuringBlockDrag_();
            this.dragTarget_ !== c && (c && c.onDragExit(this.draggingBlock_), this.dragTarget_ && this.dragTarget_.onDragEnter(this.draggingBlock_));
            this.dragTarget_ && this.dragTarget_.onDragOver(this.draggingBlock_);
        }
        endDrag(a, b) {
            this.drag(a, b);
            this.dragIconData_ = [];
            this.fireDragEndEvent_();
            stopTextWidthCache$$module$build$src$core$utils$dom();
            disconnectUiStop$$module$build$src$core$block_animations();
            a = null;
            this.dragTarget_ && this.dragTarget_.shouldPreventMove(this.draggingBlock_) ? b = this.startXY_ : (b = this.getNewLocationAfterDrag_(b), a = b.delta, b = b.newLocation);
            this.draggingBlock_.moveOffDragSurface(b);
            if (this.dragTarget_) this.dragTarget_.onDrop(this.draggingBlock_);
            this.maybeDeleteBlock_() || (this.draggingBlock_.setDragging(!1), a ? this.updateBlockAfterMove_() : bumpObjectIntoBounds$$module$build$src$core$bump_objects(this.draggingBlock_.workspace, this.workspace_.getMetricsManager().getScrollMetrics(!0), this.draggingBlock_));
            this.workspace_.setResizesEnabled(!0);
            setGroup$$module$build$src$core$events$utils(!1);
        }
        getNewLocationAfterDrag_(a) {
            a = this.pixelsToWorkspaceUnits_(a);
            const b = Coordinate$$module$build$src$core$utils$coordinate.sum(this.startXY_, a);
            return {
                delta: a,
                newLocation: b
            };
        }
        maybeDeleteBlock_() {
            return this.wouldDeleteBlock_ ? (this.fireMoveEvent_(), this.draggingBlock_.dispose(!1, !0), draggingConnections$$module$build$src$core$common.length = 0, !0) : !1;
        }
        updateBlockAfterMove_() {
            this.fireMoveEvent_();
            this.draggedConnectionManager_.wouldConnectBlock() ? this.draggedConnectionManager_.applyConnections() : this.draggingBlock_.queueRender();
            this.draggingBlock_.scheduleSnapAndBump();
        }
        fireDragEndEvent_() {
            const a = new (get$$module$build$src$core$events$utils(BLOCK_DRAG$$module$build$src$core$events$utils))(this.draggingBlock_, !1, this.draggingBlock_.getDescendants(!1));
            fire$$module$build$src$core$events$utils(a);
        }
        updateToolboxStyle_(a) {
            const b = this.workspace_.getToolbox();
            if (b) {
                const c = this.draggingBlock_.isDeletable() ? "blocklyToolboxDelete" : "blocklyToolboxGrab";
                a && "function" === typeof b.removeStyle ? b.removeStyle(c) : a || "function" !== typeof b.addStyle || b.addStyle(c);
            }
        }
        fireMoveEvent_() {
            if (!this.draggingBlock_.isDeadOrDying()) {
                var a = new (get$$module$build$src$core$events$utils(MOVE$$module$build$src$core$events$utils))(this.draggingBlock_);
                a.oldCoordinate = this.startXY_;
                a.recordNew();
                fire$$module$build$src$core$events$utils(a);
            }
        }
        updateCursorDuringBlockDrag_() {
            this.draggingBlock_.setDeleteStyle(this.wouldDeleteBlock_);
        }
        pixelsToWorkspaceUnits_(a) {
            a = new Coordinate$$module$build$src$core$utils$coordinate(a.x / this.workspace_.scale, a.y / this.workspace_.scale);
            this.workspace_.isMutator && a.scale(1 / this.workspace_.options.parentWorkspace.scale);
            return a;
        }
        dragIcons_(a) {
            for(let b = 0; b < this.dragIconData_.length; b++){
                const c = this.dragIconData_[b];
                c.icon.setIconLocation(Coordinate$$module$build$src$core$utils$coordinate.sum(c.location, a));
            }
        }
        getInsertionMarkers() {
            return this.draggedConnectionManager_ && this.draggedConnectionManager_.getInsertionMarkers ? this.draggedConnectionManager_.getInsertionMarkers() : [];
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.BLOCK_DRAGGER, DEFAULT$$module$build$src$core$registry, BlockDragger$$module$build$src$core$block_dragger);
    var module$build$src$core$block_dragger = {};
    module$build$src$core$block_dragger.BlockDragger = BlockDragger$$module$build$src$core$block_dragger;
    var Comment$$module$build$src$core$comment = class extends Icon$$module$build$src$core$icon {
        constructor(a){
            super(a);
            this.cachedText = "";
            this.boundEvents = [];
            this.paragraphElement_ = this.textarea_ = this.foreignObject = null;
            this.model = a.commentModel;
            let b;
            this.model.text = null != (b = this.model.text) ? b : "";
            this.createIcon();
        }
        drawIcon_(a) {
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.CIRCLE, {
                "class": "blocklyIconShape",
                r: "8",
                cx: "8",
                cy: "8"
            }, a);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATH, {
                "class": "blocklyIconSymbol",
                d: "m6.8,10h2c0.003,-0.617 0.271,-0.962 0.633,-1.266 2.875,-2.4050.607,-5.534 -3.765,-3.874v1.7c3.12,-1.657 3.698,0.118 2.336,1.25-1.201,0.998 -1.201,1.528 -1.204,2.19z"
            }, a);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                "class": "blocklyIconSymbol",
                x: "6.8",
                y: "10.78",
                height: "2",
                width: "2"
            }, a);
        }
        createEditor() {
            this.foreignObject = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FOREIGNOBJECT, {
                x: Bubble$$module$build$src$core$bubble.BORDER_WIDTH,
                y: Bubble$$module$build$src$core$bubble.BORDER_WIDTH
            });
            const a = document.createElementNS(HTML_NS$$module$build$src$core$utils$dom, "body");
            a.setAttribute("xmlns", HTML_NS$$module$build$src$core$utils$dom);
            a.className = "blocklyMinimalBody";
            const b = this.textarea_ = document.createElementNS(HTML_NS$$module$build$src$core$utils$dom, "textarea");
            b.className = "blocklyCommentTextarea";
            b.setAttribute("dir", this.getBlock().RTL ? "RTL" : "LTR");
            let c;
            b.value = null != (c = this.model.text) ? c : "";
            this.resizeTextarea();
            a.appendChild(b);
            this.foreignObject.appendChild(a);
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(b, "focus", this, this.startEdit, !0));
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(b, "wheel", this, function(d) {
                d.stopPropagation();
            }));
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(b, "change", this, function(d) {
                this.cachedText !== this.model.text && fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(CHANGE$$module$build$src$core$events$utils))(this.getBlock(), "comment", null, this.cachedText, this.model.text));
            }));
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(b, "input", this, function(d) {
                this.model.text = b.value;
            }));
            setTimeout(b.focus.bind(b), 0);
            return this.foreignObject;
        }
        updateEditable() {
            super.updateEditable();
            this.isVisible() && (this.disposeBubble(), this.createBubble());
        }
        onBubbleResize() {
            this.isVisible() && this.bubble_ && (this.model.size = this.bubble_.getBubbleSize(), this.resizeTextarea());
        }
        resizeTextarea() {
            if (this.textarea_ && this.foreignObject) {
                var a = this.model.size, b = 2 * Bubble$$module$build$src$core$bubble.BORDER_WIDTH, c = a.width - b;
                a = a.height - b;
                this.foreignObject.setAttribute("width", `${c}`);
                this.foreignObject.setAttribute("height", `${a}`);
                this.textarea_.style.width = c - 4 + "px";
                this.textarea_.style.height = a - 4 + "px";
            }
        }
        setVisible(a) {
            a !== this.isVisible() && (fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(BUBBLE_OPEN$$module$build$src$core$events$utils))(this.getBlock(), a, "comment")), (this.model.pinned = a) ? this.createBubble() : this.disposeBubble());
        }
        createBubble() {
            this.getBlock().isEditable() ? this.createEditableBubble() : this.createNonEditableBubble();
        }
        createEditableBubble() {
            const a = this.getBlock();
            this.bubble_ = new Bubble$$module$build$src$core$bubble(a.workspace, this.createEditor(), a.pathObject.svgPath, this.iconXY_, this.model.size.width, this.model.size.height);
            this.bubble_.setSvgId(a.id);
            this.bubble_.registerResizeEvent(this.onBubbleResize.bind(this));
            this.applyColour();
        }
        createNonEditableBubble() {
            let a;
            this.paragraphElement_ = Bubble$$module$build$src$core$bubble.textToDom(null != (a = this.model.text) ? a : "");
            this.bubble_ = Bubble$$module$build$src$core$bubble.createNonEditableBubble(this.paragraphElement_, this.getBlock(), this.iconXY_);
            this.applyColour();
        }
        disposeBubble() {
            for (const a of this.boundEvents)unbind$$module$build$src$core$browser_events(a);
            this.boundEvents.length = 0;
            this.bubble_ && (this.bubble_.dispose(), this.bubble_ = null);
            this.paragraphElement_ = this.foreignObject = this.textarea_ = null;
        }
        startEdit(a) {
            let b;
            (null == (b = this.bubble_) ? 0 : b.promote()) && this.textarea_.focus();
            this.cachedText = this.model.text;
        }
        getBubbleSize() {
            return this.model.size;
        }
        setBubbleSize(a, b) {
            this.bubble_ ? this.bubble_.setBubbleSize(a, b) : (this.model.size.width = a, this.model.size.height = b);
        }
        updateText() {
            if (this.textarea_) {
                let a;
                this.textarea_.value = null != (a = this.model.text) ? a : "";
            } else this.paragraphElement_ && (this.paragraphElement_.firstChild.textContent = this.model.text);
        }
        dispose() {
            this.getBlock().comment = null;
            super.dispose();
        }
    };
    register$$module$build$src$core$css("\n.blocklyCommentTextarea {\n  background-color: #fef49c;\n  border: 0;\n  display: block;\n  margin: 0;\n  outline: 0;\n  padding: 3px;\n  resize: none;\n  text-overflow: hidden;\n}\n");
    var module$build$src$core$comment = {};
    module$build$src$core$comment.Comment = Comment$$module$build$src$core$comment;
    var copyData$$module$build$src$core$clipboard = null, TEST_ONLY$$module$build$src$core$clipboard = {
        duplicateInternal: duplicateInternal$$module$build$src$core$clipboard,
        copyInternal: copyInternal$$module$build$src$core$clipboard
    }, module$build$src$core$clipboard = {};
    module$build$src$core$clipboard.TEST_ONLY = TEST_ONLY$$module$build$src$core$clipboard;
    module$build$src$core$clipboard.copy = copy$$module$build$src$core$clipboard;
    module$build$src$core$clipboard.duplicate = duplicate$$module$build$src$core$clipboard;
    module$build$src$core$clipboard.paste = paste$$module$build$src$core$clipboard;
    var currentBlock$$module$build$src$core$contextmenu, dummyOwner$$module$build$src$core$contextmenu, menu_$$module$build$src$core$contextmenu;
    currentBlock$$module$build$src$core$contextmenu = null;
    dummyOwner$$module$build$src$core$contextmenu = {};
    menu_$$module$build$src$core$contextmenu = null;
    $.module$build$src$core$contextmenu = {};
    $.module$build$src$core$contextmenu.callbackFactory = callbackFactory$$module$build$src$core$contextmenu;
    $.module$build$src$core$contextmenu.commentDeleteOption = commentDeleteOption$$module$build$src$core$contextmenu;
    $.module$build$src$core$contextmenu.commentDuplicateOption = commentDuplicateOption$$module$build$src$core$contextmenu;
    $.module$build$src$core$contextmenu.dispose = dispose$$module$build$src$core$contextmenu;
    $.module$build$src$core$contextmenu.getCurrentBlock = getCurrentBlock$$module$build$src$core$contextmenu;
    $.module$build$src$core$contextmenu.hide = hide$$module$build$src$core$contextmenu;
    $.module$build$src$core$contextmenu.setCurrentBlock = setCurrentBlock$$module$build$src$core$contextmenu;
    $.module$build$src$core$contextmenu.show = show$$module$build$src$core$contextmenu;
    $.module$build$src$core$contextmenu.workspaceCommentOption = workspaceCommentOption$$module$build$src$core$contextmenu;
    var ContextMenuRegistry$$module$build$src$core$contextmenu_registry = class {
        constructor(){
            this.registry_ = new Map;
            this.reset();
        }
        reset() {
            this.registry_.clear();
        }
        register(a) {
            if (this.registry_.has(a.id)) throw Error('Menu item with ID "' + a.id + '" is already registered.');
            this.registry_.set(a.id, a);
        }
        unregister(a) {
            if (!this.registry_.has(a)) throw Error('Menu item with ID "' + a + '" not found.');
            this.registry_.delete(a);
        }
        getItem(a) {
            let b;
            return null != (b = this.registry_.get(a)) ? b : null;
        }
        getContextMenuOptions(a, b) {
            const c = [];
            for (const e of this.registry_.values())if (a === e.scopeType) {
                var d = e.preconditionFn(b);
                "hidden" !== d && (d = {
                    text: "function" === typeof e.displayText ? e.displayText(b) : e.displayText,
                    enabled: "enabled" === d,
                    callback: e.callback,
                    scope: b,
                    weight: e.weight
                }, c.push(d));
            }
            c.sort(function(e, f) {
                return e.weight - f.weight;
            });
            return c;
        }
    };
    (function(a) {
        var b = a.ScopeType || (a.ScopeType = {});
        b.BLOCK = "block";
        b.WORKSPACE = "workspace";
        a.registry = new a;
    })(ContextMenuRegistry$$module$build$src$core$contextmenu_registry || (ContextMenuRegistry$$module$build$src$core$contextmenu_registry = {}));
    var ScopeType$$module$build$src$core$contextmenu_registry = ContextMenuRegistry$$module$build$src$core$contextmenu_registry.ScopeType, module$build$src$core$contextmenu_registry = {};
    module$build$src$core$contextmenu_registry.ContextMenuRegistry = ContextMenuRegistry$$module$build$src$core$contextmenu_registry;
    module$build$src$core$contextmenu_registry.ScopeType = ScopeType$$module$build$src$core$contextmenu_registry;
    var COLLAPSE_CHARS$$module$build$src$core$internal_constants = 30, DRAG_STACK$$module$build$src$core$internal_constants = !0, OPPOSITE_TYPE$$module$build$src$core$internal_constants = [];
    OPPOSITE_TYPE$$module$build$src$core$internal_constants[ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE] = ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE;
    OPPOSITE_TYPE$$module$build$src$core$internal_constants[ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE] = ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE;
    OPPOSITE_TYPE$$module$build$src$core$internal_constants[ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT] = ConnectionType$$module$build$src$core$connection_type.PREVIOUS_STATEMENT;
    OPPOSITE_TYPE$$module$build$src$core$internal_constants[ConnectionType$$module$build$src$core$connection_type.PREVIOUS_STATEMENT] = ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT;
    var RENAME_VARIABLE_ID$$module$build$src$core$internal_constants = "RENAME_VARIABLE_ID", DELETE_VARIABLE_ID$$module$build$src$core$internal_constants = "DELETE_VARIABLE_ID", module$build$src$core$internal_constants = {};
    module$build$src$core$internal_constants.COLLAPSE_CHARS = COLLAPSE_CHARS$$module$build$src$core$internal_constants;
    module$build$src$core$internal_constants.DELETE_VARIABLE_ID = DELETE_VARIABLE_ID$$module$build$src$core$internal_constants;
    module$build$src$core$internal_constants.DRAG_STACK = DRAG_STACK$$module$build$src$core$internal_constants;
    module$build$src$core$internal_constants.OPPOSITE_TYPE = OPPOSITE_TYPE$$module$build$src$core$internal_constants;
    module$build$src$core$internal_constants.RENAME_VARIABLE_ID = RENAME_VARIABLE_ID$$module$build$src$core$internal_constants;
    var ASTNode$$module$build$src$core$keyboard_nav$ast_node = class {
        constructor(a, b, c){
            this.wsCoordinate_ = null;
            if (!b) throw Error("Cannot create a node without a location.");
            this.type_ = a;
            this.isConnection_ = ASTNode$$module$build$src$core$keyboard_nav$ast_node.isConnectionType_(a);
            this.location_ = b;
            this.processParams_(c || null);
        }
        processParams_(a) {
            a && a.wsCoordinate && (this.wsCoordinate_ = a.wsCoordinate);
        }
        getLocation() {
            return this.location_;
        }
        getType() {
            return this.type_;
        }
        getWsCoordinate() {
            return this.wsCoordinate_;
        }
        isConnection() {
            return this.isConnection_;
        }
        findNextForInput_() {
            var a = this.location_.getParentInput();
            const b = a.getSourceBlock();
            a = b.inputList.indexOf(a);
            for(a += 1; a < b.inputList.length; a++){
                const c = b.inputList[a], d = c.fieldRow;
                for(let e = 0; e < d.length; e++){
                    const f = d[e];
                    if (f.isClickable() || ASTNode$$module$build$src$core$keyboard_nav$ast_node.NAVIGATE_ALL_FIELDS) return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createFieldNode(f);
                }
                if (c.connection) return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createInputNode(c);
            }
            return null;
        }
        findNextForField_() {
            var a = this.location_, b = a.getParentInput();
            const c = a.getSourceBlock();
            if (!c) throw Error("The current AST location is not associated with a block");
            var d = c.inputList.indexOf(b);
            for(a = b.fieldRow.indexOf(a) + 1; d < c.inputList.length; d++){
                b = c.inputList[d];
                const e = b.fieldRow;
                for(; a < e.length;){
                    if (e[a].isClickable() || ASTNode$$module$build$src$core$keyboard_nav$ast_node.NAVIGATE_ALL_FIELDS) return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createFieldNode(e[a]);
                    a++;
                }
                a = 0;
                if (b.connection) return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createInputNode(b);
            }
            return null;
        }
        findPrevForInput_() {
            const a = this.location_.getParentInput(), b = a.getSourceBlock();
            for(var c = b.inputList.indexOf(a); 0 <= c; c--){
                var d = b.inputList[c];
                if (d.connection && d !== a) return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createInputNode(d);
                d = d.fieldRow;
                for(let e = d.length - 1; 0 <= e; e--){
                    const f = d[e];
                    if (f.isClickable() || ASTNode$$module$build$src$core$keyboard_nav$ast_node.NAVIGATE_ALL_FIELDS) return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createFieldNode(f);
                }
            }
            return null;
        }
        findPrevForField_() {
            var a = this.location_;
            const b = a.getParentInput(), c = a.getSourceBlock();
            if (!c) throw Error("The current AST location is not associated with a block");
            var d = c.inputList.indexOf(b);
            for(a = b.fieldRow.indexOf(a) - 1; 0 <= d; d--){
                var e = c.inputList[d];
                if (e.connection && e !== b) return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createInputNode(e);
                for(e = e.fieldRow; -1 < a;){
                    if (e[a].isClickable() || ASTNode$$module$build$src$core$keyboard_nav$ast_node.NAVIGATE_ALL_FIELDS) return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createFieldNode(e[a]);
                    a--;
                }
                0 <= d - 1 && (a = c.inputList[d - 1].fieldRow.length - 1);
            }
            return null;
        }
        navigateBetweenStacks_(a) {
            var b = this.getLocation();
            if (b.getSourceBlock) {
                var c = b.getSourceBlock();
                c && (b = c);
            }
            if (!b || b.isDeadOrDying()) return null;
            c = b.getRootBlock();
            b = c.workspace.getTopBlocks(!0);
            for(let d = 0; d < b.length; d++)if (c.id === b[d].id) return a = d + (a ? 1 : -1), -1 === a || a === b.length ? null : ASTNode$$module$build$src$core$keyboard_nav$ast_node.createStackNode(b[a]);
            throw Error("Couldn't find " + (a ? "next" : "previous") + " stack?!");
        }
        findTopASTNodeForBlock_(a) {
            const b = getParentConnection$$module$build$src$core$keyboard_nav$ast_node(a);
            return b ? ASTNode$$module$build$src$core$keyboard_nav$ast_node.createConnectionNode(b) : ASTNode$$module$build$src$core$keyboard_nav$ast_node.createBlockNode(a);
        }
        getOutAstNodeForBlock_(a) {
            if (!a) return null;
            a = a.getTopStackBlock();
            const b = getParentConnection$$module$build$src$core$keyboard_nav$ast_node(a);
            return b && b.targetConnection && b.targetConnection.getParentInput() ? ASTNode$$module$build$src$core$keyboard_nav$ast_node.createInputNode(b.targetConnection.getParentInput()) : ASTNode$$module$build$src$core$keyboard_nav$ast_node.createStackNode(a);
        }
        findFirstFieldOrInput_(a) {
            a = a.inputList;
            for(let b = 0; b < a.length; b++){
                const c = a[b], d = c.fieldRow;
                for(let e = 0; e < d.length; e++){
                    const f = d[e];
                    if (f.isClickable() || ASTNode$$module$build$src$core$keyboard_nav$ast_node.NAVIGATE_ALL_FIELDS) return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createFieldNode(f);
                }
                if (c.connection) return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createInputNode(c);
            }
            return null;
        }
        getSourceBlock() {
            return this.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.BLOCK ? this.getLocation() : this.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.STACK ? this.getLocation() : this.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.WORKSPACE ? null : this.getLocation().getSourceBlock();
        }
        next() {
            switch(this.type_){
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.STACK:
                    return this.navigateBetweenStacks_(!0);
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.OUTPUT:
                    return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createBlockNode(this.location_.getSourceBlock());
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.FIELD:
                    return this.findNextForField_();
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.INPUT:
                    return this.findNextForInput_();
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.BLOCK:
                    const a = this.location_.nextConnection;
                    if (!a) break;
                    return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createConnectionNode(a);
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.PREVIOUS:
                    return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createBlockNode(this.location_.getSourceBlock());
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.NEXT:
                    return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createConnectionNode(this.location_.targetConnection);
            }
            return null;
        }
        in() {
            switch(this.type_){
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.WORKSPACE:
                    const a = this.location_.getTopBlocks(!0);
                    if (0 < a.length) return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createStackNode(a[0]);
                    break;
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.STACK:
                    return this.findTopASTNodeForBlock_(this.location_);
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.BLOCK:
                    return this.findFirstFieldOrInput_(this.location_);
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.INPUT:
                    return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createConnectionNode(this.location_.targetConnection);
            }
            return null;
        }
        prev() {
            switch(this.type_){
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.STACK:
                    return this.navigateBetweenStacks_(!1);
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.FIELD:
                    return this.findPrevForField_();
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.INPUT:
                    return this.findPrevForInput_();
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.BLOCK:
                    var a = getParentConnection$$module$build$src$core$keyboard_nav$ast_node(this.location_);
                    if (!a) break;
                    return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createConnectionNode(a);
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.PREVIOUS:
                    if ((a = this.location_.targetConnection) && !a.getParentInput()) return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createConnectionNode(a);
                    break;
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.NEXT:
                    return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createBlockNode(this.location_.getSourceBlock());
            }
            return null;
        }
        out() {
            switch(this.type_){
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.STACK:
                    var a = this.location_, b = a.getRelativeToSurfaceXY();
                    b = new Coordinate$$module$build$src$core$utils$coordinate(b.x, b.y + ASTNode$$module$build$src$core$keyboard_nav$ast_node.DEFAULT_OFFSET_Y);
                    return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createWorkspaceNode(a.workspace, b);
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.OUTPUT:
                    return a = this.location_, (b = a.targetConnection) ? ASTNode$$module$build$src$core$keyboard_nav$ast_node.createConnectionNode(b) : ASTNode$$module$build$src$core$keyboard_nav$ast_node.createStackNode(a.getSourceBlock());
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.FIELD:
                    a = this.location_.getSourceBlock();
                    if (!a) throw Error("The current AST location is not associated with a block");
                    return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createBlockNode(a);
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.INPUT:
                    return ASTNode$$module$build$src$core$keyboard_nav$ast_node.createBlockNode(this.location_.getSourceBlock());
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.BLOCK:
                    return this.getOutAstNodeForBlock_(this.location_);
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.PREVIOUS:
                    return this.getOutAstNodeForBlock_(this.location_.getSourceBlock());
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.NEXT:
                    return this.getOutAstNodeForBlock_(this.location_.getSourceBlock());
            }
            return null;
        }
        static isConnectionType_(a) {
            switch(a){
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.PREVIOUS:
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.NEXT:
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.INPUT:
                case ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.OUTPUT:
                    return !0;
            }
            return !1;
        }
        static createFieldNode(a) {
            return a ? new ASTNode$$module$build$src$core$keyboard_nav$ast_node(ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.FIELD, a) : null;
        }
        static createConnectionNode(a) {
            if (!a) return null;
            const b = a.type;
            return b === ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE || b === ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT && a.getParentInput() ? ASTNode$$module$build$src$core$keyboard_nav$ast_node.createInputNode(a.getParentInput()) : b === ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT ? new ASTNode$$module$build$src$core$keyboard_nav$ast_node(ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.NEXT, a) : b === ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE ? new ASTNode$$module$build$src$core$keyboard_nav$ast_node(ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.OUTPUT, a) : b === ConnectionType$$module$build$src$core$connection_type.PREVIOUS_STATEMENT ? new ASTNode$$module$build$src$core$keyboard_nav$ast_node(ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.PREVIOUS, a) : null;
        }
        static createInputNode(a) {
            return a && a.connection ? new ASTNode$$module$build$src$core$keyboard_nav$ast_node(ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.INPUT, a.connection) : null;
        }
        static createBlockNode(a) {
            return a ? new ASTNode$$module$build$src$core$keyboard_nav$ast_node(ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.BLOCK, a) : null;
        }
        static createStackNode(a) {
            return a ? new ASTNode$$module$build$src$core$keyboard_nav$ast_node(ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.STACK, a) : null;
        }
        static createWorkspaceNode(a, b) {
            return b && a ? new ASTNode$$module$build$src$core$keyboard_nav$ast_node(ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.WORKSPACE, a, {
                wsCoordinate: b
            }) : null;
        }
        static createTopNode(a) {
            const b = getParentConnection$$module$build$src$core$keyboard_nav$ast_node(a);
            return b ? ASTNode$$module$build$src$core$keyboard_nav$ast_node.createConnectionNode(b) : ASTNode$$module$build$src$core$keyboard_nav$ast_node.createBlockNode(a);
        }
    };
    ASTNode$$module$build$src$core$keyboard_nav$ast_node.NAVIGATE_ALL_FIELDS = !1;
    ASTNode$$module$build$src$core$keyboard_nav$ast_node.DEFAULT_OFFSET_Y = -20;
    (function(a) {
        a = a.types || (a.types = {});
        a.FIELD = "field";
        a.BLOCK = "block";
        a.INPUT = "input";
        a.OUTPUT = "output";
        a.NEXT = "next";
        a.PREVIOUS = "previous";
        a.STACK = "stack";
        a.WORKSPACE = "workspace";
    })(ASTNode$$module$build$src$core$keyboard_nav$ast_node || (ASTNode$$module$build$src$core$keyboard_nav$ast_node = {}));
    var module$build$src$core$keyboard_nav$ast_node = {};
    module$build$src$core$keyboard_nav$ast_node.ASTNode = ASTNode$$module$build$src$core$keyboard_nav$ast_node;
    var Marker$$module$build$src$core$keyboard_nav$marker = class {
        constructor(){
            this.drawer_ = this.curNode_ = this.colour = null;
            this.type = "marker";
        }
        setDrawer(a) {
            this.drawer_ = a;
        }
        getDrawer() {
            return this.drawer_;
        }
        getCurNode() {
            return this.curNode_;
        }
        setCurNode(a) {
            const b = this.curNode_;
            this.curNode_ = a;
            this.drawer_ && this.drawer_.draw(b, this.curNode_);
        }
        draw() {
            this.drawer_ && this.drawer_.draw(this.curNode_, this.curNode_);
        }
        hide() {
            this.drawer_ && this.drawer_.hide();
        }
        dispose() {
            this.getDrawer() && this.getDrawer().dispose();
        }
    }, module$build$src$core$keyboard_nav$marker = {};
    module$build$src$core$keyboard_nav$marker.Marker = Marker$$module$build$src$core$keyboard_nav$marker;
    var Cursor$$module$build$src$core$keyboard_nav$cursor = class extends Marker$$module$build$src$core$keyboard_nav$marker {
        constructor(){
            super();
            this.type = "cursor";
        }
        next() {
            var a = this.getCurNode();
            if (!a) return null;
            for(a = a.next(); a && a.next() && (a.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.NEXT || a.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.BLOCK);)a = a.next();
            a && this.setCurNode(a);
            return a;
        }
        in() {
            var a = this.getCurNode();
            if (!a) return null;
            if (a.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.PREVIOUS || a.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.OUTPUT) a = a.next();
            let b, c;
            (a = null != (c = null == (b = a) ? void 0 : b.in()) ? c : null) && this.setCurNode(a);
            return a;
        }
        prev() {
            var a = this.getCurNode();
            if (!a) return null;
            for(a = a.prev(); a && a.prev() && (a.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.NEXT || a.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.BLOCK);)a = a.prev();
            a && this.setCurNode(a);
            return a;
        }
        out() {
            var a = this.getCurNode();
            if (!a) return null;
            (a = a.out()) && a.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.BLOCK && (a = a.prev() || a);
            a && this.setCurNode(a);
            return a;
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.CURSOR, DEFAULT$$module$build$src$core$registry, Cursor$$module$build$src$core$keyboard_nav$cursor);
    var module$build$src$core$keyboard_nav$cursor = {};
    module$build$src$core$keyboard_nav$cursor.Cursor = Cursor$$module$build$src$core$keyboard_nav$cursor;
    var BasicCursor$$module$build$src$core$keyboard_nav$basic_cursor = class extends Cursor$$module$build$src$core$keyboard_nav$cursor {
        constructor(){
            super();
        }
        next() {
            var a = this.getCurNode();
            if (!a) return null;
            (a = this.getNextNode_(a, this.validNode_)) && this.setCurNode(a);
            return a;
        }
        in() {
            return this.next();
        }
        prev() {
            var a = this.getCurNode();
            if (!a) return null;
            (a = this.getPreviousNode_(a, this.validNode_)) && this.setCurNode(a);
            return a;
        }
        out() {
            return this.prev();
        }
        getNextNode_(a, b) {
            if (!a) return null;
            const c = a.in() || a.next();
            if (b(c)) return c;
            if (c) return this.getNextNode_(c, b);
            a = this.findSiblingOrParent_(a.out());
            return b(a) ? a : a ? this.getNextNode_(a, b) : null;
        }
        getPreviousNode_(a, b) {
            if (!a) return null;
            let c = a.prev();
            c = c ? this.getRightMostChild_(c) : a.out();
            return b(c) ? c : c ? this.getPreviousNode_(c, b) : null;
        }
        validNode_(a) {
            let b = !1;
            a = a && a.getType();
            if (a === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.OUTPUT || a === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.INPUT || a === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.FIELD || a === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.NEXT || a === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.PREVIOUS || a === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.WORKSPACE) b = !0;
            return b;
        }
        findSiblingOrParent_(a) {
            if (!a) return null;
            const b = a.next();
            return b ? b : this.findSiblingOrParent_(a.out());
        }
        getRightMostChild_(a) {
            if (!a.in()) return a;
            for(a = a.in(); a && a.next();)a = a.next();
            return this.getRightMostChild_(a);
        }
    };
    BasicCursor$$module$build$src$core$keyboard_nav$basic_cursor.registrationName = "basicCursor";
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.CURSOR, BasicCursor$$module$build$src$core$keyboard_nav$basic_cursor.registrationName, BasicCursor$$module$build$src$core$keyboard_nav$basic_cursor);
    var module$build$src$core$keyboard_nav$basic_cursor = {};
    module$build$src$core$keyboard_nav$basic_cursor.BasicCursor = BasicCursor$$module$build$src$core$keyboard_nav$basic_cursor;
    var TabNavigateCursor$$module$build$src$core$keyboard_nav$tab_navigate_cursor = class extends BasicCursor$$module$build$src$core$keyboard_nav$basic_cursor {
        validNode_(a) {
            let b = !1;
            const c = a && a.getType();
            a && (a = a.getLocation(), c === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.FIELD && a && a.isTabNavigable() && a.isClickable() && (b = !0));
            return b;
        }
    }, module$build$src$core$keyboard_nav$tab_navigate_cursor = {};
    module$build$src$core$keyboard_nav$tab_navigate_cursor.TabNavigateCursor = TabNavigateCursor$$module$build$src$core$keyboard_nav$tab_navigate_cursor;
    var module$build$src$core$utils$svg_paths = {};
    module$build$src$core$utils$svg_paths.arc = arc$$module$build$src$core$utils$svg_paths;
    module$build$src$core$utils$svg_paths.curve = curve$$module$build$src$core$utils$svg_paths;
    module$build$src$core$utils$svg_paths.line = line$$module$build$src$core$utils$svg_paths;
    module$build$src$core$utils$svg_paths.lineOnAxis = lineOnAxis$$module$build$src$core$utils$svg_paths;
    module$build$src$core$utils$svg_paths.lineTo = lineTo$$module$build$src$core$utils$svg_paths;
    module$build$src$core$utils$svg_paths.moveBy = moveBy$$module$build$src$core$utils$svg_paths;
    module$build$src$core$utils$svg_paths.moveTo = moveTo$$module$build$src$core$utils$svg_paths;
    module$build$src$core$utils$svg_paths.point = point$$module$build$src$core$utils$svg_paths;
    var BUMP_RANDOMNESS$$module$build$src$core$rendered_connection = 10, RenderedConnection$$module$build$src$core$rendered_connection = class extends Connection$$module$build$src$core$connection {
        constructor(a, b){
            super(a, b);
            this.targetConnection = this.highlightPath = null;
            this.db_ = a.workspace.connectionDBList[b];
            this.dbOpposite_ = a.workspace.connectionDBList[OPPOSITE_TYPE$$module$build$src$core$internal_constants[b]];
            this.offsetInBlock_ = new Coordinate$$module$build$src$core$utils$coordinate(0, 0);
            this.trackedState_ = RenderedConnection$$module$build$src$core$rendered_connection.TrackedState.WILL_TRACK;
        }
        dispose() {
            super.dispose();
            this.trackedState_ === RenderedConnection$$module$build$src$core$rendered_connection.TrackedState.TRACKED && this.db_.removeConnection(this, this.y);
        }
        getSourceBlock() {
            return super.getSourceBlock();
        }
        targetBlock() {
            return super.targetBlock();
        }
        distanceFrom(a) {
            const b = this.x - a.x;
            a = this.y - a.y;
            return Math.sqrt(b * b + a * a);
        }
        bumpAwayFrom(a) {
            if (!this.sourceBlock_.workspace.isDragging()) {
                var b = this.sourceBlock_.getRootBlock();
                if (!b.isInFlyout) {
                    var c = !1;
                    if (!b.isMovable()) {
                        b = a.getSourceBlock().getRootBlock();
                        if (!b.isMovable()) return;
                        a = this;
                        c = !0;
                    }
                    var d = getSelected$$module$build$src$core$common() == b;
                    d || b.addSelect();
                    var e = a.x + $.config$$module$build$src$core$config.snapRadius + Math.floor(Math.random() * BUMP_RANDOMNESS$$module$build$src$core$rendered_connection) - this.x, f = a.y + $.config$$module$build$src$core$config.snapRadius + Math.floor(Math.random() * BUMP_RANDOMNESS$$module$build$src$core$rendered_connection) - this.y;
                    c && (f = -f);
                    b.RTL && (e = a.x - $.config$$module$build$src$core$config.snapRadius - Math.floor(Math.random() * BUMP_RANDOMNESS$$module$build$src$core$rendered_connection) - this.x);
                    b.moveBy(e, f);
                    d || b.removeSelect();
                }
            }
        }
        moveTo(a, b) {
            let c = !1;
            this.trackedState_ === RenderedConnection$$module$build$src$core$rendered_connection.TrackedState.WILL_TRACK ? (this.db_.addConnection(this, b), this.trackedState_ = RenderedConnection$$module$build$src$core$rendered_connection.TrackedState.TRACKED, c = !0) : this.trackedState_ === RenderedConnection$$module$build$src$core$rendered_connection.TrackedState.TRACKED && (this.db_.removeConnection(this, this.y), this.db_.addConnection(this, b), c = !0);
            this.x = a;
            this.y = b;
            return c;
        }
        moveBy(a, b) {
            return this.moveTo(this.x + a, this.y + b);
        }
        moveToOffset(a) {
            return this.moveTo(a.x + this.offsetInBlock_.x, a.y + this.offsetInBlock_.y);
        }
        setOffsetInBlock(a, b) {
            this.offsetInBlock_.x = a;
            this.offsetInBlock_.y = b;
        }
        getOffsetInBlock() {
            return this.offsetInBlock_;
        }
        tighten() {
            const a = this.targetConnection.x - this.x, b = this.targetConnection.y - this.y;
            if (0 !== a || 0 !== b) {
                const d = this.targetBlock();
                var c = d.getSvgRoot();
                if (!c) throw Error("block is not rendered.");
                c = getRelativeXY$$module$build$src$core$utils$svg_math(c);
                d.translate(c.x - a, c.y - b);
                d.moveConnections(-a, -b);
            }
        }
        tightenEfficiently() {
            var a = this.targetConnection;
            const b = this.targetBlock();
            a && b && (a = Coordinate$$module$build$src$core$utils$coordinate.difference(this.offsetInBlock_, a.offsetInBlock_), b.translate(a.x, a.y));
        }
        closest(a, b) {
            return this.dbOpposite_.searchForClosest(this, a, b);
        }
        highlight() {
            if (!this.highlightPath) {
                var a = this.sourceBlock_.workspace.getRenderer().getConstants();
                var b = a.shapeFor(this);
                this.type === ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE || this.type === ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE ? (a = a.TAB_OFFSET_FROM_TOP, b = moveBy$$module$build$src$core$utils$svg_paths(0, -a) + lineOnAxis$$module$build$src$core$utils$svg_paths("v", a) + b.pathDown + lineOnAxis$$module$build$src$core$utils$svg_paths("v", a)) : (a = a.NOTCH_OFFSET_LEFT - a.CORNER_RADIUS, b = moveBy$$module$build$src$core$utils$svg_paths(-a, 0) + lineOnAxis$$module$build$src$core$utils$svg_paths("h", a) + b.pathLeft + lineOnAxis$$module$build$src$core$utils$svg_paths("h", a));
                a = this.offsetInBlock_;
                this.highlightPath = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATH, {
                    "class": "blocklyHighlightedConnectionPath",
                    d: b,
                    transform: `translate(${a.x}, ${a.y})` + (this.sourceBlock_.RTL ? " scale(-1 1)" : "")
                }, this.sourceBlock_.getSvgRoot());
            }
        }
        unhighlight() {
            this.highlightPath && (removeNode$$module$build$src$core$utils$dom(this.highlightPath), this.highlightPath = null);
        }
        setTracking(a) {
            a && this.trackedState_ === RenderedConnection$$module$build$src$core$rendered_connection.TrackedState.TRACKED || !a && this.trackedState_ === RenderedConnection$$module$build$src$core$rendered_connection.TrackedState.UNTRACKED || this.sourceBlock_.isInFlyout || (a ? (this.db_.addConnection(this, this.y), this.trackedState_ = RenderedConnection$$module$build$src$core$rendered_connection.TrackedState.TRACKED) : (this.trackedState_ === RenderedConnection$$module$build$src$core$rendered_connection.TrackedState.TRACKED && this.db_.removeConnection(this, this.y), this.trackedState_ = RenderedConnection$$module$build$src$core$rendered_connection.TrackedState.UNTRACKED));
        }
        stopTrackingAll() {
            this.setTracking(!1);
            if (this.targetConnection) {
                const c = this.targetBlock().getDescendants(!1);
                for(let d = 0; d < c.length; d++){
                    var a = c[d], b = a.getConnections_(!0);
                    for(let e = 0; e < b.length; e++)b[e].setTracking(!1);
                    a = a.getIcons();
                    for(b = 0; b < a.length; b++)a[b].setVisible(!1);
                }
            }
        }
        startTrackingAll() {
            this.setTracking(!0);
            let a = [];
            if (this.type !== ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE && this.type !== ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT) return a;
            const b = this.targetBlock();
            if (b) {
                let c;
                b.isCollapsed() ? (c = [], b.outputConnection && c.push(b.outputConnection), b.nextConnection && c.push(b.nextConnection), b.previousConnection && c.push(b.previousConnection)) : c = b.getConnections_(!0);
                for(let d = 0; d < c.length; d++)a.push(...c[d].startTrackingAll());
                a.length || (a = [
                    b
                ]);
            }
            return a;
        }
        onFailedConnect(a) {
            const b = this.getSourceBlock();
            if (getRecordUndo$$module$build$src$core$events$utils()) {
                const c = getGroup$$module$build$src$core$events$utils();
                setTimeout((function() {
                    b.isDisposed() || b.getParent() || (setGroup$$module$build$src$core$events$utils(c), this.bumpAwayFrom(a), setGroup$$module$build$src$core$events$utils(!1));
                }).bind(this), $.config$$module$build$src$core$config.bumpDelay);
            }
        }
        disconnectInternal(a = !0) {
            const { parentConnection: b, childConnection: c } = this.getParentAndChildConnections();
            if (b && c) {
                var d = b.getSourceBlock(), e = c.getSourceBlock();
                super.disconnectInternal(a);
                d.rendered && d.queueRender();
                e.rendered && (e.updateDisabled(), e.queueRender(), e.getSvgRoot().style.display = "block");
            }
        }
        respawnShadow_() {
            super.respawnShadow_();
            var a = this.targetBlock();
            a && (a.initSvg(), a.render(!1), a = this.getSourceBlock(), a.rendered && a.queueRender());
        }
        neighbours(a) {
            return this.dbOpposite_.getNeighbours(this, a);
        }
        connect_(a) {
            super.connect_(a);
            var b = this.getSourceBlock();
            a = a.getSourceBlock();
            const c = b.rendered, d = a.rendered;
            c && b.updateDisabled();
            d && a.updateDisabled();
            c && d && (this.type === ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT || this.type === ConnectionType$$module$build$src$core$connection_type.PREVIOUS_STATEMENT ? a.queueRender() : b.queueRender());
            if (b = b.getInputWithBlock(a)) b = b.isVisible(), a.getSvgRoot().style.display = b ? "block" : "none";
        }
        onCheckChanged_() {
            !this.isConnected() || this.targetConnection && this.getConnectionChecker().canConnect(this, this.targetConnection, !1) || ((this.isSuperior() ? this.targetBlock() : this.sourceBlock_).unplug(), this.sourceBlock_.bumpNeighbours());
        }
    };
    (function(a) {
        a = a.TrackedState || (a.TrackedState = {});
        a[a.WILL_TRACK = -1] = "WILL_TRACK";
        a[a.UNTRACKED = 0] = "UNTRACKED";
        a[a.TRACKED = 1] = "TRACKED";
    })(RenderedConnection$$module$build$src$core$rendered_connection || (RenderedConnection$$module$build$src$core$rendered_connection = {}));
    var TrackedState$$module$build$src$core$rendered_connection = RenderedConnection$$module$build$src$core$rendered_connection.TrackedState, module$build$src$core$rendered_connection = {};
    module$build$src$core$rendered_connection.RenderedConnection = RenderedConnection$$module$build$src$core$rendered_connection;
    module$build$src$core$rendered_connection.TrackedState = TrackedState$$module$build$src$core$rendered_connection;
    var Warning$$module$build$src$core$warning = class extends Icon$$module$build$src$core$icon {
        constructor(a){
            super(a);
            this.paragraphElement = null;
            this.collapseHidden = !1;
            this.createIcon();
            this.text = Object.create(null);
        }
        drawIcon_(a) {
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATH, {
                "class": "blocklyIconShape",
                d: "M2,15Q-1,15 0.5,12L6.5,1.7Q8,-1 9.5,1.7L15.5,12Q17,15 14,15z"
            }, a);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATH, {
                "class": "blocklyIconSymbol",
                d: "m7,4.8v3.16l0.27,2.27h1.46l0.27,-2.27v-3.16z"
            }, a);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                "class": "blocklyIconSymbol",
                x: "7",
                y: "11",
                height: "2",
                width: "2"
            }, a);
        }
        setVisible(a) {
            a !== this.isVisible() && (fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(BUBBLE_OPEN$$module$build$src$core$events$utils))(this.getBlock(), a, "warning")), a ? this.createBubble() : this.disposeBubble());
        }
        createBubble() {
            this.paragraphElement = Bubble$$module$build$src$core$bubble.textToDom(this.getText());
            this.bubble_ = Bubble$$module$build$src$core$bubble.createNonEditableBubble(this.paragraphElement, this.getBlock(), this.iconXY_);
            this.applyColour();
        }
        disposeBubble() {
            this.bubble_ && (this.bubble_.dispose(), this.bubble_ = null);
            this.paragraphElement = null;
        }
        setText(a, b) {
            this.text[b] !== a && (a ? this.text[b] = a : delete this.text[b], this.isVisible() && (this.setVisible(!1), this.setVisible(!0)));
        }
        getText() {
            const a = [];
            for(const b in this.text)a.push(this.text[b]);
            return a.join("\n");
        }
        dispose() {
            this.getBlock().warning = null;
            super.dispose();
        }
    }, module$build$src$core$warning = {};
    module$build$src$core$warning.Warning = Warning$$module$build$src$core$warning;
    var rootBlocks$$module$build$src$core$render_management = new Set, dirtyBlocks$$module$build$src$core$render_management = new WeakSet, pid$$module$build$src$core$render_management = 0, module$build$src$core$render_management = {};
    module$build$src$core$render_management.queueRender = queueRender$$module$build$src$core$render_management;
    var BlockSvg$$module$build$src$core$block_svg = class extends Block$$module$build$src$core$block {
        constructor(a, b, c){
            super(a, b, c);
            this.renderingDebugger = null;
            this.width = this.height = 0;
            this.warningTextDb = new Map;
            this.warning = this.commentIcon_ = this.mutator = null;
            this.eventsInit_ = this.renderIsInProgress_ = this.visuallyDisabled = this.rendered = !1;
            this.translation = "";
            this.bumpNeighboursPid = 0;
            this.relativeCoords = new Coordinate$$module$build$src$core$utils$coordinate(0, 0);
            this.workspace = a;
            this.svgGroup_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {});
            this.style = a.getRenderer().getConstants().getBlockStyle(null);
            this.pathObject = a.getRenderer().makePathObject(this.svgGroup_, this.style);
            this.useDragSurface_ = !!a.getBlockDragSurface();
            a = this.pathObject.svgPath;
            a.tooltip = this;
            bindMouseEvents$$module$build$src$core$tooltip(a);
            this.svgGroup_.setAttribute("data-id", this.id);
            this.doInit_();
        }
        initSvg() {
            if (!this.workspace.rendered) throw TypeError("Workspace is headless.");
            for(let b = 0, c; c = this.inputList[b]; b++)c.init();
            var a = this.getIcons();
            for(let b = 0; b < a.length; b++)a[b].createIcon();
            this.applyColour();
            this.pathObject.updateMovable(this.isMovable());
            a = this.getSvgRoot();
            this.workspace.options.readOnly || this.eventsInit_ || !a || conditionalBind$$module$build$src$core$browser_events(a, "pointerdown", this, this.onMouseDown_);
            this.eventsInit_ = !0;
            a.parentNode || this.workspace.getCanvas().appendChild(a);
        }
        getColourSecondary() {
            return this.style.colourSecondary;
        }
        getColourTertiary() {
            return this.style.colourTertiary;
        }
        select() {
            if (this.isShadow() && this.getParent()) this.getParent().select();
            else if (getSelected$$module$build$src$core$common() !== this) {
                var a = null;
                if (getSelected$$module$build$src$core$common()) {
                    a = getSelected$$module$build$src$core$common().id;
                    disable$$module$build$src$core$events$utils();
                    try {
                        getSelected$$module$build$src$core$common().unselect();
                    } finally{
                        enable$$module$build$src$core$events$utils();
                    }
                }
                a = new (get$$module$build$src$core$events$utils(SELECTED$$module$build$src$core$events$utils))(a, this.id, this.workspace.id);
                fire$$module$build$src$core$events$utils(a);
                setSelected$$module$build$src$core$common(this);
                this.addSelect();
            }
        }
        unselect() {
            if (getSelected$$module$build$src$core$common() === this) {
                var a = new (get$$module$build$src$core$events$utils(SELECTED$$module$build$src$core$events$utils))(this.id, null, this.workspace.id);
                a.workspaceId = this.workspace.id;
                fire$$module$build$src$core$events$utils(a);
                setSelected$$module$build$src$core$common(null);
                this.removeSelect();
            }
        }
        getIcons() {
            const a = [];
            this.mutator && a.push(this.mutator);
            this.commentIcon_ && a.push(this.commentIcon_);
            this.warning && a.push(this.warning);
            return a;
        }
        setParent(a) {
            const b = this.parentBlock_;
            if (a !== b) {
                startTextWidthCache$$module$build$src$core$utils$dom();
                super.setParent(a);
                stopTextWidthCache$$module$build$src$core$utils$dom();
                var c = this.getSvgRoot();
                if (!this.workspace.isClearing && c) {
                    var d = this.getRelativeToSurfaceXY();
                    a ? a.getSvgRoot().appendChild(c) : b && (this.workspace.getCanvas().appendChild(c), this.translate(d.x, d.y));
                    this.applyColour();
                }
            }
        }
        getRelativeToSurfaceXY() {
            let a = 0, b = 0;
            const c = this.useDragSurface_ ? this.workspace.getBlockDragSurface().getGroup() : null;
            let d = this.getSvgRoot();
            if (d) do {
                var e = getRelativeXY$$module$build$src$core$utils$svg_math(d);
                a += e.x;
                b += e.y;
                this.useDragSurface_ && this.workspace.getBlockDragSurface().getCurrentBlock() === d && (e = this.workspace.getBlockDragSurface().getSurfaceTranslation(), a += e.x, b += e.y);
                d = d.parentNode;
            }while (d && d !== this.workspace.getCanvas() && d !== c);
            return new Coordinate$$module$build$src$core$utils$coordinate(a, b);
        }
        moveBy(a, b) {
            if (this.parentBlock_) throw Error("Block has parent.");
            const c = isEnabled$$module$build$src$core$events$utils();
            let d = null;
            c && (d = new (get$$module$build$src$core$events$utils(MOVE$$module$build$src$core$events$utils))(this));
            const e = this.getRelativeToSurfaceXY();
            this.translate(e.x + a, e.y + b);
            this.moveConnections(a, b);
            c && d && (d.recordNew(), fire$$module$build$src$core$events$utils(d));
            this.workspace.resizeContents();
        }
        translate(a, b) {
            this.translation = `translate(${a}, ${b})`;
            this.relativeCoords = new Coordinate$$module$build$src$core$utils$coordinate(a, b);
            this.getSvgRoot().setAttribute("transform", this.getTranslation());
        }
        getTranslation() {
            return this.translation;
        }
        moveToDragSurface() {
            if (this.useDragSurface_) {
                var a = this.getRelativeToSurfaceXY();
                this.clearTransformAttributes_();
                this.workspace.getBlockDragSurface().translateSurface(a.x, a.y);
                (a = this.getSvgRoot()) && this.workspace.getBlockDragSurface().setBlocksAndShow(a);
            }
        }
        moveTo(a) {
            const b = this.getRelativeToSurfaceXY();
            this.moveBy(a.x - b.x, a.y - b.y);
        }
        moveOffDragSurface(a) {
            this.useDragSurface_ && (this.translate(a.x, a.y), this.workspace.getBlockDragSurface().clearAndHide(this.workspace.getCanvas()));
        }
        moveDuringDrag(a) {
            this.useDragSurface_ ? this.workspace.getBlockDragSurface().translateSurface(a.x, a.y) : (this.translate(a.x, a.y), this.getSvgRoot().setAttribute("transform", this.getTranslation()));
        }
        clearTransformAttributes_() {
            this.getSvgRoot().removeAttribute("transform");
        }
        snapToGrid() {
            if (!(this.isDeadOrDying() || this.workspace.isDragging() || this.getParent() || this.isInFlyout)) {
                var a = this.workspace.getGrid();
                if (a && a.shouldSnap()) {
                    var b = a.getSpacing(), c = b / 2, d = this.getRelativeToSurfaceXY();
                    a = Math.round(Math.round((d.x - c) / b) * b + c - d.x);
                    b = Math.round(Math.round((d.y - c) / b) * b + c - d.y);
                    (a || b) && this.moveBy(a, b);
                }
            }
        }
        getBoundingRectangle() {
            const a = this.getRelativeToSurfaceXY(), b = this.getHeightWidth();
            let c, d;
            this.RTL ? (c = a.x - b.width, d = a.x) : (c = a.x, d = a.x + b.width);
            return new Rect$$module$build$src$core$utils$rect(a.y, a.y + b.height, c, d);
        }
        markDirty() {
            this.pathObject.constants = this.workspace.getRenderer().getConstants();
            for(let a = 0, b; b = this.inputList[a]; a++)b.markDirty();
        }
        setCollapsed(a) {
            this.collapsed_ !== a && (super.setCollapsed(a), this.updateCollapsed_());
        }
        updateCollapsed_() {
            var a = this.isCollapsed();
            const b = COLLAPSED_INPUT_NAME$$module$build$src$core$constants, c = COLLAPSED_FIELD_NAME$$module$build$src$core$constants;
            for(let e = 0, f; f = this.inputList[e]; e++)f.name !== b && f.setVisible(!a);
            if (a) {
                a = this.getIcons();
                for(let e = 0, f; f = a[e]; e++)f.setVisible(!1);
                a = this.toString(COLLAPSE_CHARS$$module$build$src$core$internal_constants);
                var d = this.getField(c);
                d ? d.setValue(a) : (this.getInput(b) || this.appendDummyInput(b)).appendField(new FieldLabel$$module$build$src$core$field_label(a), c);
            } else this.updateDisabled(), this.removeInput(b);
        }
        tab(a, b) {
            const c = new TabNavigateCursor$$module$build$src$core$keyboard_nav$tab_navigate_cursor;
            c.setCurNode(ASTNode$$module$build$src$core$keyboard_nav$ast_node.createFieldNode(a));
            a = c.getCurNode();
            b ? c.next() : c.prev();
            (b = c.getCurNode()) && b !== a && (b.getLocation().showEditor(), this.workspace.keyboardAccessibilityMode && this.workspace.getCursor().setCurNode(b));
        }
        onMouseDown_(a) {
            const b = this.workspace.getGesture(a);
            b && b.handleBlockStart(a, this);
        }
        showHelp() {
            const a = "function" === typeof this.helpUrl ? this.helpUrl() : this.helpUrl;
            a && window.open(a);
        }
        generateContextMenu() {
            if (this.workspace.options.readOnly || !this.contextMenu) return null;
            const a = ContextMenuRegistry$$module$build$src$core$contextmenu_registry.registry.getContextMenuOptions(ContextMenuRegistry$$module$build$src$core$contextmenu_registry.ScopeType.BLOCK, {
                block: this
            });
            this.customContextMenu && this.customContextMenu(a);
            return a;
        }
        showContextMenu(a) {
            const b = this.generateContextMenu();
            b && b.length && (show$$module$build$src$core$contextmenu(a, b, this.RTL), setCurrentBlock$$module$build$src$core$contextmenu(this));
        }
        moveConnections(a, b) {
            if (this.rendered) {
                var c = this.getConnections_(!1);
                for(var d = 0; d < c.length; d++)c[d].moveBy(a, b);
                c = this.getIcons();
                for(d = 0; d < c.length; d++)c[d].computeIconLocation();
                for(c = 0; c < this.childBlocks_.length; c++)this.childBlocks_[c].moveConnections(a, b);
            }
        }
        setDragging(a) {
            a ? (this.translation = "", draggingConnections$$module$build$src$core$common.push(...this.getConnections_(!0)), addClass$$module$build$src$core$utils$dom(this.svgGroup_, "blocklyDragging")) : (draggingConnections$$module$build$src$core$common.length = 0, removeClass$$module$build$src$core$utils$dom(this.svgGroup_, "blocklyDragging"));
            for(let b = 0; b < this.childBlocks_.length; b++)this.childBlocks_[b].setDragging(a);
        }
        setMovable(a) {
            super.setMovable(a);
            this.pathObject.updateMovable(a);
        }
        setEditable(a) {
            super.setEditable(a);
            a = this.getIcons();
            for(let b = 0; b < a.length; b++)a[b].updateEditable();
        }
        setShadow(a) {
            super.setShadow(a);
            this.applyColour();
        }
        setInsertionMarker(a) {
            this.isInsertionMarker_ !== a && (this.isInsertionMarker_ = a) && (this.setColour(this.workspace.getRenderer().getConstants().INSERTION_MARKER_COLOUR), this.pathObject.updateInsertionMarker(!0));
        }
        getSvgRoot() {
            return this.svgGroup_;
        }
        dispose(a, b) {
            this.isDeadOrDying() || (dispose$$module$build$src$core$tooltip(), hide$$module$build$src$core$contextmenu(), b && this.rendered && (this.unplug(a), disposeUiEffect$$module$build$src$core$block_animations(this)), super.dispose(!!a), removeNode$$module$build$src$core$utils$dom(this.svgGroup_));
        }
        disposeInternal() {
            this.isDeadOrDying() || (super.disposeInternal(), this.rendered = !1, getSelected$$module$build$src$core$common() === this && (this.unselect(), this.workspace.cancelCurrentGesture()), [
                ...this.warningTextDb.values()
            ].forEach((a)=>clearTimeout(a)), this.warningTextDb.clear(), this.getIcons().forEach((a)=>a.dispose()));
        }
        checkAndDelete() {
            this.workspace.isFlyout || (setGroup$$module$build$src$core$events$utils(!0), this.workspace.hideChaff(), this.outputConnection ? this.dispose(!1, !0) : this.dispose(!0, !0), setGroup$$module$build$src$core$events$utils(!1));
        }
        toCopyData() {
            return this.isInsertionMarker_ ? null : {
                saveInfo: save$$module$build$src$core$serialization$blocks(this, {
                    addCoordinates: !0,
                    addNextBlocks: !1
                }),
                source: this.workspace,
                typeCounts: getBlockTypeCounts$$module$build$src$core$common(this, !0)
            };
        }
        applyColour() {
            this.pathObject.applyColour(this);
            const a = this.getIcons();
            for(let b = 0; b < a.length; b++)a[b].applyColour();
            for(let b = 0, c; c = this.inputList[b]; b++)for(let d = 0, e; e = c.fieldRow[d]; d++)e.applyColour();
        }
        updateDisabled() {
            const a = !this.isEnabled() || this.getInheritedDisabled();
            if (this.visuallyDisabled !== a) {
                this.applyColour();
                this.visuallyDisabled = a;
                for (const b of this.getChildren(!1))b.updateDisabled();
            }
        }
        getCommentIcon() {
            return this.commentIcon_;
        }
        setCommentText(a) {
            this.commentModel.text !== a && (super.setCommentText(a), a = null !== a, !!this.commentIcon_ === a ? this.commentIcon_.updateText() : (a ? this.comment = this.commentIcon_ = new Comment$$module$build$src$core$comment(this) : (this.commentIcon_.dispose(), this.comment = this.commentIcon_ = null), this.rendered && (this.render(), this.bumpNeighbours())));
        }
        setWarningText(a, b) {
            const c = b || "";
            if (c) this.warningTextDb.has(c) && (clearTimeout(this.warningTextDb.get(c)), this.warningTextDb.delete(c));
            else {
                for (var d of this.warningTextDb.values())clearTimeout(d);
                this.warningTextDb.clear();
            }
            if (this.workspace.isDragging()) this.warningTextDb.set(c, setTimeout(()=>{
                this.isDeadOrDying() || (this.warningTextDb.delete(c), this.setWarningText(a, c));
            }, 100));
            else {
                this.isInFlyout && (a = null);
                b = !1;
                if ("string" === typeof a) {
                    d = this.getSurroundParent();
                    let e = null;
                    for(; d;)d.isCollapsed() && (e = d), d = d.getSurroundParent();
                    e && e.setWarningText(Msg$$module$build$src$core$msg.COLLAPSED_WARNINGS_WARNING, BlockSvg$$module$build$src$core$block_svg.COLLAPSED_WARNING_ID);
                    this.warning || (this.warning = new Warning$$module$build$src$core$warning(this), b = !0);
                    this.warning.setText(a, c);
                } else this.warning && !c ? (this.warning.dispose(), b = !0) : this.warning && (b = this.warning.getText(), this.warning.setText("", c), (d = this.warning.getText()) || this.warning.dispose(), b = b !== d);
                b && this.rendered && (this.render(), this.bumpNeighbours());
            }
        }
        setMutator(a) {
            this.mutator && this.mutator !== a && this.mutator.dispose();
            a && (a.setBlock(this), this.mutator = a, a.createIcon());
            this.rendered && (this.render(), this.bumpNeighbours());
        }
        setEnabled(a) {
            this.isEnabled() !== a && (super.setEnabled(a), this.rendered && !this.getInheritedDisabled() && this.updateDisabled());
        }
        setHighlighted(a) {
            this.rendered && this.pathObject.updateHighlighted(a);
        }
        addSelect() {
            this.pathObject.updateSelected(!0);
        }
        removeSelect() {
            this.pathObject.updateSelected(!1);
        }
        setDeleteStyle(a) {
            this.pathObject.updateDraggingDelete(a);
        }
        getColour() {
            return this.style.colourPrimary;
        }
        setColour(a) {
            super.setColour(a);
            a = this.workspace.getRenderer().getConstants().getBlockStyleForColour(this.colour_);
            this.pathObject.setStyle(a.style);
            this.style = a.style;
            this.styleName_ = a.name;
            this.applyColour();
        }
        setStyle(a) {
            const b = this.workspace.getRenderer().getConstants().getBlockStyle(a);
            this.styleName_ = a;
            if (b) this.hat = b.hat, this.pathObject.setStyle(b), this.colour_ = b.colourPrimary, this.style = b, this.applyColour();
            else throw Error("Invalid style name: " + a);
        }
        bringToFront() {
            let a = this;
            do {
                const b = a.getSvgRoot(), c = b.parentNode, d = c.childNodes;
                d[d.length - 1] !== b && c.appendChild(b);
                a = a.getParent();
            }while (a);
        }
        setPreviousStatement(a, b) {
            super.setPreviousStatement(a, b);
            this.rendered && (this.queueRender(), this.bumpNeighbours());
        }
        setNextStatement(a, b) {
            super.setNextStatement(a, b);
            this.rendered && (this.queueRender(), this.bumpNeighbours());
        }
        setOutput(a, b) {
            super.setOutput(a, b);
            this.rendered && (this.queueRender(), this.bumpNeighbours());
        }
        setInputsInline(a) {
            super.setInputsInline(a);
            this.rendered && (this.queueRender(), this.bumpNeighbours());
        }
        removeInput(a, b) {
            a = super.removeInput(a, b);
            this.rendered && (this.queueRender(), this.bumpNeighbours());
            return a;
        }
        moveNumberedInputBefore(a, b) {
            super.moveNumberedInputBefore(a, b);
            this.rendered && (this.queueRender(), this.bumpNeighbours());
        }
        appendInput_(a, b) {
            a = super.appendInput_(a, b);
            this.rendered && (this.queueRender(), this.bumpNeighbours());
            return a;
        }
        setConnectionTracking(a) {
            this.previousConnection && this.previousConnection.setTracking(a);
            this.outputConnection && this.outputConnection.setTracking(a);
            if (this.nextConnection) {
                this.nextConnection.setTracking(a);
                var b = this.nextConnection.targetBlock();
                b && b.setConnectionTracking(a);
            }
            if (!this.collapsed_) for(b = 0; b < this.inputList.length; b++){
                var c = this.inputList[b].connection;
                c && (c.setTracking(a), (c = c.targetBlock()) && c.setConnectionTracking(a));
            }
        }
        getConnections_(a) {
            const b = [];
            if (a || this.rendered) {
                if (this.outputConnection && b.push(this.outputConnection), this.previousConnection && b.push(this.previousConnection), this.nextConnection && b.push(this.nextConnection), a || !this.collapsed_) for(let c = 0, d; d = this.inputList[c]; c++)d.connection && b.push(d.connection);
            }
            return b;
        }
        lastConnectionInStack(a) {
            return super.lastConnectionInStack(a);
        }
        getMatchingConnection(a, b) {
            return super.getMatchingConnection(a, b);
        }
        makeConnection_(a) {
            return new RenderedConnection$$module$build$src$core$rendered_connection(this, a);
        }
        getNextBlock() {
            return super.getNextBlock();
        }
        getPreviousBlock() {
            return super.getPreviousBlock();
        }
        bumpNeighbours() {
            if (!this.bumpNeighboursPid) {
                var a = getGroup$$module$build$src$core$events$utils();
                this.bumpNeighboursPid = setTimeout(()=>{
                    const b = getGroup$$module$build$src$core$events$utils();
                    setGroup$$module$build$src$core$events$utils(a);
                    this.getRootBlock().bumpNeighboursInternal();
                    setGroup$$module$build$src$core$events$utils(b);
                    this.bumpNeighboursPid = 0;
                }, $.config$$module$build$src$core$config.bumpDelay);
            }
        }
        bumpNeighboursInternal() {
            const a = this.getRootBlock();
            if (!(this.isDeadOrDying() || this.workspace.isDragging() || a.isInFlyout)) for (const b of this.getConnections_(!1)){
                if (b.isSuperior()) {
                    let c;
                    null == (c = b.targetBlock()) || c.bumpNeighboursInternal();
                }
                for (const c of b.neighbours($.config$$module$build$src$core$config.snapRadius))c.getSourceBlock().getRootBlock() !== a && (b.isConnected() && c.isConnected() || (b.isSuperior() ? c.bumpAwayFrom(b) : b.bumpAwayFrom(c)));
            }
        }
        scheduleSnapAndBump() {
            const a = getGroup$$module$build$src$core$events$utils();
            setTimeout(()=>{
                setGroup$$module$build$src$core$events$utils(a);
                this.snapToGrid();
                setGroup$$module$build$src$core$events$utils(!1);
            }, $.config$$module$build$src$core$config.bumpDelay / 2);
            this.bumpNeighbours();
        }
        positionNearConnection(a, b) {
            a.type !== ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT && a.type !== ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE || this.moveBy(b.x - a.x, b.y - a.y);
        }
        getFirstStatementConnection() {
            return super.getFirstStatementConnection();
        }
        getChildren(a) {
            return super.getChildren(a);
        }
        queueRender() {
            queueRender$$module$build$src$core$render_management(this);
        }
        render(a) {
            if (!this.renderIsInProgress_) {
                this.renderIsInProgress_ = !0;
                try {
                    this.rendered = !0;
                    startTextWidthCache$$module$build$src$core$utils$dom();
                    this.isCollapsed() && this.updateCollapsed_();
                    this.workspace.getRenderer().render(this);
                    this.updateConnectionLocations();
                    if (!1 !== a) {
                        const b = this.getParent();
                        b ? b.render(!0) : this.workspace.resizeContents();
                    }
                    stopTextWidthCache$$module$build$src$core$utils$dom();
                    this.updateMarkers_();
                } finally{
                    this.renderIsInProgress_ = !1;
                }
            }
        }
        renderEfficiently() {
            this.rendered = !0;
            startTextWidthCache$$module$build$src$core$utils$dom();
            this.isCollapsed() && this.updateCollapsed_();
            this.workspace.getRenderer().render(this);
            this.tightenChildrenEfficiently();
            stopTextWidthCache$$module$build$src$core$utils$dom();
            this.updateMarkers_();
        }
        tightenChildrenEfficiently() {
            for (const a of this.inputList){
                const b = a.connection;
                b && b.tightenEfficiently();
            }
            this.nextConnection && this.nextConnection.tightenEfficiently();
        }
        updateMarkers_() {
            this.workspace.keyboardAccessibilityMode && this.pathObject.cursorSvg && this.workspace.getCursor().draw();
            this.workspace.keyboardAccessibilityMode && this.pathObject.markerSvg && this.workspace.getMarker(MarkerManager$$module$build$src$core$marker_manager.LOCAL_MARKER).draw();
            for (const a of this.inputList)for (const b of a.fieldRow)b.updateMarkers_();
        }
        updateConnectionLocations() {
            const a = this.getRelativeToSurfaceXY();
            this.previousConnection && this.previousConnection.moveToOffset(a);
            this.outputConnection && this.outputConnection.moveToOffset(a);
            for(let b = 0; b < this.inputList.length; b++){
                const c = this.inputList[b].connection;
                c && (c.moveToOffset(a), c.isConnected() && c.tighten());
            }
            this.nextConnection && (this.nextConnection.moveToOffset(a), this.nextConnection.isConnected() && this.nextConnection.tighten());
        }
        setCursorSvg(a) {
            this.pathObject.setCursorSvg(a);
        }
        setMarkerSvg(a) {
            this.pathObject.setMarkerSvg(a);
        }
        getHeightWidth() {
            let a = this.height, b = this.width;
            var c = this.getNextBlock();
            if (c) {
                c = c.getHeightWidth();
                const d = this.workspace.getRenderer().getConstants().NOTCH_HEIGHT;
                a += c.height - d;
                b = Math.max(b, c.width);
            }
            return {
                height: a,
                width: b
            };
        }
        fadeForReplacement(a) {
            this.pathObject.updateReplacementFade(a);
        }
        highlightShapeForInput(a, b) {
            this.pathObject.updateShapeForInputHighlight(a, b);
        }
    };
    BlockSvg$$module$build$src$core$block_svg.INLINE = -1;
    BlockSvg$$module$build$src$core$block_svg.COLLAPSED_WARNING_ID = "TEMP_COLLAPSED_WARNING_";
    var module$build$src$core$block_svg = {};
    module$build$src$core$block_svg.BlockSvg = BlockSvg$$module$build$src$core$block_svg;
    var BubbleDragger$$module$build$src$core$bubble_dragger = class {
        constructor(a, b){
            this.bubble = a;
            this.workspace = b;
            this.dragTarget_ = null;
            this.wouldDeleteBubble_ = !1;
            this.startXY_ = this.bubble.getRelativeToSurfaceXY();
            this.dragSurface_ = b.getBlockDragSurface();
        }
        startBubbleDrag() {
            getGroup$$module$build$src$core$events$utils() || setGroup$$module$build$src$core$events$utils(!0);
            this.workspace.setResizesEnabled(!1);
            this.bubble.setAutoLayout(!1);
            this.dragSurface_ && (this.bubble.moveTo(0, 0), this.dragSurface_.translateSurface(this.startXY_.x, this.startXY_.y), this.dragSurface_.setBlocksAndShow(this.bubble.getSvgRoot()));
            this.bubble.setDragging && this.bubble.setDragging(!0);
        }
        dragBubble(a, b) {
            b = this.pixelsToWorkspaceUnits_(b);
            b = Coordinate$$module$build$src$core$utils$coordinate.sum(this.startXY_, b);
            this.bubble.moveDuringDrag(this.dragSurface_, b);
            b = this.dragTarget_;
            this.dragTarget_ = this.workspace.getDragTarget(a);
            a = this.wouldDeleteBubble_;
            this.wouldDeleteBubble_ = this.shouldDelete_(this.dragTarget_);
            a !== this.wouldDeleteBubble_ && this.updateCursorDuringBubbleDrag_();
            this.dragTarget_ !== b && (b && b.onDragExit(this.bubble), this.dragTarget_ && this.dragTarget_.onDragEnter(this.bubble));
            this.dragTarget_ && this.dragTarget_.onDragOver(this.bubble);
        }
        shouldDelete_(a) {
            return a && this.workspace.getComponentManager().hasCapability(a.id, ComponentManager$$module$build$src$core$component_manager.Capability.DELETE_AREA) ? a.wouldDelete(this.bubble, !1) : !1;
        }
        updateCursorDuringBubbleDrag_() {
            this.bubble.setDeleteStyle(this.wouldDeleteBubble_);
        }
        endBubbleDrag(a, b) {
            this.dragBubble(a, b);
            this.dragTarget_ && this.dragTarget_.shouldPreventMove(this.bubble) ? a = this.startXY_ : (a = this.pixelsToWorkspaceUnits_(b), a = Coordinate$$module$build$src$core$utils$coordinate.sum(this.startXY_, a));
            this.bubble.moveTo(a.x, a.y);
            if (this.dragTarget_) this.dragTarget_.onDrop(this.bubble);
            this.wouldDeleteBubble_ ? (this.fireMoveEvent_(), this.bubble.dispose()) : (this.dragSurface_ && this.dragSurface_.clearAndHide(this.workspace.getBubbleCanvas()), this.bubble.setDragging && this.bubble.setDragging(!1), this.fireMoveEvent_());
            this.workspace.setResizesEnabled(!0);
            setGroup$$module$build$src$core$events$utils(!1);
        }
        fireMoveEvent_() {
            if (this.bubble instanceof WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg) {
                const a = new (get$$module$build$src$core$events$utils(COMMENT_MOVE$$module$build$src$core$events$utils))(this.bubble);
                a.setOldCoordinate(this.startXY_);
                a.recordNew();
                fire$$module$build$src$core$events$utils(a);
            }
        }
        pixelsToWorkspaceUnits_(a) {
            a = new Coordinate$$module$build$src$core$utils$coordinate(a.x / this.workspace.scale, a.y / this.workspace.scale);
            this.workspace.isMutator && a.scale(1 / this.workspace.options.parentWorkspace.scale);
            return a;
        }
    }, module$build$src$core$bubble_dragger = {};
    module$build$src$core$bubble_dragger.BubbleDragger = BubbleDragger$$module$build$src$core$bubble_dragger;
    var ConnectionChecker$$module$build$src$core$connection_checker = class {
        canConnect(a, b, c, d) {
            return this.canConnectWithReason(a, b, c, d) === Connection$$module$build$src$core$connection.CAN_CONNECT;
        }
        canConnectWithReason(a, b, c, d) {
            const e = this.doSafetyChecks(a, b);
            return e !== Connection$$module$build$src$core$connection.CAN_CONNECT ? e : this.doTypeChecks(a, b) ? c && !this.doDragChecks(a, b, d || 0) ? Connection$$module$build$src$core$connection.REASON_DRAG_CHECKS_FAILED : Connection$$module$build$src$core$connection.CAN_CONNECT : Connection$$module$build$src$core$connection.REASON_CHECKS_FAILED;
        }
        getErrorMessage(a, b, c) {
            switch(a){
                case Connection$$module$build$src$core$connection.REASON_SELF_CONNECTION:
                    return "Attempted to connect a block to itself.";
                case Connection$$module$build$src$core$connection.REASON_DIFFERENT_WORKSPACES:
                    return "Blocks not on same workspace.";
                case Connection$$module$build$src$core$connection.REASON_WRONG_TYPE:
                    return "Attempt to connect incompatible types.";
                case Connection$$module$build$src$core$connection.REASON_TARGET_NULL:
                    return "Target connection is null.";
                case Connection$$module$build$src$core$connection.REASON_CHECKS_FAILED:
                    return "Connection checks failed. " + (b + " expected " + b.getCheck() + ", found " + c.getCheck());
                case Connection$$module$build$src$core$connection.REASON_SHADOW_PARENT:
                    return "Connecting non-shadow to shadow block.";
                case Connection$$module$build$src$core$connection.REASON_DRAG_CHECKS_FAILED:
                    return "Drag checks failed.";
                case Connection$$module$build$src$core$connection.REASON_PREVIOUS_AND_OUTPUT:
                    return "Block would have an output and a previous connection.";
                default:
                    return "Unknown connection failure: this should never happen!";
            }
        }
        doSafetyChecks(a, b) {
            if (!a || !b) return Connection$$module$build$src$core$connection.REASON_TARGET_NULL;
            let c, d, e;
            a.isSuperior() ? (c = a.getSourceBlock(), d = b.getSourceBlock(), e = b) : (d = a.getSourceBlock(), c = b.getSourceBlock(), e = a, a = b);
            return c === d ? Connection$$module$build$src$core$connection.REASON_SELF_CONNECTION : e.type !== OPPOSITE_TYPE$$module$build$src$core$internal_constants[a.type] ? Connection$$module$build$src$core$connection.REASON_WRONG_TYPE : c.workspace !== d.workspace ? Connection$$module$build$src$core$connection.REASON_DIFFERENT_WORKSPACES : c.isShadow() && !d.isShadow() ? Connection$$module$build$src$core$connection.REASON_SHADOW_PARENT : e.type === ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE && d.previousConnection && d.previousConnection.isConnected() || e.type === ConnectionType$$module$build$src$core$connection_type.PREVIOUS_STATEMENT && d.outputConnection && d.outputConnection.isConnected() ? Connection$$module$build$src$core$connection.REASON_PREVIOUS_AND_OUTPUT : Connection$$module$build$src$core$connection.CAN_CONNECT;
        }
        doTypeChecks(a, b) {
            a = a.getCheck();
            b = b.getCheck();
            if (!a || !b) return !0;
            for(let c = 0; c < a.length; c++)if (-1 !== b.indexOf(a[c])) return !0;
            return !1;
        }
        doDragChecks(a, b, c) {
            if (a.distanceFrom(b) > c || b.getSourceBlock().isInsertionMarker()) return !1;
            switch(b.type){
                case ConnectionType$$module$build$src$core$connection_type.PREVIOUS_STATEMENT:
                    return this.canConnectToPrevious_(a, b);
                case ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE:
                    if (b.isConnected() && !b.targetBlock().isInsertionMarker() || a.isConnected()) return !1;
                    break;
                case ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE:
                    if (b.isConnected() && !b.targetBlock().isMovable() && !b.targetBlock().isShadow()) return !1;
                    break;
                case ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT:
                    if (b.isConnected() && !a.getSourceBlock().nextConnection && !b.targetBlock().isShadow() && b.targetBlock().nextConnection || b.targetBlock() && !b.targetBlock().isMovable() && !b.targetBlock().isShadow()) return !1;
                    break;
                default:
                    return !1;
            }
            return -1 !== draggingConnections$$module$build$src$core$common.indexOf(b) ? !1 : !0;
        }
        canConnectToPrevious_(a, b) {
            if (a.targetConnection || -1 !== draggingConnections$$module$build$src$core$common.indexOf(b)) return !1;
            if (!b.targetConnection) return !0;
            a = b.targetBlock();
            return a.isInsertionMarker() ? !a.getPreviousBlock() : !1;
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.CONNECTION_CHECKER, DEFAULT$$module$build$src$core$registry, ConnectionChecker$$module$build$src$core$connection_checker);
    var module$build$src$core$connection_checker = {};
    module$build$src$core$connection_checker.ConnectionChecker = ConnectionChecker$$module$build$src$core$connection_checker;
    var ConnectionDB$$module$build$src$core$connection_db = class {
        constructor(a){
            this.connectionChecker = a;
            this.connections_ = [];
        }
        addConnection(a, b) {
            b = this.calculateIndexForYPos_(b);
            this.connections_.splice(b, 0, a);
        }
        findIndexOfConnection_(a, b) {
            if (!this.connections_.length) return -1;
            const c = this.calculateIndexForYPos_(b);
            if (c >= this.connections_.length) return -1;
            b = a.y;
            let d = c;
            for(; 0 <= d && this.connections_[d].y === b;){
                if (this.connections_[d] === a) return d;
                d--;
            }
            for(d = c; d < this.connections_.length && this.connections_[d].y === b;){
                if (this.connections_[d] === a) return d;
                d++;
            }
            return -1;
        }
        calculateIndexForYPos_(a) {
            if (!this.connections_.length) return 0;
            let b = 0, c = this.connections_.length;
            for(; b < c;){
                const d = Math.floor((b + c) / 2);
                if (this.connections_[d].y < a) b = d + 1;
                else if (this.connections_[d].y > a) c = d;
                else {
                    b = d;
                    break;
                }
            }
            return b;
        }
        removeConnection(a, b) {
            a = this.findIndexOfConnection_(a, b);
            if (-1 === a) throw Error("Unable to find connection in connectionDB.");
            this.connections_.splice(a, 1);
        }
        getNeighbours(a, b) {
            function c(l) {
                const m = e - d[l].x, n = f - d[l].y;
                Math.sqrt(m * m + n * n) <= b && k.push(d[l]);
                return n < b;
            }
            const d = this.connections_, e = a.x, f = a.y;
            a = 0;
            let g = d.length - 2, h = g;
            for(; a < h;)d[h].y < f ? a = h : g = h, h = Math.floor((a + g) / 2);
            const k = [];
            g = a = h;
            if (d.length) {
                for(; 0 <= a && c(a);)a--;
                do g++;
                while (g < d.length && c(g));
            }
            return k;
        }
        isInYRange_(a, b, c) {
            return Math.abs(this.connections_[a].y - b) <= c;
        }
        searchForClosest(a, b, c) {
            if (!this.connections_.length) return {
                connection: null,
                radius: b
            };
            const d = a.y, e = a.x;
            a.x = e + c.x;
            a.y = d + c.y;
            var f = this.calculateIndexForYPos_(a.y);
            c = null;
            let g = b, h, k = f - 1;
            for(; 0 <= k && this.isInYRange_(k, a.y, b);)h = this.connections_[k], this.connectionChecker.canConnect(a, h, !0, g) && (c = h, g = h.distanceFrom(a)), k--;
            for(; f < this.connections_.length && this.isInYRange_(f, a.y, b);)h = this.connections_[f], this.connectionChecker.canConnect(a, h, !0, g) && (c = h, g = h.distanceFrom(a)), f++;
            a.x = e;
            a.y = d;
            return {
                connection: c,
                radius: g
            };
        }
        static init(a) {
            const b = [];
            b[ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE] = new ConnectionDB$$module$build$src$core$connection_db(a);
            b[ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE] = new ConnectionDB$$module$build$src$core$connection_db(a);
            b[ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT] = new ConnectionDB$$module$build$src$core$connection_db(a);
            b[ConnectionType$$module$build$src$core$connection_type.PREVIOUS_STATEMENT] = new ConnectionDB$$module$build$src$core$connection_db(a);
            return b;
        }
    }, module$build$src$core$connection_db = {};
    module$build$src$core$connection_db.ConnectionDB = ConnectionDB$$module$build$src$core$connection_db;
    var BlockMove$$module$build$src$core$events$events_block_move = class extends BlockBase$$module$build$src$core$events$events_block_base {
        constructor(a){
            super(a);
            this.type = MOVE$$module$build$src$core$events$utils;
            a && (a.isShadow() && (this.recordUndo = !1), a = this.currentLocation_(), this.oldParentId = a.parentId, this.oldInputName = a.inputName, this.oldCoordinate = a.coordinate);
        }
        toJson() {
            const a = super.toJson();
            a.oldParentId = this.oldParentId;
            a.oldInputName = this.oldInputName;
            this.oldCoordinate && (a.oldCoordinate = `${Math.round(this.oldCoordinate.x)}, ` + `${Math.round(this.oldCoordinate.y)}`);
            a.newParentId = this.newParentId;
            a.newInputName = this.newInputName;
            this.newCoordinate && (a.newCoordinate = `${Math.round(this.newCoordinate.x)}, ` + `${Math.round(this.newCoordinate.y)}`);
            this.recordUndo || (a.recordUndo = this.recordUndo);
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.BlockMove.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.oldParentId = a.oldParentId;
            this.oldInputName = a.oldInputName;
            if (a.oldCoordinate) {
                var b = a.oldCoordinate.split(",");
                this.oldCoordinate = new Coordinate$$module$build$src$core$utils$coordinate(Number(b[0]), Number(b[1]));
            }
            this.newParentId = a.newParentId;
            this.newInputName = a.newInputName;
            a.newCoordinate && (b = a.newCoordinate.split(","), this.newCoordinate = new Coordinate$$module$build$src$core$utils$coordinate(Number(b[0]), Number(b[1])));
            void 0 !== a.recordUndo && (this.recordUndo = a.recordUndo);
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new BlockMove$$module$build$src$core$events$events_block_move);
            b.oldParentId = a.oldParentId;
            b.oldInputName = a.oldInputName;
            a.oldCoordinate && (c = a.oldCoordinate.split(","), b.oldCoordinate = new Coordinate$$module$build$src$core$utils$coordinate(Number(c[0]), Number(c[1])));
            b.newParentId = a.newParentId;
            b.newInputName = a.newInputName;
            a.newCoordinate && (c = a.newCoordinate.split(","), b.newCoordinate = new Coordinate$$module$build$src$core$utils$coordinate(Number(c[0]), Number(c[1])));
            void 0 !== a.recordUndo && (b.recordUndo = a.recordUndo);
            return b;
        }
        recordNew() {
            const a = this.currentLocation_();
            this.newParentId = a.parentId;
            this.newInputName = a.inputName;
            this.newCoordinate = a.coordinate;
        }
        currentLocation_() {
            var a = this.getEventWorkspace_();
            if (!this.blockId) throw Error("The block ID is undefined. Either pass a block to the constructor, or call fromJson");
            var b = a.getBlockById(this.blockId);
            if (!b) throw Error("The block associated with the block move event could not be found");
            a = {};
            const c = b.getParent();
            if (c) {
                if (a.parentId = c.id, b = c.getInputWithBlock(b)) a.inputName = b.name;
            } else a.coordinate = b.getRelativeToSurfaceXY();
            return a;
        }
        isNull() {
            return this.oldParentId === this.newParentId && this.oldInputName === this.newInputName && Coordinate$$module$build$src$core$utils$coordinate.equals(this.oldCoordinate, this.newCoordinate);
        }
        run(a) {
            var b = this.getEventWorkspace_();
            if (!this.blockId) throw Error("The block ID is undefined. Either pass a block to the constructor, or call fromJson");
            var c = b.getBlockById(this.blockId);
            if (c) {
                var d = a ? this.newParentId : this.oldParentId, e = a ? this.newInputName : this.oldInputName;
                a = a ? this.newCoordinate : this.oldCoordinate;
                if (d) {
                    var f = b.getBlockById(d);
                    if (!f) {
                        console.warn("Can't connect to non-existent block: " + d);
                        return;
                    }
                }
                c.getParent() && c.unplug();
                if (a) e = c.getRelativeToSurfaceXY(), c.moveBy(a.x - e.x, a.y - e.y);
                else {
                    b = c.outputConnection;
                    if (!b || c.previousConnection && c.previousConnection.isConnected()) b = c.previousConnection;
                    let g, h;
                    c = null == (h = b) ? void 0 : h.type;
                    if (e) {
                        if (c = f.getInput(e)) g = c.connection;
                    } else c === ConnectionType$$module$build$src$core$connection_type.PREVIOUS_STATEMENT && (g = f.nextConnection);
                    g && b ? b.connect(g) : console.warn("Can't connect to non-existent input: " + e);
                }
            } else console.warn("Can't move non-existent block: " + this.blockId);
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, MOVE$$module$build$src$core$events$utils, BlockMove$$module$build$src$core$events$events_block_move);
    var module$build$src$core$events$events_block_move = {};
    module$build$src$core$events$events_block_move.BlockMove = BlockMove$$module$build$src$core$events$events_block_move;
    var Click$$module$build$src$core$events$events_click = class extends UiBase$$module$build$src$core$events$events_ui_base {
        constructor(a, b, c){
            b = a ? a.workspace.id : b;
            null === b && (b = void 0);
            super(b);
            this.type = CLICK$$module$build$src$core$events$utils;
            this.blockId = a ? a.id : void 0;
            this.targetType = c;
        }
        toJson() {
            const a = super.toJson();
            if (!this.targetType) throw Error("The click target type is undefined. Either pass a block to the constructor, or call fromJson");
            a.targetType = this.targetType;
            a.blockId = this.blockId;
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.Click.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.targetType = a.targetType;
            this.blockId = a.blockId;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new Click$$module$build$src$core$events$events_click);
            b.targetType = a.targetType;
            b.blockId = a.blockId;
            return b;
        }
    }, ClickTarget$$module$build$src$core$events$events_click;
    (function(a) {
        a.BLOCK = "block";
        a.WORKSPACE = "workspace";
        a.ZOOM_CONTROLS = "zoom_controls";
    })(ClickTarget$$module$build$src$core$events$events_click || (ClickTarget$$module$build$src$core$events$events_click = {}));
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, CLICK$$module$build$src$core$events$utils, Click$$module$build$src$core$events$events_click);
    var module$build$src$core$events$events_click = {};
    module$build$src$core$events$events_click.Click = Click$$module$build$src$core$events$events_click;
    module$build$src$core$events$events_click.ClickTarget = ClickTarget$$module$build$src$core$events$events_click;
    var CommentBase$$module$build$src$core$events$events_comment_base = class extends Abstract$$module$build$src$core$events$events_abstract {
        constructor(a){
            super();
            this.isBlank = !a;
            a && (this.commentId = a.id, this.workspaceId = a.workspace.id, this.group = getGroup$$module$build$src$core$events$utils(), this.recordUndo = getRecordUndo$$module$build$src$core$events$utils());
        }
        toJson() {
            const a = super.toJson();
            if (!this.commentId) throw Error("The comment ID is undefined. Either pass a comment to the constructor, or call fromJson");
            a.commentId = this.commentId;
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.CommentBase.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.commentId = a.commentId;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new CommentBase$$module$build$src$core$events$events_comment_base);
            b.commentId = a.commentId;
            return b;
        }
        static CommentCreateDeleteHelper(a, b) {
            var c = a.getEventWorkspace_();
            if (b) {
                b = $.createElement$$module$build$src$core$utils$xml("xml");
                if (!a.xml) throw Error("Ecountered a comment event without proper xml");
                b.appendChild(a.xml);
                domToWorkspace$$module$build$src$core$xml(b, c);
            } else {
                if (!a.commentId) throw Error("The comment ID is undefined. Either pass a comment to the constructor, or call fromJson");
                (c = c.getCommentById(a.commentId)) ? c.dispose() : console.warn("Can't uncreate non-existent comment: " + a.commentId);
            }
        }
    }, module$build$src$core$events$events_comment_base = {};
    module$build$src$core$events$events_comment_base.CommentBase = CommentBase$$module$build$src$core$events$events_comment_base;
    var CommentChange$$module$build$src$core$events$events_comment_change = class extends CommentBase$$module$build$src$core$events$events_comment_base {
        constructor(a, b, c){
            super(a);
            this.type = COMMENT_CHANGE$$module$build$src$core$events$utils;
            a && (this.oldContents_ = "undefined" === typeof b ? "" : b, this.newContents_ = "undefined" === typeof c ? "" : c);
        }
        toJson() {
            const a = super.toJson();
            if (!this.oldContents_) throw Error("The old contents is undefined. Either pass a value to the constructor, or call fromJson");
            if (!this.newContents_) throw Error("The new contents is undefined. Either pass a value to the constructor, or call fromJson");
            a.oldContents = this.oldContents_;
            a.newContents = this.newContents_;
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.CommentChange.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.oldContents_ = a.oldContents;
            this.newContents_ = a.newContents;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new CommentChange$$module$build$src$core$events$events_comment_change);
            b.oldContents_ = a.oldContents;
            b.newContents_ = a.newContents;
            return b;
        }
        isNull() {
            return this.oldContents_ === this.newContents_;
        }
        run(a) {
            var b = this.getEventWorkspace_();
            if (!this.commentId) throw Error("The comment ID is undefined. Either pass a comment to the constructor, or call fromJson");
            if (b = b.getCommentById(this.commentId)) {
                var c = a ? this.newContents_ : this.oldContents_;
                if (!c) {
                    if (a) throw Error("The new contents is undefined. Either pass a value to the constructor, or call fromJson");
                    throw Error("The old contents is undefined. Either pass a value to the constructor, or call fromJson");
                }
                b.setContent(c);
            } else console.warn("Can't change non-existent comment: " + this.commentId);
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, COMMENT_CHANGE$$module$build$src$core$events$utils, CommentChange$$module$build$src$core$events$events_comment_change);
    var module$build$src$core$events$events_comment_change = {};
    module$build$src$core$events$events_comment_change.CommentChange = CommentChange$$module$build$src$core$events$events_comment_change;
    var CommentCreate$$module$build$src$core$events$events_comment_create = class extends CommentBase$$module$build$src$core$events$events_comment_base {
        constructor(a){
            super(a);
            this.type = COMMENT_CREATE$$module$build$src$core$events$utils;
            a && (this.xml = a.toXmlWithXY());
        }
        toJson() {
            const a = super.toJson();
            if (!this.xml) throw Error("The comment XML is undefined. Either pass a comment to the constructor, or call fromJson");
            a.xml = domToText$$module$build$src$core$xml(this.xml);
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.CommentCreate.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.xml = textToDom$$module$build$src$core$utils$xml(a.xml);
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new CommentCreate$$module$build$src$core$events$events_comment_create);
            b.xml = textToDom$$module$build$src$core$utils$xml(a.xml);
            return b;
        }
        run(a) {
            CommentBase$$module$build$src$core$events$events_comment_base.CommentCreateDeleteHelper(this, a);
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, COMMENT_CREATE$$module$build$src$core$events$utils, CommentCreate$$module$build$src$core$events$events_comment_create);
    var module$build$src$core$events$events_comment_create = {};
    module$build$src$core$events$events_comment_create.CommentCreate = CommentCreate$$module$build$src$core$events$events_comment_create;
    var CommentDelete$$module$build$src$core$events$events_comment_delete = class extends CommentBase$$module$build$src$core$events$events_comment_base {
        constructor(a){
            super(a);
            this.type = COMMENT_DELETE$$module$build$src$core$events$utils;
            a && (this.xml = a.toXmlWithXY());
        }
        run(a) {
            CommentBase$$module$build$src$core$events$events_comment_base.CommentCreateDeleteHelper(this, !a);
        }
        toJson() {
            const a = super.toJson();
            if (!this.xml) throw Error("The comment XML is undefined. Either pass a comment to the constructor, or call fromJson");
            a.xml = domToText$$module$build$src$core$xml(this.xml);
            return a;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new CommentDelete$$module$build$src$core$events$events_comment_delete);
            b.xml = textToDom$$module$build$src$core$utils$xml(a.xml);
            return b;
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, COMMENT_DELETE$$module$build$src$core$events$utils, CommentDelete$$module$build$src$core$events$events_comment_delete);
    var module$build$src$core$events$events_comment_delete = {};
    module$build$src$core$events$events_comment_delete.CommentDelete = CommentDelete$$module$build$src$core$events$events_comment_delete;
    var CommentMove$$module$build$src$core$events$events_comment_move = class extends CommentBase$$module$build$src$core$events$events_comment_base {
        constructor(a){
            super(a);
            this.type = COMMENT_MOVE$$module$build$src$core$events$utils;
            a && (this.comment_ = a, this.oldCoordinate_ = a.getRelativeToSurfaceXY());
        }
        recordNew() {
            if (this.newCoordinate_) throw Error("Tried to record the new position of a comment on the same event twice.");
            if (!this.comment_) throw Error("The comment is undefined. Pass a comment to the constructor if you want to use the record functionality");
            this.newCoordinate_ = this.comment_.getRelativeToSurfaceXY();
        }
        setOldCoordinate(a) {
            this.oldCoordinate_ = a;
        }
        toJson() {
            const a = super.toJson();
            if (!this.oldCoordinate_) throw Error("The old comment position is undefined. Either pass a comment to the constructor, or call fromJson");
            if (!this.newCoordinate_) throw Error("The new comment position is undefined. Either call recordNew, or call fromJson");
            a.oldCoordinate = `${Math.round(this.oldCoordinate_.x)}, ` + `${Math.round(this.oldCoordinate_.y)}`;
            a.newCoordinate = Math.round(this.newCoordinate_.x) + "," + Math.round(this.newCoordinate_.y);
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.CommentMove.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            let b = a.oldCoordinate.split(",");
            this.oldCoordinate_ = new Coordinate$$module$build$src$core$utils$coordinate(Number(b[0]), Number(b[1]));
            b = a.newCoordinate.split(",");
            this.newCoordinate_ = new Coordinate$$module$build$src$core$utils$coordinate(Number(b[0]), Number(b[1]));
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new CommentMove$$module$build$src$core$events$events_comment_move);
            c = a.oldCoordinate.split(",");
            b.oldCoordinate_ = new Coordinate$$module$build$src$core$utils$coordinate(Number(c[0]), Number(c[1]));
            c = a.newCoordinate.split(",");
            b.newCoordinate_ = new Coordinate$$module$build$src$core$utils$coordinate(Number(c[0]), Number(c[1]));
            return b;
        }
        isNull() {
            return Coordinate$$module$build$src$core$utils$coordinate.equals(this.oldCoordinate_, this.newCoordinate_);
        }
        run(a) {
            var b = this.getEventWorkspace_();
            if (!this.commentId) throw Error("The comment ID is undefined. Either pass a comment to the constructor, or call fromJson");
            if (b = b.getCommentById(this.commentId)) {
                a = a ? this.newCoordinate_ : this.oldCoordinate_;
                if (!a) throw Error("Either oldCoordinate_ or newCoordinate_ is undefined. Either pass a comment to the constructor and call recordNew, or call fromJson");
                var c = b.getRelativeToSurfaceXY();
                b.moveBy(a.x - c.x, a.y - c.y);
            } else console.warn("Can't move non-existent comment: " + this.commentId);
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, COMMENT_MOVE$$module$build$src$core$events$utils, CommentMove$$module$build$src$core$events$events_comment_move);
    var module$build$src$core$events$events_comment_move = {};
    module$build$src$core$events$events_comment_move.CommentMove = CommentMove$$module$build$src$core$events$events_comment_move;
    var MarkerMove$$module$build$src$core$events$events_marker_move = class extends UiBase$$module$build$src$core$events$events_ui_base {
        constructor(a, b, c, d){
            let e = a ? a.workspace.id : void 0;
            d && d.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.WORKSPACE && (e = d.getLocation().id);
            super(e);
            this.type = MARKER_MOVE$$module$build$src$core$events$utils;
            this.blockId = null == a ? void 0 : a.id;
            this.oldNode = c || void 0;
            this.newNode = d;
            this.isCursor = b;
        }
        toJson() {
            const a = super.toJson();
            if (void 0 === this.isCursor) throw Error("Whether this is a cursor event or not is undefined. Either pass a value to the constructor, or call fromJson");
            if (!this.newNode) throw Error("The new node is undefined. Either pass a node to the constructor, or call fromJson");
            a.isCursor = this.isCursor;
            a.blockId = this.blockId;
            a.oldNode = this.oldNode;
            a.newNode = this.newNode;
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.MarkerMove.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.isCursor = a.isCursor;
            this.blockId = a.blockId;
            this.oldNode = a.oldNode;
            this.newNode = a.newNode;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new MarkerMove$$module$build$src$core$events$events_marker_move);
            b.isCursor = a.isCursor;
            b.blockId = a.blockId;
            b.oldNode = a.oldNode;
            b.newNode = a.newNode;
            return b;
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, MARKER_MOVE$$module$build$src$core$events$utils, MarkerMove$$module$build$src$core$events$events_marker_move);
    var module$build$src$core$events$events_marker_move = {};
    module$build$src$core$events$events_marker_move.MarkerMove = MarkerMove$$module$build$src$core$events$events_marker_move;
    var ThemeChange$$module$build$src$core$events$events_theme_change = class extends UiBase$$module$build$src$core$events$events_ui_base {
        constructor(a, b){
            super(b);
            this.type = THEME_CHANGE$$module$build$src$core$events$utils;
            this.themeName = a;
        }
        toJson() {
            const a = super.toJson();
            if (!this.themeName) throw Error("The theme name is undefined. Either pass a theme name to the constructor, or call fromJson");
            a.themeName = this.themeName;
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.ThemeChange.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.themeName = a.themeName;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new ThemeChange$$module$build$src$core$events$events_theme_change);
            b.themeName = a.themeName;
            return b;
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, THEME_CHANGE$$module$build$src$core$events$utils, ThemeChange$$module$build$src$core$events$events_theme_change);
    var module$build$src$core$events$events_theme_change = {};
    module$build$src$core$events$events_theme_change.ThemeChange = ThemeChange$$module$build$src$core$events$events_theme_change;
    var ToolboxItemSelect$$module$build$src$core$events$events_toolbox_item_select = class extends UiBase$$module$build$src$core$events$events_ui_base {
        constructor(a, b, c){
            super(c);
            this.type = TOOLBOX_ITEM_SELECT$$module$build$src$core$events$utils;
            this.oldItem = null != a ? a : void 0;
            this.newItem = null != b ? b : void 0;
        }
        toJson() {
            const a = super.toJson();
            a.oldItem = this.oldItem;
            a.newItem = this.newItem;
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.ToolboxItemSelect.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.oldItem = a.oldItem;
            this.newItem = a.newItem;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new ToolboxItemSelect$$module$build$src$core$events$events_toolbox_item_select);
            b.oldItem = a.oldItem;
            b.newItem = a.newItem;
            return b;
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, TOOLBOX_ITEM_SELECT$$module$build$src$core$events$utils, ToolboxItemSelect$$module$build$src$core$events$events_toolbox_item_select);
    var module$build$src$core$events$events_toolbox_item_select = {};
    module$build$src$core$events$events_toolbox_item_select.ToolboxItemSelect = ToolboxItemSelect$$module$build$src$core$events$events_toolbox_item_select;
    var TrashcanOpen$$module$build$src$core$events$events_trashcan_open = class extends UiBase$$module$build$src$core$events$events_ui_base {
        constructor(a, b){
            super(b);
            this.type = TRASHCAN_OPEN$$module$build$src$core$events$utils;
            this.isOpen = a;
        }
        toJson() {
            const a = super.toJson();
            if (void 0 === this.isOpen) throw Error("Whether this is already open or not is undefined. Either pass a value to the constructor, or call fromJson");
            a.isOpen = this.isOpen;
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.TrashcanOpen.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.isOpen = a.isOpen;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new TrashcanOpen$$module$build$src$core$events$events_trashcan_open);
            b.isOpen = a.isOpen;
            return b;
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, TRASHCAN_OPEN$$module$build$src$core$events$utils, TrashcanOpen$$module$build$src$core$events$events_trashcan_open);
    var module$build$src$core$events$events_trashcan_open = {};
    module$build$src$core$events$events_trashcan_open.TrashcanOpen = TrashcanOpen$$module$build$src$core$events$events_trashcan_open;
    var VarDelete$$module$build$src$core$events$events_var_delete = class extends VarBase$$module$build$src$core$events$events_var_base {
        constructor(a){
            super(a);
            this.type = VAR_DELETE$$module$build$src$core$events$utils;
            a && (this.varType = a.type, this.varName = a.name);
        }
        toJson() {
            const a = super.toJson();
            if (void 0 === this.varType) throw Error("The var type is undefined. Either pass a variable to the constructor, or call fromJson");
            if (!this.varName) throw Error("The var name is undefined. Either pass a variable to the constructor, or call fromJson");
            a.varType = this.varType;
            a.varName = this.varName;
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.VarDelete.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.varType = a.varType;
            this.varName = a.varName;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new VarDelete$$module$build$src$core$events$events_var_delete);
            b.varType = a.varType;
            b.varName = a.varName;
            return b;
        }
        run(a) {
            const b = this.getEventWorkspace_();
            if (!this.varId) throw Error("The var ID is undefined. Either pass a variable to the constructor, or call fromJson");
            if (!this.varName) throw Error("The var name is undefined. Either pass a variable to the constructor, or call fromJson");
            a ? b.deleteVariableById(this.varId) : b.createVariable(this.varName, this.varType, this.varId);
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, VAR_DELETE$$module$build$src$core$events$utils, VarDelete$$module$build$src$core$events$events_var_delete);
    var module$build$src$core$events$events_var_delete = {};
    module$build$src$core$events$events_var_delete.VarDelete = VarDelete$$module$build$src$core$events$events_var_delete;
    var VarRename$$module$build$src$core$events$events_var_rename = class extends VarBase$$module$build$src$core$events$events_var_base {
        constructor(a, b){
            super(a);
            this.type = VAR_RENAME$$module$build$src$core$events$utils;
            a && (this.oldName = a.name, this.newName = "undefined" === typeof b ? "" : b);
        }
        toJson() {
            const a = super.toJson();
            if (!this.oldName) throw Error("The old var name is undefined. Either pass a variable to the constructor, or call fromJson");
            if (!this.newName) throw Error("The new var name is undefined. Either pass a value to the constructor, or call fromJson");
            a.oldName = this.oldName;
            a.newName = this.newName;
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.VarRename.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.oldName = a.oldName;
            this.newName = a.newName;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new VarRename$$module$build$src$core$events$events_var_rename);
            b.oldName = a.oldName;
            b.newName = a.newName;
            return b;
        }
        run(a) {
            const b = this.getEventWorkspace_();
            if (!this.varId) throw Error("The var ID is undefined. Either pass a variable to the constructor, or call fromJson");
            if (!this.oldName) throw Error("The old var name is undefined. Either pass a variable to the constructor, or call fromJson");
            if (!this.newName) throw Error("The new var name is undefined. Either pass a value to the constructor, or call fromJson");
            a ? b.renameVariableById(this.varId, this.newName) : b.renameVariableById(this.varId, this.oldName);
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, VAR_RENAME$$module$build$src$core$events$utils, VarRename$$module$build$src$core$events$events_var_rename);
    var module$build$src$core$events$events_var_rename = {};
    module$build$src$core$events$events_var_rename.VarRename = VarRename$$module$build$src$core$events$events_var_rename;
    var ViewportChange$$module$build$src$core$events$events_viewport = class extends UiBase$$module$build$src$core$events$events_ui_base {
        constructor(a, b, c, d, e){
            super(d);
            this.type = VIEWPORT_CHANGE$$module$build$src$core$events$utils;
            this.viewTop = a;
            this.viewLeft = b;
            this.scale = c;
            this.oldScale = e;
        }
        toJson() {
            const a = super.toJson();
            if (void 0 === this.viewTop) throw Error("The view top is undefined. Either pass a value to the constructor, or call fromJson");
            if (void 0 === this.viewLeft) throw Error("The view left is undefined. Either pass a value to the constructor, or call fromJson");
            if (void 0 === this.scale) throw Error("The scale is undefined. Either pass a value to the constructor, or call fromJson");
            if (void 0 === this.oldScale) throw Error("The old scale is undefined. Either pass a value to the constructor, or call fromJson");
            a.viewTop = this.viewTop;
            a.viewLeft = this.viewLeft;
            a.scale = this.scale;
            a.oldScale = this.oldScale;
            return a;
        }
        fromJson(a) {
            warn$$module$build$src$core$utils$deprecation("Blockly.Events.Viewport.prototype.fromJson", "version 9", "version 10", "Blockly.Events.fromJson");
            super.fromJson(a);
            this.viewTop = a.viewTop;
            this.viewLeft = a.viewLeft;
            this.scale = a.scale;
            this.oldScale = a.oldScale;
        }
        static fromJson(a, b, c) {
            b = super.fromJson(a, b, null != c ? c : new ViewportChange$$module$build$src$core$events$events_viewport);
            b.viewTop = a.viewTop;
            b.viewLeft = a.viewLeft;
            b.scale = a.scale;
            b.oldScale = a.oldScale;
            return b;
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.EVENT, VIEWPORT_CHANGE$$module$build$src$core$events$utils, ViewportChange$$module$build$src$core$events$events_viewport);
    var module$build$src$core$events$events_viewport = {};
    module$build$src$core$events$events_viewport.ViewportChange = ViewportChange$$module$build$src$core$events$events_viewport;
    var BLOCK_CHANGE$$module$build$src$core$events$events, BLOCK_CREATE$$module$build$src$core$events$events, BLOCK_DELETE$$module$build$src$core$events$events, BLOCK_DRAG$$module$build$src$core$events$events, BLOCK_MOVE$$module$build$src$core$events$events, BUBBLE_OPEN$$module$build$src$core$events$events, BUMP_EVENTS$$module$build$src$core$events$events, CHANGE$$module$build$src$core$events$events, CLICK$$module$build$src$core$events$events, COMMENT_CHANGE$$module$build$src$core$events$events, COMMENT_CREATE$$module$build$src$core$events$events, COMMENT_DELETE$$module$build$src$core$events$events, COMMENT_MOVE$$module$build$src$core$events$events, CREATE$$module$build$src$core$events$events, DELETE$$module$build$src$core$events$events, FINISHED_LOADING$$module$build$src$core$events$events, MARKER_MOVE$$module$build$src$core$events$events, MOVE$$module$build$src$core$events$events, SELECTED$$module$build$src$core$events$events, THEME_CHANGE$$module$build$src$core$events$events, TOOLBOX_ITEM_SELECT$$module$build$src$core$events$events, TRASHCAN_OPEN$$module$build$src$core$events$events, UI$$module$build$src$core$events$events, VAR_CREATE$$module$build$src$core$events$events, VAR_DELETE$$module$build$src$core$events$events, VAR_RENAME$$module$build$src$core$events$events, VIEWPORT_CHANGE$$module$build$src$core$events$events, clearPendingUndo$$module$build$src$core$events$events, disable$$module$build$src$core$events$events, enable$$module$build$src$core$events$events, filter$$module$build$src$core$events$events, fire$$module$build$src$core$events$events, fromJson$$module$build$src$core$events$events, getDescendantIds$$module$build$src$core$events$events, get$$module$build$src$core$events$events, getGroup$$module$build$src$core$events$events, getRecordUndo$$module$build$src$core$events$events, isEnabled$$module$build$src$core$events$events, setGroup$$module$build$src$core$events$events, setRecordUndo$$module$build$src$core$events$events, disableOrphans$$module$build$src$core$events$events;
    BLOCK_CHANGE$$module$build$src$core$events$events = CHANGE$$module$build$src$core$events$utils;
    BLOCK_CREATE$$module$build$src$core$events$events = CREATE$$module$build$src$core$events$utils;
    BLOCK_DELETE$$module$build$src$core$events$events = DELETE$$module$build$src$core$events$utils;
    BLOCK_DRAG$$module$build$src$core$events$events = BLOCK_DRAG$$module$build$src$core$events$utils;
    BLOCK_MOVE$$module$build$src$core$events$events = MOVE$$module$build$src$core$events$utils;
    BUBBLE_OPEN$$module$build$src$core$events$events = BUBBLE_OPEN$$module$build$src$core$events$utils;
    BUMP_EVENTS$$module$build$src$core$events$events = BUMP_EVENTS$$module$build$src$core$events$utils;
    CHANGE$$module$build$src$core$events$events = CHANGE$$module$build$src$core$events$utils;
    CLICK$$module$build$src$core$events$events = CLICK$$module$build$src$core$events$utils;
    COMMENT_CHANGE$$module$build$src$core$events$events = COMMENT_CHANGE$$module$build$src$core$events$utils;
    COMMENT_CREATE$$module$build$src$core$events$events = COMMENT_CREATE$$module$build$src$core$events$utils;
    COMMENT_DELETE$$module$build$src$core$events$events = COMMENT_DELETE$$module$build$src$core$events$utils;
    COMMENT_MOVE$$module$build$src$core$events$events = COMMENT_MOVE$$module$build$src$core$events$utils;
    CREATE$$module$build$src$core$events$events = CREATE$$module$build$src$core$events$utils;
    DELETE$$module$build$src$core$events$events = DELETE$$module$build$src$core$events$utils;
    FINISHED_LOADING$$module$build$src$core$events$events = FINISHED_LOADING$$module$build$src$core$events$utils;
    MARKER_MOVE$$module$build$src$core$events$events = MARKER_MOVE$$module$build$src$core$events$utils;
    MOVE$$module$build$src$core$events$events = MOVE$$module$build$src$core$events$utils;
    SELECTED$$module$build$src$core$events$events = SELECTED$$module$build$src$core$events$utils;
    THEME_CHANGE$$module$build$src$core$events$events = THEME_CHANGE$$module$build$src$core$events$utils;
    TOOLBOX_ITEM_SELECT$$module$build$src$core$events$events = TOOLBOX_ITEM_SELECT$$module$build$src$core$events$utils;
    TRASHCAN_OPEN$$module$build$src$core$events$events = TRASHCAN_OPEN$$module$build$src$core$events$utils;
    UI$$module$build$src$core$events$events = UI$$module$build$src$core$events$utils;
    VAR_CREATE$$module$build$src$core$events$events = VAR_CREATE$$module$build$src$core$events$utils;
    VAR_DELETE$$module$build$src$core$events$events = VAR_DELETE$$module$build$src$core$events$utils;
    VAR_RENAME$$module$build$src$core$events$events = VAR_RENAME$$module$build$src$core$events$utils;
    VIEWPORT_CHANGE$$module$build$src$core$events$events = VIEWPORT_CHANGE$$module$build$src$core$events$utils;
    clearPendingUndo$$module$build$src$core$events$events = clearPendingUndo$$module$build$src$core$events$utils;
    disable$$module$build$src$core$events$events = disable$$module$build$src$core$events$utils;
    enable$$module$build$src$core$events$events = enable$$module$build$src$core$events$utils;
    filter$$module$build$src$core$events$events = filter$$module$build$src$core$events$utils;
    fire$$module$build$src$core$events$events = fire$$module$build$src$core$events$utils;
    fromJson$$module$build$src$core$events$events = fromJson$$module$build$src$core$events$utils;
    getDescendantIds$$module$build$src$core$events$events = getDescendantIds$$module$build$src$core$events$utils;
    get$$module$build$src$core$events$events = get$$module$build$src$core$events$utils;
    getGroup$$module$build$src$core$events$events = getGroup$$module$build$src$core$events$utils;
    getRecordUndo$$module$build$src$core$events$events = getRecordUndo$$module$build$src$core$events$utils;
    isEnabled$$module$build$src$core$events$events = isEnabled$$module$build$src$core$events$utils;
    setGroup$$module$build$src$core$events$events = setGroup$$module$build$src$core$events$utils;
    setRecordUndo$$module$build$src$core$events$events = setRecordUndo$$module$build$src$core$events$utils;
    disableOrphans$$module$build$src$core$events$events = disableOrphans$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events = {};
    $.module$build$src$core$events$events.Abstract = Abstract$$module$build$src$core$events$events_abstract;
    $.module$build$src$core$events$events.BLOCK_CHANGE = CHANGE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.BLOCK_CREATE = CREATE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.BLOCK_DELETE = DELETE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.BLOCK_DRAG = BLOCK_DRAG$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.BLOCK_MOVE = MOVE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.BUBBLE_OPEN = BUBBLE_OPEN$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.BUMP_EVENTS = BUMP_EVENTS$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.BlockBase = BlockBase$$module$build$src$core$events$events_block_base;
    $.module$build$src$core$events$events.BlockChange = BlockChange$$module$build$src$core$events$events_block_change;
    $.module$build$src$core$events$events.BlockCreate = BlockCreate$$module$build$src$core$events$events_block_create;
    $.module$build$src$core$events$events.BlockDelete = BlockDelete$$module$build$src$core$events$events_block_delete;
    $.module$build$src$core$events$events.BlockDrag = BlockDrag$$module$build$src$core$events$events_block_drag;
    $.module$build$src$core$events$events.BlockMove = BlockMove$$module$build$src$core$events$events_block_move;
    $.module$build$src$core$events$events.BubbleOpen = BubbleOpen$$module$build$src$core$events$events_bubble_open;
    $.module$build$src$core$events$events.BubbleType = BubbleType$$module$build$src$core$events$events_bubble_open;
    $.module$build$src$core$events$events.CHANGE = CHANGE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.CLICK = CLICK$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.COMMENT_CHANGE = COMMENT_CHANGE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.COMMENT_CREATE = COMMENT_CREATE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.COMMENT_DELETE = COMMENT_DELETE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.COMMENT_MOVE = COMMENT_MOVE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.CREATE = CREATE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.Click = Click$$module$build$src$core$events$events_click;
    $.module$build$src$core$events$events.ClickTarget = ClickTarget$$module$build$src$core$events$events_click;
    $.module$build$src$core$events$events.CommentBase = CommentBase$$module$build$src$core$events$events_comment_base;
    $.module$build$src$core$events$events.CommentChange = CommentChange$$module$build$src$core$events$events_comment_change;
    $.module$build$src$core$events$events.CommentCreate = CommentCreate$$module$build$src$core$events$events_comment_create;
    $.module$build$src$core$events$events.CommentDelete = CommentDelete$$module$build$src$core$events$events_comment_delete;
    $.module$build$src$core$events$events.CommentMove = CommentMove$$module$build$src$core$events$events_comment_move;
    $.module$build$src$core$events$events.DELETE = DELETE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.FINISHED_LOADING = FINISHED_LOADING$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.FinishedLoading = FinishedLoading$$module$build$src$core$events$workspace_events;
    $.module$build$src$core$events$events.MARKER_MOVE = MARKER_MOVE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.MOVE = MOVE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.MarkerMove = MarkerMove$$module$build$src$core$events$events_marker_move;
    $.module$build$src$core$events$events.SELECTED = SELECTED$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.Selected = Selected$$module$build$src$core$events$events_selected;
    $.module$build$src$core$events$events.THEME_CHANGE = THEME_CHANGE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.TOOLBOX_ITEM_SELECT = TOOLBOX_ITEM_SELECT$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.TRASHCAN_OPEN = TRASHCAN_OPEN$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.ThemeChange = ThemeChange$$module$build$src$core$events$events_theme_change;
    $.module$build$src$core$events$events.ToolboxItemSelect = ToolboxItemSelect$$module$build$src$core$events$events_toolbox_item_select;
    $.module$build$src$core$events$events.TrashcanOpen = TrashcanOpen$$module$build$src$core$events$events_trashcan_open;
    $.module$build$src$core$events$events.UI = UI$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.Ui = Ui$$module$build$src$core$events$events_ui;
    $.module$build$src$core$events$events.UiBase = UiBase$$module$build$src$core$events$events_ui_base;
    $.module$build$src$core$events$events.VAR_CREATE = VAR_CREATE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.VAR_DELETE = VAR_DELETE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.VAR_RENAME = VAR_RENAME$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.VIEWPORT_CHANGE = VIEWPORT_CHANGE$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.VarBase = VarBase$$module$build$src$core$events$events_var_base;
    $.module$build$src$core$events$events.VarCreate = VarCreate$$module$build$src$core$events$events_var_create;
    $.module$build$src$core$events$events.VarDelete = VarDelete$$module$build$src$core$events$events_var_delete;
    $.module$build$src$core$events$events.VarRename = VarRename$$module$build$src$core$events$events_var_rename;
    $.module$build$src$core$events$events.ViewportChange = ViewportChange$$module$build$src$core$events$events_viewport;
    $.module$build$src$core$events$events.clearPendingUndo = clearPendingUndo$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.disable = disable$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.disableOrphans = disableOrphans$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.enable = enable$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.filter = filter$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.fire = fire$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.fromJson = fromJson$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.get = get$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.getDescendantIds = getDescendantIds$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.getGroup = getGroup$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.getRecordUndo = getRecordUndo$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.isEnabled = isEnabled$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.setGroup = setGroup$$module$build$src$core$events$utils;
    $.module$build$src$core$events$events.setRecordUndo = setRecordUndo$$module$build$src$core$events$utils;
    registerDefaultOptions$$module$build$src$core$contextmenu_items();
    var module$build$src$core$contextmenu_items = {};
    module$build$src$core$contextmenu_items.registerCleanup = registerCleanup$$module$build$src$core$contextmenu_items;
    module$build$src$core$contextmenu_items.registerCollapse = registerCollapse$$module$build$src$core$contextmenu_items;
    module$build$src$core$contextmenu_items.registerCollapseExpandBlock = registerCollapseExpandBlock$$module$build$src$core$contextmenu_items;
    module$build$src$core$contextmenu_items.registerComment = registerComment$$module$build$src$core$contextmenu_items;
    module$build$src$core$contextmenu_items.registerDefaultOptions = registerDefaultOptions$$module$build$src$core$contextmenu_items;
    module$build$src$core$contextmenu_items.registerDelete = registerDelete$$module$build$src$core$contextmenu_items;
    module$build$src$core$contextmenu_items.registerDeleteAll = registerDeleteAll$$module$build$src$core$contextmenu_items;
    module$build$src$core$contextmenu_items.registerDisable = registerDisable$$module$build$src$core$contextmenu_items;
    module$build$src$core$contextmenu_items.registerDuplicate = registerDuplicate$$module$build$src$core$contextmenu_items;
    module$build$src$core$contextmenu_items.registerExpand = registerExpand$$module$build$src$core$contextmenu_items;
    module$build$src$core$contextmenu_items.registerHelp = registerHelp$$module$build$src$core$contextmenu_items;
    module$build$src$core$contextmenu_items.registerInline = registerInline$$module$build$src$core$contextmenu_items;
    module$build$src$core$contextmenu_items.registerRedo = registerRedo$$module$build$src$core$contextmenu_items;
    module$build$src$core$contextmenu_items.registerUndo = registerUndo$$module$build$src$core$contextmenu_items;
    var DragTarget$$module$build$src$core$drag_target = class {
        constructor(){}
        onDragEnter(a) {}
        onDragOver(a) {}
        onDragExit(a) {}
        onDrop(a) {}
        getClientRect() {
            return null;
        }
        shouldPreventMove(a) {
            return !1;
        }
    }, module$build$src$core$drag_target = {};
    module$build$src$core$drag_target.DragTarget = DragTarget$$module$build$src$core$drag_target;
    var DeleteArea$$module$build$src$core$delete_area = class extends DragTarget$$module$build$src$core$drag_target {
        constructor(){
            super();
            this.wouldDelete_ = !1;
        }
        wouldDelete(a, b) {
            a instanceof BlockSvg$$module$build$src$core$block_svg ? (a = !a.getParent() && a.isDeletable(), this.updateWouldDelete_(a && !b)) : this.updateWouldDelete_(a.isDeletable());
            return this.wouldDelete_;
        }
        updateWouldDelete_(a) {
            this.wouldDelete_ = a;
        }
    }, module$build$src$core$delete_area = {};
    module$build$src$core$delete_area.DeleteArea = DeleteArea$$module$build$src$core$delete_area;
    var FieldInput$$module$build$src$core$field_input = class extends Field$$module$build$src$core$field {
        constructor(a, b, c){
            super(Field$$module$build$src$core$field.SKIP_SETUP);
            this.spellcheck_ = !0;
            this.htmlInput_ = null;
            this.isTextValid_ = this.isBeingEdited_ = !1;
            this.onKeyInputWrapper_ = this.onKeyDownWrapper_ = null;
            this.fullBlockClickTarget_ = !1;
            this.workspace_ = null;
            this.SERIALIZABLE = !0;
            this.CURSOR = "text";
            a !== Field$$module$build$src$core$field.SKIP_SETUP && (c && this.configure_(c), this.setValue(a), b && this.setValidator(b));
        }
        configure_(a) {
            super.configure_(a);
            void 0 !== a.spellcheck && (this.spellcheck_ = a.spellcheck);
        }
        initView() {
            const a = this.getSourceBlock();
            if (!a) throw new UnattachedFieldError$$module$build$src$core$field;
            if (this.getConstants().FULL_BLOCK_FIELDS) {
                let b = 0, c = 0;
                for(let d = 0, e; e = a.inputList[d]; d++){
                    for(let f = 0; e.fieldRow[f]; f++)b++;
                    e.connection && c++;
                }
                this.fullBlockClickTarget_ = 1 >= b && a.outputConnection && !c;
            } else this.fullBlockClickTarget_ = !1;
            this.fullBlockClickTarget_ ? this.clickTarget_ = this.sourceBlock_.getSvgRoot() : this.createBorderRect_();
            this.createTextElement_();
        }
        doValueInvalid_(a) {
            this.isBeingEdited_ && (this.isDirty_ = !0, this.isTextValid_ = !1, a = this.value_, this.value_ = this.htmlInput_.getAttribute("data-untyped-default-value"), this.sourceBlock_ && isEnabled$$module$build$src$core$events$utils() && fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(CHANGE$$module$build$src$core$events$utils))(this.sourceBlock_, "field", this.name || null, a, this.value_)));
        }
        doValueUpdate_(a) {
            this.isTextValid_ = this.isDirty_ = !0;
            this.value_ = a;
        }
        applyColour() {
            if (this.sourceBlock_ && this.getConstants().FULL_BLOCK_FIELDS) {
                var a = this.sourceBlock_;
                this.borderRect_ ? this.borderRect_.setAttribute("stroke", a.style.colourTertiary) : a.pathObject.svgPath.setAttribute("fill", this.getConstants().FIELD_BORDER_RECT_COLOUR);
            }
        }
        render_() {
            super.render_();
            if (this.isBeingEdited_) {
                this.resizeEditor_();
                const a = this.htmlInput_;
                this.isTextValid_ ? (removeClass$$module$build$src$core$utils$dom(a, "blocklyInvalidInput"), setState$$module$build$src$core$utils$aria(a, State$$module$build$src$core$utils$aria.INVALID, !1)) : (addClass$$module$build$src$core$utils$dom(a, "blocklyInvalidInput"), setState$$module$build$src$core$utils$aria(a, State$$module$build$src$core$utils$aria.INVALID, !0));
            }
        }
        setSpellcheck(a) {
            a !== this.spellcheck_ && (this.spellcheck_ = a, this.htmlInput_ && this.htmlInput_.setAttribute("spellcheck", this.spellcheck_));
        }
        showEditor_(a, b = !1) {
            this.workspace_ = this.sourceBlock_.workspace;
            !b && this.workspace_.options.modalInputs && (MOBILE$$module$build$src$core$utils$useragent || ANDROID$$module$build$src$core$utils$useragent || IPAD$$module$build$src$core$utils$useragent) ? this.showPromptEditor_() : this.showInlineEditor_(b);
        }
        showPromptEditor_() {
            prompt$$module$build$src$core$dialog(Msg$$module$build$src$core$msg.CHANGE_VALUE_TITLE, this.getText(), (a)=>{
                null !== a && this.setValue(this.getValueFromEditorText_(a));
            });
        }
        showInlineEditor_(a) {
            const b = this.getSourceBlock();
            if (!b) throw new UnattachedFieldError$$module$build$src$core$field;
            show$$module$build$src$core$widgetdiv(this, b.RTL, this.widgetDispose_.bind(this));
            this.htmlInput_ = this.widgetCreate_();
            this.isBeingEdited_ = !0;
            a || (this.htmlInput_.focus({
                preventScroll: !0
            }), this.htmlInput_.select());
        }
        widgetCreate_() {
            var a = this.getSourceBlock();
            if (!a) throw new UnattachedFieldError$$module$build$src$core$field;
            setGroup$$module$build$src$core$events$utils(!0);
            const b = getDiv$$module$build$src$core$widgetdiv();
            var c = this.getClickTarget_();
            if (!c) throw Error("A click target has not been set.");
            addClass$$module$build$src$core$utils$dom(c, "editing");
            c = document.createElement("input");
            c.className = "blocklyHtmlInput";
            c.setAttribute("spellcheck", this.spellcheck_);
            const d = this.workspace_.getScale();
            var e = this.getConstants().FIELD_TEXT_FONTSIZE * d + "pt";
            b.style.fontSize = e;
            c.style.fontSize = e;
            e = FieldInput$$module$build$src$core$field_input.BORDERRADIUS * d + "px";
            this.fullBlockClickTarget_ && (e = this.getScaledBBox(), e = (e.bottom - e.top) / 2 + "px", a = a.getParent() ? a.getParent().style.colourTertiary : this.sourceBlock_.style.colourTertiary, c.style.border = 1 * d + "px solid " + a, b.style.borderRadius = e, b.style.transition = "box-shadow 0.25s ease 0s", this.getConstants().FIELD_TEXTINPUT_BOX_SHADOW && (b.style.boxShadow = "rgba(255, 255, 255, 0.3) 0 0 0 " + 4 * d + "px"));
            c.style.borderRadius = e;
            b.appendChild(c);
            c.value = c.defaultValue = this.getEditorText_(this.value_);
            c.setAttribute("data-untyped-default-value", String(this.value_));
            this.resizeEditor_();
            this.bindInputEvents_(c);
            return c;
        }
        widgetDispose_() {
            this.isBeingEdited_ = !1;
            this.isTextValid_ = !0;
            this.forceRerender();
            this.onFinishEditing_(this.value_);
            setGroup$$module$build$src$core$events$utils(!1);
            this.unbindInputEvents_();
            var a = getDiv$$module$build$src$core$widgetdiv().style;
            a.width = "auto";
            a.height = "auto";
            a.fontSize = "";
            a.transition = "";
            a.boxShadow = "";
            this.htmlInput_ = null;
            a = this.getClickTarget_();
            if (!a) throw Error("A click target has not been set.");
            removeClass$$module$build$src$core$utils$dom(a, "editing");
        }
        onFinishEditing_(a) {}
        bindInputEvents_(a) {
            this.onKeyDownWrapper_ = conditionalBind$$module$build$src$core$browser_events(a, "keydown", this, this.onHtmlInputKeyDown_);
            this.onKeyInputWrapper_ = conditionalBind$$module$build$src$core$browser_events(a, "input", this, this.onHtmlInputChange_);
        }
        unbindInputEvents_() {
            this.onKeyDownWrapper_ && (unbind$$module$build$src$core$browser_events(this.onKeyDownWrapper_), this.onKeyDownWrapper_ = null);
            this.onKeyInputWrapper_ && (unbind$$module$build$src$core$browser_events(this.onKeyInputWrapper_), this.onKeyInputWrapper_ = null);
        }
        onHtmlInputKeyDown_(a) {
            "Enter" === a.key ? (hide$$module$build$src$core$widgetdiv(), hideWithoutAnimation$$module$build$src$core$dropdowndiv()) : "Escape" === a.key ? (this.setValue(this.htmlInput_.getAttribute("data-untyped-default-value")), hide$$module$build$src$core$widgetdiv(), hideWithoutAnimation$$module$build$src$core$dropdowndiv()) : "Tab" === a.key && (hide$$module$build$src$core$widgetdiv(), hideWithoutAnimation$$module$build$src$core$dropdowndiv(), this.sourceBlock_.tab(this, !a.shiftKey), a.preventDefault());
        }
        onHtmlInputChange_(a) {
            this.setValue(this.getValueFromEditorText_(this.htmlInput_.value));
        }
        setEditorValue_(a) {
            this.isDirty_ = !0;
            this.isBeingEdited_ && (this.htmlInput_.value = this.getEditorText_(a));
            this.setValue(a);
        }
        resizeEditor_() {
            var a = this.getSourceBlock();
            if (!a) throw new UnattachedFieldError$$module$build$src$core$field;
            const b = getDiv$$module$build$src$core$widgetdiv(), c = this.getScaledBBox();
            b.style.width = c.right - c.left + "px";
            b.style.height = c.bottom - c.top + "px";
            a = new Coordinate$$module$build$src$core$utils$coordinate(a.RTL ? c.right - b.offsetWidth : c.left, c.top);
            b.style.left = a.x + "px";
            b.style.top = a.y + "px";
        }
        isTabNavigable() {
            return !0;
        }
        getText_() {
            return this.isBeingEdited_ && this.htmlInput_ ? this.htmlInput_.value : null;
        }
        getEditorText_(a) {
            return `${a}`;
        }
        getValueFromEditorText_(a) {
            return a;
        }
    };
    FieldInput$$module$build$src$core$field_input.BORDERRADIUS = 4;
    var module$build$src$core$field_input = {};
    module$build$src$core$field_input.FieldInput = FieldInput$$module$build$src$core$field_input;
    var FieldAngle$$module$build$src$core$field_angle = class extends FieldInput$$module$build$src$core$field_input {
        constructor(a, b, c){
            super(Field$$module$build$src$core$field.SKIP_SETUP);
            this.clockwise = FieldAngle$$module$build$src$core$field_angle.CLOCKWISE;
            this.offset = FieldAngle$$module$build$src$core$field_angle.OFFSET;
            this.wrap = FieldAngle$$module$build$src$core$field_angle.WRAP;
            this.round = FieldAngle$$module$build$src$core$field_angle.ROUND;
            this.boundEvents = [];
            this.symbol_ = this.gauge = this.line = null;
            a !== Field$$module$build$src$core$field.SKIP_SETUP && (c && this.configure_(c), this.setValue(a), b && this.setValidator(b));
        }
        configure_(a) {
            super.configure_(a);
            switch(a.mode){
                case Mode$$module$build$src$core$field_angle.COMPASS:
                    this.clockwise = !0;
                    this.offset = 90;
                    break;
                case Mode$$module$build$src$core$field_angle.PROTRACTOR:
                    this.clockwise = !1, this.offset = 0;
            }
            a.clockwise && (this.clockwise = a.clockwise);
            a.offset && (this.offset = a.offset);
            a.wrap && (this.wrap = a.wrap);
            a.round && (this.round = a.round);
        }
        initView() {
            super.initView();
            this.symbol_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.TSPAN, {});
            this.symbol_.appendChild(document.createTextNode("\xb0"));
            this.getTextElement().appendChild(this.symbol_);
        }
        render_() {
            super.render_();
            this.updateGraph();
        }
        showEditor_(a) {
            super.showEditor_(a, MOBILE$$module$build$src$core$utils$useragent || ANDROID$$module$build$src$core$utils$useragent || IPAD$$module$build$src$core$utils$useragent);
            a = this.dropdownCreate();
            getContentDiv$$module$build$src$core$dropdowndiv().appendChild(a);
            this.sourceBlock_ instanceof BlockSvg$$module$build$src$core$block_svg && setColour$$module$build$src$core$dropdowndiv(this.sourceBlock_.style.colourPrimary, this.sourceBlock_.style.colourTertiary);
            showPositionedByField$$module$build$src$core$dropdowndiv(this, this.dropdownDispose.bind(this));
            this.updateGraph();
        }
        dropdownCreate() {
            const a = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.SVG, {
                xmlns: SVG_NS$$module$build$src$core$utils$dom,
                "xmlns:html": HTML_NS$$module$build$src$core$utils$dom,
                "xmlns:xlink": XLINK_NS$$module$build$src$core$utils$dom,
                version: "1.1",
                height: 2 * FieldAngle$$module$build$src$core$field_angle.HALF + "px",
                width: 2 * FieldAngle$$module$build$src$core$field_angle.HALF + "px",
                style: "touch-action: none"
            }), b = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.CIRCLE, {
                cx: FieldAngle$$module$build$src$core$field_angle.HALF,
                cy: FieldAngle$$module$build$src$core$field_angle.HALF,
                r: FieldAngle$$module$build$src$core$field_angle.RADIUS,
                "class": "blocklyAngleCircle"
            }, a);
            this.gauge = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATH, {
                "class": "blocklyAngleGauge"
            }, a);
            this.line = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.LINE, {
                x1: FieldAngle$$module$build$src$core$field_angle.HALF,
                y1: FieldAngle$$module$build$src$core$field_angle.HALF,
                "class": "blocklyAngleLine"
            }, a);
            for(let c = 0; 360 > c; c += 15)createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.LINE, {
                x1: FieldAngle$$module$build$src$core$field_angle.HALF + FieldAngle$$module$build$src$core$field_angle.RADIUS,
                y1: FieldAngle$$module$build$src$core$field_angle.HALF,
                x2: FieldAngle$$module$build$src$core$field_angle.HALF + FieldAngle$$module$build$src$core$field_angle.RADIUS - (0 === c % 45 ? 10 : 5),
                y2: FieldAngle$$module$build$src$core$field_angle.HALF,
                "class": "blocklyAngleMarks",
                transform: "rotate(" + c + "," + FieldAngle$$module$build$src$core$field_angle.HALF + "," + FieldAngle$$module$build$src$core$field_angle.HALF + ")"
            }, a);
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(a, "click", this, this.hide));
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(b, "pointerdown", this, this.onMouseMove_, !0));
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(b, "pointermove", this, this.onMouseMove_, !0));
            return a;
        }
        dropdownDispose() {
            for (const a of this.boundEvents)unbind$$module$build$src$core$browser_events(a);
            this.boundEvents.length = 0;
            this.line = this.gauge = null;
        }
        hide() {
            hideIfOwner$$module$build$src$core$dropdowndiv(this);
            hide$$module$build$src$core$widgetdiv();
        }
        onMouseMove_(a) {
            var b = this.gauge.ownerSVGElement.getBoundingClientRect();
            const c = a.clientX - b.left - FieldAngle$$module$build$src$core$field_angle.HALF;
            a = a.clientY - b.top - FieldAngle$$module$build$src$core$field_angle.HALF;
            b = Math.atan(-a / c);
            isNaN(b) || (b = toDegrees$$module$build$src$core$utils$math(b), 0 > c ? b += 180 : 0 < a && (b += 360), b = this.clockwise ? this.offset + 360 - b : 360 - (this.offset - b), this.displayMouseOrKeyboardValue(b));
        }
        displayMouseOrKeyboardValue(a) {
            this.round && (a = Math.round(a / this.round) * this.round);
            a = this.wrapValue(a);
            a !== this.value_ && this.setEditorValue_(a);
        }
        updateGraph() {
            if (this.gauge && this.line) {
                var a = Number(this.getText()) + this.offset, b = toRadians$$module$build$src$core$utils$math(a % 360);
                a = [
                    "M ",
                    FieldAngle$$module$build$src$core$field_angle.HALF,
                    ",",
                    FieldAngle$$module$build$src$core$field_angle.HALF
                ];
                var c = FieldAngle$$module$build$src$core$field_angle.HALF, d = FieldAngle$$module$build$src$core$field_angle.HALF;
                if (!isNaN(b)) {
                    const e = Number(this.clockwise), f = toRadians$$module$build$src$core$utils$math(this.offset), g = Math.cos(f) * FieldAngle$$module$build$src$core$field_angle.RADIUS, h = Math.sin(f) * -FieldAngle$$module$build$src$core$field_angle.RADIUS;
                    e && (b = 2 * f - b);
                    c += Math.cos(b) * FieldAngle$$module$build$src$core$field_angle.RADIUS;
                    d -= Math.sin(b) * FieldAngle$$module$build$src$core$field_angle.RADIUS;
                    b = Math.abs(Math.floor((b - f) / Math.PI) % 2);
                    e && (b = 1 - b);
                    a.push(" l ", g, ",", h, " A ", FieldAngle$$module$build$src$core$field_angle.RADIUS, ",", FieldAngle$$module$build$src$core$field_angle.RADIUS, " 0 ", b, " ", e, " ", c, ",", d, " z");
                }
                this.gauge.setAttribute("d", a.join(""));
                this.line.setAttribute("x2", `${c}`);
                this.line.setAttribute("y2", `${d}`);
            }
        }
        onHtmlInputKeyDown_(a) {
            super.onHtmlInputKeyDown_(a);
            var b = this.getSourceBlock();
            if (!b) throw new UnattachedFieldError$$module$build$src$core$field;
            let c = 0;
            switch(a.key){
                case "ArrowLeft":
                    c = b.RTL ? 1 : -1;
                    break;
                case "ArrowRight":
                    c = b.RTL ? -1 : 1;
                    break;
                case "ArrowDown":
                    c = -1;
                    break;
                case "ArrowUp":
                    c = 1;
            }
            c && (b = this.getValue(), this.displayMouseOrKeyboardValue(b + c * this.round), a.preventDefault(), a.stopPropagation());
        }
        doClassValidation_(a) {
            a = Number(a);
            return isNaN(a) || !isFinite(a) ? null : this.wrapValue(a);
        }
        wrapValue(a) {
            a %= 360;
            0 > a && (a += 360);
            a > this.wrap && (a -= 360);
            return a;
        }
        static fromJson(a) {
            return new this(a.angle, void 0, a);
        }
    };
    FieldAngle$$module$build$src$core$field_angle.HALF = 50;
    FieldAngle$$module$build$src$core$field_angle.RADIUS = FieldAngle$$module$build$src$core$field_angle.HALF - 1;
    FieldAngle$$module$build$src$core$field_angle.CLOCKWISE = !1;
    FieldAngle$$module$build$src$core$field_angle.OFFSET = 0;
    FieldAngle$$module$build$src$core$field_angle.WRAP = 360;
    FieldAngle$$module$build$src$core$field_angle.ROUND = 15;
    register$$module$build$src$core$field_registry("field_angle", FieldAngle$$module$build$src$core$field_angle);
    FieldAngle$$module$build$src$core$field_angle.prototype.DEFAULT_VALUE = 0;
    register$$module$build$src$core$css("\n.blocklyAngleCircle {\n  stroke: #444;\n  stroke-width: 1;\n  fill: #ddd;\n  fill-opacity: 0.8;\n}\n\n.blocklyAngleMarks {\n  stroke: #444;\n  stroke-width: 1;\n}\n\n.blocklyAngleGauge {\n  fill: #f88;\n  fill-opacity: 0.8;\n  pointer-events: none;\n}\n\n.blocklyAngleLine {\n  stroke: #f00;\n  stroke-width: 2;\n  stroke-linecap: round;\n  pointer-events: none;\n}\n");
    var Mode$$module$build$src$core$field_angle;
    (function(a) {
        a.COMPASS = "compass";
        a.PROTRACTOR = "protractor";
    })(Mode$$module$build$src$core$field_angle || (Mode$$module$build$src$core$field_angle = {}));
    var module$build$src$core$field_angle = {};
    module$build$src$core$field_angle.FieldAngle = FieldAngle$$module$build$src$core$field_angle;
    module$build$src$core$field_angle.Mode = Mode$$module$build$src$core$field_angle;
    var FieldCheckbox$$module$build$src$core$field_checkbox = class extends Field$$module$build$src$core$field {
        constructor(a, b, c){
            super(Field$$module$build$src$core$field.SKIP_SETUP);
            this.SERIALIZABLE = !0;
            this.CURSOR = "default";
            this.value_ = this.value_;
            this.checkChar_ = FieldCheckbox$$module$build$src$core$field_checkbox.CHECK_CHAR;
            a !== Field$$module$build$src$core$field.SKIP_SETUP && (c && this.configure_(c), this.setValue(a), b && this.setValidator(b));
        }
        configure_(a) {
            super.configure_(a);
            a.checkCharacter && (this.checkChar_ = a.checkCharacter);
        }
        saveState() {
            const a = this.saveLegacyState(FieldCheckbox$$module$build$src$core$field_checkbox);
            return null !== a ? a : this.getValueBoolean();
        }
        initView() {
            super.initView();
            const a = this.getTextElement();
            addClass$$module$build$src$core$utils$dom(a, "blocklyCheckbox");
            a.style.display = this.value_ ? "block" : "none";
        }
        render_() {
            this.textContent_ && (this.textContent_.nodeValue = this.getDisplayText_());
            this.updateSize_(this.getConstants().FIELD_CHECKBOX_X_OFFSET);
        }
        getDisplayText_() {
            return this.checkChar_;
        }
        setCheckCharacter(a) {
            this.checkChar_ = a || FieldCheckbox$$module$build$src$core$field_checkbox.CHECK_CHAR;
            this.forceRerender();
        }
        showEditor_() {
            this.setValue(!this.value_);
        }
        doClassValidation_(a) {
            return !0 === a || "TRUE" === a ? "TRUE" : !1 === a || "FALSE" === a ? "FALSE" : null;
        }
        doValueUpdate_(a) {
            this.value_ = this.convertValueToBool_(a);
            this.textElement_ && (this.textElement_.style.display = this.value_ ? "block" : "none");
        }
        getValue() {
            return this.value_ ? "TRUE" : "FALSE";
        }
        getValueBoolean() {
            return this.value_;
        }
        getText() {
            return String(this.convertValueToBool_(this.value_));
        }
        convertValueToBool_(a) {
            return "string" === typeof a ? "TRUE" === a : !!a;
        }
        static fromJson(a) {
            return new this(a.checked, void 0, a);
        }
    };
    FieldCheckbox$$module$build$src$core$field_checkbox.CHECK_CHAR = "\u2713";
    register$$module$build$src$core$field_registry("field_checkbox", FieldCheckbox$$module$build$src$core$field_checkbox);
    FieldCheckbox$$module$build$src$core$field_checkbox.prototype.DEFAULT_VALUE = !1;
    var module$build$src$core$field_checkbox = {};
    module$build$src$core$field_checkbox.FieldCheckbox = FieldCheckbox$$module$build$src$core$field_checkbox;
    var FieldColour$$module$build$src$core$field_colour = class extends Field$$module$build$src$core$field {
        constructor(a, b, c){
            super(Field$$module$build$src$core$field.SKIP_SETUP);
            this.highlightedIndex = this.picker = null;
            this.boundEvents = [];
            this.SERIALIZABLE = !0;
            this.CURSOR = "default";
            this.isDirty_ = !1;
            this.titles = this.colours = null;
            this.columns = 0;
            a !== Field$$module$build$src$core$field.SKIP_SETUP && (c && this.configure_(c), this.setValue(a), b && this.setValidator(b));
        }
        configure_(a) {
            super.configure_(a);
            a.colourOptions && (this.colours = a.colourOptions);
            a.colourTitles && (this.titles = a.colourTitles);
            a.columns && (this.columns = a.columns);
        }
        initView() {
            this.size_ = new Size$$module$build$src$core$utils$size(this.getConstants().FIELD_COLOUR_DEFAULT_WIDTH, this.getConstants().FIELD_COLOUR_DEFAULT_HEIGHT);
            this.getConstants().FIELD_COLOUR_FULL_BLOCK ? this.sourceBlock_ instanceof BlockSvg$$module$build$src$core$block_svg && (this.clickTarget_ = this.sourceBlock_.getSvgRoot()) : (this.createBorderRect_(), this.getBorderRect().style.fillOpacity = "1");
        }
        applyColour() {
            this.getConstants().FIELD_COLOUR_FULL_BLOCK ? this.sourceBlock_ instanceof BlockSvg$$module$build$src$core$block_svg && (this.sourceBlock_.pathObject.svgPath.setAttribute("fill", this.getValue()), this.sourceBlock_.pathObject.svgPath.setAttribute("stroke", "#fff")) : this.borderRect_ && (this.borderRect_.style.fill = this.getValue());
        }
        doClassValidation_(a) {
            return "string" !== typeof a ? null : parse$$module$build$src$core$utils$colour(a);
        }
        doValueUpdate_(a) {
            this.value_ = a;
            this.borderRect_ ? this.borderRect_.style.fill = a : this.sourceBlock_ && this.sourceBlock_.rendered && this.sourceBlock_ instanceof BlockSvg$$module$build$src$core$block_svg && (this.sourceBlock_.pathObject.svgPath.setAttribute("fill", a), this.sourceBlock_.pathObject.svgPath.setAttribute("stroke", "#fff"));
        }
        getText() {
            let a = this.value_;
            /^#(.)\1(.)\2(.)\3$/.test(a) && (a = "#" + a[1] + a[3] + a[5]);
            return a;
        }
        setColours(a, b) {
            this.colours = a;
            b && (this.titles = b);
            return this;
        }
        setColumns(a) {
            this.columns = a;
            return this;
        }
        showEditor_() {
            this.dropdownCreate();
            getContentDiv$$module$build$src$core$dropdowndiv().appendChild(this.picker);
            showPositionedByField$$module$build$src$core$dropdowndiv(this, this.dropdownDispose.bind(this));
            this.picker.focus({
                preventScroll: !0
            });
        }
        onClick(a) {
            a = (a = a.target) && a.getAttribute("data-colour");
            null !== a && (this.setValue(a), hideIfOwner$$module$build$src$core$dropdowndiv(this));
        }
        onKeyDown(a) {
            let b = !0;
            var c;
            switch(a.key){
                case "ArrowUp":
                    this.moveHighlightBy(0, -1);
                    break;
                case "ArrowDown":
                    this.moveHighlightBy(0, 1);
                    break;
                case "ArrowLeft":
                    this.moveHighlightBy(-1, 0);
                    break;
                case "ArrowRight":
                    this.moveHighlightBy(1, 0);
                    break;
                case "Enter":
                    if (c = this.getHighlighted()) c = c.getAttribute("data-colour"), null !== c && this.setValue(c);
                    hideWithoutAnimation$$module$build$src$core$dropdowndiv();
                    break;
                default:
                    b = !1;
            }
            b && a.stopPropagation();
        }
        moveHighlightBy(a, b) {
            if (this.highlightedIndex) {
                var c = this.colours || FieldColour$$module$build$src$core$field_colour.COLOURS, d = this.columns || FieldColour$$module$build$src$core$field_colour.COLUMNS, e = this.highlightedIndex % d, f = Math.floor(this.highlightedIndex / d);
                e += a;
                f += b;
                0 > a ? 0 > e && 0 < f ? (e = d - 1, f--) : 0 > e && (e = 0) : 0 < a ? e > d - 1 && f < Math.floor(c.length / d) - 1 ? (e = 0, f++) : e > d - 1 && e-- : 0 > b ? 0 > f && (f = 0) : 0 < b && f > Math.floor(c.length / d) - 1 && (f = Math.floor(c.length / d) - 1);
                this.setHighlightedCell(this.picker.childNodes[f].childNodes[e], f * d + e);
            }
        }
        onMouseMove(a) {
            const b = (a = a.target) && Number(a.getAttribute("data-index"));
            null !== b && b !== this.highlightedIndex && this.setHighlightedCell(a, b);
        }
        onMouseEnter() {
            let a;
            null == (a = this.picker) || a.focus({
                preventScroll: !0
            });
        }
        onMouseLeave() {
            var a;
            null == (a = this.picker) || a.blur();
            (a = this.getHighlighted()) && removeClass$$module$build$src$core$utils$dom(a, "blocklyColourHighlighted");
        }
        getHighlighted() {
            if (!this.highlightedIndex) return null;
            const a = this.columns || FieldColour$$module$build$src$core$field_colour.COLUMNS, b = this.picker.childNodes[Math.floor(this.highlightedIndex / a)];
            return b ? b.childNodes[this.highlightedIndex % a] : null;
        }
        setHighlightedCell(a, b) {
            const c = this.getHighlighted();
            c && removeClass$$module$build$src$core$utils$dom(c, "blocklyColourHighlighted");
            addClass$$module$build$src$core$utils$dom(a, "blocklyColourHighlighted");
            this.highlightedIndex = b;
            (a = a.getAttribute("id")) && this.picker && setState$$module$build$src$core$utils$aria(this.picker, State$$module$build$src$core$utils$aria.ACTIVEDESCENDANT, a);
        }
        dropdownCreate() {
            const a = this.columns || FieldColour$$module$build$src$core$field_colour.COLUMNS, b = this.colours || FieldColour$$module$build$src$core$field_colour.COLOURS, c = this.titles || FieldColour$$module$build$src$core$field_colour.TITLES, d = this.getValue(), e = document.createElement("table");
            e.className = "blocklyColourTable";
            e.tabIndex = 0;
            e.dir = "ltr";
            setRole$$module$build$src$core$utils$aria(e, Role$$module$build$src$core$utils$aria.GRID);
            setState$$module$build$src$core$utils$aria(e, State$$module$build$src$core$utils$aria.EXPANDED, !0);
            setState$$module$build$src$core$utils$aria(e, State$$module$build$src$core$utils$aria.ROWCOUNT, Math.floor(b.length / a));
            setState$$module$build$src$core$utils$aria(e, State$$module$build$src$core$utils$aria.COLCOUNT, a);
            let f;
            for(let g = 0; g < b.length; g++){
                0 === g % a && (f = document.createElement("tr"), setRole$$module$build$src$core$utils$aria(f, Role$$module$build$src$core$utils$aria.ROW), e.appendChild(f));
                const h = document.createElement("td");
                f.appendChild(h);
                h.setAttribute("data-colour", b[g]);
                h.title = c[g] || b[g];
                h.id = getNextUniqueId$$module$build$src$core$utils$idgenerator();
                h.setAttribute("data-index", `${g}`);
                setRole$$module$build$src$core$utils$aria(h, Role$$module$build$src$core$utils$aria.GRIDCELL);
                setState$$module$build$src$core$utils$aria(h, State$$module$build$src$core$utils$aria.LABEL, b[g]);
                setState$$module$build$src$core$utils$aria(h, State$$module$build$src$core$utils$aria.SELECTED, b[g] === d);
                h.style.backgroundColor = b[g];
                b[g] === d && (h.className = "blocklyColourSelected", this.highlightedIndex = g);
            }
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(e, "pointerdown", this, this.onClick, !0));
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(e, "pointermove", this, this.onMouseMove, !0));
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(e, "pointerenter", this, this.onMouseEnter, !0));
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(e, "pointerleave", this, this.onMouseLeave, !0));
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(e, "keydown", this, this.onKeyDown, !1));
            this.picker = e;
        }
        dropdownDispose() {
            for (const a of this.boundEvents)unbind$$module$build$src$core$browser_events(a);
            this.boundEvents.length = 0;
            this.highlightedIndex = this.picker = null;
        }
        static fromJson(a) {
            return new this(a.colour, void 0, a);
        }
    };
    FieldColour$$module$build$src$core$field_colour.COLOURS = "#ffffff #cccccc #c0c0c0 #999999 #666666 #333333 #000000 #ffcccc #ff6666 #ff0000 #cc0000 #990000 #660000 #330000 #ffcc99 #ff9966 #ff9900 #ff6600 #cc6600 #993300 #663300 #ffff99 #ffff66 #ffcc66 #ffcc33 #cc9933 #996633 #663333 #ffffcc #ffff33 #ffff00 #ffcc00 #999900 #666600 #333300 #99ff99 #66ff99 #33ff33 #33cc00 #009900 #006600 #003300 #99ffff #33ffff #66cccc #00cccc #339999 #336666 #003333 #ccffff #66ffff #33ccff #3366ff #3333ff #000099 #000066 #ccccff #9999ff #6666cc #6633ff #6600cc #333399 #330099 #ffccff #ff99ff #cc66cc #cc33cc #993399 #663366 #330033".split(" ");
    FieldColour$$module$build$src$core$field_colour.TITLES = [];
    FieldColour$$module$build$src$core$field_colour.COLUMNS = 7;
    FieldColour$$module$build$src$core$field_colour.prototype.DEFAULT_VALUE = FieldColour$$module$build$src$core$field_colour.COLOURS[0];
    register$$module$build$src$core$field_registry("field_colour", FieldColour$$module$build$src$core$field_colour);
    register$$module$build$src$core$css("\n.blocklyColourTable {\n  border-collapse: collapse;\n  display: block;\n  outline: none;\n  padding: 1px;\n}\n\n.blocklyColourTable>tr>td {\n  border: 0.5px solid #888;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: inline-block;\n  height: 20px;\n  padding: 0;\n  width: 20px;\n}\n\n.blocklyColourTable>tr>td.blocklyColourHighlighted {\n  border-color: #eee;\n  box-shadow: 2px 2px 7px 2px rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n\n.blocklyColourSelected, .blocklyColourSelected:hover {\n  border-color: #eee !important;\n  outline: 1px solid #333;\n  position: relative;\n}\n");
    var module$build$src$core$field_colour = {};
    module$build$src$core$field_colour.FieldColour = FieldColour$$module$build$src$core$field_colour;
    var FieldImage$$module$build$src$core$field_image = class extends Field$$module$build$src$core$field {
        constructor(a, b, c, d, e, f, g){
            super(Field$$module$build$src$core$field.SKIP_SETUP);
            this.imageElement_ = this.clickHandler_ = null;
            this.flipRtl_ = this.isDirty_ = this.EDITABLE = !1;
            this.altText_ = "";
            c = Number(replaceMessageReferences$$module$build$src$core$utils$parsing(c));
            b = Number(replaceMessageReferences$$module$build$src$core$utils$parsing(b));
            if (isNaN(c) || isNaN(b)) throw Error("Height and width values of an image field must cast to numbers.");
            if (0 >= c || 0 >= b) throw Error("Height and width values of an image field must be greater than 0.");
            this.size_ = new Size$$module$build$src$core$utils$size(b, c + FieldImage$$module$build$src$core$field_image.Y_PADDING);
            this.imageHeight_ = c;
            "function" === typeof e && (this.clickHandler_ = e);
            a !== Field$$module$build$src$core$field.SKIP_SETUP && (g ? this.configure_(g) : (this.flipRtl_ = !!f, this.altText_ = replaceMessageReferences$$module$build$src$core$utils$parsing(d) || ""), this.setValue(replaceMessageReferences$$module$build$src$core$utils$parsing(a)));
        }
        configure_(a) {
            super.configure_(a);
            a.flipRtl && (this.flipRtl_ = a.flipRtl);
            a.alt && (this.altText_ = replaceMessageReferences$$module$build$src$core$utils$parsing(a.alt));
        }
        initView() {
            this.imageElement_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.IMAGE, {
                height: this.imageHeight_ + "px",
                width: this.size_.width + "px",
                alt: this.altText_
            }, this.fieldGroup_);
            this.imageElement_.setAttributeNS(XLINK_NS$$module$build$src$core$utils$dom, "xlink:href", this.value_);
            this.clickHandler_ && (this.imageElement_.style.cursor = "pointer");
        }
        updateSize_() {}
        doClassValidation_(a) {
            return "string" !== typeof a ? null : a;
        }
        doValueUpdate_(a) {
            this.value_ = a;
            this.imageElement_ && this.imageElement_.setAttributeNS(XLINK_NS$$module$build$src$core$utils$dom, "xlink:href", this.value_);
        }
        getFlipRtl() {
            return this.flipRtl_;
        }
        setAlt(a) {
            a !== this.altText_ && (this.altText_ = a || "", this.imageElement_ && this.imageElement_.setAttribute("alt", this.altText_));
        }
        showEditor_() {
            this.clickHandler_ && this.clickHandler_(this);
        }
        setOnClickHandler(a) {
            this.clickHandler_ = a;
        }
        getText_() {
            return this.altText_;
        }
        static fromJson(a) {
            if (!a.src || !a.width || !a.height) throw Error("src, width, and height values for an image field arerequired. The width and height must be non-zero.");
            return new this(a.src, a.width, a.height, void 0, void 0, void 0, a);
        }
    };
    FieldImage$$module$build$src$core$field_image.Y_PADDING = 1;
    register$$module$build$src$core$field_registry("field_image", FieldImage$$module$build$src$core$field_image);
    FieldImage$$module$build$src$core$field_image.prototype.DEFAULT_VALUE = "";
    var module$build$src$core$field_image = {};
    module$build$src$core$field_image.FieldImage = FieldImage$$module$build$src$core$field_image;
    var FieldLabelSerializable$$module$build$src$core$field_label_serializable = class extends FieldLabel$$module$build$src$core$field_label {
        constructor(a, b, c){
            super(String(null != a ? a : ""), b, c);
            this.EDITABLE = !1;
            this.SERIALIZABLE = !0;
        }
        static fromJson(a) {
            return new this(replaceMessageReferences$$module$build$src$core$utils$parsing(a.text), void 0, a);
        }
    };
    register$$module$build$src$core$field_registry("field_label_serializable", FieldLabelSerializable$$module$build$src$core$field_label_serializable);
    var module$build$src$core$field_label_serializable = {};
    module$build$src$core$field_label_serializable.FieldLabelSerializable = FieldLabelSerializable$$module$build$src$core$field_label_serializable;
    var FieldTextInput$$module$build$src$core$field_textinput = class extends FieldInput$$module$build$src$core$field_input {
        constructor(a, b, c){
            super(a, b, c);
        }
        doClassValidation_(a) {
            return void 0 === a ? null : `${a}`;
        }
        static fromJson(a) {
            return new this(replaceMessageReferences$$module$build$src$core$utils$parsing(a.text), void 0, a);
        }
    };
    register$$module$build$src$core$field_registry("field_input", FieldTextInput$$module$build$src$core$field_textinput);
    FieldTextInput$$module$build$src$core$field_textinput.prototype.DEFAULT_VALUE = "";
    var module$build$src$core$field_textinput = {};
    module$build$src$core$field_textinput.FieldTextInput = FieldTextInput$$module$build$src$core$field_textinput;
    var FieldMultilineInput$$module$build$src$core$field_multilineinput = class extends FieldTextInput$$module$build$src$core$field_textinput {
        constructor(a, b, c){
            super(Field$$module$build$src$core$field.SKIP_SETUP);
            this.textGroup = null;
            this.maxLines_ = Infinity;
            this.isOverflowedY_ = !1;
            a !== Field$$module$build$src$core$field.SKIP_SETUP && (c && this.configure_(c), this.setValue(a), b && this.setValidator(b));
        }
        configure_(a) {
            super.configure_(a);
            a.maxLines && this.setMaxLines(a.maxLines);
        }
        toXml(a) {
            a.textContent = this.getValue().replace(/\n/g, "&#10;");
            return a;
        }
        fromXml(a) {
            this.setValue(a.textContent.replace(/&#10;/g, "\n"));
        }
        saveState() {
            const a = this.saveLegacyState(FieldMultilineInput$$module$build$src$core$field_multilineinput);
            return null !== a ? a : this.getValue();
        }
        loadState(a) {
            this.loadLegacyState(Field$$module$build$src$core$field, a) || this.setValue(a);
        }
        initView() {
            this.createBorderRect_();
            this.textGroup = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {
                "class": "blocklyEditableText"
            }, this.fieldGroup_);
        }
        getDisplayText_() {
            const a = this.getSourceBlock();
            if (!a) throw new UnattachedFieldError$$module$build$src$core$field;
            let b = this.getText();
            if (!b) return Field$$module$build$src$core$field.NBSP;
            const c = b.split("\n");
            b = "";
            const d = this.isOverflowedY_ ? this.maxLines_ : c.length;
            for(let e = 0; e < d; e++){
                let f = c[e];
                f.length > this.maxDisplayLength ? f = f.substring(0, this.maxDisplayLength - 4) + "..." : this.isOverflowedY_ && e === d - 1 && (f = f.substring(0, f.length - 3) + "...");
                f = f.replace(/\s/g, Field$$module$build$src$core$field.NBSP);
                b += f;
                e !== d - 1 && (b += "\n");
            }
            a.RTL && (b += "\u200F");
            return b;
        }
        doValueUpdate_(a) {
            super.doValueUpdate_(a);
            null !== this.value_ && (this.isOverflowedY_ = this.value_.split("\n").length > this.maxLines_);
        }
        render_() {
            var a = this.getSourceBlock();
            if (!a) throw new UnattachedFieldError$$module$build$src$core$field;
            for(var b, c = this.textGroup; b = c.firstChild;)c.removeChild(b);
            b = this.getDisplayText_().split("\n");
            let d = 0;
            for(let e = 0; e < b.length; e++){
                const f = this.getConstants().FIELD_TEXT_HEIGHT + this.getConstants().FIELD_BORDER_RECT_Y_PADDING;
                createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.TEXT, {
                    "class": "blocklyText blocklyMultilineText",
                    x: this.getConstants().FIELD_BORDER_RECT_X_PADDING,
                    y: d + this.getConstants().FIELD_BORDER_RECT_Y_PADDING,
                    dy: this.getConstants().FIELD_TEXT_BASELINE
                }, c).appendChild(document.createTextNode(b[e]));
                d += f;
            }
            this.isBeingEdited_ && (c = this.htmlInput_, this.isOverflowedY_ ? addClass$$module$build$src$core$utils$dom(c, "blocklyHtmlTextAreaInputOverflowedY") : removeClass$$module$build$src$core$utils$dom(c, "blocklyHtmlTextAreaInputOverflowedY"));
            this.updateSize_();
            this.isBeingEdited_ && (a.RTL ? setTimeout(this.resizeEditor_.bind(this), 0) : this.resizeEditor_(), a = this.htmlInput_, this.isTextValid_ ? (removeClass$$module$build$src$core$utils$dom(a, "blocklyInvalidInput"), setState$$module$build$src$core$utils$aria(a, State$$module$build$src$core$utils$aria.INVALID, !1)) : (addClass$$module$build$src$core$utils$dom(a, "blocklyInvalidInput"), setState$$module$build$src$core$utils$aria(a, State$$module$build$src$core$utils$aria.INVALID, !0)));
        }
        updateSize_() {
            var a = this.textGroup.childNodes;
            const b = this.getConstants().FIELD_TEXT_FONTSIZE, c = this.getConstants().FIELD_TEXT_FONTWEIGHT, d = this.getConstants().FIELD_TEXT_FONTFAMILY;
            let e = 0, f = 0;
            for(var g = 0; g < a.length; g++){
                var h = getFastTextWidth$$module$build$src$core$utils$dom(a[g], b, c, d);
                h > e && (e = h);
                f += this.getConstants().FIELD_TEXT_HEIGHT + (0 < g ? this.getConstants().FIELD_BORDER_RECT_Y_PADDING : 0);
            }
            if (this.isBeingEdited_) {
                a = String(this.value_).split("\n");
                g = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.TEXT, {
                    "class": "blocklyText blocklyMultilineText"
                });
                for(h = 0; h < a.length; h++){
                    a[h].length > this.maxDisplayLength && (a[h] = a[h].substring(0, this.maxDisplayLength));
                    g.textContent = a[h];
                    const k = getFastTextWidth$$module$build$src$core$utils$dom(g, b, c, d);
                    k > e && (e = k);
                }
                e += this.htmlInput_.offsetWidth - this.htmlInput_.clientWidth;
            }
            this.borderRect_ && (f += 2 * this.getConstants().FIELD_BORDER_RECT_Y_PADDING, e += 2 * this.getConstants().FIELD_BORDER_RECT_X_PADDING, this.borderRect_.setAttribute("width", `${e}`), this.borderRect_.setAttribute("height", `${f}`));
            this.size_.width = e;
            this.size_.height = f;
            this.positionBorderRect_();
        }
        showEditor_(a, b) {
            super.showEditor_(a, b);
            this.forceRerender();
        }
        widgetCreate_() {
            const a = getDiv$$module$build$src$core$widgetdiv(), b = this.workspace_.getScale(), c = document.createElement("textarea");
            c.className = "blocklyHtmlInput blocklyHtmlTextAreaInput";
            c.setAttribute("spellcheck", String(this.spellcheck_));
            var d = this.getConstants().FIELD_TEXT_FONTSIZE * b + "pt";
            a.style.fontSize = d;
            c.style.fontSize = d;
            c.style.borderRadius = FieldTextInput$$module$build$src$core$field_textinput.BORDERRADIUS * b + "px";
            d = this.getConstants().FIELD_BORDER_RECT_X_PADDING * b;
            const e = this.getConstants().FIELD_BORDER_RECT_Y_PADDING * b / 2;
            c.style.padding = e + "px " + d + "px " + e + "px " + d + "px";
            d = this.getConstants().FIELD_TEXT_HEIGHT + this.getConstants().FIELD_BORDER_RECT_Y_PADDING;
            c.style.lineHeight = d * b + "px";
            a.appendChild(c);
            c.value = c.defaultValue = this.getEditorText_(this.value_);
            c.setAttribute("data-untyped-default-value", String(this.value_));
            c.setAttribute("data-old-value", "");
            GECKO$$module$build$src$core$utils$useragent ? setTimeout(this.resizeEditor_.bind(this), 0) : this.resizeEditor_();
            this.bindInputEvents_(c);
            return c;
        }
        setMaxLines(a) {
            "number" === typeof a && 0 < a && a !== this.maxLines_ && (this.maxLines_ = a, this.forceRerender());
        }
        getMaxLines() {
            return this.maxLines_;
        }
        onHtmlInputKeyDown_(a) {
            if ("Enter" !== a.key) super.onHtmlInputKeyDown_(a);
        }
        static fromJson(a) {
            return new this(replaceMessageReferences$$module$build$src$core$utils$parsing(a.text), void 0, a);
        }
    };
    register$$module$build$src$core$field_registry("field_multilinetext", FieldMultilineInput$$module$build$src$core$field_multilineinput);
    register$$module$build$src$core$css("\n.blocklyHtmlTextAreaInput {\n  font-family: monospace;\n  resize: none;\n  overflow: hidden;\n  height: 100%;\n  text-align: left;\n}\n\n.blocklyHtmlTextAreaInputOverflowedY {\n  overflow-y: scroll;\n}\n");
    var module$build$src$core$field_multilineinput = {};
    module$build$src$core$field_multilineinput.FieldMultilineInput = FieldMultilineInput$$module$build$src$core$field_multilineinput;
    var FieldNumber$$module$build$src$core$field_number = class extends FieldInput$$module$build$src$core$field_input {
        constructor(a, b, c, d, e, f){
            super(Field$$module$build$src$core$field.SKIP_SETUP);
            this.min_ = -Infinity;
            this.max_ = Infinity;
            this.precision_ = 0;
            this.decimalPlaces_ = null;
            this.spellcheck_ = !1;
            a !== Field$$module$build$src$core$field.SKIP_SETUP && (f ? this.configure_(f) : this.setConstraints(b, c, d), this.setValue(a), e && this.setValidator(e));
        }
        configure_(a) {
            super.configure_(a);
            this.setMinInternal_(a.min);
            this.setMaxInternal_(a.max);
            this.setPrecisionInternal_(a.precision);
        }
        setConstraints(a, b, c) {
            this.setMinInternal_(a);
            this.setMaxInternal_(b);
            this.setPrecisionInternal_(c);
            this.setValue(this.getValue());
        }
        setMin(a) {
            this.setMinInternal_(a);
            this.setValue(this.getValue());
        }
        setMinInternal_(a) {
            null == a ? this.min_ = -Infinity : (a = Number(a), isNaN(a) || (this.min_ = a));
        }
        getMin() {
            return this.min_;
        }
        setMax(a) {
            this.setMaxInternal_(a);
            this.setValue(this.getValue());
        }
        setMaxInternal_(a) {
            null == a ? this.max_ = Infinity : (a = Number(a), isNaN(a) || (this.max_ = a));
        }
        getMax() {
            return this.max_;
        }
        setPrecision(a) {
            this.setPrecisionInternal_(a);
            this.setValue(this.getValue());
        }
        setPrecisionInternal_(a) {
            this.precision_ = Number(a) || 0;
            let b = String(this.precision_);
            -1 !== b.indexOf("e") && (b = this.precision_.toLocaleString("en-US", {
                maximumFractionDigits: 20
            }));
            const c = b.indexOf(".");
            this.decimalPlaces_ = -1 === c ? a ? 0 : null : b.length - c - 1;
        }
        getPrecision() {
            return this.precision_;
        }
        doClassValidation_(a) {
            if (null === a) return null;
            a = `${a}`.replace(/O/ig, "0");
            a = a.replace(/,/g, "");
            a = a.replace(/infinity/i, "Infinity");
            a = Number(a || 0);
            if (isNaN(a)) return null;
            a = Math.min(Math.max(a, this.min_), this.max_);
            this.precision_ && isFinite(a) && (a = Math.round(a / this.precision_) * this.precision_);
            null !== this.decimalPlaces_ && (a = Number(a.toFixed(this.decimalPlaces_)));
            return a;
        }
        widgetCreate_() {
            const a = super.widgetCreate_();
            a.type = "number";
            -Infinity < this.min_ && (a.min = `${this.min_}`, setState$$module$build$src$core$utils$aria(a, State$$module$build$src$core$utils$aria.VALUEMIN, this.min_));
            Infinity > this.max_ && (a.max = `${this.max_}`, setState$$module$build$src$core$utils$aria(a, State$$module$build$src$core$utils$aria.VALUEMAX, this.max_));
            return a;
        }
        static fromJson(a) {
            return new this(a.value, void 0, void 0, void 0, void 0, a);
        }
    };
    register$$module$build$src$core$field_registry("field_number", FieldNumber$$module$build$src$core$field_number);
    FieldNumber$$module$build$src$core$field_number.prototype.DEFAULT_VALUE = 0;
    var module$build$src$core$field_number = {};
    module$build$src$core$field_number.FieldNumber = FieldNumber$$module$build$src$core$field_number;
    var FieldVariable$$module$build$src$core$field_variable = class extends FieldDropdown$$module$build$src$core$field_dropdown {
        constructor(a, b, c, d, e){
            super(Field$$module$build$src$core$field.SKIP_SETUP);
            this.defaultType_ = "";
            this.variableTypes = [];
            this.variable_ = null;
            this.SERIALIZABLE = !0;
            this.menuGenerator_ = FieldVariable$$module$build$src$core$field_variable.dropdownCreate;
            this.defaultVariableName = "string" === typeof a ? a : "";
            this.size_ = new Size$$module$build$src$core$utils$size(0, 0);
            a !== Field$$module$build$src$core$field.SKIP_SETUP && (e ? this.configure_(e) : this.setTypes_(c, d), b && this.setValidator(b));
        }
        configure_(a) {
            super.configure_(a);
            this.setTypes_(a.variableTypes, a.defaultType);
        }
        initModel() {
            var a = this.getSourceBlock();
            if (!a) throw new UnattachedFieldError$$module$build$src$core$field;
            this.variable_ || (a = getOrCreateVariablePackage$$module$build$src$core$variables(a.workspace, null, this.defaultVariableName, this.defaultType_), this.doValueUpdate_(a.getId()));
        }
        shouldAddBorderRect_() {
            const a = this.getSourceBlock();
            if (!a) throw new UnattachedFieldError$$module$build$src$core$field;
            return super.shouldAddBorderRect_() && (!this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW || "variables_get" !== a.type);
        }
        fromXml(a) {
            var b = this.getSourceBlock();
            if (!b) throw new UnattachedFieldError$$module$build$src$core$field;
            const c = a.getAttribute("id"), d = a.textContent, e = a.getAttribute("variabletype") || a.getAttribute("variableType") || "";
            b = getOrCreateVariablePackage$$module$build$src$core$variables(b.workspace, c, d, e);
            if (null !== e && e !== b.type) throw Error("Serialized variable type with id '" + b.getId() + "' had type " + b.type + ", and does not match variable field that references it: " + domToText$$module$build$src$core$xml(a) + ".");
            this.setValue(b.getId());
        }
        toXml(a) {
            this.initModel();
            a.id = this.variable_.getId();
            a.textContent = this.variable_.name;
            this.variable_.type && a.setAttribute("variabletype", this.variable_.type);
            return a;
        }
        saveState(a) {
            var b = this.saveLegacyState(FieldVariable$$module$build$src$core$field_variable);
            if (null !== b) return b;
            this.initModel();
            b = {
                id: this.variable_.getId()
            };
            a && (b.name = this.variable_.name, b.type = this.variable_.type);
            return b;
        }
        loadState(a) {
            const b = this.getSourceBlock();
            if (!b) throw new UnattachedFieldError$$module$build$src$core$field;
            this.loadLegacyState(FieldVariable$$module$build$src$core$field_variable, a) || (a = getOrCreateVariablePackage$$module$build$src$core$variables(b.workspace, a.id || null, a.name, a.type || ""), this.setValue(a.getId()));
        }
        setSourceBlock(a) {
            if (a.isShadow()) throw Error("Variable fields are not allowed to exist on shadow blocks.");
            super.setSourceBlock(a);
        }
        getValue() {
            return this.variable_ ? this.variable_.getId() : null;
        }
        getText() {
            return this.variable_ ? this.variable_.name : "";
        }
        getVariable() {
            return this.variable_;
        }
        getValidator() {
            return this.variable_ ? this.validator_ : null;
        }
        doClassValidation_(a) {
            if (null === a) return null;
            var b = this.getSourceBlock();
            if (!b) throw new UnattachedFieldError$$module$build$src$core$field;
            b = getVariable$$module$build$src$core$variables(b.workspace, a);
            if (!b) return console.warn("Variable id doesn't point to a real variable! ID was " + a), null;
            b = b.type;
            return this.typeIsAllowed_(b) ? a : (console.warn("Variable type doesn't match this field!  Type was " + b), null);
        }
        doValueUpdate_(a) {
            const b = this.getSourceBlock();
            if (!b) throw new UnattachedFieldError$$module$build$src$core$field;
            this.variable_ = getVariable$$module$build$src$core$variables(b.workspace, a);
            super.doValueUpdate_(a);
        }
        typeIsAllowed_(a) {
            const b = this.getVariableTypes_();
            if (!b) return !0;
            for(let c = 0; c < b.length; c++)if (a === b[c]) return !0;
            return !1;
        }
        getVariableTypes_() {
            var a = this.variableTypes;
            if (null === a && this.sourceBlock_ && !this.sourceBlock_.isDeadOrDying()) return this.sourceBlock_.workspace.getVariableTypes();
            a = a || [
                ""
            ];
            if (0 === a.length) throw a = this.getText(), Error("'variableTypes' of field variable " + a + " was an empty list");
            return a;
        }
        setTypes_(a = null, b = "") {
            if (Array.isArray(a)) {
                let c = !1;
                for(let d = 0; d < a.length; d++)a[d] === b && (c = !0);
                if (!c) throw Error("Invalid default type '" + b + "' in the definition of a FieldVariable");
            } else if (null !== a) throw Error("'variableTypes' was not an array in the definition of a FieldVariable");
            this.defaultType_ = b;
            this.variableTypes = a;
        }
        refreshVariableName() {
            this.forceRerender();
        }
        onItemSelected_(a, b) {
            a = b.getValue();
            if (this.sourceBlock_ && !this.sourceBlock_.isDeadOrDying()) {
                if (a === RENAME_VARIABLE_ID$$module$build$src$core$internal_constants) {
                    renameVariable$$module$build$src$core$variables(this.sourceBlock_.workspace, this.variable_);
                    return;
                }
                if (a === DELETE_VARIABLE_ID$$module$build$src$core$internal_constants) {
                    this.sourceBlock_.workspace.deleteVariableById(this.variable_.getId());
                    return;
                }
            }
            this.setValue(a);
        }
        referencesVariables() {
            return !0;
        }
        static fromJson(a) {
            return new this(replaceMessageReferences$$module$build$src$core$utils$parsing(a.variable), void 0, void 0, void 0, a);
        }
        static dropdownCreate() {
            if (!this.variable_) throw Error("Tried to call dropdownCreate on a variable field with no variable selected.");
            const a = this.getText();
            let b = [];
            if (this.sourceBlock_ && !this.sourceBlock_.isDeadOrDying()) {
                var c = this.getVariableTypes_();
                for(var d = 0; d < c.length; d++){
                    const e = this.sourceBlock_.workspace.getVariablesOfType(c[d]);
                    b = b.concat(e);
                }
            }
            b.sort(VariableModel$$module$build$src$core$variable_model.compareByName);
            c = [];
            for(d = 0; d < b.length; d++)c[d] = [
                b[d].name,
                b[d].getId()
            ];
            c.push([
                Msg$$module$build$src$core$msg.RENAME_VARIABLE,
                RENAME_VARIABLE_ID$$module$build$src$core$internal_constants
            ]);
            Msg$$module$build$src$core$msg.DELETE_VARIABLE && c.push([
                Msg$$module$build$src$core$msg.DELETE_VARIABLE.replace("%1", a),
                DELETE_VARIABLE_ID$$module$build$src$core$internal_constants
            ]);
            return c;
        }
    };
    register$$module$build$src$core$field_registry("field_variable", FieldVariable$$module$build$src$core$field_variable);
    var module$build$src$core$field_variable = {};
    module$build$src$core$field_variable.FieldVariable = FieldVariable$$module$build$src$core$field_variable;
    var FlyoutButton$$module$build$src$core$flyout_button = class {
        constructor(a, b, c, d){
            this.workspace = a;
            this.targetWorkspace = b;
            this.isLabel_ = d;
            this.onMouseUpWrapper_ = null;
            this.height = this.width = 0;
            this.svgText_ = this.svgGroup_ = null;
            this.text_ = c.text;
            this.position_ = new Coordinate$$module$build$src$core$utils$coordinate(0, 0);
            this.callbackKey_ = c.callbackKey || c.callbackkey;
            this.cssClass_ = c["web-class"] || null;
            this.info = c;
        }
        createDom() {
            var a = this.isLabel_ ? "blocklyFlyoutLabel" : "blocklyFlyoutButton";
            this.cssClass_ && (a += " " + this.cssClass_);
            this.svgGroup_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {
                "class": a
            }, this.workspace.getCanvas());
            let b;
            this.isLabel_ || (b = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                "class": "blocklyFlyoutButtonShadow",
                rx: FlyoutButton$$module$build$src$core$flyout_button.BORDER_RADIUS,
                ry: FlyoutButton$$module$build$src$core$flyout_button.BORDER_RADIUS,
                x: 1,
                y: 1
            }, this.svgGroup_));
            a = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                "class": this.isLabel_ ? "blocklyFlyoutLabelBackground" : "blocklyFlyoutButtonBackground",
                rx: FlyoutButton$$module$build$src$core$flyout_button.BORDER_RADIUS,
                ry: FlyoutButton$$module$build$src$core$flyout_button.BORDER_RADIUS
            }, this.svgGroup_);
            const c = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.TEXT, {
                "class": this.isLabel_ ? "blocklyFlyoutLabelText" : "blocklyText",
                x: 0,
                y: 0,
                "text-anchor": "middle"
            }, this.svgGroup_);
            var d = replaceMessageReferences$$module$build$src$core$utils$parsing(this.text_);
            this.workspace.RTL && (d += "\u200F");
            c.textContent = d;
            this.isLabel_ && (this.svgText_ = c, this.workspace.getThemeManager().subscribe(this.svgText_, "flyoutForegroundColour", "fill"));
            const e = getComputedStyle$$module$build$src$core$utils$style(c, "fontSize"), f = getComputedStyle$$module$build$src$core$utils$style(c, "fontWeight"), g = getComputedStyle$$module$build$src$core$utils$style(c, "fontFamily");
            this.width = getFastTextWidthWithSizeString$$module$build$src$core$utils$dom(c, e, f, g);
            d = measureFontMetrics$$module$build$src$core$utils$dom(d, e, f, g);
            this.height = d.height;
            if (!this.isLabel_) {
                this.width += 2 * FlyoutButton$$module$build$src$core$flyout_button.TEXT_MARGIN_X;
                this.height += 2 * FlyoutButton$$module$build$src$core$flyout_button.TEXT_MARGIN_Y;
                let h;
                null == (h = b) || h.setAttribute("width", String(this.width));
                let k;
                null == (k = b) || k.setAttribute("height", String(this.height));
            }
            a.setAttribute("width", String(this.width));
            a.setAttribute("height", String(this.height));
            c.setAttribute("x", String(this.width / 2));
            c.setAttribute("y", String(this.height / 2 - d.height / 2 + d.baseline));
            this.updateTransform_();
            this.onMouseUpWrapper_ = conditionalBind$$module$build$src$core$browser_events(this.svgGroup_, "pointerup", this, this.onMouseUp_);
            return this.svgGroup_;
        }
        show() {
            this.updateTransform_();
            this.svgGroup_.setAttribute("display", "block");
        }
        updateTransform_() {
            this.svgGroup_.setAttribute("transform", "translate(" + this.position_.x + "," + this.position_.y + ")");
        }
        moveTo(a, b) {
            this.position_.x = a;
            this.position_.y = b;
            this.updateTransform_();
        }
        isLabel() {
            return this.isLabel_;
        }
        getPosition() {
            return this.position_;
        }
        getButtonText() {
            return this.text_;
        }
        getTargetWorkspace() {
            return this.targetWorkspace;
        }
        dispose() {
            this.onMouseUpWrapper_ && unbind$$module$build$src$core$browser_events(this.onMouseUpWrapper_);
            this.svgGroup_ && removeNode$$module$build$src$core$utils$dom(this.svgGroup_);
            this.svgText_ && this.workspace.getThemeManager().unsubscribe(this.svgText_);
        }
        onMouseUp_(a) {
            (a = this.targetWorkspace.getGesture(a)) && a.cancel();
            this.isLabel_ && this.callbackKey_ ? console.warn("Labels should not have callbacks. Label text: " + this.text_) : this.isLabel_ || this.callbackKey_ && this.targetWorkspace.getButtonCallback(this.callbackKey_) ? this.isLabel_ || (a = this.targetWorkspace.getButtonCallback(this.callbackKey_)) && a(this) : console.warn("Buttons should have callbacks. Button text: " + this.text_);
        }
    };
    FlyoutButton$$module$build$src$core$flyout_button.TEXT_MARGIN_X = 5;
    FlyoutButton$$module$build$src$core$flyout_button.TEXT_MARGIN_Y = 2;
    FlyoutButton$$module$build$src$core$flyout_button.BORDER_RADIUS = 4;
    register$$module$build$src$core$css("\n.blocklyFlyoutButton {\n  fill: #888;\n  cursor: default;\n}\n\n.blocklyFlyoutButtonShadow {\n  fill: #666;\n}\n\n.blocklyFlyoutButton:hover {\n  fill: #aaa;\n}\n\n.blocklyFlyoutLabel {\n  cursor: default;\n}\n\n.blocklyFlyoutLabelBackground {\n  opacity: 0;\n}\n");
    var module$build$src$core$flyout_button = {};
    module$build$src$core$flyout_button.FlyoutButton = FlyoutButton$$module$build$src$core$flyout_button;
    var MetricsManager$$module$build$src$core$metrics_manager = class {
        constructor(a){
            this.workspace_ = a;
        }
        getDimensionsPx_(a) {
            let b = 0, c = 0;
            a && (b = a.getWidth(), c = a.getHeight());
            return new Size$$module$build$src$core$utils$size(b, c);
        }
        getFlyoutMetrics(a) {
            a = this.getDimensionsPx_(this.workspace_.getFlyout(a));
            return {
                width: a.width,
                height: a.height,
                position: this.workspace_.toolboxPosition
            };
        }
        getToolboxMetrics() {
            const a = this.getDimensionsPx_(this.workspace_.getToolbox());
            return {
                width: a.width,
                height: a.height,
                position: this.workspace_.toolboxPosition
            };
        }
        getSvgMetrics() {
            return this.workspace_.getCachedParentSvgSize();
        }
        getAbsoluteMetrics() {
            let a = 0;
            const b = this.getToolboxMetrics(), c = this.getFlyoutMetrics(!0), d = !!this.workspace_.getToolbox(), e = !!this.workspace_.getFlyout(!0);
            var f = d ? b.position : c.position, g = f === Position$$module$build$src$core$utils$toolbox.LEFT;
            f = f === Position$$module$build$src$core$utils$toolbox.TOP;
            d && g ? a = b.width : e && g && (a = c.width);
            g = 0;
            d && f ? g = b.height : e && f && (g = c.height);
            return {
                top: g,
                left: a
            };
        }
        getViewMetrics(a) {
            a = a ? this.workspace_.scale : 1;
            const b = this.getSvgMetrics(), c = this.getToolboxMetrics(), d = this.getFlyoutMetrics(!0), e = this.workspace_.getToolbox() ? c.position : d.position;
            if (this.workspace_.getToolbox()) {
                if (e === Position$$module$build$src$core$utils$toolbox.TOP || e === Position$$module$build$src$core$utils$toolbox.BOTTOM) b.height -= c.height;
                else if (e === Position$$module$build$src$core$utils$toolbox.LEFT || e === Position$$module$build$src$core$utils$toolbox.RIGHT) b.width -= c.width;
            } else if (this.workspace_.getFlyout(!0)) {
                if (e === Position$$module$build$src$core$utils$toolbox.TOP || e === Position$$module$build$src$core$utils$toolbox.BOTTOM) b.height -= d.height;
                else if (e === Position$$module$build$src$core$utils$toolbox.LEFT || e === Position$$module$build$src$core$utils$toolbox.RIGHT) b.width -= d.width;
            }
            return {
                height: b.height / a,
                width: b.width / a,
                top: -this.workspace_.scrollY / a,
                left: -this.workspace_.scrollX / a
            };
        }
        getContentMetrics(a) {
            a = a ? 1 : this.workspace_.scale;
            const b = this.workspace_.getBlocksBoundingBox();
            return {
                height: (b.bottom - b.top) * a,
                width: (b.right - b.left) * a,
                top: b.top * a,
                left: b.left * a
            };
        }
        hasFixedEdges() {
            return !this.workspace_.isMovableHorizontally() || !this.workspace_.isMovableVertically();
        }
        getComputedFixedEdges_(a) {
            if (!this.hasFixedEdges()) return {};
            const b = this.workspace_.isMovableHorizontally(), c = this.workspace_.isMovableVertically();
            a = a || this.getViewMetrics(!1);
            const d = {};
            c || (d.top = a.top, d.bottom = a.top + a.height);
            b || (d.left = a.left, d.right = a.left + a.width);
            return d;
        }
        getPaddedContent_(a, b) {
            const c = b.top + b.height, d = b.left + b.width, e = a.width;
            a = a.height;
            const f = e / 2, g = a / 2;
            return {
                top: Math.min(b.top - g, c - a),
                bottom: Math.max(c + g, b.top + a),
                left: Math.min(b.left - f, d - e),
                right: Math.max(d + f, b.left + e)
            };
        }
        getScrollMetrics(a, b, c) {
            a = a ? this.workspace_.scale : 1;
            b = b || this.getViewMetrics(!1);
            var d = c || this.getContentMetrics();
            c = this.getComputedFixedEdges_(b);
            b = this.getPaddedContent_(b, d);
            d = void 0 !== c.top ? c.top : b.top;
            const e = void 0 !== c.left ? c.left : b.left;
            return {
                top: d / a,
                left: e / a,
                width: ((void 0 !== c.right ? c.right : b.right) - e) / a,
                height: ((void 0 !== c.bottom ? c.bottom : b.bottom) - d) / a
            };
        }
        getUiMetrics() {
            return {
                viewMetrics: this.getViewMetrics(),
                absoluteMetrics: this.getAbsoluteMetrics(),
                toolboxMetrics: this.getToolboxMetrics()
            };
        }
        getMetrics() {
            const a = this.getToolboxMetrics(), b = this.getFlyoutMetrics(!0), c = this.getSvgMetrics(), d = this.getAbsoluteMetrics(), e = this.getViewMetrics(), f = this.getContentMetrics(), g = this.getScrollMetrics(!1, e, f);
            return {
                contentHeight: f.height,
                contentWidth: f.width,
                contentTop: f.top,
                contentLeft: f.left,
                scrollHeight: g.height,
                scrollWidth: g.width,
                scrollTop: g.top,
                scrollLeft: g.left,
                viewHeight: e.height,
                viewWidth: e.width,
                viewTop: e.top,
                viewLeft: e.left,
                absoluteTop: d.top,
                absoluteLeft: d.left,
                svgHeight: c.height,
                svgWidth: c.width,
                toolboxWidth: a.width,
                toolboxHeight: a.height,
                toolboxPosition: a.position,
                flyoutWidth: b.width,
                flyoutHeight: b.height
            };
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.METRICS_MANAGER, DEFAULT$$module$build$src$core$registry, MetricsManager$$module$build$src$core$metrics_manager);
    var module$build$src$core$metrics_manager = {};
    module$build$src$core$metrics_manager.MetricsManager = MetricsManager$$module$build$src$core$metrics_manager;
    var FlyoutMetricsManager$$module$build$src$core$flyout_metrics_manager = class extends MetricsManager$$module$build$src$core$metrics_manager {
        constructor(a, b){
            super(a);
            this.flyout_ = b;
        }
        getBoundingBox_() {
            let a;
            try {
                a = this.workspace_.getCanvas().getBBox();
            } catch (b) {
                a = {
                    height: 0,
                    y: 0,
                    width: 0,
                    x: 0
                };
            }
            return a;
        }
        getContentMetrics(a) {
            const b = this.getBoundingBox_();
            a = a ? 1 : this.workspace_.scale;
            return {
                height: b.height * a,
                width: b.width * a,
                top: b.y * a,
                left: b.x * a
            };
        }
        getScrollMetrics(a, b, c) {
            b = c || this.getContentMetrics();
            c = this.flyout_.MARGIN * this.workspace_.scale;
            a = a ? this.workspace_.scale : 1;
            return {
                height: (b.height + 2 * c) / a,
                width: (b.width + b.left + c) / a,
                top: 0,
                left: 0
            };
        }
    }, module$build$src$core$flyout_metrics_manager = {};
    module$build$src$core$flyout_metrics_manager.FlyoutMetricsManager = FlyoutMetricsManager$$module$build$src$core$flyout_metrics_manager;
    var ScrollbarPair$$module$build$src$core$scrollbar_pair = class {
        constructor(a, b, c, d, e){
            this.workspace = a;
            this.oldHostMetrics_ = this.corner_ = this.vScroll = this.hScroll = null;
            b = void 0 === b ? !0 : b;
            c = void 0 === c ? !0 : c;
            const f = b && c;
            b && (this.hScroll = new Scrollbar$$module$build$src$core$scrollbar(a, !0, f, d, e));
            c && (this.vScroll = new Scrollbar$$module$build$src$core$scrollbar(a, !1, f, d, e));
            f && (this.corner_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                height: Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness,
                width: Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness,
                "class": "blocklyScrollbarBackground"
            }), insertAfter$$module$build$src$core$utils$dom(this.corner_, a.getBubbleCanvas()));
        }
        dispose() {
            removeNode$$module$build$src$core$utils$dom(this.corner_);
            this.oldHostMetrics_ = this.corner_ = null;
            this.hScroll && (this.hScroll.dispose(), this.hScroll = null);
            this.vScroll && (this.vScroll.dispose(), this.vScroll = null);
        }
        resize() {
            const a = this.workspace.getMetrics();
            if (a) {
                var b = !1, c = !1;
                this.oldHostMetrics_ && this.oldHostMetrics_.viewWidth === a.viewWidth && this.oldHostMetrics_.viewHeight === a.viewHeight && this.oldHostMetrics_.absoluteTop === a.absoluteTop && this.oldHostMetrics_.absoluteLeft === a.absoluteLeft ? (this.oldHostMetrics_ && this.oldHostMetrics_.scrollWidth === a.scrollWidth && this.oldHostMetrics_.viewLeft === a.viewLeft && this.oldHostMetrics_.scrollLeft === a.scrollLeft || (b = !0), this.oldHostMetrics_ && this.oldHostMetrics_.scrollHeight === a.scrollHeight && this.oldHostMetrics_.viewTop === a.viewTop && this.oldHostMetrics_.scrollTop === a.scrollTop || (c = !0)) : c = b = !0;
                if (b || c) {
                    try {
                        disable$$module$build$src$core$events$utils(), this.hScroll && b && this.hScroll.resize(a), this.vScroll && c && this.vScroll.resize(a);
                    } finally{
                        enable$$module$build$src$core$events$utils();
                    }
                    this.workspace.maybeFireViewportChangeEvent();
                }
                if (this.hScroll && this.vScroll) {
                    if (!this.oldHostMetrics_ || this.oldHostMetrics_.viewWidth !== a.viewWidth || this.oldHostMetrics_.absoluteLeft !== a.absoluteLeft) {
                        let d;
                        null == (d = this.corner_) || d.setAttribute("x", String(this.vScroll.position.x));
                    }
                    if (!this.oldHostMetrics_ || this.oldHostMetrics_.viewHeight !== a.viewHeight || this.oldHostMetrics_.absoluteTop !== a.absoluteTop) {
                        let d;
                        null == (d = this.corner_) || d.setAttribute("y", String(this.hScroll.position.y));
                    }
                }
                this.oldHostMetrics_ = a;
            }
        }
        canScrollHorizontally() {
            return !!this.hScroll;
        }
        canScrollVertically() {
            return !!this.vScroll;
        }
        setOrigin(a, b) {
            this.hScroll && this.hScroll.setOrigin(a, b);
            this.vScroll && this.vScroll.setOrigin(a, b);
        }
        set(a, b, c) {
            this.hScroll && this.hScroll.set(a, !1);
            this.vScroll && this.vScroll.set(b, !1);
            if (c || void 0 === c) a = {}, this.hScroll && (a.x = this.hScroll.getRatio_()), this.vScroll && (a.y = this.vScroll.getRatio_()), this.workspace.setMetrics(a);
        }
        setX(a) {
            this.hScroll && this.hScroll.set(a, !0);
        }
        setY(a) {
            this.vScroll && this.vScroll.set(a, !0);
        }
        setContainerVisible(a) {
            this.hScroll && this.hScroll.setContainerVisible(a);
            this.vScroll && this.vScroll.setContainerVisible(a);
        }
        isVisible() {
            let a = !1;
            this.hScroll && (a = this.hScroll.isVisible());
            this.vScroll && (a = a || this.vScroll.isVisible());
            return a;
        }
        resizeContent(a) {
            this.hScroll && this.hScroll.resizeContentHorizontal(a);
            this.vScroll && this.vScroll.resizeContentVertical(a);
        }
        resizeView(a) {
            this.hScroll && this.hScroll.resizeViewHorizontal(a);
            this.vScroll && this.vScroll.resizeViewVertical(a);
        }
    }, module$build$src$core$scrollbar_pair = {};
    module$build$src$core$scrollbar_pair.ScrollbarPair = ScrollbarPair$$module$build$src$core$scrollbar_pair;
    var WorkspaceDragger$$module$build$src$core$workspace_dragger = class {
        constructor(a){
            this.workspace = a;
            this.horizontalScrollEnabled_ = this.workspace.isMovableHorizontally();
            this.verticalScrollEnabled_ = this.workspace.isMovableVertically();
            this.startScrollXY_ = new Coordinate$$module$build$src$core$utils$coordinate(a.scrollX, a.scrollY);
        }
        dispose() {
            this.workspace = null;
        }
        startDrag() {
            getSelected$$module$build$src$core$common() && getSelected$$module$build$src$core$common().unselect();
            this.workspace.setupDragSurface();
        }
        endDrag(a) {
            this.drag(a);
            this.workspace.resetDragSurface();
        }
        drag(a) {
            a = Coordinate$$module$build$src$core$utils$coordinate.sum(this.startScrollXY_, a);
            if (this.horizontalScrollEnabled_ && this.verticalScrollEnabled_) this.workspace.scroll(a.x, a.y);
            else if (this.horizontalScrollEnabled_) this.workspace.scroll(a.x, this.workspace.scrollY);
            else if (this.verticalScrollEnabled_) this.workspace.scroll(this.workspace.scrollX, a.y);
            else throw new TypeError("Invalid state.");
        }
    }, module$build$src$core$workspace_dragger = {};
    module$build$src$core$workspace_dragger.WorkspaceDragger = WorkspaceDragger$$module$build$src$core$workspace_dragger;
    var ZOOM_IN_MULTIPLIER$$module$build$src$core$gesture = 5, ZOOM_OUT_MULTIPLIER$$module$build$src$core$gesture = 6, Gesture$$module$build$src$core$gesture = class {
        constructor(a, b){
            this.creatorWorkspace = b;
            this.mouseDownXY_ = new Coordinate$$module$build$src$core$utils$coordinate(0, 0);
            this.startWorkspace_ = this.targetBlock_ = this.startBlock_ = this.startField_ = this.startBubble_ = null;
            this.hasExceededDragRadius_ = !1;
            this.boundEvents = [];
            this.flyout_ = this.workspaceDragger_ = this.blockDragger_ = this.bubbleDragger_ = null;
            this.isMultiTouch_ = this.isEnding_ = this.hasStarted_ = this.calledUpdateIsDragging_ = !1;
            this.cachedPoints = new Map;
            this.startDistance_ = this.previousScale_ = 0;
            this.currentDropdownOwner = this.isPinchZoomEnabled_ = null;
            this.mostRecentEvent_ = a;
            this.currentDragDeltaXY_ = new Coordinate$$module$build$src$core$utils$coordinate(0, 0);
            this.healStack_ = !DRAG_STACK$$module$build$src$core$internal_constants;
        }
        dispose() {
            clearTouchIdentifier$$module$build$src$core$touch();
            unblock$$module$build$src$core$tooltip();
            this.creatorWorkspace.clearGesture();
            for (const a of this.boundEvents)unbind$$module$build$src$core$browser_events(a);
            this.boundEvents.length = 0;
            this.blockDragger_ && this.blockDragger_.dispose();
            this.workspaceDragger_ && this.workspaceDragger_.dispose();
        }
        updateFromEvent_(a) {
            const b = new Coordinate$$module$build$src$core$utils$coordinate(a.clientX, a.clientY);
            this.updateDragDelta_(b) && (this.updateIsDragging_(), longStop$$module$build$src$core$touch());
            this.mostRecentEvent_ = a;
        }
        updateDragDelta_(a) {
            this.currentDragDeltaXY_ = Coordinate$$module$build$src$core$utils$coordinate.difference(a, this.mouseDownXY_);
            return this.hasExceededDragRadius_ ? !1 : this.hasExceededDragRadius_ = Coordinate$$module$build$src$core$utils$coordinate.magnitude(this.currentDragDeltaXY_) > (this.flyout_ ? $.config$$module$build$src$core$config.flyoutDragRadius : $.config$$module$build$src$core$config.dragRadius);
        }
        updateIsDraggingFromFlyout_() {
            let a;
            if (!this.targetBlock_ || null == (a = this.flyout_) || !a.isBlockCreatable(this.targetBlock_)) return !1;
            if (!this.flyout_.targetWorkspace) throw Error("Cannot update dragging from the flyout because the ' +\n          'flyout's target workspace is undefined");
            return !this.flyout_.isScrollable() || this.flyout_.isDragTowardWorkspace(this.currentDragDeltaXY_) ? (this.startWorkspace_ = this.flyout_.targetWorkspace, this.startWorkspace_.updateScreenCalculationsIfScrolled(), getGroup$$module$build$src$core$events$utils() || setGroup$$module$build$src$core$events$utils(!0), this.startBlock_ = null, this.targetBlock_ = this.flyout_.createBlock(this.targetBlock_), this.targetBlock_.select(), !0) : !1;
        }
        updateIsDraggingBubble_() {
            if (!this.startBubble_) return !1;
            this.startDraggingBubble_();
            return !0;
        }
        updateIsDraggingBlock_() {
            if (!this.targetBlock_) return !1;
            if (this.flyout_) {
                if (this.updateIsDraggingFromFlyout_()) return this.startDraggingBlock_(), !0;
            } else if (this.targetBlock_.isMovable()) return this.startDraggingBlock_(), !0;
            return !1;
        }
        updateIsDraggingWorkspace_() {
            if (!this.startWorkspace_) throw Error("Cannot update dragging the workspace because the start workspace is undefined");
            if (this.flyout_ ? this.flyout_.isScrollable() : this.startWorkspace_ && this.startWorkspace_.isDraggable()) this.workspaceDragger_ = new WorkspaceDragger$$module$build$src$core$workspace_dragger(this.startWorkspace_), this.workspaceDragger_.startDrag();
        }
        updateIsDragging_() {
            if (this.calledUpdateIsDragging_) throw Error("updateIsDragging_ should only be called once per gesture.");
            this.calledUpdateIsDragging_ = !0;
            this.updateIsDraggingBubble_() || this.updateIsDraggingBlock_() || this.updateIsDraggingWorkspace_();
        }
        startDraggingBlock_() {
            this.blockDragger_ = new (getClassFromOptions$$module$build$src$core$registry(Type$$module$build$src$core$registry.BLOCK_DRAGGER, this.creatorWorkspace.options, !0))(this.targetBlock_, this.startWorkspace_);
            this.blockDragger_.startDrag(this.currentDragDeltaXY_, this.healStack_);
            this.blockDragger_.drag(this.mostRecentEvent_, this.currentDragDeltaXY_);
        }
        startDraggingBubble_() {
            if (!this.startBubble_) throw Error("Cannot update dragging the bubble because the start bubble is undefined");
            if (!this.startWorkspace_) throw Error("Cannot update dragging the bubble because the start workspace is undefined");
            this.bubbleDragger_ = new BubbleDragger$$module$build$src$core$bubble_dragger(this.startBubble_, this.startWorkspace_);
            this.bubbleDragger_.startBubbleDrag();
            this.bubbleDragger_.dragBubble(this.mostRecentEvent_, this.currentDragDeltaXY_);
        }
        doStart(a) {
            if (!this.startWorkspace_) throw Error("Cannot start the touch gesture becauase the start workspace is undefined");
            this.isPinchZoomEnabled_ = this.startWorkspace_.options.zoomOptions && this.startWorkspace_.options.zoomOptions.pinch;
            isTargetInput$$module$build$src$core$browser_events(a) ? this.cancel() : (this.hasStarted_ = !0, disconnectUiStop$$module$build$src$core$block_animations(), this.startWorkspace_.updateScreenCalculationsIfScrolled(), this.startWorkspace_.isMutator && this.startWorkspace_.resize(), this.currentDropdownOwner = getOwner$$module$build$src$core$dropdowndiv(), this.startWorkspace_.hideChaff(!!this.flyout_), this.startWorkspace_.markFocused(), this.mostRecentEvent_ = a, block$$module$build$src$core$tooltip(), this.targetBlock_ && this.targetBlock_.select(), isRightButton$$module$build$src$core$browser_events(a) ? this.handleRightClick(a) : ("pointerdown" === a.type.toLowerCase() && "mouse" !== a.pointerType && longStart$$module$build$src$core$touch(a, this), this.mouseDownXY_ = new Coordinate$$module$build$src$core$utils$coordinate(a.clientX, a.clientY), this.healStack_ = a.altKey || a.ctrlKey || a.metaKey, this.bindMouseEvents(a), this.isEnding_ || this.handleTouchStart(a)));
        }
        bindMouseEvents(a) {
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(document, "pointerdown", null, this.handleStart.bind(this), !0));
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(document, "pointermove", null, this.handleMove.bind(this), !0));
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(document, "pointerup", null, this.handleUp.bind(this), !0));
            a.preventDefault();
            a.stopPropagation();
        }
        handleStart(a) {
            this.isDragging() || (this.handleTouchStart(a), this.isMultiTouch() && longStop$$module$build$src$core$touch());
        }
        handleMove(a) {
            this.isDragging() && shouldHandleEvent$$module$build$src$core$touch(a) || !this.isMultiTouch() ? (this.updateFromEvent_(a), this.workspaceDragger_ ? this.workspaceDragger_.drag(this.currentDragDeltaXY_) : this.blockDragger_ ? this.blockDragger_.drag(this.mostRecentEvent_, this.currentDragDeltaXY_) : this.bubbleDragger_ && this.bubbleDragger_.dragBubble(this.mostRecentEvent_, this.currentDragDeltaXY_), a.preventDefault(), a.stopPropagation()) : this.isMultiTouch() && (this.handleTouchMove(a), longStop$$module$build$src$core$touch());
        }
        handleUp(a) {
            this.isDragging() || this.handleTouchEnd(a);
            if (!this.isMultiTouch() || this.isDragging()) {
                if (!shouldHandleEvent$$module$build$src$core$touch(a)) return;
                this.updateFromEvent_(a);
                longStop$$module$build$src$core$touch();
                if (this.isEnding_) {
                    console.log("Trying to end a gesture recursively.");
                    return;
                }
                this.isEnding_ = !0;
                this.bubbleDragger_ ? this.bubbleDragger_.endBubbleDrag(a, this.currentDragDeltaXY_) : this.blockDragger_ ? this.blockDragger_.endDrag(a, this.currentDragDeltaXY_) : this.workspaceDragger_ ? this.workspaceDragger_.endDrag(this.currentDragDeltaXY_) : this.isBubbleClick_() ? this.doBubbleClick_() : this.isFieldClick_() ? this.doFieldClick_() : this.isBlockClick_() ? this.doBlockClick_() : this.isWorkspaceClick_() && this.doWorkspaceClick_(a);
            }
            a.preventDefault();
            a.stopPropagation();
            this.dispose();
        }
        handleTouchStart(a) {
            var b = getTouchIdentifierFromEvent$$module$build$src$core$touch(a);
            this.cachedPoints.set(b, this.getTouchPoint(a));
            var c = Array.from(this.cachedPoints.keys());
            2 === c.length && (b = this.cachedPoints.get(c[0]), c = this.cachedPoints.get(c[1]), this.startDistance_ = Coordinate$$module$build$src$core$utils$coordinate.distance(b, c), this.isMultiTouch_ = !0, a.preventDefault());
        }
        handleTouchMove(a) {
            const b = getTouchIdentifierFromEvent$$module$build$src$core$touch(a);
            this.cachedPoints.set(b, this.getTouchPoint(a));
            this.isPinchZoomEnabled_ && 2 === this.cachedPoints.size ? this.handlePinch_(a) : this.handleMove(a);
        }
        handlePinch_(a) {
            var b = Array.from(this.cachedPoints.keys()), c = this.cachedPoints.get(b[0]);
            b = this.cachedPoints.get(b[1]);
            c = Coordinate$$module$build$src$core$utils$coordinate.distance(c, b) / this.startDistance_;
            if (0 < this.previousScale_ && Infinity > this.previousScale_) {
                b = c - this.previousScale_;
                b = 0 < b ? b * ZOOM_IN_MULTIPLIER$$module$build$src$core$gesture : b * ZOOM_OUT_MULTIPLIER$$module$build$src$core$gesture;
                if (!this.startWorkspace_) throw Error("Cannot handle a pinch because the start workspace is undefined");
                const d = this.startWorkspace_, e = mouseToSvg$$module$build$src$core$browser_events(a, d.getParentSvg(), d.getInverseScreenCTM());
                d.zoom(e.x, e.y, b);
            }
            this.previousScale_ = c;
            a.preventDefault();
        }
        handleTouchEnd(a) {
            a = getTouchIdentifierFromEvent$$module$build$src$core$touch(a);
            this.cachedPoints.has(a) && this.cachedPoints.delete(a);
            2 > this.cachedPoints.size && (this.cachedPoints.clear(), this.previousScale_ = 0);
        }
        getTouchPoint(a) {
            return this.startWorkspace_ ? new Coordinate$$module$build$src$core$utils$coordinate(a.pageX, a.pageY) : null;
        }
        isMultiTouch() {
            return this.isMultiTouch_;
        }
        cancel() {
            this.isEnding_ || (longStop$$module$build$src$core$touch(), this.bubbleDragger_ ? this.bubbleDragger_.endBubbleDrag(this.mostRecentEvent_, this.currentDragDeltaXY_) : this.blockDragger_ ? this.blockDragger_.endDrag(this.mostRecentEvent_, this.currentDragDeltaXY_) : this.workspaceDragger_ && this.workspaceDragger_.endDrag(this.currentDragDeltaXY_), this.dispose());
        }
        handleRightClick(a) {
            this.targetBlock_ ? (this.bringBlockToFront_(), this.targetBlock_.workspace.hideChaff(!!this.flyout_), this.targetBlock_.showContextMenu(a)) : this.startBubble_ ? this.startBubble_.showContextMenu(a) : this.startWorkspace_ && !this.flyout_ && (this.startWorkspace_.hideChaff(), this.startWorkspace_.showContextMenu(a));
            a.preventDefault();
            a.stopPropagation();
            this.dispose();
        }
        handleWsStart(a, b) {
            if (this.hasStarted_) throw Error("Tried to call gesture.handleWsStart, but the gesture had already been started.");
            this.setStartWorkspace_(b);
            this.mostRecentEvent_ = a;
            this.doStart(a);
        }
        fireWorkspaceClick_(a) {
            fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(CLICK$$module$build$src$core$events$utils))(null, a.id, "workspace"));
        }
        handleFlyoutStart(a, b) {
            if (this.hasStarted_) throw Error("Tried to call gesture.handleFlyoutStart, but the gesture had already been started.");
            this.setStartFlyout_(b);
            this.handleWsStart(a, b.getWorkspace());
        }
        handleBlockStart(a, b) {
            if (this.hasStarted_) throw Error("Tried to call gesture.handleBlockStart, but the gesture had already been started.");
            this.setStartBlock(b);
            this.mostRecentEvent_ = a;
        }
        handleBubbleStart(a, b) {
            if (this.hasStarted_) throw Error("Tried to call gesture.handleBubbleStart, but the gesture had already been started.");
            this.setStartBubble(b);
            this.mostRecentEvent_ = a;
        }
        doBubbleClick_() {
            this.startBubble_ instanceof WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg && (this.startBubble_.setFocus(), this.startBubble_.select());
        }
        doFieldClick_() {
            if (!this.startField_) throw Error("Cannot do a field click because the start field is undefined");
            this.currentDropdownOwner !== this.startField_ && this.startField_.showEditor(this.mostRecentEvent_);
            this.bringBlockToFront_();
        }
        doBlockClick_() {
            if (this.flyout_ && this.flyout_.autoClose) {
                if (!this.targetBlock_) throw Error("Cannot do a block click because the target block is undefined");
                this.targetBlock_.isEnabled() && (getGroup$$module$build$src$core$events$utils() || setGroup$$module$build$src$core$events$utils(!0), this.flyout_.createBlock(this.targetBlock_).scheduleSnapAndBump());
            } else {
                if (!this.startWorkspace_) throw Error("Cannot do a block click because the start workspace is undefined");
                const a = new (get$$module$build$src$core$events$utils(CLICK$$module$build$src$core$events$utils))(this.startBlock_, this.startWorkspace_.id, "block");
                fire$$module$build$src$core$events$utils(a);
            }
            this.bringBlockToFront_();
            setGroup$$module$build$src$core$events$utils(!1);
        }
        doWorkspaceClick_(a) {
            a = this.creatorWorkspace;
            getSelected$$module$build$src$core$common() && getSelected$$module$build$src$core$common().unselect();
            this.fireWorkspaceClick_(this.startWorkspace_ || a);
        }
        bringBlockToFront_() {
            this.targetBlock_ && !this.flyout_ && this.targetBlock_.bringToFront();
        }
        setStartField(a) {
            if (this.hasStarted_) throw Error("Tried to call gesture.setStartField, but the gesture had already been started.");
            this.startField_ || (this.startField_ = a);
        }
        setStartBubble(a) {
            this.startBubble_ || (this.startBubble_ = a);
        }
        setStartBlock(a) {
            this.startBlock_ || this.startBubble_ || (this.startBlock_ = a, a.isInFlyout && a !== a.getRootBlock() ? this.setTargetBlock_(a.getRootBlock()) : this.setTargetBlock_(a));
        }
        setTargetBlock_(a) {
            a.isShadow() ? this.setTargetBlock_(a.getParent()) : this.targetBlock_ = a;
        }
        setStartWorkspace_(a) {
            this.startWorkspace_ || (this.startWorkspace_ = a);
        }
        setStartFlyout_(a) {
            this.flyout_ || (this.flyout_ = a);
        }
        isBubbleClick_() {
            return !!this.startBubble_ && !this.hasExceededDragRadius_;
        }
        isBlockClick_() {
            return !!this.startBlock_ && !this.hasExceededDragRadius_ && !this.isFieldClick_();
        }
        isFieldClick_() {
            return (this.startField_ ? this.startField_.isClickable() : !1) && !this.hasExceededDragRadius_ && (!this.flyout_ || !this.flyout_.autoClose);
        }
        isWorkspaceClick_() {
            return !this.startBlock_ && !this.startBubble_ && !this.startField_ && !this.hasExceededDragRadius_;
        }
        isDragging() {
            return !!this.workspaceDragger_ || !!this.blockDragger_ || !!this.bubbleDragger_;
        }
        hasStarted() {
            return this.hasStarted_;
        }
        getInsertionMarkers() {
            return this.blockDragger_ ? this.blockDragger_.getInsertionMarkers() : [];
        }
        getCurrentDragger() {
            let a, b;
            return null != (b = null != (a = this.blockDragger_) ? a : this.workspaceDragger_) ? b : this.bubbleDragger_;
        }
        static inProgress() {
            const a = getAllWorkspaces$$module$build$src$core$common();
            for(let b = 0, c; c = a[b]; b++)if (c.currentGesture_) return !0;
            return !1;
        }
    }, module$build$src$core$gesture = {};
    module$build$src$core$gesture.Gesture = Gesture$$module$build$src$core$gesture;
    var Grid$$module$build$src$core$grid = class {
        constructor(a, b){
            this.pattern = a;
            let c;
            this.spacing = null != (c = b.spacing) ? c : 0;
            let d;
            this.length = null != (d = b.length) ? d : 1;
            this.line2 = (this.line1 = a.firstChild) && this.line1.nextSibling;
            let e;
            this.snapToGrid = null != (e = b.snap) ? e : !1;
        }
        shouldSnap() {
            return this.snapToGrid;
        }
        getSpacing() {
            return this.spacing;
        }
        getPatternId() {
            return this.pattern.id;
        }
        update(a) {
            var b = this.spacing * a;
            this.pattern.setAttribute("width", `${b}`);
            this.pattern.setAttribute("height", `${b}`);
            b = Math.floor(this.spacing / 2) + .5;
            let c = b - this.length / 2, d = b + this.length / 2;
            b *= a;
            c *= a;
            d *= a;
            this.setLineAttributes(this.line1, a, c, d, b, b);
            this.setLineAttributes(this.line2, a, b, b, c, d);
        }
        setLineAttributes(a, b, c, d, e, f) {
            a && (a.setAttribute("stroke-width", `${b}`), a.setAttribute("x1", `${c}`), a.setAttribute("y1", `${e}`), a.setAttribute("x2", `${d}`), a.setAttribute("y2", `${f}`));
        }
        moveTo(a, b) {
            this.pattern.setAttribute("x", `${a}`);
            this.pattern.setAttribute("y", `${b}`);
        }
        static createDom(a, b, c) {
            a = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATTERN, {
                id: "blocklyGridPattern" + a,
                patternUnits: "userSpaceOnUse"
            }, c);
            let d, e;
            if (0 < (null != (d = b.length) ? d : 1) && 0 < (null != (e = b.spacing) ? e : 0)) {
                createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.LINE, {
                    stroke: b.colour
                }, a);
                let f;
                null != (f = b.length) && f && createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.LINE, {
                    stroke: b.colour
                }, a);
            } else createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.LINE, {}, a);
            return a;
        }
    }, module$build$src$core$grid = {};
    module$build$src$core$grid.Grid = Grid$$module$build$src$core$grid;
    var Names$$module$build$src$core$names = class {
        constructor(a, b){
            this.db = new Map;
            this.dbReverse = new Set;
            this.variableMap_ = null;
            this.variablePrefix_ = b || "";
            this.reservedWords = new Set(a ? a.split(",") : []);
        }
        reset() {
            this.db.clear();
            this.dbReverse.clear();
            this.variableMap_ = null;
        }
        setVariableMap(a) {
            this.variableMap_ = a;
        }
        getNameForUserVariable_(a) {
            return this.variableMap_ ? (a = this.variableMap_.getVariableById(a)) ? a.name : null : (console.warn("Deprecated call to Names.prototype.getName without defining a variable map. To fix, add the following code in your generator's init() function:\nBlockly.YourGeneratorName.nameDB_.setVariableMap(workspace.getVariableMap());"), null);
        }
        populateVariables(a) {
            a = allUsedVarModels$$module$build$src$core$variables(a);
            for(let b = 0; b < a.length; b++)this.getName(a[b].getId(), $.NameType$$module$build$src$core$names.VARIABLE);
        }
        populateProcedures(a) {
            throw Error("The implementation of populateProcedures should be monkey-patched in by blockly.ts");
        }
        getName(a, b) {
            let c = a;
            b === $.NameType$$module$build$src$core$names.VARIABLE && (a = this.getNameForUserVariable_(a)) && (c = a);
            a = c.toLowerCase();
            const d = b === $.NameType$$module$build$src$core$names.VARIABLE || b === $.NameType$$module$build$src$core$names.DEVELOPER_VARIABLE ? this.variablePrefix_ : "";
            this.db.has(b) || this.db.set(b, new Map);
            const e = this.db.get(b);
            if (e.has(a)) return d + e.get(a);
            b = this.getDistinctName(c, b);
            e.set(a, b.substr(d.length));
            return b;
        }
        getUserNames(a) {
            let b;
            return (a = null == (b = this.db.get(a)) ? void 0 : b.keys()) ? Array.from(a) : [];
        }
        getDistinctName(a, b) {
            a = this.safeName_(a);
            let c = null, d, e;
            for(; this.dbReverse.has(a + (null != (d = c) ? d : "")) || this.reservedWords.has(a + (null != (e = c) ? e : ""));)c = c ? c + 1 : 2;
            let f;
            a += null != (f = c) ? f : "";
            this.dbReverse.add(a);
            return (b === $.NameType$$module$build$src$core$names.VARIABLE || b === $.NameType$$module$build$src$core$names.DEVELOPER_VARIABLE ? this.variablePrefix_ : "") + a;
        }
        safeName_(a) {
            a ? (a = encodeURI(a.replace(/ /g, "_")).replace(/[^\w]/g, "_"), -1 !== "0123456789".indexOf(a[0]) && (a = "my_" + a)) : a = Msg$$module$build$src$core$msg.UNNAMED_KEY || "unnamed";
            return a;
        }
        static equals(a, b) {
            return a.toLowerCase() === b.toLowerCase();
        }
    };
    (function(a) {
        a = a.NameType || (a.NameType = {});
        a.DEVELOPER_VARIABLE = "DEVELOPER_VARIABLE";
        a.VARIABLE = "VARIABLE";
        a.PROCEDURE = "PROCEDURE";
    })(Names$$module$build$src$core$names || (Names$$module$build$src$core$names = {}));
    $.NameType$$module$build$src$core$names = Names$$module$build$src$core$names.NameType;
    Names$$module$build$src$core$names.DEVELOPER_VARIABLE_TYPE = $.NameType$$module$build$src$core$names.DEVELOPER_VARIABLE;
    $.module$build$src$core$names = {};
    $.module$build$src$core$names.NameType = $.NameType$$module$build$src$core$names;
    $.module$build$src$core$names.Names = Names$$module$build$src$core$names;
    var module$build$src$core$interfaces$i_procedure_block = {};
    module$build$src$core$interfaces$i_procedure_block.isProcedureBlock = isProcedureBlock$$module$build$src$core$interfaces$i_procedure_block;
    var module$build$src$core$interfaces$i_observable = {};
    module$build$src$core$interfaces$i_observable.isObservable = isObservable$$module$build$src$core$interfaces$i_observable;
    var ObservableProcedureMap$$module$build$src$core$observable_procedure_map = class extends Map {
        constructor(){
            super();
        }
        set(a, b) {
            if (this.get(a) === b) return this;
            super.set(a, b);
            isObservable$$module$build$src$core$interfaces$i_observable(b) && b.startPublishing();
            return this;
        }
        delete(a) {
            const b = this.get(a);
            a = super.delete(a);
            if (!a) return a;
            isObservable$$module$build$src$core$interfaces$i_observable(b) && b.stopPublishing();
            return a;
        }
        clear() {
            if (this.size) for (const a of this.keys())this.delete(a);
        }
        add(a) {
            return this.set(a.getId(), a);
        }
        getProcedures() {
            return [
                ...this.values()
            ];
        }
    }, module$build$src$core$observable_procedure_map = {};
    module$build$src$core$observable_procedure_map.ObservableProcedureMap = ObservableProcedureMap$$module$build$src$core$observable_procedure_map;
    var CATEGORY_NAME$$module$build$src$core$procedures, DEFAULT_ARG$$module$build$src$core$procedures;
    CATEGORY_NAME$$module$build$src$core$procedures = "PROCEDURE";
    DEFAULT_ARG$$module$build$src$core$procedures = "x";
    $.module$build$src$core$procedures = {};
    $.module$build$src$core$procedures.CATEGORY_NAME = CATEGORY_NAME$$module$build$src$core$procedures;
    $.module$build$src$core$procedures.DEFAULT_ARG = DEFAULT_ARG$$module$build$src$core$procedures;
    $.module$build$src$core$procedures.ObservableProcedureMap = ObservableProcedureMap$$module$build$src$core$observable_procedure_map;
    $.module$build$src$core$procedures.allProcedures = allProcedures$$module$build$src$core$procedures;
    $.module$build$src$core$procedures.findLegalName = findLegalName$$module$build$src$core$procedures;
    $.module$build$src$core$procedures.flyoutCategory = flyoutCategory$$module$build$src$core$procedures;
    $.module$build$src$core$procedures.getCallers = getCallers$$module$build$src$core$procedures;
    $.module$build$src$core$procedures.getDefinition = getDefinition$$module$build$src$core$procedures;
    $.module$build$src$core$procedures.isNameUsed = isNameUsed$$module$build$src$core$procedures;
    $.module$build$src$core$procedures.isProcedureBlock = isProcedureBlock$$module$build$src$core$interfaces$i_procedure_block;
    $.module$build$src$core$procedures.mutateCallers = mutateCallers$$module$build$src$core$procedures;
    $.module$build$src$core$procedures.mutatorOpenListener = mutatorOpenListener$$module$build$src$core$procedures;
    $.module$build$src$core$procedures.rename = rename$$module$build$src$core$procedures;
    var TypesContainer$$module$build$src$core$renderers$measurables$types = class {
        constructor(){
            this.NONE = 0;
            this.FIELD = 1;
            this.HAT = 2;
            this.ICON = 4;
            this.SPACER = 8;
            this.BETWEEN_ROW_SPACER = 16;
            this.IN_ROW_SPACER = 32;
            this.EXTERNAL_VALUE_INPUT = 64;
            this.INPUT = 128;
            this.INLINE_INPUT = 256;
            this.STATEMENT_INPUT = 512;
            this.CONNECTION = 1024;
            this.PREVIOUS_CONNECTION = 2048;
            this.NEXT_CONNECTION = 4096;
            this.OUTPUT_CONNECTION = 8192;
            this.CORNER = 16384;
            this.LEFT_SQUARE_CORNER = 32768;
            this.LEFT_ROUND_CORNER = 65536;
            this.RIGHT_SQUARE_CORNER = 131072;
            this.RIGHT_ROUND_CORNER = 262144;
            this.JAGGED_EDGE = 524288;
            this.ROW = 1048576;
            this.TOP_ROW = 2097152;
            this.BOTTOM_ROW = 4194304;
            this.INPUT_ROW = 8388608;
            this.LEFT_CORNER = this.LEFT_SQUARE_CORNER | this.LEFT_ROUND_CORNER;
            this.RIGHT_CORNER = this.RIGHT_SQUARE_CORNER | this.RIGHT_ROUND_CORNER;
            this.nextTypeValue_ = 16777216;
        }
        getType(a) {
            Object.prototype.hasOwnProperty.call(this, a) || (this[a] = this.nextTypeValue_, this.nextTypeValue_ <<= 1);
            return this[a];
        }
        isField(a) {
            return a.type & this.FIELD;
        }
        isHat(a) {
            return a.type & this.HAT;
        }
        isIcon(a) {
            return a.type & this.ICON;
        }
        isSpacer(a) {
            return a.type & this.SPACER;
        }
        isInRowSpacer(a) {
            return a.type & this.IN_ROW_SPACER;
        }
        isInput(a) {
            return a.type & this.INPUT;
        }
        isExternalInput(a) {
            return a.type & this.EXTERNAL_VALUE_INPUT;
        }
        isInlineInput(a) {
            return a.type & this.INLINE_INPUT;
        }
        isStatementInput(a) {
            return a.type & this.STATEMENT_INPUT;
        }
        isPreviousConnection(a) {
            return a.type & this.PREVIOUS_CONNECTION;
        }
        isNextConnection(a) {
            return a.type & this.NEXT_CONNECTION;
        }
        isPreviousOrNextConnection(a) {
            return a.type & (this.PREVIOUS_CONNECTION | this.NEXT_CONNECTION);
        }
        isLeftRoundedCorner(a) {
            return a.type & this.LEFT_ROUND_CORNER;
        }
        isRightRoundedCorner(a) {
            return a.type & this.RIGHT_ROUND_CORNER;
        }
        isLeftSquareCorner(a) {
            return a.type & this.LEFT_SQUARE_CORNER;
        }
        isRightSquareCorner(a) {
            return a.type & this.RIGHT_SQUARE_CORNER;
        }
        isCorner(a) {
            return a.type & this.CORNER;
        }
        isJaggedEdge(a) {
            return a.type & this.JAGGED_EDGE;
        }
        isRow(a) {
            return a.type & this.ROW;
        }
        isBetweenRowSpacer(a) {
            return a.type & this.BETWEEN_ROW_SPACER;
        }
        isTopRow(a) {
            return a.type & this.TOP_ROW;
        }
        isBottomRow(a) {
            return a.type & this.BOTTOM_ROW;
        }
        isTopOrBottomRow(a) {
            return a.type & (this.TOP_ROW | this.BOTTOM_ROW);
        }
        isInputRow(a) {
            return a.type & this.INPUT_ROW;
        }
    }, Types$$module$build$src$core$renderers$measurables$types = new TypesContainer$$module$build$src$core$renderers$measurables$types, module$build$src$core$renderers$measurables$types = {};
    module$build$src$core$renderers$measurables$types.Types = Types$$module$build$src$core$renderers$measurables$types;
    var Measurable$$module$build$src$core$renderers$measurables$base = class {
        constructor(a){
            this.centerline = this.xPos = this.height = this.width = 0;
            this.constants_ = a;
            this.type = Types$$module$build$src$core$renderers$measurables$types.NONE;
            this.notchOffset = this.constants_.NOTCH_OFFSET_LEFT;
        }
    }, module$build$src$core$renderers$measurables$base = {};
    module$build$src$core$renderers$measurables$base.Measurable = Measurable$$module$build$src$core$renderers$measurables$base;
    var Row$$module$build$src$core$renderers$measurables$row = class {
        constructor(a){
            this.elements = [];
            this.xPos = this.yPos = this.widthWithConnectedBlocks = this.minWidth = this.minHeight = this.width = this.height = 0;
            this.hasStatement = this.hasExternalInput = !1;
            this.statementEdge = 0;
            this.hasJaggedEdge = this.hasDummyInput = this.hasInlineInput = !1;
            this.align = null;
            this.constants_ = a;
            this.type = Types$$module$build$src$core$renderers$measurables$types.ROW;
            this.notchOffset = this.constants_.NOTCH_OFFSET_LEFT;
        }
        getLastInput() {
            for(let a = this.elements.length - 1; 0 <= a; a--){
                const b = this.elements[a];
                if (Types$$module$build$src$core$renderers$measurables$types.isInput(b)) return b;
            }
            return null;
        }
        measure() {
            throw Error("Unexpected attempt to measure a base Row.");
        }
        startsWithElemSpacer() {
            return !0;
        }
        endsWithElemSpacer() {
            return !0;
        }
        getFirstSpacer() {
            for(let a = 0; a < this.elements.length; a++){
                const b = this.elements[a];
                if (Types$$module$build$src$core$renderers$measurables$types.isSpacer(b)) return b;
            }
            return null;
        }
        getLastSpacer() {
            for(let a = this.elements.length - 1; 0 <= a; a--){
                const b = this.elements[a];
                if (Types$$module$build$src$core$renderers$measurables$types.isSpacer(b)) return b;
            }
            return null;
        }
    }, module$build$src$core$renderers$measurables$row = {};
    module$build$src$core$renderers$measurables$row.Row = Row$$module$build$src$core$renderers$measurables$row;
    var BottomRow$$module$build$src$core$renderers$measurables$bottom_row = class extends Row$$module$build$src$core$renderers$measurables$row {
        constructor(a){
            super(a);
            this.hasNextConnection = !1;
            this.connection = null;
            this.baseline = this.descenderHeight = 0;
            this.type |= Types$$module$build$src$core$renderers$measurables$types.BOTTOM_ROW;
        }
        hasLeftSquareCorner(a) {
            return !!a.outputConnection || !!a.getNextBlock();
        }
        hasRightSquareCorner(a) {
            return !0;
        }
        measure() {
            let a = 0, b = 0, c = 0;
            for(let d = 0; d < this.elements.length; d++){
                const e = this.elements[d];
                b += e.width;
                Types$$module$build$src$core$renderers$measurables$types.isSpacer(e) || (Types$$module$build$src$core$renderers$measurables$types.isNextConnection(e) ? c = Math.max(c, e.height) : a = Math.max(a, e.height));
            }
            this.width = Math.max(this.minWidth, b);
            this.height = Math.max(this.minHeight, a) + c;
            this.descenderHeight = c;
            this.widthWithConnectedBlocks = this.width;
        }
        startsWithElemSpacer() {
            return !1;
        }
        endsWithElemSpacer() {
            return !1;
        }
    }, module$build$src$core$renderers$measurables$bottom_row = {};
    module$build$src$core$renderers$measurables$bottom_row.BottomRow = BottomRow$$module$build$src$core$renderers$measurables$bottom_row;
    var Connection$$module$build$src$core$renderers$measurables$connection = class extends Measurable$$module$build$src$core$renderers$measurables$base {
        constructor(a, b){
            super(a);
            this.connectionModel = b;
            this.shape = this.constants_.shapeFor(b);
            this.isDynamicShape = "isDynamic" in this.shape && this.shape.isDynamic;
            this.type |= Types$$module$build$src$core$renderers$measurables$types.CONNECTION;
        }
    }, module$build$src$core$renderers$measurables$connection = {};
    module$build$src$core$renderers$measurables$connection.Connection = Connection$$module$build$src$core$renderers$measurables$connection;
    var InputConnection$$module$build$src$core$renderers$measurables$input_connection = class extends Connection$$module$build$src$core$renderers$measurables$connection {
        constructor(a, b){
            super(a, b.connection);
            this.input = b;
            this.connectionOffsetY = this.connectionOffsetX = 0;
            this.type |= Types$$module$build$src$core$renderers$measurables$types.INPUT;
            this.align = b.align;
            (this.connectedBlock = b.connection && b.connection.targetBlock() ? b.connection.targetBlock() : null) ? (a = this.connectedBlock.getHeightWidth(), this.connectedBlockWidth = a.width, this.connectedBlockHeight = a.height) : this.connectedBlockHeight = this.connectedBlockWidth = 0;
        }
    }, module$build$src$core$renderers$measurables$input_connection = {};
    module$build$src$core$renderers$measurables$input_connection.InputConnection = InputConnection$$module$build$src$core$renderers$measurables$input_connection;
    var ExternalValueInput$$module$build$src$core$renderers$measurables$external_value_input = class extends InputConnection$$module$build$src$core$renderers$measurables$input_connection {
        constructor(a, b){
            super(a, b);
            this.height = 0;
            this.type |= Types$$module$build$src$core$renderers$measurables$types.EXTERNAL_VALUE_INPUT;
            this.height = this.connectedBlock ? this.connectedBlockHeight - this.constants_.TAB_OFFSET_FROM_TOP - this.constants_.MEDIUM_PADDING : this.shape.height;
            this.width = this.shape.width + this.constants_.EXTERNAL_VALUE_INPUT_PADDING;
            this.connectionOffsetY = this.constants_.TAB_OFFSET_FROM_TOP;
            this.connectionHeight = this.shape.height;
            this.connectionWidth = this.shape.width;
        }
    }, module$build$src$core$renderers$measurables$external_value_input = {};
    module$build$src$core$renderers$measurables$external_value_input.ExternalValueInput = ExternalValueInput$$module$build$src$core$renderers$measurables$external_value_input;
    var Field$$module$build$src$core$renderers$measurables$field = class extends Measurable$$module$build$src$core$renderers$measurables$base {
        constructor(a, b, c){
            super(a);
            this.field = b;
            this.parentInput = c;
            this.isEditable = b.EDITABLE;
            this.flipRtl = b.getFlipRtl();
            this.type |= Types$$module$build$src$core$renderers$measurables$types.FIELD;
            a = this.field.getSize();
            this.height = a.height;
            this.width = a.width;
        }
    }, module$build$src$core$renderers$measurables$field = {};
    module$build$src$core$renderers$measurables$field.Field = Field$$module$build$src$core$renderers$measurables$field;
    var Hat$$module$build$src$core$renderers$measurables$hat = class extends Measurable$$module$build$src$core$renderers$measurables$base {
        constructor(a){
            super(a);
            this.type |= Types$$module$build$src$core$renderers$measurables$types.HAT;
            this.height = this.constants_.START_HAT.height;
            this.width = this.constants_.START_HAT.width;
            this.ascenderHeight = this.height;
        }
    }, module$build$src$core$renderers$measurables$hat = {};
    module$build$src$core$renderers$measurables$hat.Hat = Hat$$module$build$src$core$renderers$measurables$hat;
    var Icon$$module$build$src$core$renderers$measurables$icon = class extends Measurable$$module$build$src$core$renderers$measurables$base {
        constructor(a, b){
            super(a);
            this.icon = b;
            this.flipRtl = !1;
            this.isVisible = b.isVisible();
            this.type |= Types$$module$build$src$core$renderers$measurables$types.ICON;
            a = b.getCorrectedSize();
            this.height = a.height;
            this.width = a.width;
        }
    }, module$build$src$core$renderers$measurables$icon = {};
    module$build$src$core$renderers$measurables$icon.Icon = Icon$$module$build$src$core$renderers$measurables$icon;
    var InRowSpacer$$module$build$src$core$renderers$measurables$in_row_spacer = class extends Measurable$$module$build$src$core$renderers$measurables$base {
        constructor(a, b){
            super(a);
            this.type = this.type | Types$$module$build$src$core$renderers$measurables$types.SPACER | Types$$module$build$src$core$renderers$measurables$types.IN_ROW_SPACER;
            this.width = b;
            this.height = this.constants_.SPACER_DEFAULT_HEIGHT;
        }
    }, module$build$src$core$renderers$measurables$in_row_spacer = {};
    module$build$src$core$renderers$measurables$in_row_spacer.InRowSpacer = InRowSpacer$$module$build$src$core$renderers$measurables$in_row_spacer;
    var InlineInput$$module$build$src$core$renderers$measurables$inline_input = class extends InputConnection$$module$build$src$core$renderers$measurables$input_connection {
        constructor(a, b){
            super(a, b);
            this.type |= Types$$module$build$src$core$renderers$measurables$types.INLINE_INPUT;
            this.connectedBlock ? (this.width = this.connectedBlockWidth, this.height = this.connectedBlockHeight) : (this.height = this.constants_.EMPTY_INLINE_INPUT_HEIGHT, this.width = this.constants_.EMPTY_INLINE_INPUT_PADDING);
            this.connectionHeight = this.isDynamicShape ? this.shape.height(this.height) : this.shape.height;
            this.connectionWidth = this.isDynamicShape ? this.shape.width(this.height) : this.shape.width;
            this.connectedBlock || (this.width += this.connectionWidth * (this.isDynamicShape ? 2 : 1));
            this.connectionOffsetY = "connectionOffsetY" in this.shape ? this.shape.connectionOffsetY(this.connectionHeight) : this.constants_.TAB_OFFSET_FROM_TOP;
            this.connectionOffsetX = "connectionOffsetX" in this.shape ? this.shape.connectionOffsetX(this.connectionWidth) : 0;
        }
    }, module$build$src$core$renderers$measurables$inline_input = {};
    module$build$src$core$renderers$measurables$inline_input.InlineInput = InlineInput$$module$build$src$core$renderers$measurables$inline_input;
    var StatementInput$$module$build$src$core$renderers$measurables$statement_input = class extends InputConnection$$module$build$src$core$renderers$measurables$input_connection {
        constructor(a, b){
            super(a, b);
            this.type |= Types$$module$build$src$core$renderers$measurables$types.STATEMENT_INPUT;
            this.height = this.connectedBlock ? this.connectedBlockHeight + this.constants_.STATEMENT_BOTTOM_SPACER : this.constants_.EMPTY_STATEMENT_INPUT_HEIGHT;
            this.width = this.constants_.STATEMENT_INPUT_NOTCH_OFFSET + this.shape.width;
        }
    }, module$build$src$core$renderers$measurables$statement_input = {};
    module$build$src$core$renderers$measurables$statement_input.StatementInput = StatementInput$$module$build$src$core$renderers$measurables$statement_input;
    var InputRow$$module$build$src$core$renderers$measurables$input_row = class extends Row$$module$build$src$core$renderers$measurables$row {
        constructor(a){
            super(a);
            this.connectedBlockWidths = 0;
            this.type |= Types$$module$build$src$core$renderers$measurables$types.INPUT_ROW;
        }
        measure() {
            this.width = this.minWidth;
            this.height = this.minHeight;
            let a = 0;
            for(let b = 0; b < this.elements.length; b++){
                const c = this.elements[b];
                this.width += c.width;
                Types$$module$build$src$core$renderers$measurables$types.isInput(c) && c instanceof InputConnection$$module$build$src$core$renderers$measurables$input_connection && (Types$$module$build$src$core$renderers$measurables$types.isStatementInput(c) && c instanceof StatementInput$$module$build$src$core$renderers$measurables$statement_input ? a += c.connectedBlockWidth : Types$$module$build$src$core$renderers$measurables$types.isExternalInput(c) && c instanceof ExternalValueInput$$module$build$src$core$renderers$measurables$external_value_input && 0 !== c.connectedBlockWidth && (a += c.connectedBlockWidth - c.connectionWidth));
                Types$$module$build$src$core$renderers$measurables$types.isSpacer(c) || (this.height = Math.max(this.height, c.height));
            }
            this.connectedBlockWidths = a;
            this.widthWithConnectedBlocks = this.width + a;
        }
        endsWithElemSpacer() {
            return !this.hasExternalInput && !this.hasStatement;
        }
    }, module$build$src$core$renderers$measurables$input_row = {};
    module$build$src$core$renderers$measurables$input_row.InputRow = InputRow$$module$build$src$core$renderers$measurables$input_row;
    var JaggedEdge$$module$build$src$core$renderers$measurables$jagged_edge = class extends Measurable$$module$build$src$core$renderers$measurables$base {
        constructor(a){
            super(a);
            this.type |= Types$$module$build$src$core$renderers$measurables$types.JAGGED_EDGE;
            this.height = this.constants_.JAGGED_TEETH.height;
            this.width = this.constants_.JAGGED_TEETH.width;
        }
    }, module$build$src$core$renderers$measurables$jagged_edge = {};
    module$build$src$core$renderers$measurables$jagged_edge.JaggedEdge = JaggedEdge$$module$build$src$core$renderers$measurables$jagged_edge;
    var NextConnection$$module$build$src$core$renderers$measurables$next_connection = class extends Connection$$module$build$src$core$renderers$measurables$connection {
        constructor(a, b){
            super(a, b);
            this.type |= Types$$module$build$src$core$renderers$measurables$types.NEXT_CONNECTION;
            this.height = this.shape.height;
            this.width = this.shape.width;
        }
    }, module$build$src$core$renderers$measurables$next_connection = {};
    module$build$src$core$renderers$measurables$next_connection.NextConnection = NextConnection$$module$build$src$core$renderers$measurables$next_connection;
    var OutputConnection$$module$build$src$core$renderers$measurables$output_connection = class extends Connection$$module$build$src$core$renderers$measurables$connection {
        constructor(a, b){
            super(a, b);
            this.connectionOffsetX = 0;
            this.type |= Types$$module$build$src$core$renderers$measurables$types.OUTPUT_CONNECTION;
            this.height = this.isDynamicShape ? 0 : this.shape.height;
            this.startX = this.width = this.isDynamicShape ? 0 : this.shape.width;
            this.connectionOffsetY = this.constants_.TAB_OFFSET_FROM_TOP;
        }
    }, module$build$src$core$renderers$measurables$output_connection = {};
    module$build$src$core$renderers$measurables$output_connection.OutputConnection = OutputConnection$$module$build$src$core$renderers$measurables$output_connection;
    var PreviousConnection$$module$build$src$core$renderers$measurables$previous_connection = class extends Connection$$module$build$src$core$renderers$measurables$connection {
        constructor(a, b){
            super(a, b);
            this.type |= Types$$module$build$src$core$renderers$measurables$types.PREVIOUS_CONNECTION;
            this.height = this.shape.height;
            this.width = this.shape.width;
        }
    }, module$build$src$core$renderers$measurables$previous_connection = {};
    module$build$src$core$renderers$measurables$previous_connection.PreviousConnection = PreviousConnection$$module$build$src$core$renderers$measurables$previous_connection;
    var RoundCorner$$module$build$src$core$renderers$measurables$round_corner = class extends Measurable$$module$build$src$core$renderers$measurables$base {
        constructor(a, b){
            super(a);
            this.type = (b && "left" !== b ? Types$$module$build$src$core$renderers$measurables$types.RIGHT_ROUND_CORNER : Types$$module$build$src$core$renderers$measurables$types.LEFT_ROUND_CORNER) | Types$$module$build$src$core$renderers$measurables$types.CORNER;
            this.width = this.constants_.CORNER_RADIUS;
            this.height = this.constants_.CORNER_RADIUS / 2;
        }
    }, module$build$src$core$renderers$measurables$round_corner = {};
    module$build$src$core$renderers$measurables$round_corner.RoundCorner = RoundCorner$$module$build$src$core$renderers$measurables$round_corner;
    var SpacerRow$$module$build$src$core$renderers$measurables$spacer_row = class extends Row$$module$build$src$core$renderers$measurables$row {
        constructor(a, b, c){
            super(a);
            this.height = b;
            this.width = c;
            this.precedesStatement = this.followsStatement = !1;
            this.widthWithConnectedBlocks = 0;
            this.type = this.type | Types$$module$build$src$core$renderers$measurables$types.SPACER | Types$$module$build$src$core$renderers$measurables$types.BETWEEN_ROW_SPACER;
            this.elements = [
                new InRowSpacer$$module$build$src$core$renderers$measurables$in_row_spacer(this.constants_, c)
            ];
        }
        measure() {}
    }, module$build$src$core$renderers$measurables$spacer_row = {};
    module$build$src$core$renderers$measurables$spacer_row.SpacerRow = SpacerRow$$module$build$src$core$renderers$measurables$spacer_row;
    var SquareCorner$$module$build$src$core$renderers$measurables$square_corner = class extends Measurable$$module$build$src$core$renderers$measurables$base {
        constructor(a, b){
            super(a);
            this.type = (b && "left" !== b ? Types$$module$build$src$core$renderers$measurables$types.RIGHT_SQUARE_CORNER : Types$$module$build$src$core$renderers$measurables$types.LEFT_SQUARE_CORNER) | Types$$module$build$src$core$renderers$measurables$types.CORNER;
            this.width = this.height = this.constants_.NO_PADDING;
        }
    }, module$build$src$core$renderers$measurables$square_corner = {};
    module$build$src$core$renderers$measurables$square_corner.SquareCorner = SquareCorner$$module$build$src$core$renderers$measurables$square_corner;
    var TopRow$$module$build$src$core$renderers$measurables$top_row = class extends Row$$module$build$src$core$renderers$measurables$row {
        constructor(a){
            super(a);
            this.ascenderHeight = this.capline = 0;
            this.hasPreviousConnection = !1;
            this.connection = null;
            this.type |= Types$$module$build$src$core$renderers$measurables$types.TOP_ROW;
        }
        hasLeftSquareCorner(a) {
            const b = (a.hat ? "cap" === a.hat : this.constants_.ADD_START_HATS) && !a.outputConnection && !a.previousConnection, c = a.getPreviousBlock();
            return !!a.outputConnection || b || (c ? c.getNextBlock() === a : !1);
        }
        hasRightSquareCorner(a) {
            return !0;
        }
        measure() {
            let a = 0, b = 0, c = 0;
            for(let d = 0; d < this.elements.length; d++){
                const e = this.elements[d];
                b += e.width;
                Types$$module$build$src$core$renderers$measurables$types.isSpacer(e) || (Types$$module$build$src$core$renderers$measurables$types.isHat(e) && e instanceof Hat$$module$build$src$core$renderers$measurables$hat ? c = Math.max(c, e.ascenderHeight) : a = Math.max(a, e.height));
            }
            this.width = Math.max(this.minWidth, b);
            this.height = Math.max(this.minHeight, a) + c;
            this.capline = this.ascenderHeight = c;
            this.widthWithConnectedBlocks = this.width;
        }
        startsWithElemSpacer() {
            return !1;
        }
        endsWithElemSpacer() {
            return !1;
        }
    }, module$build$src$core$renderers$measurables$top_row = {};
    module$build$src$core$renderers$measurables$top_row.TopRow = TopRow$$module$build$src$core$renderers$measurables$top_row;
    var ConstantProvider$$module$build$src$core$renderers$common$constants = class {
        constructor(){
            this.NO_PADDING = 0;
            this.SMALL_PADDING = 3;
            this.MEDIUM_PADDING = 5;
            this.MEDIUM_LARGE_PADDING = 8;
            this.LARGE_PADDING = 10;
            this.TAB_HEIGHT = 15;
            this.TAB_OFFSET_FROM_TOP = 5;
            this.TAB_VERTICAL_OVERLAP = 2.5;
            this.TAB_WIDTH = 8;
            this.NOTCH_WIDTH = 15;
            this.NOTCH_HEIGHT = 4;
            this.MIN_BLOCK_WIDTH = 12;
            this.EMPTY_BLOCK_SPACER_HEIGHT = 16;
            this.CORNER_RADIUS = 8;
            this.NOTCH_OFFSET_LEFT = 15;
            this.STATEMENT_BOTTOM_SPACER = 0;
            this.STATEMENT_INPUT_PADDING_LEFT = 20;
            this.BETWEEN_STATEMENT_PADDING_Y = 4;
            this.ADD_START_HATS = !1;
            this.START_HAT_HEIGHT = 15;
            this.START_HAT_WIDTH = 100;
            this.SPACER_DEFAULT_HEIGHT = 15;
            this.MIN_BLOCK_HEIGHT = 24;
            this.EMPTY_INLINE_INPUT_PADDING = 14.5;
            this.EXTERNAL_VALUE_INPUT_PADDING = 2;
            this.JAGGED_TEETH_HEIGHT = 12;
            this.JAGGED_TEETH_WIDTH = 6;
            this.FIELD_TEXT_FONTSIZE = 11;
            this.FIELD_TEXT_FONTWEIGHT = "normal";
            this.FIELD_TEXT_FONTFAMILY = "sans-serif";
            this.FIELD_TEXT_BASELINE = this.FIELD_TEXT_HEIGHT = -1;
            this.FIELD_BORDER_RECT_RADIUS = 4;
            this.FIELD_BORDER_RECT_HEIGHT = 16;
            this.FIELD_BORDER_RECT_X_PADDING = 5;
            this.FIELD_BORDER_RECT_Y_PADDING = 3;
            this.FIELD_BORDER_RECT_COLOUR = "#fff";
            this.FIELD_DROPDOWN_SVG_ARROW = this.FIELD_DROPDOWN_COLOURED_DIV = this.FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW = !1;
            this.FIELD_DROPDOWN_SVG_ARROW_SIZE = 12;
            this.FIELD_COLOUR_FULL_BLOCK = this.FIELD_TEXTINPUT_BOX_SHADOW = !1;
            this.FIELD_COLOUR_DEFAULT_WIDTH = 26;
            this.defs_ = null;
            this.embossFilterId = "";
            this.embossFilter_ = null;
            this.disabledPatternId = "";
            this.disabledPattern_ = null;
            this.debugFilterId = "";
            this.cssNode_ = this.debugFilter_ = null;
            this.CURSOR_COLOUR = "#cc0a0a";
            this.MARKER_COLOUR = "#4286f4";
            this.CURSOR_WS_WIDTH = 100;
            this.WS_CURSOR_HEIGHT = 5;
            this.CURSOR_STACK_PADDING = 10;
            this.CURSOR_BLOCK_PADDING = 2;
            this.CURSOR_STROKE_WIDTH = 4;
            this.FULL_BLOCK_FIELDS = !1;
            this.INSERTION_MARKER_COLOUR = "#000000";
            this.INSERTION_MARKER_OPACITY = .2;
            this.SHAPES = {
                PUZZLE: 1,
                NOTCH: 2
            };
            this.TALL_INPUT_FIELD_OFFSET_Y = this.MEDIUM_PADDING;
            this.DUMMY_INPUT_SHADOW_MIN_HEIGHT = this.DUMMY_INPUT_MIN_HEIGHT = this.TAB_HEIGHT;
            this.STATEMENT_INPUT_NOTCH_OFFSET = this.NOTCH_OFFSET_LEFT;
            this.TOP_ROW_MIN_HEIGHT = this.MEDIUM_PADDING;
            this.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT = this.LARGE_PADDING;
            this.BOTTOM_ROW_MIN_HEIGHT = this.MEDIUM_PADDING;
            this.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT = this.LARGE_PADDING;
            this.EMPTY_INLINE_INPUT_HEIGHT = this.TAB_HEIGHT + 11;
            this.EMPTY_STATEMENT_INPUT_HEIGHT = this.MIN_BLOCK_HEIGHT;
            this.START_POINT = moveBy$$module$build$src$core$utils$svg_paths(0, 0);
            this.FIELD_TEXT_BASELINE_CENTER = !0;
            this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT = this.FIELD_BORDER_RECT_HEIGHT;
            this.FIELD_DROPDOWN_SVG_ARROW_PADDING = this.FIELD_BORDER_RECT_X_PADDING;
            this.FIELD_DROPDOWN_SVG_ARROW_DATAURI = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMi43MSIgaGVpZ2h0PSI4Ljc5IiB2aWV3Qm94PSIwIDAgMTIuNzEgOC43OSI+PHRpdGxlPmRyb3Bkb3duLWFycm93PC90aXRsZT48ZyBvcGFjaXR5PSIwLjEiPjxwYXRoIGQ9Ik0xMi43MSwyLjQ0QTIuNDEsMi40MSwwLDAsMSwxMiw0LjE2TDguMDgsOC4wOGEyLjQ1LDIuNDUsMCwwLDEtMy40NSwwTDAuNzIsNC4xNkEyLjQyLDIuNDIsMCwwLDEsMCwyLjQ0LDIuNDgsMi40OCwwLDAsMSwuNzEuNzFDMSwwLjQ3LDEuNDMsMCw2LjM2LDBTMTEuNzUsMC40NiwxMiwuNzFBMi40NCwyLjQ0LDAsMCwxLDEyLjcxLDIuNDRaIiBmaWxsPSIjMjMxZjIwIi8+PC9nPjxwYXRoIGQ9Ik02LjM2LDcuNzlhMS40MywxLjQzLDAsMCwxLTEtLjQyTDEuNDIsMy40NWExLjQ0LDEuNDQsMCwwLDEsMC0yYzAuNTYtLjU2LDkuMzEtMC41Niw5Ljg3LDBhMS40NCwxLjQ0LDAsMCwxLDAsMkw3LjM3LDcuMzdBMS40MywxLjQzLDAsMCwxLDYuMzYsNy43OVoiIGZpbGw9IiNmZmYiLz48L3N2Zz4=";
            this.FIELD_COLOUR_DEFAULT_HEIGHT = this.FIELD_BORDER_RECT_HEIGHT;
            this.FIELD_CHECKBOX_X_OFFSET = this.FIELD_BORDER_RECT_X_PADDING - 3;
            this.randomIdentifier = String(Math.random()).substring(2);
        }
        init() {
            this.JAGGED_TEETH = this.makeJaggedTeeth();
            this.NOTCH = this.makeNotch();
            this.START_HAT = this.makeStartHat();
            this.PUZZLE_TAB = this.makePuzzleTab();
            this.INSIDE_CORNERS = this.makeInsideCorners();
            this.OUTSIDE_CORNERS = this.makeOutsideCorners();
        }
        setTheme(a) {
            this.blockStyles = Object.create(null);
            const b = a.blockStyles;
            for(const c in b)this.blockStyles[c] = this.validatedBlockStyle_(b[c]);
            this.setDynamicProperties_(a);
        }
        setDynamicProperties_(a) {
            this.setFontConstants_(a);
            this.setComponentConstants_(a);
            this.ADD_START_HATS = void 0 !== a.startHats ? a.startHats : this.ADD_START_HATS;
        }
        setFontConstants_(a) {
            a.fontStyle && a.fontStyle.family && (this.FIELD_TEXT_FONTFAMILY = a.fontStyle.family);
            a.fontStyle && a.fontStyle.weight && (this.FIELD_TEXT_FONTWEIGHT = a.fontStyle.weight);
            a.fontStyle && a.fontStyle.size && (this.FIELD_TEXT_FONTSIZE = a.fontStyle.size);
            a = measureFontMetrics$$module$build$src$core$utils$dom("Hg", this.FIELD_TEXT_FONTSIZE + "pt", this.FIELD_TEXT_FONTWEIGHT, this.FIELD_TEXT_FONTFAMILY);
            this.FIELD_TEXT_HEIGHT = a.height;
            this.FIELD_TEXT_BASELINE = a.baseline;
        }
        setComponentConstants_(a) {
            this.CURSOR_COLOUR = a.getComponentStyle("cursorColour") || this.CURSOR_COLOUR;
            this.MARKER_COLOUR = a.getComponentStyle("markerColour") || this.MARKER_COLOUR;
            this.INSERTION_MARKER_COLOUR = a.getComponentStyle("insertionMarkerColour") || this.INSERTION_MARKER_COLOUR;
            this.INSERTION_MARKER_OPACITY = Number(a.getComponentStyle("insertionMarkerOpacity")) || this.INSERTION_MARKER_OPACITY;
        }
        getBlockStyleForColour(a) {
            const b = "auto_" + a;
            this.blockStyles[b] || (this.blockStyles[b] = this.createBlockStyle_(a));
            return {
                style: this.blockStyles[b],
                name: b
            };
        }
        getBlockStyle(a) {
            return this.blockStyles[a || ""] || (a && 0 === a.indexOf("auto_") ? this.getBlockStyleForColour(a.substring(5)).style : this.createBlockStyle_("#000000"));
        }
        createBlockStyle_(a) {
            return this.validatedBlockStyle_({
                colourPrimary: a
            });
        }
        validatedBlockStyle_(a) {
            const b = {};
            a && Object.assign(b, a);
            a = parseBlockColour$$module$build$src$core$utils$parsing(b.colourPrimary || "#000");
            b.colourPrimary = a.hex;
            b.colourSecondary = b.colourSecondary ? parseBlockColour$$module$build$src$core$utils$parsing(b.colourSecondary).hex : this.generateSecondaryColour_(b.colourPrimary);
            b.colourTertiary = b.colourTertiary ? parseBlockColour$$module$build$src$core$utils$parsing(b.colourTertiary).hex : this.generateTertiaryColour_(b.colourPrimary);
            b.hat = b.hat || "";
            return b;
        }
        generateSecondaryColour_(a) {
            return blend$$module$build$src$core$utils$colour("#fff", a, .6) || a;
        }
        generateTertiaryColour_(a) {
            return blend$$module$build$src$core$utils$colour("#fff", a, .3) || a;
        }
        dispose() {
            this.embossFilter_ && removeNode$$module$build$src$core$utils$dom(this.embossFilter_);
            this.disabledPattern_ && removeNode$$module$build$src$core$utils$dom(this.disabledPattern_);
            this.debugFilter_ && removeNode$$module$build$src$core$utils$dom(this.debugFilter_);
            this.cssNode_ = null;
        }
        makeJaggedTeeth() {
            const a = this.JAGGED_TEETH_HEIGHT, b = this.JAGGED_TEETH_WIDTH, c = line$$module$build$src$core$utils$svg_paths([
                point$$module$build$src$core$utils$svg_paths(b, a / 4),
                point$$module$build$src$core$utils$svg_paths(2 * -b, a / 2),
                point$$module$build$src$core$utils$svg_paths(b, a / 4)
            ]);
            return {
                height: a,
                width: b,
                path: c
            };
        }
        makeStartHat() {
            const a = this.START_HAT_HEIGHT, b = this.START_HAT_WIDTH, c = curve$$module$build$src$core$utils$svg_paths("c", [
                point$$module$build$src$core$utils$svg_paths(30, -a),
                point$$module$build$src$core$utils$svg_paths(70, -a),
                point$$module$build$src$core$utils$svg_paths(b, 0)
            ]);
            return {
                height: a,
                width: b,
                path: c
            };
        }
        makePuzzleTab() {
            function a(f) {
                f = f ? -1 : 1;
                const g = -f;
                var h = c / 2;
                const k = h + 2.5, l = h + .5, m = point$$module$build$src$core$utils$svg_paths(-b, f * h);
                h = point$$module$build$src$core$utils$svg_paths(b, f * h);
                return curve$$module$build$src$core$utils$svg_paths("c", [
                    point$$module$build$src$core$utils$svg_paths(0, f * k),
                    point$$module$build$src$core$utils$svg_paths(-b, g * l),
                    m
                ]) + curve$$module$build$src$core$utils$svg_paths("s", [
                    point$$module$build$src$core$utils$svg_paths(b, 2.5 * g),
                    h
                ]);
            }
            const b = this.TAB_WIDTH, c = this.TAB_HEIGHT, d = a(!0), e = a(!1);
            return {
                type: this.SHAPES.PUZZLE,
                width: b,
                height: c,
                pathDown: e,
                pathUp: d
            };
        }
        makeNotch() {
            function a(g) {
                return line$$module$build$src$core$utils$svg_paths([
                    point$$module$build$src$core$utils$svg_paths(g * d, c),
                    point$$module$build$src$core$utils$svg_paths(3 * g, 0),
                    point$$module$build$src$core$utils$svg_paths(g * d, -c)
                ]);
            }
            const b = this.NOTCH_WIDTH, c = this.NOTCH_HEIGHT, d = (b - 3) / 2, e = a(1), f = a(-1);
            return {
                type: this.SHAPES.NOTCH,
                width: b,
                height: c,
                pathLeft: e,
                pathRight: f
            };
        }
        makeInsideCorners() {
            const a = this.CORNER_RADIUS, b = arc$$module$build$src$core$utils$svg_paths("a", "0 0,0", a, point$$module$build$src$core$utils$svg_paths(-a, a)), c = arc$$module$build$src$core$utils$svg_paths("a", "0 0,0", a, point$$module$build$src$core$utils$svg_paths(a, a));
            return {
                width: a,
                height: a,
                pathTop: b,
                pathBottom: c
            };
        }
        makeOutsideCorners() {
            const a = this.CORNER_RADIUS, b = moveBy$$module$build$src$core$utils$svg_paths(0, a) + arc$$module$build$src$core$utils$svg_paths("a", "0 0,1", a, point$$module$build$src$core$utils$svg_paths(a, -a)), c = arc$$module$build$src$core$utils$svg_paths("a", "0 0,1", a, point$$module$build$src$core$utils$svg_paths(a, a)), d = arc$$module$build$src$core$utils$svg_paths("a", "0 0,1", a, point$$module$build$src$core$utils$svg_paths(-a, -a)), e = arc$$module$build$src$core$utils$svg_paths("a", "0 0,1", a, point$$module$build$src$core$utils$svg_paths(-a, a));
            return {
                topLeft: b,
                topRight: c,
                bottomRight: e,
                bottomLeft: d,
                rightHeight: a
            };
        }
        shapeFor(a) {
            switch(a.type){
                case ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE:
                case ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE:
                    return this.PUZZLE_TAB;
                case ConnectionType$$module$build$src$core$connection_type.PREVIOUS_STATEMENT:
                case ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT:
                    return this.NOTCH;
                default:
                    throw Error("Unknown connection type");
            }
        }
        createDom(a, b, c) {
            this.injectCSS_(b, c);
            this.defs_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.DEFS, {}, a);
            a = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FILTER, {
                id: "blocklyEmbossFilter" + this.randomIdentifier
            }, this.defs_);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FEGAUSSIANBLUR, {
                "in": "SourceAlpha",
                stdDeviation: 1,
                result: "blur"
            }, a);
            b = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FESPECULARLIGHTING, {
                "in": "blur",
                surfaceScale: 1,
                specularConstant: .5,
                specularExponent: 10,
                "lighting-color": "white",
                result: "specOut"
            }, a);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FEPOINTLIGHT, {
                x: -5000,
                y: -10000,
                z: 2E4
            }, b);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FECOMPOSITE, {
                "in": "specOut",
                in2: "SourceAlpha",
                operator: "in",
                result: "specOut"
            }, a);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FECOMPOSITE, {
                "in": "SourceGraphic",
                in2: "specOut",
                operator: "arithmetic",
                k1: 0,
                k2: 1,
                k3: 1,
                k4: 0
            }, a);
            this.embossFilterId = a.id;
            this.embossFilter_ = a;
            a = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATTERN, {
                id: "blocklyDisabledPattern" + this.randomIdentifier,
                patternUnits: "userSpaceOnUse",
                width: 10,
                height: 10
            }, this.defs_);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                width: 10,
                height: 10,
                fill: "#aaa"
            }, a);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATH, {
                d: "M 0 0 L 10 10 M 10 0 L 0 10",
                stroke: "#cc0"
            }, a);
            this.disabledPatternId = a.id;
            this.disabledPattern_ = a;
            this.createDebugFilter();
        }
        createDebugFilter() {
            if (!this.debugFilter_) {
                const a = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FILTER, {
                    id: "blocklyDebugFilter" + this.randomIdentifier,
                    height: "160%",
                    width: "180%",
                    y: "-30%",
                    x: "-40%"
                }, this.defs_), b = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FECOMPONENTTRANSFER, {
                    result: "outBlur"
                }, a);
                createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FEFUNCA, {
                    type: "table",
                    tableValues: "0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1"
                }, b);
                createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FEFLOOD, {
                    "flood-color": "#ff0000",
                    "flood-opacity": .5,
                    result: "outColor"
                }, a);
                createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FECOMPOSITE, {
                    "in": "outColor",
                    in2: "outBlur",
                    operator: "in",
                    result: "outGlow"
                }, a);
                this.debugFilterId = a.id;
                this.debugFilter_ = a;
            }
        }
        injectCSS_(a, b) {
            b = this.getCSS_(b);
            a = "blockly-renderer-style-" + a;
            this.cssNode_ = document.getElementById(a);
            const c = b.join("\n");
            this.cssNode_ ? this.cssNode_.firstChild.textContent = c : (b = document.createElement("style"), b.id = a, a = document.createTextNode(c), b.appendChild(a), document.head.insertBefore(b, document.head.firstChild), this.cssNode_ = b);
        }
        getCSS_(a) {
            return [
                `${a} .blocklyText, `,
                `${a} .blocklyFlyoutLabelText {`,
                `font: ${this.FIELD_TEXT_FONTWEIGHT} ` + `${this.FIELD_TEXT_FONTSIZE}pt ${this.FIELD_TEXT_FONTFAMILY};`,
                "}",
                `${a} .blocklyText {`,
                "fill: #fff;",
                "}",
                `${a} .blocklyNonEditableText>rect,`,
                `${a} .blocklyEditableText>rect {`,
                `fill: ${this.FIELD_BORDER_RECT_COLOUR};`,
                "fill-opacity: .6;",
                "stroke: none;",
                "}",
                `${a} .blocklyNonEditableText>text,`,
                `${a} .blocklyEditableText>text {`,
                "fill: #000;",
                "}",
                `${a} .blocklyFlyoutLabelText {`,
                "fill: #000;",
                "}",
                `${a} .blocklyText.blocklyBubbleText {`,
                "fill: #000;",
                "}",
                `${a} .blocklyEditableText:not(.editing):hover>rect {`,
                "stroke: #fff;",
                "stroke-width: 2;",
                "}",
                `${a} .blocklyHtmlInput {`,
                `font-family: ${this.FIELD_TEXT_FONTFAMILY};`,
                `font-weight: ${this.FIELD_TEXT_FONTWEIGHT};`,
                "}",
                `${a} .blocklySelected>.blocklyPath {`,
                "stroke: #fc3;",
                "stroke-width: 3px;",
                "}",
                `${a} .blocklyHighlightedConnectionPath {`,
                "stroke: #fc3;",
                "}",
                `${a} .blocklyReplaceable .blocklyPath {`,
                "fill-opacity: .5;",
                "}",
                `${a} .blocklyReplaceable .blocklyPathLight,`,
                `${a} .blocklyReplaceable .blocklyPathDark {`,
                "display: none;",
                "}",
                `${a} .blocklyInsertionMarker>.blocklyPath {`,
                `fill-opacity: ${this.INSERTION_MARKER_OPACITY};`,
                "stroke: none;",
                "}"
            ];
        }
    }, module$build$src$core$renderers$common$constants = {};
    module$build$src$core$renderers$common$constants.ConstantProvider = ConstantProvider$$module$build$src$core$renderers$common$constants;
    module$build$src$core$renderers$common$constants.isDynamicShape = isDynamicShape$$module$build$src$core$renderers$common$constants;
    var useDebugger$$module$build$src$core$renderers$common$debug = !1, module$build$src$core$renderers$common$debug = {};
    module$build$src$core$renderers$common$debug.isDebuggerEnabled = isDebuggerEnabled$$module$build$src$core$renderers$common$debug;
    module$build$src$core$renderers$common$debug.startDebugger = startDebugger$$module$build$src$core$renderers$common$debug;
    module$build$src$core$renderers$common$debug.stopDebugger = stopDebugger$$module$build$src$core$renderers$common$debug;
    var Debug$$module$build$src$core$renderers$common$debugger = class {
        constructor(a){
            this.constants = a;
            this.debugElements_ = [];
            this.svgRoot_ = null;
            this.randomColour_ = "";
        }
        clearElems() {
            for(let a = 0; a < this.debugElements_.length; a++)removeNode$$module$build$src$core$utils$dom(this.debugElements_[a]);
            this.debugElements_ = [];
        }
        drawSpacerRow(a, b, c) {
            if (Debug$$module$build$src$core$renderers$common$debugger.config.rowSpacers) {
                var d = Math.abs(a.height), e = 0 > a.height;
                e && (b -= d);
                this.debugElements_.push(createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                    "class": "rowSpacerRect blockRenderDebug",
                    x: c ? -(a.xPos + a.width) : a.xPos,
                    y: b,
                    width: a.width,
                    height: d,
                    stroke: e ? "black" : "blue",
                    fill: "blue",
                    "fill-opacity": "0.5",
                    "stroke-width": "1px"
                }, this.svgRoot_));
            }
        }
        drawSpacerElem(a, b, c) {
            if (Debug$$module$build$src$core$renderers$common$debugger.config.elemSpacers) {
                b = Math.abs(a.width);
                var d = 0 > a.width, e = d ? a.xPos - b : a.xPos;
                c && (e = -(e + b));
                this.debugElements_.push(createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                    "class": "elemSpacerRect blockRenderDebug",
                    x: e,
                    y: a.centerline - a.height / 2,
                    width: b,
                    height: a.height,
                    stroke: "pink",
                    fill: d ? "black" : "pink",
                    "fill-opacity": "0.5",
                    "stroke-width": "1px"
                }, this.svgRoot_));
            }
        }
        drawRenderedElem(a, b) {
            if (Debug$$module$build$src$core$renderers$common$debugger.config.elems) {
                let c = a.xPos;
                b && (c = -(c + a.width));
                b = a.centerline - a.height / 2;
                this.debugElements_.push(createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                    "class": "rowRenderingRect blockRenderDebug",
                    x: c,
                    y: b,
                    width: a.width,
                    height: a.height,
                    stroke: "black",
                    fill: "none",
                    "stroke-width": "1px"
                }, this.svgRoot_));
                Types$$module$build$src$core$renderers$measurables$types.isField(a) && a instanceof Field$$module$build$src$core$renderers$measurables$field && a.field instanceof FieldLabel$$module$build$src$core$field_label && this.debugElements_.push(createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                    "class": "rowRenderingRect blockRenderDebug",
                    x: c,
                    y: b + this.constants.FIELD_TEXT_BASELINE,
                    width: a.width,
                    height: "0.1px",
                    stroke: "red",
                    fill: "none",
                    "stroke-width": "0.5px"
                }, this.svgRoot_));
            }
            Types$$module$build$src$core$renderers$measurables$types.isInput(a) && a instanceof InputConnection$$module$build$src$core$renderers$measurables$input_connection && Debug$$module$build$src$core$renderers$common$debugger.config.connections && this.drawConnection(a.connectionModel);
        }
        drawConnection(a) {
            if (Debug$$module$build$src$core$renderers$common$debugger.config.connections) {
                var b = "", c = 0, d = "";
                a.type === ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE ? (c = 4, b = "magenta", d = "none") : a.type === ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE ? (c = 2, d = b = "magenta") : a.type === ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT ? (c = 4, b = "goldenrod", d = "none") : a.type === ConnectionType$$module$build$src$core$connection_type.PREVIOUS_STATEMENT && (c = 2, d = b = "goldenrod");
                this.debugElements_.push(createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.CIRCLE, {
                    "class": "blockRenderDebug",
                    cx: a.getOffsetInBlock().x,
                    cy: a.getOffsetInBlock().y,
                    r: c,
                    fill: d,
                    stroke: b
                }, this.svgRoot_));
            }
        }
        drawRenderedRow(a, b, c) {
            Debug$$module$build$src$core$renderers$common$debugger.config.rows && (this.debugElements_.push(createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                "class": "elemRenderingRect blockRenderDebug",
                x: c ? -(a.xPos + a.width) : a.xPos,
                y: a.yPos,
                width: a.width,
                height: a.height,
                stroke: "red",
                fill: "none",
                "stroke-width": "1px"
            }, this.svgRoot_)), Types$$module$build$src$core$renderers$measurables$types.isTopOrBottomRow(a) || Debug$$module$build$src$core$renderers$common$debugger.config.connectedBlockBounds && this.debugElements_.push(createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                "class": "connectedBlockWidth blockRenderDebug",
                x: c ? -(a.xPos + a.widthWithConnectedBlocks) : a.xPos,
                y: a.yPos,
                width: a.widthWithConnectedBlocks,
                height: a.height,
                stroke: this.randomColour_,
                fill: "none",
                "stroke-width": "1px",
                "stroke-dasharray": "3,3"
            }, this.svgRoot_)));
        }
        drawRowWithElements(a, b, c) {
            for(let d = 0; d < a.elements.length; d++){
                const e = a.elements[d];
                e ? Types$$module$build$src$core$renderers$measurables$types.isSpacer(e) ? this.drawSpacerElem(e, a.height, c) : this.drawRenderedElem(e, c) : console.warn("A row has an undefined or null element.", a, e);
            }
            this.drawRenderedRow(a, b, c);
        }
        drawBoundingBox(a) {
            if (Debug$$module$build$src$core$renderers$common$debugger.config.blockBounds) {
                var b = a.RTL ? -a.width : 0;
                this.debugElements_.push(createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                    "class": "blockBoundingBox blockRenderDebug",
                    x: b,
                    y: 0,
                    width: a.width,
                    height: a.height,
                    stroke: "black",
                    fill: "none",
                    "stroke-width": "1px",
                    "stroke-dasharray": "5,5"
                }, this.svgRoot_));
                Debug$$module$build$src$core$renderers$common$debugger.config.connectedBlockBounds && (b = a.RTL ? -a.widthWithChildren : 0, this.debugElements_.push(createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                    "class": "blockRenderDebug",
                    x: b,
                    y: 0,
                    width: a.widthWithChildren,
                    height: a.height,
                    stroke: "#DF57BC",
                    fill: "none",
                    "stroke-width": "1px",
                    "stroke-dasharray": "3,3"
                }, this.svgRoot_)));
            }
        }
        drawDebug(a, b) {
            this.clearElems();
            this.svgRoot_ = a.getSvgRoot();
            this.randomColour_ = "#" + Math.floor(16777215 * Math.random()).toString(16);
            let c = 0;
            for(let d = 0; d < b.rows.length; d++){
                const e = b.rows[d];
                Types$$module$build$src$core$renderers$measurables$types.isBetweenRowSpacer(e) ? this.drawSpacerRow(e, c, b.RTL) : this.drawRowWithElements(e, c, b.RTL);
                c += e.height;
            }
            a.previousConnection && this.drawConnection(a.previousConnection);
            a.nextConnection && this.drawConnection(a.nextConnection);
            a.outputConnection && this.drawConnection(a.outputConnection);
            b.rightSide && this.drawRenderedElem(b.rightSide, b.RTL);
            this.drawBoundingBox(b);
            this.drawRender(a.pathObject.svgPath);
        }
        drawRender(a) {
            Debug$$module$build$src$core$renderers$common$debugger.config.render && (a.setAttribute("filter", "url(#" + this.constants.debugFilterId + ")"), setTimeout(function() {
                a.setAttribute("filter", "");
            }, 100));
        }
    };
    Debug$$module$build$src$core$renderers$common$debugger.config = {
        rowSpacers: !0,
        elemSpacers: !0,
        rows: !0,
        elems: !0,
        connections: !0,
        blockBounds: !0,
        connectedBlockBounds: !0,
        render: !0
    };
    var module$build$src$core$renderers$common$debugger = {};
    module$build$src$core$renderers$common$debugger.Debug = Debug$$module$build$src$core$renderers$common$debugger;
    var Drawer$$module$build$src$core$renderers$common$drawer = class {
        constructor(a, b){
            this.inlinePath_ = this.outlinePath_ = "";
            this.block_ = a;
            this.info_ = b;
            this.topLeft_ = a.getRelativeToSurfaceXY();
            this.constants_ = b.getRenderer().getConstants();
        }
        draw() {
            this.hideHiddenIcons_();
            this.drawOutline_();
            this.drawInternals_();
            this.block_.pathObject.setPath(this.outlinePath_ + "\n" + this.inlinePath_);
            this.info_.RTL && this.block_.pathObject.flipRTL();
            if (isDebuggerEnabled$$module$build$src$core$renderers$common$debug()) {
                let a;
                null == (a = this.block_.renderingDebugger) || a.drawDebug(this.block_, this.info_);
            }
            this.recordSizeOnBlock_();
        }
        recordSizeOnBlock_() {
            this.block_.height = this.info_.height;
            this.block_.width = this.info_.widthWithChildren;
        }
        hideHiddenIcons_() {
            for(let a = 0, b; b = this.info_.hiddenIcons[a]; a++){
                let c;
                null == (c = b.icon.iconGroup_) || c.setAttribute("display", "none");
            }
        }
        drawOutline_() {
            this.drawTop_();
            for(let a = 1; a < this.info_.rows.length - 1; a++){
                const b = this.info_.rows[a];
                b.hasJaggedEdge ? this.drawJaggedEdge_(b) : b.hasStatement ? this.drawStatementInput_(b) : b.hasExternalInput ? this.drawValueInput_(b) : this.drawRightSideRow_(b);
            }
            this.drawBottom_();
            this.drawLeft_();
        }
        drawTop_() {
            const a = this.info_.topRow, b = a.elements;
            this.positionPreviousConnection_();
            this.outlinePath_ += moveBy$$module$build$src$core$utils$svg_paths(a.xPos, this.info_.startY);
            for(let c = 0, d; d = b[c]; c++)Types$$module$build$src$core$renderers$measurables$types.isLeftRoundedCorner(d) ? this.outlinePath_ += this.constants_.OUTSIDE_CORNERS.topLeft : Types$$module$build$src$core$renderers$measurables$types.isRightRoundedCorner(d) ? this.outlinePath_ += this.constants_.OUTSIDE_CORNERS.topRight : Types$$module$build$src$core$renderers$measurables$types.isPreviousConnection(d) && d instanceof Connection$$module$build$src$core$renderers$measurables$connection ? this.outlinePath_ += d.shape.pathLeft : Types$$module$build$src$core$renderers$measurables$types.isHat(d) ? this.outlinePath_ += this.constants_.START_HAT.path : Types$$module$build$src$core$renderers$measurables$types.isSpacer(d) && (this.outlinePath_ += lineOnAxis$$module$build$src$core$utils$svg_paths("h", d.width));
            this.outlinePath_ += lineOnAxis$$module$build$src$core$utils$svg_paths("v", a.height);
        }
        drawJaggedEdge_(a) {
            this.outlinePath_ += this.constants_.JAGGED_TEETH.path + lineOnAxis$$module$build$src$core$utils$svg_paths("v", a.height - this.constants_.JAGGED_TEETH.height);
        }
        drawValueInput_(a) {
            const b = a.getLastInput();
            this.positionExternalValueConnection_(a);
            const c = isDynamicShape$$module$build$src$core$renderers$common$constants(b.shape) ? b.shape.pathDown(b.height) : b.shape.pathDown;
            this.outlinePath_ += lineOnAxis$$module$build$src$core$utils$svg_paths("H", b.xPos + b.width) + c + lineOnAxis$$module$build$src$core$utils$svg_paths("v", a.height - b.connectionHeight);
        }
        drawStatementInput_(a) {
            var b = a.getLastInput();
            if (b) {
                var c = b.xPos + b.notchOffset + b.shape.width;
                b = b.shape.pathRight + lineOnAxis$$module$build$src$core$utils$svg_paths("h", -(b.notchOffset - this.constants_.INSIDE_CORNERS.width)) + this.constants_.INSIDE_CORNERS.pathTop;
                var d = a.height - 2 * this.constants_.INSIDE_CORNERS.height;
                this.outlinePath_ += lineOnAxis$$module$build$src$core$utils$svg_paths("H", c) + b + lineOnAxis$$module$build$src$core$utils$svg_paths("v", d) + this.constants_.INSIDE_CORNERS.pathBottom + lineOnAxis$$module$build$src$core$utils$svg_paths("H", a.xPos + a.width);
                this.positionStatementInputConnection_(a);
            }
        }
        drawRightSideRow_(a) {
            this.outlinePath_ += lineOnAxis$$module$build$src$core$utils$svg_paths("V", a.yPos + a.height);
        }
        drawBottom_() {
            const a = this.info_.bottomRow, b = a.elements;
            this.positionNextConnection_();
            let c = 0, d = "";
            for(let e = b.length - 1, f; f = b[e]; e--)Types$$module$build$src$core$renderers$measurables$types.isNextConnection(f) && f instanceof Connection$$module$build$src$core$renderers$measurables$connection ? d += f.shape.pathRight : Types$$module$build$src$core$renderers$measurables$types.isLeftSquareCorner(f) ? d += lineOnAxis$$module$build$src$core$utils$svg_paths("H", a.xPos) : Types$$module$build$src$core$renderers$measurables$types.isLeftRoundedCorner(f) ? d += this.constants_.OUTSIDE_CORNERS.bottomLeft : Types$$module$build$src$core$renderers$measurables$types.isRightRoundedCorner(f) ? (d += this.constants_.OUTSIDE_CORNERS.bottomRight, c = this.constants_.OUTSIDE_CORNERS.rightHeight) : Types$$module$build$src$core$renderers$measurables$types.isSpacer(f) && (d += lineOnAxis$$module$build$src$core$utils$svg_paths("h", -1 * f.width));
            this.outlinePath_ += lineOnAxis$$module$build$src$core$utils$svg_paths("V", a.baseline - c);
            this.outlinePath_ += d;
        }
        drawLeft_() {
            var a = this.info_.outputConnection;
            this.positionOutputConnection_();
            if (a) {
                const b = a.connectionOffsetY + a.height;
                a = isDynamicShape$$module$build$src$core$renderers$common$constants(a.shape) ? a.shape.pathUp(a.height) : a.shape.pathUp;
                this.outlinePath_ += lineOnAxis$$module$build$src$core$utils$svg_paths("V", b) + a;
            }
            this.outlinePath_ += "z";
        }
        drawInternals_() {
            for(let a = 0, b; b = this.info_.rows[a]; a++)for(let c = 0, d; d = b.elements[c]; c++)Types$$module$build$src$core$renderers$measurables$types.isInlineInput(d) ? this.drawInlineInput_(d) : (Types$$module$build$src$core$renderers$measurables$types.isIcon(d) || Types$$module$build$src$core$renderers$measurables$types.isField(d)) && this.layoutField_(d);
        }
        layoutField_(a) {
            const b = Types$$module$build$src$core$renderers$measurables$types.isField(a) ? a.field.getSvgRoot() : a.icon.iconGroup_, c = a.centerline - a.height / 2;
            let d = a.xPos, e = "";
            this.info_.RTL && (d = -(d + a.width), a.flipRtl && (d += a.width, e = "scale(-1 1)"));
            Types$$module$build$src$core$renderers$measurables$types.isIcon(a) ? (b.setAttribute("display", "block"), b.setAttribute("transform", "translate(" + d + "," + c + ")"), a.icon.computeIconLocation()) : b.setAttribute("transform", "translate(" + d + "," + c + ")" + e);
            this.info_.isInsertionMarker && b.setAttribute("display", "none");
        }
        drawInlineInput_(a) {
            const b = a.width, c = a.height, d = a.connectionOffsetY, e = a.connectionHeight + d;
            this.inlinePath_ += moveTo$$module$build$src$core$utils$svg_paths(a.xPos + a.connectionWidth, a.centerline - c / 2) + lineOnAxis$$module$build$src$core$utils$svg_paths("v", d) + a.shape.pathDown + lineOnAxis$$module$build$src$core$utils$svg_paths("v", c - e) + lineOnAxis$$module$build$src$core$utils$svg_paths("h", b - a.connectionWidth) + lineOnAxis$$module$build$src$core$utils$svg_paths("v", -c) + "z";
            this.positionInlineInputConnection_(a);
        }
        positionInlineInputConnection_(a) {
            const b = a.centerline - a.height / 2;
            if (a.connectionModel) {
                let c = a.xPos + a.connectionWidth + a.connectionOffsetX;
                this.info_.RTL && (c *= -1);
                a.connectionModel.setOffsetInBlock(c, b + a.connectionOffsetY);
            }
        }
        positionStatementInputConnection_(a) {
            const b = a.getLastInput();
            if (null == b ? 0 : b.connectionModel) {
                let c = a.xPos + a.statementEdge + b.notchOffset;
                this.info_.RTL && (c *= -1);
                b.connectionModel.setOffsetInBlock(c, a.yPos);
            }
        }
        positionExternalValueConnection_(a) {
            const b = a.getLastInput();
            if (b && b.connectionModel) {
                let c = a.xPos + a.width;
                this.info_.RTL && (c *= -1);
                b.connectionModel.setOffsetInBlock(c, a.yPos);
            }
        }
        positionPreviousConnection_() {
            const a = this.info_.topRow;
            if (a.connection) {
                const b = a.xPos + a.notchOffset;
                a.connection.connectionModel.setOffsetInBlock(this.info_.RTL ? -b : b, 0);
            }
        }
        positionNextConnection_() {
            const a = this.info_.bottomRow;
            if (a.connection) {
                const b = a.connection, c = b.xPos;
                b.connectionModel.setOffsetInBlock(this.info_.RTL ? -c : c, a.baseline);
            }
        }
        positionOutputConnection_() {
            if (this.info_.outputConnection) {
                const a = this.info_.startX + this.info_.outputConnection.connectionOffsetX;
                this.block_.outputConnection.setOffsetInBlock(this.info_.RTL ? -a : a, this.info_.outputConnection.connectionOffsetY);
            }
        }
    }, module$build$src$core$renderers$common$drawer = {};
    module$build$src$core$renderers$common$drawer.Drawer = Drawer$$module$build$src$core$renderers$common$drawer;
    var RenderInfo$$module$build$src$core$renderers$common$info = class {
        constructor(a, b){
            this.statementEdge = this.width = this.widthWithChildren = this.height = 0;
            this.rows = [];
            this.inputRows = [];
            this.hiddenIcons = [];
            this.startY = this.startX = 0;
            this.renderer_ = a;
            this.block_ = b;
            this.constants_ = this.renderer_.getConstants();
            this.outputConnection = b.outputConnection ? new OutputConnection$$module$build$src$core$renderers$measurables$output_connection(this.constants_, b.outputConnection) : null;
            this.isInline = b.getInputsInline() && !b.isCollapsed();
            this.isCollapsed = b.isCollapsed();
            this.isInsertionMarker = b.isInsertionMarker();
            this.RTL = b.RTL;
            this.topRow = new TopRow$$module$build$src$core$renderers$measurables$top_row(this.constants_);
            this.bottomRow = new BottomRow$$module$build$src$core$renderers$measurables$bottom_row(this.constants_);
        }
        getRenderer() {
            return this.renderer_;
        }
        measure() {
            this.createRows_();
            this.addElemSpacing_();
            this.addRowSpacing_();
            this.computeBounds_();
            this.alignRowElements_();
            this.finalize_();
        }
        createRows_() {
            this.populateTopRow_();
            this.rows.push(this.topRow);
            let a = new InputRow$$module$build$src$core$renderers$measurables$input_row(this.constants_);
            this.inputRows.push(a);
            var b = this.block_.getIcons();
            for(let c = 0, d; d = b[c]; c++){
                const e = new Icon$$module$build$src$core$renderers$measurables$icon(this.constants_, d);
                this.isCollapsed && d.collapseHidden ? this.hiddenIcons.push(e) : a.elements.push(e);
            }
            b = void 0;
            for(let c = 0, d; d = this.block_.inputList[c]; c++)if (d.isVisible()) {
                this.shouldStartNewRow_(d, b) && (this.rows.push(a), a = new InputRow$$module$build$src$core$renderers$measurables$input_row(this.constants_), this.inputRows.push(a));
                for(let e = 0, f; f = d.fieldRow[e]; e++)a.elements.push(new Field$$module$build$src$core$renderers$measurables$field(this.constants_, f, d));
                this.addInput_(d, a);
                b = d;
            }
            this.isCollapsed && (a.hasJaggedEdge = !0, a.elements.push(new JaggedEdge$$module$build$src$core$renderers$measurables$jagged_edge(this.constants_)));
            (a.elements.length || a.hasDummyInput) && this.rows.push(a);
            this.populateBottomRow_();
            this.rows.push(this.bottomRow);
        }
        populateTopRow_() {
            var a = !!this.block_.previousConnection;
            const b = (this.block_.hat ? "cap" === this.block_.hat : this.constants_.ADD_START_HATS) && !this.outputConnection && !a;
            let c = this.topRow.hasLeftSquareCorner(this.block_) ? SquareCorner$$module$build$src$core$renderers$measurables$square_corner : RoundCorner$$module$build$src$core$renderers$measurables$round_corner;
            this.topRow.elements.push(new c(this.constants_));
            b ? (a = new Hat$$module$build$src$core$renderers$measurables$hat(this.constants_), this.topRow.elements.push(a), this.topRow.capline = a.ascenderHeight) : a && (this.topRow.hasPreviousConnection = !0, this.topRow.connection = new PreviousConnection$$module$build$src$core$renderers$measurables$previous_connection(this.constants_, this.block_.previousConnection), this.topRow.elements.push(this.topRow.connection));
            this.block_.inputList.length && this.block_.inputList[0].type === inputTypes$$module$build$src$core$input_types.STATEMENT && !this.block_.isCollapsed() ? this.topRow.minHeight = this.constants_.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT : this.topRow.minHeight = this.constants_.TOP_ROW_MIN_HEIGHT;
            c = this.topRow.hasRightSquareCorner(this.block_) ? SquareCorner$$module$build$src$core$renderers$measurables$square_corner : RoundCorner$$module$build$src$core$renderers$measurables$round_corner;
            this.topRow.elements.push(new c(this.constants_, "right"));
        }
        populateBottomRow_() {
            this.bottomRow.hasNextConnection = !!this.block_.nextConnection;
            this.bottomRow.minHeight = this.block_.inputList.length && this.block_.inputList[this.block_.inputList.length - 1].type === inputTypes$$module$build$src$core$input_types.STATEMENT ? this.constants_.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT : this.constants_.BOTTOM_ROW_MIN_HEIGHT;
            this.bottomRow.hasLeftSquareCorner(this.block_) ? this.bottomRow.elements.push(new SquareCorner$$module$build$src$core$renderers$measurables$square_corner(this.constants_)) : this.bottomRow.elements.push(new RoundCorner$$module$build$src$core$renderers$measurables$round_corner(this.constants_));
            this.bottomRow.hasNextConnection && (this.bottomRow.connection = new NextConnection$$module$build$src$core$renderers$measurables$next_connection(this.constants_, this.block_.nextConnection), this.bottomRow.elements.push(this.bottomRow.connection));
            this.bottomRow.hasRightSquareCorner(this.block_) ? this.bottomRow.elements.push(new SquareCorner$$module$build$src$core$renderers$measurables$square_corner(this.constants_, "right")) : this.bottomRow.elements.push(new RoundCorner$$module$build$src$core$renderers$measurables$round_corner(this.constants_, "right"));
        }
        addInput_(a, b) {
            this.isInline && a.type === inputTypes$$module$build$src$core$input_types.VALUE ? (b.elements.push(new InlineInput$$module$build$src$core$renderers$measurables$inline_input(this.constants_, a)), b.hasInlineInput = !0) : a.type === inputTypes$$module$build$src$core$input_types.STATEMENT ? (b.elements.push(new StatementInput$$module$build$src$core$renderers$measurables$statement_input(this.constants_, a)), b.hasStatement = !0) : a.type === inputTypes$$module$build$src$core$input_types.VALUE ? (b.elements.push(new ExternalValueInput$$module$build$src$core$renderers$measurables$external_value_input(this.constants_, a)), b.hasExternalInput = !0) : a.type === inputTypes$$module$build$src$core$input_types.DUMMY && (b.minHeight = Math.max(b.minHeight, a.getSourceBlock() && a.getSourceBlock().isShadow() ? this.constants_.DUMMY_INPUT_SHADOW_MIN_HEIGHT : this.constants_.DUMMY_INPUT_MIN_HEIGHT), b.hasDummyInput = !0);
            null === b.align && (b.align = a.align);
        }
        shouldStartNewRow_(a, b) {
            return b ? a.type === inputTypes$$module$build$src$core$input_types.STATEMENT || b.type === inputTypes$$module$build$src$core$input_types.STATEMENT ? !0 : a.type === inputTypes$$module$build$src$core$input_types.VALUE || a.type === inputTypes$$module$build$src$core$input_types.DUMMY ? !this.isInline : !1 : !1;
        }
        addElemSpacing_() {
            for(let a = 0, b; b = this.rows[a]; a++){
                const c = b.elements;
                b.elements = [];
                b.startsWithElemSpacer() && b.elements.push(new InRowSpacer$$module$build$src$core$renderers$measurables$in_row_spacer(this.constants_, this.getInRowSpacing_(null, c[0])));
                if (c.length) {
                    for(let d = 0; d < c.length - 1; d++){
                        b.elements.push(c[d]);
                        const e = this.getInRowSpacing_(c[d], c[d + 1]);
                        b.elements.push(new InRowSpacer$$module$build$src$core$renderers$measurables$in_row_spacer(this.constants_, e));
                    }
                    b.elements.push(c[c.length - 1]);
                    b.endsWithElemSpacer() && b.elements.push(new InRowSpacer$$module$build$src$core$renderers$measurables$in_row_spacer(this.constants_, this.getInRowSpacing_(c[c.length - 1], null)));
                }
            }
        }
        getInRowSpacing_(a, b) {
            if (!a && b && Types$$module$build$src$core$renderers$measurables$types.isStatementInput(b)) return this.constants_.STATEMENT_INPUT_PADDING_LEFT;
            if (a && Types$$module$build$src$core$renderers$measurables$types.isInput(a) && !b) {
                if (Types$$module$build$src$core$renderers$measurables$types.isExternalInput(a)) return this.constants_.NO_PADDING;
                if (Types$$module$build$src$core$renderers$measurables$types.isInlineInput(a)) return this.constants_.LARGE_PADDING;
                if (Types$$module$build$src$core$renderers$measurables$types.isStatementInput(a)) return this.constants_.NO_PADDING;
            }
            return a && Types$$module$build$src$core$renderers$measurables$types.isLeftSquareCorner(a) && b && (Types$$module$build$src$core$renderers$measurables$types.isPreviousConnection(b) || Types$$module$build$src$core$renderers$measurables$types.isNextConnection(b)) ? b.notchOffset : a && Types$$module$build$src$core$renderers$measurables$types.isLeftRoundedCorner(a) && b && (Types$$module$build$src$core$renderers$measurables$types.isPreviousConnection(b) || Types$$module$build$src$core$renderers$measurables$types.isNextConnection(b)) ? b.notchOffset - this.constants_.CORNER_RADIUS : this.constants_.MEDIUM_PADDING;
        }
        computeBounds_() {
            let a = 0, b = 0, c = 0;
            for(let e = 0, f; f = this.rows[e]; e++){
                f.measure();
                b = Math.max(b, f.width);
                if (f.hasStatement) {
                    var d = f.getLastInput();
                    let g, h;
                    d = f.width - (null != (h = null == (g = d) ? void 0 : g.width) ? h : 0);
                    a = Math.max(a, d);
                }
                c = Math.max(c, f.widthWithConnectedBlocks);
            }
            this.statementEdge = a;
            this.width = b;
            for(let e = 0, f; f = this.rows[e]; e++)f.hasStatement && (f.statementEdge = this.statementEdge);
            this.widthWithChildren = Math.max(b, c);
            this.outputConnection && (this.startX = this.outputConnection.width, this.width += this.outputConnection.width, this.widthWithChildren += this.outputConnection.width);
        }
        alignRowElements_() {
            for(let b = 0, c; c = this.rows[b]; b++)if (c.hasStatement) this.alignStatementRow_(c);
            else {
                var a = c.width;
                a = this.getDesiredRowWidth_(c) - a;
                0 < a && this.addAlignmentPadding_(c, a);
                Types$$module$build$src$core$renderers$measurables$types.isTopOrBottomRow(c) && (c.widthWithConnectedBlocks = c.width);
            }
        }
        getDesiredRowWidth_(a) {
            return this.width - this.startX;
        }
        addAlignmentPadding_(a, b) {
            const c = a.getFirstSpacer(), d = a.getLastSpacer();
            if (a.hasExternalInput || a.hasStatement) a.widthWithConnectedBlocks += b;
            if (a.align === $.Align$$module$build$src$core$input.LEFT && d) d.width += b;
            else if (a.align === $.Align$$module$build$src$core$input.CENTRE && c && d) c.width += b / 2, d.width += b / 2;
            else if (a.align === $.Align$$module$build$src$core$input.RIGHT && c) c.width += b;
            else if (d) d.width += b;
            else return;
            a.width += b;
        }
        alignStatementRow_(a) {
            const b = a.getLastInput();
            if (b) {
                var c = a.width - b.width, d = this.statementEdge;
                c = d - c;
                0 < c && this.addAlignmentPadding_(a, c);
                c = a.width;
                d = this.getDesiredRowWidth_(a);
                b.width += d - c;
                b.height = Math.max(b.height, a.height);
                a.width += d - c;
                a.widthWithConnectedBlocks = Math.max(a.width, this.statementEdge + a.connectedBlockWidths);
            }
        }
        addRowSpacing_() {
            const a = this.rows;
            this.rows = [];
            for(let b = 0; b < a.length; b++)this.rows.push(a[b]), b !== a.length - 1 && this.rows.push(this.makeSpacerRow_(a[b], a[b + 1]));
        }
        makeSpacerRow_(a, b) {
            var c = this.getSpacerRowHeight_(a, b);
            const d = this.getSpacerRowWidth_(a, b);
            c = new SpacerRow$$module$build$src$core$renderers$measurables$spacer_row(this.constants_, c, d);
            a.hasStatement && (c.followsStatement = !0);
            b.hasStatement && (c.precedesStatement = !0);
            return c;
        }
        getSpacerRowWidth_(a, b) {
            return this.width - this.startX;
        }
        getSpacerRowHeight_(a, b) {
            return this.constants_.MEDIUM_PADDING;
        }
        getElemCenterline_(a, b) {
            return Types$$module$build$src$core$renderers$measurables$types.isSpacer(b) ? a.yPos + b.height / 2 : Types$$module$build$src$core$renderers$measurables$types.isBottomRow(a) ? (a = a.yPos + a.height - a.descenderHeight, Types$$module$build$src$core$renderers$measurables$types.isNextConnection(b) ? a + b.height / 2 : a - b.height / 2) : Types$$module$build$src$core$renderers$measurables$types.isTopRow(a) ? Types$$module$build$src$core$renderers$measurables$types.isHat(b) ? a.capline - b.height / 2 : a.capline + b.height / 2 : a.yPos + a.height / 2;
        }
        recordElemPositions_(a) {
            let b = a.xPos;
            for(let c = 0, d; d = a.elements[c]; c++)Types$$module$build$src$core$renderers$measurables$types.isSpacer(d) && (d.height = a.height), d.xPos = b, d.centerline = this.getElemCenterline_(a, d), b += d.width;
        }
        finalize_() {
            let a = 0, b = 0;
            for(let c = 0, d; d = this.rows[c]; c++)d.yPos = b, d.xPos = this.startX, b += d.height, a = Math.max(a, d.widthWithConnectedBlocks), this.recordElemPositions_(d);
            if (this.outputConnection && this.block_.nextConnection) {
                const c = this.block_.nextConnection.targetBlock();
                c && (a = Math.max(a, c.getHeightWidth().width));
            }
            this.widthWithChildren = a + this.startX;
            this.height = b;
            this.startY = this.topRow.capline;
            this.bottomRow.baseline = b - this.bottomRow.descenderHeight;
        }
    }, module$build$src$core$renderers$common$info = {};
    module$build$src$core$renderers$common$info.RenderInfo = RenderInfo$$module$build$src$core$renderers$common$info;
    var CURSOR_CLASS$$module$build$src$core$renderers$common$marker_svg = "blocklyCursor", MARKER_CLASS$$module$build$src$core$renderers$common$marker_svg = "blocklyMarker", HEIGHT_MULTIPLIER$$module$build$src$core$renderers$common$marker_svg = .75, MarkerSvg$$module$build$src$core$renderers$common$marker_svg = class {
        constructor(a, b, c){
            this.workspace = a;
            this.marker = c;
            this.markerSvgRect_ = this.markerSvgLine_ = this.markerInput_ = this.markerBlock_ = this.svgGroup_ = this.markerSvg_ = this.currentMarkerSvg = this.parent_ = null;
            this.constants_ = b;
            a = this.isCursor() ? this.constants_.CURSOR_COLOUR : this.constants_.MARKER_COLOUR;
            this.colour_ = c.colour || a;
        }
        getSvgRoot() {
            return this.svgGroup_;
        }
        getMarker() {
            return this.marker;
        }
        isCursor() {
            return "cursor" === this.marker.type;
        }
        createDom() {
            const a = this.isCursor() ? CURSOR_CLASS$$module$build$src$core$renderers$common$marker_svg : MARKER_CLASS$$module$build$src$core$renderers$common$marker_svg;
            this.svgGroup_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {
                "class": a
            });
            this.createDomInternal_();
            return this.svgGroup_;
        }
        setParent_(a) {
            this.isCursor() ? (this.parent_ && this.parent_.setCursorSvg(null), a.setCursorSvg(this.getSvgRoot())) : (this.parent_ && this.parent_.setMarkerSvg(null), a.setMarkerSvg(this.getSvgRoot()));
            this.parent_ = a;
        }
        draw(a, b) {
            if (b) {
                this.constants_ = this.workspace.getRenderer().getConstants();
                var c = this.isCursor() ? this.constants_.CURSOR_COLOUR : this.constants_.MARKER_COLOUR;
                this.colour_ = this.marker.colour || c;
                this.applyColour_(b);
                this.showAtLocation_(b);
                this.fireMarkerEvent_(a, b);
                a = this.currentMarkerSvg.childNodes[0];
                void 0 !== a && a.beginElement && a.beginElement();
            } else this.hide();
        }
        showAtLocation_(a) {
            const b = a.getLocation().type;
            a.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.BLOCK ? this.showWithBlock_(a) : a.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.OUTPUT ? this.showWithOutput_(a) : b === ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE ? this.showWithInput_(a) : b === ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT ? this.showWithNext_(a) : a.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.PREVIOUS ? this.showWithPrevious_(a) : a.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.FIELD ? this.showWithField_(a) : a.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.WORKSPACE ? this.showWithCoordinates_(a) : a.getType() === ASTNode$$module$build$src$core$keyboard_nav$ast_node.types.STACK && this.showWithStack_(a);
        }
        showWithBlockPrevOutput_(a) {
            a = a.getSourceBlock();
            const b = a.width;
            var c = a.height, d = c * HEIGHT_MULTIPLIER$$module$build$src$core$renderers$common$marker_svg;
            const e = this.constants_.CURSOR_BLOCK_PADDING;
            a.previousConnection ? (c = this.constants_.shapeFor(a.previousConnection), this.positionPrevious_(b, e, d, c)) : a.outputConnection ? (d = this.constants_.shapeFor(a.outputConnection), this.positionOutput_(b, c, d)) : this.positionBlock_(b, e, d);
            this.setParent_(a);
            this.showCurrent_();
        }
        showWithBlock_(a) {
            this.showWithBlockPrevOutput_(a);
        }
        showWithPrevious_(a) {
            this.showWithBlockPrevOutput_(a);
        }
        showWithOutput_(a) {
            this.showWithBlockPrevOutput_(a);
        }
        showWithCoordinates_(a) {
            var b = a.getWsCoordinate();
            a = b.x;
            b = b.y;
            this.workspace.RTL && (a -= this.constants_.CURSOR_WS_WIDTH);
            this.positionLine_(a, b, this.constants_.CURSOR_WS_WIDTH);
            this.setParent_(this.workspace);
            this.showCurrent_();
        }
        showWithField_(a) {
            a = a.getLocation();
            const b = a.getSize().width, c = a.getSize().height;
            this.positionRect_(0, 0, b, c);
            this.setParent_(a);
            this.showCurrent_();
        }
        showWithInput_(a) {
            a = a.getLocation();
            const b = a.getSourceBlock();
            this.positionInput_(a);
            this.setParent_(b);
            this.showCurrent_();
        }
        showWithNext_(a) {
            var b = a.getLocation();
            a = b.getSourceBlock();
            let c = 0;
            b = b.getOffsetInBlock().y;
            const d = a.getHeightWidth().width;
            this.workspace.RTL && (c = -d);
            this.positionLine_(c, b, d);
            this.setParent_(a);
            this.showCurrent_();
        }
        showWithStack_(a) {
            a = a.getLocation();
            var b = a.getHeightWidth();
            const c = b.width + this.constants_.CURSOR_STACK_PADDING;
            b = b.height + this.constants_.CURSOR_STACK_PADDING;
            const d = -this.constants_.CURSOR_STACK_PADDING / 2, e = -this.constants_.CURSOR_STACK_PADDING / 2;
            let f = d;
            this.workspace.RTL && (f = -(c + d));
            this.positionRect_(f, e, c, b);
            this.setParent_(a);
            this.showCurrent_();
        }
        showCurrent_() {
            this.hide();
            this.currentMarkerSvg && (this.currentMarkerSvg.style.display = "");
        }
        positionBlock_(a, b, c) {
            a = moveBy$$module$build$src$core$utils$svg_paths(-b, c) + lineOnAxis$$module$build$src$core$utils$svg_paths("V", -b) + lineOnAxis$$module$build$src$core$utils$svg_paths("H", a + 2 * b) + lineOnAxis$$module$build$src$core$utils$svg_paths("V", c);
            if (!this.markerBlock_) throw Error("createDom should be called before positioning the marker");
            this.markerBlock_.setAttribute("d", a);
            this.workspace.RTL && this.flipRtl_(this.markerBlock_);
            this.currentMarkerSvg = this.markerBlock_;
        }
        positionInput_(a) {
            const b = a.getOffsetInBlock().x, c = a.getOffsetInBlock().y;
            a = moveTo$$module$build$src$core$utils$svg_paths(0, 0) + this.constants_.shapeFor(a).pathDown;
            this.markerInput_.setAttribute("d", a);
            this.markerInput_.setAttribute("transform", "translate(" + b + "," + c + ")" + (this.workspace.RTL ? " scale(-1 1)" : ""));
            this.currentMarkerSvg = this.markerInput_;
        }
        positionLine_(a, b, c) {
            if (!this.markerSvgLine_) throw Error("createDom should be called before positioning the line");
            this.markerSvgLine_.setAttribute("x", `${a}`);
            this.markerSvgLine_.setAttribute("y", `${b}`);
            this.markerSvgLine_.setAttribute("width", `${c}`);
            this.currentMarkerSvg = this.markerSvgLine_;
        }
        positionOutput_(a, b, c) {
            if (!this.markerBlock_) throw Error("createDom should be called before positioning the output");
            a = moveBy$$module$build$src$core$utils$svg_paths(a, 0) + lineOnAxis$$module$build$src$core$utils$svg_paths("h", -(a - c.width)) + lineOnAxis$$module$build$src$core$utils$svg_paths("v", this.constants_.TAB_OFFSET_FROM_TOP) + c.pathDown + lineOnAxis$$module$build$src$core$utils$svg_paths("V", b) + lineOnAxis$$module$build$src$core$utils$svg_paths("H", a);
            this.markerBlock_.setAttribute("d", a);
            this.workspace.RTL && this.flipRtl_(this.markerBlock_);
            this.currentMarkerSvg = this.markerBlock_;
        }
        positionPrevious_(a, b, c, d) {
            if (!this.markerBlock_) throw Error("createDom should be called before positioning the previous connection marker");
            a = moveBy$$module$build$src$core$utils$svg_paths(-b, c) + lineOnAxis$$module$build$src$core$utils$svg_paths("V", -b) + lineOnAxis$$module$build$src$core$utils$svg_paths("H", this.constants_.NOTCH_OFFSET_LEFT) + d.pathLeft + lineOnAxis$$module$build$src$core$utils$svg_paths("H", a + 2 * b) + lineOnAxis$$module$build$src$core$utils$svg_paths("V", c);
            this.markerBlock_.setAttribute("d", a);
            this.workspace.RTL && this.flipRtl_(this.markerBlock_);
            this.currentMarkerSvg = this.markerBlock_;
        }
        positionRect_(a, b, c, d) {
            if (!this.markerSvgRect_) throw Error("createDom should be called before positioning the rect");
            this.markerSvgRect_.setAttribute("x", `${a}`);
            this.markerSvgRect_.setAttribute("y", `${b}`);
            this.markerSvgRect_.setAttribute("width", `${c}`);
            this.markerSvgRect_.setAttribute("height", `${d}`);
            this.currentMarkerSvg = this.markerSvgRect_;
        }
        flipRtl_(a) {
            a.setAttribute("transform", "scale(-1 1)");
        }
        hide() {
            if (!(this.markerSvgLine_ && this.markerSvgRect_ && this.markerInput_ && this.markerBlock_)) throw Error("createDom should be called before hiding the marker");
            this.markerSvgLine_.style.display = "none";
            this.markerSvgRect_.style.display = "none";
            this.markerInput_.style.display = "none";
            this.markerBlock_.style.display = "none";
        }
        fireMarkerEvent_(a, b) {
            const c = b.getSourceBlock();
            a = new (get$$module$build$src$core$events$utils(MARKER_MOVE$$module$build$src$core$events$utils))(c, this.isCursor(), a, b);
            fire$$module$build$src$core$events$utils(a);
        }
        getBlinkProperties_() {
            return {
                attributeType: "XML",
                attributeName: "fill",
                dur: "1s",
                values: this.colour_ + ";transparent;transparent;",
                repeatCount: "indefinite"
            };
        }
        createDomInternal_() {
            this.markerSvg_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {
                width: this.constants_.CURSOR_WS_WIDTH,
                height: this.constants_.WS_CURSOR_HEIGHT
            }, this.svgGroup_);
            this.markerSvgLine_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                width: this.constants_.CURSOR_WS_WIDTH,
                height: this.constants_.WS_CURSOR_HEIGHT,
                style: "display: none"
            }, this.markerSvg_);
            this.markerSvgRect_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                "class": "blocklyVerticalMarker",
                rx: 10,
                ry: 10,
                style: "display: none"
            }, this.markerSvg_);
            this.markerInput_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATH, {
                transform: "",
                style: "display: none"
            }, this.markerSvg_);
            this.markerBlock_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATH, {
                transform: "",
                style: "display: none",
                fill: "none",
                "stroke-width": this.constants_.CURSOR_STROKE_WIDTH
            }, this.markerSvg_);
            if (this.isCursor()) {
                const a = this.getBlinkProperties_();
                createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.ANIMATE, a, this.markerSvgLine_);
                createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.ANIMATE, a, this.markerInput_);
                createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.ANIMATE, Object.assign({}, a, {
                    attributeName: "stroke"
                }), this.markerBlock_);
            }
            return this.markerSvg_;
        }
        applyColour_(a) {
            if (!(this.markerSvgLine_ && this.markerSvgRect_ && this.markerInput_ && this.markerBlock_)) throw Error("createDom should be called before applying color to the markerj");
            this.markerSvgLine_.setAttribute("fill", this.colour_);
            this.markerSvgRect_.setAttribute("stroke", this.colour_);
            this.markerInput_.setAttribute("fill", this.colour_);
            this.markerBlock_.setAttribute("stroke", this.colour_);
            this.isCursor() && (a = this.colour_ + ";transparent;transparent;", this.markerSvgLine_.firstElementChild.setAttribute("values", a), this.markerInput_.firstElementChild.setAttribute("values", a), this.markerBlock_.firstElementChild.setAttribute("values", a));
        }
        dispose() {
            this.svgGroup_ && removeNode$$module$build$src$core$utils$dom(this.svgGroup_);
        }
    }, module$build$src$core$renderers$common$marker_svg = {};
    module$build$src$core$renderers$common$marker_svg.MarkerSvg = MarkerSvg$$module$build$src$core$renderers$common$marker_svg;
    var PathObject$$module$build$src$core$renderers$common$path_object = class {
        constructor(a, b, c){
            this.markerSvg = this.cursorSvg = null;
            this.constants = c;
            this.style = b;
            this.svgRoot = a;
            this.svgPath = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATH, {
                "class": "blocklyPath"
            }, this.svgRoot);
        }
        setPath(a) {
            this.svgPath.setAttribute("d", a);
        }
        flipRTL() {
            this.svgPath.setAttribute("transform", "scale(-1 1)");
        }
        setCursorSvg(a) {
            a ? (this.svgRoot.appendChild(a), this.cursorSvg = a) : this.cursorSvg = null;
        }
        setMarkerSvg(a) {
            a ? (this.cursorSvg ? this.svgRoot.insertBefore(a, this.cursorSvg) : this.svgRoot.appendChild(a), this.markerSvg = a) : this.markerSvg = null;
        }
        applyColour(a) {
            this.svgPath.setAttribute("stroke", this.style.colourTertiary);
            this.svgPath.setAttribute("fill", this.style.colourPrimary);
            this.updateShadow_(a.isShadow());
            this.updateDisabled_(!a.isEnabled() || a.getInheritedDisabled());
        }
        setStyle(a) {
            this.style = a;
        }
        setClass_(a, b) {
            a && (b ? addClass$$module$build$src$core$utils$dom(this.svgRoot, a) : removeClass$$module$build$src$core$utils$dom(this.svgRoot, a));
        }
        updateHighlighted(a) {
            a ? this.svgPath.setAttribute("filter", "url(#" + this.constants.embossFilterId + ")") : this.svgPath.setAttribute("filter", "none");
        }
        updateShadow_(a) {
            a && (this.svgPath.setAttribute("stroke", "none"), this.svgPath.setAttribute("fill", this.style.colourSecondary));
        }
        updateDisabled_(a) {
            this.setClass_("blocklyDisabled", a);
            a && this.svgPath.setAttribute("fill", "url(#" + this.constants.disabledPatternId + ")");
        }
        updateSelected(a) {
            this.setClass_("blocklySelected", a);
        }
        updateDraggingDelete(a) {
            this.setClass_("blocklyDraggingDelete", a);
        }
        updateInsertionMarker(a) {
            this.setClass_("blocklyInsertionMarker", a);
        }
        updateMovable(a) {
            this.setClass_("blocklyDraggable", a);
        }
        updateReplacementFade(a) {
            this.setClass_("blocklyReplaceable", a);
        }
        updateShapeForInputHighlight(a, b) {}
    }, module$build$src$core$renderers$common$path_object = {};
    module$build$src$core$renderers$common$path_object.PathObject = PathObject$$module$build$src$core$renderers$common$path_object;
    var Renderer$$module$build$src$core$renderers$common$renderer = class {
        constructor(a){
            this.overrides = null;
            this.name = a;
        }
        getClassName() {
            return this.name + "-renderer";
        }
        init(a, b) {
            this.constants_ = this.makeConstants_();
            b && (this.overrides = b, Object.assign(this.constants_, b));
            this.constants_.setTheme(a);
            this.constants_.init();
        }
        createDom(a, b) {
            this.constants_.createDom(a, this.name + "-" + b.name, "." + this.getClassName() + "." + b.getClassName());
        }
        refreshDom(a, b) {
            const c = this.getConstants();
            c.dispose();
            this.constants_ = this.makeConstants_();
            this.overrides && Object.assign(this.constants_, this.overrides);
            this.constants_.randomIdentifier = c.randomIdentifier;
            this.constants_.setTheme(b);
            this.constants_.init();
            this.createDom(a, b);
        }
        dispose() {
            this.constants_ && this.constants_.dispose();
        }
        makeConstants_() {
            return new ConstantProvider$$module$build$src$core$renderers$common$constants;
        }
        makeRenderInfo_(a) {
            return new RenderInfo$$module$build$src$core$renderers$common$info(this, a);
        }
        makeDrawer_(a, b) {
            return new Drawer$$module$build$src$core$renderers$common$drawer(a, b);
        }
        makeDebugger_() {
            return new Debug$$module$build$src$core$renderers$common$debugger(this.getConstants());
        }
        makeMarkerDrawer(a, b) {
            return new MarkerSvg$$module$build$src$core$renderers$common$marker_svg(a, this.getConstants(), b);
        }
        makePathObject(a, b) {
            return new PathObject$$module$build$src$core$renderers$common$path_object(a, b, this.constants_);
        }
        getConstants() {
            return this.constants_;
        }
        shouldHighlightConnection(a) {
            return !0;
        }
        orphanCanConnectAtEnd(a, b, c) {
            return !!Connection$$module$build$src$core$connection.getConnectionForOrphanedConnection(a, c === ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE ? b.outputConnection : b.previousConnection);
        }
        getConnectionPreviewMethod(a, b, c) {
            return b.type === ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE || b.type === ConnectionType$$module$build$src$core$connection_type.PREVIOUS_STATEMENT ? !a.isConnected() || this.orphanCanConnectAtEnd(c, a.targetBlock(), b.type) ? InsertionMarkerManager$$module$build$src$core$insertion_marker_manager.PREVIEW_TYPE.INSERTION_MARKER : InsertionMarkerManager$$module$build$src$core$insertion_marker_manager.PREVIEW_TYPE.REPLACEMENT_FADE : InsertionMarkerManager$$module$build$src$core$insertion_marker_manager.PREVIEW_TYPE.INSERTION_MARKER;
        }
        render(a) {
            isDebuggerEnabled$$module$build$src$core$renderers$common$debug() && !a.renderingDebugger && (a.renderingDebugger = this.makeDebugger_());
            const b = this.makeRenderInfo_(a);
            b.measure();
            this.makeDrawer_(a, b).draw();
        }
    }, module$build$src$core$renderers$common$renderer = {};
    module$build$src$core$renderers$common$renderer.Renderer = Renderer$$module$build$src$core$renderers$common$renderer;
    var module$build$src$core$renderers$common$block_rendering = {};
    module$build$src$core$renderers$common$block_rendering.BottomRow = BottomRow$$module$build$src$core$renderers$measurables$bottom_row;
    module$build$src$core$renderers$common$block_rendering.Connection = Connection$$module$build$src$core$renderers$measurables$connection;
    module$build$src$core$renderers$common$block_rendering.ConstantProvider = ConstantProvider$$module$build$src$core$renderers$common$constants;
    module$build$src$core$renderers$common$block_rendering.Debug = Debug$$module$build$src$core$renderers$common$debugger;
    module$build$src$core$renderers$common$block_rendering.Drawer = Drawer$$module$build$src$core$renderers$common$drawer;
    module$build$src$core$renderers$common$block_rendering.ExternalValueInput = ExternalValueInput$$module$build$src$core$renderers$measurables$external_value_input;
    module$build$src$core$renderers$common$block_rendering.Field = Field$$module$build$src$core$renderers$measurables$field;
    module$build$src$core$renderers$common$block_rendering.Hat = Hat$$module$build$src$core$renderers$measurables$hat;
    module$build$src$core$renderers$common$block_rendering.Icon = Icon$$module$build$src$core$renderers$measurables$icon;
    module$build$src$core$renderers$common$block_rendering.InRowSpacer = InRowSpacer$$module$build$src$core$renderers$measurables$in_row_spacer;
    module$build$src$core$renderers$common$block_rendering.InlineInput = InlineInput$$module$build$src$core$renderers$measurables$inline_input;
    module$build$src$core$renderers$common$block_rendering.InputConnection = InputConnection$$module$build$src$core$renderers$measurables$input_connection;
    module$build$src$core$renderers$common$block_rendering.InputRow = InputRow$$module$build$src$core$renderers$measurables$input_row;
    module$build$src$core$renderers$common$block_rendering.JaggedEdge = JaggedEdge$$module$build$src$core$renderers$measurables$jagged_edge;
    module$build$src$core$renderers$common$block_rendering.MarkerSvg = MarkerSvg$$module$build$src$core$renderers$common$marker_svg;
    module$build$src$core$renderers$common$block_rendering.Measurable = Measurable$$module$build$src$core$renderers$measurables$base;
    module$build$src$core$renderers$common$block_rendering.NextConnection = NextConnection$$module$build$src$core$renderers$measurables$next_connection;
    module$build$src$core$renderers$common$block_rendering.OutputConnection = OutputConnection$$module$build$src$core$renderers$measurables$output_connection;
    module$build$src$core$renderers$common$block_rendering.PathObject = PathObject$$module$build$src$core$renderers$common$path_object;
    module$build$src$core$renderers$common$block_rendering.PreviousConnection = PreviousConnection$$module$build$src$core$renderers$measurables$previous_connection;
    module$build$src$core$renderers$common$block_rendering.RenderInfo = RenderInfo$$module$build$src$core$renderers$common$info;
    module$build$src$core$renderers$common$block_rendering.Renderer = Renderer$$module$build$src$core$renderers$common$renderer;
    module$build$src$core$renderers$common$block_rendering.RoundCorner = RoundCorner$$module$build$src$core$renderers$measurables$round_corner;
    module$build$src$core$renderers$common$block_rendering.Row = Row$$module$build$src$core$renderers$measurables$row;
    module$build$src$core$renderers$common$block_rendering.SpacerRow = SpacerRow$$module$build$src$core$renderers$measurables$spacer_row;
    module$build$src$core$renderers$common$block_rendering.SquareCorner = SquareCorner$$module$build$src$core$renderers$measurables$square_corner;
    module$build$src$core$renderers$common$block_rendering.StatementInput = StatementInput$$module$build$src$core$renderers$measurables$statement_input;
    module$build$src$core$renderers$common$block_rendering.TopRow = TopRow$$module$build$src$core$renderers$measurables$top_row;
    module$build$src$core$renderers$common$block_rendering.Types = Types$$module$build$src$core$renderers$measurables$types;
    module$build$src$core$renderers$common$block_rendering.init = init$$module$build$src$core$renderers$common$block_rendering;
    module$build$src$core$renderers$common$block_rendering.register = register$$module$build$src$core$renderers$common$block_rendering;
    module$build$src$core$renderers$common$block_rendering.stopDebugger = stopDebugger$$module$build$src$core$renderers$common$block_rendering;
    module$build$src$core$renderers$common$block_rendering.unregister = unregister$$module$build$src$core$renderers$common$block_rendering;
    var ThemeManager$$module$build$src$core$theme_manager = class {
        constructor(a, b){
            this.workspace = a;
            this.theme = b;
            this.subscribedWorkspaces_ = [];
            this.componentDB = new Map;
        }
        getTheme() {
            return this.theme;
        }
        setTheme(a) {
            var b = this.theme;
            this.theme = a;
            if (a = this.workspace.getInjectionDiv()) b && (b = b.getClassName()) && removeClass$$module$build$src$core$utils$dom(a, b), (b = this.theme.getClassName()) && addClass$$module$build$src$core$utils$dom(a, b);
            for(let c = 0, d; d = this.subscribedWorkspaces_[c]; c++)d.refreshTheme();
            for (const [c, d] of this.componentDB)for (const e of d){
                a = e.element;
                b = e.propertyName;
                const f = this.theme && this.theme.getComponentStyle(c);
                a.style.setProperty(b, f || "");
            }
            for (const c of this.subscribedWorkspaces_)c.hideChaff();
        }
        subscribeWorkspace(a) {
            this.subscribedWorkspaces_.push(a);
        }
        unsubscribeWorkspace(a) {
            if (!removeElem$$module$build$src$core$utils$array(this.subscribedWorkspaces_, a)) throw Error("Cannot unsubscribe a workspace that hasn't been subscribed.");
        }
        subscribe(a, b, c) {
            this.componentDB.has(b) || this.componentDB.set(b, []);
            this.componentDB.get(b).push({
                element: a,
                propertyName: c
            });
            b = this.theme && this.theme.getComponentStyle(b);
            a.style.setProperty(c, b || "");
        }
        unsubscribe(a) {
            if (a) for (const [b, c] of this.componentDB){
                for(let d = c.length - 1; 0 <= d; d--)c[d].element === a && c.splice(d, 1);
                c.length || this.componentDB.delete(b);
            }
        }
        dispose() {
            this.subscribedWorkspaces_.length = 0;
            this.componentDB.clear();
        }
    }, module$build$src$core$theme_manager = {};
    module$build$src$core$theme_manager.ThemeManager = ThemeManager$$module$build$src$core$theme_manager;
    var CATEGORY_NAME$$module$build$src$core$variables_dynamic = "VARIABLE_DYNAMIC", onCreateVariableButtonClick_String$$module$build$src$core$variables_dynamic = stringButtonClickHandler$$module$build$src$core$variables_dynamic, onCreateVariableButtonClick_Number$$module$build$src$core$variables_dynamic = numberButtonClickHandler$$module$build$src$core$variables_dynamic, onCreateVariableButtonClick_Colour$$module$build$src$core$variables_dynamic = colourButtonClickHandler$$module$build$src$core$variables_dynamic, module$build$src$core$variables_dynamic = {};
    module$build$src$core$variables_dynamic.CATEGORY_NAME = CATEGORY_NAME$$module$build$src$core$variables_dynamic;
    module$build$src$core$variables_dynamic.flyoutCategory = flyoutCategory$$module$build$src$core$variables_dynamic;
    module$build$src$core$variables_dynamic.flyoutCategoryBlocks = flyoutCategoryBlocks$$module$build$src$core$variables_dynamic;
    module$build$src$core$variables_dynamic.onCreateVariableButtonClick_Colour = colourButtonClickHandler$$module$build$src$core$variables_dynamic;
    module$build$src$core$variables_dynamic.onCreateVariableButtonClick_Number = numberButtonClickHandler$$module$build$src$core$variables_dynamic;
    module$build$src$core$variables_dynamic.onCreateVariableButtonClick_String = stringButtonClickHandler$$module$build$src$core$variables_dynamic;
    var VariableMap$$module$build$src$core$variable_map = class {
        constructor(a){
            this.workspace = a;
            this.variableMap = new Map;
        }
        clear() {
            for (const a of this.variableMap.values())for(; 0 < a.length;)this.deleteVariable(a[0]);
            if (0 !== this.variableMap.size) throw Error("Non-empty variable map");
        }
        renameVariable(a, b) {
            if (a.name !== b) {
                var c = this.getVariable(b, a.type), d = this.workspace.getAllBlocks(!1), e = getGroup$$module$build$src$core$events$utils();
                e || setGroup$$module$build$src$core$events$utils(!0);
                try {
                    c && c.getId() !== a.getId() ? this.renameVariableWithConflict_(a, b, c, d) : this.renameVariableAndUses_(a, b, d);
                } finally{
                    setGroup$$module$build$src$core$events$utils(e);
                }
            }
        }
        renameVariableById(a, b) {
            const c = this.getVariableById(a);
            if (!c) throw Error("Tried to rename a variable that didn't exist. ID: " + a);
            this.renameVariable(c, b);
        }
        renameVariableAndUses_(a, b, c) {
            fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(VAR_RENAME$$module$build$src$core$events$utils))(a, b));
            a.name = b;
            for(b = 0; b < c.length; b++)c[b].updateVarName(a);
        }
        renameVariableWithConflict_(a, b, c, d) {
            const e = a.type;
            b !== c.name && this.renameVariableAndUses_(c, b, d);
            for(b = 0; b < d.length; b++)d[b].renameVarById(a.getId(), c.getId());
            fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(VAR_DELETE$$module$build$src$core$events$utils))(a));
            removeElem$$module$build$src$core$utils$array(this.variableMap.get(e), a);
        }
        createVariable(a, b, c) {
            var d = this.getVariable(a, b);
            if (d) {
                if (c && d.getId() !== c) throw Error('Variable "' + a + '" is already in use and its id is "' + d.getId() + '" which conflicts with the passed in id, "' + c + '".');
                return d;
            }
            if (c && this.getVariableById(c)) throw Error('Variable id, "' + c + '", is already in use.');
            d = c || genUid$$module$build$src$core$utils$idgenerator();
            b = b || "";
            d = new VariableModel$$module$build$src$core$variable_model(this.workspace, a, b, d);
            a = this.variableMap.get(b) || [];
            a.push(d);
            this.variableMap.delete(b);
            this.variableMap.set(b, a);
            fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(VAR_CREATE$$module$build$src$core$events$utils))(d));
            return d;
        }
        deleteVariable(a) {
            const b = a.getId(), c = this.variableMap.get(a.type);
            if (c) {
                for(let d = 0; d < c.length; d++)if (c[d].getId() === b) {
                    c.splice(d, 1);
                    fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(VAR_DELETE$$module$build$src$core$events$utils))(a));
                    0 === c.length && this.variableMap.delete(a.type);
                    break;
                }
            }
        }
        deleteVariableById(a) {
            const b = this.getVariableById(a);
            if (b) {
                var c = b.name;
                const d = this.getVariableUsesById(a);
                for(let e = 0, f; f = d[e]; e++)if ("procedures_defnoreturn" === f.type || "procedures_defreturn" === f.type) {
                    a = String(f.getFieldValue("NAME"));
                    c = Msg$$module$build$src$core$msg.CANNOT_DELETE_VARIABLE_PROCEDURE.replace("%1", c).replace("%2", a);
                    alert$$module$build$src$core$dialog(c);
                    return;
                }
                1 < d.length ? (c = Msg$$module$build$src$core$msg.DELETE_VARIABLE_CONFIRMATION.replace("%1", String(d.length)).replace("%2", c), confirm$$module$build$src$core$dialog(c, (e)=>{
                    e && b && this.deleteVariableInternal(b, d);
                })) : this.deleteVariableInternal(b, d);
            } else console.warn("Can't delete non-existent variable: " + a);
        }
        deleteVariableInternal(a, b) {
            const c = getGroup$$module$build$src$core$events$utils();
            c || setGroup$$module$build$src$core$events$utils(!0);
            try {
                for(let d = 0; d < b.length; d++)b[d].dispose(!0);
                this.deleteVariable(a);
            } finally{
                setGroup$$module$build$src$core$events$utils(c);
            }
        }
        getVariable(a, b) {
            if (b = this.variableMap.get(b || "")) {
                for(let c = 0, d; d = b[c]; c++)if (Names$$module$build$src$core$names.equals(d.name, a)) return d;
            }
            return null;
        }
        getVariableById(a) {
            for (const b of this.variableMap.values())for (const c of b)if (c.getId() === a) return c;
            return null;
        }
        getVariablesOfType(a) {
            return (a = this.variableMap.get(a || "")) ? a.slice() : [];
        }
        getVariableTypes(a) {
            const b = new Set(this.variableMap.keys());
            if (a && a.getPotentialVariableMap()) for (const c of a.getPotentialVariableMap().variableMap.keys())b.add(c);
            b.has("") || b.add("");
            return Array.from(b.values());
        }
        getAllVariables() {
            let a = [];
            for (const b of this.variableMap.values())a = a.concat(b);
            return a;
        }
        getAllVariableNames() {
            return Array.from(this.variableMap.values()).flat().map((a)=>a.name);
        }
        getVariableUsesById(a) {
            const b = [], c = this.workspace.getAllBlocks(!1);
            for(let d = 0; d < c.length; d++){
                const e = c[d].getVarModels();
                if (e) for(let f = 0; f < e.length; f++)e[f].getId() === a && b.push(c[d]);
            }
            return b;
        }
    }, module$build$src$core$variable_map = {};
    module$build$src$core$variable_map.VariableMap = VariableMap$$module$build$src$core$variable_map;
    var Workspace$$module$build$src$core$workspace = class {
        get isFlyout() {
            return this.internalIsFlyout;
        }
        get isMutator() {
            return this.internalIsMutator;
        }
        constructor(a){
            this.isClearing = this.internalIsMutator = this.internalIsFlyout = this.rendered = !1;
            this.MAX_UNDO = 1024;
            this.connectionDBList = [];
            this.topBlocks = [];
            this.topComments = [];
            this.commentDB = new Map;
            this.listeners = [];
            this.undoStack_ = [];
            this.redoStack_ = [];
            this.blockDB = new Map;
            this.typedBlocksDB = new Map;
            this.procedureMap = new ObservableProcedureMap$$module$build$src$core$observable_procedure_map;
            this.potentialVariableMap = null;
            this.id = genUid$$module$build$src$core$utils$idgenerator();
            registerWorkspace$$module$build$src$core$common(this);
            this.options = a || new Options$$module$build$src$core$options({});
            this.RTL = !!this.options.RTL;
            this.horizontalLayout = !!this.options.horizontalLayout;
            this.toolboxPosition = this.options.toolboxPosition;
            this.connectionChecker = new (getClassFromOptions$$module$build$src$core$registry(Type$$module$build$src$core$registry.CONNECTION_CHECKER, this.options, !0))(this);
            this.variableMap = new VariableMap$$module$build$src$core$variable_map(this);
        }
        dispose() {
            this.listeners.length = 0;
            this.clear();
            unregisterWorkpace$$module$build$src$core$common(this);
        }
        sortObjects_(a, b) {
            const c = Math.sin(toRadians$$module$build$src$core$utils$math(Workspace$$module$build$src$core$workspace.SCAN_ANGLE)) * (this.RTL ? -1 : 1);
            a = a.getRelativeToSurfaceXY();
            b = b.getRelativeToSurfaceXY();
            return a.y + c * a.x - (b.y + c * b.x);
        }
        addTopBlock(a) {
            this.topBlocks.push(a);
        }
        removeTopBlock(a) {
            if (!removeElem$$module$build$src$core$utils$array(this.topBlocks, a)) throw Error("Block not present in workspace's list of top-most blocks.");
        }
        getTopBlocks(a) {
            const b = [].concat(this.topBlocks);
            a && 1 < b.length && b.sort(this.sortObjects_.bind(this));
            return b;
        }
        addTypedBlock(a) {
            this.typedBlocksDB.has(a.type) || this.typedBlocksDB.set(a.type, []);
            this.typedBlocksDB.get(a.type).push(a);
        }
        removeTypedBlock(a) {
            removeElem$$module$build$src$core$utils$array(this.typedBlocksDB.get(a.type), a);
            this.typedBlocksDB.get(a.type).length || this.typedBlocksDB.delete(a.type);
        }
        getBlocksByType(a, b) {
            if (!this.typedBlocksDB.has(a)) return [];
            a = this.typedBlocksDB.get(a).slice(0);
            b && a && 1 < a.length && a.sort(this.sortObjects_.bind(this));
            return a.filter(function(c) {
                return !c.isInsertionMarker();
            });
        }
        addTopComment(a) {
            this.topComments.push(a);
            this.commentDB.has(a.id) && console.warn('Overriding an existing comment on this workspace, with id "' + a.id + '"');
            this.commentDB.set(a.id, a);
        }
        removeTopComment(a) {
            if (!removeElem$$module$build$src$core$utils$array(this.topComments, a)) throw Error("Comment not present in workspace's list of top-most comments.");
            this.commentDB.delete(a.id);
        }
        getTopComments(a) {
            const b = [].concat(this.topComments);
            a && 1 < b.length && b.sort(this.sortObjects_.bind(this));
            return b;
        }
        getAllBlocks(a) {
            if (a) {
                var b = this.getTopBlocks(!0);
                a = [];
                for(let c = 0; c < b.length; c++)a.push(...b[c].getDescendants(!0));
            } else for(a = this.getTopBlocks(!1), b = 0; b < a.length; b++)a.push(...a[b].getChildren(!1));
            return a.filter(function(c) {
                return !c.isInsertionMarker();
            });
        }
        clear() {
            this.isClearing = !0;
            try {
                const a = getGroup$$module$build$src$core$events$utils();
                for(a || setGroup$$module$build$src$core$events$utils(!0); this.topBlocks.length;)this.topBlocks[0].dispose(!1);
                for(; this.topComments.length;)this.topComments[this.topComments.length - 1].dispose();
                setGroup$$module$build$src$core$events$utils(a);
                this.variableMap.clear();
                this.potentialVariableMap && this.potentialVariableMap.clear();
            } finally{
                this.isClearing = !1;
            }
        }
        renameVariableById(a, b) {
            this.variableMap.renameVariableById(a, b);
        }
        createVariable(a, b, c) {
            return this.variableMap.createVariable(a, b, c);
        }
        getVariableUsesById(a) {
            return this.variableMap.getVariableUsesById(a);
        }
        deleteVariableById(a) {
            this.variableMap.deleteVariableById(a);
        }
        getVariable(a, b) {
            return this.variableMap.getVariable(a, b);
        }
        getVariableById(a) {
            return this.variableMap.getVariableById(a);
        }
        getVariablesOfType(a) {
            return this.variableMap.getVariablesOfType(a);
        }
        getVariableTypes() {
            return this.variableMap.getVariableTypes(this);
        }
        getAllVariables() {
            return this.variableMap.getAllVariables();
        }
        getAllVariableNames() {
            return this.variableMap.getAllVariableNames();
        }
        getWidth() {
            return 0;
        }
        newBlock(a, b) {
            throw Error("The implementation of newBlock should be monkey-patched in by blockly.ts");
        }
        remainingCapacity() {
            return isNaN(this.options.maxBlocks) ? Infinity : this.options.maxBlocks - this.getAllBlocks(!1).length;
        }
        remainingCapacityOfType(a) {
            return this.options.maxInstances ? (void 0 !== this.options.maxInstances[a] ? this.options.maxInstances[a] : Infinity) - this.getBlocksByType(a, !1).length : Infinity;
        }
        isCapacityAvailable(a) {
            if (!this.hasBlockLimits()) return !0;
            let b = 0;
            for(const c in a){
                if (a[c] > this.remainingCapacityOfType(c)) return !1;
                b += a[c];
            }
            return b > this.remainingCapacity() ? !1 : !0;
        }
        hasBlockLimits() {
            return Infinity !== this.options.maxBlocks || !!this.options.maxInstances;
        }
        getUndoStack() {
            return this.undoStack_;
        }
        getRedoStack() {
            return this.redoStack_;
        }
        undo(a) {
            var b = a ? this.redoStack_ : this.undoStack_, c = a ? this.undoStack_ : this.redoStack_;
            const d = b.pop();
            if (d) {
                for(var e = [
                    d
                ]; b.length && d.group && d.group === b[b.length - 1].group;){
                    const f = b.pop();
                    f && e.push(f);
                }
                for(b = 0; b < e.length; b++)c.push(e[b]);
                e = filter$$module$build$src$core$events$utils(e, a);
                setRecordUndo$$module$build$src$core$events$utils(!1);
                try {
                    for(c = 0; c < e.length; c++)e[c].run(a);
                } finally{
                    setRecordUndo$$module$build$src$core$events$utils(!0);
                }
            }
        }
        clearUndo() {
            this.undoStack_.length = 0;
            this.redoStack_.length = 0;
            clearPendingUndo$$module$build$src$core$events$utils();
        }
        addChangeListener(a) {
            this.listeners.push(a);
            return a;
        }
        removeChangeListener(a) {
            removeElem$$module$build$src$core$utils$array(this.listeners, a);
        }
        fireChangeListener(a) {
            if (a.recordUndo) for(this.undoStack_.push(a), this.redoStack_.length = 0; this.undoStack_.length > this.MAX_UNDO && 0 <= this.MAX_UNDO;)this.undoStack_.shift();
            for(let b = 0; b < this.listeners.length; b++)(0, this.listeners[b])(a);
        }
        getBlockById(a) {
            return this.blockDB.get(a) || null;
        }
        setBlockById(a, b) {
            this.blockDB.set(a, b);
        }
        removeBlockById(a) {
            this.blockDB.delete(a);
        }
        getCommentById(a) {
            let b;
            return null != (b = this.commentDB.get(a)) ? b : null;
        }
        allInputsFilled(a) {
            const b = this.getTopBlocks(!1);
            for(let c = 0; c < b.length; c++)if (!b[c].allInputsFilled(a)) return !1;
            return !0;
        }
        getPotentialVariableMap() {
            return this.potentialVariableMap;
        }
        createPotentialVariableMap() {
            this.potentialVariableMap = new VariableMap$$module$build$src$core$variable_map(this);
        }
        getVariableMap() {
            return this.variableMap;
        }
        setVariableMap(a) {
            this.variableMap = a;
        }
        getProcedureMap() {
            return this.procedureMap;
        }
        static getById(a) {
            return getWorkspaceById$$module$build$src$core$common(a);
        }
        static getAll() {
            return getAllWorkspaces$$module$build$src$core$common();
        }
    };
    Workspace$$module$build$src$core$workspace.SCAN_ANGLE = 3;
    var module$build$src$core$workspace = {};
    module$build$src$core$workspace.Workspace = Workspace$$module$build$src$core$workspace;
    var SOUND_LIMIT$$module$build$src$core$workspace_audio = 100, WorkspaceAudio$$module$build$src$core$workspace_audio = class {
        constructor(a){
            this.parentWorkspace = a;
            this.sounds = new Map;
            this.lastSound_ = null;
        }
        dispose() {
            this.sounds.clear();
        }
        load(a, b) {
            if (a.length) {
                try {
                    var c = new globalThis.Audio;
                } catch (e) {
                    return;
                }
                for(let e = 0; e < a.length; e++){
                    const f = a[e], g = f.match(/\.(\w+)$/);
                    if (g && c.canPlayType("audio/" + g[1])) {
                        var d = new globalThis.Audio(f);
                        break;
                    }
                }
                d && this.sounds.set(b, d);
            }
        }
        preload() {
            for (const a of this.sounds.values()){
                a.volume = .01;
                const b = a.play();
                void 0 !== b ? b.then(a.pause).catch(function() {}) : a.pause();
                if (IPAD$$module$build$src$core$utils$useragent || IPHONE$$module$build$src$core$utils$useragent) break;
            }
        }
        play(a, b) {
            var c = this.sounds.get(a);
            c ? (a = new Date, null !== this.lastSound_ && a.getTime() - this.lastSound_.getTime() < SOUND_LIMIT$$module$build$src$core$workspace_audio || (this.lastSound_ = a, c = IPAD$$module$build$src$core$utils$useragent || ANDROID$$module$build$src$core$utils$useragent ? c : c.cloneNode(), c.volume = void 0 === b ? 1 : b, c.play())) : this.parentWorkspace && this.parentWorkspace.getAudioManager().play(a, b);
        }
    }, module$build$src$core$workspace_audio = {};
    module$build$src$core$workspace_audio.WorkspaceAudio = WorkspaceAudio$$module$build$src$core$workspace_audio;
    var verticalPosition$$module$build$src$core$positionable_helpers;
    (function(a) {
        a[a.TOP = 0] = "TOP";
        a[a.BOTTOM = 1] = "BOTTOM";
    })(verticalPosition$$module$build$src$core$positionable_helpers || (verticalPosition$$module$build$src$core$positionable_helpers = {}));
    var horizontalPosition$$module$build$src$core$positionable_helpers;
    (function(a) {
        a[a.LEFT = 0] = "LEFT";
        a[a.RIGHT = 1] = "RIGHT";
    })(horizontalPosition$$module$build$src$core$positionable_helpers || (horizontalPosition$$module$build$src$core$positionable_helpers = {}));
    var bumpDirection$$module$build$src$core$positionable_helpers;
    (function(a) {
        a[a.UP = 0] = "UP";
        a[a.DOWN = 1] = "DOWN";
    })(bumpDirection$$module$build$src$core$positionable_helpers || (bumpDirection$$module$build$src$core$positionable_helpers = {}));
    var module$build$src$core$positionable_helpers = {};
    module$build$src$core$positionable_helpers.bumpDirection = bumpDirection$$module$build$src$core$positionable_helpers;
    module$build$src$core$positionable_helpers.bumpPositionRect = bumpPositionRect$$module$build$src$core$positionable_helpers;
    module$build$src$core$positionable_helpers.getCornerOppositeToolbox = getCornerOppositeToolbox$$module$build$src$core$positionable_helpers;
    module$build$src$core$positionable_helpers.getStartPositionRect = getStartPositionRect$$module$build$src$core$positionable_helpers;
    module$build$src$core$positionable_helpers.horizontalPosition = horizontalPosition$$module$build$src$core$positionable_helpers;
    module$build$src$core$positionable_helpers.verticalPosition = verticalPosition$$module$build$src$core$positionable_helpers;
    var SPRITE$$module$build$src$core$sprites = {
        width: 96,
        height: 124,
        url: "sprites.png"
    }, module$build$src$core$sprites = {};
    module$build$src$core$sprites.SPRITE = SPRITE$$module$build$src$core$sprites;
    var ZoomControls$$module$build$src$core$zoom_controls = class {
        constructor(a){
            this.workspace = a;
            this.id = "zoomControls";
            this.boundEvents = [];
            this.zoomResetGroup = this.zoomOutGroup = this.zoomInGroup = null;
            this.HEIGHT = this.WIDTH = 32;
            this.SMALL_SPACING = 2;
            this.LARGE_SPACING = 11;
            this.MARGIN_HORIZONTAL = this.MARGIN_VERTICAL = 20;
            this.svgGroup = null;
            this.top = this.left = 0;
            this.initialized = !1;
        }
        createDom() {
            this.svgGroup = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {});
            const a = String(Math.random()).substring(2);
            this.createZoomOutSvg(a);
            this.createZoomInSvg(a);
            this.workspace.isMovable() && this.createZoomResetSvg(a);
            return this.svgGroup;
        }
        init() {
            this.workspace.getComponentManager().addComponent({
                component: this,
                weight: 2,
                capabilities: [
                    ComponentManager$$module$build$src$core$component_manager.Capability.POSITIONABLE
                ]
            });
            this.initialized = !0;
        }
        dispose() {
            this.workspace.getComponentManager().removeComponent("zoomControls");
            this.svgGroup && removeNode$$module$build$src$core$utils$dom(this.svgGroup);
            for (const a of this.boundEvents)unbind$$module$build$src$core$browser_events(a);
            this.boundEvents.length = 0;
        }
        getBoundingRectangle() {
            let a = this.SMALL_SPACING + 2 * this.HEIGHT;
            this.zoomResetGroup && (a += this.LARGE_SPACING + this.HEIGHT);
            return new Rect$$module$build$src$core$utils$rect(this.top, this.top + a, this.left, this.left + this.WIDTH);
        }
        position(a, b) {
            if (this.initialized) {
                var c = getCornerOppositeToolbox$$module$build$src$core$positionable_helpers(this.workspace, a), d = this.SMALL_SPACING + 2 * this.HEIGHT;
                this.zoomResetGroup && (d += this.LARGE_SPACING + this.HEIGHT);
                a = getStartPositionRect$$module$build$src$core$positionable_helpers(c, new Size$$module$build$src$core$utils$size(this.WIDTH, d), this.MARGIN_HORIZONTAL, this.MARGIN_VERTICAL, a, this.workspace);
                c = c.vertical;
                b = bumpPositionRect$$module$build$src$core$positionable_helpers(a, this.MARGIN_VERTICAL, c === verticalPosition$$module$build$src$core$positionable_helpers.TOP ? bumpDirection$$module$build$src$core$positionable_helpers.DOWN : bumpDirection$$module$build$src$core$positionable_helpers.UP, b);
                if (c === verticalPosition$$module$build$src$core$positionable_helpers.TOP) {
                    var e = this.SMALL_SPACING + this.HEIGHT, f;
                    null == (f = this.zoomInGroup) || f.setAttribute("transform", "translate(0, " + e + ")");
                    this.zoomResetGroup && this.zoomResetGroup.setAttribute("transform", "translate(0, " + (e + this.LARGE_SPACING + this.HEIGHT) + ")");
                } else {
                    f = this.zoomResetGroup ? this.LARGE_SPACING + this.HEIGHT : 0;
                    let h;
                    null == (h = this.zoomInGroup) || h.setAttribute("transform", "translate(0, " + f + ")");
                    f = f + this.SMALL_SPACING + this.HEIGHT;
                    null == (e = this.zoomOutGroup) || e.setAttribute("transform", "translate(0, " + f + ")");
                }
                this.top = b.top;
                this.left = b.left;
                var g;
                null == (g = this.svgGroup) || g.setAttribute("transform", "translate(" + this.left + "," + this.top + ")");
            }
        }
        createZoomOutSvg(a) {
            this.zoomOutGroup = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {
                "class": "blocklyZoom"
            }, this.svgGroup);
            const b = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.CLIPPATH, {
                id: "blocklyZoomoutClipPath" + a
            }, this.zoomOutGroup);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                width: 32,
                height: 32
            }, b);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.IMAGE, {
                width: SPRITE$$module$build$src$core$sprites.width,
                height: SPRITE$$module$build$src$core$sprites.height,
                x: -64,
                y: -92,
                "clip-path": "url(#blocklyZoomoutClipPath" + a + ")"
            }, this.zoomOutGroup).setAttributeNS(XLINK_NS$$module$build$src$core$utils$dom, "xlink:href", this.workspace.options.pathToMedia + SPRITE$$module$build$src$core$sprites.url);
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(this.zoomOutGroup, "pointerdown", null, this.zoom.bind(this, -1)));
        }
        createZoomInSvg(a) {
            this.zoomInGroup = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {
                "class": "blocklyZoom"
            }, this.svgGroup);
            const b = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.CLIPPATH, {
                id: "blocklyZoominClipPath" + a
            }, this.zoomInGroup);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                width: 32,
                height: 32
            }, b);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.IMAGE, {
                width: SPRITE$$module$build$src$core$sprites.width,
                height: SPRITE$$module$build$src$core$sprites.height,
                x: -32,
                y: -92,
                "clip-path": "url(#blocklyZoominClipPath" + a + ")"
            }, this.zoomInGroup).setAttributeNS(XLINK_NS$$module$build$src$core$utils$dom, "xlink:href", this.workspace.options.pathToMedia + SPRITE$$module$build$src$core$sprites.url);
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(this.zoomInGroup, "pointerdown", null, this.zoom.bind(this, 1)));
        }
        zoom(a, b) {
            this.workspace.markFocused();
            this.workspace.zoomCenter(a);
            this.fireZoomEvent();
            clearTouchIdentifier$$module$build$src$core$touch();
            b.stopPropagation();
            b.preventDefault();
        }
        createZoomResetSvg(a) {
            this.zoomResetGroup = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {
                "class": "blocklyZoom"
            }, this.svgGroup);
            const b = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.CLIPPATH, {
                id: "blocklyZoomresetClipPath" + a
            }, this.zoomResetGroup);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                width: 32,
                height: 32
            }, b);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.IMAGE, {
                width: SPRITE$$module$build$src$core$sprites.width,
                height: SPRITE$$module$build$src$core$sprites.height,
                y: -92,
                "clip-path": "url(#blocklyZoomresetClipPath" + a + ")"
            }, this.zoomResetGroup).setAttributeNS(XLINK_NS$$module$build$src$core$utils$dom, "xlink:href", this.workspace.options.pathToMedia + SPRITE$$module$build$src$core$sprites.url);
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(this.zoomResetGroup, "pointerdown", null, this.resetZoom.bind(this)));
        }
        resetZoom(a) {
            this.workspace.markFocused();
            const b = Math.log(this.workspace.options.zoomOptions.startScale / this.workspace.scale) / Math.log(this.workspace.options.zoomOptions.scaleSpeed);
            this.workspace.beginCanvasTransition();
            this.workspace.zoomCenter(b);
            this.workspace.scrollCenter();
            setTimeout(this.workspace.endCanvasTransition.bind(this.workspace), 500);
            this.fireZoomEvent();
            clearTouchIdentifier$$module$build$src$core$touch();
            a.stopPropagation();
            a.preventDefault();
        }
        fireZoomEvent() {
            const a = new (get$$module$build$src$core$events$utils(CLICK$$module$build$src$core$events$utils))(null, this.workspace.id, "zoom_controls");
            fire$$module$build$src$core$events$utils(a);
        }
    };
    register$$module$build$src$core$css("\n.blocklyZoom>image, .blocklyZoom>svg>image {\n  opacity: .4;\n}\n\n.blocklyZoom>image:hover, .blocklyZoom>svg>image:hover {\n  opacity: .6;\n}\n\n.blocklyZoom>image:active, .blocklyZoom>svg>image:active {\n  opacity: .8;\n}\n");
    var module$build$src$core$zoom_controls = {};
    module$build$src$core$zoom_controls.ZoomControls = ZoomControls$$module$build$src$core$zoom_controls;
    var ZOOM_TO_FIT_MARGIN$$module$build$src$core$workspace_svg = 20, WorkspaceSvg$$module$build$src$core$workspace_svg = class extends Workspace$$module$build$src$core$workspace {
        constructor(a, b, c){
            super(a);
            this.resizeHandlerWrapper = null;
            this.resizesEnabled = this.isVisible_ = this.rendered = !0;
            this.startScrollY = this.startScrollX = this.scrollY = this.scrollX = 0;
            this.dragDeltaXY = null;
            this.oldScale = this.scale = 1;
            this.oldLeft = this.oldTop = 0;
            this.workspaceDragSurface = this.blockDragSurface = this.currentGesture_ = this.toolbox_ = this.flyout = this.scrollbar = this.trashcan = null;
            this.isDragSurfaceActive = !1;
            this.inverseScreenCTM = this.targetWorkspace = this.configureContextMenu = this.lastRecordedPageScroll = this.injectionDiv = null;
            this.inverseScreenCTMDirty = !0;
            this.highlightedBlocks = [];
            this.toolboxCategoryCallbacks = new Map;
            this.flyoutButtonCallbacks = new Map;
            this.cachedParentSvg = null;
            this.keyboardAccessibilityMode = !1;
            this.topBoundedElements = [];
            this.dragTargetAreas = [];
            this.zoomControls_ = null;
            this.metricsManager = new (getClassFromOptions$$module$build$src$core$registry(Type$$module$build$src$core$registry.METRICS_MANAGER, a, !0))(this);
            this.getMetrics = a.getMetrics || this.metricsManager.getMetrics.bind(this.metricsManager);
            this.setMetrics = a.setMetrics || WorkspaceSvg$$module$build$src$core$workspace_svg.setTopLevelWorkspaceMetrics_;
            this.componentManager = new ComponentManager$$module$build$src$core$component_manager;
            this.connectionDBList = ConnectionDB$$module$build$src$core$connection_db.init(this.connectionChecker);
            b && (this.blockDragSurface = b);
            c && (this.workspaceDragSurface = c);
            this.useWorkspaceDragSurface = !!this.workspaceDragSurface;
            this.audioManager = new WorkspaceAudio$$module$build$src$core$workspace_audio(a.parentWorkspace);
            this.grid = this.options.gridPattern ? new Grid$$module$build$src$core$grid(this.options.gridPattern, a.gridOptions) : null;
            this.markerManager = new MarkerManager$$module$build$src$core$marker_manager(this);
            $.module$build$src$core$variables && flyoutCategory$$module$build$src$core$variables && this.registerToolboxCategoryCallback(CATEGORY_NAME$$module$build$src$core$variables, flyoutCategory$$module$build$src$core$variables);
            module$build$src$core$variables_dynamic && flyoutCategory$$module$build$src$core$variables_dynamic && this.registerToolboxCategoryCallback(CATEGORY_NAME$$module$build$src$core$variables_dynamic, flyoutCategory$$module$build$src$core$variables_dynamic);
            $.module$build$src$core$procedures && flyoutCategory$$module$build$src$core$procedures && (this.registerToolboxCategoryCallback(CATEGORY_NAME$$module$build$src$core$procedures, flyoutCategory$$module$build$src$core$procedures), this.addChangeListener(mutatorOpenListener$$module$build$src$core$procedures));
            this.themeManager_ = this.options.parentWorkspace ? this.options.parentWorkspace.getThemeManager() : new ThemeManager$$module$build$src$core$theme_manager(this, this.options.theme || Classic$$module$build$src$core$theme$classic);
            this.themeManager_.subscribeWorkspace(this);
            let d;
            this.renderer = init$$module$build$src$core$renderers$common$block_rendering(this.options.renderer || "geras", this.getTheme(), null != (d = this.options.rendererOverrides) ? d : void 0);
            this.cachedParentSvgSize = new Size$$module$build$src$core$utils$size(0, 0);
        }
        getMarkerManager() {
            return this.markerManager;
        }
        getMetricsManager() {
            return this.metricsManager;
        }
        setMetricsManager(a) {
            this.metricsManager = a;
            this.getMetrics = this.metricsManager.getMetrics.bind(this.metricsManager);
        }
        getComponentManager() {
            return this.componentManager;
        }
        setCursorSvg(a) {
            this.markerManager.setCursorSvg(a);
        }
        setMarkerSvg(a) {
            this.markerManager.setMarkerSvg(a);
        }
        getMarker(a) {
            return this.markerManager ? this.markerManager.getMarker(a) : null;
        }
        getCursor() {
            return this.markerManager ? this.markerManager.getCursor() : null;
        }
        getRenderer() {
            return this.renderer;
        }
        getThemeManager() {
            return this.themeManager_;
        }
        getTheme() {
            return this.themeManager_.getTheme();
        }
        setTheme(a) {
            a || (a = Classic$$module$build$src$core$theme$classic);
            this.themeManager_.setTheme(a);
        }
        refreshTheme() {
            this.svgGroup_ && this.renderer.refreshDom(this.svgGroup_, this.getTheme());
            this.updateBlockStyles_(this.getAllBlocks(!1).filter(function(b) {
                return !!b.getStyleName();
            }));
            this.refreshToolboxSelection();
            this.toolbox_ && this.toolbox_.refreshTheme();
            this.isVisible() && this.setVisible(!0);
            const a = new (get$$module$build$src$core$events$utils(THEME_CHANGE$$module$build$src$core$events$utils))(this.getTheme().name, this.id);
            fire$$module$build$src$core$events$utils(a);
        }
        updateBlockStyles_(a) {
            for(let b = 0, c; c = a[b]; b++){
                const d = c.getStyleName();
                if (d) {
                    const e = c;
                    e.setStyle(d);
                    e.mutator && e.mutator.updateBlockStyle();
                }
            }
        }
        getInverseScreenCTM() {
            if (this.inverseScreenCTMDirty) {
                const a = this.getParentSvg().getScreenCTM();
                a && (this.inverseScreenCTM = a.inverse(), this.inverseScreenCTMDirty = !1);
            }
            return this.inverseScreenCTM;
        }
        updateInverseScreenCTM() {
            this.inverseScreenCTMDirty = !0;
        }
        isVisible() {
            return this.isVisible_;
        }
        getSvgXY(a) {
            let b = 0, c = 0, d = 1;
            if (containsNode$$module$build$src$core$utils$dom(this.getCanvas(), a) || containsNode$$module$build$src$core$utils$dom(this.getBubbleCanvas(), a)) d = this.scale;
            do {
                const e = getRelativeXY$$module$build$src$core$utils$svg_math(a);
                if (a === this.getCanvas() || a === this.getBubbleCanvas()) d = 1;
                b += e.x * d;
                c += e.y * d;
                a = a.parentNode;
            }while (a && a !== this.getParentSvg());
            return new Coordinate$$module$build$src$core$utils$coordinate(b, c);
        }
        getCachedParentSvgSize() {
            const a = this.cachedParentSvgSize;
            return new Size$$module$build$src$core$utils$size(a.width, a.height);
        }
        getOriginOffsetInPixels() {
            return getInjectionDivXY$$module$build$src$core$utils$svg_math(this.getCanvas());
        }
        getInjectionDiv() {
            if (!this.injectionDiv) {
                let a = this.svgGroup_;
                for(; a;){
                    if (-1 !== (" " + (a.getAttribute("class") || "") + " ").indexOf(" injectionDiv ")) {
                        this.injectionDiv = a;
                        break;
                    }
                    a = a.parentNode;
                }
            }
            return this.injectionDiv;
        }
        getBlockCanvas() {
            return this.svgBlockCanvas_;
        }
        setResizeHandlerWrapper(a) {
            this.resizeHandlerWrapper = a;
        }
        createDom(a) {
            this.svgGroup_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {
                "class": "blocklyWorkspace"
            });
            a && (this.svgBackground_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                height: "100%",
                width: "100%",
                "class": a
            }, this.svgGroup_), "blocklyMainBackground" === a && this.grid ? this.svgBackground_.style.fill = "url(#" + this.grid.getPatternId() + ")" : this.themeManager_.subscribe(this.svgBackground_, "workspaceBackgroundColour", "fill"));
            this.svgBlockCanvas_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {
                "class": "blocklyBlockCanvas"
            }, this.svgGroup_);
            this.svgBubbleCanvas_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {
                "class": "blocklyBubbleCanvas"
            }, this.svgGroup_);
            this.isFlyout || (conditionalBind$$module$build$src$core$browser_events(this.svgGroup_, "pointerdown", this, this.onMouseDown_, !1), document.body.addEventListener("wheel", function() {}), conditionalBind$$module$build$src$core$browser_events(this.svgGroup_, "wheel", this, this.onMouseWheel_));
            this.options.hasCategories && (this.toolbox_ = new (getClassFromOptions$$module$build$src$core$registry(Type$$module$build$src$core$registry.TOOLBOX, this.options, !0))(this));
            this.grid && this.grid.update(this.scale);
            this.recordDragTargets();
            (a = getClassFromOptions$$module$build$src$core$registry(Type$$module$build$src$core$registry.CURSOR, this.options)) && this.markerManager.setCursor(new a);
            this.renderer.createDom(this.svgGroup_, this.getTheme());
            return this.svgGroup_;
        }
        dispose() {
            this.rendered = !1;
            this.currentGesture_ && this.currentGesture_.cancel();
            this.svgGroup_ && removeNode$$module$build$src$core$utils$dom(this.svgGroup_);
            this.toolbox_ && (this.toolbox_.dispose(), this.toolbox_ = null);
            this.flyout && (this.flyout.dispose(), this.flyout = null);
            this.trashcan && (this.trashcan.dispose(), this.trashcan = null);
            this.scrollbar && (this.scrollbar.dispose(), this.scrollbar = null);
            this.zoomControls_ && this.zoomControls_.dispose();
            this.audioManager && this.audioManager.dispose();
            this.grid && (this.grid = null);
            this.renderer.dispose();
            this.markerManager && this.markerManager.dispose();
            super.dispose();
            this.themeManager_ && (this.themeManager_.unsubscribeWorkspace(this), this.themeManager_.unsubscribe(this.svgBackground_), this.options.parentWorkspace || this.themeManager_.dispose());
            this.connectionDBList.length = 0;
            this.toolboxCategoryCallbacks.clear();
            this.flyoutButtonCallbacks.clear();
            if (!this.options.parentWorkspace) {
                const a = this.getParentSvg();
                a && a.parentNode && removeNode$$module$build$src$core$utils$dom(a.parentNode);
            }
            this.resizeHandlerWrapper && (unbind$$module$build$src$core$browser_events(this.resizeHandlerWrapper), this.resizeHandlerWrapper = null);
        }
        addTrashcan() {
            this.trashcan = WorkspaceSvg$$module$build$src$core$workspace_svg.newTrashcan(this);
            const a = this.trashcan.createDom();
            this.svgGroup_.insertBefore(a, this.svgBlockCanvas_);
        }
        static newTrashcan(a) {
            throw Error("The implementation of newTrashcan should be monkey-patched in by blockly.ts");
        }
        addZoomControls() {
            this.zoomControls_ = new ZoomControls$$module$build$src$core$zoom_controls(this);
            const a = this.zoomControls_.createDom();
            this.svgGroup_.appendChild(a);
        }
        addFlyout(a) {
            const b = new Options$$module$build$src$core$options({
                parentWorkspace: this,
                rtl: this.RTL,
                oneBasedIndex: this.options.oneBasedIndex,
                horizontalLayout: this.horizontalLayout,
                renderer: this.options.renderer,
                rendererOverrides: this.options.rendererOverrides,
                move: {
                    scrollbars: !0
                }
            });
            b.toolboxPosition = this.options.toolboxPosition;
            this.flyout = this.horizontalLayout ? new (getClassFromOptions$$module$build$src$core$registry(Type$$module$build$src$core$registry.FLYOUTS_HORIZONTAL_TOOLBOX, this.options, !0))(b) : new (getClassFromOptions$$module$build$src$core$registry(Type$$module$build$src$core$registry.FLYOUTS_VERTICAL_TOOLBOX, this.options, !0))(b);
            this.flyout.autoClose = !1;
            this.flyout.getWorkspace().setVisible(!0);
            return this.flyout.createDom(a);
        }
        getFlyout(a) {
            return this.flyout || a ? this.flyout : this.toolbox_ ? this.toolbox_.getFlyout() : null;
        }
        getToolbox() {
            return this.toolbox_;
        }
        updateScreenCalculations_() {
            this.updateInverseScreenCTM();
            this.recordDragTargets();
        }
        resizeContents() {
            this.resizesEnabled && this.rendered && (this.scrollbar && this.scrollbar.resize(), this.updateInverseScreenCTM());
        }
        resize() {
            this.toolbox_ && this.toolbox_.position();
            this.flyout && this.flyout.position();
            const a = this.componentManager.getComponents(ComponentManager$$module$build$src$core$component_manager.Capability.POSITIONABLE, !0), b = this.getMetricsManager().getUiMetrics(), c = [];
            for(let d = 0, e; e = a[d]; d++){
                e.position(b, c);
                const f = e.getBoundingRectangle();
                f && c.push(f);
            }
            this.scrollbar && this.scrollbar.resize();
            this.updateScreenCalculations_();
        }
        updateScreenCalculationsIfScrolled() {
            const a = getDocumentScroll$$module$build$src$core$utils$svg_math();
            Coordinate$$module$build$src$core$utils$coordinate.equals(this.lastRecordedPageScroll, a) || (this.lastRecordedPageScroll = a, this.updateScreenCalculations_());
        }
        getCanvas() {
            return this.svgBlockCanvas_;
        }
        setCachedParentSvgSize(a, b) {
            const c = this.getParentSvg();
            null != a && (this.cachedParentSvgSize.width = a, c.setAttribute("data-cached-width", `${a}`));
            null != b && (this.cachedParentSvgSize.height = b, c.setAttribute("data-cached-height", `${b}`));
        }
        getBubbleCanvas() {
            return this.svgBubbleCanvas_;
        }
        getParentSvg() {
            if (!this.cachedParentSvg) {
                let a = this.svgGroup_;
                for(; a;){
                    if ("svg" === a.tagName) {
                        this.cachedParentSvg = a;
                        break;
                    }
                    a = a.parentNode;
                }
            }
            return this.cachedParentSvg;
        }
        maybeFireViewportChangeEvent() {
            if (isEnabled$$module$build$src$core$events$utils()) {
                var a = this.scale, b = -this.scrollY, c = -this.scrollX;
                if (!(a === this.oldScale && 1 > Math.abs(b - this.oldTop) && 1 > Math.abs(c - this.oldLeft))) {
                    var d = new (get$$module$build$src$core$events$utils(VIEWPORT_CHANGE$$module$build$src$core$events$utils))(b, c, a, this.id, this.oldScale);
                    this.oldScale = a;
                    this.oldTop = b;
                    this.oldLeft = c;
                    fire$$module$build$src$core$events$utils(d);
                }
            }
        }
        translate(a, b) {
            if (this.useWorkspaceDragSurface && this.isDragSurfaceActive) {
                var c;
                null == (c = this.workspaceDragSurface) || c.translateSurface(a, b);
            } else c = "translate(" + a + "," + b + ") scale(" + this.scale + ")", this.svgBlockCanvas_.setAttribute("transform", c), this.svgBubbleCanvas_.setAttribute("transform", c);
            this.blockDragSurface && this.blockDragSurface.translateAndScaleGroup(a, b, this.scale);
            this.grid && this.grid.moveTo(a, b);
            this.maybeFireViewportChangeEvent();
        }
        resetDragSurface() {
            if (this.useWorkspaceDragSurface) {
                this.isDragSurfaceActive = !1;
                var a = this.workspaceDragSurface.getSurfaceTranslation();
                this.workspaceDragSurface.clearAndHide(this.svgGroup_);
                a = "translate(" + a.x + "," + a.y + ") scale(" + this.scale + ")";
                this.svgBlockCanvas_.setAttribute("transform", a);
                this.svgBubbleCanvas_.setAttribute("transform", a);
            }
        }
        setupDragSurface() {
            if (this.useWorkspaceDragSurface && !this.isDragSurfaceActive) {
                this.isDragSurfaceActive = !0;
                var a = this.svgBlockCanvas_.previousSibling, b, c = parseInt(null != (b = this.getParentSvg().getAttribute("width")) ? b : "0"), d;
                b = parseInt(null != (d = this.getParentSvg().getAttribute("height")) ? d : "0");
                d = getRelativeXY$$module$build$src$core$utils$svg_math(this.getCanvas());
                this.workspaceDragSurface.setContentsAndShow(this.getCanvas(), this.getBubbleCanvas(), a, c, b, this.scale);
                this.workspaceDragSurface.translateSurface(d.x, d.y);
            }
        }
        getBlockDragSurface() {
            return this.blockDragSurface;
        }
        getWidth() {
            const a = this.getMetrics();
            return a ? a.viewWidth / this.scale : 0;
        }
        setVisible(a) {
            this.isVisible_ = a;
            if (this.svgGroup_) {
                if (this.scrollbar && this.scrollbar.setContainerVisible(a), this.getFlyout() && this.getFlyout().setContainerVisible(a), this.getParentSvg().style.display = a ? "block" : "none", this.toolbox_ && this.toolbox_.setVisible(a), a) {
                    a = this.getAllBlocks(!1);
                    for(let b = a.length - 1; 0 <= b; b--)a[b].markDirty();
                    this.render();
                    this.toolbox_ && this.toolbox_.position();
                } else this.hideChaff(!0);
            }
        }
        render() {
            var a = this.getAllBlocks(!1);
            for(var b = a.length - 1; 0 <= b; b--)a[b].render(!1);
            if (this.currentGesture_) for(a = this.currentGesture_.getInsertionMarkers(), b = 0; b < a.length; b++)a[b].render(!1);
            this.markerManager.updateMarkers();
        }
        highlightBlock(a, b) {
            if (void 0 === b) {
                for(let c = 0, d; d = this.highlightedBlocks[c]; c++)d.setHighlighted(!1);
                this.highlightedBlocks.length = 0;
            }
            if (a = a ? this.getBlockById(a) : null) (b = void 0 === b || b) ? -1 === this.highlightedBlocks.indexOf(a) && this.highlightedBlocks.push(a) : removeElem$$module$build$src$core$utils$array(this.highlightedBlocks, a), a.setHighlighted(b);
        }
        paste(a) {
            if (!this.rendered || !a.type && !a.tagName) return null;
            this.currentGesture_ && this.currentGesture_.cancel();
            const b = getGroup$$module$build$src$core$events$utils();
            b || setGroup$$module$build$src$core$events$utils(!0);
            let c;
            try {
                c = a.type ? this.pasteBlock_(null, a) : "comment" === a.tagName.toLowerCase() ? this.pasteWorkspaceComment_(a) : this.pasteBlock_(a, null);
            } finally{
                setGroup$$module$build$src$core$events$utils(b);
            }
            return c;
        }
        pasteBlock_(a, b) {
            disable$$module$build$src$core$events$utils();
            let c;
            try {
                let d = 0, e = 0;
                if (a) {
                    c = domToBlock$$module$build$src$core$xml(a, this);
                    let f;
                    d = parseInt(null != (f = a.getAttribute("x")) ? f : "0");
                    this.RTL && (d = -d);
                    let g;
                    e = parseInt(null != (g = a.getAttribute("y")) ? g : "0");
                } else b && (c = append$$module$build$src$core$serialization$blocks(b, this), d = b.x || 10, this.RTL && (d = this.getWidth() - d), e = b.y || 10);
                if (!isNaN(d) && !isNaN(e)) {
                    let f;
                    do {
                        f = !1;
                        const g = this.getAllBlocks(!1);
                        for(let h = 0, k; k = g[h]; h++){
                            const l = k.getRelativeToSurfaceXY();
                            if (1 >= Math.abs(d - l.x) && 1 >= Math.abs(e - l.y)) {
                                f = !0;
                                break;
                            }
                        }
                        if (!f) {
                            const h = c.getConnections_(!1);
                            for(let k = 0, l; l = h[k]; k++)if (l.closest($.config$$module$build$src$core$config.snapRadius, new Coordinate$$module$build$src$core$utils$coordinate(d, e)).connection) {
                                f = !0;
                                break;
                            }
                        }
                        f && (d = this.RTL ? d - $.config$$module$build$src$core$config.snapRadius : d + $.config$$module$build$src$core$config.snapRadius, e += 2 * $.config$$module$build$src$core$config.snapRadius);
                    }while (f);
                    c.moveTo(new Coordinate$$module$build$src$core$utils$coordinate(d, e));
                }
            } finally{
                enable$$module$build$src$core$events$utils();
            }
            isEnabled$$module$build$src$core$events$utils() && !c.isShadow() && fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(CREATE$$module$build$src$core$events$utils))(c));
            c.select();
            return c;
        }
        pasteWorkspaceComment_(a) {
            disable$$module$build$src$core$events$utils();
            let b;
            try {
                b = WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg.fromXmlRendered(a, this);
                let c, d = parseInt(null != (c = a.getAttribute("x")) ? c : "0"), e, f = parseInt(null != (e = a.getAttribute("y")) ? e : "0");
                isNaN(d) || isNaN(f) || (this.RTL && (d = -d), b.moveBy(d + 50, f + 50));
            } finally{
                enable$$module$build$src$core$events$utils();
            }
            isEnabled$$module$build$src$core$events$utils() && WorkspaceComment$$module$build$src$core$workspace_comment.fireCreateEvent(b);
            b.select();
            return b;
        }
        refreshToolboxSelection() {
            const a = this.isFlyout ? this.targetWorkspace : this;
            a && !a.currentGesture_ && a.toolbox_ && a.toolbox_.getFlyout() && a.toolbox_.refreshSelection();
        }
        renameVariableById(a, b) {
            super.renameVariableById(a, b);
            this.refreshToolboxSelection();
        }
        deleteVariableById(a) {
            super.deleteVariableById(a);
            this.refreshToolboxSelection();
        }
        createVariable(a, b, c) {
            a = super.createVariable(a, b, c);
            this.refreshToolboxSelection();
            return a;
        }
        recordDragTargets() {
            const a = this.componentManager.getComponents(ComponentManager$$module$build$src$core$component_manager.Capability.DRAG_TARGET, !0);
            this.dragTargetAreas = [];
            for(let b = 0, c; c = a[b]; b++){
                const d = c.getClientRect();
                d && this.dragTargetAreas.push({
                    component: c,
                    clientRect: d
                });
            }
        }
        newBlock(a, b) {
            throw Error("The implementation of newBlock should be monkey-patched in by blockly.ts");
        }
        getDragTarget(a) {
            for(let b = 0, c; c = this.dragTargetAreas[b]; b++)if (c.clientRect.contains(a.clientX, a.clientY)) return c.component;
            return null;
        }
        onMouseDown_(a) {
            const b = this.getGesture(a);
            b && b.handleWsStart(a, this);
        }
        startDrag(a, b) {
            a = mouseToSvg$$module$build$src$core$browser_events(a, this.getParentSvg(), this.getInverseScreenCTM());
            a.x /= this.scale;
            a.y /= this.scale;
            this.dragDeltaXY = Coordinate$$module$build$src$core$utils$coordinate.difference(b, a);
        }
        moveDrag(a) {
            a = mouseToSvg$$module$build$src$core$browser_events(a, this.getParentSvg(), this.getInverseScreenCTM());
            a.x /= this.scale;
            a.y /= this.scale;
            return Coordinate$$module$build$src$core$utils$coordinate.sum(this.dragDeltaXY, a);
        }
        isDragging() {
            return null !== this.currentGesture_ && this.currentGesture_.isDragging();
        }
        isDraggable() {
            return this.options.moveOptions && this.options.moveOptions.drag;
        }
        isMovable() {
            return this.options.moveOptions && !!this.options.moveOptions.scrollbars || this.options.moveOptions && this.options.moveOptions.wheel || this.options.moveOptions && this.options.moveOptions.drag || this.options.zoomOptions && this.options.zoomOptions.wheel || this.options.zoomOptions && this.options.zoomOptions.pinch;
        }
        isMovableHorizontally() {
            const a = !!this.scrollbar;
            return this.isMovable() && (!a || a && this.scrollbar.canScrollHorizontally());
        }
        isMovableVertically() {
            const a = !!this.scrollbar;
            return this.isMovable() && (!a || a && this.scrollbar.canScrollVertically());
        }
        onMouseWheel_(a) {
            if (Gesture$$module$build$src$core$gesture.inProgress()) a.preventDefault(), a.stopPropagation();
            else {
                var b = this.options.zoomOptions && this.options.zoomOptions.wheel, c = this.options.moveOptions && this.options.moveOptions.wheel;
                if (b || c) {
                    var d = getScrollDeltaPixels$$module$build$src$core$browser_events(a);
                    if (MAC$$module$build$src$core$utils$useragent) var e = a.metaKey;
                    b && (a.ctrlKey || e || !c) ? (d = -d.y / 50, b = mouseToSvg$$module$build$src$core$browser_events(a, this.getParentSvg(), this.getInverseScreenCTM()), this.zoom(b.x, b.y, d)) : (b = this.scrollX - d.x, c = this.scrollY - d.y, a.shiftKey && !d.x && (b = this.scrollX - d.y, c = this.scrollY), this.scroll(b, c));
                    a.preventDefault();
                }
            }
        }
        getBlocksBoundingBox() {
            const a = this.getTopBoundedElements();
            if (!a.length) return new Rect$$module$build$src$core$utils$rect(0, 0, 0, 0);
            const b = a[0].getBoundingRectangle();
            for(let d = 1; d < a.length; d++){
                var c = a[d];
                c.isInsertionMarker && c.isInsertionMarker() || (c = c.getBoundingRectangle(), c.top < b.top && (b.top = c.top), c.bottom > b.bottom && (b.bottom = c.bottom), c.left < b.left && (b.left = c.left), c.right > b.right && (b.right = c.right));
            }
            return b;
        }
        cleanUp() {
            this.setResizesEnabled(!1);
            setGroup$$module$build$src$core$events$utils(!0);
            const a = this.getTopBlocks(!0);
            let b = 0;
            for(let c = 0, d; d = a[c]; c++){
                if (!d.isMovable()) continue;
                const e = d.getRelativeToSurfaceXY();
                d.moveBy(-e.x, b - e.y);
                d.snapToGrid();
                b = d.getRelativeToSurfaceXY().y + d.getHeightWidth().height + this.renderer.getConstants().MIN_BLOCK_HEIGHT;
            }
            setGroup$$module$build$src$core$events$utils(!1);
            this.setResizesEnabled(!0);
        }
        showContextMenu(a) {
            if (!this.options.readOnly && !this.isFlyout) {
                var b = ContextMenuRegistry$$module$build$src$core$contextmenu_registry.registry.getContextMenuOptions(ContextMenuRegistry$$module$build$src$core$contextmenu_registry.ScopeType.WORKSPACE, {
                    workspace: this
                });
                this.configureContextMenu && this.configureContextMenu(b, a);
                show$$module$build$src$core$contextmenu(a, b, this.RTL);
            }
        }
        updateToolbox(a) {
            if (a = convertToolboxDefToJson$$module$build$src$core$utils$toolbox(a)) {
                if (!this.options.languageTree) throw Error("Existing toolbox is null.  Can't create new toolbox.");
                if (hasCategories$$module$build$src$core$utils$toolbox(a)) {
                    if (!this.toolbox_) throw Error("Existing toolbox has no categories.  Can't change mode.");
                    this.options.languageTree = a;
                    this.toolbox_.render(a);
                } else {
                    if (!this.flyout) throw Error("Existing toolbox has categories.  Can't change mode.");
                    this.options.languageTree = a;
                    this.flyout.show(a);
                }
            } else if (this.options.languageTree) throw Error("Can't nullify an existing toolbox.");
        }
        markFocused() {
            this.options.parentWorkspace ? this.options.parentWorkspace.markFocused() : (setMainWorkspace$$module$build$src$core$common(this), this.getParentSvg().focus({
                preventScroll: !0
            }));
        }
        zoom(a, b, c) {
            c = Math.pow(this.options.zoomOptions.scaleSpeed, c);
            const d = this.scale * c;
            if (this.scale !== d) {
                d > this.options.zoomOptions.maxScale ? c = this.options.zoomOptions.maxScale / this.scale : d < this.options.zoomOptions.minScale && (c = this.options.zoomOptions.minScale / this.scale);
                var e = this.getCanvas().getCTM(), f = this.getParentSvg().createSVGPoint();
                f.x = a;
                f.y = b;
                f = f.matrixTransform(e.inverse());
                a = f.x;
                b = f.y;
                e = e.translate(a * (1 - c), b * (1 - c)).scale(c);
                this.scrollX = e.e;
                this.scrollY = e.f;
                this.setScale(d);
            }
        }
        zoomCenter(a) {
            var b = this.getMetrics();
            let c;
            this.flyout ? (c = b.svgWidth ? b.svgWidth / 2 : 0, b = b.svgHeight ? b.svgHeight / 2 : 0) : (c = b.viewWidth / 2 + b.absoluteLeft, b = b.viewHeight / 2 + b.absoluteTop);
            this.zoom(c, b, a);
        }
        zoomToFit() {
            if (this.isMovable()) {
                var a = this.getMetrics(), b = a.viewWidth;
                a = a.viewHeight;
                var c = this.getBlocksBoundingBox(), d = 2 * ZOOM_TO_FIT_MARGIN$$module$build$src$core$workspace_svg, e = c.right - c.left + d;
                c = c.bottom - c.top + d;
                if (e) {
                    this.flyout && (this.horizontalLayout ? (a += this.flyout.getHeight(), c += this.flyout.getHeight() / this.scale) : (b += this.flyout.getWidth(), e += this.flyout.getWidth() / this.scale));
                    b /= e;
                    a /= c;
                    disable$$module$build$src$core$events$utils();
                    try {
                        this.setScale(Math.min(b, a)), this.scrollCenter();
                    } finally{
                        enable$$module$build$src$core$events$utils();
                    }
                    this.maybeFireViewportChangeEvent();
                }
            } else console.warn("Tried to move a non-movable workspace. This could result in blocks becoming inaccessible.");
        }
        beginCanvasTransition() {
            addClass$$module$build$src$core$utils$dom(this.svgBlockCanvas_, "blocklyCanvasTransitioning");
            addClass$$module$build$src$core$utils$dom(this.svgBubbleCanvas_, "blocklyCanvasTransitioning");
        }
        endCanvasTransition() {
            removeClass$$module$build$src$core$utils$dom(this.svgBlockCanvas_, "blocklyCanvasTransitioning");
            removeClass$$module$build$src$core$utils$dom(this.svgBubbleCanvas_, "blocklyCanvasTransitioning");
        }
        scrollCenter() {
            if (this.isMovable()) {
                var a = this.getMetrics(), b = (a.scrollWidth - a.viewWidth) / 2, c = (a.scrollHeight - a.viewHeight) / 2;
                b = -b - a.scrollLeft;
                c = -c - a.scrollTop;
                this.scroll(b, c);
            } else console.warn("Tried to move a non-movable workspace. This could result in blocks becoming inaccessible.");
        }
        centerOnBlock(a, b) {
            if (this.isMovable()) {
                var c = a ? this.getBlockById(a) : null;
                if (c) {
                    a = c.getRelativeToSurfaceXY();
                    c = b ? {
                        height: c.height,
                        width: c.width
                    } : c.getHeightWidth();
                    var d = this.scale;
                    b = (a.x + (this.RTL ? -1 : 1) * c.width / 2) * d;
                    a = (a.y + c.height / 2) * d;
                    c = this.getMetrics();
                    this.scroll(-(b - c.viewWidth / 2), -(a - c.viewHeight / 2));
                }
            } else console.warn("Tried to move a non-movable workspace. This could result in blocks becoming inaccessible.");
        }
        setScale(a) {
            this.options.zoomOptions.maxScale && a > this.options.zoomOptions.maxScale ? a = this.options.zoomOptions.maxScale : this.options.zoomOptions.minScale && a < this.options.zoomOptions.minScale && (a = this.options.zoomOptions.minScale);
            this.scale = a;
            this.hideChaff(!1);
            (a = this.getFlyout(!1)) && a.isVisible() && (a.reflow(), this.recordDragTargets());
            this.grid && this.grid.update(this.scale);
            a = this.getMetrics();
            this.scrollX -= a.absoluteLeft;
            this.scrollY -= a.absoluteTop;
            a.viewLeft += a.absoluteLeft;
            a.viewTop += a.absoluteTop;
            this.scroll(this.scrollX, this.scrollY);
            this.scrollbar && (this.flyout ? this.scrollbar.resizeView(a) : this.scrollbar.resizeContent(a));
        }
        getScale() {
            return this.options.parentWorkspace ? this.options.parentWorkspace.getScale() : this.scale;
        }
        scroll(a, b) {
            this.hideChaff(!0);
            const c = this.getMetrics();
            a = Math.min(a, -c.scrollLeft);
            b = Math.min(b, -c.scrollTop);
            const d = c.scrollTop + Math.max(0, c.scrollHeight - c.viewHeight);
            a = Math.max(a, -(c.scrollLeft + Math.max(0, c.scrollWidth - c.viewWidth)));
            b = Math.max(b, -d);
            this.scrollX = a;
            this.scrollY = b;
            this.scrollbar && this.scrollbar.set(-(a + c.scrollLeft), -(b + c.scrollTop), !1);
            a += c.absoluteLeft;
            b += c.absoluteTop;
            this.translate(a, b);
        }
        getBlockById(a) {
            return super.getBlockById(a);
        }
        getAllBlocks(a) {
            return super.getAllBlocks(a);
        }
        getTopBlocks(a) {
            return super.getTopBlocks(a);
        }
        addTopBlock(a) {
            this.addTopBoundedElement(a);
            super.addTopBlock(a);
        }
        removeTopBlock(a) {
            this.removeTopBoundedElement(a);
            super.removeTopBlock(a);
        }
        addTopComment(a) {
            this.addTopBoundedElement(a);
            super.addTopComment(a);
        }
        removeTopComment(a) {
            this.removeTopBoundedElement(a);
            super.removeTopComment(a);
        }
        addTopBoundedElement(a) {
            this.topBoundedElements.push(a);
        }
        removeTopBoundedElement(a) {
            removeElem$$module$build$src$core$utils$array(this.topBoundedElements, a);
        }
        getTopBoundedElements() {
            return [].concat(this.topBoundedElements);
        }
        setResizesEnabled(a) {
            const b = !this.resizesEnabled && a;
            this.resizesEnabled = a;
            b && this.resizeContents();
        }
        clear() {
            this.setResizesEnabled(!1);
            super.clear();
            this.topBoundedElements = [];
            this.setResizesEnabled(!0);
        }
        registerButtonCallback(a, b) {
            if ("function" !== typeof b) throw TypeError("Button callbacks must be functions.");
            this.flyoutButtonCallbacks.set(a, b);
        }
        getButtonCallback(a) {
            let b;
            return null != (b = this.flyoutButtonCallbacks.get(a)) ? b : null;
        }
        removeButtonCallback(a) {
            this.flyoutButtonCallbacks.delete(a);
        }
        registerToolboxCategoryCallback(a, b) {
            if ("function" !== typeof b) throw TypeError("Toolbox category callbacks must be functions.");
            this.toolboxCategoryCallbacks.set(a, b);
        }
        getToolboxCategoryCallback(a) {
            return this.toolboxCategoryCallbacks.get(a) || null;
        }
        removeToolboxCategoryCallback(a) {
            this.toolboxCategoryCallbacks.delete(a);
        }
        getGesture(a) {
            const b = "pointerdown" === a.type, c = this.currentGesture_;
            return c ? b && c.hasStarted() ? (console.warn("Tried to start the same gesture twice."), c.cancel(), null) : c : b ? this.currentGesture_ = new Gesture$$module$build$src$core$gesture(a, this) : null;
        }
        clearGesture() {
            this.currentGesture_ = null;
        }
        cancelCurrentGesture() {
            this.currentGesture_ && this.currentGesture_.cancel();
        }
        getAudioManager() {
            return this.audioManager;
        }
        getGrid() {
            return this.grid;
        }
        hideChaff(a) {
            hide$$module$build$src$core$tooltip();
            hide$$module$build$src$core$widgetdiv();
            hideWithoutAnimation$$module$build$src$core$dropdowndiv();
            const b = !!a;
            this.getComponentManager().getComponents(ComponentManager$$module$build$src$core$component_manager.Capability.AUTOHIDEABLE, !0).forEach((c)=>c.autoHide(b));
        }
        static setTopLevelWorkspaceMetrics_(a) {
            const b = this.getMetrics();
            "number" === typeof a.x && (this.scrollX = -(b.scrollLeft + (b.scrollWidth - b.viewWidth) * a.x));
            "number" === typeof a.y && (this.scrollY = -(b.scrollTop + (b.scrollHeight - b.viewHeight) * a.y));
            this.translate(this.scrollX + b.absoluteLeft, this.scrollY + b.absoluteTop);
        }
    }, module$build$src$core$workspace_svg = {};
    module$build$src$core$workspace_svg.WorkspaceSvg = WorkspaceSvg$$module$build$src$core$workspace_svg;
    module$build$src$core$workspace_svg.resizeSvgContents = resizeSvgContents$$module$build$src$core$workspace_svg;
    var FlyoutItemType$$module$build$src$core$flyout_base;
    (function(a) {
        a.BLOCK = "block";
        a.BUTTON = "button";
    })(FlyoutItemType$$module$build$src$core$flyout_base || (FlyoutItemType$$module$build$src$core$flyout_base = {}));
    var Flyout$$module$build$src$core$flyout_base = class extends DeleteArea$$module$build$src$core$delete_area {
        constructor(a){
            super();
            this.horizontalLayout = !1;
            this.boundEvents = [];
            this.filterWrapper_ = this.reflowWrapper_ = null;
            this.mats_ = [];
            this.buttons_ = [];
            this.listeners_ = [];
            this.permanentlyDisabled_ = [];
            this.recycledBlocks_ = [];
            this.autoClose = !0;
            this.isVisible_ = !1;
            this.containerVisible_ = !0;
            this.CORNER_RADIUS = 8;
            this.SCROLLBAR_MARGIN = 2.5;
            this.height_ = this.width_ = 0;
            this.dragAngleRange_ = 70;
            this.svgGroup_ = this.svgBackground_ = null;
            a.setMetrics = this.setMetrics_.bind(this);
            this.workspace_ = new WorkspaceSvg$$module$build$src$core$workspace_svg(a);
            this.workspace_.setMetricsManager(new FlyoutMetricsManager$$module$build$src$core$flyout_metrics_manager(this.workspace_, this));
            this.workspace_.internalIsFlyout = !0;
            this.workspace_.setVisible(this.isVisible_);
            this.id = genUid$$module$build$src$core$utils$idgenerator();
            this.RTL = !!a.RTL;
            this.toolboxPosition_ = a.toolboxPosition;
            this.tabWidth_ = this.workspace_.getRenderer().getConstants().TAB_WIDTH;
            this.rectMap_ = new WeakMap;
            this.MARGIN = this.CORNER_RADIUS;
            this.GAP_X = 3 * this.MARGIN;
            this.GAP_Y = 3 * this.MARGIN;
        }
        createDom(a) {
            this.svgGroup_ = createSvgElement$$module$build$src$core$utils$dom(a, {
                "class": "blocklyFlyout",
                style: "display: none"
            });
            this.svgBackground_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATH, {
                "class": "blocklyFlyoutBackground"
            }, this.svgGroup_);
            this.svgGroup_.appendChild(this.workspace_.createDom());
            this.workspace_.getThemeManager().subscribe(this.svgBackground_, "flyoutBackgroundColour", "fill");
            this.workspace_.getThemeManager().subscribe(this.svgBackground_, "flyoutOpacity", "fill-opacity");
            return this.svgGroup_;
        }
        init(a) {
            this.targetWorkspace = a;
            this.workspace_.targetWorkspace = a;
            this.workspace_.scrollbar = new ScrollbarPair$$module$build$src$core$scrollbar_pair(this.workspace_, this.horizontalLayout, !this.horizontalLayout, "blocklyFlyoutScrollbar", this.SCROLLBAR_MARGIN);
            this.hide();
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(this.svgGroup_, "wheel", this, this.wheel_));
            this.autoClose || (this.filterWrapper_ = this.filterForCapacity_.bind(this), this.targetWorkspace.addChangeListener(this.filterWrapper_));
            this.boundEvents.push(conditionalBind$$module$build$src$core$browser_events(this.svgBackground_, "pointerdown", this, this.onMouseDown_));
            this.workspace_.getGesture = this.targetWorkspace.getGesture.bind(this.targetWorkspace);
            this.workspace_.setVariableMap(this.targetWorkspace.getVariableMap());
            this.workspace_.createPotentialVariableMap();
            a.getComponentManager().addComponent({
                component: this,
                weight: 1,
                capabilities: [
                    ComponentManager$$module$build$src$core$component_manager.Capability.DELETE_AREA,
                    ComponentManager$$module$build$src$core$component_manager.Capability.DRAG_TARGET
                ]
            });
        }
        dispose() {
            this.hide();
            this.workspace_.getComponentManager().removeComponent(this.id);
            for (const a of this.boundEvents)unbind$$module$build$src$core$browser_events(a);
            this.boundEvents.length = 0;
            this.filterWrapper_ && (this.targetWorkspace.removeChangeListener(this.filterWrapper_), this.filterWrapper_ = null);
            this.workspace_ && (this.workspace_.getThemeManager().unsubscribe(this.svgBackground_), this.workspace_.dispose());
            this.svgGroup_ && (removeNode$$module$build$src$core$utils$dom(this.svgGroup_), this.svgGroup_ = null);
            this.svgBackground_ = null;
        }
        getWidth() {
            return this.width_;
        }
        getHeight() {
            return this.height_;
        }
        getFlyoutScale() {
            return this.targetWorkspace.scale;
        }
        getWorkspace() {
            return this.workspace_;
        }
        isVisible() {
            return this.isVisible_;
        }
        setVisible(a) {
            const b = a !== this.isVisible();
            this.isVisible_ = a;
            b && (this.autoClose || this.workspace_.recordDragTargets(), this.updateDisplay_());
        }
        setContainerVisible(a) {
            const b = a !== this.containerVisible_;
            this.containerVisible_ = a;
            b && this.updateDisplay_();
        }
        updateDisplay_() {
            let a;
            a = this.containerVisible_ ? this.isVisible() : !1;
            this.svgGroup_ && (this.svgGroup_.style.display = a ? "block" : "none");
            let b;
            null == (b = this.workspace_.scrollbar) || b.setContainerVisible(a);
        }
        positionAt_(a, b, c, d) {
            let e;
            null == (e = this.svgGroup_) || e.setAttribute("width", `${a}`);
            let f;
            null == (f = this.svgGroup_) || f.setAttribute("height", `${b}`);
            this.workspace_.setCachedParentSvgSize(a, b);
            this.svgGroup_ && setCssTransform$$module$build$src$core$utils$dom(this.svgGroup_, "translate(" + c + "px," + d + "px)");
            if (a = this.workspace_.scrollbar) a.setOrigin(c, d), a.resize(), a.hScroll && a.hScroll.setPosition(a.hScroll.position.x, a.hScroll.position.y), a.vScroll && a.vScroll.setPosition(a.vScroll.position.x, a.vScroll.position.y);
        }
        hide() {
            if (this.isVisible()) {
                this.setVisible(!1);
                for (const a of this.listeners_)unbind$$module$build$src$core$browser_events(a);
                this.listeners_.length = 0;
                this.reflowWrapper_ && (this.workspace_.removeChangeListener(this.reflowWrapper_), this.reflowWrapper_ = null);
            }
        }
        show(a) {
            this.workspace_.setResizesEnabled(!1);
            this.hide();
            this.clearOldBlocks_();
            "string" === typeof a && (a = this.getDynamicCategoryContents_(a));
            this.setVisible(!0);
            a = convertFlyoutDefToJsonArray$$module$build$src$core$utils$toolbox(a);
            a = this.createFlyoutInfo_(a);
            this.layout_(a.contents, a.gaps);
            this.horizontalLayout ? this.height_ = 0 : this.width_ = 0;
            this.workspace_.setResizesEnabled(!0);
            this.reflow();
            this.filterForCapacity_();
            this.position();
            this.reflowWrapper_ = this.reflow.bind(this);
            this.workspace_.addChangeListener(this.reflowWrapper_);
            this.emptyRecycledBlocks_();
        }
        createFlyoutInfo_(a) {
            const b = [], c = [];
            this.permanentlyDisabled_.length = 0;
            const d = this.horizontalLayout ? this.GAP_X : this.GAP_Y;
            for (const e of a){
                if ("custom" in e) {
                    a = this.getDynamicCategoryContents_(e.custom);
                    a = convertFlyoutDefToJsonArray$$module$build$src$core$utils$toolbox(a);
                    const { contents: f, gaps: g } = this.createFlyoutInfo_(a);
                    b.push(...f);
                    c.push(...g);
                }
                switch(e.kind.toUpperCase()){
                    case "BLOCK":
                        a = e;
                        const f = this.createFlyoutBlock_(a);
                        b.push({
                            type: FlyoutItemType$$module$build$src$core$flyout_base.BLOCK,
                            block: f
                        });
                        this.addBlockGap_(a, c, d);
                        break;
                    case "SEP":
                        this.addSeparatorGap_(e, c, d);
                        break;
                    case "LABEL":
                        a = this.createButton_(e, !0);
                        b.push({
                            type: FlyoutItemType$$module$build$src$core$flyout_base.BUTTON,
                            button: a
                        });
                        c.push(d);
                        break;
                    case "BUTTON":
                        a = this.createButton_(e, !1), b.push({
                            type: FlyoutItemType$$module$build$src$core$flyout_base.BUTTON,
                            button: a
                        }), c.push(d);
                }
            }
            return {
                contents: b,
                gaps: c
            };
        }
        getDynamicCategoryContents_(a) {
            a = this.workspace_.targetWorkspace.getToolboxCategoryCallback(a);
            if ("function" !== typeof a) throw TypeError("Couldn't find a callback function when opening a toolbox category.");
            return a(this.workspace_.targetWorkspace);
        }
        createButton_(a, b) {
            return new FlyoutButton$$module$build$src$core$flyout_button(this.workspace_, this.targetWorkspace, a, b);
        }
        createFlyoutBlock_(a) {
            let b;
            a.blockxml ? (a = "string" === typeof a.blockxml ? textToDom$$module$build$src$core$utils$xml(a.blockxml) : a.blockxml, (b = this.getRecycledBlock_(a.getAttribute("type"))) || (b = domToBlock$$module$build$src$core$xml(a, this.workspace_))) : (b = this.getRecycledBlock_(a.type), b || (void 0 === a.enabled && (a.enabled = "true" !== a.disabled && !0 !== a.disabled), b = append$$module$build$src$core$serialization$blocks(a, this.workspace_)));
            b.isEnabled() || this.permanentlyDisabled_.push(b);
            return b;
        }
        getRecycledBlock_(a) {
            let b = -1;
            for(let c = 0; c < this.recycledBlocks_.length; c++)if (this.recycledBlocks_[c].type === a) {
                b = c;
                break;
            }
            return -1 === b ? void 0 : this.recycledBlocks_.splice(b, 1)[0];
        }
        addBlockGap_(a, b, c) {
            let d;
            a.gap ? d = parseInt(String(a.gap)) : a.blockxml && (a = "string" === typeof a.blockxml ? textToDom$$module$build$src$core$utils$xml(a.blockxml) : a.blockxml, d = parseInt(a.getAttribute("gap")));
            b.push(!d || isNaN(d) ? c : d);
        }
        addSeparatorGap_(a, b, c) {
            a = parseInt(String(a.gap));
            !isNaN(a) && 0 < b.length ? b[b.length - 1] = a : b.push(c);
        }
        clearOldBlocks_() {
            var a = this.workspace_.getTopBlocks(!1);
            for(let c = 0, d; d = a[c]; c++)this.blockIsRecyclable_(d) ? this.recycleBlock_(d) : d.dispose(!1, !1);
            for(a = 0; a < this.mats_.length; a++){
                const c = this.mats_[a];
                c && (unbindMouseEvents$$module$build$src$core$tooltip(c), removeNode$$module$build$src$core$utils$dom(c));
            }
            this.mats_.length = 0;
            for(let c = 0, d; d = this.buttons_[c]; c++)d.dispose();
            this.buttons_.length = 0;
            let b;
            null == (b = this.workspace_.getPotentialVariableMap()) || b.clear();
        }
        emptyRecycledBlocks_() {
            for(let a = 0; a < this.recycledBlocks_.length; a++)this.recycledBlocks_[a].dispose();
            this.recycledBlocks_ = [];
        }
        blockIsRecyclable_(a) {
            return !1;
        }
        recycleBlock_(a) {
            const b = a.getRelativeToSurfaceXY();
            a.moveBy(-b.x, -b.y);
            this.recycledBlocks_.push(a);
        }
        addBlockListeners_(a, b, c) {
            this.listeners_.push(conditionalBind$$module$build$src$core$browser_events(a, "pointerdown", null, this.blockMouseDown_(b)));
            this.listeners_.push(conditionalBind$$module$build$src$core$browser_events(c, "pointerdown", null, this.blockMouseDown_(b)));
            this.listeners_.push(bind$$module$build$src$core$browser_events(a, "pointerenter", b, b.addSelect));
            this.listeners_.push(bind$$module$build$src$core$browser_events(a, "pointerleave", b, b.removeSelect));
            this.listeners_.push(bind$$module$build$src$core$browser_events(c, "pointerenter", b, b.addSelect));
            this.listeners_.push(bind$$module$build$src$core$browser_events(c, "pointerleave", b, b.removeSelect));
        }
        blockMouseDown_(a) {
            return (b)=>{
                const c = this.targetWorkspace.getGesture(b);
                c && (c.setStartBlock(a), c.handleFlyoutStart(b, this));
            };
        }
        onMouseDown_(a) {
            const b = this.targetWorkspace.getGesture(a);
            b && b.handleFlyoutStart(a, this);
        }
        isBlockCreatable(a) {
            return a.isEnabled();
        }
        createBlock(a) {
            let b = null;
            disable$$module$build$src$core$events$utils();
            var c = this.targetWorkspace.getAllVariables();
            this.targetWorkspace.setResizesEnabled(!1);
            try {
                b = this.placeNewBlock_(a);
            } finally{
                enable$$module$build$src$core$events$utils();
            }
            this.targetWorkspace.hideChaff();
            a = getAddedVariables$$module$build$src$core$variables(this.targetWorkspace, c);
            if (isEnabled$$module$build$src$core$events$utils()) {
                setGroup$$module$build$src$core$events$utils(!0);
                for(c = 0; c < a.length; c++){
                    const d = a[c];
                    fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(VAR_CREATE$$module$build$src$core$events$utils))(d));
                }
                fire$$module$build$src$core$events$utils(new (get$$module$build$src$core$events$utils(CREATE$$module$build$src$core$events$utils))(b));
            }
            this.autoClose ? this.hide() : this.filterForCapacity_();
            return b;
        }
        initFlyoutButton_(a, b, c) {
            const d = a.createDom();
            a.moveTo(b, c);
            a.show();
            this.listeners_.push(conditionalBind$$module$build$src$core$browser_events(d, "pointerdown", this, this.onMouseDown_));
            this.buttons_.push(a);
        }
        createRect_(a, b, c, d, e) {
            b = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                "fill-opacity": 0,
                x: b,
                y: c,
                height: d.height,
                width: d.width
            });
            b.tooltip = a;
            bindMouseEvents$$module$build$src$core$tooltip(b);
            this.workspace_.getCanvas().insertBefore(b, a.getSvgRoot());
            this.rectMap_.set(a, b);
            return this.mats_[e] = b;
        }
        moveRectToBlock_(a, b) {
            const c = b.getHeightWidth();
            a.setAttribute("width", String(c.width));
            a.setAttribute("height", String(c.height));
            b = b.getRelativeToSurfaceXY();
            a.setAttribute("y", String(b.y));
            a.setAttribute("x", String(this.RTL ? b.x - c.width : b.x));
        }
        filterForCapacity_() {
            const a = this.workspace_.getTopBlocks(!1);
            for(let b = 0, c; c = a[b]; b++)if (-1 === this.permanentlyDisabled_.indexOf(c)) {
                const d = this.targetWorkspace.isCapacityAvailable(getBlockTypeCounts$$module$build$src$core$common(c));
                for(; c;)c.setEnabled(d), c = c.getNextBlock();
            }
        }
        reflow() {
            this.reflowWrapper_ && this.workspace_.removeChangeListener(this.reflowWrapper_);
            this.reflowInternal_();
            this.reflowWrapper_ && this.workspace_.addChangeListener(this.reflowWrapper_);
        }
        isScrollable() {
            return this.workspace_.scrollbar ? this.workspace_.scrollbar.isVisible() : !1;
        }
        placeNewBlock_(a) {
            var b = this.targetWorkspace;
            if (!a.getSvgRoot()) throw Error("oldBlock is not rendered.");
            const c = save$$module$build$src$core$serialization$blocks(a);
            b.setResizesEnabled(!1);
            b = append$$module$build$src$core$serialization$blocks(c, b);
            this.positionNewBlock_(a, b);
            return b;
        }
        positionNewBlock_(a, b) {
            const c = this.targetWorkspace;
            var d = c.getOriginOffsetInPixels(), e = this.workspace_.getOriginOffsetInPixels();
            a = a.getRelativeToSurfaceXY();
            a.scale(this.workspace_.scale);
            e = Coordinate$$module$build$src$core$utils$coordinate.sum(e, a);
            d = Coordinate$$module$build$src$core$utils$coordinate.difference(e, d);
            d.scale(1 / c.scale);
            b.moveTo(new Coordinate$$module$build$src$core$utils$coordinate(d.x, d.y));
        }
    };
    Flyout$$module$build$src$core$flyout_base.FlyoutItemType = FlyoutItemType$$module$build$src$core$flyout_base;
    var module$build$src$core$flyout_base = {};
    module$build$src$core$flyout_base.Flyout = Flyout$$module$build$src$core$flyout_base;
    var HorizontalFlyout$$module$build$src$core$flyout_horizontal = class extends Flyout$$module$build$src$core$flyout_base {
        constructor(a){
            super(a);
            this.horizontalLayout = !0;
        }
        setMetrics_(a) {
            if (this.isVisible()) {
                var b = this.workspace_.getMetricsManager(), c = b.getScrollMetrics(), d = b.getViewMetrics();
                b = b.getAbsoluteMetrics();
                "number" === typeof a.x && (this.workspace_.scrollX = -(c.left + (c.width - d.width) * a.x));
                this.workspace_.translate(this.workspace_.scrollX + b.left, this.workspace_.scrollY + b.top);
            }
        }
        getX() {
            return 0;
        }
        getY() {
            if (!this.isVisible()) return 0;
            var a = this.targetWorkspace.getMetricsManager();
            const b = a.getAbsoluteMetrics(), c = a.getViewMetrics();
            a = a.getToolboxMetrics();
            const d = this.toolboxPosition_ === Position$$module$build$src$core$utils$toolbox.TOP;
            return this.targetWorkspace.toolboxPosition === this.toolboxPosition_ ? this.targetWorkspace.getToolbox() ? d ? a.height : c.height - this.height_ : d ? 0 : c.height : d ? 0 : c.height + b.top - this.height_;
        }
        position() {
            if (this.isVisible() && this.targetWorkspace.isVisible()) {
                var a = this.targetWorkspace.getMetricsManager().getViewMetrics();
                this.width_ = a.width;
                this.setBackgroundPath_(a.width - 2 * this.CORNER_RADIUS, this.height_ - this.CORNER_RADIUS);
                a = this.getX();
                var b = this.getY();
                this.positionAt_(this.width_, this.height_, a, b);
            }
        }
        setBackgroundPath_(a, b) {
            const c = this.toolboxPosition_ === Position$$module$build$src$core$utils$toolbox.TOP, d = [
                "M 0," + (c ? 0 : this.CORNER_RADIUS)
            ];
            c ? (d.push("h", a + 2 * this.CORNER_RADIUS), d.push("v", b), d.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, 1, -this.CORNER_RADIUS, this.CORNER_RADIUS), d.push("h", -a), d.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, 1, -this.CORNER_RADIUS, -this.CORNER_RADIUS)) : (d.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, 1, this.CORNER_RADIUS, -this.CORNER_RADIUS), d.push("h", a), d.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, 1, this.CORNER_RADIUS, this.CORNER_RADIUS), d.push("v", b), d.push("h", -a - 2 * this.CORNER_RADIUS));
            d.push("z");
            this.svgBackground_.setAttribute("d", d.join(" "));
        }
        scrollToStart() {
            let a;
            null == (a = this.workspace_.scrollbar) || a.setX(this.RTL ? Infinity : 0);
        }
        wheel_(a) {
            var b = getScrollDeltaPixels$$module$build$src$core$browser_events(a);
            if (b = b.x || b.y) {
                const c = this.workspace_.getMetricsManager(), d = c.getScrollMetrics();
                b = c.getViewMetrics().left - d.left + b;
                let e;
                null == (e = this.workspace_.scrollbar) || e.setX(b);
                hide$$module$build$src$core$widgetdiv();
                hideWithoutAnimation$$module$build$src$core$dropdowndiv();
            }
            a.preventDefault();
            a.stopPropagation();
        }
        layout_(a, b) {
            this.workspace_.scale = this.targetWorkspace.scale;
            const c = this.MARGIN;
            let d = c + this.tabWidth_;
            this.RTL && (a = a.reverse());
            for(let h = 0, k; k = a[h]; h++)if ("block" === k.type) {
                var e = k.block, f = e.getDescendants(!1);
                for(let m = 0, n; n = f[m]; m++)n.isInFlyout = !0;
                e.render();
                f = e.getSvgRoot();
                const l = e.getHeightWidth();
                var g = e.outputConnection ? this.tabWidth_ : 0;
                g = this.RTL ? d + l.width : d - g;
                e.moveBy(g, c);
                g = this.createRect_(e, g, c, l, h);
                d += l.width + b[h];
                this.addBlockListeners_(f, e, g);
            } else "button" === k.type && (e = k.button, this.initFlyoutButton_(e, d, c), d += e.width + b[h]);
        }
        isDragTowardWorkspace(a) {
            a = Math.atan2(a.y, a.x) / Math.PI * 180;
            const b = this.dragAngleRange_;
            return a < 90 + b && a > 90 - b || a > -90 - b && a < -90 + b ? !0 : !1;
        }
        getClientRect() {
            if (!this.svgGroup_ || this.autoClose || !this.isVisible()) return null;
            const a = this.svgGroup_.getBoundingClientRect(), b = a.top;
            return this.toolboxPosition_ === Position$$module$build$src$core$utils$toolbox.TOP ? new Rect$$module$build$src$core$utils$rect(-1000000000, b + a.height, -1000000000, 1E9) : new Rect$$module$build$src$core$utils$rect(b, 1E9, -1000000000, 1E9);
        }
        reflowInternal_() {
            this.workspace_.scale = this.getFlyoutScale();
            let a = 0;
            const b = this.workspace_.getTopBlocks(!1);
            for(let d = 0, e; e = b[d]; d++)a = Math.max(a, e.getHeightWidth().height);
            const c = this.buttons_;
            for(let d = 0, e; e = c[d]; d++)a = Math.max(a, e.height);
            a += 1.5 * this.MARGIN;
            a *= this.workspace_.scale;
            a += Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness;
            if (this.height_ !== a) {
                for(let d = 0, e; e = b[d]; d++)this.rectMap_.has(e) && this.moveRectToBlock_(this.rectMap_.get(e), e);
                this.targetWorkspace.toolboxPosition !== this.toolboxPosition_ || this.toolboxPosition_ !== Position$$module$build$src$core$utils$toolbox.TOP || this.targetWorkspace.getToolbox() || this.targetWorkspace.translate(this.targetWorkspace.scrollX, this.targetWorkspace.scrollY + a);
                this.height_ = a;
                this.position();
                this.targetWorkspace.recordDragTargets();
            }
        }
    };
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.FLYOUTS_HORIZONTAL_TOOLBOX, DEFAULT$$module$build$src$core$registry, HorizontalFlyout$$module$build$src$core$flyout_horizontal);
    var module$build$src$core$flyout_horizontal = {};
    module$build$src$core$flyout_horizontal.HorizontalFlyout = HorizontalFlyout$$module$build$src$core$flyout_horizontal;
    var VerticalFlyout$$module$build$src$core$flyout_vertical = class extends Flyout$$module$build$src$core$flyout_base {
        constructor(a){
            super(a);
        }
        setMetrics_(a) {
            if (this.isVisible()) {
                var b = this.workspace_.getMetricsManager(), c = b.getScrollMetrics(), d = b.getViewMetrics();
                b = b.getAbsoluteMetrics();
                "number" === typeof a.y && (this.workspace_.scrollY = -(c.top + (c.height - d.height) * a.y));
                this.workspace_.translate(this.workspace_.scrollX + b.left, this.workspace_.scrollY + b.top);
            }
        }
        getX() {
            if (!this.isVisible()) return 0;
            var a = this.targetWorkspace.getMetricsManager();
            const b = a.getAbsoluteMetrics(), c = a.getViewMetrics();
            a = a.getToolboxMetrics();
            return this.targetWorkspace.toolboxPosition === this.toolboxPosition_ ? this.targetWorkspace.getToolbox() ? this.toolboxPosition_ === Position$$module$build$src$core$utils$toolbox.LEFT ? a.width : c.width - this.width_ : this.toolboxPosition_ === Position$$module$build$src$core$utils$toolbox.LEFT ? 0 : c.width : this.toolboxPosition_ === Position$$module$build$src$core$utils$toolbox.LEFT ? 0 : c.width + b.left - this.width_;
        }
        getY() {
            return 0;
        }
        position() {
            if (this.isVisible() && this.targetWorkspace.isVisible()) {
                var a = this.targetWorkspace.getMetricsManager().getViewMetrics();
                this.height_ = a.height;
                this.setBackgroundPath_(this.width_ - this.CORNER_RADIUS, a.height - 2 * this.CORNER_RADIUS);
                a = this.getX();
                var b = this.getY();
                this.positionAt_(this.width_, this.height_, a, b);
            }
        }
        setBackgroundPath_(a, b) {
            const c = this.toolboxPosition_ === Position$$module$build$src$core$utils$toolbox.RIGHT;
            var d = a + this.CORNER_RADIUS;
            d = [
                "M " + (c ? d : 0) + ",0"
            ];
            d.push("h", c ? -a : a);
            d.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, c ? 0 : 1, c ? -this.CORNER_RADIUS : this.CORNER_RADIUS, this.CORNER_RADIUS);
            d.push("v", Math.max(0, b));
            d.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, c ? 0 : 1, c ? this.CORNER_RADIUS : -this.CORNER_RADIUS, this.CORNER_RADIUS);
            d.push("h", c ? a : -a);
            d.push("z");
            this.svgBackground_.setAttribute("d", d.join(" "));
        }
        scrollToStart() {
            let a;
            null == (a = this.workspace_.scrollbar) || a.setY(0);
        }
        wheel_(a) {
            var b = getScrollDeltaPixels$$module$build$src$core$browser_events(a);
            if (b.y) {
                const c = this.workspace_.getMetricsManager(), d = c.getScrollMetrics();
                b = c.getViewMetrics().top - d.top + b.y;
                let e;
                null == (e = this.workspace_.scrollbar) || e.setY(b);
                hide$$module$build$src$core$widgetdiv();
                hideWithoutAnimation$$module$build$src$core$dropdowndiv();
            }
            a.preventDefault();
            a.stopPropagation();
        }
        layout_(a, b) {
            this.workspace_.scale = this.targetWorkspace.scale;
            var c = this.MARGIN;
            const d = this.RTL ? c : c + this.tabWidth_;
            for(let h = 0, k; k = a[h]; h++)if ("block" === k.type) {
                var e = k.block, f = e.getDescendants(!1);
                for(let m = 0, n; n = f[m]; m++)n.isInFlyout = !0;
                e.render();
                f = e.getSvgRoot();
                const l = e.getHeightWidth();
                var g = e.outputConnection ? d - this.tabWidth_ : d;
                e.moveBy(g, c);
                g = this.createRect_(e, this.RTL ? g - l.width : g, c, l, h);
                this.addBlockListeners_(f, e, g);
                c += l.height + b[h];
            } else "button" === k.type && (e = k.button, this.initFlyoutButton_(e, d, c), c += e.height + b[h]);
        }
        isDragTowardWorkspace(a) {
            a = Math.atan2(a.y, a.x) / Math.PI * 180;
            const b = this.dragAngleRange_;
            return a < b && a > -b || a < -180 + b || a > 180 - b ? !0 : !1;
        }
        getClientRect() {
            if (!this.svgGroup_ || this.autoClose || !this.isVisible()) return null;
            const a = this.svgGroup_.getBoundingClientRect(), b = a.left;
            return this.toolboxPosition_ === Position$$module$build$src$core$utils$toolbox.LEFT ? new Rect$$module$build$src$core$utils$rect(-1000000000, 1E9, -1000000000, b + a.width) : new Rect$$module$build$src$core$utils$rect(-1000000000, 1E9, b, 1E9);
        }
        reflowInternal_() {
            this.workspace_.scale = this.getFlyoutScale();
            let a = 0;
            var b = this.workspace_.getTopBlocks(!1);
            for(let d = 0, e; e = b[d]; d++){
                var c = e.getHeightWidth().width;
                e.outputConnection && (c -= this.tabWidth_);
                a = Math.max(a, c);
            }
            for(let d = 0, e; e = this.buttons_[d]; d++)a = Math.max(a, e.width);
            a += 1.5 * this.MARGIN + this.tabWidth_;
            a *= this.workspace_.scale;
            a += Scrollbar$$module$build$src$core$scrollbar.scrollbarThickness;
            if (this.width_ !== a) {
                for(let d = 0, e; e = b[d]; d++){
                    if (this.RTL) {
                        c = e.getRelativeToSurfaceXY().x;
                        let f = a / this.workspace_.scale - this.MARGIN;
                        e.outputConnection || (f -= this.tabWidth_);
                        e.moveBy(f - c, 0);
                    }
                    this.rectMap_.has(e) && this.moveRectToBlock_(this.rectMap_.get(e), e);
                }
                if (this.RTL) for(let d = 0, e; e = this.buttons_[d]; d++)b = e.getPosition().y, e.moveTo(a / this.workspace_.scale - e.width - this.MARGIN - this.tabWidth_, b);
                this.targetWorkspace.toolboxPosition !== this.toolboxPosition_ || this.toolboxPosition_ !== Position$$module$build$src$core$utils$toolbox.LEFT || this.targetWorkspace.getToolbox() || this.targetWorkspace.translate(this.targetWorkspace.scrollX + a, this.targetWorkspace.scrollY);
                this.width_ = a;
                this.position();
                this.targetWorkspace.recordDragTargets();
            }
        }
    };
    VerticalFlyout$$module$build$src$core$flyout_vertical.registryName = "verticalFlyout";
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.FLYOUTS_VERTICAL_TOOLBOX, DEFAULT$$module$build$src$core$registry, VerticalFlyout$$module$build$src$core$flyout_vertical);
    var module$build$src$core$flyout_vertical = {};
    module$build$src$core$flyout_vertical.VerticalFlyout = VerticalFlyout$$module$build$src$core$flyout_vertical;
    $.CodeGenerator$$module$build$src$core$generator = class {
        constructor(a){
            this.FUNCTION_NAME_PLACEHOLDER_ = "{leCUI8hutHZI4480Dc}";
            this.STATEMENT_SUFFIX = this.STATEMENT_PREFIX = this.INFINITE_LOOP_TRAP = null;
            this.INDENT = "  ";
            this.COMMENT_WRAP = 60;
            this.ORDER_OVERRIDES = [];
            this.isInitialized = null;
            this.RESERVED_WORDS_ = "";
            this.definitions_ = Object.create(null);
            this.functionNames_ = Object.create(null);
            this.nameDB_ = void 0;
            this.name_ = a;
            this.FUNCTION_NAME_PLACEHOLDER_REGEXP_ = new RegExp(this.FUNCTION_NAME_PLACEHOLDER_, "g");
        }
        workspaceToCode(a) {
            a || (console.warn("No workspace specified in workspaceToCode call.  Guessing."), a = getMainWorkspace$$module$build$src$core$common());
            var b = [];
            this.init(a);
            a = a.getTopBlocks(!0);
            for(let c = 0, d; d = a[c]; c++){
                let e = this.blockToCode(d);
                Array.isArray(e) && (e = e[0]);
                e && (d.outputConnection && (e = this.scrubNakedValue(e), this.STATEMENT_PREFIX && !d.suppressPrefixSuffix && (e = this.injectId(this.STATEMENT_PREFIX, d) + e), this.STATEMENT_SUFFIX && !d.suppressPrefixSuffix && (e += this.injectId(this.STATEMENT_SUFFIX, d))), b.push(e));
            }
            b = b.join("\n");
            b = this.finish(b);
            b = b.replace(/^\s+\n/, "");
            b = b.replace(/\n\s+$/, "\n");
            return b = b.replace(/[ \t]+\n/g, "\n");
        }
        prefixLines(a, b) {
            return b + a.replace(/(?!\n$)\n/g, "\n" + b);
        }
        allNestedComments(a) {
            const b = [];
            a = a.getDescendants(!0);
            for(let c = 0; c < a.length; c++){
                const d = a[c].getCommentText();
                d && b.push(d);
            }
            b.length && b.push("");
            return b.join("\n");
        }
        blockToCode(a, b) {
            !1 === this.isInitialized && console.warn("CodeGenerator init was not called before blockToCode was called.");
            if (!a) return "";
            if (!a.isEnabled()) return b ? "" : this.blockToCode(a.getNextBlock());
            if (a.isInsertionMarker()) return b ? "" : this.blockToCode(a.getChildren(!1)[0]);
            var c = this[a.type];
            if ("function" !== typeof c) throw Error('Language "' + this.name_ + '" does not know how to generate code for block type "' + a.type + '".');
            c = c.call(a, a);
            if (Array.isArray(c)) {
                if (!a.outputConnection) throw TypeError("Expecting string from statement block: " + a.type);
                return [
                    this.scrub_(a, c[0], b),
                    c[1]
                ];
            }
            if ("string" === typeof c) return this.STATEMENT_PREFIX && !a.suppressPrefixSuffix && (c = this.injectId(this.STATEMENT_PREFIX, a) + c), this.STATEMENT_SUFFIX && !a.suppressPrefixSuffix && (c += this.injectId(this.STATEMENT_SUFFIX, a)), this.scrub_(a, c, b);
            if (null === c) return "";
            throw SyntaxError("Invalid code generated: " + c);
        }
        valueToCode(a, b, c) {
            if (isNaN(c)) throw TypeError("Expecting valid order from block: " + a.type);
            var d = a.getInputTargetBlock(b);
            if (!d) return "";
            b = this.blockToCode(d);
            if ("" === b) return "";
            if (!Array.isArray(b)) throw TypeError(`Expecting tuple from value block: ${d.type} See ` + "developers.google.com/blockly/guides/create-custom-blocks/generating-code for more information");
            a = b[0];
            b = b[1];
            if (isNaN(b)) throw TypeError("Expecting valid order from value block: " + d.type);
            if (!a) return "";
            d = !1;
            var e = Math.floor(c);
            const f = Math.floor(b);
            if (e <= f && (e !== f || 0 !== e && 99 !== e)) {
                for(d = !0, e = 0; e < this.ORDER_OVERRIDES.length; e++)if (this.ORDER_OVERRIDES[e][0] === c && this.ORDER_OVERRIDES[e][1] === b) {
                    d = !1;
                    break;
                }
            }
            d && (a = "(" + a + ")");
            return a;
        }
        statementToCode(a, b) {
            a = a.getInputTargetBlock(b);
            b = this.blockToCode(a);
            if ("string" !== typeof b) throw TypeError("Expecting code from statement block: " + (a && a.type));
            b && (b = this.prefixLines(b, this.INDENT));
            return b;
        }
        addLoopTrap(a, b) {
            this.INFINITE_LOOP_TRAP && (a = this.prefixLines(this.injectId(this.INFINITE_LOOP_TRAP, b), this.INDENT) + a);
            this.STATEMENT_SUFFIX && !b.suppressPrefixSuffix && (a = this.prefixLines(this.injectId(this.STATEMENT_SUFFIX, b), this.INDENT) + a);
            this.STATEMENT_PREFIX && !b.suppressPrefixSuffix && (a += this.prefixLines(this.injectId(this.STATEMENT_PREFIX, b), this.INDENT));
            return a;
        }
        injectId(a, b) {
            b = b.id.replace(/\$/g, "$$$$");
            return a.replace(/%1/g, "'" + b + "'");
        }
        addReservedWords(a) {
            this.RESERVED_WORDS_ += a + ",";
        }
        provideFunction_(a, b) {
            if (!this.definitions_[a]) {
                const c = this.nameDB_.getDistinctName(a, $.NameType$$module$build$src$core$names.PROCEDURE);
                this.functionNames_[a] = c;
                Array.isArray(b) && (b = b.join("\n"));
                b = b.trim().replace(this.FUNCTION_NAME_PLACEHOLDER_REGEXP_, c);
                let d;
                for(; d !== b;)d = b, b = b.replace(/^(( {2})*) {2}/gm, "$1\0");
                b = b.replace(/\0/g, this.INDENT);
                this.definitions_[a] = b;
            }
            return this.functionNames_[a];
        }
        init(a) {
            this.definitions_ = Object.create(null);
            this.functionNames_ = Object.create(null);
        }
        scrub_(a, b, c) {
            return b;
        }
        finish(a) {
            this.definitions_ = Object.create(null);
            this.functionNames_ = Object.create(null);
            return a;
        }
        scrubNakedValue(a) {
            return a;
        }
    };
    Object.defineProperties($.CodeGenerator$$module$build$src$core$generator.prototype, {
        variableDB_: {
            get () {
                warn$$module$build$src$core$utils$deprecation("variableDB_", "version 9", "version 10", "nameDB_");
                return this.nameDB_;
            },
            set (a) {
                warn$$module$build$src$core$utils$deprecation("variableDB_", "version 9", "version 10", "nameDB_");
                this.nameDB_ = a;
            }
        }
    });
    var module$build$src$core$generator = {};
    module$build$src$core$generator.CodeGenerator = $.CodeGenerator$$module$build$src$core$generator;
    var ShortcutRegistry$$module$build$src$core$shortcut_registry = class {
        constructor(){
            this.shortcuts = new Map;
            this.keyMap = new Map;
            this.reset();
        }
        reset() {
            this.shortcuts.clear();
            this.keyMap.clear();
        }
        register(a, b) {
            if (this.shortcuts.get(a.name) && !b) throw Error(`Shortcut named "${a.name}" already exists.`);
            this.shortcuts.set(a.name, a);
            if ((b = a.keyCodes) && 0 < b.length) for(let c = 0; c < b.length; c++)this.addKeyMapping(b[c], a.name, !!a.allowCollision);
        }
        unregister(a) {
            if (!this.shortcuts.get(a)) return console.warn(`Keyboard shortcut named "${a}" not found.`), !1;
            this.removeAllKeyMappings(a);
            this.shortcuts.delete(a);
            return !0;
        }
        addKeyMapping(a, b, c) {
            a = `${a}`;
            const d = this.keyMap.get(a);
            if (d && !c) throw Error(`Shortcut named "${b}" collides with shortcuts "${d}"`);
            d && c ? d.unshift(b) : this.keyMap.set(a, [
                b
            ]);
        }
        removeKeyMapping(a, b, c) {
            const d = this.keyMap.get(a);
            if (!d) return c || console.warn(`No keyboard shortcut named "${b}" registered with key code "${a}"`), !1;
            const e = d.indexOf(b);
            if (-1 < e) return d.splice(e, 1), 0 === d.length && this.keyMap.delete(a), !0;
            c || console.warn(`No keyboard shortcut named "${b}" registered with key code "${a}"`);
            return !1;
        }
        removeAllKeyMappings(a) {
            for (const b of this.keyMap.keys())this.removeKeyMapping(b, a, !0);
        }
        setKeyMap(a) {
            this.keyMap.clear();
            for(const b in a)this.keyMap.set(b, a[b]);
        }
        getKeyMap() {
            const a = Object.create(null);
            for (const [b, c] of this.keyMap)a[b] = c;
            return a;
        }
        getRegistry() {
            const a = Object.create(null);
            for (const [b, c] of this.shortcuts)a[b] = c;
            return deepMerge$$module$build$src$core$utils$object(Object.create(null), a);
        }
        onKeyDown(a, b) {
            var c = this.serializeKeyEvent_(b);
            c = this.getShortcutNamesByKeyCode(c);
            if (!c) return !1;
            for(let d = 0, e; e = c[d]; d++){
                const f = this.shortcuts.get(e);
                let g, h;
                if (null == (g = f) || !g.preconditionFn || (null == (h = f) ? 0 : h.preconditionFn(a))) {
                    let k, l;
                    if ((null == (k = f) ? 0 : k.callback) && (null == (l = f) ? 0 : l.callback(a, b, f))) return !0;
                }
            }
            return !1;
        }
        getShortcutNamesByKeyCode(a) {
            return this.keyMap.get(a) || [];
        }
        getKeyCodesByShortcutName(a) {
            const b = [];
            for (const [c, d] of this.keyMap)-1 < d.indexOf(a) && b.push(c);
            return b;
        }
        serializeKeyEvent_(a) {
            let b = "";
            for(const c in ShortcutRegistry$$module$build$src$core$shortcut_registry.modifierKeys)a.getModifierState(c) && ("" !== b && (b += "+"), b += c);
            "" !== b && a.keyCode ? b = b + "+" + a.keyCode : a.keyCode && (b = String(a.keyCode));
            return b;
        }
        checkModifiers_(a) {
            for(let b = 0, c; c = a[b]; b++)if (!(c in ShortcutRegistry$$module$build$src$core$shortcut_registry.modifierKeys)) throw Error(c + " is not a valid modifier key.");
        }
        createSerializedKey(a, b) {
            let c = "";
            if (b) {
                this.checkModifiers_(b);
                for(const d in ShortcutRegistry$$module$build$src$core$shortcut_registry.modifierKeys)-1 < b.indexOf(ShortcutRegistry$$module$build$src$core$shortcut_registry.modifierKeys[d]) && ("" !== c && (c += "+"), c += d);
            }
            "" !== c && a ? c = c + "+" + a : a && (c = `${a}`);
            return c;
        }
    };
    ShortcutRegistry$$module$build$src$core$shortcut_registry.registry = new ShortcutRegistry$$module$build$src$core$shortcut_registry;
    (function(a) {
        a = a.modifierKeys || (a.modifierKeys = {});
        a[a.Shift = 16] = "Shift";
        a[a.Control = 17] = "Control";
        a[a.Alt = 18] = "Alt";
        a[a.Meta = 91] = "Meta";
    })(ShortcutRegistry$$module$build$src$core$shortcut_registry || (ShortcutRegistry$$module$build$src$core$shortcut_registry = {}));
    var module$build$src$core$shortcut_registry = {};
    module$build$src$core$shortcut_registry.ShortcutRegistry = ShortcutRegistry$$module$build$src$core$shortcut_registry;
    var WorkspaceDragSurfaceSvg$$module$build$src$core$workspace_drag_surface_svg = class {
        constructor(a){
            this.container = a;
            this.previousSibling = null;
            this.createDom();
        }
        createDom() {
            this.SVG || (this.SVG = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.SVG, {
                xmlns: SVG_NS$$module$build$src$core$utils$dom,
                "xmlns:html": HTML_NS$$module$build$src$core$utils$dom,
                "xmlns:xlink": XLINK_NS$$module$build$src$core$utils$dom,
                version: "1.1",
                "class": "blocklyWsDragSurface blocklyOverflowVisible"
            }), this.container.appendChild(this.SVG));
        }
        translateSurface(a, b) {
            a = Math.round(a);
            b = Math.round(b);
            this.SVG.style.display = "block";
            setCssTransform$$module$build$src$core$utils$dom(this.SVG, "translate3d(" + a + "px, " + b + "px, 0)");
        }
        getSurfaceTranslation() {
            return getRelativeXY$$module$build$src$core$utils$svg_math(this.SVG);
        }
        clearAndHide(a) {
            if (!a) throw Error("Couldn't clear and hide the drag surface: missing new surface.");
            const b = this.SVG.childNodes[0], c = this.SVG.childNodes[1];
            if (!b || !c || !b.classList.contains("blocklyBlockCanvas") && c.classList.contains("blocklyBubbleCanvas")) throw Error("Couldn't clear and hide the drag surface. A node was missing.");
            null !== this.previousSibling ? insertAfter$$module$build$src$core$utils$dom(b, this.previousSibling) : a.insertBefore(b, a.firstChild);
            insertAfter$$module$build$src$core$utils$dom(c, b);
            this.SVG.style.display = "none";
            if (this.SVG.childNodes.length) throw Error("Drag surface was not cleared.");
            setCssTransform$$module$build$src$core$utils$dom(this.SVG, "");
            this.previousSibling = null;
        }
        setContentsAndShow(a, b, c, d, e, f) {
            if (this.SVG.childNodes.length) throw Error("Already dragging a block.");
            this.previousSibling = c;
            a.setAttribute("transform", "translate(0, 0) scale(" + f + ")");
            b.setAttribute("transform", "translate(0, 0) scale(" + f + ")");
            this.SVG.setAttribute("width", String(d));
            this.SVG.setAttribute("height", String(e));
            this.SVG.appendChild(a);
            this.SVG.appendChild(b);
            this.SVG.style.display = "block";
        }
    }, module$build$src$core$workspace_drag_surface_svg = {};
    module$build$src$core$workspace_drag_surface_svg.WorkspaceDragSurfaceSvg = WorkspaceDragSurfaceSvg$$module$build$src$core$workspace_drag_surface_svg;
    var documentEventsBound$$module$build$src$core$inject = !1, module$build$src$core$inject = {};
    module$build$src$core$inject.inject = inject$$module$build$src$core$inject;
    var ConstantProvider$$module$build$src$core$renderers$geras$constants = class extends ConstantProvider$$module$build$src$core$renderers$common$constants {
        constructor(){
            super();
            this.FIELD_TEXT_BASELINE_CENTER = !1;
            this.DARK_PATH_OFFSET = 1;
            this.MAX_BOTTOM_WIDTH = 30;
            this.STATEMENT_BOTTOM_SPACER = -this.NOTCH_HEIGHT / 2;
        }
        getCSS_(a) {
            return super.getCSS_(a).concat([
                `${a} .blocklyInsertionMarker>.blocklyPathLight,`,
                `${a} .blocklyInsertionMarker>.blocklyPathDark {`,
                `fill-opacity: ${this.INSERTION_MARKER_OPACITY};`,
                "stroke: none;",
                "}"
            ]);
        }
    }, module$build$src$core$renderers$geras$constants = {};
    module$build$src$core$renderers$geras$constants.ConstantProvider = ConstantProvider$$module$build$src$core$renderers$geras$constants;
    var Highlighter$$module$build$src$core$renderers$geras$highlighter = class {
        constructor(a){
            this.inlineSteps_ = this.steps_ = "";
            this.info_ = a;
            this.RTL_ = this.info_.RTL;
            a = a.getRenderer();
            this.constants_ = a.getConstants();
            this.highlightConstants_ = a.getHighlightConstants();
            this.highlightOffset_ = this.highlightConstants_.OFFSET;
            this.outsideCornerPaths_ = this.highlightConstants_.OUTSIDE_CORNER;
            this.insideCornerPaths_ = this.highlightConstants_.INSIDE_CORNER;
            this.puzzleTabPaths_ = this.highlightConstants_.PUZZLE_TAB;
            this.notchPaths_ = this.highlightConstants_.NOTCH;
            this.startPaths_ = this.highlightConstants_.START_HAT;
            this.jaggedTeethPaths_ = this.highlightConstants_.JAGGED_TEETH;
        }
        getPath() {
            return this.steps_ + "\n" + this.inlineSteps_;
        }
        drawTopCorner(a) {
            this.steps_ += moveBy$$module$build$src$core$utils$svg_paths(a.xPos, this.info_.startY);
            for(let b = 0, c; c = a.elements[b]; b++)Types$$module$build$src$core$renderers$measurables$types.isLeftSquareCorner(c) ? this.steps_ += this.highlightConstants_.START_POINT : Types$$module$build$src$core$renderers$measurables$types.isLeftRoundedCorner(c) ? this.steps_ += this.outsideCornerPaths_.topLeft(this.RTL_) : Types$$module$build$src$core$renderers$measurables$types.isPreviousConnection(c) ? this.steps_ += this.notchPaths_.pathLeft : Types$$module$build$src$core$renderers$measurables$types.isHat(c) ? this.steps_ += this.startPaths_.path(this.RTL_) : Types$$module$build$src$core$renderers$measurables$types.isSpacer(c) && 0 !== c.width && (this.steps_ += lineOnAxis$$module$build$src$core$utils$svg_paths("H", c.xPos + c.width - this.highlightOffset_));
            this.steps_ += lineOnAxis$$module$build$src$core$utils$svg_paths("H", a.xPos + a.width - this.highlightOffset_);
        }
        drawJaggedEdge_(a) {
            this.info_.RTL && (this.steps_ += this.jaggedTeethPaths_.pathLeft + lineOnAxis$$module$build$src$core$utils$svg_paths("v", a.height - this.jaggedTeethPaths_.height - this.highlightOffset_));
        }
        drawValueInput(a) {
            const b = a.getLastInput();
            if (this.RTL_) {
                const c = a.height - b.connectionHeight;
                this.steps_ += moveTo$$module$build$src$core$utils$svg_paths(b.xPos + b.width - this.highlightOffset_, a.yPos) + this.puzzleTabPaths_.pathDown(this.RTL_) + lineOnAxis$$module$build$src$core$utils$svg_paths("v", c);
            } else this.steps_ += moveTo$$module$build$src$core$utils$svg_paths(b.xPos + b.width, a.yPos) + this.puzzleTabPaths_.pathDown(this.RTL_);
        }
        drawStatementInput(a) {
            const b = a.getLastInput();
            if (b) {
                if (this.RTL_) {
                    const c = a.height - 2 * this.insideCornerPaths_.height;
                    this.steps_ += moveTo$$module$build$src$core$utils$svg_paths(b.xPos, a.yPos) + this.insideCornerPaths_.pathTop(this.RTL_) + lineOnAxis$$module$build$src$core$utils$svg_paths("v", c) + this.insideCornerPaths_.pathBottom(this.RTL_) + lineTo$$module$build$src$core$utils$svg_paths(a.width - b.xPos - this.insideCornerPaths_.width, 0);
                } else this.steps_ += moveTo$$module$build$src$core$utils$svg_paths(b.xPos, a.yPos + a.height) + this.insideCornerPaths_.pathBottom(this.RTL_) + lineTo$$module$build$src$core$utils$svg_paths(a.width - b.xPos - this.insideCornerPaths_.width, 0);
            }
        }
        drawRightSideRow(a) {
            const b = a.xPos + a.width - this.highlightOffset_;
            a instanceof SpacerRow$$module$build$src$core$renderers$measurables$spacer_row && a.followsStatement && (this.steps_ += lineOnAxis$$module$build$src$core$utils$svg_paths("H", b));
            this.RTL_ && (this.steps_ += lineOnAxis$$module$build$src$core$utils$svg_paths("H", b), a.height > this.highlightOffset_ && (this.steps_ += lineOnAxis$$module$build$src$core$utils$svg_paths("V", a.yPos + a.height - this.highlightOffset_)));
        }
        drawBottomRow(a) {
            if (this.RTL_) this.steps_ += lineOnAxis$$module$build$src$core$utils$svg_paths("V", a.baseline - this.highlightOffset_);
            else {
                const b = this.info_.bottomRow.elements[0];
                Types$$module$build$src$core$renderers$measurables$types.isLeftSquareCorner(b) ? this.steps_ += moveTo$$module$build$src$core$utils$svg_paths(a.xPos + this.highlightOffset_, a.baseline - this.highlightOffset_) : Types$$module$build$src$core$renderers$measurables$types.isLeftRoundedCorner(b) && (this.steps_ += moveTo$$module$build$src$core$utils$svg_paths(a.xPos, a.baseline), this.steps_ += this.outsideCornerPaths_.bottomLeft());
            }
        }
        drawLeft() {
            var a = this.info_.outputConnection;
            a && (a = a.connectionOffsetY + a.height, this.RTL_ ? this.steps_ += moveTo$$module$build$src$core$utils$svg_paths(this.info_.startX, a) : (this.steps_ += moveTo$$module$build$src$core$utils$svg_paths(this.info_.startX + this.highlightOffset_, this.info_.bottomRow.baseline - this.highlightOffset_), this.steps_ += lineOnAxis$$module$build$src$core$utils$svg_paths("V", a)), this.steps_ += this.puzzleTabPaths_.pathUp(this.RTL_));
            this.RTL_ || (a = this.info_.topRow, Types$$module$build$src$core$renderers$measurables$types.isLeftRoundedCorner(a.elements[0]) ? this.steps_ += lineOnAxis$$module$build$src$core$utils$svg_paths("V", this.outsideCornerPaths_.height) : this.steps_ += lineOnAxis$$module$build$src$core$utils$svg_paths("V", a.capline + this.highlightOffset_));
        }
        drawInlineInput(a) {
            const b = this.highlightOffset_, c = a.xPos + a.connectionWidth;
            var d = a.centerline - a.height / 2;
            const e = a.width - a.connectionWidth, f = d + b;
            this.RTL_ ? (d = a.connectionOffsetY - b, a = a.height - (a.connectionOffsetY + a.connectionHeight) + b, this.inlineSteps_ += moveTo$$module$build$src$core$utils$svg_paths(c - b, f) + lineOnAxis$$module$build$src$core$utils$svg_paths("v", d) + this.puzzleTabPaths_.pathDown(this.RTL_) + lineOnAxis$$module$build$src$core$utils$svg_paths("v", a) + lineOnAxis$$module$build$src$core$utils$svg_paths("h", e)) : this.inlineSteps_ += moveTo$$module$build$src$core$utils$svg_paths(a.xPos + a.width + b, f) + lineOnAxis$$module$build$src$core$utils$svg_paths("v", a.height) + lineOnAxis$$module$build$src$core$utils$svg_paths("h", -e) + moveTo$$module$build$src$core$utils$svg_paths(c, d + a.connectionOffsetY) + this.puzzleTabPaths_.pathDown(this.RTL_);
        }
    }, module$build$src$core$renderers$geras$highlighter = {};
    module$build$src$core$renderers$geras$highlighter.Highlighter = Highlighter$$module$build$src$core$renderers$geras$highlighter;
    var Drawer$$module$build$src$core$renderers$geras$drawer = class extends Drawer$$module$build$src$core$renderers$common$drawer {
        constructor(a, b){
            super(a, b);
            this.highlighter_ = new Highlighter$$module$build$src$core$renderers$geras$highlighter(b);
        }
        draw() {
            this.hideHiddenIcons_();
            this.drawOutline_();
            this.drawInternals_();
            const a = this.block_.pathObject;
            a.setPath(this.outlinePath_ + "\n" + this.inlinePath_);
            a.setHighlightPath(this.highlighter_.getPath());
            this.info_.RTL && a.flipRTL();
            if (isDebuggerEnabled$$module$build$src$core$renderers$common$debug()) {
                let b, c;
                null == (b = this.block_) || null == (c = b.renderingDebugger) || c.drawDebug(this.block_, this.info_);
            }
            this.recordSizeOnBlock_();
        }
        drawTop_() {
            this.highlighter_.drawTopCorner(this.info_.topRow);
            this.highlighter_.drawRightSideRow(this.info_.topRow);
            super.drawTop_();
        }
        drawJaggedEdge_(a) {
            this.highlighter_.drawJaggedEdge_(a);
            super.drawJaggedEdge_(a);
        }
        drawValueInput_(a) {
            this.highlighter_.drawValueInput(a);
            super.drawValueInput_(a);
        }
        drawStatementInput_(a) {
            this.highlighter_.drawStatementInput(a);
            super.drawStatementInput_(a);
        }
        drawRightSideRow_(a) {
            this.highlighter_.drawRightSideRow(a);
            this.outlinePath_ += lineOnAxis$$module$build$src$core$utils$svg_paths("H", a.xPos + a.width) + lineOnAxis$$module$build$src$core$utils$svg_paths("V", a.yPos + a.height);
        }
        drawBottom_() {
            this.highlighter_.drawBottomRow(this.info_.bottomRow);
            super.drawBottom_();
        }
        drawLeft_() {
            this.highlighter_.drawLeft();
            super.drawLeft_();
        }
        drawInlineInput_(a) {
            this.highlighter_.drawInlineInput(a);
            super.drawInlineInput_(a);
        }
        positionInlineInputConnection_(a) {
            const b = a.centerline - a.height / 2;
            if (a.connectionModel) {
                let c = a.xPos + a.connectionWidth + this.constants_.DARK_PATH_OFFSET;
                this.info_.RTL && (c *= -1);
                a.connectionModel.setOffsetInBlock(c, b + a.connectionOffsetY + this.constants_.DARK_PATH_OFFSET);
            }
        }
        positionStatementInputConnection_(a) {
            const b = a.getLastInput();
            if (null == b ? 0 : b.connectionModel) {
                let c = a.xPos + a.statementEdge + b.notchOffset;
                c = this.info_.RTL ? -1 * c : c + this.constants_.DARK_PATH_OFFSET;
                b.connectionModel.setOffsetInBlock(c, a.yPos + this.constants_.DARK_PATH_OFFSET);
            }
        }
        positionExternalValueConnection_(a) {
            const b = a.getLastInput();
            if (b && b.connectionModel) {
                let c = a.xPos + a.width + this.constants_.DARK_PATH_OFFSET;
                this.info_.RTL && (c *= -1);
                b.connectionModel.setOffsetInBlock(c, a.yPos);
            }
        }
        positionNextConnection_() {
            const a = this.info_.bottomRow;
            if (a.connection) {
                const b = a.connection, c = b.xPos;
                b.connectionModel.setOffsetInBlock((this.info_.RTL ? -c : c) + this.constants_.DARK_PATH_OFFSET / 2, a.baseline + this.constants_.DARK_PATH_OFFSET);
            }
        }
    }, module$build$src$core$renderers$geras$drawer = {};
    module$build$src$core$renderers$geras$drawer.Drawer = Drawer$$module$build$src$core$renderers$geras$drawer;
    var HighlightConstantProvider$$module$build$src$core$renderers$geras$highlight_constants = class {
        constructor(a){
            this.OFFSET = .5;
            this.constantProvider = a;
            this.START_POINT = moveBy$$module$build$src$core$utils$svg_paths(this.OFFSET, this.OFFSET);
        }
        init() {
            this.INSIDE_CORNER = this.makeInsideCorner();
            this.OUTSIDE_CORNER = this.makeOutsideCorner();
            this.PUZZLE_TAB = this.makePuzzleTab();
            this.NOTCH = this.makeNotch();
            this.JAGGED_TEETH = this.makeJaggedTeeth();
            this.START_HAT = this.makeStartHat();
        }
        makeInsideCorner() {
            const a = this.constantProvider.CORNER_RADIUS, b = this.OFFSET, c = (1 - Math.SQRT1_2) * (a + b) - b, d = moveBy$$module$build$src$core$utils$svg_paths(c, c) + arc$$module$build$src$core$utils$svg_paths("a", "0 0,0", a, point$$module$build$src$core$utils$svg_paths(-c - b, a - c)), e = arc$$module$build$src$core$utils$svg_paths("a", "0 0,0", a + b, point$$module$build$src$core$utils$svg_paths(a + b, a + b)), f = moveBy$$module$build$src$core$utils$svg_paths(c, -c) + arc$$module$build$src$core$utils$svg_paths("a", "0 0,0", a + b, point$$module$build$src$core$utils$svg_paths(a - c, c + b));
            return {
                width: a + b,
                height: a,
                pathTop (g) {
                    return g ? d : "";
                },
                pathBottom (g) {
                    return g ? e : f;
                }
            };
        }
        makeOutsideCorner() {
            const a = this.constantProvider.CORNER_RADIUS, b = this.OFFSET, c = (1 - Math.SQRT1_2) * (a - b) + b, d = moveBy$$module$build$src$core$utils$svg_paths(c, c) + arc$$module$build$src$core$utils$svg_paths("a", "0 0,1", a - b, point$$module$build$src$core$utils$svg_paths(a - c, -c + b)), e = moveBy$$module$build$src$core$utils$svg_paths(b, a) + arc$$module$build$src$core$utils$svg_paths("a", "0 0,1", a - b, point$$module$build$src$core$utils$svg_paths(a, -a + b)), f = -c, g = moveBy$$module$build$src$core$utils$svg_paths(c, f) + arc$$module$build$src$core$utils$svg_paths("a", "0 0,1", a - b, point$$module$build$src$core$utils$svg_paths(-c + b, -f - a));
            return {
                height: a,
                topLeft (h) {
                    return h ? d : e;
                },
                bottomLeft () {
                    return g;
                }
            };
        }
        makePuzzleTab() {
            const a = this.constantProvider.TAB_WIDTH, b = this.constantProvider.TAB_HEIGHT, c = moveBy$$module$build$src$core$utils$svg_paths(-2, -b + 3.4) + lineTo$$module$build$src$core$utils$svg_paths(-0.45 * a, -2.1), d = lineOnAxis$$module$build$src$core$utils$svg_paths("v", 2.5) + moveBy$$module$build$src$core$utils$svg_paths(.97 * -a, 2.5) + curve$$module$build$src$core$utils$svg_paths("q", [
                point$$module$build$src$core$utils$svg_paths(.05 * -a, 10),
                point$$module$build$src$core$utils$svg_paths(.3 * a, 9.5)
            ]) + moveBy$$module$build$src$core$utils$svg_paths(.67 * a, -1.9) + lineOnAxis$$module$build$src$core$utils$svg_paths("v", 2.5), e = lineOnAxis$$module$build$src$core$utils$svg_paths("v", -1.5) + moveBy$$module$build$src$core$utils$svg_paths(-0.92 * a, -0.5) + curve$$module$build$src$core$utils$svg_paths("q", [
                point$$module$build$src$core$utils$svg_paths(-0.19 * a, -5.5),
                point$$module$build$src$core$utils$svg_paths(0, -11)
            ]) + moveBy$$module$build$src$core$utils$svg_paths(.92 * a, 1), f = moveBy$$module$build$src$core$utils$svg_paths(-5, b - .7) + lineTo$$module$build$src$core$utils$svg_paths(.46 * a, -2.1);
            return {
                width: a,
                height: b,
                pathUp (g) {
                    return g ? c : e;
                },
                pathDown (g) {
                    return g ? d : f;
                }
            };
        }
        makeNotch() {
            return {
                pathLeft: lineOnAxis$$module$build$src$core$utils$svg_paths("h", this.OFFSET) + this.constantProvider.NOTCH.pathLeft
            };
        }
        makeJaggedTeeth() {
            return {
                pathLeft: lineTo$$module$build$src$core$utils$svg_paths(5.1, 2.6) + moveBy$$module$build$src$core$utils$svg_paths(-10.2, 6.8) + lineTo$$module$build$src$core$utils$svg_paths(5.1, 2.6),
                height: 12,
                width: 10.2
            };
        }
        makeStartHat() {
            const a = this.constantProvider.START_HAT.height, b = moveBy$$module$build$src$core$utils$svg_paths(25, -8.7) + curve$$module$build$src$core$utils$svg_paths("c", [
                point$$module$build$src$core$utils$svg_paths(29.7, -6.2),
                point$$module$build$src$core$utils$svg_paths(57.2, -0.5),
                point$$module$build$src$core$utils$svg_paths(75, 8.7)
            ]), c = curve$$module$build$src$core$utils$svg_paths("c", [
                point$$module$build$src$core$utils$svg_paths(17.8, -9.2),
                point$$module$build$src$core$utils$svg_paths(45.3, -14.9),
                point$$module$build$src$core$utils$svg_paths(75, -8.7)
            ]) + moveTo$$module$build$src$core$utils$svg_paths(100.5, a + .5);
            return {
                path (d) {
                    return d ? b : c;
                }
            };
        }
    }, module$build$src$core$renderers$geras$highlight_constants = {};
    module$build$src$core$renderers$geras$highlight_constants.HighlightConstantProvider = HighlightConstantProvider$$module$build$src$core$renderers$geras$highlight_constants;
    var InlineInput$$module$build$src$core$renderers$geras$measurables$inline_input = class extends InlineInput$$module$build$src$core$renderers$measurables$inline_input {
        constructor(a, b){
            super(a, b);
            this.constants_ = a;
            this.connectedBlock && (this.width += this.constants_.DARK_PATH_OFFSET, this.height += this.constants_.DARK_PATH_OFFSET);
        }
    }, module$build$src$core$renderers$geras$measurables$inline_input = {};
    module$build$src$core$renderers$geras$measurables$inline_input.InlineInput = InlineInput$$module$build$src$core$renderers$geras$measurables$inline_input;
    var StatementInput$$module$build$src$core$renderers$geras$measurables$statement_input = class extends StatementInput$$module$build$src$core$renderers$measurables$statement_input {
        constructor(a, b){
            super(a, b);
            this.constants_ = a;
            this.connectedBlock && (this.height += this.constants_.DARK_PATH_OFFSET);
        }
    }, module$build$src$core$renderers$geras$measurables$statement_input = {};
    module$build$src$core$renderers$geras$measurables$statement_input.StatementInput = StatementInput$$module$build$src$core$renderers$geras$measurables$statement_input;
    var RenderInfo$$module$build$src$core$renderers$geras$info = class extends RenderInfo$$module$build$src$core$renderers$common$info {
        constructor(a, b){
            super(a, b);
            this.renderer_ = a;
        }
        getRenderer() {
            return this.renderer_;
        }
        populateBottomRow_() {
            super.populateBottomRow_();
            this.block_.inputList.length && this.block_.inputList[this.block_.inputList.length - 1].type === inputTypes$$module$build$src$core$input_types.STATEMENT || (this.bottomRow.minHeight = this.constants_.MEDIUM_PADDING - this.constants_.DARK_PATH_OFFSET);
        }
        addInput_(a, b) {
            this.isInline && a.type === inputTypes$$module$build$src$core$input_types.VALUE ? (b.elements.push(new InlineInput$$module$build$src$core$renderers$geras$measurables$inline_input(this.constants_, a)), b.hasInlineInput = !0) : a.type === inputTypes$$module$build$src$core$input_types.STATEMENT ? (b.elements.push(new StatementInput$$module$build$src$core$renderers$geras$measurables$statement_input(this.constants_, a)), b.hasStatement = !0) : a.type === inputTypes$$module$build$src$core$input_types.VALUE ? (b.elements.push(new ExternalValueInput$$module$build$src$core$renderers$measurables$external_value_input(this.constants_, a)), b.hasExternalInput = !0) : a.type === inputTypes$$module$build$src$core$input_types.DUMMY && (b.minHeight = Math.max(b.minHeight, this.constants_.DUMMY_INPUT_MIN_HEIGHT), b.hasDummyInput = !0);
            this.isInline || null !== b.align || (b.align = a.align);
        }
        addElemSpacing_() {
            let a = !1;
            for(let c = 0, d; d = this.rows[c]; c++)d.hasExternalInput && (a = !0);
            for(let c = 0, d; d = this.rows[c]; c++){
                var b = d.elements;
                d.elements = [];
                d.startsWithElemSpacer() && d.elements.push(new InRowSpacer$$module$build$src$core$renderers$measurables$in_row_spacer(this.constants_, this.getInRowSpacing_(null, b[0])));
                if (b.length) {
                    for(let e = 0; e < b.length - 1; e++){
                        d.elements.push(b[e]);
                        const f = this.getInRowSpacing_(b[e], b[e + 1]);
                        d.elements.push(new InRowSpacer$$module$build$src$core$renderers$measurables$in_row_spacer(this.constants_, f));
                    }
                    d.elements.push(b[b.length - 1]);
                    d.endsWithElemSpacer() && (b = this.getInRowSpacing_(b[b.length - 1], null), a && d.hasDummyInput && (b += this.constants_.TAB_WIDTH), d.elements.push(new InRowSpacer$$module$build$src$core$renderers$measurables$in_row_spacer(this.constants_, b)));
                }
            }
        }
        getInRowSpacing_(a, b) {
            if (!a) return b && Types$$module$build$src$core$renderers$measurables$types.isField(b) && b.isEditable ? this.constants_.MEDIUM_PADDING : b && Types$$module$build$src$core$renderers$measurables$types.isInlineInput(b) ? this.constants_.MEDIUM_LARGE_PADDING : b && Types$$module$build$src$core$renderers$measurables$types.isStatementInput(b) ? this.constants_.STATEMENT_INPUT_PADDING_LEFT : this.constants_.LARGE_PADDING;
            if (!Types$$module$build$src$core$renderers$measurables$types.isInput(a) && (!b || Types$$module$build$src$core$renderers$measurables$types.isStatementInput(b))) return Types$$module$build$src$core$renderers$measurables$types.isField(a) && a.isEditable ? this.constants_.MEDIUM_PADDING : Types$$module$build$src$core$renderers$measurables$types.isIcon(a) ? 2 * this.constants_.LARGE_PADDING + 1 : Types$$module$build$src$core$renderers$measurables$types.isHat(a) ? this.constants_.NO_PADDING : Types$$module$build$src$core$renderers$measurables$types.isPreviousOrNextConnection(a) ? this.constants_.LARGE_PADDING : Types$$module$build$src$core$renderers$measurables$types.isLeftRoundedCorner(a) ? this.constants_.MIN_BLOCK_WIDTH : Types$$module$build$src$core$renderers$measurables$types.isJaggedEdge(a) ? this.constants_.NO_PADDING : this.constants_.LARGE_PADDING;
            if (Types$$module$build$src$core$renderers$measurables$types.isInput(a) && !b) {
                if (Types$$module$build$src$core$renderers$measurables$types.isExternalInput(a)) return this.constants_.NO_PADDING;
                if (Types$$module$build$src$core$renderers$measurables$types.isInlineInput(a)) return this.constants_.LARGE_PADDING;
                if (Types$$module$build$src$core$renderers$measurables$types.isStatementInput(a)) return this.constants_.NO_PADDING;
            }
            if (!Types$$module$build$src$core$renderers$measurables$types.isInput(a) && b && Types$$module$build$src$core$renderers$measurables$types.isInput(b)) {
                if (Types$$module$build$src$core$renderers$measurables$types.isField(a) && a.isEditable) {
                    if (Types$$module$build$src$core$renderers$measurables$types.isInlineInput(b) || Types$$module$build$src$core$renderers$measurables$types.isExternalInput(b)) return this.constants_.SMALL_PADDING;
                } else {
                    if (Types$$module$build$src$core$renderers$measurables$types.isInlineInput(b) || Types$$module$build$src$core$renderers$measurables$types.isExternalInput(b)) return this.constants_.MEDIUM_LARGE_PADDING;
                    if (Types$$module$build$src$core$renderers$measurables$types.isStatementInput(b)) return this.constants_.LARGE_PADDING;
                }
                return this.constants_.LARGE_PADDING - 1;
            }
            if (Types$$module$build$src$core$renderers$measurables$types.isIcon(a) && b && !Types$$module$build$src$core$renderers$measurables$types.isInput(b)) return this.constants_.LARGE_PADDING;
            if (Types$$module$build$src$core$renderers$measurables$types.isInlineInput(a) && b && Types$$module$build$src$core$renderers$measurables$types.isField(b)) return b.isEditable ? this.constants_.MEDIUM_PADDING : this.constants_.LARGE_PADDING;
            if (Types$$module$build$src$core$renderers$measurables$types.isLeftSquareCorner(a) && b) {
                if (Types$$module$build$src$core$renderers$measurables$types.isHat(b)) return this.constants_.NO_PADDING;
                if (Types$$module$build$src$core$renderers$measurables$types.isPreviousConnection(b)) return b.notchOffset;
                if (Types$$module$build$src$core$renderers$measurables$types.isNextConnection(b)) return b.notchOffset + (this.RTL ? 1 : -1) * this.constants_.DARK_PATH_OFFSET / 2;
            }
            if (Types$$module$build$src$core$renderers$measurables$types.isLeftRoundedCorner(a) && b) {
                if (Types$$module$build$src$core$renderers$measurables$types.isPreviousConnection(b)) return b.notchOffset - this.constants_.CORNER_RADIUS;
                if (Types$$module$build$src$core$renderers$measurables$types.isNextConnection(b)) return b.notchOffset - this.constants_.CORNER_RADIUS + (this.RTL ? 1 : -1) * this.constants_.DARK_PATH_OFFSET / 2;
            }
            return Types$$module$build$src$core$renderers$measurables$types.isField(a) && b && Types$$module$build$src$core$renderers$measurables$types.isField(b) && a.isEditable === b.isEditable || b && Types$$module$build$src$core$renderers$measurables$types.isJaggedEdge(b) ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
        }
        getSpacerRowHeight_(a, b) {
            return Types$$module$build$src$core$renderers$measurables$types.isTopRow(a) && Types$$module$build$src$core$renderers$measurables$types.isBottomRow(b) ? this.constants_.EMPTY_BLOCK_SPACER_HEIGHT : Types$$module$build$src$core$renderers$measurables$types.isTopRow(a) || Types$$module$build$src$core$renderers$measurables$types.isBottomRow(b) ? this.constants_.NO_PADDING : a.hasExternalInput && b.hasExternalInput ? this.constants_.LARGE_PADDING : !a.hasStatement && b.hasStatement ? this.constants_.BETWEEN_STATEMENT_PADDING_Y : a.hasStatement && b.hasStatement || !a.hasStatement && b.hasDummyInput || a.hasDummyInput ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
        }
        getElemCenterline_(a, b) {
            if (Types$$module$build$src$core$renderers$measurables$types.isSpacer(b)) return a.yPos + b.height / 2;
            if (Types$$module$build$src$core$renderers$measurables$types.isBottomRow(a)) return a = a.yPos + a.height - a.descenderHeight, Types$$module$build$src$core$renderers$measurables$types.isNextConnection(b) ? a + b.height / 2 : a - b.height / 2;
            if (Types$$module$build$src$core$renderers$measurables$types.isTopRow(a)) return Types$$module$build$src$core$renderers$measurables$types.isHat(b) ? a.capline - b.height / 2 : a.capline + b.height / 2;
            let c = a.yPos;
            Types$$module$build$src$core$renderers$measurables$types.isField(b) || Types$$module$build$src$core$renderers$measurables$types.isIcon(b) ? (c += b.height / 2, (a.hasInlineInput || a.hasStatement) && b.height + this.constants_.TALL_INPUT_FIELD_OFFSET_Y <= a.height && (c += this.constants_.TALL_INPUT_FIELD_OFFSET_Y)) : c = Types$$module$build$src$core$renderers$measurables$types.isInlineInput(b) ? c + b.height / 2 : c + a.height / 2;
            return c;
        }
        alignRowElements_() {
            if (this.isInline) {
                var a = 0, b = new WeakMap, c = null;
                for(let d = this.rows.length - 1, e; e = this.rows[d]; d--)b.set(e, a), Types$$module$build$src$core$renderers$measurables$types.isInputRow(e) && (e.hasStatement && this.alignStatementRow_(e), c && c.hasStatement && e.width < c.width ? b.set(e, c.width) : a = e.width, c = e);
                a = 0;
                for(let d = 0, e; e = this.rows[d]; d++)e.hasStatement ? a = this.getDesiredRowWidth_(e) : Types$$module$build$src$core$renderers$measurables$types.isSpacer(e) ? e.width = Math.max(a, b.get(e)) : (c = e.width, a = Math.max(a, b.get(e)) - c, 0 < a && this.addAlignmentPadding_(e, a), a = e.width);
            } else super.alignRowElements_();
        }
        getDesiredRowWidth_(a) {
            return this.isInline && a.hasStatement ? this.statementEdge + this.constants_.MAX_BOTTOM_WIDTH + this.startX : super.getDesiredRowWidth_(a);
        }
        finalize_() {
            let a = 0, b = 0;
            for(let d = 0, e; e = this.rows[d]; d++){
                e.yPos = b;
                e.xPos = this.startX;
                b += e.height;
                a = Math.max(a, e.widthWithConnectedBlocks);
                var c = b - this.topRow.ascenderHeight;
                e === this.bottomRow && c < this.constants_.MIN_BLOCK_HEIGHT && (c = this.constants_.MIN_BLOCK_HEIGHT - c, this.bottomRow.height += c, b += c);
                this.recordElemPositions_(e);
            }
            this.outputConnection && this.block_.nextConnection && this.block_.nextConnection.isConnected() && (c = this.block_.nextConnection.targetBlock()) && (a = Math.max(a, c.getHeightWidth().width - this.constants_.DARK_PATH_OFFSET));
            this.bottomRow.baseline = b - this.bottomRow.descenderHeight;
            this.widthWithChildren = a + this.startX + this.constants_.DARK_PATH_OFFSET;
            this.width += this.constants_.DARK_PATH_OFFSET;
            this.height = b + this.constants_.DARK_PATH_OFFSET;
            this.startY = this.topRow.capline;
        }
    }, module$build$src$core$renderers$geras$info = {};
    module$build$src$core$renderers$geras$info.RenderInfo = RenderInfo$$module$build$src$core$renderers$geras$info;
    var PathObject$$module$build$src$core$renderers$geras$path_object = class extends PathObject$$module$build$src$core$renderers$common$path_object {
        constructor(a, b, c){
            super(a, b, c);
            this.constants = c;
            this.colourDark = "#000000";
            this.svgPathDark = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATH, {
                "class": "blocklyPathDark",
                transform: "translate(1,1)"
            });
            this.svgRoot.insertBefore(this.svgPathDark, this.svgPath);
            this.svgPathLight = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATH, {
                "class": "blocklyPathLight"
            }, this.svgRoot);
        }
        setPath(a) {
            this.svgPath.setAttribute("d", a);
            this.svgPathDark.setAttribute("d", a);
        }
        setHighlightPath(a) {
            this.svgPathLight.setAttribute("d", a);
        }
        flipRTL() {
            this.svgPath.setAttribute("transform", "scale(-1 1)");
            this.svgPathLight.setAttribute("transform", "scale(-1 1)");
            this.svgPathDark.setAttribute("transform", "translate(1,1) scale(-1 1)");
        }
        applyColour(a) {
            this.svgPathLight.style.display = "";
            this.svgPathDark.style.display = "";
            if (!this.style.colourTertiary) throw Error("The renderer did not properly initialize the tertiary colour of the block style");
            this.svgPathLight.setAttribute("stroke", this.style.colourTertiary);
            this.svgPathDark.setAttribute("fill", this.colourDark);
            super.applyColour(a);
            this.svgPath.setAttribute("stroke", "none");
        }
        setStyle(a) {
            this.style = a;
            this.colourDark = blend$$module$build$src$core$utils$colour("#000", this.style.colourPrimary, .2) || this.colourDark;
        }
        updateHighlighted(a) {
            a ? (this.svgPath.setAttribute("filter", "url(#" + this.constants.embossFilterId + ")"), this.svgPathLight.style.display = "none") : (this.svgPath.setAttribute("filter", "none"), this.svgPathLight.style.display = "inline");
        }
        updateShadow_(a) {
            if (a) {
                this.svgPathLight.style.display = "none";
                if (!this.style.colourSecondary) throw Error("The renderer did not properly initialize the secondary colour of the block style block style");
                this.svgPathDark.setAttribute("fill", this.style.colourSecondary);
                this.svgPath.setAttribute("stroke", "none");
                this.svgPath.setAttribute("fill", this.style.colourSecondary);
            }
        }
        updateDisabled_(a) {
            super.updateDisabled_(a);
            a && this.svgPath.setAttribute("stroke", "none");
        }
    }, module$build$src$core$renderers$geras$path_object = {};
    module$build$src$core$renderers$geras$path_object.PathObject = PathObject$$module$build$src$core$renderers$geras$path_object;
    var Renderer$$module$build$src$core$renderers$geras$renderer = class extends Renderer$$module$build$src$core$renderers$common$renderer {
        constructor(a){
            super(a);
            this.highlightConstants_ = null;
        }
        init(a, b) {
            super.init(a, b);
            this.highlightConstants_ = this.makeHighlightConstants_();
            this.highlightConstants_.init();
        }
        refreshDom(a, b) {
            super.refreshDom(a, b);
            this.getHighlightConstants().init();
        }
        makeConstants_() {
            return new ConstantProvider$$module$build$src$core$renderers$geras$constants;
        }
        makeRenderInfo_(a) {
            return new RenderInfo$$module$build$src$core$renderers$geras$info(this, a);
        }
        makeDrawer_(a, b) {
            return new Drawer$$module$build$src$core$renderers$geras$drawer(a, b);
        }
        makePathObject(a, b) {
            return new PathObject$$module$build$src$core$renderers$geras$path_object(a, b, this.getConstants());
        }
        makeHighlightConstants_() {
            return new HighlightConstantProvider$$module$build$src$core$renderers$geras$highlight_constants(this.getConstants());
        }
        getHighlightConstants() {
            if (!this.highlightConstants_) throw Error("Cannot access the highlight constants because init has not been called");
            return this.highlightConstants_;
        }
    };
    register$$module$build$src$core$renderers$common$block_rendering("geras", Renderer$$module$build$src$core$renderers$geras$renderer);
    var module$build$src$core$renderers$geras$renderer = {};
    module$build$src$core$renderers$geras$renderer.Renderer = Renderer$$module$build$src$core$renderers$geras$renderer;
    var module$build$src$core$renderers$geras$geras = {};
    module$build$src$core$renderers$geras$geras.ConstantProvider = ConstantProvider$$module$build$src$core$renderers$geras$constants;
    module$build$src$core$renderers$geras$geras.Drawer = Drawer$$module$build$src$core$renderers$geras$drawer;
    module$build$src$core$renderers$geras$geras.HighlightConstantProvider = HighlightConstantProvider$$module$build$src$core$renderers$geras$highlight_constants;
    module$build$src$core$renderers$geras$geras.Highlighter = Highlighter$$module$build$src$core$renderers$geras$highlighter;
    module$build$src$core$renderers$geras$geras.InlineInput = InlineInput$$module$build$src$core$renderers$geras$measurables$inline_input;
    module$build$src$core$renderers$geras$geras.PathObject = PathObject$$module$build$src$core$renderers$geras$path_object;
    module$build$src$core$renderers$geras$geras.RenderInfo = RenderInfo$$module$build$src$core$renderers$geras$info;
    module$build$src$core$renderers$geras$geras.Renderer = Renderer$$module$build$src$core$renderers$geras$renderer;
    module$build$src$core$renderers$geras$geras.StatementInput = StatementInput$$module$build$src$core$renderers$geras$measurables$statement_input;
    var ConstantProvider$$module$build$src$core$renderers$minimalist$constants = class extends ConstantProvider$$module$build$src$core$renderers$common$constants {
        constructor(){
            super();
        }
    }, module$build$src$core$renderers$minimalist$constants = {};
    module$build$src$core$renderers$minimalist$constants.ConstantProvider = ConstantProvider$$module$build$src$core$renderers$minimalist$constants;
    var Drawer$$module$build$src$core$renderers$minimalist$drawer = class extends Drawer$$module$build$src$core$renderers$common$drawer {
        constructor(a, b){
            super(a, b);
        }
    }, module$build$src$core$renderers$minimalist$drawer = {};
    module$build$src$core$renderers$minimalist$drawer.Drawer = Drawer$$module$build$src$core$renderers$minimalist$drawer;
    var RenderInfo$$module$build$src$core$renderers$minimalist$info = class extends RenderInfo$$module$build$src$core$renderers$common$info {
        constructor(a, b){
            super(a, b);
        }
        getRenderer() {
            return this.renderer_;
        }
    }, module$build$src$core$renderers$minimalist$info = {};
    module$build$src$core$renderers$minimalist$info.RenderInfo = RenderInfo$$module$build$src$core$renderers$minimalist$info;
    var Renderer$$module$build$src$core$renderers$minimalist$renderer = class extends Renderer$$module$build$src$core$renderers$common$renderer {
        constructor(a){
            super(a);
        }
        makeConstants_() {
            return new ConstantProvider$$module$build$src$core$renderers$minimalist$constants;
        }
        makeRenderInfo_(a) {
            return new RenderInfo$$module$build$src$core$renderers$minimalist$info(this, a);
        }
        makeDrawer_(a, b) {
            return new Drawer$$module$build$src$core$renderers$minimalist$drawer(a, b);
        }
    };
    register$$module$build$src$core$renderers$common$block_rendering("minimalist", Renderer$$module$build$src$core$renderers$minimalist$renderer);
    var module$build$src$core$renderers$minimalist$renderer = {};
    module$build$src$core$renderers$minimalist$renderer.Renderer = Renderer$$module$build$src$core$renderers$minimalist$renderer;
    var module$build$src$core$renderers$minimalist$minimalist = {};
    module$build$src$core$renderers$minimalist$minimalist.ConstantProvider = ConstantProvider$$module$build$src$core$renderers$minimalist$constants;
    module$build$src$core$renderers$minimalist$minimalist.Drawer = Drawer$$module$build$src$core$renderers$minimalist$drawer;
    module$build$src$core$renderers$minimalist$minimalist.RenderInfo = RenderInfo$$module$build$src$core$renderers$minimalist$info;
    module$build$src$core$renderers$minimalist$minimalist.Renderer = Renderer$$module$build$src$core$renderers$minimalist$renderer;
    var RenderInfo$$module$build$src$core$renderers$thrasos$info = class extends RenderInfo$$module$build$src$core$renderers$common$info {
        constructor(a, b){
            super(a, b);
        }
        getRenderer() {
            return this.renderer_;
        }
        addElemSpacing_() {
            let a = !1;
            for(var b = 0; b < this.rows.length; b++)if (this.rows[b].hasExternalInput) {
                a = !0;
                break;
            }
            for(b = 0; b < this.rows.length; b++){
                const d = this.rows[b];
                var c = d.elements;
                d.elements = [];
                d.startsWithElemSpacer() && d.elements.push(new InRowSpacer$$module$build$src$core$renderers$measurables$in_row_spacer(this.constants_, this.getInRowSpacing_(null, c[0])));
                if (c.length) {
                    for(let e = 0; e < c.length - 1; e++){
                        d.elements.push(c[e]);
                        const f = this.getInRowSpacing_(c[e], c[e + 1]);
                        d.elements.push(new InRowSpacer$$module$build$src$core$renderers$measurables$in_row_spacer(this.constants_, f));
                    }
                    d.elements.push(c[c.length - 1]);
                    d.endsWithElemSpacer() && (c = this.getInRowSpacing_(c[c.length - 1], null), a && d.hasDummyInput && (c += this.constants_.TAB_WIDTH), d.elements.push(new InRowSpacer$$module$build$src$core$renderers$measurables$in_row_spacer(this.constants_, c)));
                }
            }
        }
        getInRowSpacing_(a, b) {
            if (!a) return b && Types$$module$build$src$core$renderers$measurables$types.isField(b) && b.isEditable ? this.constants_.MEDIUM_PADDING : b && Types$$module$build$src$core$renderers$measurables$types.isInlineInput(b) ? this.constants_.MEDIUM_LARGE_PADDING : b && Types$$module$build$src$core$renderers$measurables$types.isStatementInput(b) ? this.constants_.STATEMENT_INPUT_PADDING_LEFT : this.constants_.LARGE_PADDING;
            if (!Types$$module$build$src$core$renderers$measurables$types.isInput(a) && !b) return Types$$module$build$src$core$renderers$measurables$types.isField(a) && a.isEditable ? this.constants_.MEDIUM_PADDING : Types$$module$build$src$core$renderers$measurables$types.isIcon(a) ? 2 * this.constants_.LARGE_PADDING + 1 : Types$$module$build$src$core$renderers$measurables$types.isHat(a) ? this.constants_.NO_PADDING : Types$$module$build$src$core$renderers$measurables$types.isPreviousOrNextConnection(a) ? this.constants_.LARGE_PADDING : Types$$module$build$src$core$renderers$measurables$types.isLeftRoundedCorner(a) ? this.constants_.MIN_BLOCK_WIDTH : Types$$module$build$src$core$renderers$measurables$types.isJaggedEdge(a) ? this.constants_.NO_PADDING : this.constants_.LARGE_PADDING;
            if (Types$$module$build$src$core$renderers$measurables$types.isInput(a) && !b) {
                if (Types$$module$build$src$core$renderers$measurables$types.isExternalInput(a)) return this.constants_.NO_PADDING;
                if (Types$$module$build$src$core$renderers$measurables$types.isInlineInput(a)) return this.constants_.LARGE_PADDING;
                if (Types$$module$build$src$core$renderers$measurables$types.isStatementInput(a)) return this.constants_.NO_PADDING;
            }
            if (!Types$$module$build$src$core$renderers$measurables$types.isInput(a) && b && Types$$module$build$src$core$renderers$measurables$types.isInput(b)) {
                if (Types$$module$build$src$core$renderers$measurables$types.isField(a) && a.isEditable) {
                    if (Types$$module$build$src$core$renderers$measurables$types.isInlineInput(b) || Types$$module$build$src$core$renderers$measurables$types.isExternalInput(b)) return this.constants_.SMALL_PADDING;
                } else {
                    if (Types$$module$build$src$core$renderers$measurables$types.isInlineInput(b) || Types$$module$build$src$core$renderers$measurables$types.isExternalInput(b)) return this.constants_.MEDIUM_LARGE_PADDING;
                    if (Types$$module$build$src$core$renderers$measurables$types.isStatementInput(b)) return this.constants_.LARGE_PADDING;
                }
                return this.constants_.LARGE_PADDING - 1;
            }
            if (Types$$module$build$src$core$renderers$measurables$types.isIcon(a) && b && !Types$$module$build$src$core$renderers$measurables$types.isInput(b)) return this.constants_.LARGE_PADDING;
            if (Types$$module$build$src$core$renderers$measurables$types.isInlineInput(a) && b && Types$$module$build$src$core$renderers$measurables$types.isField(b)) return b.isEditable ? this.constants_.MEDIUM_PADDING : this.constants_.LARGE_PADDING;
            if (Types$$module$build$src$core$renderers$measurables$types.isLeftSquareCorner(a) && b) {
                if (Types$$module$build$src$core$renderers$measurables$types.isHat(b)) return this.constants_.NO_PADDING;
                if (Types$$module$build$src$core$renderers$measurables$types.isPreviousConnection(b) || Types$$module$build$src$core$renderers$measurables$types.isNextConnection(b)) return b.notchOffset;
            }
            return Types$$module$build$src$core$renderers$measurables$types.isLeftRoundedCorner(a) && b ? b.notchOffset - this.constants_.CORNER_RADIUS : Types$$module$build$src$core$renderers$measurables$types.isField(a) && b && Types$$module$build$src$core$renderers$measurables$types.isField(b) && a.isEditable === b.isEditable || b && Types$$module$build$src$core$renderers$measurables$types.isJaggedEdge(b) ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
        }
        getSpacerRowHeight_(a, b) {
            return Types$$module$build$src$core$renderers$measurables$types.isTopRow(a) && Types$$module$build$src$core$renderers$measurables$types.isBottomRow(b) ? this.constants_.EMPTY_BLOCK_SPACER_HEIGHT : Types$$module$build$src$core$renderers$measurables$types.isTopRow(a) || Types$$module$build$src$core$renderers$measurables$types.isBottomRow(b) ? this.constants_.NO_PADDING : a.hasExternalInput && b.hasExternalInput ? this.constants_.LARGE_PADDING : !a.hasStatement && b.hasStatement ? this.constants_.BETWEEN_STATEMENT_PADDING_Y : a.hasStatement && b.hasStatement || a.hasDummyInput || b.hasDummyInput ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
        }
        getElemCenterline_(a, b) {
            if (Types$$module$build$src$core$renderers$measurables$types.isSpacer(b)) return a.yPos + b.height / 2;
            if (Types$$module$build$src$core$renderers$measurables$types.isBottomRow(a)) return a = a.yPos + a.height - a.descenderHeight, Types$$module$build$src$core$renderers$measurables$types.isNextConnection(b) ? a + b.height / 2 : a - b.height / 2;
            if (Types$$module$build$src$core$renderers$measurables$types.isTopRow(a)) return Types$$module$build$src$core$renderers$measurables$types.isHat(b) ? a.capline - b.height / 2 : a.capline + b.height / 2;
            let c = a.yPos;
            return c = Types$$module$build$src$core$renderers$measurables$types.isField(b) && a.hasStatement ? c + (this.constants_.TALL_INPUT_FIELD_OFFSET_Y + b.height / 2) : c + a.height / 2;
        }
        finalize_() {
            let a = 0, b = 0;
            for(var c = 0; c < this.rows.length; c++){
                const e = this.rows[c];
                e.yPos = b;
                e.xPos = this.startX;
                b += e.height;
                a = Math.max(a, e.widthWithConnectedBlocks);
                var d = b - this.topRow.ascenderHeight;
                e === this.bottomRow && d < this.constants_.MIN_BLOCK_HEIGHT && (d = this.constants_.MIN_BLOCK_HEIGHT - d, this.bottomRow.height += d, b += d);
                this.recordElemPositions_(e);
            }
            this.outputConnection && this.block_.nextConnection && this.block_.nextConnection.isConnected() && (c = this.block_.nextConnection.targetBlock()) && (a = Math.max(a, c.getHeightWidth().width));
            this.bottomRow.baseline = b - this.bottomRow.descenderHeight;
            this.widthWithChildren = a + this.startX;
            this.height = b;
            this.startY = this.topRow.capline;
        }
    }, module$build$src$core$renderers$thrasos$info = {};
    module$build$src$core$renderers$thrasos$info.RenderInfo = RenderInfo$$module$build$src$core$renderers$thrasos$info;
    var Renderer$$module$build$src$core$renderers$thrasos$renderer = class extends Renderer$$module$build$src$core$renderers$common$renderer {
        constructor(a){
            super(a);
        }
        makeRenderInfo_(a) {
            return new RenderInfo$$module$build$src$core$renderers$thrasos$info(this, a);
        }
    };
    register$$module$build$src$core$renderers$common$block_rendering("thrasos", Renderer$$module$build$src$core$renderers$thrasos$renderer);
    var module$build$src$core$renderers$thrasos$renderer = {};
    module$build$src$core$renderers$thrasos$renderer.Renderer = Renderer$$module$build$src$core$renderers$thrasos$renderer;
    var module$build$src$core$renderers$thrasos$thrasos = {};
    module$build$src$core$renderers$thrasos$thrasos.RenderInfo = RenderInfo$$module$build$src$core$renderers$thrasos$info;
    module$build$src$core$renderers$thrasos$thrasos.Renderer = Renderer$$module$build$src$core$renderers$thrasos$renderer;
    var ConstantProvider$$module$build$src$core$renderers$zelos$constants = class extends ConstantProvider$$module$build$src$core$renderers$common$constants {
        constructor(){
            super();
            this.GRID_UNIT = 4;
            this.CURSOR_COLOUR = "#ffa200";
            this.CURSOR_RADIUS = 5;
            this.JAGGED_TEETH_WIDTH = this.JAGGED_TEETH_HEIGHT = 0;
            this.START_HAT_HEIGHT = 22;
            this.START_HAT_WIDTH = 96;
            this.SHAPES = {
                HEXAGONAL: 1,
                ROUND: 2,
                SQUARE: 3,
                PUZZLE: 4,
                NOTCH: 5
            };
            this.SHAPE_IN_SHAPE_PADDING = {
                1: {
                    0: 5 * this.GRID_UNIT,
                    1: 2 * this.GRID_UNIT,
                    2: 5 * this.GRID_UNIT,
                    3: 5 * this.GRID_UNIT
                },
                2: {
                    0: 3 * this.GRID_UNIT,
                    1: 3 * this.GRID_UNIT,
                    2: 1 * this.GRID_UNIT,
                    3: 2 * this.GRID_UNIT
                },
                3: {
                    0: 2 * this.GRID_UNIT,
                    1: 2 * this.GRID_UNIT,
                    2: 2 * this.GRID_UNIT,
                    3: 2 * this.GRID_UNIT
                }
            };
            this.FULL_BLOCK_FIELDS = !0;
            this.FIELD_TEXT_FONTWEIGHT = "bold";
            this.FIELD_TEXT_FONTFAMILY = '"Helvetica Neue", "Segoe UI", Helvetica, sans-serif';
            this.FIELD_COLOUR_FULL_BLOCK = this.FIELD_TEXTINPUT_BOX_SHADOW = this.FIELD_DROPDOWN_SVG_ARROW = this.FIELD_DROPDOWN_COLOURED_DIV = this.FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW = !0;
            this.SELECTED_GLOW_COLOUR = "#fff200";
            this.SELECTED_GLOW_SIZE = .5;
            this.REPLACEMENT_GLOW_COLOUR = "#fff200";
            this.REPLACEMENT_GLOW_SIZE = 2;
            this.selectedGlowFilterId = "";
            this.selectedGlowFilter_ = null;
            this.replacementGlowFilterId = "";
            this.SQUARED = this.ROUNDED = this.HEXAGONAL = this.replacementGlowFilter_ = null;
            this.SMALL_PADDING = this.GRID_UNIT;
            this.MEDIUM_PADDING = 2 * this.GRID_UNIT;
            this.MEDIUM_LARGE_PADDING = 3 * this.GRID_UNIT;
            this.LARGE_PADDING = 4 * this.GRID_UNIT;
            this.CORNER_RADIUS = 1 * this.GRID_UNIT;
            this.NOTCH_WIDTH = 9 * this.GRID_UNIT;
            this.NOTCH_HEIGHT = 2 * this.GRID_UNIT;
            this.STATEMENT_INPUT_NOTCH_OFFSET = this.NOTCH_OFFSET_LEFT = 3 * this.GRID_UNIT;
            this.MIN_BLOCK_WIDTH = 2 * this.GRID_UNIT;
            this.MIN_BLOCK_HEIGHT = 12 * this.GRID_UNIT;
            this.EMPTY_STATEMENT_INPUT_HEIGHT = 6 * this.GRID_UNIT;
            this.TOP_ROW_MIN_HEIGHT = this.CORNER_RADIUS;
            this.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT = this.LARGE_PADDING;
            this.BOTTOM_ROW_MIN_HEIGHT = this.CORNER_RADIUS;
            this.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT = 6 * this.GRID_UNIT;
            this.STATEMENT_BOTTOM_SPACER = -this.NOTCH_HEIGHT;
            this.STATEMENT_INPUT_SPACER_MIN_WIDTH = 40 * this.GRID_UNIT;
            this.STATEMENT_INPUT_PADDING_LEFT = 4 * this.GRID_UNIT;
            this.EMPTY_INLINE_INPUT_PADDING = 4 * this.GRID_UNIT;
            this.EMPTY_INLINE_INPUT_HEIGHT = 8 * this.GRID_UNIT;
            this.DUMMY_INPUT_MIN_HEIGHT = 8 * this.GRID_UNIT;
            this.DUMMY_INPUT_SHADOW_MIN_HEIGHT = 6 * this.GRID_UNIT;
            this.CURSOR_WS_WIDTH = 20 * this.GRID_UNIT;
            this.FIELD_TEXT_FONTSIZE = 3 * this.GRID_UNIT;
            this.FIELD_BORDER_RECT_RADIUS = this.CORNER_RADIUS;
            this.FIELD_BORDER_RECT_X_PADDING = 2 * this.GRID_UNIT;
            this.FIELD_BORDER_RECT_Y_PADDING = 1.625 * this.GRID_UNIT;
            this.FIELD_BORDER_RECT_HEIGHT = 8 * this.GRID_UNIT;
            this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT = 8 * this.GRID_UNIT;
            this.FIELD_DROPDOWN_SVG_ARROW_PADDING = this.FIELD_BORDER_RECT_X_PADDING;
            this.FIELD_COLOUR_DEFAULT_WIDTH = 2 * this.GRID_UNIT;
            this.FIELD_COLOUR_DEFAULT_HEIGHT = 4 * this.GRID_UNIT;
            this.FIELD_CHECKBOX_X_OFFSET = 1 * this.GRID_UNIT;
            this.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH = 12 * this.GRID_UNIT;
        }
        setFontConstants_(a) {
            super.setFontConstants_(a);
            this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT = this.FIELD_BORDER_RECT_HEIGHT = this.FIELD_TEXT_HEIGHT + 2 * this.FIELD_BORDER_RECT_Y_PADDING;
        }
        init() {
            super.init();
            this.HEXAGONAL = this.makeHexagonal();
            this.ROUNDED = this.makeRounded();
            this.SQUARED = this.makeSquared();
            this.STATEMENT_INPUT_NOTCH_OFFSET = this.NOTCH_OFFSET_LEFT + this.INSIDE_CORNERS.rightWidth;
        }
        setDynamicProperties_(a) {
            super.setDynamicProperties_(a);
            this.SELECTED_GLOW_COLOUR = a.getComponentStyle("selectedGlowColour") || this.SELECTED_GLOW_COLOUR;
            const b = Number(a.getComponentStyle("selectedGlowSize"));
            this.SELECTED_GLOW_SIZE = b && !isNaN(b) ? b : this.SELECTED_GLOW_SIZE;
            this.REPLACEMENT_GLOW_COLOUR = a.getComponentStyle("replacementGlowColour") || this.REPLACEMENT_GLOW_COLOUR;
            this.REPLACEMENT_GLOW_SIZE = (a = Number(a.getComponentStyle("replacementGlowSize"))) && !isNaN(a) ? a : this.REPLACEMENT_GLOW_SIZE;
        }
        dispose() {
            super.dispose();
            this.selectedGlowFilter_ && removeNode$$module$build$src$core$utils$dom(this.selectedGlowFilter_);
            this.replacementGlowFilter_ && removeNode$$module$build$src$core$utils$dom(this.replacementGlowFilter_);
        }
        makeStartHat() {
            const a = this.START_HAT_HEIGHT, b = this.START_HAT_WIDTH, c = curve$$module$build$src$core$utils$svg_paths("c", [
                point$$module$build$src$core$utils$svg_paths(25, -a),
                point$$module$build$src$core$utils$svg_paths(71, -a),
                point$$module$build$src$core$utils$svg_paths(b, 0)
            ]);
            return {
                height: a,
                width: b,
                path: c
            };
        }
        makeHexagonal() {
            function a(c, d, e) {
                var f = c / 2;
                f = f > b ? b : f;
                e = e ? -1 : 1;
                c = (d ? -1 : 1) * c / 2;
                return lineTo$$module$build$src$core$utils$svg_paths(-e * f, c) + lineTo$$module$build$src$core$utils$svg_paths(e * f, c);
            }
            const b = this.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH;
            return {
                type: this.SHAPES.HEXAGONAL,
                isDynamic: !0,
                width (c) {
                    c /= 2;
                    return c > b ? b : c;
                },
                height (c) {
                    return c;
                },
                connectionOffsetY (c) {
                    return c / 2;
                },
                connectionOffsetX (c) {
                    return -c;
                },
                pathDown (c) {
                    return a(c, !1, !1);
                },
                pathUp (c) {
                    return a(c, !0, !1);
                },
                pathRightDown (c) {
                    return a(c, !1, !0);
                },
                pathRightUp (c) {
                    return a(c, !1, !0);
                }
            };
        }
        makeRounded() {
            function a(d, e, f) {
                const g = d > c ? d - c : 0;
                d = (d > c ? c : d) / 2;
                return arc$$module$build$src$core$utils$svg_paths("a", "0 0,1", d, point$$module$build$src$core$utils$svg_paths((e ? -1 : 1) * d, (e ? -1 : 1) * d)) + lineOnAxis$$module$build$src$core$utils$svg_paths("v", (f ? 1 : -1) * g) + arc$$module$build$src$core$utils$svg_paths("a", "0 0,1", d, point$$module$build$src$core$utils$svg_paths((e ? 1 : -1) * d, (e ? -1 : 1) * d));
            }
            const b = this.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH, c = 2 * b;
            return {
                type: this.SHAPES.ROUND,
                isDynamic: !0,
                width (d) {
                    d /= 2;
                    return d > b ? b : d;
                },
                height (d) {
                    return d;
                },
                connectionOffsetY (d) {
                    return d / 2;
                },
                connectionOffsetX (d) {
                    return -d;
                },
                pathDown (d) {
                    return a(d, !1, !1);
                },
                pathUp (d) {
                    return a(d, !0, !1);
                },
                pathRightDown (d) {
                    return a(d, !1, !0);
                },
                pathRightUp (d) {
                    return a(d, !1, !0);
                }
            };
        }
        makeSquared() {
            function a(c, d, e) {
                c -= 2 * b;
                return arc$$module$build$src$core$utils$svg_paths("a", "0 0,1", b, point$$module$build$src$core$utils$svg_paths((d ? -1 : 1) * b, (d ? -1 : 1) * b)) + lineOnAxis$$module$build$src$core$utils$svg_paths("v", (e ? 1 : -1) * c) + arc$$module$build$src$core$utils$svg_paths("a", "0 0,1", b, point$$module$build$src$core$utils$svg_paths((d ? 1 : -1) * b, (d ? -1 : 1) * b));
            }
            const b = this.CORNER_RADIUS;
            return {
                type: this.SHAPES.SQUARE,
                isDynamic: !0,
                width (c) {
                    return b;
                },
                height (c) {
                    return c;
                },
                connectionOffsetY (c) {
                    return c / 2;
                },
                connectionOffsetX (c) {
                    return -c;
                },
                pathDown (c) {
                    return a(c, !1, !1);
                },
                pathUp (c) {
                    return a(c, !0, !1);
                },
                pathRightDown (c) {
                    return a(c, !1, !0);
                },
                pathRightUp (c) {
                    return a(c, !1, !0);
                }
            };
        }
        shapeFor(a) {
            let b = a.getCheck();
            !b && a.targetConnection && (b = a.targetConnection.getCheck());
            switch(a.type){
                case ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE:
                case ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE:
                    a = a.getSourceBlock().getOutputShape();
                    if (null !== a) switch(a){
                        case this.SHAPES.HEXAGONAL:
                            return this.HEXAGONAL;
                        case this.SHAPES.ROUND:
                            return this.ROUNDED;
                        case this.SHAPES.SQUARE:
                            return this.SQUARED;
                    }
                    if (b && -1 !== b.indexOf("Boolean")) return this.HEXAGONAL;
                    if (b && -1 !== b.indexOf("Number")) return this.ROUNDED;
                    b && b.indexOf("String");
                    return this.ROUNDED;
                case ConnectionType$$module$build$src$core$connection_type.PREVIOUS_STATEMENT:
                case ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT:
                    return this.NOTCH;
                default:
                    throw Error("Unknown type");
            }
        }
        makeNotch() {
            function a(l) {
                return curve$$module$build$src$core$utils$svg_paths("c", [
                    point$$module$build$src$core$utils$svg_paths(l * e / 2, 0),
                    point$$module$build$src$core$utils$svg_paths(l * e * 3 / 4, g / 2),
                    point$$module$build$src$core$utils$svg_paths(l * e, g)
                ]) + line$$module$build$src$core$utils$svg_paths([
                    point$$module$build$src$core$utils$svg_paths(l * e, f)
                ]) + curve$$module$build$src$core$utils$svg_paths("c", [
                    point$$module$build$src$core$utils$svg_paths(l * e / 4, g / 2),
                    point$$module$build$src$core$utils$svg_paths(l * e / 2, g),
                    point$$module$build$src$core$utils$svg_paths(l * e, g)
                ]) + lineOnAxis$$module$build$src$core$utils$svg_paths("h", l * d) + curve$$module$build$src$core$utils$svg_paths("c", [
                    point$$module$build$src$core$utils$svg_paths(l * e / 2, 0),
                    point$$module$build$src$core$utils$svg_paths(l * e * 3 / 4, -(g / 2)),
                    point$$module$build$src$core$utils$svg_paths(l * e, -g)
                ]) + line$$module$build$src$core$utils$svg_paths([
                    point$$module$build$src$core$utils$svg_paths(l * e, -f)
                ]) + curve$$module$build$src$core$utils$svg_paths("c", [
                    point$$module$build$src$core$utils$svg_paths(l * e / 4, -(g / 2)),
                    point$$module$build$src$core$utils$svg_paths(l * e / 2, -g),
                    point$$module$build$src$core$utils$svg_paths(l * e, -g)
                ]);
            }
            const b = this.NOTCH_WIDTH, c = this.NOTCH_HEIGHT, d = b / 3, e = d / 3, f = c / 2, g = f / 2, h = a(1), k = a(-1);
            return {
                type: this.SHAPES.NOTCH,
                width: b,
                height: c,
                pathLeft: h,
                pathRight: k
            };
        }
        makeInsideCorners() {
            const a = this.CORNER_RADIUS, b = arc$$module$build$src$core$utils$svg_paths("a", "0 0,0", a, point$$module$build$src$core$utils$svg_paths(-a, a)), c = arc$$module$build$src$core$utils$svg_paths("a", "0 0,1", a, point$$module$build$src$core$utils$svg_paths(-a, a)), d = arc$$module$build$src$core$utils$svg_paths("a", "0 0,0", a, point$$module$build$src$core$utils$svg_paths(a, a)), e = arc$$module$build$src$core$utils$svg_paths("a", "0 0,1", a, point$$module$build$src$core$utils$svg_paths(a, a));
            return {
                width: a,
                height: a,
                pathTop: b,
                pathBottom: d,
                rightWidth: a,
                rightHeight: a,
                pathTopRight: c,
                pathBottomRight: e
            };
        }
        generateSecondaryColour_(a) {
            return blend$$module$build$src$core$utils$colour("#000", a, .15) || a;
        }
        generateTertiaryColour_(a) {
            return blend$$module$build$src$core$utils$colour("#000", a, .25) || a;
        }
        createDom(a, b, c) {
            super.createDom(a, b, c);
            a = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.DEFS, {}, a);
            b = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FILTER, {
                id: "blocklySelectedGlowFilter" + this.randomIdentifier,
                height: "160%",
                width: "180%",
                y: "-30%",
                x: "-40%"
            }, a);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FEGAUSSIANBLUR, {
                "in": "SourceGraphic",
                stdDeviation: this.SELECTED_GLOW_SIZE
            }, b);
            c = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FECOMPONENTTRANSFER, {
                result: "outBlur"
            }, b);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FEFUNCA, {
                type: "table",
                tableValues: "0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1"
            }, c);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FEFLOOD, {
                "flood-color": this.SELECTED_GLOW_COLOUR,
                "flood-opacity": 1,
                result: "outColor"
            }, b);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FECOMPOSITE, {
                "in": "outColor",
                in2: "outBlur",
                operator: "in",
                result: "outGlow"
            }, b);
            this.selectedGlowFilterId = b.id;
            this.selectedGlowFilter_ = b;
            a = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FILTER, {
                id: "blocklyReplacementGlowFilter" + this.randomIdentifier,
                height: "160%",
                width: "180%",
                y: "-30%",
                x: "-40%"
            }, a);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FEGAUSSIANBLUR, {
                "in": "SourceGraphic",
                stdDeviation: this.REPLACEMENT_GLOW_SIZE
            }, a);
            b = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FECOMPONENTTRANSFER, {
                result: "outBlur"
            }, a);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FEFUNCA, {
                type: "table",
                tableValues: "0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1"
            }, b);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FEFLOOD, {
                "flood-color": this.REPLACEMENT_GLOW_COLOUR,
                "flood-opacity": 1,
                result: "outColor"
            }, a);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FECOMPOSITE, {
                "in": "outColor",
                in2: "outBlur",
                operator: "in",
                result: "outGlow"
            }, a);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.FECOMPOSITE, {
                "in": "SourceGraphic",
                in2: "outGlow",
                operator: "over"
            }, a);
            this.replacementGlowFilterId = a.id;
            this.replacementGlowFilter_ = a;
        }
        getCSS_(a) {
            return [
                `${a} .blocklyText,`,
                `${a} .blocklyFlyoutLabelText {`,
                `font: ${this.FIELD_TEXT_FONTWEIGHT} ${this.FIELD_TEXT_FONTSIZE}` + `pt ${this.FIELD_TEXT_FONTFAMILY};`,
                "}",
                `${a} .blocklyText {`,
                "fill: #fff;",
                "}",
                `${a} .blocklyNonEditableText>rect:not(.blocklyDropdownRect),`,
                `${a} .blocklyEditableText>rect:not(.blocklyDropdownRect) {`,
                `fill: ${this.FIELD_BORDER_RECT_COLOUR};`,
                "}",
                `${a} .blocklyNonEditableText>text,`,
                `${a} .blocklyEditableText>text,`,
                `${a} .blocklyNonEditableText>g>text,`,
                `${a} .blocklyEditableText>g>text {`,
                "fill: #575E75;",
                "}",
                `${a} .blocklyFlyoutLabelText {`,
                "fill: #575E75;",
                "}",
                `${a} .blocklyText.blocklyBubbleText {`,
                "fill: #575E75;",
                "}",
                `${a} .blocklyDraggable:not(.blocklyDisabled)`,
                " .blocklyEditableText:not(.editing):hover>rect,",
                `${a} .blocklyDraggable:not(.blocklyDisabled)`,
                " .blocklyEditableText:not(.editing):hover>.blocklyPath {",
                "stroke: #fff;",
                "stroke-width: 2;",
                "}",
                `${a} .blocklyHtmlInput {`,
                `font-family: ${this.FIELD_TEXT_FONTFAMILY};`,
                `font-weight: ${this.FIELD_TEXT_FONTWEIGHT};`,
                "color: #575E75;",
                "}",
                `${a} .blocklyDropdownText {`,
                "fill: #fff !important;",
                "}",
                `${a}.blocklyWidgetDiv .goog-menuitem,`,
                `${a}.blocklyDropDownDiv .goog-menuitem {`,
                `font-family: ${this.FIELD_TEXT_FONTFAMILY};`,
                "}",
                `${a}.blocklyDropDownDiv .goog-menuitem-content {`,
                "color: #fff;",
                "}",
                `${a} .blocklyHighlightedConnectionPath {`,
                `stroke: ${this.SELECTED_GLOW_COLOUR};`,
                "}",
                `${a} .blocklyDisabled > .blocklyOutlinePath {`,
                `fill: url(#blocklyDisabledPattern${this.randomIdentifier})`,
                "}",
                `${a} .blocklyInsertionMarker>.blocklyPath {`,
                `fill-opacity: ${this.INSERTION_MARKER_OPACITY};`,
                "stroke: none;",
                "}"
            ];
        }
    }, module$build$src$core$renderers$zelos$constants = {};
    module$build$src$core$renderers$zelos$constants.ConstantProvider = ConstantProvider$$module$build$src$core$renderers$zelos$constants;
    var Drawer$$module$build$src$core$renderers$zelos$drawer = class extends Drawer$$module$build$src$core$renderers$common$drawer {
        constructor(a, b){
            super(a, b);
        }
        draw() {
            const a = this.block_.pathObject;
            a.beginDrawing();
            this.hideHiddenIcons_();
            this.drawOutline_();
            this.drawInternals_();
            a.setPath(this.outlinePath_ + "\n" + this.inlinePath_);
            this.info_.RTL && a.flipRTL();
            if (isDebuggerEnabled$$module$build$src$core$renderers$common$debug()) {
                let b, c;
                null == (b = this.block_) || null == (c = b.renderingDebugger) || c.drawDebug(this.block_, this.info_);
            }
            this.recordSizeOnBlock_();
            this.info_.outputConnection && (a.outputShapeType = this.info_.outputConnection.shape.type);
            a.endDrawing();
        }
        drawOutline_() {
            this.info_.outputConnection && this.info_.outputConnection.isDynamicShape && !this.info_.hasStatementInput && !this.info_.bottomRow.hasNextConnection ? (this.drawFlatTop_(), this.drawRightDynamicConnection_(), this.drawFlatBottom_(), this.drawLeftDynamicConnection_()) : super.drawOutline_();
        }
        drawLeft_() {
            this.info_.outputConnection && this.info_.outputConnection.isDynamicShape ? this.drawLeftDynamicConnection_() : super.drawLeft_();
        }
        drawRightSideRow_(a) {
            if (!(0 >= a.height)) {
                if (Types$$module$build$src$core$renderers$measurables$types.isSpacer(a) && (a.precedesStatement || a.followsStatement)) {
                    var b = this.constants_.INSIDE_CORNERS.rightHeight;
                    b = a.height - (a.precedesStatement ? b : 0);
                    this.outlinePath_ += (a.followsStatement ? this.constants_.INSIDE_CORNERS.pathBottomRight : "") + (0 < b ? lineOnAxis$$module$build$src$core$utils$svg_paths("V", a.yPos + b) : "") + (a.precedesStatement ? this.constants_.INSIDE_CORNERS.pathTopRight : "");
                } else this.outlinePath_ += lineOnAxis$$module$build$src$core$utils$svg_paths("V", a.yPos + a.height);
            }
        }
        drawRightDynamicConnection_() {
            if (!this.info_.outputConnection) throw Error("Cannot draw the output connection of a block that doesn't have one");
            this.outlinePath_ += this.info_.outputConnection.shape.pathRightDown(this.info_.outputConnection.height);
        }
        drawLeftDynamicConnection_() {
            if (!this.info_.outputConnection) throw Error("Cannot draw the output connection of a block that doesn't have one");
            this.positionOutputConnection_();
            this.outlinePath_ += this.info_.outputConnection.shape.pathUp(this.info_.outputConnection.height);
            this.outlinePath_ += "z";
        }
        drawFlatTop_() {
            const a = this.info_.topRow;
            this.positionPreviousConnection_();
            this.outlinePath_ += moveBy$$module$build$src$core$utils$svg_paths(a.xPos, this.info_.startY);
            this.outlinePath_ += lineOnAxis$$module$build$src$core$utils$svg_paths("h", a.width);
        }
        drawFlatBottom_() {
            const a = this.info_.bottomRow;
            this.positionNextConnection_();
            this.outlinePath_ += lineOnAxis$$module$build$src$core$utils$svg_paths("V", a.baseline);
            this.outlinePath_ += lineOnAxis$$module$build$src$core$utils$svg_paths("h", -a.width);
        }
        drawInlineInput_(a) {
            this.positionInlineInputConnection_(a);
            const b = a.input.name;
            if (!a.connectedBlock && !this.info_.isInsertionMarker) {
                var c = a.width - 2 * a.connectionWidth;
                a = moveTo$$module$build$src$core$utils$svg_paths(a.xPos + a.connectionWidth, a.centerline - a.height / 2) + lineOnAxis$$module$build$src$core$utils$svg_paths("h", c) + a.shape.pathRightDown(a.height) + lineOnAxis$$module$build$src$core$utils$svg_paths("h", -c) + a.shape.pathUp(a.height) + "z";
                this.block_.pathObject.setOutlinePath(b, a);
            }
        }
        drawStatementInput_(a) {
            var b = a.getLastInput();
            const c = b.xPos + b.notchOffset + b.shape.width, d = b.shape.pathRight + lineOnAxis$$module$build$src$core$utils$svg_paths("h", -(b.notchOffset - this.constants_.INSIDE_CORNERS.width)) + this.constants_.INSIDE_CORNERS.pathTop, e = a.height - 2 * this.constants_.INSIDE_CORNERS.height;
            b = this.constants_.INSIDE_CORNERS.pathBottom + lineOnAxis$$module$build$src$core$utils$svg_paths("h", b.notchOffset - this.constants_.INSIDE_CORNERS.width) + (b.connectedBottomNextConnection ? "" : b.shape.pathLeft);
            this.outlinePath_ += lineOnAxis$$module$build$src$core$utils$svg_paths("H", c) + d + lineOnAxis$$module$build$src$core$utils$svg_paths("v", e) + b + lineOnAxis$$module$build$src$core$utils$svg_paths("H", a.xPos + a.width);
            this.positionStatementInputConnection_(a);
        }
    }, module$build$src$core$renderers$zelos$drawer = {};
    module$build$src$core$renderers$zelos$drawer.Drawer = Drawer$$module$build$src$core$renderers$zelos$drawer;
    var BottomRow$$module$build$src$core$renderers$zelos$measurables$bottom_row = class extends BottomRow$$module$build$src$core$renderers$measurables$bottom_row {
        constructor(a){
            super(a);
        }
        endsWithElemSpacer() {
            return !1;
        }
        hasLeftSquareCorner(a) {
            return !!a.outputConnection;
        }
        hasRightSquareCorner(a) {
            return !!a.outputConnection && !a.statementInputCount && !a.nextConnection;
        }
    }, module$build$src$core$renderers$zelos$measurables$bottom_row = {};
    module$build$src$core$renderers$zelos$measurables$bottom_row.BottomRow = BottomRow$$module$build$src$core$renderers$zelos$measurables$bottom_row;
    var StatementInput$$module$build$src$core$renderers$zelos$measurables$inputs = class extends StatementInput$$module$build$src$core$renderers$measurables$statement_input {
        constructor(a, b){
            super(a, b);
            this.connectedBottomNextConnection = !1;
            if (this.connectedBlock) {
                for(a = this.connectedBlock; b = a.getNextBlock();)a = b;
                a.nextConnection || (this.height = this.connectedBlockHeight, this.connectedBottomNextConnection = !0);
            }
        }
    }, module$build$src$core$renderers$zelos$measurables$inputs = {};
    module$build$src$core$renderers$zelos$measurables$inputs.StatementInput = StatementInput$$module$build$src$core$renderers$zelos$measurables$inputs;
    var RightConnectionShape$$module$build$src$core$renderers$zelos$measurables$row_elements = class extends Measurable$$module$build$src$core$renderers$measurables$base {
        constructor(a){
            super(a);
            this.width = this.height = 0;
            this.type |= Types$$module$build$src$core$renderers$measurables$types.getType("RIGHT_CONNECTION");
        }
    }, module$build$src$core$renderers$zelos$measurables$row_elements = {};
    module$build$src$core$renderers$zelos$measurables$row_elements.RightConnectionShape = RightConnectionShape$$module$build$src$core$renderers$zelos$measurables$row_elements;
    var TopRow$$module$build$src$core$renderers$zelos$measurables$top_row = class extends TopRow$$module$build$src$core$renderers$measurables$top_row {
        constructor(a){
            super(a);
        }
        endsWithElemSpacer() {
            return !1;
        }
        hasLeftSquareCorner(a) {
            const b = (a.hat ? "cap" === a.hat : this.constants_.ADD_START_HATS) && !a.outputConnection && !a.previousConnection;
            return !!a.outputConnection || b;
        }
        hasRightSquareCorner(a) {
            return !!a.outputConnection && !a.statementInputCount && !a.nextConnection;
        }
    }, module$build$src$core$renderers$zelos$measurables$top_row = {};
    module$build$src$core$renderers$zelos$measurables$top_row.TopRow = TopRow$$module$build$src$core$renderers$zelos$measurables$top_row;
    var RenderInfo$$module$build$src$core$renderers$zelos$info = class extends RenderInfo$$module$build$src$core$renderers$common$info {
        constructor(a, b){
            super(a, b);
            this.isInline = !0;
            this.renderer_ = a;
            this.constants_ = this.renderer_.getConstants();
            this.topRow = new TopRow$$module$build$src$core$renderers$zelos$measurables$top_row(this.constants_);
            this.bottomRow = new BottomRow$$module$build$src$core$renderers$zelos$measurables$bottom_row(this.constants_);
            this.isMultiRow = !b.getInputsInline() || b.isCollapsed();
            this.hasStatementInput = 0 < b.statementInputCount;
            this.rightSide = this.outputConnection ? new RightConnectionShape$$module$build$src$core$renderers$zelos$measurables$row_elements(this.constants_) : null;
            this.rightAlignedDummyInputs_ = new WeakMap;
        }
        getRenderer() {
            return this.renderer_;
        }
        measure() {
            this.createRows_();
            this.addElemSpacing_();
            this.addRowSpacing_();
            this.adjustXPosition_();
            this.computeBounds_();
            this.alignRowElements_();
            this.finalize_();
        }
        shouldStartNewRow_(a, b) {
            return b ? a.type === inputTypes$$module$build$src$core$input_types.STATEMENT || b.type === inputTypes$$module$build$src$core$input_types.STATEMENT ? !0 : a.type === inputTypes$$module$build$src$core$input_types.VALUE || a.type === inputTypes$$module$build$src$core$input_types.DUMMY ? !this.isInline || this.isMultiRow : !1 : !1;
        }
        getDesiredRowWidth_(a) {
            return a.hasStatement ? this.width - this.startX - (this.constants_.INSIDE_CORNERS.rightWidth || 0) : super.getDesiredRowWidth_(a);
        }
        getInRowSpacing_(a, b) {
            return a && b || !this.outputConnection || !this.outputConnection.isDynamicShape || this.hasStatementInput || this.bottomRow.hasNextConnection ? !a && b && Types$$module$build$src$core$renderers$measurables$types.isStatementInput(b) ? this.constants_.STATEMENT_INPUT_PADDING_LEFT : a && Types$$module$build$src$core$renderers$measurables$types.isLeftRoundedCorner(a) && b && (Types$$module$build$src$core$renderers$measurables$types.isPreviousConnection(b) || Types$$module$build$src$core$renderers$measurables$types.isNextConnection(b)) ? b.notchOffset - this.constants_.CORNER_RADIUS : a && Types$$module$build$src$core$renderers$measurables$types.isLeftSquareCorner(a) && b && Types$$module$build$src$core$renderers$measurables$types.isHat(b) ? this.constants_.NO_PADDING : this.constants_.MEDIUM_PADDING : this.constants_.NO_PADDING;
        }
        getSpacerRowHeight_(a, b) {
            if (Types$$module$build$src$core$renderers$measurables$types.isTopRow(a) && Types$$module$build$src$core$renderers$measurables$types.isBottomRow(b)) return this.constants_.EMPTY_BLOCK_SPACER_HEIGHT;
            const c = Types$$module$build$src$core$renderers$measurables$types.isInputRow(a) && a.hasStatement, d = Types$$module$build$src$core$renderers$measurables$types.isInputRow(b) && b.hasStatement;
            return d || c ? (a = Math.max(this.constants_.NOTCH_HEIGHT, this.constants_.INSIDE_CORNERS.rightHeight || 0), d && c ? Math.max(a, this.constants_.DUMMY_INPUT_MIN_HEIGHT) : a) : Types$$module$build$src$core$renderers$measurables$types.isTopRow(a) ? a.hasPreviousConnection || this.outputConnection && !this.hasStatementInput ? this.constants_.NO_PADDING : Math.abs(this.constants_.NOTCH_HEIGHT - this.constants_.CORNER_RADIUS) : Types$$module$build$src$core$renderers$measurables$types.isBottomRow(b) ? this.outputConnection ? !b.hasNextConnection && this.hasStatementInput ? Math.abs(this.constants_.NOTCH_HEIGHT - this.constants_.CORNER_RADIUS) : this.constants_.NO_PADDING : Math.max(this.topRow.minHeight, Math.max(this.constants_.NOTCH_HEIGHT, this.constants_.CORNER_RADIUS)) - this.constants_.CORNER_RADIUS : this.constants_.MEDIUM_PADDING;
        }
        getSpacerRowWidth_(a, b) {
            const c = this.width - this.startX;
            return Types$$module$build$src$core$renderers$measurables$types.isInputRow(a) && a.hasStatement || Types$$module$build$src$core$renderers$measurables$types.isInputRow(b) && b.hasStatement ? Math.max(c, this.constants_.STATEMENT_INPUT_SPACER_MIN_WIDTH) : c;
        }
        getElemCenterline_(a, b) {
            if (a.hasStatement && !Types$$module$build$src$core$renderers$measurables$types.isSpacer(b) && !Types$$module$build$src$core$renderers$measurables$types.isStatementInput(b)) return a.yPos + this.constants_.EMPTY_STATEMENT_INPUT_HEIGHT / 2;
            if (Types$$module$build$src$core$renderers$measurables$types.isInlineInput(b) && b instanceof InputConnection$$module$build$src$core$renderers$measurables$input_connection) {
                const c = b.connectedBlock;
                if (c && c.outputConnection && c.nextConnection) return a.yPos + c.height / 2;
            }
            return super.getElemCenterline_(a, b);
        }
        addInput_(a, b) {
            if (a.type === inputTypes$$module$build$src$core$input_types.DUMMY && b.hasDummyInput && b.align === $.Align$$module$build$src$core$input.LEFT && a.align === $.Align$$module$build$src$core$input.RIGHT) this.rightAlignedDummyInputs_.set(b, a);
            else if (a.type === inputTypes$$module$build$src$core$input_types.STATEMENT) {
                b.elements.push(new StatementInput$$module$build$src$core$renderers$zelos$measurables$inputs(this.constants_, a));
                b.hasStatement = !0;
                null === b.align && (b.align = a.align);
                return;
            }
            super.addInput_(a, b);
        }
        addAlignmentPadding_(a, b) {
            if (this.rightAlignedDummyInputs_.get(a)) {
                let c;
                for(let d = 0; d < a.elements.length; d++){
                    const e = a.elements[d];
                    Types$$module$build$src$core$renderers$measurables$types.isSpacer(e) && (c = e);
                    if (Types$$module$build$src$core$renderers$measurables$types.isField(e) && e instanceof Field$$module$build$src$core$renderers$measurables$field && e.parentInput === this.rightAlignedDummyInputs_.get(a)) break;
                }
                if (c) {
                    c.width += b;
                    a.width += b;
                    return;
                }
            }
            super.addAlignmentPadding_(a, b);
        }
        adjustXPosition_() {
            const a = this.constants_.NOTCH_OFFSET_LEFT + this.constants_.NOTCH_WIDTH;
            let b = a;
            for(let e = 2; e < this.rows.length - 1; e += 2){
                var c = this.rows[e - 1];
                const f = this.rows[e];
                var d = this.rows[e + 1];
                c = 2 === e ? !!this.topRow.hasPreviousConnection : !!c.followsStatement;
                d = e + 2 >= this.rows.length - 1 ? !!this.bottomRow.hasNextConnection : !!d.precedesStatement;
                if (Types$$module$build$src$core$renderers$measurables$types.isInputRow(f) && f.hasStatement) {
                    f.measure();
                    let g, h;
                    b = f.width - (null != (h = null == (g = f.getLastInput()) ? void 0 : g.width) ? h : 0) + a;
                } else if (c && (2 === e || d) && Types$$module$build$src$core$renderers$measurables$types.isInputRow(f) && !f.hasStatement) {
                    d = f.xPos;
                    c = null;
                    for(let g = 0; g < f.elements.length; g++){
                        const h = f.elements[g];
                        Types$$module$build$src$core$renderers$measurables$types.isSpacer(h) && (c = h);
                        c && (Types$$module$build$src$core$renderers$measurables$types.isField(h) || Types$$module$build$src$core$renderers$measurables$types.isInput(h)) && d < b && !(Types$$module$build$src$core$renderers$measurables$types.isField(h) && h instanceof Field$$module$build$src$core$renderers$measurables$field && (h.field instanceof FieldLabel$$module$build$src$core$field_label || h.field instanceof FieldImage$$module$build$src$core$field_image)) && (c.width += b - d);
                        d += h.width;
                    }
                }
            }
        }
        finalizeOutputConnection_() {
            if (this.outputConnection && this.outputConnection.isDynamicShape) {
                var a = this.outputConnection.shape;
                if ("isDynamic" in a && a.isDynamic) {
                    var b = 0;
                    for(var c = 0; c < this.rows.length; c++){
                        const d = this.rows[c];
                        d.yPos = b;
                        b += d.height;
                    }
                    this.height = b;
                    c = this.bottomRow.hasNextConnection ? this.height - this.bottomRow.descenderHeight : this.height;
                    b = a.height(c);
                    c = a.width(c);
                    this.outputConnection.height = b;
                    this.outputConnection.width = c;
                    this.outputConnection.startX = c;
                    this.outputConnection.connectionOffsetY = a.connectionOffsetY(b);
                    this.outputConnection.connectionOffsetX = a.connectionOffsetX(c);
                    a = 0;
                    this.hasStatementInput || this.bottomRow.hasNextConnection || (a = c, this.rightSide.height = b, this.rightSide.width = a, this.rightSide.centerline = b / 2, this.rightSide.xPos = this.width + a);
                    this.startX = c;
                    this.width += c + a;
                    this.widthWithChildren += c + a;
                }
            }
        }
        finalizeHorizontalAlignment_() {
            if (this.outputConnection && !this.hasStatementInput && !this.bottomRow.hasNextConnection) {
                var a = 0;
                for(var b = 0; b < this.rows.length; b++){
                    var c = this.rows[b];
                    if (!Types$$module$build$src$core$renderers$measurables$types.isInputRow(c)) continue;
                    a = c.elements[c.elements.length - 2];
                    let d = this.getNegativeSpacing_(c.elements[1]), e = this.getNegativeSpacing_(a);
                    a = d + e;
                    const f = this.constants_.MIN_BLOCK_WIDTH + 2 * this.outputConnection.width;
                    this.width - a < f && (a = this.width - f, d = a / 2, e = a / 2);
                    c.elements.unshift(new InRowSpacer$$module$build$src$core$renderers$measurables$in_row_spacer(this.constants_, -d));
                    c.elements.push(new InRowSpacer$$module$build$src$core$renderers$measurables$in_row_spacer(this.constants_, -e));
                }
                if (a) for(this.width -= a, this.widthWithChildren -= a, this.rightSide.xPos -= a, b = 0; b < this.rows.length; b++)c = this.rows[b], Types$$module$build$src$core$renderers$measurables$types.isTopOrBottomRow(c) && (c.elements[1].width -= a), c.width -= a, c.widthWithConnectedBlocks -= a;
            }
        }
        getNegativeSpacing_(a) {
            if (!a || !this.outputConnection) return 0;
            const b = this.outputConnection.width;
            var c = this.outputConnection.shape.type;
            const d = this.constants_;
            if (this.isMultiRow && 1 < this.inputRows.length) switch(c){
                case d.SHAPES.ROUND:
                    return c = this.constants_.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH, c = this.height / 2 > c ? c : this.height / 2, b - c * (1 - Math.sin(Math.acos((c - this.constants_.SMALL_PADDING) / c)));
                default:
                    return 0;
            }
            if (Types$$module$build$src$core$renderers$measurables$types.isInlineInput(a) && a instanceof InputConnection$$module$build$src$core$renderers$measurables$input_connection) {
                const e = a.connectedBlock;
                a = e ? e.pathObject.outputShapeType : a.shape.type;
                return null == a || e && e.outputConnection && (e.statementInputCount || e.nextConnection) || c === d.SHAPES.HEXAGONAL && c !== a ? 0 : b - this.constants_.SHAPE_IN_SHAPE_PADDING[c][a];
            }
            return Types$$module$build$src$core$renderers$measurables$types.isField(a) && a instanceof Field$$module$build$src$core$renderers$measurables$field ? c === d.SHAPES.ROUND && a.field instanceof FieldTextInput$$module$build$src$core$field_textinput ? b - 2.75 * d.GRID_UNIT : b - this.constants_.SHAPE_IN_SHAPE_PADDING[c][0] : Types$$module$build$src$core$renderers$measurables$types.isIcon(a) ? this.constants_.SMALL_PADDING : 0;
        }
        finalizeVerticalAlignment_() {
            if (!this.outputConnection) for(let d = 2; d < this.rows.length - 1; d += 2){
                const e = this.rows[d - 1], f = this.rows[d], g = this.rows[d + 1];
                var a = 2 === d, b = d + 2 >= this.rows.length - 1 ? !!this.bottomRow.hasNextConnection : !!g.precedesStatement;
                if (a ? this.topRow.hasPreviousConnection : e.followsStatement) {
                    var c = f.elements[1];
                    c = 3 === f.elements.length && c instanceof Field$$module$build$src$core$renderers$measurables$field && (c.field instanceof FieldLabel$$module$build$src$core$field_label || c.field instanceof FieldImage$$module$build$src$core$field_image);
                    if (!a && c) e.height -= this.constants_.SMALL_PADDING, g.height -= this.constants_.SMALL_PADDING, f.height -= this.constants_.MEDIUM_PADDING;
                    else if (!a && !b) e.height += this.constants_.SMALL_PADDING;
                    else if (b) {
                        a = !1;
                        for(b = 0; b < f.elements.length; b++)if (c = f.elements[b], c instanceof InputConnection$$module$build$src$core$renderers$measurables$input_connection && Types$$module$build$src$core$renderers$measurables$types.isInlineInput(c) && c.connectedBlock && !c.connectedBlock.isShadow() && 40 <= c.connectedBlock.getHeightWidth().height) {
                            a = !0;
                            break;
                        }
                        a && (e.height -= this.constants_.SMALL_PADDING, g.height -= this.constants_.SMALL_PADDING);
                    }
                }
            }
        }
        finalize_() {
            this.finalizeOutputConnection_();
            this.finalizeHorizontalAlignment_();
            this.finalizeVerticalAlignment_();
            super.finalize_();
            this.rightSide && (this.widthWithChildren += this.rightSide.width);
        }
    }, module$build$src$core$renderers$zelos$info = {};
    module$build$src$core$renderers$zelos$info.RenderInfo = RenderInfo$$module$build$src$core$renderers$zelos$info;
    var MarkerSvg$$module$build$src$core$renderers$zelos$marker_svg = class extends MarkerSvg$$module$build$src$core$renderers$common$marker_svg {
        constructor(a, b, c){
            super(a, b, c);
            this.markerCircle_ = null;
        }
        showWithInputOutput_(a) {
            const b = a.getSourceBlock();
            a = a.getLocation().getOffsetInBlock();
            this.positionCircle_(a.x, a.y);
            this.setParent_(b);
            this.showCurrent_();
        }
        showWithOutput_(a) {
            this.showWithInputOutput_(a);
        }
        showWithInput_(a) {
            this.showWithInputOutput_(a);
        }
        showWithBlock_(a) {
            a = a.getLocation();
            const b = a.getHeightWidth();
            this.positionRect_(0, 0, b.width, b.height);
            this.setParent_(a);
            this.showCurrent_();
        }
        positionCircle_(a, b) {
            let c;
            null == (c = this.markerCircle_) || c.setAttribute("cx", `${a}`);
            let d;
            null == (d = this.markerCircle_) || d.setAttribute("cy", `${b}`);
            this.currentMarkerSvg = this.markerCircle_;
        }
        hide() {
            super.hide();
            this.markerCircle_ && (this.markerCircle_.style.display = "none");
        }
        createDomInternal_() {
            super.createDomInternal_();
            this.markerCircle_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.CIRCLE, {
                r: this.constants_.CURSOR_RADIUS,
                style: "display: none",
                "stroke-width": this.constants_.CURSOR_STROKE_WIDTH
            }, this.markerSvg_);
            if (this.isCursor()) {
                const a = this.getBlinkProperties_();
                createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.ANIMATE, a, this.markerCircle_);
            }
            return this.markerSvg_;
        }
        applyColour_(a) {
            super.applyColour_(a);
            let b;
            null == (b = this.markerCircle_) || b.setAttribute("fill", this.colour_);
            let c;
            null == (c = this.markerCircle_) || c.setAttribute("stroke", this.colour_);
            if (this.isCursor()) {
                a = this.colour_ + ";transparent;transparent;";
                let d;
                null == (d = this.markerCircle_) || d.firstElementChild.setAttribute("values", a);
            }
        }
    }, module$build$src$core$renderers$zelos$marker_svg = {};
    module$build$src$core$renderers$zelos$marker_svg.MarkerSvg = MarkerSvg$$module$build$src$core$renderers$zelos$marker_svg;
    var PathObject$$module$build$src$core$renderers$zelos$path_object = class extends PathObject$$module$build$src$core$renderers$common$path_object {
        constructor(a, b, c){
            super(a, b, c);
            this.svgPathSelected_ = null;
            this.outlines = new Map;
            this.remainingOutlines = new Set;
            this.outputShapeType = null;
            this.constants = c;
        }
        setPath(a) {
            super.setPath(a);
            this.svgPathSelected_ && this.svgPathSelected_.setAttribute("d", a);
        }
        applyColour(a) {
            super.applyColour(a);
            const b = a.getParent();
            a.isShadow() && b && this.svgPath.setAttribute("stroke", b.style.colourTertiary);
            for (const c of this.outlines.values())c.setAttribute("fill", this.style.colourTertiary);
        }
        flipRTL() {
            super.flipRTL();
            for (const a of this.outlines.values())a.setAttribute("transform", "scale(-1 1)");
        }
        updateSelected(a) {
            this.setClass_("blocklySelected", a);
            a ? this.svgPathSelected_ || (this.svgPathSelected_ = this.svgPath.cloneNode(!0), this.svgPathSelected_.setAttribute("fill", "none"), this.svgPathSelected_.setAttribute("filter", "url(#" + this.constants.selectedGlowFilterId + ")"), this.svgRoot.appendChild(this.svgPathSelected_)) : this.svgPathSelected_ && (this.svgRoot.removeChild(this.svgPathSelected_), this.svgPathSelected_ = null);
        }
        updateReplacementFade(a) {
            this.setClass_("blocklyReplaceable", a);
            a ? this.svgPath.setAttribute("filter", "url(#" + this.constants.replacementGlowFilterId + ")") : this.svgPath.removeAttribute("filter");
        }
        updateShapeForInputHighlight(a, b) {
            a = a.getParentInput().name;
            (a = this.getOutlinePath_(a)) && (b ? a.setAttribute("filter", "url(#" + this.constants.replacementGlowFilterId + ")") : a.removeAttribute("filter"));
        }
        beginDrawing() {
            this.remainingOutlines.clear();
            for (const a of this.outlines.keys())this.remainingOutlines.add(a);
        }
        endDrawing() {
            if (this.remainingOutlines.size) for (const a of this.remainingOutlines)this.removeOutlinePath_(a);
            this.remainingOutlines.clear();
        }
        setOutlinePath(a, b) {
            a = this.getOutlinePath_(a);
            a.setAttribute("d", b);
            a.setAttribute("fill", this.style.colourTertiary);
        }
        getOutlinePath_(a) {
            this.outlines.has(a) || this.outlines.set(a, createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.PATH, {
                "class": "blocklyOutlinePath",
                d: ""
            }, this.svgRoot));
            this.remainingOutlines.delete(a);
            return this.outlines.get(a);
        }
        removeOutlinePath_(a) {
            let b, c;
            null == (b = this.outlines.get(a)) || null == (c = b.parentNode) || c.removeChild(this.outlines.get(a));
            this.outlines.delete(a);
        }
    }, module$build$src$core$renderers$zelos$path_object = {};
    module$build$src$core$renderers$zelos$path_object.PathObject = PathObject$$module$build$src$core$renderers$zelos$path_object;
    var Renderer$$module$build$src$core$renderers$zelos$renderer = class extends Renderer$$module$build$src$core$renderers$common$renderer {
        constructor(a){
            super(a);
        }
        makeConstants_() {
            return new ConstantProvider$$module$build$src$core$renderers$zelos$constants;
        }
        makeRenderInfo_(a) {
            return new RenderInfo$$module$build$src$core$renderers$zelos$info(this, a);
        }
        makeDrawer_(a, b) {
            return new Drawer$$module$build$src$core$renderers$zelos$drawer(a, b);
        }
        makeMarkerDrawer(a, b) {
            return new MarkerSvg$$module$build$src$core$renderers$zelos$marker_svg(a, this.getConstants(), b);
        }
        makePathObject(a, b) {
            return new PathObject$$module$build$src$core$renderers$zelos$path_object(a, b, this.getConstants());
        }
        getConstants() {
            return this.constants_;
        }
        shouldHighlightConnection(a) {
            return a.type !== ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE && a.type !== ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE;
        }
        getConnectionPreviewMethod(a, b, c) {
            return b.type === ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE ? a.isConnected() ? InsertionMarkerManager$$module$build$src$core$insertion_marker_manager.PREVIEW_TYPE.REPLACEMENT_FADE : InsertionMarkerManager$$module$build$src$core$insertion_marker_manager.PREVIEW_TYPE.INPUT_OUTLINE : super.getConnectionPreviewMethod(a, b, c);
        }
    };
    register$$module$build$src$core$renderers$common$block_rendering("zelos", Renderer$$module$build$src$core$renderers$zelos$renderer);
    var module$build$src$core$renderers$zelos$renderer = {};
    module$build$src$core$renderers$zelos$renderer.Renderer = Renderer$$module$build$src$core$renderers$zelos$renderer;
    var module$build$src$core$renderers$zelos$zelos = {};
    module$build$src$core$renderers$zelos$zelos.BottomRow = BottomRow$$module$build$src$core$renderers$zelos$measurables$bottom_row;
    module$build$src$core$renderers$zelos$zelos.ConstantProvider = ConstantProvider$$module$build$src$core$renderers$zelos$constants;
    module$build$src$core$renderers$zelos$zelos.Drawer = Drawer$$module$build$src$core$renderers$zelos$drawer;
    module$build$src$core$renderers$zelos$zelos.MarkerSvg = MarkerSvg$$module$build$src$core$renderers$zelos$marker_svg;
    module$build$src$core$renderers$zelos$zelos.PathObject = PathObject$$module$build$src$core$renderers$zelos$path_object;
    module$build$src$core$renderers$zelos$zelos.RenderInfo = RenderInfo$$module$build$src$core$renderers$zelos$info;
    module$build$src$core$renderers$zelos$zelos.Renderer = Renderer$$module$build$src$core$renderers$zelos$renderer;
    module$build$src$core$renderers$zelos$zelos.RightConnectionShape = RightConnectionShape$$module$build$src$core$renderers$zelos$measurables$row_elements;
    module$build$src$core$renderers$zelos$zelos.StatementInput = StatementInput$$module$build$src$core$renderers$zelos$measurables$inputs;
    module$build$src$core$renderers$zelos$zelos.TopRow = TopRow$$module$build$src$core$renderers$zelos$measurables$top_row;
    var ProcedureSerializer$$module$build$src$core$serialization$procedures = class {
        constructor(a, b){
            this.procedureModelClass = a;
            this.parameterModelClass = b;
            this.priority = PROCEDURES$$module$build$src$core$serialization$priorities;
        }
        save(a) {
            a = a.getProcedureMap().getProcedures().map((b)=>saveProcedure$$module$build$src$core$serialization$procedures(b));
            return a.length ? a : null;
        }
        load(a, b) {
            const c = b.getProcedureMap();
            for (const d of a)c.add(loadProcedure$$module$build$src$core$serialization$procedures(this.procedureModelClass, this.parameterModelClass, d, b));
        }
        clear(a) {
            a.getProcedureMap().clear();
        }
    }, module$build$src$core$serialization$procedures = {};
    module$build$src$core$serialization$procedures.ProcedureSerializer = ProcedureSerializer$$module$build$src$core$serialization$procedures;
    module$build$src$core$serialization$procedures.loadParameter = loadParameter$$module$build$src$core$serialization$procedures;
    module$build$src$core$serialization$procedures.loadProcedure = loadProcedure$$module$build$src$core$serialization$procedures;
    module$build$src$core$serialization$procedures.saveParameter = saveParameter$$module$build$src$core$serialization$procedures;
    module$build$src$core$serialization$procedures.saveProcedure = saveProcedure$$module$build$src$core$serialization$procedures;
    var VariableSerializer$$module$build$src$core$serialization$variables = class {
        constructor(){
            this.priority = VARIABLES$$module$build$src$core$serialization$priorities;
        }
        save(a) {
            const b = [];
            for (const c of a.getAllVariables())a = {
                name: c.name,
                id: c.getId()
            }, c.type && (a.type = c.type), b.push(a);
            return b.length ? b : null;
        }
        load(a, b) {
            for (const c of a)b.createVariable(c.name, c.type, c.id);
        }
        clear(a) {
            a.getVariableMap().clear();
        }
    };
    register$$module$build$src$core$serialization$registry("variables", new VariableSerializer$$module$build$src$core$serialization$variables);
    var module$build$src$core$serialization$variables = {};
    module$build$src$core$serialization$variables.VariableSerializer = VariableSerializer$$module$build$src$core$serialization$variables;
    var module$build$src$core$serialization$workspaces = {};
    module$build$src$core$serialization$workspaces.load = load$$module$build$src$core$serialization$workspaces;
    module$build$src$core$serialization$workspaces.save = save$$module$build$src$core$serialization$workspaces;
    var module$build$src$core$serialization = {
        blocks: module$build$src$core$serialization$blocks,
        exceptions: module$build$src$core$serialization$exceptions,
        priorities: module$build$src$core$serialization$priorities,
        procedures: module$build$src$core$serialization$procedures,
        registry: module$build$src$core$serialization$registry,
        variables: module$build$src$core$serialization$variables,
        workspaces: module$build$src$core$serialization$workspaces
    };
    var KeyCodes$$module$build$src$core$utils$keycodes;
    (function(a) {
        a[a.WIN_KEY_FF_LINUX = 0] = "WIN_KEY_FF_LINUX";
        a[a.MAC_ENTER = 3] = "MAC_ENTER";
        a[a.BACKSPACE = 8] = "BACKSPACE";
        a[a.TAB = 9] = "TAB";
        a[a.NUM_CENTER = 12] = "NUM_CENTER";
        a[a.ENTER = 13] = "ENTER";
        a[a.SHIFT = 16] = "SHIFT";
        a[a.CTRL = 17] = "CTRL";
        a[a.ALT = 18] = "ALT";
        a[a.PAUSE = 19] = "PAUSE";
        a[a.CAPS_LOCK = 20] = "CAPS_LOCK";
        a[a.ESC = 27] = "ESC";
        a[a.SPACE = 32] = "SPACE";
        a[a.PAGE_UP = 33] = "PAGE_UP";
        a[a.PAGE_DOWN = 34] = "PAGE_DOWN";
        a[a.END = 35] = "END";
        a[a.HOME = 36] = "HOME";
        a[a.LEFT = 37] = "LEFT";
        a[a.UP = 38] = "UP";
        a[a.RIGHT = 39] = "RIGHT";
        a[a.DOWN = 40] = "DOWN";
        a[a.PLUS_SIGN = 43] = "PLUS_SIGN";
        a[a.PRINT_SCREEN = 44] = "PRINT_SCREEN";
        a[a.INSERT = 45] = "INSERT";
        a[a.DELETE = 46] = "DELETE";
        a[a.ZERO = 48] = "ZERO";
        a[a.ONE = 49] = "ONE";
        a[a.TWO = 50] = "TWO";
        a[a.THREE = 51] = "THREE";
        a[a.FOUR = 52] = "FOUR";
        a[a.FIVE = 53] = "FIVE";
        a[a.SIX = 54] = "SIX";
        a[a.SEVEN = 55] = "SEVEN";
        a[a.EIGHT = 56] = "EIGHT";
        a[a.NINE = 57] = "NINE";
        a[a.FF_SEMICOLON = 59] = "FF_SEMICOLON";
        a[a.FF_EQUALS = 61] = "FF_EQUALS";
        a[a.FF_DASH = 173] = "FF_DASH";
        a[a.FF_HASH = 163] = "FF_HASH";
        a[a.QUESTION_MARK = 63] = "QUESTION_MARK";
        a[a.AT_SIGN = 64] = "AT_SIGN";
        a[a.A = 65] = "A";
        a[a.B = 66] = "B";
        a[a.C = 67] = "C";
        a[a.D = 68] = "D";
        a[a.E = 69] = "E";
        a[a.F = 70] = "F";
        a[a.G = 71] = "G";
        a[a.H = 72] = "H";
        a[a.I = 73] = "I";
        a[a.J = 74] = "J";
        a[a.K = 75] = "K";
        a[a.L = 76] = "L";
        a[a.M = 77] = "M";
        a[a.N = 78] = "N";
        a[a.O = 79] = "O";
        a[a.P = 80] = "P";
        a[a.Q = 81] = "Q";
        a[a.R = 82] = "R";
        a[a.S = 83] = "S";
        a[a.T = 84] = "T";
        a[a.U = 85] = "U";
        a[a.V = 86] = "V";
        a[a.W = 87] = "W";
        a[a.X = 88] = "X";
        a[a.Y = 89] = "Y";
        a[a.Z = 90] = "Z";
        a[a.META = 91] = "META";
        a[a.WIN_KEY_RIGHT = 92] = "WIN_KEY_RIGHT";
        a[a.CONTEXT_MENU = 93] = "CONTEXT_MENU";
        a[a.NUM_ZERO = 96] = "NUM_ZERO";
        a[a.NUM_ONE = 97] = "NUM_ONE";
        a[a.NUM_TWO = 98] = "NUM_TWO";
        a[a.NUM_THREE = 99] = "NUM_THREE";
        a[a.NUM_FOUR = 100] = "NUM_FOUR";
        a[a.NUM_FIVE = 101] = "NUM_FIVE";
        a[a.NUM_SIX = 102] = "NUM_SIX";
        a[a.NUM_SEVEN = 103] = "NUM_SEVEN";
        a[a.NUM_EIGHT = 104] = "NUM_EIGHT";
        a[a.NUM_NINE = 105] = "NUM_NINE";
        a[a.NUM_MULTIPLY = 106] = "NUM_MULTIPLY";
        a[a.NUM_PLUS = 107] = "NUM_PLUS";
        a[a.NUM_MINUS = 109] = "NUM_MINUS";
        a[a.NUM_PERIOD = 110] = "NUM_PERIOD";
        a[a.NUM_DIVISION = 111] = "NUM_DIVISION";
        a[a.F1 = 112] = "F1";
        a[a.F2 = 113] = "F2";
        a[a.F3 = 114] = "F3";
        a[a.F4 = 115] = "F4";
        a[a.F5 = 116] = "F5";
        a[a.F6 = 117] = "F6";
        a[a.F7 = 118] = "F7";
        a[a.F8 = 119] = "F8";
        a[a.F9 = 120] = "F9";
        a[a.F10 = 121] = "F10";
        a[a.F11 = 122] = "F11";
        a[a.F12 = 123] = "F12";
        a[a.NUMLOCK = 144] = "NUMLOCK";
        a[a.SCROLL_LOCK = 145] = "SCROLL_LOCK";
        a[a.FIRST_MEDIA_KEY = 166] = "FIRST_MEDIA_KEY";
        a[a.LAST_MEDIA_KEY = 183] = "LAST_MEDIA_KEY";
        a[a.SEMICOLON = 186] = "SEMICOLON";
        a[a.DASH = 189] = "DASH";
        a[a.EQUALS = 187] = "EQUALS";
        a[a.COMMA = 188] = "COMMA";
        a[a.PERIOD = 190] = "PERIOD";
        a[a.SLASH = 191] = "SLASH";
        a[a.APOSTROPHE = 192] = "APOSTROPHE";
        a[a.TILDE = 192] = "TILDE";
        a[a.SINGLE_QUOTE = 222] = "SINGLE_QUOTE";
        a[a.OPEN_SQUARE_BRACKET = 219] = "OPEN_SQUARE_BRACKET";
        a[a.BACKSLASH = 220] = "BACKSLASH";
        a[a.CLOSE_SQUARE_BRACKET = 221] = "CLOSE_SQUARE_BRACKET";
        a[a.WIN_KEY = 224] = "WIN_KEY";
        a[a.MAC_FF_META = 224] = "MAC_FF_META";
        a[a.MAC_WK_CMD_LEFT = 91] = "MAC_WK_CMD_LEFT";
        a[a.MAC_WK_CMD_RIGHT = 93] = "MAC_WK_CMD_RIGHT";
        a[a.WIN_IME = 229] = "WIN_IME";
        a[a.VK_NONAME = 252] = "VK_NONAME";
        a[a.PHANTOM = 255] = "PHANTOM";
    })(KeyCodes$$module$build$src$core$utils$keycodes || (KeyCodes$$module$build$src$core$utils$keycodes = {}));
    var module$build$src$core$utils$keycodes = {};
    module$build$src$core$utils$keycodes.KeyCodes = KeyCodes$$module$build$src$core$utils$keycodes;
    var names$$module$build$src$core$shortcut_items;
    (function(a) {
        a.ESCAPE = "escape";
        a.DELETE = "delete";
        a.COPY = "copy";
        a.CUT = "cut";
        a.PASTE = "paste";
        a.UNDO = "undo";
        a.REDO = "redo";
    })(names$$module$build$src$core$shortcut_items || (names$$module$build$src$core$shortcut_items = {}));
    registerDefaultShortcuts$$module$build$src$core$shortcut_items();
    var module$build$src$core$shortcut_items = {};
    module$build$src$core$shortcut_items.names = names$$module$build$src$core$shortcut_items;
    module$build$src$core$shortcut_items.registerCopy = registerCopy$$module$build$src$core$shortcut_items;
    module$build$src$core$shortcut_items.registerCut = registerCut$$module$build$src$core$shortcut_items;
    module$build$src$core$shortcut_items.registerDefaultShortcuts = registerDefaultShortcuts$$module$build$src$core$shortcut_items;
    module$build$src$core$shortcut_items.registerDelete = registerDelete$$module$build$src$core$shortcut_items;
    module$build$src$core$shortcut_items.registerEscape = registerEscape$$module$build$src$core$shortcut_items;
    module$build$src$core$shortcut_items.registerPaste = registerPaste$$module$build$src$core$shortcut_items;
    module$build$src$core$shortcut_items.registerRedo = registerRedo$$module$build$src$core$shortcut_items;
    module$build$src$core$shortcut_items.registerUndo = registerUndo$$module$build$src$core$shortcut_items;
    var defaultBlockStyles$$module$build$src$core$theme$zelos = {
        colour_blocks: {
            colourPrimary: "#CF63CF",
            colourSecondary: "#C94FC9",
            colourTertiary: "#BD42BD"
        },
        list_blocks: {
            colourPrimary: "#9966FF",
            colourSecondary: "#855CD6",
            colourTertiary: "#774DCB"
        },
        logic_blocks: {
            colourPrimary: "#4C97FF",
            colourSecondary: "#4280D7",
            colourTertiary: "#3373CC"
        },
        loop_blocks: {
            colourPrimary: "#0fBD8C",
            colourSecondary: "#0DA57A",
            colourTertiary: "#0B8E69"
        },
        math_blocks: {
            colourPrimary: "#59C059",
            colourSecondary: "#46B946",
            colourTertiary: "#389438"
        },
        procedure_blocks: {
            colourPrimary: "#FF6680",
            colourSecondary: "#FF4D6A",
            colourTertiary: "#FF3355"
        },
        text_blocks: {
            colourPrimary: "#FFBF00",
            colourSecondary: "#E6AC00",
            colourTertiary: "#CC9900"
        },
        variable_blocks: {
            colourPrimary: "#FF8C1A",
            colourSecondary: "#FF8000",
            colourTertiary: "#DB6E00"
        },
        variable_dynamic_blocks: {
            colourPrimary: "#FF8C1A",
            colourSecondary: "#FF8000",
            colourTertiary: "#DB6E00"
        },
        hat_blocks: {
            colourPrimary: "#4C97FF",
            colourSecondary: "#4280D7",
            colourTertiary: "#3373CC",
            hat: "cap"
        }
    }, categoryStyles$$module$build$src$core$theme$zelos = {
        colour_category: {
            colour: "#CF63CF"
        },
        list_category: {
            colour: "#9966FF"
        },
        logic_category: {
            colour: "#4C97FF"
        },
        loop_category: {
            colour: "#0fBD8C"
        },
        math_category: {
            colour: "#59C059"
        },
        procedure_category: {
            colour: "#FF6680"
        },
        text_category: {
            colour: "#FFBF00"
        },
        variable_category: {
            colour: "#FF8C1A"
        },
        variable_dynamic_category: {
            colour: "#FF8C1A"
        }
    }, Zelos$$module$build$src$core$theme$zelos = new Theme$$module$build$src$core$theme("zelos", defaultBlockStyles$$module$build$src$core$theme$zelos, categoryStyles$$module$build$src$core$theme$zelos), module$build$src$core$theme$zelos = {};
    module$build$src$core$theme$zelos.Zelos = Zelos$$module$build$src$core$theme$zelos;
    var module$build$src$core$theme$themes = {};
    module$build$src$core$theme$themes.Classic = Classic$$module$build$src$core$theme$classic;
    module$build$src$core$theme$themes.Zelos = Zelos$$module$build$src$core$theme$zelos;
    var ToolboxItem$$module$build$src$core$toolbox$toolbox_item = class {
        constructor(a, b, c){
            this.id_ = a.toolboxitemid || getNextUniqueId$$module$build$src$core$utils$idgenerator();
            this.level_ = (this.parent_ = c || null) ? this.parent_.getLevel() + 1 : 0;
            this.toolboxItemDef_ = a;
            this.parentToolbox_ = b;
            this.workspace_ = this.parentToolbox_.getWorkspace();
        }
        init() {}
        getDiv() {
            return null;
        }
        getClickTarget() {
            return null;
        }
        getId() {
            return this.id_;
        }
        getParent() {
            return null;
        }
        getLevel() {
            return this.level_;
        }
        isSelectable() {
            return !1;
        }
        isCollapsible() {
            return !1;
        }
        dispose() {}
        setVisible_(a) {}
    }, module$build$src$core$toolbox$toolbox_item = {};
    module$build$src$core$toolbox$toolbox_item.ToolboxItem = ToolboxItem$$module$build$src$core$toolbox$toolbox_item;
    var ToolboxCategory$$module$build$src$core$toolbox$category = class extends ToolboxItem$$module$build$src$core$toolbox$toolbox_item {
        constructor(a, b, c){
            super(a, b, c);
            this.colour_ = this.name_ = "";
            this.labelDom_ = this.iconDom_ = this.rowContents_ = this.rowDiv_ = this.htmlDiv_ = null;
            this.isDisabled_ = this.isHidden_ = !1;
            this.flyoutItems_ = [];
            this.cssConfig_ = this.makeDefaultCssConfig_();
        }
        init() {
            this.parseCategoryDef_(this.toolboxItemDef_);
            this.parseContents_(this.toolboxItemDef_);
            this.createDom_();
            "true" === this.toolboxItemDef_.hidden && this.hide();
        }
        makeDefaultCssConfig_() {
            return {
                container: "blocklyToolboxCategory",
                row: "blocklyTreeRow",
                rowcontentcontainer: "blocklyTreeRowContentContainer",
                icon: "blocklyTreeIcon",
                label: "blocklyTreeLabel",
                contents: "blocklyToolboxContents",
                selected: "blocklyTreeSelected",
                openicon: "blocklyTreeIconOpen",
                closedicon: "blocklyTreeIconClosed"
            };
        }
        parseContents_(a) {
            if ("custom" in a) this.flyoutItems_ = a.custom;
            else if (a = a.contents) for(let b = 0; b < a.length; b++){
                const c = a[b];
                Array.isArray(this.flyoutItems_) && this.flyoutItems_.push(c);
            }
        }
        parseCategoryDef_(a) {
            this.name_ = "name" in a ? replaceMessageReferences$$module$build$src$core$utils$parsing(a.name) : "";
            this.colour_ = this.getColour_(a);
            Object.assign(this.cssConfig_, a.cssconfig || a.cssConfig);
        }
        createDom_() {
            this.htmlDiv_ = this.createContainer_();
            setRole$$module$build$src$core$utils$aria(this.htmlDiv_, Role$$module$build$src$core$utils$aria.TREEITEM);
            setState$$module$build$src$core$utils$aria(this.htmlDiv_, State$$module$build$src$core$utils$aria.SELECTED, !1);
            setState$$module$build$src$core$utils$aria(this.htmlDiv_, State$$module$build$src$core$utils$aria.LEVEL, this.level_);
            this.rowDiv_ = this.createRowContainer_();
            this.rowDiv_.style.pointerEvents = "auto";
            this.htmlDiv_.appendChild(this.rowDiv_);
            this.rowContents_ = this.createRowContentsContainer_();
            this.rowContents_.style.pointerEvents = "none";
            this.rowDiv_.appendChild(this.rowContents_);
            this.iconDom_ = this.createIconDom_();
            setRole$$module$build$src$core$utils$aria(this.iconDom_, Role$$module$build$src$core$utils$aria.PRESENTATION);
            this.rowContents_.appendChild(this.iconDom_);
            this.labelDom_ = this.createLabelDom_(this.name_);
            this.rowContents_.appendChild(this.labelDom_);
            const a = this.labelDom_.getAttribute("id");
            a && setState$$module$build$src$core$utils$aria(this.htmlDiv_, State$$module$build$src$core$utils$aria.LABELLEDBY, a);
            this.addColourBorder_(this.colour_);
            return this.htmlDiv_;
        }
        createContainer_() {
            const a = document.createElement("div"), b = this.cssConfig_.container;
            b && addClass$$module$build$src$core$utils$dom(a, b);
            return a;
        }
        createRowContainer_() {
            const a = document.createElement("div");
            var b = this.cssConfig_.row;
            b && addClass$$module$build$src$core$utils$dom(a, b);
            b = `${ToolboxCategory$$module$build$src$core$toolbox$category.nestedPadding * this.getLevel()}px`;
            this.workspace_.RTL ? a.style.paddingRight = b : a.style.paddingLeft = b;
            return a;
        }
        createRowContentsContainer_() {
            const a = document.createElement("div"), b = this.cssConfig_.rowcontentcontainer;
            b && addClass$$module$build$src$core$utils$dom(a, b);
            return a;
        }
        createIconDom_() {
            const a = document.createElement("span");
            if (!this.parentToolbox_.isHorizontal()) {
                const b = this.cssConfig_.icon;
                b && addClass$$module$build$src$core$utils$dom(a, b);
            }
            a.style.display = "inline-block";
            return a;
        }
        createLabelDom_(a) {
            const b = document.createElement("span");
            b.setAttribute("id", this.getId() + ".label");
            b.textContent = a;
            (a = this.cssConfig_.label) && addClass$$module$build$src$core$utils$dom(b, a);
            return b;
        }
        refreshTheme() {
            this.colour_ = this.getColour_(this.toolboxItemDef_);
            this.addColourBorder_(this.colour_);
        }
        addColourBorder_(a) {
            a && (a = ToolboxCategory$$module$build$src$core$toolbox$category.borderWidth + "px solid " + (a || "#ddd"), this.workspace_.RTL ? this.rowDiv_.style.borderRight = a : this.rowDiv_.style.borderLeft = a);
        }
        getColour_(a) {
            const b = a.categorystyle || a.categoryStyle;
            if ((a = a.colour) && b) console.warn('Toolbox category "' + this.name_ + '" must not have both a style and a colour');
            else {
                if (b) return this.getColourfromStyle_(b);
                if (a) return this.parseColour_(a);
            }
            return "";
        }
        getColourfromStyle_(a) {
            var b = this.workspace_.getTheme();
            if (a && b) {
                if ((b = b.categoryStyles[a]) && b.colour) return this.parseColour_(b.colour);
                console.warn('Style "' + a + '" must exist and contain a colour value');
            }
            return "";
        }
        getClickTarget() {
            return this.rowDiv_;
        }
        parseColour_(a) {
            a = replaceMessageReferences$$module$build$src$core$utils$parsing(a);
            if (null == a || "" === a) return "";
            var b = Number(a);
            if (isNaN(b)) {
                if (b = parse$$module$build$src$core$utils$colour(a)) return b;
                console.warn('Toolbox category "' + this.name_ + '" has unrecognized colour attribute: ' + a);
                return "";
            }
            return hueToHex$$module$build$src$core$utils$colour(b);
        }
        openIcon_(a) {
            if (a) {
                var b = this.cssConfig_.closedicon;
                b && removeClasses$$module$build$src$core$utils$dom(a, b);
                (b = this.cssConfig_.openicon) && addClass$$module$build$src$core$utils$dom(a, b);
            }
        }
        closeIcon_(a) {
            if (a) {
                var b = this.cssConfig_.openicon;
                b && removeClasses$$module$build$src$core$utils$dom(a, b);
                (b = this.cssConfig_.closedicon) && addClass$$module$build$src$core$utils$dom(a, b);
            }
        }
        setVisible_(a) {
            this.htmlDiv_.style.display = a ? "block" : "none";
            this.isHidden_ = !a;
            this.parentToolbox_.getSelectedItem() === this && this.parentToolbox_.clearSelection();
        }
        hide() {
            this.setVisible_(!1);
        }
        show() {
            this.setVisible_(!0);
        }
        isVisible() {
            return !this.isHidden_ && this.allAncestorsExpanded_();
        }
        allAncestorsExpanded_() {
            let a = this;
            for(; a.getParent();)if (a = a.getParent(), !a.isExpanded()) return !1;
            return !0;
        }
        isSelectable() {
            return this.isVisible() && !this.isDisabled_;
        }
        onClick(a) {}
        setSelected(a) {
            if (this.rowDiv_) {
                var b = this.cssConfig_.selected;
                if (a) {
                    const c = this.parseColour_(ToolboxCategory$$module$build$src$core$toolbox$category.defaultBackgroundColour);
                    this.rowDiv_.style.backgroundColor = this.colour_ || c;
                    b && addClass$$module$build$src$core$utils$dom(this.rowDiv_, b);
                } else this.rowDiv_.style.backgroundColor = "", b && removeClass$$module$build$src$core$utils$dom(this.rowDiv_, b);
                setState$$module$build$src$core$utils$aria(this.htmlDiv_, State$$module$build$src$core$utils$aria.SELECTED, a);
            }
        }
        setDisabled(a) {
            this.isDisabled_ = a;
            this.getDiv().setAttribute("disabled", `${a}`);
            a ? this.getDiv().setAttribute("disabled", "true") : this.getDiv().removeAttribute("disabled");
        }
        getName() {
            return this.name_;
        }
        getParent() {
            return this.parent_;
        }
        getDiv() {
            return this.htmlDiv_;
        }
        getContents() {
            return this.flyoutItems_;
        }
        updateFlyoutContents(a) {
            this.flyoutItems_ = [];
            this.toolboxItemDef_ = "string" === typeof a ? {
                kind: this.toolboxItemDef_.kind,
                custom: a,
                id: this.toolboxItemDef_.id,
                categorystyle: this.toolboxItemDef_.categorystyle,
                colour: this.toolboxItemDef_.colour,
                cssconfig: this.toolboxItemDef_.cssconfig,
                hidden: this.toolboxItemDef_.hidden
            } : {
                kind: this.toolboxItemDef_.kind,
                name: "name" in this.toolboxItemDef_ ? this.toolboxItemDef_.name : "",
                contents: convertFlyoutDefToJsonArray$$module$build$src$core$utils$toolbox(a),
                id: this.toolboxItemDef_.id,
                categorystyle: this.toolboxItemDef_.categorystyle,
                colour: this.toolboxItemDef_.colour,
                cssconfig: this.toolboxItemDef_.cssconfig,
                hidden: this.toolboxItemDef_.hidden
            };
            this.parseContents_(this.toolboxItemDef_);
        }
        dispose() {
            removeNode$$module$build$src$core$utils$dom(this.htmlDiv_);
        }
    };
    ToolboxCategory$$module$build$src$core$toolbox$category.registrationName = "category";
    ToolboxCategory$$module$build$src$core$toolbox$category.nestedPadding = 19;
    ToolboxCategory$$module$build$src$core$toolbox$category.borderWidth = 8;
    ToolboxCategory$$module$build$src$core$toolbox$category.defaultBackgroundColour = "#57e";
    register$$module$build$src$core$css('\n.blocklyTreeRow:not(.blocklyTreeSelected):hover {\n  background-color: rgba(255, 255, 255, .2);\n}\n\n.blocklyToolboxDiv[layout="h"] .blocklyToolboxCategory {\n  margin: 1px 5px 1px 0;\n}\n\n.blocklyToolboxDiv[dir="RTL"][layout="h"] .blocklyToolboxCategory {\n  margin: 1px 0 1px 5px;\n}\n\n.blocklyTreeRow {\n  height: 22px;\n  line-height: 22px;\n  margin-bottom: 3px;\n  padding-right: 8px;\n  white-space: nowrap;\n}\n\n.blocklyToolboxDiv[dir="RTL"] .blocklyTreeRow {\n  margin-left: 8px;\n  padding-right: 0;\n}\n\n.blocklyTreeIcon {\n  background-image: url(<<<PATH>>>/sprites.png);\n  height: 16px;\n  vertical-align: middle;\n  visibility: hidden;\n  width: 16px;\n}\n\n.blocklyTreeIconClosed {\n  background-position: -32px -1px;\n}\n\n.blocklyToolboxDiv[dir="RTL"] .blocklyTreeIconClosed {\n  background-position: 0 -1px;\n}\n\n.blocklyTreeSelected>.blocklyTreeIconClosed {\n  background-position: -32px -17px;\n}\n\n.blocklyToolboxDiv[dir="RTL"] .blocklyTreeSelected>.blocklyTreeIconClosed {\n  background-position: 0 -17px;\n}\n\n.blocklyTreeIconOpen {\n  background-position: -16px -1px;\n}\n\n.blocklyTreeSelected>.blocklyTreeIconOpen {\n  background-position: -16px -17px;\n}\n\n.blocklyTreeLabel {\n  cursor: default;\n  font: 16px sans-serif;\n  padding: 0 3px;\n  vertical-align: middle;\n}\n\n.blocklyToolboxDelete .blocklyTreeLabel {\n  cursor: url("<<<PATH>>>/handdelete.cur"), auto;\n}\n\n.blocklyTreeSelected .blocklyTreeLabel {\n  color: #fff;\n}\n');
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.TOOLBOX_ITEM, ToolboxCategory$$module$build$src$core$toolbox$category.registrationName, ToolboxCategory$$module$build$src$core$toolbox$category);
    var module$build$src$core$toolbox$category = {};
    module$build$src$core$toolbox$category.ToolboxCategory = ToolboxCategory$$module$build$src$core$toolbox$category;
    var ToolboxSeparator$$module$build$src$core$toolbox$separator = class extends ToolboxItem$$module$build$src$core$toolbox$toolbox_item {
        constructor(a, b){
            super(a, b);
            this.cssConfig_ = {
                container: "blocklyTreeSeparator"
            };
            this.htmlDiv_ = null;
            Object.assign(this.cssConfig_, a.cssconfig || a.cssConfig);
        }
        init() {
            this.createDom_();
        }
        createDom_() {
            const a = document.createElement("div"), b = this.cssConfig_.container;
            b && addClass$$module$build$src$core$utils$dom(a, b);
            return this.htmlDiv_ = a;
        }
        getDiv() {
            return this.htmlDiv_;
        }
        dispose() {
            removeNode$$module$build$src$core$utils$dom(this.htmlDiv_);
        }
    };
    ToolboxSeparator$$module$build$src$core$toolbox$separator.registrationName = "sep";
    register$$module$build$src$core$css('\n.blocklyTreeSeparator {\n  border-bottom: solid #e5e5e5 1px;\n  height: 0;\n  margin: 5px 0;\n}\n\n.blocklyToolboxDiv[layout="h"] .blocklyTreeSeparator {\n  border-right: solid #e5e5e5 1px;\n  border-bottom: none;\n  height: auto;\n  margin: 0 5px 0 5px;\n  padding: 5px 0;\n  width: 0;\n}\n');
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.TOOLBOX_ITEM, ToolboxSeparator$$module$build$src$core$toolbox$separator.registrationName, ToolboxSeparator$$module$build$src$core$toolbox$separator);
    var module$build$src$core$toolbox$separator = {};
    module$build$src$core$toolbox$separator.ToolboxSeparator = ToolboxSeparator$$module$build$src$core$toolbox$separator;
    var CollapsibleToolboxCategory$$module$build$src$core$toolbox$collapsible_category = class extends ToolboxCategory$$module$build$src$core$toolbox$category {
        constructor(a, b, c){
            super(a, b, c);
            this.subcategoriesDiv_ = null;
            this.expanded_ = !1;
            this.toolboxItems_ = [];
        }
        makeDefaultCssConfig_() {
            const a = super.makeDefaultCssConfig_();
            a.contents = "blocklyToolboxContents";
            return a;
        }
        parseContents_(a) {
            if ("custom" in a) this.flyoutItems_ = a.custom;
            else {
                const b = a.contents;
                if (b) {
                    this.flyoutItems_ = [];
                    a = !0;
                    for(let c = 0; c < b.length; c++){
                        const d = b[c];
                        !hasItem$$module$build$src$core$registry(Type$$module$build$src$core$registry.TOOLBOX_ITEM, d.kind) || d.kind.toLowerCase() === ToolboxSeparator$$module$build$src$core$toolbox$separator.registrationName && a ? (this.flyoutItems_.push(d), a = !0) : (this.createToolboxItem_(d), a = !1);
                    }
                }
            }
        }
        createToolboxItem_(a) {
            let b = a.kind;
            "CATEGORY" === b.toUpperCase() && isCategoryCollapsible$$module$build$src$core$utils$toolbox(a) && (b = CollapsibleToolboxCategory$$module$build$src$core$toolbox$collapsible_category.registrationName);
            a = new (getClass$$module$build$src$core$registry(Type$$module$build$src$core$registry.TOOLBOX_ITEM, b))(a, this.parentToolbox_, this);
            this.toolboxItems_.push(a);
        }
        init() {
            super.init();
            this.setExpanded("true" === this.toolboxItemDef_.expanded || !!this.toolboxItemDef_.expanded);
        }
        createDom_() {
            super.createDom_();
            const a = this.getChildToolboxItems();
            this.subcategoriesDiv_ = this.createSubCategoriesDom_(a);
            setRole$$module$build$src$core$utils$aria(this.subcategoriesDiv_, Role$$module$build$src$core$utils$aria.GROUP);
            this.htmlDiv_.appendChild(this.subcategoriesDiv_);
            return this.htmlDiv_;
        }
        createIconDom_() {
            const a = document.createElement("span");
            if (!this.parentToolbox_.isHorizontal()) {
                const b = this.cssConfig_.icon;
                b && addClass$$module$build$src$core$utils$dom(a, b);
                a.style.visibility = "visible";
            }
            a.style.display = "inline-block";
            return a;
        }
        createSubCategoriesDom_(a) {
            const b = document.createElement("div");
            var c = this.cssConfig_.contents;
            c && addClass$$module$build$src$core$utils$dom(b, c);
            for(c = 0; c < a.length; c++){
                const d = a[c];
                d.init();
                const e = d.getDiv();
                b.appendChild(e);
                if (d.getClickTarget) {
                    let f;
                    null == (f = d.getClickTarget()) || f.setAttribute("id", d.getId());
                }
            }
            return b;
        }
        setExpanded(a) {
            this.expanded_ !== a && ((this.expanded_ = a) ? (this.subcategoriesDiv_.style.display = "block", this.openIcon_(this.iconDom_)) : (this.subcategoriesDiv_.style.display = "none", this.closeIcon_(this.iconDom_)), setState$$module$build$src$core$utils$aria(this.htmlDiv_, State$$module$build$src$core$utils$aria.EXPANDED, a), this.parentToolbox_.handleToolboxItemResize());
        }
        setVisible_(a) {
            this.htmlDiv_.style.display = a ? "block" : "none";
            const b = this.getChildToolboxItems();
            for(let c = 0; c < b.length; c++)b[c].setVisible_(a);
            this.isHidden_ = !a;
            this.parentToolbox_.getSelectedItem() === this && this.parentToolbox_.clearSelection();
        }
        isExpanded() {
            return this.expanded_;
        }
        isCollapsible() {
            return !0;
        }
        onClick(a) {
            this.toggleExpanded();
        }
        toggleExpanded() {
            this.setExpanded(!this.expanded_);
        }
        getDiv() {
            return this.htmlDiv_;
        }
        getChildToolboxItems() {
            return this.toolboxItems_;
        }
    };
    CollapsibleToolboxCategory$$module$build$src$core$toolbox$collapsible_category.registrationName = "collapsibleCategory";
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.TOOLBOX_ITEM, CollapsibleToolboxCategory$$module$build$src$core$toolbox$collapsible_category.registrationName, CollapsibleToolboxCategory$$module$build$src$core$toolbox$collapsible_category);
    var module$build$src$core$toolbox$collapsible_category = {};
    module$build$src$core$toolbox$collapsible_category.CollapsibleToolboxCategory = CollapsibleToolboxCategory$$module$build$src$core$toolbox$collapsible_category;
    var module$build$src$core$interfaces$i_selectable_toolbox_item = {};
    module$build$src$core$interfaces$i_selectable_toolbox_item.isSelectableToolboxItem = isSelectableToolboxItem$$module$build$src$core$interfaces$i_selectable_toolbox_item;
    var Toolbox$$module$build$src$core$toolbox$toolbox = class extends DeleteArea$$module$build$src$core$delete_area {
        constructor(a){
            super();
            this.id = "toolbox";
            this.contentsDiv_ = this.HtmlDiv = null;
            this.isVisible_ = !1;
            this.contents_ = [];
            this.height_ = this.width_ = 0;
            this.previouslySelectedItem_ = this.selectedItem_ = this.flyout_ = null;
            this.boundEvents_ = [];
            this.workspace_ = a;
            this.toolboxDef_ = a.options.languageTree || {
                contents: []
            };
            this.horizontalLayout_ = a.options.horizontalLayout;
            this.RTL = a.options.RTL;
            this.contentMap_ = Object.create(null);
            this.toolboxPosition = a.options.toolboxPosition;
        }
        onShortcut(a) {
            return !1;
        }
        init() {
            var a = this.workspace_;
            const b = a.getParentSvg();
            this.flyout_ = this.createFlyout_();
            this.HtmlDiv = this.createDom_(this.workspace_);
            insertAfter$$module$build$src$core$utils$dom(this.flyout_.createDom("svg"), b);
            this.setVisible(!0);
            this.flyout_.init(a);
            this.render(this.toolboxDef_);
            a = a.getThemeManager();
            a.subscribe(this.HtmlDiv, "toolboxBackgroundColour", "background-color");
            a.subscribe(this.HtmlDiv, "toolboxForegroundColour", "color");
            this.workspace_.getComponentManager().addComponent({
                component: this,
                weight: 1,
                capabilities: [
                    ComponentManager$$module$build$src$core$component_manager.Capability.AUTOHIDEABLE,
                    ComponentManager$$module$build$src$core$component_manager.Capability.DELETE_AREA,
                    ComponentManager$$module$build$src$core$component_manager.Capability.DRAG_TARGET
                ]
            });
        }
        createDom_(a) {
            a = a.getParentSvg();
            const b = this.createContainer_();
            this.contentsDiv_ = this.createContentsContainer_();
            this.contentsDiv_.tabIndex = 0;
            setRole$$module$build$src$core$utils$aria(this.contentsDiv_, Role$$module$build$src$core$utils$aria.TREE);
            b.appendChild(this.contentsDiv_);
            a.parentNode.insertBefore(b, a);
            this.attachEvents_(b, this.contentsDiv_);
            return b;
        }
        createContainer_() {
            const a = document.createElement("div");
            a.setAttribute("layout", this.isHorizontal() ? "h" : "v");
            addClass$$module$build$src$core$utils$dom(a, "blocklyToolboxDiv");
            addClass$$module$build$src$core$utils$dom(a, "blocklyNonSelectable");
            a.setAttribute("dir", this.RTL ? "RTL" : "LTR");
            return a;
        }
        createContentsContainer_() {
            const a = document.createElement("div");
            addClass$$module$build$src$core$utils$dom(a, "blocklyToolboxContents");
            this.isHorizontal() && (a.style.flexDirection = "row");
            return a;
        }
        attachEvents_(a, b) {
            a = conditionalBind$$module$build$src$core$browser_events(a, "pointerdown", this, this.onClick_, !1);
            this.boundEvents_.push(a);
            b = conditionalBind$$module$build$src$core$browser_events(b, "keydown", this, this.onKeyDown_, !1);
            this.boundEvents_.push(b);
        }
        onClick_(a) {
            if (isRightButton$$module$build$src$core$browser_events(a) || a.target === this.HtmlDiv) getMainWorkspace$$module$build$src$core$common().hideChaff(!1);
            else {
                var b = a.target.getAttribute("id");
                b && (b = this.getToolboxItemById(b), b.isSelectable() && (this.setSelectedItem(b), b.onClick(a)));
                getMainWorkspace$$module$build$src$core$common().hideChaff(!0);
            }
            clearTouchIdentifier$$module$build$src$core$touch();
        }
        onKeyDown_(a) {
            let b = !1;
            switch(a.key){
                case "ArrowDown":
                    b = this.selectNext_();
                    break;
                case "ArrowUp":
                    b = this.selectPrevious_();
                    break;
                case "ArrowLeft":
                    b = this.selectParent_();
                    break;
                case "ArrowRight":
                    b = this.selectChild_();
                    break;
                case "Enter":
                case " ":
                    this.selectedItem_ && this.selectedItem_.isCollapsible() && (this.selectedItem_.toggleExpanded(), b = !0);
                    break;
                default:
                    b = !1;
            }
            !b && this.selectedItem_ && this.selectedItem_.onKeyDown && (b = this.selectedItem_.onKeyDown(a));
            b && a.preventDefault();
        }
        createFlyout_() {
            const a = this.workspace_, b = new Options$$module$build$src$core$options({
                parentWorkspace: a,
                rtl: a.RTL,
                oneBasedIndex: a.options.oneBasedIndex,
                horizontalLayout: a.horizontalLayout,
                renderer: a.options.renderer,
                rendererOverrides: a.options.rendererOverrides,
                move: {
                    scrollbars: !0
                }
            });
            b.toolboxPosition = a.options.toolboxPosition;
            return new (a.horizontalLayout ? getClassFromOptions$$module$build$src$core$registry(Type$$module$build$src$core$registry.FLYOUTS_HORIZONTAL_TOOLBOX, a.options, !0) : getClassFromOptions$$module$build$src$core$registry(Type$$module$build$src$core$registry.FLYOUTS_VERTICAL_TOOLBOX, a.options, !0))(b);
        }
        render(a) {
            this.toolboxDef_ = a;
            for(let b = 0; b < this.contents_.length; b++){
                const c = this.contents_[b];
                c && c.dispose();
            }
            this.contents_ = [];
            this.contentMap_ = Object.create(null);
            this.renderContents_(a.contents);
            this.position();
            this.handleToolboxItemResize();
        }
        renderContents_(a) {
            const b = document.createDocumentFragment();
            for(let c = 0; c < a.length; c++)this.createToolboxItem_(a[c], b);
            this.contentsDiv_.appendChild(b);
        }
        createToolboxItem_(a, b) {
            var c = a.kind;
            "CATEGORY" === c.toUpperCase() && isCategoryCollapsible$$module$build$src$core$utils$toolbox(a) && (c = CollapsibleToolboxCategory$$module$build$src$core$toolbox$collapsible_category.registrationName);
            if (c = getClass$$module$build$src$core$registry(Type$$module$build$src$core$registry.TOOLBOX_ITEM, c.toLowerCase())) a = new c(a, this), a.init(), this.addToolboxItem_(a), (c = a.getDiv()) && b.appendChild(c), a.getClickTarget() && a.getClickTarget().setAttribute("id", a.getId());
        }
        addToolboxItem_(a) {
            this.contents_.push(a);
            this.contentMap_[a.getId()] = a;
            if (a.isCollapsible()) {
                a = a.getChildToolboxItems();
                for(let b = 0; b < a.length; b++)this.addToolboxItem_(a[b]);
            }
        }
        getToolboxItems() {
            return this.contents_;
        }
        addStyle(a) {
            a && this.HtmlDiv && addClass$$module$build$src$core$utils$dom(this.HtmlDiv, a);
        }
        removeStyle(a) {
            a && this.HtmlDiv && removeClass$$module$build$src$core$utils$dom(this.HtmlDiv, a);
        }
        getClientRect() {
            if (!this.HtmlDiv || !this.isVisible_) return null;
            var a = this.HtmlDiv.getBoundingClientRect();
            const b = a.top, c = b + a.height, d = a.left;
            a = d + a.width;
            return this.toolboxPosition === Position$$module$build$src$core$utils$toolbox.TOP ? new Rect$$module$build$src$core$utils$rect(-10000000, c, -10000000, 1E7) : this.toolboxPosition === Position$$module$build$src$core$utils$toolbox.BOTTOM ? new Rect$$module$build$src$core$utils$rect(b, 1E7, -10000000, 1E7) : this.toolboxPosition === Position$$module$build$src$core$utils$toolbox.LEFT ? new Rect$$module$build$src$core$utils$rect(-10000000, 1E7, -10000000, a) : new Rect$$module$build$src$core$utils$rect(-10000000, 1E7, d, 1E7);
        }
        wouldDelete(a, b) {
            a instanceof BlockSvg$$module$build$src$core$block_svg ? this.updateWouldDelete_(!a.getParent() && a.isDeletable()) : this.updateWouldDelete_(a.isDeletable());
            return this.wouldDelete_;
        }
        onDragEnter(a) {
            this.updateCursorDeleteStyle_(!0);
        }
        onDragExit(a) {
            this.updateCursorDeleteStyle_(!1);
        }
        onDrop(a) {
            this.updateCursorDeleteStyle_(!1);
        }
        updateWouldDelete_(a) {
            a !== this.wouldDelete_ && (this.updateCursorDeleteStyle_(!1), this.wouldDelete_ = a, this.updateCursorDeleteStyle_(!0));
        }
        updateCursorDeleteStyle_(a) {
            const b = this.wouldDelete_ ? "blocklyToolboxDelete" : "blocklyToolboxGrab";
            a ? this.addStyle(b) : this.removeStyle(b);
        }
        getToolboxItemById(a) {
            return this.contentMap_[a] || null;
        }
        getWidth() {
            return this.width_;
        }
        getHeight() {
            return this.height_;
        }
        getFlyout() {
            return this.flyout_;
        }
        getWorkspace() {
            return this.workspace_;
        }
        getSelectedItem() {
            return this.selectedItem_;
        }
        getPreviouslySelectedItem() {
            return this.previouslySelectedItem_;
        }
        isHorizontal() {
            return this.horizontalLayout_;
        }
        position() {
            const a = this.workspace_.getMetrics(), b = this.HtmlDiv;
            b && (this.horizontalLayout_ ? (b.style.left = "0", b.style.height = "auto", b.style.width = "100%", this.height_ = b.offsetHeight, this.width_ = a.viewWidth, this.toolboxPosition === Position$$module$build$src$core$utils$toolbox.TOP ? b.style.top = "0" : b.style.bottom = "0") : (this.toolboxPosition === Position$$module$build$src$core$utils$toolbox.RIGHT ? b.style.right = "0" : b.style.left = "0", b.style.height = "100%", this.width_ = b.offsetWidth, this.height_ = a.viewHeight), this.flyout_.position());
        }
        handleToolboxItemResize() {
            const a = this.workspace_, b = this.HtmlDiv.getBoundingClientRect();
            a.translate(this.toolboxPosition === Position$$module$build$src$core$utils$toolbox.LEFT ? a.scrollX + b.width : a.scrollX, this.toolboxPosition === Position$$module$build$src$core$utils$toolbox.TOP ? a.scrollY + b.height : a.scrollY);
            svgResize$$module$build$src$core$common(a);
        }
        clearSelection() {
            this.setSelectedItem(null);
        }
        refreshTheme() {
            for(let a = 0; a < this.contents_.length; a++){
                const b = this.contents_[a];
                b.refreshTheme && b.refreshTheme();
            }
        }
        refreshSelection() {
            this.selectedItem_ && this.selectedItem_.isSelectable() && this.selectedItem_.getContents().length && this.flyout_.show(this.selectedItem_.getContents());
        }
        setVisible(a) {
            this.isVisible_ !== a && (this.HtmlDiv.style.display = a ? "block" : "none", this.isVisible_ = a, this.workspace_.recordDragTargets());
        }
        autoHide(a) {
            !a && this.flyout_ && this.flyout_.autoClose && this.clearSelection();
        }
        setSelectedItem(a) {
            const b = this.selectedItem_;
            !a && !b || a && !isSelectableToolboxItem$$module$build$src$core$interfaces$i_selectable_toolbox_item(a) || (this.shouldDeselectItem_(b, a) && null !== b && this.deselectItem_(b), this.shouldSelectItem_(b, a) && null !== a && this.selectItem_(b, a), this.updateFlyout_(b, a), this.fireSelectEvent_(b, a));
        }
        shouldDeselectItem_(a, b) {
            return null !== a && (!a.isCollapsible() || a !== b);
        }
        shouldSelectItem_(a, b) {
            return null !== b && b !== a;
        }
        deselectItem_(a) {
            this.selectedItem_ = null;
            this.previouslySelectedItem_ = a;
            a.setSelected(!1);
            setState$$module$build$src$core$utils$aria(this.contentsDiv_, State$$module$build$src$core$utils$aria.ACTIVEDESCENDANT, "");
        }
        selectItem_(a, b) {
            this.selectedItem_ = b;
            this.previouslySelectedItem_ = a;
            b.setSelected(!0);
            setState$$module$build$src$core$utils$aria(this.contentsDiv_, State$$module$build$src$core$utils$aria.ACTIVEDESCENDANT, b.getId());
        }
        selectItemByPosition(a) {
            -1 < a && a < this.contents_.length && (a = this.contents_[a], a.isSelectable() && this.setSelectedItem(a));
        }
        updateFlyout_(a, b) {
            b && (a !== b || b.isCollapsible()) && b.getContents().length ? (this.flyout_.show(b.getContents()), this.flyout_.scrollToStart()) : this.flyout_.hide();
        }
        fireSelectEvent_(a, b) {
            const c = a && a.getName();
            let d = b && b.getName();
            a === b && (d = null);
            a = new (get$$module$build$src$core$events$utils(TOOLBOX_ITEM_SELECT$$module$build$src$core$events$utils))(c, d, this.workspace_.id);
            fire$$module$build$src$core$events$utils(a);
        }
        selectParent_() {
            return this.selectedItem_ ? this.selectedItem_.isCollapsible() && this.selectedItem_.isExpanded() ? (this.selectedItem_.toggleExpanded(), !0) : this.selectedItem_.getParent() && this.selectedItem_.getParent().isSelectable() ? (this.setSelectedItem(this.selectedItem_.getParent()), !0) : !1 : !1;
        }
        selectChild_() {
            if (!this.selectedItem_ || !this.selectedItem_.isCollapsible()) return !1;
            const a = this.selectedItem_;
            a.isExpanded() ? this.selectNext_() : a.toggleExpanded();
            return !0;
        }
        selectNext_() {
            if (!this.selectedItem_) return !1;
            let a = this.contents_.indexOf(this.selectedItem_) + 1;
            if (-1 < a && a < this.contents_.length) {
                let b = this.contents_[a];
                for(; b && !b.isSelectable();)b = this.contents_[++a];
                if (b && b.isSelectable()) return this.setSelectedItem(b), !0;
            }
            return !1;
        }
        selectPrevious_() {
            if (!this.selectedItem_) return !1;
            let a = this.contents_.indexOf(this.selectedItem_) - 1;
            if (-1 < a && a < this.contents_.length) {
                let b = this.contents_[a];
                for(; b && !b.isSelectable();)b = this.contents_[--a];
                if (b && b.isSelectable()) return this.setSelectedItem(b), !0;
            }
            return !1;
        }
        dispose() {
            this.workspace_.getComponentManager().removeComponent("toolbox");
            this.flyout_.dispose();
            for(var a = 0; a < this.contents_.length; a++)this.contents_[a].dispose();
            for(a = 0; a < this.boundEvents_.length; a++)unbind$$module$build$src$core$browser_events(this.boundEvents_[a]);
            this.boundEvents_ = [];
            this.contents_ = [];
            this.HtmlDiv && (this.workspace_.getThemeManager().unsubscribe(this.HtmlDiv), removeNode$$module$build$src$core$utils$dom(this.HtmlDiv));
        }
    };
    register$$module$build$src$core$css('\n.blocklyToolboxDelete {\n  cursor: url("<<<PATH>>>/handdelete.cur"), auto;\n}\n\n.blocklyToolboxGrab {\n  cursor: url("<<<PATH>>>/handclosed.cur"), auto;\n  cursor: grabbing;\n  cursor: -webkit-grabbing;\n}\n\n/* Category tree in Toolbox. */\n.blocklyToolboxDiv {\n  background-color: #ddd;\n  overflow-x: visible;\n  overflow-y: auto;\n  padding: 4px 0 4px 0;\n  position: absolute;\n  z-index: 70;  /* so blocks go under toolbox when dragging */\n  -webkit-tap-highlight-color: transparent;  /* issue #1345 */\n}\n\n.blocklyToolboxContents {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n}\n\n.blocklyToolboxContents:focus {\n  outline: none;\n}\n');
    register$$module$build$src$core$registry(Type$$module$build$src$core$registry.TOOLBOX, DEFAULT$$module$build$src$core$registry, Toolbox$$module$build$src$core$toolbox$toolbox);
    var module$build$src$core$toolbox$toolbox = {};
    module$build$src$core$toolbox$toolbox.Toolbox = Toolbox$$module$build$src$core$toolbox$toolbox;
    var Trashcan$$module$build$src$core$trashcan = class extends DeleteArea$$module$build$src$core$delete_area {
        constructor(a){
            super();
            this.workspace = a;
            this.id = "trashcan";
            this.contents_ = [];
            this.flyout = null;
            this.isLidOpen = !1;
            this.minOpenness_ = 0;
            this.lidTask_ = this.svgLid_ = this.svgGroup_ = null;
            this.top_ = this.left_ = this.lidOpen_ = 0;
            this.initialized_ = !1;
            0 >= this.workspace.options.maxTrashcanContents || (a = new Options$$module$build$src$core$options({
                scrollbars: !0,
                parentWorkspace: this.workspace,
                rtl: this.workspace.RTL,
                oneBasedIndex: this.workspace.options.oneBasedIndex,
                renderer: this.workspace.options.renderer,
                rendererOverrides: this.workspace.options.rendererOverrides,
                move: {
                    scrollbars: !0
                }
            }), this.workspace.horizontalLayout ? (a.toolboxPosition = this.workspace.toolboxPosition === Position$$module$build$src$core$utils$toolbox.TOP ? Position$$module$build$src$core$utils$toolbox.BOTTOM : Position$$module$build$src$core$utils$toolbox.TOP, this.flyout = new (getClassFromOptions$$module$build$src$core$registry(Type$$module$build$src$core$registry.FLYOUTS_HORIZONTAL_TOOLBOX, this.workspace.options, !0))(a)) : (a.toolboxPosition = this.workspace.toolboxPosition === Position$$module$build$src$core$utils$toolbox.RIGHT ? Position$$module$build$src$core$utils$toolbox.LEFT : Position$$module$build$src$core$utils$toolbox.RIGHT, this.flyout = new (getClassFromOptions$$module$build$src$core$registry(Type$$module$build$src$core$registry.FLYOUTS_VERTICAL_TOOLBOX, this.workspace.options, !0))(a)), this.workspace.addChangeListener(this.onDelete_.bind(this)));
        }
        createDom() {
            this.svgGroup_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.G, {
                "class": "blocklyTrash"
            });
            let a;
            const b = String(Math.random()).substring(2);
            a = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.CLIPPATH, {
                id: "blocklyTrashBodyClipPath" + b
            }, this.svgGroup_);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                width: WIDTH$$module$build$src$core$trashcan,
                height: BODY_HEIGHT$$module$build$src$core$trashcan,
                y: LID_HEIGHT$$module$build$src$core$trashcan
            }, a);
            const c = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.IMAGE, {
                width: SPRITE$$module$build$src$core$sprites.width,
                x: -SPRITE_LEFT$$module$build$src$core$trashcan,
                height: SPRITE$$module$build$src$core$sprites.height,
                y: -SPRITE_TOP$$module$build$src$core$trashcan,
                "clip-path": "url(#blocklyTrashBodyClipPath" + b + ")"
            }, this.svgGroup_);
            c.setAttributeNS(XLINK_NS$$module$build$src$core$utils$dom, "xlink:href", this.workspace.options.pathToMedia + SPRITE$$module$build$src$core$sprites.url);
            a = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.CLIPPATH, {
                id: "blocklyTrashLidClipPath" + b
            }, this.svgGroup_);
            createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.RECT, {
                width: WIDTH$$module$build$src$core$trashcan,
                height: LID_HEIGHT$$module$build$src$core$trashcan
            }, a);
            this.svgLid_ = createSvgElement$$module$build$src$core$utils$dom(Svg$$module$build$src$core$utils$svg.IMAGE, {
                width: SPRITE$$module$build$src$core$sprites.width,
                x: -SPRITE_LEFT$$module$build$src$core$trashcan,
                height: SPRITE$$module$build$src$core$sprites.height,
                y: -SPRITE_TOP$$module$build$src$core$trashcan,
                "clip-path": "url(#blocklyTrashLidClipPath" + b + ")"
            }, this.svgGroup_);
            this.svgLid_.setAttributeNS(XLINK_NS$$module$build$src$core$utils$dom, "xlink:href", this.workspace.options.pathToMedia + SPRITE$$module$build$src$core$sprites.url);
            bind$$module$build$src$core$browser_events(this.svgGroup_, "pointerdown", this, this.blockMouseDownWhenOpenable_);
            bind$$module$build$src$core$browser_events(this.svgGroup_, "pointerup", this, this.click);
            bind$$module$build$src$core$browser_events(c, "pointerover", this, this.mouseOver_);
            bind$$module$build$src$core$browser_events(c, "pointerout", this, this.mouseOut_);
            this.animateLid_();
            return this.svgGroup_;
        }
        init() {
            0 < this.workspace.options.maxTrashcanContents && (insertAfter$$module$build$src$core$utils$dom(this.flyout.createDom(Svg$$module$build$src$core$utils$svg.SVG), this.workspace.getParentSvg()), this.flyout.init(this.workspace));
            this.workspace.getComponentManager().addComponent({
                component: this,
                weight: 1,
                capabilities: [
                    ComponentManager$$module$build$src$core$component_manager.Capability.AUTOHIDEABLE,
                    ComponentManager$$module$build$src$core$component_manager.Capability.DELETE_AREA,
                    ComponentManager$$module$build$src$core$component_manager.Capability.DRAG_TARGET,
                    ComponentManager$$module$build$src$core$component_manager.Capability.POSITIONABLE
                ]
            });
            this.initialized_ = !0;
            this.setLidOpen(!1);
        }
        dispose() {
            this.workspace.getComponentManager().removeComponent("trashcan");
            this.svgGroup_ && (removeNode$$module$build$src$core$utils$dom(this.svgGroup_), this.svgGroup_ = null);
            this.svgLid_ = null;
            this.lidTask_ && clearTimeout(this.lidTask_);
        }
        hasContents_() {
            return !!this.contents_.length;
        }
        contentsIsOpen() {
            return !!this.flyout && this.flyout.isVisible();
        }
        openFlyout() {
            if (!this.contentsIsOpen()) {
                var a = this.contents_.map(function(c) {
                    return JSON.parse(c);
                }), b = this.workspace.getParentSvg().style;
                b.cursor = "wait";
                setTimeout(()=>{
                    let c;
                    null == (c = this.flyout) || c.show(a);
                    b.cursor = "";
                }, 10);
                this.fireUiEvent_(!0);
            }
        }
        closeFlyout() {
            if (this.contentsIsOpen()) {
                var a;
                null == (a = this.flyout) || a.hide();
                this.fireUiEvent_(!1);
                this.workspace.recordDragTargets();
            }
        }
        autoHide(a) {
            !a && this.flyout && this.closeFlyout();
        }
        emptyContents() {
            this.hasContents_() && (this.contents_.length = 0, this.setMinOpenness_(0), this.closeFlyout());
        }
        position(a, b) {
            if (this.initialized_) {
                var c = getCornerOppositeToolbox$$module$build$src$core$positionable_helpers(this.workspace, a);
                a = getStartPositionRect$$module$build$src$core$positionable_helpers(c, new Size$$module$build$src$core$utils$size(WIDTH$$module$build$src$core$trashcan, BODY_HEIGHT$$module$build$src$core$trashcan + LID_HEIGHT$$module$build$src$core$trashcan), MARGIN_HORIZONTAL$$module$build$src$core$trashcan, MARGIN_VERTICAL$$module$build$src$core$trashcan, a, this.workspace);
                b = bumpPositionRect$$module$build$src$core$positionable_helpers(a, MARGIN_VERTICAL$$module$build$src$core$trashcan, c.vertical === verticalPosition$$module$build$src$core$positionable_helpers.TOP ? bumpDirection$$module$build$src$core$positionable_helpers.DOWN : bumpDirection$$module$build$src$core$positionable_helpers.UP, b);
                this.top_ = b.top;
                this.left_ = b.left;
                var d;
                null == (d = this.svgGroup_) || d.setAttribute("transform", "translate(" + this.left_ + "," + this.top_ + ")");
            }
        }
        getBoundingRectangle() {
            return new Rect$$module$build$src$core$utils$rect(this.top_, this.top_ + BODY_HEIGHT$$module$build$src$core$trashcan + LID_HEIGHT$$module$build$src$core$trashcan, this.left_, this.left_ + WIDTH$$module$build$src$core$trashcan);
        }
        getClientRect() {
            if (!this.svgGroup_) return null;
            var a = this.svgGroup_.getBoundingClientRect();
            const b = a.top + SPRITE_TOP$$module$build$src$core$trashcan - MARGIN_HOTSPOT$$module$build$src$core$trashcan;
            a = a.left + SPRITE_LEFT$$module$build$src$core$trashcan - MARGIN_HOTSPOT$$module$build$src$core$trashcan;
            return new Rect$$module$build$src$core$utils$rect(b, b + LID_HEIGHT$$module$build$src$core$trashcan + BODY_HEIGHT$$module$build$src$core$trashcan + 2 * MARGIN_HOTSPOT$$module$build$src$core$trashcan, a, a + WIDTH$$module$build$src$core$trashcan + 2 * MARGIN_HOTSPOT$$module$build$src$core$trashcan);
        }
        onDragOver(a) {
            this.setLidOpen(this.wouldDelete_);
        }
        onDragExit(a) {
            this.setLidOpen(!1);
        }
        onDrop(a) {
            setTimeout(this.setLidOpen.bind(this, !1), 100);
        }
        setLidOpen(a) {
            this.isLidOpen !== a && (this.lidTask_ && clearTimeout(this.lidTask_), this.isLidOpen = a, this.animateLid_());
        }
        animateLid_() {
            const a = ANIMATION_FRAMES$$module$build$src$core$trashcan;
            var b = 1 / (a + 1);
            this.lidOpen_ += this.isLidOpen ? b : -b;
            this.lidOpen_ = Math.min(Math.max(this.lidOpen_, this.minOpenness_), 1);
            this.setLidAngle_(this.lidOpen_ * MAX_LID_ANGLE$$module$build$src$core$trashcan);
            b = OPACITY_MIN$$module$build$src$core$trashcan + this.lidOpen_ * (OPACITY_MAX$$module$build$src$core$trashcan - OPACITY_MIN$$module$build$src$core$trashcan);
            this.svgGroup_ && (this.svgGroup_.style.opacity = `${b}`);
            this.lidOpen_ > this.minOpenness_ && 1 > this.lidOpen_ && (this.lidTask_ = setTimeout(this.animateLid_.bind(this), ANIMATION_LENGTH$$module$build$src$core$trashcan / a));
        }
        setLidAngle_(a) {
            const b = this.workspace.toolboxPosition === Position$$module$build$src$core$utils$toolbox.RIGHT || this.workspace.horizontalLayout && this.workspace.RTL;
            let c;
            null == (c = this.svgLid_) || c.setAttribute("transform", "rotate(" + (b ? -a : a) + "," + (b ? 4 : WIDTH$$module$build$src$core$trashcan - 4) + "," + (LID_HEIGHT$$module$build$src$core$trashcan - 2) + ")");
        }
        setMinOpenness_(a) {
            this.minOpenness_ = a;
            this.isLidOpen || this.setLidAngle_(a * MAX_LID_ANGLE$$module$build$src$core$trashcan);
        }
        closeLid() {
            this.setLidOpen(!1);
        }
        click() {
            this.hasContents_() && this.openFlyout();
        }
        fireUiEvent_(a) {
            a = new (get$$module$build$src$core$events$utils(TRASHCAN_OPEN$$module$build$src$core$events$utils))(a, this.workspace.id);
            fire$$module$build$src$core$events$utils(a);
        }
        blockMouseDownWhenOpenable_(a) {
            !this.contentsIsOpen() && this.hasContents_() && a.stopPropagation();
        }
        mouseOver_() {
            this.hasContents_() && this.setLidOpen(!0);
        }
        mouseOut_() {
            this.setLidOpen(!1);
        }
        onDelete_(a) {
            if (!(0 >= this.workspace.options.maxTrashcanContents || a.type !== DELETE$$module$build$src$core$events$utils || a.type !== DELETE$$module$build$src$core$events$utils || a.wasShadow)) {
                if (!a.oldJson) throw Error("Encountered a delete event without proper oldJson");
                a = JSON.stringify(this.cleanBlockJson_(a.oldJson));
                if (-1 === this.contents_.indexOf(a)) {
                    for(this.contents_.unshift(a); this.contents_.length > this.workspace.options.maxTrashcanContents;)this.contents_.pop();
                    this.setMinOpenness_(HAS_BLOCKS_LID_ANGLE$$module$build$src$core$trashcan);
                }
            }
        }
        cleanBlockJson_(a) {
            function b(c) {
                if (c) {
                    delete c.id;
                    delete c.x;
                    delete c.y;
                    delete c.enabled;
                    if (c.icons && c.icons.comment) {
                        var d = c.icons.comment;
                        delete d.height;
                        delete d.width;
                        delete d.pinned;
                    }
                    d = c.inputs;
                    for(var e in d){
                        var f = d[e];
                        const g = f.block;
                        f = f.shadow;
                        g && b(g);
                        f && b(f);
                    }
                    c.next && (e = c.next, c = e.block, e = e.shadow, c && b(c), e && b(e));
                }
            }
            a = JSON.parse(JSON.stringify(a));
            b(a);
            return Object.assign({}, {
                kind: "BLOCK"
            }, a);
        }
    }, WIDTH$$module$build$src$core$trashcan = 47, BODY_HEIGHT$$module$build$src$core$trashcan = 44, LID_HEIGHT$$module$build$src$core$trashcan = 16, MARGIN_VERTICAL$$module$build$src$core$trashcan = 20, MARGIN_HORIZONTAL$$module$build$src$core$trashcan = 20, MARGIN_HOTSPOT$$module$build$src$core$trashcan = 10, SPRITE_LEFT$$module$build$src$core$trashcan = 0, SPRITE_TOP$$module$build$src$core$trashcan = 32, HAS_BLOCKS_LID_ANGLE$$module$build$src$core$trashcan = .1, ANIMATION_LENGTH$$module$build$src$core$trashcan = 80, ANIMATION_FRAMES$$module$build$src$core$trashcan = 4, OPACITY_MIN$$module$build$src$core$trashcan = .4, OPACITY_MAX$$module$build$src$core$trashcan = .8, MAX_LID_ANGLE$$module$build$src$core$trashcan = 45, module$build$src$core$trashcan = {};
    module$build$src$core$trashcan.Trashcan = Trashcan$$module$build$src$core$trashcan;
    var getInjectionDivXY_$$module$build$src$core$utils = getInjectionDivXY$$module$build$src$core$utils, module$build$src$core$utils = {};
    module$build$src$core$utils.Coordinate = Coordinate$$module$build$src$core$utils$coordinate;
    module$build$src$core$utils.KeyCodes = KeyCodes$$module$build$src$core$utils$keycodes;
    module$build$src$core$utils.Rect = Rect$$module$build$src$core$utils$rect;
    module$build$src$core$utils.Size = Size$$module$build$src$core$utils$size;
    module$build$src$core$utils.Svg = Svg$$module$build$src$core$utils$svg;
    module$build$src$core$utils.aria = module$build$src$core$utils$aria;
    module$build$src$core$utils.array = module$build$src$core$utils$array;
    module$build$src$core$utils.arrayRemove = arrayRemove$$module$build$src$core$utils;
    module$build$src$core$utils.browserEvents = module$build$src$core$browser_events;
    module$build$src$core$utils.checkMessageReferences = checkMessageReferences$$module$build$src$core$utils;
    module$build$src$core$utils.colour = module$build$src$core$utils$colour;
    module$build$src$core$utils.deprecation = module$build$src$core$utils$deprecation;
    module$build$src$core$utils.dom = module$build$src$core$utils$dom;
    module$build$src$core$utils.extensions = $.module$build$src$core$extensions;
    module$build$src$core$utils.getBlockTypeCounts = getBlockTypeCounts$$module$build$src$core$utils;
    module$build$src$core$utils.getDocumentScroll = getDocumentScroll$$module$build$src$core$utils;
    module$build$src$core$utils.getInjectionDivXY_ = getInjectionDivXY$$module$build$src$core$utils;
    module$build$src$core$utils.getRelativeXY = getRelativeXY$$module$build$src$core$utils;
    module$build$src$core$utils.getViewportBBox = getViewportBBox$$module$build$src$core$utils;
    module$build$src$core$utils.idGenerator = module$build$src$core$utils$idgenerator;
    module$build$src$core$utils.is3dSupported = is3dSupported$$module$build$src$core$utils;
    module$build$src$core$utils.math = module$build$src$core$utils$math;
    module$build$src$core$utils.object = module$build$src$core$utils$object;
    module$build$src$core$utils.parseBlockColour = parseBlockColour$$module$build$src$core$utils;
    module$build$src$core$utils.parsing = module$build$src$core$utils$parsing;
    module$build$src$core$utils.replaceMessageReferences = replaceMessageReferences$$module$build$src$core$utils;
    module$build$src$core$utils.runAfterPageLoad = runAfterPageLoad$$module$build$src$core$utils;
    module$build$src$core$utils.screenToWsCoordinates = screenToWsCoordinates$$module$build$src$core$utils;
    module$build$src$core$utils.string = $.module$build$src$core$utils$string;
    module$build$src$core$utils.style = module$build$src$core$utils$style;
    module$build$src$core$utils.svgMath = module$build$src$core$utils$svg_math;
    module$build$src$core$utils.svgPaths = module$build$src$core$utils$svg_paths;
    module$build$src$core$utils.tokenizeInterpolation = tokenizeInterpolation$$module$build$src$core$utils;
    module$build$src$core$utils.toolbox = module$build$src$core$utils$toolbox;
    module$build$src$core$utils.userAgent = module$build$src$core$utils$useragent;
    module$build$src$core$utils.xml = $.module$build$src$core$utils$xml;
    var VERSION$$module$build$src$core$blockly = "9.3.3", ALIGN_LEFT$$module$build$src$core$blockly = $.Align$$module$build$src$core$input.LEFT, ALIGN_CENTRE$$module$build$src$core$blockly = $.Align$$module$build$src$core$input.CENTRE, ALIGN_RIGHT$$module$build$src$core$blockly = $.Align$$module$build$src$core$input.RIGHT, INPUT_VALUE$$module$build$src$core$blockly = ConnectionType$$module$build$src$core$connection_type.INPUT_VALUE, OUTPUT_VALUE$$module$build$src$core$blockly = ConnectionType$$module$build$src$core$connection_type.OUTPUT_VALUE, NEXT_STATEMENT$$module$build$src$core$blockly = ConnectionType$$module$build$src$core$connection_type.NEXT_STATEMENT, PREVIOUS_STATEMENT$$module$build$src$core$blockly = ConnectionType$$module$build$src$core$connection_type.PREVIOUS_STATEMENT, DUMMY_INPUT$$module$build$src$core$blockly = inputTypes$$module$build$src$core$input_types.DUMMY, TOOLBOX_AT_TOP$$module$build$src$core$blockly = Position$$module$build$src$core$utils$toolbox.TOP, TOOLBOX_AT_BOTTOM$$module$build$src$core$blockly = Position$$module$build$src$core$utils$toolbox.BOTTOM, TOOLBOX_AT_LEFT$$module$build$src$core$blockly = Position$$module$build$src$core$utils$toolbox.LEFT, TOOLBOX_AT_RIGHT$$module$build$src$core$blockly = Position$$module$build$src$core$utils$toolbox.RIGHT, svgResize$$module$build$src$core$blockly = svgResize$$module$build$src$core$common, getMainWorkspace$$module$build$src$core$blockly = getMainWorkspace$$module$build$src$core$common, getSelected$$module$build$src$core$blockly = getSelected$$module$build$src$core$common, defineBlocksWithJsonArray$$module$build$src$core$blockly = defineBlocksWithJsonArray$$module$build$src$core$common, setParentContainer$$module$build$src$core$blockly = setParentContainer$$module$build$src$core$common, resizeSvgContents$$module$build$src$core$blockly = resizeSvgContentsLocal$$module$build$src$core$blockly, COLLAPSE_CHARS$$module$build$src$core$blockly = COLLAPSE_CHARS$$module$build$src$core$internal_constants, DRAG_STACK$$module$build$src$core$blockly = DRAG_STACK$$module$build$src$core$internal_constants, OPPOSITE_TYPE$$module$build$src$core$blockly = OPPOSITE_TYPE$$module$build$src$core$internal_constants, RENAME_VARIABLE_ID$$module$build$src$core$blockly = RENAME_VARIABLE_ID$$module$build$src$core$internal_constants, DELETE_VARIABLE_ID$$module$build$src$core$blockly = DELETE_VARIABLE_ID$$module$build$src$core$internal_constants, COLLAPSED_INPUT_NAME$$module$build$src$core$blockly = COLLAPSED_INPUT_NAME$$module$build$src$core$constants, COLLAPSED_FIELD_NAME$$module$build$src$core$blockly = COLLAPSED_FIELD_NAME$$module$build$src$core$constants, VARIABLE_CATEGORY_NAME$$module$build$src$core$blockly = CATEGORY_NAME$$module$build$src$core$variables, VARIABLE_DYNAMIC_CATEGORY_NAME$$module$build$src$core$blockly = CATEGORY_NAME$$module$build$src$core$variables_dynamic, PROCEDURE_CATEGORY_NAME$$module$build$src$core$blockly = CATEGORY_NAME$$module$build$src$core$procedures;
    Workspace$$module$build$src$core$workspace.prototype.newBlock = function(a, b) {
        return new Block$$module$build$src$core$block(this, a, b);
    };
    WorkspaceSvg$$module$build$src$core$workspace_svg.prototype.newBlock = function(a, b) {
        return new BlockSvg$$module$build$src$core$block_svg(this, a, b);
    };
    WorkspaceSvg$$module$build$src$core$workspace_svg.newTrashcan = function(a) {
        return new Trashcan$$module$build$src$core$trashcan(a);
    };
    WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg.prototype.showContextMenu = function(a) {
        if (!this.workspace.options.readOnly) {
            var b = [];
            this.isDeletable() && this.isMovable() && (b.push(commentDuplicateOption$$module$build$src$core$contextmenu(this)), b.push(commentDeleteOption$$module$build$src$core$contextmenu(this)));
            show$$module$build$src$core$contextmenu(a, b, this.RTL);
        }
    };
    $.Mutator$$module$build$src$core$mutator.prototype.newWorkspaceSvg = function(a) {
        return new WorkspaceSvg$$module$build$src$core$workspace_svg(a);
    };
    Names$$module$build$src$core$names.prototype.populateProcedures = function(a) {
        a = allProcedures$$module$build$src$core$procedures(a);
        a = a[0].concat(a[1]);
        for(let b = 0; b < a.length; b++)this.getName(a[b][0], Names$$module$build$src$core$names.NameType.PROCEDURE);
    };
    var DropDownDiv$$module$build$src$core$blockly = module$build$src$core$dropdowndiv, connectionTypes$$module$build$src$core$blockly = ConnectionType$$module$build$src$core$connection_type, module$build$src$core$blockly = {};
    module$build$src$core$blockly.ALIGN_CENTRE = ALIGN_CENTRE$$module$build$src$core$blockly;
    module$build$src$core$blockly.ALIGN_LEFT = ALIGN_LEFT$$module$build$src$core$blockly;
    module$build$src$core$blockly.ALIGN_RIGHT = ALIGN_RIGHT$$module$build$src$core$blockly;
    module$build$src$core$blockly.ASTNode = ASTNode$$module$build$src$core$keyboard_nav$ast_node;
    module$build$src$core$blockly.BasicCursor = BasicCursor$$module$build$src$core$keyboard_nav$basic_cursor;
    module$build$src$core$blockly.Block = Block$$module$build$src$core$block;
    module$build$src$core$blockly.BlockDragSurfaceSvg = BlockDragSurfaceSvg$$module$build$src$core$block_drag_surface;
    module$build$src$core$blockly.BlockDragger = BlockDragger$$module$build$src$core$block_dragger;
    module$build$src$core$blockly.BlockSvg = BlockSvg$$module$build$src$core$block_svg;
    module$build$src$core$blockly.Blocks = Blocks$$module$build$src$core$blocks;
    module$build$src$core$blockly.Bubble = Bubble$$module$build$src$core$bubble;
    module$build$src$core$blockly.BubbleDragger = BubbleDragger$$module$build$src$core$bubble_dragger;
    module$build$src$core$blockly.COLLAPSED_FIELD_NAME = COLLAPSED_FIELD_NAME$$module$build$src$core$constants;
    module$build$src$core$blockly.COLLAPSED_INPUT_NAME = COLLAPSED_INPUT_NAME$$module$build$src$core$constants;
    module$build$src$core$blockly.COLLAPSE_CHARS = COLLAPSE_CHARS$$module$build$src$core$internal_constants;
    module$build$src$core$blockly.CodeGenerator = $.CodeGenerator$$module$build$src$core$generator;
    module$build$src$core$blockly.CollapsibleToolboxCategory = CollapsibleToolboxCategory$$module$build$src$core$toolbox$collapsible_category;
    module$build$src$core$blockly.Comment = Comment$$module$build$src$core$comment;
    module$build$src$core$blockly.ComponentManager = ComponentManager$$module$build$src$core$component_manager;
    module$build$src$core$blockly.Connection = Connection$$module$build$src$core$connection;
    module$build$src$core$blockly.ConnectionChecker = ConnectionChecker$$module$build$src$core$connection_checker;
    module$build$src$core$blockly.ConnectionDB = ConnectionDB$$module$build$src$core$connection_db;
    module$build$src$core$blockly.ConnectionType = ConnectionType$$module$build$src$core$connection_type;
    module$build$src$core$blockly.ContextMenu = $.module$build$src$core$contextmenu;
    module$build$src$core$blockly.ContextMenuItems = module$build$src$core$contextmenu_items;
    module$build$src$core$blockly.ContextMenuRegistry = ContextMenuRegistry$$module$build$src$core$contextmenu_registry;
    module$build$src$core$blockly.Css = module$build$src$core$css;
    module$build$src$core$blockly.Cursor = Cursor$$module$build$src$core$keyboard_nav$cursor;
    module$build$src$core$blockly.DELETE_VARIABLE_ID = DELETE_VARIABLE_ID$$module$build$src$core$internal_constants;
    module$build$src$core$blockly.DRAG_STACK = DRAG_STACK$$module$build$src$core$internal_constants;
    module$build$src$core$blockly.DUMMY_INPUT = DUMMY_INPUT$$module$build$src$core$blockly;
    module$build$src$core$blockly.DeleteArea = DeleteArea$$module$build$src$core$delete_area;
    module$build$src$core$blockly.DragTarget = DragTarget$$module$build$src$core$drag_target;
    module$build$src$core$blockly.DropDownDiv = module$build$src$core$dropdowndiv;
    module$build$src$core$blockly.Events = $.module$build$src$core$events$events;
    module$build$src$core$blockly.Extensions = $.module$build$src$core$extensions;
    module$build$src$core$blockly.Field = Field$$module$build$src$core$field;
    module$build$src$core$blockly.FieldAngle = FieldAngle$$module$build$src$core$field_angle;
    module$build$src$core$blockly.FieldCheckbox = FieldCheckbox$$module$build$src$core$field_checkbox;
    module$build$src$core$blockly.FieldColour = FieldColour$$module$build$src$core$field_colour;
    module$build$src$core$blockly.FieldDropdown = FieldDropdown$$module$build$src$core$field_dropdown;
    module$build$src$core$blockly.FieldImage = FieldImage$$module$build$src$core$field_image;
    module$build$src$core$blockly.FieldLabel = FieldLabel$$module$build$src$core$field_label;
    module$build$src$core$blockly.FieldLabelSerializable = FieldLabelSerializable$$module$build$src$core$field_label_serializable;
    module$build$src$core$blockly.FieldMultilineInput = FieldMultilineInput$$module$build$src$core$field_multilineinput;
    module$build$src$core$blockly.FieldNumber = FieldNumber$$module$build$src$core$field_number;
    module$build$src$core$blockly.FieldTextInput = FieldTextInput$$module$build$src$core$field_textinput;
    module$build$src$core$blockly.FieldVariable = FieldVariable$$module$build$src$core$field_variable;
    module$build$src$core$blockly.Flyout = Flyout$$module$build$src$core$flyout_base;
    module$build$src$core$blockly.FlyoutButton = FlyoutButton$$module$build$src$core$flyout_button;
    module$build$src$core$blockly.FlyoutMetricsManager = FlyoutMetricsManager$$module$build$src$core$flyout_metrics_manager;
    module$build$src$core$blockly.Generator = $.CodeGenerator$$module$build$src$core$generator;
    module$build$src$core$blockly.Gesture = Gesture$$module$build$src$core$gesture;
    module$build$src$core$blockly.Grid = Grid$$module$build$src$core$grid;
    module$build$src$core$blockly.HorizontalFlyout = HorizontalFlyout$$module$build$src$core$flyout_horizontal;
    module$build$src$core$blockly.INPUT_VALUE = INPUT_VALUE$$module$build$src$core$blockly;
    module$build$src$core$blockly.Icon = Icon$$module$build$src$core$icon;
    module$build$src$core$blockly.Input = Input$$module$build$src$core$input;
    module$build$src$core$blockly.InsertionMarkerManager = InsertionMarkerManager$$module$build$src$core$insertion_marker_manager;
    module$build$src$core$blockly.Marker = Marker$$module$build$src$core$keyboard_nav$marker;
    module$build$src$core$blockly.MarkerManager = MarkerManager$$module$build$src$core$marker_manager;
    module$build$src$core$blockly.Menu = Menu$$module$build$src$core$menu;
    module$build$src$core$blockly.MenuItem = MenuItem$$module$build$src$core$menuitem;
    module$build$src$core$blockly.MetricsManager = MetricsManager$$module$build$src$core$metrics_manager;
    module$build$src$core$blockly.Msg = Msg$$module$build$src$core$msg;
    module$build$src$core$blockly.Mutator = $.Mutator$$module$build$src$core$mutator;
    module$build$src$core$blockly.NEXT_STATEMENT = NEXT_STATEMENT$$module$build$src$core$blockly;
    module$build$src$core$blockly.Names = Names$$module$build$src$core$names;
    module$build$src$core$blockly.OPPOSITE_TYPE = OPPOSITE_TYPE$$module$build$src$core$internal_constants;
    module$build$src$core$blockly.OUTPUT_VALUE = OUTPUT_VALUE$$module$build$src$core$blockly;
    module$build$src$core$blockly.Options = Options$$module$build$src$core$options;
    module$build$src$core$blockly.PREVIOUS_STATEMENT = PREVIOUS_STATEMENT$$module$build$src$core$blockly;
    module$build$src$core$blockly.PROCEDURE_CATEGORY_NAME = CATEGORY_NAME$$module$build$src$core$procedures;
    module$build$src$core$blockly.Procedures = $.module$build$src$core$procedures;
    module$build$src$core$blockly.RENAME_VARIABLE_ID = RENAME_VARIABLE_ID$$module$build$src$core$internal_constants;
    module$build$src$core$blockly.RenderedConnection = RenderedConnection$$module$build$src$core$rendered_connection;
    module$build$src$core$blockly.Scrollbar = Scrollbar$$module$build$src$core$scrollbar;
    module$build$src$core$blockly.ScrollbarPair = ScrollbarPair$$module$build$src$core$scrollbar_pair;
    module$build$src$core$blockly.ShortcutItems = module$build$src$core$shortcut_items;
    module$build$src$core$blockly.ShortcutRegistry = ShortcutRegistry$$module$build$src$core$shortcut_registry;
    module$build$src$core$blockly.TOOLBOX_AT_BOTTOM = TOOLBOX_AT_BOTTOM$$module$build$src$core$blockly;
    module$build$src$core$blockly.TOOLBOX_AT_LEFT = TOOLBOX_AT_LEFT$$module$build$src$core$blockly;
    module$build$src$core$blockly.TOOLBOX_AT_RIGHT = TOOLBOX_AT_RIGHT$$module$build$src$core$blockly;
    module$build$src$core$blockly.TOOLBOX_AT_TOP = TOOLBOX_AT_TOP$$module$build$src$core$blockly;
    module$build$src$core$blockly.TabNavigateCursor = TabNavigateCursor$$module$build$src$core$keyboard_nav$tab_navigate_cursor;
    module$build$src$core$blockly.Theme = Theme$$module$build$src$core$theme;
    module$build$src$core$blockly.ThemeManager = ThemeManager$$module$build$src$core$theme_manager;
    module$build$src$core$blockly.Themes = module$build$src$core$theme$themes;
    module$build$src$core$blockly.Toolbox = Toolbox$$module$build$src$core$toolbox$toolbox;
    module$build$src$core$blockly.ToolboxCategory = ToolboxCategory$$module$build$src$core$toolbox$category;
    module$build$src$core$blockly.ToolboxItem = ToolboxItem$$module$build$src$core$toolbox$toolbox_item;
    module$build$src$core$blockly.ToolboxSeparator = ToolboxSeparator$$module$build$src$core$toolbox$separator;
    module$build$src$core$blockly.Tooltip = module$build$src$core$tooltip;
    module$build$src$core$blockly.Touch = module$build$src$core$touch;
    module$build$src$core$blockly.TouchGesture = Gesture$$module$build$src$core$gesture;
    module$build$src$core$blockly.Trashcan = Trashcan$$module$build$src$core$trashcan;
    module$build$src$core$blockly.UnattachedFieldError = UnattachedFieldError$$module$build$src$core$field;
    module$build$src$core$blockly.VARIABLE_CATEGORY_NAME = CATEGORY_NAME$$module$build$src$core$variables;
    module$build$src$core$blockly.VARIABLE_DYNAMIC_CATEGORY_NAME = CATEGORY_NAME$$module$build$src$core$variables_dynamic;
    module$build$src$core$blockly.VERSION = VERSION$$module$build$src$core$blockly;
    module$build$src$core$blockly.VariableMap = VariableMap$$module$build$src$core$variable_map;
    module$build$src$core$blockly.VariableModel = VariableModel$$module$build$src$core$variable_model;
    module$build$src$core$blockly.Variables = $.module$build$src$core$variables;
    module$build$src$core$blockly.VariablesDynamic = module$build$src$core$variables_dynamic;
    module$build$src$core$blockly.VerticalFlyout = VerticalFlyout$$module$build$src$core$flyout_vertical;
    module$build$src$core$blockly.Warning = Warning$$module$build$src$core$warning;
    module$build$src$core$blockly.WidgetDiv = module$build$src$core$widgetdiv;
    module$build$src$core$blockly.Workspace = Workspace$$module$build$src$core$workspace;
    module$build$src$core$blockly.WorkspaceAudio = WorkspaceAudio$$module$build$src$core$workspace_audio;
    module$build$src$core$blockly.WorkspaceComment = WorkspaceComment$$module$build$src$core$workspace_comment;
    module$build$src$core$blockly.WorkspaceCommentSvg = WorkspaceCommentSvg$$module$build$src$core$workspace_comment_svg;
    module$build$src$core$blockly.WorkspaceDragSurfaceSvg = WorkspaceDragSurfaceSvg$$module$build$src$core$workspace_drag_surface_svg;
    module$build$src$core$blockly.WorkspaceDragger = WorkspaceDragger$$module$build$src$core$workspace_dragger;
    module$build$src$core$blockly.WorkspaceSvg = WorkspaceSvg$$module$build$src$core$workspace_svg;
    module$build$src$core$blockly.Xml = $.module$build$src$core$xml;
    module$build$src$core$blockly.ZoomControls = ZoomControls$$module$build$src$core$zoom_controls;
    module$build$src$core$blockly.bindEventWithChecks_ = bindEventWithChecks_$$module$build$src$core$blockly;
    module$build$src$core$blockly.bindEvent_ = bindEvent_$$module$build$src$core$blockly;
    module$build$src$core$blockly.blockAnimations = module$build$src$core$block_animations;
    module$build$src$core$blockly.blockRendering = module$build$src$core$renderers$common$block_rendering;
    module$build$src$core$blockly.browserEvents = module$build$src$core$browser_events;
    module$build$src$core$blockly.bumpObjects = module$build$src$core$bump_objects;
    module$build$src$core$blockly.clipboard = module$build$src$core$clipboard;
    module$build$src$core$blockly.common = $.module$build$src$core$common;
    module$build$src$core$blockly.config = $.config$$module$build$src$core$config;
    module$build$src$core$blockly.connectionTypes = connectionTypes$$module$build$src$core$blockly;
    module$build$src$core$blockly.constants = module$build$src$core$constants;
    module$build$src$core$blockly.copy = copy$$module$build$src$core$blockly;
    module$build$src$core$blockly.defineBlocksWithJsonArray = defineBlocksWithJsonArray$$module$build$src$core$common;
    module$build$src$core$blockly.dialog = module$build$src$core$dialog;
    module$build$src$core$blockly.duplicate = duplicate$$module$build$src$core$blockly;
    module$build$src$core$blockly.fieldRegistry = $.module$build$src$core$field_registry;
    module$build$src$core$blockly.geras = module$build$src$core$renderers$geras$geras;
    module$build$src$core$blockly.getMainWorkspace = getMainWorkspace$$module$build$src$core$common;
    module$build$src$core$blockly.getSelected = getSelected$$module$build$src$core$common;
    module$build$src$core$blockly.hideChaff = hideChaff$$module$build$src$core$blockly;
    module$build$src$core$blockly.hueToHex = hueToHex$$module$build$src$core$blockly;
    module$build$src$core$blockly.inject = inject$$module$build$src$core$inject;
    module$build$src$core$blockly.inputTypes = inputTypes$$module$build$src$core$input_types;
    module$build$src$core$blockly.isNumber = isNumber$$module$build$src$core$blockly;
    module$build$src$core$blockly.isObservable = isObservable$$module$build$src$core$interfaces$i_observable;
    module$build$src$core$blockly.isVariableBackedParameterModel = isVariableBackedParameterModel$$module$build$src$core$interfaces$i_variable_backed_parameter_model;
    module$build$src$core$blockly.minimalist = module$build$src$core$renderers$minimalist$minimalist;
    module$build$src$core$blockly.paste = paste$$module$build$src$core$blockly;
    module$build$src$core$blockly.procedures = $.module$build$src$core$procedures;
    module$build$src$core$blockly.registry = module$build$src$core$registry;
    module$build$src$core$blockly.resizeSvgContents = resizeSvgContentsLocal$$module$build$src$core$blockly;
    module$build$src$core$blockly.serialization = module$build$src$core$serialization;
    module$build$src$core$blockly.setLocale = setLocale$$module$build$src$core$msg;
    module$build$src$core$blockly.setParentContainer = setParentContainer$$module$build$src$core$common;
    module$build$src$core$blockly.svgResize = svgResize$$module$build$src$core$common;
    module$build$src$core$blockly.thrasos = module$build$src$core$renderers$thrasos$thrasos;
    module$build$src$core$blockly.uiPosition = module$build$src$core$positionable_helpers;
    module$build$src$core$blockly.unbindEvent_ = unbindEvent_$$module$build$src$core$blockly;
    module$build$src$core$blockly.utils = module$build$src$core$utils;
    module$build$src$core$blockly.zelos = module$build$src$core$renderers$zelos$zelos;
    var module$exports$Blockly$main = {}, module$contents$Blockly$main_Blockly = module$build$src$core$blockly, module$contents$Blockly$main_ContextMenu = $.module$build$src$core$contextmenu, module$contents$Blockly$main_Events = $.module$build$src$core$events$events, module$contents$Blockly$main_Msg = $.module$build$src$core$msg, module$contents$Blockly$main_Tooltip = module$build$src$core$tooltip, module$contents$Blockly$main_WidgetDiv = module$build$src$core$widgetdiv, module$contents$Blockly$main_colour = module$build$src$core$utils$colour, module$contents$Blockly$main_common = $.module$build$src$core$common, module$contents$Blockly$main_deprecation = module$build$src$core$utils$deprecation, module$contents$Blockly$main_dialog = module$build$src$core$dialog, module$contents$Blockly$main_eventUtils = module$build$src$core$events$utils;
    Object.defineProperties(module$build$src$core$blockly, {
        alert: {
            set: function(a) {
                module$build$src$core$utils$deprecation.warn("Blockly.alert", "version 9", "version 10", "Blockly.dialog.setAlert");
                module$build$src$core$dialog.setAlert(a);
            },
            get: function() {
                module$build$src$core$utils$deprecation.warn("Blockly.alert", "version 9", "version 10", "Blockly.dialog.alert");
                return module$build$src$core$dialog.alert;
            }
        },
        confirm: {
            set: function(a) {
                module$build$src$core$utils$deprecation.warn("Blockly.confirm", "version 9", "version 10", "Blockly.dialog.setConfirm");
                module$build$src$core$dialog.setConfirm(a);
            },
            get: function() {
                module$build$src$core$utils$deprecation.warn("Blockly.confirm", "version 9", "version 10", "Blockly.dialog.confirm");
                return module$build$src$core$dialog.confirm;
            }
        },
        mainWorkspace: {
            set: function(a) {
                module$build$src$core$utils$deprecation.warn("Blockly.mainWorkspace", "version 9", "version 10", "Blockly.getMainWorkspace");
                $.module$build$src$core$common.setMainWorkspace(a);
            },
            get: function() {
                module$build$src$core$utils$deprecation.warn("Blockly.mainWorkspace", "version 9", "version 10", "Blockly.getMainWorkspace");
                return $.module$build$src$core$common.getMainWorkspace();
            }
        },
        prompt: {
            set: function(a) {
                module$build$src$core$utils$deprecation.warn("Blockly.prompt", "version 9", "version 10", "Blockly.dialog.setPrompt");
                module$build$src$core$dialog.setPrompt(a);
            },
            get: function() {
                module$build$src$core$utils$deprecation.warn("Blockly.prompt", "version 9", "version 10", "Blockly.dialog.prompt");
                return module$build$src$core$dialog.prompt;
            }
        },
        selected: {
            get: function() {
                module$build$src$core$utils$deprecation.warn("Blockly.selected", "version 9", "version 10", "Blockly.getSelected");
                return $.module$build$src$core$common.getSelected();
            },
            set: function(a) {
                module$build$src$core$utils$deprecation.warn("Blockly.selected", "version 9", "version 10", "Blockly.getSelected");
                $.module$build$src$core$common.setSelected(a);
            }
        },
        HSV_SATURATION: {
            get: function() {
                return module$build$src$core$utils$colour.getHsvSaturation();
            },
            set: function(a) {
                module$build$src$core$utils$colour.setHsvSaturation(a);
            }
        },
        HSV_VALUE: {
            get: function() {
                return module$build$src$core$utils$colour.getHsvValue();
            },
            set: function(a) {
                module$build$src$core$utils$colour.setHsvValue(a);
            }
        }
    });
    Object.defineProperties($.module$build$src$core$contextmenu, {
        currentBlock: {
            get: function() {
                module$build$src$core$utils$deprecation.warn("Blockly.ContextMenu.currentBlock", "September 2021", "September 2022", "Blockly.Tooltip.getCurrentBlock()");
                return $.module$build$src$core$contextmenu.getCurrentBlock();
            },
            set: function(a) {
                module$build$src$core$utils$deprecation.warn("Blockly.ContextMenu.currentBlock", "September 2021", "September 2022", "Blockly.Tooltip.setCurrentBlock(block)");
                $.module$build$src$core$contextmenu.setCurrentBlock(a);
            }
        }
    });
    Object.defineProperties($.module$build$src$core$events$events, {
        recordUndo: {
            get: function() {
                module$build$src$core$utils$deprecation.warn("Blockly.Events.recordUndo", "September 2021", "September 2022", "Blockly.Events.getRecordUndo()");
                return module$build$src$core$events$utils.getRecordUndo();
            },
            set: function(a) {
                module$build$src$core$utils$deprecation.warn("Blockly.Events.recordUndo", "September 2021", "September 2022", "Blockly.Events.setRecordUndo()");
                module$build$src$core$events$utils.setRecordUndo(a);
            }
        }
    });
    Object.defineProperties(module$build$src$core$tooltip, {
        visible: {
            get: function() {
                module$build$src$core$utils$deprecation.warn("Blockly.Tooltip.visible", "September 2021", "September 2022", "Blockly.Tooltip.isVisible()");
                return module$build$src$core$tooltip.isVisible();
            }
        },
        DIV: {
            get: function() {
                module$build$src$core$utils$deprecation.warn("Blockly.Tooltip.DIV", "September 2021", "September 2022", "Blockly.Tooltip.getDiv()");
                return module$build$src$core$tooltip.getDiv();
            }
        }
    });
    Object.defineProperties(module$build$src$core$widgetdiv, {
        DIV: {
            get: function() {
                module$build$src$core$utils$deprecation.warn("Blockly.WidgetDiv.DIV", "September 2021", "September 2022", "Blockly.WidgetDiv.getDiv()");
                return module$build$src$core$widgetdiv.getDiv();
            }
        }
    });
    "Blockly" in globalThis || (globalThis.Blockly = {
        Msg: $.module$build$src$core$msg
    });
    module$build$src$core$blockly.__namespace__ = $;
    return module$build$src$core$blockly;
});

});



parcelRegister("cWmWX", function(module, exports) {
(function(root, factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else {
        var messages, key;
        module.exports = factory();
    }
})(module.exports, function() {
    // This file was automatically generated.  Do not modify.
    "use strict";
    var Blockly = Blockly || {
        Msg: Object.create(null)
    };
    Blockly.Msg["ADD_COMMENT"] = "Add Comment";
    Blockly.Msg["CANNOT_DELETE_VARIABLE_PROCEDURE"] = "Can't delete the variable '%1' because it's part of the definition of the function '%2'";
    Blockly.Msg["CHANGE_VALUE_TITLE"] = "Change value:";
    Blockly.Msg["CLEAN_UP"] = "Clean up Blocks";
    Blockly.Msg["COLLAPSED_WARNINGS_WARNING"] = "Collapsed blocks contain warnings.";
    Blockly.Msg["COLLAPSE_ALL"] = "Collapse Blocks";
    Blockly.Msg["COLLAPSE_BLOCK"] = "Collapse Block";
    Blockly.Msg["COLOUR_BLEND_COLOUR1"] = "colour 1";
    Blockly.Msg["COLOUR_BLEND_COLOUR2"] = "colour 2";
    Blockly.Msg["COLOUR_BLEND_HELPURL"] = "https://meyerweb.com/eric/tools/color-blend/#:::rgbp";
    Blockly.Msg["COLOUR_BLEND_RATIO"] = "ratio";
    Blockly.Msg["COLOUR_BLEND_TITLE"] = "blend";
    Blockly.Msg["COLOUR_BLEND_TOOLTIP"] = "Blends two colours together with a given ratio (0.0 - 1.0).";
    Blockly.Msg["COLOUR_PICKER_HELPURL"] = "https://en.wikipedia.org/wiki/Color";
    Blockly.Msg["COLOUR_PICKER_TOOLTIP"] = "Choose a colour from the palette.";
    Blockly.Msg["COLOUR_RANDOM_HELPURL"] = "http://randomcolour.com";
    Blockly.Msg["COLOUR_RANDOM_TITLE"] = "random colour";
    Blockly.Msg["COLOUR_RANDOM_TOOLTIP"] = "Choose a colour at random.";
    Blockly.Msg["COLOUR_RGB_BLUE"] = "blue";
    Blockly.Msg["COLOUR_RGB_GREEN"] = "green";
    Blockly.Msg["COLOUR_RGB_HELPURL"] = "https://www.december.com/html/spec/colorpercompact.html";
    Blockly.Msg["COLOUR_RGB_RED"] = "red";
    Blockly.Msg["COLOUR_RGB_TITLE"] = "colour with";
    Blockly.Msg["COLOUR_RGB_TOOLTIP"] = "Create a colour with the specified amount of red, green, and blue. All values must be between 0 and 100.";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#loop-termination-blocks";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK"] = "break out of loop";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE"] = "continue with next iteration of loop";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_TOOLTIP_BREAK"] = "Break out of the containing loop.";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_TOOLTIP_CONTINUE"] = "Skip the rest of this loop, and continue with the next iteration.";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_WARNING"] = "Warning: This block may only be used within a loop.";
    Blockly.Msg["CONTROLS_FOREACH_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#for-each";
    Blockly.Msg["CONTROLS_FOREACH_TITLE"] = "for each item %1 in list %2";
    Blockly.Msg["CONTROLS_FOREACH_TOOLTIP"] = "For each item in a list, set the variable '%1' to the item, and then do some statements.";
    Blockly.Msg["CONTROLS_FOR_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#count-with";
    Blockly.Msg["CONTROLS_FOR_TITLE"] = "count with %1 from %2 to %3 by %4";
    Blockly.Msg["CONTROLS_FOR_TOOLTIP"] = "Have the variable '%1' take on the values from the start number to the end number, counting by the specified interval, and do the specified blocks.";
    Blockly.Msg["CONTROLS_IF_ELSEIF_TOOLTIP"] = "Add a condition to the if block.";
    Blockly.Msg["CONTROLS_IF_ELSE_TOOLTIP"] = "Add a final, catch-all condition to the if block.";
    Blockly.Msg["CONTROLS_IF_HELPURL"] = "https://github.com/google/blockly/wiki/IfElse";
    Blockly.Msg["CONTROLS_IF_IF_TOOLTIP"] = "Add, remove, or reorder sections to reconfigure this if block.";
    Blockly.Msg["CONTROLS_IF_MSG_ELSE"] = "else";
    Blockly.Msg["CONTROLS_IF_MSG_ELSEIF"] = "else if";
    Blockly.Msg["CONTROLS_IF_MSG_IF"] = "if";
    Blockly.Msg["CONTROLS_IF_TOOLTIP_1"] = "If a value is true, then do some statements.";
    Blockly.Msg["CONTROLS_IF_TOOLTIP_2"] = "If a value is true, then do the first block of statements. Otherwise, do the second block of statements.";
    Blockly.Msg["CONTROLS_IF_TOOLTIP_3"] = "If the first value is true, then do the first block of statements. Otherwise, if the second value is true, do the second block of statements.";
    Blockly.Msg["CONTROLS_IF_TOOLTIP_4"] = "If the first value is true, then do the first block of statements. Otherwise, if the second value is true, do the second block of statements. If none of the values are true, do the last block of statements.";
    Blockly.Msg["CONTROLS_REPEAT_HELPURL"] = "https://en.wikipedia.org/wiki/For_loop";
    Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"] = "do";
    Blockly.Msg["CONTROLS_REPEAT_TITLE"] = "repeat %1 times";
    Blockly.Msg["CONTROLS_REPEAT_TOOLTIP"] = "Do some statements several times.";
    Blockly.Msg["CONTROLS_WHILEUNTIL_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#repeat";
    Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_UNTIL"] = "repeat until";
    Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_WHILE"] = "repeat while";
    Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL"] = "While a value is false, then do some statements.";
    Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_WHILE"] = "While a value is true, then do some statements.";
    Blockly.Msg["DELETE_ALL_BLOCKS"] = "Delete all %1 blocks?";
    Blockly.Msg["DELETE_BLOCK"] = "Delete Block";
    Blockly.Msg["DELETE_VARIABLE"] = "Delete the '%1' variable";
    Blockly.Msg["DELETE_VARIABLE_CONFIRMATION"] = "Delete %1 uses of the '%2' variable?";
    Blockly.Msg["DELETE_X_BLOCKS"] = "Delete %1 Blocks";
    Blockly.Msg["DIALOG_CANCEL"] = "Cancel";
    Blockly.Msg["DIALOG_OK"] = "OK";
    Blockly.Msg["DISABLE_BLOCK"] = "Disable Block";
    Blockly.Msg["DUPLICATE_BLOCK"] = "Duplicate";
    Blockly.Msg["DUPLICATE_COMMENT"] = "Duplicate Comment";
    Blockly.Msg["ENABLE_BLOCK"] = "Enable Block";
    Blockly.Msg["EXPAND_ALL"] = "Expand Blocks";
    Blockly.Msg["EXPAND_BLOCK"] = "Expand Block";
    Blockly.Msg["EXTERNAL_INPUTS"] = "External Inputs";
    Blockly.Msg["HELP"] = "Help";
    Blockly.Msg["INLINE_INPUTS"] = "Inline Inputs";
    Blockly.Msg["LISTS_CREATE_EMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-empty-list";
    Blockly.Msg["LISTS_CREATE_EMPTY_TITLE"] = "create empty list";
    Blockly.Msg["LISTS_CREATE_EMPTY_TOOLTIP"] = "Returns a list, of length 0, containing no data records";
    Blockly.Msg["LISTS_CREATE_WITH_CONTAINER_TITLE_ADD"] = "list";
    Blockly.Msg["LISTS_CREATE_WITH_CONTAINER_TOOLTIP"] = "Add, remove, or reorder sections to reconfigure this list block.";
    Blockly.Msg["LISTS_CREATE_WITH_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-list-with";
    Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH"] = "create list with";
    Blockly.Msg["LISTS_CREATE_WITH_ITEM_TOOLTIP"] = "Add an item to the list.";
    Blockly.Msg["LISTS_CREATE_WITH_TOOLTIP"] = "Create a list with any number of items.";
    Blockly.Msg["LISTS_GET_INDEX_FIRST"] = "first";
    Blockly.Msg["LISTS_GET_INDEX_FROM_END"] = "# from end";
    Blockly.Msg["LISTS_GET_INDEX_FROM_START"] = "#";
    Blockly.Msg["LISTS_GET_INDEX_GET"] = "get";
    Blockly.Msg["LISTS_GET_INDEX_GET_REMOVE"] = "get and remove";
    Blockly.Msg["LISTS_GET_INDEX_LAST"] = "last";
    Blockly.Msg["LISTS_GET_INDEX_RANDOM"] = "random";
    Blockly.Msg["LISTS_GET_INDEX_REMOVE"] = "remove";
    Blockly.Msg["LISTS_GET_INDEX_TAIL"] = "";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_FIRST"] = "Returns the first item in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_FROM"] = "Returns the item at the specified position in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_LAST"] = "Returns the last item in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_RANDOM"] = "Returns a random item in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FIRST"] = "Removes and returns the first item in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FROM"] = "Removes and returns the item at the specified position in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_LAST"] = "Removes and returns the last item in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_RANDOM"] = "Removes and returns a random item in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_FIRST"] = "Removes the first item in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_FROM"] = "Removes the item at the specified position in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_LAST"] = "Removes the last item in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_RANDOM"] = "Removes a random item in a list.";
    Blockly.Msg["LISTS_GET_SUBLIST_END_FROM_END"] = "to # from end";
    Blockly.Msg["LISTS_GET_SUBLIST_END_FROM_START"] = "to #";
    Blockly.Msg["LISTS_GET_SUBLIST_END_LAST"] = "to last";
    Blockly.Msg["LISTS_GET_SUBLIST_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#getting-a-sublist";
    Blockly.Msg["LISTS_GET_SUBLIST_START_FIRST"] = "get sub-list from first";
    Blockly.Msg["LISTS_GET_SUBLIST_START_FROM_END"] = "get sub-list from # from end";
    Blockly.Msg["LISTS_GET_SUBLIST_START_FROM_START"] = "get sub-list from #";
    Blockly.Msg["LISTS_GET_SUBLIST_TAIL"] = "";
    Blockly.Msg["LISTS_GET_SUBLIST_TOOLTIP"] = "Creates a copy of the specified portion of a list.";
    Blockly.Msg["LISTS_INDEX_FROM_END_TOOLTIP"] = "%1 is the last item.";
    Blockly.Msg["LISTS_INDEX_FROM_START_TOOLTIP"] = "%1 is the first item.";
    Blockly.Msg["LISTS_INDEX_OF_FIRST"] = "find first occurrence of item";
    Blockly.Msg["LISTS_INDEX_OF_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#getting-items-from-a-list";
    Blockly.Msg["LISTS_INDEX_OF_LAST"] = "find last occurrence of item";
    Blockly.Msg["LISTS_INDEX_OF_TOOLTIP"] = "Returns the index of the first/last occurrence of the item in the list. Returns %1 if item is not found.";
    Blockly.Msg["LISTS_INLIST"] = "in list";
    Blockly.Msg["LISTS_ISEMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#is-empty";
    Blockly.Msg["LISTS_ISEMPTY_TITLE"] = "%1 is empty";
    Blockly.Msg["LISTS_ISEMPTY_TOOLTIP"] = "Returns true if the list is empty.";
    Blockly.Msg["LISTS_LENGTH_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#length-of";
    Blockly.Msg["LISTS_LENGTH_TITLE"] = "length of %1";
    Blockly.Msg["LISTS_LENGTH_TOOLTIP"] = "Returns the length of a list.";
    Blockly.Msg["LISTS_REPEAT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-list-with";
    Blockly.Msg["LISTS_REPEAT_TITLE"] = "create list with item %1 repeated %2 times";
    Blockly.Msg["LISTS_REPEAT_TOOLTIP"] = "Creates a list consisting of the given value repeated the specified number of times.";
    Blockly.Msg["LISTS_REVERSE_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#reversing-a-list";
    Blockly.Msg["LISTS_REVERSE_MESSAGE0"] = "reverse %1";
    Blockly.Msg["LISTS_REVERSE_TOOLTIP"] = "Reverse a copy of a list.";
    Blockly.Msg["LISTS_SET_INDEX_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#in-list--set";
    Blockly.Msg["LISTS_SET_INDEX_INPUT_TO"] = "as";
    Blockly.Msg["LISTS_SET_INDEX_INSERT"] = "insert at";
    Blockly.Msg["LISTS_SET_INDEX_SET"] = "set";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_FIRST"] = "Inserts the item at the start of a list.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_FROM"] = "Inserts the item at the specified position in a list.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_LAST"] = "Append the item to the end of a list.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_RANDOM"] = "Inserts the item randomly in a list.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_FIRST"] = "Sets the first item in a list.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_FROM"] = "Sets the item at the specified position in a list.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_LAST"] = "Sets the last item in a list.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_RANDOM"] = "Sets a random item in a list.";
    Blockly.Msg["LISTS_SORT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#sorting-a-list";
    Blockly.Msg["LISTS_SORT_ORDER_ASCENDING"] = "ascending";
    Blockly.Msg["LISTS_SORT_ORDER_DESCENDING"] = "descending";
    Blockly.Msg["LISTS_SORT_TITLE"] = "sort %1 %2 %3";
    Blockly.Msg["LISTS_SORT_TOOLTIP"] = "Sort a copy of a list.";
    Blockly.Msg["LISTS_SORT_TYPE_IGNORECASE"] = "alphabetic, ignore case";
    Blockly.Msg["LISTS_SORT_TYPE_NUMERIC"] = "numeric";
    Blockly.Msg["LISTS_SORT_TYPE_TEXT"] = "alphabetic";
    Blockly.Msg["LISTS_SPLIT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#splitting-strings-and-joining-lists";
    Blockly.Msg["LISTS_SPLIT_LIST_FROM_TEXT"] = "make list from text";
    Blockly.Msg["LISTS_SPLIT_TEXT_FROM_LIST"] = "make text from list";
    Blockly.Msg["LISTS_SPLIT_TOOLTIP_JOIN"] = "Join a list of texts into one text, separated by a delimiter.";
    Blockly.Msg["LISTS_SPLIT_TOOLTIP_SPLIT"] = "Split text into a list of texts, breaking at each delimiter.";
    Blockly.Msg["LISTS_SPLIT_WITH_DELIMITER"] = "with delimiter";
    Blockly.Msg["LOGIC_BOOLEAN_FALSE"] = "false";
    Blockly.Msg["LOGIC_BOOLEAN_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#values";
    Blockly.Msg["LOGIC_BOOLEAN_TOOLTIP"] = "Returns either true or false.";
    Blockly.Msg["LOGIC_BOOLEAN_TRUE"] = "true";
    Blockly.Msg["LOGIC_COMPARE_HELPURL"] = "https://en.wikipedia.org/wiki/Inequality_(mathematics)";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_EQ"] = "Return true if both inputs equal each other.";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GT"] = "Return true if the first input is greater than the second input.";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GTE"] = "Return true if the first input is greater than or equal to the second input.";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LT"] = "Return true if the first input is smaller than the second input.";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LTE"] = "Return true if the first input is smaller than or equal to the second input.";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_NEQ"] = "Return true if both inputs are not equal to each other.";
    Blockly.Msg["LOGIC_NEGATE_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#not";
    Blockly.Msg["LOGIC_NEGATE_TITLE"] = "not %1";
    Blockly.Msg["LOGIC_NEGATE_TOOLTIP"] = "Returns true if the input is false. Returns false if the input is true.";
    Blockly.Msg["LOGIC_NULL"] = "null";
    Blockly.Msg["LOGIC_NULL_HELPURL"] = "https://en.wikipedia.org/wiki/Nullable_type";
    Blockly.Msg["LOGIC_NULL_TOOLTIP"] = "Returns null.";
    Blockly.Msg["LOGIC_OPERATION_AND"] = "and";
    Blockly.Msg["LOGIC_OPERATION_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#logical-operations";
    Blockly.Msg["LOGIC_OPERATION_OR"] = "or";
    Blockly.Msg["LOGIC_OPERATION_TOOLTIP_AND"] = "Return true if both inputs are true.";
    Blockly.Msg["LOGIC_OPERATION_TOOLTIP_OR"] = "Return true if at least one of the inputs is true.";
    Blockly.Msg["LOGIC_TERNARY_CONDITION"] = "test";
    Blockly.Msg["LOGIC_TERNARY_HELPURL"] = "https://en.wikipedia.org/wiki/%3F:";
    Blockly.Msg["LOGIC_TERNARY_IF_FALSE"] = "if false";
    Blockly.Msg["LOGIC_TERNARY_IF_TRUE"] = "if true";
    Blockly.Msg["LOGIC_TERNARY_TOOLTIP"] = "Check the condition in 'test'. If the condition is true, returns the 'if true' value; otherwise returns the 'if false' value.";
    Blockly.Msg["MATH_ADDITION_SYMBOL"] = "+";
    Blockly.Msg["MATH_ARITHMETIC_HELPURL"] = "https://en.wikipedia.org/wiki/Arithmetic";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_ADD"] = "Return the sum of the two numbers.";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_DIVIDE"] = "Return the quotient of the two numbers.";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MINUS"] = "Return the difference of the two numbers.";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MULTIPLY"] = "Return the product of the two numbers.";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_POWER"] = "Return the first number raised to the power of the second number.";
    Blockly.Msg["MATH_ATAN2_HELPURL"] = "https://en.wikipedia.org/wiki/Atan2";
    Blockly.Msg["MATH_ATAN2_TITLE"] = "atan2 of X:%1 Y:%2";
    Blockly.Msg["MATH_ATAN2_TOOLTIP"] = "Return the arctangent of point (X, Y) in degrees from -180 to 180.";
    Blockly.Msg["MATH_CHANGE_HELPURL"] = "https://en.wikipedia.org/wiki/Programming_idiom#Incrementing_a_counter";
    Blockly.Msg["MATH_CHANGE_TITLE"] = "change %1 by %2";
    Blockly.Msg["MATH_CHANGE_TOOLTIP"] = "Add a number to variable '%1'.";
    Blockly.Msg["MATH_CONSTANT_HELPURL"] = "https://en.wikipedia.org/wiki/Mathematical_constant";
    Blockly.Msg["MATH_CONSTANT_TOOLTIP"] = "Return one of the common constants: \u03C0 (3.141\u2026), e (2.718\u2026), \u03C6 (1.618\u2026), sqrt(2) (1.414\u2026), sqrt(\xbd) (0.707\u2026), or \u221E (infinity).";
    Blockly.Msg["MATH_CONSTRAIN_HELPURL"] = "https://en.wikipedia.org/wiki/Clamping_(graphics)";
    Blockly.Msg["MATH_CONSTRAIN_TITLE"] = "constrain %1 low %2 high %3";
    Blockly.Msg["MATH_CONSTRAIN_TOOLTIP"] = "Constrain a number to be between the specified limits (inclusive).";
    Blockly.Msg["MATH_DIVISION_SYMBOL"] = "\xf7";
    Blockly.Msg["MATH_IS_DIVISIBLE_BY"] = "is divisible by";
    Blockly.Msg["MATH_IS_EVEN"] = "is even";
    Blockly.Msg["MATH_IS_NEGATIVE"] = "is negative";
    Blockly.Msg["MATH_IS_ODD"] = "is odd";
    Blockly.Msg["MATH_IS_POSITIVE"] = "is positive";
    Blockly.Msg["MATH_IS_PRIME"] = "is prime";
    Blockly.Msg["MATH_IS_TOOLTIP"] = "Check if a number is an even, odd, prime, whole, positive, negative, or if it is divisible by certain number. Returns true or false.";
    Blockly.Msg["MATH_IS_WHOLE"] = "is whole";
    Blockly.Msg["MATH_MODULO_HELPURL"] = "https://en.wikipedia.org/wiki/Modulo_operation";
    Blockly.Msg["MATH_MODULO_TITLE"] = "remainder of %1 \xf7 %2";
    Blockly.Msg["MATH_MODULO_TOOLTIP"] = "Return the remainder from dividing the two numbers.";
    Blockly.Msg["MATH_MULTIPLICATION_SYMBOL"] = "\xd7";
    Blockly.Msg["MATH_NUMBER_HELPURL"] = "https://en.wikipedia.org/wiki/Number";
    Blockly.Msg["MATH_NUMBER_TOOLTIP"] = "A number.";
    Blockly.Msg["MATH_ONLIST_HELPURL"] = "";
    Blockly.Msg["MATH_ONLIST_OPERATOR_AVERAGE"] = "average of list";
    Blockly.Msg["MATH_ONLIST_OPERATOR_MAX"] = "max of list";
    Blockly.Msg["MATH_ONLIST_OPERATOR_MEDIAN"] = "median of list";
    Blockly.Msg["MATH_ONLIST_OPERATOR_MIN"] = "min of list";
    Blockly.Msg["MATH_ONLIST_OPERATOR_MODE"] = "modes of list";
    Blockly.Msg["MATH_ONLIST_OPERATOR_RANDOM"] = "random item of list";
    Blockly.Msg["MATH_ONLIST_OPERATOR_STD_DEV"] = "standard deviation of list";
    Blockly.Msg["MATH_ONLIST_OPERATOR_SUM"] = "sum of list";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_AVERAGE"] = "Return the average (arithmetic mean) of the numeric values in the list.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_MAX"] = "Return the largest number in the list.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_MEDIAN"] = "Return the median number in the list.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_MIN"] = "Return the smallest number in the list.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_MODE"] = "Return a list of the most common item(s) in the list.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_RANDOM"] = "Return a random element from the list.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_STD_DEV"] = "Return the standard deviation of the list.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_SUM"] = "Return the sum of all the numbers in the list.";
    Blockly.Msg["MATH_POWER_SYMBOL"] = "^";
    Blockly.Msg["MATH_RANDOM_FLOAT_HELPURL"] = "https://en.wikipedia.org/wiki/Random_number_generation";
    Blockly.Msg["MATH_RANDOM_FLOAT_TITLE_RANDOM"] = "random fraction";
    Blockly.Msg["MATH_RANDOM_FLOAT_TOOLTIP"] = "Return a random fraction between 0.0 (inclusive) and 1.0 (exclusive).";
    Blockly.Msg["MATH_RANDOM_INT_HELPURL"] = "https://en.wikipedia.org/wiki/Random_number_generation";
    Blockly.Msg["MATH_RANDOM_INT_TITLE"] = "random integer from %1 to %2";
    Blockly.Msg["MATH_RANDOM_INT_TOOLTIP"] = "Return a random integer between the two specified limits, inclusive.";
    Blockly.Msg["MATH_ROUND_HELPURL"] = "https://en.wikipedia.org/wiki/Rounding";
    Blockly.Msg["MATH_ROUND_OPERATOR_ROUND"] = "round";
    Blockly.Msg["MATH_ROUND_OPERATOR_ROUNDDOWN"] = "round down";
    Blockly.Msg["MATH_ROUND_OPERATOR_ROUNDUP"] = "round up";
    Blockly.Msg["MATH_ROUND_TOOLTIP"] = "Round a number up or down.";
    Blockly.Msg["MATH_SINGLE_HELPURL"] = "https://en.wikipedia.org/wiki/Square_root";
    Blockly.Msg["MATH_SINGLE_OP_ABSOLUTE"] = "absolute";
    Blockly.Msg["MATH_SINGLE_OP_ROOT"] = "square root";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_ABS"] = "Return the absolute value of a number.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_EXP"] = "Return e to the power of a number.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_LN"] = "Return the natural logarithm of a number.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_LOG10"] = "Return the base 10 logarithm of a number.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_NEG"] = "Return the negation of a number.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_POW10"] = "Return 10 to the power of a number.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_ROOT"] = "Return the square root of a number.";
    Blockly.Msg["MATH_SUBTRACTION_SYMBOL"] = "-";
    Blockly.Msg["MATH_TRIG_ACOS"] = "acos";
    Blockly.Msg["MATH_TRIG_ASIN"] = "asin";
    Blockly.Msg["MATH_TRIG_ATAN"] = "atan";
    Blockly.Msg["MATH_TRIG_COS"] = "cos";
    Blockly.Msg["MATH_TRIG_HELPURL"] = "https://en.wikipedia.org/wiki/Trigonometric_functions";
    Blockly.Msg["MATH_TRIG_SIN"] = "sin";
    Blockly.Msg["MATH_TRIG_TAN"] = "tan";
    Blockly.Msg["MATH_TRIG_TOOLTIP_ACOS"] = "Return the arccosine of a number.";
    Blockly.Msg["MATH_TRIG_TOOLTIP_ASIN"] = "Return the arcsine of a number.";
    Blockly.Msg["MATH_TRIG_TOOLTIP_ATAN"] = "Return the arctangent of a number.";
    Blockly.Msg["MATH_TRIG_TOOLTIP_COS"] = "Return the cosine of a degree (not radian).";
    Blockly.Msg["MATH_TRIG_TOOLTIP_SIN"] = "Return the sine of a degree (not radian).";
    Blockly.Msg["MATH_TRIG_TOOLTIP_TAN"] = "Return the tangent of a degree (not radian).";
    Blockly.Msg["NEW_COLOUR_VARIABLE"] = "Create colour variable...";
    Blockly.Msg["NEW_NUMBER_VARIABLE"] = "Create number variable...";
    Blockly.Msg["NEW_STRING_VARIABLE"] = "Create string variable...";
    Blockly.Msg["NEW_VARIABLE"] = "Create variable...";
    Blockly.Msg["NEW_VARIABLE_TITLE"] = "New variable name:";
    Blockly.Msg["NEW_VARIABLE_TYPE_TITLE"] = "New variable type:";
    Blockly.Msg["ORDINAL_NUMBER_SUFFIX"] = "";
    Blockly.Msg["PROCEDURES_ALLOW_STATEMENTS"] = "allow statements";
    Blockly.Msg["PROCEDURES_BEFORE_PARAMS"] = "with:";
    Blockly.Msg["PROCEDURES_CALLNORETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";
    Blockly.Msg["PROCEDURES_CALLNORETURN_TOOLTIP"] = "Run the user-defined function '%1'.";
    Blockly.Msg["PROCEDURES_CALLRETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";
    Blockly.Msg["PROCEDURES_CALLRETURN_TOOLTIP"] = "Run the user-defined function '%1' and use its output.";
    Blockly.Msg["PROCEDURES_CALL_BEFORE_PARAMS"] = "with:";
    Blockly.Msg["PROCEDURES_CREATE_DO"] = "Create '%1'";
    Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"] = "Describe this function...";
    Blockly.Msg["PROCEDURES_DEFNORETURN_DO"] = "";
    Blockly.Msg["PROCEDURES_DEFNORETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";
    Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"] = "do something";
    Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"] = "to";
    Blockly.Msg["PROCEDURES_DEFNORETURN_TOOLTIP"] = "Creates a function with no output.";
    Blockly.Msg["PROCEDURES_DEFRETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";
    Blockly.Msg["PROCEDURES_DEFRETURN_RETURN"] = "return";
    Blockly.Msg["PROCEDURES_DEFRETURN_TOOLTIP"] = "Creates a function with an output.";
    Blockly.Msg["PROCEDURES_DEF_DUPLICATE_WARNING"] = "Warning: This function has duplicate parameters.";
    Blockly.Msg["PROCEDURES_HIGHLIGHT_DEF"] = "Highlight function definition";
    Blockly.Msg["PROCEDURES_IFRETURN_HELPURL"] = "http://c2.com/cgi/wiki?GuardClause";
    Blockly.Msg["PROCEDURES_IFRETURN_TOOLTIP"] = "If a value is true, then return a second value.";
    Blockly.Msg["PROCEDURES_IFRETURN_WARNING"] = "Warning: This block may be used only within a function definition.";
    Blockly.Msg["PROCEDURES_MUTATORARG_TITLE"] = "input name:";
    Blockly.Msg["PROCEDURES_MUTATORARG_TOOLTIP"] = "Add an input to the function.";
    Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TITLE"] = "inputs";
    Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TOOLTIP"] = "Add, remove, or reorder inputs to this function.";
    Blockly.Msg["REDO"] = "Redo";
    Blockly.Msg["REMOVE_COMMENT"] = "Remove Comment";
    Blockly.Msg["RENAME_VARIABLE"] = "Rename variable...";
    Blockly.Msg["RENAME_VARIABLE_TITLE"] = "Rename all '%1' variables to:";
    Blockly.Msg["TEXT_APPEND_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-modification";
    Blockly.Msg["TEXT_APPEND_TITLE"] = "to %1 append text %2";
    Blockly.Msg["TEXT_APPEND_TOOLTIP"] = "Append some text to variable '%1'.";
    Blockly.Msg["TEXT_CHANGECASE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#adjusting-text-case";
    Blockly.Msg["TEXT_CHANGECASE_OPERATOR_LOWERCASE"] = "to lower case";
    Blockly.Msg["TEXT_CHANGECASE_OPERATOR_TITLECASE"] = "to Title Case";
    Blockly.Msg["TEXT_CHANGECASE_OPERATOR_UPPERCASE"] = "to UPPER CASE";
    Blockly.Msg["TEXT_CHANGECASE_TOOLTIP"] = "Return a copy of the text in a different case.";
    Blockly.Msg["TEXT_CHARAT_FIRST"] = "get first letter";
    Blockly.Msg["TEXT_CHARAT_FROM_END"] = "get letter # from end";
    Blockly.Msg["TEXT_CHARAT_FROM_START"] = "get letter #";
    Blockly.Msg["TEXT_CHARAT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#extracting-text";
    Blockly.Msg["TEXT_CHARAT_LAST"] = "get last letter";
    Blockly.Msg["TEXT_CHARAT_RANDOM"] = "get random letter";
    Blockly.Msg["TEXT_CHARAT_TAIL"] = "";
    Blockly.Msg["TEXT_CHARAT_TITLE"] = "in text %1 %2";
    Blockly.Msg["TEXT_CHARAT_TOOLTIP"] = "Returns the letter at the specified position.";
    Blockly.Msg["TEXT_COUNT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#counting-substrings";
    Blockly.Msg["TEXT_COUNT_MESSAGE0"] = "count %1 in %2";
    Blockly.Msg["TEXT_COUNT_TOOLTIP"] = "Count how many times some text occurs within some other text.";
    Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TOOLTIP"] = "Add an item to the text.";
    Blockly.Msg["TEXT_CREATE_JOIN_TITLE_JOIN"] = "join";
    Blockly.Msg["TEXT_CREATE_JOIN_TOOLTIP"] = "Add, remove, or reorder sections to reconfigure this text block.";
    Blockly.Msg["TEXT_GET_SUBSTRING_END_FROM_END"] = "to letter # from end";
    Blockly.Msg["TEXT_GET_SUBSTRING_END_FROM_START"] = "to letter #";
    Blockly.Msg["TEXT_GET_SUBSTRING_END_LAST"] = "to last letter";
    Blockly.Msg["TEXT_GET_SUBSTRING_HELPURL"] = "https://github.com/google/blockly/wiki/Text#extracting-a-region-of-text";
    Blockly.Msg["TEXT_GET_SUBSTRING_INPUT_IN_TEXT"] = "in text";
    Blockly.Msg["TEXT_GET_SUBSTRING_START_FIRST"] = "get substring from first letter";
    Blockly.Msg["TEXT_GET_SUBSTRING_START_FROM_END"] = "get substring from letter # from end";
    Blockly.Msg["TEXT_GET_SUBSTRING_START_FROM_START"] = "get substring from letter #";
    Blockly.Msg["TEXT_GET_SUBSTRING_TAIL"] = "";
    Blockly.Msg["TEXT_GET_SUBSTRING_TOOLTIP"] = "Returns a specified portion of the text.";
    Blockly.Msg["TEXT_INDEXOF_HELPURL"] = "https://github.com/google/blockly/wiki/Text#finding-text";
    Blockly.Msg["TEXT_INDEXOF_OPERATOR_FIRST"] = "find first occurrence of text";
    Blockly.Msg["TEXT_INDEXOF_OPERATOR_LAST"] = "find last occurrence of text";
    Blockly.Msg["TEXT_INDEXOF_TITLE"] = "in text %1 %2 %3";
    Blockly.Msg["TEXT_INDEXOF_TOOLTIP"] = "Returns the index of the first/last occurrence of the first text in the second text. Returns %1 if text is not found.";
    Blockly.Msg["TEXT_ISEMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Text#checking-for-empty-text";
    Blockly.Msg["TEXT_ISEMPTY_TITLE"] = "%1 is empty";
    Blockly.Msg["TEXT_ISEMPTY_TOOLTIP"] = "Returns true if the provided text is empty.";
    Blockly.Msg["TEXT_JOIN_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-creation";
    Blockly.Msg["TEXT_JOIN_TITLE_CREATEWITH"] = "create text with";
    Blockly.Msg["TEXT_JOIN_TOOLTIP"] = "Create a piece of text by joining together any number of items.";
    Blockly.Msg["TEXT_LENGTH_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-modification";
    Blockly.Msg["TEXT_LENGTH_TITLE"] = "length of %1";
    Blockly.Msg["TEXT_LENGTH_TOOLTIP"] = "Returns the number of letters (including spaces) in the provided text.";
    Blockly.Msg["TEXT_PRINT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#printing-text";
    Blockly.Msg["TEXT_PRINT_TITLE"] = "print %1";
    Blockly.Msg["TEXT_PRINT_TOOLTIP"] = "Print the specified text, number or other value.";
    Blockly.Msg["TEXT_PROMPT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#getting-input-from-the-user";
    Blockly.Msg["TEXT_PROMPT_TOOLTIP_NUMBER"] = "Prompt for user for a number.";
    Blockly.Msg["TEXT_PROMPT_TOOLTIP_TEXT"] = "Prompt for user for some text.";
    Blockly.Msg["TEXT_PROMPT_TYPE_NUMBER"] = "prompt for number with message";
    Blockly.Msg["TEXT_PROMPT_TYPE_TEXT"] = "prompt for text with message";
    Blockly.Msg["TEXT_REPLACE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#replacing-substrings";
    Blockly.Msg["TEXT_REPLACE_MESSAGE0"] = "replace %1 with %2 in %3";
    Blockly.Msg["TEXT_REPLACE_TOOLTIP"] = "Replace all occurances of some text within some other text.";
    Blockly.Msg["TEXT_REVERSE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#reversing-text";
    Blockly.Msg["TEXT_REVERSE_MESSAGE0"] = "reverse %1";
    Blockly.Msg["TEXT_REVERSE_TOOLTIP"] = "Reverses the order of the characters in the text.";
    Blockly.Msg["TEXT_TEXT_HELPURL"] = "https://en.wikipedia.org/wiki/String_(computer_science)";
    Blockly.Msg["TEXT_TEXT_TOOLTIP"] = "A letter, word, or line of text.";
    Blockly.Msg["TEXT_TRIM_HELPURL"] = "https://github.com/google/blockly/wiki/Text#trimming-removing-spaces";
    Blockly.Msg["TEXT_TRIM_OPERATOR_BOTH"] = "trim spaces from both sides of";
    Blockly.Msg["TEXT_TRIM_OPERATOR_LEFT"] = "trim spaces from left side of";
    Blockly.Msg["TEXT_TRIM_OPERATOR_RIGHT"] = "trim spaces from right side of";
    Blockly.Msg["TEXT_TRIM_TOOLTIP"] = "Return a copy of the text with spaces removed from one or both ends.";
    Blockly.Msg["TODAY"] = "Today";
    Blockly.Msg["UNDO"] = "Undo";
    Blockly.Msg["UNNAMED_KEY"] = "unnamed";
    Blockly.Msg["VARIABLES_DEFAULT_NAME"] = "item";
    Blockly.Msg["VARIABLES_GET_CREATE_SET"] = "Create 'set %1'";
    Blockly.Msg["VARIABLES_GET_HELPURL"] = "https://github.com/google/blockly/wiki/Variables#get";
    Blockly.Msg["VARIABLES_GET_TOOLTIP"] = "Returns the value of this variable.";
    Blockly.Msg["VARIABLES_SET"] = "set %1 to %2";
    Blockly.Msg["VARIABLES_SET_CREATE_GET"] = "Create 'get %1'";
    Blockly.Msg["VARIABLES_SET_HELPURL"] = "https://github.com/google/blockly/wiki/Variables#set";
    Blockly.Msg["VARIABLES_SET_TOOLTIP"] = "Sets this variable to be equal to the input.";
    Blockly.Msg["VARIABLE_ALREADY_EXISTS"] = "A variable named '%1' already exists.";
    Blockly.Msg["VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE"] = "A variable named '%1' already exists for another type: '%2'.";
    Blockly.Msg["WORKSPACE_ARIA_LABEL"] = "Blockly Workspace";
    Blockly.Msg["WORKSPACE_COMMENT_DEFAULT_TEXT"] = "Say something...";
    Blockly.Msg["CONTROLS_FOREACH_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
    Blockly.Msg["CONTROLS_FOR_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
    Blockly.Msg["CONTROLS_IF_ELSEIF_TITLE_ELSEIF"] = Blockly.Msg["CONTROLS_IF_MSG_ELSEIF"];
    Blockly.Msg["CONTROLS_IF_ELSE_TITLE_ELSE"] = Blockly.Msg["CONTROLS_IF_MSG_ELSE"];
    Blockly.Msg["CONTROLS_IF_IF_TITLE_IF"] = Blockly.Msg["CONTROLS_IF_MSG_IF"];
    Blockly.Msg["CONTROLS_IF_MSG_THEN"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
    Blockly.Msg["CONTROLS_WHILEUNTIL_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
    Blockly.Msg["LISTS_CREATE_WITH_ITEM_TITLE"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
    Blockly.Msg["LISTS_GET_INDEX_HELPURL"] = Blockly.Msg["LISTS_INDEX_OF_HELPURL"];
    Blockly.Msg["LISTS_GET_INDEX_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
    Blockly.Msg["LISTS_GET_SUBLIST_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
    Blockly.Msg["LISTS_INDEX_OF_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
    Blockly.Msg["LISTS_SET_INDEX_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
    Blockly.Msg["MATH_CHANGE_TITLE_ITEM"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
    Blockly.Msg["PROCEDURES_DEFRETURN_COMMENT"] = Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"];
    Blockly.Msg["PROCEDURES_DEFRETURN_DO"] = Blockly.Msg["PROCEDURES_DEFNORETURN_DO"];
    Blockly.Msg["PROCEDURES_DEFRETURN_PROCEDURE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"];
    Blockly.Msg["PROCEDURES_DEFRETURN_TITLE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"];
    Blockly.Msg["TEXT_APPEND_VARIABLE"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
    Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TITLE_ITEM"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
    Blockly.Msg["MATH_HUE"] = "230";
    Blockly.Msg["LOOPS_HUE"] = "120";
    Blockly.Msg["LISTS_HUE"] = "260";
    Blockly.Msg["LOGIC_HUE"] = "210";
    Blockly.Msg["VARIABLES_HUE"] = "330";
    Blockly.Msg["TEXTS_HUE"] = "160";
    Blockly.Msg["PROCEDURES_HUE"] = "290";
    Blockly.Msg["COLOUR_HUE"] = "20";
    Blockly.Msg["VARIABLES_DYNAMIC_HUE"] = "310";
    return Blockly.Msg;
});

});

parcelRegister("94GXq", function(module, exports) {

(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "./blocks_compressed"
    ], factory);
    else module.exports = factory((parcelRequire("34v67")));
})(module.exports, function(BlocklyBlocks) {
    /**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @fileoverview Blockly blocks module; just a wrapper for blocks_compressed.js.
 */ return BlocklyBlocks;
});

});
parcelRegister("34v67", function(module, exports) {
// Do not edit this file; automatically generated.

(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "./blockly_compressed.js"
    ], factory);
    else {
        var factoryExports;
        module.exports = factory((parcelRequire("97Mr6")));
    }
})(module.exports, function(__parent__) {
    var $ = __parent__.__namespace__;
    var blocks$$module$build$src$blocks$colour = $.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([
        {
            type: "colour_picker",
            message0: "%1",
            args0: [
                {
                    type: "field_colour",
                    name: "COLOUR",
                    colour: "#ff0000"
                }
            ],
            output: "Colour",
            helpUrl: "%{BKY_COLOUR_PICKER_HELPURL}",
            style: "colour_blocks",
            tooltip: "%{BKY_COLOUR_PICKER_TOOLTIP}",
            extensions: [
                "parent_tooltip_when_inline"
            ]
        },
        {
            type: "colour_random",
            message0: "%{BKY_COLOUR_RANDOM_TITLE}",
            output: "Colour",
            helpUrl: "%{BKY_COLOUR_RANDOM_HELPURL}",
            style: "colour_blocks",
            tooltip: "%{BKY_COLOUR_RANDOM_TOOLTIP}"
        },
        {
            type: "colour_rgb",
            message0: "%{BKY_COLOUR_RGB_TITLE} %{BKY_COLOUR_RGB_RED} %1 %{BKY_COLOUR_RGB_GREEN} %2 %{BKY_COLOUR_RGB_BLUE} %3",
            args0: [
                {
                    type: "input_value",
                    name: "RED",
                    check: "Number",
                    align: "RIGHT"
                },
                {
                    type: "input_value",
                    name: "GREEN",
                    check: "Number",
                    align: "RIGHT"
                },
                {
                    type: "input_value",
                    name: "BLUE",
                    check: "Number",
                    align: "RIGHT"
                }
            ],
            output: "Colour",
            helpUrl: "%{BKY_COLOUR_RGB_HELPURL}",
            style: "colour_blocks",
            tooltip: "%{BKY_COLOUR_RGB_TOOLTIP}"
        },
        {
            type: "colour_blend",
            message0: "%{BKY_COLOUR_BLEND_TITLE} %{BKY_COLOUR_BLEND_COLOUR1} %1 %{BKY_COLOUR_BLEND_COLOUR2} %2 %{BKY_COLOUR_BLEND_RATIO} %3",
            args0: [
                {
                    type: "input_value",
                    name: "COLOUR1",
                    check: "Colour",
                    align: "RIGHT"
                },
                {
                    type: "input_value",
                    name: "COLOUR2",
                    check: "Colour",
                    align: "RIGHT"
                },
                {
                    type: "input_value",
                    name: "RATIO",
                    check: "Number",
                    align: "RIGHT"
                }
            ],
            output: "Colour",
            helpUrl: "%{BKY_COLOUR_BLEND_HELPURL}",
            style: "colour_blocks",
            tooltip: "%{BKY_COLOUR_BLEND_TOOLTIP}"
        }
    ]);
    $.defineBlocks$$module$build$src$core$common(blocks$$module$build$src$blocks$colour);
    var module$build$src$blocks$colour = {};
    module$build$src$blocks$colour.blocks = blocks$$module$build$src$blocks$colour;
    var module$exports$Blockly$libraryBlocks$lists = {}, module$contents$Blockly$libraryBlocks$lists_fieldRegistry = $.module$build$src$core$field_registry, module$contents$Blockly$libraryBlocks$lists_xmlUtils = $.module$build$src$core$utils$xml, module$contents$Blockly$libraryBlocks$lists_Align = $.Align$$module$build$src$core$input, module$contents$Blockly$libraryBlocks$lists_BlockDefinition = Object, module$contents$Blockly$libraryBlocks$lists_ConnectionType = $.module$build$src$core$connection_type.ConnectionType, module$contents$Blockly$libraryBlocks$lists_Msg = $.module$build$src$core$msg.Msg, module$contents$Blockly$libraryBlocks$lists_Mutator = $.Mutator$$module$build$src$core$mutator, module$contents$Blockly$libraryBlocks$lists_createBlockDefinitionsFromJsonArray = $.module$build$src$core$common.createBlockDefinitionsFromJsonArray, module$contents$Blockly$libraryBlocks$lists_defineBlocks = $.module$build$src$core$common.defineBlocks;
    module$exports$Blockly$libraryBlocks$lists.blocks = module$contents$Blockly$libraryBlocks$lists_createBlockDefinitionsFromJsonArray([
        {
            type: "lists_create_empty",
            message0: "%{BKY_LISTS_CREATE_EMPTY_TITLE}",
            output: "Array",
            style: "list_blocks",
            tooltip: "%{BKY_LISTS_CREATE_EMPTY_TOOLTIP}",
            helpUrl: "%{BKY_LISTS_CREATE_EMPTY_HELPURL}"
        },
        {
            type: "lists_repeat",
            message0: "%{BKY_LISTS_REPEAT_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "ITEM"
                },
                {
                    type: "input_value",
                    name: "NUM",
                    check: "Number"
                }
            ],
            output: "Array",
            style: "list_blocks",
            tooltip: "%{BKY_LISTS_REPEAT_TOOLTIP}",
            helpUrl: "%{BKY_LISTS_REPEAT_HELPURL}"
        },
        {
            type: "lists_reverse",
            message0: "%{BKY_LISTS_REVERSE_MESSAGE0}",
            args0: [
                {
                    type: "input_value",
                    name: "LIST",
                    check: "Array"
                }
            ],
            output: "Array",
            inputsInline: !0,
            style: "list_blocks",
            tooltip: "%{BKY_LISTS_REVERSE_TOOLTIP}",
            helpUrl: "%{BKY_LISTS_REVERSE_HELPURL}"
        },
        {
            type: "lists_isEmpty",
            message0: "%{BKY_LISTS_ISEMPTY_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "VALUE",
                    check: [
                        "String",
                        "Array"
                    ]
                }
            ],
            output: "Boolean",
            style: "list_blocks",
            tooltip: "%{BKY_LISTS_ISEMPTY_TOOLTIP}",
            helpUrl: "%{BKY_LISTS_ISEMPTY_HELPURL}"
        },
        {
            type: "lists_length",
            message0: "%{BKY_LISTS_LENGTH_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "VALUE",
                    check: [
                        "String",
                        "Array"
                    ]
                }
            ],
            output: "Number",
            style: "list_blocks",
            tooltip: "%{BKY_LISTS_LENGTH_TOOLTIP}",
            helpUrl: "%{BKY_LISTS_LENGTH_HELPURL}"
        }
    ]);
    module$exports$Blockly$libraryBlocks$lists.blocks.lists_create_with = {
        init: function() {
            this.setHelpUrl(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_CREATE_WITH_HELPURL);
            this.setStyle("list_blocks");
            this.itemCount_ = 3;
            this.updateShape_();
            this.setOutput(!0, "Array");
            this.setMutator(new $.Mutator$$module$build$src$core$mutator([
                "lists_create_with_item"
            ], this));
            this.setTooltip(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_CREATE_WITH_TOOLTIP);
        },
        mutationToDom: function() {
            const a = $.module$build$src$core$utils$xml.createElement("mutation");
            a.setAttribute("items", this.itemCount_);
            return a;
        },
        domToMutation: function(a) {
            this.itemCount_ = parseInt(a.getAttribute("items"), 10);
            this.updateShape_();
        },
        saveExtraState: function() {
            return {
                itemCount: this.itemCount_
            };
        },
        loadExtraState: function(a) {
            this.itemCount_ = a.itemCount;
            this.updateShape_();
        },
        decompose: function(a) {
            const b = a.newBlock("lists_create_with_container");
            b.initSvg();
            let c = b.getInput("STACK").connection;
            for(let d = 0; d < this.itemCount_; d++){
                const e = a.newBlock("lists_create_with_item");
                e.initSvg();
                c.connect(e.previousConnection);
                c = e.nextConnection;
            }
            return b;
        },
        compose: function(a) {
            var b = a.getInputTargetBlock("STACK");
            for(a = []; b;)b.isInsertionMarker() || a.push(b.valueConnection_), b = b.getNextBlock();
            for(b = 0; b < this.itemCount_; b++){
                const c = this.getInput("ADD" + b).connection.targetConnection;
                c && -1 === a.indexOf(c) && c.disconnect();
            }
            this.itemCount_ = a.length;
            this.updateShape_();
            for(b = 0; b < this.itemCount_; b++)$.Mutator$$module$build$src$core$mutator.reconnect(a[b], this, "ADD" + b);
        },
        saveConnections: function(a) {
            a = a.getInputTargetBlock("STACK");
            let b = 0;
            for(; a;){
                if (a.isInsertionMarker()) {
                    a = a.getNextBlock();
                    continue;
                }
                const c = this.getInput("ADD" + b);
                a.valueConnection_ = c && c.connection.targetConnection;
                a = a.getNextBlock();
                b++;
            }
        },
        updateShape_: function() {
            this.itemCount_ && this.getInput("EMPTY") ? this.removeInput("EMPTY") : this.itemCount_ || this.getInput("EMPTY") || this.appendDummyInput("EMPTY").appendField(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_CREATE_EMPTY_TITLE);
            for(var a = 0; a < this.itemCount_; a++)if (!this.getInput("ADD" + a)) {
                const b = this.appendValueInput("ADD" + a).setAlign($.Align$$module$build$src$core$input.RIGHT);
                0 === a && b.appendField(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_CREATE_WITH_INPUT_WITH);
            }
            for(a = this.itemCount_; this.getInput("ADD" + a); a++)this.removeInput("ADD" + a);
        }
    };
    module$exports$Blockly$libraryBlocks$lists.blocks.lists_create_with_container = {
        init: function() {
            this.setStyle("list_blocks");
            this.appendDummyInput().appendField(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_CREATE_WITH_CONTAINER_TITLE_ADD);
            this.appendStatementInput("STACK");
            this.setTooltip(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_CREATE_WITH_CONTAINER_TOOLTIP);
            this.contextMenu = !1;
        }
    };
    module$exports$Blockly$libraryBlocks$lists.blocks.lists_create_with_item = {
        init: function() {
            this.setStyle("list_blocks");
            this.appendDummyInput().appendField(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_CREATE_WITH_ITEM_TITLE);
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
            this.setTooltip(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_CREATE_WITH_ITEM_TOOLTIP);
            this.contextMenu = !1;
        }
    };
    module$exports$Blockly$libraryBlocks$lists.blocks.lists_indexOf = {
        init: function() {
            var a = [
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_INDEX_OF_FIRST,
                    "FIRST"
                ],
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_INDEX_OF_LAST,
                    "LAST"
                ]
            ];
            this.setHelpUrl(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_INDEX_OF_HELPURL);
            this.setStyle("list_blocks");
            this.setOutput(!0, "Number");
            this.appendValueInput("VALUE").setCheck("Array").appendField(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_INDEX_OF_INPUT_IN_LIST);
            a = $.module$build$src$core$field_registry.fromJson({
                type: "field_dropdown",
                options: a
            });
            this.appendValueInput("FIND").appendField(a, "END");
            this.setInputsInline(!0);
            const b = this;
            this.setTooltip(function() {
                return module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_INDEX_OF_TOOLTIP.replace("%1", b.workspace.options.oneBasedIndex ? "0" : "-1");
            });
        }
    };
    module$exports$Blockly$libraryBlocks$lists.blocks.lists_getIndex = {
        init: function() {
            var a = [
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_GET,
                    "GET"
                ],
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_GET_REMOVE,
                    "GET_REMOVE"
                ],
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_REMOVE,
                    "REMOVE"
                ]
            ];
            this.WHERE_OPTIONS = [
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_FROM_START,
                    "FROM_START"
                ],
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_FROM_END,
                    "FROM_END"
                ],
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_FIRST,
                    "FIRST"
                ],
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_LAST,
                    "LAST"
                ],
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_RANDOM,
                    "RANDOM"
                ]
            ];
            this.setHelpUrl(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_HELPURL);
            this.setStyle("list_blocks");
            a = $.module$build$src$core$field_registry.fromJson({
                type: "field_dropdown",
                options: a
            });
            a.setValidator(function(c) {
                c = "REMOVE" === c;
                this.getSourceBlock().updateStatement_(c);
            });
            this.appendValueInput("VALUE").setCheck("Array").appendField(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_INPUT_IN_LIST);
            this.appendDummyInput().appendField(a, "MODE").appendField("", "SPACE");
            this.appendDummyInput("AT");
            module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_TAIL && this.appendDummyInput("TAIL").appendField(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_TAIL);
            this.setInputsInline(!0);
            this.setOutput(!0);
            this.updateAt_(!0);
            const b = this;
            this.setTooltip(function() {
                const c = b.getFieldValue("MODE"), d = b.getFieldValue("WHERE");
                let e = "";
                switch(c + " " + d){
                    case "GET FROM_START":
                    case "GET FROM_END":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_TOOLTIP_GET_FROM;
                        break;
                    case "GET FIRST":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_TOOLTIP_GET_FIRST;
                        break;
                    case "GET LAST":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_TOOLTIP_GET_LAST;
                        break;
                    case "GET RANDOM":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_TOOLTIP_GET_RANDOM;
                        break;
                    case "GET_REMOVE FROM_START":
                    case "GET_REMOVE FROM_END":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FROM;
                        break;
                    case "GET_REMOVE FIRST":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FIRST;
                        break;
                    case "GET_REMOVE LAST":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_LAST;
                        break;
                    case "GET_REMOVE RANDOM":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_RANDOM;
                        break;
                    case "REMOVE FROM_START":
                    case "REMOVE FROM_END":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_FROM;
                        break;
                    case "REMOVE FIRST":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_FIRST;
                        break;
                    case "REMOVE LAST":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_LAST;
                        break;
                    case "REMOVE RANDOM":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_RANDOM;
                }
                if ("FROM_START" === d || "FROM_END" === d) e += "  " + ("FROM_START" === d ? module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_INDEX_FROM_START_TOOLTIP : module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_INDEX_FROM_END_TOOLTIP).replace("%1", b.workspace.options.oneBasedIndex ? "#1" : "#0");
                return e;
            });
        },
        mutationToDom: function() {
            const a = $.module$build$src$core$utils$xml.createElement("mutation");
            a.setAttribute("statement", !this.outputConnection);
            const b = this.getInput("AT").type === $.module$build$src$core$connection_type.ConnectionType.INPUT_VALUE;
            a.setAttribute("at", b);
            return a;
        },
        domToMutation: function(a) {
            const b = "true" === a.getAttribute("statement");
            this.updateStatement_(b);
            a = "false" !== a.getAttribute("at");
            this.updateAt_(a);
        },
        saveExtraState: function() {
            return this.outputConnection ? null : {
                isStatement: !0
            };
        },
        loadExtraState: function(a) {
            a.isStatement ? this.updateStatement_(!0) : "string" === typeof a && this.domToMutation($.module$build$src$core$utils$xml.textToDom(a));
        },
        updateStatement_: function(a) {
            a !== !this.outputConnection && (this.unplug(!0, !0), a ? (this.setOutput(!1), this.setPreviousStatement(!0), this.setNextStatement(!0)) : (this.setPreviousStatement(!1), this.setNextStatement(!1), this.setOutput(!0)));
        },
        updateAt_: function(a) {
            this.removeInput("AT");
            this.removeInput("ORDINAL", !0);
            a ? (this.appendValueInput("AT").setCheck("Number"), module$contents$Blockly$libraryBlocks$lists_Msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL").appendField(module$contents$Blockly$libraryBlocks$lists_Msg.ORDINAL_NUMBER_SUFFIX)) : this.appendDummyInput("AT");
            const b = $.module$build$src$core$field_registry.fromJson({
                type: "field_dropdown",
                options: this.WHERE_OPTIONS
            });
            b.setValidator(function(c) {
                const d = "FROM_START" === c || "FROM_END" === c;
                if (d !== a) {
                    const e = this.getSourceBlock();
                    e.updateAt_(d);
                    e.setFieldValue(c, "WHERE");
                    return null;
                }
            });
            this.getInput("AT").appendField(b, "WHERE");
            module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_TAIL && this.moveInputBefore("TAIL", null);
        }
    };
    module$exports$Blockly$libraryBlocks$lists.blocks.lists_setIndex = {
        init: function() {
            var a = [
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SET_INDEX_SET,
                    "SET"
                ],
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SET_INDEX_INSERT,
                    "INSERT"
                ]
            ];
            this.WHERE_OPTIONS = [
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_FROM_START,
                    "FROM_START"
                ],
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_FROM_END,
                    "FROM_END"
                ],
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_FIRST,
                    "FIRST"
                ],
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_LAST,
                    "LAST"
                ],
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_INDEX_RANDOM,
                    "RANDOM"
                ]
            ];
            this.setHelpUrl(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SET_INDEX_HELPURL);
            this.setStyle("list_blocks");
            this.appendValueInput("LIST").setCheck("Array").appendField(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SET_INDEX_INPUT_IN_LIST);
            a = $.module$build$src$core$field_registry.fromJson({
                type: "field_dropdown",
                options: a
            });
            this.appendDummyInput().appendField(a, "MODE").appendField("", "SPACE");
            this.appendDummyInput("AT");
            this.appendValueInput("TO").appendField(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SET_INDEX_INPUT_TO);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
            this.setTooltip(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SET_INDEX_TOOLTIP);
            this.updateAt_(!0);
            const b = this;
            this.setTooltip(function() {
                const c = b.getFieldValue("MODE"), d = b.getFieldValue("WHERE");
                let e = "";
                switch(c + " " + d){
                    case "SET FROM_START":
                    case "SET FROM_END":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SET_INDEX_TOOLTIP_SET_FROM;
                        break;
                    case "SET FIRST":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SET_INDEX_TOOLTIP_SET_FIRST;
                        break;
                    case "SET LAST":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SET_INDEX_TOOLTIP_SET_LAST;
                        break;
                    case "SET RANDOM":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SET_INDEX_TOOLTIP_SET_RANDOM;
                        break;
                    case "INSERT FROM_START":
                    case "INSERT FROM_END":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_FROM;
                        break;
                    case "INSERT FIRST":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_FIRST;
                        break;
                    case "INSERT LAST":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_LAST;
                        break;
                    case "INSERT RANDOM":
                        e = module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_RANDOM;
                }
                if ("FROM_START" === d || "FROM_END" === d) e += "  " + module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_INDEX_FROM_START_TOOLTIP.replace("%1", b.workspace.options.oneBasedIndex ? "#1" : "#0");
                return e;
            });
        },
        mutationToDom: function() {
            const a = $.module$build$src$core$utils$xml.createElement("mutation"), b = this.getInput("AT").type === $.module$build$src$core$connection_type.ConnectionType.INPUT_VALUE;
            a.setAttribute("at", b);
            return a;
        },
        domToMutation: function(a) {
            a = "false" !== a.getAttribute("at");
            this.updateAt_(a);
        },
        saveExtraState: function() {
            return null;
        },
        loadExtraState: function() {},
        updateAt_: function(a) {
            this.removeInput("AT");
            this.removeInput("ORDINAL", !0);
            a ? (this.appendValueInput("AT").setCheck("Number"), module$contents$Blockly$libraryBlocks$lists_Msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL").appendField(module$contents$Blockly$libraryBlocks$lists_Msg.ORDINAL_NUMBER_SUFFIX)) : this.appendDummyInput("AT");
            const b = $.module$build$src$core$field_registry.fromJson({
                type: "field_dropdown",
                options: this.WHERE_OPTIONS
            });
            b.setValidator(function(c) {
                const d = "FROM_START" === c || "FROM_END" === c;
                if (d !== a) {
                    const e = this.getSourceBlock();
                    e.updateAt_(d);
                    e.setFieldValue(c, "WHERE");
                    return null;
                }
            });
            this.moveInputBefore("AT", "TO");
            this.getInput("ORDINAL") && this.moveInputBefore("ORDINAL", "TO");
            this.getInput("AT").appendField(b, "WHERE");
        }
    };
    module$exports$Blockly$libraryBlocks$lists.blocks.lists_getSublist = {
        init: function() {
            this.WHERE_OPTIONS_1 = [
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_SUBLIST_START_FROM_START,
                    "FROM_START"
                ],
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_SUBLIST_START_FROM_END,
                    "FROM_END"
                ],
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_SUBLIST_START_FIRST,
                    "FIRST"
                ]
            ];
            this.WHERE_OPTIONS_2 = [
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_SUBLIST_END_FROM_START,
                    "FROM_START"
                ],
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_SUBLIST_END_FROM_END,
                    "FROM_END"
                ],
                [
                    module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_SUBLIST_END_LAST,
                    "LAST"
                ]
            ];
            this.setHelpUrl(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_SUBLIST_HELPURL);
            this.setStyle("list_blocks");
            this.appendValueInput("LIST").setCheck("Array").appendField(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_SUBLIST_INPUT_IN_LIST);
            this.appendDummyInput("AT1");
            this.appendDummyInput("AT2");
            module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_SUBLIST_TAIL && this.appendDummyInput("TAIL").appendField(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_SUBLIST_TAIL);
            this.setInputsInline(!0);
            this.setOutput(!0, "Array");
            this.updateAt_(1, !0);
            this.updateAt_(2, !0);
            this.setTooltip(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_SUBLIST_TOOLTIP);
        },
        mutationToDom: function() {
            const a = $.module$build$src$core$utils$xml.createElement("mutation");
            var b = this.getInput("AT1").type === $.module$build$src$core$connection_type.ConnectionType.INPUT_VALUE;
            a.setAttribute("at1", b);
            b = this.getInput("AT2").type === $.module$build$src$core$connection_type.ConnectionType.INPUT_VALUE;
            a.setAttribute("at2", b);
            return a;
        },
        domToMutation: function(a) {
            const b = "true" === a.getAttribute("at1");
            a = "true" === a.getAttribute("at2");
            this.updateAt_(1, b);
            this.updateAt_(2, a);
        },
        saveExtraState: function() {
            return null;
        },
        loadExtraState: function() {},
        updateAt_: function(a, b) {
            this.removeInput("AT" + a);
            this.removeInput("ORDINAL" + a, !0);
            b ? (this.appendValueInput("AT" + a).setCheck("Number"), module$contents$Blockly$libraryBlocks$lists_Msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL" + a).appendField(module$contents$Blockly$libraryBlocks$lists_Msg.ORDINAL_NUMBER_SUFFIX)) : this.appendDummyInput("AT" + a);
            const c = $.module$build$src$core$field_registry.fromJson({
                type: "field_dropdown",
                options: this["WHERE_OPTIONS_" + a]
            });
            c.setValidator(function(d) {
                const e = "FROM_START" === d || "FROM_END" === d;
                if (e !== b) {
                    const f = this.getSourceBlock();
                    f.updateAt_(a, e);
                    f.setFieldValue(d, "WHERE" + a);
                    return null;
                }
            });
            this.getInput("AT" + a).appendField(c, "WHERE" + a);
            1 === a && (this.moveInputBefore("AT1", "AT2"), this.getInput("ORDINAL1") && this.moveInputBefore("ORDINAL1", "AT2"));
            module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_GET_SUBLIST_TAIL && this.moveInputBefore("TAIL", null);
        }
    };
    module$exports$Blockly$libraryBlocks$lists.blocks.lists_sort = {
        init: function() {
            this.jsonInit({
                message0: "%{BKY_LISTS_SORT_TITLE}",
                args0: [
                    {
                        type: "field_dropdown",
                        name: "TYPE",
                        options: [
                            [
                                "%{BKY_LISTS_SORT_TYPE_NUMERIC}",
                                "NUMERIC"
                            ],
                            [
                                "%{BKY_LISTS_SORT_TYPE_TEXT}",
                                "TEXT"
                            ],
                            [
                                "%{BKY_LISTS_SORT_TYPE_IGNORECASE}",
                                "IGNORE_CASE"
                            ]
                        ]
                    },
                    {
                        type: "field_dropdown",
                        name: "DIRECTION",
                        options: [
                            [
                                "%{BKY_LISTS_SORT_ORDER_ASCENDING}",
                                "1"
                            ],
                            [
                                "%{BKY_LISTS_SORT_ORDER_DESCENDING}",
                                "-1"
                            ]
                        ]
                    },
                    {
                        type: "input_value",
                        name: "LIST",
                        check: "Array"
                    }
                ],
                output: "Array",
                style: "list_blocks",
                tooltip: "%{BKY_LISTS_SORT_TOOLTIP}",
                helpUrl: "%{BKY_LISTS_SORT_HELPURL}"
            });
        }
    };
    module$exports$Blockly$libraryBlocks$lists.blocks.lists_split = {
        init: function() {
            const a = this, b = $.module$build$src$core$field_registry.fromJson({
                type: "field_dropdown",
                options: [
                    [
                        module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SPLIT_LIST_FROM_TEXT,
                        "SPLIT"
                    ],
                    [
                        module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SPLIT_TEXT_FROM_LIST,
                        "JOIN"
                    ]
                ]
            });
            b.setValidator(function(c) {
                a.updateType_(c);
            });
            this.setHelpUrl(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SPLIT_HELPURL);
            this.setStyle("list_blocks");
            this.appendValueInput("INPUT").setCheck("String").appendField(b, "MODE");
            this.appendValueInput("DELIM").setCheck("String").appendField(module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SPLIT_WITH_DELIMITER);
            this.setInputsInline(!0);
            this.setOutput(!0, "Array");
            this.setTooltip(function() {
                const c = a.getFieldValue("MODE");
                if ("SPLIT" === c) return module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SPLIT_TOOLTIP_SPLIT;
                if ("JOIN" === c) return module$contents$Blockly$libraryBlocks$lists_Msg.LISTS_SPLIT_TOOLTIP_JOIN;
                throw Error("Unknown mode: " + c);
            });
        },
        updateType_: function(a) {
            if (this.getFieldValue("MODE") !== a) {
                const b = this.getInput("INPUT").connection;
                b.setShadowDom(null);
                const c = b.targetBlock();
                c && (b.disconnect(), c.isShadow() ? c.dispose() : this.bumpNeighbours());
            }
            "SPLIT" === a ? (this.outputConnection.setCheck("Array"), this.getInput("INPUT").setCheck("String")) : (this.outputConnection.setCheck("String"), this.getInput("INPUT").setCheck("Array"));
        },
        mutationToDom: function() {
            const a = $.module$build$src$core$utils$xml.createElement("mutation");
            a.setAttribute("mode", this.getFieldValue("MODE"));
            return a;
        },
        domToMutation: function(a) {
            this.updateType_(a.getAttribute("mode"));
        },
        saveExtraState: function() {
            return null;
        },
        loadExtraState: function() {}
    };
    module$contents$Blockly$libraryBlocks$lists_defineBlocks(module$exports$Blockly$libraryBlocks$lists.blocks);
    var module$exports$Blockly$libraryBlocks$logic = {}, module$contents$Blockly$libraryBlocks$logic_Events = $.module$build$src$core$events$events, module$contents$Blockly$libraryBlocks$logic_Extensions = $.module$build$src$core$extensions, module$contents$Blockly$libraryBlocks$logic_xmlUtils = $.module$build$src$core$utils$xml, module$contents$Blockly$libraryBlocks$logic_BlockDefinition = Object, module$contents$Blockly$libraryBlocks$logic_Msg = $.module$build$src$core$msg.Msg, module$contents$Blockly$libraryBlocks$logic_Mutator = $.Mutator$$module$build$src$core$mutator, module$contents$Blockly$libraryBlocks$logic_createBlockDefinitionsFromJsonArray = $.module$build$src$core$common.createBlockDefinitionsFromJsonArray, module$contents$Blockly$libraryBlocks$logic_defineBlocks = $.module$build$src$core$common.defineBlocks;
    module$exports$Blockly$libraryBlocks$logic.blocks = module$contents$Blockly$libraryBlocks$logic_createBlockDefinitionsFromJsonArray([
        {
            type: "logic_boolean",
            message0: "%1",
            args0: [
                {
                    type: "field_dropdown",
                    name: "BOOL",
                    options: [
                        [
                            "%{BKY_LOGIC_BOOLEAN_TRUE}",
                            "TRUE"
                        ],
                        [
                            "%{BKY_LOGIC_BOOLEAN_FALSE}",
                            "FALSE"
                        ]
                    ]
                }
            ],
            output: "Boolean",
            style: "logic_blocks",
            tooltip: "%{BKY_LOGIC_BOOLEAN_TOOLTIP}",
            helpUrl: "%{BKY_LOGIC_BOOLEAN_HELPURL}"
        },
        {
            type: "controls_if",
            message0: "%{BKY_CONTROLS_IF_MSG_IF} %1",
            args0: [
                {
                    type: "input_value",
                    name: "IF0",
                    check: "Boolean"
                }
            ],
            message1: "%{BKY_CONTROLS_IF_MSG_THEN} %1",
            args1: [
                {
                    type: "input_statement",
                    name: "DO0"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "logic_blocks",
            helpUrl: "%{BKY_CONTROLS_IF_HELPURL}",
            suppressPrefixSuffix: !0,
            mutator: "controls_if_mutator",
            extensions: [
                "controls_if_tooltip"
            ]
        },
        {
            type: "controls_ifelse",
            message0: "%{BKY_CONTROLS_IF_MSG_IF} %1",
            args0: [
                {
                    type: "input_value",
                    name: "IF0",
                    check: "Boolean"
                }
            ],
            message1: "%{BKY_CONTROLS_IF_MSG_THEN} %1",
            args1: [
                {
                    type: "input_statement",
                    name: "DO0"
                }
            ],
            message2: "%{BKY_CONTROLS_IF_MSG_ELSE} %1",
            args2: [
                {
                    type: "input_statement",
                    name: "ELSE"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "logic_blocks",
            tooltip: "%{BKYCONTROLS_IF_TOOLTIP_2}",
            helpUrl: "%{BKY_CONTROLS_IF_HELPURL}",
            suppressPrefixSuffix: !0,
            extensions: [
                "controls_if_tooltip"
            ]
        },
        {
            type: "logic_compare",
            message0: "%1 %2 %3",
            args0: [
                {
                    type: "input_value",
                    name: "A"
                },
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        [
                            "=",
                            "EQ"
                        ],
                        [
                            "\u2260",
                            "NEQ"
                        ],
                        [
                            "\u200F<",
                            "LT"
                        ],
                        [
                            "\u200F\u2264",
                            "LTE"
                        ],
                        [
                            "\u200F>",
                            "GT"
                        ],
                        [
                            "\u200F\u2265",
                            "GTE"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "B"
                }
            ],
            inputsInline: !0,
            output: "Boolean",
            style: "logic_blocks",
            helpUrl: "%{BKY_LOGIC_COMPARE_HELPURL}",
            extensions: [
                "logic_compare",
                "logic_op_tooltip"
            ]
        },
        {
            type: "logic_operation",
            message0: "%1 %2 %3",
            args0: [
                {
                    type: "input_value",
                    name: "A",
                    check: "Boolean"
                },
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        [
                            "%{BKY_LOGIC_OPERATION_AND}",
                            "AND"
                        ],
                        [
                            "%{BKY_LOGIC_OPERATION_OR}",
                            "OR"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "B",
                    check: "Boolean"
                }
            ],
            inputsInline: !0,
            output: "Boolean",
            style: "logic_blocks",
            helpUrl: "%{BKY_LOGIC_OPERATION_HELPURL}",
            extensions: [
                "logic_op_tooltip"
            ]
        },
        {
            type: "logic_negate",
            message0: "%{BKY_LOGIC_NEGATE_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "BOOL",
                    check: "Boolean"
                }
            ],
            output: "Boolean",
            style: "logic_blocks",
            tooltip: "%{BKY_LOGIC_NEGATE_TOOLTIP}",
            helpUrl: "%{BKY_LOGIC_NEGATE_HELPURL}"
        },
        {
            type: "logic_null",
            message0: "%{BKY_LOGIC_NULL}",
            output: null,
            style: "logic_blocks",
            tooltip: "%{BKY_LOGIC_NULL_TOOLTIP}",
            helpUrl: "%{BKY_LOGIC_NULL_HELPURL}"
        },
        {
            type: "logic_ternary",
            message0: "%{BKY_LOGIC_TERNARY_CONDITION} %1",
            args0: [
                {
                    type: "input_value",
                    name: "IF",
                    check: "Boolean"
                }
            ],
            message1: "%{BKY_LOGIC_TERNARY_IF_TRUE} %1",
            args1: [
                {
                    type: "input_value",
                    name: "THEN"
                }
            ],
            message2: "%{BKY_LOGIC_TERNARY_IF_FALSE} %1",
            args2: [
                {
                    type: "input_value",
                    name: "ELSE"
                }
            ],
            output: null,
            style: "logic_blocks",
            tooltip: "%{BKY_LOGIC_TERNARY_TOOLTIP}",
            helpUrl: "%{BKY_LOGIC_TERNARY_HELPURL}",
            extensions: [
                "logic_ternary"
            ]
        },
        {
            type: "controls_if_if",
            message0: "%{BKY_CONTROLS_IF_IF_TITLE_IF}",
            nextStatement: null,
            enableContextMenu: !1,
            style: "logic_blocks",
            tooltip: "%{BKY_CONTROLS_IF_IF_TOOLTIP}"
        },
        {
            type: "controls_if_elseif",
            message0: "%{BKY_CONTROLS_IF_ELSEIF_TITLE_ELSEIF}",
            previousStatement: null,
            nextStatement: null,
            enableContextMenu: !1,
            style: "logic_blocks",
            tooltip: "%{BKY_CONTROLS_IF_ELSEIF_TOOLTIP}"
        },
        {
            type: "controls_if_else",
            message0: "%{BKY_CONTROLS_IF_ELSE_TITLE_ELSE}",
            previousStatement: null,
            enableContextMenu: !1,
            style: "logic_blocks",
            tooltip: "%{BKY_CONTROLS_IF_ELSE_TOOLTIP}"
        }
    ]);
    var module$contents$Blockly$libraryBlocks$logic_TOOLTIPS_BY_OP = {
        EQ: "%{BKY_LOGIC_COMPARE_TOOLTIP_EQ}",
        NEQ: "%{BKY_LOGIC_COMPARE_TOOLTIP_NEQ}",
        LT: "%{BKY_LOGIC_COMPARE_TOOLTIP_LT}",
        LTE: "%{BKY_LOGIC_COMPARE_TOOLTIP_LTE}",
        GT: "%{BKY_LOGIC_COMPARE_TOOLTIP_GT}",
        GTE: "%{BKY_LOGIC_COMPARE_TOOLTIP_GTE}",
        AND: "%{BKY_LOGIC_OPERATION_TOOLTIP_AND}",
        OR: "%{BKY_LOGIC_OPERATION_TOOLTIP_OR}"
    };
    $.module$build$src$core$extensions.register("logic_op_tooltip", $.module$build$src$core$extensions.buildTooltipForDropdown("OP", module$contents$Blockly$libraryBlocks$logic_TOOLTIPS_BY_OP));
    var module$contents$Blockly$libraryBlocks$logic_CONTROLS_IF_MUTATOR_MIXIN = {
        elseifCount_: 0,
        elseCount_: 0,
        mutationToDom: function() {
            if (!this.elseifCount_ && !this.elseCount_) return null;
            const a = $.module$build$src$core$utils$xml.createElement("mutation");
            this.elseifCount_ && a.setAttribute("elseif", this.elseifCount_);
            this.elseCount_ && a.setAttribute("else", 1);
            return a;
        },
        domToMutation: function(a) {
            this.elseifCount_ = parseInt(a.getAttribute("elseif"), 10) || 0;
            this.elseCount_ = parseInt(a.getAttribute("else"), 10) || 0;
            this.rebuildShape_();
        },
        saveExtraState: function() {
            if (!this.elseifCount_ && !this.elseCount_) return null;
            const a = Object.create(null);
            this.elseifCount_ && (a.elseIfCount = this.elseifCount_);
            this.elseCount_ && (a.hasElse = !0);
            return a;
        },
        loadExtraState: function(a) {
            this.elseifCount_ = a.elseIfCount || 0;
            this.elseCount_ = a.hasElse ? 1 : 0;
            this.updateShape_();
        },
        decompose: function(a) {
            const b = a.newBlock("controls_if_if");
            b.initSvg();
            let c = b.nextConnection;
            for(let d = 1; d <= this.elseifCount_; d++){
                const e = a.newBlock("controls_if_elseif");
                e.initSvg();
                c.connect(e.previousConnection);
                c = e.nextConnection;
            }
            this.elseCount_ && (a = a.newBlock("controls_if_else"), a.initSvg(), c.connect(a.previousConnection));
            return b;
        },
        compose: function(a) {
            a = a.nextConnection.targetBlock();
            this.elseCount_ = this.elseifCount_ = 0;
            const b = [
                null
            ], c = [
                null
            ];
            let d = null;
            for(; a;){
                if (!a.isInsertionMarker()) switch(a.type){
                    case "controls_if_elseif":
                        this.elseifCount_++;
                        b.push(a.valueConnection_);
                        c.push(a.statementConnection_);
                        break;
                    case "controls_if_else":
                        this.elseCount_++;
                        d = a.statementConnection_;
                        break;
                    default:
                        throw TypeError("Unknown block type: " + a.type);
                }
                a = a.getNextBlock();
            }
            this.updateShape_();
            this.reconnectChildBlocks_(b, c, d);
        },
        saveConnections: function(a) {
            a = a.nextConnection.targetBlock();
            let b = 1;
            for(; a;){
                if (!a.isInsertionMarker()) switch(a.type){
                    case "controls_if_elseif":
                        var c = this.getInput("IF" + b);
                        const d = this.getInput("DO" + b);
                        a.valueConnection_ = c && c.connection.targetConnection;
                        a.statementConnection_ = d && d.connection.targetConnection;
                        b++;
                        break;
                    case "controls_if_else":
                        c = this.getInput("ELSE");
                        a.statementConnection_ = c && c.connection.targetConnection;
                        break;
                    default:
                        throw TypeError("Unknown block type: " + a.type);
                }
                a = a.getNextBlock();
            }
        },
        rebuildShape_: function() {
            const a = [
                null
            ], b = [
                null
            ];
            let c = null;
            this.getInput("ELSE") && (c = this.getInput("ELSE").connection.targetConnection);
            for(let d = 1; this.getInput("IF" + d); d++){
                const e = this.getInput("IF" + d), f = this.getInput("DO" + d);
                a.push(e.connection.targetConnection);
                b.push(f.connection.targetConnection);
            }
            this.updateShape_();
            this.reconnectChildBlocks_(a, b, c);
        },
        updateShape_: function() {
            this.getInput("ELSE") && this.removeInput("ELSE");
            for(var a = 1; this.getInput("IF" + a); a++)this.removeInput("IF" + a), this.removeInput("DO" + a);
            for(a = 1; a <= this.elseifCount_; a++)this.appendValueInput("IF" + a).setCheck("Boolean").appendField(module$contents$Blockly$libraryBlocks$logic_Msg.CONTROLS_IF_MSG_ELSEIF), this.appendStatementInput("DO" + a).appendField(module$contents$Blockly$libraryBlocks$logic_Msg.CONTROLS_IF_MSG_THEN);
            this.elseCount_ && this.appendStatementInput("ELSE").appendField(module$contents$Blockly$libraryBlocks$logic_Msg.CONTROLS_IF_MSG_ELSE);
        },
        reconnectChildBlocks_: function(a, b, c) {
            for(let d = 1; d <= this.elseifCount_; d++)$.Mutator$$module$build$src$core$mutator.reconnect(a[d], this, "IF" + d), $.Mutator$$module$build$src$core$mutator.reconnect(b[d], this, "DO" + d);
            $.Mutator$$module$build$src$core$mutator.reconnect(c, this, "ELSE");
        }
    };
    $.module$build$src$core$extensions.registerMutator("controls_if_mutator", module$contents$Blockly$libraryBlocks$logic_CONTROLS_IF_MUTATOR_MIXIN, null, [
        "controls_if_elseif",
        "controls_if_else"
    ]);
    var module$contents$Blockly$libraryBlocks$logic_CONTROLS_IF_TOOLTIP_EXTENSION = function() {
        this.setTooltip((function() {
            if (this.elseifCount_ || this.elseCount_) {
                if (!this.elseifCount_ && this.elseCount_) return module$contents$Blockly$libraryBlocks$logic_Msg.CONTROLS_IF_TOOLTIP_2;
                if (this.elseifCount_ && !this.elseCount_) return module$contents$Blockly$libraryBlocks$logic_Msg.CONTROLS_IF_TOOLTIP_3;
                if (this.elseifCount_ && this.elseCount_) return module$contents$Blockly$libraryBlocks$logic_Msg.CONTROLS_IF_TOOLTIP_4;
            } else return module$contents$Blockly$libraryBlocks$logic_Msg.CONTROLS_IF_TOOLTIP_1;
            return "";
        }).bind(this));
    };
    $.module$build$src$core$extensions.register("controls_if_tooltip", module$contents$Blockly$libraryBlocks$logic_CONTROLS_IF_TOOLTIP_EXTENSION);
    var module$contents$Blockly$libraryBlocks$logic_LOGIC_COMPARE_ONCHANGE_MIXIN = {
        onchange: function(a) {
            this.prevBlocks_ || (this.prevBlocks_ = [
                null,
                null
            ]);
            var b = this.getInputTargetBlock("A");
            const c = this.getInputTargetBlock("B");
            b && c && !this.workspace.connectionChecker.doTypeChecks(b.outputConnection, c.outputConnection) && ($.module$build$src$core$events$events.setGroup(a.group), a = this.prevBlocks_[0], a !== b && (b.unplug(), !a || a.isDisposed() || a.isShadow() || this.getInput("A").connection.connect(a.outputConnection)), b = this.prevBlocks_[1], b !== c && (c.unplug(), !b || b.isDisposed() || b.isShadow() || this.getInput("B").connection.connect(b.outputConnection)), this.bumpNeighbours(), $.module$build$src$core$events$events.setGroup(!1));
            this.prevBlocks_[0] = this.getInputTargetBlock("A");
            this.prevBlocks_[1] = this.getInputTargetBlock("B");
        }
    }, module$contents$Blockly$libraryBlocks$logic_LOGIC_COMPARE_EXTENSION = function() {
        this.mixin(module$contents$Blockly$libraryBlocks$logic_LOGIC_COMPARE_ONCHANGE_MIXIN);
    };
    $.module$build$src$core$extensions.register("logic_compare", module$contents$Blockly$libraryBlocks$logic_LOGIC_COMPARE_EXTENSION);
    var module$contents$Blockly$libraryBlocks$logic_LOGIC_TERNARY_ONCHANGE_MIXIN = {
        prevParentConnection_: null,
        onchange: function(a) {
            const b = this.getInputTargetBlock("THEN"), c = this.getInputTargetBlock("ELSE"), d = this.outputConnection.targetConnection;
            if ((b || c) && d) for(let e = 0; 2 > e; e++){
                const f = 1 === e ? b : c;
                f && !f.workspace.connectionChecker.doTypeChecks(f.outputConnection, d) && ($.module$build$src$core$events$events.setGroup(a.group), d === this.prevParentConnection_ ? (this.unplug(), d.getSourceBlock().bumpNeighbours()) : (f.unplug(), f.bumpNeighbours()), $.module$build$src$core$events$events.setGroup(!1));
            }
            this.prevParentConnection_ = d;
        }
    };
    $.module$build$src$core$extensions.registerMixin("logic_ternary", module$contents$Blockly$libraryBlocks$logic_LOGIC_TERNARY_ONCHANGE_MIXIN);
    module$contents$Blockly$libraryBlocks$logic_defineBlocks(module$exports$Blockly$libraryBlocks$logic.blocks);
    var module$exports$Blockly$libraryBlocks$loops = {}, module$contents$Blockly$libraryBlocks$loops_ContextMenu = $.module$build$src$core$contextmenu, module$contents$Blockly$libraryBlocks$loops_Events = $.module$build$src$core$events$events, module$contents$Blockly$libraryBlocks$loops_Extensions = $.module$build$src$core$extensions, module$contents$Blockly$libraryBlocks$loops_Variables = $.module$build$src$core$variables, module$contents$Blockly$libraryBlocks$loops_xmlUtils = $.module$build$src$core$utils$xml, module$contents$Blockly$libraryBlocks$loops_BlockDefinition = Object, module$contents$Blockly$libraryBlocks$loops_Msg = $.module$build$src$core$msg.Msg, module$contents$Blockly$libraryBlocks$loops_createBlockDefinitionsFromJsonArray = $.module$build$src$core$common.createBlockDefinitionsFromJsonArray, module$contents$Blockly$libraryBlocks$loops_defineBlocks = $.module$build$src$core$common.defineBlocks;
    module$exports$Blockly$libraryBlocks$loops.blocks = module$contents$Blockly$libraryBlocks$loops_createBlockDefinitionsFromJsonArray([
        {
            type: "controls_repeat_ext",
            message0: "%{BKY_CONTROLS_REPEAT_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "TIMES",
                    check: "Number"
                }
            ],
            message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",
            args1: [
                {
                    type: "input_statement",
                    name: "DO"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "loop_blocks",
            tooltip: "%{BKY_CONTROLS_REPEAT_TOOLTIP}",
            helpUrl: "%{BKY_CONTROLS_REPEAT_HELPURL}"
        },
        {
            type: "controls_repeat",
            message0: "%{BKY_CONTROLS_REPEAT_TITLE}",
            args0: [
                {
                    type: "field_number",
                    name: "TIMES",
                    value: 10,
                    min: 0,
                    precision: 1
                }
            ],
            message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",
            args1: [
                {
                    type: "input_statement",
                    name: "DO"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "loop_blocks",
            tooltip: "%{BKY_CONTROLS_REPEAT_TOOLTIP}",
            helpUrl: "%{BKY_CONTROLS_REPEAT_HELPURL}"
        },
        {
            type: "controls_whileUntil",
            message0: "%1 %2",
            args0: [
                {
                    type: "field_dropdown",
                    name: "MODE",
                    options: [
                        [
                            "%{BKY_CONTROLS_WHILEUNTIL_OPERATOR_WHILE}",
                            "WHILE"
                        ],
                        [
                            "%{BKY_CONTROLS_WHILEUNTIL_OPERATOR_UNTIL}",
                            "UNTIL"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "BOOL",
                    check: "Boolean"
                }
            ],
            message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",
            args1: [
                {
                    type: "input_statement",
                    name: "DO"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "loop_blocks",
            helpUrl: "%{BKY_CONTROLS_WHILEUNTIL_HELPURL}",
            extensions: [
                "controls_whileUntil_tooltip"
            ]
        },
        {
            type: "controls_for",
            message0: "%{BKY_CONTROLS_FOR_TITLE}",
            args0: [
                {
                    type: "field_variable",
                    name: "VAR",
                    variable: null
                },
                {
                    type: "input_value",
                    name: "FROM",
                    check: "Number",
                    align: "RIGHT"
                },
                {
                    type: "input_value",
                    name: "TO",
                    check: "Number",
                    align: "RIGHT"
                },
                {
                    type: "input_value",
                    name: "BY",
                    check: "Number",
                    align: "RIGHT"
                }
            ],
            message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",
            args1: [
                {
                    type: "input_statement",
                    name: "DO"
                }
            ],
            inputsInline: !0,
            previousStatement: null,
            nextStatement: null,
            style: "loop_blocks",
            helpUrl: "%{BKY_CONTROLS_FOR_HELPURL}",
            extensions: [
                "contextMenu_newGetVariableBlock",
                "controls_for_tooltip"
            ]
        },
        {
            type: "controls_forEach",
            message0: "%{BKY_CONTROLS_FOREACH_TITLE}",
            args0: [
                {
                    type: "field_variable",
                    name: "VAR",
                    variable: null
                },
                {
                    type: "input_value",
                    name: "LIST",
                    check: "Array"
                }
            ],
            message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",
            args1: [
                {
                    type: "input_statement",
                    name: "DO"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "loop_blocks",
            helpUrl: "%{BKY_CONTROLS_FOREACH_HELPURL}",
            extensions: [
                "contextMenu_newGetVariableBlock",
                "controls_forEach_tooltip"
            ]
        },
        {
            type: "controls_flow_statements",
            message0: "%1",
            args0: [
                {
                    type: "field_dropdown",
                    name: "FLOW",
                    options: [
                        [
                            "%{BKY_CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK}",
                            "BREAK"
                        ],
                        [
                            "%{BKY_CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE}",
                            "CONTINUE"
                        ]
                    ]
                }
            ],
            previousStatement: null,
            style: "loop_blocks",
            helpUrl: "%{BKY_CONTROLS_FLOW_STATEMENTS_HELPURL}",
            suppressPrefixSuffix: !0,
            extensions: [
                "controls_flow_tooltip",
                "controls_flow_in_loop_check"
            ]
        }
    ]);
    var module$contents$Blockly$libraryBlocks$loops_WHILE_UNTIL_TOOLTIPS = {
        WHILE: "%{BKY_CONTROLS_WHILEUNTIL_TOOLTIP_WHILE}",
        UNTIL: "%{BKY_CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL}"
    };
    $.module$build$src$core$extensions.register("controls_whileUntil_tooltip", $.module$build$src$core$extensions.buildTooltipForDropdown("MODE", module$contents$Blockly$libraryBlocks$loops_WHILE_UNTIL_TOOLTIPS));
    var module$contents$Blockly$libraryBlocks$loops_BREAK_CONTINUE_TOOLTIPS = {
        BREAK: "%{BKY_CONTROLS_FLOW_STATEMENTS_TOOLTIP_BREAK}",
        CONTINUE: "%{BKY_CONTROLS_FLOW_STATEMENTS_TOOLTIP_CONTINUE}"
    };
    $.module$build$src$core$extensions.register("controls_flow_tooltip", $.module$build$src$core$extensions.buildTooltipForDropdown("FLOW", module$contents$Blockly$libraryBlocks$loops_BREAK_CONTINUE_TOOLTIPS));
    var module$contents$Blockly$libraryBlocks$loops_CUSTOM_CONTEXT_MENU_CREATE_VARIABLES_GET_MIXIN = {
        customContextMenu: function(a) {
            if (!this.isInFlyout) {
                var b = this.getField("VAR").getVariable(), c = b.name;
                if (!this.isCollapsed() && null !== c) {
                    const d = {
                        enabled: !0
                    };
                    d.text = module$contents$Blockly$libraryBlocks$loops_Msg.VARIABLES_SET_CREATE_GET.replace("%1", c);
                    b = $.module$build$src$core$variables.generateVariableFieldDom(b);
                    c = $.module$build$src$core$utils$xml.createElement("block");
                    c.setAttribute("type", "variables_get");
                    c.appendChild(b);
                    d.callback = $.module$build$src$core$contextmenu.callbackFactory(this, c);
                    a.push(d);
                }
            }
        }
    };
    $.module$build$src$core$extensions.registerMixin("contextMenu_newGetVariableBlock", module$contents$Blockly$libraryBlocks$loops_CUSTOM_CONTEXT_MENU_CREATE_VARIABLES_GET_MIXIN);
    $.module$build$src$core$extensions.register("controls_for_tooltip", $.module$build$src$core$extensions.buildTooltipWithFieldText("%{BKY_CONTROLS_FOR_TOOLTIP}", "VAR"));
    $.module$build$src$core$extensions.register("controls_forEach_tooltip", $.module$build$src$core$extensions.buildTooltipWithFieldText("%{BKY_CONTROLS_FOREACH_TOOLTIP}", "VAR"));
    module$exports$Blockly$libraryBlocks$loops.loopTypes = new Set([
        "controls_repeat",
        "controls_repeat_ext",
        "controls_forEach",
        "controls_for",
        "controls_whileUntil"
    ]);
    var module$contents$Blockly$libraryBlocks$loops_CONTROL_FLOW_IN_LOOP_CHECK_MIXIN = {
        getSurroundLoop: function() {
            let a = this;
            do {
                if (module$exports$Blockly$libraryBlocks$loops.loopTypes.has(a.type)) return a;
                a = a.getSurroundParent();
            }while (a);
            return null;
        },
        onchange: function(a) {
            if (this.workspace.isDragging && !this.workspace.isDragging() && a.type === $.module$build$src$core$events$events.BLOCK_MOVE) {
                var b = this.getSurroundLoop(this);
                this.setWarningText(b ? null : module$contents$Blockly$libraryBlocks$loops_Msg.CONTROLS_FLOW_STATEMENTS_WARNING);
                if (!this.isInFlyout) {
                    const c = $.module$build$src$core$events$events.getGroup();
                    $.module$build$src$core$events$events.setGroup(a.group);
                    this.setEnabled(b);
                    $.module$build$src$core$events$events.setGroup(c);
                }
            }
        }
    };
    $.module$build$src$core$extensions.registerMixin("controls_flow_in_loop_check", module$contents$Blockly$libraryBlocks$loops_CONTROL_FLOW_IN_LOOP_CHECK_MIXIN);
    module$contents$Blockly$libraryBlocks$loops_defineBlocks(module$exports$Blockly$libraryBlocks$loops.blocks);
    var blocks$$module$build$src$blocks$math = $.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([
        {
            type: "math_number",
            message0: "%1",
            args0: [
                {
                    type: "field_number",
                    name: "NUM",
                    value: 0
                }
            ],
            output: "Number",
            helpUrl: "%{BKY_MATH_NUMBER_HELPURL}",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_NUMBER_TOOLTIP}",
            extensions: [
                "parent_tooltip_when_inline"
            ]
        },
        {
            type: "math_arithmetic",
            message0: "%1 %2 %3",
            args0: [
                {
                    type: "input_value",
                    name: "A",
                    check: "Number"
                },
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        [
                            "%{BKY_MATH_ADDITION_SYMBOL}",
                            "ADD"
                        ],
                        [
                            "%{BKY_MATH_SUBTRACTION_SYMBOL}",
                            "MINUS"
                        ],
                        [
                            "%{BKY_MATH_MULTIPLICATION_SYMBOL}",
                            "MULTIPLY"
                        ],
                        [
                            "%{BKY_MATH_DIVISION_SYMBOL}",
                            "DIVIDE"
                        ],
                        [
                            "%{BKY_MATH_POWER_SYMBOL}",
                            "POWER"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "B",
                    check: "Number"
                }
            ],
            inputsInline: !0,
            output: "Number",
            style: "math_blocks",
            helpUrl: "%{BKY_MATH_ARITHMETIC_HELPURL}",
            extensions: [
                "math_op_tooltip"
            ]
        },
        {
            type: "math_single",
            message0: "%1 %2",
            args0: [
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        [
                            "%{BKY_MATH_SINGLE_OP_ROOT}",
                            "ROOT"
                        ],
                        [
                            "%{BKY_MATH_SINGLE_OP_ABSOLUTE}",
                            "ABS"
                        ],
                        [
                            "-",
                            "NEG"
                        ],
                        [
                            "ln",
                            "LN"
                        ],
                        [
                            "log10",
                            "LOG10"
                        ],
                        [
                            "e^",
                            "EXP"
                        ],
                        [
                            "10^",
                            "POW10"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "NUM",
                    check: "Number"
                }
            ],
            output: "Number",
            style: "math_blocks",
            helpUrl: "%{BKY_MATH_SINGLE_HELPURL}",
            extensions: [
                "math_op_tooltip"
            ]
        },
        {
            type: "math_trig",
            message0: "%1 %2",
            args0: [
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        [
                            "%{BKY_MATH_TRIG_SIN}",
                            "SIN"
                        ],
                        [
                            "%{BKY_MATH_TRIG_COS}",
                            "COS"
                        ],
                        [
                            "%{BKY_MATH_TRIG_TAN}",
                            "TAN"
                        ],
                        [
                            "%{BKY_MATH_TRIG_ASIN}",
                            "ASIN"
                        ],
                        [
                            "%{BKY_MATH_TRIG_ACOS}",
                            "ACOS"
                        ],
                        [
                            "%{BKY_MATH_TRIG_ATAN}",
                            "ATAN"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "NUM",
                    check: "Number"
                }
            ],
            output: "Number",
            style: "math_blocks",
            helpUrl: "%{BKY_MATH_TRIG_HELPURL}",
            extensions: [
                "math_op_tooltip"
            ]
        },
        {
            type: "math_constant",
            message0: "%1",
            args0: [
                {
                    type: "field_dropdown",
                    name: "CONSTANT",
                    options: [
                        [
                            "\u03C0",
                            "PI"
                        ],
                        [
                            "e",
                            "E"
                        ],
                        [
                            "\u03C6",
                            "GOLDEN_RATIO"
                        ],
                        [
                            "sqrt(2)",
                            "SQRT2"
                        ],
                        [
                            "sqrt(\xbd)",
                            "SQRT1_2"
                        ],
                        [
                            "\u221E",
                            "INFINITY"
                        ]
                    ]
                }
            ],
            output: "Number",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_CONSTANT_TOOLTIP}",
            helpUrl: "%{BKY_MATH_CONSTANT_HELPURL}"
        },
        {
            type: "math_number_property",
            message0: "%1 %2",
            args0: [
                {
                    type: "input_value",
                    name: "NUMBER_TO_CHECK",
                    check: "Number"
                },
                {
                    type: "field_dropdown",
                    name: "PROPERTY",
                    options: [
                        [
                            "%{BKY_MATH_IS_EVEN}",
                            "EVEN"
                        ],
                        [
                            "%{BKY_MATH_IS_ODD}",
                            "ODD"
                        ],
                        [
                            "%{BKY_MATH_IS_PRIME}",
                            "PRIME"
                        ],
                        [
                            "%{BKY_MATH_IS_WHOLE}",
                            "WHOLE"
                        ],
                        [
                            "%{BKY_MATH_IS_POSITIVE}",
                            "POSITIVE"
                        ],
                        [
                            "%{BKY_MATH_IS_NEGATIVE}",
                            "NEGATIVE"
                        ],
                        [
                            "%{BKY_MATH_IS_DIVISIBLE_BY}",
                            "DIVISIBLE_BY"
                        ]
                    ]
                }
            ],
            inputsInline: !0,
            output: "Boolean",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_IS_TOOLTIP}",
            mutator: "math_is_divisibleby_mutator"
        },
        {
            type: "math_change",
            message0: "%{BKY_MATH_CHANGE_TITLE}",
            args0: [
                {
                    type: "field_variable",
                    name: "VAR",
                    variable: "%{BKY_MATH_CHANGE_TITLE_ITEM}"
                },
                {
                    type: "input_value",
                    name: "DELTA",
                    check: "Number"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "variable_blocks",
            helpUrl: "%{BKY_MATH_CHANGE_HELPURL}",
            extensions: [
                "math_change_tooltip"
            ]
        },
        {
            type: "math_round",
            message0: "%1 %2",
            args0: [
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        [
                            "%{BKY_MATH_ROUND_OPERATOR_ROUND}",
                            "ROUND"
                        ],
                        [
                            "%{BKY_MATH_ROUND_OPERATOR_ROUNDUP}",
                            "ROUNDUP"
                        ],
                        [
                            "%{BKY_MATH_ROUND_OPERATOR_ROUNDDOWN}",
                            "ROUNDDOWN"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "NUM",
                    check: "Number"
                }
            ],
            output: "Number",
            style: "math_blocks",
            helpUrl: "%{BKY_MATH_ROUND_HELPURL}",
            tooltip: "%{BKY_MATH_ROUND_TOOLTIP}"
        },
        {
            type: "math_on_list",
            message0: "%1 %2",
            args0: [
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        [
                            "%{BKY_MATH_ONLIST_OPERATOR_SUM}",
                            "SUM"
                        ],
                        [
                            "%{BKY_MATH_ONLIST_OPERATOR_MIN}",
                            "MIN"
                        ],
                        [
                            "%{BKY_MATH_ONLIST_OPERATOR_MAX}",
                            "MAX"
                        ],
                        [
                            "%{BKY_MATH_ONLIST_OPERATOR_AVERAGE}",
                            "AVERAGE"
                        ],
                        [
                            "%{BKY_MATH_ONLIST_OPERATOR_MEDIAN}",
                            "MEDIAN"
                        ],
                        [
                            "%{BKY_MATH_ONLIST_OPERATOR_MODE}",
                            "MODE"
                        ],
                        [
                            "%{BKY_MATH_ONLIST_OPERATOR_STD_DEV}",
                            "STD_DEV"
                        ],
                        [
                            "%{BKY_MATH_ONLIST_OPERATOR_RANDOM}",
                            "RANDOM"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "LIST",
                    check: "Array"
                }
            ],
            output: "Number",
            style: "math_blocks",
            helpUrl: "%{BKY_MATH_ONLIST_HELPURL}",
            mutator: "math_modes_of_list_mutator",
            extensions: [
                "math_op_tooltip"
            ]
        },
        {
            type: "math_modulo",
            message0: "%{BKY_MATH_MODULO_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "DIVIDEND",
                    check: "Number"
                },
                {
                    type: "input_value",
                    name: "DIVISOR",
                    check: "Number"
                }
            ],
            inputsInline: !0,
            output: "Number",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_MODULO_TOOLTIP}",
            helpUrl: "%{BKY_MATH_MODULO_HELPURL}"
        },
        {
            type: "math_constrain",
            message0: "%{BKY_MATH_CONSTRAIN_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "VALUE",
                    check: "Number"
                },
                {
                    type: "input_value",
                    name: "LOW",
                    check: "Number"
                },
                {
                    type: "input_value",
                    name: "HIGH",
                    check: "Number"
                }
            ],
            inputsInline: !0,
            output: "Number",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_CONSTRAIN_TOOLTIP}",
            helpUrl: "%{BKY_MATH_CONSTRAIN_HELPURL}"
        },
        {
            type: "math_random_int",
            message0: "%{BKY_MATH_RANDOM_INT_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "FROM",
                    check: "Number"
                },
                {
                    type: "input_value",
                    name: "TO",
                    check: "Number"
                }
            ],
            inputsInline: !0,
            output: "Number",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_RANDOM_INT_TOOLTIP}",
            helpUrl: "%{BKY_MATH_RANDOM_INT_HELPURL}"
        },
        {
            type: "math_random_float",
            message0: "%{BKY_MATH_RANDOM_FLOAT_TITLE_RANDOM}",
            output: "Number",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_RANDOM_FLOAT_TOOLTIP}",
            helpUrl: "%{BKY_MATH_RANDOM_FLOAT_HELPURL}"
        },
        {
            type: "math_atan2",
            message0: "%{BKY_MATH_ATAN2_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "X",
                    check: "Number"
                },
                {
                    type: "input_value",
                    name: "Y",
                    check: "Number"
                }
            ],
            inputsInline: !0,
            output: "Number",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_ATAN2_TOOLTIP}",
            helpUrl: "%{BKY_MATH_ATAN2_HELPURL}"
        }
    ]), TOOLTIPS_BY_OP$$module$build$src$blocks$math = {
        ADD: "%{BKY_MATH_ARITHMETIC_TOOLTIP_ADD}",
        MINUS: "%{BKY_MATH_ARITHMETIC_TOOLTIP_MINUS}",
        MULTIPLY: "%{BKY_MATH_ARITHMETIC_TOOLTIP_MULTIPLY}",
        DIVIDE: "%{BKY_MATH_ARITHMETIC_TOOLTIP_DIVIDE}",
        POWER: "%{BKY_MATH_ARITHMETIC_TOOLTIP_POWER}",
        ROOT: "%{BKY_MATH_SINGLE_TOOLTIP_ROOT}",
        ABS: "%{BKY_MATH_SINGLE_TOOLTIP_ABS}",
        NEG: "%{BKY_MATH_SINGLE_TOOLTIP_NEG}",
        LN: "%{BKY_MATH_SINGLE_TOOLTIP_LN}",
        LOG10: "%{BKY_MATH_SINGLE_TOOLTIP_LOG10}",
        EXP: "%{BKY_MATH_SINGLE_TOOLTIP_EXP}",
        POW10: "%{BKY_MATH_SINGLE_TOOLTIP_POW10}",
        SIN: "%{BKY_MATH_TRIG_TOOLTIP_SIN}",
        COS: "%{BKY_MATH_TRIG_TOOLTIP_COS}",
        TAN: "%{BKY_MATH_TRIG_TOOLTIP_TAN}",
        ASIN: "%{BKY_MATH_TRIG_TOOLTIP_ASIN}",
        ACOS: "%{BKY_MATH_TRIG_TOOLTIP_ACOS}",
        ATAN: "%{BKY_MATH_TRIG_TOOLTIP_ATAN}",
        SUM: "%{BKY_MATH_ONLIST_TOOLTIP_SUM}",
        MIN: "%{BKY_MATH_ONLIST_TOOLTIP_MIN}",
        MAX: "%{BKY_MATH_ONLIST_TOOLTIP_MAX}",
        AVERAGE: "%{BKY_MATH_ONLIST_TOOLTIP_AVERAGE}",
        MEDIAN: "%{BKY_MATH_ONLIST_TOOLTIP_MEDIAN}",
        MODE: "%{BKY_MATH_ONLIST_TOOLTIP_MODE}",
        STD_DEV: "%{BKY_MATH_ONLIST_TOOLTIP_STD_DEV}",
        RANDOM: "%{BKY_MATH_ONLIST_TOOLTIP_RANDOM}"
    };
    $.register$$module$build$src$core$extensions("math_op_tooltip", $.buildTooltipForDropdown$$module$build$src$core$extensions("OP", TOOLTIPS_BY_OP$$module$build$src$blocks$math));
    var IS_DIVISIBLEBY_MUTATOR_MIXIN$$module$build$src$blocks$math = {
        mutationToDom: function() {
            const a = $.createElement$$module$build$src$core$utils$xml("mutation"), b = "DIVISIBLE_BY" === this.getFieldValue("PROPERTY");
            a.setAttribute("divisor_input", String(b));
            return a;
        },
        domToMutation: function(a) {
            a = "true" === a.getAttribute("divisor_input");
            this.updateShape_(a);
        },
        updateShape_: function(a) {
            const b = this.getInput("DIVISOR");
            a ? b || this.appendValueInput("DIVISOR").setCheck("Number") : b && this.removeInput("DIVISOR");
        }
    }, IS_DIVISIBLE_MUTATOR_EXTENSION$$module$build$src$blocks$math = function() {
        this.getField("PROPERTY").setValidator(function(a) {
            a = "DIVISIBLE_BY" === a;
            this.getSourceBlock().updateShape_(a);
        });
    };
    $.registerMutator$$module$build$src$core$extensions("math_is_divisibleby_mutator", IS_DIVISIBLEBY_MUTATOR_MIXIN$$module$build$src$blocks$math, IS_DIVISIBLE_MUTATOR_EXTENSION$$module$build$src$blocks$math);
    $.register$$module$build$src$core$extensions("math_change_tooltip", $.buildTooltipWithFieldText$$module$build$src$core$extensions("%{BKY_MATH_CHANGE_TOOLTIP}", "VAR"));
    var LIST_MODES_MUTATOR_MIXIN$$module$build$src$blocks$math = {
        updateType_: function(a) {
            "MODE" === a ? this.outputConnection.setCheck("Array") : this.outputConnection.setCheck("Number");
        },
        mutationToDom: function() {
            const a = $.createElement$$module$build$src$core$utils$xml("mutation");
            a.setAttribute("op", this.getFieldValue("OP"));
            return a;
        },
        domToMutation: function(a) {
            a = a.getAttribute("op");
            if (null === a) throw new TypeError("xmlElement had no op attribute");
            this.updateType_(a);
        }
    }, LIST_MODES_MUTATOR_EXTENSION$$module$build$src$blocks$math = function() {
        this.getField("OP").setValidator((function(a) {
            this.updateType_(a);
        }).bind(this));
    };
    $.registerMutator$$module$build$src$core$extensions("math_modes_of_list_mutator", LIST_MODES_MUTATOR_MIXIN$$module$build$src$blocks$math, LIST_MODES_MUTATOR_EXTENSION$$module$build$src$blocks$math);
    $.defineBlocks$$module$build$src$core$common(blocks$$module$build$src$blocks$math);
    var module$build$src$blocks$math = {};
    module$build$src$blocks$math.blocks = blocks$$module$build$src$blocks$math;
    var module$exports$Blockly$libraryBlocks$procedures = {}, module$contents$Blockly$libraryBlocks$procedures_ContextMenu = $.module$build$src$core$contextmenu, module$contents$Blockly$libraryBlocks$procedures_Events = $.module$build$src$core$events$events, module$contents$Blockly$libraryBlocks$procedures_Procedures = $.module$build$src$core$procedures, module$contents$Blockly$libraryBlocks$procedures_Variables = $.module$build$src$core$variables, module$contents$Blockly$libraryBlocks$procedures_Xml = $.module$build$src$core$xml, module$contents$Blockly$libraryBlocks$procedures_fieldRegistry = $.module$build$src$core$field_registry, module$contents$Blockly$libraryBlocks$procedures_xmlUtils = $.module$build$src$core$utils$xml, module$contents$Blockly$libraryBlocks$procedures_Align = $.Align$$module$build$src$core$input, module$contents$Blockly$libraryBlocks$procedures_BlockDefinition = Object, module$contents$Blockly$libraryBlocks$procedures_config = $.config$$module$build$src$core$config, module$contents$Blockly$libraryBlocks$procedures_Msg = $.module$build$src$core$msg.Msg, module$contents$Blockly$libraryBlocks$procedures_Mutator = $.Mutator$$module$build$src$core$mutator, module$contents$Blockly$libraryBlocks$procedures_Names = $.module$build$src$core$names.Names, module$contents$Blockly$libraryBlocks$procedures_defineBlocks = $.module$build$src$core$common.defineBlocks;
    module$exports$Blockly$libraryBlocks$procedures.blocks = {};
    var module$contents$Blockly$libraryBlocks$procedures_PROCEDURE_DEF_COMMON = {
        setStatements_: function(a) {
            this.hasStatements_ !== a && (a ? (this.appendStatementInput("STACK").appendField(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_DEFNORETURN_DO), this.getInput("RETURN") && this.moveInputBefore("STACK", "RETURN")) : this.removeInput("STACK", !0), this.hasStatements_ = a);
        },
        updateParams_: function() {
            let a = "";
            this.arguments_.length && (a = module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_BEFORE_PARAMS + " " + this.arguments_.join(", "));
            $.module$build$src$core$events$events.disable();
            try {
                this.setFieldValue(a, "PARAMS");
            } finally{
                $.module$build$src$core$events$events.enable();
            }
        },
        mutationToDom: function(a) {
            const b = $.module$build$src$core$utils$xml.createElement("mutation");
            a && b.setAttribute("name", this.getFieldValue("NAME"));
            for(let c = 0; c < this.argumentVarModels_.length; c++){
                const d = $.module$build$src$core$utils$xml.createElement("arg"), e = this.argumentVarModels_[c];
                d.setAttribute("name", e.name);
                d.setAttribute("varid", e.getId());
                a && this.paramIds_ && d.setAttribute("paramId", this.paramIds_[c]);
                b.appendChild(d);
            }
            this.hasStatements_ || b.setAttribute("statements", "false");
            return b;
        },
        domToMutation: function(a) {
            this.arguments_ = [];
            this.argumentVarModels_ = [];
            for(let c = 0, d; d = a.childNodes[c]; c++)if ("arg" === d.nodeName.toLowerCase()) {
                const e = d.getAttribute("name");
                var b = d.getAttribute("varid") || d.getAttribute("varId");
                this.arguments_.push(e);
                b = $.module$build$src$core$variables.getOrCreateVariablePackage(this.workspace, b, e, "");
                null !== b ? this.argumentVarModels_.push(b) : console.log(`Failed to create a variable named "${e}", ignoring.`);
            }
            this.updateParams_();
            $.module$build$src$core$procedures.mutateCallers(this);
            this.setStatements_("false" !== a.getAttribute("statements"));
        },
        saveExtraState: function() {
            if (!this.argumentVarModels_.length && this.hasStatements_) return null;
            const a = Object.create(null);
            if (this.argumentVarModels_.length) {
                a.params = [];
                for(let b = 0; b < this.argumentVarModels_.length; b++)a.params.push({
                    name: this.argumentVarModels_[b].name,
                    id: this.argumentVarModels_[b].getId()
                });
            }
            this.hasStatements_ || (a.hasStatements = !1);
            return a;
        },
        loadExtraState: function(a) {
            this.arguments_ = [];
            this.argumentVarModels_ = [];
            if (a.params) for(let c = 0; c < a.params.length; c++){
                var b = a.params[c];
                b = $.module$build$src$core$variables.getOrCreateVariablePackage(this.workspace, b.id, b.name, "");
                this.arguments_.push(b.name);
                this.argumentVarModels_.push(b);
            }
            this.updateParams_();
            $.module$build$src$core$procedures.mutateCallers(this);
            this.setStatements_(!1 === a.hasStatements ? !1 : !0);
        },
        decompose: function(a) {
            const b = $.module$build$src$core$utils$xml.createElement("block");
            b.setAttribute("type", "procedures_mutatorcontainer");
            var c = $.module$build$src$core$utils$xml.createElement("statement");
            c.setAttribute("name", "STACK");
            b.appendChild(c);
            for(let e = 0; e < this.arguments_.length; e++){
                const f = $.module$build$src$core$utils$xml.createElement("block");
                f.setAttribute("type", "procedures_mutatorarg");
                var d = $.module$build$src$core$utils$xml.createElement("field");
                d.setAttribute("name", "NAME");
                const g = $.module$build$src$core$utils$xml.createTextNode(this.arguments_[e]);
                d.appendChild(g);
                f.appendChild(d);
                d = $.module$build$src$core$utils$xml.createElement("next");
                f.appendChild(d);
                c.appendChild(f);
                c = d;
            }
            a = $.module$build$src$core$xml.domToBlock(b, a);
            "procedures_defreturn" === this.type ? a.setFieldValue(this.hasStatements_, "STATEMENTS") : a.removeInput("STATEMENT_INPUT");
            $.module$build$src$core$procedures.mutateCallers(this);
            return a;
        },
        compose: function(a) {
            this.arguments_ = [];
            this.paramIds_ = [];
            this.argumentVarModels_ = [];
            let b = a.getInputTargetBlock("STACK");
            for(; b && !b.isInsertionMarker();){
                var c = b.getFieldValue("NAME");
                this.arguments_.push(c);
                c = this.workspace.getVariable(c, "");
                this.argumentVarModels_.push(c);
                this.paramIds_.push(b.id);
                b = b.nextConnection && b.nextConnection.targetBlock();
            }
            this.updateParams_();
            $.module$build$src$core$procedures.mutateCallers(this);
            a = a.getFieldValue("STATEMENTS");
            if (null !== a && (a = "TRUE" === a, this.hasStatements_ !== a)) {
                if (a) this.setStatements_(!0), $.Mutator$$module$build$src$core$mutator.reconnect(this.statementConnection_, this, "STACK"), this.statementConnection_ = null;
                else {
                    a = this.getInput("STACK").connection;
                    if (this.statementConnection_ = a.targetConnection) a = a.targetBlock(), a.unplug(), a.bumpNeighbours();
                    this.setStatements_(!1);
                }
            }
        },
        getVars: function() {
            return this.arguments_;
        },
        getVarModels: function() {
            return this.argumentVarModels_;
        },
        renameVarById: function(a, b) {
            var c = this.workspace.getVariableById(a);
            if ("" === c.type) {
                c = c.name;
                b = this.workspace.getVariableById(b);
                var d = !1;
                for(let e = 0; e < this.argumentVarModels_.length; e++)this.argumentVarModels_[e].getId() === a && (this.arguments_[e] = b.name, this.argumentVarModels_[e] = b, d = !0);
                d && (this.displayRenamedVar_(c, b.name), $.module$build$src$core$procedures.mutateCallers(this));
            }
        },
        updateVarName: function(a) {
            const b = a.name;
            let c = !1, d;
            for(let e = 0; e < this.argumentVarModels_.length; e++)this.argumentVarModels_[e].getId() === a.getId() && (d = this.arguments_[e], this.arguments_[e] = b, c = !0);
            c && (this.displayRenamedVar_(d, b), $.module$build$src$core$procedures.mutateCallers(this));
        },
        displayRenamedVar_: function(a, b) {
            this.updateParams_();
            if (this.mutator && this.mutator.isVisible()) {
                const c = this.mutator.workspace_.getAllBlocks(!1);
                for(let d = 0, e; e = c[d]; d++)"procedures_mutatorarg" === e.type && $.module$build$src$core$names.Names.equals(a, e.getFieldValue("NAME")) && e.setFieldValue(b, "NAME");
            }
        },
        customContextMenu: function(a) {
            if (!this.isInFlyout) {
                var b = {
                    enabled: !0
                }, c = this.getFieldValue("NAME");
                b.text = module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_CREATE_DO.replace("%1", c);
                var d = $.module$build$src$core$utils$xml.createElement("mutation");
                d.setAttribute("name", c);
                for(c = 0; c < this.arguments_.length; c++){
                    var e = $.module$build$src$core$utils$xml.createElement("arg");
                    e.setAttribute("name", this.arguments_[c]);
                    d.appendChild(e);
                }
                c = $.module$build$src$core$utils$xml.createElement("block");
                c.setAttribute("type", this.callType_);
                c.appendChild(d);
                b.callback = $.module$build$src$core$contextmenu.callbackFactory(this, c);
                a.push(b);
                if (!this.isCollapsed()) for(b = 0; b < this.argumentVarModels_.length; b++)d = {
                    enabled: !0
                }, c = this.argumentVarModels_[b], d.text = module$contents$Blockly$libraryBlocks$procedures_Msg.VARIABLES_SET_CREATE_GET.replace("%1", c.name), c = $.module$build$src$core$variables.generateVariableFieldDom(c), e = $.module$build$src$core$utils$xml.createElement("block"), e.setAttribute("type", "variables_get"), e.appendChild(c), d.callback = $.module$build$src$core$contextmenu.callbackFactory(this, e), a.push(d);
            }
        }
    };
    module$exports$Blockly$libraryBlocks$procedures.blocks.procedures_defnoreturn = Object.assign({}, module$contents$Blockly$libraryBlocks$procedures_PROCEDURE_DEF_COMMON, {
        init: function() {
            var a = $.module$build$src$core$procedures.findLegalName("", this);
            a = $.module$build$src$core$field_registry.fromJson({
                type: "field_input",
                text: a
            });
            a.setValidator($.module$build$src$core$procedures.rename);
            a.setSpellcheck(!1);
            this.appendDummyInput().appendField(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_DEFNORETURN_TITLE).appendField(a, "NAME").appendField("", "PARAMS");
            this.setMutator(new $.Mutator$$module$build$src$core$mutator([
                "procedures_mutatorarg"
            ], this));
            (this.workspace.options.comments || this.workspace.options.parentWorkspace && this.workspace.options.parentWorkspace.options.comments) && module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_DEFNORETURN_COMMENT && this.setCommentText(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_DEFNORETURN_COMMENT);
            this.setStyle("procedure_blocks");
            this.setTooltip(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_DEFNORETURN_TOOLTIP);
            this.setHelpUrl(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_DEFNORETURN_HELPURL);
            this.arguments_ = [];
            this.argumentVarModels_ = [];
            this.setStatements_(!0);
            this.statementConnection_ = null;
        },
        getProcedureDef: function() {
            return [
                this.getFieldValue("NAME"),
                this.arguments_,
                !1
            ];
        },
        callType_: "procedures_callnoreturn"
    });
    module$exports$Blockly$libraryBlocks$procedures.blocks.procedures_defreturn = Object.assign({}, module$contents$Blockly$libraryBlocks$procedures_PROCEDURE_DEF_COMMON, {
        init: function() {
            var a = $.module$build$src$core$procedures.findLegalName("", this);
            a = $.module$build$src$core$field_registry.fromJson({
                type: "field_input",
                text: a
            });
            a.setValidator($.module$build$src$core$procedures.rename);
            a.setSpellcheck(!1);
            this.appendDummyInput().appendField(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_DEFRETURN_TITLE).appendField(a, "NAME").appendField("", "PARAMS");
            this.appendValueInput("RETURN").setAlign($.Align$$module$build$src$core$input.RIGHT).appendField(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_DEFRETURN_RETURN);
            this.setMutator(new $.Mutator$$module$build$src$core$mutator([
                "procedures_mutatorarg"
            ], this));
            (this.workspace.options.comments || this.workspace.options.parentWorkspace && this.workspace.options.parentWorkspace.options.comments) && module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_DEFRETURN_COMMENT && this.setCommentText(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_DEFRETURN_COMMENT);
            this.setStyle("procedure_blocks");
            this.setTooltip(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_DEFRETURN_TOOLTIP);
            this.setHelpUrl(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_DEFRETURN_HELPURL);
            this.arguments_ = [];
            this.argumentVarModels_ = [];
            this.setStatements_(!0);
            this.statementConnection_ = null;
        },
        getProcedureDef: function() {
            return [
                this.getFieldValue("NAME"),
                this.arguments_,
                !0
            ];
        },
        callType_: "procedures_callreturn"
    });
    module$exports$Blockly$libraryBlocks$procedures.blocks.procedures_mutatorcontainer = {
        init: function() {
            this.appendDummyInput().appendField(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_MUTATORCONTAINER_TITLE);
            this.appendStatementInput("STACK");
            this.appendDummyInput("STATEMENT_INPUT").appendField(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_ALLOW_STATEMENTS).appendField($.module$build$src$core$field_registry.fromJson({
                type: "field_checkbox",
                checked: !0
            }), "STATEMENTS");
            this.setStyle("procedure_blocks");
            this.setTooltip(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_MUTATORCONTAINER_TOOLTIP);
            this.contextMenu = !1;
        }
    };
    module$exports$Blockly$libraryBlocks$procedures.blocks.procedures_mutatorarg = {
        init: function() {
            const a = $.module$build$src$core$field_registry.fromJson({
                type: "field_input",
                text: $.module$build$src$core$procedures.DEFAULT_ARG
            });
            a.setValidator(this.validator_);
            a.oldShowEditorFn_ = a.showEditor_;
            a.showEditor_ = function() {
                this.createdVariables_ = [];
                this.oldShowEditorFn_();
            };
            this.appendDummyInput().appendField(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_MUTATORARG_TITLE).appendField(a, "NAME");
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
            this.setStyle("procedure_blocks");
            this.setTooltip(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_MUTATORARG_TOOLTIP);
            this.contextMenu = !1;
            a.onFinishEditing_ = this.deleteIntermediateVars_;
            a.createdVariables_ = [];
            a.onFinishEditing_("x");
        },
        validator_: function(a) {
            var b = this.getSourceBlock();
            const c = $.Mutator$$module$build$src$core$mutator.findParentWs(b.workspace);
            a = a.replace(/[\s\xa0]+/g, " ").replace(/^ | $/g, "");
            if (!a) return null;
            const d = (b.workspace.targetWorkspace || b.workspace).getAllBlocks(!1), e = a.toLowerCase();
            for(let f = 0; f < d.length; f++){
                if (d[f].id === this.getSourceBlock().id) continue;
                const g = d[f].getFieldValue("NAME");
                if (g && g.toLowerCase() === e) return null;
            }
            if (b.isInFlyout) return a;
            (b = c.getVariable(a, "")) && b.name !== a && c.renameVariableById(b.getId(), a);
            b || (b = c.createVariable(a, "")) && this.createdVariables_ && this.createdVariables_.push(b);
            return a;
        },
        deleteIntermediateVars_: function(a) {
            const b = $.Mutator$$module$build$src$core$mutator.findParentWs(this.getSourceBlock().workspace);
            if (b) for(let c = 0; c < this.createdVariables_.length; c++){
                const d = this.createdVariables_[c];
                d.name !== a && b.deleteVariableById(d.getId());
            }
        }
    };
    var module$contents$Blockly$libraryBlocks$procedures_PROCEDURE_CALL_COMMON = {
        getProcedureCall: function() {
            return this.getFieldValue("NAME");
        },
        renameProcedure: function(a, b) {
            $.module$build$src$core$names.Names.equals(a, this.getProcedureCall()) && (this.setFieldValue(b, "NAME"), this.setTooltip((this.outputConnection ? module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_CALLRETURN_TOOLTIP : module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_CALLNORETURN_TOOLTIP).replace("%1", b)));
        },
        setProcedureParameters_: function(a, b) {
            var c = $.module$build$src$core$procedures.getDefinition(this.getProcedureCall(), this.workspace), d = c && c.mutator && c.mutator.isVisible();
            d ? this.setCollapsed(!1) : (this.quarkConnections_ = {}, this.quarkIds_ = null);
            if (a.join("\n") === this.arguments_.join("\n")) this.quarkIds_ = b;
            else {
                if (b.length !== a.length) throw RangeError("paramNames and paramIds must be the same length.");
                this.quarkIds_ || (this.quarkConnections_ = {}, this.quarkIds_ = []);
                c = this.rendered;
                this.rendered = !1;
                for(let f = 0; f < this.arguments_.length; f++){
                    var e = this.getInput("ARG" + f);
                    e && (e = e.connection.targetConnection, this.quarkConnections_[this.quarkIds_[f]] = e, d && e && -1 === b.indexOf(this.quarkIds_[f]) && (e.disconnect(), e.getSourceBlock().bumpNeighbours()));
                }
                this.arguments_ = [].concat(a);
                this.argumentVarModels_ = [];
                for(a = 0; a < this.arguments_.length; a++)d = $.module$build$src$core$variables.getOrCreateVariablePackage(this.workspace, null, this.arguments_[a], ""), this.argumentVarModels_.push(d);
                this.updateShape_();
                if (this.quarkIds_ = b) for(b = 0; b < this.arguments_.length; b++)a = this.quarkIds_[b], a in this.quarkConnections_ && ($.Mutator$$module$build$src$core$mutator.reconnect(this.quarkConnections_[a], this, "ARG" + b) || delete this.quarkConnections_[a]);
                (this.rendered = c) && this.render();
            }
        },
        updateShape_: function() {
            for(var a = 0; a < this.arguments_.length; a++){
                var b = this.getField("ARGNAME" + a);
                if (b) {
                    $.module$build$src$core$events$events.disable();
                    try {
                        b.setValue(this.arguments_[a]);
                    } finally{
                        $.module$build$src$core$events$events.enable();
                    }
                } else b = $.module$build$src$core$field_registry.fromJson({
                    type: "field_label",
                    text: this.arguments_[a]
                }), this.appendValueInput("ARG" + a).setAlign($.Align$$module$build$src$core$input.RIGHT).appendField(b, "ARGNAME" + a).init();
            }
            for(a = this.arguments_.length; this.getInput("ARG" + a); a++)this.removeInput("ARG" + a);
            if (a = this.getInput("TOPROW")) this.arguments_.length ? this.getField("WITH") || (a.appendField(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_CALL_BEFORE_PARAMS, "WITH"), a.init()) : this.getField("WITH") && a.removeField("WITH");
        },
        mutationToDom: function() {
            const a = $.module$build$src$core$utils$xml.createElement("mutation");
            a.setAttribute("name", this.getProcedureCall());
            for(let b = 0; b < this.arguments_.length; b++){
                const c = $.module$build$src$core$utils$xml.createElement("arg");
                c.setAttribute("name", this.arguments_[b]);
                a.appendChild(c);
            }
            return a;
        },
        domToMutation: function(a) {
            var b = a.getAttribute("name");
            this.renameProcedure(this.getProcedureCall(), b);
            b = [];
            const c = [];
            for(let d = 0, e; e = a.childNodes[d]; d++)"arg" === e.nodeName.toLowerCase() && (b.push(e.getAttribute("name")), c.push(e.getAttribute("paramId")));
            this.setProcedureParameters_(b, c);
        },
        saveExtraState: function() {
            const a = Object.create(null);
            a.name = this.getProcedureCall();
            this.arguments_.length && (a.params = this.arguments_);
            return a;
        },
        loadExtraState: function(a) {
            this.renameProcedure(this.getProcedureCall(), a.name);
            if (a = a.params) {
                const b = [];
                b.length = a.length;
                b.fill(null);
                this.setProcedureParameters_(a, b);
            }
        },
        getVars: function() {
            return this.arguments_;
        },
        getVarModels: function() {
            return this.argumentVarModels_;
        },
        onchange: function(a) {
            if (this.workspace && !this.workspace.isFlyout && a.recordUndo) {
                if (a.type === $.module$build$src$core$events$events.BLOCK_CREATE && -1 !== a.ids.indexOf(this.id)) {
                    var b = this.getProcedureCall();
                    b = $.module$build$src$core$procedures.getDefinition(b, this.workspace);
                    !b || b.type === this.defType_ && JSON.stringify(b.getVars()) === JSON.stringify(this.arguments_) || (b = null);
                    if (!b) {
                        $.module$build$src$core$events$events.setGroup(a.group);
                        a = $.module$build$src$core$utils$xml.createElement("xml");
                        b = $.module$build$src$core$utils$xml.createElement("block");
                        b.setAttribute("type", this.defType_);
                        var c = this.getRelativeToSurfaceXY(), d = c.y + 2 * $.config$$module$build$src$core$config.snapRadius;
                        b.setAttribute("x", c.x + $.config$$module$build$src$core$config.snapRadius * (this.RTL ? -1 : 1));
                        b.setAttribute("y", d);
                        c = this.mutationToDom();
                        b.appendChild(c);
                        c = $.module$build$src$core$utils$xml.createElement("field");
                        c.setAttribute("name", "NAME");
                        d = this.getProcedureCall();
                        const e = $.module$build$src$core$procedures.findLegalName(d, this);
                        d !== e && this.renameProcedure(d, e);
                        c.appendChild($.module$build$src$core$utils$xml.createTextNode(d));
                        b.appendChild(c);
                        a.appendChild(b);
                        $.module$build$src$core$xml.domToWorkspace(a, this.workspace);
                        $.module$build$src$core$events$events.setGroup(!1);
                    }
                } else a.type === $.module$build$src$core$events$events.BLOCK_DELETE ? (b = this.getProcedureCall(), $.module$build$src$core$procedures.getDefinition(b, this.workspace) || ($.module$build$src$core$events$events.setGroup(a.group), this.dispose(!0), $.module$build$src$core$events$events.setGroup(!1))) : a.type === $.module$build$src$core$events$events.CHANGE && "disabled" === a.element && (b = this.getProcedureCall(), (b = $.module$build$src$core$procedures.getDefinition(b, this.workspace)) && b.id === a.blockId && ((b = $.module$build$src$core$events$events.getGroup()) && console.log("Saw an existing group while responding to a definition change"), $.module$build$src$core$events$events.setGroup(a.group), a.newValue ? (this.previousEnabledState_ = this.isEnabled(), this.setEnabled(!1)) : this.setEnabled(this.previousEnabledState_), $.module$build$src$core$events$events.setGroup(b)));
            }
        },
        customContextMenu: function(a) {
            if (this.workspace.isMovable()) {
                var b = {
                    enabled: !0
                };
                b.text = module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_HIGHLIGHT_DEF;
                var c = this.getProcedureCall(), d = this.workspace;
                b.callback = function() {
                    const e = $.module$build$src$core$procedures.getDefinition(c, d);
                    e && (d.centerOnBlock(e.id), e.select());
                };
                a.push(b);
            }
        }
    };
    module$exports$Blockly$libraryBlocks$procedures.blocks.procedures_callnoreturn = Object.assign({}, module$contents$Blockly$libraryBlocks$procedures_PROCEDURE_CALL_COMMON, {
        init: function() {
            this.appendDummyInput("TOPROW").appendField("", "NAME");
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
            this.setStyle("procedure_blocks");
            this.setHelpUrl(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_CALLNORETURN_HELPURL);
            this.arguments_ = [];
            this.argumentVarModels_ = [];
            this.quarkConnections_ = {};
            this.quarkIds_ = null;
            this.previousEnabledState_ = !0;
        },
        defType_: "procedures_defnoreturn"
    });
    module$exports$Blockly$libraryBlocks$procedures.blocks.procedures_callreturn = Object.assign({}, module$contents$Blockly$libraryBlocks$procedures_PROCEDURE_CALL_COMMON, {
        init: function() {
            this.appendDummyInput("TOPROW").appendField("", "NAME");
            this.setOutput(!0);
            this.setStyle("procedure_blocks");
            this.setHelpUrl(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_CALLRETURN_HELPURL);
            this.arguments_ = [];
            this.argumentVarModels_ = [];
            this.quarkConnections_ = {};
            this.quarkIds_ = null;
            this.previousEnabledState_ = !0;
        },
        defType_: "procedures_defreturn"
    });
    module$exports$Blockly$libraryBlocks$procedures.blocks.procedures_ifreturn = {
        init: function() {
            this.appendValueInput("CONDITION").setCheck("Boolean").appendField(module$contents$Blockly$libraryBlocks$procedures_Msg.CONTROLS_IF_MSG_IF);
            this.appendValueInput("VALUE").appendField(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_DEFRETURN_RETURN);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
            this.setStyle("procedure_blocks");
            this.setTooltip(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_IFRETURN_TOOLTIP);
            this.setHelpUrl(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_IFRETURN_HELPURL);
            this.hasReturnValue_ = !0;
        },
        mutationToDom: function() {
            const a = $.module$build$src$core$utils$xml.createElement("mutation");
            a.setAttribute("value", Number(this.hasReturnValue_));
            return a;
        },
        domToMutation: function(a) {
            this.hasReturnValue_ = "1" === a.getAttribute("value");
            this.hasReturnValue_ || (this.removeInput("VALUE"), this.appendDummyInput("VALUE").appendField(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_DEFRETURN_RETURN));
        },
        onchange: function(a) {
            if (!(this.workspace.isDragging && this.workspace.isDragging() || a.type !== $.module$build$src$core$events$events.BLOCK_MOVE)) {
                var b = !1, c = this;
                do {
                    if (-1 !== this.FUNCTION_TYPES.indexOf(c.type)) {
                        b = !0;
                        break;
                    }
                    c = c.getSurroundParent();
                }while (c);
                b ? ("procedures_defnoreturn" === c.type && this.hasReturnValue_ ? (this.removeInput("VALUE"), this.appendDummyInput("VALUE").appendField(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_DEFRETURN_RETURN), this.hasReturnValue_ = !1) : "procedures_defreturn" !== c.type || this.hasReturnValue_ || (this.removeInput("VALUE"), this.appendValueInput("VALUE").appendField(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_DEFRETURN_RETURN), this.hasReturnValue_ = !0), this.setWarningText(null)) : this.setWarningText(module$contents$Blockly$libraryBlocks$procedures_Msg.PROCEDURES_IFRETURN_WARNING);
                this.isInFlyout || (c = $.module$build$src$core$events$events.getGroup(), $.module$build$src$core$events$events.setGroup(a.group), this.setEnabled(b), $.module$build$src$core$events$events.setGroup(c));
            }
        },
        FUNCTION_TYPES: [
            "procedures_defnoreturn",
            "procedures_defreturn"
        ]
    };
    module$contents$Blockly$libraryBlocks$procedures_defineBlocks(module$exports$Blockly$libraryBlocks$procedures.blocks);
    var module$exports$Blockly$libraryBlocks$texts = {}, module$contents$Blockly$libraryBlocks$texts_Extensions = $.module$build$src$core$extensions, module$contents$Blockly$libraryBlocks$texts_Msg = $.module$build$src$core$msg.Msg, module$contents$Blockly$libraryBlocks$texts_fieldRegistry = $.module$build$src$core$field_registry, module$contents$Blockly$libraryBlocks$texts_xmlUtils = $.module$build$src$core$utils$xml, module$contents$Blockly$libraryBlocks$texts_Align = $.Align$$module$build$src$core$input, module$contents$Blockly$libraryBlocks$texts_BlockDefinition = Object, module$contents$Blockly$libraryBlocks$texts_ConnectionType = $.module$build$src$core$connection_type.ConnectionType, module$contents$Blockly$libraryBlocks$texts_Mutator = $.Mutator$$module$build$src$core$mutator, module$contents$Blockly$libraryBlocks$texts_createBlockDefinitionsFromJsonArray = $.module$build$src$core$common.createBlockDefinitionsFromJsonArray, module$contents$Blockly$libraryBlocks$texts_defineBlocks = $.module$build$src$core$common.defineBlocks;
    module$exports$Blockly$libraryBlocks$texts.blocks = module$contents$Blockly$libraryBlocks$texts_createBlockDefinitionsFromJsonArray([
        {
            type: "text",
            message0: "%1",
            args0: [
                {
                    type: "field_input",
                    name: "TEXT",
                    text: ""
                }
            ],
            output: "String",
            style: "text_blocks",
            helpUrl: "%{BKY_TEXT_TEXT_HELPURL}",
            tooltip: "%{BKY_TEXT_TEXT_TOOLTIP}",
            extensions: [
                "text_quotes",
                "parent_tooltip_when_inline"
            ]
        },
        {
            type: "text_multiline",
            message0: "%1 %2",
            args0: [
                {
                    type: "field_image",
                    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAARCAYAAADpPU2iAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAdhgAAHYYBXaITgQAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMS42/U4J6AAAAP1JREFUOE+Vks0KQUEYhjmRIja4ABtZ2dm5A3t3Ia6AUm7CylYuQRaUhZSlLZJiQbFAyRnPN33y01HOW08z8873zpwzM4F3GWOCruvGIE4/rLaV+Nq1hVGMBqzhqlxgCys4wJA65xnogMHsQ5lujnYHTejBBCK2mE4abjCgMGhNxHgDFWjDSG07kdfVa2pZMf4ZyMAdWmpZMfYOsLiDMYMjlMB+K613QISRhTnITnsYg5yUd0DETmEoMlkFOeIT/A58iyK5E18BuTBfgYXfwNJv4P9/oEBerLylOnRhygmGdPpTTBZAPkde61lbQe4moWUvYUZYLfUNftIY4zwA5X2Z9AYnQrEAAAAASUVORK5CYII=",
                    width: 12,
                    height: 17,
                    alt: "\xb6"
                },
                {
                    type: "field_multilinetext",
                    name: "TEXT",
                    text: ""
                }
            ],
            output: "String",
            style: "text_blocks",
            helpUrl: "%{BKY_TEXT_TEXT_HELPURL}",
            tooltip: "%{BKY_TEXT_TEXT_TOOLTIP}",
            extensions: [
                "parent_tooltip_when_inline"
            ]
        },
        {
            type: "text_join",
            message0: "",
            output: "String",
            style: "text_blocks",
            helpUrl: "%{BKY_TEXT_JOIN_HELPURL}",
            tooltip: "%{BKY_TEXT_JOIN_TOOLTIP}",
            mutator: "text_join_mutator"
        },
        {
            type: "text_create_join_container",
            message0: "%{BKY_TEXT_CREATE_JOIN_TITLE_JOIN} %1 %2",
            args0: [
                {
                    type: "input_dummy"
                },
                {
                    type: "input_statement",
                    name: "STACK"
                }
            ],
            style: "text_blocks",
            tooltip: "%{BKY_TEXT_CREATE_JOIN_TOOLTIP}",
            enableContextMenu: !1
        },
        {
            type: "text_create_join_item",
            message0: "%{BKY_TEXT_CREATE_JOIN_ITEM_TITLE_ITEM}",
            previousStatement: null,
            nextStatement: null,
            style: "text_blocks",
            tooltip: "%{BKY_TEXT_CREATE_JOIN_ITEM_TOOLTIP}",
            enableContextMenu: !1
        },
        {
            type: "text_append",
            message0: "%{BKY_TEXT_APPEND_TITLE}",
            args0: [
                {
                    type: "field_variable",
                    name: "VAR",
                    variable: "%{BKY_TEXT_APPEND_VARIABLE}"
                },
                {
                    type: "input_value",
                    name: "TEXT"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "text_blocks",
            extensions: [
                "text_append_tooltip"
            ]
        },
        {
            type: "text_length",
            message0: "%{BKY_TEXT_LENGTH_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "VALUE",
                    check: [
                        "String",
                        "Array"
                    ]
                }
            ],
            output: "Number",
            style: "text_blocks",
            tooltip: "%{BKY_TEXT_LENGTH_TOOLTIP}",
            helpUrl: "%{BKY_TEXT_LENGTH_HELPURL}"
        },
        {
            type: "text_isEmpty",
            message0: "%{BKY_TEXT_ISEMPTY_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "VALUE",
                    check: [
                        "String",
                        "Array"
                    ]
                }
            ],
            output: "Boolean",
            style: "text_blocks",
            tooltip: "%{BKY_TEXT_ISEMPTY_TOOLTIP}",
            helpUrl: "%{BKY_TEXT_ISEMPTY_HELPURL}"
        },
        {
            type: "text_indexOf",
            message0: "%{BKY_TEXT_INDEXOF_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "VALUE",
                    check: "String"
                },
                {
                    type: "field_dropdown",
                    name: "END",
                    options: [
                        [
                            "%{BKY_TEXT_INDEXOF_OPERATOR_FIRST}",
                            "FIRST"
                        ],
                        [
                            "%{BKY_TEXT_INDEXOF_OPERATOR_LAST}",
                            "LAST"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "FIND",
                    check: "String"
                }
            ],
            output: "Number",
            style: "text_blocks",
            helpUrl: "%{BKY_TEXT_INDEXOF_HELPURL}",
            inputsInline: !0,
            extensions: [
                "text_indexOf_tooltip"
            ]
        },
        {
            type: "text_charAt",
            message0: "%{BKY_TEXT_CHARAT_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "VALUE",
                    check: "String"
                },
                {
                    type: "field_dropdown",
                    name: "WHERE",
                    options: [
                        [
                            "%{BKY_TEXT_CHARAT_FROM_START}",
                            "FROM_START"
                        ],
                        [
                            "%{BKY_TEXT_CHARAT_FROM_END}",
                            "FROM_END"
                        ],
                        [
                            "%{BKY_TEXT_CHARAT_FIRST}",
                            "FIRST"
                        ],
                        [
                            "%{BKY_TEXT_CHARAT_LAST}",
                            "LAST"
                        ],
                        [
                            "%{BKY_TEXT_CHARAT_RANDOM}",
                            "RANDOM"
                        ]
                    ]
                }
            ],
            output: "String",
            style: "text_blocks",
            helpUrl: "%{BKY_TEXT_CHARAT_HELPURL}",
            inputsInline: !0,
            mutator: "text_charAt_mutator"
        }
    ]);
    module$exports$Blockly$libraryBlocks$texts.blocks.text_getSubstring = {
        init: function() {
            this.WHERE_OPTIONS_1 = [
                [
                    module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_GET_SUBSTRING_START_FROM_START,
                    "FROM_START"
                ],
                [
                    module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_GET_SUBSTRING_START_FROM_END,
                    "FROM_END"
                ],
                [
                    module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_GET_SUBSTRING_START_FIRST,
                    "FIRST"
                ]
            ];
            this.WHERE_OPTIONS_2 = [
                [
                    module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_GET_SUBSTRING_END_FROM_START,
                    "FROM_START"
                ],
                [
                    module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_GET_SUBSTRING_END_FROM_END,
                    "FROM_END"
                ],
                [
                    module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_GET_SUBSTRING_END_LAST,
                    "LAST"
                ]
            ];
            this.setHelpUrl(module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_GET_SUBSTRING_HELPURL);
            this.setStyle("text_blocks");
            this.appendValueInput("STRING").setCheck("String").appendField(module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_GET_SUBSTRING_INPUT_IN_TEXT);
            this.appendDummyInput("AT1");
            this.appendDummyInput("AT2");
            module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_GET_SUBSTRING_TAIL && this.appendDummyInput("TAIL").appendField(module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_GET_SUBSTRING_TAIL);
            this.setInputsInline(!0);
            this.setOutput(!0, "String");
            this.updateAt_(1, !0);
            this.updateAt_(2, !0);
            this.setTooltip(module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_GET_SUBSTRING_TOOLTIP);
        },
        mutationToDom: function() {
            const a = $.module$build$src$core$utils$xml.createElement("mutation");
            var b = this.getInput("AT1").type === $.module$build$src$core$connection_type.ConnectionType.INPUT_VALUE;
            a.setAttribute("at1", b);
            b = this.getInput("AT2").type === $.module$build$src$core$connection_type.ConnectionType.INPUT_VALUE;
            a.setAttribute("at2", b);
            return a;
        },
        domToMutation: function(a) {
            const b = "true" === a.getAttribute("at1");
            a = "true" === a.getAttribute("at2");
            this.updateAt_(1, b);
            this.updateAt_(2, a);
        },
        updateAt_: function(a, b) {
            this.removeInput("AT" + a);
            this.removeInput("ORDINAL" + a, !0);
            b ? (this.appendValueInput("AT" + a).setCheck("Number"), module$contents$Blockly$libraryBlocks$texts_Msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL" + a).appendField(module$contents$Blockly$libraryBlocks$texts_Msg.ORDINAL_NUMBER_SUFFIX)) : this.appendDummyInput("AT" + a);
            2 === a && module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_GET_SUBSTRING_TAIL && (this.removeInput("TAIL", !0), this.appendDummyInput("TAIL").appendField(module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_GET_SUBSTRING_TAIL));
            const c = $.module$build$src$core$field_registry.fromJson({
                type: "field_dropdown",
                options: this["WHERE_OPTIONS_" + a]
            });
            c.setValidator(function(d) {
                const e = "FROM_START" === d || "FROM_END" === d;
                if (e !== b) {
                    const f = this.getSourceBlock();
                    f.updateAt_(a, e);
                    f.setFieldValue(d, "WHERE" + a);
                    return null;
                }
            });
            this.getInput("AT" + a).appendField(c, "WHERE" + a);
            1 === a && (this.moveInputBefore("AT1", "AT2"), this.getInput("ORDINAL1") && this.moveInputBefore("ORDINAL1", "AT2"));
        }
    };
    module$exports$Blockly$libraryBlocks$texts.blocks.text_changeCase = {
        init: function() {
            const a = [
                [
                    module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_CHANGECASE_OPERATOR_UPPERCASE,
                    "UPPERCASE"
                ],
                [
                    module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_CHANGECASE_OPERATOR_LOWERCASE,
                    "LOWERCASE"
                ],
                [
                    module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_CHANGECASE_OPERATOR_TITLECASE,
                    "TITLECASE"
                ]
            ];
            this.setHelpUrl(module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_CHANGECASE_HELPURL);
            this.setStyle("text_blocks");
            this.appendValueInput("TEXT").setCheck("String").appendField($.module$build$src$core$field_registry.fromJson({
                type: "field_dropdown",
                options: a
            }), "CASE");
            this.setOutput(!0, "String");
            this.setTooltip(module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_CHANGECASE_TOOLTIP);
        }
    };
    module$exports$Blockly$libraryBlocks$texts.blocks.text_trim = {
        init: function() {
            const a = [
                [
                    module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_TRIM_OPERATOR_BOTH,
                    "BOTH"
                ],
                [
                    module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_TRIM_OPERATOR_LEFT,
                    "LEFT"
                ],
                [
                    module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_TRIM_OPERATOR_RIGHT,
                    "RIGHT"
                ]
            ];
            this.setHelpUrl(module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_TRIM_HELPURL);
            this.setStyle("text_blocks");
            this.appendValueInput("TEXT").setCheck("String").appendField($.module$build$src$core$field_registry.fromJson({
                type: "field_dropdown",
                options: a
            }), "MODE");
            this.setOutput(!0, "String");
            this.setTooltip(module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_TRIM_TOOLTIP);
        }
    };
    module$exports$Blockly$libraryBlocks$texts.blocks.text_print = {
        init: function() {
            this.jsonInit({
                message0: module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_PRINT_TITLE,
                args0: [
                    {
                        type: "input_value",
                        name: "TEXT"
                    }
                ],
                previousStatement: null,
                nextStatement: null,
                style: "text_blocks",
                tooltip: module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_PRINT_TOOLTIP,
                helpUrl: module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_PRINT_HELPURL
            });
        }
    };
    var module$contents$Blockly$libraryBlocks$texts_TEXT_PROMPT_COMMON = {
        updateType_: function(a) {
            this.outputConnection.setCheck("NUMBER" === a ? "Number" : "String");
        },
        mutationToDom: function() {
            const a = $.module$build$src$core$utils$xml.createElement("mutation");
            a.setAttribute("type", this.getFieldValue("TYPE"));
            return a;
        },
        domToMutation: function(a) {
            this.updateType_(a.getAttribute("type"));
        }
    };
    module$exports$Blockly$libraryBlocks$texts.blocks.text_prompt_ext = Object.assign({}, module$contents$Blockly$libraryBlocks$texts_TEXT_PROMPT_COMMON, {
        init: function() {
            var a = [
                [
                    module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_PROMPT_TYPE_TEXT,
                    "TEXT"
                ],
                [
                    module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_PROMPT_TYPE_NUMBER,
                    "NUMBER"
                ]
            ];
            this.setHelpUrl(module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_PROMPT_HELPURL);
            this.setStyle("text_blocks");
            const b = this;
            a = $.module$build$src$core$field_registry.fromJson({
                type: "field_dropdown",
                options: a
            });
            a.setValidator(function(c) {
                b.updateType_(c);
            });
            this.appendValueInput("TEXT").appendField(a, "TYPE");
            this.setOutput(!0, "String");
            this.setTooltip(function() {
                return "TEXT" === b.getFieldValue("TYPE") ? module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_PROMPT_TOOLTIP_TEXT : module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_PROMPT_TOOLTIP_NUMBER;
            });
        }
    });
    module$exports$Blockly$libraryBlocks$texts.blocks.text_prompt = Object.assign({}, module$contents$Blockly$libraryBlocks$texts_TEXT_PROMPT_COMMON, {
        init: function() {
            this.mixin(module$contents$Blockly$libraryBlocks$texts_QUOTE_IMAGE_MIXIN);
            var a = [
                [
                    module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_PROMPT_TYPE_TEXT,
                    "TEXT"
                ],
                [
                    module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_PROMPT_TYPE_NUMBER,
                    "NUMBER"
                ]
            ];
            const b = this;
            this.setHelpUrl(module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_PROMPT_HELPURL);
            this.setStyle("text_blocks");
            a = $.module$build$src$core$field_registry.fromJson({
                type: "field_dropdown",
                options: a
            });
            a.setValidator(function(c) {
                b.updateType_(c);
            });
            this.appendDummyInput().appendField(a, "TYPE").appendField(this.newQuote_(!0)).appendField($.module$build$src$core$field_registry.fromJson({
                type: "field_input",
                text: ""
            }), "TEXT").appendField(this.newQuote_(!1));
            this.setOutput(!0, "String");
            this.setTooltip(function() {
                return "TEXT" === b.getFieldValue("TYPE") ? module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_PROMPT_TOOLTIP_TEXT : module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_PROMPT_TOOLTIP_NUMBER;
            });
        }
    });
    module$exports$Blockly$libraryBlocks$texts.blocks.text_count = {
        init: function() {
            this.jsonInit({
                message0: module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_COUNT_MESSAGE0,
                args0: [
                    {
                        type: "input_value",
                        name: "SUB",
                        check: "String"
                    },
                    {
                        type: "input_value",
                        name: "TEXT",
                        check: "String"
                    }
                ],
                output: "Number",
                inputsInline: !0,
                style: "text_blocks",
                tooltip: module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_COUNT_TOOLTIP,
                helpUrl: module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_COUNT_HELPURL
            });
        }
    };
    module$exports$Blockly$libraryBlocks$texts.blocks.text_replace = {
        init: function() {
            this.jsonInit({
                message0: module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_REPLACE_MESSAGE0,
                args0: [
                    {
                        type: "input_value",
                        name: "FROM",
                        check: "String"
                    },
                    {
                        type: "input_value",
                        name: "TO",
                        check: "String"
                    },
                    {
                        type: "input_value",
                        name: "TEXT",
                        check: "String"
                    }
                ],
                output: "String",
                inputsInline: !0,
                style: "text_blocks",
                tooltip: module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_REPLACE_TOOLTIP,
                helpUrl: module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_REPLACE_HELPURL
            });
        }
    };
    module$exports$Blockly$libraryBlocks$texts.blocks.text_reverse = {
        init: function() {
            this.jsonInit({
                message0: module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_REVERSE_MESSAGE0,
                args0: [
                    {
                        type: "input_value",
                        name: "TEXT",
                        check: "String"
                    }
                ],
                output: "String",
                inputsInline: !0,
                style: "text_blocks",
                tooltip: module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_REVERSE_TOOLTIP,
                helpUrl: module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_REVERSE_HELPURL
            });
        }
    };
    var module$contents$Blockly$libraryBlocks$texts_QUOTE_IMAGE_MIXIN = {
        QUOTE_IMAGE_LEFT_DATAURI: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAQAAAAqJXdxAAAAn0lEQVQI1z3OMa5BURSF4f/cQhAKjUQhuQmFNwGJEUi0RKN5rU7FHKhpjEH3TEMtkdBSCY1EIv8r7nFX9e29V7EBAOvu7RPjwmWGH/VuF8CyN9/OAdvqIXYLvtRaNjx9mMTDyo+NjAN1HNcl9ZQ5oQMM3dgDUqDo1l8DzvwmtZN7mnD+PkmLa+4mhrxVA9fRowBWmVBhFy5gYEjKMfz9AylsaRRgGzvZAAAAAElFTkSuQmCC",
        QUOTE_IMAGE_RIGHT_DATAURI: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAQAAAAqJXdxAAAAqUlEQVQI1z3KvUpCcRiA8ef9E4JNHhI0aFEacm1o0BsI0Slx8wa8gLauoDnoBhq7DcfWhggONDmJJgqCPA7neJ7p934EOOKOnM8Q7PDElo/4x4lFb2DmuUjcUzS3URnGib9qaPNbuXvBO3sGPHJDRG6fGVdMSeWDP2q99FQdFrz26Gu5Tq7dFMzUvbXy8KXeAj57cOklgA+u1B5AoslLtGIHQMaCVnwDnADZIFIrXsoXrgAAAABJRU5ErkJggg==",
        QUOTE_IMAGE_WIDTH: 12,
        QUOTE_IMAGE_HEIGHT: 12,
        quoteField_: function(a) {
            for(let b = 0, c; c = this.inputList[b]; b++)for(let d = 0, e; e = c.fieldRow[d]; d++)if (a === e.name) {
                c.insertFieldAt(d, this.newQuote_(!0));
                c.insertFieldAt(d + 2, this.newQuote_(!1));
                return;
            }
            console.warn('field named "' + a + '" not found in ' + this.toDevString());
        },
        newQuote_: function(a) {
            a = this.RTL ? !a : a;
            return $.module$build$src$core$field_registry.fromJson({
                type: "field_image",
                src: a ? this.QUOTE_IMAGE_LEFT_DATAURI : this.QUOTE_IMAGE_RIGHT_DATAURI,
                width: this.QUOTE_IMAGE_WIDTH,
                height: this.QUOTE_IMAGE_HEIGHT,
                alt: a ? "\u201C" : "\u201D"
            });
        }
    }, module$contents$Blockly$libraryBlocks$texts_TEXT_QUOTES_EXTENSION = function() {
        this.mixin(module$contents$Blockly$libraryBlocks$texts_QUOTE_IMAGE_MIXIN);
        this.quoteField_("TEXT");
    }, module$contents$Blockly$libraryBlocks$texts_TEXT_JOIN_MUTATOR_MIXIN = {
        mutationToDom: function() {
            const a = $.module$build$src$core$utils$xml.createElement("mutation");
            a.setAttribute("items", this.itemCount_);
            return a;
        },
        domToMutation: function(a) {
            this.itemCount_ = parseInt(a.getAttribute("items"), 10);
            this.updateShape_();
        },
        saveExtraState: function() {
            return {
                itemCount: this.itemCount_
            };
        },
        loadExtraState: function(a) {
            this.itemCount_ = a.itemCount;
            this.updateShape_();
        },
        decompose: function(a) {
            const b = a.newBlock("text_create_join_container");
            b.initSvg();
            let c = b.getInput("STACK").connection;
            for(let d = 0; d < this.itemCount_; d++){
                const e = a.newBlock("text_create_join_item");
                e.initSvg();
                c.connect(e.previousConnection);
                c = e.nextConnection;
            }
            return b;
        },
        compose: function(a) {
            var b = a.getInputTargetBlock("STACK");
            for(a = []; b;)b.isInsertionMarker() || a.push(b.valueConnection_), b = b.getNextBlock();
            for(b = 0; b < this.itemCount_; b++){
                const c = this.getInput("ADD" + b).connection.targetConnection;
                c && -1 === a.indexOf(c) && c.disconnect();
            }
            this.itemCount_ = a.length;
            this.updateShape_();
            for(b = 0; b < this.itemCount_; b++)$.Mutator$$module$build$src$core$mutator.reconnect(a[b], this, "ADD" + b);
        },
        saveConnections: function(a) {
            a = a.getInputTargetBlock("STACK");
            let b = 0;
            for(; a;){
                if (a.isInsertionMarker()) {
                    a = a.getNextBlock();
                    continue;
                }
                const c = this.getInput("ADD" + b);
                a.valueConnection_ = c && c.connection.targetConnection;
                a = a.getNextBlock();
                b++;
            }
        },
        updateShape_: function() {
            this.itemCount_ && this.getInput("EMPTY") ? this.removeInput("EMPTY") : this.itemCount_ || this.getInput("EMPTY") || this.appendDummyInput("EMPTY").appendField(this.newQuote_(!0)).appendField(this.newQuote_(!1));
            for(var a = 0; a < this.itemCount_; a++)if (!this.getInput("ADD" + a)) {
                const b = this.appendValueInput("ADD" + a).setAlign($.Align$$module$build$src$core$input.RIGHT);
                0 === a && b.appendField(module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_JOIN_TITLE_CREATEWITH);
            }
            for(a = this.itemCount_; this.getInput("ADD" + a); a++)this.removeInput("ADD" + a);
        }
    }, module$contents$Blockly$libraryBlocks$texts_TEXT_JOIN_EXTENSION = function() {
        this.mixin(module$contents$Blockly$libraryBlocks$texts_QUOTE_IMAGE_MIXIN);
        this.itemCount_ = 2;
        this.updateShape_();
        this.setMutator(new $.Mutator$$module$build$src$core$mutator([
            "text_create_join_item"
        ], this));
    };
    $.module$build$src$core$extensions.register("text_append_tooltip", $.module$build$src$core$extensions.buildTooltipWithFieldText("%{BKY_TEXT_APPEND_TOOLTIP}", "VAR"));
    var module$contents$Blockly$libraryBlocks$texts_TEXT_INDEXOF_TOOLTIP_EXTENSION = function() {
        const a = this;
        this.setTooltip(function() {
            return module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_INDEXOF_TOOLTIP.replace("%1", a.workspace.options.oneBasedIndex ? "0" : "-1");
        });
    }, module$contents$Blockly$libraryBlocks$texts_TEXT_CHARAT_MUTATOR_MIXIN = {
        mutationToDom: function() {
            const a = $.module$build$src$core$utils$xml.createElement("mutation");
            a.setAttribute("at", !!this.isAt_);
            return a;
        },
        domToMutation: function(a) {
            a = "false" !== a.getAttribute("at");
            this.updateAt_(a);
        },
        updateAt_: function(a) {
            this.removeInput("AT", !0);
            this.removeInput("ORDINAL", !0);
            a && (this.appendValueInput("AT").setCheck("Number"), module$contents$Blockly$libraryBlocks$texts_Msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL").appendField(module$contents$Blockly$libraryBlocks$texts_Msg.ORDINAL_NUMBER_SUFFIX));
            module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_CHARAT_TAIL && (this.removeInput("TAIL", !0), this.appendDummyInput("TAIL").appendField(module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_CHARAT_TAIL));
            this.isAt_ = a;
        }
    }, module$contents$Blockly$libraryBlocks$texts_TEXT_CHARAT_EXTENSION = function() {
        this.getField("WHERE").setValidator(function(b) {
            b = "FROM_START" === b || "FROM_END" === b;
            b !== this.isAt_ && this.getSourceBlock().updateAt_(b);
        });
        this.updateAt_(!0);
        const a = this;
        this.setTooltip(function() {
            var b = a.getFieldValue("WHERE");
            let c = module$contents$Blockly$libraryBlocks$texts_Msg.TEXT_CHARAT_TOOLTIP;
            ("FROM_START" === b || "FROM_END" === b) && (b = "FROM_START" === b ? module$contents$Blockly$libraryBlocks$texts_Msg.LISTS_INDEX_FROM_START_TOOLTIP : module$contents$Blockly$libraryBlocks$texts_Msg.LISTS_INDEX_FROM_END_TOOLTIP) && (c += "  " + b.replace("%1", a.workspace.options.oneBasedIndex ? "#1" : "#0"));
            return c;
        });
    };
    $.module$build$src$core$extensions.register("text_indexOf_tooltip", module$contents$Blockly$libraryBlocks$texts_TEXT_INDEXOF_TOOLTIP_EXTENSION);
    $.module$build$src$core$extensions.register("text_quotes", module$contents$Blockly$libraryBlocks$texts_TEXT_QUOTES_EXTENSION);
    $.module$build$src$core$extensions.registerMutator("text_join_mutator", module$contents$Blockly$libraryBlocks$texts_TEXT_JOIN_MUTATOR_MIXIN, module$contents$Blockly$libraryBlocks$texts_TEXT_JOIN_EXTENSION);
    $.module$build$src$core$extensions.registerMutator("text_charAt_mutator", module$contents$Blockly$libraryBlocks$texts_TEXT_CHARAT_MUTATOR_MIXIN, module$contents$Blockly$libraryBlocks$texts_TEXT_CHARAT_EXTENSION);
    module$contents$Blockly$libraryBlocks$texts_defineBlocks(module$exports$Blockly$libraryBlocks$texts.blocks);
    var module$exports$Blockly$libraryBlocks$variables = {}, module$contents$Blockly$libraryBlocks$variables_ContextMenu = $.module$build$src$core$contextmenu, module$contents$Blockly$libraryBlocks$variables_Extensions = $.module$build$src$core$extensions, module$contents$Blockly$libraryBlocks$variables_Variables = $.module$build$src$core$variables, module$contents$Blockly$libraryBlocks$variables_xmlUtils = $.module$build$src$core$utils$xml, module$contents$Blockly$libraryBlocks$variables_BlockDefinition = Object, module$contents$Blockly$libraryBlocks$variables_Msg = $.module$build$src$core$msg.Msg, module$contents$Blockly$libraryBlocks$variables_createBlockDefinitionsFromJsonArray = $.module$build$src$core$common.createBlockDefinitionsFromJsonArray, module$contents$Blockly$libraryBlocks$variables_defineBlocks = $.module$build$src$core$common.defineBlocks;
    module$exports$Blockly$libraryBlocks$variables.blocks = module$contents$Blockly$libraryBlocks$variables_createBlockDefinitionsFromJsonArray([
        {
            type: "variables_get",
            message0: "%1",
            args0: [
                {
                    type: "field_variable",
                    name: "VAR",
                    variable: "%{BKY_VARIABLES_DEFAULT_NAME}"
                }
            ],
            output: null,
            style: "variable_blocks",
            helpUrl: "%{BKY_VARIABLES_GET_HELPURL}",
            tooltip: "%{BKY_VARIABLES_GET_TOOLTIP}",
            extensions: [
                "contextMenu_variableSetterGetter"
            ]
        },
        {
            type: "variables_set",
            message0: "%{BKY_VARIABLES_SET}",
            args0: [
                {
                    type: "field_variable",
                    name: "VAR",
                    variable: "%{BKY_VARIABLES_DEFAULT_NAME}"
                },
                {
                    type: "input_value",
                    name: "VALUE"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "variable_blocks",
            tooltip: "%{BKY_VARIABLES_SET_TOOLTIP}",
            helpUrl: "%{BKY_VARIABLES_SET_HELPURL}",
            extensions: [
                "contextMenu_variableSetterGetter"
            ]
        }
    ]);
    var module$contents$Blockly$libraryBlocks$variables_CUSTOM_CONTEXT_MENU_VARIABLE_GETTER_SETTER_MIXIN = {
        customContextMenu: function(a) {
            if (!this.isInFlyout) {
                if ("variables_get" === this.type) {
                    var b = "variables_set";
                    var c = module$contents$Blockly$libraryBlocks$variables_Msg.VARIABLES_GET_CREATE_SET;
                } else b = "variables_get", c = module$contents$Blockly$libraryBlocks$variables_Msg.VARIABLES_SET_CREATE_GET;
                var d = {
                    enabled: 0 < this.workspace.remainingCapacity()
                }, e = this.getField("VAR").getText();
                d.text = c.replace("%1", e);
                c = $.module$build$src$core$utils$xml.createElement("field");
                c.setAttribute("name", "VAR");
                c.appendChild($.module$build$src$core$utils$xml.createTextNode(e));
                e = $.module$build$src$core$utils$xml.createElement("block");
                e.setAttribute("type", b);
                e.appendChild(c);
                d.callback = $.module$build$src$core$contextmenu.callbackFactory(this, e);
                a.push(d);
            } else if ("variables_get" === this.type || "variables_get_reporter" === this.type) b = {
                text: module$contents$Blockly$libraryBlocks$variables_Msg.RENAME_VARIABLE,
                enabled: !0,
                callback: module$contents$Blockly$libraryBlocks$variables_renameOptionCallbackFactory(this)
            }, d = this.getField("VAR").getText(), d = {
                text: module$contents$Blockly$libraryBlocks$variables_Msg.DELETE_VARIABLE.replace("%1", d),
                enabled: !0,
                callback: module$contents$Blockly$libraryBlocks$variables_deleteOptionCallbackFactory(this)
            }, a.unshift(b), a.unshift(d);
        }
    }, module$contents$Blockly$libraryBlocks$variables_renameOptionCallbackFactory = function(a) {
        return function() {
            const b = a.workspace, c = a.getField("VAR").getVariable();
            $.module$build$src$core$variables.renameVariable(b, c);
        };
    }, module$contents$Blockly$libraryBlocks$variables_deleteOptionCallbackFactory = function(a) {
        return function() {
            const b = a.workspace, c = a.getField("VAR").getVariable();
            b.deleteVariableById(c.getId());
            b.refreshToolboxSelection();
        };
    };
    $.module$build$src$core$extensions.registerMixin("contextMenu_variableSetterGetter", module$contents$Blockly$libraryBlocks$variables_CUSTOM_CONTEXT_MENU_VARIABLE_GETTER_SETTER_MIXIN);
    module$contents$Blockly$libraryBlocks$variables_defineBlocks(module$exports$Blockly$libraryBlocks$variables.blocks);
    var module$exports$Blockly$libraryBlocks$variablesDynamic = {}, module$contents$Blockly$libraryBlocks$variablesDynamic_ContextMenu = $.module$build$src$core$contextmenu, module$contents$Blockly$libraryBlocks$variablesDynamic_Extensions = $.module$build$src$core$extensions, module$contents$Blockly$libraryBlocks$variablesDynamic_Variables = $.module$build$src$core$variables, module$contents$Blockly$libraryBlocks$variablesDynamic_xml = $.module$build$src$core$utils$xml, module$contents$Blockly$libraryBlocks$variablesDynamic_BlockDefinition = Object, module$contents$Blockly$libraryBlocks$variablesDynamic_Msg = $.module$build$src$core$msg.Msg, module$contents$Blockly$libraryBlocks$variablesDynamic_createBlockDefinitionsFromJsonArray = $.module$build$src$core$common.createBlockDefinitionsFromJsonArray, module$contents$Blockly$libraryBlocks$variablesDynamic_defineBlocks = $.module$build$src$core$common.defineBlocks;
    module$exports$Blockly$libraryBlocks$variablesDynamic.blocks = module$contents$Blockly$libraryBlocks$variablesDynamic_createBlockDefinitionsFromJsonArray([
        {
            type: "variables_get_dynamic",
            message0: "%1",
            args0: [
                {
                    type: "field_variable",
                    name: "VAR",
                    variable: "%{BKY_VARIABLES_DEFAULT_NAME}"
                }
            ],
            output: null,
            style: "variable_dynamic_blocks",
            helpUrl: "%{BKY_VARIABLES_GET_HELPURL}",
            tooltip: "%{BKY_VARIABLES_GET_TOOLTIP}",
            extensions: [
                "contextMenu_variableDynamicSetterGetter"
            ]
        },
        {
            type: "variables_set_dynamic",
            message0: "%{BKY_VARIABLES_SET}",
            args0: [
                {
                    type: "field_variable",
                    name: "VAR",
                    variable: "%{BKY_VARIABLES_DEFAULT_NAME}"
                },
                {
                    type: "input_value",
                    name: "VALUE"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "variable_dynamic_blocks",
            tooltip: "%{BKY_VARIABLES_SET_TOOLTIP}",
            helpUrl: "%{BKY_VARIABLES_SET_HELPURL}",
            extensions: [
                "contextMenu_variableDynamicSetterGetter"
            ]
        }
    ]);
    var module$contents$Blockly$libraryBlocks$variablesDynamic_CUSTOM_CONTEXT_MENU_VARIABLE_GETTER_SETTER_MIXIN = {
        customContextMenu: function(a) {
            if (!this.isInFlyout) {
                var b = this.getFieldValue("VAR");
                var c = this.workspace.getVariableById(b).type;
                if ("variables_get_dynamic" === this.type) {
                    b = "variables_set_dynamic";
                    var d = module$contents$Blockly$libraryBlocks$variablesDynamic_Msg.VARIABLES_GET_CREATE_SET;
                } else b = "variables_get_dynamic", d = module$contents$Blockly$libraryBlocks$variablesDynamic_Msg.VARIABLES_SET_CREATE_GET;
                var e = {
                    enabled: 0 < this.workspace.remainingCapacity()
                };
                const f = this.getField("VAR").getText();
                e.text = d.replace("%1", f);
                d = $.module$build$src$core$utils$xml.createElement("field");
                d.setAttribute("name", "VAR");
                d.setAttribute("variabletype", c);
                d.appendChild($.module$build$src$core$utils$xml.createTextNode(f));
                c = $.module$build$src$core$utils$xml.createElement("block");
                c.setAttribute("type", b);
                c.appendChild(d);
                e.callback = $.module$build$src$core$contextmenu.callbackFactory(this, c);
                a.push(e);
            } else if ("variables_get_dynamic" === this.type || "variables_get_reporter_dynamic" === this.type) b = {
                text: module$contents$Blockly$libraryBlocks$variablesDynamic_Msg.RENAME_VARIABLE,
                enabled: !0,
                callback: module$contents$Blockly$libraryBlocks$variablesDynamic_renameOptionCallbackFactory(this)
            }, e = this.getField("VAR").getText(), e = {
                text: module$contents$Blockly$libraryBlocks$variablesDynamic_Msg.DELETE_VARIABLE.replace("%1", e),
                enabled: !0,
                callback: module$contents$Blockly$libraryBlocks$variablesDynamic_deleteOptionCallbackFactory(this)
            }, a.unshift(b), a.unshift(e);
        },
        onchange: function(a) {
            a = this.getFieldValue("VAR");
            a = $.module$build$src$core$variables.getVariable(this.workspace, a);
            "variables_get_dynamic" === this.type ? this.outputConnection.setCheck(a.type) : this.getInput("VALUE").connection.setCheck(a.type);
        }
    }, module$contents$Blockly$libraryBlocks$variablesDynamic_renameOptionCallbackFactory = function(a) {
        return function() {
            const b = a.workspace, c = a.getField("VAR").getVariable();
            $.module$build$src$core$variables.renameVariable(b, c);
        };
    }, module$contents$Blockly$libraryBlocks$variablesDynamic_deleteOptionCallbackFactory = function(a) {
        return function() {
            const b = a.workspace, c = a.getField("VAR").getVariable();
            b.deleteVariableById(c.getId());
            b.refreshToolboxSelection();
        };
    };
    $.module$build$src$core$extensions.registerMixin("contextMenu_variableDynamicSetterGetter", module$contents$Blockly$libraryBlocks$variablesDynamic_CUSTOM_CONTEXT_MENU_VARIABLE_GETTER_SETTER_MIXIN);
    module$contents$Blockly$libraryBlocks$variablesDynamic_defineBlocks(module$exports$Blockly$libraryBlocks$variablesDynamic.blocks);
    var module$exports$Blockly$libraryBlocks = {
        colour: module$build$src$blocks$colour,
        math: module$build$src$blocks$math
    }, module$contents$Blockly$libraryBlocks_BlockDefinition = Object;
    module$exports$Blockly$libraryBlocks.lists = module$exports$Blockly$libraryBlocks$lists;
    module$exports$Blockly$libraryBlocks.logic = module$exports$Blockly$libraryBlocks$logic;
    module$exports$Blockly$libraryBlocks.loops = module$exports$Blockly$libraryBlocks$loops;
    module$exports$Blockly$libraryBlocks.procedures = module$exports$Blockly$libraryBlocks$procedures;
    module$exports$Blockly$libraryBlocks.texts = module$exports$Blockly$libraryBlocks$texts;
    module$exports$Blockly$libraryBlocks.variables = module$exports$Blockly$libraryBlocks$variables;
    module$exports$Blockly$libraryBlocks.variablesDynamic = module$exports$Blockly$libraryBlocks$variablesDynamic;
    module$exports$Blockly$libraryBlocks.blocks = Object.assign({}, module$build$src$blocks$colour.blocks, module$exports$Blockly$libraryBlocks$lists.blocks, module$exports$Blockly$libraryBlocks$logic.blocks, module$exports$Blockly$libraryBlocks$loops.blocks, module$build$src$blocks$math.blocks, module$exports$Blockly$libraryBlocks$procedures.blocks, module$exports$Blockly$libraryBlocks$variables.blocks, module$exports$Blockly$libraryBlocks$variablesDynamic.blocks);
    module$exports$Blockly$libraryBlocks.__namespace__ = $;
    return module$exports$Blockly$libraryBlocks;
});

});


parcelRegister("1FOTS", function(module, exports) {


(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "./core",
        "./javascript_compressed.js"
    ], factory);
    else module.exports = factory((parcelRequire("d9riD")), (parcelRequire("2Ken5")));
})(module.exports, function(Blockly, BlocklyJavaScript) {
    /**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @fileoverview JavaScript Generator module; just a wrapper for
 *     javascript_compressed.js.
 */ return BlocklyJavaScript;
});

});
parcelRegister("2Ken5", function(module, exports) {
// Do not edit this file; automatically generated.

(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "./blockly_compressed.js"
    ], factory);
    else {
        var factoryExports;
        module.exports = factory((parcelRequire("97Mr6")));
    }
})(module.exports, function(__parent__) {
    var $ = __parent__.__namespace__;
    var module$exports$Blockly$JavaScript = {}, module$contents$Blockly$JavaScript_Variables = $.module$build$src$core$variables, module$contents$Blockly$JavaScript_stringUtils = $.module$build$src$core$utils$string, module$contents$Blockly$JavaScript_CodeGenerator = $.CodeGenerator$$module$build$src$core$generator, module$contents$Blockly$JavaScript_inputTypes = $.module$build$src$core$input_types.inputTypes, module$contents$Blockly$JavaScript_Names = $.module$build$src$core$names.Names, module$contents$Blockly$JavaScript_NameType = $.NameType$$module$build$src$core$names;
    module$exports$Blockly$JavaScript.javascriptGenerator = new $.CodeGenerator$$module$build$src$core$generator("JavaScript");
    module$exports$Blockly$JavaScript.javascriptGenerator.addReservedWords("break,case,catch,class,const,continue,debugger,default,delete,do,else,export,extends,finally,for,function,if,import,in,instanceof,new,return,super,switch,this,throw,try,typeof,var,void,while,with,yield,enum,implements,interface,let,package,private,protected,public,static,await,null,true,false,arguments," + Object.getOwnPropertyNames(globalThis).join(","));
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ATOMIC = 0;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NEW = 1.1;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER = 1.2;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL = 2;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_INCREMENT = 3;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_DECREMENT = 3;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_BITWISE_NOT = 4.1;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_UNARY_PLUS = 4.2;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_UNARY_NEGATION = 4.3;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_LOGICAL_NOT = 4.4;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_TYPEOF = 4.5;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_VOID = 4.6;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_DELETE = 4.7;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_AWAIT = 4.8;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_EXPONENTIATION = 5;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MULTIPLICATION = 5.1;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_DIVISION = 5.2;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MODULUS = 5.3;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_SUBTRACTION = 6.1;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ADDITION = 6.2;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_BITWISE_SHIFT = 7;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_RELATIONAL = 8;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_IN = 8;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_INSTANCEOF = 8;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_EQUALITY = 9;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_BITWISE_AND = 10;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_BITWISE_XOR = 11;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_BITWISE_OR = 12;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_LOGICAL_AND = 13;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_LOGICAL_OR = 14;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_CONDITIONAL = 15;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ASSIGNMENT = 16;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_YIELD = 17;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_COMMA = 18;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE = 99;
    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_OVERRIDES = [
        [
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER
        ],
        [
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ],
        [
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER
        ],
        [
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ],
        [
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_LOGICAL_NOT,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_LOGICAL_NOT
        ],
        [
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MULTIPLICATION,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MULTIPLICATION
        ],
        [
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ADDITION,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ADDITION
        ],
        [
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_LOGICAL_AND,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_LOGICAL_AND
        ],
        [
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_LOGICAL_OR,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_LOGICAL_OR
        ]
    ];
    module$exports$Blockly$JavaScript.javascriptGenerator.isInitialized = !1;
    module$exports$Blockly$JavaScript.javascriptGenerator.init = function(a) {
        Object.getPrototypeOf(this).init.call(this);
        this.nameDB_ ? this.nameDB_.reset() : this.nameDB_ = new $.module$build$src$core$names.Names(this.RESERVED_WORDS_);
        this.nameDB_.setVariableMap(a.getVariableMap());
        this.nameDB_.populateVariables(a);
        this.nameDB_.populateProcedures(a);
        const b = [];
        var c = $.module$build$src$core$variables.allDeveloperVariables(a);
        for(let d = 0; d < c.length; d++)b.push(this.nameDB_.getName(c[d], $.NameType$$module$build$src$core$names.DEVELOPER_VARIABLE));
        a = $.module$build$src$core$variables.allUsedVarModels(a);
        for(c = 0; c < a.length; c++)b.push(this.nameDB_.getName(a[c].getId(), $.NameType$$module$build$src$core$names.VARIABLE));
        b.length && (this.definitions_.variables = "var " + b.join(", ") + ";");
        this.isInitialized = !0;
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.finish = function(a) {
        const b = Object.values(this.definitions_);
        a = Object.getPrototypeOf(this).finish.call(this, a);
        this.isInitialized = !1;
        this.nameDB_.reset();
        return b.join("\n\n") + "\n\n\n" + a;
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.scrubNakedValue = function(a) {
        return a + ";\n";
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.quote_ = function(a) {
        a = a.replace(/\\/g, "\\\\").replace(/\n/g, "\\\n").replace(/'/g, "\\'");
        return "'" + a + "'";
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.multiline_quote_ = function(a) {
        return a.split(/\n/g).map(this.quote_).join(" + '\\n' +\n");
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.scrub_ = function(a, b, c) {
        let d = "";
        if (!a.outputConnection || !a.outputConnection.targetConnection) {
            var e = a.getCommentText();
            e && (e = $.module$build$src$core$utils$string.wrap(e, this.COMMENT_WRAP - 3), d += this.prefixLines(e + "\n", "// "));
            for(let f = 0; f < a.inputList.length; f++)a.inputList[f].type === $.module$build$src$core$input_types.inputTypes.VALUE && (e = a.inputList[f].connection.targetBlock()) && (e = this.allNestedComments(e)) && (d += this.prefixLines(e, "// "));
        }
        a = a.nextConnection && a.nextConnection.targetBlock();
        c = c ? "" : this.blockToCode(a);
        return d + b + c;
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted = function(a, b, c, d, e) {
        c = c || 0;
        e = e || this.ORDER_NONE;
        a.workspace.options.oneBasedIndex && c--;
        const f = a.workspace.options.oneBasedIndex ? "1" : "0";
        let g, h = e;
        0 < c ? g = h = this.ORDER_ADDITION : 0 > c ? g = h = this.ORDER_SUBTRACTION : d && (g = h = this.ORDER_UNARY_NEGATION);
        a = this.valueToCode(a, b, h) || f;
        $.module$build$src$core$utils$string.isNumber(a) ? (a = Number(a) + c, d && (a = -a)) : (0 < c ? a = a + " + " + c : 0 > c && (a = a + " - " + -c), d && (a = c ? "-(" + a + ")" : "-" + a), g = Math.floor(g), e = Math.floor(e), g && e >= g && (a = "(" + a + ")"));
        return a;
    };
    var module$exports$Blockly$JavaScript$colour = {};
    module$exports$Blockly$JavaScript.javascriptGenerator.colour_picker = function(a) {
        return [
            module$exports$Blockly$JavaScript.javascriptGenerator.quote_(a.getFieldValue("COLOUR")),
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ATOMIC
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.colour_random = function(a) {
        return [
            module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("colourRandom", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}() {
  var num = Math.floor(Math.random() * Math.pow(2, 24));
  return '#' + ('00000' + num.toString(16)).substr(-6);
}
`) + "()",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.colour_rgb = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "RED", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || 0, c = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "GREEN", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || 0;
        a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "BLUE", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || 0;
        return [
            module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("colourRgb", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(r, g, b) {
  r = Math.max(Math.min(Number(r), 100), 0) * 2.55;
  g = Math.max(Math.min(Number(g), 100), 0) * 2.55;
  b = Math.max(Math.min(Number(b), 100), 0) * 2.55;
  r = ('0' + (Math.round(r) || 0).toString(16)).slice(-2);
  g = ('0' + (Math.round(g) || 0).toString(16)).slice(-2);
  b = ('0' + (Math.round(b) || 0).toString(16)).slice(-2);
  return '#' + r + g + b;
}
`) + "(" + b + ", " + c + ", " + a + ")",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.colour_blend = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "COLOUR1", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "'#000000'", c = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "COLOUR2", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "'#000000'";
        a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "RATIO", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || .5;
        return [
            module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("colourBlend", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(c1, c2, ratio) {
  ratio = Math.max(Math.min(Number(ratio), 1), 0);
  var r1 = parseInt(c1.substring(1, 3), 16);
  var g1 = parseInt(c1.substring(3, 5), 16);
  var b1 = parseInt(c1.substring(5, 7), 16);
  var r2 = parseInt(c2.substring(1, 3), 16);
  var g2 = parseInt(c2.substring(3, 5), 16);
  var b2 = parseInt(c2.substring(5, 7), 16);
  var r = Math.round(r1 * (1 - ratio) + r2 * ratio);
  var g = Math.round(g1 * (1 - ratio) + g2 * ratio);
  var b = Math.round(b1 * (1 - ratio) + b2 * ratio);
  r = ('0' + (r || 0).toString(16)).slice(-2);
  g = ('0' + (g || 0).toString(16)).slice(-2);
  b = ('0' + (b || 0).toString(16)).slice(-2);
  return '#' + r + g + b;
}
`) + "(" + b + ", " + c + ", " + a + ")",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    var module$exports$Blockly$JavaScript$lists = {}, module$contents$Blockly$JavaScript$lists_NameType = $.NameType$$module$build$src$core$names;
    module$exports$Blockly$JavaScript.javascriptGenerator.lists_create_empty = function(a) {
        return [
            "[]",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ATOMIC
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.lists_create_with = function(a) {
        const b = Array(a.itemCount_);
        for(let c = 0; c < a.itemCount_; c++)b[c] = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "ADD" + c, module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "null";
        return [
            "[" + b.join(", ") + "]",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ATOMIC
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.lists_repeat = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("listsRepeat", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}
`), c = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "ITEM", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "null";
        a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "NUM", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "0";
        return [
            b + "(" + c + ", " + a + ")",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.lists_length = function(a) {
        return [
            (module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "VALUE", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER) || "[]") + ".length",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.lists_isEmpty = function(a) {
        return [
            "!" + (module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "VALUE", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER) || "[]") + ".length",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_LOGICAL_NOT
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.lists_indexOf = function(a) {
        var b = "FIRST" === a.getFieldValue("END") ? "indexOf" : "lastIndexOf";
        const c = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "FIND", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''";
        b = (module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "VALUE", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER) || "[]") + "." + b + "(" + c + ")";
        return a.workspace.options.oneBasedIndex ? [
            b + " + 1",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ADDITION
        ] : [
            b,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.lists_getIndex = function(a) {
        const b = a.getFieldValue("MODE") || "GET", c = a.getFieldValue("WHERE") || "FROM_START";
        var d = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "VALUE", "RANDOM" === c ? module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE : module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER) || "[]";
        switch(c){
            case "FIRST":
                if ("GET" === b) return [
                    d + "[0]",
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER
                ];
                if ("GET_REMOVE" === b) return [
                    d + ".shift()",
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER
                ];
                if ("REMOVE" === b) return d + ".shift();\n";
                break;
            case "LAST":
                if ("GET" === b) return [
                    d + ".slice(-1)[0]",
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER
                ];
                if ("GET_REMOVE" === b) return [
                    d + ".pop()",
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER
                ];
                if ("REMOVE" === b) return d + ".pop();\n";
                break;
            case "FROM_START":
                a = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT");
                if ("GET" === b) return [
                    d + "[" + a + "]",
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER
                ];
                if ("GET_REMOVE" === b) return [
                    d + ".splice(" + a + ", 1)[0]",
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
                ];
                if ("REMOVE" === b) return d + ".splice(" + a + ", 1);\n";
                break;
            case "FROM_END":
                a = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT", 1, !0);
                if ("GET" === b) return [
                    d + ".slice(" + a + ")[0]",
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
                ];
                if ("GET_REMOVE" === b) return [
                    d + ".splice(" + a + ", 1)[0]",
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
                ];
                if ("REMOVE" === b) return d + ".splice(" + a + ", 1);";
                break;
            case "RANDOM":
                d = module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("listsGetRandomItem", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}
`) + "(" + d + ", " + ("GET" !== b) + ")";
                if ("GET" === b || "GET_REMOVE" === b) return [
                    d,
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
                ];
                if ("REMOVE" === b) return d + ";\n";
        }
        throw Error("Unhandled combination (lists_getIndex).");
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.lists_setIndex = function(a) {
        function b() {
            if (c.match(/^\w+$/)) return "";
            const g = module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getDistinctName("tmpList", $.NameType$$module$build$src$core$names.VARIABLE), h = "var " + g + " = " + c + ";\n";
            c = g;
            return h;
        }
        let c = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "LIST", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER) || "[]";
        const d = a.getFieldValue("MODE") || "GET";
        var e = a.getFieldValue("WHERE") || "FROM_START";
        const f = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "TO", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ASSIGNMENT) || "null";
        switch(e){
            case "FIRST":
                if ("SET" === d) return c + "[0] = " + f + ";\n";
                if ("INSERT" === d) return c + ".unshift(" + f + ");\n";
                break;
            case "LAST":
                if ("SET" === d) return b() + (c + "[" + c + ".length - 1] = " + f + ";\n");
                if ("INSERT" === d) return c + ".push(" + f + ");\n";
                break;
            case "FROM_START":
                a = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT");
                if ("SET" === d) return c + "[" + a + "] = " + f + ";\n";
                if ("INSERT" === d) return c + ".splice(" + a + ", 0, " + f + ");\n";
                break;
            case "FROM_END":
                a = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT", 1, !1, module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_SUBTRACTION);
                e = b();
                if ("SET" === d) return e + (c + "[" + c + ".length - " + a + "] = " + f + ";\n");
                if ("INSERT" === d) return e + (c + ".splice(" + c + ".length - " + a + ", 0, " + f + ");\n");
                break;
            case "RANDOM":
                a = b();
                e = module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getDistinctName("tmpX", $.NameType$$module$build$src$core$names.VARIABLE);
                a += "var " + e + " = Math.floor(Math.random() * " + c + ".length);\n";
                if ("SET" === d) return a + (c + "[" + e + "] = " + f + ";\n");
                if ("INSERT" === d) return a + (c + ".splice(" + e + ", 0, " + f + ");\n");
        }
        throw Error("Unhandled combination (lists_setIndex).");
    };
    var module$contents$Blockly$JavaScript$lists_getSubstringIndex = function(a, b, c) {
        return "FIRST" === b ? "0" : "FROM_END" === b ? a + ".length - 1 - " + c : "LAST" === b ? a + ".length - 1" : c;
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.lists_getSublist = function(a) {
        var b = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "LIST", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER) || "[]", c = a.getFieldValue("WHERE1"), d = a.getFieldValue("WHERE2");
        if ("FIRST" === c && "LAST" === d) b += ".slice(0)";
        else if (b.match(/^\w+$/) || "FROM_END" !== c && "FROM_START" === d) {
            switch(c){
                case "FROM_START":
                    c = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT1");
                    break;
                case "FROM_END":
                    c = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT1", 1, !1, module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_SUBTRACTION);
                    c = b + ".length - " + c;
                    break;
                case "FIRST":
                    c = "0";
                    break;
                default:
                    throw Error("Unhandled option (lists_getSublist).");
            }
            switch(d){
                case "FROM_START":
                    d = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT2", 1);
                    break;
                case "FROM_END":
                    d = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT2", 0, !1, module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_SUBTRACTION);
                    d = b + ".length - " + d;
                    break;
                case "LAST":
                    d = b + ".length";
                    break;
                default:
                    throw Error("Unhandled option (lists_getSublist).");
            }
            b = b + ".slice(" + c + ", " + d + ")";
        } else {
            const e = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT1");
            a = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT2");
            const f = {
                FIRST: "First",
                LAST: "Last",
                FROM_START: "FromStart",
                FROM_END: "FromEnd"
            };
            b = module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("subsequence" + f[c] + f[d], `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(sequence${"FROM_END" === c || "FROM_START" === c ? ", at1" : ""}${"FROM_END" === d || "FROM_START" === d ? ", at2" : ""}) {
  var start = ${module$contents$Blockly$JavaScript$lists_getSubstringIndex("sequence", c, "at1")};
  var end = ${module$contents$Blockly$JavaScript$lists_getSubstringIndex("sequence", d, "at2")} + 1;
  return sequence.slice(start, end);
}
`) + "(" + b + ("FROM_END" === c || "FROM_START" === c ? ", " + e : "") + ("FROM_END" === d || "FROM_START" === d ? ", " + a : "") + ")";
        }
        return [
            b,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.lists_sort = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "LIST", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL) || "[]", c = "1" === a.getFieldValue("DIRECTION") ? 1 : -1;
        a = a.getFieldValue("TYPE");
        const d = module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("listsGetSortCompare", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(type, direction) {
  var compareFuncs = {
    'NUMERIC': function(a, b) {
        return Number(a) - Number(b); },
    'TEXT': function(a, b) {
        return String(a) > String(b) ? 1 : -1; },
    'IGNORE_CASE': function(a, b) {
        return String(a).toLowerCase() > String(b).toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; };
}
      `);
        return [
            b + ".slice().sort(" + d + '("' + a + '", ' + c + "))",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.lists_split = function(a) {
        let b = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "INPUT", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER);
        const c = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "DELIM", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''";
        a = a.getFieldValue("MODE");
        if ("SPLIT" === a) b || (b = "''"), a = "split";
        else if ("JOIN" === a) b || (b = "[]"), a = "join";
        else throw Error("Unknown mode: " + a);
        return [
            b + "." + a + "(" + c + ")",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.lists_reverse = function(a) {
        return [
            (module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "LIST", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL) || "[]") + ".slice().reverse()",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    var module$exports$Blockly$JavaScript$logic = {};
    module$exports$Blockly$JavaScript.javascriptGenerator.controls_if = function(a) {
        var b = 0;
        let c = "";
        module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_PREFIX && (c += module$exports$Blockly$JavaScript.javascriptGenerator.injectId(module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_PREFIX, a));
        do {
            const d = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "IF" + b, module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "false";
            let e = module$exports$Blockly$JavaScript.javascriptGenerator.statementToCode(a, "DO" + b);
            module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_SUFFIX && (e = module$exports$Blockly$JavaScript.javascriptGenerator.prefixLines(module$exports$Blockly$JavaScript.javascriptGenerator.injectId(module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_SUFFIX, a), module$exports$Blockly$JavaScript.javascriptGenerator.INDENT) + e);
            c += (0 < b ? " else " : "") + "if (" + d + ") {\n" + e + "}";
            b++;
        }while (a.getInput("IF" + b));
        if (a.getInput("ELSE") || module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_SUFFIX) b = module$exports$Blockly$JavaScript.javascriptGenerator.statementToCode(a, "ELSE"), module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_SUFFIX && (b = module$exports$Blockly$JavaScript.javascriptGenerator.prefixLines(module$exports$Blockly$JavaScript.javascriptGenerator.injectId(module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_SUFFIX, a), module$exports$Blockly$JavaScript.javascriptGenerator.INDENT) + b), c += " else {\n" + b + "}";
        return c + "\n";
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.controls_ifelse = module$exports$Blockly$JavaScript.javascriptGenerator.controls_if;
    module$exports$Blockly$JavaScript.javascriptGenerator.logic_compare = function(a) {
        const b = {
            EQ: "==",
            NEQ: "!=",
            LT: "<",
            LTE: "<=",
            GT: ">",
            GTE: ">="
        }[a.getFieldValue("OP")], c = "==" === b || "!=" === b ? module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_EQUALITY : module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_RELATIONAL, d = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "A", c) || "0";
        a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "B", c) || "0";
        return [
            d + " " + b + " " + a,
            c
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.logic_operation = function(a) {
        const b = "AND" === a.getFieldValue("OP") ? "&&" : "||", c = "&&" === b ? module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_LOGICAL_AND : module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_LOGICAL_OR;
        let d = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "A", c);
        a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "B", c);
        if (d || a) {
            const e = "&&" === b ? "true" : "false";
            d || (d = e);
            a || (a = e);
        } else a = d = "false";
        return [
            d + " " + b + " " + a,
            c
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.logic_negate = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_LOGICAL_NOT;
        return [
            "!" + (module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "BOOL", b) || "true"),
            b
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.logic_boolean = function(a) {
        return [
            "TRUE" === a.getFieldValue("BOOL") ? "true" : "false",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ATOMIC
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.logic_null = function(a) {
        return [
            "null",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ATOMIC
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.logic_ternary = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "IF", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_CONDITIONAL) || "false", c = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "THEN", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_CONDITIONAL) || "null";
        a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "ELSE", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_CONDITIONAL) || "null";
        return [
            b + " ? " + c + " : " + a,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_CONDITIONAL
        ];
    };
    var module$exports$Blockly$JavaScript$loops = {}, module$contents$Blockly$JavaScript$loops_stringUtils = $.module$build$src$core$utils$string, module$contents$Blockly$JavaScript$loops_NameType = $.NameType$$module$build$src$core$names;
    module$exports$Blockly$JavaScript.javascriptGenerator.controls_repeat_ext = function(a) {
        let b;
        b = a.getField("TIMES") ? String(Number(a.getFieldValue("TIMES"))) : module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "TIMES", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ASSIGNMENT) || "0";
        let c = module$exports$Blockly$JavaScript.javascriptGenerator.statementToCode(a, "DO");
        c = module$exports$Blockly$JavaScript.javascriptGenerator.addLoopTrap(c, a);
        a = "";
        const d = module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getDistinctName("count", $.NameType$$module$build$src$core$names.VARIABLE);
        let e = b;
        b.match(/^\w+$/) || $.module$build$src$core$utils$string.isNumber(b) || (e = module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getDistinctName("repeat_end", $.NameType$$module$build$src$core$names.VARIABLE), a += "var " + e + " = " + b + ";\n");
        return a + ("for (var " + d + " = 0; " + d + " < " + e + "; " + d + "++) {\n" + c + "}\n");
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.controls_repeat = module$exports$Blockly$JavaScript.javascriptGenerator.controls_repeat_ext;
    module$exports$Blockly$JavaScript.javascriptGenerator.controls_whileUntil = function(a) {
        const b = "UNTIL" === a.getFieldValue("MODE");
        let c = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "BOOL", b ? module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_LOGICAL_NOT : module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "false", d = module$exports$Blockly$JavaScript.javascriptGenerator.statementToCode(a, "DO");
        d = module$exports$Blockly$JavaScript.javascriptGenerator.addLoopTrap(d, a);
        b && (c = "!" + c);
        return "while (" + c + ") {\n" + d + "}\n";
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.controls_for = function(a) {
        var b = module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getName(a.getFieldValue("VAR"), $.NameType$$module$build$src$core$names.VARIABLE), c = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "FROM", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ASSIGNMENT) || "0", d = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "TO", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ASSIGNMENT) || "0";
        const e = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "BY", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ASSIGNMENT) || "1";
        let f = module$exports$Blockly$JavaScript.javascriptGenerator.statementToCode(a, "DO");
        f = module$exports$Blockly$JavaScript.javascriptGenerator.addLoopTrap(f, a);
        if ($.module$build$src$core$utils$string.isNumber(c) && $.module$build$src$core$utils$string.isNumber(d) && $.module$build$src$core$utils$string.isNumber(e)) {
            var g = Number(c) <= Number(d);
            a = "for (" + b + " = " + c + "; " + b + (g ? " <= " : " >= ") + d + "; " + b;
            b = Math.abs(Number(e));
            a = 1 === b ? a + (g ? "++" : "--") : a + ((g ? " += " : " -= ") + b);
            a += ") {\n" + f + "}\n";
        } else a = "", g = c, c.match(/^\w+$/) || $.module$build$src$core$utils$string.isNumber(c) || (g = module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getDistinctName(b + "_start", $.NameType$$module$build$src$core$names.VARIABLE), a += "var " + g + " = " + c + ";\n"), c = d, d.match(/^\w+$/) || $.module$build$src$core$utils$string.isNumber(d) || (c = module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getDistinctName(b + "_end", $.NameType$$module$build$src$core$names.VARIABLE), a += "var " + c + " = " + d + ";\n"), d = module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getDistinctName(b + "_inc", $.NameType$$module$build$src$core$names.VARIABLE), a += "var " + d + " = ", a = $.module$build$src$core$utils$string.isNumber(e) ? a + (Math.abs(e) + ";\n") : a + ("Math.abs(" + e + ");\n"), a += "if (" + g + " > " + c + ") {\n", a += module$exports$Blockly$JavaScript.javascriptGenerator.INDENT + d + " = -" + d + ";\n", a = a + "}\nfor (" + (b + " = " + g + "; " + d + " >= 0 ? " + b + " <= " + c + " : " + b + " >= " + c + "; " + b + " += " + d + ") {\n" + f + "}\n");
        return a;
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.controls_forEach = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getName(a.getFieldValue("VAR"), $.NameType$$module$build$src$core$names.VARIABLE);
        var c = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "LIST", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ASSIGNMENT) || "[]";
        let d = module$exports$Blockly$JavaScript.javascriptGenerator.statementToCode(a, "DO");
        d = module$exports$Blockly$JavaScript.javascriptGenerator.addLoopTrap(d, a);
        a = "";
        let e = c;
        c.match(/^\w+$/) || (e = module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getDistinctName(b + "_list", $.NameType$$module$build$src$core$names.VARIABLE), a += "var " + e + " = " + c + ";\n");
        c = module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getDistinctName(b + "_index", $.NameType$$module$build$src$core$names.VARIABLE);
        d = module$exports$Blockly$JavaScript.javascriptGenerator.INDENT + b + " = " + e + "[" + c + "];\n" + d;
        return a + ("for (var " + c + " in " + e + ") {\n" + d + "}\n");
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.controls_flow_statements = function(a) {
        let b = "";
        module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_PREFIX && (b += module$exports$Blockly$JavaScript.javascriptGenerator.injectId(module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_PREFIX, a));
        module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_SUFFIX && (b += module$exports$Blockly$JavaScript.javascriptGenerator.injectId(module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_SUFFIX, a));
        if (module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_PREFIX) {
            const c = a.getSurroundLoop();
            c && !c.suppressPrefixSuffix && (b += module$exports$Blockly$JavaScript.javascriptGenerator.injectId(module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_PREFIX, c));
        }
        switch(a.getFieldValue("FLOW")){
            case "BREAK":
                return b + "break;\n";
            case "CONTINUE":
                return b + "continue;\n";
        }
        throw Error("Unknown flow statement.");
    };
    var module$exports$Blockly$JavaScript$math = {}, module$contents$Blockly$JavaScript$math_NameType = $.NameType$$module$build$src$core$names;
    module$exports$Blockly$JavaScript.javascriptGenerator.math_number = function(a) {
        a = Number(a.getFieldValue("NUM"));
        return [
            a,
            0 <= a ? module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ATOMIC : module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_UNARY_NEGATION
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.math_arithmetic = function(a) {
        var b = {
            ADD: [
                " + ",
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ADDITION
            ],
            MINUS: [
                " - ",
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_SUBTRACTION
            ],
            MULTIPLY: [
                " * ",
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MULTIPLICATION
            ],
            DIVIDE: [
                " / ",
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_DIVISION
            ],
            POWER: [
                null,
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE
            ]
        }[a.getFieldValue("OP")];
        const c = b[0];
        b = b[1];
        const d = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "A", b) || "0";
        a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "B", b) || "0";
        return c ? [
            d + c + a,
            b
        ] : [
            "Math.pow(" + d + ", " + a + ")",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.math_single = function(a) {
        const b = a.getFieldValue("OP");
        let c;
        if ("NEG" === b) return a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "NUM", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_UNARY_NEGATION) || "0", "-" === a[0] && (a = " " + a), [
            "-" + a,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_UNARY_NEGATION
        ];
        a = "SIN" === b || "COS" === b || "TAN" === b ? module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "NUM", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_DIVISION) || "0" : module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "NUM", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "0";
        switch(b){
            case "ABS":
                c = "Math.abs(" + a + ")";
                break;
            case "ROOT":
                c = "Math.sqrt(" + a + ")";
                break;
            case "LN":
                c = "Math.log(" + a + ")";
                break;
            case "EXP":
                c = "Math.exp(" + a + ")";
                break;
            case "POW10":
                c = "Math.pow(10," + a + ")";
                break;
            case "ROUND":
                c = "Math.round(" + a + ")";
                break;
            case "ROUNDUP":
                c = "Math.ceil(" + a + ")";
                break;
            case "ROUNDDOWN":
                c = "Math.floor(" + a + ")";
                break;
            case "SIN":
                c = "Math.sin(" + a + " / 180 * Math.PI)";
                break;
            case "COS":
                c = "Math.cos(" + a + " / 180 * Math.PI)";
                break;
            case "TAN":
                c = "Math.tan(" + a + " / 180 * Math.PI)";
        }
        if (c) return [
            c,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
        switch(b){
            case "LOG10":
                c = "Math.log(" + a + ") / Math.log(10)";
                break;
            case "ASIN":
                c = "Math.asin(" + a + ") / Math.PI * 180";
                break;
            case "ACOS":
                c = "Math.acos(" + a + ") / Math.PI * 180";
                break;
            case "ATAN":
                c = "Math.atan(" + a + ") / Math.PI * 180";
                break;
            default:
                throw Error("Unknown math operator: " + b);
        }
        return [
            c,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_DIVISION
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.math_constant = function(a) {
        return ({
            PI: [
                "Math.PI",
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER
            ],
            E: [
                "Math.E",
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER
            ],
            GOLDEN_RATIO: [
                "(1 + Math.sqrt(5)) / 2",
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_DIVISION
            ],
            SQRT2: [
                "Math.SQRT2",
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER
            ],
            SQRT1_2: [
                "Math.SQRT1_2",
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER
            ],
            INFINITY: [
                "Infinity",
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ATOMIC
            ]
        })[a.getFieldValue("CONSTANT")];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.math_number_property = function(a) {
        var b = {
            EVEN: [
                " % 2 === 0",
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MODULUS,
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_EQUALITY
            ],
            ODD: [
                " % 2 === 1",
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MODULUS,
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_EQUALITY
            ],
            WHOLE: [
                " % 1 === 0",
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MODULUS,
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_EQUALITY
            ],
            POSITIVE: [
                " > 0",
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_RELATIONAL,
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_RELATIONAL
            ],
            NEGATIVE: [
                " < 0",
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_RELATIONAL,
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_RELATIONAL
            ],
            DIVISIBLE_BY: [
                null,
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MODULUS,
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_EQUALITY
            ],
            PRIME: [
                null,
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE,
                module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
            ]
        };
        const c = a.getFieldValue("PROPERTY"), [d, e, f] = b[c];
        b = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "NUMBER_TO_CHECK", e) || "0";
        "PRIME" === c ? a = module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("mathIsPrime", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(n) {
  // https://en.wikipedia.org/wiki/Primality_test#Naive_methods
  if (n == 2 || n == 3) {
    return true;
  }
  // False if n is NaN, negative, is 1, or not whole.
  // And false if n is divisible by 2 or 3.
  if (isNaN(n) || n <= 1 || n % 1 !== 0 || n % 2 === 0 || n % 3 === 0) {
    return false;
  }
  // Check all the numbers of form 6k +/- 1, up to sqrt(n).
  for (var x = 6; x <= Math.sqrt(n) + 1; x += 6) {
    if (n % (x - 1) === 0 || n % (x + 1) === 0) {
      return false;
    }
  }
  return true;
}
`) + "(" + b + ")" : "DIVISIBLE_BY" === c ? (a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "DIVISOR", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MODULUS) || "0", a = b + " % " + a + " === 0") : a = b + d;
        return [
            a,
            f
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.math_change = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "DELTA", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ADDITION) || "0";
        a = module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getName(a.getFieldValue("VAR"), $.NameType$$module$build$src$core$names.VARIABLE);
        return a + " = (typeof " + a + " === 'number' ? " + a + " : 0) + " + b + ";\n";
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.math_round = module$exports$Blockly$JavaScript.javascriptGenerator.math_single;
    module$exports$Blockly$JavaScript.javascriptGenerator.math_trig = module$exports$Blockly$JavaScript.javascriptGenerator.math_single;
    module$exports$Blockly$JavaScript.javascriptGenerator.math_on_list = function(a) {
        var b = a.getFieldValue("OP");
        switch(b){
            case "SUM":
                a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "LIST", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER) || "[]";
                a += ".reduce(function(x, y) {return x + y;}, 0)";
                break;
            case "MIN":
                a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "LIST", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "[]";
                a = "Math.min.apply(null, " + a + ")";
                break;
            case "MAX":
                a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "LIST", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "[]";
                a = "Math.max.apply(null, " + a + ")";
                break;
            case "AVERAGE":
                b = module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("mathMean", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(myList) {
  return myList.reduce(function(x, y) {return x + y;}, 0) / myList.length;
}
`);
                a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "LIST", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "[]";
                a = b + "(" + a + ")";
                break;
            case "MEDIAN":
                b = module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("mathMedian", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(myList) {
  var localList = myList.filter(function (x) {return typeof x === 'number';});
  if (!localList.length) return null;
  localList.sort(function(a, b) {return b - a;});
  if (localList.length % 2 === 0) {
    return (localList[localList.length / 2 - 1] + localList[localList.length / 2]) / 2;
  } else {
    return localList[(localList.length - 1) / 2];
  }
}
`);
                a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "LIST", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "[]";
                a = b + "(" + a + ")";
                break;
            case "MODE":
                b = module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("mathModes", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(values) {
  var modes = [];
  var counts = [];
  var maxCount = 0;
  for (var i = 0; i < values.length; i++) {
    var value = values[i];
    var found = false;
    var thisCount;
    for (var j = 0; j < counts.length; j++) {
      if (counts[j][0] === value) {
        thisCount = ++counts[j][1];
        found = true;
        break;
      }
    }
    if (!found) {
      counts.push([value, 1]);
      thisCount = 1;
    }
    maxCount = Math.max(thisCount, maxCount);
  }
  for (var j = 0; j < counts.length; j++) {
    if (counts[j][1] === maxCount) {
        modes.push(counts[j][0]);
    }
  }
  return modes;
}
`);
                a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "LIST", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "[]";
                a = b + "(" + a + ")";
                break;
            case "STD_DEV":
                b = module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("mathStandardDeviation", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(numbers) {
  var n = numbers.length;
  if (!n) return null;
  var mean = numbers.reduce(function(x, y) {return x + y;}) / n;
  var variance = 0;
  for (var j = 0; j < n; j++) {
    variance += Math.pow(numbers[j] - mean, 2);
  }
  variance = variance / n;
  return Math.sqrt(variance);
}
`);
                a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "LIST", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "[]";
                a = b + "(" + a + ")";
                break;
            case "RANDOM":
                b = module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("mathRandomList", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(list) {
  var x = Math.floor(Math.random() * list.length);
  return list[x];
}
`);
                a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "LIST", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "[]";
                a = b + "(" + a + ")";
                break;
            default:
                throw Error("Unknown operator: " + b);
        }
        return [
            a,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.math_modulo = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "DIVIDEND", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MODULUS) || "0";
        a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "DIVISOR", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MODULUS) || "0";
        return [
            b + " % " + a,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MODULUS
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.math_constrain = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "VALUE", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "0", c = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "LOW", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "0";
        a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "HIGH", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "Infinity";
        return [
            "Math.min(Math.max(" + b + ", " + c + "), " + a + ")",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.math_random_int = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "FROM", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "0";
        a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "TO", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "0";
        return [
            module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("mathRandomInt", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}
`) + "(" + b + ", " + a + ")",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.math_random_float = function(a) {
        return [
            "Math.random()",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.math_atan2 = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "X", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "0";
        return [
            "Math.atan2(" + (module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "Y", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "0") + ", " + b + ") / Math.PI * 180",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_DIVISION
        ];
    };
    var module$exports$Blockly$JavaScript$procedures = {}, module$contents$Blockly$JavaScript$procedures_NameType = $.NameType$$module$build$src$core$names;
    module$exports$Blockly$JavaScript.javascriptGenerator.procedures_defreturn = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getName(a.getFieldValue("NAME"), $.NameType$$module$build$src$core$names.PROCEDURE);
        var c = "";
        module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_PREFIX && (c += module$exports$Blockly$JavaScript.javascriptGenerator.injectId(module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_PREFIX, a));
        module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_SUFFIX && (c += module$exports$Blockly$JavaScript.javascriptGenerator.injectId(module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_SUFFIX, a));
        c && (c = module$exports$Blockly$JavaScript.javascriptGenerator.prefixLines(c, module$exports$Blockly$JavaScript.javascriptGenerator.INDENT));
        let d = "";
        module$exports$Blockly$JavaScript.javascriptGenerator.INFINITE_LOOP_TRAP && (d = module$exports$Blockly$JavaScript.javascriptGenerator.prefixLines(module$exports$Blockly$JavaScript.javascriptGenerator.injectId(module$exports$Blockly$JavaScript.javascriptGenerator.INFINITE_LOOP_TRAP, a), module$exports$Blockly$JavaScript.javascriptGenerator.INDENT));
        const e = module$exports$Blockly$JavaScript.javascriptGenerator.statementToCode(a, "STACK");
        let f = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "RETURN", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "", g = "";
        e && f && (g = c);
        f && (f = module$exports$Blockly$JavaScript.javascriptGenerator.INDENT + "return " + f + ";\n");
        const h = [], k = a.getVars();
        for(let l = 0; l < k.length; l++)h[l] = module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getName(k[l], $.NameType$$module$build$src$core$names.VARIABLE);
        c = "function " + b + "(" + h.join(", ") + ") {\n" + c + d + e + g + f + "}";
        c = module$exports$Blockly$JavaScript.javascriptGenerator.scrub_(a, c);
        module$exports$Blockly$JavaScript.javascriptGenerator.definitions_["%" + b] = c;
        return null;
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.procedures_defnoreturn = module$exports$Blockly$JavaScript.javascriptGenerator.procedures_defreturn;
    module$exports$Blockly$JavaScript.javascriptGenerator.procedures_callreturn = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getName(a.getFieldValue("NAME"), $.NameType$$module$build$src$core$names.PROCEDURE), c = [], d = a.getVars();
        for(let e = 0; e < d.length; e++)c[e] = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "ARG" + e, module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "null";
        return [
            b + "(" + c.join(", ") + ")",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.procedures_callnoreturn = function(a) {
        return module$exports$Blockly$JavaScript.javascriptGenerator.procedures_callreturn(a)[0] + ";\n";
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.procedures_ifreturn = function(a) {
        let b = "if (" + (module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "CONDITION", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "false") + ") {\n";
        module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_SUFFIX && (b += module$exports$Blockly$JavaScript.javascriptGenerator.prefixLines(module$exports$Blockly$JavaScript.javascriptGenerator.injectId(module$exports$Blockly$JavaScript.javascriptGenerator.STATEMENT_SUFFIX, a), module$exports$Blockly$JavaScript.javascriptGenerator.INDENT));
        a.hasReturnValue_ ? (a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "VALUE", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "null", b += module$exports$Blockly$JavaScript.javascriptGenerator.INDENT + "return " + a + ";\n") : b += module$exports$Blockly$JavaScript.javascriptGenerator.INDENT + "return;\n";
        return b + "}\n";
    };
    var module$exports$Blockly$JavaScript$texts = {}, module$contents$Blockly$JavaScript$texts_NameType = $.NameType$$module$build$src$core$names, module$contents$Blockly$JavaScript$texts_strRegExp = /^\s*'([^']|\\')*'\s*$/, module$contents$Blockly$JavaScript$texts_forceString = function(a) {
        return module$contents$Blockly$JavaScript$texts_strRegExp.test(a) ? [
            a,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ATOMIC
        ] : [
            "String(" + a + ")",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    }, module$contents$Blockly$JavaScript$texts_getSubstringIndex = function(a, b, c) {
        return "FIRST" === b ? "0" : "FROM_END" === b ? a + ".length - 1 - " + c : "LAST" === b ? a + ".length - 1" : c;
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.text = function(a) {
        return [
            module$exports$Blockly$JavaScript.javascriptGenerator.quote_(a.getFieldValue("TEXT")),
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ATOMIC
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.text_multiline = function(a) {
        a = module$exports$Blockly$JavaScript.javascriptGenerator.multiline_quote_(a.getFieldValue("TEXT"));
        const b = -1 !== a.indexOf("+") ? module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ADDITION : module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ATOMIC;
        return [
            a,
            b
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.text_join = function(a) {
        switch(a.itemCount_){
            case 0:
                return [
                    "''",
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ATOMIC
                ];
            case 1:
                return a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "ADD0", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''", module$contents$Blockly$JavaScript$texts_forceString(a);
            case 2:
                var b = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "ADD0", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''";
                a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "ADD1", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''";
                return [
                    module$contents$Blockly$JavaScript$texts_forceString(b)[0] + " + " + module$contents$Blockly$JavaScript$texts_forceString(a)[0],
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ADDITION
                ];
            default:
                b = Array(a.itemCount_);
                for(let c = 0; c < a.itemCount_; c++)b[c] = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "ADD" + c, module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''";
                return [
                    "[" + b.join(",") + "].join('')",
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
                ];
        }
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.text_append = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getName(a.getFieldValue("VAR"), $.NameType$$module$build$src$core$names.VARIABLE);
        a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "TEXT", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''";
        return b + " += " + module$contents$Blockly$JavaScript$texts_forceString(a)[0] + ";\n";
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.text_length = function(a) {
        return [
            (module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "VALUE", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER) || "''") + ".length",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.text_isEmpty = function(a) {
        return [
            "!" + (module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "VALUE", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER) || "''") + ".length",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_LOGICAL_NOT
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.text_indexOf = function(a) {
        var b = "FIRST" === a.getFieldValue("END") ? "indexOf" : "lastIndexOf";
        const c = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "FIND", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''";
        b = (module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "VALUE", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER) || "''") + "." + b + "(" + c + ")";
        return a.workspace.options.oneBasedIndex ? [
            b + " + 1",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ADDITION
        ] : [
            b,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.text_charAt = function(a) {
        const b = a.getFieldValue("WHERE") || "FROM_START", c = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "VALUE", "RANDOM" === b ? module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE : module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER) || "''";
        switch(b){
            case "FIRST":
                return [
                    c + ".charAt(0)",
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
                ];
            case "LAST":
                return [
                    c + ".slice(-1)",
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
                ];
            case "FROM_START":
                return a = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT"), [
                    c + ".charAt(" + a + ")",
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
                ];
            case "FROM_END":
                return a = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT", 1, !0), [
                    c + ".slice(" + a + ").charAt(0)",
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
                ];
            case "RANDOM":
                return [
                    module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("textRandomLetter", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(text) {
  var x = Math.floor(Math.random() * text.length);
  return text[x];
}
`) + "(" + c + ")",
                    module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
                ];
        }
        throw Error("Unhandled option (text_charAt).");
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.text_getSubstring = function(a) {
        var b = a.getFieldValue("WHERE1"), c = a.getFieldValue("WHERE2"), d = "FROM_END" !== b && "LAST" !== b && "FROM_END" !== c && "LAST" !== c, e = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "STRING", d ? module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER : module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''";
        if ("FIRST" === b && "LAST" === c) return [
            e,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE
        ];
        if (e.match(/^'?\w+'?$/) || d) {
            switch(b){
                case "FROM_START":
                    b = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT1");
                    break;
                case "FROM_END":
                    b = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT1", 1, !1, module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_SUBTRACTION);
                    b = e + ".length - " + b;
                    break;
                case "FIRST":
                    b = "0";
                    break;
                default:
                    throw Error("Unhandled option (text_getSubstring).");
            }
            switch(c){
                case "FROM_START":
                    c = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT2", 1);
                    break;
                case "FROM_END":
                    c = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT2", 0, !1, module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_SUBTRACTION);
                    c = e + ".length - " + c;
                    break;
                case "LAST":
                    c = e + ".length";
                    break;
                default:
                    throw Error("Unhandled option (text_getSubstring).");
            }
            e = e + ".slice(" + b + ", " + c + ")";
        } else {
            d = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT1");
            a = module$exports$Blockly$JavaScript.javascriptGenerator.getAdjusted(a, "AT2");
            const f = {
                FIRST: "First",
                LAST: "Last",
                FROM_START: "FromStart",
                FROM_END: "FromEnd"
            };
            e = module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("subsequence" + f[b] + f[c], `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(sequence${"FROM_END" === b || "FROM_START" === b ? ", at1" : ""}${"FROM_END" === c || "FROM_START" === c ? ", at2" : ""}) {
  var start = ${module$contents$Blockly$JavaScript$texts_getSubstringIndex("sequence", b, "at1")};
  var end = ${module$contents$Blockly$JavaScript$texts_getSubstringIndex("sequence", c, "at2")} + 1;
  return sequence.slice(start, end);
}
`) + "(" + e + ("FROM_END" === b || "FROM_START" === b ? ", " + d : "") + ("FROM_END" === c || "FROM_START" === c ? ", " + a : "") + ")";
        }
        return [
            e,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.text_changeCase = function(a) {
        const b = {
            UPPERCASE: ".toUpperCase()",
            LOWERCASE: ".toLowerCase()",
            TITLECASE: null
        }[a.getFieldValue("CASE")];
        a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "TEXT", b ? module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER : module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''";
        return [
            b ? a + b : module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("textToTitleCase", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(str) {
  return str.replace(/\\S+/g,
      function(txt) {return txt[0].toUpperCase() + txt.substring(1).toLowerCase();});
}
`) + "(" + a + ")",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.text_trim = function(a) {
        const b = {
            LEFT: ".replace(/^[\\s\\xa0]+/, '')",
            RIGHT: ".replace(/[\\s\\xa0]+$/, '')",
            BOTH: ".trim()"
        }[a.getFieldValue("MODE")];
        return [
            (module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "TEXT", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER) || "''") + b,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.text_print = function(a) {
        return "window.alert(" + (module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "TEXT", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''") + ");\n";
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.text_prompt_ext = function(a) {
        let b = "window.prompt(" + (a.getField("TEXT") ? module$exports$Blockly$JavaScript.javascriptGenerator.quote_(a.getFieldValue("TEXT")) : module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "TEXT", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''") + ")";
        "NUMBER" === a.getFieldValue("TYPE") && (b = "Number(" + b + ")");
        return [
            b,
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.text_prompt = module$exports$Blockly$JavaScript.javascriptGenerator.text_prompt_ext;
    module$exports$Blockly$JavaScript.javascriptGenerator.text_count = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "TEXT", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''";
        a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "SUB", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''";
        return [
            module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("textCount", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(haystack, needle) {
  if (needle.length === 0) {
    return haystack.length + 1;
  } else {
    return haystack.split(needle).length - 1;
  }
}
`) + "(" + b + ", " + a + ")",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.text_replace = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "TEXT", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''", c = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "FROM", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''";
        a = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "TO", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_NONE) || "''";
        return [
            module$exports$Blockly$JavaScript.javascriptGenerator.provideFunction_("textReplace", `
function ${module$exports$Blockly$JavaScript.javascriptGenerator.FUNCTION_NAME_PLACEHOLDER_}(haystack, needle, replacement) {
  needle = needle.replace(/([-()\\[\\]{}+?*.$\\^|,:#<!\\\\])/g, '\\\\$1')
                 .replace(/\\x08/g, '\\\\x08');
  return haystack.replace(new RegExp(needle, 'g'), replacement);
}
`) + "(" + b + ", " + c + ", " + a + ")",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.text_reverse = function(a) {
        return [
            (module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "TEXT", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_MEMBER) || "''") + ".split('').reverse().join('')",
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_FUNCTION_CALL
        ];
    };
    var module$exports$Blockly$JavaScript$variables = {}, module$contents$Blockly$JavaScript$variables_NameType = $.NameType$$module$build$src$core$names;
    module$exports$Blockly$JavaScript.javascriptGenerator.variables_get = function(a) {
        return [
            module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getName(a.getFieldValue("VAR"), $.NameType$$module$build$src$core$names.VARIABLE),
            module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ATOMIC
        ];
    };
    module$exports$Blockly$JavaScript.javascriptGenerator.variables_set = function(a) {
        const b = module$exports$Blockly$JavaScript.javascriptGenerator.valueToCode(a, "VALUE", module$exports$Blockly$JavaScript.javascriptGenerator.ORDER_ASSIGNMENT) || "0";
        return module$exports$Blockly$JavaScript.javascriptGenerator.nameDB_.getName(a.getFieldValue("VAR"), $.NameType$$module$build$src$core$names.VARIABLE) + " = " + b + ";\n";
    };
    var module$exports$Blockly$JavaScript$variablesDynamic = {};
    module$exports$Blockly$JavaScript.javascriptGenerator.variables_get_dynamic = module$exports$Blockly$JavaScript.javascriptGenerator.variables_get;
    module$exports$Blockly$JavaScript.javascriptGenerator.variables_set_dynamic = module$exports$Blockly$JavaScript.javascriptGenerator.variables_set;
    var module$exports$Blockly$JavaScript$all = module$exports$Blockly$JavaScript;
    module$exports$Blockly$JavaScript.__namespace__ = $;
    return module$exports$Blockly$JavaScript;
});

});



parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRegister("5Gn6I", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = mergeWith;

});

parcelRegister("8RYFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $675256233f0d2ee0$export$2e2bcd8739ae039);

var $bOhW4 = parcelRequire("bOhW4");
var $675256233f0d2ee0$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $675256233f0d2ee0$var$index = (0, $bOhW4.default)(function(prop) {
    return $675256233f0d2ee0$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $675256233f0d2ee0$export$2e2bcd8739ae039 = $675256233f0d2ee0$var$index;

});
parcelRegister("bOhW4", function(module, exports) {

$parcel$export(module.exports, "default", () => $899246d8080f48a0$export$2e2bcd8739ae039);
function $899246d8080f48a0$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $899246d8080f48a0$export$2e2bcd8739ae039 = $899246d8080f48a0$var$memoize;

});


parcelRegister("aeJDW", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, "_", {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    "Array",
    "Boolean",
    "Date",
    "Error",
    "EvalError",
    "Function",
    "Infinity",
    "JSON",
    "Math",
    "NaN",
    "Number",
    "Object",
    "RangeError",
    "ReferenceError",
    "RegExp",
    "String",
    "SyntaxError",
    "TypeError",
    "URIError",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "undefined",
    "unescape"
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement("iframe");
    if (!iframe.style) iframe.style = {};
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, "null");
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === "object") forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


var $ecab2ad3ed5a93ad$exports = {};

(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "./browser"
    ], factory);
    else $ecab2ad3ed5a93ad$exports = factory((parcelRequire("i9V5k")));
})($ecab2ad3ed5a93ad$exports, function(Blockly) {
    /**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @fileoverview Blockly module; this is a wrapper which selects
 *     either browser.js or node.js, depending on which environment we
 *     are running in.
 */ return Blockly;
});



var $1FOTS = parcelRequire("1FOTS");
var $e3ecb3c4189731c8$exports = {};
(function(root, factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else {
        var messages, key;
        $e3ecb3c4189731c8$exports = factory();
    }
})($e3ecb3c4189731c8$exports, function() {
    // This file was automatically generated.  Do not modify.
    "use strict";
    var Blockly = Blockly || {
        Msg: Object.create(null)
    };
    Blockly.Msg["ADD_COMMENT"] = "\u30B3\u30E1\u30F3\u30C8\u3092\u8FFD\u52A0";
    Blockly.Msg["CANNOT_DELETE_VARIABLE_PROCEDURE"] = "\u5909\u6570 '%1' \u306F\u95A2\u6570 '%2' \u306E\u5B9A\u7FA9\u306E\u4E00\u90E8\u3067\u3042\u308B\u305F\u3081\u3001\u524A\u9664\u3067\u304D\u307E\u305B\u3093";
    Blockly.Msg["CHANGE_VALUE_TITLE"] = "\u5024\u3092\u5909\u3048\u308B\uFF1A";
    Blockly.Msg["CLEAN_UP"] = "\u30D6\u30ED\u30C3\u30AF\u3092\u6574\u7406\u3059\u308B";
    Blockly.Msg["COLLAPSED_WARNINGS_WARNING"] = "\u3064\u3076\u3057\u305F\u30D6\u30ED\u30C3\u30AF\u306B\u306F\u8B66\u544A\u304C\u5165\u3063\u3066\u3044\u307E\u3059\u3002";
    Blockly.Msg["COLLAPSE_ALL"] = "\u30D6\u30ED\u30C3\u30AF\u3092\u6298\u308A\u305F\u305F\u3080";
    Blockly.Msg["COLLAPSE_BLOCK"] = "\u30D6\u30ED\u30C3\u30AF\u3092\u6298\u308A\u305F\u305F\u3080";
    Blockly.Msg["COLOUR_BLEND_COLOUR1"] = "\u8272 1";
    Blockly.Msg["COLOUR_BLEND_COLOUR2"] = "\u8272 2";
    Blockly.Msg["COLOUR_BLEND_HELPURL"] = "https://meyerweb.com/eric/tools/color-blend/#:::rgbp"; // untranslated
    Blockly.Msg["COLOUR_BLEND_RATIO"] = "\u6BD4\u7387";
    Blockly.Msg["COLOUR_BLEND_TITLE"] = "\u30D6\u30EC\u30F3\u30C9";
    Blockly.Msg["COLOUR_BLEND_TOOLTIP"] = "2\u8272\u3092\u4E0E\u3048\u3089\u308C\u305F\u6BD4\u7387\uFF080.0\uFF5E1.0\uFF09\u3067\u6DF7\u305C\u307E\u3059\u3002";
    Blockly.Msg["COLOUR_PICKER_HELPURL"] = "https://ja.wikipedia.org/wiki/\u8272";
    Blockly.Msg["COLOUR_PICKER_TOOLTIP"] = "\u30D1\u30EC\u30C3\u30C8\u304B\u3089\u8272\u3092\u9078\u3093\u3067\u304F\u3060\u3055\u3044\u3002";
    Blockly.Msg["COLOUR_RANDOM_HELPURL"] = "http://randomcolour.com"; // untranslated
    Blockly.Msg["COLOUR_RANDOM_TITLE"] = "\u30E9\u30F3\u30C0\u30E0\u306A\u8272";
    Blockly.Msg["COLOUR_RANDOM_TOOLTIP"] = "\u30E9\u30F3\u30C0\u30E0\u306B\u8272\u3092\u9078\u3076\u3002";
    Blockly.Msg["COLOUR_RGB_BLUE"] = "\u9752";
    Blockly.Msg["COLOUR_RGB_GREEN"] = "\u7DD1";
    Blockly.Msg["COLOUR_RGB_HELPURL"] = "https://www.december.com/html/spec/colorpercompact.html"; // untranslated
    Blockly.Msg["COLOUR_RGB_RED"] = "\u8D64";
    Blockly.Msg["COLOUR_RGB_TITLE"] = "\u8272:";
    Blockly.Msg["COLOUR_RGB_TOOLTIP"] = "\u8D64\u3001\u7DD1\u3001\u304A\u3088\u3073\u9752\u306E\u6307\u5B9A\u3055\u308C\u305F\u91CF\u3067\u8272\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002\u3059\u3079\u3066\u306E\u5024\u306F 0 \uFF5E 100 \u306E\u9593\u3067\u306A\u3051\u308C\u3070\u306A\u308A\u307E\u305B\u3093\u3002";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#loop-termination-blocks"; // untranslated
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK"] = "\u30EB\u30FC\u30D7\u304B\u3089\u629C\u3051\u51FA\u3059";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE"] = "\u30EB\u30FC\u30D7\u306E\u6B21\u306E\u53CD\u5FA9\u51E6\u7406\u3092\u7D9A\u884C\u3057\u307E\u3059";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_TOOLTIP_BREAK"] = "\u5165\u3063\u3066\u3044\u308B\u30EB\u30FC\u30D7\u304B\u3089\u629C\u3051\u51FA\u3057\u307E\u3059\u3002";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_TOOLTIP_CONTINUE"] = "\u3053\u306E\u30EB\u30FC\u30D7\u306E\u6B8B\u308A\u306E\u90E8\u5206\u3092\u30B9\u30AD\u30C3\u30D7\u3057\u3066\u3001\u30EB\u30FC\u30D7\u306E\u7E70\u308A\u8FD4\u3057\u3092\u7D9A\u3051\u307E\u3059\u3002";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_WARNING"] = "\u6CE8\u610F: \u3053\u306E\u30D6\u30ED\u30C3\u30AF\u306F\u3001\u30EB\u30FC\u30D7\u5185\u3067\u306E\u307F\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002";
    Blockly.Msg["CONTROLS_FOREACH_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#for-each"; // untranslated
    Blockly.Msg["CONTROLS_FOREACH_TITLE"] = "\u30EA\u30B9\u30C8%2\u306E\u5404\u9805\u76EE%1\u306B\u3064\u3044\u3066";
    Blockly.Msg["CONTROLS_FOREACH_TOOLTIP"] = "\u30EA\u30B9\u30C8\u306E\u5404\u9805\u76EE\u306B\u3064\u3044\u3066\u3001\u305D\u306E\u9805\u76EE\u3092\u5909\u6570'%1'\u3068\u3057\u3066\u3001\u3044\u304F\u3064\u304B\u306E\u30B9\u30C6\u30FC\u30C8\u30E1\u30F3\u30C8\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002";
    Blockly.Msg["CONTROLS_FOR_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#count-with"; // untranslated
    Blockly.Msg["CONTROLS_FOR_TITLE"] = "%1 \u3092 %2 \u304B\u3089 %3 \u307E\u3067 %4 \u305A\u3064\u30AB\u30A6\u30F3\u30C8\u3059\u308B";
    Blockly.Msg["CONTROLS_FOR_TOOLTIP"] = "\u5909\u6570 '%1' \u304C\u958B\u59CB\u756A\u53F7\u304B\u3089\u7D42\u4E86\u756A\u53F7\u307E\u3067\u6307\u5B9A\u3057\u305F\u9593\u9694\u3067\u306E\u5024\u3092\u3068\u3063\u3066\u3001\u6307\u5B9A\u3057\u305F\u30D6\u30ED\u30C3\u30AF\u3092\u5B9F\u884C\u3059\u308B\u3002";
    Blockly.Msg["CONTROLS_IF_ELSEIF_TOOLTIP"] = "\u300C\u3082\u3057\u3082\u300D\u306E\u30D6\u30ED\u30C3\u30AF\u306B\u6761\u4EF6\u3092\u8FFD\u52A0\u3057\u307E\u3059\u3002";
    Blockly.Msg["CONTROLS_IF_ELSE_TOOLTIP"] = "If\u30D6\u30ED\u30C3\u30AF\u306B\u3001\u3059\u3079\u3066\u3092\u30AD\u30E3\u30C3\u30C1\u3059\u308B\u6761\u4EF6\u3092\u8FFD\u52A0\u3002";
    Blockly.Msg["CONTROLS_IF_HELPURL"] = "https://github.com/google/blockly/wiki/IfElse"; // untranslated
    Blockly.Msg["CONTROLS_IF_IF_TOOLTIP"] = "\u8FFD\u52A0\u3001\u524A\u9664\u3001\u307E\u305F\u306F\u30BB\u30AF\u30B7\u30E7\u30F3\u3092\u9806\u5E8F\u5909\u66F4\u3057\u3066\u3001\u30D6\u30ED\u30C3\u30AF\u3092\u3053\u308C\u3092\u518D\u69CB\u6210\u3057\u307E\u3059\u3002";
    Blockly.Msg["CONTROLS_IF_MSG_ELSE"] = "\u305D\u3046\u3067\u306A\u3051\u308C\u3070";
    Blockly.Msg["CONTROLS_IF_MSG_ELSEIF"] = "\u305D\u3046\u3067\u306A\u304F\u3082\u3057";
    Blockly.Msg["CONTROLS_IF_MSG_IF"] = "\u3082\u3057";
    Blockly.Msg["CONTROLS_IF_TOOLTIP_1"] = "\u5024\u304C true \u306E\u5834\u5408\u3001\u30B9\u30C6\u30FC\u30C8\u30E1\u30F3\u30C8\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002";
    Blockly.Msg["CONTROLS_IF_TOOLTIP_2"] = "\u5024\u304C true \u306E\u5834\u5408\u306F\u3001\u6700\u521D\u306E\u30B9\u30C6\u30FC\u30C8\u30E1\u30F3\u30C8\u306E\u30D6\u30ED\u30C3\u30AF\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002\u305D\u308C\u4EE5\u5916\u306E\u5834\u5408\u306F\u30012\u756A\u76EE\u306E\u30B9\u30C6\u30FC\u30C8\u30E1\u30F3\u30C8\u306E\u30D6\u30ED\u30C3\u30AF\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002";
    Blockly.Msg["CONTROLS_IF_TOOLTIP_3"] = "\u6700\u521D\u306E\u5024\u304C true \u306E\u5834\u5408\u306F\u3001\u6700\u521D\u306E\u30B9\u30C6\u30FC\u30C8\u30E1\u30F3\u30C8\u306E\u30D6\u30ED\u30C3\u30AF\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002\u305D\u308C\u4EE5\u5916\u306E\u5834\u5408\u3067\u30012\u756A\u76EE\u306E\u5024\u304C true \u306E\u5834\u5408\u306F\u30012\u756A\u76EE\u306E\u30B9\u30C6\u30FC\u30C8\u30E1\u30F3\u30C8\u306E\u30D6\u30ED\u30C3\u30AF\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002";
    Blockly.Msg["CONTROLS_IF_TOOLTIP_4"] = "\u6700\u521D\u306E\u5024\u304C true \u306E\u5834\u5408\u306F\u3001\u6700\u521D\u306E\u30B9\u30C6\u30FC\u30C8\u30E1\u30F3\u30C8\u306E\u30D6\u30ED\u30C3\u30AF\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002\u305D\u308C\u4EE5\u5916\u306E\u5834\u5408\u3067\u30012\u756A\u76EE\u306E\u5024\u304C true \u306E\u5834\u5408\u306F\u30012\u756A\u76EE\u306E\u30B9\u30C6\u30FC\u30C8\u30E1\u30F3\u30C8\u306E\u30D6\u30ED\u30C3\u30AF\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002\u3059\u3079\u3066\u306E\u5024\u304C true \u3067\u306A\u3044\u5834\u5408\u306F\u3001\u6700\u5F8C\u306E\u30B9\u30C6\u30FC\u30C8\u30E1\u30F3\u30C8\u306E\u30D6\u30ED\u30C3\u30AF\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002";
    Blockly.Msg["CONTROLS_REPEAT_HELPURL"] = "https://ja.wikipedia.org/wiki/for\u6587";
    Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"] = "\u5B9F\u884C";
    Blockly.Msg["CONTROLS_REPEAT_TITLE"] = "%1 \u56DE\u7E70\u308A\u8FD4\u3059";
    Blockly.Msg["CONTROLS_REPEAT_TOOLTIP"] = "\u3044\u304F\u3064\u304B\u306E\u30B9\u30C6\u30FC\u30C8\u30E1\u30F3\u30C8\u3092\u6570\u56DE\u5B9F\u884C\u3057\u307E\u3059\u3002";
    Blockly.Msg["CONTROLS_WHILEUNTIL_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#repeat"; // untranslated
    Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_UNTIL"] = "\u7E70\u308A\u8FD4\u3059\uFF1A\u7D42\u308F\u308B\u6761\u4EF6";
    Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_WHILE"] = "\u7E70\u308A\u8FD4\u3059\uFF1A\u7D9A\u3051\u308B\u6761\u4EF6";
    Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL"] = "\u5024\u304Cfalse\u306E\u9593\u3001\u3044\u304F\u3064\u304B\u306E\u30B9\u30C6\u30FC\u30C8\u30E1\u30F3\u30C8\u3092\u5B9F\u884C\u3059\u308B\u3002";
    Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_WHILE"] = "\u5024\u304Ctrue\u306E\u9593\u3001\u3044\u304F\u3064\u304B\u306E\u30B9\u30C6\u30FC\u30C8\u30E1\u30F3\u30C8\u3092\u5B9F\u884C\u3059\u308B\u3002";
    Blockly.Msg["DELETE_ALL_BLOCKS"] = "%1\u500B\u3042\u308B\u3059\u3079\u3066\u306E\u30D6\u30ED\u30C3\u30AF\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F";
    Blockly.Msg["DELETE_BLOCK"] = "\u30D6\u30ED\u30C3\u30AF\u3092\u524A\u9664";
    Blockly.Msg["DELETE_VARIABLE"] = "\u5909\u6570 '%1' \u3092\u524A\u9664";
    Blockly.Msg["DELETE_VARIABLE_CONFIRMATION"] = "%1\u304B\u6240\u3067\u4F7F\u308F\u308C\u3066\u3044\u308B\u5909\u6570 '%2' \u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F";
    Blockly.Msg["DELETE_X_BLOCKS"] = "%1\u500B\u306E\u30D6\u30ED\u30C3\u30AF\u3092\u524A\u9664";
    Blockly.Msg["DIALOG_CANCEL"] = "\u30AD\u30E3\u30F3\u30BB\u30EB";
    Blockly.Msg["DIALOG_OK"] = "OK";
    Blockly.Msg["DISABLE_BLOCK"] = "\u30D6\u30ED\u30C3\u30AF\u3092\u7121\u52B9\u306B\u3059\u308B";
    Blockly.Msg["DUPLICATE_BLOCK"] = "\u8907\u88FD";
    Blockly.Msg["DUPLICATE_COMMENT"] = "\u30B3\u30E1\u30F3\u30C8\u3092\u8907\u88FD";
    Blockly.Msg["ENABLE_BLOCK"] = "\u30D6\u30ED\u30C3\u30AF\u3092\u6709\u52B9\u306B\u3059\u308B";
    Blockly.Msg["EXPAND_ALL"] = "\u30D6\u30ED\u30C3\u30AF\u3092\u5C55\u958B\u3059\u308B";
    Blockly.Msg["EXPAND_BLOCK"] = "\u30D6\u30ED\u30C3\u30AF\u3092\u5C55\u958B\u3059\u308B";
    Blockly.Msg["EXTERNAL_INPUTS"] = "\u5916\u90E8\u5165\u529B";
    Blockly.Msg["HELP"] = "\u30D8\u30EB\u30D7";
    Blockly.Msg["INLINE_INPUTS"] = "\u30A4\u30F3\u30E9\u30A4\u30F3\u5165\u529B";
    Blockly.Msg["LISTS_CREATE_EMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-empty-list"; // untranslated
    Blockly.Msg["LISTS_CREATE_EMPTY_TITLE"] = "\u7A7A\u306E\u30EA\u30B9\u30C8\u3092\u4F5C\u6210";
    Blockly.Msg["LISTS_CREATE_EMPTY_TOOLTIP"] = "\u9577\u3055\uFF10\u3067\u30C7\u30FC\u30BF\u30FB\u30EC\u30B3\u30FC\u30C9\u3092\u542B\u307E\u306A\u3044\u7A7A\u306E\u30EA\u30B9\u30C8\u3092\u8FD4\u3059";
    Blockly.Msg["LISTS_CREATE_WITH_CONTAINER_TITLE_ADD"] = "\u30EA\u30B9\u30C8";
    Blockly.Msg["LISTS_CREATE_WITH_CONTAINER_TOOLTIP"] = "\u8FFD\u52A0\u3001\u524A\u9664\u3001\u307E\u305F\u306F\u30BB\u30AF\u30B7\u30E7\u30F3\u306E\u9806\u5E8F\u5909\u66F4\u3092\u3057\u3066\u3001\u3053\u306E\u30EA\u30B9\u30C8\u30FB\u30D6\u30ED\u30C3\u30AF\u3092\u518D\u69CB\u6210\u3059\u308B\u3002";
    Blockly.Msg["LISTS_CREATE_WITH_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-list-with"; // untranslated
    Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH"] = "\u4EE5\u4E0B\u3092\u4F7F\u3063\u3066\u30EA\u30B9\u30C8\u3092\u4F5C\u6210\uFF1A";
    Blockly.Msg["LISTS_CREATE_WITH_ITEM_TOOLTIP"] = "\u30EA\u30B9\u30C8\u306B\u9805\u76EE\u3092\u8FFD\u52A0\u3002";
    Blockly.Msg["LISTS_CREATE_WITH_TOOLTIP"] = "\u9805\u76EE\u6570\u304C\u4E0D\u5B9A\u306E\u30EA\u30B9\u30C8\u3092\u4F5C\u6210\u3002";
    Blockly.Msg["LISTS_GET_INDEX_FIRST"] = "\u6700\u521D";
    Blockly.Msg["LISTS_GET_INDEX_FROM_END"] = "\u4F4D\u7F6E\uFF1A\u5F8C\u308D\u304B\u3089";
    Blockly.Msg["LISTS_GET_INDEX_FROM_START"] = "#";
    Blockly.Msg["LISTS_GET_INDEX_GET"] = "\u53D6\u5F97";
    Blockly.Msg["LISTS_GET_INDEX_GET_REMOVE"] = "\u53D6\u5F97\u3057\u3066\u524A\u9664";
    Blockly.Msg["LISTS_GET_INDEX_LAST"] = "\u6700\u5F8C";
    Blockly.Msg["LISTS_GET_INDEX_RANDOM"] = "\u30E9\u30F3\u30C0\u30E0";
    Blockly.Msg["LISTS_GET_INDEX_REMOVE"] = "\u524A\u9664";
    Blockly.Msg["LISTS_GET_INDEX_TAIL"] = ""; // untranslated
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_FIRST"] = "\u30EA\u30B9\u30C8\u306E\u6700\u521D\u306E\u9805\u76EE\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_FROM"] = "\u30EA\u30B9\u30C8\u5185\u306E\u6307\u5B9A\u4F4D\u7F6E\u306B\u3042\u308B\u9805\u76EE\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_LAST"] = "\u30EA\u30B9\u30C8\u306E\u6700\u5F8C\u306E\u9805\u76EE\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_RANDOM"] = "\u30E9\u30F3\u30C0\u30E0 \u30A2\u30A4\u30C6\u30E0 \u30EA\u30B9\u30C8\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FIRST"] = "\u30EA\u30B9\u30C8\u5185\u306E\u6700\u521D\u306E\u9805\u76EE\u3092\u524A\u9664\u3057\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FROM"] = "\u30EA\u30B9\u30C8\u5185\u306E\u6307\u5B9A\u4F4D\u7F6E\u306B\u3042\u308B\u9805\u76EE\u3092\u524A\u9664\u3057\u3001\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_LAST"] = "\u30EA\u30B9\u30C8\u5185\u306E\u6700\u5F8C\u306E\u9805\u76EE\u3092\u524A\u9664\u3057\u305F\u3042\u3068\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_RANDOM"] = "\u30EA\u30B9\u30C8\u306E\u30E9\u30F3\u30C0\u30E0\u306A\u30A2\u30A4\u30C6\u30E0\u3092\u524A\u9664\u3057\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_FIRST"] = "\u30EA\u30B9\u30C8\u5185\u306E\u6700\u521D\u306E\u9805\u76EE\u3092\u524A\u9664\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_FROM"] = "\u30EA\u30B9\u30C8\u5185\u306E\u6307\u5B9A\u3055\u308C\u305F\u9805\u76EE\u3092\u524A\u9664\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_LAST"] = "\u30EA\u30B9\u30C8\u5185\u306E\u6700\u5F8C\u306E\u9805\u76EE\u3092\u524A\u9664\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_RANDOM"] = "\u30EA\u30B9\u30C8\u5185\u306B\u3042\u308B\u30A2\u30A4\u30C6\u30E0\u3092\u30E9\u30F3\u30C0\u30E0\u306B\u524A\u9664\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_GET_SUBLIST_END_FROM_END"] = "\u7D42\u4E86\u4F4D\u7F6E\uFF1A\u5F8C\u308D\u304B\u3089";
    Blockly.Msg["LISTS_GET_SUBLIST_END_FROM_START"] = "\u7D42\u4E86\u4F4D\u7F6E\uFF1A";
    Blockly.Msg["LISTS_GET_SUBLIST_END_LAST"] = "\u6700\u5F8C\u307E\u3067";
    Blockly.Msg["LISTS_GET_SUBLIST_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#getting-a-sublist"; // untranslated
    Blockly.Msg["LISTS_GET_SUBLIST_START_FIRST"] = "\u6700\u521D\u304B\u3089\u30B5\u30D6\u30EA\u30B9\u30C8\u3092\u53D6\u5F97\u3059\u308B\u3002";
    Blockly.Msg["LISTS_GET_SUBLIST_START_FROM_END"] = "\u7AEF\u304B\u3089 #\u306E\u30B5\u30D6\u30EA\u30B9\u30C8\u3092\u53D6\u5F97\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_GET_SUBLIST_START_FROM_START"] = "# \u304B\u3089\u30B5\u30D6\u30C7\u30A3\u30EC\u30AF\u30C8\u30EA\u306E\u30EA\u30B9\u30C8\u3092\u53D6\u5F97\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_GET_SUBLIST_TAIL"] = ""; // untranslated
    Blockly.Msg["LISTS_GET_SUBLIST_TOOLTIP"] = "\u30EA\u30B9\u30C8\u306E\u6307\u5B9A\u3055\u308C\u305F\u90E8\u5206\u306E\u30B3\u30D4\u30FC\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_INDEX_FROM_END_TOOLTIP"] = "%1 \u306F\u3001\u6700\u5F8C\u306E\u9805\u76EE\u3067\u3059\u3002";
    Blockly.Msg["LISTS_INDEX_FROM_START_TOOLTIP"] = "%1 \u306F\u3001\u6700\u521D\u306E\u9805\u76EE\u3067\u3059\u3002";
    Blockly.Msg["LISTS_INDEX_OF_FIRST"] = "\u3067\u4EE5\u4E0B\u306E\u30A2\u30A4\u30C6\u30E0\u306E\u6700\u521D\u306E\u51FA\u73FE\u7B87\u6240\u3092\u691C\u7D22\uFF1A";
    Blockly.Msg["LISTS_INDEX_OF_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#getting-items-from-a-list"; // untranslated
    Blockly.Msg["LISTS_INDEX_OF_LAST"] = "\u3067\u4EE5\u4E0B\u306E\u30C6\u30AD\u30B9\u30C8\u306E\u6700\u5F8C\u306E\u51FA\u73FE\u7B87\u6240\u3092\u691C\u7D22\uFF1A";
    Blockly.Msg["LISTS_INDEX_OF_TOOLTIP"] = "\u30EA\u30B9\u30C8\u9805\u76EE\u306E\u6700\u521D/\u6700\u5F8C\u306B\u51FA\u73FE\u3059\u308B\u30A4\u30F3\u30C7\u30C3\u30AF\u30B9\u4F4D\u7F6E\u3092\u8FD4\u3057\u307E\u3059\u3002\u9805\u76EE\u304C\u898B\u3064\u304B\u3089\u306A\u3044\u5834\u5408\u306F %1 \u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_INLIST"] = "\u30EA\u30B9\u30C8";
    Blockly.Msg["LISTS_ISEMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#is-empty"; // untranslated
    Blockly.Msg["LISTS_ISEMPTY_TITLE"] = "%1\u304C\u7A7A";
    Blockly.Msg["LISTS_ISEMPTY_TOOLTIP"] = "\u30EA\u30B9\u30C8\u304C\u7A7A\u306E\u5834\u5408\u306F\u3001true \u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_LENGTH_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#length-of"; // untranslated
    Blockly.Msg["LISTS_LENGTH_TITLE"] = "%1\u306E\u9577\u3055";
    Blockly.Msg["LISTS_LENGTH_TOOLTIP"] = "\u30EA\u30B9\u30C8\u306E\u9577\u3055\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_REPEAT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-list-with"; // untranslated
    Blockly.Msg["LISTS_REPEAT_TITLE"] = "\u9805\u76EE%1\u3092%2\u56DE\u7E70\u308A\u8FD4\u3057\u305F\u30EA\u30B9\u30C8\u3092\u4F5C\u6210";
    Blockly.Msg["LISTS_REPEAT_TOOLTIP"] = "\u4E0E\u3048\u3089\u308C\u305F\u5024\u3092\u6307\u5B9A\u3055\u308C\u305F\u56DE\u6570\u7E70\u308A\u8FD4\u3057\u3066\u30EA\u30B9\u30C8\u3092\u4F5C\u6210\u3002";
    Blockly.Msg["LISTS_REVERSE_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#reversing-a-list"; // untranslated
    Blockly.Msg["LISTS_REVERSE_MESSAGE0"] = "%1\u3092\u9006\u9806\u306B";
    Blockly.Msg["LISTS_REVERSE_TOOLTIP"] = "\u30EA\u30B9\u30C8\u306E\u30B3\u30D4\u30FC\u3092\u9006\u9806\u306B\u3059\u308B\u3002";
    Blockly.Msg["LISTS_SET_INDEX_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#in-list--set"; // untranslated
    Blockly.Msg["LISTS_SET_INDEX_INPUT_TO"] = "\u5024\uFF1A";
    Blockly.Msg["LISTS_SET_INDEX_INSERT"] = "\u633F\u5165\u4F4D\u7F6E\uFF1A";
    Blockly.Msg["LISTS_SET_INDEX_SET"] = "\u30BB\u30C3\u30C8";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_FIRST"] = "\u30EA\u30B9\u30C8\u306E\u5148\u982D\u306B\u9805\u76EE\u3092\u633F\u5165\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_FROM"] = "\u30EA\u30B9\u30C8\u5185\u306E\u6307\u5B9A\u4F4D\u7F6E\u306B\u9805\u76EE\u3092\u633F\u5165\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_LAST"] = "\u30EA\u30B9\u30C8\u306E\u672B\u5C3E\u306B\u9805\u76EE\u3092\u8FFD\u52A0\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_RANDOM"] = "\u30EA\u30B9\u30C8\u306B\u9805\u76EE\u3092\u30E9\u30F3\u30C0\u30E0\u306B\u633F\u5165\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_FIRST"] = "\u30EA\u30B9\u30C8\u5185\u306B\u6700\u521D\u306E\u9805\u76EE\u3092\u8A2D\u5B9A\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_FROM"] = "\u30EA\u30B9\u30C8\u5185\u306E\u6307\u5B9A\u3055\u308C\u305F\u4F4D\u7F6E\u306B\u9805\u76EE\u3092\u8A2D\u5B9A\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_LAST"] = "\u30EA\u30B9\u30C8\u5185\u306E\u6700\u5F8C\u306E\u9805\u76EE\u3092\u8A2D\u5B9A\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_RANDOM"] = "\u30EA\u30B9\u30C8\u5185\u306B\u30E9\u30F3\u30C0\u30E0\u306A\u30A2\u30A4\u30C6\u30E0\u3092\u8A2D\u5B9A\u3057\u307E\u3059\u3002";
    Blockly.Msg["LISTS_SORT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#sorting-a-list"; // untranslated
    Blockly.Msg["LISTS_SORT_ORDER_ASCENDING"] = "\u6607\u9806";
    Blockly.Msg["LISTS_SORT_ORDER_DESCENDING"] = "\u964D\u9806";
    Blockly.Msg["LISTS_SORT_TITLE"] = "%1 ( %2 ) \u306B %3 \u3092\u4E26\u3073\u66FF\u3048\u308B";
    Blockly.Msg["LISTS_SORT_TOOLTIP"] = "\u30EA\u30B9\u30C8\u306E\u30B3\u30D4\u30FC\u3092\u4E26\u3079\u66FF\u3048";
    Blockly.Msg["LISTS_SORT_TYPE_IGNORECASE"] = "\u30A2\u30EB\u30D5\u30A1\u30D9\u30C3\u30C8\u9806\uFF08\u5927\u6587\u5B57\u30FB\u5C0F\u6587\u5B57\u306E\u533A\u5225\u7121\u3057\uFF09";
    Blockly.Msg["LISTS_SORT_TYPE_NUMERIC"] = "\u6570\u5024\u9806";
    Blockly.Msg["LISTS_SORT_TYPE_TEXT"] = "\u30A2\u30EB\u30D5\u30A1\u30D9\u30C3\u30C8\u9806";
    Blockly.Msg["LISTS_SPLIT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#splitting-strings-and-joining-lists"; // untranslated
    Blockly.Msg["LISTS_SPLIT_LIST_FROM_TEXT"] = "\u30C6\u30AD\u30B9\u30C8\u304B\u3089\u30EA\u30B9\u30C8\u3092\u4F5C\u308B";
    Blockly.Msg["LISTS_SPLIT_TEXT_FROM_LIST"] = "\u30EA\u30B9\u30C8\u304B\u3089\u30C6\u30AD\u30B9\u30C8\u3092\u4F5C\u308B";
    Blockly.Msg["LISTS_SPLIT_TOOLTIP_JOIN"] = "\u30C6\u30AD\u30B9\u30C8\u306E\u30EA\u30B9\u30C8\u3092\u533A\u5207\u308A\u8A18\u53F7\u3067\u533A\u5207\u3089\u308C\u305F\u4E00\u3064\u306E\u30C6\u30AD\u30B9\u30C8\u306B\u3059\u308B";
    Blockly.Msg["LISTS_SPLIT_TOOLTIP_SPLIT"] = "\u30C6\u30AD\u30B9\u30C8\u3092\u533A\u5207\u308A\u8A18\u53F7\u3067\u5206\u5272\u3057\u305F\u30EA\u30B9\u30C8\u306B\u3059\u308B";
    Blockly.Msg["LISTS_SPLIT_WITH_DELIMITER"] = "\u533A\u5207\u308A\u8A18\u53F7";
    Blockly.Msg["LOGIC_BOOLEAN_FALSE"] = "false";
    Blockly.Msg["LOGIC_BOOLEAN_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#values"; // untranslated
    Blockly.Msg["LOGIC_BOOLEAN_TOOLTIP"] = "true \u307E\u305F\u306F false \u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LOGIC_BOOLEAN_TRUE"] = "true";
    Blockly.Msg["LOGIC_COMPARE_HELPURL"] = "https://ja.wikipedia.org/wiki/\u4E0D\u7B49\u5F0F";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_EQ"] = "\u4E21\u65B9\u306E\u5165\u529B\u304C\u4E92\u3044\u306B\u7B49\u3057\u3044\u5834\u5408\u306B true \u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GT"] = "\u6700\u521D\u306E\u5165\u529B\u304C 2 \u756A\u76EE\u306E\u5165\u529B\u3088\u308A\u3082\u5927\u304D\u3044\u5834\u5408\u306F true \u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GTE"] = "\u6700\u521D\u306E\u5165\u529B\u304C 2 \u756A\u76EE\u306E\u5165\u529B\u4EE5\u4E0A\u306E\u5834\u5408\u306B true \u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LT"] = "\u6700\u521D\u306E\u5165\u529B\u304C 2 \u756A\u76EE\u306E\u5165\u529B\u3088\u308A\u3082\u5C0F\u3055\u3044\u5834\u5408\u306F true \u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LTE"] = "\u6700\u521D\u306E\u5165\u529B\u304C 2 \u756A\u76EE\u306E\u5165\u529B\u4EE5\u4E0B\u306E\u5834\u5408\u306B true \u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_NEQ"] = "\u4E21\u65B9\u306E\u5165\u529B\u304C\u4E92\u3044\u306B\u7B49\u3057\u304F\u306A\u3044\u5834\u5408\u306B true \u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LOGIC_NEGATE_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#not"; // untranslated
    Blockly.Msg["LOGIC_NEGATE_TITLE"] = "%1\u3067\u306F\u306A\u3044";
    Blockly.Msg["LOGIC_NEGATE_TOOLTIP"] = "\u5165\u529B\u304C false \u306E\u5834\u5408\u306F\u3001true \u3092\u8FD4\u3057\u307E\u3059\u3002\u5165\u529B\u304C true \u306E\u5834\u5408\u306F false \u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LOGIC_NULL"] = "null";
    Blockly.Msg["LOGIC_NULL_HELPURL"] = "https://en.wikipedia.org/wiki/Nullable_type"; // untranslated
    Blockly.Msg["LOGIC_NULL_TOOLTIP"] = "null \u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LOGIC_OPERATION_AND"] = "\u304B\u3064";
    Blockly.Msg["LOGIC_OPERATION_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#logical-operations"; // untranslated
    Blockly.Msg["LOGIC_OPERATION_OR"] = "\u307E\u305F\u306F";
    Blockly.Msg["LOGIC_OPERATION_TOOLTIP_AND"] = "\u4E21\u65B9\u306E\u5165\u529B\u304C true \u306E\u3068\u304D\u306B true \u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LOGIC_OPERATION_TOOLTIP_OR"] = "\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u306E\u5165\u529B\u304C true \u306E\u3068\u304D\u306B true \u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["LOGIC_TERNARY_CONDITION"] = "\u30C6\u30B9\u30C8";
    Blockly.Msg["LOGIC_TERNARY_HELPURL"] = "https://ja.wikipedia.org/wiki/%3F:";
    Blockly.Msg["LOGIC_TERNARY_IF_FALSE"] = "false \u306E\u5834\u5408";
    Blockly.Msg["LOGIC_TERNARY_IF_TRUE"] = "true \u306E\u5834\u5408";
    Blockly.Msg["LOGIC_TERNARY_TOOLTIP"] = "'\u30C6\u30B9\u30C8' \u306E\u6761\u4EF6\u3092\u30C1\u30A7\u30C3\u30AF\u3057\u307E\u3059\u3002\u6761\u4EF6\u304C true \u306E\u5834\u5408\u3001'true' \u306E\u5024\u3092\u8FD4\u3057\u307E\u3059\u3002\u305D\u308C\u4EE5\u5916\u306E\u5834\u5408 'false' \u306E\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["MATH_ADDITION_SYMBOL"] = "+"; // untranslated
    Blockly.Msg["MATH_ARITHMETIC_HELPURL"] = "https://ja.wikipedia.org/wiki/\u7B97\u8853";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_ADD"] = "2 \u3064\u306E\u6570\u306E\u5408\u8A08\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_DIVIDE"] = "2 \u3064\u306E\u6570\u306E\u5546\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MINUS"] = "2 \u3064\u306E\u6570\u306E\u5DEE\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MULTIPLY"] = "2 \u3064\u306E\u6570\u306E\u7A4D\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_POWER"] = "\u6700\u521D\u306E\u6570\u30922 \u756A\u76EE\u306E\u5024\u3067\u7D2F\u4E57\u3057\u305F\u7D50\u679C\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["MATH_ATAN2_HELPURL"] = "https://ja.wikipedia.org/wiki/Atan2";
    Blockly.Msg["MATH_ATAN2_TITLE"] = "X:%1 Y:%2\u306Eatan2";
    Blockly.Msg["MATH_ATAN2_TOOLTIP"] = "\u30A2\u30FC\u30AF\u30BF\u30F3\u30B8\u30A7\u30F3\u30C8\u3092\u7528\u3044\u3066\u3001\u70B9 (X, Y) \u306E\u89D2\u5EA6\u3092 -180\u5EA6\u304B\u3089 180\u5EA6\u3067\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["MATH_CHANGE_HELPURL"] = "https://ja.wikipedia.org/wiki/\u52A0\u6CD5";
    Blockly.Msg["MATH_CHANGE_TITLE"] = "%1 \u3092 %2 \u5897\u3084\u3059";
    Blockly.Msg["MATH_CHANGE_TOOLTIP"] = "\u5909\u6570'%1'\u306B\u6570\u3092\u305F\u3059\u3002";
    Blockly.Msg["MATH_CONSTANT_HELPURL"] = "https://ja.wikipedia.org/wiki/\u6570\u5B66\u5B9A\u6570";
    Blockly.Msg["MATH_CONSTANT_TOOLTIP"] = "\u3044\u305A\u308C\u304B\u306E\u5171\u901A\u306E\u5B9A\u6570\u306E\u3092\u8FD4\u3059: \u03C0 (3.141\u2026), e (2.718\u2026), \u03C6 (1.618\u2026), sqrt(2) (1.414\u2026), sqrt(\xbd) (0.707\u2026), or \u221E (\u7121\u9650).";
    Blockly.Msg["MATH_CONSTRAIN_HELPURL"] = "https://en.wikipedia.org/wiki/Clamping_(graphics)"; // untranslated
    Blockly.Msg["MATH_CONSTRAIN_TITLE"] = "%1 \u3092 %2 \u4EE5\u4E0A %3 \u4EE5\u4E0B\u306E\u7BC4\u56F2\u306B\u5236\u9650";
    Blockly.Msg["MATH_CONSTRAIN_TOOLTIP"] = "\u6307\u5B9A\u3057\u305F\u4E0A\u9650\u3068\u4E0B\u9650\u306E\u9593\u306B\u5024\u3092\u5236\u9650\u3059\u308B\uFF08\u4E0A\u9650\u3068\u4E0B\u9650\u306E\u5024\u3092\u542B\u3080\uFF09\u3002";
    Blockly.Msg["MATH_DIVISION_SYMBOL"] = "\xf7"; // untranslated
    Blockly.Msg["MATH_IS_DIVISIBLE_BY"] = "\u306F\u4EE5\u4E0B\u3067\u5272\u308A\u304D\u308C\u308B\uFF1A";
    Blockly.Msg["MATH_IS_EVEN"] = "\u306F\u5076\u6570";
    Blockly.Msg["MATH_IS_NEGATIVE"] = "\u306F\u8CA0";
    Blockly.Msg["MATH_IS_ODD"] = "\u306F\u5947\u6570";
    Blockly.Msg["MATH_IS_POSITIVE"] = "\u306F\u6B63";
    Blockly.Msg["MATH_IS_PRIME"] = "\u306F\u7D20\u6570";
    Blockly.Msg["MATH_IS_TOOLTIP"] = "\u6570\u5B57\u304C\u3001\u5076\u6570\u3001\u5947\u6570\u3001\u7D20\u6570\u3001\u6574\u6570\u3001\u6B63\u6570\u3001\u8CA0\u6570\u3001\u307E\u305F\u306F\u7279\u5B9A\u306E\u6570\u3067\u5272\u308A\u5207\u308C\u308B\u304B\u3069\u3046\u304B\u3092\u5224\u5B9A\u3057\u3001true \u304B false \u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["MATH_IS_WHOLE"] = "\u306F\u6574\u6570";
    Blockly.Msg["MATH_MODULO_HELPURL"] = "https://ja.wikipedia.org/wiki/\u5270\u4F59\u6F14\u7B97";
    Blockly.Msg["MATH_MODULO_TITLE"] = "%1\xf7%2\u306E\u4F59\u308A";
    Blockly.Msg["MATH_MODULO_TOOLTIP"] = "2\u3064\u306E\u6570\u5024\u306E\u5272\u308A\u7B97\u306E\u4F59\u308A\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_MULTIPLICATION_SYMBOL"] = "\xd7"; // untranslated
    Blockly.Msg["MATH_NUMBER_HELPURL"] = "https://ja.wikipedia.org/wiki/\u6570";
    Blockly.Msg["MATH_NUMBER_TOOLTIP"] = "\u6570\u3067\u3059\u3002";
    Blockly.Msg["MATH_ONLIST_HELPURL"] = ""; // untranslated
    Blockly.Msg["MATH_ONLIST_OPERATOR_AVERAGE"] = "\u30EA\u30B9\u30C8\u306E\u5E73\u5747";
    Blockly.Msg["MATH_ONLIST_OPERATOR_MAX"] = "\u30EA\u30B9\u30C8\u306E\u6700\u5927\u5024";
    Blockly.Msg["MATH_ONLIST_OPERATOR_MEDIAN"] = "\u30EA\u30B9\u30C8\u306E\u4E2D\u592E\u5024";
    Blockly.Msg["MATH_ONLIST_OPERATOR_MIN"] = "\u30EA\u30B9\u30C8\u306E\u6700\u5C0F\u5024";
    Blockly.Msg["MATH_ONLIST_OPERATOR_MODE"] = "\u30EA\u30B9\u30C8\u306E\u6700\u983B\u5024";
    Blockly.Msg["MATH_ONLIST_OPERATOR_RANDOM"] = "\u30EA\u30B9\u30C8\u304B\u3089\u30E9\u30F3\u30C0\u30E0\u306B\u9078\u3070\u308C\u305F\u9805\u76EE";
    Blockly.Msg["MATH_ONLIST_OPERATOR_STD_DEV"] = "\u30EA\u30B9\u30C8\u306E\u6A19\u6E96\u504F\u5DEE";
    Blockly.Msg["MATH_ONLIST_OPERATOR_SUM"] = "\u30EA\u30B9\u30C8\u306E\u5408\u8A08";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_AVERAGE"] = "\u30EA\u30B9\u30C8\u306E\u6570\u5024\u306E\u5E73\u5747 (\u7B97\u8853\u5E73\u5747) \u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_MAX"] = "\u30EA\u30B9\u30C8\u306E\u6700\u5927\u5024\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_MEDIAN"] = "\u30EA\u30B9\u30C8\u306E\u4E2D\u592E\u5024\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_MIN"] = "\u30EA\u30B9\u30C8\u306E\u6700\u5C0F\u5024\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_MODE"] = "\u30EA\u30B9\u30C8\u4E2D\u306E\u6700\u983B\u9805\u76EE\u306E\u30EA\u30B9\u30C8\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_RANDOM"] = "\u30EA\u30B9\u30C8\u304B\u3089\u30E9\u30F3\u30C0\u30E0\u306B\u9078\u3070\u308C\u305F\u8981\u7D20\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_STD_DEV"] = "\u30EA\u30B9\u30C8\u306E\u6A19\u6E96\u504F\u5DEE\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_SUM"] = "\u30EA\u30B9\u30C8\u306E\u6570\u5024\u3092\u8DB3\u3057\u3066\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_POWER_SYMBOL"] = "^"; // untranslated
    Blockly.Msg["MATH_RANDOM_FLOAT_HELPURL"] = "https://ja.wikipedia.org/wiki/\u7591\u4F3C\u4E71\u6570";
    Blockly.Msg["MATH_RANDOM_FLOAT_TITLE_RANDOM"] = "1\u672A\u6E80\u306E\u6B63\u306E\u4E71\u6570";
    Blockly.Msg["MATH_RANDOM_FLOAT_TOOLTIP"] = "0.0\u4EE5\u4E0A\u30671.0\u672A\u6E80\u306E\u7BC4\u56F2\u306E\u4E71\u6570\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["MATH_RANDOM_INT_HELPURL"] = "https://ja.wikipedia.org/wiki/\u7591\u4F3C\u4E71\u6570";
    Blockly.Msg["MATH_RANDOM_INT_TITLE"] = "%1\u304B\u3089%2\u307E\u3067\u306E\u30E9\u30F3\u30C0\u30E0\u306A\u6574\u6570";
    Blockly.Msg["MATH_RANDOM_INT_TOOLTIP"] = "\u6307\u5B9A\u3055\u308C\u305F\uFF08\u4E0A\u4E0B\u9650\u3092\u542B\u3080\uFF09\u7BC4\u56F2\u306E\u30E9\u30F3\u30C0\u30E0\u306A\u6574\u6570\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["MATH_ROUND_HELPURL"] = "https://ja.wikipedia.org/wiki/\u7AEF\u6570\u51E6\u7406";
    Blockly.Msg["MATH_ROUND_OPERATOR_ROUND"] = "\u56DB\u6368\u4E94\u5165";
    Blockly.Msg["MATH_ROUND_OPERATOR_ROUNDDOWN"] = "\u5207\u308A\u6368\u3066";
    Blockly.Msg["MATH_ROUND_OPERATOR_ROUNDUP"] = "\u5207\u308A\u4E0A\u3052";
    Blockly.Msg["MATH_ROUND_TOOLTIP"] = "\u6570\u5024\u3092\u5207\u308A\u4E0A\u3052\u308B\u304B\u5207\u308A\u6368\u3066\u308B";
    Blockly.Msg["MATH_SINGLE_HELPURL"] = "https://ja.wikipedia.org/wiki/\u5E73\u65B9\u6839";
    Blockly.Msg["MATH_SINGLE_OP_ABSOLUTE"] = "\u7D76\u5BFE\u5024";
    Blockly.Msg["MATH_SINGLE_OP_ROOT"] = "\u5E73\u65B9\u6839";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_ABS"] = "\u7D76\u5BFE\u5024\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_EXP"] = "\u30CD\u30A4\u30D4\u30A2\u6570e\u306E\u6570\u5024\u4E57\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_LN"] = "\u6570\u5024\u306E\u81EA\u7136\u5BFE\u6570\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_LOG10"] = "\u5E95\u304C10\u306E\u5BFE\u6570\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_NEG"] = "\u8CA0\u306E\u6570\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_POW10"] = "10\u306E\u6570\u5024\u4E57\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_ROOT"] = "\u5E73\u65B9\u6839\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_SUBTRACTION_SYMBOL"] = "-"; // untranslated
    Blockly.Msg["MATH_TRIG_ACOS"] = "acos";
    Blockly.Msg["MATH_TRIG_ASIN"] = "asin";
    Blockly.Msg["MATH_TRIG_ATAN"] = "atan";
    Blockly.Msg["MATH_TRIG_COS"] = "cos";
    Blockly.Msg["MATH_TRIG_HELPURL"] = "https://ja.wikipedia.org/wiki/\u4E09\u89D2\u95A2\u6570";
    Blockly.Msg["MATH_TRIG_SIN"] = "sin";
    Blockly.Msg["MATH_TRIG_TAN"] = "tan";
    Blockly.Msg["MATH_TRIG_TOOLTIP_ACOS"] = "\u30A2\u30FC\u30AF\u30B3\u30B5\u30A4\u30F3\uFF08arccosin\uFF09\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_TRIG_TOOLTIP_ASIN"] = "\u30A2\u30FC\u30AF\u30B5\u30A4\u30F3\uFF08arcsin\uFF09\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_TRIG_TOOLTIP_ATAN"] = "\u30A2\u30FC\u30AF\u30BF\u30F3\u30B8\u30A7\u30F3\u30C8\uFF08arctan\uFF09\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_TRIG_TOOLTIP_COS"] = "\uFF08\u30E9\u30B8\u30A2\u30F3\u3067\u306F\u306A\u304F\uFF09\u5EA6\u6570\u306E\u4F59\u5F26\uFF08cosin\uFF09\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_TRIG_TOOLTIP_SIN"] = "\uFF08\u30E9\u30B8\u30A2\u30F3\u3067\u306F\u306A\u304F\uFF09\u5EA6\u6570\u306E\u6B63\u5F26\uFF08sin\uFF09\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["MATH_TRIG_TOOLTIP_TAN"] = "\uFF08\u30E9\u30B8\u30A2\u30F3\u3067\u306F\u306A\u304F\uFF09\u5EA6\u6570\u306E\u6B63\u63A5\uFF08tan\uFF09\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["NEW_COLOUR_VARIABLE"] = "\u8272\u306E\u5909\u6570\u3092\u4F5C\u308B...";
    Blockly.Msg["NEW_NUMBER_VARIABLE"] = "\u6570\u306E\u5909\u6570\u3092\u4F5C\u308B...";
    Blockly.Msg["NEW_STRING_VARIABLE"] = "\u6587\u5B57\u5217\u306E\u5909\u6570\u3092\u4F5C\u308B...";
    Blockly.Msg["NEW_VARIABLE"] = "\u5909\u6570\u306E\u4F5C\u6210\u2026";
    Blockly.Msg["NEW_VARIABLE_TITLE"] = "\u65B0\u3057\u3044\u5909\u6570\u306E\u540D\u524D:";
    Blockly.Msg["NEW_VARIABLE_TYPE_TITLE"] = "\u65B0\u3057\u3044\u5909\u6570\u306E\u578B:";
    Blockly.Msg["ORDINAL_NUMBER_SUFFIX"] = ""; // untranslated
    Blockly.Msg["PROCEDURES_ALLOW_STATEMENTS"] = "\u30B9\u30C6\u30FC\u30C8\u30E1\u30F3\u30C8\u3092\u8A31\u53EF";
    Blockly.Msg["PROCEDURES_BEFORE_PARAMS"] = "\u5F15\u6570\uFF1A";
    Blockly.Msg["PROCEDURES_CALLNORETURN_HELPURL"] = "https://ja.wikipedia.org/wiki/\u30B5\u30D6\u30EB\u30FC\u30C1\u30F3";
    Blockly.Msg["PROCEDURES_CALLNORETURN_TOOLTIP"] = "\u30E6\u30FC\u30B6\u30FC\u5B9A\u7FA9\u95A2\u6570 '%1' \u3092\u5B9F\u884C\u3057\u307E\u3059\u3002";
    Blockly.Msg["PROCEDURES_CALLRETURN_HELPURL"] = "https://ja.wikipedia.org/wiki/\u30B5\u30D6\u30EB\u30FC\u30C1\u30F3";
    Blockly.Msg["PROCEDURES_CALLRETURN_TOOLTIP"] = "\u30E6\u30FC\u30B6\u30FC\u5B9A\u7FA9\u95A2\u6570 '%1' \u3092\u5B9F\u884C\u3057\u3001\u305D\u306E\u51FA\u529B\u3092\u4F7F\u7528\u3057\u307E\u3059\u3002";
    Blockly.Msg["PROCEDURES_CALL_BEFORE_PARAMS"] = "\u5F15\u6570\uFF1A";
    Blockly.Msg["PROCEDURES_CREATE_DO"] = "'%1' \u3092\u4F5C\u6210";
    Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"] = "\u3053\u306E\u95A2\u6570\u306E\u8AAC\u660E\u2026";
    Blockly.Msg["PROCEDURES_DEFNORETURN_DO"] = ""; // untranslated
    Blockly.Msg["PROCEDURES_DEFNORETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine"; // untranslated
    Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"] = "\u4F55\u304B\u3059\u308B";
    Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"] = "\u95A2\u6570";
    Blockly.Msg["PROCEDURES_DEFNORETURN_TOOLTIP"] = "\u51FA\u529B\u306A\u3057\u306E\u95A2\u6570\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002";
    Blockly.Msg["PROCEDURES_DEFRETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine"; // untranslated
    Blockly.Msg["PROCEDURES_DEFRETURN_RETURN"] = "\u8FD4\u3059";
    Blockly.Msg["PROCEDURES_DEFRETURN_TOOLTIP"] = "\u4E00\u3064\u306E\u51FA\u529B\u3092\u6301\u3064\u95A2\u6570\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002";
    Blockly.Msg["PROCEDURES_DEF_DUPLICATE_WARNING"] = "\u8B66\u544A: \u3053\u306E\u95A2\u6570\u306B\u306F\u91CD\u8907\u3059\u308B\u30D1\u30E9\u30E1\u30FC\u30BF\u30FC\u304C\u3042\u308A\u307E\u3059\u3002";
    Blockly.Msg["PROCEDURES_HIGHLIGHT_DEF"] = "\u95A2\u6570\u306E\u5185\u5BB9\u3092\u5F37\u8ABF\u8868\u793A\u3057\u307E\u3059\u3002";
    Blockly.Msg["PROCEDURES_IFRETURN_HELPURL"] = "http://c2.com/cgi/wiki?GuardClause"; // untranslated
    Blockly.Msg["PROCEDURES_IFRETURN_TOOLTIP"] = "1\u756A\u76EE\u306E\u5024\u304C true \u306E\u5834\u5408\u30012\u756A\u76EE\u306E\u5024\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["PROCEDURES_IFRETURN_WARNING"] = "\u8B66\u544A: \u3053\u306E\u30D6\u30ED\u30C3\u30AF\u306F\u3001\u95A2\u6570\u5B9A\u7FA9\u5185\u3067\u306E\u307F\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002";
    Blockly.Msg["PROCEDURES_MUTATORARG_TITLE"] = "\u5165\u529B\u540D:";
    Blockly.Msg["PROCEDURES_MUTATORARG_TOOLTIP"] = "\u95A2\u6570\u3078\u306E\u5165\u529B\u306E\u8FFD\u52A0\u3002";
    Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TITLE"] = "\u5165\u529B";
    Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TOOLTIP"] = "\u3053\u306E\u95A2\u6570\u3078\u306E\u5165\u529B\u306E\u8FFD\u52A0\u3001\u524A\u9664\u3001\u9806\u756A\u5909\u66F4\u3002";
    Blockly.Msg["REDO"] = "\u3084\u308A\u76F4\u3059";
    Blockly.Msg["REMOVE_COMMENT"] = "\u30B3\u30E1\u30F3\u30C8\u3092\u524A\u9664";
    Blockly.Msg["RENAME_VARIABLE"] = "\u5909\u6570\u306E\u540D\u524D\u3092\u5909\u3048\u308B\u2026";
    Blockly.Msg["RENAME_VARIABLE_TITLE"] = "\u300C%1\u300D\u3068\u3044\u3046\u540D\u524D\u306E\u5909\u6570\u540D\u3092\u3059\u3079\u3066\u5909\u3048\u308B\uFF1A";
    Blockly.Msg["TEXT_APPEND_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-modification"; // untranslated
    Blockly.Msg["TEXT_APPEND_TITLE"] = "\u9805\u76EE %1 \u3078\u30C6\u30AD\u30B9\u30C8\u3092\u8FFD\u52A0 %2";
    Blockly.Msg["TEXT_APPEND_TOOLTIP"] = "\u5909\u6570 '%1' \u306B\u30C6\u30AD\u30B9\u30C8\u3092\u8FFD\u52A0\u3002";
    Blockly.Msg["TEXT_CHANGECASE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#adjusting-text-case"; // untranslated
    Blockly.Msg["TEXT_CHANGECASE_OPERATOR_LOWERCASE"] = "\u5C0F\u6587\u5B57\u306B";
    Blockly.Msg["TEXT_CHANGECASE_OPERATOR_TITLECASE"] = "\u30BF\u30A4\u30C8\u30EB \u30B1\u30FC\u30B9\u306B";
    Blockly.Msg["TEXT_CHANGECASE_OPERATOR_UPPERCASE"] = "\u5927\u6587\u5B57\u306B";
    Blockly.Msg["TEXT_CHANGECASE_TOOLTIP"] = "\u5225\u306E\u30B1\u30FC\u30B9\u306B\u3001\u30C6\u30AD\u30B9\u30C8\u306E\u30B3\u30D4\u30FC\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["TEXT_CHARAT_FIRST"] = "\u6700\u521D\u306E\u6587\u5B57\u3092\u5F97\u308B";
    Blockly.Msg["TEXT_CHARAT_FROM_END"] = "\u306E\u3001\u5F8C\u308D\u304B\u3089\u4EE5\u4E0B\u306E\u6570\u5B57\u756A\u76EE\u306E\u6587\u5B57\uFF1A";
    Blockly.Msg["TEXT_CHARAT_FROM_START"] = "\u306E\u3001\u4EE5\u4E0B\u306E\u6570\u5B57\u756A\u76EE\u306E\u6587\u5B57\uFF1A";
    Blockly.Msg["TEXT_CHARAT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#extracting-text"; // untranslated
    Blockly.Msg["TEXT_CHARAT_LAST"] = "\u6700\u5F8C\u306E\u6587\u5B57\u3092\u5F97\u308B";
    Blockly.Msg["TEXT_CHARAT_RANDOM"] = "\u30E9\u30F3\u30C0\u30E0\u306A\u6587\u5B57\u3092\u5F97\u308B";
    Blockly.Msg["TEXT_CHARAT_TAIL"] = ""; // untranslated
    Blockly.Msg["TEXT_CHARAT_TITLE"] = "\u30C6\u30AD\u30B9\u30C8 %1 %2";
    Blockly.Msg["TEXT_CHARAT_TOOLTIP"] = "\u6307\u5B9A\u3055\u308C\u305F\u4F4D\u7F6E\u306B\u6587\u5B57\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["TEXT_COUNT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#counting-substrings"; // untranslated
    Blockly.Msg["TEXT_COUNT_MESSAGE0"] = "%2\u306B\u542B\u307E\u308C\u308B%1\u306E\u6570\u3092\u6570\u3048\u308B";
    Blockly.Msg["TEXT_COUNT_TOOLTIP"] = "\u3068\u3042\u308B\u6587\u304C\u5225\u306E\u6587\u306E\u306A\u304B\u306B\u4F7F\u308F\u308C\u305F\u56DE\u6570\u3092\u6570\u3048\u308B\u3002";
    Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TOOLTIP"] = "\u30C6\u30AD\u30B9\u30C8\u3078\u9805\u76EE\u3092\u8FFD\u52A0\u3002";
    Blockly.Msg["TEXT_CREATE_JOIN_TITLE_JOIN"] = "\u7D50\u5408";
    Blockly.Msg["TEXT_CREATE_JOIN_TOOLTIP"] = "\u30BB\u30AF\u30B7\u30E7\u30F3\u3092\u8FFD\u52A0\u3001\u524A\u9664\u3001\u307E\u305F\u306F\u9806\u5E8F\u5909\u66F4\u3057\u3066\u3001\u30D6\u30ED\u30C3\u30AF\u3092\u518D\u69CB\u6210\u3002";
    Blockly.Msg["TEXT_GET_SUBSTRING_END_FROM_END"] = "\u7D42\u4E86\u4F4D\u7F6E\uFF1A\u5F8C\u308D\u304B\u3089";
    Blockly.Msg["TEXT_GET_SUBSTRING_END_FROM_START"] = "\u7D42\u4E86\u4F4D\u7F6E\uFF1A";
    Blockly.Msg["TEXT_GET_SUBSTRING_END_LAST"] = "\u6700\u5F8C\u306E\u6587\u5B57";
    Blockly.Msg["TEXT_GET_SUBSTRING_HELPURL"] = "https://github.com/google/blockly/wiki/Text#extracting-a-region-of-text"; // untranslated
    Blockly.Msg["TEXT_GET_SUBSTRING_INPUT_IN_TEXT"] = "\u30C6\u30AD\u30B9\u30C8";
    Blockly.Msg["TEXT_GET_SUBSTRING_START_FIRST"] = "\u306E\u90E8\u5206\u6587\u5B57\u5217\u3092\u53D6\u5F97\uFF1B\u6700\u521D\u304B\u3089";
    Blockly.Msg["TEXT_GET_SUBSTRING_START_FROM_END"] = "\u306E\u90E8\u5206\u6587\u5B57\u5217\u3092\u53D6\u5F97\uFF1B\u958B\u59CB\u4F4D\u7F6E\uFF1A\u5F8C\u308D\u304B\u3089";
    Blockly.Msg["TEXT_GET_SUBSTRING_START_FROM_START"] = "\u306E\u90E8\u5206\u6587\u5B57\u5217\u3092\u53D6\u5F97\uFF1B\u958B\u59CB\u4F4D\u7F6E\uFF1A";
    Blockly.Msg["TEXT_GET_SUBSTRING_TAIL"] = ""; // untranslated
    Blockly.Msg["TEXT_GET_SUBSTRING_TOOLTIP"] = "\u30C6\u30AD\u30B9\u30C8\u306E\u6307\u5B9A\u90E8\u5206\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["TEXT_INDEXOF_HELPURL"] = "https://github.com/google/blockly/wiki/Text#finding-text"; // untranslated
    Blockly.Msg["TEXT_INDEXOF_OPERATOR_FIRST"] = "\u3067\u4EE5\u4E0B\u306E\u30C6\u30AD\u30B9\u30C8\u306E\u6700\u521D\u306E\u51FA\u73FE\u7B87\u6240\u3092\u691C\u7D22\uFF1A";
    Blockly.Msg["TEXT_INDEXOF_OPERATOR_LAST"] = "\u3067\u4EE5\u4E0B\u306E\u30C6\u30AD\u30B9\u30C8\u306E\u6700\u5F8C\u306E\u51FA\u73FE\u7B87\u6240\u3092\u691C\u7D22\uFF1A";
    Blockly.Msg["TEXT_INDEXOF_TITLE"] = "\u30C6\u30AD\u30B9\u30C8 %1 %2 %3";
    Blockly.Msg["TEXT_INDEXOF_TOOLTIP"] = "\u4E8C\u756A\u76EE\u306E\u30C6\u30AD\u30B9\u30C8\u306E\u4E2D\u3067\u4E00\u756A\u76EE\u306E\u30C6\u30AD\u30B9\u30C8\u304C\u6700\u521D\uFF0F\u6700\u5F8C\u306B\u51FA\u73FE\u3057\u305F\u30A4\u30F3\u30C7\u30C3\u30AF\u30B9\u3092\u8FD4\u3059\u3002\u30C6\u30AD\u30B9\u30C8\u304C\u898B\u3064\u304B\u3089\u306A\u3044\u5834\u5408\u306F%1\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["TEXT_ISEMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Text#checking-for-empty-text"; // untranslated
    Blockly.Msg["TEXT_ISEMPTY_TITLE"] = "%1\u304C\u7A7A";
    Blockly.Msg["TEXT_ISEMPTY_TOOLTIP"] = "\u4E0E\u3048\u3089\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u304C\u7A7A\u306E\u5834\u5408\u306F true \u3092\u8FD4\u3059\u3002";
    Blockly.Msg["TEXT_JOIN_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-creation"; // untranslated
    Blockly.Msg["TEXT_JOIN_TITLE_CREATEWITH"] = "\u30C6\u30AD\u30B9\u30C8\u3092\u7D50\u5408\u3057\u3066\u4F5C\u6210\uFF1A";
    Blockly.Msg["TEXT_JOIN_TOOLTIP"] = "\u4EFB\u610F\u306E\u6570\u306E\u9805\u76EE\u4E00\u90E8\u3092\u4E00\u7DD2\u306B\u63A5\u5408\u3057\u3066\u30C6\u30AD\u30B9\u30C8\u3092\u4F5C\u6210\u3002";
    Blockly.Msg["TEXT_LENGTH_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-modification"; // untranslated
    Blockly.Msg["TEXT_LENGTH_TITLE"] = "%1\u306E\u9577\u3055";
    Blockly.Msg["TEXT_LENGTH_TOOLTIP"] = "\u4E0E\u3048\u3089\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u306E(\u30B9\u30DA\u30FC\u30B9\u3092\u542B\u3080)\u6587\u5B57\u6570\u3092\u8FD4\u3059\u3002";
    Blockly.Msg["TEXT_PRINT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#printing-text"; // untranslated
    Blockly.Msg["TEXT_PRINT_TITLE"] = "%1 \u3092\u8868\u793A";
    Blockly.Msg["TEXT_PRINT_TOOLTIP"] = "\u6307\u5B9A\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u3001\u756A\u53F7\u307E\u305F\u306F\u4ED6\u306E\u5024\u3092\u5370\u5237\u3057\u307E\u3059\u3002";
    Blockly.Msg["TEXT_PROMPT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#getting-input-from-the-user"; // untranslated
    Blockly.Msg["TEXT_PROMPT_TOOLTIP_NUMBER"] = "\u30E6\u30FC\u30B6\u30FC\u306B\u6570\u5024\u306E\u30A4\u30F3\u30D7\u30C3\u30C8\u3092\u6C42\u3081\u308B\u3002";
    Blockly.Msg["TEXT_PROMPT_TOOLTIP_TEXT"] = "\u30E6\u30FC\u30B6\u30FC\u306B\u30C6\u30AD\u30B9\u30C8\u5165\u529B\u3092\u6C42\u3081\u308B\u3002";
    Blockly.Msg["TEXT_PROMPT_TYPE_NUMBER"] = "\u30E1\u30C3\u30BB\u30FC\u30B8\u3067\u756A\u53F7\u306E\u5165\u529B\u3092\u6C42\u3081\u308B";
    Blockly.Msg["TEXT_PROMPT_TYPE_TEXT"] = "\u30E1\u30C3\u30BB\u30FC\u30B8\u3067\u30C6\u30AD\u30B9\u30C8\u5165\u529B\u3092\u6C42\u3081\u308B";
    Blockly.Msg["TEXT_REPLACE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#replacing-substrings"; // untranslated
    Blockly.Msg["TEXT_REPLACE_MESSAGE0"] = "%3\u306B\u542B\u307E\u308C\u308B%1\u3092%2\u306B\u7F6E\u63DB";
    Blockly.Msg["TEXT_REPLACE_TOOLTIP"] = "\u6587\u306B\u542B\u307E\u308C\u308B\u30AD\u30FC\u30EF\u30FC\u30C9\u3092\u7F6E\u63DB\u3059\u308B\u3002";
    Blockly.Msg["TEXT_REVERSE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#reversing-text"; // untranslated
    Blockly.Msg["TEXT_REVERSE_MESSAGE0"] = "%1\u3092\u9006\u9806\u306B";
    Blockly.Msg["TEXT_REVERSE_TOOLTIP"] = "\u6587\u306E\u6587\u5B57\u3092\u9006\u9806\u306B\u3059\u308B\u3002";
    Blockly.Msg["TEXT_TEXT_HELPURL"] = "https://ja.wikipedia.org/wiki/\u6587\u5B57\u5217";
    Blockly.Msg["TEXT_TEXT_TOOLTIP"] = "\u6587\u5B57\u3001\u5358\u8A9E\u3001\u307E\u305F\u306F\u884C\u306E\u30C6\u30AD\u30B9\u30C8\u3002";
    Blockly.Msg["TEXT_TRIM_HELPURL"] = "https://github.com/google/blockly/wiki/Text#trimming-removing-spaces"; // untranslated
    Blockly.Msg["TEXT_TRIM_OPERATOR_BOTH"] = "\u4E21\u7AEF\u306E\u30B9\u30DA\u30FC\u30B9\u3092\u53D6\u308A\u9664\u304F";
    Blockly.Msg["TEXT_TRIM_OPERATOR_LEFT"] = "\u5DE6\u7AEF\u306E\u30B9\u30DA\u30FC\u30B9\u3092\u53D6\u308A\u9664\u304F";
    Blockly.Msg["TEXT_TRIM_OPERATOR_RIGHT"] = "\u53F3\u7AEF\u306E\u30B9\u30DA\u30FC\u30B9\u3092\u53D6\u308A\u9664\u304F";
    Blockly.Msg["TEXT_TRIM_TOOLTIP"] = "\u30B9\u30DA\u30FC\u30B9\u3092 1 \u3064\u307E\u305F\u306F\u4E21\u65B9\u306E\u7AEF\u304B\u3089\u524A\u9664\u3057\u305F\u306E\u3061\u3001\u30C6\u30AD\u30B9\u30C8\u306E\u30B3\u30D4\u30FC\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["TODAY"] = "\u4ECA\u65E5";
    Blockly.Msg["UNDO"] = "\u53D6\u308A\u6D88\u3059";
    Blockly.Msg["UNNAMED_KEY"] = "\u540D\u524D\u306A\u3057";
    Blockly.Msg["VARIABLES_DEFAULT_NAME"] = "\u9805\u76EE";
    Blockly.Msg["VARIABLES_GET_CREATE_SET"] = "'\u30BB\u30C3\u30C8%1\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002";
    Blockly.Msg["VARIABLES_GET_HELPURL"] = "https://github.com/google/blockly/wiki/Variables#get"; // untranslated
    Blockly.Msg["VARIABLES_GET_TOOLTIP"] = "\u3053\u306E\u5909\u6570\u306E\u5024\u3092\u8FD4\u3057\u307E\u3059\u3002";
    Blockly.Msg["VARIABLES_SET"] = "%1 \u306B %2 \u3092\u30BB\u30C3\u30C8";
    Blockly.Msg["VARIABLES_SET_CREATE_GET"] = "'%1 \u3092\u53D6\u5F97' \u3092\u4F5C\u6210\u3057\u307E\u3059\u3002";
    Blockly.Msg["VARIABLES_SET_HELPURL"] = "https://github.com/google/blockly/wiki/Variables#set"; // untranslated
    Blockly.Msg["VARIABLES_SET_TOOLTIP"] = "\u3053\u306E\u5165\u529B\u3092\u5909\u6570\u3068\u7B49\u3057\u304F\u306A\u308B\u3088\u3046\u306B\u8A2D\u5B9A\u3057\u307E\u3059\u3002";
    Blockly.Msg["VARIABLE_ALREADY_EXISTS"] = "\u5909\u6570\u540D '%1' \u306F\u65E2\u306B\u5B58\u5728\u3057\u3066\u3044\u307E\u3059\u3002";
    Blockly.Msg["VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE"] = "'%2' \u578B\u306E '%1' \u3068\u3044\u3046\u540D\u524D\u306E\u5909\u6570\u304C\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059\u3002";
    Blockly.Msg["WORKSPACE_ARIA_LABEL"] = "Blockly\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9";
    Blockly.Msg["WORKSPACE_COMMENT_DEFAULT_TEXT"] = "\u3053\u3053\u3078\u5165\u529B";
    Blockly.Msg["CONTROLS_FOREACH_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
    Blockly.Msg["CONTROLS_FOR_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
    Blockly.Msg["CONTROLS_IF_ELSEIF_TITLE_ELSEIF"] = Blockly.Msg["CONTROLS_IF_MSG_ELSEIF"];
    Blockly.Msg["CONTROLS_IF_ELSE_TITLE_ELSE"] = Blockly.Msg["CONTROLS_IF_MSG_ELSE"];
    Blockly.Msg["CONTROLS_IF_IF_TITLE_IF"] = Blockly.Msg["CONTROLS_IF_MSG_IF"];
    Blockly.Msg["CONTROLS_IF_MSG_THEN"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
    Blockly.Msg["CONTROLS_WHILEUNTIL_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
    Blockly.Msg["LISTS_CREATE_WITH_ITEM_TITLE"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
    Blockly.Msg["LISTS_GET_INDEX_HELPURL"] = Blockly.Msg["LISTS_INDEX_OF_HELPURL"];
    Blockly.Msg["LISTS_GET_INDEX_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
    Blockly.Msg["LISTS_GET_SUBLIST_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
    Blockly.Msg["LISTS_INDEX_OF_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
    Blockly.Msg["LISTS_SET_INDEX_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
    Blockly.Msg["MATH_CHANGE_TITLE_ITEM"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
    Blockly.Msg["PROCEDURES_DEFRETURN_COMMENT"] = Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"];
    Blockly.Msg["PROCEDURES_DEFRETURN_DO"] = Blockly.Msg["PROCEDURES_DEFNORETURN_DO"];
    Blockly.Msg["PROCEDURES_DEFRETURN_PROCEDURE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"];
    Blockly.Msg["PROCEDURES_DEFRETURN_TITLE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"];
    Blockly.Msg["TEXT_APPEND_VARIABLE"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
    Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TITLE_ITEM"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
    Blockly.Msg["MATH_HUE"] = "230";
    Blockly.Msg["LOOPS_HUE"] = "120";
    Blockly.Msg["LISTS_HUE"] = "260";
    Blockly.Msg["LOGIC_HUE"] = "210";
    Blockly.Msg["VARIABLES_HUE"] = "330";
    Blockly.Msg["TEXTS_HUE"] = "160";
    Blockly.Msg["PROCEDURES_HUE"] = "290";
    Blockly.Msg["COLOUR_HUE"] = "20";
    Blockly.Msg["VARIABLES_DYNAMIC_HUE"] = "310";
    return Blockly.Msg;
});


const $4dac3bd746fe0f69$export$d274976115d95baf = (0, $1FOTS.javascriptGenerator);
const $4dac3bd746fe0f69$export$c8c2787436d1a72f = "beforeStatement";
$4dac3bd746fe0f69$export$d274976115d95baf.STATEMENT_PREFIX = `typeof ${$4dac3bd746fe0f69$export$c8c2787436d1a72f} === "function" && ${$4dac3bd746fe0f69$export$c8c2787436d1a72f}(%1);\n`;
$4dac3bd746fe0f69$export$d274976115d95baf.addReservedWords($4dac3bd746fe0f69$export$c8c2787436d1a72f);
function $4dac3bd746fe0f69$var$initBlockly() {
    (0, (/*@__PURE__*/$parcel$interopDefault($ecab2ad3ed5a93ad$exports))).setLocale((0, (/*@__PURE__*/$parcel$interopDefault($e3ecb3c4189731c8$exports))));
    // https://developers.google.com/blockly/guides/create-custom-blocks/block-colour#defining_the_block_colour
    Object.assign((0, (/*@__PURE__*/$parcel$interopDefault($ecab2ad3ed5a93ad$exports))), {
        HSV_SATURATION: 0.6,
        HSV_VALUE: 1
    });
}
$4dac3bd746fe0f69$var$initBlockly();




const $b480c861dade9b3d$export$ad3fb0f57a50679b = "math_number";
const $b480c861dade9b3d$export$c6c6f4d7d7ed2c79 = "math_arithmetic";
const $b480c861dade9b3d$export$3ac91e9d3c3696d4 = "logic_compare";
const $b480c861dade9b3d$export$6ca0e2a878895d7f = "logic_operation";
const $b480c861dade9b3d$export$799c625a065df40e = "logic_negate";
const $b480c861dade9b3d$export$ec69332b69b50348 = "EXPRESSION";
const $b480c861dade9b3d$export$410d803c700b23dd = "TRUE_STATEMENTS";
const $b480c861dade9b3d$export$419726fce36c61c2 = "FALSE_STATEMENTS";
const $b480c861dade9b3d$export$c8ff9eb81b1b85ff = "STATEMENTS";
const $b480c861dade9b3d$export$5ed6ef3067e4d0c1 = "custom_common_if";
(0, (/*@__PURE__*/$parcel$interopDefault($ecab2ad3ed5a93ad$exports))).Blocks[$b480c861dade9b3d$export$5ed6ef3067e4d0c1] = {
    init () {
        this.appendDummyInput().appendField("\u3082\u3057");
        this.appendValueInput($b480c861dade9b3d$export$ec69332b69b50348).setCheck("Boolean");
        this.appendDummyInput().appendField("\u306A\u3089\u3070");
        this.appendStatementInput($b480c861dade9b3d$export$410d803c700b23dd).setCheck(null);
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(210);
        this.setTooltip("\u6761\u4EF6\u304C\u6E80\u305F\u3055\u308C\u305F\u5834\u5408\u306E\u307F\u3001\u5185\u90E8\u306E\u6587\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002");
    }
};
(0, $4dac3bd746fe0f69$export$d274976115d95baf)[$b480c861dade9b3d$export$5ed6ef3067e4d0c1] = (block)=>{
    const expression = (0, $4dac3bd746fe0f69$export$d274976115d95baf).valueToCode(block, $b480c861dade9b3d$export$ec69332b69b50348, 0) || "false";
    const trueStatements = (0, $4dac3bd746fe0f69$export$d274976115d95baf).statementToCode(block, $b480c861dade9b3d$export$410d803c700b23dd);
    return `if(${expression}){${trueStatements}}`;
};
const $b480c861dade9b3d$export$2559b0f93d9e1295 = "custom_common_if_else";
(0, (/*@__PURE__*/$parcel$interopDefault($ecab2ad3ed5a93ad$exports))).Blocks[$b480c861dade9b3d$export$2559b0f93d9e1295] = {
    init () {
        this.appendDummyInput().appendField("\u3082\u3057");
        this.appendValueInput($b480c861dade9b3d$export$ec69332b69b50348).setCheck(null);
        this.appendDummyInput().appendField("\u306A\u3089\u3070");
        this.appendStatementInput($b480c861dade9b3d$export$410d803c700b23dd).setCheck(null);
        this.appendDummyInput().appendField("\u9055\u3048\u3070");
        this.appendStatementInput($b480c861dade9b3d$export$419726fce36c61c2).setCheck(null);
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(210);
        this.setTooltip("\u6761\u4EF6\u304C\u6E80\u305F\u3055\u308C\u305F\u5834\u5408\u306F1\u756A\u76EE\u306E\u6587\u3092\u3001\u6E80\u305F\u3055\u308C\u306A\u3044\u5834\u5408\u306F2\u756A\u76EE\u306E\u6587\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002");
    }
};
(0, $4dac3bd746fe0f69$export$d274976115d95baf)[$b480c861dade9b3d$export$2559b0f93d9e1295] = (block)=>{
    const expression = (0, $4dac3bd746fe0f69$export$d274976115d95baf).valueToCode(block, $b480c861dade9b3d$export$ec69332b69b50348, 0) || "false";
    const trueStatements = (0, $4dac3bd746fe0f69$export$d274976115d95baf).statementToCode(block, $b480c861dade9b3d$export$410d803c700b23dd);
    const falseStatements = (0, $4dac3bd746fe0f69$export$d274976115d95baf).statementToCode(block, $b480c861dade9b3d$export$419726fce36c61c2);
    return `if(${expression}){${trueStatements}}else{${falseStatements}}`;
};
const $b480c861dade9b3d$export$363e4bccfe48d30a = "custom_while_true";
(0, (/*@__PURE__*/$parcel$interopDefault($ecab2ad3ed5a93ad$exports))).Blocks[$b480c861dade9b3d$export$363e4bccfe48d30a] = {
    init () {
        this.appendDummyInput().appendField("\u305A\u3063\u3068");
        this.appendStatementInput($b480c861dade9b3d$export$c8ff9eb81b1b85ff).setCheck(null);
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(120);
        this.setTooltip("\u6587\u3092\u7E70\u308A\u8FD4\u3057\u5B9F\u884C\u3057\u307E\u3059\u3002");
    }
};
(0, $4dac3bd746fe0f69$export$d274976115d95baf)[$b480c861dade9b3d$export$363e4bccfe48d30a] = (block)=>{
    const statements = (0, $4dac3bd746fe0f69$export$d274976115d95baf).statementToCode(block, $b480c861dade9b3d$export$c8ff9eb81b1b85ff);
    return `while(true){${statements}}`;
};
const $b480c861dade9b3d$export$815f12e287fce685 = "custom_while";
(0, (/*@__PURE__*/$parcel$interopDefault($ecab2ad3ed5a93ad$exports))).Blocks[$b480c861dade9b3d$export$815f12e287fce685] = {
    init () {
        this.appendValueInput($b480c861dade9b3d$export$ec69332b69b50348).setCheck("Boolean");
        this.appendDummyInput().appendField("\u306E\u9593\u305A\u3063\u3068");
        this.appendStatementInput($b480c861dade9b3d$export$c8ff9eb81b1b85ff).setCheck(null);
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(120);
        this.setTooltip("\u6761\u4EF6\u304C\u6E80\u305F\u3055\u308C\u3066\u3044\u308B\u9593\u3001\u6587\u3092\u7E70\u308A\u8FD4\u3057\u5B9F\u884C\u3057\u307E\u3059\u3002");
    }
};
(0, $4dac3bd746fe0f69$export$d274976115d95baf)[$b480c861dade9b3d$export$815f12e287fce685] = (block)=>{
    const expression = (0, $4dac3bd746fe0f69$export$d274976115d95baf).valueToCode(block, $b480c861dade9b3d$export$ec69332b69b50348, 0) || "false";
    const statements = (0, $4dac3bd746fe0f69$export$d274976115d95baf).statementToCode(block, $b480c861dade9b3d$export$c8ff9eb81b1b85ff);
    return `while(${expression}){${statements}}`;
};
const $b480c861dade9b3d$export$ca676e339c3b41b5 = "custom_do_until";
(0, (/*@__PURE__*/$parcel$interopDefault($ecab2ad3ed5a93ad$exports))).Blocks[$b480c861dade9b3d$export$ca676e339c3b41b5] = {
    init () {
        this.appendValueInput($b480c861dade9b3d$export$ec69332b69b50348).setCheck("Boolean");
        this.appendDummyInput().appendField("\u306B\u306A\u308B\u307E\u3067\u305A\u3063\u3068");
        this.appendStatementInput($b480c861dade9b3d$export$c8ff9eb81b1b85ff).setCheck(null);
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(120);
        this.setTooltip("\u6761\u4EF6\u304C\u6E80\u305F\u3055\u308C\u308B\u307E\u3067\u3001\u6587\u3092\u7E70\u308A\u8FD4\u3057\u5B9F\u884C\u3057\u307E\u3059\u3002");
    }
};
(0, $4dac3bd746fe0f69$export$d274976115d95baf)[$b480c861dade9b3d$export$ca676e339c3b41b5] = (block)=>{
    const expression = (0, $4dac3bd746fe0f69$export$d274976115d95baf).valueToCode(block, $b480c861dade9b3d$export$ec69332b69b50348, 0) || "false";
    const statements = (0, $4dac3bd746fe0f69$export$d274976115d95baf).statementToCode(block, $b480c861dade9b3d$export$c8ff9eb81b1b85ff);
    return `while(!(${expression})){${statements}}`;
};
const $b480c861dade9b3d$export$bf7c57ad29736406 = "custom_times";
(0, (/*@__PURE__*/$parcel$interopDefault($ecab2ad3ed5a93ad$exports))).Blocks[$b480c861dade9b3d$export$bf7c57ad29736406] = {
    init () {
        this.appendValueInput($b480c861dade9b3d$export$ec69332b69b50348).setCheck("Number");
        this.appendDummyInput().appendField("\u56DE\u7E70\u308A\u8FD4\u3059");
        this.appendStatementInput($b480c861dade9b3d$export$c8ff9eb81b1b85ff).setCheck(null);
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(120);
        this.setTooltip("\u6307\u5B9A\u3055\u308C\u305F\u56DE\u6570\u3001\u6587\u3092\u7E70\u308A\u8FD4\u3057\u5B9F\u884C\u3057\u307E\u3059\u3002");
    }
};
let $b480c861dade9b3d$var$tempVariableIndex = 0;
(0, $4dac3bd746fe0f69$export$d274976115d95baf)[$b480c861dade9b3d$export$bf7c57ad29736406] = (block)=>{
    const tempVariableName = `blocklyTempVariable${$b480c861dade9b3d$export$bf7c57ad29736406}${$b480c861dade9b3d$var$tempVariableIndex}`;
    $b480c861dade9b3d$var$tempVariableIndex += 1;
    const expression = (0, $4dac3bd746fe0f69$export$d274976115d95baf).valueToCode(block, $b480c861dade9b3d$export$ec69332b69b50348, 0) || "0";
    const statements = (0, $4dac3bd746fe0f69$export$d274976115d95baf).statementToCode(block, $b480c861dade9b3d$export$c8ff9eb81b1b85ff);
    return `for (var ${tempVariableName} = 0; ${tempVariableName} < (${expression}); ${tempVariableName}++) {${statements}}`;
};



function $44426ff073d2f442$export$477202748c7242bf(name, map = {}) {
    let called = false;
    function assert() {
        if (!called) {
            called = true;
            return;
        }
        throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
    }
    function parts(...values) {
        assert();
        for (const part of values)map[part] = toPart(part);
        return $44426ff073d2f442$export$477202748c7242bf(name, map);
    }
    function extend(...parts2) {
        for (const part of parts2){
            if (part in map) continue;
            map[part] = toPart(part);
        }
        return $44426ff073d2f442$export$477202748c7242bf(name, map);
    }
    function selectors() {
        const value = Object.fromEntries(Object.entries(map).map(([key, part])=>[
                key,
                part.selector
            ]));
        return value;
    }
    function classnames() {
        const value = Object.fromEntries(Object.entries(map).map(([key, part])=>[
                key,
                part.className
            ]));
        return value;
    }
    function toPart(part) {
        const el = [
            "container",
            "root"
        ].includes(part ?? "") ? [
            name
        ] : [
            name,
            part
        ];
        const attr = el.filter(Boolean).join("__");
        const className = `chakra-${attr}`;
        const partObj = {
            className: className,
            selector: `.${className}`,
            toString: ()=>part
        };
        return partObj;
    }
    const __type = {};
    return {
        parts: parts,
        toPart: toPart,
        extend: extend,
        selectors: selectors,
        classnames: classnames,
        get keys () {
            return Object.keys(map);
        },
        __type: __type
    };
}


const $73a5ef2a56a2154e$export$377a77e99e7c73a5 = (0, $44426ff073d2f442$export$477202748c7242bf)("accordion").parts("root", "container", "button", "panel", "icon");
const $73a5ef2a56a2154e$export$fc51889fa4de265a = (0, $44426ff073d2f442$export$477202748c7242bf)("alert").parts("title", "description", "container", "icon", "spinner");
const $73a5ef2a56a2154e$export$60f8655d889e17c7 = (0, $44426ff073d2f442$export$477202748c7242bf)("avatar").parts("label", "badge", "container", "excessLabel", "group");
const $73a5ef2a56a2154e$export$2fb03f744a6ecf93 = (0, $44426ff073d2f442$export$477202748c7242bf)("breadcrumb").parts("link", "item", "container", "separator");
const $73a5ef2a56a2154e$export$1699c5cb20c07888 = (0, $44426ff073d2f442$export$477202748c7242bf)("button").parts();
const $73a5ef2a56a2154e$export$21946b04497ed6ac = (0, $44426ff073d2f442$export$477202748c7242bf)("checkbox").parts("control", "icon", "container", "label");
const $73a5ef2a56a2154e$export$2c953111278f3272 = (0, $44426ff073d2f442$export$477202748c7242bf)("progress").parts("track", "filledTrack", "label");
const $73a5ef2a56a2154e$export$d3f4aaa4b0f2907a = (0, $44426ff073d2f442$export$477202748c7242bf)("drawer").parts("overlay", "dialogContainer", "dialog", "header", "closeButton", "body", "footer");
const $73a5ef2a56a2154e$export$2813c9511eeab082 = (0, $44426ff073d2f442$export$477202748c7242bf)("editable").parts("preview", "input", "textarea");
const $73a5ef2a56a2154e$export$4b243e3f209a7e5e = (0, $44426ff073d2f442$export$477202748c7242bf)("form").parts("container", "requiredIndicator", "helperText");
const $73a5ef2a56a2154e$export$bb18c440c00e82d9 = (0, $44426ff073d2f442$export$477202748c7242bf)("formError").parts("text", "icon");
const $73a5ef2a56a2154e$export$1ffeb100b532f46d = (0, $44426ff073d2f442$export$477202748c7242bf)("input").parts("addon", "field", "element", "group");
const $73a5ef2a56a2154e$export$12b3a655a94374ed = (0, $44426ff073d2f442$export$477202748c7242bf)("list").parts("container", "item", "icon");
const $73a5ef2a56a2154e$export$e251092a5dcb1329 = (0, $44426ff073d2f442$export$477202748c7242bf)("menu").parts("button", "list", "item", "groupTitle", "icon", "command", "divider");
const $73a5ef2a56a2154e$export$34e33beb8d992ac2 = (0, $44426ff073d2f442$export$477202748c7242bf)("modal").parts("overlay", "dialogContainer", "dialog", "header", "closeButton", "body", "footer");
const $73a5ef2a56a2154e$export$859cc7ca3200df97 = (0, $44426ff073d2f442$export$477202748c7242bf)("numberinput").parts("root", "field", "stepperGroup", "stepper");
const $73a5ef2a56a2154e$export$12bb869d7991ac50 = (0, $44426ff073d2f442$export$477202748c7242bf)("pininput").parts("field");
const $73a5ef2a56a2154e$export$afda07d12cd4337d = (0, $44426ff073d2f442$export$477202748c7242bf)("popover").parts("content", "header", "body", "footer", "popper", "arrow", "closeButton");
const $73a5ef2a56a2154e$export$ba6328c242bd649c = (0, $44426ff073d2f442$export$477202748c7242bf)("progress").parts("label", "filledTrack", "track");
const $73a5ef2a56a2154e$export$d28d06d0e29ef022 = (0, $44426ff073d2f442$export$477202748c7242bf)("radio").parts("container", "control", "label");
const $73a5ef2a56a2154e$export$17993f0be9538b5a = (0, $44426ff073d2f442$export$477202748c7242bf)("select").parts("field", "icon");
const $73a5ef2a56a2154e$export$c21b4b3f8b239f32 = (0, $44426ff073d2f442$export$477202748c7242bf)("slider").parts("container", "track", "thumb", "filledTrack", "mark");
const $73a5ef2a56a2154e$export$2cfbad67ae6ee421 = (0, $44426ff073d2f442$export$477202748c7242bf)("stat").parts("container", "label", "helpText", "number", "icon");
const $73a5ef2a56a2154e$export$921c1a2d1ce1e86a = (0, $44426ff073d2f442$export$477202748c7242bf)("switch").parts("container", "track", "thumb", "label");
const $73a5ef2a56a2154e$export$8b1b9cdd5db9f5fd = (0, $44426ff073d2f442$export$477202748c7242bf)("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption");
const $73a5ef2a56a2154e$export$97383552563be58d = (0, $44426ff073d2f442$export$477202748c7242bf)("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator");
const $73a5ef2a56a2154e$export$4c2f5f7f2ea94a8e = (0, $44426ff073d2f442$export$477202748c7242bf)("tag").parts("container", "label", "closeButton");
const $73a5ef2a56a2154e$export$487a447ffa5755b6 = (0, $44426ff073d2f442$export$477202748c7242bf)("card").parts("container", "header", "body", "footer");
const $73a5ef2a56a2154e$export$76976ae72ac68c27 = (0, $44426ff073d2f442$export$477202748c7242bf)("stepper").parts("stepper", "step", "title", "description", "indicator", "separator", "icon", "number");


function $72fdfa583ecf837c$export$9a6b93c1c4f92839(styles) {
    return styles;
}
function $72fdfa583ecf837c$export$5c9a64458a4ed8a4(config) {
    return config;
}
function $72fdfa583ecf837c$export$d5f717dc145477b8(parts) {
    return {
        definePartsStyle (config) {
            return config;
        },
        defineMultiStyleConfig (config) {
            return {
                parts: parts,
                ...config
            };
        }
    };
}


const { definePartsStyle: $4f3acc954068efea$var$definePartsStyle, defineMultiStyleConfig: $4f3acc954068efea$var$defineMultiStyleConfig } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$377a77e99e7c73a5).keys);
const $4f3acc954068efea$var$baseStyleContainer = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    borderTopWidth: "1px",
    borderColor: "inherit",
    _last: {
        borderBottomWidth: "1px"
    }
});
const $4f3acc954068efea$var$baseStyleButton = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "normal",
    fontSize: "md",
    _focusVisible: {
        boxShadow: "outline"
    },
    _hover: {
        bg: "blackAlpha.50"
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    },
    px: "4",
    py: "2"
});
const $4f3acc954068efea$var$baseStylePanel = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    pt: "2",
    px: "4",
    pb: "5"
});
const $4f3acc954068efea$var$baseStyleIcon = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    fontSize: "1.25em"
});
const $4f3acc954068efea$var$baseStyle = $4f3acc954068efea$var$definePartsStyle({
    container: $4f3acc954068efea$var$baseStyleContainer,
    button: $4f3acc954068efea$var$baseStyleButton,
    panel: $4f3acc954068efea$var$baseStylePanel,
    icon: $4f3acc954068efea$var$baseStyleIcon
});
const $4f3acc954068efea$export$20ec2254f76fa604 = $4f3acc954068efea$var$defineMultiStyleConfig({
    baseStyle: $4f3acc954068efea$var$baseStyle
});



function $baa260bb5827f910$var$replaceWhiteSpace(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
}
function $baa260bb5827f910$var$escape(value) {
    const valueStr = $baa260bb5827f910$var$replaceWhiteSpace(value.toString());
    return $baa260bb5827f910$var$escapeSymbol($baa260bb5827f910$var$escapeDot(valueStr));
}
function $baa260bb5827f910$var$escapeDot(value) {
    if (value.includes("\\.")) return value;
    const isDecimal = !Number.isInteger(parseFloat(value.toString()));
    return isDecimal ? value.replace(".", `\\.`) : value;
}
function $baa260bb5827f910$var$escapeSymbol(value) {
    return value.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function $baa260bb5827f910$export$9748efee331ec573(value, prefix = "") {
    return [
        prefix,
        value
    ].filter(Boolean).join("-");
}
function $baa260bb5827f910$export$bb435e137b4b8e38(name, fallback) {
    return `var(${name}${fallback ? `, ${fallback}` : ""})`;
}
function $baa260bb5827f910$export$3695bd65cc73dae9(value, prefix = "") {
    return $baa260bb5827f910$var$escape(`--${$baa260bb5827f910$export$9748efee331ec573(value, prefix)}`);
}
function $baa260bb5827f910$export$8b4981022bd80a4e(name, fallback, cssVarPrefix) {
    const cssVariable = $baa260bb5827f910$export$3695bd65cc73dae9(name, cssVarPrefix);
    return {
        variable: cssVariable,
        reference: $baa260bb5827f910$export$bb435e137b4b8e38(cssVariable, fallback)
    };
}
function $baa260bb5827f910$export$bd40561c6c056841(scope, keys) {
    const vars = {};
    for (const key of keys){
        if (Array.isArray(key)) {
            const [name, fallback] = key;
            vars[name] = $baa260bb5827f910$export$8b4981022bd80a4e(`${scope}-${name}`, fallback);
            continue;
        }
        vars[key] = $baa260bb5827f910$export$8b4981022bd80a4e(`${scope}-${key}`);
    }
    return vars;
}


function $aef92f153ae08b35$export$93c8e06b7014dc33(theme, scale, value) {
    return theme.__cssMap?.[`${scale}.${value}`]?.varRef ?? value;
}


/**
 * A simple guard function:
 *
 * ```js
 * Math.min(Math.max(low, value), high)
 * ```
 */ function $82bd23a4eacb9716$export$864d727b48066337(low, high, value) {
    return Math.min(Math.max(low, value), high);
}
class $82bd23a4eacb9716$var$ColorError extends Error {
    constructor(color){
        super(`Failed to parse color: "${color}"`);
    }
}
var $82bd23a4eacb9716$export$21f8cadbc4af9bbf = $82bd23a4eacb9716$var$ColorError;
/**
 * Parses a color into red, gree, blue, alpha parts
 *
 * @param color the input color. Can be a RGB, RBGA, HSL, HSLA, or named color
 */ function $82bd23a4eacb9716$export$88c26fe48243d749(color) {
    if (typeof color !== "string") throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
    if (color.trim().toLowerCase() === "transparent") return [
        0,
        0,
        0,
        0
    ];
    let normalizedColor = color.trim();
    normalizedColor = $82bd23a4eacb9716$var$namedColorRegex.test(color) ? $82bd23a4eacb9716$var$nameToHex(color) : color;
    const reducedHexMatch = $82bd23a4eacb9716$var$reducedHexRegex.exec(normalizedColor);
    if (reducedHexMatch) {
        const arr = Array.from(reducedHexMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt($82bd23a4eacb9716$var$r(x, 2), 16)),
            parseInt($82bd23a4eacb9716$var$r(arr[3] || "f", 2), 16) / 255
        ];
    }
    const hexMatch = $82bd23a4eacb9716$var$hexRegex.exec(normalizedColor);
    if (hexMatch) {
        const arr = Array.from(hexMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt(x, 16)),
            parseInt(arr[3] || "ff", 16) / 255
        ];
    }
    const rgbaMatch = $82bd23a4eacb9716$var$rgbaRegex.exec(normalizedColor);
    if (rgbaMatch) {
        const arr = Array.from(rgbaMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt(x, 10)),
            parseFloat(arr[3] || "1")
        ];
    }
    const hslaMatch = $82bd23a4eacb9716$var$hslaRegex.exec(normalizedColor);
    if (hslaMatch) {
        const [h, s, l, a] = Array.from(hslaMatch).slice(1).map(parseFloat);
        if ($82bd23a4eacb9716$export$864d727b48066337(0, 100, s) !== s) throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
        if ($82bd23a4eacb9716$export$864d727b48066337(0, 100, l) !== l) throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
        return [
            ...$82bd23a4eacb9716$var$hslToRgb(h, s, l),
            Number.isNaN(a) ? 1 : a
        ];
    }
    throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
}
function $82bd23a4eacb9716$var$hash(str) {
    let hash = 5381;
    let i = str.length;
    while(i)hash = hash * 33 ^ str.charCodeAt(--i);
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return (hash >>> 0) % 2341;
}
const $82bd23a4eacb9716$var$colorToInt = (x)=>parseInt(x.replace(/_/g, ""), 36);
const $82bd23a4eacb9716$var$compressedColorMap = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((acc, next)=>{
    const key = $82bd23a4eacb9716$var$colorToInt(next.substring(0, 3));
    const hex = $82bd23a4eacb9716$var$colorToInt(next.substring(3)).toString(16);
    // NOTE: padStart could be used here but it breaks Node 6 compat
    // https://github.com/ricokahler/color2k/issues/351
    let prefix = "";
    for(let i = 0; i < 6 - hex.length; i++)prefix += "0";
    acc[key] = `${prefix}${hex}`;
    return acc;
}, {});
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 */ function $82bd23a4eacb9716$var$nameToHex(color) {
    const normalizedColorName = color.toLowerCase().trim();
    const result = $82bd23a4eacb9716$var$compressedColorMap[$82bd23a4eacb9716$var$hash(normalizedColorName)];
    if (!result) throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
    return `#${result}`;
}
const $82bd23a4eacb9716$var$r = (str, amount)=>Array.from(Array(amount)).map(()=>str).join("");
const $82bd23a4eacb9716$var$reducedHexRegex = new RegExp(`^#${$82bd23a4eacb9716$var$r("([a-f0-9])", 3)}([a-f0-9])?$`, "i");
const $82bd23a4eacb9716$var$hexRegex = new RegExp(`^#${$82bd23a4eacb9716$var$r("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i");
const $82bd23a4eacb9716$var$rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${$82bd23a4eacb9716$var$r(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i");
const $82bd23a4eacb9716$var$hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i;
const $82bd23a4eacb9716$var$namedColorRegex = /^[a-z]+$/i;
const $82bd23a4eacb9716$var$roundColor = (color)=>{
    return Math.round(color * 255);
};
const $82bd23a4eacb9716$var$hslToRgb = (hue, saturation, lightness)=>{
    let l = lightness / 100;
    if (saturation === 0) // achromatic
    return [
        l,
        l,
        l
    ].map($82bd23a4eacb9716$var$roundColor);
    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    const huePrime = (hue % 360 + 360) % 360 / 60;
    const chroma = (1 - Math.abs(2 * l - 1)) * (saturation / 100);
    const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    let red = 0;
    let green = 0;
    let blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    const lightnessModification = l - chroma / 2;
    const finalRed = red + lightnessModification;
    const finalGreen = green + lightnessModification;
    const finalBlue = blue + lightnessModification;
    return [
        finalRed,
        finalGreen,
        finalBlue
    ].map($82bd23a4eacb9716$var$roundColor);
};
// taken from:
/**
 * Parses a color in hue, saturation, lightness, and the alpha channel.
 *
 * Hue is a number between 0 and 360, saturation, lightness, and alpha are
 * decimal percentages between 0 and 1
 */ function $82bd23a4eacb9716$export$c7d9b10ca8edee87(color) {
    const [red, green, blue, alpha] = $82bd23a4eacb9716$export$88c26fe48243d749(color).map((value, index)=>// 3rd index is alpha channel which is already normalized
        index === 3 ? value : value / 255);
    const max = Math.max(red, green, blue);
    const min = Math.min(red, green, blue);
    const lightness = (max + min) / 2;
    // achromatic
    if (max === min) return [
        0,
        0,
        lightness,
        alpha
    ];
    const delta = max - min;
    const saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    const hue = 60 * (red === max ? (green - blue) / delta + (green < blue ? 6 : 0) : green === max ? (blue - red) / delta + 2 : (red - green) / delta + 4);
    return [
        hue,
        saturation,
        lightness,
        alpha
    ];
}
/**
 * Takes in hsla parts and constructs an hsla string
 *
 * @param hue The color circle (from 0 to 360) - 0 (or 360) is red, 120 is green, 240 is blue
 * @param saturation Percentage of saturation, given as a decimal between 0 and 1
 * @param lightness Percentage of lightness, given as a decimal between 0 and 1
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$810b04175080204c(hue, saturation, lightness, alpha) {
    return `hsla(${(hue % 360).toFixed()}, ${$82bd23a4eacb9716$export$864d727b48066337(0, 100, saturation * 100).toFixed()}%, ${$82bd23a4eacb9716$export$864d727b48066337(0, 100, lightness * 100).toFixed()}%, ${parseFloat($82bd23a4eacb9716$export$864d727b48066337(0, 1, alpha).toFixed(3))})`;
}
/**
 * Adjusts the current hue of the color by the given degrees. Wraps around when
 * over 360.
 *
 * @param color input color
 * @param degrees degrees to adjust the input color, accepts degree integers
 * (0 - 360) and wraps around on overflow
 */ function $82bd23a4eacb9716$export$2b372a09365374d6(color, degrees) {
    const [h, s, l, a] = $82bd23a4eacb9716$export$c7d9b10ca8edee87(color);
    return $82bd23a4eacb9716$export$810b04175080204c(h + degrees, s, l, a);
}
/**
 * Darkens using lightness. This is equivalent to subtracting the lightness
 * from the L in HSL.
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$4b073707ff63303(color, amount) {
    const [hue, saturation, lightness, alpha] = $82bd23a4eacb9716$export$c7d9b10ca8edee87(color);
    return $82bd23a4eacb9716$export$810b04175080204c(hue, saturation, lightness - amount, alpha);
}
/**
 * Desaturates the input color by the given amount via subtracting from the `s`
 * in `hsla`.
 *
 * @param amount The amount to desaturate, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$fb75607d98509d9(color, amount) {
    const [h, s, l, a] = $82bd23a4eacb9716$export$c7d9b10ca8edee87(color);
    return $82bd23a4eacb9716$export$810b04175080204c(h, s - amount, l, a);
}
// taken from:
// https://github.com/styled-components/polished/blob/0764c982551b487469043acb56281b0358b3107b/src/color/getLuminance.js
/**
 * Returns a number (float) representing the luminance of a color.
 */ function $82bd23a4eacb9716$export$c852d90bf7403b62(color) {
    if (color === "transparent") return 0;
    function f(x) {
        const channel = x / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }
    const [r, g, b] = $82bd23a4eacb9716$export$88c26fe48243d749(color);
    return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
}
// taken from:
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 */ function $82bd23a4eacb9716$export$850ce485a60d103b(color1, color2) {
    const luminance1 = $82bd23a4eacb9716$export$c852d90bf7403b62(color1);
    const luminance2 = $82bd23a4eacb9716$export$c852d90bf7403b62(color2);
    return luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05);
}
/**
 * Takes in rgba parts and returns an rgba string
 *
 * @param red The amount of red in the red channel, given in a number between 0 and 255 inclusive
 * @param green The amount of green in the red channel, given in a number between 0 and 255 inclusive
 * @param blue The amount of blue in the red channel, given in a number between 0 and 255 inclusive
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$4e46ac54fc82cf3b(red, green, blue, alpha) {
    return `rgba(${$82bd23a4eacb9716$export$864d727b48066337(0, 255, red).toFixed()}, ${$82bd23a4eacb9716$export$864d727b48066337(0, 255, green).toFixed()}, ${$82bd23a4eacb9716$export$864d727b48066337(0, 255, blue).toFixed()}, ${parseFloat($82bd23a4eacb9716$export$864d727b48066337(0, 1, alpha).toFixed(3))})`;
}
/**
 * Mixes two colors together. Taken from sass's implementation.
 */ function $82bd23a4eacb9716$export$2c9e8a9632a706b2(color1, color2, weight) {
    const normalize = (n, index)=>// 3rd index is alpha channel which is already normalized
        index === 3 ? n : n / 255;
    const [r1, g1, b1, a1] = $82bd23a4eacb9716$export$88c26fe48243d749(color1).map(normalize);
    const [r2, g2, b2, a2] = $82bd23a4eacb9716$export$88c26fe48243d749(color2).map(normalize);
    // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    const alphaDelta = a2 - a1;
    const normalizedWeight = weight * 2 - 1;
    const combinedWeight = normalizedWeight * alphaDelta === -1 ? normalizedWeight : normalizedWeight + alphaDelta / (1 + normalizedWeight * alphaDelta);
    const weight2 = (combinedWeight + 1) / 2;
    const weight1 = 1 - weight2;
    const r = (r1 * weight1 + r2 * weight2) * 255;
    const g = (g1 * weight1 + g2 * weight2) * 255;
    const b = (b1 * weight1 + b2 * weight2) * 255;
    const a = a2 * weight + a1 * (1 - weight);
    return $82bd23a4eacb9716$export$4e46ac54fc82cf3b(r, g, b, a);
}
/**
 * Given a series colors, this function will return a `scale(x)` function that
 * accepts a percentage as a decimal between 0 and 1 and returns the color at
 * that percentage in the scale.
 *
 * ```js
 * const scale = getScale('red', 'yellow', 'green');
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(0.5)); // rgba(255, 255, 0, 1)
 * console.log(scale(1)); // rgba(0, 128, 0, 1)
 * ```
 *
 * If you'd like to limit the domain and range like chroma-js, we recommend
 * wrapping scale again.
 *
 * ```js
 * const _scale = getScale('red', 'yellow', 'green');
 * const scale = x => _scale(x / 100);
 *
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(50)); // rgba(255, 255, 0, 1)
 * console.log(scale(100)); // rgba(0, 128, 0, 1)
 * ```
 */ function $82bd23a4eacb9716$export$5cdac61cf538712e(...colors) {
    return (n)=>{
        const lastIndex = colors.length - 1;
        const lowIndex = $82bd23a4eacb9716$export$864d727b48066337(0, lastIndex, Math.floor(n * lastIndex));
        const highIndex = $82bd23a4eacb9716$export$864d727b48066337(0, lastIndex, Math.ceil(n * lastIndex));
        const color1 = colors[lowIndex];
        const color2 = colors[highIndex];
        const unit = 1 / lastIndex;
        const weight = (n - unit * lowIndex) / unit;
        return $82bd23a4eacb9716$export$2c9e8a9632a706b2(color1, color2, weight);
    };
}
const $82bd23a4eacb9716$var$guidelines = {
    decorative: 1.5,
    readable: 3,
    aa: 4.5,
    aaa: 7
};
/**
 * Returns whether or not a color has bad contrast against a background
 * according to a given standard.
 */ function $82bd23a4eacb9716$export$f4ab80233a44f806(color, standard = "aa", background = "#fff") {
    return $82bd23a4eacb9716$export$850ce485a60d103b(color, background) < $82bd23a4eacb9716$var$guidelines[standard];
}
/**
 * Lightens a color by a given amount. This is equivalent to
 * `darken(color, -amount)`
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$c0816ed86df316af(color, amount) {
    return $82bd23a4eacb9716$export$4b073707ff63303(color, -amount);
}
/**
 * Takes in a color and makes it more transparent by convert to `rgba` and
 * decreasing the amount in the alpha channel.
 *
 * @param amount The amount to increase the transparency by, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$d11da87e55cc498f(color, amount) {
    const [r, g, b, a] = $82bd23a4eacb9716$export$88c26fe48243d749(color);
    return $82bd23a4eacb9716$export$4e46ac54fc82cf3b(r, g, b, a - amount);
}
/**
 * Takes a color and un-transparentizes it. Equivalent to
 * `transparentize(color, -amount)`
 *
 * @param amount The amount to increase the opacity by, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$f4f50e3877dd0530(color, amount) {
    return $82bd23a4eacb9716$export$d11da87e55cc498f(color, -amount);
}
/**
 * An alternative function to `readableColor`. Returns whether or not the 
 * readable color (i.e. the color to be place on top the input color) should be
 * black.
 */ function $82bd23a4eacb9716$export$dcb2d24cf045d06(color) {
    return $82bd23a4eacb9716$export$c852d90bf7403b62(color) > 0.179;
}
/**
 * Returns black or white for best contrast depending on the luminosity of the
 * given color.
 */ function $82bd23a4eacb9716$export$61654c1796c44811(color) {
    return $82bd23a4eacb9716$export$dcb2d24cf045d06(color) ? "#000" : "#fff";
}
/**
 * Saturates a color by converting it to `hsl` and increasing the saturation
 * amount. Equivalent to `desaturate(color, -amount)`
 * 
 * @param color Input color
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$5fcac96f5a87e3db(color, amount) {
    return $82bd23a4eacb9716$export$fb75607d98509d9(color, -amount);
}
/**
 * Takes in any color and returns it as a hex code.
 */ function $82bd23a4eacb9716$export$7ea66e3774a60b67(color) {
    const [r, g, b, a] = $82bd23a4eacb9716$export$88c26fe48243d749(color);
    let hex = (x)=>{
        const h = $82bd23a4eacb9716$export$864d727b48066337(0, 255, x).toString(16);
        // NOTE: padStart could be used here but it breaks Node 6 compat
        // https://github.com/ricokahler/color2k/issues/351
        return h.length === 1 ? `0${h}` : h;
    };
    return `#${hex(r)}${hex(g)}${hex(b)}${a < 1 ? hex(Math.round(a * 255)) : ""}`;
}
/**
 * Takes in any color and returns it as an rgba string.
 */ function $82bd23a4eacb9716$export$5db297beaffffbfc(color) {
    return $82bd23a4eacb9716$export$4e46ac54fc82cf3b(...$82bd23a4eacb9716$export$88c26fe48243d749(color));
}
/**
 * Takes in any color and returns it as an hsla string.
 */ function $82bd23a4eacb9716$export$b9678a7d4ac803cc(color) {
    return $82bd23a4eacb9716$export$810b04175080204c(...$82bd23a4eacb9716$export$c7d9b10ca8edee87(color));
}


const $f3aed9929b079adb$var$isEmptyObject = (obj)=>Object.keys(obj).length === 0;
function $f3aed9929b079adb$var$get(obj, key, def, p, undef) {
    key = key.split ? key.split(".") : key;
    for(p = 0; p < key.length; p++)obj = obj ? obj[key[p]] : undef;
    return obj === undef ? def : obj;
}
const $f3aed9929b079adb$export$5551a2d24ff40153 = (theme, color, fallback)=>{
    const hex = $f3aed9929b079adb$var$get(theme, `colors.${color}`, color);
    try {
        (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)(hex);
        return hex;
    } catch  {
        return fallback ?? "#000000";
    }
};
const $f3aed9929b079adb$export$fdaf813cf8a11246 = (theme, color, fallback)=>{
    return (0, $aef92f153ae08b35$export$93c8e06b7014dc33)(theme, "colors", color) ?? fallback;
};
const $f3aed9929b079adb$var$getBrightness = (color)=>{
    const [r, g, b] = (0, $82bd23a4eacb9716$export$88c26fe48243d749)(color);
    return (r * 299 + g * 587 + b * 114) / 1e3;
};
const $f3aed9929b079adb$export$7297c25227171a1f = (color)=>(theme)=>{
        const hex = $f3aed9929b079adb$export$5551a2d24ff40153(theme, color);
        const brightness = $f3aed9929b079adb$var$getBrightness(hex);
        const isDark2 = brightness < 128;
        return isDark2 ? "dark" : "light";
    };
const $f3aed9929b079adb$export$a79ad82046afa44e = (color)=>(theme)=>$f3aed9929b079adb$export$7297c25227171a1f(color)(theme) === "dark";
const $f3aed9929b079adb$export$44af652f4cca9039 = (color)=>(theme)=>$f3aed9929b079adb$export$7297c25227171a1f(color)(theme) === "light";
const $f3aed9929b079adb$export$d11da87e55cc498f = (color, opacity)=>(theme)=>{
        const raw = $f3aed9929b079adb$export$5551a2d24ff40153(theme, color);
        return (0, $82bd23a4eacb9716$export$d11da87e55cc498f)(raw, 1 - opacity);
    };
const $f3aed9929b079adb$export$81525e9955aa80e8 = (color, amount)=>(theme)=>{
        const raw = $f3aed9929b079adb$export$5551a2d24ff40153(theme, color);
        return (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$2c9e8a9632a706b2)(raw, "#fff", amount));
    };
const $f3aed9929b079adb$export$2b471577c483101c = (color, amount)=>(theme)=>{
        const raw = $f3aed9929b079adb$export$5551a2d24ff40153(theme, color);
        return (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$2c9e8a9632a706b2)(raw, "#000", amount / 100));
    };
const $f3aed9929b079adb$export$4b073707ff63303 = (color, amount)=>(theme)=>{
        const raw = $f3aed9929b079adb$export$5551a2d24ff40153(theme, color);
        return (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$4b073707ff63303)(raw, amount / 100));
    };
const $f3aed9929b079adb$export$c0816ed86df316af = (color, amount)=>(theme)=>{
        const raw = $f3aed9929b079adb$export$5551a2d24ff40153(theme, color);
        (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$c0816ed86df316af)(raw, amount / 100));
    };
const $f3aed9929b079adb$export$1ec78ac20028ebd4 = (fg, bg)=>(theme)=>(0, $82bd23a4eacb9716$export$850ce485a60d103b)($f3aed9929b079adb$export$5551a2d24ff40153(theme, bg), $f3aed9929b079adb$export$5551a2d24ff40153(theme, fg));
const $f3aed9929b079adb$export$cd41ae544cfc2a65 = (textColor, bgColor, options)=>(theme)=>$f3aed9929b079adb$export$3fe5b5ca1e6a6a28($f3aed9929b079adb$export$5551a2d24ff40153(theme, bgColor), $f3aed9929b079adb$export$5551a2d24ff40153(theme, textColor), options);
function $f3aed9929b079adb$export$3fe5b5ca1e6a6a28(color1, color2, wcag2 = {
    level: "AA",
    size: "small"
}) {
    const readabilityLevel = $f3aed9929b079adb$export$b7b705aaad1c5b6a(color1, color2);
    switch((wcag2.level ?? "AA") + (wcag2.size ?? "small")){
        case "AAsmall":
        case "AAAlarge":
            return readabilityLevel >= 4.5;
        case "AAlarge":
            return readabilityLevel >= 3;
        case "AAAsmall":
            return readabilityLevel >= 7;
        default:
            return false;
    }
}
function $f3aed9929b079adb$export$b7b705aaad1c5b6a(color1, color2) {
    return (Math.max((0, $82bd23a4eacb9716$export$c852d90bf7403b62)(color1), (0, $82bd23a4eacb9716$export$c852d90bf7403b62)(color2)) + 0.05) / (Math.min((0, $82bd23a4eacb9716$export$c852d90bf7403b62)(color1), (0, $82bd23a4eacb9716$export$c852d90bf7403b62)(color2)) + 0.05);
}
const $f3aed9929b079adb$export$504efcfbebdbcaf = (color)=>(theme)=>{
        const raw = $f3aed9929b079adb$export$5551a2d24ff40153(theme, color);
        const hsl = (0, $82bd23a4eacb9716$export$c7d9b10ca8edee87)(raw);
        const complementHsl = Object.assign(hsl, [
            (hsl[0] + 180) % 360
        ]);
        return (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$810b04175080204c)(...complementHsl));
    };
function $f3aed9929b079adb$export$db0ffb03ee9f3080(size = "1rem", color = "rgba(255, 255, 255, 0.15)") {
    return {
        backgroundImage: `linear-gradient(
    45deg,
    ${color} 25%,
    transparent 25%,
    transparent 50%,
    ${color} 50%,
    ${color} 75%,
    transparent 75%,
    transparent
  )`,
        backgroundSize: `${size} ${size}`
    };
}
const $f3aed9929b079adb$var$randomHex = ()=>`#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
function $f3aed9929b079adb$export$f3c6ed4330abfc18(opts) {
    const fallback = $f3aed9929b079adb$var$randomHex();
    if (!opts || $f3aed9929b079adb$var$isEmptyObject(opts)) return fallback;
    if (opts.string && opts.colors) return $f3aed9929b079adb$var$randomColorFromList(opts.string, opts.colors);
    if (opts.string && !opts.colors) return $f3aed9929b079adb$var$randomColorFromString(opts.string);
    if (opts.colors && !opts.string) return $f3aed9929b079adb$var$randomFromList(opts.colors);
    return fallback;
}
function $f3aed9929b079adb$var$randomColorFromString(str) {
    let hash = 0;
    if (str.length === 0) return hash.toString();
    for(let i = 0; i < str.length; i += 1){
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    let color = "#";
    for(let j = 0; j < 3; j += 1){
        const value = hash >> j * 8 & 255;
        color += `00${value.toString(16)}`.substr(-2);
    }
    return color;
}
function $f3aed9929b079adb$var$randomColorFromList(str, list) {
    let index = 0;
    if (str.length === 0) return list[0];
    for(let i = 0; i < str.length; i += 1){
        index = str.charCodeAt(i) + ((index << 5) - index);
        index = index & index;
    }
    index = (index % list.length + list.length) % list.length;
    return list[index];
}
function $f3aed9929b079adb$var$randomFromList(list) {
    return list[Math.floor(Math.random() * list.length)];
}


const { definePartsStyle: $666bd9e41b46c240$var$definePartsStyle, defineMultiStyleConfig: $666bd9e41b46c240$var$defineMultiStyleConfig } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$fc51889fa4de265a).keys);
const $666bd9e41b46c240$var$$fg = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("alert-fg");
const $666bd9e41b46c240$var$$bg = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("alert-bg");
const $666bd9e41b46c240$var$baseStyle = $666bd9e41b46c240$var$definePartsStyle({
    container: {
        bg: $666bd9e41b46c240$var$$bg.reference,
        px: "4",
        py: "3"
    },
    title: {
        fontWeight: "bold",
        lineHeight: "6",
        marginEnd: "2"
    },
    description: {
        lineHeight: "6"
    },
    icon: {
        color: $666bd9e41b46c240$var$$fg.reference,
        flexShrink: 0,
        marginEnd: "3",
        w: "5",
        h: "6"
    },
    spinner: {
        color: $666bd9e41b46c240$var$$fg.reference,
        flexShrink: 0,
        marginEnd: "3",
        w: "5",
        h: "5"
    }
});
function $666bd9e41b46c240$var$getBg(props) {
    const { theme: theme, colorScheme: c } = props;
    const darkBg = (0, $f3aed9929b079adb$export$d11da87e55cc498f)(`${c}.200`, 0.16)(theme);
    return {
        light: `colors.${c}.100`,
        dark: darkBg
    };
}
const $666bd9e41b46c240$var$variantSubtle = $666bd9e41b46c240$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $666bd9e41b46c240$var$getBg(props);
    return {
        container: {
            [$666bd9e41b46c240$var$$fg.variable]: `colors.${c}.600`,
            [$666bd9e41b46c240$var$$bg.variable]: bg.light,
            _dark: {
                [$666bd9e41b46c240$var$$fg.variable]: `colors.${c}.200`,
                [$666bd9e41b46c240$var$$bg.variable]: bg.dark
            }
        }
    };
});
const $666bd9e41b46c240$var$variantLeftAccent = $666bd9e41b46c240$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $666bd9e41b46c240$var$getBg(props);
    return {
        container: {
            [$666bd9e41b46c240$var$$fg.variable]: `colors.${c}.600`,
            [$666bd9e41b46c240$var$$bg.variable]: bg.light,
            _dark: {
                [$666bd9e41b46c240$var$$fg.variable]: `colors.${c}.200`,
                [$666bd9e41b46c240$var$$bg.variable]: bg.dark
            },
            paddingStart: "3",
            borderStartWidth: "4px",
            borderStartColor: $666bd9e41b46c240$var$$fg.reference
        }
    };
});
const $666bd9e41b46c240$var$variantTopAccent = $666bd9e41b46c240$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $666bd9e41b46c240$var$getBg(props);
    return {
        container: {
            [$666bd9e41b46c240$var$$fg.variable]: `colors.${c}.600`,
            [$666bd9e41b46c240$var$$bg.variable]: bg.light,
            _dark: {
                [$666bd9e41b46c240$var$$fg.variable]: `colors.${c}.200`,
                [$666bd9e41b46c240$var$$bg.variable]: bg.dark
            },
            pt: "2",
            borderTopWidth: "4px",
            borderTopColor: $666bd9e41b46c240$var$$fg.reference
        }
    };
});
const $666bd9e41b46c240$var$variantSolid = $666bd9e41b46c240$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        container: {
            [$666bd9e41b46c240$var$$fg.variable]: `colors.white`,
            [$666bd9e41b46c240$var$$bg.variable]: `colors.${c}.600`,
            _dark: {
                [$666bd9e41b46c240$var$$fg.variable]: `colors.gray.900`,
                [$666bd9e41b46c240$var$$bg.variable]: `colors.${c}.200`
            },
            color: $666bd9e41b46c240$var$$fg.reference
        }
    };
});
const $666bd9e41b46c240$var$variants = {
    subtle: $666bd9e41b46c240$var$variantSubtle,
    "left-accent": $666bd9e41b46c240$var$variantLeftAccent,
    "top-accent": $666bd9e41b46c240$var$variantTopAccent,
    solid: $666bd9e41b46c240$var$variantSolid
};
const $666bd9e41b46c240$export$9d77d9665d829e89 = $666bd9e41b46c240$var$defineMultiStyleConfig({
    baseStyle: $666bd9e41b46c240$var$baseStyle,
    variants: $666bd9e41b46c240$var$variants,
    defaultProps: {
        variant: "subtle",
        colorScheme: "blue"
    }
});





const $db0948d028fed175$export$5458b64234d1333c = {
    px: "1px",
    0.5: "0.125rem",
    1: "0.25rem",
    1.5: "0.375rem",
    2: "0.5rem",
    2.5: "0.625rem",
    3: "0.75rem",
    3.5: "0.875rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    52: "13rem",
    56: "14rem",
    60: "15rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem"
};


const $da66fdd6a25ef817$var$largeSizes = {
    max: "max-content",
    min: "min-content",
    full: "100%",
    "3xs": "14rem",
    "2xs": "16rem",
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    xl: "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    "7xl": "80rem",
    "8xl": "90rem",
    prose: "60ch"
};
const $da66fdd6a25ef817$var$container = {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px"
};
const $da66fdd6a25ef817$export$2e2bcd8739ae039 = {
    ...(0, $db0948d028fed175$export$5458b64234d1333c),
    ...$da66fdd6a25ef817$var$largeSizes,
    container: $da66fdd6a25ef817$var$container
};


const $97561ccf56589493$var$isFunction = (value)=>typeof value === "function";
function $97561ccf56589493$export$624e501d81f5ffce(valueOrFn, ...args) {
    return $97561ccf56589493$var$isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}


const { definePartsStyle: $4e037b0b726b6770$var$definePartsStyle, defineMultiStyleConfig: $4e037b0b726b6770$var$defineMultiStyleConfig } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$60f8655d889e17c7).keys);
const $4e037b0b726b6770$var$$border = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("avatar-border-color");
const $4e037b0b726b6770$var$$bg = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("avatar-bg");
const $4e037b0b726b6770$var$$fs = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("avatar-font-size");
const $4e037b0b726b6770$var$$size = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("avatar-size");
const $4e037b0b726b6770$var$baseStyleBadge = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    borderRadius: "full",
    border: "0.2em solid",
    borderColor: $4e037b0b726b6770$var$$border.reference,
    [$4e037b0b726b6770$var$$border.variable]: "white",
    _dark: {
        [$4e037b0b726b6770$var$$border.variable]: "colors.gray.800"
    }
});
const $4e037b0b726b6770$var$baseStyleExcessLabel = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    bg: $4e037b0b726b6770$var$$bg.reference,
    fontSize: $4e037b0b726b6770$var$$fs.reference,
    width: $4e037b0b726b6770$var$$size.reference,
    height: $4e037b0b726b6770$var$$size.reference,
    lineHeight: "1",
    [$4e037b0b726b6770$var$$bg.variable]: "colors.gray.200",
    _dark: {
        [$4e037b0b726b6770$var$$bg.variable]: "colors.whiteAlpha.400"
    }
});
const $4e037b0b726b6770$var$baseStyleContainer = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { name: name, theme: theme } = props;
    const bg = name ? (0, $f3aed9929b079adb$export$f3c6ed4330abfc18)({
        string: name
    }) : "colors.gray.400";
    const isBgDark = (0, $f3aed9929b079adb$export$a79ad82046afa44e)(bg)(theme);
    let color = "white";
    if (!isBgDark) color = "gray.800";
    return {
        bg: $4e037b0b726b6770$var$$bg.reference,
        fontSize: $4e037b0b726b6770$var$$fs.reference,
        color: color,
        borderColor: $4e037b0b726b6770$var$$border.reference,
        verticalAlign: "top",
        width: $4e037b0b726b6770$var$$size.reference,
        height: $4e037b0b726b6770$var$$size.reference,
        "&:not([data-loaded])": {
            [$4e037b0b726b6770$var$$bg.variable]: bg
        },
        [$4e037b0b726b6770$var$$border.variable]: "colors.white",
        _dark: {
            [$4e037b0b726b6770$var$$border.variable]: "colors.gray.800"
        }
    };
});
const $4e037b0b726b6770$var$baseStyleLabel = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    fontSize: $4e037b0b726b6770$var$$fs.reference,
    lineHeight: "1"
});
const $4e037b0b726b6770$var$baseStyle = $4e037b0b726b6770$var$definePartsStyle((props)=>({
        badge: (0, $97561ccf56589493$export$624e501d81f5ffce)($4e037b0b726b6770$var$baseStyleBadge, props),
        excessLabel: (0, $97561ccf56589493$export$624e501d81f5ffce)($4e037b0b726b6770$var$baseStyleExcessLabel, props),
        container: (0, $97561ccf56589493$export$624e501d81f5ffce)($4e037b0b726b6770$var$baseStyleContainer, props),
        label: $4e037b0b726b6770$var$baseStyleLabel
    }));
function $4e037b0b726b6770$var$getSize(size) {
    const themeSize = size !== "100%" ? (0, $da66fdd6a25ef817$export$2e2bcd8739ae039)[size] : void 0;
    return $4e037b0b726b6770$var$definePartsStyle({
        container: {
            [$4e037b0b726b6770$var$$size.variable]: themeSize ?? size,
            [$4e037b0b726b6770$var$$fs.variable]: `calc(${themeSize ?? size} / 2.5)`
        },
        excessLabel: {
            [$4e037b0b726b6770$var$$size.variable]: themeSize ?? size,
            [$4e037b0b726b6770$var$$fs.variable]: `calc(${themeSize ?? size} / 2.5)`
        }
    });
}
const $4e037b0b726b6770$var$sizes = {
    "2xs": $4e037b0b726b6770$var$getSize(4),
    xs: $4e037b0b726b6770$var$getSize(6),
    sm: $4e037b0b726b6770$var$getSize(8),
    md: $4e037b0b726b6770$var$getSize(12),
    lg: $4e037b0b726b6770$var$getSize(16),
    xl: $4e037b0b726b6770$var$getSize(24),
    "2xl": $4e037b0b726b6770$var$getSize(32),
    full: $4e037b0b726b6770$var$getSize("100%")
};
const $4e037b0b726b6770$export$9975d21893c10e66 = $4e037b0b726b6770$var$defineMultiStyleConfig({
    baseStyle: $4e037b0b726b6770$var$baseStyle,
    sizes: $4e037b0b726b6770$var$sizes,
    defaultProps: {
        size: "md"
    }
});




const $abac354712895270$export$947cd287c296b479 = (0, $baa260bb5827f910$export$bd40561c6c056841)("badge", [
    "bg",
    "color",
    "shadow"
]);
const $abac354712895270$var$baseStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    px: 1,
    textTransform: "uppercase",
    fontSize: "xs",
    borderRadius: "sm",
    fontWeight: "bold",
    bg: $abac354712895270$export$947cd287c296b479.bg.reference,
    color: $abac354712895270$export$947cd287c296b479.color.reference,
    boxShadow: $abac354712895270$export$947cd287c296b479.shadow.reference
});
const $abac354712895270$var$variantSolid = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const dark = (0, $f3aed9929b079adb$export$d11da87e55cc498f)(`${c}.500`, 0.6)(theme);
    return {
        [$abac354712895270$export$947cd287c296b479.bg.variable]: `colors.${c}.500`,
        [$abac354712895270$export$947cd287c296b479.color.variable]: `colors.white`,
        _dark: {
            [$abac354712895270$export$947cd287c296b479.bg.variable]: dark,
            [$abac354712895270$export$947cd287c296b479.color.variable]: `colors.whiteAlpha.800`
        }
    };
});
const $abac354712895270$var$variantSubtle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const darkBg = (0, $f3aed9929b079adb$export$d11da87e55cc498f)(`${c}.200`, 0.16)(theme);
    return {
        [$abac354712895270$export$947cd287c296b479.bg.variable]: `colors.${c}.100`,
        [$abac354712895270$export$947cd287c296b479.color.variable]: `colors.${c}.800`,
        _dark: {
            [$abac354712895270$export$947cd287c296b479.bg.variable]: darkBg,
            [$abac354712895270$export$947cd287c296b479.color.variable]: `colors.${c}.200`
        }
    };
});
const $abac354712895270$var$variantOutline = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const darkColor = (0, $f3aed9929b079adb$export$d11da87e55cc498f)(`${c}.200`, 0.8)(theme);
    return {
        [$abac354712895270$export$947cd287c296b479.color.variable]: `colors.${c}.500`,
        _dark: {
            [$abac354712895270$export$947cd287c296b479.color.variable]: darkColor
        },
        [$abac354712895270$export$947cd287c296b479.shadow.variable]: `inset 0 0 0px 1px ${$abac354712895270$export$947cd287c296b479.color.reference}`
    };
});
const $abac354712895270$var$variants = {
    solid: $abac354712895270$var$variantSolid,
    subtle: $abac354712895270$var$variantSubtle,
    outline: $abac354712895270$var$variantOutline
};
const $abac354712895270$export$eb6e7cbc82d0f88b = (0, $72fdfa583ecf837c$export$5c9a64458a4ed8a4)({
    baseStyle: $abac354712895270$var$baseStyle,
    variants: $abac354712895270$var$variants,
    defaultProps: {
        variant: "subtle",
        colorScheme: "gray"
    }
});




const { defineMultiStyleConfig: $f188fbf516f46a1a$var$defineMultiStyleConfig, definePartsStyle: $f188fbf516f46a1a$var$definePartsStyle } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$2fb03f744a6ecf93).keys);
const $f188fbf516f46a1a$var$$decor = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("breadcrumb-link-decor");
const $f188fbf516f46a1a$var$baseStyleLink = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    outline: "none",
    color: "inherit",
    textDecoration: $f188fbf516f46a1a$var$$decor.reference,
    [$f188fbf516f46a1a$var$$decor.variable]: "none",
    "&:not([aria-current=page])": {
        cursor: "pointer",
        _hover: {
            [$f188fbf516f46a1a$var$$decor.variable]: "underline"
        },
        _focusVisible: {
            boxShadow: "outline"
        }
    }
});
const $f188fbf516f46a1a$var$baseStyle = $f188fbf516f46a1a$var$definePartsStyle({
    link: $f188fbf516f46a1a$var$baseStyleLink
});
const $f188fbf516f46a1a$export$e2d8c6f6af55009 = $f188fbf516f46a1a$var$defineMultiStyleConfig({
    baseStyle: $f188fbf516f46a1a$var$baseStyle
});



function $e5881595af47b095$export$549ff81930776885(light, dark) {
    return (props)=>props.colorMode === "dark" ? dark : light;
}
function $e5881595af47b095$export$f3eec17ee6065eee(options) {
    const { orientation: orientation, vertical: vertical, horizontal: horizontal } = options;
    if (!orientation) return {};
    return orientation === "vertical" ? vertical : horizontal;
}



const $7d7d1be714046c52$var$baseStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    lineHeight: "1.2",
    borderRadius: "md",
    fontWeight: "semibold",
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
        boxShadow: "outline"
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        boxShadow: "none"
    },
    _hover: {
        _disabled: {
            bg: "initial"
        }
    }
});
const $7d7d1be714046c52$var$variantGhost = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    if (c === "gray") return {
        color: (0, $e5881595af47b095$export$549ff81930776885)(`gray.800`, `whiteAlpha.900`)(props),
        _hover: {
            bg: (0, $e5881595af47b095$export$549ff81930776885)(`gray.100`, `whiteAlpha.200`)(props)
        },
        _active: {
            bg: (0, $e5881595af47b095$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props)
        }
    };
    const darkHoverBg = (0, $f3aed9929b079adb$export$d11da87e55cc498f)(`${c}.200`, 0.12)(theme);
    const darkActiveBg = (0, $f3aed9929b079adb$export$d11da87e55cc498f)(`${c}.200`, 0.24)(theme);
    return {
        color: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.600`, `${c}.200`)(props),
        bg: "transparent",
        _hover: {
            bg: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.50`, darkHoverBg)(props)
        },
        _active: {
            bg: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.100`, darkActiveBg)(props)
        }
    };
});
const $7d7d1be714046c52$var$variantOutline = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    const borderColor = (0, $e5881595af47b095$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props);
    return {
        border: "1px solid",
        borderColor: c === "gray" ? borderColor : "currentColor",
        ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": {
            marginEnd: "-1px"
        },
        ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": {
            marginBottom: "-1px"
        },
        ...(0, $97561ccf56589493$export$624e501d81f5ffce)($7d7d1be714046c52$var$variantGhost, props)
    };
});
const $7d7d1be714046c52$var$accessibleColorMap = {
    yellow: {
        bg: "yellow.400",
        color: "black",
        hoverBg: "yellow.500",
        activeBg: "yellow.600"
    },
    cyan: {
        bg: "cyan.400",
        color: "black",
        hoverBg: "cyan.500",
        activeBg: "cyan.600"
    }
};
const $7d7d1be714046c52$var$variantSolid = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    if (c === "gray") {
        const bg2 = (0, $e5881595af47b095$export$549ff81930776885)(`gray.100`, `whiteAlpha.200`)(props);
        return {
            bg: bg2,
            color: (0, $e5881595af47b095$export$549ff81930776885)(`gray.800`, `whiteAlpha.900`)(props),
            _hover: {
                bg: (0, $e5881595af47b095$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props),
                _disabled: {
                    bg: bg2
                }
            },
            _active: {
                bg: (0, $e5881595af47b095$export$549ff81930776885)(`gray.300`, `whiteAlpha.400`)(props)
            }
        };
    }
    const { bg: bg = `${c}.500`, color: color = "white", hoverBg: hoverBg = `${c}.600`, activeBg: activeBg = `${c}.700` } = $7d7d1be714046c52$var$accessibleColorMap[c] ?? {};
    const background = (0, $e5881595af47b095$export$549ff81930776885)(bg, `${c}.200`)(props);
    return {
        bg: background,
        color: (0, $e5881595af47b095$export$549ff81930776885)(color, `gray.800`)(props),
        _hover: {
            bg: (0, $e5881595af47b095$export$549ff81930776885)(hoverBg, `${c}.300`)(props),
            _disabled: {
                bg: background
            }
        },
        _active: {
            bg: (0, $e5881595af47b095$export$549ff81930776885)(activeBg, `${c}.400`)(props)
        }
    };
});
const $7d7d1be714046c52$var$variantLink = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        padding: 0,
        height: "auto",
        lineHeight: "normal",
        verticalAlign: "baseline",
        color: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
        _hover: {
            textDecoration: "underline",
            _disabled: {
                textDecoration: "none"
            }
        },
        _active: {
            color: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.700`, `${c}.500`)(props)
        }
    };
});
const $7d7d1be714046c52$var$variantUnstyled = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    bg: "none",
    color: "inherit",
    display: "inline",
    lineHeight: "inherit",
    m: "0",
    p: "0"
});
const $7d7d1be714046c52$var$variants = {
    ghost: $7d7d1be714046c52$var$variantGhost,
    outline: $7d7d1be714046c52$var$variantOutline,
    solid: $7d7d1be714046c52$var$variantSolid,
    link: $7d7d1be714046c52$var$variantLink,
    unstyled: $7d7d1be714046c52$var$variantUnstyled
};
const $7d7d1be714046c52$var$sizes = {
    lg: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        h: "12",
        minW: "12",
        fontSize: "lg",
        px: "6"
    }),
    md: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        h: "10",
        minW: "10",
        fontSize: "md",
        px: "4"
    }),
    sm: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        h: "8",
        minW: "8",
        fontSize: "sm",
        px: "3"
    }),
    xs: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        h: "6",
        minW: "6",
        fontSize: "xs",
        px: "2"
    })
};
const $7d7d1be714046c52$export$577deec5d331f6be = (0, $72fdfa583ecf837c$export$5c9a64458a4ed8a4)({
    baseStyle: $7d7d1be714046c52$var$baseStyle,
    variants: $7d7d1be714046c52$var$variants,
    sizes: $7d7d1be714046c52$var$sizes,
    defaultProps: {
        variant: "solid",
        size: "md",
        colorScheme: "gray"
    }
});




const { definePartsStyle: $7ecdaea5a4a75c2b$var$definePartsStyle, defineMultiStyleConfig: $7ecdaea5a4a75c2b$var$defineMultiStyleConfig } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$487a447ffa5755b6).keys);
const $7ecdaea5a4a75c2b$var$$bg = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("card-bg");
const $7ecdaea5a4a75c2b$var$$padding = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("card-padding");
const $7ecdaea5a4a75c2b$var$$shadow = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("card-shadow");
const $7ecdaea5a4a75c2b$var$$radius = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("card-radius");
const $7ecdaea5a4a75c2b$var$$border = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("card-border-width", "0");
const $7ecdaea5a4a75c2b$var$$borderColor = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("card-border-color");
const $7ecdaea5a4a75c2b$var$baseStyle = $7ecdaea5a4a75c2b$var$definePartsStyle({
    container: {
        [$7ecdaea5a4a75c2b$var$$bg.variable]: "colors.chakra-body-bg",
        backgroundColor: $7ecdaea5a4a75c2b$var$$bg.reference,
        boxShadow: $7ecdaea5a4a75c2b$var$$shadow.reference,
        borderRadius: $7ecdaea5a4a75c2b$var$$radius.reference,
        color: "chakra-body-text",
        borderWidth: $7ecdaea5a4a75c2b$var$$border.reference,
        borderColor: $7ecdaea5a4a75c2b$var$$borderColor.reference
    },
    body: {
        padding: $7ecdaea5a4a75c2b$var$$padding.reference,
        flex: "1 1 0%"
    },
    header: {
        padding: $7ecdaea5a4a75c2b$var$$padding.reference
    },
    footer: {
        padding: $7ecdaea5a4a75c2b$var$$padding.reference
    }
});
const $7ecdaea5a4a75c2b$var$sizes = {
    sm: $7ecdaea5a4a75c2b$var$definePartsStyle({
        container: {
            [$7ecdaea5a4a75c2b$var$$radius.variable]: "radii.base",
            [$7ecdaea5a4a75c2b$var$$padding.variable]: "space.3"
        }
    }),
    md: $7ecdaea5a4a75c2b$var$definePartsStyle({
        container: {
            [$7ecdaea5a4a75c2b$var$$radius.variable]: "radii.md",
            [$7ecdaea5a4a75c2b$var$$padding.variable]: "space.5"
        }
    }),
    lg: $7ecdaea5a4a75c2b$var$definePartsStyle({
        container: {
            [$7ecdaea5a4a75c2b$var$$radius.variable]: "radii.xl",
            [$7ecdaea5a4a75c2b$var$$padding.variable]: "space.7"
        }
    })
};
const $7ecdaea5a4a75c2b$var$variants = {
    elevated: $7ecdaea5a4a75c2b$var$definePartsStyle({
        container: {
            [$7ecdaea5a4a75c2b$var$$shadow.variable]: "shadows.base",
            _dark: {
                [$7ecdaea5a4a75c2b$var$$bg.variable]: "colors.gray.700"
            }
        }
    }),
    outline: $7ecdaea5a4a75c2b$var$definePartsStyle({
        container: {
            [$7ecdaea5a4a75c2b$var$$border.variable]: "1px",
            [$7ecdaea5a4a75c2b$var$$borderColor.variable]: "colors.chakra-border-color"
        }
    }),
    filled: $7ecdaea5a4a75c2b$var$definePartsStyle({
        container: {
            [$7ecdaea5a4a75c2b$var$$bg.variable]: "colors.chakra-subtle-bg"
        }
    }),
    unstyled: {
        body: {
            [$7ecdaea5a4a75c2b$var$$padding.variable]: 0
        },
        header: {
            [$7ecdaea5a4a75c2b$var$$padding.variable]: 0
        },
        footer: {
            [$7ecdaea5a4a75c2b$var$$padding.variable]: 0
        }
    }
};
const $7ecdaea5a4a75c2b$export$880f7b1201440c23 = $7ecdaea5a4a75c2b$var$defineMultiStyleConfig({
    baseStyle: $7ecdaea5a4a75c2b$var$baseStyle,
    variants: $7ecdaea5a4a75c2b$var$variants,
    sizes: $7ecdaea5a4a75c2b$var$sizes,
    defaultProps: {
        variant: "elevated",
        size: "md"
    }
});






const { definePartsStyle: $73c7ff1048be51eb$var$definePartsStyle, defineMultiStyleConfig: $73c7ff1048be51eb$var$defineMultiStyleConfig } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$21946b04497ed6ac).keys);
const $73c7ff1048be51eb$var$$size = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("checkbox-size");
const $73c7ff1048be51eb$var$baseStyleControl = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        w: $73c7ff1048be51eb$var$$size.reference,
        h: $73c7ff1048be51eb$var$$size.reference,
        transitionProperty: "box-shadow",
        transitionDuration: "normal",
        border: "2px solid",
        borderRadius: "sm",
        borderColor: "inherit",
        color: "white",
        _checked: {
            bg: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            borderColor: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            color: (0, $e5881595af47b095$export$549ff81930776885)("white", "gray.900")(props),
            _hover: {
                bg: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.600`, `${c}.300`)(props),
                borderColor: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.600`, `${c}.300`)(props)
            },
            _disabled: {
                borderColor: (0, $e5881595af47b095$export$549ff81930776885)("gray.200", "transparent")(props),
                bg: (0, $e5881595af47b095$export$549ff81930776885)("gray.200", "whiteAlpha.300")(props),
                color: (0, $e5881595af47b095$export$549ff81930776885)("gray.500", "whiteAlpha.500")(props)
            }
        },
        _indeterminate: {
            bg: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            borderColor: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            color: (0, $e5881595af47b095$export$549ff81930776885)("white", "gray.900")(props)
        },
        _disabled: {
            bg: (0, $e5881595af47b095$export$549ff81930776885)("gray.100", "whiteAlpha.100")(props),
            borderColor: (0, $e5881595af47b095$export$549ff81930776885)("gray.100", "transparent")(props)
        },
        _focusVisible: {
            boxShadow: "outline"
        },
        _invalid: {
            borderColor: (0, $e5881595af47b095$export$549ff81930776885)("red.500", "red.300")(props)
        }
    };
});
const $73c7ff1048be51eb$var$baseStyleContainer = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    _disabled: {
        cursor: "not-allowed"
    }
});
const $73c7ff1048be51eb$var$baseStyleLabel = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    userSelect: "none",
    _disabled: {
        opacity: 0.4
    }
});
const $73c7ff1048be51eb$var$baseStyleIcon = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    transitionProperty: "transform",
    transitionDuration: "normal"
});
const $73c7ff1048be51eb$var$baseStyle = $73c7ff1048be51eb$var$definePartsStyle((props)=>({
        icon: $73c7ff1048be51eb$var$baseStyleIcon,
        container: $73c7ff1048be51eb$var$baseStyleContainer,
        control: (0, $97561ccf56589493$export$624e501d81f5ffce)($73c7ff1048be51eb$var$baseStyleControl, props),
        label: $73c7ff1048be51eb$var$baseStyleLabel
    }));
const $73c7ff1048be51eb$var$sizes = {
    sm: $73c7ff1048be51eb$var$definePartsStyle({
        control: {
            [$73c7ff1048be51eb$var$$size.variable]: "sizes.3"
        },
        label: {
            fontSize: "sm"
        },
        icon: {
            fontSize: "3xs"
        }
    }),
    md: $73c7ff1048be51eb$var$definePartsStyle({
        control: {
            [$73c7ff1048be51eb$var$$size.variable]: "sizes.4"
        },
        label: {
            fontSize: "md"
        },
        icon: {
            fontSize: "2xs"
        }
    }),
    lg: $73c7ff1048be51eb$var$definePartsStyle({
        control: {
            [$73c7ff1048be51eb$var$$size.variable]: "sizes.5"
        },
        label: {
            fontSize: "lg"
        },
        icon: {
            fontSize: "2xs"
        }
    })
};
const $73c7ff1048be51eb$export$86286d8c37984115 = $73c7ff1048be51eb$var$defineMultiStyleConfig({
    baseStyle: $73c7ff1048be51eb$var$baseStyle,
    sizes: $73c7ff1048be51eb$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});



function $5e3b1f5ac021fa20$export$2ad0182371401ea4(value) {
    return !Number.isInteger(parseFloat(value.toString()));
}
function $5e3b1f5ac021fa20$var$replaceWhiteSpace(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
}
function $5e3b1f5ac021fa20$var$escape(value) {
    const valueStr = $5e3b1f5ac021fa20$var$replaceWhiteSpace(value.toString());
    if (valueStr.includes("\\.")) return value;
    return $5e3b1f5ac021fa20$export$2ad0182371401ea4(value) ? valueStr.replace(".", `\\.`) : value;
}
function $5e3b1f5ac021fa20$export$9748efee331ec573(value, prefix = "") {
    return [
        prefix,
        $5e3b1f5ac021fa20$var$escape(value)
    ].filter(Boolean).join("-");
}
function $5e3b1f5ac021fa20$export$44410db3a43190e8(name, fallback) {
    return `var(${$5e3b1f5ac021fa20$var$escape(name)}${fallback ? `, ${fallback}` : ""})`;
}
function $5e3b1f5ac021fa20$export$e2ffa342f278b3a3(value, prefix = "") {
    return `--${$5e3b1f5ac021fa20$export$9748efee331ec573(value, prefix)}`;
}
function $5e3b1f5ac021fa20$export$8b4981022bd80a4e(name, options) {
    const cssVariable = $5e3b1f5ac021fa20$export$e2ffa342f278b3a3(name, options?.prefix);
    return {
        variable: cssVariable,
        reference: $5e3b1f5ac021fa20$export$44410db3a43190e8(cssVariable, $5e3b1f5ac021fa20$var$getFallback(options?.fallback))
    };
}
function $5e3b1f5ac021fa20$var$getFallback(fallback) {
    if (typeof fallback === "string") return fallback;
    return fallback?.reference;
}


const $dc7d80f12e56f3a3$var$$size = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("close-button-size");
const $dc7d80f12e56f3a3$var$$bg = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("close-button-bg");
const $dc7d80f12e56f3a3$var$baseStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    w: [
        $dc7d80f12e56f3a3$var$$size.reference
    ],
    h: [
        $dc7d80f12e56f3a3$var$$size.reference
    ],
    borderRadius: "md",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        boxShadow: "none"
    },
    _hover: {
        [$dc7d80f12e56f3a3$var$$bg.variable]: "colors.blackAlpha.100",
        _dark: {
            [$dc7d80f12e56f3a3$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _active: {
        [$dc7d80f12e56f3a3$var$$bg.variable]: "colors.blackAlpha.200",
        _dark: {
            [$dc7d80f12e56f3a3$var$$bg.variable]: "colors.whiteAlpha.200"
        }
    },
    _focusVisible: {
        boxShadow: "outline"
    },
    bg: $dc7d80f12e56f3a3$var$$bg.reference
});
const $dc7d80f12e56f3a3$var$sizes = {
    lg: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        [$dc7d80f12e56f3a3$var$$size.variable]: "sizes.10",
        fontSize: "md"
    }),
    md: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        [$dc7d80f12e56f3a3$var$$size.variable]: "sizes.8",
        fontSize: "xs"
    }),
    sm: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        [$dc7d80f12e56f3a3$var$$size.variable]: "sizes.6",
        fontSize: "2xs"
    })
};
const $dc7d80f12e56f3a3$export$47615e5b7f7e315f = (0, $72fdfa583ecf837c$export$5c9a64458a4ed8a4)({
    baseStyle: $dc7d80f12e56f3a3$var$baseStyle,
    sizes: $dc7d80f12e56f3a3$var$sizes,
    defaultProps: {
        size: "md"
    }
});




const { variants: $f86fc7105e4a17e9$var$variants, defaultProps: $f86fc7105e4a17e9$var$defaultProps } = (0, $abac354712895270$export$eb6e7cbc82d0f88b);
const $f86fc7105e4a17e9$var$baseStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    fontFamily: "mono",
    fontSize: "sm",
    px: "0.2em",
    borderRadius: "sm",
    bg: (0, $abac354712895270$export$947cd287c296b479).bg.reference,
    color: (0, $abac354712895270$export$947cd287c296b479).color.reference,
    boxShadow: (0, $abac354712895270$export$947cd287c296b479).shadow.reference
});
const $f86fc7105e4a17e9$export$f9b9a8633a36e3c7 = (0, $72fdfa583ecf837c$export$5c9a64458a4ed8a4)({
    baseStyle: $f86fc7105e4a17e9$var$baseStyle,
    variants: $f86fc7105e4a17e9$var$variants,
    defaultProps: $f86fc7105e4a17e9$var$defaultProps
});



const $141d27f87a0bf98a$var$baseStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    w: "100%",
    mx: "auto",
    maxW: "prose",
    px: "4"
});
const $141d27f87a0bf98a$export$3ca0760d240fe5f4 = (0, $72fdfa583ecf837c$export$5c9a64458a4ed8a4)({
    baseStyle: $141d27f87a0bf98a$var$baseStyle
});



const $0043da67a82d8949$var$baseStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    opacity: 0.6,
    borderColor: "inherit"
});
const $0043da67a82d8949$var$variantSolid = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    borderStyle: "solid"
});
const $0043da67a82d8949$var$variantDashed = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    borderStyle: "dashed"
});
const $0043da67a82d8949$var$variants = {
    solid: $0043da67a82d8949$var$variantSolid,
    dashed: $0043da67a82d8949$var$variantDashed
};
const $0043da67a82d8949$export$f0e91f779c5bb416 = (0, $72fdfa583ecf837c$export$5c9a64458a4ed8a4)({
    baseStyle: $0043da67a82d8949$var$baseStyle,
    variants: $0043da67a82d8949$var$variants,
    defaultProps: {
        variant: "solid"
    }
});





const { definePartsStyle: $dd8f405fb0ed04bf$var$definePartsStyle, defineMultiStyleConfig: $dd8f405fb0ed04bf$var$defineMultiStyleConfig } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$d3f4aaa4b0f2907a).keys);
const $dd8f405fb0ed04bf$var$$bg = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("drawer-bg");
const $dd8f405fb0ed04bf$var$$bs = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("drawer-box-shadow");
function $dd8f405fb0ed04bf$var$getSize(value) {
    if (value === "full") return $dd8f405fb0ed04bf$var$definePartsStyle({
        dialog: {
            maxW: "100vw",
            h: "100vh"
        }
    });
    return $dd8f405fb0ed04bf$var$definePartsStyle({
        dialog: {
            maxW: value
        }
    });
}
const $dd8f405fb0ed04bf$var$baseStyleOverlay = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    bg: "blackAlpha.600",
    zIndex: "modal"
});
const $dd8f405fb0ed04bf$var$baseStyleDialogContainer = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    display: "flex",
    zIndex: "modal",
    justifyContent: "center"
});
const $dd8f405fb0ed04bf$var$baseStyleDialog = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { isFullHeight: isFullHeight } = props;
    return {
        ...isFullHeight && {
            height: "100vh"
        },
        zIndex: "modal",
        maxH: "100vh",
        color: "inherit",
        [$dd8f405fb0ed04bf$var$$bg.variable]: "colors.white",
        [$dd8f405fb0ed04bf$var$$bs.variable]: "shadows.lg",
        _dark: {
            [$dd8f405fb0ed04bf$var$$bg.variable]: "colors.gray.700",
            [$dd8f405fb0ed04bf$var$$bs.variable]: "shadows.dark-lg"
        },
        bg: $dd8f405fb0ed04bf$var$$bg.reference,
        boxShadow: $dd8f405fb0ed04bf$var$$bs.reference
    };
});
const $dd8f405fb0ed04bf$var$baseStyleHeader = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
});
const $dd8f405fb0ed04bf$var$baseStyleCloseButton = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    position: "absolute",
    top: "2",
    insetEnd: "3"
});
const $dd8f405fb0ed04bf$var$baseStyleBody = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    px: "6",
    py: "2",
    flex: "1",
    overflow: "auto"
});
const $dd8f405fb0ed04bf$var$baseStyleFooter = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4"
});
const $dd8f405fb0ed04bf$var$baseStyle = $dd8f405fb0ed04bf$var$definePartsStyle((props)=>({
        overlay: $dd8f405fb0ed04bf$var$baseStyleOverlay,
        dialogContainer: $dd8f405fb0ed04bf$var$baseStyleDialogContainer,
        dialog: (0, $97561ccf56589493$export$624e501d81f5ffce)($dd8f405fb0ed04bf$var$baseStyleDialog, props),
        header: $dd8f405fb0ed04bf$var$baseStyleHeader,
        closeButton: $dd8f405fb0ed04bf$var$baseStyleCloseButton,
        body: $dd8f405fb0ed04bf$var$baseStyleBody,
        footer: $dd8f405fb0ed04bf$var$baseStyleFooter
    }));
const $dd8f405fb0ed04bf$var$sizes = {
    xs: $dd8f405fb0ed04bf$var$getSize("xs"),
    sm: $dd8f405fb0ed04bf$var$getSize("md"),
    md: $dd8f405fb0ed04bf$var$getSize("lg"),
    lg: $dd8f405fb0ed04bf$var$getSize("2xl"),
    xl: $dd8f405fb0ed04bf$var$getSize("4xl"),
    full: $dd8f405fb0ed04bf$var$getSize("full")
};
const $dd8f405fb0ed04bf$export$8057937c11129602 = $dd8f405fb0ed04bf$var$defineMultiStyleConfig({
    baseStyle: $dd8f405fb0ed04bf$var$baseStyle,
    sizes: $dd8f405fb0ed04bf$var$sizes,
    defaultProps: {
        size: "xs"
    }
});




const { definePartsStyle: $5555e8c0d78e172f$var$definePartsStyle, defineMultiStyleConfig: $5555e8c0d78e172f$var$defineMultiStyleConfig } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$2813c9511eeab082).keys);
const $5555e8c0d78e172f$var$baseStylePreview = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal"
});
const $5555e8c0d78e172f$var$baseStyleInput = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: {
        boxShadow: "outline"
    },
    _placeholder: {
        opacity: 0.6
    }
});
const $5555e8c0d78e172f$var$baseStyleTextarea = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: {
        boxShadow: "outline"
    },
    _placeholder: {
        opacity: 0.6
    }
});
const $5555e8c0d78e172f$var$baseStyle = $5555e8c0d78e172f$var$definePartsStyle({
    preview: $5555e8c0d78e172f$var$baseStylePreview,
    input: $5555e8c0d78e172f$var$baseStyleInput,
    textarea: $5555e8c0d78e172f$var$baseStyleTextarea
});
const $5555e8c0d78e172f$export$a09813cbe72349b1 = $5555e8c0d78e172f$var$defineMultiStyleConfig({
    baseStyle: $5555e8c0d78e172f$var$baseStyle
});




const { definePartsStyle: $494aa3c4b7c388ab$var$definePartsStyle, defineMultiStyleConfig: $494aa3c4b7c388ab$var$defineMultiStyleConfig } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$4b243e3f209a7e5e).keys);
const $494aa3c4b7c388ab$var$$fg = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("form-control-color");
const $494aa3c4b7c388ab$var$baseStyleRequiredIndicator = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    marginStart: "1",
    [$494aa3c4b7c388ab$var$$fg.variable]: "colors.red.500",
    _dark: {
        [$494aa3c4b7c388ab$var$$fg.variable]: "colors.red.300"
    },
    color: $494aa3c4b7c388ab$var$$fg.reference
});
const $494aa3c4b7c388ab$var$baseStyleHelperText = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    mt: "2",
    [$494aa3c4b7c388ab$var$$fg.variable]: "colors.gray.600",
    _dark: {
        [$494aa3c4b7c388ab$var$$fg.variable]: "colors.whiteAlpha.600"
    },
    color: $494aa3c4b7c388ab$var$$fg.reference,
    lineHeight: "normal",
    fontSize: "sm"
});
const $494aa3c4b7c388ab$var$baseStyle = $494aa3c4b7c388ab$var$definePartsStyle({
    container: {
        width: "100%",
        position: "relative"
    },
    requiredIndicator: $494aa3c4b7c388ab$var$baseStyleRequiredIndicator,
    helperText: $494aa3c4b7c388ab$var$baseStyleHelperText
});
const $494aa3c4b7c388ab$export$870bcc1d98fee0aa = $494aa3c4b7c388ab$var$defineMultiStyleConfig({
    baseStyle: $494aa3c4b7c388ab$var$baseStyle
});




const { definePartsStyle: $51c3bd5bb50af8fe$var$definePartsStyle, defineMultiStyleConfig: $51c3bd5bb50af8fe$var$defineMultiStyleConfig } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$bb18c440c00e82d9).keys);
const $51c3bd5bb50af8fe$var$$fg = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("form-error-color");
const $51c3bd5bb50af8fe$var$baseStyleText = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    [$51c3bd5bb50af8fe$var$$fg.variable]: `colors.red.500`,
    _dark: {
        [$51c3bd5bb50af8fe$var$$fg.variable]: `colors.red.300`
    },
    color: $51c3bd5bb50af8fe$var$$fg.reference,
    mt: "2",
    fontSize: "sm",
    lineHeight: "normal"
});
const $51c3bd5bb50af8fe$var$baseStyleIcon = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    marginEnd: "0.5em",
    [$51c3bd5bb50af8fe$var$$fg.variable]: `colors.red.500`,
    _dark: {
        [$51c3bd5bb50af8fe$var$$fg.variable]: `colors.red.300`
    },
    color: $51c3bd5bb50af8fe$var$$fg.reference
});
const $51c3bd5bb50af8fe$var$baseStyle = $51c3bd5bb50af8fe$var$definePartsStyle({
    text: $51c3bd5bb50af8fe$var$baseStyleText,
    icon: $51c3bd5bb50af8fe$var$baseStyleIcon
});
const $51c3bd5bb50af8fe$export$b8d6747e16cd5f4d = $51c3bd5bb50af8fe$var$defineMultiStyleConfig({
    baseStyle: $51c3bd5bb50af8fe$var$baseStyle
});



const $d1298c7333328bad$var$baseStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    fontSize: "md",
    marginEnd: "3",
    mb: "2",
    fontWeight: "medium",
    transitionProperty: "common",
    transitionDuration: "normal",
    opacity: 1,
    _disabled: {
        opacity: 0.4
    }
});
const $d1298c7333328bad$export$c49af69dbfc0c993 = (0, $72fdfa583ecf837c$export$5c9a64458a4ed8a4)({
    baseStyle: $d1298c7333328bad$var$baseStyle
});



const $400864f1db9df809$var$baseStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    fontFamily: "heading",
    fontWeight: "bold"
});
const $400864f1db9df809$var$sizes = {
    "4xl": (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        fontSize: [
            "6xl",
            null,
            "7xl"
        ],
        lineHeight: 1
    }),
    "3xl": (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        fontSize: [
            "5xl",
            null,
            "6xl"
        ],
        lineHeight: 1
    }),
    "2xl": (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        fontSize: [
            "4xl",
            null,
            "5xl"
        ],
        lineHeight: [
            1.2,
            null,
            1
        ]
    }),
    xl: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        fontSize: [
            "3xl",
            null,
            "4xl"
        ],
        lineHeight: [
            1.33,
            null,
            1.2
        ]
    }),
    lg: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        fontSize: [
            "2xl",
            null,
            "3xl"
        ],
        lineHeight: [
            1.33,
            null,
            1.2
        ]
    }),
    md: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        fontSize: "xl",
        lineHeight: 1.2
    }),
    sm: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        fontSize: "md",
        lineHeight: 1.2
    }),
    xs: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        fontSize: "sm",
        lineHeight: 1.2
    })
};
const $400864f1db9df809$export$5f175074e0f09e7b = (0, $72fdfa583ecf837c$export$5c9a64458a4ed8a4)({
    baseStyle: $400864f1db9df809$var$baseStyle,
    sizes: $400864f1db9df809$var$sizes,
    defaultProps: {
        size: "xl"
    }
});





const { definePartsStyle: $784186043f2fed12$var$definePartsStyle, defineMultiStyleConfig: $784186043f2fed12$var$defineMultiStyleConfig } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$1ffeb100b532f46d).keys);
const $784186043f2fed12$var$$height = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("input-height");
const $784186043f2fed12$var$$fontSize = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("input-font-size");
const $784186043f2fed12$var$$padding = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("input-padding");
const $784186043f2fed12$var$$borderRadius = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("input-border-radius");
const $784186043f2fed12$var$baseStyle = $784186043f2fed12$var$definePartsStyle({
    addon: {
        height: $784186043f2fed12$var$$height.reference,
        fontSize: $784186043f2fed12$var$$fontSize.reference,
        px: $784186043f2fed12$var$$padding.reference,
        borderRadius: $784186043f2fed12$var$$borderRadius.reference
    },
    field: {
        width: "100%",
        height: $784186043f2fed12$var$$height.reference,
        fontSize: $784186043f2fed12$var$$fontSize.reference,
        px: $784186043f2fed12$var$$padding.reference,
        borderRadius: $784186043f2fed12$var$$borderRadius.reference,
        minWidth: 0,
        outline: 0,
        position: "relative",
        appearance: "none",
        transitionProperty: "common",
        transitionDuration: "normal",
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        }
    }
});
const $784186043f2fed12$var$size = {
    lg: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        [$784186043f2fed12$var$$fontSize.variable]: "fontSizes.lg",
        [$784186043f2fed12$var$$padding.variable]: "space.4",
        [$784186043f2fed12$var$$borderRadius.variable]: "radii.md",
        [$784186043f2fed12$var$$height.variable]: "sizes.12"
    }),
    md: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        [$784186043f2fed12$var$$fontSize.variable]: "fontSizes.md",
        [$784186043f2fed12$var$$padding.variable]: "space.4",
        [$784186043f2fed12$var$$borderRadius.variable]: "radii.md",
        [$784186043f2fed12$var$$height.variable]: "sizes.10"
    }),
    sm: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        [$784186043f2fed12$var$$fontSize.variable]: "fontSizes.sm",
        [$784186043f2fed12$var$$padding.variable]: "space.3",
        [$784186043f2fed12$var$$borderRadius.variable]: "radii.sm",
        [$784186043f2fed12$var$$height.variable]: "sizes.8"
    }),
    xs: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        [$784186043f2fed12$var$$fontSize.variable]: "fontSizes.xs",
        [$784186043f2fed12$var$$padding.variable]: "space.2",
        [$784186043f2fed12$var$$borderRadius.variable]: "radii.sm",
        [$784186043f2fed12$var$$height.variable]: "sizes.6"
    })
};
const $784186043f2fed12$var$sizes = {
    lg: $784186043f2fed12$var$definePartsStyle({
        field: $784186043f2fed12$var$size.lg,
        group: $784186043f2fed12$var$size.lg
    }),
    md: $784186043f2fed12$var$definePartsStyle({
        field: $784186043f2fed12$var$size.md,
        group: $784186043f2fed12$var$size.md
    }),
    sm: $784186043f2fed12$var$definePartsStyle({
        field: $784186043f2fed12$var$size.sm,
        group: $784186043f2fed12$var$size.sm
    }),
    xs: $784186043f2fed12$var$definePartsStyle({
        field: $784186043f2fed12$var$size.xs,
        group: $784186043f2fed12$var$size.xs
    })
};
function $784186043f2fed12$var$getDefaults(props) {
    const { focusBorderColor: fc, errorBorderColor: ec } = props;
    return {
        focusBorderColor: fc || (0, $e5881595af47b095$export$549ff81930776885)("blue.500", "blue.300")(props),
        errorBorderColor: ec || (0, $e5881595af47b095$export$549ff81930776885)("red.500", "red.300")(props)
    };
}
const $784186043f2fed12$var$variantOutline = $784186043f2fed12$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $784186043f2fed12$var$getDefaults(props);
    return {
        field: {
            border: "1px solid",
            borderColor: "inherit",
            bg: "inherit",
            _hover: {
                borderColor: (0, $e5881595af47b095$export$549ff81930776885)("gray.300", "whiteAlpha.400")(props)
            },
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $f3aed9929b079adb$export$5551a2d24ff40153)(theme, ec),
                boxShadow: `0 0 0 1px ${(0, $f3aed9929b079adb$export$5551a2d24ff40153)(theme, ec)}`
            },
            _focusVisible: {
                zIndex: 1,
                borderColor: (0, $f3aed9929b079adb$export$5551a2d24ff40153)(theme, fc),
                boxShadow: `0 0 0 1px ${(0, $f3aed9929b079adb$export$5551a2d24ff40153)(theme, fc)}`
            }
        },
        addon: {
            border: "1px solid",
            borderColor: (0, $e5881595af47b095$export$549ff81930776885)("inherit", "whiteAlpha.50")(props),
            bg: (0, $e5881595af47b095$export$549ff81930776885)("gray.100", "whiteAlpha.300")(props)
        }
    };
});
const $784186043f2fed12$var$variantFilled = $784186043f2fed12$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $784186043f2fed12$var$getDefaults(props);
    return {
        field: {
            border: "2px solid",
            borderColor: "transparent",
            bg: (0, $e5881595af47b095$export$549ff81930776885)("gray.100", "whiteAlpha.50")(props),
            _hover: {
                bg: (0, $e5881595af47b095$export$549ff81930776885)("gray.200", "whiteAlpha.100")(props)
            },
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $f3aed9929b079adb$export$5551a2d24ff40153)(theme, ec)
            },
            _focusVisible: {
                bg: "transparent",
                borderColor: (0, $f3aed9929b079adb$export$5551a2d24ff40153)(theme, fc)
            }
        },
        addon: {
            border: "2px solid",
            borderColor: "transparent",
            bg: (0, $e5881595af47b095$export$549ff81930776885)("gray.100", "whiteAlpha.50")(props)
        }
    };
});
const $784186043f2fed12$var$variantFlushed = $784186043f2fed12$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $784186043f2fed12$var$getDefaults(props);
    return {
        field: {
            borderBottom: "1px solid",
            borderColor: "inherit",
            borderRadius: "0",
            px: "0",
            bg: "transparent",
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $f3aed9929b079adb$export$5551a2d24ff40153)(theme, ec),
                boxShadow: `0px 1px 0px 0px ${(0, $f3aed9929b079adb$export$5551a2d24ff40153)(theme, ec)}`
            },
            _focusVisible: {
                borderColor: (0, $f3aed9929b079adb$export$5551a2d24ff40153)(theme, fc),
                boxShadow: `0px 1px 0px 0px ${(0, $f3aed9929b079adb$export$5551a2d24ff40153)(theme, fc)}`
            }
        },
        addon: {
            borderBottom: "2px solid",
            borderColor: "inherit",
            borderRadius: "0",
            px: "0",
            bg: "transparent"
        }
    };
});
const $784186043f2fed12$var$variantUnstyled = $784186043f2fed12$var$definePartsStyle({
    field: {
        bg: "transparent",
        px: "0",
        height: "auto"
    },
    addon: {
        bg: "transparent",
        px: "0",
        height: "auto"
    }
});
const $784186043f2fed12$var$variants = {
    outline: $784186043f2fed12$var$variantOutline,
    filled: $784186043f2fed12$var$variantFilled,
    flushed: $784186043f2fed12$var$variantFlushed,
    unstyled: $784186043f2fed12$var$variantUnstyled
};
const $784186043f2fed12$export$b1b9f3bced726e54 = $784186043f2fed12$var$defineMultiStyleConfig({
    baseStyle: $784186043f2fed12$var$baseStyle,
    sizes: $784186043f2fed12$var$sizes,
    variants: $784186043f2fed12$var$variants,
    defaultProps: {
        size: "md",
        variant: "outline"
    }
});



const $9c5afc6534d82b03$var$$bg = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("kbd-bg");
const $9c5afc6534d82b03$var$baseStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    [$9c5afc6534d82b03$var$$bg.variable]: "colors.gray.100",
    _dark: {
        [$9c5afc6534d82b03$var$$bg.variable]: "colors.whiteAlpha.100"
    },
    bg: $9c5afc6534d82b03$var$$bg.reference,
    borderRadius: "md",
    borderWidth: "1px",
    borderBottomWidth: "3px",
    fontSize: "0.8em",
    fontWeight: "bold",
    lineHeight: "normal",
    px: "0.4em",
    whiteSpace: "nowrap"
});
const $9c5afc6534d82b03$export$e193528a501e9a4a = (0, $72fdfa583ecf837c$export$5c9a64458a4ed8a4)({
    baseStyle: $9c5afc6534d82b03$var$baseStyle
});



const $8dedbe51f6a97aae$var$baseStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    cursor: "pointer",
    textDecoration: "none",
    outline: "none",
    color: "inherit",
    _hover: {
        textDecoration: "underline"
    },
    _focusVisible: {
        boxShadow: "outline"
    }
});
const $8dedbe51f6a97aae$export$af7f58b96695762e = (0, $72fdfa583ecf837c$export$5c9a64458a4ed8a4)({
    baseStyle: $8dedbe51f6a97aae$var$baseStyle
});




const { defineMultiStyleConfig: $16ce78115e0392f2$var$defineMultiStyleConfig, definePartsStyle: $16ce78115e0392f2$var$definePartsStyle } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$12b3a655a94374ed).keys);
const $16ce78115e0392f2$var$baseStyleIcon = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    marginEnd: "2",
    display: "inline",
    verticalAlign: "text-bottom"
});
const $16ce78115e0392f2$var$baseStyle = $16ce78115e0392f2$var$definePartsStyle({
    icon: $16ce78115e0392f2$var$baseStyleIcon
});
const $16ce78115e0392f2$export$ce840f8e8ef752d = $16ce78115e0392f2$var$defineMultiStyleConfig({
    baseStyle: $16ce78115e0392f2$var$baseStyle
});




const { defineMultiStyleConfig: $04d621803672fce5$var$defineMultiStyleConfig, definePartsStyle: $04d621803672fce5$var$definePartsStyle } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$e251092a5dcb1329).keys);
const $04d621803672fce5$var$$bg = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("menu-bg");
const $04d621803672fce5$var$$shadow = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("menu-shadow");
const $04d621803672fce5$var$baseStyleList = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    [$04d621803672fce5$var$$bg.variable]: "#fff",
    [$04d621803672fce5$var$$shadow.variable]: "shadows.sm",
    _dark: {
        [$04d621803672fce5$var$$bg.variable]: "colors.gray.700",
        [$04d621803672fce5$var$$shadow.variable]: "shadows.dark-lg"
    },
    color: "inherit",
    minW: "3xs",
    py: "2",
    zIndex: "dropdown",
    borderRadius: "md",
    borderWidth: "1px",
    bg: $04d621803672fce5$var$$bg.reference,
    boxShadow: $04d621803672fce5$var$$shadow.reference
});
const $04d621803672fce5$var$baseStyleItem = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    py: "1.5",
    px: "3",
    transitionProperty: "background",
    transitionDuration: "ultra-fast",
    transitionTimingFunction: "ease-in",
    _focus: {
        [$04d621803672fce5$var$$bg.variable]: "colors.gray.100",
        _dark: {
            [$04d621803672fce5$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _active: {
        [$04d621803672fce5$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$04d621803672fce5$var$$bg.variable]: "colors.whiteAlpha.200"
        }
    },
    _expanded: {
        [$04d621803672fce5$var$$bg.variable]: "colors.gray.100",
        _dark: {
            [$04d621803672fce5$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    },
    bg: $04d621803672fce5$var$$bg.reference
});
const $04d621803672fce5$var$baseStyleGroupTitle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    mx: 4,
    my: 2,
    fontWeight: "semibold",
    fontSize: "sm"
});
const $04d621803672fce5$var$baseStyleIcon = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
const $04d621803672fce5$var$baseStyleCommand = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    opacity: 0.6
});
const $04d621803672fce5$var$baseStyleDivider = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    border: 0,
    borderBottom: "1px solid",
    borderColor: "inherit",
    my: "2",
    opacity: 0.6
});
const $04d621803672fce5$var$baseStyleButton = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "normal"
});
const $04d621803672fce5$var$baseStyle = $04d621803672fce5$var$definePartsStyle({
    button: $04d621803672fce5$var$baseStyleButton,
    list: $04d621803672fce5$var$baseStyleList,
    item: $04d621803672fce5$var$baseStyleItem,
    groupTitle: $04d621803672fce5$var$baseStyleGroupTitle,
    icon: $04d621803672fce5$var$baseStyleIcon,
    command: $04d621803672fce5$var$baseStyleCommand,
    divider: $04d621803672fce5$var$baseStyleDivider
});
const $04d621803672fce5$export$687ce088075ea42b = $04d621803672fce5$var$defineMultiStyleConfig({
    baseStyle: $04d621803672fce5$var$baseStyle
});





const { defineMultiStyleConfig: $5ea5377d270687ca$var$defineMultiStyleConfig, definePartsStyle: $5ea5377d270687ca$var$definePartsStyle } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$34e33beb8d992ac2).keys);
const $5ea5377d270687ca$var$$bg = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("modal-bg");
const $5ea5377d270687ca$var$$shadow = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("modal-shadow");
const $5ea5377d270687ca$var$baseStyleOverlay = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    bg: "blackAlpha.600",
    zIndex: "modal"
});
const $5ea5377d270687ca$var$baseStyleDialogContainer = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { isCentered: isCentered, scrollBehavior: scrollBehavior } = props;
    return {
        display: "flex",
        zIndex: "modal",
        justifyContent: "center",
        alignItems: isCentered ? "center" : "flex-start",
        overflow: scrollBehavior === "inside" ? "hidden" : "auto",
        overscrollBehaviorY: "none"
    };
});
const $5ea5377d270687ca$var$baseStyleDialog = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { isCentered: isCentered, scrollBehavior: scrollBehavior } = props;
    return {
        borderRadius: "md",
        color: "inherit",
        my: isCentered ? "auto" : "16",
        mx: isCentered ? "auto" : void 0,
        zIndex: "modal",
        maxH: scrollBehavior === "inside" ? "calc(100% - 7.5rem)" : void 0,
        [$5ea5377d270687ca$var$$bg.variable]: "colors.white",
        [$5ea5377d270687ca$var$$shadow.variable]: "shadows.lg",
        _dark: {
            [$5ea5377d270687ca$var$$bg.variable]: "colors.gray.700",
            [$5ea5377d270687ca$var$$shadow.variable]: "shadows.dark-lg"
        },
        bg: $5ea5377d270687ca$var$$bg.reference,
        boxShadow: $5ea5377d270687ca$var$$shadow.reference
    };
});
const $5ea5377d270687ca$var$baseStyleHeader = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
});
const $5ea5377d270687ca$var$baseStyleCloseButton = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    position: "absolute",
    top: "2",
    insetEnd: "3"
});
const $5ea5377d270687ca$var$baseStyleBody = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { scrollBehavior: scrollBehavior } = props;
    return {
        px: "6",
        py: "2",
        flex: "1",
        overflow: scrollBehavior === "inside" ? "auto" : void 0
    };
});
const $5ea5377d270687ca$var$baseStyleFooter = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4"
});
const $5ea5377d270687ca$var$baseStyle = $5ea5377d270687ca$var$definePartsStyle((props)=>({
        overlay: $5ea5377d270687ca$var$baseStyleOverlay,
        dialogContainer: (0, $97561ccf56589493$export$624e501d81f5ffce)($5ea5377d270687ca$var$baseStyleDialogContainer, props),
        dialog: (0, $97561ccf56589493$export$624e501d81f5ffce)($5ea5377d270687ca$var$baseStyleDialog, props),
        header: $5ea5377d270687ca$var$baseStyleHeader,
        closeButton: $5ea5377d270687ca$var$baseStyleCloseButton,
        body: (0, $97561ccf56589493$export$624e501d81f5ffce)($5ea5377d270687ca$var$baseStyleBody, props),
        footer: $5ea5377d270687ca$var$baseStyleFooter
    }));
function $5ea5377d270687ca$var$getSize(value) {
    if (value === "full") return $5ea5377d270687ca$var$definePartsStyle({
        dialog: {
            maxW: "100vw",
            minH: "$100vh",
            my: "0",
            borderRadius: "0"
        }
    });
    return $5ea5377d270687ca$var$definePartsStyle({
        dialog: {
            maxW: value
        }
    });
}
const $5ea5377d270687ca$var$sizes = {
    xs: $5ea5377d270687ca$var$getSize("xs"),
    sm: $5ea5377d270687ca$var$getSize("sm"),
    md: $5ea5377d270687ca$var$getSize("md"),
    lg: $5ea5377d270687ca$var$getSize("lg"),
    xl: $5ea5377d270687ca$var$getSize("xl"),
    "2xl": $5ea5377d270687ca$var$getSize("2xl"),
    "3xl": $5ea5377d270687ca$var$getSize("3xl"),
    "4xl": $5ea5377d270687ca$var$getSize("4xl"),
    "5xl": $5ea5377d270687ca$var$getSize("5xl"),
    "6xl": $5ea5377d270687ca$var$getSize("6xl"),
    full: $5ea5377d270687ca$var$getSize("full")
};
const $5ea5377d270687ca$export$158ae9a07be41c05 = $5ea5377d270687ca$var$defineMultiStyleConfig({
    baseStyle: $5ea5377d270687ca$var$baseStyle,
    sizes: $5ea5377d270687ca$var$sizes,
    defaultProps: {
        size: "md"
    }
});




function $ee96c6227c318ff4$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $ee96c6227c318ff4$export$3f283ac14831e759(value) {
    return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function $ee96c6227c318ff4$export$e90fb89750dba83f(value) {
    return value != null && value - parseFloat(value) + 1 >= 0;
}
function $ee96c6227c318ff4$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $ee96c6227c318ff4$export$4c0262a4f954db45(value) {
    return $ee96c6227c318ff4$export$43bee75e5e14138e(value) && value.length === 0;
}
function $ee96c6227c318ff4$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $ee96c6227c318ff4$export$4e62c701997796c1(value) {
    return typeof value !== "undefined" && value !== void 0;
}
function $ee96c6227c318ff4$export$fce6876652108ab(value) {
    return typeof value === "undefined" || value === void 0;
}
function $ee96c6227c318ff4$export$a6cdc56e425d0d0a(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !$ee96c6227c318ff4$export$43bee75e5e14138e(value);
}
function $ee96c6227c318ff4$export$83b788b1a3698c03(value) {
    return $ee96c6227c318ff4$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $ee96c6227c318ff4$export$630801d484da15df(value) {
    return value == null;
}
function $ee96c6227c318ff4$export$844ec244b1367d54(value) {
    return Object.prototype.toString.call(value) === "[object String]";
}
function $ee96c6227c318ff4$export$30a9abfd5fb9f5f6(value) {
    return /^var\(--.+\)$/.test(value);
}
function $ee96c6227c318ff4$export$dd1bc94b04021eeb(value) {
    if ($ee96c6227c318ff4$export$43bee75e5e14138e(value)) return $ee96c6227c318ff4$export$4c0262a4f954db45(value);
    if ($ee96c6227c318ff4$export$a6cdc56e425d0d0a(value)) return $ee96c6227c318ff4$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
function $ee96c6227c318ff4$export$dedd81df7bc1307(val) {
    return "current" in val;
}
function $ee96c6227c318ff4$export$4215e022093e324e(value) {
    return value && $ee96c6227c318ff4$export$a6cdc56e425d0d0a(value) && $ee96c6227c318ff4$export$a6cdc56e425d0d0a(value.target);
}


function $dbe04e73e897103d$var$toRef(operand) {
    if ((0, $ee96c6227c318ff4$export$a6cdc56e425d0d0a)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
const $dbe04e73e897103d$var$toExpr = (operator, ...operands)=>operands.map($dbe04e73e897103d$var$toRef).join(` ${operator} `).replace(/calc/g, "");
const $dbe04e73e897103d$var$add = (...operands)=>`calc(${$dbe04e73e897103d$var$toExpr("+", ...operands)})`;
const $dbe04e73e897103d$var$subtract = (...operands)=>`calc(${$dbe04e73e897103d$var$toExpr("-", ...operands)})`;
const $dbe04e73e897103d$var$multiply = (...operands)=>`calc(${$dbe04e73e897103d$var$toExpr("*", ...operands)})`;
const $dbe04e73e897103d$var$divide = (...operands)=>`calc(${$dbe04e73e897103d$var$toExpr("/", ...operands)})`;
const $dbe04e73e897103d$var$negate = (x)=>{
    const value = $dbe04e73e897103d$var$toRef(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    return $dbe04e73e897103d$var$multiply(value, -1);
};
const $dbe04e73e897103d$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: (...operands)=>$dbe04e73e897103d$export$42bfa9b2d4dad91a($dbe04e73e897103d$var$add(x, ...operands)),
        subtract: (...operands)=>$dbe04e73e897103d$export$42bfa9b2d4dad91a($dbe04e73e897103d$var$subtract(x, ...operands)),
        multiply: (...operands)=>$dbe04e73e897103d$export$42bfa9b2d4dad91a($dbe04e73e897103d$var$multiply(x, ...operands)),
        divide: (...operands)=>$dbe04e73e897103d$export$42bfa9b2d4dad91a($dbe04e73e897103d$var$divide(x, ...operands)),
        negate: ()=>$dbe04e73e897103d$export$42bfa9b2d4dad91a($dbe04e73e897103d$var$negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $dbe04e73e897103d$var$add,
    subtract: $dbe04e73e897103d$var$subtract,
    multiply: $dbe04e73e897103d$var$multiply,
    divide: $dbe04e73e897103d$var$divide,
    negate: $dbe04e73e897103d$var$negate
});


const $f05894c954e333ef$export$2e2bcd8739ae039 = {
    letterSpacings: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
    },
    lineHeights: {
        normal: "normal",
        none: 1,
        shorter: 1.25,
        short: 1.375,
        base: 1.5,
        tall: 1.625,
        taller: "2",
        "3": ".75rem",
        "4": "1rem",
        "5": "1.25rem",
        "6": "1.5rem",
        "7": "1.75rem",
        "8": "2rem",
        "9": "2.25rem",
        "10": "2.5rem"
    },
    fontWeights: {
        hairline: 100,
        thin: 200,
        light: 300,
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
        black: 900
    },
    fonts: {
        heading: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        body: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`
    },
    fontSizes: {
        "3xs": "0.45rem",
        "2xs": "0.625rem",
        xs: "0.75rem",
        sm: "0.875rem",
        md: "1rem",
        lg: "1.125rem",
        xl: "1.25rem",
        "2xl": "1.5rem",
        "3xl": "1.875rem",
        "4xl": "2.25rem",
        "5xl": "3rem",
        "6xl": "3.75rem",
        "7xl": "4.5rem",
        "8xl": "6rem",
        "9xl": "8rem"
    }
};




const { defineMultiStyleConfig: $f8594d8ba3060cee$var$defineMultiStyleConfig, definePartsStyle: $f8594d8ba3060cee$var$definePartsStyle } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$859cc7ca3200df97).keys);
const $f8594d8ba3060cee$var$$stepperWidth = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("number-input-stepper-width");
const $f8594d8ba3060cee$var$$inputPadding = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("number-input-input-padding");
const $f8594d8ba3060cee$var$inputPaddingValue = (0, $dbe04e73e897103d$export$42bfa9b2d4dad91a)($f8594d8ba3060cee$var$$stepperWidth).add("0.5rem").toString();
const $f8594d8ba3060cee$var$$bg = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("number-input-bg");
const $f8594d8ba3060cee$var$$fg = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("number-input-color");
const $f8594d8ba3060cee$var$$border = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("number-input-border-color");
const $f8594d8ba3060cee$var$baseStyleRoot = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    [$f8594d8ba3060cee$var$$stepperWidth.variable]: "sizes.6",
    [$f8594d8ba3060cee$var$$inputPadding.variable]: $f8594d8ba3060cee$var$inputPaddingValue
});
const $f8594d8ba3060cee$var$baseStyleField = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>(0, $97561ccf56589493$export$624e501d81f5ffce)((0, $784186043f2fed12$export$b1b9f3bced726e54).baseStyle, props)?.field ?? {});
const $f8594d8ba3060cee$var$baseStyleStepperGroup = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    width: $f8594d8ba3060cee$var$$stepperWidth.reference
});
const $f8594d8ba3060cee$var$baseStyleStepper = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    borderStart: "1px solid",
    borderStartColor: $f8594d8ba3060cee$var$$border.reference,
    color: $f8594d8ba3060cee$var$$fg.reference,
    bg: $f8594d8ba3060cee$var$$bg.reference,
    [$f8594d8ba3060cee$var$$fg.variable]: "colors.chakra-body-text",
    [$f8594d8ba3060cee$var$$border.variable]: "colors.chakra-border-color",
    _dark: {
        [$f8594d8ba3060cee$var$$fg.variable]: "colors.whiteAlpha.800",
        [$f8594d8ba3060cee$var$$border.variable]: "colors.whiteAlpha.300"
    },
    _active: {
        [$f8594d8ba3060cee$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$f8594d8ba3060cee$var$$bg.variable]: "colors.whiteAlpha.300"
        }
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    }
});
const $f8594d8ba3060cee$var$baseStyle = $f8594d8ba3060cee$var$definePartsStyle((props)=>({
        root: $f8594d8ba3060cee$var$baseStyleRoot,
        field: (0, $97561ccf56589493$export$624e501d81f5ffce)($f8594d8ba3060cee$var$baseStyleField, props) ?? {},
        stepperGroup: $f8594d8ba3060cee$var$baseStyleStepperGroup,
        stepper: $f8594d8ba3060cee$var$baseStyleStepper
    }));
function $f8594d8ba3060cee$var$getSize(size) {
    const sizeStyle = (0, $784186043f2fed12$export$b1b9f3bced726e54).sizes?.[size];
    const radius = {
        lg: "md",
        md: "md",
        sm: "sm",
        xs: "sm"
    };
    const _fontSize = sizeStyle.field?.fontSize ?? "md";
    const fontSize = (0, $f05894c954e333ef$export$2e2bcd8739ae039).fontSizes[_fontSize];
    return $f8594d8ba3060cee$var$definePartsStyle({
        field: {
            ...sizeStyle.field,
            paddingInlineEnd: $f8594d8ba3060cee$var$$inputPadding.reference,
            verticalAlign: "top"
        },
        stepper: {
            fontSize: (0, $dbe04e73e897103d$export$42bfa9b2d4dad91a)(fontSize).multiply(0.75).toString(),
            _first: {
                borderTopEndRadius: radius[size]
            },
            _last: {
                borderBottomEndRadius: radius[size],
                mt: "-1px",
                borderTopWidth: 1
            }
        }
    });
}
const $f8594d8ba3060cee$var$sizes = {
    xs: $f8594d8ba3060cee$var$getSize("xs"),
    sm: $f8594d8ba3060cee$var$getSize("sm"),
    md: $f8594d8ba3060cee$var$getSize("md"),
    lg: $f8594d8ba3060cee$var$getSize("lg")
};
const $f8594d8ba3060cee$export$b9bc5fa6e7f960a1 = $f8594d8ba3060cee$var$defineMultiStyleConfig({
    baseStyle: $f8594d8ba3060cee$var$baseStyle,
    sizes: $f8594d8ba3060cee$var$sizes,
    variants: (0, $784186043f2fed12$export$b1b9f3bced726e54).variants,
    defaultProps: (0, $784186043f2fed12$export$b1b9f3bced726e54).defaultProps
});





const $030673c1bddca1df$var$baseStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    ...(0, $784186043f2fed12$export$b1b9f3bced726e54).baseStyle?.field,
    textAlign: "center"
});
const $030673c1bddca1df$var$sizes = {
    lg: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        fontSize: "lg",
        w: 12,
        h: 12,
        borderRadius: "md"
    }),
    md: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        fontSize: "md",
        w: 10,
        h: 10,
        borderRadius: "md"
    }),
    sm: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        fontSize: "sm",
        w: 8,
        h: 8,
        borderRadius: "sm"
    }),
    xs: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        fontSize: "xs",
        w: 6,
        h: 6,
        borderRadius: "sm"
    })
};
const $030673c1bddca1df$var$variants = {
    outline: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>(0, $97561ccf56589493$export$624e501d81f5ffce)((0, $784186043f2fed12$export$b1b9f3bced726e54).variants?.outline, props)?.field ?? {}),
    flushed: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>(0, $97561ccf56589493$export$624e501d81f5ffce)((0, $784186043f2fed12$export$b1b9f3bced726e54).variants?.flushed, props)?.field ?? {}),
    filled: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>(0, $97561ccf56589493$export$624e501d81f5ffce)((0, $784186043f2fed12$export$b1b9f3bced726e54).variants?.filled, props)?.field ?? {}),
    unstyled: (0, $784186043f2fed12$export$b1b9f3bced726e54).variants?.unstyled.field ?? {}
};
const $030673c1bddca1df$export$8504c22c55a552e0 = (0, $72fdfa583ecf837c$export$5c9a64458a4ed8a4)({
    baseStyle: $030673c1bddca1df$var$baseStyle,
    sizes: $030673c1bddca1df$var$sizes,
    variants: $030673c1bddca1df$var$variants,
    defaultProps: (0, $784186043f2fed12$export$b1b9f3bced726e54).defaultProps
});





const { defineMultiStyleConfig: $8c8c475f6e0a754e$var$defineMultiStyleConfig, definePartsStyle: $8c8c475f6e0a754e$var$definePartsStyle } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$afda07d12cd4337d).keys);
const $8c8c475f6e0a754e$var$$popperBg = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("popper-bg");
const $8c8c475f6e0a754e$var$$arrowBg = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("popper-arrow-bg");
const $8c8c475f6e0a754e$var$$arrowShadowColor = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("popper-arrow-shadow-color");
const $8c8c475f6e0a754e$var$baseStylePopper = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    zIndex: "popover"
});
const $8c8c475f6e0a754e$var$baseStyleContent = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    [$8c8c475f6e0a754e$var$$popperBg.variable]: `colors.white`,
    bg: $8c8c475f6e0a754e$var$$popperBg.reference,
    [$8c8c475f6e0a754e$var$$arrowBg.variable]: $8c8c475f6e0a754e$var$$popperBg.reference,
    [$8c8c475f6e0a754e$var$$arrowShadowColor.variable]: `colors.gray.200`,
    _dark: {
        [$8c8c475f6e0a754e$var$$popperBg.variable]: `colors.gray.700`,
        [$8c8c475f6e0a754e$var$$arrowShadowColor.variable]: `colors.whiteAlpha.300`
    },
    width: "xs",
    border: "1px solid",
    borderColor: "inherit",
    borderRadius: "md",
    boxShadow: "sm",
    zIndex: "inherit",
    _focusVisible: {
        outline: 0,
        boxShadow: "outline"
    }
});
const $8c8c475f6e0a754e$var$baseStyleHeader = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2,
    borderBottomWidth: "1px"
});
const $8c8c475f6e0a754e$var$baseStyleBody = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2
});
const $8c8c475f6e0a754e$var$baseStyleFooter = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2,
    borderTopWidth: "1px"
});
const $8c8c475f6e0a754e$var$baseStyleCloseButton = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    position: "absolute",
    borderRadius: "md",
    top: 1,
    insetEnd: 2,
    padding: 2
});
const $8c8c475f6e0a754e$var$baseStyle = $8c8c475f6e0a754e$var$definePartsStyle({
    popper: $8c8c475f6e0a754e$var$baseStylePopper,
    content: $8c8c475f6e0a754e$var$baseStyleContent,
    header: $8c8c475f6e0a754e$var$baseStyleHeader,
    body: $8c8c475f6e0a754e$var$baseStyleBody,
    footer: $8c8c475f6e0a754e$var$baseStyleFooter,
    closeButton: $8c8c475f6e0a754e$var$baseStyleCloseButton
});
const $8c8c475f6e0a754e$export$135f12f777be1ef7 = $8c8c475f6e0a754e$var$defineMultiStyleConfig({
    baseStyle: $8c8c475f6e0a754e$var$baseStyle
});





const { defineMultiStyleConfig: $a63448f63006079b$var$defineMultiStyleConfig, definePartsStyle: $a63448f63006079b$var$definePartsStyle } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$ba6328c242bd649c).keys);
const $a63448f63006079b$var$filledStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: t, isIndeterminate: isIndeterminate, hasStripe: hasStripe } = props;
    const stripeStyle = (0, $e5881595af47b095$export$549ff81930776885)((0, $f3aed9929b079adb$export$db0ffb03ee9f3080)(), (0, $f3aed9929b079adb$export$db0ffb03ee9f3080)("1rem", "rgba(0,0,0,0.1)"))(props);
    const bgColor = (0, $e5881595af47b095$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props);
    const gradient = `linear-gradient(
    to right,
    transparent 0%,
    ${(0, $f3aed9929b079adb$export$5551a2d24ff40153)(t, bgColor)} 50%,
    transparent 100%
  )`;
    const addStripe = !isIndeterminate && hasStripe;
    return {
        ...addStripe && stripeStyle,
        ...isIndeterminate ? {
            bgImage: gradient
        } : {
            bgColor: bgColor
        }
    };
});
const $a63448f63006079b$var$baseStyleLabel = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    lineHeight: "1",
    fontSize: "0.25em",
    fontWeight: "bold",
    color: "white"
});
const $a63448f63006079b$var$baseStyleTrack = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    return {
        bg: (0, $e5881595af47b095$export$549ff81930776885)("gray.100", "whiteAlpha.300")(props)
    };
});
const $a63448f63006079b$var$baseStyleFilledTrack = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    return {
        transitionProperty: "common",
        transitionDuration: "slow",
        ...$a63448f63006079b$var$filledStyle(props)
    };
});
const $a63448f63006079b$var$baseStyle = $a63448f63006079b$var$definePartsStyle((props)=>({
        label: $a63448f63006079b$var$baseStyleLabel,
        filledTrack: $a63448f63006079b$var$baseStyleFilledTrack(props),
        track: $a63448f63006079b$var$baseStyleTrack(props)
    }));
const $a63448f63006079b$var$sizes = {
    xs: $a63448f63006079b$var$definePartsStyle({
        track: {
            h: "1"
        }
    }),
    sm: $a63448f63006079b$var$definePartsStyle({
        track: {
            h: "2"
        }
    }),
    md: $a63448f63006079b$var$definePartsStyle({
        track: {
            h: "3"
        }
    }),
    lg: $a63448f63006079b$var$definePartsStyle({
        track: {
            h: "4"
        }
    })
};
const $a63448f63006079b$export$dc04d8e6a17afea1 = $a63448f63006079b$var$defineMultiStyleConfig({
    sizes: $a63448f63006079b$var$sizes,
    baseStyle: $a63448f63006079b$var$baseStyle,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});






const { defineMultiStyleConfig: $8ce8f1f3c8621e83$var$defineMultiStyleConfig, definePartsStyle: $8ce8f1f3c8621e83$var$definePartsStyle } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$d28d06d0e29ef022).keys);
const $8ce8f1f3c8621e83$var$baseStyleControl = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const controlStyle = (0, $97561ccf56589493$export$624e501d81f5ffce)((0, $73c7ff1048be51eb$export$86286d8c37984115).baseStyle, props)?.control;
    return {
        ...controlStyle,
        borderRadius: "full",
        _checked: {
            ...controlStyle?.["_checked"],
            _before: {
                content: `""`,
                display: "inline-block",
                pos: "relative",
                w: "50%",
                h: "50%",
                borderRadius: "50%",
                bg: "currentColor"
            }
        }
    };
});
const $8ce8f1f3c8621e83$var$baseStyle = $8ce8f1f3c8621e83$var$definePartsStyle((props)=>({
        label: (0, $73c7ff1048be51eb$export$86286d8c37984115).baseStyle?.(props).label,
        container: (0, $73c7ff1048be51eb$export$86286d8c37984115).baseStyle?.(props).container,
        control: $8ce8f1f3c8621e83$var$baseStyleControl(props)
    }));
const $8ce8f1f3c8621e83$var$sizes = {
    md: $8ce8f1f3c8621e83$var$definePartsStyle({
        control: {
            w: "4",
            h: "4"
        },
        label: {
            fontSize: "md"
        }
    }),
    lg: $8ce8f1f3c8621e83$var$definePartsStyle({
        control: {
            w: "5",
            h: "5"
        },
        label: {
            fontSize: "lg"
        }
    }),
    sm: $8ce8f1f3c8621e83$var$definePartsStyle({
        control: {
            width: "3",
            height: "3"
        },
        label: {
            fontSize: "sm"
        }
    })
};
const $8ce8f1f3c8621e83$export$f0b387b940941887 = $8ce8f1f3c8621e83$var$defineMultiStyleConfig({
    baseStyle: $8ce8f1f3c8621e83$var$baseStyle,
    sizes: $8ce8f1f3c8621e83$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});





const { defineMultiStyleConfig: $e135b6e1e9e3c892$var$defineMultiStyleConfig, definePartsStyle: $e135b6e1e9e3c892$var$definePartsStyle } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$17993f0be9538b5a).keys);
const $e135b6e1e9e3c892$var$$bg = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("select-bg");
const $e135b6e1e9e3c892$var$baseStyleField = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    ...(0, $784186043f2fed12$export$b1b9f3bced726e54).baseStyle?.field,
    appearance: "none",
    paddingBottom: "1px",
    lineHeight: "normal",
    bg: $e135b6e1e9e3c892$var$$bg.reference,
    [$e135b6e1e9e3c892$var$$bg.variable]: "colors.white",
    _dark: {
        [$e135b6e1e9e3c892$var$$bg.variable]: "colors.gray.700"
    },
    "> option, > optgroup": {
        bg: $e135b6e1e9e3c892$var$$bg.reference
    }
});
const $e135b6e1e9e3c892$var$baseStyleIcon = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    width: "6",
    height: "100%",
    insetEnd: "2",
    position: "relative",
    color: "currentColor",
    fontSize: "xl",
    _disabled: {
        opacity: 0.5
    }
});
const $e135b6e1e9e3c892$var$baseStyle = $e135b6e1e9e3c892$var$definePartsStyle({
    field: $e135b6e1e9e3c892$var$baseStyleField,
    icon: $e135b6e1e9e3c892$var$baseStyleIcon
});
const $e135b6e1e9e3c892$var$iconSpacing = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    paddingInlineEnd: "8"
});
const $e135b6e1e9e3c892$var$sizes = {
    lg: {
        ...(0, $784186043f2fed12$export$b1b9f3bced726e54).sizes?.lg,
        field: {
            ...(0, $784186043f2fed12$export$b1b9f3bced726e54).sizes?.lg.field,
            ...$e135b6e1e9e3c892$var$iconSpacing
        }
    },
    md: {
        ...(0, $784186043f2fed12$export$b1b9f3bced726e54).sizes?.md,
        field: {
            ...(0, $784186043f2fed12$export$b1b9f3bced726e54).sizes?.md.field,
            ...$e135b6e1e9e3c892$var$iconSpacing
        }
    },
    sm: {
        ...(0, $784186043f2fed12$export$b1b9f3bced726e54).sizes?.sm,
        field: {
            ...(0, $784186043f2fed12$export$b1b9f3bced726e54).sizes?.sm.field,
            ...$e135b6e1e9e3c892$var$iconSpacing
        }
    },
    xs: {
        ...(0, $784186043f2fed12$export$b1b9f3bced726e54).sizes?.xs,
        field: {
            ...(0, $784186043f2fed12$export$b1b9f3bced726e54).sizes?.xs.field,
            ...$e135b6e1e9e3c892$var$iconSpacing
        },
        icon: {
            insetEnd: "1"
        }
    }
};
const $e135b6e1e9e3c892$export$21af0fc3c16183e1 = $e135b6e1e9e3c892$var$defineMultiStyleConfig({
    baseStyle: $e135b6e1e9e3c892$var$baseStyle,
    sizes: $e135b6e1e9e3c892$var$sizes,
    variants: (0, $784186043f2fed12$export$b1b9f3bced726e54).variants,
    defaultProps: (0, $784186043f2fed12$export$b1b9f3bced726e54).defaultProps
});



const $2977b16c79f64fa6$var$$startColor = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("skeleton-start-color");
const $2977b16c79f64fa6$var$$endColor = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("skeleton-end-color");
const $2977b16c79f64fa6$var$baseStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    [$2977b16c79f64fa6$var$$startColor.variable]: "colors.gray.100",
    [$2977b16c79f64fa6$var$$endColor.variable]: "colors.gray.400",
    _dark: {
        [$2977b16c79f64fa6$var$$startColor.variable]: "colors.gray.800",
        [$2977b16c79f64fa6$var$$endColor.variable]: "colors.gray.600"
    },
    background: $2977b16c79f64fa6$var$$startColor.reference,
    borderColor: $2977b16c79f64fa6$var$$endColor.reference,
    opacity: 0.7,
    borderRadius: "sm"
});
const $2977b16c79f64fa6$export$7680371ad2d79142 = (0, $72fdfa583ecf837c$export$5c9a64458a4ed8a4)({
    baseStyle: $2977b16c79f64fa6$var$baseStyle
});



const $389d33e698508b2a$var$$bg = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("skip-link-bg");
const $389d33e698508b2a$var$baseStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    fontWeight: "semibold",
    _focusVisible: {
        boxShadow: "outline",
        padding: "4",
        position: "fixed",
        top: "6",
        insetStart: "6",
        [$389d33e698508b2a$var$$bg.variable]: "colors.white",
        _dark: {
            [$389d33e698508b2a$var$$bg.variable]: "colors.gray.700"
        },
        bg: $389d33e698508b2a$var$$bg.reference
    }
});
const $389d33e698508b2a$export$a8cf3228ef52959 = (0, $72fdfa583ecf837c$export$5c9a64458a4ed8a4)({
    baseStyle: $389d33e698508b2a$var$baseStyle
});




function $fc947a413c6e9a5d$var$resolveReference(operand) {
    if ((0, $ee96c6227c318ff4$export$a6cdc56e425d0d0a)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
const $fc947a413c6e9a5d$var$toExpression = (operator, ...operands)=>operands.map($fc947a413c6e9a5d$var$resolveReference).join(` ${operator} `).replace(/calc/g, "");
const $fc947a413c6e9a5d$var$add = (...operands)=>`calc(${$fc947a413c6e9a5d$var$toExpression("+", ...operands)})`;
const $fc947a413c6e9a5d$var$subtract = (...operands)=>`calc(${$fc947a413c6e9a5d$var$toExpression("-", ...operands)})`;
const $fc947a413c6e9a5d$var$multiply = (...operands)=>`calc(${$fc947a413c6e9a5d$var$toExpression("*", ...operands)})`;
const $fc947a413c6e9a5d$var$divide = (...operands)=>`calc(${$fc947a413c6e9a5d$var$toExpression("/", ...operands)})`;
const $fc947a413c6e9a5d$var$negate = (x)=>{
    const value = $fc947a413c6e9a5d$var$resolveReference(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    return $fc947a413c6e9a5d$var$multiply(value, -1);
};
const $fc947a413c6e9a5d$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: (...operands)=>$fc947a413c6e9a5d$export$42bfa9b2d4dad91a($fc947a413c6e9a5d$var$add(x, ...operands)),
        subtract: (...operands)=>$fc947a413c6e9a5d$export$42bfa9b2d4dad91a($fc947a413c6e9a5d$var$subtract(x, ...operands)),
        multiply: (...operands)=>$fc947a413c6e9a5d$export$42bfa9b2d4dad91a($fc947a413c6e9a5d$var$multiply(x, ...operands)),
        divide: (...operands)=>$fc947a413c6e9a5d$export$42bfa9b2d4dad91a($fc947a413c6e9a5d$var$divide(x, ...operands)),
        negate: ()=>$fc947a413c6e9a5d$export$42bfa9b2d4dad91a($fc947a413c6e9a5d$var$negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $fc947a413c6e9a5d$var$add,
    subtract: $fc947a413c6e9a5d$var$subtract,
    multiply: $fc947a413c6e9a5d$var$multiply,
    divide: $fc947a413c6e9a5d$var$divide,
    negate: $fc947a413c6e9a5d$var$negate
});



const { defineMultiStyleConfig: $9d24530876c6a189$var$defineMultiStyleConfig, definePartsStyle: $9d24530876c6a189$var$definePartsStyle } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$c21b4b3f8b239f32).keys);
const $9d24530876c6a189$var$$thumbSize = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("slider-thumb-size");
const $9d24530876c6a189$var$$trackSize = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("slider-track-size");
const $9d24530876c6a189$var$$bg = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("slider-bg");
const $9d24530876c6a189$var$baseStyleContainer = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    return {
        display: "inline-block",
        position: "relative",
        cursor: "pointer",
        _disabled: {
            opacity: 0.6,
            cursor: "default",
            pointerEvents: "none"
        },
        ...(0, $e5881595af47b095$export$f3eec17ee6065eee)({
            orientation: orientation,
            vertical: {
                h: "100%",
                px: (0, $fc947a413c6e9a5d$export$42bfa9b2d4dad91a)($9d24530876c6a189$var$$thumbSize.reference).divide(2).toString()
            },
            horizontal: {
                w: "100%",
                py: (0, $fc947a413c6e9a5d$export$42bfa9b2d4dad91a)($9d24530876c6a189$var$$thumbSize.reference).divide(2).toString()
            }
        })
    };
});
const $9d24530876c6a189$var$baseStyleTrack = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const orientationStyles = (0, $e5881595af47b095$export$f3eec17ee6065eee)({
        orientation: props.orientation,
        horizontal: {
            h: $9d24530876c6a189$var$$trackSize.reference
        },
        vertical: {
            w: $9d24530876c6a189$var$$trackSize.reference
        }
    });
    return {
        ...orientationStyles,
        overflow: "hidden",
        borderRadius: "sm",
        [$9d24530876c6a189$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$9d24530876c6a189$var$$bg.variable]: "colors.whiteAlpha.200"
        },
        _disabled: {
            [$9d24530876c6a189$var$$bg.variable]: "colors.gray.300",
            _dark: {
                [$9d24530876c6a189$var$$bg.variable]: "colors.whiteAlpha.300"
            }
        },
        bg: $9d24530876c6a189$var$$bg.reference
    };
});
const $9d24530876c6a189$var$baseStyleThumb = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    const orientationStyle = (0, $e5881595af47b095$export$f3eec17ee6065eee)({
        orientation: orientation,
        vertical: {
            left: "50%",
            transform: `translateX(-50%)`,
            _active: {
                transform: `translateX(-50%) scale(1.15)`
            }
        },
        horizontal: {
            top: "50%",
            transform: `translateY(-50%)`,
            _active: {
                transform: `translateY(-50%) scale(1.15)`
            }
        }
    });
    return {
        ...orientationStyle,
        w: $9d24530876c6a189$var$$thumbSize.reference,
        h: $9d24530876c6a189$var$$thumbSize.reference,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        outline: 0,
        zIndex: 1,
        borderRadius: "full",
        bg: "white",
        boxShadow: "base",
        border: "1px solid",
        borderColor: "transparent",
        transitionProperty: "transform",
        transitionDuration: "normal",
        _focusVisible: {
            boxShadow: "outline"
        },
        _disabled: {
            bg: "gray.300"
        }
    };
});
const $9d24530876c6a189$var$baseStyleFilledTrack = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        width: "inherit",
        height: "inherit",
        [$9d24530876c6a189$var$$bg.variable]: `colors.${c}.500`,
        _dark: {
            [$9d24530876c6a189$var$$bg.variable]: `colors.${c}.200`
        },
        bg: $9d24530876c6a189$var$$bg.reference
    };
});
const $9d24530876c6a189$var$baseStyle = $9d24530876c6a189$var$definePartsStyle((props)=>({
        container: $9d24530876c6a189$var$baseStyleContainer(props),
        track: $9d24530876c6a189$var$baseStyleTrack(props),
        thumb: $9d24530876c6a189$var$baseStyleThumb(props),
        filledTrack: $9d24530876c6a189$var$baseStyleFilledTrack(props)
    }));
const $9d24530876c6a189$var$sizeLg = $9d24530876c6a189$var$definePartsStyle({
    container: {
        [$9d24530876c6a189$var$$thumbSize.variable]: `sizes.4`,
        [$9d24530876c6a189$var$$trackSize.variable]: `sizes.1`
    }
});
const $9d24530876c6a189$var$sizeMd = $9d24530876c6a189$var$definePartsStyle({
    container: {
        [$9d24530876c6a189$var$$thumbSize.variable]: `sizes.3.5`,
        [$9d24530876c6a189$var$$trackSize.variable]: `sizes.1`
    }
});
const $9d24530876c6a189$var$sizeSm = $9d24530876c6a189$var$definePartsStyle({
    container: {
        [$9d24530876c6a189$var$$thumbSize.variable]: `sizes.2.5`,
        [$9d24530876c6a189$var$$trackSize.variable]: `sizes.0.5`
    }
});
const $9d24530876c6a189$var$sizes = {
    lg: $9d24530876c6a189$var$sizeLg,
    md: $9d24530876c6a189$var$sizeMd,
    sm: $9d24530876c6a189$var$sizeSm
};
const $9d24530876c6a189$export$fff8df8fd8e1ed6f = $9d24530876c6a189$var$defineMultiStyleConfig({
    baseStyle: $9d24530876c6a189$var$baseStyle,
    sizes: $9d24530876c6a189$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});




const $6d11ea28d5000747$var$$size = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("spinner-size");
const $6d11ea28d5000747$var$baseStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    width: [
        $6d11ea28d5000747$var$$size.reference
    ],
    height: [
        $6d11ea28d5000747$var$$size.reference
    ]
});
const $6d11ea28d5000747$var$sizes = {
    xs: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        [$6d11ea28d5000747$var$$size.variable]: "sizes.3"
    }),
    sm: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        [$6d11ea28d5000747$var$$size.variable]: "sizes.4"
    }),
    md: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        [$6d11ea28d5000747$var$$size.variable]: "sizes.6"
    }),
    lg: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        [$6d11ea28d5000747$var$$size.variable]: "sizes.8"
    }),
    xl: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        [$6d11ea28d5000747$var$$size.variable]: "sizes.12"
    })
};
const $6d11ea28d5000747$export$d76156e68e556d3f = (0, $72fdfa583ecf837c$export$5c9a64458a4ed8a4)({
    baseStyle: $6d11ea28d5000747$var$baseStyle,
    sizes: $6d11ea28d5000747$var$sizes,
    defaultProps: {
        size: "md"
    }
});




const { defineMultiStyleConfig: $b6708541ae5a603e$var$defineMultiStyleConfig, definePartsStyle: $b6708541ae5a603e$var$definePartsStyle } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$2cfbad67ae6ee421).keys);
const $b6708541ae5a603e$var$baseStyleLabel = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    fontWeight: "medium"
});
const $b6708541ae5a603e$var$baseStyleHelpText = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    opacity: 0.8,
    marginBottom: "2"
});
const $b6708541ae5a603e$var$baseStyleNumber = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    verticalAlign: "baseline",
    fontWeight: "semibold"
});
const $b6708541ae5a603e$var$baseStyleIcon = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    marginEnd: 1,
    w: "3.5",
    h: "3.5",
    verticalAlign: "middle"
});
const $b6708541ae5a603e$var$baseStyle = $b6708541ae5a603e$var$definePartsStyle({
    container: {},
    label: $b6708541ae5a603e$var$baseStyleLabel,
    helpText: $b6708541ae5a603e$var$baseStyleHelpText,
    number: $b6708541ae5a603e$var$baseStyleNumber,
    icon: $b6708541ae5a603e$var$baseStyleIcon
});
const $b6708541ae5a603e$var$sizes = {
    md: $b6708541ae5a603e$var$definePartsStyle({
        label: {
            fontSize: "sm"
        },
        helpText: {
            fontSize: "sm"
        },
        number: {
            fontSize: "2xl"
        }
    })
};
const $b6708541ae5a603e$export$f3301eb37a20f09e = $b6708541ae5a603e$var$defineMultiStyleConfig({
    baseStyle: $b6708541ae5a603e$var$baseStyle,
    sizes: $b6708541ae5a603e$var$sizes,
    defaultProps: {
        size: "md"
    }
});



const { defineMultiStyleConfig: $b845893e40ea7d0a$var$defineMultiStyleConfig, definePartsStyle: $b845893e40ea7d0a$var$definePartsStyle } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)([
    "stepper",
    "step",
    "title",
    "description",
    "indicator",
    "separator",
    "icon",
    "number"
]);
const $b845893e40ea7d0a$var$$size = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("stepper-indicator-size");
const $b845893e40ea7d0a$var$$iconSize = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("stepper-icon-size");
const $b845893e40ea7d0a$var$$titleFontSize = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("stepper-title-font-size");
const $b845893e40ea7d0a$var$$descFontSize = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("stepper-description-font-size");
const $b845893e40ea7d0a$var$$accentColor = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("stepper-accent-color");
const $b845893e40ea7d0a$var$baseStyle = $b845893e40ea7d0a$var$definePartsStyle(({ colorScheme: c })=>({
        stepper: {
            display: "flex",
            justifyContent: "space-between",
            gap: "4",
            "&[data-orientation=vertical]": {
                flexDirection: "column",
                alignItems: "flex-start"
            },
            "&[data-orientation=horizontal]": {
                flexDirection: "row",
                alignItems: "center"
            },
            [$b845893e40ea7d0a$var$$accentColor.variable]: `colors.${c}.500`,
            _dark: {
                [$b845893e40ea7d0a$var$$accentColor.variable]: `colors.${c}.200`
            }
        },
        title: {
            fontSize: $b845893e40ea7d0a$var$$titleFontSize.reference,
            fontWeight: "medium"
        },
        description: {
            fontSize: $b845893e40ea7d0a$var$$descFontSize.reference,
            color: "chakra-subtle-text"
        },
        number: {
            fontSize: $b845893e40ea7d0a$var$$titleFontSize.reference
        },
        step: {
            flexShrink: 0,
            position: "relative",
            display: "flex",
            gap: "2",
            "&[data-orientation=horizontal]": {
                alignItems: "center"
            },
            flex: "1",
            "&:last-of-type:not([data-stretch])": {
                flex: "initial"
            }
        },
        icon: {
            flexShrink: 0,
            width: $b845893e40ea7d0a$var$$iconSize.reference,
            height: $b845893e40ea7d0a$var$$iconSize.reference
        },
        indicator: {
            flexShrink: 0,
            borderRadius: "full",
            width: $b845893e40ea7d0a$var$$size.reference,
            height: $b845893e40ea7d0a$var$$size.reference,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&[data-status=active]": {
                borderWidth: "2px",
                borderColor: $b845893e40ea7d0a$var$$accentColor.reference
            },
            "&[data-status=complete]": {
                bg: $b845893e40ea7d0a$var$$accentColor.reference,
                color: "chakra-inverse-text"
            },
            "&[data-status=incomplete]": {
                borderWidth: "2px"
            }
        },
        separator: {
            bg: "chakra-border-color",
            flex: "1",
            "&[data-status=complete]": {
                bg: $b845893e40ea7d0a$var$$accentColor.reference
            },
            "&[data-orientation=horizontal]": {
                width: "100%",
                height: "2px",
                marginStart: "2"
            },
            "&[data-orientation=vertical]": {
                width: "2px",
                position: "absolute",
                height: "100%",
                maxHeight: `calc(100% - ${$b845893e40ea7d0a$var$$size.reference} - 8px)`,
                top: `calc(${$b845893e40ea7d0a$var$$size.reference} + 4px)`,
                insetStart: `calc(${$b845893e40ea7d0a$var$$size.reference} / 2 - 1px)`
            }
        }
    }));
const $b845893e40ea7d0a$export$54c84d54375c8d75 = $b845893e40ea7d0a$var$defineMultiStyleConfig({
    baseStyle: $b845893e40ea7d0a$var$baseStyle,
    sizes: {
        xs: $b845893e40ea7d0a$var$definePartsStyle({
            stepper: {
                [$b845893e40ea7d0a$var$$size.variable]: "sizes.4",
                [$b845893e40ea7d0a$var$$iconSize.variable]: "sizes.3",
                [$b845893e40ea7d0a$var$$titleFontSize.variable]: "fontSizes.xs",
                [$b845893e40ea7d0a$var$$descFontSize.variable]: "fontSizes.xs"
            }
        }),
        sm: $b845893e40ea7d0a$var$definePartsStyle({
            stepper: {
                [$b845893e40ea7d0a$var$$size.variable]: "sizes.6",
                [$b845893e40ea7d0a$var$$iconSize.variable]: "sizes.4",
                [$b845893e40ea7d0a$var$$titleFontSize.variable]: "fontSizes.sm",
                [$b845893e40ea7d0a$var$$descFontSize.variable]: "fontSizes.xs"
            }
        }),
        md: $b845893e40ea7d0a$var$definePartsStyle({
            stepper: {
                [$b845893e40ea7d0a$var$$size.variable]: "sizes.8",
                [$b845893e40ea7d0a$var$$iconSize.variable]: "sizes.5",
                [$b845893e40ea7d0a$var$$titleFontSize.variable]: "fontSizes.md",
                [$b845893e40ea7d0a$var$$descFontSize.variable]: "fontSizes.sm"
            }
        }),
        lg: $b845893e40ea7d0a$var$definePartsStyle({
            stepper: {
                [$b845893e40ea7d0a$var$$size.variable]: "sizes.10",
                [$b845893e40ea7d0a$var$$iconSize.variable]: "sizes.6",
                [$b845893e40ea7d0a$var$$titleFontSize.variable]: "fontSizes.lg",
                [$b845893e40ea7d0a$var$$descFontSize.variable]: "fontSizes.md"
            }
        })
    },
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});





const { defineMultiStyleConfig: $796f49695e282fd6$var$defineMultiStyleConfig, definePartsStyle: $796f49695e282fd6$var$definePartsStyle } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$921c1a2d1ce1e86a).keys);
const $796f49695e282fd6$var$$width = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("switch-track-width");
const $796f49695e282fd6$var$$height = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("switch-track-height");
const $796f49695e282fd6$var$$diff = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("switch-track-diff");
const $796f49695e282fd6$var$diffValue = (0, $dbe04e73e897103d$export$42bfa9b2d4dad91a).subtract($796f49695e282fd6$var$$width, $796f49695e282fd6$var$$height);
const $796f49695e282fd6$var$$translateX = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("switch-thumb-x");
const $796f49695e282fd6$var$$bg = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("switch-bg");
const $796f49695e282fd6$var$baseStyleTrack = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        borderRadius: "full",
        p: "0.5",
        width: [
            $796f49695e282fd6$var$$width.reference
        ],
        height: [
            $796f49695e282fd6$var$$height.reference
        ],
        transitionProperty: "common",
        transitionDuration: "fast",
        [$796f49695e282fd6$var$$bg.variable]: "colors.gray.300",
        _dark: {
            [$796f49695e282fd6$var$$bg.variable]: "colors.whiteAlpha.400"
        },
        _focusVisible: {
            boxShadow: "outline"
        },
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        },
        _checked: {
            [$796f49695e282fd6$var$$bg.variable]: `colors.${c}.500`,
            _dark: {
                [$796f49695e282fd6$var$$bg.variable]: `colors.${c}.200`
            }
        },
        bg: $796f49695e282fd6$var$$bg.reference
    };
});
const $796f49695e282fd6$var$baseStyleThumb = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    bg: "white",
    transitionProperty: "transform",
    transitionDuration: "normal",
    borderRadius: "inherit",
    width: [
        $796f49695e282fd6$var$$height.reference
    ],
    height: [
        $796f49695e282fd6$var$$height.reference
    ],
    _checked: {
        transform: `translateX(${$796f49695e282fd6$var$$translateX.reference})`
    }
});
const $796f49695e282fd6$var$baseStyle = $796f49695e282fd6$var$definePartsStyle((props)=>({
        container: {
            [$796f49695e282fd6$var$$diff.variable]: $796f49695e282fd6$var$diffValue,
            [$796f49695e282fd6$var$$translateX.variable]: $796f49695e282fd6$var$$diff.reference,
            _rtl: {
                [$796f49695e282fd6$var$$translateX.variable]: (0, $dbe04e73e897103d$export$42bfa9b2d4dad91a)($796f49695e282fd6$var$$diff).negate().toString()
            }
        },
        track: $796f49695e282fd6$var$baseStyleTrack(props),
        thumb: $796f49695e282fd6$var$baseStyleThumb
    }));
const $796f49695e282fd6$var$sizes = {
    sm: $796f49695e282fd6$var$definePartsStyle({
        container: {
            [$796f49695e282fd6$var$$width.variable]: "1.375rem",
            [$796f49695e282fd6$var$$height.variable]: "sizes.3"
        }
    }),
    md: $796f49695e282fd6$var$definePartsStyle({
        container: {
            [$796f49695e282fd6$var$$width.variable]: "1.875rem",
            [$796f49695e282fd6$var$$height.variable]: "sizes.4"
        }
    }),
    lg: $796f49695e282fd6$var$definePartsStyle({
        container: {
            [$796f49695e282fd6$var$$width.variable]: "2.875rem",
            [$796f49695e282fd6$var$$height.variable]: "sizes.6"
        }
    })
};
const $796f49695e282fd6$export$6856b73e98185bff = $796f49695e282fd6$var$defineMultiStyleConfig({
    baseStyle: $796f49695e282fd6$var$baseStyle,
    sizes: $796f49695e282fd6$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});





const { defineMultiStyleConfig: $185e32c52a242ba2$var$defineMultiStyleConfig, definePartsStyle: $185e32c52a242ba2$var$definePartsStyle } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$8b1b9cdd5db9f5fd).keys);
const $185e32c52a242ba2$var$baseStyle = $185e32c52a242ba2$var$definePartsStyle({
    table: {
        fontVariantNumeric: "lining-nums tabular-nums",
        borderCollapse: "collapse",
        width: "full"
    },
    th: {
        fontFamily: "heading",
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "wider",
        textAlign: "start"
    },
    td: {
        textAlign: "start"
    },
    caption: {
        mt: 4,
        fontFamily: "heading",
        textAlign: "center",
        fontWeight: "medium"
    }
});
const $185e32c52a242ba2$var$numericStyles = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    "&[data-is-numeric=true]": {
        textAlign: "end"
    }
});
const $185e32c52a242ba2$var$variantSimple = $185e32c52a242ba2$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        th: {
            color: (0, $e5881595af47b095$export$549ff81930776885)("gray.600", "gray.400")(props),
            borderBottom: "1px",
            borderColor: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$185e32c52a242ba2$var$numericStyles
        },
        td: {
            borderBottom: "1px",
            borderColor: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$185e32c52a242ba2$var$numericStyles
        },
        caption: {
            color: (0, $e5881595af47b095$export$549ff81930776885)("gray.600", "gray.100")(props)
        },
        tfoot: {
            tr: {
                "&:last-of-type": {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
});
const $185e32c52a242ba2$var$variantStripe = $185e32c52a242ba2$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        th: {
            color: (0, $e5881595af47b095$export$549ff81930776885)("gray.600", "gray.400")(props),
            borderBottom: "1px",
            borderColor: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$185e32c52a242ba2$var$numericStyles
        },
        td: {
            borderBottom: "1px",
            borderColor: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$185e32c52a242ba2$var$numericStyles
        },
        caption: {
            color: (0, $e5881595af47b095$export$549ff81930776885)("gray.600", "gray.100")(props)
        },
        tbody: {
            tr: {
                "&:nth-of-type(odd)": {
                    "th, td": {
                        borderBottomWidth: "1px",
                        borderColor: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props)
                    },
                    td: {
                        background: (0, $e5881595af47b095$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props)
                    }
                }
            }
        },
        tfoot: {
            tr: {
                "&:last-of-type": {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
});
const $185e32c52a242ba2$var$variants = {
    simple: $185e32c52a242ba2$var$variantSimple,
    striped: $185e32c52a242ba2$var$variantStripe,
    unstyled: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({})
};
const $185e32c52a242ba2$var$sizes = {
    sm: $185e32c52a242ba2$var$definePartsStyle({
        th: {
            px: "4",
            py: "1",
            lineHeight: "4",
            fontSize: "xs"
        },
        td: {
            px: "4",
            py: "2",
            fontSize: "sm",
            lineHeight: "4"
        },
        caption: {
            px: "4",
            py: "2",
            fontSize: "xs"
        }
    }),
    md: $185e32c52a242ba2$var$definePartsStyle({
        th: {
            px: "6",
            py: "3",
            lineHeight: "4",
            fontSize: "xs"
        },
        td: {
            px: "6",
            py: "4",
            lineHeight: "5"
        },
        caption: {
            px: "6",
            py: "2",
            fontSize: "sm"
        }
    }),
    lg: $185e32c52a242ba2$var$definePartsStyle({
        th: {
            px: "8",
            py: "4",
            lineHeight: "5",
            fontSize: "sm"
        },
        td: {
            px: "8",
            py: "5",
            lineHeight: "6"
        },
        caption: {
            px: "6",
            py: "2",
            fontSize: "md"
        }
    })
};
const $185e32c52a242ba2$export$3339219781bb5161 = $185e32c52a242ba2$var$defineMultiStyleConfig({
    baseStyle: $185e32c52a242ba2$var$baseStyle,
    variants: $185e32c52a242ba2$var$variants,
    sizes: $185e32c52a242ba2$var$sizes,
    defaultProps: {
        variant: "simple",
        size: "md",
        colorScheme: "gray"
    }
});





const $c64b56df44e30b46$var$$fg = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("tabs-color");
const $c64b56df44e30b46$var$$bg = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("tabs-bg");
const $c64b56df44e30b46$var$$border = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("tabs-border-color");
const { defineMultiStyleConfig: $c64b56df44e30b46$var$defineMultiStyleConfig, definePartsStyle: $c64b56df44e30b46$var$definePartsStyle } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$97383552563be58d).keys);
const $c64b56df44e30b46$var$baseStyleRoot = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    return {
        display: orientation === "vertical" ? "flex" : "block"
    };
});
const $c64b56df44e30b46$var$baseStyleTab = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { isFitted: isFitted } = props;
    return {
        flex: isFitted ? 1 : void 0,
        transitionProperty: "common",
        transitionDuration: "normal",
        _focusVisible: {
            zIndex: 1,
            boxShadow: "outline"
        },
        _disabled: {
            cursor: "not-allowed",
            opacity: 0.4
        }
    };
});
const $c64b56df44e30b46$var$baseStyleTablist = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>{
    const { align: align = "start", orientation: orientation } = props;
    const alignments = {
        end: "flex-end",
        center: "center",
        start: "flex-start"
    };
    return {
        justifyContent: alignments[align],
        flexDirection: orientation === "vertical" ? "column" : "row"
    };
});
const $c64b56df44e30b46$var$baseStyleTabpanel = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    p: 4
});
const $c64b56df44e30b46$var$baseStyle = $c64b56df44e30b46$var$definePartsStyle((props)=>({
        root: $c64b56df44e30b46$var$baseStyleRoot(props),
        tab: $c64b56df44e30b46$var$baseStyleTab(props),
        tablist: $c64b56df44e30b46$var$baseStyleTablist(props),
        tabpanel: $c64b56df44e30b46$var$baseStyleTabpanel
    }));
const $c64b56df44e30b46$var$sizes = {
    sm: $c64b56df44e30b46$var$definePartsStyle({
        tab: {
            py: 1,
            px: 4,
            fontSize: "sm"
        }
    }),
    md: $c64b56df44e30b46$var$definePartsStyle({
        tab: {
            fontSize: "md",
            py: 2,
            px: 4
        }
    }),
    lg: $c64b56df44e30b46$var$definePartsStyle({
        tab: {
            fontSize: "lg",
            py: 3,
            px: 4
        }
    })
};
const $c64b56df44e30b46$var$variantLine = $c64b56df44e30b46$var$definePartsStyle((props)=>{
    const { colorScheme: c, orientation: orientation } = props;
    const isVertical = orientation === "vertical";
    const borderProp = isVertical ? "borderStart" : "borderBottom";
    const marginProp = isVertical ? "marginStart" : "marginBottom";
    return {
        tablist: {
            [borderProp]: "2px solid",
            borderColor: "inherit"
        },
        tab: {
            [borderProp]: "2px solid",
            borderColor: "transparent",
            [marginProp]: "-2px",
            _selected: {
                [$c64b56df44e30b46$var$$fg.variable]: `colors.${c}.600`,
                _dark: {
                    [$c64b56df44e30b46$var$$fg.variable]: `colors.${c}.300`
                },
                borderColor: "currentColor"
            },
            _active: {
                [$c64b56df44e30b46$var$$bg.variable]: "colors.gray.200",
                _dark: {
                    [$c64b56df44e30b46$var$$bg.variable]: "colors.whiteAlpha.300"
                }
            },
            _disabled: {
                _active: {
                    bg: "none"
                }
            },
            color: $c64b56df44e30b46$var$$fg.reference,
            bg: $c64b56df44e30b46$var$$bg.reference
        }
    };
});
const $c64b56df44e30b46$var$variantEnclosed = $c64b56df44e30b46$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            borderTopRadius: "md",
            border: "1px solid",
            borderColor: "transparent",
            mb: "-1px",
            [$c64b56df44e30b46$var$$border.variable]: "transparent",
            _selected: {
                [$c64b56df44e30b46$var$$fg.variable]: `colors.${c}.600`,
                [$c64b56df44e30b46$var$$border.variable]: `colors.white`,
                _dark: {
                    [$c64b56df44e30b46$var$$fg.variable]: `colors.${c}.300`,
                    [$c64b56df44e30b46$var$$border.variable]: `colors.gray.800`
                },
                borderColor: "inherit",
                borderBottomColor: $c64b56df44e30b46$var$$border.reference
            },
            color: $c64b56df44e30b46$var$$fg.reference
        },
        tablist: {
            mb: "-1px",
            borderBottom: "1px solid",
            borderColor: "inherit"
        }
    };
});
const $c64b56df44e30b46$var$variantEnclosedColored = $c64b56df44e30b46$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            border: "1px solid",
            borderColor: "inherit",
            [$c64b56df44e30b46$var$$bg.variable]: "colors.gray.50",
            _dark: {
                [$c64b56df44e30b46$var$$bg.variable]: "colors.whiteAlpha.50"
            },
            mb: "-1px",
            _notLast: {
                marginEnd: "-1px"
            },
            _selected: {
                [$c64b56df44e30b46$var$$bg.variable]: "colors.white",
                [$c64b56df44e30b46$var$$fg.variable]: `colors.${c}.600`,
                _dark: {
                    [$c64b56df44e30b46$var$$bg.variable]: "colors.gray.800",
                    [$c64b56df44e30b46$var$$fg.variable]: `colors.${c}.300`
                },
                borderColor: "inherit",
                borderTopColor: "currentColor",
                borderBottomColor: "transparent"
            },
            color: $c64b56df44e30b46$var$$fg.reference,
            bg: $c64b56df44e30b46$var$$bg.reference
        },
        tablist: {
            mb: "-1px",
            borderBottom: "1px solid",
            borderColor: "inherit"
        }
    };
});
const $c64b56df44e30b46$var$variantSoftRounded = $c64b56df44e30b46$var$definePartsStyle((props)=>{
    const { colorScheme: c, theme: theme } = props;
    return {
        tab: {
            borderRadius: "full",
            fontWeight: "semibold",
            color: "gray.600",
            _selected: {
                color: (0, $f3aed9929b079adb$export$5551a2d24ff40153)(theme, `${c}.700`),
                bg: (0, $f3aed9929b079adb$export$5551a2d24ff40153)(theme, `${c}.100`)
            }
        }
    };
});
const $c64b56df44e30b46$var$variantSolidRounded = $c64b56df44e30b46$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            borderRadius: "full",
            fontWeight: "semibold",
            [$c64b56df44e30b46$var$$fg.variable]: "colors.gray.600",
            _dark: {
                [$c64b56df44e30b46$var$$fg.variable]: "inherit"
            },
            _selected: {
                [$c64b56df44e30b46$var$$fg.variable]: "colors.white",
                [$c64b56df44e30b46$var$$bg.variable]: `colors.${c}.600`,
                _dark: {
                    [$c64b56df44e30b46$var$$fg.variable]: "colors.gray.800",
                    [$c64b56df44e30b46$var$$bg.variable]: `colors.${c}.300`
                }
            },
            color: $c64b56df44e30b46$var$$fg.reference,
            bg: $c64b56df44e30b46$var$$bg.reference
        }
    };
});
const $c64b56df44e30b46$var$variantUnstyled = $c64b56df44e30b46$var$definePartsStyle({});
const $c64b56df44e30b46$var$variants = {
    line: $c64b56df44e30b46$var$variantLine,
    enclosed: $c64b56df44e30b46$var$variantEnclosed,
    "enclosed-colored": $c64b56df44e30b46$var$variantEnclosedColored,
    "soft-rounded": $c64b56df44e30b46$var$variantSoftRounded,
    "solid-rounded": $c64b56df44e30b46$var$variantSolidRounded,
    unstyled: $c64b56df44e30b46$var$variantUnstyled
};
const $c64b56df44e30b46$export$847a245e7ebce2a1 = $c64b56df44e30b46$var$defineMultiStyleConfig({
    baseStyle: $c64b56df44e30b46$var$baseStyle,
    sizes: $c64b56df44e30b46$var$sizes,
    variants: $c64b56df44e30b46$var$variants,
    defaultProps: {
        size: "md",
        variant: "line",
        colorScheme: "blue"
    }
});





const { defineMultiStyleConfig: $47453cae6f42196f$var$defineMultiStyleConfig, definePartsStyle: $47453cae6f42196f$var$definePartsStyle } = (0, $72fdfa583ecf837c$export$d5f717dc145477b8)((0, $73a5ef2a56a2154e$export$4c2f5f7f2ea94a8e).keys);
const $47453cae6f42196f$var$$bg = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("tag-bg");
const $47453cae6f42196f$var$$color = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("tag-color");
const $47453cae6f42196f$var$$shadow = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("tag-shadow");
const $47453cae6f42196f$var$$minH = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("tag-min-height");
const $47453cae6f42196f$var$$minW = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("tag-min-width");
const $47453cae6f42196f$var$$fontSize = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("tag-font-size");
const $47453cae6f42196f$var$$paddingX = (0, $baa260bb5827f910$export$8b4981022bd80a4e)("tag-padding-inline");
const $47453cae6f42196f$var$baseStyleContainer = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    fontWeight: "medium",
    lineHeight: 1.2,
    outline: 0,
    [$47453cae6f42196f$var$$color.variable]: (0, $abac354712895270$export$947cd287c296b479).color.reference,
    [$47453cae6f42196f$var$$bg.variable]: (0, $abac354712895270$export$947cd287c296b479).bg.reference,
    [$47453cae6f42196f$var$$shadow.variable]: (0, $abac354712895270$export$947cd287c296b479).shadow.reference,
    color: $47453cae6f42196f$var$$color.reference,
    bg: $47453cae6f42196f$var$$bg.reference,
    boxShadow: $47453cae6f42196f$var$$shadow.reference,
    borderRadius: "md",
    minH: $47453cae6f42196f$var$$minH.reference,
    minW: $47453cae6f42196f$var$$minW.reference,
    fontSize: $47453cae6f42196f$var$$fontSize.reference,
    px: $47453cae6f42196f$var$$paddingX.reference,
    _focusVisible: {
        [$47453cae6f42196f$var$$shadow.variable]: "shadows.outline"
    }
});
const $47453cae6f42196f$var$baseStyleLabel = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    lineHeight: 1.2,
    overflow: "visible"
});
const $47453cae6f42196f$var$baseStyleCloseButton = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    fontSize: "lg",
    w: "5",
    h: "5",
    transitionProperty: "common",
    transitionDuration: "normal",
    borderRadius: "full",
    marginStart: "1.5",
    marginEnd: "-1",
    opacity: 0.5,
    _disabled: {
        opacity: 0.4
    },
    _focusVisible: {
        boxShadow: "outline",
        bg: "rgba(0, 0, 0, 0.14)"
    },
    _hover: {
        opacity: 0.8
    },
    _active: {
        opacity: 1
    }
});
const $47453cae6f42196f$var$baseStyle = $47453cae6f42196f$var$definePartsStyle({
    container: $47453cae6f42196f$var$baseStyleContainer,
    label: $47453cae6f42196f$var$baseStyleLabel,
    closeButton: $47453cae6f42196f$var$baseStyleCloseButton
});
const $47453cae6f42196f$var$sizes = {
    sm: $47453cae6f42196f$var$definePartsStyle({
        container: {
            [$47453cae6f42196f$var$$minH.variable]: "sizes.5",
            [$47453cae6f42196f$var$$minW.variable]: "sizes.5",
            [$47453cae6f42196f$var$$fontSize.variable]: "fontSizes.xs",
            [$47453cae6f42196f$var$$paddingX.variable]: "space.2"
        },
        closeButton: {
            marginEnd: "-2px",
            marginStart: "0.35rem"
        }
    }),
    md: $47453cae6f42196f$var$definePartsStyle({
        container: {
            [$47453cae6f42196f$var$$minH.variable]: "sizes.6",
            [$47453cae6f42196f$var$$minW.variable]: "sizes.6",
            [$47453cae6f42196f$var$$fontSize.variable]: "fontSizes.sm",
            [$47453cae6f42196f$var$$paddingX.variable]: "space.2"
        }
    }),
    lg: $47453cae6f42196f$var$definePartsStyle({
        container: {
            [$47453cae6f42196f$var$$minH.variable]: "sizes.8",
            [$47453cae6f42196f$var$$minW.variable]: "sizes.8",
            [$47453cae6f42196f$var$$fontSize.variable]: "fontSizes.md",
            [$47453cae6f42196f$var$$paddingX.variable]: "space.3"
        }
    })
};
const $47453cae6f42196f$var$variants = {
    subtle: $47453cae6f42196f$var$definePartsStyle((props)=>({
            container: (0, $abac354712895270$export$eb6e7cbc82d0f88b).variants?.subtle(props)
        })),
    solid: $47453cae6f42196f$var$definePartsStyle((props)=>({
            container: (0, $abac354712895270$export$eb6e7cbc82d0f88b).variants?.solid(props)
        })),
    outline: $47453cae6f42196f$var$definePartsStyle((props)=>({
            container: (0, $abac354712895270$export$eb6e7cbc82d0f88b).variants?.outline(props)
        }))
};
const $47453cae6f42196f$export$f8ab9ac2a319695b = $47453cae6f42196f$var$defineMultiStyleConfig({
    variants: $47453cae6f42196f$var$variants,
    baseStyle: $47453cae6f42196f$var$baseStyle,
    sizes: $47453cae6f42196f$var$sizes,
    defaultProps: {
        size: "md",
        variant: "subtle",
        colorScheme: "gray"
    }
});




const $42bd8e7524f7cb5e$var$baseStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    ...(0, $784186043f2fed12$export$b1b9f3bced726e54).baseStyle?.field,
    paddingY: "2",
    minHeight: "20",
    lineHeight: "short",
    verticalAlign: "top"
});
const $42bd8e7524f7cb5e$var$variants = {
    outline: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>(0, $784186043f2fed12$export$b1b9f3bced726e54).variants?.outline(props).field ?? {}),
    flushed: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>(0, $784186043f2fed12$export$b1b9f3bced726e54).variants?.flushed(props).field ?? {}),
    filled: (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)((props)=>(0, $784186043f2fed12$export$b1b9f3bced726e54).variants?.filled(props).field ?? {}),
    unstyled: (0, $784186043f2fed12$export$b1b9f3bced726e54).variants?.unstyled.field ?? {}
};
const $42bd8e7524f7cb5e$var$sizes = {
    xs: (0, $784186043f2fed12$export$b1b9f3bced726e54).sizes?.xs.field ?? {},
    sm: (0, $784186043f2fed12$export$b1b9f3bced726e54).sizes?.sm.field ?? {},
    md: (0, $784186043f2fed12$export$b1b9f3bced726e54).sizes?.md.field ?? {},
    lg: (0, $784186043f2fed12$export$b1b9f3bced726e54).sizes?.lg.field ?? {}
};
const $42bd8e7524f7cb5e$export$394b8322fab774c1 = (0, $72fdfa583ecf837c$export$5c9a64458a4ed8a4)({
    baseStyle: $42bd8e7524f7cb5e$var$baseStyle,
    sizes: $42bd8e7524f7cb5e$var$sizes,
    variants: $42bd8e7524f7cb5e$var$variants,
    defaultProps: {
        size: "md",
        variant: "outline"
    }
});




const $b6725ead9d736cab$var$$bg = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("tooltip-bg");
const $b6725ead9d736cab$var$$fg = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("tooltip-fg");
const $b6725ead9d736cab$var$$arrowBg = (0, $5e3b1f5ac021fa20$export$8b4981022bd80a4e)("popper-arrow-bg");
const $b6725ead9d736cab$var$baseStyle = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
    bg: $b6725ead9d736cab$var$$bg.reference,
    color: $b6725ead9d736cab$var$$fg.reference,
    [$b6725ead9d736cab$var$$bg.variable]: "colors.gray.700",
    [$b6725ead9d736cab$var$$fg.variable]: "colors.whiteAlpha.900",
    _dark: {
        [$b6725ead9d736cab$var$$bg.variable]: "colors.gray.300",
        [$b6725ead9d736cab$var$$fg.variable]: "colors.gray.900"
    },
    [$b6725ead9d736cab$var$$arrowBg.variable]: $b6725ead9d736cab$var$$bg.reference,
    px: "2",
    py: "0.5",
    borderRadius: "sm",
    fontWeight: "medium",
    fontSize: "sm",
    boxShadow: "md",
    maxW: "xs",
    zIndex: "tooltip"
});
const $b6725ead9d736cab$export$7472a7883840b563 = (0, $72fdfa583ecf837c$export$5c9a64458a4ed8a4)({
    baseStyle: $b6725ead9d736cab$var$baseStyle
});


const $13b8358de5ab660c$export$9b5ac10f59f76296 = {
    Accordion: (0, $4f3acc954068efea$export$20ec2254f76fa604),
    Alert: (0, $666bd9e41b46c240$export$9d77d9665d829e89),
    Avatar: (0, $4e037b0b726b6770$export$9975d21893c10e66),
    Badge: (0, $abac354712895270$export$eb6e7cbc82d0f88b),
    Breadcrumb: (0, $f188fbf516f46a1a$export$e2d8c6f6af55009),
    Button: (0, $7d7d1be714046c52$export$577deec5d331f6be),
    Checkbox: (0, $73c7ff1048be51eb$export$86286d8c37984115),
    CloseButton: (0, $dc7d80f12e56f3a3$export$47615e5b7f7e315f),
    Code: (0, $f86fc7105e4a17e9$export$f9b9a8633a36e3c7),
    Container: (0, $141d27f87a0bf98a$export$3ca0760d240fe5f4),
    Divider: (0, $0043da67a82d8949$export$f0e91f779c5bb416),
    Drawer: (0, $dd8f405fb0ed04bf$export$8057937c11129602),
    Editable: (0, $5555e8c0d78e172f$export$a09813cbe72349b1),
    Form: (0, $494aa3c4b7c388ab$export$870bcc1d98fee0aa),
    FormError: (0, $51c3bd5bb50af8fe$export$b8d6747e16cd5f4d),
    FormLabel: (0, $d1298c7333328bad$export$c49af69dbfc0c993),
    Heading: (0, $400864f1db9df809$export$5f175074e0f09e7b),
    Input: (0, $784186043f2fed12$export$b1b9f3bced726e54),
    Kbd: (0, $9c5afc6534d82b03$export$e193528a501e9a4a),
    Link: (0, $8dedbe51f6a97aae$export$af7f58b96695762e),
    List: (0, $16ce78115e0392f2$export$ce840f8e8ef752d),
    Menu: (0, $04d621803672fce5$export$687ce088075ea42b),
    Modal: (0, $5ea5377d270687ca$export$158ae9a07be41c05),
    NumberInput: (0, $f8594d8ba3060cee$export$b9bc5fa6e7f960a1),
    PinInput: (0, $030673c1bddca1df$export$8504c22c55a552e0),
    Popover: (0, $8c8c475f6e0a754e$export$135f12f777be1ef7),
    Progress: (0, $a63448f63006079b$export$dc04d8e6a17afea1),
    Radio: (0, $8ce8f1f3c8621e83$export$f0b387b940941887),
    Select: (0, $e135b6e1e9e3c892$export$21af0fc3c16183e1),
    Skeleton: (0, $2977b16c79f64fa6$export$7680371ad2d79142),
    SkipLink: (0, $389d33e698508b2a$export$a8cf3228ef52959),
    Slider: (0, $9d24530876c6a189$export$fff8df8fd8e1ed6f),
    Spinner: (0, $6d11ea28d5000747$export$d76156e68e556d3f),
    Stat: (0, $b6708541ae5a603e$export$f3301eb37a20f09e),
    Switch: (0, $796f49695e282fd6$export$6856b73e98185bff),
    Table: (0, $185e32c52a242ba2$export$3339219781bb5161),
    Tabs: (0, $c64b56df44e30b46$export$847a245e7ebce2a1),
    Tag: (0, $47453cae6f42196f$export$f8ab9ac2a319695b),
    Textarea: (0, $42bd8e7524f7cb5e$export$394b8322fab774c1),
    Tooltip: (0, $b6725ead9d736cab$export$7472a7883840b563),
    Card: (0, $7ecdaea5a4a75c2b$export$880f7b1201440c23),
    Stepper: (0, $b845893e40ea7d0a$export$54c84d54375c8d75)
};


const $264b8d18aa549d90$export$2e2bcd8739ae039 = {
    none: 0,
    "1px": "1px solid",
    "2px": "2px solid",
    "4px": "4px solid",
    "8px": "8px solid"
};


const $c8804ab891fe9701$export$2e2bcd8739ae039 = {
    base: "0em",
    sm: "30em",
    md: "48em",
    lg: "62em",
    xl: "80em",
    "2xl": "96em"
};


const $f5d17d17f75fdebc$export$2e2bcd8739ae039 = {
    transparent: "transparent",
    current: "currentColor",
    black: "#000000",
    white: "#FFFFFF",
    whiteAlpha: {
        50: "rgba(255, 255, 255, 0.04)",
        100: "rgba(255, 255, 255, 0.06)",
        200: "rgba(255, 255, 255, 0.08)",
        300: "rgba(255, 255, 255, 0.16)",
        400: "rgba(255, 255, 255, 0.24)",
        500: "rgba(255, 255, 255, 0.36)",
        600: "rgba(255, 255, 255, 0.48)",
        700: "rgba(255, 255, 255, 0.64)",
        800: "rgba(255, 255, 255, 0.80)",
        900: "rgba(255, 255, 255, 0.92)"
    },
    blackAlpha: {
        50: "rgba(0, 0, 0, 0.04)",
        100: "rgba(0, 0, 0, 0.06)",
        200: "rgba(0, 0, 0, 0.08)",
        300: "rgba(0, 0, 0, 0.16)",
        400: "rgba(0, 0, 0, 0.24)",
        500: "rgba(0, 0, 0, 0.36)",
        600: "rgba(0, 0, 0, 0.48)",
        700: "rgba(0, 0, 0, 0.64)",
        800: "rgba(0, 0, 0, 0.80)",
        900: "rgba(0, 0, 0, 0.92)"
    },
    gray: {
        50: "#F7FAFC",
        100: "#EDF2F7",
        200: "#E2E8F0",
        300: "#CBD5E0",
        400: "#A0AEC0",
        500: "#718096",
        600: "#4A5568",
        700: "#2D3748",
        800: "#1A202C",
        900: "#171923"
    },
    red: {
        50: "#FFF5F5",
        100: "#FED7D7",
        200: "#FEB2B2",
        300: "#FC8181",
        400: "#F56565",
        500: "#E53E3E",
        600: "#C53030",
        700: "#9B2C2C",
        800: "#822727",
        900: "#63171B"
    },
    orange: {
        50: "#FFFAF0",
        100: "#FEEBC8",
        200: "#FBD38D",
        300: "#F6AD55",
        400: "#ED8936",
        500: "#DD6B20",
        600: "#C05621",
        700: "#9C4221",
        800: "#7B341E",
        900: "#652B19"
    },
    yellow: {
        50: "#FFFFF0",
        100: "#FEFCBF",
        200: "#FAF089",
        300: "#F6E05E",
        400: "#ECC94B",
        500: "#D69E2E",
        600: "#B7791F",
        700: "#975A16",
        800: "#744210",
        900: "#5F370E"
    },
    green: {
        50: "#F0FFF4",
        100: "#C6F6D5",
        200: "#9AE6B4",
        300: "#68D391",
        400: "#48BB78",
        500: "#38A169",
        600: "#2F855A",
        700: "#276749",
        800: "#22543D",
        900: "#1C4532"
    },
    teal: {
        50: "#E6FFFA",
        100: "#B2F5EA",
        200: "#81E6D9",
        300: "#4FD1C5",
        400: "#38B2AC",
        500: "#319795",
        600: "#2C7A7B",
        700: "#285E61",
        800: "#234E52",
        900: "#1D4044"
    },
    blue: {
        50: "#ebf8ff",
        100: "#bee3f8",
        200: "#90cdf4",
        300: "#63b3ed",
        400: "#4299e1",
        500: "#3182ce",
        600: "#2b6cb0",
        700: "#2c5282",
        800: "#2a4365",
        900: "#1A365D"
    },
    cyan: {
        50: "#EDFDFD",
        100: "#C4F1F9",
        200: "#9DECF9",
        300: "#76E4F7",
        400: "#0BC5EA",
        500: "#00B5D8",
        600: "#00A3C4",
        700: "#0987A0",
        800: "#086F83",
        900: "#065666"
    },
    purple: {
        50: "#FAF5FF",
        100: "#E9D8FD",
        200: "#D6BCFA",
        300: "#B794F4",
        400: "#9F7AEA",
        500: "#805AD5",
        600: "#6B46C1",
        700: "#553C9A",
        800: "#44337A",
        900: "#322659"
    },
    pink: {
        50: "#FFF5F7",
        100: "#FED7E2",
        200: "#FBB6CE",
        300: "#F687B3",
        400: "#ED64A6",
        500: "#D53F8C",
        600: "#B83280",
        700: "#97266D",
        800: "#702459",
        900: "#521B41"
    }
};


const $30ed20f0bac5e2af$export$2e2bcd8739ae039 = {
    none: "0",
    sm: "0.125rem",
    base: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    full: "9999px"
};


const $461083799a7af125$export$2e2bcd8739ae039 = {
    xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
    inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
    none: "none",
    "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
};




const $adf2a288ccd3df38$var$transitionProperty = {
    common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
    colors: "background-color, border-color, color, fill, stroke",
    dimensions: "width, height",
    position: "left, right, top, bottom",
    background: "background-color, background-image, background-position"
};
const $adf2a288ccd3df38$var$transitionTimingFunction = {
    "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
    "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
    "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
};
const $adf2a288ccd3df38$var$transitionDuration = {
    "ultra-fast": "50ms",
    faster: "100ms",
    fast: "150ms",
    normal: "200ms",
    slow: "300ms",
    slower: "400ms",
    "ultra-slow": "500ms"
};
const $adf2a288ccd3df38$export$2e2bcd8739ae039 = {
    property: $adf2a288ccd3df38$var$transitionProperty,
    easing: $adf2a288ccd3df38$var$transitionTimingFunction,
    duration: $adf2a288ccd3df38$var$transitionDuration
};



const $d72494c4f440b90e$export$2e2bcd8739ae039 = {
    hide: -1,
    auto: "auto",
    base: 0,
    docked: 10,
    dropdown: 1e3,
    sticky: 1100,
    banner: 1200,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    skipLink: 1600,
    toast: 1700,
    tooltip: 1800
};


const $6ee592c522a53d47$export$2e2bcd8739ae039 = {
    none: 0,
    sm: "4px",
    base: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    "2xl": "40px",
    "3xl": "64px"
};


const $821fb51aaca643e2$export$651a0b7b10dae380 = {
    breakpoints: $c8804ab891fe9701$export$2e2bcd8739ae039,
    zIndices: $d72494c4f440b90e$export$2e2bcd8739ae039,
    radii: $30ed20f0bac5e2af$export$2e2bcd8739ae039,
    blur: $6ee592c522a53d47$export$2e2bcd8739ae039,
    colors: $f5d17d17f75fdebc$export$2e2bcd8739ae039,
    ...(0, $f05894c954e333ef$export$2e2bcd8739ae039),
    sizes: $da66fdd6a25ef817$export$2e2bcd8739ae039,
    shadows: $461083799a7af125$export$2e2bcd8739ae039,
    space: (0, $db0948d028fed175$export$5458b64234d1333c),
    borders: $264b8d18aa549d90$export$2e2bcd8739ae039,
    transition: $adf2a288ccd3df38$export$2e2bcd8739ae039
};


const $5dc79238dbcd617b$export$c1b409c4e1d33fce = {
    colors: {
        "chakra-body-text": {
            _light: "gray.800",
            _dark: "whiteAlpha.900"
        },
        "chakra-body-bg": {
            _light: "white",
            _dark: "gray.800"
        },
        "chakra-border-color": {
            _light: "gray.200",
            _dark: "whiteAlpha.300"
        },
        "chakra-inverse-text": {
            _light: "white",
            _dark: "gray.800"
        },
        "chakra-subtle-bg": {
            _light: "gray.100",
            _dark: "gray.700"
        },
        "chakra-subtle-text": {
            _light: "gray.600",
            _dark: "gray.400"
        },
        "chakra-placeholder-color": {
            _light: "gray.500",
            _dark: "whiteAlpha.400"
        }
    }
};


const $1d0977cf52889acb$export$9dd6ff9ea0189349 = {
    global: {
        body: {
            fontFamily: "body",
            color: "chakra-body-text",
            bg: "chakra-body-bg",
            transitionProperty: "background-color",
            transitionDuration: "normal",
            lineHeight: "base"
        },
        "*::placeholder": {
            color: "chakra-placeholder-color"
        },
        "*, *::before, &::after": {
            borderColor: "chakra-border-color"
        }
    }
};



const $08099edf7566eba4$var$direction = "ltr";
const $08099edf7566eba4$var$config = {
    useSystemColorMode: false,
    initialColorMode: "light",
    cssVarPrefix: "chakra"
};
const $08099edf7566eba4$export$bca14c5b3b88a9c9 = {
    semanticTokens: $5dc79238dbcd617b$export$c1b409c4e1d33fce,
    direction: $08099edf7566eba4$var$direction,
    ...(0, $821fb51aaca643e2$export$651a0b7b10dae380),
    components: $13b8358de5ab660c$export$9b5ac10f59f76296,
    styles: $1d0977cf52889acb$export$9dd6ff9ea0189349,
    config: $08099edf7566eba4$var$config
};
const $08099edf7566eba4$export$9e955aef208055a6 = {
    semanticTokens: $5dc79238dbcd617b$export$c1b409c4e1d33fce,
    direction: $08099edf7566eba4$var$direction,
    components: {},
    ...(0, $821fb51aaca643e2$export$651a0b7b10dae380),
    styles: $1d0977cf52889acb$export$9dd6ff9ea0189349,
    config: $08099edf7566eba4$var$config
};





function $225a75bff56eb0c3$export$1b3bfaa9684536aa(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $225a75bff56eb0c3$export$4e09c449d6c407f7() {
    return Boolean(globalThis?.document);
}
function $225a75bff56eb0c3$export$63ed1d20cf8213cf(element) {
    return $225a75bff56eb0c3$export$1b3bfaa9684536aa(element) && element.localName === "input" && "select" in element;
}
function $225a75bff56eb0c3$export$8a2eb51c14bb8899(element) {
    const doc = $225a75bff56eb0c3$export$1b3bfaa9684536aa(element) ? element.ownerDocument : document;
    return doc.activeElement === element;
}
function $225a75bff56eb0c3$export$ca1c506c57abefed(element) {
    if (element.parentElement && $225a75bff56eb0c3$export$ca1c506c57abefed(element.parentElement)) return true;
    return element.hidden;
}
function $225a75bff56eb0c3$export$de19eba357c4d80f(element) {
    const value = element.getAttribute("contenteditable");
    return value !== "false" && value != null;
}
function $225a75bff56eb0c3$export$f1048a3bb039cd02(element) {
    return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}



var $acw62 = parcelRequire("acw62");
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $76500f1a9bc57c92$var$isBrowser = typeof document !== "undefined";
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)) break;
        (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)();
    }
    return (0, $298fb931ed4fbf8b$export$58adb3bec8346d0f)(begin, (0, $298fb931ed4fbf8b$export$5880b8b5730aff45));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $298fb931ed4fbf8b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $298fb931ed4fbf8b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $298fb931ed4fbf8b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $298fb931ed4fbf8b$export$45918ac1574455b1)($76500f1a9bc57c92$var$toRules((0, $298fb931ed4fbf8b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $298fb931ed4fbf8b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-item-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "stretch") ? $76500f1a9bc57c92$var$prefix((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, (0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 3 - (~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $298fb931ed4fbf8b$export$527d108ccf083c2b:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                    (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                        value: (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $298fb931ed4fbf8b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
/* import type { StylisPlugin } from './types' */ /*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/ var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function() {
    return (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function() {
        var cache = {};
        return function(name) {
            return cache[name];
        };
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if ($76500f1a9bc57c92$var$isBrowser) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
            (0, $298fb931ed4fbf8b$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $298fb931ed4fbf8b$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function /*: string */ getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function /*: string | void */ _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $e19976245606d3d7$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}



var $72623ab6bcb0a33b$exports = {};
"use strict";
var $3251146683c5d714$exports = {};
"use strict";

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($3251146683c5d714$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(targetComponent, sourceComponent);
};


var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== "undefined";
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, "-$&").toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}



var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== "undefined";
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;


var $f603cc9427f570ab$export$407448d2b89b1813 = false;
var $f603cc9427f570ab$export$23f2a1d2818174ef = typeof document !== "undefined";
/* import { type EmotionCache } from '@emotion/utils' */ var $f603cc9427f570ab$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $76500f1a9bc57c92$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
var $f603cc9427f570ab$export$e7094788287c5e9b = $f603cc9427f570ab$var$EmotionCacheContext.Provider;
var $f603cc9427f570ab$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $acw62.useContext)($f603cc9427f570ab$var$EmotionCacheContext);
};
var $f603cc9427f570ab$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($f603cc9427f570ab$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$f603cc9427f570ab$export$23f2a1d2818174ef) $f603cc9427f570ab$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.StatelessFunctionalComponent<Props> */ {
    return function(props) {
        var cache = (0, $acw62.useContext)($f603cc9427f570ab$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $76500f1a9bc57c92$export$2e2bcd8739ae039)({
                key: "css"
            });
            return /*#__PURE__*/ $acw62.createElement($f603cc9427f570ab$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $f603cc9427f570ab$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $f603cc9427f570ab$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($f603cc9427f570ab$export$971d5caa766a69d7);
};
var $f603cc9427f570ab$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $f603cc9427f570ab$var$createCacheWithTheme = /* #__PURE__ */ (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(theme) {
        return $f603cc9427f570ab$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $f603cc9427f570ab$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($f603cc9427f570ab$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $f603cc9427f570ab$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($f603cc9427f570ab$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $f603cc9427f570ab$export$4368d992c4eafac0(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $acw62.useContext($f603cc9427f570ab$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $794b155aeb6b00fd$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $f603cc9427f570ab$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $f603cc9427f570ab$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $f603cc9427f570ab$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($f603cc9427f570ab$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$f603cc9427f570ab$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $f603cc9427f570ab$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $5f1e384d41b6dbd9$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $1b59f2f50af460c0$export$db21c7ffa21794e7)(function() {
        return (0, $5f1e384d41b6dbd9$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    if (!$f603cc9427f570ab$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $f603cc9427f570ab$var$Emotion = /* #__PURE__ */ $f603cc9427f570ab$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$f603cc9427f570ab$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $5f1e384d41b6dbd9$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(registeredStyles, undefined, $acw62.useContext($f603cc9427f570ab$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($f603cc9427f570ab$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $f603cc9427f570ab$var$typePropName && !$f603cc9427f570ab$export$407448d2b89b1813) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($f603cc9427f570ab$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $f603cc9427f570ab$export$a9c23c6ac3fc3eca = $f603cc9427f570ab$var$Emotion;



var $acw62 = parcelRequire("acw62");




var $27ab08c24269de64$exports = {};
function $27ab08c24269de64$var$_extends() {
    $27ab08c24269de64$exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;
    return $27ab08c24269de64$var$_extends.apply(this, arguments);
}
$27ab08c24269de64$exports = $27ab08c24269de64$var$_extends, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;





var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $f603cc9427f570ab$export$dda1d9f60106f0e9).call(props, "css")) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $f603cc9427f570ab$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $f603cc9427f570ab$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $f603cc9427f570ab$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)([
        styles
    ], undefined, $acw62.useContext((0, $f603cc9427f570ab$export$971d5caa766a69d7)));
    if (!(0, $f603cc9427f570ab$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $1b59f2f50af460c0$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $1b59f2f50af460c0$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $5f1e384d41b6dbd9$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $e0f035ab0866fe47$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $62578605b07c8dad$export$6321afa313b251b5)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $e0f035ab0866fe47$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $e0f035ab0866fe47$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $5f1e384d41b6dbd9$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $1b59f2f50af460c0$export$db21c7ffa21794e7)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $5f1e384d41b6dbd9$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
            if (!(0, $f603cc9427f570ab$export$23f2a1d2818174ef) && res !== undefined) rules += res;
        }
        if (!(0, $f603cc9427f570ab$export$23f2a1d2818174ef)) return rules;
    });
    if (!(0, $f603cc9427f570ab$export$23f2a1d2818174ef) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $f603cc9427f570ab$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $f603cc9427f570ab$export$407448d2b89b1813)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $5f1e384d41b6dbd9$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $f603cc9427f570ab$export$407448d2b89b1813)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $f603cc9427f570ab$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
const $43224bfcd60683b5$export$49ddd74a6729fdb0 = (0, $acw62.createContext)({});
$43224bfcd60683b5$export$49ddd74a6729fdb0.displayName = "ColorModeContext";
function $43224bfcd60683b5$export$20f3076712c8dfa() {
    const context = (0, $acw62.useContext)($43224bfcd60683b5$export$49ddd74a6729fdb0);
    if (context === void 0) throw new Error("useColorMode must be used within a ColorModeProvider");
    return context;
}
function $43224bfcd60683b5$export$d18f2ef57b0d7644(light, dark) {
    const { colorMode: colorMode } = $43224bfcd60683b5$export$20f3076712c8dfa();
    return colorMode === "dark" ? dark : light;
}


"use client";
const $c9248196c4abdcc9$var$classNames = {
    light: "chakra-ui-light",
    dark: "chakra-ui-dark"
};
function $c9248196c4abdcc9$export$4bb933d353baa01c(options = {}) {
    const { preventTransition: preventTransition = true, nonce: nonce } = options;
    const utils = {
        setDataset: (value)=>{
            const cleanup = preventTransition ? utils.preventTransition() : void 0;
            document.documentElement.dataset.theme = value;
            document.documentElement.style.colorScheme = value;
            cleanup?.();
        },
        setClassName (dark) {
            document.body.classList.add(dark ? $c9248196c4abdcc9$var$classNames.dark : $c9248196c4abdcc9$var$classNames.light);
            document.body.classList.remove(dark ? $c9248196c4abdcc9$var$classNames.light : $c9248196c4abdcc9$var$classNames.dark);
        },
        query () {
            return window.matchMedia("(prefers-color-scheme: dark)");
        },
        getSystemTheme (fallback) {
            const dark = utils.query().matches ?? fallback === "dark";
            return dark ? "dark" : "light";
        },
        addListener (fn) {
            const mql = utils.query();
            const listener = (e)=>{
                fn(e.matches ? "dark" : "light");
            };
            if (typeof mql.addListener === "function") mql.addListener(listener);
            else mql.addEventListener("change", listener);
            return ()=>{
                if (typeof mql.removeListener === "function") mql.removeListener(listener);
                else mql.removeEventListener("change", listener);
            };
        },
        preventTransition () {
            const css = document.createElement("style");
            css.appendChild(document.createTextNode(`*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}`));
            if (nonce !== void 0) css.nonce = nonce;
            document.head.appendChild(css);
            return ()=>{
                (()=>window.getComputedStyle(document.body))();
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        document.head.removeChild(css);
                    });
                });
            };
        }
    };
    return utils;
}


"use client";
const $d4480021530e7709$export$86880b4b2e1a2384 = "chakra-ui-color-mode";
function $d4480021530e7709$export$cdf53b88b62eb393(key) {
    return {
        ssr: false,
        type: "localStorage",
        get (init) {
            if (!globalThis?.document) return init;
            let value;
            try {
                value = localStorage.getItem(key) || init;
            } catch (e) {}
            return value || init;
        },
        set (value) {
            try {
                localStorage.setItem(key, value);
            } catch (e) {}
        }
    };
}
const $d4480021530e7709$export$8e35886de8a54f45 = $d4480021530e7709$export$cdf53b88b62eb393($d4480021530e7709$export$86880b4b2e1a2384);
function $d4480021530e7709$var$parseCookie(cookie, key) {
    const match = cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
    return match?.[2];
}
function $d4480021530e7709$export$df28b7d6efe2673c(key, cookie) {
    return {
        ssr: !!cookie,
        type: "cookie",
        get (init) {
            if (cookie) return $d4480021530e7709$var$parseCookie(cookie, key);
            if (!globalThis?.document) return init;
            return $d4480021530e7709$var$parseCookie(document.cookie, key) || init;
        },
        set (value) {
            document.cookie = `${key}=${value}; max-age=31536000; path=/`;
        }
    };
}
const $d4480021530e7709$export$2e2b0158437077e3 = $d4480021530e7709$export$df28b7d6efe2673c($d4480021530e7709$export$86880b4b2e1a2384);
const $d4480021530e7709$export$d76e8eed3e914fa0 = (cookie)=>$d4480021530e7709$export$df28b7d6efe2673c($d4480021530e7709$export$86880b4b2e1a2384, cookie);


"use client";
const $c66eeb0a39f5709f$var$noop = ()=>{};
const $c66eeb0a39f5709f$var$useSafeLayoutEffect = (0, $225a75bff56eb0c3$export$4e09c449d6c407f7)() ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $c66eeb0a39f5709f$var$getTheme(manager, fallback) {
    return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
}
const $c66eeb0a39f5709f$export$7a858aa3ff83dde7 = (0, $f603cc9427f570ab$export$efccba1c4a2ef57b)(function ColorModeProvider2(props, cache) {
    const { value: value, children: children, options: { useSystemColorMode: useSystemColorMode, initialColorMode: initialColorMode, disableTransitionOnChange: disableTransitionOnChange } = {}, colorModeManager: colorModeManager = (0, $d4480021530e7709$export$8e35886de8a54f45) } = props;
    const defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
    const [colorMode, rawSetColorMode] = (0, $acw62.useState)(()=>$c66eeb0a39f5709f$var$getTheme(colorModeManager, defaultColorMode));
    const [resolvedColorMode, setResolvedColorMode] = (0, $acw62.useState)(()=>$c66eeb0a39f5709f$var$getTheme(colorModeManager));
    const { getSystemTheme: getSystemTheme, setClassName: setClassName, setDataset: setDataset, addListener: addListener } = (0, $acw62.useMemo)(()=>(0, $c9248196c4abdcc9$export$4bb933d353baa01c)({
            preventTransition: disableTransitionOnChange,
            nonce: cache?.nonce
        }), [
        disableTransitionOnChange,
        cache?.nonce
    ]);
    const resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
    const setColorMode = (0, $acw62.useCallback)((value2)=>{
        const resolved = value2 === "system" ? getSystemTheme() : value2;
        rawSetColorMode(resolved);
        setClassName(resolved === "dark");
        setDataset(resolved);
        colorModeManager.set(resolved);
    }, [
        colorModeManager,
        getSystemTheme,
        setClassName,
        setDataset
    ]);
    $c66eeb0a39f5709f$var$useSafeLayoutEffect(()=>{
        if (initialColorMode === "system") setResolvedColorMode(getSystemTheme());
    }, []);
    (0, $acw62.useEffect)(()=>{
        const managerValue = colorModeManager.get();
        if (managerValue) {
            setColorMode(managerValue);
            return;
        }
        if (initialColorMode === "system") {
            setColorMode("system");
            return;
        }
        setColorMode(defaultColorMode);
    }, [
        colorModeManager,
        defaultColorMode,
        initialColorMode,
        setColorMode
    ]);
    const toggleColorMode = (0, $acw62.useCallback)(()=>{
        setColorMode(resolvedValue === "dark" ? "light" : "dark");
    }, [
        resolvedValue,
        setColorMode
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!useSystemColorMode) return;
        return addListener(setColorMode);
    }, [
        useSystemColorMode,
        addListener,
        setColorMode
    ]);
    const context = (0, $acw62.useMemo)(()=>({
            colorMode: value ?? resolvedValue,
            toggleColorMode: value ? $c66eeb0a39f5709f$var$noop : toggleColorMode,
            setColorMode: value ? $c66eeb0a39f5709f$var$noop : setColorMode,
            forced: value !== void 0
        }), [
        resolvedValue,
        toggleColorMode,
        setColorMode,
        value
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $43224bfcd60683b5$export$49ddd74a6729fdb0).Provider, {
        value: context,
        children: children
    });
});
$c66eeb0a39f5709f$export$7a858aa3ff83dde7.displayName = "ColorModeProvider";
function $c66eeb0a39f5709f$export$8b41b18ed1f3731e(props) {
    const context = (0, $acw62.useMemo)(()=>({
            colorMode: "dark",
            toggleColorMode: $c66eeb0a39f5709f$var$noop,
            setColorMode: $c66eeb0a39f5709f$var$noop,
            forced: true
        }), []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $43224bfcd60683b5$export$49ddd74a6729fdb0).Provider, {
        value: context,
        ...props
    });
}
$c66eeb0a39f5709f$export$8b41b18ed1f3731e.displayName = "DarkMode";
function $c66eeb0a39f5709f$export$cee2b1aa9166b2a3(props) {
    const context = (0, $acw62.useMemo)(()=>({
            colorMode: "light",
            toggleColorMode: $c66eeb0a39f5709f$var$noop,
            setColorMode: $c66eeb0a39f5709f$var$noop,
            forced: true
        }), []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $43224bfcd60683b5$export$49ddd74a6729fdb0).Provider, {
        value: context,
        ...props
    });
}
$c66eeb0a39f5709f$export$cee2b1aa9166b2a3.displayName = "LightMode";




"use client";
const $722c916e91f387b3$var$css = String.raw;
const $722c916e91f387b3$var$vhPolyfill = $722c916e91f387b3$var$css`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`;
const $722c916e91f387b3$export$43a6590e493ec44a = ()=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e0f035ab0866fe47$export$98f03c5d19621d70), {
        styles: $722c916e91f387b3$var$vhPolyfill
    });
const $722c916e91f387b3$export$b751feffed387621 = ({ scope: scope = "" })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e0f035ab0866fe47$export$98f03c5d19621d70), {
        styles: $722c916e91f387b3$var$css`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${scope} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${scope} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${scope} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${scope} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${scope} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${scope} :where(b, strong) {
        font-weight: bold;
      }

      ${scope} small {
        font-size: 80%;
      }

      ${scope} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${scope} sub {
        bottom: -0.25em;
      }

      ${scope} sup {
        top: -0.5em;
      }

      ${scope} img {
        border-style: none;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${scope} :where(button, input) {
        overflow: visible;
      }

      ${scope} :where(button, select) {
        text-transform: none;
      }

      ${scope} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${scope} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${scope} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${scope} progress {
        vertical-align: baseline;
      }

      ${scope} textarea {
        overflow: auto;
      }

      ${scope} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${scope} input[type="number"]::-webkit-inner-spin-button,
      ${scope} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${scope} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${scope} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${scope} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${scope} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${scope} details {
        display: block;
      }

      ${scope} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${scope} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${scope} button {
        background: transparent;
        padding: 0;
      }

      ${scope} fieldset {
        margin: 0;
        padding: 0;
      }

      ${scope} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${scope} textarea {
        resize: vertical;
      }

      ${scope} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${scope} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${scope} table {
        border-collapse: collapse;
      }

      ${scope} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${scope} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${scope} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${scope} select::-ms-expand {
        display: none;
      }

      ${$722c916e91f387b3$var$vhPolyfill}
    `
    });




var $5Gn6I = parcelRequire("5Gn6I");const $e02dbdd8eca189fb$var$isFunction = (value)=>typeof value === "function";
function $e02dbdd8eca189fb$export$624e501d81f5ffce(valueOrFn, ...args) {
    return $e02dbdd8eca189fb$var$isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}


const $542184161165dad3$var$state = {
    open: (str, post)=>`${str}[data-open], ${str}[open], ${str}[data-state=open] ${post}`,
    closed: (str, post)=>`${str}[data-closed], ${str}[data-state=closed] ${post}`,
    hover: (str, post)=>`${str}:hover ${post}, ${str}[data-hover] ${post}`,
    focus: (str, post)=>`${str}:focus ${post}, ${str}[data-focus] ${post}`,
    focusVisible: (str, post)=>`${str}:focus-visible ${post}`,
    focusWithin: (str, post)=>`${str}:focus-within ${post}`,
    active: (str, post)=>`${str}:active ${post}, ${str}[data-active] ${post}`,
    disabled: (str, post)=>`${str}:disabled ${post}, ${str}[data-disabled] ${post}`,
    invalid: (str, post)=>`${str}:invalid ${post}, ${str}[data-invalid] ${post}`,
    checked: (str, post)=>`${str}:checked ${post}, ${str}[data-checked] ${post}`,
    indeterminate: (str, post)=>`${str}:indeterminate ${post}, ${str}[aria-checked=mixed] ${post}, ${str}[data-indeterminate] ${post}`,
    readOnly: (str, post)=>`${str}:read-only ${post}, ${str}[readonly] ${post}, ${str}[data-read-only] ${post}`,
    expanded: (str, post)=>`${str}:read-only ${post}, ${str}[aria-expanded=true] ${post}, ${str}[data-expanded] ${post}`,
    placeholderShown: (str, post)=>`${str}:placeholder-shown ${post}`
};
const $542184161165dad3$var$toGroup = (fn)=>$542184161165dad3$var$merge((v)=>fn(v, "&"), "[role=group]", "[data-group]", ".group");
const $542184161165dad3$var$toPeer = (fn)=>$542184161165dad3$var$merge((v)=>fn(v, "~ &"), "[data-peer]", ".peer");
const $542184161165dad3$var$merge = (fn, ...selectors)=>selectors.map(fn).join(", ");
const $542184161165dad3$var$pseudoSelectors = {
    /**
   * Styles for CSS selector `&:hover`
   */ _hover: "&:hover, &[data-hover]",
    /**
   * Styles for CSS Selector `&:active`
   */ _active: "&:active, &[data-active]",
    /**
   * Styles for CSS selector `&:focus`
   *
   */ _focus: "&:focus, &[data-focus]",
    /**
   * Styles for the highlighted state.
   */ _highlighted: "&[data-highlighted]",
    /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */ _focusWithin: "&:focus-within, &[data-focus-within]",
    /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */ _focusVisible: "&:focus-visible, &[data-focus-visible]",
    /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   * - `&[disabled]`
   */ _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
    /**
   * Styles for CSS Selector `&:readonly`
   */ _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
    /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */ _before: "&::before",
    /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */ _after: "&::after",
    /**
   * Styles for CSS selector `&:empty`
   */ _empty: "&:empty, &[data-empty]",
    /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */ _expanded: "&[aria-expanded=true], &[data-expanded], &[data-state=expanded]",
    /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */ _checked: "&[aria-checked=true], &[data-checked], &[data-state=checked]",
    /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */ _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
    /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */ _pressed: "&[aria-pressed=true], &[data-pressed]",
    /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */ _invalid: "&[aria-invalid=true], &[data-invalid]",
    /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */ _valid: "&[data-valid], &[data-state=valid]",
    /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */ _loading: "&[data-loading], &[aria-busy=true]",
    /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */ _selected: "&[aria-selected=true], &[data-selected]",
    /**
   * Styles for CSS Selector `[hidden=true]`
   */ _hidden: "&[hidden], &[data-hidden]",
    /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */ _autofill: "&:-webkit-autofill",
    /**
   * Styles for CSS Selector `&:nth-child(even)`
   */ _even: "&:nth-of-type(even)",
    /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */ _odd: "&:nth-of-type(odd)",
    /**
   * Styles for CSS Selector `&:first-of-type`
   */ _first: "&:first-of-type",
    /**
   * Styles for CSS selector `&::first-letter`
   *
   * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
   * @example
   * ```jsx
   * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
   * ```
   */ _firstLetter: "&::first-letter",
    /**
   * Styles for CSS Selector `&:last-of-type`
   */ _last: "&:last-of-type",
    /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */ _notFirst: "&:not(:first-of-type)",
    /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */ _notLast: "&:not(:last-of-type)",
    /**
   * Styles for CSS Selector `&:visited`
   */ _visited: "&:visited",
    /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */ _activeLink: "&[aria-current=page]",
    /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */ _activeStep: "&[aria-current=step]",
    /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */ _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate], &[data-state=indeterminate]",
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is open
   */ _groupOpen: $542184161165dad3$var$toGroup($542184161165dad3$var$state.open),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is closed
   */ _groupClosed: $542184161165dad3$var$toGroup($542184161165dad3$var$state.closed),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */ _groupHover: $542184161165dad3$var$toGroup($542184161165dad3$var$state.hover),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */ _peerHover: $542184161165dad3$var$toPeer($542184161165dad3$var$state.hover),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */ _groupFocus: $542184161165dad3$var$toGroup($542184161165dad3$var$state.focus),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */ _peerFocus: $542184161165dad3$var$toPeer($542184161165dad3$var$state.focus),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */ _groupFocusVisible: $542184161165dad3$var$toGroup($542184161165dad3$var$state.focusVisible),
    /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */ _peerFocusVisible: $542184161165dad3$var$toPeer($542184161165dad3$var$state.focusVisible),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */ _groupActive: $542184161165dad3$var$toGroup($542184161165dad3$var$state.active),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */ _peerActive: $542184161165dad3$var$toPeer($542184161165dad3$var$state.active),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */ _groupDisabled: $542184161165dad3$var$toGroup($542184161165dad3$var$state.disabled),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */ _peerDisabled: $542184161165dad3$var$toPeer($542184161165dad3$var$state.disabled),
    /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */ _groupInvalid: $542184161165dad3$var$toGroup($542184161165dad3$var$state.invalid),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */ _peerInvalid: $542184161165dad3$var$toPeer($542184161165dad3$var$state.invalid),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */ _groupChecked: $542184161165dad3$var$toGroup($542184161165dad3$var$state.checked),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */ _peerChecked: $542184161165dad3$var$toPeer($542184161165dad3$var$state.checked),
    /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */ _groupFocusWithin: $542184161165dad3$var$toGroup($542184161165dad3$var$state.focusWithin),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */ _peerFocusWithin: $542184161165dad3$var$toPeer($542184161165dad3$var$state.focusWithin),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */ _peerPlaceholderShown: $542184161165dad3$var$toPeer($542184161165dad3$var$state.placeholderShown),
    /**
   * Styles for CSS Selector `&::placeholder`.
   */ _placeholder: "&::placeholder, &[data-placeholder]",
    /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */ _placeholderShown: "&:placeholder-shown, &[data-placeholder-shown]",
    /**
   * Styles for CSS Selector `&:fullscreen`.
   */ _fullScreen: "&:fullscreen, &[data-fullscreen]",
    /**
   * Styles for CSS Selector `&::selection`
   */ _selection: "&::selection",
    /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */ _rtl: "[dir=rtl] &, &[dir=rtl]",
    /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */ _ltr: "[dir=ltr] &, &[dir=ltr]",
    /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */ _mediaDark: "@media (prefers-color-scheme: dark)",
    /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */ _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
    /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */ _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
    /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */ _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
    /**
   * Styles for the CSS Selector `&[data-orientation=horizontal]`
   */ _horizontal: "&[data-orientation=horizontal]",
    /**
   * Styles for the CSS Selector `&[data-orientation=vertical]`
   */ _vertical: "&[data-orientation=vertical]",
    /**
   * Styles for the CSS Selector `&[data-open], &[open], &[data-state=open]`
   */ _open: "&[data-open], &[open], &[data-state=open]",
    /**
   * Styles for the CSS Selector `&[data-closed], &[data-state=closed]`
   */ _closed: "&[data-closed], &[data-state=closed]",
    /**
   * Styles for the CSS Selector `&[data-complete]`
   */ _complete: "&[data-complete]",
    /**
   * Styles for the CSS Selector `&[data-incomplete]`
   */ _incomplete: "&[data-incomplete]",
    /**
   * Styles for the CSS Selector `&[data-current]`
   */ _current: "&[data-current]"
};
function $542184161165dad3$export$f41ab9e4dfc20352(theme) {
    const __conds = theme.conditions ?? {};
    const conditions = Object.fromEntries(Object.entries(__conds).map(([key, value])=>[
            `_${key}`,
            value
        ]));
    return {
        ...$542184161165dad3$var$pseudoSelectors,
        ...conditions
    };
}
function $542184161165dad3$export$a7126a96abbbb621(theme) {
    return Object.keys($542184161165dad3$export$f41ab9e4dfc20352(theme));
}



var $5Gn6I = parcelRequire("5Gn6I");


const $ad3fc94f62c40c23$var$isImportant = (value)=>/!(important)?$/.test(value);
const $ad3fc94f62c40c23$var$withoutImportant = (value)=>typeof value === "string" ? value.replace(/!(important)?$/, "").trim() : value;
const $ad3fc94f62c40c23$export$92f5bb613cffac78 = (scale, value)=>(theme)=>{
        const valueStr = String(value);
        const important = $ad3fc94f62c40c23$var$isImportant(valueStr);
        const valueWithoutImportant = $ad3fc94f62c40c23$var$withoutImportant(valueStr);
        const key = scale ? `${scale}.${valueWithoutImportant}` : valueWithoutImportant;
        let transformed = (0, $ee96c6227c318ff4$export$a6cdc56e425d0d0a)(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
        transformed = $ad3fc94f62c40c23$var$withoutImportant(transformed);
        return important ? `${transformed} !important` : transformed;
    };
function $ad3fc94f62c40c23$export$99c68a89351e15c0(options) {
    const { scale: scale, transform: transform, compose: compose } = options;
    const fn = (value, theme)=>{
        const _value = $ad3fc94f62c40c23$export$92f5bb613cffac78(scale, value)(theme);
        let result = transform?.(_value, theme) ?? _value;
        if (compose) result = compose(result, theme);
        return result;
    };
    return fn;
}


const $9259c122d7a79a92$export$a4627e546088548d = (...fns)=>(v)=>fns.reduce((a, b)=>b(a), v);



function $cfce0acadbae6d18$export$9ced7da5e9a2be1b(scale, transform) {
    return (property)=>{
        const result = {
            property: property,
            scale: scale
        };
        result.transform = (0, $ad3fc94f62c40c23$export$99c68a89351e15c0)({
            scale: scale,
            transform: transform
        });
        return result;
    };
}
const $cfce0acadbae6d18$var$getRtl = ({ rtl: rtl, ltr: ltr })=>(theme)=>theme.direction === "rtl" ? rtl : ltr;
function $cfce0acadbae6d18$export$965c6ce6d3869a7a(options) {
    const { property: property, scale: scale, transform: transform } = options;
    return {
        scale: scale,
        property: $cfce0acadbae6d18$var$getRtl(property),
        transform: scale ? (0, $ad3fc94f62c40c23$export$99c68a89351e15c0)({
            scale: scale,
            compose: transform
        }) : transform
    };
}


const $88e37d014ec8a612$var$transformTemplate = [
    "rotate(var(--chakra-rotate, 0))",
    "scaleX(var(--chakra-scale-x, 1))",
    "scaleY(var(--chakra-scale-y, 1))",
    "skewX(var(--chakra-skew-x, 0))",
    "skewY(var(--chakra-skew-y, 0))"
];
function $88e37d014ec8a612$export$5f430efbe955e23() {
    return [
        "translateX(var(--chakra-translate-x, 0))",
        "translateY(var(--chakra-translate-y, 0))",
        ...$88e37d014ec8a612$var$transformTemplate
    ].join(" ");
}
function $88e37d014ec8a612$export$64ac7328c339e78f() {
    return [
        "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
        ...$88e37d014ec8a612$var$transformTemplate
    ].join(" ");
}
const $88e37d014ec8a612$export$b74d0d62597cd7c1 = {
    "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
    filter: [
        "var(--chakra-blur)",
        "var(--chakra-brightness)",
        "var(--chakra-contrast)",
        "var(--chakra-grayscale)",
        "var(--chakra-hue-rotate)",
        "var(--chakra-invert)",
        "var(--chakra-saturate)",
        "var(--chakra-sepia)",
        "var(--chakra-drop-shadow)"
    ].join(" ")
};
const $88e37d014ec8a612$export$560b9f000772a3a3 = {
    backdropFilter: [
        "var(--chakra-backdrop-blur)",
        "var(--chakra-backdrop-brightness)",
        "var(--chakra-backdrop-contrast)",
        "var(--chakra-backdrop-grayscale)",
        "var(--chakra-backdrop-hue-rotate)",
        "var(--chakra-backdrop-invert)",
        "var(--chakra-backdrop-opacity)",
        "var(--chakra-backdrop-saturate)",
        "var(--chakra-backdrop-sepia)"
    ].join(" "),
    "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function $88e37d014ec8a612$export$c6454f9b51b226bb(value) {
    return {
        "--chakra-ring-offset-shadow": `var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)`,
        "--chakra-ring-shadow": `var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)`,
        "--chakra-ring-width": value,
        boxShadow: [
            `var(--chakra-ring-offset-shadow)`,
            `var(--chakra-ring-shadow)`,
            `var(--chakra-shadow, 0 0 #0000)`
        ].join(", ")
    };
}
const $88e37d014ec8a612$export$2d29807f3ae71abd = {
    "row-reverse": {
        space: "--chakra-space-x-reverse",
        divide: "--chakra-divide-x-reverse"
    },
    "column-reverse": {
        space: "--chakra-space-y-reverse",
        divide: "--chakra-divide-y-reverse"
    }
};


const $cb2277a3cf45ece0$var$directionMap = {
    "to-t": "to top",
    "to-tr": "to top right",
    "to-r": "to right",
    "to-br": "to bottom right",
    "to-b": "to bottom",
    "to-bl": "to bottom left",
    "to-l": "to left",
    "to-tl": "to top left"
};
const $cb2277a3cf45ece0$var$valueSet = new Set(Object.values($cb2277a3cf45ece0$var$directionMap));
const $cb2277a3cf45ece0$export$64d5d115563291e3 = /* @__PURE__ */ new Set([
    "none",
    "-moz-initial",
    "inherit",
    "initial",
    "revert",
    "unset"
]);
const $cb2277a3cf45ece0$var$trimSpace = (str)=>str.trim();
function $cb2277a3cf45ece0$export$1089ae7f4d02cd2e(value, theme) {
    if (value == null || $cb2277a3cf45ece0$export$64d5d115563291e3.has(value)) return value;
    const prevent = $cb2277a3cf45ece0$export$710a7f202c1f9f4e(value) || $cb2277a3cf45ece0$export$64d5d115563291e3.has(value);
    if (!prevent) return `url('${value}')`;
    const regex = /(^[a-z-A-Z]+)\((.*)\)/g;
    const results = regex.exec(value);
    const type = results?.[1];
    const values = results?.[2];
    if (!type || !values) return value;
    const _type = type.includes("-gradient") ? type : `${type}-gradient`;
    const [maybeDirection, ...stops] = values.split(",").map($cb2277a3cf45ece0$var$trimSpace).filter(Boolean);
    if (stops?.length === 0) return value;
    const direction = maybeDirection in $cb2277a3cf45ece0$var$directionMap ? $cb2277a3cf45ece0$var$directionMap[maybeDirection] : maybeDirection;
    stops.unshift(direction);
    const _values = stops.map((stop)=>{
        if ($cb2277a3cf45ece0$var$valueSet.has(stop)) return stop;
        const firstStop = stop.indexOf(" ");
        const [_color, _stop] = firstStop !== -1 ? [
            stop.substr(0, firstStop),
            stop.substr(firstStop + 1)
        ] : [
            stop
        ];
        const _stopOrFunc = $cb2277a3cf45ece0$export$710a7f202c1f9f4e(_stop) ? _stop : _stop && _stop.split(" ");
        const key = `colors.${_color}`;
        const color = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
        return _stopOrFunc ? [
            color,
            ...Array.isArray(_stopOrFunc) ? _stopOrFunc : [
                _stopOrFunc
            ]
        ].join(" ") : color;
    });
    return `${_type}(${_values.join(", ")})`;
}
const $cb2277a3cf45ece0$export$710a7f202c1f9f4e = (value)=>{
    return typeof value === "string" && value.includes("(") && value.includes(")");
};
const $cb2277a3cf45ece0$export$6bab994d7a66bebb = (value, theme)=>$cb2277a3cf45ece0$export$1089ae7f4d02cd2e(value, theme ?? {});


function $ebcf615ace51411a$var$isCssVar(value) {
    return /^var\(--.+\)$/.test(value);
}
const $ebcf615ace51411a$var$analyzeCSSValue = (value)=>{
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
};
const $ebcf615ace51411a$var$wrap = (str)=>(value)=>`${str}(${value})`;
const $ebcf615ace51411a$export$f1c738cddd9a74ae = {
    filter (value) {
        return value !== "auto" ? value : (0, $88e37d014ec8a612$export$b74d0d62597cd7c1);
    },
    backdropFilter (value) {
        return value !== "auto" ? value : (0, $88e37d014ec8a612$export$560b9f000772a3a3);
    },
    ring (value) {
        return (0, $88e37d014ec8a612$export$c6454f9b51b226bb)($ebcf615ace51411a$export$f1c738cddd9a74ae.px(value));
    },
    bgClip (value) {
        return value === "text" ? {
            color: "transparent",
            backgroundClip: "text"
        } : {
            backgroundClip: value
        };
    },
    transform (value) {
        if (value === "auto") return (0, $88e37d014ec8a612$export$5f430efbe955e23)();
        if (value === "auto-gpu") return (0, $88e37d014ec8a612$export$64ac7328c339e78f)();
        return value;
    },
    vh (value) {
        return value === "$100vh" ? "var(--chakra-vh)" : value;
    },
    px (value) {
        if (value == null) return value;
        const { unitless: unitless } = $ebcf615ace51411a$var$analyzeCSSValue(value);
        return unitless || typeof value === "number" ? `${value}px` : value;
    },
    fraction (value) {
        return !(typeof value === "number") || value > 1 ? value : `${value * 100}%`;
    },
    float (value, theme) {
        const map = {
            left: "right",
            right: "left"
        };
        return theme.direction === "rtl" ? map[value] : value;
    },
    degree (value) {
        if ($ebcf615ace51411a$var$isCssVar(value) || value == null) return value;
        const unitless = typeof value === "string" && !value.endsWith("deg");
        return typeof value === "number" || unitless ? `${value}deg` : value;
    },
    gradient: (0, $cb2277a3cf45ece0$export$6bab994d7a66bebb),
    blur: $ebcf615ace51411a$var$wrap("blur"),
    opacity: $ebcf615ace51411a$var$wrap("opacity"),
    brightness: $ebcf615ace51411a$var$wrap("brightness"),
    contrast: $ebcf615ace51411a$var$wrap("contrast"),
    dropShadow: $ebcf615ace51411a$var$wrap("drop-shadow"),
    grayscale: $ebcf615ace51411a$var$wrap("grayscale"),
    hueRotate: (value)=>$ebcf615ace51411a$var$wrap("hue-rotate")($ebcf615ace51411a$export$f1c738cddd9a74ae.degree(value)),
    invert: $ebcf615ace51411a$var$wrap("invert"),
    saturate: $ebcf615ace51411a$var$wrap("saturate"),
    sepia: $ebcf615ace51411a$var$wrap("sepia"),
    bgImage (value) {
        if (value == null) return value;
        const prevent = (0, $cb2277a3cf45ece0$export$710a7f202c1f9f4e)(value) || (0, $cb2277a3cf45ece0$export$64d5d115563291e3).has(value);
        return !prevent ? `url(${value})` : value;
    },
    outline (value) {
        const isNoneOrZero = String(value) === "0" || String(value) === "none";
        return value !== null && isNoneOrZero ? {
            outline: "2px solid transparent",
            outlineOffset: "2px"
        } : {
            outline: value
        };
    },
    flexDirection (value) {
        const { space: space, divide: divide } = (0, $88e37d014ec8a612$export$2d29807f3ae71abd)[value] ?? {};
        const result = {
            flexDirection: value
        };
        if (space) result[space] = 1;
        if (divide) result[divide] = 1;
        return result;
    }
};


const $298e3917d07cd4fb$export$625550452a3fa3ec = {
    borderWidths: (0, $cfce0acadbae6d18$export$9ced7da5e9a2be1b)("borderWidths"),
    borderStyles: (0, $cfce0acadbae6d18$export$9ced7da5e9a2be1b)("borderStyles"),
    colors: (0, $cfce0acadbae6d18$export$9ced7da5e9a2be1b)("colors"),
    borders: (0, $cfce0acadbae6d18$export$9ced7da5e9a2be1b)("borders"),
    gradients: (0, $cfce0acadbae6d18$export$9ced7da5e9a2be1b)("gradients", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).gradient),
    radii: (0, $cfce0acadbae6d18$export$9ced7da5e9a2be1b)("radii", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).px),
    space: (0, $cfce0acadbae6d18$export$9ced7da5e9a2be1b)("space", (0, $9259c122d7a79a92$export$a4627e546088548d)((0, $ebcf615ace51411a$export$f1c738cddd9a74ae).vh, (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).px)),
    spaceT: (0, $cfce0acadbae6d18$export$9ced7da5e9a2be1b)("space", (0, $9259c122d7a79a92$export$a4627e546088548d)((0, $ebcf615ace51411a$export$f1c738cddd9a74ae).vh, (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).px)),
    degreeT (property) {
        return {
            property: property,
            transform: (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).degree
        };
    },
    prop (property, scale, transform) {
        return {
            property: property,
            scale: scale,
            ...scale && {
                transform: (0, $ad3fc94f62c40c23$export$99c68a89351e15c0)({
                    scale: scale,
                    transform: transform
                })
            }
        };
    },
    propT (property, transform) {
        return {
            property: property,
            transform: transform
        };
    },
    sizes: (0, $cfce0acadbae6d18$export$9ced7da5e9a2be1b)("sizes", (0, $9259c122d7a79a92$export$a4627e546088548d)((0, $ebcf615ace51411a$export$f1c738cddd9a74ae).vh, (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).px)),
    sizesT: (0, $cfce0acadbae6d18$export$9ced7da5e9a2be1b)("sizes", (0, $9259c122d7a79a92$export$a4627e546088548d)((0, $ebcf615ace51411a$export$f1c738cddd9a74ae).vh, (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).fraction)),
    shadows: (0, $cfce0acadbae6d18$export$9ced7da5e9a2be1b)("shadows"),
    logical: $cfce0acadbae6d18$export$965c6ce6d3869a7a,
    blur: (0, $cfce0acadbae6d18$export$9ced7da5e9a2be1b)("blur", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).blur)
};



const $a47d92dc74e89080$export$8ce1fd94bee2f412 = {
    background: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("background"),
    backgroundColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("backgroundColor"),
    backgroundImage: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).gradients("backgroundImage"),
    backgroundSize: true,
    backgroundPosition: true,
    backgroundRepeat: true,
    backgroundAttachment: true,
    backgroundClip: {
        transform: (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).bgClip
    },
    bgSize: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("backgroundSize"),
    bgPosition: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("backgroundPosition"),
    bg: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("background"),
    bgColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("backgroundColor"),
    bgPos: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("backgroundPosition"),
    bgRepeat: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("backgroundRepeat"),
    bgAttachment: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("backgroundAttachment"),
    bgGradient: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).gradients("backgroundImage"),
    bgClip: {
        transform: (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).bgClip
    }
};
Object.assign($a47d92dc74e89080$export$8ce1fd94bee2f412, {
    bgImage: $a47d92dc74e89080$export$8ce1fd94bee2f412.backgroundImage,
    bgImg: $a47d92dc74e89080$export$8ce1fd94bee2f412.backgroundImage
});



const $1ff845c742d45e90$export$1edee58a52776cd9 = {
    border: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borders("border"),
    borderWidth: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderWidths("borderWidth"),
    borderStyle: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderStyles("borderStyle"),
    borderColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("borderColor"),
    borderRadius: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).radii("borderRadius"),
    borderTop: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borders("borderTop"),
    borderBlockStart: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borders("borderBlockStart"),
    borderTopLeftRadius: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).radii("borderTopLeftRadius"),
    borderStartStartRadius: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).logical({
        scale: "radii",
        property: {
            ltr: "borderTopLeftRadius",
            rtl: "borderTopRightRadius"
        }
    }),
    borderEndStartRadius: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).logical({
        scale: "radii",
        property: {
            ltr: "borderBottomLeftRadius",
            rtl: "borderBottomRightRadius"
        }
    }),
    borderTopRightRadius: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).radii("borderTopRightRadius"),
    borderStartEndRadius: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).logical({
        scale: "radii",
        property: {
            ltr: "borderTopRightRadius",
            rtl: "borderTopLeftRadius"
        }
    }),
    borderEndEndRadius: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).logical({
        scale: "radii",
        property: {
            ltr: "borderBottomRightRadius",
            rtl: "borderBottomLeftRadius"
        }
    }),
    borderRight: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borders("borderRight"),
    borderInlineEnd: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borders("borderInlineEnd"),
    borderBottom: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borders("borderBottom"),
    borderBlockEnd: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borders("borderBlockEnd"),
    borderBottomLeftRadius: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).radii("borderBottomLeftRadius"),
    borderBottomRightRadius: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).radii("borderBottomRightRadius"),
    borderLeft: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borders("borderLeft"),
    borderInlineStart: {
        property: "borderInlineStart",
        scale: "borders"
    },
    borderInlineStartRadius: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ],
            rtl: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ]
        }
    }),
    borderInlineEndRadius: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ],
            rtl: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ]
        }
    }),
    borderX: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borders([
        "borderLeft",
        "borderRight"
    ]),
    borderInline: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borders("borderInline"),
    borderY: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borders([
        "borderTop",
        "borderBottom"
    ]),
    borderBlock: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borders("borderBlock"),
    borderTopWidth: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderWidths("borderTopWidth"),
    borderBlockStartWidth: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderWidths("borderBlockStartWidth"),
    borderTopColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("borderTopColor"),
    borderBlockStartColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("borderBlockStartColor"),
    borderTopStyle: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderStyles("borderTopStyle"),
    borderBlockStartStyle: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderStyles("borderBlockStartStyle"),
    borderBottomWidth: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderWidths("borderBottomWidth"),
    borderBlockEndWidth: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderWidths("borderBlockEndWidth"),
    borderBottomColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("borderBottomColor"),
    borderBlockEndColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("borderBlockEndColor"),
    borderBottomStyle: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderStyles("borderBottomStyle"),
    borderBlockEndStyle: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderStyles("borderBlockEndStyle"),
    borderLeftWidth: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderWidths("borderLeftWidth"),
    borderInlineStartWidth: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderWidths("borderInlineStartWidth"),
    borderLeftColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("borderLeftColor"),
    borderInlineStartColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("borderInlineStartColor"),
    borderLeftStyle: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderStyles("borderLeftStyle"),
    borderInlineStartStyle: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderStyles("borderInlineStartStyle"),
    borderRightWidth: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderWidths("borderRightWidth"),
    borderInlineEndWidth: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderWidths("borderInlineEndWidth"),
    borderRightColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("borderRightColor"),
    borderInlineEndColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("borderInlineEndColor"),
    borderRightStyle: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderStyles("borderRightStyle"),
    borderInlineEndStyle: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).borderStyles("borderInlineEndStyle"),
    borderTopRadius: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).radii([
        "borderTopLeftRadius",
        "borderTopRightRadius"
    ]),
    borderBottomRadius: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).radii([
        "borderBottomLeftRadius",
        "borderBottomRightRadius"
    ]),
    borderLeftRadius: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).radii([
        "borderTopLeftRadius",
        "borderBottomLeftRadius"
    ]),
    borderRightRadius: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).radii([
        "borderTopRightRadius",
        "borderBottomRightRadius"
    ])
};
Object.assign($1ff845c742d45e90$export$1edee58a52776cd9, {
    rounded: $1ff845c742d45e90$export$1edee58a52776cd9.borderRadius,
    roundedTop: $1ff845c742d45e90$export$1edee58a52776cd9.borderTopRadius,
    roundedTopLeft: $1ff845c742d45e90$export$1edee58a52776cd9.borderTopLeftRadius,
    roundedTopRight: $1ff845c742d45e90$export$1edee58a52776cd9.borderTopRightRadius,
    roundedTopStart: $1ff845c742d45e90$export$1edee58a52776cd9.borderStartStartRadius,
    roundedTopEnd: $1ff845c742d45e90$export$1edee58a52776cd9.borderStartEndRadius,
    roundedBottom: $1ff845c742d45e90$export$1edee58a52776cd9.borderBottomRadius,
    roundedBottomLeft: $1ff845c742d45e90$export$1edee58a52776cd9.borderBottomLeftRadius,
    roundedBottomRight: $1ff845c742d45e90$export$1edee58a52776cd9.borderBottomRightRadius,
    roundedBottomStart: $1ff845c742d45e90$export$1edee58a52776cd9.borderEndStartRadius,
    roundedBottomEnd: $1ff845c742d45e90$export$1edee58a52776cd9.borderEndEndRadius,
    roundedLeft: $1ff845c742d45e90$export$1edee58a52776cd9.borderLeftRadius,
    roundedRight: $1ff845c742d45e90$export$1edee58a52776cd9.borderRightRadius,
    roundedStart: $1ff845c742d45e90$export$1edee58a52776cd9.borderInlineStartRadius,
    roundedEnd: $1ff845c742d45e90$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStart: $1ff845c742d45e90$export$1edee58a52776cd9.borderInlineStart,
    borderEnd: $1ff845c742d45e90$export$1edee58a52776cd9.borderInlineEnd,
    borderTopStartRadius: $1ff845c742d45e90$export$1edee58a52776cd9.borderStartStartRadius,
    borderTopEndRadius: $1ff845c742d45e90$export$1edee58a52776cd9.borderStartEndRadius,
    borderBottomStartRadius: $1ff845c742d45e90$export$1edee58a52776cd9.borderEndStartRadius,
    borderBottomEndRadius: $1ff845c742d45e90$export$1edee58a52776cd9.borderEndEndRadius,
    borderStartRadius: $1ff845c742d45e90$export$1edee58a52776cd9.borderInlineStartRadius,
    borderEndRadius: $1ff845c742d45e90$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStartWidth: $1ff845c742d45e90$export$1edee58a52776cd9.borderInlineStartWidth,
    borderEndWidth: $1ff845c742d45e90$export$1edee58a52776cd9.borderInlineEndWidth,
    borderStartColor: $1ff845c742d45e90$export$1edee58a52776cd9.borderInlineStartColor,
    borderEndColor: $1ff845c742d45e90$export$1edee58a52776cd9.borderInlineEndColor,
    borderStartStyle: $1ff845c742d45e90$export$1edee58a52776cd9.borderInlineStartStyle,
    borderEndStyle: $1ff845c742d45e90$export$1edee58a52776cd9.borderInlineEndStyle
});



const $54fd1ae18d67c1fc$export$35e9368ef982300f = {
    color: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("color"),
    textColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("color"),
    fill: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("fill"),
    stroke: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("stroke"),
    accentColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("accentColor"),
    textFillColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("textFillColor")
};




const $6f4ffb4e74c66d93$export$feec61708a55c80e = {
    alignItems: true,
    alignContent: true,
    justifyItems: true,
    justifyContent: true,
    flexWrap: true,
    flexDirection: {
        transform: (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).flexDirection
    },
    flex: true,
    flexFlow: true,
    flexGrow: true,
    flexShrink: true,
    flexBasis: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).sizes("flexBasis"),
    justifySelf: true,
    alignSelf: true,
    order: true,
    placeItems: true,
    placeContent: true,
    placeSelf: true,
    gap: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("gap"),
    rowGap: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("rowGap"),
    columnGap: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("columnGap")
};
Object.assign($6f4ffb4e74c66d93$export$feec61708a55c80e, {
    flexDir: $6f4ffb4e74c66d93$export$feec61708a55c80e.flexDirection
});




const $ae09e8b4a28210d3$export$b3219800bda33a1f = {
    width: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).sizesT("width"),
    inlineSize: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).sizesT("inlineSize"),
    height: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).sizes("height"),
    blockSize: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).sizes("blockSize"),
    boxSize: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).sizes([
        "width",
        "height"
    ]),
    minWidth: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).sizes("minWidth"),
    minInlineSize: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).sizes("minInlineSize"),
    minHeight: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).sizes("minHeight"),
    minBlockSize: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).sizes("minBlockSize"),
    maxWidth: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).sizes("maxWidth"),
    maxInlineSize: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).sizes("maxInlineSize"),
    maxHeight: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).sizes("maxHeight"),
    maxBlockSize: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).sizes("maxBlockSize"),
    overflow: true,
    overflowX: true,
    overflowY: true,
    overscrollBehavior: true,
    overscrollBehaviorX: true,
    overscrollBehaviorY: true,
    display: true,
    aspectRatio: true,
    hideFrom: {
        scale: "breakpoints",
        transform: (value, theme)=>{
            const breakpoint = theme.__breakpoints?.get(value)?.minW ?? value;
            const mq = `@media screen and (min-width: ${breakpoint})`;
            return {
                [mq]: {
                    display: "none"
                }
            };
        }
    },
    hideBelow: {
        scale: "breakpoints",
        transform: (value, theme)=>{
            const breakpoint = theme.__breakpoints?.get(value)?._minW ?? value;
            const mq = `@media screen and (max-width: ${breakpoint})`;
            return {
                [mq]: {
                    display: "none"
                }
            };
        }
    },
    verticalAlign: true,
    boxSizing: true,
    boxDecorationBreak: true,
    float: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).propT("float", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).float),
    objectFit: true,
    objectPosition: true,
    visibility: true,
    isolation: true
};
Object.assign($ae09e8b4a28210d3$export$b3219800bda33a1f, {
    w: $ae09e8b4a28210d3$export$b3219800bda33a1f.width,
    h: $ae09e8b4a28210d3$export$b3219800bda33a1f.height,
    minW: $ae09e8b4a28210d3$export$b3219800bda33a1f.minWidth,
    maxW: $ae09e8b4a28210d3$export$b3219800bda33a1f.maxWidth,
    minH: $ae09e8b4a28210d3$export$b3219800bda33a1f.minHeight,
    maxH: $ae09e8b4a28210d3$export$b3219800bda33a1f.maxHeight,
    overscroll: $ae09e8b4a28210d3$export$b3219800bda33a1f.overscrollBehavior,
    overscrollX: $ae09e8b4a28210d3$export$b3219800bda33a1f.overscrollBehaviorX,
    overscrollY: $ae09e8b4a28210d3$export$b3219800bda33a1f.overscrollBehaviorY
});




const $d1ea2024abf1b1bf$export$3dea766d36a8935f = {
    filter: {
        transform: (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).filter
    },
    blur: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).blur("--chakra-blur"),
    brightness: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).propT("--chakra-brightness", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).brightness),
    contrast: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).propT("--chakra-contrast", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).contrast),
    hueRotate: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).propT("--chakra-hue-rotate", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).hueRotate),
    invert: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).propT("--chakra-invert", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).invert),
    saturate: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).propT("--chakra-saturate", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).saturate),
    dropShadow: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).propT("--chakra-drop-shadow", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).dropShadow),
    backdropFilter: {
        transform: (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).backdropFilter
    },
    backdropBlur: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).blur("--chakra-backdrop-blur"),
    backdropBrightness: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).propT("--chakra-backdrop-brightness", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).brightness),
    backdropContrast: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).propT("--chakra-backdrop-contrast", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).contrast),
    backdropHueRotate: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).propT("--chakra-backdrop-hue-rotate", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).hueRotate),
    backdropInvert: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).propT("--chakra-backdrop-invert", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).invert),
    backdropSaturate: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).propT("--chakra-backdrop-saturate", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).saturate)
};




const $baf44fd4d588ecc4$export$e7d0da6968da5dd = {
    ring: {
        transform: (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).ring
    },
    ringColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("--chakra-ring-color"),
    ringOffset: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("--chakra-ring-offset-width"),
    ringOffsetColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("--chakra-ring-offset-color"),
    ringInset: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("--chakra-ring-inset")
};




const $164b868603b7832f$export$2499a341a8256d68 = {
    appearance: true,
    cursor: true,
    resize: true,
    userSelect: true,
    pointerEvents: true,
    outline: {
        transform: (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).outline
    },
    outlineOffset: true,
    outlineColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("outlineColor")
};



const $2547c21df53e8992$export$85fc379452d91af0 = {
    gridGap: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("gridGap"),
    gridColumnGap: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("gridColumnGap"),
    gridRowGap: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("gridRowGap"),
    gridColumn: true,
    gridRow: true,
    gridAutoFlow: true,
    gridAutoColumns: true,
    gridColumnStart: true,
    gridColumnEnd: true,
    gridRowStart: true,
    gridRowEnd: true,
    gridAutoRows: true,
    gridTemplate: true,
    gridTemplateColumns: true,
    gridTemplateRows: true,
    gridTemplateAreas: true,
    gridArea: true
};


function $95b0c0675fe9660f$export$3988ae62b71be9a3(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
}
const $95b0c0675fe9660f$export$fc10aeed3a532e2a = (fn)=>{
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index)=>{
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, /* @__PURE__ */ new Map());
        const map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        const value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
const $95b0c0675fe9660f$export$1bb32d0c65da6059 = $95b0c0675fe9660f$export$fc10aeed3a532e2a($95b0c0675fe9660f$export$3988ae62b71be9a3);


const $0b43f35ac1e1eea9$var$srOnly = {
    border: "0px",
    clip: "rect(0, 0, 0, 0)",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};
const $0b43f35ac1e1eea9$var$srFocusable = {
    position: "static",
    width: "auto",
    height: "auto",
    clip: "auto",
    padding: "0",
    margin: "0",
    overflow: "visible",
    whiteSpace: "normal"
};
const $0b43f35ac1e1eea9$var$getWithPriority = (theme, key, styles)=>{
    const result = {};
    const obj = (0, $95b0c0675fe9660f$export$1bb32d0c65da6059)(theme, key, {});
    for(const prop in obj){
        const isInStyles = prop in styles && styles[prop] != null;
        if (!isInStyles) result[prop] = obj[prop];
    }
    return result;
};
const $0b43f35ac1e1eea9$export$36263e8f8d7ce3b1 = {
    srOnly: {
        transform (value) {
            if (value === true) return $0b43f35ac1e1eea9$var$srOnly;
            if (value === "focusable") return $0b43f35ac1e1eea9$var$srFocusable;
            return {};
        }
    },
    layerStyle: {
        processResult: true,
        transform: (value, theme, styles)=>$0b43f35ac1e1eea9$var$getWithPriority(theme, `layerStyles.${value}`, styles)
    },
    textStyle: {
        processResult: true,
        transform: (value, theme, styles)=>$0b43f35ac1e1eea9$var$getWithPriority(theme, `textStyles.${value}`, styles)
    },
    apply: {
        processResult: true,
        transform: (value, theme, styles)=>$0b43f35ac1e1eea9$var$getWithPriority(theme, value, styles)
    }
};



const $1e7a1a4872322736$export$5880b8b5730aff45 = {
    position: true,
    pos: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("position"),
    zIndex: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("zIndex", "zIndices"),
    inset: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("inset"),
    insetX: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT([
        "left",
        "right"
    ]),
    insetInline: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("insetInline"),
    insetY: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT([
        "top",
        "bottom"
    ]),
    insetBlock: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("insetBlock"),
    top: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("top"),
    insetBlockStart: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("insetBlockStart"),
    bottom: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("bottom"),
    insetBlockEnd: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("insetBlockEnd"),
    left: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("left"),
    insetInlineStart: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).logical({
        scale: "space",
        property: {
            ltr: "left",
            rtl: "right"
        }
    }),
    right: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("right"),
    insetInlineEnd: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).logical({
        scale: "space",
        property: {
            ltr: "right",
            rtl: "left"
        }
    })
};
Object.assign($1e7a1a4872322736$export$5880b8b5730aff45, {
    insetStart: $1e7a1a4872322736$export$5880b8b5730aff45.insetInlineStart,
    insetEnd: $1e7a1a4872322736$export$5880b8b5730aff45.insetInlineEnd
});



const $13b223486c5cc944$export$dc573d8a6576cdb3 = {
    boxShadow: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).shadows("boxShadow"),
    mixBlendMode: true,
    blendMode: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("mixBlendMode"),
    backgroundBlendMode: true,
    bgBlendMode: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("backgroundBlendMode"),
    opacity: true
};
Object.assign($13b223486c5cc944$export$dc573d8a6576cdb3, {
    shadow: $13b223486c5cc944$export$dc573d8a6576cdb3.boxShadow
});



const $5629c22fbb9910bd$export$a941ed4b947d12f8 = {
    margin: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("margin"),
    marginTop: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("marginTop"),
    marginBlockStart: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("marginBlockStart"),
    marginRight: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("marginRight"),
    marginInlineEnd: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("marginInlineEnd"),
    marginBottom: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("marginBottom"),
    marginBlockEnd: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("marginBlockEnd"),
    marginLeft: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("marginLeft"),
    marginInlineStart: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("marginInlineStart"),
    marginX: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT([
        "marginInlineStart",
        "marginInlineEnd"
    ]),
    marginInline: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("marginInline"),
    marginY: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT([
        "marginTop",
        "marginBottom"
    ]),
    marginBlock: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("marginBlock"),
    padding: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("padding"),
    paddingTop: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("paddingTop"),
    paddingBlockStart: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("paddingBlockStart"),
    paddingRight: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("paddingRight"),
    paddingBottom: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("paddingBottom"),
    paddingBlockEnd: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("paddingBlockEnd"),
    paddingLeft: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("paddingLeft"),
    paddingInlineStart: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("paddingInlineStart"),
    paddingInlineEnd: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("paddingInlineEnd"),
    paddingX: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space([
        "paddingInlineStart",
        "paddingInlineEnd"
    ]),
    paddingInline: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("paddingInline"),
    paddingY: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space([
        "paddingTop",
        "paddingBottom"
    ]),
    paddingBlock: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).space("paddingBlock")
};
Object.assign($5629c22fbb9910bd$export$a941ed4b947d12f8, {
    m: $5629c22fbb9910bd$export$a941ed4b947d12f8.margin,
    mt: $5629c22fbb9910bd$export$a941ed4b947d12f8.marginTop,
    mr: $5629c22fbb9910bd$export$a941ed4b947d12f8.marginRight,
    me: $5629c22fbb9910bd$export$a941ed4b947d12f8.marginInlineEnd,
    marginEnd: $5629c22fbb9910bd$export$a941ed4b947d12f8.marginInlineEnd,
    mb: $5629c22fbb9910bd$export$a941ed4b947d12f8.marginBottom,
    ml: $5629c22fbb9910bd$export$a941ed4b947d12f8.marginLeft,
    ms: $5629c22fbb9910bd$export$a941ed4b947d12f8.marginInlineStart,
    marginStart: $5629c22fbb9910bd$export$a941ed4b947d12f8.marginInlineStart,
    mx: $5629c22fbb9910bd$export$a941ed4b947d12f8.marginX,
    my: $5629c22fbb9910bd$export$a941ed4b947d12f8.marginY,
    p: $5629c22fbb9910bd$export$a941ed4b947d12f8.padding,
    pt: $5629c22fbb9910bd$export$a941ed4b947d12f8.paddingTop,
    py: $5629c22fbb9910bd$export$a941ed4b947d12f8.paddingY,
    px: $5629c22fbb9910bd$export$a941ed4b947d12f8.paddingX,
    pb: $5629c22fbb9910bd$export$a941ed4b947d12f8.paddingBottom,
    pl: $5629c22fbb9910bd$export$a941ed4b947d12f8.paddingLeft,
    ps: $5629c22fbb9910bd$export$a941ed4b947d12f8.paddingInlineStart,
    paddingStart: $5629c22fbb9910bd$export$a941ed4b947d12f8.paddingInlineStart,
    pr: $5629c22fbb9910bd$export$a941ed4b947d12f8.paddingRight,
    pe: $5629c22fbb9910bd$export$a941ed4b947d12f8.paddingInlineEnd,
    paddingEnd: $5629c22fbb9910bd$export$a941ed4b947d12f8.paddingInlineEnd
});



const $5ba5ff21d913b421$export$209876d7b1ac8f3 = {
    scrollBehavior: true,
    scrollSnapAlign: true,
    scrollSnapStop: true,
    scrollSnapType: true,
    // scroll margin
    scrollMargin: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("scrollMargin"),
    scrollMarginTop: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("scrollMarginTop"),
    scrollMarginBottom: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("scrollMarginBottom"),
    scrollMarginLeft: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("scrollMarginLeft"),
    scrollMarginRight: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("scrollMarginRight"),
    scrollMarginX: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT([
        "scrollMarginLeft",
        "scrollMarginRight"
    ]),
    scrollMarginY: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT([
        "scrollMarginTop",
        "scrollMarginBottom"
    ]),
    // scroll padding
    scrollPadding: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("scrollPadding"),
    scrollPaddingTop: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("scrollPaddingTop"),
    scrollPaddingBottom: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("scrollPaddingBottom"),
    scrollPaddingLeft: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("scrollPaddingLeft"),
    scrollPaddingRight: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("scrollPaddingRight"),
    scrollPaddingX: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT([
        "scrollPaddingLeft",
        "scrollPaddingRight"
    ]),
    scrollPaddingY: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT([
        "scrollPaddingTop",
        "scrollPaddingBottom"
    ])
};




const $f5c04ea8aae58d1d$export$d846a084e680d8e = {
    fontFamily: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("fontFamily", "fonts"),
    fontSize: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("fontSize", "fontSizes", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).px),
    fontWeight: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("fontWeight", "fontWeights"),
    lineHeight: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("lineHeight", "lineHeights"),
    letterSpacing: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("letterSpacing", "letterSpacings"),
    textAlign: true,
    fontStyle: true,
    textIndent: true,
    wordBreak: true,
    overflowWrap: true,
    textOverflow: true,
    textTransform: true,
    whiteSpace: true,
    isTruncated: {
        transform (value) {
            if (value === true) return {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            };
        }
    },
    noOfLines: {
        static: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            //@ts-ignore
            WebkitLineClamp: "var(--chakra-line-clamp)"
        },
        property: "--chakra-line-clamp"
    }
};



const $369d921b6589a50e$export$6b7f9af9aa033040 = {
    textDecorationColor: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).colors("textDecorationColor"),
    textDecoration: true,
    textDecor: {
        property: "textDecoration"
    },
    textDecorationLine: true,
    textDecorationStyle: true,
    textDecorationThickness: true,
    textUnderlineOffset: true,
    textShadow: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).shadows("textShadow")
};




const $0019c18f2af1f35a$export$51186ad6e864892a = {
    clipPath: true,
    transform: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).propT("transform", (0, $ebcf615ace51411a$export$f1c738cddd9a74ae).transform),
    transformOrigin: true,
    translateX: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("--chakra-translate-x"),
    translateY: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).spaceT("--chakra-translate-y"),
    skewX: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).degreeT("--chakra-skew-x"),
    skewY: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).degreeT("--chakra-skew-y"),
    scaleX: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("--chakra-scale-x"),
    scaleY: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("--chakra-scale-y"),
    scale: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop([
        "--chakra-scale-x",
        "--chakra-scale-y"
    ]),
    rotate: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).degreeT("--chakra-rotate")
};



const $20ac6eed47626990$export$8837f4fc672e936d = {
    listStyleType: true,
    listStylePosition: true,
    listStylePos: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("listStylePosition"),
    listStyleImage: true,
    listStyleImg: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("listStyleImage")
};



const $af0d7cf68d52de35$export$66bb15e2994e6a26 = {
    transition: true,
    transitionDelay: true,
    animation: true,
    willChange: true,
    transitionDuration: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("transitionDuration", "transition.duration"),
    transitionProperty: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("transitionProperty", "transition.property"),
    transitionTimingFunction: (0, $298e3917d07cd4fb$export$625550452a3fa3ec).prop("transitionTimingFunction", "transition.easing")
};


const $2f4a74a4061ab430$export$30cfa87a708babfc = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, (0, $a47d92dc74e89080$export$8ce1fd94bee2f412), (0, $1ff845c742d45e90$export$1edee58a52776cd9), (0, $54fd1ae18d67c1fc$export$35e9368ef982300f), (0, $6f4ffb4e74c66d93$export$feec61708a55c80e), (0, $ae09e8b4a28210d3$export$b3219800bda33a1f), (0, $d1ea2024abf1b1bf$export$3dea766d36a8935f), (0, $baf44fd4d588ecc4$export$e7d0da6968da5dd), (0, $164b868603b7832f$export$2499a341a8256d68), (0, $2547c21df53e8992$export$85fc379452d91af0), (0, $0b43f35ac1e1eea9$export$36263e8f8d7ce3b1), (0, $1e7a1a4872322736$export$5880b8b5730aff45), (0, $13b223486c5cc944$export$dc573d8a6576cdb3), (0, $5629c22fbb9910bd$export$a941ed4b947d12f8), (0, $5ba5ff21d913b421$export$209876d7b1ac8f3), (0, $f5c04ea8aae58d1d$export$d846a084e680d8e), (0, $369d921b6589a50e$export$6b7f9af9aa033040), (0, $0019c18f2af1f35a$export$51186ad6e864892a), (0, $20ac6eed47626990$export$8837f4fc672e936d), (0, $af0d7cf68d52de35$export$66bb15e2994e6a26));
const $2f4a74a4061ab430$var$layoutSystem = Object.assign({}, (0, $5629c22fbb9910bd$export$a941ed4b947d12f8), (0, $ae09e8b4a28210d3$export$b3219800bda33a1f), (0, $6f4ffb4e74c66d93$export$feec61708a55c80e), (0, $2547c21df53e8992$export$85fc379452d91af0), (0, $1e7a1a4872322736$export$5880b8b5730aff45));
const $2f4a74a4061ab430$export$bccb7c6ca2f4f912 = Object.keys($2f4a74a4061ab430$var$layoutSystem);
const $2f4a74a4061ab430$export$efd83c674fc6ddd4 = (theme)=>[
        ...Object.keys($2f4a74a4061ab430$export$30cfa87a708babfc),
        ...(0, $542184161165dad3$export$a7126a96abbbb621)(theme)
    ];
const $2f4a74a4061ab430$export$891a13dd8973414c = (theme)=>{
    const pseudoSelectors = (0, $542184161165dad3$export$f41ab9e4dfc20352)(theme);
    const styleProps = {
        ...$2f4a74a4061ab430$export$30cfa87a708babfc,
        ...pseudoSelectors
    };
    return (prop)=>{
        return Object.hasOwnProperty.call(styleProps, prop);
    };
};



const $f880b03ec0ecb76d$export$fc306d944aa46af9 = (styles)=>(theme)=>{
        if (!theme.__breakpoints) return styles;
        const { isResponsive: isResponsive, toArrayValue: toArrayValue, media: medias } = theme.__breakpoints;
        const computedStyles = {};
        for(const key in styles){
            let value = (0, $e02dbdd8eca189fb$export$624e501d81f5ffce)(styles[key], theme);
            if (value == null) continue;
            value = (0, $ee96c6227c318ff4$export$a6cdc56e425d0d0a)(value) && isResponsive(value) ? toArrayValue(value) : value;
            if (!Array.isArray(value)) {
                computedStyles[key] = value;
                continue;
            }
            const queries = value.slice(0, medias.length).length;
            for(let index = 0; index < queries; index += 1){
                const media = medias?.[index];
                if (!media) {
                    computedStyles[key] = value[index];
                    continue;
                }
                computedStyles[media] = computedStyles[media] || {};
                if (value[index] == null) continue;
                computedStyles[media][key] = value[index];
            }
        }
        return computedStyles;
    };


function $7a3994bb3789f786$export$7a009bad0a54bada(value) {
    const chunks = [];
    let chunk = "";
    let inParens = false;
    for(let i = 0; i < value.length; i++){
        const char = value[i];
        if (char === "(") {
            inParens = true;
            chunk += char;
        } else if (char === ")") {
            inParens = false;
            chunk += char;
        } else if (char === "," && !inParens) {
            chunks.push(chunk);
            chunk = "";
        } else chunk += char;
    }
    chunk = chunk.trim();
    if (chunk) chunks.push(chunk);
    return chunks;
}


function $1b647ad110670368$var$isCssVar(value) {
    return /^var\(--.+\)$/.test(value);
}
const $1b647ad110670368$var$isCSSVariableTokenValue = (key, value)=>key.startsWith("--") && typeof value === "string" && !$1b647ad110670368$var$isCssVar(value);
const $1b647ad110670368$var$resolveTokenValue = (theme, value)=>{
    if (value == null) return value;
    const getVar = (val)=>theme.__cssMap?.[val]?.varRef;
    const getValue = (val)=>getVar(val) ?? val;
    const [tokenValue, fallbackValue] = (0, $7a3994bb3789f786$export$7a009bad0a54bada)(value);
    value = getVar(tokenValue) ?? getValue(fallbackValue) ?? getValue(value);
    return value;
};
function $1b647ad110670368$export$955358618f994a11(options) {
    const { configs: configs = {}, pseudos: pseudos = {}, theme: theme } = options;
    const css2 = (stylesOrFn, nested = false)=>{
        const _styles = (0, $e02dbdd8eca189fb$export$624e501d81f5ffce)(stylesOrFn, theme);
        const styles = (0, $f880b03ec0ecb76d$export$fc306d944aa46af9)(_styles)(theme);
        let computedStyles = {};
        for(let key in styles){
            const valueOrFn = styles[key];
            let value = (0, $e02dbdd8eca189fb$export$624e501d81f5ffce)(valueOrFn, theme);
            if (key in pseudos) key = pseudos[key];
            if ($1b647ad110670368$var$isCSSVariableTokenValue(key, value)) value = $1b647ad110670368$var$resolveTokenValue(theme, value);
            let config = configs[key];
            if (config === true) config = {
                property: key
            };
            if ((0, $ee96c6227c318ff4$export$a6cdc56e425d0d0a)(value)) {
                computedStyles[key] = computedStyles[key] ?? {};
                computedStyles[key] = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, computedStyles[key], css2(value, true));
                continue;
            }
            let rawValue = config?.transform?.(value, theme, _styles) ?? value;
            rawValue = config?.processResult ? css2(rawValue, true) : rawValue;
            const configProperty = (0, $e02dbdd8eca189fb$export$624e501d81f5ffce)(config?.property, theme);
            if (!nested && config?.static) {
                const staticStyles = (0, $e02dbdd8eca189fb$export$624e501d81f5ffce)(config.static, theme);
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, computedStyles, staticStyles);
            }
            if (configProperty && Array.isArray(configProperty)) {
                for (const property of configProperty)computedStyles[property] = rawValue;
                continue;
            }
            if (configProperty) {
                if (configProperty === "&" && (0, $ee96c6227c318ff4$export$a6cdc56e425d0d0a)(rawValue)) computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, computedStyles, rawValue);
                else computedStyles[configProperty] = rawValue;
                continue;
            }
            if ((0, $ee96c6227c318ff4$export$a6cdc56e425d0d0a)(rawValue)) {
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, computedStyles, rawValue);
                continue;
            }
            computedStyles[key] = rawValue;
        }
        return computedStyles;
    };
    return css2;
}
const $1b647ad110670368$export$dbf350e5966cf602 = (styles)=>(theme)=>{
        const cssFn = $1b647ad110670368$export$955358618f994a11({
            theme: theme,
            pseudos: (0, $542184161165dad3$export$f41ab9e4dfc20352)(theme),
            configs: (0, $2f4a74a4061ab430$export$30cfa87a708babfc)
        });
        return cssFn(styles);
    };


function $e60527e8093ba1ab$var$getLastItem(array) {
    const length = array == null ? 0 : array.length;
    return length ? array[length - 1] : void 0;
}
function $e60527e8093ba1ab$var$analyzeCSSValue(value) {
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
}
function $e60527e8093ba1ab$export$91c0eda1d06bf008(value) {
    if (value == null) return value;
    const { unitless: unitless } = $e60527e8093ba1ab$var$analyzeCSSValue(value);
    return unitless || typeof value === "number" ? `${value}px` : value;
}
const $e60527e8093ba1ab$var$sortByBreakpointValue = (a, b)=>parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
const $e60527e8093ba1ab$var$sortBps = (breakpoints)=>Object.fromEntries(Object.entries(breakpoints).sort($e60527e8093ba1ab$var$sortByBreakpointValue));
function $e60527e8093ba1ab$var$normalize(breakpoints) {
    const sorted = $e60527e8093ba1ab$var$sortBps(breakpoints);
    return Object.assign(Object.values(sorted), sorted);
}
function $e60527e8093ba1ab$var$keys(breakpoints) {
    const value = Object.keys($e60527e8093ba1ab$var$sortBps(breakpoints));
    return new Set(value);
}
function $e60527e8093ba1ab$var$subtract(value) {
    if (!value) return value;
    value = $e60527e8093ba1ab$export$91c0eda1d06bf008(value) ?? value;
    const OFFSET = -0.02;
    return typeof value === "number" ? `${value + OFFSET}` : value.replace(/(\d+\.?\d*)/u, (m)=>`${parseFloat(m) + OFFSET}`);
}
function $e60527e8093ba1ab$export$81f279c16481b446(min, max) {
    const query = [
        "@media screen"
    ];
    if (min) query.push("and", `(min-width: ${$e60527e8093ba1ab$export$91c0eda1d06bf008(min)})`);
    if (max) query.push("and", `(max-width: ${$e60527e8093ba1ab$export$91c0eda1d06bf008(max)})`);
    return query.join(" ");
}
function $e60527e8093ba1ab$export$9aa97eb2b674b920(breakpoints) {
    if (!breakpoints) return null;
    breakpoints.base = breakpoints.base ?? "0px";
    const normalized = $e60527e8093ba1ab$var$normalize(breakpoints);
    const queries = Object.entries(breakpoints).sort($e60527e8093ba1ab$var$sortByBreakpointValue).map(([breakpoint, minW], index, entry)=>{
        let [, maxW] = entry[index + 1] ?? [];
        maxW = parseFloat(maxW) > 0 ? $e60527e8093ba1ab$var$subtract(maxW) : void 0;
        return {
            _minW: $e60527e8093ba1ab$var$subtract(minW),
            breakpoint: breakpoint,
            minW: minW,
            maxW: maxW,
            maxWQuery: $e60527e8093ba1ab$export$81f279c16481b446(null, maxW),
            minWQuery: $e60527e8093ba1ab$export$81f279c16481b446(minW),
            minMaxQuery: $e60527e8093ba1ab$export$81f279c16481b446(minW, maxW)
        };
    });
    const _keys = $e60527e8093ba1ab$var$keys(breakpoints);
    const _keysArr = Array.from(_keys.values());
    return {
        keys: _keys,
        normalized: normalized,
        isResponsive (test) {
            const keys2 = Object.keys(test);
            return keys2.length > 0 && keys2.every((key)=>_keys.has(key));
        },
        asObject: $e60527e8093ba1ab$var$sortBps(breakpoints),
        asArray: $e60527e8093ba1ab$var$normalize(breakpoints),
        details: queries,
        get (key) {
            return queries.find((q)=>q.breakpoint === key);
        },
        media: [
            null,
            ...normalized.map((minW)=>$e60527e8093ba1ab$export$81f279c16481b446(minW)).slice(1)
        ],
        /**
     * Converts the object responsive syntax to array syntax
     *
     * @example
     * toArrayValue({ base: 1, sm: 2, md: 3 }) // => [1, 2, 3]
     */ toArrayValue (test) {
            if (!(0, $ee96c6227c318ff4$export$a6cdc56e425d0d0a)(test)) throw new Error("toArrayValue: value must be an object");
            const result = _keysArr.map((bp)=>test[bp] ?? null);
            while($e60527e8093ba1ab$var$getLastItem(result) === null)result.pop();
            return result;
        },
        /**
     * Converts the array responsive syntax to object syntax
     *
     * @example
     * toObjectValue([1, 2, 3]) // => { base: 1, sm: 2, md: 3 }
     */ toObjectValue (test) {
            if (!Array.isArray(test)) throw new Error("toObjectValue: value must be an array");
            return test.reduce((acc, value, index)=>{
                const key = _keysArr[index];
                if (key != null && value != null) acc[key] = value;
                return acc;
            }, {});
        }
    };
}



var $5Gn6I = parcelRequire("5Gn6I");




function $110eb992cf5d627e$export$915658b6215945a4(target, predicate, options = {}) {
    const { stop: stop, getKey: getKey } = options;
    function inner(value, path = []) {
        if ((0, $ee96c6227c318ff4$export$a6cdc56e425d0d0a)(value) || Array.isArray(value)) {
            const result = {};
            for (const [prop, child] of Object.entries(value)){
                const key = getKey?.(prop) ?? prop;
                const childPath = [
                    ...path,
                    key
                ];
                if (stop?.(value, childPath)) return predicate(value, path);
                result[key] = inner(child, childPath);
            }
            return result;
        }
        return predicate(value, path);
    }
    return inner(target);
}



function $6c431212eaf97cd6$export$357523c63a2253b9(object, keysToPick) {
    const result = {};
    for (const key of keysToPick)if (key in object) result[key] = object[key];
    return result;
}


const $e37b6fe523836bf0$var$tokens = [
    "colors",
    "borders",
    "borderWidths",
    "borderStyles",
    "fonts",
    "fontSizes",
    "fontWeights",
    "gradients",
    "letterSpacings",
    "lineHeights",
    "radii",
    "space",
    "shadows",
    "sizes",
    "zIndices",
    "transition",
    "blur",
    "breakpoints"
];
function $e37b6fe523836bf0$export$10e0af2de97b9ee7(theme) {
    const _tokens = $e37b6fe523836bf0$var$tokens;
    return (0, $6c431212eaf97cd6$export$357523c63a2253b9)(theme, _tokens);
}
function $e37b6fe523836bf0$export$39f91607195ce67d(theme) {
    return theme.semanticTokens;
}
function $e37b6fe523836bf0$export$290969626bfda4a4(rawTheme) {
    const { __cssMap: __cssMap, __cssVars: __cssVars, __breakpoints: __breakpoints, ...cleanTheme } = rawTheme;
    return cleanTheme;
}


function $aa054efcfa543f49$export$8f520cff3dbc4769(theme) {
    const tokens = (0, $e37b6fe523836bf0$export$10e0af2de97b9ee7)(theme);
    const semanticTokens = (0, $e37b6fe523836bf0$export$39f91607195ce67d)(theme);
    const pseudoPropNames = (0, $542184161165dad3$export$a7126a96abbbb621)(theme);
    const isSemanticCondition = (key)=>pseudoPropNames.includes(key) || "default" === key;
    const result = {};
    (0, $110eb992cf5d627e$export$915658b6215945a4)(tokens, (value, path)=>{
        if (value == null) return;
        result[path.join(".")] = {
            isSemantic: false,
            value: value
        };
    });
    (0, $110eb992cf5d627e$export$915658b6215945a4)(semanticTokens, (value, path)=>{
        if (value == null) return;
        result[path.join(".")] = {
            isSemantic: true,
            value: value
        };
    }, {
        stop: (value)=>Object.keys(value).every(isSemanticCondition)
    });
    return result;
}


function $666c521c968ede53$var$tokenToCssVar(token, prefix) {
    return (0, $baa260bb5827f910$export$8b4981022bd80a4e)(String(token).replace(/\./g, "-"), void 0, prefix);
}
function $666c521c968ede53$export$69e96ceeb663bb9(theme) {
    const flatTokens = (0, $aa054efcfa543f49$export$8f520cff3dbc4769)(theme);
    const cssVarPrefix = theme.config?.cssVarPrefix;
    const pseudoSelectors = (0, $542184161165dad3$export$f41ab9e4dfc20352)(theme);
    let cssVars = {};
    const cssMap = {};
    function lookupToken(token, maybeToken) {
        const scale = String(token).split(".")[0];
        const withScale = [
            scale,
            maybeToken
        ].join(".");
        const resolvedTokenValue = flatTokens[withScale];
        if (!resolvedTokenValue) return maybeToken;
        const { reference: reference } = $666c521c968ede53$var$tokenToCssVar(withScale, cssVarPrefix);
        return reference;
    }
    for (const [token, tokenValue] of Object.entries(flatTokens)){
        const { isSemantic: isSemantic, value: value } = tokenValue;
        const { variable: variable, reference: reference } = $666c521c968ede53$var$tokenToCssVar(token, cssVarPrefix);
        if (!isSemantic) {
            if (token.startsWith("space")) {
                const keys = token.split(".");
                const [firstKey, ...referenceKeys] = keys;
                const negativeLookupKey = `${firstKey}.-${referenceKeys.join(".")}`;
                const negativeValue = (0, $fc947a413c6e9a5d$export$42bfa9b2d4dad91a).negate(value);
                const negatedReference = (0, $fc947a413c6e9a5d$export$42bfa9b2d4dad91a).negate(reference);
                cssMap[negativeLookupKey] = {
                    value: negativeValue,
                    var: variable,
                    varRef: negatedReference
                };
            }
            cssVars[variable] = value;
            cssMap[token] = {
                value: value,
                var: variable,
                varRef: reference
            };
            continue;
        }
        const normalizedValue = (0, $ee96c6227c318ff4$export$a6cdc56e425d0d0a)(value) ? value : {
            default: value
        };
        cssVars = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))(cssVars, Object.entries(normalizedValue).reduce((acc, [conditionAlias, conditionValue])=>{
            if (!conditionValue) return acc;
            const tokenReference = lookupToken(token, `${conditionValue}`);
            if (conditionAlias === "default") {
                acc[variable] = tokenReference;
                return acc;
            }
            const conditionSelector = pseudoSelectors?.[conditionAlias] ?? conditionAlias;
            acc[conditionSelector] = {
                [variable]: tokenReference
            };
            return acc;
        }, {}));
        cssMap[token] = {
            value: reference,
            var: variable,
            varRef: reference
        };
    }
    return {
        cssVars: cssVars,
        cssMap: cssMap
    };
}




function $cad82096395b2078$export$d4e5dc2a444c0164(rawTheme) {
    const theme = (0, $e37b6fe523836bf0$export$290969626bfda4a4)(rawTheme);
    const { cssMap: /**
     * This is more like a dictionary of tokens users will type `green.500`,
     * and their equivalent css variable.
     */ cssMap, cssVars: /**
     * The extracted css variables will be stored here, and used in
     * the emotion's <Global/> component to attach variables to `:root`
     */ cssVars } = (0, $666c521c968ede53$export$69e96ceeb663bb9)(theme);
    const defaultCssVars = {
        "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
        "--chakra-ring-offset-width": "0px",
        "--chakra-ring-offset-color": "#fff",
        "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
        "--chakra-ring-offset-shadow": "0 0 #0000",
        "--chakra-ring-shadow": "0 0 #0000",
        "--chakra-space-x-reverse": "0",
        "--chakra-space-y-reverse": "0"
    };
    const isStyleProp = (0, $2f4a74a4061ab430$export$891a13dd8973414c)(theme);
    Object.assign(theme, {
        __cssVars: {
            ...defaultCssVars,
            ...cssVars
        },
        __cssMap: cssMap,
        __breakpoints: (0, $e60527e8093ba1ab$export$9aa97eb2b674b920)(theme.breakpoints),
        __isStyleProp: isStyleProp
    });
    return theme;
}



var $acw62 = parcelRequire("acw62");
function $f5f62380657c0122$var$getErrorMessage(hook, provider) {
    return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
}
function $f5f62380657c0122$export$fd42f52fd3ae1109(options = {}) {
    const { name: name, strict: strict = true, hookName: hookName = "useContext", providerName: providerName = "Provider", errorMessage: errorMessage, defaultValue: defaultValue } = options;
    const Context = (0, $acw62.createContext)(defaultValue);
    Context.displayName = name;
    function useContext$1() {
        const context = (0, $acw62.useContext)(Context);
        if (!context && strict) {
            const error = new Error(errorMessage ?? $f5f62380657c0122$var$getErrorMessage(hookName, providerName));
            error.name = "ContextError";
            Error.captureStackTrace?.(error, useContext$1);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext$1,
        Context
    ];
}

function $7546e7769da6785d$export$3988ae62b71be9a3(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
}
const $7546e7769da6785d$var$memoize = (fn)=>{
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index)=>{
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, /* @__PURE__ */ new Map());
        const map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        const value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
const $7546e7769da6785d$export$1bb32d0c65da6059 = $7546e7769da6785d$var$memoize($7546e7769da6785d$export$3988ae62b71be9a3);




var $acw62 = parcelRequire("acw62");

"use client";
function $e07bb924cf528662$export$d8964aec282183a3(props) {
    const { cssVarsRoot: cssVarsRoot, theme: theme, children: children } = props;
    const computedTheme = (0, $acw62.useMemo)(()=>(0, $cad82096395b2078$export$d4e5dc2a444c0164)(theme), [
        theme
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $f603cc9427f570ab$export$8b22cf2602fb60ce), {
        theme: computedTheme,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($e07bb924cf528662$export$d767872124667db6, {
                root: cssVarsRoot
            }),
            children
        ]
    });
}
function $e07bb924cf528662$export$d767872124667db6({ root: root = ":host, :root" }) {
    const selector = [
        root,
        `[data-theme]`
    ].join(",");
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e0f035ab0866fe47$export$98f03c5d19621d70), {
        styles: (theme)=>({
                [selector]: theme.__cssVars
            })
    });
}
const [$e07bb924cf528662$export$dc4c659861f00dbe, $e07bb924cf528662$export$28e6b9b82ee883c] = (0, $f5f62380657c0122$export$fd42f52fd3ae1109)({
    name: "StylesContext",
    errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function $e07bb924cf528662$export$11d9f9905bcdc114(componentName) {
    return (0, $f5f62380657c0122$export$fd42f52fd3ae1109)({
        name: `${componentName}StylesContext`,
        errorMessage: `useStyles: "styles" is undefined. Seems you forgot to wrap the components in "<${componentName} />" `
    });
}
function $e07bb924cf528662$export$f05794e648629f6c() {
    const { colorMode: colorMode } = (0, $43224bfcd60683b5$export$20f3076712c8dfa)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e0f035ab0866fe47$export$98f03c5d19621d70), {
        styles: (theme)=>{
            const styleObjectOrFn = (0, $7546e7769da6785d$export$1bb32d0c65da6059)(theme, "styles.global");
            const globalStyles = (0, $e02dbdd8eca189fb$export$624e501d81f5ffce)(styleObjectOrFn, {
                theme: theme,
                colorMode: colorMode
            });
            if (!globalStyles) return void 0;
            const styles = (0, $1b647ad110670368$export$dbf350e5966cf602)(globalStyles)(theme);
            return styles;
        }
    });
}




"use client";
const [$07482164f1449a19$var$PortalManagerContextProvider, $07482164f1449a19$export$ef203b29c2cc1f5d] = (0, $f5f62380657c0122$export$fd42f52fd3ae1109)({
    strict: false,
    name: "PortalManagerContext"
});
function $07482164f1449a19$export$52c7ef79917c2f38(props) {
    const { children: children, zIndex: zIndex } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($07482164f1449a19$var$PortalManagerContextProvider, {
        value: {
            zIndex: zIndex
        },
        children: children
    });
}
$07482164f1449a19$export$52c7ef79917c2f38.displayName = "PortalManager";




var $acw62 = parcelRequire("acw62");
"use client";
const $2968f7a4ec8a3686$export$deebe11a338de063 = Boolean(globalThis?.document) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



var $acw62 = parcelRequire("acw62");
"use client";
const $334f639ecd2b23f8$var$EnvironmentContext = (0, $acw62.createContext)({
    getDocument () {
        return document;
    },
    getWindow () {
        return window;
    }
});
$334f639ecd2b23f8$var$EnvironmentContext.displayName = "EnvironmentContext";
function $334f639ecd2b23f8$export$ea7ed2425832167d({ defer: defer } = {}) {
    const [, forceUpdate] = (0, $acw62.useReducer)((c)=>c + 1, 0);
    (0, $2968f7a4ec8a3686$export$deebe11a338de063)(()=>{
        if (!defer) return;
        forceUpdate();
    }, [
        defer
    ]);
    return (0, $acw62.useContext)($334f639ecd2b23f8$var$EnvironmentContext);
}
function $334f639ecd2b23f8$export$29a4c0b32fc9db42(props) {
    const { children: children, environment: environmentProp, disabled: disabled } = props;
    const ref = (0, $acw62.useRef)(null);
    const context = (0, $acw62.useMemo)(()=>{
        if (environmentProp) return environmentProp;
        return {
            getDocument: ()=>ref.current?.ownerDocument ?? document,
            getWindow: ()=>ref.current?.ownerDocument.defaultView ?? window
        };
    }, [
        environmentProp
    ]);
    const showSpan = !disabled || !environmentProp;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)($334f639ecd2b23f8$var$EnvironmentContext.Provider, {
        value: context,
        children: [
            children,
            showSpan && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                id: "__chakra_env",
                hidden: true,
                ref: ref
            })
        ]
    });
}
$334f639ecd2b23f8$export$29a4c0b32fc9db42.displayName = "EnvironmentProvider";


"use client";
const $8e40c08a2dde6692$export$2881499e37b75b9a = (props)=>{
    const { children: children, colorModeManager: colorModeManager, portalZIndex: portalZIndex, resetScope: resetScope, resetCSS: resetCSS = true, theme: theme = {}, environment: environment, cssVarsRoot: cssVarsRoot, disableEnvironment: disableEnvironment, disableGlobalStyle: disableGlobalStyle } = props;
    const _children = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $334f639ecd2b23f8$export$29a4c0b32fc9db42), {
        environment: environment,
        disabled: disableEnvironment,
        children: children
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e07bb924cf528662$export$d8964aec282183a3), {
        theme: theme,
        cssVarsRoot: cssVarsRoot,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $c66eeb0a39f5709f$export$7a858aa3ff83dde7), {
            colorModeManager: colorModeManager,
            options: theme.config,
            children: [
                resetCSS ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $722c916e91f387b3$export$b751feffed387621), {
                    scope: resetScope
                }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $722c916e91f387b3$export$43a6590e493ec44a), {}),
                !disableGlobalStyle && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e07bb924cf528662$export$f05794e648629f6c), {}),
                portalZIndex ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $07482164f1449a19$export$52c7ef79917c2f38), {
                    zIndex: portalZIndex,
                    children: _children
                }) : _children
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $784730508f12f72c$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $9c674755a93db746$export$700979bc83e7db82 = (0, $784730508f12f72c$export$4e09c449d6c407f7) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);


function $c0a2e592950340df$export$80c2a3957bcb42ea() {
    const isMounted = (0, $acw62.useRef)(false);
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}


const $448ce039afb5ec07$export$8793edee2d425525 = (any)=>any;


class $f4ac54c83388ba0d$var$Queue {
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function $f4ac54c83388ba0d$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $f4ac54c83388ba0d$var$Queue();
    let nextFrame = new $f4ac54c83388ba0d$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $d022ffbd5a1b0ae4$export$71ecace0a033b35a = [
    "prepare",
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $d022ffbd5a1b0ae4$var$maxElapsed = 40;
function $d022ffbd5a1b0ae4$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $d022ffbd5a1b0ae4$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $f4ac54c83388ba0d$export$b995e5e85f5c8289)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>steps[stepId].process(state);
    const processBatch = ()=>{
        const timestamp = performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $d022ffbd5a1b0ae4$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $d022ffbd5a1b0ae4$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $d022ffbd5a1b0ae4$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$d022ffbd5a1b0ae4$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $9f96722ff12dbfe7$export$2cef06c20297c17d, cancel: $9f96722ff12dbfe7$export$ec99c0ef4978dccb, state: $9f96722ff12dbfe7$export$fff89137e9e818ce, steps: $9f96722ff12dbfe7$export$be3f796aed065412 } = (0, $d022ffbd5a1b0ae4$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $448ce039afb5ec07$export$8793edee2d425525), true);


function $0316e1262c81ebb4$export$91db9bc4f8ac944a() {
    const isMounted = (0, $c0a2e592950340df$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $acw62.useState)(0);
    const forceRender = (0, $acw62.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $acw62.useCallback)(()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ const $dba5d94a982c4145$export$f224e4635b6f8ce2 = (0, $acw62.createContext)(null);



var $acw62 = parcelRequire("acw62");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $40f5fd83135889a9$export$fe4300aa8eebea86(init) {
    const ref = (0, $acw62.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $acw62 = parcelRequire("acw62");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $6f8c626e496e1918$var$PopChildMeasure extends $acw62.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $6f8c626e496e1918$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $acw62.useId)();
    const ref = (0, $acw62.useRef)(null);
    const size = (0, $acw62.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $acw62.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $acw62.createElement($6f8c626e496e1918$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $acw62.cloneElement(children, {
        ref: ref
    }));
}


const $f57f9e9f321f3a7c$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $40f5fd83135889a9$export$fe4300aa8eebea86)($f57f9e9f321f3a7c$var$newChildrenMap);
    const id = (0, $acw62.useId)();
    const context = (0, $acw62.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $acw62.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $acw62.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $acw62.createElement((0, $6f8c626e496e1918$export$1d6cdde0c6816c6d), {
        isPresent: isPresent
    }, children);
    return $acw62.createElement((0, $dba5d94a982c4145$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $f57f9e9f321f3a7c$var$newChildrenMap() {
    return new Map();
}



var $acw62 = parcelRequire("acw62");
const $4ae202aab5791dbc$export$a3579ca508007a95 = (0, $acw62.createContext)({});




var $acw62 = parcelRequire("acw62");
function $7bbbf777b15ef7cf$export$f3a192d0cbd30b96(callback) {
    return (0, $acw62.useEffect)(()=>()=>callback(), []);
}



let $bf99d85f7a843912$export$491112666e282270 = (0, $448ce039afb5ec07$export$8793edee2d425525);
let $bf99d85f7a843912$export$f5708dca728d7177 = (0, $448ce039afb5ec07$export$8793edee2d425525);
var $bf99d85f7a843912$var$check, $bf99d85f7a843912$var$message, $bf99d85f7a843912$var$check1, $bf99d85f7a843912$var$message1;


const $06516233abcfeeff$var$getChildKey = (child)=>child.key || "";
function $06516233abcfeeff$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $06516233abcfeeff$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $06516233abcfeeff$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $acw62.Children).forEach(children, (child)=>{
        if ((0, $acw62.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $06516233abcfeeff$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95)).forceRender || (0, $0316e1262c81ebb4$export$91db9bc4f8ac944a)()[0];
    const isMounted = (0, $c0a2e592950340df$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $06516233abcfeeff$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $acw62.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $acw62.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $acw62.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $acw62.useRef)(true);
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $06516233abcfeeff$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $7bbbf777b15ef7cf$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return $acw62.createElement($acw62.Fragment, null, childrenToRender.map((child)=>$acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($06516233abcfeeff$var$getChildKey);
    const targetKeys = filteredChildren.map($06516233abcfeeff$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                // clean up the exiting children map
                exitingChildren.delete(key);
                // compute the keys of children that were rendered once but are no longer present
                // this could happen in case of too many fast consequent renderings
                // @link https://github.com/framer/motion/issues/2023
                const leftOverKeys = Array.from(allChildren.keys()).filter((childKey)=>!targetKeys.includes(childKey));
                // clean up the all children map
                leftOverKeys.forEach((leftOverKey)=>allChildren.delete(leftOverKey));
                // make sure to render only the children that are actually visible
                presentChildren.current = filteredChildren.filter((presentChild)=>{
                    const presentChildKey = $06516233abcfeeff$var$getChildKey(presentChild);
                    return(// filter out the node exiting
                    presentChildKey === key || // filter out the leftover children
                    leftOverKeys.includes(presentChildKey));
                });
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = $acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
                key: $06516233abcfeeff$var$getChildKey(child),
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode
            }, child);
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : $acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    return $acw62.createElement($acw62.Fragment, null, exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $acw62.cloneElement)(child)));
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
function $5aeabd701a2e12e7$export$25bec8c6f54ee79a(callback, deps = []) {
    const callbackRef = (0, $acw62.useRef)(callback);
    (0, $acw62.useEffect)(()=>{
        callbackRef.current = callback;
    });
    return (0, $acw62.useCallback)((...args)=>callbackRef.current?.(...args), deps);
}


"use client";
function $f600c73be48e52b0$export$d8e6abf214c9ec0f(callback, delay) {
    const fn = (0, $5aeabd701a2e12e7$export$25bec8c6f54ee79a)(callback);
    (0, $acw62.useEffect)(()=>{
        if (delay == null) return void 0;
        let timeoutId = null;
        timeoutId = window.setTimeout(()=>{
            fn();
        }, delay);
        return ()=>{
            if (timeoutId) window.clearTimeout(timeoutId);
        };
    }, [
        delay,
        fn
    ]);
}


var $acw62 = parcelRequire("acw62");
"use client";
const $b9c7bec3faa3a5b6$export$496315a1608d9602 = (effect, deps)=>{
    const renderCycleRef = (0, $acw62.useRef)(false);
    const effectCycleRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const isMounted = renderCycleRef.current;
        const shouldRun = isMounted && effectCycleRef.current;
        if (shouldRun) return effect();
        effectCycleRef.current = true;
    }, deps);
    (0, $acw62.useEffect)(()=>{
        renderCycleRef.current = true;
        return ()=>{
            renderCycleRef.current = false;
        };
    }, []);
};




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ const $3bbbde5b328b4154$export$22a697fb29aac98d = (0, $acw62.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $acw62 = parcelRequire("acw62");
const $3ce32ada97cfc8f7$export$2285bbca2c666415 = (0, $acw62.createContext)({});



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
const $410b846e117db9e1$export$40f10139ecf1f171 = (0, $acw62.createContext)({
    strict: false
});



/**
 * Convert camelCase to dash-case properties.
 */ const $9dc069bda924fd3f$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();


const $5fd2b57c27674a98$export$ed7b8fa9dbf0105d = "framerAppearId";
const $5fd2b57c27674a98$export$8592e1c077c890a6 = "data-" + (0, $9dc069bda924fd3f$export$9fd24a634729c672)($5fd2b57c27674a98$export$ed7b8fa9dbf0105d);


function $7fb0f4644b9cc8ad$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415));
    const lazyContext = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171));
    const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $acw62.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $acw62.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const wantsHandoff = (0, $acw62.useRef)(Boolean(props[0, $5fd2b57c27674a98$export$8592e1c077c890a6] && !window.HandoffComplete));
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        visualElement.render();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $acw62.useEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            wantsHandoff.current = false;
            // This ensures all future calls to animateChanges() will run in useEffect
            window.HandoffComplete = true;
        }
    });
    return visualElement;
}



var $acw62 = parcelRequire("acw62");
function $d157673547c2a934$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $88efa764bb00537b$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $acw62.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $d157673547c2a934$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $acw62 = parcelRequire("acw62");

/**
 * Decides if the supplied variable is variant label
 */ function $a35be4d5814e7c66$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $1e5344c7f0db9c8f$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $0172fb3d3512f551$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $0172fb3d3512f551$export$1405a65085f40b9 = [
    "initial",
    ...$0172fb3d3512f551$export$16e45afcc206d3a8
];


function $06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) {
    return (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(props.animate) || (0, $0172fb3d3512f551$export$1405a65085f40b9).some((name)=>(0, $a35be4d5814e7c66$export$720b90e312cea233)(props[name]));
}
function $06b1046bf0f33e63$export$ce46fa4165cdec40(props) {
    return Boolean($06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $9e57028cf0cad086$export$12fc32fc096a04a3(props, context) {
    if ((0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $a35be4d5814e7c66$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $a35be4d5814e7c66$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $4cb87fa0b981df8c$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $9e57028cf0cad086$export$12fc32fc096a04a3)(props, (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415)));
    return (0, $acw62.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(initial),
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(animate)
    ]);
}
function $4cb87fa0b981df8c$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $a8d82256030e9525$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $a8d82256030e9525$export$65570e08d843624d = {};
for(const key in $a8d82256030e9525$var$featureProps)$a8d82256030e9525$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$a8d82256030e9525$var$featureProps[key].some((name)=>!!props[name])
};


function $b9879783068c1762$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $a8d82256030e9525$export$65570e08d843624d)[key] = {
        ...(0, $a8d82256030e9525$export$65570e08d843624d)[key],
        ...features[key]
    };
}






var $acw62 = parcelRequire("acw62");
/**
 * Internal, exported only for usage in Framer
 */ const $c612a166b65a9c69$export$da5f7b802957459a = (0, $acw62.createContext)({});


const $9b94ea54d3350cc1$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $b40dad60036091a1$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $b9879783068c1762$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)),
            ...props,
            layoutId: $b40dad60036091a1$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $4cb87fa0b981df8c$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $784730508f12f72c$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $7fb0f4644b9cc8ad$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a));
            const isStrict = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $acw62.createElement((0, $3ce32ada97cfc8f7$export$2285bbca2c666415).Provider, {
            value: context
        }, MeasureLayout && context.visualElement ? $acw62.createElement(MeasureLayout, {
            visualElement: context.visualElement,
            ...configAndProps
        }) : null, useRender(Component, props, (0, $88efa764bb00537b$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
    }
    const ForwardRefComponent = (0, $acw62.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $9b94ea54d3350cc1$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $b40dad60036091a1$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $16a09bb264d348bb$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $b40dad60036091a1$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $1d85745fbdd79bfa$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $ca4ea6365adee72d$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $1d85745fbdd79bfa$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $eced91e16bda42df$export$91ddd985b97788d1 = {};
function $eced91e16bda42df$export$de9e7791c71225fd(correctors) {
    Object.assign($eced91e16bda42df$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $ac502869c4d3e65a$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $ac502869c4d3e65a$export$7b42a0094fb00b6e = new Set($ac502869c4d3e65a$export$280dc01950909d86);


function $443c859766df5778$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $eced91e16bda42df$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $55c3387a92452647$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $1724c99b9b724858$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $1724c99b9b724858$var$numTransforms = (0, $ac502869c4d3e65a$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $1724c99b9b724858$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $1724c99b9b724858$var$numTransforms; i++){
        const key = (0, $ac502869c4d3e65a$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $1724c99b9b724858$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


const $f9c5e88311214d2a$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $f9c5e88311214d2a$export$9de1236619d9e756 = $f9c5e88311214d2a$var$checkStringStartsWith("--");
const $f9c5e88311214d2a$export$31f9caa2600b5723 = $f9c5e88311214d2a$var$checkStringStartsWith("var(--");
const $f9c5e88311214d2a$export$f7c0a352d8ef6313 = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $a19b1277e1098e3a$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $965bce4b5aab9d94$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $965bce4b5aab9d94$export$58f0f39f63f3cf42 = {
    ...$965bce4b5aab9d94$export$98e628dec113755e,
    transform: (v)=>(0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $965bce4b5aab9d94$export$dcdf75081b88279d = {
    ...$965bce4b5aab9d94$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $9d068be114f1d873$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $9d068be114f1d873$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $9d068be114f1d873$export$740b69c5fad25dba = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $9d068be114f1d873$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $9d068be114f1d873$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $25ca921ba8e55794$var$createUnitType = (unit)=>({
        test: (v)=>(0, $9d068be114f1d873$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $25ca921ba8e55794$export$41fc368e1a942b97 = $25ca921ba8e55794$var$createUnitType("deg");
const $25ca921ba8e55794$export$626336c2cd4b14de = $25ca921ba8e55794$var$createUnitType("%");
const $25ca921ba8e55794$export$91c0eda1d06bf008 = $25ca921ba8e55794$var$createUnitType("px");
const $25ca921ba8e55794$export$f91e8c45a95a32f2 = $25ca921ba8e55794$var$createUnitType("vh");
const $25ca921ba8e55794$export$aed3d7b7d206c196 = $25ca921ba8e55794$var$createUnitType("vw");
const $25ca921ba8e55794$export$44e2e1705876d7ed = {
    ...$25ca921ba8e55794$export$626336c2cd4b14de,
    parse: (v)=>$25ca921ba8e55794$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$25ca921ba8e55794$export$626336c2cd4b14de.transform(v * 100)
};



const $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e = {
    ...(0, $965bce4b5aab9d94$export$98e628dec113755e),
    transform: Math.round
};


const $d5c56ef81d4ff9c2$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderRightWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    radius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    maxWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    height: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    maxHeight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    size: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    top: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    right: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    bottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    left: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingTop: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingRight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingBottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingLeft: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    margin: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginTop: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginRight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginBottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginLeft: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateX: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateY: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateZ: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    scale: $965bce4b5aab9d94$export$dcdf75081b88279d,
    scaleX: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    scaleY: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    scaleZ: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    skew: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    skewX: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    skewY: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    distance: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateX: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateY: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateZ: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    x: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    y: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    z: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    perspective: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    transformPerspective: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    opacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    originX: (0, $25ca921ba8e55794$export$44e2e1705876d7ed),
    originY: (0, $25ca921ba8e55794$export$44e2e1705876d7ed),
    originZ: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    numOctaves: (0, $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e)
};


function $a883e7c624291d03$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $f9c5e88311214d2a$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $a19b1277e1098e3a$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $1724c99b9b724858$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $57bb451bc3d87577$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $81d8dfeeb8038b0d$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $55c3387a92452647$export$605d60a2578142d3)(source[key]) && !(0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $81d8dfeeb8038b0d$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $acw62.useMemo)(()=>{
        const state = (0, $57bb451bc3d87577$export$8940b483cf52eeda)();
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $81d8dfeeb8038b0d$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $81d8dfeeb8038b0d$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $81d8dfeeb8038b0d$var$useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function $81d8dfeeb8038b0d$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $81d8dfeeb8038b0d$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $c4bee6acbf082b7d$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $c4bee6acbf082b7d$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $c4bee6acbf082b7d$var$validMotionProps.has(key);
}


let $05db6db4ebcdf5f1$var$shouldForward = (key)=>!(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key);
function $05db6db4ebcdf5f1$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $05db6db4ebcdf5f1$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $05db6db4ebcdf5f1$export$59d6962c470509a5((parcelRequire("8RYFI")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $05db6db4ebcdf5f1$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($05db6db4ebcdf5f1$var$shouldForward(key) || forwardMotionProps === true && (0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || !isDom && !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $acw62 = parcelRequire("acw62");



function $2860344bf6c6c49f$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $2860344bf6c6c49f$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $2860344bf6c6c49f$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $2860344bf6c6c49f$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $f5fdba1fd96a9ba7$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $f5fdba1fd96a9ba7$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $f5fdba1fd96a9ba7$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $f5fdba1fd96a9ba7$var$dashKeys : $f5fdba1fd96a9ba7$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $59f141cfaf6fcabb$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $2860344bf6c6c49f$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $f5fdba1fd96a9ba7$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $b7a2547211637b3c$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $57bb451bc3d87577$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $c139bf35362d2174$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $268dc116ac4d3a3d$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $acw62.useMemo)(()=>{
        const state = (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9)();
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $c139bf35362d2174$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $81d8dfeeb8038b0d$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $dc80cb5954e76638$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $268dc116ac4d3a3d$export$84309c4f53cb1bd5) : (0, $81d8dfeeb8038b0d$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $05db6db4ebcdf5f1$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref: ref
        };
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $acw62.useMemo)(()=>(0, $55c3387a92452647$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $acw62.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}



function $a52b6fc2f3af305f$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $ea3ecc5fb2887a0f$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $9422342e44092cf6$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $a8ee53e44f8c4ac8$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $55c3387a92452647$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $55c3387a92452647$export$605d60a2578142d3)(prevProps.style[key]) || (0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}



function $eac085b45c9e0925$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props, prevProps);
    for(const key in props)if ((0, $55c3387a92452647$export$605d60a2578142d3)(props[key]) || (0, $55c3387a92452647$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $ac502869c4d3e65a$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $acw62 = parcelRequire("acw62");


function $abbf779fde460163$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



const $ef59b2359a289b82$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $21f654501c04362b$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $21f654501c04362b$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $18cbbcef55016eac$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $55c3387a92452647$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $21f654501c04362b$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $5c26ebcca6422185$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $5c26ebcca6422185$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415));
        const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
        const make = ()=>$5c26ebcca6422185$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $40f5fd83135889a9$export$fe4300aa8eebea86)(make);
    };
function $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $06b1046bf0f33e63$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $abbf779fde460163$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}






const $fde6d634ecc7ed6c$export$44dabd3fae512e85 = {
    useVisualState: (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $eac085b45c9e0925$export$16da615486abaa45),
        createRenderState: (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).render(()=>{
                (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, {
                    enableHardwareAcceleration: false
                }, (0, $c139bf35362d2174$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $9422342e44092cf6$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $dcb38e10dcfb6316$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $a8ee53e44f8c4ac8$export$16da615486abaa45,
        createRenderState: (0, $57bb451bc3d87577$export$8940b483cf52eeda)
    })
};


function $73e3a8d89278ed7b$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $fde6d634ecc7ed6c$export$44dabd3fae512e85) : (0, $dcb38e10dcfb6316$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $dc80cb5954e76638$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $43ace1b5a11c3a40$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $6b2f8b101475710a$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $23ab615c547792c0$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const $23ab615c547792c0$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $6b2f8b101475710a$export$a4cf9c8a4b063a6e)(event) && handler(event, $23ab615c547792c0$export$12f84bb882d06e1a(event));
};


function $7fd40e38993f1c69$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(target, eventName, (0, $23ab615c547792c0$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $21841eadb135946f$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $21841eadb135946f$export$a4627e546088548d = (...transformers)=>transformers.reduce($21841eadb135946f$var$combineFunctions);


function $df8cc4eab047d382$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $df8cc4eab047d382$var$globalHorizontalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragHorizontal");
const $df8cc4eab047d382$var$globalVerticalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragVertical");
function $df8cc4eab047d382$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $df8cc4eab047d382$var$globalVerticalLock();
    else if (drag === "x") lock = $df8cc4eab047d382$var$globalHorizontalLock();
    else {
        const openHorizontal = $df8cc4eab047d382$var$globalHorizontalLock();
        const openVertical = $df8cc4eab047d382$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $df8cc4eab047d382$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $df8cc4eab047d382$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $5b9241b1e863e695$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}



function $dfb80d799aa36175$var$addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $df8cc4eab047d382$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        if (props[callbackName]) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>props[callbackName](event, info));
    };
    return (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $dfb80d799aa36175$export$93a81ea037eac456 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $21841eadb135946f$export$a4627e546088548d)($dfb80d799aa36175$var$addHoverEvent(this.node, true), $dfb80d799aa36175$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $46d14c2f8ccf5da4$export$d4826db40d47595b extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $21841eadb135946f$export$a4627e546088548d)((0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $ae5289b89bf4fd95$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $ae5289b89bf4fd95$export$e841ada32ff745b(parent, child.parentElement);
};




function $b3902e3e20ea107a$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $23ab615c547792c0$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $b3902e3e20ea107a$export$f026abdbba7f0c9e extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeEndListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>{
                    /**
                     * We only count this as a tap gesture if the event.target is the same
                     * as, or a child of, this component's element
                     */ !globalTapTarget && !(0, $ae5289b89bf4fd95$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
                });
            };
            const removePointerUpListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $b3902e3e20ea107a$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $b3902e3e20ea107a$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $b3902e3e20ea107a$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $df8cc4eab047d382$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $577133ec08d9e334$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $577133ec08d9e334$var$observers = new WeakMap();
const $577133ec08d9e334$var$fireObserverCallback = (entry)=>{
    const callback = $577133ec08d9e334$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $577133ec08d9e334$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($577133ec08d9e334$var$fireObserverCallback);
};
function $577133ec08d9e334$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$577133ec08d9e334$var$observers.has(lookupRoot)) $577133ec08d9e334$var$observers.set(lookupRoot, {});
    const rootObservers = $577133ec08d9e334$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($577133ec08d9e334$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $577133ec08d9e334$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $577133ec08d9e334$var$initIntersectionObserver(options);
    $577133ec08d9e334$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $577133ec08d9e334$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $3926a5d0685d183c$var$thresholdNames = {
    some: 0,
    all: 1
};
class $3926a5d0685d183c$export$150851c8cc2f0c72 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $3926a5d0685d183c$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $577133ec08d9e334$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($3926a5d0685d183c$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $3926a5d0685d183c$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $5e115984cd871deb$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $3926a5d0685d183c$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $b3902e3e20ea107a$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $46d14c2f8ccf5da4$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $dfb80d799aa36175$export$93a81ea037eac456)
    }
};





function $21ec58272207c53a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $58c1fda9d3891d8d$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $58c1fda9d3891d8d$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $58c1fda9d3891d8d$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $abbf779fde460163$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $58c1fda9d3891d8d$var$getCurrent(visualElement), $58c1fda9d3891d8d$var$getVelocity(visualElement));
}







/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $083454c8244247d6$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $083454c8244247d6$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


const $77818709e1bb6833$export$888a3d84909f9e3d = {
    current: false
};


const $8a5eba8ea233e901$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $877fa42e69510d34$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && $877fa42e69510d34$export$2cf569f5e2221176[easing] || (0, $8a5eba8ea233e901$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($877fa42e69510d34$export$fcdd8f3f2160beda));
}
const $877fa42e69510d34$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $877fa42e69510d34$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $877fa42e69510d34$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return (0, $8a5eba8ea233e901$export$ff43f99925d7366b)(easing) ? $877fa42e69510d34$export$2523b8f0bd8f44cb(easing) : Array.isArray(easing) ? easing.map($877fa42e69510d34$export$916ea73bcd3a6030) : $877fa42e69510d34$export$2cf569f5e2221176[easing];
}


function $db913f3e2f893030$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $877fa42e69510d34$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $b7455746a6cabbfe$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
    return keyframes[index];
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $cdee14e408821ec6$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $cdee14e408821ec6$var$subdivisionPrecision = 0.0000001;
const $cdee14e408821ec6$var$subdivisionMaxIterations = 12;
function $cdee14e408821ec6$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $cdee14e408821ec6$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $cdee14e408821ec6$var$subdivisionPrecision && ++i < $cdee14e408821ec6$var$subdivisionMaxIterations);
    return currentT;
}
function $cdee14e408821ec6$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $448ce039afb5ec07$export$8793edee2d425525;
    const getTForX = (aX)=>$cdee14e408821ec6$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $cdee14e408821ec6$var$calcBezier(getTForX(t), mY1, mY2);
}


const $c24ef35c6cea05c0$export$929e5a82286172a6 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $c24ef35c6cea05c0$export$57636bb43b1ccbb0 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $c24ef35c6cea05c0$export$c07234257a03d5e9 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $b8e36ee1e1d53e83$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $6fc2fca13a5370f0$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $daf16ad73b68faf0$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $66a2361fd99a4040$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $66a2361fd99a4040$export$c8d67a19199d1a50 = (0, $daf16ad73b68faf0$export$2c07eeff45156d4d)($66a2361fd99a4040$export$e444123e42d03385);
const $66a2361fd99a4040$export$30d3455eee55bed5 = (0, $6fc2fca13a5370f0$export$f946554fb8aeaf0d)($66a2361fd99a4040$export$e444123e42d03385);





const $a7ddcde2a4282efd$export$77edfce482316a60 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $a7ddcde2a4282efd$export$b01116c84cdfe1a2 = (0, $daf16ad73b68faf0$export$2c07eeff45156d4d)($a7ddcde2a4282efd$export$77edfce482316a60);
const $a7ddcde2a4282efd$export$ddc5fd596f6c71b2 = (0, $6fc2fca13a5370f0$export$f946554fb8aeaf0d)($a7ddcde2a4282efd$export$b01116c84cdfe1a2);



const $5e5a5cfe1fa796ef$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $a7ddcde2a4282efd$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $15a4078bfbf4856a$var$easingLookup = {
    linear: (0, $448ce039afb5ec07$export$8793edee2d425525),
    easeIn: $c24ef35c6cea05c0$export$929e5a82286172a6,
    easeInOut: $c24ef35c6cea05c0$export$c07234257a03d5e9,
    easeOut: $c24ef35c6cea05c0$export$57636bb43b1ccbb0,
    circIn: $66a2361fd99a4040$export$e444123e42d03385,
    circInOut: $66a2361fd99a4040$export$30d3455eee55bed5,
    circOut: $66a2361fd99a4040$export$c8d67a19199d1a50,
    backIn: $a7ddcde2a4282efd$export$b01116c84cdfe1a2,
    backInOut: $a7ddcde2a4282efd$export$ddc5fd596f6c71b2,
    backOut: $a7ddcde2a4282efd$export$77edfce482316a60,
    anticipate: $5e5a5cfe1fa796ef$export$6b0af63b873d419e
};
const $15a4078bfbf4856a$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $bf99d85f7a843912$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $bf99d85f7a843912$export$f5708dca728d7177)($15a4078bfbf4856a$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $15a4078bfbf4856a$var$easingLookup[definition];
    }
    return definition;
};








/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $ded99e01d9b518c0$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $9d068be114f1d873$export$844ec244b1367d54)(v) && (0, $9d068be114f1d873$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $ded99e01d9b518c0$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $9d068be114f1d873$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $9d068be114f1d873$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $c79d1e7d77418d04$var$clampRgbUnit = (v)=>(0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 255, v);
const $c79d1e7d77418d04$export$7a99c86b5b1f4c9e = {
    ...(0, $965bce4b5aab9d94$export$98e628dec113755e),
    transform: (v)=>Math.round($c79d1e7d77418d04$var$clampRgbUnit(v))
};
const $c79d1e7d77418d04$export$4e46ac54fc82cf3b = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $ded99e01d9b518c0$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(red) + ", " + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(green) + ", " + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)((0, $965bce4b5aab9d94$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $875e9bff470aaa65$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $875e9bff470aaa65$export$834dfc94dde4b3d8 = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("#"),
    parse: $875e9bff470aaa65$var$parseHex,
    transform: (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform
};






const $8bf8a43b3506d305$export$810b04175080204c = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $ded99e01d9b518c0$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $25ca921ba8e55794$export$626336c2cd4b14de).transform((0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $25ca921ba8e55794$export$626336c2cd4b14de).transform((0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)((0, $965bce4b5aab9d94$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $d8fe6ea9e8bd3d9c$export$35e9368ef982300f = {
    test: (v)=>(0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).test(v) || (0, $875e9bff470aaa65$export$834dfc94dde4b3d8).test(v) || (0, $8bf8a43b3506d305$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).test(v)) return (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $8bf8a43b3506d305$export$810b04175080204c).test(v)) return (0, $8bf8a43b3506d305$export$810b04175080204c).parse(v);
        else return (0, $875e9bff470aaa65$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $9d068be114f1d873$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform(v) : (0, $8bf8a43b3506d305$export$810b04175080204c).transform(v);
    }
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $70c54e935a247717$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;




// Adapted from https://gist.github.com/mjackson/5311256
function $fd6f5ba04ea8bac3$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $fd6f5ba04ea8bac3$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue + 1 / 3);
        green = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue);
        blue = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $7691d9e96675321f$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $7691d9e96675321f$var$colorTypes = [
    (0, $875e9bff470aaa65$export$834dfc94dde4b3d8),
    (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b),
    (0, $8bf8a43b3506d305$export$810b04175080204c)
];
const $7691d9e96675321f$var$getColorType = (v)=>$7691d9e96675321f$var$colorTypes.find((type)=>type.test(v));
function $7691d9e96675321f$var$asRGBA(color) {
    const type = $7691d9e96675321f$var$getColorType(color);
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $8bf8a43b3506d305$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $fd6f5ba04ea8bac3$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $7691d9e96675321f$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $7691d9e96675321f$var$asRGBA(from);
    const toRGBA = $7691d9e96675321f$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform(blended);
    };
};












function $b7b50ce2c2d54405$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $9d068be114f1d873$export$844ec244b1367d54)(v) && (((_a = v.match((0, $9d068be114f1d873$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $9d068be114f1d873$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $b7b50ce2c2d54405$var$cssVarTokeniser = {
    regex: (0, $f9c5e88311214d2a$export$f7c0a352d8ef6313),
    countKey: "Vars",
    token: "${v}",
    parse: (0, $448ce039afb5ec07$export$8793edee2d425525)
};
const $b7b50ce2c2d54405$var$colorTokeniser = {
    regex: (0, $9d068be114f1d873$export$740b69c5fad25dba),
    countKey: "Colors",
    token: "${c}",
    parse: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).parse
};
const $b7b50ce2c2d54405$var$numberTokeniser = {
    regex: (0, $9d068be114f1d873$export$2444ca58c08448e4),
    countKey: "Numbers",
    token: "${n}",
    parse: (0, $965bce4b5aab9d94$export$98e628dec113755e).parse
};
function $b7b50ce2c2d54405$var$tokenise(info, { regex: regex, countKey: countKey, token: token, parse: parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches) return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function $b7b50ce2c2d54405$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0
    };
    if (info.value.includes("var(--")) $b7b50ce2c2d54405$var$tokenise(info, $b7b50ce2c2d54405$var$cssVarTokeniser);
    $b7b50ce2c2d54405$var$tokenise(info, $b7b50ce2c2d54405$var$colorTokeniser);
    $b7b50ce2c2d54405$var$tokenise(info, $b7b50ce2c2d54405$var$numberTokeniser);
    return info;
}
function $b7b50ce2c2d54405$var$parseComplexValue(v) {
    return $b7b50ce2c2d54405$export$b61fc7c44bf646d5(v).values;
}
function $b7b50ce2c2d54405$var$createTransformer(source) {
    const { values: values, numColors: numColors, numVars: numVars, tokenised: tokenised } = $b7b50ce2c2d54405$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++){
            if (i < numVars) output = output.replace($b7b50ce2c2d54405$var$cssVarTokeniser.token, v[i]);
            else if (i < numVars + numColors) output = output.replace($b7b50ce2c2d54405$var$colorTokeniser.token, (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).transform(v[i]));
            else output = output.replace($b7b50ce2c2d54405$var$numberTokeniser.token, (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(v[i]));
        }
        return output;
    };
}
const $b7b50ce2c2d54405$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $b7b50ce2c2d54405$var$getAnimatableNone(v) {
    const parsed = $b7b50ce2c2d54405$var$parseComplexValue(v);
    const transformer = $b7b50ce2c2d54405$var$createTransformer(v);
    return transformer(parsed.map($b7b50ce2c2d54405$var$convertNumbersToZero));
}
const $b7b50ce2c2d54405$export$83a0e34f1302825b = {
    test: $b7b50ce2c2d54405$var$test,
    parse: $b7b50ce2c2d54405$var$parseComplexValue,
    createTransformer: $b7b50ce2c2d54405$var$createTransformer,
    getAnimatableNone: $b7b50ce2c2d54405$var$getAnimatableNone
};


const $6ec69123567a0d66$var$mixImmediate = (origin, target)=>(p)=>`${p > 0 ? target : origin}`;
function $6ec69123567a0d66$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $70c54e935a247717$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).test(origin)) return (0, $7691d9e96675321f$export$51e568cf5c039bac)(origin, target);
    else return origin.startsWith("var(") ? $6ec69123567a0d66$var$mixImmediate(origin, target) : $6ec69123567a0d66$export$65516310a87d8205(origin, target);
}
const $6ec69123567a0d66$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$6ec69123567a0d66$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $6ec69123567a0d66$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $6ec69123567a0d66$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $6ec69123567a0d66$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $b7b50ce2c2d54405$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $b7b50ce2c2d54405$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $21841eadb135946f$export$a4627e546088548d)($6ec69123567a0d66$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $bf99d85f7a843912$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return $6ec69123567a0d66$var$mixImmediate(origin, target);
    }
};



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $3a28fe0c82ae45f8$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



const $ec602dd05d6627bc$var$mixNumber = (from, to)=>(p)=>(0, $70c54e935a247717$export$2c9e8a9632a706b2)(from, to, p);
function $ec602dd05d6627bc$var$detectMixerFactory(v) {
    if (typeof v === "number") return $ec602dd05d6627bc$var$mixNumber;
    else if (typeof v === "string") return (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).test(v) ? (0, $7691d9e96675321f$export$51e568cf5c039bac) : (0, $6ec69123567a0d66$export$65516310a87d8205);
    else if (Array.isArray(v)) return 0, $6ec69123567a0d66$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $6ec69123567a0d66$export$ebc23b6840c51ba1;
    return $ec602dd05d6627bc$var$mixNumber;
}
function $ec602dd05d6627bc$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $ec602dd05d6627bc$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $448ce039afb5ec07$export$8793edee2d425525) : ease;
            mixer = (0, $21841eadb135946f$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $ec602dd05d6627bc$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $ec602dd05d6627bc$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $a4ecf42dec726852$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}


function $481477152292f1a1$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $a4ecf42dec726852$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $d61eba3ef0284b9c$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $c1d90d9dcdf1c489$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $c24ef35c6cea05c0$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $b8e36ee1e1d53e83$export$216948827bbdc797)(ease) ? ease.map((0, $15a4078bfbf4856a$export$ef97fe084f156ca4)) : (0, $15a4078bfbf4856a$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $d61eba3ef0284b9c$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $481477152292f1a1$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $ec602dd05d6627bc$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $c1d90d9dcdf1c489$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $acbc43562ac6dbd8$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $8896dd99c5adcd8e$var$velocitySampleDuration = 5; // ms
function $8896dd99c5adcd8e$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $8896dd99c5adcd8e$var$velocitySampleDuration, 0);
    return (0, $acbc43562ac6dbd8$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $18564078b4b5453e$var$safeMin = 0.001;
const $18564078b4b5453e$export$a3cdb76e84ee608e = 0.01;
const $18564078b4b5453e$export$1824b851fad8862b = 10.0;
const $18564078b4b5453e$export$ff08f2d53484465 = 0.05;
const $18564078b4b5453e$export$201ca48e54038115 = 1;
function $18564078b4b5453e$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $bf99d85f7a843912$export$491112666e282270)(duration <= (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)($18564078b4b5453e$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)($18564078b4b5453e$export$ff08f2d53484465, $18564078b4b5453e$export$201ca48e54038115, dampingRatio);
    duration = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)($18564078b4b5453e$export$a3cdb76e84ee608e, $18564078b4b5453e$export$1824b851fad8862b, (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $18564078b4b5453e$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $18564078b4b5453e$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $18564078b4b5453e$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $18564078b4b5453e$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$18564078b4b5453e$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $18564078b4b5453e$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $18564078b4b5453e$var$rootIterations = 12;
function $18564078b4b5453e$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $18564078b4b5453e$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $18564078b4b5453e$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $74970353647274e4$var$durationKeys = [
    "duration",
    "bounce"
];
const $74970353647274e4$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $74970353647274e4$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $74970353647274e4$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$74970353647274e4$var$isSpringType(options, $74970353647274e4$var$physicsKeys) && $74970353647274e4$var$isSpringType(options, $74970353647274e4$var$durationKeys)) {
        const derived = (0, $18564078b4b5453e$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $74970353647274e4$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $74970353647274e4$var$getSpringOptions({
        ...options,
        velocity: -(0, $083454c8244247d6$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $18564078b4b5453e$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $8896dd99c5adcd8e$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $32590f88ff47d1eb$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $74970353647274e4$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $8896dd99c5adcd8e$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t > timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $cf38d8859c00efa2$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing ? (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp : performance.now()
    };
};





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $506ba0ac589a486f$export$f4ff70a5b4808fd8 = 20000;
function $506ba0ac589a486f$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $506ba0ac589a486f$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $506ba0ac589a486f$export$f4ff70a5b4808fd8 ? Infinity : duration;
}



const $f8b512b91d9f08e1$var$types = {
    decay: (0, $32590f88ff47d1eb$export$ee3ff3a17106998),
    inertia: $32590f88ff47d1eb$export$ee3ff3a17106998,
    tween: (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e),
    keyframes: (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e),
    spring: $74970353647274e4$export$b36281d89752ae66
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */ function $f8b512b91d9f08e1$export$ee9b76de7353d815({ autoplay: autoplay = true, delay: delay = 0, driver: driver = (0, $cf38d8859c00efa2$export$c1033964b5ad7fef), keyframes: keyframes$1, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", onPlay: onPlay, onStop: onStop, onComplete: onComplete, onUpdate: onUpdate, ...options }) {
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = $f8b512b91d9f08e1$var$types[type] || (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e);
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     */ let mapNumbersToKeyframes;
    if (generatorFactory !== (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = (0, $ec602dd05d6627bc$export$89e29e4ab65e70a9)([
            0,
            100
        ], keyframes$1, {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const generator = generatorFactory({
        ...options,
        keyframes: keyframes$1
    });
    let mirroredGenerator;
    if (repeatType === "mirror") mirroredGenerator = generatorFactory({
        ...options,
        keyframes: [
            ...keyframes$1
        ].reverse(),
        velocity: -(options.velocity || 0)
    });
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */ if (generator.calculatedDuration === null && repeat) generator.calculatedDuration = (0, $506ba0ac589a486f$export$cbdd6b3d40ea54e2)(generator);
    const { calculatedDuration: calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp)=>{
        if (startTime === null) return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (speed > 0) startTime = Math.min(startTime, timestamp);
        if (speed < 0) startTime = Math.min(timestamp - totalDuration / speed, startTime);
        if (holdTime !== null) currentTime = holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        currentTime = Math.round(timestamp - startTime) * speed;
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
        const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */ if (playState === "finished" && holdTime === null) currentTime = totalDuration;
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes$1[0]
        } : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) state.value = mapNumbersToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
        const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) finish();
        return state;
    };
    const stopAnimationDriver = ()=>{
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = ()=>{
        playState = "idle";
        stopAnimationDriver();
        resolveFinishedPromise();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = ()=>{
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        resolveFinishedPromise();
    };
    const play = ()=>{
        if (hasStopped) return;
        if (!animationDriver) animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) startTime = now - holdTime;
        else if (!startTime || playState === "finished") startTime = now;
        if (playState === "finished") updateFinishedPromise();
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ playState = "running";
        animationDriver.start();
    };
    if (autoplay) play();
    const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time () {
            return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(currentTime);
        },
        set time (newTime){
            newTime = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) holdTime = newTime;
            else startTime = animationDriver.now() - newTime / speed;
        },
        get duration () {
            const duration = generator.calculatedDuration === null ? (0, $506ba0ac589a486f$export$cbdd6b3d40ea54e2)(generator) : generator.calculatedDuration;
            return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(duration);
        },
        get speed () {
            return speed;
        },
        set speed (newSpeed){
            if (newSpeed === speed || !animationDriver) return;
            speed = newSpeed;
            controls.time = (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(currentTime);
        },
        get state () {
            return playState;
        },
        play: play,
        pause: ()=>{
            playState = "paused";
            holdTime = currentTime;
        },
        stop: ()=>{
            hasStopped = true;
            if (playState === "idle") return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: ()=>{
            if (cancelTime !== null) tick(cancelTime);
            cancel();
        },
        complete: ()=>{
            playState = "finished";
        },
        sample: (elapsed)=>{
            startTime = 0;
            return tick(elapsed);
        }
    };
    return controls;
}



function $af0183976178f4ae$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}




const $132e6771f76a8482$var$supportsWaapi = (0, $af0183976178f4ae$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $132e6771f76a8482$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $132e6771f76a8482$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $132e6771f76a8482$var$maxDuration = 20000;
const $132e6771f76a8482$var$requiresPregeneratedKeyframes = (valueName, options)=>options.type === "spring" || valueName === "backgroundColor" || !(0, $877fa42e69510d34$export$fcdd8f3f2160beda)(options.ease);
function $132e6771f76a8482$export$4d5d9557ab897126(value, valueName, { onUpdate: onUpdate, onComplete: onComplete, ...options }) {
    const canAccelerateAnimation = $132e6771f76a8482$var$supportsWaapi() && $132e6771f76a8482$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
    if (!canAccelerateAnimation) return false;
    /**
     * TODO: Unify with js/index
     */ let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Cancelling an animation will write to the DOM. For safety we want to defer
     * this until the next `update` frame lifecycle. This flag tracks whether we
     * have a pending cancel, if so we shouldn't allow animations to finish.
     */ let pendingCancel = false;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes: keyframes, duration: duration = 300, ease: ease, times: times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if ($132e6771f76a8482$var$requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = (0, $f8b512b91d9f08e1$export$ee9b76de7353d815)({
            ...options,
            repeat: 0,
            delay: 0
        });
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */ let t = 0;
        while(!state.done && t < $132e6771f76a8482$var$maxDuration){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += $132e6771f76a8482$var$sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - $132e6771f76a8482$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $db913f3e2f893030$export$c76cd972d26986f9)(value.owner.current, valueName, keyframes, {
        ...options,
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease,
        times: times
    });
    const cancelAnimation = ()=>{
        pendingCancel = false;
        animation.cancel();
    };
    const safeCancel = ()=>{
        pendingCancel = true;
        (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        if (pendingCancel) return;
        value.set((0, $b7455746a6cabbfe$export$14de59408fad90b)(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */ const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        attachTimeline (timeline) {
            animation.timeline = timeline;
            animation.onfinish = null;
            return 0, $448ce039afb5ec07$export$8793edee2d425525;
        },
        get time () {
            return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
        },
        set time (newTime){
            animation.currentTime = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(newTime);
        },
        get speed () {
            return animation.playbackRate;
        },
        set speed (newSpeed){
            animation.playbackRate = newSpeed;
        },
        get duration () {
            return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(duration);
        },
        play: ()=>{
            if (hasStopped) return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */ (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(cancelAnimation);
        },
        pause: ()=>animation.pause(),
        stop: ()=>{
            hasStopped = true;
            if (animation.playState === "idle") return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */ const { currentTime: currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = (0, $f8b512b91d9f08e1$export$ee9b76de7353d815)({
                    ...options,
                    autoplay: false
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - $132e6771f76a8482$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $132e6771f76a8482$var$sampleDelta);
            }
            safeCancel();
        },
        complete: ()=>{
            if (pendingCancel) return;
            animation.finish();
        },
        cancel: safeCancel
    };
    return controls;
}




function $8aad9a13037709d9$export$6f34fc8ef6c42b70({ keyframes: keyframes, delay: delay, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */ return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (0, $448ce039afb5ec07$export$8793edee2d425525),
            pause: (0, $448ce039afb5ec07$export$8793edee2d425525),
            stop: (0, $448ce039afb5ec07$export$8793edee2d425525),
            then: (resolve)=>{
                resolve();
                return Promise.resolve();
            },
            cancel: (0, $448ce039afb5ec07$export$8793edee2d425525),
            complete: (0, $448ce039afb5ec07$export$8793edee2d425525)
        };
    };
    return delay ? (0, $f8b512b91d9f08e1$export$ee9b76de7353d815)({
        keyframes: [
            0,
            1
        ],
        duration: 0,
        delay: delay,
        onComplete: setValue
    }) : setValue();
}



const $5f1d5ca1d398e82d$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $5f1d5ca1d398e82d$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $5f1d5ca1d398e82d$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $5f1d5ca1d398e82d$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $5f1d5ca1d398e82d$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $5f1d5ca1d398e82d$var$keyframesTransition;
    else if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $5f1d5ca1d398e82d$var$criticallyDampedSpring(keyframes[1]) : $5f1d5ca1d398e82d$var$underDampedSpring;
    return $5f1d5ca1d398e82d$var$ease;
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $ef4086713d7b0bdb$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $b7b50ce2c2d54405$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};





/**
 * Properties that should default to 1 or 100%
 */ const $c55938f2e5f09a1e$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $c55938f2e5f09a1e$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $9d068be114f1d873$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $c55938f2e5f09a1e$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $c55938f2e5f09a1e$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $c55938f2e5f09a1e$export$3dea766d36a8935f = {
    ...(0, $b7b50ce2c2d54405$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($c55938f2e5f09a1e$var$functionRegex);
        return functions ? functions.map($c55938f2e5f09a1e$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $6da1de6e0a9a8c9d$export$98cd7c72c5a731fb = {
    ...(0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b),
    color: // Color props
    $d8fe6ea9e8bd3d9c$export$35e9368ef982300f,
    backgroundColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    outlineColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    fill: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    stroke: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderTopColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderRightColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderBottomColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderLeftColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    filter: $c55938f2e5f09a1e$export$3dea766d36a8935f,
    WebkitFilter: (0, $c55938f2e5f09a1e$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $6da1de6e0a9a8c9d$export$67d1babe0338d23b = (key)=>$6da1de6e0a9a8c9d$export$98cd7c72c5a731fb[key];


function $ca0a3798777df465$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $c55938f2e5f09a1e$export$3dea766d36a8935f)) defaultValueType = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}



/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $933209bc9c035719$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);


function $e0feaef7a76d9154$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $933209bc9c035719$export$ade84c85e44a6cb1)(value);
}


function $cef4c9de9cdf8072$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, target);
    let keyframes;
    if (Array.isArray(target)) keyframes = [
        ...target
    ];
    else keyframes = [
        null,
        target
    ];
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for(let i = 0; i < keyframes.length; i++){
        /**
         * Fill null/wildcard keyframes
         */ if (keyframes[i] === null) keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        if ((0, $e0feaef7a76d9154$export$e56af863d5645d5f)(keyframes[i])) noneKeyframeIndexes.push(i);
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") animatableTemplateValue = keyframes[i];
    }
    if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) for(let i = 0; i < noneKeyframeIndexes.length; i++){
        const index = noneKeyframeIndexes[i];
        keyframes[index] = (0, $ca0a3798777df465$export$cea0cedcb94873b5)(valueName, animatableTemplateValue);
    }
    return keyframes;
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $ec9bae3b9c638c7a$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $f69e8e67d72e77c2$export$dd826089e3c5e502 = {
    skipAnimations: false
};


const $9e7a9f8af70c9aa6$export$90b3dfc33ff3548 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $ec9bae3b9c638c7a$export$7c1391340308742e)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(delay);
        const keyframes = (0, $cef4c9de9cdf8072$export$b2b5e866b2fbf2ec)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, targetKeyframe);
        (0, $bf99d85f7a843912$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut",
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $5f1d5ca1d398e82d$export$262124b154b9f1c0)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $77818709e1bb6833$export$888a3d84909f9e3d).current || valueTransition.type === false || (0, $f69e8e67d72e77c2$export$dd826089e3c5e502).skipAnimations) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $8aad9a13037709d9$export$6f34fc8ef6c42b70)((0, $77818709e1bb6833$export$888a3d84909f9e3d).current ? {
            ...options,
            delay: 0
        } : options);
        /**
         * Animate via WAAPI if possible.
         */ if (/**
         * If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         */ !transition.isHandoff && value.owner && value.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = (0, $132e6771f76a8482$export$4d5d9557ab897126)(value, valueName, options);
            if (acceleratedAnimation) return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */ return (0, $f8b512b91d9f08e1$export$ee9b76de7353d815)(options);
    };
};



function $d94f283b675f700d$export$98397f3adbf6259f(value) {
    return Boolean((0, $55c3387a92452647$export$605d60a2578142d3)(value) && value.add);
}


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $d56714d1e4e43615$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);




function $f9c6cc6428ae273c$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $f9c6cc6428ae273c$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $f9c6cc6428ae273c$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $ad746ac6e5aa4783$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}





const $e32104bb79321603$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $e32104bb79321603$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $e32104bb79321603$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "10.18.0";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $e32104bb79321603$var$isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($e32104bb79321603$export$67fcd818a264039d.current) $e32104bb79321603$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $acbc43562ac6dbd8$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $e32104bb79321603$export$ce8bdc721e76545f(init, options) {
    return new $e32104bb79321603$export$8cea36d14ee64562(init, options);
}








/**
 * Tests a provided value against a ValueType
 */ const $a1e2618328995be8$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $c231a4375b038d3c$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $a90ec5e4ad59372f$export$d176691c1998a1f5 = [
    (0, $965bce4b5aab9d94$export$98e628dec113755e),
    (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    (0, $25ca921ba8e55794$export$626336c2cd4b14de),
    (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    (0, $25ca921ba8e55794$export$aed3d7b7d206c196),
    (0, $25ca921ba8e55794$export$f91e8c45a95a32f2),
    (0, $c231a4375b038d3c$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $a90ec5e4ad59372f$export$eefdd52e3ccae428 = (v)=>$a90ec5e4ad59372f$export$d176691c1998a1f5.find((0, $a1e2618328995be8$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $0bb49f6c51badae3$var$valueTypes = [
    ...(0, $a90ec5e4ad59372f$export$d176691c1998a1f5),
    (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    (0, $b7b50ce2c2d54405$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $0bb49f6c51badae3$export$950e7e59ea1ffed7 = (v)=>$0bb49f6c51badae3$var$valueTypes.find((0, $a1e2618328995be8$export$6eae4d0a6a7ca7cd)(v));



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $ea04fe669600292a$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(value));
}
function $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $21f654501c04362b$export$5485128c47bd48bb)(target[key]);
        $ea04fe669600292a$var$setMotionValue(visualElement, key, value);
    }
}
function $ea04fe669600292a$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            $ea04fe669600292a$var$setVariants(child, variantLabels);
        });
    });
}
function $ea04fe669600292a$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $ea04fe669600292a$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $ea04fe669600292a$var$setVariants(visualElement, [
        definition
    ]);
    else $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition);
}
function $ea04fe669600292a$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $d56714d1e4e43615$export$65583ed5a868f2d9)(value) || (0, $933209bc9c035719$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $0bb49f6c51badae3$export$950e7e59ea1ffed7)(value) && (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).test(targetValue)) value = (0, $ca0a3798777df465$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $ea04fe669600292a$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $ea04fe669600292a$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    const origin = {};
    for(const key in target){
        const transitionOrigin = $ea04fe669600292a$export$c3befe8e18686628(key, transition);
        if (transitionOrigin !== undefined) origin[key] = transitionOrigin;
        else {
            const value = visualElement.getValue(key);
            if (value) origin[key] = value.get();
        }
    }
    return origin;
}




/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $14d5e29c1a7af8ca$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $14d5e29c1a7af8ca$var$hasKeyframesChanged(value, target) {
    const current = value.get();
    if (Array.isArray(target)) for(let i = 0; i < target.length; i++){
        if (target[i] !== current) return true;
    }
    else return current !== target;
}
function $14d5e29c1a7af8ca$export$68cacfeee78d98d2(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $14d5e29c1a7af8ca$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...(0, $ec9bae3b9c638c7a$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (window.HandoffAppearAnimations) {
            const appearId = visualElement.getProps()[0, $5fd2b57c27674a98$export$8592e1c077c890a6];
            if (appearId) {
                const elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $9f96722ff12dbfe7$export$2cef06c20297c17d));
                if (elapsed !== null) {
                    valueTransition.elapsed = elapsed;
                    valueTransition.isHandoff = true;
                }
            }
        }
        let canSkip = !valueTransition.isHandoff && !$14d5e29c1a7af8ca$var$hasKeyframesChanged(value, valueTarget);
        if (valueTransition.type === "spring" && (value.getVelocity() || valueTransition.velocity)) canSkip = false;
        /**
         * Temporarily disable skipping animations if there's an animation in
         * progress. Better would be to track the current target of a value
         * and compare that against valueTarget.
         */ if (value.animation) canSkip = false;
        if (canSkip) continue;
        value.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition));
        const animation = value.animation;
        if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        transitionEnd && (0, $ea04fe669600292a$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
    return animations;
}




function $697c3fc694c39c2d$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $14d5e29c1a7af8ca$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $697c3fc694c39c2d$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $697c3fc694c39c2d$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($697c3fc694c39c2d$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($697c3fc694c39c2d$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $697c3fc694c39c2d$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $7d7d5f8a14d3a662$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $697c3fc694c39c2d$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $697c3fc694c39c2d$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $14d5e29c1a7af8ca$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}


const $351ff45a987b08cc$var$reversePriorityOrder = [
    ...(0, $0172fb3d3512f551$export$16e45afcc206d3a8)
].reverse();
const $351ff45a987b08cc$var$numAnimationTypes = (0, $0172fb3d3512f551$export$16e45afcc206d3a8).length;
function $351ff45a987b08cc$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $7d7d5f8a14d3a662$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $351ff45a987b08cc$export$bb53502b7a672aa8(visualElement) {
    let animate = $351ff45a987b08cc$var$animateList(visualElement);
    const state = $351ff45a987b08cc$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
            acc = {
                ...acc,
                ...target,
                ...transitionEnd
            };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $351ff45a987b08cc$var$numAnimationTypes; i++){
            const type = $351ff45a987b08cc$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $a35be4d5814e7c66$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $351ff45a987b08cc$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(next) && (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type,
                        ...options
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $351ff45a987b08cc$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $351ff45a987b08cc$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $351ff45a987b08cc$var$createState() {
    return {
        animate: $351ff45a987b08cc$var$createTypeState(true),
        whileInView: $351ff45a987b08cc$var$createTypeState(),
        whileHover: $351ff45a987b08cc$var$createTypeState(),
        whileTap: $351ff45a987b08cc$var$createTypeState(),
        whileDrag: $351ff45a987b08cc$var$createTypeState(),
        whileFocus: $351ff45a987b08cc$var$createTypeState(),
        exit: $351ff45a987b08cc$var$createTypeState()
    };
}



class $bfc36aed86970b83$export$b45b3fe5caabdca extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $351ff45a987b08cc$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}



let $7ad505f20eee7073$var$id = 0;
class $7ad505f20eee7073$export$4989d1eb6104cc6c extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $7ad505f20eee7073$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete, custom: custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
            custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
        });
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $03e8b675a1009b68$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $bfc36aed86970b83$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $7ad505f20eee7073$export$4989d1eb6104cc6c)
    }
};









const $8eeaeb5692ba8175$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $8eeaeb5692ba8175$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.x, b.x);
    const yDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $2bb1a5b2e1002b2e$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $2bb1a5b2e1002b2e$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $8eeaeb5692ba8175$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $2bb1a5b2e1002b2e$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $6b2f8b101475710a$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $23ab615c547792c0$export$12f84bb882d06e1a)(event);
        const initialInfo = $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $2bb1a5b2e1002b2e$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $21841eadb135946f$export$a4627e546088548d)((0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $2bb1a5b2e1002b2e$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $2bb1a5b2e1002b2e$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $2bb1a5b2e1002b2e$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $2bb1a5b2e1002b2e$var$subtractPoint(point, $2bb1a5b2e1002b2e$var$lastDevicePoint(history)),
        offset: $2bb1a5b2e1002b2e$var$subtractPoint(point, $2bb1a5b2e1002b2e$var$startDevicePoint(history)),
        velocity: $2bb1a5b2e1002b2e$var$getVelocity(history, 0.1)
    };
}
function $2bb1a5b2e1002b2e$var$startDevicePoint(history) {
    return history[0];
}
function $2bb1a5b2e1002b2e$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $2bb1a5b2e1002b2e$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $2bb1a5b2e1002b2e$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $b352f7cdd42c49d7$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $b352f7cdd42c49d7$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $b352f7cdd42c49d7$export$c1c127004b72a37(target) / $b352f7cdd42c49d7$export$c1c127004b72a37(source);
    if ($b352f7cdd42c49d7$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($b352f7cdd42c49d7$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $b352f7cdd42c49d7$export$c0d25e96fc67d310(delta, source, target, origin) {
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $b352f7cdd42c49d7$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(relative);
}
function $b352f7cdd42c49d7$export$426154f9d100f99(target, relative, parent) {
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(layout);
}
function $b352f7cdd42c49d7$export$2785bfcc929c5650(target, layout, parent) {
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $70c54e935a247717$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $2df0cf7aa8fef8fc$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $2df0cf7aa8fef8fc$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.x, left, right),
        y: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $2df0cf7aa8fef8fc$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $2df0cf7aa8fef8fc$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(source);
    const targetLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $2df0cf7aa8fef8fc$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22(dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742;
    return {
        x: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $a3727e4e12b23353$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $a3727e4e12b23353$export$3d227df54007d73a = ()=>({
        x: $a3727e4e12b23353$export$ff25708b37f72782(),
        y: $a3727e4e12b23353$export$ff25708b37f72782()
    });
const $a3727e4e12b23353$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $a3727e4e12b23353$export$6459fc9e86be362e = ()=>({
        x: $a3727e4e12b23353$export$6db76765312617ac(),
        y: $a3727e4e12b23353$export$6db76765312617ac()
    });


function $247f90d2510fbc55$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $0e0401fe38bd0bd1$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $0e0401fe38bd0bd1$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $0e0401fe38bd0bd1$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $fe0ee806cd19fc1f$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fe0ee806cd19fc1f$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$fe0ee806cd19fc1f$var$isIdentityScale(scale) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleX) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleY);
}
function $fe0ee806cd19fc1f$export$a545127cf1fbb600(values) {
    return $fe0ee806cd19fc1f$export$bdf30dca883ea463(values) || $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) {
    return $fe0ee806cd19fc1f$var$is2DTranslate(values.x) || $fe0ee806cd19fc1f$var$is2DTranslate(values.y);
}
function $fe0ee806cd19fc1f$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $d8332eb74969584e$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $d8332eb74969584e$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $d8332eb74969584e$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $d8332eb74969584e$export$d80074982803af5c(box, { x: x, y: y }) {
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $d8332eb74969584e$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $d8332eb74969584e$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $d8332eb74969584e$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) $d8332eb74969584e$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $d8332eb74969584e$var$snapToDefault(treeScale.x);
    treeScale.y = $d8332eb74969584e$var$snapToDefault(treeScale.y);
}
function $d8332eb74969584e$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $d8332eb74969584e$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $d8332eb74969584e$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $d8332eb74969584e$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $d8332eb74969584e$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $d8332eb74969584e$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $d8332eb74969584e$export$58b16271041fbfb(box, transform) {
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.x, transform, $d8332eb74969584e$var$xKeys);
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.y, transform, $d8332eb74969584e$var$yKeys);
}


function $4ca2f8055771ddf4$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)((0, $0e0401fe38bd0bd1$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $4ca2f8055771ddf4$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $4ca2f8055771ddf4$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
const $763b481d779908b7$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};



const $59924ee873defaad$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $59924ee873defaad$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $23ab615c547792c0$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $df8cc4eab047d382$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onDragStart(event, info), false, true);
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $59924ee873defaad$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $2bb1a5b2e1002b2e$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $763b481d779908b7$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $2df0cf7aa8fef8fc$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $d157673547c2a934$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $bf99d85f7a843912$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $4ca2f8055771ddf4$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $2df0cf7aa8fef8fc$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $0e0401fe38bd0bd1$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $2df0cf7aa8fef8fc$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $59924ee873defaad$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $2df0cf7aa8fef8fc$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $59924ee873defaad$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $59924ee873defaad$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $abae7830ca84eed8$export$5d97dc2872682820 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.controls = new (0, $59924ee873defaad$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $448ce039afb5ec07$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $d43ff984f7bd7f1a$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>handler(event, info));
    };
class $d43ff984f7bd7f1a$export$b4f8f1ee75ce5859 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $448ce039afb5ec07$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $2bb1a5b2e1002b2e$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $763b481d779908b7$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $d43ff984f7bd7f1a$var$asyncHandler(onPanSessionStart),
            onStart: $d43ff984f7bd7f1a$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $bc77fac60b5d77cc$export$2a8c16d82a0a0e26() {
    const context = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $acw62.useId)();
    (0, $acw62.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $bc77fac60b5d77cc$export$8249053f690ea39a() {
    return $bc77fac60b5d77cc$export$ee27c052bca048fb((0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2)));
}
function $bc77fac60b5d77cc$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $b29dc04080b74d0c$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $967b202c839557ef$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $967b202c839557ef$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $25ca921ba8e55794$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $967b202c839557ef$export$fafff692be55225d(latest, node.target.x);
        const y = $967b202c839557ef$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $a42cd9e0ef50cb70$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};




class $cdf2a2ac04e7ce67$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $eced91e16bda42df$export$de9e7791c71225fd)($cdf2a2ac04e7ce67$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            queueMicrotask(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $cdf2a2ac04e7ce67$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $bc77fac60b5d77cc$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cdf2a2ac04e7ce67$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $cdf2a2ac04e7ce67$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $967b202c839557ef$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    boxShadow: (0, $a42cd9e0ef50cb70$export$eb0bc629e74dcf8)
};








const $82b1c16a20b13fa0$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $82b1c16a20b13fa0$var$numBorders = $82b1c16a20b13fa0$var$borders.length;
const $82b1c16a20b13fa0$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $82b1c16a20b13fa0$var$isPx = (value)=>typeof value === "number" || (0, $25ca921ba8e55794$export$91c0eda1d06bf008).test(value);
function $82b1c16a20b13fa0$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $82b1c16a20b13fa0$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, 0, $82b1c16a20b13fa0$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $82b1c16a20b13fa0$var$numBorders; i++){
        const borderLabel = `border${$82b1c16a20b13fa0$var$borders[i]}Radius`;
        let followRadius = $82b1c16a20b13fa0$var$getRadius(follow, borderLabel);
        let leadRadius = $82b1c16a20b13fa0$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $82b1c16a20b13fa0$var$isPx(followRadius) === $82b1c16a20b13fa0$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $70c54e935a247717$export$2c9e8a9632a706b2)($82b1c16a20b13fa0$var$asNumber(followRadius), $82b1c16a20b13fa0$var$asNumber(leadRadius), progress), 0);
            if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(leadRadius) || (0, $25ca921ba8e55794$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $82b1c16a20b13fa0$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $82b1c16a20b13fa0$var$easeCrossfadeIn = $82b1c16a20b13fa0$var$compress(0, 0.5, (0, $66a2361fd99a4040$export$c8d67a19199d1a50));
const $82b1c16a20b13fa0$var$easeCrossfadeOut = $82b1c16a20b13fa0$var$compress(0.5, 0.95, (0, $448ce039afb5ec07$export$8793edee2d425525));
function $82b1c16a20b13fa0$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$c53fd88f45d77e4b(box, originBox) {
    $5960d81994414d5a$export$a0230ae482601ae8(box.x, originBox.x);
    $5960d81994414d5a$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $db628fcc785b8b87$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $db628fcc785b8b87$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $db628fcc785b8b87$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $db628fcc785b8b87$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $db628fcc785b8b87$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.x, transforms, $db628fcc785b8b87$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.y, transforms, $db628fcc785b8b87$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $b070f9c5f268d45c$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $b070f9c5f268d45c$export$a7ec7642fe550fb6(delta) {
    return $b070f9c5f268d45c$var$isAxisDeltaZero(delta.x) && $b070f9c5f268d45c$var$isAxisDeltaZero(delta.y);
}
function $b070f9c5f268d45c$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $b070f9c5f268d45c$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $b070f9c5f268d45c$export$c5706146bc63213(box) {
    return (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(box.x) / (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(box.y);
}



class $a040ab986103db06$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $0214cdf9d4bb801d$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $8e214807702da081$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $e21f5e6c9473a18c$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $8e214807702da081$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}





/**
 * Timeout defined in ms
 */ function $fab50a206e6cc096$export$1391212d75b2ee65(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(checkElapsed);
}



function $0b58405220d0640d$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $c4715fe9f944e8b8$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $f5de8fc8cd768a38$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $55c3387a92452647$export$605d60a2578142d3)(value) ? value : (0, $e32104bb79321603$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}





const $d2ca41ba1b84bcfe$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $d2ca41ba1b84bcfe$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $d2ca41ba1b84bcfe$var$animationTarget = 1000;
let $d2ca41ba1b84bcfe$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $d2ca41ba1b84bcfe$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $d2ca41ba1b84bcfe$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $d2ca41ba1b84bcfe$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $d2ca41ba1b84bcfe$var$projectionFrameData.totalNodes = $d2ca41ba1b84bcfe$var$projectionFrameData.resolvedTargetDeltas = $d2ca41ba1b84bcfe$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($d2ca41ba1b84bcfe$export$131f2f0cc5fe9609);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$resolveTargetDelta);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$calcProjection);
                this.nodes.forEach($d2ca41ba1b84bcfe$export$c2664f37bc951031);
                (0, $0b58405220d0640d$export$e5185e241753e543)($d2ca41ba1b84bcfe$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $e21f5e6c9473a18c$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $c4715fe9f944e8b8$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $fab50a206e6cc096$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($d2ca41ba1b84bcfe$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $d2ca41ba1b84bcfe$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $b070f9c5f268d45c$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $ec9bae3b9c638c7a$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $d2ca41ba1b84bcfe$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($d2ca41ba1b84bcfe$var$resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($d2ca41ba1b84bcfe$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($d2ca41ba1b84bcfe$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($d2ca41ba1b84bcfe$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($d2ca41ba1b84bcfe$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = performance.now();
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).delta = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp);
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp = now;
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing = true;
            (0, $9f96722ff12dbfe7$export$be3f796aed065412).update.process((0, $9f96722ff12dbfe7$export$fff89137e9e818ce));
            (0, $9f96722ff12dbfe7$export$be3f796aed065412).preRender.process((0, $9f96722ff12dbfe7$export$fff89137e9e818ce));
            (0, $9f96722ff12dbfe7$export$be3f796aed065412).render.process((0, $9f96722ff12dbfe7$export$fff89137e9e818ce));
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                queueMicrotask(()=>this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($d2ca41ba1b84bcfe$var$clearSnapshot);
            this.sharedNodes.forEach($d2ca41ba1b84bcfe$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $d2ca41ba1b84bcfe$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $b352f7cdd42c49d7$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $d8332eb74969584e$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $d2ca41ba1b84bcfe$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $d8332eb74969584e$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) lead.target = lead.layout.layoutBox;
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $0214cdf9d4bb801d$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $d2ca41ba1b84bcfe$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($d2ca41ba1b84bcfe$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $b070f9c5f268d45c$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $82b1c16a20b13fa0$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>{
                (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $f5de8fc8cd768a38$export$335a17c977067b99)(0, $d2ca41ba1b84bcfe$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($d2ca41ba1b84bcfe$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                const xLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $d8332eb74969584e$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $a040ab986103db06$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < $d2ca41ba1b84bcfe$var$transformAxes.length; i++){
                const key = "rotate" + $d2ca41ba1b84bcfe$var$transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $d2ca41ba1b84bcfe$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $0214cdf9d4bb801d$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $eced91e16bda42df$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $eced91e16bda42df$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $d2ca41ba1b84bcfe$var$updateLayout(node) {
    node.updateLayout();
}
function $d2ca41ba1b84bcfe$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        if (isShared) (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $b070f9c5f268d45c$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $d2ca41ba1b84bcfe$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $d2ca41ba1b84bcfe$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $d2ca41ba1b84bcfe$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $d2ca41ba1b84bcfe$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $d2ca41ba1b84bcfe$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $d2ca41ba1b84bcfe$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $d2ca41ba1b84bcfe$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $d2ca41ba1b84bcfe$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $d2ca41ba1b84bcfe$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $d2ca41ba1b84bcfe$var$calcProjection(node) {
    node.calcProjection();
}
function $d2ca41ba1b84bcfe$var$resetRotation(node) {
    node.resetRotation();
}
function $d2ca41ba1b84bcfe$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(output, from, to, p) {
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $d2ca41ba1b84bcfe$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $d2ca41ba1b84bcfe$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $d2ca41ba1b84bcfe$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $d2ca41ba1b84bcfe$var$roundPoint = $d2ca41ba1b84bcfe$var$userAgentContains("applewebkit/") && !$d2ca41ba1b84bcfe$var$userAgentContains("chrome/") ? Math.round : (0, $448ce039afb5ec07$export$8793edee2d425525);
function $d2ca41ba1b84bcfe$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $d2ca41ba1b84bcfe$var$roundPoint(axis.min);
    axis.max = $d2ca41ba1b84bcfe$var$roundPoint(axis.max);
}
function $d2ca41ba1b84bcfe$var$roundBox(box) {
    $d2ca41ba1b84bcfe$var$roundAxis(box.x);
    $d2ca41ba1b84bcfe$var$roundAxis(box.y);
}
function $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $b352f7cdd42c49d7$export$28d0384c4b79bde2)((0, $b070f9c5f268d45c$export$c5706146bc63213)(snapshot), (0, $b070f9c5f268d45c$export$c5706146bc63213)(layout), 0.2);
}




const $6e97f3a9a89d5fc1$export$2d029a49a09b6177 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $a3289660bde9b219$export$b91509fcf893b648 = {
    current: undefined
};
const $a3289660bde9b219$export$b61a9eb3dbde8858 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$a3289660bde9b219$export$b91509fcf893b648.current) {
            const documentNode = new (0, $6e97f3a9a89d5fc1$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $a3289660bde9b219$export$b91509fcf893b648.current = documentNode;
        }
        return $a3289660bde9b219$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $fc1974bcfc4fde1a$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $d43ff984f7bd7f1a$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $abae7830ca84eed8$export$5d97dc2872682820),
        ProjectionNode: (0, $a3289660bde9b219$export$b61a9eb3dbde8858),
        MeasureLayout: $cdf2a2ac04e7ce67$export$779f5fb01ad751cd
    }
};













/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $ac0e5a3978f40f61$var$splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current) {
    const match = $ac0e5a3978f40f61$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $ac0e5a3978f40f61$var$maxDepth = 4;
function $ac0e5a3978f40f61$var$getVariableValue(current, element, depth = 1) {
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(depth <= $ac0e5a3978f40f61$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $d56714d1e4e43615$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    } else if ((0, $f9c5e88311214d2a$export$31f9caa2600b5723)(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $ac0e5a3978f40f61$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $ac0e5a3978f40f61$export$669319b042b57350(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!(0, $f9c5e88311214d2a$export$31f9caa2600b5723)(current)) return;
        const resolved = $ac0e5a3978f40f61$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!(0, $f9c5e88311214d2a$export$31f9caa2600b5723)(current)) continue;
        const resolved = $ac0e5a3978f40f61$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd) transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}









const $a731b8aa4fe311d9$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $a731b8aa4fe311d9$var$isPositionalKey = (key)=>$a731b8aa4fe311d9$var$positionalKeys.has(key);
const $a731b8aa4fe311d9$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($a731b8aa4fe311d9$var$isPositionalKey);
};
const $a731b8aa4fe311d9$var$isNumOrPxType = (v)=>v === (0, $965bce4b5aab9d94$export$98e628dec113755e) || v === (0, $25ca921ba8e55794$export$91c0eda1d06bf008);
const $a731b8aa4fe311d9$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $a731b8aa4fe311d9$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $a731b8aa4fe311d9$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $a731b8aa4fe311d9$var$nonTranslationalTransformKeys = (0, $ac502869c4d3e65a$export$280dc01950909d86).filter((key)=>!$a731b8aa4fe311d9$var$transformKeys.has(key));
function $a731b8aa4fe311d9$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $a731b8aa4fe311d9$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $a731b8aa4fe311d9$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $a731b8aa4fe311d9$var$getTranslateFromMatrix(4, 13),
    y: $a731b8aa4fe311d9$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$a731b8aa4fe311d9$export$781d46a8aa670d52.translateX = $a731b8aa4fe311d9$export$781d46a8aa670d52.x;
$a731b8aa4fe311d9$export$781d46a8aa670d52.translateY = $a731b8aa4fe311d9$export$781d46a8aa670d52.y;
const $a731b8aa4fe311d9$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $a731b8aa4fe311d9$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = $a731b8aa4fe311d9$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $a731b8aa4fe311d9$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter($a731b8aa4fe311d9$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++){
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */ if (to[i] === null) break;
                if (!toType) {
                    toType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to[i]);
                    (0, $bf99d85f7a843912$export$f5708dca728d7177)(toType === fromType || $a731b8aa4fe311d9$var$isNumOrPxType(fromType) && $a731b8aa4fe311d9$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
                } else (0, $bf99d85f7a843912$export$f5708dca728d7177)((0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
            }
        } else toType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($a731b8aa4fe311d9$var$isNumOrPxType(fromType) && $a731b8aa4fe311d9$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $25ca921ba8e55794$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $a731b8aa4fe311d9$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $a731b8aa4fe311d9$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $784730508f12f72c$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $a731b8aa4fe311d9$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $a731b8aa4fe311d9$var$hasPositionalKey(target) ? $a731b8aa4fe311d9$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $d9a589b84d5ec1d1$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $ac0e5a3978f40f61$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $a731b8aa4fe311d9$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};






// Does this device prefer reduced motion? Returns `null` server-side.
const $5d1c3a7750a03ec7$export$ff7706047246b98b = {
    current: null
};
const $5d1c3a7750a03ec7$export$6476d16e2fd2d0db = {
    current: false
};


function $402b11b96c54cb2c$export$ca9f41fb23dded3d() {
    (0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current = true;
    if (!(0, $784730508f12f72c$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current = false;
}














function $69635cdb8982f9d2$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $55c3387a92452647$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $55c3387a92452647$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $a4ccbde0d696dfdf$export$bc2a978a17abfdde = new WeakMap();



const $e66750f3fb0f96bb$var$featureNames = Object.keys((0, $a8d82256030e9525$export$65570e08d843624d));
const $e66750f3fb0f96bb$var$numFeatures = $e66750f3fb0f96bb$var$featureNames.length;
const $e66750f3fb0f96bb$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $e66750f3fb0f96bb$var$numVariantProps = (0, $0172fb3d3512f551$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $e66750f3fb0f96bb$export$fa8b653c0f3714e5 {
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $06b1046bf0f33e63$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $55c3387a92452647$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $a4ccbde0d696dfdf$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current) (0, $402b11b96c54cb2c$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $a4ccbde0d696dfdf$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $e66750f3fb0f96bb$var$numFeatures; i++){
            const name = $e66750f3fb0f96bb$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $a8d82256030e9525$export$65570e08d843624d)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if ((this.type === "html" || this.type === "svg") && !this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $e66750f3fb0f96bb$var$propEventHandlers.length; i++){
            const key = $e66750f3fb0f96bb$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $69635cdb8982f9d2$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $e66750f3fb0f96bb$var$numVariantProps; i++){
            const name = (0, $0172fb3d3512f551$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $a35be4d5814e7c66$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $e32104bb79321603$export$ce8bdc721e76545f)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        var _a;
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $abbf779fde460163$export$d68f140c4d9b48bc)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $55c3387a92452647$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}


class $28a1ebc4c0bc036f$export$e49735c2a366bdc7 extends (0, $e66750f3fb0f96bb$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition: transition, transitionEnd: transitionEnd, ...target }, { transformValues: transformValues }, isMounted) {
        let origin = (0, $ea04fe669600292a$export$5a759dc7a1cfb72a)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $ea04fe669600292a$export$6afbed164019a54c)(this, target, origin);
            const parsed = (0, $d9a589b84d5ec1d1$export$5849e743e29831d6)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition: transition,
            transitionEnd: transitionEnd,
            ...target
        };
    }
}



function $bce82b8bf0dbf6b7$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $bce82b8bf0dbf6b7$export$23fea75b03ac16b3 extends (0, $28a1ebc4c0bc036f$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
    }
    readValueFromInstance(instance, key) {
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $bce82b8bf0dbf6b7$export$3735103072e4a80(instance);
            const value = ((0, $f9c5e88311214d2a$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $4ca2f8055771ddf4$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $55c3387a92452647$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $a0798b9f9973cb35$export$86bcdffbaf733d84 extends (0, $28a1ebc4c0bc036f$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $eac085b45c9e0925$export$16da615486abaa45)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $9422342e44092cf6$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $c139bf35362d2174$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $2f8881102ac6dde9$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? new (0, $a0798b9f9973cb35$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $bce82b8bf0dbf6b7$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
};




const $2c407ffdaf3c120a$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $a3289660bde9b219$export$b61a9eb3dbde8858),
        MeasureLayout: $cdf2a2ac04e7ce67$export$779f5fb01ad751cd
    }
};


const $a93b6401f922fd1e$var$preloadedFeatures = {
    ...(0, $03e8b675a1009b68$export$7f9953c70dacfd7f),
    ...(0, $5e115984cd871deb$export$e5b72898e5a201f1),
    ...(0, $fc1974bcfc4fde1a$export$d7d5d435647ed5a0),
    ...(0, $2c407ffdaf3c120a$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $a93b6401f922fd1e$export$e25e478948902b8b = /*@__PURE__*/ (0, $16a09bb264d348bb$export$a28d6df673050e18)((Component, config)=>(0, $73e3a8d89278ed7b$export$732916c0e88175fb)(Component, config, $a93b6401f922fd1e$var$preloadedFeatures, (0, $2f8881102ac6dde9$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $a93b6401f922fd1e$export$546614c4a05701f9(key) {
    return (0, $b40dad60036091a1$export$46b7e4b9dc6110c3)((0, $73e3a8d89278ed7b$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $a93b6401f922fd1e$var$preloadedFeatures, (0, $2f8881102ac6dde9$export$56ba0183203348f5)));
}



var $acw62 = parcelRequire("acw62");
"use client";
const $71b942d03604330e$export$6486ede9e74d7d9d = (arr, id)=>arr.find((toast)=>toast.id === id);
function $71b942d03604330e$export$67080b9d5f0a62ea(toasts, id) {
    const position = $71b942d03604330e$export$500f52ac46324ec6(toasts, id);
    const index = position ? toasts[position].findIndex((toast)=>toast.id === id) : -1;
    return {
        position: position,
        index: index
    };
}
function $71b942d03604330e$export$500f52ac46324ec6(toasts, id) {
    for (const [position, values] of Object.entries(toasts)){
        if ($71b942d03604330e$export$6486ede9e74d7d9d(values, id)) return position;
    }
}
const $71b942d03604330e$export$795910f5f15a9633 = (toasts, id)=>!!$71b942d03604330e$export$500f52ac46324ec6(toasts, id);
function $71b942d03604330e$export$27777812cc6d52de(position) {
    const isRighty = position.includes("right");
    const isLefty = position.includes("left");
    let alignItems = "center";
    if (isRighty) alignItems = "flex-end";
    if (isLefty) alignItems = "flex-start";
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: alignItems
    };
}
function $71b942d03604330e$export$55dd410e8ef136e0(position) {
    const isTopOrBottom = position === "top" || position === "bottom";
    const margin = isTopOrBottom ? "0 auto" : void 0;
    const top = position.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0;
    const bottom = position.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0;
    const right = !position.includes("left") ? "env(safe-area-inset-right, 0px)" : void 0;
    const left = !position.includes("right") ? "env(safe-area-inset-left, 0px)" : void 0;
    return {
        position: "fixed",
        zIndex: "var(--toast-z-index, 5500)",
        pointerEvents: "none",
        display: "flex",
        flexDirection: "column",
        margin: margin,
        top: top,
        bottom: bottom,
        right: right,
        left: left
    };
}



function $a1109faa373d9b20$export$1ab078c80230a125(target, ...sources) {
    if (target == null) throw new TypeError("Cannot convert undefined or null to object");
    const result = {
        ...target
    };
    for (const nextSource of sources){
        if (nextSource == null) continue;
        for(const nextKey in nextSource){
            if (!Object.prototype.hasOwnProperty.call(nextSource, nextKey)) continue;
            if (nextKey in result) delete result[nextKey];
            result[nextKey] = nextSource[nextKey];
        }
    }
    return result;
}

function $30752b4853cae067$export$8e16b83750b44988(object) {
    const clone = Object.assign({}, object);
    for(let key in clone)if (clone[key] === void 0) delete clone[key];
    return clone;
}

const $9eb62b7cfc2383b6$export$c77b7fefca3cef07 = (mod)=>mod.default || mod;

function $2f24f5b7b24b6936$export$45029c61b0073d87(props, ...keys) {
    const descriptors = Object.getOwnPropertyDescriptors(props);
    const dKeys = Object.keys(descriptors);
    const split = (k)=>{
        const clone = {};
        for(let i = 0; i < k.length; i++){
            const key = k[i];
            if (descriptors[key]) {
                Object.defineProperty(clone, key, descriptors[key]);
                delete descriptors[key];
            }
        }
        return clone;
    };
    const fn = (key)=>split(Array.isArray(key) ? key : dKeys.filter(key));
    return keys.map(fn).concat(split(dKeys));
}




var $acw62 = parcelRequire("acw62");

// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});






/* import type {
  ElementType,
  StatelessFunctionalComponent,
  AbstractComponent
} from 'react' */ /*
export type Interpolations = Array<any>

export type StyledElementType<Props> =
  | string
  | AbstractComponent<{ ...Props, className: string }, mixed>

export type StyledOptions = {
  label?: string,
  shouldForwardProp?: string => boolean,
  target?: string
}

export type StyledComponent<Props> = StatelessFunctionalComponent<Props> & {
  defaultProps: any,
  toString: () => string,
  withComponent: (
    nextTag: StyledElementType<Props>,
    nextOptions?: StyledOptions
  ) => StyledComponent<Props>
}

export type PrivateStyledComponent<Props> = StyledComponent<Props> & {
  __emotion_real: StyledComponent<Props>,
  __emotion_base: any,
  __emotion_styles: any,
  __emotion_forwardProp: any
}
*/ var $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag = (0, $bcd4e42ca4163639$export$2e2bcd8739ae039);
var $9e4a09088fdc2ec0$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag : $9e4a09088fdc2ec0$var$testOmitPropsOnComponent;
};
var $9e4a09088fdc2ec0$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
/*
export type CreateStyledComponent = <Props>(
  ...args: Interpolations
) => StyledComponent<Props>

export type CreateStyled = {
  <Props>(
    tag: StyledElementType<Props>,
    options?: StyledOptions
  ): (...args: Interpolations) => StyledComponent<Props>,
  [key: string]: CreateStyledComponent,
  bind: () => CreateStyled
}
*/ var $9e4a09088fdc2ec0$var$isDevelopment = false;
var $9e4a09088fdc2ec0$var$isBrowser = typeof document !== "undefined";
var $9e4a09088fdc2ec0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $5f1e384d41b6dbd9$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $1b59f2f50af460c0$export$db21c7ffa21794e7)(function() {
        return (0, $5f1e384d41b6dbd9$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    if (!$9e4a09088fdc2ec0$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $9e4a09088fdc2ec0$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $9e4a09088fdc2ec0$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    /* return function<Props>(): PrivateStyledComponent<Props> { */ return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        }
        var Styled = (0, $f603cc9427f570ab$export$efccba1c4a2ef57b)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $f603cc9427f570ab$export$971d5caa766a69d7));
            }
            if (typeof props.className === "string") className = (0, $5f1e384d41b6dbd9$export$95d99596f328fd52)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($9e4a09088fdc2ec0$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                if (targetClassName === undefined && $9e4a09088fdc2ec0$var$isDevelopment) return "NO_COMPONENT_SELECTOR";
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, nextOptions, {
                shouldForwardProp: $9e4a09088fdc2ec0$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};



parcelRequire("acw62");





var $3f5b60245567d758$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $3f5b60245567d758$export$2e2bcd8739ae039 = (0, $9e4a09088fdc2ec0$export$2e2bcd8739ae039).bind();
$3f5b60245567d758$var$tags.forEach(function(tagName) {
    $3f5b60245567d758$export$2e2bcd8739ae039[tagName] = $3f5b60245567d758$export$2e2bcd8739ae039(tagName);
});



var $acw62 = parcelRequire("acw62");

"use client";
const $5893af27072a18dd$var$allPropNames = /* @__PURE__ */ new Set([
    ...(0, $2f4a74a4061ab430$export$efd83c674fc6ddd4)({}),
    "textStyle",
    "layerStyle",
    "apply",
    "noOfLines",
    "focusBorderColor",
    "errorBorderColor",
    "as",
    "__css",
    "css",
    "sx"
]);
const $5893af27072a18dd$var$validHTMLProps = /* @__PURE__ */ new Set([
    "htmlWidth",
    "htmlHeight",
    "htmlSize",
    "htmlTranslate"
]);
function $5893af27072a18dd$export$3ba67b570e26eea0(prop) {
    return ($5893af27072a18dd$var$validHTMLProps.has(prop) || !$5893af27072a18dd$var$allPropNames.has(prop)) && prop[0] !== "_";
}



"use client";
const $91446aa4a5be886c$var$emotion_styled = (0, $9eb62b7cfc2383b6$export$c77b7fefca3cef07)((0, $3f5b60245567d758$export$2e2bcd8739ae039));
const $91446aa4a5be886c$export$9dba07f3d84163bb = ({ baseStyle: baseStyle })=>(props)=>{
        const { theme: theme, css: cssProp, __css: __css, sx: sx, ...restProps } = props;
        const [styleProps] = (0, $2f24f5b7b24b6936$export$45029c61b0073d87)(restProps, theme.__isStyleProp);
        const finalBaseStyle = (0, $e02dbdd8eca189fb$export$624e501d81f5ffce)(baseStyle, props);
        const finalStyles = (0, $a1109faa373d9b20$export$1ab078c80230a125)({}, __css, finalBaseStyle, (0, $30752b4853cae067$export$8e16b83750b44988)(styleProps), sx);
        const computedCSS = (0, $1b647ad110670368$export$dbf350e5966cf602)(finalStyles)(props.theme);
        return cssProp ? [
            computedCSS,
            cssProp
        ] : computedCSS;
    };
function $91446aa4a5be886c$export$3817b7a54a07cec7(component, options) {
    const { baseStyle: baseStyle, ...styledOptions } = options ?? {};
    if (!styledOptions.shouldForwardProp) styledOptions.shouldForwardProp = (0, $5893af27072a18dd$export$3ba67b570e26eea0);
    const styleObject = $91446aa4a5be886c$export$9dba07f3d84163bb({
        baseStyle: baseStyle
    });
    const Component = $91446aa4a5be886c$var$emotion_styled(component, styledOptions)(styleObject);
    const chakraComponent = (0, $acw62.forwardRef)(function ChakraComponent2(props, ref) {
        const { children: children, ...restProps } = props;
        const { colorMode: colorMode, forced: forced } = (0, $43224bfcd60683b5$export$20f3076712c8dfa)();
        const dataTheme = forced ? colorMode : void 0;
        return (0, $acw62.createElement)(Component, {
            ref: ref,
            "data-theme": dataTheme,
            ...restProps
        }, children);
    });
    return chakraComponent;
}


"use client";
function $b03209b927263f16$var$factory() {
    const cache = /* @__PURE__ */ new Map();
    return new Proxy((0, $91446aa4a5be886c$export$3817b7a54a07cec7), {
        /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */ apply (target, thisArg, argArray) {
            return (0, $91446aa4a5be886c$export$3817b7a54a07cec7)(...argArray);
        },
        /**
     * @example
     * <chakra.div />
     */ get (_, element) {
            if (!cache.has(element)) cache.set(element, (0, $91446aa4a5be886c$export$3817b7a54a07cec7)(element));
            return cache.get(element);
        }
    });
}
const $b03209b927263f16$export$7cd122d781af9fa4 = $b03209b927263f16$var$factory();


"use client";
const $64070b6fac4e0e34$var$toastMotionVariants = {
    initial: (props)=>{
        const { position: position } = props;
        const dir = [
            "top",
            "bottom"
        ].includes(position) ? "y" : "x";
        let factor = [
            "top-right",
            "bottom-right"
        ].includes(position) ? 1 : -1;
        if (position === "bottom") factor = 1;
        return {
            opacity: 0,
            [dir]: factor * 24
        };
    },
    animate: {
        opacity: 1,
        y: 0,
        x: 0,
        scale: 1,
        transition: {
            duration: 0.4,
            ease: [
                0.4,
                0,
                0.2,
                1
            ]
        }
    },
    exit: {
        opacity: 0,
        scale: 0.85,
        transition: {
            duration: 0.2,
            ease: [
                0.4,
                0,
                1,
                1
            ]
        }
    }
};
const $64070b6fac4e0e34$export$8743ba3ef25f9582 = (0, $acw62.memo)((props)=>{
    const { id: id, message: message, onCloseComplete: onCloseComplete, onRequestRemove: onRequestRemove, requestClose: requestClose = false, position: position = "bottom", duration: duration = 5e3, containerStyle: containerStyle, motionVariants: motionVariants = $64070b6fac4e0e34$var$toastMotionVariants, toastSpacing: toastSpacing = "0.5rem" } = props;
    const [delay, setDelay] = (0, $acw62.useState)(duration);
    const isPresent = (0, $bc77fac60b5d77cc$export$8249053f690ea39a)();
    (0, $b9c7bec3faa3a5b6$export$496315a1608d9602)(()=>{
        if (!isPresent) onCloseComplete?.();
    }, [
        isPresent
    ]);
    (0, $b9c7bec3faa3a5b6$export$496315a1608d9602)(()=>{
        setDelay(duration);
    }, [
        duration
    ]);
    const onMouseEnter = ()=>setDelay(null);
    const onMouseLeave = ()=>setDelay(duration);
    const close = ()=>{
        if (isPresent) onRequestRemove();
    };
    (0, $acw62.useEffect)(()=>{
        if (isPresent && requestClose) onRequestRemove();
    }, [
        isPresent,
        requestClose,
        onRequestRemove
    ]);
    (0, $f600c73be48e52b0$export$d8e6abf214c9ec0f)(close, delay);
    const containerStyles = (0, $acw62.useMemo)(()=>({
            pointerEvents: "auto",
            maxWidth: 560,
            minWidth: 300,
            margin: toastSpacing,
            ...containerStyle
        }), [
        containerStyle,
        toastSpacing
    ]);
    const toastStyle = (0, $acw62.useMemo)(()=>(0, $71b942d03604330e$export$27777812cc6d52de)(position), [
        position
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
        layout: true,
        className: "chakra-toast",
        variants: motionVariants,
        initial: "initial",
        animate: "animate",
        exit: "exit",
        onHoverStart: onMouseEnter,
        onHoverEnd: onMouseLeave,
        custom: {
            position: position
        },
        style: toastStyle,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
            role: "status",
            "aria-atomic": "true",
            className: "chakra-toast__inner",
            __css: containerStyles,
            children: (0, $e02dbdd8eca189fb$export$624e501d81f5ffce)(message, {
                id: id,
                onClose: close
            })
        })
    });
});
$64070b6fac4e0e34$export$8743ba3ef25f9582.displayName = "ToastComponent";




function $900b7f4f02bde73c$export$30a06c8d3562193f(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}


function $30f8a8e85c908575$export$adfcf5a5e4d17785(props) {
    return (0, $900b7f4f02bde73c$export$30a06c8d3562193f)(props, [
        "styleConfig",
        "size",
        "variant",
        "colorScheme"
    ]);
}


const $c206e257e9c6c2b1$export$a274e22fb40f762e = (...classNames)=>classNames.filter(Boolean).join(" ");







var $acw62 = parcelRequire("acw62");
"use client";
function $bef38e2b541bb56e$export$257a8862b851cb5b(component) {
    return (0, $acw62.forwardRef)(component);
}



var $5Gn6I = parcelRequire("5Gn6I");
function $bb7645db61c982be$var$normalize(value, toArray) {
    if (Array.isArray(value)) return value;
    if ((0, $ee96c6227c318ff4$export$a6cdc56e425d0d0a)(value)) return toArray(value);
    if (value != null) return [
        value
    ];
}
function $bb7645db61c982be$var$getNextIndex(values, i) {
    for(let j = i + 1; j < values.length; j++){
        if (values[j] != null) return j;
    }
    return -1;
}
function $bb7645db61c982be$var$createResolver(theme) {
    const breakpointUtil = theme.__breakpoints;
    return function resolver(config, prop, value, props) {
        if (!breakpointUtil) return;
        const result = {};
        const normalized = $bb7645db61c982be$var$normalize(value, breakpointUtil.toArrayValue);
        if (!normalized) return result;
        const len = normalized.length;
        const isSingle = len === 1;
        const isMultipart = !!config.parts;
        for(let i = 0; i < len; i++){
            const key = breakpointUtil.details[i];
            const nextKey = breakpointUtil.details[$bb7645db61c982be$var$getNextIndex(normalized, i)];
            const query = (0, $e60527e8093ba1ab$export$81f279c16481b446)(key.minW, nextKey?._minW);
            const styles = (0, $e02dbdd8eca189fb$export$624e501d81f5ffce)(config[prop]?.[normalized[i]], props);
            if (!styles) continue;
            if (isMultipart) {
                config.parts?.forEach((part)=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))(result, {
                        [part]: isSingle ? styles[part] : {
                            [query]: styles[part]
                        }
                    });
                });
                continue;
            }
            if (!isMultipart) {
                if (isSingle) (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))(result, styles);
                else result[query] = styles;
                continue;
            }
            result[query] = styles;
        }
        return result;
    };
}
function $bb7645db61c982be$export$f94106bbb00e81eb(config) {
    return (props)=>{
        const { variant: variant, size: size, theme: theme } = props;
        const recipe = $bb7645db61c982be$var$createResolver(theme);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, (0, $e02dbdd8eca189fb$export$624e501d81f5ffce)(config.baseStyle ?? {}, props), recipe(config, "sizes", size, props), recipe(config, "variants", variant, props));
    };
}



var $5Gn6I = parcelRequire("5Gn6I");

var $acw62 = parcelRequire("acw62");
var $77ddc6be16b1d7de$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== "undefined";
var $77ddc6be16b1d7de$var$hasMap = typeof Map === "function";
var $77ddc6be16b1d7de$var$hasSet = typeof Set === "function";
var $77ddc6be16b1d7de$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $77ddc6be16b1d7de$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($77ddc6be16b1d7de$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$77ddc6be16b1d7de$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($77ddc6be16b1d7de$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($77ddc6be16b1d7de$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$77ddc6be16b1d7de$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$77ddc6be16b1d7de$exports = function isEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};




var $acw62 = parcelRequire("acw62");
"use client";
function $438cb0f953004812$export$93d4e7f90805808f() {
    const theme = (0, $acw62.useContext)((0, $f603cc9427f570ab$export$971d5caa766a69d7));
    if (!theme) throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
    return theme;
}



"use client";
function $dade0a7e101641ba$export$a513a93efd9ab8a7() {
    const colorModeResult = (0, $43224bfcd60683b5$export$20f3076712c8dfa)();
    const theme = (0, $438cb0f953004812$export$93d4e7f90805808f)();
    return {
        ...colorModeResult,
        theme: theme
    };
}
function $dade0a7e101641ba$var$getBreakpointValue(theme, value, fallback) {
    if (value == null) return value;
    const getValue = (val)=>theme.__breakpoints?.asArray?.[val];
    return getValue(value) ?? getValue(fallback) ?? fallback;
}
function $dade0a7e101641ba$var$getTokenValue(theme, value, fallback) {
    if (value == null) return value;
    const getValue = (val)=>theme.__cssMap?.[val]?.value;
    return getValue(value) ?? getValue(fallback) ?? fallback;
}
function $dade0a7e101641ba$export$31dcd79391e423fe(scale, token, fallback) {
    const theme = (0, $438cb0f953004812$export$93d4e7f90805808f)();
    return $dade0a7e101641ba$export$257b2d10b709d8ef(scale, token, fallback)(theme);
}
function $dade0a7e101641ba$export$257b2d10b709d8ef(scale, token, fallback) {
    const _token = Array.isArray(token) ? token : [
        token
    ];
    const _fallback = Array.isArray(fallback) ? fallback : [
        fallback
    ];
    return (theme)=>{
        const fallbackArr = _fallback.filter(Boolean);
        const result = _token.map((token2, index)=>{
            if (scale === "breakpoints") return $dade0a7e101641ba$var$getBreakpointValue(theme, token2, fallbackArr[index] ?? token2);
            const path = `${scale}.${token2}`;
            return $dade0a7e101641ba$var$getTokenValue(theme, path, fallbackArr[index] ?? token2);
        });
        return Array.isArray(token) ? result : result[0];
    };
}


"use client";
function $ec61beff530ee0ac$var$useStyleConfigImpl(themeKey, props = {}) {
    const { styleConfig: styleConfigProp, ...rest } = props;
    const { theme: theme, colorMode: colorMode } = (0, $dade0a7e101641ba$export$a513a93efd9ab8a7)();
    const themeStyleConfig = themeKey ? (0, $7546e7769da6785d$export$1bb32d0c65da6059)(theme, `components.${themeKey}`) : void 0;
    const styleConfig = styleConfigProp || themeStyleConfig;
    const mergedProps = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({
        theme: theme,
        colorMode: colorMode
    }, styleConfig?.defaultProps ?? {}, (0, $30752b4853cae067$export$8e16b83750b44988)((0, $900b7f4f02bde73c$export$30a06c8d3562193f)(rest, [
        "children"
    ])), (obj, src)=>!obj ? src : void 0);
    const stylesRef = (0, $acw62.useRef)({});
    if (styleConfig) {
        const getStyles = (0, $bb7645db61c982be$export$f94106bbb00e81eb)(styleConfig);
        const styles = getStyles(mergedProps);
        const isStyleEqual = (0, (/*@__PURE__*/$parcel$interopDefault($77ddc6be16b1d7de$exports)))(stylesRef.current, styles);
        if (!isStyleEqual) stylesRef.current = styles;
    }
    return stylesRef.current;
}
function $ec61beff530ee0ac$export$b863f77547fbcb03(themeKey, props = {}) {
    return $ec61beff530ee0ac$var$useStyleConfigImpl(themeKey, props);
}
function $ec61beff530ee0ac$export$31cdfe60c085d76f(themeKey, props = {}) {
    return $ec61beff530ee0ac$var$useStyleConfigImpl(themeKey, props);
}



"use client";
const $20f456d5883a34dd$var$fallbackIcon = {
    path: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                strokeLinecap: "round",
                fill: "none",
                d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "currentColor",
                strokeLinecap: "round",
                d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("circle", {
                fill: "none",
                strokeMiterlimit: "10",
                cx: "12",
                cy: "12",
                r: "11.25"
            })
        ]
    }),
    viewBox: "0 0 24 24"
};
const $20f456d5883a34dd$export$f04a61298a47a40f = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>{
    const { as: element, viewBox: viewBox, color: color = "currentColor", focusable: focusable = false, children: children, className: className, __css: __css, ...rest } = props;
    const _className = (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-icon", className);
    const customStyles = (0, $ec61beff530ee0ac$export$b863f77547fbcb03)("Icon", props);
    const styles = {
        w: "1em",
        h: "1em",
        display: "inline-block",
        lineHeight: "1em",
        flexShrink: 0,
        color: color,
        ...__css,
        ...customStyles
    };
    const shared = {
        ref: ref,
        focusable: focusable,
        className: _className,
        __css: styles
    };
    const _viewBox = viewBox ?? $20f456d5883a34dd$var$fallbackIcon.viewBox;
    if (element && typeof element !== "string") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).svg, {
        as: element,
        ...shared,
        ...rest
    });
    const _path = children ?? $20f456d5883a34dd$var$fallbackIcon.path;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).svg, {
        verticalAlign: "middle",
        viewBox: _viewBox,
        ...shared,
        ...rest,
        children: _path
    });
});
$20f456d5883a34dd$export$f04a61298a47a40f.displayName = "Icon";


"use client";
function $ed6dd60d8a5cb00d$export$7dd004358974b05d(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $20f456d5883a34dd$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
        })
    });
}
function $ed6dd60d8a5cb00d$export$2957fc44b3d2481(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $20f456d5883a34dd$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
        })
    });
}
function $ed6dd60d8a5cb00d$export$f7dc499a72baa103(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $20f456d5883a34dd$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
        })
    });
}









"use client";
const $ef9297cc2eaade2d$var$spin = (0, $e0f035ab0866fe47$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
const $ef9297cc2eaade2d$export$7f7cbe89f1eacd2 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $ec61beff530ee0ac$export$b863f77547fbcb03)("Spinner", props);
    const { label: label = "Loading...", thickness: thickness = "2px", speed: speed = "0.45s", emptyColor: emptyColor = "transparent", className: className, ...rest } = (0, $30f8a8e85c908575$export$adfcf5a5e4d17785)(props);
    const _className = (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-spinner", className);
    const spinnerStyles = {
        display: "inline-block",
        borderColor: "currentColor",
        borderStyle: "solid",
        borderRadius: "99999px",
        borderWidth: thickness,
        borderBottomColor: emptyColor,
        borderLeftColor: emptyColor,
        animation: `${$ef9297cc2eaade2d$var$spin} ${speed} linear infinite`,
        ...styles
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: spinnerStyles,
        className: _className,
        ...rest,
        children: label && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).span, {
            srOnly: true,
            children: label
        })
    });
});
$ef9297cc2eaade2d$export$7f7cbe89f1eacd2.displayName = "Spinner";


"use client";
const [$50c8391e9f627cd9$export$a7901f7b4cce70b0, $50c8391e9f627cd9$export$50b520f08832063d] = (0, $f5f62380657c0122$export$fd42f52fd3ae1109)({
    name: "AlertContext",
    hookName: "useAlertContext",
    providerName: "<Alert />"
});
const [$50c8391e9f627cd9$export$17cf5063e294f385, $50c8391e9f627cd9$export$167ececdbea67592] = (0, $f5f62380657c0122$export$fd42f52fd3ae1109)({
    name: `AlertStylesContext`,
    hookName: `useAlertStyles`,
    providerName: "<Alert />"
});
const $50c8391e9f627cd9$var$STATUSES = {
    info: {
        icon: (0, $ed6dd60d8a5cb00d$export$2957fc44b3d2481),
        colorScheme: "blue"
    },
    warning: {
        icon: (0, $ed6dd60d8a5cb00d$export$f7dc499a72baa103),
        colorScheme: "orange"
    },
    success: {
        icon: (0, $ed6dd60d8a5cb00d$export$7dd004358974b05d),
        colorScheme: "green"
    },
    error: {
        icon: (0, $ed6dd60d8a5cb00d$export$f7dc499a72baa103),
        colorScheme: "red"
    },
    loading: {
        icon: (0, $ef9297cc2eaade2d$export$7f7cbe89f1eacd2),
        colorScheme: "blue"
    }
};
function $50c8391e9f627cd9$export$8df8f66d0469c54d(status) {
    return $50c8391e9f627cd9$var$STATUSES[status].colorScheme;
}
function $50c8391e9f627cd9$export$c742923ea4ac4c1c(status) {
    return $50c8391e9f627cd9$var$STATUSES[status].icon;
}





"use client";
const $27563f2a1a40a57c$export$caec2af78bcc877f = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)(function Alert2(props, ref) {
    const { status: status = "info", addRole: addRole = true, ...rest } = (0, $30f8a8e85c908575$export$adfcf5a5e4d17785)(props);
    const colorScheme = props.colorScheme ?? (0, $50c8391e9f627cd9$export$8df8f66d0469c54d)(status);
    const styles = (0, $ec61beff530ee0ac$export$31cdfe60c085d76f)("Alert", {
        ...props,
        colorScheme: colorScheme
    });
    const alertStyles = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        width: "100%",
        display: "flex",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
        ...styles.container
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $50c8391e9f627cd9$export$a7901f7b4cce70b0), {
        value: {
            status: status
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $50c8391e9f627cd9$export$17cf5063e294f385), {
            value: styles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
                "data-status": status,
                role: addRole ? "alert" : void 0,
                ref: ref,
                ...rest,
                className: (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-alert", props.className),
                __css: alertStyles
            })
        })
    });
});
$27563f2a1a40a57c$export$caec2af78bcc877f.displayName = "Alert";






"use client";
function $e04559f41f2b32b9$export$4a143c8822a09fb4(props) {
    const { status: status } = (0, $50c8391e9f627cd9$export$50b520f08832063d)();
    const BaseIcon = (0, $50c8391e9f627cd9$export$c742923ea4ac4c1c)(status);
    const styles = (0, $50c8391e9f627cd9$export$167ececdbea67592)();
    const css = status === "loading" ? styles.spinner : styles.icon;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).span, {
        display: "inherit",
        "data-status": status,
        ...props,
        className: (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-alert__icon", props.className),
        __css: css,
        children: props.children || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(BaseIcon, {
            h: "100%",
            w: "100%"
        })
    });
}
$e04559f41f2b32b9$export$4a143c8822a09fb4.displayName = "AlertIcon";







"use client";
const $b56785faf44156cb$export$4a7253439a300753 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)(function AlertTitle2(props, ref) {
    const styles = (0, $50c8391e9f627cd9$export$167ececdbea67592)();
    const { status: status } = (0, $50c8391e9f627cd9$export$50b520f08832063d)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
        ref: ref,
        "data-status": status,
        ...props,
        className: (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-alert__title", props.className),
        __css: styles.title
    });
});
$b56785faf44156cb$export$4a7253439a300753.displayName = "AlertTitle";








"use client";
const $dd6b48874092fec3$export$d4feae172fccda11 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)(function AlertDescription2(props, ref) {
    const { status: status } = (0, $50c8391e9f627cd9$export$50b520f08832063d)();
    const styles = (0, $50c8391e9f627cd9$export$167ececdbea67592)();
    const descriptionStyles = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        display: "inline",
        ...styles.description
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
        ref: ref,
        "data-status": status,
        ...props,
        className: (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-alert__desc", props.className),
        __css: descriptionStyles
    });
});
$dd6b48874092fec3$export$d4feae172fccda11.displayName = "AlertDescription";








"use client";
function $4de0b737b8d06ee0$var$CloseIcon(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $20f456d5883a34dd$export$f04a61298a47a40f), {
        focusable: "false",
        "aria-hidden": true,
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
        })
    });
}
const $4de0b737b8d06ee0$export$de65de8213222d10 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)(function CloseButton2(props, ref) {
    const styles = (0, $ec61beff530ee0ac$export$b863f77547fbcb03)("CloseButton", props);
    const { children: children, isDisabled: isDisabled, __css: __css, ...rest } = (0, $30f8a8e85c908575$export$adfcf5a5e4d17785)(props);
    const baseStyle = {
        outline: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).button, {
        type: "button",
        "aria-label": "Close",
        ref: ref,
        disabled: isDisabled,
        __css: {
            ...baseStyle,
            ...styles,
            ...__css
        },
        ...rest,
        children: children || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($4de0b737b8d06ee0$var$CloseIcon, {
            width: "1em",
            height: "1em"
        })
    });
});
$4de0b737b8d06ee0$export$de65de8213222d10.displayName = "CloseButton";



"use client";
const $063a7d66b4be71b9$export$8d8dc7d5f743331b = (props)=>{
    const { status: status, variant: variant = "solid", id: id, title: title, isClosable: isClosable, onClose: onClose, description: description, colorScheme: colorScheme, icon: icon } = props;
    const ids = id ? {
        root: `toast-${id}`,
        title: `toast-${id}-title`,
        description: `toast-${id}-description`
    } : void 0;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $27563f2a1a40a57c$export$caec2af78bcc877f), {
        addRole: false,
        status: status,
        variant: variant,
        id: ids?.root,
        alignItems: "start",
        borderRadius: "md",
        boxShadow: "lg",
        paddingEnd: 8,
        textAlign: "start",
        width: "auto",
        colorScheme: colorScheme,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e04559f41f2b32b9$export$4a143c8822a09fb4), {
                children: icon
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
                flex: "1",
                maxWidth: "100%",
                children: [
                    title && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b56785faf44156cb$export$4a7253439a300753), {
                        id: ids?.title,
                        children: title
                    }),
                    description && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dd6b48874092fec3$export$d4feae172fccda11), {
                        id: ids?.description,
                        display: "block",
                        children: description
                    })
                ]
            }),
            isClosable && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4de0b737b8d06ee0$export$de65de8213222d10), {
                size: "sm",
                onClick: onClose,
                position: "absolute",
                insetEnd: 1,
                top: 1
            })
        ]
    });
};
function $063a7d66b4be71b9$export$d9d796c483697359(options = {}) {
    const { render: render, toastComponent: ToastComponent = $063a7d66b4be71b9$export$8d8dc7d5f743331b } = options;
    const renderToast = (props)=>{
        if (typeof render === "function") return render({
            ...props,
            ...options
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ToastComponent, {
            ...props,
            ...options
        });
    };
    return renderToast;
}



"use client";
const $69ac468afa324d05$var$initialState = {
    top: [],
    "top-left": [],
    "top-right": [],
    "bottom-left": [],
    bottom: [],
    "bottom-right": []
};
const $69ac468afa324d05$export$e80fa18a42ed98ef = $69ac468afa324d05$var$createStore($69ac468afa324d05$var$initialState);
function $69ac468afa324d05$var$createStore(initialState2) {
    let state = initialState2;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (setStateFn)=>{
        state = setStateFn(state);
        listeners.forEach((l)=>l());
    };
    return {
        getState: ()=>state,
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                setState(()=>initialState2);
                listeners.delete(listener);
            };
        },
        /**
     * Delete a toast record at its position
     */ removeToast: (id, position)=>{
            setState((prevState)=>({
                    ...prevState,
                    // id may be string or number
                    // eslint-disable-next-line eqeqeq
                    [position]: prevState[position].filter((toast)=>toast.id != id)
                }));
        },
        notify: (message, options)=>{
            const toast = $69ac468afa324d05$var$createToast(message, options);
            const { position: position, id: id } = toast;
            setState((prevToasts)=>{
                const isTop = position.includes("top");
                const toasts = isTop ? [
                    toast,
                    ...prevToasts[position] ?? []
                ] : [
                    ...prevToasts[position] ?? [],
                    toast
                ];
                return {
                    ...prevToasts,
                    [position]: toasts
                };
            });
            return id;
        },
        update: (id, options)=>{
            if (!id) return;
            setState((prevState)=>{
                const nextState = {
                    ...prevState
                };
                const { position: position, index: index } = (0, $71b942d03604330e$export$67080b9d5f0a62ea)(nextState, id);
                if (position && index !== -1) nextState[position][index] = {
                    ...nextState[position][index],
                    ...options,
                    message: (0, $063a7d66b4be71b9$export$d9d796c483697359)(options)
                };
                return nextState;
            });
        },
        closeAll: ({ positions: positions } = {})=>{
            setState((prev)=>{
                const allPositions = [
                    "bottom",
                    "bottom-right",
                    "bottom-left",
                    "top",
                    "top-left",
                    "top-right"
                ];
                const positionsToClose = positions ?? allPositions;
                return positionsToClose.reduce((acc, position)=>{
                    acc[position] = prev[position].map((toast)=>({
                            ...toast,
                            requestClose: true
                        }));
                    return acc;
                }, {
                    ...prev
                });
            });
        },
        close: (id)=>{
            setState((prevState)=>{
                const position = (0, $71b942d03604330e$export$500f52ac46324ec6)(prevState, id);
                if (!position) return prevState;
                return {
                    ...prevState,
                    [position]: prevState[position].map((toast)=>{
                        if (toast.id == id) return {
                            ...toast,
                            requestClose: true
                        };
                        return toast;
                    })
                };
            });
        },
        isActive: (id)=>Boolean((0, $71b942d03604330e$export$67080b9d5f0a62ea)($69ac468afa324d05$export$e80fa18a42ed98ef.getState(), id).position)
    };
}
let $69ac468afa324d05$var$counter = 0;
function $69ac468afa324d05$var$createToast(message, options = {}) {
    $69ac468afa324d05$var$counter += 1;
    const id = options.id ?? $69ac468afa324d05$var$counter;
    const position = options.position ?? "bottom";
    return {
        id: id,
        message: message,
        position: position,
        duration: options.duration,
        onCloseComplete: options.onCloseComplete,
        onRequestRemove: ()=>$69ac468afa324d05$export$e80fa18a42ed98ef.removeToast(String(id), position),
        status: options.status,
        requestClose: false,
        containerStyle: options.containerStyle
    };
}







var $acw62 = parcelRequire("acw62");


"use client";
const [$b1eb6dbc7c2eef5d$var$PortalContextProvider, $b1eb6dbc7c2eef5d$var$usePortalContext] = (0, $f5f62380657c0122$export$fd42f52fd3ae1109)({
    strict: false,
    name: "PortalContext"
});
const $b1eb6dbc7c2eef5d$var$PORTAL_CLASSNAME = "chakra-portal";
const $b1eb6dbc7c2eef5d$var$PORTAL_SELECTOR = `.chakra-portal`;
const $b1eb6dbc7c2eef5d$var$Container = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "chakra-portal-zIndex",
        style: {
            position: "absolute",
            zIndex: props.zIndex,
            top: 0,
            left: 0,
            right: 0
        },
        children: props.children
    });
const $b1eb6dbc7c2eef5d$var$DefaultPortal = (props)=>{
    const { appendToParentPortal: appendToParentPortal, children: children } = props;
    const [tempNode, setTempNode] = (0, $acw62.useState)(null);
    const portal = (0, $acw62.useRef)(null);
    const [, forceUpdate] = (0, $acw62.useState)({});
    (0, $acw62.useEffect)(()=>forceUpdate({}), []);
    const parentPortal = $b1eb6dbc7c2eef5d$var$usePortalContext();
    const manager = (0, $07482164f1449a19$export$ef203b29c2cc1f5d)();
    (0, $2968f7a4ec8a3686$export$deebe11a338de063)(()=>{
        if (!tempNode) return;
        const doc = tempNode.ownerDocument;
        const host = appendToParentPortal ? parentPortal ?? doc.body : doc.body;
        if (!host) return;
        portal.current = doc.createElement("div");
        portal.current.className = $b1eb6dbc7c2eef5d$var$PORTAL_CLASSNAME;
        host.appendChild(portal.current);
        forceUpdate({});
        const portalNode = portal.current;
        return ()=>{
            if (host.contains(portalNode)) host.removeChild(portalNode);
        };
    }, [
        tempNode
    ]);
    const _children = manager?.zIndex ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b1eb6dbc7c2eef5d$var$Container, {
        zIndex: manager?.zIndex,
        children: children
    }) : children;
    return portal.current ? (0, $11492dca620dcaa5$exports.createPortal)(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b1eb6dbc7c2eef5d$var$PortalContextProvider, {
        value: portal.current,
        children: _children
    }), portal.current) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
        ref: (el)=>{
            if (el) setTempNode(el);
        }
    });
};
const $b1eb6dbc7c2eef5d$var$ContainerPortal = (props)=>{
    const { children: children, containerRef: containerRef, appendToParentPortal: appendToParentPortal } = props;
    const containerEl = containerRef.current;
    const host = containerEl ?? (typeof window !== "undefined" ? document.body : void 0);
    const portal = (0, $acw62.useMemo)(()=>{
        const node = containerEl?.ownerDocument.createElement("div");
        if (node) node.className = $b1eb6dbc7c2eef5d$var$PORTAL_CLASSNAME;
        return node;
    }, [
        containerEl
    ]);
    const [, forceUpdate] = (0, $acw62.useState)({});
    (0, $2968f7a4ec8a3686$export$deebe11a338de063)(()=>forceUpdate({}), []);
    (0, $2968f7a4ec8a3686$export$deebe11a338de063)(()=>{
        if (!portal || !host) return;
        host.appendChild(portal);
        return ()=>{
            host.removeChild(portal);
        };
    }, [
        portal,
        host
    ]);
    if (host && portal) return (0, $11492dca620dcaa5$exports.createPortal)(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b1eb6dbc7c2eef5d$var$PortalContextProvider, {
        value: appendToParentPortal ? portal : null,
        children: children
    }), portal);
    return null;
};
function $b1eb6dbc7c2eef5d$export$602eac185826482c(props) {
    const portalProps = {
        appendToParentPortal: true,
        ...props
    };
    const { containerRef: containerRef, ...rest } = portalProps;
    return containerRef ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b1eb6dbc7c2eef5d$var$ContainerPortal, {
        containerRef: containerRef,
        ...rest
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b1eb6dbc7c2eef5d$var$DefaultPortal, {
        ...rest
    });
}
$b1eb6dbc7c2eef5d$export$602eac185826482c.className = $b1eb6dbc7c2eef5d$var$PORTAL_CLASSNAME;
$b1eb6dbc7c2eef5d$export$602eac185826482c.selector = $b1eb6dbc7c2eef5d$var$PORTAL_SELECTOR;
$b1eb6dbc7c2eef5d$export$602eac185826482c.displayName = "Portal";


"use client";
const [$78a9c789cf0417da$export$cfcc07abbe2e36a8, $78a9c789cf0417da$export$7c4af276256dc908] = (0, $f5f62380657c0122$export$fd42f52fd3ae1109)({
    name: `ToastOptionsContext`,
    strict: false
});
const $78a9c789cf0417da$export$f5d03d415824e0e = (props)=>{
    const state = (0, $acw62.useSyncExternalStore)((0, $69ac468afa324d05$export$e80fa18a42ed98ef).subscribe, (0, $69ac468afa324d05$export$e80fa18a42ed98ef).getState, (0, $69ac468afa324d05$export$e80fa18a42ed98ef).getState);
    const { motionVariants: motionVariants, component: Component = (0, $64070b6fac4e0e34$export$8743ba3ef25f9582), portalProps: portalProps, animatePresenceProps: animatePresenceProps } = props;
    const stateKeys = Object.keys(state);
    const toastList = stateKeys.map((position)=>{
        const toasts = state[position];
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            role: "region",
            "aria-live": "polite",
            "aria-label": `Notifications-${position}`,
            id: `chakra-toast-manager-${position}`,
            style: (0, $71b942d03604330e$export$55dd410e8ef136e0)(position),
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                ...animatePresenceProps,
                initial: false,
                children: toasts.map((toast)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                        motionVariants: motionVariants,
                        ...toast
                    }, toast.id))
            })
        }, position);
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b1eb6dbc7c2eef5d$export$602eac185826482c), {
        ...portalProps,
        children: toastList
    });
};


"use client";
const $b77fb74b62ac1bce$export$500fbc0cd14cdbaa = (providerTheme)=>{
    return function ChakraProvider({ children: children, theme: theme = providerTheme, toastOptions: toastOptions, ...restProps }) {
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $8e40c08a2dde6692$export$2881499e37b75b9a), {
            theme: theme,
            ...restProps,
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $78a9c789cf0417da$export$cfcc07abbe2e36a8), {
                    value: toastOptions?.defaultOptions,
                    children: children
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $78a9c789cf0417da$export$f5d03d415824e0e), {
                    ...toastOptions
                })
            ]
        });
    };
};


"use client";
const $2f5c55c63aeaff4b$export$80dbe0482bcbd25a = (0, $b77fb74b62ac1bce$export$500fbc0cd14cdbaa)((0, $08099edf7566eba4$export$bca14c5b3b88a9c9));


/**
 * React Router DOM v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $acw62 = parcelRequire("acw62");


"use client";
const $7797ad21d1688bf5$export$e71c4d32a2263218 = (0, $b03209b927263f16$export$7cd122d781af9fa4)("div");
$7797ad21d1688bf5$export$e71c4d32a2263218.displayName = "Box";



var $acw62 = parcelRequire("acw62");
"use client";
function $6b244ebab8c02c76$export$d734136a7b018efe(ref, value) {
    if (ref == null) return;
    if (typeof ref === "function") {
        ref(value);
        return;
    }
    try {
        ref.current = value;
    } catch (error) {
        throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
    }
}
function $6b244ebab8c02c76$export$c9058316764c140e(...refs) {
    return (node)=>{
        refs.forEach((ref)=>{
            $6b244ebab8c02c76$export$d734136a7b018efe(ref, node);
        });
    };
}
function $6b244ebab8c02c76$export$74665b213cb5c4cf(...refs) {
    return (0, $acw62.useMemo)(()=>$6b244ebab8c02c76$export$c9058316764c140e(...refs), refs);
}



const $b0e804a3cb579fb7$export$5cc3b7b83e34ade7 = (condition)=>condition ? "" : void 0;
const $b0e804a3cb579fb7$export$91a6105db3d4be7b = (condition)=>condition ? true : void 0;



var $acw62 = parcelRequire("acw62");

"use client";
const [$e0f0176608de46c8$export$85041a2bb9328e33, $e0f0176608de46c8$export$749e21be8b14b968] = (0, $f5f62380657c0122$export$fd42f52fd3ae1109)({
    strict: false,
    name: "ButtonGroupContext"
});





var $acw62 = parcelRequire("acw62");

"use client";
function $4b289cd76997d89f$export$e1c22a2ee2645e36(props) {
    const { children: children, className: className, ...rest } = props;
    const _children = (0, $acw62.isValidElement)(children) ? (0, $acw62.cloneElement)(children, {
        "aria-hidden": true,
        focusable: false
    }) : children;
    const _className = (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-button__icon", className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).span, {
        display: "inline-flex",
        alignSelf: "center",
        flexShrink: 0,
        ...rest,
        className: _className,
        children: _children
    });
}
$4b289cd76997d89f$export$e1c22a2ee2645e36.displayName = "ButtonIcon";






var $acw62 = parcelRequire("acw62");


"use client";
function $dd6441f206de53da$export$f2c034885dd3ba7b(props) {
    const { label: label, placement: placement, spacing: spacing = "0.5rem", children: children = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ef9297cc2eaade2d$export$7f7cbe89f1eacd2), {
        color: "currentColor",
        width: "1em",
        height: "1em"
    }), className: className, __css: __css, ...rest } = props;
    const _className = (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-button__spinner", className);
    const marginProp = placement === "start" ? "marginEnd" : "marginStart";
    const spinnerStyles = (0, $acw62.useMemo)(()=>(0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
            display: "flex",
            alignItems: "center",
            position: label ? "relative" : "absolute",
            [marginProp]: label ? spacing : 0,
            fontSize: "1em",
            lineHeight: "normal",
            ...__css
        }), [
        __css,
        label,
        marginProp,
        spacing
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
        className: _className,
        ...rest,
        __css: spinnerStyles,
        children: children
    });
}
$dd6441f206de53da$export$f2c034885dd3ba7b.displayName = "ButtonSpinner";



var $acw62 = parcelRequire("acw62");
"use client";
function $c4da5bb466be6989$export$867b668ad7ef61e5(value) {
    const [isButton, setIsButton] = (0, $acw62.useState)(!value);
    const refCallback = (0, $acw62.useCallback)((node)=>{
        if (!node) return;
        setIsButton(node.tagName === "BUTTON");
    }, []);
    const type = isButton ? "button" : void 0;
    return {
        ref: refCallback,
        type: type
    };
}





"use client";
const $bc53aedf0bdeff61$export$353f5b6fc5456de1 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>{
    const group = (0, $e0f0176608de46c8$export$749e21be8b14b968)();
    const styles = (0, $ec61beff530ee0ac$export$b863f77547fbcb03)("Button", {
        ...group,
        ...props
    });
    const { isDisabled: isDisabled = group?.isDisabled, isLoading: isLoading, isActive: isActive, children: children, leftIcon: leftIcon, rightIcon: rightIcon, loadingText: loadingText, iconSpacing: iconSpacing = "0.5rem", type: type, spinner: spinner, spinnerPlacement: spinnerPlacement = "start", className: className, as: as, shouldWrapChildren: shouldWrapChildren, ...rest } = (0, $30f8a8e85c908575$export$adfcf5a5e4d17785)(props);
    const buttonStyles = (0, $acw62.useMemo)(()=>{
        const _focus = {
            ...styles?.["_focus"],
            zIndex: 1
        };
        return {
            display: "inline-flex",
            appearance: "none",
            alignItems: "center",
            justifyContent: "center",
            userSelect: "none",
            position: "relative",
            whiteSpace: "nowrap",
            verticalAlign: "middle",
            outline: "none",
            ...styles,
            ...!!group && {
                _focus: _focus
            }
        };
    }, [
        styles,
        group
    ]);
    const { ref: _ref, type: defaultType } = (0, $c4da5bb466be6989$export$867b668ad7ef61e5)(as);
    const contentProps = {
        rightIcon: rightIcon,
        leftIcon: leftIcon,
        iconSpacing: iconSpacing,
        children: children,
        shouldWrapChildren: shouldWrapChildren
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $b03209b927263f16$export$7cd122d781af9fa4).button, {
        disabled: isDisabled || isLoading,
        ref: (0, $6b244ebab8c02c76$export$74665b213cb5c4cf)(ref, _ref),
        as: as,
        type: type ?? defaultType,
        "data-active": (0, $b0e804a3cb579fb7$export$5cc3b7b83e34ade7)(isActive),
        "data-loading": (0, $b0e804a3cb579fb7$export$5cc3b7b83e34ade7)(isLoading),
        __css: buttonStyles,
        className: (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-button", className),
        ...rest,
        children: [
            isLoading && spinnerPlacement === "start" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dd6441f206de53da$export$f2c034885dd3ba7b), {
                className: "chakra-button__spinner--start",
                label: loadingText,
                placement: "start",
                spacing: iconSpacing,
                children: spinner
            }),
            isLoading ? loadingText || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).span, {
                opacity: 0,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($bc53aedf0bdeff61$var$ButtonContent, {
                    ...contentProps
                })
            }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($bc53aedf0bdeff61$var$ButtonContent, {
                ...contentProps
            }),
            isLoading && spinnerPlacement === "end" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dd6441f206de53da$export$f2c034885dd3ba7b), {
                className: "chakra-button__spinner--end",
                label: loadingText,
                placement: "end",
                spacing: iconSpacing,
                children: spinner
            })
        ]
    });
});
$bc53aedf0bdeff61$export$353f5b6fc5456de1.displayName = "Button";
function $bc53aedf0bdeff61$var$ButtonContent(props) {
    const { leftIcon: leftIcon, rightIcon: rightIcon, children: children, iconSpacing: iconSpacing, shouldWrapChildren: shouldWrapChildren } = props;
    if (!shouldWrapChildren) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            leftIcon && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4b289cd76997d89f$export$e1c22a2ee2645e36), {
                marginEnd: iconSpacing,
                children: leftIcon
            }),
            children,
            rightIcon && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4b289cd76997d89f$export$e1c22a2ee2645e36), {
                marginStart: iconSpacing,
                children: rightIcon
            })
        ]
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("span", {
        style: {
            display: "contents"
        },
        children: [
            leftIcon && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4b289cd76997d89f$export$e1c22a2ee2645e36), {
                marginEnd: iconSpacing,
                children: leftIcon
            }),
            children,
            rightIcon && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4b289cd76997d89f$export$e1c22a2ee2645e36), {
                marginStart: iconSpacing,
                children: rightIcon
            })
        ]
    });
}




"use client";
const $bda70ca026e698db$export$f51f4c4ede09e011 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)(function Flex2(props, ref) {
    const { direction: direction, align: align, justify: justify, wrap: wrap, basis: basis, grow: grow, shrink: shrink, ...rest } = props;
    const styles = {
        display: "flex",
        flexDirection: direction,
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap,
        flexBasis: basis,
        flexGrow: grow,
        flexShrink: shrink
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: styles,
        ...rest
    });
});
$bda70ca026e698db$export$f51f4c4ede09e011.displayName = "Flex";







"use client";
const $13ae9840661bf0be$export$a6c7ac8248d6e38a = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)(function Link2(props, ref) {
    const styles = (0, $ec61beff530ee0ac$export$b863f77547fbcb03)("Link", props);
    const { className: className, isExternal: isExternal, ...rest } = (0, $30f8a8e85c908575$export$adfcf5a5e4d17785)(props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).a, {
        target: isExternal ? "_blank" : void 0,
        rel: isExternal ? "noopener" : void 0,
        ref: ref,
        className: (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-link", className),
        ...rest,
        __css: styles
    });
});
$13ae9840661bf0be$export$a6c7ac8248d6e38a.displayName = "Link";


"use client";
const $d49876b21d3f7aec$export$d7a54cba636a8cd6 = (0, $b03209b927263f16$export$7cd122d781af9fa4)("div", {
    baseStyle: {
        flex: 1,
        justifySelf: "stretch",
        alignSelf: "stretch"
    }
});
$d49876b21d3f7aec$export$d7a54cba636a8cd6.displayName = "Spacer";



var $acw62 = parcelRequire("acw62");
// THIS FILE IS AUTO GENERATED
var $d0610069b91132c4$export$a0f7048edafc45cd = [
    {
        "id": "ci",
        "name": "Circum Icons",
        "projectUrl": "https://circumicons.com/",
        "license": "MPL-2.0 license",
        "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
    },
    {
        "id": "fa",
        "name": "Font Awesome 5",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "fa6",
        "name": "Font Awesome 6",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "lu",
        "name": "Lucide",
        "projectUrl": "https://lucide.dev/",
        "license": "ISC",
        "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "hi2",
        "name": "Heroicons 2",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "sl",
        "name": "Simple Line Icons",
        "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
    },
    {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "tb",
        "name": "Tabler Icons",
        "projectUrl": "https://github.com/tabler/tabler-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "tfi",
        "name": "Themify Icons",
        "projectUrl": "https://github.com/lykmapipo/themify-icons",
        "license": "MIT",
        "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
    },
    {
        "id": "rx",
        "name": "Radix Icons",
        "projectUrl": "https://icons.radix-ui.com",
        "license": "MIT",
        "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
    },
    {
        "id": "pi",
        "name": "Phosphor Icons",
        "projectUrl": "https://github.com/phosphor-icons/core",
        "license": "MIT",
        "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
    },
    {
        "id": "lia",
        "name": "Icons8 Line Awesome",
        "projectUrl": "https://icons8.com/line-awesome",
        "license": "MIT",
        "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
    }
];



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $235129a1ef69bfce$export$4a4ef469214f8641 = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var $235129a1ef69bfce$export$a49f528ae1a4d0ed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($235129a1ef69bfce$export$4a4ef469214f8641);


var $88a9a4518753b77c$var$__assign = undefined && undefined.__assign || function() {
    $88a9a4518753b77c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $88a9a4518753b77c$var$__assign.apply(this, arguments);
};
var $88a9a4518753b77c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $88a9a4518753b77c$var$Tree2Element(tree) {
    return tree && tree.map(function(node, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, $88a9a4518753b77c$var$__assign({
            key: i
        }, node.attr), $88a9a4518753b77c$var$Tree2Element(node.child));
    });
}
function $88a9a4518753b77c$export$6fce6cce1e9a936d(data) {
    // eslint-disable-next-line react/display-name
    return function(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($88a9a4518753b77c$export$a188ecdd443fe91a, $88a9a4518753b77c$var$__assign({
            attr: $88a9a4518753b77c$var$__assign({}, data.attr)
        }, props), $88a9a4518753b77c$var$Tree2Element(data.child));
    };
}
function $88a9a4518753b77c$export$a188ecdd443fe91a(props) {
    var elem = function(conf) {
        var attr = props.attr, size = props.size, title = props.title, svgProps = $88a9a4518753b77c$var$__rest(props, [
            "attr",
            "size",
            "title"
        ]);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $88a9a4518753b77c$var$__assign({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: $88a9a4518753b77c$var$__assign($88a9a4518753b77c$var$__assign({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), props.children);
    };
    return (0, $235129a1ef69bfce$export$a49f528ae1a4d0ed) !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $235129a1ef69bfce$export$a49f528ae1a4d0ed).Consumer, null, function(conf) {
        return elem(conf);
    }) : elem((0, $235129a1ef69bfce$export$4a4ef469214f8641));
}





function $0d9043722344d99e$export$25d43073366996bf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM13 12V8H11V12H8L12 16L16 12H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d98a66ae073f7e2f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM13 12H16L12 16L8 12H11V8H13V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4e8f2a28513fffbf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0001 19.1643L18.2072 12.9572L16.793 11.543L12.0001 16.3359L7.20718 11.543L5.79297 12.9572L12.0001 19.1643ZM12.0001 13.5144L18.2072 7.30728L16.793 5.89307L12.0001 10.686L7.20718 5.89307L5.79297 7.30728L12.0001 13.5144Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4afebd796350e846(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0001 19.1643L18.2072 12.9572L16.793 11.543L12.0001 16.3359L7.20718 11.543L5.79297 12.9572L12.0001 19.1643ZM12.0001 13.5144L18.2072 7.30728L16.793 5.89307L12.0001 10.686L7.20718 5.89307L5.79297 7.30728L12.0001 13.5144Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e93ca4703bbc5e86(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12H20L12 20L4 12H11V4H13V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$499c8cacc1fa49d6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9999 16.1716L18.3638 10.8076L19.778 12.2218L11.9999 20L4.22168 12.2218L5.63589 10.8076L10.9999 16.1716V4H12.9999V16.1716Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$229dd1e70b46419a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16L6 10H18L12 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f9699f2fcd345493(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9997 13.1714L16.9495 8.22168L18.3637 9.63589L11.9997 15.9999L5.63574 9.63589L7.04996 8.22168L11.9997 13.1714Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$393e94e055ea87cf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14L8 10H16L12 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4491b319b22e84e9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15.0006L7.75732 10.758L9.17154 9.34375L12 12.1722L14.8284 9.34375L16.2426 10.758L12 15.0006Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1939b6f5dd8bf695(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12L13 8V16L9 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$93bc91ec0cf8e81f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.8284 12.0005L14.6569 14.8289L13.2426 16.2431L9 12.0005L13.2426 7.75781L14.6569 9.17203L11.8284 12.0005Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cfd8e318a9fbd092(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12L10 16V8L14 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$820fe74a794897f2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.1717 12.0005L9.34326 9.17203L10.7575 7.75781L15.0001 12.0005L10.7575 16.2431L9.34326 14.8289L12.1717 12.0005Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bb1cfbb2dfa4a386(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10L16 14H8L12 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d016ac472625664e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11.8284L9.17154 14.6569L7.75732 13.2426L12 9L16.2426 13.2426L14.8284 14.6569L12 11.8284Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c479e86c21d4861c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7V11L2 6L8 1V5H13C17.4183 5 21 8.58172 21 13C21 17.4183 17.4183 21 13 21H4V19H13C16.3137 19 19 16.3137 19 13C19 9.68629 16.3137 7 13 7H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7ee360c071dbb12e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.82843 6.99955L8.36396 9.53509L6.94975 10.9493L2 5.99955L6.94975 1.0498L8.36396 2.46402L5.82843 4.99955H13C17.4183 4.99955 21 8.58127 21 12.9996C21 17.4178 17.4183 20.9996 13 20.9996H4V18.9996H13C16.3137 18.9996 19 16.3133 19 12.9996C19 9.68584 16.3137 6.99955 13 6.99955H5.82843Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e69b1e2d0596b6fe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7H11C7.68629 7 5 9.68629 5 13C5 16.3137 7.68629 19 11 19H20V21H11C6.58172 21 3 17.4183 3 13C3 8.58172 6.58172 5 11 5H16V1L22 6L16 11V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$641c653e5065addc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.1716 6.99955H11C7.68629 6.99955 5 9.68584 5 12.9996C5 16.3133 7.68629 18.9996 11 18.9996H20V20.9996H11C6.58172 20.9996 3 17.4178 3 12.9996C3 8.58127 6.58172 4.99955 11 4.99955H18.1716L15.636 2.46402L17.0503 1.0498L22 5.99955L17.0503 10.9493L15.636 9.53509L18.1716 6.99955Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1f61d10791972200(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 11V8L8 12L12 16V13H16V11H12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$369384453bb0e4a7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM12 11H16V13H12V16L8 12L12 8V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b5a8de0d870f8eee(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.83594 12.0001L11.043 18.2072L12.4573 16.793L7.66436 12.0001L12.4573 7.20718L11.043 5.79297L4.83594 12.0001ZM10.4858 12.0001L16.6929 18.2072L18.1072 16.793L13.3143 12.0001L18.1072 7.20718L16.6929 5.79297L10.4858 12.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fdb87a2ee742bcc5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.83594 12.0001L11.043 18.2072L12.4573 16.793L7.66436 12.0001L12.4573 7.20718L11.043 5.79297L4.83594 12.0001ZM10.4858 12.0001L16.6929 18.2072L18.1072 16.793L13.3143 12.0001L18.1072 7.20718L16.6929 5.79297L10.4858 12.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fd11ea5ad1e54949(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.361 13.0515L17.3108 18.0013H5.99707V6.68758L10.9468 11.6373L16.6037 5.98047L18.0179 7.39468L12.361 13.0515Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9ed9ab5f7963922f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13.589L17.6066 4.98242L19.0208 6.39664L10.4142 15.0032H18V17.0032H7V6.00324H9V13.589Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6a2d14ad117b28a5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13V20L4 12L12 4V11H20V13H12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$63a3c67b8f09e18a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f5d6c2a80470a866(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16V12L21 17L16 22V18H4V16H16ZM8 2V5.999L20 6V8H8V12L3 7L8 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d39ec0b6d1d38f5f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.0503 12.0498L21 16.9996L16.0503 21.9493L14.636 20.5351L17.172 17.9988L4 17.9996V15.9996L17.172 15.9988L14.636 13.464L16.0503 12.0498ZM7.94975 2.0498L9.36396 3.46402L6.828 5.9988L20 5.99955V7.99955L6.828 7.9988L9.36396 10.5351L7.94975 11.9493L3 6.99955L7.94975 2.0498Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$87af5a4d6075bd94(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12L14 6V18L8 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$928eb7d32afe35c2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6fba117ddf23dc87(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.361 10.9468L18.0179 16.6037L16.6037 18.0179L10.9468 12.361L5.99707 17.3108V5.99707H17.3108L12.361 10.9468Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fb17067ec508d0f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.41421 8L18.0208 16.6066L16.6066 18.0208L8 9.41421V17H6V6H17V8H9.41421Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$664fbacf39862a29(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 11H8V13H12V16L16 12L12 8V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c12f81f3ac978323(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11V8L16 12L12 16V13H8V11H12ZM12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ce030a3260d20f21(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.1643 12.0001L12.9572 5.79297L11.543 7.20718L16.3359 12.0001L11.543 16.793L12.9572 18.2072L19.1643 12.0001ZM13.5144 12.0001L7.30728 5.79297L5.89307 7.20718L10.686 12.0001L5.89307 16.793L7.30728 18.2072L13.5144 12.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f17c5a4ca0e1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.1643 12.0001L12.9572 5.79297L11.543 7.20718L16.3359 12.0001L11.543 16.793L12.9572 18.2072L19.1643 12.0001ZM13.5144 12.0001L7.30728 5.79297L5.89307 7.20718L10.686 12.0001L5.89307 16.793L7.30728 18.2072L13.5144 12.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$84c931cf9acd20b6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.6363 13.0515L5.97949 7.39468L7.39371 5.98047L13.0506 11.6373L18.0003 6.68758V18.0013H6.6866L11.6363 13.0515Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b40c5965918576af(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5895 16.0032L5.98291 7.39664L7.39712 5.98242L16.0037 14.589V7.00324H18.0037V18.0032H7.00373V16.0032H14.5895Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cf3ad62ff7f1cd89(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13H4V11H12V4L20 12L12 20V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a4887b7c7bbffe50(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b2f29bce69b48202(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12L10 18V6L16 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2e71b5c01b6ef3b9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.1714 12.0007L8.22168 7.05093L9.63589 5.63672L15.9999 12.0007L9.63589 18.3646L8.22168 16.9504L13.1714 12.0007Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$73ca2fb131083b9b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.0506 12.361L7.39371 18.0179L5.97949 16.6037L11.6363 10.9468L6.6866 5.99707H18.0003V17.3108L13.0506 12.361Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$10f4b0666e160841(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$15a01a5a752c9ce7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16H13L18 22L23 16H19V11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11V20H5V11C5 7.68629 7.68629 5 11 5C14.3137 5 17 7.68629 17 11V16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8c1ee5eb77941ccf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0005 18.1716L14.465 15.636L13.0507 17.0503L18.0005 22L22.9502 17.0503L21.536 15.636L19.0005 18.1716V11C19.0005 6.58172 15.4188 3 11.0005 3C6.58221 3 3.00049 6.58172 3.00049 11V20H5.00049V11C5.00049 7.68629 7.68678 5 11.0005 5C14.3142 5 17.0005 7.68629 17.0005 11V18.1716Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d648821c1c466736(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8V13C17 16.3137 14.3137 19 11 19C7.68629 19 5 16.3137 5 13V4H3V13C3 17.4183 6.58172 21 11 21C15.4183 21 19 17.4183 19 13V8H23L18 2L13 8H17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bd2ac48e13b54018(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0005 5.82843V13C17.0005 16.3137 14.3142 19 11.0005 19C7.68678 19 5.00049 16.3137 5.00049 13V4H3.00049V13C3.00049 17.4183 6.58221 21 11.0005 21C15.4188 21 19.0005 17.4183 19.0005 13V5.82843L21.536 8.36396L22.9502 6.94975L18.0005 2L13.0507 6.94975L14.465 8.36396L17.0005 5.82843Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5395de452711ab4f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM13 12H16L12 8L8 12H11V16H13V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8c092a8567dab523(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM13 12V16H11V12H8L12 8L16 12H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2d81ee0912dd5c7e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0001 4.83594L5.79297 11.043L7.20718 12.4573L12.0001 7.66436L16.793 12.4573L18.2072 11.043L12.0001 4.83594ZM12.0001 10.4858L5.79297 16.6929L7.20718 18.1072L12.0001 13.3143L16.793 18.1072L18.2072 16.6929L12.0001 10.4858Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$82f4bbb5156bc93f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0001 4.83594L5.79297 11.043L7.20718 12.4573L12.0001 7.66436L16.793 12.4573L18.2072 11.043L12.0001 4.83594ZM12.0001 10.4858L5.79297 16.6929L7.20718 18.1072L12.0001 13.3143L16.793 18.1072L18.2072 16.6929L12.0001 10.4858Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e1940c5bd8581cd4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8H8.001L8 20H6V8H2L7 3L12 8ZM22 16L17 21L12 16H16V4H18V16H22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7ab1c721b2d2af22(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9498 7.94975L10.5356 9.36396L8.00079 6.828L8.00004 20H6.00004L6.00079 6.828L3.46451 9.36396L2.05029 7.94975L7.00004 3L11.9498 7.94975ZM21.9498 16.0503L17 21L12.0503 16.0503L13.4645 14.636L16.0008 17.172L16 4H18L18.0008 17.172L20.5356 14.636L21.9498 16.0503Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fbed438a41e340a7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12V20H11V12H4L12 4L20 12H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f63195dcf0995458(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9999 7.82843V20H10.9999V7.82843L5.63589 13.1924L4.22168 11.7782L11.9999 4L19.778 11.7782L18.3638 13.1924L12.9999 7.82843Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8375b4b86328c8b4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8L18 14H6L12 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2ec8a7e60dd4ce5e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9997 10.8284L7.04996 15.7782L5.63574 14.364L11.9997 8L18.3637 14.364L16.9495 15.7782L11.9997 10.8284Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7aa4b16af6f19af0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.4141 4.58594L15.414 11.0003L21.0001 11.0004L21 13.0004L15.414 13.0003L15.4139 19.4144L7.99979 12.0002L15.4141 4.58594ZM4 19.0002L4 5.00018H6L6 19.0002H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$abe01a0069453133(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.0713 4.92871L16.4856 6.34292L11.8287 10.9998L21.0006 10.9999L21.0005 12.9999L11.8287 12.9998L16.4856 17.6566L15.0714 19.0708L8.00028 11.9998L15.0713 4.92871ZM4.00049 18.9997L4.00049 4.99972H6.00049L6.00049 18.9997H4.00049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d56874f4f8386450(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18 11 12 5 6V18ZM19 6 13 12 19 18V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$284c34e7d8d5126(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.7933 5.79297 12.5862 12.0001 18.7933 18.2072 20.2075 16.793 15.4146 12.0001 20.2075 7.20718 18.7933 5.79297ZM5.20718 18.2073 11.4143 12.0002 5.20718 5.79312 3.79297 7.20733 8.58586 12.0002 3.79297 16.7931 5.20718 18.2073Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1ea404e2c0a40488(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.58598 4.58594L16.0003 12.0002L8.58615 19.4144L8.58608 13.0003L3.00002 13.0004L3 11.0004L8.58605 11.0003L8.58598 4.58594ZM18.0001 19.0002L18.0001 5.00018H20.0001L20.0001 19.0002H18.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4814383592b0aea6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.1714 10.9998L7.51451 6.34292L8.92872 4.92871L15.9998 11.9998L8.92872 19.0708L7.51451 17.6566L12.1713 12.9998L2.99953 12.9999L2.99951 10.9999L12.1714 10.9998ZM17.9996 18.9997L17.9996 4.99972H19.9996L19.9996 18.9997H17.9996Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$52e83434f57d6bdb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5 12 11 6 5H18ZM18 19 12 13 6 19H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5007f124c563b870(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.79297 5.20718 12.0001 11.4143 18.2072 5.20718 16.793 3.79297 12.0001 8.58586 7.20718 3.79297 5.79297 5.20718ZM18.2073 18.7928 12.0002 12.5857 5.79312 18.7928 7.20733 20.207 12.0002 15.4141 16.7931 20.207 18.2073 18.7928Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d13f514cd9eab1ea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.0003 13.9999L19.0004 5.00003L17.0004 5L17.0003 11.9999L9.41421 12V6.58581L3 13L9.41421 19.4142L9.41421 14L19.0003 13.9999Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6b22d25009b877e7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.0003 13.9999L19.0004 5.00003L17.0004 5L17.0003 11.9999L6.82845 12L10.7782 8.05027L9.36396 6.63606L3 13L9.36396 19.364L10.7782 17.9498L6.8284 14L19.0003 13.9999Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dab598ba182082f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.00014 13.9999L5 5.00003L7 5L7.00011 11.9999L14.5862 12V6.58581L21.0004 13L14.5862 19.4142L14.5862 14L5.00014 13.9999Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b647bb7828e997a4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.00014 13.9999L5 5.00003L7 5L7.00011 11.9999L17.1719 12L13.2222 8.05027L14.6364 6.63606L21.0004 13L14.6364 19.364L13.2222 17.9498L17.172 14L5.00014 13.9999Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4ac6777aa9d13e54(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.0003 5.00014L19.0001 5L19.0002 7L12.0003 7.00011L12.0002 14.5862H17.4144L11.0001 21.0004L4.58594 14.5862L10.0002 14.5862L10.0003 5.00014Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1207ab79d568dd23(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.0003 5.00014L19.0002 5L19.0002 7L12.0003 7.00011L12.0002 17.1719L15.9499 13.2222L17.3642 14.6364L11.0002 21.0004L4.63623 14.6364L6.05044 13.2222L10.0002 17.172L10.0003 5.00014Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3d070796de9a411(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.0003 19.0003L19.0001 19.0004L19.0002 17.0004L12.0003 17.0003L12.0002 9.41421H17.4144L11.0001 3L4.58594 9.41421L10.0002 9.41421L10.0003 19.0003Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c14c329211abc489(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.0003 19.0003L19.0002 19.0004L19.0002 17.0004L12.0003 17.0003L12.0002 6.82845L15.9499 10.7782L17.3642 9.36396L11.0002 3L4.63623 9.36396L6.05044 10.7782L10.0002 6.8284L10.0003 19.0003Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$10c9cbd05f2b0bbe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9999 5.00014L5.00003 5L5 7L11.9999 7.00011L12 14.5862H6.58581L13 21.0004L19.4142 14.5862L14 14.5862L13.9999 5.00014Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$79c80cd855728afa(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9999 5.00014L5.00003 5L5 7L11.9999 7.00011L12 17.1719L8.05027 13.2222L6.63606 14.6364L13 21.0004L19.364 14.6364L17.9498 13.2222L14 17.172L13.9999 5.00014Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c62f80ff20fab581(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9999 19.0003L5.00003 19.0004L5 17.0004L11.9999 17.0003L12 9.41421H6.58581L13 3L19.4142 9.41421L14 9.41421L13.9999 19.0003Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1337d714b6e886f1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9999 19.0003L5.00003 19.0004L5 17.0004L11.9999 17.0003L12 6.82845L8.05027 10.7782L6.63606 9.36396L13 3L19.364 9.36396L17.9498 10.7782L14 6.8284L13.9999 19.0003Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a556a3fbb9b04fac(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.0005 19.0001 20.0004 10.0003 14.4143 10.0002V4.58594L8.00014 11.0001 14.4143 17.4144V12.0002L18.0004 12.0003 18.0005 19.0002 20.0005 19.0001ZM10.1639 6.05029 8.7497 4.63608 2.38574 11 8.7497 17.364 10.1639 15.9498 5.21417 11 10.1639 6.05029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b0d497ca5fd78c22(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.0001 10.0003L20.0003 19.0002L18.0003 19.0002L18.0002 12.0003L11.8283 12.0002L15.7781 15.9499L14.3638 17.3642L7.99988 11.0002L14.3638 4.63623L15.7781 6.05044L11.8283 10.0002L20.0001 10.0003ZM8.7497 4.63623L10.1639 6.05044L5.21417 11.0002L10.1639 15.9499L8.7497 17.3642L2.38574 11.0002L8.7497 4.63623Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6e93c9fc66f953af(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.0003 10.0003L19.0004 19.0001L17.0004 19.0002L17.0003 12.0003L9.41421 12.0002V17.4144L3 11.0001L9.41421 4.58594L9.41421 10.0002L19.0003 10.0003Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5516ec570f995af6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.0003 10.0003L19.0004 19.0002L17.0004 19.0002L17.0003 12.0003L6.82845 12.0002L10.7782 15.9499L9.36396 17.3642L3 11.0002L9.36396 4.63623L10.7782 6.05044L6.8284 10.0002L19.0003 10.0003Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6e20f91ae9446e7d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.99951 19.0001 3.99965 10.0003 9.58569 10.0002V4.58594L15.9999 11.0001 9.58569 17.4144V12.0002L5.99962 12.0003 5.99951 19.0002 3.99951 19.0001ZM13.8361 6.05029 15.2503 4.63608 21.6143 11 15.2503 17.364 13.8361 15.9498 18.7859 11 13.8361 6.05029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$339e8c6b1358b744(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.00014 10.0003L4 19.0002L6 19.0002L6.00011 12.0003L12.1719 12.0002L8.22222 15.9499L9.63643 17.3642L16.0004 11.0002L9.63643 4.63623L8.22221 6.05044L12.172 10.0002L4.00014 10.0003ZM15.2506 4.63623L13.8364 6.05044L18.7861 11.0002L13.8364 15.9499L15.2506 17.3642L21.6145 11.0002L15.2506 4.63623Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2949f8cc7f1c6fb8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.00014 10.0003L5 19.0001L7 19.0002L7.00011 12.0003L14.5862 12.0002V17.4144L21.0004 11.0001L14.5862 4.58594L14.5862 10.0002L5.00014 10.0003Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e20247697d3ca673(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.00014 10.0003L5 19.0002L7 19.0002L7.00011 12.0003L17.1719 12.0002L13.2222 15.9499L14.6364 17.3642L21.0004 11.0002L14.6364 4.63623L13.2222 6.05044L17.172 10.0002L5.00014 10.0003Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ce3df61e35b2d81f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11V8L22 12L18 16V13H13V18H16L12 22L8 18H11V13H6V16L2 12L6 8V11H11V6H8L12 2L16 6H13V11H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$93c391de8249946c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11V5.82843L9.17157 7.65685L7.75736 6.24264L12 2L16.2426 6.24264L14.8284 7.65685L13 5.82843V11H18.1716L16.3431 9.17157L17.7574 7.75736L22 12L17.7574 16.2426L16.3431 14.8284L18.1716 13H13V18.1716L14.8284 16.3431L16.2426 17.7574L12 22L7.75736 17.7574L9.17157 16.3431L11 18.1716V13H5.82843L7.65685 14.8284L6.24264 16.2426L2 12L6.24264 7.75736L7.65685 9.17157L5.82843 11H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e20b99a4353e3dbb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22L8 18H16L12 22ZM12 2L16 6H8L12 2ZM12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14ZM2 12L6 8V16L2 12ZM22 12L18 16V8L22 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$190feaeafae60efe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L16.2426 6.24264L14.8284 7.65685L12 4.82843L9.17157 7.65685L7.75736 6.24264L12 2ZM2 12L6.24264 7.75736L7.65685 9.17157L4.82843 12L7.65685 14.8284L6.24264 16.2426L2 12ZM22 12L17.7574 16.2426L16.3431 14.8284L19.1716 12L16.3431 9.17157L17.7574 7.75736L22 12ZM12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14ZM12 22L7.75736 17.7574L9.17157 16.3431L12 19.1716L14.8284 16.3431L16.2426 17.7574L12 22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$46d2b8224ceca78f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.4143 4.58594L10.4142 11.0003L16.0003 11.0004L16.0003 13.0004L10.4142 13.0003L10.4141 19.4144L3 12.0002L10.4143 4.58594ZM18.0002 19.0002V5.00018H20.0002V19.0002H18.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1b3844b0d730506(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.0711 4.9292L11.4853 6.34341L6.8284 11.0003L16.0003 11.0004L16.0003 13.0004L6.82845 13.0003L11.4853 17.6571L10.0711 19.0713L3 12.0003L10.0711 4.9292ZM18.0002 19.0002V5.00021H20.0002V19.0002H18.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$617ddff40a6b5dd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6 3 12 9 18V6ZM15 18 21 12 15 6V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c0ad84f21e61c155(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.04304 5.79297 2.83594 12.0001 9.04304 18.2072 10.4573 16.793 5.66436 12.0001 10.4573 7.20718 9.04304 5.79297ZM14.957 18.2073 21.1641 12.0002 14.957 5.79312 13.5427 7.20733 18.3356 12.0002 13.5427 16.7931 14.957 18.2073Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d180bc60f7fc3dc4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5859 4.58594L21.0002 12.0002L13.5861 19.4144L13.586 13.0003L7.99995 13.0004L7.99993 11.0004L13.586 11.0003L13.5859 4.58594ZM4 19.0002L4 5.00018H6V19.0002H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$829bd9ecd7ab8bae(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.1718 11.0003L12.5149 6.34341L13.9291 4.9292L21.0002 12.0003L13.9291 19.0713L12.5149 17.6571L17.1718 13.0003L7.99995 13.0004L7.99993 11.0004L17.1718 11.0003ZM4 19.0002L4 5.00021H6V19.0002H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$70a972675d859ad(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9 12 3 6 9H18ZM18 15 12 21 6 15H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7228081d15ab95c3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.2073 9.04304 12.0002 2.83594 5.79312 9.04304 7.20733 10.4573 12.0002 5.66436 16.7931 10.4573 18.2073 9.04304ZM5.79297 14.9574 12.0001 21.1646 18.2072 14.9574 16.793 13.5432 12.0001 18.3361 7.20718 13.5432 5.79297 14.9574Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a054ade1e139c9b9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17 6 17 6 15 18 15 18 17ZM12 13 18 7H6L12 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7717d4dd3e66ee80(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0001 10.0859L7.20718 5.29297L5.79297 6.70718L12.0001 12.9143L18.2072 6.70718L16.793 5.29297L12.0001 10.0859ZM18.0001 17.0001L6.00007 17.0001L6.00007 15.0001L18.0001 15.0001V17.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$29c7b2d9f81f7906(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18V6H9V18H7ZM11 12 17 6V18L11 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$296db8604719e6b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9142 12.0001L18.7071 7.20718L17.2929 5.79297L11.0858 12.0001L17.2929 18.2072L18.7071 16.793L13.9142 12.0001ZM7 18.0001V6.00008H9V18.0001H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4432e2fd28d37d7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6 17 18H15L15 6 17 6ZM13 12 7 18V6L13 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d8764016d1161274(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.0859 12.0001L5.29297 16.793L6.70718 18.2072L12.9143 12.0001L6.70718 5.79297L5.29297 7.20718L10.0859 12.0001ZM17.0001 6.00008L17.0001 18.0001H15.0001L15.0001 6.00008L17.0001 6.00008Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e82a11038fc14865(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7 18 7V9L6 9 6 7ZM12 11 18 17H6L12 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2bde4cd2f46e24aa(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0001 13.9142L16.793 18.7071L18.2072 17.2929L12.0001 11.0858L5.79297 17.2929L7.20718 18.7071L12.0001 13.9142ZM6.00008 7L18.0001 7V9L6.00008 9L6.00008 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ccd14e3b185e833a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.9641 3H17.0359C17.2844 4.722 18.7602 6 20.5 6C20.8322 6 21.1626 5.95271 21.4815 5.85956C21.2972 7.64386 19.7938 9 18 9H6C4.20622 9 2.7028 7.64386 2.51852 5.85957C2.83736 5.95271 3.16783 6 3.5 6C5.23985 6 6.71555 4.722 6.9641 3ZM22.9786 11.1114C22.5422 11.3591 22.0376 11.5005 21.5 11.5005C20.3896 11.5005 19.4201 10.8972 18.9013 10.0005H5.09865C4.57994 10.8972 3.61042 11.5005 2.5 11.5005C1.96237 11.5005 1.45778 11.3591 1.02138 11.1114C1.00725 11.2391 1 11.369 1 11.5005C1 12.8967 1.81753 14.1019 3 14.6637V21H9V19C9 17.3431 10.3432 16 12 16C13.6569 16 15 17.3431 15 19V21H21V14.6637C22.1825 14.1019 23 12.8967 23 11.5005C23 11.369 22.9927 11.2391 22.9786 11.1114Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$85242f8c5f655ba3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.96407 3H17.0358C17.2844 4.72201 18.7601 6 20.5 6 20.8321 6 21.1626 5.95272 21.4814 5.85957 21.2972 7.64386 19.7937 9 18 9H5.99997C4.20619 9 2.70278 7.64386 2.51849 5.85957 2.83733 5.95272 3.16781 6 3.49997 6 5.23982 6 6.71552 4.72201 6.96407 3ZM16.8994 6.65761C16.3391 6.1724 15.902 5.61986 15.5881 5H8.41184C8.09793 5.61986 7.66084 6.1724 7.10057 6.65761 6.9591 6.78013 6.8145 6.89426 6.66678 7H17.3331C17.1855 6.89426 17.0409 6.78013 16.8994 6.65761ZM21.5 11.5005C22.0376 11.5005 22.5422 11.3591 22.9786 11.1114 22.9927 11.2391 23 11.369 23 11.5005 23 12.8967 22.1825 14.1019 21 14.6637V21H14V19C14 17.8954 13.1046 17 12 17 10.8954 17 10 17.8954 10 19V21H3V14.6637C1.81753 14.1019 1 12.8967 1 11.5005 1 11.369 1.00725 11.2391 1.02138 11.1114 1.45778 11.3591 1.96237 11.5005 2.5 11.5005 3.61042 11.5005 4.57994 10.8972 5.09865 10.0005H18.9013C19.4201 10.8972 20.3896 11.5005 21.5 11.5005ZM18.9632 12.8097C18.5756 12.5812 18.2296 12.3115 17.9252 12.0005H6.07479C5.77042 12.3115 5.42443 12.5812 5.03683 12.8097 4.834 12.9293 4.62683 13.0333 4.41532 13.1218L5 13.3996V19H8C8 17.8954 8.39052 16.9526 9.17157 16.1716 9.95262 15.3905 10.8954 15 12 15 13.1046 15 14.0474 15.3905 14.8284 16.1716 15.6095 16.9526 16 17.8954 16 19H19V13.3996L19.5847 13.1218C19.3732 13.0333 19.166 12.9293 18.9632 12.8097Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$130d029b7688b305(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.51562 7.87678C1.67972 9.82977 3.08896 11.452 4.99982 11.8875V19.0013H2.99982V21.0013H20.9999V19.0013H18.9999V11.8875C20.9107 11.452 22.32 9.82977 22.484 7.87678C21.9936 7.95878 21.4971 8 20.9999 8C17.1858 8 13.7859 5.59592 12.5146 2H11.4851C10.2138 5.59592 6.81387 8 2.99982 8C2.50254 8 2.0061 7.95878 1.51562 7.87678ZM16.9999 19.0013H6.99982V12H16.9999V19.0013Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e3b3cdc8ad13fa75(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.51562 7.87678C1.67972 9.82977 3.08896 11.452 4.99982 11.8875V19.0013H2.99982V21.0013H20.9999V19.0013H18.9999V11.8875C20.9107 11.452 22.32 9.82977 22.484 7.87678C21.9936 7.95878 21.4971 8 20.9999 8C17.1858 8 13.7859 5.59592 12.5146 2H11.4851C10.2138 5.59592 6.81387 8 2.99982 8C2.50254 8 2.0061 7.95878 1.51562 7.87678ZM16.9999 19.0013H6.99982V12H16.9999V19.0013ZM18.5554 9.93749L18.2811 10H5.71853L5.44427 9.93749C5.3082 9.90648 5.17785 9.86594 5.0532 9.81587C6.58988 9.53219 8.02237 8.92072 9.35068 7.98146C10.4073 7.23431 11.2904 6.35588 11.9999 5.34615C12.7093 6.35588 13.5924 7.23431 14.649 7.98146C15.9773 8.92072 17.4098 9.53219 18.9465 9.81587C18.8218 9.86594 18.6914 9.90648 18.5554 9.93749Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$28652a34a13c6ec4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20H22V22H2V20ZM4 12H6V19H4V12ZM9 12H11V19H9V12ZM13 12H15V19H13V12ZM18 12H20V19H18V12ZM2 7L12 2L22 7V11H2V7ZM12 8C12.5523 8 13 7.55228 13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6f9449278a9693ec(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20H22V22H2V20ZM4 12H6V19H4V12ZM9 12H11V19H9V12ZM13 12H15V19H13V12ZM18 12H20V19H18V12ZM2 7L12 2L22 7V11H2V7ZM4 8.23607V9H20V8.23607L12 4.23607L4 8.23607ZM12 8C11.4477 8 11 7.55228 11 7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7C13 7.55228 12.5523 8 12 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$89677d11f52a7c2a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19.0003H14V6.00028L20.3939 8.74053C20.7616 8.89811 21 9.25964 21 9.65967V19.0003H23V21.0003H1V19.0003H3V5.65015C3 5.25496 3.23273 4.89684 3.59386 4.73634L11.2969 1.31275C11.5493 1.2006 11.8448 1.31424 11.9569 1.56659C11.9853 1.63052 12 1.6997 12 1.76966V19.0003Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$da79709965b7fd9a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19.0002V5.70058C3 5.28007 3.26307 4.90449 3.65826 4.76079L13.3291 1.24411C13.5886 1.14974 13.8755 1.28361 13.9699 1.54313C13.9898 1.5979 14 1.65573 14 1.714V6.66682L20.3162 8.77223C20.7246 8.90834 21 9.29048 21 9.72091V19.0002H23V21.0002H1V19.0002H3ZM5 19.0002H12V3.85555L5 6.40101V19.0002ZM19 19.0002V10.4417L14 8.77501V19.0002H19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e6cddab10ebf91e3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10.1111V1L21 7V21H3V7L10 10.1111Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fbb89d9248d04716(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10.1111V1L21 7V21H3V7L10 10.1111ZM12 4.36908V13.1886L5 10.0775V19H19V8.18727L12 4.36908Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dd394421f3ff0040(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 20H23V22H1V20H3V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V20ZM8 11V13H11V11H8ZM8 7V9H11V7H8ZM8 15V17H11V15H8ZM13 15V17H16V15H13ZM13 11V13H16V11H13ZM13 7V9H16V7H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$394594dd2488fb94(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 20H23V22H1V20H3V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V20ZM19 20V4H5V20H19ZM8 11H11V13H8V11ZM8 7H11V9H8V7ZM8 15H11V17H8V15ZM13 15H16V17H13V15ZM13 11H16V13H13V11ZM13 7H16V9H13V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bf36f4a5a7bf5c0a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19H23V21H1V19H3V4C3 3.44772 3.44772 3 4 3H14C14.5523 3 15 3.44772 15 4V19H17V9H20C20.5523 9 21 9.44772 21 10V19ZM7 11V13H11V11H7ZM7 7V9H11V7H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$12a60ad7c1aeb0b9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19H23V21H1V19H3V4C3 3.44772 3.44772 3 4 3H14C14.5523 3 15 3.44772 15 4V19H19V11H17V9H20C20.5523 9 21 9.44772 21 10V19ZM5 5V19H13V5H5ZM7 11H11V13H7V11ZM7 7H11V9H7V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1f21f4798efde90c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 19H12V12.9416L8 9.45402L4 12.9416V19H7V15H9V19ZM21 21H3C2.44772 21 2 20.5523 2 20V12.4868C2 12.1978 2.12501 11.9229 2.34282 11.733L6 8.54435V4C6 3.44772 6.44772 3 7 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21ZM16 11V13H18V11H16ZM16 15V17H18V15H16ZM16 7V9H18V7H16ZM12 7V9H14V7H12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2dd36e8900a741fd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 21H3C2.44772 21 2 20.5523 2 20V12.4868C2 12.1978 2.12501 11.9229 2.34282 11.733L6 8.54435V4C6 3.44772 6.44772 3 7 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21ZM9 19H12V12.9416L8 9.45402L4 12.9416V19H7V15H9V19ZM14 19H20V5H8V7.12729C8.23444 7.12729 8.46888 7.20938 8.65718 7.37355L13.6572 11.733C13.875 11.9229 14 12.1978 14 12.4868V19ZM16 11H18V13H16V11ZM16 15H18V17H16V15ZM16 7H18V9H16V7ZM12 7H14V9H12V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c535aaa16c18c81c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 19V8H1V6H4V4C4 3.44772 4.44772 3 5 3H19C19.5523 3 20 3.44772 20 4V6H23V8H22V19H23V21H1V19H2ZM13 19V12H11V19H13ZM8 19V12H6V19H8ZM18 19V12H16V19H18ZM6 5V6H18V5H6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c61d8e9fd20bb1b3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6H23V8H22V19H23V21H1V19H2V8H1V6H4V4C4 3.44772 4.44772 3 5 3H19C19.5523 3 20 3.44772 20 4V6ZM20 8H4V19H7V12H9V19H11V12H13V19H15V12H17V19H20V8ZM6 5V6H18V5H6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b6983304318d3965(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20.0001C20 20.5524 19.5523 21.0001 19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001L20 11.0001V20.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$16ebadaaae24eb80(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001L20 11.0001V20.0001C20 20.5524 19.5523 21.0001 19 21.0001ZM6 19.0001H18V9.15757L12 3.70302L6 9.15757V19.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$356014036a333a7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20.0001C20 20.5524 19.5523 21.0001 19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001L20 11.0001V20.0001ZM8 15.0001V17.0001H16V15.0001H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7302b7d65b4c861f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001L20 11.0001V20.0001C20 20.5524 19.5523 21.0001 19 21.0001ZM6 19.0001H18V9.15757L12 3.70302L6 9.15757V19.0001ZM8 15.0001H16V17.0001H8V15.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ab7374a40fe88d4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20.0001C20 20.5524 19.5523 21.0001 19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001L20 11.0001V20.0001ZM11 13.0001V19.0001H13V13.0001H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fec4ae4aee1a3320(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001L20 11.0001V20.0001C20 20.5524 19.5523 21.0001 19 21.0001ZM13 19.0001H18V9.15757L12 3.70302L6 9.15757V19.0001H11V13.0001H13V19.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3079a36626a3aaba(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19.9997C21 20.552 20.5523 20.9997 20 20.9997H4C3.44772 20.9997 3 20.552 3 19.9997V9.48882C3 9.18023 3.14247 8.88893 3.38606 8.69947L11.3861 2.47725C11.7472 2.19639 12.2528 2.19639 12.6139 2.47725L20.6139 8.69947C20.8575 8.88893 21 9.18023 21 9.48882V19.9997ZM11 12.9997V18.9997H13V12.9997H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b98cc6b84f8146a8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18.9997H19V9.97791L12 4.53346L5 9.97791V18.9997H11V12.9997H13V18.9997ZM21 19.9997C21 20.552 20.5523 20.9997 20 20.9997H4C3.44772 20.9997 3 20.552 3 19.9997V9.48882C3 9.18023 3.14247 8.88893 3.38606 8.69947L11.3861 2.47725C11.7472 2.19639 12.2528 2.19639 12.6139 2.47725L20.6139 8.69947C20.8575 8.88893 21 9.18023 21 9.48882V19.9997Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$593c4553a12ca4bc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19.9997C21 20.552 20.5523 20.9997 20 20.9997H4C3.44772 20.9997 3 20.552 3 19.9997V9.48882C3 9.18023 3.14247 8.88893 3.38606 8.69947L11.3861 2.47725C11.7472 2.19639 12.2528 2.19639 12.6139 2.47725L20.6139 8.69947C20.8575 8.88893 21 9.18023 21 9.48882V19.9997ZM7 14.9997V16.9997H17V14.9997H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a05b98ba2ab0ac10(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19.9997C21 20.552 20.5523 20.9997 20 20.9997H4C3.44772 20.9997 3 20.552 3 19.9997V9.48882C3 9.18023 3.14247 8.88893 3.38606 8.69947L11.3861 2.47725C11.7472 2.19639 12.2528 2.19639 12.6139 2.47725L20.6139 8.69947C20.8575 8.88893 21 9.18023 21 9.48882V19.9997ZM19 18.9997V9.97791L12 4.53346L5 9.97791V18.9997H19ZM7 14.9997H17V16.9997H7V14.9997Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$feddfc7b7649f586(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20.0001C20 20.5524 19.5523 21.0001 19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001L20 11.0001V20.0001ZM12 15.0001C13.3807 15.0001 14.5 13.8808 14.5 12.5001C14.5 11.1194 13.3807 10.0001 12 10.0001C10.6193 10.0001 9.5 11.1194 9.5 12.5001C9.5 13.8808 10.6193 15.0001 12 15.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8604bbbdba5fdf1e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001L20 11.0001V20.0001C20 20.5524 19.5523 21.0001 19 21.0001ZM6 19.0001H18V9.15757L12 3.70302L6 9.15757V19.0001ZM12 15.0001C10.6193 15.0001 9.5 13.8808 9.5 12.5001C9.5 11.1194 10.6193 10.0001 12 10.0001C13.3807 10.0001 14.5 11.1194 14.5 12.5001C14.5 13.8808 13.3807 15.0001 12 15.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5dcced557aeb2194(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20.0001C20 20.5524 19.5523 21.0001 19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001L20 11.0001V20.0001ZM9 10.0001V16.0001H15V10.0001H9ZM11 12.0001H13V14.0001H11V12.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$325dbbbe257182c2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001L20 11.0001V20.0001C20 20.5524 19.5523 21.0001 19 21.0001ZM6 19.0001H18V9.15757L12 3.70302L6 9.15757V19.0001ZM9 10.0001H15V16.0001H9V10.0001ZM11 12.0001V14.0001H13V12.0001H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$69a9be62ec1b3174(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19.9997C21 20.552 20.5523 20.9997 20 20.9997H4C3.44772 20.9997 3 20.552 3 19.9997V9.48882C3 9.18023 3.14247 8.88893 3.38606 8.69947L11.3861 2.47725C11.7472 2.19639 12.2528 2.19639 12.6139 2.47725L20.6139 8.69947C20.8575 8.88893 21 9.18023 21 9.48882V19.9997Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f65aba3b6673e8d6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20.0001C20 20.5524 19.5523 21.0001 19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001L20 11.0001V20.0001ZM8.59208 13.8081L7.60099 14.3803L8.6017 16.1135L9.5943 15.5404C9.98756 15.9118 10.467 16.1931 10.9994 16.3514V17.4957H13.0007V16.3513C13.5331 16.193 14.0125 15.9116 14.4057 15.5403L15.3984 16.1134L16.399 14.3802L15.4079 13.8079C15.4696 13.548 15.5022 13.2767 15.5022 12.9979C15.5022 12.719 15.4696 12.4478 15.4078 12.1878L16.399 11.6155L15.3983 9.88237L14.4056 10.4555C14.0124 10.0841 13.533 9.80276 13.0006 9.64448V8.5001H10.9993V9.64448C10.4669 9.80277 9.98747 10.0841 9.59421 10.4555L8.60164 9.88247L7.60099 11.6156L8.59205 12.1878C8.53034 12.4478 8.49768 12.7191 8.49768 12.9979C8.49768 13.2768 8.53035 13.5481 8.59208 13.8081ZM12 14.4972C11.171 14.4972 10.499 13.8259 10.499 12.9979C10.499 12.1699 11.171 11.4986 12 11.4986C12.8289 11.4986 13.5009 12.1699 13.5009 12.9979C13.5009 13.8259 12.8289 14.4972 12 14.4972Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$22cfa60331d4f295(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001L20 11.0001V20.0001C20 20.5524 19.5523 21.0001 19 21.0001ZM6 19.0001H18V9.15757L12 3.70302L6 9.15757V19.0001ZM8.59117 13.809C8.52937 13.5487 8.49666 13.2771 8.49666 12.9979C8.49666 12.7187 8.52936 12.4472 8.59115 12.1869L7.60001 11.6147L8.59952 9.88345L9.59136 10.4561C9.98427 10.0844 10.4633 9.80285 10.9954 9.64448V8.5001H12.9945V9.64448C13.5266 9.80284 14.0056 10.0844 14.3985 10.456L15.3904 9.88336L16.39 11.6146L15.3987 12.1868C15.4605 12.4471 15.4932 12.7187 15.4932 12.9979C15.4932 13.2771 15.4605 13.5486 15.3988 13.8089L16.39 14.3812L15.3905 16.1124L14.3986 15.5397C14.0057 15.9114 13.5267 16.1929 12.9946 16.3513V17.4957H10.9955V16.3514C10.4634 16.193 9.98437 15.9115 9.59144 15.5398L8.59957 16.1125L7.60001 14.3813L8.59117 13.809ZM11.995 14.4972C12.823 14.4972 13.4942 13.8259 13.4942 12.9979C13.4942 12.1699 12.823 11.4986 11.995 11.4986C11.1669 11.4986 10.4957 12.1699 10.4957 12.9979C10.4957 13.8259 11.1669 14.4972 11.995 14.4972Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$837fcf1fbd27955f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20.0001C20 20.5524 19.5523 21.0001 19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001H1L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001H20V20.0001ZM12 17.0001L15.3588 13.6413C16.2374 12.7627 16.2374 11.338 15.3588 10.4594C14.4801 9.58068 13.0555 9.58068 12.1768 10.4594L12 10.6361L11.8232 10.4594C10.9445 9.58068 9.51992 9.58068 8.64124 10.4594C7.76256 11.338 7.76256 12.7627 8.64124 13.6413L12 17.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fcb187d9668d0dae(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20.0001C20 20.5524 19.5523 21.0001 19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001H1L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001H20V20.0001ZM18 19.0001V9.15757L12 3.70302L6 9.15757V19.0001H18ZM12 17.0001L8.64124 13.6413C7.76256 12.7627 7.76256 11.338 8.64124 10.4594C9.51992 9.58068 10.9445 9.58068 11.8232 10.4594L12 10.6361L12.1768 10.4594C13.0555 9.58068 14.4801 9.58068 15.3588 10.4594C16.2374 11.338 16.2374 12.7627 15.3588 13.6413L12 17.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$69ed5dff921f67b2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19.9997C21 20.552 20.5523 20.9997 20 20.9997H4C3.44772 20.9997 3 20.552 3 19.9997V9.48882C3 9.18023 3.14247 8.88893 3.38606 8.69947L11.3861 2.47725C11.7472 2.19639 12.2528 2.19639 12.6139 2.47725L20.6139 8.69947C20.8575 8.88893 21 9.18023 21 9.48882V19.9997ZM19 18.9997V9.97791L12 4.53346L5 9.97791V18.9997H19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9b7004d756aee943(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.7999 9H12V17H11V21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001 11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L20.7999 9ZM14 11H23V18H14V11ZM13 21H24V19H13V21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5186e34f20acefb1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.6727 1.61162 20.7999 9H17.8267L12 3.70302 6 9.15757V19.0001H11V21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001 11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162ZM14 11H23V18H14V11ZM16 13V16H21V13H16ZM24 21H13V19H24V21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d5508dc23443baa(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19.9999C21 20.5522 20.5523 20.9999 20 20.9999H4C3.44772 20.9999 3 20.5522 3 19.9999V9.31379C3 9.00761 3.14027 8.7183 3.38065 8.52867L11.3807 2.21781C11.7438 1.9313 12.2562 1.9313 12.6193 2.21781L20.6193 8.52867C20.8597 8.7183 21 9.00761 21 9.31379V19.9999ZM7 11.9999C7 14.7613 9.23858 16.9999 12 16.9999C14.7614 16.9999 17 14.7613 17 11.9999H15C15 13.6568 13.6569 14.9999 12 14.9999C10.3431 14.9999 9 13.6568 9 11.9999H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9fac8badcdb4308b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 18.9999V9.79863L12 4.27662L5 9.79863V18.9999H19ZM21 19.9999C21 20.5522 20.5523 20.9999 20 20.9999H4C3.44772 20.9999 3 20.5522 3 19.9999V9.31379C3 9.00761 3.14027 8.7183 3.38065 8.52867L11.3807 2.21781C11.7438 1.9313 12.2562 1.9313 12.6193 2.21781L20.6193 8.52867C20.8597 8.7183 21 9.00761 21 9.31379V19.9999ZM7 11.9999H9C9 13.6568 10.3431 14.9999 12 14.9999C13.6569 14.9999 15 13.6568 15 11.9999H17C17 14.7613 14.7614 16.9999 12 16.9999C9.23858 16.9999 7 14.7613 7 11.9999Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bf5194cd24884d6e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20.0001C20 20.5524 19.5523 21.0001 19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001L20 11.0001V20.0001ZM7.5 13.0001C7.5 15.4854 9.51472 17.5001 12 17.5001C14.4853 17.5001 16.5 15.4854 16.5 13.0001H14.5C14.5 14.3808 13.3807 15.5001 12 15.5001C10.6193 15.5001 9.5 14.3808 9.5 13.0001H7.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f0a7099fe6508fb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19.0001H18V9.15757L12 3.70302L6 9.15757V19.0001ZM19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001L20 11.0001V20.0001C20 20.5524 19.5523 21.0001 19 21.0001ZM7.5 13.0001H9.5C9.5 14.3808 10.6193 15.5001 12 15.5001C13.3807 15.5001 14.5 14.3808 14.5 13.0001H16.5C16.5 15.4854 14.4853 17.5001 12 17.5001C9.51472 17.5001 7.5 15.4854 7.5 13.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3667ce995c04d5c9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20.0001C20 20.5524 19.5523 21.0001 19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001L20 11.0001V20.0001ZM7 11.0001V13.0001C9.76142 13.0001 12 15.2387 12 18.0001H14C14 14.1341 10.866 11.0001 7 11.0001ZM7 15.0001V18.0001H10C10 16.3432 8.65685 15.0001 7 15.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e04518f0540d4304(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19.0001H18V9.15757L12 3.70302L6 9.15757V19.0001ZM19 21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001L11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L23 11.0001L20 11.0001V20.0001C20 20.5524 19.5523 21.0001 19 21.0001ZM8 10.0001C11.866 10.0001 15 13.1341 15 17.0001H13C13 14.2387 10.7614 12.0001 8 12.0001V10.0001ZM8 14.0001C9.65685 14.0001 11 15.3432 11 17.0001H8V14.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9ca92cf0372d0d88(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 20H23V22H1V20H3V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V20ZM11 8H9V10H11V12H13V10H15V8H13V6H11V8ZM14 20H16V14H8V20H10V16H14V20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c892a8fb712a1aa5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 20V14H16V20H19V4H5V20H8ZM10 20H14V16H10V20ZM21 20H23V22H1V20H3V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V20ZM11 8V6H13V8H15V10H13V12H11V10H9V8H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9098b4f6e48b989f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 19H19V11H13V19H15V13H17V19ZM3 19V4C3 3.44772 3.44772 3 4 3H18C18.5523 3 19 3.44772 19 4V9H21V19H22V21H2V19H3ZM7 11V13H9V11H7ZM7 15V17H9V15H7ZM7 7V9H9V7H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8e1dec480258af38(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 21H2V19H3V4C3 3.44772 3.44772 3 4 3H18C18.5523 3 19 3.44772 19 4V9H21V19H22V21ZM17 19H19V11H13V19H15V13H17V19ZM17 9V5H5V19H11V9H17ZM7 11H9V13H7V11ZM7 15H9V17H7V15ZM7 7H9V9H7V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dd029c239a553a7d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 19.0002H22V9.00015H18V6.58594L12 0.585938L6 6.58594V9.00015H2V19.0002H1V21.0002H23V19.0002ZM6 19.0002H4V11.0002H6V19.0002ZM18 11.0002H20V19.0002H18V11.0002ZM11 12.0002H13V19.0002H11V12.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$efcade195ff19eed(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0.585938L18 6.58594V9.00024H22V19.0002H23V21.0002H1V19.0002H2V9.00024H6V6.58594L12 0.585938ZM18 19.0002H20V11.0002H18V19.0002ZM6 11.0002H4V19.0002H6V11.0002ZM8 7.41436V19.0002H11V12.0002H13V19.0002H16V7.41436L12 3.41436L8 7.41436Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ee83ad4ac03803fc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 20V22H2V20H3V13.2422C1.79401 12.435 1 11.0602 1 9.5C1 8.67286 1.22443 7.87621 1.63322 7.19746L4.3453 2.5C4.52393 2.1906 4.85406 2 5.21132 2H18.7887C19.1459 2 19.4761 2.1906 19.6547 2.5L22.3575 7.18172C22.7756 7.87621 23 8.67286 23 9.5C23 11.0602 22.206 12.435 21 13.2422V20H22ZM5.78865 4L3.35598 8.21321C3.12409 8.59843 3 9.0389 3 9.5C3 10.8807 4.11929 12 5.5 12C6.53096 12 7.44467 11.3703 7.82179 10.4295C8.1574 9.59223 9.3426 9.59223 9.67821 10.4295C10.0553 11.3703 10.969 12 12 12C13.031 12 13.9447 11.3703 14.3218 10.4295C14.6574 9.59223 15.8426 9.59223 16.1782 10.4295C16.5553 11.3703 17.469 12 18.5 12C19.8807 12 21 10.8807 21 9.5C21 9.0389 20.8759 8.59843 20.6347 8.19746L18.2113 4H5.78865Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$270a0924e9be4f09(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 13.2422V20H22V22H2V20H3V13.2422C1.79401 12.435 1 11.0602 1 9.5C1 8.67286 1.22443 7.87621 1.63322 7.19746L4.3453 2.5C4.52393 2.1906 4.85406 2 5.21132 2H18.7887C19.1459 2 19.4761 2.1906 19.6547 2.5L22.3575 7.18172C22.7756 7.87621 23 8.67286 23 9.5C23 11.0602 22.206 12.435 21 13.2422ZM19 13.9725C18.8358 13.9907 18.669 14 18.5 14C17.2409 14 16.0789 13.478 15.25 12.6132C14.4211 13.478 13.2591 14 12 14C10.7409 14 9.5789 13.478 8.75 12.6132C7.9211 13.478 6.75911 14 5.5 14C5.331 14 5.16417 13.9907 5 13.9725V20H19V13.9725ZM5.78865 4L3.35598 8.21321C3.12409 8.59843 3 9.0389 3 9.5C3 10.8807 4.11929 12 5.5 12C6.53096 12 7.44467 11.3703 7.82179 10.4295C8.1574 9.59223 9.3426 9.59223 9.67821 10.4295C10.0553 11.3703 10.969 12 12 12C13.031 12 13.9447 11.3703 14.3218 10.4295C14.6574 9.59223 15.8426 9.59223 16.1782 10.4295C16.5553 11.3703 17.469 12 18.5 12C19.8807 12 21 10.8807 21 9.5C21 9.0389 20.8759 8.59843 20.6347 8.19746L18.2113 4H5.78865Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$deff520dc1fa82e2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 13V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V13H2V11L3 6H21L22 11V13H21ZM5 13V19H19V13H5ZM6 14H14V17H6V14ZM3 3H21V5H3V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a9b35b7472de2638(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 13V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V13H2V11L3 6H21L22 11V13H21ZM5 13V19H19V13H5ZM4.03961 11H19.9604L19.3604 8H4.63961L4.03961 11ZM6 14H14V17H6V14ZM3 3H21V5H3V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b9b8b9fa1a3c7fd5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.6458V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11.6458C2.37764 10.9407 2 10.0144 2 9V3C2 2.44772 2.44772 2 3 2H21C21.5523 2 22 2.44772 22 3V9C22 10.0144 21.6224 10.9407 21 11.6458ZM14 9C14 8.44772 14.4477 8 15 8C15.5523 8 16 8.44772 16 9C16 10.1046 16.8954 11 18 11C19.1046 11 20 10.1046 20 9V4H4V9C4 10.1046 4.89543 11 6 11C7.10457 11 8 10.1046 8 9C8 8.44772 8.44772 8 9 8C9.55228 8 10 8.44772 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b774557d6a2f21a1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.6458V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11.6458C2.37764 10.9407 2 10.0144 2 9V3C2 2.44772 2.44772 2 3 2H21C21.5523 2 22 2.44772 22 3V9C22 10.0144 21.6224 10.9407 21 11.6458ZM19 12.874C18.6804 12.9562 18.3453 13 18 13C16.8053 13 15.7329 12.4762 15 11.6458C14.2671 12.4762 13.1947 13 12 13C10.8053 13 9.73294 12.4762 9 11.6458C8.26706 12.4762 7.19469 13 6 13C5.6547 13 5.31962 12.9562 5 12.874V20H19V12.874ZM14 9C14 8.44772 14.4477 8 15 8C15.5523 8 16 8.44772 16 9C16 10.1046 16.8954 11 18 11C19.1046 11 20 10.1046 20 9V4H4V9C4 10.1046 4.89543 11 6 11C7.10457 11 8 10.1046 8 9C8 8.44772 8.44772 8 9 8C9.55228 8 10 8.44772 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bfe06cfc3c2cfc24(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.8659 3.00017L22.1034 19H23V21H1V19H1.89638L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM12 12.9248L8.65869 19H15.3414L12 12.9248Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ecb29852ad706a73(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.1034 19L12.8659 3.00017C12.7782 2.84815 12.6519 2.72191 12.4999 2.63414C12.0216 2.358 11.41 2.52187 11.1339 3.00017L1.89638 19H1V21C8.33333 21 15.6667 21 23 21V19H22.1034ZM7.59991 19.0002H4.20568L11.9999 5.50017L19.7941 19.0002H16.4001L12 11L7.59991 19.0002ZM12 15.1501L14.1175 19H9.88254L12 15.1501Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bd0b7bce57304aef(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.55197 13 8.39897 10.8852 9.24398 13H7.55197ZM16 12H17V14H16C15.4477 14 15 13.5523 15 13 15 12.4477 15.4477 12 16 12ZM21 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3ZM12.598 16H10.443L10.043 15H6.75297L6.35297 16H4.19897L5.39797 13.002 5.39897 13 7.39897 8H9.39897L12.598 16ZM17 8H19V16H16C14.3431 16 13 14.6569 13 13 13 11.3431 14.3431 10 16 10H17V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d57dfe42d974121(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.598 16 9.39893 8H7.39893L5.39893 13 5.39795 13.002 4.19897 16H6.35303L6.75293 15H10.043L10.443 16H12.598ZM7.552 13 8.39893 10.8851 9.24402 13H7.552ZM17 8H19V16H16C14.3431 16 13 14.6569 13 13 13 11.3431 14.3431 10 16 10H17V8ZM16 12C15.4478 12 15 12.4478 15 13 15 13.5522 15.4478 14 16 14H17V12H16ZM21 3H3C2.44775 3 2 3.44775 2 4V20C2 20.5522 2.44775 21 3 21H21C21.5522 21 22 20.5522 22 20V4C22 3.44775 21.5522 3 21 3ZM4 19V5H20V19H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4bd75123bdef5fe7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 20V7L20 3H4L2 7.00353V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20ZM5.23582 5H18.7638L19.7638 7H4.23682L5.23582 5ZM9 11H15V13H9V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2ced2359f1f09ae3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 20V7L20 3H4L2 7.00353V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20ZM4 9H20V19H4V9ZM5.236 5H18.764L19.764 7H4.237L5.236 5ZM15 11H9V13H15V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c91d6f325411a198(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13H21V21.0025C21 21.5534 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5537 3 21.0025V13ZM3 2.99754C3 2.44662 3.44495 2 3.9934 2H20.0066C20.5552 2 21 2.44631 21 2.99754V11H3V2.99754ZM9 5V7H15V5H9ZM9 16V18H15V16H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$535a5c6ee12bf5f5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2.9918C3 2.44405 3.44495 2 3.9934 2H20.0066C20.5552 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM19 11V4H5V11H19ZM19 13H5V20H19V13ZM9 6H15V8H9V6ZM9 15H15V17H9V15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2369078647e9c851(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10H21V20.0044C21 20.5543 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5552 3 20.0044V10ZM9 12V14H15V12H9ZM2 3.99981C2 3.44763 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44372 22 3.99981V8H2V3.99981Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$156e5f4ecb99dc65(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10H2V4.00293C2 3.44903 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.43788 22 4.00293V10H21V20.0015C21 20.553 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5525 3 20.0015V10ZM19 10H5V19H19V10ZM4 5V8H20V5H4ZM9 12H15V14H9V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eacc51acb2559372(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C13.4702 20 14.8478 19.6034 16.0316 18.9114L15.0237 17.1835C14.1359 17.7026 13.1027 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12V13C18 13.5523 17.5523 14 17 14C16.4477 14 16 13.5523 16 13V9H14.6458C13.9407 8.37764 13.0144 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C13.0465 16 13.9991 15.5982 14.7119 14.9404C15.2622 15.5886 16.0831 16 17 16C18.6569 16 20 14.6569 20 13V12ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e8475857492e1e73(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C13.6418 20 15.1681 19.5054 16.4381 18.6571L17.5476 20.3214C15.9602 21.3818 14.0523 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V13.5C22 15.433 20.433 17 18.5 17C17.2958 17 16.2336 16.3918 15.6038 15.4659C14.6942 16.4115 13.4158 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C13.1258 7 14.1647 7.37209 15.0005 8H17V13.5C17 14.3284 17.6716 15 18.5 15C19.3284 15 20 14.3284 20 13.5V12ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3f5f91c8ae977f45(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.997 2.9918L20.9998 21.0082C20.9998 21.5447 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.44468 2 3.99322 2H20.0036C20.5519 2 20.9969 2.44405 20.997 2.9918ZM9 13V9C9 8.44772 9.44772 8 10 8C10.5523 8 11 8.44772 11 9V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13V9C13 7.34315 11.6569 6 10 6C8.34315 6 7 7.34315 7 9V13C7 15.7614 9.23858 18 12 18C14.7614 18 17 15.7614 17 13V8H15V13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b6f34ca9c912b831(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13.5V8C14 5.79086 12.2091 4 10 4C7.79086 4 6 5.79086 6 8V13.5C6 17.0899 8.91015 20 12.5 20C16.0899 20 19 17.0899 19 13.5V4H21V13.5C21 18.1944 17.1944 22 12.5 22C7.80558 22 4 18.1944 4 13.5V8C4 4.68629 6.68629 2 10 2C13.3137 2 16 4.68629 16 8V13.5C16 15.433 14.433 17 12.5 17C10.567 17 9 15.433 9 13.5V8H11V13.5C11 14.3284 11.6716 15 12.5 15C13.3284 15 14 14.3284 14 13.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bfd0f9e9c2b0e616(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 15.2454V22.1169C17 22.393 16.7761 22.617 16.5 22.617C16.4094 22.617 16.3205 22.5923 16.2428 22.5457L12 20L7.75725 22.5457C7.52046 22.6877 7.21333 22.6109 7.07125 22.3742C7.02463 22.2964 7 22.2075 7 22.1169V15.2454C5.17107 13.7793 4 11.5264 4 9C4 4.58172 7.58172 1 12 1C16.4183 1 20 4.58172 20 9C20 11.5264 18.8289 13.7793 17 15.2454ZM12 15C15.3137 15 18 12.3137 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 12.3137 8.68629 15 12 15ZM12 13C9.79086 13 8 11.2091 8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$352668135be50ae7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 15.2454V22.1169C17 22.393 16.7761 22.617 16.5 22.617C16.4094 22.617 16.3205 22.5923 16.2428 22.5457L12 20L7.75725 22.5457C7.52046 22.6877 7.21333 22.6109 7.07125 22.3742C7.02463 22.2964 7 22.2075 7 22.1169V15.2454C5.17107 13.7793 4 11.5264 4 9C4 4.58172 7.58172 1 12 1C16.4183 1 20 4.58172 20 9C20 11.5264 18.8289 13.7793 17 15.2454ZM9 16.4185V19.4676L12 17.6676L15 19.4676V16.4185C14.0736 16.7935 13.0609 17 12 17C10.9391 17 9.92643 16.7935 9 16.4185ZM12 15C15.3137 15 18 12.3137 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 12.3137 8.68629 15 12 15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4198b9b309b49456(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13H8V21H2V13ZM9 3H15V21H9V3ZM16 8H22V21H16V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1d371ad74327314c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13H8V21H2V13ZM16 8H22V21H16V8ZM9 3H15V21H9V3ZM4 15V19H6V15H4ZM11 5V19H13V5H11ZM18 10V19H20V10H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2a7e7858dfe9ca06(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM7 13V17H9V13H7ZM11 7V17H13V7H11ZM15 10V17H17V10H15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c5a632fa115176f3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM4 5V19H20V5H4ZM7 13H9V17H7V13ZM11 7H13V17H11V7ZM15 10H17V17H15V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f82c076ef8a5df1f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12H7V21H3V12ZM17 8H21V21H17V8ZM10 2H14V21H10V2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4eb985c57a59b7ca(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12H4V21H2V12ZM5 14H7V21H5V14ZM16 8H18V21H16V8ZM19 10H21V21H19V10ZM9 2H11V21H9V2ZM12 4H14V21H12V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f27870ec1018cb25(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12H4V21H2V12ZM5 14H7V21H5V14ZM16 8H18V21H16V8ZM19 10H21V21H19V10ZM9 2H11V21H9V2ZM12 4H14V21H12V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9847c69ad8a2e063(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3V7H3V3H12ZM16 17V21H3V17H16ZM22 10V14H3V10H22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$552398dc99ebbab1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3V5H3V3H12ZM16 19V21H3V19H16ZM22 11V13H3V11H22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a01fd5110bf92940(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12H5V21H3V12ZM19 8H21V21H19V8ZM11 2H13V21H11V2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$286402309ebbe568(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2H19C19.5523 2 20 2.44772 20 3V22.1433C20 22.4194 19.7761 22.6434 19.5 22.6434C19.4061 22.6434 19.314 22.6168 19.2344 22.5669L12 18.0313L4.76559 22.5669C4.53163 22.7136 4.22306 22.6429 4.07637 22.4089C4.02647 22.3293 4 22.2373 4 22.1433V3C4 2.44772 4.44772 2 5 2ZM8 9V11H16V9H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$59489448b8ac256a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2H19C19.5523 2 20 2.44772 20 3V22.1433C20 22.4194 19.7761 22.6434 19.5 22.6434C19.4061 22.6434 19.314 22.6168 19.2344 22.5669L12 18.0313L4.76559 22.5669C4.53163 22.7136 4.22306 22.6429 4.07637 22.4089C4.02647 22.3293 4 22.2373 4 22.1433V3C4 2.44772 4.44772 2 5 2ZM18 4H6V19.4324L12 15.6707L18 19.4324V4ZM8 9H16V11H8V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$411f4d51824794b3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2H20C20.5523 2 21 2.44772 21 3V22.2763C21 22.5525 20.7761 22.7764 20.5 22.7764C20.4298 22.7764 20.3604 22.7615 20.2963 22.7329L12 19.0313L3.70373 22.7329C3.45155 22.8455 3.15591 22.7322 3.04339 22.4801C3.01478 22.4159 3 22.3465 3 22.2763V3C3 2.44772 3.44772 2 4 2ZM12 13.5L14.9389 15.0451L14.3776 11.7725L16.7553 9.45492L13.4695 8.97746L12 6L10.5305 8.97746L7.24472 9.45492L9.62236 11.7725L9.06107 15.0451L12 13.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7da95e15851b689f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2H20C20.5523 2 21 2.44772 21 3V22.2763C21 22.5525 20.7761 22.7764 20.5 22.7764C20.4298 22.7764 20.3604 22.7615 20.2963 22.7329L12 19.0313L3.70373 22.7329C3.45155 22.8455 3.15591 22.7322 3.04339 22.4801C3.01478 22.4159 3 22.3465 3 22.2763V3C3 2.44772 3.44772 2 4 2ZM19 19.9645V4H5V19.9645L12 16.8412L19 19.9645ZM12 13.5L9.06107 15.0451L9.62236 11.7725L7.24472 9.45492L10.5305 8.97746L12 6L13.4695 8.97746L16.7553 9.45492L14.3776 11.7725L14.9389 15.0451L12 13.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7be5be33a4065865(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2H19C19.5523 2 20 2.44772 20 3V22.1433C20 22.4194 19.7761 22.6434 19.5 22.6434C19.4061 22.6434 19.314 22.6168 19.2344 22.5669L12 18.0313L4.76559 22.5669C4.53163 22.7136 4.22306 22.6429 4.07637 22.4089C4.02647 22.3293 4 22.2373 4 22.1433V3C4 2.44772 4.44772 2 5 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1fa700415e8398a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2H19C19.5523 2 20 2.44772 20 3V22.1433C20 22.4194 19.7761 22.6434 19.5 22.6434C19.4061 22.6434 19.314 22.6168 19.2344 22.5669L12 18.0313L4.76559 22.5669C4.53163 22.7136 4.22306 22.6429 4.07637 22.4089C4.02647 22.3293 4 22.2373 4 22.1433V3C4 2.44772 4.44772 2 5 2ZM18 4H6V19.4324L12 15.6707L18 19.4324V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$647232c911415067(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM17 13V10H15V13H9V10H7V13H4V19H20V13H17ZM9 3V5H15V3H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a6cf68cd17d3fdb9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM20 13H4V19H20V13ZM20 7H4V11H7V9H9V11H15V9H17V11H20V7ZM9 3V5H15V3H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9a72ff5f0fd2ced6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM17 7V12H20V7H17ZM15 7H9V12H15V7ZM7 7H4V12H7V7ZM9 3V5H15V3H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5fe210fcb23736dc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM15 7H9V19H15V7ZM7 7H4V19H7V7ZM17 7V19H20V7H17ZM9 3V5H15V3H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5530b506d74264cf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13V16H15V13H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V13H9ZM11 11H13V14H11V11ZM7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V11H15V9H9V11H2V6C2 5.44772 2.44772 5 3 5H7ZM9 3V5H15V3H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e471339d03d04406(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM9 13H4V19H20V13H15V16H9V13ZM20 7H4V11H9V9H15V11H20V7ZM11 11V14H13V11H11ZM9 3V5H15V3H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c36653fcb34e5e83(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM6 13V7H4V13H6ZM8 7V13H11V11H13V13H16V7H8ZM18 13H20V7H18V13ZM9 3V5H15V3H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c75d55ccf61506aa(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM16 15H13V16H11V15H8V19H16V15ZM8 7V13H11V12H13V13H16V7H8ZM6 13V7H4V13H6ZM18 13H20V7H18V13ZM6 15H4V19H6V15ZM18 15V19H20V15H18ZM9 3V5H15V3H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$727a367c5a85d933(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM4 15V19H20V15H4ZM11 11V13H13V11H11ZM9 3V5H15V3H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4b1636efe156f208(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM4 16V19H20V16H4ZM4 14H20V7H4V14ZM9 3V5H15V3H9ZM11 11H13V13H11V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$490c54cd98a99f1e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16C17.6569 16 19 17.3431 19 19C19 20.6569 17.6569 22 16 22C14.3431 22 13 20.6569 13 19C13 17.3431 14.3431 16 16 16ZM6 12C8.20914 12 10 13.7909 10 16C10 18.2091 8.20914 20 6 20C3.79086 20 2 18.2091 2 16C2 13.7909 3.79086 12 6 12ZM14.5 2C17.5376 2 20 4.46243 20 7.5C20 10.5376 17.5376 13 14.5 13C11.4624 13 9 10.5376 9 7.5C9 4.46243 11.4624 2 14.5 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b0484966ee49e0a3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16C17.6569 16 19 17.3431 19 19C19 20.6569 17.6569 22 16 22C14.3431 22 13 20.6569 13 19C13 17.3431 14.3431 16 16 16ZM6 12C8.20914 12 10 13.7909 10 16C10 18.2091 8.20914 20 6 20C3.79086 20 2 18.2091 2 16C2 13.7909 3.79086 12 6 12ZM16 18C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20C16.5523 20 17 19.5523 17 19C17 18.4477 16.5523 18 16 18ZM6 14C4.89543 14 4 14.8954 4 16C4 17.1046 4.89543 18 6 18C7.10457 18 8 17.1046 8 16C8 14.8954 7.10457 14 6 14ZM14.5 2C17.5376 2 20 4.46243 20 7.5C20 10.5376 17.5376 13 14.5 13C11.4624 13 9 10.5376 9 7.5C9 4.46243 11.4624 2 14.5 2ZM14.5 4C12.567 4 11 5.567 11 7.5C11 9.433 12.567 11 14.5 11C16.433 11 18 9.433 18 7.5C18 5.567 16.433 4 14.5 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c339f53fc2d6c2ac(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2ZM7 12V14H9V12H7ZM7 16V18H9V16H7ZM11 12V14H13V12H11ZM11 16V18H13V16H11ZM15 12V18H17V12H15ZM7 6V10H17V6H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e257e0ded583027(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2ZM5 4V20H19V4H5ZM7 6H17V10H7V6ZM7 12H9V14H7V12ZM7 16H9V18H7V16ZM11 12H13V14H11V12ZM11 16H13V18H11V16ZM15 12H17V18H15V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$46a127dacc436145(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 11H8V13H6V11ZM11 11H13V13H11V11ZM16 11H18V13H16V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$26823b3a43ccd984(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM8 13V15H6V13H8ZM13 13V15H11V13H13ZM18 13V15H16V13H18ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$95e03a496d9f6602(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 8H4V19H20V8ZM15.0355 10.136L16.4497 11.5503L11.5 16.5L7.96447 12.9645L9.37868 11.5503L11.5 13.6716L15.0355 10.136Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$43342c8eca680ab6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 10H4V19H20V10ZM15.0355 11.136L16.4497 12.5503L11.5 17.5L7.96447 13.9645L9.37868 12.5503L11.5 14.6716L15.0355 11.136ZM7 5H4V8H20V5H17V6H15V5H9V6H7V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d4ac112c3a4bd71(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3V1H7V3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3H17V1H15V3H9ZM4 8H20V19H4V8ZM9.87852 9.9643L11.9999 12.0858L14.1211 9.96432L15.5354 11.3785L13.4141 13.5L15.5353 15.6211L14.1212 17.0354L11.9999 14.9142L9.87845 17.0354L8.46432 15.6211L10.5856 13.5L8.46426 11.3785L9.87852 9.9643Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cceb23b51e472088(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3V1H7V3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3H17V1H15V3H9ZM4 10H20V19H4V10ZM4 5H7V6H9V5H15V6H17V5H20V8H4V5ZM9.87862 10.9644L12 13.0858L14.1212 10.9644L15.5355 12.3785L13.4142 14.5001L15.5354 16.6212L14.1213 18.0354L12 15.9143L9.87855 18.0354L8.46442 16.6211L10.5857 14.5001L8.46436 12.3785L9.87862 10.9644Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$620739ab33f41e78(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 13H11V17H6V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bcce90a30fa770fd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM11 13V17H6V13H11ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1f459d8ec469922f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 11H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V11ZM17 3H21C21.5523 3 22 3.44772 22 4V9H2V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$574c9d4b862b2013(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e15bb92c685fa470(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 11H8V13H6V11ZM6 15H8V17H6V15ZM10 11H18V13H10V11ZM10 15H15V17H10V15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$71ee0ed2611eb66c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM8 14V16H6V14H8ZM18 14V16H10V14H18ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$81551b2fec87d4dd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7C13.5705 7 10.6449 9.15804 9.50734 12.1903L11.3805 12.8927C12.2337 10.6185 14.4278 9 17 9C17.6983 9 18.3687 9.11928 18.992 9.33857C21.3265 10.16 23 12.3846 23 15C23 18.3137 20.3137 21 17 21H7C3.68629 21 1 18.3137 1 15C1 12.3846 2.67346 10.16 5.00804 9.33857C5.0027 9.22639 5 9.11351 5 9C5 5.13401 8.13401 2 12 2C15.242 2 17.9693 4.20399 18.7652 7.19539C18.1973 7.0675 17.6065 7 17 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$546ba6e976fb9afa(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C15.866 2 19 5.13401 19 9C19 9.11351 18.9973 9.22639 18.992 9.33857C21.3265 10.16 23 12.3846 23 15C23 18.3137 20.3137 21 17 21H7C3.68629 21 1 18.3137 1 15C1 12.3846 2.67346 10.16 5.00804 9.33857C5.0027 9.22639 5 9.11351 5 9C5 5.13401 8.13401 2 12 2ZM12 4C9.23858 4 7 6.23858 7 9C7 9.08147 7.00193 9.16263 7.00578 9.24344L7.07662 10.7309L5.67183 11.2252C4.0844 11.7837 3 13.2889 3 15C3 17.2091 4.79086 19 7 19H17C19.2091 19 21 17.2091 21 15C21 12.79 19.21 11 17 11C15.233 11 13.7337 12.1457 13.2042 13.7347L11.3064 13.1021C12.1005 10.7185 14.35 9 17 9C17 6.23858 14.7614 4 12 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5d3e59495678677d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.51472 2.10051L22.6066 21.1924L21.1924 22.6066L19.1782 20.5924C18.503 20.8556 17.7684 21 17 21H7C3.68629 21 1 18.3137 1 15C1 12.3846 2.67346 10.16 5.00804 9.33857C5.0027 9.22639 5 9.11351 5 9C5 8.22228 5.12683 7.47418 5.36094 6.77527L2.10051 3.51472L3.51472 2.10051ZM17 9C17.6983 9 18.3687 9.11928 18.992 9.33857C21.3265 10.16 23 12.3846 23 15C23 16.0883 22.7103 17.1089 22.2037 17.9889L14.0109 9.79638C14.891 9.28977 15.9117 9 17 9ZM12 2C15.242 2 17.9693 4.20399 18.7652 7.19539C18.1973 7.0675 17.6065 7 17 7C15.357 7 13.8297 7.49529 12.5592 8.34471L7.69418 3.48056C8.88169 2.55284 10.3763 2 12 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b5feeaba6aa40f0f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.51472 2.10051L22.6066 21.1924L21.1924 22.6066L19.1782 20.5924C18.503 20.8556 17.7684 21 17 21H7C3.68629 21 1 18.3137 1 15C1 12.3846 2.67346 10.16 5.00804 9.33857C5.0027 9.22639 5 9.11351 5 9C5 8.22228 5.12683 7.47418 5.36094 6.77527L2.10051 3.51472L3.51472 2.10051ZM7 9C7 9.08147 7.00193 9.16263 7.00578 9.24344L7.07662 10.7309L5.67183 11.2252C4.0844 11.7837 3 13.2889 3 15C3 17.2091 4.79086 19 7 19H17C17.1858 19 17.3687 18.9873 17.5478 18.9628L7.03043 8.44519C7.01032 8.62736 7 8.81247 7 9ZM12 2C15.866 2 19 5.13401 19 9C19 9.11351 18.9973 9.22639 18.992 9.33857C21.3265 10.16 23 12.3846 23 15C23 16.0883 22.7103 17.1089 22.2037 17.9889L20.7111 16.4955C20.8974 16.0335 21 15.5287 21 15C21 12.79 19.21 11 17 11C16.4711 11 15.9661 11.1027 15.5039 11.2892L14.0111 9.7964C14.8912 9.28978 15.9118 9 17 9C17 6.23858 14.7614 4 12 4C10.9295 4 9.93766 4.33639 9.12428 4.90922L7.69418 3.48056C8.88169 2.55284 10.3763 2 12 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$45cbc0c8941f59f0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22ZM12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7C10.1805 7 8.58698 7.9735 7.71225 9.42771L9.42709 10.4558C9.95162 9.58339 10.9074 9 12 9C13.6575 9 15 10.3425 15 12C15 13.6575 13.6575 15 12 15C10.9069 15 9.95089 14.4162 9.42649 13.5432L7.71225 14.5723C8.58698 16.0265 10.1805 17 12 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$baf141f48bce6e47(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM12 17C10.1805 17 8.58698 16.0265 7.71225 14.5723L9.42649 13.5432C9.95089 14.4162 10.9069 15 12 15C13.6575 15 15 13.6575 15 12C15 10.3425 13.6575 9 12 9C10.9074 9 9.95162 9.58339 9.42709 10.4558L7.71225 9.42771C8.58698 7.9735 10.1805 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$37ab3b0e747eae66(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C13.8195 17 15.413 16.0265 16.2878 14.5723L14.5729 13.5442C14.0484 14.4166 13.0926 15 12 15C10.3425 15 9 13.6575 9 12C9 10.3425 10.3425 9 12 9C13.0931 9 14.0491 9.58383 14.5735 10.4568L16.2878 9.42771C15.413 7.9735 13.8195 7 12 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5a8c923b3f9f1ab3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.2877 9.42773C15.413 7.97351 13.8195 7 12 7 9.23999 7 7 9.23999 7 12 7 14.76 9.23999 17 12 17 13.8195 17 15.413 16.0265 16.2877 14.5723L14.5729 13.5442C14.0483 14.4166 13.0927 15 12 15 10.3425 15 9 13.6575 9 12 9 10.3425 10.3425 9 12 9 13.093 9 14.0491 9.58386 14.5735 10.4568L16.2877 9.42773ZM22 12C22 6.47998 17.52 2 12 2 6.47998 2 2 6.47998 2 12 2 17.52 6.47998 22 12 22 17.52 22 22 17.52 22 12ZM4 12C4 7.57996 7.57996 4 12 4 16.42 4 20 7.57996 20 12 20 16.42 16.42 20 12 20 7.57996 20 4 16.42 4 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9d7995cafff9057a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM14 10H10C9.44772 10 9 10.4477 9 11V15H10.5V19H13.5V15H15V11C15 10.4477 14.5523 10 14 10ZM12 5C10.8954 5 10 5.89543 10 7C10 8.10457 10.8954 9 12 9C13.1046 9 14 8.10457 14 7C14 5.89543 13.1046 5 12 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$944150f4079d78a5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7C14 8.10461 13.1046 9 12 9 10.8954 9 10 8.10461 10 7 10 5.89539 10.8954 5 12 5 13.1046 5 14 5.89539 14 7ZM15 11C15 10.4478 14.5522 10 14 10H10C9.44775 10 9 10.4478 9 11V15H10.5V19H13.5V15H15V11ZM12 2C6.47717 2 2 6.47717 2 12 2 17.5228 6.47717 22 12 22 17.5228 22 22 17.5228 22 12 22 6.47717 17.5228 2 12 2ZM4 12C4 7.58167 7.58167 4 12 4 16.4183 4 20 7.58167 20 12 20 16.4183 16.4183 20 12 20 7.58167 20 4 16.4183 4 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9754d107499a59ae(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM9 8C6.792 8 5 9.792 5 12C5 14.208 6.792 16 9 16C10.104 16 11.104 15.552 11.828 14.828L10.4144 13.4144C10.0525 13.7762 9.5525 14 9 14C7.895 14 7 13.105 7 12C7 10.895 7.895 10 9 10C9.55299 10 10.0534 10.2241 10.4153 10.5866L11.829 9.173C11.1049 8.44841 10.1045 8 9 8ZM16 8C13.792 8 12 9.792 12 12C12 14.208 13.792 16 16 16C17.104 16 18.104 15.552 18.828 14.828L17.4144 13.4144C17.0525 13.7762 16.5525 14 16 14C14.895 14 14 13.105 14 12C14 10.895 14.895 10 16 10C16.553 10 17.0534 10.2241 17.4153 10.5866L18.829 9.173C18.1049 8.44841 17.1045 8 16 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1b1996fd45acdc94(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8C10.1045 8 11.1049 8.44836 11.829 9.17297L10.4153 10.5865C10.0533 10.2241 9.55298 10 9 10 7.89502 10 7 10.895 7 12 7 13.105 7.89502 14 9 14 9.55249 14 10.0525 13.7762 10.4144 13.4144L11.828 14.828C11.104 15.552 10.104 16 9 16 6.79199 16 5 14.208 5 12 5 9.79199 6.79199 8 9 8ZM18.829 9.17297C18.1049 8.44836 17.1045 8 16 8 13.792 8 12 9.79199 12 12 12 14.208 13.792 16 16 16 17.104 16 18.104 15.552 18.828 14.828L17.4144 13.4144C17.0525 13.7762 16.5525 14 16 14 14.895 14 14 13.105 14 12 14 10.895 14.895 10 16 10 16.553 10 17.0533 10.2241 17.4153 10.5865L18.829 9.17297ZM2 12C2 6.47717 6.47717 2 12 2 17.5228 2 22 6.47717 22 12 22 17.5228 17.5228 22 12 22 6.47717 22 2 17.5228 2 12ZM12 4C7.58167 4 4 7.58167 4 12 4 16.4183 7.58167 20 12 20 16.4183 20 20 16.4183 20 12 20 7.58167 16.4183 4 12 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e312adbcbe8ee6ff(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.25639 5.67208L7.83528 9.24858C7.62206 9.61662 7.5 10.0441 7.5 10.5C7.5 11.8807 8.61929 13 10 13H14L14.0899 13.0081C14.3231 13.0504 14.5 13.2545 14.5 13.5C14.5 13.7761 14.2761 14 14 14H8.5V16H11V18H13V16H14C14.1817 16 14.3589 15.9806 14.5296 15.9438L18.3279 19.7436C16.6042 21.1539 14.4009 22 12 22C6.47715 22 2 17.5228 2 12C2 9.5991 2.8461 7.39583 4.25639 5.67208ZM12 2C17.5228 2 22 6.47715 22 12C22 14.4009 21.1539 16.6042 19.7436 18.3279L16.1652 14.7507C16.3781 14.3828 16.5 13.9556 16.5 13.5C16.5 12.1193 15.3807 11 14 11H10L9.91012 10.9919C9.67688 10.9496 9.5 10.7455 9.5 10.5C9.5 10.2239 9.72386 10 10 10H15.5V8H13V6H11V8H10C9.81853 8 9.64159 8.01933 9.4711 8.05605L5.67208 4.25639C7.39583 2.8461 9.5991 2 12 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5fabdd00e2dc3cd1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47717 2 2 6.47717 2 12C2 17.5228 6.47717 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47717 17.5228 2 12 2ZM7.09436 5.68018C8.4491 4.62708 10.1512 4 12 4C16.4183 4 20 7.58167 20 12C20 13.8488 19.3729 15.5509 18.3198 16.9056L16.165 14.7509C16.3781 14.3829 16.5 13.9557 16.5 13.5C16.5 12.1193 15.3807 11 14 11H10C9.72388 11 9.5 10.7761 9.5 10.5C9.5 10.2239 9.72388 10 10 10H15.5V8H13V6H11V8H10C9.81836 8 9.64111 8.01929 9.47046 8.05615L7.09436 5.68018ZM5.68018 7.09436L7.83496 9.24915C7.62195 9.61707 7.5 10.0443 7.5 10.5C7.5 11.8807 8.61926 13 10 13H14C14.2761 13 14.5 13.2239 14.5 13.5C14.5 13.7761 14.2761 14 14 14H8.5V16H11V18H13V16H14C14.1818 16 14.359 15.9807 14.5297 15.9438L16.9056 18.3198C15.5509 19.3729 13.8488 20 12 20C7.58167 20 4 16.4183 4 12C4 10.1512 4.62708 8.4491 5.68018 7.09436Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4e00c5309f15a7f7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM16 13H8V15H16V13ZM16 9H8V11H16V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8bb453b6abfbbb12(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9H16V11H8V9ZM8 15V13H16V15H8ZM2 12C2 6.47717 6.47717 2 12 2 17.5228 2 22 6.47717 22 12 22 17.5228 17.5228 22 12 22 6.47717 22 2 17.5228 2 12ZM12 4C7.58167 4 4 7.58167 4 12 4 16.4183 7.58167 20 12 20 16.4183 20 20 16.4183 20 12 20 7.58167 16.4183 4 12 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a30e3e94c9f12170(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 6C9.82278 6 7.97058 7.66991 7.28433 10.0006L6 10L8.5 13L11 10L9.40123 10.0003C9.91991 8.80452 10.8895 8 12 8C13.6569 8 15 9.79086 15 12C15 14.2091 13.6569 16 12 16C10.8899 16 9.92064 15.1961 9.40181 14.0011L7.28471 14.0007C7.97126 16.3307 9.82318 18 12 18C14.7614 18 17 15.3137 17 12C17 8.68629 14.7614 6 12 6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bcdaf0eb1488020f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12C17 8.68628 14.7615 6 12 6 9.82275 6 7.97058 7.66992 7.2843 10.0006L6 10 8.5 13 11 10 9.40125 10.0002C9.91992 8.80457 10.8895 8 12 8 13.6569 8 15 9.79089 15 12 15 14.2091 13.6569 16 12 16 10.8899 16 9.92065 15.196 9.40186 14.0011L7.28467 14.0006C7.97131 16.3307 9.82312 18 12 18 14.7615 18 17 15.3137 17 12ZM12 2C9.23987 2 6.73865 3.12134 4.93005 4.93005 3.12134 6.73865 2 9.23987 2 12 2 14.7601 3.12134 17.2614 4.93005 19.0699 6.73865 20.8787 9.23987 22 12 22 14.7601 22 17.2614 20.8787 19.0699 19.0699 20.8787 17.2614 22 14.7601 22 12 22 9.23987 20.8787 6.73865 19.0699 4.93005 17.2614 3.12134 14.7601 2 12 2ZM6.34424 6.34424C7.79358 4.8949 9.79224 4 12 4 14.2078 4 16.2064 4.8949 17.6558 6.34424 19.1051 7.79358 20 9.79224 20 12 20 14.2078 19.1051 16.2064 17.6558 17.6558 16.2064 19.1051 14.2078 20 12 20 9.79224 20 7.79358 19.1051 6.34424 17.6558 4.8949 16.2064 4 14.2078 4 12 4 9.79224 4.8949 7.79358 6.34424 6.34424Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dbdb7509c8311bb6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 6C9.23858 6 7 8.68629 7 12C7 15.3137 9.23858 18 12 18C14.7614 18 17 15.3137 17 12C17 8.68629 14.7614 6 12 6ZM14.3253 9.47238C14.747 10.1614 15 11.0413 15 12C15 14.2091 13.6569 16 12 16C11.5589 16 11.1401 15.8731 10.7629 15.6452L14.3253 9.47238ZM12 8C12.4411 8 12.8599 8.12691 13.2371 8.35483L9.67474 14.5276C9.25296 13.8386 9 12.9587 9 12C9 9.79086 10.3431 8 12 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8baab31751bd55f2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12C17 8.68628 14.7615 6 12 6 9.23853 6 7 8.68628 7 12 7 15.3137 9.23853 18 12 18 14.7615 18 17 15.3137 17 12ZM10.7629 15.6451 14.3253 9.47241C14.7471 10.1614 15 11.0413 15 12 15 14.2091 13.6569 16 12 16 11.559 16 11.1401 15.873 10.7629 15.6451ZM9 12C9 9.79089 10.3431 8 12 8 12.441 8 12.8599 8.12695 13.2371 8.35486L9.67468 14.5276C9.25293 13.8386 9 12.9587 9 12ZM12 2C9.23987 2 6.73865 3.12134 4.93005 4.93005 3.12134 6.73865 2 9.23987 2 12 2 14.7601 3.12134 17.2614 4.93005 19.0699 6.73865 20.8787 9.23987 22 12 22 14.7601 22 17.2614 20.8787 19.0699 19.0699 20.8787 17.2614 22 14.7601 22 12 22 9.23987 20.8787 6.73865 19.0699 4.93005 17.2614 3.12134 14.7601 2 12 2ZM6.34424 6.34424C7.79358 4.8949 9.79224 4 12 4 14.2078 4 16.2064 4.8949 17.6558 6.34424 19.1051 7.79358 20 9.79224 20 12 20 14.2078 19.1051 16.2064 17.6558 17.6558 16.2064 19.1051 14.2078 20 12 20 9.79224 20 7.79358 19.1051 6.34424 17.6558 4.8949 16.2064 4 14.2078 4 12 4 9.79224 4.8949 7.79358 6.34424 6.34424Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5c41a951a0a41891(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8C22.1046 8 23 8.89543 23 10V14C23 15.1046 22.1046 16 21 16H19.9381C19.446 19.9463 16.0796 23 12 23V21C15.3137 21 18 18.3137 18 15V9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9V16H3C1.89543 16 1 15.1046 1 14V10C1 8.89543 1.89543 8 3 8H4.06189C4.55399 4.05369 7.92038 1 12 1C16.0796 1 19.446 4.05369 19.9381 8H21ZM7.75944 15.7849L8.81958 14.0887C9.74161 14.6662 10.8318 15 12 15C13.1682 15 14.2584 14.6662 15.1804 14.0887L16.2406 15.7849C15.0112 16.5549 13.5576 17 12 17C10.4424 17 8.98882 16.5549 7.75944 15.7849Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6d3eec01d3f8adf2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.9381 8H21C22.1046 8 23 8.89543 23 10V14C23 15.1046 22.1046 16 21 16H19.9381C19.446 19.9463 16.0796 23 12 23V21C15.3137 21 18 18.3137 18 15V9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9V16H3C1.89543 16 1 15.1046 1 14V10C1 8.89543 1.89543 8 3 8H4.06189C4.55399 4.05369 7.92038 1 12 1C16.0796 1 19.446 4.05369 19.9381 8ZM3 10V14H4V10H3ZM20 10V14H21V10H20ZM7.75944 15.7849L8.81958 14.0887C9.74161 14.6662 10.8318 15 12 15C13.1682 15 14.2584 14.6662 15.1804 14.0887L16.2406 15.7849C15.0112 16.5549 13.5576 17 12 17C10.4424 17 8.98882 16.5549 7.75944 15.7849Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$677169f3fc3ebdb7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 17.0022C21.999 19.8731 19.9816 22.2726 17.2872 22.8616L16.6492 20.9476C17.8532 20.7511 18.8765 20.0171 19.4649 19H17C15.8954 19 15 18.1046 15 17V13C15 11.8954 15.8954 11 17 11H19.9381C19.446 7.05369 16.0796 4 12 4C7.92038 4 4.55399 7.05369 4.06189 11H7C8.10457 11 9 11.8954 9 13V17C9 18.1046 8.10457 19 7 19H4C2.89543 19 2 18.1046 2 17V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V12.9987V13V17V17.0013V17.0022Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$70d223ec158ff057(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 17.0022C21.999 19.8731 19.9816 22.2726 17.2872 22.8616L16.6492 20.9476C17.8532 20.7511 18.8765 20.0171 19.4649 19H17C15.8954 19 15 18.1046 15 17V13C15 11.8954 15.8954 11 17 11H19.9381C19.446 7.05369 16.0796 4 12 4C7.92038 4 4.55399 7.05369 4.06189 11H7C8.10457 11 9 11.8954 9 13V17C9 18.1046 8.10457 19 7 19H4C2.89543 19 2 18.1046 2 17V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V12.9987V13V17V17.0013V17.0022ZM20 17V13H17V17H20ZM4 13V17H7V13H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e18232cae282d558(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9999 2.04932L11 5.07082C7.6077 5.55605 5 8.47346 5 11.9999C5 15.8659 8.13401 18.9999 12 18.9999C13.5723 18.9999 15.0236 18.4815 16.1922 17.6063L18.3289 19.7427C16.605 21.1535 14.4014 21.9999 12 21.9999C6.47715 21.9999 2 17.5228 2 11.9999C2 6.81462 5.94662 2.55109 10.9999 2.04932ZM21.9506 13C21.7509 15.011 20.9555 16.8467 19.7433 18.3282L17.6064 16.1921C18.2926 15.2759 18.7595 14.1859 18.9291 12.9999L21.9506 13ZM13.0011 2.04942C17.725 2.51895 21.4815 6.27583 21.9506 10.9998L18.9291 10.9997C18.4905 7.93446 16.0661 5.50985 13.001 5.07096L13.0011 2.04942Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$649478149bdbbf9c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9999 2.04932L11 4.06182C7.05371 4.5539 4 7.9203 4 11.9999C4 16.4182 7.58172 19.9999 12 19.9999C13.8487 19.9999 15.5509 19.3729 16.9055 18.3199L18.3289 19.7427C16.605 21.1535 14.4014 21.9999 12 21.9999C6.47715 21.9999 2 17.5228 2 11.9999C2 6.81462 5.94662 2.55109 10.9999 2.04932ZM21.9506 13C21.7509 15.011 20.9555 16.8467 19.7433 18.3282L18.3199 16.9055C19.1801 15.7989 19.756 14.4606 19.9381 12.9999L21.9506 13ZM13.0011 2.04942C17.725 2.51895 21.4815 6.27583 21.9506 10.9998L19.9381 11C19.4869 7.38156 16.6192 4.51358 13.001 4.06194L13.0011 2.04942Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$21047cd832eb299e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3H21.1384C21.4146 3 21.6385 3.22386 21.6385 3.5C21.6385 3.58701 21.6157 3.67252 21.5725 3.74807L18 10L21.5725 16.2519C21.7095 16.4917 21.6262 16.7971 21.3865 16.9341C21.3109 16.9773 21.2254 17 21.1384 17H4V22H2V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7a73e563d17a3caa(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.1384 3C21.4146 3 21.6385 3.22386 21.6385 3.5C21.6385 3.58701 21.6157 3.67252 21.5725 3.74807L18 10L21.5725 16.2519C21.7095 16.4917 21.6262 16.7971 21.3865 16.9341C21.3109 16.9773 21.2254 17 21.1384 17H4V22H2V3H21.1384ZM18.5536 5H4V15H18.5536L15.6965 10L18.5536 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e64b1ffdb9aa5fe5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H12.382C12.7607 3 13.107 3.214 13.2764 3.55279L14 5H20C20.5523 5 21 5.44772 21 6V17C21 17.5523 20.5523 18 20 18H13.618C13.2393 18 12.893 17.786 12.7236 17.4472L12 16H5V22H3V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$63eaeaedf63275da(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.382 3C12.7607 3 13.107 3.214 13.2764 3.55279L14 5H20C20.5523 5 21 5.44772 21 6V17C21 17.5523 20.5523 18 20 18H13.618C13.2393 18 12.893 17.786 12.7236 17.4472L12 16H5V22H3V3H12.382ZM11.7639 5H5V14H13.2361L14.2361 16H19V7H12.7639L11.7639 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$61fb42d71d5a791d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.04932 13.0001H7.52725C7.70624 16.2689 8.7574 19.3054 10.452 21.881C5.98761 21.1872 2.5001 17.5403 2.04932 13.0001ZM2.04932 11.0001C2.5001 6.4598 5.98761 2.81288 10.452 2.11914C8.7574 4.69468 7.70624 7.73123 7.52725 11.0001H2.04932ZM21.9506 11.0001H16.4726C16.2936 7.73123 15.2425 4.69468 13.5479 2.11914C18.0123 2.81288 21.4998 6.4598 21.9506 11.0001ZM21.9506 13.0001C21.4998 17.5403 18.0123 21.1872 13.5479 21.881C15.2425 19.3054 16.2936 16.2689 16.4726 13.0001H21.9506ZM9.53068 13.0001H14.4692C14.2976 15.7829 13.4146 18.3733 11.9999 20.5916C10.5852 18.3733 9.70229 15.7829 9.53068 13.0001ZM9.53068 11.0001C9.70229 8.21722 10.5852 5.62684 11.9999 3.40853C13.4146 5.62684 14.2976 8.21722 14.4692 11.0001H9.53068Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$71f160fb9f47a4db(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9.71002 19.6674C8.74743 17.6259 8.15732 15.3742 8.02731 13H4.06189C4.458 16.1765 6.71639 18.7747 9.71002 19.6674ZM10.0307 13C10.1811 15.4388 10.8778 17.7297 12 19.752C13.1222 17.7297 13.8189 15.4388 13.9693 13H10.0307ZM19.9381 13H15.9727C15.8427 15.3742 15.2526 17.6259 14.29 19.6674C17.2836 18.7747 19.542 16.1765 19.9381 13ZM4.06189 11H8.02731C8.15732 8.62577 8.74743 6.37407 9.71002 4.33256C6.71639 5.22533 4.458 7.8235 4.06189 11ZM10.0307 11H13.9693C13.8189 8.56122 13.1222 6.27025 12 4.24799C10.8778 6.27025 10.1811 8.56122 10.0307 11ZM14.29 4.33256C15.2526 6.37407 15.8427 8.62577 15.9727 11H19.9381C19.542 7.8235 17.2836 5.22533 14.29 4.33256Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c7134a2af5f7431b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4V18.7215C21 18.9193 20.8833 19.0986 20.7024 19.1787L12 23.0313L3.29759 19.1787C3.11667 19.0986 3 18.9193 3 18.7215V4H1V2H23V4H21ZM8 12V14H16V12H8ZM8 8V10H16V8H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dcaced06fada7d6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4V18.7215C21 18.9193 20.8833 19.0986 20.7024 19.1787L12 23.0313L3.29759 19.1787C3.11667 19.0986 3 18.9193 3 18.7215V4H1V2H23V4H21ZM5 4V17.7451L12 20.8441L19 17.7451V4H5ZM8 8H16V10H8V8ZM8 12H16V14H8V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f3f472417c23119(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3C4.5313 3 4.12549 3.32553 4.02381 3.78307L2.02381 12.7831C2.00799 12.8543 2 12.927 2 13V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V13C22 12.927 21.992 12.8543 21.9762 12.7831L19.9762 3.78307C19.8745 3.32553 19.4687 3 19 3H5ZM19.7534 12H15C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12H4.24662L5.80217 5H18.1978L19.7534 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fec872e741ff83c1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.02381 3.78307C4.12549 3.32553 4.5313 3 5 3H19C19.4687 3 19.8745 3.32553 19.9762 3.78307L21.9762 12.7831C21.992 12.8543 22 12.927 22 13V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V13C2 12.927 2.00799 12.8543 2.02381 12.7831L4.02381 3.78307ZM5.80217 5L4.24662 12H9C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12H19.7534L18.1978 5H5.80217ZM16.584 14C15.8124 15.7659 14.0503 17 12 17C9.94968 17 8.1876 15.7659 7.41604 14H4V19H20V14H16.584Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d6945fb5f4a3948(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20L22 7V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7.00353L4 3ZM13 14V10H11V14H8L12 18L16 14H13ZM19.7639 7L18.7639 5H5.23656L4.23744 7H19.7639Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c2a1091fc3a0436c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3L22 7V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7.00353L4 3H20ZM20 9H4V19H20V9ZM13 10V14H16L12 18L8 14H11V10H13ZM18.7639 5H5.23656L4.23744 7H19.7639L18.7639 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6ce49e562ee4965e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12H20V5H4V12H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7b5fe5e9763c9ab4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM7.41604 14H4V19H20V14H16.584C15.8124 15.7659 14.0503 17 12 17C9.94968 17 8.1876 15.7659 7.41604 14ZM20 5H4V12H9C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12H20V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1a4cd91983d6417(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3L22 7V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7.00353L4 3H20ZM12 10L8 14H11V18H13V14H16L12 10ZM18.764 5H5.236L4.237 7H19.764L18.764 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$aba12f67fedb6d0f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3L22 7V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7.00353L4 3H20ZM20 9H4V19H20V9ZM12 10L16 14H13V18H11V14H8L12 10ZM18.764 5H5.236L4.237 7H19.764L18.764 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b9493e7f814c47ec(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3V19H21V21H3V3H5ZM19.9393 5.93934L22.0607 8.06066L16 14.1213L13 11.121L9.06066 15.0607L6.93934 12.9393L13 6.87868L16 9.879L19.9393 5.93934Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$100db3705bf30e70(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3V19H21V21H3V3H5ZM20.2929 6.29289L21.7071 7.70711L16 13.4142L13 10.415L8.70711 14.7071L7.29289 13.2929L13 7.58579L16 10.585L20.2929 6.29289Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2d0125653d41e29c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.0605 8.11073L14.4747 9.52494C17.2084 12.2586 17.2084 16.6908 14.4747 19.4244L14.1211 19.778C11.3875 22.5117 6.95531 22.5117 4.22164 19.778C1.48797 17.0443 1.48797 12.6122 4.22164 9.87849L5.63585 11.2927C3.68323 13.2453 3.68323 16.4112 5.63585 18.3638C7.58847 20.3164 10.7543 20.3164 12.7069 18.3638L13.0605 18.0102C15.0131 16.0576 15.0131 12.8918 13.0605 10.9392L11.6463 9.52494L13.0605 8.11073ZM19.778 14.1211L18.3638 12.7069C20.3164 10.7543 20.3164 7.58847 18.3638 5.63585C16.4112 3.68323 13.2453 3.68323 11.2927 5.63585L10.9392 5.98941C8.98653 7.94203 8.98653 11.1079 10.9392 13.0605L12.3534 14.4747L10.9392 15.8889L9.52494 14.4747C6.79127 11.741 6.79127 7.30886 9.52494 4.57519L9.87849 4.22164C12.6122 1.48797 17.0443 1.48797 19.778 4.22164C22.5117 6.95531 22.5117 11.3875 19.778 14.1211Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2d6a86427f1ca1c1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.0605 8.11073L14.4747 9.52494C17.2084 12.2586 17.2084 16.6908 14.4747 19.4244L14.1211 19.778C11.3875 22.5117 6.95531 22.5117 4.22164 19.778C1.48797 17.0443 1.48797 12.6122 4.22164 9.87849L5.63585 11.2927C3.68323 13.2453 3.68323 16.4112 5.63585 18.3638C7.58847 20.3164 10.7543 20.3164 12.7069 18.3638L13.0605 18.0102C15.0131 16.0576 15.0131 12.8918 13.0605 10.9392L11.6463 9.52494L13.0605 8.11073ZM19.778 14.1211L18.3638 12.7069C20.3164 10.7543 20.3164 7.58847 18.3638 5.63585C16.4112 3.68323 13.2453 3.68323 11.2927 5.63585L10.9392 5.98941C8.98653 7.94203 8.98653 11.1079 10.9392 13.0605L12.3534 14.4747L10.9392 15.8889L9.52494 14.4747C6.79127 11.741 6.79127 7.30886 9.52494 4.57519L9.87849 4.22164C12.6122 1.48797 17.0443 1.48797 19.778 4.22164C22.5117 6.95531 22.5117 11.3875 19.778 14.1211Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f1c969bb60618646(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13.3414C21.3744 13.1203 20.7013 13 20 13C16.6863 13 14 15.6863 14 19C14 19.7013 14.1203 20.3744 14.3414 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V13.3414ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829ZM21 18H24V20H21V23H19V20H16V18H19V15H21V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ebc16e214cc38358(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13H20V7.23792L12.0718 14.338L4 7.21594V19H14V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V13ZM4.51146 5L12.0619 11.662L19.501 5H4.51146ZM21 18H24V20H21V23H19V20H16V18H19V15H21V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$301c9797683348d8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13.3414C21.3744 13.1203 20.7013 13 20 13C16.6863 13 14 15.6863 14 19C14 19.7013 14.1203 20.3744 14.3414 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V13.3414ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829ZM19 22L15.4645 18.4645L16.8787 17.0503L19 19.1716L22.5355 15.636L23.9497 17.0503L19 22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9579f6fea5c2ea0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 14H20V7.23792L12.0718 14.338L4 7.21594V19H14V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V14ZM4.51146 5L12.0619 11.662L19.501 5H4.51146ZM19 22L15.4645 18.4645L16.8787 17.0503L19 19.1716L22.5355 15.636L23.9497 17.0503L19 22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9817fc19afc4f5c3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13.3414C21.3744 13.1203 20.7013 13 20 13C16.6863 13 14 15.6863 14 19C14 19.7013 14.1203 20.3744 14.3414 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V13.3414ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829ZM21.4142 19L23.5355 21.1213L22.1213 22.5355L20 20.4142L17.8787 22.5355L16.4645 21.1213L18.5858 19L16.4645 16.8787L17.8787 15.4645L20 17.5858L22.1213 15.4645L23.5355 16.8787L21.4142 19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1c07cd3b0f99e58(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 14H20V7.23792L12.0718 14.338L4 7.21594V19H15V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V14ZM4.51146 5L12.0619 11.662L19.501 5H4.51146ZM21.4142 19L23.5355 21.1213L22.1213 22.5355L20 20.4142L17.8787 22.5355L16.4645 21.1213L18.5858 19L16.4645 16.8787L17.8787 15.4645L20 17.5858L22.1213 15.4645L23.5355 16.8787L21.4142 19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a63aff72e8d06cf5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12.8027C21.1175 12.2922 20.0929 12 19 12C15.6863 12 13 14.6863 13 18C13 19.0929 13.2922 20.1175 13.8027 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V12.8027ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829ZM20 18H23L19 22L15 18H18V14H20V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2fc88035ffad1482(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7.23792L12.0718 14.338L4 7.21594V19H13V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V12H20V7.23792ZM19.501 5H4.51146L12.0619 11.662L19.501 5ZM20 18H23L19 22L15 18H18V14H20V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2e76b855ca7ef382(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$53fc99fbda3ee68d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.2657 11.5541L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0554 14.3021C11.3865 15.3751 11 16.6424 11 18C11 19.0736 11.2417 20.0907 11.6736 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V12.2547C20.8662 11.4638 19.4872 11 18 11C17.0298 11 16.1057 11.1974 15.2657 11.5541ZM16.7066 20.7076C17.0982 20.895 17.5369 21 18 21C19.6569 21 21 19.6569 21 18C21 17.5369 20.895 17.0982 20.7076 16.7066L16.7066 20.7076ZM15.2924 19.2934L19.2934 15.2924C18.9018 15.105 18.4631 15 18 15C16.3431 15 15 16.3431 15 18C15 18.4631 15.105 18.9018 15.2924 19.2934ZM18 23C15.2386 23 13 20.7614 13 18C13 15.2386 15.2386 13 18 13C20.7614 13 23 15.2386 23 18C23 20.7614 20.7614 23 18 23Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e2a371b9f25115f8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7.23792L12.0718 14.338L4 7.21594V19H11.0709C11.1719 19.7061 11.3783 20.3783 11.6736 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V12.2547C21.396 11.8334 20.7224 11.5049 20 11.2899V7.23792ZM19.501 5H4.51146L12.0619 11.662L19.501 5ZM16.7066 20.7076C17.0982 20.895 17.5369 21 18 21C19.6569 21 21 19.6569 21 18C21 17.5369 20.895 17.0982 20.7076 16.7066L16.7066 20.7076ZM15.2924 19.2934L19.2934 15.2924C18.9018 15.105 18.4631 15 18 15C16.3431 15 15 16.3431 15 18C15 18.4631 15.105 18.9018 15.2924 19.2934ZM18 23C15.2386 23 13 20.7614 13 18C13 15.2386 15.2386 13 18 13C20.7614 13 23 15.2386 23 18C23 20.7614 20.7614 23 18 23Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$16a240973c445cff(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM20 7.23792L12.0718 14.338L4 7.21594V19H20V7.23792ZM4.51146 5L12.0619 11.662L19.501 5H4.51146Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$75a633b8233c8ebd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11.9996C21.1643 11.3719 20.1256 11 19 11C16.581 11 14.5633 12.7178 14.1 15H13V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V11.9996ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829ZM22 17H23V22H15V17H16V16C16 14.3431 17.3431 13 19 13C20.6569 13 22 14.3431 22 16V17ZM20 17V16C20 15.4477 19.5523 15 19 15C18.4477 15 18 15.4477 18 16V17H20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$87c166c52fb69bb8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7.23792L12.0718 14.338L4 7.21594V19H13V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V11H20V7.23792ZM19.501 5H4.51146L12.0619 11.662L19.501 5ZM22 17H23V22H15V17H16V16C16 14.3431 17.3431 13 19 13C20.6569 13 22 14.3431 22 16V17ZM20 17V16C20 15.4477 19.5523 15 19 15C18.4477 15 18 15.4477 18 16V17H20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c35bfc066bfa7ad6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.24283 6.85419L11.4895 1.30843C11.8062 1.11848 12.2019 1.11855 12.5185 1.30862L21.7573 6.85416C21.9079 6.94453 22 7.10726 22 7.28286V19.9998C22 20.5521 21.5523 20.9998 21 20.9998H3C2.44772 20.9998 2 20.5521 2 19.9998V7.28298C2 7.10732 2.09218 6.94454 2.24283 6.85419ZM18.3456 8.24367L12.0606 13.6827L5.64722 8.23752L4.35278 9.76213L12.0731 16.3169L19.6544 9.75599L18.3456 8.24367Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ee864c6b15568de9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.24283 6.85419L11.4895 1.30843C11.8062 1.11848 12.2019 1.11855 12.5185 1.30862L21.7573 6.85416C21.9079 6.94453 22 7.10726 22 7.28286V19.9998C22 20.5521 21.5523 20.9998 21 20.9998H3C2.44772 20.9998 2 20.5521 2 19.9998V7.28298C2 7.10732 2.09218 6.94454 2.24283 6.85419ZM4 8.13244V18.9998H20V8.13197L12.0037 3.33221L4 8.13244ZM12.0597 13.6981L17.3556 9.23515L18.6444 10.7645L12.074 16.3016L5.36401 10.7715L6.63599 9.22813L12.0597 13.6981Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f9064cb52ff47078(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5.5V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V19H20V7.3L12 14.5L2 5.5ZM0 10H5V12H0V10ZM0 15H8V17H0V15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ada339a06ff13403(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V19H20V7.3L12 14.5L2 5.5V4C2 3.44772 2.44772 3 3 3H21ZM8 15V17H0V15H8ZM5 10V12H0V10H5ZM19.5659 5H4.43414L12 11.8093L19.5659 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8d001f7ed557c12e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13.3414C21.3744 13.1203 20.7013 13 20 13C16.6863 13 14 15.6863 14 19C14 19.7013 14.1203 20.3744 14.3414 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V13.3414ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829ZM17.05 19.5485C17.0172 19.3706 17 19.1873 17 19C17 18.8127 17.0172 18.6294 17.05 18.4515L16.0359 17.866L17.0359 16.134L18.0505 16.7197C18.3278 16.4824 18.6489 16.2948 19 16.1707V15H21V16.1707C21.3511 16.2948 21.6722 16.4824 21.9495 16.7197L22.9641 16.134L23.9641 17.866L22.95 18.4515C22.9828 18.6294 23 18.8127 23 19C23 19.1873 22.9828 19.3706 22.95 19.5485L23.9641 20.134L22.9641 21.866L21.9495 21.2803C21.6722 21.5176 21.3511 21.7052 21 21.8293V23H19V21.8293C18.6489 21.7052 18.3278 21.5176 18.0505 21.2803L17.0359 21.866L16.0359 20.134L17.05 19.5485ZM20 20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18C19.4477 18 19 18.4477 19 19C19 19.5523 19.4477 20 20 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6a39a5c8524b7550(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7.23792L12.0718 14.338L4 7.21594V19H14V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V13H20V7.23792ZM19.501 5H4.51146L12.0619 11.662L19.501 5ZM17.05 19.5485C17.0172 19.3706 17 19.1873 17 19C17 18.8127 17.0172 18.6294 17.05 18.4515L16.0359 17.866L17.0359 16.134L18.0505 16.7197C18.3278 16.4824 18.6489 16.2948 19 16.1707V15H21V16.1707C21.3511 16.2948 21.6722 16.4824 21.9495 16.7197L22.9641 16.134L23.9641 17.866L22.95 18.4515C22.9828 18.6294 23 18.8127 23 19C23 19.1873 22.9828 19.3706 22.95 19.5485L23.9641 20.134L22.9641 21.866L21.9495 21.2803C21.6722 21.5176 21.3511 21.7052 21 21.8293V23H19V21.8293C18.6489 21.7052 18.3278 21.5176 18.0505 21.2803L17.0359 21.866L16.0359 20.134L17.05 19.5485ZM20 20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18C19.4477 18 19 18.4477 19 19C19 19.5523 19.4477 20 20 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c7b43375dd1af767(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 14.044C21.2389 13.6947 20.3922 13.5 19.5 13.5C16.1863 13.5 13.5 16.1863 13.5 19.5C13.5 20.018 13.5656 20.5206 13.689 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V14.044ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829ZM19.5 21.75L16.855 23.1406L17.3601 20.1953L15.2202 18.1094L18.1775 17.6797L19.5 15L20.8225 17.6797L23.7798 18.1094L21.6399 20.1953L22.145 23.1406L19.5 21.75Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8b061035ce942c91(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13H20V7.23792L12.0718 14.338L4 7.21594V19H14V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V13ZM4.51146 5L12.0619 11.662L19.501 5H4.51146ZM19.5 21.75L16.855 23.1406L17.3601 20.1953L15.2202 18.1094L18.1775 17.6797L19.5 15L20.8225 17.6797L23.7798 18.1094L21.6399 20.1953L22.145 23.1406L19.5 21.75Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ef8cd387d74db6c1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.8032 8.4928C19.4663 8.81764 20.2118 9 21 9C21.3425 9 21.6769 8.96557 22 8.89998V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H16.1C16.0344 3.32311 16 3.65753 16 4C16 5.23672 16.449 6.36857 17.1929 7.24142L12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L18.8032 8.4928ZM21 7C19.3431 7 18 5.65685 18 4C18 2.34315 19.3431 1 21 1C22.6569 1 24 2.34315 24 4C24 5.65685 22.6569 7 21 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f969344293a95f97(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.1 3C16.0344 3.32311 16 3.65753 16 4C16 4.34247 16.0344 4.67689 16.1 5H4.51146L12.0619 11.662L17.1098 7.14141C17.5363 7.66888 18.0679 8.10787 18.6728 8.42652L12.0718 14.338L4 7.21594V19H20V8.89998C20.3231 8.96557 20.6575 9 21 9C21.3425 9 21.6769 8.96557 22 8.89998V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H16.1ZM21 1C22.6569 1 24 2.34315 24 4C24 5.65685 22.6569 7 21 7C19.3431 7 18 5.65685 18 4C18 2.34315 19.3431 1 21 1Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5bf17d0a9abfa7c8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14.5V23.5L16.667 21H14V17H16.667L20 14.5ZM21 3C21.5523 3 22 3.44772 22 4L22.0009 14.5286C20.9393 13.578 19.5371 13 18 13C14.6863 13 12 15.6863 12 19C12 19.7015 12.1204 20.3749 12.3417 21.0007L3 21C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 17C22.1046 17 23 17.8954 23 19C23 20.0544 22.1841 20.9182 21.1493 20.9945L21 21V17ZM5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.06 11.682L5.64722 6.2377Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fbb76ce8e537977e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14.5V23.5L16.667 21H14V17H16.667L20 14.5ZM21 3C21.5523 3 22 3.44772 22 4V13H20V7.237L12.0718 14.338L4 7.215V19H12V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 17C22.1046 17 23 17.8954 23 19C23 20.0544 22.1841 20.9182 21.1493 20.9945L21 21V17ZM19.5 5H4.511L12.061 11.662L19.5 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8710ad993beadd45(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0001 8.5L14.1161 13.5875L19.6085 14.0279L15.4239 17.6125L16.7023 22.9721L12.0001 20.1L7.29777 22.9721L8.57625 17.6125L4.3916 14.0279L9.88403 13.5875L12.0001 8.5ZM8.00005 2V11H6.00005V2H8.00005ZM18.0001 2V11H16.0001V2H18.0001ZM13.0001 2V7H11.0001V2H13.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$819d295428c22f80(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0001 8.5L14.1161 13.5875L19.6085 14.0279L15.4239 17.6125L16.7023 22.9721L12.0001 20.1L7.29777 22.9721L8.57625 17.6125L4.3916 14.0279L9.88403 13.5875L12.0001 8.5ZM12.0001 13.707L11.2615 15.4835L9.34505 15.637L10.8051 16.8883L10.3581 18.759L12.0001 17.7564L13.6411 18.759L13.195 16.8883L14.6541 15.637L12.7386 15.4835L12.0001 13.707ZM8.00005 2V11H6.00005V2H8.00005ZM18.0001 2V11H16.0001V2H18.0001ZM13.0001 2V7H11.0001V2H13.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a993dbb74ff824b2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.00002C16.4183 7.00002 20 10.5817 20 15C20 19.4183 16.4183 23 12 23C7.58172 23 4 19.4183 4 15C4 10.5817 7.58172 7.00002 12 7.00002ZM12 10.5L10.6775 13.1797L7.72025 13.6094L9.86012 15.6953L9.35497 18.6406L12 17.25L14.645 18.6406L14.1399 15.6953L16.2798 13.6094L13.3225 13.1797L12 10.5ZM13 1.99902L18 2.00002V5.00002L16.6366 6.13758C15.5305 5.55773 14.3025 5.17887 13.0011 5.04951L13 1.99902ZM11 1.99902L10.9997 5.04943C9.6984 5.17866 8.47046 5.55738 7.36441 6.13706L6 5.00002V2.00002L11 1.99902Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9bceb17938c5c5d4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.00002C16.4183 7.00002 20 10.5817 20 15C20 19.4183 16.4183 23 12 23C7.58172 23 4 19.4183 4 15C4 10.5817 7.58172 7.00002 12 7.00002ZM12 9.00002C8.68629 9.00002 6 11.6863 6 15C6 18.3137 8.68629 21 12 21C15.3137 21 18 18.3137 18 15C18 11.6863 15.3137 9.00002 12 9.00002ZM12 10.5L13.3225 13.1797L16.2798 13.6094L14.1399 15.6953L14.645 18.6406L12 17.25L9.35497 18.6406L9.86012 15.6953L7.72025 13.6094L10.6775 13.1797L12 10.5ZM18 2.00002V5.00002L16.6366 6.13758C15.5305 5.55773 14.3025 5.17887 13.0011 5.04951L13 1.99902L18 2.00002ZM11 1.99902L10.9997 5.04943C9.6984 5.17866 8.47046 5.55738 7.36441 6.13706L6 5.00002V2.00002L11 1.99902Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7ca7884503a6fbf3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10.063V4C21 3.44772 20.5523 3 20 3H19C17.0214 4.97864 13.3027 6.08728 11 6.61281V17.3872C13.3027 17.9127 17.0214 19.0214 19 21H20C20.5523 21 21 20.5523 21 20V13.937C21.8626 13.715 22.5 12.9319 22.5 12 22.5 11.0681 21.8626 10.285 21 10.063ZM5 7C3.89543 7 3 7.89543 3 9V15C3 16.1046 3.89543 17 5 17H6L7 22H9V7H5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eecce3346e44ecc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17C9 17 16 18 19 21H20C20.5523 21 21 20.5523 21 20V13.937C21.8626 13.715 22.5 12.9319 22.5 12C22.5 11.0681 21.8626 10.285 21 10.063V4C21 3.44772 20.5523 3 20 3H19C16 6 9 7 9 7H5C3.89543 7 3 7.89543 3 9V15C3 16.1046 3.89543 17 5 17H6L7 22H9V17ZM11 8.6612C11.6833 8.5146 12.5275 8.31193 13.4393 8.04373C15.1175 7.55014 17.25 6.77262 19 5.57458V18.4254C17.25 17.2274 15.1175 16.4499 13.4393 15.9563C12.5275 15.6881 11.6833 15.4854 11 15.3388V8.6612ZM5 9H9V15H5V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$80a597925e618ce5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.00008 10C9.00008 10.5523 8.55236 11 8.00008 11 7.44779 11 7.00008 10.5523 7.00008 10 7.00008 9.44772 7.44779 9 8.00008 9 8.55236 9 9.00008 9.44772 9.00008 10ZM2 4C1.44772 4 1 4.44772 1 5V19C1 19.5523 1.44772 20 2 20H22C22.5523 20 23 19.5523 23 19V5C23 4.44772 22.5523 4 22 4H2ZM11.0001 10C11.0001 11.6569 9.65693 13 8.00008 13 6.34322 13 5.00008 11.6569 5.00008 10 5.00008 8.34315 6.34322 7 8.00008 7 9.65693 7 11.0001 8.34315 11.0001 10ZM5.52725 17.0251 4.11304 15.6109C5.10725 14.6167 6.48362 14 8.00212 14 9.52063 14 10.897 14.6167 11.8912 15.6109L10.477 17.0251C9.84253 16.3907 8.9689 16 8.00212 16 7.03535 16 6.16172 16.3907 5.52725 17.0251ZM16.0001 10.5858 17.793 8.79289 19.2072 10.2071 17.4143 12 19.2072 13.7929 17.793 15.2071 16.0001 13.4142 14.2072 15.2071 12.793 13.7929 14.5859 12 12.793 10.2071 14.2072 8.79289 16.0001 10.5858Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7d61955f0c7ad791(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18H21V6H3V18ZM1 5C1 4.44772 1.44772 4 2 4H22C22.5523 4 23 4.44772 23 5V19C23 19.5523 22.5523 20 22 20H2C1.44772 20 1 19.5523 1 19V5ZM9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11C8.55228 11 9 10.5523 9 10ZM11 10C11 11.6569 9.65685 13 8 13C6.34315 13 5 11.6569 5 10C5 8.34315 6.34315 7 8 7C9.65685 7 11 8.34315 11 10ZM8.0018 16C7.03503 16 6.1614 16.3907 5.52693 17.0251L4.11272 15.6109C5.10693 14.6167 6.4833 14 8.0018 14C9.52031 14 10.8967 14.6167 11.8909 15.6109L10.4767 17.0251C9.84221 16.3907 8.96858 16 8.0018 16ZM17.7929 8.79289L16 10.5858L14.2071 8.79289L12.7929 10.2071L14.5858 12L12.7929 13.7929L14.2071 15.2071L16 13.4142L17.7929 15.2071L19.2071 13.7929L17.4142 12L19.2071 10.2071L17.7929 8.79289Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4e43a6df354d570c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4C1.44772 4 1 4.44772 1 5V19C1 19.5523 1.44772 20 2 20H22C22.5523 20 23 19.5523 23 19V5C23 4.44772 22.5523 4 22 4H2ZM9.00008 10C9.00008 9.44772 8.55236 9 8.00008 9C7.44779 9 7.00008 9.44772 7.00008 10C7.00008 10.5523 7.44779 11 8.00008 11C8.55236 11 9.00008 10.5523 9.00008 10ZM11.0001 10C11.0001 11.6569 9.65693 13 8.00008 13C6.34322 13 5.00008 11.6569 5.00008 10C5.00008 8.34315 6.34322 7 8.00008 7C9.65693 7 11.0001 8.34315 11.0001 10ZM5.52725 17.0251L4.11304 15.6109C5.10725 14.6167 6.48362 14 8.00212 14C9.52063 14 10.897 14.6167 11.8912 15.6109L10.477 17.0251C9.84253 16.3907 8.9689 16 8.00212 16C7.03535 16 6.16172 16.3907 5.52725 17.0251ZM13 15V9H15V15H13ZM17 15V9H19V15H17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1c2918a90bcff02e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18H21V6H3V18ZM1 5C1 4.44772 1.44772 4 2 4H22C22.5523 4 23 4.44772 23 5V19C23 19.5523 22.5523 20 22 20H2C1.44772 20 1 19.5523 1 19V5ZM9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11C8.55228 11 9 10.5523 9 10ZM11 10C11 11.6569 9.65685 13 8 13C6.34315 13 5 11.6569 5 10C5 8.34315 6.34315 7 8 7C9.65685 7 11 8.34315 11 10ZM8.0018 16C7.03503 16 6.1614 16.3907 5.52693 17.0251L4.11272 15.6109C5.10693 14.6167 6.4833 14 8.0018 14C9.52031 14 10.8967 14.6167 11.8909 15.6109L10.4767 17.0251C9.84221 16.3907 8.96858 16 8.0018 16ZM13 9V15H15V9H13ZM17 9V15H19V9H17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4c9e8e8b9cddbdfe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4C1.44772 4 1 4.44772 1 5V19C1 19.5523 1.44772 20 2 20H22C22.5523 20 23 19.5523 23 19V5C23 4.44772 22.5523 4 22 4H2ZM9.00008 10C9.00008 9.44772 8.55236 9 8.00008 9C7.44779 9 7.00008 9.44772 7.00008 10C7.00008 10.5523 7.44779 11 8.00008 11C8.55236 11 9.00008 10.5523 9.00008 10ZM11.0001 10C11.0001 11.6569 9.65693 13 8.00008 13C6.34322 13 5.00008 11.6569 5.00008 10C5.00008 8.34315 6.34322 7 8.00008 7C9.65693 7 11.0001 8.34315 11.0001 10ZM5.52725 17.0251L4.11304 15.6109C5.10725 14.6167 6.48362 14 8.00212 14C9.52063 14 10.897 14.6167 11.8912 15.6109L10.477 17.0251C9.84253 16.3907 8.9689 16 8.00212 16C7.03535 16 6.16172 16.3907 5.52725 17.0251ZM20.2071 10.7071L16.2071 14.7071L15.5 15.4142L14.7929 14.7071L12.2929 12.2071L13.7071 10.7929L15.5 12.5858L18.7929 9.29289L20.2071 10.7071Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cf1475f56d911075(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18H21V6H3V18ZM1 5C1 4.44772 1.44772 4 2 4H22C22.5523 4 23 4.44772 23 5V19C23 19.5523 22.5523 20 22 20H2C1.44772 20 1 19.5523 1 19V5ZM9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11C8.55228 11 9 10.5523 9 10ZM11 10C11 11.6569 9.65685 13 8 13C6.34315 13 5 11.6569 5 10C5 8.34315 6.34315 7 8 7C9.65685 7 11 8.34315 11 10ZM8.0018 16C7.03503 16 6.1614 16.3907 5.52693 17.0251L4.11272 15.6109C5.10693 14.6167 6.4833 14 8.0018 14C9.52031 14 10.8967 14.6167 11.8909 15.6109L10.4767 17.0251C9.84221 16.3907 8.96858 16 8.0018 16ZM16.2071 14.7071L20.2071 10.7071L18.7929 9.29289L15.5 12.5858L13.7071 10.7929L12.2929 12.2071L14.7929 14.7071L15.5 15.4142L16.2071 14.7071Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4e827a9779dd869c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2.04947V13.0001H21.9506C21.4489 18.0534 17.1853 22.0001 12 22.0001C6.47715 22.0001 2 17.5229 2 12.0001C2 6.81475 5.94668 2.55119 11 2.04947ZM13 0.542969C18.5535 1.02133 22.9788 5.44662 23.4571 11.0001H13V0.542969Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$99348ebda204f0d0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 12.3369 23.4855 12.6704 23.4571 13H21.9506C21.4489 18.0533 17.1853 22 12 22C6.47715 22 2 17.5228 2 12C2 6.81465 5.94668 2.5511 11 2.04938V0.542876C11.3296 0.514488 11.6631 0.5 12 0.5ZM11 4.06189C7.05369 4.55399 4 7.92038 4 12C4 16.4183 7.58172 20 12 20C16.0796 20 19.446 16.9463 19.9381 13H11V4.06189ZM13 2.552V11H21.448C20.9827 6.55197 17.448 3.01732 13 2.552Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fe8a84550f1ab447(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM16.9 13H11V7.10002C8.71776 7.56329 7 9.58104 7 12C7 14.7614 9.23858 17 12 17C14.419 17 16.4367 15.2822 16.9 13ZM16.9 11C16.5023 9.04087 14.9591 7.4977 13 7.10002V11H16.9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d4a9d7cbab438c97(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM4 5V19H20V5H4ZM16.9 13C16.4367 15.2822 14.419 17 12 17C9.23858 17 7 14.7614 7 12C7 9.58104 8.71776 7.56329 11 7.10002V13H16.9ZM16.9 11H13V7.10002C14.9591 7.4977 16.5023 9.04087 16.9 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$67115d3590d318de(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2.04932V12.9999H21.9506C21.4489 18.0533 17.1853 21.9999 12 21.9999C6.47715 21.9999 2 17.5228 2 11.9999C2 6.81459 5.94668 2.55104 11 2.04932ZM13 2.04932C17.7244 2.51839 21.4816 6.27552 21.9506 10.9999H13V2.04932Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$84d2791e50404282(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2.4578V4.58152C6.06817 5.76829 4 8.64262 4 12C4 16.4183 7.58172 20 12 20C15.3574 20 18.2317 17.9318 19.4185 15H21.5422C20.2679 19.0571 16.4776 22 12 22C6.47715 22 2 17.5228 2 12C2 7.52236 4.94289 3.73207 9 2.4578ZM12 2C17.5228 2 22 6.47715 22 12C22 12.3375 21.9833 12.6711 21.9506 13H11V2.04938C11.3289 2.01672 11.6625 2 12 2ZM13 4.06189V11H19.9381C19.4869 7.38128 16.6187 4.51314 13 4.06189Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$746d36162c326f1a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4C8 5.10457 7.10457 6 6 6 4.89543 6 4 5.10457 4 4 4 2.89543 4.89543 2 6 2 7.10457 2 8 2.89543 8 4ZM5 16V22H3V10C3 8.34315 4.34315 7 6 7 6.82059 7 7.56423 7.32946 8.10585 7.86333L10.4803 10.1057 12.7931 7.79289 14.2073 9.20711 10.5201 12.8943 9 11.4587V22H7V16H5ZM10 5H19V14H10V16H14.3654L17.1889 22H19.3993L16.5758 16H20C20.5523 16 21 15.5523 21 15V4C21 3.44772 20.5523 3 20 3H10V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7aa6d5c21bddbb26(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4C8 5.10457 7.10457 6 6 6 4.89543 6 4 5.10457 4 4 4 2.89543 4.89543 2 6 2 7.10457 2 8 2.89543 8 4ZM5 16V22H3V10C3 8.34315 4.34315 7 6 7 6.82059 7 7.56423 7.32946 8.10585 7.86333L10.4803 10.1057 12.7931 7.79289 14.2073 9.20711 10.5201 12.8943 9 11.4587V22H7V16H5ZM6 9C5.44772 9 5 9.44772 5 10V14H7V10C7 9.44772 6.55228 9 6 9ZM19 5H10V3H20C20.5523 3 21 3.44772 21 4V15C21 15.5523 20.5523 16 20 16H16.5758L19.3993 22H17.1889L14.3654 16H10V14H19V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d7d05868f2683181(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2H17C17.5523 2 18 2.44771 18 3V6H6V3C6 2.44771 6.44772 2 7 2ZM22 9C22 8.44771 21.5523 8 21 8H3C2.44771 8 2 8.44771 2 9V19C2 19.5523 2.44771 20 3 20H5V15H12.1938C12.4371 14.1087 12.9094 13.3124 13.6109 12.6109C14.6848 11.537 15.9812 11 17.5 11C19.0188 11 20.3152 11.537 21.3891 12.6109C21.6169 12.8387 21.8205 13.0765 22 13.3243V9ZM8 10V12H5V10H8ZM21 16.5C21 14.567 19.433 13 17.5 13C15.567 13 14 14.567 14 16.5L14.0034 16.6025C12.8474 16.9279 12 17.99 12 19.25C12 20.7125 13.1417 21.9084 14.5825 21.995L14.75 22H20.25L20.4175 21.995C21.8583 21.9084 23 20.7125 23 19.25C23 17.9903 22.1531 16.9285 20.9985 16.6033L21 16.5ZM7 17H10.562C10.1873 17.6859 10 18.4359 10 19.25C10 20.2823 10.2905 21.199 10.8715 22H7V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$134727ff5ec6cd6a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2C17.5523 2 18 2.44771 18 3V7H21C21.5523 7 22 7.44772 22 8V13.3243C21.8205 13.0765 21.6169 12.8387 21.3891 12.6109C20.9614 12.1832 20.4983 11.8406 20 11.5832V9H4V17H6V16C6 15.4477 6.44772 15 7 15H12.1938C12.1683 15.0933 12.1454 15.1877 12.1249 15.283C11.6949 15.5675 11.314 15.9255 10.9824 16.357C10.8228 16.5647 10.6827 16.779 10.562 17H8V20H10.0541C10.1628 20.7319 10.4352 21.3985 10.8715 22H7C6.44772 22 6 21.5523 6 21V19H3C2.44771 19 2 18.5523 2 18V8C2 7.44772 2.44771 7 3 7H6V3C6 2.44771 6.44772 2 7 2H17ZM16 4H8V7H16V4ZM8 10V12H5V10H8ZM21 16.5C21 14.567 19.433 13 17.5 13C15.567 13 14 14.567 14 16.5L14.0034 16.6025C12.8474 16.9279 12 17.99 12 19.25C12 20.7125 13.1417 21.9084 14.5825 21.995L14.75 22H20.25L20.4175 21.995C21.8583 21.9084 23 20.7125 23 19.25C23 17.9903 22.1531 16.9285 20.9985 16.6033L21 16.5ZM16.0069 16.3555C16.0796 15.5949 16.7203 15 17.5 15C18.2797 15 18.9204 15.5949 18.9931 16.3555L19 16.5V18.12C19.696 18.3189 20.1774 18.4541 20.4441 18.5256C20.8442 18.6328 21.0816 19.044 20.9744 19.4441C20.8851 19.7775 20.5846 19.998 20.2554 20.0002H14.7446C14.4154 19.998 14.1149 19.7775 14.0256 19.4441C13.9183 19.044 14.1558 18.6328 14.5559 18.5256C14.793 18.462 15.1997 18.3482 15.7759 18.1839L16 18.12V16.5L16.0069 16.3555Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6ed8494c86b7c9dd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17H17V22H7V17ZM19 20V15H5V20H3C2.44772 20 2 19.5523 2 19V9C2 8.44772 2.44772 8 3 8H21C21.5523 8 22 8.44772 22 9V19C22 19.5523 21.5523 20 21 20H19ZM5 10V12H8V10H5ZM7 2H17C17.5523 2 18 2.44772 18 3V6H6V3C6 2.44772 6.44772 2 7 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2fd0e5e66036d985(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2C17.5523 2 18 2.44772 18 3V7H21C21.5523 7 22 7.44772 22 8V18C22 18.5523 21.5523 19 21 19H18V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21V19H3C2.44772 19 2 18.5523 2 18V8C2 7.44772 2.44772 7 3 7H6V3C6 2.44772 6.44772 2 7 2H17ZM16 17H8V20H16V17ZM20 9H4V17H6V16C6 15.4477 6.44772 15 7 15H17C17.5523 15 18 15.4477 18 16V17H20V9ZM8 10V12H5V10H8ZM16 4H8V7H16V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$240a60f724116994(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM6 15V17H18V15H6ZM6 7V13H12V7H6ZM14 7V9H18V7H14ZM14 11V13H18V11H14ZM8 9H10V11H8V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$66eec7ec721daf3f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.0082 3C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082ZM20 5H4V19H20V5ZM18 15V17H6V15H18ZM12 7V13H6V7H12ZM18 11V13H14V11H18ZM10 9H8V11H10V9ZM18 7V9H14V7H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5b4ae0dfb8ccf482(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19V21H20V19H4V21H2V19C1.44772 19 1 18.5523 1 18V6C1 5.44772 1.44772 5 2 5H11.8096C12.9925 3.76733 14.6566 3 16.5 3C18.3434 3 20.0075 3.76733 21.1904 5H22C22.5523 5 23 5.44772 23 6V18C23 18.5523 22.5523 19 22 19ZM16.5 14C18.9853 14 21 11.9853 21 9.5C21 7.01472 18.9853 5 16.5 5C14.0147 5 12 7.01472 12 9.5C12 11.9853 14.0147 14 16.5 14ZM16.5 12C15.1193 12 14 10.8807 14 9.5C14 8.11929 15.1193 7 16.5 7C17.8807 7 19 8.11929 19 9.5C19 10.8807 17.8807 12 16.5 12ZM4 13V15H6V13H4ZM8 13V15H10V13H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8c7bcccc55f92254(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19V21H20V19H4V21H2V19C1.44772 19 1 18.5523 1 18V6C1 5.44772 1.44772 5 2 5H12.5278C13.6264 3.7725 15.223 3 17 3C18.777 3 20.3736 3.7725 21.4722 5H22C22.5523 5 23 5.44772 23 6V18C23 18.5523 22.5523 19 22 19ZM11.3414 7H3V17H21V13.4722C19.9385 14.4223 18.5367 15 17 15C13.6863 15 11 12.3137 11 9C11 8.29873 11.1203 7.62556 11.3414 7ZM17 13C19.2091 13 21 11.2091 21 9C21 6.79086 19.2091 5 17 5C14.7909 5 13 6.79086 13 9C13 11.2091 14.7909 13 17 13ZM5 13H7V15H5V13ZM8 13H10V15H8V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$76e9bef21f2dbe95(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.1115 12C11.5662 14.004 13.3584 15.5 15.5 15.5C17.6416 15.5 19.4338 14.004 19.8885 12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H11.1115ZM5 16H7V18H5V16ZM15.5 13.5C14.1193 13.5 13 12.3807 13 11C13 9.61929 14.1193 8.5 15.5 8.5C16.8807 8.5 18 9.61929 18 11C18 12.3807 16.8807 13.5 15.5 13.5ZM11.1115 10H2V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V10H19.8885C19.4338 7.99601 17.6416 6.5 15.5 6.5C13.3584 6.5 11.5662 7.99601 11.1115 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1ade0c988d8ea429(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM11.126 12H4V19H20V12H18.874C18.4299 13.7252 16.8638 15 15 15C13.1362 15 11.5701 13.7252 11.126 12ZM11.126 10C11.5701 8.27477 13.1362 7 15 7C16.8638 7 18.4299 8.27477 18.874 10H20V5H4V10H11.126ZM15 13C16.1046 13 17 12.1046 17 11C17 9.89543 16.1046 9 15 9C13.8954 9 13 9.89543 13 11C13 12.1046 13.8954 13 15 13ZM6 15H8V17H6V15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a8a135f52ebf1736(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.74284 15H14.2572C13.4718 14.0491 13 12.8296 13 11.5C13 8.46243 15.4624 6 18.5 6C21.5376 6 24 8.46243 24 11.5C24 14.5376 21.5376 17 18.5 17H5.5C2.46243 17 0 14.5376 0 11.5C0 8.46243 2.46243 6 5.5 6C8.53757 6 11 8.46243 11 11.5C11 12.8296 10.5282 14.0491 9.74284 15ZM5.5 13C6.32843 13 7 12.3284 7 11.5C7 10.6716 6.32843 10 5.5 10C4.67157 10 4 10.6716 4 11.5C4 12.3284 4.67157 13 5.5 13ZM18.5 13C19.3284 13 20 12.3284 20 11.5C20 10.6716 19.3284 10 18.5 10C17.6716 10 17 10.6716 17 11.5C17 12.3284 17.6716 13 18.5 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8aa532b3371ed336(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.2572 15C13.4718 14.0491 13 12.8296 13 11.5C13 8.46243 15.4624 6 18.5 6C21.5376 6 24 8.46243 24 11.5C24 14.5376 21.5376 17 18.5 17H5.5C2.46243 17 0 14.5376 0 11.5C0 8.46243 2.46243 6 5.5 6C8.53757 6 11 8.46243 11 11.5C11 12.8296 10.5282 14.0491 9.74284 15H14.2572ZM5.5 15C7.433 15 9 13.433 9 11.5C9 9.567 7.433 8 5.5 8C3.567 8 2 9.567 2 11.5C2 13.433 3.567 15 5.5 15ZM18.5 15C20.433 15 22 13.433 22 11.5C22 9.567 20.433 8 18.5 8C16.567 8 15 9.567 15 11.5C15 13.433 16.567 15 18.5 15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7d23f14a50abebb2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12.5 7H8V17H10V14H12.217L14.397 17H16.869L14.3191 13.4907C15.327 12.8763 16 11.7668 16 10.5C16 8.63144 14.5357 7.10487 12.692 7.00518L12.5 7ZM12.5 9C13.2797 9 13.9204 9.59489 13.9931 10.3555L14 10.5L13.9931 10.6445C13.925 11.3576 13.3576 11.925 12.6445 11.9931L12.5 12H10V9H12.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ab8002e0a5496211(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12.5 7C14.433 7 16 8.567 16 10.5C16 11.7668 15.327 12.8763 14.3191 13.4907L16.869 17H14.397L12.217 14H10V17H8V7H12.5ZM12.5 9H10V12H12.5C13.2797 12 13.9204 11.4051 13.9931 10.6445L14 10.5C14 9.67157 13.3284 9 12.5 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f3d57dc05f7485c1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5V9C19.5228 9 24 13.4772 24 19C24 19.2727 23.9891 19.5428 23.9677 19.81C22.5055 17.0364 19.6381 15.119 16.313 15.0053L16 15H13.9999L14 19.5L6 12L14 4.5ZM8 4.5V7.237L2.92 12L7.999 16.761L8 19.5L0 12L8 4.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$463bcc91fdc69daa(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5V9C19.5228 9 24 13.4772 24 19C24 19.2727 23.9891 19.5428 23.9677 19.81C22.5055 17.0364 19.6381 15.119 16.313 15.0053L16 15H13.9999L14 19.5L6 12L14 4.5ZM8 4.5V7.237L2.92 12L7.999 16.761L8 19.5L0 12L8 4.5ZM12 9.11646L8.92423 12L11.9999 14.8834L11.9999 13L16.0341 13.0003L16.3814 13.0065C17.6657 13.0504 18.9053 13.3165 20.0568 13.7734C18.5898 12.0749 16.4204 11 14 11H12V9.11646Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1577db0ceac28311(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 20L1 12L11 4V9C16.5228 9 21 13.4772 21 19C21 19.2729 20.9891 19.5433 20.9676 19.8107C19.4605 16.9502 16.458 15 13 15H11V20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9c6c138dbe1dfde6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 20L1 12L11 4V9C16.5228 9 21 13.4772 21 19C21 19.2727 20.9891 19.5428 20.9677 19.81C19.5055 17.0364 16.6381 15.119 13.313 15.0053L13 15H10.9999L11 20ZM8.99986 13H10.9999L13.0341 13.0003L13.3814 13.0065C14.6657 13.0504 15.9053 13.3165 17.0568 13.7734C15.5898 12.0749 13.4204 11 11 11H9V8.16125L4.20156 12L8.99992 15.8387L8.99986 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ca2b9395fe787ba1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13.0001H9V11.0001H3V1.8457C3 1.56956 3.22386 1.3457 3.5 1.3457C3.58425 1.3457 3.66714 1.36699 3.74096 1.4076L22.2034 11.562C22.4454 11.695 22.5337 11.9991 22.4006 12.241C22.3549 12.3241 22.2865 12.3925 22.2034 12.4382L3.74096 22.5925C3.499 22.7256 3.19497 22.6374 3.06189 22.3954C3.02129 22.3216 3 22.2387 3 22.1544V13.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a2c158961312fc41(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 1.3457C3.58425 1.3457 3.66714 1.36699 3.74096 1.4076L22.2034 11.562C22.4454 11.695 22.5337 11.9991 22.4006 12.241C22.3549 12.3241 22.2865 12.3925 22.2034 12.4382L3.74096 22.5925C3.499 22.7256 3.19497 22.6374 3.06189 22.3954C3.02129 22.3216 3 22.2387 3 22.1544V1.8457C3 1.56956 3.22386 1.3457 3.5 1.3457ZM5 4.38261V11.0001H10V13.0001H5V19.6175L18.8499 12.0001L5 4.38261Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$24264d295ee279f3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.94631 9.31555C1.42377 9.14137 1.41965 8.86034 1.95706 8.6812L21.0433 2.31913C21.5717 2.14297 21.8748 2.43878 21.7268 2.95706L16.2736 22.0433C16.1226 22.5718 15.8179 22.5901 15.5946 22.0877L12.0002 14.0002L18.0002 6.00017L10.0002 12.0002L1.94631 9.31555Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$19daa85569243204(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.7264 2.95706L16.2732 22.0433C16.1222 22.5718 15.7976 22.5958 15.5561 22.1127L10.9998 13.0002L1.92266 9.36931C1.41298 9.16544 1.41929 8.86034 1.9567 8.6812L21.0429 2.31913C21.5714 2.14297 21.8745 2.43878 21.7264 2.95706ZM19.0351 5.0966L6.81197 9.17097L12.4486 11.4256L15.4893 17.507L19.0351 5.0966Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b4a951a39105b050(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3C4.13401 3 1 6.13401 1 10C1 13.866 4.13401 17 8 17H9.07089C9.02417 16.6734 9 16.3395 9 16C9 15.6605 9.02417 15.3266 9.07089 15H8C5.23858 15 3 12.7614 3 10C3 7.23858 5.23858 5 8 5H16C18.7614 5 21 7.23858 21 10C21 10.3428 20.9655 10.6775 20.8998 11.0008C21.4853 11.5748 21.9704 12.2508 22.3264 13C22.7583 12.0907 23 11.0736 23 10C23 6.13401 19.866 3 16 3H8ZM11 16C11 13.2386 13.2386 11 16 11C18.7614 11 21 13.2386 21 16C21 17.0191 20.6951 17.967 20.1716 18.7574L22.7071 21.2929L21.2929 22.7071L18.7574 20.1716C17.967 20.6951 17.0191 21 16 21C13.2386 21 11 18.7614 11 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3b40b0bb17a1cefe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3C4.13401 3 1 6.13401 1 10C1 13.866 4.13401 17 8 17H9.07089C9.02417 16.6734 9 16.3395 9 16C9 15.6605 9.02417 15.3266 9.07089 15H8C5.23858 15 3 12.7614 3 10C3 7.23858 5.23858 5 8 5H16C18.7614 5 21 7.23858 21 10C21 10.3428 20.9655 10.6775 20.8998 11.0008C21.4853 11.5748 21.9704 12.2508 22.3264 13C22.7583 12.0907 23 11.0736 23 10C23 6.13401 19.866 3 16 3H8ZM16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13ZM11 16C11 13.2386 13.2386 11 16 11C18.7614 11 21 13.2386 21 16C21 17.0191 20.6951 17.967 20.1716 18.7574L22.7071 21.2929L21.2929 22.7071L18.7574 20.1716C17.967 20.6951 17.0191 21 16 21C13.2386 21 11 18.7614 11 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ed9c8b561330fd49(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.1213 10.4796C13.7308 10.0891 13.0976 10.0891 12.7071 10.4796L12 11.1868C11.2189 11.9678 9.95259 11.9678 9.17154 11.1868C8.39049 10.4057 8.39049 9.13937 9.17154 8.35832L14.8022 2.72617C16.9061 2.25022 19.2008 2.83124 20.8388 4.46924C23.2582 6.8886 23.3716 10.7407 21.1792 13.2944L19.071 15.4294L14.1213 10.4796ZM3.16113 4.46924C5.33452 2.29584 8.66411 1.98332 11.17 3.53165L7.75732 6.94411C6.19523 8.50621 6.19523 11.0389 7.75732 12.601C9.27209 14.1157 11.6995 14.1616 13.2695 12.7387L13.4142 12.601L17.6568 16.8436L13.4142 21.0862C12.6331 21.8673 11.3668 21.8673 10.5858 21.0862L3.16113 13.6616C0.622722 11.1232 0.622722 7.00764 3.16113 4.46924Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$573a27ef6227c1f3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.16113 4.46924C5.58508 2.04529 9.44716 1.93599 12.0008 4.14133C14.5528 1.93599 18.4149 2.04529 20.8388 4.46924C23.2584 6.88884 23.3716 10.7414 21.1785 13.2952L13.4142 21.0862C12.6686 21.8318 11.4809 21.8657 10.6952 21.1879L10.5858 21.0862L2.82141 13.2952C0.628282 10.7414 0.741522 6.88884 3.16113 4.46924ZM4.57534 5.88345C2.86819 7.5906 2.81942 10.3281 4.42902 12.0942L4.57534 12.2474L12 19.672L17.3026 14.368L13.7677 10.8332L12.7071 11.8939C11.5355 13.0654 9.636 13.0654 8.46443 11.8939C7.29286 10.7223 7.29286 8.82279 8.46443 7.65122L10.5656 5.54872C8.85292 4.17762 6.37076 4.24042 4.7286 5.73712L4.57534 5.88345ZM13.0606 8.71188C13.4511 8.32135 14.0843 8.32135 14.4748 8.71188L18.7168 12.9538L19.4246 12.2474C21.1819 10.4901 21.1819 7.64081 19.4246 5.88345C17.7174 4.1763 14.9799 4.12752 13.2139 5.73712L13.0606 5.88345L9.87864 9.06543C9.51601 9.42806 9.49011 9.99991 9.80094 10.3924L9.87864 10.4796C10.2413 10.8423 10.8131 10.8682 11.2056 10.5573L11.2929 10.4796L13.0606 8.71188Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fb559c8504b109e3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.2914 5.99994H20.0002C20.5525 5.99994 21.0002 6.44766 21.0002 6.99994V13.9999C21.0002 14.5522 20.5525 14.9999 20.0002 14.9999H18.0002L13.8319 9.16427C13.3345 8.46797 12.4493 8.16522 11.6297 8.41109L9.14444 9.15668C8.43971 9.3681 7.6758 9.17551 7.15553 8.65524L6.86277 8.36247C6.41655 7.91626 6.49011 7.17336 7.01517 6.82332L12.4162 3.22262C13.0752 2.78333 13.9312 2.77422 14.5994 3.1994L18.7546 5.8436C18.915 5.94571 19.1013 5.99994 19.2914 5.99994ZM5.02708 14.2947L3.41132 15.7085C2.93991 16.1209 2.95945 16.8603 3.45201 17.2474L8.59277 21.2865C9.07284 21.6637 9.77592 21.5264 10.0788 20.9963L10.7827 19.7645C11.2127 19.012 11.1091 18.0682 10.5261 17.4269L7.82397 14.4545C7.09091 13.6481 5.84722 13.5771 5.02708 14.2947ZM7.04557 5H3C2.44772 5 2 5.44772 2 6V13.5158C2 13.9242 2.12475 14.3173 2.35019 14.6464C2.3741 14.6238 2.39856 14.6015 2.42357 14.5796L4.03933 13.1658C5.47457 11.91 7.65103 12.0343 8.93388 13.4455L11.6361 16.4179C12.6563 17.5401 12.8376 19.1918 12.0851 20.5087L11.4308 21.6538C11.9937 21.8671 12.635 21.819 13.169 21.4986L17.5782 18.8531C18.0786 18.5528 18.2166 17.8896 17.8776 17.4146L12.6109 10.0361C12.4865 9.86205 12.2652 9.78636 12.0603 9.84783L9.57505 10.5934C8.34176 10.9634 7.00492 10.6264 6.09446 9.7159L5.80169 9.42313C4.68615 8.30759 4.87005 6.45035 6.18271 5.57524L7.04557 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5a7cb7b12194091f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.8611 2.39057C12.8495 1.73163 14.1336 1.71797 15.1358 2.35573L19.291 4.99994H20.9998C21.5521 4.99994 21.9998 5.44766 21.9998 5.99994V14.9999C21.9998 15.5522 21.5521 15.9999 20.9998 15.9999H19.4801C19.5396 16.9472 19.0933 17.9102 18.1955 18.4489L13.1021 21.505C12.4591 21.8907 11.6609 21.8817 11.0314 21.4974C10.3311 22.1167 9.2531 22.1849 8.47104 21.5704L3.33028 17.5312C2.56387 16.9291 2.37006 15.9003 2.76579 15.0847C2.28248 14.7057 2 14.1254 2 13.5109V6C2 5.44772 2.44772 5 3 5H7.94693L11.8611 2.39057ZM4.17264 13.6452L4.86467 13.0397C6.09488 11.9632 7.96042 12.0698 9.06001 13.2794L11.7622 16.2518C12.6317 17.2083 12.7903 18.6135 12.1579 19.739L17.1665 16.7339C17.4479 16.5651 17.5497 16.2276 17.4448 15.9433L13.0177 9.74551C12.769 9.39736 12.3264 9.24598 11.9166 9.36892L9.43135 10.1145C8.37425 10.4316 7.22838 10.1427 6.44799 9.36235L6.15522 9.06958C5.58721 8.50157 5.44032 7.69318 5.67935 7H4V13.5109L4.17264 13.6452ZM14.0621 4.04306C13.728 3.83047 13.3 3.83502 12.9705 4.05467L7.56943 7.65537L7.8622 7.94814C8.12233 8.20827 8.50429 8.30456 8.85666 8.19885L11.3419 7.45327C12.5713 7.08445 13.8992 7.53859 14.6452 8.58303L18.5144 13.9999H19.9998V6.99994H19.291C18.9106 6.99994 18.5381 6.89148 18.2172 6.68727L14.0621 4.04306ZM6.18168 14.5448L4.56593 15.9586L9.70669 19.9978L10.4106 18.7659C10.6256 18.3897 10.5738 17.9178 10.2823 17.5971L7.58013 14.6247C7.2136 14.2215 6.59175 14.186 6.18168 14.5448Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f0878b7b0e98886d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 17V20H18V22H6V20H11V17H4C3.44772 17 3 16.5523 3 16V4H2V2H22V4H21V16C21 16.5523 20.5523 17 20 17H13ZM10 6V13L15 9.5L10 6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e40786cd4cacd7a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 17V20H18V22H6V20H11V17H4C3.44772 17 3 16.5523 3 16V4H2V2H22V4H21V16C21 16.5523 20.5523 17 20 17H13ZM5 15H19V4H5V15ZM10 6L15 9.5L10 13V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a72240db87526549(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18V20H17V22H7V20H11V18H3C2.44772 18 2 17.5523 2 17V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V17C22 17.5523 21.5523 18 21 18H13ZM10 7.5V13.5L15 10.5L10 7.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e228864f31523885(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18V20H17V22H7V20H11V18H3C2.44772 18 2 17.5523 2 17V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V17C22 17.5523 21.5523 18 21 18H13ZM4 5V16H20V5H4ZM10 7.5L15 10.5L10 13.5V7.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$577c4d5d5d5ebdc3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.17071 3C8.58254 1.83481 9.69378 1 11 1H13C14.3062 1 15.4175 1.83481 15.8293 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H8.17071ZM10 9V15L15 12L10 9ZM11 3C10.4477 3 10 3.44772 10 4C10 4.55228 10.4477 5 11 5H13C13.5523 5 14 4.55228 14 4C14 3.44772 13.5523 3 13 3H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f557cb9fba39e627(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.17071 3C8.58254 1.83481 9.69378 1 11 1H13C14.3062 1 15.4175 1.83481 15.8293 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H8.17071ZM4 5V19H20V5H15.8293C15.4175 6.16519 14.3062 7 13 7H11C9.69378 7 8.58254 6.16519 8.17071 5H4ZM11 3C10.4477 3 10 3.44772 10 4C10 4.55228 10.4477 5 11 5H13C13.5523 5 14 4.55228 14 4C14 3.44772 13.5523 3 13 3H11ZM10 9L15 12L10 15V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7e1924e70ec8d25e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 21V23H11V21H3C2.44772 21 2 20.5523 2 20V6H22V20C22 20.5523 21.5523 21 21 21H13ZM8 10C6.34315 10 5 11.3431 5 13C5 14.6569 6.34315 16 8 16C9.65685 16 11 14.6569 11 13H8V10ZM13 10V12H19V10H13ZM13 14V16H19V14H13ZM2 3H22V5H2V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$66ecebf8d2de4562(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 21V23H11V21H3C2.44772 21 2 20.5523 2 20V6H22V20C22 20.5523 21.5523 21 21 21H13ZM4 19H20V8H4V19ZM13 10H18V12H13V10ZM13 14H18V16H13V14ZM9 10V13H12C12 14.6569 10.6569 16 9 16C7.34315 16 6 14.6569 6 13C6 11.3431 7.34315 10 9 10ZM2 3H22V5H2V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$661687e5c51360f6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.0833 10.4998L21.2854 11.2211C21.5221 11.3632 21.5989 11.6703 21.4569 11.9071C21.4146 11.9774 21.3557 12.0363 21.2854 12.0786L11.9999 17.6498L2.71451 12.0786C2.47772 11.9365 2.40093 11.6294 2.54301 11.3926C2.58523 11.3222 2.64413 11.2633 2.71451 11.2211L3.9166 10.4998L11.9999 15.3498L20.0833 10.4998ZM20.0833 15.1998L21.2854 15.9211C21.5221 16.0632 21.5989 16.3703 21.4569 16.6071C21.4146 16.6774 21.3557 16.7363 21.2854 16.7786L12.5144 22.0411C12.1977 22.2311 11.8021 22.2311 11.4854 22.0411L2.71451 16.7786C2.47772 16.6365 2.40093 16.3294 2.54301 16.0926C2.58523 16.0222 2.64413 15.9633 2.71451 15.9211L3.9166 15.1998L11.9999 20.0498L20.0833 15.1998ZM12.5144 1.30852L21.2854 6.57108C21.5221 6.71315 21.5989 7.02028 21.4569 7.25707C21.4146 7.32745 21.3557 7.38635 21.2854 7.42857L11.9999 12.9998L2.71451 7.42857C2.47772 7.2865 2.40093 6.97937 2.54301 6.74258C2.58523 6.6722 2.64413 6.6133 2.71451 6.57108L11.4854 1.30852C11.8021 1.11851 12.1977 1.11851 12.5144 1.30852Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$40e4d6a0412a2ff(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.0833 15.1998L21.2854 15.9211C21.5221 16.0632 21.5989 16.3703 21.4569 16.6071C21.4146 16.6774 21.3557 16.7363 21.2854 16.7786L12.5144 22.0411C12.1977 22.2311 11.8021 22.2311 11.4854 22.0411L2.71451 16.7786C2.47772 16.6365 2.40093 16.3294 2.54301 16.0926C2.58523 16.0222 2.64413 15.9633 2.71451 15.9211L3.9166 15.1998L11.9999 20.0498L20.0833 15.1998ZM20.0833 10.4998L21.2854 11.2211C21.5221 11.3632 21.5989 11.6703 21.4569 11.9071C21.4146 11.9774 21.3557 12.0363 21.2854 12.0786L11.9999 17.6498L2.71451 12.0786C2.47772 11.9365 2.40093 11.6294 2.54301 11.3926C2.58523 11.3222 2.64413 11.2633 2.71451 11.2211L3.9166 10.4998L11.9999 15.3498L20.0833 10.4998ZM12.5144 1.30852L21.2854 6.57108C21.5221 6.71315 21.5989 7.02028 21.4569 7.25707C21.4146 7.32745 21.3557 7.38635 21.2854 7.42857L11.9999 12.9998L2.71451 7.42857C2.47772 7.2865 2.40093 6.97937 2.54301 6.74258C2.58523 6.6722 2.64413 6.6133 2.71451 6.57108L11.4854 1.30852C11.8021 1.11851 12.1977 1.11851 12.5144 1.30852ZM11.9999 3.33221L5.88723 6.99983L11.9999 10.6674L18.1126 6.99983L11.9999 3.33221Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ece777b9c09ad153(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6V8H6V18H4V8H0V6H10ZM12 6H14.5L17.4999 11.196L20.5 6H23V18H21V9.133L17.4999 15.196L14 9.135V18H12V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$75aa4f70a9bb116a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6V8H6V18H4V8H0V6H10ZM12 6H14.5L17.4999 11.196L20.5 6H23V18H21V9.133L17.4999 15.196L14 9.135V18H12V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2549e0e1bf0a5586(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.007 2.10377C8.60544 1.65006 7.08181 2.28116 6.41156 3.59306L5.60578 5.17023C5.51004 5.35763 5.35763 5.51004 5.17023 5.60578L3.59306 6.41156C2.28116 7.08181 1.65006 8.60544 2.10377 10.007L2.64923 11.692C2.71404 11.8922 2.71404 12.1078 2.64923 12.308L2.10377 13.993C1.65006 15.3946 2.28116 16.9182 3.59306 17.5885L5.17023 18.3942C5.35763 18.49 5.51004 18.6424 5.60578 18.8298L6.41156 20.407C7.08181 21.7189 8.60544 22.35 10.007 21.8963L11.692 21.3508C11.8922 21.286 12.1078 21.286 12.308 21.3508L13.993 21.8963C15.3946 22.35 16.9182 21.7189 17.5885 20.407L18.3942 18.8298C18.49 18.6424 18.6424 18.49 18.8298 18.3942L20.407 17.5885C21.7189 16.9182 22.35 15.3946 21.8963 13.993L21.3508 12.308C21.286 12.1078 21.286 11.8922 21.3508 11.692L21.8963 10.007C22.35 8.60544 21.7189 7.08181 20.407 6.41156L18.8298 5.60578C18.6424 5.51004 18.49 5.35763 18.3942 5.17023L17.5885 3.59306C16.9182 2.28116 15.3946 1.65006 13.993 2.10377L12.308 2.64923C12.1078 2.71403 11.8922 2.71404 11.692 2.64923L10.007 2.10377ZM6.75977 11.7573L8.17399 10.343L11.0024 13.1715L16.6593 7.51465L18.0735 8.92886L11.0024 15.9999L6.75977 11.7573Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b3428bf91d584ec2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.007 2.10377C8.60544 1.65006 7.08181 2.28116 6.41156 3.59306L5.60578 5.17023C5.51004 5.35763 5.35763 5.51004 5.17023 5.60578L3.59306 6.41156C2.28116 7.08181 1.65006 8.60544 2.10377 10.007L2.64923 11.692C2.71403 11.8922 2.71403 12.1078 2.64923 12.308L2.10377 13.993C1.65006 15.3946 2.28116 16.9182 3.59306 17.5885L5.17023 18.3942C5.35763 18.49 5.51004 18.6424 5.60578 18.8298L6.41156 20.407C7.08181 21.7189 8.60544 22.35 10.007 21.8963L11.692 21.3508C11.8922 21.286 12.1078 21.286 12.308 21.3508L13.993 21.8963C15.3946 22.35 16.9182 21.7189 17.5885 20.407L18.3942 18.8298C18.49 18.6424 18.6424 18.49 18.8298 18.3942L20.407 17.5885C21.7189 16.9182 22.35 15.3946 21.8963 13.993L21.3508 12.308C21.286 12.1078 21.286 11.8922 21.3508 11.692L21.8963 10.007C22.35 8.60544 21.7189 7.08181 20.407 6.41156L18.8298 5.60578C18.6424 5.51004 18.49 5.35763 18.3942 5.17023L17.5885 3.59306C16.9182 2.28116 15.3946 1.65006 13.993 2.10377L12.308 2.64923C12.1078 2.71403 11.8922 2.71404 11.692 2.64923L10.007 2.10377ZM8.19258 4.50299C8.416 4.06569 8.92388 3.85532 9.39107 4.00656L11.0761 4.55201C11.6767 4.74644 12.3233 4.74644 12.9239 4.55201L14.609 4.00656C15.0761 3.85532 15.584 4.06569 15.8074 4.50298L16.6132 6.08016C16.9004 6.64234 17.3577 7.09958 17.9199 7.3868L19.497 8.19258C19.9343 8.416 20.1447 8.92388 19.9935 9.39107L19.448 11.0761C19.2536 11.6767 19.2536 12.3233 19.448 12.9239L19.9935 14.609C20.1447 15.0761 19.9343 15.584 19.497 15.8074L17.9199 16.6132C17.3577 16.9004 16.9004 17.3577 16.6132 17.9199L15.8074 19.497C15.584 19.9343 15.0761 20.1447 14.609 19.9935L12.9239 19.448C12.3233 19.2536 11.6767 19.2536 11.0761 19.448L9.39107 19.9935C8.92388 20.1447 8.416 19.9343 8.19258 19.497L7.3868 17.9199C7.09958 17.3577 6.64234 16.9004 6.08016 16.6132L4.50299 15.8074C4.06569 15.584 3.85532 15.0761 4.00656 14.609L4.55201 12.9239C4.74644 12.3233 4.74644 11.6767 4.55201 11.0761L4.00656 9.39107C3.85532 8.92388 4.06569 8.416 4.50299 8.19258L6.08016 7.3868C6.64234 7.09958 7.09958 6.64234 7.3868 6.08016L8.19258 4.50299ZM6.7596 11.7574L11.0022 16L18.0733 8.92897L16.6591 7.51476L11.0022 13.1716L8.17382 10.3431L6.7596 11.7574Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ff439614ed6049c9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM20 10H4V19H20V10ZM15 6V8H19V6H15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$579ceb256f839045(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 11H4V19H20V11ZM20 5H4V9H20V5ZM19 6V8H15V6H19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f5456870219f5cc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM20 10H4V19H20V10ZM5 6V8H7V6H5ZM9 6V8H11V6H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$282e479486232304(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 11H4V19H20V11ZM20 5H4V9H20V5ZM11 6V8H9V6H11ZM7 6V8H5V6H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6f806c23508b88e2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H14C18.4183 3 22 6.58172 22 11C22 15.4183 18.4183 19 14 19V22.5C9 20.5 2 17.5 2 11C2 6.58172 5.58172 3 10 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c0822ed6381937e0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H14C18.4183 3 22 6.58172 22 11C22 15.4183 18.4183 19 14 19V22.5C9 20.5 2 17.5 2 11C2 6.58172 5.58172 3 10 3ZM12 17H14C17.3137 17 20 14.3137 20 11C20 7.68629 17.3137 5 14 5H10C6.68629 5 4 7.68629 4 11C4 14.61 6.46208 16.9656 12 19.4798V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6e8136bf825ab0c4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.45 19L12 22.5L9.55 19H3C2.44772 19 2 18.5523 2 18V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H14.45Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$431ea0fb60400efc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.45 19L12 22.5L9.55 19H3C2.73478 19 2.48043 18.8946 2.29289 18.7071C2.10536 18.5196 2 18.2652 2 18V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H14.45ZM13.409 17H20V5H4V17H10.591L12 19.012L13.409 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fad43e5a5981471a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.29117 20.8242L2 22L3.17581 16.7088C2.42544 15.3056 2 13.7025 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.2975 22 8.6944 21.5746 7.29117 20.8242Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a0b8a14aade92d6b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.29117 20.8242L2 22L3.17581 16.7088C2.42544 15.3056 2 13.7025 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.2975 22 8.6944 21.5746 7.29117 20.8242ZM7.58075 18.711L8.23428 19.0605C9.38248 19.6745 10.6655 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 13.3345 4.32549 14.6175 4.93949 15.7657L5.28896 16.4192L4.63416 19.3658L7.58075 18.711Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d75126646ae57a97(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$555e387adf3aae4c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.76282 17H20V5H4V18.3851L5.76282 17ZM6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$24998c48f8cd9ff2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM11.2929 12.1213L8.81802 9.64645L7.40381 11.0607L11.2929 14.9497L16.9497 9.29289L15.5355 7.87868L11.2929 12.1213Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c8a1a68fef792ac(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM5.76282 17H20V5H4V18.3851L5.76282 17ZM11.2929 12.1213L15.5355 7.87868L16.9497 9.29289L11.2929 14.9497L7.40381 11.0607L8.81802 9.64645L11.2929 12.1213Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ff525b67410f8d03(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM13.4142 11L15.8891 8.52513L14.4749 7.11091L12 9.58579L9.52513 7.11091L8.11091 8.52513L10.5858 11L8.11091 13.4749L9.52513 14.8891L12 12.4142L14.4749 14.8891L15.8891 13.4749L13.4142 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3ac75d4dafaf0b53(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM4 18.3851L5.76282 17H20V5H4V18.3851ZM13.4142 11L15.8891 13.4749L14.4749 14.8891L12 12.4142L9.52513 14.8891L8.11091 13.4749L10.5858 11L8.11091 8.52513L9.52513 7.11091L12 9.58579L14.4749 7.11091L15.8891 8.52513L13.4142 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9d0ca910f47f2330(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM13 11V7H11V11H8L12 15L16 11H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$63c3417095cf4ebf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM4 18.3851L5.76282 17H20V5H4V18.3851ZM13 11H16L12 15L8 11H11V7H13V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1776f65ca72a4eb0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.455L2 22.5V4C2 3.44772 2.44772 3 3 3H21ZM17 7H15V15H17V7ZM11 8H9V9.999L7 10V12L9 11.999V14H11V11.999L13 12V10L11 9.999V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$26e7c6c21a4c411a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.455L2 22.5V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V18.385L5.76333 17H20V5ZM17 7V15H15V7H17ZM11 8V9.999L13 10V12L11 11.999V14H9V11.999L7 12V10L9 9.999V8H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$904d8f6e28f6a7c1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM12 10H8V12H12V15L16 11L12 7V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bc55cecb87a1c41d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM4 18.3851L5.76282 17H20V5H4V18.3851ZM12 10V7L16 11L12 15V12H8V10H12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$83e02d553d420f5f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM12.0178 14.6997L15.3765 11.341C16.2552 10.4623 16.2552 9.03769 15.3765 8.15901C14.4978 7.28033 13.0732 7.28033 12.1945 8.15901L12.0178 8.33579L11.841 8.15901C10.9623 7.28033 9.53769 7.28033 8.65901 8.15901C7.78033 9.03769 7.78033 10.4623 8.65901 11.341L12.0178 14.6997Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1cfeab6d3eada265(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM4 18.3851L5.76282 17H20V5H4V18.3851ZM12.0178 14.6997L8.65901 11.341C7.78033 10.4623 7.78033 9.03769 8.65901 8.15901C9.53769 7.28033 10.9623 7.28033 11.841 8.15901L12.0178 8.33579L12.1945 8.15901C13.0732 7.28033 14.4978 7.28033 15.3765 8.15901C16.2552 9.03769 16.2552 10.4623 15.3765 11.341L12.0178 14.6997Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e34e34ff60a8044(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.298 22 8.69525 21.5748 7.29229 20.8248L2 22L3.17629 16.7097C2.42562 15.3063 2 13.7028 2 12C2 6.47715 6.47715 2 12 2ZM13 7H11V14H17V12H13V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ca4a8a7a3db6cac(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.298 22 8.69525 21.5748 7.29229 20.8248L2 22L3.17629 16.7097C2.42562 15.3063 2 13.7028 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 13.3347 4.32563 14.6181 4.93987 15.7664L5.28952 16.4201L4.63445 19.3663L7.58189 18.7118L8.23518 19.061C9.38315 19.6747 10.6659 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM13 7V12H17V14H11V7H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c2108d6dbdccc8d1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM11 10H8V12H11V15H13V12H16V10H13V7H11V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$be994f4ee365ecf0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3V5H4V18.3851L5.76282 17H20V10H22V18C22 18.5523 21.5523 19 21 19H6.45455L2 22.5V4C2 3.44772 2.44772 3 3 3H14ZM19 3V0H21V3H24V5H21V8H19V5H16V3H19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a975b403ac8ab296(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.80777 1.39355L22.6068 21.1925L21.1925 22.6068L17.5846 18.9996L6.45516 19.0002L2.00016 22.5002V4.00016C2.00016 3.83085 2.04223 3.67138 2.11649 3.53162L1.39355 2.80777L2.80777 1.39355ZM21.0002 3.00016C21.5524 3.00016 22.0002 3.44787 22.0002 4.00016V17.7852L7.21416 3.00016H21.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ba105d0c9683908d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.80777 1.39355L22.6068 21.1925L21.1925 22.6068L17.5846 18.9996L6.45516 19.0002L2.00016 22.5002V4.00016C2.00016 3.83085 2.04223 3.67138 2.11649 3.53162L1.39355 2.80777L2.80777 1.39355ZM3.99955 5.41355L4.00016 18.3855L5.76349 17.0002L15.5846 16.9996L3.99955 5.41355ZM21.0002 3.00016C21.5524 3.00016 22.0002 3.44787 22.0002 4.00016V17.7852L20.0002 15.7852V5.00016L9.21316 4.99916L7.21416 3.00016H21.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2fecb146e1049b81(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.455L2 22.5V4C2 3.44772 2.44772 3 3 3H21ZM13 7H11V15H13V7ZM17 9H15V15H17V9ZM9 11H7V15H9V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a1e521d939d23ef1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.455L2 22.5V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V18.385L5.76333 17H20V5ZM13 7V15H11V7H13ZM17 9V15H15V9H17ZM9 11V15H7V11H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$16b02e69f79d3473(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.298 22 8.69525 21.5748 7.29229 20.8248L2 22L3.17629 16.7097C2.42562 15.3063 2 13.7028 2 12C2 6.47715 6.47715 2 12 2ZM12 7C10.4023 7 9 8.34 9 10V11H8V16H16V11H15V10C15 8.34315 13.6569 7 12 7ZM14 13V14H10V13H14ZM12 9C12.4762 9 13 9.49 13 10V11H11V10C11 9.49 11.4872 9 12 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$21b4154bce58783f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.298 22 8.69525 21.5748 7.29229 20.8248L2 22L3.17629 16.7097C2.42562 15.3063 2 13.7028 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 13.3347 4.32563 14.6181 4.93987 15.7664L5.28952 16.4201L4.63445 19.3663L7.58189 18.7118L8.23518 19.061C9.38315 19.6747 10.6659 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 7C13.6569 7 15 8.34315 15 10V11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7ZM14 13H10V14H14V13ZM12 9C11.4477 9 11 9.45 11 10V11H13V10C13 9.44772 12.5523 9 12 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$aa77d5f5eeab67de(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.455L2 22.5V4C2 3.44772 2.44772 3 3 3H21ZM10.5153 7.4116C8.72825 8.18684 7.5 9.75543 7.5 11.5052C7.5 12.5 7.77658 13.1137 8.29171 13.6605C8.61598 14.0048 9.12905 14.25 9.66558 14.25C10.6321 14.25 11.4156 13.4665 11.4156 12.5C11.4156 11.5795 10.7045 10.8389 9.80236 10.7553C9.64107 10.7403 9.47827 10.7431 9.32317 10.7645L9.32344 10.6729C9.32873 10.2322 9.4223 8.9333 10.9616 8.1004L10.5153 7.4116ZM15.5153 7.4116C13.7283 8.18684 12.5 9.75543 12.5 11.5052C12.5 12.5 12.7766 13.1137 13.2917 13.6605C13.616 14.0048 14.1291 14.25 14.6656 14.25C15.6321 14.25 16.4156 13.4665 16.4156 12.5C16.4156 11.5795 15.7045 10.8389 14.8024 10.7553C14.6411 10.7403 14.4783 10.7431 14.3232 10.7645L14.3234 10.6729C14.3287 10.2322 14.4223 8.9333 15.9616 8.1004L15.5153 7.4116Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$529d842631856dd0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.455L2 22.5V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V18.385L5.76333 17H20V5ZM10.5153 7.4116L10.9616 8.1004C9.29402 9.0027 9.32317 10.4519 9.32317 10.7645C9.47827 10.7431 9.64107 10.7403 9.80236 10.7553C10.7045 10.8389 11.4156 11.5795 11.4156 12.5C11.4156 13.4665 10.6321 14.25 9.66558 14.25C9.12905 14.25 8.61598 14.0048 8.29171 13.6605C7.77658 13.1137 7.5 12.5 7.5 11.5052C7.5 9.75543 8.72825 8.18684 10.5153 7.4116ZM15.5153 7.4116L15.9616 8.1004C14.294 9.0027 14.3232 10.4519 14.3232 10.7645C14.4783 10.7431 14.6411 10.7403 14.8024 10.7553C15.7045 10.8389 16.4156 11.5795 16.4156 12.5C16.4156 13.4665 15.6321 14.25 14.6656 14.25C14.1291 14.25 13.616 14.0048 13.2917 13.6605C12.7766 13.1137 12.5 12.5 12.5 11.5052C12.5 9.75543 13.7283 8.18684 15.5153 7.4116Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4f0cba9750c70664(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM8.14499 12.071L7.16987 12.634L8.16987 14.366L9.1459 13.8025C9.64746 14.3133 10.2851 14.69 11 14.874V16H13V14.874C13.7149 14.69 14.3525 14.3133 14.8541 13.8025L15.8301 14.366L16.8301 12.634L15.855 12.071C15.9495 11.7301 16 11.371 16 11C16 10.629 15.9495 10.2699 15.855 9.92901L16.8301 9.36602L15.8301 7.63397L14.8541 8.19748C14.3525 7.68674 13.7149 7.31003 13 7.12602V6H11V7.12602C10.2851 7.31003 9.64746 7.68674 9.1459 8.19748L8.16987 7.63397L7.16987 9.36602L8.14499 9.92901C8.0505 10.2699 8 10.629 8 11C8 11.371 8.0505 11.7301 8.14499 12.071ZM12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7adcbc3177263d5d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12H20V5H4V18.3851L5.76282 17H12V19H6.45455L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V12ZM14.145 19.071C14.0505 18.7301 14 18.371 14 18C14 17.629 14.0505 17.2699 14.145 16.929L13.1699 16.366L14.1699 14.634L15.1459 15.1975C15.6475 14.6867 16.2851 14.31 17 14.126V13H19V14.126C19.7149 14.31 20.3525 14.6867 20.8541 15.1975L21.8301 14.634L22.8301 16.366L21.855 16.929C21.9495 17.2699 22 17.629 22 18C22 18.371 21.9495 18.7301 21.855 19.071L22.8301 19.634L21.8301 21.366L20.8541 20.8025C20.3525 21.3133 19.7149 21.69 19 21.874V23H17V21.874C16.2851 21.69 15.6475 21.3133 15.1459 20.8025L14.1699 21.366L13.1699 19.634L14.145 19.071ZM18 20C19.1046 20 20 19.1046 20 18C20 16.8954 19.1046 16 18 16C16.8954 16 16 16.8954 16 18C16 19.1046 16.8954 20 18 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ca041b7c20e2eacf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.29117 20.8242L2 22L3.17581 16.7088C2.42544 15.3056 2 13.7025 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.2975 22 8.6944 21.5746 7.29117 20.8242ZM7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12H15C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8c50bcd5527a1f35(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.29117 20.8242L2 22L3.17581 16.7088C2.42544 15.3056 2 13.7025 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.2975 22 8.6944 21.5746 7.29117 20.8242ZM7.58075 18.711L8.23428 19.0605C9.38248 19.6745 10.6655 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 13.3345 4.32549 14.6175 4.93949 15.7657L5.28896 16.4192L4.63416 19.3658L7.58075 18.711ZM7 12H9C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12H17C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3f705a1344bfdf51(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22H2L4.92893 19.0711C3.11929 17.2614 2 14.7614 2 12C2 6.47715 6.47715 2 12 2ZM16 13H8C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4523177b561ed15a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22H2L4.92893 19.0711C3.11929 17.2614 2 14.7614 2 12ZM6.82843 20H12C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 14.1524 4.85124 16.1649 6.34315 17.6569L7.75736 19.0711L6.82843 20ZM8 13H16C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1a1f66a4b1163e6c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM7 10C7 12.7614 9.23858 15 12 15C14.7614 15 17 12.7614 17 10H15C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b541389e4ea4d975(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM5.76282 17H20V5H4V18.3851L5.76282 17ZM7 10H9C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10H17C17 12.7614 14.7614 15 12 15C9.23858 15 7 12.7614 7 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$81b80d0e902eb4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM13 11H16L12 7L8 11H11V15H13V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b193e86f29d28192(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM4 18.3851L5.76282 17H20V5H4V18.3851ZM13 11V15H11V11H8L12 7L16 11H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ead0e6a2eaf49452(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.92893 19.0711C3.11929 17.2614 2 14.7614 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22H2L4.92893 19.0711ZM11 6V18H13V6H11ZM7 9V15H9V9H7ZM15 9V15H17V9H15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8301cbc46c393925(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22H2L4.92893 19.0711C3.11929 17.2614 2 14.7614 2 12ZM6.82843 20H12C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 14.1524 4.85124 16.1649 6.34315 17.6569L7.75736 19.0711L6.82843 20ZM11 6H13V18H11V6ZM7 9H9V15H7V9ZM15 9H17V15H15V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$251580b4da0b55f1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.8 19L14 22.5L11.2 19H6C5.44772 19 5 18.5523 5 18V7.10256C5 6.55028 5.44772 6.10256 6 6.10256H22C22.5523 6.10256 23 6.55028 23 7.10256V18C23 18.5523 22.5523 19 22 19H16.8ZM2 2H19V4H3V15H1V3C1 2.44772 1.44772 2 2 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6c2a6b0dba2646ee(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 22.5L11.2 19H6C5.44772 19 5 18.5523 5 18V7.10256C5 6.55028 5.44772 6.10256 6 6.10256H22C22.5523 6.10256 23 6.55028 23 7.10256V18C23 18.5523 22.5523 19 22 19H16.8L14 22.5ZM15.8387 17H21V8.10256H7V17H11.2H12.1613L14 19.2984L15.8387 17ZM2 2H19V4H3V15H1V3C1 2.44772 1.44772 2 2 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$32c65f49397c51bc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.9024 10.5976C21.4442 10.5333 20.976 10.5 20.5 10.5C17.2404 10.5 14.3455 12.0604 12.5212 14.471C12.3501 14.4887 12.1763 14.4978 12 14.4978C10.7188 14.4978 9.55217 14.0172 8.66691 13.2248L7.33309 14.7151C8.41871 15.6868 9.81141 16.3253 11.3466 16.4676C10.8023 17.7016 10.5 19.0662 10.5 20.5C10.5 20.976 10.5333 21.4442 10.5976 21.9024C5.7387 21.2205 2 17.0469 2 12C2 6.47715 6.47715 2 12 2C17.0469 2 21.2205 5.7387 21.9024 10.5976ZM21.8707 12.617C21.4254 12.5401 20.9674 12.5 20.5 12.5C17.7656 12.5 15.3512 13.8709 13.9068 15.9675C13.0194 17.2556 12.5 18.8156 12.5 20.5C12.5 20.9674 12.5401 21.4254 12.617 21.8707L21.8707 12.617ZM8.5 11.5C9.32843 11.5 10 10.8284 10 10C10 9.17157 9.32843 8.5 8.5 8.5C7.67157 8.5 7 9.17157 7 10C7 10.8284 7.67157 11.5 8.5 11.5ZM15.5 11.5C16.3284 11.5 17 10.8284 17 10C17 9.17157 16.3284 8.5 15.5 8.5C14.6716 8.5 14 9.17157 14 10C14 10.8284 14.6716 11.5 15.5 11.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ba39eb3cb5080d84(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5199 19.8634C10.5955 18.6615 10.8833 17.5172 11.3463 16.4676C9.81124 16.3252 8.41864 15.6867 7.33309 14.7151L8.66691 13.2248C9.55217 14.0172 10.7188 14.4978 12 14.4978C12.1763 14.4978 12.3501 14.4887 12.5211 14.471C14.227 12.2169 16.8661 10.7083 19.8634 10.5199C19.1692 6.80877 15.9126 4 12 4C7.58172 4 4 7.58172 4 12C4 15.9126 6.80877 19.1692 10.5199 19.8634ZM19.0233 12.636C15.7891 13.2396 13.2396 15.7891 12.636 19.0233L19.0233 12.636ZM22 12C22 12.1677 21.9959 12.3344 21.9877 12.5L12.5 21.9877C12.3344 21.9959 12.1677 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM10 10C10 10.8284 9.32843 11.5 8.5 11.5C7.67157 11.5 7 10.8284 7 10C7 9.17157 7.67157 8.5 8.5 8.5C9.32843 8.5 10 9.17157 10 10ZM17 10C17 10.8284 16.3284 11.5 15.5 11.5C14.6716 11.5 14 10.8284 14 10C14 9.17157 14.6716 8.5 15.5 8.5C16.3284 8.5 17 9.17157 17 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$517351bbb82c89a9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM11 13V15H13V13H11ZM11 7V12H13V7H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4d347e85d198cddf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM4 18.3851L5.76282 17H20V5H4V18.3851ZM11 13H13V15H11V13ZM11 7H13V12H11V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bed35970be0ec112(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM7 10V12H9V10H7ZM11 10V12H13V10H11ZM15 10V12H17V10H15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$20b4ba05d6cd8714(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM5.76282 17H20V5H4V18.3851L5.76282 17ZM11 10H13V12H11V10ZM7 10H9V12H7V10ZM15 10H17V12H15V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ac28e1a8a05601fb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8.99374C2 5.68349 4.67654 3 8.00066 3H15.9993C19.3134 3 22 5.69478 22 8.99374V21H8.00066C4.68659 21 2 18.3052 2 15.0063V8.99374ZM14 11V13H16V11H14ZM8 11V13H10V11H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$491b10d2a75e753d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8.99374C2 5.68349 4.67654 3 8.00066 3H15.9993C19.3134 3 22 5.69478 22 8.99374V21H8.00066C4.68659 21 2 18.3052 2 15.0063V8.99374ZM20 19V8.99374C20 6.79539 18.2049 5 15.9993 5H8.00066C5.78458 5 4 6.78458 4 8.99374V15.0063C4 17.2046 5.79512 19 8.00066 19H20ZM14 11H16V13H14V11ZM8 11H10V13H8V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4fdb41ac0f34beef(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM8 10V12H16V10H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f4e6bc922e7a163a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM5.76282 17H20V5H4V18.3851L5.76282 17ZM8 10H16V12H8V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6cdad70e514596fd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18H18.2372L20 19.3851V9H21C21.5523 9 22 9.44772 22 10V23.5L17.5455 20H9C8.44772 20 8 19.5523 8 19V18ZM5.45455 16L1 19.5V4C1 3.44772 1.44772 3 2 3H17C17.5523 3 18 3.44772 18 4V16H5.45455Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$650ac60b0403cf26(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.45455 15L1 18.5V3C1 2.44772 1.44772 2 2 2H17C17.5523 2 18 2.44772 18 3V15H5.45455ZM4.76282 13H16V4H3V14.3851L4.76282 13ZM8 17H18.2372L20 18.3851V8H21C21.5523 8 22 8.44772 22 9V22.5L17.5455 19H9C8.44772 19 8 18.5523 8 18V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6638810dbd4c6cb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM11 14V16H13V14H11ZM8.56731 8.81346L10.5288 9.20577C10.6656 8.51823 11.2723 8 12 8C12.8284 8 13.5 8.67157 13.5 9.5C13.5 10.3284 12.8284 11 12 11H11V13H12C13.933 13 15.5 11.433 15.5 9.5C15.5 7.567 13.933 6 12 6C10.302 6 8.88637 7.20919 8.56731 8.81346Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d10b5aa96acd35d7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.76282 17H20V5H4V18.3851L5.76282 17ZM6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM11 14H13V16H11V14ZM8.56731 8.81346C8.88637 7.20919 10.302 6 12 6C13.933 6 15.5 7.567 15.5 9.5C15.5 11.433 13.933 13 12 13H11V11H12C12.8284 11 13.5 10.3284 13.5 9.5C13.5 8.67157 12.8284 8 12 8C11.2723 8 10.6656 8.51823 10.5288 9.20577L8.56731 8.81346Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d76451706cb542cd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2C13.0675 2 16.426 5.03562 16.9337 8.96494L19.1842 12.5037C19.3324 12.7367 19.3025 13.0847 18.9593 13.2317L17 14.071V17C17 18.1046 16.1046 19 15 19H13.001L13 22H4L4.00025 18.3061C4.00033 17.1252 3.56351 16.0087 2.7555 15.0011 1.65707 13.6313 1 11.8924 1 10 1 5.58172 4.58172 2 9 2ZM21.1535 18.1024 19.4893 16.9929C20.4436 15.5642 21 13.8471 21 12.0001 21 10.153 20.4436 8.4359 19.4893 7.00722L21.1535 5.89771C22.32 7.64386 23 9.74254 23 12.0001 23 14.2576 22.32 16.3562 21.1535 18.1024Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1e01f1b95609714c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9337 8.96494C16.426 5.03562 13.0675 2 9 2 4.58172 2 1 5.58172 1 10 1 11.8924 1.65707 13.6313 2.7555 15.0011 3.56351 16.0087 4.00033 17.1252 4.00025 18.3061L4 22H13L13.001 19H15C16.1046 19 17 18.1046 17 17V14.071L18.9593 13.2317C19.3025 13.0847 19.3324 12.7367 19.1842 12.5037L16.9337 8.96494ZM3 10C3 6.68629 5.68629 4 9 4 12.0243 4 14.5665 6.25141 14.9501 9.22118L15.0072 9.66262 16.5497 12.0881 15 12.7519V17H11.0017L11.0007 20H6.00013L6.00025 18.3063C6.00036 16.6672 5.40965 15.114 4.31578 13.7499 3.46818 12.6929 3 11.3849 3 10ZM21.1535 18.1024 19.4893 16.9929C20.4436 15.5642 21 13.8471 21 12.0001 21 10.153 20.4436 8.4359 19.4893 7.00722L21.1535 5.89771C22.32 7.64386 23 9.74254 23 12.0001 23 14.2576 22.32 16.3562 21.1535 18.1024Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d5117a535a010b4f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM14 10.25V8H7V14H14V11.75L17 14V8L14 10.25Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$117a4f6c6d797e7c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10.25L17 8V14L14 11.75V14H7V8H14V10.25ZM5.76282 17H20V5H4V18.3851L5.76282 17ZM6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$12a7ee72f1623908(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4H16C18.7614 4 21 6.23858 21 9V13H19V9C19 7.34315 17.6569 6 16 6H14V9L9 5L14 1V4ZM15 11V21C15 21.5523 14.5523 22 14 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H14C14.5523 10 15 10.4477 15 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4f5002066e846a82(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.4142 5.99996L15.2426 7.82839L13.8284 9.24261L9.58579 4.99996L13.8284 0.757324L15.2426 2.17154L13.4142 3.99996H16C18.7614 3.99996 21 6.23854 21 8.99996V13H19V8.99996C19 7.34311 17.6569 5.99996 16 5.99996H13.4142ZM15 11V21C15 21.5522 14.5523 22 14 22H4C3.44772 22 3 21.5522 3 21V11C3 10.4477 3.44772 9.99996 4 9.99996H14C14.5523 9.99996 15 10.4477 15 11ZM13 12H5V20H13V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f07a86a61e8b420(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10H9L5 15L1 10H4V8C4 5.23858 6.23858 3 9 3H13V5H9C7.34315 5 6 6.34315 6 8V10ZM11 9H21C21.5523 9 22 9.44772 22 10V20C22 20.5523 21.5523 21 21 21H11C10.4477 21 10 20.5523 10 20V10C10 9.44772 10.4477 9 11 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$939cd23226418aca(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.0005 9H21.0005C21.5527 9 22.0005 9.44772 22.0005 10V20C22.0005 20.5523 21.5527 21 21.0005 21H11.0005C10.4482 21 10.0005 20.5523 10.0005 20V10C10.0005 9.44772 10.4482 9 11.0005 9ZM12.0005 11V19H20.0005V11H12.0005ZM6.00045 10.5858L7.82888 8.75736L9.24309 10.1716L5.00045 14.4142L0.757812 10.1716L2.17203 8.75736L4.00045 10.5858V8C4.00045 5.23858 6.23903 3 9.00045 3H13.0005V5H9.00045C7.3436 5 6.00045 6.34315 6.00045 8V10.5858Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$777df15a0fa46d59(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6H18V18H6V6ZM6 2H8V5H6V2ZM6 19H8V22H6V19ZM2 6H5V8H2V6ZM2 16H5V18H2V16ZM19 6H22V8H19V6ZM19 16H22V18H19V16ZM16 2H18V5H16V2ZM16 19H18V22H16V19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$122f61081ff9af55(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8V16H16V8H8ZM6 6H18V18H6V6ZM6 2H8V5H6V2ZM6 19H8V22H6V19ZM2 6H5V8H2V6ZM2 16H5V18H2V16ZM19 6H22V8H19V6ZM19 16H22V18H19V16ZM16 2H18V5H16V2ZM16 19H18V22H16V19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c5d2b4b429809ce1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.58579 17H3V15H21V17H15.4142L18.6569 20.2426L17.2426 21.6569L13 17.4142V20H11V17.4142L6.75736 21.6569L5.34315 20.2426L8.58579 17ZM5 3H19C19.5523 3 20 3.44772 20 4V14H4V4C4 3.44772 4.44772 3 5 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8c2be89b08423269(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.58579 17H3V15H21V17H15.4142L18.6569 20.2426L17.2426 21.6569L13 17.4142V20H11V17.4142L6.75736 21.6569L5.34315 20.2426L8.58579 17ZM5 3H19C19.5523 3 20 3.44772 20 4V14H4V4C4 3.44772 4.44772 3 5 3ZM6 5V12H18V5H6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4823139070128fe1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.8492 11.8051L17.1421 11.098L7.24264 20.9975H3V16.7549L14.3137 5.44114L19.9706 11.098C20.3611 11.4885 20.3611 12.1217 19.9706 12.5122L12.8995 19.5833L11.4853 18.1691L17.8492 11.8051ZM18.5563 2.61272L21.3848 5.44114C21.7753 5.83167 21.7753 6.46483 21.3848 6.85536L19.9706 8.26957L15.7279 4.02693L17.1421 2.61272C17.5327 2.22219 18.1658 2.22219 18.5563 2.61272Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$627753903c615b5e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.8492 11.6982L17.1421 10.9911L7.24264 20.8906H3V16.6479L14.3137 5.33421L19.9706 10.9911C20.3611 11.3816 20.3611 12.0148 19.9706 12.4053L12.8995 19.4763L11.4853 18.0621L17.8492 11.6982ZM15.7279 9.57685L14.3137 8.16264L5 17.4763V18.8906H6.41421L15.7279 9.57685ZM18.5563 2.50578L21.3848 5.33421C21.7753 5.72474 21.7753 6.3579 21.3848 6.74842L19.9706 8.16264L15.7279 3.92L17.1421 2.50578C17.5327 2.11526 18.1658 2.11526 18.5563 2.50578Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4463a93368a7c55(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.43239 6.84342L1.39355 2.80458L2.80777 1.39036L22.6068 21.1894L21.1925 22.6036L18.1537 19.5647C14.6255 22.8743 9.08161 22.8063 5.6362 19.3609C2.19078 15.9155 2.12284 10.3716 5.43239 6.84342ZM8.2433 4.0259L12.0002 0.269043L18.3641 6.633C20.9499 9.21876 21.6333 12.9865 20.4144 16.197L8.2433 4.0259Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7843b7292b597890(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.1537 19.5647C14.6255 22.8743 9.08161 22.8063 5.6362 19.3609C2.19078 15.9155 2.12284 10.3716 5.43239 6.84342L1.39355 2.80458L2.80777 1.39036L22.6068 21.1894L21.1925 22.6036L18.1537 19.5647ZM6.84756 8.25858C4.3185 11.0048 4.38612 15.2824 7.05041 17.9467C9.7147 20.611 13.9924 20.6786 16.7385 18.1496L6.84756 8.25858ZM20.4144 16.197L18.8156 14.5982C19.3488 12.3189 18.7269 9.82419 16.9499 8.04722L12.0002 3.09747L9.65751 5.44012L8.2433 4.0259L12.0002 0.269043L18.3641 6.633C20.9499 9.21876 21.6333 12.9865 20.4144 16.197Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fb0e33e2e073323f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5357 15.9466L18.657 13.8253L15.475 10.6433L19.0106 7.1078L16.8892 4.98648L13.3537 8.52201L10.1717 5.34003L8.05041 7.46135L16.5357 15.9466ZM13.3537 5.69359L16.1821 2.86516C16.5727 2.47463 17.2058 2.47463 17.5963 2.86516L21.1319 6.40069C21.5224 6.79122 21.5224 7.42438 21.1319 7.81491L18.3035 10.6433L20.7783 13.1182C21.1689 13.5087 21.1689 14.1419 20.7783 14.5324L13.0002 22.3106C12.6096 22.7011 11.9765 22.7011 11.5859 22.3106L1.68645 12.4111C1.29592 12.0206 1.29592 11.3874 1.68645 10.9969L9.46462 3.21871C9.85515 2.82819 10.4883 2.82819 10.8788 3.21871L13.3537 5.69359Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$714c074e0d2befbe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5357 15.9466L18.657 13.8253L15.475 10.6433L19.0106 7.1078L16.8892 4.98648L13.3537 8.52201L10.1717 5.34003L8.05041 7.46135L16.5357 15.9466ZM15.1215 17.3608L6.6362 8.87557L3.80777 11.704L12.293 20.1893L15.1215 17.3608ZM13.3537 5.69359L16.1821 2.86516C16.5727 2.47463 17.2058 2.47463 17.5963 2.86516L21.1319 6.40069C21.5224 6.79122 21.5224 7.42438 21.1319 7.81491L18.3035 10.6433L20.7783 13.1182C21.1689 13.5087 21.1689 14.1419 20.7783 14.5324L13.0002 22.3106C12.6096 22.7011 11.9765 22.7011 11.5859 22.3106L1.68645 12.4111C1.29592 12.0206 1.29592 11.3874 1.68645 10.9969L9.46462 3.21871C9.85515 2.82819 10.4883 2.82819 10.8788 3.21871L13.3537 5.69359Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8d21714fec125517(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10.9966V7.99658H14V3.99658H10V7.99658H4V10.9966H20ZM21 12.9966V20.9966C21 21.5489 20.5523 21.9966 20 21.9966H10V15.9966H8V21.9966H4C3.44772 21.9966 3 21.5489 3 20.9966V12.9966H2V6.99658C2 6.4443 2.44772 5.99658 3 5.99658H8V2.99658C8 2.4443 8.44772 1.99658 9 1.99658H15C15.5523 1.99658 16 2.4443 16 2.99658V5.99658H21C21.5523 5.99658 22 6.4443 22 6.99658V12.9966H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c7fb4af14aee131f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19.9966V14.9966H10V19.9966H19V12.9966H5V19.9966H8ZM4 10.9966H20V7.99658H14V3.99658H10V7.99658H4V10.9966ZM3 20.9966V12.9966H2V6.99658C2 6.4443 2.44772 5.99658 3 5.99658H8V2.99658C8 2.4443 8.44772 1.99658 9 1.99658H15C15.5523 1.99658 16 2.4443 16 2.99658V5.99658H21C21.5523 5.99658 22 6.4443 22 6.99658V12.9966H21V20.9966C21 21.5489 20.5523 21.9966 20 21.9966H4C3.44772 21.9966 3 21.5489 3 20.9966Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$13e9a524ff2f6d9f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.9966H4V17.9966H20V15.9966ZM3 13.9966V3.99658C3 3.4443 3.44772 2.99658 4 2.99658H7V11.2693H9V2.99658H20C20.5523 2.99658 21 3.4443 21 3.99658V13.9966H22V18.9966C22 19.5489 21.5523 19.9966 21 19.9966H13V22.9966H11V19.9966H3C2.44772 19.9966 2 19.5489 2 18.9966V13.9966H3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$66a0e830dea8be16(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4.99658V11.2693H7V4.99658H5V13.9966H19V4.99658H9ZM20 15.9966H4V17.9966H20V15.9966ZM3 13.9966V3.99658C3 3.4443 3.44772 2.99658 4 2.99658H20C20.5523 2.99658 21 3.4443 21 3.99658V13.9966H22V18.9966C22 19.5489 21.5523 19.9966 21 19.9966H13V22.9966H11V19.9966H3C2.44772 19.9966 2 19.5489 2 18.9966V13.9966H3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b6b70812ef3d8edf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.2886 6.21289L18.2278 2.3713C18.6259 2.06168 19.1922 2.09694 19.5488 2.45355L22.543 5.44774C22.8997 5.80435 22.9349 6.3707 22.6253 6.76879L18.7847 11.7067C19.0778 12.895 19.0836 14.1719 18.7444 15.4377C17.8463 18.7896 14.8142 20.9984 11.5016 20.9984C8 20.9984 3.5 19.4966 1 17.9966C4.97978 14.9966 4.04722 13.1864 4.5 11.4966C5.55843 7.54646 9.34224 5.23923 13.2886 6.21289ZM16.7015 8.09149C16.7673 8.15494 16.8319 8.21952 16.8952 8.2852L18.0297 9.41972L20.5046 6.23774L18.7589 4.49198L15.5769 6.96685L16.7015 8.09149Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$59e9bbd2af55cc7f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.4565 9.67491L15.3144 9.53285C14.6661 8.90783 13.8549 8.43357 12.9235 8.18399C10.0168 7.40515 7.22541 9.05261 6.43185 12.0142C6.38901 12.1741 6.36574 12.3536 6.3285 12.805C6.17423 14.675 5.73449 16.0696 4.5286 17.4841C6.78847 18.3726 9.46572 18.9984 11.5016 18.9984C13.9702 18.9984 16.1644 17.3393 16.8126 14.9201C17.3306 12.9868 16.7513 11.018 15.4565 9.67491ZM13.2886 6.21289L18.2278 2.3713C18.6259 2.06168 19.1922 2.09694 19.5488 2.45355L22.543 5.44774C22.8997 5.80435 22.9349 6.3707 22.6253 6.76879L18.7847 11.7067C19.0778 12.895 19.0836 14.1719 18.7444 15.4377C17.8463 18.7896 14.8142 20.9984 11.5016 20.9984C8 20.9984 3.5 19.4966 1 17.9966C4.97978 14.9966 4.04722 13.1864 4.5 11.4966C5.55843 7.54646 9.34224 5.23923 13.2886 6.21289ZM16.7015 8.09149C16.7673 8.15494 16.8319 8.21952 16.8952 8.2852L18.0297 9.41972L20.5046 6.23774L18.7589 4.49198L15.5769 6.96685L16.7015 8.09149Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9915967dc79df0fe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5b6a4bd3ca023bb1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$77270e23336dfd98(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4V1L15 5L10 9V6H8C6.34315 6 5 7.34315 5 9V13H3V9C3 6.23858 5.23858 4 8 4H10ZM9 11C9 10.4477 9.44772 10 10 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H10C9.44772 22 9 21.5523 9 21V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a8e71c581eb32941(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5858 3.99997L8.75736 2.17154L10.1716 0.757324L14.4142 4.99997L10.1716 9.24261L8.75736 7.82839L10.5858 5.99997H8C6.34315 5.99997 5 7.34311 5 8.99997V13H3V8.99997C3 6.23854 5.23858 3.99997 8 3.99997H10.5858ZM9 11C9 10.4477 9.44772 9.99997 10 9.99997H20C20.5523 9.99997 21 10.4477 21 11V21C21 21.5522 20.5523 22 20 22H10C9.44772 22 9 21.5522 9 21V11ZM11 12V20H19V12H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c0fc213673c7e8ea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10H23L19 15L15 10H18V8C18 6.34315 16.6569 5 15 5H11V3H15C17.7614 3 20 5.23858 20 8V10ZM13 9C13.5523 9 14 9.44772 14 10V20C14 20.5523 13.5523 21 13 21H3C2.44772 21 2 20.5523 2 20V10C2 9.44772 2.44772 9 3 9H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b2f50120802d4a79(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10.5858L21.8284 8.75736L23.2426 10.1716L19 14.4142L14.7574 10.1716L16.1716 8.75736L18 10.5858V8C18 6.34315 16.6569 5 15 5H11V3H15C17.7614 3 20 5.23858 20 8V10.5858ZM13 9C13.5523 9 14 9.44772 14 10V20C14 20.5523 13.5523 21 13 21H3C2.44772 21 2 20.5523 2 20V10C2 9.44772 2.44772 9 3 9H13ZM12 11H4V19H12V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e17ec18d4a06995d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.1894 13.2637L12.572 21.1055L4.00073 21.1062C3.44844 21.1062 3.00073 20.6585 3.00073 20.1062L3 14.7085L11.1894 13.2637ZM20.0007 3.10619C20.553 3.10619 21.0007 3.55391 21.0007 4.10619V20.1062C21.0007 20.6585 20.553 21.1062 20.0007 21.1062L14.603 21.1055L11.429 3.10547L20.0007 3.10619ZM9.398 3.10547L10.8421 11.2941L3 12.6775L3.00073 4.10619C3.00073 3.55391 3.44844 3.10619 4.00073 3.10619L9.398 3.10547Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$69b6576b0dd53b64(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3.10645C20.5523 3.10645 21 3.55416 21 4.10645V20.1064C21 20.6587 20.5523 21.1064 20 21.1064H4C3.44772 21.1064 3 20.6587 3 20.1064V4.10645C3 3.55416 3.44772 3.10645 4 3.10645H20ZM11.1888 13.2649L5 14.3554V19.1064H12.218L11.1888 13.2649ZM19 5.10645H11.781L14.249 19.1064H19V5.10645ZM9.75 5.10645H5V12.3244L10.8415 11.2953L9.75 5.10645Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fe8629222feb0b63(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.3298 13.4968C17.9557 12.215 18.9995 10.2277 18.9995 7.99658H20.9995C20.9995 10.9686 19.559 13.6041 17.338 15.2431L19.8656 19.6209C20.4179 20.5775 20.0901 21.8007 19.1335 22.353L15.6068 16.2445C14.5025 16.7282 13.2823 16.9966 11.9995 16.9966C10.7167 16.9966 9.49663 16.7282 8.39229 16.2445L4.86557 22.353C3.90898 21.8007 3.58123 20.5775 4.13352 19.6209L9.19702 10.8507C8.45796 10.1249 7.99954 9.11427 7.99954 7.99658C7.99954 6.13274 9.27432 4.56664 10.9995 4.1226V1.99658H12.9995V4.1226C14.7248 4.56664 15.9995 6.13274 15.9995 7.99658C15.9995 9.11427 15.5411 10.1249 14.8021 10.8507L16.3298 13.4968ZM14.5986 14.4982L13.0705 11.8516C12.7297 11.9461 12.3705 11.9966 11.9995 11.9966C11.6286 11.9966 11.2694 11.9461 10.9286 11.8516L9.40053 14.4982C10.2041 14.8197 11.0812 14.9966 11.9995 14.9966C12.9179 14.9966 13.795 14.8197 14.5986 14.4982ZM11.9995 8.99658C12.5518 8.99658 12.9995 8.54887 12.9995 7.99658C12.9995 7.4443 12.5518 6.99658 11.9995 6.99658C11.4473 6.99658 10.9995 7.4443 10.9995 7.99658C10.9995 8.54887 11.4473 8.99658 11.9995 8.99658Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d160d3f61fc44942(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.3298 13.4968C17.9557 12.215 18.9995 10.2277 18.9995 7.99658H20.9995C20.9995 10.9686 19.559 13.6041 17.338 15.2431L19.8656 19.6209C20.4179 20.5775 20.0901 21.8007 19.1335 22.353L15.6068 16.2445C14.5025 16.7282 13.2823 16.9966 11.9995 16.9966C10.7167 16.9966 9.49663 16.7282 8.39229 16.2445L4.86557 22.353C3.90898 21.8007 3.58123 20.5775 4.13352 19.6209L9.19702 10.8507C8.45796 10.1249 7.99954 9.11427 7.99954 7.99658C7.99954 6.13274 9.27432 4.56664 10.9995 4.1226V1.99658H12.9995V4.1226C14.7248 4.56664 15.9995 6.13274 15.9995 7.99658C15.9995 9.11427 15.5411 10.1249 14.8021 10.8507L16.3298 13.4968ZM14.5986 14.4982L13.0705 11.8516C12.7297 11.9461 12.3705 11.9966 11.9995 11.9966C11.6286 11.9966 11.2694 11.9461 10.9286 11.8516L9.40053 14.4982C10.2041 14.8197 11.0812 14.9966 11.9995 14.9966C12.9179 14.9966 13.795 14.8197 14.5986 14.4982ZM11.9995 9.99658C13.1041 9.99658 13.9995 9.10115 13.9995 7.99658C13.9995 6.89201 13.1041 5.99658 11.9995 5.99658C10.895 5.99658 9.99954 6.89201 9.99954 7.99658C9.99954 9.10115 10.895 9.99658 11.9995 9.99658Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b645c1a358b9cbe3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9998 4.1226V1.99658H12.9998V4.1226C14.725 4.56664 15.9998 6.13274 15.9998 7.99658C15.9998 9.11427 15.5414 10.1249 14.8023 10.8507L20.8658 21.353L19.1338 22.353L13.0708 11.8516C12.7299 11.9461 12.3708 11.9966 11.9998 11.9966C11.6289 11.9966 11.2697 11.9461 10.9288 11.8516L4.86584 22.353L3.13379 21.353L9.1973 10.8507C8.45823 10.1249 7.99981 9.11427 7.99981 7.99658C7.99981 6.13274 9.27459 4.56664 10.9998 4.1226ZM11.9998 8.99658C12.5521 8.99658 12.9998 8.54887 12.9998 7.99658C12.9998 7.4443 12.5521 6.99658 11.9998 6.99658C11.4475 6.99658 10.9998 7.4443 10.9998 7.99658C10.9998 8.54887 11.4475 8.99658 11.9998 8.99658Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$da6cab4bd5ab7435(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9998 4.1226V1.99658H12.9998V4.1226C14.725 4.56664 15.9998 6.13274 15.9998 7.99658C15.9998 9.11427 15.5414 10.1249 14.8023 10.8507L20.8658 21.353L19.1338 22.353L13.0708 11.8516C12.7299 11.9461 12.3708 11.9966 11.9998 11.9966C11.6289 11.9966 11.2697 11.9461 10.9288 11.8516L4.86584 22.353L3.13379 21.353L9.1973 10.8507C8.45823 10.1249 7.99981 9.11427 7.99981 7.99658C7.99981 6.13274 9.27459 4.56664 10.9998 4.1226ZM11.9998 9.99658C13.1044 9.99658 13.9998 9.10115 13.9998 7.99658C13.9998 6.89201 13.1044 5.99658 11.9998 5.99658C10.8952 5.99658 9.99981 6.89201 9.99981 7.99658C9.99981 9.10115 10.8952 9.99658 11.9998 9.99658Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$468defbb2b957d23(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21.9966C6.47715 21.9966 2 17.5194 2 11.9966C2 6.47373 6.47715 1.99658 12 1.99658C17.5228 1.99658 22 6.47373 22 11.9966C22 17.5194 17.5228 21.9966 12 21.9966ZM5.32889 16.4219C6.76378 18.5674 9.20868 19.9801 11.9836 19.9801C16.4018 19.9801 19.9836 16.3984 19.9836 11.9801C19.9836 9.20518 18.5707 6.76021 16.4251 5.32535C17.2705 8.35312 16.5025 11.7367 14.1213 14.118C11.7401 16.4992 8.3566 17.2671 5.32889 16.4219Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ec3bba8b1fe6edb7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21.9966C6.47715 21.9966 2 17.5194 2 11.9966C2 6.47373 6.47715 1.99658 12 1.99658C17.5228 1.99658 22 6.47373 22 11.9966C22 17.5194 17.5228 21.9966 12 21.9966ZM12 19.9966C16.4183 19.9966 20 16.4149 20 11.9966C20 7.5783 16.4183 3.99658 12 3.99658C7.58172 3.99658 4 7.5783 4 11.9966C4 16.4149 7.58172 19.9966 12 19.9966ZM7.00035 15.3158C9.07995 15.1645 11.117 14.2938 12.7071 12.7037C14.2972 11.1136 15.1679 9.07654 15.3193 6.99694C15.6454 7.21396 15.955 7.46629 16.2426 7.75394C18.5858 10.0971 18.5858 13.8961 16.2426 16.2392C13.8995 18.5824 10.1005 18.5824 7.75736 16.2392C7.46971 15.9516 7.21738 15.642 7.00035 15.3158Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d0945192950b1ad2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.63604 6.633L12 0.269043L18.364 6.633C21.8787 10.1477 21.8787 15.8462 18.364 19.3609C14.8492 22.8756 9.15076 22.8756 5.63604 19.3609C2.12132 15.8462 2.12132 10.1477 5.63604 6.633H5.63604ZM12 3.09747L7.05025 8.04722C5.7835 9.31397 5 11.064 5 12.997H19C19 11.064 18.2165 9.31397 16.9497 8.04722L12 3.09747Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$45de9a74d2408533(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3.09747L7.05025 8.04722C4.31658 10.7809 4.31658 15.213 7.05025 17.9467C9.78392 20.6804 14.2161 20.6804 16.9497 17.9467C19.6834 15.213 19.6834 10.7809 16.9497 8.04722L12 3.09747ZM12 0.269043L18.364 6.633C21.8787 10.1477 21.8787 15.8462 18.364 19.3609C14.8492 22.8756 9.15076 22.8756 5.63604 19.3609C2.12132 15.8462 2.12132 10.1477 5.63604 6.633L12 0.269043ZM7 12.997H17C17 15.7584 14.7614 17.997 12 17.997C9.23858 17.997 7 15.7584 7 12.997Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f6d1a5d59831eef3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0.269043L18.364 6.633C21.8787 10.1477 21.8787 15.8462 18.364 19.3609C14.8492 22.8756 9.15076 22.8756 5.63604 19.3609C2.12132 15.8462 2.12132 10.1477 5.63604 6.633L12 0.269043ZM12 3.09747L7.05025 8.04722C4.31658 10.7809 4.31658 15.213 7.05025 17.9467C8.41814 19.3146 10.2113 19.998 12.0042 19.997L12 3.09747Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d035379e546ffda0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3.09747L7.05025 8.04722C4.31658 10.7809 4.31658 15.213 7.05025 17.9467C9.78392 20.6804 14.2161 20.6804 16.9497 17.9467C19.6834 15.213 19.6834 10.7809 16.9497 8.04722L12 3.09747ZM12 0.269043L18.364 6.633C21.8787 10.1477 21.8787 15.8462 18.364 19.3609C14.8492 22.8756 9.15076 22.8756 5.63604 19.3609C2.12132 15.8462 2.12132 10.1477 5.63604 6.633L12 0.269043ZM12 17.997V7.99696C14.7614 7.99696 17 10.2355 17 12.997C17 15.7584 14.7614 17.997 12 17.997Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7213aa255a1cc09c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21.9966C6.47715 21.9966 2 17.5194 2 11.9966C2 6.47373 6.47715 1.99658 12 1.99658C17.5228 1.99658 22 6.47373 22 11.9966C22 17.5194 17.5228 21.9966 12 21.9966ZM12 19.9966V3.99658C7.58172 3.99658 4 7.5783 4 11.9966C4 16.4149 7.58172 19.9966 12 19.9966Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ca3c24a3f637dd6b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21.9966C6.47715 21.9966 2 17.5194 2 11.9966C2 6.47373 6.47715 1.99658 12 1.99658C17.5228 1.99658 22 6.47373 22 11.9966C22 17.5194 17.5228 21.9966 12 21.9966ZM12 19.9966C16.4183 19.9966 20 16.4149 20 11.9966C20 7.5783 16.4183 3.99658 12 3.99658C7.58172 3.99658 4 7.5783 4 11.9966C4 16.4149 7.58172 19.9966 12 19.9966ZM12 17.9966V5.99658C15.3137 5.99658 18 8.68287 18 11.9966C18 15.3103 15.3137 17.9966 12 17.9966Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e08af3fe57ddedc8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5858 5L20.1421 2.44365L21.5563 3.85786L19 6.41421V17H22V19H19V22H17V7H9V5H17.5858ZM15 17V19H6C5.44772 19 5 18.5523 5 18V7H2V5H5V2H7V17H15ZM9 9H15V15H9V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4bd09998c9af010a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.41421 17H15V19H6C5.44772 19 5 18.5523 5 18V7H2V5H5V2H7V15.5858L15.5858 7H9V5H17.5858L20.1421 2.44365L21.5563 3.85786L19 6.41421V17H22V19H19V22H17V8.41421L8.41421 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e8721e73148fb376(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 17H22V19H19V22H17V19H6C5.44772 19 5 18.5523 5 18V7H2V5H5V2H7V5H18C18.5523 5 19 5.44772 19 6V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b3e7e12f73f066e6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 17V19H6C5.44772 19 5 18.5523 5 18V7H2V5H5V2H7V17H15ZM17 22V7H9V5H18C18.5523 5 19 5.44772 19 6V17H22V19H19V22H17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$18fb7d120ff8a95d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5.07089C7.93431 5.5094 5.5094 7.93431 5.07089 11H7V13H5.07089C5.5094 16.0657 7.93431 18.4906 11 18.9291V17H13V18.9291C16.0657 18.4906 18.4906 16.0657 18.9291 13H17V11H18.9291C18.4906 7.93431 16.0657 5.5094 13 5.07089V7H11V5.07089ZM3.05493 11C3.51608 6.82838 6.82838 3.51608 11 3.05493V1H13V3.05493C17.1716 3.51608 20.4839 6.82838 20.9451 11H23V13H20.9451C20.4839 17.1716 17.1716 20.4839 13 20.9451V23H11V20.9451C6.82838 20.4839 3.51608 17.1716 3.05493 13H1V11H3.05493ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c15dcd48b06c0db8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5.07089C7.93431 5.5094 5.5094 7.93431 5.07089 11H7V13H5.07089C5.5094 16.0657 7.93431 18.4906 11 18.9291V17H13V18.9291C16.0657 18.4906 18.4906 16.0657 18.9291 13H17V11H18.9291C18.4906 7.93431 16.0657 5.5094 13 5.07089V7H11V5.07089ZM3.05493 11C3.51608 6.82838 6.82838 3.51608 11 3.05493V1H13V3.05493C17.1716 3.51608 20.4839 6.82838 20.9451 11H23V13H20.9451C20.4839 17.1716 17.1716 20.4839 13 20.9451V23H11V20.9451C6.82838 20.4839 3.51608 17.1716 3.05493 13H1V11H3.05493ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b37e2e715244f550(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.9381 13C19.4869 16.6187 16.6187 19.4869 13 19.9381V17H11V19.9381C7.38128 19.4869 4.51314 16.6187 4.06189 13H7V11H4.06189C4.51314 7.38128 7.38128 4.51314 11 4.06189V7H13V4.06189C16.6187 4.51314 19.4869 7.38128 19.9381 11H17V13H19.9381ZM2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1e4c460b1a970cd2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 19.9381C16.6187 19.4869 19.4869 16.6187 19.9381 13H17V11H19.9381C19.4869 7.38128 16.6187 4.51314 13 4.06189V7H11V4.06189C7.38128 4.51314 4.51314 7.38128 4.06189 11H7V13H4.06189C4.51314 16.6187 7.38128 19.4869 11 19.9381V17H13V19.9381ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fab90fc996c3abf5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6H16V8H21C21.5523 8 22 8.44772 22 9V16.5L16 13L16.0359 21.0622L18.2592 18.9129L20.041 22H9C8.44772 22 8 21.5523 8 21V16H6V14H8V9C8 8.44772 8.44772 8 9 8H14V6ZM22 17.338V21C22 21.107 21.9832 21.2101 21.9521 21.3068L19.9913 17.9129L22 17.338ZM4 14V16H2V14H4ZM4 10V12H2V10H4ZM4 6V8H2V6H4ZM4 2V4H2V2H4ZM8 2V4H6V2H8ZM12 2V4H10V2H12ZM16 2V4H14V2H16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6930c6a9da8ab532(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13L22.9641 17.0622L19.9913 17.9129L22.116 21.5933L20.384 22.5933L18.2592 18.9129L16.0359 21.0622L16 13ZM14 6H16V8H21C21.5523 8 22 8.44772 22 9V13H20V10H10V20H14V22H9C8.44772 22 8 21.5523 8 21V16H6V14H8V9C8 8.44772 8.44772 8 9 8H14V6ZM4 14V16H2V14H4ZM4 10V12H2V10H4ZM4 6V8H2V6H4ZM4 2V4H2V2H4ZM8 2V4H6V2H8ZM12 2V4H10V2H12ZM16 2V4H14V2H16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1eb54f4ce7573a6f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.63604 6.633L12 0.269043L18.364 6.633C21.8787 10.1477 21.8787 15.8462 18.364 19.3609C14.8492 22.8756 9.15076 22.8756 5.63604 19.3609C2.12132 15.8462 2.12132 10.1477 5.63604 6.633H5.63604Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1eb4218dc7b24fb7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3.09698L7.05025 8.04673C4.31658 10.7804 4.31658 15.2126 7.05025 17.9462C9.78392 20.6799 14.2161 20.6799 16.9497 17.9462C19.6834 15.2126 19.6834 10.7804 16.9497 8.04673L12 3.09698ZM12 0.268555L18.364 6.63252C21.8787 10.1472 21.8787 15.8457 18.364 19.3604C14.8492 22.8752 9.15076 22.8752 5.63604 19.3604C2.12132 15.8457 2.12132 10.1472 5.63604 6.63252L12 0.268555Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c6c3e462093b5f50(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.24264 18.9964H21V20.9964H3V16.7538L12.8995 6.85431L17.1421 11.0969L9.24264 18.9964ZM14.3137 5.44009L16.435 3.31877C16.8256 2.92825 17.4587 2.92825 17.8492 3.31877L20.6777 6.1472C21.0682 6.53772 21.0682 7.17089 20.6777 7.56141L18.5563 9.68273L14.3137 5.44009Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5f5466b6f0c4341b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18.89H6.41421L15.7279 9.57629L14.3137 8.16207L5 17.4758V18.89ZM21 20.89H3V16.6474L16.435 3.21233C16.8256 2.8218 17.4587 2.8218 17.8492 3.21233L20.6777 6.04075C21.0682 6.43128 21.0682 7.06444 20.6777 7.45497L9.24264 18.89H21V20.89ZM15.7279 6.74786L17.1421 8.16207L18.5563 6.74786L17.1421 5.33365L15.7279 6.74786Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f156560fda67ed33(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.7574 2.99666L9.29145 10.4626L9.29886 14.7097L13.537 14.7023L21 7.2393V19.9967C21 20.5489 20.5523 20.9967 20 20.9967H4C3.44772 20.9967 3 20.5489 3 19.9967V3.99666C3 3.44438 3.44772 2.99666 4 2.99666H16.7574ZM20.4853 2.09717L21.8995 3.51138L12.7071 12.7038L11.2954 12.7062L11.2929 11.2896L20.4853 2.09717Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f9ef309919f1e850(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.7574 2.99666L14.7574 4.99666H5V18.9967H19V9.2393L21 7.2393V19.9967C21 20.5489 20.5523 20.9967 20 20.9967H4C3.44772 20.9967 3 20.5489 3 19.9967V3.99666C3 3.44438 3.44772 2.99666 4 2.99666H16.7574ZM20.4853 2.09717L21.8995 3.51138L12.7071 12.7038L11.2954 12.7062L11.2929 11.2896L20.4853 2.09717Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8b7b133bd06a3018(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.6256 3.12837L9.29145 10.4625L9.29886 14.7097L13.537 14.7022L20.8682 7.37102C21.5912 8.75426 22 10.3277 22 11.9966C22 17.5194 17.5228 21.9966 12 21.9966C6.47715 21.9966 2 17.5194 2 11.9966C2 6.47373 6.47715 1.99658 12 1.99658C13.6689 1.99658 15.2423 2.40541 16.6256 3.12837ZM20.4853 2.09709L21.8995 3.5113L12.7071 12.7037L11.2954 12.7062L11.2929 11.2895L20.4853 2.09709Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$29bd68068316a801(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.6844 4.02535C12.4588 4.00633 12.2306 3.99658 12 3.99658C7.58172 3.99658 4 7.5783 4 11.9966C4 16.4149 7.58172 19.9966 12 19.9966C16.4183 19.9966 20 16.4149 20 11.9966C20 11.766 19.9902 11.5378 19.9711 11.3122C19.8996 10.4644 19.6953 9.64408 19.368 8.87332L20.8682 7.37102C21.2031 8.01179 21.4706 8.69338 21.6613 9.40637C21.8213 10.0062 21.9258 10.6221 21.9723 11.2479C21.9907 11.4951 22 11.7447 22 11.9966C22 17.5194 17.5228 21.9966 12 21.9966C6.47715 21.9966 2 17.5194 2 11.9966C2 6.47373 6.47715 1.99658 12 1.99658C12.2518 1.99658 12.5015 2.00589 12.7487 2.02419C13.3745 2.07069 13.9904 2.17529 14.5898 2.33568C15.3032 2.52597 15.9848 2.79347 16.6256 3.12837L15.1247 4.62922C14.3525 4.30131 13.5321 4.09695 12.6844 4.02535ZM20.4853 2.09709L21.8995 3.5113L12.7071 12.7037L11.2954 12.7062L11.2929 11.2895L20.4853 2.09709Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$31d7f76d976b2f70(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.24264 17.9964H3V13.7538L14.435 2.31877C14.8256 1.92825 15.4587 1.92825 15.8492 2.31877L18.6777 5.1472C19.0682 5.53772 19.0682 6.17089 18.6777 6.56141L7.24264 17.9964ZM3 19.9964H21V21.9964H3V19.9964Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7181113e36c75b84(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.41421 15.89L16.5563 5.74786L15.1421 4.33365L5 14.4758V15.89H6.41421ZM7.24264 17.89H3V13.6474L14.435 2.21233C14.8256 1.8218 15.4587 1.8218 15.8492 2.21233L18.6777 5.04075C19.0682 5.43128 19.0682 6.06444 18.6777 6.45497L7.24264 17.89ZM3 19.89H21V21.89H3V19.89Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4fc3672b9e0bb4af(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9999 18.9967H20.9999V20.9967H11.9999L8.00229 20.9992L1.51457 14.5115C1.12405 14.1209 1.12405 13.4878 1.51457 13.0972L12.1212 2.49065C12.5117 2.10012 13.1449 2.10012 13.5354 2.49065L21.3136 10.2688C21.7041 10.6593 21.7041 11.2925 21.3136 11.683L13.9999 18.9967ZM15.6567 14.5115L19.1922 10.9759L12.8283 4.61197L9.29275 8.1475L15.6567 14.5115Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b905963edfa0c915(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.58564 8.85461L3.63589 13.8044L8.83021 18.9987L9.99985 18.998V18.9967H11.1714L14.9496 15.2186L8.58564 8.85461ZM9.99985 7.44039L16.3638 13.8044L19.1922 10.9759L12.8283 4.61197L9.99985 7.44039ZM13.9999 18.9967H20.9999V20.9967H11.9999L8.00229 20.9992L1.51457 14.5115C1.12405 14.1209 1.12405 13.4878 1.51457 13.0972L12.1212 2.49065C12.5117 2.10012 13.1449 2.10012 13.5354 2.49065L21.3136 10.2688C21.7041 10.6593 21.7041 11.2925 21.3136 11.683L13.9999 18.9967Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$84facba0650cc57(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.4267 20 20 16.4267 20 12C20 7.57333 16.4267 4 12 4C7.57333 4 4 7.57333 4 12C4 16.4267 7.57333 20 12 20ZM12 18C8.68 18 6 15.32 6 12C6 8.68 8.68 6 12 6C15.32 6 18 8.68 18 12C18 15.32 15.32 18 12 18ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8216daeaf4fd4ecf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16ZM12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18ZM12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e1c62f0a5df1a00d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1L13.001 4.06201C16.6192 4.51365 19.4869 7.38163 19.9381 11L23 11V13L19.938 13.001C19.4864 16.6189 16.6189 19.4864 13.001 19.938L13 23H11L11 19.9381C7.38163 19.4869 4.51365 16.6192 4.06201 13.001L1 13V11L4.06189 11C4.51312 7.38129 7.38129 4.51312 11 4.06189L11 1H13ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ab526e8e10206a36(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1L13.001 4.06201C16.6192 4.51365 19.4869 7.38163 19.9381 11L23 11V13L19.938 13.001C19.4864 16.6189 16.6189 19.4864 13.001 19.938L13 23H11L11 19.9381C7.38163 19.4869 4.51365 16.6192 4.06201 13.001L1 13V11L4.06189 11C4.51312 7.38129 7.38129 4.51312 11 4.06189L11 1H13ZM12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a0e755fb9452a576(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$37e3d04e9d931892(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9ff1fb0583849879(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10V14H10V10H14ZM16 10H21V14H16V10ZM14 21H10V16H14V21ZM16 21V16H21V20C21 20.5523 20.5523 21 20 21H16ZM14 3V8H10V3H14ZM16 3H20C20.5523 3 21 3.44772 21 4V8H16V3ZM8 10V14H3V10H8ZM8 21H4C3.44772 21 3 20.5523 3 20V16H8V21ZM8 3V8H3V4C3 3.44772 3.44772 3 4 3H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$feef64173212675b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10H10V14H14V10ZM16 10V14H19V10H16ZM14 19V16H10V19H14ZM16 19H19V16H16V19ZM14 5H10V8H14V5ZM16 5V8H19V5H16ZM8 10H5V14H8V10ZM8 19V16H5V19H8ZM8 5H5V8H8V5ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$89ab7be7a45f71ab(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8V2H20C20.5523 2 21 2.44772 21 3V7C21 7.55228 20.5523 8 20 8H17ZM15 22C15 22.5523 14.5523 23 14 23H10C9.44772 23 9 22.5523 9 22V8H2.5V6.07437C2.5 5.7187 2.68891 5.3898 2.99613 5.21059L8.5 2H15V22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e9f750afeb4a916b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2C20.5523 2 21 2.44772 21 3V8C21 8.55228 20.5523 9 20 9H15V22C15 22.5523 14.5523 23 14 23H10C9.44772 23 9 22.5523 9 22V9H3.5C2.94772 9 2.5 8.55228 2.5 8V5.61803C2.5 5.23926 2.714 4.893 3.05279 4.72361L8.5 2H20ZM15 4H8.97214L4.5 6.23607V7H11V21H13V7H15V4ZM19 4H17V7H19V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$41e0b4fbc5c4c39d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 2.5L23 12L17.5 21.5H6.5L1 12L6.5 2.5H17.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eb63b34e7a2ecf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 2.5L23 12L17.5 21.5H6.5L1 12L6.5 2.5H17.5ZM16.3469 4.5H7.65311L3.311 12L7.65311 19.5H16.3469L20.689 12L16.3469 4.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$32f00df4cfec5bf6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8.99658L20.3714 10.7451C20.751 10.897 21 11.2647 21 11.6736V20.9966C21 21.5489 20.5523 21.9966 20 21.9966H4C3.44772 21.9966 3 21.5489 3 20.9966V11.6736C3 11.2647 3.24895 10.897 3.62861 10.7451L8 8.99658H16ZM20 13.9966H8V18.9966H20V13.9966ZM16 2.99658C16.5523 2.99658 17 3.4443 17 3.99658V7.99658H7V3.99658C7 3.4443 7.44772 2.99658 8 2.99658H16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bbebd56012e90f81(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8.99658L20.3714 10.7451C20.751 10.897 21 11.2647 21 11.6736V20.9966C21 21.5489 20.5523 21.9966 20 21.9966H4C3.44772 21.9966 3 21.5489 3 20.9966V11.6736C3 11.2647 3.24895 10.897 3.62861 10.7451L8 8.99658H16ZM15.6148 10.9966H8.38517L5 12.3506V19.9966H19V18.9966H8V13.9966H19V12.3506L15.6148 10.9966ZM16 2.99658C16.5523 2.99658 17 3.4443 17 3.99658V7.99658H7V3.99658C7 3.4443 7.44772 2.99658 8 2.99658H16ZM15 4.99658H9V5.99658H15V4.99658Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f71f7a21e21cbe7b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM9.86885 15H14.1311L14.9508 17H17.1667L13 7H11L6.83333 17H9.04918L9.86885 15ZM10.6885 13L12 9.8L13.3115 13H10.6885Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3b4c534bf16c4aed(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5V19H19V5H5ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM9.86885 15L9.04918 17H6.83333L11 7H13L17.1667 17H14.9508L14.1311 15H9.86885ZM10.6885 13H13.3115L12 9.8L10.6885 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$284b3c2a8e159488(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 3V21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H11ZM21 13V20C21 20.5523 20.5523 21 20 21H13V13H21ZM20 3C20.5523 3 21 3.44772 21 4V11H13V3H20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c0782f93fe502f3e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20ZM11 5H5V19H11V5ZM19 13H13V19H19V13ZM19 5H13V11H19V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$68aba740dc9abfa0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10V21H4C3.44772 21 3 20.5523 3 20V10H8ZM21 10V20C21 20.5523 20.5523 21 20 21H10V10H21ZM20 3C20.5523 3 21 3.44772 21 4V8H3V4C3 3.44772 3.44772 3 4 3H20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$64f0e61c627a3606(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4ZM8 10H5V19H8V10ZM19 10H10V19H19V10ZM19 5H5V8H19V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$edc7f19e1955a07e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13V21H4C3.44772 21 3 20.5523 3 20V13H11ZM13 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H13V3ZM3 4C3 3.44772 3.44772 3 4 3H11V11H3V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6d694c1cbb50379d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM11 13H5V19H11V13ZM13 19H19V5H13V19ZM11 5H5V11H11V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a5c48ece77b6f16(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10V21H3C2.44772 21 2 20.5523 2 20V10H7ZM22 10V20C22 20.5523 21.5523 21 21 21H9V10H22ZM21 3C21.5523 3 22 3.44772 22 4V8H2V4C2 3.44772 2.44772 3 3 3H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b8111298406fcb91(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3ZM7 10H4V19H7V10ZM20 10H9V19H20V10ZM20 5H4V8H20V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$311ee12f9b8df5cb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 10V21H3C2.44772 21 2 20.5523 2 20V10H15ZM22 10V20C22 20.5523 21.5523 21 21 21H17V10H22ZM21 3C21.5523 3 22 3.44772 22 4V8H2V4C2 3.44772 2.44772 3 3 3H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$86f95a08a2175057(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3ZM15 10H4V19H15V10ZM20 10H17V19H20V10ZM20 5H4V8H20V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$20dcd5afb62886cc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM19 16H5V18H19V16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d1e393bb25b04a0d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V19H20V5ZM18 15V17H6V15H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f6dc1eb100f30dbf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V16H22ZM21 3C21.5523 3 22 3.44772 22 4V14H2V4C2 3.44772 2.44772 3 3 3H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$55df25ca27d2fb70(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM4 16V19H20V16H4ZM4 14H20V5H4V14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$596b364f2c1cd1d6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5V19H19V5H12ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$139d265fa5a3f7d8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5H5V19H11V5ZM13 5V19H19V5H13ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$aebaf6dcb5867745(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21V10H21V20C21 20.5523 20.5523 21 20 21H16ZM14 21H4C3.44772 21 3 20.5523 3 20V10H14V21ZM21 8H3V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2b86629ec2eafb6e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12.999V20C22 20.5523 21.5523 21 21 21H13V12.999H22ZM11 12.999V21H3C2.44772 21 2 20.5523 2 20V12.999H11ZM11 3V10.999H2V4C2 3.44772 2.44772 3 3 3H11ZM21 3C21.5523 3 22 3.44772 22 4V10.999H13V3H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6889df2bac2c17a8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM11 13H4V19H11V13ZM20 13H13V19H20V13ZM11 5H4V11H11V5ZM20 5H13V11H20V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cd38ba1cc66cd0e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM7 6H5V18H7V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$905629770a9f6150(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V19H20V5ZM8 7V17H6V7H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c0c4fd4a114977c8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H9V3H21ZM7 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b0aa405087451b00(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM7 5H4V19H7V5ZM20 5H9V19H20V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6b1a18a2f2d1e45d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8H19V5H5V8ZM14 19V10H5V19H14ZM16 19H19V10H16V19ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5e69936576866870(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.999V20C22 20.5523 21.5523 21 21 21H13V9.999H22ZM11 15.999V21H3C2.44772 21 2 20.5523 2 20V15.999H11ZM11 3V13.999H2V4C2 3.44772 2.44772 3 3 3H11ZM21 3C21.5523 3 22 3.44772 22 4V7.999H13V3H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8c362bd970d16196(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20ZM11 15H4V19H11V15ZM20 11H13V19H20V11ZM11 5H4V13H11V5ZM20 5H13V9H20V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$19da07b81260c90b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM19 6H17V18H19V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cc066d2cb82e66f5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V19H20V5ZM18 7V17H16V7H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ca18fd8e3336ff8a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H17V3H21ZM15 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H15V21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a248974f69202418(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM15 5H4V19H15V5ZM20 5H17V19H20V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6172626ed50b52b4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12H5V19H19V12ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$34e2de87c3baa9ab(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11V5H5V11H19ZM19 13H5V19H19V13ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$75f9092ec9b48c2e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM19 6H5V8H19V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$35560c52a1e03cf8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V19H20V5ZM18 7V9H6V7H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2a5558e3e9ccf196(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V10H22ZM21 3C21.5523 3 22 3.44772 22 4V8H2V4C2 3.44772 2.44772 3 3 3H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b09a1500347ee1a0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM4 10V19H20V10H4ZM4 8H20V5H4V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dfa07177c217127c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.2238 15.5078L13.0111 20.1579C12.8687 20.4572 12.5107 20.5843 12.2115 20.4419C12.1448 20.4102 12.0845 20.3664 12.0337 20.3127L8.49229 16.574C8.39749 16.4739 8.27113 16.4095 8.13445 16.3917L3.02816 15.7242C2.69958 15.6812 2.46804 15.3801 2.51099 15.0515C2.52056 14.9782 2.54359 14.9074 2.5789 14.8425L5.04031 10.3191C5.1062 10.198 5.12839 10.0579 5.10314 9.92241L4.16 4.85979C4.09931 4.53402 4.3142 4.22074 4.63997 4.16005C4.7126 4.14652 4.78711 4.14652 4.85974 4.16005L9.92237 5.10319C10.0579 5.12843 10.198 5.10625 10.319 5.04036L14.8424 2.57895C15.1335 2.42056 15.4979 2.52812 15.6562 2.81919C15.6916 2.88409 15.7146 2.95495 15.7241 3.02821L16.3916 8.13449C16.4095 8.27118 16.4739 8.39754 16.5739 8.49233L20.3127 12.0337C20.5533 12.2616 20.5636 12.6414 20.3357 12.8819C20.2849 12.9356 20.2246 12.9794 20.1579 13.0111L15.5078 15.2238C15.3833 15.2831 15.283 15.3833 15.2238 15.5078ZM16.0206 17.4349L17.4348 16.0207L21.6775 20.2633L20.2633 21.6775L16.0206 17.4349Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$790d8b0d4451116d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.1986 9.94435C14.7649 9.53358 14.4859 8.98601 14.4085 8.39371L14.0056 5.31126L11.275 6.79711C10.7503 7.08262 10.1433 7.17876 9.55608 7.06936L6.49998 6.50003L7.06931 9.55612C7.17871 10.1434 7.08257 10.7503 6.79707 11.275L5.31121 14.0056L8.39367 14.4085C8.98596 14.4859 9.53353 14.7649 9.94431 15.1986L12.0821 17.4555L13.4178 14.6485C13.6745 14.1091 14.109 13.6745 14.6484 13.4179L17.4555 12.0821L15.1986 9.94435ZM15.2238 15.5078L13.0111 20.1579C12.8687 20.4572 12.5107 20.5843 12.2115 20.4419C12.1448 20.4102 12.0845 20.3664 12.0337 20.3127L8.49229 16.574C8.39749 16.4739 8.27113 16.4095 8.13445 16.3917L3.02816 15.7242C2.69958 15.6812 2.46804 15.3801 2.51099 15.0515C2.52056 14.9782 2.54359 14.9074 2.5789 14.8425L5.04031 10.3191C5.1062 10.198 5.12839 10.0579 5.10314 9.92241L4.16 4.85979C4.09931 4.53402 4.3142 4.22074 4.63997 4.16005C4.7126 4.14652 4.78711 4.14652 4.85974 4.16005L9.92237 5.10319C10.0579 5.12843 10.198 5.10625 10.319 5.04036L14.8424 2.57895C15.1335 2.42056 15.4979 2.52812 15.6562 2.81919C15.6916 2.88409 15.7146 2.95495 15.7241 3.02821L16.3916 8.13449C16.4095 8.27118 16.4739 8.39754 16.5739 8.49233L20.3127 12.0337C20.5533 12.2616 20.5636 12.6414 20.3357 12.8819C20.2849 12.9356 20.2246 12.9794 20.1579 13.0111L15.5078 15.2238C15.3833 15.2831 15.283 15.3833 15.2238 15.5078ZM16.0206 17.4349L17.4348 16.0207L21.6775 20.2633L20.2633 21.6775L16.0206 17.4349Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1b4845e0a2057b0b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.9498 2.39006L21.6066 8.04692C21.9972 8.43744 21.9972 9.0706 21.6066 9.46113L13.8285 17.2393L11.7071 17.9464L10.2929 19.3606C9.90241 19.7511 9.26925 19.7511 8.87872 19.3606L4.63608 15.118C4.24556 14.7275 4.24556 14.0943 4.63608 13.7038L6.0503 12.2896L6.7574 10.1682L14.5356 2.39006C14.9261 1.99954 15.5593 1.99954 15.9498 2.39006ZM16.6569 5.9256L10.2929 12.2896L11.7071 13.7038L18.0711 7.33981L16.6569 5.9256ZM4.28253 16.8858L7.11096 19.7142L5.69674 21.1284L1.4541 19.7142L4.28253 16.8858Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$353c97e8d3e4b829(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.2427 4.51138L8.50547 11.2486L7.79836 13.3699L6.7574 14.4109L9.58583 17.2393L10.6268 16.1983L12.7481 15.4912L19.4853 8.75402L15.2427 4.51138ZM21.6066 8.04692C21.9972 8.43744 21.9972 9.0706 21.6066 9.46113L13.8285 17.2393L11.7071 17.9464L10.2929 19.3606C9.90241 19.7511 9.26925 19.7511 8.87872 19.3606L4.63608 15.118C4.24556 14.7275 4.24556 14.0943 4.63608 13.7038L6.0503 12.2896L6.7574 10.1682L14.5356 2.39006C14.9261 1.99954 15.5593 1.99954 15.9498 2.39006L21.6066 8.04692ZM15.2427 7.33981L16.6569 8.75402L11.7071 13.7038L10.2929 12.2896L15.2427 7.33981ZM4.28253 16.8858L7.11096 19.7142L5.69674 21.1284L1.4541 19.7142L4.28253 16.8858Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6f369dcce6fdaa55(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21.9966C6.47715 21.9966 2 17.5194 2 11.9966C2 6.47373 6.47715 1.99658 12 1.99658C17.5228 1.99658 22 6.47373 22 11.9966C22 17.5194 17.5228 21.9966 12 21.9966ZM17.051 18.2007L16.1894 14.754C16.0781 14.3089 15.6781 13.9966 15.2192 13.9966H8.78078C8.32191 13.9966 7.92193 14.3089 7.81063 14.754L6.94897 18.2007C8.32629 19.3234 10.0845 19.9966 12 19.9966C13.9155 19.9966 15.6737 19.3234 17.051 18.2007ZM10 11.9966H14V10.4966L12.9615 6.86192C12.8666 6.52971 12.6069 6.27003 12.2747 6.17511C11.7437 6.02339 11.1902 6.33088 11.0385 6.86192L10 10.4966V11.9966Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$90322bcfb25b798a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10.4966L11.0385 6.86192C11.1902 6.33088 11.7437 6.02339 12.2747 6.17511C12.6069 6.27003 12.8666 6.52971 12.9615 6.86192L14 10.4966V11.9966H14.7192C15.1781 11.9966 15.5781 12.3089 15.6894 12.754L17.051 18.2007C18.8507 16.7338 20 14.4994 20 11.9966C20 7.5783 16.4183 3.99658 12 3.99658C7.58172 3.99658 4 7.5783 4 11.9966C4 14.4994 5.14932 16.7338 6.94897 18.2007L8.31063 12.754C8.42193 12.3089 8.82191 11.9966 9.28078 11.9966H10V10.4966ZM12 19.9966C12.2415 19.9966 12.4813 19.9859 12.7189 19.9648C13.6187 19.8846 14.4756 19.6555 15.2649 19.3022L13.9384 13.9966H10.0616L8.73514 19.3022C9.52438 19.6555 10.3813 19.8846 11.2811 19.9647C11.5187 19.9859 11.7585 19.9966 12 19.9966ZM12 21.9966C6.47715 21.9966 2 17.5194 2 11.9966C2 6.47373 6.47715 1.99658 12 1.99658C17.5228 1.99658 22 6.47373 22 11.9966C22 17.5194 17.5228 21.9966 12 21.9966Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7ff1acd55c8034ab(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.936 2.50098L21.501 8.06595V15.936L15.936 21.501H8.06595L2.50098 15.936V8.06595L8.06595 2.50098H15.936Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$822c6b4f6790620e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.936 2.50098L21.501 8.06595V15.936L15.936 21.501H8.06595L2.50098 15.936V8.06595L8.06595 2.50098H15.936ZM15.1076 4.50098H8.89437L4.50098 8.89437V15.1076L8.89437 19.501H15.1076L19.501 15.1076V8.89437L15.1076 4.50098Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$407ec9fcac8a2808(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2.99658H20C20.5523 2.99658 21 3.4443 21 3.99658V8.99658C21 9.54887 20.5523 9.99658 20 9.99658H4C3.44772 9.99658 3 9.54887 3 8.99658V3.99658C3 3.4443 3.44772 2.99658 4 2.99658ZM6 11.9966H12C12.5523 11.9966 13 12.4443 13 12.9966V15.9966H14V21.9966H10V15.9966H11V13.9966H5C4.44772 13.9966 4 13.5489 4 12.9966V10.9966H6V11.9966ZM17.7322 13.7288L19.5 11.961L21.2678 13.7288C22.2441 14.7051 22.2441 16.288 21.2678 17.2643C20.2915 18.2407 18.7085 18.2407 17.7322 17.2643C16.7559 16.288 16.7559 14.7051 17.7322 13.7288Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4116bc52a1d9a37e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4.99658V7.99658H19V4.99658H5ZM4 2.99658H20C20.5523 2.99658 21 3.4443 21 3.99658V8.99658C21 9.54887 20.5523 9.99658 20 9.99658H4C3.44772 9.99658 3 9.54887 3 8.99658V3.99658C3 3.4443 3.44772 2.99658 4 2.99658ZM6 11.9966H12C12.5523 11.9966 13 12.4443 13 12.9966V15.9966H14V21.9966H10V15.9966H11V13.9966H5C4.44772 13.9966 4 13.5489 4 12.9966V10.9966H6V11.9966ZM17.7322 13.7288L19.5 11.961L21.2678 13.7288C22.2441 14.7051 22.2441 16.288 21.2678 17.2643C20.2915 18.2407 18.7085 18.2407 17.7322 17.2643C16.7559 16.288 16.7559 14.7051 17.7322 13.7288Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8853c320ea025181(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.2277 18.7321L20.9955 16.9644L22.7632 18.7321C23.7395 19.7084 23.7395 21.2914 22.7632 22.2677C21.7869 23.244 20.204 23.244 19.2277 22.2677C18.2514 21.2914 18.2514 19.7084 19.2277 18.7321ZM8.87861 1.07959L20.1923 12.3933C20.5828 12.7838 20.5828 13.417 20.1923 13.8075L11.707 22.2928C11.3165 22.6833 10.6833 22.6833 10.2928 22.2928L1.80754 13.8075C1.41702 13.417 1.41702 12.7838 1.80754 12.3933L9.58572 4.61512L7.4644 2.4938L8.87861 1.07959ZM10.9999 6.02934L3.92886 13.1004H18.071L10.9999 6.02934Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$175ce4dfb169a62f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.2277 18.7321L20.9955 16.9644L22.7632 18.7321C23.7395 19.7084 23.7395 21.2914 22.7632 22.2677C21.7869 23.244 20.204 23.244 19.2277 22.2677C18.2514 21.2914 18.2514 19.7084 19.2277 18.7321ZM8.87861 1.07959L20.1923 12.3933C20.5828 12.7838 20.5828 13.417 20.1923 13.8075L11.707 22.2928C11.3165 22.6833 10.6833 22.6833 10.2928 22.2928L1.80754 13.8075C1.41702 13.417 1.41702 12.7838 1.80754 12.3933L9.58572 4.61512L7.4644 2.4938L8.87861 1.07959ZM10.9999 6.02934L3.92886 13.1004L10.9999 20.1715L18.071 13.1004L10.9999 6.02934Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$47826faed4e669e5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5222 2 22 5.97778 22 10.8889C22 13.9556 19.5111 16.4444 16.4444 16.4444H14.4778C13.5556 16.4444 12.8111 17.1889 12.8111 18.1111C12.8111 18.5333 12.9778 18.9222 13.2333 19.2111C13.5 19.5111 13.6667 19.9 13.6667 20.3333C13.6667 21.2556 12.9 22 12 22C6.47778 22 2 17.5222 2 12C2 6.47778 6.47778 2 12 2ZM7.5 12C8.32843 12 9 11.3284 9 10.5C9 9.67157 8.32843 9 7.5 9C6.67157 9 6 9.67157 6 10.5C6 11.3284 6.67157 12 7.5 12ZM16.5 12C17.3284 12 18 11.3284 18 10.5C18 9.67157 17.3284 9 16.5 9C15.6716 9 15 9.67157 15 10.5C15 11.3284 15.6716 12 16.5 12ZM12 9C12.8284 9 13.5 8.32843 13.5 7.5C13.5 6.67157 12.8284 6 12 6C11.1716 6 10.5 6.67157 10.5 7.5C10.5 8.32843 11.1716 9 12 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ef88431fc707bd5c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5222 2 22 5.97778 22 10.8889C22 13.9556 19.5111 16.4444 16.4444 16.4444H14.4778C13.5556 16.4444 12.8111 17.1889 12.8111 18.1111C12.8111 18.5333 12.9778 18.9222 13.2333 19.2111C13.5 19.5111 13.6667 19.9 13.6667 20.3333C13.6667 21.2556 12.9 22 12 22C6.47778 22 2 17.5222 2 12C2 6.47778 6.47778 2 12 2ZM10.8111 18.1111C10.8111 16.0843 12.451 14.4444 14.4778 14.4444H16.4444C18.4065 14.4444 20 12.851 20 10.8889C20 7.1392 16.4677 4 12 4C7.58235 4 4 7.58235 4 12C4 16.19 7.2226 19.6285 11.324 19.9718C10.9948 19.4168 10.8111 18.7761 10.8111 18.1111ZM7.5 12C6.67157 12 6 11.3284 6 10.5C6 9.67157 6.67157 9 7.5 9C8.32843 9 9 9.67157 9 10.5C9 11.3284 8.32843 12 7.5 12ZM16.5 12C15.6716 12 15 11.3284 15 10.5C15 9.67157 15.6716 9 16.5 9C17.3284 9 18 9.67157 18 10.5C18 11.3284 17.3284 12 16.5 12ZM12 9C11.1716 9 10.5 8.32843 10.5 7.5C10.5 6.67157 11.1716 6 12 6C12.8284 6 13.5 6.67157 13.5 7.5C13.5 8.32843 12.8284 9 12 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2b639b26650643(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.0007 18.9222L2.65105 18.3769C2.13898 18.17 1.89158 17.5872 2.09847 17.0751L4.0007 12.367V18.9222ZM8.86036 20.9999H7.0007C6.44841 20.9999 6.0007 20.5522 6.0007 19.9999V13.922L8.86036 20.9999ZM6.02251 5.96758L15.2943 2.22152C15.8064 2.01463 16.3892 2.26203 16.5961 2.7741L22.2152 16.6819C22.4221 17.1939 22.1747 17.7768 21.6627 17.9836L12.3908 21.7297C11.8788 21.9366 11.2959 21.6892 11.089 21.1771L5.46993 7.26937C5.26304 6.75731 5.51044 6.17447 6.02251 5.96758ZM9.0007 8.99992C9.55298 8.99992 10.0007 8.55221 10.0007 7.99992C10.0007 7.44764 9.55298 6.99992 9.0007 6.99992C8.44841 6.99992 8.0007 7.44764 8.0007 7.99992C8.0007 8.55221 8.44841 8.99992 9.0007 8.99992Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e20c3ffeaa3a713d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.76509 7.99992L5.46993 7.26937C5.26304 6.75731 5.51044 6.17447 6.02251 5.96758L15.2943 2.22152C15.8064 2.01463 16.3892 2.26203 16.5961 2.7741L22.2152 16.6819C22.4221 17.1939 22.1747 17.7768 21.6627 17.9836L12.3908 21.7297C11.8788 21.9366 11.2959 21.6892 11.089 21.1771L11.0007 20.9585V20.9999H7.0007C6.44841 20.9999 6.0007 20.5522 6.0007 19.9999V19.7303L2.65105 18.3769C2.13898 18.17 1.89158 17.5872 2.09847 17.0751L5.76509 7.99992ZM8.0007 18.9999H10.2094L8.0007 13.5332V18.9999ZM6.0007 12.7557L4.32745 16.8972L6.0007 17.6084V12.7557ZM7.69891 7.44735L12.5688 19.5007L19.9863 16.5039L15.1164 4.45049L7.69891 7.44735ZM10.6771 9.47968C10.165 9.68657 9.58219 9.43918 9.3753 8.92711C9.16841 8.41504 9.41581 7.83221 9.92788 7.62532C10.4399 7.41843 11.0228 7.66582 11.2297 8.17789C11.4366 8.68996 11.1892 9.27279 10.6771 9.47968Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$52ce89f0dba7434f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.92898 21.4821L10.775 15.636C11.4423 15.8142 12.1837 15.6416 12.7071 15.1181C13.4882 14.3371 13.4882 13.0707 12.7071 12.2897C11.9261 11.5086 10.6598 11.5086 9.87872 12.2897C9.35526 12.8132 9.18263 13.5546 9.36081 14.2218L3.51476 20.0679L2.4541 19.0072C5.28253 15.7074 6.34319 12.054 7.7574 5.92573L14.1214 5.21863L19.7783 10.8755L19.0711 17.2394C12.9429 18.6537 9.28947 19.7143 5.98964 22.5427L4.92898 21.4821ZM16.5962 2.03665L22.9428 8.38325C23.1381 8.57852 23.1381 8.8951 22.9428 9.09036C22.8679 9.16526 22.7712 9.21444 22.6665 9.23081L21.1924 9.46127L15.5356 3.80441L15.7477 2.31949C15.7868 2.04612 16.04 1.85617 16.3134 1.89523C16.4205 1.91053 16.5197 1.96015 16.5962 2.03665Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$990f434df77ea0b1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5962 1.03665L22.9428 7.38325C23.1381 7.57852 23.1381 7.8951 22.9428 8.09036C22.8679 8.16526 22.7712 8.21444 22.6665 8.23081L21.1924 8.46127L15.5356 2.80441L15.7477 1.31949C15.7868 1.04612 16.04 0.856173 16.3134 0.895226C16.4205 0.910525 16.5197 0.960149 16.5962 1.03665ZM4.59487 20.148C8.31725 16.8165 12.5899 15.8201 17.2379 14.6275L17.6843 10.61L13.3869 6.31255L9.36936 6.75894C8.17674 11.407 7.18038 15.6796 3.84886 19.402L2.4541 18.0072C5.28253 14.7074 6.34319 11.054 7.7574 4.92573L14.1214 4.21863L19.7783 9.87552L19.0711 16.2394C12.9429 17.6537 9.28947 18.7143 5.98964 21.5427L4.59487 20.148ZM9.87872 14.1181C9.09767 13.3371 9.09767 12.0707 9.87872 11.2897C10.6598 10.5086 11.9261 10.5086 12.7071 11.2897C13.4882 12.0707 13.4882 13.3371 12.7071 14.1181C11.9261 14.8992 10.6598 14.8992 9.87872 14.1181Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3e0f6117ef7955b7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.8995 6.85431L17.1421 11.0969L7.24264 20.9964H3V16.7538L12.8995 6.85431ZM14.3137 5.44009L16.435 3.31877C16.8256 2.92825 17.4587 2.92825 17.8492 3.31877L20.6777 6.1472C21.0682 6.53772 21.0682 7.17089 20.6777 7.56141L18.5563 9.68273L14.3137 5.44009Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8322222e6db295b7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.7279 9.57629L14.3137 8.16207L5 17.4758V18.89H6.41421L15.7279 9.57629ZM17.1421 8.16207L18.5563 6.74786L17.1421 5.33365L15.7279 6.74786L17.1421 8.16207ZM7.24264 20.89H3V16.6474L16.435 3.21233C16.8256 2.8218 17.4587 2.8218 17.8492 3.21233L20.6777 6.04075C21.0682 6.43128 21.0682 7.06444 20.6777 7.45497L7.24264 20.89Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e1ebb3005c01762f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.63611 12.7072L7.46454 14.5356L8.87875 13.1214L7.05033 11.293L8.46454 9.87875L10.293 11.7072L11.7072 10.293L9.87875 8.46454L11.293 7.05033L13.1214 8.87875L14.5356 7.46454L12.7072 5.63611L15.5356 2.80768C15.9261 2.41716 16.5593 2.41716 16.9498 2.80768L21.1925 7.05033C21.583 7.44085 21.583 8.07401 21.1925 8.46454L8.46454 21.1925C8.07401 21.583 7.44085 21.583 7.05033 21.1925L2.80768 16.9498C2.41716 16.5593 2.41716 15.9261 2.80768 15.5356L5.63611 12.7072ZM14.1214 18.3635L18.364 14.1209L20.9997 16.7566V20.9999H16.7578L14.1214 18.3635ZM5.63597 9.87812L2.80754 7.04969C2.41702 6.65917 2.41702 6.02601 2.80754 5.63548L5.63597 2.80705C6.02649 2.41653 6.65966 2.41653 7.05018 2.80705L9.87861 5.63548L5.63597 9.87812Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$94f925f5657ab332(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.05033 14.1214L4.929 16.2427L7.75743 19.0711L19.0711 7.75743L16.2427 4.929L14.1214 7.05033L15.5356 8.46454L14.1214 9.87875L12.7072 8.46454L11.293 9.87875L12.7072 11.293L11.293 12.7072L9.87875 11.293L8.46454 12.7072L9.87875 14.1214L8.46454 15.5356L7.05033 14.1214ZM16.9498 2.80768L21.1925 7.05033C21.583 7.44085 21.583 8.07401 21.1925 8.46454L8.46454 21.1925C8.07401 21.583 7.44085 21.583 7.05033 21.1925L2.80768 16.9498C2.41716 16.5593 2.41716 15.9261 2.80768 15.5356L15.5356 2.80768C15.9261 2.41716 16.5593 2.41716 16.9498 2.80768ZM14.1214 18.3635L15.5356 16.9493L17.7781 19.1918H19.1923V17.7776L16.9498 15.5351L18.364 14.1209L20.9997 16.7566V20.9999H16.7578L14.1214 18.3635ZM5.63597 9.87812L2.80754 7.04969C2.41702 6.65917 2.41702 6.02601 2.80754 5.63548L5.63597 2.80705C6.02649 2.41653 6.65966 2.41653 7.05018 2.80705L9.87861 5.63548L8.4644 7.04969L6.34308 4.92837L4.92886 6.34259L7.05018 8.46391L5.63597 9.87812Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$72b72da7ac12e689(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18V20H9V18H5ZM3 7L7 2L11 7V22H3V7ZM21 8H19V10H21V12H18V14H21V16H19V18H21V21C21 21.5523 20.5523 22 20 22H14C13.4477 22 13 21.5523 13 21V5C13 4.44772 13.4477 4 14 4H20C20.5523 4 21 4.44772 21 5V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6c236023e9a47476(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8V20H9V8H5ZM3 7L7 2L11 7V22H3V7ZM19 16V14H16V12H19V10H17V8H19V6H15V20H19V18H17V16H19ZM14 4H20C20.5523 4 21 4.44772 21 5V21C21 21.5523 20.5523 22 20 22H14C13.4477 22 13 21.5523 13 21V5C13 4.44772 13.4477 4 14 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6657fa0015f78e1d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9999 0.700195L22.7468 8.5083L18.6418 21.1421H5.35789L1.25293 8.5083L11.9999 0.700195Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$850f6edb71109f15(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9999 3.03068L20.5304 9.22846L17.272 19.2567H6.72772L3.46935 9.22846L11.9999 3.03068ZM22.7468 8.5083L11.9999 0.700195L1.25293 8.5083L5.35789 21.1421H18.6418L22.7468 8.5083Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8f101ca9753d721d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1.99658C6 1.99658 4 15.9966 3 21.9966C3.66667 21.9966 4.33275 21.9966 4.99824 21.9966C5.66421 18.6635 7.33146 16.8301 10 16.4966C14 15.9966 17 12.4966 18 9.49658L16.5 8.49658C16.8333 8.16325 17.1667 7.82992 17.5 7.49658C18.5 6.49658 19.5042 4.99658 21 1.99658Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$83892b6839351d50(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.93912 14.0327C6.7072 14.6562 6.51032 15.233 6.33421 15.8154C7.29345 15.1188 8.43544 14.6766 9.75193 14.512C12.2652 14.1979 14.4976 12.5384 15.6279 10.4535L14.1721 8.99878L15.5848 7.58407C15.9185 7.24993 16.2521 6.91603 16.5858 6.58237C17.0151 6.15301 17.5 5.35838 18.0129 4.21479C12.4197 5.08172 8.99484 8.50636 6.93912 14.0327ZM17 8.99728L18 9.99658C17 12.9966 14 15.9966 10 16.4966C7.33146 16.8301 5.66421 18.6635 4.99824 21.9966H3C4 15.9966 6 1.99658 21 1.99658C20.0009 4.99392 19.0018 6.99303 18.0027 7.99391C17.6662 8.33038 17.3331 8.66372 17 8.99728Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6604a86fd9b5916c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4H21C21.5523 4 22 4.44772 22 5V19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19V5C2 4.44772 2.44772 4 3 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$73691abe85275193(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4H21C21.5523 4 22 4.44772 22 5V19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19V5C2 4.44772 2.44772 4 3 4ZM4 6V18H20V6H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8e38346c9d3c963e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21H13V18H11V21H9V19H7V21H4C3.44772 21 3 20.5523 3 20V17H5V15H3V13H6V11H3V9H5V7H3V4C3 3.44772 3.44772 3 4 3H10C10.5523 3 11 3.44772 11 4V13H20C20.5523 13 21 13.4477 21 14V20C21 20.5523 20.5523 21 20 21H17V19H15V21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e3f907b6fc04f9a6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 19H19V14H10V5H5V7H7V9H5V11H8V13H5V15H7V17H5V19H7V17H9V19H11V16H13V19H15V17H17V19ZM12 12H20C20.5523 12 21 12.4477 21 13V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H11C11.5523 3 12 3.44772 12 4V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9728312532fb4c4a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.92901 13.3136L7.05033 15.435L8.46455 14.0207L6.34323 11.8994L8.46455 9.7781L11.293 12.6065L12.7072 11.1923L9.87876 8.36389L12.0001 6.24257L14.1214 8.36389L15.5356 6.94967L13.4143 4.82835L16.2427 1.99992C16.6332 1.6094 17.2664 1.6094 17.6569 1.99992L22.6067 6.94967C22.9972 7.3402 22.9972 7.97336 22.6067 8.36389L7.75744 23.2131C7.36692 23.6037 6.73375 23.6037 6.34323 23.2131L1.39348 18.2634C1.00295 17.8729 1.00295 17.2397 1.39348 16.8492L4.92901 13.3136Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$712f7f6ec66755e0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.34323 14.7278L3.5148 17.5563L7.05033 21.0918L20.4854 7.65678L16.9498 4.12124L14.8285 6.24257L16.2427 7.65678L14.8285 9.07099L13.4143 7.65678L11.293 9.7781L13.4143 11.8994L12.0001 13.3136L9.87876 11.1923L7.75744 13.3136L9.17165 14.7278L7.75744 16.1421L6.34323 14.7278ZM17.6569 1.99992L22.6067 6.94967C22.9972 7.3402 22.9972 7.97336 22.6067 8.36389L7.75744 23.2131C7.36692 23.6037 6.73375 23.6037 6.34323 23.2131L1.39348 18.2634C1.00295 17.8729 1.00295 17.2397 1.39348 16.8492L16.2427 1.99992C16.6332 1.6094 17.2664 1.6094 17.6569 1.99992Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d9de69385911f702(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14.1181L9.68347 16.4346C9.88726 16.9145 10 17.4425 10 17.9967C10 20.2059 8.20914 21.9967 6 21.9967C3.79086 21.9967 2 20.2059 2 17.9967C2 15.7876 3.79086 13.9967 6 13.9967C6.55427 13.9967 7.08222 14.1095 7.56215 14.3133L9.87868 11.9967L4.21142 6.32948C3.43037 5.54843 3.43037 4.2821 4.21142 3.50105L4.91852 2.79395L12 9.87542L19.0815 2.79395L19.7886 3.50105C20.5696 4.2821 20.5696 5.54843 19.7886 6.32948L14.1213 11.9967L16.4379 14.3133C16.9178 14.1095 17.4457 13.9967 18 13.9967C20.2091 13.9967 22 15.7876 22 17.9967C22 20.2059 20.2091 21.9967 18 21.9967C15.7909 21.9967 14 20.2059 14 17.9967C14 17.4425 14.1127 16.9145 14.3165 16.4346L12 14.1181ZM6 19.9967C7.10457 19.9967 8 19.1013 8 17.9967C8 16.8922 7.10457 15.9967 6 15.9967C4.89543 15.9967 4 16.8922 4 17.9967C4 19.1013 4.89543 19.9967 6 19.9967ZM18 19.9967C19.1046 19.9967 20 19.1013 20 17.9967C20 16.8922 19.1046 15.9967 18 15.9967C16.8954 15.9967 16 16.8922 16 17.9967C16 19.1013 16.8954 19.9967 18 19.9967Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f36396e39f3a62ae(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.4109L9.44618 15.9647C9.79807 16.5602 10 17.2549 10 17.9967C10 20.2058 8.20914 21.9967 6 21.9967C3.79086 21.9967 2 20.2058 2 17.9967C2 15.7876 3.79086 13.9967 6 13.9967C6.74181 13.9967 7.43645 14.1986 8.03197 14.5505L10.5858 11.9967L4.56497 5.97589C3.78392 5.19484 3.78392 3.92851 4.56497 3.14746L12 10.5825L19.435 3.14746C20.2161 3.92851 20.2161 5.19484 19.435 5.97589L13.4142 11.9967L15.968 14.5505C16.5635 14.1986 17.2582 13.9967 18 13.9967C20.2091 13.9967 22 15.7876 22 17.9967C22 20.2058 20.2091 21.9967 18 21.9967C15.7909 21.9967 14 20.2058 14 17.9967C14 17.2549 14.2019 16.5602 14.5538 15.9647L12 13.4109ZM6 19.9967C7.10457 19.9967 8 19.1013 8 17.9967C8 16.8921 7.10457 15.9967 6 15.9967C4.89543 15.9967 4 16.8921 4 17.9967C4 19.1013 4.89543 19.9967 6 19.9967ZM18 19.9967C19.1046 19.9967 20 19.1013 20 17.9967C20 16.8921 19.1046 15.9967 18 15.9967C16.8954 15.9967 16 16.8921 16 17.9967C16 19.1013 16.8954 19.9967 18 19.9967Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a849727b9e1e6d8e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.87868 11.9966L7.56215 9.68005C7.08222 9.88385 6.55427 9.99658 6 9.99658C3.79086 9.99658 2 8.20572 2 5.99658C2 3.78744 3.79086 1.99658 6 1.99658C8.20914 1.99658 10 3.78744 10 5.99658C10 6.55086 9.88726 7.0788 9.68347 7.55873L12 9.87526L18.3744 3.50089C19.1554 2.71984 20.4217 2.71984 21.2028 3.50089L21.9099 4.208L9.68347 16.4344C9.88726 16.9144 10 17.4423 10 17.9966C10 20.2057 8.20914 21.9966 6 21.9966C3.79086 21.9966 2 20.2057 2 17.9966C2 15.7874 3.79086 13.9966 6 13.9966C6.55427 13.9966 7.08222 14.1093 7.56215 14.3131L9.87868 11.9966ZM6 7.99658C7.10457 7.99658 8 7.10115 8 5.99658C8 4.89201 7.10457 3.99658 6 3.99658C4.89543 3.99658 4 4.89201 4 5.99658C4 7.10115 4.89543 7.99658 6 7.99658ZM6 19.9966C7.10457 19.9966 8 19.1012 8 17.9966C8 16.892 7.10457 15.9966 6 15.9966C4.89543 15.9966 4 16.892 4 17.9966C4 19.1012 4.89543 19.9966 6 19.9966ZM15.5346 13.4099L21.9099 19.7852L21.2028 20.4923C20.4217 21.2733 19.1554 21.2733 18.3744 20.4923L13.4133 15.5312L15.5346 13.4099ZM16 10.9966H18V12.9966H16V10.9966ZM20 10.9966H22V12.9966H20V10.9966ZM6 10.9966H8V12.9966H6V10.9966ZM2 10.9966H4V12.9966H2V10.9966Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$67833817b0a0ef83(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 5.99658C10 6.72908 9.80311 7.41559 9.45936 8.00608L12 10.5824L18.7279 3.85445C19.509 3.0734 20.7753 3.0734 21.5563 3.85445L9.44618 15.9646C9.79807 16.5601 10 17.2548 10 17.9966C10 20.2057 8.20914 21.9966 6 21.9966C3.79086 21.9966 2 20.2057 2 17.9966C2 15.7874 3.79086 13.9966 6 13.9966C6.74181 13.9966 7.43645 14.1985 8.03197 14.5504L10.5858 11.9966L8.03197 9.44276C7.43645 9.79465 6.74181 9.99658 6 9.99658C3.79086 9.99658 2 8.20572 2 5.99658C2 3.78744 3.79086 1.99658 6 1.99658C8.20914 1.99658 10 3.78744 10 5.99658ZM8 5.99658C8 4.89201 7.10457 3.99658 6 3.99658C4.89543 3.99658 4 4.89201 4 5.99658C4 7.10115 4.89543 7.99658 6 7.99658C7.10457 7.99658 8 7.10115 8 5.99658ZM21.5563 20.1387C20.7753 20.9198 19.509 20.9198 18.7279 20.1387L13.4113 14.8221L14.8255 13.4079L21.5563 20.1387ZM16 10.9966H18V12.9966H16V10.9966ZM20 10.9966H22V12.9966H20V10.9966ZM6 10.9966H8V12.9966H6V10.9966ZM2 10.9966H4V12.9966H2V10.9966ZM6 19.9966C7.10457 19.9966 8 19.1012 8 17.9966C8 16.892 7.10457 15.9966 6 15.9966C4.89543 15.9966 4 16.892 4 17.9966C4 19.1012 4.89543 19.9966 6 19.9966Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3629c2b39eee05ff(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.68347 7.55873L12 9.87526L18.3744 3.50089C19.1554 2.71984 20.4217 2.71984 21.2028 3.50089L21.9099 4.208L9.68347 16.4344C9.88726 16.9144 10 17.4423 10 17.9966C10 20.2057 8.20914 21.9966 6 21.9966C3.79086 21.9966 2 20.2057 2 17.9966C2 15.7874 3.79086 13.9966 6 13.9966C6.55427 13.9966 7.08222 14.1093 7.56215 14.3131L9.87868 11.9966L7.56215 9.68005C7.08222 9.88385 6.55427 9.99658 6 9.99658C3.79086 9.99658 2 8.20572 2 5.99658C2 3.78744 3.79086 1.99658 6 1.99658C8.20914 1.99658 10 3.78744 10 5.99658C10 6.55086 9.88726 7.0788 9.68347 7.55873ZM6 7.99658C7.10457 7.99658 8 7.10115 8 5.99658C8 4.89201 7.10457 3.99658 6 3.99658C4.89543 3.99658 4 4.89201 4 5.99658C4 7.10115 4.89543 7.99658 6 7.99658ZM6 19.9966C7.10457 19.9966 8 19.1012 8 17.9966C8 16.892 7.10457 15.9966 6 15.9966C4.89543 15.9966 4 16.892 4 17.9966C4 19.1012 4.89543 19.9966 6 19.9966ZM15.5346 13.4099L21.9099 19.7852L21.2028 20.4923C20.4217 21.2733 19.1554 21.2733 18.3744 20.4923L13.4133 15.5312L15.5346 13.4099Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f7034076be1aa508(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.44618 8.02855L12 10.5824L18.7279 3.85445C19.509 3.0734 20.7753 3.0734 21.5563 3.85445L9.44618 15.9646C9.79807 16.5601 10 17.2548 10 17.9966C10 20.2057 8.20914 21.9966 6 21.9966C3.79086 21.9966 2 20.2057 2 17.9966C2 15.7874 3.79086 13.9966 6 13.9966C6.74181 13.9966 7.43645 14.1985 8.03197 14.5504L10.5858 11.9966L8.03197 9.44276C7.43645 9.79465 6.74181 9.99658 6 9.99658C3.79086 9.99658 2 8.20572 2 5.99658C2 3.78744 3.79086 1.99658 6 1.99658C8.20914 1.99658 10 3.78744 10 5.99658C10 6.73839 9.79807 7.43304 9.44618 8.02855ZM14.8255 13.4079L21.5563 20.1387C20.7753 20.9198 19.509 20.9198 18.7279 20.1387L13.4113 14.8221L14.8255 13.4079ZM7.41421 16.5824C7.05228 16.2204 6.55228 15.9966 6 15.9966C4.89543 15.9966 4 16.892 4 17.9966C4 19.1012 4.89543 19.9966 6 19.9966C7.10457 19.9966 8 19.1012 8 17.9966C8 17.4443 7.77614 16.9443 7.41421 16.5824ZM7.41421 7.4108C7.77614 7.04887 8 6.54887 8 5.99658C8 4.89201 7.10457 3.99658 6 3.99658C4.89543 3.99658 4 4.89201 4 5.99658C4 7.10115 4.89543 7.99658 6 7.99658C6.55228 7.99658 7.05228 7.77272 7.41421 7.4108Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$53d2029d8c6e558c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H5V5H3V3ZM7 3H9V5H7V3ZM11 3H13V5H11V3ZM15 3H17V5H15V3ZM19 3H21V5H19V3ZM19 7H21V9H19V7ZM3 19H5V21H3V19ZM3 15H5V17H3V15ZM3 11H5V13H3V11ZM3 7H5V9H3V7ZM10.6667 11L11.7031 9.4453C11.8886 9.1671 12.2008 9 12.5352 9H15.4648C15.7992 9 16.1114 9.1671 16.2969 9.4453L17.3333 11H20C20.5523 11 21 11.4477 21 12V20C21 20.5523 20.5523 21 20 21H8C7.44772 21 7 20.5523 7 20V12C7 11.4477 7.44772 11 8 11H10.6667ZM14 18C15.1046 18 16 17.1046 16 16C16 14.8954 15.1046 14 14 14C12.8954 14 12 14.8954 12 16C12 17.1046 12.8954 18 14 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d737ee32229f1f8e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H5V5H3V3ZM7 3H9V5H7V3ZM11 3H13V5H11V3ZM15 3H17V5H15V3ZM19 3H21V5H19V3ZM19 7H21V9H19V7ZM3 19H5V21H3V19ZM3 15H5V17H3V15ZM3 11H5V13H3V11ZM3 7H5V9H3V7ZM10.6667 11L11.7031 9.4453C11.8886 9.1671 12.2008 9 12.5352 9H15.4648C15.7992 9 16.1114 9.1671 16.2969 9.4453L17.3333 11H20C20.5523 11 21 11.4477 21 12V20C21 20.5523 20.5523 21 20 21H8C7.44772 21 7 20.5523 7 20V12C7 11.4477 7.44772 11 8 11H10.6667ZM9 19H19V13H16.263L14.9296 11H13.0704L11.737 13H9V19ZM14 18C12.8954 18 12 17.1046 12 16C12 14.8954 12.8954 14 14 14C15.1046 14 16 14.8954 16 16C16 17.1046 15.1046 18 14 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7d2788f7819225e7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9926 14.4068L10.4406 15.9587C10.7959 16.5563 11 17.2543 11 18C11 20.2091 9.20914 22 7 22C4.79086 22 3 20.2091 3 18C3 15.7909 4.79086 14 7 14C7.73792 14 8.42917 14.1998 9.0226 14.5483L10.5783 12.9926L7.45406 9.86827C6.86827 9.28249 6.86827 8.33274 7.45406 7.74695L7.80761 7.3934L11.9926 11.5783L16.1819 7.38904L16.5354 7.74259C17.1212 8.32838 17.1212 9.27813 16.5354 9.86391L13.4068 12.9926L14.968 14.5538C15.5635 14.2019 16.2582 14 17 14C19.2091 14 21 15.7909 21 18C21 20.2091 19.2091 22 17 22C14.7909 22 13 20.2091 13 18C13 17.2582 13.2019 16.5635 13.5538 15.968L11.9926 14.4068ZM19 13V5H5V13H3V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V13H19ZM7 20C8.10457 20 9 19.1046 9 18C9 16.8954 8.10457 16 7 16C5.89543 16 5 16.8954 5 18C5 19.1046 5.89543 20 7 20ZM17 20C18.1046 20 19 19.1046 19 18C19 16.8954 18.1046 16 17 16C15.8954 16 15 16.8954 15 18C15 19.1046 15.8954 20 17 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c1891dbf77c2bc9b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9926 14.4068L10.4406 15.9587C10.7959 16.5563 11 17.2543 11 18C11 20.2091 9.20914 22 7 22C4.79086 22 3 20.2091 3 18C3 15.7909 4.79086 14 7 14C7.73792 14 8.42917 14.1998 9.0226 14.5483L10.5783 12.9926L6.3934 8.80761L7.80761 7.3934L11.9926 11.5783L16.1819 7.38904L17.5961 8.80325L13.4068 12.9926L14.968 14.5538C15.5635 14.2019 16.2582 14 17 14C19.2091 14 21 15.7909 21 18C21 20.2091 19.2091 22 17 22C14.7909 22 13 20.2091 13 18C13 17.2582 13.2019 16.5635 13.5538 15.968L11.9926 14.4068ZM7 20C8.10457 20 9 19.1046 9 18C9 16.8954 8.10457 16 7 16C5.89543 16 5 16.8954 5 18C5 19.1046 5.89543 20 7 20ZM17 20C18.1046 20 19 19.1046 19 18C19 16.8954 18.1046 16 17 16C15.8954 16 15 16.8954 15 18C15 19.1046 15.8954 20 17 20ZM19 13V5H5V13H3V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V13H19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$403af54c42c4e402(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2H7V7H2V2ZM2 17H7V22H2V17ZM17 2H22V7H17V2ZM17 17H22V22H17V17ZM8 4H16V6H8V4ZM4 8H6V16H4V8ZM18 8H20V16H18V8ZM8 18H16V20H8V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$aaf0daf32d935cd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16H22V22H16V20H8V22H2V16H4V8H2V2H8V4H16V2H22V8H20V16ZM18 16V8H16V6H8V8H6V16H8V18H16V16H18ZM4 4V6H6V4H4ZM4 18V20H6V18H4ZM18 4V6H20V4H18ZM18 18V20H20V18H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f26c814c7d6908af(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8C3.34315 8 2 6.65685 2 5C2 3.34315 3.34315 2 5 2C6.65685 2 8 3.34315 8 5C8 6.65685 6.65685 8 5 8ZM19 8C17.3431 8 16 6.65685 16 5C16 3.34315 17.3431 2 19 2C20.6569 2 22 3.34315 22 5C22 6.65685 20.6569 8 19 8ZM19 22C17.3431 22 16 20.6569 16 19C16 17.3431 17.3431 16 19 16C20.6569 16 22 17.3431 22 19C22 20.6569 20.6569 22 19 22ZM5 22C3.34315 22 2 20.6569 2 19C2 17.3431 3.34315 16 5 16C6.65685 16 8 17.3431 8 19C8 20.6569 6.65685 22 5 22ZM9 4H15V6H9V4ZM9 18H15V20H9V18ZM4 9H6V15H4V9ZM18 9H20V15H18V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f3c9c8b024a94b3e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.82929 20C7.41746 21.1652 6.30622 22 5 22C3.34315 22 2 20.6569 2 19C2 17.6938 2.83481 16.5825 4 16.1707V7.82929C2.83481 7.41746 2 6.30622 2 5C2 3.34315 3.34315 2 5 2C6.30622 2 7.41746 2.83481 7.82929 4H16.1707C16.5825 2.83481 17.6938 2 19 2C20.6569 2 22 3.34315 22 5C22 6.30622 21.1652 7.41746 20 7.82929V16.1707C21.1652 16.5825 22 17.6938 22 19C22 20.6569 20.6569 22 19 22C17.6938 22 16.5825 21.1652 16.1707 20H7.82929ZM7.82929 18H16.1707C16.472 17.1476 17.1476 16.472 18 16.1707V7.82929C17.1476 7.52801 16.472 6.85241 16.1707 6H7.82929C7.52801 6.85241 6.85241 7.52801 6 7.82929V16.1707C6.85241 16.472 7.52801 17.1476 7.82929 18ZM5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6ZM19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5C18 5.55228 18.4477 6 19 6ZM19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20ZM5 20C5.55228 20 6 19.5523 6 19C6 18.4477 5.55228 18 5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dcf0083a362ad091(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9998 1L18 11H6L11.9998 1ZM13 13.5H21V21.5H13V13.5ZM6.75 22C9.37335 22 11.5 19.8734 11.5 17.25C11.5 14.6266 9.37335 12.5 6.75 12.5C4.12665 12.5 2 14.6266 2 17.25C2 19.8734 4.12665 22 6.75 22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7d01393e5aedbc5b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9998 1L6 11H18L11.9998 1ZM11.9998 4.8873L14.4676 9H9.53232L11.9998 4.8873ZM6.75 20C5.23122 20 4 18.7688 4 17.25C4 15.7312 5.23122 14.5 6.75 14.5C8.26878 14.5 9.5 15.7312 9.5 17.25C9.5 18.7688 8.26878 20 6.75 20ZM6.75 22C9.37335 22 11.5 19.8734 11.5 17.25C11.5 14.6266 9.37335 12.5 6.75 12.5C4.12665 12.5 2 14.6266 2 17.25C2 19.8734 4.12665 22 6.75 22ZM15 15.5V19.5H19V15.5H15ZM13 21.5V13.5H21V21.5H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$60d060421169e571(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9602 6.5012L16.7886 3.67278C17.1791 3.28225 17.8123 3.28225 18.2028 3.67278L20.3241 5.7941C20.7146 6.18462 20.7146 6.81779 20.3241 7.20831L17.4957 10.0367L19.2635 11.8045L17.8492 13.2187L10.7782 6.14765L12.1924 4.73344L13.9602 6.5012ZM10.7782 8.97608L15.0208 13.2187L7.24264 20.9969H3V16.7543L10.7782 8.97608Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3776ad1384eae8bf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.45711 18.954L15.0208 10.3903L13.6066 8.97608L5.04289 17.5398L6.45711 18.954ZM12.1924 7.56186L10.7782 6.14765L12.1924 4.73344L13.9602 6.5012L16.7886 3.67278C17.1791 3.28225 17.8123 3.28225 18.2028 3.67278L20.3241 5.7941C20.7146 6.18462 20.7146 6.81779 20.3241 7.20831L17.4957 10.0367L19.2635 11.8045L17.8492 13.2187L16.435 11.8045L7.24264 20.9969H3V16.7543L12.1924 7.56186Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cc51565243cc672a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.7678 12.2289L15.8892 14.3502C11.293 18.9464 5.63612 20.3606 2.10059 19.6535L17.6569 4.09717L19.7783 6.21849L13.7678 12.2289Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ba1b5200905a3882(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.6909 12.9146L17.4587 14.6823C11.4482 20.6927 6.4985 20.6927 2.25586 19.2785L17.8122 3.72217L21.3477 7.2577L15.6909 12.9146ZM12.8625 12.9146L18.5193 7.2577L17.8122 6.55059L6.3145 18.0483C9.04606 18.1557 11.6722 17.1419 14.5808 14.6329L12.8625 12.9146Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bce1a108697417d3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$df9ee278108d6170(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e587aa7b324d0db(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8H7V10H11V17H13V10H17V8ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f66a31122fae9bbf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5V19H19V5H5ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM13 10V17H11V10H7V8H17V10H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2e066da53abeb7f7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14V3H3C2.44772 3 2 3.44772 2 4V14H7ZM15 14V3H9V14H15ZM22 14V4C22 3.44772 21.5523 3 21 3H17V14H22ZM21 21C21.5523 21 22 20.5523 22 20V16H2V20C2 20.5523 2.44772 21 3 21H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9f2da15e93fc6d1b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 16H4V19H20V16ZM8 5H4V14H8V5ZM14 5H10V14H14V5ZM20 5H16V14H20V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d7763124fdbd9c48(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21H9V10H15V21ZM17 21V10H22V20C22 20.5523 21.5523 21 21 21H17ZM7 21H3C2.44772 21 2 20.5523 2 20V10H7V21ZM22 8H2V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9799e7308b65b6f2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H20V5H4V8ZM14 19V10H10V19H14ZM16 19H20V10H16V19ZM8 19V10H4V19H8ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$35eb6cbdb619d8f9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.32894 3.27158C6.56203 2.8332 7.99181 3.10749 8.97878 4.09446C9.96603 5.08171 10.2402 6.51202 9.80129 7.74535L20.646 18.5902L18.5247 20.7115L7.67887 9.86709C6.44578 10.3055 5.016 10.0312 4.02903 9.04421C3.04178 8.05696 2.76761 6.62665 3.20652 5.39332L5.44325 7.63C6.02903 8.21578 6.97878 8.21578 7.56457 7.63C8.15035 7.04421 8.15035 6.09446 7.56457 5.50868L5.32894 3.27158ZM15.6963 5.15512L18.8783 3.38736L20.2925 4.80157L18.5247 7.98355L16.757 8.3371L14.6356 10.4584L13.2214 9.04421L15.3427 6.92289L15.6963 5.15512ZM8.62523 12.9333L10.7465 15.0546L5.7968 20.0044C5.21101 20.5902 4.26127 20.5902 3.67548 20.0044C3.12415 19.453 3.09172 18.5793 3.57819 17.99L3.67548 17.883L8.62523 12.9333Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1fa1d0956e9ed1c0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.32894 3.27158C6.56203 2.8332 7.99181 3.10749 8.97878 4.09446C10.0997 5.21537 10.3014 6.90741 9.58382 8.23385L20.2925 18.9437L18.8783 20.3579L8.16933 9.64875C6.84277 10.3669 5.1502 10.1654 4.02903 9.04421C3.04178 8.05696 2.76761 6.62665 3.20652 5.39332L5.44325 7.63C6.02903 8.21578 6.97878 8.21578 7.56457 7.63C8.15035 7.04421 8.15035 6.09446 7.56457 5.50868L5.32894 3.27158ZM15.6963 5.15512L18.8783 3.38736L20.2925 4.80157L18.5247 7.98355L16.757 8.3371L14.6356 10.4584L13.2214 9.04421L15.3427 6.92289L15.6963 5.15512ZM8.97878 13.2868L10.393 14.7011L5.08969 20.0044C4.69917 20.3949 4.066 20.3949 3.67548 20.0044C3.31285 19.6417 3.28695 19.0699 3.59777 18.6774L3.67548 18.5902L8.97878 13.2868Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d6da1b792363bab3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$69fc469eaefa4146(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM4.20568 19.0002H19.7941L11.9999 5.50017L4.20568 19.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$461dbdde66537bb4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18V14.3C4 13.4716 3.32843 12.8 2.5 12.8H2V11.2H2.5C3.32843 11.2 4 10.5284 4 9.7V6C4 4.34315 5.34315 3 7 3H8V5H7C6.44772 5 6 5.44772 6 6V10.1C6 10.9858 5.42408 11.7372 4.62623 12C5.42408 12.2628 6 13.0142 6 13.9V18C6 18.5523 6.44772 19 7 19H8V21H7C5.34315 21 4 19.6569 4 18ZM20 14.3V18C20 19.6569 18.6569 21 17 21H16V19H17C17.5523 19 18 18.5523 18 18V13.9C18 13.0142 18.5759 12.2628 19.3738 12C18.5759 11.7372 18 10.9858 18 10.1V6C18 5.44772 17.5523 5 17 5H16V3H17C18.6569 3 20 4.34315 20 6V9.7C20 10.5284 20.6716 11.2 21.5 11.2H22V12.8H21.5C20.6716 12.8 20 13.4716 20 14.3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b144e83dd3e4be05(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18V14.3C4 13.4716 3.32843 12.8 2.5 12.8H2V11.2H2.5C3.32843 11.2 4 10.5284 4 9.7V6C4 4.34315 5.34315 3 7 3H8V5H7C6.44772 5 6 5.44772 6 6V10.1C6 10.9858 5.42408 11.7372 4.62623 12C5.42408 12.2628 6 13.0142 6 13.9V18C6 18.5523 6.44772 19 7 19H8V21H7C5.34315 21 4 19.6569 4 18ZM20 14.3V18C20 19.6569 18.6569 21 17 21H16V19H17C17.5523 19 18 18.5523 18 18V13.9C18 13.0142 18.5759 12.2628 19.3738 12C18.5759 11.7372 18 10.9858 18 10.1V6C18 5.44772 17.5523 5 17 5H16V3H17C18.6569 3 20 4.34315 20 6V9.7C20 10.5284 20.6716 11.2 21.5 11.2H22V12.8H21.5C20.6716 12.8 20 13.4716 20 14.3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ffde0e579c539b3d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3V5H6V19H9V21H4V3H9ZM15 3H20V21H15V19H18V5H15V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$381f59e886b9ef19(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3V5H6V19H9V21H4V3H9ZM15 3H20V21H15V19H18V5H15V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ac0f5606d6192c6c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.07089 15.9999C5.02417 15.6733 5 15.3394 5 14.9999V13.9999H3V11.9999H5V10.9999C5 10.6604 5.02417 10.3265 5.07089 9.99989H3V7.99989H5.67363C6.28647 6.70984 7.28227 5.63698 8.51412 4.92822L7.46447 3.87857L8.87868 2.46436L10.5621 4.14773C11.0262 4.05083 11.5071 3.99989 12 3.99989C12.4929 3.99989 12.9738 4.05083 13.4379 4.14773L15.1213 2.46436L16.5355 3.87857L15.4859 4.92822C16.7177 5.63698 17.7135 6.70984 18.3264 7.99989H21V9.99989H18.9291C18.9758 10.3265 19 10.6604 19 10.9999V11.9999H21V13.9999H19V14.9999C19 15.3394 18.9758 15.6733 18.9291 15.9999H21V17.9999H18.3264C17.2029 20.3648 14.7924 21.9999 12 21.9999C9.2076 21.9999 6.7971 20.3648 5.67363 17.9999H3V15.9999H5.07089ZM9 9.99989V11.9999H15V9.99989H9ZM9 13.9999V15.9999H15V13.9999H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a4a140326c4301fc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5621 4.14773C11.0262 4.05083 11.5071 3.99989 12 3.99989C12.4929 3.99989 12.9738 4.05083 13.4379 4.14773L15.1213 2.46436L16.5355 3.87857L15.4859 4.92822C16.7177 5.63698 17.7135 6.70984 18.3264 7.99989H21V9.99989H18.9291C18.9758 10.3265 19 10.6604 19 10.9999V11.9999H21V13.9999H19V14.9999C19 15.3394 18.9758 15.6733 18.9291 15.9999H21V17.9999H18.3264C17.2029 20.3648 14.7924 21.9999 12 21.9999C9.2076 21.9999 6.7971 20.3648 5.67363 17.9999H3V15.9999H5.07089C5.02417 15.6733 5 15.3394 5 14.9999V13.9999H3V11.9999H5V10.9999C5 10.6604 5.02417 10.3265 5.07089 9.99989H3V7.99989H5.67363C6.28647 6.70984 7.28227 5.63698 8.51412 4.92822L7.46447 3.87857L8.87868 2.46436L10.5621 4.14773ZM12 5.99989C9.23858 5.99989 7 8.23847 7 10.9999V14.9999C7 17.7613 9.23858 19.9999 12 19.9999C14.7614 19.9999 17 17.7613 17 14.9999V10.9999C17 8.23847 14.7614 5.99989 12 5.99989ZM9 13.9999H15V15.9999H9V13.9999ZM9 9.99989H15V11.9999H9V9.99989Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$780cdd35cacd4eb3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.05636 8.30049C6.11995 8.19854 6.18609 8.09835 6.25469 8H17.7453C17.8139 8.09835 17.88 8.19854 17.9436 8.30049L19.9641 7.13397L20.9641 8.86602L18.7512 10.1436C18.9134 10.7348 19 11.3573 19 12V13H22V15H19C19 15.9534 18.8094 16.8623 18.4642 17.6907L20.9641 19.134L19.9641 20.866L17.4383 19.4077C16.3533 20.7447 14.7853 21.6737 13 21.9291V14H11V21.9291C9.21467 21.6737 7.64665 20.7447 6.56171 19.4077L4.0359 20.866L3.0359 19.134L5.5358 17.6907C5.19061 16.8623 5 15.9534 5 15H2V13H5V12C5 11.3573 5.08661 10.7348 5.2488 10.1436L3.0359 8.86602L4.0359 7.13397L6.05636 8.30049ZM8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$631b8a5262ebc8b5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 19.9C15.2822 19.4367 17 17.419 17 15V12C17 11.299 16.8564 10.6219 16.5846 10H7.41538C7.14358 10.6219 7 11.299 7 12V15C7 17.419 8.71776 19.4367 11 19.9V14H13V19.9ZM5.5358 17.6907C5.19061 16.8623 5 15.9534 5 15H2V13H5V12C5 11.3573 5.08661 10.7348 5.2488 10.1436L3.0359 8.86602L4.0359 7.13397L6.05636 8.30049C6.11995 8.19854 6.18609 8.09835 6.25469 8H17.7453C17.8139 8.09835 17.88 8.19854 17.9436 8.30049L19.9641 7.13397L20.9641 8.86602L18.7512 10.1436C18.9134 10.7348 19 11.3573 19 12V13H22V15H19C19 15.9534 18.8094 16.8623 18.4642 17.6907L20.9641 19.134L19.9641 20.866L17.4383 19.4077C16.1549 20.9893 14.1955 22 12 22C9.80453 22 7.84512 20.9893 6.56171 19.4077L4.0359 20.866L3.0359 19.134L5.5358 17.6907ZM8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ef6130ab78531a47(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM16.4645 15.5355L20 12L16.4645 8.46447L15.0503 9.87868L17.1716 12L15.0503 14.1213L16.4645 15.5355ZM6.82843 12L8.94975 9.87868L7.53553 8.46447L4 12L7.53553 15.5355L8.94975 14.1213L6.82843 12ZM11.2443 17L14.884 7H12.7557L9.11597 17H11.2443Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c390a7ed81ccd784(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM4 5V19H20V5H4ZM20 12L16.4645 15.5355L15.0503 14.1213L17.1716 12L15.0503 9.87868L16.4645 8.46447L20 12ZM6.82843 12L8.94975 14.1213L7.53553 15.5355L4 12L7.53553 8.46447L8.94975 9.87868L6.82843 12ZM11.2443 17H9.11597L12.7557 7H14.884L11.2443 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4fc699670ee314fe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 11.9998L15.9289 19.0708L14.5147 17.6566L20.1716 11.9998L14.5147 6.34292L15.9289 4.92871L23 11.9998ZM3.82843 11.9998L9.48528 17.6566L8.07107 19.0708L1 11.9998L8.07107 4.92871L9.48528 6.34292L3.82843 11.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ba65516135f12962(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 11.9998L15.9289 19.0708L14.5147 17.6566L20.1716 11.9998L14.5147 6.34292L15.9289 4.92871L23 11.9998ZM3.82843 11.9998L9.48528 17.6566L8.07107 19.0708L1 11.9998L8.07107 4.92871L9.48528 6.34292L3.82843 11.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4de1546458c57092(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 12.0001L18.3431 17.657L16.9289 16.2428L21.1716 12.0001L16.9289 7.75748L18.3431 6.34326L24 12.0001ZM2.82843 12.0001L7.07107 16.2428L5.65685 17.657L0 12.0001L5.65685 6.34326L7.07107 7.75748L2.82843 12.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$995c9b3cfb36fbef(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 12.0001L18.3431 17.657L16.9289 16.2428L21.1716 12.0001L16.9289 7.75748L18.3431 6.34326L24 12.0001ZM2.82843 12.0001L7.07107 16.2428L5.65685 17.657L0 12.0001L5.65685 6.34326L7.07107 7.75748L2.82843 12.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e96f53bf5699cf2e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 12L18.3431 17.6569L16.9289 16.2426L21.1716 12L16.9289 7.75736L18.3431 6.34315L24 12ZM2.82843 12L7.07107 16.2426L5.65685 17.6569L0 12L5.65685 6.34315L7.07107 7.75736L2.82843 12ZM9.78845 21H7.66009L14.2116 3H16.3399L9.78845 21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$66651acc84de9194(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 12L18.3431 17.6569L16.9289 16.2426L21.1716 12L16.9289 7.75736L18.3431 6.34315L24 12ZM2.82843 12L7.07107 16.2426L5.65685 17.6569L0 12L5.65685 6.34315L7.07107 7.75736L2.82843 12ZM9.78845 21H7.66009L14.2116 3H16.3399L9.78845 21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4c121154e53586b7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8H14V6.5C14 4.567 15.567 3 17.5 3C19.433 3 21 4.567 21 6.5C21 8.433 19.433 10 17.5 10H16V14H17.5C19.433 14 21 15.567 21 17.5C21 19.433 19.433 21 17.5 21C15.567 21 14 19.433 14 17.5V16H10V17.5C10 19.433 8.433 21 6.5 21C4.567 21 3 19.433 3 17.5C3 15.567 4.567 14 6.5 14H8V10H6.5C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5V8ZM8 8V6.5C8 5.67157 7.32843 5 6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8H8ZM8 16H6.5C5.67157 16 5 16.6716 5 17.5C5 18.3284 5.67157 19 6.5 19C7.32843 19 8 18.3284 8 17.5V16ZM16 8H17.5C18.3284 8 19 7.32843 19 6.5C19 5.67157 18.3284 5 17.5 5C16.6716 5 16 5.67157 16 6.5V8ZM16 16V17.5C16 18.3284 16.6716 19 17.5 19C18.3284 19 19 18.3284 19 17.5C19 16.6716 18.3284 16 17.5 16H16ZM10 10V14H14V10H10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7f4b4e0671054fb3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8H14V6.5C14 4.567 15.567 3 17.5 3C19.433 3 21 4.567 21 6.5C21 8.433 19.433 10 17.5 10H16V14H17.5C19.433 14 21 15.567 21 17.5C21 19.433 19.433 21 17.5 21C15.567 21 14 19.433 14 17.5V16H10V17.5C10 19.433 8.433 21 6.5 21C4.567 21 3 19.433 3 17.5C3 15.567 4.567 14 6.5 14H8V10H6.5C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5V8ZM8 8V6.5C8 5.67157 7.32843 5 6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8H8ZM8 16H6.5C5.67157 16 5 16.6716 5 17.5C5 18.3284 5.67157 19 6.5 19C7.32843 19 8 18.3284 8 17.5V16ZM16 8H17.5C18.3284 8 19 7.32843 19 6.5C19 5.67157 18.3284 5 17.5 5C16.6716 5 16 5.67157 16 6.5V8ZM16 16V17.5C16 18.3284 16.6716 19 17.5 19C18.3284 19 19 18.3284 19 17.5C19 16.6716 18.3284 16 17.5 16H16ZM10 10V14H14V10H10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7e0a3e40ed2ece95(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.00055 3L4.35055 6.34H17.9405L17.5005 8.5H3.92055L3.26055 11.83H16.8505L16.0905 15.64L10.6105 17.45L5.86055 15.64L6.19055 14H2.85055L2.06055 18L9.91055 21L18.9605 18L20.1605 11.97L20.4005 10.76L21.9405 3H5.00055Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$35392ff7713194da(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.8 14H4.83961L4.2947 16.7245L10.0393 18.8787L17.2665 16.4697L18.3604 11H3.4L3.8 9H18.7604L19.5604 5H4.6L5 3H22L19 18L10 21L2 18L2.8 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ed5a92540011fd6e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9093 12.3604L17.0007 20.8538L14.1816 21.8799L11.0902 13.3865L6.91797 16.5423L8.4087 1.6333L19.134 12.096L13.9093 12.3604Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8e01a2c6dc440e7c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.3873 13.4977L17.9403 20.5118L13.2418 22.2219L10.6889 15.2078L6.79004 17.653L8.4086 1.6333L19.9457 12.8647L15.3873 13.4977ZM15.3768 19.3165L12.6618 11.8569L15.6212 11.446L9.98201 5.95622L9.19088 13.7864L11.7221 12.1989L14.4371 19.6585L15.3768 19.3165Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b5e361f328de7384(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.10508 15.2101C8.21506 15.6501 9 16.7334 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929C3.83481 8.41746 3 7.30622 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.30622 8.16519 8.41746 7 8.82929V11.9996C7.83566 11.3719 8.87439 11 10 11H14C15.3835 11 16.5482 10.0635 16.8949 8.78991C15.7849 8.34988 15 7.26661 15 6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6C21 7.3332 20.1303 8.46329 18.9274 8.85392C18.5222 11.2085 16.4703 13 14 13H10C8.61653 13 7.45179 13.9365 7.10508 15.2101Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ef1a53919027d98(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.10508 15.2101C8.21506 15.6501 9 16.7334 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929C3.83481 8.41746 3 7.30622 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.30622 8.16519 8.41746 7 8.82929V11.9996C7.83566 11.3719 8.87439 11 10 11H14C15.3835 11 16.5482 10.0635 16.8949 8.78991C15.7849 8.34988 15 7.26661 15 6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6C21 7.3332 20.1303 8.46329 18.9274 8.85392C18.5222 11.2085 16.4703 13 14 13H10C8.61653 13 7.45179 13.9365 7.10508 15.2101ZM6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17ZM6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5ZM18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9333e6a1ae545a20(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.30622 8.16519 8.41746 7 8.82929V15.1707C8.16519 15.5825 9 16.6938 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929C3.83481 8.41746 3 7.30622 3 6ZM15.2929 3.29289C15.6834 2.90237 16.3166 2.90237 16.7071 3.29289L18 4.58579L19.2929 3.29289C19.6834 2.90237 20.3166 2.90237 20.7071 3.29289C21.0976 3.68342 21.0976 4.31658 20.7071 4.70711L19.4142 6L20.7071 7.29289C21.0976 7.68342 21.0976 8.31658 20.7071 8.70711C20.3166 9.09763 19.6834 9.09763 19.2929 8.70711L18 7.41421L16.7071 8.70711C16.3166 9.09763 15.6834 9.09763 15.2929 8.70711C14.9024 8.31658 14.9024 7.68342 15.2929 7.29289L16.5858 6L15.2929 4.70711C14.9024 4.31658 14.9024 3.68342 15.2929 3.29289ZM18 10C18.5523 10 19 10.4477 19 11V15.1707C20.1652 15.5825 21 16.6938 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.6938 15.8348 15.5825 17 15.1707V11C17 10.4477 17.4477 10 18 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fffc8833557f70c9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5ZM3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.30622 8.16519 8.41746 7 8.82929V15.1707C8.16519 15.5825 9 16.6938 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929C3.83481 8.41746 3 7.30622 3 6ZM15.2929 3.29289C15.6834 2.90237 16.3166 2.90237 16.7071 3.29289L18 4.58579L19.2929 3.29289C19.6834 2.90237 20.3166 2.90237 20.7071 3.29289C21.0976 3.68342 21.0976 4.31658 20.7071 4.70711L19.4142 6L20.7071 7.29289C21.0976 7.68342 21.0976 8.31658 20.7071 8.70711C20.3166 9.09763 19.6834 9.09763 19.2929 8.70711L18 7.41421L16.7071 8.70711C16.3166 9.09763 15.6834 9.09763 15.2929 8.70711C14.9024 8.31658 14.9024 7.68342 15.2929 7.29289L16.5858 6L15.2929 4.70711C14.9024 4.31658 14.9024 3.68342 15.2929 3.29289ZM18 10C18.5523 10 19 10.4477 19 11V15.1707C20.1652 15.5825 21 16.6938 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.6938 15.8348 15.5825 17 15.1707V11C17 10.4477 17.4477 10 18 10ZM6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17ZM18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$150e794bd7497f0a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.874 13C15.4299 14.7252 13.8638 16 12 16C10.1362 16 8.57006 14.7252 8.12602 13H3V11H8.12602C8.57006 9.27477 10.1362 8 12 8C13.8638 8 15.4299 9.27477 15.874 11H21V13H15.874Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dae61f2697da777f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.874 13C15.4299 14.7252 13.8638 16 12 16C10.1362 16 8.57006 14.7252 8.12602 13H3V11H8.12602C8.57006 9.27477 10.1362 8 12 8C13.8638 8 15.4299 9.27477 15.874 11H21V13H15.874ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c791d5ebaba2caad(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.10508 8.78991C7.45179 10.0635 8.61653 11 10 11H14C16.4703 11 18.5222 12.7915 18.9274 15.1461C20.1303 15.5367 21 16.6668 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.7334 15.7849 15.6501 16.8949 15.2101C16.5482 13.9365 15.3835 13 14 13H10C8.87439 13 7.83566 12.6281 7 12.0004V15.1707C8.16519 15.5825 9 16.6938 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929C3.83481 8.41746 3 7.30622 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.26661 8.21506 8.34988 7.10508 8.78991Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$49275e6706b038f9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.10508 8.78991C7.45179 10.0635 8.61653 11 10 11H14C16.4703 11 18.5222 12.7915 18.9274 15.1461C20.1303 15.5367 21 16.6668 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.7334 15.7849 15.6501 16.8949 15.2101C16.5482 13.9365 15.3835 13 14 13H10C8.87439 13 7.83566 12.6281 7 12.0004V15.1707C8.16519 15.5825 9 16.6938 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929C3.83481 8.41746 3 7.30622 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.26661 8.21506 8.34988 7.10508 8.78991ZM6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7ZM6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19ZM18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$edcd52d63bdc13a7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5H17C18.1046 5 19 5.89543 19 7V15.1707C20.1652 15.5825 21 16.6938 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.6938 15.8348 15.5825 17 15.1707V7H15V10L10.5 6L15 2V5ZM5 8.82929C3.83481 8.41746 3 7.30622 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.30622 8.16519 8.41746 7 8.82929V15.1707C8.16519 15.5825 9 16.6938 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7f009cc5911b38ae(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5H17C18.1046 5 19 5.89543 19 7V15.1707C20.1652 15.5825 21 16.6938 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.6938 15.8348 15.5825 17 15.1707V7H15V10L10.5 6L15 2V5ZM5 8.82929C3.83481 8.41746 3 7.30622 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.30622 8.16519 8.41746 7 8.82929V15.1707C8.16519 15.5825 9 16.6938 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929ZM6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7ZM6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19ZM18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d4de51b935318dc5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17V23H12V17H9L13 12L17 17H14ZM16 19H19V16H18.2L13 9.5L7.64706 16H6.5C5.67157 16 5 16.6716 5 17.5C5 18.3284 5.67157 19 6.5 19H10V21H6.5C4.567 21 3 19.433 3 17.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V20C21 20.5523 20.5523 21 20 21H16V19ZM7 5V7H9V5H7ZM7 8V10H9V8H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2f6960c25946c77e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16V14H19V4H6V14.0354C6.1633 14.0121 6.33024 14 6.5 14H8V16H6.5C5.67157 16 5 16.6716 5 17.5C5 18.3284 5.67157 19 6.5 19H10V21H6.5C4.567 21 3 19.433 3 17.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V20C21 20.5523 20.5523 21 20 21H16V19H19V16H18ZM7 5H9V7H7V5ZM7 8H9V10H7V8ZM14 17V23H12V17H9L13 12L17 17H14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$73f3653f46eba835(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 21V23.5L10 21.5L7 23.5V21H6.5C4.567 21 3 19.433 3 17.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V20C21 20.5523 20.5523 21 20 21H13ZM7 19V17H13V19H19V16H6.5C5.67157 16 5 16.6716 5 17.5C5 18.3284 5.67157 19 6.5 19H7ZM7 5V7H9V5H7ZM7 8V10H9V8H7ZM7 11V13H9V11H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$999221d0c89d74(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 21V23.5L10 21.5L7 23.5V21H6.5C4.567 21 3 19.433 3 17.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V20C21 20.5523 20.5523 21 20 21H13ZM13 19H19V16H6.5C5.67157 16 5 16.6716 5 17.5C5 18.3284 5.67157 19 6.5 19H7V17H13V19ZM19 14V4H6V14.0354C6.1633 14.0121 6.33024 14 6.5 14H19ZM7 5H9V7H7V5ZM7 8H9V10H7V8ZM7 11H9V13H7V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$442e775ed1c6836a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8ZM16 8V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8H16ZM7 11V13H9V11H7ZM7 14V16H9V14H7ZM7 17V19H9V17H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d7ca3db390dca65a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10V20H19V10H6ZM18 8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8ZM16 8V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8H16ZM7 11H9V13H7V11ZM7 14H9V16H7V14ZM7 17H9V19H7V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f19cb917c8a4c77b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18.1778L16.6192 16.9222L17.2434 10.1444H9.02648L8.82219 7.88889H17.4477L17.6747 5.67778H6.32535L6.96091 12.3556H14.7806L14.5195 15.2222L12 15.8889L9.48045 15.2222L9.32156 13.3778H7.0517L7.38083 16.9222L12 18.1778ZM3 2H21L19.377 20L12 22L4.62295 20L3 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9d8c9f351c10d5f6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18.1778L7.38083 16.9222L7.0517 13.3778H9.32156L9.48045 15.2222L12 15.8889L14.5195 15.2222L14.7806 12.3556H6.96091L6.32535 5.67778H17.6747L17.4477 7.88889H8.82219L9.02648 10.1444H17.2434L16.6192 16.9222L12 18.1778ZM3 2H21L19.377 20L12 22L4.62295 20L3 2ZM5.18844 4L6.48986 18.4339L12 19.9278L17.5101 18.4339L18.8116 4H5.18844Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6afa49c9b6b8671a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6ZM13.3344 16.055C14.0531 16.6343 14.7717 16.9203 15.4904 16.913C15.9304 16.913 16.2677 16.8323 16.5024 16.671C16.7297 16.517 16.8434 16.297 16.8434 16.011C16.8434 15.7177 16.7297 15.4683 16.5024 15.263C16.2677 15.0577 15.8241 14.8523 15.1714 14.647C14.3867 14.4197 13.7817 14.1263 13.3564 13.767C12.9384 13.4077 12.7257 12.9053 12.7184 12.26C12.7184 11.6513 12.9824 11.1417 13.5104 10.731C14.0237 10.3203 14.6801 10.115 15.4794 10.115C16.5941 10.115 17.4887 10.3863 18.1634 10.929L17.3934 12.128C17.1221 11.9153 16.8104 11.7613 16.4584 11.666C16.1064 11.556 15.7911 11.501 15.5124 11.501C15.1311 11.501 14.8267 11.5707 14.5994 11.71C14.3721 11.8493 14.2584 12.0327 14.2584 12.26C14.2584 12.5093 14.3977 12.722 14.6764 12.898C14.9551 13.0667 15.4317 13.2537 16.1064 13.459C16.9204 13.701 17.4997 14.0237 17.8444 14.427C18.1891 14.8303 18.3614 15.3437 18.3614 15.967C18.3614 16.605 18.1157 17.155 17.6244 17.617C17.1404 18.0717 16.4364 18.31 15.5124 18.332C14.3024 18.332 13.2904 17.969 12.4764 17.243L13.3344 16.055ZM7.80405 16.693C8.03872 16.8397 8.32105 16.913 8.65105 16.913C8.99572 16.913 9.28172 16.814 9.50905 16.616C9.73639 16.4107 9.85005 16.055 9.85005 15.549V10.247H11.3351V15.835C11.3131 16.7003 11.0637 17.3237 10.5871 17.705C10.3157 17.9323 10.0187 18.0937 9.69605 18.189C9.37339 18.2843 9.06172 18.332 8.76105 18.332C8.21105 18.332 7.72339 18.2367 7.29805 18.046C6.84339 17.8407 6.46205 17.4777 6.15405 16.957L7.18805 16.11C7.37872 16.3667 7.58405 16.561 7.80405 16.693Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$727d4552f78c29a1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.3344 16.055 12.4764 17.243C13.2904 17.969 14.3024 18.332 15.5124 18.332 16.4364 18.31 17.1404 18.0717 17.6244 17.617 18.1157 17.155 18.3614 16.605 18.3614 15.967 18.3614 15.3437 18.1891 14.8303 17.8444 14.427 17.4997 14.0237 16.9204 13.701 16.1064 13.459 15.4317 13.2537 14.9551 13.0667 14.6764 12.898 14.3977 12.722 14.2584 12.5093 14.2584 12.26 14.2584 12.0327 14.3721 11.8493 14.5994 11.71 14.8267 11.5707 15.1311 11.501 15.5124 11.501 15.7911 11.501 16.1064 11.556 16.4584 11.666 16.8104 11.7613 17.1221 11.9153 17.3934 12.128L18.1634 10.929C17.4887 10.3863 16.5941 10.115 15.4794 10.115 14.6801 10.115 14.0237 10.3203 13.5104 10.731 12.9824 11.1417 12.7184 11.6513 12.7184 12.26 12.7257 12.9053 12.9384 13.4077 13.3564 13.767 13.7817 14.1263 14.3867 14.4197 15.1714 14.647 15.8241 14.8523 16.2677 15.0577 16.5024 15.263 16.7297 15.4683 16.8434 15.7177 16.8434 16.011 16.8434 16.297 16.7297 16.517 16.5024 16.671 16.2677 16.8323 15.9304 16.913 15.4904 16.913 14.7717 16.9203 14.0531 16.6343 13.3344 16.055ZM7.80405 16.693C7.58405 16.561 7.37872 16.3667 7.18805 16.11L6.15405 16.957C6.46205 17.4777 6.84339 17.8407 7.29805 18.046 7.72339 18.2367 8.21105 18.332 8.76105 18.332 9.06172 18.332 9.37339 18.2843 9.69605 18.189 10.0187 18.0937 10.3157 17.9323 10.5871 17.705 11.0637 17.3237 11.3131 16.7003 11.3351 15.835V10.247H9.85005V15.549C9.85005 16.055 9.73639 16.4107 9.50905 16.616 9.28172 16.814 8.99572 16.913 8.65105 16.913 8.32105 16.913 8.03872 16.8397 7.80405 16.693ZM3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM6 5C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V6C19 5.44772 18.5523 5 18 5H6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$36cd3e1c8267d703(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.92316 21C5.11268 18.6642 4 15.493 4 12C4 8.50702 5.11268 5.33579 6.92316 3H8.93729C7.23506 5.3884 6.2 8.54241 6.2 12C6.2 15.4576 7.23506 18.6116 8.93729 21H6.92316ZM17.0741 21H15.06C16.7622 18.6116 17.7973 15.4576 17.7973 12C17.7973 8.54241 16.7622 5.3884 15.06 3H17.0741C18.8846 5.33579 19.9973 8.50702 19.9973 12C19.9973 15.493 18.8846 18.6642 17.0741 21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f27ba6fa4ba08112(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.92316 21C5.11268 18.6642 4 15.493 4 12C4 8.50702 5.11268 5.33579 6.92316 3H8.93729C7.23506 5.3884 6.2 8.54241 6.2 12C6.2 15.4576 7.23506 18.6116 8.93729 21H6.92316ZM17.0741 21H15.06C16.7622 18.6116 17.7973 15.4576 17.7973 12C17.7973 8.54241 16.7622 5.3884 15.06 3H17.0741C18.8846 5.33579 19.9973 8.50702 19.9973 12C19.9973 15.493 18.8846 18.6642 17.0741 21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b4fd3f98d69547f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM12 15V17H18V15H12ZM8.41421 12L5.58579 14.8284L7 16.2426L11.2426 12L7 7.75736L5.58579 9.17157L8.41421 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$53c2b1a97182487f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM4 5V19H20V5H4ZM12 15H18V17H12V15ZM8.66685 12L5.83842 9.17157L7.25264 7.75736L11.4953 12L7.25264 16.2426L5.83842 14.8284L8.66685 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a29fde64e39547ed(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9999 11.9998L3.92886 19.0708L2.51465 17.6566L8.1715 11.9998L2.51465 6.34292L3.92886 4.92871L10.9999 11.9998ZM10.9999 18.9998H20.9999V20.9998H10.9999V18.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f1507c2e6e61163b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9999 11.9998L3.92886 19.0708L2.51465 17.6566L8.1715 11.9998L2.51465 6.34292L3.92886 4.92871L10.9999 11.9998ZM10.9999 18.9998H20.9999V20.9998H10.9999V18.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e7808e19405778d5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10H4V19H20V10ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM5 6V8H7V6H5ZM9 6V8H11V6H9ZM5 11H8V16H5V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2631ab5d2bf85fd7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9V5H4V9H20ZM20 11H4V19H20V11ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM5 12H8V17H5V12ZM5 6H7V8H5V6ZM9 6H11V8H9V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5f222d29ef31d879(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4 13.5333L17.4 20.2C17.5657 20.4209 17.5209 20.7343 17.3 20.9C17.2135 20.9649 17.1082 21 17 21H7C6.72386 21 6.5 20.7761 6.5 20.5C6.5 20.3918 6.53509 20.2865 6.6 20.2L11.6 13.5333C11.7657 13.3124 12.0791 13.2676 12.3 13.4333C12.3379 13.4618 12.3716 13.4954 12.4 13.5333ZM18 19V17H20V5H4V17H6V19H2.9918C2.44405 19 2 18.5554 2 17.9991V4.00087C2 3.44811 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44463 22 4.00087V17.9991C22 18.5519 21.5447 19 21.0082 19H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$44c2b48a47850ebd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4 13.5333L17.4 20.2C17.5657 20.4209 17.5209 20.7343 17.3 20.9C17.2135 20.9649 17.1082 21 17 21H7C6.72386 21 6.5 20.7761 6.5 20.5C6.5 20.3918 6.53509 20.2865 6.6 20.2L11.6 13.5333C11.7657 13.3124 12.0791 13.2676 12.3 13.4333C12.3379 13.4618 12.3716 13.4954 12.4 13.5333ZM12 16.33L10 19H14L12 16.33ZM18 19V17H20V5H4V17H6V19H2.9918C2.44405 19 2 18.5554 2 17.9991V4.00087C2 3.44811 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44463 22 4.00087V17.9991C22 18.5519 21.5447 19 21.0082 19H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f85a128c3c031fb0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM6 7V17H9V7H6ZM10 7V17H12V7H10ZM13 7V17H14V7H13ZM15 7V17H18V7H15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5ce8141d464f1bb3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5V19H20V5H4ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM6 7H9V17H6V7ZM10 7H12V17H10V7ZM13 7H14V17H13V7ZM15 7H18V17H15V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1c3d70a32540e79f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4H4V20H2V4ZM6 4H8V20H6V4ZM9 4H12V20H9V4ZM13 4H15V20H13V4ZM16 4H18V20H16V4ZM19 4H22V20H19V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e23c970153c50608(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4H4V20H2V4ZM6 4H7V20H6V4ZM8 4H10V20H8V4ZM11 4H13V20H11V4ZM14 4H16V20H14V4ZM17 4H18V20H17V4ZM19 4H22V20H19V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2c70f6c22fc0f507(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.9997L18 21.9997H6L12 12.9997ZM10.9393 10.5604C10.3536 9.97462 10.3536 9.02487 10.9393 8.43908C11.5251 7.85329 12.4749 7.85329 13.0607 8.43908C13.6464 9.02487 13.6464 9.97462 13.0607 10.5604C12.4749 11.1462 11.5251 11.1462 10.9393 10.5604ZM5.28249 2.78223L6.6967 4.19644C3.76777 7.12537 3.76777 11.8741 6.6967 14.803L5.28249 16.2173C1.5725 12.5073 1.5725 6.49221 5.28249 2.78223ZM18.7175 2.78223C22.4275 6.49221 22.4275 12.5073 18.7175 16.2173L17.3033 14.803C20.2322 11.8741 20.2322 7.12537 17.3033 4.19644L18.7175 2.78223ZM8.11091 5.61065L9.52513 7.02487C8.15829 8.3917 8.15829 10.6078 9.52513 11.9746L8.11091 13.3888C5.96303 11.2409 5.96303 7.75854 8.11091 5.61065H8.11091ZM15.8891 5.61065C18.037 7.75854 18.037 11.2409 15.8891 13.3888L14.4749 11.9746C15.8417 10.6078 15.8417 8.3917 14.4749 7.02487L15.8891 5.61065Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a9b5bd99d0cd47ee(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.9997L18 21.9997H6L12 12.9997ZM12 16.5997L9.74 19.9997H14.26L12 16.5997ZM10.9393 10.5604C10.3536 9.97462 10.3536 9.02487 10.9393 8.43908C11.5251 7.85329 12.4749 7.85329 13.0607 8.43908C13.6464 9.02487 13.6464 9.97462 13.0607 10.5604C12.4749 11.1462 11.5251 11.1462 10.9393 10.5604ZM5.28249 2.78223L6.6967 4.19644C3.76777 7.12537 3.76777 11.8741 6.6967 14.803L5.28249 16.2173C1.5725 12.5073 1.5725 6.49221 5.28249 2.78223ZM18.7175 2.78223C22.4275 6.49221 22.4275 12.5073 18.7175 16.2173L17.3033 14.803C20.2322 11.8741 20.2322 7.12537 17.3033 4.19644L18.7175 2.78223ZM8.11091 5.61065L9.52513 7.02487C8.15829 8.3917 8.15829 10.6078 9.52513 11.9746L8.11091 13.3888C5.96303 11.2409 5.96303 7.75854 8.11091 5.61065H8.11091ZM15.8891 5.61065C18.037 7.75854 18.037 11.2409 15.8891 13.3888L14.4749 11.9746C15.8417 10.6078 15.8417 8.3917 14.4749 7.02487L15.8891 5.61065Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e5cf2eef0ed2a14b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4V3C9 2.44772 9.44772 2 10 2H14C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V5C5 4.44772 5.44772 4 6 4H9ZM13 12V7L8 14H11V19L16 12H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7acd510f88ea739f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12H16L11 19V14H8L13 7V12ZM11 6H7V20H17V6H13V4H11V6ZM9 4V3C9 2.44772 9.44772 2 10 2H14C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V5C5 4.44772 5.44772 4 6 4H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ce5e4af04a526f88(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4V3C9 2.44772 9.44772 2 10 2H14C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V5C5 4.44772 5.44772 4 6 4H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$df40bf8010c1504e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6H7V20H17V6H13V4H11V6ZM9 4V3C9 2.44772 9.44772 2 10 2H14C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V5C5 4.44772 5.44772 4 6 4H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$18665a0c1dd1ce68(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11V5L7 13H10V19L15 11H12ZM3 5H19C19.5523 5 20 5.44772 20 6V18C20 18.5523 19.5523 19 19 19H3C2.44772 19 2 18.5523 2 18V6C2 5.44772 2.44772 5 3 5ZM21 9H23V15H21V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cbe36dc87909c848(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19H3C2.44772 19 2 18.5523 2 18V6C2 5.44772 2.44772 5 3 5H9.625L8.45833 7H4V17H8V19ZM12.375 19L13.5417 17H18V7H14V5H19C19.5523 5 20 5.44772 20 6V18C20 18.5523 19.5523 19 19 19H12.375ZM21 9H23V15H21V9ZM12 11H15L10 19V13H7L12 5V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e17d9f15daeea518(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H19C19.5523 5 20 5.44772 20 6V18C20 18.5523 19.5523 19 19 19H3C2.44772 19 2 18.5523 2 18V6C2 5.44772 2.44772 5 3 5ZM21 9H23V15H21V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6981d76783b92f0d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7V17H18V7H4ZM3 5H19C19.5523 5 20 5.44772 20 6V18C20 18.5523 19.5523 19 19 19H3C2.44772 19 2 18.5523 2 18V6C2 5.44772 2.44772 5 3 5ZM21 9H23V15H21V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8ba010c0059159(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H19C19.5523 5 20 5.44772 20 6V18C20 18.5523 19.5523 19 19 19H3C2.44772 19 2 18.5523 2 18V6C2 5.44772 2.44772 5 3 5ZM5 8V16H9V8H5ZM21 9H23V15H21V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d52730ba7190662a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7V17H18V7H4ZM3 5H19C19.5523 5 20 5.44772 20 6V18C20 18.5523 19.5523 19 19 19H3C2.44772 19 2 18.5523 2 18V6C2 5.44772 2.44772 5 3 5ZM5 8H9V16H5V8ZM21 9H23V15H21V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$37c8547725cb4371(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V5C5 4.44772 5.44772 4 6 4H9V3C9 2.44772 9.44772 2 10 2H14ZM13 9H11V12H8V14H11V17H13V14H16V12H13V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$845ee566c0a372a8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V5C5 4.44772 5.44772 4 6 4H9V3C9 2.44772 9.44772 2 10 2H14ZM13 4H11V6H7V20H17V6H13V4ZM13 9V12H16V14H13V17H11V14H8V12H11V9H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$aeffe2397ba9df03(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5V11.2L15 8V11H14C11.8578 11 10 12.79 10 15V18H12V15C12 13.95 12.95 13 14 13H15V16L19 12.8V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V5C5 4.44772 5.44772 4 6 4H9V3C9 2.44772 9.44772 2 10 2H14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$70dfcbcbb0bf9fd3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5V7H17V6H13V4H11V6H7V20H17V17H19V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V5C5 4.44772 5.44772 4 6 4H9V3C9 2.44772 9.44772 2 10 2H14ZM15 8L20 12L15 16V13H14C12.9456 13 12 13.95 12 15V18H10V15C10 12.7909 11.7909 11 14 11H15V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b9916c4504aee5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.3113 12L18.6544 16.3431L12.9976 22H10.9976V15.3137L6.63359 19.6777L5.21938 18.2635L10.9976 12.4853V11.5147L5.21938 5.73654L6.63359 4.32233L10.9976 8.68629V2H12.9976L18.6544 7.65685L14.3113 12ZM12.9976 13.5147V19.1716L15.826 16.3431L12.9976 13.5147ZM12.9976 10.4853L15.826 7.65685L12.9976 4.82843V10.4853ZM19.5 13.5C18.6716 13.5 18 12.8284 18 12C18 11.1716 18.6716 10.5 19.5 10.5C20.3284 10.5 21 11.1716 21 12C21 12.8284 20.3284 13.5 19.5 13.5ZM6.5 13.5C5.67157 13.5 5 12.8284 5 12C5 11.1716 5.67157 10.5 6.5 10.5C7.32843 10.5 8 11.1716 8 12C8 12.8284 7.32843 13.5 6.5 13.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b641d2bf9740b6fe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.3113 12L18.6544 16.3431L12.9976 22H10.9976V15.3137L6.63359 19.6777L5.21938 18.2635L10.9976 12.4853V11.5147L5.21938 5.73654L6.63359 4.32233L10.9976 8.68629V2H12.9976L18.6544 7.65685L14.3113 12ZM12.9976 13.5147V19.1716L15.826 16.3431L12.9976 13.5147ZM12.9976 10.4853L15.826 7.65685L12.9976 4.82843V10.4853ZM19.5 13.5C18.6716 13.5 18 12.8284 18 12C18 11.1716 18.6716 10.5 19.5 10.5C20.3284 10.5 21 11.1716 21 12C21 12.8284 20.3284 13.5 19.5 13.5ZM6.5 13.5C5.67157 13.5 5 12.8284 5 12C5 11.1716 5.67157 10.5 6.5 10.5C7.32843 10.5 8 11.1716 8 12C8 12.8284 7.32843 13.5 6.5 13.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a0a879432c7ba9b2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.3116 12L18.6548 16.3431L12.9979 22H10.9979V15.3137L6.63394 19.6777L5.21973 18.2635L10.9979 12.4853V11.5147L5.21973 5.73654L6.63394 4.32233L10.9979 8.68629V2H12.9979L18.6548 7.65685L14.3116 12ZM12.9979 13.5147V19.1716L15.8263 16.3431L12.9979 13.5147ZM12.9979 10.4853L15.8263 7.65685L12.9979 4.82843V10.4853Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c802b8618f916bff(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.3116 12L18.6548 16.3431L12.9979 22H10.9979V15.3137L6.63394 19.6777L5.21973 18.2635L10.9979 12.4853V11.5147L5.21973 5.73654L6.63394 4.32233L10.9979 8.68629V2H12.9979L18.6548 7.65685L14.3116 12ZM12.9979 13.5147V19.1716L15.8263 16.3431L12.9979 13.5147ZM12.9979 10.4853L15.8263 7.65685L12.9979 4.82843V10.4853Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$18144561266a59b6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H15C15 20.3199 14.9478 19.6519 14.8471 19H20V5H4V8.1529C3.34806 8.05223 2.68013 8 2 8V4C2 3.44772 2.44772 3 3 3ZM13 21H11C11 16.0294 6.97056 12 2 12V10C8.07513 10 13 14.9249 13 21ZM9 21H7C7 18.2386 4.76142 16 2 16V14C5.86599 14 9 17.134 9 21ZM5 21H2V18C3.65685 18 5 19.3431 5 21ZM14.373 17C13.093 13.0376 9.9624 9.90704 6 8.627V7H18V17H14.373Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$74684dbeaaf58342(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H15C15 20.3199 14.9478 19.6519 14.8471 19H20V5H4V8.1529C3.34806 8.05223 2.68013 8 2 8V4C2 3.44772 2.44772 3 3 3ZM13 21H11C11 16.0294 6.97056 12 2 12V10C8.07513 10 13 14.9249 13 21ZM9 21H7C7 18.2386 4.76142 16 2 16V14C5.86599 14 9 17.134 9 21ZM5 21H2V18C3.65685 18 5 19.3431 5 21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7b1d41b068098695(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2H18C18.5523 2 19 2.44772 19 3V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V0H7V2ZM7 4V9H17V4H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c5d8e67d001f0fc4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2H18C18.5523 2 19 2.44772 19 3V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V0H7V2ZM7 9H17V4H7V9ZM7 11V20H17V11H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b8d3bf5ad475de34(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18V20H17V22H7V20H11V18H2.9918C2.44405 18 2 17.5511 2 16.9925V4.00748C2 3.45107 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44892 22 4.00748V16.9925C22 17.5489 21.5447 18 21.0082 18H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4e3dd2e022abd353(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16H20V5H4V16ZM13 18V20H17V22H7V20H11V18H2.9918C2.44405 18 2 17.5511 2 16.9925V4.00748C2 3.45107 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44892 22 4.00748V16.9925C22 17.5489 21.5447 18 21.0082 18H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e02c2605fe6af2ba(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 20H10V22H8V20H5C4.44772 20 4 19.5523 4 19V16H2V14H4V10H2V8H4V5C4 4.44772 4.44772 4 5 4H8V2H10V4H14V2H16V4H19C19.5523 4 20 4.44772 20 5V8H22V10H20V14H22V16H20V19C20 19.5523 19.5523 20 19 20H16V22H14V20ZM7 7V11H11V7H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$38c167c5c8345691(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18H18V6H6V18ZM14 20H10V22H8V20H5C4.44772 20 4 19.5523 4 19V16H2V14H4V10H2V8H4V5C4 4.44772 4.44772 4 5 4H8V2H10V4H14V2H16V4H19C19.5523 4 20 4.44772 20 5V8H22V10H20V14H22V16H20V19C20 19.5523 19.5523 20 19 20H16V22H14V20ZM8 8H16V16H8V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$566dae471ec161a7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 5C8.13401 5 5 8.13401 5 12C5 13.8525 5.71957 15.5368 6.89445 16.7889L7.05025 16.9497L8.46447 15.5355C7.55964 14.6307 7 13.3807 7 12C7 9.23858 9.23858 7 12 7C12.448 7 12.8822 7.05892 13.2954 7.16944L14.8579 5.60806C13.9852 5.21731 13.018 5 12 5ZM18.3924 9.14312L16.8306 10.7046C16.9411 11.1178 17 11.552 17 12C17 13.3807 16.4404 14.6307 15.5355 15.5355L16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 10.9824 18.7829 10.0155 18.3924 9.14312ZM16.2426 6.34315L12.517 10.0675C12.3521 10.0235 12.1788 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 11.8212 13.9765 11.6479 13.9325 11.483L17.6569 7.75736L16.2426 6.34315Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c7ca2ab1cfaa6570(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 5C13.018 5 13.9852 5.21731 14.8579 5.60806L13.2954 7.16944C12.8822 7.05892 12.448 7 12 7C9.23858 7 7 9.23858 7 12C7 13.3807 7.55964 14.6307 8.46447 15.5355L7.05025 16.9497L6.89445 16.7889C5.71957 15.5368 5 13.8525 5 12C5 8.13401 8.13401 5 12 5ZM18.3924 9.14312C18.7829 10.0155 19 10.9824 19 12C19 13.933 18.2165 15.683 16.9497 16.9497L15.5355 15.5355C16.4404 14.6307 17 13.3807 17 12C17 11.552 16.9411 11.1178 16.8306 10.7046L18.3924 9.14312ZM16.2426 6.34315L17.6569 7.75736L13.9325 11.483C13.9765 11.6479 14 11.8212 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C12.1788 10 12.3521 10.0235 12.517 10.0675L16.2426 6.34315Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5d0aec39bb08f349(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM16.5962 7.40381C16.3916 7.19926 16.0697 7.17128 15.8329 7.33748C12.9438 9.36549 11.3126 10.5661 10.9393 10.9393C10.3536 11.5251 10.3536 12.4749 10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607C13.2796 12.8417 14.479 11.2095 16.6587 8.16418C16.8267 7.92955 16.8002 7.60784 16.5962 7.40381ZM17.5 11C16.9477 11 16.5 11.4477 16.5 12C16.5 12.5523 16.9477 13 17.5 13C18.0523 13 18.5 12.5523 18.5 12C18.5 11.4477 18.0523 11 17.5 11ZM6.5 11C5.94772 11 5.5 11.4477 5.5 12C5.5 12.5523 5.94772 13 6.5 13C7.05228 13 7.5 12.5523 7.5 12C7.5 11.4477 7.05228 11 6.5 11ZM8.81802 7.40381C8.4275 7.01328 7.79433 7.01328 7.40381 7.40381C7.01328 7.79433 7.01328 8.4275 7.40381 8.81802C7.79433 9.20854 8.4275 9.20854 8.81802 8.81802C9.20854 8.4275 9.20854 7.79433 8.81802 7.40381ZM12 5.5C11.4477 5.5 11 5.94772 11 6.5C11 7.05228 11.4477 7.5 12 7.5C12.5523 7.5 13 7.05228 13 6.5C13 5.94772 12.5523 5.5 12 5.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$49e6f543804ae8cf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM15.8329 7.33748C16.0697 7.17128 16.3916 7.19926 16.5962 7.40381C16.8002 7.60784 16.8267 7.92955 16.6587 8.16418C14.479 11.2095 13.2796 12.8417 13.0607 13.0607C12.4749 13.6464 11.5251 13.6464 10.9393 13.0607C10.3536 12.4749 10.3536 11.5251 10.9393 10.9393C11.3126 10.5661 12.9438 9.36549 15.8329 7.33748ZM17.5 11C18.0523 11 18.5 11.4477 18.5 12C18.5 12.5523 18.0523 13 17.5 13C16.9477 13 16.5 12.5523 16.5 12C16.5 11.4477 16.9477 11 17.5 11ZM6.5 11C7.05228 11 7.5 11.4477 7.5 12C7.5 12.5523 7.05228 13 6.5 13C5.94772 13 5.5 12.5523 5.5 12C5.5 11.4477 5.94772 11 6.5 11ZM8.81802 7.40381C9.20854 7.79433 9.20854 8.4275 8.81802 8.81802C8.4275 9.20854 7.79433 9.20854 7.40381 8.81802C7.01328 8.4275 7.01328 7.79433 7.40381 7.40381C7.79433 7.01328 8.4275 7.01328 8.81802 7.40381ZM12 5.5C12.5523 5.5 13 5.94772 13 6.5C13 7.05228 12.5523 7.5 12 7.5C11.4477 7.5 11 7.05228 11 6.5C11 5.94772 11.4477 5.5 12 5.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$df279f22a5109d10(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9.5V12.5C21 14.9853 16.9706 17 12 17C7.02944 17 3 14.9853 3 12.5V9.5C3 11.9853 7.02944 14 12 14C16.9706 14 21 11.9853 21 9.5ZM3 14.5C3 16.9853 7.02944 19 12 19C16.9706 19 21 16.9853 21 14.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5V14.5ZM12 12C7.02944 12 3 9.98528 3 7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5C21 9.98528 16.9706 12 12 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a9ed8af25ffcd9a8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$65594f81b2d3139(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7V4C11 3.44772 11.4477 3 12 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V8C2 7.44772 2.44772 7 3 7H11ZM5 16V18H10V16H5ZM14 16V18H19V16H14ZM14 13V15H19V13H14ZM14 10V12H19V10H14ZM5 13V15H10V13H5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e94f53459b82117b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19V9H4V19H11ZM11 7V4C11 3.44772 11.4477 3 12 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V8C2 7.44772 2.44772 7 3 7H11ZM13 5V19H20V5H13ZM5 16H10V18H5V16ZM14 16H19V18H14V16ZM14 13H19V15H14V13ZM14 10H19V12H14V10ZM5 13H10V15H5V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$83b8bfea9eed3817(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6H11C10.4477 6 10 6.44772 10 7V20H4C3.44772 20 3 19.5523 3 19V3C3 2.44772 3.44772 2 4 2H18C18.5523 2 19 2.44772 19 3V6ZM13 8H21C21.5523 8 22 8.44772 22 9V21C22 21.5523 21.5523 22 21 22H13C12.4477 22 12 21.5523 12 21V9C12 8.44772 12.4477 8 13 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f1242537077efa49(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8H21C21.5523 8 22 8.44772 22 9V21C22 21.5523 21.5523 22 21 22H13C12.4477 22 12 21.5523 12 21V20H4C3.44772 20 3 19.5523 3 19V3C3 2.44772 3.44772 2 4 2H18C18.5523 2 19 2.44772 19 3V8ZM17 8V4H5V18H12V9C12 8.44772 12.4477 8 13 8H17ZM14 10V20H20V10H14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2bdf7115082971cf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H19ZM12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C12.33 17 12.65 16.97 12.9552 16.9089L12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.5977 9 15 10.3393 15 12H12.5L14.6282 16.2544C16.0517 15.3731 17 13.7973 17 12C17 9.23858 14.7614 7 12 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1f51bcd94d554a1b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H19ZM18 4H6V20H18V4ZM12 7C14.7614 7 17 9.23858 17 12C17 13.7973 16.0517 15.3731 14.6282 16.2544L12.5 12H15C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15L12.9552 16.9089C12.646 16.9687 12.3267 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$845acfd478a0ddea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2L19.7071 6.70711C19.8946 6.89464 20 7.149 20 7.41421V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H15ZM13 8H10V10H11V16H13V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d92a14503eb9df1c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2L19.7071 6.70711C19.8946 6.89464 20 7.149 20 7.41421V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H15ZM14.171 4H6V20H18V7.829L14.171 4ZM13 16H11V10H10V8H13V16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$48a3f8ec43f3077d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2L19.7071 6.70711C19.8946 6.89464 20 7.149 20 7.41421V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H15ZM12 7.5C10.4023 7.5 9.09634 8.74892 9.00509 10.3237L9 10.5H11C11 9.94772 11.4477 9.5 12 9.5C12.5523 9.5 13 9.94772 13 10.5C13 10.7528 12.9062 10.9836 12.7514 11.1598L12.6691 11.2431L8.99926 14.547L9 16H15V14H12.5953L14.0074 12.7294L14.0013 12.72L14.009 12.728C14.6175 12.179 15 11.3841 15 10.5C15 8.84315 13.6569 7.5 12 7.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e47b6bfc3ee9703d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2L19.7071 6.70711C19.8946 6.89464 20 7.149 20 7.41421V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H15ZM14.171 4H6V20H18V7.829L14.171 4ZM12 7.5C13.6569 7.5 15 8.84315 15 10.5C15 11.3841 14.6175 12.179 14.009 12.728L14.0013 12.72L14.0074 12.7294L12.5953 14H15V16H9L8.99926 14.547L12.6691 11.2431C12.8723 11.06 13 10.7949 13 10.5C13 9.94772 12.5523 9.5 12 9.5C11.4477 9.5 11 9.94772 11 10.5H9C9 8.84315 10.3431 7.5 12 7.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4909e3ad070c90cd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1C16.9706 1 21 5.02944 21 10V14C21 17.0383 19.4945 19.7249 17.1887 21.3546C17.7164 19.6635 18 17.8649 18 16L17.9996 13.999H15.9996L16 16L15.997 16.3149C15.9535 18.5643 15.4459 20.7 14.5657 22.6304C13.7516 22.8705 12.8909 23 12 23C11.6587 23 11.3218 22.981 10.9903 22.944C12.2637 20.9354 13 18.5537 13 16V9H11V16L10.9963 16.2884C10.9371 18.5891 10.1714 20.7142 8.90785 22.4547C7.9456 22.1028 7.05988 21.5909 6.28319 20.9515C7.35876 19.5892 8 17.8695 8 16V10L8.0049 9.80036C8.03767 9.1335 8.23376 8.50957 8.554 7.96773L7.10935 6.52332C6.41083 7.50417 6 8.70411 6 10V16L5.99586 16.2249C5.95095 17.4436 5.54259 18.5694 4.87532 19.4973C3.69863 17.9762 3 16.0697 3 14V10C3 5.02944 7.02944 1 12 1ZM12 4C10.7042 4 9.50434 4.41077 8.52353 5.10921L9.96848 6.55356C10.5639 6.20183 11.2584 6 12 6C14.2091 6 16 7.79086 16 10V12H18V10C18 6.68629 15.3137 4 12 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$40f0b7e22816790f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1C16.9706 1 21 5.02944 21 10V14C21 18.9706 16.9706 23 12 23C10.9137 23 9.8724 22.8076 8.90826 22.4549C9.03638 22.2782 9.15938 22.0977 9.27703 21.9134L9.44782 21.633C10.388 20.0636 10.9461 18.2391 10.9963 16.2884L11 16V9H13V16C13 17.7724 12.6453 19.4619 12.0031 21.0015C12.7954 21 13.5599 20.8673 14.2724 20.6229C14.7147 19.2616 14.966 17.8148 14.9968 16.3138L15 16L14.9998 12.999H16.9998L17 16C17 17.0885 16.8977 18.1531 16.7022 19.1847C18.0583 17.9552 18.9297 16.2 18.9959 14.2407L19 14V10C19 6.13401 15.866 3 12 3C10.4277 3 8.97638 3.51841 7.8078 4.39364L6.38282 2.96769C7.92242 1.73631 9.87522 1 12 1ZM7 10C7 7.23858 9.23858 5 12 5C14.7614 5 17 7.23858 17 10V11H15V10C15 8.34315 13.6569 7 12 7C10.4023 7 9.09634 8.24892 9.00509 9.82373L9 10V16C9 17.5669 8.5996 19.0402 7.89554 20.3233L7.87214 20.3627C7.64284 20.7771 7.38087 21.1711 7.09037 21.5417C6.6495 21.2545 6.23541 20.9297 5.85264 20.5719L5.5445 20.2711C3.96956 18.65 3 16.4382 3 14V10C3 7.87522 3.73631 5.92242 4.96769 4.38282L6.39364 5.8078C5.56325 6.91652 5.05405 8.27971 5.00406 9.75935L5 10V14C5 15.6748 5.58816 17.2122 6.56918 18.4169C6.82239 17.7351 6.97017 17.0034 6.99594 16.2407L7 16V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$38d70d475ad21bd3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0003 13V14C17.0003 16.7696 16.3364 19.445 15.0853 21.8455L14.8585 22.2663L13.1116 21.2924C14.2716 19.2115 14.9211 16.8817 14.9935 14.4559L15.0003 14V13H17.0003ZM11.0003 10H13.0003V14L12.9948 14.3787C12.9153 17.1495 11.9645 19.7731 10.3038 21.928L10.073 22.2189L8.52406 20.9536C10.0408 19.0969 10.9145 16.8017 10.9943 14.3663L11.0003 14V10ZM12.0003 6C14.7617 6 17.0003 8.23858 17.0003 11H15.0003C15.0003 9.34315 13.6571 8 12.0003 8C10.3434 8 9.00025 9.34315 9.00025 11V14C9.00025 16.2354 8.1806 18.3444 6.72928 19.9768L6.51767 20.2067L5.06955 18.8273C6.23328 17.6056 6.92099 16.0118 6.99381 14.3027L7.00025 14V11C7.00025 8.23858 9.23883 6 12.0003 6ZM12.0003 2C16.9708 2 21.0003 6.02944 21.0003 11V14C21.0003 15.6979 20.7985 17.3699 20.4035 18.9903L20.2647 19.5285L18.3349 19.0032C18.726 17.5662 18.9475 16.0808 18.9919 14.5684L19.0003 14V11C19.0003 7.13401 15.8662 4 12.0003 4C10.4279 4 8.97663 4.51841 7.80805 5.39364L6.38308 3.96769C7.92267 2.73631 9.87547 2 12.0003 2ZM4.96794 5.38282L6.39389 6.8078C5.5635 7.91652 5.0543 9.27971 5.00431 10.7593L4.99961 10.999L5.00378 13C5.00378 14.1195 4.73991 15.2026 4.24263 16.1772L4.08648 16.4663L2.34961 15.4747C2.72889 14.8103 2.95077 14.0681 2.99539 13.2924L3.00378 13L3.00361 11C3.00025 8.87522 3.73656 6.92242 4.96794 5.38282Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6e67a7d04c968e31(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0003 13V14C17.0003 16.7696 16.3364 19.445 15.0853 21.8455L14.8585 22.2663L13.1116 21.2924C14.2716 19.2115 14.9211 16.8817 14.9935 14.4559L15.0003 14V13H17.0003ZM11.0003 10H13.0003V14L12.9948 14.3787C12.9153 17.1495 11.9645 19.7731 10.3038 21.928L10.073 22.2189L8.52406 20.9536C10.0408 19.0969 10.9145 16.8017 10.9943 14.3663L11.0003 14V10ZM12.0003 6C14.7617 6 17.0003 8.23858 17.0003 11H15.0003C15.0003 9.34315 13.6571 8 12.0003 8C10.3434 8 9.00025 9.34315 9.00025 11V14C9.00025 16.2354 8.1806 18.3444 6.72928 19.9768L6.51767 20.2067L5.06955 18.8273C6.23328 17.6056 6.92099 16.0118 6.99381 14.3027L7.00025 14V11C7.00025 8.23858 9.23883 6 12.0003 6ZM12.0003 2C16.9708 2 21.0003 6.02944 21.0003 11V14C21.0003 15.6979 20.7985 17.3699 20.4035 18.9903L20.2647 19.5285L18.3349 19.0032C18.726 17.5662 18.9475 16.0808 18.9919 14.5684L19.0003 14V11C19.0003 7.13401 15.8662 4 12.0003 4C10.4279 4 8.97663 4.51841 7.80805 5.39364L6.38308 3.96769C7.92267 2.73631 9.87547 2 12.0003 2ZM4.96794 5.38282L6.39389 6.8078C5.5635 7.91652 5.0543 9.27971 5.00431 10.7593L4.99961 10.999L5.00378 13C5.00378 14.1195 4.73991 15.2026 4.24263 16.1772L4.08648 16.4663L2.34961 15.4747C2.72889 14.8103 2.95077 14.0681 2.99539 13.2924L3.00378 13L3.00361 11C3.00025 8.87522 3.73656 6.92242 4.96794 5.38282Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$465b7de4cd885bdc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4C20.3137 4 23 6.68629 23 10V14C23 17.3137 20.3137 20 17 20H7C3.68629 20 1 17.3137 1 14V10C1 6.68629 3.68629 4 7 4H17ZM10 9H8V11H6V13H7.999L8 15H10L9.999 13H12V11H10V9ZM18 13H16V15H18V13ZM16 9H14V11H16V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6dd7856d243bb80d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4C20.3137 4 23 6.68629 23 10V14C23 17.3137 20.3137 20 17 20H7C3.68629 20 1 17.3137 1 14V10C1 6.68629 3.68629 4 7 4H17ZM17 6H7C4.8578 6 3.10892 7.68397 3.0049 9.80036L3 10V14C3 16.1422 4.68397 17.8911 6.80036 17.9951L7 18H17C19.1422 18 20.8911 16.316 20.9951 14.1996L21 14V10C21 7.8578 19.316 6.10892 17.1996 6.0049L17 6ZM10 9V11H12V13H9.999L10 15H8L7.999 13H6V11H8V9H10ZM18 13V15H16V13H18ZM16 9V11H14V9H16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f11b0b2eb8146291(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16L15 22H9L12 16ZM9.37258 16.2548C7.94863 15.3737 7 13.7976 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 13.7976 16.0514 15.3737 14.6274 16.2548L13.2718 13.5436C13.7165 13.1768 14 12.6215 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 12.6215 10.2835 13.1768 10.7282 13.5436L9.37258 16.2548ZM7.13153 20.7369C4.07014 19.0274 2 15.7554 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 15.7554 19.9299 19.0274 16.8685 20.7369L15.5246 18.0492C17.6033 16.8354 19 14.5808 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 14.5808 6.39666 16.8354 8.47539 18.0492L7.13153 20.7369Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8f21f70f16861ab4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.13173 20.7371C4.07023 19.0275 2 15.7555 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 15.7555 19.9298 19.0275 16.8683 20.7371L15.9724 18.9457C18.3788 17.5664 20 14.9725 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 14.9725 5.62119 17.5664 8.02763 18.9457L7.13173 20.7371ZM8.92427 17.1528C7.17271 16.105 6 14.1894 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 14.1894 16.8273 16.105 15.0757 17.1528L14.1772 15.3561C15.2744 14.6429 16 13.4062 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 13.4062 8.72559 14.6429 9.82279 15.3561L8.92427 17.1528ZM12 16L15 22H9L12 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d85e42bbfabf7a5a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8.12602 11H4.06189C4.02104 11.3276 4 11.6613 4 12C4 12.3387 4.02104 12.6724 4.06189 13H8.12602C8.04375 12.6804 8 12.3453 8 12C8 11.6547 8.04375 11.3196 8.12602 11ZM15.874 11C15.9562 11.3196 16 11.6547 16 12C16 12.3453 15.9562 12.6804 15.874 13H19.9381C19.979 12.6724 20 12.3387 20 12C20 11.6613 19.979 11.3276 19.9381 11H15.874ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f239cd6ee8024d92(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.04883 13H4.06135C4.55344 16.9463 7.91984 20 11.9995 20C16.0791 20 19.4455 16.9463 19.9376 13H21.9501C21.4484 18.0533 17.1848 22 11.9995 22C6.8141 22 2.55055 18.0533 2.04883 13ZM2.04883 11C2.55055 5.94668 6.8141 2 11.9995 2C17.1848 2 21.4484 5.94668 21.9501 11H19.9376C19.4455 7.05369 16.0791 4 11.9995 4C7.91984 4 4.55344 7.05369 4.06135 11H2.04883ZM11.9995 14C10.8949 14 9.99945 13.1046 9.99945 12C9.99945 10.8954 10.8949 10 11.9995 10C13.104 10 13.9995 10.8954 13.9995 12C13.9995 13.1046 13.104 14 11.9995 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d24f3192235c84eb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3ZM5 16V20H19V16H5ZM15 17H17V19H15V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c55b7407beb3b556(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 14H19V4H5V14ZM5 16V20H19V16H5ZM4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2ZM15 17H17V19H15V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$169e82f90ae9d082(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 2C4.99568 2 4.57028 2.37554 4.50772 2.87597L3.00772 14.876C3.00258 14.9171 3 14.9585 3 15V21C3 21.5523 3.44772 22 4 22H20C20.5523 22 21 21.5523 21 21V15C21 14.9585 20.9974 14.9171 20.9923 14.876L19.4923 2.87597C19.4297 2.37554 19.0043 2 18.5 2H5.5ZM5 16H19V20H5V16ZM15 17H17V19H15V17ZM13 17H11V19H13V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3973b02634031706(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.50772 2.87597C4.57028 2.37554 4.99568 2 5.5 2H18.5C19.0043 2 19.4297 2.37554 19.4923 2.87597L20.9923 14.876C20.9974 14.9171 21 14.9585 21 15V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V15C3 14.9585 3.00258 14.9171 3.00772 14.876L4.50772 2.87597ZM6.38278 4L5.13278 14H18.8672L17.6172 4H6.38278ZM19 16H5V20H19V16ZM15 17H17V19H15V17ZM13 17H11V19H13V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f2eb9f26e3da0e3a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9506 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V12.9506C3.32891 12.9833 3.6625 13 4 13C9.52285 13 14 8.52285 14 3C14 2.6625 13.9833 2.32891 13.9506 2ZM15 16V18H17V16H15ZM11.9381 2C11.979 2.32759 12 2.66134 12 3C12 7.41828 8.41828 11 4 11C3.66134 11 3.32759 10.979 3 10.9381V3C3 2.44772 3.44772 2 4 2H11.9381Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$807fd011c3d39166(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10.9381C8.61872 10.4869 11.4869 7.61872 11.9381 4H5V10.9381ZM5 12.9506V20H19V4H13.9506C13.4816 8.72442 9.72442 12.4816 5 12.9506ZM4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2ZM15 16H17V18H15V16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3e90fc70a226355f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2V11H18V21C18 21.5523 17.5523 22 17 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H11ZM13 7C14.1046 7 15 7.89543 15 9H13V7ZM13 4C15.7614 4 18 6.23858 18 9H16C16 7.34315 14.6569 6 13 6V4ZM13 1C17.4183 1 21 4.58172 21 9H19C19 5.68629 16.3137 3 13 3V1Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5729a2665755196b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2V4H7V20H17V11H19V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2H11ZM13 7C14.1046 7 15 7.89543 15 9H13V7ZM13 4C15.7614 4 18 6.23858 18 9H16C16 7.34315 14.6569 6 13 6V4ZM13 1C17.4183 1 21 4.58172 21 9H19C19 5.68629 16.3137 3 13 3V1Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$90eb292e0556998b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2V7H8L12 11L16 7H13V2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H11ZM19 16H5V20H19V16ZM17 17V19H15V17H17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6fb88a390a71ca6c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2V4H5L4.999 14H18.999L19 4H15V2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H9ZM18.999 16H4.999L5 20H19L18.999 16ZM17 17V19H15V17H17ZM13 2V7H16L12 11L8 7H11V2H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$24e8df474355dd72(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM6.49896 9.97089L11 12.5768V17.6252H13V12.5768L17.501 9.9709L16.499 8.24005L12 10.8447L7.50104 8.24004L6.49896 9.97089Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$af8073ee27627763(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 7.65311V16.3469L12 20.689L19.5 16.3469V7.65311L12 3.311L4.5 7.65311ZM12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM6.49896 9.97065L11 12.5765V17.625H13V12.5765L17.501 9.97066L16.499 8.2398L12 10.8445L7.50104 8.2398L6.49896 9.97065Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fda9f3a16ca37906(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM5 7V9H7V7H5ZM5 11V13H7V11H5ZM5 15V17H19V15H5ZM9 11V13H11V11H9ZM9 7V9H11V7H9ZM13 7V9H15V7H13ZM17 7V9H19V7H17ZM13 11V13H15V11H13ZM17 11V13H19V11H17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$92adb49860d77947(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5V19H20V5H4ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM6 7H8V9H6V7ZM6 11H8V13H6V11ZM6 15H18V17H6V15ZM11 11H13V13H11V11ZM11 7H13V9H11V7ZM16 7H18V9H16V7ZM16 11H18V13H16V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6d903a879e4aaf9c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17H21V19H3V17ZM3 11H6V14H3V11ZM8 11H11V14H8V11ZM3 5H6V8H3V5ZM13 5H16V8H13V5ZM18 5H21V8H18V5ZM13 11H16V14H13V11ZM18 11H21V14H18V11ZM8 5H11V8H8V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$316877910a5cd0c7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17H21V19H3V17ZM3 11H6V14H3V11ZM8 11H11V14H8V11ZM3 5H6V8H3V5ZM13 5H16V8H13V5ZM18 5H21V8H18V5ZM13 11H16V14H13V11ZM18 11H21V14H18V11ZM8 5H11V8H8V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a9859366a06c72fa(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 18V20L16 21V22H8L7.99639 21.0036L10 20V18H2.9918C2.44405 18 2 17.5511 2 16.9925V4.00748C2 3.45107 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44892 22 4.00748V16.9925C22 17.5489 21.5447 18 21.0082 18H14ZM4 14V16H20V14H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$62589295f1c922ca(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 18V20L16 21V22H8L7.99639 21.0036L10 20V18H2.9918C2.44405 18 2 17.5511 2 16.9925V4.00748C2 3.45107 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44892 22 4.00748V16.9925C22 17.5489 21.5447 18 21.0082 18H14ZM4 5V14H20V5H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b1d3656d85d8f67(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4.00685C2 3.45078 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44995 22 4.00685V17H2V4.00685ZM1 19H23V21H1V19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e41ed2d4adeb11e7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5V16H20V5H4ZM2 4.00748C2 3.45107 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44892 22 4.00748V18H2V4.00748ZM1 19H23V21H1V19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8542efe8e95be0e0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.1411 2H12.8589C14.8728 2 15.9528 2.27848 16.9305 2.8014C17.9083 3.32432 18.6757 4.09169 19.1986 5.06946C19.7215 6.04724 20 7.12721 20 9.14111V14.8589C20 16.8728 19.7215 17.9528 19.1986 18.9305C18.6757 19.9083 17.9083 20.6757 16.9305 21.1986C15.9528 21.7215 14.8728 22 12.8589 22H11.1411C9.12721 22 8.04724 21.7215 7.06946 21.1986C6.09169 20.6757 5.32432 19.9083 4.8014 18.9305C4.27848 17.9528 4 16.8728 4 14.8589V9.14111C4 7.12721 4.27848 6.04724 4.8014 5.06946C5.32432 4.09169 6.09169 3.32432 7.06946 2.8014C8.04724 2.27848 9.12721 2 11.1411 2ZM11 6V11H13V6H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$648ddcb0ce042e1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.1411 4C9.5587 4 8.75361 4.16876 8.01266 4.56502C7.38342 4.90155 6.90155 5.38342 6.56502 6.01266C6.16876 6.75361 6 7.5587 6 9.14111V14.8589C6 16.4413 6.16876 17.2464 6.56502 17.9873C6.90155 18.6166 7.38342 19.0985 8.01266 19.435C8.75361 19.8312 9.5587 20 11.1411 20H12.8589C14.4413 20 15.2464 19.8312 15.9873 19.435C16.6166 19.0985 17.0985 18.6166 17.435 17.9873C17.8312 17.2464 18 16.4413 18 14.8589V9.14111C18 7.5587 17.8312 6.75361 17.435 6.01266C17.0985 5.38342 16.6166 4.90155 15.9873 4.56502C15.2464 4.16876 14.4413 4 12.8589 4H11.1411ZM11.1411 2H12.8589C14.8728 2 15.9528 2.27848 16.9305 2.8014C17.9083 3.32432 18.6757 4.09169 19.1986 5.06946C19.7215 6.04724 20 7.12721 20 9.14111V14.8589C20 16.8728 19.7215 17.9528 19.1986 18.9305C18.6757 19.9083 17.9083 20.6757 16.9305 21.1986C15.9528 21.7215 14.8728 22 12.8589 22H11.1411C9.12721 22 8.04724 21.7215 7.06946 21.1986C6.09169 20.6757 5.32432 19.9083 4.8014 18.9305C4.27848 17.9528 4 16.8728 4 14.8589V9.14111C4 7.12721 4.27848 6.04724 4.8014 5.06946C5.32432 4.09169 6.09169 3.32432 7.06946 2.8014C8.04724 2.27848 9.12721 2 11.1411 2ZM11 6H13V11H11V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$756ab9ddfbb3fdc1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7dd9e1c990b09d31(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2C18.5523 2 19 2.44772 19 3L19.0009 11.5286C17.9393 10.578 16.5371 10 15 10C11.6863 10 9 12.6863 9 16C9 19.2384 11.76 22 15 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2H18ZM15 12C17.2091 12 19 13.7909 19 16C19 16.7418 18.7981 17.4365 18.4462 18.032L20.6569 20.2426L19.2426 21.6569L17.032 19.4462C16.4365 19.7981 15.7418 20 15 20C12.7909 20 11 18.2091 11 16C11 13.7909 12.7909 12 15 12ZM15 14C13.8954 14 13 14.8954 13 16C13 17.1046 13.8954 18 15 18C16.1046 18 17 17.1046 17 16C17 14.8954 16.1046 14 15 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$479009ccdb9a6d3d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2C18.5523 2 19 2.44772 19 3V11H17V4H7V20H11V22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2H18ZM15 12C17.2091 12 19 13.7909 19 16C19 16.7419 18.798 17.4366 18.446 18.0322L20.6569 20.2426L19.2426 21.6569L17.0313 19.4466C16.4359 19.7982 15.7415 20 15 20C12.7909 20 11 18.2091 11 16C11 13.7909 12.7909 12 15 12ZM15 14C13.8954 14 13 14.8954 13 16C13 17.1046 13.8954 18 15 18C16.1046 18 17 17.1046 17 16C17 14.8954 16.1046 14 15 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$408caf25786ab7b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.36556 10.6821C10.302 12.3288 11.6712 13.698 13.3179 14.6344L14.2024 13.3961C14.4965 12.9845 15.0516 12.8573 15.4956 13.0998C16.9024 13.8683 18.4571 14.3353 20.0789 14.4637C20.599 14.5049 21 14.9389 21 15.4606V19.9234C21 20.4361 20.6122 20.8657 20.1022 20.9181C19.5723 20.9726 19.0377 21 18.5 21C9.93959 21 3 14.0604 3 5.5C3 4.96227 3.02742 4.42771 3.08189 3.89776C3.1343 3.38775 3.56394 3 4.07665 3H8.53942C9.0611 3 9.49513 3.40104 9.5363 3.92109C9.66467 5.54288 10.1317 7.09764 10.9002 8.50444C11.1427 8.9484 11.0155 9.50354 10.6039 9.79757L9.36556 10.6821ZM6.84425 10.0252L8.7442 8.66809C8.20547 7.50514 7.83628 6.27183 7.64727 5H5.00907C5.00303 5.16632 5 5.333 5 5.5C5 12.9558 11.0442 19 18.5 19C18.667 19 18.8337 18.997 19 18.9909V16.3527C17.7282 16.1637 16.4949 15.7945 15.3319 15.2558L13.9748 17.1558C13.4258 16.9425 12.8956 16.6915 12.3874 16.4061L12.3293 16.373C10.3697 15.2587 8.74134 13.6303 7.627 11.6707L7.59394 11.6126C7.30849 11.1044 7.05754 10.5742 6.84425 10.0252Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a8a81dc4894ffeae(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2C18.5523 2 19 2.44772 19 3L19.0012 10.1003C18.6777 10.0345 18.3429 10 18 10C15.5811 10 13.5634 11.7177 13.1001 13.9998L12 14V22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2H18ZM18 12C19.6569 12 21 13.3431 21 15V16H22V21C22 21.5523 21.5523 22 21 22H15C14.4477 22 14 21.5523 14 21V16H15V15C15 13.3431 16.3431 12 18 12ZM18 14C17.4872 14 17 14.45 17 15V16H19V15C19 14.4477 18.5523 14 18 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3a33edfcdcdea72b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2C18.5523 2 19 2.44772 19 3V10H17V4H7V20H12V22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2H18ZM18 12C19.6569 12 21 13.3431 21 15V16H22V21C22 21.5523 21.5523 22 21 22H15C14.4477 22 14 21.5523 14 21V16H15V15C15 13.3431 16.3431 12 18 12ZM20 18H16V20H20V18ZM18 14C17.4919 14 17 14.45 17 15V16H19V15C19 14.4477 18.5523 14 18 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$836be9155d15bcf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 17V16H13V13H16V15H18V17H17V19H15V21H13V18H15V17H16ZM21 21H17V19H19V17H21V21ZM3 3H11V11H3V3ZM13 3H21V11H13V3ZM3 13H11V21H3V13ZM18 13H21V15H18V13ZM6 6V8H8V6H6ZM6 16V18H8V16H6ZM16 6V8H18V6H16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2940a50e0ba7969c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 17V16H13V13H16V15H18V17H17V19H15V21H13V18H15V17H16ZM21 21H17V19H19V17H21V21ZM3 3H11V11H3V3ZM5 5V9H9V5H5ZM13 3H21V11H13V3ZM15 5V9H19V5H15ZM3 13H11V21H3V13ZM5 15V19H9V15H5ZM18 13H21V15H18V13ZM6 6H8V8H6V6ZM6 16H8V18H6V16ZM16 6H18V8H16V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ffedfb93121afee1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H21V9H15V3ZM9 3V9H3V3H9ZM15 21V15H21V21H15ZM9 21H3V15H9V21ZM3 11H21V13H3V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a39d01ac4a3490ed(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H21V8H19V5H15V3ZM9 3V5H5V8H3V3H9ZM15 21V19H19V16H21V21H15ZM9 21H3V16H5V19H9V21ZM3 11H21V13H3V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5a3920bc5ee20e8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15V20.0066C21 20.5552 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5551 3 20.0066V15H21ZM2 11H22V13H2V11ZM21 9H3V3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44495 21 3.9934V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f6c4ec58d42dc0c5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V21H3V16H5V19H19V16H21ZM3 11H21V13H3V11ZM21 8H19V5H5V8H3V3H21V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cb6aa5f433c451c1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.3685 4.39825L10.8842 10.4332L12.6163 11.4332L16.1006 5.39825C20.27 8.1702 22.4058 12.4773 20.6605 15.5002C18.8003 18.7223 13.4717 18.8552 8.75027 16.1294C4.0289 13.4035 1.47976 8.72227 3.34002 5.50019C5.08527 2.47733 9.88324 2.17339 14.3685 4.39825ZM15.8842 1.77295L17.6163 2.77295L16.1163 5.37103L14.3842 4.37103L15.8842 1.77295ZM6.73233 20.0002H17.0003V22.0002H5.01761C4.94008 22.0016 4.86194 21.994 4.78481 21.977C4.77025 21.9737 4.7558 21.9702 4.74147 21.9664C4.6589 21.9442 4.57784 21.911 4.50028 21.8662C4.47106 21.8493 4.44301 21.8312 4.41616 21.812C4.30161 21.7294 4.20524 21.6232 4.1342 21.5004C4.06328 21.3774 4.01939 21.2406 4.00518 21.0999C4.00446 21.0926 4.00381 21.0852 4.00325 21.0779C3.98786 20.8832 4.02924 20.6821 4.13425 20.5002L6.38425 16.6031L8.1163 17.6031L6.73233 20.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$be14bce5d1430d55(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5065 3.62344L11.4835 5.39519C8.57378 4.51647 5.96968 4.9455 5.07207 6.50019C3.89477 8.53934 5.86239 12.1526 9.75027 14.3973C13.6382 16.642 17.7512 16.5393 18.9285 14.5002C19.8261 12.9455 18.8956 10.4758 16.6797 8.39519L17.7026 6.62344C20.7847 9.33215 22.1654 12.8936 20.6605 15.5002C18.8003 18.7223 13.4717 18.8552 8.75027 16.1294C4.0289 13.4035 1.47976 8.72227 3.34002 5.50019C4.84492 2.89362 8.61964 2.30867 12.5065 3.62344ZM15.8842 1.77295L17.6163 2.77295L12.6163 11.4332L10.8842 10.4332L15.8842 1.77295ZM6.73233 20.0002H17.0003V22.0002H5.01761C4.94008 22.0016 4.86194 21.994 4.78481 21.977C4.77025 21.9737 4.7558 21.9702 4.74147 21.9664C4.6589 21.9442 4.57784 21.911 4.50028 21.8662C4.47106 21.8493 4.44301 21.8312 4.41616 21.812C4.30161 21.7294 4.20524 21.6232 4.1342 21.5004C4.06328 21.3774 4.01939 21.2406 4.00518 21.0999C4.00446 21.0926 4.00381 21.0852 4.00325 21.0779C3.98786 20.8832 4.02924 20.6821 4.13425 20.5002L6.38425 16.6031L8.1163 17.6031L6.73233 20.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$339a609be7942037(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2C18.5523 2 19 2.44772 19 3V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2H18ZM15 15H13V17H15V15ZM11 15H9V17H11V15ZM13 6H11V8H9V10H10.999L11 12H13L12.999 10H15V8H13V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$90139ce6f24b4a39(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2C18.5523 2 19 2.44772 19 3V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2H18ZM17 4H7V20H17V4ZM15 15V17H13V15H15ZM11 15V17H9V15H11ZM13 6V8H15V10H12.999L13 12H11L10.999 10H9V8H11V6H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c5c40eb91f60c7b0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0001 12C17.5524 12 18.0001 12.4477 18.0001 13V22H6.00015V13C6.00015 12.4477 6.44786 12 7.00015 12H17.0001ZM10.0001 14H8.00015V16H10.0001V14ZM12.0001 6C14.3491 6 16.3827 7.34978 17.3678 9.31602L15.5787 10.2108C14.922 8.89991 13.5662 8 12.0001 8C10.4341 8 9.07833 8.89991 8.42163 10.2108L6.63247 9.31602C7.61755 7.34978 9.65122 6 12.0001 6ZM12.0001 2C15.9153 2 19.3049 4.24991 20.9466 7.5273L19.1576 8.42242C17.8443 5.80019 15.1325 4 12.0001 4C8.86783 4 6.15596 5.80019 4.84271 8.42242L3.05371 7.5273C4.69541 4.24991 8.08503 2 12.0001 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cb99d8e3dc5304f3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0001 12C17.5524 12 18.0001 12.4477 18.0001 13V22H16.0001V14H8.00015V22H6.00015V13C6.00015 12.4477 6.44786 12 7.00015 12H17.0001ZM12.0001 16V18H10.0001V16H12.0001ZM12.0001 6C14.3491 6 16.3827 7.34978 17.3678 9.31602L15.5787 10.2108C14.922 8.89991 13.5662 8 12.0001 8C10.4341 8 9.07833 8.89991 8.42163 10.2108L6.63247 9.31602C7.61755 7.34978 9.65122 6 12.0001 6ZM12.0001 2C15.9153 2 19.3049 4.24991 20.9466 7.5273L19.1576 8.42242C17.8443 5.80019 15.1325 4 12.0001 4C8.86783 4 6.15596 5.80019 4.84271 8.42242L3.05371 7.5273C4.69541 4.24991 8.08503 2 12.0001 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$564c5c081dff6bbb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM16.8201 17.0761C18.1628 15.8007 19 13.9981 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.0609 19 14.0666 18.764 14.9676 18.3417L13.9928 16.5871C13.3823 16.8527 12.7083 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12H14L16.8201 17.0761Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6e5105d16c28709c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$63f5fbc36e0472b6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.364 18.3638C21.8787 14.8491 21.8787 9.15061 18.364 5.63589L19.7782 4.22168C24.0739 8.51745 24.0739 15.4823 19.7782 19.778L18.364 18.3638ZM5.63604 5.63589C2.12132 9.15061 2.12132 14.8491 5.63604 18.3638L4.22183 19.778C-0.0739417 15.4823 -0.0739417 8.51745 4.22183 4.22168L5.63604 5.63589ZM15.5355 15.5353C17.4882 13.5827 17.4882 10.4168 15.5355 8.4642L16.9497 7.04999C19.6834 9.78366 19.6834 14.2158 16.9497 16.9495L15.5355 15.5353ZM8.46447 8.4642C6.51184 10.4168 6.51184 13.5827 8.46447 15.5353L7.05025 16.9495C4.31658 14.2158 4.31658 9.78366 7.05025 7.04999L8.46447 8.4642ZM12 13.9998C13.1046 13.9998 14 13.1044 14 11.9998C14 10.8952 13.1046 9.99981 12 9.99981C10.8954 9.99981 10 10.8952 10 11.9998C10 13.1044 10.8954 13.9998 12 13.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$39b49827e3cac4b7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.364 18.3638C21.8787 14.8491 21.8787 9.15061 18.364 5.63589L19.7782 4.22168C24.0739 8.51745 24.0739 15.4823 19.7782 19.778L18.364 18.3638ZM5.63604 5.63589C2.12132 9.15061 2.12132 14.8491 5.63604 18.3638L4.22183 19.778C-0.0739417 15.4823 -0.0739417 8.51745 4.22183 4.22168L5.63604 5.63589ZM15.5355 15.5353C17.4882 13.5827 17.4882 10.4168 15.5355 8.4642L16.9497 7.04999C19.6834 9.78366 19.6834 14.2158 16.9497 16.9495L15.5355 15.5353ZM8.46447 8.4642C6.51184 10.4168 6.51184 13.5827 8.46447 15.5353L7.05025 16.9495C4.31658 14.2158 4.31658 9.78366 7.05025 7.04999L8.46447 8.4642ZM12 13.9998C13.1046 13.9998 14 13.1044 14 11.9998C14 10.8952 13.1046 9.99981 12 9.99981C10.8954 9.99981 10 10.8952 10 11.9998C10 13.1044 10.8954 13.9998 12 13.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$916003d2a2ea7198(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 14.1364 21.3301 16.1162 20.1889 17.741L17 12H20C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.1502 20 16.1023 19.1517 17.5398 17.7716L18.5379 19.567C16.7848 21.083 14.4995 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 7C13.6569 7 15 8.34315 15 10V11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7ZM12 9C11.4872 9 11.0645 9.38604 11.0067 9.88338L11 10V11H13V10C13 9.48716 12.614 9.06449 12.1166 9.00673L12 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5caed75bacd2061e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 14.1364 21.3301 16.1162 20.1889 17.741L17 12H20C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.1502 20 16.1023 19.1517 17.5398 17.7716L18.5379 19.567C16.7848 21.083 14.4995 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 7C13.6569 7 15 8.34315 15 10V11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7ZM14 13H10V14H14V13ZM12 9C11.4872 9 11.0645 9.38604 11.0067 9.88338L11 10V11H13V10C13 9.48716 12.614 9.06449 12.1166 9.00673L12 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$68b72d22882eba5f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.0001 14V11H13.0001V14H18.0001C18.5524 14 19.0001 14.4477 19.0001 15V21C19.0001 21.5523 18.5524 22 18.0001 22H6.00015C5.44786 22 5.00015 21.5523 5.00015 21V15C5.00015 14.4477 5.44786 14 6.00015 14H11.0001ZM2.51074 8.83686C3.83432 4.86424 7.58275 2 12.0001 2C16.4176 2 20.166 4.86424 21.4896 8.83686L19.5917 9.46949C18.5328 6.29139 15.5341 4 12.0001 4C8.46623 4 5.46749 6.29139 4.40862 9.46949L2.51074 8.83686ZM6.3065 10.1021C7.10065 7.71854 9.34971 6 12.0001 6C14.6506 6 16.8996 7.71854 17.6938 10.1021L15.7959 10.7347C15.2665 9.1457 13.7671 8 12.0001 8C10.2332 8 8.73382 9.1457 8.20439 10.7347L6.3065 10.1021Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a20150a7310c31b0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.0001 14V11H13.0001V14H18.0001C18.5524 14 19.0001 14.4477 19.0001 15V21C19.0001 21.5523 18.5524 22 18.0001 22H6.00015C5.44786 22 5.00015 21.5523 5.00015 21V15C5.00015 14.4477 5.44786 14 6.00015 14H11.0001ZM2.51074 8.83686C3.83432 4.86424 7.58275 2 12.0001 2C16.4176 2 20.166 4.86424 21.4896 8.83686L19.5917 9.46949C18.5328 6.29139 15.5341 4 12.0001 4C8.46623 4 5.46749 6.29139 4.40862 9.46949L2.51074 8.83686ZM6.3065 10.1021C7.10065 7.71854 9.34971 6 12.0001 6C14.6506 6 16.8996 7.71854 17.6938 10.1021L15.7959 10.7347C15.2665 9.1457 13.7671 8 12.0001 8C10.2332 8 8.73382 9.1457 8.20439 10.7347L6.3065 10.1021ZM7.00015 16V20H17.0001V16H7.00015Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a42dd2c01e9650bb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3C12.9411 3 21 11.0589 21 21H18C18 12.7157 11.2843 6 3 6V3ZM3 10C9.07513 10 14 14.9249 14 21H11C11 16.5817 7.41828 13 3 13V10ZM3 17C5.20914 17 7 18.7909 7 21H3V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$65899b7128c2df3c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17C5.20914 17 7 18.7909 7 21H3V17ZM3 10C9.07513 10 14 14.9249 14 21H12C12 16.0294 7.97056 12 3 12V10ZM3 3C12.9411 3 21 11.0589 21 21H19C19 12.1634 11.8366 5 3 5V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c8672b40253ec900(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H17L20.7071 6.70711C20.8946 6.89464 21 7.149 21 7.41421V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM12 18C13.6569 18 15 16.6569 15 15C15 13.3431 13.6569 12 12 12C10.3431 12 9 13.3431 9 15C9 16.6569 10.3431 18 12 18ZM5 5V9H15V5H5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6bd665a4229e43eb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5V19H19V7.82843L16.1716 5H5ZM4 3H17L20.7071 6.70711C20.8946 6.89464 21 7.149 21 7.41421V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM12 18C10.3431 18 9 16.6569 9 15C9 13.3431 10.3431 12 12 12C13.6569 12 15 13.3431 15 15C15 16.6569 13.6569 18 12 18ZM6 6H15V10H6V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2bca045fe61cda1e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H18L20.7071 5.70711C20.8946 5.89464 21 6.149 21 6.41421V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM7 4V9H16V4H7ZM6 12V19H18V12H6ZM13 5H15V8H13V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b0bbca1fca7b619a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 19H19V6.82843L17.1716 5H16V9H7V5H5V19H6V12H18V19ZM4 3H18L20.7071 5.70711C20.8946 5.89464 21 6.149 21 6.41421V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM8 14V19H16V14H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$94e0f04493515d35(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 21V13H6V21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H17L21 7V20C21 20.5523 20.5523 21 20 21H18ZM16 21H8V15H16V21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$da974077d5cba436(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19V13H17V19H19V7.82843L16.1716 5H5V19H7ZM4 3H17L21 7V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM9 15V19H15V15H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3c384af86b44189e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.25705 5.67127L6.39362 7.80783C5.5184 8.97641 5 10.4277 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C10.4277 5 8.97641 5.5184 7.80783 6.39362L5.67127 4.25705C7.39514 2.84637 9.59873 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 9.59873 2.84637 7.39514 4.25705 5.67127ZM7.8284 9.24261L12 13.4142L13.4142 12L9.24261 7.8284C10.033 7.30488 10.9809 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 10.9809 7.30488 10.033 7.8284 9.24261Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8a83737b101ccbf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.67127 4.25705L13.4142 12L12 13.4142L8.55382 9.96803C8.20193 10.5635 8 11.2582 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.87494 14.3429 8.13693 12.2503 8.00771L10.4459 6.20323C10.9416 6.07067 11.4625 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 10.7042 6.41079 9.50428 7.10925 8.52347L5.68014 7.09436C4.62708 8.44904 4 10.1513 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C10.8915 4 9.83557 4.22547 8.8757 4.63306L7.37443 3.13179C8.75768 2.40883 10.3311 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 8.87842 3.43029 6.09091 5.67127 4.25705Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2d81d0cab9023321(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.25705 5.67127L12 13.4142L13.4142 12L5.67127 4.25705C7.39514 2.84637 9.59873 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 9.59873 2.84637 7.39514 4.25705 5.67127Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$42c824b0ee2655eb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.67127 4.25705L13.4142 12L12 13.4142L5.68014 7.09436C4.62708 8.44904 4 10.1513 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C11.0848 4 10.2054 4.15369 9.38641 4.43667L7.84921 2.89947C9.11354 2.32187 10.5192 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 8.87842 3.43029 6.09091 5.67127 4.25705Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f3a4fed43f92ac4d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.29289 6.70711L9 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V7.41421C4 7.149 4.10536 6.89464 4.29289 6.70711ZM15 5V9H17V5H15ZM12 5V9H14V5H12ZM9 5V9H11V5H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1ed706e91e4d32b5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7.82843V20H18V4H9.82843L6 7.82843ZM4.29289 6.70711L9 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V7.41421C4 7.149 4.10536 6.89464 4.29289 6.70711ZM15 5H17V9H15V5ZM12 5H14V9H12V5ZM9 6H11V9H9V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c11a3157cafd1fa7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V12.4196C4 12.1549 4.10493 11.901 4.29179 11.7135L5.8541 10.1464C5.94754 10.0526 6 9.92569 6 9.79335V3C6 2.44772 6.44772 2 7 2ZM15 4V8H17V4H15ZM12 4V8H14V4H12ZM9 4V8H11V4H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a9b10ce29e175706(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4V9.79335C8 10.455 7.73768 11.0897 7.27052 11.5584L6 12.8329V20H18V4H8ZM7 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V12.4196C4 12.1549 4.10493 11.901 4.29179 11.7135L5.8541 10.1464C5.94754 10.0526 6 9.92569 6 9.79335V3C6 2.44772 6.44772 2 7 2ZM15 5H17V9H15V5ZM12 5H14V9H12V5ZM9 5H11V9H9V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3fa756fcb4bbbb64(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8V10H18V8H15V2H17V6H22V8H20V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V8H2V6H7V2H9V8H6ZM13 2V8H11V2H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$82362be47bb70c5c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8V19H18V8H15V2H17V6H22V8H20V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V8H2V6H7V2H9V8H6ZM13 2V8H11V2H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8acf60a917d877de(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V11H3V4C3 3.44772 3.44772 3 4 3ZM3 13H21V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V13ZM7 16V18H10V16H7ZM7 6V8H10V6H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$46ddd8172a325c7c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11H19V5H5V11ZM21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4ZM19 13H5V19H19V13ZM7 15H10V17H7V15ZM7 7H10V9H7V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1738034b2862e413(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2.04932V11.9999H13V2.04932C18.0533 2.55104 22 6.81459 22 11.9999C22 17.5228 17.5228 21.9999 12 21.9999C6.47715 21.9999 2 17.5228 2 11.9999C2 6.81459 5.94668 2.55104 11 2.04932Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5fbd2c09f5ce0dc2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.26489 3.80698L7.41191 5.44558C5.34875 6.89247 4 9.28873 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 9.28873 18.6512 6.89247 16.5881 5.44558L17.7351 3.80698C20.3141 5.61559 22 8.61091 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 8.61091 3.68594 5.61559 6.26489 3.80698ZM11 12V2H13V12H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eef81b5e54510d06(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 3C16.2854 3 20.2201 4.49683 23.3108 6.99607L12.001 21L0.69043 6.99671C3.78127 4.49709 7.71632 3 12.001 3ZM12.001 5C8.97344 5 6.07837 5.84185 3.58046 7.39179L8.68934 13.7155C9.69848 13.256 10.8199 13 12.001 13C13.1822 13 14.3037 13.256 15.3128 13.7155L20.4208 7.39132C17.9231 5.84167 15.0283 5 12.001 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$142f74c382f7775(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 3C16.2854 3 20.2201 4.49683 23.3108 6.99607L12.001 21L0.69043 6.99671C3.78127 4.49709 7.71632 3 12.001 3ZM12.001 15C11.3076 15 10.6336 15.1174 10.0006 15.3409L12.0009 17.8169L14.0004 15.34C13.371 15.12 12.6944 15 12.001 15ZM12.001 5C8.97344 5 6.07837 5.84185 3.58046 7.39179L8.68934 13.7155C9.69848 13.256 10.8199 13 12.001 13C13.1822 13 14.3037 13.256 15.3128 13.7155L20.4208 7.39132C17.9231 5.84167 15.0283 5 12.001 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cb3f598ce54b3336(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 3C16.2854 3 20.2201 4.49683 23.3108 6.99607L12.001 21L0.69043 6.99671C3.78127 4.49709 7.71632 3 12.001 3ZM12.001 5C8.97344 5 6.07837 5.84185 3.58046 7.39179L6.759 11.327C8.31734 10.4807 10.103 10 12.001 10C13.8988 10 15.6843 10.4806 17.2425 11.3267L20.4208 7.39132C17.9231 5.84167 15.0283 5 12.001 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$330a41349c20e5d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 3C16.2854 3 20.2201 4.49683 23.3108 6.99607L12.001 21L0.69043 6.99671C3.78127 4.49709 7.71632 3 12.001 3ZM12.001 12C10.5805 12 9.23687 12.3291 8.04217 12.9152L12.0009 17.8169L15.9594 12.915C14.7648 12.329 13.4213 12 12.001 12ZM12.001 5C8.97344 5 6.07837 5.84185 3.58046 7.39179L6.759 11.327C8.31734 10.4807 10.103 10 12.001 10C13.8988 10 15.6843 10.4806 17.2425 11.3267L20.4208 7.39132C17.9231 5.84167 15.0283 5 12.001 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$17a31e03d1df0540(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 3C16.2854 3 20.2201 4.49683 23.3108 6.99607L12.001 21L0.69043 6.99671C3.78127 4.49709 7.71632 3 12.001 3ZM12.001 5C8.97344 5 6.07837 5.84185 3.58046 7.39179L5.48487 9.74853C7.40065 8.63663 9.62649 8 12.001 8C14.3756 8 16.6015 8.63667 18.5174 9.74863L20.4208 7.39132C17.9231 5.84167 15.0283 5 12.001 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$369940eccd893743(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 3C16.2854 3 20.2201 4.49683 23.3108 6.99607L12.001 21L0.69043 6.99671C3.78127 4.49709 7.71632 3 12.001 3ZM12.001 10C10.1033 10 8.31775 10.4806 6.75954 11.3267L12.0009 17.8169L17.2424 11.3266C15.6842 10.4805 13.8987 10 12.001 10ZM12.001 5C8.97344 5 6.07837 5.84185 3.58046 7.39179L5.48487 9.74853C7.40065 8.63663 9.62649 8 12.001 8C14.3756 8 16.6015 8.63667 18.5174 9.74863L20.4208 7.39132C17.9231 5.84167 15.0283 5 12.001 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b1fb431b3d91bbde(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 3C16.2854 3 20.2201 4.49683 23.3108 6.99607L22.4994 8H18.001L18.0004 13.571L12.001 21L0.69043 6.99671C3.78127 4.49709 7.71632 3 12.001 3ZM22.001 19V21H20.001V19H22.001ZM22.001 10V17H20.001V10H22.001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$46fabdbd42ba2a0e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 3C16.2854 3 20.2201 4.49683 23.3108 6.99607L22.0544 8.55224C19.3071 6.33059 15.8094 5 12.001 5C8.91207 5 6.02755 5.87535 3.58201 7.39152L12.0009 17.8169L18.0004 10.388V13.571L12.001 21L0.69043 6.99671C3.78127 4.49709 7.71632 3 12.001 3ZM22.001 19V21H20.001V19H22.001ZM22.001 10V17H20.001V10H22.001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b1c05bd7d22110a0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 3C16.2854 3 20.2201 4.49683 23.3108 6.99607L12.001 21L0.69043 6.99671C3.78127 4.49709 7.71632 3 12.001 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3ffb258c3732719d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 3C16.2854 3 20.2201 4.49683 23.3108 6.99607L12.001 21L0.69043 6.99671C3.78127 4.49709 7.71632 3 12.001 3ZM12.001 5C8.97344 5 6.07837 5.84185 3.58046 7.39179L12.0009 17.8169L20.4208 7.39132C17.9231 5.84167 15.0283 5 12.001 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$978cbbc84039db58(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.80864 1.39355L20.4863 19.0712L19.0721 20.4854L15.3894 16.8026L12.001 21.0002L0.69043 6.99686C1.60456 6.25759 2.59253 5.60601 3.64156 5.05491L1.39443 2.80777L2.80864 1.39355ZM12.001 3.00016C16.2854 3.00016 20.2201 4.49699 23.3108 6.99623L17.9044 13.6892L7.72553 3.511C9.09596 3.17714 10.5278 3.00016 12.001 3.00016Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e0e8098a8ad99ec3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.80864 1.39355L20.4863 19.0712L19.0721 20.4854L15.3894 16.8036L12.001 21.0002L0.69043 6.99686C1.60456 6.25759 2.59253 5.60601 3.64156 5.05491L1.39443 2.80777L2.80864 1.39355ZM3.58046 7.39195L12.0009 17.8171L13.9674 15.3806L5.13212 6.54451C4.60029 6.79768 4.08236 7.08052 3.58046 7.39195ZM12.001 3.00016C16.2854 3.00016 20.2201 4.49699 23.3108 6.99623L17.9044 13.6892L16.4824 12.2672L20.4208 7.39148C17.9231 5.84183 15.0283 5.00016 12.001 5.00016C11.1282 5.00016 10.2664 5.07013 9.42189 5.20686L7.72553 3.511C9.09596 3.17714 10.5278 3.00016 12.001 3.00016Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bc7b456f542c6db6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2H15L19.7071 6.70711C19.8946 6.89464 20 7.149 20 7.41421V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2ZM13 18V10H8V12H11V18H13ZM8 13V15H10V13H8ZM14 13V15H16V13H14ZM14 10V12H16V10H14ZM8 16V18H10V16H8ZM14 16V18H16V16H14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$267ec3ec5092da88(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4V20H18V7.82843L14.1716 4H6ZM5 2H15L19.7071 6.70711C19.8946 6.89464 20 7.149 20 7.41421V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2ZM13 10V18H11V12H8V10H13ZM8 13H10V15H8V13ZM14 13H16V15H14V13ZM14 10H16V12H14V10ZM8 16H10V18H8V16ZM14 16H16V18H14V16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e28dcb8ffcefecd0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2H15L19.7071 6.70711C19.8946 6.89464 20 7.149 20 7.41421V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2ZM8 12V18H16V12H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1214947590329763(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4V20H18V7.82843L14.1716 4H6ZM5 2H15L19.7071 6.70711C19.8946 6.89464 20 7.149 20 7.41421V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2ZM8 12H16V18H8V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2b7483dc1970137a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2H18C18.5523 2 19 2.44772 19 3V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2ZM12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c6c50d50bd37b584(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4V20H17V4H7ZM6 2H18C18.5523 2 19 2.44772 19 3V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2ZM12 17C12.5523 17 13 17.4477 13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5cee2fadb31ac655(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2ZM12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9b3c10a938b437d0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4V20H18V4H6ZM5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2ZM12 17C12.5523 17 13 17.4477 13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dbecb4cda99a02e7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4.00087C2 3.44811 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44463 22 4.00087V17.9991C22 18.5519 21.5447 19 21.0082 19H2.9918C2.44405 19 2 18.5554 2 17.9991V4.00087ZM5 20H19V22H5V20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fe97afcaa9a9a76(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4.00087C2 3.44811 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44463 22 4.00087V17.9991C22 18.5519 21.5447 19 21.0082 19H2.9918C2.44405 19 2 18.5554 2 17.9991V4.00087ZM4 5V17H20V5H4ZM5 20H19V22H5V20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f59be15463d2da0c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.4142 5.00004H21.0082C21.556 5.00004 22 5.44467 22 6.00091V19.9992C22 20.5519 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5554 2 19.9992V6.00091C2 5.44815 2.45531 5.00004 2.9918 5.00004H8.58579L6.05025 2.46451L7.46447 1.05029L11.4142 5.00004H12.5858L16.5355 1.05029L17.9497 2.46451L15.4142 5.00004Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$18a95562aa67fe54(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.4142 5.00004H21.0082C21.556 5.00004 22 5.44467 22 6.00091V19.9992C22 20.5519 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5554 2 19.9992V6.00091C2 5.44815 2.45531 5.00004 2.9918 5.00004H8.58579L6.05025 2.46451L7.46447 1.05029L11.4142 5.00004H12.5858L16.5355 1.05029L17.9497 2.46451L15.4142 5.00004ZM4 7.00004V19H20V7.00004H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1e59385d2b239a3f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12H20C20.5523 12 21 12.4477 21 13V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V13C3 12.4477 3.44772 12 4 12ZM5 2H19V10H5V2ZM9 5V7H11V5H9ZM13 5V7H15V5H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a7013aaa6b4cc7ef(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12H5V20H19V12ZM5 10V2H19V10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5ZM7 10H17V4H7V10ZM9 6H11V8H9V6ZM13 6H15V8H13V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3ec994fe48575dd4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20ZM19 16H5V20H19V16ZM17 17V19H15V17H17ZM12 2L8 6H11V11H13V6H16L12 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$18550b877deb9686(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2V4H5L4.999 14H18.999L19 4H16V2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H8ZM18.999 16H4.999L5 20H19L18.999 16ZM17 17V19H15V17H17ZM12 2L16 6H13V11H11V6H8L12 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ed19ab78850d84a0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L15 6H13V13.381L16 11.882L15.999 11H15V7H19V11H17.999L18 13.118L13 15.618L13.0009 17.171C14.1656 17.5831 15 18.6941 15 20C15 21.6569 13.6569 23 12 23C10.3431 23 9 21.6569 9 20C9 18.813 9.68934 17.7871 10.6895 17.3006L6 14L5.99892 11.7318C5.40172 11.3858 5 10.7398 5 10C5 8.89543 5.89543 8 7 8C8.10457 8 9 8.89543 9 10C9 10.7403 8.59783 11.3866 8.00007 11.7324L8 13L11 15.086V6H9L12 1Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9a16f4d37576b562(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L15 6H13V13.381L16 11.882L15.999 11H15V7H19V11H17.999L18 13.118L13 15.618L13.0009 17.171C14.1656 17.5831 15 18.6941 15 20C15 21.6569 13.6569 23 12 23C10.3431 23 9 21.6569 9 20C9 18.813 9.68934 17.7871 10.6895 17.3006L6 14L5.99892 11.7318C5.40172 11.3858 5 10.7398 5 10C5 8.89543 5.89543 8 7 8C8.10457 8 9 8.89543 9 10C9 10.7403 8.59783 11.3866 8.00007 11.7324L8 13L11 15.086V6H9L12 1ZM12 19C11.4477 19 11 19.4477 11 20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20C13 19.4477 12.5523 19 12 19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3302b874d5fabf6f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.689453 6.99659C3.78027 4.49704 7.71526 3 11.9999 3C16.2845 3 20.2195 4.49704 23.3104 6.99659L21.4253 9.33049C18.8496 7.24753 15.5704 6 11.9999 6C8.42937 6 5.15021 7.24753 2.57453 9.33049L0.689453 6.99659ZM3.83124 10.8864C6.0635 9.08119 8.90544 8 11.9999 8C15.0944 8 17.9363 9.08119 20.1686 10.8864L18.2835 13.2203C16.5664 11.8317 14.3803 11 11.9999 11C9.61954 11 7.43344 11.8317 5.71632 13.2203L3.83124 10.8864ZM6.97304 14.7763C8.34673 13.6653 10.0956 13 11.9999 13C13.9042 13 15.6531 13.6653 17.0268 14.7763L15.1417 17.1102C14.2831 16.4158 13.1901 16 11.9999 16C10.8097 16 9.71667 16.4158 8.85811 17.1102L6.97304 14.7763ZM10.1148 18.6661C10.63 18.2495 11.2858 18 11.9999 18C12.714 18 13.3698 18.2495 13.885 18.6661L11.9999 21L10.1148 18.6661Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bbbdb75287db7c54(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.689453 6.99659C3.78027 4.49704 7.71526 3 11.9999 3C16.2845 3 20.2195 4.49704 23.3104 6.99659L22.0536 8.55252C19.3062 6.3307 15.8085 5 11.9999 5C8.19133 5 4.69356 6.3307 1.94617 8.55252L0.689453 6.99659ZM3.83124 10.8864C6.0635 9.08119 8.90544 8 11.9999 8C15.0944 8 17.9363 9.08119 20.1686 10.8864L18.9118 12.4424C17.023 10.9149 14.6183 10 11.9999 10C9.38151 10 6.97679 10.9149 5.08796 12.4424L3.83124 10.8864ZM6.97304 14.7763C8.34673 13.6653 10.0956 13 11.9999 13C13.9042 13 15.6531 13.6653 17.0268 14.7763L15.7701 16.3322C14.7398 15.499 13.4281 15 11.9999 15C10.5717 15 9.26002 15.499 8.22975 16.3322L6.97304 14.7763ZM10.1148 18.6661C10.63 18.2495 11.2858 18 11.9999 18C12.714 18 13.3698 18.2495 13.885 18.6661L11.9999 21L10.1148 18.6661Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8133019367d9e794(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0001 18.0002C12.7144 18.0002 13.3704 18.2498 13.8856 18.6666L12.0001 21.0002L10.1145 18.6666C10.6297 18.2498 11.2857 18.0002 12.0001 18.0002ZM2.80766 1.39355L20.4853 19.0712L19.0711 20.4854L15.3895 16.8046L15.1425 17.1108C14.2838 16.4162 13.1905 16.0002 12.0001 16.0002C10.81 16.0002 9.71712 16.4159 8.85862 17.11L6.97363 14.7761C8.24961 13.7443 9.84925 13.097 11.5964 13.0102L9.82328 11.2378C8.29284 11.5775 6.89439 12.2679 5.71658 13.2204L3.83099 10.8869C4.89946 10.0228 6.10763 9.3245 7.41633 8.8313L5.88489 7.29919C4.69082 7.83295 3.5793 8.51822 2.57479 9.33056L0.689453 6.99686C1.60358 6.25759 2.59156 5.60601 3.64058 5.05491L1.39345 2.80777L2.80766 1.39355ZM16.0844 11.8696L12.2165 8.00255L12.0001 8.00016C15.0948 8.00016 17.9369 9.08154 20.1693 10.887L18.284 13.2207C17.6163 12.6808 16.8777 12.225 16.0844 11.8696ZM12.0001 3.00016C16.2849 3.00016 20.22 4.49731 23.3109 6.99703L21.4254 9.3306C18.8497 7.24767 15.5706 6.00016 12.0001 6.00016C11.4284 6.00016 10.8642 6.03214 10.3091 6.09441L7.72455 3.511C9.09498 3.17714 10.5268 3.00016 12.0001 3.00016Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$66d9d239890230ed(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0001 18.0002C12.7144 18.0002 13.3704 18.2498 13.8856 18.6666L12.0001 21.0002L10.1145 18.6666C10.6297 18.2498 11.2857 18.0002 12.0001 18.0002ZM2.80766 1.39355L20.4853 19.0712L19.0711 20.4854L13.8913 15.3043C13.2967 15.107 12.6609 15.0002 12.0001 15.0002C10.5719 15.0002 9.26024 15.4991 8.22998 16.3323L6.97363 14.7761C8.24961 13.7443 9.84925 13.097 11.5964 13.0102L9.00025 10.4142C7.55273 10.8235 6.22651 11.5218 5.0878 12.4428L3.83099 10.8869C4.89946 10.0228 6.10763 9.3245 7.41633 8.8313L5.13168 6.54522C3.98878 7.08925 2.92058 7.76484 1.94666 8.5524L0.689453 6.99686C1.60358 6.25759 2.59156 5.60601 3.64058 5.05491L1.39345 2.80777L2.80766 1.39355ZM14.5004 10.2856L12.2165 8.00255L12 8.00012C15.0947 8.00012 17.9369 9.08154 20.1693 10.887L18.9123 12.4428C17.6438 11.4169 16.1427 10.6673 14.5004 10.2856ZM12.0001 3.00016C16.2849 3.00016 20.22 4.49731 23.3109 6.99703L22.0534 8.5524C19.3061 6.33074 15.8085 5.00016 12.0001 5.00016C11.122 5.00016 10.2604 5.07089 9.42075 5.20697L7.72455 3.511C9.09498 3.17714 10.5268 3.00016 12.0001 3.00016Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3b2973dc48d700b5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.92887 4.92871L5.34315 6.34298C3.89543 7.7907 3 9.7907 3 11.9998C3 14.209 3.89543 16.209 5.34315 17.6567L3.92887 19.071C2.11925 17.2613 1 14.7613 1 11.9998C1 9.23834 2.11925 6.73834 3.92887 4.92871ZM20.0711 4.92871C21.8808 6.73834 23 9.23834 23 11.9998C23 14.7613 21.8808 17.2613 20.0711 19.071L18.6569 17.6567C20.1046 16.209 21 14.209 21 11.9998C21 9.79121 20.105 7.79162 18.6579 6.34398L20.0711 4.92871ZM13 4.99984V10.9998H16L11 18.9998V12.9998H8L13 4.99984ZM6.75736 7.7572L8.17157 9.17141C7.44771 9.89527 7 10.8953 7 11.9998C7 13.1044 7.44771 14.1044 8.17157 14.8283L6.75736 16.2425C5.67157 15.1567 5 13.6567 5 11.9998C5 10.343 5.67157 8.84298 6.75736 7.7572ZM17.2436 7.75818C18.3288 8.84388 19 10.3435 19 11.9998C19 13.6567 18.3284 15.1567 17.2426 16.2425L15.8284 14.8283C16.5523 14.1044 17 13.1044 17 11.9998C17 10.8958 16.5527 9.89618 15.8294 9.17241L17.2436 7.75818Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2add6b458cf25cab(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.92887 4.92871L5.34315 6.34298C3.89543 7.7907 3 9.7907 3 11.9998C3 14.209 3.89543 16.209 5.34315 17.6567L3.92887 19.071C2.11925 17.2613 1 14.7613 1 11.9998C1 9.23834 2.11925 6.73834 3.92887 4.92871ZM20.0711 4.92871C21.8808 6.73834 23 9.23834 23 11.9998C23 14.7613 21.8808 17.2613 20.0711 19.071L18.6569 17.6567C20.1046 16.209 21 14.209 21 11.9998C21 9.79121 20.105 7.79162 18.6579 6.34398L20.0711 4.92871ZM13 4.99984V10.9998H16L11 18.9998V12.9998H8L13 4.99984ZM6.75736 7.7572L8.17157 9.17141C7.44771 9.89527 7 10.8953 7 11.9998C7 13.1044 7.44771 14.1044 8.17157 14.8283L6.75736 16.2425C5.67157 15.1567 5 13.6567 5 11.9998C5 10.343 5.67157 8.84298 6.75736 7.7572ZM17.2436 7.75818C18.3288 8.84388 19 10.3435 19 11.9998C19 13.6567 18.3284 15.1567 17.2426 16.2425L15.8284 14.8283C16.5523 14.1044 17 13.1044 17 11.9998C17 10.8958 16.5527 9.89618 15.8294 9.17241L17.2436 7.75818Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6d00b501ab6ba210(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM7 6V10H11V6H7ZM7 12V14H17V12H7ZM7 16V18H17V16H7ZM13 7V9H17V7H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$265a0b030c2739a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM7 6H11V10H7V6ZM7 12H17V14H7V12ZM7 16H17V18H7V16ZM13 7H17V9H13V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a4dbb7044d55615(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM8 9V11H16V9H8ZM8 13V15H16V13H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1ff58b5084797ca(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM8 9H16V11H8V9ZM8 13H16V15H8V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d4124090375c2f97(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18H6C5.44772 18 5 18.4477 5 19C5 19.5523 5.44772 20 6 20H21V22H6C4.34315 22 3 20.6569 3 19V4C3 2.89543 3.89543 2 5 2H21V18ZM16 9V7H8V9H16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fb9871a850330257(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18H6C5.44772 18 5 18.4477 5 19C5 19.5523 5.44772 20 6 20H21V22H6C4.34315 22 3 20.6569 3 19V4C3 2.89543 3.89543 2 5 2H21V18ZM5 16.05C5.16156 16.0172 5.32877 16 5.5 16H19V4H5V16.05ZM16 9H8V7H16V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$64671199f5430b8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H7C5.89543 4 5 4.89543 5 6C5 7.10457 5.89543 8 7 8H21V21C21 21.5523 20.5523 22 20 22H7C4.79086 22 3 20.2091 3 18V6C3 3.79086 4.79086 2 7 2H20C20.5523 2 21 2.44772 21 3V4ZM20 7H7C6.44772 7 6 6.55228 6 6C6 5.44772 6.44772 5 7 5H20V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$782bbe407f3f03f8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H7C5.89543 4 5 4.89543 5 6C5 7.10457 5.89543 8 7 8H21V21C21 21.5523 20.5523 22 20 22H7C4.79086 22 3 20.2091 3 18V6C3 3.79086 4.79086 2 7 2H20C20.5523 2 21 2.44772 21 3V4ZM5 18C5 19.1046 5.89543 20 7 20H19V10H7C6.27143 10 5.58835 9.80521 5 9.46487V18ZM20 7H7C6.44772 7 6 6.55228 6 6C6 5.44772 6.44772 5 7 5H20V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$732a0f89db137a7b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H6.5C4.567 22 3 20.433 3 18.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V17H6.5C5.67157 17 5 17.6716 5 18.5C5 19.3284 5.67157 20 6.5 20H19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$da8b935d3b3deed3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H6.5C4.567 22 3 20.433 3 18.5ZM19 20V17H6.5C5.67157 17 5 17.6716 5 18.5C5 19.3284 5.67157 20 6.5 20H19ZM5 15.3368C5.45463 15.1208 5.9632 15 6.5 15H19V4H6C5.44772 4 5 4.44772 5 5V15.3368Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dd607ec427a69098(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H6.5C4.567 22 3 20.433 3 18.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V17H6.5C5.67157 17 5 17.6716 5 18.5C5 19.3284 5.67157 20 6.5 20H19ZM10 4V12L13.5 10L17 12V4H10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b7a0fa8306caf1fd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H6.5C4.567 22 3 20.433 3 18.5ZM19 20V17H6.5C5.67157 17 5 17.6716 5 18.5C5 19.3284 5.67157 20 6.5 20H19ZM10 4H6C5.44772 4 5 4.44772 5 5V15.3368C5.45463 15.1208 5.9632 15 6.5 15H19V4H17V12L13.5 10L10 12V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$efc8923b0e6efc1d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 21H13V6C13 4.34315 14.3431 3 16 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21ZM11 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H8C9.65685 3 11 4.34315 11 6V21ZM11 21H13V23H11V21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a894ac62cc1b1f45(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 21V23H11V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H9C10.1947 3 11.2671 3.52375 12 4.35418C12.7329 3.52375 13.8053 3 15 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H13ZM20 19V5H15C13.8954 5 13 5.89543 13 7V19H20ZM11 19V7C11 5.89543 10.1046 5 9 5H4V19H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9e54a90b37448ea9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM12 5V19H20V5H12ZM13 7H19V9H13V7ZM13 10H19V12H13V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f0e76cbc3d5acf4a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM11 5H4V19H11V5ZM13 5V19H20V5H13ZM14 7H19V9H14V7ZM14 10H19V12H14V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ed45303d1f875df6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2V22H4V18H2V16H4V13H2V11H4V8H2V6H4V2H8ZM20.0049 2C21.1068 2 22 2.89821 22 3.9908V20.0092C22 21.1087 21.1074 22 20.0049 22H10V2H20.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$947c369684e5d491(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.0049 2C21.1068 2 22 2.89821 22 3.9908V20.0092C22 21.1087 21.1074 22 20.0049 22H4V18H2V16H4V13H2V11H4V8H2V6H4V2H20.0049ZM8 4H6V20H8V4ZM20 4H10V20H20V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a5cb2b10ee833b34(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4V8H18V4H20.0066C20.5552 4 21 4.44495 21 4.9934V21.0066C21 21.5552 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5551 3 21.0066V4.9934C3 4.44476 3.44495 4 3.9934 4H6ZM8 2H16V6H8V2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ea357e34ccebc2dd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4V2H17V4H20.0066C20.5552 4 21 4.44495 21 4.9934V21.0066C21 21.5552 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5551 3 21.0066V4.9934C3 4.44476 3.44495 4 3.9934 4H7ZM7 6H5V20H19V6H17V8H7V6ZM9 4V6H15V4H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$54aec2053845f7bb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H6C4.34315 22 3 20.6569 3 19V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V18H6C5.44772 18 5 18.4477 5 19C5 19.5523 5.44772 20 6 20H19ZM12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10ZM9 14H15C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$47fd6930d69c49d4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H6C4.34315 22 3 20.6569 3 19V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V18H6C5.44772 18 5 18.4477 5 19C5 19.5523 5.44772 20 6 20H19ZM5 16.1707C5.31278 16.0602 5.64936 16 6 16H19V4H6C5.44772 4 5 4.44772 5 5V16.1707ZM12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8C14 9.10457 13.1046 10 12 10ZM9 14C9 12.3431 10.3431 11 12 11C13.6569 11 15 12.3431 15 14H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fc1d2828f75f62e4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2V22H3V2H7ZM9 2H19.0049C20.1068 2 21 2.89821 21 3.9908V20.0092C21 21.1087 20.1074 22 19.0049 22H9V2ZM22 6H24V10H22V6ZM22 12H24V16H22V12ZM15 12C16.1046 12 17 11.1046 17 10C17 8.89543 16.1046 8 15 8C13.8954 8 13 8.89543 13 10C13 11.1046 13.8954 12 15 12ZM12 16H18C18 14.3431 16.6569 13 15 13C13.3431 13 12 14.3431 12 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$56b42a2123bb3783(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2H19.0049C20.1068 2 21 2.89821 21 3.9908V20.0092C21 21.1087 20.1074 22 19.0049 22H3V2ZM7 4H5V20H7V4ZM9 20H19V4H9V20ZM11 16C11 14.3431 12.3431 13 14 13C15.6569 13 17 14.3431 17 16H11ZM14 12C12.8954 12 12 11.1046 12 10C12 8.89543 12.8954 8 14 8C15.1046 8 16 8.89543 16 10C16 11.1046 15.1046 12 14 12ZM22 6H24V10H22V6ZM22 12H24V16H22V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$70b38c57c526fdcc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2V22H3V2H7ZM19.0049 2C20.1068 2 21 2.89821 21 3.9908V20.0092C21 21.1087 20.1074 22 19.0049 22H9V2H19.0049ZM15 8L11 12H14V16H16V12H19L15 8ZM24 12V16H22V12H24ZM24 6V10H22V6H24Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4d322ee64916135e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.0049 2C20.1068 2 21 2.89821 21 3.9908V20.0092C21 21.1087 20.1074 22 19.0049 22H3V2H19.0049ZM7 4H5V20H7V4ZM19 4H9V20H19V4ZM14 8L18 12H15V16H13V12H10L14 8ZM24 12V16H22V12H24ZM24 6V10H22V6H24Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1eaa7427391dd720(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2C20.5523 2 21 2.44772 21 3V6.757L12.0012 15.7562L11.995 19.995L16.2414 20.0012L21 15.242V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20ZM21.7782 8.80761L23.1924 10.2218L15.4142 18L13.9979 17.9979L14 16.5858L21.7782 8.80761ZM12 12H7V14H12V12ZM15 8H7V10H15V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$adf154b2e6a6593e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2C20.5523 2 21 2.44772 21 3V6.757L19 8.757V4H5V20H19V17.242L21 15.242V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20ZM21.7782 8.80761L23.1924 10.2218L15.4142 18L13.9979 17.9979L14 16.5858L21.7782 8.80761ZM13 12V14H8V12H13ZM16 8V10H8V8H16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$694e04bfa0367e40(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9H9C9.55228 9 10 8.55228 10 8V2H20.0017C20.5531 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5511 3 20.9925V9ZM3 7L8 2.00318V7H3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a9ddd8dc06677467(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8ZM10 4V9H5V20H19V4H10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e0e4f0c103c8e10e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9V20.9925C21 21.5511 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.44694 2 3.99826 2H14V8C14 8.55228 14.4477 9 15 9H21ZM21 7H16V2.00318L21 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$42d7103ab2aa2f88(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8ZM19 9H14V4H5V20H19V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d124b01d47aa5731(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15H14V22H3.99826C3.44694 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H20.0066C20.5552 2 21 2.44892 21 3.00748V15ZM21 17L16 21.9968V17H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eb45199045b8c893(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16L14.9968 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V16ZM19 15V4H5V20H14V15H19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7d97641c259fc269(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM11 11H8V13H11V16H13V13H16V11H13V8H11V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5cbebdd3d63cc07c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM11 11V8H13V11H16V13H13V16H11V13H8V11H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$50797cd34dd09d65(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12H12V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$98934cb9163da140(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM12 8V12H16C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cb926908725944f3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM11 7V17H13V7H11ZM15 11V17H17V11H15ZM7 13V17H9V13H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$43082efa87712fbb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7H13V17H11V7ZM15 11H17V17H15V11ZM7 13H9V17H7V13ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9524530ff4e0ea92(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13C19.0928 13 20.1174 13.2922 20.9999 13.8026L20.9998 7L16 2H3.9985C3.44749 2 3 2.44405 3 2.9918V21.0082C3 21.5447 3.44476 22 3.9934 22H12.8027C12.2922 21.1175 12 20.0929 12 19C12 15.6863 14.6863 13 18 13ZM21.5356 21.1212L19.4143 18.9999L21.5356 16.8786L20.1214 15.4644L18.0001 17.5857L15.8788 15.4644L14.4646 16.8786L16.5859 18.9999L14.4646 21.1212L15.8788 22.5354L18.0001 20.4141L20.1214 22.5354L21.5356 21.1212Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c5f28e1f7c1066c0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22V20H5V4H15V8H19V13H20.9998V7L16 2H3.9985C3.44749 2 3 2.44405 3 2.9918V21.0082C3 21.5447 3.44476 22 3.9934 22H12ZM21.5356 21.1212L19.4143 18.9999L21.5356 16.8786L20.1214 15.4644L18.0001 17.5857L15.8788 15.4644L14.4646 16.8786L16.5859 18.9999L14.4646 21.1212L15.8788 22.5354L18.0001 20.4141L20.1214 22.5354L21.5356 21.1212Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3c538788bb2c9905(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.9968 2L21 8L21.0012 12.2606C20.0501 11.4722 18.8302 11 17.5 11L17.2788 11.0044C14.784 11.103 12.7164 12.8635 12.1523 15.2093L12.136 15.283L12.1068 15.3024C10.8223 16.1634 10 17.6255 10 19.25C10 20.273 10.3242 21.2231 10.8771 22.0006L3.9934 22C3.48412 22 3.06409 21.6171 3.00669 21.1239L3 21.0082V2.9918C3 2.49363 3.38689 2.06546 3.88533 2.00683L4.00221 2H14.9968ZM17.5 13C19.433 13 21 14.567 21 16.5L20.9985 16.6033C22.1531 16.9285 23 17.9903 23 19.25C23 20.7125 21.8583 21.9084 20.4175 21.995L20.25 22H14.75L14.5825 21.995C13.1417 21.9084 12 20.7125 12 19.25C12 17.99 12.8474 16.9279 14.0034 16.6025L14 16.5C14 14.567 15.567 13 17.5 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$68ff40024e09e995(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.9968 2L21 8L21.0012 12.2606C20.4221 11.7806 19.7434 11.4178 19.0008 11.2074L19 9H14V4H5V20L10.0591 20.0009C10.1761 20.7365 10.4622 21.4172 10.8771 22.0006L3.9934 22C3.48412 22 3.06409 21.6171 3.00669 21.1239L3 21.0082V2.9918C3 2.49363 3.38689 2.06546 3.88533 2.00683L4.00221 2H14.9968ZM17.5 13C19.433 13 21 14.567 21 16.5L20.9985 16.6033C22.1531 16.9285 23 17.9903 23 19.25C23 20.7125 21.8583 21.9084 20.4175 21.995L20.25 22H14.75L14.5825 21.995C13.1417 21.9084 12 20.7125 12 19.25C12 17.99 12.8474 16.9279 14.0034 16.6025L14 16.5C14 14.567 15.567 13 17.5 13ZM17.5 15C16.769 15 16.1602 15.5229 16.027 16.215L16.0069 16.3555L16 16.5V18.12L14.5559 18.5256C14.1558 18.6328 13.9183 19.044 14.0256 19.4441C14.105 19.7405 14.3512 19.9476 14.6362 19.9915L14.7446 20.0002H20.2554C20.5846 19.998 20.8851 19.7775 20.9744 19.4441C21.0817 19.044 20.8442 18.6328 20.4441 18.5256L19.4322 18.2432L19 18.12V16.5L18.9931 16.3555C18.9204 15.5949 18.2797 15 17.5 15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a660d4e5069ce0ad(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM17.6569 12L14.1213 8.46447L12.7071 9.87868L14.8284 12L12.7071 14.1213L14.1213 15.5355L17.6569 12ZM6.34315 12L9.87868 15.5355L11.2929 14.1213L9.17157 12L11.2929 9.87868L9.87868 8.46447L6.34315 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dc814e2fc74f9217(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM17.6569 12L14.1213 15.5355L12.7071 14.1213L14.8284 12L12.7071 9.87868L14.1213 8.46447L17.6569 12ZM6.34315 12L9.87868 8.46447L11.2929 9.87868L9.17157 12L11.2929 14.1213L9.87868 15.5355L6.34315 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d653b15f4b8e5def(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6ZM6.9998 11V13H12.9998V11H6.9998ZM6.9998 15V17H12.9998V15H6.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f7cfb3b4715ed467(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM5.00242 8L5.00019 20H14.9998V8H5.00242ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6ZM7 11H13V13H7V11ZM7 15H13V17H7V15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c034fcb567306c48(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f080236d9d59ba7d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM5.00242 8L5.00019 20H14.9998V8H5.00242ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fb2abc9c18c23e93(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14L7 16.5L10 13L13 17L15 14.5L18 15L15 12L13 14.5L10 9.5L6.5 13.25L3 10V2.9918C3 2.45531 3.44694 2 3.99826 2H14V8C14 8.55228 14.4477 9 15 9H21V20.9925C21 21.5511 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V14ZM21 7H16V2.00318L21 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$afc42510c78a01b8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9H14V4H5V11.8571L6.5 13.25L10 9.5L13 14.5L15 12L18 15L15 14.5L13 17L10 13L7 16.5L5 15.25V20H19V9ZM21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cb1de02fb01fa397(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM13 12V8H11V12H8L12 16L16 12H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bbe85508439cf848(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12H16L12 16L8 12H11V8H13V12ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d017b8ac1798b020(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15.2426V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5511 3 20.9925V9H9C9.55228 9 10 8.55228 10 8V2H20.0017C20.5531 2 21 2.45531 21 2.9918V6.75736L12.0012 15.7562L11.995 19.995L16.2414 20.0012L21 15.2426ZM21.7782 8.80761L23.1924 10.2218L15.4142 18L13.9979 17.9979L14 16.5858L21.7782 8.80761ZM3 7L8 2.00318V7H3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a546612730588347(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6.75736L19 8.75736V4H10V9H5V20H19V17.2426L21 15.2426V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V6.75736ZM21.7782 8.80761L23.1924 10.2218L15.4142 18L13.9979 17.9979L14 16.5858L21.7782 8.80761Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f22120139c6c1de0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.85858 2.87756L15.4293 1.08175C15.7027 1.0427 15.9559 1.23265 15.995 1.50601C15.9983 1.52943 16 1.55306 16 1.57672V22.4237C16 22.6999 15.7761 22.9237 15.5 22.9237C15.4763 22.9237 15.4527 22.922 15.4293 22.9187L2.85858 21.1229C2.36593 21.0525 2 20.6306 2 20.1329V3.86751C2 3.36986 2.36593 2.94794 2.85858 2.87756ZM17 3.00022H21C21.5523 3.00022 22 3.44793 22 4.00022V20.0002C22 20.5525 21.5523 21.0002 21 21.0002H17V3.00022ZM10.2 12.0002L13 8.00022H10.6L9 10.2859L7.39999 8.00022H5L7.8 12.0002L5 16.0002H7.39999L9 13.7145L10.6 16.0002H13L10.2 12.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$361af5da18e2248a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.85858 2.87756L15.4293 1.08175C15.7027 1.0427 15.9559 1.23265 15.995 1.50601C15.9983 1.52943 16 1.55306 16 1.57672V22.4237C16 22.6999 15.7761 22.9237 15.5 22.9237C15.4763 22.9237 15.4527 22.922 15.4293 22.9187L2.85858 21.1229C2.36593 21.0525 2 20.6306 2 20.1329V3.86751C2 3.36986 2.36593 2.94794 2.85858 2.87756ZM4 4.73481V19.2656L14 20.6942V3.30624L4 4.73481ZM17 19.0002H20V5.00022H17V3.00022H21C21.5523 3.00022 22 3.44793 22 4.00022V20.0002C22 20.5525 21.5523 21.0002 21 21.0002H17V19.0002ZM10.2 12.0002L13 16.0002H10.6L9 13.7145L7.39999 16.0002H5L7.8 12.0002L5 8.00022H7.39999L9 10.2859L10.6 8.00022H13L10.2 12.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7637bf7de66a8ab1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM13.2 12L16 8H13.6L12 10.2857L10.4 8H8L10.8 12L8 16H10.4L12 13.7143L13.6 16H16L13.2 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7cdb41b338107bda(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.2 12L16 16H13.6L12 13.7143L10.4 16H8L10.8 12L8 8H10.4L12 10.2857L13.6 8H15V4H5V20H19V8H16L13.2 12ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$940580ac12da1a45(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8ZM10 3.5L4.5 9H10V3.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fbbf777cf1f572b9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.6736C20.0907 11.2417 19.0736 11 18 11C14.134 11 11 14.134 11 18C11 19.4872 11.4638 20.8662 12.2547 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16L21 7V11.6736ZM18 23C15.2386 23 13 20.7614 13 18C13 15.2386 15.2386 13 18 13C20.7614 13 23 15.2386 23 18C23 20.7614 20.7614 23 18 23ZM16.7066 20.7076C17.0982 20.895 17.5369 21 18 21C19.6569 21 21 19.6569 21 18C21 17.5369 20.895 17.0982 20.7076 16.7066L16.7066 20.7076ZM15.2924 19.2934L19.2934 15.2924C18.9018 15.105 18.4631 15 18 15C16.3431 15 15 16.3431 15 18C15 18.4631 15.105 18.9018 15.2924 19.2934Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$753226b2c92ba633(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.2899 20C11.5049 20.7224 11.8334 21.396 12.2547 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9998 7V11.6735C20.3781 11.3782 19.7061 11.1719 19 11.0709V8H15V4H5V20H11.2899ZM18 23C15.2386 23 13 20.7614 13 18C13 15.2386 15.2386 13 18 13C20.7614 13 23 15.2386 23 18C23 20.7614 20.7614 23 18 23ZM16.7066 20.7076C17.0982 20.895 17.5369 21 18 21C19.6569 21 21 19.6569 21 18C21 17.5369 20.895 17.0982 20.7076 16.7066L16.7066 20.7076ZM15.2924 19.2934L19.2934 15.2924C18.9018 15.105 18.4631 15 18 15C16.3431 15 15 16.3431 15 18C15 18.4631 15.105 18.9018 15.2924 19.2934Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ead71a53ac5982c7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44749 2 3.9985 2H16ZM13 10H12V15H13V10ZM11 10H9C7.89543 10 7 10.8954 7 12V13C7 14.1046 7.89543 15 9 15H10C10.5523 15 11 14.5523 11 14V12H9V13H10V14H9C8.44772 14 8 13.5523 8 13V12C8 11.4477 8.44772 11 9 11H11V10ZM17 10H14V15H15V13H17V12H15V11H17V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$52fe4e5c67a2f6e7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44749 2 3.9985 2H16ZM15 4H5V20H19V8H15V4ZM13 10V15H12V10H13ZM11 10V11H9C8.44772 11 8 11.4477 8 12V13C8 13.5523 8.44772 14 9 14H10V13H9V12H11V14C11 14.5523 10.5523 15 10 15H9C7.89543 15 7 14.1046 7 13V12C7 10.8954 7.89543 10 9 10H11ZM17 10V11H15V12H17V13H15V15H14V10H17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$57e9225960f617ae(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 6.999V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM13 9H11V15H16V13H13V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7c558431bbe49344(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44749 2 3.9985 2H16ZM15 4H5V20H19V8H15V4ZM13 9V13H16V15H11V9H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$42d8425967e90104(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44749 2 3.9985 2H16ZM9.33333 14.6667H8V18H16V16.6667L9.333 16.666L9.33333 14.6667ZM12 14.3333C11.4477 14.3333 11 14.781 11 15.3333C11 15.8856 11.4477 16.3333 12 16.3333C12.5523 16.3333 13 15.8856 13 15.3333C13 14.781 12.5523 14.3333 12 14.3333ZM12 9C10.6193 9 9.5 10.1193 9.5 11.5C9.5 12.8807 10.6193 14 12 14C13.3807 14 14.5 12.8807 14.5 11.5C14.5 10.1193 13.3807 9 12 9ZM12 10.3333C12.6443 10.3333 13.1667 10.8557 13.1667 11.5C13.1667 12.1443 12.6443 12.6667 12 12.6667C11.3557 12.6667 10.8333 12.1443 10.8333 11.5C10.8333 10.8557 11.3557 10.3333 12 10.3333ZM12.6667 6H11.3333L11.333 7.333L8 7.33333V8.66667H16V7.33333L12.666 7.333L12.6667 6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a1f582f7968c2239(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44749 2 3.9985 2H16ZM16 8.66667H8V7.33333L11.333 7.333L11.3333 6H12.6667L12.666 7.333H14.999L15 4H5V20H19V8L16 7.999V8.66667ZM9.33333 14.6667L9.333 16.666L16 16.6667V18H8V14.6667H9.33333ZM12 14.3333C12.5523 14.3333 13 14.781 13 15.3333C13 15.8856 12.5523 16.3333 12 16.3333C11.4477 16.3333 11 15.8856 11 15.3333C11 14.781 11.4477 14.3333 12 14.3333ZM12 9C13.3807 9 14.5 10.1193 14.5 11.5C14.5 12.8807 13.3807 14 12 14C10.6193 14 9.5 12.8807 9.5 11.5C9.5 10.1193 10.6193 9 12 9ZM12 10.3333C11.3557 10.3333 10.8333 10.8557 10.8333 11.5C10.8333 12.1443 11.3557 12.6667 12 12.6667C12.6443 12.6667 13.1667 12.1443 13.1667 11.5C13.1667 10.8557 12.6443 10.3333 12 10.3333Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4c02fb387f1005e8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7L16 2H3.9934C3.44495 2 3 2.44405 3 2.9918V21.0082C3 21.5447 3.44476 22 3.9934 22H20.0066C20.5551 22 21 21.556 21 21.0082V7ZM11 9.5C11 10.3284 10.3284 11 9.5 11C8.67157 11 8 10.3284 8 9.5C8 8.67157 8.67157 8 9.5 8C10.3284 8 11 8.67157 11 9.5ZM17.5 17H8L13.5 10L17.5 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dae4668289b5133c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8V4H5V20H19V8H15ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM11 9.5C11 10.3284 10.3284 11 9.5 11C8.67157 11 8 10.3284 8 9.5C8 8.67157 8.67157 8 9.5 8C10.3284 8 11 8.67157 11 9.5ZM17.5 17L13.5 10L8 17H17.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ceea5b298ff2d85d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM11 7V9H13V7H11ZM11 11V17H13V11H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9e9f35edbed77803(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM11 11H13V17H11V11ZM11 7H13V9H11V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$418f6d9aa5f98a7d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2.00318V2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8L9 2.00318ZM5.82918 8H9V4.83086L5.82918 8ZM11 4V9C11 9.55228 10.5523 10 10 10H5V20H19V4H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$365bbb3f01dd5c04(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM8 7V9H16V7H8ZM8 11V13H16V11H8ZM8 15V17H13V15H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$db2dd47393737147(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM8 7H16V9H8V7ZM8 11H16V13H8V11ZM8 15H13V17H8V15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7b0b66689734cd4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 22H5C3.34315 22 2 20.6569 2 19V3C2 2.44772 2.44772 2 3 2H17C17.5523 2 18 2.44772 18 3V15H22V19C22 20.6569 20.6569 22 19 22ZM18 17V19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19V17H18ZM6 7V9H14V7H6ZM6 11V13H14V11H6ZM6 15V17H11V15H6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f6e6f2da986bd6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 22H5C3.34315 22 2 20.6569 2 19V3C2 2.44772 2.44772 2 3 2H17C17.5523 2 18 2.44772 18 3V15H22V19C22 20.6569 20.6569 22 19 22ZM18 17V19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19V17H18ZM16 20V4H4V19C4 19.5523 4.44772 20 5 20H16ZM6 7H14V9H6V7ZM6 11H14V13H6V11ZM6 15H11V17H6V15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$be3e28e8dd3a6885(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM8 7V9H16V7H8ZM8 11V13H16V11H8ZM8 15V17H16V15H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$99783583cce202f5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM8 7H16V9H8V7ZM8 11H16V13H8V11ZM8 15H16V17H8V15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7c1c410c04a43072(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM15 11V10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10V11H8V16H16V11H15ZM13 11H11V10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$93f38f768dbcde6c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM15 11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10V11ZM13 11V10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10V11H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7e95b44518be82dd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2.9918V21.0082C21 21.5447 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.44476 2 3.9934 2H20.0066C20.5551 2 21 2.44405 21 2.9918ZM7 4V13L10.5 11L14 13V4H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$77e89e8132a469fd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM7 4H5V20H19V4H14V13L10.5 11L7 13V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a88b6b0239ef9118(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM11 12.05C10.8384 12.0172 10.6712 12 10.5 12C9.11929 12 8 13.1193 8 14.5C8 15.8807 9.11929 17 10.5 17C11.8807 17 13 15.8807 13 14.5V10H16V8H11V12.05Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$72b4bd63d2a15f6d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8V10H13V14.5C13 15.8807 11.8807 17 10.5 17C9.11929 17 8 15.8807 8 14.5C8 13.1193 9.11929 12 10.5 12C10.6712 12 10.8384 12.0172 11 12.05V8H15V4H5V20H19V8H16ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$858a9e13a0f5c33c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2C21.6569 2 23 3.34315 23 5V7H21V19C21 20.6569 19.6569 22 18 22H4C2.34315 22 1 20.6569 1 19V17H17V19C17 19.5128 17.386 19.9355 17.8834 19.9933L18 20C18.5128 20 18.9355 19.614 18.9933 19.1166L19 19V15H3V5C3 3.34315 4.34315 2 6 2H20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c0e1854d767a0f9f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2C21.6569 2 23 3.34315 23 5V7H21V19C21 20.6569 19.6569 22 18 22H4C2.34315 22 1 20.6569 1 19V17H17V19C17 19.5128 17.386 19.9355 17.8834 19.9933L18 20C18.5128 20 18.9355 19.614 18.9933 19.1166L19 19V4H6C5.48716 4 5.06449 4.38604 5.00673 4.88338L5 5V15H3V5C3 3.34315 4.34315 2 6 2H20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$500458b1887fead0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V19C21 20.6569 19.6569 22 18 22H4C2.34315 22 1 20.6569 1 19V17H17V19C17 19.5523 17.4477 20 18 20C18.5523 20 19 19.5523 19 19V15H3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4b1b5cc55617cb98(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17V19C17 19.5523 17.4477 20 18 20C18.5523 20 19 19.5523 19 19V4H5V15H3V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V19C21 20.6569 19.6569 22 18 22H4C2.34315 22 1 20.6569 1 19V17H17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3e3f10691d1f93a2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.9985 2C3.44749 2 3 2.44405 3 2.9918V21.0082C3 21.5447 3.44476 22 3.9934 22H20.0066C20.5551 22 21 21.5489 21 20.9925L20.9997 7L16 2H3.9985ZM10.5 7.5H12.5C12.5 9.98994 14.6436 12.6604 17.3162 13.5513L16.8586 15.49C13.7234 15.0421 10.4821 16.3804 7.5547 18.3321L6.3753 16.7191C7.46149 15.8502 8.50293 14.3757 9.27499 12.6534C10.0443 10.9373 10.5 9.07749 10.5 7.5ZM11.1 13.4716C11.3673 12.8752 11.6043 12.2563 11.8037 11.6285C12.2754 12.3531 12.8553 13.0182 13.5102 13.5953C12.5284 13.7711 11.5666 14.0596 10.6353 14.4276C10.8 14.1143 10.9551 13.7948 11.1 13.4716Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$61ade498d8126e9d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4H15V8H19V20H5V4ZM3.9985 2C3.44749 2 3 2.44405 3 2.9918V21.0082C3 21.5447 3.44476 22 3.9934 22H20.0066C20.5551 22 21 21.5489 21 20.9925L20.9997 7L16 2H3.9985ZM10.4999 7.5C10.4999 9.07749 10.0442 10.9373 9.27493 12.6534C8.50287 14.3757 7.46143 15.8502 6.37524 16.7191L7.55464 18.3321C10.4821 16.3804 13.7233 15.0421 16.8585 15.49L17.3162 13.5513C14.6435 12.6604 12.4999 9.98994 12.4999 7.5H10.4999ZM11.0999 13.4716C11.3673 12.8752 11.6042 12.2563 11.8037 11.6285C12.2753 12.3531 12.8553 13.0182 13.5101 13.5953C12.5283 13.7711 11.5665 14.0596 10.6352 14.4276C10.7999 14.1143 10.9551 13.7948 11.0999 13.4716Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fcc24be4f7b7aa3b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8H8V16H12ZM10 10H12C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14H10V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f8ca88003fbef49b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16H8V8H12C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16ZM10 10V14H12C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10H10ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b7e82c95c7fec971(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3.00022H21C21.5523 3.00022 22 3.44793 22 4.00022V20.0002C22 20.5525 21.5523 21.0002 21 21.0002H17V3.00022ZM2.85858 2.87756L15.4293 1.08175C15.7027 1.0427 15.9559 1.23265 15.995 1.50601C15.9983 1.52943 16 1.55306 16 1.57672V22.4237C16 22.6999 15.7761 22.9237 15.5 22.9237C15.4763 22.9237 15.4527 22.922 15.4293 22.9187L2.85858 21.1229C2.36593 21.0525 2 20.6306 2 20.1329V3.86751C2 3.36986 2.36593 2.94794 2.85858 2.87756ZM5 8.00022V16.0002H7V14.0002H13V8.00022H5ZM7 10.0002H11V12.0002H7V10.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$782d333bb92e15f9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.85858 2.87756L15.4293 1.08175C15.7027 1.0427 15.9559 1.23265 15.995 1.50601C15.9983 1.52943 16 1.55306 16 1.57672V22.4237C16 22.6999 15.7761 22.9237 15.5 22.9237C15.4763 22.9237 15.4527 22.922 15.4293 22.9187L2.85858 21.1229C2.36593 21.0525 2 20.6306 2 20.1329V3.86751C2 3.36986 2.36593 2.94794 2.85858 2.87756ZM4 4.73481V19.2656L14 20.6942V3.30624L4 4.73481ZM17 19.0002H20V5.00022H17V3.00022H21C21.5523 3.00022 22 3.44793 22 4.00022V20.0002C22 20.5525 21.5523 21.0002 21 21.0002H17V19.0002ZM5 8.00022H13V14.0002H7V16.0002H5V8.00022ZM7 10.0002V12.0002H11V10.0002H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$185faa9abbdbf7c8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM8 8V16H10V14H16V8H8ZM10 10H14V12H10V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1b8f2bb21061d3bd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM5 4V20H19V8H16V14H10V16H8V8H15V4H5ZM10 10V12H14V10H10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3c41e22a636f99b0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM8 11V13H16V11H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ab6b79e0ed79695a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM16 11V13H8V11H16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3bb36491ff029b49(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM13.529 14.4464L15.7395 16.6569L17.1537 15.2426L14.9432 13.0322C15.8492 11.4983 15.6432 9.48951 14.3252 8.17157C12.7631 6.60948 10.2305 6.60948 8.66839 8.17157C7.1063 9.73367 7.1063 12.2663 8.66839 13.8284C9.98633 15.1464 11.9951 15.3524 13.529 14.4464ZM12.911 12.4142C12.13 13.1953 10.8637 13.1953 10.0826 12.4142C9.30156 11.6332 9.30156 10.3668 10.0826 9.58579C10.8637 8.80474 12.13 8.80474 12.911 9.58579C13.6921 10.3668 13.6921 11.6332 12.911 12.4142Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fb8c7ad03883f870(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM13.529 14.4464C11.9951 15.3524 9.98633 15.1464 8.66839 13.8284C7.1063 12.2663 7.1063 9.73367 8.66839 8.17157C10.2305 6.60948 12.7631 6.60948 14.3252 8.17157C15.6432 9.48951 15.8492 11.4983 14.9432 13.0322L17.1537 15.2426L15.7395 16.6569L13.529 14.4464ZM12.911 12.4142C13.6921 11.6332 13.6921 10.3668 12.911 9.58579C12.13 8.80474 10.8637 8.80474 10.0826 9.58579C9.30156 10.3668 9.30156 11.6332 10.0826 12.4142C10.8637 13.1953 12.13 13.1953 12.911 12.4142Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$62d0ea94f71b2ba2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM8.59456 12.8115L7.60291 13.384L8.60297 15.1161L9.59532 14.5431C9.98844 14.915 10.4677 15.1967 11.0001 15.3551V16.5H13.0001V15.355C13.5325 15.1966 14.0117 14.9149 14.4048 14.543L15.3972 15.116L16.3972 13.3839L15.4055 12.8114C15.4673 12.551 15.5 12.2793 15.5 12C15.5 11.7207 15.4673 11.449 15.4054 11.1885L16.3972 10.616L15.3971 8.88393L14.4047 9.4569C14.0116 9.08506 13.5324 8.80337 13 8.64494V7.5H11V8.64494C10.4676 8.80338 9.98834 9.08508 9.59523 9.45694L8.60291 8.88402L7.60291 10.6161L8.59454 11.1886C8.53272 11.449 8.5 11.7207 8.5 12C8.5 12.2794 8.53273 12.5511 8.59456 12.8115ZM12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12C13.5 12.8284 12.8284 13.5 12 13.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9620a20641769dbc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.59456 12.8115C8.53273 12.5511 8.5 12.2794 8.5 12C8.5 11.7207 8.53272 11.449 8.59454 11.1886L7.60291 10.6161L8.60291 8.88402L9.59523 9.45694C9.98834 9.08508 10.4676 8.80338 11 8.64494V7.5H13V8.64494C13.5324 8.80337 14.0116 9.08506 14.4047 9.4569L15.3971 8.88393L16.3972 10.616L15.4054 11.1885C15.4673 11.449 15.5 11.7207 15.5 12C15.5 12.2793 15.4673 12.551 15.4055 12.8114L16.3972 13.3839L15.3972 15.116L14.4048 14.543C14.0117 14.9149 13.5325 15.1966 13.0001 15.355V16.5H11.0001V15.3551C10.4677 15.1967 9.98844 14.915 9.59532 14.5431L8.60297 15.1161L7.60291 13.384L8.59456 12.8115ZM12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9544bbe814cdc23(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10H11V17.3823C11 18.9449 11.7775 20.4053 13.074 21.2742L14.1569 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.44694 2 3.99826 2H15.9968L21 7V10ZM13 12H21V17.3823C21 18.2786 20.5544 19.1156 19.8125 19.6128L17 21.4978L14.1875 19.6128C13.4456 19.1156 13 18.2786 13 17.3823V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e0523317a2a395bd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9V4H5V20H11.0563C11.3838 20.4171 11.7803 20.7847 12.236 21.0848L13.626 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8V9H14ZM12 11H21V16.949C21 17.9397 20.4987 18.8648 19.6641 19.4144L16.5 21.4978L13.3359 19.4144C12.5013 18.8648 12 17.9397 12 16.949V11ZM14 16.949C14 17.2652 14.1616 17.5634 14.4358 17.744L16.5 19.1032L18.5642 17.744C18.8384 17.5634 19 17.2652 19 16.949V13H14V16.949Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8c72b48d7777f583(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7V20.9925C21 21.5511 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.44694 2 3.99826 2H15.9968L21 7ZM8 8V13.6002C8 14.4496 8.4456 15.2427 9.18747 15.7138L12 17.5L14.8125 15.7138C15.5544 15.2427 16 14.4496 16 13.6002V8H8ZM10 10H14V13.6002C14 13.7579 13.9103 13.9176 13.7403 14.0255L12 15.1308L10.2597 14.0255C10.0897 13.9176 10 13.7579 10 13.6002V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$159bcc0f1634649c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8V4H5V20H19V9H16V13.6195C16 14.4641 15.5544 15.2529 14.8125 15.7215L12 17.4978L9.18747 15.7215C8.4456 15.2529 8 14.4641 8 13.6195V8H14ZM21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8ZM10 13.6195C10 13.7698 10.0872 13.9242 10.2554 14.0305L12 15.1323L13.7446 14.0305C13.9128 13.9242 14 13.7698 14 13.6195V10H10V13.6195Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$62ef9256946129d1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12V14H2V12H4V2.9954C4 2.44565 4.44484 2 4.99558 2H15L19.9997 7L20 12H22ZM3 16H5V22H3V16ZM19 16H21V22H19V16ZM15 16H17V22H15V16ZM11 16H13V22H11V16ZM7 16H9V22H7V16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d595611e2cf5eb22(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12H18V8H14V4H6V12ZM4 12V2.9954C4 2.44565 4.44484 2 4.99558 2H15L19.9997 7L20 12H22V14H2V12H4ZM3 16H5V22H3V16ZM19 16H21V22H19V16ZM15 16H17V22H15V16ZM11 16H13V22H11V16ZM7 16H9V22H7V16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2d8bf3d3062b6a3d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9V20.9925C21 21.5511 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.44694 2 3.99826 2H14V8C14 8.55228 14.4477 9 15 9H21ZM21 7H16V2.00318L21 7ZM8 7V9H11V7H8ZM8 11V13H16V11H8ZM8 15V17H16V15H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9499cfddab46085b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8ZM19 9H14V4H5V20H19V9ZM8 7H11V9H8V7ZM8 11H16V13H8V11ZM8 15H16V17H8V15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$aedce003f6dafab3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM12 11H8V13H12V16L16 12L12 8V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5f535781c7fdd62a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM12 11V8L16 12L12 16V13H8V11H12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$80a6c2bbdb8bba46(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM11 15V17H13V15H11ZM13 13.3551C14.4457 12.9248 15.5 11.5855 15.5 10C15.5 8.067 13.933 6.5 12 6.5C10.302 6.5 8.88637 7.70919 8.56731 9.31346L10.5288 9.70577C10.6656 9.01823 11.2723 8.5 12 8.5C12.8284 8.5 13.5 9.17157 13.5 10C13.5 10.8284 12.8284 11.5 12 11.5C11.4477 11.5 11 11.9477 11 12.5V14H13V13.3551Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f67c326f16978b5e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15H13V17H11V15ZM13 13.3551V14H11V12.5C11 11.9477 11.4477 11.5 12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.2723 8.5 10.6656 9.01823 10.5288 9.70577L8.56731 9.31346C8.88637 7.70919 10.302 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10C15.5 11.5855 14.4457 12.9248 13 13.3551ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a0eb4c9b1f36c1a7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM13 12H16L12 8L8 12H11V16H13V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6f603ff237fbc447(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM13 12V16H11V12H8L12 8L16 12H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6e8ea8d9f2eb97f2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5ZM7.52746 17H16.4725C16.2238 14.75 14.3163 13 12 13C9.68372 13 7.77619 14.75 7.52746 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ac0028c422ed4e58(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM12 11.5C10.6193 11.5 9.5 10.3807 9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C13.3807 6.5 14.5 7.61929 14.5 9C14.5 10.3807 13.3807 11.5 12 11.5ZM7.52746 17C7.77619 14.75 9.68372 13 12 13C14.3163 13 16.2238 14.75 16.4725 17H7.52746Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e3aaf2748f91b101(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM15.0008 11.667L10.1219 8.41435C10.0562 8.37054 9.979 8.34717 9.9 8.34717C9.6791 8.34717 9.5 8.52625 9.5 8.74717V15.2524C9.5 15.3314 9.5234 15.4086 9.5672 15.4743C9.6897 15.6581 9.9381 15.7078 10.1219 15.5852L15.0008 12.3326C15.0447 12.3033 15.0824 12.2656 15.1117 12.2217C15.2343 12.0379 15.1846 11.7895 15.0008 11.667Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5c3173786897476d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4V8H19V20H5V4H15ZM3.9985 2C3.44749 2 3 2.44405 3 2.9918V21.0082C3 21.5447 3.44476 22 3.9934 22H20.0066C20.5551 22 21 21.5489 21 20.9925L20.9997 7L16 2H3.9985ZM15.0008 11.667L10.1219 8.41435C10.0562 8.37054 9.979 8.34717 9.9 8.34717C9.6791 8.34717 9.5 8.52625 9.5 8.74717V15.2524C9.5 15.3314 9.5234 15.4086 9.5672 15.4743C9.6897 15.6581 9.9381 15.7078 10.1219 15.5852L15.0008 12.3326C15.0447 12.3033 15.0824 12.2656 15.1117 12.2217C15.2343 12.0379 15.1846 11.7895 15.0008 11.667Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bb796868d54dac5e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$23e7a70261698273(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b1032c4741bd1dc2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3.00022H21C21.5523 3.00022 22 3.44793 22 4.00022V20.0002C22 20.5525 21.5523 21.0002 21 21.0002H17V3.00022ZM2.85858 2.87756L15.4293 1.08175C15.7027 1.0427 15.9559 1.23265 15.995 1.50601C15.9983 1.52943 16 1.55306 16 1.57672V22.4237C16 22.6999 15.7761 22.9237 15.5 22.9237C15.4763 22.9237 15.4527 22.922 15.4293 22.9187L2.85858 21.1229C2.36593 21.0525 2 20.6306 2 20.1329V3.86751C2 3.36986 2.36593 2.94794 2.85858 2.87756ZM11 8.00022V12.9892L9 11.0002L7.01083 13.0002L7 8.00022H5V16.0002H7L9 14.0002L11 16.0002H13V8.00022H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e6030786aa2a555(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 19.0002H20V5.00022H17V3.00022H21C21.5523 3.00022 22 3.44793 22 4.00022V20.0002C22 20.5525 21.5523 21.0002 21 21.0002H17V19.0002ZM2.85858 2.87756L15.4293 1.08175C15.7027 1.0427 15.9559 1.23265 15.995 1.50601C15.9983 1.52943 16 1.55306 16 1.57672V22.4237C16 22.6999 15.7761 22.9237 15.5 22.9237C15.4763 22.9237 15.4527 22.922 15.4293 22.9187L2.85858 21.1229C2.36593 21.0525 2 20.6306 2 20.1329V3.86751C2 3.36986 2.36593 2.94794 2.85858 2.87756ZM4 4.73481V19.2656L14 20.6942V3.30624L4 4.73481ZM11 8.00022H13V16.0002H11L9 14.0002L7 16.0002H5V8.00022H7L7.01083 13.0002L9 11.0002L11 12.9892V8.00022Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2df94722d0ee5dc0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM14 8V12.989L12 11L10.0108 13L10 8H8V16H10L12 14L14 16H16V8H14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ae22876af7dbc31c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8V16H14L12 14L10 16H8V8H10V13L12 11L14 13V8H15V4H5V20H19V8H16ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$17a92ccfe1111ad7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2V4H12V2H20.0066C20.5551 2 21 2.44405 21 2.9918V21.0082C21 21.5447 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.44476 2 3.9934 2H10ZM12 4V6H14V4H12ZM10 6V8H12V6H10ZM12 8V10H14V8H12ZM10 10V12H12V10H10ZM12 12V14H10V17H14V12H12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$79cb5688d51fecf8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM14 12V17H10V14H12V12H14ZM12 4H14V6H12V4ZM10 6H12V8H10V6ZM12 8H14V10H12V8ZM10 10H12V12H10V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c2bdb6eed361575a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V11H22ZM22 9H2V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a8f64eaf01303f33(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM20 11H4V19H20V11ZM20 9V7H11.5858L9.58579 5H4V9H20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ece1c04c33d9cf76(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7H21C21.5523 7 22 7.44772 22 8ZM12.4142 5H2V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5557298c6f2f981e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 7V19H20V7H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fd4e5296ab89b420(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21V11H22V20C22 20.5523 21.5523 21 21 21H8ZM6 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V9H7C6.44772 9 6 9.44772 6 10V21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1e46fe1096294311(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM8 19H20V11H8V19ZM6 19V10C6 9.44772 6.44772 9 7 9H20V7H11.5858L9.58579 5H4V19H6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5b13e27691dceee4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.4144 5H20.0002C20.5525 5 21.0002 5.44772 21.0002 6V7H3.00017V4C3.00017 3.44772 3.44789 3 4.00017 3H11.4144L13.4144 5ZM3.08697 9H20.9134C21.4657 9 21.9134 9.44772 21.9134 10C21.9134 10.0277 21.9122 10.0554 21.9099 10.083L21.0766 20.083C21.0334 20.6013 20.6001 21 20.08 21H3.9203C3.40021 21 2.96695 20.6013 2.92376 20.083L2.09042 10.083C2.04456 9.53267 2.45355 9.04932 3.00392 9.00345C3.03155 9.00115 3.05925 9 3.08697 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$12491ce31cf53cdb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.08697 9H20.9134C21.4657 9 21.9134 9.44772 21.9134 10C21.9134 10.0277 21.9122 10.0554 21.9099 10.083L21.0766 20.083C21.0334 20.6013 20.6001 21 20.08 21H3.9203C3.40021 21 2.96695 20.6013 2.92376 20.083L2.09042 10.083C2.04456 9.53267 2.45355 9.04932 3.00392 9.00345C3.03155 9.00115 3.05925 9 3.08697 9ZM4.84044 19H19.1599L19.8266 11H4.17377L4.84044 19ZM13.4144 5H20.0002C20.5525 5 21.0002 5.44772 21.0002 6V7H3.00017V4C3.00017 3.44772 3.44789 3 4.00017 3H11.4144L13.4144 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$510753d934a792d5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM11 12H8V14H11V17H13V14H16V12H13V9H11V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3e86be5e4fa2aeca(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM11 12V9H13V12H16V14H13V17H11V14H8V12H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e2bd684bcfc4b74d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13H12V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6d259ab607819ff(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM12 9V13H16C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13C8 10.7909 9.79086 9 12 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1c7ad61a74fa7b95(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM11 9V17H13V9H11ZM15 12V17H17V12H15ZM7 14V17H9V14H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$97ca550c82e82bdb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM11 9H13V17H11V9ZM15 12H17V17H15V12ZM7 14H9V17H7V14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a55a96b7cadbfadb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM13 13V9H11V13H8L12 17L16 13H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$43d0440aefdb4a75(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM13 13H16L12 17L8 13H11V9H13V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$de65d74e2b0c9648(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$12c6c39c55d44f39(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11.2547C20.8662 10.4638 19.4872 10 18 10C14.134 10 11 13.134 11 17C11 18.4872 11.4638 19.8662 12.2547 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V11.2547ZM18 22C15.2386 22 13 19.7614 13 17C13 14.2386 15.2386 12 18 12C20.7614 12 23 14.2386 23 17C23 19.7614 20.7614 22 18 22ZM16.7066 19.7076C17.0982 19.895 17.5369 20 18 20C19.6569 20 21 18.6569 21 17C21 16.5369 20.895 16.0982 20.7076 15.7066L16.7066 19.7076ZM15.2924 18.2934L19.2934 14.2924C18.9018 14.105 18.4631 14 18 14C16.3431 14 15 15.3431 15 17C15 17.4631 15.105 17.9018 15.2924 18.2934Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3d807a8d0d2f7f02(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11.2547C21.396 10.8334 20.7224 10.5049 20 10.2899V7H11.5858L9.58579 5H4V19H11.2899C11.5049 19.7224 11.8334 20.396 12.2547 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V11.2547ZM18 22C15.2386 22 13 19.7614 13 17C13 14.2386 15.2386 12 18 12C20.7614 12 23 14.2386 23 17C23 19.7614 20.7614 22 18 22ZM16.7066 19.7076C17.0982 19.895 17.5369 20 18 20C19.6569 20 21 18.6569 21 17C21 16.5369 20.895 16.0982 20.7076 15.7066L16.7066 19.7076ZM15.2924 18.2934L19.2934 14.2924C18.9018 14.105 18.4631 14 18 14C16.3431 14 15 15.3431 15 17C15 17.4631 15.105 17.9018 15.2924 18.2934Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e0b00af81d1f475e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.4142 3L12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142ZM13 9H11V15H16V13H13V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fe7b6ce00030a67f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.4142 3L12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142ZM9.58579 5H4V19H20V7H11.5858L9.58579 5ZM13 9V13H16V15H11V9H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c6792702b59a703d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM10 10.5C10 9.67157 9.32843 9 8.5 9C7.67157 9 7 9.67157 7 10.5C7 11.3284 7.67157 12 8.5 12C9.32843 12 10 11.3284 10 10.5ZM18 17L14 11L7 17H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$659417b9674d39bd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5V19H20V7H11.5858L9.58579 5H4ZM12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM10 10.5C10 11.3284 9.32843 12 8.5 12C7.67157 12 7 11.3284 7 10.5C7 9.67157 7.67157 9 8.5 9C9.32843 9 10 9.67157 10 10.5ZM18 17L14 11L7 17H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ea77c33f087c919f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM11 9V11H13V9H11ZM11 12V17H13V12H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$18fc38724735a328(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM11 12H13V17H11V12ZM11 9H13V11H11V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e11e8311a4ee036e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.4142 3L12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142ZM12 9C10.8954 9 10 9.89543 10 11C10 11.7403 10.4022 12.3866 10.9999 12.7324L11 17H13L13.0011 12.7318C13.5983 12.3858 14 11.7398 14 11C14 9.89543 13.1046 9 12 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$de0312a10fc51d63(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.4142 3L12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142ZM9.58579 5H4V19H20V7H11.5858L9.58579 5ZM12 9C13.1046 9 14 9.89543 14 11C14 11.7398 13.5983 12.3858 13.0011 12.7318L13 17H11L10.9999 12.7324C10.4022 12.3866 10 11.7403 10 11C10 9.89543 10.8954 9 12 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9554420ba4b8d6b3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5V19H20V7H11.5858L9.58579 5H4ZM12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ef33d211c257b6d3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM15 13V12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12V13H8V17H16V13H15ZM13 13H11V12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bccda78025768230(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM15 13H16V17H8V13H9V12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12V13ZM13 13V12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12V13H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$58b3d7fe45aab874(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM11 13.05C10.8384 13.0172 10.6712 13 10.5 13C9.11929 13 8 14.1193 8 15.5C8 16.8807 9.11929 18 10.5 18C11.8807 18 13 16.8807 13 15.5V11H16V9H11V13.05Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5bcead7bfff62376(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM11 13.05V9H16V11H13V15.5C13 16.8807 11.8807 18 10.5 18C9.11929 18 8 16.8807 8 15.5C8 14.1193 9.11929 13 10.5 13C10.6712 13 10.8384 13.0172 11 13.05Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$69dc7b80b97de2cc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H20C20.5523 5 21 5.44772 21 6V9H4V18.996L6 11H22.5L20.1894 20.2425C20.0781 20.6877 19.6781 21 19.2192 21H3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$979e52bbccd0b467(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H20C20.5523 5 21 5.44772 21 6V9H19V7H11.5858L9.58579 5H4V16.998L5.5 11H22.5L20.1894 20.2425C20.0781 20.6877 19.6781 21 19.2192 21H3ZM19.9384 13H7.06155L5.56155 19H18.4384L19.9384 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a0a21fd4eec254de(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13.126C21.0149 12.4174 19.8062 12 18.5 12C15.1863 12 12.5 14.6863 12.5 18C12.5 19.0929 12.7922 20.1175 13.3027 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V13.126ZM20 17H23V19H20V22.5L15 18L20 13.5V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1d8fa85933342647(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13H20V7H11.5858L9.58579 5H4V19H13V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V13ZM20 17H23V19H20V22.5L15 18L20 13.5V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$18d60735dfb6fd67(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM8 12V14H16V12H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e14ef6db7199449c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM8 12H16V14H8V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d869847652aaefb3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM8.59114 13.8089L7.59998 14.3812L8.59954 16.1124L9.59141 15.5397C9.98434 15.9114 10.4634 16.1929 10.9955 16.3513V17.4956H12.9945V16.3512C13.5266 16.1928 14.0057 15.9113 14.3986 15.5396L15.3905 16.1123L16.39 14.3811L15.3987 13.8088C15.4605 13.5485 15.4932 13.277 15.4932 12.9978C15.4932 12.7186 15.4605 12.447 15.3987 12.1867L16.39 11.6145L15.3904 9.88325L14.3985 10.4559C14.0056 10.0843 13.5265 9.80274 12.9944 9.64438V8.5H10.9954V9.64438C10.4633 9.80275 9.98424 10.0843 9.59133 10.456L8.59949 9.88335L7.59998 11.6146L8.59112 12.1868C8.52933 12.4471 8.49663 12.7186 8.49663 12.9978C8.49663 13.277 8.52934 13.5486 8.59114 13.8089ZM11.9949 14.4971C11.1669 14.4971 10.4957 13.8258 10.4957 12.9978C10.4957 12.1698 11.1669 11.4985 11.9949 11.4985C12.8229 11.4985 13.4942 12.1698 13.4942 12.9978C13.4942 13.8258 12.8229 14.4971 11.9949 14.4971Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ccc980b6ff97ca08(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM8.59114 13.8089C8.52934 13.5486 8.49663 13.277 8.49663 12.9978C8.49663 12.7186 8.52933 12.4471 8.59112 12.1868L7.59998 11.6146L8.59949 9.88335L9.59133 10.456C9.98424 10.0843 10.4633 9.80275 10.9954 9.64438V8.5H12.9944V9.64438C13.5265 9.80274 14.0056 10.0843 14.3985 10.4559L15.3904 9.88325L16.39 11.6145L15.3987 12.1867C15.4605 12.447 15.4932 12.7186 15.4932 12.9978C15.4932 13.277 15.4605 13.5485 15.3987 13.8088L16.39 14.3811L15.3905 16.1123L14.3986 15.5396C14.0057 15.9113 13.5266 16.1928 12.9945 16.3512V17.4956H10.9955V16.3513C10.4634 16.1929 9.98434 15.9114 9.59141 15.5397L8.59954 16.1124L7.59998 14.3812L8.59114 13.8089ZM11.9949 14.4971C12.8229 14.4971 13.4942 13.8258 13.4942 12.9978C13.4942 12.1698 12.8229 11.4985 11.9949 11.4985C11.1669 11.4985 10.4957 12.1698 10.4957 12.9978C10.4957 13.8258 11.1669 14.4971 11.9949 14.4971Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$aa7093ce3559dd2b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13.126C21.0149 12.4174 19.8062 12 18.5 12C15.1863 12 12.5 14.6863 12.5 18C12.5 19.0929 12.7922 20.1175 13.3027 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V13.126ZM18 17V13.5L23 18L18 22.5V19H15V17H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$485f9c4be74228ae(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13H20V7H11.5858L9.58579 5H4V19H13V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V13ZM18 17V13.5L23 18L18 22.5V19H15V17H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ac48fc3a3e6610fd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10H12V17.3823C12 18.7906 12.6315 20.1159 13.7054 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V10ZM14 12H22V17.3823C22 18.2786 21.5544 19.1156 20.8125 19.6128L18 21.4978L15.1875 19.6128C14.4456 19.1156 14 18.2786 14 17.3823V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c33a0260c1db79e7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9H20V7H11.5858L9.58579 5H4V19H11.4469C11.8089 19.7916 12.3786 20.4853 13.1114 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V9ZM13 11H22V16.949C22 17.9397 21.4987 18.8648 20.6641 19.4144L17.5 21.4978L14.3359 19.4144C13.5013 18.8648 13 17.9397 13 16.949V11ZM15 16.949C15 17.2652 15.1616 17.5634 15.4358 17.744L17.5 19.1032L19.5642 17.744C19.8384 17.5634 20 17.2652 20 16.949V13H15V16.949Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5f9970c1c68a94c2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM8 9V13.904C8 14.7956 8.4456 15.6282 9.18747 16.1228L12 17.9978L14.8125 16.1228C15.5544 15.6282 16 14.7956 16 13.904V9H8ZM10 13.904V11H14V13.904C14 14.1269 13.8886 14.335 13.7031 14.4587L12 15.5941L10.2969 14.4587C10.1114 14.335 10 14.1269 10 13.904Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c4d429e27965ff29(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM8 9H16V13.904C16 14.7956 15.5544 15.6282 14.8125 16.1228L12 17.9978L9.18747 16.1228C8.4456 15.6282 8 14.7956 8 13.904V9ZM10 13.904C10 14.1269 10.1114 14.335 10.2969 14.4587L12 15.5941L13.7031 14.4587C13.8886 14.335 14 14.1269 14 13.904V11H10V13.904Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c5939a676c90f14c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM12 12H8V14H12V17L16 13L12 9V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5abd7470662838c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM12 12V9L16 13L12 17V14H8V12H12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c2e7f23c3e7eebbe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM11 16V18H13V16H11ZM8.56731 10.8135L10.5288 11.2058C10.6656 10.5182 11.2723 10 12 10C12.8284 10 13.5 10.6716 13.5 11.5C13.5 12.3284 12.8284 13 12 13H11V15H12C13.933 15 15.5 13.433 15.5 11.5C15.5 9.567 13.933 8 12 8C10.302 8 8.88637 9.20919 8.56731 10.8135Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$545140d5c51fc144(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM11 16H13V18H11V16ZM8.56731 10.8135C8.88637 9.20919 10.302 8 12 8C13.933 8 15.5 9.567 15.5 11.5C15.5 13.433 13.933 15 12 15H11V13H12C12.8284 13 13.5 12.3284 13.5 11.5C13.5 10.6716 12.8284 10 12 10C11.2723 10 10.6656 10.5182 10.5288 11.2058L8.56731 10.8135Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7de02390afdbc8f8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM13 13H16L12 9L8 13H11V17H13V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d4c97c430529c2d7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM13 13V17H11V13H8L12 9L16 13H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ebd4120f1f532bbf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM12 13C13.3807 13 14.5 11.8807 14.5 10.5C14.5 9.11929 13.3807 8 12 8C10.6193 8 9.5 9.11929 9.5 10.5C9.5 11.8807 10.6193 13 12 13ZM8 18H16C16 15.7909 14.2091 14 12 14C9.79086 14 8 15.7909 8 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$27dd2c5d9d74fb5d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM8 18C8 15.7909 9.79086 14 12 14C14.2091 14 16 15.7909 16 18H8ZM12 13C10.6193 13 9.5 11.8807 9.5 10.5C9.5 9.11929 10.6193 8 12 8C13.3807 8 14.5 9.11929 14.5 10.5C14.5 11.8807 13.3807 13 12 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3e74d6c88d33237a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H12.4142L10.4142 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V6C22 5.44772 21.5523 5 21 5ZM15.0008 12.667C15.1846 12.7895 15.2343 13.0379 15.1117 13.2217C15.0824 13.2656 15.0447 13.3033 15.0008 13.3326L10.1219 16.5852C9.9381 16.7078 9.6897 16.6581 9.5672 16.4743C9.5234 16.4086 9.5 16.3314 9.5 16.2524V9.74717C9.5 9.52625 9.6791 9.34717 9.9 9.34717C9.979 9.34717 10.0562 9.37054 10.1219 9.41435L15.0008 12.667Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$682aca1ecf1893e4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19V5H9.58579L11.5858 7H20V19H4ZM21 5H12.4142L10.4142 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V6C22 5.44772 21.5523 5 21 5ZM15.0008 12.667L10.1219 9.41435C10.0562 9.37054 9.979 9.34717 9.9 9.34717C9.6791 9.34717 9.5 9.52625 9.5 9.74717V16.2524C9.5 16.3314 9.5234 16.4086 9.5672 16.4743C9.6897 16.6581 9.9381 16.7078 10.1219 16.5852L15.0008 13.3326C15.0447 13.3033 15.0824 13.2656 15.1117 13.2217C15.2343 13.0379 15.1846 12.7895 15.0008 12.667Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$60784b8d65c22951(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM11 9V14H13V9H11ZM11 15V17H13V15H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b6d77d4f92aa15d6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM11 15H13V17H11V15ZM11 9H13V14H11V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b697d40b808fc8ea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H16V7H18V5H21ZM18 13H16V15H14V18H18V13ZM16 11H14V13H16V11ZM18 9H16V11H18V9ZM16 7H14V9H16V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6c1883fb6eca2daf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.4142 3L12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142ZM18 18H14V15H16V13H14V11H16V9H14V7H11.5858L9.58579 5H4V19H20V7H16V9H18V11H16V13H18V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c3a1bcd3afc6e76d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7V4C6 3.44772 6.44772 3 7 3H13.4142L15.4142 5H21C21.5523 5 22 5.44772 22 6V16C22 16.5523 21.5523 17 21 17H18V20C18 20.5523 17.5523 21 17 21H3C2.44772 21 2 20.5523 2 20V8C2 7.44772 2.44772 7 3 7H6ZM6 9H4V19H16V17H6V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6eecd91faed15376(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7V4C6 3.44772 6.44772 3 7 3H13.4142L15.4142 5H21C21.5523 5 22 5.44772 22 6V16C22 16.5523 21.5523 17 21 17H18V20C18 20.5523 17.5523 21 17 21H3C2.44772 21 2 20.5523 2 20V8C2 7.44772 2.44772 7 3 7H6ZM6 9H4V19H16V17H6V9ZM8 5V15H20V7H14.5858L12.5858 5H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4dab6bead1c5461b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.9992 2C19.552 2 20.086 2.42969 20.1955 2.97705L21.8047 11.023C21.9126 11.5626 21.5448 12 21.0083 12H12.9998V20H17.0001V22H7.00006V20H10.9998V12H2.99187C2.44411 12 2.086 11.5703 2.19547 11.023L3.80465 2.97705C3.91258 2.43744 4.4447 2 5.00094 2H18.9992Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$323a7e62be5e1438(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.43967 10H19.5605L18.3605 4H5.63967L4.43967 10ZM13.0001 12V20H17.0001V22H7.00006V20H11.0001V12H2.99187C2.44411 12 2.086 11.5703 2.19547 11.023L3.80465 2.97705C3.91258 2.43744 4.4447 2 5.00094 2H18.9992C19.552 2 20.086 2.42969 20.1955 2.97705L21.8047 11.023C21.9126 11.5626 21.5448 12 21.0083 12H13.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$479cccdc0f8dbab8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM7 15.5V11.5L9 13.5L11 11.5V15.5H13V8.5H11L9 10.5L7 8.5H5V15.5H7ZM18 12.5V8.5H16V12.5H14L17 15.5L20 12.5H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d6ff4b11a64511d1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM4 5V19H20V5H4ZM7 15.5H5V8.5H7L9 10.5L11 8.5H13V15.5H11V11.5L9 13.5L7 11.5V15.5ZM18 12.5H20L17 15.5L14 12.5H16V8.5H18V12.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1ca8b1bdedf3bef5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 22H5C3.34315 22 2 20.6569 2 19V3C2 2.44772 2.44772 2 3 2H17C17.5523 2 18 2.44772 18 3V10H22V19C22 20.6569 20.6569 22 19 22ZM18 12V19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19V12H18ZM5 6V12H11V6H5ZM5 13V15H15V13H5ZM5 16V18H15V16H5ZM7 8H9V10H7V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$17c05c1cf15f5b3b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 20V4H4V19C4 19.5523 4.44772 20 5 20H16ZM19 22H5C3.34315 22 2 20.6569 2 19V3C2 2.44772 2.44772 2 3 2H17C17.5523 2 18 2.44772 18 3V10H22V19C22 20.6569 20.6569 22 19 22ZM18 12V19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19V12H18ZM6 6H12V12H6V6ZM8 8V10H10V8H8ZM6 13H14V15H6V13ZM6 16H14V18H6V16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6ef61cec91547c7c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18H4V10H9V18ZM15 18H10V6H15V18ZM21 18H16V2H21V18ZM22 22H3V20H22V22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a45dc0dd4c388b9b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18H4V10H9V18ZM7 16V12H6V16H7ZM13 16V8H12V16H13ZM15 18H10V6H15V18ZM19 16V4H18V16H19ZM21 18H16V2H21V18ZM22 22H3V20H22V22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bea53c8a200e8809(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H4C3.44772 22 3 21.5523 3 21V8H21V21C21 21.5523 20.5523 22 20 22ZM21 6H3V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V6ZM7 11V15H11V11H7ZM7 17V19H17V17H7ZM13 12V14H17V12H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$347479dfc7a7292f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8V20H19V8H5ZM5 6H19V4H5V6ZM20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM7 10H11V14H7V10ZM7 16H17V18H7V16ZM13 11H17V13H13V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$998071e012c75f30(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16L15.9968 21H3.99826C3.44694 21 3 20.5551 3 20.0066V3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44749 21 3.9985V16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e18ac86cc6db5d14(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.99826 21C3.44694 21 3 20.5551 3 20.0066V3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44749 21 3.9985V16L15.9968 21H3.99826ZM5 19H15.1688L19 15.1712V5H5V19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c174f6ece974a7d9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 14L14.8834 14.0067C14.4243 14.0601 14.0601 14.4243 14.0067 14.8834L14 15V21H3.99826C3.44694 21 3 20.5551 3 20.0066V3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44749 21 3.9985V14H15ZM21 16L16 20.997V16H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fcbe257503f128c9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15L15 20.996L4.00221 21C3.4487 21 3 20.5551 3 20.0066V3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.45576 21 4.00247V15ZM19 5H5V19H13V14C13 13.4872 13.386 13.0645 13.8834 13.0067L14 13L19 12.999V5ZM18.171 14.999L15 15V18.169L18.171 14.999Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$71b0ad48887a2641(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4V8H18V4H20.0066C20.5552 4 21 4.44495 21 4.9934V21.0066C21 21.5552 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5551 3 21.0066V4.9934C3 4.44476 3.44495 4 3.9934 4H6ZM9 17H7V19H9V17ZM9 14H7V16H9V14ZM9 11H7V13H9V11ZM16 2V6H8V2H16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a7957d3145e84cbd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2V4H20.0066C20.5552 4 21 4.44495 21 4.9934V21.0066C21 21.5552 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5551 3 21.0066V4.9934C3 4.44476 3.44495 4 3.9934 4H7V2H17ZM7 6H5V20H19V6H17V8H7V6ZM9 16V18H7V16H9ZM9 13V15H7V13H9ZM9 10V12H7V10H9ZM15 4H9V6H15V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3c16e63f558ae6e3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H20C20.5523 2 21 2.44772 21 3ZM11.2929 13.1213L8.81802 10.6464L7.40381 12.0607L11.2929 15.9497L16.9497 10.2929L15.5355 8.87868L11.2929 13.1213Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dbe04e7d5f8539e1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5V20H19V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H19.9997C20.5519 2 20.9996 2.44772 20.9997 3L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM11.2929 13.1213L15.5355 8.87868L16.9497 10.2929L11.2929 15.9497L7.40381 12.0607L8.81802 10.6464L11.2929 13.1213Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3a307fbc107aa160(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H7V0H9V2H15V0H17V2ZM7 8V10H17V8H7ZM7 12V14H17V12H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6f40cc45b86c95d3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H7V0H9V2H15V0H17V2ZM17 4V6H15V4H9V6H7V4H5V20H19V4H17ZM7 8H17V10H7V8ZM7 12H17V14H7V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ed40dd0665926a0f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15V17C5 18.0544 5.95 19 7 19H10V21H7C4.79086 21 3 19.2091 3 17V15H5ZM18 10L22.4 21H20.245L19.044 18H14.954L13.755 21H11.601L16 10H18ZM17 12.8852L15.753 16H18.245L17 12.8852ZM3 3H9C10.6569 3 12 4.34315 12 6C12 6.76878 11.7108 7.47002 11.2353 8.00088C11.7112 8.53084 12 9.23169 12 10C12 11.6569 10.6569 13 9 13H3V3ZM9 9H5V11H9C9.55228 11 10 10.5523 10 10C10 9.45 9.55 9 9 9ZM17 3C19.2091 3 21 4.79086 21 7V9H19V7C19 5.89543 18.1046 5 17 5H14V3H17ZM9 5H5V7H9C9.55228 7 10 6.55228 10 6C10 5.45 9.55 5 9 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1c6ededbfd7b4baf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5.25C16.7949 5.25 18.25 3.79493 18.25 2H19.75C19.75 3.79493 21.2051 5.25 23 5.25V6.75C21.2051 6.75 19.75 8.20507 19.75 10H18.25C18.25 8.20507 16.7949 6.75 15 6.75V5.25ZM4 7C4 5.89543 4.89543 5 6 5H13V3H6C3.79086 3 2 4.79086 2 7V17C2 19.2091 3.79086 21 6 21H18C20.2091 21 22 19.2091 22 17V12H20V17C20 18.1046 19.1046 19 18 19H6C4.89543 19 4 18.1046 4 17V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bf0105fa8a91e2be(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19H21V21H3V19ZM8 13H11L7 17L3 13H6V3H8V13ZM18 13H21L17 17L13 13H16V3H18V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6cc1eb78bc0421e2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4H21V6H3V4ZM5 19H19V21H5V19ZM3 14H21V16H3V14ZM5 9H19V11H5V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b44719efa0362593(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM3 14H21V16H3V14ZM3 9H21V11H3V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bb0f8edea87b5d29(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4H21V6H3V4ZM3 19H17V21H3V19ZM3 14H21V16H3V14ZM3 9H17V11H3V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4184cd3b8b3fc317(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4H21V6H3V4ZM7 19H21V21H7V19ZM3 14H21V16H3V14ZM7 9H21V11H7V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$584bb8b31a0b64e5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21V5H3V3ZM8 11V21H6V11H3L7 7L11 11H8ZM18 11V21H16V11H13L17 7L21 11H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$162388492b462b31(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11H21V13H3V11ZM18 18V21H16V18H13L17 14L21 18H18ZM8 18V21H6V18H3L7 14L11 18H8ZM18 6H21L17 10L13 6H16V3H18V6ZM8 6H11L7 10L3 6H6V3H8V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4f0b90782ec081d8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9993 3L12.9991 10.267L19.2935 6.63397L20.2935 8.36602L14.0001 11.999L20.2935 15.634L19.2935 17.366L12.9991 13.732L12.9993 21H10.9993L10.9991 13.732L4.70508 17.366L3.70508 15.634L9.99808 12L3.70508 8.36602L4.70508 6.63397L10.9991 10.267L10.9993 3H12.9993Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7f3df4f67cf072e5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8287 7.7574L9.1718 13.4143C8.78127 13.8048 8.78127 14.4379 9.1718 14.8285C9.56232 15.219 10.1955 15.219 10.586 14.8285L16.2429 9.17161C17.4144 8.00004 17.4144 6.10055 16.2429 4.92897C15.0713 3.7574 13.1718 3.7574 12.0002 4.92897L6.34337 10.5858C4.39075 12.5384 4.39075 15.7043 6.34337 17.6569C8.29599 19.6095 11.4618 19.6095 13.4144 17.6569L19.0713 12L20.4855 13.4143L14.8287 19.0711C12.095 21.8048 7.66283 21.8048 4.92916 19.0711C2.19549 16.3374 2.19549 11.9053 4.92916 9.17161L10.586 3.51476C12.5386 1.56214 15.7045 1.56214 17.6571 3.51476C19.6097 5.46738 19.6097 8.63321 17.6571 10.5858L12.0002 16.2427C10.8287 17.4143 8.92916 17.4143 7.75759 16.2427C6.58601 15.0711 6.58601 13.1716 7.75759 12L13.4144 6.34319L14.8287 7.7574Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$de79ffa066a6a72e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11H12.5C13.8807 11 15 9.88071 15 8.5C15 7.11929 13.8807 6 12.5 6H8V11ZM18 15.5C18 17.9853 15.9853 20 13.5 20H6V4H12.5C14.9853 4 17 6.01472 17 8.5C17 9.70431 16.5269 10.7981 15.7564 11.6058C17.0979 12.3847 18 13.837 18 15.5ZM8 13V18H13.5C14.8807 18 16 16.8807 16 15.5C16 14.1193 14.8807 13 13.5 13H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e80dfa5eaa25c557(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3C14.5523 3 15 3.44772 15 4V9H20C20.5523 9 21 9.44772 21 10V20C21 20.5523 20.5523 21 20 21H10C9.44772 21 9 20.5523 9 20V15H4C3.44772 15 3 14.5523 3 14V4C3 3.44772 3.44772 3 4 3H14ZM13 5H5V13H13V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d0af87cd8e982c0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 3C11.5523 3 12 3.44772 12 4V6H17C17.5523 6 18 6.44772 18 7V12H20C20.5523 12 21 12.4477 21 13V20C21 20.5523 20.5523 21 20 21H13C12.4477 21 12 20.5523 12 20V18H7C6.44772 18 6 17.5523 6 17V12H4C3.44772 12 3 11.5523 3 11V4C3 3.44772 3.44772 3 4 3H11ZM16 8H8V16H16V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6672ae1559b2ee1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.95 8.46451L18.3642 7.05029L23.3139 12L18.3642 16.9498L16.95 15.5356L20.4855 12L16.95 8.46451ZM7.05048 8.46451L3.51495 12L7.05048 15.5356L5.63627 16.9498L0.686523 12L5.63627 7.05029L7.05048 8.46451Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$95d4c3714b27824e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3C12.5523 3 13 3.44772 13 4L12.9998 11.9998C13.8355 11.372 14.8743 11 16 11C18.7614 11 21 13.2386 21 16C21 18.7614 18.7614 21 16 21C14.9681 21 14.0092 20.6874 13.2129 20.1518L13 20C13 20.5523 12.5523 21 12 21H6C5.44772 21 5 20.5523 5 20V4C5 3.44772 5.44772 3 6 3H12ZM11 5H7V19H11V5ZM19 15H13V17H19V15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b4e342a0206bcee0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5C20.5523 5 21 5.44772 21 6V12C21 12.5523 20.5523 13 20 13C20.628 13.8355 21 14.8743 21 16C21 18.7614 18.7614 21 16 21C13.2386 21 11 18.7614 11 16C11 14.8743 11.372 13.8355 11.9998 12.9998L4 13C3.44772 13 3 12.5523 3 12V6C3 5.44772 3.44772 5 4 5H20ZM13 15V17H19V15H13ZM19 7H5V11H19V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7e40806915ccccdc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.58341 17.3211C3.55316 16.2275 3 15 3 13.0104C3 9.51092 5.45651 6.37372 9.03059 4.82324L9.92328 6.20085C6.58804 8.00545 5.93618 10.3461 5.67564 11.8221C6.21263 11.5444 6.91558 11.4467 7.60471 11.5106C9.40908 11.6778 10.8312 13.1591 10.8312 15C10.8312 16.933 9.26416 18.5 7.33116 18.5C6.2581 18.5 5.23196 18.0096 4.58341 17.3211ZM14.5834 17.3211C13.5532 16.2275 13 15 13 13.0104C13 9.51092 15.4565 6.37372 19.0306 4.82324L19.9233 6.20085C16.588 8.00545 15.9362 10.3461 15.6756 11.8221C16.2126 11.5444 16.9156 11.4467 17.6047 11.5106C19.4091 11.6778 20.8312 13.1591 20.8312 15C20.8312 16.933 19.2642 18.5 17.3312 18.5C16.2581 18.5 15.232 18.0096 14.5834 17.3211Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4418ac301eac7757(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.4167 6.67891C20.4469 7.77257 21.0001 9 21.0001 10.9897C21.0001 14.4891 18.5436 17.6263 14.9695 19.1768L14.0768 17.7992C17.4121 15.9946 18.0639 13.6539 18.3245 12.178C17.7875 12.4557 17.0845 12.5533 16.3954 12.4895C14.591 12.3222 13.1689 10.8409 13.1689 9C13.1689 7.067 14.7359 5.5 16.6689 5.5C17.742 5.5 18.7681 5.99045 19.4167 6.67891ZM9.41669 6.67891C10.4469 7.77257 11.0001 9 11.0001 10.9897C11.0001 14.4891 8.54359 17.6263 4.96951 19.1768L4.07682 17.7992C7.41206 15.9946 8.06392 13.6539 8.32447 12.178C7.78747 12.4557 7.08452 12.5533 6.39539 12.4895C4.59102 12.3222 3.16895 10.8409 3.16895 9C3.16895 7.067 4.73595 5.5 6.66895 5.5C7.742 5.5 8.76814 5.99045 9.41669 6.67891Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ff9433b6b703061b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 7C9.32843 7 10 6.32843 10 5.5C10 4.67157 9.32843 4 8.5 4C7.67157 4 7 4.67157 7 5.5C7 6.32843 7.67157 7 8.5 7ZM8.5 13.5C9.32843 13.5 10 12.8284 10 12C10 11.1716 9.32843 10.5 8.5 10.5C7.67157 10.5 7 11.1716 7 12C7 12.8284 7.67157 13.5 8.5 13.5ZM10 18.5C10 19.3284 9.32843 20 8.5 20C7.67157 20 7 19.3284 7 18.5C7 17.6716 7.67157 17 8.5 17C9.32843 17 10 17.6716 10 18.5ZM15.5 7C16.3284 7 17 6.32843 17 5.5C17 4.67157 16.3284 4 15.5 4C14.6716 4 14 4.67157 14 5.5C14 6.32843 14.6716 7 15.5 7ZM17 12C17 12.8284 16.3284 13.5 15.5 13.5C14.6716 13.5 14 12.8284 14 12C14 11.1716 14.6716 10.5 15.5 10.5C16.3284 10.5 17 11.1716 17 12ZM15.5 20C16.3284 20 17 19.3284 17 18.5C17 17.6716 16.3284 17 15.5 17C14.6716 17 14 17.6716 14 18.5C14 19.3284 14.6716 20 15.5 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2c76b50a7d9dd31e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5V19H13V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V9H20V5H4ZM19.7071 11.2929L19 10.5858L18.2929 11.2929L15.2929 14.2929L16.7071 15.7071L19 13.4142L21.2929 15.7071L22.7071 14.2929L19.7071 11.2929ZM16.7071 17.2929L19 19.5858L21.2929 17.2929L22.7071 18.7071L19.7071 21.7071L19 22.4142L18.2929 21.7071L15.2929 18.7071L16.7071 17.2929Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7324a0c7ebd5fc6b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19C12.8284 19 13.5 19.6716 13.5 20.5C13.5 21.3284 12.8284 22 12 22C11.1716 22 10.5 21.3284 10.5 20.5C10.5 19.6716 11.1716 19 12 19ZM6.5 19C7.32843 19 8 19.6716 8 20.5C8 21.3284 7.32843 22 6.5 22C5.67157 22 5 21.3284 5 20.5C5 19.6716 5.67157 19 6.5 19ZM17.5 19C18.3284 19 19 19.6716 19 20.5C19 21.3284 18.3284 22 17.5 22C16.6716 22 16 21.3284 16 20.5C16 19.6716 16.6716 19 17.5 19ZM13 2V4H19V6L17.0322 6.0006C16.2423 8.3666 14.9984 10.5065 13.4107 12.302C14.9544 13.6737 16.7616 14.7204 18.7379 15.3443L18.2017 17.2736C15.8917 16.5557 13.787 15.3326 12.0005 13.7257C10.214 15.332 8.10914 16.5553 5.79891 17.2734L5.26257 15.3442C7.2385 14.7203 9.04543 13.6737 10.5904 12.3021C9.46307 11.0285 8.50916 9.58052 7.76789 8.00128L10.0074 8.00137C10.5706 9.03952 11.2401 10.0037 11.9998 10.8772C13.2283 9.46508 14.2205 7.81616 14.9095 6.00101L5 6V4H11V2H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2efccdfd53543b11(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19C12.8284 19 13.5 19.6716 13.5 20.5C13.5 21.3284 12.8284 22 12 22C11.1716 22 10.5 21.3284 10.5 20.5C10.5 19.6716 11.1716 19 12 19ZM6.5 19C7.32843 19 8 19.6716 8 20.5C8 21.3284 7.32843 22 6.5 22C5.67157 22 5 21.3284 5 20.5C5 19.6716 5.67157 19 6.5 19ZM17.5 19C18.3284 19 19 19.6716 19 20.5C19 21.3284 18.3284 22 17.5 22C16.6716 22 16 21.3284 16 20.5C16 19.6716 16.6716 19 17.5 19ZM18 3V5H8V9H17V11H8V15H18V17H6V3H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ce06f9d50c57e8d7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10H16L16.0005 10.7574C16.7154 10.279 17.5751 10 18.5 10C20.9853 10 23 12.0147 23 14.5V20H21V14.5C21 13.07 19.8255 12 18.5 12C17.1745 12 16 13.07 16 14.5V20H14V10ZM12 4V6H4V11H12V13H4V18H12V20H2V4H12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$88dacfd85954940c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 21.5C4.067 21.5 2.5 19.933 2.5 18C2.5 16.067 4.067 14.5 6 14.5C7.5852 14.5 8.92427 15.5538 9.35481 16.9991L15 16.9993V15L17 14.9993V9.24332L14.757 6.99932H9V8.99996H3V2.99996H9V4.99932H14.757L18 1.75732L22.2426 5.99996L19 9.24132V14.9993L21 15V21H15V18.9993L9.35499 19.0002C8.92464 20.4458 7.58543 21.5 6 21.5ZM6 16.5C5.17157 16.5 4.5 17.1715 4.5 18C4.5 18.8284 5.17157 19.5 6 19.5C6.82843 19.5 7.5 18.8284 7.5 18C7.5 17.1715 6.82843 16.5 6 16.5ZM19 17H17V19H19V17ZM18 4.58575L16.5858 5.99996L18 7.41418L19.4142 5.99996L18 4.58575ZM7 4.99996H5V6.99996H7V4.99996Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6c298b36b09b090c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.2459 14H8.75407L7.15407 18H5L11 3H13L19 18H16.8459L15.2459 14ZM14.4459 12L12 5.88516L9.55407 12H14.4459ZM3 20H21V22H3V20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a43ed3a88131c542(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.55446 22H3.40039L11.0004 3H13.0004L20.6004 22H18.4463L16.0463 16H7.95446L5.55446 22ZM8.75446 14H15.2463L12.0004 5.88517L8.75446 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a58ced2d2e28bbd7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4H19V6H8V12H18V14H8V21H6V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d20e5e135b1321d1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4H19V8H17.5C17 6 17 5 15 5H10V12H13C14 12 15 11.5 15 10H16V15H15C15 13.5 14 13 13 13H10V17.5C10 20 13.5 20 13.5 20V21H5V20C7 19.5 7 18.5 7 17.5V7.5C7 6.5 7 5.5 5 5V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d15c8dd6a497776d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4H19V6H10V12H18V14H10V21H7V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ef6b9c3efca64f0d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6V21H8V6H2V4H16V6H10ZM18 14V21H16V14H13V12H21V14H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$de6ebf22afa62eec(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.2455 15H4.75368L2.75368 20H0.599609L6.99961 4H8.99961L15.3996 20H13.2455L11.2455 15ZM10.4455 13L7.99961 6.88516L5.55368 13H10.4455ZM20.9996 12.5351V12H22.9996V20H20.9996V19.4649C20.4113 19.8052 19.7282 20 18.9996 20C16.7905 20 14.9996 18.2091 14.9996 16C14.9996 13.7909 16.7905 12 18.9996 12C19.7282 12 20.4113 12.1948 20.9996 12.5351ZM18.9996 18C20.1042 18 20.9996 17.1046 20.9996 16C20.9996 14.8954 20.1042 14 18.9996 14C17.895 14 16.9996 14.8954 16.9996 16C16.9996 17.1046 17.895 18 18.9996 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9c3d80654d80d7f0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.6512 14.0654L11.6047 19.9999H9.57389L10.9247 12.3389L3.51465 4.92886L4.92886 3.51465L20.4852 19.071L19.071 20.4852L12.6512 14.0654ZM11.7727 7.53003L12.0425 5.99993H10.2426L8.24257 3.99993H19.9999V5.99993H14.0733L13.4991 9.25646L11.7727 7.53003Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8d181f75592a32e0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18L12.6796 12L5 6V4H19V6H8.26348L16 12L8.26348 18H19V20H5V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1428117b86ab8d95(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 20H11V13H4V20H2V4H4V11H11V4H13V20ZM21.0005 8V20H19.0005L19 10.204L17 10.74V8.67L19.5005 8H21.0005Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2e87ce771c9577ad(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4V11H11V4H13V20H11V13H4V20H2V4H4ZM18.5 8C20.5711 8 22.25 9.67893 22.25 11.75C22.25 12.6074 21.9623 13.3976 21.4781 14.0292L21.3302 14.2102L18.0343 18H22V20H15L14.9993 18.444L19.8207 12.8981C20.0881 12.5908 20.25 12.1893 20.25 11.75C20.25 10.7835 19.4665 10 18.5 10C17.5818 10 16.8288 10.7071 16.7558 11.6065L16.75 11.75H14.75C14.75 9.67893 16.4289 8 18.5 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d35e2b002beae01c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8L21.9984 10L19.4934 12.883C21.0823 13.3184 22.25 14.7728 22.25 16.5C22.25 18.5711 20.5711 20.25 18.5 20.25C16.674 20.25 15.1528 18.9449 14.8184 17.2166L16.7821 16.8352C16.9384 17.6413 17.6481 18.25 18.5 18.25C19.4665 18.25 20.25 17.4665 20.25 16.5C20.25 15.5335 19.4665 14.75 18.5 14.75C18.214 14.75 17.944 14.8186 17.7056 14.9403L16.3992 13.3932L19.3484 10H15V8H22ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f2521c31e015d637(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 20H11V13H4V20H2V4H4V11H11V4H13V20ZM22 8V16H23.5V18H22V20H20V18H14.5V16.66L19.5 8H22ZM20 11.133L17.19 16H20V11.133Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e0a13bf92136ec22(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8V10H17.6769L17.2126 12.6358C17.5435 12.5472 17.8912 12.5 18.25 12.5C20.4591 12.5 22.25 14.2909 22.25 16.5C22.25 18.7091 20.4591 20.5 18.25 20.5C16.4233 20.5 14.8827 19.2756 14.4039 17.6027L16.3271 17.0519C16.5667 17.8881 17.3369 18.5 18.25 18.5C19.3546 18.5 20.25 17.6046 20.25 16.5C20.25 15.3954 19.3546 14.5 18.25 14.5C17.6194 14.5 17.057 14.7918 16.6904 15.2478L14.8803 14.3439L16 8H22ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1c9bbfd31dd1da4f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.097 8L18.499 12.5C20.7091 12.5 22.5 14.2909 22.5 16.5C22.5 18.7091 20.7091 20.5 18.5 20.5C16.2909 20.5 14.5 18.7091 14.5 16.5C14.5 15.7636 14.699 15.0737 15.0461 14.4811L18.788 8H21.097ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4ZM18.5 14.5C17.3954 14.5 16.5 15.3954 16.5 16.5C16.5 17.6046 17.3954 18.5 18.5 18.5C19.6046 18.5 20.5 17.6046 20.5 16.5C20.5 15.3954 19.6046 14.5 18.5 14.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dbf1978bb1c92608(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.78428 14L8.2047 10H4V8H8.41491L8.94043 3H10.9514L10.4259 8H14.4149L14.9404 3H16.9514L16.4259 8H20V10H16.2157L15.7953 14H20V16H15.5851L15.0596 21H13.0486L13.5741 16H9.58509L9.05957 21H7.04855L7.57407 16H4V14H7.78428ZM9.7953 14H13.7843L14.2047 10H10.2157L9.7953 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ffbbd2b24c092885(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11V4H19V21H17V13H7V21H5V4H7V11H17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d4fcdd769558e890(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM11 14H21V16H11V14ZM11 9H21V11H11V9ZM3 12.5L7 9V16L3 12.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1e1f833c1e65d76a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM11 14H21V16H11V14ZM11 9H21V11H11V9ZM7 12.5L3 16V9L7 12.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c7d08d6e4c93ac8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21V19H11V5H8V3H16V5H13V19H16V21H8ZM18.0503 7.05025L23 12L18.0503 16.9497L16.636 15.5355L20.1716 12L16.636 8.46447L18.0503 7.05025ZM5.94975 7.05025L7.36396 8.46447L3.82843 12L7.36396 15.5355L5.94975 16.9497L1 12L5.94975 7.05025Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7cae42f77e16a764(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H14C13.4477 21 13 20.5523 13 20V4C13 3.44772 13.4477 3 14 3H20ZM19 5H15V19H19V5ZM6 7C8.76142 7 11 9.23858 11 12C11 14.7614 8.76142 17 6 17C3.23858 17 1 14.7614 1 12C1 9.23858 3.23858 7 6 7ZM7 9H5V10.999L3 11V13L5 12.999V15H7V12.999L9 13V11L7 10.999V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5e1c92eabf57ec5f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3C10.5523 3 11 3.44772 11 4V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H10ZM9 5H5V19H9V5ZM18 7C20.7614 7 23 9.23858 23 12C23 14.7614 20.7614 17 18 17C15.2386 17 13 14.7614 13 12C13 9.23858 15.2386 7 18 7ZM19 9H17V10.999L15 11V13L17 12.999V15H19V12.999L21 13V11L19 10.999V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ee3386e36881ad64(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13C14.7614 13 17 15.2386 17 18C17 20.7614 14.7614 23 12 23C9.23858 23 7 20.7614 7 18C7 15.2386 9.23858 13 12 13ZM13 15H11V16.999L9 17V19L11 18.999V21H13V18.999L15 19V17L13 16.999V15ZM20 3C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11H4C3.44772 11 3 10.5523 3 10V4C3 3.44772 3.44772 3 4 3H20ZM5 5V9H19V5H5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ed802f28fe830579(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13C20.5523 13 21 13.4477 21 14V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V14C3 13.4477 3.44772 13 4 13H20ZM19 15H5V19H19V15ZM12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6C7 3.23858 9.23858 1 12 1ZM13 3H11V4.999L9 5V7L11 6.999V9H13V6.999L15 7V5L13 4.999V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c2415f066daee9e0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 20H7V18H9.92661L12.0425 6H9V4H17V6H14.0734L11.9575 18H15V20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1611278efa0d422e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4H21V6H11V4ZM6 7V11H4V7H1L5 3L9 7H6ZM6 17H9L5 21L1 17H4V13H6V17ZM11 18H21V20H11V18ZM9 11H21V13H9V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7337925bc09f07ea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6572 14.8282L16.2429 13.414L17.6572 11.9998C19.2193 10.4377 19.2193 7.90506 17.6572 6.34296C16.0951 4.78086 13.5624 4.78086 12.0003 6.34296L10.5861 7.75717L9.17188 6.34296L10.5861 4.92875C12.9292 2.5856 16.7282 2.5856 19.0714 4.92875C21.4145 7.27189 21.4145 11.0709 19.0714 13.414L17.6572 14.8282ZM14.8287 17.6567L13.4145 19.0709C11.0714 21.414 7.27238 21.414 4.92923 19.0709C2.58609 16.7277 2.58609 12.9287 4.92923 10.5856L6.34345 9.17139L7.75766 10.5856L6.34345 11.9998C4.78135 13.5619 4.78135 16.0946 6.34345 17.6567C7.90555 19.2188 10.4382 19.2188 12.0003 17.6567L13.4145 16.2425L14.8287 17.6567ZM14.8287 7.75717L16.2429 9.17139L9.17188 16.2425L7.75766 14.8282L14.8287 7.75717Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b93dad8fe1f0690a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.657 14.8286L16.2428 13.4143L17.657 12.0001C19.2191 10.438 19.2191 7.90538 17.657 6.34328C16.0949 4.78118 13.5622 4.78118 12.0001 6.34328L10.5859 7.75749L9.17171 6.34328L10.5859 4.92907C12.9291 2.58592 16.7281 2.58592 19.0712 4.92907C21.4143 7.27221 21.4143 11.0712 19.0712 13.4143L17.657 14.8286ZM14.8286 17.657L13.4143 19.0712C11.0712 21.4143 7.27221 21.4143 4.92907 19.0712C2.58592 16.7281 2.58592 12.9291 4.92907 10.5859L6.34328 9.17171L7.75749 10.5859L6.34328 12.0001C4.78118 13.5622 4.78118 16.0949 6.34328 17.657C7.90538 19.2191 10.438 19.2191 12.0001 17.657L13.4143 16.2428L14.8286 17.657ZM14.8286 7.75749L16.2428 9.17171L9.17171 16.2428L7.75749 14.8286L14.8286 7.75749ZM5.77539 2.29303L7.70724 1.77539L8.74252 5.63909L6.81067 6.15673L5.77539 2.29303ZM15.2578 18.3612L17.1896 17.8435L18.2249 21.7072L16.293 22.2249L15.2578 18.3612ZM2.29303 5.77539L6.15673 6.81067L5.63909 8.74252L1.77539 7.70724L2.29303 5.77539ZM18.3612 15.2578L22.2249 16.293L21.7072 18.2249L17.8435 17.1896L18.3612 15.2578Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$99712a4b1a38ea7a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17H22V19H19V22H17V17ZM7 7H2V5H5V2H7V7ZM18.364 15.5355L16.9497 14.1213L18.364 12.7071C20.3166 10.7545 20.3166 7.58866 18.364 5.63604C16.4113 3.68342 13.2455 3.68342 11.2929 5.63604L9.87868 7.05025L8.46447 5.63604L9.87868 4.22183C12.6123 1.48816 17.0445 1.48816 19.7782 4.22183C22.5118 6.9555 22.5118 11.3877 19.7782 14.1213L18.364 15.5355ZM15.5355 18.364L14.1213 19.7782C11.3877 22.5118 6.9555 22.5118 4.22183 19.7782C1.48816 17.0445 1.48816 12.6123 4.22183 9.87868L5.63604 8.46447L7.05025 9.87868L5.63604 11.2929C3.68342 13.2455 3.68342 16.4113 5.63604 18.364C7.58866 20.3166 10.7545 20.3166 12.7071 18.364L14.1213 16.9497L15.5355 18.364ZM14.8284 7.75736L16.2426 9.17157L9.17157 16.2426L7.75736 14.8284L14.8284 7.75736Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1c3d0ce414d6079c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.3643 15.5353L16.95 14.1211L18.3643 12.7069C20.3169 10.7543 20.3169 7.58847 18.3643 5.63585C16.4116 3.68323 13.2458 3.68323 11.2932 5.63585L9.87898 7.05007L8.46477 5.63585L9.87898 4.22164C12.6127 1.48797 17.0448 1.48797 19.7785 4.22164C22.5121 6.95531 22.5121 11.3875 19.7785 14.1211L18.3643 15.5353ZM15.5358 18.3638L14.1216 19.778C11.388 22.5117 6.9558 22.5117 4.22213 19.778C1.48846 17.0443 1.48846 12.6122 4.22213 9.87849L5.63634 8.46428L7.05055 9.87849L5.63634 11.2927C3.68372 13.2453 3.68372 16.4112 5.63634 18.3638C7.58896 20.3164 10.7548 20.3164 12.7074 18.3638L14.1216 16.9496L15.5358 18.3638ZM14.8287 7.75717L16.2429 9.17139L9.17187 16.2425L7.75766 14.8282L14.8287 7.75717Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fe663ddf78a701b3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4H21V6H11V4ZM11 8H17V10H11V8ZM11 14H21V16H11V14ZM11 18H17V20H11V18ZM3 4H9V10H3V4ZM5 6V8H7V6H5ZM3 14H9V20H3V14ZM5 16V18H7V16H5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a35b7d8829316346(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.00008 6V9H5.00008V6H8.00008ZM3.00008 4V11H10.0001V4H3.00008ZM13.0001 4H21.0001V6H13.0001V4ZM13.0001 11H21.0001V13H13.0001V11ZM13.0001 18H21.0001V20H13.0001V18ZM10.7072 16.2071L9.29297 14.7929L6.00008 18.0858L4.20718 16.2929L2.79297 17.7071L6.00008 20.9142L10.7072 16.2071Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1418af60465932c0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4H21V6H8V4ZM3 3.5H6V6.5H3V3.5ZM3 10.5H6V13.5H3V10.5ZM3 17.5H6V20.5H3V17.5ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7ce59b588fa22e08(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4H21V6H13V4ZM13 11H21V13H13V11ZM13 18H21V20H13V18ZM6.5 19C5.39543 19 4.5 18.1046 4.5 17C4.5 15.8954 5.39543 15 6.5 15C7.60457 15 8.5 15.8954 8.5 17C8.5 18.1046 7.60457 19 6.5 19ZM6.5 21C8.70914 21 10.5 19.2091 10.5 17C10.5 14.7909 8.70914 13 6.5 13C4.29086 13 2.5 14.7909 2.5 17C2.5 19.2091 4.29086 21 6.5 21ZM5 6V9H8V6H5ZM3 4H10V11H3V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1e29171c2b3be80c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.75024 3.5H4.71733L3.25 3.89317V5.44582L4.25002 5.17782L4.25018 8.5H3V10H7V8.5H5.75024V3.5ZM10 4H21V6H10V4ZM10 11H21V13H10V11ZM10 18H21V20H10V18ZM2.875 15.625C2.875 14.4514 3.82639 13.5 5 13.5C6.17361 13.5 7.125 14.4514 7.125 15.625C7.125 16.1106 6.96183 16.5587 6.68747 16.9167L6.68271 16.9229L5.31587 18.5H7V20H3.00012L2.99959 18.8786L5.4717 16.035C5.5673 15.9252 5.625 15.7821 5.625 15.625C5.625 15.2798 5.34518 15 5 15C4.67378 15 4.40573 15.2501 4.37747 15.5688L4.3651 15.875H2.875V15.625Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c2240a9ec85819a5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4H21V6H8V4ZM5 3V6H6V7H3V6H4V4H3V3H5ZM3 14V11.5H5V11H3V10H6V12.5H4V13H6V14H3ZM5 19.5H3V18.5H5V18H3V17H6V21H3V20H5V19.5ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a562591da066df52(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 7C8.5 5.89543 7.60457 5 6.5 5C5.39543 5 4.5 5.89543 4.5 7C4.5 8.10457 5.39543 9 6.5 9C7.60457 9 8.5 8.10457 8.5 7ZM10.5 7C10.5 9.20914 8.70914 11 6.5 11C4.29086 11 2.5 9.20914 2.5 7C2.5 4.79086 4.29086 3 6.5 3C8.70914 3 10.5 4.79086 10.5 7ZM21 4H13V6H21V4ZM21 11H13V13H21V11ZM21 18H13V20H21V18ZM6.5 19C5.39543 19 4.5 18.1046 4.5 17C4.5 15.8954 5.39543 15 6.5 15C7.60457 15 8.5 15.8954 8.5 17C8.5 18.1046 7.60457 19 6.5 19ZM6.5 21C8.70914 21 10.5 19.2091 10.5 17C10.5 14.7909 8.70914 13 6.5 13C4.29086 13 2.5 14.7909 2.5 17C2.5 19.2091 4.29086 21 6.5 21ZM6.5 8C7.05228 8 7.5 7.55228 7.5 7C7.5 6.44772 7.05228 6 6.5 6C5.94772 6 5.5 6.44772 5.5 7C5.5 7.55228 5.94772 8 6.5 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$705c34697983f864(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4H21V6H8V4ZM4.5 6.5C3.67157 6.5 3 5.82843 3 5C3 4.17157 3.67157 3.5 4.5 3.5C5.32843 3.5 6 4.17157 6 5C6 5.82843 5.32843 6.5 4.5 6.5ZM4.5 13.5C3.67157 13.5 3 12.8284 3 12C3 11.1716 3.67157 10.5 4.5 10.5C5.32843 10.5 6 11.1716 6 12C6 12.8284 5.32843 13.5 4.5 13.5ZM4.5 20.4C3.67157 20.4 3 19.7284 3 18.9C3 18.0716 3.67157 17.4 4.5 17.4C5.32843 17.4 6 18.0716 6 18.9C6 19.7284 5.32843 20.4 4.5 20.4ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1ff89ba04fd12bda(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM11 5H5V10.999H7V9L10 12L7 15V13H5V19H11V17H13V19H19V13H17V15L14 12L17 9V10.999H19V5H13V7H11V5ZM13 13V15H11V13H13ZM13 9V11H11V9H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$293be09447b4ca5f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20ZM19 11V5H13.001V7H15L12 10L9 7H11V5H5V11H7V13H5V19H11V17H9L12 14L15 17H13.001V19H19V13H17V11H19ZM11 13H9V11H11V13ZM15 13H13V11H15V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fc1df666c25f6ee2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3C19.6569 3 21 4.34315 21 6C21 7.65685 19.6569 9 18 9H15C13.6941 9 12.5831 8.16562 12.171 7.0009L11 7C9.9 7 9 7.9 9 9L9.0009 9.17102C10.1656 9.58312 11 10.6941 11 12C11 13.3059 10.1656 14.4169 9.0009 14.829L9 15C9 16.1 9.9 17 11 17L12.1707 17.0001C12.5825 15.8349 13.6937 15 15 15H18C19.6569 15 21 16.3431 21 18C21 19.6569 19.6569 21 18 21H15C13.6941 21 12.5831 20.1656 12.171 19.0009L11 19C8.79 19 7 17.21 7 15H5C3.34315 15 2 13.6569 2 12C2 10.3431 3.34315 9 5 9H7C7 6.79086 8.79086 5 11 5L12.1707 5.00009C12.5825 3.83485 13.6937 3 15 3H18ZM18 17H15C14.4477 17 14 17.4477 14 18C14 18.5523 14.4477 19 15 19H18C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17ZM8 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H8C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11ZM18 5H15C14.4477 5 14 5.44772 14 6C14 6.55228 14.4477 7 15 7H18C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1938ae99440e755(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2C10.5523 2 11 2.44772 11 3V7C11 7.55228 10.5523 8 10 8H8V10H13V9C13 8.44772 13.4477 8 14 8H20C20.5523 8 21 8.44772 21 9V13C21 13.5523 20.5523 14 20 14H14C13.4477 14 13 13.5523 13 13V12H8V18H13V17C13 16.4477 13.4477 16 14 16H20C20.5523 16 21 16.4477 21 17V21C21 21.5523 20.5523 22 20 22H14C13.4477 22 13 21.5523 13 21V20H7C6.44772 20 6 19.5523 6 19V8H4C3.44772 8 3 7.55228 3 7V3C3 2.44772 3.44772 2 4 2H10ZM19 18H15V20H19V18ZM19 10H15V12H19V10ZM9 4H5V6H9V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d0ae72475ddee1d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1.5C13.3212 1.5 14.4839 1.84812 15.4468 2.49362C16.4098 3.13913 17.1731 4.08202 17.6956 5.27156C18.2182 6.4611 18.5 7.8973 18.5 9.52941V14.4706C18.5 16.1027 18.2182 17.5389 17.6956 18.7284C17.1731 19.918 16.4098 20.8609 15.4468 21.5064C14.4839 22.1519 13.3212 22.5 12 22.5C10.6788 22.5 9.51613 22.1519 8.55317 21.5064C7.5902 20.8609 6.82691 19.918 6.30436 18.7284C5.78181 17.5389 5.5 16.1027 5.5 14.4706V9.52941C5.5 7.8973 5.78181 6.4611 6.30436 5.27156C6.82691 4.08202 7.5902 3.13913 8.55317 2.49362C9.51613 1.84812 10.6788 1.5 12 1.5ZM12 3.5C11.084 3.5 10.3059 3.72649 9.66678 4.15491C9.02961 4.58202 8.50949 5.22453 8.13547 6.07594C7.72283 7.01528 7.5 8.18343 7.5 9.52941V14.4706C7.5 15.8166 7.72283 16.9847 8.13547 17.9241C8.50949 18.7755 9.02961 19.418 9.66678 19.8451C10.3059 20.2735 11.084 20.5 12 20.5C12.916 20.5 13.6941 20.2735 14.3332 19.8451C14.9704 19.418 15.4905 18.7755 15.8645 17.9241C16.2772 16.9847 16.5 15.8166 16.5 14.4706V9.52941C16.5 8.18343 16.2772 7.01528 15.8645 6.07594C15.4905 5.22453 14.9704 4.58202 14.3332 4.15491C13.6941 3.72649 12.916 3.5 12 3.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fa39618acb25699a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1.5V22H12V3.704L7.5 4.91V2.839L12.5 1.5H14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ef6767e718b656db(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.0002 7.5C16.0002 5.29086 14.2094 3.5 12.0002 3.5C9.7911 3.5 8.00024 5.29086 8.00024 7.5H6.00024C6.00024 4.18629 8.68653 1.5 12.0002 1.5C15.314 1.5 18.0002 4.18629 18.0002 7.5C18.0002 8.93092 17.4993 10.2448 16.6633 11.276L9.344 19.9991L18.0002 20V22H6.00024L6 20.8731L15.0642 10.071C15.6485 9.37595 16.0002 8.47905 16.0002 7.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$96cc4b4f4a1b8184(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.0005 2V3.36217L12.8092 9.54981C16.0174 9.94792 18.5005 12.684 18.5005 16C18.5005 19.5899 15.5904 22.5 12.0005 22.5C8.95483 22.5 6.39837 20.4052 5.69336 17.5778L7.634 17.0922C8.12205 19.0497 9.89193 20.5 12.0005 20.5C14.4858 20.5 16.5005 18.4853 16.5005 16C16.5005 13.5147 14.4858 11.5 12.0005 11.5C11.28 11.5 10.599 11.6694 9.99514 11.9705L9.76741 12.0923L9.07754 10.8852L14.8555 3.99917L6.50054 4V2H18.0005Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ba413514da9c941d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.0001 1.5L16 16H19.0001V18H16L16.0001 22H14.0001L14 18H4V16.898L14.0001 1.5H16.0001ZM14 16V5.171L6.968 16H14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8795b18cddd83379(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.0005 2V4H9.30073L8.62386 10.4448C9.60799 9.84532 10.7639 9.5 12.0005 9.5C15.5904 9.5 18.5005 12.4101 18.5005 16C18.5005 19.5899 15.5904 22.5 12.0005 22.5C8.95483 22.5 6.39837 20.4052 5.69336 17.5778L7.634 17.0922C8.12205 19.0497 9.89193 20.5 12.0005 20.5C14.4858 20.5 16.5005 18.4853 16.5005 16C16.5005 13.5147 14.4858 11.5 12.0005 11.5C9.97832 11.5 8.72286 12.139 8.04033 13.0293L6.46536 11.848L7.50054 2H18.0005Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d480e68165f19431(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.886 2L10.4482 9.6864C10.9454 9.56459 11.4652 9.5 12 9.5C15.5899 9.5 18.5 12.4101 18.5 16C18.5 19.5899 15.5899 22.5 12 22.5C8.41015 22.5 5.5 19.5899 5.5 16C5.5 14.7949 5.82793 13.6665 6.39941 12.699L12.576 2H14.886ZM12 11.5C9.51472 11.5 7.5 13.5147 7.5 16C7.5 18.4853 9.51472 20.5 12 20.5C14.4853 20.5 16.5 18.4853 16.5 16C16.5 13.5147 14.4853 11.5 12 11.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$45bbda06d2675478(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2V3.5L10.763 21.9995H8.574L16.587 4H6V2H19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8f267cdb7bcafbea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1.5C15.0376 1.5 17.5 3.96243 17.5 7C17.5 8.77579 16.6584 10.355 15.3523 11.3606C17.2389 12.4091 18.5 14.3186 18.5 16.5C18.5 19.8137 15.5899 22.5 12 22.5C8.41015 22.5 5.5 19.8137 5.5 16.5C5.5 14.3186 6.7611 12.4091 8.64703 11.3589C7.34158 10.355 6.5 8.77579 6.5 7C6.5 3.96243 8.96243 1.5 12 1.5ZM12 12.5C9.48055 12.5 7.5 14.3282 7.5 16.5C7.5 18.6718 9.48055 20.5 12 20.5C14.5194 20.5 16.5 18.6718 16.5 16.5C16.5 14.3282 14.5194 12.5 12 12.5ZM12 3.5C10.067 3.5 8.5 5.067 8.5 7C8.5 8.933 10.067 10.5 12 10.5C13.933 10.5 15.5 8.933 15.5 7C15.5 5.067 13.933 3.5 12 3.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2e1ca646ee8094d6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1.5C15.5899 1.5 18.5 4.41015 18.5 8C18.5 9.19219 18.179 10.3094 17.6188 11.27L11.423 21.999H9.114L13.5528 14.3134C13.0553 14.4353 12.5352 14.5 12 14.5C8.41015 14.5 5.5 11.5899 5.5 8C5.5 4.41015 8.41015 1.5 12 1.5ZM12 3.5C9.51472 3.5 7.5 5.51472 7.5 8C7.5 10.4853 9.51472 12.5 12 12.5C14.4853 12.5 16.5 10.4853 16.5 8C16.5 5.51472 14.4853 3.5 12 3.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a4a77dba485d1255(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 20V17.8432C15.8631 16.6512 17.5 13.9677 17.5 10.8844C17.5 7.8107 15.5 4.85516 12 4.85516C8.5 4.85516 6.5 7.8107 6.5 10.8844C6.5 13.9677 8.13687 16.6512 10 17.8432V20H3V18H7.7597C5.66635 16.5054 4 13.9889 4 10.8844C4 6.24653 7.5 3 12 3C16.5 3 20 6.24653 20 10.8844C20 13.9889 18.3336 16.5054 16.2403 18H21V20H14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ff5b155b8b15af67(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3C15.5523 3 16 3.44772 16 4V8C16 8.55228 15.5523 9 15 9H13V11H17C17.5523 11 18 11.4477 18 12V15H20C20.5523 15 21 15.4477 21 16V20C21 20.5523 20.5523 21 20 21H14C13.4477 21 13 20.5523 13 20V16C13 15.4477 13.4477 15 14 15H16V13H8V15H10C10.5523 15 11 15.4477 11 16V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V16C3 15.4477 3.44772 15 4 15H6V12C6 11.4477 6.44772 11 7 11H11V9H9C8.44772 9 8 8.55228 8 8V4C8 3.44772 8.44772 3 9 3H15ZM9 17H5V19H9V17ZM19 17H15V19H19V17ZM14 5H10V7H14V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$361d5d0b08dcba90(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.2459 18H8.75407L7.15407 22H5L11 7H13L19 22H16.8459L15.2459 18ZM14.4459 16L12 9.88516L9.55407 16H14.4459ZM4 3H20V5H4V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$793e3768a54805f9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 21V17H7V21H5V16C5 15.4477 5.44772 15 6 15H18C18.5523 15 19 15.4477 19 16V21H17ZM7 3V7H17V3H19V8C19 8.55228 18.5523 9 18 9H6C5.44772 9 5 8.55228 5 8V3H7ZM2 9L6 12L2 15V9ZM22 9V15L18 12L22 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2679e4c07bd17f18(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6V21H10V16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4H20V6H17V21H15V6H12ZM10 6C7.79086 6 6 7.79086 6 10C6 12.2091 7.79086 14 10 14V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fc75e591db986741(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.934 3.0359L19.666 4.0359L18.531 6H21V8H19V12H21V14H19V21H17V14L13.9157 14.0004C13.5914 16.8623 12.3522 19.3936 10.5466 21.1933L8.98361 19.9233C10.5031 18.4847 11.5801 16.4008 11.9008 14.0009L10 14V12L12 11.999V8H10V6H12.467L11.334 4.0359L13.066 3.0359L14.777 6H16.221L17.934 3.0359ZM5 13.803L3 14.339V12.268L5 11.732V8H3V6H5V3H7V6H9V8H7V11.197L9 10.661V12.731L7 13.267V18.5C7 19.8807 5.88071 21 4.5 21H3V19H4.5C4.74546 19 4.94961 18.8231 4.99194 18.5899L5 18.5V13.803ZM17 8H14V12H17V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e0dbf38b9e2efd0e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19C12.8284 19 13.5 19.6716 13.5 20.5C13.5 21.3284 12.8284 22 12 22C11.1716 22 10.5 21.3284 10.5 20.5C10.5 19.6716 11.1716 19 12 19ZM12 2C15.3137 2 18 4.68629 18 8C18 10.1646 17.2474 11.2907 15.3259 12.9231C13.3986 14.5604 13 15.2969 13 17H11C11 14.526 11.787 13.3052 14.031 11.3989C15.5479 10.1102 16 9.43374 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8V9H6V8C6 4.68629 8.68629 2 12 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fdbeaf5c9038219d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3V6H21V4ZM21 11H8V13H21V11ZM21 18H8V20H21V18ZM5 11H3V20H5V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1fa4a7794358f312(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19V21H19V19H21ZM17 19V21H15V19H17ZM13 19V21H11V19H13ZM9 19V21H7V19H9ZM5 19V21H3V19H5ZM21 15V17H19V15H21ZM5 15V17H3V15H5ZM5 11V13H3V11H5ZM16 3C18.6874 3 20.8817 5.12366 20.9954 7.78322L21 8V13H19V8C19 6.40893 17.7447 5.09681 16.1756 5.00512L16 5H11V3H16ZM5 7V9H3V7H5ZM5 3V5H3V3H5ZM9 3V5H7V3H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8a35e040745c2294(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3C14.5523 3 15 3.44772 15 4V9H20C20.5523 9 21 9.44772 21 10V20C21 20.5523 20.5523 21 20 21H10C9.44772 21 9 20.5523 9 20V15H4C3.44772 15 3 14.5523 3 14V4C3 3.44772 3.44772 3 4 3H14ZM13 5H5V13H9V10C9 9.44772 9.44772 9 10 9H13V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ccbe73e3094ee39c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 3C11.5523 3 12 3.44772 12 4V6H17C17.5523 6 18 6.44772 18 7V12H20C20.5523 12 21 12.4477 21 13V20C21 20.5523 20.5523 21 20 21H13C12.4477 21 12 20.5523 12 20V18H7C6.44772 18 6 17.5523 6 17V12H4C3.44772 12 3 11.5523 3 11V4C3 3.44772 3.44772 3 4 3H11ZM16 8H12V11C12 11.5523 11.5523 12 11 12H8V16H12V13C12 12.4477 12.4477 12 13 12H16V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$219df406f03cfd9c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 11H4V13H2V11ZM6 11H18V13H6V11ZM20 11H22V13H20V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$db30668347638463(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.58341 17.3211C8.55316 16.2275 8 15 8 13.0104C8 9.51092 10.4565 6.37372 14.0306 4.82324L14.9233 6.20085C11.588 8.00545 10.9362 10.3461 10.6756 11.8221C11.2126 11.5444 11.9156 11.4467 12.6047 11.5106C14.4091 11.6778 15.8312 13.1591 15.8312 15C15.8312 16.933 14.2642 18.5 12.3312 18.5C11.2581 18.5 10.232 18.0096 9.58341 17.3211Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8891307731ec0f86(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.4167 6.67891C15.4469 7.77257 16.0001 9 16.0001 10.9897C16.0001 14.4891 13.5436 17.6263 9.96951 19.1768L9.07682 17.7992C12.4121 15.9946 13.0639 13.6539 13.3245 12.178C12.7875 12.4557 12.0845 12.5533 11.3954 12.4895C9.59102 12.3222 8.16895 10.8409 8.16895 9C8.16895 7.067 9.73595 5.5 11.6689 5.5C12.742 5.5 13.7681 5.99045 14.4167 6.67891Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$caeca8258843b0ce(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.0357 7.69802C8.38492 9.55932 6.5134 12.2442 4.89465 15.4817C4.64766 15.9757 4.04698 16.1759 3.55301 15.9289C3.05903 15.6819 2.8588 15.0812 3.10579 14.5873C4.79739 11.2041 6.76494 8.37171 8.53943 6.37095C9.4251 5.37234 10.2797 4.56162 11.0449 3.99131C11.4272 3.7063 11.8049 3.46806 12.1677 3.29756C12.5193 3.13234 12.921 3 13.3336 3C13.5496 3 13.7872 3.0535 14.007 3.19476C14.2233 3.33371 14.3629 3.51925 14.4495 3.69083C14.6066 4.00215 14.624 4.33473 14.6201 4.55938C14.6118 5.03651 14.4847 5.6328 14.3216 6.23975C13.9874 7.48318 13.3994 9.13104 12.8149 10.7577L12.7329 10.9858C12.1671 12.5598 11.6101 14.1093 11.248 15.3466C11.1505 15.68 11.0706 15.9792 11.0094 16.2414C11.7035 15.6835 12.5581 14.8454 13.466 13.9534L13.4956 13.9243C14.3772 13.0581 15.3098 12.1418 16.0967 11.5127C16.4872 11.2006 16.9082 10.904 17.3138 10.7322C17.6544 10.5878 18.4343 10.3532 19.0407 10.9596C19.4251 11.344 19.5318 11.8438 19.5594 12.2164C19.5883 12.6064 19.5429 13.0267 19.4725 13.4261C19.3315 14.2258 19.0483 15.159 18.7894 16.0009L18.7478 16.136C18.5165 16.8874 18.3102 17.5577 18.1926 18.0965C18.4529 17.8352 18.7734 17.4216 19.1475 16.811C19.436 16.34 20.0517 16.1921 20.5226 16.4806C20.9935 16.7691 21.1414 17.3848 20.8529 17.8557C20.3099 18.7422 19.748 19.4622 19.1519 19.9092C18.5283 20.377 17.7121 20.6407 16.8863 20.2278C16.2779 19.9235 16.1398 19.3173 16.1091 18.9819C16.0759 18.6192 16.1284 18.2233 16.1979 17.8667C16.3288 17.1944 16.5829 16.3698 16.823 15.5907L16.8777 15.4129C17.1447 14.5451 17.3873 13.734 17.5028 13.0789C17.5117 13.0284 17.5196 12.9802 17.5266 12.9341C17.4697 12.977 17.4094 13.0239 17.3455 13.0749C16.6477 13.6328 15.785 14.4788 14.8677 15.38L14.8381 15.4091C13.9566 16.2752 13.024 17.1915 12.2371 17.8206C11.8466 18.1328 11.4255 18.4293 11.02 18.6012C10.6794 18.7455 9.89947 18.9801 9.29311 18.3738C8.9843 18.065 8.9052 17.6753 8.87972 17.4382C8.8515 17.1755 8.86901 16.8971 8.90269 16.6351C8.9706 16.1069 9.12934 15.4656 9.32855 14.7849C9.70829 13.4872 10.2842 11.8852 10.8411 10.3362L10.9327 10.0814C11.5263 8.42931 12.082 6.8674 12.3901 5.72074C12.4172 5.61968 12.4418 5.52435 12.4638 5.43468C12.3924 5.48361 12.3178 5.53695 12.2401 5.59489C11.6173 6.05907 10.8627 6.76559 10.0357 7.69802Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$75ca23f8c939af58(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V5ZM9.72318 18L16.5803 6H14.2768L7.41968 18H9.72318Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dcca98851a44d598(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H5V7H3V3ZM9.78839 21H7.66003L14.2115 3H16.3398L9.78839 21ZM21 3H19V7H21V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$86b4c314bf02cb74(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3L23 8H20V20H18V8H15L19 3ZM14 18V20H3V18H14ZM14 11V13H3V11H14ZM12 4V6H3V4H12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e37f06b56a6834ca(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4V16H23L19 21L15 16H18V4H20ZM12 18V20H3V18H12ZM14 11V13H3V11H14ZM14 4V6H3V4H14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9ad6652d4518f63b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9V13H20V9H22V14C22 14.5523 21.5523 15 21 15H3C2.44772 15 2 14.5523 2 14V9H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1f4485d9275d86c9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM11 5H5V19H11V15H13V19H19V5H13V9H11V5ZM15 9L18 12L15 15V13H9V15L6 12L9 9V11H15V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$deab3ad83c0d2581(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM19 5H5V10.999L9 11V13H5V19H19V13H15V11L19 10.999V5ZM12 6L15 9H13V15H15L12 18L9 15H11V9H9L12 6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$86d71a42fda89345(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9H11V6H5V4H19V6H13V9ZM13 15V20H11V15H13ZM3 11H21V13H3V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ada47a243905c509(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.1538 14C17.3846 14.5161 17.5 15.0893 17.5 15.7196C17.5 17.0625 16.9762 18.1116 15.9286 18.867C14.8809 19.6223 13.4335 20 11.5862 20C9.94674 20 8.32335 19.6185 6.71592 18.8555V16.6009C8.23538 17.4783 9.7908 17.917 11.3822 17.917C13.9333 17.917 15.2128 17.1846 15.2208 15.7196C15.2208 15.0939 15.0049 14.5598 14.5731 14.1173C14.5339 14.0772 14.4939 14.0381 14.4531 14H3V12H21V14H17.1538ZM13.076 11H7.62908C7.4566 10.8433 7.29616 10.6692 7.14776 10.4778C6.71592 9.92084 6.5 9.24559 6.5 8.45207C6.5 7.21602 6.96583 6.165 7.89749 5.299C8.82916 4.43299 10.2706 4 12.2219 4C13.6934 4 15.1009 4.32808 16.4444 4.98426V7.13591C15.2448 6.44921 13.9293 6.10587 12.4978 6.10587C10.0187 6.10587 8.77917 6.88793 8.77917 8.45207C8.77917 8.87172 8.99709 9.23796 9.43293 9.55079C9.86878 9.86362 10.4066 10.1135 11.0463 10.3004C11.6665 10.4816 12.3431 10.7148 13.076 11H13.076Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6f121c9a44069724(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6V19H9V6H3V4H17V6H11ZM19.5507 16.5803C19.7042 16.4345 19.8 16.2284 19.8 16C19.8 15.5582 19.4418 15.2 19 15.2C18.5582 15.2 18.2 15.5582 18.2 16C18.2 16.0762 18.2107 16.15 18.2306 16.2198L17.0765 16.5496C17.0267 16.375 17 16.1906 17 16C17 14.8954 17.8954 14 19 14C20.1046 14 21 14.8954 21 16C21 16.5727 20.7593 17.0892 20.3735 17.4538L18.7441 19H21V20H17V19L19.5507 16.5803V16.5803Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f75cdf81221b34c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.59567 4L10.5 9.92831L15.4043 4H18L11.7978 11.4971L18 18.9943V19H15.4091L10.5 13.0659L5.59092 19H3V18.9943L9.20216 11.4971L3 4H5.59567ZM21.8 16C21.8 15.5582 21.4418 15.2 21 15.2C20.5582 15.2 20.2 15.5582 20.2 16C20.2 16.0762 20.2107 16.15 20.2306 16.2198L19.0765 16.5496C19.0267 16.375 19 16.1906 19 16C19 14.8954 19.8954 14 21 14C22.1046 14 23 14.8954 23 16C23 16.5727 22.7593 17.0892 22.3735 17.4538L20.7441 19H23V20H19V19L21.5507 16.5803C21.7042 16.4345 21.8 16.2284 21.8 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a415e2688fddf549(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7V20H9V7H3V5H15V7H11ZM19.5507 6.5803C19.7042 6.43453 19.8 6.22845 19.8 6C19.8 5.55817 19.4418 5.2 19 5.2C18.5582 5.2 18.2 5.55817 18.2 6C18.2 6.07624 18.2107 6.14999 18.2306 6.21983L17.0765 6.54958C17.0267 6.37497 17 6.1906 17 6C17 4.89543 17.8954 4 19 4C20.1046 4 21 4.89543 21 6C21 6.57273 20.7593 7.08923 20.3735 7.45384L18.7441 9H21V10H17V9L19.5507 6.5803V6.5803Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a63f3075d8f3ff63(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.59567 5L10.5 10.9283L15.4043 5H18L11.7978 12.4971L18 19.9943V20H15.4091L10.5 14.0659L5.59092 20H3V19.9943L9.20216 12.4971L3 5H5.59567ZM21.5507 6.5803C21.7042 6.43453 21.8 6.22845 21.8 6C21.8 5.55817 21.4418 5.2 21 5.2C20.5582 5.2 20.2 5.55817 20.2 6C20.2 6.07624 20.2107 6.14999 20.2306 6.21983L19.0765 6.54958C19.0267 6.37497 19 6.1906 19 6C19 4.89543 19.8954 4 21 4C22.1046 4 23 4.89543 23 6C23 6.57273 22.7593 7.08923 22.3735 7.45384L20.7441 9H23V10H19V9L21.5507 6.5803V6.5803Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7ae15cc282ab5db9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10V14H19V10H13ZM11 10H5V14H11V10ZM13 19H19V16H13V19ZM11 19V16H5V19H11ZM13 5V8H19V5H13ZM11 5H5V8H11V5ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$83f176c7ff34ba2b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5V15H9V11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3H17V5H15V15H13V5H11ZM9 5C7.89543 5 7 5.89543 7 7C7 8.10457 7.89543 9 9 9V5ZM17 17V14.5L21 18L17 21.5V19H5V17H17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$58f3915eae37336d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5V15H9V11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3H17V5H15V15H13V5H11ZM9 5C7.89543 5 7 5.89543 7 7C7 8.10457 7.89543 9 9 9V5ZM7 17H19V19H7V21.5L3 18L7 14.5V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8d884c8a4fd68af0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17H17V14.5L20.5 18L17 21.5V19H7V21.5L3.5 18L7 14.5V17ZM13 6V15H11V6H5V4H19V6H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e90adc370abdf5f3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 18H16.5C17.8807 18 19 16.8807 19 15.5C19 14.1193 17.8807 13 16.5 13H3V11H16.5C18.9853 11 21 13.0147 21 15.5C21 17.9853 18.9853 20 16.5 20H15V22L11 19L15 16V18ZM3 4H21V6H3V4ZM9 18V20H3V18H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$193a16ac6b675ad3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6V21H11V6H5V4H19V6H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f2a6115274b1860a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 10L22.9 21H20.745L19.544 18H15.454L14.255 21H12.101L16.5 10H18.5ZM10 2V4H16V6L14.0322 6.0006C13.2425 8.36616 11.9988 10.5057 10.4115 12.301C11.1344 12.9457 11.917 13.5176 12.7475 14.0079L11.9969 15.8855C10.9237 15.2781 9.91944 14.5524 8.99961 13.7249C7.21403 15.332 5.10914 16.5553 2.79891 17.2734L2.26257 15.3442C4.2385 14.7203 6.04543 13.6737 7.59042 12.3021C6.46277 11.0281 5.50873 9.57985 4.76742 8.00028L7.00684 8.00037C7.57018 9.03885 8.23979 10.0033 8.99967 10.877C10.2283 9.46508 11.2205 7.81616 11.9095 6.00101L2 6V4H8V2H10ZM17.5 12.8852L16.253 16H18.745L17.5 12.8852Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$99da1613a57847f6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15V17C5 18.0544 5.81588 18.9182 6.85074 18.9945L7 19H10V21H7C4.79086 21 3 19.2091 3 17V15H5ZM18 10L22.4 21H20.245L19.044 18H14.954L13.755 21H11.601L16 10H18ZM17 12.8852L15.753 16H18.245L17 12.8852ZM8 2V4H12V11H8V14H6V11H2V4H6V2H8ZM17 3C19.2091 3 21 4.79086 21 7V9H19V7C19 5.89543 18.1046 5 17 5H14V3H17ZM6 6H4V9H6V6ZM10 6H8V9H10V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$be3eaaa2606da359(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V3H18V12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12V3H8ZM4 20H20V22H4V20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$344399b7deb63085(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21V19H6.662L7.896 12H5V10H8.249L9.13 5H4V3H20V5H11.161L10.279 10H18V19H21V21H3ZM16 12H9.927L8.692 19H16V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5bab7b9f7cff15c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 13.0029C13.6617 13.0029 15.0049 14.3461 15.0049 16.0029C15.0049 16.8521 14.6521 17.6188 14.0851 18.1646L12.175 20.0025L15.0049 20.0029V22.0029H9.00488L9.00398 20.2785L12.6983 16.7235C12.8874 16.5413 13.0049 16.2858 13.0049 16.0029C13.0049 15.4506 12.5572 15.0029 12.0049 15.0029C11.4526 15.0029 11.0049 15.4506 11.0049 16.0029H9.00488C9.00488 14.3461 10.348 13.0029 12.0049 13.0029ZM18.0049 13.0029V17.0029H20.0049V13.0029H22.0049V22.0029H20.0049V19.0029H16.0049V13.0029H18.0049ZM4.00488 12.0029C4.00488 14.5295 5.17612 16.7825 7.00527 18.2486L7.0049 20.6651C4.01588 18.9361 2.00488 15.7043 2.00488 12.0029H4.00488ZM12.0049 2.00293C17.1902 2.00293 21.4537 5.94955 21.9555 11.0028L19.943 11.003C19.4509 7.05664 16.0845 4.00293 12.0049 4.00293C9.54102 4.00293 7.33731 5.11676 5.8698 6.86836L8.00488 9.00293H2.00488V3.00293L4.45144 5.44941C6.28491 3.33802 8.98898 2.00293 12.0049 2.00293Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$86b289490f645392(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 13.0029C13.6617 13.0029 15.0049 14.3461 15.0049 16.0029C15.0049 16.8521 14.6521 17.6188 14.0851 18.1646L12.175 20.0025L15.0049 20.0029V22.0029H9.00488L9.00398 20.2785L12.6983 16.7235C12.8874 16.5413 13.0049 16.2858 13.0049 16.0029C13.0049 15.4506 12.5572 15.0029 12.0049 15.0029C11.4526 15.0029 11.0049 15.4506 11.0049 16.0029H9.00488C9.00488 14.3461 10.348 13.0029 12.0049 13.0029ZM18.0049 13.0029V17.0029H20.0049V13.0029H22.0049V22.0029H20.0049V19.0029H16.0049V13.0029H18.0049ZM4.00488 12.0029C4.00488 14.5295 5.17612 16.7825 7.00527 18.2486L7.0049 20.6651C4.01588 18.9361 2.00488 15.7043 2.00488 12.0029H4.00488ZM12.0049 2.00293C17.1902 2.00293 21.4537 5.94955 21.9555 11.0028L19.943 11.003C19.4509 7.05664 16.0845 4.00293 12.0049 4.00293C9.2551 4.00293 6.82935 5.39027 5.3894 7.50317L8.00488 7.50293V9.50293H2.00488V3.50293H4.00488L4.00477 6.00211C5.82922 3.57368 8.73362 2.00293 12.0049 2.00293Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$135bf17b93387948(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.0049 20.0027V22.0027H2.00488V20.0027H14.0049ZM14.5907 0.688965L22.3688 8.46714L20.9546 9.88135L19.894 9.5278L17.4191 12.0027L23.076 17.6595L21.6617 19.0737L16.0049 13.4169L13.6007 15.821L13.8836 16.9524L12.4693 18.3666L4.69117 10.5885L6.10539 9.17425L7.23676 9.45709L13.53 3.16384L13.1765 2.10318L14.5907 0.688965Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5caa8e740e81139f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.0049 20.0027V22.0027H2.00488V20.0027H14.0049ZM14.5907 0.688965L22.3688 8.46714L20.9546 9.88135L19.894 9.5278L17.4191 12.0027L23.076 17.6595L21.6617 19.0737L16.0049 13.4169L13.6007 15.821L13.8836 16.9524L12.4693 18.3666L4.69117 10.5885L6.10539 9.17425L7.23676 9.45709L13.53 3.16384L13.1765 2.10318L14.5907 0.688965ZM15.2978 4.2245L8.22671 11.2956L11.7622 14.8311L18.8333 7.76003L15.2978 4.2245Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1e07167fae810c02(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.0049 11V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V11H22.0049ZM22.0049 7H2.00488V4C2.00488 3.44772 2.4526 3 3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$33a301b829dfe4c7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V4C2.00488 3.44772 2.4526 3 3.00488 3ZM20.0049 12H4.00488V19H20.0049V12ZM20.0049 8V5H4.00488V8H20.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fba3603675e99e7f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.0049 10V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V10H22.0049ZM22.0049 8H2.00488V4C2.00488 3.44772 2.4526 3 3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V8ZM15.0049 16V18H19.0049V16H15.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2caf23ac369eeb2a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V4C2.00488 3.44772 2.4526 3 3.00488 3ZM20.0049 11H4.00488V19H20.0049V11ZM20.0049 9V5H4.00488V9H20.0049ZM14.0049 15H18.0049V17H14.0049V15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$aa3c50fdc9eb8c3b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM11.0049 16.0029V18.0029H13.0049V16.0029H14.0049C15.3856 16.0029 16.5049 14.8836 16.5049 13.5029C16.5049 12.9401 16.3189 12.4208 16.0051 12.0029C16.3189 11.5851 16.5049 11.0657 16.5049 10.5029C16.5049 9.12222 15.3856 8.00293 14.0049 8.00293H13.0049V6.00293H11.0049V8.00293H8.00488V16.0029H11.0049ZM10.0049 13.0029H14.0049C14.281 13.0029 14.5049 13.2268 14.5049 13.5029C14.5049 13.7791 14.281 14.0029 14.0049 14.0029H10.0049V13.0029ZM10.0049 10.0029H14.0049C14.281 10.0029 14.5049 10.2268 14.5049 10.5029C14.5049 10.7791 14.281 11.0029 14.0049 11.0029H10.0049V10.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e721ef2bf87096f7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM12.0049 20.0029C16.4232 20.0029 20.0049 16.4212 20.0049 12.0029C20.0049 7.58465 16.4232 4.00293 12.0049 4.00293C7.5866 4.00293 4.00488 7.58465 4.00488 12.0029C4.00488 16.4212 7.5866 20.0029 12.0049 20.0029ZM11.0049 16.0029H8.00488V8.00293H11.0049V6.00293H13.0049V8.00293H14.0049C15.3856 8.00293 16.5049 9.12222 16.5049 10.5029C16.5049 11.0657 16.3189 11.5851 16.0051 12.0029C16.3189 12.4208 16.5049 12.9401 16.5049 13.5029C16.5049 14.8836 15.3856 16.0029 14.0049 16.0029H13.0049V18.0029H11.0049V16.0029ZM10.0049 13.0029V14.0029H14.0049C14.281 14.0029 14.5049 13.7791 14.5049 13.5029C14.5049 13.2268 14.281 13.0029 14.0049 13.0029H10.0049ZM10.0049 10.0029V11.0029H14.0049C14.281 11.0029 14.5049 10.7791 14.5049 10.5029C14.5049 10.2268 14.281 10.0029 14.0049 10.0029H10.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f53ecdf4321c6b75(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 4.00293H21.0049C21.5572 4.00293 22.0049 4.45064 22.0049 5.00293V19.0029C22.0049 19.5552 21.5572 20.0029 21.0049 20.0029H3.00488C2.4526 20.0029 2.00488 19.5552 2.00488 19.0029V5.00293C2.00488 4.45064 2.4526 4.00293 3.00488 4.00293ZM6.50037 6H4.00037V8.5C5.38108 8.5 6.50037 7.38071 6.50037 6ZM17.5004 6C17.5004 7.38071 18.6197 8.5 20.0004 8.5V6H17.5004ZM4.00037 15.5V18H6.50037C6.50037 16.6193 5.38108 15.5 4.00037 15.5ZM17.5004 18H20.0004V15.5C18.6197 15.5 17.5004 16.6193 17.5004 18ZM12.0004 16C14.2095 16 16.0004 14.2091 16.0004 12C16.0004 9.79086 14.2095 8 12.0004 8C9.79123 8 8.00037 9.79086 8.00037 12C8.00037 14.2091 9.79123 16 12.0004 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$26008e8ae4660c84(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0004 16C14.2095 16 16.0004 14.2091 16.0004 12 16.0004 9.79086 14.2095 8 12.0004 8 9.79123 8 8.00037 9.79086 8.00037 12 8.00037 14.2091 9.79123 16 12.0004 16ZM21.0049 4.00293H3.00488C2.4526 4.00293 2.00488 4.45064 2.00488 5.00293V19.0029C2.00488 19.5552 2.4526 20.0029 3.00488 20.0029H21.0049C21.5572 20.0029 22.0049 19.5552 22.0049 19.0029V5.00293C22.0049 4.45064 21.5572 4.00293 21.0049 4.00293ZM4.00488 15.6463V8.35371C5.13065 8.017 6.01836 7.12892 6.35455 6.00293H17.6462C17.9833 7.13193 18.8748 8.02175 20.0049 8.3564V15.6436C18.8729 15.9788 17.9802 16.8711 17.6444 18.0029H6.3563C6.02144 16.8742 5.13261 15.9836 4.00488 15.6463Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$90174deb02ad98cf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23.0049 12.0029V14.0029C23.0049 17.3166 18.08 20.0029 12.0049 20.0029C6.03824 20.0029 1.18114 17.4117 1.00957 14.1798L1.00488 14.0029V12.0029C1.00488 15.3166 5.92975 18.0029 12.0049 18.0029C18.08 18.0029 23.0049 15.3166 23.0049 12.0029ZM12.0049 4.00293C18.08 4.00293 23.0049 6.68922 23.0049 10.0029C23.0049 13.3166 18.08 16.0029 12.0049 16.0029C5.92975 16.0029 1.00488 13.3166 1.00488 10.0029C1.00488 6.68922 5.92975 4.00293 12.0049 4.00293Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9de61221137c9585(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 4.00293C18.08 4.00293 23.0049 6.68922 23.0049 10.0029V14.0029C23.0049 17.3166 18.08 20.0029 12.0049 20.0029C6.03824 20.0029 1.18114 17.4117 1.00957 14.1798L1.00488 14.0029V10.0029C1.00488 6.68922 5.92975 4.00293 12.0049 4.00293ZM12.0049 16.0029C8.28443 16.0029 4.99537 14.9955 3.00466 13.4534L3.00488 14.0029C3.00488 15.8851 6.88751 18.0029 12.0049 18.0029C17.0156 18.0029 20.8426 15.9725 20.9999 14.1209L21.0049 14.0029L21.0061 13.4526C19.0155 14.9951 15.726 16.0029 12.0049 16.0029ZM12.0049 6.00293C6.88751 6.00293 3.00488 8.12073 3.00488 10.0029C3.00488 11.8851 6.88751 14.0029 12.0049 14.0029C17.1223 14.0029 21.0049 11.8851 21.0049 10.0029C21.0049 8.12073 17.1223 6.00293 12.0049 6.00293Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b068247c81ac43cf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.0049 2.00293C18.4232 2.00293 22.0049 5.58465 22.0049 10.0029C22.0049 13.2475 20.0733 16.041 17.2973 17.2962C16.0422 20.0719 13.249 22.0029 10.0049 22.0029C5.5866 22.0029 2.00488 18.4212 2.00488 14.0029C2.00488 10.7588 3.9359 7.96566 6.71122 6.71024C7.96681 3.9345 10.7603 2.00293 14.0049 2.00293ZM11.0049 9.00293H9.00488V10.0029C7.62417 10.0029 6.50488 11.1222 6.50488 12.5029C6.50488 13.8284 7.53642 14.913 8.84051 14.9976L9.00488 15.0029H11.0049L11.0948 15.011C11.328 15.0533 11.5049 15.2575 11.5049 15.5029C11.5049 15.7484 11.328 15.9525 11.0948 15.9949L11.0049 16.0029H7.00488V18.0029H9.00488V19.0029H11.0049V18.0029C12.3856 18.0029 13.5049 16.8836 13.5049 15.5029C13.5049 14.1774 12.4733 13.0929 11.1693 13.0082L11.0049 13.0029H9.00488L8.91501 12.9949C8.68176 12.9525 8.50488 12.7484 8.50488 12.5029C8.50488 12.2575 8.68176 12.0533 8.91501 12.011L9.00488 12.0029H13.0049V10.0029H11.0049V9.00293ZM14.0049 4.00293C12.2214 4.00293 10.6196 4.78109 9.52064 6.01642C9.68133 6.00776 9.84254 6.00293 10.0049 6.00293C14.4232 6.00293 18.0049 9.58465 18.0049 14.0029C18.0049 14.1656 18 14.3272 17.9905 14.4874C19.2265 13.3887 20.0049 11.7867 20.0049 10.0029C20.0049 6.68922 17.3186 4.00293 14.0049 4.00293Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8818a2785aaee6ea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.0049 2.00293C18.4232 2.00293 22.0049 5.58465 22.0049 10.0029C22.0049 13.2475 20.0733 16.041 17.2973 17.2962C16.0422 20.0719 13.249 22.0029 10.0049 22.0029C5.5866 22.0029 2.00488 18.4212 2.00488 14.0029C2.00488 10.7588 3.9359 7.96566 6.71122 6.71024C7.96681 3.9345 10.7603 2.00293 14.0049 2.00293ZM10.0049 8.00293C6.69117 8.00293 4.00488 10.6892 4.00488 14.0029C4.00488 17.3166 6.69117 20.0029 10.0049 20.0029C13.3186 20.0029 16.0049 17.3166 16.0049 14.0029C16.0049 10.6892 13.3186 8.00293 10.0049 8.00293ZM11.0049 9.00293V10.0029H13.0049V12.0029H9.00488C8.72874 12.0029 8.50488 12.2268 8.50488 12.5029C8.50488 12.7484 8.68176 12.9525 8.91501 12.9949L9.00488 13.0029H11.0049C12.3856 13.0029 13.5049 14.1222 13.5049 15.5029C13.5049 16.8836 12.3856 18.0029 11.0049 18.0029V19.0029H9.00488V18.0029H7.00488V16.0029H11.0049C11.281 16.0029 11.5049 15.7791 11.5049 15.5029C11.5049 15.2575 11.328 15.0533 11.0948 15.011L11.0049 15.0029H9.00488C7.62417 15.0029 6.50488 13.8836 6.50488 12.5029C6.50488 11.1222 7.62417 10.0029 9.00488 10.0029V9.00293H11.0049ZM14.0049 4.00293C12.2214 4.00293 10.6196 4.78109 9.52064 6.01642C9.68133 6.00776 9.84254 6.00293 10.0049 6.00293C14.4232 6.00293 18.0049 9.58465 18.0049 14.0029C18.0049 14.1656 18 14.3272 17.9905 14.4874C19.2265 13.3887 20.0049 11.7867 20.0049 10.0029C20.0049 6.68922 17.3186 4.00293 14.0049 4.00293Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3ce70373e30c17f1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM12.0049 7.76029L7.76224 12.0029L12.0049 16.2456L16.2475 12.0029L12.0049 7.76029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9a07eb6375e282f3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM12.0049 20.0029C16.4232 20.0029 20.0049 16.4212 20.0049 12.0029C20.0049 7.58465 16.4232 4.00293 12.0049 4.00293C7.5866 4.00293 4.00488 7.58465 4.00488 12.0029C4.00488 16.4212 7.5866 20.0029 12.0049 20.0029ZM12.0049 7.05318L16.9546 12.0029L12.0049 16.9527L7.05514 12.0029L12.0049 7.05318ZM12.0049 9.88161L9.88356 12.0029L12.0049 14.1243L14.1262 12.0029L12.0049 9.88161Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2586377134d3b43a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM9.50488 9.00293L7.00488 11.5029L12.0041 16.5029L17.0049 11.5029L14.5049 9.00293H9.50488Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9e82d0a24891a6d8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM12.0049 20.0029C16.4232 20.0029 20.0049 16.4212 20.0049 12.0029C20.0049 7.58465 16.4232 4.00293 12.0049 4.00293C7.5866 4.00293 4.00488 7.58465 4.00488 12.0029C4.00488 16.4212 7.5866 20.0029 12.0049 20.0029ZM9.00488 8.00293H15.0049L17.5049 11.5029L12.0041 17.0029L6.50488 11.5029L9.00488 8.00293ZM10.0349 10.0029L9.11488 11.2929L12.0041 14.1829L14.8949 11.2929L13.9749 10.0029H10.0349Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2c8462346dbc877a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.0049 2.99951V20.9995H3.00488C2.4526 20.9995 2.00488 20.5518 2.00488 19.9995V14.4995C3.38559 14.4995 4.50488 13.3802 4.50488 11.9995C4.50488 10.6188 3.38559 9.49951 2.00488 9.49951V3.99951C2.00488 3.44723 2.4526 2.99951 3.00488 2.99951H14.0049ZM16.0049 2.99951H21.0049C21.5572 2.99951 22.0049 3.44723 22.0049 3.99951V9.49951C20.6242 9.49951 19.5049 10.6188 19.5049 11.9995C19.5049 13.3802 20.6242 14.4995 22.0049 14.4995V19.9995C22.0049 20.5518 21.5572 20.9995 21.0049 20.9995H16.0049V2.99951Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c68397e5fe1d550b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.00488 9.5V4C2.00488 3.44772 2.4526 3 3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V9.5C20.6242 9.5 19.5049 10.6193 19.5049 12C19.5049 13.3807 20.6242 14.5 22.0049 14.5V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V14.5C3.38559 14.5 4.50488 13.3807 4.50488 12C4.50488 10.6193 3.38559 9.5 2.00488 9.5ZM14.0049 5H4.00488V7.96776C5.4866 8.70411 6.50488 10.2331 6.50488 12C6.50488 13.7669 5.4866 15.2959 4.00488 16.0322V19H14.0049V5ZM16.0049 5V19H20.0049V16.0322C18.5232 15.2959 17.5049 13.7669 17.5049 12C17.5049 10.2331 18.5232 8.70411 20.0049 7.96776V5H16.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$103390c7a4056e8a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.0049 20.9995C11.0049 20.1711 10.3333 19.4995 9.50488 19.4995C8.67646 19.4995 8.00488 20.1711 8.00488 20.9995H3.00488C2.4526 20.9995 2.00488 20.5518 2.00488 19.9995V3.99951C2.00488 3.44723 2.4526 2.99951 3.00488 2.99951H8.00488C8.00488 3.82794 8.67646 4.49951 9.50488 4.49951C10.3333 4.49951 11.0049 3.82794 11.0049 2.99951H21.0049C21.5572 2.99951 22.0049 3.44723 22.0049 3.99951V9.49951C20.6242 9.49951 19.5049 10.6188 19.5049 11.9995C19.5049 13.3802 20.6242 14.4995 22.0049 14.4995V19.9995C22.0049 20.5518 21.5572 20.9995 21.0049 20.9995H11.0049ZM9.50488 10.4995C10.3333 10.4995 11.0049 9.82794 11.0049 8.99951C11.0049 8.17108 10.3333 7.49951 9.50488 7.49951C8.67646 7.49951 8.00488 8.17108 8.00488 8.99951C8.00488 9.82794 8.67646 10.4995 9.50488 10.4995ZM9.50488 16.4995C10.3333 16.4995 11.0049 15.8279 11.0049 14.9995C11.0049 14.1711 10.3333 13.4995 9.50488 13.4995C8.67646 13.4995 8.00488 14.1711 8.00488 14.9995C8.00488 15.8279 8.67646 16.4995 9.50488 16.4995Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3414c9b0a89d5a34(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.00488 4C2.00488 3.44772 2.4526 3 3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V9.5C20.6242 9.5 19.5049 10.6193 19.5049 12C19.5049 13.3807 20.6242 14.5 22.0049 14.5V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V4ZM8.09024 19C8.29615 18.4174 8.85177 18 9.50488 18C10.158 18 10.7136 18.4174 10.9195 19H20.0049V16.0322C18.5232 15.2959 17.5049 13.7669 17.5049 12C17.5049 10.2331 18.5232 8.70411 20.0049 7.96776V5H10.9195C10.7136 5.5826 10.158 6 9.50488 6C8.85177 6 8.29615 5.5826 8.09024 5H4.00488V19H8.09024ZM9.50488 11C8.67646 11 8.00488 10.3284 8.00488 9.5C8.00488 8.67157 8.67646 8 9.50488 8C10.3333 8 11.0049 8.67157 11.0049 9.5C11.0049 10.3284 10.3333 11 9.50488 11ZM9.50488 16C8.67646 16 8.00488 15.3284 8.00488 14.5C8.00488 13.6716 8.67646 13 9.50488 13C10.3333 13 11.0049 13.6716 11.0049 14.5C11.0049 15.3284 10.3333 16 9.50488 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f6f63d587f79fdd5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.0049 20.9995H3.00488C2.4526 20.9995 2.00488 20.5518 2.00488 19.9995V3.99951C2.00488 3.44723 2.4526 2.99951 3.00488 2.99951H10.0049C10.0049 4.10408 10.9003 4.99951 12.0049 4.99951C13.1095 4.99951 14.0049 4.10408 14.0049 2.99951H21.0049C21.5572 2.99951 22.0049 3.44723 22.0049 3.99951V19.9995C22.0049 20.5518 21.5572 20.9995 21.0049 20.9995H14.0049C14.0049 19.8949 13.1095 18.9995 12.0049 18.9995C10.9003 18.9995 10.0049 19.8949 10.0049 20.9995ZM6.00488 7.99951V15.9995H8.00488V7.99951H6.00488ZM16.0049 7.99951V15.9995H18.0049V7.99951H16.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$279cc6ce162e6c65(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V4C2.00488 3.44772 2.4526 3 3.00488 3H10.0049C10.0049 4.10457 10.9003 5 12.0049 5C13.1095 5 14.0049 4.10457 14.0049 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V20C22.0049 20.5523 21.5572 21 21.0049 21H14.0049C14.0049 19.8954 13.1095 19 12.0049 19C10.9003 19 10.0049 19.8954 10.0049 21ZM8.54001 19C9.23163 17.8044 10.5243 17 12.0049 17C13.4854 17 14.7781 17.8044 15.4698 19H20.0049V5H15.4698C14.7781 6.1956 13.4854 7 12.0049 7C10.5243 7 9.23163 6.1956 8.54001 5H4.00488V19H8.54001ZM6.00488 8H8.00488V16H6.00488V8ZM16.0049 8H18.0049V16H16.0049V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d4f40e013c2c8495(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.0049 13.9995V20.9995C21.0049 21.5518 20.5572 21.9995 20.0049 21.9995H4.00488C3.4526 21.9995 3.00488 21.5518 3.00488 20.9995V13.9995C4.10945 13.9995 5.00488 13.1041 5.00488 11.9995C5.00488 10.8949 4.10945 9.99951 3.00488 9.99951V2.99951C3.00488 2.44723 3.4526 1.99951 4.00488 1.99951H20.0049C20.5572 1.99951 21.0049 2.44723 21.0049 2.99951V9.99951C19.9003 9.99951 19.0049 10.8949 19.0049 11.9995C19.0049 13.1041 19.9003 13.9995 21.0049 13.9995ZM9.00488 5.99951V7.99951H15.0049V5.99951H9.00488ZM9.00488 15.9995V17.9995H15.0049V15.9995H9.00488Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e0d1f8eb5e1de0d4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.0049 14V21C21.0049 21.5523 20.5572 22 20.0049 22H4.00488C3.4526 22 3.00488 21.5523 3.00488 21V14C4.10945 14 5.00488 13.1046 5.00488 12C5.00488 10.8954 4.10945 10 3.00488 10V3C3.00488 2.44772 3.4526 2 4.00488 2H20.0049C20.5572 2 21.0049 2.44772 21.0049 3V10C19.9003 10 19.0049 10.8954 19.0049 12C19.0049 13.1046 19.9003 14 21.0049 14ZM19.0049 15.4649C17.8093 14.7733 17.0049 13.4806 17.0049 12C17.0049 10.5194 17.8093 9.22675 19.0049 8.53513V4H5.00488V8.53513C6.20049 9.22675 7.00488 10.5194 7.00488 12C7.00488 13.4806 6.20049 14.7733 5.00488 15.4649V20H19.0049V15.4649ZM9.00488 6H15.0049V8H9.00488V6ZM9.00488 16H15.0049V18H9.00488V16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c265db80c781cf07(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.00488 9.49951V3.99951C2.00488 3.44723 2.4526 2.99951 3.00488 2.99951H21.0049C21.5572 2.99951 22.0049 3.44723 22.0049 3.99951V9.49951C20.6242 9.49951 19.5049 10.6188 19.5049 11.9995C19.5049 13.3802 20.6242 14.4995 22.0049 14.4995V19.9995C22.0049 20.5518 21.5572 20.9995 21.0049 20.9995H3.00488C2.4526 20.9995 2.00488 20.5518 2.00488 19.9995V14.4995C3.38559 14.4995 4.50488 13.3802 4.50488 11.9995C4.50488 10.6188 3.38559 9.49951 2.00488 9.49951ZM9.00488 8.99951V10.9995H15.0049V8.99951H9.00488ZM9.00488 12.9995V14.9995H15.0049V12.9995H9.00488Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1e160134311bee10(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.00488 9.5V4C2.00488 3.44772 2.4526 3 3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V9.5C20.6242 9.5 19.5049 10.6193 19.5049 12C19.5049 13.3807 20.6242 14.5 22.0049 14.5V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V14.5C3.38559 14.5 4.50488 13.3807 4.50488 12C4.50488 10.6193 3.38559 9.5 2.00488 9.5ZM4.00488 7.96776C5.4866 8.70411 6.50488 10.2331 6.50488 12C6.50488 13.7669 5.4866 15.2959 4.00488 16.0322V19H20.0049V16.0322C18.5232 15.2959 17.5049 13.7669 17.5049 12C17.5049 10.2331 18.5232 8.70411 20.0049 7.96776V5H4.00488V7.96776ZM9.00488 9H15.0049V11H9.00488V9ZM9.00488 13H15.0049V15H9.00488V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c84d62ddd089c7a0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0047 16.0029H19.0047V4.00293H9.00468V6.00293H17.0047V16.0029ZM17.0047 18.0029V21.0021C17.0047 21.5548 16.5547 22.0029 15.9978 22.0029H4.01154C3.45548 22.0029 3.00488 21.5583 3.00488 21.0021L3.00748 7.0038C3.00759 6.45104 3.45752 6.00293 4.0143 6.00293H7.00468V3.00293C7.00468 2.45064 7.4524 2.00293 8.00468 2.00293H20.0047C20.557 2.00293 21.0047 2.45064 21.0047 3.00293V17.0029C21.0047 17.5552 20.557 18.0029 20.0047 18.0029H17.0047ZM7.00468 16.0029V18.0029H9.00468V19.0029H11.0047V18.0029H11.5047C12.8854 18.0029 14.0047 16.8836 14.0047 15.5029C14.0047 14.1222 12.8854 13.0029 11.5047 13.0029H8.50468C8.22854 13.0029 8.00468 12.7791 8.00468 12.5029C8.00468 12.2268 8.22854 12.0029 8.50468 12.0029H13.0047V10.0029H11.0047V9.00293H9.00468V10.0029H8.50468C7.12397 10.0029 6.00468 11.1222 6.00468 12.5029C6.00468 13.8836 7.12397 15.0029 8.50468 15.0029H11.5047C11.7808 15.0029 12.0047 15.2268 12.0047 15.5029C12.0047 15.7791 11.7808 16.0029 11.5047 16.0029H7.00468Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1dc532e7b856eb6a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0047 16.0029H19.0047V4.00293H9.00468V6.00293H17.0047V16.0029ZM17.0047 18.0029V21.0021C17.0047 21.5548 16.5547 22.0029 15.9978 22.0029H4.01154C3.45548 22.0029 3.00488 21.5583 3.00488 21.0021L3.00748 7.0038C3.00759 6.45104 3.45752 6.00293 4.0143 6.00293H7.00468V3.00293C7.00468 2.45064 7.4524 2.00293 8.00468 2.00293H20.0047C20.557 2.00293 21.0047 2.45064 21.0047 3.00293V17.0029C21.0047 17.5552 20.557 18.0029 20.0047 18.0029H17.0047ZM5.0073 8.00293L5.00507 20.0029H15.0047V8.00293H5.0073ZM7.00468 16.0029H11.5047C11.7808 16.0029 12.0047 15.7791 12.0047 15.5029C12.0047 15.2268 11.7808 15.0029 11.5047 15.0029H8.50468C7.12397 15.0029 6.00468 13.8836 6.00468 12.5029C6.00468 11.1222 7.12397 10.0029 8.50468 10.0029H9.00468V9.00293H11.0047V10.0029H13.0047V12.0029H8.50468C8.22854 12.0029 8.00468 12.2268 8.00468 12.5029C8.00468 12.7791 8.22854 13.0029 8.50468 13.0029H11.5047C12.8854 13.0029 14.0047 14.1222 14.0047 15.5029C14.0047 16.8836 12.8854 18.0029 11.5047 18.0029H11.0047V19.0029H9.00468V18.0029H7.00468V16.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$352703211013463b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 3.00293H21.0049C21.5572 3.00293 22.0049 3.45064 22.0049 4.00293V20.0029C22.0049 20.5552 21.5572 21.0029 21.0049 21.0029H3.00488C2.4526 21.0029 2.00488 20.5552 2.00488 20.0029V4.00293C2.00488 3.45064 2.4526 3.00293 3.00488 3.00293ZM12.0049 9.00293H8.00488V11.0029H17.0049L12.0049 6.00293V9.00293ZM7.00488 13.0029L12.0049 18.0029V15.0029H16.0049V13.0029H7.00488Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1503885fc3d3f952(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.00488 5.00293V19.0029H20.0049V5.00293H4.00488ZM3.00488 3.00293H21.0049C21.5572 3.00293 22.0049 3.45064 22.0049 4.00293V20.0029C22.0049 20.5552 21.5572 21.0029 21.0049 21.0029H3.00488C2.4526 21.0029 2.00488 20.5552 2.00488 20.0029V4.00293C2.00488 3.45064 2.4526 3.00293 3.00488 3.00293ZM12.0049 9.00293V6.00293L17.0049 11.0029H8.00488V9.00293H12.0049ZM7.00488 13.0029H16.0049V15.0029H12.0049V18.0029L7.00488 13.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$688ee6c9df077a4c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.37833 4.51353C7.14264 2.95131 9.46301 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 14.1279 21.3421 16.098 20.212 17.7179L17.5049 12.0029H20.0049C20.0049 7.58465 16.4232 4.00293 12.0049 4.00293C9.76058 4.00293 7.73213 4.92709 6.27932 6.41563L5.37833 4.51353ZM18.6314 19.4923C16.8671 21.0545 14.5468 22.0029 12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 9.87798 2.66767 7.90784 3.79778 6.28794L6.50488 12.0029H4.00488C4.00488 16.4212 7.5866 20.0029 12.0049 20.0029C14.2492 20.0029 16.2776 19.0788 17.7304 17.5902L18.6314 19.4923ZM13.0049 13.5385H16.0049V15.5385H13.0049V17.5385H11.0049V15.5385H8.00488V13.5385H11.0049V12.5385H8.00488V10.5385H10.5907L8.46935 8.41714L9.88356 7.00293L12.0049 9.12425L14.1262 7.00293L15.5404 8.41714L13.4191 10.5385H16.0049V12.5385H13.0049V13.5385Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7b26872543d4c1ac(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.3788 15.1057C20.9258 11.442 19.5373 7.11425 16.0042 5.07444C13.4511 3.6004 10.4232 3.69359 8.03452 5.05554L7.04216 3.31873C10.028 1.61633 13.8128 1.49984 17.0042 3.34239C21.4949 5.93507 23.2139 11.4848 21.1217 16.1119L22.4635 16.8866L18.2984 19.1007L18.1334 14.3866L19.3788 15.1057ZM4.62961 8.89962C3.08263 12.5633 4.47116 16.891 8.00421 18.9308C10.5573 20.4049 13.5851 20.3117 15.9737 18.9499L16.9661 20.6866C13.9803 22.389 10.1956 22.5054 7.00421 20.6629C2.51357 18.0702 0.794565 12.5205 2.88672 7.89336L1.54492 7.11867L5.70999 4.90457L5.87505 9.61867L4.62961 8.89962ZM13.0042 13.5382H16.0042V15.5382H13.0042V17.5382H11.0042V15.5382H8.00421V13.5382H11.0042V12.5382H8.00421V10.5382H10.59L8.46868 8.41686L9.88289 7.00265L12.0042 9.12397L14.1255 7.00265L15.5397 8.41686L13.4184 10.5382H16.0042V12.5382H13.0042V13.5382Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$66ff1650134003f0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.37833 4.51353C7.14264 2.95131 9.46301 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 14.1279 21.3421 16.098 20.212 17.7179L17.5049 12.0029H20.0049C20.0049 7.58465 16.4232 4.00293 12.0049 4.00293C9.76058 4.00293 7.73213 4.92709 6.27932 6.41563L5.37833 4.51353ZM18.6314 19.4923C16.8671 21.0545 14.5468 22.0029 12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 9.87798 2.66767 7.90784 3.79778 6.28794L6.50488 12.0029H4.00488C4.00488 16.4212 7.5866 20.0029 12.0049 20.0029C14.2492 20.0029 16.2776 19.0788 17.7304 17.5902L18.6314 19.4923ZM8.50488 14.0029H14.0049C14.281 14.0029 14.5049 13.7791 14.5049 13.5029C14.5049 13.2268 14.281 13.0029 14.0049 13.0029H10.0049C8.62417 13.0029 7.50488 11.8836 7.50488 10.5029C7.50488 9.12222 8.62417 8.00293 10.0049 8.00293H11.0049V7.00293H13.0049V8.00293H15.5049V10.0029H10.0049C9.72874 10.0029 9.50488 10.2268 9.50488 10.5029C9.50488 10.7791 9.72874 11.0029 10.0049 11.0029H14.0049C15.3856 11.0029 16.5049 12.1222 16.5049 13.5029C16.5049 14.8836 15.3856 16.0029 14.0049 16.0029H13.0049V17.0029H11.0049V16.0029H8.50488V14.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1b5f975290ac713a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.3788 15.1057C20.9258 11.442 19.5373 7.11425 16.0042 5.07444C13.4511 3.6004 10.4232 3.69359 8.03452 5.05554L7.04216 3.31873C10.028 1.61633 13.8128 1.49984 17.0042 3.34239C21.4949 5.93507 23.2139 11.4848 21.1217 16.1119L22.4635 16.8866L18.2984 19.1007L18.1334 14.3866L19.3788 15.1057ZM4.62961 8.89962C3.08263 12.5633 4.47116 16.891 8.00421 18.9308C10.5573 20.4049 13.5851 20.3117 15.9737 18.9499L16.9661 20.6866C13.9803 22.389 10.1956 22.5054 7.00421 20.6629C2.51357 18.0702 0.794565 12.5205 2.88672 7.89336L1.54492 7.11867L5.70999 4.90457L5.87505 9.61867L4.62961 8.89962ZM8.50421 14.0026H14.0042C14.2804 14.0026 14.5042 13.7788 14.5042 13.5026C14.5042 13.2265 14.2804 13.0026 14.0042 13.0026H10.0042C8.6235 13.0026 7.50421 11.8834 7.50421 10.5026C7.50421 9.12193 8.6235 8.00265 10.0042 8.00265H11.0042V7.00265H13.0042V8.00265H15.5042V10.0026H10.0042C9.72807 10.0026 9.50421 10.2265 9.50421 10.5026C9.50421 10.7788 9.72807 11.0026 10.0042 11.0026H14.0042C15.3849 11.0026 16.5042 12.1219 16.5042 13.5026C16.5042 14.8834 15.3849 16.0026 14.0042 16.0026H13.0042V17.0026H11.0042V16.0026H8.50421V14.0026Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6595b8cb8b930563(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM12.0049 9.00293H8.00488V11.0029H17.0049L12.0049 6.00293V9.00293ZM7.00488 13.0029L12.0049 18.0029V15.0029H16.0049V13.0029H7.00488Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1b529e3604aa7cb9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.37833 4.51353C7.14264 2.95131 9.46301 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 14.1279 21.3421 16.098 20.212 17.7179L17.5049 12.0029H20.0049C20.0049 7.58465 16.4232 4.00293 12.0049 4.00293C9.76058 4.00293 7.73213 4.92709 6.27932 6.41563L5.37833 4.51353ZM18.6314 19.4923C16.8671 21.0545 14.5468 22.0029 12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 9.87798 2.66767 7.90784 3.79778 6.28794L6.50488 12.0029H4.00488C4.00488 16.4212 7.5866 20.0029 12.0049 20.0029C14.2492 20.0029 16.2776 19.0788 17.7304 17.5902L18.6314 19.4923ZM13.4191 14.8314L10.5907 12.0029L7.76224 14.8314L6.34803 13.4171L10.5907 9.1745L13.4191 12.0029L16.2475 9.1745L17.6617 10.5887L13.4191 14.8314Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$16688dff845caf89(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.3788 15.1057C20.9258 11.442 19.5373 7.11425 16.0042 5.07444C13.4511 3.6004 10.4232 3.69359 8.03452 5.05554L7.04216 3.31873C10.028 1.61633 13.8128 1.49984 17.0042 3.34239C21.4949 5.93507 23.2139 11.4848 21.1217 16.1119L22.4635 16.8866L18.2984 19.1007L18.1334 14.3866L19.3788 15.1057ZM4.62961 8.89962C3.08263 12.5633 4.47116 16.891 8.00421 18.9308C10.5573 20.4049 13.5851 20.3117 15.9737 18.9499L16.9661 20.6866C13.9803 22.389 10.1956 22.5054 7.00421 20.6629C2.51357 18.0702 0.794565 12.5205 2.88672 7.89336L1.54492 7.11867L5.70999 4.90457L5.87505 9.61867L4.62961 8.89962ZM13.4184 14.8311L10.59 12.0026L7.76157 14.8311L6.34736 13.4169L10.59 9.17422L13.4184 12.0026L16.2469 9.17422L17.6611 10.5884L13.4184 14.8311Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$842f36597f822c88(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM12.0049 20.0029C16.4232 20.0029 20.0049 16.4212 20.0049 12.0029C20.0049 7.58465 16.4232 4.00293 12.0049 4.00293C7.5866 4.00293 4.00488 7.58465 4.00488 12.0029C4.00488 16.4212 7.5866 20.0029 12.0049 20.0029ZM7.00488 13.0029H16.0049V15.0029H12.0049V18.0029L7.00488 13.0029ZM12.0049 9.00293V6.00293L17.0049 11.0029H8.00488V9.00293H12.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e56e5250b13b30de(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 3.00293H21.0049C21.5572 3.00293 22.0049 3.45064 22.0049 4.00293V20.0029C22.0049 20.5552 21.5572 21.0029 21.0049 21.0029H3.00488C2.4526 21.0029 2.00488 20.5552 2.00488 20.0029V4.00293C2.00488 3.45064 2.4526 3.00293 3.00488 3.00293ZM14.7978 9.79582L12.348 12.2456L10.2267 10.1243L5.98407 14.3669L7.39828 15.7811L10.2267 12.9527L12.348 15.074L16.212 11.21L18.0049 13.0029V8.00293H13.0049L14.7978 9.79582Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8d7efebb6598066f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.00488 5.00293V19.0029H20.0049V5.00293H4.00488ZM3.00488 3.00293H21.0049C21.5572 3.00293 22.0049 3.45064 22.0049 4.00293V20.0029C22.0049 20.5552 21.5572 21.0029 21.0049 21.0029H3.00488C2.4526 21.0029 2.00488 20.5552 2.00488 20.0029V4.00293C2.00488 3.45064 2.4526 3.00293 3.00488 3.00293ZM14.7978 9.79582L13.0049 8.00293H18.0049V13.0029L16.212 11.21L12.348 15.074L10.2267 12.9527L7.39828 15.7811L5.98407 14.3669L10.2267 10.1243L12.348 12.2456L14.7978 9.79582Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b122277791bfacfb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.90145 17.8637L7.81249 13.9527L10.6409 16.7811L15.212 12.21L17.0049 14.0029V9.00293H12.0049L13.7978 10.7958L10.6409 13.9527L7.81249 11.1243L2.86662 16.0701C2.31276 14.8276 2.00488 13.4512 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029C8.67116 22.0029 5.71844 20.3716 3.90145 17.8637Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$afd44d953e70e12b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.41085 14.5259L7.81249 11.1243L10.6409 13.9527L13.7978 10.7958L12.0049 9.00293H17.0049V14.0029L15.212 12.21L10.6409 16.7811L7.81249 13.9527L5.33834 16.4268C6.77158 18.5823 9.22233 20.0029 12.0049 20.0029C16.4232 20.0029 20.0049 16.4212 20.0049 12.0029C20.0049 7.58465 16.4232 4.00293 12.0049 4.00293C7.5866 4.00293 4.00488 7.58465 4.00488 12.0029C4.00488 12.8845 4.14747 13.7327 4.41085 14.5259ZM2.87288 16.0841L2.86275 16.074L2.86662 16.0701C2.31276 14.8276 2.00488 13.4512 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029C7.93574 22.0029 4.43426 19.5725 2.87288 16.0841Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5622c2f5293d4c5c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.0049 13.0029V20.0029C20.0049 20.5552 19.5572 21.0029 19.0049 21.0029H5.00488C4.4526 21.0029 4.00488 20.5552 4.00488 20.0029V13.0029H20.0049ZM14.5049 2.00293C16.4379 2.00293 18.0049 3.56993 18.0049 5.50293C18.0049 6.04014 17.8839 6.54908 17.6676 7.00397L21.0049 7.00293C21.5572 7.00293 22.0049 7.45064 22.0049 8.00293V11.0029C22.0049 11.5552 21.5572 12.0029 21.0049 12.0029H3.00488C2.4526 12.0029 2.00488 11.5552 2.00488 11.0029V8.00293C2.00488 7.45064 2.4526 7.00293 3.00488 7.00293L6.34219 7.00397C6.12591 6.54908 6.00488 6.04014 6.00488 5.50293C6.00488 3.56993 7.57189 2.00293 9.50488 2.00293C10.4849 2.00293 11.3708 2.40569 12.0061 3.05471C12.639 2.40569 13.5249 2.00293 14.5049 2.00293ZM9.50488 4.00293C8.67646 4.00293 8.00488 4.6745 8.00488 5.50293C8.00488 6.28263 8.59977 6.92338 9.36042 6.99606L9.50488 7.00293H11.0049V5.50293C11.0049 4.72323 10.41 4.08248 9.64934 4.0098L9.50488 4.00293ZM14.5049 4.00293L14.3604 4.0098C13.6473 4.07794 13.0799 4.64536 13.0117 5.35847L13.0049 5.50293V7.00293H14.5049L14.6493 6.99606C15.41 6.92338 16.0049 6.28263 16.0049 5.50293C16.0049 4.72323 15.41 4.08248 14.6493 4.0098L14.5049 4.00293Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8adde51a2599201c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5049 2.00293C16.4379 2.00293 18.0049 3.56993 18.0049 5.50293C18.0049 6.04014 17.8839 6.54908 17.6676 7.00397L21.0049 7.00293C21.5572 7.00293 22.0049 7.45064 22.0049 8.00293V12.0029C22.0049 12.5552 21.5572 13.0029 21.0049 13.0029H20.0049V21.0029C20.0049 21.5552 19.5572 22.0029 19.0049 22.0029H5.00488C4.4526 22.0029 4.00488 21.5552 4.00488 21.0029V13.0029H3.00488C2.4526 13.0029 2.00488 12.5552 2.00488 12.0029V8.00293C2.00488 7.45064 2.4526 7.00293 3.00488 7.00293L6.34219 7.00397C6.12591 6.54908 6.00488 6.04014 6.00488 5.50293C6.00488 3.56993 7.57189 2.00293 9.50488 2.00293C10.4849 2.00293 11.3708 2.40569 12.0061 3.05471C12.639 2.40569 13.5249 2.00293 14.5049 2.00293ZM18.0049 13.0029H6.00488V20.0029H18.0049V13.0029ZM20.0049 9.00293H4.00488V11.0029H20.0049V9.00293ZM9.50488 4.00293C8.67646 4.00293 8.00488 4.6745 8.00488 5.50293C8.00488 6.28263 8.59977 6.92338 9.36042 6.99606L9.50488 7.00293H11.0049V5.50293C11.0049 4.72323 10.41 4.08248 9.64934 4.0098L9.50488 4.00293ZM14.5049 4.00293L14.3604 4.0098C13.6473 4.07794 13.0799 4.64536 13.0117 5.35847L13.0049 5.50293V7.00293H14.5049L14.6493 6.99606C15.41 6.92338 16.0049 6.28263 16.0049 5.50293C16.0049 4.72323 15.41 4.08248 14.6493 4.0098L14.5049 4.00293Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d75c8ec8173b027c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.0049 2.00293C17.214 2.00293 19.0049 3.79379 19.0049 6.00293C19.0049 6.73196 18.8098 7.41544 18.4691 8.00404L23.0049 8.00293V10.0029H21.0049V20.0029C21.0049 20.5552 20.5572 21.0029 20.0049 21.0029H4.00488C3.4526 21.0029 3.00488 20.5552 3.00488 20.0029V10.0029H1.00488V8.00293L5.54065 8.00404C5.19992 7.41544 5.00488 6.73196 5.00488 6.00293C5.00488 3.79379 6.79574 2.00293 9.00488 2.00293C10.2001 2.00293 11.2729 2.52714 12.0058 3.35819C12.7369 2.52714 13.8097 2.00293 15.0049 2.00293ZM13.0049 10.0029H11.0049V20.0029H13.0049V10.0029ZM9.00488 4.00293C7.90031 4.00293 7.00488 4.89836 7.00488 6.00293C7.00488 7.05729 7.82076 7.92109 8.85562 7.99744L9.00488 8.00293H11.0049V6.00293C11.0049 5.00129 10.2686 4.17162 9.30766 4.0257L9.15415 4.00842L9.00488 4.00293ZM15.0049 4.00293C13.9505 4.00293 13.0867 4.81881 13.0104 5.85367L13.0049 6.00293V8.00293H15.0049C16.0592 8.00293 16.923 7.18705 16.9994 6.15219L17.0049 6.00293C17.0049 4.89836 16.1095 4.00293 15.0049 4.00293Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$54be2ddad03117be(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.0049 2.00293C17.214 2.00293 19.0049 3.79379 19.0049 6.00293C19.0049 6.73196 18.8098 7.41544 18.4691 8.00404L23.0049 8.00293V10.0029H21.0049V20.0029C21.0049 20.5552 20.5572 21.0029 20.0049 21.0029H4.00488C3.4526 21.0029 3.00488 20.5552 3.00488 20.0029V10.0029H1.00488V8.00293L5.54065 8.00404C5.19992 7.41544 5.00488 6.73196 5.00488 6.00293C5.00488 3.79379 6.79574 2.00293 9.00488 2.00293C10.2001 2.00293 11.2729 2.52714 12.0058 3.35819C12.7369 2.52714 13.8097 2.00293 15.0049 2.00293ZM11.0049 10.0029H5.00488V19.0029H11.0049V10.0029ZM19.0049 10.0029H13.0049V19.0029H19.0049V10.0029ZM9.00488 4.00293C7.90031 4.00293 7.00488 4.89836 7.00488 6.00293C7.00488 7.05729 7.82076 7.92109 8.85562 7.99744L9.00488 8.00293H11.0049V6.00293C11.0049 5.00129 10.2686 4.17162 9.30766 4.0257L9.15415 4.00842L9.00488 4.00293ZM15.0049 4.00293C13.9505 4.00293 13.0867 4.81881 13.0104 5.85367L13.0049 6.00293V8.00293H15.0049C16.0592 8.00293 16.923 7.18705 16.9994 6.15219L17.0049 6.00293C17.0049 4.89836 16.1095 4.00293 15.0049 4.00293Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2c6a362625fef1d8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.3349 11.5025L11.5049 11.5029C13.9902 11.5029 16.0049 13.5176 16.0049 16.0029H9.00388L9.00488 17.0029L17.0049 17.0021V16.0029C17.0049 14.9205 16.6867 13.8998 16.1188 13.0021L19.0049 13.0029C20.9972 13.0029 22.7173 14.1682 23.521 15.8543C21.1562 18.975 17.3268 21.0029 13.0049 21.0029C10.2436 21.0029 7.90445 20.4123 6.00456 19.3782L6.00592 10.074C7.25147 10.2523 8.39122 10.7586 9.3349 11.5025ZM5.00488 19.0029C5.00488 19.5552 4.55717 20.0029 4.00488 20.0029H2.00488C1.4526 20.0029 1.00488 19.5552 1.00488 19.0029V10.0029C1.00488 9.45064 1.4526 9.00293 2.00488 9.00293H4.00488C4.55717 9.00293 5.00488 9.45064 5.00488 10.0029V19.0029ZM18.0049 5.00293C19.6617 5.00293 21.0049 6.34608 21.0049 8.00293C21.0049 9.65978 19.6617 11.0029 18.0049 11.0029C16.348 11.0029 15.0049 9.65978 15.0049 8.00293C15.0049 6.34608 16.348 5.00293 18.0049 5.00293ZM11.0049 2.00293C12.6617 2.00293 14.0049 3.34608 14.0049 5.00293C14.0049 6.65978 12.6617 8.00293 11.0049 8.00293C9.34803 8.00293 8.00488 6.65978 8.00488 5.00293C8.00488 3.34608 9.34803 2.00293 11.0049 2.00293Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8bd8e7e9d3f77ac8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.00488 9.00293C5.55717 9.00293 6.00488 9.45064 6.00488 10.0029C7.63965 10.0029 9.14352 10.5633 10.3349 11.5025L12.5049 11.5029C13.8375 11.5029 15.0348 12.0822 15.8588 13.0027L19.0049 13.0029C20.9972 13.0029 22.7173 14.1682 23.521 15.8543C21.1562 18.975 17.3268 21.0029 13.0049 21.0029C10.2142 21.0029 7.85466 20.3997 5.944 19.345C5.80557 19.7285 5.43727 20.0029 5.00488 20.0029H2.00488C1.4526 20.0029 1.00488 19.5552 1.00488 19.0029V10.0029C1.00488 9.45064 1.4526 9.00293 2.00488 9.00293H5.00488ZM6.00589 12.0029L6.00488 17.0249L6.05024 17.0574C7.84406 18.3178 10.183 19.0029 13.0049 19.0029C16.0089 19.0029 18.8035 17.8473 20.84 15.8735L20.9729 15.7399L20.8537 15.6395C20.3897 15.2765 19.8205 15.0513 19.2099 15.0099L19.0049 15.0029L16.8934 15.003C16.9664 15.3246 17.0049 15.6593 17.0049 16.0029V17.0029H8.00488V15.0029L14.7949 15.0019L14.7605 14.9235C14.38 14.1299 13.593 13.5682 12.6693 13.5082L12.5049 13.5029L9.57547 13.5028C8.66823 12.5774 7.40412 12.0032 6.00589 12.0029ZM4.00488 11.0029H3.00488V18.0029H4.00488V11.0029ZM18.0049 5.00293C19.6617 5.00293 21.0049 6.34608 21.0049 8.00293C21.0049 9.65978 19.6617 11.0029 18.0049 11.0029C16.348 11.0029 15.0049 9.65978 15.0049 8.00293C15.0049 6.34608 16.348 5.00293 18.0049 5.00293ZM18.0049 7.00293C17.4526 7.00293 17.0049 7.45064 17.0049 8.00293C17.0049 8.55521 17.4526 9.00293 18.0049 9.00293C18.5572 9.00293 19.0049 8.55521 19.0049 8.00293C19.0049 7.45064 18.5572 7.00293 18.0049 7.00293ZM11.0049 2.00293C12.6617 2.00293 14.0049 3.34608 14.0049 5.00293C14.0049 6.65978 12.6617 8.00293 11.0049 8.00293C9.34803 8.00293 8.00488 6.65978 8.00488 5.00293C8.00488 3.34608 9.34803 2.00293 11.0049 2.00293ZM11.0049 4.00293C10.4526 4.00293 10.0049 4.45064 10.0049 5.00293C10.0049 5.55521 10.4526 6.00293 11.0049 6.00293C11.5572 6.00293 12.0049 5.55521 12.0049 5.00293C12.0049 4.45064 11.5572 4.00293 11.0049 4.00293Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ffa468b69b475eb5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.3349 11.5021L11.5049 11.5026C13.9902 11.5026 16.0049 13.5173 16.0049 16.0026L9.00388 16.0017L9.00488 17.0026L17.0049 17.0018V16.0026C17.0049 14.9201 16.6867 13.8995 16.1188 13.0018L19.0049 13.0026C20.9972 13.0026 22.7173 14.1678 23.521 15.854C21.1562 18.9746 17.3268 21.0026 13.0049 21.0026C10.2436 21.0026 7.90437 20.4119 6.00447 19.3778L6.00592 10.0736C7.25147 10.2519 8.39122 10.7582 9.3349 11.5021ZM4.00488 9.00256C4.51772 9.00256 4.94039 9.3886 4.99816 9.88594L5.00488 10.0017V19.0026C5.00488 19.5548 4.55717 20.0026 4.00488 20.0026H2.00488C1.4526 20.0026 1.00488 19.5548 1.00488 19.0026V10.0026C1.00488 9.45027 1.4526 9.00256 2.00488 9.00256H4.00488ZM13.6513 3.57794L14.0046 3.9317L14.3584 3.57794C15.3347 2.60163 16.9177 2.60163 17.894 3.57794C18.8703 4.55425 18.8703 6.13716 17.894 7.11347L14.0049 11.0026L10.1158 7.11347C9.13948 6.13716 9.13948 4.55425 10.1158 3.57794C11.0921 2.60163 12.675 2.60163 13.6513 3.57794Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$376230617bdabaa2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.00488 9.00256C5.55717 9.00256 6.00488 9.45027 6.00488 10.0026C7.63965 10.0026 9.14352 10.5629 10.3349 11.5021L12.5049 11.5026C13.837 11.5026 15.0339 12.0814 15.8579 13.0013L19.0049 13.0026C20.9972 13.0026 22.7173 14.1678 23.521 15.854C21.1562 18.9746 17.3268 21.0026 13.0049 21.0026C10.2142 21.0026 7.85466 20.3993 5.944 19.3446C5.80557 19.7281 5.43727 20.0026 5.00488 20.0026H2.00488C1.4526 20.0026 1.00488 19.5548 1.00488 19.0026V10.0026C1.00488 9.45027 1.4526 9.00256 2.00488 9.00256H5.00488ZM6.00589 12.0026L6.00488 17.0237L6.05024 17.057C7.84406 18.3175 10.183 19.0026 13.0049 19.0026C16.0089 19.0026 18.8035 17.8469 20.84 15.8731L20.9729 15.7396L20.8537 15.6392C20.3897 15.2762 19.8205 15.0509 19.2099 15.0095L19.0049 15.0026L16.8932 15.0016C16.9663 15.3235 17.0049 15.6585 17.0049 16.0026V17.0026H8.00488V15.0026L14.7949 15.0016L14.7605 14.9231C14.38 14.1295 13.593 13.5678 12.6693 13.5079L12.5049 13.5026L9.57547 13.5024C8.66823 12.577 7.40412 12.0028 6.00589 12.0026ZM4.00488 11.0026H3.00488V18.0026H4.00488V11.0026ZM13.6513 3.57794L14.0046 3.9317L14.3584 3.57794C15.3347 2.60163 16.9177 2.60163 17.894 3.57794C18.8703 4.55425 18.8703 6.13716 17.894 7.11347L14.0049 11.0026L10.1158 7.11347C9.13948 6.13716 9.13948 4.55425 10.1158 3.57794C11.0921 2.60163 12.675 2.60163 13.6513 3.57794ZM11.53 4.99215C11.3564 5.16572 11.3372 5.43514 11.4714 5.62926L11.5289 5.69819L14.0039 8.17356L16.4798 5.69926C16.6533 5.52569 16.6726 5.25627 16.5376 5.0614L16.4798 4.99215C16.3062 4.81858 16.0368 4.7993 15.8417 4.93444L15.7724 4.99236L14.0033 6.76098L12.236 4.99108L12.1679 4.93429C11.973 4.7993 11.7036 4.81858 11.53 4.99215Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2bd3e9de73c672b4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 3.00293H21.0049C21.5572 3.00293 22.0049 3.45064 22.0049 4.00293V20.0029C22.0049 20.5552 21.5572 21.0029 21.0049 21.0029H3.00488C2.4526 21.0029 2.00488 20.5552 2.00488 20.0029V4.00293C2.00488 3.45064 2.4526 3.00293 3.00488 3.00293ZM9.00488 11.0029V9.00293H7.00488V11.0029H5.00488V13.0029H7.00488V15.0029H9.00488V13.0029H11.0049V11.0029H9.00488ZM13.0049 11.0029V13.0029H19.0049V11.0029H13.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5ae77eb9e95129ea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 3.00293H21.0049C21.5572 3.00293 22.0049 3.45064 22.0049 4.00293V20.0029C22.0049 20.5552 21.5572 21.0029 21.0049 21.0029H3.00488C2.4526 21.0029 2.00488 20.5552 2.00488 20.0029V4.00293C2.00488 3.45064 2.4526 3.00293 3.00488 3.00293ZM4.00488 5.00293V19.0029H20.0049V5.00293H4.00488ZM9.00488 11.0029H11.0049V13.0029H9.00488V15.0029H7.00488V13.0029H5.00488V11.0029H7.00488V9.00293H9.00488V11.0029ZM13.0049 11.0029H19.0049V13.0029H13.0049V11.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dab5909dacd1bd3b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 3.00293H21.0049C21.5572 3.00293 22.0049 3.45064 22.0049 4.00293V20.0029C22.0049 20.5552 21.5572 21.0029 21.0049 21.0029H3.00488C2.4526 21.0029 2.00488 20.5552 2.00488 20.0029V4.00293C2.00488 3.45064 2.4526 3.00293 3.00488 3.00293ZM13.0049 13.0029V12.0029H16.0049V10.0029H13.4191L15.5404 7.88161L14.1262 6.4674L12.0049 8.58872L9.88356 6.4674L8.46935 7.88161L10.5907 10.0029H8.00488V12.0029H11.0049V13.0029H8.00488V15.0029H11.0049V17.0029H13.0049V15.0029H16.0049V13.0029H13.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4f25012a3d55d419(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 3.00293H21.0049C21.5572 3.00293 22.0049 3.45064 22.0049 4.00293V20.0029C22.0049 20.5552 21.5572 21.0029 21.0049 21.0029H3.00488C2.4526 21.0029 2.00488 20.5552 2.00488 20.0029V4.00293C2.00488 3.45064 2.4526 3.00293 3.00488 3.00293ZM4.00488 5.00293V19.0029H20.0049V5.00293H4.00488ZM13.0049 13.0029H16.0049V15.0029H13.0049V17.0029H11.0049V15.0029H8.00488V13.0029H11.0049V12.0029H8.00488V10.0029H10.5907L8.46935 7.88161L9.88356 6.4674L12.0049 8.58872L14.1262 6.4674L15.5404 7.88161L13.4191 10.0029H16.0049V12.0029H13.0049V13.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e57ad98f14b51ad1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM13.0049 13.0029V12.0029H16.0049V10.0029H13.4191L15.5404 7.88161L14.1262 6.4674L12.0049 8.58872L9.88356 6.4674L8.46935 7.88161L10.5907 10.0029H8.00488V12.0029H11.0049V13.0029H8.00488V15.0029H11.0049V17.0029H13.0049V15.0029H16.0049V13.0029H13.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$24fe1ac45364f551(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM12.0049 20.0029C16.4232 20.0029 20.0049 16.4212 20.0049 12.0029C20.0049 7.58465 16.4232 4.00293 12.0049 4.00293C7.5866 4.00293 4.00488 7.58465 4.00488 12.0029C4.00488 16.4212 7.5866 20.0029 12.0049 20.0029ZM13.0049 13.0029H16.0049V15.0029H13.0049V17.0029H11.0049V15.0029H8.00488V13.0029H11.0049V12.0029H8.00488V10.0029H10.5907L8.46935 7.88161L9.88356 6.4674L12.0049 8.58872L14.1262 6.4674L15.5404 7.88161L13.4191 10.0029H16.0049V12.0029H13.0049V13.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8fade0bbd49e4bd1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 3.00293H21.0049C21.5572 3.00293 22.0049 3.45064 22.0049 4.00293V20.0029C22.0049 20.5552 21.5572 21.0029 21.0049 21.0029H3.00488C2.4526 21.0029 2.00488 20.5552 2.00488 20.0029V4.00293C2.00488 3.45064 2.4526 3.00293 3.00488 3.00293ZM8.50488 14.0029V16.0029H11.0049V18.0029H13.0049V16.0029H14.0049C15.3856 16.0029 16.5049 14.8836 16.5049 13.5029C16.5049 12.1222 15.3856 11.0029 14.0049 11.0029H10.0049C9.72874 11.0029 9.50488 10.7791 9.50488 10.5029C9.50488 10.2268 9.72874 10.0029 10.0049 10.0029H15.5049V8.00293H13.0049V6.00293H11.0049V8.00293H10.0049C8.62417 8.00293 7.50488 9.12222 7.50488 10.5029C7.50488 11.8836 8.62417 13.0029 10.0049 13.0029H14.0049C14.281 13.0029 14.5049 13.2268 14.5049 13.5029C14.5049 13.7791 14.281 14.0029 14.0049 14.0029H8.50488Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5d00a9ce871eeaf5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 3.00293H21.0049C21.5572 3.00293 22.0049 3.45064 22.0049 4.00293V20.0029C22.0049 20.5552 21.5572 21.0029 21.0049 21.0029H3.00488C2.4526 21.0029 2.00488 20.5552 2.00488 20.0029V4.00293C2.00488 3.45064 2.4526 3.00293 3.00488 3.00293ZM4.00488 5.00293V19.0029H20.0049V5.00293H4.00488ZM8.50488 14.0029H14.0049C14.281 14.0029 14.5049 13.7791 14.5049 13.5029C14.5049 13.2268 14.281 13.0029 14.0049 13.0029H10.0049C8.62417 13.0029 7.50488 11.8836 7.50488 10.5029C7.50488 9.12222 8.62417 8.00293 10.0049 8.00293H11.0049V6.00293H13.0049V8.00293H15.5049V10.0029H10.0049C9.72874 10.0029 9.50488 10.2268 9.50488 10.5029C9.50488 10.7791 9.72874 11.0029 10.0049 11.0029H14.0049C15.3856 11.0029 16.5049 12.1222 16.5049 13.5029C16.5049 14.8836 15.3856 16.0029 14.0049 16.0029H13.0049V18.0029H11.0049V16.0029H8.50488V14.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8bb4e99bce0107b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM8.50488 14.0029V16.0029H11.0049V18.0029H13.0049V16.0029H14.0049C15.3856 16.0029 16.5049 14.8836 16.5049 13.5029C16.5049 12.1222 15.3856 11.0029 14.0049 11.0029H10.0049C9.72874 11.0029 9.50488 10.7791 9.50488 10.5029C9.50488 10.2268 9.72874 10.0029 10.0049 10.0029H15.5049V8.00293H13.0049V6.00293H11.0049V8.00293H10.0049C8.62417 8.00293 7.50488 9.12222 7.50488 10.5029C7.50488 11.8836 8.62417 13.0029 10.0049 13.0029H14.0049C14.281 13.0029 14.5049 13.2268 14.5049 13.5029C14.5049 13.7791 14.281 14.0029 14.0049 14.0029H8.50488Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d344c280f7253180(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM12.0049 20.0029C16.4232 20.0029 20.0049 16.4212 20.0049 12.0029C20.0049 7.58465 16.4232 4.00293 12.0049 4.00293C7.5866 4.00293 4.00488 7.58465 4.00488 12.0029C4.00488 16.4212 7.5866 20.0029 12.0049 20.0029ZM8.50488 14.0029H14.0049C14.281 14.0029 14.5049 13.7791 14.5049 13.5029C14.5049 13.2268 14.281 13.0029 14.0049 13.0029H10.0049C8.62417 13.0029 7.50488 11.8836 7.50488 10.5029C7.50488 9.12222 8.62417 8.00293 10.0049 8.00293H11.0049V6.00293H13.0049V8.00293H15.5049V10.0029H10.0049C9.72874 10.0029 9.50488 10.2268 9.50488 10.5029C9.50488 10.7791 9.72874 11.0029 10.0049 11.0029H14.0049C15.3856 11.0029 16.5049 12.1222 16.5049 13.5029C16.5049 14.8836 15.3856 16.0029 14.0049 16.0029H13.0049V18.0029H11.0049V16.0029H8.50488V14.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7525c09e83815e92(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 3.00293H21.0049C21.5572 3.00293 22.0049 3.45064 22.0049 4.00293V20.0029C22.0049 20.5552 21.5572 21.0029 21.0049 21.0029H3.00488C2.4526 21.0029 2.00488 20.5552 2.00488 20.0029V4.00293C2.00488 3.45064 2.4526 3.00293 3.00488 3.00293ZM10.0549 11.0029C10.2865 9.86181 11.2954 9.00293 12.5049 9.00293C13.1201 9.00293 13.6834 9.22515 14.1189 9.59369L15.8198 8.45969C14.9973 7.5642 13.8166 7.00293 12.5049 7.00293C10.1886 7.00293 8.28107 8.75295 8.03235 11.0029H7.00488V13.0029H8.03235C8.28107 15.2529 10.1886 17.0029 12.5049 17.0029C13.8166 17.0029 14.9973 16.4417 15.8198 15.5462L14.1188 14.4122C13.6833 14.7807 13.1201 15.0029 12.5049 15.0029C11.2954 15.0029 10.2865 14.144 10.0549 13.0029H15.0049V11.0029H10.0549Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$59f888886e8738ae(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 3.00293H21.0049C21.5572 3.00293 22.0049 3.45064 22.0049 4.00293V20.0029C22.0049 20.5552 21.5572 21.0029 21.0049 21.0029H3.00488C2.4526 21.0029 2.00488 20.5552 2.00488 20.0029V4.00293C2.00488 3.45064 2.4526 3.00293 3.00488 3.00293ZM4.00488 5.00293V19.0029H20.0049V5.00293H4.00488ZM10.0549 11.0029H15.0049V13.0029H10.0549C10.2865 14.144 11.2954 15.0029 12.5049 15.0029C13.1201 15.0029 13.6833 14.7807 14.1188 14.4122L15.8198 15.5462C14.9973 16.4417 13.8166 17.0029 12.5049 17.0029C10.1886 17.0029 8.28107 15.2529 8.03235 13.0029H7.00488V11.0029H8.03235C8.28107 8.75295 10.1886 7.00293 12.5049 7.00293C13.8166 7.00293 14.9973 7.5642 15.8198 8.45969L14.1189 9.59369C13.6834 9.22515 13.1201 9.00293 12.5049 9.00293C11.2954 9.00293 10.2865 9.86181 10.0549 11.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ef06e52bdff4487e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM10.0549 11.0029C10.2865 9.86181 11.2954 9.00293 12.5049 9.00293C13.1201 9.00293 13.6834 9.22515 14.1189 9.59369L15.8198 8.45969C14.9973 7.5642 13.8166 7.00293 12.5049 7.00293C10.1886 7.00293 8.28107 8.75295 8.03235 11.0029H7.00488V13.0029H8.03235C8.28107 15.2529 10.1886 17.0029 12.5049 17.0029C13.8166 17.0029 14.9973 16.4417 15.8198 15.5462L14.1188 14.4122C13.6833 14.7807 13.1201 15.0029 12.5049 15.0029C11.2954 15.0029 10.2865 14.144 10.0549 13.0029H15.0049V11.0029H10.0549Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$81d1b1c11595df2c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM12.0049 20.0029C16.4232 20.0029 20.0049 16.4212 20.0049 12.0029C20.0049 7.58465 16.4232 4.00293 12.0049 4.00293C7.5866 4.00293 4.00488 7.58465 4.00488 12.0029C4.00488 16.4212 7.5866 20.0029 12.0049 20.0029ZM10.0549 11.0029H15.0049V13.0029H10.0549C10.2865 14.144 11.2954 15.0029 12.5049 15.0029C13.1201 15.0029 13.6833 14.7807 14.1188 14.4122L15.8198 15.5462C14.9973 16.4417 13.8166 17.0029 12.5049 17.0029C10.1886 17.0029 8.28107 15.2529 8.03235 13.0029H7.00488V11.0029H8.03235C8.28107 8.75295 10.1886 7.00293 12.5049 7.00293C13.8166 7.00293 14.9973 7.5642 15.8198 8.45969L14.1189 9.59369C13.6834 9.22515 13.1201 9.00293 12.5049 9.00293C11.2954 9.00293 10.2865 9.86181 10.0549 11.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ad12803fe01880e7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 3.00293H21.0049C21.5572 3.00293 22.0049 3.45064 22.0049 4.00293V20.0029C22.0049 20.5552 21.5572 21.0029 21.0049 21.0029H3.00488C2.4526 21.0029 2.00488 20.5552 2.00488 20.0029V4.00293C2.00488 3.45064 2.4526 3.00293 3.00488 3.00293ZM9.00488 13.0029V15.0029H8.00488V17.0029H16.0049V15.0029H11.0049V13.0029H14.0049V11.0029H11.0049V10.0029C11.0049 9.1745 11.6765 8.50293 12.5049 8.50293C13.0329 8.50293 13.4971 8.77572 13.7644 9.18804L15.7509 8.69143C15.2319 7.40823 13.9741 6.50293 12.5049 6.50293C10.5719 6.50293 9.00488 8.06993 9.00488 10.0029V11.0029H8.00488V13.0029H9.00488Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7752cb9630539f4f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 3.00293H21.0049C21.5572 3.00293 22.0049 3.45064 22.0049 4.00293V20.0029C22.0049 20.5552 21.5572 21.0029 21.0049 21.0029H3.00488C2.4526 21.0029 2.00488 20.5552 2.00488 20.0029V4.00293C2.00488 3.45064 2.4526 3.00293 3.00488 3.00293ZM4.00488 5.00293V19.0029H20.0049V5.00293H4.00488ZM9.00488 13.0029H8.00488V11.0029H9.00488V10.0029C9.00488 8.06993 10.5719 6.50293 12.5049 6.50293C13.9741 6.50293 15.2319 7.40823 15.7509 8.69143L13.7644 9.18804C13.4971 8.77572 13.0329 8.50293 12.5049 8.50293C11.6765 8.50293 11.0049 9.1745 11.0049 10.0029V11.0029H14.0049V13.0029H11.0049V15.0029H16.0049V17.0029H8.00488V15.0029H9.00488V13.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f7a767dd183901bf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM9.00488 13.0029V15.0029H8.00488V17.0029H16.0049V15.0029H11.0049V13.0029H14.0049V11.0029H11.0049V10.0029C11.0049 9.1745 11.6765 8.50293 12.5049 8.50293C13.0329 8.50293 13.4971 8.77572 13.7644 9.18804L15.7509 8.69143C15.2319 7.40823 13.9741 6.50293 12.5049 6.50293C10.5719 6.50293 9.00488 8.06993 9.00488 10.0029V11.0029H8.00488V13.0029H9.00488Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5fe642f8ebe41620(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM12.0049 20.0029C16.4232 20.0029 20.0049 16.4212 20.0049 12.0029C20.0049 7.58465 16.4232 4.00293 12.0049 4.00293C7.5866 4.00293 4.00488 7.58465 4.00488 12.0029C4.00488 16.4212 7.5866 20.0029 12.0049 20.0029ZM9.00488 13.0029H8.00488V11.0029H9.00488V10.0029C9.00488 8.06993 10.5719 6.50293 12.5049 6.50293C13.9741 6.50293 15.2319 7.40823 15.7509 8.69143L13.7644 9.18804C13.4971 8.77572 13.0329 8.50293 12.5049 8.50293C11.6765 8.50293 11.0049 9.1745 11.0049 10.0029V11.0029H14.0049V13.0029H11.0049V15.0029H16.0049V17.0029H8.00488V15.0029H9.00488V13.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d7d1a7733bc6d05b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12C10.1046 12 11 11.1046 11 10 11 8.89543 10.1046 8 9 8 7.89543 8 7 8.89543 7 10 7 11.1046 7.89543 12 9 12ZM12 1 21.5 6.5V17.5L12 23 2.5 17.5V6.5L12 1ZM4.5 7.65311V16.3469L6.8724 17.7204 14.9446 11.8008 19.5 14.534V7.65311L12 3.311 4.5 7.65311Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cb8a6778e64e64df(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12C10.1046 12 11 11.1046 11 10 11 8.89543 10.1046 8 9 8 7.89543 8 7 8.89543 7 10 7 11.1046 7.89543 12 9 12ZM21.5 6.5 12 1 2.5 6.5V17.5L12 23 21.5 17.5V6.5ZM12 3.311 19.5 7.65311V14.5338L14.9379 11.7966 6.96669 17.775 4.5 16.3469V7.65311L12 3.311ZM12 20.689 8.84788 18.8641 15.0621 14.2034 19.0595 16.6019 12 20.689Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$235f8ca11db43f58(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5C20 6.65685 18.6569 8 17 8C15.3431 8 14 6.65685 14 5C14 3.34315 15.3431 2 17 2C18.6569 2 20 3.34315 20 5ZM7 3C4.79086 3 3 4.79086 3 7V9H5V7C5 5.89543 5.89543 5 7 5H10V3H7ZM17 21C19.2091 21 21 19.2091 21 17V15H19V17C19 18.1046 18.1046 19 17 19H14V21H17ZM7 16C8.65685 16 10 14.6569 10 13C10 11.3431 8.65685 10 7 10C5.34315 10 4 11.3431 4 13C4 14.6569 5.34315 16 7 16ZM17 9C14.7909 9 13 10.7909 13 13H21C21 10.7909 19.2091 9 17 9ZM3 21C3 18.7909 4.79086 17 7 17C9.20914 17 11 18.7909 11 21H3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3fe496b89d57f78b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6C16.4477 6 16 5.55228 16 5C16 4.44772 16.4477 4 17 4C17.5523 4 18 4.44772 18 5C18 5.55228 17.5523 6 17 6ZM17 8C18.6569 8 20 6.65685 20 5C20 3.34315 18.6569 2 17 2C15.3431 2 14 3.34315 14 5C14 6.65685 15.3431 8 17 8ZM7 3C4.79086 3 3 4.79086 3 7V9H5V7C5 5.89543 5.89543 5 7 5H10V3H7ZM17 21C19.2091 21 21 19.2091 21 17V15H19V17C19 18.1046 18.1046 19 17 19H14V21H17ZM8 13C8 12.4477 7.55228 12 7 12C6.44772 12 6 12.4477 6 13C6 13.5523 6.44772 14 7 14C7.55228 14 8 13.5523 8 13ZM10 13C10 14.6569 8.65685 16 7 16C5.34315 16 4 14.6569 4 13C4 11.3431 5.34315 10 7 10C8.65685 10 10 11.3431 10 13ZM17 11C15.8954 11 15 11.8954 15 13H13C13 10.7909 14.7909 9 17 9C19.2091 9 21 10.7909 21 13H19C19 11.8954 18.1046 11 17 11ZM5 21C5 19.8954 5.89543 19 7 19C8.10457 19 9 19.8954 9 21H11C11 18.7909 9.20914 17 7 17C4.79086 17 3 18.7909 3 21H5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f7d9e3e2e15a3224(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5049 21.0029C15.5719 21.0029 14.0049 19.4359 14.0049 17.5029C14.0049 15.5699 15.5719 14.0029 17.5049 14.0029C19.4379 14.0029 21.0049 15.5699 21.0049 17.5029C21.0049 19.4359 19.4379 21.0029 17.5049 21.0029ZM6.50488 10.0029C4.57189 10.0029 3.00488 8.43593 3.00488 6.50293C3.00488 4.56993 4.57189 3.00293 6.50488 3.00293C8.43788 3.00293 10.0049 4.56993 10.0049 6.50293C10.0049 8.43593 8.43788 10.0029 6.50488 10.0029ZM19.076 3.51765L20.4902 4.93186L4.93382 20.4882L3.5196 19.074L19.076 3.51765Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f92179451e04fde3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5049 21.0029C15.5719 21.0029 14.0049 19.4359 14.0049 17.5029C14.0049 15.5699 15.5719 14.0029 17.5049 14.0029C19.4379 14.0029 21.0049 15.5699 21.0049 17.5029C21.0049 19.4359 19.4379 21.0029 17.5049 21.0029ZM17.5049 19.0029C18.3333 19.0029 19.0049 18.3314 19.0049 17.5029C19.0049 16.6745 18.3333 16.0029 17.5049 16.0029C16.6765 16.0029 16.0049 16.6745 16.0049 17.5029C16.0049 18.3314 16.6765 19.0029 17.5049 19.0029ZM6.50488 10.0029C4.57189 10.0029 3.00488 8.43593 3.00488 6.50293C3.00488 4.56993 4.57189 3.00293 6.50488 3.00293C8.43788 3.00293 10.0049 4.56993 10.0049 6.50293C10.0049 8.43593 8.43788 10.0029 6.50488 10.0029ZM6.50488 8.00293C7.33331 8.00293 8.00488 7.33136 8.00488 6.50293C8.00488 5.6745 7.33331 5.00293 6.50488 5.00293C5.67646 5.00293 5.00488 5.6745 5.00488 6.50293C5.00488 7.33136 5.67646 8.00293 6.50488 8.00293ZM19.076 3.51765L20.4902 4.93186L4.93382 20.4882L3.5196 19.074L19.076 3.51765Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$89bf0474e4ef0e0f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 6.99981L11.4502 1.36961C11.7861 1.14568 12.2237 1.14568 12.5596 1.36961L21.0049 6.99981V20.9998C21.0049 21.5521 20.5572 21.9998 20.0049 21.9998H4.00488C3.4526 21.9998 3.00488 21.5521 3.00488 20.9998V6.99981ZM12.0049 10.9998C13.1095 10.9998 14.0049 10.1044 14.0049 8.99981C14.0049 7.89524 13.1095 6.99981 12.0049 6.99981C10.9003 6.99981 10.0049 7.89524 10.0049 8.99981C10.0049 10.1044 10.9003 10.9998 12.0049 10.9998ZM8.00488 15.9998V17.9998H16.0049V15.9998H8.00488ZM8.00488 12.9998V14.9998H16.0049V12.9998H8.00488Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e14a8db6e32acfec(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 6.99981L11.4502 1.36961C11.7861 1.14568 12.2237 1.14568 12.5596 1.36961L21.0049 6.99981V20.9998C21.0049 21.5521 20.5572 21.9998 20.0049 21.9998H4.00488C3.4526 21.9998 3.00488 21.5521 3.00488 20.9998V6.99981ZM5.00488 8.07018V19.9998H19.0049V8.07018L12.0049 3.40351L5.00488 8.07018ZM8.00488 15.9998H16.0049V17.9998H8.00488V15.9998ZM8.00488 12.9998H16.0049V14.9998H8.00488V12.9998ZM12.0049 10.9998C10.9003 10.9998 10.0049 10.1044 10.0049 8.99981C10.0049 7.89524 10.9003 6.99981 12.0049 6.99981C13.1095 6.99981 14.0049 7.89524 14.0049 8.99981C14.0049 10.1044 13.1095 10.9998 12.0049 10.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$147b4321be65c5da(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9042 2.1001L20.8037 3.51431L22.2179 13.4138L13.0255 22.6062C12.635 22.9967 12.0019 22.9967 11.6113 22.6062L1.71184 12.7067C1.32131 12.3162 1.32131 11.683 1.71184 11.2925L10.9042 2.1001ZM13.7327 10.5854C14.5137 11.3664 15.78 11.3664 16.5611 10.5854C17.3421 9.80433 17.3421 8.538 16.5611 7.75695C15.78 6.9759 14.5137 6.9759 13.7327 7.75695C12.9516 8.538 12.9516 9.80433 13.7327 10.5854Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f9b6e983844efb01(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9042 2.1001L20.8037 3.51431L22.2179 13.4138L13.0255 22.6062C12.635 22.9967 12.0019 22.9967 11.6113 22.6062L1.71184 12.7067C1.32131 12.3162 1.32131 11.683 1.71184 11.2925L10.9042 2.1001ZM11.6113 4.22142L3.83316 11.9996L12.3184 20.4849L20.0966 12.7067L19.036 5.28208L11.6113 4.22142ZM13.7327 10.5854C12.9516 9.80433 12.9516 8.538 13.7327 7.75695C14.5137 6.9759 15.78 6.9759 16.5611 7.75695C17.3421 8.538 17.3421 9.80433 16.5611 10.5854C15.78 11.3664 14.5137 11.3664 13.7327 10.5854Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eecb68b55dcbdd33(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 6.99981L11.4502 1.36961C11.7861 1.14568 12.2237 1.14568 12.5596 1.36961L21.0049 6.99981V20.9998C21.0049 21.5521 20.5572 21.9998 20.0049 21.9998H4.00488C3.4526 21.9998 3.00488 21.5521 3.00488 20.9998V6.99981ZM12.0049 10.9998C13.1095 10.9998 14.0049 10.1044 14.0049 8.99981C14.0049 7.89524 13.1095 6.99981 12.0049 6.99981C10.9003 6.99981 10.0049 7.89524 10.0049 8.99981C10.0049 10.1044 10.9003 10.9998 12.0049 10.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2e37ab36015c94c9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 6.99981L11.4502 1.36961C11.7861 1.14568 12.2237 1.14568 12.5596 1.36961L21.0049 6.99981V20.9998C21.0049 21.5521 20.5572 21.9998 20.0049 21.9998H4.00488C3.4526 21.9998 3.00488 21.5521 3.00488 20.9998V6.99981ZM5.00488 8.07018V19.9998H19.0049V8.07018L12.0049 3.40351L5.00488 8.07018ZM12.0049 10.9998C10.9003 10.9998 10.0049 10.1044 10.0049 8.99981C10.0049 7.89524 10.9003 6.99981 12.0049 6.99981C13.1095 6.99981 14.0049 7.89524 14.0049 8.99981C14.0049 10.1044 13.1095 10.9998 12.0049 10.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b662f010ff475a40(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.0049 5.9404C19.2657 7.91087 16.8895 9.30578 14.1986 9.80288C13.7739 9.02817 12.9507 8.50293 12.0049 8.50293C11.0591 8.50293 10.2359 9.02817 9.8112 9.80288C7.12025 9.30578 4.74405 7.91087 3.00488 5.9404V3.00293C3.00488 2.45064 3.4526 2.00293 4.00488 2.00293H20.0049C20.5572 2.00293 21.0049 2.45064 21.0049 3.00293V5.9404ZM21.0049 8.72716V21.0029C21.0049 21.5552 20.5572 22.0029 20.0049 22.0029H4.00488C3.4526 22.0029 3.00488 21.5552 3.00488 21.0029V8.72716C4.86501 10.2899 7.13757 11.3775 9.63575 11.8033C9.96947 12.7915 10.9041 13.5029 12.0049 13.5029C13.1057 13.5029 14.0403 12.7915 14.374 11.8033C16.8722 11.3775 19.1448 10.2899 21.0049 8.72716Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$322664f95fabdb8c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.178 9.76614C16.0334 9.35499 17.695 8.42842 19.0049 7.14436V4.00293H5.00488V7.14436C6.31472 8.42842 7.97632 9.35499 9.83175 9.76614C10.2621 9.01161 11.0741 8.50293 12.0049 8.50293C12.9357 8.50293 13.7477 9.01161 14.178 9.76614ZM14.3861 11.7667C14.0633 12.7739 13.1192 13.5029 12.0049 13.5029C10.8905 13.5029 9.94648 12.7739 9.6237 11.7667C7.92722 11.4252 6.36024 10.7258 5.00488 9.75083V20.0029H19.0049V9.75083C17.6495 10.7258 16.0825 11.4252 14.3861 11.7667ZM4.00488 2.00293H20.0049C20.5572 2.00293 21.0049 2.45064 21.0049 3.00293V21.0029C21.0049 21.5552 20.5572 22.0029 20.0049 22.0029H4.00488C3.4526 22.0029 3.00488 21.5552 3.00488 21.0029V3.00293C3.00488 2.45064 3.4526 2.00293 4.00488 2.00293Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a78410a29b1aeda4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 2C17.5277 2 22.0049 6.47715 22.0049 12C22.0049 17.5228 17.5277 22 12.0049 22C9.57847 22 7.3539 21.1358 5.62216 19.6985L5.37815 19.4892L6.27949 17.5875C7.73229 19.0759 9.76067 20 12.0049 20C16.4232 20 20.0049 16.4183 20.0049 12C20.0049 7.58172 16.4232 4 12.0049 4C7.66997 4 4.14034 7.44784 4.00869 11.7508L4.00488 12H6.50488L3.79854 17.7161C2.66796 16.096 2.00488 14.1254 2.00488 12C2.00488 6.47715 6.48204 2 12.0049 2ZM13.0049 6V8H15.5049V10H10.0049C9.72874 10 9.50488 10.2239 9.50488 10.5C9.50488 10.7455 9.68176 10.9496 9.91501 10.9919L10.0049 11H14.0049C15.3856 11 16.5049 12.1193 16.5049 13.5C16.5049 14.8807 15.3856 16 14.0049 16H13.0049V18H11.0049V16H8.50488V14H14.0049C14.281 14 14.5049 13.7761 14.5049 13.5C14.5049 13.2545 14.328 13.0504 14.0948 13.0081L14.0049 13H10.0049C8.62417 13 7.50488 11.8807 7.50488 10.5C7.50488 9.11929 8.62417 8 10.0049 8H11.0049V6H13.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5da046927453501d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.67591 4.25667C9.60392 1.03828 15.4094 1.26236 19.076 4.92893C22.9812 8.83418 22.9812 15.1658 19.076 19.0711C15.1707 22.9763 8.83906 22.9763 4.93382 19.0711C2.40932 16.5466 1.51676 13.0081 2.25611 9.76666L2.33275 9.45394L4.26718 9.96315C3.56967 12.623 4.26329 15.5721 6.34803 17.6569C9.47222 20.781 14.5375 20.781 17.6617 17.6569C20.7859 14.5327 20.7859 9.46734 17.6617 6.34315C14.8441 3.5255 10.4475 3.24903 7.32006 5.51375L7.09886 5.67983L8.1158 6.6967L3.5196 7.75736L4.58026 3.16117L5.67591 4.25667ZM13.0049 6V8H15.5049V10H10.0049C9.72874 10 9.50488 10.2239 9.50488 10.5C9.50488 10.7455 9.68176 10.9496 9.91501 10.9919L10.0049 11H14.0049C15.3856 11 16.5049 12.1193 16.5049 13.5C16.5049 14.8807 15.3856 16 14.0049 16H13.0049V18H11.0049V16H8.50488V14H14.0049C14.281 14 14.5049 13.7761 14.5049 13.5C14.5049 13.2545 14.328 13.0504 14.0948 13.0081L14.0049 13H10.0049C8.62417 13 7.50488 11.8807 7.50488 10.5C7.50488 9.11929 8.62417 8 10.0049 8H11.0049V6H13.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f10e5dc6579c2342(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.0049 7H2.00488V4C2.00488 3.44772 2.4526 3 3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V7ZM22.0049 9V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V9H22.0049ZM11.0049 14V11.5L6.50488 16H17.0049V14H11.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$feefff7461bf20ea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.0049 8V5H4.00488V8H20.0049ZM20.0049 10H4.00488V19H20.0049V10ZM3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V4C2.00488 3.44772 2.4526 3 3.00488 3ZM11.0049 14H17.0049V16H6.50488L11.0049 11.5V14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9f5959da46a7aa73(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.0049 19.9996H6.00488V21.9996H4.00488V19.9996H3.00488C2.4526 19.9996 2.00488 19.5519 2.00488 18.9996V3.99961C2.00488 3.44733 2.4526 2.99961 3.00488 2.99961H10.0049V1.58984C10.0049 1.3137 10.2287 1.08984 10.5049 1.08984C10.5324 1.08984 10.5599 1.09212 10.5871 1.09665L21.1693 2.86035C21.6515 2.94071 22.0049 3.3579 22.0049 3.84674V5.99961H23.0049V7.99961H22.0049V14.9996H23.0049V16.9996H22.0049V19.1525C22.0049 19.6413 21.6515 20.0585 21.1693 20.1389L20.0049 20.3329V21.9996H18.0049V20.6663L10.5871 21.9026C10.3147 21.948 10.0571 21.764 10.0117 21.4916C10.0072 21.4644 10.0049 21.4369 10.0049 21.4094V19.9996ZM12.0049 19.6387L20.0049 18.3054V4.69387L12.0049 3.36053V19.6387ZM16.5049 13.9996C15.6765 13.9996 15.0049 12.8803 15.0049 11.4996C15.0049 10.1189 15.6765 8.99961 16.5049 8.99961C17.3333 8.99961 18.0049 10.1189 18.0049 11.4996C18.0049 12.8803 17.3333 13.9996 16.5049 13.9996Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ed6dc378609b9481(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.0049 20.3329V21.9996H18.0049V20.6663L10.5871 21.9026C10.3147 21.948 10.0571 21.764 10.0117 21.4916C10.0072 21.4644 10.0049 21.4369 10.0049 21.4094V19.9996H6.00488V21.9996H4.00488V19.9996H3.00488C2.4526 19.9996 2.00488 19.5519 2.00488 18.9996V3.99961C2.00488 3.44733 2.4526 2.99961 3.00488 2.99961H10.0049V1.58984C10.0049 1.3137 10.2287 1.08984 10.5049 1.08984C10.5324 1.08984 10.5599 1.09212 10.5871 1.09665L21.1693 2.86035C21.6515 2.94071 22.0049 3.3579 22.0049 3.84674V5.99961H23.0049V7.99961H22.0049V14.9996H23.0049V16.9996H22.0049V19.1525C22.0049 19.6413 21.6515 20.0585 21.1693 20.1389L20.0049 20.3329ZM4.00488 4.99961V17.9996H10.0049V4.99961H4.00488ZM12.0049 19.6387L20.0049 18.3054V4.69387L12.0049 3.36053V19.6387ZM16.5049 13.9996C15.6765 13.9996 15.0049 12.8803 15.0049 11.4996C15.0049 10.1189 15.6765 8.99961 16.5049 8.99961C17.3333 8.99961 18.0049 10.1189 18.0049 11.4996C18.0049 12.8803 17.3333 13.9996 16.5049 13.9996Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$14fa78e8e627293a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.0049 20H6.00488V22H4.00488V20H3.00488C2.4526 20 2.00488 19.5523 2.00488 19V4C2.00488 3.44772 2.4526 3 3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V19C22.0049 19.5523 21.5572 20 21.0049 20H20.0049V22H18.0049V20ZM11.0049 13.874V17H13.0049V13.874C14.7301 13.4299 16.0049 11.8638 16.0049 10C16.0049 7.79086 14.214 6 12.0049 6C9.79574 6 8.00488 7.79086 8.00488 10C8.00488 11.8638 9.27966 13.4299 11.0049 13.874ZM12.0049 12C10.9003 12 10.0049 11.1046 10.0049 10C10.0049 8.89543 10.9003 8 12.0049 8C13.1095 8 14.0049 8.89543 14.0049 10C14.0049 11.1046 13.1095 12 12.0049 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e7b4818b5e300c02(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.0049 20H6.00488V22H4.00488V20H3.00488C2.4526 20 2.00488 19.5523 2.00488 19V4C2.00488 3.44772 2.4526 3 3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V19C22.0049 19.5523 21.5572 20 21.0049 20H20.0049V22H18.0049V20ZM4.00488 18H20.0049V5H4.00488V18ZM13.0049 13.874V17H11.0049V13.874C9.27966 13.4299 8.00488 11.8638 8.00488 10C8.00488 7.79086 9.79574 6 12.0049 6C14.214 6 16.0049 7.79086 16.0049 10C16.0049 11.8638 14.7301 13.4299 13.0049 13.874ZM12.0049 12C13.1095 12 14.0049 11.1046 14.0049 10C14.0049 8.89543 13.1095 8 12.0049 8C10.9003 8 10.0049 8.89543 10.0049 10C10.0049 11.1046 10.9003 12 12.0049 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$308bc1ed7e3c1b53(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.0049 2L18.3032 4.28071C18.7206 4.41117 19.0049 4.79781 19.0049 5.23519V7H21.0049C21.5572 7 22.0049 7.44772 22.0049 8V10H9.00488V8C9.00488 7.44772 9.4526 7 10.0049 7H17.0049V5.97L11.0049 4.094L5.00488 5.97V13.3744C5.00488 14.6193 5.58406 15.7884 6.56329 16.5428L6.75154 16.6793L11.0049 19.579L14.7869 17H10.0049C9.4526 17 9.00488 16.5523 9.00488 16V12H22.0049V16C22.0049 16.5523 21.5572 17 21.0049 17L17.7848 17.0011C17.3982 17.5108 16.9276 17.9618 16.3849 18.3318L11.0049 22L5.62486 18.3318C3.98563 17.2141 3.00488 15.3584 3.00488 13.3744V5.23519C3.00488 4.79781 3.28913 4.41117 3.70661 4.28071L11.0049 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$771d7c3f5236a64a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.0049 2L18.3032 4.28071C18.7206 4.41117 19.0049 4.79781 19.0049 5.23519V7H21.0049C21.5572 7 22.0049 7.44772 22.0049 8V16C22.0049 16.5523 21.5572 17 21.0049 17L17.7848 17.0011C17.3982 17.5108 16.9276 17.9618 16.3849 18.3318L11.0049 22L5.62486 18.3318C3.98563 17.2141 3.00488 15.3584 3.00488 13.3744V5.23519C3.00488 4.79781 3.28913 4.41117 3.70661 4.28071L11.0049 2ZM11.0049 4.094L5.00488 5.97V13.3744C5.00488 14.6193 5.58406 15.7884 6.56329 16.5428L6.75154 16.6793L11.0049 19.579L14.7869 17H10.0049C9.4526 17 9.00488 16.5523 9.00488 16V8C9.00488 7.44772 9.4526 7 10.0049 7H17.0049V5.97L11.0049 4.094ZM11.0049 12V15H20.0049V12H11.0049ZM11.0049 10H20.0049V9H11.0049V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$345fb79afe3c08a4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.0049 22H4.00488C3.4526 22 3.00488 21.5523 3.00488 21V3C3.00488 2.44772 3.4526 2 4.00488 2H20.0049C20.5572 2 21.0049 2.44772 21.0049 3V21C21.0049 21.5523 20.5572 22 20.0049 22ZM9.00488 6H7.00488V8C7.00488 10.7614 9.24346 13 12.0049 13C14.7663 13 17.0049 10.7614 17.0049 8V6H15.0049V8C15.0049 9.65685 13.6617 11 12.0049 11C10.348 11 9.00488 9.65685 9.00488 8V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$aa5e364d0bb9cb67(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.0049 22H4.00488C3.4526 22 3.00488 21.5523 3.00488 21V3C3.00488 2.44772 3.4526 2 4.00488 2H20.0049C20.5572 2 21.0049 2.44772 21.0049 3V21C21.0049 21.5523 20.5572 22 20.0049 22ZM19.0049 20V4H5.00488V20H19.0049ZM9.00488 6V8C9.00488 9.65685 10.348 11 12.0049 11C13.6617 11 15.0049 9.65685 15.0049 8V6H17.0049V8C17.0049 10.7614 14.7663 13 12.0049 13C9.24346 13 7.00488 10.7614 7.00488 8V6H9.00488Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2b20ec1a6004995a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.50488 2H17.5049C17.8196 2 18.116 2.14819 18.3049 2.4L21.0049 6V21C21.0049 21.5523 20.5572 22 20.0049 22H4.00488C3.4526 22 3.00488 21.5523 3.00488 21V6L5.70488 2.4C5.89374 2.14819 6.19013 2 6.50488 2ZM18.5049 6L17.0049 4H7.00488L5.50488 6H18.5049ZM9.00488 10H7.00488V12C7.00488 14.7614 9.24346 17 12.0049 17C14.7663 17 17.0049 14.7614 17.0049 12V10H15.0049V12C15.0049 13.6569 13.6617 15 12.0049 15C10.348 15 9.00488 13.6569 9.00488 12V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b771c1fa63372f82(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.50488 2H17.5049C17.8196 2 18.116 2.14819 18.3049 2.4L21.0049 6V21C21.0049 21.5523 20.5572 22 20.0049 22H4.00488C3.4526 22 3.00488 21.5523 3.00488 21V6L5.70488 2.4C5.89374 2.14819 6.19013 2 6.50488 2ZM19.0049 8H5.00488V20H19.0049V8ZM18.5049 6L17.0049 4H7.00488L5.50488 6H18.5049ZM9.00488 10V12C9.00488 13.6569 10.348 15 12.0049 15C13.6617 15 15.0049 13.6569 15.0049 12V10H17.0049V12C17.0049 14.7614 14.7663 17 12.0049 17C9.24346 17 7.00488 14.7614 7.00488 12V10H9.00488Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fffe04b189ce4fc5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 0.999512C14.7663 0.999512 17.0049 3.23809 17.0049 5.99951V7.99951H20.0049C20.5572 7.99951 21.0049 8.44723 21.0049 8.99951V20.9995C21.0049 21.5518 20.5572 21.9995 20.0049 21.9995H4.00488C3.4526 21.9995 3.00488 21.5518 3.00488 20.9995V8.99951C3.00488 8.44723 3.4526 7.99951 4.00488 7.99951H7.00488V5.99951C7.00488 3.23809 9.24346 0.999512 12.0049 0.999512ZM17.0049 10.9995H15.0049V11.9995C15.0049 12.5518 15.4526 12.9995 16.0049 12.9995C16.5177 12.9995 16.9404 12.6135 16.9982 12.1161L17.0049 11.9995V10.9995ZM9.00488 10.9995H7.00488V11.9995C7.00488 12.5518 7.4526 12.9995 8.00488 12.9995C8.51772 12.9995 8.94039 12.6135 8.99815 12.1161L9.00488 11.9995V10.9995ZM12.0049 2.99951C10.4072 2.99951 9.10122 4.24843 9.00998 5.82324L9.00488 5.99951V7.99951H15.0049V5.99951C15.0049 4.40183 13.756 3.09585 12.1812 3.0046L12.0049 2.99951Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5a977e5ccb31d681(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.00488 7.99951V5.99951C7.00488 3.23809 9.24346 0.999512 12.0049 0.999512C14.7663 0.999512 17.0049 3.23809 17.0049 5.99951V7.99951H20.0049C20.5572 7.99951 21.0049 8.44723 21.0049 8.99951V20.9995C21.0049 21.5518 20.5572 21.9995 20.0049 21.9995H4.00488C3.4526 21.9995 3.00488 21.5518 3.00488 20.9995V8.99951C3.00488 8.44723 3.4526 7.99951 4.00488 7.99951H7.00488ZM7.00488 9.99951H5.00488V19.9995H19.0049V9.99951H17.0049V11.9995H15.0049V9.99951H9.00488V11.9995H7.00488V9.99951ZM9.00488 7.99951H15.0049V5.99951C15.0049 4.34266 13.6617 2.99951 12.0049 2.99951C10.348 2.99951 9.00488 4.34266 9.00488 5.99951V7.99951Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bcb4b48f0db53a0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.3709 3.43994L18.5819 9.00194L22.0049 9.00212V11.0021L20.8379 11.0019L20.0813 20.0852C20.0381 20.6035 19.6048 21.0021 19.0847 21.0021H4.92502C4.40493 21.0021 3.97166 20.6035 3.92847 20.0852L3.17088 11.0019L2.00488 11.0021V9.00212L5.42688 9.00194L8.63886 3.43994L10.3709 4.43994L7.73688 9.00194H16.2719L13.6389 4.43994L15.3709 3.43994ZM13.0049 13.0021H11.0049V17.0021H13.0049V13.0021ZM9.00488 13.0021H7.00488V17.0021H9.00488V13.0021ZM17.0049 13.0021H15.0049V17.0021H17.0049V13.0021Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ee6be0e72c70b028(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.3709 3.43994L18.5819 9.00194L22.0049 9.00212V11.0021L20.8379 11.0019L20.0813 20.0852C20.0381 20.6035 19.6048 21.0021 19.0847 21.0021H4.92502C4.40493 21.0021 3.97166 20.6035 3.92847 20.0852L3.17088 11.0019L2.00488 11.0021V9.00212L5.42688 9.00194L8.63886 3.43994L10.3709 4.43994L7.73688 9.00194H16.2719L13.6389 4.43994L15.3709 3.43994ZM18.8309 11.0019L5.17788 11.0021L5.84488 19.0021H18.1639L18.8309 11.0019ZM13.0049 13.0021V17.0021H11.0049V13.0021H13.0049ZM9.00488 13.0021V17.0021H7.00488V13.0021H9.00488ZM17.0049 13.0021V17.0021H15.0049V13.0021H17.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$62de2cefeead7629(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 2C15.3186 2 18.0049 4.68629 18.0049 8V9H22.0049V11H20.8379L20.0813 20.083C20.0381 20.6013 19.6048 21 19.0847 21H4.92502C4.40493 21 3.97166 20.6013 3.92847 20.083L3.17088 11H2.00488V9H6.00488V8C6.00488 4.68629 8.69117 2 12.0049 2ZM13.0049 13H11.0049V17H13.0049V13ZM9.00488 13H7.00488V17H9.00488V13ZM17.0049 13H15.0049V17H17.0049V13ZM12.0049 4C9.86269 4 8.1138 5.68397 8.00978 7.80036L8.00488 8V9H16.0049V8C16.0049 5.8578 14.3209 4.10892 12.2045 4.0049L12.0049 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4b09b7248f51bd4c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 2C15.3186 2 18.0049 4.68629 18.0049 8V9H22.0049V11H20.8379L20.0813 20.083C20.0381 20.6013 19.6048 21 19.0847 21H4.92502C4.40493 21 3.97166 20.6013 3.92847 20.083L3.17088 11H2.00488V9H6.00488V8C6.00488 4.68629 8.69117 2 12.0049 2ZM18.8309 11H5.17788L5.84488 19H18.1639L18.8309 11ZM13.0049 13V17H11.0049V13H13.0049ZM9.00488 13V17H7.00488V13H9.00488ZM17.0049 13V17H15.0049V13H17.0049ZM12.0049 4C9.86269 4 8.1138 5.68397 8.00978 7.80036L8.00488 8V9H16.0049V8C16.0049 5.8578 14.3209 4.10892 12.2045 4.0049L12.0049 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$474cb5f767467462(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.00436 6.41662L0.761719 3.17398L2.17593 1.75977L5.41857 5.00241H20.6603C21.2126 5.00241 21.6603 5.45012 21.6603 6.00241C21.6603 6.09973 21.6461 6.19653 21.6182 6.28975L19.2182 14.2898C19.0913 14.7127 18.7019 15.0024 18.2603 15.0024H6.00436V17.0024H17.0044V19.0024H5.00436C4.45207 19.0024 4.00436 18.5547 4.00436 18.0024V6.41662ZM5.50436 23.0024C4.67593 23.0024 4.00436 22.3308 4.00436 21.5024C4.00436 20.674 4.67593 20.0024 5.50436 20.0024C6.33279 20.0024 7.00436 20.674 7.00436 21.5024C7.00436 22.3308 6.33279 23.0024 5.50436 23.0024ZM17.5044 23.0024C16.6759 23.0024 16.0044 22.3308 16.0044 21.5024C16.0044 20.674 16.6759 20.0024 17.5044 20.0024C18.3328 20.0024 19.0044 20.674 19.0044 21.5024C19.0044 22.3308 18.3328 23.0024 17.5044 23.0024Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a6432c866002804f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.00436 6.41662L0.761719 3.17398L2.17593 1.75977L5.41857 5.00241H20.6603C21.2126 5.00241 21.6603 5.45012 21.6603 6.00241C21.6603 6.09973 21.6461 6.19653 21.6182 6.28975L19.2182 14.2898C19.0913 14.7127 18.7019 15.0024 18.2603 15.0024H6.00436V17.0024H17.0044V19.0024H5.00436C4.45207 19.0024 4.00436 18.5547 4.00436 18.0024V6.41662ZM6.00436 7.00241V13.0024H17.5163L19.3163 7.00241H6.00436ZM5.50436 23.0024C4.67593 23.0024 4.00436 22.3308 4.00436 21.5024C4.00436 20.674 4.67593 20.0024 5.50436 20.0024C6.33279 20.0024 7.00436 20.674 7.00436 21.5024C7.00436 22.3308 6.33279 23.0024 5.50436 23.0024ZM17.5044 23.0024C16.6759 23.0024 16.0044 22.3308 16.0044 21.5024C16.0044 20.674 16.6759 20.0024 17.5044 20.0024C18.3328 20.0024 19.0044 20.674 19.0044 21.5024C19.0044 22.3308 18.3328 23.0024 17.5044 23.0024Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$19db079feea998de(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.00488 9H19.9433L20.4433 7H8.00488V5H21.7241C22.2764 5 22.7241 5.44772 22.7241 6C22.7241 6.08176 22.7141 6.16322 22.6942 6.24254L20.1942 16.2425C20.083 16.6877 19.683 17 19.2241 17H5.00488C4.4526 17 4.00488 16.5523 4.00488 16V4H2.00488V2H5.00488C5.55717 2 6.00488 2.44772 6.00488 3V9ZM6.00488 23C4.90031 23 4.00488 22.1046 4.00488 21C4.00488 19.8954 4.90031 19 6.00488 19C7.10945 19 8.00488 19.8954 8.00488 21C8.00488 22.1046 7.10945 23 6.00488 23ZM18.0049 23C16.9003 23 16.0049 22.1046 16.0049 21C16.0049 19.8954 16.9003 19 18.0049 19C19.1095 19 20.0049 19.8954 20.0049 21C20.0049 22.1046 19.1095 23 18.0049 23Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$20b7671d4e7fcb9d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.00488 16V4H2.00488V2H5.00488C5.55717 2 6.00488 2.44772 6.00488 3V15H18.4433L20.4433 7H8.00488V5H21.7241C22.2764 5 22.7241 5.44772 22.7241 6C22.7241 6.08176 22.7141 6.16322 22.6942 6.24254L20.1942 16.2425C20.083 16.6877 19.683 17 19.2241 17H5.00488C4.4526 17 4.00488 16.5523 4.00488 16ZM6.00488 23C4.90031 23 4.00488 22.1046 4.00488 21C4.00488 19.8954 4.90031 19 6.00488 19C7.10945 19 8.00488 19.8954 8.00488 21C8.00488 22.1046 7.10945 23 6.00488 23ZM18.0049 23C16.9003 23 16.0049 22.1046 16.0049 21C16.0049 19.8954 16.9003 19 18.0049 19C19.1095 19 20.0049 19.8954 20.0049 21C20.0049 22.1046 19.1095 23 18.0049 23Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e1b04a33d3afb0af(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.00488 5.00293H11.0049V14.0029H8.00488V17.0029H6.00488V14.0029H3.00488V5.00293H6.00488V2.00293H8.00488V5.00293ZM18.0049 10.0029H21.0049V19.0029H18.0049V22.0029H16.0049V19.0029H13.0049V10.0029H16.0049V7.00293H18.0049V10.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$796a5d888bbc95b6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.00488 5.00293H11.0049V14.0029H8.00488V17.0029H6.00488V14.0029H3.00488V5.00293H6.00488V2.00293H8.00488V5.00293ZM5.00488 7.00293V12.0029H9.00488V7.00293H5.00488ZM18.0049 10.0029H21.0049V19.0029H18.0049V22.0029H16.0049V19.0029H13.0049V10.0029H16.0049V7.00293H18.0049V10.0029ZM15.0049 12.0029V17.0029H19.0049V12.0029H15.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dd1f17ed37aa4863(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 3.00293H21.0049C21.5572 3.00293 22.0049 3.45064 22.0049 4.00293V20.0029C22.0049 20.5552 21.5572 21.0029 21.0049 21.0029H3.00488C2.4526 21.0029 2.00488 20.5552 2.00488 20.0029V4.00293C2.00488 3.45064 2.4526 3.00293 3.00488 3.00293ZM15.0049 7.00293V9.00293H11.0049V11.0029H15.0049V13.0029L18.5049 10.0029L15.0049 7.00293ZM9.00488 17.0029V15.0029H13.0049V13.0029H9.00488V11.0029L5.50488 14.0029L9.00488 17.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d920fbd14eb8c180(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.00488 5.00293V19.0029H20.0049V5.00293H4.00488ZM3.00488 3.00293H21.0049C21.5572 3.00293 22.0049 3.45064 22.0049 4.00293V20.0029C22.0049 20.5552 21.5572 21.0029 21.0049 21.0029H3.00488C2.4526 21.0029 2.00488 20.5552 2.00488 20.0029V4.00293C2.00488 3.45064 2.4526 3.00293 3.00488 3.00293ZM15.0049 7.00293L18.5049 10.0029L15.0049 13.0029V11.0029H11.0049V9.00293H15.0049V7.00293ZM9.00488 17.0029L5.50488 14.0029L9.00488 11.0029V13.0029H13.0049V15.0029H9.00488V17.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a2fd6f068cde54b8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM7.00488 9.00293H9.00488V13.0029H11.0049V9.00293H13.0049L10.0049 5.50293L7.00488 9.00293ZM17.0049 15.0029H15.0049V11.0029H13.0049V15.0029H11.0049L14.0049 18.5029L17.0049 15.0029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f50138577808b74c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM12.0049 20.0029C16.4232 20.0029 20.0049 16.4212 20.0049 12.0029C20.0049 7.58465 16.4232 4.00293 12.0049 4.00293C7.5866 4.00293 4.00488 7.58465 4.00488 12.0029C4.00488 16.4212 7.5866 20.0029 12.0049 20.0029ZM7.00488 9.00293L10.0049 5.50293L13.0049 9.00293H11.0049V13.0029H9.00488V9.00293H7.00488ZM17.0049 15.0029L14.0049 18.5029L11.0049 15.0029H13.0049V11.0029H15.0049V15.0029H17.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$747f880eb03d4045(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.0049 2.99951C21.5572 2.99951 22.0049 3.44723 22.0049 3.99951V9.49951C20.6242 9.49951 19.5049 10.6188 19.5049 11.9995C19.5049 13.3802 20.6242 14.4995 22.0049 14.4995V19.9995C22.0049 20.5518 21.5572 20.9995 21.0049 20.9995H3.00488C2.4526 20.9995 2.00488 20.5518 2.00488 19.9995V14.4995C3.38559 14.4995 4.50488 13.3802 4.50488 11.9995C4.50488 10.6188 3.38559 9.49951 2.00488 9.49951V3.99951C2.00488 3.44723 2.4526 2.99951 3.00488 2.99951H21.0049ZM16.0049 8.99951H8.00488V14.9995H16.0049V8.99951Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$21e06f3305b1931f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.0049 3C21.5572 3 22.0049 3.44772 22.0049 4V9.5C20.6242 9.5 19.5049 10.6193 19.5049 12C19.5049 13.3807 20.6242 14.5 22.0049 14.5V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V14.5C3.38559 14.5 4.50488 13.3807 4.50488 12C4.50488 10.6193 3.38559 9.5 2.00488 9.5V4C2.00488 3.44772 2.4526 3 3.00488 3H21.0049ZM20.0049 5H4.00488V7.968L4.16077 8.04908C5.49935 8.78105 6.42516 10.1735 6.49998 11.7882L6.50488 12C6.50488 13.7042 5.55755 15.1871 4.16077 15.9509L4.00488 16.031V19H20.0049V16.031L19.849 15.9509C18.5104 15.219 17.5846 13.8265 17.5098 12.2118L17.5049 12C17.5049 10.2958 18.4522 8.81287 19.849 8.04908L20.0049 7.968V5ZM16.0049 9V15H8.00488V9H16.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c8c5ed55f34f5d0c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.0049 2.99951C21.5572 2.99951 22.0049 3.44723 22.0049 3.99951V9.49951C20.6242 9.49951 19.5049 10.6188 19.5049 11.9995C19.5049 13.3802 20.6242 14.4995 22.0049 14.4995V19.9995C22.0049 20.5518 21.5572 20.9995 21.0049 20.9995H3.00488C2.4526 20.9995 2.00488 20.5518 2.00488 19.9995V14.4995C3.38559 14.4995 4.50488 13.3802 4.50488 11.9995C4.50488 10.6188 3.38559 9.49951 2.00488 9.49951V3.99951C2.00488 3.44723 2.4526 2.99951 3.00488 2.99951H21.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7c5462ca14e4bc07(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.0049 3C21.5572 3 22.0049 3.44772 22.0049 4V9.5C20.6242 9.5 19.5049 10.6193 19.5049 12C19.5049 13.3807 20.6242 14.5 22.0049 14.5V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V14.5C3.38559 14.5 4.50488 13.3807 4.50488 12C4.50488 10.6193 3.38559 9.5 2.00488 9.5V4C2.00488 3.44772 2.4526 3 3.00488 3H21.0049ZM20.0049 5H4.00488V7.968L4.16077 8.04908C5.49935 8.78105 6.42516 10.1735 6.49998 11.7882L6.50488 12C6.50488 13.7042 5.55755 15.1871 4.16077 15.9509L4.00488 16.031V19H20.0049V16.031L19.849 15.9509C18.5104 15.219 17.5846 13.8265 17.5098 12.2118L17.5049 12C17.5049 10.2958 18.4522 8.81287 19.849 8.04908L20.0049 7.968V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$538d759336c1a6ca(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.5 9C21.5 11.7039 19.849 14.0223 17.5 15.0018L17.5 15C17.5 10.3056 13.6944 6.5 9.00001 6.5L8.99817 6.5C9.97773 4.15105 12.2961 2.5 15 2.5C18.5899 2.5 21.5 5.41015 21.5 9ZM7 3C4.79086 3 3 4.79086 3 7V8.5H5V7C5 5.89543 5.89543 5 7 5H8.5V3H7ZM19 15.5V17C19 18.1046 18.1046 19 17 19H15.5V21H17C19.2091 21 21 19.2091 21 17V15.5H19ZM9 21.5C12.5899 21.5 15.5 18.5899 15.5 15C15.5 11.4101 12.5899 8.5 9 8.5C5.41015 8.5 2.5 11.4101 2.5 15C2.5 18.5899 5.41015 21.5 9 21.5ZM9 12.5L11.5 15L9 17.5L6.5 15L9 12.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$756c9ab8395ec17a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12.5 6.5 15 9 17.5 11.5 15 9 12.5ZM15 2.5C11.5724 2.5 8.76444 5.15304 8.51763 8.51763 5.15304 8.76445 2.5 11.5724 2.5 15 2.5 18.5899 5.41015 21.5 9 21.5 12.4276 21.5 15.2356 18.847 15.4824 15.4824 18.847 15.2356 21.5 12.4276 21.5 9 21.5 5.41015 18.5899 2.5 15 2.5ZM15.3234 13.4886C14.7575 11.1126 12.8874 9.24245 10.5114 8.67665 10.6772 6.34229 12.6234 4.5 15 4.5 17.4853 4.5 19.5 6.51472 19.5 9 19.5 11.3766 17.6577 13.3228 15.3234 13.4886ZM13.5 15C13.5 17.4853 11.4853 19.5 9 19.5 6.51472 19.5 4.5 17.4853 4.5 15 4.5 12.5147 6.51472 10.5 9 10.5 11.4853 10.5 13.5 12.5147 13.5 15ZM3 7C3 4.79086 4.79086 3 7 3H8.5V5H7C5.89543 5 5 5.89543 5 7V8.5H3V7ZM19 17V15.5H21V17C21 19.2091 19.2091 21 17 21H15.5V19H17C18.1046 19 19 18.1046 19 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d86c336289516186(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.0049 16.941V19.0029H18.0049V21.0029H6.00488V19.0029H11.0049V16.941C7.05857 16.4489 4.00488 13.0825 4.00488 9.00293V3.00293H20.0049V9.00293C20.0049 13.0825 16.9512 16.4489 13.0049 16.941ZM1.00488 5.00293H3.00488V9.00293H1.00488V5.00293ZM21.0049 5.00293H23.0049V9.00293H21.0049V5.00293Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8a3f16355f062535(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.0049 16.941V19.0029H18.0049V21.0029H6.00488V19.0029H11.0049V16.941C7.05857 16.4489 4.00488 13.0825 4.00488 9.00293V3.00293H20.0049V9.00293C20.0049 13.0825 16.9512 16.4489 13.0049 16.941ZM6.00488 5.00293V9.00293C6.00488 12.3166 8.69117 15.0029 12.0049 15.0029C15.3186 15.0029 18.0049 12.3166 18.0049 9.00293V5.00293H6.00488ZM1.00488 5.00293H3.00488V9.00293H1.00488V5.00293ZM21.0049 5.00293H23.0049V9.00293H21.0049V5.00293Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3377b7ed1031916f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.80577 5.20031L7.00505 7.99983L11.1913 2.13905C11.5123 1.68964 12.1369 1.58555 12.5863 1.90656C12.6761 1.9707 12.7546 2.04926 12.8188 2.13905L17.0051 7.99983L21.2043 5.20031C21.6639 4.89395 22.2847 5.01813 22.5911 5.47766C22.7228 5.67527 22.7799 5.91332 22.7522 6.1492L21.109 20.1167C21.0497 20.6203 20.6229 20.9998 20.1158 20.9998H3.8943C3.38722 20.9998 2.9604 20.6203 2.90115 20.1167L1.25792 6.1492C1.19339 5.6007 1.58573 5.10374 2.13423 5.03921C2.37011 5.01146 2.60816 5.06856 2.80577 5.20031ZM12.0051 14.9998C13.1096 14.9998 14.0051 14.1044 14.0051 12.9998C14.0051 11.8953 13.1096 10.9998 12.0051 10.9998C10.9005 10.9998 10.0051 11.8953 10.0051 12.9998C10.0051 14.1044 10.9005 14.9998 12.0051 14.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7084d7dcefe0406f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.49709 8.06489L4.78355 18.9998H19.2266L20.513 8.06489L16.5032 10.7381L12.0051 4.44076L7.50694 10.7381L3.49709 8.06489ZM2.80577 5.20031L7.00505 7.99983L11.1913 2.13905C11.5123 1.68964 12.1369 1.58555 12.5863 1.90656C12.6761 1.9707 12.7546 2.04926 12.8188 2.13905L17.0051 7.99983L21.2043 5.20031C21.6639 4.89395 22.2847 5.01813 22.5911 5.47766C22.7228 5.67527 22.7799 5.91332 22.7522 6.1492L21.109 20.1167C21.0497 20.6203 20.6229 20.9998 20.1158 20.9998H3.8943C3.38722 20.9998 2.9604 20.6203 2.90115 20.1167L1.25792 6.1492C1.19339 5.6007 1.58573 5.10374 2.13423 5.03921C2.37011 5.01146 2.60816 5.06856 2.80577 5.20031ZM12.0051 14.9998C10.9005 14.9998 10.0051 14.1044 10.0051 12.9998C10.0051 11.8953 10.9005 10.9998 12.0051 10.9998C13.1096 10.9998 14.0051 11.8953 14.0051 12.9998C14.0051 14.1044 13.1096 14.9998 12.0051 14.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$638a7c7fbf8f9511(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.00488 19H22.0049V21H2.00488V19ZM2.00488 5L7.00488 8L12.0049 2L17.0049 8L22.0049 5V17H2.00488V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$531f050c50f052f0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.00488 19H22.0049V21H2.00488V19ZM2.00488 5L7.00488 8.5L12.0049 2L17.0049 8.5L22.0049 5V17H2.00488V5ZM4.00488 8.84131V15H20.0049V8.84131L16.5854 11.2349L12.0049 5.28024L7.42435 11.2349L4.00488 8.84131Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8c547d1f96ed949(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.87759 3.00293H19.1319C19.4518 3.00293 19.7524 3.15601 19.9406 3.41476L23.7634 8.67115C23.9037 8.86403 23.8882 9.12913 23.7265 9.30438L12.3721 21.6049C12.1848 21.8078 11.8685 21.8205 11.6656 21.6332C11.6558 21.6241 11.6464 21.6147 11.6373 21.6049L0.282992 9.30438C0.121226 9.12913 0.10575 8.86403 0.246026 8.67115L4.06886 3.41476C4.25704 3.15601 4.55766 3.00293 4.87759 3.00293Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$226505832ac580e7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.87759 3.00293H19.1319C19.4518 3.00293 19.7524 3.15601 19.9406 3.41476L23.7634 8.67115C23.9037 8.86403 23.8882 9.12913 23.7265 9.30438L12.3721 21.6049C12.1848 21.8078 11.8685 21.8205 11.6656 21.6332C11.6591 21.6271 7.86486 17.5175 0.282992 9.30438C0.121226 9.12913 0.10575 8.86403 0.246026 8.67115L4.06886 3.41476C4.25704 3.15601 4.55766 3.00293 4.87759 3.00293ZM5.38682 5.00293L2.58738 8.85216L12.0047 19.0543L21.4221 8.85216L18.6226 5.00293H5.38682Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$14c742b81f31e183(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V4C2.00488 3.44772 2.4526 3 3.00488 3ZM11.0049 8.5V15.5H13.0049V8.5H11.0049ZM10.72 8.5H8.60604L7.10912 12.6127L5.61221 8.5H3.49827L6.10912 15.4637H8.10912L10.72 8.5ZM16.0049 13.5H17.5049C18.8856 13.5 20.0049 12.3807 20.0049 11C20.0049 9.61929 18.8856 8.5 17.5049 8.5H14.0049V15.5H16.0049V13.5ZM16.0049 11.5V10.5H17.5049C17.781 10.5 18.0049 10.7239 18.0049 11C18.0049 11.2761 17.781 11.5 17.5049 11.5H16.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$809cc902d2b5e9ba(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.00488 19H22.0049V21H2.00488V19ZM11.0049 8H13.0049V16H11.0049V8ZM7.97001 8L6.10912 13.1127L4.24824 8H2.12334L5.10912 15.9637H7.10912L10.0949 8H7.97001ZM17.0049 14V16H15.0049V8H19.0049C20.6617 8 22.0049 9.34315 22.0049 11C22.0049 12.6569 20.6617 14 19.0049 14H17.0049ZM17.0049 10V12H19.0049C19.5572 12 20.0049 11.5523 20.0049 11C20.0049 10.4477 19.5572 10 19.0049 10H17.0049ZM2.00488 3H22.0049V5H2.00488V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c45ae4d9a3a59a3a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.0049 8H13.0049C12.4526 8 12.0049 8.44772 12.0049 9V15C12.0049 15.5523 12.4526 16 13.0049 16H22.0049V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V4C2.00488 3.44772 2.4526 3 3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V8ZM15.0049 11H18.0049V13H15.0049V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$79e3a32637b31755(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.0049 7V5H4.00488V19H20.0049V17H12.0049C11.4526 17 11.0049 16.5523 11.0049 16V8C11.0049 7.44772 11.4526 7 12.0049 7H20.0049ZM3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V4C2.00488 3.44772 2.4526 3 3.00488 3ZM13.0049 9V15H20.0049V9H13.0049ZM15.0049 11H18.0049V13H15.0049V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$626bf737b4bffaac(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.0049 6H15.0049C11.6912 6 9.00488 8.68629 9.00488 12C9.00488 15.3137 11.6912 18 15.0049 18H22.0049V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V4C2.00488 3.44772 2.4526 3 3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V6ZM15.0049 8H23.0049V16H15.0049C12.7957 16 11.0049 14.2091 11.0049 12C11.0049 9.79086 12.7957 8 15.0049 8ZM15.0049 11V13H18.0049V11H15.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fea3a09a1ecd587a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.0049 7H23.0049V17H22.0049V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V4C2.00488 3.44772 2.4526 3 3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V7ZM20.0049 17H14.0049C11.2435 17 9.00488 14.7614 9.00488 12C9.00488 9.23858 11.2435 7 14.0049 7H20.0049V5H4.00488V19H20.0049V17ZM21.0049 15V9H14.0049C12.348 9 11.0049 10.3431 11.0049 12C11.0049 13.6569 12.348 15 14.0049 15H21.0049ZM14.0049 11H17.0049V13H14.0049V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$53d6fa2d77b31228(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.00488 9H21.0049C21.5572 9 22.0049 9.44772 22.0049 10V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V9ZM3.00488 3H18.0049V7H2.00488V4C2.00488 3.44772 2.4526 3 3.00488 3ZM15.0049 14V16H18.0049V14H15.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a8cae55ca5c5bbfc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.0049 7H21.0049C21.5572 7 22.0049 7.44772 22.0049 8V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V4C2.00488 3.44772 2.4526 3 3.00488 3H18.0049V7ZM4.00488 9V19H20.0049V9H4.00488ZM4.00488 5V7H16.0049V5H4.00488ZM15.0049 13H18.0049V15H15.0049V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2378c9a68d274017(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.64092 6.63886L12.0049 0.274902L18.3688 6.63886C21.8836 10.1536 21.8836 15.8521 18.3688 19.3668C14.8541 22.8815 9.15564 22.8815 5.64092 19.3668C2.1262 15.8521 2.1262 10.1536 5.64092 6.63886H5.64092ZM13.0049 11.0028V6.50282L8.50488 13.0028H11.0049V17.5028L15.5049 11.0028H13.0049Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dd31faecb4f66b82(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0049 3.10333L7.05514 8.05308C4.32147 10.7867 4.32147 15.2189 7.05514 17.9526C9.78881 20.6862 14.221 20.6862 16.9546 17.9526C19.6883 15.2189 19.6883 10.7867 16.9546 8.05308L12.0049 3.10333ZM12.0049 0.274902L18.3688 6.63886C21.8836 10.1536 21.8836 15.8521 18.3688 19.3668C14.8541 22.8815 9.15564 22.8815 5.64092 19.3668C2.1262 15.8521 2.1262 10.1536 5.64092 6.63886L12.0049 0.274902ZM13.0049 11.0028H15.5049L11.0049 17.5028V13.0028H8.50488L13.0049 6.50282V11.0028Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f129a4e884af66e3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2.53513C10.4117 2.19479 9.72857 2 9 2 6.79086 2 5 3.79086 5 6V7.77422C4.14895 8.11644 3.45143 8.64785 2.94126 9.34933 2.29239 10.2415 2 11.3347 2 12.5 2 14.0614 2.79529 15.4356 4 16.242V17.5C4 19.9853 6.01472 22 8.5 22 9.42507 22 10.285 21.7209 11 21.2422V17.5C11 16.167 10.67 15.3147 10.1402 14.7408 9.59743 14.1528 8.71622 13.7165 7.3356 13.4864L7.6644 11.5136C8.96602 11.7305 10.1058 12.1373 11 12.8271V2.53513ZM13 2.53513V12.8271C13.8942 12.1373 15.034 11.7305 16.3356 11.5136L16.6644 13.4864C15.2838 13.7165 14.4026 14.1528 13.8598 14.7408 13.33 15.3147 13 16.167 13 17.5V21.2422C13.715 21.7209 14.5749 22 15.5 22 17.9853 22 20 19.9853 20 17.5V16.242C21.2047 15.4356 22 14.0614 22 12.5 22 11.3347 21.7076 10.2415 21.0587 9.34933 20.5486 8.64785 19.8511 8.11644 19 7.77422V6C19 3.79086 17.2091 2 15 2 14.2714 2 13.5883 2.19479 13 2.53513Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$314afc5fc37da632(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4C10.1046 4 11 4.89543 11 6V12.8271C10.1058 12.1373 8.96602 11.7305 7.6644 11.5136L7.3356 13.4864C8.71622 13.7165 9.59743 14.1528 10.1402 14.7408C10.67 15.3147 11 16.167 11 17.5C11 18.8807 9.88071 20 8.5 20C7.11929 20 6 18.8807 6 17.5V17.1493C6.43007 17.2926 6.87634 17.4099 7.3356 17.4864L7.6644 15.5136C6.92149 15.3898 6.1752 15.1144 5.42909 14.7599C4.58157 14.3573 4 13.499 4 12.5C4 11.6653 4.20761 11.0085 4.55874 10.5257C4.90441 10.0504 5.4419 9.6703 6.24254 9.47014L7 9.28078V6C7 4.89543 7.89543 4 9 4ZM12 3.35418C11.2671 2.52376 10.1947 2 9 2C6.79086 2 5 3.79086 5 6V7.77422C4.14895 8.11644 3.45143 8.64785 2.94126 9.34933C2.29239 10.2415 2 11.3347 2 12.5C2 14.0652 2.79565 15.4367 4 16.2422V17.5C4 19.9853 6.01472 22 8.5 22C9.91363 22 11.175 21.3482 12 20.3287C12.825 21.3482 14.0864 22 15.5 22C17.9853 22 20 19.9853 20 17.5V16.2422C21.2044 15.4367 22 14.0652 22 12.5C22 11.3347 21.7076 10.2415 21.0587 9.34933C20.5486 8.64785 19.8511 8.11644 19 7.77422V6C19 3.79086 17.2091 2 15 2C13.8053 2 12.7329 2.52376 12 3.35418ZM18 17.1493V17.5C18 18.8807 16.8807 20 15.5 20C14.1193 20 13 18.8807 13 17.5C13 16.167 13.33 15.3147 13.8598 14.7408C14.4026 14.1528 15.2838 13.7165 16.6644 13.4864L16.3356 11.5136C15.034 11.7305 13.8942 12.1373 13 12.8271V6C13 4.89543 13.8954 4 15 4C16.1046 4 17 4.89543 17 6V9.28078L17.7575 9.47014C18.5581 9.6703 19.0956 10.0504 19.4413 10.5257C19.7924 11.0085 20 11.6653 20 12.5C20 13.499 19.4184 14.3573 18.5709 14.7599C17.8248 15.1144 17.0785 15.3898 16.3356 15.5136L16.6644 17.4864C17.1237 17.4099 17.5699 17.2926 18 17.1493Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$575ac4fb8a9d8bc8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.7786 4.22171C22.1217 6.56486 22.1217 10.3639 19.7786 12.707L17.6565 14.8276L12.7075 19.7781C10.3643 22.1212 6.56535 22.1212 4.2222 19.7781C1.87906 17.4349 1.87906 13.6359 4.2222 11.2928L11.2933 4.22171C13.6364 1.87857 17.4354 1.87857 19.7786 4.22171ZM14.8288 14.8283L9.17195 9.17146L5.63642 12.707C4.07432 14.2691 4.07432 16.8018 5.63642 18.3638C7.19851 19.9259 9.73117 19.9259 11.2933 18.3638L14.8288 14.8283Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dcc7332a923a0b72(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.7786 4.22171C22.1217 6.56486 22.1217 10.3639 19.7786 12.707L12.7075 19.7781C10.3643 22.1212 6.56535 22.1212 4.2222 19.7781C1.87906 17.4349 1.87906 13.6359 4.2222 11.2928L11.2933 4.22171C13.6364 1.87857 17.4354 1.87857 19.7786 4.22171ZM14.1224 15.5347L8.46555 9.87786L5.63642 12.707C4.07432 14.2691 4.07432 16.8018 5.63642 18.3638C7.19851 19.9259 9.73117 19.9259 11.2933 18.3638L14.1224 15.5347ZM18.3643 5.63593C16.8022 4.07383 14.2696 4.07383 12.7075 5.63593L9.87976 8.46365L15.5366 14.1205L18.3643 11.2928C19.9264 9.73069 19.9264 7.19803 18.3643 5.63593Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4de3a5a7d786238(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.80777 1.39355L21.1925 19.7783L19.7783 21.1925L16.0316 17.4456L12 21.4852L3.52154 12.9932C1.48186 10.7095 1.49309 7.2403 3.55524 4.96974L1.39355 2.80777L2.80777 1.39355ZM20.2428 4.75752C22.5054 7.02488 22.5831 10.6372 20.4788 12.9932L18.8442 14.6292L7.2604 3.04566C8.92926 2.8395 10.6682 3.33385 12.0011 4.52869C14.3502 2.42016 17.9802 2.49016 20.2428 4.75752Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d4db7d507c863d85(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.80777 1.39355L21.1925 19.7783L19.7783 21.1925L16.0316 17.4456L12 21.4852L3.52154 12.9932C1.48186 10.7095 1.49309 7.2403 3.55524 4.96974L1.39355 2.80777L2.80777 1.39355ZM4.98009 11.6233L12 18.6545L14.6176 16.0316L4.97206 6.38638C3.67816 7.8828 3.67138 10.1211 4.98009 11.6233ZM20.2428 4.75752C22.5054 7.02488 22.5831 10.6372 20.4788 12.9932L18.8442 14.6292L17.4302 13.2152L19.0202 11.6233C20.3937 10.0469 20.3191 7.66541 18.8271 6.17026C17.3281 4.66809 14.9078 4.60717 13.3371 6.01703L12.0021 7.21539L10.6662 6.01796C10.3163 5.70431 9.92487 5.4634 9.51117 5.29488L7.2604 3.04566C8.92926 2.8395 10.6682 3.33385 12.0011 4.52869C14.3502 2.42016 17.9802 2.49016 20.2428 4.75752Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ec0a24e0300e119e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2V4H20C20.5523 4 21 4.44772 21 5V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V5C3 4.44772 3.44772 4 4 4H7V2H17ZM13 11H11V13H9V15H10.999L11 17H13L12.999 15H15V13H13V11ZM15 4H9V6H15V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1283386949af90bd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2V4H20C20.5523 4 21 4.44772 21 5V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V5C3 4.44772 3.44772 4 4 4H7V2H17ZM7 6H5V20H19V6H17V8H7V6ZM13 11V13H15V15H12.999L13 17H11L10.999 15H9V13H11V11H13ZM15 4H9V6H15V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1f1e8b209205b96e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.3643 10.9792C19.9264 12.5413 19.9264 15.0739 18.3643 16.636L12.7075 22.2929C12.317 22.6834 11.6838 22.6834 11.2933 22.2929L5.63642 16.636C4.07432 15.0739 4.07432 12.5413 5.63642 10.9792C7.19851 9.41709 9.73117 9.41709 11.2933 10.9792L11.9997 11.6856L12.7075 10.9792C14.2696 9.41709 16.8022 9.41709 18.3643 10.9792ZM12.0004 1C14.2095 1 16.0004 2.79086 16.0004 5C16.0004 7.20914 14.2095 9 12.0004 9C9.79124 9 8.00038 7.20914 8.00038 5C8.00038 2.79086 9.79124 1 12.0004 1Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1606be2471748805(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.3643 10.9792C19.9264 12.5413 19.9264 15.0739 18.3643 16.636L12.7075 22.2929C12.317 22.6834 11.6838 22.6834 11.2933 22.2929L5.63642 16.636C4.07432 15.0739 4.07432 12.5413 5.63642 10.9792C7.19851 9.41709 9.73117 9.41709 11.2933 10.9792L11.9997 11.6856L12.7075 10.9792C14.2696 9.41709 16.8022 9.41709 18.3643 10.9792ZM7.05063 12.3934C6.26958 13.1744 6.26958 14.4408 7.05063 15.2218L12.0004 20.1716L16.9501 15.2218C17.7312 14.4408 17.7312 13.1744 16.9501 12.3934C16.1691 11.6123 14.9027 11.6123 14.1203 12.3948L11.9983 14.5126L9.87906 12.3934C9.09801 11.6123 7.83168 11.6123 7.05063 12.3934ZM12.0004 1C14.2095 1 16.0004 2.79086 16.0004 5C16.0004 7.20914 14.2095 9 12.0004 9C9.79124 9 8.00038 7.20914 8.00038 5C8.00038 2.79086 9.79124 1 12.0004 1ZM12.0004 3C10.8958 3 10.0004 3.89543 10.0004 5C10.0004 6.10457 10.8958 7 12.0004 7C13.1049 7 14.0004 6.10457 14.0004 5C14.0004 3.89543 13.1049 3 12.0004 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7bb37e03655f511d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7V2C7 1.44772 7.44772 1 8 1H16ZM13 9H11V12H8V14H10.999L11 17H13L12.999 14H16V12H13V9ZM15 3H9V5H15V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7fe9ad6071b66fd8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7V2C7 1.44772 7.44772 1 8 1H16ZM20 7H4V19H20V7ZM13 9V12H16V14H12.999L13 17H11L10.999 14H8V12H11V9H13ZM15 3H9V5H15V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$181fdbb4990aef91(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.9994 2V4H14.9994V7.24291C14.9994 8.40051 15.2506 9.54432 15.7357 10.5954L20.017 19.8714C20.3641 20.6236 20.0358 21.5148 19.2836 21.8619C19.0865 21.9529 18.8721 22 18.655 22H5.34375C4.51532 22 3.84375 21.3284 3.84375 20.5C3.84375 20.2829 3.89085 20.0685 3.98181 19.8714L8.26306 10.5954C8.74816 9.54432 8.99939 8.40051 8.99939 7.24291V4H7.99939V2H15.9994ZM12.9994 4H10.9994V8H12.9994V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d5ded2d4cd9fa426(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.9994 2V4H14.9994V7.24291C14.9994 8.40051 15.2506 9.54432 15.7357 10.5954L20.017 19.8714C20.3641 20.6236 20.0358 21.5148 19.2836 21.8619C19.0865 21.9529 18.8721 22 18.655 22H5.34375C4.51532 22 3.84375 21.3284 3.84375 20.5C3.84375 20.2829 3.89085 20.0685 3.98181 19.8714L8.26306 10.5954C8.74816 9.54432 8.99939 8.40051 8.99939 7.24291V4H7.99939V2H15.9994ZM13.3873 10.0012H10.6115C10.5072 10.3644 10.3823 10.7221 10.2371 11.0724L10.079 11.4335L6.12439 20H17.8734L13.9198 11.4335C13.7054 10.9691 13.5276 10.4902 13.3873 10.0012ZM10.9994 7.24291C10.9994 7.49626 10.9898 7.7491 10.9706 8.00087H13.0282C13.0189 7.87982 13.0119 7.75852 13.0072 7.63704L12.9994 7.24291V4H10.9994V7.24291Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3ceb039f12259555(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0002 2V4L13.0002 3.999V6H16.0002V8C18.2093 8 20.0002 9.79086 20.0002 12V20C20.0002 21.1046 19.1048 22 18.0002 22H6.0002C4.89563 22 4.0002 21.1046 4.0002 20V12C4.0002 9.79086 5.79106 8 8.0002 8V6H11.0002V3.999L7.5002 4C6.8702 4 6.1302 4.49 5.3002 5.6L3.7002 4.4C4.8702 2.84 6.1302 2 7.5002 2H17.0002ZM13.0002 12H11.0002V14H9.0002V16H10.9992L11.0002 18H13.0002L12.9992 16H15.0002V14H13.0002V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$84f2d10309d12b98(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0002 2V4L13.0002 3.999V6H16.0002V8C18.2093 8 20.0002 9.79086 20.0002 12V20C20.0002 21.1046 19.1048 22 18.0002 22H6.0002C4.89563 22 4.0002 21.1046 4.0002 20V12C4.0002 9.79086 5.79106 8 8.0002 8V6H11.0002V3.999L7.5002 4C6.8702 4 6.1302 4.49 5.3002 5.6L3.7002 4.4C4.8702 2.84 6.1302 2 7.5002 2H17.0002ZM16.0002 10H8.0002C6.89563 10 6.0002 10.8954 6.0002 12V20H18.0002V12C18.0002 10.8954 17.1048 10 16.0002 10ZM13.0002 12V14H15.0002V16H12.9992L13.0002 18H11.0002L10.9992 16H9.0002V14H11.0002V12H13.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b78ead5c88f7add9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H6C5.44772 22 5 21.5523 5 21V19H3V17H5V15H3V13H5V11H3V9H5V7H3V5H5V3C5 2.44772 5.44772 2 6 2H20ZM14 8H12V11H9V13H11.999L12 16H14L13.999 13H17V11H14V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ebf55a6dcd9e1b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H6C5.44772 22 5 21.5523 5 21V19H3V17H5V15H3V13H5V11H3V9H5V7H3V5H5V3C5 2.44772 5.44772 2 6 2H20ZM19 4H7V20H19V4ZM14 8V11H17V13H13.999L14 16H12L11.999 13H9V11H12V8H14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$42bb7df7484aa79c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2426 4.75736C22.5053 7.02472 22.583 10.637 20.4786 12.993L11.9999 21.485L3.52138 12.993C1.41705 10.637 1.49571 7.01901 3.75736 4.75736C5.51545 2.99926 8.09315 2.56029 10.2605 3.44044L6.34315 7.35843L7.75736 8.77264L12 4.53L11.9872 4.51617C11.9918 4.52028 11.9964 4.5244 12.001 4.52853C14.35 2.42 17.98 2.49 20.2426 4.75736Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a9d821da687200a1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2426 4.75736C22.5053 7.02472 22.583 10.637 20.4786 12.993L11.9999 21.485L3.52138 12.993C1.41705 10.637 1.49571 7.01901 3.75736 4.75736C6.02157 2.49315 9.64519 2.41687 12.001 4.52853C14.35 2.42 17.98 2.49 20.2426 4.75736ZM5.17157 6.17157C3.68183 7.66131 3.60704 10.0473 4.97993 11.6232L11.9999 18.6543L19.0201 11.6232C20.3935 10.0467 20.319 7.66525 18.827 6.1701C17.3397 4.67979 14.9458 4.60806 13.3743 5.98376L9.17157 10.1869L7.75736 8.77264L10.582 5.946L10.5002 5.87701C8.92545 4.61197 6.62322 4.71993 5.17157 6.17157Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$96081b4420416928(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3C19.5376 3 22 5.5 22 9C22 16 14.5 20 12 21.5C9.5 20 2 16 2 9C2 5.5 4.5 3 7.5 3C9.35997 3 11 4 12 5C13 4 14.64 3 16.5 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$22093bb87b687a7a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3C19.5376 3 22 5.5 22 9C22 16 14.5 20 12 21.5C9.5 20 2 16 2 9C2 5.5 4.5 3 7.5 3C9.35997 3 11 4 12 5C13 4 14.64 3 16.5 3ZM12.9339 18.6038C13.8155 18.0485 14.61 17.4955 15.3549 16.9029C18.3337 14.533 20 11.9435 20 9C20 6.64076 18.463 5 16.5 5C15.4241 5 14.2593 5.56911 13.4142 6.41421L12 7.82843L10.5858 6.41421C9.74068 5.56911 8.5759 5 7.5 5C5.55906 5 4 6.6565 4 9C4 11.9435 5.66627 14.533 8.64514 16.9029C9.39 17.4955 10.1845 18.0485 11.0661 18.6038C11.3646 18.7919 11.6611 18.9729 12 19.1752C12.3389 18.9729 12.6354 18.7919 12.9339 18.6038Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$584956d80dcbd8d6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.0001 13.9999V16.9999H22.0001V18.9999H18.9991L19.0001 21.9999H17.0001L16.9991 18.9999H14.0001V16.9999H17.0001V13.9999H19.0001ZM20.2426 4.75736C22.4033 6.92253 22.5715 10.3141 20.7498 12.667C19.9261 12.2403 18.9911 12 18 12C14.6863 12 12 14.6863 12 18C12 19.0089 12.249 19.9596 12.6889 20.794L11.9999 21.485L3.52138 12.993C1.41705 10.637 1.49571 7.01901 3.75736 4.75736C6.02157 2.49315 9.64519 2.41687 12.001 4.52853C14.35 2.42 17.98 2.49 20.2426 4.75736Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b5597d3daef4c522(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.0001 13.9999V16.9999H22.0001V18.9999H18.9991L19.0001 21.9999H17.0001L16.9991 18.9999H14.0001V16.9999H17.0001V13.9999H19.0001ZM20.2426 4.75736C22.505 7.0244 22.5829 10.636 20.4795 12.992L19.06 11.574C20.3901 10.0499 20.3201 7.65987 18.827 6.1701C17.3244 4.67092 14.9076 4.60701 13.337 6.01688L12.0019 7.21524L10.6661 6.01781C9.09098 4.60597 6.67506 4.66808 5.17157 6.17157C3.68183 7.66131 3.60704 10.0473 4.97993 11.6232L13.412 20.069L11.9999 21.485L3.52138 12.993C1.41705 10.637 1.49571 7.01901 3.75736 4.75736C6.02157 2.49315 9.64519 2.41687 12.001 4.52853C14.35 2.42 17.98 2.49 20.2426 4.75736Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3943e321613750b9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 4.52853C14.35 2.42 17.98 2.49 20.2426 4.75736C22.5053 7.02472 22.583 10.637 20.4786 12.993L11.9999 21.485L3.52138 12.993C1.41705 10.637 1.49571 7.01901 3.75736 4.75736C6.02157 2.49315 9.64519 2.41687 12.001 4.52853Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4e1ce9bdd7fad317(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 4.52853C14.35 2.42 17.98 2.49 20.2426 4.75736C22.5053 7.02472 22.583 10.637 20.4786 12.993L11.9999 21.485L3.52138 12.993C1.41705 10.637 1.49571 7.01901 3.75736 4.75736C6.02157 2.49315 9.64519 2.41687 12.001 4.52853ZM18.827 6.1701C17.3279 4.66794 14.9076 4.60701 13.337 6.01687L12.0019 7.21524L10.6661 6.01781C9.09098 4.60597 6.67506 4.66808 5.17157 6.17157C3.68183 7.66131 3.60704 10.0473 4.97993 11.6232L11.9999 18.6543L19.0201 11.6232C20.3935 10.0467 20.319 7.66525 18.827 6.1701Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$26faa3914a248a0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3C19.5376 3 22 5.5 22 9C22 16 14.5 20 12 21.5C10.0224 20.3135 4.91625 17.5626 2.8685 13L7.56619 13L8.5 11.4437L11.5 16.4437L13.5662 13H17V11H12.4338L11.5 12.5563L8.5 7.55635L6.43381 11L2.21024 10.9999C2.07418 10.3626 2 9.69615 2 9C2 5.5 4.5 3 7.5 3C9.35997 3 11 4 12 5C13 4 14.64 3 16.5 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8f89bdd54af99ff0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3C19.5376 3 22 5.5 22 9C22 16 14.5 20 12 21.5C10.0226 20.3135 4.91699 17.563 2.86894 13.001L1 13V11L2.21045 11.0009C2.07425 10.3633 2 9.69651 2 9C2 5.5 4.5 3 7.5 3C9.35997 3 11 4 12 5C13 4 14.64 3 16.5 3ZM16.5 5C15.4241 5 14.2593 5.56911 13.4142 6.41421L12 7.82843L10.5858 6.41421C9.74068 5.56911 8.5759 5 7.5 5C5.55906 5 4 6.6565 4 9C4 9.68542 4.09035 10.3516 4.26658 11.0004L6.43381 11L8.5 7.55635L11.5 12.5563L12.4338 11H17V13H13.5662L11.5 16.4437L8.5 11.4437L7.56619 13L5.10789 13.0006C5.89727 14.3737 7.09304 15.6681 8.64514 16.9029C9.39001 17.4955 10.1845 18.0485 11.0661 18.6038C11.3646 18.7919 11.6611 18.9729 12 19.1752C12.3389 18.9729 12.6354 18.7919 12.9339 18.6038C13.8155 18.0485 14.61 17.4955 15.3549 16.9029C18.3337 14.533 20 11.9435 20 9C20 6.64076 18.463 5 16.5 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3f05088bad73e136(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.3631 11.0453C18.767 9.65157 21.0432 9.65157 22.4471 11.0453C23.851 12.439 23.851 14.6987 22.4471 16.0924L17 21.5L11.5529 16.0924C10.149 14.6987 10.149 12.439 11.5529 11.0453C12.9568 9.65157 15.233 9.65157 16.6369 11.0453L16.9996 11.4051L17.3631 11.0453ZM19.2426 4.75736C20.1831 5.69977 20.7461 6.87453 20.9318 8.09485C19.5993 7.84749 18.1932 8.08543 17.0001 8.808C14.8491 7.50516 12.0056 7.7777 10.1439 9.62594C8.01293 11.7414 7.95374 15.1405 9.96628 17.3273L10.1439 17.5117L12.565 19.916L10.9999 21.485L2.52138 12.993C0.417048 10.637 0.495706 7.01901 2.75736 4.75736C5.02157 2.49315 8.64519 2.41687 11.001 4.52853C13.35 2.42 16.98 2.49 19.2426 4.75736Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d3acf2e347123d39(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.2426 4.75736C20.705 6.2228 21.2547 8.25005 20.8924 10.1368C21.4614 10.2972 21.9987 10.6002 22.4471 11.0453C23.851 12.439 23.851 14.6987 22.4471 16.0924L17 21.5L13.978 18.5L10.9999 21.485L2.52138 12.993C0.417048 10.637 0.495706 7.01901 2.75736 4.75736C5.02157 2.49315 8.64519 2.41687 11.001 4.52853C13.35 2.42 16.98 2.49 19.2426 4.75736ZM12.962 12.4646C12.346 13.0761 12.346 14.0615 12.962 14.673L17 18.6818L21.038 14.673C21.654 14.0615 21.654 13.0761 21.038 12.4646C20.414 11.8451 19.3962 11.8451 18.77 12.4668L16.9979 14.2206L15.591 12.825L15.2278 12.4646C14.6038 11.8451 13.586 11.8451 12.962 12.4646ZM4.17157 6.17157C2.68183 7.66131 2.60704 10.0473 3.97993 11.6232L10.9999 18.6543L12.559 17.092L11.5529 16.0924C10.149 14.6987 10.149 12.439 11.5529 11.0453C12.9568 9.65157 15.233 9.65157 16.6369 11.0453L16.9996 11.4051L17.3631 11.0453C17.7877 10.6238 18.2921 10.3297 18.828 10.1632C19.2436 8.79577 18.9058 7.25122 17.827 6.1701C16.3279 4.66794 13.9076 4.60701 12.337 6.01687L11.0019 7.21524L9.66605 6.01781C8.09098 4.60597 5.67506 4.66808 4.17157 6.17157Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$da70dbfa3c01f340(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2V11H17.999L18 12C18 14.2091 16.2091 16 14 16H12.621L12.0084 19.1113L12.9192 20.4324C13.2327 20.8871 13.1182 21.5098 12.6635 21.8233C12.4966 21.9384 12.2987 22 12.0959 22H3L5.31286 11.9762L3 11L7 2H21ZM15.999 11H13.6051L13.014 14H14C15.1046 14 16 13.1046 16 12L15.999 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8096f136269e8a0c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2V11H17.999L18 12C18 14.2091 16.2091 16 14 16H12.621L12.0084 19.1113L12.9192 20.4324C13.2327 20.8871 13.1182 21.5098 12.6635 21.8233C12.4966 21.9384 12.2987 22 12.0959 22H3L5.31286 11.9762L3 11L7 2H21ZM19 4H8.29975L5.65535 9.9499L7.6397 10.7874L5.51402 20H10.1918L9.88322 19.5524L11.9604 9H19V4ZM15.999 11H13.6051L13.014 14H14C15.1046 14 16 13.1046 16 12L15.999 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$52df3cf599962d3a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5.5C9.91162 5.97054 10.5483 7.65881 10.8268 9.52302L6.30385 12.134L7.30385 13.866L11.014 11.7247C11.0598 13.0789 11 14.3085 11 15C11 18 10 21 6 21C2 21 2 21 2 17C2 9.5 5.50055 4.50018 8.5 5.5ZM22.0012 17L22.001 17.436C21.9956 21 21.8503 21 18.0012 21C14.0012 21 13.0013 18 13.0013 15C13.0013 14.3086 12.9415 13.0795 12.9872 11.7257L16.6962 13.866L17.6962 12.134L13.1743 9.52402C13.4527 7.65942 14.0894 5.97062 15.5013 5.5C18.5007 4.50018 22.0012 9.5 22.0012 17ZM13 2V11H11V2H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fd6e1485937ebc7d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.0013 17C22 21 22 21 18.0012 21C14.0012 21 13.0013 18 13.0013 15C13.0013 14.6216 12.9834 14.0822 12.9746 13.4495L14.9976 14.6186L15.0013 15C15.0013 17.7759 15.8173 19 18.0012 19C19.1415 19 19.6118 18.993 19.9637 18.9625C19.9943 18.6106 20.0012 18.1403 20.0012 17C20.0012 13.7947 19.298 10.9675 18.1657 9.09922C17.3283 7.71769 16.5533 7.2575 16.1337 7.39737C15.8411 7.49489 15.5286 8.04672 15.3027 9.02034L13.5124 7.98683C13.882 6.79047 14.4945 5.83557 15.5013 5.5C18.5007 4.50018 22.0036 9.5 22.0013 17ZM8.5 5.5C9.50665 5.83555 10.1192 6.79037 10.4888 7.98665L8.69853 9.02034C8.47269 8.04672 8.16013 7.49489 7.86754 7.39737C7.44794 7.2575 6.67292 7.71769 5.83557 9.09922C4.70322 10.9675 4 13.7947 4 17C4 18.1403 4.00698 18.6106 4.0375 18.9625C4.3894 18.993 4.85973 19 6 19C8.18395 19 9 17.7759 9 15L9.00367 14.6176L11.0266 13.4502C11.0179 14.0826 11 14.6218 11 15C11 18 10 21 6 21C2 21 2 21 2 17C2 9.5 5.50055 4.50018 8.5 5.5ZM13 2L12.9998 9.422L17.6962 12.134L16.6962 13.866L11.9998 11.155L7.30385 13.866L6.30385 12.134L10.9998 9.422L11 2H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$389d6ce2c5e868b3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5V7C18.6569 7 20 8.34315 20 10V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V10C4 8.34315 5.34315 7 7 7V5H17ZM13 11H11V13H9V15H10.999L11 17H13L12.999 15H15V13H13V11ZM19 2V4H5V2H19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$65d89184a939b129(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2V4H17V7C18.6569 7 20 8.34315 20 10V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V10C4 8.34315 5.34315 7 7 7V4H5V2H19ZM17 9H7C6.44772 9 6 9.44772 6 10V20H18V10C18 9.44772 17.5523 9 17 9ZM13 11V13H15V15H12.999L13 17H11L10.999 15H9V13H11V11H13ZM15 4H9V7H15V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$77f0562293f9ad90(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2C15.0675 2 18.426 5.03562 18.9337 8.96494L21.1842 12.5037C21.3324 12.7367 21.3025 13.0847 20.9593 13.2317L19 14.071V17C19 18.1046 18.1046 19 17 19H15.001L15 22H6L6.00025 18.3061C6.00033 17.1252 5.56351 16.0087 4.7555 15.0011C3.65707 13.6313 3 11.8924 3 10C3 5.58172 6.58172 2 11 2ZM10.4697 7.76256C9.78625 7.07915 8.67821 7.07915 7.9948 7.76256C7.31138 8.44598 7.31138 9.55402 7.9948 10.2374L11 13.2426L14.0052 10.2374C14.6886 9.55402 14.6886 8.44598 14.0052 7.76256C13.3218 7.07915 12.2137 7.07915 11.5303 7.76256L11 8.29289L10.4697 7.76256Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f151a1725d560176(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2C15.0675 2 18.426 5.03562 18.9337 8.96494L21.1842 12.5037C21.3324 12.7367 21.3025 13.0847 20.9593 13.2317L19 14.071V17C19 18.1046 18.1046 19 17 19H15.001L15 22H6L6.00025 18.3061C6.00033 17.1252 5.56351 16.0087 4.7555 15.0011C3.65707 13.6313 3 11.8924 3 10C3 5.58172 6.58172 2 11 2ZM11 4C7.68629 4 5 6.68629 5 10C5 11.3849 5.46818 12.6929 6.31578 13.7499C7.40965 15.114 8.00036 16.6672 8.00025 18.3063L8.00013 20H13.0007L13.0017 17H17V12.7519L18.5497 12.0881L17.0072 9.66262L16.9501 9.22118C16.5665 6.25141 14.0243 4 11 4ZM10.4697 7.76256L11 8.29289L11.5303 7.76256C12.2137 7.07915 13.3218 7.07915 14.0052 7.76256C14.6886 8.44598 14.6886 9.55402 14.0052 10.2374L11 13.2426L7.9948 10.2374C7.31138 9.55402 7.31138 8.44598 7.9948 7.76256C8.67821 7.07915 9.78625 7.07915 10.4697 7.76256Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2db23084b474fd7e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.1962 2.26791L16.4462 7.89708C16.7223 8.37537 16.5584 8.98696 16.0801 9.2631L14.7806 10.0122L15.7811 11.7452L14.049 12.7452L13.0485 11.0122L11.75 11.7631C11.2717 12.0392 10.6601 11.8754 10.384 11.3971L8.5462 8.2146C6.49383 8.8373 5 10.7442 5 13C5 13.6253 5.1148 14.2238 5.32447 14.7756C6.0992 14.284 7.01643 14 8 14C9.68408 14 11.1737 14.8326 12.0797 16.1086L19.7681 11.6704L20.7681 13.4024L12.8898 17.9509C12.962 18.2892 13 18.6401 13 19C13 19.3427 12.9655 19.6773 12.8999 20.0006L21 20V22L4.00054 22.0012C3.3723 21.1653 3 20.1261 3 19C3 17.9927 3.29782 17.0551 3.81021 16.2702C3.29276 15.2948 3 14.1816 3 13C3 10.0047 4.88131 7.44875 7.52677 6.44942L7.13397 5.76791C6.58169 4.81133 6.90944 3.58815 7.86603 3.03586L10.4641 1.53586C11.4207 0.983577 12.6439 1.31133 13.1962 2.26791Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$22ef7ffdc48de95(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.1962 2.26791L16.4462 7.89708C16.7223 8.37537 16.5584 8.98696 16.0801 9.2631L14.7806 10.0122L15.7811 11.7452L14.049 12.7452L13.0485 11.0122L11.75 11.7631C11.2717 12.0392 10.6601 11.8754 10.384 11.3971L8.5462 8.2146C6.49383 8.8373 5 10.7442 5 13C5 13.6253 5.1148 14.2238 5.32447 14.7756C6.0992 14.284 7.01643 14 8 14C9.68408 14 11.1737 14.8326 12.0797 16.1086L19.7681 11.6704L20.7681 13.4024L12.8898 17.9509C12.962 18.2892 13 18.6401 13 19C13 19.3427 12.9655 19.6773 12.8999 20.0006L21 20V22L4.00054 22.0012C3.3723 21.1653 3 20.1261 3 19C3 17.9927 3.29782 17.0551 3.81021 16.2702C3.29276 15.2948 3 14.1816 3 13C3 10.0047 4.88131 7.44875 7.52677 6.44942L7.13397 5.76791C6.58169 4.81133 6.90944 3.58815 7.86603 3.03586L10.4641 1.53586C11.4207 0.983577 12.6439 1.31133 13.1962 2.26791ZM8 16C6.34315 16 5 17.3431 5 19C5 19.3506 5.06014 19.6871 5.17067 19.9999H10.8293C10.9399 19.6871 11 19.3506 11 19C11 17.3431 9.65685 16 8 16ZM11.4641 3.26791L8.86602 4.76791L11.616 9.53105L14.2141 8.03105L11.4641 3.26791Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$563caab50c6192eb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.9571 15.564C17.6154 16.6219 19.5726 19.0639 19.9387 22H4.0625C4.42862 19.0639 6.38587 16.6219 9.04417 15.564L12.0006 20L14.9571 15.564ZM18.0006 2V8C18.0006 11.3137 15.3143 14 12.0006 14C8.6869 14 6.00061 11.3137 6.00061 8V2H18.0006ZM16.0006 8H8.00061C8.00061 10.2091 9.79147 12 12.0006 12C14.2098 12 16.0006 10.2091 16.0006 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b868ec25aa564e8e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0006 15C16.0802 15 19.4466 18.0537 19.9387 22H4.0625C4.55458 18.0537 7.92098 15 12.0006 15ZM10.1875 17.2795C8.75387 17.734 7.54637 18.7133 6.80201 20L12.0006 20L10.1875 17.2795ZM13.8141 17.2797L12.0006 20L17.1992 20C16.4549 18.7135 15.2476 17.7342 13.8141 17.2797ZM18.0006 2V8C18.0006 11.3137 15.3143 14 12.0006 14C8.6869 14 6.00061 11.3137 6.00061 8V2H18.0006ZM8.00061 8C8.00061 10.2091 9.79147 12 12.0006 12C14.2098 12 16.0006 10.2091 16.0006 8H8.00061ZM16.0006 4H8.00061L8.0005 6H16.0005L16.0006 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f3de06820d9e7ef(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2C15.0675 2 18.426 5.03562 18.9337 8.96494L21.1842 12.5037C21.3324 12.7367 21.3025 13.0847 20.9593 13.2317L19 14.071V17C19 18.1046 18.1046 19 17 19H15.001L15 22H6L6.00025 18.3061C6.00033 17.1252 5.56351 16.0087 4.7555 15.0011C3.65707 13.6313 3 11.8924 3 10C3 5.58172 6.58172 2 11 2ZM11 7C10.4477 7 10 7.44772 10 8V8.999L9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11L10 10.999V12C10 12.5523 10.4477 13 11 13C11.5523 13 12 12.5523 12 12V11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H12V8C12 7.44772 11.5523 7 11 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6d6dff57bf3fe291(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2C15.0675 2 18.426 5.03562 18.9337 8.96494L21.1842 12.5037C21.3324 12.7367 21.3025 13.0847 20.9593 13.2317L19 14.071V17C19 18.1046 18.1046 19 17 19H15.001L15 22H6L6.00025 18.3061C6.00033 17.1252 5.56351 16.0087 4.7555 15.0011C3.65707 13.6313 3 11.8924 3 10C3 5.58172 6.58172 2 11 2ZM11 4C7.68629 4 5 6.68629 5 10C5 11.3849 5.46818 12.6929 6.31578 13.7499C7.40965 15.114 8.00036 16.6672 8.00025 18.3063L8.00013 20H13.0007L13.0017 17H17V12.7519L18.5497 12.0881L17.0072 9.66262L16.9501 9.22118C16.5665 6.25141 14.0243 4 11 4ZM11 7C11.5523 7 12 7.44772 12 8V9H13C13.5523 9 14 9.44772 14 10C14 10.5523 13.5523 11 13 11H12V12C12 12.5523 11.5523 13 11 13C10.4477 13 10 12.5523 10 12V10.999L9 11C8.44772 11 8 10.5523 8 10C8 9.44772 8.44772 9 9 9L10 8.999V8C10 7.44772 10.4477 7 11 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4563ce4cc752a215(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7.53861L15 21.5386L18.6594 13H23V11H17.3406L15 16.4614L9 2.46143L5.3406 11H1V13H6.6594L9 7.53861Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c1508c61253c3a50(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7.53861L15 21.5386L18.6594 13H23V11H17.3406L15 16.4614L9 2.46143L5.3406 11H1V13H6.6594L9 7.53861Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8a7a1de52eb7e0c3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6V14H19C19 18.4183 15.4183 22 11 22C6.58172 22 3 18.4183 3 14C3 9.66509 6.58 6 11 6ZM21 2V4L15.6726 10H21V12H13V10L18.3256 4H13V2H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$557c274b97887232(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6V8C7.68629 8 5 10.6863 5 14C5 17.3137 7.68629 20 11 20C14.2384 20 16.8776 17.4344 16.9959 14.2249L17 14H19C19 18.4183 15.4183 22 11 22C6.58172 22 3 18.4183 3 14C3 9.66509 6.58 6 11 6ZM21 2V4L15.6726 10H21V12H13V10L18.3256 4H13V2H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$232dbb86508a0730(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3V5H6V9C6 11.2091 7.79086 13 10 13C12.2091 13 14 11.2091 14 9V5H12V3H15C15.5523 3 16 3.44772 16 4V9C16 11.9727 13.8381 14.4405 11.0008 14.9169L11 16.5C11 18.433 12.567 20 14.5 20C15.9973 20 17.275 19.0598 17.7749 17.7375C16.7283 17.27 16 16.2201 16 15C16 13.3431 17.3431 12 19 12C20.6569 12 22 13.3431 22 15C22 16.3711 21.0802 17.5274 19.824 17.8854C19.2102 20.252 17.0592 22 14.5 22C11.4624 22 9 19.5376 9 16.5L9.00019 14.9171C6.16238 14.4411 4 11.9731 4 9V4C4 3.44772 4.44772 3 5 3H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$21cace0a0b7e0112(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3V5H6V9C6 11.2091 7.79086 13 10 13C12.2091 13 14 11.2091 14 9V5H12V3H15C15.5523 3 16 3.44772 16 4V9C16 11.9727 13.8381 14.4405 11.0008 14.9169L11 16.5C11 18.433 12.567 20 14.5 20C15.9973 20 17.275 19.0598 17.7749 17.7375C16.7283 17.27 16 16.2201 16 15C16 13.3431 17.3431 12 19 12C20.6569 12 22 13.3431 22 15C22 16.3711 21.0802 17.5274 19.824 17.8854C19.2102 20.252 17.0592 22 14.5 22C11.4624 22 9 19.5376 9 16.5L9.00019 14.9171C6.16238 14.4411 4 11.9731 4 9V4C4 3.44772 4.44772 3 5 3H8ZM19 14C18.4477 14 18 14.4477 18 15C18 15.5523 18.4477 16 19 16C19.5523 16 20 15.5523 20 15C20 14.4477 19.5523 14 19 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9157393ca2a76884(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4851 3.12124L20.2425 5.0606C20.6877 5.1719 21 5.57188 21 6.03075V6.99952L22 6.99997C23.1 6.99997 24 7.89997 24 8.99997V12C24 13.6568 22.6569 15 21 15L20.5789 15.0003C20.0443 16.3501 19.0275 17.4862 17.6833 18.1583L12.8944 20.5528C12.3314 20.8343 11.6686 20.8343 11.1056 20.5528L6.31672 18.1583C4.97252 17.4862 3.95573 16.3501 3.42113 15.0003L3 15C1.34315 15 0 13.6568 0 12V8.99997C0 7.8954 0.89543 6.99997 2 6.99997L3 6.99952V6.03075C3 5.57188 3.3123 5.1719 3.75746 5.0606L11.5149 3.12124C11.8334 3.04162 12.1666 3.04162 12.4851 3.12124ZM3 8.99997H2V12C2 12.5523 2.44772 13 3 13V8.99997ZM22 8.99997H21V13C21.5523 13 22 12.5523 22 12V8.99997Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4a171b1c9459dfe5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4851 3.12124L20.2425 5.0606C20.6877 5.1719 21 5.57188 21 6.03075V6.99952L22 6.99997C23.1 6.99997 24 7.89997 24 8.99997V12C24 13.6568 22.6569 15 21 15L20.5789 15.0003C20.0443 16.3501 19.0275 17.4862 17.6833 18.1583L12.8944 20.5528C12.3314 20.8343 11.6686 20.8343 11.1056 20.5528L6.31672 18.1583C4.97252 17.4862 3.95573 16.3501 3.42113 15.0003L3 15C1.34315 15 0 13.6568 0 12V8.99997C0 7.8954 0.89543 6.99997 2 6.99997L3 6.99952V6.03075C3 5.57188 3.3123 5.1719 3.75746 5.0606L11.5149 3.12124C11.8334 3.04162 12.1666 3.04162 12.4851 3.12124ZM12 5.06152L5 6.81152V12.7918C5 14.3069 5.85601 15.6919 7.21115 16.3695L12 18.7639L16.7889 16.3695C18.144 15.6919 19 14.3069 19 12.7918V6.81152L12 5.06152ZM3 8.99997H2V12C2 12.5523 2.44772 13 3 13V8.99997ZM22 8.99997H21V13C21.5523 13 22 12.5523 22 12V8.99997Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eb688e30171d9021(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.6779 7.97912L20.2637 9.39333L18.1424 7.27201L16.021 9.39333L19.5566 12.9289L18.1424 14.3431L17.4353 13.636L11.0713 19.9999H5.41444L3.29312 22.1213L1.87891 20.707L4.00023 18.5857V12.9289L10.3642 6.56491L9.65708 5.8578L11.0713 4.44359L14.6068 7.97912L16.7281 5.8578L14.6068 3.73648L16.021 2.32227L21.6779 7.97912ZM9.65708 14.3431L6.82865 11.5147L5.41444 12.9289L8.24287 15.7573L9.65708 14.3431ZM12.4855 11.5147L9.65708 8.68623L8.24287 10.1004L11.0713 12.9289L12.4855 11.5147Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f24dd644ca82ea5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.6779 7.97912L20.2637 9.39333L18.1424 7.27201L16.021 9.39333L19.5566 12.9289L18.1424 14.3431L17.4353 13.636L11.0713 19.9999H5.41444L3.29312 22.1213L1.87891 20.707L4.00023 18.5857V12.9289L10.3642 6.56491L9.65708 5.8578L11.0713 4.44359L14.6068 7.97912L16.7281 5.8578L14.6068 3.73648L16.021 2.32227L21.6779 7.97912ZM16.021 12.2218L11.7784 7.97912L10.3642 9.39333L12.4855 11.5147L11.0713 12.9289L8.94997 10.8075L7.53576 12.2218L9.65708 14.3431L8.24287 15.7573L6.12155 13.636L6.00023 13.7573V17.9999H10.2429L16.021 12.2218Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$29818ed30d0a0e1e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2V4H16V18C16 20.2091 14.2091 22 12 22C9.79086 22 8 20.2091 8 18V4H7V2H17ZM13 15C12.4477 15 12 15.4477 12 16C12 16.5523 12.4477 17 13 17C13.5523 17 14 16.5523 14 16C14 15.4477 13.5523 15 13 15ZM11 12C10.4477 12 10 12.4477 10 13C10 13.5523 10.4477 14 11 14C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12ZM14 4H10V8H14V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7268906e9d17b273(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2V4H16V18C16 20.2091 14.2091 22 12 22C9.79086 22 8 20.2091 8 18V4H7V2H17ZM14 10H10V18C10 19.1046 10.8954 20 12 20C13.1046 20 14 19.1046 14 18V10ZM13 15C13.5523 15 14 15.4477 14 16C14 16.5523 13.5523 17 13 17C12.4477 17 12 16.5523 12 16C12 15.4477 12.4477 15 13 15ZM11 12C11.5523 12 12 12.4477 12 13C12 13.5523 11.5523 14 11 14C10.4477 14 10 13.5523 10 13C10 12.4477 10.4477 12 11 12ZM14 4H10V8H14V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a9dc46a1874bbe7e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5565 3.44355C22.1186 5.00564 22.1186 7.5383 20.5565 9.1004L12.3563 17.3006C11.714 17.9429 10.8723 18.3474 9.96957 18.4477L6.59094 18.822L4.29304 21.1212C3.90252 21.5117 3.26936 21.5117 2.87883 21.1212C2.48831 20.7307 2.48831 20.0975 2.87883 19.707L5.17694 17.408L5.55231 14.0305C5.65261 13.1277 6.05716 12.286 6.69942 11.6438L14.8996 3.44355C16.4617 1.88145 18.9944 1.88145 20.5565 3.44355ZM11.3641 12.6359L9.9499 14.0501L12.0712 16.1715L13.4854 14.7573L11.3641 12.6359ZM14.1925 9.80751L12.7783 11.2217L14.8996 13.343L16.3139 11.9288L14.1925 9.80751ZM17.021 6.97908L15.6068 8.39329L17.7281 10.5146L19.1423 9.1004L17.021 6.97908Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5d2a5a63ff3fbad6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5565 3.44355C22.1186 5.00564 22.1186 7.5383 20.5565 9.1004L12.3563 17.3006C11.714 17.9429 10.8723 18.3474 9.96957 18.4477L6.59094 18.822L4.29304 21.1212C3.90252 21.5117 3.26936 21.5117 2.87883 21.1212C2.48831 20.7307 2.48831 20.0975 2.87883 19.707L5.17694 17.408L5.55231 14.0305C5.65261 13.1277 6.05716 12.286 6.69942 11.6438L14.8996 3.44355C16.4617 1.88145 18.9944 1.88145 20.5565 3.44355ZM16.3139 4.85776L8.11363 13.058C7.7925 13.3791 7.59023 13.8 7.54008 14.2513L7.264 16.736L9.74871 16.46C10.2001 16.4098 10.6209 16.2075 10.9421 15.8864L11.3639 15.464L9.9499 14.0501L11.3641 12.6359L12.7779 14.05L14.1919 12.636L12.7783 11.2217L14.1925 9.80751L15.6069 11.222L17.0209 9.80697L15.6068 8.39329L17.021 6.97908L18.4349 8.39297L19.1423 7.68619C19.9233 6.90514 19.9233 5.63881 19.1423 4.85776C18.3612 4.07671 17.0949 4.07671 16.3139 4.85776Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bde6d24240df5016(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.7163 1.94727L17.4506 3.38074L16.7339 5.2479L15.8003 4.88928L15.0539 6.83418C15.8328 7.29566 16.4983 7.92829 16.9986 8.68026L18.9014 7.83237L18.4947 6.91882L20.3218 6.10535L21.9487 9.75953L20.1216 10.573L19.7149 9.65946L17.8126 10.5069C17.9348 10.9842 17.9998 11.4844 17.9998 11.9998C17.9998 12.4061 17.9594 12.8029 17.8825 13.1865L19.8265 13.9325L20.1852 12.9996L22.0523 13.7163L20.6189 17.4506L18.7517 16.7339L19.1094 15.8007L17.1654 15.0539C16.7039 15.8328 16.0713 16.4983 15.3194 16.9986L16.1672 18.9014L17.0808 18.4947L17.8943 20.3218L14.2401 21.9487L13.4266 20.1216L14.3402 19.7149L13.4927 17.8126C13.0154 17.9348 12.5152 17.9998 11.9998 17.9998C11.5932 17.9998 11.196 17.9594 10.8121 17.8823L10.0662 19.827L11 20.1852L10.2833 22.0523L6.54897 20.6189L7.2657 18.7517L8.19803 19.1098L8.9457 17.1654C8.16683 16.7039 7.50133 16.0713 7.00097 15.3194L5.09818 16.1672L5.50492 17.0808L3.67782 17.8943L2.05088 14.2401L3.87797 13.4266L4.28379 14.3406L6.18702 13.4927C6.06479 13.0154 5.99981 12.5152 5.99981 11.9998C5.99981 11.5935 6.04018 11.1967 6.11714 10.8131L4.17174 10.0666L3.81443 11L1.94727 10.2833L3.38074 6.54897L5.2479 7.2657L4.88888 8.19844L6.83418 8.9457C7.29566 8.16683 7.92829 7.50133 8.68026 7.00097L7.83237 5.09818L6.91882 5.50492L6.10535 3.67782L9.75953 2.05088L10.573 3.87797L9.65946 4.28471L10.5069 6.18702C10.9842 6.06479 11.4844 5.99981 11.9998 5.99981C12.4061 5.99981 12.8029 6.04018 13.1865 6.11714L13.9321 4.17215L12.9996 3.81443L13.7163 1.94727ZM10.1338 13.2319C9.85764 13.7101 10.0215 14.3217 10.4998 14.5979C10.9781 14.874 11.5897 14.7101 11.8658 14.2319C12.142 13.7536 11.9781 13.142 11.4998 12.8658C11.0215 12.5897 10.4099 12.7536 10.1338 13.2319ZM13.9998 10.9998C13.4475 10.9998 12.9998 11.4475 12.9998 11.9998C12.9998 12.5521 13.4475 12.9998 13.9998 12.9998C14.5521 12.9998 14.9998 12.5521 14.9998 11.9998C14.9998 11.4475 14.5521 10.9998 13.9998 10.9998ZM10.4998 9.40173C10.0215 9.67787 9.85764 10.2895 10.1338 10.7678C10.4099 11.246 11.0215 11.4099 11.4998 11.1338C11.9781 10.8576 12.142 10.246 11.8658 9.76776C11.5897 9.28946 10.9781 9.12559 10.4998 9.40173Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$93bc8fe87ca51144(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.7163 1.94727L17.4506 3.38074L16.7339 5.2479L15.8003 4.88928L15.0539 6.83418C15.8328 7.29566 16.4983 7.92829 16.9986 8.68026L18.9014 7.83237L18.4947 6.91882L20.3218 6.10535L21.9487 9.75953L20.1216 10.573L19.7149 9.65946L17.8126 10.5069C17.9348 10.9842 17.9998 11.4844 17.9998 11.9998C17.9998 12.4061 17.9594 12.8029 17.8825 13.1865L19.8265 13.9325L20.1852 12.9996L22.0523 13.7163L20.6189 17.4506L18.7517 16.7339L19.1094 15.8007L17.1654 15.0539C16.7039 15.8328 16.0713 16.4983 15.3194 16.9986L16.1672 18.9014L17.0808 18.4947L17.8943 20.3218L14.2401 21.9487L13.4266 20.1216L14.3402 19.7149L13.4927 17.8126C13.0154 17.9348 12.5152 17.9998 11.9998 17.9998C11.5932 17.9998 11.196 17.9594 10.8121 17.8823L10.0662 19.827L11 20.1852L10.2833 22.0523L6.54897 20.6189L7.2657 18.7517L8.19803 19.1098L8.9457 17.1654C8.16683 16.7039 7.50133 16.0713 7.00097 15.3194L5.09818 16.1672L5.50492 17.0808L3.67782 17.8943L2.05088 14.2401L3.87797 13.4266L4.28379 14.3406L6.18702 13.4927C6.06479 13.0154 5.99981 12.5152 5.99981 11.9998C5.99981 11.5935 6.04018 11.1967 6.11714 10.8131L4.17174 10.0666L3.81443 11L1.94727 10.2833L3.38074 6.54897L5.2479 7.2657L4.88888 8.19844L6.83418 8.9457C7.29566 8.16683 7.92829 7.50133 8.68026 7.00097L7.83237 5.09818L6.91882 5.50492L6.10535 3.67782L9.75953 2.05088L10.573 3.87797L9.65946 4.28471L10.5069 6.18702C10.9842 6.06479 11.4844 5.99981 11.9998 5.99981C12.4061 5.99981 12.8029 6.04018 13.1865 6.11714L13.9321 4.17215L12.9996 3.81443L13.7163 1.94727ZM11.9998 7.99981C9.79067 7.99981 7.99981 9.79067 7.99981 11.9998C7.99981 14.2089 9.79067 15.9998 11.9998 15.9998C14.2089 15.9998 15.9998 14.2089 15.9998 11.9998C15.9998 9.79067 14.2089 7.99981 11.9998 7.99981ZM11.4998 12.8658C11.9781 13.142 12.142 13.7536 11.8658 14.2319C11.5897 14.7101 10.9781 14.874 10.4998 14.5979C10.0215 14.3217 9.85764 13.7101 10.1338 13.2319C10.4099 12.7536 11.0215 12.5897 11.4998 12.8658ZM13.9998 10.9998C14.5521 10.9998 14.9998 11.4475 14.9998 11.9998C14.9998 12.5521 14.5521 12.9998 13.9998 12.9998C13.4475 12.9998 12.9998 12.5521 12.9998 11.9998C12.9998 11.4475 13.4475 10.9998 13.9998 10.9998ZM11.8658 9.76776C12.142 10.246 11.9781 10.8576 11.4998 11.1338C11.0215 11.4099 10.4099 11.246 10.1338 10.7678C9.85764 10.2895 10.0215 9.67787 10.4998 9.40173C10.9781 9.12559 11.5897 9.28946 11.8658 9.76776Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a7e1dd109c59c64f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11V13L5.67257 19H11V21H3V19L8.32557 13H3V11H11ZM21 3V5L15.6726 11H21V13H13V11L18.3256 5H13V3H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$96f2e181ad428365(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11V13L5.67257 19H11V21H3V19L8.32557 13H3V11H11ZM21 3V5L15.6726 11H21V13H13V11L18.3256 5H13V3H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f8fad88af79be2c7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.4224 15.3576C17.5929 14.2048 15.3667 13.5176 14.744 13.296C15.312 12.32 15.768 11.2 16.064 9.976H12.8V8.872H16.8V8.192H12.8V6.344H11.264C10.984 6.344 10.952 6.592 10.952 6.592V8.184H7.2V8.864H10.952V9.968H7.88V10.584H14.104C13.88 11.36 13.576 12.096 13.216 12.76C11.808 12.296 11.024 11.976 9.304 11.816C6.048 11.504 5.296 13.296 5.176 14.392C5 16.064 6.48 17.424 8.688 17.424C10.896 17.424 12.368 16.4 13.768 14.704C14.9346 15.2619 17.1059 16.2293 20.2819 17.6062C18.4835 20.2577 15.4452 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 13.1778 21.7964 14.3081 21.4224 15.3576ZM8.432 16.368C6.096 16.368 5.728 14.888 5.848 14.272C5.968 13.656 6.648 12.856 7.952 12.856C9.448 12.856 10.784 13.24 12.392 14.016C11.256 15.496 9.872 16.368 8.432 16.368Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$262c0945b0e12063(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.4079 16.7903C16.2353 15.8398 14.6887 15.1443 13.768 14.704C12.368 16.4 10.896 17.424 8.688 17.424C6.48 17.424 5 16.064 5.176 14.392C5.296 13.296 6.048 11.504 9.304 11.816C11.024 11.976 11.808 12.296 13.216 12.76C13.576 12.096 13.88 11.36 14.104 10.584H7.88V9.968H10.952V8.864H7.2V8.184H10.952V6.592C10.952 6.592 10.984 6.344 11.264 6.344H12.8V8.192H16.8V8.872H12.8V9.976H16.064C15.768 11.2 15.312 12.32 14.744 13.296C15.2543 13.4776 16.841 13.9718 19.5043 14.7785C19.8249 13.913 20 12.977 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.6217 20 16.9488 18.7389 18.4079 16.7903ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8.432 16.368C9.872 16.368 11.256 15.496 12.392 14.016C10.784 13.24 9.448 12.856 7.952 12.856C6.648 12.856 5.968 13.656 5.848 14.272C5.728 14.888 6.096 16.368 8.432 16.368Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c2837de01bd20dd0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.997 18.2294C21.997 18.9572 21.5919 20.3571 20.6823 21.1263C20.5002 21.2667 20.3181 21.187 20.3979 20.983C20.6625 20.3352 21.2694 18.8356 20.985 18.4912C20.7839 18.2294 19.954 18.2485 19.2462 18.3092C18.923 18.3501 18.6393 18.3699 18.4191 18.4136C18.2152 18.4305 18.1736 18.2513 18.3775 18.1109C18.6393 17.926 18.923 17.7855 19.2483 17.6832C20.3979 17.3388 21.7269 17.5461 21.9172 17.7658C21.954 17.8083 21.997 17.926 21.997 18.2294ZM20.0754 19.5244C19.8136 19.7262 19.5299 19.9104 19.2462 20.0734C17.1235 21.3493 14.3748 22.0168 11.9875 22.0168C8.14505 22.0168 4.70765 20.5998 2.10014 18.2294C1.87644 18.0474 2.06133 17.7827 2.32314 17.926C5.13247 19.566 8.6108 20.5582 12.2112 20.5582C14.4772 20.5582 16.9195 20.1341 19.2462 19.2216C19.4085 19.1609 19.5906 19.0784 19.7501 19.0205C20.117 18.8547 20.4395 19.2625 20.0754 19.5244ZM13.9051 8.49485C13.9059 7.45265 13.9472 6.8397 13.6019 6.31359C13.2955 5.88081 12.7691 5.62128 12.0335 5.66194C11.2353 5.70607 10.3784 6.22935 10.1595 7.18824C10.1174 7.40711 9.98855 7.6235 9.72343 7.6714L7.28779 7.36168C7.11352 7.32039 6.84922 7.18824 6.93595 6.8397C7.45875 4.08774 9.81097 3.12884 12.0335 3H12.5563C13.7762 3 15.3438 3.34854 16.3473 4.26448C17.5639 5.40012 17.4342 6.92642 17.4342 8.58487V12.5113C17.4342 13.6891 17.9116 14.211 18.3923 14.8247C18.522 15.0436 18.5666 15.3021 18.3477 15.4797C17.867 15.9149 16.9535 16.6987 16.4307 17.134C16.2565 17.2669 15.9424 17.2811 15.8212 17.1794C15.0514 16.5336 14.8631 16.1759 14.3857 15.5209C13.5565 16.3923 12.8594 16.873 12.0302 17.134C11.5074 17.2669 10.9433 17.3504 10.2462 17.3504C8.15583 17.3504 6.50069 16.0471 6.50069 13.4694C6.50069 11.4211 7.5909 10.0276 9.20062 9.36867C10.8103 8.7097 13.1505 8.49857 13.9051 8.49485ZM13.4277 13.6858C13.9472 12.8144 13.9051 12.0996 13.9051 10.501C13.2534 10.501 12.5985 10.5464 12.0335 10.6786C10.9887 10.9817 10.1595 11.6399 10.1595 13.0341C10.1595 14.1243 10.7269 14.866 11.685 14.866C11.8171 14.866 11.9328 14.8495 12.0335 14.8214C12.7028 14.6346 13.1213 14.2986 13.4277 13.6858Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2e0117518ca07a7b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.6262 14.6198C14.5191 16.2384 12.8976 17.0039 11.0007 17.0039C8.69659 17.0039 6.7243 15.2312 7.00788 12.8801C7.32248 10.2717 9.34731 9.14937 12.716 8.73701C13.3171 8.66343 13.566 8.64274 14.8629 8.54667C14.9116 8.54306 14.9575 8.53964 15.001 8.53635C15.0008 8.4652 15.0007 8.39361 15.0007 8.3216C15.0007 6.52571 13.9328 5.2998 12.5007 5.2998C11.0638 5.2998 10.0603 6.04715 9.44592 7.82621L7.55546 7.1734C8.44288 4.60353 10.1935 3.2998 12.5007 3.2998C15.1034 3.2998 17.0007 5.47779 17.0007 8.3216C17.0007 10.9704 17.164 13.0773 17.484 13.8792C17.84 14.7712 17.9698 14.9957 18.3677 15.4918L16.8075 16.7431C16.2843 16.0908 16.0549 15.6942 15.6264 14.6205L15.6262 14.6198ZM21.2572 20.545C20.9864 20.745 20.5157 20.6261 20.7288 20.1045C20.9934 19.4567 21.2755 18.6969 20.9911 18.3525C20.7807 18.0977 20.5235 17.9709 19.9637 17.9709C19.5041 17.9709 19.2733 18.0303 18.9688 18.0506C18.7646 18.0642 18.6753 17.7535 18.8775 17.6107C19.1393 17.4258 19.4216 17.2809 19.7483 17.183C20.8979 16.8387 22.253 17.0274 22.4172 17.2656C22.7826 17.7957 22.2189 19.8348 21.2572 20.545ZM20.0754 19.4606C19.8136 19.7162 19.5299 19.9494 19.2462 20.1558C17.1235 21.7713 14.3748 22.6166 11.9875 22.6166C8.14505 22.6166 4.70765 20.8224 2.10014 17.8209C1.87644 17.5904 2.06133 17.2553 2.32314 17.4367C5.13247 19.5133 8.6108 20.7697 12.2112 20.7697C14.4772 20.7697 16.9195 20.2326 19.2462 19.0773C19.4085 19.0004 19.5906 18.8959 19.7501 18.8226C20.117 18.6126 20.4395 19.1291 20.0754 19.4606ZM15.0107 10.5412C13.7522 10.6344 13.5147 10.6542 12.959 10.7222C10.4062 11.0347 9.16175 11.7245 8.99349 13.1195C8.86763 14.163 9.80321 15.0039 11.0007 15.0039C13.0397 15.0039 14.5179 13.7762 15.0227 10.5403C15.0187 10.5406 15.0147 10.5409 15.0107 10.5412Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2b2cf4d2cec0859(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.38231 3.9681C7.92199 2.73647 9.87499 2 12 2C14.125 2 16.078 2.73647 17.6177 3.9681L19.0711 2.51472L20.4853 3.92893L19.0319 5.38231C20.2635 6.92199 21 8.87499 21 11V12H3V11C3 8.87499 3.73647 6.92199 4.9681 5.38231L3.51472 3.92893L4.92893 2.51472L6.38231 3.9681ZM3 14H21V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V14ZM9 9C9.55228 9 10 8.55228 10 8C10 7.44772 9.55228 7 9 7C8.44772 7 8 7.44772 8 8C8 8.55228 8.44772 9 9 9ZM15 9C15.5523 9 16 8.55228 16 8C16 7.44772 15.5523 7 15 7C14.4477 7 14 7.44772 14 8C14 8.55228 14.4477 9 15 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5e717ea862a63615(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13H5V20H19V13ZM19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11H19ZM6.38231 3.9681C7.92199 2.73647 9.87499 2 12 2C14.125 2 16.078 2.73647 17.6177 3.9681L19.0711 2.51472L20.4853 3.92893L19.0319 5.38231C20.2635 6.92199 21 8.87499 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 8.87499 3.73647 6.92199 4.9681 5.38231L3.51472 3.92893L4.92893 2.51472L6.38231 3.9681ZM9 9C8.44772 9 8 8.55228 8 8C8 7.44772 8.44772 7 9 7C9.55228 7 10 7.44772 10 8C10 8.55228 9.55228 9 9 9ZM15 9C14.4477 9 14 8.55228 14 8C14 7.44772 14.4477 7 15 7C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$640496529d1396fc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0002 2L21.3002 5.32L19.8817 17.63L12.0002 22L4.11867 17.63L2.7002 5.32L12.0002 2ZM12.0002 4.21L6.18645 17.26H8.35412L9.52286 14.34H14.4576L15.6263 17.26H17.794L12.0002 4.21ZM13.6984 12.54H10.302L12.0002 8.45L13.6984 12.54Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$35b666e40c061c9b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5235 16.6507L18.0126 16.3795L19.1315 6.66941L12.0002 4.12362L4.86892 6.66941L5.98781 16.3795L6.46166 16.6422L12.0002 4.21L17.5235 16.6507ZM16.4246 17.26H15.6263L14.4576 14.34H9.52286L8.35412 17.26H7.57582L12.0002 19.7131L16.4246 17.26ZM12.0002 2L21.3002 5.32L19.8817 17.63L12.0002 22L4.11867 17.63L2.7002 5.32L12.0002 2ZM13.6984 12.54L12.0002 8.45L10.302 12.54H13.6984Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$33353869e66410c6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM8.82258 15.3427C8.42804 14.8663 7.9373 14.6957 7.34401 14.834L7.19355 14.875L6.60484 15.8911C6.37903 16.2863 6.5121 16.7903 6.90726 17.0161C7.26949 17.2231 7.7232 17.1286 7.97023 16.807L8.03226 16.7137L8.82258 15.3427ZM13.2097 8.66129C12.7218 9.06452 12.2298 10.2581 12.9194 11.4476L15.9597 16.7137C16.1895 17.1089 16.6895 17.2419 17.0847 17.0161C17.4469 16.8054 17.5889 16.3677 17.4361 15.9919L17.3871 15.8911L16.5847 14.5H17.7742C18.2298 14.5 18.5968 14.1331 18.5968 13.6774C18.5968 13.2568 18.2841 12.9118 17.8776 12.8612L17.7742 12.8548H15.6331L13.44 9.05741L13.2097 8.66129ZM13.4879 5.61694C13.1257 5.40995 12.672 5.50451 12.4249 5.82608L12.3629 5.91935L11.996 6.55242L11.6371 5.91935C11.4073 5.52419 10.9073 5.39113 10.5121 5.61694C10.1499 5.82762 10.0079 6.26532 10.1606 6.64118L10.2097 6.74194L11.0484 8.19758L8.3629 12.8508H6.26613C5.81048 12.8508 5.44355 13.2177 5.44355 13.6734C5.44355 14.094 5.7562 14.439 6.16268 14.4896L6.26613 14.496H13.746C14.0869 13.8562 13.6854 12.9472 12.9357 12.8579L12.8145 12.8508H10.2621L13.7903 6.74194C14.0161 6.34677 13.8831 5.84274 13.4879 5.61694Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9d0435a646ef2382(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM8.82258 15.3427L8.03226 16.7137C7.80645 17.1089 7.30242 17.2419 6.90726 17.0161C6.5121 16.7903 6.37903 16.2863 6.60484 15.8911L7.19355 14.875C7.85484 14.6694 8.39516 14.8266 8.82258 15.3427ZM13.2097 8.66129L15.6331 12.8548H17.7742C18.2298 12.8548 18.5968 13.2218 18.5968 13.6774C18.5968 14.1331 18.2298 14.5 17.7742 14.5H16.5847L17.3871 15.8911C17.6129 16.2863 17.4798 16.7863 17.0847 17.0161C16.6895 17.2419 16.1895 17.1089 15.9597 16.7137L12.9194 11.4476C12.2298 10.2581 12.7218 9.06452 13.2097 8.66129ZM13.4879 5.61694C13.8831 5.84274 14.0161 6.34677 13.7903 6.74194L10.2621 12.8508H12.8145C13.6411 12.8508 14.1048 13.8226 13.746 14.496H6.26613C5.81048 14.496 5.44355 14.129 5.44355 13.6734C5.44355 13.2177 5.81048 12.8508 6.26613 12.8508H8.3629L11.0484 8.19758L10.2097 6.74194C9.98387 6.34677 10.1169 5.84677 10.5121 5.61694C10.9073 5.39113 11.4073 5.52419 11.6371 5.91935L11.996 6.55242L12.3629 5.91935C12.5887 5.52419 13.0927 5.39113 13.4879 5.61694Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6d708324810dfc3b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.6734 7.2221C10.7974 7.2221 9.44138 6.2261 8.01338 6.2621C6.12938 6.2861 4.40138 7.3541 3.42938 9.0461C1.47338 12.4421 2.92538 17.4581 4.83338 20.2181C5.76938 21.5621 6.87338 23.0741 8.33738 23.0261C9.74138 22.9661 10.2694 22.1141 11.9734 22.1141C13.6654 22.1141 14.1454 23.0261 15.6334 22.9901C17.1454 22.9661 18.1054 21.6221 19.0294 20.2661C20.0974 18.7061 20.5414 17.1941 20.5654 17.1101C20.5294 17.0981 17.6254 15.9821 17.5894 12.6221C17.5654 9.8141 19.8814 8.4701 19.9894 8.4101C18.6694 6.4781 16.6414 6.2621 15.9334 6.2141C14.0854 6.0701 12.5374 7.2221 11.6734 7.2221ZM14.7934 4.3901C15.5734 3.4541 16.0894 2.1461 15.9454 0.850098C14.8294 0.898098 13.4854 1.5941 12.6814 2.5301C11.9614 3.3581 11.3374 4.6901 11.5054 5.9621C12.7414 6.0581 14.0134 5.3261 14.7934 4.3901Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$574c696e73066ea7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.778 8.20805C15.3053 8.17122 14.7974 8.28446 14.0197 8.58079C14.085 8.55589 13.2775 8.87185 13.0511 8.95089C12.5494 9.12605 12.1364 9.2221 11.6734 9.2221C11.2151 9.2221 10.7925 9.13054 10.3078 8.96695C10.1524 8.91453 9.99616 8.85652 9.80283 8.78102C9.71993 8.74864 9.41997 8.62959 9.3544 8.60391C8.70626 8.35008 8.34154 8.25446 8.03885 8.26194C6.88626 8.27662 5.79557 8.94222 5.16246 10.0443C3.87037 12.2876 4.58583 16.3429 6.47459 19.0751C7.4802 20.5191 8.03062 21.0351 8.25199 21.028C8.4743 21.0184 8.63777 20.9714 9.03567 20.8027C9.11485 20.769 9.11485 20.769 9.202 20.7318C10.2077 20.3033 10.9118 20.1141 11.9734 20.1141C12.9944 20.1141 13.6763 20.2999 14.6416 20.716C14.7302 20.7543 14.7302 20.7543 14.8097 20.7885C15.2074 20.9589 15.3509 20.9963 15.6016 20.9903C15.9591 20.9847 16.4003 20.5727 17.3791 19.1363C17.6471 18.7448 17.884 18.3334 18.0895 17.9169C17.9573 17.8078 17.826 17.6918 17.6975 17.5694C16.4086 16.3409 15.6114 14.6846 15.5895 12.6392C15.5756 11.0188 16.1057 9.61499 16.999 8.4581C16.6293 8.31432 16.2216 8.23817 15.778 8.20805ZM15.9334 6.2141C16.6414 6.2621 18.6694 6.4781 19.9894 8.4101C19.8814 8.4701 17.5654 9.8141 17.5894 12.6221C17.6254 15.9821 20.5294 17.0981 20.5654 17.1101C20.5414 17.1941 20.0974 18.7061 19.0294 20.2661C18.1054 21.6221 17.1454 22.9661 15.6334 22.9901C14.1454 23.0261 13.6654 22.1141 11.9734 22.1141C10.2694 22.1141 9.74138 22.9661 8.33738 23.0261C6.87338 23.0741 5.76938 21.5621 4.83338 20.2181C2.92538 17.4581 1.47338 12.4421 3.42938 9.0461C4.40138 7.3541 6.12938 6.2861 8.01338 6.2621C9.44138 6.2261 10.7974 7.2221 11.6734 7.2221C12.5374 7.2221 14.0854 6.0701 15.9334 6.2141ZM14.7934 4.3901C14.0134 5.3261 12.7414 6.0581 11.5054 5.9621C11.3374 4.6901 11.9614 3.3581 12.6814 2.5301C13.4854 1.5941 14.8294 0.898098 15.9454 0.850098C16.0894 2.1461 15.5734 3.4541 14.7934 4.3901Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$68458e5d705eb787(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.92636 12.4965C7.98921 12.0535 7.70815 9.5883 7.64641 9.04949C7.54538 8.21882 6.56836 6.76688 5.24162 6.88173C3.57208 7.03154 3.32815 9.44324 3.32815 9.44324C3.10235 10.558 3.86869 12.9399 5.92636 12.4965ZM8.11701 16.7845C8.05656 16.9577 7.92186 17.4011 8.03843 17.787C8.26855 18.6531 9.02021 18.692 9.02021 18.692H10.1004V16.0514H8.94379C8.42397 16.2064 8.17313 16.611 8.11701 16.7845ZM9.75503 8.36259C10.8944 8.36259 11.8153 7.0514 11.8153 5.43022C11.8153 3.81076 10.8944 2.5 9.75503 2.5C8.61739 2.5 7.69433 3.81076 7.69433 5.43022C7.69433 7.0514 8.61783 8.36259 9.75503 8.36259ZM14.6622 8.55644C16.1849 8.75418 17.1641 7.12911 17.3588 5.89736C17.5574 4.66733 16.5748 3.23871 15.4967 2.99305C14.4165 2.74523 13.0678 4.47564 12.9447 5.60378C12.7979 6.98275 13.142 8.36087 14.6622 8.55644ZM14.6617 12.0039C12.7975 9.09914 10.1492 10.2812 9.26328 11.7587C8.38123 13.2356 7.00657 14.1699 6.81143 14.4173C6.61326 14.6608 3.9654 16.0903 4.55343 18.701C5.14103 21.31 7.20561 21.2604 7.20561 21.2604C7.20561 21.2604 8.72706 21.4102 10.492 21.0152C12.2578 20.6236 13.778 21.1127 13.778 21.1127C13.778 21.1127 17.9024 22.4939 19.031 19.8352C20.1582 17.1757 18.3933 15.7967 18.3933 15.7967C18.3933 15.7967 16.0373 13.9739 14.6617 12.0039ZM8.65496 19.7536C7.49703 19.5226 7.03593 18.7325 6.97765 18.5978C6.92066 18.461 6.59167 17.8259 6.76566 16.7453C7.26605 15.1262 8.69295 15.0101 8.69295 15.0101H10.1203V13.2555L11.3361 13.2741V19.7536H8.65496ZM13.2448 19.735C12.0489 19.4268 11.9932 18.5771 11.9932 18.5771V15.1651L13.2448 15.1448V18.2114C13.3212 18.5387 13.7275 18.5978 13.7275 18.5978H14.9989V15.1651H16.3304V19.735H13.2448ZM20.6983 10.6249C20.6983 10.0356 20.2087 8.26113 18.3933 8.26113C16.5748 8.26113 16.3317 9.93585 16.3317 11.1197C16.3317 12.2495 16.4271 13.8267 18.686 13.7766C20.9457 13.7265 20.6983 11.2173 20.6983 10.6249Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2c2c8c51b09b6cea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.56331 19.2798C7.73337 19.2876 7.92984 19.2906 8.14727 19.2863C8.77279 19.2739 9.4239 19.2047 10.059 19.0626C11.0716 18.838 12.0771 18.8143 13.0395 18.9318C13.5864 18.9986 14.0247 19.0969 14.3275 19.1891C15.4052 19.4638 16.9386 19.4119 17.3331 18.7782C17.6238 18.3113 17.5856 17.9916 17.3071 17.5803C17.2466 17.4909 17.1809 17.4105 17.1185 17.3445C17.1097 17.3351 17.1016 17.3269 17.0945 17.3197C17.0282 17.267 16.9917 17.2377 16.9302 17.1878C16.7544 17.0449 16.5599 16.8823 16.3513 16.702C15.7559 16.1875 15.1602 15.6296 14.5987 15.0426C13.9929 14.4095 13.461 13.7777 13.0219 13.1489L12.9861 13.0958C12.2441 11.9571 11.428 12.029 10.9837 12.7785C10.7019 13.254 10.3821 13.696 10.029 14.1105C9.61853 14.5924 9.19882 15.0001 8.72348 15.4067C8.60056 15.5119 8.22086 15.8269 8.31171 15.751C8.30802 15.7541 8.29484 15.7661 8.36265 15.6797C8.26441 15.8004 7.41258 16.5574 7.16177 16.8417C6.64726 17.4248 6.44014 17.9224 6.51725 18.3224C6.58965 18.6978 6.73623 18.9089 6.96754 19.0667C7.08515 19.1469 7.22108 19.2086 7.35634 19.2494C7.39091 19.2598 7.42153 19.2677 7.44674 19.2732C7.48007 19.2755 7.51904 19.2777 7.56331 19.2798ZM14.6617 12.0039C16.0373 13.9739 18.3933 15.7967 18.3933 15.7967C18.3933 15.7967 20.4569 17.5447 19.031 19.8352C17.605 22.1257 13.778 21.1127 13.778 21.1127C13.778 21.1127 12.2578 20.6236 10.492 21.0152C8.72706 21.4102 7.20561 21.2604 7.20561 21.2604C7.20561 21.2604 4.99964 21.0152 4.55343 18.701C4.10721 16.3869 6.61326 14.6608 6.81143 14.4173C7.00657 14.1699 8.32336 13.3442 9.26328 11.7587C10.2032 10.1731 12.8471 9.21909 14.6617 12.0039ZM20.2002 10.5846C20.2002 11.0415 20.391 12.9772 18.6478 13.0158C16.9053 13.0544 16.8317 11.8378 16.8317 10.9662C16.8317 10.053 17.0192 8.76113 18.422 8.76113C19.8225 8.76113 20.2002 10.13 20.2002 10.5846ZM14.7711 7.80669C13.591 7.65486 13.3238 6.58499 13.4378 5.51446C13.5333 4.63866 14.5804 3.2953 15.419 3.48769C16.2559 3.6784 17.0188 4.78748 16.8646 5.74238C16.7134 6.69862 15.9533 7.9602 14.7711 7.80669ZM9.75498 7.43996C8.89373 7.43996 8.19433 6.44695 8.19433 5.21916C8.19433 3.99269 8.8934 3 9.75498 3C10.6179 3 11.3153 3.99269 11.3153 5.21916C11.3153 6.44695 10.6179 7.43996 9.75498 7.43996ZM5.96186 12.0061C4.26673 12.3714 3.63542 10.4091 3.82144 9.49078C3.82144 9.49078 4.02239 7.50401 5.39776 7.38059C6.49074 7.28599 7.29562 8.4821 7.37884 9.16641C7.42971 9.61029 7.66125 11.6412 5.96186 12.0061Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7eeaa62946fbf165(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.6144 17.7956 11.492 15.7854C12.2731 13.9966 13.6789 12.5726 15.4325 11.7942L17.8482 10.7219C18.6162 10.381 18.6162 9.26368 17.8482 8.92277L15.5079 7.88394C13.7092 7.08552 12.2782 5.60881 11.5105 3.75894L10.6215 1.61673C10.2916.821765 9.19319.821767 8.8633 1.61673L7.97427 3.75892C7.20657 5.60881 5.77553 7.08552 3.97685 7.88394L1.63658 8.92277C.868537 9.26368.868536 10.381 1.63658 10.7219L4.0523 11.7942C5.80589 12.5726 7.21171 13.9966 7.99275 15.7854L8.8704 17.7956C9.20776 18.5682 10.277 18.5682 10.6144 17.7956ZM19.4014 22.6899 19.6482 22.1242C20.0882 21.1156 20.8807 20.3125 21.8695 19.8732L22.6299 19.5353C23.0412 19.3526 23.0412 18.7549 22.6299 18.5722L21.9121 18.2532C20.8978 17.8026 20.0911 16.9698 19.6586 15.9269L19.4052 15.3156C19.2285 14.8896 18.6395 14.8896 18.4628 15.3156L18.2094 15.9269C17.777 16.9698 16.9703 17.8026 15.956 18.2532L15.2381 18.5722C14.8269 18.7549 14.8269 19.3526 15.2381 19.5353L15.9985 19.8732C16.9874 20.3125 17.7798 21.1156 18.2198 22.1242L18.4667 22.6899C18.6473 23.104 19.2207 23.104 19.4014 22.6899Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8f01c03949f7f8d8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.6144 17.7956C10.277 18.5682 9.20776 18.5682 8.8704 17.7956L7.99275 15.7854C7.21171 13.9966 5.80589 12.5726 4.0523 11.7942L1.63658 10.7219C.868536 10.381.868537 9.26368 1.63658 8.92276L3.97685 7.88394C5.77553 7.08552 7.20657 5.60881 7.97427 3.75892L8.8633 1.61673C9.19319.821767 10.2916.821765 10.6215 1.61673L11.5105 3.75894C12.2782 5.60881 13.7092 7.08552 15.5079 7.88394L17.8482 8.92276C18.6162 9.26368 18.6162 10.381 17.8482 10.7219L15.4325 11.7942C13.6789 12.5726 12.2731 13.9966 11.492 15.7854L10.6144 17.7956ZM4.53956 9.82234C6.8254 10.837 8.68402 12.5048 9.74238 14.7996 10.8008 12.5048 12.6594 10.837 14.9452 9.82234 12.6321 8.79557 10.7676 7.04647 9.74239 4.71088 8.71719 7.04648 6.85267 8.79557 4.53956 9.82234ZM19.4014 22.6899 19.6482 22.1242C20.0882 21.1156 20.8807 20.3125 21.8695 19.8732L22.6299 19.5353C23.0412 19.3526 23.0412 18.7549 22.6299 18.5722L21.9121 18.2532C20.8978 17.8026 20.0911 16.9698 19.6586 15.9269L19.4052 15.3156C19.2285 14.8896 18.6395 14.8896 18.4628 15.3156L18.2094 15.9269C17.777 16.9698 16.9703 17.8026 15.956 18.2532L15.2381 18.5722C14.8269 18.7549 14.8269 19.3526 15.2381 19.5353L15.9985 19.8732C16.9874 20.3125 17.7798 21.1156 18.2198 22.1242L18.4667 22.6899C18.6473 23.104 19.2207 23.104 19.4014 22.6899ZM18.3745 19.0469 18.937 18.4883 19.4878 19.0469 18.937 19.5898 18.3745 19.0469Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$749d02fddcbbae11(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.44262 5.3501C8.08197 5.3501 8.67213 5.39957 9.21311 5.54798C9.7541 5.64692 10.1967 5.8448 10.5902 6.09215C10.9836 6.3395 11.2787 6.68579 11.4754 7.13102C11.6721 7.57625 11.7705 8.12042 11.7705 8.71406C11.7705 9.40664 11.623 10.0003 11.2787 10.4455C10.9836 10.8907 10.4918 11.2865 9.90164 11.5833C10.7377 11.8307 11.377 12.2759 11.7705 12.8695C12.1639 13.4632 12.4098 14.2052 12.4098 15.0462C12.4098 15.7388 12.2623 16.3324 12.0164 16.8271C11.7705 17.3218 11.377 17.7671 10.9344 18.0639C10.4918 18.3607 9.95082 18.608 9.36066 18.7565C8.77049 18.9049 8.18033 19.0038 7.59016 19.0038H1V5.3501H7.44262ZM7.04918 10.8907C7.59016 10.8907 8.03279 10.7423 8.37705 10.495C8.72131 10.2476 8.86885 9.80239 8.86885 9.25822C8.86885 8.96141 8.81967 8.66458 8.72131 8.4667C8.62295 8.26883 8.47541 8.12042 8.27869 7.97201C8.08197 7.87307 7.88525 7.77413 7.63934 7.72466C7.39344 7.67519 7.14754 7.67519 6.85246 7.67519H4V10.8907H7.04918ZM7.19672 16.7282C7.4918 16.7282 7.78689 16.6787 8.03279 16.6292C8.27869 16.5798 8.52459 16.4808 8.72131 16.3324C8.91803 16.184 9.06557 16.0356 9.21311 15.7883C9.31148 15.5409 9.40984 15.2441 9.40984 14.8978C9.40984 14.2052 9.21312 13.7105 8.81967 13.3642C8.42623 13.0674 7.88525 12.919 7.2459 12.919H4V16.7282H7.19672ZM16.6885 16.6787C17.082 17.0745 17.6721 17.2724 18.459 17.2724C19 17.2724 19.4918 17.1239 19.8852 16.8766C20.2787 16.5798 20.5246 16.283 20.623 15.9861H23.0328C22.6393 17.1734 22.0492 18.0144 21.2623 18.5586C20.4754 19.0533 19.541 19.3501 18.4098 19.3501C17.6229 19.3501 16.9344 19.2017 16.2951 18.9543C15.6557 18.707 15.1639 18.3607 14.7213 17.866C14.2787 17.4208 13.9344 16.8766 13.7377 16.2335C13.4918 15.5904 13.3934 14.8978 13.3934 14.1063C13.3934 13.3642 13.4918 12.6717 13.7377 12.0285C13.9836 11.3854 14.3279 10.8413 14.7705 10.3466C15.2131 9.90133 15.7541 9.50557 16.3443 9.25822C16.9836 9.01087 17.6229 8.86246 18.4098 8.86246C19.2459 8.86246 19.9836 9.01088 20.623 9.35716C21.2623 9.70345 21.7541 10.0992 22.1475 10.6929C22.541 11.237 22.8361 11.8801 23.0328 12.5727C23.1311 13.2653 23.1803 13.9579 23.1311 14.7494H16C16 15.5409 16.2951 16.283 16.6885 16.6787ZM19.7869 11.4844C19.4426 11.1381 18.9016 10.9402 18.2623 10.9402C17.8197 10.9402 17.4754 11.0391 17.1803 11.1876C16.8852 11.336 16.6885 11.5338 16.4918 11.7317C16.2951 11.9296 16.1967 12.177 16.1475 12.4243C16.0984 12.6717 16.0492 12.8695 16.0492 13.0674H20.4754C20.3771 12.3254 20.1311 11.8307 19.7869 11.4844ZM15.459 6.29003H20.9672V7.62572H15.459V6.29003Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e0e71c44fcb89aed(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 11C8.60457 11 9.5 10.1046 9.5 9C9.5 7.89543 8.60457 7 7.5 7H3V11H7.5ZM8.5 13H3V17H8.5C9.60457 17 10.5 16.1046 10.5 15C10.5 13.8954 9.60457 13 8.5 13ZM10.5632 11.5725C11.7239 12.2726 12.5 13.5457 12.5 15C12.5 17.2091 10.7091 19 8.5 19H1V5H7.5C9.70914 5 11.5 6.79086 11.5 9C11.5 9.97964 11.1478 10.877 10.5632 11.5725ZM15.5 6H21V7.5H15.5V6ZM23 14.5H15.5V14.75C15.5 16.2688 16.7312 17.5 18.25 17.5C19.3187 17.5 20.245 16.8904 20.7001 16H22.8338C22.2851 18.0169 20.4407 19.5 18.25 19.5C15.6266 19.5 13.5 17.3734 13.5 14.75V13.25C13.5 10.6266 15.6266 8.5 18.25 8.5C20.8734 8.5 23 10.6266 23 13.25V14.5ZM20.8965 12.5C20.57 11.3457 19.5088 10.5 18.25 10.5C16.9912 10.5 15.93 11.3457 15.6035 12.5H20.8965Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$60e48caeb59fee89(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.223 3.08584C18.7112 3.574 18.7112 4.36545 18.223 4.85361L17.08 5.99598L18.25 5.99638C20.3211 5.99638 22 7.67531 22 9.74638V17.2464C22 19.3174 20.3211 20.9964 18.25 20.9964H5.75C3.67893 20.9964 2 19.3174 2 17.2464V9.74638C2 7.67531 3.67893 5.99638 5.75 5.99638L6.91625 5.99598L5.77466 4.85456C5.28651 4.36641 5.28651 3.57495 5.77466 3.0868C6.26282 2.59864 7.05427 2.59864 7.54243 3.0868L10.1941 5.73845C10.2729 5.81729 10.339 5.90403 10.3924 5.99614L13.6046 5.99636C13.6581 5.90382 13.7244 5.81667 13.8036 5.73749L16.4553 3.08584C16.9434 2.59769 17.7349 2.59769 18.223 3.08584ZM18.25 8.50638H5.75C5.09102 8.50638 4.55115 9.0163 4.50343 9.66309L4.5 9.75638V17.2564C4.5 17.9154 5.00992 18.4552 5.65671 18.5029L5.75 18.5064H18.25C18.909 18.5064 19.4489 17.9965 19.4966 17.3497L19.5 17.2564V9.75638C19.5 9.06602 18.9404 8.50638 18.25 8.50638ZM8.25 11.0064C8.94036 11.0064 9.5 11.566 9.5 12.2564V13.5064C9.5 14.1967 8.94036 14.7564 8.25 14.7564C7.55964 14.7564 7 14.1967 7 13.5064V12.2564C7 11.566 7.55964 11.0064 8.25 11.0064ZM15.75 11.0064C16.4404 11.0064 17 11.566 17 12.2564V13.5064C17 14.1967 16.4404 14.7564 15.75 14.7564C15.0596 14.7564 14.5 14.1967 14.5 13.5064V12.2564C14.5 11.566 15.0596 11.0064 15.75 11.0064Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4a5221c74310a65(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.17157 2.75725L10.414 5.99936H13.585L16.8284 2.75725C17.219 2.36672 17.8521 2.36672 18.2426 2.75725C18.6332 3.14777 18.6332 3.78094 18.2426 4.17146L16.414 5.99936L18.5 5.99989C20.433 5.99989 22 7.56689 22 9.49989V17.4999C22 19.4329 20.433 20.9999 18.5 20.9999H5.5C3.567 20.9999 2 19.4329 2 17.4999V9.49989C2 7.56689 3.567 5.99989 5.5 5.99989L7.585 5.99936L5.75736 4.17146C5.36684 3.78094 5.36684 3.14777 5.75736 2.75725C6.14788 2.36672 6.78105 2.36672 7.17157 2.75725ZM18.5 7.99989H5.5C4.7203 7.99989 4.07955 8.59478 4.00687 9.35543L4 9.49989V17.4999C4 18.2796 4.59489 18.9203 5.35554 18.993L5.5 18.9999H18.5C19.2797 18.9999 19.9204 18.405 19.9931 17.6444L20 17.4999V9.49989C20 8.67146 19.3284 7.99989 18.5 7.99989ZM8 10.9999C8.55228 10.9999 9 11.4476 9 11.9999V13.9999C9 14.5522 8.55228 14.9999 8 14.9999C7.44772 14.9999 7 14.5522 7 13.9999V11.9999C7 11.4476 7.44772 10.9999 8 10.9999ZM16 10.9999C16.5523 10.9999 17 11.4476 17 11.9999V13.9999C17 14.5522 16.5523 14.9999 16 14.9999C15.4477 14.9999 15 14.5522 15 13.9999V11.9999C15 11.4476 15.4477 10.9999 16 10.9999Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d52bddcaa60d4f2f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.78934 15.7141C7.64573 15.2585 7.54999 14.6752 7.54472 14.375 7.53944 14.076 7.60516 13.5778 7.60516 13.5778L3.09648 17.2679C2.30907 17.904 1.24985 17.9027.751679 17.2642.260811 16.6362.512736 15.6439 1.29204 15.0472L9.58486 8.68254 4.95651 8.68863C4.17152 8.68579 3.65875 8.15679 3.80642 7.51907 3.95003 6.89311 4.67578 6.39778 5.43074 6.39697L14.5767 6.38723 11.582 3.94831C11.1155 3.56576 11.1755 2.95927 11.6996 2.59254 12.2181 2.22987 13.0108 2.22865 13.4822 2.59051L20.6858 8.1219 20.6841 8.12312C21.3961 8.67524 21.9949 9.33122 22.4594 10.0805 22.9673 10.8959 23.2971 11.7904 23.4326 12.7438 23.502 13.233 23.5178 13.7227 23.4801 14.2115 23.4415 14.7076 23.3454 15.2022 23.1933 15.6894 22.8906 16.6537 22.3795 17.5474 21.6675 18.3368 20.9377 19.1453 20.0383 19.7972 18.9986 20.2626 17.9057 20.7502 16.7215 21.0017 15.4935 21.0033 14.2635 21.0053 13.0794 20.7587 11.9865 20.2747 10.9467 19.8139 10.0465 19.1648 9.31549 18.3567 8.60313 17.5705 8.09116 16.6784 7.78934 15.7141ZM15.4935 17.5291C16.9008 17.5263 18.2014 16.9896 19.1304 16.0431 19.5844 15.5807 19.9166 15.0508 20.1227 14.4849 20.3243 13.93 20.4026 13.3421 20.3515 12.749 20.3004 12.1669 20.1288 11.6152 19.8517 11.1146 19.5807 10.6229 19.2079 10.1795 18.7479 9.80464 17.844 9.07118 16.6951 8.67646 15.4915 8.67808 14.2891 8.6797 13.1394 9.07808 12.2364 9.81397 11.7755 10.1904 11.4023 10.6355 11.1313 11.128 10.8554 11.629 10.6826 12.1827 10.6335 12.7632 10.5816 13.3571 10.6599 13.9458 10.8615 14.5003 11.0672 15.0646 11.4007 15.5944 11.8546 16.0549 12.7836 16.9997 14.0842 17.5315 15.4935 17.5291ZM13.4751 10.9034C14.0308 10.4328 14.7789 10.1452 15.5951 10.1452 16.4105 10.1452 17.1586 10.4328 17.7148 10.9034 18.2811 11.3825 18.6568 12.0583 18.7002 12.8247 18.7432 13.6129 18.4263 14.3451 17.8706 14.8879 17.3038 15.44 16.4978 15.7865 15.5951 15.7865 14.6925 15.7865 13.8848 15.44 13.3185 14.8879 12.7623 14.3451 12.4463 13.6129 12.4897 12.8255 12.5327 12.0583 12.9083 11.3825 13.4751 10.9034ZM13.4751 10.9034C12.9083 11.3825 12.5327 12.0583 12.4897 12.8255 12.4463 13.6129 12.7623 14.3451 13.3185 14.8879 13.8848 15.44 14.6925 15.7865 15.5951 15.7865 16.4978 15.7865 17.3038 15.44 17.8706 14.8879 18.4263 14.3451 18.7432 13.6129 18.7002 12.8247 18.6568 12.0583 18.2811 11.3825 17.7148 10.9034 17.1586 10.4328 16.4105 10.1452 15.5951 10.1452 14.7789 10.1452 14.0308 10.4328 13.4751 10.9034ZM7.78934 15.7141C7.64573 15.2585 7.54999 14.6752 7.54472 14.375 7.53944 14.076 7.60516 13.5778 7.60516 13.5778L3.09648 17.2679C2.30907 17.904 1.24985 17.9027.751679 17.2642.260811 16.6362.512736 15.6439 1.29204 15.0472L9.58486 8.68254 4.95651 8.68863C4.17152 8.68579 3.65875 8.15679 3.80642 7.51907 3.95003 6.89311 4.67578 6.39778 5.43074 6.39697L14.5767 6.38723 11.582 3.94831C11.1155 3.56576 11.1755 2.95927 11.6996 2.59254 12.2181 2.22987 13.0108 2.22865 13.4822 2.59051L20.6858 8.1219 20.6841 8.12312C21.3961 8.67524 21.9949 9.33122 22.4594 10.0805 22.9673 10.8959 23.2971 11.7904 23.4326 12.7438 23.502 13.233 23.5178 13.7227 23.4801 14.2115 23.4415 14.7076 23.3454 15.2022 23.1933 15.6894 22.8906 16.6537 22.3795 17.5474 21.6675 18.3368 20.9377 19.1453 20.0383 19.7972 18.9986 20.2626 17.9057 20.7502 16.7215 21.0017 15.4935 21.0033 14.2635 21.0053 13.0794 20.7587 11.9865 20.2747 10.9467 19.8139 10.0465 19.1648 9.31549 18.3567 8.60313 17.5705 8.09116 16.6784 7.78934 15.7141ZM15.4935 17.5291C16.9008 17.5263 18.2014 16.9896 19.1304 16.0431 19.5844 15.5807 19.9166 15.0508 20.1227 14.4849 20.3243 13.93 20.4026 13.3421 20.3515 12.749 20.3004 12.1669 20.1288 11.6152 19.8517 11.1146 19.5807 10.6229 19.2079 10.1795 18.7479 9.80464 17.844 9.07118 16.6951 8.67646 15.4915 8.67808 14.2891 8.6797 13.1394 9.07808 12.2364 9.81397 11.7755 10.1904 11.4023 10.6355 11.1313 11.128 10.8554 11.629 10.6826 12.1827 10.6335 12.7632 10.5816 13.3571 10.6599 13.9458 10.8615 14.5003 11.0672 15.0646 11.4007 15.5944 11.8546 16.0549 12.7836 16.9997 14.0842 17.5315 15.4935 17.5291Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3714464e49ab5c97(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.1222 2.21716C12.6898 1.87354 12.0608 1.94549 11.7172 2.37786C11.3735 2.81023 11.4455 3.43929 11.8779 3.78291L15.2968 6.50004H4.50004C3.94775 6.50004 3.50004 6.94775 3.50004 7.50004C3.50004 8.05232 3.94775 8.50004 4.50004 8.50004H9.97176L0.878395 15.7167C0.445791 16.0601 0.373415 16.6891 0.71674 17.1217C1.06006 17.5543 1.68908 17.6267 2.12168 17.2833L7.54456 12.9796C7.51516 13.2324 7.50004 13.4894 7.50004 13.75C7.50004 17.8577 11.1913 21 15.5 21C19.8087 21 23.5 17.8577 23.5 13.75C23.5 11.5033 22.3763 9.52296 20.6647 8.21146L13.1222 2.21716ZM11.5646 9.78924C12.6109 8.99203 13.9834 8.50004 15.5 8.50004C17.0201 8.50004 18.3953 8.99422 19.4425 9.79456C20.7262 10.7757 21.5 12.1982 21.5 13.75C21.5 16.546 18.9233 19 15.5 19C12.0768 19 9.50004 16.546 9.50004 13.75C9.50004 12.2702 10.2037 10.908 11.3822 9.93395L11.5646 9.78924ZM14.4777 14.0919C14.2012 13.8314 14.0793 13.5265 14.0965 13.2102C14.1287 12.6453 14.7205 12 15.595 12C16.468 12 17.0599 12.6438 17.0932 13.209C17.1106 13.539 16.9851 13.8423 16.7153 14.0962C16.4296 14.3651 16.018 14.536 15.595 14.536C15.1815 14.536 14.7685 14.366 14.4777 14.0919ZM15.595 10C13.849 10 12.2007 11.2947 12.0996 13.0992C11.9923 15.0452 13.7253 16.536 15.595 16.536C17.471 16.536 19.1971 15.0592 19.0901 13.098C18.9879 11.2944 17.3406 10 15.595 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b7668caebab4afd0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.42333 3.03809C4.13949 3.03809 3.18953 4.16175 3.23206 5.38037C3.27286 6.55114 3.21985 8.06741 2.83811 9.30395C2.45523 10.5441 1.80769 11.3297 0.75 11.4306V12.5693C1.80769 12.6702 2.45523 13.4558 2.83811 14.6959C3.21985 15.9325 3.27286 17.4488 3.23206 18.6195C3.18953 19.838 4.13949 20.9618 5.42352 20.9618H18.5784C19.8622 20.9618 20.812 19.8382 20.7695 18.6195C20.7287 17.4488 20.7817 15.9325 21.1634 14.6959C21.5465 13.4558 22.1923 12.6702 23.25 12.5693V11.4306C22.1923 11.3297 21.5465 10.5441 21.1634 9.30395C20.7817 8.0676 20.7287 6.55114 20.7695 5.38037C20.812 4.16194 19.8622 3.03809 18.5784 3.03809H5.42314H5.42333ZM16.0042 14.0713C16.0042 15.7493 14.7526 16.7669 12.6756 16.7669H9.13983C9.03869 16.7669 8.94169 16.7267 8.87017 16.6552C8.79865 16.5837 8.75847 16.4867 8.75847 16.3855V7.61436C8.75847 7.51322 8.79865 7.41622 8.87017 7.3447C8.94169 7.27318 9.03869 7.233 9.13983 7.233H12.6554C14.3873 7.233 15.5239 8.17114 15.5239 9.61152C15.5239 10.6225 14.7593 11.5276 13.7851 11.6861V11.7389C15.1113 11.8844 16.0042 12.8027 16.0042 14.0713ZM12.29 8.4419H10.274V11.2895H11.972C13.2846 11.2895 14.0084 10.7609 14.0084 9.81612C14.0084 8.9308 13.386 8.4419 12.29 8.4419ZM10.274 12.4194V15.5576H12.3642C13.7308 15.5576 14.4548 15.0092 14.4548 13.9786C14.4548 12.9478 13.7106 12.4193 12.2763 12.4193L10.274 12.4194Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d5270ab10c3efc4b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11L1 13C1 13 3 13 3 17V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V17C21 13 23 13 23 13V11C23 11 21 11 21 7V6C21 4.34315 19.6569 3 18 3L6 3C4.34315 3 3 4.34315 3 6V7C3 11 1 11 1 11ZM20.6742 12C20.6446 12.0278 20.6151 12.0564 20.5858 12.0858C19.5784 13.0931 19 14.6917 19 17V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V17C5 14.6917 4.42157 13.0931 3.41421 12.0858C3.38486 12.0564 3.35539 12.0278 3.32582 12C3.35539 11.9722 3.38486 11.9436 3.41421 11.9142C4.42157 10.9069 5 9.30829 5 7V6C5 5.44772 5.44772 5 6 5L18 5C18.5523 5 19 5.44772 19 6V7C19 9.30829 19.5784 10.9069 20.5858 11.9142C20.6151 11.9436 20.6446 11.9722 20.6742 12ZM8.5 7V17H13.5C15.1569 17 16.5 15.6569 16.5 14C16.5 12.9377 15.9479 12.0044 15.115 11.4714C15.3601 11.0366 15.5 10.5347 15.5 10C15.5 8.34315 14.1569 7 12.5 7L8.5 7ZM10.5 11V9H12.5C13.0523 9 13.5 9.44772 13.5 10C13.5 10.5523 13.0523 11 12.5 11H10.5ZM10.5 13H13.5C14.0523 13 14.5 13.4477 14.5 14C14.5 14.5523 14.0523 15 13.5 15H10.5V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$61c71d50e2d1e645(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.0607L16.47 17.531L12 22L7.53 17.53L12 13.0607ZM3.99968 16.1207L7.87868 19.9997L4 20L3.99968 16.1207ZM19.9997 16.1207L20 20L16.1207 19.9997L19.9997 16.1207ZM17.53 7.53L22 12L17.531 16.47L13.0607 12L17.53 7.53ZM6.47 7.53L10.9393 12L6.469 16.469L2 12L6.47 7.53ZM12 2L16.469 6.469L12 10.9393L7.53 6.47L12 2ZM7.87868 3.99968L3.99968 7.87868L4 4L7.87868 3.99968ZM20 4L19.9997 7.87868L16.1207 3.99968L20 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f9baba23a5a7e58b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L16.292 6.292L17.353 5.232L16.1207 3.99968L20 4L19.9997 7.87868L18.767 6.646L17.707 7.707L22 12L17.708 16.293L18.767 17.352L19.9997 16.1207L20 20L16.1207 19.9997L17.352 18.767L16.293 17.707L12 22L7.707 17.707L6.646 18.767L7.87868 19.9997L4 20L3.99968 16.1207L5.231 17.352L6.292 16.292L2 12L6.293 7.707L5.231 6.646L3.99968 7.87868L4 4L7.87868 3.99968L6.646 5.231L7.708 6.293L12 2ZM12 13.4128L9.12 16.292L12 19.1716L14.879 16.292L12 13.4128ZM7.707 9.121L4.82843 12L7.706 14.878L10.5858 11.9986L7.707 9.121ZM16.292 9.121L13.4149 11.9993L16.293 14.878L19.1716 12L16.292 9.121ZM12 4.82843L9.122 7.707L12.0007 10.5851L14.878 7.706L12 4.82843Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6987e141276c031e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.82726 21.7633C5.34912 20.7712 2 16.7767 2 12C2 10.1779 2.48734 8.46958 3.33878 6.99834L7.62189 14.4169C8.47396 15.9571 10.1152 17 12 17C12.2023 17 12.4018 16.988 12.5978 16.9646L9.82726 21.7633ZM12 22L16.2868 14.5751C16.7396 13.8229 17 12.9419 17 12C17 10.8744 16.6281 9.83566 16.0004 9H21.5422C21.8396 9.94704 22 10.9548 22 12C22 17.5228 17.5228 22 12 22ZM14.5721 13.545C14.0473 14.4168 13.0917 15 12 15C10.8897 15 9.92024 14.3968 9.40149 13.5002L9.37313 13.4501C9.13535 13.0203 9 12.526 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 12.5465 14.8539 13.0589 14.5985 13.5002L14.5721 13.545ZM4.6322 5.23859C6.46008 3.24783 9.08432 2 12 2C15.7014 2 18.9331 4.01099 20.6622 7H12C9.93635 7 8.1647 8.25019 7.40112 10.0345L4.6322 5.23859Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4e753dcac2835519(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.3645 19.8327L12.2941 16.4905C12.1969 16.4968 12.0988 16.5 12 16.5C10.3037 16.5 8.82656 15.5614 8.0597 14.1752L4.79459 8.51986C4.28545 9.57206 4 10.7527 4 12C4 15.8578 6.73064 19.0778 10.3645 19.8327ZM12.5897 19.9786C16.7326 19.6767 20 16.2199 20 12C20 11.1269 19.8601 10.2865 19.6016 9.5H15.7422C16.2209 10.215 16.5 11.0749 16.5 12C16.5 12.8477 16.2656 13.6406 15.8581 14.3175L12.5897 19.9786ZM14.1434 13.2875L14.1651 13.25C14.3782 12.8824 14.5 12.4554 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 12.4383 9.6128 12.8503 9.81094 13.2084L9.83494 13.25C10.2669 13.9973 11.0747 14.5 12 14.5C12.9098 14.5 13.7061 14.014 14.1434 13.2875ZM6.03522 6.66871L7.9635 10.0086C8.69821 8.52222 10.2297 7.5 12 7.5H18.6153C17.1753 5.38723 14.7497 4 12 4C9.62968 4 7.50014 5.03086 6.03522 6.66871ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$856ed130706d8cb3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10.2018L9.30278 12L12 13.7982L14.6972 12L12 10.2018ZM16.5 10.7982L19.1972 9L13 4.86852V8.46482L16.5 10.7982ZM20 10.8685L18.3028 12L20 13.1315V10.8685ZM16.5 13.2018L13 15.5352V19.1315L19.1972 15L16.5 13.2018ZM11 8.46482V4.86852L4.80278 9L7.5 10.7982L11 8.46482ZM4.80278 15L11 19.1315V15.5352L7.5 13.2018L4.80278 15ZM5.69722 12L4 10.8685V13.1315L5.69722 12ZM2 9C2 8.66565 2.1671 8.35342 2.4453 8.16795L11.4453 2.16795C11.7812 1.94402 12.2188 1.94402 12.5547 2.16795L21.5547 8.16795C21.8329 8.35342 22 8.66565 22 9V15C22 15.3344 21.8329 15.6466 21.5547 15.8321L12.5547 21.8321C12.2188 22.056 11.7812 22.056 11.4453 21.8321L2.4453 15.8321C2.1671 15.6466 2 15.3344 2 15V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c08545bfa9d6cf59(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 13.2018L13 15.5352V19.1315L19.1972 15L16.5 13.2018ZM14.6972 12L12 10.2018L9.30278 12L12 13.7982L14.6972 12ZM20 10.8685L18.3028 12L20 13.1315V10.8685ZM19.1972 9L13 4.86852V8.46482L16.5 10.7982L19.1972 9ZM7.5 10.7982L11 8.46482V4.86852L4.80278 9L7.5 10.7982ZM4.80278 15L11 19.1315V15.5352L7.5 13.2018L4.80278 15ZM4 13.1315L5.69722 12L4 10.8685V13.1315ZM2 9C2 8.66565 2.1671 8.35342 2.4453 8.16795L11.4453 2.16795C11.7812 1.94402 12.2188 1.94402 12.5547 2.16795L21.5547 8.16795C21.8329 8.35342 22 8.66565 22 9V15C22 15.3344 21.8329 15.6466 21.5547 15.8321L12.5547 21.8321C12.2188 22.056 11.7812 22.056 11.4453 21.8321L2.4453 15.8321C2.1671 15.6466 2 15.3344 2 15V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1543bdb721e45071(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.66223 14.4841C8.66223 13.9312 9.11034 13.4829 9.6634 13.4829 10.2163 13.4829 10.6646 13.9312 10.6646 14.4841V16.4812C10.6646 17.0341 10.2165 17.4824 9.6634 17.4824 9.11034 17.4824 8.66223 17.0341 8.66223 16.4812V14.4841ZM15.3367 14.4841C15.3367 13.9312 14.8886 13.4829 14.3355 13.4829 13.7822 13.4829 13.3344 13.9314 13.3344 14.4841V16.4812C13.3344 17.0341 13.7825 17.4824 14.3355 17.4824 14.8886 17.4824 15.3367 17.0341 15.3367 16.4812V14.4841ZM11.9995 4.02765C11.1541 2.80927 9.40138 2.71883 8.0541 2.83958 6.51063 2.99438 5.21093 3.52495 4.48026 4.30434 3.2125 5.68959 3.15351 8.59518 3.76523 10.1949 3.70377 10.4683 3.64517 10.7453 3.60293 11.0385 2.4729 11.3362 1.32031 12.9371 1.32031 14.0819V16.2445C1.32031 16.8449 1.60059 17.3921 2.09466 17.7659 4.9186 19.8644 8.43899 21.49 11.9995 21.49 15.5599 21.49 19.0803 19.8644 21.9043 17.7659 22.3983 17.3921 22.6786 16.8449 22.6786 16.2445V14.0819C22.6786 12.9371 21.5261 11.3362 20.396 11.0385 20.3539 10.7453 20.2953 10.4683 20.2338 10.1949 20.8454 8.59518 20.7864 5.68959 19.5187 4.30434 18.788 3.52495 17.4883 2.99438 15.9449 2.83958 14.5976 2.71883 12.8449 2.80927 11.9995 4.02765ZM18.674 17.4874C17.139 18.3415 14.5891 19.4879 11.9995 19.4879 9.40986 19.4879 6.86 18.3415 5.325 17.4874V11.689C7.80186 12.6484 10.6522 12.1537 11.9975 9.93121H12.0014C13.3468 12.1537 16.1971 12.6484 18.674 11.689V17.4874ZM10.6646 6.82895C10.6646 8.41414 10.1848 10.1401 7.99479 10.1401 5.80474 10.1401 5.38758 9.61574 5.38758 8.14315 5.38758 5.80709 5.7441 4.80738 8.70396 4.80738 10.4143 4.80738 10.6646 5.35636 10.6646 6.82895ZM13.3344 6.82895C13.3344 5.35636 13.5847 4.80738 15.2951 4.80738 18.2548 4.80738 18.6114 5.80709 18.6114 8.14315 18.6114 9.61574 18.1942 10.1401 16.0042 10.1401 13.8141 10.1401 13.3344 8.41414 13.3344 6.82895Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$40adc2a75ff5fd04(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.40051 7.80002C5.40051 5.71236 6.57782 4.80034 8.57168 4.80029C9.76759 4.80027 10.7005 5.0638 10.7005 6.4C10.7005 8.21368 10.1264 10.15 8.00051 10.15C6.77216 10.15 6.20265 9.97408 5.91113 9.72598C5.66394 9.51561 5.40051 9.05684 5.40051 7.80002ZM8.57163 2.80029C5.49709 2.80037 3.40051 4.62592 3.40051 7.80002C3.40051 8.79906 3.53783 9.68933 3.93013 10.4046L3.74781 10.7693C3.25056 11.0536 2.74122 11.4328 2.32288 11.8765C1.26166 13.0021 1.35046 14.2647 1.35046 15.7C1.35046 17.9667 3.86212 19.3206 5.66543 20.0729C7.79841 20.9627 10.3423 21.5 12.0005 21.5C13.6586 21.5 16.2025 20.9627 18.3355 20.0729C20.1388 19.3206 22.6505 17.9667 22.6505 15.7C22.6505 14.2647 22.7393 13.0021 21.6781 11.8765C21.2597 11.4328 20.7504 11.0536 20.2532 10.7693L20.0709 10.4047C20.4632 9.68937 20.6005 8.79908 20.6005 7.80002C20.6005 4.62592 18.5039 2.80037 15.4294 2.80029C14.1881 2.80027 12.8109 3.05908 12.0005 4.08307C11.1902 3.05908 9.81287 2.80027 8.57163 2.80029ZM8.00051 12.15C9.6929 12.15 11.225 11.3349 12.0005 9.81566C12.776 11.3349 14.3081 12.15 16.0005 12.15C16.8955 12.15 17.77 12.0762 18.5176 11.7703C19.0291 12.3663 19.6883 12.6816 20.2229 13.2485C20.8616 13.926 20.6505 14.8327 20.6505 15.7C20.6505 16.9719 18.4846 17.8436 17.5654 18.2271C15.6234 19.0373 13.3423 19.5 12.0005 19.5C10.6586 19.5 8.37748 19.0373 6.43547 18.2271C5.51631 17.8436 3.35046 16.9719 3.35046 15.7C3.35046 14.8327 3.13931 13.926 3.77806 13.2485C4.33864 12.654 5.1192 12.4986 5.48335 11.7703C6.23093 12.0762 7.10552 12.15 8.00051 12.15ZM13.3006 6.4C13.3006 5.06379 14.2334 4.80027 15.4293 4.80029C17.4232 4.80034 18.6005 5.71236 18.6005 7.80002C18.6005 9.05684 18.3371 9.51561 18.0899 9.72598C17.7984 9.97408 17.2289 10.15 16.0005 10.15C13.8746 10.15 13.3006 8.21368 13.3006 6.4ZM8.6632 14.4842C8.6632 13.9313 9.11131 13.483 9.66437 13.483C10.2172 13.483 10.6655 13.9313 10.6655 14.4842V16.4813C10.6655 17.0342 10.2174 17.4825 9.66437 17.4825C9.11131 17.4825 8.6632 17.0342 8.6632 16.4813V14.4842ZM15.3377 14.4842C15.3377 13.9313 14.8895 13.483 14.3365 13.483C13.7832 13.483 13.3353 13.9315 13.3353 14.4842V16.4813C13.3353 17.0342 13.7834 17.4825 14.3365 17.4825C14.8895 17.4825 15.3377 17.0342 15.3377 16.4813V14.4842Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5b6147b0f6b87de9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8.32864 12.3036C8.28909 13.1546 8.36645 14.0015 8.44669 14.8484C8.45244 14.9088 8.47434 14.9217 8.52744 14.9287C8.93342 14.982 9.33986 15.0298 9.74853 15.0555C10.7131 15.116 11.6771 15.1936 12.6447 15.1398C13.1941 15.1092 13.7446 15.0924 14.2925 15.0446C15.0732 14.9766 15.8524 14.8895 16.6224 14.7333C17.5814 14.5388 18.5298 14.3079 19.4238 13.888C19.829 13.6976 20.2136 13.4729 20.537 13.1521C20.7745 12.9167 20.9448 12.6445 20.9472 12.2929C20.9493 11.9788 20.9333 11.6646 20.9022 11.3524C20.8281 10.606 20.6748 9.87659 20.4205 9.17197C19.8367 7.55443 18.9115 6.18315 17.5955 5.10253C16.4576 4.16822 15.1751 3.5396 13.744 3.23907C13.2445 3.13419 12.7381 3.09535 12.2299 3.05885C11.6571 3.01769 11.1662 3.17993 10.7418 3.57258C10.2472 4.03031 9.90481 4.5975 9.62019 5.2061C8.95309 6.63257 8.64727 8.15994 8.45434 9.71384C8.34789 10.5713 8.28789 11.435 8.32864 12.3036ZM11.8988 7.27379C12.8578 7.30486 13.6687 7.59825 14.3926 8.12993C15.2883 8.78776 15.8625 9.65802 16.1068 10.742C16.1752 11.0457 16.2039 11.3537 16.2104 11.6637C16.2148 11.8727 16.1005 12.0258 15.9478 12.1541C15.6412 12.4116 15.2773 12.5552 14.898 12.6615C14.1573 12.8692 13.4021 12.9885 12.6328 13.028C12.1326 13.0537 11.6331 13.0628 11.133 13.038C10.9406 13.0285 10.7485 13.0136 10.5561 13.0061C10.4964 13.0038 10.4758 12.9861 10.4725 12.9246C10.4491 12.4909 10.4152 12.0572 10.4219 11.6228C10.4376 10.5969 10.5163 9.57811 10.819 8.5893C10.9197 8.26005 11.0423 7.93967 11.2396 7.6532C11.4118 7.40327 11.6175 7.21569 11.8988 7.27379Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7d4aa108061b9abc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.45447 4.41393C8.31731 4.79453 7.24869 5.4376 6.34315 6.34315C3.21895 9.46734 3.21895 14.5327 6.34315 17.6569C9.46734 20.781 14.5327 20.781 17.6569 17.6569C18.6209 16.6929 19.2874 15.544 19.6565 14.3245C16.2563 15.7834 12.4077 16.3049 8.11091 15.8891C7.39961 11.7635 7.84746 7.93846 9.45447 4.41393ZM11.9023 4.00059C11.2268 5.21641 10.7129 6.47151 10.3605 7.76913C11.853 7.80085 13.3359 8.38618 14.4749 9.52513C15.5494 10.5997 16.1312 11.9804 16.2202 13.3864C17.5495 13.0447 18.8086 12.5666 19.9999 11.9528C19.9922 10.6417 19.6642 9.33223 19.016 8.15169C18.6567 7.49783 18.202 6.88829 17.6569 6.34315C17.0828 5.76913 16.4374 5.29549 15.7442 4.92788C14.5473 4.29366 13.2232 3.98456 11.9023 4.00059ZM4.92893 19.0711C1.02369 15.1658 1.02369 8.83418 4.92893 4.92893C8.83418 1.02369 15.1658 1.02369 19.0711 4.92893C22.9763 8.83418 22.9763 15.1658 19.0711 19.0711C15.1658 22.9763 8.83418 22.9763 4.92893 19.0711ZM9.94875 9.77776C9.75716 11.1407 9.73211 12.5491 9.87338 14.0066C11.3972 14.0679 12.8495 13.9948 14.2322 13.788C14.2374 12.7576 13.8469 11.7255 13.0607 10.9393C12.2075 10.0861 11.0647 9.69895 9.94875 9.77776Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6aa9bd79822e0ee0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47717 2 2 6.47715 2 12C2 17.5229 6.47717 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47717 17.5229 2 12 2ZM16.4904 11.0399L16.4838 11.0543C16.0641 11.9522 14.9684 13.7132 14.9684 13.7132C14.9684 13.7132 14.9669 13.7091 14.9627 13.7022L14.6424 14.2596H16.1856L13.2383 18.1788L13.9074 15.5127H12.6931L13.115 13.7496C12.7736 13.832 12.3703 13.9451 11.8923 14.0988C11.8923 14.0988 11.2459 14.4774 10.0302 13.3705C10.0302 13.3705 9.21029 12.6482 9.68568 12.4676C9.88788 12.3909 10.6672 12.2935 11.2805 12.2106C12.1092 12.0985 12.619 12.0392 12.619 12.0392C12.619 12.0392 10.0641 12.0775 9.45797 11.9821C8.85178 11.8868 8.08285 10.8753 7.91909 9.98621C7.91909 9.98621 7.66575 9.49805 8.46378 9.72912C9.26178 9.96021 12.5653 10.6286 12.5653 10.6286C12.5653 10.6286 8.26903 9.31176 7.98319 8.99048C7.69727 8.66918 7.14179 7.23638 7.21412 6.35602C7.21412 6.35602 7.24548 6.13656 7.47054 6.19532C7.47054 6.19532 10.6467 7.64667 12.8184 8.44116C14.9902 9.23567 16.8784 9.63987 16.6345 10.6686C16.6136 10.7563 16.5624 10.8848 16.4904 11.0399Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$565887422a598779(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.58173 4 4 7.58172 4 12C4 16.4183 7.58173 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58173 16.4183 4 12 4ZM12 2C17.5229 2 22 6.47717 22 12C22 17.5228 17.5228 22 12 22C6.47717 22 2 17.5229 2 12C2 6.47715 6.47717 2 12 2ZM16.4904 11.0399L16.4838 11.0543C16.0641 11.9522 14.9684 13.7132 14.9684 13.7132C14.9684 13.7132 14.9669 13.7091 14.9627 13.7022L14.6424 14.2596H16.1856L13.2383 18.1788L13.9074 15.5127H12.6931L13.115 13.7496C12.7736 13.832 12.3703 13.9451 11.8923 14.0988C11.8923 14.0988 11.2459 14.4774 10.0302 13.3705C10.0302 13.3705 9.21029 12.6482 9.68568 12.4676C9.88788 12.3909 10.6672 12.2935 11.2805 12.2106C12.1092 12.0985 12.619 12.0392 12.619 12.0392C12.619 12.0392 10.0641 12.0775 9.45797 11.9821C8.85178 11.8868 8.08285 10.8753 7.91909 9.98621C7.91909 9.98621 7.66575 9.49805 8.46378 9.72912C9.26178 9.96021 12.5653 10.6286 12.5653 10.6286C12.5653 10.6286 8.26903 9.31176 7.98319 8.99048C7.69727 8.66918 7.14179 7.23638 7.21412 6.35602C7.21412 6.35602 7.24548 6.13656 7.47054 6.19532C7.47054 6.19532 10.6467 7.64667 12.8184 8.44116C14.9902 9.23567 16.8784 9.63987 16.6345 10.6686C16.6136 10.7563 16.5624 10.8848 16.4904 11.0399Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d0438539bada711e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.3034 5.33716C17.9344 4.71103 16.4805 4.2547 14.9629 4C14.7719 4.32899 14.5596 4.77471 14.411 5.12492C12.7969 4.89144 11.1944 4.89144 9.60255 5.12492C9.45397 4.77471 9.2311 4.32899 9.05068 4C7.52251 4.2547 6.06861 4.71103 4.70915 5.33716C1.96053 9.39111 1.21766 13.3495 1.5891 17.2549C3.41443 18.5815 5.17612 19.388 6.90701 19.9187C7.33151 19.3456 7.71356 18.73 8.04255 18.0827C7.41641 17.8492 6.82211 17.5627 6.24904 17.2231C6.39762 17.117 6.5462 17.0003 6.68416 16.8835C10.1438 18.4648 13.8911 18.4648 17.3082 16.8835C17.4568 17.0003 17.5948 17.117 17.7434 17.2231C17.1703 17.5627 16.576 17.8492 15.9499 18.0827C16.2789 18.73 16.6609 19.3456 17.0854 19.9187C18.8152 19.388 20.5875 18.5815 22.4033 17.2549C22.8596 12.7341 21.6806 8.80747 19.3034 5.33716ZM8.5201 14.8459C7.48007 14.8459 6.63107 13.9014 6.63107 12.7447C6.63107 11.5879 7.45884 10.6434 8.5201 10.6434C9.57071 10.6434 10.4303 11.5879 10.4091 12.7447C10.4091 13.9014 9.57071 14.8459 8.5201 14.8459ZM15.4936 14.8459C14.4535 14.8459 13.6034 13.9014 13.6034 12.7447C13.6034 11.5879 14.4323 10.6434 15.4936 10.6434C16.5442 10.6434 17.4038 11.5879 17.3825 12.7447C17.3825 13.9014 16.5548 14.8459 15.4936 14.8459Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9cf8ba1d131ceb67(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.52062 13.8456C7.48059 13.8456 6.63159 12.9011 6.63159 11.7444 6.63159 10.5876 7.45936 9.64307 8.52062 9.64307 9.57123 9.64307 10.4308 10.5876 10.4096 11.7444 10.4096 12.9011 9.57123 13.8456 8.52062 13.8456ZM15.4941 13.8456C14.454 13.8456 13.604 12.9011 13.604 11.7444 13.604 10.5876 14.4328 9.64307 15.4941 9.64307 16.5447 9.64307 17.4043 10.5876 17.3831 11.7444 17.3831 12.9011 16.5553 13.8456 15.4941 13.8456ZM10.1253 4.32272 9.81655 3.75977 9.18323 3.86532C7.71915 4.10934 6.32658 4.54652 5.02544 5.1458L4.79651 5.25124 4.65507 5.45985C2.0418 9.31417 1.3258 13.1084 1.68032 16.836L1.71897 17.2423 2.04912 17.4822C3.78851 18.7463 5.47417 19.5186 7.12727 20.0254L7.91657 20.2674 9.03013 17.5504C10.9397 18.0224 13.0592 18.0225 14.969 17.5508L16.0757 20.2681 16.8668 20.0254C18.5173 19.5191 20.2137 18.7469 21.9466 17.4809L22.2726 17.2428 22.3131 16.8412C22.7491 12.521 21.616 8.75749 19.3547 5.45628L19.2128 5.2492 18.9846 5.1448C17.6767 4.5466 16.2852 4.10957 14.8309 3.86549L14.2132 3.76182 13.8987 4.30344C13.8112 4.4542 13.7215 4.6244 13.6364 4.79662 12.5441 4.68445 11.456 4.68421 10.3726 4.79627 10.2882 4.62711 10.2025 4.46356 10.1253 4.32272ZM6.71436 16.61C6.91235 16.724 7.11973 16.8356 7.32557 16.9378L6.8764 18.0338C5.75585 17.6256 4.61837 17.0635 3.4476 16.2555 3.22313 13.1175 3.86092 9.95075 6.01196 6.68602 6.90962 6.29099 7.8535 5.98255 8.83606 5.77271 8.89631 5.89807 8.95235 6.02042 8.99839 6.12892L9.27128 6.77213 9.96259 6.67074C11.3152 6.47235 12.6772 6.47209 14.0523 6.671L14.7424 6.77082 15.0147 6.12892C15.0621 6.01719 15.1167 5.89523 15.1743 5.77298 16.1525 5.98301 17.098 6.29188 18.0029 6.68787 19.8781 9.50833 20.8241 12.6541 20.5486 16.255 19.3837 17.0623 18.2422 17.6246 17.1193 18.0333L16.6735 16.9387C16.8799 16.8362 17.0879 16.7243 17.2865 16.61 17.7763 16.3277 18.3039 15.9757 18.6402 15.6395L17.3606 14.36C17.1969 14.5237 16.837 14.7805 16.3831 15.0421 15.9388 15.2981 15.498 15.5049 15.2164 15.598 13.2126 16.2606 10.7883 16.2606 8.78443 15.598 8.50285 15.5049 8.06205 15.2981 7.61772 15.0421 7.16383 14.7805 6.80392 14.5237 6.64017 14.36L5.36065 15.6395C5.6969 15.9757 6.2245 16.3277 6.71436 16.61Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f95a021b081af3b4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C9.47017 22 7.15975 21.0606 5.39856 19.5116L1.5 20L2.92355 16.2031C2.33082 14.9253 2 13.5013 2 12C2 6.47715 6.47715 2 12 2ZM8 7.0003V17.0003H11.7335L11.9959 16.9963C15.3714 16.8928 17.3333 14.7848 17.3333 11.9714V11.9436L17.3295 11.7287C17.2307 8.95633 15.2107 7.0003 11.7896 7.0003H8ZM11.8314 9.45793C13.4594 9.45793 14.54 10.3861 14.54 11.9868V12.0147L14.5352 12.1978C14.4561 13.6979 13.3968 14.5434 11.8314 14.5434H10.723V9.45793H11.8314Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1ad1b58964197609(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9971 2C17.52 2 21.9971 6.47715 21.9971 12C21.9971 17.5228 17.52 22 11.9971 22C9.69135 22 7.50495 21.2156 5.74846 19.8078L1.03027 20.3973L2.74948 15.8116C2.2553 14.614 1.99712 13.3245 1.99712 12C1.99712 6.47715 6.47427 2 11.9971 2ZM11.9971 4C7.57884 4 3.99712 7.58172 3.99712 12C3.99712 13.178 4.25126 14.3181 4.73544 15.3619L4.91161 15.7418L4.06396 18.0027L6.37947 17.7134L6.71733 18.0105C8.16756 19.2855 10.0256 20 11.9971 20C16.4154 20 19.9971 16.4183 19.9971 12C19.9971 7.58172 16.4154 4 11.9971 4ZM8.04712 7.0003H11.8367C15.2578 7.0003 17.2778 8.95633 17.3766 11.7287L17.3805 11.9436V11.9714C17.3805 14.7848 15.4185 16.8928 12.043 16.9963L11.7806 17.0003H8.04712V7.0003H11.8367H8.04712ZM11.8785 9.45793H10.7701V14.5434H11.8785C13.4439 14.5434 14.5032 13.6979 14.5824 12.1978L14.5871 12.0147V11.9868C14.5871 10.3861 13.5065 9.45793 11.8785 9.45793Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cdb583c4adf396e6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.3143 19.1379H20.3793C20.7221 19.1379 21 19.4158 21 19.7586V20.3793C21 20.7221 20.7221 21 20.3793 21H3.62069C3.27789 21 3 20.7221 3 20.3793V19.7586C3 19.4158 3.27789 19.1379 3.62069 19.1379H7.37438L6.41379 16.0345H8.60436C8.87152 16.0345 9.10871 16.2054 9.19319 16.4589L10.0862 19.1379H13.5988L14.8236 15.1034H5.17241C4.82962 15.1034 4.55172 14.8256 4.55172 14.4828V7.34483C4.55172 7.00203 4.82962 6.72414 5.17241 6.72414H18.8276C19.1704 6.72414 19.4483 7.00203 19.4483 7.34483V14.4828C19.4483 14.8256 19.1704 15.1034 18.8276 15.1034H17.5391L16.3143 19.1379ZM3.93103 3H20.069C20.4118 3 20.6897 3.27789 20.6897 3.62069V4.24138C20.6897 4.58418 20.4118 4.86207 20.069 4.86207H3.93103C3.58824 4.86207 3.31034 4.58418 3.31034 4.24138V3.62069C3.31034 3.27789 3.58824 3 3.93103 3ZM7.18966 8.58621C7.10396 8.58621 7.03448 8.65568 7.03448 8.74138V12.7759C7.03448 12.8616 7.10396 12.931 7.18966 12.931H16.8103C16.896 12.931 16.9655 12.8616 16.9655 12.7759V8.74138C16.9655 8.65568 16.896 8.58621 16.8103 8.58621H7.18966Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c31e4ce44aa7b56(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.2735 15H5V7H19V15H17.3764L16.0767 19H21V21H3V19H7.6123L6.8 16.5L8.70211 15.882L9.71522 19H13.9738L15.2735 15ZM3.5 3H20.5V5H3.5V3ZM7 9V13H17V9H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b33b0c9df3059f50(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47939 2 2 6.47939 2 12C2 17.5206 6.47939 22 12 22C17.5098 22 22 17.5206 22 12C22 6.47939 17.5098 2 12 2ZM18.6052 6.60954C19.7983 8.06291 20.5141 9.91756 20.5358 11.9241C20.2538 11.8699 17.4338 11.295 14.5922 11.6529C14.5271 11.5119 14.4729 11.3601 14.4078 11.2083C14.2343 10.7961 14.0391 10.3731 13.8438 9.97181C16.9891 8.692 18.4208 6.84816 18.6052 6.60954ZM12 3.47506C14.1692 3.47506 16.154 4.28851 17.6616 5.62256C17.5098 5.83948 16.2191 7.56399 13.1822 8.70281C11.7831 6.13232 10.2321 4.0282 9.9935 3.70282C10.6334 3.55097 11.3059 3.47506 12 3.47506ZM8.36662 4.27766C8.59437 4.58134 10.1128 6.69631 11.5336 9.21256C7.5423 10.2755 4.01736 10.2538 3.63774 10.2538C4.19089 7.60738 5.98047 5.40564 8.36662 4.27766ZM3.45336 12.0109C3.45336 11.9241 3.45336 11.8373 3.45336 11.7506C3.82212 11.7614 7.96529 11.8156 12.2277 10.5358C12.4773 11.013 12.705 11.5011 12.9219 11.9891C12.8134 12.0217 12.6941 12.0542 12.5857 12.0868C8.18221 13.5076 5.83948 17.3904 5.64425 17.7158C4.2885 16.2083 3.45336 14.2017 3.45336 12.0109ZM12 20.5466C10.026 20.5466 8.20391 19.8742 6.76139 18.7462C6.91323 18.4317 8.64856 15.0911 13.4642 13.41C13.4859 13.3991 13.4967 13.3991 13.5184 13.3883C14.7223 16.5011 15.2104 19.1149 15.3406 19.8633C14.3102 20.308 13.1822 20.5466 12 20.5466ZM16.7614 19.0824C16.6746 18.5618 16.2191 16.0672 15.1019 12.9978C17.7809 12.5748 20.1236 13.269 20.4165 13.3666C20.0478 15.7419 18.6811 17.7917 16.7614 19.0824Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c1f7b67d20d6f458(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.9887 11.5716C19.9029 9.94513 19.3313 8.44745 18.4163 7.22097C18.1749 7.48407 17.8785 7.7698 17.4957 8.09159C16.5881 8.85458 15.4887 9.54307 14.1834 10.101C14.3498 10.4506 14.5029 10.7899 14.6376 11.1098L14.6388 11.1125C14.6652 11.1742 14.6879 11.2306 14.7321 11.3418C14.7379 11.3562 14.7433 11.3697 14.7485 11.3825C16.2621 11.2122 17.8576 11.2749 19.4049 11.4845C19.6106 11.5123 19.805 11.5415 19.9887 11.5716ZM10.6044 4.1213C10.7783 4.36621 10.9602 4.62859 11.1803 4.95378C11.7929 5.8589 12.396 6.81391 12.9604 7.79507C13.0749 7.99416 13.187 8.19289 13.2964 8.39112C14.5193 7.90993 15.5296 7.30281 16.3438 6.62486C16.6731 6.35063 16.9383 6.093 17.1403 5.86972C15.7501 4.70277 13.9571 4 12 4C11.524 4 11.0576 4.04158 10.6044 4.1213ZM4.25266 9.99755C4.83145 9.98452 5.48467 9.94941 6.29303 9.87518C7.90024 9.72758 9.54141 9.46249 11.1549 9.05274C10.5719 8.03721 9.93888 7.02331 9.29452 6.05378C8.98479 5.58775 8.68357 5.14992 8.45484 4.82642C6.39541 5.84613 4.83794 7.72658 4.25266 9.99755ZM5.78366 17.036C6.17111 16.4693 6.68061 15.8314 7.35797 15.1374C8.81199 13.6478 10.5286 12.4878 12.5139 11.8473C12.5417 11.8391 12.5604 11.8336 12.576 11.829C12.411 11.4651 12.2562 11.1405 12.1003 10.8342C10.2643 11.3687 8.3303 11.703 6.40279 11.8762C5.46319 11.9606 4.62005 11.9981 4 12.0044C4.00102 13.9112 4.66915 15.662 5.78366 17.036ZM15.0045 19.4166C14.9001 18.8745 14.7669 18.2706 14.5899 17.574C14.2689 16.3112 13.8668 15.012 13.373 13.7078C11.3712 14.4343 9.77574 15.4974 8.54309 16.7649C7.94904 17.3757 7.51244 17.9537 7.22642 18.4203C8.55892 19.4127 10.2109 20 12 20C13.0626 20 14.0769 19.7928 15.0045 19.4166ZM16.8778 18.3414C18.4073 17.1632 19.4985 15.444 19.8652 13.4703C19.5253 13.3865 19.094 13.3005 18.6196 13.2346C17.5756 13.0897 16.5014 13.0655 15.4409 13.2018C15.8933 14.4764 16.2642 15.7332 16.5608 16.9361C16.6903 17.4614 16.7958 17.9358 16.8778 18.3414ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$35a86cbb9e833f5c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.94037 4.14596L11.4217 10.1759L5.48201 20.4688L2 14.44L7.94037 4.14596ZM10.1161 14.44H22L18.518 20.4688H6.63537L10.1161 14.44ZM14.4589 13.4399L8.51799 3.14502H15.482L21.4229 13.4399H14.4589Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$883ce4d138894c35(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.09742 6.15002L4.31009 14.4429L6.06471 17.4745L10.8502 9.18584L9.09742 6.15002ZM7.79701 18.474H17.3651L19.1162 15.4399H9.54877L7.79701 18.474ZM19.1109 13.4399L14.3252 5.1499H10.8294L15.6156 13.4399H19.1109ZM8.52 3.1499H15.48L22 14.4442L18.52 20.474H5.49L2 14.4442L8.52 3.1499ZM12.0049 11.1858L10.7035 13.4399H13.3062L12.0049 11.1858Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d54d6d1fcde944d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.2847 10.6683L22.5 13.9909L17.248 17.3368L12 13.9934L6.75198 17.3368L1.5 13.9909L6.7152 10.6684L1.5 7.34587L6.75206 4L11.9999 7.34335L17.2481 4L22.5 7.34587L17.2847 10.6683ZM17.2112 10.6684L11.9999 7.3484L6.78869 10.6683L12 13.9883L17.2112 10.6684ZM6.78574 18.4456L12.0377 15.1L17.2898 18.4456L12.0377 21.7916L6.78574 18.4456Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5325ab5ade07a64b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.65039 17.2605L12.0422 19.4213L15.434 17.2605L17.2942 18.4454L12.0422 21.7914L6.79021 18.4454L8.65039 17.2605ZM7.77356 8.97982L10.1669 7.42713L7.74124 5.85326L5.28562 7.36964L7.77356 8.97982ZM9.61315 10.1704L12.0045 11.7181L14.3953 10.1707L12.0042 8.61922L9.61315 10.1704ZM13.845 12.9092L16.2689 14.478L18.7187 12.9759L16.2335 11.3634L13.845 12.9092ZM12.0042 6.23516L16.2413 3.48633L22.4656 7.32996L18.073 10.1728L22.4669 13.0237L16.2401 16.8416L12.0045 14.1004L7.76898 16.8416L1.54004 13.0238L5.93528 10.1724L1.54332 7.32996L7.7677 3.48633L12.0042 6.23516ZM13.8415 7.42724L16.2349 8.98015L18.7233 7.36963L16.2677 5.85324L13.8415 7.42724ZM10.164 12.9092L7.77487 11.363L5.2889 12.9758L7.73997 14.478L10.164 12.9092Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6c08d90f0c5847c0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.645 8.586C20.475 7.875 20.204 7.138 19.871 6.565C19.1 5.236 18.407 4.328 16.694 3.245C14.981 2.162 13.077 2 12.171 2C9.75598 2 7.95998 2.86 6.64598 3.887C3.34498 6.47 3.00098 11 3.00098 11C3.00098 11 4.22198 8.955 6.54098 7.474C7.94398 6.579 9.94198 6 11.569 6C15.886 6 16.001 10 16.001 10H9.00098C9.00098 8 10.001 7 10.001 7C10.001 7 5.00098 9 5.00098 14.044C5.00098 14.531 4.99798 15.416 5.24898 16.327C5.48098 17.17 5.94898 18.032 6.38098 18.68C7.60198 20.512 9.42598 21.294 10.297 21.584C11.293 21.916 12.326 22 13.307 22C16.027 22 18.184 21.114 19.001 20.725V16.553C18.243 17.007 16.322 18 14.001 18C9.00098 18 9.00098 14 9.00098 14H21.001V11.51C21.001 11.51 20.962 9.917 20.645 8.586Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ffc89c81ebca8b18(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.00776 14.0012C8.00326 14.0837 8.00098 14.1666 8.00098 14.25C8.00098 16.6319 9.75362 19 13.001 19C15.3739 19 17.5285 18.345 19.001 17.4465V20.7972C17.2123 21.5636 15.1135 22 13.001 22C7.49897 22 5.00098 18.5302 5.00098 14.25C5.00098 11.0187 7.04227 8.24935 9.94376 7.08603C8.53997 8.66307 8.00098 10.3413 8.00098 10.9952L18.001 11C18.001 7.59382 15.4528 5 12.001 5C7.00098 5 3.99969 8.9877 3.00098 10.9989C3.29063 6.23741 7.01012 2 12.001 2C17.201 2 21.001 6.02944 21.001 11V14H8.00098L8.00776 14.0012Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6b22dd9b1fc754d8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.817 21.8353C13.7106 21.8384 13.6049 21.84 13.5 21.84 12.4265 21.84 11.1264 21.2191 10.0806 20.0816 9.04473 18.9549 8.30005 17.363 8.30005 15.5 8.30005 14.0815 8.81836 12.9347 9.50108 12.0942 9.55796 14.5796 11.8588 17.7 16.5 17.7 18.1779 17.7 19.2172 17.2476 19.7794 17.0029 19.9878 16.9122 20.1306 16.85 20.2161 16.85 20.4 16.85 20.5 16.95 20.5 17.15 20.5 17.3366 20.3987 17.4712 20.0742 17.9023L20.0007 18C18.5223 19.9682 16.3345 21.3732 13.817 21.8353ZM10.7016 21.9165C5.79216 21.2799 2 17.0828 2 12 2 10.7202 2.74053 9.67125 3.89749 8.91922 5.05841 8.16463 6.58675 7.75 8 7.75 10.2764 7.75 11.6347 8.51511 12.4284 9.39698 12.4785 9.45269 12.5265 9.50903 12.5725 9.56586 12.3887 9.52278 12.197 9.5 12 9.5L11.996 9.5C11.5608 9.50069 11.1518 9.61255 10.7956 9.80869 10.7171 9.84506 10.6385 9.88421 10.5603 9.92588 10.0565 10.1942 9.52919 10.587 9.04942 11.0938 8.08779 12.1096 7.30005 13.6034 7.30005 15.5 7.30005 17.637 8.15534 19.4651 9.34445 20.7584 9.75828 21.2085 10.2178 21.5991 10.7016 21.9165ZM13.8515 13.5956C14.1178 13.3151 14.5 12.9123 14.5 12 14.5 11.1394 14.1625 9.82898 13.1716 8.72802 12.1653 7.60989 10.5236 6.75 8 6.75 6.41325 6.75 4.69159 7.21037 3.35251 8.08078 3.07269 8.26266 2.80734 8.46421 2.5626 8.68489 3.93023 4.7914 7.63913 2 12 2 17.5228 2 22 6 22 10.5 22 13.3 19.8 15.35 17 15.35 15 15.35 13.6 14.7 13.6 14 13.6 13.8607 13.7092 13.7456 13.8515 13.5956Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b5c434d7ae162ce1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.94904 18.2042C6.30026 16.775 6 15.201 6 14C6 12.5038 6.58998 10.907 7.60307 9.67679C8.24373 8.89885 9.0774 8.24143 10.0679 7.85877C9.58717 7.78813 9.06479 7.75 8.5 7.75C5.99051 7.75 4 9.6121 4 12C4 14.5028 5.14935 16.7372 6.94904 18.2042ZM12 20C12.9283 20 13.8197 19.8421 14.6488 19.5514C11.2851 18.9939 9.00087 16.9378 8.02881 14.5882C8.1242 15.6137 8.45824 16.8842 9.05806 17.9454C9.7767 19.2169 10.7531 20 12 20ZM16.5 12C16.5 12.474 16.4359 12.9117 16.3121 13.315C16.5177 13.3369 16.7475 13.35 17 13.35C18.7765 13.35 20 12.1161 20 10.5C20 7.37014 16.704 4 12 4C9.98053 4 8.13583 4.74827 6.72803 5.98269C7.29501 5.83052 7.89017 5.75 8.5 5.75C10.907 5.75 12.8964 6.35136 14.3071 7.46512C15.7378 8.59457 16.5 10.1977 16.5 12ZM12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 14.5 11.8 17.7 16.5 17.7C16.9419 17.7 17.3394 17.6686 17.6957 17.6179C18.0046 17.574 18.2824 17.5155 18.531 17.4504C18.7234 17.4 18.8983 17.3456 19.0566 17.2909C19.194 17.2434 19.3189 17.1956 19.4319 17.15C19.5635 17.0969 19.679 17.0466 19.7794 17.0029C19.9878 16.9122 20.1306 16.85 20.2161 16.85C20.4 16.85 20.5 16.95 20.5 17.15C20.5 17.306 20.4291 17.4257 20.2161 17.7129C20.1745 17.7691 20.1274 17.8317 20.0743 17.9022L20.0007 18C19.8289 18.2288 19.6475 18.4499 19.4571 18.6629C19.1995 18.951 18.9254 19.2241 18.6364 19.4807C16.8708 21.0481 14.5466 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6 22 10.5C22 13.3 19.8 15.35 17 15.35C15 15.35 13.6 14.7 13.6 14C13.6 13.8607 13.7092 13.7456 13.8515 13.5956C14.1178 13.3151 14.5 12.9123 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$adbc14ec5df40042(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.63007 7.75444C8.41531 7.95499 8.08524 7.97086 7.88803 7.97086H5.77723C5.16722 7.97086 4.80372 7.97086 4.55721 8.00429C4.42435 8.021 4.25973 8.08785 4.177 8.12128C4.14358 8.13715 4.14358 8.12128 4.16029 8.10456L8.97602 3.16516C8.99273 3.14845 9.00944 3.14845 8.99273 3.18187C8.9593 3.2646 8.89413 3.43089 8.87741 3.56376C8.84399 3.81277 8.84399 4.17878 8.84399 4.7938V7.00571C8.84399 7.20626 8.82728 7.53884 8.63007 7.75444ZM13.3129 21.9384C12.7531 21.5724 12.4556 21.0902 12.3403 20.7911C12.2216 20.5006 12.1601 20.1899 12.1589 19.8761C12.1603 18.4916 13.2813 17.3691 14.6658 17.3658C15.0778 17.3658 15.4079 17.6984 15.4079 18.1137C15.4097 18.383 15.2641 18.6318 15.0285 18.7622C14.9458 18.8123 14.8304 18.8457 14.7477 18.8625C14.6658 18.8792 14.3525 18.9126 14.2045 19.0446C14.0391 19.1783 13.9071 19.3939 13.9071 19.6271C13.9071 19.8761 14.0057 20.1092 14.1711 20.2755C14.4678 20.5747 14.8639 20.7409 15.2925 20.7409C15.8327 20.739 16.3499 20.5224 16.7303 20.1388C17.1107 19.7553 17.3231 19.2363 17.3206 18.6962C17.3206 17.6817 16.6446 16.7834 15.7538 16.3848C15.6218 16.318 15.4079 16.2678 15.2098 16.2177C15.046 16.184 14.881 16.1564 14.7151 16.135C14.0224 16.0514 12.291 15.5032 12.1748 13.9573C12.1748 13.9573 11.6642 16.2845 10.6414 16.9163C10.5428 16.9664 10.4108 17.0165 10.2621 17.05C10.1141 17.0834 9.94953 17.1001 9.89939 17.1001C8.23398 17.1995 6.46913 16.6673 5.24911 15.4038C5.24911 15.4038 4.42435 14.7219 3.99567 12.81C3.89706 12.3437 3.69902 11.5123 3.5837 10.7309C3.53357 10.4485 3.51685 10.2321 3.50098 10.0324C3.50098 9.21762 3.99567 8.66945 4.62239 8.58672H7.98663C8.56322 8.58672 8.89413 8.43631 9.10805 8.23659C9.38882 7.97086 9.45483 7.58815 9.45483 7.13941V3.73005V3.63144C9.53589 3.01558 10.0816 2.5 10.8888 2.5H11.2849C11.4495 2.5 11.6475 2.51671 11.8289 2.53343C11.9609 2.55014 12.0762 2.58356 12.2742 2.6337C13.2803 2.88272 13.4943 3.91388 13.4943 3.91388C13.4943 3.91388 15.3911 4.24646 16.3479 4.41276C17.2546 4.57905 19.4983 4.72862 19.9261 7.00655C20.9322 12.4273 20.3222 17.6817 20.2729 17.6817C19.5634 22.8033 15.3418 22.5534 15.3418 22.5534C14.6175 22.5681 13.9072 22.3528 13.3129 21.9384ZM15.9351 11.6292C15.9017 11.7128 15.8691 11.8122 15.8858 11.8616C15.9025 11.9117 15.936 11.9284 15.9686 11.9451C16.1666 12.0454 16.4958 12.0947 16.9747 12.1448C17.4526 12.195 17.7827 12.2284 17.9966 12.195C18.0301 12.195 18.0635 12.1783 18.0961 12.1281C18.1295 12.078 18.1128 11.9777 18.1128 11.895C18.0626 11.4462 17.6507 11.1137 17.1067 11.0468C16.5619 10.9967 16.1006 11.2139 15.9351 11.6292Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$42600613b7e5b691(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.501 8.5C10.501 9.05228 10.0533 9.5 9.50098 9.5H6.00219C5.666 9.5 5.50098 9.76137 5.50098 10.0324C5.50098 11.3515 5.75509 12.4035 6.16482 13.2251C6.38075 13.6581 6.56374 13.8948 6.68785 14.0145C7.42307 14.7759 8.57381 15.1757 9.78018 15.1037C9.87471 15.098 9.97857 15.0401 10.1116 14.8962C10.2335 14.7644 10.3154 14.6277 10.3263 14.6029C10.7514 13.6301 11.8626 13.1589 12.8574 13.5297C13.5504 13.788 14.1339 13.9641 14.6703 14.0899C14.8658 14.1357 15.0452 14.1728 15.2562 14.2125C15.1787 14.1979 15.6579 14.2861 15.7742 14.3101C16.1144 14.3802 16.372 14.4561 16.6573 14.6005C17.3644 14.9585 17.9744 15.4655 18.4316 16.0752C18.4768 15.4836 18.5086 14.8073 18.5187 14.0487C18.5474 11.8917 18.3803 9.63789 17.9605 7.37573C17.8858 6.97793 17.7238 6.8136 17.2965 6.65764C17.1327 6.59785 16.9423 6.5482 16.7101 6.50321C16.5635 6.4748 16.0594 6.39296 16.0166 6.38528C16.002 6.38265 16.002 6.38265 16.0055 6.38322C15.7139 6.33254 15.3189 6.26362 14.8459 6.18094C14.4683 6.11492 14.2042 6.0687 13.6764 5.97628C13.2544 5.90233 13.2544 5.90233 13.1489 5.88383C12.4543 5.76205 11.8751 5.28347 11.6247 4.62426C11.6118 4.59043 11.6006 4.56115 11.5907 4.53583C11.4779 4.52134 11.2541 4.5 10.8888 4.5C10.6179 4.5 10.501 4.62426 10.501 4.96269V8.5ZM16.7303 20.1388C17.0834 19.7828 17.2917 19.3101 17.3178 18.812C17.3722 17.776 16.4941 16.3326 15.001 16.1783C14.3842 16.1146 13.4151 15.872 12.1589 15.4038C12.1589 15.4038 11.4583 17.007 9.89939 17.1001C8.23398 17.1995 6.46913 16.6673 5.24911 15.4038C5.24911 15.4038 3.50098 13.7647 3.50098 10.0324C3.50098 9.21762 3.79137 8.60963 4.14931 8.12783C5.10894 6.83612 6.65415 5.34816 8.28241 3.82392C9.00098 3.15126 9.70215 2.5 10.8888 2.5C12.9294 2.5 13.2094 3.16415 13.4943 3.91388C13.4943 3.91388 15.3911 4.24646 16.3479 4.41276C17.2546 4.57905 19.4983 4.72862 19.9261 7.00655C20.9322 12.4273 20.3843 16.8774 20.2729 17.6817C19.5634 22.8033 15.501 22.5534 15.3418 22.5534C13.283 22.5534 12.1636 21.1796 12.1589 19.8761C12.1559 19.0394 12.5664 18.2985 13.1973 17.8423C13.8061 17.4021 14.4359 17.3642 14.7236 17.3642C15.0285 17.3642 15.4111 17.6817 15.4111 18.117C15.4111 18.4869 15.1561 18.6916 15.0285 18.7622C14.8055 18.8855 13.9071 18.9355 13.9071 19.6271C13.9071 19.9438 14.2563 20.7409 15.2925 20.7409C15.8813 20.7409 16.3865 20.4855 16.7303 20.1388ZM14.9351 10.6292C15.1006 10.2139 15.5619 9.99668 16.1067 10.0468C16.6507 10.1137 17.0626 10.4462 17.1128 10.895C17.1128 10.9777 17.1295 11.078 17.0961 11.1281C17.0635 11.1783 17.0301 11.195 16.9966 11.195C16.7827 11.2284 16.4526 11.195 15.9747 11.1448C15.4958 11.0947 15.1666 11.0454 14.9686 10.9451C14.936 10.9284 14.9025 10.9117 14.8858 10.8616C14.8691 10.8122 14.9017 10.7128 14.9351 10.6292Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5c6f7f1e413c2dbb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.4024 21V14.0344H17.7347L18.0838 11.3265H15.4024V9.59765C15.4024 8.81364 15.62 8.27934 16.7443 8.27934L18.1783 8.27867V5.85676C17.9302 5.82382 17.0791 5.75006 16.0888 5.75006C14.0213 5.75006 12.606 7.01198 12.606 9.32952V11.3265H10.2677V14.0344H12.606V21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H15.4024Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$10c6bdd474193f7e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 19H19V5H5V19H12V14H10V12H12V10.3458C12 9.00855 12.1392 8.52362 12.4007 8.03473C12.6622 7.54584 13.0458 7.16216 13.5347 6.9007C13.9174 6.69604 14.3922 6.57252 15.2217 6.51954C15.551 6.49851 15.9771 6.52533 16.5 6.6V8.5H16C15.0827 8.5 14.7042 8.54332 14.4779 8.66433C14.3376 8.73939 14.2394 8.83758 14.1643 8.97793C14.0433 9.20418 14 9.42853 14 10.3458V12H16.5L16 14H14V19ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e758aa78f7f4bfa7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 2C6.47813 2 2.00098 6.47715 2.00098 12C2.00098 16.9913 5.65783 21.1283 10.4385 21.8785V14.8906H7.89941V12H10.4385V9.79688C10.4385 7.29063 11.9314 5.90625 14.2156 5.90625C15.3097 5.90625 16.4541 6.10156 16.4541 6.10156V8.5625H15.1931C13.9509 8.5625 13.5635 9.33334 13.5635 10.1242V12H16.3369L15.8936 14.8906H13.5635V21.8785C18.3441 21.1283 22.001 16.9913 22.001 12C22.001 6.47715 17.5238 2 12.001 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$61f8e8820735d905(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.001 19.9381C16.9473 19.446 20.001 16.0796 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 16.0796 7.05467 19.446 11.001 19.9381V14H9.00098V12H11.001V10.3458C11.001 9.00855 11.1402 8.52362 11.4017 8.03473C11.6631 7.54584 12.0468 7.16216 12.5357 6.9007C12.9184 6.69604 13.3931 6.57252 14.2227 6.51954C14.5519 6.49851 14.9781 6.52533 15.501 6.6V8.5H15.001C14.0837 8.5 13.7052 8.54332 13.4789 8.66433C13.3386 8.73939 13.2404 8.83758 13.1653 8.97793C13.0443 9.20418 13.001 9.42853 13.001 10.3458V12H15.501L15.001 14H13.001V19.9381ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$11b9cd78a5f690de(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47062 14 5.5 16 5.5H17.5V2.1401C17.1743 2.09685 15.943 2 14.6429 2C11.9284 2 10 3.65686 10 6.69971V9.5H7V13.5H10V22H14V13.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$36918a633bbd5958(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9H17.5L17 11H13V20H11V11H7V9H11V7.12777C11 5.34473 11.1857 4.69816 11.5343 4.04631C11.8829 3.39446 12.3945 2.88288 13.0463 2.53427C13.6982 2.18565 14.3447 2 16.1278 2C16.6498 2 17.1072 2.05 17.5 2.15V4H16.1278C14.8041 4 14.401 4.07784 13.9895 4.29789C13.6862 4.46011 13.4601 4.68619 13.2979 4.98951C13.0778 5.40096 13 5.80407 13 7.12777V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$41f88d9d7fc6bc26(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.001 3C21.5533 3 22.001 3.44772 22.001 4V20C22.001 20.5523 21.5533 21 21.001 21H3.00098C2.44869 21 2.00098 20.5523 2.00098 20V4C2.00098 3.44772 2.44869 3 3.00098 3H21.001ZM20.001 4.99996H11.5356C10.8458 6.97692 10.501 9.6436 10.501 13H13.501C13.386 13.9194 13.3504 14.8785 13.3939 15.8772C14.6196 15.6656 16.0978 15.1004 17.421 14.1679L18.5557 15.8321C16.914 16.9265 15.2534 17.6108 13.5802 17.8753C13.6316 18.2452 13.6929 18.6202 13.7642 19.0001L20.001 19V4.99996ZM6.55568 14.1679L5.44628 15.8321C7.60332 17.2701 9.79308 18 12.001 18V16C10.2089 16 8.39863 15.3966 6.55568 14.1679ZM17.001 7C17.5533 7 18.001 7.44772 18.001 8V9C18.001 9.55228 17.5533 10 17.001 10C16.4487 10 16.001 9.55228 16.001 9V8C16.001 7.44772 16.4487 7 17.001 7ZM7.00098 7C6.44869 7 6.00098 7.45174 6.00098 8C6.00098 8.3655 6.00098 8.69884 6.00098 9C6.00098 9.55228 6.44869 10 7.00098 10C7.55326 10 8.00098 9.55 8.00098 9V8C8.00098 7.44772 7.55326 7 7.00098 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a22670c02d5b8df9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.001 3C21.5533 3 22.001 3.44772 22.001 4V20C22.001 20.5523 21.5533 21 21.001 21H3.00098C2.44869 21 2.00098 20.5523 2.00098 20V4C2.00098 3.44772 2.44869 3 3.00098 3H21.001ZM10.4817 4.99884L4.00098 5V19L12.747 18.9997C12.6851 18.6562 12.6308 18.3163 12.5844 17.98C12.2874 17.9933 12.0929 18 12.001 18C9.79308 18 7.60332 17.2701 5.44628 15.8321L6.55568 14.1679C8.39863 15.3966 10.2089 16 12.001 16C12.1337 16 12.2664 15.9967 12.3993 15.9901C12.3747 15.4926 12.3747 14.5797 12.4064 14H9.50098V13C9.50098 9.72527 9.82146 7.06094 10.4817 4.99884ZM12.601 4.99851C11.9358 6.58176 11.5567 9.41121 11.5119 12H14.6338L14.4933 13.124C14.3927 13.9288 14.3567 14.7687 14.3857 15.6439C15.3987 15.3449 16.4174 14.8539 17.4463 14.1679L18.5557 15.8321C17.2358 16.7119 15.9038 17.3267 14.5628 17.6714C14.62 18.1052 14.6937 18.5482 14.7819 18.999L20.001 19V5L12.601 4.99851ZM7.00098 7C7.55326 7 8.00098 7.44772 8.00098 8V9C8.00098 9.55228 7.55326 10 7.00098 10C6.44869 10 6.00098 9.55228 6.00098 9V8C6.00098 7.44772 6.44869 7 7.00098 7ZM17.001 7C17.5533 7 18.001 7.44772 18.001 8V9C18.001 9.55228 17.5533 10 17.001 10C16.4487 10 16.001 9.55228 16.001 9V8C16.001 7.44772 16.4487 7 17.001 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$89abff98cc8707b1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 10.5365 2.31538 9.14635 2.88033 7.89353C3.34744 6.95503 4.11409 6.01955 4.73082 5.7004C4.07759 6.98266 3.75823 8.24073 3.69049 9.08266C4.14533 7.58266 5.00622 6.32621 6.21106 5.43911C8.27719 3.92016 11.059 3.85202 12.1671 4.81976C10.1107 5.52581 7.87073 8.36653 8.36428 11.6952C8.44419 12.2447 8.60906 12.7785 8.85299 13.2774C8.46912 12.2661 8.43525 10.8435 9.05461 9.91935C9.74654 8.88911 10.7332 8.67137 11.2607 8.78266C11.0526 8.73911 10.5929 9.61936 10.5252 9.77419C10.3523 10.1679 10.2664 10.5943 10.2736 11.0242C10.2888 11.9223 10.6594 12.7778 11.3042 13.4032C13.2256 15.2754 16.3268 14.5387 17.7155 12.4016C18.6687 10.9306 18.7848 8.43427 17.5607 6.4504C17.2554 5.96696 16.8913 5.52325 16.4768 5.12944C14.6262 3.36387 11.9979 2.56054 9.49503 2.92549C8.38907 3.10214 7.44765 3.42052 6.67077 3.88065C7.75554 2.79776 9.9123 2 12.001 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e673e97340e350d2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 10.5365 2.31538 9.14635 2.88033 7.89353C3.34744 6.95503 4.11409 6.01955 4.73082 5.7004C4.07759 6.98266 3.75823 8.24073 3.69049 9.08266C4.14533 7.58266 5.00622 6.32621 6.21106 5.43911C8.27719 3.92016 11.059 3.85202 12.1671 4.81976C10.1107 5.52581 7.87073 8.36653 8.36428 11.6952C8.44419 12.2447 8.60906 12.7785 8.85299 13.2774C8.46912 12.2661 8.43525 10.8435 9.05461 9.91935C9.74654 8.88911 10.7332 8.67137 11.2607 8.78266C11.0526 8.73911 10.5929 9.61936 10.5252 9.77419C10.3523 10.1679 10.2664 10.5943 10.2736 11.0242C10.2888 11.9223 10.6594 12.7778 11.3042 13.4032C13.2256 15.2754 16.3268 14.5387 17.7155 12.4016C18.6687 10.9306 18.7848 8.43427 17.5607 6.4504C17.2554 5.96696 16.8913 5.52325 16.4768 5.12944C14.6262 3.36387 11.9979 2.56054 9.49503 2.92549C8.38907 3.10214 7.44765 3.42052 6.67077 3.88065C7.75554 2.79776 9.9123 2 12.001 2ZM6.87552 7.7048C4.62257 8.48634 3.37469 10.8751 4.29738 14.165C5.22008 17.4549 8.19356 19.8873 11.7518 19.9962L12.001 20C16.2525 20 19.7295 16.6835 19.9858 12.4965L19.995 12.284C19.8654 12.6327 19.7118 12.958 19.5321 13.2648L19.3925 13.4914C17.2881 16.7299 12.7109 17.5664 9.91169 14.8388C9.52745 14.4661 9.20448 14.042 8.94958 13.5821L8.84398 13.381C7.10788 12.994 6.26027 12.0549 6.30116 10.5637C6.32833 9.5728 6.53175 8.6049 6.87552 7.7048Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9b76bfd33e0f2784(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12C11 14.7615 8.76146 17 5.99998 17 3.23849 17 1 14.7615 1 12 1 9.23899 3.23849 7 5.99998 7 8.76146 7 11 9.23899 11 12ZM23 12C23 14.7615 20.7615 17 18 17 15.2385 17 13 14.7615 13 12 13 9.23899 15.2385 7 18 7 20.7615 7 23 9.23899 23 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$58360b67d8a6ab29(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.99998 17C8.76146 17 11 14.7615 11 12 11 9.23899 8.76146 7 5.99998 7 3.23849 7 1 9.23899 1 12 1 14.7615 3.23849 17 5.99998 17ZM8.99995 12C8.99995 13.6569 7.65689 15 5.99998 15 4.34306 15 3 13.6569 3 12 3 10.3434 4.34319 9 5.99998 9 7.65676 9 8.99995 10.3434 8.99995 12ZM18 17C20.7615 17 23 14.7615 23 12 23 9.23899 20.7615 7 18 7 15.2385 7 13 9.23899 13 12 13 14.7615 15.2385 17 18 17ZM21 12C21 13.6569 19.6569 15 18 15 16.3431 15 15 13.6569 15 12 15 10.3434 16.3432 9 18 9 19.6568 9 21 10.3434 21 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f6bf84411c5e7338(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5039 2.00098L3.50391 12.001L6.58724 15.0843L19.6673 2.00098H13.5039ZM13.4985 11.1989L8.12328 16.6199L13.4956 21.9998H19.6842L14.2975 16.5999L19.6856 11.1998L13.4985 11.1989Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e001016e3eb01d8b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5979 10.6843H17.4264L11.7688 16.3419L17.4264 21.998H14.5979L8.94108 16.3412L14.5979 10.6843ZM14.4044 2.00439H17.2328L5.9191 13.3181L4.50488 11.9039L14.4044 2.00439Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d5de3486739c3cf5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 2C6.50098 2 2.00098 6.5 2.00098 12C2.00098 17.5 6.50098 22 12.001 22C17.501 22 22.001 17.5 22.001 12C22.001 6.5 17.501 2 12.001 2ZM6.42956 17.5714C4.92956 16.0714 4.14385 14.0714 4.14385 12.1429L11.9297 19.8571C9.92973 19.7857 7.92973 19.0714 6.42956 17.5714ZM13.7151 19.6429L4.3581 10.2857C5.14385 6.78571 8.28681 4.14286 12.001 4.14286C14.6439 4.14286 16.9297 5.42857 18.3581 7.35712L17.2868 8.28571C16.0722 6.64288 14.1439 5.57143 12.001 5.57143C9.21514 5.57143 6.8581 7.35713 5.92956 9.85713L14.1439 18.0714C16.2151 17.3571 17.7868 15.5714 18.2868 13.4286H14.8581V12H19.8581C19.8581 15.7143 17.2151 18.8571 13.7151 19.6429Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$26a49912d14e218e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.7519 21.997C6.53059 21.8694 2.3017 17.7397 2.01626 12.559L2.00391 12.246L11.7519 21.997ZM12.0009 2C15.39 2 18.3854 3.68597 20.194 6.26495L18.556 7.41293C17.1092 5.3492 14.7126 4 12.0009 4C8.59784 4 5.69105 6.12484 4.53491 9.12017L14.8807 19.466C17.2681 18.5445 19.1025 16.5109 19.7488 14.0004L15.5009 14V12H22.0009C22.0009 16.7261 18.7223 20.6865 14.3155 21.7308L2.27013 9.68538C3.31443 5.27856 7.27479 2 12.0009 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$935242d7a332dbd3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 2C6.47598 2 2.00098 6.475 2.00098 12C2.00098 16.425 4.86348 20.1625 8.83848 21.4875C9.33848 21.575 9.52598 21.275 9.52598 21.0125C9.52598 20.775 9.51348 19.9875 9.51348 19.15C7.00098 19.6125 6.35098 18.5375 6.15098 17.975C6.03848 17.6875 5.55098 16.8 5.12598 16.5625C4.77598 16.375 4.27598 15.9125 5.11348 15.9C5.90098 15.8875 6.46348 16.625 6.65098 16.925C7.55098 18.4375 8.98848 18.0125 9.56348 17.75C9.65098 17.1 9.91348 16.6625 10.201 16.4125C7.97598 16.1625 5.65098 15.3 5.65098 11.475C5.65098 10.3875 6.03848 9.4875 6.67598 8.7875C6.57598 8.5375 6.22598 7.5125 6.77598 6.1375C6.77598 6.1375 7.61348 5.875 9.52598 7.1625C10.326 6.9375 11.176 6.825 12.026 6.825C12.876 6.825 13.726 6.9375 14.526 7.1625C16.4385 5.8625 17.276 6.1375 17.276 6.1375C17.826 7.5125 17.476 8.5375 17.376 8.7875C18.0135 9.4875 18.401 10.375 18.401 11.475C18.401 15.3125 16.0635 16.1625 13.8385 16.4125C14.201 16.725 14.5135 17.325 14.5135 18.2625C14.5135 19.6 14.501 20.675 14.501 21.0125C14.501 21.275 14.6885 21.5875 15.1885 21.4875C19.259 20.1133 21.9999 16.2963 22.001 12C22.001 6.475 17.526 2 12.001 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a3ac83fabdeedf55(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.88401 18.6531C5.58404 18.4523 5.32587 18.1972 5.0239 17.8366C4.91473 17.7062 4.47283 17.1521 4.55811 17.258C4.09533 16.6831 3.80296 16.4168 3.50156 16.3087C2.9817 16.1223 2.7114 15.5497 2.89784 15.0298C3.08428 14.51 3.65685 14.2397 4.17672 14.4261C4.92936 14.696 5.43847 15.1609 6.12425 16.0141C6.03025 15.8972 6.46364 16.4408 6.55731 16.5526C6.74784 16.7802 6.88732 16.918 6.99629 16.9909C7.20118 17.128 7.58451 17.1871 8.14709 17.1308C8.17065 16.7487 8.24136 16.378 8.34919 16.0355C5.38097 15.3101 3.70116 13.3949 3.70116 9.63947C3.70116 8.4006 4.0704 7.28368 4.75917 6.34756C4.5415 5.45368 4.57433 4.37259 5.06092 3.15611C5.1725 2.87715 5.40361 2.66314 5.69031 2.57328C5.77242 2.54949 5.81791 2.5389 5.89878 2.52648C6.70167 2.40319 7.83573 2.69681 9.31449 3.62311C10.181 3.41855 11.0885 3.31476 12.0012 3.31476C12.9129 3.31476 13.8196 3.41835 14.6854 3.62253C16.1619 2.68976 17.2986 2.39625 18.1072 2.52627C18.1919 2.53988 18.2645 2.55758 18.3249 2.57741C18.6059 2.66967 18.8316 2.88155 18.9414 3.15611C19.4279 4.37232 19.4608 5.45319 19.2433 6.34695C19.9342 7.28313 20.3012 8.39184 20.3012 9.63947C20.3012 13.3966 18.627 15.3046 15.6588 16.0318C15.7837 16.4467 15.8496 16.9103 15.8496 17.4118C15.8496 18.0763 15.8471 18.7108 15.8424 19.4223C15.8412 19.6124 15.8397 19.8156 15.8375 20.1279C16.2129 20.2107 16.5229 20.5074 16.6031 20.9086C16.7114 21.4502 16.3602 21.977 15.8186 22.0853C14.6794 22.3132 13.8353 21.5535 13.8353 20.5608C13.8353 20.4705 13.836 20.3414 13.8375 20.1142C13.8398 19.8012 13.8412 19.5987 13.8425 19.4092C13.8471 18.7017 13.8496 18.0714 13.8496 17.4118C13.8496 16.7145 13.6664 16.26 13.4237 16.0508C12.7627 15.481 13.0977 14.3971 13.965 14.2996C16.9314 13.9663 18.3012 12.8174 18.3012 9.63947C18.3012 8.68484 17.9893 7.89547 17.3881 7.23534C17.1301 6.95209 17.0567 6.54634 17.199 6.19062C17.3647 5.77639 17.4354 5.2336 17.2941 4.57678L17.2847 4.57944C16.7928 4.71861 16.1744 5.01956 15.4261 5.52826C15.182 5.69413 14.8772 5.74377 14.5932 5.66388C13.7729 5.43319 12.8913 5.31476 12.0012 5.31476C11.111 5.31476 10.2294 5.43319 9.40916 5.66388C9.12662 5.74335 8.82344 5.69468 8.57997 5.53077C7.8274 5.02414 7.2056 4.72355 6.71079 4.58352C6.56735 5.23672 6.63814 5.77758 6.80336 6.19062C6.94565 6.54634 6.87219 6.95209 6.61423 7.23534C6.01715 7.89096 5.70116 8.69352 5.70116 9.63947C5.70116 12.8114 7.07225 13.9681 10.023 14.2996C10.8883 14.3969 11.2246 15.4767 10.5675 16.048C10.3751 16.2153 10.1384 16.7799 10.1384 17.4118V20.5608C10.1384 21.5472 9.30356 22.2866 8.17878 22.0898C7.63476 21.9946 7.27093 21.4764 7.36613 20.9324C7.43827 20.5201 7.75331 20.2114 8.13841 20.1274V19.1379C7.22829 19.1991 6.47656 19.0496 5.88401 18.6531Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b92970eddd606204(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.6634 9.98693L21.6354 9.91531L18.9164 2.82092C18.8612 2.68178 18.7634 2.56365 18.6371 2.48339C18.5098 2.40304 18.3607 2.36419 18.2104 2.37219C18.0601 2.38019 17.9159 2.43464 17.7979 2.52804C17.6809 2.62181 17.5966 2.75012 17.5569 2.89466L15.7187 8.52049H8.28157L6.44336 2.89466C6.40366 2.75012 6.31934 2.62181 6.20241 2.52804C6.08487 2.43402 5.94083 2.37915 5.79052 2.37114C5.64021 2.36313 5.49116 2.40238 5.36429 2.48339C5.2374 2.56332 5.13921 2.68153 5.08388 2.82092L2.36183 9.92462L2.33379 9.99524C1.94304 11.0184 1.895 12.1407 2.19691 13.1934C2.49882 14.2462 3.13436 15.1725 4.00794 15.833L4.01832 15.8402L4.04221 15.8589L8.18917 18.9632L10.2393 20.5159L11.4856 21.4599C11.6319 21.5705 11.8104 21.6304 11.9939 21.6304C12.1774 21.6304 12.3559 21.5705 12.5023 21.4599L13.7486 20.5159L15.7997 18.9632L19.9706 15.8402L19.9819 15.8319C20.8585 15.1721 21.4966 14.245 21.7999 13.1906C22.1033 12.1362 22.0553 11.0117 21.6634 9.98693Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c650f0a3e0b34677(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.54429 2.67311C5.81644 2.50001 6.13587 2.41618 6.45799 2.43335C6.78102 2.45056 7.09056 2.56848 7.34318 2.77056L7.34405 2.77125C7.59044 2.96885 7.76998 3.23726 7.85866 3.53996L9.30537 7.9676H14.6944L16.1411 3.53996C16.2298 3.23728 16.4093 2.96885 16.6557 2.77122L16.6604 2.76751C16.9128 2.56783 17.2209 2.45139 17.5424 2.43429C17.8638 2.41718 18.1826 2.50029 18.4547 2.67203L18.4571 2.67353C18.7307 2.84741 18.9427 3.10334 19.0624 3.40492L19.0664 3.41497L21.5393 9.86628C21.9619 10.9712 22.0136 12.1837 21.6865 13.3206C21.3594 14.4575 20.6715 15.4571 19.7263 16.1686L12.9955 21.2331L12.9945 21.2338C12.7066 21.4514 12.3554 21.5692 11.9943 21.5692C11.6332 21.5692 11.2819 21.4514 10.9939 21.2337L4.26254 16.1684C3.32063 15.4562 2.63541 14.4575 2.30989 13.3224C1.98437 12.1874 2.03616 10.9773 2.45747 9.87416L4.93724 3.40503C5.0571 3.10303 5.26966 2.84679 5.54429 2.67311ZM6.35534 4.73573L4.16029 10.4639C3.87993 11.2014 3.82298 12.0677 4.04049 12.8261C4.25704 13.5812 4.71123 14.2462 5.33544 14.7225L11.9943 19.7329L18.6484 14.7266C19.2789 14.2503 19.7379 13.5823 19.9563 12.8228C20.1751 12.0624 20.1148 11.1848 19.8328 10.4455L17.6444 4.73564L16.0001 9.76797H7.9996L6.35534 4.73573Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f929ea9e87dd7f8f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.06364 7.50914C4.70909 4.24092 8.09084 2 12 2C14.6954 2 16.959 2.99095 18.6909 4.60455L15.8227 7.47274C14.7864 6.48185 13.4681 5.97727 12 5.97727C9.39542 5.97727 7.19084 7.73637 6.40455 10.1C6.2045 10.7 6.09086 11.3409 6.09086 12C6.09086 12.6591 6.2045 13.3 6.40455 13.9C7.19084 16.2636 9.39542 18.0227 12 18.0227C13.3454 18.0227 14.4909 17.6682 15.3864 17.0682C16.4454 16.3591 17.15 15.3 17.3818 14.05H12V10.1818H21.4181C21.5364 10.8363 21.6 11.5182 21.6 12.2273C21.6 15.2727 20.5091 17.8363 18.6181 19.5773C16.9636 21.1046 14.7 22 12 22C8.09084 22 4.70909 19.7591 3.06364 16.4909C2.38638 15.1409 2 13.6136 2 12C2 10.3864 2.38638 8.85911 3.06364 7.50914Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5ca63b884222c04(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11H20.5329C20.5769 11.3847 20.6 11.7792 20.6 12.1837C20.6 14.9184 19.6204 17.2204 17.9224 18.7837C16.4367 20.1551 14.404 20.9592 11.9796 20.9592C8.46933 20.9592 5.43266 18.947 3.9551 16.0123C3.34695 14.8 3 13.4286 3 11.9796C3 10.5306 3.34695 9.1592 3.9551 7.94698C5.43266 5.01226 8.46933 3 11.9796 3C14.4 3 16.4326 3.88983 17.9877 5.33878L16.5255 6.80101C15.3682 5.68153 13.8028 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.5265 19 18.1443 16.3923 18.577 13H12V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a9a0f05e3bf1f9b6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.60972 1.81396L13.793 12L3.61082 22.1864C3.41776 22.1048 3.24866 21.962 3.13555 21.7667C3.0474 21.6144 3.00098 21.4416 3.00098 21.2656V2.73453C3.00098 2.32109 3.25188 1.96625 3.60972 1.81396ZM14.5 12.707L16.802 15.009L5.86498 21.342L14.5 12.707ZM17.699 9.50896L20.5061 11.1347C20.9841 11.4114 21.1473 12.0232 20.8705 12.5011C20.783 12.6523 20.6574 12.778 20.5061 12.8655L17.698 14.491L15.207 12L17.699 9.50896ZM5.86498 2.65796L16.803 8.98996L14.5 11.293L5.86498 2.65796Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c21c02806cccc28e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.00098 1.73438C4.17692 1.73438 4.34975 1.7808 4.50201 1.86895L20.5061 11.1345C20.9841 11.4112 21.1473 12.023 20.8705 12.501C20.783 12.6522 20.6574 12.7778 20.5061 12.8654L4.50201 22.1309C4.02405 22.4076 3.41226 22.2445 3.13555 21.7665C3.0474 21.6143 3.00098 21.4414 3.00098 21.2655V2.73438C3.00098 2.18209 3.44869 1.73438 4.00098 1.73438ZM12.2931 13.4132L7.79498 17.9124L13.494 14.6134L12.2931 13.4132ZM4.99998 6.11938V17.8784L10.8791 11.9992L4.99998 6.11938ZM15.284 10.4214L13.7071 11.9992L15.285 13.5764L18.009 11.9999L15.284 10.4214ZM7.79398 6.08537L12.2931 10.5852L13.493 9.38437L7.79398 6.08537Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e8e4aed87b9c97a5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.1592 4.25759C21.1934 7.75736 21.7504 9.06895 21.947 10.9594C22.248 13.8533 21.2897 16.8534 19.072 19.0711C15.4057 22.7374 9.60078 22.9617 5.67278 19.744L8.52438 16.8913C10.8676 18.561 14.1415 18.3448 16.2436 16.2426C18.346 14.1403 18.562 10.8658 16.8917 8.52257L21.1592 4.25759ZM18.3292 4.25604L15.4776 7.10872C13.1344 5.439 9.86048 5.65522 7.75834 7.75736C5.65619 9.8595 5.43998 13.1334 7.10969 15.4766L2.8428 19.7424C2.80859 16.2426 2.25158 14.931 2.05494 13.0406C1.75392 10.1467 2.71224 7.1466 4.92991 4.92893C8.59624 1.2626 14.4012 1.03831 18.3292 4.25604ZM12.001 8C14.2101 8 16.001 9.79086 16.001 12C16.001 14.2091 14.2101 16 12.001 16C9.79184 16 8.00098 14.2091 8.00098 12C8.00098 9.79086 9.79184 8 12.001 8ZM12.001 10.5C11.1725 10.5 10.501 11.1716 10.501 12C10.501 12.8284 11.1725 13.5 12.001 13.5C12.8294 13.5 13.501 12.8284 13.501 12C13.501 11.1716 12.8294 10.5 12.001 10.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eff2ad83066743cb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.3292 4.25604L16.9062 5.67921C13.7678 3.23734 9.22861 3.45865 6.34412 6.34315C3.97034 8.71692 3.40017 12.2113 4.63361 15.1234L7.0508 12.7061C6.83751 11.2027 7.30906 9.62085 8.46544 8.46447C10.1757 6.75423 12.8166 6.54193 14.7579 7.82757L13.2937 9.2919C12.1787 8.75967 10.8031 8.95526 9.87966 9.87868C8.95624 10.8021 8.76065 12.1777 9.29288 13.2927L2.8428 19.7424C2.80859 16.2426 2.25158 14.931 2.05494 13.0406C1.75392 10.1467 2.71224 7.1466 4.92991 4.92893C8.59624 1.2626 14.4012 1.03831 18.3292 4.25604ZM21.1592 4.25759C21.1934 7.75736 21.7504 9.06895 21.947 10.9594C22.248 13.8533 21.2897 16.8534 19.072 19.0711C15.4057 22.7374 9.60078 22.9617 5.67278 19.744L7.09575 18.3208C10.2342 20.7627 14.7733 20.5413 17.6578 17.6569C20.0316 15.2831 20.6018 11.7887 19.3683 8.87656L16.9512 11.2939C17.1644 12.7973 16.6929 14.3792 15.5365 15.5355C13.8263 17.2458 11.1853 17.4581 9.24404 16.1724L10.7083 14.7081C11.8233 15.2403 13.1989 15.0447 14.1223 14.1213C15.0457 13.1979 15.2413 11.8223 14.7091 10.7073L21.1592 4.25759Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ebbd6aa9c4ed452e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.61295 20.1193C5.86915 21.6102 3.50024 21.9188 2.1909 20.6106C0.847101 19.2694 1.56267 15.7588 3.50394 12.2367C4.4519 10.5168 5.69213 8.79409 7.12757 7.31987C7.31507 7.13266 8.25257 6.19657 8.31507 6.19657C8.31507 6.19657 7.81507 6.5086 7.75257 6.5086C5.80254 7.60383 4.09018 9.58895 3.71617 10.0345C3.77393 9.77522 3.84289 9.52012 3.92249 9.26978C5.07865 5.63404 8.48217 3.00008 12.5009 3.00008C12.7308 3.00008 12.9586 3.0087 13.1842 3.02563C16.2787 1.62287 19.158 1.29938 20.3759 2.51465C21.5009 3.63795 21.4384 5.51011 20.5009 7.75671C20.4918 7.77847 20.4828 7.79991 20.4739 7.82104C21.1298 9.06983 21.5009 10.4916 21.5009 12.0001C21.5009 12.3794 21.4774 12.7531 21.4319 13.1201H20.6274C20.5763 13.1219 20.529 13.1227 20.4855 13.1227H8.69007V13.31C8.75173 15.3069 10.5017 17.0543 12.6267 17.0543C14.1267 17.0543 15.5642 16.243 16.1892 15.0573H20.9683C20.9608 15.0783 20.953 15.0992 20.9451 15.1201C19.6766 18.5528 16.3746 21.0001 12.5009 21.0001C11.1084 21.0001 9.7898 20.6839 8.61295 20.1193ZM8.00613 19.7991C6.1803 18.7445 4.75932 17.0672 4.03351 15.0575C2.87291 17.3392 2.57399 19.2474 3.56507 20.237C4.37757 21.0491 6.00257 20.861 8.00257 19.801L8.00613 19.7991ZM20.1728 7.29218C20.178 7.28091 20.1832 7.26962 20.1884 7.2583C20.9384 5.63576 21.0009 4.26367 20.3134 3.4524C19.4442 2.58451 17.7732 2.70192 15.7906 3.62029C17.6193 4.33877 19.1559 5.63857 20.1728 7.29218ZM16.5642 10.753V10.6906C16.4392 8.63122 14.8142 7.07108 12.8142 7.07108C10.6892 7.07108 8.87757 8.75603 8.75257 10.6906V10.753H16.5642Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$93f2f875ce6dbd34(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.1595 10.0001C17.3358 7.6697 15.1133 6.00008 12.5009 6.00008C9.88846 6.00008 7.66598 7.6697 6.84231 10.0001H18.1595ZM6.58385 13.0001C7.05993 15.8378 9.5279 18.0001 12.5009 18.0001C14.698 18.0001 16.6193 16.8191 17.6647 15.0573H20.9683C20.9608 15.0783 20.953 15.0992 20.9451 15.1201C19.6766 18.5528 16.3746 21.0001 12.5009 21.0001C11.1084 21.0001 9.7898 20.6839 8.61295 20.1193C5.86915 21.6102 3.50024 21.9188 2.1909 20.6106C0.847101 19.2694 1.56267 15.7588 3.50394 12.2367C4.19428 10.9842 5.03962 9.7302 6.00247 8.57179C6.36179 8.13949 6.73747 7.72051 7.12757 7.31987C6.85302 7.37539 5.24718 8.17147 3.71617 10.0345C3.77393 9.77522 3.84289 9.52012 3.92249 9.26978C5.07865 5.63404 8.48217 3.00008 12.5009 3.00008C12.7308 3.00008 12.9586 3.0087 13.1842 3.02563C16.2787 1.62287 19.158 1.29938 20.3759 2.51465C21.5009 3.63795 21.4384 5.51011 20.5009 7.75671C20.4918 7.77847 20.4828 7.79991 20.4739 7.82104C21.1298 9.06983 21.5009 10.4916 21.5009 12.0001C21.5009 12.3381 21.4823 12.6718 21.446 13.0001H18.4179H6.58385ZM8.00613 19.7991C6.1803 18.7445 4.75932 17.0672 4.03351 15.0575C2.87291 17.3392 2.57399 19.2474 3.56507 20.237C4.37757 21.0491 6.00257 20.861 8.00257 19.801L8.00613 19.7991ZM20.1728 7.29218C20.178 7.28091 20.1832 7.26962 20.1884 7.2583C20.9384 5.63576 21.0009 4.26367 20.3134 3.4524C19.4442 2.58451 17.7732 2.70192 15.7906 3.62029C17.6193 4.33877 19.1559 5.63857 20.1728 7.29218Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$14746ef7a36ef966(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.0281 2.00098C14.1535 2.00284 14.7238 2.00879 15.2166 2.02346L15.4107 2.02981C15.6349 2.03778 15.8561 2.04778 16.1228 2.06028C17.1869 2.10944 17.9128 2.27778 18.5503 2.52528C19.2094 2.77944 19.7661 3.12278 20.3219 3.67861C20.8769 4.23444 21.2203 4.79278 21.4753 5.45028C21.7219 6.08694 21.8903 6.81361 21.9403 7.87778C21.9522 8.14444 21.9618 8.36564 21.9697 8.58989L21.976 8.78397C21.9906 9.27672 21.9973 9.8471 21.9994 10.9725L22.0002 11.7182C22.0003 11.8093 22.0003 11.9033 22.0003 12.0003L22.0002 12.2824L21.9996 13.0281C21.9977 14.1535 21.9918 14.7238 21.9771 15.2166L21.9707 15.4107C21.9628 15.6349 21.9528 15.8561 21.9403 16.1228C21.8911 17.1869 21.7219 17.9128 21.4753 18.5503C21.2211 19.2094 20.8769 19.7661 20.3219 20.3219C19.7661 20.8769 19.2069 21.2203 18.5503 21.4753C17.9128 21.7219 17.1869 21.8903 16.1228 21.9403C15.8561 21.9522 15.6349 21.9618 15.4107 21.9697L15.2166 21.976C14.7238 21.9906 14.1535 21.9973 13.0281 21.9994L12.2824 22.0002C12.1913 22.0003 12.0973 22.0003 12.0003 22.0003L11.7182 22.0002L10.9725 21.9996C9.8471 21.9977 9.27672 21.9918 8.78397 21.9771L8.58989 21.9707C8.36564 21.9628 8.14444 21.9528 7.87778 21.9403C6.81361 21.8911 6.08861 21.7219 5.45028 21.4753C4.79194 21.2211 4.23444 20.8769 3.67861 20.3219C3.12278 19.7661 2.78028 19.2069 2.52528 18.5503C2.27778 17.9128 2.11028 17.1869 2.06028 16.1228C2.0484 15.8561 2.03871 15.6349 2.03086 15.4107L2.02457 15.2166C2.00994 14.7238 2.00327 14.1535 2.00111 13.0281L2.00098 10.9725C2.00284 9.8471 2.00879 9.27672 2.02346 8.78397L2.02981 8.58989C2.03778 8.36564 2.04778 8.14444 2.06028 7.87778C2.10944 6.81278 2.27778 6.08778 2.52528 5.45028C2.77944 4.79194 3.12278 4.23444 3.67861 3.67861C4.23444 3.12278 4.79278 2.78028 5.45028 2.52528C6.08778 2.27778 6.81278 2.11028 7.87778 2.06028C8.14444 2.0484 8.36564 2.03871 8.58989 2.03086L8.78397 2.02457C9.27672 2.00994 9.8471 2.00327 10.9725 2.00111L13.0281 2.00098ZM12.0003 7.00028C9.23738 7.00028 7.00028 9.23981 7.00028 12.0003C7.00028 14.7632 9.23981 17.0003 12.0003 17.0003C14.7632 17.0003 17.0003 14.7607 17.0003 12.0003C17.0003 9.23738 14.7607 7.00028 12.0003 7.00028ZM12.0003 9.00028C13.6572 9.00028 15.0003 10.3429 15.0003 12.0003C15.0003 13.6572 13.6576 15.0003 12.0003 15.0003C10.3434 15.0003 9.00028 13.6576 9.00028 12.0003C9.00028 10.3434 10.3429 9.00028 12.0003 9.00028ZM17.2503 5.50028C16.561 5.50028 16.0003 6.06018 16.0003 6.74943C16.0003 7.43867 16.5602 7.99944 17.2503 7.99944C17.9395 7.99944 18.5003 7.43954 18.5003 6.74943C18.5003 6.06018 17.9386 5.49941 17.2503 5.50028Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b136e1993828e038(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 9C10.3436 9 9.00098 10.3431 9.00098 12C9.00098 13.6573 10.3441 15 12.001 15C13.6583 15 15.001 13.6569 15.001 12C15.001 10.3427 13.6579 9 12.001 9ZM12.001 7C14.7614 7 17.001 9.2371 17.001 12C17.001 14.7605 14.7639 17 12.001 17C9.24051 17 7.00098 14.7629 7.00098 12C7.00098 9.23953 9.23808 7 12.001 7ZM18.501 6.74915C18.501 7.43926 17.9402 7.99917 17.251 7.99917C16.5609 7.99917 16.001 7.4384 16.001 6.74915C16.001 6.0599 16.5617 5.5 17.251 5.5C17.9393 5.49913 18.501 6.0599 18.501 6.74915ZM12.001 4C9.5265 4 9.12318 4.00655 7.97227 4.0578C7.18815 4.09461 6.66253 4.20007 6.17416 4.38967C5.74016 4.55799 5.42709 4.75898 5.09352 5.09255C4.75867 5.4274 4.55804 5.73963 4.3904 6.17383C4.20036 6.66332 4.09493 7.18811 4.05878 7.97115C4.00703 9.0752 4.00098 9.46105 4.00098 12C4.00098 14.4745 4.00753 14.8778 4.05877 16.0286C4.0956 16.8124 4.2012 17.3388 4.39034 17.826C4.5591 18.2606 4.7605 18.5744 5.09246 18.9064C5.42863 19.2421 5.74179 19.4434 6.17187 19.6094C6.66619 19.8005 7.19148 19.9061 7.97212 19.9422C9.07618 19.9939 9.46203 20 12.001 20C14.4755 20 14.8788 19.9934 16.0296 19.9422C16.8117 19.9055 17.3385 19.7996 17.827 19.6106C18.2604 19.4423 18.5752 19.2402 18.9074 18.9085C19.2436 18.5718 19.4445 18.2594 19.6107 17.8283C19.8013 17.3358 19.9071 16.8098 19.9432 16.0289C19.9949 14.9248 20.001 14.5389 20.001 12C20.001 9.52552 19.9944 9.12221 19.9432 7.97137C19.9064 7.18906 19.8005 6.66149 19.6113 6.17318C19.4434 5.74038 19.2417 5.42635 18.9084 5.09255C18.573 4.75715 18.2616 4.55693 17.8271 4.38942C17.338 4.19954 16.8124 4.09396 16.0298 4.05781C14.9258 4.00605 14.5399 4 12.001 4ZM12.001 2C14.7176 2 15.0568 2.01 16.1235 2.06C17.1876 2.10917 17.9135 2.2775 18.551 2.525C19.2101 2.77917 19.7668 3.1225 20.3226 3.67833C20.8776 4.23417 21.221 4.7925 21.476 5.45C21.7226 6.08667 21.891 6.81333 21.941 7.8775C21.9885 8.94417 22.001 9.28333 22.001 12C22.001 14.7167 21.991 15.0558 21.941 16.1225C21.8918 17.1867 21.7226 17.9125 21.476 18.55C21.2218 19.2092 20.8776 19.7658 20.3226 20.3217C19.7668 20.8767 19.2076 21.22 18.551 21.475C17.9135 21.7217 17.1876 21.89 16.1235 21.94C15.0568 21.9875 14.7176 22 12.001 22C9.28431 22 8.94514 21.99 7.87848 21.94C6.81431 21.8908 6.08931 21.7217 5.45098 21.475C4.79264 21.2208 4.23514 20.8767 3.67931 20.3217C3.12348 19.7658 2.78098 19.2067 2.52598 18.55C2.27848 17.9125 2.11098 17.1867 2.06098 16.1225C2.01348 15.0558 2.00098 14.7167 2.00098 12C2.00098 9.28333 2.01098 8.94417 2.06098 7.8775C2.11014 6.8125 2.27848 6.0875 2.52598 5.45C2.78014 4.79167 3.12348 4.23417 3.67931 3.67833C4.23514 3.1225 4.79348 2.78 5.45098 2.525C6.08848 2.2775 6.81348 2.11 7.87848 2.06C8.94514 2.0125 9.28431 2 12.001 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5f26e518fd80ae10(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.00098 3H20.001C20.5533 3 21.001 3.44772 21.001 4V20C21.001 20.5523 20.5533 21 20.001 21H4.00098C3.44869 21 3.00098 20.5523 3.00098 20V4C3.00098 3.44772 3.44869 3 4.00098 3ZM6.98859 14.065C6.92833 14.3319 6.89804 14.6202 6.89804 14.8553C6.89804 15.7819 7.38103 16.397 8.40727 16.397C9.25846 16.397 9.94845 15.8711 10.4453 15.022L10.1419 16.2887H11.8321L12.798 12.2578C13.0395 11.2372 13.5073 10.7074 14.2167 10.7074C14.7751 10.7074 15.1222 11.0687 15.1222 11.6652C15.1222 11.838 15.1071 12.0263 15.0468 12.2304L14.5486 14.0832C14.4732 14.3502 14.4431 14.6173 14.4431 14.8683C14.4431 15.7479 14.941 16.3913 15.9824 16.3913C16.8729 16.3913 17.5821 15.7949 17.9746 14.366L17.3106 14.0993C16.9785 15.0566 16.6917 15.2297 16.4654 15.2297C16.239 15.2297 16.1182 15.0727 16.1182 14.7589C16.1182 14.6176 16.1485 14.4607 16.1937 14.2719L16.6767 12.4668C16.7974 12.043 16.8428 11.6671 16.8428 11.3218C16.8428 9.97143 16.0579 9.26673 15.1071 9.26673C14.2167 9.26673 13.3111 10.1023 12.8585 10.9817L13.1904 9.40324H10.6098L10.2475 10.7936H11.4549L10.7114 13.8906C10.1275 15.2409 9.05502 15.2628 8.92043 15.2314C8.69942 15.1796 8.55815 15.0923 8.55815 14.7935C8.55815 14.6211 8.58825 14.3735 8.66372 14.0749L9.79573 9.40324H6.92833L6.56612 10.7936H7.75826L6.98859 14.065ZM8.62598 8.625C9.2473 8.625 9.75098 8.12132 9.75098 7.5C9.75098 6.87868 9.2473 6.375 8.62598 6.375C8.00466 6.375 7.50098 6.87868 7.50098 7.5C7.50098 8.12132 8.00466 8.625 8.62598 8.625Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a4d084ec1835f9a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.00098 3H20.001C20.5533 3 21.001 3.44772 21.001 4V20C21.001 20.5523 20.5533 21 20.001 21H4.00098C3.44869 21 3.00098 20.5523 3.00098 20V4C3.00098 3.44772 3.44869 3 4.00098 3ZM5.00098 5V19H19.001V5H5.00098ZM6.98859 14.065L7.75826 10.7936H6.56612L6.92833 9.40324H9.79573L8.66372 14.0749C8.58825 14.3735 8.55815 14.6211 8.55815 14.7935C8.55815 15.0923 8.69942 15.1796 8.92043 15.2314C9.05502 15.2628 10.1275 15.2409 10.7114 13.8906L11.4549 10.7936H10.2475L10.6098 9.40324H13.1904L12.8585 10.9817C13.3111 10.1023 14.2167 9.26673 15.1071 9.26673C16.0579 9.26673 16.8428 9.97143 16.8428 11.3218C16.8428 11.6671 16.7974 12.043 16.6767 12.4668L16.1937 14.2719C16.1485 14.4607 16.1182 14.6176 16.1182 14.7589C16.1182 15.0727 16.239 15.2297 16.4654 15.2297C16.6917 15.2297 16.9785 15.0566 17.3106 14.0993L17.9746 14.366C17.5821 15.7949 16.8729 16.3913 15.9824 16.3913C14.941 16.3913 14.4431 15.7479 14.4431 14.8683C14.4431 14.6173 14.4732 14.3502 14.5486 14.0832L15.0468 12.2304C15.1071 12.0263 15.1222 11.838 15.1222 11.6652C15.1222 11.0687 14.7751 10.7074 14.2167 10.7074C13.5073 10.7074 13.0395 11.2372 12.798 12.2578L11.8321 16.2887H10.1419L10.4453 15.022C9.94845 15.8711 9.25846 16.397 8.40727 16.397C7.38103 16.397 6.89804 15.7819 6.89804 14.8553C6.89804 14.6202 6.92833 14.3319 6.98859 14.065ZM8.62598 8.625C8.00466 8.625 7.50098 8.12132 7.50098 7.5C7.50098 6.87868 8.00466 6.375 8.62598 6.375C9.2473 6.375 9.75098 6.87868 9.75098 7.5C9.75098 8.12132 9.2473 8.625 8.62598 8.625Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$495afadb04cc70bc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0009 3C17.7999 3 22.501 6.66445 22.501 11.1847C22.501 15.705 17.7999 19.3694 12.0009 19.3694C11.4127 19.3694 10.8361 19.331 10.2742 19.2586L5.86611 22.1419C5.36471 22.4073 5.18769 22.3778 5.39411 21.7289L6.28571 18.0513C3.40572 16.5919 1.50098 14.0619 1.50098 11.1847C1.50098 6.66445 6.20194 3 12.0009 3ZM17.908 11.0591L19.3783 9.63617C19.5656 9.45485 19.5705 9.15617 19.3893 8.96882C19.2081 8.78172 18.9094 8.77668 18.7219 8.95788L16.7937 10.8239V9.28226C16.7937 9.02172 16.5825 8.81038 16.3218 8.81038C16.0613 8.81038 15.8499 9.02172 15.8499 9.28226V11.8393C15.8321 11.9123 15.8325 11.9879 15.8499 12.0611V13.5C15.8499 13.7606 16.0613 13.9719 16.3218 13.9719C16.5825 13.9719 16.7937 13.7606 16.7937 13.5V12.1373L17.2213 11.7236L18.6491 13.7565C18.741 13.8873 18.8873 13.9573 19.0357 13.9573C19.1295 13.9573 19.2241 13.9293 19.3066 13.8714C19.5199 13.7217 19.5713 13.4273 19.4215 13.214L17.908 11.0591ZM14.9503 12.9839H13.4904V9.29702C13.4904 9.03648 13.2791 8.82514 13.0184 8.82514C12.7579 8.82514 12.5467 9.03648 12.5467 9.29702V13.4557C12.5467 13.7164 12.7579 13.9276 13.0184 13.9276H14.9503C15.211 13.9276 15.4222 13.7164 15.4222 13.4557C15.4222 13.1952 15.211 12.9839 14.9503 12.9839ZM9.09318 11.8925L9.78919 10.1849L10.4265 11.8925H9.09318ZM11.6159 12.3802C11.6161 12.3748 11.6175 12.3699 11.6175 12.3645C11.6175 12.2405 11.5687 12.1287 11.4906 12.0445L10.4452 9.24376C10.3468 8.9639 10.1005 8.77815 9.81761 8.77028C9.53948 8.76277 9.28066 8.93672 9.16453 9.21669L7.50348 13.2924C7.40519 13.5337 7.52107 13.8092 7.76242 13.9076C8.00378 14.006 8.2792 13.89 8.37749 13.6486L8.70852 12.8364H10.7787L11.077 13.6356C11.1479 13.8254 11.3278 13.9426 11.5193 13.9425C11.5741 13.9425 11.6298 13.9329 11.6842 13.9126C11.9284 13.8216 12.0524 13.5497 11.9612 13.3054L11.6159 12.3802ZM8.29446 9.30194C8.29446 9.0414 8.08312 8.83006 7.82258 8.83006H4.57822C4.31755 8.83006 4.10622 9.0414 4.10622 9.30194C4.10622 9.56249 4.31755 9.77382 4.57822 9.77382H5.73824V13.5099C5.73824 13.7705 5.94957 13.9817 6.21012 13.9817C6.47078 13.9817 6.68212 13.7705 6.68212 13.5099V9.77382H7.82258C8.08312 9.77382 8.29446 9.56249 8.29446 9.30194Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e4ba35e9b5a9c50f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.67859 18.123C3.09315 16.5658 1.50098 14.112 1.50098 11.4052C1.50098 6.70096 6.24882 3 12.0009 3C17.753 3 22.501 6.70097 22.501 11.4052C22.501 16.1094 17.753 19.8104 12.0009 19.8104C11.5591 19.8104 11.1195 19.7883 10.6834 19.7446L6.91829 22.2026C6.3026 22.5286 5.96085 22.6281 5.4334 22.2685C4.8127 21.8453 4.83666 21.3768 5.05149 20.7096L5.67859 18.123ZM3.50098 11.4052C3.50098 13.5368 4.91871 15.5282 7.28204 16.7258L7.98846 17.0838L7.80187 17.8535L7.40093 19.5022L10.2003 17.6711L10.5665 17.7183C11.04 17.7794 11.5188 17.8104 12.0009 17.8104C16.7422 17.8104 20.501 14.8805 20.501 11.4052C20.501 7.92993 16.7422 5 12.0009 5C7.25967 5 3.50098 7.92991 3.50098 11.4052ZM17.908 11.0591L19.4215 13.214C19.5713 13.4273 19.5199 13.7217 19.3066 13.8714C19.2241 13.9293 19.1295 13.9573 19.0357 13.9573C18.8873 13.9573 18.741 13.8873 18.6491 13.7565L17.2213 11.7236L16.7937 12.1373V13.5C16.7937 13.7606 16.5825 13.9719 16.3218 13.9719C16.0613 13.9719 15.8499 13.7606 15.8499 13.5V12.0611C15.8325 11.9879 15.8321 11.9123 15.8499 11.8393V9.28226C15.8499 9.02172 16.0613 8.81038 16.3218 8.81038C16.5825 8.81038 16.7937 9.02172 16.7937 9.28226V10.8239L18.7219 8.95788C18.9094 8.77668 19.2081 8.78172 19.3893 8.96882C19.5705 9.15617 19.5656 9.45485 19.3783 9.63617L17.908 11.0591ZM14.9503 12.9839C15.211 12.9839 15.4222 13.1952 15.4222 13.4557C15.4222 13.7164 15.211 13.9276 14.9503 13.9276H13.0184C12.7579 13.9276 12.5467 13.7164 12.5467 13.4557V9.29702C12.5467 9.03648 12.7579 8.82514 13.0184 8.82514C13.2791 8.82514 13.4904 9.03648 13.4904 9.29702V12.9839H14.9503ZM9.09318 11.8925H10.4265L9.78919 10.1849L9.09318 11.8925ZM11.6159 12.3802L11.9612 13.3054C12.0524 13.5497 11.9284 13.8216 11.6842 13.9126C11.6298 13.9329 11.5741 13.9425 11.5193 13.9425C11.3278 13.9426 11.1479 13.8254 11.077 13.6356L10.7787 12.8364H8.70852L8.37749 13.6486C8.2792 13.89 8.00378 14.006 7.76242 13.9076C7.52107 13.8092 7.40519 13.5337 7.50348 13.2924L9.16453 9.21669C9.28066 8.93672 9.53948 8.76277 9.81761 8.77028C10.1005 8.77815 10.3468 8.9639 10.4452 9.24376L11.4906 12.0445C11.5687 12.1287 11.6175 12.2405 11.6175 12.3645C11.6175 12.3699 11.6161 12.3748 11.6159 12.3802ZM8.29446 9.30194C8.29446 9.56249 8.08312 9.77382 7.82258 9.77382H6.68212V13.5099C6.68212 13.7705 6.47078 13.9817 6.21012 13.9817C5.94957 13.9817 5.73824 13.7705 5.73824 13.5099V9.77382H4.57822C4.31755 9.77382 4.10622 9.56249 4.10622 9.30194C4.10622 9.0414 4.31755 8.83006 4.57822 8.83006H7.82258C8.08312 8.83006 8.29446 9.0414 8.29446 9.30194Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b9784201a37e5e86(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21V21H3V3ZM10.5637 5.53613H6.25452V18.4635H10.5637V15.5907H12.0001V17.0271H13.4364V18.4635H17.7455V14.1543H16.3091V12.7179H14.8728V11.2816H16.3091V9.8452H17.7455V5.53613H13.4364V6.97249H12.0001V8.40884H10.5637V5.53613Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$31e34eebd27cf457(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2H11.0001V3.99998H13.0001V2H21V9.99994H19V13.9999H21V22H13.0001V20H11.0001V22H3V2ZM13.0001 18H15.0001V20H19V15.9999H17V13.9999H15V9.99992H17V7.99994H19V4H15.0001V5.99998H13.0001V7.99996H9.0001V4H5V20H9.0001V16H13.0001V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$301021dce2c09089(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.6635 10.8406C18.6635 11.1281 18.4293 11.3656 18.1385 11.3656H16.676V12.3031H18.1385C18.4293 12.3031 18.6635 12.5389 18.6635 12.8281C18.6635 13.1148 18.4293 13.3523 18.1385 13.3523H16.1501C15.8626 13.3523 15.6276 13.1148 15.6276 12.8281V8.85227C15.6276 8.56477 15.8626 8.32727 16.1526 8.32727H18.141C18.4293 8.32727 18.6635 8.56477 18.6635 8.85227C18.6635 9.1431 18.4293 9.37727 18.1385 9.37727H16.676V10.3148H18.1385C18.4293 10.3148 18.6635 10.5523 18.6635 10.8406ZM14.566 13.3248C14.5126 13.3423 14.4551 13.3506 14.4001 13.3506C14.2243 13.3506 14.0743 13.2756 13.9751 13.1423L11.9393 10.3781V12.8281C11.9393 13.1148 11.7068 13.3523 11.4135 13.3523C11.1251 13.3523 10.8918 13.1148 10.8918 12.8281V8.85227C10.8918 8.62727 11.036 8.42727 11.2501 8.35643C11.3001 8.33727 11.3635 8.32893 11.4118 8.32893C11.5743 8.32893 11.7243 8.4156 11.8243 8.5406L13.876 11.3156V8.85227C13.876 8.56477 14.111 8.32727 14.401 8.32727C14.6885 8.32727 14.926 8.56477 14.926 8.85227V12.8281C14.926 13.0531 14.781 13.2531 14.566 13.3248ZM9.61598 13.3523C9.32848 13.3523 9.09348 13.1148 9.09348 12.8281V8.85227C9.09348 8.56477 9.32848 8.32727 9.61848 8.32727C9.90681 8.32727 10.1418 8.56477 10.1418 8.85227V12.8281C10.1418 13.1148 9.90681 13.3523 9.61598 13.3523ZM8.08681 13.3523H6.09848C5.81098 13.3523 5.57348 13.1148 5.57348 12.8281V8.85227C5.57348 8.56477 5.81098 8.32727 6.09848 8.32727C6.38848 8.32727 6.62348 8.56477 6.62348 8.85227V12.3031H8.08681C8.37681 12.3031 8.61098 12.5389 8.61098 12.8281C8.61098 13.1148 8.37598 13.3523 8.08681 13.3523ZM12.001 2.57227C6.48848 2.57227 2.00098 6.21477 2.00098 10.6906C2.00098 14.6998 5.55931 18.0589 10.3635 18.6973C10.6893 18.7656 11.1326 18.9123 11.2451 19.1889C11.3451 19.4398 11.311 19.8273 11.2768 20.0889L11.1401 20.9389C11.1026 21.1898 10.9401 21.9273 12.0143 21.4764C13.0901 21.0273 17.7776 18.0781 19.8776 15.6639C21.3143 14.0898 22.001 12.4773 22.001 10.6906C22.001 6.21477 17.5135 2.57227 12.001 2.57227Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fa907d328f57877a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.001 10.6906C22.001 12.4773 21.3143 14.0898 19.8776 15.6639C17.7776 18.0781 13.0901 21.0273 12.0143 21.4764C10.9401 21.9273 11.1026 21.1898 11.1401 20.9389L11.2768 20.0889C11.311 19.8273 11.3451 19.4398 11.2451 19.1889C11.1326 18.9123 10.6893 18.7656 10.3635 18.6973C5.55931 18.0589 2.00098 14.6998 2.00098 10.6906C2.00098 6.21477 6.48848 2.57227 12.001 2.57227C17.5135 2.57227 22.001 6.21477 22.001 10.6906ZM18.4004 14.3157C19.514 13.0955 20.001 11.9542 20.001 10.6906C20.001 7.42219 16.4903 4.57227 12.001 4.57227C7.51164 4.57227 4.00098 7.42219 4.00098 10.6906C4.00098 13.5955 6.7293 16.1968 10.6269 16.7147L10.774 16.7398C11.8525 16.966 12.6581 17.3541 13.1029 18.4483C13.1158 18.4804 13.1279 18.5124 13.1395 18.5441C14.9449 17.3678 17.313 15.5652 18.4004 14.3157ZM18.1385 10.3148C18.4293 10.3148 18.6635 10.5523 18.6635 10.8406C18.6635 11.1281 18.4293 11.3656 18.1385 11.3656H16.676V12.3031H18.1385C18.4293 12.3031 18.6635 12.5389 18.6635 12.8281C18.6635 13.1148 18.4293 13.3523 18.1385 13.3523H16.1501C15.8626 13.3523 15.6276 13.1148 15.6276 12.8281V8.85227C15.6276 8.56477 15.8626 8.32727 16.1526 8.32727H18.141C18.4293 8.32727 18.6635 8.56477 18.6635 8.85227C18.6635 9.1431 18.4293 9.37727 18.1385 9.37727H16.676V10.3148H18.1385ZM14.926 12.8281C14.926 13.0531 14.781 13.2531 14.566 13.3248C14.5126 13.3423 14.4551 13.3506 14.4001 13.3506C14.2243 13.3506 14.0743 13.2756 13.9751 13.1423L11.9393 10.3781V12.8281C11.9393 13.1148 11.7068 13.3523 11.4135 13.3523C11.1251 13.3523 10.8918 13.1148 10.8918 12.8281V8.85227C10.8918 8.62727 11.036 8.42727 11.2501 8.35643C11.3001 8.33727 11.3635 8.32893 11.4118 8.32893C11.5743 8.32893 11.7243 8.4156 11.8243 8.5406L13.876 11.3156V8.85227C13.876 8.56477 14.111 8.32727 14.401 8.32727C14.6885 8.32727 14.926 8.56477 14.926 8.85227V12.8281ZM10.1418 12.8281C10.1418 13.1148 9.90681 13.3523 9.61598 13.3523C9.32848 13.3523 9.09348 13.1148 9.09348 12.8281V8.85227C9.09348 8.56477 9.32848 8.32727 9.61848 8.32727C9.90681 8.32727 10.1418 8.56477 10.1418 8.85227V12.8281ZM8.08681 13.3523H6.09848C5.81098 13.3523 5.57348 13.1148 5.57348 12.8281V8.85227C5.57348 8.56477 5.81098 8.32727 6.09848 8.32727C6.38848 8.32727 6.62348 8.56477 6.62348 8.85227V12.3031H8.08681C8.37681 12.3031 8.61098 12.5389 8.61098 12.8281C8.61098 13.1148 8.37598 13.3523 8.08681 13.3523Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8141ebf35564dcb9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.3362 18.339H15.6707V14.1622C15.6707 13.1662 15.6505 11.8845 14.2817 11.8845C12.892 11.8845 12.6797 12.9683 12.6797 14.0887V18.339H10.0142V9.75H12.5747V10.9207H12.6092C12.967 10.2457 13.837 9.53325 15.1367 9.53325C17.8375 9.53325 18.337 11.3108 18.337 13.6245V18.339H18.3362ZM7.00373 8.57475C6.14573 8.57475 5.45648 7.88025 5.45648 7.026C5.45648 6.1725 6.14648 5.47875 7.00373 5.47875C7.85873 5.47875 8.55173 6.1725 8.55173 7.026C8.55173 7.88025 7.85798 8.57475 7.00373 8.57475ZM8.34023 18.339H5.66723V9.75H8.34023V18.339ZM19.6697 3H4.32923C3.59498 3 3.00098 3.5805 3.00098 4.29675V19.7033C3.00098 20.4202 3.59498 21 4.32923 21H19.6675C20.401 21 21.001 20.4202 21.001 19.7033V4.29675C21.001 3.5805 20.401 3 19.6675 3H19.6697Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4614c9659f89b61b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.00098 3H20.001C20.5533 3 21.001 3.44772 21.001 4V20C21.001 20.5523 20.5533 21 20.001 21H4.00098C3.44869 21 3.00098 20.5523 3.00098 20V4C3.00098 3.44772 3.44869 3 4.00098 3ZM5.00098 5V19H19.001V5H5.00098ZM7.50098 9C6.67255 9 6.00098 8.32843 6.00098 7.5C6.00098 6.67157 6.67255 6 7.50098 6C8.3294 6 9.00098 6.67157 9.00098 7.5C9.00098 8.32843 8.3294 9 7.50098 9ZM6.50098 10H8.50098V17.5H6.50098V10ZM12.001 10.4295C12.5854 9.86534 13.2665 9.5 14.001 9.5C16.072 9.5 17.501 11.1789 17.501 13.25V17.5H15.501V13.25C15.501 12.2835 14.7175 11.5 13.751 11.5C12.7845 11.5 12.001 12.2835 12.001 13.25V17.5H10.001V10H12.001V10.4295Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$91787c8fac42a650(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.94048 4.99993C6.94011 5.81424 6.44608 6.54702 5.69134 6.85273C4.9366 7.15845 4.07187 6.97605 3.5049 6.39155C2.93793 5.80704 2.78195 4.93715 3.1105 4.19207C3.43906 3.44699 4.18654 2.9755 5.00048 2.99993C6.08155 3.03238 6.94097 3.91837 6.94048 4.99993ZM7.00048 8.47993H3.00048V20.9999H7.00048V8.47993ZM13.3205 8.47993H9.34048V20.9999H13.2805V14.4299C13.2805 10.7699 18.0505 10.4299 18.0505 14.4299V20.9999H22.0005V13.0699C22.0005 6.89993 14.9405 7.12993 13.2805 10.1599L13.3205 8.47993Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$75e25ebbb193064e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 9.55005C12.9181 8.61327 14.1121 8 15.501 8C18.5385 8 21.001 10.4624 21.001 13.5V21H19.001V13.5C19.001 11.567 17.434 10 15.501 10C13.568 10 12.001 11.567 12.001 13.5V21H10.001V8.5H12.001V9.55005ZM5.00098 6.5C4.17255 6.5 3.50098 5.82843 3.50098 5C3.50098 4.17157 4.17255 3.5 5.00098 3.5C5.8294 3.5 6.50098 4.17157 6.50098 5C6.50098 5.82843 5.8294 6.5 5.00098 6.5ZM4.00098 8.5H6.00098V21H4.00098V8.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$29ab94cc455561f2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 6.65431C13.5816 7.89902 14.5965 9.82997 14.5965 11.9979C14.5965 14.1659 13.5816 16.0969 12.001 17.3416C10.4204 16.0969 9.40547 14.1659 9.40547 11.9979C9.40547 9.82997 10.4204 7.89902 12.001 6.65431ZM11.1316 6.07195C9.46024 7.50254 8.40098 9.62766 8.40098 12.0002C8.40098 14.3712 9.45891 16.4952 11.1285 17.9257C10.1444 18.4797 9.00847 18.7957 7.79873 18.7957C4.04443 18.7957 1.00098 15.7522 1.00098 11.9979C1.00098 8.24365 4.04443 5.2002 7.79873 5.2002C9.00976 5.2002 10.1468 5.51688 11.1316 6.07195ZM12.8735 17.9257C14.543 16.4952 15.601 14.3712 15.601 12.0002C15.601 9.62766 14.5417 7.50254 12.8703 6.07195C13.8551 5.51688 14.9922 5.2002 16.2032 5.2002C19.9575 5.2002 23.001 8.24365 23.001 11.9979C23.001 15.7522 19.9575 18.7957 16.2032 18.7957C14.9935 18.7957 13.8576 18.4797 12.8735 17.9257Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bdce10b527926827(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 18.2944C10.916 18.9336 9.65132 19.3002 8.30098 19.3002C4.2693 19.3002 1.00098 16.0319 1.00098 12.0002C1.00098 7.96852 4.2693 4.7002 8.30098 4.7002C9.65132 4.7002 10.916 5.06683 12.001 5.70599C13.0859 5.06683 14.3506 4.7002 15.701 4.7002C19.7327 4.7002 23.001 7.96852 23.001 12.0002C23.001 16.0319 19.7327 19.3002 15.701 19.3002C14.3506 19.3002 13.0859 18.9336 12.001 18.2944ZM13.7027 16.9106C14.3194 17.1618 14.994 17.3002 15.701 17.3002C18.6281 17.3002 21.001 14.9273 21.001 12.0002C21.001 9.07309 18.6281 6.7002 15.701 6.7002C14.994 6.7002 14.3194 6.83861 13.7027 7.08982C14.8821 8.38643 15.601 10.1094 15.601 12.0002C15.601 13.891 14.8821 15.614 13.7027 16.9106ZM10.2992 7.08982C9.68255 6.83861 9.00793 6.7002 8.30098 6.7002C5.37387 6.7002 3.00098 9.07309 3.00098 12.0002C3.00098 14.9273 5.37387 17.3002 8.30098 17.3002C9.00793 17.3002 9.68255 17.1618 10.2992 16.9106C9.11986 15.614 8.40098 13.891 8.40098 12.0002C8.40098 10.1094 9.11986 8.38643 10.2992 7.08982ZM12.001 8.20546C11.0139 9.16805 10.401 10.5125 10.401 12.0002C10.401 13.4878 11.0139 14.8323 12.001 15.7949C12.9881 14.8323 13.601 13.4878 13.601 12.0002C13.601 10.5125 12.9881 9.16805 12.001 8.20546Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$79dfd02ed5369692(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.2595 13.9898C20.9852 15.4006 18.8033 16.9446 16.2974 17.2439C14.9907 17.3998 13.7041 17.5431 12.3321 17.4802C10.0885 17.3774 8.31809 16.9446 8.31809 16.9446C8.31809 17.163 8.33156 17.371 8.3585 17.5655C8.65019 19.7797 10.5541 19.9124 12.3576 19.9742C14.1779 20.0365 15.7987 19.5254 15.7987 19.5254L15.8735 21.1711C15.8735 21.1711 14.6003 21.8548 12.3321 21.9805C11.0814 22.0493 9.52849 21.9491 7.71973 21.4703C3.79684 20.432 3.12219 16.2504 3.01896 12.0074C2.98749 10.7477 3.00689 9.55981 3.00689 8.56632C3.00689 4.22771 5.84955 2.95599 5.84955 2.95599C7.2829 2.29772 9.74238 2.0209 12.2993 2H12.3621C14.919 2.0209 17.3801 2.29772 18.8133 2.95599C18.8133 2.95599 21.6559 4.22771 21.6559 8.56632C21.6559 8.56632 21.6916 11.7674 21.2595 13.9898ZM18.3029 8.9029C18.3029 7.82924 18.0295 6.97604 17.4805 6.34482C16.9142 5.71359 16.1726 5.39001 15.2522 5.39001C14.187 5.39001 13.3805 5.79937 12.8473 6.61819L12.3288 7.48723L11.8104 6.61819C11.2771 5.79937 10.4706 5.39001 9.40554 5.39001C8.485 5.39001 7.74344 5.71359 7.17719 6.34482C6.62807 6.97604 6.3547 7.82924 6.3547 8.9029V14.1562H8.43597V9.05731C8.43597 7.98246 8.88822 7.4369 9.79281 7.4369C10.793 7.4369 11.2944 8.08408 11.2944 9.36376V12.1547H13.3634V9.36376C13.3634 8.08408 13.8646 7.4369 14.8648 7.4369C15.7694 7.4369 16.2216 7.98246 16.2216 9.05731V14.1562H18.3029V8.9029Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3a8fd3ad04645e13(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.019 12.0075C2.98744 10.7478 3.00692 9.5598 3.00692 8.56644C3.00692 4.22767 5.84954 2.95597 5.84954 2.95597C7.28286 2.29767 9.74238 2.0209 12.2993 2H12.3621C14.919 2.0209 17.3801 2.29767 18.8134 2.95597C18.8134 2.95597 21.656 4.22767 21.656 8.56644C21.656 8.56644 21.6916 11.7674 21.2596 13.9898C20.9852 15.4007 18.8034 16.9446 16.2974 17.2438C14.9906 17.3999 13.7042 17.5431 12.3322 17.4802C10.0885 17.3775 8.31815 16.9446 8.31815 16.9446C8.31815 17.1631 8.33166 17.3711 8.35853 17.5655C8.44182 18.1978 8.65659 18.6604 8.96296 19C9.72944 19.8497 11.0692 19.9301 12.3577 19.9743C14.178 20.0366 15.7986 19.5254 15.7986 19.5254L15.8735 21.1712C15.8735 21.1712 14.6003 21.8548 12.3322 21.9805C11.0815 22.0493 9.52858 21.9491 7.71969 21.4704C6.18802 21.065 5.15153 20.1804 4.45091 19C3.35714 17.1573 3.08191 14.5938 3.019 12.0075ZM6.31815 16.9446V14.3967L8.79316 15.0018C8.8405 15.0134 8.95098 15.0383 9.11692 15.0723C9.40521 15.1313 9.73416 15.1908 10.0959 15.2467C10.8485 15.3628 11.6341 15.4462 12.4237 15.4823C13.4425 15.529 14.3249 15.4652 16.0603 15.2579C17.7233 15.0594 19.208 14.0622 19.2963 13.6082C19.3783 13.1861 19.4472 12.6858 19.5021 12.1261C19.5714 11.4205 19.6155 10.6558 19.6388 9.88068C19.654 9.37026 19.6582 8.93648 19.6564 8.62452L19.656 8.56644C19.656 7.1368 19.2873 6.12756 18.6928 5.40793C18.5008 5.17553 18.3004 4.99408 18.1087 4.85958C18.0183 4.79617 17.9737 4.77136 17.9787 4.77345C16.9662 4.30844 14.8859 4.02069 12.3621 3.99993H12.3156C9.77596 4.02069 7.6969 4.30836 6.66627 4.78161C6.68919 4.77136 6.64459 4.79617 6.55423 4.85958C6.36257 4.99408 6.16214 5.17553 5.97016 5.40793C5.37568 6.12756 5.00692 7.1368 5.00692 8.56644C5.00692 8.7976 5.00628 8.96339 5.00392 9.44137C4.9981 10.6238 5.00004 11.2256 5.01841 11.9589C5.07185 14.156 5.2822 15.7941 5.71797 17C5.93023 17.5874 6.19005 18.0709 6.49741 18.4507C6.37791 18.0162 6.31815 17.5142 6.31815 16.9446ZM8.08576 6.37135C8.71735 6.37135 9.22924 6.88324 9.22924 7.51482C9.22924 8.14626 8.71735 8.6583 8.08576 8.6583C7.45432 8.6583 6.94229 8.14626 6.94229 7.51482C6.94229 6.88324 7.45432 6.37135 8.08576 6.37135Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b817caa006eb4a6a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.00098 3H20.001C20.5533 3 21.001 3.44772 21.001 4V20C21.001 20.5523 20.5533 21 20.001 21H4.00098C3.44869 21 3.00098 20.5523 3.00098 20V4C3.00098 3.44772 3.44869 3 4.00098 3ZM17.3019 15.9403C17.2014 15.8901 17.1512 15.7394 17.1512 15.639V8.00643C17.1512 7.906 17.2014 7.75536 17.3019 7.65493L18.256 6.55021V6.5H14.8413L12.2802 12.9776L9.36765 6.5H5.85249V6.55021L6.75639 7.80557C6.95726 8.00643 7.00747 8.30771 7.00747 8.55879V14.0824C7.05769 14.3836 7.00747 14.7351 6.85682 15.0364L5.50098 16.8944V16.9446H9.11657V16.8944L7.76072 15.0866C7.61007 14.7854 7.55985 14.4841 7.61007 14.1326V9.11114C7.66029 9.21157 7.7105 9.21157 7.76072 9.41243L11.1754 17.045H11.2257L14.54 8.75964C14.4897 9.06093 14.4897 9.41243 14.4897 9.6635V15.5888C14.4897 15.7394 14.4395 15.8399 14.3391 15.9403L13.3348 16.8944V16.9446H18.256V16.8944L17.3019 15.9403Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e6c4c2151d4a7ce4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.00098 3H20.001C20.5533 3 21.001 3.44772 21.001 4V20C21.001 20.5523 20.5533 21 20.001 21H4.00098C3.44869 21 3.00098 20.5523 3.00098 20V4C3.00098 3.44772 3.44869 3 4.00098 3ZM5.00098 5V19H19.001V5H5.00098ZM17.3019 15.9403L18.256 16.8944V16.9446H13.3348V16.8944L14.3391 15.9403C14.4395 15.8399 14.4897 15.7394 14.4897 15.5888V9.6635C14.4897 9.41243 14.4897 9.06093 14.54 8.75964L11.2257 17.045H11.1754L7.76072 9.41243C7.7105 9.21157 7.66029 9.21157 7.61007 9.11114V14.1326C7.55985 14.4841 7.61007 14.7854 7.76072 15.0866L9.11657 16.8944V16.9446H5.50098V16.8944L6.85682 15.0364C7.00747 14.7351 7.05769 14.3836 7.00747 14.0824V8.55879C7.00747 8.30771 6.95726 8.00643 6.75639 7.80557L5.85249 6.55021V6.5H9.36765L12.2802 12.9776L14.8413 6.5H18.256V6.55021L17.3019 7.65493C17.2014 7.75536 17.1512 7.906 17.1512 8.00643V15.639C17.1512 15.7394 17.2014 15.8901 17.3019 15.9403Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6a23e2d28c9c882a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 2C17.6345 2 22.001 6.1265 22.001 11.7C22.001 17.2735 17.6345 21.4 12.001 21.4C11.0233 21.4023 10.0497 21.273 9.10648 21.0155C8.92907 20.9668 8.7403 20.9808 8.57198 21.055L6.58748 21.931C6.34398 22.0386 6.06291 22.018 5.83768 21.8761C5.61244 21.7342 5.47254 21.4896 5.46448 21.2235L5.40998 19.4445C5.40257 19.2257 5.30547 19.0196 5.14148 18.8745C3.19598 17.1345 2.00098 14.6155 2.00098 11.7C2.00098 6.1265 6.36748 2 12.001 2ZM5.99598 14.5365C5.71398 14.984 6.26398 15.488 6.68498 15.1685L9.84048 12.7735C10.0543 12.6122 10.3491 12.6122 10.563 12.7735L12.8995 14.5235C13.2346 14.7749 13.6596 14.8747 14.0716 14.7987C14.4836 14.7227 14.8451 14.4779 15.0685 14.1235L18.006 9.4635C18.288 9.016 17.738 8.512 17.317 8.8315L14.1615 11.2265C13.9476 11.3878 13.6528 11.3878 13.439 11.2265L11.1025 9.4765C10.7673 9.22511 10.3423 9.12532 9.93034 9.2013C9.51834 9.27728 9.15689 9.5221 8.93348 9.8765L5.99598 14.5365Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$23eae24c5ae5d575(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.76497 19.225C8.35411 18.9652 9.01479 18.9164 9.63316 19.0861C10.4032 19.2963 11.198 19.4019 12.001 19.4C16.5861 19.4 20.001 16.1135 20.001 11.7C20.001 7.28651 16.5861 4 12.001 4C7.41585 4 4.00098 7.28651 4.00098 11.7C4.00098 13.9699 4.89652 15.9722 6.46655 17.3764C7.0418 17.8853 7.38251 18.6082 7.409 19.3822L7.76497 19.225ZM12.001 2C17.6345 2 22.001 6.1265 22.001 11.7C22.001 17.2735 17.6345 21.4 12.001 21.4C11.0233 21.4023 10.0497 21.273 9.10648 21.0155C8.92907 20.9668 8.7403 20.9808 8.57198 21.055L6.58748 21.931C6.34398 22.0386 6.06291 22.018 5.83768 21.8761C5.61244 21.7342 5.47254 21.4896 5.46448 21.2235L5.40998 19.4445C5.40257 19.2257 5.30547 19.0196 5.14148 18.8745C3.19598 17.1345 2.00098 14.6155 2.00098 11.7C2.00098 6.1265 6.36748 2 12.001 2ZM5.99598 14.5365L8.93348 9.8765C9.15689 9.5221 9.51834 9.27728 9.93034 9.2013C10.3423 9.12532 10.7673 9.22511 11.1025 9.4765L13.439 11.2265C13.6528 11.3878 13.9476 11.3878 14.1615 11.2265L17.317 8.8315C17.738 8.512 18.288 9.016 18.006 9.4635L15.0685 14.1235C14.8451 14.4779 14.4836 14.7227 14.0716 14.7987C13.6596 14.8747 13.2346 14.7749 12.8995 14.5235L10.563 12.7735C10.3491 12.6122 10.0543 12.6122 9.84048 12.7735L6.68498 15.1685C6.26398 15.488 5.71398 14.984 5.99598 14.5365Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5f0395cf739830d2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9197 4.5C15.0689 4.5 13.622 5.89404 12.3123 7.6649C10.5124 5.37323 9.00722 4.5 7.20593 4.5C3.53352 4.5 0.719727 9.27931 0.719727 14.3379C0.719727 17.5034 2.25116 19.5 4.81628 19.5C6.66249 19.5 7.99028 18.6296 10.3508 14.5034C10.3508 14.5034 11.3347 12.7658 12.0116 11.5689C12.2488 11.9518 12.4981 12.3639 12.7611 12.8069L13.868 14.669C16.0242 18.2772 17.2256 19.5 19.4025 19.5C21.9014 19.5 23.2921 17.4761 23.2921 14.2448C23.2921 8.94828 20.4149 4.5 16.9197 4.5ZM8.55076 13.3862C6.63697 16.3862 5.9749 17.0586 4.90938 17.0586C3.81283 17.0586 3.16111 16.0959 3.16111 14.3793C3.16111 10.7069 4.99214 6.95172 7.1749 6.95172C8.35692 6.95172 9.34471 7.63438 10.8577 9.80042C9.42105 12.0041 8.55076 13.3862 8.55076 13.3862ZM15.7737 13.0085L14.4502 10.8013C14.0921 10.2188 13.7489 9.6836 13.4177 9.19286C14.6105 7.35183 15.5944 6.43448 16.7646 6.43448C19.1956 6.43448 21.1404 10.0138 21.1404 14.4103C21.1404 16.0862 20.5915 17.0586 19.4542 17.0586C18.3641 17.0586 17.8434 16.3387 15.7737 13.0085Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b2832b7b01bea4ea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.9744 16.1635C20.6888 17.0545 20.199 17.5 19.5048 17.5C18.6273 17.5 17.7647 16.9735 16.917 15.9206C16.3283 15.1893 15.5026 13.7996 14.44 11.7515C13.984 10.8723 13.5611 10.0959 13.1714 9.42225C13.4809 8.93372 13.757 8.54177 13.9998 8.24641C14.957 7.08214 15.9587 6.5 17.0048 6.5C17.8397 6.5 18.635 7.03584 19.3907 8.10753C20.1673 9.20896 20.7114 10.5694 21.0228 12.1888C21.3292 13.782 21.3131 15.1069 20.9744 16.1635ZM12.0049 11.4296C12.2149 11.8151 12.4349 12.2294 12.6647 12.6725C13.7887 14.839 14.6869 16.3397 15.3591 17.1748C16.6071 18.7249 17.989 19.5 19.5048 19.5C20.3608 19.5 21.0931 19.2297 21.7019 18.6892C22.2267 18.2233 22.6191 17.5849 22.879 16.774C23.3216 15.3931 23.3576 13.7388 22.9868 11.8112C22.6212 9.90978 21.9673 8.29105 21.0252 6.95497C19.8712 5.31832 18.531 4.5 17.0048 4.5C15.3288 4.5 13.8121 5.32543 12.4549 6.97628C12.3132 7.14862 12.1632 7.34668 12.0049 7.57046C11.8466 7.34668 11.6966 7.14862 11.5548 6.97628C10.1976 5.32543 8.68102 4.5 7.005 4.5C5.4788 4.5 4.13867 5.31833 2.98462 6.95498C2.04252 8.29105 1.38864 9.90977 1.02298 11.8112C0.652277 13.7388 0.688225 15.3931 1.13083 16.774C1.39074 17.5849 1.78309 18.2233 2.30788 18.6892C2.91672 19.2297 3.6491 19.5 4.50502 19.5C6.02087 19.5 7.40276 18.7249 8.65069 17.1748C9.32296 16.3397 10.2211 14.839 11.345 12.6726C11.575 12.2294 11.7949 11.8151 12.0049 11.4296ZM10.8384 9.42226C10.4487 10.0959 10.0258 10.8723 9.56972 11.7515C8.50715 13.7996 7.6815 15.1893 7.09279 15.9206C6.24514 16.9735 5.38255 17.5 4.50502 17.5C3.81084 17.5 3.32096 17.0545 3.03539 16.1635C2.69674 15.1069 2.6806 13.782 2.98699 12.1888C3.29843 10.5694 3.84248 9.20896 4.61913 8.10752C5.37481 7.03584 6.1701 6.5 7.005 6.5C8.05111 6.5 9.05277 7.08214 10.01 8.24641C10.2528 8.54176 10.5289 8.93371 10.8384 9.42226Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7593b1679e42fdf6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.501 3V11.5H3.00098V3H11.501ZM11.501 21H3.00098V12.5H11.501V21ZM12.501 3H21.001V11.5H12.501V3ZM21.001 12.5V21H12.501V12.5H21.001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ea355f28c06514a6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.001 5H5.00098V11H11.001V5ZM13.001 5V11H19.001V5H13.001ZM19.001 13H13.001V19H19.001V13ZM11.001 19V13H5.00098V19H11.001ZM3.00098 3H21.001V21H3.00098V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5e4f6a4349fabe77(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12C22 17.5228 17.5228 22 12 22H6.66472C8.68458 20.5479 10 18.1776 10 15.5H12C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12V15.5C8.5 19.0899 5.58985 22 2 22V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a65d18aa56a01e53(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20H7.69043C8.59297 19.0595 9.21538 17.8481 9.42355 16.5H12C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12V15.5C7.5 17.6416 6.00399 19.4338 4 19.8885V12C4 7.58172 7.58172 4 12 4ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12V22H12ZM9.5 14.5V12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5H9.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cb9e79c19ef75d5c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.8407 12.691C15.8185 12.6975 15.7966 12.7043 15.7743 12.7104C15.6382 12.749 15.4987 12.7727 15.3604 12.7727C14.7502 12.7727 14.4056 12.3605 14.5907 11.852C14.7261 11.4801 15.0814 11.1663 15.5152 11.021C16.1874 10.7758 16.6571 10.2167 16.6571 9.56612C16.6571 8.68948 15.8043 7.97881 14.7523 7.97881C13.7003 7.97881 12.8475 8.68948 12.8475 9.56612V14.4339C12.8475 15.6046 12.1693 16.6311 11.1544 17.2117C10.6012 17.5282 9.94956 17.7143 9.24971 17.7143C7.26575 17.7143 5.6518 16.2427 5.6518 14.4339C5.6518 13.8581 5.81642 13.3174 6.10329 12.8466C6.54725 12.1179 7.28702 11.5599 8.17307 11.3055C8.32463 11.2584 8.47956 11.2325 8.63232 11.2325C9.24523 11.2325 9.59142 11.6466 9.40553 12.1574C9.27956 12.5035 8.94031 12.8016 8.54478 12.9601C8.49754 12.9759 8.45157 12.9936 8.4062 13.0122C7.77792 13.2716 7.34493 13.8099 7.34493 14.4339C7.34493 15.3105 8.19769 16.0211 9.24971 16.0211C10.3016 16.0211 11.1544 15.3105 11.1544 14.4339V9.56612C11.1544 8.39537 11.8326 7.36888 12.8475 6.78821C13.4008 6.47172 14.0524 6.28567 14.7523 6.28567C16.7362 6.28567 18.3502 7.75724 18.3502 9.56612C18.3502 10.1418 18.1855 10.6826 17.8987 11.1534C17.4566 11.8789 16.7214 12.435 15.8407 12.691ZM2.00098 12C2.00098 17.5228 6.47814 22 12.001 22C17.5238 22 22.001 17.5228 22.001 12C22.001 6.47716 17.5238 2 12.001 2C6.47814 2 2.00098 6.47716 2.00098 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4248685686a033d8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 16.4183 7.5827 20 12.001 20ZM13.001 14C13.001 15.9332 11.434 17.5002 9.50098 17.5002C7.56798 17.5002 6.00098 15.9332 6.00098 14.0002C6.00098 12.6262 6.80048 11.3965 8.02405 10.8265C8.52467 10.5932 9.11958 10.81 9.35282 11.3106C9.58607 11.8112 9.36932 12.4061 8.86871 12.6393C8.34353 12.884 8.00098 13.4109 8.00098 14.0002C8.00098 14.8287 8.67255 15.5002 9.50098 15.5002C10.3294 15.5002 11.001 14.8287 11.001 14.0002V10C11.001 8.067 12.568 6.5 14.501 6.5C16.434 6.5 18.001 8.067 18.001 10C18.001 11.3741 17.2015 12.6037 15.9779 13.1738C15.4773 13.407 14.8824 13.1903 14.6491 12.6897C14.4159 12.189 14.6326 11.5941 15.1332 11.3609C15.6584 11.1162 16.001 10.5894 16.001 10C16.001 9.17157 15.3294 8.5 14.501 8.5C13.6725 8.5 13.001 9.17157 13.001 10V14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$485b27c6dcbf20d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM10.915 11.5684C11.1559 10.7273 11.9899 10.0266 12.9053 9.9202C13.092 10.6139 13.2926 11.2934 13.4503 11.9826C13.503 12.2127 13.4869 12.4776 13.4317 12.7098C13.2195 13.6019 12.1844 13.9521 11.4543 13.3949C10.9232 12.9896 10.7125 12.2757 10.915 11.5684ZM14.7323 11.3707C14.6071 10.9065 14.476 10.4438 14.3394 9.95097C14.8388 10.081 15.2465 10.3108 15.594 10.6485C16.8506 11.87 16.9793 13.9488 15.888 15.3804C14.7526 16.8698 12.7331 17.5141 10.8596 16.9848C8.55798 16.3345 7.05207 14.0327 7.41861 11.6692C7.69287 9.90076 8.68938 8.66514 10.3187 7.93582C10.7257 7.75367 10.8985 7.37612 10.739 7.0063C10.5818 6.64172 10.1984 6.50242 9.79548 6.66349C7.07384 7.7515 5.47405 10.7974 6.12578 13.6503C6.83792 16.7679 9.61963 18.8125 12.7995 18.5089C14.5318 18.3435 15.9636 17.5609 17.0156 16.1624C18.5218 14.1599 18.3131 11.3794 16.5534 9.66325C15.8867 9.01311 15.0816 8.64501 14.1638 8.50972C14.08 8.49736 13.9463 8.45787 13.9314 8.40426C13.8437 8.09092 13.7506 7.77237 13.7249 7.45035C13.6963 7.09273 14.0143 6.80938 14.3753 6.80488C14.6282 6.80173 14.8087 6.93579 14.9784 7.10468C15.2805 7.40513 15.6824 7.42674 15.9662 7.16733C16.2551 6.90322 16.2624 6.48912 15.984 6.15892C15.4178 5.48746 14.3978 5.26779 13.5545 5.63572C12.7067 6.00566 12.233 6.82256 12.3546 7.72916C12.3922 8.00993 12.4639 8.28616 12.5213 8.57131C12.4302 8.59639 12.3452 8.61951 12.2605 8.64317C11.4048 8.88224 10.6999 9.34675 10.1634 10.0575C9.24196 11.2778 9.22657 12.8846 10.1219 14.0044C11.3962 15.5982 13.8687 15.2882 14.6453 13.4357C14.9287 12.7595 14.9201 12.0676 14.7323 11.3707Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c3795f5544c0642e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.4222 11.375C10.1278 12.4026 10.4341 13.4395 11.2058 14.0282C12.267 14.8376 13.7712 14.3289 14.0796 13.0331C14.1599 12.6958 14.1833 12.311 14.1067 11.9767C13.8775 10.9756 13.586 9.98862 13.3147 8.98094C11.9843 9.13543 10.7722 10.1533 10.4222 11.375ZM15.9698 11.0879C16.2427 12.1002 16.2553 13.1053 15.8435 14.0875C14.7148 16.7784 11.1215 17.2286 9.26951 14.9136C7.96829 13.2869 7.99065 10.953 9.32982 9.18031C10.1096 8.14796 11.1339 7.47322 12.3776 7.12595C12.5007 7.09159 12.6241 7.058 12.7566 7.02157C12.6731 6.60736 12.569 6.20612 12.5143 5.79828C12.3375 4.48137 13.026 3.29477 14.2582 2.7574C15.4836 2.22294 16.9661 2.54204 17.7889 3.51738C18.1936 3.99703 18.183 4.59854 17.7631 4.98218C17.3507 5.359 16.7665 5.32761 16.3276 4.89118C16.0809 4.64585 15.8185 4.45112 15.451 4.45569C14.9264 4.46223 14.4642 4.87382 14.5058 5.39329C14.5432 5.86105 14.6785 6.32376 14.8058 6.77892C14.8276 6.85679 15.0218 6.91415 15.1436 6.9321C16.4775 7.12862 17.6476 7.66332 18.6165 8.60769C21.1739 11.1006 21.4772 15.1394 19.2882 18.0482C17.7593 20.0797 15.6785 21.2165 13.1609 21.4567C8.53953 21.8977 4.49683 18.9278 3.46188 14.3992C2.5147 10.2551 4.8397 5.83074 8.79509 4.25032C9.38067 4.01635 9.93787 4.21869 10.1664 4.74827C10.3982 5.28546 10.147 5.83389 9.55552 6.09847C7.18759 7.15787 5.73935 8.9527 5.34076 11.5215C4.80806 14.9546 6.99662 18.2982 10.3416 19.2428C13.0644 20.0117 15.9994 19.0758 17.6494 16.9123C19.2354 14.8328 19.0484 11.8131 17.2221 10.0389C16.7172 9.54838 16.1246 9.21455 15.3988 9.02564C15.5974 9.74151 15.7879 10.4136 15.9698 11.0879Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eb1796dc60783efb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.2917 3.81415L13.3102 9.52081L13.7059 10.6371L13.7132 5.82625L13.7222 1.00908H17.9931L18.0004 11.8713C18.0031 17.8519 17.9967 22.7617 17.9849 22.7708C17.9731 22.7798 17.7762 22.7708 17.5493 22.7435C16.5601 22.6256 15.2596 22.5076 14.2096 22.4622C13.8629 22.4459 13.5761 22.4277 13.5725 22.4241C13.5698 22.4205 13.3002 21.6618 12.7966 20.2397L12.7967 20.2359C12.3051 18.8476 11.5851 16.8121 10.653 14.1746L10.3126 13.2214L10.3054 17.8066C10.299 22.1718 10.2954 22.4168 10.2482 22.4168C10.0849 22.4168 8.67819 22.5076 8.20809 22.553C7.89953 22.5802 7.28241 22.6437 6.83772 22.6982C6.39212 22.749 6.02185 22.7835 6.01459 22.7762C6.00733 22.7689 6.00098 17.8674 6.00098 11.8831V1.00182H6.00615L6.00551 1H10.2936L10.3217 1.08077C10.3288 1.09558 10.3865 1.25644 10.479 1.51683L11.1204 3.29515L11.2928 3.79066L11.2917 3.81415Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1e4aae04c1a760c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.9853 17.2079L16.001 2H18.001V22C17.3209 21.7333 16.6476 21.5667 15.9809 21.5L8.00098 6.30216V21.5C7.33431 21.5667 6.66764 21.7333 6.00098 22V2H8.00098L15.9853 17.2079Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$47158175ce120895(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.1039 5.90984C6.68754 6.38398 6.90648 6.3478 8.00238 6.27469L18.3342 5.6543C18.5533 5.6543 18.3711 5.43569 18.2981 5.39936L16.5822 4.15891C16.2534 3.90367 15.8153 3.61134 14.9758 3.68446L4.9715 4.41415C4.60665 4.45033 4.53377 4.63274 4.67909 4.77898L6.1039 5.90984ZM6.72422 8.31764L6.72422 19.1885C6.72422 19.7728 7.01618 19.9913 7.6733 19.9552L19.028 19.2982C19.6854 19.262 19.7586 18.8602 19.7586 18.3856V7.58765C19.7586 7.11382 19.5764 6.85828 19.1739 6.89476L7.30815 7.58765C6.87027 7.62445 6.72422 7.84349 6.72422 8.31764ZM17.9335 8.90078C18.0063 9.22945 17.9335 9.5578 17.6043 9.59473L17.0571 9.70373V17.7293C16.5822 17.9846 16.1441 18.1306 15.7791 18.1306C15.1947 18.1306 15.0484 17.948 14.6107 17.4011L11.0321 11.7832V17.2187L12.1645 17.4742C12.1645 17.4742 12.1645 18.1306 11.2509 18.1306L8.73222 18.2767C8.65905 18.1306 8.73222 17.7661 8.98769 17.693L9.64494 17.5109V10.3241L8.73237 10.251C8.6592 9.92234 8.84146 9.44849 9.35298 9.41171L12.0549 9.22958L15.7791 14.9207V9.88615L14.8296 9.77716C14.7567 9.37538 15.0484 9.08365 15.4135 9.04747L17.9335 8.90078ZM4.13151 3.42922L14.5376 2.66291C15.8155 2.55331 16.1443 2.62672 16.9475 3.21017L20.2692 5.54485C20.8173 5.94632 21 6.05563 21 6.49328V19.2982C21 20.1007 20.7077 20.5753 19.6856 20.6479L7.60101 21.3776C6.83376 21.4142 6.4686 21.3049 6.0668 20.7938L3.6206 17.62C3.18227 17.0358 3 16.5988 3 16.0874L3 4.70557C3 4.0493 3.29242 3.50189 4.13151 3.42922Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$34b15824bb0c429c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.2852 2.95494C15.9283 2.71702 15.5011 2.60764 15.0738 2.6448L4.01455 3.60647C3.50353 3.65091 3.11133 4.0787 3.11133 4.59164L3.11133 16.1666C3.11133 16.5753 3.24389 16.973 3.48911 17.3L6.25617 20.9894C6.45903 21.2599 6.78602 21.4079 7.12313 21.382L19.9761 20.3933C20.4913 20.3537 20.8891 19.9241 20.8891 19.4074V6.52672C20.8891 6.2128 20.7322 5.91965 20.471 5.74551L16.2852 2.95494ZM15.2278 4.41589C15.2529 4.41371 15.278 4.42014 15.299 4.43414L18.0448 6.26466L7.8385 7.08117L5.97759 5.22026L15.2278 4.41589ZM19.1113 18.6768L8.38911 19.5016V8.82058L19.1113 7.9628V18.6768ZM4.88911 6.64593L6.61133 8.36815L6.61133 18.5L4.91133 16.2333C4.8969 16.2141 4.88911 16.1907 4.88911 16.1666L4.88911 6.64593ZM11.9786 10.1234L10.0022 10.2529V17.8154L11.9979 17.6846V13.3479L15.5098 17.5169L17.4861 17.3874V9.82491L15.4904 9.95571V14.2924L11.9786 10.1234Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6e118e61f965c61e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.001 3C20.5533 3 21.001 3.44772 21.001 4V20C21.001 20.5523 20.5533 21 20.001 21H4.00098C3.44869 21 3.00098 20.5523 3.00098 20V4C3.00098 3.44772 3.44869 3 4.00098 3H20.001ZM17.001 7H7.00098V17H12.001V9.5H14.501V17H17.001V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5355d8eb663141b6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.001 3C20.5533 3 21.001 3.44772 21.001 4V20C21.001 20.5523 20.5533 21 20.001 21H4.00098C3.44869 21 3.00098 20.5523 3.00098 20V4C3.00098 3.44772 3.44869 3 4.00098 3H20.001ZM19.001 5H5.00098V19H19.001V5ZM17.001 7V17H14.501V9.5H12.001V17H7.00098V7H17.001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$64c188a06cd352de(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 16.1302 19.497 19.6757 15.9243 21.201L13.4058 14.6514C14.3548 14.1476 15.001 13.1493 15.001 12C15.001 10.3431 13.6578 9 12.001 9C10.3441 9 9.00098 10.3431 9.00098 12C9.00098 13.1497 9.64766 14.1483 10.5971 14.6519L8.07863 21.2014C4.5054 19.6763 2.00098 16.1306 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ea6957364412bca8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 16.3996 19.1598 20.1355 15.2122 21.4732L14.9859 21.5469L12.082 13.997C13.151 13.95 14.001 13.0544 14.001 12C14.001 10.8954 13.1055 10 12.001 10C10.8964 10 10.001 10.8954 10.001 12C10.001 13.0768 10.8519 13.9548 11.918 13.9983L9.01501 21.5466L8.78975 21.4732C4.84212 20.1355 2.00098 16.3996 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2ZM12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 14.9201 5.56547 17.4747 7.90198 18.8715L9.38145 15.023C8.5358 14.2896 8.00098 13.2073 8.00098 12C8.00098 9.79086 9.79184 8 12.001 8C14.2101 8 16.001 9.79086 16.001 12C16.001 13.2075 15.466 14.29 14.62 15.0234C15.1861 16.4969 15.6797 17.7803 16.0998 18.8729C18.4362 17.4751 20.001 14.9203 20.001 12C20.001 7.58172 16.4193 4 12.001 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f651624ef60145e1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5624 10.1875C20.8124 9.5 20.8749 8.8125 20.8124 8.125C20.7499 7.4375 20.4999 6.75 20.1874 6.125C19.6249 5.1875 18.8124 4.4375 17.8749 4C16.8749 3.5625 15.8124 3.4375 14.7499 3.6875C14.2499 3.1875 13.6874 2.75 13.0624 2.4375C12.4374 2.125 11.6874 2 10.9999 2C9.9374 2 8.8749 2.3125 7.9999 2.9375C7.1249 3.5625 6.4999 4.4375 6.1874 5.4375C5.4374 5.625 4.8124 5.9375 4.1874 6.3125C3.6249 6.75 3.1874 7.3125 2.8124 7.875C2.24991 8.8125 2.06241 9.875 2.18741 10.9375C2.31241 12 2.7499 13 3.4374 13.8125C3.1874 14.5 3.1249 15.1875 3.1874 15.875C3.2499 16.5625 3.4999 17.25 3.8124 17.875C4.3749 18.8125 5.1874 19.5625 6.1249 20C7.1249 20.4375 8.1874 20.5625 9.2499 20.3125C9.7499 20.8125 10.3124 21.25 10.9374 21.5625C11.5624 21.875 12.3124 22 12.9999 22C14.0624 22 15.1249 21.6875 15.9999 21.0625C16.8749 20.4375 17.4999 19.5625 17.8124 18.5625C18.4999 18.4375 19.1874 18.125 19.7499 17.6875C20.3124 17.25 20.8124 16.75 21.1249 16.125C21.6874 15.1875 21.8749 14.125 21.7499 13.0625C21.6249 12 21.2499 11 20.5624 10.1875ZM13.0624 20.6875C12.0624 20.6875 11.3124 20.375 10.6249 19.8125C10.6249 19.8125 10.6874 19.75 10.7499 19.75L14.7499 17.4375C14.8749 17.375 14.9374 17.3125 14.9999 17.1875C15.0624 17.0625 15.0624 17 15.0624 16.875V11.25L16.7499 12.25V16.875C16.8124 19.0625 15.0624 20.6875 13.0624 20.6875ZM4.9999 17.25C4.5624 16.5 4.3749 15.625 4.5624 14.75C4.5624 14.75 4.6249 14.8125 4.6874 14.8125L8.6874 17.125C8.8124 17.1875 8.8749 17.1875 8.9999 17.1875C9.1249 17.1875 9.2499 17.1875 9.3124 17.125L14.1874 14.3125V16.25L10.1249 18.625C9.2499 19.125 8.2499 19.25 7.3124 19C6.3124 18.75 5.4999 18.125 4.9999 17.25ZM3.9374 8.5625C4.3749 7.8125 5.0624 7.25 5.8749 6.9375V7.0625V11.6875C5.8749 11.8125 5.8749 11.9375 5.9374 12C5.9999 12.125 6.0624 12.1875 6.1874 12.25L11.0624 15.0625L9.3749 16.0625L5.3749 13.75C4.4999 13.25 3.8749 12.4375 3.6249 11.5C3.3749 10.5625 3.4374 9.4375 3.9374 8.5625ZM17.7499 11.75L12.8749 8.9375L14.5624 7.9375L18.5624 10.25C19.1874 10.625 19.6874 11.125 19.9999 11.75C20.3124 12.375 20.4999 13.0625 20.4374 13.8125C20.3749 14.5 20.1249 15.1875 19.6874 15.75C19.2499 16.3125 18.6874 16.75 17.9999 17V12.25C17.9999 12.125 17.9999 12 17.9374 11.9375C17.9374 11.9375 17.8749 11.8125 17.7499 11.75ZM19.4374 9.25C19.4374 9.25 19.3749 9.1875 19.3124 9.1875L15.3124 6.875C15.1874 6.8125 15.1249 6.8125 14.9999 6.8125C14.8749 6.8125 14.7499 6.8125 14.6874 6.875L9.8124 9.6875V7.75L13.8749 5.375C14.4999 5 15.1874 4.875 15.9374 4.875C16.6249 4.875 17.3124 5.125 17.9374 5.5625C18.4999 6 18.9999 6.5625 19.2499 7.1875C19.4999 7.8125 19.5624 8.5625 19.4374 9.25ZM8.9374 12.75L7.2499 11.75V7.0625C7.2499 6.375 7.4374 5.625 7.8124 5.0625C8.1874 4.4375 8.7499 4 9.3749 3.6875C9.9999 3.375 10.7499 3.25 11.4374 3.375C12.1249 3.4375 12.8124 3.75 13.3749 4.1875C13.3749 4.1875 13.3124 4.25 13.2499 4.25L9.2499 6.5625C9.1249 6.625 9.0624 6.6875 8.9999 6.8125C8.9374 6.9375 8.9374 7 8.9374 7.125V12.75ZM9.8124 10.75L11.9999 9.5L14.1874 10.75V13.25L11.9999 14.5L9.8124 13.25V10.75Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c5e47374d12d9b02(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4C11.6487 4 12.2498 4.20569 12.7411 4.55646C11.4486 5.22914 10.2602 6.07623 8.99996 6.80385L9.99996 8.5359C11.575 7.62654 13.0517 6.48541 14.7608 5.83037C16.1134 5.31198 17.681 5.83976 18.4282 7.13398C18.7526 7.69582 18.8749 8.31917 18.8168 8.92006C17.588 8.13708 16.2602 7.53146 15 6.80385L14 8.5359C15.575 9.44525 17.3016 10.1536 18.7234 11.3061C19.8487 12.2183 20.1754 13.8398 19.4282 15.134C19.1037 15.696 18.6249 16.1137 18.0752 16.3638C18.1385 14.9081 18 13.4553 18 12H16C16 13.8184 16.2498 15.6685 15.9626 17.4758C15.7353 18.9063 14.4944 20 13 20C12.351 20 11.7498 19.7942 11.2584 19.4432C12.5508 18.7701 13.7396 17.9238 15 17.1962L14 15.4641C12.4252 16.3733 10.9478 17.5147 9.23912 18.1696C7.88657 18.688 6.31898 18.1602 5.57176 16.866C5.24729 16.304 5.12493 15.6805 5.18316 15.0794C6.41224 15.8621 7.73964 16.4685 8.99997 17.1962L9.99997 15.4641C8.42517 14.5549 6.69801 13.8462 5.27649 12.6939C4.15128 11.7817 3.82455 10.1602 4.57176 8.86602C4.89624 8.30402 5.37506 7.88628 5.9247 7.63618C5.86145 9.09192 5.99997 10.5447 5.99997 12H7.99997C7.99997 10.1816 7.75013 8.33148 8.03733 6.52422C8.26467 5.09369 9.50554 4 11 4ZM14.7925 3.74171C13.8765 2.67659 12.5176 2 11 2C8.7782 2 6.89621 3.44833 6.24435 5.45243C4.86393 5.71314 3.59851 6.55175 2.83971 7.86602C1.72883 9.79013 2.04213 12.1442 3.4518 13.7107C2.98737 15.0366 3.08092 16.5518 3.83971 17.866C4.95059 19.7901 7.14589 20.6958 9.20742 20.2583C10.1234 21.3234 11.4824 22 13 22C15.2217 22 17.1037 20.5517 17.7556 18.5476C19.136 18.2869 20.4014 17.4482 21.1602 16.134C22.2711 14.2099 21.9578 11.8559 20.5481 10.2893C21.0126 8.96345 20.919 7.44825 20.1602 6.13398C19.0493 4.20987 16.854 3.30419 14.7925 3.74171Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$65924edd962bad12(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0001 2.75977L21.9992 5.99576L21.1001 15.4638L12.0001 22.3232L2.90012 15.4598L2.01074 5.99977L12.0001 2.75977ZM12.0001 3.58511L3.18898 6.43476L12.0001 20.7929L20.8058 6.43476L12.0001 3.58511Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4338b8312e50d843(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L2 5.996L3 15.46L12 22.5L21 15.46L22 5.996L12 3ZM19.8367 7.43572L12 19.9608L4.16326 7.43572L12 5.08783L19.8367 7.43572Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7a274b5f3f68b13f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.71014 6.365C7.60348 7.67 6.88848 9.60083 6.83848 11.765V12.235C6.88931 14.4 7.60348 16.3283 8.71014 17.6342C10.1443 19.4975 12.276 20.6792 14.6593 20.6792C16.1226 20.6792 17.4926 20.2317 18.6651 19.4533C16.9001 21.0383 14.5626 22 12.001 22C11.841 22 11.6818 21.9967 11.526 21.9883C6.22098 21.7408 2.00098 17.3633 2.00098 12C2.00098 6.47583 6.47848 2 12.001 2H12.0385C14.5843 2.01 16.9051 2.97167 18.666 4.54583C17.4926 3.77083 16.1235 3.32 14.6576 3.32C12.276 3.32 10.1435 4.50333 8.70764 6.365H8.71014ZM22.001 12C22.001 14.9633 20.7135 17.6233 18.666 19.4542C16.101 20.7042 13.711 19.83 12.9193 19.2833C15.4385 18.73 17.3418 15.6833 17.3418 12C17.3418 8.315 15.4393 5.27083 12.9193 4.71667C13.7101 4.17167 16.101 3.2975 18.666 4.54583C20.7135 6.375 22.001 9.0375 22.001 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$736f0c6207a2d7d5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.7665 19.5091C17.8219 18.3834 20.001 15.4462 20.001 12C20.001 8.55381 17.8219 5.61656 14.7665 4.4909C16.7122 5.97596 18.001 8.93354 18.001 12C18.001 15.0665 16.7122 18.024 14.7665 19.5091ZM9.23543 4.4909C6.18001 5.61656 4.00098 8.55381 4.00098 12C4.00098 15.4462 6.18001 18.3834 9.23543 19.5091C7.28979 18.024 6.00098 15.0665 6.00098 12C6.00098 8.93354 7.28979 5.97596 9.23543 4.4909ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM12.001 18.5C14.001 18.5 16.001 15.4667 16.001 12C16.001 8.53333 14.001 5.5 12.001 5.5C10.001 5.5 8.00098 8.53333 8.00098 12C8.00098 15.4667 10.001 18.5 12.001 18.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ada79ccc5a75dd3b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.001 17C10.8588 17 7.50098 13.6421 7.50098 9.5C7.50098 5.35786 10.8588 2 15.001 2C19.1431 2 22.501 5.35786 22.501 9.5C22.501 13.6421 19.1431 17 15.001 17ZM2.00098 2H6.00098V22H2.00098V2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$db9da3d773c544a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.001 17C10.8588 17 7.50098 13.6421 7.50098 9.5C7.50098 5.35786 10.8588 2 15.001 2C19.1431 2 22.501 5.35786 22.501 9.5C22.501 13.6421 19.1431 17 15.001 17ZM15.001 15C18.0385 15 20.501 12.5376 20.501 9.5C20.501 6.46243 18.0385 4 15.001 4C11.9634 4 9.50098 6.46243 9.50098 9.5C9.50098 12.5376 11.9634 15 15.001 15ZM2.00098 2H7.00098V22H2.00098V2ZM4.00098 4V20H5.00098V4H4.00098Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$38ada49d00becfd7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.0673 8.47768C20.5591 9.35823 20.6237 10.4924 20.3676 11.8053C19.627 15.6107 17.0916 16.9253 13.8536 16.9253H13.3536C12.9583 16.9253 12.6216 17.214 12.5596 17.6047L12.519 17.8253L11.8896 21.818L11.857 21.988C11.795 22.3787 11.4583 22.6667 11.063 22.6667H7.72031C7.42365 22.6667 7.19698 22.402 7.24298 22.1093L7.41807 21H8.9367L9.88603 14.9793H11.2716C15.9496 14.9793 19.0209 12.7768 20.0673 8.47768ZM17.1066 3.38784C17.8693 4.25635 18.0908 5.19891 17.8597 6.67324C17.8405 6.79594 17.82 6.91391 17.7973 7.03253C17.0621 10.8057 14.7087 12.4793 10.8417 12.4793H8.95703C8.32647 12.4793 7.78368 12.8928 7.60372 13.4811L7.58913 13.4788L6.65969 19.3733H3.12169C3.08991 19.3733 3.06598 19.3454 3.07097 19.3136L5.66905 2.80233C5.74174 2.34036 6.13984 2 6.6075 2H12.583C14.7658 2 16.2998 2.46869 17.1066 3.38784Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e4281c9074b9165e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.49626 20.6667H10.0474L10.5852 17.2912C10.8012 15.93 11.9747 14.9253 13.3545 14.9253H13.8545C16.5322 14.9253 17.915 13.9421 18.4055 11.4224C18.6134 10.3564 18.5222 9.69183 18.2339 9.32047C17.0272 12.3744 14.4449 13.4793 11.2725 13.4793H10.3878C10.004 13.4793 9.59454 13.6889 9.53611 14.0602L8.49626 20.6667ZM3.55247 20.3733C3.21381 20.3733 2.95514 20.0713 3.00781 19.736L5.68247 2.776C5.75314 2.32933 6.13847 2 6.59047 2H13.0138C15.2265 2 16.9558 2.46733 17.9131 3.558C18.783 4.54853 19.0364 5.64237 18.7846 7.25001C19.1438 7.44133 19.4518 7.67467 19.6998 7.956C20.5185 8.88867 20.6785 10.216 20.3685 11.8053C19.6278 15.6107 17.0925 16.9253 13.8545 16.9253H13.3545C12.9591 16.9253 12.6225 17.214 12.5605 17.6047L11.8578 21.988C11.7958 22.3787 11.4591 22.6667 11.0638 22.6667H6.72114C6.42447 22.6667 6.19781 22.402 6.24381 22.1093L6.51781 20.3733H3.55247ZM10.3878 11.4793H11.2725C14.462 11.4793 16.1671 10.2667 16.7549 7.2501C16.7744 7.14856 16.7919 7.04727 16.8086 6.94101C16.9746 5.88187 16.8586 5.38808 16.4104 4.87773C15.9451 4.34763 14.8073 4 13.0138 4H7.51416L5.24742 18.3733H6.80845L7.53821 13.7452L7.54562 13.7463C7.84632 12.4296 9.0169 11.4793 10.3878 11.4793Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d3e32b503911777b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.3717 2.09442C8.42512 1.41268 3.73383 4.48505 2.38064 9.29256C1.02745 14.1001 3.42711 19.1692 8.00271 21.1689C7.94264 20.4008 7.99735 19.628 8.16502 18.8761C8.34964 18.0374 9.46121 13.4132 9.46121 13.4132C9.23971 12.9173 9.12893 12.379 9.13659 11.8359C9.13659 10.3509 9.99353 9.24295 11.0597 9.24295C11.4472 9.23718 11.8181 9.40028 12.0758 9.68981C12.3335 9.97934 12.4526 10.3667 12.402 10.751C12.402 11.6512 11.8236 13.0131 11.5228 14.2903C11.4014 14.7656 11.5131 15.2703 11.8237 15.65C12.1343 16.0296 12.6069 16.2389 13.0967 16.2139C14.9944 16.2139 16.2675 13.7825 16.2675 10.9126C16.2675 8.71205 14.8098 7.0655 12.1243 7.0655C10.826 7.01531 9.56388 7.4996 8.63223 8.40543C7.70057 9.31126 7.18084 10.5595 7.19423 11.859C7.16563 12.5722 7.39566 13.2717 7.84194 13.8287C8.01361 13.9564 8.07985 14.1825 8.00425 14.3827C7.9581 14.5673 7.84194 15.0059 7.79578 15.1675C7.77632 15.278 7.70559 15.3728 7.60516 15.4228C7.50473 15.4729 7.38651 15.4724 7.28654 15.4214C5.9019 14.8674 5.24957 13.3439 5.24957 11.6051C5.24957 8.75822 7.63424 5.3497 12.4036 5.3497C16.1998 5.3497 18.723 8.1273 18.723 11.0972C18.723 15.0059 16.5468 17.9451 13.3298 17.9451C12.3526 17.9761 11.4273 17.5061 10.8759 16.6986C10.8759 16.6986 10.2974 19.0146 10.1835 19.4531C9.95101 20.2099 9.60779 20.9281 9.16505 21.5844C10.0877 21.8643 11.0471 22.0044 12.0113 22C14.6636 22.0017 17.2078 20.9484 19.0829 19.072C20.958 17.1957 22.0099 14.6504 22.0069 11.9975C22.004 7.00306 18.3183 2.77616 13.3717 2.09442Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$858b02d031776303(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.49161 19.1912C8.51535 18.8546 8.56306 18.5199 8.63456 18.1897C8.69754 17.8951 8.88867 17.0596 9.16872 15.8498L9.17581 15.8191C9.29895 15.2872 9.43089 14.7192 9.56283 14.1525C9.64199 13.8124 9.70356 13.5484 9.74438 13.4602C9.55012 13.0123 9.45298 12.5263 9.45969 12.0373C9.45969 10.6999 10.2157 9.66359 11.1958 9.6636C11.5555 9.65809 11.8996 9.81388 12.1383 10.09C12.3764 10.3655 12.4863 10.7335 12.4404 11.086C12.4404 11.5385 12.3548 11.8844 11.9865 13.1212C11.9158 13.3587 11.8674 13.5254 11.8215 13.692C11.7696 13.8799 11.7261 14.0503 11.6887 14.2136C11.5928 14.6003 11.6811 15.011 11.9262 15.3195C12.1707 15.6272 12.5421 15.7966 12.9319 15.7762C14.4242 15.7762 15.5321 13.7911 15.5321 11.2277C15.5321 9.25804 14.2412 7.95424 12.1 7.95416C11.0224 7.91127 9.97466 8.32523 9.20095 9.09986C8.42664 9.87508 7.99452 10.9437 8.00559 12.0614C7.98214 12.6633 8.17064 13.2536 8.51804 13.7053C8.69915 13.8441 8.76869 14.0885 8.69262 14.2941C8.65157 14.4632 8.55259 14.8473 8.51649 14.9755C8.49464 15.1032 8.41497 15.2131 8.30126 15.2715C8.18678 15.3303 8.05172 15.3297 7.94618 15.2737C6.78507 14.7954 6.14967 13.4963 6.14967 11.8349C6.14967 8.84907 8.64129 6.2497 12.3417 6.2497C15.4772 6.2497 17.8231 8.57864 17.8231 11.3896C17.8231 14.922 15.8911 17.4942 13.1337 17.4942C12.3393 17.5202 11.5838 17.162 11.087 16.535L11.044 16.712C10.9499 17.0992 10.9028 17.2928 10.8368 17.5638L10.8349 17.5715C10.6887 18.1717 10.5867 18.5885 10.5471 18.7452C10.4412 19.0998 10.307 19.448 10.1471 19.7841C10.7421 19.9253 11.3628 20 12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 15.1594 5.83244 17.8911 8.49161 19.1912ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$baefdf5afd944875(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2ZM13.0322 8.09865H10.4084C9.42035 8.09865 8.61941 8.87488 8.61941 9.83241V16.5804L11.2143 14.109H13.0322C14.7448 14.109 16.1331 12.7635 16.1331 11.1038C16.1331 9.44411 14.7448 8.09865 13.0322 8.09865Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7c1d4f9200d643dd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2ZM12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 16.4183 7.5827 20 12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4ZM13.0322 8.09865C14.7448 8.09865 16.1331 9.44411 16.1331 11.1038C16.1331 12.7635 14.7448 14.109 13.0322 14.109H11.2143L8.61941 16.5804V9.83241C8.61941 8.87488 9.42035 8.09865 10.4084 8.09865H13.0322Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$148d113c707eb104(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.5846 17.0112C22.1549 17.554 21.102 17.9412 21.102 17.9412L13.2697 20.7579V18.6806L19.0337 16.6244C19.6878 16.3898 19.7883 16.0581 19.2566 15.884C18.7259 15.7094 17.765 15.7594 17.1104 15.9951L13.2697 17.3494V15.1936L13.491 15.1185C13.491 15.1185 14.6009 14.7253 16.1614 14.5522C17.722 14.3801 19.6329 14.5757 21.133 15.1451C22.8235 15.6799 23.0139 16.4683 22.5846 17.0112ZM14.0152 13.4741V8.16195C14.0152 7.53808 13.9003 6.96374 13.3156 6.80115C12.8679 6.65756 12.5901 7.07381 12.5901 7.69718V21L9.0067 19.8613V4C10.5303 4.28317 12.75 4.95256 13.9433 5.3553C16.978 6.39841 18.0068 7.69667 18.0068 10.6219C18.0068 13.4731 16.2489 14.5537 14.0152 13.4741ZM2.43161 18.4635C0.696139 17.9742 0.407311 16.9546 1.19834 16.3673C1.92941 15.825 3.17267 15.4167 3.17267 15.4167L8.31061 13.5876V15.6729L4.61331 16.9976C3.9602 17.2323 3.85976 17.5645 4.39044 17.7386C4.92163 17.9127 5.88305 17.8632 6.53717 17.628L8.31061 16.9836V18.8492C8.19818 18.8692 8.07275 18.8893 7.95682 18.9088C6.18288 19.1989 4.2935 19.0779 2.43161 18.4635Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bc240e74ac1aeb16(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.5846 17.0112C22.1549 17.554 21.102 17.9412 21.102 17.9412L13.2697 20.7579V18.6806L19.0337 16.6244C19.6878 16.3898 19.7883 16.0581 19.2566 15.884C18.7259 15.7094 17.765 15.7594 17.1104 15.9951L13.2697 17.3494V15.1936L13.491 15.1185C13.491 15.1185 14.6009 14.7253 16.1614 14.5522C17.722 14.3801 19.6329 14.5757 21.133 15.1451C22.8235 15.6799 23.0139 16.4683 22.5846 17.0112ZM14.0152 13.4741V8.16195C14.0152 7.53808 13.9003 6.96374 13.3156 6.80115C12.8679 6.65756 12.5901 7.07381 12.5901 7.69718V21L9.0067 19.8613V4C10.5303 4.28317 12.75 4.95256 13.9433 5.3553C16.978 6.39841 18.0068 7.69667 18.0068 10.6219C18.0068 13.4731 16.2489 14.5537 14.0152 13.4741ZM2.43161 18.4635C0.696139 17.9742 0.407311 16.9546 1.19834 16.3673C1.92941 15.825 3.17267 15.4167 3.17267 15.4167L8.31061 13.5876V15.6729L4.61331 16.9976C3.9602 17.2323 3.85976 17.5645 4.39044 17.7386C4.92163 17.9127 5.88305 17.8632 6.53717 17.628L8.31061 16.9836V18.8492C8.19818 18.8692 8.07275 18.8893 7.95682 18.9088C6.18288 19.1989 4.2935 19.0779 2.43161 18.4635Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2029a25627478e63(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM13.3345 12H10.501V9H13.3345C14.1629 9 14.8345 9.67157 14.8345 10.5C14.8345 11.3284 14.1629 12 13.3345 12ZM13.3345 7H8.50098V17H10.501V14H13.3345C15.2675 14 16.8345 12.433 16.8345 10.5C16.8345 8.567 15.2675 7 13.3345 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$87f790b8acab8afc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 16.4183 7.5827 20 12.001 20ZM13.3345 12C14.1629 12 14.8345 11.3284 14.8345 10.5C14.8345 9.67157 14.1629 9 13.3345 9H10.501V12H13.3345ZM13.3345 7C15.2675 7 16.8345 8.567 16.8345 10.5C16.8345 12.433 15.2675 14 13.3345 14H10.501V17H8.50098V7H13.3345Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5ff3ebba09f79802(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.9139 14.529C19.7336 13.955 19.4877 13.2856 19.2385 12.643L18.3288 10.3969C18.3295 10.371 18.3408 9.92858 18.3408 9.70053C18.3408 5.8599 16.5082 2.00037 12.0009 2C7.49403 2.00037 5.66113 5.8599 5.66113 9.70053C5.66113 9.92858 5.67237 10.371 5.67312 10.3969L4.76379 12.643C4.51453 13.2856 4.26827 13.955 4.08798 14.529C3.2285 17.2657 3.507 18.3982 3.71915 18.4238C4.17419 18.4779 5.49021 16.3635 5.49021 16.3635C5.49021 17.5879 6.12741 19.1858 7.5064 20.3398C6.99064 20.4971 6.35868 20.7388 5.95237 21.0355C5.58729 21.3025 5.63302 21.5743 5.69861 21.6841C5.9876 22.1661 10.6542 21.9918 12.0017 21.8417C13.3488 21.9918 18.0158 22.1661 18.3044 21.6841C18.3704 21.5743 18.4157 21.3025 18.0507 21.0355C17.6443 20.7388 17.012 20.4971 16.4959 20.3395C17.8745 19.1858 18.5117 17.5879 18.5117 16.3635C18.5117 16.3635 19.8281 18.4779 20.2831 18.4238C20.4949 18.3982 20.7734 17.2657 19.9139 14.529Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$36862ae99d13b481(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5359 12.5144L16.8402 10.7175C16.8408 10.6968 16.8494 10.3429 16.8494 10.1604C16.8494 7.08792 15.448 4.0003 12.0012 4C8.55459 4.0003 7.15292 7.08792 7.15292 10.1604C7.15292 10.3429 7.16151 10.6968 7.16209 10.7175L6.4667 12.5144C6.27608 13.0285 6.08776 13.564 5.94988 14.0232C5.29262 16.2126 5.50559 17.1186 5.66783 17.139C6.01581 17.1823 7.02221 15.4908 7.02221 15.4908C7.02221 16.4704 7.5095 17.7487 8.56405 18.6719C8.16963 18.7976 7.68635 18.9911 7.37564 19.2284C7.09645 19.442 7.13142 19.6594 7.18158 19.7473C7.40258 20.1329 10.9713 19.9935 12.0017 19.8733C13.0319 19.9935 16.6009 20.1329 16.8216 19.7473C16.872 19.6594 16.9067 19.442 16.6275 19.2284C16.3168 18.9911 15.8333 18.7976 15.4386 18.6716C16.4928 17.7487 16.9801 16.4704 16.9801 15.4908C16.9801 15.4908 17.9868 17.1823 18.3348 17.139C18.4967 17.1186 18.7131 16.2108 18.0524 14.0232C17.9125 13.56 17.7265 13.0285 17.5359 12.5144ZM18.5574 20.7407C18.1843 21.3926 17.7237 21.6334 17.1187 21.7981C16.8792 21.8633 16.621 21.9056 16.325 21.936C15.8844 21.9814 15.3392 22.001 14.712 22C13.786 21.9985 12.693 21.9491 12.0017 21.884C11.3103 21.9491 10.2173 21.9985 9.29129 22C8.66414 22.001 8.11889 21.9814 7.67832 21.936C7.38236 21.9056 7.12409 21.8633 6.88467 21.7981C6.27994 21.6335 5.81954 21.393 5.44496 20.7393C5.15165 20.2258 5.07747 19.6406 5.20612 19.0866C4.61376 18.9546 4.20483 18.6045 3.92733 18.1757C3.77911 17.9466 3.68408 17.7127 3.61845 17.4663C3.53001 17.1344 3.49486 16.7666 3.50184 16.3601C3.51532 15.5749 3.68902 14.5984 4.03435 13.4481C4.17427 12.9821 4.3614 12.4396 4.6015 11.7926L5.15467 10.3632C5.1536 10.287 5.15292 10.2154 5.15292 10.1604C5.15292 5.6047 7.58875 2.00038 12.0013 2C16.4138 2.00038 18.8494 5.60454 18.8494 10.1604C18.8494 10.2154 18.8487 10.2869 18.8477 10.3631L19.401 11.7923L19.4112 11.8191C19.636 12.4254 19.8242 12.9722 19.967 13.445C20.3145 14.5956 20.4889 15.5735 20.5018 16.361C20.5085 16.768 20.4728 17.1365 20.3837 17.4689C20.3178 17.7148 20.2226 17.9483 20.0746 18.1768C19.7976 18.6041 19.3905 18.9532 18.7974 19.0862C18.9266 19.6411 18.8523 20.2274 18.5574 20.7407Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$716c5c599f459bb6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.448 16.2394C13.8809 17.0412 13.2933 17.7714 12.7015 18.4146C14.3738 20.0375 15.9291 20.7975 16.792 20.2993C17.6549 19.8011 17.7744 18.0742 17.2051 15.8145C16.3521 16.0054 15.426 16.1492 14.448 16.2394ZM13.138 16.3265C12.7641 16.342 12.3845 16.3499 12.0003 16.3499C11.6161 16.3499 11.2365 16.342 10.8627 16.3265C11.2394 16.8188 11.6208 17.2749 12.0003 17.6905C12.3798 17.2749 12.7612 16.8188 13.138 16.3265ZM18.1787 8.43278C20.8434 9.19718 22.5837 10.4672 22.5837 11.9999C22.5837 13.5325 20.8434 14.8026 18.1787 15.567C18.8491 18.2569 18.6193 20.399 17.292 21.1653C15.9647 21.9316 13.9947 21.0595 12.0003 19.134C10.006 21.0595 8.03596 21.9316 6.70866 21.1653C5.38136 20.399 5.15158 18.2569 5.82195 15.567C3.15724 14.8026 1.41699 13.5325 1.41699 11.9999C1.41699 10.4672 3.15724 9.19718 5.82195 8.43278C5.15158 5.74288 5.38136 3.60075 6.70866 2.83443C8.03596 2.06811 10.006 2.94019 12.0003 4.86569C13.9947 2.94019 15.9647 2.06811 17.292 2.83443C18.6193 3.60075 18.8491 5.74288 18.1787 8.43278ZM17.2051 8.18527C17.7744 5.92558 17.6549 4.19865 16.792 3.70046C15.9291 3.20226 14.3738 3.96221 12.7015 5.58509C13.2933 6.2283 13.8809 6.95849 14.448 7.76031C15.426 7.85054 16.3521 7.99432 17.2051 8.18527ZM6.79554 15.8145C6.22624 18.0742 6.34577 19.8011 7.20866 20.2993C8.07155 20.7975 9.62688 20.0375 11.2992 18.4146C10.7073 17.7714 10.1197 17.0412 9.55262 16.2394C8.57467 16.1492 7.6485 16.0054 6.79554 15.8145ZM10.8627 7.67324C11.2365 7.65776 11.6161 7.64987 12.0003 7.64987C12.3845 7.64987 12.7641 7.65776 13.138 7.67324C12.7612 7.18096 12.3798 6.7248 12.0003 6.30922C11.6208 6.7248 11.2394 7.18096 10.8627 7.67324ZM9.55262 7.76031C10.1197 6.95849 10.7073 6.2283 11.2992 5.58509C9.62688 3.96221 8.07155 3.20226 7.20866 3.70046C6.34577 4.19865 6.22624 5.92558 6.79554 8.18527C7.6485 7.99432 8.57467 7.85054 9.55262 7.76031ZM13.8939 15.2797C14.2395 14.7728 14.5772 14.2366 14.9015 13.6749C15.2258 13.1131 15.5213 12.5526 15.7875 11.9999C15.5213 11.4471 15.2258 10.8866 14.9015 10.3249C14.5772 9.76311 14.2395 9.22694 13.8939 8.72005C13.2821 8.6742 12.649 8.64987 12.0003 8.64987C11.3517 8.64987 10.7185 8.6742 10.1067 8.72005C9.76112 9.22694 9.42347 9.76311 9.09914 10.3249C8.77481 10.8866 8.4793 11.4471 8.21312 11.9999C8.4793 12.5526 8.77481 13.1131 9.09914 13.6749C9.42347 14.2366 9.76112 14.7728 10.1067 15.2797C10.7185 15.3255 11.3517 15.3499 12.0003 15.3499C12.649 15.3499 13.2821 15.3255 13.8939 15.2797ZM15.1785 15.1484C15.7932 15.0683 16.3789 14.9661 16.9286 14.8452C16.7584 14.3087 16.5541 13.7504 16.3161 13.178C16.1426 13.5095 15.9596 13.8421 15.7675 14.1749C15.5754 14.5076 15.3788 14.8324 15.1785 15.1484ZM8.82218 8.85133C8.20747 8.93147 7.62174 9.03367 7.07208 9.15454C7.24223 9.691 7.44659 10.2494 7.68454 10.8218C7.85806 10.4903 8.04101 10.1576 8.23311 9.82487C8.42522 9.49212 8.62185 9.16736 8.82218 8.85133ZM7.07208 14.8452C7.62174 14.9661 8.20747 15.0683 8.82218 15.1484C8.62185 14.8324 8.42522 14.5076 8.23311 14.1749C8.04101 13.8421 7.85806 13.5095 7.68454 13.178C7.44659 13.7504 7.24223 14.3087 7.07208 14.8452ZM6.09439 14.6C6.35551 13.7659 6.69407 12.8919 7.10491 11.9999C6.69407 11.1078 6.35551 10.2339 6.09439 9.39969C3.85279 10.0365 2.41699 11.0035 2.41699 11.9999C2.41699 12.9962 3.85279 13.9632 6.09439 14.6ZM16.9286 9.15454C16.3789 9.03367 15.7932 8.93147 15.1785 8.85133C15.3788 9.16736 15.5754 9.49212 15.7675 9.82487C15.9596 10.1576 16.1426 10.4903 16.3161 10.8218C16.5541 10.2494 16.7584 9.691 16.9286 9.15454ZM17.9063 9.39969C17.6451 10.2339 17.3066 11.1078 16.8957 11.9999C17.3066 12.8919 17.6451 13.7659 17.9063 14.6C20.1479 13.9632 21.5837 12.9962 21.5837 11.9999C21.5837 11.0035 20.1479 10.0365 17.9063 9.39969ZM12.0003 13.879C10.9625 13.879 10.1212 13.0377 10.1212 11.9999C10.1212 10.962 10.9625 10.1207 12.0003 10.1207C13.0382 10.1207 13.8795 10.962 13.8795 11.9999C13.8795 13.0377 13.0382 13.879 12.0003 13.879Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6fdb543887ef844b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 13.5001C11.1725 13.5001 10.501 12.8285 10.501 12.0001C10.501 11.1716 11.1725 10.5001 12.001 10.5001C12.8294 10.5001 13.501 11.1716 13.501 12.0001C13.501 12.8285 12.8294 13.5001 12.001 13.5001ZM11.4733 16.4945C11.6479 16.705 11.8239 16.908 12.001 17.103C12.178 16.908 12.3541 16.705 12.5286 16.4945C12.3538 16.4982 12.1779 16.5001 12.001 16.5001C11.824 16.5001 11.6481 16.4982 11.4733 16.4945ZM9.47837 16.3694C8.6762 16.2846 7.91035 16.1603 7.19268 16.0016C7.11832 16.3512 7.06134 16.6904 7.02243 17.0166C6.83358 18.6 7.09805 19.5617 7.50098 19.7943C7.9039 20.0269 8.86893 19.7751 10.1458 18.8199C10.4088 18.6231 10.6741 18.4042 10.9397 18.1649C10.4434 17.6228 9.95287 17.0217 9.47837 16.3694ZM16.8093 16.0016C16.0916 16.1603 15.3257 16.2846 14.5236 16.3694C14.0491 17.0217 13.5585 17.6228 13.0622 18.1649C13.3279 18.4042 13.5931 18.6231 13.8562 18.8199C15.133 19.7751 16.0981 20.0269 16.501 19.7943C16.9039 19.5617 17.1684 18.6 16.9795 17.0166C16.9406 16.6904 16.8836 16.3512 16.8093 16.0016ZM18.2598 15.6136C18.8364 18.2526 18.5328 20.3533 17.251 21.0933C15.9691 21.8334 13.9981 21.046 12.001 19.2271C10.0038 21.046 8.03282 21.8334 6.75098 21.0933C5.46913 20.3533 5.16555 18.2526 5.74217 15.6136C3.16842 14.7935 1.50098 13.4802 1.50098 12.0001C1.50098 10.5199 3.16842 9.20668 5.74217 8.38654C5.16555 5.74754 5.46913 3.64687 6.75098 2.9068C8.03282 2.16673 10.0038 2.95415 12.001 4.77302C13.9981 2.95415 15.9691 2.16673 17.251 2.9068C18.5328 3.64687 18.8364 5.74754 18.2598 8.38654C20.8335 9.20668 22.501 10.5199 22.501 12.0001C22.501 13.4802 20.8335 14.7935 18.2598 15.6136ZM10.9397 5.83521C10.6741 5.59597 10.4088 5.37703 10.1458 5.18024C8.86893 4.22499 7.9039 3.97321 7.50098 4.20584C7.09805 4.43847 6.83358 5.4001 7.02243 6.9835C7.06134 7.30969 7.11832 7.6489 7.19268 7.99857C7.91035 7.83985 8.6762 7.71556 9.47837 7.63078C9.95287 6.97848 10.4434 6.37737 10.9397 5.83521ZM14.5236 7.63078C15.3257 7.71556 16.0916 7.83985 16.8093 7.99857C16.8836 7.6489 16.9406 7.30969 16.9795 6.9835C17.1684 5.4001 16.9039 4.43847 16.501 4.20584C16.0981 3.97321 15.133 4.22499 13.8562 5.18024C13.5931 5.37703 13.3279 5.59597 13.0622 5.83521C13.5585 6.37737 14.0491 6.97848 14.5236 7.63078ZM12.5286 7.50565C12.3541 7.29515 12.178 7.09211 12.001 6.89711C11.8239 7.09211 11.6479 7.29515 11.4733 7.50565C11.6481 7.50194 11.824 7.50007 12.001 7.50007C12.1779 7.50007 12.3538 7.50194 12.5286 7.50565ZM8.37252 14.7042C8.28191 14.5547 8.19233 14.4033 8.10386 14.2501C8.01539 14.0968 7.92906 13.9435 7.84488 13.7903C7.74985 14.0467 7.66205 14.3007 7.58169 14.5515C7.83908 14.6074 8.10295 14.6583 8.37252 14.7042ZM10.3049 14.9377C10.8579 14.9788 11.4251 15.0001 12.001 15.0001C12.5769 15.0001 13.144 14.9788 13.697 14.9377C14.0091 14.4793 14.3111 13.9988 14.5991 13.5001C14.887 13.0013 15.1522 12.4995 15.393 12.0001C15.1522 11.5006 14.887 10.9988 14.5991 10.5001C14.3111 10.0013 14.0091 9.52081 13.697 9.06246C13.144 9.02133 12.5769 9.00007 12.001 9.00007C11.4251 9.00007 10.8579 9.02133 10.3049 9.06246C9.99283 9.52081 9.69086 10.0013 9.4029 10.5001C9.11494 10.9988 8.8498 11.5006 8.60892 12.0001C8.8498 12.4995 9.11494 13.0013 9.4029 13.5001C9.69086 13.9988 9.99283 14.4793 10.3049 14.9377ZM16.1571 10.2098C16.2521 9.9534 16.3399 9.6994 16.4203 9.44859C16.1629 9.39278 15.899 9.34182 15.6294 9.29591C15.72 9.44543 15.8096 9.59683 15.8981 9.75007C15.9866 9.9033 16.0729 10.0566 16.1571 10.2098ZM6.13143 9.83671C5.79142 9.94714 5.46917 10.0674 5.16723 10.1968C3.70154 10.825 3.00098 11.5348 3.00098 12.0001C3.00098 12.4653 3.70154 13.1752 5.16723 13.8033C5.46917 13.9327 5.79142 14.053 6.13143 14.1634C6.35281 13.4625 6.6281 12.7371 6.95576 12.0001C6.6281 11.263 6.35281 10.5376 6.13143 9.83671ZM7.58169 9.44859C7.66205 9.6994 7.74985 9.9534 7.84488 10.2098C7.92906 10.0566 8.01539 9.9033 8.10386 9.75007C8.19233 9.59683 8.28191 9.44543 8.37252 9.29591C8.10295 9.34182 7.83908 9.39278 7.58169 9.44859ZM17.8705 14.1634C18.2105 14.053 18.5328 13.9327 18.8347 13.8033C20.3004 13.1752 21.001 12.4653 21.001 12.0001C21.001 11.5348 20.3004 10.825 18.8347 10.1968C18.5328 10.0674 18.2105 9.94714 17.8705 9.83671C17.6491 10.5376 17.3739 11.263 17.0462 12.0001C17.3739 12.7371 17.6491 13.4625 17.8705 14.1634ZM16.4203 14.5515C16.3399 14.3007 16.2521 14.0467 16.1571 13.7903C16.0729 13.9435 15.9866 14.0968 15.8981 14.2501C15.8096 14.4033 15.72 14.5547 15.6294 14.7042C15.899 14.6583 16.1629 14.6074 16.4203 14.5515Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$69a0d698093326de(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM18.671 12C18.65 11.425 18.2932 10.916 17.7598 10.7C17.2265 10.4841 16.6161 10.6016 16.201 11C15.0634 10.2267 13.7262 9.7995 12.351 9.77L13.001 6.65L15.141 7.1C15.1935 7.58851 15.5932 7.96647 16.0839 7.99172C16.5745 8.01696 17.0109 7.68201 17.1133 7.20147C17.2157 6.72094 16.9538 6.23719 16.4955 6.06019C16.0372 5.88318 15.5181 6.06536 15.271 6.49L12.821 6C12.74 5.98224 12.6554 5.99763 12.5858 6.04272C12.5163 6.08781 12.4678 6.15886 12.451 6.24L11.711 9.71C10.3189 9.73099 8.96325 10.1585 7.81098 10.94C7.38972 10.5436 6.77418 10.4333 6.2415 10.6588C5.70882 10.8842 5.35944 11.4028 5.35067 11.9812C5.3419 12.5595 5.67538 13.0885 6.20098 13.33C6.18972 13.4765 6.18972 13.6235 6.20098 13.77C6.20098 16.01 8.81098 17.83 12.031 17.83C15.251 17.83 17.861 16.01 17.861 13.77C17.8722 13.6235 17.8722 13.4765 17.861 13.33C18.3646 13.0797 18.6797 12.5623 18.671 12ZM8.67098 13C8.67098 12.4477 9.11869 12 9.67098 12C10.2233 12 10.671 12.4477 10.671 13C10.671 13.5523 10.2233 14 9.67098 14C9.40576 14 9.15141 13.8946 8.96387 13.7071C8.77633 13.5196 8.67098 13.2652 8.67098 13ZM14.481 15.75C13.7715 16.2847 12.8986 16.5568 12.011 16.52C11.1234 16.5568 10.2505 16.2847 9.54098 15.75C9.45288 15.6427 9.46057 15.486 9.55877 15.3878C9.65696 15.2896 9.81363 15.2819 9.92098 15.37C10.5222 15.811 11.2561 16.0333 12.001 16C12.7468 16.0406 13.4841 15.8254 14.091 15.39C14.1624 15.3203 14.2656 15.2941 14.3617 15.3211C14.4577 15.3482 14.5321 15.4244 14.5567 15.5211C14.5813 15.6178 14.5524 15.7203 14.481 15.79V15.75ZM14.301 14.04C13.7487 14.04 13.301 13.5923 13.301 13.04C13.301 12.4877 13.7487 12.04 14.301 12.04C14.8533 12.04 15.301 12.4877 15.301 13.04C15.312 13.3138 15.2101 13.5802 15.0192 13.7767C14.8282 13.9733 14.565 14.083 14.291 14.08L14.301 14.04Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ced77262add545ce(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.0526 7.8154L11.8042 4.27941C12.0339 3.19898 13.0959 2.50929 14.1764 2.73894L17.3725 3.4183C17.8351 2.90546 18.5509 2.64644 19.275 2.80035C20.3554 3.03 21.0451 4.09204 20.8155 5.17247C20.5858 6.2529 19.5238 6.94259 18.4434 6.71294C17.7193 6.55903 17.1707 6.03124 16.9567 5.3746L13.7605 4.69523L13.0943 7.82978C14.8789 7.96683 16.6522 8.56079 18.2581 9.52961C19.0892 9.06763 20.0992 8.99337 21.007 9.36091C22.1731 9.833 22.9531 10.9459 22.9991 12.2031L22.9996 12.2241C23.0151 13.2277 22.559 14.1657 21.792 14.7742C21.7899 14.8178 21.7871 14.859 21.7836 14.8971C21.7836 18.8949 17.3341 21.9267 11.9852 21.9267C6.65232 21.9267 2.27693 18.9027 2.27987 14.9738C2.27523 14.9134 2.27162 14.853 2.26905 14.7926C1.46701 14.1873 0.984722 13.2277 1.00037 12.1962C1.01955 10.9317 1.78341 9.79777 2.94804 9.30491C3.85909 8.91936 4.881 8.98299 5.72371 9.44381C7.3578 8.46653 9.15777 7.91241 11.0526 7.8154ZM20.3385 13.341C20.7466 13.1382 21.003 12.7207 21.0001 12.2656C20.9789 11.8005 20.6887 11.3897 20.2565 11.2147C19.821 11.0384 19.3226 11.1343 18.9837 11.4597L18.3991 12.0207L17.729 11.5652C16.1137 10.4672 14.2771 9.8397 12.4995 9.80134L11.493 9.80123C9.61791 9.8295 7.84136 10.4002 6.25552 11.4757L5.59246 11.9254L5.00897 11.3764C4.66501 11.0528 4.16243 10.9627 3.7275 11.1468C3.29257 11.3308 3.0073 11.7543 3 12.2265C2.99298 12.6987 3.26526 13.1307 3.69441 13.3278L4.32738 13.6186L4.27399 14.3132C4.261 14.482 4.261 14.6516 4.27693 14.8971C4.27693 17.6071 7.63313 19.9267 11.9852 19.9267C16.3561 19.9267 19.7836 17.5913 19.7865 14.8205C19.7995 14.6516 19.7995 14.482 19.7865 14.3132L19.7348 13.6411L20.3385 13.341ZM6.95075 13.4999C6.95075 12.6715 7.62232 11.9999 8.45075 11.9999C9.27918 11.9999 9.95075 12.6715 9.95075 13.4999C9.95075 14.3283 9.27918 14.9999 8.45075 14.9999C8.05292 14.9999 7.67139 14.8419 7.39009 14.5606C7.10878 14.2793 6.95075 13.8977 6.95075 13.4999ZM13.9507 13.4999C13.9507 12.6715 14.6223 11.9999 15.4507 11.9999C16.2792 11.9999 16.9507 12.6715 16.9507 13.4999C16.9507 14.3283 16.2792 14.9999 15.4507 14.9999C15.0529 14.9999 14.6714 14.8419 14.3901 14.5606C14.1088 14.2793 13.9507 13.8977 13.9507 13.4999ZM11.9665 18.6028C10.5693 18.6028 9.19993 18.2329 8.08503 17.3928C7.94659 17.2241 7.95868 16.9779 8.11299 16.8236C8.2673 16.6693 8.51349 16.6572 8.68218 16.7956C9.62697 17.4886 10.805 17.7856 11.9507 17.7856C13.0965 17.7856 14.2813 17.5112 15.235 16.8271C15.3473 16.7176 15.5095 16.6763 15.6604 16.7188C15.8114 16.7613 15.9282 16.8811 15.9669 17.0331C16.0055 17.1851 15.9517 17.3346 15.8479 17.4556C15.1638 18.2531 13.3636 18.6028 11.9665 18.6028Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c465627ddf298437(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5301 17.5291L20.001 21H3.00098V4H13.6676V4.0078C13.7781 4.00262 13.8892 4 14.001 4C14.0464 4 14.0918 4.00043 14.137 4.0013C14.048 4.37162 14.001 4.76172 14.001 5.16667C14.001 7.48528 16.0157 9.5 18.6676 9.5C19.3921 9.5 20.0868 9.30333 20.6997 8.96217C20.8956 9.60697 21.001 10.2912 21.001 11C21.001 13.9742 19.1461 16.5151 16.5301 17.5291ZM18.501 7.5C17.1203 7.5 16.001 6.38071 16.001 5C16.001 3.61929 17.1203 2.5 18.501 2.5C19.8817 2.5 21.001 3.61929 21.001 5C21.001 6.38071 19.8817 7.5 18.501 7.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eb12d60ce902babf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.36461 6L15.1491 15.6629L15.8699 15.38C17.5538 14.719 18.7326 13.2237 18.9607 11.4839C18.8083 11.4946 18.655 11.5 18.501 11.5C15.2512 11.5 12.5584 9.11509 12.0774 6H6.36461ZM14.001 5C14.001 7.48528 16.0157 9.5 18.501 9.5C19.306 9.5 20.0617 9.28861 20.7155 8.91831C20.9013 9.53558 21.001 10.1891 21.001 10.8654C21.001 13.7561 19.1794 16.2295 16.6006 17.2417L20.001 21H3.00098V4H14.001C14.0381 4 14.0753 4.00028 14.1123 4.00085C14.0394 4.3222 14.001 4.65661 14.001 5ZM18.501 7.5C17.1203 7.5 16.001 6.38071 16.001 5C16.001 3.61929 17.1203 2.5 18.501 2.5C19.8817 2.5 21.001 3.61929 21.001 5C21.001 6.38071 19.8817 7.5 18.501 7.5ZM5.00098 7.47V19H15.481L5.00098 7.47Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4f715b37d1d499a5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.7012 6.80069L10.5868 10.5858L6.80166 16.7002L6.69768 16.5962L5.28346 18.0104L5.99057 18.7175L7.40478 17.3033L7.3008 17.1993L13.4152 13.4142L17.2003 7.29982L17.3043 7.40381L18.7185 5.98959L18.0114 5.28249L16.5972 6.6967L16.7012 6.80069ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM11.501 3V5H12.501V3H11.501ZM11.501 19V21H12.501V19H11.501ZM8.09489 3.87643L8.86025 5.72418L9.78413 5.3415L9.01877 3.49374L8.09489 3.87643ZM14.2178 18.6585L14.9832 20.5063L15.9071 20.1236L15.1417 18.2758L14.2178 18.6585ZM14.9832 3.49374L14.2178 5.3415L15.1417 5.72418L15.9071 3.87643L14.9832 3.49374ZM8.86025 18.2758L8.09489 20.1236L9.01877 20.5063L9.78413 18.6585L8.86025 18.2758ZM21.001 11.5H19.001V12.5H21.001V11.5ZM5.00098 11.5H3.00098V12.5H5.00098V11.5ZM20.4593 15.1155L18.6238 14.3212L18.2267 15.2389L20.0622 16.0332L20.4593 15.1155ZM5.77527 8.76109L3.93976 7.96679L3.54261 8.88455L5.37812 9.67884L5.77527 8.76109ZM20.1245 8.09391L18.2768 8.85928L18.6595 9.78316L20.5072 9.01779L20.1245 8.09391ZM5.34248 14.2168L3.49472 14.9822L3.8774 15.9061L5.72516 15.1407L5.34248 14.2168ZM18.7185 18.0104L17.3043 16.5962L16.5972 17.3033L18.0114 18.7175L18.7185 18.0104ZM7.40478 6.6967L5.99057 5.28249L5.28346 5.98959L6.69768 7.40381L7.40478 6.6967ZM11.3132 11.3122L14.9241 9.07686L12.6888 12.6878L11.3132 11.3122Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$34ee854030c393c9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.8133 6.50295L13.4152 13.4142L6.50392 17.8123C7.70928 18.9527 9.26918 19.7222 11.001 19.9381V18H13.001V19.9381C14.4617 19.756 15.8001 19.18 16.9066 18.3199L15.5365 16.9497L16.9507 15.5355L18.3208 16.9056C19.181 15.7991 19.7569 14.4607 19.9391 13H18.001V11H19.9391C19.7231 9.2682 18.9536 7.70831 17.8133 6.50295ZM17.498 6.18771C16.2927 5.04733 14.7328 4.27785 13.001 4.06189V6H11.001V4.06189C9.54027 4.24404 8.20186 4.81999 7.09533 5.68014L8.46544 7.05025L7.05123 8.46447L5.68112 7.09436C4.82097 8.20088 4.24502 9.53929 4.06287 11H6.00098V13H4.06287C4.27882 14.7318 5.04831 16.2917 6.18868 17.4971L10.5868 10.5858L17.498 6.18771ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7011dd189b4ccc74(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.3109 20.3997C12.8839 20.4657 12.4464 20.5 12.001 20.5C7.30656 20.5 3.50098 16.6944 3.50098 12C3.50098 11.5545 3.53524 11.1171 3.60129 10.6901C3.21792 9.96108 3.00098 9.13087 3.00098 8.25C3.00098 5.35051 5.35148 3 8.25098 3C9.13185 3 9.96205 3.21694 10.6911 3.60031C11.118 3.53427 11.5555 3.5 12.001 3.5C16.6954 3.5 20.501 7.30558 20.501 12C20.501 12.4455 20.4667 12.8829 20.4007 13.3099C20.784 14.0389 21.001 14.8691 21.001 15.75C21.001 18.6495 18.6505 21 15.751 21C14.8701 21 14.0399 20.7831 13.3109 20.3997ZM12.0532 17.1555L12.0126 17.1562C14.8854 17.1562 16.3158 15.7703 16.3158 13.9132C16.3158 12.7148 15.7645 11.442 13.5904 10.9552L11.6073 10.515C10.8522 10.3433 9.98514 10.1145 9.98514 9.39975C9.98514 8.685 10.6041 8.187 11.7088 8.187C13.9394 8.187 13.7355 9.71475 14.8403 9.71475C15.4156 9.71475 15.933 9.37275 15.933 8.78475C15.933 7.41525 13.7355 6.3855 11.8773 6.3855C9.85579 6.3855 7.70421 7.2435 7.70421 9.52875C7.70421 10.6275 8.09753 11.799 10.2634 12.342L12.9527 13.0133C13.7686 13.215 13.9709 13.6718 13.9709 14.085C13.9709 14.772 13.2873 15.4432 12.0532 15.4432C9.6362 15.4432 9.97461 13.5855 8.67885 13.5855C8.09828 13.5855 7.67639 13.9837 7.67639 14.5575C7.67639 15.6712 9.0278 17.1555 12.0532 17.1555Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$404b0e7c067bf9a4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.0052 18.4232C13.4288 18.3577 13.8623 18.43 14.2418 18.6295C14.7026 18.8719 15.2154 19 15.751 19C17.5459 19 19.001 17.5449 19.001 15.75C19.001 15.2144 18.8728 14.7016 18.6305 14.2408C18.431 13.8613 18.3586 13.4278 18.4242 13.0042C18.4752 12.6746 18.501 12.3393 18.501 12C18.501 8.41015 15.5908 5.5 12.001 5.5C11.6617 5.5 11.3264 5.52582 10.9968 5.57681C10.5731 5.64234 10.1396 5.57001 9.7602 5.37047C9.29939 5.12815 8.7866 5 8.25098 5C6.45605 5 5.00098 6.45507 5.00098 8.25C5.00098 8.78562 5.12912 9.29841 5.37145 9.75922C5.57098 10.1387 5.64332 10.5722 5.57778 10.9958C5.5268 11.3254 5.50098 11.6607 5.50098 12C5.50098 15.5899 8.41113 18.5 12.001 18.5C12.3403 18.5 12.6755 18.4742 13.0052 18.4232ZM12.001 20.5C7.30656 20.5 3.50098 16.6944 3.50098 12C3.50098 11.5545 3.53524 11.1171 3.60129 10.6901C3.21792 9.96108 3.00098 9.13087 3.00098 8.25C3.00098 5.35051 5.35148 3 8.25098 3C9.13185 3 9.96205 3.21694 10.6911 3.60031C11.118 3.53427 11.5555 3.5 12.001 3.5C16.6954 3.5 20.501 7.30558 20.501 12C20.501 12.4455 20.4667 12.8829 20.4007 13.3099C20.784 14.0389 21.001 14.8691 21.001 15.75C21.001 18.6495 18.6505 21 15.751 21C14.8701 21 14.0399 20.7831 13.3109 20.3997C12.8839 20.4657 12.4464 20.5 12.001 20.5ZM12.0539 16.9993C9.25237 16.9993 8.00098 15.6213 8.00098 14.5872C8.00098 14.0545 8.39165 13.6848 8.92925 13.6848C10.1291 13.6848 9.81574 15.4096 12.0539 15.4096C13.1967 15.4096 13.8297 14.7864 13.8297 14.1485C13.8297 13.7648 13.6423 13.3408 12.8868 13.1535L10.3965 12.5303C8.39095 12.0261 8.02674 10.9384 8.02674 9.91832C8.02674 7.7966 10.0191 7 11.8909 7C13.6117 7 15.6465 7.95606 15.6465 9.22756C15.6465 9.77348 15.1674 10.091 14.6347 10.091C13.6117 10.091 13.8004 8.67259 11.735 8.67259C10.712 8.67259 10.1389 9.13495 10.1389 9.79855C10.1389 10.4622 10.9418 10.6745 11.6409 10.834L13.4773 11.2427C15.4905 11.6947 16.001 12.8763 16.001 13.9891C16.001 15.7132 14.6765 17 12.0163 17L12.0539 16.9993Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ec5b2eaf848868eb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.52739 14.5138C6.52739 15.5969 5.64264 16.4816 4.55959 16.4816C3.47654 16.4816 2.5918 15.5969 2.5918 14.5138C2.5918 13.4308 3.47654 12.546 4.55959 12.546H6.52739V14.5138ZM7.51892 14.5138C7.51892 13.4308 8.40366 12.546 9.48671 12.546C10.5698 12.546 11.4545 13.4308 11.4545 14.5138V19.4409C11.4545 20.524 10.5698 21.4087 9.48671 21.4087C8.40366 21.4087 7.51892 20.524 7.51892 19.4409V14.5138ZM9.48671 6.52739C8.40366 6.52739 7.51892 5.64264 7.51892 4.55959C7.51892 3.47654 8.40366 2.5918 9.48671 2.5918C10.5698 2.5918 11.4545 3.47654 11.4545 4.55959V6.52739H9.48671ZM9.48671 7.51892C10.5698 7.51892 11.4545 8.40366 11.4545 9.48671C11.4545 10.5698 10.5698 11.4545 9.48671 11.4545H4.55959C3.47654 11.4545 2.5918 10.5698 2.5918 9.48671C2.5918 8.40366 3.47654 7.51892 4.55959 7.51892H9.48671ZM17.4732 9.48671C17.4732 8.40366 18.3579 7.51892 19.4409 7.51892C20.524 7.51892 21.4087 8.40366 21.4087 9.48671C21.4087 10.5698 20.524 11.4545 19.4409 11.4545H17.4732V9.48671ZM16.4816 9.48671C16.4816 10.5698 15.5969 11.4545 14.5138 11.4545C13.4308 11.4545 12.546 10.5698 12.546 9.48671V4.55959C12.546 3.47654 13.4308 2.5918 14.5138 2.5918C15.5969 2.5918 16.4816 3.47654 16.4816 4.55959V9.48671ZM14.5138 17.4732C15.5969 17.4732 16.4816 18.3579 16.4816 19.4409C16.4816 20.524 15.5969 21.4087 14.5138 21.4087C13.4308 21.4087 12.546 20.524 12.546 19.4409V17.4732H14.5138ZM14.5138 16.4816C13.4308 16.4816 12.546 15.5969 12.546 14.5138C12.546 13.4308 13.4308 12.546 14.5138 12.546H19.4409C20.524 12.546 21.4087 13.4308 21.4087 14.5138C21.4087 15.5969 20.524 16.4816 19.4409 16.4816H14.5138Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6ce94b721680e72f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.501 3C15.3294 3 16.001 3.67157 16.001 4.5V9.5C16.001 10.3284 15.3294 11 14.501 11C13.6725 11 13.001 10.3284 13.001 9.5V4.5C13.001 3.67157 13.6725 3 14.501 3ZM4.50098 13H6.00098V14.5C6.00098 15.3284 5.3294 16 4.50098 16C3.67255 16 3.00098 15.3284 3.00098 14.5C3.00098 13.6716 3.67255 13 4.50098 13ZM13.001 18H14.501C15.3294 18 16.001 18.6716 16.001 19.5C16.001 20.3284 15.3294 21 14.501 21C13.6725 21 13.001 20.3284 13.001 19.5V18ZM14.501 13H19.501C20.3294 13 21.001 13.6716 21.001 14.5C21.001 15.3284 20.3294 16 19.501 16H14.501C13.6725 16 13.001 15.3284 13.001 14.5C13.001 13.6716 13.6725 13 14.501 13ZM19.501 8C20.3294 8 21.001 8.67157 21.001 9.5C21.001 10.3284 20.3294 11 19.501 11H18.001V9.5C18.001 8.67157 18.6725 8 19.501 8ZM4.50098 8H9.50098C10.3294 8 11.001 8.67157 11.001 9.5C11.001 10.3284 10.3294 11 9.50098 11H4.50098C3.67255 11 3.00098 10.3284 3.00098 9.5C3.00098 8.67157 3.67255 8 4.50098 8ZM9.50098 3C10.3294 3 11.001 3.67157 11.001 4.5V6H9.50098C8.67255 6 8.00098 5.32843 8.00098 4.5C8.00098 3.67157 8.67255 3 9.50098 3ZM9.50098 13C10.3294 13 11.001 13.6716 11.001 14.5V19.5C11.001 20.3284 10.3294 21 9.50098 21C8.67255 21 8.00098 20.3284 8.00098 19.5V14.5C8.00098 13.6716 8.67255 13 9.50098 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$46efb6bee6a5ae5d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.872 21.7645C10.6817 21.7645 9.88811 21.2027 9.17926 20.7079C8.67548 20.3512 8.20292 20.0124 7.64564 19.9188C7.37369 19.8697 7.09729 19.8519 6.84317 19.8519C6.3706 19.8519 5.99612 19.9232 5.72863 19.9767C5.55922 20.0079 5.41655 20.0347 5.3051 20.0347C5.18919 20.0347 5.04207 20.0035 4.98411 19.8073C4.93507 19.6468 4.90386 19.4953 4.87266 19.3481C4.79241 18.9781 4.72554 18.7507 4.58733 18.7285C3.0983 18.5011 2.20667 18.1578 2.0328 17.7521C2.01942 17.7075 2.00159 17.6629 2.00159 17.6273C1.99267 17.5025 2.08184 17.3999 2.20667 17.3776C3.38808 17.1815 4.44913 16.5529 5.34522 15.5186C6.0407 14.7161 6.37952 13.9404 6.41073 13.8557C6.41073 13.8467 6.41964 13.8467 6.41964 13.8467C6.58906 13.4946 6.62472 13.1959 6.52218 12.9507C6.33048 12.4915 5.69742 12.2953 5.26498 12.1616C5.15352 12.1303 5.0599 12.0947 4.97965 12.0679C4.60962 11.9208 3.9944 11.6087 4.07464 11.1763C4.1326 10.8642 4.54721 10.6413 4.88603 10.6413C4.97965 10.6413 5.0599 10.6547 5.12677 10.6904C5.50572 10.8642 5.849 10.9534 6.14324 10.9534C6.50881 10.9534 6.68268 10.8152 6.72726 10.7706C6.71834 10.5744 6.70497 10.3694 6.69159 10.1777C6.60243 8.81346 6.49989 7.11936 6.93234 6.14747C8.22967 3.24074 10.9848 3.00892 11.8007 3.00892C11.823 3.00892 12.1573 3 12.1573 3C12.1707 3 12.1885 3 12.2064 3C13.0222 3 15.7774 3.22737 17.0747 6.13856C17.5116 7.11044 17.4046 8.80901 17.3154 10.1687L17.3065 10.2356C17.2976 10.4184 17.2842 10.5923 17.2753 10.7706C17.3199 10.8063 17.4804 10.94 17.8103 10.9445C18.0956 10.9356 18.4077 10.8419 18.7643 10.6814C18.8758 10.6324 18.9917 10.6146 19.0764 10.6146C19.2012 10.6146 19.3261 10.6458 19.4331 10.6814H19.442C19.7407 10.7929 19.9368 11.0024 19.9368 11.2209C19.9458 11.426 19.7853 11.738 19.0229 12.0456C18.9427 12.0768 18.849 12.1125 18.7376 12.1393C18.3141 12.2686 17.681 12.4736 17.4804 12.9284C17.3689 13.1691 17.4135 13.4767 17.5829 13.8245C17.5829 13.8334 17.5918 13.8334 17.5918 13.8334C17.6409 13.9582 18.9293 16.8828 21.7959 17.3598C21.9207 17.3821 22.001 17.4846 22.001 17.6094C22.001 17.654 21.9921 17.6986 21.9698 17.7387C21.7959 18.1489 20.9132 18.4833 19.4152 18.7151C19.277 18.7374 19.2102 18.9647 19.1299 19.3348C19.0987 19.4863 19.063 19.6335 19.0185 19.794C18.9739 19.9411 18.8803 20.0213 18.7198 20.0213H18.6975C18.5949 20.0213 18.4567 20.0079 18.2739 19.9723C17.953 19.9054 17.6008 19.8564 17.1594 19.8564C16.8964 19.8564 16.6244 19.8787 16.3569 19.9232C15.8041 20.0124 15.3271 20.3557 14.8233 20.7123C14.1055 21.2027 13.3075 21.7645 12.1261 21.7645C12.1261 21.7645 11.9077 21.7645 11.872 21.7645Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$43198a45cab1dffa(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.3826 10.5792C15.3904 10.4826 15.3969 10.4035 15.4025 10.3311C15.4137 10.1844 15.4243 10.0268 15.4344 9.85059C15.4662 9.29326 15.4853 8.67669 15.4853 8.00554C15.4853 7.1344 15.191 6.51928 14.571 5.94177C13.9117 5.3277 13.1124 5 11.9819 5C10.8441 5 10.0229 5.33486 9.4705 5.88766C8.77543 6.58319 8.51358 7.10616 8.51358 7.98803C8.51358 8.50939 8.57456 9.98166 8.60927 10.6065C8.63818 11.1269 8.46325 11.6252 8.14058 12.0076C8.19484 12.1062 8.24561 12.2117 8.29289 12.3251C8.59378 13.0961 8.4912 13.8677 8.1413 14.5963C7.74878 15.4136 7.41022 15.9889 6.7313 16.7497C6.52804 16.9775 6.31412 17.1923 6.08941 17.3927C6.25199 17.5489 6.38901 17.7334 6.49251 17.9404C6.49542 17.9462 6.49827 17.9519 6.50106 17.9575C7.01006 17.9137 7.52238 17.93 8.08587 18.032C8.89536 18.1784 9.41032 18.4661 10.2803 19.0933L10.2958 19.1042C10.4079 19.184 10.4079 19.184 10.5093 19.2562C11.1281 19.6957 11.3863 19.802 11.9819 19.802C12.5908 19.802 12.892 19.6808 13.5054 19.2501C13.554 19.2159 13.6109 19.1756 13.7125 19.1036C14.5885 18.4722 15.1194 18.1765 15.9433 18.0281C16.4093 17.9491 16.9362 17.9154 17.5022 17.9538C17.517 17.9255 17.5331 17.8957 17.551 17.8635C17.6502 17.685 17.7747 17.525 17.9192 17.3873C17.7052 17.1946 17.4999 16.9885 17.3032 16.7705C16.8745 16.2954 16.5148 15.7932 16.2164 15.2892C16.0348 14.9826 15.9084 14.7317 15.8559 14.611C15.4931 13.8621 15.3867 13.0718 15.7191 12.29C15.7598 12.1923 15.8038 12.1005 15.8509 12.0139C15.5196 11.6223 15.3447 11.1099 15.3826 10.5792ZM5.06689 10.4776C5.48626 10.4776 5.66798 10.7826 6.28626 10.7826C6.44278 10.7826 6.54713 10.7478 6.61235 10.7174C6.60365 10.5609 6.51358 8.73083 6.51358 7.98803C6.51358 6.29966 7.23253 5.29775 8.05583 4.47391C8.87912 3.65008 10.1616 3 11.9819 3C13.8022 3 15.0481 3.65305 15.9341 4.47826C16.8201 5.30347 17.4853 6.4089 17.4853 8.00554C17.4853 9.56082 17.3863 10.6 17.3776 10.7217C17.4341 10.7522 17.5294 10.787 17.6558 10.787C18.2866 10.787 18.2866 10.4776 18.9863 10.4776C19.6715 10.4776 19.9689 11.0468 19.9689 11.3C19.9689 11.9213 19.1368 12.2675 18.6384 12.4261C18.2703 12.5433 17.708 12.7174 17.5645 13.0609C17.4906 13.2348 17.521 13.4609 17.6558 13.7391C17.6597 13.747 18.9167 16.6217 21.5863 17.0652C21.821 17.1 21.9776 17.3065 21.9776 17.5478C21.9776 17.8805 21.608 18.1652 21.2515 18.3304C20.808 18.5304 20.1602 18.7 19.2993 18.8348C19.2558 18.913 19.1648 19.3201 19.0645 19.7217C18.9292 20.2636 18.2633 20.0881 18.0732 20.0478C17.2413 19.8716 16.5341 19.9565 16.2776 20C15.795 20.087 15.3645 20.3783 14.8819 20.7261C14.1689 21.2304 13.4172 21.802 11.9819 21.802C10.5466 21.802 9.83843 21.2304 9.12539 20.7261C8.64278 20.3783 8.22066 20.0888 7.72974 20C6.83117 19.8374 6.15981 20.0357 5.93409 20.0565C5.70837 20.0773 5.09257 20.3009 4.93843 19.7304C4.89359 19.5645 4.74713 18.9217 4.70365 18.8348C3.84713 18.7 3.19496 18.5217 2.75148 18.3217C2.38626 18.1565 2.02539 17.8787 2.02539 17.5435C2.02539 17.3078 2.18336 17.1034 2.41669 17.0609C5.06017 16.5785 6.18185 14.0565 6.33843 13.7304C6.47054 13.4554 6.4993 13.2304 6.42974 13.0522C6.28626 12.7087 5.72539 12.5391 5.35583 12.4174C5.25148 12.3826 4.02067 12.0445 4.02067 11.3C4.02067 11.06 4.22508 10.7269 4.60241 10.5704C4.76382 10.5035 4.9609 10.4776 5.06689 10.4776Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$260b3019862ce0b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.464 8.59655C10.7291 8.59655 10.944 10.7026 10.944 13.3005L10.9427 13.6516C10.9244 16.0856 10.717 18.0045 10.464 18.0045C10.2079 18.0045 9.99871 16.0396 9.98474 13.5645L9.98408 13.2122C9.98889 10.655 10.2019 8.59655 10.464 8.59655ZM8.8 9.55655C9.05863 9.55655 9.26949 11.3566 9.27962 13.6107V13.9504C9.26949 16.2045 9.05863 18.0045 8.8 18.0045C8.5446 18.0045 8.33579 16.2492 8.32086 14.0347L8.3201 13.6954L8.32241 13.3549C8.34666 11.2219 8.55123 9.55655 8.8 9.55655ZM7.136 9.55655C7.3914 9.55655 7.60021 11.3119 7.61515 13.5263L7.6159 13.8657L7.61359 14.2062C7.58934 16.3392 7.38477 18.0045 7.136 18.0045C6.87737 18.0045 6.66651 16.2045 6.65638 13.9504V13.6107C6.66651 11.3566 6.87737 9.55655 7.136 9.55655ZM5.472 10.1325C5.7371 10.1325 5.952 11.8948 5.952 14.0685L5.95028 14.4038C5.92954 16.4207 5.72333 18.0045 5.472 18.0045C5.21035 18.0045 4.99759 16.2878 4.99211 14.153V13.9841C4.99759 11.8493 5.21035 10.1325 5.472 10.1325ZM3.808 11.8605C4.0731 11.8605 4.288 13.2359 4.288 14.9325L4.28738 15.0906C4.27452 16.7138 4.06481 18.0045 3.808 18.0045C3.5429 18.0045 3.328 16.6292 3.328 14.9325L3.32862 14.7745C3.34148 13.1513 3.55119 11.8605 3.808 11.8605ZM14.592 7.06055C17.1727 7.06055 19.3129 8.94627 19.71 11.415C20.0053 11.33 20.3173 11.2845 20.64 11.2845C22.4957 11.2845 24 12.7889 24 14.6445C24 16.4791 22.5297 17.9703 20.7031 18.004L20.64 18.0045H12.48C12.0558 18.0045 11.712 17.6607 11.712 17.2365V7.93345C12.5358 7.38209 13.5263 7.06055 14.592 7.06055ZM2.144 11.6685C2.4091 11.6685 2.624 13.0009 2.624 14.6445L2.62336 14.8001C2.6103 16.3714 2.40068 17.6205 2.144 17.6205C1.88311 17.6205 1.67084 16.3301 1.66416 14.7226L1.664 14.6445C1.664 13.0009 1.8789 11.6685 2.144 11.6685ZM0.48 12.6285C0.745097 12.6285 0.96 13.5741 0.96 14.7405L0.959091 14.8716C0.943709 15.977 0.735093 16.8525 0.48 16.8525C0.214903 16.8525 0 15.907 0 14.7405L0.000909213 14.6095C0.0162906 13.5041 0.224907 12.6285 0.48 12.6285Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$15e6c2671e18a776(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10C4.55228 10 5 10.4477 5 11V18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18V11C3 10.4477 3.44772 10 4 10ZM7 11C7.55228 11 8 11.4477 8 12V18C8 18.5523 7.55228 19 7 19C6.44772 19 6 18.5523 6 18V12C6 11.4477 6.44772 11 7 11ZM10 7C10.5523 7 11 7.44772 11 8V18C11 18.5523 10.5523 19 10 19C9.44771 19 9 18.5523 9 18V8C9 7.44772 9.44771 7 10 7ZM15 6C18.2384 6 20.8776 8.56557 20.9959 11.7751L20.999 12.0353C22.6956 12.2775 24 13.7364 24 15.5C24 17.3686 22.5357 18.8951 20.692 18.9948L20.5 19H16.999C16.4468 19 15.999 18.5523 15.999 18C15.9989 17.4872 16.3849 17.0645 16.8823 17.0067L16.999 17L20.4461 17.0007L20.584 16.9977C21.3751 16.955 22 16.2975 22 15.5C22 14.7984 21.5142 14.199 20.8512 14.0409L20.7164 14.0152L18.9467 13.7626L18.999 11.976L18.9951 11.8004C18.8943 9.75011 17.2499 8.10567 15.1996 8.0049L15 8C14.7321 8 14.4687 8.02612 14.2123 8.07715L13.999 8.126L13.999 18.0005C13.999 18.5131 13.6132 18.9355 13.1161 18.9933L12.9995 19C12.4475 19 12 18.5525 11.9999 18.0005L11.999 6.80325C12.8818 6.2924 13.9067 6 15 6ZM1 12C1.55228 12 2 12.4477 2 13V17C2 17.5523 1.55228 18 1 18C0.447715 18 0 17.5523 0 17V13C0 12.4477 0.447715 12 1 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$95af8be239eb59f3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.1997 2.00644C21.2413 2.09355 22.0006 3.25057 22.0006 12.0006L21.9948 13.1996C21.9077 21.2413 20.7506 22.0006 12.0006 22.0006L10.8016 21.9947C3.14288 21.9117 2.08947 20.8583 2.00651 13.1996L2.00098 11.6913L2.00651 10.8015C2.09154 2.95134 3.19615 2.04086 11.3885 2.00195L13.1997 2.00644ZM8.25064 7.00057H7.66731C7.33265 7.00057 7.0555 7.2473 7.00787 7.56874L7.00064 7.66724V11.3339C7.00064 11.6688 7.24737 11.9458 7.56881 11.9933L7.66731 12.0006H8.25064C10.2549 12.0006 11.8919 13.573 11.9954 15.5514L12.0006 15.7506V16.3339C12.0006 16.6688 12.2474 16.9458 12.5688 16.9933L12.6673 17.0006H16.334C16.6686 17.0006 16.9458 16.754 16.9934 16.4325L17.0006 16.3339V15.7506C17.0006 11.0044 13.2218 7.14078 8.50863 7.0043L8.25064 7.00057Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$24d51580218c4b88(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.3885 2.00146L13.1997 2.00596L14.0434 2.0199C21.2046 2.18454 21.982 3.53205 22.0003 11.6871L21.9948 13.1991L21.9808 14.0429C21.8162 21.204 20.4687 21.9814 12.3136 21.9997L10.8016 21.9942L9.91389 21.9792C3.06016 21.8164 2.08615 20.5515 2.00651 13.1991L2.00098 11.6908L2.00651 10.801L2.02094 9.9364C2.18566 2.88296 3.50725 2.03889 11.3885 2.00146ZM14.1204 4.00883L10.8829 4.00079L9.561 4.01053C4.07209 4.09335 4.01663 4.83194 4.0016 11.414L4.00259 13.5888L4.0132 14.6296C4.10138 19.6115 4.80564 19.9723 10.4119 19.9981L13.8667 19.9965L14.6429 19.9873C19.7508 19.8957 19.9894 19.1505 20.0002 13.1103L19.998 10.3675L19.9859 9.31193C19.892 4.51568 19.201 4.06256 14.1204 4.00883ZM8.25064 7.00009C13.0831 7.00009 17.0006 10.9176 17.0006 15.7501V16.3334C17.0006 16.7018 16.7021 17.0001 16.334 17.0001H12.6673C12.2992 17.0001 12.0006 16.7018 12.0006 16.3334V15.7501C12.0006 13.679 10.3217 12.0001 8.25064 12.0001H7.66731C7.29918 12.0001 7.00064 11.7018 7.00064 11.3334V7.66675C7.00064 7.29863 7.29918 7.00009 7.66731 7.00009H8.25064Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b73a3cf14b014477(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 2C6.50098 2 2.00098 6.5 2.00098 12C2.00098 17.5 6.50098 22 12.001 22C17.501 22 22.001 17.5 22.001 12C22.001 6.5 17.551 2 12.001 2ZM15.751 16.65C13.401 15.2 10.451 14.8992 6.95014 15.6992C6.60181 15.8008 6.30098 15.55 6.20098 15.25C6.10098 14.8992 6.35098 14.6 6.65098 14.5C10.451 13.6492 13.751 14 16.351 15.6C16.701 15.75 16.7501 16.1492 16.6018 16.45C16.4018 16.7492 16.0518 16.85 15.751 16.65ZM16.7501 13.95C14.051 12.3 9.95098 11.8 6.80098 12.8C6.40181 12.9 5.95098 12.7 5.85098 12.3C5.75098 11.9 5.95098 11.4492 6.35098 11.3492C10.001 10.25 14.501 10.8008 17.601 12.7C17.9018 12.8508 18.051 13.35 17.8018 13.7C17.551 14.05 17.101 14.2 16.7501 13.95ZM6.30098 9.75083C5.80098 9.9 5.30098 9.6 5.15098 9.15C5.00098 8.64917 5.30098 8.15 5.75098 7.99917C9.30098 6.94917 15.151 7.14917 18.8518 9.35C19.301 9.6 19.451 10.2 19.201 10.65C18.9518 11.0008 18.351 11.1492 17.9018 10.9C14.701 9 9.35098 8.8 6.30098 9.75083Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bef68bda0184897a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 2C17.551 2 22.001 6.5 22.001 12C22.001 17.5 17.501 22 12.001 22C6.50098 22 2.00098 17.5 2.00098 12C2.00098 6.5 6.50098 2 12.001 2ZM12.001 4C7.60555 4 4.00098 7.60457 4.00098 12C4.00098 16.3954 7.60555 20 12.001 20C16.3964 20 20.001 16.3954 20.001 12C20.001 7.58572 16.4276 4 12.001 4ZM15.751 16.65C13.401 15.2 10.451 14.8992 6.95014 15.6992C6.60181 15.8008 6.30098 15.55 6.20098 15.25C6.10098 14.8992 6.35098 14.6 6.65098 14.5C10.451 13.6492 13.751 14 16.351 15.6C16.701 15.75 16.7501 16.1492 16.6018 16.45C16.4018 16.7492 16.0518 16.85 15.751 16.65ZM16.7501 13.95C14.051 12.3 9.95098 11.8 6.80098 12.8C6.40181 12.9 5.95098 12.7 5.85098 12.3C5.75098 11.9 5.95098 11.4492 6.35098 11.3492C10.001 10.25 14.501 10.8008 17.601 12.7C17.9018 12.8508 18.051 13.35 17.8018 13.7C17.551 14.05 17.101 14.2 16.7501 13.95ZM6.30098 9.75083C5.80098 9.9 5.30098 9.6 5.15098 9.15C5.00098 8.64917 5.30098 8.15 5.75098 7.99917C9.30098 6.94917 15.151 7.14917 18.8518 9.35C19.301 9.6 19.451 10.2 19.201 10.65C18.9518 11.0008 18.351 11.1492 17.9018 10.9C14.701 9 9.35098 8.8 6.30098 9.75083Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f7d32bcc447bd1ed(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.001 20.0031V14.6698H20.001V22.0031H4.00098V14.6698H6.00098V20.0031H18.001ZM7.59977 14.7364L7.913 12.7571L16.75 14.4565L16.6367 16.0426L7.59977 14.7364ZM8.79937 10.2046L9.53245 8.60512L17.5298 12.3372L16.7967 13.9367L8.79937 10.2046ZM11.0653 6.27257L12.1982 4.93969L18.9959 10.6045L17.863 11.9373L11.0653 6.27257ZM15.3972 2.14062L20.6621 9.20492L19.2625 10.2712L13.9976 3.20693L15.3972 2.14062ZM7.33319 18.6684V16.6691H16.6634V18.6684H7.33319Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9ff28a9ac2c3087c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.001 20.0028V15.0003H20.001V22.0028H4.00098V15.0003H6.00098V20.0028H18.001ZM7.50098 18.0003V16.0003H16.501V18.0003H7.50098ZM7.578 13.6199L7.9253 11.6503L16.7886 13.2131L16.4413 15.1827L7.578 13.6199ZM9.21156 8.11632L10.2116 6.38427L18.0058 10.8843L17.0058 12.6163L9.21156 8.11632ZM12.6289 3.50335L14.161 2.21777L19.9461 9.11217L18.414 10.3977L12.6289 3.50335Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$645fa1671349b551(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.001 3C21.5533 3 22.001 3.44772 22.001 4V20C22.001 20.5523 21.5533 21 21.001 21H3.00098C2.44869 21 2.00098 20.5523 2.00098 20V4C2.00098 3.44772 2.44869 3 3.00098 3H21.001ZM16.7931 5.62118C15.782 5.62118 14.9292 6.29705 14.6603 7.22158H12.6618L10.2022 11.4056H8.76433C8.49549 10.481 7.64267 9.80516 6.63133 9.80516C5.40457 9.80516 4.40993 10.8 4.40993 12.0269C4.40993 13.2536 5.40457 14.2483 6.63133 14.2483C7.64267 14.2483 8.49549 13.5724 8.76433 12.6481H10.2353L12.6523 16.7815H14.6696C14.9383 17.7057 15.7913 18.3814 16.8023 18.3814C18.0294 18.3814 19.024 17.3868 19.024 16.1599C19.024 14.933 18.0294 13.9382 16.8023 13.9382C15.7913 13.9382 14.9383 14.6142 14.6696 15.5387H13.3526L11.2968 12.0017L13.3495 8.46402H14.6603C14.9292 9.38855 15.782 10.0644 16.7931 10.0644C18.0201 10.0644 19.0148 9.06963 19.0148 7.84287C19.0148 6.61597 18.0201 5.62118 16.7931 5.62118ZM16.8044 15.0484C17.448 15.0484 17.9718 15.5721 17.9718 16.2158C17.9718 16.8596 17.448 17.3829 16.8044 17.3829C16.2384 17.3829 15.7658 16.9779 15.6598 16.4427C15.6598 16.4427 15.629 16.2164 15.6598 15.9893C15.7656 15.4537 16.2384 15.0484 16.8044 15.0484ZM6.65209 10.8387C7.29588 10.8387 7.81948 11.3622 7.81948 12.006C7.81948 12.6495 7.29588 13.1732 6.65209 13.1732C6.00844 13.1732 5.48485 12.6495 5.48485 12.006C5.48485 11.3622 6.00844 10.8387 6.65209 10.8387ZM16.8023 6.62903C17.4461 6.62903 17.9697 7.15248 17.9697 7.79627C17.9697 8.43977 17.4461 8.96352 16.8023 8.96352C16.2365 8.96352 15.7637 8.55837 15.6578 8.02287C15.6316 7.81689 15.6578 7.57679 15.6578 7.57679C15.7637 7.03418 16.2365 6.62903 16.8023 6.62903Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3bac3fa5e0ed5f62(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.53698 13L7.32995 13.0009C6.91786 14.1656 5.80686 15 4.50098 15C2.84412 15 1.50098 13.6569 1.50098 12C1.50098 10.3431 2.84412 9 4.50098 9C5.80723 9 6.91849 9.83485 7.3303 11.0001L9.53698 11L13.001 5L16.1716 5.00009C16.5835 3.83485 17.6947 3 19.001 3C20.6578 3 22.001 4.34315 22.001 6C22.001 7.65685 20.6578 9 19.001 9C17.6951 9 16.5841 8.16562 16.172 7.0009L14.155 7L11.269 11.999L14.156 17L16.1716 17.0001C16.5835 15.8349 17.6947 15 19.001 15C20.6578 15 22.001 16.3431 22.001 18C22.001 19.6569 20.6578 21 19.001 21C17.6951 21 16.5841 20.1656 16.172 19.0009L13.001 19L9.53698 13ZM19.001 17C18.4487 17 18.001 17.4477 18.001 18C18.001 18.5523 18.4487 19 19.001 19C19.5533 19 20.001 18.5523 20.001 18C20.001 17.4477 19.5533 17 19.001 17ZM4.50098 11C3.94869 11 3.50098 11.4477 3.50098 12C3.50098 12.5523 3.94869 13 4.50098 13C5.05326 13 5.50098 12.5523 5.50098 12C5.50098 11.4477 5.05326 11 4.50098 11ZM19.001 5C18.4487 5 18.001 5.44772 18.001 6C18.001 6.55228 18.4487 7 19.001 7C19.5533 7 20.001 6.55228 20.001 6C20.001 5.44772 19.5533 5 19.001 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f525e3b43440e28(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0052 2C6.75435 2 2.44852 6.05 2.04102 11.1975L7.40102 13.4125C7.85518 13.1033 8.40352 12.9208 8.99435 12.9208C9.04685 12.9208 9.09852 12.9242 9.15102 12.9258L11.5352 9.47417V9.425C11.5352 7.34583 13.2252 5.655 15.3052 5.655C17.3835 5.655 19.0752 7.3475 19.0752 9.4275C19.0752 11.5075 17.3835 13.1983 15.3052 13.1983H15.2177L11.821 15.6242C11.821 15.6675 11.8243 15.7117 11.8243 15.7567C11.8243 17.3192 10.5618 18.5867 8.99935 18.5867C7.63685 18.5867 6.48602 17.6092 6.22352 16.3142L2.38602 14.725C3.57435 18.9225 7.42768 22 12.0052 22C17.5277 22 22.0043 17.5225 22.0043 12C22.0043 6.4775 17.5268 2 12.0052 2ZM7.07852 16.6667C7.29685 17.1192 7.67352 17.4992 8.17352 17.7083C9.25435 18.1575 10.501 17.645 10.9502 16.5625C11.1693 16.0375 11.1702 15.4633 10.9543 14.9383C10.7385 14.4133 10.3293 14.0042 9.80685 13.7858C9.28685 13.5692 8.73185 13.5783 8.24185 13.7608L9.51102 14.2858C10.3077 14.6192 10.6852 15.5358 10.3518 16.3317C10.021 17.1292 9.10435 17.5067 8.30685 17.175L7.07852 16.6667ZM17.8185 9.4225C17.8185 8.0375 16.691 6.91 15.306 6.91C13.9185 6.91 12.7935 8.0375 12.7935 9.4225C12.7935 10.81 13.9185 11.935 15.306 11.935C16.6918 11.935 17.8185 10.81 17.8185 9.4225ZM15.3118 7.53C16.3527 7.53 17.2002 8.375 17.2002 9.41833C17.2002 10.4608 16.3527 11.3058 15.3118 11.3058C14.2677 11.3058 13.4243 10.4608 13.4243 9.41833C13.4243 8.375 14.2685 7.53 15.3118 7.53Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a1fc0b55c79f372a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0011 4C19.7625 4 22.0011 6.23858 22.0011 9C22.0011 11.7614 19.7625 14 17.0011 14C16.6966 14 16.3985 13.9728 16.1091 13.9207L13.4577 15.9089C13.4863 16.1018 13.5011 16.2992 13.5011 16.5C13.5011 18.7091 11.7102 20.5 9.50106 20.5C7.29192 20.5 5.50106 18.7091 5.50106 16.5C5.50106 16.3225 5.51262 16.1477 5.53503 15.9764L1.70898 14.4303L2.4582 12.576L6.28509 14.121C7.01383 13.1375 8.183 12.5 9.50106 12.5C9.66379 12.5 9.82424 12.5097 9.98188 12.5286L12.0226 9.4676C12.0084 9.31365 12.0011 9.15768 12.0011 9C12.0011 6.23858 14.2396 4 17.0011 4ZM9.50106 14.5C9.03676 14.5 8.6094 14.6582 8.26998 14.9237L9.87567 15.5728C10.3877 15.7797 10.6351 16.3625 10.4282 16.8746C10.2214 17.3867 9.63853 17.6341 9.12646 17.4272L7.52032 16.7787C7.65592 17.7513 8.49106 18.5 9.50106 18.5C10.6056 18.5 11.5011 17.6046 11.5011 16.5C11.5011 15.3954 10.6056 14.5 9.50106 14.5ZM12.8647 11.8099L11.8821 13.2855C12.1661 13.4963 12.4213 13.7438 12.6405 14.021L14.0009 13.0002C13.5599 12.669 13.1755 12.2665 12.8647 11.8099ZM17.0011 6C15.3442 6 14.0011 7.34315 14.0011 9C14.0011 10.6569 15.3442 12 17.0011 12C18.6579 12 20.0011 10.6569 20.0011 9C20.0011 7.34315 18.6579 6 17.0011 6ZM17.0011 7C18.1056 7 19.0011 7.89543 19.0011 9C19.0011 10.1046 18.1056 11 17.0011 11C15.8965 11 15.0011 10.1046 15.0011 9C15.0011 7.89543 15.8965 7 17.0011 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3ffa8e966a761c39(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.08378 15.2505C1.42044 15.2505 0.483971 13.3382 1.5038 12.0242L10.2099 0.806805C10.794 0.0542043 11.9999 0.467253 11.9999 1.41993V8.75048H20.9159C22.5793 8.75048 23.5157 10.6627 22.4959 11.9767L13.7898 23.1941C13.2057 23.9467 11.9999 23.5337 11.9999 22.581V15.2505H3.08378Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dbe406f7234b99ba(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9997 2.5982V13.9693H3.90013C3.23055 13.9693 2.83063 13.1844 3.25654 12.6325L10.9997 2.5982ZM12.9997 8.03049V2.33284C12.9997 0.521392 10.7034 -0.291556 9.58194 1.16173L1.67316 11.4107C0.246185 13.2599 1.54768 15.9693 3.90013 15.9693H10.9997V21.6669C10.9997 23.4784 13.296 24.2913 14.4175 22.8381L22.3262 12.5891C23.7532 10.7399 22.4517 8.03049 20.0993 8.03049H12.9997ZM12.9997 10.0305H20.0993C20.7688 10.0305 21.1688 10.8153 20.7429 11.3673L12.9997 21.4016V10.0305Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6317286553e34029(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.62 21C13.5351 21 13.4786 20.9434 13.4927 20.8727V3.12726C13.4927 3.0707 13.5351 3.01414 13.6058 3.01414H16.3914C18.9366 3.01414 21.001 5.07855 21.001 7.62372V16.3904C21.001 18.9356 18.9366 21 16.3914 21H13.62ZM17.0418 11.0738C16.0379 11.0738 15.2178 11.894 15.2178 12.8979C15.2178 13.9018 16.0379 14.7219 17.0418 14.7219C18.0458 14.7219 18.8659 13.9018 18.8659 12.8979C18.8659 11.894 18.0458 11.0738 17.0418 11.0738ZM5.80066 8.40141C5.80066 7.46819 6.56421 6.70463 7.49744 6.70463C8.43067 6.70463 9.19422 7.46819 9.19422 8.40141C9.19422 9.33464 8.43067 10.0982 7.49744 10.0982C6.56421 10.0982 5.80066 9.33464 5.80066 8.40141ZM11.5414 3C11.6263 3 11.6828 3.05656 11.6687 3.12726V20.8586C11.6687 20.9293 11.6121 20.9859 11.5414 20.9859H7.61056C5.06539 20.9859 3.00098 18.9214 3.00098 16.3763V7.60958C3.00098 5.06441 5.06539 3 7.61056 3H11.5414ZM10.2264 19.5436V4.44226H7.61056C6.76217 4.44226 5.97034 4.78162 5.37647 5.37549C4.76846 5.96936 4.44324 6.76119 4.44324 7.60958V16.3763C4.44324 17.2247 4.78259 18.0165 5.37647 18.6104C5.97034 19.2184 6.76217 19.5436 7.61056 19.5436H10.2264Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$67e087cab33ee632(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 3V21H7.60098C5.06047 21 3.00098 18.9405 3.00098 16.4V7.6C3.00098 5.05949 5.06047 3 7.60098 3H12.001ZM10.001 5H7.60098C6.16504 5 5.00098 6.16406 5.00098 7.6V16.4C5.00098 17.8359 6.16504 19 7.60098 19H10.001V5ZM7.50098 10C6.67255 10 6.00098 9.32843 6.00098 8.5C6.00098 7.67157 6.67255 7 7.50098 7C8.3294 7 9.00098 7.67157 9.00098 8.5C9.00098 9.32843 8.3294 10 7.50098 10ZM14.001 3H16.401C18.9415 3 21.001 5.05949 21.001 7.6V16.4C21.001 18.9405 18.9415 21 16.401 21H14.001V3ZM17.001 14.7C17.9951 14.7 18.801 13.8941 18.801 12.9C18.801 11.9059 17.9951 11.1 17.001 11.1C16.0069 11.1 15.201 11.9059 15.201 12.9C15.201 13.8941 16.0069 14.7 17.001 14.7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c0a2e85b76a6c685(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.57626 8.27724L2.38292 10.1197L4.58416 11.4904C4.58416 11.4904 6.04762 12.2443 5.34613 13.6594C4.69704 14.9979 1.5 17.9288 1.5 17.9288L4.36242 19.7269C6.34596 15.401 6.21292 15.9776 6.7088 14.4214C7.22081 12.841 7.3337 11.6275 6.46691 10.7446C5.35419 9.61975 5.22921 9.51493 3.57626 8.27724ZM5.14052 7.5838C6.18067 7.5838 7.02327 6.82587 7.02327 5.89054C7.02327 4.94715 6.18067 4.18921 5.14052 4.18921C4.09231 4.18921 3.25374 4.95118 3.25374 5.89054C3.25777 6.82184 4.09231 7.5838 5.14052 7.5838ZM22.1457 7.79345C22.1457 7.79345 21.5208 2.9233 10.9379 5.93892C11.3935 5.1447 11.6072 4.63269 11.6072 4.63269L8.96649 3.88281C8.96649 3.88281 7.89812 7.39029 5.99521 9.02308C5.99521 9.02308 7.84168 10.0955 7.82152 10.0632C8.34966 9.53106 8.82538 8.99083 9.22854 8.46672C9.65186 8.27724 10.059 8.10388 10.4541 7.94261C9.96229 8.82956 9.17613 10.16 8.38594 10.9986L9.49866 11.9823C9.49866 11.9823 10.2606 11.2445 11.0871 10.3616H12.0305V11.9984H8.34562V13.3046H12.0305V16.4372L11.8894 16.4331C11.4822 16.413 10.8533 16.3444 10.6033 15.9493C10.305 15.4655 10.5267 14.5907 10.5388 14.0464H7.99488L7.90215 14.0988C7.90215 14.0988 6.96682 18.3038 10.5912 18.2111C13.9777 18.3038 15.921 17.2556 16.8563 16.5339L17.2272 17.9288L19.3156 17.0459L17.9005 13.5626L16.2072 14.0988L16.5217 15.2882C16.0943 15.6187 15.5904 15.8606 15.0542 16.0421V13.3046H18.6463V11.9944H15.0542V10.3575H18.6584V9.0513H12.2482C12.7118 8.48285 13.0706 7.96277 13.1674 7.63621L12.0466 7.32981C16.8442 5.59623 19.5171 5.89457 19.497 8.7328V16.2074C19.497 16.2074 19.7792 18.7714 16.8603 18.59L15.2799 18.2473L14.9131 19.7592C14.9131 19.7592 21.7305 21.7266 22.2868 16.4452C22.8392 11.1638 22.1457 7.79345 22.1457 7.79345Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dd4d9bcc79657e17(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.1727 13.9994H14.5011V15.3749C15.0503 15.1529 15.6538 14.8837 16.3132 14.5644C16.2861 14.4863 16.2586 14.4069 16.2306 14.3261L17.1727 13.9994ZM18.0011 13.7122L18.1202 13.6709C18.762 15.5217 19.1553 16.6823 19.3059 17.1711L17.3945 17.7599C17.3205 17.5196 17.1778 17.088 16.9672 16.4677C10.8856 19.3519 8.29581 18.5219 7.95943 14.5601L9.95226 14.3909C10.0512 15.5559 10.2958 16.0119 10.8486 16.1427C11.2419 16.2356 11.7895 16.2058 12.5011 16.0382V13.9994H9.00108V11.9994H9.51418L8.34713 10.6093C9.39046 9.7334 10.2047 8.77958 10.7955 7.74579C10.2773 7.88016 9.75799 8.0255 9.24396 8.18047C8.70907 8.96425 8.12459 9.66743 7.49009 10.2893L6.09012 8.86102C7.36251 7.61388 8.42283 5.95206 9.26582 3.86719L11.12 4.6169C10.9669 4.99557 10.8067 5.36276 10.6394 5.71842C14.3425 4.78293 17.9154 4.40123 19.7784 5.03839C21.0008 5.45649 21.6968 6.42975 21.9655 7.62252C22.1357 8.37822 22.2785 10.3114 22.2785 12.745C22.2785 15.5527 22.2225 16.5161 21.9385 17.3671C21.6414 18.2572 21.2416 18.7851 20.5308 19.3513C19.874 19.8744 18.9779 20.1145 17.8864 20.1745C17.213 20.2115 16.5177 20.177 15.7915 20.0953C15.6722 20.0819 15.5574 20.0678 15.4372 20.0521C15.3685 20.0431 15.2944 20.0331 15.195 20.0197L15.4588 18.0372C15.5638 18.0514 15.6325 18.0606 15.6962 18.069C15.8053 18.0832 15.9084 18.0959 16.0149 18.1079C16.6398 18.1781 17.2313 18.2075 17.7767 18.1775C18.4915 18.1382 19.0222 17.996 19.2848 17.7869C19.7107 17.4476 19.8761 17.2293 20.0414 16.7339C20.2266 16.179 20.2785 15.2855 20.2785 12.745C20.2785 10.4468 20.1453 8.64316 20.0144 8.0621C19.8845 7.48572 19.6032 7.0922 19.1312 6.93077C17.9245 6.51807 15.3297 6.73655 12.4792 7.34695L13.0936 7.60933C12.9644 7.91184 12.8213 8.20855 12.6645 8.49944H18.0011V10.4994H14.5011V11.9994H18.0011V13.7122ZM12.5011 10.4994H11.2926C10.8487 11.0228 10.3508 11.5229 9.79935 11.9994H12.5011V10.4994ZM2.4625 10.0611L3.53965 8.37596C4.602 9.055 6.47526 10.8031 6.87794 11.5376C8.1167 13.7971 7.07554 15.7131 3.75606 19.5349L2.24609 18.2234C4.9334 15.1294 5.74623 13.6336 5.12421 12.499C4.91013 12.1085 3.26737 10.5756 2.4625 10.0611ZM5.14134 7.58285C4.09313 7.58285 3.25859 6.82088 3.25456 5.88958C3.25456 4.95023 4.09313 4.18826 5.14134 4.18826C6.18149 4.18826 7.02409 4.94619 7.02409 5.88958C7.02409 6.82491 6.18149 7.58285 5.14134 7.58285Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3b2d2289c5c56a21(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM8.89113 13.1708L8.90378 13.1628C9.48351 15.0767 9.77337 16.0337 9.77337 16.0337C9.88564 16.3442 10.04 16.3996 10.2273 16.3743C10.4145 16.3489 10.5139 16.2476 10.6361 16.1297C10.6361 16.1297 11.0324 15.7472 11.825 14.9823L14.3759 16.8698C14.8407 17.1266 15.1763 16.9941 15.2917 16.4377L16.9495 8.61641C17.1325 7.88842 16.8115 7.59644 16.247 7.82754L6.51397 11.5871C5.84996 11.854 5.85317 12.2255 6.39308 12.3911L8.89113 13.1708Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d1063dfc26746855(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 16.4183 7.5827 20 12.001 20ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM8.89113 13.1708L6.39308 12.3911C5.85317 12.2255 5.84996 11.854 6.51397 11.5871L16.247 7.82754C16.8115 7.59644 17.1325 7.88842 16.9495 8.61641L15.2917 16.4377C15.1763 16.9941 14.8407 17.1266 14.3759 16.8698L11.825 14.9823L10.6361 16.1297C10.5139 16.2476 10.4145 16.3489 10.2273 16.3743C10.04 16.3996 9.88564 16.3442 9.77337 16.0337L8.90378 13.1628L8.89113 13.1708Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$26d1e2a2d8881312(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.7051 11.1081C16.543 8.12137 14.911 6.41148 12.1708 6.39398C10.5193 6.3838 9.13771 7.08389 8.29233 8.36664L9.79941 9.40046C10.4334 8.43852 11.4342 8.24015 12.1593 8.24685C13.0616 8.2526 13.7425 8.51494 14.1832 9.02653C14.5038 9.39899 14.7183 9.91367 14.8245 10.5632C14.0246 10.4273 13.1594 10.3855 12.2345 10.4385C9.62919 10.5886 7.95426 12.1081 8.06675 14.2194C8.12384 15.2904 8.65739 16.2118 9.56906 16.8137C10.3399 17.3225 11.3326 17.5713 12.3644 17.515C13.727 17.4403 14.7959 16.9205 15.5416 15.9699C16.1079 15.248 16.4661 14.3125 16.6243 13.1338C17.2737 13.5257 17.7549 14.0414 18.0207 14.6613C18.4726 15.7151 18.499 17.4469 17.086 18.8587C15.848 20.0955 14.3598 20.6306 12.1108 20.6471C9.61601 20.6286 7.72924 19.8285 6.50253 18.269C5.35381 16.8088 4.76014 14.6996 4.73799 12C4.76014 9.30038 5.35381 7.19117 6.50253 5.73092C7.72924 4.17147 9.61597 3.37141 12.1107 3.35287C14.6236 3.37155 16.5433 4.17547 17.8169 5.74244C18.4415 6.51086 18.9123 7.47721 19.2227 8.60394L20.9888 8.13274C20.6125 6.74587 20.0205 5.55078 19.2148 4.55966C17.582 2.55073 15.1816 1.52134 12.1046 1.5C9.03385 1.52127 6.6725 2.55457 5.08614 4.57117C3.67451 6.3657 2.94634 8.87742 2.92188 12.0074C2.94634 15.1373 3.67451 17.6343 5.08614 19.4289C6.6725 21.4454 9.04616 22.4788 12.1169 22.5C14.847 22.4811 16.7713 21.7663 18.3566 20.1825C20.4307 18.1103 20.3682 15.513 19.6846 13.9185C19.1595 12.6943 18.1141 11.7129 16.7051 11.1081ZM12.2669 15.6648C11.125 15.7291 9.93869 15.2166 9.88019 14.1188C9.83684 13.3048 10.4595 12.3966 12.3369 12.2884C13.2594 12.2352 14.1138 12.2976 14.8701 12.463C14.6538 15.1648 13.3848 15.6035 12.2669 15.6648Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1d311ac564db3a1e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.1835 1.41016L12.1822 1.41016C9.09012 1.43158 6.70036 2.47326 5.09369 4.51569C3.66581 6.33087 2.93472 8.86436 2.91016 12.0068V12.0082C2.93472 15.1508 3.66586 17.6696 5.09369 19.4847C6.70043 21.5271 9.10257 22.5688 12.1946 22.5902H12.1958C14.944 22.5711 16.8929 21.8504 18.4985 20.2463C20.6034 18.1434 20.5408 15.5048 19.8456 13.8832C19.3163 12.6493 18.2709 11.6618 16.8701 11.0477C16.6891 8.06345 15.0097 6.32178 12.2496 6.30415C10.6191 6.29409 9.14792 7.02378 8.24685 8.39104L9.90238 9.5267C10.4353 8.71818 11.2789 8.32815 12.2371 8.33701C13.6244 8.34586 14.5362 9.11128 14.7921 10.4541C14.02 10.3333 13.1902 10.2982 12.3076 10.3488C9.66843 10.5008 7.9399 12.061 8.05516 14.2244C8.17571 16.4862 10.367 17.7186 12.4476 17.605C14.9399 17.4684 16.4209 15.6292 16.7722 13.2836C17.3493 13.6575 17.7751 14.1344 18.0163 14.6969C18.4559 15.7222 18.4838 17.4132 17.1006 18.7952C15.8838 20.0108 14.4211 20.5407 12.1891 20.5572C9.71428 20.5388 7.85698 19.746 6.65154 18.2136C5.51973 16.7748 4.92843 14.6882 4.90627 12.0002C4.92843 9.31211 5.51973 7.22549 6.65154 5.78673C7.85698 4.25433 9.71424 3.46156 12.189 3.44303C14.6819 3.4617 16.5728 4.25837 17.8254 5.79937C18.5162 6.64934 18.949 7.66539 19.2379 8.71407L21.1776 8.19656C20.8148 6.85917 20.2414 5.58371 19.363 4.50305C17.7098 2.46918 15.2816 1.43166 12.1835 1.41016ZM12.4204 12.3782C13.3044 12.3272 14.1239 12.3834 14.8521 12.5345C14.7114 14.1116 14.0589 15.4806 12.3401 15.575C11.2282 15.6376 10.1031 15.1413 10.0484 14.114C10.0077 13.3503 10.5726 12.4847 12.4204 12.3782Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$adab11a13e19401b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8.24537V15.5C16 19.0899 13.0899 22 9.5 22C5.91015 22 3 19.0899 3 15.5C3 11.9101 5.91015 9 9.5 9C10.0163 9 10.5185 9.06019 11 9.17393V12.3368C10.5454 12.1208 10.0368 12 9.5 12C7.567 12 6 13.567 6 15.5C6 17.433 7.567 19 9.5 19C11.433 19 13 17.433 13 15.5V2H16C16 4.76142 18.2386 7 21 7V10C19.1081 10 17.3696 9.34328 16 8.24537Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9b95253030ff7b34(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.0004 2V8.41396C10.5947 8.33909 10.1768 8.3 9.75039 8.3C5.96724 8.3 2.90039 11.3668 2.90039 15.15C2.90039 18.9332 5.96724 22 9.75039 22C13.5335 22 16.6004 18.9332 16.6004 15.15V11.4136C17.6366 11.8539 18.7662 12.1 20.0005 12.1H21.0005V6.5H20.0005C18.0966 6.5 16.6004 4.96259 16.6004 3V2H11.0004ZM13.0004 4H14.688C15.0818 6.22009 16.7673 7.99607 19.0005 8.4091V10.0282C17.9624 9.87602 17.0253 9.48645 16.1567 8.905L14.6004 7.86327V15.15C14.6004 17.8286 12.429 20 9.75039 20C7.07181 20 4.90039 17.8286 4.90039 15.15C4.90039 12.4714 7.07181 10.3 9.75039 10.3C9.83431 10.3 9.91769 10.3021 10.0005 10.3063V11.9095C9.91795 11.9032 9.83454 11.9 9.75039 11.9C7.95547 11.9 6.50039 13.3551 6.50039 15.15C6.50039 16.9449 7.95547 18.4 9.75039 18.4C11.5453 18.4 13.0004 16.9449 13.0004 15.15C13.0004 11.4334 12.9992 7.71665 13.0004 4ZM8.50039 15.15C8.50039 14.4596 9.06003 13.9 9.75039 13.9C10.4407 13.9 11.0004 14.4596 11.0004 15.15C11.0004 15.8404 10.4407 16.4 9.75039 16.4C9.06003 16.4 8.50039 15.8404 8.50039 15.15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ef39a66830308817(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.25098 3H18.751C19.993 3 21.001 4.00737 21.001 5.25V18.75C21.001 19.992 19.9935 21 18.751 21H5.25098C4.00898 21 3.00098 19.9925 3.00098 18.75V5.25C3.00098 4.008 4.00835 3 5.25098 3ZM13.171 6.42054V12.1795C13.171 12.7762 13.6545 13.26 14.2507 13.26H17.5812C18.1776 13.26 18.661 12.7765 18.661 12.1795V6.42054C18.661 5.82384 18.1774 5.34 17.5812 5.34H14.2507C13.6543 5.34 13.171 5.82348 13.171 6.42054ZM5.34098 6.42045V16.6796C5.34098 17.2762 5.82455 17.76 6.42071 17.76H9.75125C10.3476 17.76 10.831 17.277 10.831 16.6796V6.42045C10.831 5.82375 10.3474 5.34 9.75125 5.34H6.42071C5.82428 5.34 5.34098 5.82303 5.34098 6.42045Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$43f848828a8bde06(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.00098 5V19H19.001V5H5.00098ZM5.00098 3H19.001C20.1055 3 21.001 3.89543 21.001 5V19C21.001 20.1046 20.1055 21 19.001 21H5.00098C3.89641 21 3.00098 20.1046 3.00098 19V5C3.00098 3.89543 3.89641 3 5.00098 3ZM8.00098 7H10.001C10.5533 7 11.001 7.44772 11.001 8V16C11.001 16.5523 10.5533 17 10.001 17H8.00098C7.44869 17 7.00098 16.5523 7.00098 16V8C7.00098 7.44772 7.44869 7 8.00098 7ZM14.001 7H16.001C16.5533 7 17.001 7.44772 17.001 8V12C17.001 12.5523 16.5533 13 16.001 13H14.001C13.4487 13 13.001 12.5523 13.001 12V8C13.001 7.44772 13.4487 7 14.001 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b06a44342a59aeb0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.27051 7.62976C8.86829 7.07312 10.816 4.76401 10.816 2H13.8463V7.15152H17.4826V10.7879H13.8463V16.2424C13.8463 16.7566 14.044 17.4493 14.7554 17.9091C15.2296 18.2156 16.2397 18.3671 17.7857 18.3636V22H13.5432C11.0329 22 8.99778 19.9649 8.99778 17.4545V10.7879H6.27051V7.62976Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4366f3a228c7e650(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.00098 8C9.07612 8 11.4983 7.32669 11.4983 3.5V2H12.9982V8H18.001V10H12.9982V12.9091C13.0013 15.3906 13.0013 16.596 13.001 17C12.9992 19.2084 14.6163 20.4 17.7861 20.4V22C17.1509 21.9992 16.4034 21.9992 15.5437 22C13.1417 22.0023 10.9982 19.9649 10.9982 17.4545V10H7.00098V8H8.00098Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$739d133e7b6781db(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.001 3V14.7391L16.3053 19.4348H12.3923L9.95523 21.7826H6.91402V19.4348H3.00098V6.13043L4.2281 3H21.001ZM19.4358 4.56522H6.13141V16.3043H9.26185V18.6522L11.6097 16.3043H16.3053L19.4358 13.1739V4.56522ZM16.3053 7.69565V12.3913H14.7401V7.69565H16.3053ZM12.3923 7.69565V12.3913H10.8271V7.69565H12.3923Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4cf7ff00800dacf3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.30098 3H21.001V14.7L16.301 19.4H12.401L9.90098 21.8H7.00098V19.4H3.00098V6.2L4.30098 3ZM5.00098 17.4H9.00098V19.8H9.09636L11.5964 17.4H15.4725L19.001 13.8716V5H5.00098V17.4ZM15.001 8H17.001V12.7H15.001V8ZM15.001 8H17.001V12.7H15.001V8ZM10.001 8H12.001V12.7H10.001V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bfe4a93a2aa1dc7b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.2125 5.65605C21.4491 5.99375 20.6395 6.21555 19.8106 6.31411C20.6839 5.79132 21.3374 4.9689 21.6493 4.00005C20.8287 4.48761 19.9305 4.83077 18.9938 5.01461C18.2031 4.17106 17.098 3.69303 15.9418 3.69434C13.6326 3.69434 11.7597 5.56661 11.7597 7.87683C11.7597 8.20458 11.7973 8.52242 11.8676 8.82909C8.39047 8.65404 5.31007 6.99005 3.24678 4.45941C2.87529 5.09767 2.68005 5.82318 2.68104 6.56167C2.68104 8.01259 3.4196 9.29324 4.54149 10.043C3.87737 10.022 3.22788 9.84264 2.64718 9.51973C2.64654 9.5373 2.64654 9.55487 2.64654 9.57148C2.64654 11.5984 4.08819 13.2892 6.00199 13.6731C5.6428 13.7703 5.27232 13.8194 4.90022 13.8191C4.62997 13.8191 4.36771 13.7942 4.11279 13.7453C4.64531 15.4065 6.18886 16.6159 8.0196 16.6491C6.53813 17.8118 4.70869 18.4426 2.82543 18.4399C2.49212 18.4402 2.15909 18.4205 1.82812 18.3811C3.74004 19.6102 5.96552 20.2625 8.23842 20.2601C15.9316 20.2601 20.138 13.8875 20.138 8.36111C20.138 8.1803 20.1336 7.99886 20.1256 7.81997C20.9443 7.22845 21.651 6.49567 22.2125 5.65605Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b5687b76c713fc90(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.3499 5.5498C13.7681 5.5498 12.4786 6.81785 12.4504 8.39633L12.4223 9.97138C12.4164 10.3027 12.143 10.5665 11.8117 10.5606C11.7881 10.5602 11.7646 10.5584 11.7413 10.5552L10.1805 10.3423C8.12699 10.0623 6.15883 9.11711 4.27072 7.54387C3.67275 10.8535 4.84 13.147 7.65342 14.9157L9.40041 16.014C9.68095 16.1904 9.7654 16.5608 9.58903 16.8413C9.54861 16.9056 9.49636 16.9616 9.43504 17.0064L7.84338 18.1693C8.78973 18.2288 9.68938 18.1873 10.435 18.0385C15.1526 17.097 18.2897 13.5468 18.2897 7.69084C18.2897 7.21275 17.2774 5.5498 15.3499 5.5498ZM10.4507 8.36066C10.4983 5.69559 12.6735 3.5498 15.3499 3.5498C16.7132 3.5498 17.9465 4.10658 18.8348 5.00515C19.5462 4.9998 20.1514 5.17966 21.5035 4.35943C21.1693 5.9998 21.0034 6.71177 20.2897 7.69084C20.2897 15.3324 15.5926 19.0487 10.8264 19.9998C7.5587 20.6519 2.80646 19.5812 1.44531 18.1584C2.13874 18.1051 4.95928 17.8018 6.58895 16.6089C5.20994 15.6984 -0.278631 12.4679 3.32772 3.78617C5.02119 5.76283 6.73797 7.10831 8.47807 7.82262C9.63548 8.29774 9.91978 8.28825 10.4507 8.36066Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a9e1952cd74a0ccf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.2048 2.25H21.5128L14.2858 10.51L22.7878 21.75H16.1308L10.9168 14.933L4.95084 21.75H1.64084L9.37084 12.915L1.21484 2.25H8.04084L12.7538 8.481L18.2048 2.25ZM17.0438 19.77H18.8768L7.04484 4.126H5.07784L17.0438 19.77Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$73752df464a50958(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2H1L9.26086 13.0145L1.44995 21.9999H4.09998L10.4883 14.651L16 22H23L14.3917 10.5223L21.8001 2H19.1501L13.1643 8.88578L8 2ZM17 20L5 4H7L19 20H17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5c865d2da61edfc9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.001 12C22.001 17.5224 17.524 22 12.001 22C6.47798 22 2.00098 17.5224 2.00098 12C2.00098 6.4771 6.47833 2 12.001 2C17.524 2 22.001 6.4771 22.001 12ZM5.20128 10.6642C4.46363 10.6642 3.86613 11.2623 3.86613 12C3.86613 12.7372 4.46363 13.3349 5.20128 13.3349C5.93848 13.3349 6.53628 12.7372 6.53628 12C6.53628 11.2622 5.93848 10.6642 5.20128 10.6642ZM14.7337 16.7325C14.0954 17.1015 13.8763 17.9175 14.2454 18.5558C14.6137 19.1942 15.4296 19.4137 16.0682 19.0448C16.7067 18.6759 16.9257 17.8595 16.5571 17.2208C16.1884 16.5832 15.3721 16.3644 14.7337 16.7325V16.7325ZM8.10133 12C8.10133 10.6808 8.75663 9.5152 9.75958 8.80915L8.78348 7.174C7.61518 7.955 6.74598 9.1485 6.38498 10.545C6.80648 10.8895 7.07613 11.4131 7.07613 12C7.07613 12.586 6.80643 13.1097 6.38493 13.4543C6.74583 14.8516 7.61503 16.0448 8.78343 16.826L9.75953 15.1903C8.75653 14.4848 8.10128 13.32 8.10128 12L8.10133 12ZM12.001 8.09975C14.0385 8.09975 15.7098 9.66175 15.8853 11.654L17.788 11.6261C17.6942 10.1551 17.0518 8.83495 16.0645 7.86435C15.5568 8.05565 14.9705 8.02685 14.4637 7.7342C13.9559 7.4412 13.6376 6.9472 13.5506 6.4104C13.0571 6.27455 12.538 6.2005 12.001 6.2005C11.0782 6.2005 10.2053 6.41685 9.43058 6.80035L10.3582 8.46275C10.8577 8.23045 11.4141 8.09975 12.001 8.09975ZM12.001 15.8995C11.4141 15.8995 10.8576 15.7691 10.3585 15.537L9.43063 17.1991C10.2055 17.5831 11.0782 17.8004 12.001 17.8004C12.538 17.8004 13.0575 17.7255 13.5506 17.5888C13.6376 17.0526 13.9561 16.5586 14.4638 16.2652C14.971 15.9726 15.5569 15.9435 16.0646 16.1349C17.0519 15.1642 17.6942 13.8441 17.7881 12.3732L15.8846 12.3456C15.7099 14.338 14.0386 15.8996 12.0011 15.8996L12.001 15.8995ZM14.7334 7.26675C15.372 7.6349 16.1883 7.4169 16.5566 6.77845C16.9257 6.1396 16.7071 5.32395 16.0683 4.95505C15.4296 4.58605 14.6138 4.8048 14.2447 5.44345C13.8763 6.08195 14.0954 6.89795 14.7334 7.2667V7.26675Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$61e01783f3cdf04a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.66784 19.2731L9.67371 17.5309C12.4214 18.6911 15.6673 17.6497 17.1971 15C17.6099 14.2851 17.8588 13.5206 17.9555 12.75H19.9677C19.8637 13.8618 19.5241 14.9695 18.9292 16C18.5267 16.6971 18.035 17.3108 17.477 17.8349C16.8385 17.6413 16.1244 17.7022 15.501 18.0621C14.8783 18.4216 14.4688 19.0086 14.3168 19.6575C12.4998 20.2066 10.4923 20.1118 8.66784 19.2731ZM7.3688 18.5231C5.73024 17.3624 4.64445 15.6713 4.21148 13.8232C4.69743 13.3671 5.00098 12.719 5.00098 12C5.00098 11.2801 4.69669 10.6312 4.20973 10.1751C4.38459 9.42975 4.67025 8.69715 5.07277 7.99995C5.66768 6.96954 6.4572 6.12154 7.3681 5.47557L8.3742 7.2182C7.75517 7.68729 7.21755 8.28509 6.80482 8.99995C5.27497 11.6497 5.996 14.9814 8.37467 16.7809L7.3688 18.5231ZM8.66779 4.72671C10.4122 3.92909 12.4225 3.76619 14.3163 4.34045C14.4679 4.99011 14.8776 5.57789 15.501 5.93778C16.1243 6.29766 16.8382 6.3586 17.4766 6.16508C18.9209 7.51805 19.785 9.34047 19.9664 11.25H17.9542C17.7265 9.45286 16.6908 7.77941 15.001 6.8038C13.3112 5.82819 11.3441 5.76797 9.67386 6.46927L8.66779 4.72671ZM16.001 5.07175C15.2835 4.65754 15.0377 3.74015 15.4519 3.02271C15.8662 2.30527 16.7835 2.05946 17.501 2.47367C18.2184 2.88789 18.4642 3.80527 18.05 4.52271C17.6358 5.24015 16.7184 5.48596 16.001 5.07175ZM4.00098 12C4.00098 12.8284 3.3294 13.5 2.50098 13.5C1.67255 13.5 1.00098 12.8284 1.00098 12C1.00098 11.1715 1.67255 10.5 2.50098 10.5C3.3294 10.5 4.00098 11.1715 4.00098 12ZM16.001 18.9282C16.7184 18.5139 17.6358 18.7598 18.05 19.4772C18.4642 20.1946 18.2184 21.112 17.501 21.5262C16.7835 21.9404 15.8662 21.6946 15.4519 20.9772C15.0377 20.2598 15.2835 19.3424 16.001 18.9282Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$950e417ba7542751(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.50098 11V16H15.501V11H21.001V21H3.00098V11H8.50098ZM15.501 3V8H8.50098V3H15.501Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8366091316783294(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.001 10V14H14.0002L14.0012 10H21.0012L21.0002 14L21.001 21H3.00098V10H10.001ZM8.00098 12H5.00098V19H19.001V16L19.0007 12H16.0007L15.9997 16H8.00098V12ZM16.001 3V9H8.00098V3H16.001ZM14.001 5H10.001V7H14.001V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b7985aa3ea5f768c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.17444 8.30112C0.892531 7.88758 0.922443 7.88758 1.50184 7.37867C2.73388 6.29651 3.8964 5.11316 5.23826 4.1668C6.45346 3.31485 8.06417 2.7652 9.16466 4.1202C10.1791 5.36886 10.203 7.26157 10.4599 8.76952C10.7168 10.3336 10.963 11.9336 11.5114 13.4308C11.6632 13.8514 11.9535 14.6472 12.4793 14.7141C13.1568 14.8073 13.8474 13.6184 14.1617 13.1739C14.979 11.9945 16.0867 10.4053 15.9469 8.88781C15.8094 7.27591 14.0685 7.57941 12.9811 7.96416C13.1556 6.1551 14.8392 4.1214 16.4607 3.43314C18.1801 2.71979 20.7372 2.73174 21.6011 4.67105C22.5235 6.77286 21.6943 9.21402 20.6894 11.1187C19.5925 13.187 18.1801 15.1012 16.671 16.8888C15.3399 18.4768 13.765 20.2189 11.7803 20.9777C9.51357 21.8416 8.17052 20.158 7.39862 18.2079C6.55622 16.0846 6.13682 13.702 5.52862 11.4915C5.27291 10.5571 4.96941 9.49362 4.3624 8.72292C3.57019 7.72757 2.67044 8.66317 1.88779 9.19968C1.61894 8.93322 1.39669 8.59267 1.17444 8.30112Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7785f00ae5fdf443(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.9943 3.00391C20.4268 3.00391 21.9991 4.51559 21.9991 7.49946C21.9991 9.21909 21.0011 11.4393 20.1674 12.7343C17.3783 17.0671 13.9341 21.474 10.5239 21.474C6.81821 21.474 5.85467 14.6431 5.43244 13.0422C5.01021 11.4413 4.89884 10.8333 4.26237 9.8099C3.94484 10.0286 3.50145 10.3382 2.9322 10.7387C2.7084 10.8962 2.39959 10.8446 2.23929 10.6228L0.925925 8.80695C0.790064 8.61911 0.801127 8.36252 0.952669 8.18709C3.77969 4.91376 6.12916 3.2771 8.0011 3.2771C10.3929 3.2771 11.1255 6.09233 11.325 7.49946C11.6251 9.6164 12.0159 12.2373 12.5696 13.3715C13.1258 12.5799 14.7497 10.4836 14.536 9.38067C14.4418 8.895 13.2189 9.56484 12.6493 9.45903C12.2242 9.38006 11.8435 9.05734 11.8435 8.43327C11.8435 7.12315 13.6951 3.00391 17.9943 3.00391ZM18.0011 5.00391C15.8066 5.00391 14.75 6.53616 14.3478 7.21138C15.5983 7.25709 16.3173 8.02993 16.4816 9.01464C16.8701 11.3438 14.5653 13.935 14.1425 14.5792C13.7465 15.1825 11.0808 17.9078 9.89184 11.2201C9.77992 10.5906 9.52464 9.05621 9.22685 7.03309C9.05749 5.88249 8.35454 5.27031 7.99796 5.27031C7.15495 5.27031 6.07725 5.91988 4.14249 7.78524C6.04712 7.67037 6.68738 10.0611 7.0586 11.4186C7.87446 14.4023 8.62936 19.474 10.6785 19.474C12.4048 19.474 15.1166 16.8281 18.0483 12.4354C18.2569 12.123 20.0142 9.41022 20.0142 7.39884C20.0142 5.00391 18.5451 5.00391 18.0011 5.00391Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$701a8f7034e13ba3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 4H23V6H1V4ZM1 18H23V20H1V18ZM19.6217 14.9136L19.448 14.0436L17.4994 14.0435L17.1899 14.907L15.6275 14.9105C16.6316 12.5036 17.3767 10.7206 17.8628 9.56169C17.9898 9.25902 18.2156 9.10462 18.5482 9.10699C18.802 9.10888 19.2168 9.10912 19.7927 9.10771L21 14.9108L19.6217 14.9136ZM17.9376 12.8518H19.1936L18.7248 10.6715L17.9376 12.8518ZM7.87203 9.10561L9.44245 9.10764L7.01511 14.9136L5.42535 14.9129C4.88785 12.8424 4.49315 11.3073 4.24125 10.3076C4.16402 10.001 4.01042 9.787 3.71519 9.68577C3.45195 9.59551 3.01355 9.45594 2.4 9.26707V9.10771C3.54718 9.10757 4.38339 9.10757 4.90863 9.10771C5.34299 9.10784 5.59619 9.31703 5.67765 9.74655C5.75942 10.1779 5.96599 11.2743 6.29735 13.0359L7.87203 9.10561ZM11.5994 9.10765L10.3588 14.913L8.86434 14.9108C8.89383 14.7698 9.30682 12.8347 10.1033 9.10561L11.5994 9.10765ZM14.6307 9C15.0773 9 15.6405 9.13846 15.9652 9.26707L15.703 10.4706C15.41 10.3532 14.9284 10.1944 14.5228 10.2006C13.933 10.2097 13.569 10.4566 13.569 10.6936C13.569 11.0783 14.2015 11.272 14.8528 11.6929C15.5956 12.1729 15.6937 12.603 15.6845 13.0713C15.6739 14.0422 14.8528 15 13.12 15C12.3286 14.9882 12.0444 14.9219 11.3995 14.6936L11.6718 13.4376C12.3282 13.712 12.6066 13.7991 13.1675 13.7991C13.6816 13.7991 14.1229 13.5918 14.1267 13.2308C14.1294 12.974 13.972 12.847 13.395 12.5293C12.8181 12.2117 12.0095 11.7726 12.0199 10.8889C12.0332 9.75821 13.1066 9 14.6307 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8c06f1cd00897e24(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.2215 15.7683L21.9974 14.6431L19.4831 14.6431L19.0837 15.7599L17.0677 15.7643C18.3633 12.6514 19.3247 10.3455 19.952 8.84657C20.1159 8.45511 20.4072 8.25543 20.8364 8.25848C21.1638 8.26094 21.6991 8.26124 22.4421 8.25942L24 15.7648L22.2215 15.7683ZM20.0485 13.1018H21.6692L21.0642 10.2819L20.0485 13.1018ZM7.06069 8.2567L9.08703 8.25933L5.95498 15.7683L3.90367 15.7675C3.21013 13.0896 2.70084 11.1042 2.37581 9.81122C2.27616 9.4148 2.07796 9.13797 1.69702 9.00705C1.35736 8.89031 0.791683 8.7098 0 8.46553V8.25942C1.48023 8.25924 2.55921 8.25924 3.23694 8.25942C3.7974 8.25959 4.12411 8.53015 4.22922 9.08566C4.33473 9.6435 4.60127 11.0616 5.02884 13.3398L7.06069 8.2567ZM11.8702 8.25934L10.2695 15.7676L8.34108 15.7648C8.37914 15.5824 8.91202 13.0797 9.93972 8.2567L11.8702 8.25934ZM15.7815 8.12012C16.3578 8.12012 17.0846 8.2992 17.5035 8.46553L17.1652 10.0221C16.7871 9.87023 16.1657 9.66491 15.6424 9.67294C14.8813 9.68462 14.4117 10.004 14.4117 10.3105C14.4117 10.808 15.2277 11.0586 16.0681 11.603C17.0265 12.2237 17.1531 12.78 17.1412 13.3856C17.1277 14.6413 16.0681 15.8801 13.8322 15.8801C12.8111 15.8648 12.4444 15.7791 11.6122 15.4839L11.9637 13.8595C12.8106 14.2142 13.1698 14.327 13.8935 14.327C14.5569 14.327 15.1263 14.0589 15.1312 13.5919C15.1347 13.2598 14.9316 13.0955 14.1871 12.6847C13.4427 12.2739 12.3994 11.706 12.4128 10.5631C12.43 9.10074 13.815 8.12012 15.7815 8.12012Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2f3aa2d2e6218030(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.00098 3H5.00098L12.001 15L19.001 3H23.001L12.001 22L1.00098 3ZM9.66764 3L12.001 7L14.3343 3H18.3694L12.001 14L5.63256 3H9.66764Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$15e4a8dc0aa8ac98(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.31677 3L12.001 18L20.6852 3H23.001L12.001 22L1.00098 3H3.31677ZM7.65887 3L12.001 10.5L16.3431 3H18.6589L12.001 14.5L5.34308 3H7.65887Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c97245e80e3b72b2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.45777 18.1842C3.359 16.6765 2.00098 14.3996 2.00098 11.9073C2.00098 7.32269 6.47628 3.59961 12.001 3.59961C17.5257 3.59961 22.001 7.32269 22.001 11.9073C22.001 16.4919 17.5257 20.215 12.001 20.215C10.859 20.215 9.74789 20.0611 8.72937 19.7535C8.63678 19.7227 8.51332 19.7227 8.42073 19.7227C8.23554 19.7227 8.05036 19.7842 7.89604 19.8765L5.70468 21.1381C5.64295 21.1688 5.58122 21.1996 5.5195 21.1996C5.33431 21.1996 5.17999 21.0458 5.17999 20.8611C5.17999 20.7688 5.21085 20.7073 5.24172 20.615C5.27258 20.5842 5.55036 19.5688 5.70468 18.9535C5.70468 18.8919 5.73554 18.7996 5.73554 18.7381C5.73554 18.4919 5.64295 18.3073 5.45777 18.1842ZM8.66764 10.511C9.38493 10.511 9.95278 9.94286 9.95278 9.22518C9.95278 8.5075 9.38493 7.93934 8.66764 7.93934C7.95036 7.93934 7.3825 8.5075 7.3825 9.22518C7.3825 9.94286 7.95036 10.511 8.66764 10.511ZM15.3343 10.511C16.0516 10.511 16.6194 9.94286 16.6194 9.22518C16.6194 8.5075 16.0516 7.93934 15.3343 7.93934C14.617 7.93934 14.0492 8.5075 14.0492 9.22518C14.0492 9.94286 14.617 10.511 15.3343 10.511Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6bc79ea88eabb161(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.66725 11.5116C7.94997 11.5116 7.38211 10.9434 7.38211 10.2258C7.38211 9.50809 7.94997 8.93992 8.66725 8.93992C9.38454 8.93992 9.95239 9.50809 9.95239 10.2258C9.95239 10.9434 9.38454 11.5116 8.66725 11.5116ZM15.3339 11.5116C14.6166 11.5116 14.0488 10.9434 14.0488 10.2258C14.0488 9.50809 14.6166 8.93992 15.3339 8.93992C16.0512 8.93992 16.6191 9.50809 16.6191 10.2258C16.6191 10.9434 16.0512 11.5116 15.3339 11.5116ZM6.82289 19.2156L7.53841 18.7792C8.34812 18.2853 9.30697 18.0952 10.2438 18.2428C10.4553 18.2762 10.6292 18.3018 10.7634 18.3195C11.1696 18.3731 11.5828 18.4002 12.0006 18.4002C16.4213 18.4002 19.9006 15.3778 19.9006 11.8002C19.9006 8.2226 16.4213 5.2002 12.0006 5.2002C7.57986 5.2002 4.10059 8.2226 4.10059 11.8002C4.10059 13.1658 4.60024 14.4731 5.53227 15.5812C5.58056 15.6386 5.65277 15.718 5.74666 15.8157C6.54199 16.644 6.94301 17.7741 6.84765 18.9184L6.82289 19.2156ZM6.19286 21.9425C6.00989 22.0569 5.79484 22.109 5.57981 22.0911C5.02944 22.0452 4.62045 21.5619 4.66631 21.0115L4.85456 18.7523C4.90224 18.1802 4.70173 17.6151 4.30407 17.201C4.1819 17.0738 4.08111 16.963 4.0017 16.8685C2.80622 15.4472 2.10059 13.6953 2.10059 11.8002C2.10059 7.05055 6.53297 3.2002 12.0006 3.2002C17.4682 3.2002 21.9006 7.05055 21.9006 11.8002C21.9006 16.5498 17.4682 20.4002 12.0006 20.4002C11.4911 20.4002 10.9906 20.3668 10.5018 20.3023C10.3491 20.2821 10.1593 20.2542 9.93256 20.2185C9.46412 20.1447 8.9847 20.2397 8.57985 20.4866L6.19286 21.9425Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b8f66dc5d15d6cfb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.1937 3.18117C20.3555 2.71123 21.3487 3.16205 21.8663 4.45774C23.2592 7.94366 19.9988 21.1333 17.4407 21.1333C16.6131 21.1333 15.7836 20.4447 14.8173 19.2068C14.3818 18.6489 13.9272 17.9838 13.4597 17.2333C13.0858 16.6328 12.7182 16.0015 12.3651 15.3626L12.0001 14.6901L11.9825 14.722C11.5257 15.5772 11.0385 16.4327 10.5399 17.2333C10.0725 17.9838 9.61783 18.6489 9.18231 19.2068C8.21598 20.4447 7.38653 21.1333 6.55888 21.1333C4.00086 21.1333 0.740407 7.94366 2.13327 4.45778C2.6509 3.16204 3.64414 2.71123 4.80589 3.18117C5.6482 3.5219 6.57782 4.3366 7.61665 5.55703C8.23486 6.28331 8.88155 7.14336 9.54718 8.11022C10.2842 9.18072 11.0062 10.3255 11.6841 11.4699L12.0002 12.0085L12.3156 11.4699C12.8578 10.5544 13.4284 9.63861 14.0123 8.76083L14.4524 8.11022C15.1181 7.14336 15.7648 6.28331 16.383 5.55703C17.4218 4.3366 18.3514 3.5219 19.1937 3.18117ZM4.32415 4.35258C3.83357 4.15413 3.58079 4.26886 3.31915 4.92382C2.86195 6.06804 3.05394 8.9514 3.73172 12.1871L3.89027 12.9114L4.06441 13.6438C4.91993 17.1047 6.15077 19.8682 6.55888 19.8682C6.83822 19.8682 7.44795 19.362 8.17369 18.4323C8.57863 17.9136 9.00904 17.284 9.45462 16.5685C9.8163 15.9877 10.1733 15.3745 10.5167 14.7531L10.9319 13.9859L11.2802 13.315L10.916 12.6774L10.5842 12.1107C9.91996 10.9892 9.21275 9.86797 8.49374 8.82358C7.85084 7.88975 7.22921 7.06302 6.64196 6.37311C5.72617 5.29724 4.92611 4.59608 4.32415 4.35258ZM20.6804 4.92377C20.4188 4.26886 20.1661 4.15413 19.6755 4.35258C19.0735 4.59608 18.2735 5.29724 17.3577 6.37311C16.7704 7.06302 16.1488 7.88975 15.5059 8.82358C14.9307 9.6591 14.363 10.5438 13.8189 11.4384L13.2452 12.3998L12.7184 13.315L12.8991 13.6647L13.1443 14.1298C13.5889 14.9621 14.0628 15.7941 14.545 16.5685C14.9906 17.284 15.421 17.9136 15.8259 18.4323C16.5517 19.362 17.1614 19.8682 17.4407 19.8682C17.8488 19.8682 19.0797 17.1047 19.9352 13.6438L20.1094 12.9114C20.9137 9.3881 21.1715 6.1528 20.6804 4.92377Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$51fa53ba9315d7ac(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.6607 18.9641C6.61877 18.9147 6.56632 18.8464 6.5045 18.7545C6.2667 18.4009 5.99019 17.8492 5.70035 17.1274C5.12527 15.6952 4.56176 13.7552 4.16416 11.8007C3.76442 9.83556 3.54827 7.93245 3.62744 6.55749C3.66773 5.85789 3.77997 5.39553 3.90955 5.14053C3.93885 5.08288 3.96453 5.04507 3.98332 5.02166C3.9913 5.01173 3.99778 5.00472 4.00249 5C4.29419 5.00083 4.74151 5.16186 5.35824 5.65098C5.95837 6.12695 6.6084 6.82548 7.28541 7.68296C8.52093 9.24783 9.74868 11.2146 10.8369 13.009C10.6575 13.3241 10.4674 13.6685 10.2721 14.0226C10.1805 14.1886 10.0877 14.3568 9.99429 14.5251C9.57514 15.2801 9.13019 16.0616 8.66979 16.7698C8.20474 17.4853 7.75161 18.0822 7.3264 18.4904C7.02581 18.7788 6.80541 18.9093 6.6607 18.9641ZM12.0002 11.0762C11.0381 9.51354 9.95752 7.83986 8.85513 6.44361C8.1338 5.53 7.37382 4.69689 6.60102 4.08398C5.8464 3.4855 4.9586 3 4.00024 3C3.07752 3 2.46447 3.56952 2.12656 4.23447C1.8115 4.85447 1.67684 5.64211 1.63075 6.44251C1.53717 8.06755 1.79036 10.1644 2.2043 12.1993C2.62038 14.2448 3.21487 16.3048 3.84438 17.8726C4.15683 18.6508 4.49426 19.3491 4.84482 19.8705C5.01895 20.1295 5.22203 20.3838 5.45774 20.5834C5.68336 20.7745 6.03975 21 6.50023 21C7.39472 21 8.14787 20.4741 8.7113 19.9333C9.29983 19.3684 9.8507 18.6228 10.3466 17.8599C10.8472 17.0898 11.3203 16.2571 11.7429 15.4958C11.8284 15.3418 11.9114 15.1916 11.9919 15.0457C12 15.0606 12.008 15.0757 12.0161 15.0907C12.0845 15.2186 12.1548 15.3497 12.2269 15.4839C12.6352 16.2436 13.093 17.0787 13.584 17.8512C14.0705 18.6168 14.6191 19.3686 15.2225 19.9387C15.8116 20.4953 16.5815 21 17.5002 21C17.9607 21 18.3171 20.7745 18.5427 20.5834C18.7784 20.3838 18.9815 20.1295 19.1556 19.8705C19.5062 19.3492 19.8436 18.6508 20.1561 17.8726C20.7856 16.3049 21.3802 14.2448 21.7963 12.1993C22.2102 10.1645 22.4635 8.06756 22.3699 6.44252C22.3238 5.64211 22.1892 4.85447 21.8741 4.23447C21.5362 3.5695 20.9231 3 20.0004 3C19.042 3 18.1542 3.48548 17.3995 4.08397C16.6267 4.69687 15.8667 5.52998 15.1453 6.4436C14.0429 7.83985 12.9623 9.51354 12.0002 11.0762ZM13.1622 13.0111C14.2508 11.2161 15.479 9.24844 16.715 7.68297C17.3921 6.8255 18.0421 6.12696 18.6423 5.651C19.259 5.16187 19.7064 5.00082 19.9982 5C20.0029 5.00471 20.0093 5.01173 20.0173 5.02167C20.0361 5.04507 20.0618 5.08288 20.0911 5.14053C20.2207 5.39552 20.3329 5.85789 20.3732 6.55748C20.4524 7.93244 20.2362 9.83555 19.8364 11.8006C19.4388 13.7552 18.8753 15.6951 18.3001 17.1274C18.0103 17.8492 17.7338 18.4008 17.496 18.7545C17.4304 18.852 17.3754 18.9229 17.3322 18.9729C17.1588 18.9214 16.9153 18.7865 16.596 18.4849C16.1696 18.0821 15.7249 17.4913 15.2719 16.7785C14.8233 16.0726 14.3952 15.2935 13.9885 14.537C13.9214 14.4121 13.8545 14.2872 13.7881 14.163C13.5732 13.7617 13.3626 13.3683 13.1622 13.0111Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$122f29013b5f3dd6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5753 13.7114C19.0742 13.7114 19.4733 13.2873 19.4733 12.8134C19.4733 12.3145 19.0742 11.9155 18.5753 11.9155C18.0765 11.9155 17.6774 12.3145 17.6774 12.8134C17.6774 13.3123 18.0765 13.7114 18.5753 13.7114ZM14.1497 13.7114C14.6485 13.7114 15.0476 13.2873 15.0476 12.8134C15.0476 12.3145 14.6485 11.9155 14.1497 11.9155C13.6508 11.9155 13.2517 12.3145 13.2517 12.8134C13.2517 13.3123 13.6508 13.7114 14.1497 13.7114ZM20.717 18.7516C20.5942 18.8253 20.5205 18.9482 20.5451 19.1202C20.5451 19.1693 20.5451 19.2185 20.5696 19.2676C20.6679 19.6854 20.8643 20.349 20.8643 20.3736C20.8643 20.4473 20.8889 20.4964 20.8889 20.5456C20.8889 20.6685 20.7907 20.7668 20.6679 20.7668C20.6187 20.7668 20.5942 20.7422 20.5451 20.7176L19.0961 19.882C18.9978 19.8329 18.875 19.7837 18.7522 19.7837C18.6786 19.7837 18.6049 19.7837 18.5558 19.8083C17.8681 20.0049 17.1559 20.1032 16.3946 20.1032C12.7352 20.1032 9.78815 17.6456 9.78815 14.5983C9.78815 11.5509 12.7352 9.09329 16.3946 9.09329C20.0539 9.09329 23.001 11.5509 23.001 14.5983C23.001 16.2448 22.1168 17.7439 20.717 18.7516ZM16.6737 8.09757C16.581 8.09473 16.488 8.09329 16.3946 8.09329C12.2199 8.09329 8.78815 10.9536 8.78815 14.5983C8.78815 15.1519 8.86733 15.6874 9.01626 16.1975H8.92711C8.04096 16.1975 7.15481 16.0503 6.3425 15.8296C6.26866 15.805 6.19481 15.805 6.12097 15.805C5.97327 15.805 5.82558 15.8541 5.7025 15.9277L3.95482 16.9334C3.90559 16.958 3.85635 16.9825 3.80712 16.9825C3.65943 16.9825 3.53636 16.8599 3.53636 16.7127C3.53636 16.6391 3.56097 16.59 3.58559 16.5164C3.6102 16.4919 3.83174 15.6824 3.95482 15.1918C3.95482 15.1427 3.97943 15.0691 3.97943 15.0201C3.97943 14.8238 3.88097 14.6766 3.75789 14.5785C2.05944 13.3765 1.00098 11.5858 1.00098 9.59876C1.00098 5.94369 4.5702 3 8.95173 3C12.7157 3 15.8802 5.16856 16.6737 8.09757ZM11.5199 8.51604C12.0927 8.51604 12.5462 8.03871 12.5462 7.4898C12.5462 6.91701 12.0927 6.46356 11.5199 6.46356C10.9471 6.46356 10.4937 6.91701 10.4937 7.4898C10.4937 8.06258 10.9471 8.51604 11.5199 8.51604ZM6.26045 8.51604C6.83324 8.51604 7.28669 8.03871 7.28669 7.4898C7.28669 6.91701 6.83324 6.46356 6.26045 6.46356C5.68767 6.46356 5.23421 6.91701 5.23421 7.4898C5.23421 8.06258 5.68767 8.51604 6.26045 8.51604Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8a4b258c681d21ee(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.0014 14.6759C10.0011 14.6553 10.001 14.6347 10.001 14.6141C10.001 12.1058 12.0175 9.99588 14.7539 9.38116C14.3904 7.07897 11.9602 5.2002 8.90098 5.2002C5.58037 5.2002 3.00098 7.41369 3.00098 9.97954C3.00098 10.9489 3.36131 11.8803 4.04082 12.6783C4.0728 12.7159 4.12443 12.772 4.19342 12.8429C4.78537 13.4519 5.13709 14.2459 5.19546 15.0807C5.90857 14.6685 6.74285 14.5125 7.55832 14.6394C7.72416 14.6652 7.85986 14.685 7.96345 14.6985C8.27111 14.7386 8.58419 14.7589 8.90098 14.7589C9.27825 14.7589 9.64595 14.7303 10.0014 14.6759ZM10.4581 16.6272C9.95467 16.7136 9.43399 16.7589 8.90098 16.7589C8.49441 16.7589 8.09502 16.7325 7.70499 16.6817C7.58312 16.6658 7.4317 16.6438 7.25073 16.6156C6.87693 16.5575 6.49436 16.6324 6.1713 16.827L4.26653 17.9747C4.12052 18.0649 3.94891 18.1059 3.77733 18.0918C3.33814 18.0557 3.01178 17.6746 3.04837 17.2408L3.19859 15.4599C3.23664 15.0089 3.07664 14.5634 2.75931 14.237C2.66182 14.1367 2.5814 14.0493 2.51802 13.9749C1.56406 12.8545 1.00098 11.4734 1.00098 9.97954C1.00098 6.23541 4.53793 3.2002 8.90098 3.2002C12.9601 3.2002 16.3041 5.82724 16.7504 9.20813C20.1225 9.36161 22.801 11.7232 22.801 14.6141C22.801 15.8071 22.3448 16.9099 21.572 17.8047C21.5206 17.8641 21.4555 17.9339 21.3765 18.014C21.1194 18.2747 20.9898 18.6304 21.0206 18.9906L21.1423 20.4127C21.172 20.7592 20.9076 21.0635 20.5518 21.0924C20.4128 21.1036 20.2738 21.0708 20.1555 20.9988L18.6124 20.0823C18.3506 19.9269 18.0407 19.867 17.7379 19.9135C17.5913 19.936 17.4686 19.9536 17.3699 19.9663C17.0539 20.0069 16.7303 20.0279 16.401 20.0279C13.7074 20.0279 11.4025 18.6203 10.4581 16.6272ZM17.4346 17.9366C18.0019 17.8496 18.5793 17.9112 19.1105 18.1113C19.2492 17.5506 19.5373 17.0307 19.9524 16.6097C20.0027 16.5587 20.0388 16.5201 20.0584 16.4973C20.5467 15.9321 20.801 15.2841 20.801 14.6141C20.801 12.8097 18.8983 11.2002 16.401 11.2002C13.9037 11.2002 12.001 12.8097 12.001 14.6141C12.001 16.4184 13.9037 18.0279 16.401 18.0279C16.6424 18.0279 16.8809 18.0127 17.115 17.9826C17.1957 17.9722 17.3029 17.9568 17.4346 17.9366Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2e858d61eeebb035(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.27099 14.6689C8.9532 14.8312 8.56403 14.7122 8.39132 14.4L8.3477 14.3054L6.53019 10.3069C6.52269 10.2588 6.52269 10.2097 6.53019 10.1615C6.53017 10.0735 6.56564 9.98916 6.62857 9.9276C6.6915 9.86603 6.7766 9.83243 6.86462 9.83438C6.93567 9.83269 7.00508 9.85582 7.06091 9.89981L9.24191 11.4265C9.40329 11.5346 9.59293 11.5928 9.78716 11.5937C9.90424 11.5945 10.0203 11.5723 10.1289 11.5283L20.176 7.02816C18.091 4.72544 15.1103 3.43931 12.0045 3.5022C6.4793 3.5022 2.00098 7.23172 2.00098 11.87C2.06681 14.4052 3.35646 16.7515 5.4615 18.1658C5.6878 18.3326 5.78402 18.6241 5.70141 18.8928L5.25067 20.594C5.22336 20.6714 5.20625 20.7521 5.19978 20.8339C5.19777 20.9232 5.23236 21.0094 5.29552 21.0726C5.35868 21.1358 5.44491 21.1703 5.5342 21.1684C5.60098 21.1645 5.66583 21.1445 5.72322 21.1102L7.90423 19.8452C8.06383 19.7467 8.2474 19.6939 8.43494 19.6925C8.53352 19.6923 8.63157 19.707 8.72574 19.7361C9.78781 20.0363 10.8863 20.188 11.99 20.1869C17.5152 20.1869 22.001 16.4574 22.001 11.8554C22.0108 10.4834 21.6301 9.13687 20.903 7.97326L9.35096 14.6253L9.27099 14.6689Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d5328d12f0f59d10(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.1458 8.99349L9.34705 14.6009L9.27753 14.6468C9.18483 14.6927 9.09213 14.7157 8.97625 14.7157C8.72133 14.7157 8.51275 14.5779 8.39688 14.3712L8.35053 14.2793L6.51971 10.3292C6.49653 10.2833 6.49653 10.2373 6.49653 10.1914C6.49653 10.0077 6.63558 9.86988 6.82098 9.86988C6.8905 9.86988 6.96003 9.89285 7.02955 9.93878L9.18483 11.4545C9.34705 11.5464 9.53245 11.6153 9.74103 11.6153C9.8569 11.6153 9.97278 11.5923 10.0887 11.5464L18.3634 7.8977C16.9347 6.27337 14.6348 5.2002 12.0006 5.2002C7.57986 5.2002 4.10059 8.2226 4.10059 11.8002C4.10059 13.1658 4.60024 14.4731 5.53227 15.5812C5.58056 15.6386 5.65277 15.718 5.74666 15.8157C6.54199 16.644 6.94301 17.7741 6.84765 18.9184L6.82289 19.2156L7.53841 18.7792C8.34812 18.2853 9.30697 18.0952 10.2438 18.2428C10.4553 18.2762 10.6292 18.3018 10.7634 18.3195C11.1696 18.3731 11.5828 18.4002 12.0006 18.4002C16.4213 18.4002 19.9006 15.3778 19.9006 11.8002C19.9006 10.8038 19.6307 9.85046 19.1458 8.99349ZM6.19286 21.9425C6.00989 22.0569 5.79484 22.109 5.57981 22.0911C5.02944 22.0452 4.62045 21.5619 4.66631 21.0115L4.85456 18.7523C4.90224 18.1802 4.70173 17.6151 4.30407 17.201C4.1819 17.0738 4.08111 16.963 4.0017 16.8685C2.80622 15.4472 2.10059 13.6953 2.10059 11.8002C2.10059 7.05055 6.53297 3.2002 12.0006 3.2002C17.4682 3.2002 21.9006 7.05055 21.9006 11.8002C21.9006 16.5498 17.4682 20.4002 12.0006 20.4002C11.4911 20.4002 10.9906 20.3668 10.5018 20.3023C10.3491 20.2821 10.1593 20.2542 9.93256 20.2185C9.46412 20.1447 8.9847 20.2397 8.57985 20.4866L6.19286 21.9425Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4c75b7efd0bcd0d7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.27799 8.59201C7.05085 5.8217 10.282 4.55876 11.4966 5.77587C12.0338 6.31312 12.0848 7.23996 11.741 8.34757C11.5628 8.9052 12.2655 8.5971 12.2655 8.5971C14.5062 7.66008 16.4618 7.60407 17.1747 8.62511C17.5541 9.16746 17.5184 9.93133 17.1671 10.8149C17.0041 11.2223 17.2154 11.2859 17.5261 11.3776C18.789 11.7697 20.1945 12.7144 20.1945 14.3822C20.1945 17.1448 16.2148 20.6205 10.2311 20.6205C5.66569 20.6205 1.00098 18.4078 1.00098 14.7692C1.00098 12.8671 2.20535 10.6672 4.27799 8.59201ZM16.4108 14.3338C16.174 11.9429 13.0294 10.2954 9.38829 10.657C5.74717 11.016 2.9845 13.2465 3.2213 15.6375C3.4581 18.0309 6.60271 19.6758 10.2438 19.3168C13.885 18.9552 16.6451 16.7247 16.4108 14.3338ZM6.16221 14.4382C6.91589 12.9104 8.87395 12.0473 10.6079 12.4979C12.4005 12.9614 13.3146 14.6521 12.5838 16.2969C11.8403 17.98 9.70148 18.8763 7.88856 18.2906C6.13674 17.7254 5.39579 15.9965 6.16221 14.4382ZM8.8765 15.0162C8.31378 14.7794 7.58556 15.0238 7.23672 15.5687C6.88279 16.1162 7.0483 16.7705 7.60847 17.0252C8.17628 17.2823 8.93252 17.0379 9.2839 16.4752C9.63019 15.9074 9.44686 15.2581 8.8765 15.0162ZM10.2642 14.4382C10.0478 14.3542 9.77787 14.456 9.65056 14.6699C9.52834 14.8838 9.59709 15.1282 9.81352 15.2173C10.0325 15.309 10.3151 15.2046 10.4424 14.9856C10.5647 14.7666 10.4857 14.5197 10.2642 14.4382ZM15.9576 2.92408C17.9258 2.50649 20.0545 3.12017 21.5008 4.71918C22.947 6.31822 23.3341 8.50034 22.7204 10.4228C22.5796 10.8639 22.1036 11.1075 21.6612 10.9626C21.2181 10.8174 20.9762 10.3438 21.1188 9.90078C21.5568 8.54108 21.2806 6.98652 20.2531 5.84971C19.2244 4.71154 17.712 4.27613 16.3115 4.57404C15.8558 4.67099 15.41 4.37994 15.3109 3.92475C15.2115 3.46897 15.5018 3.02078 15.9576 2.92408ZM16.584 5.84971C17.5414 5.64601 18.5802 5.94392 19.283 6.72307C19.9858 7.50222 20.1742 8.56655 19.8737 9.49847C19.7511 9.87865 19.3409 10.089 18.9596 9.96443C18.5777 9.83967 18.3714 9.43227 18.4962 9.04779C18.6464 8.59201 18.5522 8.07258 18.2085 7.69064C17.8622 7.31125 17.3555 7.16611 16.887 7.26542C16.4949 7.35199 16.1104 7.09991 16.0263 6.71034C15.9423 6.31822 16.1917 5.93316 16.584 5.84971Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9b3ca3c0d6f4f175(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.1945 14.1973C20.1945 17.5586 15.6658 20.6206 10.2693 20.6206C5.31907 20.6206 1.00098 18.1885 1.00098 14.5338C1.00098 12.5873 2.1808 10.447 4.24042 8.44571C7.0727 5.69957 10.4695 4.41277 12.0994 5.99781C12.5966 6.48041 12.8225 7.11988 12.8178 7.85577C14.7934 7.28031 16.4689 7.45174 17.3006 8.60768C17.7497 9.2307 17.8332 9.98744 17.6268 10.8152C19.1382 11.4259 20.1945 12.5847 20.1945 14.1973ZM15.755 12.1279C15.3691 11.7166 15.3549 11.2078 15.5572 10.7169C15.7655 10.2087 15.7701 9.90467 15.6776 9.77646C15.4134 9.40925 14.1443 9.41428 12.4833 10.0883C12.4306 10.1106 12.3609 10.1367 12.2765 10.1623C12.1789 10.1917 12.0794 10.2147 11.9744 10.2286C11.6296 10.274 11.3028 10.2293 10.9913 9.96287C10.572 9.60419 10.5175 9.10776 10.6694 8.64655C10.8835 7.97702 10.8482 7.57054 10.7057 7.43232C10.5197 7.25137 9.92883 7.24087 9.04745 7.57477C7.97823 7.97981 6.74875 8.79941 5.63339 9.88084C3.92586 11.54 3.00098 13.2178 3.00098 14.5338C3.00098 16.7755 6.27688 18.6206 10.2693 18.6206C14.6892 18.6206 18.1945 16.2506 18.1945 14.1973C18.1945 13.4588 17.558 12.8585 16.5218 12.5446C16.1276 12.4316 15.9855 12.3736 15.755 12.1279ZM22.8091 10.5099C22.6705 11.0445 22.1247 11.3655 21.5901 11.2268C21.0555 11.0882 20.7345 10.5424 20.8732 10.0078C20.9577 9.68188 21.001 9.34424 21.001 9C21.001 6.79086 19.2101 5 17.001 5C16.7223 5 16.448 5.02834 16.1806 5.08401C15.6399 5.19657 15.1103 4.84949 14.9977 4.3088C14.8852 3.76811 15.2323 3.23854 15.773 3.12599C16.1743 3.04244 16.5852 3 17.001 3C20.3147 3 23.001 5.68629 23.001 9C23.001 9.514 22.9361 10.0203 22.8091 10.5099Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$373ec1f124d64401(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22C10.1671 22 8.44851 21.5064 6.97086 20.6447L2.00516 22L3.35712 17.0315C2.49494 15.5536 2.00098 13.8345 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2ZM8.59339 7.30019L8.39232 7.30833C8.26293 7.31742 8.13607 7.34902 8.02057 7.40811C7.93392 7.45244 7.85348 7.51651 7.72709 7.63586C7.60774 7.74855 7.53857 7.84697 7.46569 7.94186C7.09599 8.4232 6.89729 9.01405 6.90098 9.62098C6.90299 10.1116 7.03043 10.5884 7.23169 11.0336C7.63982 11.9364 8.31288 12.8908 9.20194 13.7759C9.4155 13.9885 9.62473 14.2034 9.85034 14.402C10.9538 15.3736 12.2688 16.0742 13.6907 16.4482C13.6907 16.4482 14.2507 16.5342 14.2589 16.5347C14.4444 16.5447 14.6296 16.5313 14.8153 16.5218C15.1066 16.5068 15.391 16.428 15.6484 16.2909C15.8139 16.2028 15.8922 16.159 16.0311 16.0714C16.0311 16.0714 16.0737 16.0426 16.1559 15.9814C16.2909 15.8808 16.3743 15.81 16.4866 15.6934C16.5694 15.6074 16.6406 15.5058 16.6956 15.3913C16.7738 15.2281 16.8525 14.9166 16.8838 14.6579C16.9077 14.4603 16.9005 14.3523 16.8979 14.2854C16.8936 14.1778 16.8047 14.0671 16.7073 14.0201L16.1258 13.7587C16.1258 13.7587 15.2563 13.3803 14.7245 13.1377C14.6691 13.1124 14.6085 13.1007 14.5476 13.097C14.4142 13.0888 14.2647 13.1236 14.1696 13.2238C14.1646 13.2218 14.0984 13.279 13.3749 14.1555C13.335 14.2032 13.2415 14.3069 13.0798 14.2972C13.0554 14.2955 13.0311 14.292 13.0074 14.2858C12.9419 14.2685 12.8781 14.2457 12.8157 14.2193C12.692 14.1668 12.6486 14.1469 12.5641 14.1105C11.9868 13.8583 11.457 13.5209 10.9887 13.108C10.8631 12.9974 10.7463 12.8783 10.6259 12.7616C10.2057 12.3543 9.86169 11.9211 9.60577 11.4938C9.5918 11.4705 9.57027 11.4368 9.54708 11.3991C9.50521 11.331 9.45903 11.25 9.44455 11.1944C9.40738 11.0473 9.50599 10.9291 9.50599 10.9291C9.50599 10.9291 9.74939 10.663 9.86248 10.5183C9.97128 10.379 10.0652 10.2428 10.125 10.1457C10.2428 9.95633 10.2801 9.76062 10.2182 9.60963C9.93764 8.92565 9.64818 8.24536 9.34986 7.56894C9.29098 7.43545 9.11585 7.33846 8.95659 7.32007C8.90265 7.31384 8.84875 7.30758 8.79459 7.30402C8.66053 7.29748 8.5262 7.29892 8.39232 7.30833L8.59339 7.30019Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5cc89cd73ffdff26(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.25361 18.4944L7.97834 18.917C9.18909 19.623 10.5651 20 12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 13.4363 4.37821 14.8128 5.08466 16.0238L5.50704 16.7478L4.85355 19.1494L7.25361 18.4944ZM2.00516 22L3.35712 17.0315C2.49494 15.5536 2.00098 13.8345 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22C10.1671 22 8.44851 21.5064 6.97086 20.6447L2.00516 22ZM8.39232 7.30833C8.5262 7.29892 8.66053 7.29748 8.79459 7.30402C8.84875 7.30758 8.90265 7.31384 8.95659 7.32007C9.11585 7.33846 9.29098 7.43545 9.34986 7.56894C9.64818 8.24536 9.93764 8.92565 10.2182 9.60963C10.2801 9.76062 10.2428 9.95633 10.125 10.1457C10.0652 10.2428 9.97128 10.379 9.86248 10.5183C9.74939 10.663 9.50599 10.9291 9.50599 10.9291C9.50599 10.9291 9.40738 11.0473 9.44455 11.1944C9.45903 11.25 9.50521 11.331 9.54708 11.3991C9.57027 11.4368 9.5918 11.4705 9.60577 11.4938C9.86169 11.9211 10.2057 12.3543 10.6259 12.7616C10.7463 12.8783 10.8631 12.9974 10.9887 13.108C11.457 13.5209 11.9868 13.8583 12.559 14.1082L12.5641 14.1105C12.6486 14.1469 12.692 14.1668 12.8157 14.2193C12.8781 14.2457 12.9419 14.2685 13.0074 14.2858C13.0311 14.292 13.0554 14.2955 13.0798 14.2972C13.2415 14.3069 13.335 14.2032 13.3749 14.1555C14.0984 13.279 14.1646 13.2218 14.1696 13.2222V13.2238C14.2647 13.1236 14.4142 13.0888 14.5476 13.097C14.6085 13.1007 14.6691 13.1124 14.7245 13.1377C15.2563 13.3803 16.1258 13.7587 16.1258 13.7587L16.7073 14.0201C16.8047 14.0671 16.8936 14.1778 16.8979 14.2854C16.9005 14.3523 16.9077 14.4603 16.8838 14.6579C16.8525 14.9166 16.7738 15.2281 16.6956 15.3913C16.6406 15.5058 16.5694 15.6074 16.4866 15.6934C16.3743 15.81 16.2909 15.8808 16.1559 15.9814C16.0737 16.0426 16.0311 16.0714 16.0311 16.0714C15.8922 16.159 15.8139 16.2028 15.6484 16.2909C15.391 16.428 15.1066 16.5068 14.8153 16.5218C14.6296 16.5313 14.4444 16.5447 14.2589 16.5347C14.2507 16.5342 13.6907 16.4482 13.6907 16.4482C12.2688 16.0742 10.9538 15.3736 9.85034 14.402C9.62473 14.2034 9.4155 13.9885 9.20194 13.7759C8.31288 12.8908 7.63982 11.9364 7.23169 11.0336C7.03043 10.5884 6.90299 10.1116 6.90098 9.62098C6.89729 9.01405 7.09599 8.4232 7.46569 7.94186C7.53857 7.84697 7.60774 7.74855 7.72709 7.63586C7.85348 7.51651 7.93392 7.45244 8.02057 7.40811C8.13607 7.34902 8.26293 7.31742 8.39232 7.30833Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7e5ad58df9891a6e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00098 5.47902L10.3778 4.4625V11.5902H3.00098V5.47902ZM3.00098 18.521L10.3778 19.5375V12.4982H3.00098V18.521ZM11.1894 19.646L21.001 21V12.4982H11.1894V19.646ZM11.1894 4.35402V11.5902H21.001V3L11.1894 4.35402Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fd4d516717178751(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.001 2.5V21.5L3.00098 19.5V4.5L21.001 2.5ZM19.001 12.999L12.001 13V18.487L19.001 19.2655V12.999ZM5.00098 17.7099L10.001 18.265V13L5.00098 12.999V17.7099ZM19.001 10.999V4.73453L12.001 5.512V11L19.001 10.999ZM10.001 5.734L5.00098 6.29009V10.999L10.001 11V5.734Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a1bb8dbc8bcfb968(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.32308 12C3.32308 15.4385 5.32308 18.4 8.21538 19.8077L4.07692 8.46923C3.57998 9.57999 3.3231 10.7831 3.32308 12ZM12 20.6769C13.0077 20.6769 13.9769 20.5 14.8846 20.1846L14.8231 20.0692L12.1538 12.7615L9.55385 20.3231C10.3231 20.5538 11.1462 20.6769 12 20.6769ZM13.1923 7.93077L16.3308 17.2615L17.2 14.3692C17.5692 13.1692 17.8538 12.3077 17.8538 11.5615C17.8538 10.4846 17.4692 9.74615 17.1462 9.17692C16.7 8.45385 16.2923 7.84615 16.2923 7.13846C16.2923 6.33846 16.8923 5.6 17.7538 5.6H17.8615C16.2627 4.13224 14.1704 3.31946 12 3.32308C10.5629 3.32281 9.14834 3.67979 7.88347 4.3619C6.61861 5.04402 5.54315 6.02987 4.75385 7.23077L5.30769 7.24615C6.21538 7.24615 7.61539 7.13077 7.61539 7.13077C8.09231 7.10769 8.14615 7.79231 7.67692 7.84615C7.67692 7.84615 7.20769 7.90769 6.67692 7.93077L9.84615 17.3308L11.7462 11.6385L10.3923 7.93077C10.0891 7.91404 9.78636 7.88838 9.48462 7.85385C9.01538 7.82308 9.06923 7.10769 9.53846 7.13077C9.53846 7.13077 10.9692 7.24615 11.8231 7.24615C12.7308 7.24615 14.1308 7.13077 14.1308 7.13077C14.6 7.10769 14.6615 7.79231 14.1923 7.84615C14.1923 7.84615 13.7231 7.9 13.1923 7.93077ZM16.3615 19.5C17.6742 18.7368 18.7636 17.6424 19.5208 16.3263C20.2781 15.0102 20.6767 13.5184 20.6769 12C20.6769 10.4923 20.2923 9.07692 19.6154 7.83846C19.7529 9.20099 19.5466 10.5762 19.0154 11.8385L16.3615 19.5ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5cd4344be1da31f7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM14.6059 19.566L12.4512 13.5807L10.27 19.8125C10.8271 19.9353 11.406 20 12 20C12.9124 20 13.789 19.8473 14.6059 19.566ZM17.0741 18.1853C18.8605 16.7181 20 14.4921 20 12C20 10.9742 19.8069 9.99354 19.4552 9.09231C19.2048 10.5459 18.7629 12.4415 18.4794 13.4073L17.0741 18.1853ZM16.8726 5.65461C15.5233 4.61695 13.8337 4 12 4C9.47362 4 7.22075 5.17108 5.75463 7H7.14502V9H6.39547L9.15016 16.958L11.3768 10.5962L10.8021 9H8.64502L8.64505 7H13.6451L13.645 9H12.9278L15.5492 16.2817L16.5606 12.8429C17.0844 11.0096 16.653 10.2107 16.2222 9.41327C15.9334 8.87865 15.645 8.34466 15.645 7.5C15.645 6.66923 16.1515 5.95677 16.8726 5.65461ZM4.42479 9.42105C4.14939 10.2302 4 11.0977 4 12C4 14.8098 5.44856 17.2813 7.63963 18.7084L4.42479 9.42105Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c4e5e5fafa875a1e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.41931 19.5275C7.17681 21.0675 9.48181 22 12.001 22C14.5226 22 16.8251 21.0675 18.586 19.5275C20.1501 17.9342 14.9893 12.27 12.001 10.0133C9.01598 12.27 3.85181 17.9342 5.41931 19.5275ZM14.7193 7.5225C16.8026 9.99 20.956 16.1167 19.7826 18.2825C21.1693 16.5667 22.001 14.3842 22.001 12.0033C22.001 9.22 20.8635 6.70167 19.026 4.89C19.026 4.89 19.0035 4.87167 18.9576 4.855C18.9051 4.83667 18.831 4.8175 18.7235 4.8175C18.2301 4.8175 17.0693 5.17917 14.7193 7.5225ZM5.04598 4.855C4.99848 4.87167 4.97764 4.88917 4.97431 4.89C3.13848 6.70167 2.00098 9.22 2.00098 12.0033C2.00098 14.3817 2.83264 16.5642 4.21848 18.2808C3.05098 16.11 7.20098 9.98833 9.28514 7.5225C6.93514 5.17833 5.77181 4.81833 5.28014 4.81833C5.17098 4.81833 5.09431 4.83583 5.04598 4.85667V4.855ZM12.001 4.95917C12.001 4.95917 9.54681 3.52333 7.63014 3.455C6.87764 3.4275 6.41848 3.70083 6.36264 3.7375C8.15014 2.53833 10.0501 2 11.9876 2H12.001C13.946 2 15.8385 2.53833 17.6393 3.7375C17.5826 3.69917 17.1268 3.4275 16.3726 3.455C14.456 3.52333 12.001 4.95417 12.001 4.95417V4.95917Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d0f31b150e855522(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.79792 15.485C5.9215 12.9646 7.99755 10.0459 9.28514 8.5225C8.03654 7.277 7.12294 6.59163 6.46709 6.22278C4.94728 7.67896 4.00098 9.72897 4.00098 12C4.00098 13.2492 4.28731 14.4316 4.79792 15.485ZM8.84911 4.64483C10.4487 5.05101 12.001 5.95917 12.001 5.95917V5.95417C12.001 5.95417 13.5529 5.04965 15.1523 4.64461C14.1853 4.22973 13.1199 4 12.001 4C10.8818 4 9.81631 4.22982 8.84911 4.64483ZM17.5353 6.22317C16.8799 6.59249 15.9673 7.27806 14.7193 8.5225C16.0056 10.046 18.0809 12.9643 19.2045 15.484C19.7148 14.4309 20.001 13.2488 20.001 12C20.001 9.72917 19.0548 7.67933 17.5353 6.22317ZM17.9431 17.3565C16.5404 15.1202 13.8533 12.4122 12.001 11.0133C10.1504 12.4124 7.46222 15.1211 6.05981 17.3576C7.52394 18.9802 9.64336 20 12.001 20C14.3591 20 16.479 18.9797 17.9431 17.3565ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3ca2fff43a2d0dd9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.4619 3.23047C20.6158 3.23047 20.7696 3.30739 20.8465 3.38432C20.9235 3.53816 20.9235 3.69201 20.8465 3.84585L14.7696 14.6151L18.6158 21.692C18.6927 21.8459 18.6927 21.9997 18.6158 22.1535C18.5388 22.2305 18.385 22.3074 18.2311 22.3074H15.4619C15.0773 22.3074 14.8465 21.9997 14.6927 21.7689L10.7696 14.6151C11.0004 14.3074 16.9235 3.76893 16.9235 3.76893C17.0773 3.46124 17.3081 3.23047 17.6927 3.23047H20.4619ZM8.92345 6.9997C9.30807 6.9997 9.53884 7.30739 9.69268 7.53816L11.6158 10.8459C11.4619 10.9997 8.61576 16.0766 8.61576 16.0766C8.46191 16.3074 8.23114 16.6151 7.84653 16.6151H5.15422C5.00038 16.6151 4.84653 16.5382 4.76961 16.4612C4.69268 16.3074 4.69268 16.1535 4.76961 15.9997L7.61576 10.8459L5.76961 7.61508C5.69268 7.46124 5.69268 7.30739 5.76961 7.15355C5.84653 7.07662 6.00038 6.9997 6.15422 6.9997H8.92345Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$86f3d1ad2560cf3a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.4443 3.5L13.8099 14.9901L17.8573 22H15.5473L11.5021 14.9914L11.5003 14.9904L18.1343 3.5H20.4443ZM8.31033 7L10.7324 11.1962L10.7305 11.1973L7.66933 16.5H5.36133L8.42215 11.1951L6.00133 7H8.31033Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c8a69b9e36b08ff3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.2439 4C12.778 4.00294 14.1143 4.01586 15.5341 4.07273L16.0375 4.09468C17.467 4.16236 18.8953 4.27798 19.6037 4.4755C20.5486 4.74095 21.2913 5.5155 21.5423 6.49732C21.942 8.05641 21.992 11.0994 21.9982 11.8358L21.9991 11.9884L21.9991 11.9991C21.9991 11.9991 21.9991 12.0028 21.9991 12.0099L21.9982 12.1625C21.992 12.8989 21.942 15.9419 21.5423 17.501C21.2878 18.4864 20.5451 19.261 19.6037 19.5228C18.8953 19.7203 17.467 19.8359 16.0375 19.9036L15.5341 19.9255C14.1143 19.9824 12.778 19.9953 12.2439 19.9983L12.0095 19.9991L11.9991 19.9991C11.9991 19.9991 11.9956 19.9991 11.9887 19.9991L11.7545 19.9983C10.6241 19.9921 5.89772 19.941 4.39451 19.5228C3.4496 19.2573 2.70692 18.4828 2.45587 17.501C2.0562 15.9419 2.00624 12.8989 2 12.1625V11.8358C2.00624 11.0994 2.0562 8.05641 2.45587 6.49732C2.7104 5.51186 3.45308 4.73732 4.39451 4.4755C5.89772 4.05723 10.6241 4.00622 11.7545 4H12.2439ZM9.99911 8.49914V15.4991L15.9991 11.9991L9.99911 8.49914Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3db7c25a2d261f67(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.6069 6.99482C19.5307 6.69695 19.3152 6.47221 19.0684 6.40288C18.6299 6.28062 16.501 6 12.001 6C7.50098 6 5.37252 6.28073 4.93225 6.40323C4.68776 6.47123 4.4723 6.69593 4.3951 6.99482C4.2863 7.41923 4.00098 9.19595 4.00098 12C4.00098 14.804 4.2863 16.5808 4.3954 17.0064C4.47126 17.3031 4.68676 17.5278 4.93251 17.5968C5.37252 17.7193 7.50098 18 12.001 18C16.501 18 18.6299 17.7194 19.0697 17.5968C19.3142 17.5288 19.5297 17.3041 19.6069 17.0052C19.7157 16.5808 20.001 14.8 20.001 12C20.001 9.2 19.7157 7.41923 19.6069 6.99482ZM21.5442 6.49818C22.001 8.28 22.001 12 22.001 12C22.001 12 22.001 15.72 21.5442 17.5018C21.2897 18.4873 20.547 19.2618 19.6056 19.5236C17.8971 20 12.001 20 12.001 20C12.001 20 6.10837 20 4.39637 19.5236C3.45146 19.2582 2.70879 18.4836 2.45774 17.5018C2.00098 15.72 2.00098 12 2.00098 12C2.00098 12 2.00098 8.28 2.45774 6.49818C2.71227 5.51273 3.45495 4.73818 4.39637 4.47636C6.10837 4 12.001 4 12.001 4C12.001 4 17.8971 4 19.6056 4.47636C20.5505 4.74182 21.2932 5.51636 21.5442 6.49818ZM10.001 15.5V8.5L16.001 12L10.001 15.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1edbed7b60422357(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.2809 2.95549C20.2499 3.1584 21.0363 5.29655 21.1199 5.5524L22.4167 5.64758C22.5466 5.64758 22.5858 5.82844 22.471 5.88421C21.148 6.60011 20.7438 8.05479 20.9814 9.00236C21.071 9.35974 21.2346 9.69179 21.3932 10.0224C21.6998 10.6637 22.0441 11.4403 22.1003 13.0033C22.2168 16.2423 19.5895 19.1778 16.3115 19.5956C17.4813 18.4088 18.1256 17.1518 18.4313 16.2207C19.0373 14.375 18.9393 12.9046 18.4857 11.781C18.0385 10.6732 17.2806 9.98965 16.7036 9.63988C15.021 8.62006 13.4846 8.54938 12.2604 8.878C12.7253 8.28379 13.1361 7.6768 13.4596 7.01357C14.0436 5.36416 13.3581 4.1657 12.7563 3.49525C12.5642 3.24941 12.695 2.83984 13.0607 2.83984C14.4703 2.83984 15.8737 2.8604 17.2809 2.95549ZM3.31872 19.1067C5.24275 16.9048 8.0315 13.7133 10.4814 10.9564C11.04 10.3277 13.2499 8.61858 16.2285 10.424C17.1068 10.9564 18.6589 12.589 17.5605 15.9349C16.7576 18.3804 13.1532 23.7301 1.80115 21.7784C1.5741 21.7394 1.29 21.4242 1.58312 21.0905C1.99794 20.6183 2.59759 19.932 3.31872 19.1067Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7d3fda13a3120b94(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5054 3.04345C11.669 2.7592 11.972 2.58398 12.3 2.58398C13.8467 2.58398 15.3904 2.63257 16.9367 2.73706C19.4462 2.90856 20.6379 4.32828 21.1168 5.1681C21.7132 5.25986 22.5053 5.2559 22.6883 5.9744C22.8288 6.52612 22.4713 6.80767 22.1338 7.12258C21.6507 7.57334 21.0015 8.29871 21.1799 9.01039C21.2355 9.23211 21.3389 9.4477 21.4959 9.77535L21.4975 9.77882C21.8163 10.4456 22.1819 11.2885 22.2397 12.8936C22.3958 17.2341 18.644 19.79 14.9881 19.9726C12.5773 21.7886 8.6429 22.9983 2.43068 21.9303C2.0357 21.8624 1.6727 21.5954 1.48562 21.2218C1.38225 21.0153 1.32573 20.7614 1.36515 20.4861C1.40453 20.2111 1.53081 19.9751 1.69602 19.787C4.92443 16.1115 8.33058 12.5405 11.3498 8.68888C11.8761 8.01761 12.3106 7.4091 12.5009 7.04098C12.8087 6.12171 12.4912 5.59669 11.8748 4.57756C11.5926 4.11094 11.1855 3.59953 11.5054 3.04345ZM13.4938 8.88684C14.3682 8.89195 15.3448 9.13531 16.3787 9.76193C18.5029 11.0495 18.7134 13.7579 18.004 15.9188C17.84 16.4184 17.5722 17.0169 17.1676 17.6452C19.1038 16.8487 20.4867 15.1615 20.4075 12.9595C20.3615 11.6795 20.0913 11.0879 19.8441 10.5708C19.8346 10.551 19.8248 10.5307 19.8147 10.5098C19.6818 10.2334 19.5038 9.86372 19.4017 9.45634C19.1309 8.37645 19.577 7.41735 20.0157 6.77895C19.8359 6.66703 19.6969 6.49411 19.6287 6.28558C19.6287 6.28558 19.629 6.28643 19.6281 6.28432C19.6159 6.25304 19.4495 5.85304 19.0499 5.46762C18.6421 5.07435 17.9553 4.64434 16.8127 4.56619C15.85 4.50115 14.8873 4.45833 13.9231 4.43597C14.3747 5.31477 14.6813 6.37727 14.2117 7.7035C14.0609 8.12933 13.7525 8.52294 13.4938 8.88684ZM12.6619 10.8314C11.9432 11.0338 11.4483 11.4609 11.2837 11.6462C8.56713 14.7033 5.40256 18.3354 3.70758 20.2731C9.15721 21.0209 12.3092 19.7826 14.0856 18.3519C15.3813 17.3084 16.0109 16.1123 16.2621 15.3469C16.6965 14.0239 16.7989 12.1605 15.4284 11.3297C14.2752 10.6308 13.3405 10.6402 12.6619 10.8314Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$577bccd9e21a86a9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.90338 21.8387C5.539 21.8387 2.00098 18.3003 2.00098 13.9355C2.00098 10.2901 4.46846 7.05968 7.82477 6.30851C11.746 5.4309 13.5286 4.74194 14.9016 2C15.9002 3.93518 15.2254 5.70968 14.9029 6.67742C19.5998 5.54839 21.2732 3.39627 21.6763 3.12903C21.6763 7.08065 20.4448 9.58065 19.2572 11.1935C20.733 11.1382 21.2656 10.7097 22.001 10.6071C21.6763 12.0553 20.5 14.0968 17.67 15.4017C16.9827 19.066 13.7668 21.8387 9.90338 21.8387ZM13.6127 15.3871C13.6127 15.7097 13.5595 15.871 13.2095 15.871L10.0592 15.873L13.0203 12.6251C13.8799 11.7653 13.8799 11.3354 13.8799 10.2369C13.8799 9.90252 13.8322 9.52041 13.9277 9.18607C13.9754 9.04278 13.8799 8.99501 13.7367 9.04278C13.4023 9.1383 12.8292 9.1383 11.8741 9.1383H7.57579C7.33699 9.1383 7.24148 8.99501 7.33699 8.80396C7.33699 8.75619 7.33699 8.6129 7.24147 8.6129C6.62061 8.89949 6.47734 10.1891 6.52509 11.0011C6.52509 11.431 6.76389 11.6698 7.0982 11.6698H10.4891L7.00268 15.3953C6.76389 15.6819 6.52509 16.064 6.52509 16.5894V17.6402C6.52509 18.1179 6.81165 18.4045 7.33699 18.5H13.3248C13.8799 18.5 14.2578 18.2665 14.2578 17.6452V16.5161C14.2578 16.3076 14.2578 15.5484 13.6127 15.3871Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4f6d5031c545c192(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.26158 8.26022C5.8379 8.80266 4.00098 11.2081 4.00098 13.9355C4.00098 17.1958 6.64362 19.8387 9.90338 19.8387C12.7548 19.8387 15.1852 17.8007 15.7043 15.033C15.8238 14.3962 16.2442 13.8568 16.8326 13.5855C17.3154 13.3628 17.7433 13.1123 18.1174 12.8418C17.2537 12.2391 16.9306 10.9804 17.6467 10.0078C18.2274 9.21897 18.6973 8.34856 19.0382 7.35686C17.9545 7.86679 16.7372 8.29346 15.3703 8.62203C14.1085 8.92532 12.9778 7.98421 12.9039 6.80753C11.7237 7.38016 10.2337 7.81884 8.26158 8.26022ZM19.2572 11.1935C20.4234 11.1935 21.1735 10.7697 22.001 10.6071C21.6763 12.0553 20.5 14.0968 17.67 15.4017C16.9827 19.066 13.7668 21.8387 9.90338 21.8387C5.539 21.8387 2.00098 18.3003 2.00098 13.9355C2.00098 10.2901 4.46846 7.05968 7.82477 6.30851C11.746 5.4309 13.5286 4.74194 14.9016 2C15.5905 3.33333 15.591 4.89247 14.9029 6.67742C17.718 6.00736 19.9758 4.82457 21.6763 3.12903C21.6763 7.93116 19.8537 10.315 19.2572 11.1935ZM13.4176 15.1256C14.001 15.2715 14.001 15.9581 14.001 16.1466V17.1675C14.001 17.7294 13.6593 17.9405 13.1574 17.9405H7.7428C7.26775 17.8541 7.00863 17.595 7.00863 17.1631V16.2129C7.00863 15.7378 7.22456 15.3922 7.44049 15.1331L10.5931 11.7642H7.52686C7.22456 11.7642 7.00863 11.5483 7.00863 11.1595C6.96544 10.4253 7.095 9.25914 7.65642 9C7.7428 9 7.7428 9.12957 7.7428 9.17276C7.65642 9.34553 7.7428 9.4751 7.95873 9.4751H11.8455C12.7092 9.4751 13.2275 9.4751 13.5298 9.38872C13.6593 9.34553 13.7457 9.38872 13.7025 9.51829C13.6161 9.82063 13.6593 10.1662 13.6593 10.4685C13.6593 11.4619 13.6593 11.8506 12.882 12.628L10.2044 15.565L13.0531 15.5632C13.3696 15.5632 13.4176 15.4173 13.4176 15.1256Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d0f14b681186268b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.3735 18.897L14.8258 18.8974L15.3039 20.534L17.9085 18.8974H20.9792V5.39517H13.3735V18.897ZM14.9191 6.86099H19.4338V17.4316H17.7018L15.9722 18.5186L15.6573 17.4342L14.9193 17.4318V6.86119L14.9191 6.86099ZM12.0895 11.5733H8.84563C8.95376 9.89154 8.98193 8.3715 8.98193 7.01393H12.1538C12.1538 7.01393 12.2758 5.61365 11.622 5.62954H6.13529C6.35155 4.8152 6.62335 3.97463 6.94873 3.10547C6.94873 3.10547 5.45617 3.10547 4.94787 4.44417C4.73756 4.99634 4.12887 7.12158 3.04481 9.2925C3.40987 9.25278 4.61753 9.21901 5.32879 7.91408C5.45974 7.54861 5.48454 7.50094 5.64723 7.01234H7.43679C7.43679 7.66381 7.36259 11.1635 7.33244 11.5707H4.09237C3.36424 11.5707 3.12755 13.0365 3.12755 13.0365H7.19336C6.92056 16.1312 5.45637 18.7391 2.80078 20.8008C4.07114 21.1639 5.33713 20.7432 5.96268 20.1863C5.96268 20.1863 7.38759 18.8893 8.16889 15.8881L11.5145 19.9189C11.5145 19.9189 12.0052 18.2501 11.4375 17.4369C10.9673 16.8832 9.69796 15.3852 9.15672 14.8422L8.25004 15.5626C8.52045 14.695 8.68314 13.8524 8.7381 13.0381H12.5601C12.5601 13.0381 12.5547 11.5723 12.0895 11.5723V11.5733Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7f6f2aff99b0700a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.3445 17.9633L10.6572 19.037L8.52534 15.687C8.0855 17.089 7.3539 18.3525 6.38696 19.5123C5.98479 19.9947 5.5676 20.4299 5.08571 20.8876C4.93103 21.0345 4.31113 21.604 4.20793 21.7072L2.79372 20.293C2.93256 20.1542 3.58085 19.5585 3.70848 19.4373C4.13828 19.0292 4.50381 18.6478 4.8508 18.2316C6.11713 16.7127 6.87997 15.0205 6.98764 13.0001H3.00082V11.0001H7.00082V7.00013H6.13284C5.44422 8.26619 4.57451 9.22211 3.51532 9.85763L2.48633 8.14264C3.88223 7.3051 4.91211 5.53959 5.52464 2.7832L7.47701 3.21706C7.33636 3.85 7.17352 4.44451 6.98811 5.00013H11.5008V7.00013H9.00082V11.0001H11.5008V13.0001H9.18613L12.3445 17.9633ZM16.1833 17.8929L17.2993 17.0001H19.0008V7.00013H15.0008V17.0001H15.7369L16.1833 17.8929ZM13.0008 5.00013H21.0008V19.0001H18.0008L15.5008 21.0001L14.5008 19.0001H13.0008V5.00013Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$64366ad0bba843ba(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9.87398V19.928C16.6187 19.4745 19.4869 16.5923 19.9381 12.9558H17L20.7042 7C21.529 8.46132 22 10.1508 22 11.9509C22 17.5009 17.5228 22 12 22C6.47715 22 2 17.5009 2 11.9509C2 10.1508 2.47097 8.46132 3.29582 7L7 12.9558H4.06189C4.51314 16.5923 7.38128 19.4745 11 19.928V9.87398C9.27477 9.42994 8 7.86384 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6C16 7.86384 14.7252 9.42994 13 9.87398ZM12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dc73f40dd416c9d2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.04938 11H7V13H4.06189C4.51314 16.6187 7.38128 19.4869 11 19.9381V9.87398C9.27477 9.42994 8 7.86384 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6C16 7.86384 14.7252 9.42994 13 9.87398V19.9381C16.6187 19.4869 19.4869 16.6187 19.9381 13H17V11H21.9506C21.9833 11.3289 22 11.6625 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 11.6625 2.01672 11.3289 2.04938 11ZM12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$36a94a3a26e3301c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5556 19H21V21H3V19H4.44444L5.33333 15H18.6667L19.5556 19ZM17.3333 9L18.2222 13H5.77778L6.66667 9H17.3333ZM16.8889 7H7.11111L7.82598 3.78307C7.92766 3.32553 8.33347 3 8.80217 3H15.1978C15.6665 3 16.0723 3.32553 16.174 3.78307L16.8889 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ec0515dc085726ce(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.49323 19H17.5068L16.8401 16H7.1599L6.49323 19ZM19.5556 19H21V21H3V19H4.44444L7.82598 3.78307C7.92766 3.32553 8.33347 3 8.80217 3H15.1978C15.6665 3 16.0723 3.32553 16.174 3.78307L19.5556 19ZM7.60434 14H16.3957L15.5068 10H8.49323L7.60434 14ZM8.93768 8H15.0623L14.3957 5H9.60434L8.93768 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9ae0ced014986450(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3C10.1046 3 11 3.89543 11 5C11 5.11469 10.9904 5.22639 10.9723 5.33454L12.9447 5.66546C12.9812 5.4484 13 5.22602 13 5C13 4.7625 12.9793 4.52984 12.9396 4.30371C13.2472 4.11088 13.6103 4 14 4C15.1046 4 16 4.89543 16 6C16 6.36443 15.903 6.70571 15.7327 7H5C4.44772 7 4 6.55228 4 6C4 5.44772 4.44772 5 5 5C5.20008 5 5.38362 5.05773 5.53851 5.15709C5.81193 5.33249 6.15353 5.36415 6.45453 5.24199C6.75554 5.11982 6.97845 4.85905 7.05229 4.5427C7.25876 3.65813 8.05374 3 9 3ZM10.5164 1.29745C10.0489 1.10575 9.53693 1 9 1C7.50087 1 6.19573 1.82409 5.51068 3.04344C5.34453 3.01488 5.17387 3 5 3C3.34315 3 2 4.34315 2 6C2 6.8885 2.38625 7.68679 3 8.23611V20C3 21.1046 3.89543 22 5 22H15C16.1046 22 17 21.1046 17 20H19C20.1046 20 21 19.1046 21 18V11C21 9.89543 20.1046 9 19 9H17V8.64575C17.6215 7.94132 18 7.01438 18 6C18 3.79086 16.2091 2 14 2C13.3143 2 12.6684 2.17301 12.1042 2.47716C11.6851 1.96201 11.1402 1.5532 10.5164 1.29745ZM17 18V11H19V18H17ZM7 11H9V18H7V11ZM11 11H13V18H11V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a9b652e1b9b5628a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3C10.1046 3 11 3.89543 11 5C11 5.11469 10.9904 5.22639 10.9723 5.33454L12.9447 5.66546C12.9812 5.4484 13 5.22602 13 5C13 4.7625 12.9793 4.52984 12.9396 4.30371C13.2472 4.11088 13.6103 4 14 4C15.1046 4 16 4.89543 16 6C16 6.36443 15.903 6.70571 15.7327 7H5C4.44772 7 4 6.55228 4 6C4 5.44772 4.44772 5 5 5C5.20008 5 5.38362 5.05773 5.53851 5.15709C5.81193 5.33249 6.15353 5.36415 6.45453 5.24199C6.75554 5.11982 6.97845 4.85905 7.05229 4.5427C7.25876 3.65813 8.05374 3 9 3ZM10.5164 1.29745C10.0489 1.10575 9.53693 1 9 1C7.50087 1 6.19573 1.82409 5.51068 3.04344C5.34453 3.01488 5.17387 3 5 3C3.34315 3 2 4.34315 2 6C2 6.8885 2.38625 7.68679 3 8.23611V20C3 21.1046 3.89543 22 5 22H15C16.1046 22 17 21.1046 17 20H19C20.1046 20 21 19.1046 21 18V11C21 9.89543 20.1046 9 19 9H17V8.64575C17.6215 7.94132 18 7.01438 18 6C18 3.79086 16.2091 2 14 2C13.3143 2 12.6684 2.17301 12.1042 2.47716C11.6851 1.96201 11.1402 1.5532 10.5164 1.29745ZM17 11H19V18H17V11ZM15 9V10V19V20H5V9H15ZM7 11V18H9V11H7ZM13 11V18H11V11H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9b3390f3ce97a332(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 12.0002H4V7.00025H2V5.00025H8V7.00025H6V9.79572L15.8131 7.16632L15.2327 5.00025H12V3.00025H15.9784C16.4286 2.99018 16.8442 3.28718 16.9659 3.74143L18.5188 9.53698L16.587 10.0546L16.3307 9.09817L5.5 12.0002ZM5 21.0002C2.79086 21.0002 1 19.2094 1 17.0002C1 14.7911 2.79086 13.0002 5 13.0002C7.20914 13.0002 9 14.7911 9 17.0002C9 19.2094 7.20914 21.0002 5 21.0002ZM5 18.0002C5.55228 18.0002 6 17.5525 6 17.0002C6 16.448 5.55228 16.0002 5 16.0002C4.44772 16.0002 4 16.448 4 17.0002C4 17.5525 4.44772 18.0002 5 18.0002ZM18 21.0002C15.2386 21.0002 13 18.7617 13 16.0002C13 13.2388 15.2386 11.0002 18 11.0002C20.7614 11.0002 23 13.2388 23 16.0002C23 18.7617 20.7614 21.0002 18 21.0002ZM18 17.0002C18.5523 17.0002 19 16.5525 19 16.0002C19 15.448 18.5523 15.0002 18 15.0002C17.4477 15.0002 17 15.448 17 16.0002C17 16.5525 17.4477 17.0002 18 17.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e4ff2e478d33f364(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 12.0002H4V7.00025H2V5.00025H8V7.00025H6V9.79572L15.8131 7.16632L15.2327 5.00025H12V3.00025H15.9784C16.4286 2.99018 16.8442 3.28718 16.9659 3.74143L18.5188 9.53698L16.587 10.0546L16.3307 9.09817L5.5 12.0002ZM5 19.0002C6.10457 19.0002 7 18.1048 7 17.0002C7 15.8957 6.10457 15.0002 5 15.0002C3.89543 15.0002 3 15.8957 3 17.0002C3 18.1048 3.89543 19.0002 5 19.0002ZM5 21.0002C2.79086 21.0002 1 19.2094 1 17.0002C1 14.7911 2.79086 13.0002 5 13.0002C7.20914 13.0002 9 14.7911 9 17.0002C9 19.2094 7.20914 21.0002 5 21.0002ZM18 19.0002C19.6569 19.0002 21 17.6571 21 16.0002C21 14.3434 19.6569 13.0002 18 13.0002C16.3431 13.0002 15 14.3434 15 16.0002C15 17.6571 16.3431 19.0002 18 19.0002ZM18 21.0002C15.2386 21.0002 13 18.7617 13 16.0002C13 13.2388 15.2386 11.0002 18 11.0002C20.7614 11.0002 23 13.2388 23 16.0002C23 18.7617 20.7614 21.0002 18 21.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b6b7ae3638671d7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20H7V21C7 21.5523 6.55228 22 6 22H4C3.44772 22 3 21.5523 3 21V12H2V8H3V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V8H22V12H21V21C21 21.5523 20.5523 22 20 22H18C17.4477 22 17 21.5523 17 21V20ZM5 5V12H19V5H5ZM7.5 18C8.32843 18 9 17.3284 9 16.5C9 15.6716 8.32843 15 7.5 15C6.67157 15 6 15.6716 6 16.5C6 17.3284 6.67157 18 7.5 18ZM16.5 18C17.3284 18 18 17.3284 18 16.5C18 15.6716 17.3284 15 16.5 15C15.6716 15 15 15.6716 15 16.5C15 17.3284 15.6716 18 16.5 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$28677114a9efadc5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20H7V21C7 21.5523 6.55228 22 6 22H4C3.44772 22 3 21.5523 3 21V12H2V8H3V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V8H22V12H21V21C21 21.5523 20.5523 22 20 22H18C17.4477 22 17 21.5523 17 21V20ZM5 5V11H19V5H5ZM19 13H5V18H19V13ZM7.5 17C6.67157 17 6 16.3284 6 15.5C6 14.6716 6.67157 14 7.5 14C8.32843 14 9 14.6716 9 15.5C9 16.3284 8.32843 17 7.5 17ZM16.5 17C15.6716 17 15 16.3284 15 15.5C15 14.6716 15.6716 14 16.5 14C17.3284 14 18 14.6716 18 15.5C18 16.3284 17.3284 17 16.5 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bded2ffaaabd1a37(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20H7V21C7 21.5523 6.55228 22 6 22H5C4.44772 22 4 21.5523 4 21V20H3V12H2V8H3V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V8H22V12H21V20H20V21C20 21.5523 19.5523 22 19 22H18C17.4477 22 17 21.5523 17 21V20ZM5 5V14H19V5H5ZM5 16V18H9V16H5ZM15 16V18H19V16H15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9450f49c4fd39a37(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20H7V21C7 21.5523 6.55228 22 6 22H5C4.44772 22 4 21.5523 4 21V20H3V12H2V8H3V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V8H22V12H21V20H20V21C20 21.5523 19.5523 22 19 22H18C17.4477 22 17 21.5523 17 21V20ZM19 12V5H5V12H19ZM19 14H5V18H19V14ZM6 15H10V17H6V15ZM14 15H18V17H14V15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$37ede1fe0bcc96a7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3V5H5V14H19V12H21V20H20V21C20 21.5523 19.5523 22 19 22H18C17.4477 22 17 21.5523 17 21V20H7V21C7 21.5523 6.55228 22 6 22H5C4.44772 22 4 21.5523 4 21V20H3V12H2V8H3V5C3 3.89543 3.89543 3 5 3H12ZM9 16H5V18H9V16ZM19 16H15V18H19V16ZM18.5 1C20.9853 1 23 3.01472 23 5.5C23 7.98528 20.9853 10 18.5 10C16.0147 10 14 7.98528 14 5.5C14 3.01472 16.0147 1 18.5 1ZM18.4998 6.16667C18.0089 6.16667 17.5593 6.34354 17.2113 6.63704L17.0856 6.75245L18.4998 8.16667L19.9131 6.7515C19.5512 6.39013 19.0516 6.16667 18.4998 6.16667ZM18.4998 3.5C17.2966 3.5 16.1998 3.95536 15.3722 4.70316L15.199 4.86781L16.1428 5.80964C16.746 5.20643 17.5794 4.83333 18.4998 4.83333C19.3436 4.83333 20.1141 5.14684 20.7013 5.66372L20.8569 5.80964L21.7997 4.86684C20.9552 4.02233 19.7885 3.5 18.4998 3.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1f211dfd264abeb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3V5H5V12H21V20H20V21C20 21.5523 19.5523 22 19 22H18C17.4477 22 17 21.5523 17 21V20H7V21C7 21.5523 6.55228 22 6 22H5C4.44772 22 4 21.5523 4 21V20H3V12H2V8H3V5C3 3.89543 3.89543 3 5 3H12ZM19 14H5V18H19V14ZM10 15V17H6V15H10ZM18 15V17H14V15H18ZM18.5 1C20.9853 1 23 3.01472 23 5.5C23 7.98528 20.9853 10 18.5 10C16.0147 10 14 7.98528 14 5.5C14 3.01472 16.0147 1 18.5 1ZM18.4998 6.16667C18.0089 6.16667 17.5593 6.34354 17.2113 6.63704L17.0856 6.75245L18.4998 8.16667L19.9131 6.7515C19.5512 6.39013 19.0516 6.16667 18.4998 6.16667ZM18.4998 3.5C17.2966 3.5 16.1998 3.95536 15.3722 4.70316L15.199 4.86781L16.1428 5.80964C16.746 5.20643 17.5794 4.83333 18.4998 4.83333C19.3436 4.83333 20.1141 5.14684 20.7013 5.66372L20.8569 5.80964L21.7997 4.86684C20.9552 4.02233 19.7885 3.5 18.4998 3.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$da855cd3fff01e7a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V12L4.51334 5.29775C4.80607 4.51715 5.55231 4 6.386 4H17.614C18.4477 4 19.1939 4.51715 19.4867 5.29775L22 12V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20ZM4.136 12H19.864L17.614 6H6.386L4.136 12ZM6.5 17C7.32843 17 8 16.3284 8 15.5C8 14.6716 7.32843 14 6.5 14C5.67157 14 5 14.6716 5 15.5C5 16.3284 5.67157 17 6.5 17ZM17.5 17C18.3284 17 19 16.3284 19 15.5C19 14.6716 18.3284 14 17.5 14C16.6716 14 16 14.6716 16 15.5C16 16.3284 16.6716 17 17.5 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$41e3168d01b2ce77(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V11L4.4805 5.21216C4.79566 4.47679 5.51874 4 6.31879 4H17.6812C18.4813 4 19.2043 4.47679 19.5195 5.21216L22 11V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20ZM20 13H4V18H20V13ZM4.17594 11H19.8241L17.6812 6H6.31879L4.17594 11ZM6.5 17C5.67157 17 5 16.3284 5 15.5C5 14.6716 5.67157 14 6.5 14C7.32843 14 8 14.6716 8 15.5C8 16.3284 7.32843 17 6.5 17ZM17.5 17C16.6716 17 16 16.3284 16 15.5C16 14.6716 16.6716 14 17.5 14C18.3284 14 19 14.6716 19 15.5C19 16.3284 18.3284 17 17.5 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7b4b87b077407e81(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21.0002H5V22.0002C5 22.5525 4.55228 23.0002 4 23.0002H3C2.44772 23.0002 2 22.5525 2 22.0002V13.0002L4.4174 8.97123C4.77884 8.36882 5.42986 8.00023 6.13238 8.00023H17.8676C18.5701 8.00023 19.2212 8.36882 19.5826 8.97123L22 13.0002V22.0002C22 22.5525 21.5523 23.0002 21 23.0002H20C19.4477 23.0002 19 22.5525 19 22.0002V21.0002ZM4.33238 13.0002H19.6676L17.8676 10.0002H6.13238L4.33238 13.0002ZM6.5 18.0002C7.32843 18.0002 8 17.3287 8 16.5002C8 15.6718 7.32843 15.0002 6.5 15.0002C5.67157 15.0002 5 15.6718 5 16.5002C5 17.3287 5.67157 18.0002 6.5 18.0002ZM17.5 18.0002C18.3284 18.0002 19 17.3287 19 16.5002C19 15.6718 18.3284 15.0002 17.5 15.0002C16.6716 15.0002 16 15.6718 16 16.5002C16 17.3287 16.6716 18.0002 17.5 18.0002ZM5.43934 3.43957L6.5 2.37891L7.56066 3.43957C7.83211 3.71101 8 4.08601 8 4.50023C8 5.32865 7.32843 6.00023 6.5 6.00023C5.67157 6.00023 5 5.32865 5 4.50023C5 4.08601 5.16789 3.71101 5.43934 3.43957ZM10.9393 3.43957L12 2.37891L13.0607 3.43957C13.3321 3.71101 13.5 4.08601 13.5 4.50023C13.5 5.32865 12.8284 6.00023 12 6.00023C11.1716 6.00023 10.5 5.32865 10.5 4.50023C10.5 4.08601 10.6679 3.71101 10.9393 3.43957ZM16.4393 3.43957L17.5 2.37891L18.5607 3.43957C18.8321 3.71101 19 4.08601 19 4.50023C19 5.32865 18.3284 6.00023 17.5 6.00023C16.6716 6.00023 16 5.32865 16 4.50023C16 4.08601 16.1679 3.71101 16.4393 3.43957Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2454b7e06467dd87(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21.0002H5V22.0002C5 22.5525 4.55228 23.0002 4 23.0002H3C2.44772 23.0002 2 22.5525 2 22.0002V12.0002L4.4174 7.97123C4.77884 7.36882 5.42986 7.00023 6.13238 7.00023H17.8676C18.5701 7.00023 19.2212 7.36882 19.5826 7.97123L22 12.0002V22.0002C22 22.5525 21.5523 23.0002 21 23.0002H20C19.4477 23.0002 19 22.5525 19 22.0002V21.0002ZM20 14.0002H4V19.0002H20V14.0002ZM4.33238 12.0002H19.6676L17.8676 9.00023H6.13238L4.33238 12.0002ZM5.43934 3.43957L6.5 2.37891L7.56066 3.43957C7.83211 3.71101 8 4.08601 8 4.50023C8 5.32865 7.32843 6.00023 6.5 6.00023C5.67157 6.00023 5 5.32865 5 4.50023C5 4.08601 5.16789 3.71101 5.43934 3.43957ZM10.9393 3.43957L12 2.37891L13.0607 3.43957C13.3321 3.71101 13.5 4.08601 13.5 4.50023C13.5 5.32865 12.8284 6.00023 12 6.00023C11.1716 6.00023 10.5 5.32865 10.5 4.50023C10.5 4.08601 10.6679 3.71101 10.9393 3.43957ZM16.4393 3.43957L17.5 2.37891L18.5607 3.43957C18.8321 3.71101 19 4.08601 19 4.50023C19 5.32865 18.3284 6.00023 17.5 6.00023C16.6716 6.00023 16 5.32865 16 4.50023C16 4.08601 16.1679 3.71101 16.4393 3.43957ZM6.5 18.0002C5.67157 18.0002 5 17.3287 5 16.5002C5 15.6718 5.67157 15.0002 6.5 15.0002C7.32843 15.0002 8 15.6718 8 16.5002C8 17.3287 7.32843 18.0002 6.5 18.0002ZM17.5 18.0002C16.6716 18.0002 16 17.3287 16 16.5002C16 15.6718 16.6716 15.0002 17.5 15.0002C18.3284 15.0002 19 15.6718 19 16.5002C19 17.3287 18.3284 18.0002 17.5 18.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d8fe74cabcc1ee70(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.1716 3C14.702 3 15.2107 3.21071 15.5858 3.58579L20.4142 8.41421C20.7893 8.78929 21 9.29799 21 9.82843V17H23V19L14.8738 19.0008C14.4295 20.7256 12.8636 22 11 22C9.13643 22 7.57052 20.7256 7.12621 19.0008L3 19C2.44772 19 2 18.5523 2 18V5C2 3.89543 2.89543 3 4 3H14.1716ZM11 16C9.89543 16 9 16.8954 9 18C9 19.1046 9.89543 20 11 20C12.1046 20 13 19.1046 13 18C13 16.8954 12.1046 16 11 16ZM14 7H6V13H14V7ZM12 9V11H8V9H12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$213f7e6a291feb70(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.1716 3C14.702 3 15.2107 3.21071 15.5858 3.58579L20.4142 8.41421C20.7893 8.78929 21 9.29799 21 9.82843V17H23V19L14.8738 19.0008C14.4295 20.7256 12.8636 22 11 22C9.13643 22 7.57052 20.7256 7.12621 19.0008L3 19C2.44772 19 2 18.5523 2 18V5C2 3.89543 2.89543 3 4 3H14.1716ZM11 16C9.89543 16 9 16.8954 9 18C9 19.1046 9.89543 20 11 20C12.1046 20 13 19.1046 13 18C13 16.8954 12.1046 16 11 16ZM14.1716 5H4V17L7.12595 17.0002C7.56991 15.2749 9.13607 14 11 14C12.8639 14 14.4301 15.2749 14.874 17.0002L19 17V9.82843L14.1716 5ZM14 7V13H6V7H14ZM12 9H8V11H12V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5b332a02238fff86(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11H19V7H20V4H22V7H23V11H22V18C22 19.6569 20.6569 21 19 21C17.3431 21 16 19.6569 16 18V14H14V19H15V21H2V19H3V4C3 3.44772 3.44772 3 4 3H13C13.5523 3 14 3.44772 14 4V12H16C17.1046 12 18 12.8954 18 14V18C18 18.5523 18.4477 19 19 19C19.5523 19 20 18.5523 20 18V11ZM9 11V7L5 13H8V17L12 11H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$21c551105d3e8846(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11H19V7H20V4H22V7H23V11H22V18C22 19.6569 20.6569 21 19 21C17.3431 21 16 19.6569 16 18V14H14V19H15V21H2V19H3V4C3 3.44772 3.44772 3 4 3H13C13.5523 3 14 3.44772 14 4V12H16C17.1046 12 18 12.8954 18 14V18C18 18.5523 18.4477 19 19 19C19.5523 19 20 18.5523 20 18V11ZM12 19V5H5V19H12ZM9 11H12L8 17V13H5L9 7V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6d5a087f9c46921d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19V4C3 3.44772 3.44772 3 4 3H13C13.5523 3 14 3.44772 14 4V12H16C17.1046 12 18 12.8954 18 14V18C18 18.5523 18.4477 19 19 19C19.5523 19 20 18.5523 20 18V11H18C17.4477 11 17 10.5523 17 10V6.41421L15.3431 4.75736L16.7574 3.34315L21.7071 8.29289C21.9024 8.48816 22 8.74408 22 9V18C22 19.6569 20.6569 21 19 21C17.3431 21 16 19.6569 16 18V14H14V19H15V21H2V19H3ZM9 11V7L5 13H8V17L12 11H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$21d48dabdacad5dd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 19H15V21H2V19H3V4C3 3.44772 3.44772 3 4 3H13C13.5523 3 14 3.44772 14 4V12H16C17.1046 12 18 12.8954 18 14V18C18 18.5523 18.4477 19 19 19C19.5523 19 20 18.5523 20 18V11H18C17.4477 11 17 10.5523 17 10V6.41421L15.3431 4.75736L16.7574 3.34315L21.7071 8.29289C21.9024 8.48816 22 8.74408 22 9V18C22 19.6569 20.6569 21 19 21C17.3431 21 16 19.6569 16 18V14H14V19ZM5 19H12V5H5V19ZM9 11H12L8 17V13H5L9 7V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$46350b38bfee2129(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19V13L9 12V9H15V12L13 13V19L18 20V22H6V20L11 19ZM10 2.22302V1H14V2.22302C18.008 3.13247 21 6.71683 21 11C21 14.1235 19.4088 16.8754 16.9928 18.4892L15.8833 16.825C17.7624 15.5697 19 13.4294 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 13.4294 6.23758 15.5697 8.11669 16.825L7.00717 18.4892C4.59118 16.8754 3 14.1235 3 11C3 6.71683 5.99202 3.13247 10 2.22302Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fc8661dabb5b8cfe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 20V13H9V10H15V13H13V20H18V22H6V20H11ZM10 2.22302V1H14V2.22302C18.008 3.13247 21 6.71683 21 11C21 14.1235 19.4088 16.8754 16.9928 18.4892L15.8833 16.825C17.7624 15.5697 19 13.4294 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 13.4294 6.23758 15.5697 8.11669 16.825L7.00717 18.4892C4.59118 16.8754 3 14.1235 3 11C3 6.71683 5.99202 3.13247 10 2.22302Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$17ef27b520b67845(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.3277 4.25809L10.5858 12L12 13.4142L19.7419 5.6723C21.153 7.39641 22 9.5999 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C14.4001 2 16.6036 2.84695 18.3277 4.25809Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9c7061eabbaedd48(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.6248 3.13258L15.1247 4.63267C14.1648 4.22531 13.1088 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 10.8912 19.7747 9.83517 19.3673 8.87531L20.8674 7.37522C21.5908 8.75852 22 10.3318 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C13.6682 2 15.2415 2.40918 16.6248 3.13258ZM18.364 4.22183L19.7782 5.63604L12 13.4142L10.5858 12L18.364 4.22183Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$89a56b88d3655067(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM16.5 7.5L10 10L7.5 16.5L14 14L16.5 7.5ZM12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e4530c9057cf839c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM16.5 7.5L14 14L7.5 16.5L10 10L16.5 7.5ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$190e43f0d64b55e9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM15.4462 9.96803C15.102 9.38559 14.6144 8.89798 14.032 8.55382L8.55382 14.032C8.89798 14.6144 9.38559 15.102 9.96803 15.4462L15.4462 9.96803Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6adc09d7c04c0836(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM15.4462 9.96803L9.96803 15.4462C9.38559 15.102 8.89798 14.6144 8.55382 14.032L14.032 8.55382C14.6144 8.89798 15.102 9.38559 15.4462 9.96803Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6772f4d5ba16e20a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 22C7.47715 22 3 17.5228 3 12C3 6.47715 7.47715 2 13 2C18.5228 2 23 6.47715 23 12C23 17.5228 18.5228 22 13 22ZM8 11.5L12 13L13.5 17.0021L17 8L8 11.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$20b2bd94927c7c93(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM7 11.5L16 8L12.5 17.0021L11 13L7 11.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a39d0d47852648fd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM15.5 8.5L10.5 10.5L8.5 15.5L13.5 13.5L15.5 8.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9a56e48f59a1b2c0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM15.5 8.5L13.5 13.5L8.5 15.5L10.5 10.5L15.5 8.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e4c8364408dbd668(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3H20C21.1046 3 22 3.89543 22 5V8C22 9.10457 21.1046 10 20 10H18V13C18 15.2091 16.2091 17 14 17H8C5.79086 17 4 15.2091 4 13V4C4 3.44772 4.44772 3 5 3ZM18 5V8H20V5H18ZM2 19H20V21H2V19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b4ea0088d2cb2530(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13V5H6V13C6 14.1046 6.89543 15 8 15H14C15.1046 15 16 14.1046 16 13ZM5 3H20C21.1046 3 22 3.89543 22 5V8C22 9.10457 21.1046 10 20 10H18V13C18 15.2091 16.2091 17 14 17H8C5.79086 17 4 15.2091 4 13V4C4 3.44772 4.44772 3 5 3ZM18 5V8H20V5H18ZM2 19H20V21H2V19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d468f6e00506d74d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.00008 10.0001C8.4478 10.0001 8.00008 10.4478 8.00008 11.0001V15.0001H10.0001V12.0001H13.0001V14.5001L16.5001 11.0001L13.0001 7.50008V10.0001H9.00008ZM12.7072 1.39348L22.6067 11.293C22.9972 11.6835 22.9972 12.3167 22.6067 12.7072L12.7072 22.6067C12.3167 22.9972 11.6835 22.9972 11.293 22.6067L1.39348 12.7072C1.00295 12.3167 1.00295 11.6835 1.39348 11.293L11.293 1.39348C11.6835 1.00295 12.3167 1.00295 12.7072 1.39348Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f6bf948aaf2ea2d7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0001 3.5148L3.5148 12.0001L12.0001 20.4854L20.4854 12.0001L12.0001 3.5148ZM12.7072 1.39348L22.6067 11.293C22.9972 11.6835 22.9972 12.3167 22.6067 12.7072L12.7072 22.6067C12.3167 22.9972 11.6835 22.9972 11.293 22.6067L1.39348 12.7072C1.00295 12.3167 1.00295 11.6835 1.39348 11.293L11.293 1.39348C11.6835 1.00295 12.3167 1.00295 12.7072 1.39348ZM13.0001 10.0001V7.50008L16.5001 11.0001L13.0001 14.5001V12.0001H10.0001V15.0001H8.00008V11.0001C8.00008 10.4478 8.4478 10.0001 9.00008 10.0001H13.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b4cb5002248e327a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1C16.5523 1 17 1.44772 17 2V3H22V9H19.981L22.7271 16.5448C22.9033 16.9958 23 17.4866 23 18C23 20.2091 21.2091 22 19 22C17.1362 22 15.5701 20.7252 15.126 19H10.874C10.4299 20.7252 8.86384 22 7 22C5.05551 22 3.43508 20.6125 3.07474 18.7736C2.43596 18.4396 2 17.7707 2 17V7C2 6.44772 2.44772 6 3 6H10C10.5523 6 11 6.44772 11 7V12C11 12.5523 11.4477 13 12 13H14C14.5523 13 15 12.5523 15 12V3H12V1H16ZM19 16C17.8954 16 17 16.8954 17 18C17 19.1046 17.8954 20 19 20C20.1046 20 21 19.1046 21 18C21 17.7597 20.9576 17.5292 20.8799 17.3158L20.8635 17.2724C20.5725 16.5276 19.8479 16 19 16ZM7 16C5.89543 16 5 16.8954 5 18C5 19.1046 5.89543 20 7 20C8.10457 20 9 19.1046 9 18C9 16.8954 8.10457 16 7 16ZM9 8H4V10H9V8ZM20 5H17V7H20V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e946a5422c06445d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1C16.5523 1 17 1.44772 17 2V3H22V9H19.9813L22.7271 16.5439C22.9033 16.9948 23 17.4856 23 17.999C23 20.2082 21.2091 21.999 19 21.999C17.1365 21.999 15.5707 20.7247 15.1263 19H10.874C10.4299 20.7252 8.86384 22 7 22C5.05551 22 3.43508 20.6125 3.07474 18.7736C2.43596 18.4396 2 17.7707 2 17V7C2 6.44772 2.44772 6 3 6H10C10.5523 6 11 6.44772 11 7V12C11 12.5523 11.4477 13 12 13H14C14.5523 13 15 12.5523 15 12V3H12V1H16ZM7 16C5.89543 16 5 16.8954 5 18C5 19.1046 5.89543 20 7 20C8.10457 20 9 19.1046 9 18C9 16.8954 8.10457 16 7 16ZM19 15.999C17.8954 15.999 17 16.8944 17 17.999C17 19.1036 17.8954 19.999 19 19.999C20.1046 19.999 21 19.1036 21 17.999C21 17.7587 20.9576 17.5282 20.8799 17.3148L20.8635 17.2714C20.5725 16.5266 19.8479 15.999 19 15.999ZM17.853 9H17V12C17 13.6569 15.6569 15 14 15H12C10.3431 15 9 13.6569 9 12H4V15.3542C4.73294 14.5238 5.80531 14 7 14C8.86384 14 10.4299 15.2748 10.874 17H15.1258C15.5695 15.2743 17.1358 13.999 19 13.999C19.2368 13.999 19.4688 14.0196 19.6943 14.0591L17.853 9ZM9 8H4V10H9V8ZM20 5H17V7H20V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5ddf9a08d4653561(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5006 6.93685C17.5926 8.14727 19 10.4093 19 13V21H14.8293C14.4175 22.1652 13.3062 23 12 23C10.6938 23 9.58254 22.1652 9.17071 21H5V13C5 10.4093 6.40741 8.14727 8.49936 6.93685C8.33754 6.645 8.21115 6.33078 8.12602 6H5V4H8.12602C8.57006 2.27477 10.1362 1 12 1C13.8638 1 15.4299 2.27477 15.874 4H19V6H15.874C15.7888 6.33078 15.6625 6.645 15.5006 6.93685ZM12 14C11.4477 14 11 14.4477 11 15V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V15C13 14.4477 12.5523 14 12 14ZM12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$12afaf1856bdf145(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5006 6.93685C17.5926 8.14727 19 10.4093 19 13V21H14.8293C14.4175 22.1652 13.3062 23 12 23C10.6938 23 9.58254 22.1652 9.17071 21H5V13C5 10.4093 6.40741 8.14727 8.49936 6.93685C8.33754 6.645 8.21115 6.33078 8.12602 6H5V4H8.12602C8.57006 2.27477 10.1362 1 12 1C13.8638 1 15.4299 2.27477 15.874 4H19V6H15.874C15.7888 6.33078 15.6625 6.645 15.5006 6.93685ZM14.0474 8.43703C13.4484 8.79457 12.7482 9 12 9C11.2518 9 10.5516 8.79457 9.95263 8.43703C8.21207 9.21922 7 10.9681 7 13V19H9V15C9 13.3431 10.3431 12 12 12C13.6569 12 15 13.3431 15 15V19H17V13C17 10.9681 15.7879 9.21922 14.0474 8.43703ZM12 14C11.4477 14 11 14.4477 11 15V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V15C13 14.4477 12.5523 14 12 14ZM12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$efc10b749e192315(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM16.0043 12.8777C15.6589 12.3533 15.4097 11.9746 14.4622 12.1248C12.6717 12.409 12.4732 12.7224 12.3877 13.2375L12.3636 13.3943L12.3393 13.5597C12.2416 14.2428 12.2453 14.5012 12.5589 14.8308C13.8241 16.1582 14.582 17.115 14.8116 17.6746C14.9237 17.9484 15.2119 18.7751 15.0136 19.5927C16.2372 19.1066 17.3156 18.3332 18.1653 17.3559C18.2755 16.9821 18.3551 16.5166 18.3551 15.9518V15.8472C18.3551 14.9247 18.3551 14.504 17.7031 14.1314C17.428 13.9751 17.2227 13.881 17.0582 13.8064C16.691 13.6394 16.4479 13.5297 16.1198 13.0499C16.0807 12.9928 16.0425 12.9358 16.0043 12.8777ZM12 3.83333C9.68259 3.83333 7.59062 4.79858 6.1042 6.34896C6.28116 6.47186 6.43537 6.64453 6.54129 6.88256C6.74529 7.34029 6.74529 7.8112 6.74529 8.22764C6.74488 8.55621 6.74442 8.8672 6.84992 9.09302C6.99443 9.40134 7.6164 9.53227 8.16548 9.64736C8.36166 9.68867 8.56395 9.73083 8.74797 9.78176C9.25405 9.92233 9.64554 10.3765 9.95938 10.7412C10.0896 10.8931 10.2819 11.1163 10.3783 11.1717C10.4286 11.1356 10.59 10.9608 10.6699 10.6735C10.7307 10.4547 10.7134 10.2597 10.6239 10.1543C10.0648 9.49445 10.0952 8.2232 10.268 7.75495C10.5402 7.01606 11.3905 7.07058 12.012 7.11097C12.2438 7.12589 12.4626 7.14023 12.6257 7.11976C13.2482 7.04166 13.4396 6.09538 13.575 5.91C13.8671 5.50981 14.7607 4.9071 15.3158 4.53454C14.3025 4.08382 13.1805 3.83333 12 3.83333Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$751fc7959573669e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.23509 6.45329C4.85101 7.89148 4 9.84636 4 12C4 16.4183 7.58172 20 12 20C13.0808 20 14.1116 19.7857 15.0521 19.3972C15.1671 18.6467 14.9148 17.9266 14.8116 17.6746C14.582 17.115 13.8241 16.1582 12.5589 14.8308C12.2212 14.4758 12.2429 14.2035 12.3636 13.3943L12.3775 13.3029C12.4595 12.7486 12.5971 12.4209 14.4622 12.1248C15.4097 11.9746 15.6589 12.3533 16.0043 12.8777C16.0425 12.9358 16.0807 12.9928 16.1198 13.0499C16.4479 13.5297 16.691 13.6394 17.0582 13.8064C17.2227 13.881 17.428 13.9751 17.7031 14.1314C18.3551 14.504 18.3551 14.9247 18.3551 15.8472V15.9518C18.3551 16.3434 18.3168 16.6872 18.2566 16.9859C19.3478 15.6185 20 13.8854 20 12C20 8.70089 18.003 5.8682 15.1519 4.64482C14.5987 5.01813 13.8398 5.54726 13.575 5.91C13.4396 6.09538 13.2482 7.04166 12.6257 7.11976C12.4626 7.14023 12.2438 7.12589 12.012 7.11097C11.3905 7.07058 10.5402 7.01606 10.268 7.75495C10.0952 8.2232 10.0648 9.49445 10.6239 10.1543C10.7134 10.2597 10.7307 10.4547 10.6699 10.6735C10.59 10.9608 10.4286 11.1356 10.3783 11.1717C10.2819 11.1163 10.0896 10.8931 9.95938 10.7412C9.64554 10.3765 9.25405 9.92233 8.74797 9.78176C8.56395 9.73083 8.36166 9.68867 8.16548 9.64736C7.6164 9.53227 6.99443 9.40134 6.84992 9.09302C6.74442 8.8672 6.74488 8.55621 6.74529 8.22764C6.74529 7.8112 6.74529 7.34029 6.54129 6.88256C6.46246 6.70541 6.35689 6.56446 6.23509 6.45329ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$74f515fa8798a442(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.949 14.8881C20.7346 15.6883 19.9121 16.1632 19.1119 15.9488L3.44528 11.751C3.00205 11.6322 2.69653 11.227 2.70424 10.7682L2.79514 5.36509L4.24403 5.75332L5.15891 9.10429L10.2542 10.4696L9.88479 2.08838L11.8166 2.60602L14.6269 11.6412L19.8883 13.051C20.6885 13.2654 21.1634 14.0879 20.949 14.8881ZM4.00008 18.9999H20.0001V20.9999H4.00008V18.9999Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$acc1738af71c929d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.949 14.8881C20.7346 15.6883 19.9121 16.1632 19.1119 15.9488L3.44528 11.751C3.00205 11.6322 2.69653 11.227 2.70424 10.7682L2.79514 5.36509L4.24403 5.75332L5.15891 9.10429L10.2542 10.4696L9.88479 2.08838L11.8166 2.60602L14.6269 11.6412L19.8883 13.051C20.6885 13.2654 21.1634 14.0879 20.949 14.8881ZM4.00008 18.9999H20.0001V20.9999H4.00008V18.9999Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e02945377fcd8579(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.949 10.112C22.1634 10.9122 21.6886 11.7347 20.8884 11.9491L5.2218 16.1469C4.77856 16.2657 4.31138 16.0676 4.08866 15.6664L1.46582 10.9417L2.91471 10.5535L5.3825 12.998L10.4778 11.6328L5.96728 4.55914L7.89913 4.0415L14.8505 10.4611L20.1119 9.05131C20.9121 8.8369 21.7346 9.31177 21.949 10.112ZM4.00013 19.0002H20.0001V21.0002H4.00013V19.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b76ecf950c5c47b8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.949 10.112C22.1634 10.9122 21.6886 11.7347 20.8884 11.9491L5.2218 16.1469C4.77856 16.2657 4.31138 16.0676 4.08866 15.6664L1.46582 10.9417L2.91471 10.5535L5.3825 12.998L10.4778 11.6328L5.96728 4.55914L7.89913 4.0415L14.8505 10.4611L20.1119 9.05131C20.9121 8.8369 21.7346 9.31177 21.949 10.112ZM4.00013 19.0002H20.0001V21.0002H4.00013V19.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$804a9584d59b0c1c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17.9998H9.5V19.2498C9.5 20.7686 8.26878 21.9998 6.75 21.9998C5.23122 21.9998 4 20.7686 4 19.2498V17.9998ZM8 6.12043C10 6.12043 11 8.99982 11 10.9998C11 11.9998 10.5 12.9998 10 14.4998L9.5 15.9998H4C4 14.9998 3.5 13.4998 3.5 10.9998C3.5 8.49982 5.49783 6.12043 8 6.12043ZM20.054 14.0981L19.8369 15.3292C19.5732 16.8249 18.1468 17.8236 16.6511 17.5598C15.1554 17.2961 14.1567 15.8698 14.4205 14.3741L14.6375 13.1431L20.054 14.0981ZM18.1776 1.70464C20.6417 2.13914 22.196 4.82929 21.7619 7.29131C21.3278 9.75333 20.5749 11.1437 20.4013 12.1285L14.9848 11.1735L14.7529 9.60943C14.5209 8.04539 14.2022 6.97376 14.3758 5.98895C14.7231 4.01934 16.2079 1.35734 18.1776 1.70464Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$72514d9fa4dd37f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17.9998H9.5V19.2498C9.5 20.7686 8.26878 21.9998 6.75 21.9998C5.23122 21.9998 4 20.7686 4 19.2498V17.9998ZM8.05848 13.9998L8.10263 13.8674C8.86974 11.762 9 11.3712 9 10.9998C9 10.2503 8.79747 9.35724 8.47234 8.72659C8.23039 8.25729 8.06 8.12043 8 8.12043C6.72086 8.12043 5.5 9.48426 5.5 10.9998C5.5 11.9586 5.57517 12.773 5.72674 13.7582C5.7328 13.7976 5.74709 13.8871 5.76512 13.9998H8.05848ZM8 6.12043C10 6.12043 11 8.99982 11 10.9998C11 11.9998 10.5 12.9998 10 14.4998L9.5 15.9998H4C4 14.9998 3.5 13.4998 3.5 10.9998C3.5 8.49982 5.49783 6.12043 8 6.12043ZM20.054 14.0981L19.8369 15.3292C19.5732 16.8249 18.1468 17.8236 16.6511 17.5598C15.1554 17.2961 14.1567 15.8698 14.4205 14.3741L14.6375 13.1431L20.054 14.0981ZM19.0045 9.8514C19.1695 9.35163 19.3054 8.95728 19.3071 8.95163C19.5089 8.2935 19.668 7.64868 19.7923 6.94402C20.0555 5.45149 19.09 3.89638 17.8303 3.67426C17.7712 3.66384 17.5796 3.76903 17.2598 4.18919C16.8301 4.7538 16.4756 5.59814 16.3455 6.33625C16.2872 6.66645 16.2964 6.74048 16.6158 8.59923C16.6596 8.85446 16.697 9.08498 16.7312 9.31605L16.7517 9.45416L19.0045 9.8514ZM18.1776 1.70464C20.6417 2.13914 22.196 4.82929 21.7619 7.29131C21.3278 9.75333 20.5749 11.1437 20.4013 12.1285L14.9848 11.1735L14.7529 9.60943C14.5209 8.04539 14.2022 6.97376 14.3758 5.98895C14.7231 4.01934 16.2079 1.35734 18.1776 1.70464Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4901dc1ac8d591bd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19V4C3 3.44772 3.44772 3 4 3H13C13.5523 3 14 3.44772 14 4V12H16C17.1046 12 18 12.8954 18 14V18C18 18.5523 18.4477 19 19 19C19.5523 19 20 18.5523 20 18V11H18C17.4477 11 17 10.5523 17 10V6.41421L15.3431 4.75736L16.7574 3.34315L21.7071 8.29289C21.9024 8.48816 22 8.74408 22 9V18C22 19.6569 20.6569 21 19 21C17.3431 21 16 19.6569 16 18V14H14V19H15V21H2V19H3ZM5 5V11H12V5H5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$73f483914c80813f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 19H15V21H2V19H3V4C3 3.44772 3.44772 3 4 3H13C13.5523 3 14 3.44772 14 4V12H16C17.1046 12 18 12.8954 18 14V18C18 18.5523 18.4477 19 19 19C19.5523 19 20 18.5523 20 18V11H18C17.4477 11 17 10.5523 17 10V6.41421L15.3431 4.75736L16.7574 3.34315L21.7071 8.29289C21.9024 8.48816 22 8.74408 22 9V18C22 19.6569 20.6569 21 19 21C17.3431 21 16 19.6569 16 18V14H14V19ZM5 19H12V13H5V19ZM5 5V11H12V5H5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b010813bcfa03f09(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.0003 20.9998H18.0003V22.9998H6.00032V20.9998H11.0003V19.9505C7.70689 19.6235 4.88351 17.6986 3.31641 14.9621L5.05319 13.9696C6.43208 16.3775 9.02674 17.9998 12.0003 17.9998C16.4186 17.9998 20.0003 14.4181 20.0003 9.99983C20.0003 7.02625 18.378 4.43159 15.9701 3.0527L16.9626 1.31592C19.9724 3.03953 22.0003 6.28285 22.0003 9.99983C22.0003 15.1852 18.0536 19.4487 13.0003 19.9505V20.9998ZM12.0003 16.9998C8.13433 16.9998 5.00032 13.8658 5.00032 9.99983C5.00032 6.13384 8.13433 2.99983 12.0003 2.99983C15.8663 2.99983 19.0003 6.13384 19.0003 9.99983C19.0003 13.8658 15.8663 16.9998 12.0003 16.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dcbafc3f98575213(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.0003 20.9998H18.0003V22.9998H6.00032V20.9998H11.0003V19.9505C7.70689 19.6235 4.88351 17.6986 3.31641 14.9621L5.05319 13.9696C6.43208 16.3775 9.02674 17.9998 12.0003 17.9998C16.4186 17.9998 20.0003 14.4181 20.0003 9.99983C20.0003 7.02625 18.378 4.43159 15.9701 3.0527L16.9626 1.31592C19.9724 3.03953 22.0003 6.28285 22.0003 9.99983C22.0003 15.1852 18.0536 19.4487 13.0003 19.9505V20.9998ZM12.0003 16.9998C8.13433 16.9998 5.00032 13.8658 5.00032 9.99983C5.00032 6.13384 8.13433 2.99983 12.0003 2.99983C15.8663 2.99983 19.0003 6.13384 19.0003 9.99983C19.0003 13.8658 15.8663 16.9998 12.0003 16.9998ZM12.0003 14.9998C14.7617 14.9998 17.0003 12.7613 17.0003 9.99983C17.0003 7.23841 14.7617 4.99983 12.0003 4.99983C9.2389 4.99983 7.00032 7.23841 7.00032 9.99983C7.00032 12.7613 9.2389 14.9998 12.0003 14.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9605d88500211f29(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19V13.8889L3 5V3H21V5L13 13.8889V19H18V21H6V19H11ZM7.49073 7H16.5093L18.3093 5H5.69072L7.49073 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d009c0cddab459b0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19V13.8889L3 5V3H21V5L13 13.8889V19H18V21H6V19H11ZM7.49073 7H16.5093L18.3093 5H5.69072L7.49073 7ZM9.29072 9L12 12.0103L14.7093 9H9.29072Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ca2216922b94aac4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8V16C13 17.6569 11.6569 19 10 19H7.82929C7.41746 20.1652 6.30622 21 5 21C3.34315 21 2 19.6569 2 18C2 16.3431 3.34315 15 5 15C6.30622 15 7.41746 15.8348 7.82929 17H10C10.5523 17 11 16.5523 11 16V8C11 6.34315 12.3431 5 14 5H17V2L22 6L17 10V7H14C13.4477 7 13 7.44772 13 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$59a258ae5524c852(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8V16C13 17.6569 11.6569 19 10 19H7.82929C7.41746 20.1652 6.30622 21 5 21C3.34315 21 2 19.6569 2 18C2 16.3431 3.34315 15 5 15C6.30622 15 7.41746 15.8348 7.82929 17H10C10.5523 17 11 16.5523 11 16V8C11 6.34315 12.3431 5 14 5H17V2L22 6L17 10V7H14C13.4477 7 13 7.44772 13 8ZM5 19C5.55228 19 6 18.5523 6 18C6 17.4477 5.55228 17 5 17C4.44772 17 4 17.4477 4 18C4 18.5523 4.44772 19 5 19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$609eb3c602b01b96(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V20H20V17H4V20H2V4H4V14H12V7H18C20.2091 7 22 8.79086 22 11ZM8 13C6.34315 13 5 11.6569 5 10C5 8.34315 6.34315 7 8 7C9.65685 7 11 8.34315 11 10C11 11.6569 9.65685 13 8 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5693abb6319bddb2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V20H20V17H4V20H2V4H4V14H12V7H18C20.2091 7 22 8.79086 22 11ZM20 14V11C20 9.89543 19.1046 9 18 9H14V14H20ZM8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11ZM8 13C6.34315 13 5 11.6569 5 10C5 8.34315 6.34315 7 8 7C9.65685 7 11 8.34315 11 10C11 11.6569 9.65685 13 8 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4278e45e6480d832(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM7.19709 14.682L5.02243 16.8555C5.52665 17.5788 6.14045 18.2199 6.83975 18.7549L7.14462 18.9777L9.31803 16.8029C8.51078 16.3512 7.82909 15.7018 7.33848 14.9203L7.19709 14.682ZM16.8029 14.682C16.3512 15.4892 15.7018 16.1709 14.9203 16.6615L14.682 16.8029L16.8555 18.9776C17.5787 18.4734 18.2198 17.8596 18.7549 17.1604L18.9776 16.8555L16.8029 14.682ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8ZM7.14462 5.02232C6.42133 5.52656 5.78012 6.14039 5.24506 6.83973L5.02232 7.14462L7.19709 9.31803C7.64883 8.51078 8.2982 7.82909 9.07969 7.33848L9.31803 7.19709L7.14462 5.02232ZM16.8555 5.02243L14.682 7.19709C15.4892 7.64883 16.1709 8.2982 16.6615 9.07969L16.8029 9.31803L18.9777 7.14462C18.4735 6.42137 17.8597 5.7802 17.1604 5.24516L16.8555 5.02243Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$68e194c1337a2104(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 17C11.355 17 10.7386 16.8779 10.1725 16.6555L7.93604 18.8923C9.12707 19.5961 10.5164 20 12 20C13.4836 20 14.8729 19.5961 16.064 18.8923L13.8275 16.6555C13.2614 16.8779 12.645 17 12 17ZM4 12C4 13.4836 4.40386 14.8729 5.10765 16.064L7.34451 13.8275C7.12213 13.2614 7 12.645 7 12C7 11.355 7.12213 10.7386 7.34451 10.1725L5.10765 7.93604C4.40386 9.12707 4 10.5164 4 12ZM18.8923 7.93604L16.6555 10.1725C16.8779 10.7386 17 11.355 17 12C17 12.645 16.8779 13.2614 16.6555 13.8275L18.8923 16.064C19.5961 14.8729 20 13.4836 20 12C20 10.5164 19.5961 9.12707 18.8923 7.93604ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM12 4C10.5164 4 9.12707 4.40386 7.93604 5.10765L10.1725 7.34451C10.7386 7.12213 11.355 7 12 7C12.645 7 13.2614 7.12213 13.8275 7.34451L16.064 5.10765C14.8729 4.40386 13.4836 4 12 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9c9fa1eac7f78cf2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.50045 20.0005C6.32888 20.0005 7.00045 20.672 7.00045 21.5005C7.00045 22.3289 6.32888 23.0005 5.50045 23.0005C4.67203 23.0005 4.00045 22.3289 4.00045 21.5005C4.00045 20.672 4.67203 20.0005 5.50045 20.0005ZM18.5005 20.0005C19.3289 20.0005 20.0005 20.672 20.0005 21.5005C20.0005 22.3289 19.3289 23.0005 18.5005 23.0005C17.672 23.0005 17.0005 22.3289 17.0005 21.5005C17.0005 20.672 17.672 20.0005 18.5005 20.0005ZM2.17203 1.75781L5.99981 5.58581V16.9998L20.0005 17.0005V19.0005H5.00045C4.44817 19.0005 4.00045 18.5527 4.00045 18.0005L3.99981 6.41381L0.757812 3.17203L2.17203 1.75781ZM16.0005 3.00045C16.5527 3.00045 17.0005 3.44817 17.0005 4.00045L16.9998 5.99981L19.9936 6.00045C20.5497 6.00045 21.0005 6.45612 21.0005 6.99585V15.0051C21.0005 15.5548 20.5505 16.0005 19.9936 16.0005H8.0073C7.45123 16.0005 7.00045 15.5448 7.00045 15.0051V6.99585C7.00045 6.44611 7.4504 6.00045 8.0073 6.00045L10.9998 5.99981L11.0005 4.00045C11.0005 3.44817 11.4482 3.00045 12.0005 3.00045H16.0005ZM11.0005 8.00045H10.0005V14.0005H11.0005V8.00045ZM18.0005 8.00045H17.0005V14.0005H18.0005V8.00045ZM15.0005 5.00045H13.0005V6.00045H15.0005V5.00045Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$65cc4e36e736487f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.50045 20.0005C6.32888 20.0005 7.00045 20.672 7.00045 21.5005C7.00045 22.3289 6.32888 23.0005 5.50045 23.0005C4.67203 23.0005 4.00045 22.3289 4.00045 21.5005C4.00045 20.672 4.67203 20.0005 5.50045 20.0005ZM18.5005 20.0005C19.3289 20.0005 20.0005 20.672 20.0005 21.5005C20.0005 22.3289 19.3289 23.0005 18.5005 23.0005C17.672 23.0005 17.0005 22.3289 17.0005 21.5005C17.0005 20.672 17.672 20.0005 18.5005 20.0005ZM2.17203 1.75781L5.99981 5.58581V16.9998L20.0005 17.0005V19.0005H5.00045C4.44817 19.0005 4.00045 18.5527 4.00045 18.0005L3.99981 6.41381L0.757812 3.17203L2.17203 1.75781ZM16.0005 3.00045C16.5527 3.00045 17.0005 3.44817 17.0005 4.00045L16.9998 5.99981L19.9936 6.00045C20.5497 6.00045 21.0005 6.45612 21.0005 6.99585V15.0051C21.0005 15.5548 20.5505 16.0005 19.9936 16.0005H8.0073C7.45123 16.0005 7.00045 15.5448 7.00045 15.0051V6.99585C7.00045 6.44611 7.4504 6.00045 8.0073 6.00045L10.9998 5.99981L11.0005 4.00045C11.0005 3.44817 11.4482 3.00045 12.0005 3.00045H16.0005ZM9.99981 7.99981L9.00045 8.00045V14.0005L9.99981 13.9998V7.99981ZM15.9998 7.99981H11.9998V13.9998H15.9998V7.99981ZM19.0005 8.00045L17.9998 7.99981V13.9998L19.0005 14.0005V8.00045ZM15.0005 5.00045H13.0005V6.00045H15.0005V5.00045Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4eb8cf36c26a676f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3C15.5523 3 16 3.44772 16 4V6H20C20.5523 6 21 6.44772 21 7V19H23V21H1V19H3V7C3 6.44772 3.44772 6 4 6H8V4C8 3.44772 8.44772 3 9 3H15ZM10 8H8V19H10V8ZM16 8H14V19H16V8ZM14 5H10V6H14V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9b19b74d7fb06767(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3C15.5523 3 16 3.44772 16 4V6H20C20.5523 6 21 6.44772 21 7V19H23V21H1V19H3V7C3 6.44772 3.44772 6 4 6H8V4C8 3.44772 8.44772 3 9 3H15ZM8 8H5V19H8V8ZM14 8H10V19H14V8ZM19 8H16V19H19V8ZM14 5H10V6H14V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$778d82391c6e2d44(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5L9 2L15 5L21.303 2.2987C21.5569 2.18992 21.8508 2.30749 21.9596 2.56131C21.9862 2.62355 22 2.69056 22 2.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V5ZM15 19.7639V7.17594L14.9352 7.20369L9 4.23607V16.8241L9.06476 16.7963L15 19.7639Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ec7789d29874ff40(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5L9 2L15 5L21.303 2.2987C21.5569 2.18992 21.8508 2.30749 21.9596 2.56131C21.9862 2.62355 22 2.69056 22 2.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V5ZM16 19.3955L20 17.6812V5.03308L16 6.74736V19.3955ZM14 19.2639V6.73607L10 4.73607V17.2639L14 19.2639ZM8 17.2526V4.60451L4 6.31879V18.9669L8 17.2526Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a8a94a75ad018546(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5L9 2L15 5L21.303 2.2987C21.5569 2.18992 21.8508 2.30749 21.9596 2.56131C21.9862 2.62355 22 2.69056 22 2.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eae5d0c7958a678b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5L9 2L15 5L21.303 2.2987C21.5569 2.18992 21.8508 2.30749 21.9596 2.56131C21.9862 2.62355 22 2.69056 22 2.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V5ZM14.9352 7.20369L8.93524 4.20369L4 6.31879V18.9669L9.06476 16.7963L15.0648 19.7963L20 17.6812V5.03308L14.9352 7.20369Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1793cd34afe79392(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.364 17.364L12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5e2ba3123419390(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995L16.9497 15.9497ZM12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2406905f5162d90d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19.9451C6.50005 19.4476 3 15.6326 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11C21 15.6326 17.5 19.4476 13 19.9451V24H11V19.9451Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d95a6b3d35bc34e7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19.9451C6.50005 19.4476 3 15.6326 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11C21 15.6326 17.5 19.4476 13 19.9451V24H11V19.9451ZM12 18C15.866 18 19 14.866 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 14.866 8.13401 18 12 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5286c3aff006ea71(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17.9381C7.05369 17.446 4 14.0796 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 14.0796 16.9463 17.446 13 17.9381V21H11V17.9381ZM5 22H19V24H5V22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cbba68beaf3b0ebe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17.9381C7.05369 17.446 4 14.0796 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 14.0796 16.9463 17.446 13 17.9381V21H11V17.9381ZM12 16C15.3137 16 18 13.3137 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16ZM5 22H19V24H5V22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9b9dceb510c601c5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6569 15.6569L12 21.3137L6.34315 15.6569C3.21895 12.5327 3.21895 7.46734 6.34315 4.34315C9.46734 1.21895 14.5327 1.21895 17.6569 4.34315C20.781 7.46734 20.781 12.5327 17.6569 15.6569ZM5 22H19V24H5V22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$759f878a368659cc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18.4853L16.2426 14.2426C18.5858 11.8995 18.5858 8.10051 16.2426 5.75736C13.8995 3.41421 10.1005 3.41421 7.75736 5.75736C5.41421 8.10051 5.41421 11.8995 7.75736 14.2426L12 18.4853ZM17.6569 15.6569L12 21.3137L6.34315 15.6569C3.21895 12.5327 3.21895 7.46734 6.34315 4.34315C9.46734 1.21895 14.5327 1.21895 17.6569 4.34315C20.781 7.46734 20.781 12.5327 17.6569 15.6569ZM5 22H19V24H5V22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ec51db520eb7ad83(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.364 17.364L12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364ZM11 10H8V12H11V15H13V12H16V10H13V7H11V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fec059fda40f58f2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM11 10V7H13V10H16V12H13V15H11V12H8V10H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e530a52492ed0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.364 17.364L12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364ZM12 15C14.2091 15 16 13.2091 16 11C16 8.79086 14.2091 7 12 7C9.79086 7 8 8.79086 8 11C8 13.2091 9.79086 15 12 15ZM12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$397c9ea1d9b31460(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 15C9.79086 15 8 13.2091 8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d0df9a51f2da7cf5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17.9381C7.05369 17.446 4 14.0796 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 14.0796 16.9463 17.446 13 17.9381V20.0116C16.9463 20.1039 20 20.7351 20 21.5C20 22.3284 16.4183 23 12 23C7.58172 23 4 22.3284 4 21.5C4 20.7351 7.05369 20.1039 11 20.0116V17.9381ZM12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b921302497e8368d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17.9381C7.05369 17.446 4 14.0796 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 14.0796 16.9463 17.446 13 17.9381V20.0116C16.9463 20.1039 20 20.7351 20 21.5C20 22.3284 16.4183 23 12 23C7.58172 23 4 22.3284 4 21.5C4 20.7351 7.05369 20.1039 11 20.0116V17.9381ZM12 16C15.3137 16 18 13.3137 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16ZM12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$84d4c5cab337ceb7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11V6H11V13H17V11H13ZM18.364 17.364L12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$489f66ed16cc80ba(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995L16.9497 15.9497ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM13 11H17V13H11V6H13V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e2fdfa65aac765f4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0839 15.812C19.6827 13.0691 19.6379 8.73845 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.36205 8.73845 4.31734 13.0691 6.91612 15.812C7.97763 14.1228 9.8577 13 12 13C14.1423 13 16.0224 14.1228 17.0839 15.812ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a7803756afa41bea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0839 15.812C19.6827 13.0691 19.6379 8.73845 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.36205 8.73845 4.31734 13.0691 6.91612 15.812C7.97763 14.1228 9.8577 13 12 13C14.1423 13 16.0224 14.1228 17.0839 15.812ZM8.38535 17.2848L12 20.8995L15.6147 17.2848C14.9725 15.9339 13.5953 15 12 15C10.4047 15 9.0275 15.9339 8.38535 17.2848ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 10C12.5523 10 13 9.55228 13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9C11 9.55228 11.4477 10 12 10ZM12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$80c616ff85737c8a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.36547 10L11.2 8H14.6915L13.5996 5H11V3H15L16.0919 6H20V9H17.1838L18.6405 13.0022C21.0608 13.0764 23 15.0617 23 17.5C23 19.9853 20.9853 22 18.5 22C16.0147 22 14 19.9853 14 17.5C14 15.6722 15.0897 14.0989 16.6549 13.3944L15.4194 10H14.4718L12.89 15.87L9.96536 16.9389C9.98822 17.1227 10 17.31 10 17.5C10 19.9853 7.98528 22 5.5 22C3.01472 22 1 19.9853 1 17.5C1 15.5407 2.25221 13.8738 4 13.2561V12H2V10H8.36547ZM5.5 20C6.88071 20 8 18.8807 8 17.5C8 16.1193 6.88071 15 5.5 15C4.11929 15 3 16.1193 3 17.5C3 18.8807 4.11929 20 5.5 20ZM18.5 20C19.8807 20 21 18.8807 21 17.5C21 16.1193 19.8807 15 18.5 15C17.1193 15 16 16.1193 16 17.5C16 18.8807 17.1193 20 18.5 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$414f24dc794479f5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13.2561V12H2V10H8.36547L11.2 8H14.6915L13.5996 5H11V3H15L16.0919 6H20V9H17.1838L18.6405 13.0022C21.0608 13.0764 23 15.0617 23 17.5C23 19.9853 20.9853 22 18.5 22C16.0147 22 14 19.9853 14 17.5C14 15.6722 15.0897 14.0989 16.6549 13.3944L15.4194 10H14.4718L12.89 15.87L12.8876 15.8689L12.8897 15.8745L9.96536 16.9389C9.98822 17.1227 10 17.31 10 17.5C10 19.9853 7.98528 22 5.5 22C3.01472 22 1 19.9853 1 17.5C1 15.5407 2.25221 13.8738 4 13.2561ZM6 13.0275C7.37617 13.1796 8.56531 13.9523 9.28138 15.0595L11.2383 14.3472L12.4032 10H11.8563L9 12H6V13.0275ZM5.5 20C6.88071 20 8 18.8807 8 17.5C8 16.1193 6.88071 15 5.5 15C4.11929 15 3 16.1193 3 17.5C3 18.8807 4.11929 20 5.5 20ZM18.5 20C19.8807 20 21 18.8807 21 17.5C21 16.1193 19.8807 15 18.5 15C17.1193 15 16 16.1193 16 17.5C16 18.8807 17.1193 20 18.5 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f344a6b89c78677(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.89945 2.30007L21.7052 8.56867C21.9672 8.65599 22.1088 8.93915 22.0215 9.20112C21.975 9.34065 21.8694 9.45262 21.7328 9.50725L13.0002 13.0003L8.57501 21.8506C8.45151 22.0976 8.15118 22.1977 7.90419 22.0742C7.77883 22.0115 7.68553 21.8991 7.64703 21.7644L2.26058 2.91177C2.18472 2.64626 2.33846 2.36951 2.60398 2.29365C2.70087 2.26597 2.80386 2.26821 2.89945 2.30007Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e0401d7dbc563e65(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.96488 5.09625L8.5107 17.5066L11.5514 11.4253L17.188 9.17062L4.96488 5.09625ZM2.89945 2.29958L21.7052 8.56818C21.9672 8.6555 22.1088 8.93866 22.0215 9.20063C21.975 9.34016 21.8694 9.45214 21.7328 9.50676L13.0002 12.9998L8.57501 21.8501C8.45151 22.0971 8.15118 22.1972 7.90419 22.0737C7.77883 22.011 7.68553 21.8986 7.64703 21.7639L2.26058 2.91129C2.18472 2.64577 2.33846 2.36903 2.60398 2.29316C2.70087 2.26548 2.80386 2.26772 2.89945 2.29958Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b7a0f1388e7a94e3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5H19C19.5523 5 20 5.44772 20 6V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V11L8 5ZM13 1H18C18.5523 1 19 1.44772 19 2V4H12V2C12 1.44772 12.4477 1 13 1ZM6 12V19H8V12H6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c1bcd04793e94b1f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.07037 7L6 11.6056V20H18V7H9.07037ZM8 5H19C19.5523 5 20 5.44772 20 6V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V11L8 5ZM13 1H18C18.5523 1 19 1.44772 19 2V4H12V2C12 1.44772 12.4477 1 13 1ZM8 12H10V18H8V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$83df91c276d4e1e6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14H12.5C14.433 14 16 12.433 16 10.5C16 8.567 14.433 7 12.5 7H9V17H11V14ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM11 9H12.5C13.3284 9 14 9.67157 14 10.5C14 11.3284 13.3284 12 12.5 12H11V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9173698f8b8925ed(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5ZM9 7H12.5C14.433 7 16 8.567 16 10.5C16 12.433 14.433 14 12.5 14H11V17H9V7ZM11 9V12H12.5C13.3284 12 14 11.3284 14 10.5C14 9.67157 13.3284 9 12.5 9H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$64bd8ca64f23e7db(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3H13C16.3137 3 19 5.68629 19 9C19 12.3137 16.3137 15 13 15H10V21H6V3ZM10 7V11H13C14.1046 11 15 10.1046 15 9C15 7.89543 14.1046 7 13 7H10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4b23cddade77dd29(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3H13C16.3137 3 19 5.68629 19 9C19 12.3137 16.3137 15 13 15H8V21H6V3ZM8 5V13H13C15.2091 13 17 11.2091 17 9C17 6.79086 15.2091 5 13 5H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b1ad5f48d5d01f6e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20ZM16 16H8V18H16V16ZM12 6C9.79086 6 8 7.79086 8 10C8 12.2091 9.79086 14 12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6ZM12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5c189fcfbb86d346(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20ZM19 4H5V20H19V4ZM16 16V18H8V16H16ZM12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6ZM12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3ac06b289abc1863(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.3891 10.3891L7.5 14.2782L3.61091 10.3891C1.46303 8.2412 1.46303 4.7588 3.61091 2.61091C5.7588 0.463029 9.2412 0.463029 11.3891 2.61091C13.537 4.7588 13.537 8.2412 11.3891 10.3891ZM7.5 8.5C8.60457 8.5 9.5 7.60457 9.5 6.5C9.5 5.39543 8.60457 4.5 7.5 4.5C6.39543 4.5 5.5 5.39543 5.5 6.5C5.5 7.60457 6.39543 8.5 7.5 8.5ZM20.3891 19.3891L16.5 23.2782L12.6109 19.3891C10.463 17.2412 10.463 13.7588 12.6109 11.6109C14.7588 9.46303 18.2412 9.46303 20.3891 11.6109C22.537 13.7588 22.537 17.2412 20.3891 19.3891ZM16.5 17.5C17.6046 17.5 18.5 16.6046 18.5 15.5C18.5 14.3954 17.6046 13.5 16.5 13.5C15.3954 13.5 14.5 14.3954 14.5 15.5C14.5 16.6046 15.3954 17.5 16.5 17.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b8f9db3a729b2d75(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.97487 8.97487C11.3417 7.60804 11.3417 5.39196 9.97487 4.02513C8.60804 2.65829 6.39196 2.65829 5.02513 4.02513C3.65829 5.39196 3.65829 7.60804 5.02513 8.97487L7.5 11.4497L9.97487 8.97487ZM7.5 14.2782L3.61091 10.3891C1.46303 8.2412 1.46303 4.7588 3.61091 2.61091C5.7588 0.463029 9.2412 0.463029 11.3891 2.61091C13.537 4.7588 13.537 8.2412 11.3891 10.3891L7.5 14.2782ZM7.5 8C6.67157 8 6 7.32843 6 6.5C6 5.67157 6.67157 5 7.5 5C8.32843 5 9 5.67157 9 6.5C9 7.32843 8.32843 8 7.5 8ZM16.5 20.4497L18.9749 17.9749C20.3417 16.608 20.3417 14.392 18.9749 13.0251C17.608 11.6583 15.392 11.6583 14.0251 13.0251C12.6583 14.392 12.6583 16.608 14.0251 17.9749L16.5 20.4497ZM20.3891 19.3891L16.5 23.2782L12.6109 19.3891C10.463 17.2412 10.463 13.7588 12.6109 11.6109C14.7588 9.46303 18.2412 9.46303 20.3891 11.6109C22.537 13.7588 22.537 17.2412 20.3891 19.3891ZM16.5 17C15.6716 17 15 16.3284 15 15.5C15 14.6716 15.6716 14 16.5 14C17.3284 14 18 14.6716 18 15.5C18 16.3284 17.3284 17 16.5 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b906a5522e2ff5b9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8.94737L22 14V16L14 13.4737V18.8333L17 20.5V22L12.5 21L8 22V20.5L11 18.8333V13.4737L3 16V14L11 8.94737V3.5C11 2.67157 11.6716 2 12.5 2C13.3284 2 14 2.67157 14 3.5V8.94737Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c825c5774ee8309f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8.94737L22 14V16L14 13.4737V18.8333L17 20.5V22L12.5 21L8 22V20.5L11 18.8333V13.4737L3 16V14L11 8.94737V3.5C11 2.67157 11.6716 2 12.5 2C13.3284 2 14 2.67157 14 3.5V8.94737Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4e6836974c07a8ab(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.32244 5.96577C5.42367 5.85395 5.5282 5.74405 5.63604 5.6362C6.11945 5.1528 6.64417 4.73588 7.19883 4.38544C6.8849 4.29891 6.60274 4.24766 6.35542 4.22901C5.78308 4.18584 5.53243 4.32175 5.42553 4.42865C5.31863 4.53555 5.18272 4.7862 5.22589 5.35853C5.23974 5.54216 5.27156 5.74499 5.32244 5.96577ZM20.7257 14.2109C20.7873 14.3339 20.8463 14.4559 20.9028 14.5768C21.3793 15.5979 21.6941 16.5946 21.7616 17.4905C21.8289 18.3821 21.656 19.3109 20.9819 19.985C20.3077 20.6591 19.379 20.832 18.4874 20.7648C17.7068 20.7059 16.8497 20.4593 15.9666 20.0817L15.964 20.0829C15.8109 20.0174 15.657 19.948 15.5025 19.8748C13.4695 18.9125 11.1435 17.2207 8.9599 15.0371C6.77855 12.8558 5.08807 10.5323 4.1252 8.50091C4.05178 8.346 3.98205 8.19166 3.91629 8.03814L3.91734 8.036C3.53815 7.1507 3.29057 6.2914 3.23155 5.50895C3.1643 4.61731 3.33717 3.68858 4.01132 3.01444C4.68547 2.34029 5.61419 2.16742 6.50583 2.23467C7.40174 2.30224 8.3984 2.61703 9.41949 3.09353C9.54253 3.15096 9.66667 3.21108 9.79181 3.27384C12.7623 2.52515 16.0404 3.3126 18.364 5.6362C20.6882 7.96047 21.4755 11.2397 20.7257 14.2109ZM19.6128 16.8044C19.2627 17.3579 18.8465 17.8816 18.364 18.3641C18.257 18.4711 18.1479 18.5749 18.037 18.6754C18.2553 18.7254 18.456 18.7567 18.6378 18.7704C19.2101 18.8136 19.4608 18.6777 19.5677 18.5708C19.6746 18.4639 19.8105 18.2132 19.7673 17.6409C19.7488 17.3954 19.6982 17.1156 19.6128 16.8044ZM5.63604 18.3641C3.37241 16.1005 2.56666 12.9311 3.21877 10.0226C4.30105 12.0034 5.92374 14.1223 7.89924 16.0978C9.87632 18.0748 11.9971 19.6986 13.9794 20.781C11.0705 21.4339 7.90015 20.6282 5.63604 18.3641Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$282aef226fb8749c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.91762 8.0366C3.32984 9.23328 3 10.5792 3 11.9999C3 16.9704 7.02944 20.9999 12 20.9999C13.4216 20.9999 14.7684 20.6696 15.9657 20.081C16.8385 20.4544 17.6848 20.6991 18.4564 20.762C19.3582 20.8356 20.3 20.6665 20.9818 19.9847C21.7339 19.2325 21.8625 18.1689 21.7279 17.1727C21.6052 16.2638 21.2481 15.2537 20.726 14.2114C20.9051 13.503 21 12.7619 21 11.9999C21 7.02929 16.9706 2.99986 12 2.99986C11.2389 2.99986 10.4987 3.09454 9.79103 3.27318C8.7474 2.7498 7.73605 2.39172 6.8261 2.26834C5.82897 2.13315 4.76406 2.26128 4.01121 3.01413C3.3287 3.69664 3.16001 4.63956 3.2341 5.54233C3.29752 6.315 3.54313 7.16247 3.91762 8.0366ZM5.3224 5.96574C5.2734 5.75321 5.24204 5.55715 5.2274 5.37873C5.17928 4.79243 5.31727 4.53649 5.42543 4.42834C5.54452 4.30925 5.84797 4.15403 6.55739 4.25021C6.75482 4.27698 6.96951 4.32189 7.2 4.38547C6.50364 4.82527 5.87203 5.35784 5.3224 5.96574ZM19.6124 16.803C19.6751 17.0316 19.7195 17.2445 19.7459 17.4404C19.8416 18.1485 19.6865 18.4515 19.5676 18.5705C19.4595 18.6785 19.204 18.8163 18.6189 18.7686C18.4419 18.7542 18.2475 18.7233 18.0368 18.675C18.6427 18.1268 19.1736 17.4971 19.6124 16.803ZM15.8812 17.8264C14.2046 16.9482 12.2571 15.5026 10.3752 13.6207C8.4954 11.741 7.05092 9.79561 6.17241 8.12028C7.06357 6.78465 8.40124 5.77312 9.96933 5.29866C10.6108 5.10457 11.2923 4.99986 12 4.99986C15.866 4.99986 19 8.13386 19 11.9999C19 12.7083 18.8951 13.3904 18.7006 14.0325C18.2261 15.5991 17.2155 16.9356 15.8812 17.8264ZM13.6052 18.8152C13.0901 18.9359 12.5528 18.9999 12 18.9999C8.13401 18.9999 5 15.8658 5 11.9999C5 11.4476 5.06377 10.9109 5.18429 10.3963C6.14883 11.913 7.43475 13.5087 8.96096 15.0349C10.489 16.563 12.0868 17.8502 13.6052 18.8152Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7b1f710d05edb55(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13.5V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V13.5L0.757464 13.1894C0.312297 13.0781 0 12.6781 0 12.2192V11.5C0 11.2239 0.223858 11 0.5 11H2.42857L4.4805 6.21216C4.79566 5.47679 5.51874 5 6.31879 5H8V3H11V5H13V3H16V5H17.6812C18.4813 5 19.2043 5.47679 19.5195 6.21216L21.5714 11H23.5C23.7761 11 24 11.2239 24 11.5V12.2192C24 12.6781 23.6877 13.0781 23.2425 13.1894L22 13.5ZM4 15V17C4 17.5523 4.44772 18 5 18H8.24496C8.3272 18 8.40818 17.9797 8.4807 17.9409C8.72418 17.8107 8.81602 17.5078 8.68582 17.2643L8.68588 17.2643C7.87868 15.7548 6.31672 15 4 15ZM20 15C17.6833 15 16.1213 15.7548 15.3141 17.2643L15.3142 17.2643C15.184 17.5078 15.2758 17.8107 15.5193 17.9409C15.5918 17.9797 15.6728 18 15.755 18H19C19.5523 18 20 17.5523 20 17V15ZM6 7L4.54856 10.6286C4.50131 10.7467 4.47703 10.8728 4.47703 11C4.47703 11.5523 4.92475 12 5.47703 12H18.523C18.6502 12 18.7762 11.9757 18.8944 11.9285C19.4071 11.7234 19.6566 11.1414 19.4514 10.6286L18 7H6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f3c3a8e6911b76e5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13V18H20V13H4ZM5.61803 11H18.382C18.5372 11 18.6903 10.9639 18.8292 10.8944C19.3232 10.6474 19.5234 10.0468 19.2764 9.55279L18 7H6L4.72361 9.55279C4.65418 9.69164 4.61803 9.84475 4.61803 10C4.61803 10.5523 5.06575 11 5.61803 11ZM22 13.5V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V13.5L0.757464 13.1894C0.312297 13.0781 0 12.6781 0 12.2192V11.5C0 11.2239 0.223858 11 0.5 11H2L4.44721 6.10557C4.786 5.428 5.47852 5 6.23607 5H8V3H11V5H13V3H16V5H17.7639C18.5215 5 19.214 5.428 19.5528 6.10557L22 11H23.5C23.7761 11 24 11.2239 24 11.5V12.2192C24 12.6781 23.6877 13.0781 23.2425 13.1894L22 13.5ZM5 14C7.31672 14 8.87868 14.7548 9.68588 16.2643L9.68582 16.2643C9.81602 16.5078 9.72418 16.8107 9.4807 16.9409C9.40818 16.9797 9.3272 17 9.24496 17H6C5.44772 17 5 16.5523 5 16V14ZM19 14V16C19 16.5523 18.5523 17 18 17H14.755C14.6728 17 14.5918 16.9797 14.5193 16.9409C14.2758 16.8107 14.184 16.5078 14.3142 16.2643L14.3141 16.2643C15.1213 14.7548 16.6833 14 19 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$82213c5c7a3a191(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3V5H17V11L19 14V16H13V23H11V16H5V14L7 11V5H6V3H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$65e64e68764a4550(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3V5H17V11L19 14V16H13V23H11V16H5V14L7 11V5H6V3H18ZM9 5V11.6056L7.4037 14H16.5963L15 11.6056V5H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e874e5912add6de8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.3126 10.1752L20.8984 11.5894L20.1913 10.8823L15.9486 15.125L15.2415 18.6605L13.8273 20.0747L9.58466 15.8321L4.63492 20.7818L3.2207 19.3676L8.17045 14.4179L3.92781 10.1752L5.34202 8.76101L8.87756 8.0539L13.1202 3.81126L12.4131 3.10416L13.8273 1.68994L22.3126 10.1752Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8629e86f75810d8a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.8273 1.68994L22.3126 10.1752L20.8984 11.5894L20.1913 10.8823L15.9486 15.125L15.2415 18.6605L13.8273 20.0747L9.58466 15.8321L4.63492 20.7818L3.2207 19.3676L8.17045 14.4179L3.92781 10.1752L5.34202 8.76101L8.87756 8.0539L13.1202 3.81126L12.4131 3.10416L13.8273 1.68994ZM14.5344 5.22548L9.86358 9.89631L7.0417 10.4607L13.5418 16.9608L14.1062 14.1389L18.7771 9.46812L14.5344 5.22548Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ce16a3b4ce3124c8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.22235 3.80777L10.9399 10.5253L8.11144 13.3537L4.22235 9.46463C2.66026 7.90253 2.66026 5.36987 4.22235 3.80777ZM14.2683 12.1466L13.4147 13.0002L20.4858 20.0712L19.0716 21.4854L12.0005 14.4144L4.92946 21.4854L3.51525 20.0712L12.854 10.7324C12.2664 9.27549 12.8738 7.17715 14.4754 5.57554C16.428 3.62292 19.119 3.14805 20.4858 4.51488C21.8526 5.88172 21.3778 8.57267 19.4251 10.5253C17.8235 12.1269 15.7252 12.7343 14.2683 12.1466Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$550a793596448beb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.2683 12.1466L13.4147 13.0002L20.4858 20.0712L19.0716 21.4854L12.0005 14.4144L4.92946 21.4854L3.51525 20.0712L12.854 10.7324C12.2664 9.27549 12.8738 7.17715 14.4754 5.57554C16.428 3.62292 19.119 3.14805 20.4858 4.51488C21.8526 5.88172 21.3778 8.57267 19.4251 10.5253C17.8235 12.1269 15.7252 12.7343 14.2683 12.1466ZM4.22235 3.80777L10.9399 10.5253L8.11144 13.3537L4.22235 9.46463C2.66026 7.90253 2.66026 5.36987 4.22235 3.80777ZM18.0109 9.11107C19.2682 7.85386 19.5274 6.38488 19.0716 5.92909C18.6158 5.47331 17.1468 5.73254 15.8896 6.98975C14.6324 8.24697 14.3732 9.71595 14.829 10.1717C15.2847 10.6275 16.7537 10.3683 18.0109 9.11107Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$17fe24d37c6f072a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2V22H19V14H16V7C16 4.23858 18.2386 2 21 2ZM9 13.9V22H7V13.9C4.71776 13.4367 3 11.419 3 9V3H5V10H7V3H9V10H11V3H13V9C13 11.419 11.2822 13.4367 9 13.9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$da259dc95bb22179(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2V22H19V15H15V8C15 4.68629 17.6863 2 21 2ZM19 4.53C18.17 5 17 6.17 17 8V13H19V4.53ZM9 13.9V22H7V13.9C4.71776 13.4367 3 11.419 3 9V3H5V10H7V3H9V10H11V3H13V9C13 11.419 11.2822 13.4367 9 13.9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eb0457446f5eec99(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 21C3.01472 21 1 18.9853 1 16.5C1 14.0147 3.01472 12 5.5 12C7.98528 12 10 14.0147 10 16.5C10 18.9853 7.98528 21 5.5 21ZM5.5 18C6.32843 18 7 17.3284 7 16.5C7 15.6716 6.32843 15 5.5 15C4.67157 15 4 15.6716 4 16.5C4 17.3284 4.67157 18 5.5 18ZM18.5 21C16.0147 21 14 18.9853 14 16.5C14 14.0147 16.0147 12 18.5 12C20.9853 12 23 14.0147 23 16.5C23 18.9853 20.9853 21 18.5 21ZM18.5 18C19.3284 18 20 17.3284 20 16.5C20 15.6716 19.3284 15 18.5 15C17.6716 15 17 15.6716 17 16.5C17 17.3284 17.6716 18 18.5 18ZM11.5314 9.79706L13 12V18H11V13L8.28117 10.7343C8.18221 10.6661 8.08802 10.588 8 10.5C7.21895 9.71895 7.21895 8.45262 8 7.67157L10.8284 4.84315C11.6095 4.0621 12.8758 4.0621 13.6569 4.84315L15.0711 6.25736C16.1746 7.36086 17.5548 8.01891 18.9884 8.23151L18.978 10.2474C17.0335 10.0218 15.1485 9.16323 13.6569 7.67157L11.5314 9.79706ZM16 5C14.8954 5 14 4.10457 14 3C14 1.89543 14.8954 1 16 1C17.1046 1 18 1.89543 18 3C18 4.10457 17.1046 5 16 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eaf4253c6fbb155d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 21C3.01472 21 1 18.9853 1 16.5C1 14.0147 3.01472 12 5.5 12C7.98528 12 10 14.0147 10 16.5C10 18.9853 7.98528 21 5.5 21ZM5.5 19C6.88071 19 8 17.8807 8 16.5C8 15.1193 6.88071 14 5.5 14C4.11929 14 3 15.1193 3 16.5C3 17.8807 4.11929 19 5.5 19ZM18.5 21C16.0147 21 14 18.9853 14 16.5C14 14.0147 16.0147 12 18.5 12C20.9853 12 23 14.0147 23 16.5C23 18.9853 20.9853 21 18.5 21ZM18.5 19C19.8807 19 21 17.8807 21 16.5C21 15.1193 19.8807 14 18.5 14C17.1193 14 16 15.1193 16 16.5C16 17.8807 17.1193 19 18.5 19ZM11.023 10.3054L13 12V18H11V13L8.28117 10.7343C8.18221 10.6661 8.08802 10.588 8 10.5C7.21895 9.71895 7.21895 8.45262 8 7.67157L10.8284 4.84315C11.6095 4.0621 12.8758 4.0621 13.6569 4.84315L15.0711 6.25736C16.1746 7.36086 17.5548 8.01891 18.9884 8.23151L18.978 10.2474C17.0335 10.0218 15.1485 9.16323 13.6569 7.67157L11.023 10.3054ZM16 5C14.8954 5 14 4.10457 14 3C14 1.89543 14.8954 1 16 1C17.1046 1 18 1.89543 18 3C18 4.10457 17.1046 5 16 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c7c74f315cdf63ed(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9497 11.9497C18.7347 10.1648 19.3542 7.65558 18.8081 5.36796L21.303 4.2987C21.5569 4.18992 21.8508 4.30749 21.9596 4.56131C21.9862 4.62355 22 4.69056 22 4.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V7L5.12892 5.65904C4.70023 7.86632 5.34067 10.2402 7.05025 11.9497L12 16.8995L16.9497 11.9497ZM15.5355 10.5355L12 14.0711L8.46447 10.5355C6.51184 8.58291 6.51184 5.41709 8.46447 3.46447C10.4171 1.51184 13.5829 1.51184 15.5355 3.46447C17.4882 5.41709 17.4882 8.58291 15.5355 10.5355Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8fc390670413b588(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6.14286V18.9669L9.06476 16.7963L15.0648 19.7963L20 17.6812V4.85714L21.303 4.2987C21.5569 4.18992 21.8508 4.30749 21.9596 4.56131C21.9862 4.62355 22 4.69056 22 4.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V7L4 6.14286ZM16.2426 11.2426L12 15.4853L7.75736 11.2426C5.41421 8.89949 5.41421 5.10051 7.75736 2.75736C10.1005 0.414214 13.8995 0.414214 16.2426 2.75736C18.5858 5.10051 18.5858 8.89949 16.2426 11.2426ZM12 12.6569L14.8284 9.82843C16.3905 8.26633 16.3905 5.73367 14.8284 4.17157C13.2663 2.60948 10.7337 2.60948 9.17157 4.17157C7.60948 5.73367 7.60948 8.26633 9.17157 9.82843L12 12.6569Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$394857e3636a08fc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13.5V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V13.5L0.757464 13.1894C0.312297 13.0781 0 12.6781 0 12.2192V11.5C0 11.2239 0.223858 11 0.5 11H2.375L4.51334 5.29775C4.80607 4.51715 5.55231 4 6.386 4H17.614C18.4477 4 19.1939 4.51715 19.4867 5.29775L21.625 11H23.5C23.7761 11 24 11.2239 24 11.5V12.2192C24 12.6781 23.6877 13.0781 23.2425 13.1894L22 13.5ZM4 15V17C4 17.5523 4.44772 18 5 18H8.24496C8.3272 18 8.40818 17.9797 8.4807 17.9409C8.72418 17.8107 8.81602 17.5078 8.68582 17.2643L8.68588 17.2643C7.87868 15.7548 6.31672 15 4 15ZM20 15C17.6833 15 16.1213 15.7548 15.3141 17.2643L15.3142 17.2643C15.184 17.5078 15.2758 17.8107 15.5193 17.9409C15.5918 17.9797 15.6728 18 15.755 18H19C19.5523 18 20 17.5523 20 17V15ZM6 6L4.43874 10.6838C4.40475 10.7857 4.38743 10.8925 4.38743 11C4.38743 11.5523 4.83514 12 5.38743 12H18.6126C18.7201 12 18.8268 11.9827 18.9288 11.9487C19.4527 11.774 19.7359 11.2077 19.5613 10.6838L18 6H6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1fc22693c385feb6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V13.5L0.757464 13.1894C0.312297 13.0781 0 12.6781 0 12.2192V11.5C0 11.2239 0.223858 11 0.5 11H2L4.4805 5.21216C4.79566 4.47679 5.51874 4 6.31879 4H17.6812C18.4813 4 19.2043 4.47679 19.5195 5.21216L22 11H23.5C23.7761 11 24 11.2239 24 11.5V12.2192C24 12.6781 23.6877 13.0781 23.2425 13.1894L22 13.5V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20ZM20 18V13H4V18H20ZM5.47703 11H18.523C18.6502 11 18.7762 10.9757 18.8944 10.9285C19.4071 10.7234 19.6566 10.1414 19.4514 9.62861L18 6H6L4.54856 9.62861C4.50131 9.74673 4.47703 9.87278 4.47703 10C4.47703 10.5523 4.92475 11 5.47703 11ZM5 14C7.31672 14 8.87868 14.7548 9.68588 16.2643L9.68582 16.2643C9.81602 16.5078 9.72418 16.8107 9.4807 16.9409C9.40818 16.9797 9.3272 17 9.24496 17H6C5.44772 17 5 16.5523 5 16V14ZM19 14V16C19 16.5523 18.5523 17 18 17H14.755C14.6728 17 14.5918 16.9797 14.5193 16.9409C14.2758 16.8107 14.184 16.5078 14.3142 16.2643L14.3141 16.2643C15.1213 14.7548 16.6833 14 19 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$410ed79e43fdae77(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.49816 20.0047H15.5018C14.8432 21.5841 13.5794 22.848 12 23.5066C10.4206 22.848 9.15679 21.5841 8.49816 20.0047ZM18 14.8095L20 17.0777V19.0047H4V17.0777L6 14.8095V9.00475C6 5.5215 8.50442 2.55819 12 1.45996C15.4956 2.55819 18 5.5215 18 9.00475V14.8095ZM12 11.0047C13.1046 11.0047 14 10.1093 14 9.00475C14 7.90018 13.1046 7.00475 12 7.00475C10.8954 7.00475 10 7.90018 10 9.00475C10 10.1093 10.8954 11.0047 12 11.0047Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b2bd47f9ea12c390(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5018 20.0047C14.8432 21.5841 13.5794 22.848 12 23.5066C10.4206 22.848 9.15679 21.5841 8.49816 20.0047H10.7575C11.0838 20.4933 11.5051 20.9171 12 21.248C12.4949 20.9171 12.9162 20.4933 13.2425 20.0047H15.5018ZM18 14.8095L20 17.0777V19.0047H4V17.0777L6 14.8095V9.00475C6 5.5215 8.50442 2.55819 12 1.45996C15.4956 2.55819 18 5.5215 18 9.00475V14.8095ZM17.2692 17.0047L16 15.5653V9.00475C16 6.68691 14.4292 4.57428 12 3.58381C9.57078 4.57428 8 6.68691 8 9.00475V15.5653L6.73076 17.0047H17.2692ZM12 11.0047C10.8954 11.0047 10 10.1093 10 9.00475C10 7.90018 10.8954 7.00475 12 7.00475C13.1046 7.00475 14 7.90018 14 9.00475C14 10.1093 13.1046 11.0047 12 11.0047Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7a2980d21d9189a8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.33053 15.9287C5.115 14.9913 5.00054 14.0101 5.00054 12.9998C5.00054 7.91186 7.90319 3.56348 12.0005 1.81787C16.0979 3.56348 19.0005 7.91186 19.0005 12.9998C19.0005 14.0101 18.8861 14.9913 18.6706 15.9287L20.6907 17.7244C20.8704 17.8841 20.9109 18.1492 20.7872 18.3553L18.33 22.4507C18.1879 22.6875 17.8808 22.7643 17.644 22.6222C17.609 22.6012 17.5766 22.5759 17.5477 22.547L15.2934 20.2927C15.1059 20.1052 14.8515 19.9998 14.5863 19.9998H9.41476C9.14954 19.9998 8.89519 20.1052 8.70765 20.2927L6.45337 22.547C6.2581 22.7423 5.94152 22.7423 5.74626 22.547C5.71735 22.5181 5.6921 22.4857 5.67107 22.4507L3.21385 18.3553C3.09014 18.1492 3.13071 17.8841 3.31042 17.7244L5.33053 15.9287ZM12.0005 12.9998C13.1051 12.9998 14.0005 12.1044 14.0005 10.9998C14.0005 9.89525 13.1051 8.99982 12.0005 8.99982C10.896 8.99982 10.0005 9.89525 10.0005 10.9998C10.0005 12.1044 10.896 12.9998 12.0005 12.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a4f617441aef6dd9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.99958 12.9998C4.99958 7.91186 7.90222 3.56348 11.9996 1.81787C16.0969 3.56348 18.9996 7.91186 18.9996 12.9998C18.9996 13.8227 18.9236 14.6263 18.779 15.4026L20.7194 17.2352C20.8845 17.3911 20.9238 17.6388 20.815 17.8381L18.3196 22.4132C18.1873 22.6556 17.8836 22.7449 17.6412 22.6127C17.5993 22.5898 17.5608 22.5611 17.5271 22.5273L15.2925 20.2927C15.1049 20.1052 14.8506 19.9998 14.5854 19.9998H9.41379C9.14857 19.9998 8.89422 20.1052 8.70668 20.2927L6.47209 22.5273C6.27683 22.7226 5.96025 22.7226 5.76498 22.5273C5.73122 22.4935 5.70246 22.4551 5.67959 22.4132L3.18412 17.8381C3.07537 17.6388 3.11464 17.3911 3.27975 17.2352L5.22014 15.4026C5.07551 14.6263 4.99958 13.8227 4.99958 12.9998ZM6.47542 19.6955L7.29247 18.8785C7.85508 18.3159 8.61814 17.9998 9.41379 17.9998H14.5854C15.381 17.9998 16.1441 18.3159 16.7067 18.8785L17.5237 19.6955L18.5056 17.8954L17.4058 16.8566C16.9117 16.39 16.6884 15.7044 16.8128 15.0363C16.9366 14.3721 16.9996 13.691 16.9996 12.9998C16.9996 9.13025 15.0045 5.69953 11.9996 4.04021C8.99462 5.69953 6.99958 9.13025 6.99958 12.9998C6.99958 13.691 7.06255 14.3721 7.18631 15.0363C7.31078 15.7044 7.08746 16.39 6.59338 16.8566L5.49353 17.8954L6.47542 19.6955ZM11.9996 12.9998C10.895 12.9998 9.99958 12.1044 9.99958 10.9998C9.99958 9.89525 10.895 8.99982 11.9996 8.99982C13.1041 8.99982 13.9996 9.89525 13.9996 10.9998C13.9996 12.1044 13.1041 12.9998 11.9996 12.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$db81c7ab8be84bd1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15V8.5C4 6.01472 6.01472 4 8.5 4C10.9853 4 13 6.01472 13 8.5V15.5C13 16.8807 14.1193 18 15.5 18C16.8807 18 18 16.8807 18 15.5V8.82929C16.8348 8.41746 16 7.30622 16 6C16 4.34315 17.3431 3 19 3C20.6569 3 22 4.34315 22 6C22 7.30622 21.1652 8.41746 20 8.82929V15.5C20 17.9853 17.9853 20 15.5 20C13.0147 20 11 17.9853 11 15.5V8.5C11 7.11929 9.88071 6 8.5 6C7.11929 6 6 7.11929 6 8.5V15H9L5 20L1 15H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8ef54cdc615e3fd0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15V8.5C4 6.01472 6.01472 4 8.5 4C10.9853 4 13 6.01472 13 8.5V15.5C13 16.8807 14.1193 18 15.5 18C16.8807 18 18 16.8807 18 15.5V8.82929C16.8348 8.41746 16 7.30622 16 6C16 4.34315 17.3431 3 19 3C20.6569 3 22 4.34315 22 6C22 7.30622 21.1652 8.41746 20 8.82929V15.5C20 17.9853 17.9853 20 15.5 20C13.0147 20 11 17.9853 11 15.5V8.5C11 7.11929 9.88071 6 8.5 6C7.11929 6 6 7.11929 6 8.5V15H9L5 20L1 15H4ZM19 7C19.5523 7 20 6.55228 20 6C20 5.44772 19.5523 5 19 5C18.4477 5 18 5.44772 18 6C18 6.55228 18.4477 7 19 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ca49848af8524bf6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.82986 8.78986L7.99998 9.45588V13H5.99998V8.05H6.015L11.2834 6.13247C11.5274 6.03855 11.7922 5.99162 12.0648 6.0008C13.1762 6.02813 14.1522 6.75668 14.4917 7.82036C14.678 8.40431 14.848 8.79836 15.0015 9.0025C15.9138 10.2155 17.3653 11 19 11V13C16.8253 13 14.8823 12.0083 13.5984 10.4526L13.017 13.7497L15 15.67V23H13V17.0142L10.9507 15.0271L10.003 19.3253L3.10938 18.1098L3.45667 16.1401L8.38071 17.0084L9.82986 8.78986ZM13.5 5.5C12.3954 5.5 11.5 4.60457 11.5 3.5C11.5 2.39543 12.3954 1.5 13.5 1.5C14.6046 1.5 15.5 2.39543 15.5 3.5C15.5 4.60457 14.6046 5.5 13.5 5.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b1124b4016fead85(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.82986 8.78986L7.99998 9.45588V13H5.99998V8.05H6.015L11.2834 6.13247C11.5274 6.03855 11.7922 5.99162 12.0648 6.0008C13.1762 6.02813 14.1522 6.75668 14.4917 7.82036C14.678 8.40431 14.848 8.79836 15.0015 9.0025C15.9138 10.2155 17.3653 11 19 11V13C16.8253 13 14.8823 12.0083 13.5984 10.4526L12.9008 14.4085L15 16.17V23H13V17.1025L10.7307 15.1984L10.003 19.3253L3.10938 18.1098L3.45667 16.1401L8.38071 17.0084L9.82986 8.78986ZM13.5 5.5C12.3954 5.5 11.5 4.60457 11.5 3.5C11.5 2.39543 12.3954 1.5 13.5 1.5C14.6046 1.5 15.5 2.39543 15.5 3.5C15.5 4.60457 14.6046 5.5 13.5 5.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4488b4487ec413ee(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00003 17.9999H21C21.2762 17.9999 21.5 18.2238 21.5 18.4999C21.5 18.6081 21.4649 18.7134 21.4 18.7999L19.3 21.5999C19.1112 21.8517 18.8148 21.9999 18.5 21.9999H5.50003C5.18527 21.9999 4.88888 21.8517 4.70003 21.5999L2.60003 18.7999C2.43434 18.579 2.47912 18.2656 2.70003 18.0999C2.78658 18.035 2.89184 17.9999 3.00003 17.9999ZM15 2.42531V14.9999C15 15.5522 14.5523 15.9999 14 15.9999H4.04034C3.7642 15.9999 3.54034 15.7761 3.54034 15.4999C3.54034 15.3864 3.57898 15.2762 3.64991 15.1876L14.1096 2.11296C14.2821 1.89733 14.5967 1.86237 14.8124 2.03488C14.931 2.12976 15 2.27342 15 2.42531Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4ebf3217a2f7a259(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.00003 17.9999H21C21.2762 17.9999 21.5 18.2238 21.5 18.4999C21.5 18.6081 21.4649 18.7134 21.4 18.7999L19.3 21.5999C19.1112 21.8517 18.8148 21.9999 18.5 21.9999H5.50003C5.18527 21.9999 4.88888 21.8517 4.70003 21.5999L2.60003 18.7999C2.43434 18.579 2.47912 18.2656 2.70003 18.0999C2.78658 18.035 2.89184 17.9999 3.00003 17.9999ZM7.16128 13.9999H13V6.70148L7.16128 13.9999ZM15 2.42531V14.9999C15 15.5522 14.5523 15.9999 14 15.9999H4.04034C3.7642 15.9999 3.54034 15.7761 3.54034 15.4999C3.54034 15.3864 3.57898 15.2762 3.64991 15.1876L14.1096 2.11296C14.2821 1.89733 14.5967 1.86237 14.8124 2.03488C14.931 2.12976 15 2.27342 15 2.42531Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$72b601f2851ca65b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4H14.4458C14.7905 4 15.111 4.17762 15.2938 4.47L18.75 10H23.1577C23.4339 10 23.6577 10.2239 23.6577 10.5C23.6577 10.5837 23.6367 10.666 23.5967 10.7394L19.6599 17.9568C19.444 17.9853 19.2237 18 19 18C17.3644 18 15.9122 17.2147 15 16.0005C14.0878 17.2147 12.6356 18 11 18C9.3644 18 7.91223 17.2147 7 16.0005C6.08777 17.2147 4.6356 18 3 18C2.81381 18 2.63 17.9898 2.44909 17.97L1.21434 11.1789C1.11555 10.6355 1.47595 10.1149 2.01933 10.0161C2.07835 10.0054 2.13822 10 2.19821 10H3V5C3 4.44772 3.44772 4 4 4H5V1H9V4ZM5 10H16.3915L13.8915 6H5V10ZM3 20C4.53671 20 5.93849 19.4223 7 18.4722C8.06151 19.4223 9.46329 20 11 20C12.5367 20 13.9385 19.4223 15 18.4722C16.0615 19.4223 17.4633 20 19 20H21V22H19C17.5429 22 16.1767 21.6104 15 20.9297C13.8233 21.6104 12.4571 22 11 22C9.54285 22 8.17669 21.6104 7 20.9297C5.82331 21.6104 4.45715 22 3 22H1V20H3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5e76464e788c566f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4H14.4458C14.7905 4 15.111 4.17762 15.2938 4.47L18.75 10H23.1577C23.4339 10 23.6577 10.2239 23.6577 10.5C23.6577 10.5837 23.6367 10.666 23.5967 10.7394L19.6364 18H19C18.4694 18 17.9548 17.9311 17.4648 17.8018L20.63 12H3.4L4.44833 17.824C3.9845 17.939 3.49937 18 3 18H2.45455L1.21434 11.1789C1.11555 10.6355 1.47595 10.1149 2.01933 10.0161C2.07835 10.0054 2.13822 10 2.19821 10H3V5C3 4.44772 3.44772 4 4 4H5V1H9V4ZM5 10H16.3915L13.8915 6H5V10ZM3 20C4.53671 20 5.93849 19.4223 7 18.4722C8.06151 19.4223 9.46329 20 11 20C12.5367 20 13.9385 19.4223 15 18.4722C16.0615 19.4223 17.4633 20 19 20H21V22H19C17.5429 22 16.1767 21.6104 15 20.9297C13.8233 21.6104 12.4571 22 11 22C9.54285 22 8.17669 21.6104 7 20.9297C5.82331 21.6104 4.45715 22 3 22H1V20H3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$239de64ad33f0fe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10.4V4C4 3.44772 4.44772 3 5 3H10V1H14V3H19C19.5523 3 20 3.44772 20 4V10.4L21.0857 10.7257C21.5974 10.8792 21.8981 11.4078 21.7685 11.9261L20.2516 17.9938C20.1682 17.9979 20.0844 18 20 18C18.3644 18 16.9122 17.2147 16 16.0005C15.0878 17.2147 13.6356 18 12 18C10.3644 18 8.91223 17.2147 8 16.0005C7.08777 17.2147 5.6356 18 4 18C3.91564 18 3.83178 17.9979 3.74845 17.9938L2.23152 11.9261C2.10195 11.4078 2.40262 10.8792 2.91431 10.7257L4 10.4ZM6 9.8L12 8L14.7541 8.82624L16.5627 9.36882L18 9.8V5H6V9.8ZM4 20C5.53671 20 6.93849 19.4223 8 18.4722C9.06151 19.4223 10.4633 20 12 20C13.5367 20 14.9385 19.4223 16 18.4722C17.0615 19.4223 18.4633 20 20 20H22V22H20C18.5429 22 17.1767 21.6104 16 20.9297C14.8233 21.6104 13.4571 22 12 22C10.5429 22 9.17669 21.6104 8 20.9297C6.82331 21.6104 5.45715 22 4 22H2V20H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$97b34823215b4454(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10.4V4C4 3.44772 4.44772 3 5 3H10V1H14V3H19C19.5523 3 20 3.44772 20 4V10.4L21.0857 10.7257C21.5974 10.8792 21.8981 11.4078 21.7685 11.9261L20.2516 17.9938C20.1682 17.9979 20.0844 18 20 18C19.4218 18 18.8665 17.9019 18.3499 17.7213L19.6 12.37L12 10L4.4 12.37L5.65008 17.7213C5.13348 17.9019 4.5782 18 4 18C3.91564 18 3.83178 17.9979 3.74845 17.9938L2.23152 11.9261C2.10195 11.4078 2.40262 10.8792 2.91431 10.7257L4 10.4ZM6 9.8L12 8L18 9.8V5H6V9.8ZM4 20C5.53671 20 6.93849 19.4223 8 18.4722C9.06151 19.4223 10.4633 20 12 20C13.5367 20 14.9385 19.4223 16 18.4722C17.0615 19.4223 18.4633 20 20 20H22V22H20C18.5429 22 17.1767 21.6104 16 20.9297C14.8233 21.6104 13.4571 22 12 22C10.5429 22 9.17669 21.6104 8 20.9297C6.82331 21.6104 5.45715 22 4 22H2V20H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d613cd442f07bcba(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.11629 20.0868C3.62137 18.2684 2 15.3236 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 15.3236 20.3786 18.2684 17.8837 20.0868L16.8692 18.348C18.7729 16.8856 20 14.5861 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 14.5861 5.2271 16.8856 7.1308 18.348L6.11629 20.0868ZM8.14965 16.6018C6.83562 15.5012 6 13.8482 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 13.8482 17.1644 15.5012 15.8503 16.6018L14.8203 14.8365C15.549 14.112 16 13.1087 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 13.1087 8.45105 14.112 9.17965 14.8365L8.14965 16.6018ZM11 13H13L14 22H10L11 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$21ba4adf1e5f3625(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.11629 20.0868L7.1308 18.348C5.2271 16.8856 4 14.5861 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 14.5861 18.7729 16.8856 16.8692 18.348L17.8837 20.0868C20.3786 18.2684 22 15.3236 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 15.3236 3.62137 18.2684 6.11629 20.0868ZM8.14965 16.6018C6.83562 15.5012 6 13.8482 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 13.8482 17.1644 15.5012 15.8503 16.6018L14.8203 14.8365C15.549 14.112 16 13.1087 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 13.1087 8.45105 14.112 9.17965 14.8365L8.14965 16.6018ZM11 13H13V22H11V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$26486af638ab2d40(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.87988 18.0493C4.23015 12.056 7.07526 6.62874 11.003 2.17982C11.1105 2.05802 11.2465 1.90767 11.411 1.72876L11.411 1.72874C11.7101 1.40349 12.2162 1.38227 12.5414 1.68134C12.5579 1.69647 12.5737 1.71229 12.5888 1.72875C12.7553 1.90982 12.8929 2.06189 13.0015 2.18495C16.9268 6.63291 19.7703 12.0583 21.12 18.0493C18.9786 18.5007 16.7797 18.7963 14.5359 18.9238L12.4472 23.1012C12.3237 23.3482 12.0233 23.4483 11.7763 23.3248C11.6796 23.2764 11.6011 23.198 11.5527 23.1012L9.46401 18.9238C7.22018 18.7963 5.02133 18.5007 2.87988 18.0493ZM11.9999 14.9957C13.6568 14.9957 14.9999 13.6525 14.9999 11.9957C14.9999 10.3388 13.6568 8.99565 11.9999 8.99565C10.3431 8.99565 8.99994 10.3388 8.99994 11.9957C8.99994 13.6525 10.3431 14.9957 11.9999 14.9957Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2dbdf4ed874c25b4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.87988 18.0493C4.23015 12.056 7.07526 6.62874 11.003 2.17982C11.1105 2.05802 11.2465 1.90767 11.411 1.72875C11.7101 1.40349 12.2162 1.38227 12.5414 1.68133C12.5579 1.69647 12.5737 1.71229 12.5888 1.72875C12.7553 1.90982 12.8929 2.06188 13.0015 2.18495C16.9268 6.63291 19.7703 12.0583 21.12 18.0493C18.9786 18.5006 16.7797 18.7963 14.5359 18.9238L12.4472 23.1012C12.3237 23.3482 12.0233 23.4483 11.7763 23.3248C11.6796 23.2764 11.6011 23.198 11.5527 23.1012L9.46401 18.9238C7.22018 18.7963 5.02133 18.5006 2.87988 18.0493ZM9.57748 16.927L10.7346 16.9928L11.9999 19.5235L13.2653 16.9928L14.4224 16.927C15.8443 16.8462 17.2543 16.6943 18.6488 16.4726C17.3229 11.9195 15.0539 7.70543 11.9999 4.0855C8.94595 7.70541 6.67696 11.9194 5.35112 16.4726C6.74562 16.6943 8.15563 16.8462 9.57748 16.927ZM11.9999 14.9956C10.3431 14.9956 8.99994 13.6525 8.99994 11.9956C8.99994 10.3388 10.3431 8.99565 11.9999 8.99565C13.6568 8.99565 14.9999 10.3388 14.9999 11.9956C14.9999 13.6525 13.6568 14.9956 11.9999 14.9956ZM11.9999 12.9956C12.5522 12.9956 12.9999 12.5479 12.9999 11.9956C12.9999 11.4434 12.5522 10.9956 11.9999 10.9956C11.4477 10.9956 10.9999 11.4434 10.9999 11.9956C10.9999 12.5479 11.4477 12.9956 11.9999 12.9956Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$427044f4b675514b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM8 13L4.06201 13.001C4.51365 16.6192 7.38163 19.4869 11 19.9381V16C9.34315 16 8 14.6569 8 13ZM19.938 13.001L16 13C16 14.6569 14.6569 16 13 16L13.001 19.938C16.6189 19.4864 19.4864 16.6189 19.938 13.001ZM12 4C7.92037 4 4.55396 7.05371 4.06189 11H8C8 10.4477 8.44772 10 9 10H15C15.5523 10 16 10.4477 16 11H19.9381C19.446 7.05371 16.0796 4 12 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e930a2e57669fd3f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM8 13L4.06201 13.001C4.51365 16.6192 7.38163 19.4869 11 19.9381V16C9.34315 16 8 14.6569 8 13ZM19.938 13.001L16 13C16 14.6569 14.6569 16 13 16L13.001 19.938C16.6189 19.4864 19.4864 16.6189 19.938 13.001ZM14 12H10V13C10 13.5523 10.4477 14 11 14H13C13.5523 14 14 13.5523 14 13V12ZM12 4C7.92037 4 4.55396 7.05371 4.06189 11H8C8 10.4477 8.44772 10 9 10H15C15.5523 10 16 10.4477 16 11H19.9381C19.446 7.05371 16.0796 4 12 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f9280af93d668b84(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.7992 14.001C20.9633 18.1168 17.5995 21.3145 13.399 21.9028L13.3992 19.878C16.4926 19.3321 18.9729 17.0086 19.7473 14.0004L21.7992 14.001ZM4.25157 14.0004C5.01757 16.9759 7.45244 19.2814 10.4989 19.8595V21.8882C6.3456 21.2632 3.02888 18.0838 2.19968 14.001L4.25157 14.0004ZM17.9994 11V13H16.9994C14.8572 13 13.1084 14.684 13.0043 16.8004L12.9994 17V18H10.9994V17C10.9994 14.8578 9.31547 13.1089 7.19908 13.0049L6.99944 13H5.99944V11H17.9994ZM11.9994 2C17.1848 2 21.4483 5.94662 21.9501 10.9999L19.9376 11C19.4455 7.05371 16.0791 4 11.9994 4C7.91981 4 4.55341 7.05371 4.06133 11L2.04883 10.9999C2.5506 5.94662 6.81413 2 11.9994 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4ca549a9dedab035(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.7992 14.001C20.9633 18.1168 17.5995 21.3145 13.399 21.9028L13.3992 19.878C16.4926 19.3321 18.9729 17.0086 19.7473 14.0004L21.7992 14.001ZM4.25157 14.0004C5.01757 16.9759 7.45244 19.2814 10.4989 19.8595V21.8882C6.3456 21.2632 3.02888 18.0838 2.19968 14.001L4.25157 14.0004ZM17.9994 11V13H14.9994C13.9451 13 13.0813 13.8159 13.0049 14.8507L12.9994 15V18H10.9994V15C10.9994 13.9456 10.1836 13.0818 9.14871 13.0055L8.99944 13H5.99944V11H17.9994ZM11.9994 2C17.1848 2 21.4483 5.94662 21.9501 10.9999L19.9376 11C19.4455 7.05371 16.0791 4 11.9994 4C7.91981 4 4.55341 7.05371 4.06133 11L2.04883 10.9999C2.5506 5.94662 6.81413 2 11.9994 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a852d2e2c3fe9210(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.2 20L19 21.5V22H5V21.5L6.8 20H5C3.89543 20 3 19.1046 3 18V7C3 4.79086 4.79086 3 7 3H17C19.2091 3 21 4.79086 21 7V18C21 19.1046 20.1046 20 19 20H17.2ZM11 12V5H7C5.89543 5 5 5.89543 5 7V12H11ZM13 12H19V7C19 5.89543 18.1046 5 17 5H13V12ZM7.5 18C8.32843 18 9 17.3284 9 16.5C9 15.6716 8.32843 15 7.5 15C6.67157 15 6 15.6716 6 16.5C6 17.3284 6.67157 18 7.5 18ZM16.5 18C17.3284 18 18 17.3284 18 16.5C18 15.6716 17.3284 15 16.5 15C15.6716 15 15 15.6716 15 16.5C15 17.3284 15.6716 18 16.5 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$17d90f3488b968bb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.2 20L19 21.5V22H5V21.5L6.8 20H5C3.89543 20 3 19.1046 3 18V7C3 4.79086 4.79086 3 7 3H17C19.2091 3 21 4.79086 21 7V18C21 19.1046 20.1046 20 19 20H17.2ZM13 5V11H19V7C19 5.89543 18.1046 5 17 5H13ZM11 5H7C5.89543 5 5 5.89543 5 7V11H11V5ZM19 13H5V18H19V13ZM7.5 17C6.67157 17 6 16.3284 6 15.5C6 14.6716 6.67157 14 7.5 14C8.32843 14 9 14.6716 9 15.5C9 16.3284 8.32843 17 7.5 17ZM16.5 17C15.6716 17 15 16.3284 15 15.5C15 14.6716 15.6716 14 16.5 14C17.3284 14 18 14.6716 18 15.5C18 16.3284 17.3284 17 16.5 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e21e35b730251cf3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3V12H21V18C21 19.1046 20.1046 20 19 20H17.2L19 21.5V22H5V21.5L6.8 20H5C3.89543 20 3 19.1046 3 18V7C3 4.79086 4.79086 3 7 3H13ZM7.5 15C6.67157 15 6 15.6716 6 16.5C6 17.3284 6.67157 18 7.5 18C8.32843 18 9 17.3284 9 16.5C9 15.6716 8.32843 15 7.5 15ZM16.5 15C15.6716 15 15 15.6716 15 16.5C15 17.3284 15.6716 18 16.5 18C17.3284 18 18 17.3284 18 16.5C18 15.6716 17.3284 15 16.5 15ZM11 5H7C5.94564 5 5.08183 5.81588 5.00549 6.85074L5 7V12H11V5ZM18.5 1C20.9853 1 23 3.01472 23 5.5C23 7.98528 20.9853 10 18.5 10C16.0147 10 14 7.98528 14 5.5C14 3.01472 16.0147 1 18.5 1ZM18.4998 6.16667C18.0089 6.16667 17.5593 6.34354 17.2113 6.63704L17.0856 6.75245L18.4998 8.16667L19.9131 6.7515C19.5512 6.39013 19.0516 6.16667 18.4998 6.16667ZM18.4998 3.5C17.2966 3.5 16.1998 3.95536 15.3722 4.70316L15.199 4.86781L16.1428 5.80964C16.746 5.20643 17.5794 4.83333 18.4998 4.83333C19.3436 4.83333 20.1141 5.14684 20.7013 5.66372L20.8569 5.80964L21.7997 4.86684C20.9552 4.02233 19.7885 3.5 18.4998 3.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1730aff80866faca(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18C21 19.1046 20.1046 20 19 20H17.2L19 21.5V22H5V21.5L6.8 20H5C3.89543 20 3 19.1046 3 18V7C3 4.79086 4.79086 3 7 3H13V11H21V18ZM19 13H5V18H19V13ZM7.5 14C8.32843 14 9 14.6716 9 15.5C9 16.3284 8.32843 17 7.5 17C6.67157 17 6 16.3284 6 15.5C6 14.6716 6.67157 14 7.5 14ZM16.5 14C17.3284 14 18 14.6716 18 15.5C18 16.3284 17.3284 17 16.5 17C15.6716 17 15 16.3284 15 15.5C15 14.6716 15.6716 14 16.5 14ZM11 5H7C5.94564 5 5.08183 5.81588 5.00549 6.85074L5 7V11H11V5ZM18.5 1C20.9853 1 23 3.01472 23 5.5C23 7.98528 20.9853 10 18.5 10C16.0147 10 14 7.98528 14 5.5C14 3.01472 16.0147 1 18.5 1ZM18.4998 6.16667C18.0089 6.16667 17.5593 6.34354 17.2113 6.63704L17.0856 6.75245L18.4998 8.16667L19.9131 6.7515C19.5512 6.39013 19.0516 6.16667 18.4998 6.16667ZM18.4998 3.5C17.2966 3.5 16.1998 3.95536 15.3722 4.70316L15.199 4.86781L16.1428 5.80964C16.746 5.20643 17.5794 4.83333 18.4998 4.83333C19.3436 4.83333 20.1141 5.14684 20.7013 5.66372L20.8569 5.80964L21.7997 4.86684C20.9552 4.02233 19.7885 3.5 18.4998 3.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7311e54c53bfaf4d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 23H16V22H8V23H6V22H5C3.89543 22 3 21.1046 3 20V7C3 5.89543 3.89543 5 5 5H8V3C8 2.44772 8.44772 2 9 2H15C15.5523 2 16 2.44772 16 3V5H19C20.1046 5 21 5.89543 21 7V20C21 21.1046 20.1046 22 19 22H18V23ZM10 9H8V18H10V9ZM16 9H14V18H16V9ZM14 4H10V5H14V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5411d877465b7023(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 23H16V22H8V23H6V22H5C3.89543 22 3 21.1046 3 20V7C3 5.89543 3.89543 5 5 5H8V3C8 2.44772 8.44772 2 9 2H15C15.5523 2 16 2.44772 16 3V5H19C20.1046 5 21 5.89543 21 7V20C21 21.1046 20.1046 22 19 22H18V23ZM19 7H5V20H19V7ZM10 9V18H8V9H10ZM16 9V18H14V9H16ZM14 4H10V5H14V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6f7d6a599794e04c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 1C15.5523 1 16 1.44772 16 2V7H17V6H19V7H20C20.5523 7 21 7.44772 21 8V20C21 20.5523 20.5523 21 20 21H19V22H17V21H7V22H5V21H4C3.44772 21 3 20.5523 3 20V8C3 7.44772 3.44772 7 4 7H5V6H7V7H8V2C8 1.44772 8.44772 1 9 1H15ZM9 10H7V18H9V10ZM13 10H11V18H13V10ZM17 10H15V18H17V10ZM14 3H10V7H14V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$25dc171dc8cf08cc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 1C15.5523 1 16 1.44772 16 2V7H17V6H19V7H20C20.5523 7 21 7.44772 21 8V20C21 20.5523 20.5523 21 20 21H19V22H17V21H7V22H5V21H4C3.44772 21 3 20.5523 3 20V8C3 7.44772 3.44772 7 4 7H5V6H7V7H8V2C8 1.44772 8.44772 1 9 1H15ZM19 9H5V19H19V9ZM9 10V18H7V10H9ZM13 10V18H11V10H13ZM17 10V18H15V10H17ZM14 3H10V7H14V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cd22b6d562c49778(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3C15.5523 3 16 3.44772 16 4V6H21C21.5523 6 22 6.44772 22 7V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7C2 6.44772 2.44772 6 3 6H8V4C8 3.44772 8.44772 3 9 3H15ZM8 8H6V19H8V8ZM18 8H16V19H18V8ZM14 5H10V6H14V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$216ed1c110a05099(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3C15.5523 3 16 3.44772 16 4V6H21C21.5523 6 22 6.44772 22 7V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7C2 6.44772 2.44772 6 3 6H8V4C8 3.44772 8.44772 3 9 3H15ZM16 8H8V19H16V8ZM4 8V19H6V8H4ZM14 5H10V6H14V5ZM18 8V19H20V8H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6b45ebb26faf638d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1C16.5523 1 17 1.44772 17 2V2.999L22 3V9L19.98 8.999L22.7467 16.5953C22.9105 17.032 23 17.5051 23 17.999C23 20.2082 21.2091 21.999 19 21.999C17.1368 21.999 15.5711 20.7251 15.1265 19.0008L10.8738 19.0008C10.4295 20.7256 8.86357 22 7 22C5.05513 22 3.43445 20.612 3.07453 18.7725C2.43558 18.439 2 17.7704 2 17V12H11C11 12.5128 11.386 12.9355 11.8834 12.9933L12 13H14C14.5128 13 14.9355 12.614 14.9933 12.1166L15 12V3H12V1H16ZM7 16C5.89543 16 5 16.8954 5 18C5 19.1046 5.89543 20 7 20C8.10457 20 9 19.1046 9 18C9 16.8954 8.10457 16 7 16ZM19 16C17.8954 16 17 16.8954 17 18C17 19.1046 17.8954 20 19 20C20.1046 20 21 19.1046 21 18C21 16.8954 20.1046 16 19 16ZM10 3C10.5523 3 11 3.44772 11 4V11H2V4C2 3.44772 2.44772 3 3 3H10ZM20 5H17V7H20V5ZM9 5H4V6H9V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bb4f613632e8d3ea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1C16.5523 1 17 1.44772 17 2V2.999L22 3V9L19.98 8.999L22.7467 16.5953C22.9105 17.032 23 17.5051 23 17.999C23 20.2082 21.2091 21.999 19 21.999C17.1368 21.999 15.5711 20.7251 15.1265 19.0008L10.8738 19.0008C10.4295 20.7256 8.86357 22 7 22C5.05513 22 3.43445 20.612 3.07453 18.7725C2.43558 18.439 2 17.7704 2 17V4C2 3.44772 2.44772 3 3 3H10C10.5523 3 11 3.44772 11 4V12C11 12.5128 11.386 12.9355 11.8834 12.9933L12 13H14C14.5128 13 14.9355 12.614 14.9933 12.1166L15 12V3H12V1H16ZM7 16C5.89543 16 5 16.8954 5 18C5 19.1046 5.89543 20 7 20C8.10457 20 9 19.1046 9 18C9 16.8954 8.10457 16 7 16ZM19 15.999C17.8954 15.999 17 16.8944 17 17.999C17 19.1036 17.8954 19.999 19 19.999C20.1046 19.999 21 19.1036 21 17.999C21 16.8944 20.1046 15.999 19 15.999ZM17.852 8.999H17V12C17 13.6569 15.6569 15 14 15H12C10.6941 15 9.58312 14.1656 9.17102 13.0009L3.99994 13V15.3542C4.73289 14.5238 5.80528 14 7 14C8.86393 14 10.4301 15.2749 10.874 17.0003H15.1257C15.5693 15.2744 17.1357 13.999 19 13.999C19.2373 13.999 19.4697 14.0197 19.6957 14.0593L17.852 8.999ZM9 8H4V11H9V8ZM20 5H17V7H20V5ZM9 5H4V6H9V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bf3f0756d23bf003(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V12L4.4805 6.21216C4.79566 5.47679 5.51874 5 6.31879 5H9V3H15V5H17.6812C18.4813 5 19.2043 5.47679 19.5195 6.21216L22 12ZM4.17594 12H19.8241L17.6812 7H6.31879L4.17594 12ZM6.5 17C7.32843 17 8 16.3284 8 15.5C8 14.6716 7.32843 14 6.5 14C5.67157 14 5 14.6716 5 15.5C5 16.3284 5.67157 17 6.5 17ZM17.5 17C18.3284 17 19 16.3284 19 15.5C19 14.6716 18.3284 14 17.5 14C16.6716 14 16 14.6716 16 15.5C16 16.3284 16.6716 17 17.5 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$de986dfa34facdd9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V11L4.44721 6.10557C4.786 5.428 5.47852 5 6.23607 5H9V3H15V5H17.7639C18.5215 5 19.214 5.428 19.5528 6.10557L22 11ZM20 13H4V18H20V13ZM4.23607 11H19.7639L17.7639 7H6.23607L4.23607 11ZM6.5 17C5.67157 17 5 16.3284 5 15.5C5 14.6716 5.67157 14 6.5 14C7.32843 14 8 14.6716 8 15.5C8 16.3284 7.32843 17 6.5 17ZM17.5 17C16.6716 17 16 16.3284 16 15.5C16 14.6716 16.6716 14 17.5 14C18.3284 14 19 14.6716 19 15.5C19 16.3284 18.3284 17 17.5 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$287f8a2abc7c8d73(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3V7H6.31879L4.175 12H22V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V12L4.4805 6.21216C4.79566 5.47679 5.51874 5 6.31879 5H9V3H12ZM6.5 14C5.67157 14 5 14.6716 5 15.5C5 16.3284 5.67157 17 6.5 17C7.32843 17 8 16.3284 8 15.5C8 14.6716 7.32843 14 6.5 14ZM17.5 14C16.6716 14 16 14.6716 16 15.5C16 16.3284 16.6716 17 17.5 17C18.3284 17 19 16.3284 19 15.5C19 14.6716 18.3284 14 17.5 14ZM18.5 1C20.9853 1 23 3.01472 23 5.5C23 7.98528 20.9853 10 18.5 10C16.0147 10 14 7.98528 14 5.5C14 3.01472 16.0147 1 18.5 1ZM18.4998 6.16667C18.0089 6.16667 17.5593 6.34354 17.2113 6.63704L17.0856 6.75245L18.4998 8.16667L19.9131 6.7515C19.5512 6.39013 19.0516 6.16667 18.4998 6.16667ZM18.4998 3.5C17.2966 3.5 16.1998 3.95536 15.3722 4.70316L15.199 4.86781L16.1428 5.80964C16.746 5.20643 17.5794 4.83333 18.4998 4.83333C19.3436 4.83333 20.1141 5.14684 20.7013 5.66372L20.8569 5.80964L21.7997 4.86684C20.9552 4.02233 19.7885 3.5 18.4998 3.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4d39db7c40a8bfe9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3V7H6.23607L4.235 11H22V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V11L4.44721 6.10557C4.786 5.428 5.47852 5 6.23607 5H9V3H12ZM20 13H4V18H20V13ZM6.5 14C7.32843 14 8 14.6716 8 15.5C8 16.3284 7.32843 17 6.5 17C5.67157 17 5 16.3284 5 15.5C5 14.6716 5.67157 14 6.5 14ZM17.5 14C18.3284 14 19 14.6716 19 15.5C19 16.3284 18.3284 17 17.5 17C16.6716 17 16 16.3284 16 15.5C16 14.6716 16.6716 14 17.5 14ZM18.5 1C20.9853 1 23 3.01472 23 5.5C23 7.98528 20.9853 10 18.5 10C16.0147 10 14 7.98528 14 5.5C14 3.01472 16.0147 1 18.5 1ZM18.4998 6.16667C18.0089 6.16667 17.5593 6.34354 17.2113 6.63704L17.0856 6.75245L18.4998 8.16667L19.9131 6.7515C19.5512 6.39013 19.0516 6.16667 18.4998 6.16667ZM18.4998 3.5C17.2966 3.5 16.1998 3.95536 15.3722 4.70316L15.199 4.86781L16.1428 5.80964C16.746 5.20643 17.5794 4.83333 18.4998 4.83333C19.3436 4.83333 20.1141 5.14684 20.7013 5.66372L20.8569 5.80964L21.7997 4.86684C20.9552 4.02233 19.7885 3.5 18.4998 3.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$369b7bc018fefe9a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V4H20C20 6.5 17.5 7.5 17 7.5V10H20C20 12.5 17.5 13.5 17 13.5V16H20C20 18.5 17.5 19.5 17 19.5V21C17 21.5523 16.5523 22 16 22H8C7.44772 22 7 21.5523 7 21V19.5C6.5 19.5 4 18.5 4 16H7V13.5C6.5 13.5 4 12.5 4 10H7V7.5C6.5 7.5 4 6.5 4 4H7ZM12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b7aa0713ca483d17(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V4H20C20 6.5 17.5 7.5 17 7.5V10H20C20 12.5 17.5 13.5 17 13.5V16H20C20 18.5 17.5 19.5 17 19.5V21C17 21.5523 16.5523 22 16 22H8C7.44772 22 7 21.5523 7 21V19.5C6.5 19.5 4 18.5 4 16H7V13.5C6.5 13.5 4 12.5 4 10H7V7.5C6.5 7.5 4 6.5 4 4H7ZM12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4b84e8a8c8365829(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.2 20L19 21.5V22H5V21.5L6.8 20H5C3.89543 20 3 19.1046 3 18V7C3 4.79086 4.79086 3 7 3H17C19.2091 3 21 4.79086 21 7V18C21 19.1046 20.1046 20 19 20H17.2ZM5 7V11H19V7H5ZM12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$edf420238ca9c137(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.2 20L19 21.5V22H5V21.5L6.8 20H5C3.89543 20 3 19.1046 3 18V7C3 4.79086 4.79086 3 7 3H17C19.2091 3 21 4.79086 21 7V18C21 19.1046 20.1046 20 19 20H17.2ZM7 5C5.89543 5 5 5.89543 5 7V18H19V7C19 5.89543 18.1046 5 17 5H7ZM12 17C10.8954 17 10 16.1046 10 15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15C14 16.1046 13.1046 17 12 17ZM6 7H18V11H6V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$66a6ea70716affe5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4981 3C12.1772 3.76965 12 4.61413 12 5.5C12 6.01621 12.0602 6.51837 12.1739 6.99984L5 7V11L15.035 11.0004C16.038 11.6336 17.2262 12 18.5 12C19.3861 12 20.2308 11.8227 21.0006 11.5016L21 18C21 19.1046 20.1046 20 19 20H17.2L19 21.5V22H5V21.5L6.8 20H5C3.89543 20 3 19.1046 3 18V7C3 4.79086 4.79086 3 7 3H12.4981ZM12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14ZM18.5 1C20.9853 1 23 3.01472 23 5.5C23 7.98528 20.9853 10 18.5 10C16.0147 10 14 7.98528 14 5.5C14 3.01472 16.0147 1 18.5 1ZM18.4998 6.16667C18.0089 6.16667 17.5593 6.34354 17.2113 6.63704L17.0856 6.75245L18.4998 8.16667L19.9131 6.7515C19.5512 6.39013 19.0516 6.16667 18.4998 6.16667ZM18.4998 3.5C17.2966 3.5 16.1998 3.95536 15.3722 4.70316L15.199 4.86781L16.1428 5.80964C16.746 5.20643 17.5794 4.83333 18.4998 4.83333C19.3436 4.83333 20.1141 5.14684 20.7013 5.66372L20.8569 5.80964L21.7997 4.86684C20.9552 4.02233 19.7885 3.5 18.4998 3.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f01d68ed0a8c192e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4981 3C12.2382 3.6234 12.0725 4.29587 12.019 4.99967L7 5C5.94564 5 5.08183 5.81588 5.00549 6.85074L5 7V18H19L19.0003 11.981C19.7044 11.9274 20.3771 11.7617 21.0006 11.5016L21 18C21 19.1046 20.1046 20 19 20H17.2L19 21.5V22H5V21.5L6.8 20H5C3.89543 20 3 19.1046 3 18V7C3 4.79086 4.79086 3 7 3H12.4981ZM12 13C13.1046 13 14 13.8954 14 15C14 16.1046 13.1046 17 12 17C10.8954 17 10 16.1046 10 15C10 13.8954 10.8954 13 12 13ZM12.1741 7.00084C12.5709 8.67951 13.6186 10.1066 15.036 11.0011L6 11V7L12.1741 7.00084ZM18.5 1C20.9853 1 23 3.01472 23 5.5C23 7.98528 20.9853 10 18.5 10C16.0147 10 14 7.98528 14 5.5C14 3.01472 16.0147 1 18.5 1ZM18.4998 6.16667C18.0089 6.16667 17.5593 6.34354 17.2113 6.63704L17.0856 6.75245L18.4998 8.16667L19.9131 6.7515C19.5512 6.39013 19.0516 6.16667 18.4998 6.16667ZM18.4998 3.5C17.2966 3.5 16.1998 3.95536 15.3722 4.70316L15.199 4.86781L16.1428 5.80964C16.746 5.20643 17.5794 4.83333 18.4998 4.83333C19.3436 4.83333 20.1141 5.14684 20.7013 5.66372L20.8569 5.80964L21.7997 4.86684C20.9552 4.02233 19.7885 3.5 18.4998 3.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4e5751ddd6faea6d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5L9 2L15 5L21.303 2.2987C21.5569 2.18992 21.8508 2.30749 21.9596 2.56131C21.9862 2.62355 22 2.69056 22 2.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V5ZM6 11V13H8V11H6ZM10 11V13H12V11H10ZM16 10.9393L14.7626 9.7019L13.7019 10.7626L14.9393 12L13.7019 13.2374L14.7626 14.2981L16 13.0607L17.2374 14.2981L18.2981 13.2374L17.0607 12L18.2981 10.7626L17.2374 9.7019L16 10.9393Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fb5f101dfc676fc7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.9352 7.20369L8.93524 4.20369L4 6.31879V18.9669L9.06476 16.7963L15.0648 19.7963L20 17.6812V5.03308L14.9352 7.20369ZM2 5L9 2L15 5L21.303 2.2987C21.5569 2.18992 21.8508 2.30749 21.9596 2.56131C21.9862 2.62355 22 2.69056 22 2.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V5ZM6 11H8V13H6V11ZM10 11H12V13H10V11ZM15.9981 10.9374L17.2355 9.7L18.2962 10.7607L17.0588 11.9981L18.2962 13.2355L17.2355 14.2962L15.9981 13.0588L14.7607 14.2962L13.7 13.2355L14.9374 11.9981L13.7 10.7607L14.7607 9.7L15.9981 10.9374Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5d5c8b0abbf08f08(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8H20L23 12.0557V18H20.9646C20.7219 19.6961 19.2632 21 17.5 21C15.7368 21 14.2781 19.6961 14.0354 18H8.96456C8.72194 19.6961 7.26324 21 5.5 21C3.73676 21 2.27806 19.6961 2.03544 18H1V6C1 5.44772 1.44772 5 2 5H16C16.5523 5 17 5.44772 17 6V8ZM17 10V13H21V12.715L18.9917 10H17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f33e272f868398f4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.96456 18C8.72194 19.6961 7.26324 21 5.5 21C3.73676 21 2.27806 19.6961 2.03544 18H1V6C1 5.44772 1.44772 5 2 5H16C16.5523 5 17 5.44772 17 6V8H20L23 12.0557V18H20.9646C20.7219 19.6961 19.2632 21 17.5 21C15.7368 21 14.2781 19.6961 14.0354 18H8.96456ZM15 7H3V15.0505C3.63526 14.4022 4.52066 14 5.5 14C6.8962 14 8.10145 14.8175 8.66318 16H14.3368C14.5045 15.647 14.7296 15.3264 15 15.0505V7ZM17 13H21V12.715L18.9917 10H17V13ZM17.5 19C18.1531 19 18.7087 18.5826 18.9146 18C18.9699 17.8436 19 17.6753 19 17.5C19 16.6716 18.3284 16 17.5 16C16.6716 16 16 16.6716 16 17.5C16 17.6753 16.0301 17.8436 16.0854 18C16.2913 18.5826 16.8469 19 17.5 19ZM7 17.5C7 16.6716 6.32843 16 5.5 16C4.67157 16 4 16.6716 4 17.5C4 17.6753 4.03008 17.8436 4.08535 18C4.29127 18.5826 4.84689 19 5.5 19C6.15311 19 6.70873 18.5826 6.91465 18C6.96992 17.8436 7 17.6753 7 17.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1d468121e2d373a6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.9711 17.1715 19.5568 18.5858 16.0223 15.0513 15.9486 15.125 15.2415 18.6605 13.8273 20.0747 9.58466 15.8321 4.63492 20.7818 3.2207 19.3676 8.17045 14.4179 3.92781 10.1752 5.34202 8.76101 8.87756 8.0539 8.95127 7.98019 5.4147 4.44362 6.82892 3.02941 20.9711 17.1715ZM18.8508 12.2228 20.1913 10.8823 20.8984 11.5894 22.3126 10.1752 13.8273 1.68994 12.4131 3.10416 13.1202 3.81126 11.7797 5.15176 18.8508 12.2228Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$87205e8d74dcb8a0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.9701 17.1715 19.5559 18.5858 16.0214 15.0513 15.9476 15.125 15.2405 18.6605 13.8263 20.0747 9.58369 15.8321 4.63394 20.7818 3.21973 19.3676 8.16947 14.4179 3.92683 10.1752 5.34105 8.76101 8.87658 8.0539 8.95029 7.98019 5.41373 4.44362 6.82794 3.02941 20.9701 17.1715ZM10.3645 9.3944 9.86261 9.89631 7.04072 10.4607 13.5409 16.9608 14.1052 14.1389 14.6071 13.637 10.3645 9.3944ZM18.7761 9.46812 17.4356 10.8086 18.8498 12.2228 20.1903 10.8823 20.8974 11.5894 22.3116 10.1752 13.8263 1.68994 12.4121 3.10416 13.1192 3.81126 11.7787 5.15176 13.1929 6.56597 14.5334 5.22548 18.7761 9.46812Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9745c94e6bf692a3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.61713 8.71233L10.8222 6.38373C11.174 6.12735 11.6087 5.98543 12.065 6.0008C13.1764 6.02813 14.1524 6.75668 14.4919 7.82036C14.6782 8.40431 14.8481 8.79836 15.0017 9.0025C15.914 10.2155 17.3655 11 19.0002 11V13C16.8255 13 14.8825 12.0083 13.5986 10.4526L12.901 14.4085L14.9621 16.138L17.1853 22.246L15.3059 22.93L13.266 17.3256L9.87576 14.4808C9.32821 14.0382 9.03139 13.3192 9.16231 12.5767L9.67091 9.6923L8.99407 10.1841L6.86706 13.1116L5.24902 11.9361L7.60016 8.7L7.61713 8.71233ZM13.5002 5.5C12.3956 5.5 11.5002 4.60457 11.5002 3.5C11.5002 2.39543 12.3956 1.5 13.5002 1.5C14.6047 1.5 15.5002 2.39543 15.5002 3.5C15.5002 4.60457 14.6047 5.5 13.5002 5.5ZM10.5286 18.6813L7.31465 22.5116L5.78257 21.226L8.75774 17.6803L9.50426 15.5L11.2954 17L10.5286 18.6813Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2eb699c1fd20257e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.61713 8.71233L10.8222 6.38373C11.174 6.12735 11.6087 5.98543 12.065 6.0008C13.1764 6.02813 14.1524 6.75668 14.4919 7.82036C14.6782 8.40431 14.8481 8.79836 15.0017 9.0025C15.914 10.2155 17.3655 11 19.0002 11V13C16.8255 13 14.8825 12.0083 13.5986 10.4526L12.901 14.4085L14.9621 16.138L17.1853 22.246L15.3059 22.93L13.266 17.3256L9.87576 14.4808C9.32821 14.0382 9.03139 13.3192 9.16231 12.5767L9.67091 9.6923L8.99407 10.1841L6.86706 13.1116L5.24902 11.9361L7.60016 8.7L7.61713 8.71233ZM13.5002 5.5C12.3956 5.5 11.5002 4.60457 11.5002 3.5C11.5002 2.39543 12.3956 1.5 13.5002 1.5C14.6047 1.5 15.5002 2.39543 15.5002 3.5C15.5002 4.60457 14.6047 5.5 13.5002 5.5ZM10.5286 18.6813L7.31465 22.5116L5.78257 21.226L8.75774 17.6803L9.50426 15.5L11.2954 17L10.5286 18.6813Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$451327bd211f0bff(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM11.5 13.5V12H10.5V9H9V12H7.5V9H6V13.5H9V15H10.5V13.5H11.5ZM18 15L15.75 12L18 9H16.25L14.5 11.25V9H13V15H14.5V12.75L16.25 15H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6aa8cacc4d21f50b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5V19H20V5H4ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM11.5 13.5H10.5V15H9V13.5H6V9H7.5V12H9V9H10.5V12H11.5V13.5ZM18 15H16.25L14.5 12.75V15H13V9H14.5V11.25L16.25 9H18L15.75 12L18 15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$968101bd2f4fcea8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 16C14.2133 16 16 14.2133 16 12C16 9.78667 14.2133 8 12 8C9.78667 8 8 9.78667 8 12C8 14.2133 9.78667 16 12 16ZM12 11C12.55 11 13 11.45 13 12C13 12.55 12.55 13 12 13C11.45 13 11 12.55 11 12C11 11.45 11.45 11 12 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eb6052117f64fc1c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6f9d942b554035e2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM18 12H16V15H13V17H18V12ZM11 7H6V12H8V9H11V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d372c7577544ad8e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V19H20V5ZM13 17V15H16V12H18V17H13ZM11 7V9H8V12H6V7H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ca0f4f110fe7e88a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.92893 2.92871L6.34315 4.34292C4.89543 5.79064 4 7.79064 4 9.99978C4 12.2089 4.89543 14.2089 6.34315 15.6566L4.92893 17.0708C3.11929 15.2612 2 12.7612 2 9.99978C2 7.23835 3.11929 4.73836 4.92893 2.92871ZM19.0711 2.92871C20.8807 4.73836 22 7.23835 22 9.99978C22 12.7612 20.8807 15.2612 19.0711 17.0708L17.6569 15.6566C19.1046 14.2089 20 12.2089 20 9.99978C20 7.79064 19.1046 5.79064 17.6569 4.34292L19.0711 2.92871ZM7.75736 5.75714L9.17157 7.17135C8.44771 7.89521 8 8.89521 8 9.99978C8 11.1043 8.44771 12.1043 9.17157 12.8282L7.75736 14.2424C6.67157 13.1566 6 11.6566 6 9.99978C6 8.34292 6.67157 6.84292 7.75736 5.75714ZM16.2426 5.75714C17.3284 6.84292 18 8.34292 18 9.99978C18 11.6566 17.3284 13.1566 16.2426 14.2424L14.8284 12.8282C15.5523 12.1043 16 11.1043 16 9.99978C16 8.89521 15.5523 7.89521 14.8284 7.17135L16.2426 5.75714ZM12 11.9998C10.8954 11.9998 10 11.1043 10 9.99978C10 8.89521 10.8954 7.99978 12 7.99978C13.1046 7.99978 14 8.89521 14 9.99978C14 11.1043 13.1046 11.9998 12 11.9998ZM12 13.9998C12.5798 13.9998 13.0774 14.4128 13.1843 14.9827L14.5 21.9998H9.5L10.8157 14.9827C10.9226 14.4128 11.4202 13.9998 12 13.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1f8e81adf64f6e10(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.92893 2.92871L6.34315 4.34292C4.89543 5.79064 4 7.79064 4 9.99978C4 12.2089 4.89543 14.2089 6.34315 15.6566L4.92893 17.0708C3.11929 15.2612 2 12.7612 2 9.99978C2 7.23835 3.11929 4.73836 4.92893 2.92871ZM19.0711 2.92871C20.8807 4.73836 22 7.23835 22 9.99978C22 12.7612 20.8807 15.2612 19.0711 17.0708L17.6569 15.6566C19.1046 14.2089 20 12.2089 20 9.99978C20 7.79064 19.1046 5.79064 17.6569 4.34292L19.0711 2.92871ZM7.75736 5.75714L9.17157 7.17135C8.44771 7.89521 8 8.89521 8 9.99978C8 11.1043 8.44771 12.1043 9.17157 12.8282L7.75736 14.2424C6.67157 13.1566 6 11.6566 6 9.99978C6 8.34292 6.67157 6.84292 7.75736 5.75714ZM16.2426 5.75714C17.3284 6.84292 18 8.34292 18 9.99978C18 11.6566 17.3284 13.1566 16.2426 14.2424L14.8284 12.8282C15.5523 12.1043 16 11.1043 16 9.99978C16 8.89521 15.5523 7.89521 14.8284 7.17135L16.2426 5.75714ZM12 11.9998C10.8954 11.9998 10 11.1043 10 9.99978C10 8.89521 10.8954 7.99978 12 7.99978C13.1046 7.99978 14 8.89521 14 9.99978C14 11.1043 13.1046 11.9998 12 11.9998ZM11 13.9998H13V21.9998H11V13.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$11f01f873d514e73(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15ZM12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17ZM18 5V7H20V5H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$398965fa2c51a113(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM4 5V19H20V5H4ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15ZM12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17ZM17 6H19V8H17V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$49477a7e15fc366(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6.00087C2 5.44811 2.45531 5 2.9918 5H21.0082C21.556 5 22 5.44463 22 6.00087V19.9991C22 20.5519 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5554 2 19.9991V6.00087ZM14 18C16.7614 18 19 15.7614 19 13C19 10.2386 16.7614 8 14 8C11.2386 8 9 10.2386 9 13C9 15.7614 11.2386 18 14 18ZM4 7V9H7V7H4ZM4 2H10V4H4V2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8f97168735b315dd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6.00087C2 5.44811 2.45531 5 2.9918 5H21.0082C21.556 5 22 5.44463 22 6.00087V19.9991C22 20.5519 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5554 2 19.9991V6.00087ZM4 7V19H20V7H4ZM14 16C15.6569 16 17 14.6569 17 13C17 11.3431 15.6569 10 14 10C12.3431 10 11 11.3431 11 13C11 14.6569 12.3431 16 14 16ZM14 18C11.2386 18 9 15.7614 9 13C9 10.2386 11.2386 8 14 8C16.7614 8 19 10.2386 19 13C19 15.7614 16.7614 18 14 18ZM4 2H10V4H4V2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e5f7fe3603f14795(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3H15L17 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7L9 3ZM12 19C15.3137 19 18 16.3137 18 13C18 9.68629 15.3137 7 12 7C8.68629 7 6 9.68629 6 13C6 16.3137 8.68629 19 12 19ZM12 17C9.79086 17 8 15.2091 8 13C8 10.7909 9.79086 9 12 9C14.2091 9 16 10.7909 16 13C16 15.2091 14.2091 17 12 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f6b55b1e4ec2f6ab(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.82726 21.7633L14.3094 14L17.8413 20.1175C16.198 21.3021 14.1805 22 12 22C11.2538 22 10.5268 21.9183 9.82726 21.7633ZM7.88985 21.119C5.3115 19.955 3.31516 17.7297 2.4578 15H11.4226L7.88985 21.119ZM2.04938 13C2.01672 12.6711 2 12.3375 2 12C2 9.39284 2.99773 7.0187 4.6322 5.23859L9.11325 13H2.04938ZM6.15866 3.88251C7.80198 2.6979 9.81949 2 12 2C12.7462 2 13.4732 2.08172 14.1727 2.2367L9.6906 10L6.15866 3.88251ZM16.1101 2.88101C18.6885 4.04495 20.6848 6.27028 21.5422 9H12.5774L16.1101 2.88101ZM21.9506 11C21.9833 11.3289 22 11.6625 22 12C22 14.6072 21.0023 16.9813 19.3678 18.7614L14.8868 11H21.9506Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$765f120dd27b188(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.85802 19.71L12 16H5.07026C6.10692 17.7921 7.8188 19.1447 9.85802 19.71ZM4.25204 14H8.5359L5.07103 7.99867C4.38987 9.17566 4 10.5423 4 12C4 12.6906 4.08751 13.3608 4.25204 14ZM6.39496 6.29179L8.5359 10L12 4C9.8171 4 7.8384 4.87429 6.39496 6.29179ZM14.142 4.28998L12 8H18.9297C17.8931 6.20791 16.1812 4.85529 14.142 4.28998ZM19.748 10H15.4641L18.929 16.0013C19.6101 14.8243 20 13.4577 20 12C20 11.3094 19.9125 10.6392 19.748 10ZM17.605 17.7082L15.4641 14L12 20C14.1829 20 16.1616 19.1257 17.605 17.7082ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM13.1547 10H10.8453L9.6906 12L10.8453 14H13.1547L14.3094 12L13.1547 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6d6db8f249eea1fa(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.82843 5L7.82843 7H4V19H20V7H16.1716L14.1716 5H9.82843ZM9 3H15L17 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7L9 3ZM12 18C8.96243 18 6.5 15.5376 6.5 12.5C6.5 9.46243 8.96243 7 12 7C15.0376 7 17.5 9.46243 17.5 12.5C17.5 15.5376 15.0376 18 12 18ZM12 16C13.933 16 15.5 14.433 15.5 12.5C15.5 10.567 13.933 9 12 9C10.067 9 8.5 10.567 8.5 12.5C8.5 14.433 10.067 16 12 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$77cb86639e8c5d2e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5869 21.0002H3.00113C2.44885 21.0002 2.00113 20.5524 2.00113 20.0002V6.00016C2.00113 5.44787 2.44885 5.00016 3.00113 5.00016H3.58692L1.39453 2.80777L2.80874 1.39355L22.6077 21.1925L21.1935 22.6068L19.5869 21.0002ZM7.55641 8.96965C6.59 10.0347 6.00113 11.4487 6.00113 13.0002C6.00113 16.3139 8.68742 19.0002 12.0011 19.0002C13.5526 19.0002 14.9665 18.4113 16.0316 17.4449L14.6149 16.0281C13.9139 16.6338 13.0003 17.0002 12.0011 17.0002C9.79199 17.0002 8.00113 15.2093 8.00113 13.0002C8.00113 12.001 8.36747 11.0874 8.97315 10.3864L7.55641 8.96965ZM22.0011 17.786L17.9559 13.7407C17.9858 13.498 18.0011 13.2509 18.0011 13.0002C18.0011 9.68645 15.3148 7.00016 12.0011 7.00016C11.7504 7.00016 11.5032 7.01554 11.2606 7.04541L8.10823 3.89306L9.00113 3.00016H15.0011L17.0011 5.00016H21.0011C21.5534 5.00016 22.0011 5.44787 22.0011 6.00016V17.786ZM13.5095 9.29431C14.5055 9.70011 15.3012 10.4958 15.707 11.4918L13.5095 9.29431Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5be096d46c5da432(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5869 21.0002H3.00113C2.44885 21.0002 2.00113 20.5524 2.00113 20.0002V6.00016C2.00113 5.44787 2.44885 5.00016 3.00113 5.00016H3.58692L1.39453 2.80777L2.80874 1.39355L22.6077 21.1925L21.1935 22.6068L19.5869 21.0002ZM5.58692 7.00016H4.00113V19.0002H17.5869L15.4063 16.8196C14.4698 17.5589 13.287 18.0002 12.0011 18.0002C8.96357 18.0002 6.50113 15.5377 6.50113 12.5002C6.50113 11.2143 6.94239 10.0315 7.68173 9.09497L5.58692 7.00016ZM9.11149 10.5247C8.72641 11.0869 8.50113 11.7672 8.50113 12.5002C8.50113 14.4332 10.0681 16.0002 12.0011 16.0002C12.734 16.0002 13.4143 15.7749 13.9766 15.3898L9.11149 10.5247ZM22.0011 17.786L20.0011 15.786V7.00016H16.1727L14.1727 5.00016H9.82956L9.52245 5.30727L8.10823 3.89306L9.00113 3.00016H15.0011L17.0011 5.00016H21.0011C21.5534 5.00016 22.0011 5.44787 22.0011 6.00016V17.786ZM11.2643 7.04909C11.5053 7.01682 11.7513 7.00016 12.0011 7.00016C15.0387 7.00016 17.5011 9.46259 17.5011 12.5002C17.5011 12.75 17.4845 12.996 17.4522 13.237L15.1143 10.8991C14.7804 10.2512 14.2501 9.72089 13.6022 9.38698L11.2643 7.04909Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c2eb5739e7b36b5b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3H15L17 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7L9 3ZM14.6839 18.3677L13.7892 16.5785C13.2509 16.8482 12.6432 17 12 17C9.79086 17 8 15.2091 8 13H10L7.83875 8.67749C6.70523 9.76898 6 11.3021 6 13C6 16.3137 8.68629 19 12 19C12.9647 19 13.8763 18.7723 14.6839 18.3677ZM9.31613 7.63226L10.2108 9.42151C10.7491 9.15179 11.3568 9 12 9C14.2091 9 16 10.7909 16 13H14L16.1613 17.3225C17.2948 16.231 18 14.6979 18 13C18 9.68629 15.3137 7 12 7C11.0353 7 10.1237 7.22769 9.31613 7.63226Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$36cb7e0387476fa7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.82843 5L7.82843 7H4V19H20V7H16.1716L14.1716 5H9.82843ZM9 3H15L17 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7L9 3ZM9.64042 7.53044C10.3555 7.19033 11.1555 7 12 7C15.0376 7 17.5 9.46243 17.5 12.5C17.5 14.05 16.8588 15.4502 15.8273 16.4499L13.75 12.6H15.4986C15.4995 12.5668 15.5 12.5334 15.5 12.5C15.5 10.567 13.933 9 12 9C11.4912 9 11.0078 9.10856 10.5716 9.30378L9.64042 7.53044ZM14.3175 17.4894C13.6132 17.817 12.828 18 12 18C8.96243 18 6.5 15.5376 6.5 12.5C6.5 10.9678 7.12654 9.58193 8.13738 8.58462L10.25 12.5H8.5C8.5 14.433 10.067 16 12 16C12.4923 16 12.9608 15.8984 13.3857 15.715L14.3175 17.4894Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$289c3a51e540db8f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.9981 7L20.3075 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H5.99807L3.68867 7H5.99807L8.30747 3H11.9981L9.68867 7H11.9981L14.3075 3H17.9981L15.6887 7H17.9981Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$866be7976d9a83bc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.99807 7L8.30747 3H11.9981L9.68867 7H5.99807ZM11.9981 7L14.3075 3H17.9981L15.6887 7H11.9981ZM17.9981 7L20.3075 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H5.99807L4 6.46076V19H20V7H17.9981Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1cac52b72a5e845b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM9 8C6.792 8 5 9.792 5 12C5 14.208 6.792 16 9 16C10.1 16 11.1 15.55 11.828 14.828L10.4144 13.4144C10.0525 13.7762 9.5525 14 9 14C7.895 14 7 13.105 7 12C7 10.895 7.895 10 9 10C9.55 10 10.0483 10.22 10.4153 10.5866L11.829 9.173C11.1049 8.44841 10.1045 8 9 8ZM16 8C13.792 8 12 9.792 12 12C12 14.208 13.792 16 16 16C17.104 16 18.104 15.552 18.828 14.828L17.4144 13.4144C17.0525 13.7762 16.5525 14 16 14C14.895 14 14 13.105 14 12C14 10.895 14.895 10 16 10C16.553 10 17.0534 10.2241 17.4153 10.5866L18.829 9.173C18.1049 8.44841 17.1045 8 16 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fcd7161f85e23143(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V19H20V5ZM9 8C10.1045 8 11.1049 8.44841 11.829 9.173L10.4153 10.5866C10.0534 10.2241 9.55299 10 9 10C7.895 10 7 10.895 7 12C7 13.105 7.895 14 9 14C9.5525 14 10.0525 13.7762 10.4144 13.4144L11.828 14.828C11.104 15.552 10.104 16 9 16C6.792 16 5 14.208 5 12C5 9.792 6.792 8 9 8ZM16 8C17.1045 8 18.1049 8.44841 18.829 9.173L17.4153 10.5866C17.0534 10.2241 16.553 10 16 10C14.895 10 14 10.895 14 12C14 13.105 14.895 14 16 14C16.5525 14 17.0525 13.7762 17.4144 13.4144L18.828 14.828C18.104 15.552 17.104 16 16 16C13.792 16 12 14.208 12 12C12 9.792 13.792 8 16 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$149f55600ccbcb0e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9.17071C12.6872 9.06015 12.3506 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12V2.4578C19.0571 3.73207 22 7.52236 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.3375 2 12.6711 2.01672 13 2.04938V9.17071Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b5501350332375dc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4.58146V11.9999C15 13.6568 13.6569 14.9999 12 14.9999C10.3431 14.9999 9 13.6568 9 11.9999C9 10.3431 10.3431 8.99994 12 8.99994C12.3506 8.99994 12.6872 9.0601 13 9.17065V2.04932C18.0533 2.55104 22 6.81459 22 11.9999C22 17.5228 17.5228 21.9999 12 21.9999C6.47715 21.9999 2 17.5228 2 11.9999C2 6.81459 5.94668 2.55104 11 2.04932V4.06184C7.05369 4.55393 4 7.92032 4 11.9999C4 16.4182 7.58172 19.9999 12 19.9999C16.4183 19.9999 20 16.4182 20 11.9999C20 8.64256 17.9318 5.76823 15 4.58146Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8cc0fe8a0924bcb1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14.7453C2.18652 13.4804 1 11.3787 1 9C1 5.13401 4.13401 2 8 2C11.866 2 15 5.13401 15 9C15 11.3787 13.8135 13.4804 12 14.7453V21C12 21.5523 11.5523 22 11 22H5C4.44772 22 4 21.5523 4 21V14.7453ZM8 14C10.7614 14 13 11.7614 13 9C13 6.23858 10.7614 4 8 4C5.23858 4 3 6.23858 3 9C3 11.7614 5.23858 14 8 14ZM7 18V20H9V18H7ZM8 12C6.34315 12 5 10.6569 5 9C5 7.34315 6.34315 6 8 6C9.65685 6 11 7.34315 11 9C11 10.6569 9.65685 12 8 12ZM14 17V15.7083C15.8412 14.0604 17 11.6655 17 9C17 6.69494 16.1334 4.59227 14.7083 3H21C21.5523 3 22 3.44772 22 4V16C22 16.5523 21.5523 17 21 17H14ZM18 7V9H20V7H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$627c441d3fa6191c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.6076 3H21C21.5523 3 22 3.44772 22 4V16C22 16.5523 21.5523 17 21 17H14V15H20V5H13.7453C14.5362 6.13386 15 7.51276 15 9C15 11.3787 13.8135 13.4804 12 14.7453V21C12 21.5523 11.5523 22 11 22H5C4.44772 22 4 21.5523 4 21V14.7453C2.18652 13.4804 1 11.3787 1 9C1 5.13401 4.13401 2 8 2C9.31966 2 10.554 2.36517 11.6076 2.99999L11.6076 3ZM6 13.584V20H10V13.584C11.7659 12.8124 13 11.0503 13 9C13 6.23858 10.7614 4 8 4C5.23858 4 3 6.23858 3 9C3 11.0503 4.2341 12.8124 6 13.584ZM8 12C6.34315 12 5 10.6569 5 9C5 7.34315 6.34315 6 8 6C9.65685 6 11 7.34315 11 9C11 10.6569 9.65685 12 8 12ZM8 10C8.55228 10 9 9.55228 9 9C9 8.44772 8.55228 8 8 8C7.44772 8 7 8.44772 7 9C7 9.55228 7.44772 10 8 10ZM17 7H19V9H17V7ZM7 17H9V19H7V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e70617d50770c8ce(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11V6L8 13H11V18L16 11H13ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9b1d81b16b8b005a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM13 11H16L11 18V13H8L13 6V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eaecc5e87b3c29(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.416 3.62407L19.4818 14.2227C19.6349 14.4524 19.5729 14.7629 19.3431 14.9161C19.261 14.9708 19.1645 15 19.0657 15H4.93426C4.65812 15 4.43426 14.7762 4.43426 14.5C4.43426 14.4013 4.46348 14.3048 4.51823 14.2227L11.584 3.62407C11.7372 3.39431 12.0476 3.33222 12.2774 3.4854C12.3323 3.52201 12.3794 3.56914 12.416 3.62407ZM5 17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18C4 17.4477 4.44772 17 5 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6b2f66cad3f9eb1d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.73703 13H16.263L12 6.60558L7.73703 13ZM12.416 3.62407L19.4818 14.2227C19.6349 14.4524 19.5729 14.7629 19.3431 14.9161C19.261 14.9708 19.1645 15 19.0657 15H4.93426C4.65812 15 4.43426 14.7762 4.43426 14.5C4.43426 14.4013 4.46348 14.3048 4.51823 14.2227L11.584 3.62407C11.7372 3.39431 12.0476 3.33222 12.2774 3.4854C12.3323 3.52201 12.3794 3.56914 12.416 3.62407ZM5 17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18C4 17.4477 4.44772 17 5 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1d9dd0a396fa41d5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.17071 18C6.58254 16.8348 7.69378 16 9 16C10.3062 16 11.4175 16.8348 11.8293 18H22V20H11.8293C11.4175 21.1652 10.3062 22 9 22C7.69378 22 6.58254 21.1652 6.17071 20H2V18H6.17071ZM12.1707 11C12.5825 9.83481 13.6938 9 15 9C16.3062 9 17.4175 9.83481 17.8293 11H22V13H17.8293C17.4175 14.1652 16.3062 15 15 15C13.6938 15 12.5825 14.1652 12.1707 13H2V11H12.1707ZM6.17071 4C6.58254 2.83481 7.69378 2 9 2C10.3062 2 11.4175 2.83481 11.8293 4H22V6H11.8293C11.4175 7.16519 10.3062 8 9 8C7.69378 8 6.58254 7.16519 6.17071 6H2V4H6.17071Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4681ace4dfb4b5d3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.17071 18C6.58254 16.8348 7.69378 16 9 16C10.3062 16 11.4175 16.8348 11.8293 18H22V20H11.8293C11.4175 21.1652 10.3062 22 9 22C7.69378 22 6.58254 21.1652 6.17071 20H2V18H6.17071ZM12.1707 11C12.5825 9.83481 13.6938 9 15 9C16.3062 9 17.4175 9.83481 17.8293 11H22V13H17.8293C17.4175 14.1652 16.3062 15 15 15C13.6938 15 12.5825 14.1652 12.1707 13H2V11H12.1707ZM6.17071 4C6.58254 2.83481 7.69378 2 9 2C10.3062 2 11.4175 2.83481 11.8293 4H22V6H11.8293C11.4175 7.16519 10.3062 8 9 8C7.69378 8 6.58254 7.16519 6.17071 6H2V4H6.17071ZM9 6C9.55228 6 10 5.55228 10 5C10 4.44772 9.55228 4 9 4C8.44772 4 8 4.44772 8 5C8 5.55228 8.44772 6 9 6ZM15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12C14 12.5523 14.4477 13 15 13ZM9 20C9.55228 20 10 19.5523 10 19C10 18.4477 9.55228 18 9 18C8.44772 18 8 18.4477 8 19C8 19.5523 8.44772 20 9 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9bd8236464c88550(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM4 5V7H6V5H4ZM18 5V7H20V5H18ZM4 9V11H6V9H4ZM18 9V11H20V9H18ZM4 13V15H6V13H4ZM18 13V15H20V13H18ZM4 17V19H6V17H4ZM18 17V19H20V17H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c0df51867b0476ed(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM8 5V19H16V5H8ZM4 5V7H6V5H4ZM18 5V7H20V5H18ZM4 9V11H6V9H4ZM18 9V11H20V9H18ZM4 13V15H6V13H4ZM18 13V15H20V13H18ZM4 17V19H6V17H4ZM18 17V19H20V17H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$32d50e3d99284eba(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47715 2 2 6.47715 2 12 2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12H20C20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12 4 7.58172 7.58172 4 12 4 14.4639 4 16.6676 5.11383 18.1351 6.86543L16.1384 8.86165C15.6996 8.48063 15.1267 8.25 14.5 8.25 13.1193 8.25 12 9.36929 12 10.75V13.25C12 14.6307 13.1193 15.75 14.5 15.75 15.8807 15.75 17 14.6307 17 13.25V10.75C17 10.0686 16.7274 9.45094 16.2854 9H22V3L19.5534 5.44648C17.72 3.33509 15.0159 2 12 2ZM15.5 10.75V13.25C15.5 13.8023 15.0523 14.25 14.5 14.25 13.9477 14.25 13.5 13.8023 13.5 13.25V10.75C13.5 10.1977 13.9477 9.75 14.5 9.75 15.0523 9.75 15.5 10.1977 15.5 10.75ZM10 8.5H8.5V15.5H10V8.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d2a8453598b458ff(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47715 2 2 6.47715 2 12 2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12H20C20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12 4 7.58172 7.58172 4 12 4 14.7498 4 17.1755 5.38734 18.6155 7.50024L16 7.5V8.74982C15.5822 8.43597 15.0628 8.25 14.5 8.25 13.1193 8.25 12 9.36929 12 10.75V13.25C12 14.6307 13.1193 15.75 14.5 15.75 15.8807 15.75 17 14.6307 17 13.25V10.75C17 10.2946 16.8783 9.86772 16.6655 9.5H22V3.5H20L20.0001 5.99918C18.1757 3.57075 15.2713 2 12 2ZM15.5 10.75V13.25C15.5 13.8023 15.0523 14.25 14.5 14.25 13.9477 14.25 13.5 13.8023 13.5 13.25V10.75C13.5 10.1977 13.9477 9.75 14.5 9.75 15.0523 9.75 15.5 10.1977 15.5 10.75ZM10 8.5H8.5V15.5H10V8.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$495c5dffbeb34ab2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47715 2 2 6.47715 2 12 2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12H20C20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12 4 7.58172 7.58172 4 12 4 14.4639 4 16.6676 5.11383 18.1351 6.86543L16.5001 8.5H12V12.75H14.875C15.2202 12.75 15.5 13.0298 15.5 13.375 15.5 13.7202 15.2202 14 14.875 14H12V15.5H14.875C16.0486 15.5 17 14.5486 17 13.375 17 12.2014 16.0486 11.25 14.875 11.25H13.5V10H16.75V9H22V3L19.5534 5.44648C17.72 3.33509 15.0159 2 12 2ZM8.5 8.5H10V15.5H8.5V8.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4e2b9033afe3706d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47715 2 2 6.47715 2 12 2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12H20C20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12 4 7.58172 7.58172 4 12 4 14.7498 4 17.1755 5.38734 18.6155 7.50024L16 7.5V8.5H12V12.75H14.875C15.2202 12.75 15.5 13.0298 15.5 13.375 15.5 13.7202 15.2202 14 14.875 14H12V15.5H14.875C16.0486 15.5 17 14.5486 17 13.375 17 12.2014 16.0486 11.25 14.875 11.25H13.5V10H16.75V9.5H22V3.5H20L20.0001 5.99918C18.1757 3.57075 15.2713 2 12 2ZM8.5 8.5H10V15.5H8.5V8.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cb8582efcdbfffdf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12C2 6.47715 6.47715 2 12 2 15.0159 2 17.72 3.33509 19.5534 5.44648L22 3V9H16.7854C17.2274 9.45094 17.5 10.0686 17.5 10.75V13.25C17.5 14.6307 16.3807 15.75 15 15.75 13.6193 15.75 12.5 14.6307 12.5 13.25V10.75C12.5 9.36929 13.6193 8.25 15 8.25 15.4985 8.25 15.9629 8.39588 16.3528 8.64728L18.1351 6.86543C16.6676 5.11383 14.4639 4 12 4 7.58172 4 4 7.58172 4 12 4 16.4183 7.58172 20 12 20 16.4183 20 20 16.4183 20 12H22C22 17.5228 17.5228 22 12 22 6.47715 22 2 17.5228 2 12ZM15 9.75C14.4477 9.75 14 10.1977 14 10.75V13.25C14 13.8023 14.4477 14.25 15 14.25 15.5523 14.25 16 13.8023 16 13.25V10.75C16 10.1977 15.5523 9.75 15 9.75ZM9.99981 13.375C9.99981 13.0298 9.71999 12.75 9.37481 12.75H7.5V11.25H9.37481C9.71999 11.25 9.99981 10.9702 9.99981 10.625 9.99981 10.2798 9.71999 10 9.37481 10H6.75V8.5H9.37481C10.5484 8.5 11.4998 9.4514 11.4998 10.625 11.4998 11.1494 11.3099 11.6294 10.9951 12 11.3099 12.3706 11.4998 12.8506 11.4998 13.375 11.4998 14.5486 10.5484 15.5 9.37481 15.5H6.75V14H9.37481C9.71999 14 9.99981 13.7202 9.99981 13.375Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1b7720683babc332(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12C2 6.47715 6.47715 2 12 2 15.2713 2 18.1757 3.57075 20.0001 5.99918L20 3.5H22V9.5H17.1655C17.3783 9.86772 17.5 10.2946 17.5 10.75V13.25C17.5 14.6307 16.3807 15.75 15 15.75 13.6193 15.75 12.5 14.6307 12.5 13.25V10.75C12.5 9.36929 13.6193 8.25 15 8.25 15.3556 8.25 15.6938 8.32422 16 8.45802V7.5L18.6155 7.50024C17.1755 5.38734 14.7498 4 12 4 7.58172 4 4 7.58172 4 12 4 16.4183 7.58172 20 12 20 16.4183 20 20 16.4183 20 12H22C22 17.5228 17.5228 22 12 22 6.47715 22 2 17.5228 2 12ZM15 9.75C14.4477 9.75 14 10.1977 14 10.75V13.25C14 13.8023 14.4477 14.25 15 14.25 15.5523 14.25 16 13.8023 16 13.25V10.75C16 10.1977 15.5523 9.75 15 9.75ZM9.37481 12.75C9.71999 12.75 9.99981 13.0298 9.99981 13.375 9.99981 13.7202 9.71999 14 9.37481 14H6.75V15.5H9.37481C10.5484 15.5 11.4998 14.5486 11.4998 13.375 11.4998 12.8506 11.3099 12.3706 10.9951 12 11.3099 11.6294 11.4998 11.1494 11.4998 10.625 11.4998 9.4514 10.5484 8.5 9.37481 8.5H6.75V10H9.37481C9.71999 10 9.99981 10.2798 9.99981 10.625 9.99981 10.9702 9.71999 11.25 9.37481 11.25H7.5V12.75H9.37481Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$200462fc988a5a4e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12C2 6.47715 6.47715 2 12 2 15.0159 2 17.72 3.33509 19.5534 5.44648L22 3V9H16L18.1351 6.86543C16.6676 5.11383 14.4639 4 12 4 7.58172 4 4 7.58172 4 12 4 16.4183 7.58172 20 12 20 16.4183 20 20 16.4183 20 12H22C22 17.5228 17.5228 22 12 22 6.47715 22 2 17.5228 2 12ZM14.5 10V8.5H9.5V12.75H12.625C12.9702 12.75 13.25 13.0298 13.25 13.375 13.25 13.7202 12.9702 14 12.625 14H9.5V15.5H12.625C13.7986 15.5 14.75 14.5486 14.75 13.375 14.75 12.2014 13.7986 11.25 12.625 11.25H11V10H14.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$27583027b5dfe7a4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47715 2 2 6.47715 2 12 2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12H20C20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12 4 7.58172 7.58172 4 12 4 14.7498 4 17.1755 5.38734 18.6155 7.50024L16 7.5V9.5H22V3.5H20L20.0001 5.99918C18.1757 3.57075 15.2713 2 12 2ZM9.5 8.5H14.5V10H11V11.25H12.625C13.7986 11.25 14.75 12.2014 14.75 13.375 14.75 14.5486 13.7986 15.5 12.625 15.5H9.5V14H12.625C12.9702 14 13.25 13.7202 13.25 13.375 13.25 13.0298 12.9702 12.75 12.625 12.75H9.5V8.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c9139bebafcc8279(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7H22V9H16V3H18V7ZM8 9H2V7H6V3H8V9ZM18 17V21H16V15H22V17H18ZM8 15V21H6V17H2V15H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b8cd62ec35cc79ea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7H22V9H16V3H18V7ZM8 9H2V7H6V3H8V9ZM18 17V21H16V15H22V17H18ZM8 15V21H6V17H2V15H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2bc5df652824daa7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3H22V9H20V5H16V3ZM2 3H8V5H4V9H2V3ZM20 19V15H22V21H16V19H20ZM4 19H8V21H2V15H4V19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b97d80c1f17277f6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3V5H4V9H2V3H8ZM2 21V15H4V19H8V21H2ZM22 21H16V19H20V15H22V21ZM22 9H20V5H16V3H22V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5a1c046833c8459a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.409 19C16.633 16.6012 15.1323 15.1147 13.1434 13.3979C15.0238 11.8971 17.4071 11 20 11V3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H6V1H8V5H4V12C9.22015 12 13.6618 14.4616 15.3127 19H17.409ZM18 1V5H10V3H16V1H18ZM16.5 10C15.6716 10 15 9.32843 15 8.5C15 7.67157 15.6716 7 16.5 7C17.3284 7 18 7.67157 18 8.5C18 9.32843 17.3284 10 16.5 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7c712f947ad260db(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13C18.3221 13 16.7514 13.4592 15.4068 14.2587C16.5908 15.6438 17.5269 17.2471 18.1465 19H20V13ZM16.0037 19C14.0446 14.3021 9.4079 11 4 11V19H16.0037ZM4 9C7.82914 9 11.3232 10.4348 13.9738 12.7961C15.7047 11.6605 17.7752 11 20 11V3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H6V1H8V5H4V9ZM18 1V5H10V3H16V1H18ZM16.5 10C15.6716 10 15 9.32843 15 8.5C15 7.67157 15.6716 7 16.5 7C17.3284 7 18 7.67157 18 8.5C18 9.32843 17.3284 10 16.5 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6db74845adc79798(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1V3H16V1H18V3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H6V1H8ZM12 8L8 12H11V16H13V12H16L12 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$88e77cc53cf2ec1a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1V5H4V19H20V3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H6V1H8ZM12 8L16 12H13V16H11V12H8L12 8ZM18 1V5H10V3H16V1H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$50af6329b3543cf9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM7.5 11.25V9H6V15H7.5V12.75H9.5V15H11V9H9.5V11.25H7.5ZM14.5 10.5H16C16.2761 10.5 16.5 10.7239 16.5 11V13C16.5 13.2761 16.2761 13.5 16 13.5H14.5V10.5ZM13 9V15H16C17.1046 15 18 14.1046 18 13V11C18 9.89543 17.1046 9 16 9H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8d6d91357177803e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5V19H20V5H4ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM7.5 11.25H9.5V9H11V15H9.5V12.75H7.5V15H6V9H7.5V11.25ZM14.5 10.5V13.5H16C16.2761 13.5 16.5 13.2761 16.5 13V11C16.5 10.7239 16.2761 10.5 16 10.5H14.5ZM13 9H16C17.1046 9 18 9.89543 18 11V13C18 14.1046 17.1046 15 16 15H13V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f1f73b8c74afade4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12H7C8.10457 12 9 12.8954 9 14V19C9 20.1046 8.10457 21 7 21H4C2.89543 21 2 20.1046 2 19V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V19C22 20.1046 21.1046 21 20 21H17C15.8954 21 15 20.1046 15 19V14C15 12.8954 15.8954 12 17 12H20C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$479df6050a8938d2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.58172 4 4 7.58172 4 12H7C8.10457 12 9 12.8954 9 14V19C9 20.1046 8.10457 21 7 21H4C2.89543 21 2 20.1046 2 19V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V19C22 20.1046 21.1046 21 20 21H17C15.8954 21 15 20.1046 15 19V14C15 12.8954 15.8954 12 17 12H20C20 7.58172 16.4183 4 12 4ZM4 14V19H7V14H4ZM17 14V19H20V14H17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$aba673a0bebb6eb9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM7.5 11.25V9H6V15H7.5V12.75H9.5V15H11V9H9.5V11.25H7.5ZM16.25 15H17C17.5523 15 18 14.5523 18 14V10C18 9.44772 17.5523 9 17 9H14C13.4477 9 13 9.44772 13 10V14C13 14.5523 13.4477 15 14 15H14.75V16.5H16.25V15ZM14.5 10.5H16.5V13.5H14.5V10.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c222f0ad88b5c31a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5V19H20V5H4ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM7.5 11.25H9.5V9H11V15H9.5V12.75H7.5V15H6V9H7.5V11.25ZM16.25 15V16.5H14.75V15H14C13.4477 15 13 14.5523 13 14V10C13 9.44772 13.4477 9 14 9H17C17.5523 9 18 9.44772 18 10V14C18 14.5523 17.5523 15 17 15H16.25ZM14.5 10.5V13.5H16.5V10.5H14.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b73f023e1b52cb4c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11.1005L7 9.1005L12.5 14.6005L16 11.1005L19 14.1005V5H5V11.1005ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$de8d6d1bb67bc5ed(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11.1005L7 9.1005L12.5 14.6005L16 11.1005L19 14.1005V5H5V11.1005ZM5 13.9289V19H8.1005L11.0858 16.0147L7 11.9289L5 13.9289ZM10.9289 19H19V16.9289L16 13.9289L10.9289 19ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c46bad4bd9bc192a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15V18H24V20H21V23H19V20H16V18H19V15H21ZM21.0082 3C21.556 3 22 3.44495 22 3.9934L22.0007 13.3417C21.3749 13.1204 20.7015 13 20 13V5H4L4.001 19L13.2929 9.70715C13.6528 9.34604 14.22 9.31823 14.6123 9.62322L14.7065 9.70772L18.2521 13.2586C15.791 14.0069 14 16.2943 14 19C14 19.7015 14.1204 20.3749 14.3417 21.0007L2.9918 21C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082ZM8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a0a49613207aeb61(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15V18H24V20H21V23H19V20H16V18H19V15H21ZM21.0082 3C21.556 3 22 3.44495 22 3.9934V13H20V5H4V18.999L14 9L17 12V14.829L14 11.8284L6.827 19H14V21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082ZM8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$af4bbed1943f8f06(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3C20.5523 3 21 3.44772 21 4V5.757L19 7.757V5H5V13.1L9 9.1005L13.328 13.429L12.0012 14.7562L11.995 18.995L16.2414 19.0012L17.571 17.671L18.8995 19H19V16.242L21 14.242V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM21.7782 7.80761L23.1924 9.22183L15.4142 17L13.9979 16.9979L14 15.5858L21.7782 7.80761ZM15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6236824884a61f12(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3C20.5523 3 21 3.44772 21 4V5.757L19 7.757V5H5V13.1L9 9.1005L13.328 13.429L11.9132 14.8422L9 11.9289L5 15.928V19H15.533L16.2414 19.0012L17.57 17.671L18.8995 19H19V16.242L21 14.242V20C21 20.5523 20.5523 21 20 21H4C3.45 21 3 20.55 3 20V4C3 3.44772 3.44772 3 4 3H20ZM21.7782 7.80761L23.1924 9.22183L15.4142 17L13.9979 16.9979L14 15.5858L21.7782 7.80761ZM15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9107f0cd129a2768(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5H4V19L13.2923 9.70649C13.6828 9.31595 14.3159 9.31591 14.7065 9.70641L20 15.0104V5ZM2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fc12e667abedf284(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.9918 21C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918ZM20 15V5H4V19L14 9L20 15ZM20 17.8284L14 11.8284L6.82843 19H20V17.8284ZM8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7e5fd45776add31e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21L11.2381 12.2698L15 6L23 21H16ZM8 10L14 21H2L8 10ZM5.5 8C4.11929 8 3 6.88071 3 5.5C3 4.11929 4.11929 3 5.5 3C6.88071 3 8 4.11929 8 5.5C8 6.88071 6.88071 8 5.5 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bcfda876cfcd51ca(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.2703 12.2162L15 6L23 21H2L9 8L11.2703 12.2162ZM12.3897 14.2378L14.9873 19H19.6667L14.8976 10.058L12.3897 14.2378ZM5.34843 19H12.6516L9 12.2185L5.34843 19ZM5.5 8C4.11929 8 3 6.88071 3 5.5C3 4.11929 4.11929 3 5.5 3C6.88071 3 8 4.11929 8 5.5C8 6.88071 6.88071 8 5.5 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8c3aff657235de08(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM7.4 8.82867C7.2067 8.82867 7.04543 8.96578 7.00813 9.14806L7 9.22867V14.7713C7 14.8474 7.02169 14.9219 7.06254 14.9861C7.16631 15.1492 7.36858 15.2116 7.54238 15.1452L7.61475 15.1088L11.9697 12.3375C12.0191 12.306 12.061 12.2641 12.0924 12.2148C12.1962 12.0517 12.1671 11.842 12.0333 11.7127L11.9697 11.6625L7.61475 8.8912C7.55057 8.85036 7.47607 8.82867 7.4 8.82867Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4f0df79c9af0bef1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM15 6H3V18H15V6ZM7.4 8.82867C7.47607 8.82867 7.55057 8.85036 7.61475 8.8912L11.9697 11.6625C12.1561 11.7811 12.211 12.0284 12.0924 12.2148C12.061 12.2641 12.0191 12.306 11.9697 12.3375L7.61475 15.1088C7.42837 15.2274 7.18114 15.1725 7.06254 14.9861C7.02169 14.9219 7 14.8474 7 14.7713V9.22867C7 9.00776 7.17909 8.82867 7.4 8.82867ZM21 8.84131L17 11.641V12.359L21 15.1587V8.84131Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$204c5b404ad08fb1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12C22 6.47715 17.5228 2 12 2 8.9841 2 6.28002 3.33509 4.44656 5.44648L2 3V9H8L5.86492 6.86543C7.33243 5.11383 9.53614 4 12 4 16.4183 4 20 7.58172 20 12 20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12ZM10.7774 8.51823 15.376 11.584C15.6728 11.7819 15.6728 12.2181 15.376 12.416L10.7773 15.4818C10.4451 15.7033 10 15.4651 10 15.0657V8.93426C10 8.53491 10.4451 8.29672 10.7774 8.51823Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a9329365c8c19d7c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12C22 6.47715 17.5228 2 12 2 8.72873 2 5.82434 3.57075 3.99989 5.99918L4 3.5H2V9.5H8V7.5L5.38451 7.50024C6.82447 5.38734 9.25022 4 12 4 16.4183 4 20 7.58172 20 12 20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12ZM10.7774 8.51823 15.376 11.584C15.6728 11.7819 15.6728 12.2181 15.376 12.416L10.7773 15.4818C10.4451 15.7033 10 15.4651 10 15.0657V8.93426C10 8.53491 10.4451 8.29672 10.7774 8.51823Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ba8fc0c2c00ede2b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9991 1C14.7605 1 16.9991 3.23858 16.9991 6V12C16.9991 14.7614 14.7605 17 11.9991 17C9.23767 17 6.9991 14.7614 6.9991 12V6C6.9991 3.23858 9.23767 1 11.9991 1ZM2.19141 13.9615L4.15294 13.5692C4.88224 17.2361 8.1179 20 11.9991 20C15.8803 20 19.1159 17.2361 19.8452 13.5692L21.8068 13.9615C20.8952 18.5452 16.8506 22 11.9991 22C7.1476 22 3.10303 18.5452 2.19141 13.9615Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$82f56e6e019ddda3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9991 3C10.3422 3 8.9991 4.34315 8.9991 6V12C8.9991 13.6569 10.3422 15 11.9991 15C13.656 15 14.9991 13.6569 14.9991 12V6C14.9991 4.34315 13.656 3 11.9991 3ZM11.9991 1C14.7605 1 16.9991 3.23858 16.9991 6V12C16.9991 14.7614 14.7605 17 11.9991 17C9.23767 17 6.9991 14.7614 6.9991 12V6C6.9991 3.23858 9.23767 1 11.9991 1ZM2.19141 13.9615L4.15294 13.5692C4.88224 17.2361 8.1179 20 11.9991 20C15.8803 20 19.1159 17.2361 19.8452 13.5692L21.8068 13.9615C20.8952 18.5452 16.8506 22 11.9991 22C7.1476 22 3.10303 18.5452 2.19141 13.9615Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$97eac39dcd73cce8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9998 1C14.7612 1 16.9998 3.23858 16.9998 6V10C16.9998 12.7614 14.7612 15 11.9998 15C9.23833 15 6.99976 12.7614 6.99976 10V6C6.99976 3.23858 9.23833 1 11.9998 1ZM3.05469 11H5.07065C5.55588 14.3923 8.47329 17 11.9998 17C15.5262 17 18.4436 14.3923 18.9289 11H20.9448C20.4837 15.1716 17.1714 18.4839 12.9998 18.9451V23H10.9998V18.9451C6.82814 18.4839 3.51584 15.1716 3.05469 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$785a2922ed80a37c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9998 3C10.3429 3 8.99976 4.34315 8.99976 6V10C8.99976 11.6569 10.3429 13 11.9998 13C13.6566 13 14.9998 11.6569 14.9998 10V6C14.9998 4.34315 13.6566 3 11.9998 3ZM11.9998 1C14.7612 1 16.9998 3.23858 16.9998 6V10C16.9998 12.7614 14.7612 15 11.9998 15C9.23833 15 6.99976 12.7614 6.99976 10V6C6.99976 3.23858 9.23833 1 11.9998 1ZM3.05469 11H5.07065C5.55588 14.3923 8.47329 17 11.9998 17C15.5262 17 18.4436 14.3923 18.9289 11H20.9448C20.4837 15.1716 17.1714 18.4839 12.9998 18.9451V23H10.9998V18.9451C6.82814 18.4839 3.51584 15.1716 3.05469 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5f6459a9c8351b68(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.4259 17.839C15.3939 18.4228 14.2351 18.8087 13.0011 18.9451V23H11.0011V18.9451C6.82952 18.4839 3.51721 15.1716 3.05606 11H5.07202C5.55725 14.3923 8.47466 17 12.0011 17C13.0513 17 14.0474 16.7688 14.9413 16.3544L13.3912 14.8042C12.9499 14.9317 12.4835 15 12.0011 15C9.23971 15 7.00113 12.7614 7.00113 10V8.41421L1.39453 2.80761L2.80874 1.3934L22.6077 21.1924L21.1935 22.6066L16.4259 17.839ZM19.3757 15.1604L17.9333 13.7179C18.4417 12.9084 18.789 11.9874 18.9302 11H20.9462C20.7763 12.5366 20.2197 13.9565 19.3757 15.1604ZM16.4668 12.2514L7.68672 3.47139C8.55524 1.99268 10.1623 1 12.0011 1C14.7626 1 17.0011 3.23858 17.0011 6V10C17.0011 10.8099 16.8086 11.5748 16.4668 12.2514Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cd38be6fb40d3c28(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.4259 17.839L21.1935 22.6066L22.6077 21.1924L2.80874 1.3934L1.39453 2.80761L7.00113 8.41421V10C7.00113 12.7614 9.23971 15 12.0011 15C12.4835 15 12.9499 14.9317 13.3912 14.8042L14.9413 16.3544C14.0474 16.7688 13.0513 17 12.0011 17C8.47466 17 5.55725 14.3923 5.07202 11H3.05606C3.51721 15.1716 6.82952 18.4839 11.0011 18.9451V23H13.0011V18.9451C14.2351 18.8087 15.3939 18.4228 16.4259 17.839ZM11.5538 12.9669C10.2551 12.7727 9.22843 11.7461 9.03426 10.4473L11.5538 12.9669ZM19.3757 15.1604L17.9333 13.7179C18.4417 12.9084 18.789 11.9874 18.9302 11H20.9462C20.7763 12.5366 20.2197 13.9565 19.3757 15.1604ZM16.4668 12.2514L14.9183 10.703C14.9725 10.4775 15.0011 10.2421 15.0011 10V6C15.0011 4.34315 13.658 3 12.0011 3C10.7069 3 9.60408 3.81956 9.18335 4.96802L7.68672 3.47139C8.55524 1.99268 10.1623 1 12.0011 1C14.7626 1 17.0011 3.23858 17.0011 6V10C17.0011 10.8099 16.8086 11.5748 16.4668 12.2514Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$46749d5797807491(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.001 20H20V22H12C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 15.2712 20.4293 18.1755 18.001 20ZM12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10ZM8 14C9.10457 14 10 13.1046 10 12C10 10.8954 9.10457 10 8 10C6.89543 10 6 10.8954 6 12C6 13.1046 6.89543 14 8 14ZM16 14C17.1046 14 18 13.1046 18 12C18 10.8954 17.1046 10 16 10C14.8954 10 14 10.8954 14 12C14 13.1046 14.8954 14 16 14ZM12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f9de290dabedbd58(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20H20V22H12C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 14.2512 21.2561 16.3287 20.0007 18H17.2916C18.9525 16.5341 20 14.3894 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8C14 9.10457 13.1046 10 12 10ZM8 14C6.89543 14 6 13.1046 6 12C6 10.8954 6.89543 10 8 10C9.10457 10 10 10.8954 10 12C10 13.1046 9.10457 14 8 14ZM16 14C14.8954 14 14 13.1046 14 12C14 10.8954 14.8954 10 16 10C17.1046 10 18 10.8954 18 12C18 13.1046 17.1046 14 16 14ZM12 18C10.8954 18 10 17.1046 10 16C10 14.8954 10.8954 14 12 14C13.1046 14 14 14.8954 14 16C14 17.1046 13.1046 18 12 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b6827cc5f0efb092(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM10.6219 8.41459C10.5562 8.37078 10.479 8.34741 10.4 8.34741C10.1791 8.34741 10 8.52649 10 8.74741V15.2526C10 15.3316 10.0234 15.4088 10.0672 15.4745C10.1897 15.6583 10.4381 15.708 10.6219 15.5854L15.5008 12.3328C15.5447 12.3035 15.5824 12.2658 15.6117 12.2219C15.7343 12.0381 15.6846 11.7897 15.5008 11.6672L10.6219 8.41459Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6c2499bcc29f9697(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM4 5V19H20V5H4ZM10.6219 8.41459L15.5008 11.6672C15.6846 11.7897 15.7343 12.0381 15.6117 12.2219C15.5824 12.2658 15.5447 12.3035 15.5008 12.3328L10.6219 15.5854C10.4381 15.708 10.1897 15.6583 10.0672 15.4745C10.0234 15.4088 10 15.3316 10 15.2526V8.74741C10 8.52649 10.1791 8.34741 10.4 8.34741C10.479 8.34741 10.5562 8.37078 10.6219 8.41459Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3eb6cd34b0e24058(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3V17C20 19.2091 18.2091 21 16 21C13.7909 21 12 19.2091 12 17C12 14.7909 13.7909 13 16 13C16.7286 13 17.4117 13.1948 18 13.5351V6H9V17C9 19.2091 7.20914 21 5 21C2.79086 21 1 19.2091 1 17C1 14.7909 2.79086 13 5 13C5.72857 13 6.41165 13.1948 7 13.5351V3H20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cf375421bc7da2cd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3V17C20 19.2091 18.2091 21 16 21C13.7909 21 12 19.2091 12 17C12 14.7909 13.7909 13 16 13C16.7286 13 17.4117 13.1948 18 13.5351V5H9V17C9 19.2091 7.20914 21 5 21C2.79086 21 1 19.2091 1 17C1 14.7909 2.79086 13 5 13C5.72857 13 6.41165 13.1948 7 13.5351V3H20ZM5 19C6.10457 19 7 18.1046 7 17C7 15.8954 6.10457 15 5 15C3.89543 15 3 15.8954 3 17C3 18.1046 3.89543 19 5 19ZM16 19C17.1046 19 18 18.1046 18 17C18 15.8954 17.1046 15 16 15C14.8954 15 14 15.8954 14 17C14 18.1046 14.8954 19 16 19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$37572f5cf3056a3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.5351V3H20V6H14V17C14 19.2091 12.2091 21 10 21C7.79086 21 6 19.2091 6 17C6 14.7909 7.79086 13 10 13C10.7286 13 11.4117 13.1948 12 13.5351Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$18007f37136dac8f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.5351V3H20V5H14V17C14 19.2091 12.2091 21 10 21C7.79086 21 6 19.2091 6 17C6 14.7909 7.79086 13 10 13C10.7286 13 11.4117 13.1948 12 13.5351ZM10 19C11.1046 19 12 18.1046 12 17C12 15.8954 11.1046 15 10 15C8.89543 15 8 15.8954 8 17C8 18.1046 8.89543 19 10 19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$be32d70ebd89279e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM12 12.1707C11.6872 12.0602 11.3506 12 11 12C9.34315 12 8 13.3431 8 15C8 16.6569 9.34315 18 11 18C12.6569 18 14 16.6569 14 15V8H17V6H12V12.1707Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$41c1191a1d73ca01(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM4 5V19H20V5H4ZM12 12.1707V6H17V8H14V15C14 16.6569 12.6569 18 11 18C9.34315 18 8 16.6569 8 15C8 13.3431 9.34315 12 11 12C11.3506 12 11.6872 12.0602 12 12.1707Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fd67d7f1ce0cede3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 20H2V18H3V11.0314C3 6.04348 7.02944 2 12 2C16.9706 2 21 6.04348 21 11.0314V18H22V20ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3b35230ab4581e6f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 20H2V18H3V11.0314C3 6.04348 7.02944 2 12 2C16.9706 2 21 6.04348 21 11.0314V18H22V20ZM5 18H19V11.0314C19 7.14806 15.866 4 12 4C8.13401 4 5 7.14806 5 11.0314V18ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a64327c5e7f8e501(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17H22V19H2V17H4V10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V17ZM9 21H15V23H9V21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c36a3406d303a36c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17H22V19H2V17H4V10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V17ZM18 17V10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10V17H18ZM9 21H15V23H9V21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cda6059c27109386(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18.6667L20.4 19.2C20.5657 19.4209 20.5209 19.7343 20.3 19.9C20.2135 19.9649 20.1082 20 20 20H4C3.72386 20 3.5 19.7761 3.5 19.5C3.5 19.3918 3.53509 19.2865 3.6 19.2L4 18.6667V10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V18.6667ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5e6f62e77f017be3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10V18H18V10ZM20 18.6667L20.4 19.2C20.5657 19.4209 20.5209 19.7343 20.3 19.9C20.2135 19.9649 20.1082 20 20 20H4C3.72386 20 3.5 19.7761 3.5 19.5C3.5 19.3918 3.53509 19.2865 3.6 19.2L4 18.6667V10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V18.6667ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4fdbcd5807eb4626(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C16.9706 2 21 6.04348 21 11.0314V20H3V11.0314C3 6.04348 7.02944 2 12 2ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$50603c8e5327ccf3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18H19V11.0314C19 7.14806 15.866 4 12 4C8.13401 4 5 7.14806 5 11.0314V18ZM12 2C16.9706 2 21 6.04348 21 11.0314V20H3V11.0314C3 6.04348 7.02944 2 12 2ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ec84a7e2ae634fad(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5869 20.0002H4.00113C3.72499 20.0002 3.50113 19.7763 3.50113 19.5002C3.50113 19.392 3.53622 19.2867 3.60113 19.2002L4.00113 18.6668V10.0002C4.00113 8.67034 4.3256 7.41631 4.89968 6.31291L1.39453 2.80777L2.80874 1.39355L22.6077 21.1925L21.1935 22.6068L18.5869 20.0002ZM20.0011 15.786L7.56016 3.34499C8.83067 2.49549 10.3581 2.00016 12.0011 2.00016C16.4194 2.00016 20.0011 5.58188 20.0011 10.0002V15.786ZM9.50113 21.0002H14.5011C14.5011 22.3809 13.3818 23.5002 12.0011 23.5002C10.6204 23.5002 9.50113 22.3809 9.50113 21.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$24ea0c53b89aefca(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5869 20.0002H4.00113C3.72499 20.0002 3.50113 19.7763 3.50113 19.5002C3.50113 19.392 3.53622 19.2867 3.60113 19.2002L4.00113 18.6668V10.0002C4.00113 8.67034 4.3256 7.41631 4.89968 6.31291L1.39453 2.80777L2.80874 1.39355L22.6077 21.1925L21.1935 22.6068L18.5869 20.0002ZM6.40874 7.82198C6.14556 8.49719 6.00113 9.23181 6.00113 10.0002V18.0002H16.5869L6.40874 7.82198ZM20.0011 15.786L18.0011 13.786V10.0002C18.0011 6.68645 15.3148 4.00016 12.0011 4.00016C10.9127 4.00016 9.89194 4.28998 9.01185 4.79667L7.56016 3.34499C8.83067 2.49549 10.3581 2.00016 12.0011 2.00016C16.4194 2.00016 20.0011 5.58188 20.0011 10.0002V15.786ZM9.50113 21.0002H14.5011C14.5011 22.3809 13.3818 23.5002 12.0011 23.5002C10.6204 23.5002 9.50113 22.3809 9.50113 21.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5a204f5956e6d4f2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3.99986V2.06738C17 1.79124 17.2239 1.56738 17.5 1.56738C17.617 1.56738 17.7302 1.60839 17.8201 1.68327L21.9391 5.11575C22.1512 5.29253 22.1799 5.60782 22.0031 5.81995C21.9081 5.93395 21.7674 5.99986 21.619 5.99986H2V3.99986H17ZM2 17.9999H22V19.9999H2V17.9999ZM2 10.9999H22V12.9999H2V10.9999Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$aefefc022d0d48ce(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3.99986V2.06738C17 1.79124 17.2239 1.56738 17.5 1.56738C17.617 1.56738 17.7302 1.60839 17.8201 1.68327L21.9391 5.11575C22.1512 5.29253 22.1799 5.60782 22.0031 5.81995C21.9081 5.93395 21.7674 5.99986 21.619 5.99986H2V3.99986H17ZM2 17.9999H22V19.9999H2V17.9999ZM2 10.9999H22V12.9999H2V10.9999Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bcaf2961c28df594(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9 9V15H11V9H9ZM13 9V15H15V9H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f0e2403ad2281b7e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM9 9H11V15H9V9ZM13 9H15V15H13V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7e96c5a02ccc8cb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5H8V19H6V5ZM16 5H18V19H16V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ce84b1ec481bb394(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5H8V19H6V5ZM16 5H18V19H16V5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f6e9346a0b9bfeff(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7C15 6.44772 15.4477 6 16 6C16.5523 6 17 6.44772 17 7V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V7ZM7 7C7 6.44772 7.44772 6 8 6C8.55228 6 9 6.44772 9 7V17C9 17.5523 8.55228 18 8 18C7.44772 18 7 17.5523 7 17V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f691c513550bcdd2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7C15 6.44772 15.4477 6 16 6C16.5523 6 17 6.44772 17 7V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V7ZM7 7C7 6.44772 7.44772 6 8 6C8.55228 6 9 6.44772 9 7V17C9 17.5523 8.55228 18 8 18C7.44772 18 7 17.5523 7 17V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e350e0f95276c88b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8027 4C14.2922 4.88252 14 5.90714 14 7C14 10.3137 16.6863 13 20 13C21.0929 13 22.1175 12.7078 23 12.1973V18.9991C23 19.5519 22.5605 20 21.9975 20H2.00246C1.44882 20 1 19.5554 1 18.9991V5.00087C1 4.44811 1.43946 4 2.00246 4H14.8027ZM20 11C17.7909 11 16 9.20914 16 7C16 4.79086 17.7909 3 20 3C22.2091 3 24 4.79086 24 7C24 9.20914 22.2091 11 20 11ZM20 9C21.1046 9 22 8.10457 22 7C22 5.89543 21.1046 5 20 5C18.8954 5 18 5.89543 18 7C18 8.10457 18.8954 9 20 9ZM19 15V18H21V15H19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3b4b4f3b79a0faea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8027 4C14.4513 4.60738 14.2034 5.28208 14.083 6H3V18H21V12.917C21.7179 12.7966 22.3926 12.5487 23 12.1973V18.9991C23 19.5519 22.5605 20 21.9975 20H2.00246C1.44882 20 1 19.5554 1 18.9991V5.00087C1 4.44811 1.43946 4 2.00246 4H14.8027ZM20 9C21.1046 9 22 8.10457 22 7C22 5.89543 21.1046 5 20 5C18.8954 5 18 5.89543 18 7C18 8.10457 18.8954 9 20 9ZM20 11C17.7909 11 16 9.20914 16 7C16 4.79086 17.7909 3 20 3C22.2091 3 24 4.79086 24 7C24 9.20914 22.2091 11 20 11ZM18 13H20V16H18V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7fddb814ea2dc3c8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V11H20V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 13C21.5523 13 22 13.4477 22 14V20C22 20.5523 21.5523 21 21 21H13C12.4477 21 12 20.5523 12 20V14C12 13.4477 12.4477 13 13 13H21ZM6.70711 6.29289L8.95689 8.54289L11 6.5V12H5.5L7.54289 9.95689L5.29289 7.70711L6.70711 6.29289Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$95c03adc8306a74c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V11H20V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 13C21.5523 13 22 13.4477 22 14V20C22 20.5523 21.5523 21 21 21H13C12.4477 21 12 20.5523 12 20V14C12 13.4477 12.4477 13 13 13H21ZM20 15H14V19H20V15ZM6.70711 6.29289L8.95689 8.54289L11 6.5V12H5.5L7.54289 9.95689L5.29289 7.70711L6.70711 6.29289Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b948be4330019d12(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V11H20V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 13C21.5523 13 22 13.4477 22 14V20C22 20.5523 21.5523 21 21 21H13C12.4477 21 12 20.5523 12 20V14C12 13.4477 12.4477 13 13 13H21ZM11.5 7L9.45711 9.04311L11.7071 11.2929L10.2929 12.7071L8.04311 10.4571L6 12.5V7H11.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$21923759c2bbd16(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V11H20V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 13C21.5523 13 22 13.4477 22 14V20C22 20.5523 21.5523 21 21 21H13C12.4477 21 12 20.5523 12 20V14C12 13.4477 12.4477 13 13 13H21ZM20 15H14V19H20V15ZM11.5 7L9.45711 9.04311L11.7071 11.2929L10.2929 12.7071L8.04311 10.4571L6 12.5V7H11.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a91e0b31cd96b508(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V11H20V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 13C21.5523 13 22 13.4477 22 14V20C22 20.5523 21.5523 21 21 21H13C12.4477 21 12 20.5523 12 20V14C12 13.4477 12.4477 13 13 13H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$205f6c6806ffdd5b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3C21.5523 3 22 3.44772 22 4V11H20V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 13C21.5523 13 22 13.4477 22 14V20C22 20.5523 21.5523 21 21 21H13C12.4477 21 12 20.5523 12 20V14C12 13.4477 12.4477 13 13 13H21ZM20 15H14V19H20V15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3cbc9b5c53953a51(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM10.6219 8.41459C10.5562 8.37078 10.479 8.34741 10.4 8.34741C10.1791 8.34741 10 8.52649 10 8.74741V15.2526C10 15.3316 10.0234 15.4088 10.0672 15.4745C10.1897 15.6583 10.4381 15.708 10.6219 15.5854L15.5008 12.3328C15.5447 12.3035 15.5824 12.2658 15.6117 12.2219C15.7343 12.0381 15.6846 11.7897 15.5008 11.6672L10.6219 8.41459Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$af70c051dd10300(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM10.6219 8.41459L15.5008 11.6672C15.6846 11.7897 15.7343 12.0381 15.6117 12.2219C15.5824 12.2658 15.5447 12.3035 15.5008 12.3328L10.6219 15.5854C10.4381 15.708 10.1897 15.6583 10.0672 15.4745C10.0234 15.4088 10 15.3316 10 15.2526V8.74741C10 8.52649 10.1791 8.34741 10.4 8.34741C10.479 8.34741 10.5562 8.37078 10.6219 8.41459Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c94de331c2527d4a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.376 12.4158L8.77735 19.4816C8.54759 19.6348 8.23715 19.5727 8.08397 19.3429C8.02922 19.2608 8 19.1643 8 19.0656V4.93408C8 4.65794 8.22386 4.43408 8.5 4.43408C8.59871 4.43408 8.69522 4.4633 8.77735 4.51806L19.376 11.5838C19.6057 11.737 19.6678 12.0474 19.5146 12.2772C19.478 12.3321 19.4309 12.3792 19.376 12.4158Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2fb37f7187c91f24(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.3944 11.9998L10 7.73686V16.2628L16.3944 11.9998ZM19.376 12.4158L8.77735 19.4816C8.54759 19.6348 8.23715 19.5727 8.08397 19.3429C8.02922 19.2608 8 19.1643 8 19.0656V4.93408C8 4.65794 8.22386 4.43408 8.5 4.43408C8.59871 4.43408 8.69522 4.4633 8.77735 4.51806L19.376 11.5838C19.6057 11.737 19.6678 12.0474 19.5146 12.2772C19.478 12.3321 19.4309 12.3792 19.376 12.4158Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9f0a9cd63efa2bbe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18V20H2V18H22ZM2 3.5L10 8.5L2 13.5V3.5ZM22 11V13H12V11H22ZM22 4V6H12V4H22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$16bb36d5ce77639a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18V20H2V18H22ZM2 3.5L10 8.5L2 13.5V3.5ZM22 11V13H12V11H22ZM4 7.1085V9.8915L6.22641 8.5L4 7.1085ZM22 4V6H12V4H22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9ebc013631f11cd9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18H12V20H2V18ZM2 11H22V13H2V11ZM2 4H22V6H2V4ZM18 18V15H20V18H23V20H20V23H18V20H15V18H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a7fa104b3c4bbbd7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18H12V20H2V18ZM2 11H22V13H2V11ZM2 4H22V6H2V4ZM18 18V15H20V18H23V20H20V23H18V20H15V18H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ab2a8fd0c7abf302(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18H12V20H2V18ZM2 11H16V13H2V11ZM2 4H22V6H2V4ZM19 15.1707V9H24V11H21V18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.3431 16.3431 15 18 15C18.3506 15 18.6872 15.0602 19 15.1707Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$af2e2fc1064f8985(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18H12V20H2V18ZM2 11H16V13H2V11ZM2 4H22V6H2V4ZM19 15.1707V9H24V11H21V18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.3431 16.3431 15 18 15C18.3506 15 18.6872 15.0602 19 15.1707ZM18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d6dc176e55ea856a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.75194 5.43872L18.2596 11.5682C18.4981 11.7073 18.5787 12.0135 18.4396 12.252C18.3961 12.3265 18.3341 12.3885 18.2596 12.432L7.75194 18.5615C7.51341 18.7006 7.20725 18.62 7.06811 18.3815C7.0235 18.305 7 18.2181 7 18.1296V5.87061C7 5.59446 7.22386 5.37061 7.5 5.37061C7.58853 5.37061 7.67547 5.39411 7.75194 5.43872Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$54b82e3c3f6803e1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8.48216V15.518L15.0307 12.0001L9 8.48216ZM7.75194 5.43872L18.2596 11.5682C18.4981 11.7073 18.5787 12.0135 18.4396 12.252C18.3961 12.3265 18.3341 12.3885 18.2596 12.432L7.75194 18.5615C7.51341 18.7006 7.20725 18.62 7.06811 18.3815C7.0235 18.305 7 18.2181 7 18.1296V5.87061C7 5.59446 7.22386 5.37061 7.5 5.37061C7.58853 5.37061 7.67547 5.39411 7.75194 5.43872Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c02303c5f5032bb1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44495 21 3.9934V20.0066C21 20.5552 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5551 3 20.0066V3.9934ZM6 17V19H18V17H6ZM5 5V7H7V5H5ZM12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12ZM12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C8 12.2091 9.79086 14 12 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4d25a37417714b65(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15V5H5V15H19ZM3 3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44495 21 3.9934V20.0066C21 20.5552 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5551 3 20.0066V3.9934ZM12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12ZM12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14ZM6 6H8V8H6V6ZM6 17V19H18V17H6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$27b5512dd4a33ed9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.6586 10C19.8349 7.66962 17.6124 6 15 6C11.6863 6 9 8.68629 9 12C9 15.3137 11.6863 18 15 18C17.6124 18 19.8349 16.3304 20.6586 14H21V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V10H20.6586ZM5 6V9H7V6H5ZM15 16C12.7909 16 11 14.2091 11 12C11 9.79086 12.7909 8 15 8C17.2091 8 19 9.79086 19 12C19 14.2091 17.2091 16 15 16ZM15 14C16.1046 14 17 13.1046 17 12C17 10.8954 16.1046 10 15 10C13.8954 10 13 10.8954 13 12C13 13.1046 13.8954 14 15 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$acbffcbffed97cdd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H19V5H5V19H19V18H21V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V6ZM6 6H8V9H6V6ZM15 16C17.2091 16 19 14.2091 19 12C19 9.79086 17.2091 8 15 8C12.7909 8 11 9.79086 11 12C11 14.2091 12.7909 16 15 16ZM15 18C11.6863 18 9 15.3137 9 12C9 8.68629 11.6863 6 15 6C18.3137 6 21 8.68629 21 12C21 15.3137 18.3137 18 15 18ZM15 14C13.8954 14 13 13.1046 13 12C13 10.8954 13.8954 10 15 10C16.1046 10 17 10.8954 17 12C17 13.1046 16.1046 14 15 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$95308e245de82e9c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3V1H8V3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H6ZM9 15C10.6569 15 12 13.6569 12 12C12 10.3431 10.6569 9 9 9C7.34315 9 6 10.3431 6 12C6 13.6569 7.34315 15 9 15ZM14 9V11H18V9H14ZM14 13V15H18V13H14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e3a6b6b527190d4b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3V1H8V3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H6ZM4 5V19H20V5H4ZM9 15C7.34315 15 6 13.6569 6 12C6 10.3431 7.34315 9 9 9C10.6569 9 12 10.3431 12 12C12 13.6569 10.6569 15 9 15ZM14 9H18V11H14V9ZM14 13H18V15H14V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$798876b59e1edeea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10H20V6H4V10H15V8H17V10ZM6 3V1H8V3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H6ZM7 19C8.65685 19 10 17.6569 10 16C10 14.3431 8.65685 13 7 13C5.34315 13 4 14.3431 4 16C4 17.6569 5.34315 19 7 19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$842a1c9013c308c4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10V8H15V10H5V6H19V10H17ZM6 3V1H8V3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H6ZM4 5V19H20V5H4ZM8 18C6.34315 18 5 16.6569 5 15C5 13.3431 6.34315 12 8 12C9.65685 12 11 13.3431 11 15C11 16.6569 9.65685 18 8 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e147f30cc9299b81(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$607283c9008a0635(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c09211832cd7fbd8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19.9999V21.9323C8 22.2085 7.77614 22.4323 7.5 22.4323C7.38303 22.4323 7.26977 22.3913 7.17991 22.3165L3.06093 18.884C2.84879 18.7072 2.82013 18.3919 2.99691 18.1798C3.09191 18.0658 3.23264 17.9999 3.38103 17.9999L18 17.9999C19.1046 17.9999 20 17.1044 20 15.9999V7.99987H22V15.9999C22 18.209 20.2091 19.9999 18 19.9999H8ZM16 3.99987V2.06738C16 1.79124 16.2239 1.56738 16.5 1.56738C16.617 1.56738 16.7302 1.60839 16.8201 1.68327L20.9391 5.11575C21.1512 5.29253 21.1799 5.60782 21.0031 5.81995C20.9081 5.93395 20.7674 5.99986 20.619 5.99986L6 5.99987C4.89543 5.99987 4 6.89531 4 7.99987V15.9999H2V7.99987C2 5.79074 3.79086 3.99987 6 3.99987H16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fe2d296529bf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19.9998V21.9323C8 22.2085 7.77614 22.4323 7.5 22.4323C7.38303 22.4323 7.26977 22.3913 7.17991 22.3164L3.06093 18.8839C2.84879 18.7072 2.82013 18.3919 2.99691 18.1797C3.09191 18.0657 3.23264 17.9998 3.38103 17.9998L18 17.9998C19.1046 17.9998 20 17.1044 20 15.9998V7.99985H22V15.9998C22 18.209 20.2091 19.9998 18 19.9998H8ZM16 3.99985V2.06738C16 1.79124 16.2239 1.56738 16.5 1.56738C16.617 1.56738 16.7302 1.60839 16.8201 1.68327L20.9391 5.11575C21.1512 5.29253 21.1799 5.60782 21.0031 5.81995C20.9081 5.93395 20.7674 5.99986 20.619 5.99986L6 5.99985C4.89543 5.99985 4 6.89528 4 7.99985V15.9998H2V7.99985C2 5.79071 3.79086 3.99985 6 3.99985H16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$29bf5bad2c1cfd7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4H21C21.5523 4 22 4.44772 22 5V12H20V6H6V9L1 5L6 1V4ZM18 20H3C2.44772 20 2 19.5523 2 19V12H4V18H18V15L23 19L18 23V20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8f5b0b1bdaff9b92(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4H21C21.5523 4 22 4.44772 22 5V12H20V6H6V9L1 5L6 1V4ZM18 20H3C2.44772 20 2 19.5523 2 19V12H4V18H18V15L23 19L18 23V20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a0d356b4b6da4a89(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19.9999V21.9323C8 22.2085 7.77614 22.4323 7.5 22.4323C7.38303 22.4323 7.26977 22.3913 7.17991 22.3165L3.06093 18.884C2.84879 18.7072 2.82013 18.3919 2.99691 18.1798C3.09191 18.0658 3.23264 17.9999 3.38103 17.9999H8L18 17.9999C19.1046 17.9999 20 17.1044 20 15.9999V7.99987H22V15.9999C22 18.209 20.2091 19.9999 18 19.9999H8ZM16 3.99987V2.06738C16 1.79124 16.2239 1.56738 16.5 1.56738C16.617 1.56738 16.7302 1.60839 16.8201 1.68327L20.9391 5.11575C21.1512 5.29253 21.1799 5.60782 21.0031 5.81995C20.9081 5.93395 20.7674 5.99986 20.619 5.99986H16L6 5.99987C4.89543 5.99987 4 6.89531 4 7.99987V15.9999H2V7.99987C2 5.79074 3.79086 3.99987 6 3.99987H16ZM11 7.99987H13V15.9999H11V9.99987H9V8.99987L11 7.99987Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9fb8b4fbe7f384(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19.9999V21.9323C8 22.2085 7.77614 22.4323 7.5 22.4323C7.38303 22.4323 7.26977 22.3913 7.17991 22.3165L3.06093 18.884C2.84879 18.7072 2.82013 18.3919 2.99691 18.1798C3.09191 18.0658 3.23264 17.9999 3.38103 17.9999L18 17.9999C19.1046 17.9999 20 17.1044 20 15.9999V7.99987H22V15.9999C22 18.209 20.2091 19.9999 18 19.9999H8ZM16 2.06738C16 1.79124 16.2239 1.56738 16.5 1.56738C16.617 1.56738 16.7302 1.60839 16.8201 1.68327L20.9391 5.11575C21.1512 5.29253 21.1799 5.60782 21.0031 5.81995C20.9081 5.93395 20.7674 5.99986 20.619 5.99986L6 5.99987C4.89543 5.99987 4 6.89531 4 7.99987V15.9999H2V7.99987C2 5.79074 3.79086 3.99987 6 3.99987H16V2.06738ZM11 7.99987H13V15.9999H11V9.99987H9V8.99987L11 7.99987Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$51f5f532c7c50ead(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12 22 17.5228 17.5228 22 12 22 6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20 16.4183 20 20 16.4183 20 12 20 7.58172 16.4183 4 12 4 9.53614 4 7.33243 5.11383 5.86492 6.86543L8 9H2V3L4.44656 5.44648C6.28002 3.33509 8.9841 2 12 2ZM14.5 8.25C13.1193 8.25 12 9.36929 12 10.75V13.25C12 14.6307 13.1193 15.75 14.5 15.75 15.8807 15.75 17 14.6307 17 13.25V10.75C17 9.36929 15.8807 8.25 14.5 8.25ZM15.5 10.75V13.25C15.5 13.8023 15.0523 14.25 14.5 14.25 13.9477 14.25 13.5 13.8023 13.5 13.25V10.75C13.5 10.1977 13.9477 9.75 14.5 9.75 15.0523 9.75 15.5 10.1977 15.5 10.75ZM10 8.5H8.5V15.5H10V8.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ced27becddc5d451(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12 22 17.5228 17.5228 22 12 22 6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20 16.4183 20 20 16.4183 20 12 20 7.58172 16.4183 4 12 4 9.25022 4 6.82447 5.38734 5.38451 7.50024L8 7.5V9.5H2V3.5H4L3.99989 5.99918C5.82434 3.57075 8.72873 2 12 2ZM15.5 13.25C15.5 13.8023 15.0523 14.25 14.5 14.25 13.9477 14.25 13.5 13.8023 13.5 13.25V10.75C13.5 10.1977 13.9477 9.75 14.5 9.75 15.0523 9.75 15.5 10.1977 15.5 10.75V13.25ZM14.5 8.25C13.1193 8.25 12 9.36929 12 10.75V13.25C12 14.6307 13.1193 15.75 14.5 15.75 15.8807 15.75 17 14.6307 17 13.25V10.75C17 9.36929 15.8807 8.25 14.5 8.25ZM8.5 15.5V8.5H10V15.5H8.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bd589b5a3efa3d48(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12 22 17.5228 17.5228 22 12 22 6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20 16.4183 20 20 16.4183 20 12 20 7.58172 16.4183 4 12 4 9.53614 4 7.33243 5.11383 5.86492 6.86543L8 9H2V3L4.44656 5.44648C6.28002 3.33509 8.9841 2 12 2ZM8.5 8.5H10V15.5H8.5V8.5ZM16.75 8.5H12V12.75H14.875C15.2202 12.75 15.5 13.0298 15.5 13.375 15.5 13.7202 15.2202 14 14.875 14H12V15.5H14.875C16.0486 15.5 17 14.5486 17 13.375 17 12.2014 16.0486 11.25 14.875 11.25H13.5V10H16.75V8.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1f6eb317bfb65cf8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12 22 17.5228 17.5228 22 12 22 6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20 16.4183 20 20 16.4183 20 12 20 7.58172 16.4183 4 12 4 9.25022 4 6.82447 5.38734 5.38451 7.50024L8 7.5V9.5H2V3.5H4L3.99989 5.99918C5.82434 3.57075 8.72873 2 12 2ZM8.5 15.5V8.5H10V15.5H8.5ZM12 8.5H16.75V10H13.5V11.25H14.875C16.0486 11.25 17 12.2014 17 13.375 17 14.5486 16.0486 15.5 14.875 15.5H12V14H14.875C15.2202 14 15.5 13.7202 15.5 13.375 15.5 13.0298 15.2202 12.75 14.875 12.75H12V8.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2fd02632a13618e7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12C22 6.47715 17.5228 2 12 2 8.9841 2 6.28002 3.33509 4.44656 5.44648L2 3V9H6.75V10H9.37481C9.71999 10 9.99981 10.2798 9.99981 10.625 9.99981 10.9702 9.71999 11.25 9.37481 11.25H7.5V12.75H9.37481C9.71999 12.75 9.99981 13.0298 9.99981 13.375 9.99981 13.7202 9.71999 14 9.37481 14H6.75V15.5H9.37481C10.5484 15.5 11.4998 14.5486 11.4998 13.375 11.4998 12.8506 11.3099 12.3706 10.9951 12 11.3099 11.6294 11.4998 11.1494 11.4998 10.625 11.4998 9.4514 10.5484 8.5 9.37481 8.5H7.49988L5.86492 6.86543C7.33243 5.11383 9.53614 4 12 4 16.4183 4 20 7.58172 20 12 20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12ZM12.5 10.75C12.5 9.36929 13.6193 8.25 15 8.25 16.3807 8.25 17.5 9.36929 17.5 10.75V13.25C17.5 14.6307 16.3807 15.75 15 15.75 13.6193 15.75 12.5 14.6307 12.5 13.25V10.75ZM15 9.75C14.4477 9.75 14 10.1977 14 10.75V13.25C14 13.8023 14.4477 14.25 15 14.25 15.5523 14.25 16 13.8023 16 13.25V10.75C16 10.1977 15.5523 9.75 15 9.75Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4fab6c07800ebce8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12C22 6.47715 17.5228 2 12 2 8.72873 2 5.82434 3.57075 3.99989 5.99918L4 3.5H2V9.5H6.75V10H9.37481C9.71999 10 9.99981 10.2798 9.99981 10.625 9.99981 10.9702 9.71999 11.25 9.37481 11.25H7.5V12.75H9.37481C9.71999 12.75 9.99981 13.0298 9.99981 13.375 9.99981 13.7202 9.71999 14 9.37481 14H6.75V15.5H9.37481C10.5484 15.5 11.4998 14.5486 11.4998 13.375 11.4998 12.8506 11.3099 12.3706 10.9951 12 11.3099 11.6294 11.4998 11.1494 11.4998 10.625 11.4998 9.4514 10.5484 8.5 9.37481 8.5H8V7.5L5.38451 7.50024C6.82447 5.38734 9.25022 4 12 4 16.4183 4 20 7.58172 20 12 20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12ZM12.5 10.75C12.5 9.36929 13.6193 8.25 15 8.25 16.3807 8.25 17.5 9.36929 17.5 10.75V13.25C17.5 14.6307 16.3807 15.75 15 15.75 13.6193 15.75 12.5 14.6307 12.5 13.25V10.75ZM15 9.75C14.4477 9.75 14 10.1977 14 10.75V13.25C14 13.8023 14.4477 14.25 15 14.25 15.5523 14.25 16 13.8023 16 13.25V10.75C16 10.1977 15.5523 9.75 15 9.75Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$df2aba8ba16a6a6f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12C22 6.47715 17.5228 2 12 2 8.9841 2 6.28002 3.33509 4.44656 5.44648L2 3V9H8L5.86492 6.86543C7.33243 5.11383 9.53614 4 12 4 16.4183 4 20 7.58172 20 12 20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12ZM14.5 10V8.5H9.5V12.75H12.625C12.9702 12.75 13.25 13.0298 13.25 13.375 13.25 13.7202 12.9702 14 12.625 14H9.5V15.5H12.625C13.7986 15.5 14.75 14.5486 14.75 13.375 14.75 12.2014 13.7986 11.25 12.625 11.25H11V10H14.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5f228fc417671c47(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12 22 17.5228 17.5228 22 12 22 6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20 16.4183 20 20 16.4183 20 12 20 7.58172 16.4183 4 12 4 9.25022 4 6.82447 5.38734 5.38451 7.50024L8 7.5V9.5H2V3.5H4L3.99989 5.99918C5.82434 3.57075 8.72873 2 12 2ZM9.5 8.5H14.5V10H11V11.25H12.625C13.7986 11.25 14.75 12.2014 14.75 13.375 14.75 14.5486 13.7986 15.5 12.625 15.5H9.5V14H12.625C12.9702 14 13.25 13.7202 13.25 13.375 13.25 13.0298 12.9702 12.75 12.625 12.75H9.5V8.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$81ba60a7307e48c9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 10.6665L21.2237 4.51811C21.4534 4.36493 21.7639 4.42702 21.917 4.65679C21.9718 4.73892 22.001 4.83542 22.001 4.93414V19.0656C22.001 19.3418 21.7772 19.5656 21.501 19.5656C21.4023 19.5656 21.3058 19.5364 21.2237 19.4816L12.001 13.3332V19.0656C12.001 19.3418 11.7772 19.5656 11.501 19.5656C11.4023 19.5656 11.3058 19.5364 11.2237 19.4816L0.625047 12.4159C0.395282 12.2627 0.333196 11.9523 0.486372 11.7225C0.522989 11.6676 0.570121 11.6205 0.625047 11.5839L11.2237 4.51811C11.4534 4.36493 11.7639 4.42702 11.917 4.65679C11.9718 4.73892 12.001 4.83542 12.001 4.93414V10.6665Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f740f91b11909f1b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 10.6665L21.2237 4.51811C21.4534 4.36493 21.7639 4.42702 21.917 4.65679C21.9718 4.73892 22.001 4.83542 22.001 4.93414V19.0656C22.001 19.3418 21.7772 19.5656 21.501 19.5656C21.4023 19.5656 21.3058 19.5364 21.2237 19.4816L12.001 13.3332V19.0656C12.001 19.3418 11.7772 19.5656 11.501 19.5656C11.4023 19.5656 11.3058 19.5364 11.2237 19.4816L0.625047 12.4159C0.395282 12.2627 0.333196 11.9523 0.486372 11.7225C0.522989 11.6676 0.570121 11.6205 0.625047 11.5839L11.2237 4.51811C11.4534 4.36493 11.7639 4.42702 11.917 4.65679C11.9718 4.73892 12.001 4.83542 12.001 4.93414V10.6665ZM10.001 16.2628V7.73691L3.60656 11.9999L10.001 16.2628ZM20.001 16.2628V7.73691L13.6066 11.9999L20.001 16.2628Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9e8e51b00b0c31df(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.0002 17.0349C11.0002 17.1382 10.9682 17.2389 10.9087 17.3233C10.7494 17.5489 10.4375 17.6027 10.2119 17.4434L3.07889 12.4084C3.03228 12.3755 2.99164 12.3348 2.95874 12.2882C2.7995 12.0626 2.85329 11.7506 3.07889 11.5914L10.2119 6.55636C10.2962 6.49681 10.3969 6.46484 10.5002 6.46484C10.7763 6.46484 11.0002 6.6887 11.0002 6.96484V17.0349ZM12.0789 12.4084C12.0323 12.3755 11.9916 12.3348 11.9587 12.2882C11.7995 12.0626 11.8533 11.7506 12.0789 11.5914L19.2119 6.55636C19.2962 6.49681 19.3969 6.46484 19.5002 6.46484C19.7763 6.46484 20.0002 6.6887 20.0002 6.96484V17.0349C20.0002 17.1382 19.9682 17.2389 19.9087 17.3233C19.7494 17.5489 19.4375 17.6027 19.2119 17.4434L12.0789 12.4084Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3b3878e699b03dac(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.0002 9.85972L5.96831 11.9999L9.0002 14.14V9.85972ZM10.9087 17.3233C10.7494 17.5489 10.4375 17.6027 10.2119 17.4434L3.07889 12.4084C3.03228 12.3755 2.99164 12.3348 2.95874 12.2882C2.7995 12.0626 2.85329 11.7506 3.07889 11.5914L10.2119 6.55636C10.2962 6.49681 10.3969 6.46484 10.5002 6.46484C10.7763 6.46484 11.0002 6.6887 11.0002 6.96484V17.0349C11.0002 17.1382 10.9682 17.2389 10.9087 17.3233ZM18.0002 14.14V9.85972L14.9683 11.9999L18.0002 14.14ZM12.0789 12.4084C12.0323 12.3755 11.9916 12.3348 11.9587 12.2882C11.7995 12.0626 11.8533 11.7506 12.0789 11.5914L19.2119 6.55636C19.2962 6.49681 19.3969 6.46484 19.5002 6.46484C19.7763 6.46484 20.0002 6.6887 20.0002 6.96484V17.0349C20.0002 17.1382 19.9682 17.2389 19.9087 17.3233C19.7494 17.5489 19.4375 17.6027 19.2119 17.4434L12.0789 12.4084Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5191c75489e7914f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9H4V21H2V9ZM8 3H10V21H8V3ZM14 12H16V21H14V12ZM20 6H22V21H20V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7663c3d672575772(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9H4V21H2V9ZM8 3H10V21H8V3ZM14 12H16V21H14V12ZM20 6H22V21H20V6Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3f48d7b91682f4d5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17.8832V16L23 19L18 22V19.9095C14.9224 19.4698 12.2513 17.4584 11.0029 14.5453L11 14.5386L10.9971 14.5453C9.57893 17.8544 6.32508 20 2.72483 20H2V18H2.72483C5.52503 18 8.05579 16.3312 9.15885 13.7574L9.91203 12L9.15885 10.2426C8.05579 7.66878 5.52503 6 2.72483 6H2V4H2.72483C6.32508 4 9.57893 6.14557 10.9971 9.45473L11 9.46141L11.0029 9.45473C12.2513 6.5416 14.9224 4.53022 18 4.09051V2L23 5L18 8V6.11684C15.7266 6.53763 13.7737 8.0667 12.8412 10.2426L12.088 12L12.8412 13.7574C13.7737 15.9333 15.7266 17.4624 18 17.8832Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$214a5e5c1c9a34c3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17.8832V16L23 19L18 22V19.9095C14.9224 19.4698 12.2513 17.4584 11.0029 14.5453L11 14.5386L10.9971 14.5453C9.57893 17.8544 6.32508 20 2.72483 20H2V18H2.72483C5.52503 18 8.05579 16.3312 9.15885 13.7574L9.91203 12L9.15885 10.2426C8.05579 7.66878 5.52503 6 2.72483 6H2V4H2.72483C6.32508 4 9.57893 6.14557 10.9971 9.45473L11 9.46141L11.0029 9.45473C12.2513 6.5416 14.9224 4.53022 18 4.09051V2L23 5L18 8V6.11684C15.7266 6.53763 13.7737 8.0667 12.8412 10.2426L12.088 12L12.8412 13.7574C13.7737 15.9333 15.7266 17.4624 18 17.8832Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c916af0717f3b450(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11.3333L18.2227 4.51823C18.4524 4.36506 18.7628 4.42714 18.916 4.65691C18.9708 4.73904 19 4.83555 19 4.93426V19.0657C19 19.3419 18.7761 19.5657 18.5 19.5657C18.4013 19.5657 18.3048 19.5365 18.2227 19.4818L8 12.6667V19C8 19.5523 7.55228 20 7 20C6.44772 20 6 19.5523 6 19V5C6 4.44772 6.44772 4 7 4C7.55228 4 8 4.44772 8 5V11.3333Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$265a7cd46647d5f9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4C7.55228 4 8 4.44772 8 5V11.3333L18.2227 4.51823C18.4524 4.36506 18.7628 4.42714 18.916 4.65691C18.9708 4.73904 19 4.83555 19 4.93426V19.0657C19 19.3419 18.7761 19.5657 18.5 19.5657C18.4013 19.5657 18.3048 19.5365 18.2227 19.4818L8 12.6667V19C8 19.5523 7.55228 20 7 20C6.44772 20 6 19.5523 6 19V5C6 4.44772 6.44772 4 7 4ZM17 7.73703L10.6056 12L17 16.263V7.73703Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5a5ad58fb9dd38db(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6C7.55228 6 8 6.44772 8 7V17C8 17.5523 7.55228 18 7 18C6.44772 18 6 17.5523 6 17V7C6 6.44772 6.44772 6 7 6ZM9.07869 12.4085C9.03208 12.3756 8.99144 12.3349 8.95854 12.2883C8.7993 12.0627 8.85309 11.7508 9.07869 11.5915L16.2117 6.55648C16.296 6.49693 16.3967 6.46496 16.5 6.46496C16.7761 6.46496 17 6.68882 17 6.96496V17.035C17 17.1383 16.968 17.239 16.9085 17.3234C16.7492 17.549 16.4373 17.6028 16.2117 17.4435L9.07869 12.4085Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f4b138b8e26c2383(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6C7.55228 6 8 6.44772 8 7V17C8 17.5523 7.55228 18 7 18C6.44772 18 6 17.5523 6 17V7C6 6.44772 6.44772 6 7 6ZM15 14.1402V9.85984L11.9681 12L15 14.1402ZM9.07869 12.4085C9.03208 12.3756 8.99144 12.3349 8.95854 12.2883C8.7993 12.0627 8.85309 11.7508 9.07869 11.5915L16.2117 6.55648C16.296 6.49693 16.3967 6.46496 16.5 6.46496C16.7761 6.46496 17 6.68882 17 6.96496V17.035C17 17.1383 16.968 17.239 16.9085 17.3234C16.7492 17.549 16.4373 17.6028 16.2117 17.4435L9.07869 12.4085Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c4368ef6c279a3aa(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.6667L5.77735 19.4818C5.54759 19.6349 5.23715 19.5729 5.08397 19.3431C5.02922 19.261 5 19.1645 5 19.0657V4.93426C5 4.65812 5.22386 4.43426 5.5 4.43426C5.59871 4.43426 5.69522 4.46348 5.77735 4.51823L16 11.3333V5C16 4.44772 16.4477 4 17 4C17.5523 4 18 4.44772 18 5V19C18 19.5523 17.5523 20 17 20C16.4477 20 16 19.5523 16 19V12.6667Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$80714d1d4e33392a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.6667L5.77735 19.4818C5.54759 19.6349 5.23715 19.5729 5.08397 19.3431C5.02922 19.261 5 19.1645 5 19.0657V4.93426C5 4.65812 5.22386 4.43426 5.5 4.43426C5.59871 4.43426 5.69522 4.46348 5.77735 4.51823L16 11.3333V5C16 4.44772 16.4477 4 17 4C17.5523 4 18 4.44772 18 5V19C18 19.5523 17.5523 20 17 20C16.4477 20 16 19.5523 16 19V12.6667ZM7 7.73703V16.263L13.3944 12L7 7.73703Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$23ad87c1f62b1d99(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.78834 17.4435C7.70398 17.5031 7.60326 17.535 7.5 17.535C7.22386 17.535 7 17.3112 7 17.035V6.96496C7 6.8617 7.03197 6.76098 7.09152 6.67662C7.25076 6.45102 7.56274 6.39723 7.78834 6.55648L14.9213 11.5915C14.9679 11.6244 15.0086 11.665 15.0415 11.7117C15.2007 11.9373 15.1469 12.2492 14.9213 12.4085L7.78834 17.4435ZM16 7C16 6.44772 16.4477 6 17 6C17.5523 6 18 6.44772 18 7V17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5111f86ee55e53eb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0319 12L9 9.85984V14.1402L12.0319 12ZM7.5 17.535C7.22386 17.535 7 17.3112 7 17.035V6.96496C7 6.8617 7.03197 6.76098 7.09152 6.67662C7.25076 6.45102 7.56274 6.39723 7.78834 6.55648L14.9213 11.5915C14.9679 11.6244 15.0086 11.665 15.0415 11.7117C15.2007 11.9373 15.1469 12.2492 14.9213 12.4085L7.78834 17.4435C7.70398 17.5031 7.60326 17.535 7.5 17.535ZM16 7C16 6.44772 16.4477 6 17 6C17.5523 6 18 6.44772 18 7V17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ef800b89295a502b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13C4 15.2091 4.89543 17.2091 6.34315 18.6569L4.92893 20.0711C3.11929 18.2614 2 15.7614 2 13 2 7.47715 6.47715 3 12 3 17.5228 3 22 7.47715 22 13 22 15.7614 20.8807 18.2614 19.0711 20.0711L17.6569 18.6569C19.1046 17.2091 20 15.2091 20 13 20 8.58172 16.4183 5 12 5 7.58172 5 4 8.58172 4 13ZM8.70703 8.29297 13.5 12.5 11.5 14.5 7.29282 9.70718 8.70703 8.29297Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$98c2d70cd87ff2a9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13C4 15.2091 4.89543 17.2091 6.34315 18.6569L4.92893 20.0711C3.11929 18.2614 2 15.7614 2 13 2 7.47715 6.47715 3 12 3 17.5228 3 22 7.47715 22 13 22 15.7614 20.8807 18.2614 19.0711 20.0711L17.6569 18.6569C19.1046 17.2091 20 15.2091 20 13 20 8.58172 16.4183 5 12 5 7.58172 5 4 8.58172 4 13ZM8.70703 8.29297 13.207 12.793 11.7928 14.2072 7.29282 9.70718 8.70703 8.29297Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8a1c7f7039484a13(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18V21H19V18H17V15H23V18H21ZM5 18V21H3V18H1V15H7V18H5ZM11 6V3H13V6H15V9H9V6H11ZM11 11H13V21H11V11ZM3 13V3H5V13H3ZM19 13V3H21V13H19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8cf9ac6a2f701df9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18V21H19V18H17V16H23V18H21ZM5 18V21H3V18H1V16H7V18H5ZM11 6V3H13V6H15V8H9V6H11ZM11 10H13V21H11V10ZM3 14V3H5V14H3ZM19 14V3H21V14H19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$372c19e2eb538b20(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17ZM12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cf7944a717e4638d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5V19H19V5H5ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16ZM12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18ZM12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12C13.5 12.8284 12.8284 13.5 12 13.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c9e2f272930031e3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16ZM12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7ZM18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7ZM18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19ZM6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19ZM12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ae850da1ef7f56ea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5V19H19V5H5ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM7 8C6.44772 8 6 7.55228 6 7C6 6.44772 6.44772 6 7 6C7.55228 6 8 6.44772 8 7C8 7.55228 7.55228 8 7 8ZM17 8C16.4477 8 16 7.55228 16 7C16 6.44772 16.4477 6 17 6C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8ZM17 18C16.4477 18 16 17.5523 16 17C16 16.4477 16.4477 16 17 16C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18ZM7 18C6.44772 18 6 17.5523 6 17C6 16.4477 6.44772 16 7 16C7.55228 16 8 16.4477 8 17C8 17.5523 7.55228 18 7 18ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15ZM12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17ZM12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$19ccc209b2c78212(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2ZM12 20C14.7614 20 17 17.7614 17 15C17 12.2386 14.7614 10 12 10C9.23858 10 7 12.2386 7 15C7 17.7614 9.23858 20 12 20ZM12 8C12.8284 8 13.5 7.32843 13.5 6.5C13.5 5.67157 12.8284 5 12 5C11.1716 5 10.5 5.67157 10.5 6.5C10.5 7.32843 11.1716 8 12 8ZM12 18C10.3431 18 9 16.6569 9 15C9 13.3431 10.3431 12 12 12C13.6569 12 15 13.3431 15 15C15 16.6569 13.6569 18 12 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$22f2025f2ceed87(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4V20H19V4H5ZM4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2ZM12 17C13.3807 17 14.5 15.8807 14.5 14.5C14.5 13.1193 13.3807 12 12 12C10.6193 12 9.5 13.1193 9.5 14.5C9.5 15.8807 10.6193 17 12 17ZM12 19C9.51472 19 7.5 16.9853 7.5 14.5C7.5 12.0147 9.51472 10 12 10C14.4853 10 16.5 12.0147 16.5 14.5C16.5 16.9853 14.4853 19 12 19ZM12 8.5C11.1716 8.5 10.5 7.82843 10.5 7C10.5 6.17157 11.1716 5.5 12 5.5C12.8284 5.5 13.5 6.17157 13.5 7C13.5 7.82843 12.8284 8.5 12 8.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1fd4a9ed65052eda(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.3332L2.77735 19.4816C2.54759 19.6348 2.23715 19.5727 2.08397 19.3429C2.02922 19.2608 2 19.1643 2 19.0656V4.93408C2 4.65794 2.22386 4.43408 2.5 4.43408C2.59871 4.43408 2.69522 4.4633 2.77735 4.51806L12 10.6665V4.93408C12 4.65794 12.2239 4.43408 12.5 4.43408C12.5987 4.43408 12.6952 4.4633 12.7774 4.51806L23.376 11.5838C23.6057 11.737 23.6678 12.0474 23.5146 12.2772C23.478 12.3321 23.4309 12.3792 23.376 12.4158L12.7774 19.4816C12.5476 19.6348 12.2372 19.5727 12.084 19.3429C12.0292 19.2608 12 19.1643 12 19.0656V13.3332Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3b1eb9d528438b1d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.3332L2.77735 19.4816C2.54759 19.6348 2.23715 19.5727 2.08397 19.3429C2.02922 19.2608 2 19.1643 2 19.0656V4.93408C2 4.65794 2.22386 4.43408 2.5 4.43408C2.59871 4.43408 2.69522 4.4633 2.77735 4.51806L12 10.6665V4.93408C12 4.65794 12.2239 4.43408 12.5 4.43408C12.5987 4.43408 12.6952 4.4633 12.7774 4.51806L23.376 11.5838C23.6057 11.737 23.6678 12.0474 23.5146 12.2772C23.478 12.3321 23.4309 12.3792 23.376 12.4158L12.7774 19.4816C12.5476 19.6348 12.2372 19.5727 12.084 19.3429C12.0292 19.2608 12 19.1643 12 19.0656V13.3332ZM10.3944 11.9998L4 7.73686V16.2628L10.3944 11.9998ZM14 7.73686V16.2628L20.3944 11.9998L14 7.73686Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$16b881078bc9e58a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.78834 17.4434C4.70398 17.503 4.60326 17.535 4.5 17.535C4.22386 17.535 4 17.3111 4 17.035V6.96488C4 6.86163 4.03197 6.7609 4.09152 6.67654C4.25076 6.45094 4.56274 6.39715 4.78834 6.5564L11.9213 11.5914C11.9679 11.6243 12.0086 11.665 12.0415 11.7116C12.2007 11.9372 12.1469 12.2492 11.9213 12.4084L4.78834 17.4434ZM13 6.96488C13 6.86163 13.032 6.7609 13.0915 6.67654C13.2508 6.45094 13.5627 6.39715 13.7883 6.5564L20.9213 11.5914C20.9679 11.6243 21.0086 11.665 21.0415 11.7116C21.2007 11.9372 21.1469 12.2492 20.9213 12.4084L13.7883 17.4434C13.704 17.503 13.6033 17.535 13.5 17.535C13.2239 17.535 13 17.3111 13 17.035V6.96488Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$589ba9eb35bd50e4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.03189 11.9999L6 9.85977V14.1401L9.03189 11.9999ZM4.78834 17.4434C4.70398 17.503 4.60326 17.535 4.5 17.535C4.22386 17.535 4 17.3111 4 17.035V6.96488C4 6.86163 4.03197 6.7609 4.09152 6.67654C4.25076 6.45094 4.56274 6.39715 4.78834 6.5564L11.9213 11.5914C11.9679 11.6243 12.0086 11.665 12.0415 11.7116C12.2007 11.9372 12.1469 12.2492 11.9213 12.4084L4.78834 17.4434ZM15 14.1401L18.0319 11.9999L15 9.85977V14.1401ZM13 6.96488C13 6.86163 13.032 6.7609 13.0915 6.67654C13.2508 6.45094 13.5627 6.39715 13.7883 6.5564L20.9213 11.5914C20.9679 11.6243 21.0086 11.665 21.0415 11.7116C21.2007 11.9372 21.1469 12.2492 20.9213 12.4084L13.7883 17.4434C13.704 17.503 13.6033 17.535 13.5 17.535C13.2239 17.535 13 17.3111 13 17.035V6.96488Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b6f71ed22b8a3241(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13C20 15.2091 19.1046 17.2091 17.6569 18.6569L19.0711 20.0711C20.8807 18.2614 22 15.7614 22 13 22 7.47715 17.5228 3 12 3 6.47715 3 2 7.47715 2 13 2 15.7614 3.11929 18.2614 4.92893 20.0711L6.34315 18.6569C4.89543 17.2091 4 15.2091 4 13 4 8.58172 7.58172 5 12 5 16.4183 5 20 8.58172 20 13ZM15.293 8.29297 10.5 12.5 12.5 14.5 16.7072 9.70718 15.293 8.29297Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1805bc372817749f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13C20 15.2091 19.1046 17.2091 17.6569 18.6569L19.0711 20.0711C20.8807 18.2614 22 15.7614 22 13 22 7.47715 17.5228 3 12 3 6.47715 3 2 7.47715 2 13 2 15.7614 3.11929 18.2614 4.92893 20.0711L6.34315 18.6569C4.89543 17.2091 4 15.2091 4 13 4 8.58172 7.58172 5 12 5 16.4183 5 20 8.58172 20 13ZM15.293 8.29297 10.793 12.793 12.2072 14.2072 16.7072 9.70718 15.293 8.29297Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$85576ab71d40e96c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9 9V15H15V9H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d24e0a843c15bbf1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM9 9H15V15H9V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$904b04f47adca19a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$94bc0f6b6e977e29(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7V17H17V7H7ZM6 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$978d32edc4b37e6c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7V17C6 17.5523 6.44772 18 7 18H17C17.5523 18 18 17.5523 18 17V7C18 6.44772 17.5523 6 17 6H7C6.44772 6 6 6.44772 6 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a1a4b4b99c9eaf45(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7C6 6.44772 6.44772 6 7 6H17C17.5523 6 18 6.44772 18 7V17C18 17.5523 17.5523 18 17 18H7C6.44772 18 6 17.5523 6 17V7ZM8 8V16H16V8H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$827a0d5990672258(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM7.05025 7.12132C5.7835 8.38807 5 10.1381 5 12.0711C5 14.0041 5.7835 15.7541 7.05025 17.0208L8.46447 15.6066C7.55964 14.7018 7 13.4518 7 12.0711C7 10.6904 7.55964 9.44036 8.46447 8.53553L7.05025 7.12132ZM16.9497 7.12132L15.5355 8.53553C16.4404 9.44036 17 10.6904 17 12.0711C17 13.4518 16.4404 14.7018 15.5355 15.6066L16.9497 17.0208C18.2165 15.7541 19 14.0041 19 12.0711C19 10.1381 18.2165 8.38807 16.9497 7.12132ZM12 15.0711C13.6569 15.0711 15 13.7279 15 12.0711C15 10.4142 13.6569 9.07107 12 9.07107C10.3431 9.07107 9 10.4142 9 12.0711C9 13.7279 10.3431 15.0711 12 15.0711ZM12 13.0711C11.4477 13.0711 11 12.6234 11 12.0711C11 11.5188 11.4477 11.0711 12 11.0711C12.5523 11.0711 13 11.5188 13 12.0711C13 12.6234 12.5523 13.0711 12 13.0711Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3fcaa2c40c2a88da(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5V19H20V5H4ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM7.05025 7.12132L8.46447 8.53553C7.55964 9.44036 7 10.6904 7 12.0711C7 13.4518 7.55964 14.7018 8.46447 15.6066L7.05025 17.0208C5.7835 15.7541 5 14.0041 5 12.0711C5 10.1381 5.7835 8.38807 7.05025 7.12132ZM16.9497 7.12132C18.2165 8.38807 19 10.1381 19 12.0711C19 14.0041 18.2165 15.7541 16.9497 17.0208L15.5355 15.6066C16.4404 14.7018 17 13.4518 17 12.0711C17 10.6904 16.4404 9.44036 15.5355 8.53553L16.9497 7.12132ZM12 13.0711C12.5523 13.0711 13 12.6234 13 12.0711C13 11.5188 12.5523 11.0711 12 11.0711C11.4477 11.0711 11 11.5188 11 12.0711C11 12.6234 11.4477 13.0711 12 13.0711ZM12 15.0711C10.3431 15.0711 9 13.7279 9 12.0711C9 10.4142 10.3431 9.07107 12 9.07107C13.6569 9.07107 15 10.4142 15 12.0711C15 13.7279 13.6569 15.0711 12 15.0711Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$69d32abff0bfd702(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.8293 13C10.9398 12.6872 11 12.3506 11 12C11 10.3431 9.65685 9 8 9C6.34315 9 5 10.3431 5 12C5 13.6569 6.34315 15 8 15H16C17.6569 15 19 13.6569 19 12C19 10.3431 17.6569 9 16 9C14.3431 9 13 10.3431 13 12C13 12.3506 13.0602 12.6872 13.1707 13H10.8293ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13ZM8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12C9 12.5523 8.55228 13 8 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cafd77cdf7ae21ff(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.8293 13H13.1707C13.0602 12.6872 13 12.3506 13 12C13 10.3431 14.3431 9 16 9C17.6569 9 19 10.3431 19 12C19 13.6569 17.6569 15 16 15H8C6.34315 15 5 13.6569 5 12C5 10.3431 6.34315 9 8 9C9.65685 9 11 10.3431 11 12C11 12.3506 10.9398 12.6872 10.8293 13ZM4 5V19H20V5H4ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13ZM16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c4cc8e04e635e744(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM8 8V11H5V13H7.999L8 16H10L9.999 13H13V11H10V8H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$76923e34b31544a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM15 6H3V18H15V6ZM8 8H10V11H13V13H9.999L10 16H8L7.999 13H5V11H8V8ZM21 8.84131L17 11.641V12.359L21 15.1587V8.84131Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$693636db207c0e10(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM10 8H8V12H5L9 16L13 12H10V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$79c50fae0d8cd5d3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM15 6H3V18H15V6ZM10 8V12H13L9 16L5 12H8V8H10ZM21 8.84131L17 11.641V12.359L21 15.1587V8.84131Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4b6d2223fe0f61e4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44495 21 3.9934V20.0066C21 20.5552 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5551 3 20.0066V3.9934ZM10.6219 8.41459C10.5562 8.37078 10.479 8.34741 10.4 8.34741C10.1791 8.34741 10 8.52649 10 8.74741V15.2526C10 15.3316 10.0234 15.4088 10.0672 15.4745C10.1897 15.6583 10.4381 15.708 10.6219 15.5854L15.5008 12.3328C15.5447 12.3035 15.5824 12.2658 15.6117 12.2219C15.7343 12.0381 15.6846 11.7897 15.5008 11.6672L10.6219 8.41459Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$efcb7fdd1781266d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44495 21 3.9934V20.0066C21 20.5552 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5551 3 20.0066V3.9934ZM5 5V19H19V5H5ZM10.6219 8.41459L15.5008 11.6672C15.6846 11.7897 15.7343 12.0381 15.6117 12.2219C15.5824 12.2658 15.5447 12.3035 15.5008 12.3328L10.6219 15.5854C10.4381 15.708 10.1897 15.6583 10.0672 15.4745C10.0234 15.4088 10 15.3316 10 15.2526V8.74741C10 8.52649 10.1791 8.34741 10.4 8.34741C10.479 8.34741 10.5562 8.37078 10.6219 8.41459Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$99a468b56b02aed8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM9 8L5 12H8V16H10V12H13L9 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$63f180e2a67dc5cf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM15 6H3V18H15V6ZM9 8L13 12H10V16H8V12H5L9 8ZM21 8.84131L17 11.641V12.359L21 15.1587V8.84131Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7f69ef92ed03e6b7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6V4H5V2H15V6H16C16.5523 6 17 6.44772 17 7V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V7C1 6.44772 1.44772 6 2 6H13ZM5 10V12H7V10H5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$89ceb3262f5e215(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6V4H5V2H15V6H16C16.5523 6 17 6.44772 17 7V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V7C1 6.44772 1.44772 6 2 6H13ZM15 8H3V18H15V8ZM17 12.3587L21 15.1587V8.84131L17 11.6413V12.3587ZM5 10H7V12H5V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4cb2a3badeb8631(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16C16.5523 4 17 4.44772 17 5V9.2ZM5 8V10H7V8H5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d659745c4a3b9cc1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16C16.5523 4 17 4.44772 17 5V9.2ZM17 12.3587L21 15.1587V8.84131L17 11.6413V12.3587ZM3 6V18H15V6H3ZM5 8H7V10H5V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c7a2b79b9cf2e763(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 7H7V17H5V7ZM1 10H3V14H1V10ZM9 2H11V20H9V2ZM13 4H15V22H13V4ZM17 7H19V17H17V7ZM21 10H23V14H21V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4544dbb87e259021(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 7H7V17H5V7ZM1 10H3V14H1V10ZM9 2H11V20H9V2ZM13 4H15V22H13V4ZM17 7H19V17H17V7ZM21 10H23V14H21V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7c0841bf529a6702(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.88889 16.0001H5C4.44772 16.0001 4 15.5524 4 15.0001V9.00007C4 8.44778 4.44772 8.00007 5 8.00007H8.88889L14.1834 3.66821C14.3971 3.49335 14.7121 3.52485 14.887 3.73857C14.9601 3.8279 15 3.93977 15 4.05519V19.9449C15 20.2211 14.7761 20.4449 14.5 20.4449C14.3846 20.4449 14.2727 20.405 14.1834 20.3319L8.88889 16.0001ZM18.8631 16.5911L17.4411 15.1691C18.3892 14.4376 19 13.2902 19 12.0001C19 10.5697 18.2493 9.31476 17.1203 8.60766L18.5589 7.16906C20.0396 8.26166 21 10.0187 21 12.0001C21 13.8422 20.1698 15.4905 18.8631 16.5911Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1abd162cb7cb0cec(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.22056L9.60282 10.0001H6V14.0001H9.60282L13 16.7796V7.22056ZM8.88889 16.0001H5C4.44772 16.0001 4 15.5524 4 15.0001V9.00007C4 8.44778 4.44772 8.00007 5 8.00007H8.88889L14.1834 3.66821C14.3971 3.49335 14.7121 3.52485 14.887 3.73857C14.9601 3.8279 15 3.93977 15 4.05519V19.9449C15 20.2211 14.7761 20.4449 14.5 20.4449C14.3846 20.4449 14.2727 20.405 14.1834 20.3319L8.88889 16.0001ZM18.8631 16.5911L17.4411 15.1691C18.3892 14.4376 19 13.2902 19 12.0001C19 10.5697 18.2493 9.31476 17.1203 8.60766L18.5589 7.16906C20.0396 8.26166 21 10.0187 21 12.0001C21 13.8422 20.1698 15.4905 18.8631 16.5911Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$21c2b29a7e9705a4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.88889 16.0001H2C1.44772 16.0001 1 15.5524 1 15.0001V9.00007C1 8.44778 1.44772 8.00007 2 8.00007H5.88889L11.1834 3.66821C11.3971 3.49335 11.7121 3.52485 11.887 3.73857C11.9601 3.8279 12 3.93977 12 4.05519V19.9449C12 20.2211 11.7761 20.4449 11.5 20.4449C11.3846 20.4449 11.2727 20.405 11.1834 20.3319L5.88889 16.0001ZM20.4142 12.0001L23.9497 15.5356L22.5355 16.9498L19 13.4143L15.4645 16.9498L14.0503 15.5356L17.5858 12.0001L14.0503 8.46454L15.4645 7.05032L19 10.5859L22.5355 7.05032L23.9497 8.46454L20.4142 12.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1ea0273d3793d9c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7.22056L6.60282 10.0001H3V14.0001H6.60282L10 16.7796V7.22056ZM5.88889 16.0001H2C1.44772 16.0001 1 15.5524 1 15.0001V9.00007C1 8.44778 1.44772 8.00007 2 8.00007H5.88889L11.1834 3.66821C11.3971 3.49335 11.7121 3.52485 11.887 3.73857C11.9601 3.8279 12 3.93977 12 4.05519V19.9449C12 20.2211 11.7761 20.4449 11.5 20.4449C11.3846 20.4449 11.2727 20.405 11.1834 20.3319L5.88889 16.0001ZM20.4142 12.0001L23.9497 15.5356L22.5355 16.9498L19 13.4143L15.4645 16.9498L14.0503 15.5356L17.5858 12.0001L14.0503 8.46454L15.4645 7.05032L19 10.5859L22.5355 7.05032L23.9497 8.46454L20.4142 12.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$77b612bda8bdf38(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.3901 3.16117L20.8043 4.57538L18.3287 7.04955L20.8043 9.52513L18.3287 11.9993L20.8043 14.4749L18.3294 16.9498L20.8043 19.4246L19.3901 20.8388L15.501 16.9498L17.9759 14.4749L15.501 12L17.9759 9.52513L15.501 7.05026L19.3901 3.16117ZM13.001 19.9449C13.001 20.221 12.7771 20.4449 12.501 20.4449C12.3856 20.4449 12.2737 20.405 12.1844 20.3319L6.88998 15.9991L3.00098 16C2.4487 16 2.00098 15.5523 2.00098 15V9.00001C2.00098 8.44772 2.4487 8.00001 3.00098 8.00001L5.58459 7.99762L1.80859 4.22183L3.22281 2.80762L13.0006 12.5856L13.001 19.9449ZM12.888 3.73851C12.961 3.82784 13.001 3.93971 13.001 4.05513V9.75717L9.28298 6.04017L12.1844 3.66815C12.3981 3.49328 12.7131 3.52479 12.888 3.73851Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f48430d1aab63a7d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.3901 3.16117L20.8043 4.57538L18.3287 7.04955L20.8043 9.52513L18.3287 11.9993L20.8043 14.4749L18.3294 16.9498L20.8043 19.4246L19.3901 20.8388L15.501 16.9498L17.9759 14.4749L15.501 12L17.9759 9.52513L15.501 7.05026L19.3901 3.16117ZM13.001 19.9449C13.001 20.221 12.7771 20.4449 12.501 20.4449C12.3856 20.4449 12.2737 20.405 12.1844 20.3319L6.88998 15.9991L3.00098 16C2.4487 16 2.00098 15.5523 2.00098 15V9.00001C2.00098 8.44772 2.4487 8.00001 3.00098 8.00001L5.58459 7.99762L1.80859 4.22183L3.22281 2.80762L13.0006 12.5856L13.001 19.9449ZM7.58498 9.99811L4.00098 9.999V14L7.60383 13.9989L11.001 16.779V13.4141L7.58498 9.99811ZM12.888 3.73851C12.961 3.82784 13.001 3.93971 13.001 4.05513V9.75711L11.001 7.75711V7.22001L10.705 7.46111L9.28398 6.04011L12.1844 3.66815C12.3981 3.49328 12.7131 3.52479 12.888 3.73851Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6caf42e3e1a8c059(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16.0001H5.88889L11.1834 20.3319C11.2727 20.405 11.3846 20.4449 11.5 20.4449C11.7761 20.4449 12 20.2211 12 19.9449V4.05519C12 3.93977 11.9601 3.8279 11.887 3.73857C11.7121 3.52485 11.3971 3.49335 11.1834 3.66821L5.88889 8.00007H2C1.44772 8.00007 1 8.44778 1 9.00007V15.0001C1 15.5524 1.44772 16.0001 2 16.0001ZM23 12C23 15.292 21.5539 18.2463 19.2622 20.2622L17.8445 18.8444C19.7758 17.1937 21 14.7398 21 12C21 9.26016 19.7758 6.80629 17.8445 5.15557L19.2622 3.73779C21.5539 5.75368 23 8.70795 23 12ZM18 12C18 10.0883 17.106 8.38548 15.7133 7.28673L14.2842 8.71584C15.3213 9.43855 16 10.64 16 12C16 13.36 15.3213 14.5614 14.2842 15.2841L15.7133 16.7132C17.106 15.6145 18 13.9116 18 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d01dbe7433082dcd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.60282 10.0001L10 7.22056V16.7796L6.60282 14.0001H3V10.0001H6.60282ZM2 16.0001H5.88889L11.1834 20.3319C11.2727 20.405 11.3846 20.4449 11.5 20.4449C11.7761 20.4449 12 20.2211 12 19.9449V4.05519C12 3.93977 11.9601 3.8279 11.887 3.73857C11.7121 3.52485 11.3971 3.49335 11.1834 3.66821L5.88889 8.00007H2C1.44772 8.00007 1 8.44778 1 9.00007V15.0001C1 15.5524 1.44772 16.0001 2 16.0001ZM23 12C23 15.292 21.5539 18.2463 19.2622 20.2622L17.8445 18.8444C19.7758 17.1937 21 14.7398 21 12C21 9.26016 19.7758 6.80629 17.8445 5.15557L19.2622 3.73779C21.5539 5.75368 23 8.70795 23 12ZM18 12C18 10.0883 17.106 8.38548 15.7133 7.28673L14.2842 8.71584C15.3213 9.43855 16 10.64 16 12C16 13.36 15.3213 14.5614 14.2842 15.2841L15.7133 16.7132C17.106 15.6145 18 13.9116 18 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8c1be4ccc245c579(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.3891 3.16113L20.8033 4.57535L18.3277 7.04951L20.8033 9.52509L18.3277 11.9993L20.8033 14.4748L18.3284 16.9497L20.8033 19.4246L19.3891 20.8388L15.5 16.9497L17.9749 14.4748L15.5 12L17.9749 9.52509L15.5 7.05022L19.3891 3.16113ZM12.887 3.73847C12.9601 3.8278 13 3.93967 13 4.05509V19.9448C13 20.221 12.7761 20.4448 12.5 20.4448C12.3846 20.4448 12.2727 20.4049 12.1834 20.3318L6.889 15.9991L3 16C2.44772 16 2 15.5523 2 15V8.99997C2 8.44768 2.44772 7.99997 3 7.99997L6.889 7.99907L12.1834 3.66811C12.3971 3.49325 12.7121 3.52475 12.887 3.73847Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$45f1297e42b20c47(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.3891 3.16113L20.8033 4.57535L18.3277 7.04951L20.8033 9.52509L18.3277 11.9993L20.8033 14.4748L18.3284 16.9497L20.8033 19.4246L19.3891 20.8388L15.5 16.9497L17.9749 14.4748L15.5 12L17.9749 9.52509L15.5 7.05022L19.3891 3.16113ZM12.887 3.73847C12.9601 3.8278 13 3.93967 13 4.05509V19.9448C13 20.221 12.7761 20.4448 12.5 20.4448C12.3846 20.4448 12.2727 20.4049 12.1834 20.3318L6.889 15.9991L3 16C2.44772 16 2 15.5523 2 15V8.99997C2 8.44768 2.44772 7.99997 3 7.99997L6.889 7.99907L12.1834 3.66811C12.3971 3.49325 12.7121 3.52475 12.887 3.73847ZM11 7.21997L7.60302 9.99891L4 9.99897V14L7.60285 13.9989L11 16.779V7.21997Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$840894b2a5f2d50a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21V19.9291C7.60771 19.4439 5 16.5265 5 13V8C5 4.13401 8.13401 1 12 1C15.866 1 19 4.13401 19 8V13C19 16.5265 16.3923 19.4439 13 19.9291V21H17V23H7V21H11ZM12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9ZM12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$633dd9060168587c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21V19.9291C7.60771 19.4439 5 16.5265 5 13V8C5 4.13401 8.13401 1 12 1C15.866 1 19 4.13401 19 8V13C19 16.5265 16.3923 19.4439 13 19.9291V21H17V23H7V21H11ZM12 3C9.23858 3 7 5.23858 7 8V13C7 15.7614 9.23858 18 12 18C14.7614 18 17 15.7614 17 13V8C17 5.23858 14.7614 3 12 3ZM12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9ZM12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8C15 9.65685 13.6569 11 12 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a017122f6faf5daf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.366 13.366L14.1407 14.3911C13.05 16.8036 12.9953 19.4669 13.8296 21.8314C13.2375 21.9426 12.6255 22 12 22C10.5353 22 9.14414 21.6851 7.89054 21.1193L12.366 13.366ZM15.8835 15.3976L20.1168 17.8423C19.0224 19.3601 17.5128 20.5586 15.7543 21.2714C15.1047 19.511 15.0756 17.5348 15.7624 15.7017L15.8835 15.3976ZM8.85892 11.3417L10.634 12.366L6.15773 20.1168C4.5194 18.9355 3.25309 17.2704 2.56813 15.3308C4.92702 14.8924 7.11579 13.6115 8.65334 11.6179L8.85892 11.3417ZM21.9051 10.6165C21.9677 11.0687 22 11.5306 22 12C22 13.4647 21.6851 14.8559 21.1193 16.1095L16.8838 13.6649C18.1057 12.0497 19.8575 11.0078 21.7497 10.6436L21.9051 10.6165ZM2.8807 7.89054L7.11588 10.3356C5.86043 11.9949 4.0458 13.0491 2.09489 13.3854C2.03239 12.932 2 12.4698 2 12C2 10.5353 2.3149 9.14414 2.8807 7.89054ZM17.8423 3.88318C19.4803 5.06428 20.7465 6.72901 21.4315 8.66817C19.0721 9.108 16.8836 10.3891 15.3463 12.3826L15.1407 12.6588L13.366 11.634L17.8423 3.88318ZM12 2C13.4647 2 14.8559 2.3149 16.1095 2.8807L11.634 10.634L9.85892 9.60983C10.95 7.19703 11.0048 4.53332 10.1704 2.16848C10.7625 2.05742 11.3745 2 12 2ZM8.24679 2.72936C8.89548 4.48945 8.92444 6.46595 8.2373 8.2992L8.11613 8.60335L3.88318 6.15773C4.93611 4.69744 6.37339 3.53272 8.04682 2.81177L8.24679 2.72936Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fc51f923849fbd0f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12.366 13.366L8.89708 19.376C9.85124 19.7779 10.8997 20 12 20C12.4622 20 12.9152 19.9608 13.3559 19.8856C13.0984 18.0632 13.3411 16.1601 14.1404 14.3917L12.366 13.366ZM15.8835 15.3974C15.3519 16.6567 15.1671 17.9943 15.2969 19.2905C16.5173 18.7384 17.5737 17.8888 18.3745 16.8346L15.8835 15.3974ZM8.85855 11.3422C7.7265 12.919 6.1993 14.0809 4.49366 14.7699C5.0255 16.2135 5.96211 17.4604 7.16543 18.3745L10.634 12.366L8.85855 11.3422ZM19.9616 11.2111L19.7038 11.3328C18.6197 11.8687 17.6478 12.6548 16.8834 13.6653L19.3756 15.1039C19.7777 14.1495 20 13.1007 20 12C20 11.7338 19.987 11.4706 19.9616 11.2111ZM4 12C4 12.2662 4.013 12.5294 4.03841 12.7889C5.22626 12.2534 6.29168 11.4249 7.11596 10.3355L4.62402 8.89708C4.22214 9.85124 4 10.8997 4 12ZM16.8346 5.62552L13.366 11.634L15.1407 12.6588C16.2731 11.0812 17.8009 9.91878 19.5073 9.22969C19.0134 7.89068 18.1702 6.71922 17.0884 5.82653L16.8346 5.62552ZM12 4C11.5375 4 11.0841 4.03925 10.6431 4.1146C10.9016 5.93748 10.6588 7.8408 9.85915 9.60931L11.634 10.634L15.1029 4.62402C14.1488 4.22214 13.1003 4 12 4ZM8.70313 4.70955L8.51189 4.79845C7.37266 5.35126 6.38436 6.16644 5.62552 7.16543L8.11608 8.60349C8.64798 7.34403 8.83295 6.00607 8.70313 4.70955Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b5e23e24dc3c0d20(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.4142 10.5856L13.8936 11.0717L14.3585 11.5565L14.8177 12.049C18.2758 15.8129 20.2896 19.2665 19.4246 20.1316C19.0242 20.532 18.069 20.3155 16.7851 19.6244C13.5839 21.638 9.38982 21.4407 6.38249 19.0325L9.36197 16.0536C10.0289 16.2312 10.7697 16.0585 11.2929 15.5354C12.0739 14.7543 12.0739 13.488 11.2929 12.7069C10.5118 11.9259 9.24551 11.9259 8.46447 12.7069C7.98129 13.1901 7.79702 13.859 7.91165 14.4838L7.94653 14.639L4.968 17.6181C2.55913 14.6107 2.36164 10.4162 4.37553 7.21411C3.68433 5.93082 3.46783 4.97564 3.86827 4.5752C4.84458 3.59889 9.11845 6.28985 13.4142 10.5856ZM19.7782 4.22165C20.5592 5.0027 20.5592 6.26903 19.7782 7.05008C19.7254 7.10285 19.6704 7.15205 19.6135 7.19768C21.2304 9.7539 21.4333 12.9495 20.2214 15.6675C19.0324 13.7133 17.1513 11.4943 14.8284 9.1714L14.2905 8.6396C12.1634 6.56127 10.1352 4.87547 8.3327 3.77903C11.0504 2.56667 14.2459 2.76941 16.804 4.38688C16.8478 4.3294 16.897 4.27442 16.9497 4.22165C17.7308 3.4406 18.9971 3.4406 19.7782 4.22165Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d2adfed895b7cc0d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.1213 9.87853C18.4171 14.1743 20.9497 18.6065 19.7782 19.778C19.3031 20.2531 18.2918 20.1191 16.971 19.5054C13.746 21.645 9.44716 21.4872 6.38175 19.0319L6.34315 19.0709L4.92893 17.6567L4.96734 17.6173C2.51262 14.552 2.35503 10.2536 4.49456 7.02993C3.88075 5.70785 3.74678 4.69672 4.22183 4.22168C5.34959 3.09391 9.49865 5.39854 13.639 9.40413L14.1213 9.87853ZM12.7071 11.2927C10.823 9.40864 8.86963 7.84183 7.23581 6.86941L7.05025 7.0501C4.55691 9.54345 4.33771 13.4498 6.39266 16.1916L8.23943 14.3461C8.06128 13.6789 8.23392 12.9375 8.75736 12.4141C9.53841 11.633 10.8047 11.633 11.5858 12.4141C12.3668 13.1951 12.3668 14.4614 11.5858 15.2425C11.0626 15.7656 10.3218 15.9384 9.65487 15.7607L7.80749 17.6066C10.5493 19.6622 14.4562 19.4432 16.9497 16.9496L17.1286 16.7622L17.076 16.6732C16.1001 15.0581 14.5564 13.1421 12.7071 11.2927ZM19.7782 4.22168C20.5592 5.00273 20.5592 6.26906 19.7782 7.0501C19.7254 7.10287 19.6704 7.15207 19.6135 7.19771C21.2057 9.71492 21.4267 12.852 20.276 15.5425C19.8994 14.8063 19.4347 14.0315 18.8899 13.2367C19.2795 11.0595 18.6326 8.73296 16.9497 7.0501C15.2669 5.36725 12.9404 4.72037 10.7627 5.10945C9.96765 4.56476 9.19311 4.10017 8.45731 3.72435C11.1478 2.57323 14.2849 2.79415 16.8039 4.38683C16.8478 4.32943 16.897 4.27444 16.9497 4.22168C17.7308 3.44063 18.9971 3.44063 19.7782 4.22168Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7be6c102b1319eb7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6ZM12 7.75C13.3807 7.75 14.5 8.86929 14.5 10.25C14.5 10.8815 14.2658 11.4584 13.8796 11.8984C14.4447 12.354 14.8 13.0149 14.8 13.75C14.8 15.1307 13.5464 16.25 12 16.25C10.4536 16.25 9.2 15.1307 9.2 13.75C9.2 13.0149 9.5553 12.354 10.1209 11.8966C9.73416 11.4584 9.5 10.8815 9.5 10.25C9.5 8.86929 10.6193 7.75 12 7.75ZM12 12.75C11.2465 12.75 10.7 13.238 10.7 13.75C10.7 14.262 11.2465 14.75 12 14.75C12.7535 14.75 13.3 14.262 13.3 13.75C13.3 13.238 12.7535 12.75 12 12.75ZM12 9.25C11.4477 9.25 11 9.69772 11 10.25C11 10.8023 11.4477 11.25 12 11.25C12.5523 11.25 13 10.8023 13 10.25C13 9.69772 12.5523 9.25 12 9.25Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$119fc0e9a8301e74(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6ZM12 7.75C10.6193 7.75 9.5 8.86929 9.5 10.25C9.5 10.8815 9.73416 11.4584 10.1209 11.8966C9.5553 12.354 9.2 13.0149 9.2 13.75C9.2 15.1307 10.4536 16.25 12 16.25C13.5464 16.25 14.8 15.1307 14.8 13.75C14.8 13.0149 14.4447 12.354 13.8796 11.8984C14.2658 11.4584 14.5 10.8815 14.5 10.25C14.5 8.86929 13.3807 7.75 12 7.75ZM12 12.75C12.7535 12.75 13.3 13.238 13.3 13.75C13.3 14.262 12.7535 14.75 12 14.75C11.2465 14.75 10.7 14.262 10.7 13.75C10.7 13.238 11.2465 12.75 12 12.75ZM12 9.25C12.5523 9.25 13 9.69772 13 10.25C13 10.8023 12.5523 11.25 12 11.25C11.4477 11.25 11 10.8023 11 10.25C11 9.69772 11.4477 9.25 12 9.25Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$66ea9cf91ab31936(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1 21.5 6.5V17.5L13 22.4211V11.4234L3.49793 5.92225 12 1ZM2.5 7.6555V17.5L11 22.4211V12.5765L2.5 7.6555Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e42955c59cbf8e28(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM5.49388 7.0777L13.0001 11.4234V20.11L19.5 16.3469V7.65311L12 3.311L5.49388 7.0777ZM4.5 8.81329V16.3469L11.0001 20.1101V12.5765L4.5 8.81329Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ff61a9c0d269082e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM4.5 7.65788V16.3469L12 20.689V12L4.5 7.65788Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fb8dd3a515511d02(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM4.5 7.65311V7.65788L12 12V20.689L19.5 16.3469V7.65311L12 3.311L4.5 7.65311Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b142a4fb06db28b5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5021 5.92225 12 1 3.49793 5.92225 12 10.8445 20.5021 5.92225ZM2.5 7.6555V17.5L11 22.4211V12.5765L2.5 7.6555ZM13 22.4211 21.5 17.5V7.6555L13 12.5765V22.4211Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2025e903f5748cec(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM5.49388 7.0777L12.0001 10.8444L18.5062 7.07774L12 3.311L5.49388 7.0777ZM4.5 8.81329V16.3469L11.0001 20.1101V12.5765L4.5 8.81329ZM13.0001 20.11L19.5 16.3469V8.81337L13.0001 12.5765V20.11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$95fb914b00906830(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.501 11L9.64546 11.0069C10.3586 11.075 10.926 11.6424 10.9941 12.3555L11.001 12.5L10.9941 12.6445C10.926 13.3576 10.3586 13.925 9.64546 13.9931L9.501 14H6.001V16H9.501C11.2009 16 12.6178 14.7881 12.9348 13.1811L12.9654 13.0009L19.001 13C19.7123 13 20.3889 12.8515 21.0015 12.5837L21.001 17C21.001 18.3059 20.1666 19.4169 19.0019 19.829L19.001 21C19.001 21.5523 18.5533 22 18.001 22H6.001C5.44872 22 5.001 21.5523 5.001 21L5.00109 19.8293C3.83585 19.4175 3.001 18.3063 3.001 17V13C3.001 11.8954 3.89643 11 5.001 11H9.501ZM22.001 7.5V8L21.9959 8.17627C21.908 9.69275 20.6938 10.907 19.1773 10.9949L19.001 11H12.6642C12.1305 9.87663 11.0161 9.08266 9.70894 9.00607L9.501 9H5.001C4.27201 9 3.58857 9.19501 3 9.53571L3.001 6C3.001 3.79086 4.79186 2 7.001 2H16.501C19.5386 2 22.001 4.46243 22.001 7.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d5ffbd2c8390c453(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 2C19.5376 2 22 4.46243 22 7.5V10C22 10.8881 21.6141 11.686 21.0009 12.2353L21 17C21 18.3059 20.1656 19.4169 19.0009 19.829L19 21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21L5.00009 19.8293C3.83485 19.4175 3 18.3063 3 17V6C3 3.79086 4.79086 2 7 2H16.5ZM9.5 11H5V17C5 17.5128 5.38604 17.9355 5.88338 17.9933L6 18H18C18.5128 18 18.9355 17.614 18.9933 17.1166L19 17V13L12.9644 13.0009C12.7214 14.6966 11.2629 16 9.5 16H6V14H9.5C10.2797 14 10.9204 13.4051 10.9931 12.6445L11 12.5C11 11.7203 10.4051 11.0796 9.64446 11.0069L9.5 11ZM16.5 4H7C5.94564 4 5.08183 4.81588 5.00549 5.85074L5 6V9H9.5C10.8962 9 12.1014 9.81751 12.6632 11H19C19.5128 11 19.9355 10.614 19.9933 10.1166L20 10V7.5C20 5.63144 18.5357 4.10487 16.692 4.00518L16.5 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$61f878a5b2890c61(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.998 2C14.2072 2 15.998 3.79086 15.998 6V15H16.998C17.5476 15 17.998 14.55 17.998 14V8C17.998 7.44772 18.4458 7 18.998 7C19.5503 7 19.998 7.44772 19.998 8V14C19.998 15.6569 18.6549 17 16.998 17H15.998V20H17.998V22H5.99805V20H7.99805V14H6.99805C5.34119 14 3.99805 12.6569 3.99805 11V9C3.99805 8.44772 4.44576 8 4.99805 8C5.55033 8 5.99805 8.44772 5.99805 9V11C5.99805 11.55 6.44805 12 6.99805 12C7.36471 12 7.69805 12 7.99805 12V6C7.99805 3.79086 9.78891 2 11.998 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2dd92a3985a75195(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.998 2C14.2072 2 15.998 3.79086 15.998 6V15H16.998C17.548 15 17.998 14.55 17.998 14V8C17.998 7.44772 18.4458 7 18.998 7C19.5503 7 19.998 7.44772 19.998 8V14C19.998 15.66 18.658 17 16.998 17H15.998V20H17.998V22H5.99805V20H7.99805V14H6.99805C5.34119 14 3.99805 12.6569 3.99805 11V9C3.99805 8.44772 4.44576 8 4.99805 8C5.55033 8 5.99805 8.44772 5.99805 9V11C5.99805 11.55 6.44805 12 6.99805 12H7.99805V6C7.99805 3.79086 9.78891 2 11.998 2ZM11.998 4C10.8935 4 9.99805 4.89543 9.99805 6V20H13.998V6C13.998 4.89543 13.1026 4 11.998 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9c249d50efa80b58(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6V9.999H11V6H13V9.999H16V6H18V9.999L19 10C20.5977 10 21.9037 11.2489 21.9949 12.8237L22 13V14C22 15.0139 21.6227 15.9397 21.001 16.6447L21 21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21L2.99917 16.6401C2.47812 16.0464 2.12795 15.2943 2.02793 14.4584L2.00551 14.2052L2 14V13C2 11.4023 3.24892 10.0963 4.82373 10.0051L5 10L6 9.999V6H8ZM19 12H5C4.48716 12 4.06449 12.386 4.00673 12.8834L4 13L3.99958 13.9711L4.00342 14.1184C4.06444 15.1715 4.93934 16 6 16C7.00762 16 7.84761 15.2523 7.98033 14.2995L7.99532 14.1474L8.00042 13.9711C8.03649 12.7225 9.82713 12.6779 9.98853 13.8373L9.99958 13.9711L10.0034 14.1184C10.0644 15.1715 10.9393 16 12 16C13.0544 16 13.9182 15.1841 13.9945 14.1493L14.007 13.8668C14.131 12.7111 15.869 12.7111 15.993 13.8668L16.0055 14.1493C16.0818 15.1841 16.9456 16 18 16C19.0544 16 19.9182 15.1841 19.9945 14.1493L20 14V13C20 12.4872 19.614 12.0645 19.1166 12.0067L19 12ZM7 1C8.31948 1.87119 8.6633 3.08803 8.44889 3.88823C8.23448 4.68843 7.41197 5.1633 6.61177 4.94889C5.81157 4.73448 5.3367 3.91197 5.55111 3.11177C5.84871 2.00111 7 2.5 7 1ZM12 1C13.3195 1.87119 13.6633 3.08803 13.4489 3.88823C13.2345 4.68843 12.412 5.1633 11.6118 4.94889C10.8116 4.73448 10.3367 3.91197 10.5511 3.11177C10.8487 2.00111 12 2.5 12 1ZM17 1C18.3195 1.87119 18.6633 3.08803 18.4489 3.88823C18.2345 4.68843 17.412 5.1633 16.6118 4.94889C15.8116 4.73448 15.3367 3.91197 15.5511 3.11177C15.8487 2.00111 17 2.5 17 1Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a36c16222ffda7ef(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6V9.999H11V6H13V9.999H16V6H18V9.999L19 10C20.5977 10 21.9037 11.2489 21.9949 12.8237L22 13V14C22 15.0139 21.6227 15.9397 21.001 16.6447L21 21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21L2.99917 16.6401C2.47812 16.0464 2.12795 15.2943 2.02793 14.4584L2.00551 14.2052L2 14V13C2 11.4023 3.24892 10.0963 4.82373 10.0051L5 10L6 9.999V6H8ZM9.002 16.641L8.94768 16.7041C8.30742 17.4013 7.42357 17.8697 6.43424 17.9767L6.20413 17.9949L6 18C5.65524 18 5.32032 17.9563 5.00061 17.8738L5 20H19L19.0008 17.8738C18.6809 17.9562 18.3456 18 18 18C16.9378 18 15.9724 17.586 15.2561 16.9106L15.1065 16.7619L15 16.644L14.8935 16.7619C14.2607 17.4246 13.4024 17.8703 12.4418 17.9759L12.1996 17.9951L12 18C10.914 18 9.92563 17.5661 9.20287 16.8557L9.05211 16.6993L9.002 16.641ZM19 12H5C4.48716 12 4.06449 12.386 4.00673 12.8834L4 13L3.99958 13.9711L4.00342 14.1184C4.06444 15.1715 4.93934 16 6 16C7.00762 16 7.84761 15.2523 7.98033 14.2995L7.99532 14.1474L8.00042 13.9711C8.03649 12.7225 9.82713 12.6779 9.98853 13.8373L9.99958 13.9711L10.0034 14.1184C10.0644 15.1715 10.9393 16 12 16C13.0544 16 13.9182 15.1841 13.9945 14.1493L14.007 13.8668C14.131 12.7111 15.869 12.7111 15.993 13.8668L16.0055 14.1493C16.0818 15.1841 16.9456 16 18 16C19.0544 16 19.9182 15.1841 19.9945 14.1493L20 14V13C20 12.4872 19.614 12.0645 19.1166 12.0067L19 12ZM7 1C8.31948 1.87119 8.6633 3.08803 8.44889 3.88823C8.23448 4.68843 7.41197 5.1633 6.61177 4.94889C5.81157 4.73448 5.3367 3.91197 5.55111 3.11177C5.84871 2.00111 7 2.5 7 1ZM12 1C13.3195 1.87119 13.6633 3.08803 13.4489 3.88823C13.2345 4.68843 12.412 5.1633 11.6118 4.94889C10.8116 4.73448 10.3367 3.91197 10.5511 3.11177C10.8487 2.00111 12 2.5 12 1ZM17 1C18.3195 1.87119 18.6633 3.08803 18.4489 3.88823C18.2345 4.68843 17.412 5.1633 16.6118 4.94889C15.8116 4.73448 15.3367 3.91197 15.5511 3.11177C15.8487 2.00111 17 2.5 17 1Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b3befd0913349fc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 2C17.433 2 19 3.567 19 5.5C19 5.72679 18.9784 5.94854 18.9372 6.16332L18.9223 6.22941C20.7106 6.82471 22 8.51178 22 10.5C22 12.3741 20.8544 13.9806 19.2253 14.6574L18.1393 21.1644C18.0589 21.6466 17.6417 22 17.1529 22H6.84713C6.35829 22 5.9411 21.6466 5.86073 21.1644L4.832 14.994C3.24892 14.9037 2 13.5977 2 12C2 10.6926 2.83627 9.5806 4.00306 9.16963L4 9C4 5.68629 6.68629 3 10 3C10.9216 3 11.7947 3.20779 12.575 3.57908C13.1988 2.62827 14.276 2 15.5 2ZM11 15H9V20H11V15ZM15 15H13V20H15V15ZM17.5 13C18.8807 13 20 11.8807 20 10.5C20 9.11929 18.8807 8 17.5 8C17.1643 8 16.8417 8.06519 16.5442 8.18959L16.3688 8.27129C15.4021 8.76932 14.2253 8.40165 13.7059 7.46716L13.6362 7.32984C12.9876 5.92108 11.5778 5 10 5C7.8578 5 6.10892 6.68397 6.0046 8.76748L5.99967 8.96394L6.00273 9.13357C6.0173 9.94127 5.54534 10.6726 4.8166 10.9967L4.6675 11.056C4.27121 11.1956 4 11.5722 4 12C4 12.5523 4.44772 13 5 13H17.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c8f433d88438a1f0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 2C17.433 2 19 3.567 19 5.5C19 5.72679 18.9784 5.94854 18.9372 6.16332L18.9223 6.22941C20.7106 6.82471 22 8.51178 22 10.5C22 12.3741 20.8544 13.9806 19.2253 14.6574L18.1393 21.1644C18.0589 21.6466 17.6417 22 17.1529 22H6.84713C6.35829 22 5.9411 21.6466 5.86073 21.1644L4.832 14.994C3.24892 14.9037 2 13.5977 2 12C2 10.6926 2.83627 9.5806 4.00306 9.16963L4 9C4 5.68629 6.68629 3 10 3C10.9212 3 11.794 3.20761 12.574 3.5786C13.1984 2.62849 14.2758 2 15.5 2ZM9 15H6.86L7.694 20H9V15ZM13 15H11V20H13V15ZM17.139 15H15V20H16.305L17.139 15ZM10 5C7.8578 5 6.10892 6.68397 6.0046 8.76748L5.99967 8.96394L6.00273 9.13357C6.0173 9.94127 5.54534 10.6726 4.8166 10.9967L4.6675 11.056C4.27121 11.1956 4 11.5722 4 12C4 12.5523 4.44772 13 5 13H17.5C18.8807 13 20 11.8807 20 10.5C20 9.11929 18.8807 8 17.5 8C17.1643 8 16.8417 8.06519 16.5442 8.18959L16.3688 8.27129C15.4021 8.76932 14.2253 8.40165 13.7059 7.46716L13.6362 7.32984C12.9876 5.92108 11.5778 5 10 5ZM15.5 4C14.9536 4 14.4755 4.29211 14.2132 4.72868C14.7264 5.2345 15.1481 5.83144 15.4529 6.49336C15.8966 6.26481 16.3838 6.10867 16.8988 6.03984C16.9645 5.87263 17 5.69046 17 5.5C17 4.67157 16.3284 4 15.5 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$14f1917d1b88bddd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6.99993V10.9999L20 10.9999C20.5523 10.9999 21 11.4476 21 11.9999V19.9999L23 19.9999V21.9999H1V19.9999L3 19.9999V11.9999C3 11.4476 3.44772 10.9999 4 10.9999L11 10.9999V6.99993H13ZM13.8301 0.401855C14.6586 1.83673 14.1669 3.6715 12.7321 4.49993L11 5.49993C10.1716 4.06505 10.6632 2.23028 12.0981 1.40186L13.8301 0.401855Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6a252f85146b4962(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6.99993V10.9999L20 10.9999C20.5523 10.9999 21 11.4476 21 11.9999V19.9999L23 19.9999V21.9999H1V19.9999L3 19.9999V11.9999C3 11.4476 3.44772 10.9999 4 10.9999L11 10.9999V6.99993H13ZM19 12.9999H5V19.9999H19V12.9999ZM13.8301 0.401855C14.6586 1.83673 14.1669 3.6715 12.7321 4.49993L11 5.49993C10.1716 4.06505 10.6632 2.23028 12.0981 1.40186L13.8301 0.401855Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$10699528dc99f5c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17157 9.33147C7.60948 7.76938 7.60948 5.23672 9.17157 3.67462L12 0.846191L14.8284 3.67462C16.3905 5.23672 16.3905 7.76938 14.8284 9.33147C14.3039 9.85601 13.6699 10.2044 13 10.3767V12H18C18.5523 12 19 12.4477 19 13V20H21V22H3V20H5V13C5 12.4477 5.44772 12 6 12H11V10.3767C10.3301 10.2044 9.69611 9.85601 9.17157 9.33147ZM10.5858 5.08883C9.80474 5.86988 9.80474 7.13621 10.5858 7.91726C11.3668 8.69831 12.6332 8.69831 13.4142 7.91726C14.1953 7.13621 14.1953 5.86988 13.4142 5.08883L12 3.67462L10.5858 5.08883Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f6a9dbadab44d2c8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17157 9.33147C7.60948 7.76938 7.60948 5.23672 9.17157 3.67462L12 0.846191L14.8284 3.67462C16.3905 5.23672 16.3905 7.76938 14.8284 9.33147C14.3039 9.85601 13.6699 10.2044 13 10.3767V12H18C18.5523 12 19 12.4477 19 13V20H21V22H3V20H5V13C5 12.4477 5.44772 12 6 12H11V10.3767C10.3301 10.2044 9.69611 9.85601 9.17157 9.33147ZM10.5858 5.08883C9.80474 5.86988 9.80474 7.13621 10.5858 7.91726C11.3668 8.69831 12.6332 8.69831 13.4142 7.91726C14.1953 7.13621 14.1953 5.86988 13.4142 5.08883L12 3.67462L10.5858 5.08883ZM7 14V20H17V14H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$29dabc7ea4bf0d8a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.998 3V21H2.99805V3H20.998ZM12.997 6H10.997L6.59805 17H8.75205L9.95105 14H14.041L15.242 17H17.397L12.997 6ZM11.997 8.88517L13.242 12H10.75L11.997 8.88517Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2bd50da6f6c91b23(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.99805 15V19H8.99805V21H2.99805V15H4.99805ZM20.998 15V21H14.998V19H18.998V15H20.998ZM12.997 6L17.397 17H15.242L14.041 14H9.95105L8.75205 17H6.59805L10.997 6H12.997ZM11.997 8.88517L10.75 12H13.242L11.997 8.88517ZM8.99805 3V5H4.99805V9H2.99805V3H8.99805ZM20.998 3V9H18.998V5H14.998V3H20.998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e4a743aca75cdf43(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H10V8H4V12H10V22H14V12H20V8H14V2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a6ec7c14f83603c9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2H15V7H20V13H15V22H9V13H4V7H9V2ZM11 4V9H6V11H11V20H13V11H18V9H13V4H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f4660678174d1da3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.99805 21V19H4.99805V4C4.99805 3.44772 5.44576 3 5.99805 3H17.998C18.5503 3 18.998 3.44772 18.998 4V19H20.998V21H2.99805ZM14.998 11H12.998V13H14.998V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bfeb93a2384bf1da(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.99805 21V19H4.99805V4C4.99805 3.44772 5.44576 3 5.99805 3H17.998C18.5503 3 18.998 3.44772 18.998 4V19H20.998V21H2.99805ZM16.998 5H6.99805V19H16.998V5ZM14.998 11V13H12.998V11H14.998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$222fb0fdfd58868f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.998 3C18.5503 3 18.998 3.44772 18.998 4V20C18.998 20.5523 18.5503 21 17.998 21H5.99805C5.44576 21 4.99805 20.5523 4.99805 20V4C4.99805 3.44772 5.44576 3 5.99805 3H17.998ZM13.998 11C13.4458 11 12.998 11.4477 12.998 12C12.998 12.5523 13.4458 13 13.998 13C14.5503 13 14.998 12.5523 14.998 12C14.998 11.4477 14.5503 11 13.998 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$48bbbfa49f35e6e9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.998 3C18.5503 3 18.998 3.44772 18.998 4V20C18.998 20.5523 18.5503 21 17.998 21H5.99805C5.44576 21 4.99805 20.5523 4.99805 20V4C4.99805 3.44772 5.44576 3 5.99805 3H17.998ZM16.998 5H6.99805V19H16.998V5ZM14.998 11V13H12.998V11H14.998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$325768d6ec6e344a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM11 12.792V16H13V12.792C13.883 12.4062 14.5 11.5252 14.5 10.5C14.5 9.11929 13.3807 8 12 8C10.6193 8 9.5 9.11929 9.5 10.5C9.5 11.5252 10.117 12.4062 11 12.792Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a033a66bf464562d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5ZM11 12.792C10.117 12.4062 9.5 11.5252 9.5 10.5C9.5 9.11929 10.6193 8 12 8C13.3807 8 14.5 9.11929 14.5 10.5C14.5 11.5252 13.883 12.4062 13 12.792V16H11V12.792Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dcec4ddb3b6df311(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 12.792V16H13V12.792C13.883 12.4062 14.5 11.5252 14.5 10.5C14.5 9.11929 13.3807 8 12 8C10.6193 8 9.5 9.11929 9.5 10.5C9.5 11.5252 10.117 12.4062 11 12.792Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$25335913b957b537(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 12.792C10.117 12.4062 9.5 11.5252 9.5 10.5C9.5 9.11929 10.6193 8 12 8C13.3807 8 14.5 9.11929 14.5 10.5C14.5 11.5252 13.883 12.4062 13 12.792V16H11V12.792Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f4bad414e261af22(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.99805 21.0003V19.0003L3.99805 19.0001V4.83489C3.99805 4.35161 4.34367 3.93748 4.81916 3.85102L14.2907 2.12892C14.6167 2.06965 14.9291 2.28589 14.9884 2.61191C14.9948 2.64733 14.998 2.68325 14.998 2.71924V4.00014L18.998 4.00032C19.5503 4.00032 19.998 4.44803 19.998 5.00032V19.0001L21.998 19.0003V21.0003H17.998V6.00032L14.998 6.00014V21.0003H1.99805ZM11.998 11.0003H9.99805V13.0003H11.998V11.0003Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ee5a2a1037c2e744(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.99805 21.0003V19.0003L3.99805 19.0001V4.83489C3.99805 4.35161 4.34367 3.93748 4.81916 3.85102L14.2907 2.12892C14.6167 2.06965 14.9291 2.28589 14.9884 2.61191C14.9948 2.64733 14.998 2.68325 14.998 2.71924V4.00014L18.998 4.00032C19.5503 4.00032 19.998 4.44803 19.998 5.00032V19.0001L21.998 19.0003V21.0003H17.998V6.00032L14.998 6.00014V21.0003H1.99805ZM12.998 4.39674L5.99805 5.66947V19.0003H12.998V4.39674ZM11.998 11.0003V13.0003H9.99805V11.0003H11.998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f930f30dbb4a959a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM13.6695 15.9999H10.3295L8.95053 17.8969L9.5044 19.6031C10.2897 19.8607 11.1286 20 12 20C12.8714 20 13.7103 19.8607 14.4956 19.6031L15.0485 17.8969L13.6695 15.9999ZM5.29354 10.8719L4.00222 11.8095L4 12C4 13.7297 4.54894 15.3312 5.4821 16.6397L7.39254 16.6399L8.71453 14.8199L7.68654 11.6499L5.29354 10.8719ZM18.7055 10.8719L16.3125 11.6499L15.2845 14.8199L16.6065 16.6399L18.5179 16.6397C19.4511 15.3312 20 13.7297 20 12L19.997 11.809L18.7055 10.8719ZM14.2914 4.33299L12.9995 5.27293V7.78993L15.6935 9.74693L17.9325 9.01993L18.4867 7.3168C17.467 5.90685 15.9988 4.84254 14.2914 4.33299ZM9.70857 4.33299C8.00078 4.84265 6.53236 5.90735 5.51261 7.31778L6.06653 9.01993L8.30554 9.74693L10.9995 7.78993V5.27293L9.70857 4.33299Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$18403981ac7c5d09(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM13.6695 15.9999H10.3295L8.95053 17.8969L9.5044 19.6031C10.2897 19.8607 11.1286 20 12 20C12.8714 20 13.7103 19.8607 14.4956 19.6031L15.0485 17.8969L13.6695 15.9999ZM5.29354 10.8719L4.00222 11.8095L4 12C4 13.7297 4.54894 15.3312 5.4821 16.6397L7.39254 16.6399L8.71453 14.8199L7.68654 11.6499L5.29354 10.8719ZM18.7055 10.8719L16.3125 11.6499L15.2845 14.8199L16.6065 16.6399L18.5179 16.6397C19.4511 15.3312 20 13.7297 20 12L19.997 11.81L18.7055 10.8719ZM12 9.536L9.656 11.238L10.552 14H13.447L14.343 11.238L12 9.536ZM14.2914 4.33299L12.9995 5.27293V7.78993L15.6935 9.74693L17.9325 9.01993L18.4867 7.3168C17.467 5.90685 15.9988 4.84254 14.2914 4.33299ZM9.70757 4.33329C8.00021 4.84307 6.53216 5.90762 5.51261 7.31778L6.06653 9.01993L8.30554 9.74693L10.9995 7.78993V5.27293L9.70757 4.33329Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$381b796d020c1ba(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.998 12V22C19.998 22.5523 19.5503 23 18.998 23H4.99805C4.44576 23 3.99805 22.5523 3.99805 22V12H19.998ZM8.99805 14H6.99805V19H8.99805V14ZM18.998 1C19.5503 1 19.998 1.44772 19.998 2V10H3.99805V2C3.99805 1.44772 4.44576 1 4.99805 1H18.998ZM8.99805 4H6.99805V8H8.99805V4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5ed3009e0566e3e2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.998 1C19.5503 1 19.998 1.44772 19.998 2V22C19.998 22.5523 19.5503 23 18.998 23H4.99805C4.44576 23 3.99805 22.5523 3.99805 22V2C3.99805 1.44772 4.44576 1 4.99805 1H18.998ZM17.998 12H5.99805V21H17.998V12ZM9.99805 14V18H7.99805V14H9.99805ZM17.998 3H5.99805V10H17.998V3ZM9.99805 5V8H7.99805V5H9.99805Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$779d92e3aeb1c969(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C15.1215 2 17.9089 3.43021 19.7428 5.67108L13.4142 12L19.7428 18.3289C17.9089 20.5698 15.1215 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 5C11.1716 5 10.5 5.67157 10.5 6.5C10.5 7.32843 11.1716 8 12 8C12.8284 8 13.5 7.32843 13.5 6.5C13.5 5.67157 12.8284 5 12 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$acd9aad28c157d9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C15.1215 2 17.9089 3.43021 19.7428 5.67108L13.4142 12L19.7428 18.3289C17.9089 20.5698 15.1215 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C13.7232 20 15.3548 19.4531 16.6974 18.4774L16.905 18.32L10.5859 12L16.905 5.679L16.6974 5.52261C15.4338 4.60431 13.9142 4.06583 12.3031 4.00565L12 4ZM12 5C12.8284 5 13.5 5.67157 13.5 6.5C13.5 7.32843 12.8284 8 12 8C11.1716 8 10.5 7.32843 10.5 6.5C10.5 5.67157 11.1716 5 12 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a5b05fbdf062a694(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2 0 9 12 16 22 10.1667V17.5H24V9L12 2ZM3.99902 13.4905V18.0001C5.82344 20.429 8.72812 22.0001 11.9998 22.0001 15.2714 22.0001 18.1761 20.429 20.0005 18.0001L20.0001 13.4913 12.0003 18.1579 3.99902 13.4905Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$229e07cac011cc39(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11.3333L0 9L12 2L24 9V17.5H22V10.1667L20 11.3333V18.0113L19.7774 18.2864C17.9457 20.5499 15.1418 22 12 22C8.85817 22 6.05429 20.5499 4.22263 18.2864L4 18.0113V11.3333ZM6 12.5V17.2917C7.46721 18.954 9.61112 20 12 20C14.3889 20 16.5328 18.954 18 17.2917V12.5L12 16L6 12.5ZM3.96927 9L12 13.6846L20.0307 9L12 4.31541L3.96927 9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ab93e6d81060c9ce(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0002 2C15.8662 2 19.0002 5.13401 19.0002 9H20.0742C20.5967 9 21.0311 9.40231 21.0712 9.9233L21.9174 20.9233C21.9597 21.474 21.5477 21.9547 20.997 21.9971L20.9203 22H3.08008C2.52779 22 2.08008 21.5523 2.08008 21L2.08302 20.9233L2.92918 9.9233C2.96925 9.40231 3.4037 9 3.92623 9H5.0002C5.0002 5.13401 8.13421 2 12.0002 2ZM14.0002 13H10.0002V15H14.0002V13ZM12.0002 4C9.31145 4 7.11838 6.12231 7.00482 8.78311L7.0002 9H17.0002C17.0002 6.31124 14.8779 4.11818 12.2171 4.00462L12.0002 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$22d95f0af14fc68a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0002 2C15.8662 2 19.0002 5.13401 19.0002 9H20.0742C20.5967 9 21.0311 9.40231 21.0712 9.9233L21.9174 20.9233C21.9597 21.474 21.5477 21.9547 20.997 21.9971L20.9203 22H3.08008C2.52779 22 2.08008 21.5523 2.08008 21L2.08302 20.9233L2.92918 9.9233C2.96925 9.40231 3.4037 9 3.92623 9H5.0002C5.0002 5.13401 8.13421 2 12.0002 2ZM19.1472 11H4.8522L4.1592 20H19.8402L19.1472 11ZM14.0002 13V15H10.0002V13H14.0002ZM12.0002 4C9.31145 4 7.11838 6.12231 7.00482 8.78311L7.0002 9H17.0002C17.0002 6.31124 14.8779 4.11818 12.2171 4.00462L12.0002 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1324797fb570d2e8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12C3 13.933 4.567 15.5 6.5 15.5C7.7035 15.5 8.51959 15.0662 9.19914 14.3866C9.82141 13.7644 10.3213 12.9468 10.8546 12C10.3213 11.0532 9.82141 10.2356 9.19914 9.61336C8.51959 8.9338 7.7035 8.5 6.5 8.5C4.567 8.5 3 10.067 3 12ZM6.5 17.5C3.46243 17.5 1 15.0376 1 12C1 8.96243 3.46243 6.5 6.5 6.5C8.2965 6.5 9.60541 7.1912 10.6134 8.19914C11.1486 8.7344 11.5999 9.36157 12 10.0017C12.4001 9.36157 12.8514 8.7344 13.3866 8.19914C14.3946 7.1912 15.7035 6.5 17.5 6.5C20.5376 6.5 23 8.96243 23 12C23 15.0376 20.5376 17.5 17.5 17.5C15.7035 17.5 14.3946 16.8088 13.3866 15.8009C12.8514 15.2656 12.4001 14.6384 12 13.9983C11.5999 14.6384 11.1486 15.2656 10.6134 15.8009C9.60541 16.8088 8.2965 17.5 6.5 17.5ZM13.1454 12C13.6787 12.9468 14.1786 13.7644 14.8009 14.3866C15.4804 15.0662 16.2965 15.5 17.5 15.5C19.433 15.5 21 13.933 21 12C21 10.067 19.433 8.5 17.5 8.5C16.2965 8.5 15.4804 8.9338 14.8009 9.61336C14.1786 10.2356 13.6787 11.0532 13.1454 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6a8fff0c20ee7ad7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12C3 10.067 4.567 8.5 6.5 8.5C7.7035 8.5 8.51959 8.9338 9.19914 9.61336C9.9255 10.3397 10.4851 11.3322 11.1258 12.4856L11.1595 12.5462C11.7605 13.6283 12.4431 14.8573 13.3866 15.8009C14.3946 16.8088 15.7035 17.5 17.5 17.5C20.5376 17.5 23 15.0376 23 12C23 8.96243 20.5376 6.5 17.5 6.5C15.8394 6.5 14.3508 7.2359 13.3423 8.39937C13.7887 9.05406 14.1574 9.70577 14.464 10.2574C15.0681 9.20718 16.2014 8.5 17.5 8.5C19.433 8.5 21 10.067 21 12C21 13.933 19.433 15.5 17.5 15.5C16.2965 15.5 15.4804 15.0662 14.8009 14.3866C14.0745 13.6603 13.5149 12.6678 12.8742 11.5144L12.8405 11.4538C12.2395 10.3717 11.5569 9.14265 10.6134 8.19914C9.60541 7.1912 8.2965 6.5 6.5 6.5C3.46243 6.5 1 8.96243 1 12C1 15.0376 3.46243 17.5 6.5 17.5C8.16056 17.5 9.64923 16.7641 10.6577 15.6006C10.2113 14.9459 9.84262 14.2942 9.53605 13.7426C8.93194 14.7928 7.79856 15.5 6.5 15.5C4.567 15.5 3 13.933 3 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a4014a1fe7b63749(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.313 11.5655L18.253 3.62549L20.3744 5.74681L18.9602 7.16102L21.0815 9.28234L17.5459 12.8179L15.4246 10.6966L12.4343 13.6868C13.4182 15.5718 13.1186 17.9523 11.5355 19.5354C9.58291 21.488 6.41709 21.488 4.46447 19.5354C2.51184 17.5828 2.51184 14.4169 4.46447 12.4643C6.04755 10.8812 8.42809 10.5816 10.313 11.5655ZM9.41421 17.4141C10.1953 16.633 10.1953 15.3667 9.41421 14.5856C8.63316 13.8046 7.36684 13.8046 6.58579 14.5856C5.80474 15.3667 5.80474 16.633 6.58579 17.4141C7.36684 18.1951 8.63316 18.1951 9.41421 17.4141Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$33062f92213b682c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.7577 11.8279L18.6066 3.979L20.0208 5.39322L18.6066 6.80743L21.0815 9.28231L19.6673 10.6965L17.1924 8.22164L15.7782 9.63586L17.8995 11.7572L16.4853 13.1714L14.364 11.0501L12.1719 13.2421C13.4581 15.1835 13.246 17.8249 11.5355 19.5354C9.58291 21.488 6.41709 21.488 4.46447 19.5354C2.51184 17.5827 2.51184 14.4169 4.46447 12.4643C6.17493 10.7538 8.81633 10.5417 10.7577 11.8279ZM10.1213 18.1211C11.2929 16.9496 11.2929 15.0501 10.1213 13.8785C8.94975 12.7069 7.05025 12.7069 5.87868 13.8785C4.70711 15.0501 4.70711 16.9496 5.87868 18.1211C7.05025 19.2927 8.94975 19.2927 10.1213 18.1211Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8f13f42bcff30276(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14H12.6586C11.8349 16.3304 9.61244 18 7 18C3.68629 18 1 15.3137 1 12C1 8.68629 3.68629 6 7 6C9.61244 6 11.8349 7.66962 12.6586 10H23V14H21V18H17V14ZM7 14C8.10457 14 9 13.1046 9 12C9 10.8954 8.10457 10 7 10C5.89543 10 5 10.8954 5 12C5 13.1046 5.89543 14 7 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$889b5597bcce0bda(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.917 13C12.441 15.8377 9.973 18 7 18C3.68629 18 1 15.3137 1 12C1 8.68629 3.68629 6 7 6C9.973 6 12.441 8.16229 12.917 11H23V13H21V17H19V13H17V17H15V13H12.917ZM7 16C9.20914 16 11 14.2091 11 12C11 9.79086 9.20914 8 7 8C4.79086 8 3 9.79086 3 12C3 14.2091 4.79086 16 7 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$425833e2b467bbef(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.34315 1.4082L22.3744 19.4394C22.9602 20.0252 22.9602 20.975 22.3744 21.5607C21.7886 22.1465 20.8388 22.1465 20.253 21.5607L15.6569 16.9646L12.1213 20.5001L8.001 16.3792L8.00129 19.0001C8.00129 19.5524 7.55358 20.0001 7.00129 20.0001C6.44901 20.0001 6.00129 19.5524 6.00129 19.0001V15.0001C6.00129 14.4478 5.55358 14.0001 5.00129 14.0001C4.48846 14.0001 4.06578 14.3861 4.00802 14.8835L4.00129 15.0001V16.0001C4.00129 16.5524 3.55358 17.0001 3.00129 17.0001C2.44901 17.0001 2.00129 16.5524 2.00129 16.0001L2.00138 7.21394C1.96402 5.19447 2.68678 3.16356 4.16964 1.58709L4.34315 1.4082Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6959d487453b0fe8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.34315 1.4082L22.3744 19.4394C22.9602 20.0252 22.9602 20.975 22.3744 21.5607C21.7886 22.1465 20.8388 22.1465 20.253 21.5607L15.6569 16.9646L12.1213 20.5001L8.001 16.3792L8.00129 19.0001C8.00129 19.5524 7.55358 20.0001 7.00129 20.0001C6.44901 20.0001 6.00129 19.5524 6.00129 19.0001V15.0001C6.00129 14.4478 5.55358 14.0001 5.00129 14.0001C4.48846 14.0001 4.06578 14.3861 4.00802 14.8835L4.00129 15.0001V16.0001C4.00129 16.5524 3.55358 17.0001 3.00129 17.0001C2.44901 17.0001 2.00129 16.5524 2.00129 16.0001L2.00138 7.21394C1.96402 5.19447 2.68678 3.16356 4.16964 1.58709L4.34315 1.4082ZM4.58437 4.47838L4.5329 4.58823C4.22968 5.2577 4.05601 5.97117 4.01149 6.69097L4.00129 7.00009L4.00024 7.1196C4.01358 8.55874 4.54144 9.9933 5.58066 11.1234L5.75736 11.3077L12.1207 17.6716L14.9491 14.8431L4.58437 4.47838Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5f9e3fa1a982adb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.3744 19.4394C22.9602 20.0252 22.9602 20.975 22.3744 21.5607C21.7886 22.1465 20.8388 22.1465 20.253 21.5607L15.6569 16.9646L12.1213 20.5001L4.34315 12.7219C1.2779 9.65666 1.22006 4.72285 4.16964 1.58709L4.34315 1.4082L22.3744 19.4394Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$452532b6e6e34bc0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.34315 1.4082L22.3744 19.4394C22.9602 20.0252 22.9602 20.975 22.3744 21.5607C21.7886 22.1465 20.8388 22.1465 20.253 21.5607L15.6569 16.9646L12.1213 20.5001L4.34315 12.7219C1.2779 9.65666 1.22006 4.72285 4.16964 1.58709L4.34315 1.4082ZM4.58437 4.47838L4.5329 4.58823C3.56416 6.72709 3.91772 9.315 5.58066 11.1234L5.75736 11.3077L12.1207 17.6716L14.9491 14.8431L4.58437 4.47838Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6bc15815314ebb7e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.998 3V5C20.998 14.6274 15.6255 19 8.99805 19L7.0964 18.9999C7.3079 15.9876 8.24541 14.1648 10.6939 11.9989C11.8979 10.9338 11.7965 10.3189 11.2029 10.6721C7.1193 13.1016 5.09114 16.3862 5.00119 21.6302L4.99805 22H2.99805C2.99805 20.6373 3.11376 19.3997 3.34381 18.2682C3.1133 16.9741 2.99805 15.2176 2.99805 13C2.99805 7.47715 7.4752 3 12.998 3C14.998 3 16.998 4 20.998 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a8ad5cd507936d79(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.998 3V5C20.998 14.6274 15.6255 19 8.99805 19L5.24077 18.9999C5.0786 19.912 4.99805 20.907 4.99805 22H2.99805C2.99805 20.6373 3.11376 19.3997 3.34381 18.2682C3.1133 16.9741 2.99805 15.2176 2.99805 13C2.99805 7.47715 7.4752 3 12.998 3C14.998 3 16.998 4 20.998 3ZM12.998 5C8.57977 5 4.99805 8.58172 4.99805 13C4.99805 13.3624 5.00125 13.7111 5.00759 14.0459C6.26198 12.0684 8.09902 10.5048 10.5019 9.13176L11.4942 10.8682C8.6393 12.4996 6.74554 14.3535 5.77329 16.9998L8.99805 17C15.0132 17 18.8692 13.0269 18.9949 5.38766C17.6229 5.52113 16.3481 5.436 14.7754 5.20009C13.6243 5.02742 13.3988 5 12.998 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b469a3cc4a9fe8b8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18H7.94101C7.64391 16.7274 6.30412 15.6857 5.75395 14.9992C4.65645 13.6297 4 11.8915 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 11.8925 19.3428 13.6315 18.2443 15.0014C17.6944 15.687 16.3558 16.7276 16.059 18H13V13H11V18ZM16 20V21C16 22.1046 15.1046 23 14 23H10C8.89543 23 8 22.1046 8 21V20H16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9fa0cee60cd2e75a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.94101 18C7.64391 16.7274 6.30412 15.6857 5.75395 14.9992C4.65645 13.6297 4 11.8915 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 11.8925 19.3428 13.6315 18.2443 15.0014C17.6944 15.687 16.3558 16.7276 16.059 18H7.94101ZM16 20V21C16 22.1046 15.1046 23 14 23H10C8.89543 23 8 22.1046 8 21V20H16ZM13 10.0048V6L8.5 12.0048H11V16.0048L15.5 10.0048H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7a85e672655cdd72(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.97308 18H14.0269C14.1589 16.7984 14.7721 15.8065 15.7676 14.7226C15.8797 14.6006 16.5988 13.8564 16.6841 13.7501C17.5318 12.6931 18 11.385 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 11.3843 6.46774 12.6917 7.31462 13.7484C7.40004 13.855 8.12081 14.6012 8.23154 14.7218C9.22766 15.8064 9.84103 16.7984 9.97308 18ZM14 20H10V21H14V20ZM5.75395 14.9992C4.65645 13.6297 4 11.8915 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 11.8925 19.3428 13.6315 18.2443 15.0014C17.624 15.7748 16 17 16 18.5V21C16 22.1046 15.1046 23 14 23H10C8.89543 23 8 22.1046 8 21V18.5C8 17 6.37458 15.7736 5.75395 14.9992ZM13 10.0048H15.5L11 16.0048V12.0048H8.5L13 6V10.0048Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d3b952a50b172250(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.97308 18H11V13H13V18H14.0269C14.1589 16.7984 14.7721 15.8065 15.7676 14.7226C15.8797 14.6006 16.5988 13.8564 16.6841 13.7501C17.5318 12.6931 18 11.385 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 11.3843 6.46774 12.6917 7.31462 13.7484C7.40004 13.855 8.12081 14.6012 8.23154 14.7218C9.22766 15.8064 9.84103 16.7984 9.97308 18ZM10 20V21H14V20H10ZM5.75395 14.9992C4.65645 13.6297 4 11.8915 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 11.8925 19.3428 13.6315 18.2443 15.0014C17.624 15.7748 16 17 16 18.5V21C16 22.1046 15.1046 23 14 23H10C8.89543 23 8 22.1046 8 21V18.5C8 17 6.37458 15.7736 5.75395 14.9992Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b17b25fc315c111e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 7V11H13V7H11ZM14 12V16H16V12H14ZM8 12V16H10V12H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cd45fe22b4b9ce90(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 7H13V11H11V7ZM14 12H16V16H14V12ZM8 12H10V16H8V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c24390f11ed7421(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM14 10V14H16V10H14ZM8 10V14H10V10H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$613cdf4c57c463e0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM14 10H16V14H14V10ZM8 10H10V14H8V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$960f777c997cbb51(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 2C16.7467 2 21 6.25329 21 11.5C21 13.0291 20.6387 14.4739 19.9969 15.7536L22.4602 18.2175C22.8507 18.608 22.8507 19.2412 22.4602 19.6317L19.6317 22.4602C19.2412 22.8507 18.608 22.8507 18.2175 22.4602L15.7536 19.9969C14.4739 20.6387 13.0291 21 11.5 21C6.25329 21 2 16.7467 2 11.5C2 6.25329 6.25329 2 11.5 2ZM16.8033 15.3877L15.3891 16.8019L18.9246 20.3375L20.3388 18.9233L16.8033 15.3877ZM18.6669 9.28305L9.28305 18.6669C9.98371 18.8834 10.7282 19 11.5 19C12.4671 19 13.3914 18.817 14.2403 18.4836L13.2678 17.5104C12.8772 17.1199 12.8772 16.4867 13.2678 16.0962L16.0962 13.2678C16.4867 12.8772 17.1199 12.8772 17.5104 13.2678L18.4836 14.2403C18.817 13.3914 19 12.4671 19 11.5C19 10.7282 18.8834 9.98371 18.6669 9.28305Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3516bafdc161c744(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 2C16.7467 2 21 6.25329 21 11.5C21 13.0291 20.6387 14.4739 19.9969 15.7536L22.4602 18.2175C22.8507 18.608 22.8507 19.2412 22.4602 19.6317L19.6317 22.4602C19.2412 22.8507 18.608 22.8507 18.2175 22.4602L15.7536 19.9969C14.4739 20.6387 13.0291 21 11.5 21C6.25329 21 2 16.7467 2 11.5C2 6.25329 6.25329 2 11.5 2ZM16.8033 15.3877L15.3891 16.8019L18.9246 20.3375L20.3388 18.9233L16.8033 15.3877ZM18.6669 9.28305L9.28305 18.6669C9.98371 18.8834 10.7282 19 11.5 19C12.4671 19 13.3914 18.817 14.2403 18.4836L13.2678 17.5104C12.8772 17.1199 12.8772 16.4867 13.2678 16.0962L16.0962 13.2678C16.4867 12.8772 17.1199 12.8772 17.5104 13.2678L18.4836 14.2403C18.817 13.3914 19 12.4671 19 11.5C19 10.7282 18.8834 9.98371 18.6669 9.28305ZM11.5 4C7.35786 4 4 7.35786 4 11.5C4 14.1135 5.3368 16.4148 7.36394 17.7574L17.7574 7.36394C16.4148 5.3368 14.1135 4 11.5 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$23661d53ba2c6c0f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.998 3V5C20.998 8.86599 17.864 12 13.998 12H12.998V13H17.998V20C17.998 21.1046 17.1026 22 15.998 22H7.99805C6.89348 22 5.99805 21.1046 5.99805 20V13H10.998V10C10.998 6.13401 14.1321 3 17.998 3H20.998ZM5.49805 2C8.02667 2 10.263 3.25136 11.6216 5.1686C10.6026 6.51084 9.99805 8.18482 9.99805 10V11H9.49805C5.35591 11 1.99805 7.64214 1.99805 3.5V2H5.49805Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3c3e19695c5ab101(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.99805 2C8.68733 2 11.0224 3.51653 12.1947 5.74104C13.372 4.08252 15.3086 3 17.498 3H20.998V5.5C20.998 9.08985 18.0879 12 14.498 12H12.998V13H17.998V20C17.998 21.1046 17.1026 22 15.998 22H7.99805C6.89348 22 5.99805 21.1046 5.99805 20V13H10.998V11H8.99805C5.13205 11 1.99805 7.86599 1.99805 4V2H5.99805ZM15.998 15H7.99805V20H15.998V15ZM18.998 5H17.498C15.0128 5 12.998 7.01472 12.998 9.5V10H14.498C16.9833 10 18.998 7.98528 18.998 5.5V5ZM5.99805 4H3.99805C3.99805 6.76142 6.23662 9 8.99805 9H10.998C10.998 6.23858 8.75947 4 5.99805 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e5d263edd1cb1b1c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18V20H19V22H13C11.8954 22 11 21.1046 11 20V18H8C5.79086 18 4 16.2091 4 14V10H20V14C20 16.2091 18.2091 18 16 18H13ZM17 6H19C19.5523 6 20 6.44772 20 7V9H4V7C4 6.44772 4.44772 6 5 6H7V2H9V6H15V2H17V6ZM12 14.5C12.5523 14.5 13 14.0523 13 13.5C13 12.9477 12.5523 12.5 12 12.5C11.4477 12.5 11 12.9477 11 13.5C11 14.0523 11.4477 14.5 12 14.5ZM11 2H13V5H11V2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$76191ebc1f2ebee4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18V20H19V22H13C11.8954 22 11 21.1046 11 20V18H8C5.79086 18 4 16.2091 4 14V7C4 6.44772 4.44772 6 5 6H7V2H9V6H15V2H17V6H19C19.5523 6 20 6.44772 20 7V14C20 16.2091 18.2091 18 16 18H13ZM8 16H16C17.1046 16 18 15.1046 18 14V11H6V14C6 15.1046 6.89543 16 8 16ZM18 8H6V9H18V8ZM12 14.5C11.4477 14.5 11 14.0523 11 13.5C11 12.9477 11.4477 12.5 12 12.5C12.5523 12.5 13 12.9477 13 13.5C13 14.0523 12.5523 14.5 12 14.5ZM11 2H13V5H11V2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$db71d715697dec18(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18V20H19V22H13C11.8954 22 11 21.1046 11 20V18H8C5.79086 18 4 16.2091 4 14V10H20V14C20 16.2091 18.2091 18 16 18H13ZM16 6H19C19.5523 6 20 6.44772 20 7V9H4V7C4 6.44772 4.44772 6 5 6H8V2H10V6H14V2H16V6ZM12 14.5C12.5523 14.5 13 14.0523 13 13.5C13 12.9477 12.5523 12.5 12 12.5C11.4477 12.5 11 12.9477 11 13.5C11 14.0523 11.4477 14.5 12 14.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4fabc6603ab13511(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18V20H19V22H13C11.8954 22 11 21.1046 11 20V18H8C5.79086 18 4 16.2091 4 14V7C4 6.44772 4.44772 6 5 6H8V2H10V6H14V2H16V6H19C19.5523 6 20 6.44772 20 7V14C20 16.2091 18.2091 18 16 18H13ZM8 16H16C17.1046 16 18 15.1046 18 14V11H6V14C6 15.1046 6.89543 16 8 16ZM18 8H6V9H18V8ZM12 14.5C11.4477 14.5 11 14.0523 11 13.5C11 12.9477 11.4477 12.5 12 12.5C12.5523 12.5 13 12.9477 13 13.5C13 14.0523 12.5523 14.5 12 14.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1efedb2a8a563e36(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5611 12.0985L21.0926 14.7501C22.0591 16.4241 21.4855 18.5647 19.8115 19.5312C19.2794 19.8384 18.6759 20.0001 18.0615 20.0001L15.9993 19.9995V22.0001L10.9993 18.5001L15.9993 15.0001V16.9995L18.0615 17.0001C18.1493 17.0001 18.2355 16.977 18.3115 16.9331C18.5241 16.8104 18.6124 16.5551 18.5325 16.332L18.4945 16.2501L16.9631 13.5985L19.5611 12.0985ZM7.73617 9.38407L8.26726 15.4642L6.53571 14.4645L5.50412 16.2501C5.46023 16.3261 5.43713 16.4123 5.43713 16.5001C5.43713 16.7456 5.614 16.9497 5.84725 16.992L5.93713 17.0001L8.99919 16.9997V19.9996L5.93713 20.0001C4.00413 20.0001 2.43713 18.4331 2.43713 16.5001C2.43713 15.8857 2.59885 15.2822 2.90604 14.7501L3.93763 12.9645L2.20508 11.9642L7.73617 9.38407ZM13.7493 2.96901C14.2814 3.2762 14.7232 3.71803 15.0304 4.2501L16.061 6.03629L17.7935 5.03599L17.2624 11.1161L11.7314 8.53599L13.4629 7.53629L12.4323 5.7501C12.3884 5.67409 12.3253 5.61097 12.2493 5.56708C12.0367 5.44435 11.7715 5.49546 11.6182 5.67629L11.5663 5.7501L10.0356 8.40209L7.4376 6.90216L8.96822 4.2501C9.93472 2.57607 12.0753 2.00251 13.7493 2.96901Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d117a177d8d5ef24(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5605 12.0975L21.092 14.7501C22.0585 16.4241 21.4849 18.5647 19.8109 19.5312C19.2788 19.8384 18.6753 20.0001 18.0609 20.0001L15.9985 19.9995L15.9987 22.5001L10.9987 19.0001L15.9987 15.5001L15.9985 17.9995L18.0609 18.0001C18.3242 18.0001 18.5829 17.9308 18.8109 17.7991C19.5283 17.3849 19.7742 16.4675 19.3599 15.7501L17.8285 13.0975L19.5605 12.0975ZM7.30257 9.13407L7.83366 15.2142L5.66848 13.9635L4.63751 15.7501C4.50586 15.9781 4.43655 16.2368 4.43655 16.5001C4.43655 17.3285 5.10812 18.0001 5.93655 18.0001L8.99948 18.0002V20.0001H5.93655C4.00355 20.0001 2.43655 18.4331 2.43655 16.5001C2.43655 15.8857 2.59827 15.2822 2.90546 14.7501L3.93648 12.9635L1.77148 11.7142L7.30257 9.13407ZM13.7487 2.96901C14.2808 3.2762 14.7226 3.71803 15.0298 4.2501L16.0605 6.03551L18.226 4.78599L17.6949 10.8661L12.1638 8.28599L14.3285 7.03551L13.2978 5.2501C13.1661 5.02207 12.9768 4.83271 12.7487 4.70106C12.0313 4.28684 11.1139 4.53266 10.6997 5.2501L9.16818 7.90261L7.43615 6.90266L8.96764 4.2501C9.93414 2.57607 12.0747 2.00251 13.7487 2.96901Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$88f67e36b7f4d0a8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 15V19H16V21H8V19H11V15H4C3.44772 15 3 14.5523 3 14V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V14C21 14.5523 20.5523 15 20 15H13ZM8 8V10H16V8H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5fef18b22b0312b2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 15V19H16V21H8V19H11V15H4C3.44772 15 3 14.5523 3 14V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V14C21 14.5523 20.5523 15 20 15H13ZM5 13H19V5H5V13ZM8 8H16V10H8V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d706a0ef3cf3d1c4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.99805 2C5.99805 2.51284 6.48805 3 6.99805 3H16.998C17.5109 3 17.998 2.51 17.998 2H19.998C19.998 3.65685 18.6549 5 16.998 5H12.998L12.999 7.06201C16.9449 7.55453 19.998 10.9207 19.998 15V21C19.998 21.5523 19.5503 22 18.998 22H4.99805C4.44576 22 3.99805 21.5523 3.99805 21V15C3.99805 10.9204 7.05176 7.55396 10.9981 7.06189L10.998 5H6.99805C5.33805 5 3.99805 3.66 3.99805 2H5.99805ZM11.998 11C9.78891 11 7.99805 12.7909 7.99805 15C7.99805 17.2091 9.78891 19 11.998 19C14.2072 19 15.998 17.2091 15.998 15C15.998 14.2582 15.7961 13.5635 15.4442 12.968L12.7052 15.7071L12.6109 15.7903C12.2187 16.0953 11.6514 16.0676 11.2909 15.7071C10.9004 15.3166 10.9004 14.6834 11.2909 14.2929L14.03 11.5538C13.4345 11.2019 12.7399 11 11.998 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4414b18bd1004959(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.99805 2C5.99805 2.51284 6.48805 3 6.99805 3H16.998C17.5109 3 17.998 2.51 17.998 2H19.998C19.998 3.65685 18.6549 5 16.998 5H12.998L12.999 7.06201C16.9449 7.55453 19.998 10.9207 19.998 15V21C19.998 21.5523 19.5503 22 18.998 22H4.99805C4.44576 22 3.99805 21.5523 3.99805 21V15C3.99805 10.9204 7.05176 7.55396 10.9981 7.06189L10.998 5H6.99805C5.33805 5 3.99805 3.66 3.99805 2H5.99805ZM11.998 9C8.75965 9 5.99805 11.76 5.99805 15V20H17.998V15C17.998 11.7616 15.2364 9 11.998 9ZM11.998 11C12.7399 11 13.4345 11.2019 14.03 11.5538L11.2909 14.2929C10.9004 14.6834 10.9004 15.3166 11.2909 15.7071C11.6514 16.0676 12.2187 16.0953 12.6109 15.7903L12.7052 15.7071L15.4442 12.968C15.7961 13.5635 15.998 14.2582 15.998 15C15.998 17.2091 14.2072 19 11.998 19C9.78891 19 7.99805 17.2091 7.99805 15C7.99805 12.7909 9.78891 11 11.998 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bd8acc3976be18e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9985 2L12.9979 3.278L17.9985 4.94591L21.631 3.73509L22.2634 5.63246L19.2319 6.643L22.3272 15.1549C21.2353 16.2921 19.6996 17 17.9985 17C16.2975 17 14.7618 16.2921 13.6699 15.1549L16.7639 6.643L12.9979 5.387V19H16.9985V21H6.99854V19H10.9979V5.387L7.23192 6.643L10.3272 15.1549C9.23528 16.2921 7.69957 17 5.99854 17C4.2975 17 2.76179 16.2921 1.66992 15.1549L4.76392 6.643L1.73363 5.63246L2.36608 3.73509L5.99854 4.94591L10.9979 3.278L10.9985 2H12.9985ZM17.9985 9.10267L16.5809 13H19.4159L17.9985 9.10267ZM5.99854 9.10267L4.58092 13H7.41592L5.99854 9.10267Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ed05672451fe5940(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9985 2L12.9979 3.278L17.9985 4.94591L21.631 3.73509L22.2634 5.63246L19.2319 6.643L22.3272 15.1549C21.2353 16.2921 19.6996 17 17.9985 17C16.2975 17 14.7618 16.2921 13.6699 15.1549L16.7639 6.643L12.9979 5.387V19H16.9985V21H6.99854V19H10.9979V5.387L7.23192 6.643L10.3272 15.1549C9.23528 16.2921 7.69957 17 5.99854 17C4.2975 17 2.76179 16.2921 1.66992 15.1549L4.76392 6.643L1.73363 5.63246L2.36608 3.73509L5.99854 4.94591L10.9979 3.278L10.9985 2H12.9985ZM17.9985 9.10267L16.04 14.4892C16.628 14.8201 17.2979 15 17.9985 15C18.6992 15 19.3691 14.8201 19.957 14.4892L17.9985 9.10267ZM5.99854 9.10267L4.04004 14.4892C4.62795 14.8201 5.29792 15 5.99854 15C6.69916 15 7.36912 14.8201 7.95703 14.4892L5.99854 9.10267Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$13a70c7d80d80d7a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.998 2V3H19.998V5H12.998V19H16.998V21H6.99805V19H10.998V5H3.99805V3H10.998V2H12.998ZM4.99805 6.34315L7.82647 9.17157C8.55033 9.89543 8.99805 10.8954 8.99805 12C8.99805 14.2091 7.20719 16 4.99805 16C2.78891 16 0.998047 14.2091 0.998047 12C0.998047 10.8954 1.44576 9.89543 2.16962 9.17157L4.99805 6.34315ZM18.998 6.34315L21.8265 9.17157C22.5503 9.89543 22.998 10.8954 22.998 12C22.998 14.2091 21.2072 16 18.998 16C16.7889 16 14.998 14.2091 14.998 12C14.998 10.8954 15.4458 9.89543 16.1696 9.17157L18.998 6.34315ZM18.998 9.17157L17.5838 10.5858C17.2099 10.9597 16.998 11.4606 16.998 12L20.998 12.001C20.998 11.4606 20.7862 10.9597 20.4123 10.5858L18.998 9.17157ZM4.99805 9.17157L3.58383 10.5858C3.20988 10.9597 2.99805 11.4606 2.99805 12L6.99805 12.001C6.99805 11.4606 6.78621 10.9597 6.41226 10.5858L4.99805 9.17157Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9655f948a34b14da(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.998 2V3H19.998V5H12.998V19H16.998V21H6.99805V19H10.998V5H3.99805V3H10.998V2H12.998ZM4.99805 6.34315L7.82647 9.17157C8.55033 9.89543 8.99805 10.8954 8.99805 12C8.99805 14.2091 7.20719 16 4.99805 16C2.78891 16 0.998047 14.2091 0.998047 12C0.998047 10.8954 1.44576 9.89543 2.16962 9.17157L4.99805 6.34315ZM18.998 6.34315L21.8265 9.17157C22.5503 9.89543 22.998 10.8954 22.998 12C22.998 14.2091 21.2072 16 18.998 16C16.7889 16 14.998 14.2091 14.998 12C14.998 10.8954 15.4458 9.89543 16.1696 9.17157L18.998 6.34315ZM4.99805 9.17157L3.58383 10.5858C3.20988 10.9597 2.99805 11.4606 2.99805 12C2.99805 13.1046 3.89348 14 4.99805 14C6.10262 14 6.99805 13.1046 6.99805 12C6.99805 11.4606 6.78621 10.9597 6.41226 10.5858L4.99805 9.17157ZM18.998 9.17157L17.5838 10.5858C17.2099 10.9597 16.998 11.4606 16.998 12C16.998 13.1046 17.8935 14 18.998 14C20.1026 14 20.998 13.1046 20.998 12C20.998 11.4606 20.7862 10.9597 20.4123 10.5858L18.998 9.17157Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$39cc64950c348f15(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.998 7V9.5C21.998 13.0899 19.0879 16 15.498 16H12.998V21H10.998V14L11.0169 13.0007C11.2719 9.64413 14.0762 7 17.498 7H21.998ZM5.99805 3C9.0904 3 11.7144 5.00519 12.6408 7.78626C11.1417 9.06119 10.1516 10.9143 10.0144 13.0004L8.99805 13C5.13205 13 1.99805 9.86599 1.99805 6V3H5.99805Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3ade1deda0fc1e14(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.99805 3C9.48787 3 12.3812 5.55379 12.9112 8.8945C14.0863 7.72389 15.7076 7 17.498 7H21.998V9.5C21.998 13.0899 19.0879 16 15.498 16H12.998V21H10.998V13H8.99805C5.13205 13 1.99805 9.86599 1.99805 6V3H5.99805ZM19.998 9H17.498C15.0128 9 12.998 11.0147 12.998 13.5V14H15.498C17.9833 14 19.998 11.9853 19.998 9.5V9ZM5.99805 5H3.99805V6C3.99805 8.76142 6.23662 11 8.99805 11H10.998V10C10.998 7.23858 8.75947 5 5.99805 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$de9edc51dac2bb79(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.99805 4V11L11.998 8.5L16.998 11V4H19.998C20.5503 4 20.998 4.44772 20.998 5V21C20.998 21.5523 20.5503 22 19.998 22H3.99805C3.44576 22 2.99805 21.5523 2.99805 21V5C2.99805 4.44772 3.44576 4 3.99805 4H6.99805ZM11.998 8L7.49805 3H16.498L11.998 8ZM12.998 11.2361L11.998 10.7361L10.998 11.2361V20H12.998V11.2361ZM14.998 14V16H18.998V14H14.998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8278e64599456e1e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.998 20H18.998V16H14.998V14H18.998V6H16.998V11L12.998 9.4V20ZM10.998 20V9.4L6.99805 11V6H4.99805V20H10.998ZM6.99805 4V3H16.998V4H19.998C20.5503 4 20.998 4.44772 20.998 5V21C20.998 21.5523 20.5503 22 19.998 22H3.99805C3.44576 22 2.99805 21.5523 2.99805 21V5C2.99805 4.44772 3.44576 4 3.99805 4H6.99805ZM11.998 8L15.498 5H8.49805L11.998 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b7410df3f3c8f3b6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.04813 13.4061L10.5831 16.9421L9.1703 18.3558L10.5849 19.7711L9.17064 21.1853L6.69614 18.71L3.86734 21.5388L2.45312 20.1246L5.28192 17.2958L2.80668 14.8213L4.22089 13.4071L5.63477 14.8202L7.04813 13.4061ZM2.99907 3L6.54506 3.00335L18.3624 14.8207L19.7772 13.4071L21.1915 14.8213L18.7166 17.2962L21.545 20.1246L20.1308 21.5388L17.3024 18.7104L14.8275 21.1853L13.4133 19.7711L14.8269 18.3562L3.00181 6.53118L2.99907 3ZM17.4563 3.0001L20.9991 3.00335L21.001 6.52648L16.9481 10.5781L13.4121 7.0431L17.4563 3.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2b88060dc283d6d6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.4563 3L20.9991 3.00335L21.001 6.52648L15.5341 11.992L18.3624 14.8207L19.7772 13.4071L21.1915 14.8213L18.7166 17.2962L21.545 20.1246L20.1308 21.5388L17.3024 18.7104L14.8275 21.1853L13.4133 19.7711L14.8269 18.3562L11.9981 15.528L9.1703 18.3558L10.5849 19.7711L9.17064 21.1853L6.69614 18.71L3.86734 21.5388L2.45312 20.1246L5.28192 17.2958L2.80668 14.8213L4.22089 13.4071L5.63477 14.8202L8.46212 11.992L3.00181 6.53118L2.99907 3L6.54506 3.00335L11.9981 8.457L17.4563 3ZM9.87612 13.406L7.04807 16.234L7.75607 16.941L10.5831 14.113L9.87612 13.406ZM19.0001 5.001H18.2831L13.4121 9.87L14.1191 10.577L19.0001 5.698V5.001ZM5.00007 5.001V5.701L16.2411 16.942L16.9482 16.2349L5.71507 5.002L5.00007 5.001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3e59243510c1de72(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.998 3C21.5503 3 21.998 3.44772 21.998 4V11C21.998 11.5523 21.5503 12 20.998 12H18.997L18.998 20C18.998 20.5523 18.5503 21 17.998 21H5.99805C5.44576 21 4.99805 20.5523 4.99805 20L4.99705 11.999L2.99805 12C2.44576 12 1.99805 11.5523 1.99805 11V4C1.99805 3.44772 2.44576 3 2.99805 3H8.99805C8.99805 4.65685 10.3412 6 11.998 6C13.6549 6 14.998 4.65685 14.998 3H20.998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9f36bc6684cdaa9e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.99805 3C8.99805 4.65685 10.3412 6 11.998 6C13.6549 6 14.998 4.65685 14.998 3H20.998C21.5503 3 21.998 3.44772 21.998 4V11C21.998 11.5523 21.5503 12 20.998 12H18.997L18.998 20C18.998 20.5523 18.5503 21 17.998 21H5.99805C5.44576 21 4.99805 20.5523 4.99805 20L4.99705 11.999L2.99805 12C2.44576 12 1.99805 11.5523 1.99805 11V4C1.99805 3.44772 2.44576 3 2.99805 3H8.99805ZM19.998 4.999H16.581L16.5642 5.04018C15.8115 6.7223 14.1566 7.91251 12.2149 7.99538L11.998 8C9.96331 8 8.21245 6.7846 7.43186 5.04018L7.41405 4.999H3.99805V9.999L6.9968 9.998L6.99705 19H16.998L16.9968 10L19.998 9.999V4.999Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$efc069d99df032e9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.7052 17.7929C13.5319 18.6197 14.2926 19 14.998 19C15.3763 19 15.6782 18.9326 16.2349 18.724L16.6267 18.5715C17.6779 18.151 18.2065 18 18.998 18C20.2117 18 21.3768 18.5446 22.4844 19.5794L22.7052 19.7929L21.2909 21.2071C20.4642 20.3803 19.7035 20 18.998 20C18.6198 20 18.3179 20.0674 17.7612 20.276L17.3694 20.4285C16.3182 20.849 15.7896 21 14.998 21C13.7844 21 12.6193 20.4554 11.5117 19.4206L11.2909 19.2071L12.7052 17.7929ZM8.99805 3C8.99805 4.65685 10.3412 6 11.998 6C13.6549 6 14.998 4.65685 14.998 3H20.998C21.5503 3 21.998 3.44772 21.998 4V11C21.998 11.5523 21.5503 12 20.998 12H11.998C10.9437 12 10.0799 12.8159 10.0035 13.8507L9.99805 14V21H5.99805C5.44576 21 4.99805 20.5523 4.99805 20L4.99705 11.999L2.99805 12C2.44576 12 1.99805 11.5523 1.99805 11V4C1.99805 3.44772 2.44576 3 2.99805 3H8.99805ZM12.7052 13.7929C13.5319 14.6197 14.2926 15 14.998 15C15.3763 15 15.6782 14.9326 16.2349 14.724L16.6267 14.5715C17.6779 14.151 18.2065 14 18.998 14C20.2117 14 21.3768 14.5446 22.4844 15.5794L22.7052 15.7929L21.2909 17.2071C20.4642 16.3803 19.7035 16 18.998 16C18.6198 16 18.3179 16.0674 17.7612 16.276L17.3694 16.4285C16.3182 16.849 15.7896 17 14.998 17C13.7844 17 12.6193 16.4554 11.5117 15.4206L11.2909 15.2071L12.7052 13.7929Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dac48c64c9b912f4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.7052 17.7929C13.5319 18.6197 14.2926 19 14.998 19C15.3763 19 15.6782 18.9326 16.2349 18.724L16.6267 18.5715C17.6779 18.151 18.2065 18 18.998 18C20.2117 18 21.3768 18.5446 22.4844 19.5794L22.7052 19.7929L21.2909 21.2071C20.4642 20.3803 19.7035 20 18.998 20C18.6198 20 18.3179 20.0674 17.7612 20.276L17.3694 20.4285C16.3182 20.849 15.7896 21 14.998 21C13.7844 21 12.6193 20.4554 11.5117 19.4206L11.2909 19.2071L12.7052 17.7929ZM8.99805 3C8.99805 4.65685 10.3412 6 11.998 6C13.6549 6 14.998 4.65685 14.998 3H20.998C21.5503 3 21.998 3.44772 21.998 4V11C21.998 11.5523 21.5503 12 20.998 12H16.996L16.9968 10L19.998 9.999V4.999H16.581L16.5642 5.04018C15.8115 6.7223 14.1566 7.91251 12.2149 7.99538L11.998 8C9.96331 8 8.21245 6.7846 7.43186 5.04018L7.41405 4.999H3.99805V9.999L6.9968 9.998L6.99705 19H9.99805V21H5.99805C5.44576 21 4.99805 20.5523 4.99805 20L4.99705 11.999L2.99805 12C2.44576 12 1.99805 11.5523 1.99805 11V4C1.99805 3.44772 2.44576 3 2.99805 3H8.99805ZM12.7052 13.7929C13.5319 14.6197 14.2926 15 14.998 15C15.3763 15 15.6782 14.9326 16.2349 14.724L16.6267 14.5715C17.6779 14.151 18.2065 14 18.998 14C20.2117 14 21.3768 14.5446 22.4844 15.5794L22.7052 15.7929L21.2909 17.2071C20.4642 16.3803 19.7035 16 18.998 16C18.6198 16 18.3179 16.0674 17.7612 16.276L17.3694 16.4285C16.3182 16.849 15.7896 17 14.998 17C13.7844 17 12.6193 16.4554 11.5117 15.4206L11.2909 15.2071L12.7052 13.7929Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2c05f1465f236031(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5135 5.00008L17.1201 2.39348C17.5106 2.00295 18.1438 2.00295 18.5343 2.39348L22.777 6.63612C23.1675 7.02664 23.1675 7.65981 22.777 8.05033L18.9988 11.8285V21.0001C18.9988 21.5524 18.5511 22.0001 17.9988 22.0001H5.9988C5.44652 22.0001 4.9988 21.5524 4.9988 21.0001V11.8285L1.22063 8.05033C0.830103 7.65981 0.830103 7.02664 1.22063 6.63612L5.46327 2.39348C5.85379 2.00295 6.48696 2.00295 6.87748 2.39348L9.48408 5.00008H14.5135Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$570f764d0b682e0d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5135 5.00008L17.1201 2.39348C17.5106 2.00295 18.1438 2.00295 18.5343 2.39348L22.777 6.63612C23.1675 7.02664 23.1675 7.65981 22.777 8.05033L18.9988 11.8285V21.0001C18.9988 21.5524 18.5511 22.0001 17.9988 22.0001H5.9988C5.44652 22.0001 4.9988 21.5524 4.9988 21.0001V11.8285L1.22063 8.05033C0.830103 7.65981 0.830103 7.02664 1.22063 6.63612L5.46327 2.39348C5.85379 2.00295 6.48696 2.00295 6.87748 2.39348L9.48408 5.00008H14.5135ZM15.3419 7.00008H8.65566L6.17037 4.5148L3.34195 7.34323L6.9988 11.0001V20.0001H16.9988V11.0001L20.6557 7.34323L17.8272 4.5148L15.3419 7.00008Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e5de3d34ed55bbe2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7C18 7.2624 17.9832 7.52086 17.9505 7.77437C19.7712 8.80457 21 10.7588 21 13C21 16.3137 18.3137 19 15 19C14.2987 19 13.6256 18.8797 13 18.6586V22H11V18.4003C10.2499 18.7837 9.40022 19 8.5 19C5.46243 19 3 16.5376 3 13.5C3 12.0474 3.56312 10.7263 4.48297 9.74318C4.87725 10.8232 5.49744 11.7944 6.28576 12.5989L7.71424 11.1991C6.99071 10.4607 6.45705 9.53767 6.1906 8.50688C6.06607 8.02541 6 7.5204 6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$daf7bc98ed22a8d6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7C18 7.26214 17.9831 7.5207 17.9504 7.77457C19.77 8.80413 21 10.7575 21 13C21 16.3137 18.3137 19 15 19H13V22H11V19H8.5C5.46243 19 3 16.5376 3 13.5C3 11.2863 4.30712 9.37966 6.19098 8.50704C6.06635 8.02551 6 7.52039 6 7ZM7.00964 10.3319C5.82176 10.8918 5 12.1008 5 13.5C5 15.433 6.567 17 8.5 17H15C17.2091 17 19 15.2091 19 13C19 11.3056 17.9461 9.85488 16.4544 9.27234L15.6129 8.94372C15.7907 8.30337 16 7.67183 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 8.30783 8.6266 9.46903 9.60019 10.2005L8.39884 11.7995C7.85767 11.3929 7.38716 10.8963 7.00964 10.3319Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1b2796781324cace(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.998 2.04938C18.0514 2.5511 21.998 6.81465 21.998 12V13H12.998V19C12.998 20.1046 13.8935 21 14.998 21C16.1026 21 16.998 20.1046 16.998 19V18H18.998V19C18.998 21.2091 17.2072 23 14.998 23C12.7889 23 10.998 21.2091 10.998 19V13H1.99805V12C1.99805 6.81465 5.94472 2.5511 10.998 2.04938V2C10.998 1.44772 11.4458 1 11.998 1C12.5503 1 12.998 1.44772 12.998 2V2.04938Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$62be46a6d313ee66(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.998 2.04938C18.0514 2.5511 21.998 6.81465 21.998 12V13H12.998V19C12.998 20.1046 13.8935 21 14.998 21C16.1026 21 16.998 20.1046 16.998 19V18H18.998V19C18.998 21.2091 17.2072 23 14.998 23C12.7889 23 10.998 21.2091 10.998 19V13H1.99805V12C1.99805 6.81465 5.94472 2.5511 10.998 2.04938V2C10.998 1.44772 11.4458 1 11.998 1C12.5503 1 12.998 1.44772 12.998 2V2.04938ZM19.9362 11C19.4441 7.05369 16.0777 4 11.998 4C7.91843 4 4.55204 7.05369 4.05994 11H19.9362Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ebfda495cf83fd39(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.998 3V21H2.99805V3H20.998ZM12.998 6H10.998V18H12.998V6ZM8.99805 9H6.99805V15H8.99805V9ZM16.998 9H14.998V15H16.998V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8b7fef8e579e97df(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.99805 15V19H8.99805V21H2.99805V15H4.99805ZM20.998 15V21H14.998V19H18.998V15H20.998ZM12.998 6V18H10.998V6H12.998ZM8.99805 9V15H6.99805V9H8.99805ZM16.998 9V15H14.998V9H16.998ZM8.99805 3V5H4.99805V9H2.99805V3H8.99805ZM20.998 3V9H18.998V5H14.998V3H20.998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ed38915a0ff54feb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.99837 10.3413L7.99793 12.5352C6.80239 13.2268 5.99805 14.5195 5.99805 16C5.99805 18.2091 7.78891 20 9.99805 20C11.4786 20 12.7712 19.1957 13.4628 18.0001L15.6565 18.0004C14.8327 20.3306 12.6103 22 9.99805 22C6.68434 22 3.99805 19.3137 3.99805 16C3.99805 13.3874 5.66782 11.1649 7.99837 10.3413ZM11.998 17C10.3412 17 8.99805 15.6569 8.99805 14V10C8.99805 8.34315 10.3412 7 11.998 7C13.6549 7 14.998 8.34315 14.998 10V15H16.4319C17.0803 15 17.6849 15.3141 18.0584 15.8362L18.1468 15.971L20.8555 20.4855L19.1406 21.5145L16.4319 17H11.998ZM11.998 2C13.3788 2 14.498 3.11929 14.498 4.5C14.498 5.88071 13.3788 7 11.998 7C10.6173 7 9.49805 5.88071 9.49805 4.5C9.49805 3.11929 10.6173 2 11.998 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1565976d4c6890ce(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.99837 10.3413L7.99793 12.5352C6.80239 13.2268 5.99805 14.5195 5.99805 16C5.99805 18.2091 7.78891 20 9.99805 20C11.4786 20 12.7712 19.1957 13.4628 18.0001L15.6565 18.0004C14.8327 20.3306 12.6103 22 9.99805 22C6.68434 22 3.99805 19.3137 3.99805 16C3.99805 13.3874 5.66782 11.1649 7.99837 10.3413ZM11.998 17C10.3412 17 8.99805 15.6569 8.99805 14V10C8.99805 8.95561 9.53172 8.03587 10.3412 7.49861C9.53172 6.96413 8.99805 6.04439 8.99805 5C8.99805 3.34315 10.3412 2 11.998 2C13.6549 2 14.998 3.34315 14.998 5C14.998 6.04439 14.4644 6.96413 13.6548 7.50139C14.4644 8.03587 14.998 8.95561 14.998 10V14.999L16.4319 15C17.0803 15 17.6849 15.3141 18.0584 15.8362L18.1468 15.971L20.8555 20.4855L19.1406 21.5145L16.4319 17L14.998 16.999L11.998 17ZM11.998 9C11.4458 9 10.998 9.44772 10.998 10V14C10.998 14.5523 11.4458 15 11.998 15H12.997L12.998 10C12.998 9.44772 12.5503 9 11.998 9ZM11.998 4C11.4458 4 10.998 4.44772 10.998 5C10.998 5.55228 11.4458 6 11.998 6C12.5503 6 12.998 5.55228 12.998 5C12.998 4.44772 12.5503 4 11.998 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b8f1240c46d256d3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM11 11H7V13H11V17H13V13H17V11H13V7H11V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d2f8c045c4aef5ba(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5ZM11 11V7H13V11H17V13H13V17H11V13H7V11H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c364e52de6a65ba5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 11H7V13H11V17H13V13H17V11H13V7H11V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1e6c614bb2ee2792(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11V7H13V11H17V13H13V17H11V13H7V11H11ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8afc288b7bc4e3b1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dec92e8fdf71066a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8608045c3cfdf05b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9991 22.0001C7.02858 22.0001 2.99914 17.9707 2.99914 13.0001C2.99914 8.02956 7.02858 4.00012 11.9991 4.00012C16.9697 4.00012 20.9991 8.02956 20.9991 13.0001C20.9991 17.9707 16.9697 22.0001 11.9991 22.0001ZM12.9991 13.0001V8.00012H10.9991V15.0001H15.9991V13.0001H12.9991ZM1.74609 6.2826L5.28163 2.74707L6.69584 4.16128L3.16031 7.69682L1.74609 6.2826ZM18.7167 2.74707L22.2522 6.2826L20.838 7.69682L17.3024 4.16128L18.7167 2.74707Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2dac06e1cd3b1fb5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9991 22.0001C7.02858 22.0001 2.99914 17.9707 2.99914 13.0001C2.99914 8.02956 7.02858 4.00012 11.9991 4.00012C16.9697 4.00012 20.9991 8.02956 20.9991 13.0001C20.9991 17.9707 16.9697 22.0001 11.9991 22.0001ZM11.9991 20.0001C15.8651 20.0001 18.9991 16.8661 18.9991 13.0001C18.9991 9.13412 15.8651 6.00012 11.9991 6.00012C8.13315 6.00012 4.99914 9.13412 4.99914 13.0001C4.99914 16.8661 8.13315 20.0001 11.9991 20.0001ZM12.9991 13.0001H15.9991V15.0001H10.9991V8.00012H12.9991V13.0001ZM1.74609 6.2826L5.28163 2.74707L6.69584 4.16128L3.16031 7.69682L1.74609 6.2826ZM18.7167 2.74707L22.2522 6.2826L20.838 7.69682L17.3024 4.16128L18.7167 2.74707Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$37af340e728a15a4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.00098 20V14C4.00098 9.58172 7.5827 6 12.001 6C16.4193 6 20.001 9.58172 20.001 14V20H21.001V22H3.00098V20H4.00098ZM6.00098 14H8.00098C8.00098 11.7909 9.79184 10 12.001 10V8C8.68727 8 6.00098 10.6863 6.00098 14ZM11.001 2H13.001V5H11.001V2ZM19.7792 4.80761L21.1934 6.22183L19.0721 8.34315L17.6578 6.92893L19.7792 4.80761ZM2.80859 6.22183L4.22281 4.80761L6.34413 6.92893L4.92991 8.34315L2.80859 6.22183Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bb317cf431f982e3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.00098 20V14C4.00098 9.58172 7.5827 6 12.001 6C16.4193 6 20.001 9.58172 20.001 14V20H21.001V22H3.00098V20H4.00098ZM6.00098 20H18.001V14C18.001 10.6863 15.3147 8 12.001 8C8.68727 8 6.00098 10.6863 6.00098 14V20ZM11.001 2H13.001V5H11.001V2ZM19.7792 4.80761L21.1934 6.22183L19.0721 8.34315L17.6578 6.92893L19.7792 4.80761ZM2.80859 6.22183L4.22281 4.80761L6.34413 6.92893L4.92991 8.34315L2.80859 6.22183ZM7.00098 14C7.00098 11.2386 9.23956 9 12.001 9V11C10.3441 11 9.00098 12.3431 9.00098 14H7.00098Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$21b8c77aba1d2a3a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.865 3.00017L22.3912 19.5002C22.6674 19.9785 22.5035 20.5901 22.0252 20.8662C21.8732 20.954 21.7008 21.0002 21.5252 21.0002H2.47266C1.92037 21.0002 1.47266 20.5525 1.47266 20.0002C1.47266 19.8246 1.51886 19.6522 1.60663 19.5002L11.1329 3.00017C11.4091 2.52187 12.0206 2.358 12.4989 2.63414C12.651 2.72191 12.7772 2.84815 12.865 3.00017ZM10.9989 16.0002V18.0002H12.9989V16.0002H10.9989ZM10.9989 9.00017V14.0002H12.9989V9.00017H10.9989Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2879b4aba9345d49(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.865 3.00017L22.3912 19.5002C22.6674 19.9785 22.5035 20.5901 22.0252 20.8662C21.8732 20.954 21.7008 21.0002 21.5252 21.0002H2.47266C1.92037 21.0002 1.47266 20.5525 1.47266 20.0002C1.47266 19.8246 1.51886 19.6522 1.60663 19.5002L11.1329 3.00017C11.4091 2.52187 12.0206 2.358 12.4989 2.63414C12.651 2.72191 12.7772 2.84815 12.865 3.00017ZM4.20471 19.0002H19.7932L11.9989 5.50017L4.20471 19.0002ZM10.9989 16.0002H12.9989V18.0002H10.9989V16.0002ZM10.9989 9.00017H12.9989V14.0002H10.9989V9.00017Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1d7155c96266b45a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11.5C4.51472 11.5 2.5 9.48528 2.5 7C2.5 4.51472 4.51472 2.5 7 2.5C9.48528 2.5 11.5 4.51472 11.5 7C11.5 9.48528 9.48528 11.5 7 11.5ZM7 21.5C4.51472 21.5 2.5 19.4853 2.5 17C2.5 14.5147 4.51472 12.5 7 12.5C9.48528 12.5 11.5 14.5147 11.5 17C11.5 19.4853 9.48528 21.5 7 21.5ZM17 11.5C14.5147 11.5 12.5 9.48528 12.5 7C12.5 4.51472 14.5147 2.5 17 2.5C19.4853 2.5 21.5 4.51472 21.5 7C21.5 9.48528 19.4853 11.5 17 11.5ZM17 21.5C14.5147 21.5 12.5 19.4853 12.5 17C12.5 14.5147 14.5147 12.5 17 12.5C19.4853 12.5 21.5 14.5147 21.5 17C21.5 19.4853 19.4853 21.5 17 21.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f741b6a532402777(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 11.5C5.01472 11.5 3 9.48528 3 7C3 4.51472 5.01472 2.5 7.5 2.5C9.98528 2.5 12 4.51472 12 7C12 9.48528 9.98528 11.5 7.5 11.5ZM7.5 21.5C5.01472 21.5 3 19.4853 3 17C3 14.5147 5.01472 12.5 7.5 12.5C9.98528 12.5 12 14.5147 12 17C12 19.4853 9.98528 21.5 7.5 21.5ZM17.5 11.5C15.0147 11.5 13 9.48528 13 7C13 4.51472 15.0147 2.5 17.5 2.5C19.9853 2.5 22 4.51472 22 7C22 9.48528 19.9853 11.5 17.5 11.5ZM17.5 21.5C15.0147 21.5 13 19.4853 13 17C13 14.5147 15.0147 12.5 17.5 12.5C19.9853 12.5 22 14.5147 22 17C22 19.4853 19.9853 21.5 17.5 21.5ZM7.5 9.5C8.88071 9.5 10 8.38071 10 7C10 5.61929 8.88071 4.5 7.5 4.5C6.11929 4.5 5 5.61929 5 7C5 8.38071 6.11929 9.5 7.5 9.5ZM7.5 19.5C8.88071 19.5 10 18.3807 10 17C10 15.6193 8.88071 14.5 7.5 14.5C6.11929 14.5 5 15.6193 5 17C5 18.3807 6.11929 19.5 7.5 19.5ZM17.5 9.5C18.8807 9.5 20 8.38071 20 7C20 5.61929 18.8807 4.5 17.5 4.5C16.1193 4.5 15 5.61929 15 7C15 8.38071 16.1193 9.5 17.5 9.5ZM17.5 19.5C18.8807 19.5 20 18.3807 20 17C20 15.6193 18.8807 14.5 17.5 14.5C16.1193 14.5 15 15.6193 15 17C15 18.3807 16.1193 19.5 17.5 19.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a5956d14c6ef0c29(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.75 2.5C9.09721 2.5 11 4.40279 11 6.75V11H6.75C4.40279 11 2.5 9.09721 2.5 6.75C2.5 4.40279 4.40279 2.5 6.75 2.5ZM6.75 13H11V17.25C11 19.5972 9.09721 21.5 6.75 21.5C4.40279 21.5 2.5 19.5972 2.5 17.25C2.5 14.9028 4.40279 13 6.75 13ZM17.25 2.5C19.5972 2.5 21.5 4.40279 21.5 6.75C21.5 9.09721 19.5972 11 17.25 11H13V6.75C13 4.40279 14.9028 2.5 17.25 2.5ZM13 13H17.25C19.5972 13 21.5 14.9028 21.5 17.25C21.5 19.5972 19.5972 21.5 17.25 21.5C14.9028 21.5 13 19.5972 13 17.25V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f744205c0e5b2249(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.75 2.5C9.09721 2.5 11 4.40279 11 6.75V11H6.75C4.40279 11 2.5 9.09721 2.5 6.75C2.5 4.40279 4.40279 2.5 6.75 2.5ZM9 9V6.75C9 5.50736 7.99264 4.5 6.75 4.5C5.50736 4.5 4.5 5.50736 4.5 6.75C4.5 7.99264 5.50736 9 6.75 9H9ZM6.75 13H11V17.25C11 19.5972 9.09721 21.5 6.75 21.5C4.40279 21.5 2.5 19.5972 2.5 17.25C2.5 14.9028 4.40279 13 6.75 13ZM6.75 15C5.50736 15 4.5 16.0074 4.5 17.25C4.5 18.4926 5.50736 19.5 6.75 19.5C7.99264 19.5 9 18.4926 9 17.25V15H6.75ZM17.25 2.5C19.5972 2.5 21.5 4.40279 21.5 6.75C21.5 9.09721 19.5972 11 17.25 11H13V6.75C13 4.40279 14.9028 2.5 17.25 2.5ZM17.25 9C18.4926 9 19.5 7.99264 19.5 6.75C19.5 5.50736 18.4926 4.5 17.25 4.5C16.0074 4.5 15 5.50736 15 6.75V9H17.25ZM13 13H17.25C19.5972 13 21.5 14.9028 21.5 17.25C21.5 19.5972 19.5972 21.5 17.25 21.5C14.9028 21.5 13 19.5972 13 17.25V13ZM15 15V17.25C15 18.4926 16.0074 19.5 17.25 19.5C18.4926 19.5 19.5 18.4926 19.5 17.25C19.5 16.0074 18.4926 15 17.25 15H15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8b0a1ef41a267433(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.602 13.7599L13.014 15.1719L21.4795 6.7063L22.8938 8.12051L13.014 18.0003L6.65 11.6363L8.06421 10.2221L10.189 12.3469L11.6025 13.7594L11.602 13.7599ZM11.6037 10.9322L16.5563 5.97949L17.9666 7.38977L13.014 12.3424L11.6037 10.9322ZM8.77698 16.5873L7.36396 18.0003L1 11.6363L2.41421 10.2221L3.82723 11.6352L3.82604 11.6363L8.77698 16.5873Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$36c3ac0145bc308d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.602 13.7599L13.014 15.1719L21.4795 6.7063L22.8938 8.12051L13.014 18.0003L6.65 11.6363L8.06421 10.2221L10.189 12.3469L11.6025 13.7594L11.602 13.7599ZM11.6037 10.9322L16.5563 5.97949L17.9666 7.38977L13.014 12.3424L11.6037 10.9322ZM8.77698 16.5873L7.36396 18.0003L1 11.6363L2.41421 10.2221L3.82723 11.6352L3.82604 11.6363L8.77698 16.5873Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a1fe0524550ef089(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.0007 15.1709L19.1931 5.97852L20.6073 7.39273L10.0007 17.9993L3.63672 11.6354L5.05093 10.2212L10.0007 15.1709Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d48add6827081130(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.0007 15.1709L19.1931 5.97852L20.6073 7.39273L10.0007 17.9993L3.63672 11.6354L5.05093 10.2212L10.0007 15.1709Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$90d0b2ca7079c06d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f986655523d3acd3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$67d830fecf34ccee(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ea1907faaf0b8fe6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$58143fce31ae921a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9447b13bdb865708(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11.0026 16L6.75999 11.7574L8.17421 10.3431L11.0026 13.1716L16.6595 7.51472L18.0737 8.92893L11.0026 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a71437839ee66667(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3f2359ffc380df36(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM7 11V13H17V11H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$439c83168d0ad9e4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5ZM7 11H17V13H7V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$96949f5441a76aa2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5ZM11.0026 16L6.75999 11.7574L8.17421 10.3431L11.0026 13.1716L16.6595 7.51472L18.0737 8.92893L11.0026 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f637b0255f519936(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.99979 7V3C6.99979 2.44772 7.4475 2 7.99979 2H20.9998C21.5521 2 21.9998 2.44772 21.9998 3V16C21.9998 16.5523 21.5521 17 20.9998 17H17V20.9925C17 21.5489 16.551 22 15.9925 22H3.00728C2.45086 22 2 21.5511 2 20.9925L2.00276 8.00748C2.00288 7.45107 2.4518 7 3.01025 7H6.99979ZM8.99979 7H15.9927C16.549 7 17 7.44892 17 8.00748V15H19.9998V4H8.99979V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dff0e6341ba5862a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.99979 7V3C6.99979 2.44772 7.4475 2 7.99979 2H20.9998C21.5521 2 21.9998 2.44772 21.9998 3V16C21.9998 16.5523 21.5521 17 20.9998 17H17V20.9925C17 21.5489 16.551 22 15.9925 22H3.00728C2.45086 22 2 21.5511 2 20.9925L2.00276 8.00748C2.00288 7.45107 2.4518 7 3.01025 7H6.99979ZM8.99979 7H15.9927C16.549 7 17 7.44892 17 8.00748V15H19.9998V4H8.99979V7ZM4.00255 9L4.00021 20H15V9H4.00255Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$12d44d719af674de(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.99979 7V3C6.99979 2.44772 7.4475 2 7.99979 2H20.9998C21.5521 2 21.9998 2.44772 21.9998 3V16C21.9998 16.5523 21.5521 17 20.9998 17H17V20.9925C17 21.5489 16.551 22 15.9925 22H3.00728C2.45086 22 2 21.5511 2 20.9925L2.00276 8.00748C2.00288 7.45107 2.4518 7 3.01025 7H6.99979ZM8.99979 7H15.9927C16.549 7 17 7.44892 17 8.00748V15H19.9998V4H8.99979V7ZM8.50242 18L14.1593 12.3431L12.7451 10.9289L8.50242 15.1716L6.3811 13.0503L4.96689 14.4645L8.50242 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1310489bdff88521(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.99979 7V3C6.99979 2.44772 7.4475 2 7.99979 2H20.9998C21.5521 2 21.9998 2.44772 21.9998 3V16C21.9998 16.5523 21.5521 17 20.9998 17H17V20.9925C17 21.5489 16.551 22 15.9925 22H3.00728C2.45086 22 2 21.5511 2 20.9925L2.00276 8.00748C2.00288 7.45107 2.4518 7 3.01025 7H6.99979ZM8.99979 7H15.9927C16.549 7 17 7.44892 17 8.00748V15H19.9998V4H8.99979V7ZM15 9H4.00255L4.00021 20H15V9ZM8.50242 18L4.96689 14.4645L6.3811 13.0503L8.50242 15.1716L12.7451 10.9289L14.1593 12.3431L8.50242 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$789f8e20d208c628(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 10.5858L9.17157 7.75736L7.75736 9.17157L10.5858 12L7.75736 14.8284L9.17157 16.2426L12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L16.2426 9.17157L14.8284 7.75736L12 10.5858Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$93c484411f06704f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3f7b391d2fd26f5f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5151f0fb908b14af(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8091046e39b8bde(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3788c612a2b5581f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 21V11H21V21H13ZM3 13V3H11V13H3ZM9 11V5H5V11H9ZM3 21V15H11V21H3ZM5 19H9V17H5V19ZM15 19H19V13H15V19ZM13 3H21V9H13V3ZM15 5V7H19V5H15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c9f375c44b42d284(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.53451 3H20.9993C21.5516 3 21.9993 3.44772 21.9993 4V20C21.9993 20.5523 21.5516 21 20.9993 21H6.53451C6.20015 21 5.88792 20.8329 5.70246 20.5547L0.369122 12.5547C0.145189 12.2188 0.145189 11.7812 0.369122 11.4453L5.70246 3.4453C5.88792 3.1671 6.20015 3 6.53451 3ZM12.9993 10.5858L10.1709 7.75736L8.75668 9.17157L11.5851 12L8.75668 14.8284L10.1709 16.2426L12.9993 13.4142L15.8277 16.2426L17.242 14.8284L14.4135 12L17.242 9.17157L15.8277 7.75736L12.9993 10.5858Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6475eaa01c3dcf76(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.53451 3H20.9993C21.5516 3 21.9993 3.44772 21.9993 4V20C21.9993 20.5523 21.5516 21 20.9993 21H6.53451C6.20015 21 5.88792 20.8329 5.70246 20.5547L0.369122 12.5547C0.145189 12.2188 0.145189 11.7812 0.369122 11.4453L5.70246 3.4453C5.88792 3.1671 6.20015 3 6.53451 3ZM7.06969 5L2.40302 12L7.06969 19H19.9993V5H7.06969ZM12.9993 10.5858L15.8277 7.75736L17.242 9.17157L14.4135 12L17.242 14.8284L15.8277 16.2426L12.9993 13.4142L10.1709 16.2426L8.75668 14.8284L11.5851 12L8.75668 9.17157L10.1709 7.75736L12.9993 10.5858Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4382f545c04a118c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.53451 3H20.9993C21.5516 3 21.9993 3.44772 21.9993 4V20C21.9993 20.5523 21.5516 21 20.9993 21H6.53451C6.20015 21 5.88792 20.8329 5.70246 20.5547L0.369122 12.5547C0.145189 12.2188 0.145189 11.7812 0.369122 11.4453L5.70246 3.4453C5.88792 3.1671 6.20015 3 6.53451 3ZM15.9993 11H8.99932V13H15.9993V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$54fcf6d246ee31a0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.53451 3H20.9993C21.5516 3 21.9993 3.44772 21.9993 4V20C21.9993 20.5523 21.5516 21 20.9993 21H6.53451C6.20015 21 5.88792 20.8329 5.70246 20.5547L0.369122 12.5547C0.145189 12.2188 0.145189 11.7812 0.369122 11.4453L5.70246 3.4453C5.88792 3.1671 6.20015 3 6.53451 3ZM7.06969 5L2.40302 12L7.06969 19H19.9993V5H7.06969ZM15.9993 11V13H8.99932V11H15.9993Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2e0c64e7ccd03d22(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7ZM13.4142 13.9997L15.182 12.232L13.7678 10.8178L12 12.5855L10.2322 10.8178L8.81802 12.232L10.5858 13.9997L8.81802 15.7675L10.2322 17.1817L12 15.4139L13.7678 17.1817L15.182 15.7675L13.4142 13.9997ZM9 4V6H15V4H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1a97d42327724b73(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM13.4142 13.9997L15.182 15.7675L13.7678 17.1817L12 15.4139L10.2322 17.1817L8.81802 15.7675L10.5858 13.9997L8.81802 12.232L10.2322 10.8178L12 12.5855L13.7678 10.8178L15.182 12.232L13.4142 13.9997ZM9 4V6H15V4H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$97da5ded719c4d9e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V7H2V5H22V7H20ZM11 9V11H13V9H11ZM11 12V14H13V12H11ZM11 15V17H13V15H11ZM7 2H17V4H7V2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c8e4e939dcde99e1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V7H2V5H22V7H20ZM6 7V20H18V7H6ZM11 9H13V11H11V9ZM11 12H13V14H11V12ZM11 15H13V17H11V15ZM7 2H17V4H7V2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$35ae4bc193014a37(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V7H2V5H22V7H20ZM11 10V17H13V10H11ZM7 2H17V4H7V2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$25d8e40aa58e5189(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V7H2V5H22V7H20ZM6 7V20H18V7H6ZM7 2H17V4H7V2ZM11 10H13V17H11V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7f0433f0fbdb2bb7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8ZM7 5V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V5H22V7H2V5H7ZM9 4V5H15V4H9ZM9 12V18H11V12H9ZM13 12V18H15V12H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$68fc2c0e69483984(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8ZM6 10V20H18V10H6ZM9 12H11V18H9V12ZM13 12H15V18H13V12ZM7 5V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V5H22V7H2V5H7ZM9 4V5H15V4H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fefa263d678822af(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4H22V6H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V6H2V4H7V2H17V4ZM9 9V17H11V9H9ZM13 9V17H15V9H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f38f76a8b47cc87c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4V2H17V4H22V6H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V6H2V4H7ZM6 6V20H18V6H6ZM9 9H11V17H9V9ZM13 9H15V17H13V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$390645dfeac3515c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7ZM9 4V6H15V4H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b8dbd1fdc1dcdff6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 4V6H15V4H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c2984717936d5974(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM9 11V17H11V11H9ZM13 11V17H15V11H13ZM9 4V6H15V4H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$87fadf313616c37a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8e2e427485beb543(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11H19V13H5V11ZM12 8C11.1716 8 10.5 7.32843 10.5 6.5C10.5 5.67157 11.1716 5 12 5C12.8284 5 13.5 5.67157 13.5 6.5C13.5 7.32843 12.8284 8 12 8ZM12 19C11.1716 19 10.5 18.3284 10.5 17.5C10.5 16.6716 11.1716 16 12 16C12.8284 16 13.5 16.6716 13.5 17.5C13.5 18.3284 12.8284 19 12 19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a66d0c8168f47098(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11H19V13H5V11ZM12 8C11.1716 8 10.5 7.32843 10.5 6.5C10.5 5.67157 11.1716 5 12 5C12.8284 5 13.5 5.67157 13.5 6.5C13.5 7.32843 12.8284 8 12 8ZM12 19C11.1716 19 10.5 18.3284 10.5 17.5C10.5 16.6716 11.1716 16 12 16C12.8284 16 13.5 16.6716 13.5 17.5C13.5 18.3284 12.8284 19 12 19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$28adf1059b5fe44f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19ZM14 9H19L12 16L5 9H10V3H14V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2d9816dbb67cf601(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10H18L12 16L6 10H11V3H13V10ZM4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$935b90bdda082676(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13V18.585L14.8284 16.7574L16.2426 18.1716L12 22.4142L7.75736 18.1716L9.17157 16.7574L11 18.585V13H13ZM12 2C15.5934 2 18.5544 4.70761 18.9541 8.19395C21.2858 8.83154 23 10.9656 23 13.5C23 16.3688 20.8036 18.7246 18.0006 18.9776L18 17C18 13.6863 15.3137 11 12 11C8.7616 11 6.12243 13.5656 6.00414 16.7751L6 17L6.00039 18.9776C3.19696 18.7252 1 16.3692 1 13.5C1 10.9656 2.71424 8.83154 5.04648 8.19411C5.44561 4.70761 8.40661 2 12 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d088f608f5dede3d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13V18.585L14.8284 16.7574L16.2426 18.1716L12 22.4142L7.75736 18.1716L9.17157 16.7574L11 18.585V13H13ZM12 2C15.5934 2 18.5544 4.70761 18.9541 8.19395C21.2858 8.83154 23 10.9656 23 13.5C23 16.3688 20.8036 18.7246 18.0006 18.9776L18.0009 16.9644C19.6966 16.7214 21 15.2629 21 13.5C21 11.567 19.433 10 17.5 10C17.2912 10 17.0867 10.0183 16.8887 10.054C16.9616 9.7142 17 9.36158 17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 9.36158 7.03838 9.7142 7.11205 10.0533C6.91331 10.0183 6.70879 10 6.5 10C4.567 10 3 11.567 3 13.5C3 15.2003 4.21241 16.6174 5.81986 16.934L6.00005 16.9646L6.00039 18.9776C3.19696 18.7252 1 16.3692 1 13.5C1 10.9656 2.71424 8.83154 5.04648 8.19411C5.44561 4.70761 8.40661 2 12 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$89fdb7cf9172f52d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20.9811C3.64378 20.7257 1 17.9216 1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811V21H7V20.9811ZM13 12V8H11V12H8L12 17L16 12H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6a0f1e183fd92303(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811L7 21C3.64378 20.7257 1 17.9216 1 14.5ZM16.8483 18.9868C19.1817 18.8093 21 16.8561 21 14.5C21 12.927 20.1884 11.4962 18.8771 10.6781L18.0714 10.1754L17.9517 9.23338C17.5735 6.25803 15.0288 4 12 4C8.97116 4 6.42647 6.25803 6.0483 9.23338L5.92856 10.1754L5.12288 10.6781C3.81156 11.4962 3 12.927 3 14.5C3 16.8561 4.81833 18.8093 7.1517 18.9868L7.325 19H16.675L16.8483 18.9868ZM13 12H16L12 17L8 12H11V8H13V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d4572ed091a62bc8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19H21V21H3V19ZM13 9H20L12 17L4 9H11V1H13V9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8b7a00d08969348(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19H21V21H3V19ZM13 13.1716L19.0711 7.1005L20.4853 8.51472L12 17L3.51472 8.51472L4.92893 7.1005L11 13.1716V2H13V13.1716Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$647f4c31fc38b7ae(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8H5V10H19V8ZM19 14H5V16H19V14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5107c4e2b14bd14(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8H5V10H19V8ZM19 14H5V16H19V14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6d6e846534305694(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a212bff251a2cdfe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$76ef90696e8d0b5a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V12L17.206 8.207L11.2071 14.2071L9.79289 12.7929L15.792 6.793L12 3H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d287909fe76cab42(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V11H19L18.9999 6.413L11.2071 14.2071L9.79289 12.7929L17.5849 5H13V3H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c678981a6d784148(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 7C11.4872 7 10.9925 7.07719 10.5269 7.21995C11.3954 7.61175 12 8.48527 12 9.5C12 10.8807 10.8807 12 9.5 12C8.48527 12 7.61175 11.3954 7.22057 10.5268C7.07719 10.9925 7 11.4872 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5e8614ae5308ddb5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 11.4872 7.07719 10.9925 7.22057 10.5268C7.61175 11.3954 8.48527 12 9.5 12C10.8807 12 12 10.8807 12 9.5C12 8.48527 11.3954 7.61175 10.5269 7.21995C10.9925 7.07719 11.4872 7 12 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c775e23142d1dd20(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1305 15.8421L9.34268 18.7821L7.41083 18.2645L8.1983 15.3256C7.00919 14.8876 5.91661 14.2501 4.96116 13.4536L2.80783 15.6069L1.39362 14.1927L3.54695 12.0394C2.35581 10.6105 1.52014 8.8749 1.17578 6.96843L2.07634 6.80469C4.86882 8.81573 8.29618 10.0003 12.0002 10.0003C15.7043 10.0003 19.1316 8.81573 21.9241 6.80469L22.8247 6.96843C22.4803 8.8749 21.6446 10.6105 20.4535 12.0394L22.6068 14.1927L21.1926 15.6069L19.0393 13.4536C18.0838 14.2501 16.9912 14.8876 15.8021 15.3256L16.5896 18.2645L14.6578 18.7821L13.87 15.8421C13.2623 15.9461 12.6376 16.0003 12.0002 16.0003C11.3629 16.0003 10.7381 15.9461 10.1305 15.8421Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f6aa5c2b7bd1fd2b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.34268 18.7819L7.41083 18.2642L8.1983 15.3254C7.00919 14.8874 5.91661 14.2498 4.96116 13.4534L2.80783 15.6067L1.39362 14.1925L3.54695 12.0392C2.35581 10.6103 1.52014 8.87466 1.17578 6.96818L3.14386 6.61035C3.90289 10.8126 7.57931 14.0001 12.0002 14.0001C16.4211 14.0001 20.0976 10.8126 20.8566 6.61035L22.8247 6.96818C22.4803 8.87466 21.6446 10.6103 20.4535 12.0392L22.6068 14.1925L21.1926 15.6067L19.0393 13.4534C18.0838 14.2498 16.9912 14.8874 15.8021 15.3254L16.5896 18.2642L14.6578 18.7819L13.87 15.8418C13.2623 15.9459 12.6376 16.0001 12.0002 16.0001C11.3629 16.0001 10.7381 15.9459 10.1305 15.8418L9.34268 18.7819Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8f8d13584ffebfec(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12ZM12.0003 17C14.7617 17 17.0003 14.7614 17.0003 12C17.0003 9.23858 14.7617 7 12.0003 7C9.23884 7 7.00026 9.23858 7.00026 12C7.00026 14.7614 9.23884 17 12.0003 17ZM12.0003 15C10.3434 15 9.00026 13.6569 9.00026 12C9.00026 10.3431 10.3434 9 12.0003 9C13.6571 9 15.0003 10.3431 15.0003 12C15.0003 13.6569 13.6571 15 12.0003 15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$67a1b0936edb4c0d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bb204a3ad1f81642(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457ZM14.7577 16.1718L13.2937 14.7078C12.902 14.8952 12.4634 15.0002 12.0003 15.0002C10.3434 15.0002 9.00026 13.657 9.00026 12.0002C9.00026 11.537 9.10522 11.0984 9.29263 10.7067L7.82866 9.24277C7.30514 10.0332 7.00026 10.9811 7.00026 12.0002C7.00026 14.7616 9.23884 17.0002 12.0003 17.0002C13.0193 17.0002 13.9672 16.6953 14.7577 16.1718ZM7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925L16.947 12.7327C16.9821 12.4936 17.0003 12.249 17.0003 12.0002C17.0003 9.23873 14.7617 7.00016 12.0003 7.00016C11.7514 7.00016 11.5068 7.01833 11.2677 7.05343L7.97446 3.76015Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d7f01da47f931d9a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968ZM5.9356 7.3497C4.60673 8.56015 3.6378 10.1672 3.22278 12.0002C4.14022 16.0521 7.7646 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8384L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM20.8068 16.5925L19.376 15.1617C20.0319 14.2268 20.5154 13.1586 20.7777 12.0002C19.8603 7.94818 16.2359 5.00016 12.0003 5.00016C11.1544 5.00016 10.3329 5.11773 9.55249 5.33818L7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925ZM11.7229 7.50857C11.8146 7.50299 11.9071 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.0933 16.4974 12.1858 16.4919 12.2775L11.7229 7.50857Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$63ad684de8261902(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14L4 5V3H20V5L14 14V20L10 22V14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9e253ce285c2afdc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V20L10 22V14L4 5V3H20V5L14 14ZM6.4037 5L12 13.3944L17.5963 5H6.4037Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$736c70f9d3d79501(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7d1ed5bea1d93e30(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3896b7c6300ec567(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4V6H20L14 15V22H10V15L4 6H3V4H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$138f91307984aba2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4V6H20L15 13.5V22H9V13.5L4 6H3V4H21ZM6.4037 6L11 12.8944V20H13V12.8944L17.5963 6H6.4037Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ca6c28e65fd38d26(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.92893 0.514648L21.0711 14.6568L19.6569 16.071L15.834 12.2486L14 14.9999V21.9999H10V14.9999L4 5.99993H3V3.99993L7.585 3.99965L5.51472 1.92886L6.92893 0.514648ZM21 3.99993V5.99993H20L18.085 8.87193L13.213 3.99993H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a4bf6486a260dd4c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.92893 0.514648L21.0711 14.6568L19.6569 16.071L15.834 12.2486L15 13.4999V21.9999H9V13.4999L4 5.99993H3V3.99993L7.585 3.99965L5.51472 1.92886L6.92893 0.514648ZM9.585 5.99965L6.4037 5.99993L11 12.8944V19.9999H13V12.8944L14.392 10.8066L9.585 5.99965ZM21 3.99993V5.99993H20L18.085 8.87193L16.643 7.42893L17.5963 5.99993H15.213L13.213 3.99993H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$adde2a486ca0d43f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.6589 9C15.8357 6.66906 13.6136 5 11 5C7.685 5 5 7.685 5 11H7C7 8.792 8.792 7 11 7C11.6912 7 12.3417 7.17563 12.9092 7.48467L12 9H16.6589ZM17 11H15C15 13.208 13.208 15 11 15C10.3088 15 9.65828 14.8244 9.0908 14.5153L10 13H7.53567H5.34109C6.16433 15.3309 8.38635 17 11 17C14.315 17 17 14.315 17 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e147d71f0ca37ab3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.0326 16.6184L22.3137 20.8995L20.8995 22.3137L16.6184 18.0326C15.0789 19.2639 13.1258 20 11 20C7.46456 20 4.40684 17.964 2.93475 15H6H9L7.69597 17.1734C8.67997 17.7009 9.80489 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 10.305 17.8988 9.63365 17.7104 9H19.7772C19.923 9.64318 20 10.3126 20 11C20 13.1258 19.2639 15.0789 18.0326 16.6184ZM19.0652 7H13L14.304 4.82662C13.32 4.29912 12.1951 4 11 4C7.1325 4 4 7.1325 4 11C4 11.695 4.10117 12.3663 4.2896 13H2.22279C2.07698 12.3568 2 11.6874 2 11C2 6.0275 6.0275 2 11 2C14.5354 2 17.5932 4.03597 19.0652 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f9afa44be3f45089(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM16.8911 8.52313C16.6997 8.25459 16.4836 7.99828 16.2426 7.75736C16.0017 7.51644 15.7454 7.30029 15.4769 7.10891L7.10891 15.4769C7.30029 15.7454 7.51644 16.0017 7.75736 16.2426C7.99828 16.4836 8.25459 16.6997 8.52313 16.8911L16.8911 8.52313Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$32da5c7f49ab4ac4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM16.8911 8.52313L8.52313 16.8911C8.25459 16.6997 7.99828 16.4836 7.75736 16.2426C7.51644 16.0017 7.30029 15.7454 7.10891 15.4769L15.4769 7.10891C15.7454 7.30029 16.0017 7.51644 16.2426 7.75736C16.4836 7.99828 16.6997 8.25459 16.8911 8.52313Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$836c6e2ac71ccc70(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8.52313 7.10891C8.25459 7.30029 7.99828 7.51644 7.75736 7.75736C7.51644 7.99828 7.30029 8.25459 7.10891 8.52313L15.4769 16.8911C15.7454 16.6997 16.0017 16.4836 16.2426 16.2426C16.4836 16.0017 16.6997 15.7454 16.8911 15.4769L8.52313 7.10891Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1ad5ea43372ce24b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM8.52313 7.10891L16.8911 15.4769C16.6997 15.7454 16.4836 16.0017 16.2426 16.2426C16.0017 16.4836 15.7454 16.6997 15.4769 16.8911L7.10891 8.52313C7.30029 8.25459 7.51644 7.99828 7.75736 7.75736C7.99828 7.51644 8.25459 7.30029 8.52313 7.10891Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8c29930310438e40(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H11V11H3V3ZM3 13H11V21H3V13ZM13 3H21V11H13V3ZM13 13H21V21H13V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c0e5d6a822cb6406(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H11V11H3V3ZM3 13H11V21H3V13ZM13 3H21V11H13V3ZM13 13H21V21H13V13ZM15 5V9H19V5H15ZM15 15V19H19V15H15ZM5 5V9H9V5H5ZM5 15V19H9V15H5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b4472906e7a73372(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.53614 4 7.33243 5.11383 5.86492 6.86543L8 9H2V3L4.44656 5.44648C6.28002 3.33509 8.9841 2 12 2ZM13 7L12.9998 11.585L16.2426 14.8284L14.8284 16.2426L10.9998 12.413L11 7H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f27a2b0972e6793f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.25022 4 6.82447 5.38734 5.38451 7.50024L8 7.5V9.5H2V3.5H4L3.99989 5.99918C5.82434 3.57075 8.72873 2 12 2ZM13 7L12.9998 11.585L16.2426 14.8284L14.8284 16.2426L10.9998 12.413L11 7H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$517e2b9c0740fb38(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2H20V6.45994L13.5366 12L20 17.5401V22H4V17.5401L10.4634 12L4 6.45994V2ZM16.2967 7L18 5.54007V4H6V5.54007L7.70326 7H16.2967ZM12 13.3171L6 18.4599V20H7L12 17L17 20H18V18.4599L12 13.3171Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$80646c4081651f47(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2H20V6.45994L13.5366 12L20 17.5401V22H4V17.5401L10.4634 12L4 6.45994V2ZM12 10.6829L18 5.54007V4H6V5.54007L12 10.6829ZM12 13.3171L6 18.4599V20H18V18.4599L12 13.3171Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e27a23d09d335921(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4H4V2H20V4H18V6C18 7.61543 17.1838 8.91468 16.1561 9.97667C15.4532 10.703 14.598 11.372 13.7309 12C14.598 12.628 15.4532 13.297 16.1561 14.0233C17.1838 15.0853 18 16.3846 18 18V20H20V22H4V20H6V18C6 16.3846 6.81616 15.0853 7.8439 14.0233C8.54682 13.297 9.40202 12.628 10.2691 12C9.40202 11.372 8.54682 10.703 7.8439 9.97667C6.81616 8.91468 6 7.61543 6 6V4ZM8 4V6C8 6.68514 8.26026 7.33499 8.77131 8H15.2287C15.7397 7.33499 16 6.68514 16 6V4H8ZM12 13.2219C10.9548 13.9602 10.008 14.663 9.2811 15.4142C9.09008 15.6116 8.92007 15.8064 8.77131 16H15.2287C15.0799 15.8064 14.9099 15.6116 14.7189 15.4142C13.992 14.663 13.0452 13.9602 12 13.2219Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9b82729c6da433f9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4H4V2H20V4H18V6C18 7.61543 17.1838 8.91468 16.1561 9.97667C15.4532 10.703 14.598 11.372 13.7309 12C14.598 12.628 15.4532 13.297 16.1561 14.0233C17.1838 15.0853 18 16.3846 18 18V20H20V22H4V20H6V18C6 16.3846 6.81616 15.0853 7.8439 14.0233C8.54682 13.297 9.40202 12.628 10.2691 12C9.40202 11.372 8.54682 10.703 7.8439 9.97667C6.81616 8.91468 6 7.61543 6 6V4ZM8 4V6C8 6.88457 8.43384 7.71032 9.2811 8.58583C10.008 9.33699 10.9548 10.0398 12 10.7781C13.0452 10.0398 13.992 9.33699 14.7189 8.58583C15.5662 7.71032 16 6.88457 16 6V4H8ZM12 13.2219C10.9548 13.9602 10.008 14.663 9.2811 15.4142C8.43384 16.2897 8 17.1154 8 18V20H16V18C16 17.1154 15.5662 16.2897 14.7189 15.4142C13.992 14.663 13.0452 13.9602 12 13.2219Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$524de9ed43fd26ad(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM7 11V13H17V11H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4c3eb2e1c042bfe2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM7 11H17V13H7V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bec0a495ff53f49d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 11V17H13V11H11ZM11 7V9H13V7H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5ae2633fba899f11(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fa7515aa5adc44f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18H9V20H2V18ZM2 11H11V13H2V11ZM2 4H22V6H2V4ZM20.674 13.0251L21.8301 12.634L22.8301 14.366L21.914 15.1711C21.9704 15.4386 22 15.7158 22 16C22 16.2842 21.9704 16.5614 21.914 16.8289L22.8301 17.634L21.8301 19.366L20.674 18.9749C20.2635 19.3441 19.7763 19.6295 19.2391 19.8044L19 21H17L16.7609 19.8044C16.2237 19.6295 15.7365 19.3441 15.326 18.9749L14.1699 19.366L13.1699 17.634L14.086 16.8289C14.0296 16.5614 14 16.2842 14 16C14 15.7158 14.0296 15.4386 14.086 15.1711L13.1699 14.366L14.1699 12.634L15.326 13.0251C15.7365 12.6559 16.2237 12.3705 16.7609 12.1956L17 11H19L19.2391 12.1956C19.7763 12.3705 20.2635 12.6559 20.674 13.0251ZM18 17C18.5523 17 19 16.5523 19 16C19 15.4477 18.5523 15 18 15C17.4477 15 17 15.4477 17 16C17 16.5523 17.4477 17 18 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$77770cc3d6073212(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18H9V20H2V18ZM2 11H11V13H2V11ZM2 4H22V6H2V4ZM20.674 13.0251L21.8301 12.634L22.8301 14.366L21.914 15.1711C21.9704 15.4386 22 15.7158 22 16C22 16.2842 21.9704 16.5614 21.914 16.8289L22.8301 17.634L21.8301 19.366L20.674 18.9749C20.2635 19.3441 19.7763 19.6295 19.2391 19.8044L19 21H17L16.7609 19.8044C16.2237 19.6295 15.7365 19.3441 15.326 18.9749L14.1699 19.366L13.1699 17.634L14.086 16.8289C14.0296 16.5614 14 16.2842 14 16C14 15.7158 14.0296 15.4386 14.086 15.1711L13.1699 14.366L14.1699 12.634L15.326 13.0251C15.7365 12.6559 16.2237 12.3705 16.7609 12.1956L17 11H19L19.2391 12.1956C19.7763 12.3705 20.2635 12.6559 20.674 13.0251ZM18 18C19.1046 18 20 17.1046 20 16C20 14.8954 19.1046 14 18 14C16.8954 14 16 14.8954 16 16C16 17.1046 16.8954 18 18 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$aa91b2b9cd985abe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C12.5523 2 13 2.44772 13 3V6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6V3C11 2.44772 11.4477 2 12 2ZM12 17C12.5523 17 13 17.4477 13 18V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V18C11 17.4477 11.4477 17 12 17ZM22 12C22 12.5523 21.5523 13 21 13H18C17.4477 13 17 12.5523 17 12C17 11.4477 17.4477 11 18 11H21C21.5523 11 22 11.4477 22 12ZM7 12C7 12.5523 6.55228 13 6 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H6C6.55228 11 7 11.4477 7 12ZM19.0711 19.0711C18.6805 19.4616 18.0474 19.4616 17.6569 19.0711L15.5355 16.9497C15.145 16.5592 15.145 15.9261 15.5355 15.5355C15.9261 15.145 16.5592 15.145 16.9497 15.5355L19.0711 17.6569C19.4616 18.0474 19.4616 18.6805 19.0711 19.0711ZM8.46447 8.46447C8.07394 8.85499 7.44078 8.85499 7.05025 8.46447L4.92893 6.34315C4.53841 5.95262 4.53841 5.31946 4.92893 4.92893C5.31946 4.53841 5.95262 4.53841 6.34315 4.92893L8.46447 7.05025C8.85499 7.44078 8.85499 8.07394 8.46447 8.46447ZM4.92893 19.0711C4.53841 18.6805 4.53841 18.0474 4.92893 17.6569L7.05025 15.5355C7.44078 15.145 8.07394 15.145 8.46447 15.5355C8.85499 15.9261 8.85499 16.5592 8.46447 16.9497L6.34315 19.0711C5.95262 19.4616 5.31946 19.4616 4.92893 19.0711ZM15.5355 8.46447C15.145 8.07394 15.145 7.44078 15.5355 7.05025L17.6569 4.92893C18.0474 4.53841 18.6805 4.53841 19.0711 4.92893C19.4616 5.31946 19.4616 5.95262 19.0711 6.34315L16.9497 8.46447C16.5592 8.85499 15.9261 8.85499 15.5355 8.46447Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7f9ce4fa1c5b0f8e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C12.5523 2 13 2.44772 13 3V6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6V3C11 2.44772 11.4477 2 12 2ZM12 17C12.5523 17 13 17.4477 13 18V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V18C11 17.4477 11.4477 17 12 17ZM22 12C22 12.5523 21.5523 13 21 13H18C17.4477 13 17 12.5523 17 12C17 11.4477 17.4477 11 18 11H21C21.5523 11 22 11.4477 22 12ZM7 12C7 12.5523 6.55228 13 6 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H6C6.55228 11 7 11.4477 7 12ZM19.0711 19.0711C18.6805 19.4616 18.0474 19.4616 17.6569 19.0711L15.5355 16.9497C15.145 16.5592 15.145 15.9261 15.5355 15.5355C15.9261 15.145 16.5592 15.145 16.9497 15.5355L19.0711 17.6569C19.4616 18.0474 19.4616 18.6805 19.0711 19.0711ZM8.46447 8.46447C8.07394 8.85499 7.44078 8.85499 7.05025 8.46447L4.92893 6.34315C4.53841 5.95262 4.53841 5.31946 4.92893 4.92893C5.31946 4.53841 5.95262 4.53841 6.34315 4.92893L8.46447 7.05025C8.85499 7.44078 8.85499 8.07394 8.46447 8.46447ZM4.92893 19.0711C4.53841 18.6805 4.53841 18.0474 4.92893 17.6569L7.05025 15.5355C7.44078 15.145 8.07394 15.145 8.46447 15.5355C8.85499 15.9261 8.85499 16.5592 8.46447 16.9497L6.34315 19.0711C5.95262 19.4616 5.31946 19.4616 4.92893 19.0711ZM15.5355 8.46447C15.145 8.07394 15.145 7.44078 15.5355 7.05025L17.6569 4.92893C18.0474 4.53841 18.6805 4.53841 19.0711 4.92893C19.4616 5.31946 19.4616 5.95262 19.0711 6.34315L16.9497 8.46447C16.5592 8.85499 15.9261 8.85499 15.5355 8.46447Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$37bf3a1a0732c110(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.05469 13H5.07065C5.55588 16.3923 8.47329 19 11.9998 19C15.5262 19 18.4436 16.3923 18.9289 13H20.9448C20.4474 17.5 16.6323 21 11.9998 21C7.36721 21 3.55213 17.5 3.05469 13ZM3.05469 11C3.55213 6.50005 7.36721 3 11.9998 3C16.6323 3 20.4474 6.50005 20.9448 11H18.9289C18.4436 7.60771 15.5262 5 11.9998 5C8.47329 5 5.55588 7.60771 5.07065 11H3.05469Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2f18166495fff842(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.05469 13H5.07065C5.55588 16.3923 8.47329 19 11.9998 19C15.5262 19 18.4436 16.3923 18.9289 13H20.9448C20.4474 17.5 16.6323 21 11.9998 21C7.36721 21 3.55213 17.5 3.05469 13ZM3.05469 11C3.55213 6.50005 7.36721 3 11.9998 3C16.6323 3 20.4474 6.50005 20.9448 11H18.9289C18.4436 7.60771 15.5262 5 11.9998 5C8.47329 5 5.55588 7.60771 5.07065 11H3.05469Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7d5ba4e1cd65f655(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.364 5.63604L16.9497 7.05025C15.683 5.7835 13.933 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12H21C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.4853 3 16.7353 4.00736 18.364 5.63604Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d09a48f5aa8ec8da(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.364 5.63604L16.9497 7.05025C15.683 5.7835 13.933 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12H21C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.4853 3 16.7353 4.00736 18.364 5.63604Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ef17ba45db1e915a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3C16.9706 3 21 7.02944 21 12H19C19 8.13401 15.866 5 12 5V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$36c0c6242d8562ff(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3C16.9706 3 21 7.02944 21 12H19C19 8.13401 15.866 5 12 5V3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$722cee1df2a4f2d9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9995 2C12.5518 2 12.9995 2.44772 12.9995 3V6C12.9995 6.55228 12.5518 7 11.9995 7C11.4472 7 10.9995 6.55228 10.9995 6V3C10.9995 2.44772 11.4472 2 11.9995 2ZM11.9995 17C12.5518 17 12.9995 17.4477 12.9995 18V21C12.9995 21.5523 12.5518 22 11.9995 22C11.4472 22 10.9995 21.5523 10.9995 21V18C10.9995 17.4477 11.4472 17 11.9995 17ZM20.6597 7C20.9359 7.47829 20.772 8.08988 20.2937 8.36602L17.6956 9.86602C17.2173 10.1422 16.6057 9.97829 16.3296 9.5C16.0535 9.02171 16.2173 8.41012 16.6956 8.13398L19.2937 6.63397C19.772 6.35783 20.3836 6.52171 20.6597 7ZM7.66935 14.5C7.94549 14.9783 7.78161 15.5899 7.30332 15.866L4.70525 17.366C4.22695 17.6422 3.61536 17.4783 3.33922 17C3.06308 16.5217 3.22695 15.9101 3.70525 15.634L6.30332 14.134C6.78161 13.8578 7.3932 14.0217 7.66935 14.5ZM20.6597 17C20.3836 17.4783 19.772 17.6422 19.2937 17.366L16.6956 15.866C16.2173 15.5899 16.0535 14.9783 16.3296 14.5C16.6057 14.0217 17.2173 13.8578 17.6956 14.134L20.2937 15.634C20.772 15.9101 20.9359 16.5217 20.6597 17ZM7.66935 9.5C7.3932 9.97829 6.78161 10.1422 6.30332 9.86602L3.70525 8.36602C3.22695 8.08988 3.06308 7.47829 3.33922 7C3.61536 6.52171 4.22695 6.35783 4.70525 6.63397L7.30332 8.13398C7.78161 8.41012 7.94549 9.02171 7.66935 9.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cf319b3be7ec48b1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9995 2C12.5518 2 12.9995 2.44772 12.9995 3V6C12.9995 6.55228 12.5518 7 11.9995 7C11.4472 7 10.9995 6.55228 10.9995 6V3C10.9995 2.44772 11.4472 2 11.9995 2ZM11.9995 17C12.5518 17 12.9995 17.4477 12.9995 18V21C12.9995 21.5523 12.5518 22 11.9995 22C11.4472 22 10.9995 21.5523 10.9995 21V18C10.9995 17.4477 11.4472 17 11.9995 17ZM20.6597 7C20.9359 7.47829 20.772 8.08988 20.2937 8.36602L17.6956 9.86602C17.2173 10.1422 16.6057 9.97829 16.3296 9.5C16.0535 9.02171 16.2173 8.41012 16.6956 8.13398L19.2937 6.63397C19.772 6.35783 20.3836 6.52171 20.6597 7ZM7.66935 14.5C7.94549 14.9783 7.78161 15.5899 7.30332 15.866L4.70525 17.366C4.22695 17.6422 3.61536 17.4783 3.33922 17C3.06308 16.5217 3.22695 15.9101 3.70525 15.634L6.30332 14.134C6.78161 13.8578 7.3932 14.0217 7.66935 14.5ZM20.6597 17C20.3836 17.4783 19.772 17.6422 19.2937 17.366L16.6956 15.866C16.2173 15.5899 16.0535 14.9783 16.3296 14.5C16.6057 14.0217 17.2173 13.8578 17.6956 14.134L20.2937 15.634C20.772 15.9101 20.9359 16.5217 20.6597 17ZM7.66935 9.5C7.3932 9.97829 6.78161 10.1422 6.30332 9.86602L3.70525 8.36602C3.22695 8.08988 3.06308 7.47829 3.33922 7C3.61536 6.52171 4.22695 6.35783 4.70525 6.63397L7.30332 8.13398C7.78161 8.41012 7.94549 9.02171 7.66935 9.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eb55959f11269e7d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8ZM11 15.7324V18H13V15.7324C13.5978 15.3866 14 14.7403 14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14C10 14.7403 10.4022 15.3866 11 15.7324ZM16 8V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8H16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7a975b32bdff25e1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6ZM19 10H5V20H19V10ZM11 15.7324C10.4022 15.3866 10 14.7403 10 14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14C14 14.7403 13.5978 15.3866 13 15.7324V18H11V15.7324ZM8 8H16V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7af8cde9642523d6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V10ZM17 10V9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9V10H17ZM11 14V18H13V14H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e56c565f390056c0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V10ZM5 12V20H19V12H5ZM11 14H13V18H11V14ZM17 10V9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9V10H17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$41206d0ae5f0f7a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8ZM16 8V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8H16ZM11 14V16H13V14H11ZM7 14V16H9V14H7ZM15 14V16H17V14H15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c58a868b0ceed249(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8ZM5 10V20H19V10H5ZM11 14H13V16H11V14ZM7 14H9V16H7V14ZM15 14H17V16H15V14ZM16 8V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8H16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2f0fc66ccfa91e8e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C14.7405 2 17.1131 3.5748 18.2624 5.86882L16.4731 6.76344C15.6522 5.12486 13.9575 4 12 4C9.23858 4 7 6.23858 7 9V10ZM10 15V17H14V15H10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d9a857399f812bdf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C14.7405 2 17.1131 3.5748 18.2624 5.86882L16.4731 6.76344C15.6522 5.12486 13.9575 4 12 4C9.23858 4 7 6.23858 7 9V10ZM5 12V20H19V12H5ZM10 15H14V17H10V15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$47617504eb232095(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 11H4V3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V13H10V16L15 12L10 8V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$515cbf8899b7f2f3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15H6V20H18V4H6V9H4V3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V15ZM10 11V8L15 12L10 16V13H2V11H10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b87b042ffcaa3ea8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.99945 11H2.04883C2.55055 5.94668 6.8141 2 11.9995 2C17.5223 2 21.9995 6.47715 21.9995 12C21.9995 17.5228 17.5223 22 11.9995 22C6.8141 22 2.55055 18.0533 2.04883 13H9.99945V16L14.9995 12L9.99945 8V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4bfaf1c819a9553d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 11V8L15 12L10 16V13H1V11H10ZM2.4578 15H4.58152C5.76829 17.9318 8.64262 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C8.64262 4 5.76829 6.06817 4.58152 9H2.4578C3.73207 4.94289 7.52236 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C7.52236 22 3.73207 19.0571 2.4578 15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c0079970198ecfad(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2ZM9 11V8L4 12L9 16V13H15V11H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a187017682a99ba4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18H6V20H18V4H6V6H4V3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V18ZM6 11H13V13H6V16L1 12L6 8V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fd98c05ff5abcb8a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5ZM15 16L20 12L15 8V11H9V13H15V16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$688f0e4ea3d14b35(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V6H18V4H6V20H18V18H20V21C20 21.5523 19.5523 22 19 22H5ZM18 16V13H11V11H18V8L23 12L18 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f4ad017581d175a2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM7 11V8L2 12L7 16V13H15V11H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d73927eb6f6fdb90(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11H13V13H5V16L0 12L5 8V11ZM3.99927 18H6.70835C8.11862 19.2447 9.97111 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.97111 4 8.11862 4.75527 6.70835 6H3.99927C5.82368 3.57111 8.72836 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C8.72836 22 5.82368 20.4289 3.99927 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b51da20349fa89c9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM17 16L22 12L17 8V11H9V13H17V16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d4a94f95e860e757(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C15.2713 2 18.1757 3.57078 20.0002 5.99923L17.2909 5.99931C15.8807 4.75499 14.0285 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.029 20 15.8816 19.2446 17.2919 17.9998L20.0009 17.9998C18.1765 20.4288 15.2717 22 12 22ZM19 16V13H11V11H19V8L24 12L19 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$57773a54ebbd51ce(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C9.4095 4 7.10606 5.23053 5.64274 7.14274L8 9.5H2V3.5L4.21863 5.71863C6.05061 3.452 8.85558 2 12 2 17.5228 2 22 6.47715 22 12H20C20 7.58172 16.4183 4 12 4ZM4 12C4 16.4183 7.58172 20 12 20 14.5905 20 16.894 18.7695 18.3573 16.8573L16 14.5 22 14.5V20.5L19.7814 18.2814C17.9494 20.548 15.1444 22 12 22 6.47715 22 2 17.5228 2 12H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$79d5c7620c5509b0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C9.25144 4 6.82508 5.38626 5.38443 7.5H8V9.5H2V3.5H4V5.99936C5.82381 3.57166 8.72764 2 12 2C17.5228 2 22 6.47715 22 12H20C20 7.58172 16.4183 4 12 4ZM4 12C4 16.4183 7.58172 20 12 20C14.7486 20 17.1749 18.6137 18.6156 16.5H16V14.5H22V20.5H20V18.0006C18.1762 20.4283 15.2724 22 12 22C6.47715 22 2 17.5228 2 12H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9cc980234d83ede9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C14.5905 4 16.8939 5.23053 18.3573 7.14274L16 9.5H22V3.5L19.7814 5.71863C17.9494 3.452 15.1444 2 12 2 6.47715 2 2 6.47715 2 12H4C4 7.58172 7.58172 4 12 4ZM20 12C20 16.4183 16.4183 20 12 20 9.40951 20 7.10605 18.7695 5.64274 16.8573L8 14.5 2 14.5V20.5L4.21863 18.2814C6.05062 20.548 8.85557 22 12 22 17.5228 22 22 17.5228 22 12H20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$58910a4925606c1b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C14.7486 4 17.1749 5.38626 18.6156 7.5H16V9.5H22V3.5H20V5.99936C18.1762 3.57166 15.2724 2 12 2C6.47715 2 2 6.47715 2 12H4C4 7.58172 7.58172 4 12 4ZM20 12C20 16.4183 16.4183 20 12 20C9.25144 20 6.82508 18.6137 5.38443 16.5H8V14.5H2V20.5H4V18.0006C5.82381 20.4283 8.72764 22 12 22C17.5228 22 22 17.5228 22 12H20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1a8b863aff43584d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4H21V6H3V4ZM3 11H15V13H3V11ZM3 18H21V20H3V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f5da345aadec178f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4H21V6H3V4ZM3 11H15V13H3V11ZM3 18H21V20H3V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a7dbeeafb5247c6a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4H21V6H3V4ZM9 11H21V13H9V11ZM3 18H21V20H3V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8c2592eab1cf90b8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4H21V6H3V4ZM9 11H21V13H9V11ZM3 18H21V20H3V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$14c5c5be206cd0f4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18V20H5V18H16ZM21 11V13H3V11H21ZM19 4V6H8V4H19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8640c65f3b2a7681(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18V20H5V18H16ZM21 11V13H3V11H21ZM19 4V6H8V4H19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1720c3b38ae240ef(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 18V20H6V18H18ZM21 11V13H3V11H21ZM18 4V6H6V4H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6a157c67de96ffed(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 18V20H6V18H18ZM21 11V13H3V11H21ZM18 4V6H6V4H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5be438b467e1aa3c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 15L17.999 18H21V20H17.999L18 23H16L15.999 20H13V18H15.999L16 15H18ZM11 18V20H3V18H11ZM21 11V13H3V11H21ZM21 4V6H3V4H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a87fdbd254e6257d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 15L17.999 18H21V20H17.999L18 23H16L15.999 20H13V18H15.999L16 15H18ZM11 18V20H3V18H11ZM21 11V13H3V11H21ZM21 4V6H3V4H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$99d665153d5be50c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bbf6886ae4be75a3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17.9996V19.9996H3V17.9996H21ZM6.94975 3.5498V13.4493L2 8.49955L6.94975 3.5498ZM21 10.9996V12.9996H12V10.9996H21ZM21 3.99955V5.99955H12V3.99955H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$faec87f8dcd3b68e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17.9995V19.9995H3V17.9995H21ZM6.59619 3.90332L8.01041 5.31753L4.82843 8.49951L8.01041 11.6815L6.59619 13.0957L2 8.49951L6.59619 3.90332ZM21 10.9995V12.9995H12V10.9995H21ZM21 3.99951V5.99951H12V3.99951H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$55112b99e50dece6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c6d40c9f61b56a03(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.6175 13.0317C17.7315 13.6424 16.6575 14 15.5 14C12.4624 14 10 11.5376 10 8.5C10 5.46243 12.4624 3 15.5 3C18.5376 3 21 5.46243 21 8.5C21 9.6575 20.6424 10.7315 20.0317 11.6175L22.7071 14.2929L21.2929 15.7071L18.6175 13.0317ZM3 4H8V6H3V4ZM3 11H8V13H3V11ZM3 18H21V20H3V18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8f4405535cb2796f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 5C13.567 5 12 6.567 12 8.5C12 10.433 13.567 12 15.5 12C17.433 12 19 10.433 19 8.5C19 6.567 17.433 5 15.5 5ZM10 8.5C10 5.46243 12.4624 3 15.5 3C18.5376 3 21 5.46243 21 8.5C21 9.6575 20.6424 10.7315 20.0317 11.6175L22.7071 14.2929L21.2929 15.7071L18.6175 13.0317C17.7315 13.6424 16.6575 14 15.5 14C12.4624 14 10 11.5376 10 8.5ZM3 4H8V6H3V4ZM3 11H8V13H3V11ZM21 18V20H3V18H21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bd71bdebe4029f7d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17.9996V19.9996H3V17.9996H21ZM17.0503 3.5498L22 8.49955L17.0503 13.4493V3.5498ZM12 10.9996V12.9996H3V10.9996H12ZM12 3.99955V5.99955H3V3.99955H12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9c621344059058e9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17.9995V19.9995H3V17.9995H21ZM17.4038 3.90332L22 8.49951L17.4038 13.0957L15.9896 11.6815L19.1716 8.49951L15.9896 5.31753L17.4038 3.90332ZM12 10.9995V12.9995H3V10.9995H12ZM12 3.99951V5.99951H3V3.99951H12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ac47b817a971310d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3C10.9 3 10 3.9 10 5C10 6.1 10.9 7 12 7C13.1 7 14 6.1 14 5C14 3.9 13.1 3 12 3ZM12 17C10.9 17 10 17.9 10 19C10 20.1 10.9 21 12 21C13.1 21 14 20.1 14 19C14 17.9 13.1 17 12 17ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d70ee4ea74015f29(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3C11.175 3 10.5 3.675 10.5 4.5C10.5 5.325 11.175 6 12 6C12.825 6 13.5 5.325 13.5 4.5C13.5 3.675 12.825 3 12 3ZM12 18C11.175 18 10.5 18.675 10.5 19.5C10.5 20.325 11.175 21 12 21C12.825 21 13.5 20.325 13.5 19.5C13.5 18.675 12.825 18 12 18ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4adb7f3827eff2f4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10C3.9 10 3 10.9 3 12C3 13.1 3.9 14 5 14C6.1 14 7 13.1 7 12C7 10.9 6.1 10 5 10ZM19 10C17.9 10 17 10.9 17 12C17 13.1 17.9 14 19 14C20.1 14 21 13.1 21 12C21 10.9 20.1 10 19 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f58cf9b63701a1c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 10.5C3.675 10.5 3 11.175 3 12C3 12.825 3.675 13.5 4.5 13.5C5.325 13.5 6 12.825 6 12C6 11.175 5.325 10.5 4.5 10.5ZM19.5 10.5C18.675 10.5 18 11.175 18 12C18 12.825 18.675 13.5 19.5 13.5C20.325 13.5 21 12.825 21 12C21 11.175 20.325 10.5 19.5 10.5ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b836f92f76a604f7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.3414 4C13.1203 4.62556 13 5.29873 13 6C13 9.31371 15.6863 12 19 12C19.7013 12 20.3744 11.8797 21 11.6586V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V5C3 4.44772 3.44772 4 4 4H13.3414ZM19 10C16.7909 10 15 8.20914 15 6C15 3.79086 16.7909 2 19 2C21.2091 2 23 3.79086 23 6C23 8.20914 21.2091 10 19 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fc651ba5d07edd8e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.3414 4C13.1203 4.62556 13 5.29873 13 6H5V20H19V12C19.7013 12 20.3744 11.8797 21 11.6586V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V5C3 4.44772 3.44772 4 4 4H13.3414ZM19 8C20.1046 8 21 7.10457 21 6C21 4.89543 20.1046 4 19 4C17.8954 4 17 4.89543 17 6C17 7.10457 17.8954 8 19 8ZM19 10C16.7909 10 15 8.20914 15 6C15 3.79086 16.7909 2 19 2C21.2091 2 23 3.79086 23 6C23 8.20914 21.2091 10 19 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c944976f76e9d068(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.7429 18.3287C21.1536 16.6049 22 14.4013 22 12C22 6.47715 17.5228 2 12 2C9.59873 2 7.39514 2.84637 5.67127 4.25705L19.7429 18.3287ZM4.25705 5.67127C2.84637 7.39514 2 9.59873 2 12C2 17.5228 6.47715 22 12 22C14.4013 22 16.6049 21.1536 18.3287 19.7429L4.25705 5.67127Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ea135652da81b3f8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.0943 5.68009L18.3199 16.9057C19.3736 15.5506 20 13.8491 20 12C20 7.58172 16.4183 4 12 4C10.1509 4 8.44939 4.62644 7.0943 5.68009ZM16.9057 18.3199L5.68009 7.0943C4.62644 8.44939 4 10.1509 4 12C4 16.4183 7.58172 20 12 20C13.8491 20 15.5506 19.3736 16.9057 18.3199ZM4.92893 4.92893C6.73748 3.12038 9.23885 2 12 2C17.5228 2 22 6.47715 22 12C22 14.7611 20.8796 17.2625 19.0711 19.0711C17.2625 20.8796 14.7611 22 12 22C6.47715 22 2 17.5228 2 12C2 9.23885 3.12038 6.73748 4.92893 4.92893Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$170481990ff4655d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM13 13.3551C14.4457 12.9248 15.5 11.5855 15.5 10C15.5 8.067 13.933 6.5 12 6.5C10.302 6.5 8.88637 7.70919 8.56731 9.31346L10.5288 9.70577C10.6656 9.01823 11.2723 8.5 12 8.5C12.8284 8.5 13.5 9.17157 13.5 10C13.5 10.8284 12.8284 11.5 12 11.5C11.4477 11.5 11 11.9477 11 12.5V14H13V13.3551Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cb4e71be2df60e3c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM13 13.3551V14H11V12.5C11 11.9477 11.4477 11.5 12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.2723 8.5 10.6656 9.01823 10.5288 9.70577L8.56731 9.31346C8.88637 7.70919 10.302 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10C15.5 11.5855 14.4457 12.9248 13 13.3551Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4341cf090f059df6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7c6dd1eb733abf5a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5e9c56ad577219a3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM16.8201 17.0761C18.1628 15.8007 19 13.9981 19 12C19 8.13401 15.866 5 12 5C10.9391 5 9.9334 5.23599 9.03241 5.65834L10.0072 7.41292C10.6177 7.14729 11.2917 7 12 7C14.7614 7 17 9.23858 17 12H14L16.8201 17.0761ZM14.9676 18.3417L13.9928 16.5871C13.3823 16.8527 12.7083 17 12 17C9.23858 17 7 14.7614 7 12H10L7.17993 6.92387C5.83719 8.19929 5 10.0019 5 12C5 15.866 8.13401 19 12 19C13.0609 19 14.0666 18.764 14.9676 18.3417Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$541c90ebdf7fdf15(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.46257 4.43262C7.21556 2.91688 9.5007 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84827 6.46023 6.22842L5.46257 4.43262ZM18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 9.86386 2.66979 7.88416 3.8108 6.25944L7 12H4C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$13249810dfa20e85(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2C15.968 2 20 6.032 20 11C20 15.968 15.968 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2ZM19.4853 18.0711L22.3137 20.8995L20.8995 22.3137L18.0711 19.4853L19.4853 18.0711Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f67825a00b6ddee8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2C15.968 2 20 6.032 20 11C20 15.968 15.968 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2ZM11 18C14.8675 18 18 14.8675 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18ZM19.4853 18.0711L22.3137 20.8995L20.8995 22.3137L18.0711 19.4853L19.4853 18.0711Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$aa3cbb8e289cf5b8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM12.1779 7.17624C11.8055 7.06167 11.41 7 11 7C8.79086 7 7 8.79086 7 11C7 13.2091 8.79086 15 11 15C13.2091 15 15 13.2091 15 11C15 10.59 14.9383 10.1945 14.8238 9.82212C14.5102 10.5166 13.8115 11 13 11C11.8954 11 11 10.1046 11 9C11 8.18846 11.4834 7.48982 12.1779 7.17624Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f85925c6c93ed2ba(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748ZM12.1779 7.17624C11.4834 7.48982 11 8.18846 11 9C11 10.1046 11.8954 11 13 11C13.8115 11 14.5102 10.5166 14.8238 9.82212C14.9383 10.1945 15 10.59 15 11C15 13.2091 13.2091 15 11 15C8.79086 15 7 13.2091 7 11C7 8.79086 8.79086 7 11 7C11.41 7 11.8055 7.06167 12.1779 7.17624Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$202c3aa37a60c7de(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a434ab4faa87b661(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$74c6972de92850e1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.68735 4.00008L11.294 1.39348C11.6845 1.00295 12.3176 1.00295 12.7082 1.39348L15.3148 4.00008H19.0011C19.5533 4.00008 20.0011 4.4478 20.0011 5.00008V8.68637L22.6077 11.293C22.9982 11.6835 22.9982 12.3167 22.6077 12.7072L20.0011 15.3138V19.0001C20.0011 19.5524 19.5533 20.0001 19.0011 20.0001H15.3148L12.7082 22.6067C12.3176 22.9972 11.6845 22.9972 11.294 22.6067L8.68735 20.0001H5.00106C4.44877 20.0001 4.00106 19.5524 4.00106 19.0001V15.3138L1.39446 12.7072C1.00393 12.3167 1.00393 11.6835 1.39446 11.293L4.00106 8.68637V5.00008C4.00106 4.4478 4.44877 4.00008 5.00106 4.00008H8.68735ZM12.0011 15.0001C13.6579 15.0001 15.0011 13.6569 15.0011 12.0001C15.0011 10.3432 13.6579 9.00008 12.0011 9.00008C10.3442 9.00008 9.00106 10.3432 9.00106 12.0001C9.00106 13.6569 10.3442 15.0001 12.0011 15.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$218511d407600cba(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.68735 4.00008L11.294 1.39348C11.6845 1.00295 12.3176 1.00295 12.7082 1.39348L15.3148 4.00008H19.0011C19.5533 4.00008 20.0011 4.4478 20.0011 5.00008V8.68637L22.6077 11.293C22.9982 11.6835 22.9982 12.3167 22.6077 12.7072L20.0011 15.3138V19.0001C20.0011 19.5524 19.5533 20.0001 19.0011 20.0001H15.3148L12.7082 22.6067C12.3176 22.9972 11.6845 22.9972 11.294 22.6067L8.68735 20.0001H5.00106C4.44877 20.0001 4.00106 19.5524 4.00106 19.0001V15.3138L1.39446 12.7072C1.00393 12.3167 1.00393 11.6835 1.39446 11.293L4.00106 8.68637V5.00008C4.00106 4.4478 4.44877 4.00008 5.00106 4.00008H8.68735ZM6.00106 6.00008V9.5148L3.51578 12.0001L6.00106 14.4854V18.0001H9.51578L12.0011 20.4854L14.4863 18.0001H18.0011V14.4854L20.4863 12.0001L18.0011 9.5148V6.00008H14.4863L12.0011 3.5148L9.51578 6.00008H6.00106ZM12.0011 16.0001C9.79192 16.0001 8.00106 14.2092 8.00106 12.0001C8.00106 9.79094 9.79192 8.00008 12.0011 8.00008C14.2102 8.00008 16.0011 9.79094 16.0011 12.0001C16.0011 14.2092 14.2102 16.0001 12.0011 16.0001ZM12.0011 14.0001C13.1056 14.0001 14.0011 13.1047 14.0011 12.0001C14.0011 10.8955 13.1056 10.0001 12.0011 10.0001C10.8965 10.0001 10.0011 10.8955 10.0011 12.0001C10.0011 13.1047 10.8965 14.0001 12.0011 14.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8a058517f3358afe(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.95401 2.2106C11.2876 1.93144 12.6807 1.92263 14.0449 2.20785C14.2219 3.3674 14.9048 4.43892 15.9997 5.07103C17.0945 5.70313 18.364 5.75884 19.4566 5.3323C20.3858 6.37118 21.0747 7.58203 21.4997 8.87652C20.5852 9.60958 19.9997 10.736 19.9997 11.9992C19.9997 13.2632 20.5859 14.3902 21.5013 15.1232C21.29 15.7636 21.0104 16.3922 20.6599 16.9992C20.3094 17.6063 19.9049 18.1627 19.4559 18.6659C18.3634 18.2396 17.0943 18.2955 15.9997 18.9274C14.9057 19.559 14.223 20.6294 14.0453 21.7879C12.7118 22.067 11.3187 22.0758 9.95443 21.7906C9.77748 20.6311 9.09451 19.5595 7.99967 18.9274C6.90484 18.2953 5.63539 18.2396 4.54272 18.6662C3.61357 17.6273 2.92466 16.4164 2.49964 15.1219C3.41412 14.3889 3.99968 13.2624 3.99968 11.9992C3.99968 10.7353 3.41344 9.60827 2.49805 8.87524C2.70933 8.23482 2.98894 7.60629 3.33942 6.99923C3.68991 6.39217 4.09443 5.83576 4.54341 5.33257C5.63593 5.75881 6.90507 5.703 7.99967 5.07103C9.09364 4.43942 9.7764 3.3691 9.95401 2.2106ZM11.9997 14.9992C13.6565 14.9992 14.9997 13.6561 14.9997 11.9992C14.9997 10.3424 13.6565 8.99923 11.9997 8.99923C10.3428 8.99923 8.99967 10.3424 8.99967 11.9992C8.99967 13.6561 10.3428 14.9992 11.9997 14.9992Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8d7e7305f1c2c020(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.33946 17.0002C2.90721 16.2515 2.58277 15.4702 2.36133 14.6741C3.3338 14.1779 3.99972 13.1668 3.99972 12.0002C3.99972 10.8345 3.3348 9.824 2.36353 9.32741C2.81025 7.71651 3.65857 6.21627 4.86474 4.99001C5.7807 5.58416 6.98935 5.65534 7.99972 5.072C9.01009 4.48866 9.55277 3.40635 9.4962 2.31604C11.1613 1.8846 12.8847 1.90004 14.5031 2.31862C14.4475 3.40806 14.9901 4.48912 15.9997 5.072C17.0101 5.65532 18.2187 5.58416 19.1346 4.99007C19.7133 5.57986 20.2277 6.25151 20.66 7.00021C21.0922 7.7489 21.4167 8.53025 21.6381 9.32628C20.6656 9.82247 19.9997 10.8336 19.9997 12.0002C19.9997 13.166 20.6646 14.1764 21.6359 14.673C21.1892 16.2839 20.3409 17.7841 19.1347 19.0104C18.2187 18.4163 17.0101 18.3451 15.9997 18.9284C14.9893 19.5117 14.4467 20.5941 14.5032 21.6844C12.8382 22.1158 11.1148 22.1004 9.49633 21.6818C9.55191 20.5923 9.00929 19.5113 7.99972 18.9284C6.98938 18.3451 5.78079 18.4162 4.86484 19.0103C4.28617 18.4205 3.77172 17.7489 3.33946 17.0002ZM8.99972 17.1964C10.0911 17.8265 10.8749 18.8227 11.2503 19.9659C11.7486 20.0133 12.2502 20.014 12.7486 19.9675C13.1238 18.8237 13.9078 17.8268 14.9997 17.1964C16.0916 16.5659 17.347 16.3855 18.5252 16.6324C18.8146 16.224 19.0648 15.7892 19.2729 15.334C18.4706 14.4373 17.9997 13.2604 17.9997 12.0002C17.9997 10.74 18.4706 9.5632 19.2729 8.6665C19.1688 8.4405 19.0538 8.21822 18.9279 8.00021C18.802 7.78219 18.667 7.57148 18.5233 7.36842C17.3457 7.61476 16.0911 7.43414 14.9997 6.80405C13.9083 6.17395 13.1246 5.17768 12.7491 4.03455C12.2509 3.98714 11.7492 3.98646 11.2509 4.03292C10.8756 5.17671 10.0916 6.17364 8.99972 6.80405C7.9078 7.43447 6.65245 7.61494 5.47428 7.36803C5.18485 7.77641 4.93463 8.21117 4.72656 8.66637C5.52881 9.56311 5.99972 10.74 5.99972 12.0002C5.99972 13.2604 5.52883 14.4372 4.72656 15.3339C4.83067 15.5599 4.94564 15.7822 5.07152 16.0002C5.19739 16.2182 5.3324 16.4289 5.47612 16.632C6.65377 16.3857 7.90838 16.5663 8.99972 17.1964ZM11.9997 15.0002C10.3429 15.0002 8.99972 13.6571 8.99972 12.0002C8.99972 10.3434 10.3429 9.00021 11.9997 9.00021C13.6566 9.00021 14.9997 10.3434 14.9997 12.0002C14.9997 13.6571 13.6566 15.0002 11.9997 15.0002ZM11.9997 13.0002C12.552 13.0002 12.9997 12.5525 12.9997 12.0002C12.9997 11.4479 12.552 11.0002 11.9997 11.0002C11.4474 11.0002 10.9997 11.4479 10.9997 12.0002C10.9997 12.5525 11.4474 13.0002 11.9997 13.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d37674e9f2a898c2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.33409 4.54491C6.3494 3.63637 7.55145 2.9322 8.87555 2.49707C9.60856 3.4128 10.7358 3.99928 12 3.99928C13.2642 3.99928 14.3914 3.4128 15.1245 2.49707C16.4486 2.9322 17.6506 3.63637 18.6659 4.54491C18.2405 5.637 18.2966 6.90531 18.9282 7.99928C19.5602 9.09388 20.6314 9.77679 21.7906 9.95392C21.9279 10.6142 22 11.2983 22 11.9993C22 12.7002 21.9279 13.3844 21.7906 14.0446C20.6314 14.2218 19.5602 14.9047 18.9282 15.9993C18.2966 17.0932 18.2405 18.3616 18.6659 19.4536C17.6506 20.3622 16.4486 21.0664 15.1245 21.5015C14.3914 20.5858 13.2642 19.9993 12 19.9993C10.7358 19.9993 9.60856 20.5858 8.87555 21.5015C7.55145 21.0664 6.3494 20.3622 5.33409 19.4536C5.75952 18.3616 5.7034 17.0932 5.0718 15.9993C4.43983 14.9047 3.36862 14.2218 2.20935 14.0446C2.07212 13.3844 2 12.7002 2 11.9993C2 11.2983 2.07212 10.6142 2.20935 9.95392C3.36862 9.77679 4.43983 9.09388 5.0718 7.99928C5.7034 6.90531 5.75952 5.637 5.33409 4.54491ZM13.5 14.5974C14.9349 13.7689 15.4265 11.9342 14.5981 10.4993C13.7696 9.0644 11.9349 8.57277 10.5 9.4012C9.06512 10.2296 8.5735 12.0644 9.40192 13.4993C10.2304 14.9342 12.0651 15.4258 13.5 14.5974Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ea719617faa4e351(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 11.9998C2 11.1353 2.1097 10.2964 2.31595 9.49631C3.40622 9.55283 4.48848 9.01015 5.0718 7.99982C5.65467 6.99025 5.58406 5.78271 4.99121 4.86701C6.18354 3.69529 7.66832 2.82022 9.32603 2.36133C9.8222 3.33385 10.8333 3.99982 12 3.99982C13.1667 3.99982 14.1778 3.33385 14.674 2.36133C16.3317 2.82022 17.8165 3.69529 19.0088 4.86701C18.4159 5.78271 18.3453 6.99025 18.9282 7.99982C19.5115 9.01015 20.5938 9.55283 21.6841 9.49631C21.8903 10.2964 22 11.1353 22 11.9998C22 12.8643 21.8903 13.7032 21.6841 14.5033C20.5938 14.4468 19.5115 14.9895 18.9282 15.9998C18.3453 17.0094 18.4159 18.2169 19.0088 19.1326C17.8165 20.3043 16.3317 21.1794 14.674 21.6383C14.1778 20.6658 13.1667 19.9998 12 19.9998C10.8333 19.9998 9.8222 20.6658 9.32603 21.6383C7.66832 21.1794 6.18354 20.3043 4.99121 19.1326C5.58406 18.2169 5.65467 17.0094 5.0718 15.9998C4.48848 14.9895 3.40622 14.4468 2.31595 14.5033C2.1097 13.7032 2 12.8643 2 11.9998ZM6.80385 14.9998C7.43395 16.0912 7.61458 17.3459 7.36818 18.5236C7.77597 18.8138 8.21005 19.0652 8.66489 19.2741C9.56176 18.4712 10.7392 17.9998 12 17.9998C13.2608 17.9998 14.4382 18.4712 15.3351 19.2741C15.7899 19.0652 16.224 18.8138 16.6318 18.5236C16.3854 17.3459 16.566 16.0912 17.1962 14.9998C17.8262 13.9085 18.8225 13.1248 19.9655 12.7493C19.9884 12.5015 20 12.2516 20 11.9998C20 11.7481 19.9884 11.4981 19.9655 11.2504C18.8225 10.8749 17.8262 10.0912 17.1962 8.99982C16.566 7.90845 16.3854 6.65378 16.6318 5.47605C16.224 5.18588 15.7899 4.93447 15.3351 4.72552C14.4382 5.52844 13.2608 5.99982 12 5.99982C10.7392 5.99982 9.56176 5.52844 8.66489 4.72552C8.21005 4.93447 7.77597 5.18588 7.36818 5.47605C7.61458 6.65378 7.43395 7.90845 6.80385 8.99982C6.17376 10.0912 5.17754 10.8749 4.03451 11.2504C4.01157 11.4981 4 11.7481 4 11.9998C4 12.2516 4.01157 12.5015 4.03451 12.7493C5.17754 13.1248 6.17376 13.9085 6.80385 14.9998ZM12 14.9998C10.3431 14.9998 9 13.6567 9 11.9998C9 10.343 10.3431 8.99982 12 8.99982C13.6569 8.99982 15 10.343 15 11.9998C15 13.6567 13.6569 14.9998 12 14.9998ZM12 12.9998C12.5523 12.9998 13 12.5521 13 11.9998C13 11.4475 12.5523 10.9998 12 10.9998C11.4477 10.9998 11 11.4475 11 11.9998C11 12.5521 11.4477 12.9998 12 12.9998Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$69ccaee1c4a3f2b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.13225 13.6308C1.95018 12.5349 1.95619 11.434 2.13313 10.3695C3.23434 10.3963 4.22471 9.86798 4.60963 8.93871C4.99454 8.00944 4.66782 6.93557 3.87024 6.17581C4.49783 5.29798 5.27202 4.51528 6.17568 3.86911C6.93548 4.66716 8.00968 4.99416 8.9392 4.60914C9.86872 4.22412 10.3971 3.23332 10.37 2.13176C11.4659 1.94969 12.5668 1.9557 13.6313 2.13265C13.6045 3.23385 14.1329 4.22422 15.0621 4.60914C15.9914 4.99406 17.0653 4.66733 17.825 3.86975C18.7029 4.49734 19.4856 5.27153 20.1317 6.1752C19.3337 6.93499 19.0067 8.00919 19.3917 8.93871C19.7767 9.86823 20.7675 10.3966 21.8691 10.3695C22.0511 11.4654 22.0451 12.5663 21.8682 13.6308C20.767 13.6041 19.7766 14.1324 19.3917 15.0616C19.0068 15.9909 19.3335 17.0648 20.1311 17.8245C19.5035 18.7024 18.7293 19.4851 17.8256 20.1312C17.0658 19.3332 15.9916 19.0062 15.0621 19.3912C14.1326 19.7762 13.6043 20.767 13.6313 21.8686C12.5354 22.0507 11.4345 22.0447 10.37 21.8677C10.3968 20.7665 9.86847 19.7761 8.9392 19.3912C8.00993 19.0063 6.93605 19.333 6.1763 20.1306C5.29847 19.503 4.51577 18.7288 3.8696 17.8252C4.66765 17.0654 4.99465 15.9912 4.60963 15.0616C4.22461 14.1321 3.23381 13.6038 2.13225 13.6308ZM12.0007 15.0002C13.6575 15.0002 15.0007 13.657 15.0007 12.0002C15.0007 10.3433 13.6575 9.00018 12.0007 9.00018C10.3438 9.00018 9.00066 10.3433 9.00066 12.0002C9.00066 13.657 10.3438 15.0002 12.0007 15.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e51dc856148c87b9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.21329 14.0601C1.92026 12.6755 1.93213 11.2743 2.21413 9.94038C3.32405 10.0711 4.29284 9.7035 4.60963 8.93871C4.92641 8.17392 4.50129 7.22896 3.62405 6.53655C4.36788 5.3939 5.35029 4.39471 6.53651 3.62289C7.22898 4.50059 8.17422 4.92601 8.9392 4.60914C9.70418 4.29227 10.0717 3.32308 9.94077 2.21281C11.3253 1.91977 12.7265 1.93164 14.0605 2.21364C13.9298 3.32356 14.2973 4.29235 15.0621 4.60914C15.8269 4.92593 16.7719 4.5008 17.4643 3.62356C18.6069 4.36739 19.6061 5.3498 20.3779 6.53602C19.5002 7.22849 19.0748 8.17373 19.3917 8.93871C19.7086 9.70369 20.6778 10.0713 21.788 9.94028C22.0811 11.3248 22.0692 12.726 21.7872 14.06C20.6773 13.9293 19.7085 14.2969 19.3917 15.0616C19.0749 15.8264 19.5 16.7714 20.3773 17.4638C19.6335 18.6064 18.651 19.6056 17.4648 20.3775C16.7724 19.4998 15.8271 19.0743 15.0621 19.3912C14.2971 19.7081 13.9296 20.6773 14.0606 21.7875C12.676 22.0806 11.2748 22.0687 9.94087 21.7867C10.0716 20.6768 9.70399 19.708 8.9392 19.3912C8.17441 19.0744 7.22945 19.4995 6.53703 20.3768C5.39439 19.633 4.3952 18.6506 3.62338 17.4643C4.50108 16.7719 4.92649 15.8266 4.60963 15.0616C4.29276 14.2967 3.32356 13.9291 2.21329 14.0601ZM4.00073 12.2104C5.10054 12.5148 6.00815 13.2117 6.45739 14.2963C6.90662 15.3808 6.75764 16.5154 6.19519 17.5083C6.29175 17.61 6.39096 17.7092 6.4927 17.8056C7.48558 17.2432 8.6201 17.0943 9.70456 17.5435C10.789 17.9927 11.4859 18.9002 11.7904 19.9999C11.9305 20.0037 12.0707 20.0038 12.2109 20.0001C12.5153 18.9003 13.2122 17.9927 14.2968 17.5435C15.3813 17.0942 16.5159 17.2432 17.5088 17.8057C17.6105 17.7091 17.7096 17.6099 17.806 17.5081C17.2437 16.5153 17.0947 15.3807 17.5439 14.2963C17.9931 13.2118 18.9007 12.5149 20.0004 12.2105C20.0042 12.0704 20.0043 11.9301 20.0006 11.7899C18.9008 11.4856 17.9932 10.7886 17.5439 9.70407C17.0947 8.61953 17.2437 7.48494 17.8061 6.49204C17.7096 6.39031 17.6104 6.2912 17.5086 6.19479C16.5158 6.75717 15.3812 6.9061 14.2968 6.4569C13.2123 6.0077 12.5154 5.10016 12.211 4.00044C12.0709 3.99666 11.9306 3.99659 11.7904 4.00024C11.486 5.10005 10.7891 6.00767 9.70456 6.4569C8.62002 6.90613 7.48543 6.75715 6.49252 6.1947C6.39079 6.29126 6.29169 6.39047 6.19528 6.49222C6.75766 7.48509 6.90659 8.61961 6.45739 9.70407C6.00819 10.7885 5.10065 11.4855 4.00092 11.7899C3.99715 11.93 3.99708 12.0702 4.00073 12.2104ZM12.0007 15.0002C10.3438 15.0002 9.00066 13.657 9.00066 12.0002C9.00066 10.3433 10.3438 9.00018 12.0007 9.00018C13.6575 9.00018 15.0007 10.3433 15.0007 12.0002C15.0007 13.657 13.6575 15.0002 12.0007 15.0002ZM12.0007 13.0002C12.5529 13.0002 13.0007 12.5525 13.0007 12.0002C13.0007 11.4479 12.5529 11.0002 12.0007 11.0002C11.4484 11.0002 11.0007 11.4479 11.0007 12.0002C11.0007 12.5525 11.4484 13.0002 12.0007 13.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$afab4ab230f487e1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 2.47363L23 11.9999L17.5 21.5262H6.5L1 11.9999L6.5 2.47363H17.5ZM8.63398 8.16979L13.634 16.83L15.366 15.83L10.366 7.16979L8.63398 8.16979Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$35742f064cff2f65(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 2.47363L23 11.9999L17.5 21.5262H6.5L1 11.9999L6.5 2.47363H17.5ZM16.3453 4.47363H7.6547L3.3094 11.9999L7.6547 19.5262H16.3453L20.6906 11.9999L16.3453 4.47363ZM8.63398 8.16979L10.366 7.16979L15.366 15.83L13.634 16.83L8.63398 8.16979Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e1c5f6238a69a223(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dc4022c2a4f8e21b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM12 3.311L4.5 7.65311V16.3469L12 20.689L19.5 16.3469V7.65311L12 3.311ZM12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f9330e457d49e135(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3V5H5V19H19V14H21V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H10ZM17.7071 7.70711L12 13.4142L10.5858 12L16.2929 6.29289L13 3H21V11L17.7071 7.70711Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5d9abb98c493ad50(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3V5H5V19H19V14H21V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H10ZM17.5858 5H13V3H21V11H19V6.41421L12 13.4142L10.5858 12L17.5858 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$16cb57bac3cca1a5(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2.04938V4.06189C7.05369 4.55399 4 7.92038 4 12C4 16.4183 7.58172 20 12 20C16.0796 20 19.446 16.9463 19.9381 13H21.9506C21.4489 18.0533 17.1853 22 12 22C6.47715 22 2 17.5228 2 12C2 6.81465 5.94668 2.5511 11 2.04938ZM18.7071 6.70711L12 13.4142L10.5858 12L17.2929 5.29289L14 2H22V10L18.7071 6.70711Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$15e63ee5ff8110ae(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2.04938V4.06189C7.05369 4.55399 4 7.92038 4 12C4 16.4183 7.58172 20 12 20C16.0796 20 19.446 16.9463 19.9381 13H21.9506C21.4489 18.0533 17.1853 22 12 22C6.47715 22 2 17.5228 2 12C2 6.81465 5.94668 2.5511 11 2.04938ZM20 5.41421L12 13.4142L10.5858 12L18.5858 4H14V2H22V10H20V5.41421Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$81718c7a30505a3a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5759 17.2714L8.46576 14.484C7.83312 15.112 6.96187 15.5 6 15.5C4.067 15.5 2.5 13.933 2.5 12C2.5 10.067 4.067 8.5 6 8.5C6.96181 8.5 7.83301 8.88796 8.46564 9.51593L13.5759 6.72855C13.5262 6.49354 13.5 6.24983 13.5 6C13.5 4.067 15.067 2.5 17 2.5C18.933 2.5 20.5 4.067 20.5 6C20.5 7.933 18.933 9.5 17 9.5C16.0381 9.5 15.1669 9.11201 14.5343 8.48399L9.42404 11.2713C9.47382 11.5064 9.5 11.7501 9.5 12C9.5 12.2498 9.47383 12.4935 9.42408 12.7285L14.5343 15.516C15.167 14.888 16.0382 14.5 17 14.5C18.933 14.5 20.5 16.067 20.5 18C20.5 19.933 18.933 21.5 17 21.5C15.067 21.5 13.5 19.933 13.5 18C13.5 17.7502 13.5262 17.5064 13.5759 17.2714Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bd11ad985ec3dd9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19H20V14H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V14H4V19ZM12 10H9C7.00442 10 5.23638 10.9742 4.14556 12.473C4.85831 8.78512 8.10391 6 12 6V2L20 8L12 14V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$da57a061222cc4e6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18.9997H20V13.9997H22V19.9997C22 20.552 21.5523 20.9997 21 20.9997H3C2.44772 20.9997 2 20.552 2 19.9997V13.9997H4V18.9997ZM16.1716 6.9997L12.2218 3.04996L13.636 1.63574L20 7.9997L13.636 14.3637L12.2218 12.9495L16.1716 8.9997H5V6.9997H16.1716Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d2e41519c7b37a2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3V5H4V19H20V10H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H9ZM16 5V1L23 7H14C12.8954 7 12 7.89543 12 9V15H10V9C10 6.79086 11.7909 5 14 5H16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9c8d717276bb266e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2.9997V4.9997H4V18.9997H20V9.9997H22V19.9997C22 20.552 21.5523 20.9997 21 20.9997H3C2.44772 20.9997 2 20.552 2 19.9997V3.9997C2 3.44742 2.44772 2.9997 3 2.9997H9ZM18.9497 4.9997L16 2.04996L17.4142 0.635742L22.7539 5.97544C22.9882 6.20975 22.9882 6.58965 22.7539 6.82397C22.6414 6.93649 22.4888 6.9997 22.3296 6.9997H14C12.8954 6.9997 12 7.89513 12 8.9997V14.9997H10V8.9997C10 6.79056 11.7909 4.9997 14 4.9997H18.9497Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$700ba6dfe4bfb0d3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 14H11C7.54202 14 4.53953 15.9502 3.03239 18.8107C3.01093 18.5433 3 18.2729 3 18C3 12.4772 7.47715 8 13 8V3L23 11L13 19V14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7be630264e85bf9e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 14H11C7.54202 14 4.53953 15.9502 3.03239 18.8107C3.01093 18.5433 3 18.2729 3 18C3 12.4772 7.47715 8 13 8V2.5L23.5 11L13 19.5V14ZM11 12H15V15.3078L20.3214 11L15 6.69224V10H13C10.5795 10 8.41011 11.0749 6.94312 12.7735C8.20873 12.2714 9.58041 12 11 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2078a6ac36627b7a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.1202 17.0228L8.92129 14.7324C8.19135 15.5125 7.15261 16 6 16C3.79086 16 2 14.2091 2 12C2 9.79086 3.79086 8 6 8C7.15255 8 8.19125 8.48746 8.92118 9.26746L13.1202 6.97713C13.0417 6.66441 13 6.33707 13 6C13 3.79086 14.7909 2 17 2C19.2091 2 21 3.79086 21 6C21 8.20914 19.2091 10 17 10C15.8474 10 14.8087 9.51251 14.0787 8.73246L9.87977 11.0228C9.9583 11.3355 10 11.6629 10 12C10 12.3371 9.95831 12.6644 9.87981 12.9771L14.0788 15.2675C14.8087 14.4875 15.8474 14 17 14C19.2091 14 21 15.7909 21 18C21 20.2091 19.2091 22 17 22C14.7909 22 13 20.2091 13 18C13 17.6629 13.0417 17.3355 13.1202 17.0228ZM6 14C7.10457 14 8 13.1046 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14ZM17 8C18.1046 8 19 7.10457 19 6C19 4.89543 18.1046 4 17 4C15.8954 4 15 4.89543 15 6C15 7.10457 15.8954 8 17 8ZM17 20C18.1046 20 19 19.1046 19 18C19 16.8954 18.1046 16 17 16C15.8954 16 15 16.8954 15 18C15 19.1046 15.8954 20 17 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ba66bfa2608113c9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598L12 1ZM16.4524 8.22183L11.5019 13.1709L8.67421 10.3431L7.25999 11.7574L11.5026 16L17.8666 9.63604L16.4524 8.22183Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$36ce79792ecc4e82(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598L12 1ZM12 3.04879L5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879ZM16.4524 8.22183L17.8666 9.63604L11.5026 16L7.25999 11.7574L8.67421 10.3431L11.5019 13.1709L16.4524 8.22183Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cdd5cae27105dc43(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM11 10H8V12H11V15H13V12H16V10H13V7H11V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$23f04ff7f35b88e8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879L5 4.60434ZM11 10V7H13V10H16V12H13V15H11V12H8V10H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$23e1f9ef783ad852(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ba0b3fae23a68ed8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM13 10V5L8 12H11V17L16 10H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$94239b1e2ad521a2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879L5 4.60434ZM13 10H16L11 17V12H8L13 5V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1c600eef626bb55f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598L12 1ZM12 7C10.8954 7 10 7.89543 10 9C10 9.74025 10.4022 10.3866 10.9999 10.7324L11 15H13L13.0011 10.7318C13.5983 10.3858 14 9.73984 14 9C14 7.89543 13.1046 7 12 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b830887aa10993d4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598L12 1ZM12 3.04879L5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879ZM12 7C13.1046 7 14 7.89543 14 9C14 9.73984 13.5983 10.3858 13.0011 10.7318L13 15H11L10.9999 10.7324C10.4022 10.3866 10 9.74025 10 9C10 7.89543 10.8954 7 12 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8380a5a29d59df3f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879L5 4.60434Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a3515e8205cdfe72(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM12 13.5L14.9389 15.0451L14.3776 11.7725L16.7553 9.45492L13.4695 8.97746L12 6L10.5305 8.97746L7.24472 9.45492L9.62236 11.7725L9.06107 15.0451L12 13.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7863f1d5c8700c4a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879L5 4.60434ZM3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM12 13.5L9.06107 15.0451L9.62236 11.7725L7.24472 9.45492L10.5305 8.97746L12 6L13.4695 8.97746L16.7553 9.45492L14.3776 11.7725L14.9389 15.0451L12 13.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$fdb3cc61fa6f82e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM12 11C13.3807 11 14.5 9.88071 14.5 8.5C14.5 7.11929 13.3807 6 12 6C10.6193 6 9.5 7.11929 9.5 8.5C9.5 9.88071 10.6193 11 12 11ZM7.52746 16H16.4725C16.2238 13.75 14.3163 12 12 12C9.68372 12 7.77619 13.75 7.52746 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5526875c87eb8cff(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879L5 4.60434ZM12 11C10.6193 11 9.5 9.88071 9.5 8.5C9.5 7.11929 10.6193 6 12 6C13.3807 6 14.5 7.11929 14.5 8.5C14.5 9.88071 13.3807 11 12 11ZM7.52746 16C7.77619 13.75 9.68372 12 12 12C14.3163 12 16.2238 13.75 16.4725 16H7.52746Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ac891f5f1da0f90d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM9 5V19H20V5H9Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2eeec4da30964e12(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM8 5H4V19H8V5ZM10 5V19H20V5H10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$57c1db63cc2ebb19(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.935 2.50098L21.5 8.06595V15.936L15.935 21.501H8.06497L2.5 15.936V8.06595L8.06497 2.50098H15.935ZM10.9993 15.0002V17.0002H12.9993V15.0002H10.9993ZM10.9993 7.00024V13.0002H12.9993V7.00024H10.9993Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8f2e7f4279aa46bd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.935 2.50098L21.5 8.06595V15.936L15.935 21.501H8.06497L2.5 15.936V8.06595L8.06497 2.50098H15.935ZM15.1066 4.50098H8.8934L4.5 8.89437V15.1076L8.8934 19.501H15.1066L19.5 15.1076V8.89437L15.1066 4.50098ZM10.9993 15.0002H12.9993V17.0002H10.9993V15.0002ZM10.9993 7.00024H12.9993V13.0002H10.9993V7.00024Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$95c12a088851573(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.935 2.50098L21.5 8.06595V15.936L15.935 21.501H8.06497L2.5 15.936V8.06595L8.06497 2.50098H15.935ZM7.99926 11.0002V13.0002H15.9993V11.0002H7.99926Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e42f5372c883ed9f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.935 2.50098L21.5 8.06595V15.936L15.935 21.501H8.06497L2.5 15.936V8.06595L8.06497 2.50098H15.935ZM15.1066 4.50098H8.8934L4.5 8.89437V15.1076L8.8934 19.501H15.1066L19.5 15.1076V8.89437L15.1066 4.50098ZM7.99926 11.0002H15.9993V13.0002H7.99926V11.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$66ba24640bfd5ace(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 2.5L23 12L17.5 21.5H6.5L1 12L6.5 2.5H17.5ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9c62eea104fc4e7a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 2.5L23 12L17.5 21.5H6.5L1 12L6.5 2.5H17.5ZM16.3469 4.5H7.65311L3.311 12L7.65311 19.5H16.3469L20.689 12L16.3469 4.5ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b7f1fc377ee21068(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7c288f2916f36575(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0006 15.968L16.2473 18.3451L15.2988 13.5717L18.8719 10.2674L14.039 9.69434L12.0006 5.27502V15.968ZM12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f121e208ac4fd115(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0006 15.968L16.2473 18.3451L15.2988 13.5717L18.8719 10.2674L14.039 9.69434L12.0006 5.27502V15.968ZM12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ca536de5a35bf5c6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0008 14.6564L14.8175 16.3769L14.0517 13.1664L16.5583 11.0192L13.2683 10.7554L12.0008 7.70792V14.6564ZM12.0008 17L6.12295 20.5902L7.72105 13.8906L2.49023 9.40983L9.35577 8.85942L12.0008 2.5L14.6458 8.85942L21.5114 9.40983L16.2806 13.8906L17.8787 20.5902L12.0008 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$35b72ee2998f5d2e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0008 14.6564L14.8175 16.3769L14.0517 13.1664L16.5583 11.0192L13.2683 10.7554L12.0008 7.70792V14.6564ZM12.0008 17L6.12295 20.5902L7.72105 13.8906L2.49023 9.40983L9.35577 8.85942L12.0008 2.5L14.6458 8.85942L21.5114 9.40983L16.2806 13.8906L17.8787 20.5902L12.0008 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ba9ef77e6f73e336(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26ZM12.0006 15.968L16.2473 18.3451L15.2988 13.5717L18.8719 10.2674L14.039 9.69434L12.0006 5.27502L9.96214 9.69434L5.12921 10.2674L8.70231 13.5717L7.75383 18.3451L12.0006 15.968Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$abb9ab495961d549(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0008 17L6.12295 20.5902L7.72105 13.8906L2.49023 9.40983L9.35577 8.85942L12.0008 2.5L14.6458 8.85942L21.5114 9.40983L16.2806 13.8906L17.8787 20.5902L12.0008 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$298d6af66f91970c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0008 17L6.12295 20.5902L7.72105 13.8906L2.49023 9.40983L9.35577 8.85942L12.0008 2.5L14.6458 8.85942L21.5114 9.40983L16.2806 13.8906L17.8787 20.5902L12.0008 17ZM12.0008 14.6564L14.8175 16.3769L14.0517 13.1664L16.5583 11.0192L13.2683 10.7554L12.0008 7.70792L10.7333 10.7554L7.44326 11.0192L9.94991 13.1664L9.18408 16.3769L12.0008 14.6564Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$62080b02595087c7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11H5V13H19V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e3fb3e87d598c4a0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11V13H19V11H5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2d6940d21e1460eb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 15H19V3H22C22.5523 3 23 3.44772 23 4V14C23 14.5523 22.5523 15 22 15ZM16.7071 16.2929L10.3066 22.6934C10.1307 22.8693 9.85214 22.8891 9.65308 22.7398L8.8005 22.1004C8.3158 21.7369 8.09739 21.1174 8.24686 20.5303L9.40017 16H3C1.89543 16 1 15.1046 1 14V11.8957C1 11.6344 1.05118 11.3757 1.15064 11.1342L4.24501 3.61925C4.3993 3.24455 4.76447 3 5.16969 3H16C16.5523 3 17 3.44772 17 4V15.5858C17 15.851 16.8946 16.1054 16.7071 16.2929Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bf8f7ed7424c3169(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.40017 16H3C1.89543 16 1 15.1046 1 14V11.8957C1 11.6344 1.05118 11.3757 1.15064 11.1342L4.24501 3.61925C4.3993 3.24455 4.76447 3 5.16969 3H22C22.5523 3 23 3.44772 23 4V14C23 14.5523 22.5523 15 22 15H18.5182C18.1932 15 17.8886 15.1579 17.7012 15.4233L12.2478 23.149C12.1053 23.3508 11.8367 23.4184 11.6157 23.3078L9.80163 22.4008C8.74998 21.875 8.20687 20.6874 8.49694 19.548L9.40017 16ZM17 13.4125V5H5.83939L3 11.8957V14H9.40017C10.7049 14 11.6602 15.229 11.3384 16.4934L10.4351 20.0414C10.3771 20.2693 10.4857 20.5068 10.6961 20.612L11.3572 20.9425L16.0673 14.27C16.3172 13.9159 16.6366 13.6257 17 13.4125ZM19 13H21V5H19V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ecec4403ef684338(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8.99997H5V21H2C1.44772 21 1 20.5523 1 20V9.99997C1 9.44769 1.44772 8.99997 2 8.99997ZM7.29289 7.70708L13.6934 1.30661C13.8693 1.13066 14.1479 1.11087 14.3469 1.26016L15.1995 1.8996C15.6842 2.26312 15.9026 2.88253 15.7531 3.46966L14.5998 7.99997H21C22.1046 7.99997 23 8.8954 23 9.99997V12.1043C23 12.3656 22.9488 12.6243 22.8494 12.8658L19.755 20.3807C19.6007 20.7554 19.2355 21 18.8303 21H8C7.44772 21 7 20.5523 7 20V8.41419C7 8.14897 7.10536 7.89462 7.29289 7.70708Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$159d610cd509a5ee(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5998 8.00033H21C22.1046 8.00033 23 8.89576 23 10.0003V12.1047C23 12.3659 22.9488 12.6246 22.8494 12.8662L19.755 20.3811C19.6007 20.7558 19.2355 21.0003 18.8303 21.0003H2C1.44772 21.0003 1 20.5526 1 20.0003V10.0003C1 9.44804 1.44772 9.00033 2 9.00033H5.48184C5.80677 9.00033 6.11143 8.84246 6.29881 8.57701L11.7522 0.851355C11.8947 0.649486 12.1633 0.581978 12.3843 0.692483L14.1984 1.59951C15.25 2.12534 15.7931 3.31292 15.5031 4.45235L14.5998 8.00033ZM7 10.5878V19.0003H18.1606L21 12.1047V10.0003H14.5998C13.2951 10.0003 12.3398 8.77128 12.6616 7.50691L13.5649 3.95894C13.6229 3.73105 13.5143 3.49353 13.3039 3.38837L12.6428 3.0578L7.93275 9.73038C7.68285 10.0844 7.36341 10.3746 7 10.5878ZM5 11.0003H3V19.0003H5V11.0003Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7392fd2e7615eabf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM13 12V7H11V14H17V12H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$32ccfeabb8463b5c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM13 12H17V14H11V7H13V12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2bacd1e9c8d9b582(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM15.5355 7.05025L10.5858 12L12 13.4142L16.9497 8.46447L15.5355 7.05025Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$acee6cf5ab8ae6e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM15.5355 7.05025L16.9497 8.46447L12 13.4142L10.5858 12L15.5355 7.05025Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e06bda8fcb1154e1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6177 5.9681L19.0711 4.51472L20.4853 5.92893L19.0319 7.38231C20.2635 8.92199 21 10.875 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 8.02944 7.02944 4 12 4C14.125 4 16.078 4.73647 17.6177 5.9681ZM11 8V14H13V8H11ZM8 1H16V3H8V1Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cef6cfb1dcf8d444(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.38231 5.9681C7.92199 4.73647 9.87499 4 12 4C14.125 4 16.078 4.73647 17.6177 5.9681L19.0711 4.51472L20.4853 5.92893L19.0319 7.38231C20.2635 8.92199 21 10.875 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 10.875 3.73647 8.92199 4.9681 7.38231L3.51472 5.92893L4.92893 4.51472L6.38231 5.9681ZM13 12V7.4952L8 14H11V18.5L16 12H13ZM8 1H16V3H8V1Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a1b30212b200292d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.38231 5.9681C7.92199 4.73647 9.87499 4 12 4C14.125 4 16.078 4.73647 17.6177 5.9681L19.0711 4.51472L20.4853 5.92893L19.0319 7.38231C20.2635 8.92199 21 10.875 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 10.875 3.73647 8.92199 4.9681 7.38231L3.51472 5.92893L4.92893 4.51472L6.38231 5.9681ZM12 20C15.866 20 19 16.866 19 13C19 9.13401 15.866 6 12 6C8.13401 6 5 9.13401 5 13C5 16.866 8.13401 20 12 20ZM13 12H16L11 18.5V14H8L13 7.4952V12ZM8 1H16V3H8V1Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3c23811f60013cdf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6177 5.9681L19.0711 4.51472L20.4853 5.92893L19.0319 7.38231C20.2635 8.92199 21 10.875 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 8.02944 7.02944 4 12 4C14.125 4 16.078 4.73647 17.6177 5.9681ZM12 20C15.866 20 19 16.866 19 13C19 9.13401 15.866 6 12 6C8.13401 6 5 9.13401 5 13C5 16.866 8.13401 20 12 20ZM11 8H13V14H11V8ZM8 1H16V3H8V1Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7510fb1eebcf0eac(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5H16C19.866 5 23 8.13401 23 12C23 15.866 19.866 19 16 19H8C4.13401 19 1 15.866 1 12C1 8.13401 4.13401 5 8 5ZM16 15C17.6569 15 19 13.6569 19 12C19 10.3431 17.6569 9 16 9C14.3431 9 13 10.3431 13 12C13 13.6569 14.3431 15 16 15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c52291717fd09525(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7C5.23858 7 3 9.23858 3 12C3 14.7614 5.23858 17 8 17H16C18.7614 17 21 14.7614 21 12C21 9.23858 18.7614 7 16 7H8ZM8 5H16C19.866 5 23 8.13401 23 12C23 15.866 19.866 19 16 19H8C4.13401 19 1 15.866 1 12C1 8.13401 4.13401 5 8 5ZM8 15C6.34315 15 5 13.6569 5 12C5 10.3431 6.34315 9 8 9C9.65685 9 11 10.3431 11 12C11 13.6569 9.65685 15 8 15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e8a17d0fa5f2d386(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19ZM14 9V15H10V9H5L12 2L19 9H14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ace2e01d94a213b0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19ZM13 9V16H11V9H6L12 3L18 9H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cdaea09432fa5a83(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.5858L16.2426 16.8284L14.8284 18.2426L13 16.415V22H11V16.413L9.17157 18.2426L7.75736 16.8284L12 12.5858ZM12 2C15.5934 2 18.5544 4.70761 18.9541 8.19395C21.2858 8.83154 23 10.9656 23 13.5C23 16.3688 20.8036 18.7246 18.0006 18.9776L18 17C18 13.6863 15.3137 11 12 11C8.7616 11 6.12243 13.5656 6.00414 16.7751L6 17L6.00039 18.9776C3.19696 18.7252 1 16.3692 1 13.5C1 10.9656 2.71424 8.83154 5.04648 8.19411C5.44561 4.70761 8.40661 2 12 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d3e66c030907f12(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.5858L16.2426 16.8284L14.8284 18.2426L13 16.415V22H11V16.413L9.17157 18.2426L7.75736 16.8284L12 12.5858ZM12 2C15.5934 2 18.5544 4.70761 18.9541 8.19395C21.2858 8.83154 23 10.9656 23 13.5C23 16.3688 20.8036 18.7246 18.0006 18.9776L18.0009 16.9644C19.6966 16.7214 21 15.2629 21 13.5C21 11.567 19.433 10 17.5 10C17.2912 10 17.0867 10.0183 16.8887 10.054C16.9616 9.7142 17 9.36158 17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 9.36158 7.03838 9.7142 7.11205 10.0533C6.91331 10.0183 6.70879 10 6.5 10C4.567 10 3 11.567 3 13.5C3 15.2003 4.21241 16.6174 5.81986 16.934L6.00005 16.9646L6.00039 18.9776C3.19696 18.7252 1 16.3692 1 13.5C1 10.9656 2.71424 8.83154 5.04648 8.19411C5.44561 4.70761 8.40661 2 12 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4ea24b753ffdc16d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20.9811C3.64378 20.7257 1 17.9216 1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811V21H7V20.9811ZM13 13H16L12 8L8 13H11V17H13V13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f74e072fcac5a384(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811L7 21C3.64378 20.7257 1 17.9216 1 14.5ZM16.8483 18.9868C19.1817 18.8093 21 16.8561 21 14.5C21 12.927 20.1884 11.4962 18.8771 10.6781L18.0714 10.1754L17.9517 9.23338C17.5735 6.25803 15.0288 4 12 4C8.97116 4 6.42647 6.25803 6.0483 9.23338L5.92856 10.1754L5.12288 10.6781C3.81156 11.4962 3 12.927 3 14.5C3 16.8561 4.81833 18.8093 7.1517 18.9868L7.325 19H16.675L16.8483 18.9868ZM13 13V17H11V13H8L12 8L16 13H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$692f9687499fbeb3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19H21V21H3V19ZM13 10V18H11V10H4L12 2L20 10H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b9c5ec4f2b146f80(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19H21V21H3V19ZM13 5.82843V17H11V5.82843L4.92893 11.8995L3.51472 10.4853L12 2L20.4853 10.4853L19.0711 11.8995L13 5.82843Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$71547fc4bb62c497(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM10 10H7V12H10V15H12V12H15V10H12V7H10V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d29b2f01e552a344(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748ZM10 10V7H12V10H15V12H12V15H10V12H7V10H10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8c8652c8a4c0bea6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM7 10V12H15V10H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d922eb4f1a0e5590(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748ZM7 10H15V12H7V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c4befbdafd66ef32(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4.99509C3 3.89323 3.89262 3 4.99509 3H19.0049C20.1068 3 21 3.89262 21 4.99509V19.0049C21 20.1068 20.1074 21 19.0049 21H4.99509C3.89323 21 3 20.1074 3 19.0049V4.99509ZM6.35687 18H17.8475C16.5825 16.1865 14.4809 15 12.1022 15C9.72344 15 7.62182 16.1865 6.35687 18ZM12 13C13.933 13 15.5 11.433 15.5 9.5C15.5 7.567 13.933 6 12 6C10.067 6 8.5 7.567 8.5 9.5C8.5 11.433 10.067 13 12 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$487d1e1fe3e9f3d6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4.99509C3 3.89323 3.89262 3 4.99509 3H19.0049C20.1068 3 21 3.89262 21 4.99509V19.0049C21 20.1068 20.1074 21 19.0049 21H4.99509C3.89323 21 3 20.1074 3 19.0049V4.99509ZM5 5V19H19V5H5ZM7.97216 18.1808C7.35347 17.9129 6.76719 17.5843 6.22083 17.2024C7.46773 15.2753 9.63602 14 12.1022 14C14.5015 14 16.6189 15.2071 17.8801 17.0472C17.3438 17.4436 16.7664 17.7877 16.1555 18.0718C15.2472 16.8166 13.77 16 12.1022 16C10.3865 16 8.87271 16.8641 7.97216 18.1808ZM12 13C10.067 13 8.5 11.433 8.5 9.5C8.5 7.567 10.067 6 12 6C13.933 6 15.5 7.567 15.5 9.5C15.5 11.433 13.933 13 12 13ZM12 11C12.8284 11 13.5 10.3284 13.5 9.5C13.5 8.67157 12.8284 8 12 8C11.1716 8 10.5 8.67157 10.5 9.5C10.5 10.3284 11.1716 11 12 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f13c4c8fe4f73d78(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM6.02332 15.4163C7.49083 17.6069 9.69511 19 12.1597 19C14.6243 19 16.8286 17.6069 18.2961 15.4163C16.6885 13.9172 14.5312 13 12.1597 13C9.78821 13 7.63095 13.9172 6.02332 15.4163ZM12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7d084a41161869e2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12.1597 16C10.1243 16 8.29182 16.8687 7.01276 18.2556C8.38039 19.3474 10.114 20 12 20C13.9695 20 15.7727 19.2883 17.1666 18.1081C15.8956 16.8074 14.1219 16 12.1597 16ZM12 4C7.58172 4 4 7.58172 4 12C4 13.8106 4.6015 15.4807 5.61557 16.8214C7.25639 15.0841 9.58144 14 12.1597 14C14.6441 14 16.8933 15.0066 18.5218 16.6342C19.4526 15.3267 20 13.7273 20 12C20 7.58172 16.4183 4 12 4ZM12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9C8 6.79086 9.79086 5 12 5ZM12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$108e36805655b469(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 21L12 23L10 21H4.99509C3.89323 21 3 20.1074 3 19.0049V4.99509C3 3.89323 3.89262 3 4.99509 3H19.0049C20.1068 3 21 3.89262 21 4.99509V19.0049C21 20.1068 20.1074 21 19.0049 21H14ZM6.35687 18H17.8475C16.5825 16.1865 14.4809 15 12.1022 15C9.72344 15 7.62182 16.1865 6.35687 18ZM12 13C13.933 13 15.5 11.433 15.5 9.5C15.5 7.567 13.933 6 12 6C10.067 6 8.5 7.567 8.5 9.5C8.5 11.433 10.067 13 12 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a18eda8457e4c0de(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 21L12 23L10 21H4.99509C3.89323 21 3 20.1074 3 19.0049V4.99509C3 3.89323 3.89262 3 4.99509 3H19.0049C20.1068 3 21 3.89262 21 4.99509V19.0049C21 20.1068 20.1074 21 19.0049 21H14ZM19 19V5H5V19H10.8284L12 20.1716L13.1716 19H19ZM7.97216 18.1808C7.35347 17.9129 6.76719 17.5843 6.22083 17.2024C7.46773 15.2753 9.63602 14 12.1022 14C14.5015 14 16.6189 15.2071 17.8801 17.0472C17.3438 17.4436 16.7664 17.7877 16.1555 18.0718C15.2472 16.8166 13.77 16 12.1022 16C10.3865 16 8.87271 16.8641 7.97216 18.1808ZM12 13C10.067 13 8.5 11.433 8.5 9.5C8.5 7.567 10.067 6 12 6C13.933 6 15.5 7.567 15.5 9.5C15.5 11.433 13.933 13 12 13ZM12 11C12.8284 11 13.5 10.3284 13.5 9.5C13.5 8.67157 12.8284 8 12 8C11.1716 8 10.5 8.67157 10.5 9.5C10.5 10.3284 11.1716 11 12 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5f8f582c15f10927(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.2558 21.7442L12 24L9.74416 21.7442C5.30941 20.7204 2 16.7443 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 16.7443 18.6906 20.7204 14.2558 21.7442ZM6.02332 15.4163C7.49083 17.6069 9.69511 19 12.1597 19C14.6243 19 16.8286 17.6069 18.2961 15.4163C16.6885 13.9172 14.5312 13 12.1597 13C9.78821 13 7.63095 13.9172 6.02332 15.4163ZM12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6b11e57a83b31340(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.74462 21.7446C5.30798 20.7219 2 16.7473 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 16.7473 18.692 20.7219 14.2554 21.7446L12 24L9.74462 21.7446ZM7.01173 18.2567C7.92447 18.986 9.00433 19.5215 10.1939 19.7957L10.7531 19.9246L12 21.1716L13.2469 19.9246L13.8061 19.7957C15.0745 19.5033 16.2183 18.9139 17.1676 18.1091C15.8965 16.8078 14.1225 16 12.1597 16C10.1238 16 8.29083 16.8692 7.01173 18.2567ZM5.61562 16.8214C7.25644 15.0841 9.58146 14 12.1597 14C14.644 14 16.8931 15.0065 18.5216 16.634C19.4563 15.3185 20 13.7141 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 13.7964 4.59708 15.4722 5.61562 16.8214ZM12 13C9.79086 13 8 11.2091 8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13ZM12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$722d5ea36c9e303a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14V22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM21 17H22V22H14V17H15V16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16V17ZM19 17V16C19 15.4477 18.5523 15 18 15C17.4477 15 17 15.4477 17 16V17H19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2a59fa71080f081d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14V16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM21 17H22V22H14V17H15V16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16V17ZM19 17V16C19 15.4477 18.5523 15 18 15C17.4477 15 17 15.4477 17 16V17H19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d45db9b484fae2c2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C16.6944 2 20.5 5.80558 20.5 10.5C20.5 17 15 22.5 12 22.5C9 22.5 3.5 17 3.5 10.5C3.5 5.80558 7.30558 2 12 2ZM17.5 12C15.0147 12 13 14.0147 13 16.5C13 16.6603 13.0084 16.8186 13.0252 16.9752C13.1812 16.9916 13.3396 17 13.5 17C15.9853 17 18 14.9853 18 12.5C18 12.3396 17.9916 12.1812 17.9746 12.0247C17.8186 12.0084 17.6603 12 17.5 12ZM6.5 12C6.33963 12 6.18121 12.0084 6.02475 12.0252C6.00839 12.1812 6 12.3396 6 12.5C6 14.9853 8.01472 17 10.5 17C10.6603 17 10.8186 16.9916 10.9753 16.9746C10.9916 16.8186 11 16.6603 11 16.5C11 14.0147 8.98528 12 6.5 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8c2bbdc71cf5fc83(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C16.6944 2 20.5 5.80558 20.5 10.5C20.5 17 15 22.5 12 22.5C9 22.5 3.5 17 3.5 10.5C3.5 5.80558 7.30558 2 12 2ZM12 4C8.41015 4 5.5 6.91015 5.5 10.5C5.5 15.2938 9.665 20.5 12 20.5C14.335 20.5 18.5 15.2938 18.5 10.5C18.5 6.91015 15.5899 4 12 4ZM17.5 11C17.6603 11 17.8186 11.0084 17.9746 11.0247C17.9916 11.1812 18 11.3396 18 11.5C18 13.9853 15.9853 16 13.5 16C13.3396 16 13.1812 15.9916 13.0252 15.9752C13.0084 15.8186 13 15.6603 13 15.5C13 13.0147 15.0147 11 17.5 11ZM6.5 11C8.98528 11 11 13.0147 11 15.5C11 15.6603 10.9916 15.8186 10.9753 15.9746C10.8186 15.9916 10.6603 16 10.5 16C8.01472 16 6 13.9853 6 11.5C6 11.3396 6.00839 11.1812 6.02475 11.0252C6.18121 11.0084 6.33963 11 6.5 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7ab08b77a30af29(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 2C19.9853 2 22 4.01472 22 6.5C22 7.85621 21.4001 9.07229 20.4511 9.89732C20.8061 10.8644 21 11.9096 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 11.9096 3.19392 10.8644 3.54916 9.8972C2.59995 9.07229 2 7.85621 2 6.5C2 4.01472 4.01472 2 6.5 2C8.12553 2 9.54976 2.86189 10.3406 4.15362C10.8774 4.05251 11.4326 4 12 4C12.5674 4 13.1226 4.05251 13.6609 4.15294C14.4502 2.86189 15.8745 2 17.5 2ZM10 13H8C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13H14C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d657f82f17f5e2e7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17C14.2091 17 16 15.2091 16 13H14C14 14.1046 13.1046 15 12 15 10.8954 15 10 14.1046 10 13H8C8 15.2091 9.79086 17 12 17ZM6.5 2C4.01472 2 2 4.01472 2 6.5 2 7.85729 2.60121 9.07332 3.54934 9.89751 3.19384 10.8656 3 11.911 3 13 3 17.9706 7.02944 22 12 22 16.9706 22 21 17.9706 21 13 21 11.911 20.8062 10.8656 20.4507 9.89751 21.3988 9.07332 22 7.85729 22 6.5 22 4.01472 19.9853 2 17.5 2 15.8737 2 14.4505 2.8624 13.6601 4.15297 13.1215 4.05246 12.5665 4 12 4 11.4335 4 10.8785 4.05246 10.3399 4.15297 9.5495 2.8624 8.12635 2 6.5 2ZM4 6.5C4 5.11929 5.11929 4 6.5 4 7.58033 4 8.50304 4.68577 8.8517 5.64896L9.1696 6.52718 10.0675 6.26991C10.6801 6.09435 11.3282 6 12 6 12.6718 6 13.3199 6.09435 13.9325 6.26991L14.8304 6.52718 15.1483 5.64896C15.497 4.68577 16.4197 4 17.5 4 18.8807 4 20 5.11929 20 6.5 20 7.43301 19.4894 8.24804 18.7275 8.67859L17.9141 9.13832 18.3176 9.98107C18.7547 10.8939 19 11.9169 19 13 19 16.866 15.866 20 12 20 8.13401 20 5 16.866 5 13 5 11.9169 5.24529 10.8939 5.6824 9.98107L6.08595 9.13832 5.27248 8.6786C4.51064 8.24805 4 7.43301 4 6.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3f7f87db5dd3b8fc(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16V20H8V22H2V16H4ZM22 16V22H16V20H20V16H22ZM7.5 7C7.5 9.48528 9.51472 11.5 12 11.5C14.4853 11.5 16.5 9.48528 16.5 7H18.5C18.5 9.50729 17.0804 11.683 15.0011 12.7672L15 19H9L8.99992 12.7677C6.92007 11.6837 5.5 9.50769 5.5 7H7.5ZM12 5C13.3807 5 14.5 6.11929 14.5 7.5C14.5 8.88071 13.3807 10 12 10C10.6193 10 9.5 8.88071 9.5 7.5C9.5 6.11929 10.6193 5 12 5ZM8 2V4L4 3.999V8H2V2H8ZM22 2V8H20V4H16V2H22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$eb92c14e0ab37ace(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16V20H8V22H2V16H4ZM22 16V22H16V20H20V16H22ZM7.5 7C7.5 9.1416 8.99603 10.9338 11 11.3885L11 17H13L13.001 11.3883C15.0045 10.9332 16.5 9.14125 16.5 7H18.5C18.5 9.50729 17.0804 11.683 15.0011 12.7672L15 19H9L8.99992 12.7677C6.92007 11.6837 5.5 9.50769 5.5 7H7.5ZM12 5C13.3807 5 14.5 6.11929 14.5 7.5C14.5 8.88071 13.3807 10 12 10C10.6193 10 9.5 8.88071 9.5 7.5C9.5 6.11929 10.6193 5 12 5ZM8 2V4L4 3.999V8H2V2H8ZM22 2V8H20V4H16V2H22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bc14fca6019f8baf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22C2 17.5817 5.58172 14 10 14C14.4183 14 18 17.5817 18 22H2ZM10 13C6.685 13 4 10.315 4 7C4 3.685 6.685 1 10 1C13.315 1 16 3.685 16 7C16 10.315 13.315 13 10 13ZM20 17H24V19H20V17ZM17 12H24V14H17V12ZM19 7H24V9H19V7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4329fb67fb5a7f8d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7H24V9H19V7ZM17 12H24V14H17V12ZM20 17H24V19H20V17ZM2 22C2 17.5817 5.58172 14 10 14C14.4183 14 18 17.5817 18 22H16C16 18.6863 13.3137 16 10 16C6.68629 16 4 18.6863 4 22H2ZM10 13C6.685 13 4 10.315 4 7C4 3.685 6.685 1 10 1C13.315 1 16 3.685 16 7C16 10.315 13.315 13 10 13ZM10 11C12.21 11 14 9.21 14 7C14 4.79 12.21 3 10 3C7.79 3 6 4.79 6 7C6 9.21 7.79 11 10 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$aa03bef44eb5d537(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C16.9706 2 21 6.02944 21 11C21 13.2031 20.2084 15.2213 18.8941 16.7858C20.1491 17.6156 20.9275 18.6754 20.9952 19.835L21 20L12 22L3 20L3.00481 19.835C3.0725 18.6755 3.85076 17.6158 5.10554 16.7859C3.79194 15.2222 3 13.2036 3 11C3 6.02944 7.02944 2 12 2ZM12 13C10.6193 13 9.5 13.6716 9.5 14.5C9.5 15.3284 10.6193 16 12 16C13.3807 16 14.5 15.3284 14.5 14.5C14.5 13.6716 13.3807 13 12 13ZM9 8C7.89543 8 7 8.67157 7 9.5C7 10.3284 7.89543 11 9 11C10.1046 11 11 10.3284 11 9.5C11 8.67157 10.1046 8 9 8ZM15 8C13.8954 8 13 8.67157 13 9.5C13 10.3284 13.8954 11 15 11C16.1046 11 17 10.3284 17 9.5C17 8.67157 16.1046 8 15 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$701946c35ffa845c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C16.9706 2 21 6.02944 21 11C21 13.2031 20.2084 15.2213 18.8941 16.7858C20.1491 17.6156 20.9275 18.6754 20.9952 19.835L21 20L12 22L3 20L3.00481 19.835C3.0725 18.6755 3.85076 17.6158 5.10554 16.7859C3.79194 15.2222 3 13.2036 3 11C3 6.02944 7.02944 2 12 2ZM12 4C8.13401 4 5 7.13401 5 11C5 12.5669 5.5143 14.0501 6.44521 15.261L6.63691 15.4995L8.07955 17.2168L6.11776 18.5156L5.981 18.613L12 19.951L18.018 18.613L17.9693 18.577L17.791 18.454L15.9199 17.2168L17.3628 15.4993C18.415 14.2468 19 12.6712 19 11C19 7.13401 15.866 4 12 4ZM12 13C13.3807 13 14.5 13.6716 14.5 14.5C14.5 15.3284 13.3807 16 12 16C10.6193 16 9.5 15.3284 9.5 14.5C9.5 13.6716 10.6193 13 12 13ZM9 8C10.1046 8 11 8.67157 11 9.5C11 10.3284 10.1046 11 9 11C7.89543 11 7 10.3284 7 9.5C7 8.67157 7.89543 8 9 8ZM15 8C16.1046 8 17 8.67157 17 9.5C17 10.3284 16.1046 11 15 11C13.8954 11 13 10.3284 13 9.5C13 8.67157 13.8954 8 15 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e3f226da5122a270(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$40e201a6ba1845ff(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM8 13H16C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7ba83d7a44052e24(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13H8ZM8 11C8.82843 11 9.5 10.3284 9.5 9.5C9.5 8.67157 8.82843 8 8 8C7.17157 8 6.5 8.67157 6.5 9.5C6.5 10.3284 7.17157 11 8 11ZM16 11C16.8284 11 17.5 10.3284 17.5 9.5C17.5 8.67157 16.8284 8 16 8C15.1716 8 14.5 8.67157 14.5 9.5C14.5 10.3284 15.1716 11 16 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d481b560079e926c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM7 13C7 15.7614 9.23858 18 12 18C14.7614 18 17 15.7614 17 13H15C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13H7ZM8 11C8.82843 11 9.5 10.3284 9.5 9.5C9.5 8.67157 8.82843 8 8 8C7.17157 8 6.5 8.67157 6.5 9.5C6.5 10.3284 7.17157 11 8 11ZM16 11C16.8284 11 17.5 10.3284 17.5 9.5C17.5 8.67157 16.8284 8 16 8C15.1716 8 14.5 8.67157 14.5 9.5C14.5 10.3284 15.1716 11 16 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a2b9ace5fe4afd76(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM7 13H9C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13H17C17 15.7614 14.7614 18 12 18C9.23858 18 7 15.7614 7 13ZM8 11C7.17157 11 6.5 10.3284 6.5 9.5C6.5 8.67157 7.17157 8 8 8C8.82843 8 9.5 8.67157 9.5 9.5C9.5 10.3284 8.82843 11 8 11ZM16 11C15.1716 11 14.5 10.3284 14.5 9.5C14.5 8.67157 15.1716 8 16 8C16.8284 8 17.5 8.67157 17.5 9.5C17.5 10.3284 16.8284 11 16 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$91fcb5d55be916c2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 11C10 11 8.33333 11.3333 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C15.6667 11.3333 14 11 12 11ZM8.5 7C7.34792 7 6.37786 7.77929 6.08818 8.8395L6.04989 9.00057H10.9501C10.7187 7.85917 9.70968 7 8.5 7ZM15.5 7C14.3479 7 13.3779 7.77929 13.0882 8.8395L13.0499 9.00057H17.9501C17.7187 7.85917 16.7097 7 15.5 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2dba9e0f2dda85d9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 11C14 11 15.6667 11.3333 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C8.33333 11.3333 10 11 12 11ZM8.5 7C9.70968 7 10.7187 7.85917 10.9501 9.00057H6.04989C6.28131 7.85917 7.29032 7 8.5 7ZM15.5 7C16.7097 7 17.7187 7.85917 17.9501 9.00057H13.0499C13.2813 7.85917 14.2903 7 15.5 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$34e658702c19fb7d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM8 13H16C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13ZM8 11C7.17157 11 6.5 10.3284 6.5 9.5C6.5 8.67157 7.17157 8 8 8C8.82843 8 9.5 8.67157 9.5 9.5C9.5 10.3284 8.82843 11 8 11ZM16 11C15.1716 11 14.5 10.3284 14.5 9.5C14.5 8.67157 15.1716 8 16 8C16.8284 8 17.5 8.67157 17.5 9.5C17.5 10.3284 16.8284 11 16 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bbc364681064676(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8 14V16H16V14H8ZM8 11C8.82843 11 9.5 10.3284 9.5 9.5C9.5 8.67157 8.82843 8 8 8C7.17157 8 6.5 8.67157 6.5 9.5C6.5 10.3284 7.17157 11 8 11ZM16 11C16.8284 11 17.5 10.3284 17.5 9.5C17.5 8.67157 16.8284 8 16 8C15.1716 8 14.5 8.67157 14.5 9.5C14.5 10.3284 15.1716 11 16 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$32bc742a586c000b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM8 14H16V16H8V14ZM8 11C7.17157 11 6.5 10.3284 6.5 9.5C6.5 8.67157 7.17157 8 8 8C8.82843 8 9.5 8.67157 9.5 9.5C9.5 10.3284 8.82843 11 8 11ZM16 11C15.1716 11 14.5 10.3284 14.5 9.5C14.5 8.67157 15.1716 8 16 8C16.8284 8 17.5 8.67157 17.5 9.5C17.5 10.3284 16.8284 11 16 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$773bd1c8b43ad031(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 13.6169 21.6162 15.1442 20.9348 16.4958C20.8633 16.2175 20.7307 15.9523 20.5374 15.7206L20.4142 15.5858L19 14.1716L17.5858 15.5858L17.469 15.713C16.8069 16.4988 16.8458 17.6743 17.5858 18.4142C18.014 18.8424 18.588 19.0358 19.148 18.9946C17.3323 20.8487 14.8006 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 15C10.6199 15 9.37036 15.5592 8.46564 16.4633L8.30009 16.6368L9.24506 17.4961C10.035 17.1825 10.982 17 12 17C12.9049 17 13.7537 17.1442 14.4859 17.3965L14.7549 17.4961L15.6999 16.6368C14.7853 15.6312 13.4664 15 12 15ZM8.5 10C7.67157 10 7 10.6716 7 11.5C7 12.3284 7.67157 13 8.5 13C9.32843 13 10 12.3284 10 11.5C10 10.6716 9.32843 10 8.5 10ZM15.5 10C14.6716 10 14 10.6716 14 11.5C14 12.3284 14.6716 13 15.5 13C16.3284 13 17 12.3284 17 11.5C17 10.6716 16.3284 10 15.5 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$57f5069f14af850d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12C22 12.7266 21.9225 13.4351 21.7753 14.1177L19.9931 12.3355C19.9977 12.2242 20 12.1124 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C13.3023 20 14.5319 19.6888 15.6186 19.1368C15.7735 19.3828 15.958 19.6149 16.1716 19.8284C16.4739 20.1307 16.8125 20.3745 17.1734 20.5598C15.6642 21.4737 13.8936 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM19 14.1716L20.4142 15.5858C21.1953 16.3668 21.1953 17.6332 20.4142 18.4142C19.6332 19.1953 18.3668 19.1953 17.5858 18.4142C16.8402 17.6687 16.8064 16.481 17.4841 15.6952L17.5858 15.5858L19 14.1716ZM12 15C13.4664 15 14.7853 15.6312 15.6999 16.6368L14.7549 17.4961C13.965 17.1825 13.018 17 12 17C10.982 17 10.035 17.1825 9.24506 17.4961L8.30009 16.6368C9.21468 15.6312 10.5336 15 12 15ZM8.5 10C9.32843 10 10 10.6716 10 11.5C10 12.3284 9.32843 13 8.5 13C7.67157 13 7 12.3284 7 11.5C7 10.6716 7.67157 10 8.5 10ZM15.5 10C16.3284 10 17 10.6716 17 11.5C17 12.3284 16.3284 13 15.5 13C14.6716 13 14 12.3284 14 11.5C14 10.6716 14.6716 10 15.5 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3de9da051b59678(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM7 17H9C9 15.3431 10.3431 14 12 14C13.6569 14 15 15.3431 15 17H17C17 14.2386 14.7614 12 12 12C9.23858 12 7 14.2386 7 17ZM8 11C8.82843 11 9.5 10.3284 9.5 9.5C9.5 8.67157 8.82843 8 8 8C7.17157 8 6.5 8.67157 6.5 9.5C6.5 10.3284 7.17157 11 8 11ZM16 11C16.8284 11 17.5 10.3284 17.5 9.5C17.5 8.67157 16.8284 8 16 8C15.1716 8 14.5 8.67157 14.5 9.5C14.5 10.3284 15.1716 11 16 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4cc3cf0c81f486b0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM7 17C7 14.2386 9.23858 12 12 12C14.7614 12 17 14.2386 17 17H15C15 15.3431 13.6569 14 12 14C10.3431 14 9 15.3431 9 17H7ZM8 11C7.17157 11 6.5 10.3284 6.5 9.5C6.5 8.67157 7.17157 8 8 8C8.82843 8 9.5 8.67157 9.5 9.5C9.5 10.3284 8.82843 11 8 11ZM16 11C15.1716 11 14.5 10.3284 14.5 9.5C14.5 8.67157 15.1716 8 16 8C16.8284 8 17.5 8.67157 17.5 9.5C17.5 10.3284 16.8284 11 16 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$59b19e275ea70b29(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7.06609V1H13V7.06609C16.6694 7.55498 19.5 10.6969 19.5 14.5C19.5 18.6421 16.1421 22 12 22C7.85786 22 4.5 18.6421 4.5 14.5C4.5 10.6969 7.33064 7.55498 11 7.06609Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5c7e3093f3f4aeda(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.06609C16.6694 7.55498 19.5 10.6969 19.5 14.5C19.5 18.6421 16.1421 22 12 22C7.85786 22 4.5 18.6421 4.5 14.5C4.5 10.6969 7.33064 7.55498 11 7.06609V1H13V7.06609ZM12 20C15.0376 20 17.5 17.5376 17.5 14.5C17.5 11.4624 15.0376 9 12 9C8.96243 9 6.5 11.4624 6.5 14.5C6.5 17.5376 8.96243 20 12 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d194a2f6dd4c54d3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C15.5 2 18 5 19 8C22 9 23 11.73 23 14L20.2253 14.7928C19.796 14.9154 19.5 15.3078 19.5 15.7543V17.25C19.5 18.2165 18.7165 19 17.75 19H17.1536C16.4825 19 15.8562 19.3366 15.4858 19.8962C14.5576 21.2987 13.3957 22 12 22C10.6043 22 9.44238 21.2987 8.5142 19.8962C8.14383 19.3366 7.51746 19 6.84636 19H6.25C5.2835 19 4.5 18.2165 4.5 17.25V15.7543C4.5 15.3078 4.20402 14.9154 3.77472 14.7928L1 14C1 11.7337 2 9 5 8C6 5 8.5 2 12 2ZM12 12C11.1716 12 10.5 13.1193 10.5 14.5C10.5 15.8807 11.1716 17 12 17C12.8284 17 13.5 15.8807 13.5 14.5C13.5 13.1193 12.8284 12 12 12ZM9.5 8C8.67157 8 8 8.67157 8 9.5C8 10.3284 8.67157 11 9.5 11C10.3284 11 11 10.3284 11 9.5C11 8.67157 10.3284 8 9.5 8ZM14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11C15.3284 11 16 10.3284 16 9.5C16 8.67157 15.3284 8 14.5 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3361d8e1816339e2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C15.5 2 18 5 19 8C22 9 23 11.73 23 14L20.2253 14.7928C19.796 14.9154 19.5 15.3078 19.5 15.7543V17.25C19.5 18.2165 18.7165 19 17.75 19H17.1536C16.4825 19 15.8562 19.3366 15.4858 19.8962C14.5576 21.2987 13.3957 22 12 22C10.6043 22 9.44238 21.2987 8.5142 19.8962C8.14383 19.3366 7.51746 19 6.84636 19H6.25C5.2835 19 4.5 18.2165 4.5 17.25V15.7543C4.5 15.3078 4.20402 14.9154 3.77472 14.7928L1 14C1 11.7337 2 9 5 8C6 5 8.5 2 12 2ZM12 4C9.8906 4 7.93534 5.78788 6.98864 8.37148L6.89737 8.63246L6.58114 9.58114L5.63246 9.89737C4.37721 10.3158 3.56485 11.238 3.20834 12.4564L3.185 12.543L4.32416 12.8697C5.55353 13.221 6.41845 14.3095 6.49454 15.5727L6.5 15.7543V17H6.84636C8.1096 17 9.29359 17.5963 10.0461 18.5996L10.182 18.7925C10.7584 19.6634 11.3162 20 12 20C12.6382 20 13.1667 19.7068 13.7029 18.9596L13.818 18.7925C14.5151 17.739 15.6658 17.0807 16.9178 17.0069L17.1536 17H17.5V15.7543C17.5 14.4757 18.309 13.3451 19.5027 12.9249L19.6758 12.8697L20.815 12.543L20.7918 12.4555C20.4554 11.3047 19.7124 10.4193 18.5728 9.97176L18.3675 9.89737L17.4189 9.58114L17.1026 8.63246C16.1948 5.90906 14.1797 4 12 4ZM12 12C12.8284 12 13.5 13.1193 13.5 14.5C13.5 15.8807 12.8284 17 12 17C11.1716 17 10.5 15.8807 10.5 14.5C10.5 13.1193 11.1716 12 12 12ZM9.5 8C10.3284 8 11 8.67157 11 9.5C11 10.3284 10.3284 11 9.5 11C8.67157 11 8 10.3284 8 9.5C8 8.67157 8.67157 8 9.5 8ZM14.5 8C15.3284 8 16 8.67157 16 9.5C16 10.3284 15.3284 11 14.5 11C13.6716 11 13 10.3284 13 9.5C13 8.67157 13.6716 8 14.5 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3d34d6b302a51073(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C16.9706 2 21 6.02944 21 11V18.5C21 20.433 19.433 22 17.5 22C16.3001 22 15.2413 21.3962 14.6107 20.476C14.0976 21.3857 13.1205 22 12 22C10.8795 22 9.9024 21.3857 9.38728 20.4754C8.75869 21.3962 7.69985 22 6.5 22C4.63144 22 3.10487 20.5357 3.00518 18.692L3 18.5V11C3 6.02944 7.02944 2 12 2ZM12 12C10.8954 12 10 13.1193 10 14.5C10 15.8807 10.8954 17 12 17C13.1046 17 14 15.8807 14 14.5C14 13.1193 13.1046 12 12 12ZM9.5 8C8.67157 8 8 8.67157 8 9.5C8 10.3284 8.67157 11 9.5 11C10.3284 11 11 10.3284 11 9.5C11 8.67157 10.3284 8 9.5 8ZM14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11C15.3284 11 16 10.3284 16 9.5C16 8.67157 15.3284 8 14.5 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c707fc091a6682d6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C16.9706 2 21 6.02944 21 11V18.5C21 20.433 19.433 22 17.5 22C16.3001 22 15.2413 21.3962 14.6107 20.476C14.0976 21.3857 13.1205 22 12 22C10.8795 22 9.9024 21.3857 9.38728 20.4754C8.75869 21.3962 7.69985 22 6.5 22C4.63144 22 3.10487 20.5357 3.00518 18.692L3 18.5V11C3 6.02944 7.02944 2 12 2ZM12 4C8.21455 4 5.1309 7.00478 5.00406 10.7593L5 11L4.99927 18.4461L5.00226 18.584C5.04504 19.3751 5.70251 20 6.5 20C6.95179 20 7.36652 19.8007 7.64704 19.4648L7.73545 19.3478C8.57033 18.1248 10.3985 18.2016 11.1279 19.4904C11.3053 19.8038 11.6345 20 12 20C12.3651 20 12.6933 19.8044 12.8687 19.4934C13.5692 18.2516 15.2898 18.1317 16.1636 19.2151L16.2606 19.3455C16.5401 19.7534 16.9976 20 17.5 20C18.2797 20 18.9204 19.4051 18.9931 18.6445L19 18.5V11C19 7.13401 15.866 4 12 4ZM12 12C13.1046 12 14 13.1193 14 14.5C14 15.8807 13.1046 17 12 17C10.8954 17 10 15.8807 10 14.5C10 13.1193 10.8954 12 12 12ZM9.5 8C10.3284 8 11 8.67157 11 9.5C11 10.3284 10.3284 11 9.5 11C8.67157 11 8 10.3284 8 9.5C8 8.67157 8.67157 8 9.5 8ZM14.5 8C15.3284 8 16 8.67157 16 9.5C16 10.3284 15.3284 11 14.5 11C13.6716 11 13 10.3284 13 9.5C13 8.67157 13.6716 8 14.5 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b96b9b61b2c2643c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C16.9706 2 21 6.02944 21 11V18.5C21 20.433 19.433 22 17.5 22C16.3001 22 15.2413 21.3962 14.6107 20.476C14.0976 21.3857 13.1205 22 12 22C10.8795 22 9.9024 21.3857 9.38728 20.4754C8.75869 21.3962 7.69985 22 6.5 22C4.63144 22 3.10487 20.5357 3.00518 18.692L3 18.5V11C3 6.02944 7.02944 2 12 2ZM16 13H14C14 14.1046 13.1046 15 12 15C10.9456 15 10.0818 14.1841 10.0055 13.1493L10 13H8L8.0049 13.1996C8.10892 15.316 9.8578 17 12 17C14.1422 17 15.8911 15.316 15.9951 13.1996L16 13ZM12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ab0b98122bbec767(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C16.9706 2 21 6.02944 21 11V18.5C21 20.433 19.433 22 17.5 22C16.3001 22 15.2413 21.3962 14.6107 20.476C14.0976 21.3857 13.1205 22 12 22C10.8795 22 9.9024 21.3857 9.38728 20.4754C8.75869 21.3962 7.69985 22 6.5 22C4.63144 22 3.10487 20.5357 3.00518 18.692L3 18.5V11C3 6.02944 7.02944 2 12 2ZM12 4C8.21455 4 5.1309 7.00478 5.00406 10.7593L5 11L4.99927 18.4461L5.00226 18.584C5.04504 19.3751 5.70251 20 6.5 20C6.95179 20 7.36652 19.8007 7.64704 19.4648L7.73545 19.3478C8.57033 18.1248 10.3985 18.2016 11.1279 19.4904C11.3053 19.8038 11.6345 20 12 20C12.3651 20 12.6933 19.8044 12.8687 19.4934C13.5692 18.2516 15.2898 18.1317 16.1636 19.2151L16.2606 19.3455C16.5401 19.7534 16.9976 20 17.5 20C18.2797 20 18.9204 19.4051 18.9931 18.6445L19 18.5V11C19 7.13401 15.866 4 12 4ZM16 13C16 15.2091 14.2091 17 12 17C9.8578 17 8.10892 15.316 8.0049 13.1996L8 13H10C10 14.1046 10.8954 15 12 15C13.1046 15 14 14.1046 14 13H16ZM12 7C13.1046 7 14 7.89543 14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9C10 7.89543 10.8954 7 12 7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3cc7c653a5f5c157(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 19.748V16.4C10 15.1174 10.9948 14.1076 12.4667 13.5321C11.5431 13.188 10.5435 13 9.5 13C7.61013 13 5.86432 13.6168 4.45286 14.66C5.33199 17.1544 7.41273 19.082 10 19.748ZM18.8794 16.0859C18.4862 15.5526 17.1708 15 15.5 15C13.4939 15 12 15.7967 12 16.4V20C14.9255 20 17.4843 18.4296 18.8794 16.0859ZM9.55 11.5C10.7926 11.5 11.8 10.4926 11.8 9.25C11.8 8.00736 10.7926 7 9.55 7C8.30736 7 7.3 8.00736 7.3 9.25C7.3 10.4926 8.30736 11.5 9.55 11.5ZM15.5 12.5C16.6046 12.5 17.5 11.6046 17.5 10.5C17.5 9.39543 16.6046 8.5 15.5 8.5C14.3954 8.5 13.5 9.39543 13.5 10.5C13.5 11.6046 14.3954 12.5 15.5 12.5ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cf4098f216ec7acb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.55 11.5C8.30736 11.5 7.3 10.4926 7.3 9.25C7.3 8.00736 8.30736 7 9.55 7C10.7926 7 11.8 8.00736 11.8 9.25C11.8 10.4926 10.7926 11.5 9.55 11.5ZM10 19.748V16.4C10 15.9116 10.1442 15.4627 10.4041 15.0624C10.1087 15.0213 9.80681 15 9.5 15C7.93201 15 6.49369 15.5552 5.37091 16.4797C6.44909 18.0721 8.08593 19.2553 10 19.748ZM4.45286 14.66C5.86432 13.6168 7.61013 13 9.5 13C10.5435 13 11.5431 13.188 12.4667 13.5321C13.3447 13.1888 14.3924 13 15.5 13C17.1597 13 18.6849 13.4239 19.706 14.1563C19.8976 13.4703 20 12.7471 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 12.9325 4.15956 13.8278 4.45286 14.66ZM18.8794 16.0859C18.4862 15.5526 17.1708 15 15.5 15C13.4939 15 12 15.7967 12 16.4V20C14.9255 20 17.4843 18.4296 18.8794 16.0859ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM15.5 12.5C14.3954 12.5 13.5 11.6046 13.5 10.5C13.5 9.39543 14.3954 8.5 15.5 8.5C16.6046 8.5 17.5 9.39543 17.5 10.5C17.5 11.6046 16.6046 12.5 15.5 12.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cdd3ee65cf575e84(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22C2 17.5817 5.58172 14 10 14C14.4183 14 18 17.5817 18 22H2ZM10 13C6.685 13 4 10.315 4 7C4 3.685 6.685 1 10 1C13.315 1 16 3.685 16 7C16 10.315 13.315 13 10 13ZM17.3628 15.2332C20.4482 16.0217 22.7679 18.7235 22.9836 22H20C20 19.3902 19.0002 17.0139 17.3628 15.2332ZM15.3401 12.9569C16.9728 11.4922 18 9.36607 18 7C18 5.58266 17.6314 4.25141 16.9849 3.09687C19.2753 3.55397 21 5.57465 21 8C21 10.7625 18.7625 13 16 13C15.7763 13 15.556 12.9853 15.3401 12.9569Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a51867e9100117f2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22C2 17.5817 5.58172 14 10 14C14.4183 14 18 17.5817 18 22H16C16 18.6863 13.3137 16 10 16C6.68629 16 4 18.6863 4 22H2ZM10 13C6.685 13 4 10.315 4 7C4 3.685 6.685 1 10 1C13.315 1 16 3.685 16 7C16 10.315 13.315 13 10 13ZM10 11C12.21 11 14 9.21 14 7C14 4.79 12.21 3 10 3C7.79 3 6 4.79 6 7C6 9.21 7.79 11 10 11ZM18.2837 14.7028C21.0644 15.9561 23 18.752 23 22H21C21 19.564 19.5483 17.4671 17.4628 16.5271L18.2837 14.7028ZM17.5962 3.41321C19.5944 4.23703 21 6.20361 21 8.5C21 11.3702 18.8042 13.7252 16 13.9776V11.9646C17.6967 11.7222 19 10.264 19 8.5C19 7.11935 18.2016 5.92603 17.041 5.35635L17.5962 3.41321Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d1227055daa43029(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5858 5H14V3H22V11H20V6.41421L16.4633 9.95088C17.4274 11.2127 18 12.7895 18 14.5C18 18.6421 14.6421 22 10.5 22C6.35786 22 3 18.6421 3 14.5C3 10.3579 6.35786 7 10.5 7C12.2105 7 13.7873 7.57264 15.0491 8.53666L18.5858 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$49b23faaa4b2fb01(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.0491 8.53666L18.5858 5H14V3H22V11H20V6.41421L16.4633 9.95088C17.4274 11.2127 18 12.7895 18 14.5C18 18.6421 14.6421 22 10.5 22C6.35786 22 3 18.6421 3 14.5C3 10.3579 6.35786 7 10.5 7C12.2105 7 13.7873 7.57264 15.0491 8.53666ZM10.5 20C13.5376 20 16 17.5376 16 14.5C16 11.4624 13.5376 9 10.5 9C7.46243 9 5 11.4624 5 14.5C5 17.5376 7.46243 20 10.5 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4397874b0f17ddc3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2C20.9853 2 23 4.01472 23 6.5C23 8.68314 21.4454 10.5032 19.3828 10.9134C19.7802 11.8623 20 12.9055 20 14C20 18.4183 16.4183 22 12 22C7.58172 22 4 18.4183 4 14C4 12.9055 4.21981 11.8623 4.61769 10.9121C2.55463 10.5032 1 8.68314 1 6.5C1 4.01472 3.01472 2 5.5 2C7.90278 2 9.86572 3.88317 9.9934 6.2541C10.6348 6.08809 11.3071 6 12 6C12.6929 6 13.3652 6.08809 14.0064 6.25368C14.1343 3.88317 16.0972 2 18.5 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7c8ab91652c4b2fd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.61716 10.9134C2.5546 10.5031 1 8.68312 1 6.5C1 4.01472 3.01472 2 5.5 2C7.90266 2 9.86552 3.88299 9.99338 6.25375C10.6346 6.08811 11.307 6 12 6C12.693 6 13.3654 6.08811 14.0066 6.25375C14.1345 3.88299 16.0973 2 18.5 2C20.9853 2 23 4.01472 23 6.5C23 8.68312 21.4454 10.5031 19.3828 10.9134C19.7804 11.8632 20 12.906 20 14C20 18.4183 16.4183 22 12 22C7.58172 22 4 18.4183 4 14C4 12.906 4.21961 11.8632 4.61716 10.9134ZM3 6.5C3 7.88071 4.11929 9 5.5 9C5.5898 9 5.6785 8.99527 5.76585 8.98603C6.36594 8.24086 7.0969 7.60551 7.92382 7.11489C7.97357 6.91818 8 6.71217 8 6.5C8 5.11929 6.88071 4 5.5 4C4.11929 4 3 5.11929 3 6.5ZM18.2341 8.98603C18.3215 8.99527 18.4102 9 18.5 9C19.8807 9 21 7.88071 21 6.5C21 5.11929 19.8807 4 18.5 4C17.1193 4 16 5.11929 16 6.5C16 6.71217 16.0264 6.91818 16.0762 7.11489C16.9031 7.60551 17.6341 8.24086 18.2341 8.98603ZM6 14C6 17.3137 8.68629 20 12 20C15.3137 20 18 17.3137 18 14C18 10.6863 15.3137 8 12 8C8.68629 8 6 10.6863 6 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$64d2474f1a201022(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0014 12C9.24 12 7.00143 9.76142 7.00143 7C7.00143 4.23858 9.24 2 12.0014 2C14.7628 2 17.0014 4.23858 17.0014 7C17.0014 9.76142 14.7628 12 12.0014 12ZM18.0014 17V22H16.0014V17C16.0014 12.5487 18.6454 8.71498 22.4485 6.98352L23.2763 8.8047C20.1646 10.2213 18.0014 13.3581 18.0014 17ZM8.00143 17V22H6.00143V17C6.00143 13.3581 3.8382 10.2213 0.726562 8.8047L1.55437 6.98352C5.35749 8.71498 8.00143 12.5487 8.00143 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bca77a8dc9085cde(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.0014 17V22H16.0014V17C16.0014 12.5487 18.6454 8.71498 22.4485 6.98352L23.2763 8.8047C20.1646 10.2213 18.0014 13.3581 18.0014 17ZM8.00143 17V22H6.00143V17C6.00143 13.3581 3.8382 10.2213 0.726562 8.8047L1.55437 6.98352C5.35749 8.71498 8.00143 12.5487 8.00143 17ZM12.0014 12C9.24 12 7.00143 9.76142 7.00143 7C7.00143 4.23858 9.24 2 12.0014 2C14.7628 2 17.0014 4.23858 17.0014 7C17.0014 9.76142 14.7628 12 12.0014 12ZM12.0014 10C13.6583 10 15.0014 8.65685 15.0014 7C15.0014 5.34315 13.6583 4 12.0014 4C10.3446 4 9.00142 5.34315 9.00142 7C9.00142 8.65685 10.3446 10 12.0014 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b25076442c13cb6e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11C4.51472 11 2.5 8.98528 2.5 6.5C2.5 4.01472 4.51472 2 7 2C9.48528 2 11.5 4.01472 11.5 6.5C11.5 8.98528 9.48528 11 7 11ZM17.5 15C15.2909 15 13.5 13.2091 13.5 11C13.5 8.79086 15.2909 7 17.5 7C19.7091 7 21.5 8.79086 21.5 11C21.5 13.2091 19.7091 15 17.5 15ZM17.5 16C19.9853 16 22 18.0147 22 20.5V21H13V20.5C13 18.0147 15.0147 16 17.5 16ZM7 12C9.76142 12 12 14.2386 12 17V21H2V17C2 14.2386 4.23858 12 7 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$582dce08d4636aaa(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9C8.38071 9 9.5 7.88071 9.5 6.5C9.5 5.11929 8.38071 4 7 4C5.61929 4 4.5 5.11929 4.5 6.5C4.5 7.88071 5.61929 9 7 9ZM7 11C4.51472 11 2.5 8.98528 2.5 6.5C2.5 4.01472 4.51472 2 7 2C9.48528 2 11.5 4.01472 11.5 6.5C11.5 8.98528 9.48528 11 7 11ZM17.5 13C18.6046 13 19.5 12.1046 19.5 11C19.5 9.89543 18.6046 9 17.5 9C16.3954 9 15.5 9.89543 15.5 11C15.5 12.1046 16.3954 13 17.5 13ZM17.5 15C15.2909 15 13.5 13.2091 13.5 11C13.5 8.79086 15.2909 7 17.5 7C19.7091 7 21.5 8.79086 21.5 11C21.5 13.2091 19.7091 15 17.5 15ZM20 21V20.5C20 19.1193 18.8807 18 17.5 18C16.1193 18 15 19.1193 15 20.5V21H13V20.5C13 18.0147 15.0147 16 17.5 16C19.9853 16 22 18.0147 22 20.5V21H20ZM10 21V17C10 15.3431 8.65685 14 7 14C5.34315 14 4 15.3431 4 17V21H2V17C2 14.2386 4.23858 12 7 12C9.76142 12 12 14.2386 12 17V21H10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5130d59d1cd9f717(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 2C13.5 2.44425 13.3069 2.84339 13 3.11805V5H18C19.6569 5 21 6.34315 21 8V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V8C3 6.34315 4.34315 5 6 5H11V3.11805C10.6931 2.84339 10.5 2.44425 10.5 2C10.5 1.17157 11.1716 0.5 12 0.5C12.8284 0.5 13.5 1.17157 13.5 2ZM0 10H2V16H0V10ZM24 10H22V16H24V10ZM9 14.5C9.82843 14.5 10.5 13.8284 10.5 13C10.5 12.1716 9.82843 11.5 9 11.5C8.17157 11.5 7.5 12.1716 7.5 13C7.5 13.8284 8.17157 14.5 9 14.5ZM16.5 13C16.5 12.1716 15.8284 11.5 15 11.5C14.1716 11.5 13.5 12.1716 13.5 13C13.5 13.8284 14.1716 14.5 15 14.5C15.8284 14.5 16.5 13.8284 16.5 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e0fc81d45b54a6d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 2C13.5 2.44425 13.3069 2.84339 13 3.11805V5H18C19.6569 5 21 6.34315 21 8V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V8C3 6.34315 4.34315 5 6 5H11V3.11805C10.6931 2.84339 10.5 2.44425 10.5 2C10.5 1.17157 11.1716 0.5 12 0.5C12.8284 0.5 13.5 1.17157 13.5 2ZM6 7C5.44772 7 5 7.44772 5 8V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V8C19 7.44772 18.5523 7 18 7H13H11H6ZM2 10H0V16H2V10ZM22 10H24V16H22V10ZM9 14.5C9.82843 14.5 10.5 13.8284 10.5 13C10.5 12.1716 9.82843 11.5 9 11.5C8.17157 11.5 7.5 12.1716 7.5 13C7.5 13.8284 8.17157 14.5 9 14.5ZM15 14.5C15.8284 14.5 16.5 13.8284 16.5 13C16.5 12.1716 15.8284 11.5 15 11.5C14.1716 11.5 13.5 12.1716 13.5 13C13.5 13.8284 14.1716 14.5 15 14.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$88c430ba561741a7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4.05493C17.5 4.55237 21 8.36745 21 13V22H3V13C3 8.36745 6.50005 4.55237 11 4.05493V1H13V4.05493ZM12 18C14.7614 18 17 15.7614 17 13C17 10.2386 14.7614 8 12 8C9.23858 8 7 10.2386 7 13C7 15.7614 9.23858 18 12 18ZM12 16C10.3431 16 9 14.6569 9 13C9 11.3431 10.3431 10 12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16ZM12 14C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$353e482032e25a4a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4.05493C17.5 4.55237 21 8.36745 21 13V22H3V13C3 8.36745 6.50005 4.55237 11 4.05493V1H13V4.05493ZM19 20V13C19 9.13401 15.866 6 12 6C8.13401 6 5 9.13401 5 13V20H19ZM12 18C9.23858 18 7 15.7614 7 13C7 10.2386 9.23858 8 12 8C14.7614 8 17 10.2386 17 13C17 15.7614 14.7614 18 12 18ZM12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16ZM12 14C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13C13 13.5523 12.5523 14 12 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8892fdda955720a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12V15.7639C22 16.5215 21.572 17.214 20.8944 17.5528L18 19V20C18 21.5977 16.7511 22.9037 15.1763 22.9949L14.9499 23.0004C14.9718 22.8926 14.9868 22.7823 14.9943 22.67L15 22.5V22C15 20.9456 14.1841 20.0818 13.1493 20.0055L13 20H11C9.94564 20 9.08183 20.8159 9.00549 21.8507L9 22V22.5C9 22.6714 9.01725 22.8387 9.0501 23.0004L9 23C7.34315 23 6 21.6569 6 20V19L3.10557 17.5528C2.428 17.214 2 16.5215 2 15.7639V12C2 6.47715 6.47715 2 12 2ZM8 11C6.89543 11 6 11.8954 6 13C6 14.1046 6.89543 15 8 15C9.10457 15 10 14.1046 10 13C10 11.8954 9.10457 11 8 11ZM16 11C14.8954 11 14 11.8954 14 13C14 14.1046 14.8954 15 16 15C17.1046 15 18 14.1046 18 13C18 11.8954 17.1046 11 16 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7238730ddbdf0120(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C17.5228 2 22 6.47715 22 12V15.7639C22 16.5215 21.572 17.214 20.8944 17.5528L18 19V20C18 21.5977 16.7511 22.9037 15.1763 22.9949L14.9499 23.0004C14.9718 22.8926 14.9868 22.7823 14.9943 22.67L15 22.5V22C15 20.9456 14.1841 20.0818 13.1493 20.0055L13 20H11C9.94564 20 9.08183 20.8159 9.00549 21.8507L9 22V22.5C9 22.6714 9.01725 22.8387 9.0501 23.0004L9 23C7.34315 23 6 21.6569 6 20V19L3.10557 17.5528C2.428 17.214 2 16.5215 2 15.7639V12C2 6.47715 6.47715 2 12 2ZM12 4C7.66509 4 4.13546 7.44784 4.00381 11.7508L4 12V15.7639L8 17.7639V19.355L8.07537 19.2711C8.76418 18.5335 9.72777 18.0584 10.7981 18.005L11 18L13.0735 18.0013L13.2964 18.0109C14.2947 18.0846 15.1868 18.5219 15.8452 19.1884L16 19.355V17.7639L20 15.7639V12C20 7.58172 16.4183 4 12 4ZM8 11C9.10457 11 10 11.8954 10 13C10 14.1046 9.10457 15 8 15C6.89543 15 6 14.1046 6 13C6 11.8954 6.89543 11 8 11ZM16 11C17.1046 11 18 11.8954 18 13C18 14.1046 17.1046 15 16 15C14.8954 15 14 14.1046 14 13C14 11.8954 14.8954 11 16 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f79ee084e6d72ab3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 18V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21V18H3C2.44772 18 2 17.5523 2 17V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V17C22 17.5523 21.5523 18 21 18H18ZM7.5 14C8.32843 14 9 13.3284 9 12.5C9 11.6716 8.32843 11 7.5 11C6.67157 11 6 11.6716 6 12.5C6 13.3284 6.67157 14 7.5 14ZM16.5 14C17.3284 14 18 13.3284 18 12.5C18 11.6716 17.3284 11 16.5 11C15.6716 11 15 11.6716 15 12.5C15 13.3284 15.6716 14 16.5 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$45fb772c2442d07d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12V16H7C7.55228 16 8 16.4477 8 17V20H16V17C16 16.4477 16.4477 16 17 16H20V12ZM18 18V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21V18H3C2.44772 18 2 17.5523 2 17V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V17C22 17.5523 21.5523 18 21 18H18ZM7.5 14C6.67157 14 6 13.3284 6 12.5C6 11.6716 6.67157 11 7.5 11C8.32843 11 9 11.6716 9 12.5C9 13.3284 8.32843 14 7.5 14ZM16.5 14C15.6716 14 15 13.3284 15 12.5C15 11.6716 15.6716 11 16.5 11C17.3284 11 18 11.6716 18 12.5C18 13.3284 17.3284 14 16.5 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$afd1e9746d36a78a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13C19.2091 13 21 14.7909 21 17C21 19.2091 19.2091 21 17 21C14.8578 21 13 19.21 13 17H11C11 19.2091 9.20914 21 7 21C4.79086 21 3 19.2091 3 17C3 14.7909 4.79086 13 7 13C8.48052 13 9.77317 13.8043 10.4648 14.9999H13.5352C14.2268 13.8043 15.5195 13 17 13ZM2 12V10H4V7C4 4.79086 5.79086 3 8 3H16C18.2091 3 20 4.79086 20 7V10H22V12H2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$45ba3fff84e6e8b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13C19.2091 13 21 14.7909 21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17H11C11 19.2091 9.20914 21 7 21C4.79086 21 3 19.2091 3 17C3 14.7909 4.79086 13 7 13C8.48052 13 9.77317 13.8043 10.4648 14.9999H13.5352C14.2268 13.8043 15.5195 13 17 13ZM7 15C5.89543 15 5 15.8954 5 17C5 18.1046 5.89543 19 7 19C8.10457 19 9 18.1046 9 17C9 15.8954 8.10457 15 7 15ZM17 15C15.8954 15 15 15.8954 15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17C19 15.8954 18.1046 15 17 15ZM16 3C18.2091 3 20 4.79086 20 7V10H22V12H2V10H4V7C4 4.79086 5.79086 3 8 3H16ZM16 5H8C6.94564 5 6 5.95 6 7V10H18V7C18 5.94564 17.05 5 16 5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ff715d830fc4c50(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9986 0.5L16.2246 6.68342L23.4113 8.7918L18.8364 14.7217L19.052 22.2082L11.9986 19.6897L4.94519 22.2082L5.16082 14.7217L0.585938 8.7918L7.77262 6.68342L11.9986 0.5ZM9.99862 12H7.99862C7.99862 14.2091 9.78948 16 11.9986 16C14.1408 16 15.8897 14.316 15.9937 12.1996L15.9986 12H13.9986C13.9986 13.1046 13.1032 14 11.9986 14C10.9443 14 10.0805 13.1841 10.0041 12.1493L9.99862 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f50b3e190626fc76(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9986 0.5L16.2246 6.68342L23.4113 8.7918L18.8364 14.7217L19.052 22.2082L11.9986 19.6897L4.94519 22.2082L5.16082 14.7217L0.585938 8.7918L7.77262 6.68342L11.9986 0.5ZM11.9986 4.044L9.02089 8.40151L3.95562 9.887L7.18055 14.0655L7.02762 19.34L11.9986 17.566L16.9686 19.34L16.8167 14.0655L20.0406 9.887L14.9763 8.40151L11.9986 4.044ZM9.99862 12C9.99862 13.1046 10.894 14 11.9986 14C13.1032 14 13.9986 13.1046 13.9986 12H15.9986C15.9986 14.2091 14.2078 16 11.9986 16C9.78948 16 7.99862 14.2091 7.99862 12H9.99862Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e9e254e26de61ff6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10C14.2091 10 16 8.20914 16 6 16 3.79086 14.2091 2 12 2 9.79086 2 8 3.79086 8 6 8 8.20914 9.79086 10 12 10ZM5.5 13C6.88071 13 8 11.8807 8 10.5 8 9.11929 6.88071 8 5.5 8 4.11929 8 3 9.11929 3 10.5 3 11.8807 4.11929 13 5.5 13ZM21 10.5C21 11.8807 19.8807 13 18.5 13 17.1193 13 16 11.8807 16 10.5 16 9.11929 17.1193 8 18.5 8 19.8807 8 21 9.11929 21 10.5ZM12 11C14.7614 11 17 13.2386 17 16V22H7V16C7 13.2386 9.23858 11 12 11ZM5 15.9999C5 15.307 5.10067 14.6376 5.28818 14.0056L5.11864 14.0204C3.36503 14.2104 2 15.6958 2 17.4999V21.9999H5V15.9999ZM22 21.9999V17.4999C22 15.6378 20.5459 14.1153 18.7118 14.0056 18.8993 14.6376 19 15.307 19 15.9999V21.9999H22Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$adf2905ad331cf5a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11C14.7614 11 17 13.2386 17 16V22H15V16C15 14.4023 13.7511 13.0963 12.1763 13.0051L12 13C10.4023 13 9.09634 14.2489 9.00509 15.8237L9 16V22H7V16C7 13.2386 9.23858 11 12 11ZM5.5 14C5.77885 14 6.05009 14.0326 6.3101 14.0942C6.14202 14.594 6.03873 15.122 6.00896 15.6693L6 16L6.0007 16.0856C5.88757 16.0456 5.76821 16.0187 5.64446 16.0069L5.5 16C4.7203 16 4.07955 16.5949 4.00687 17.3555L4 17.5V22H2V17.5C2 15.567 3.567 14 5.5 14ZM18.5 14C20.433 14 22 15.567 22 17.5V22H20V17.5C20 16.7203 19.4051 16.0796 18.6445 16.0069L18.5 16C18.3248 16 18.1566 16.03 18.0003 16.0852L18 16C18 15.3343 17.8916 14.694 17.6915 14.0956C17.9499 14.0326 18.2211 14 18.5 14ZM5.5 8C6.88071 8 8 9.11929 8 10.5C8 11.8807 6.88071 13 5.5 13C4.11929 13 3 11.8807 3 10.5C3 9.11929 4.11929 8 5.5 8ZM18.5 8C19.8807 8 21 9.11929 21 10.5C21 11.8807 19.8807 13 18.5 13C17.1193 13 16 11.8807 16 10.5C16 9.11929 17.1193 8 18.5 8ZM5.5 10C5.22386 10 5 10.2239 5 10.5C5 10.7761 5.22386 11 5.5 11C5.77614 11 6 10.7761 6 10.5C6 10.2239 5.77614 10 5.5 10ZM18.5 10C18.2239 10 18 10.2239 18 10.5C18 10.7761 18.2239 11 18.5 11C18.7761 11 19 10.7761 19 10.5C19 10.2239 18.7761 10 18.5 10ZM12 2C14.2091 2 16 3.79086 16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2ZM12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$90a13903036d9454(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.53802 9.95077L4.66252 7.07527L2.18765 9.55015L0.773438 8.13593L7.1374 1.77197L8.55161 3.18619L6.07674 5.66106L8.95224 8.53656C10.214 7.57253 11.7908 6.99989 13.5014 6.99989C17.6435 6.99989 21.0014 10.3578 21.0014 14.4999C21.0014 18.642 17.6435 21.9999 13.5014 21.9999C9.35922 21.9999 6.00136 18.642 6.00136 14.4999C6.00136 12.7894 6.574 11.2126 7.53802 9.95077Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9e14c5b56418f879(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.95224 8.53656C10.214 7.57253 11.7908 6.99989 13.5014 6.99989C17.6435 6.99989 21.0014 10.3578 21.0014 14.4999C21.0014 18.642 17.6435 21.9999 13.5014 21.9999C9.35922 21.9999 6.00136 18.642 6.00136 14.4999C6.00136 12.7894 6.574 11.2126 7.53802 9.95077L4.66252 7.07527L2.18765 9.55015L0.773438 8.13593L7.1374 1.77197L8.55161 3.18619L6.07674 5.66106L8.95224 8.53656ZM13.5014 19.9999C16.5389 19.9999 19.0014 17.5375 19.0014 14.4999C19.0014 11.4623 16.5389 8.99989 13.5014 8.99989C10.4638 8.99989 8.00136 11.4623 8.00136 14.4999C8.00136 17.5375 10.4638 19.9999 13.5014 19.9999Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$61bccf1a3c47b41f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14.0619V20H13V14.0619C16.9463 14.554 20 17.9204 20 22H4C4 17.9204 7.05369 14.554 11 14.0619ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$11be656760a51498(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM13 16.083V20H17.6586C16.9423 17.9735 15.1684 16.4467 13 16.083ZM11 20V16.083C8.83165 16.4467 7.05766 17.9735 6.34141 20H11ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.2104 11 16 9.21043 16 7C16 4.78957 14.2104 3 12 3C9.78957 3 8 4.78957 8 7C8 9.21043 9.78957 11 12 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6b4cb36eb1ececdb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H4V20C4 17.2386 6.23858 15 9 15H15C17.7614 15 20 17.2386 20 20V22ZM12 13C8.68629 13 6 10.3137 6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7C18 10.3137 15.3137 13 12 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1cae025e345cc90f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H18V20C18 18.3431 16.6569 17 15 17H9C7.34315 17 6 18.3431 6 20V22H4V20C4 17.2386 6.23858 15 9 15H15C17.7614 15 20 17.2386 20 20V22ZM12 13C8.68629 13 6 10.3137 6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7C18 10.3137 15.3137 13 12 13ZM12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8f2469fa041b4055(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20H19V22H5V20ZM12 18C7.58172 18 4 14.4183 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 14.4183 16.4183 18 12 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b6e7a33cc7d9fd25(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20H19V22H5V20ZM12 18C7.58172 18 4 14.4183 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 14.4183 16.4183 18 12 18ZM12 16C15.3137 16 18 13.3137 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$78ac16a99e427982(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.38938 16.5386C5.33894 15.0901 4 12.7014 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 12.7014 18.6611 15.0901 16.6106 16.5386L18.6936 21.2996C18.8043 21.5526 18.6889 21.8474 18.4359 21.9581C18.3727 21.9857 18.3045 22 18.2355 22H5.76451C5.48837 22 5.26451 21.7761 5.26451 21.5C5.26451 21.431 5.27878 21.3628 5.30643 21.2996L7.38938 16.5386ZM8.11851 10.9704C8.55217 12.7106 10.1255 14 12 14C13.8745 14 15.4478 12.7106 15.8815 10.9704L13.9407 10.4852C13.7239 11.3553 12.9372 12 12 12C11.0628 12 10.2761 11.3553 10.0593 10.4852L8.11851 10.9704Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e85c45a566ef0208(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.38938 16.5386C5.33894 15.0901 4 12.7014 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 12.7014 18.6611 15.0901 16.6106 16.5386L18.6936 21.2996C18.8043 21.5526 18.6889 21.8474 18.4359 21.9581C18.3727 21.9857 18.3045 22 18.2355 22H5.76451C5.48837 22 5.26451 21.7761 5.26451 21.5C5.26451 21.431 5.27878 21.3628 5.30643 21.2996L7.38938 16.5386ZM14.1246 15.846L15.4567 14.905C17.041 13.7858 18 11.9752 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 11.9752 6.95901 13.7858 8.54335 14.905L9.87539 15.846L8.05803 20H15.942L14.1246 15.846ZM8.11851 10.9704L10.0593 10.4852C10.2761 11.3553 11.0628 12 12 12C12.9372 12 13.7239 11.3553 13.9407 10.4852L15.8815 10.9704C15.4478 12.7106 13.8745 14 12 14C10.1255 14 8.55217 12.7106 8.11851 10.9704Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8f92a40ccbac545e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0009 17C15.6633 17 18.8659 18.5751 20.608 20.9247L18.766 21.796C17.3482 20.1157 14.8483 19 12.0009 19C9.15346 19 6.6535 20.1157 5.23577 21.796L3.39453 20.9238C5.13673 18.5747 8.33894 17 12.0009 17ZM12.0009 2C14.7623 2 17.0009 4.23858 17.0009 7V10C17.0009 12.7614 14.7623 15 12.0009 15C9.23945 15 7.00087 12.7614 7.00087 10V7C7.00087 4.23858 9.23945 2 12.0009 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d912c210b79346a7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0009 17C15.6633 17 18.8659 18.5751 20.608 20.9247L18.766 21.796C17.3482 20.1157 14.8483 19 12.0009 19C9.15346 19 6.6535 20.1157 5.23577 21.796L3.39453 20.9238C5.13673 18.5747 8.33894 17 12.0009 17ZM12.0009 2C14.7623 2 17.0009 4.23858 17.0009 7V10C17.0009 12.6888 14.8786 14.8818 12.2178 14.9954L12.0009 15C9.23945 15 7.00087 12.7614 7.00087 10V7C7.00087 4.31125 9.12318 2.11818 11.784 2.00462L12.0009 2ZM12.0009 4C10.4032 4 9.09721 5.24892 9.00596 6.82373L9.00087 7V10C9.00087 11.6569 10.344 13 12.0009 13C13.5986 13 14.9045 11.7511 14.9958 10.1763L15.0009 10V7C15.0009 5.34315 13.6577 4 12.0009 4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e4af913971fc69dd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.252V22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM18 17V14H20V17H23V19H20V22H18V19H15V17H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9d59aa476944d2b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18 17V14H20V17H23V19H20V22H18V19H15V17H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f1b1733d1c08c007(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1ae2b7d321c04d8f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 14.0619V22H4C4 17.5817 7.58172 14 12 14C12.3387 14 12.6724 14.021 13 14.0619ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM17.7929 19.9142L21.3284 16.3787L22.7426 17.7929L17.7929 22.7426L14.2574 19.2071L15.6716 17.7929L17.7929 19.9142Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4988a37fee94b4cf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM17.7929 19.9142L21.3284 16.3787L22.7426 17.7929L17.7929 22.7426L14.2574 19.2071L15.6716 17.7929L17.7929 19.9142Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6b3111f196bbb14(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13C15.3137 13 18 10.3137 18 7C18 3.68629 15.3137 1 12 1C8.68629 1 6 3.68629 6 7C6 10.3137 8.68629 13 12 13ZM15 18C15 16.3431 16.3431 15 18 15C18.4631 15 18.9018 15.105 19.2934 15.2924L15.2924 19.2934C15.105 18.9018 15 18.4631 15 18ZM16.7066 20.7076L20.7076 16.7066C20.895 17.0982 21 17.5369 21 18C21 19.6569 19.6569 21 18 21C17.5369 21 17.0982 20.895 16.7066 20.7076ZM18 13C15.2386 13 13 15.2386 13 18C13 20.7614 15.2386 23 18 23C20.7614 23 23 20.7614 23 18C23 15.2386 20.7614 13 18 13ZM12 14C12.0843 14 12.1683 14.0013 12.252 14.0039C11.4628 15.137 11 16.5145 11 18C11 19.4872 11.4638 20.8662 12.2547 22H4C4 17.5817 7.58172 14 12 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8f02c070053292dd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7ZM12 1C8.68629 1 6 3.68629 6 7C6 10.3137 8.68629 13 12 13C15.3137 13 18 10.3137 18 7C18 3.68629 15.3137 1 12 1ZM15 18C15 16.3431 16.3431 15 18 15C18.4631 15 18.9018 15.105 19.2934 15.2924L15.2924 19.2934C15.105 18.9018 15 18.4631 15 18ZM16.7066 20.7076L20.7076 16.7066C20.895 17.0982 21 17.5369 21 18C21 19.6569 19.6569 21 18 21C17.5369 21 17.0982 20.895 16.7066 20.7076ZM18 13C15.2386 13 13 15.2386 13 18C13 20.7614 15.2386 23 18 23C20.7614 23 23 20.7614 23 18C23 15.2386 20.7614 13 18 13ZM12 14C12.0843 14 12.1683 14.0013 12.252 14.0039C11.8236 14.6189 11.4914 15.3059 11.2772 16.0431C8.30431 16.4 6 18.9309 6 22H4C4 17.5817 7.58172 14 12 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3c4afa9f53353320(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.841 15.659L18.017 15.836L18.1945 15.659C19.0732 14.7803 20.4978 14.7803 21.3765 15.659C22.2552 16.5377 22.2552 17.9623 21.3765 18.841L18.0178 22.1997L14.659 18.841C13.7803 17.9623 13.7803 16.5377 14.659 15.659C15.5377 14.7803 16.9623 14.7803 17.841 15.659ZM12 14V22H4C4 17.6651 7.44784 14.1355 11.7508 14.0038L12 14ZM12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d938f7ac44354585(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.841 15.659L18.017 15.836L18.1945 15.659C19.0732 14.7803 20.4978 14.7803 21.3765 15.659C22.2552 16.5377 22.2552 17.9623 21.3765 18.841L18.0178 22.1997L14.659 18.841C13.7803 17.9623 13.7803 16.5377 14.659 15.659C15.5377 14.7803 16.9623 14.7803 17.841 15.659ZM12 14V16C8.68629 16 6 18.6863 6 22H4C4 17.6651 7.44784 14.1355 11.7508 14.0038L12 14ZM12 1C15.315 1 18 3.685 18 7C18 10.2397 15.4357 12.8776 12.225 12.9959L12 13C8.685 13 6 10.315 6 7C6 3.76034 8.56434 1.12237 11.775 1.00414L12 1ZM12 3C9.78957 3 8 4.78957 8 7C8 9.21043 9.78957 11 12 11C14.2104 11 16 9.21043 16 7C16 4.78957 14.2104 3 12 3Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3aff237500c4f3fd(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H18C18 18.6863 15.3137 16 12 16C8.68629 16 6 18.6863 6 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$421dd9c265cc552b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14V22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM20.8284 20.8284L18 23.6569L15.1716 20.8284C13.6095 19.2663 13.6095 16.7337 15.1716 15.1716C16.7337 13.6095 19.2663 13.6095 20.8284 15.1716C22.3905 16.7337 22.3905 19.2663 20.8284 20.8284ZM18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c45de2a158dd834c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14V16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM20.8284 21.0711L18 24L15.1716 21.0711C13.6095 19.4535 13.6095 16.8308 15.1716 15.2132C16.7337 13.5956 19.2663 13.5956 20.8284 15.2132C22.3905 16.8308 22.3905 19.4535 20.8284 21.0711ZM19.3897 19.6818C20.2034 18.8392 20.2034 17.4451 19.3897 16.6025C18.614 15.7992 17.386 15.7992 16.6103 16.6025C15.7966 17.4451 15.7966 18.8392 16.6103 19.6818L18 21.1209L19.3897 19.6818Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$197905a67e28da48(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.252V22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM20 17H23V19H20V22.5L15 18L20 13.5V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6b081e8fc57ee5b9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM20 17H23V19H20V22.5L15 18L20 13.5V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e09f69050c1b5c9c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.252V22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM19.4184 17H23.0042V19H19.4184L21.2469 20.8284L19.8326 22.2426L15.59 18L19.8326 13.7574L21.2469 15.1716L19.4184 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d52b4cf5f599b113(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM19.4184 17H23.0042V19H19.4184L21.2469 20.8284L19.8326 22.2426L15.59 18L19.8326 13.7574L21.2469 15.1716L19.4184 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d32576c83bb41156(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14V22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM21.4462 20.032L22.9497 21.5355L21.5355 22.9497L20.032 21.4462C19.4365 21.7981 18.7418 22 18 22C15.7909 22 14 20.2091 14 18C14 15.7909 15.7909 14 18 14C20.2091 14 22 15.7909 22 18C22 18.7418 21.7981 19.4365 21.4462 20.032ZM18 20C19.1046 20 20 19.1046 20 18C20 16.8954 19.1046 16 18 16C16.8954 16 16 16.8954 16 18C16 19.1046 16.8954 20 18 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a367f780f080d004(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14V16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM21.4462 20.032L22.9497 21.5355L21.5355 22.9497L20.032 21.4462C19.4365 21.7981 18.7418 22 18 22C15.7909 22 14 20.2091 14 18C14 15.7909 15.7909 14 18 14C20.2091 14 22 15.7909 22 18C22 18.7418 21.7981 19.4365 21.4462 20.032ZM18 20C19.1046 20 20 19.1046 20 18C20 16.8954 19.1046 16 18 16C16.8954 16 16 16.8954 16 18C16 19.1046 16.8954 20 18 20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$70a4a9eb472c72a8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14V22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM14.5946 18.8115C14.5327 18.5511 14.5 18.2794 14.5 18C14.5 17.7207 14.5327 17.449 14.5945 17.1886L13.6029 16.6161L14.6029 14.884L15.5952 15.4569C15.9883 15.0851 16.4676 14.8034 17 14.6449V13.5H19V14.6449C19.5324 14.8034 20.0116 15.0851 20.4047 15.4569L21.3971 14.8839L22.3972 16.616L21.4055 17.1885C21.4673 17.449 21.5 17.7207 21.5 18C21.5 18.2793 21.4673 18.551 21.4055 18.8114L22.3972 19.3839L21.3972 21.116L20.4048 20.543C20.0117 20.9149 19.5325 21.1966 19.0001 21.355V22.5H17.0001V21.3551C16.4677 21.1967 15.9884 20.915 15.5953 20.5431L14.603 21.1161L13.6029 19.384L14.5946 18.8115ZM18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ff96a4670ce2a206(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14V16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM14.5946 18.8115C14.5327 18.5511 14.5 18.2794 14.5 18C14.5 17.7207 14.5327 17.449 14.5945 17.1886L13.6029 16.6161L14.6029 14.884L15.5952 15.4569C15.9883 15.0851 16.4676 14.8034 17 14.6449V13.5H19V14.6449C19.5324 14.8034 20.0116 15.0851 20.4047 15.4569L21.3971 14.8839L22.3972 16.616L21.4055 17.1885C21.4673 17.449 21.5 17.7207 21.5 18C21.5 18.2793 21.4673 18.551 21.4055 18.8114L22.3972 19.3839L21.3972 21.116L20.4048 20.543C20.0117 20.9149 19.5325 21.1966 19.0001 21.355V22.5H17.0001V21.3551C16.4677 21.1967 15.9884 20.915 15.5953 20.5431L14.603 21.1161L13.6029 19.384L14.5946 18.8115ZM18 19.5C18.8284 19.5 19.5 18.8284 19.5 18C19.5 17.1716 18.8284 16.5 18 16.5C17.1716 16.5 16.5 17.1716 16.5 18C16.5 18.8284 17.1716 19.5 18 19.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$74d50d5b21a9e053(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.252V22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM18 17V13.5L23 18L18 22.5V19H15V17H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c95ad04694aa2d1f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18 17V13.5L23 18L18 22.5V19H15V17H18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$db5db2f66d5e948(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.252V22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM18.5858 17L16.7574 15.1716L18.1716 13.7574L22.4142 18L18.1716 22.2426L16.7574 20.8284L18.5858 19H15V17H18.5858Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$de0abe42d5b4142a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18.5858 17L16.7574 15.1716L18.1716 13.7574L22.4142 18L18.1716 22.2426L16.7574 20.8284L18.5858 19H15V17H18.5858Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$67c3825911b060b8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12H15C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12H7Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$adfcb6494191932d(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM7 12H9C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12H17C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$59fe93003bb24862(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14V22H4C4 17.5817 7.58172 14 12 14ZM18 21.5L15.0611 23.0451L15.6224 19.7725L13.2447 17.4549L16.5305 16.9775L18 14L19.4695 16.9775L22.7553 17.4549L20.3776 19.7725L20.9389 23.0451L18 21.5ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$ff29eb7ba5a97151(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14V16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18 21.5L15.0611 23.0451L15.6224 19.7725L13.2447 17.4549L16.5305 16.9775L18 14L19.4695 16.9775L22.7553 17.4549L20.3776 19.7725L20.9389 23.0451L18 21.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b912b598e17aca80(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.252V22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM19 16.5858L21.1213 14.4645L22.5355 15.8787L20.4142 18L22.5355 20.1213L21.1213 21.5355L19 19.4142L16.8787 21.5355L15.4645 20.1213L17.5858 18L15.4645 15.8787L16.8787 14.4645L19 16.5858Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$83fda440ac6fc271(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM19 17.5858L21.1213 15.4645L22.5355 16.8787L20.4142 19L22.5355 21.1213L21.1213 22.5355L19 20.4142L16.8787 22.5355L15.4645 21.1213L17.5858 19L15.4645 16.8787L16.8787 15.4645L19 17.5858Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3160ba22af304434(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 22.0001C1 17.5819 4.58172 14.0001 9 14.0001C13.4183 14.0001 17 17.5819 17 22.0001H1ZM9 13.0001C5.685 13.0001 3 10.3151 3 7.00014C3 3.68514 5.685 1.00014 9 1.00014C12.315 1.00014 15 3.68514 15 7.00014C15 10.3151 12.315 13.0001 9 13.0001ZM18.2463 3.18464C18.732 4.36038 19 5.64897 19 7.00014C19 8.35131 18.732 9.6399 18.2463 10.8156L16.5694 9.59607C16.8485 8.78206 17 7.90879 17 7.00014C17 6.09149 16.8485 5.21821 16.5694 4.4042L18.2463 3.18464ZM21.5476 0.783691C22.4773 2.65664 23 4.76735 23 7.00014C23 9.23293 22.4773 11.3436 21.5476 13.2166L19.9027 12.0203C20.6071 10.493 21 8.79243 21 7.00014C21 5.20785 20.6071 3.50733 19.9027 1.98002L21.5476 0.783691Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$769b31b38b09fd95(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 22.0001C1 17.5819 4.58172 14.0001 9 14.0001C13.4183 14.0001 17 17.5819 17 22.0001H15C15 18.6864 12.3137 16.0001 9 16.0001C5.68629 16.0001 3 18.6864 3 22.0001H1ZM9 13.0001C5.685 13.0001 3 10.3151 3 7.00014C3 3.68514 5.685 1.00014 9 1.00014C12.315 1.00014 15 3.68514 15 7.00014C15 10.3151 12.315 13.0001 9 13.0001ZM9 11.0001C11.21 11.0001 13 9.21014 13 7.00014C13 4.79014 11.21 3.00014 9 3.00014C6.79 3.00014 5 4.79014 5 7.00014C5 9.21014 6.79 11.0001 9 11.0001ZM21.5476 0.783691C22.4773 2.65664 23 4.76735 23 7.00014C23 9.23293 22.4773 11.3436 21.5476 13.2166L19.9027 12.0203C20.6071 10.493 21 8.79243 21 7.00014C21 5.20785 20.6071 3.50733 19.9027 1.98002L21.5476 0.783691ZM18.2463 3.18464C18.732 4.36038 19 5.64897 19 7.00014C19 8.35131 18.732 9.6399 18.2463 10.8156L16.5694 9.59607C16.8485 8.78206 17 7.90879 17 7.00014C17 6.09149 16.8485 5.21821 16.5694 4.4042L18.2463 3.18464Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$926e52bf0d3a6827(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15.9339C7.33064 15.445 4.5 12.3031 4.5 8.5C4.5 4.35786 7.85786 1 12 1C16.1421 1 19.5 4.35786 19.5 8.5C19.5 12.3031 16.6694 15.445 13 15.9339V18H18V20H13V24H11V20H6V18H11V15.9339Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$4951534a0220ff23(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15.9339C7.33064 15.445 4.5 12.3031 4.5 8.5C4.5 4.35786 7.85786 1 12 1C16.1421 1 19.5 4.35786 19.5 8.5C19.5 12.3031 16.6694 15.445 13 15.9339V18H18V20H13V24H11V20H6V18H11V15.9339ZM12 14C15.0376 14 17.5 11.5376 17.5 8.5C17.5 5.46243 15.0376 3 12 3C8.96243 3 6.5 5.46243 6.5 8.5C6.5 11.5376 8.96243 14 12 14Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$614df2909622d50c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 9C19.5 10.0606 20 11.3939 20 13C20 16.4664 16.3 17.276 14.5 22C13.8333 21.4254 13.5 20.5921 13.5 19.5C13.5 16.0181 18.5 14.2101 18.5 9ZM14.5 5C15.7 6.23841 16.3 7.57175 16.3 9C16.3 13.9513 10.2552 14.6918 11.5 22C9.83333 20.8392 9 19.1726 9 17C9 13.675 14.5 11 14.5 5ZM10 1C11.3333 2.66667 12 4.16667 12 5.5C12 11.75 3.5 13.7218 8 22C5.38352 21.4203 3.5 19 3.5 16C3.5 9.5 10 8.5 10 1Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$db71eeee0bbcb53e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9C19.6667 10.0606 20 11.3939 20 13C20 16 16.5 17 15 22C14.3333 21.4254 14 20.5921 14 19.5C14 16.0181 19 14.2101 19 9ZM14.5 5C15.1667 6.23841 15.5 7.57175 15.5 9C15.5 14 9.5 15 11.5 22C9.83333 20.8392 9 19.1726 9 17C9 13.675 14.5 11 14.5 5ZM10 1C10.6667 2.33333 11 3.83333 11 5.5C11 11.5 2 13 8 22C5.5 21.5 3.5 19 3.5 16C3.5 9.5 10 8.5 10 1Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f3a3d4574875c0f2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 10C2.567 10 1 8.433 1 6.5C1 4.567 2.567 3 4.5 3C6.433 3 8 4.567 8 6.5C8 8.433 6.433 10 4.5 10ZM4.5 8C5.32843 8 6 7.32843 6 6.5C6 5.67157 5.32843 5 4.5 5C3.67157 5 3 5.67157 3 6.5C3 7.32843 3.67157 8 4.5 8ZM22 10H20C20 7.79086 18.2091 6 16 6C13.7909 6 12 7.79086 12 10V15C12 17.2091 13.7909 19 16 19C18.2091 19 20 17.2091 20 15H22C22 18.3137 19.3137 21 16 21C12.6863 21 10 18.3137 10 15V10C10 6.68629 12.6863 4 16 4C19.3137 4 22 6.68629 22 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$53cad1c670bd2f65(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 10C2.567 10 1 8.433 1 6.5C1 4.567 2.567 3 4.5 3C6.433 3 8 4.567 8 6.5C8 8.433 6.433 10 4.5 10ZM4.5 8C5.32843 8 6 7.32843 6 6.5C6 5.67157 5.32843 5 4.5 5C3.67157 5 3 5.67157 3 6.5C3 7.32843 3.67157 8 4.5 8ZM22 10H20C20 7.79086 18.2091 6 16 6C13.7909 6 12 7.79086 12 10V15C12 17.2091 13.7909 19 16 19C18.2091 19 20 17.2091 20 15H22C22 18.3137 19.3137 21 16 21C12.6863 21 10 18.3137 10 15V10C10 6.68629 12.6863 4 16 4C19.3137 4 22 6.68629 22 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f720eee0d56f0a2c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 19V15.0069H2.07423C1.39109 13.8286 1 12.46 1 11C1 6.58172 4.58172 3 9 3C12.3949 3 15.2959 5.11466 16.4576 8.09864C16.7951 8.0339 17.1436 8 17.5 8C20.5376 8 23 10.4624 23 13.5C23 16.5376 20.5376 19 17.5 19H14ZM6 21H16V23H6V21ZM2 17H12V19H2V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9e77d17c2c004832(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 18V16H17.5C19.433 16 21 14.433 21 12.5C21 10.567 19.433 9 17.5 9C16.5205 9 15.6351 9.40232 14.9998 10.0507C14.9999 10.0338 15 10.0169 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10V10.0069H1V10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.5376 20.5376 18 17.5 18H14ZM6 20H16V22H6V20ZM6 12H14V14H6V12ZM2 16H12V18H2V16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5d207c01bcb5b530(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 21H7C3.68629 21 1 18.3137 1 15C1 12.3846 2.67346 10.16 5.00804 9.33857C5.0027 9.22639 5 9.11351 5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9C19 9.11351 18.9973 9.22639 18.992 9.33857C21.3265 10.16 23 12.3846 23 15C23 18.3137 20.3137 21 17 21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2b9e6f758ace12d8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 21H7C3.68629 21 1 18.3137 1 15C1 12.3846 2.67346 10.16 5.00804 9.33857C5.0027 9.22639 5 9.11351 5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9C19 9.11351 18.9973 9.22639 18.992 9.33857C21.3265 10.16 23 12.3846 23 15C23 18.3137 20.3137 21 17 21ZM7 19H17C19.2091 19 21 17.2091 21 15C21 12.7909 19.2091 11 17 11C16.8561 11 16.714 11.0076 16.5741 11.0224C16.8479 10.4041 17 9.71979 17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 9.71979 7.15209 10.4041 7.4259 11.0224C7.28596 11.0076 7.14387 11 7 11C4.79086 11 3 12.7909 3 15C3 17.2091 4.79086 19 7 19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$15584ec84bf15cb0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 20.9855C4.53831 20.7267 1 17.0266 1 12.5C1 7.80558 4.80558 4 9.5 4C12.5433 4 15.2131 5.59939 16.7146 8.00348C20.2051 8.11671 23 10.982 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811V21H9V20.9855Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$79544e90356bbf52(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 6C5.91015 6 3 8.91015 3 12.5C3 16.0899 5.91015 19 9.5 19H16.5C18.9853 19 21 16.9853 21 14.5C21 12.0147 18.9853 10 16.5 10C16.1717 10 15.8516 10.0352 15.5433 10.1019C14.589 7.69894 12.2429 6 9.5 6ZM16.5 21H9.5C4.80558 21 1 17.1944 1 12.5C1 7.80558 4.80558 4 9.5 4C12.5433 4 15.2131 5.59939 16.7146 8.00348C20.2051 8.11671 23 10.982 23 14.5C23 18.0899 20.0899 21 16.5 21Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$894277d63998a5c8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18V21H9V18C4.58172 18 1 14.4183 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.5376 20.5376 18 17.5 18H11ZM13 20H15V23H13V20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$65dc02b1e1c93cdb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18V16H17.5C19.433 16 21 14.433 21 12.5C21 10.567 19.433 9 17.5 9C16.5205 9 15.6351 9.40232 14.9998 10.0507C14.9999 10.0338 15 10.0169 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10C3 12.6124 4.66962 14.8349 7 15.6586V17.748C3.54955 16.8599 1 13.7277 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.5376 20.5376 18 17.5 18H17ZM9 16H11V20H9V16ZM13 19H15V23H13V19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9cfa9dda44abe35f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.3273 1.61162C11.677 1.29377 12.1956 1.26728 12.5734 1.53216L12.6727 1.61162L23 11.0001H20V20.0001C20 20.5129 19.614 20.9356 19.1166 20.9934L19 21.0001H12.5L15 17.0001L11.5 14.0001L15.5 11.0001L13 9.0001L13.5 6.0001L10.5 9.0001L13 11.0001L8 14.0001L11.75 17.5001L8.5 21.0001H5C4.48716 21.0001 4.06449 20.6141 4.00673 20.1167L4 20.0001V11.0001H1L11.3273 1.61162Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d45a2926a7518394(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21.0001C4.48716 21.0001 4.06449 20.6141 4.00673 20.1167L4 20.0001V11.0001H1L11.3273 1.61162C11.677 1.29377 12.1956 1.26728 12.5734 1.53216L12.6727 1.61162L23 11.0001H20V20.0001C20 20.5129 19.614 20.9356 19.1166 20.9934L19 21.0001H5ZM12 3.7021L6 9.1561V19.0001L10.357 18.9996L11.75 17.5001L8 14.0001L13 11.0001L10.5 9.0001L13.5 6.0001L13 9.0001L15.5 11.0001L11.5 14.0001L15 17.0001L13.75 18.9996L18 19.0001V9.1571L12 3.7021Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$44d1af01ef61cc8a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12H19V14H12V21H10V8C10 5.79086 11.7909 4 14 4H21V6H14C12.8954 6 12 6.89543 12 8V12ZM4.5 10C2.567 10 1 8.433 1 6.5C1 4.567 2.567 3 4.5 3C6.433 3 8 4.567 8 6.5C8 8.433 6.433 10 4.5 10ZM4.5 8C5.32843 8 6 7.32843 6 6.5C6 5.67157 5.32843 5 4.5 5C3.67157 5 3 5.67157 3 6.5C3 7.32843 3.67157 8 4.5 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$59aa04095d4b97fb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12H19V14H12V21H10V8C10 5.79086 11.7909 4 14 4H21V6H14C12.8954 6 12 6.89543 12 8V12ZM4.5 10C2.567 10 1 8.433 1 6.5C1 4.567 2.567 3 4.5 3C6.433 3 8 4.567 8 6.5C8 8.433 6.433 10 4.5 10ZM4.5 8C5.32843 8 6 7.32843 6 6.5C6 5.67157 5.32843 5 4.5 5C3.67157 5 3 5.67157 3 6.5C3 7.32843 3.67157 8 4.5 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$6ac08cc9e76a668b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 23C7.85786 23 4.5 19.6421 4.5 15.5C4.5 13.3462 5.40786 11.4045 6.86179 10.0366C8.20403 8.77375 11.5 6.49951 11 1.5C17 5.5 20 9.5 14 15.5C15 15.5 16.5 15.5 19 13.0296C19.2697 13.8032 19.5 14.6345 19.5 15.5C19.5 19.6421 16.1421 23 12 23Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e9b83149c372e31c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 23C16.1421 23 19.5 19.6421 19.5 15.5C19.5 14.6345 19.2697 13.8032 19 13.0296C17.3333 14.6765 16.0667 15.5 15.2 15.5C19.1954 8.5 17 5.5 11 1.5C11.5 6.49951 8.20403 8.77375 6.86179 10.0366C5.40786 11.4045 4.5 13.3462 4.5 15.5C4.5 19.6421 7.85786 23 12 23ZM12.7094 5.23498C15.9511 7.98528 15.9666 10.1223 13.463 14.5086C12.702 15.8419 13.6648 17.5 15.2 17.5C15.8884 17.5 16.5841 17.2992 17.3189 16.9051C16.6979 19.262 14.5519 21 12 21C8.96243 21 6.5 18.5376 6.5 15.5C6.5 13.9608 7.13279 12.5276 8.23225 11.4932C8.35826 11.3747 8.99749 10.8081 9.02477 10.7836C9.44862 10.4021 9.7978 10.0663 10.1429 9.69677C11.3733 8.37932 12.2571 6.91631 12.7094 5.23498Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9552f59e4f3126b1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10H20L11 23V14H4L13 1V10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$aa75db44963a5fa9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9H21L11 24V15H4L13 0V9ZM11 11V7.22063L7.53238 13H13V17.3944L17.263 11H11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8a922fe3ecef93c2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.0001 17.4724C17.0616 18.4224 18.4634 19.0001 20 19.0001H22V21.0001H20C18.5428 21.0001 17.1766 20.6105 15.9998 19.9298C14.8242 20.6103 13.4576 21.0001 12 21.0001C10.5428 21.0001 9.17657 20.6105 7.99984 19.9298C6.8242 20.6103 5.45763 21.0001 4 21.0001H2V19.0001H4C5.53713 19.0001 6.93925 18.4221 8.00013 17.4724C9.06163 18.4224 10.4634 19.0001 12 19.0001C13.5371 19.0001 14.9393 18.4221 16.0001 17.4724ZM12.5734 1.53216L12.6727 1.61162L23 11.0001H20V17.0001C18.3643 17.0001 16.912 16.2146 15.9998 15.0003C15.088 16.2146 13.6357 17.0001 12 17.0001C10.3643 17.0001 8.91199 16.2146 7.99978 15.0003C7.08801 16.2146 5.63573 17.0001 4 17.0001L3.999 10.9996L1 11.0001L11.3273 1.61162C11.6452 1.32267 12.1027 1.27451 12.4671 1.46714L12.5734 1.53216Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e1da485a88b6372(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.0001 17.4724C17.0616 18.4224 18.4634 19.0001 20 19.0001H22V21.0001H20C18.5428 21.0001 17.1766 20.6105 15.9998 19.9298C14.8242 20.6103 13.4576 21.0001 12 21.0001C10.5428 21.0001 9.17657 20.6105 7.99984 19.9298C6.8242 20.6103 5.45763 21.0001 4 21.0001H2V19.0001H4C5.53713 19.0001 6.93925 18.4221 8.00013 17.4724C9.06163 18.4224 10.4634 19.0001 12 19.0001C13.5371 19.0001 14.9393 18.4221 16.0001 17.4724ZM12.5734 1.53216L12.6727 1.61162L23 11.0001H20V17.0001C19.2988 17.0001 18.6258 16.8798 18.0003 16.6588L18 9.1571L12 3.7021L6 9.1561L6.00125 16.6583C5.4648 16.848 4.89325 16.9636 4.29898 16.9928L4 17.0001V11.0001H1L11.3273 1.61162C11.677 1.29377 12.1956 1.26728 12.5734 1.53216Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a0e7decb51ccf141(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5843 13.0069C1.20753 12.0786 1 11.0635 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 12.6709 22.9922 12.8399 22.977 13.0069H1.5843ZM4 19H21V21H4V19ZM2 15H23V17H2V15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bf1663b662128ae6(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5843 13.0069C1.20753 12.0786 1 11.0635 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 12.6709 22.9922 12.8399 22.977 13.0069H20.9636C20.9876 12.8414 21 12.6721 21 12.5C21 10.567 19.433 9 17.5 9C16.5205 9 15.6351 9.40232 14.9998 10.0507C14.9999 10.0338 15 10.0169 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10C3 11.0957 3.2937 12.1228 3.80666 13.0069H1.5843ZM4 19H21V21H4V19ZM2 15H23V17H2V15Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3ed6d5e8a5103b1f(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.9948 17.7944C18.8878 15.6808 17.1402 14 15 14C14.622 14 14.2562 14.0524 13.9096 14.1504C13.5201 12.3494 11.9176 11 10 11C7.79086 11 6 12.7909 6 15C6 16.0794 6.42752 17.0589 7.12246 17.7784C3.61004 16.9337 1 13.7716 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.0194 21.306 17.1432 18.9948 17.7944ZM10 17C8.89543 17 8 16.1046 8 15C8 13.8954 8.89543 13 10 13C11.1046 13 12 13.8954 12 15C12 16.1046 11.1046 17 10 17ZM15 20C13.8954 20 13 19.1046 13 18C13 16.8954 13.8954 16 15 16C16.1046 16 17 16.8954 17 18C17 19.1046 16.1046 20 15 20ZM10 23C8.89543 23 8 22.1046 8 21C8 19.8954 8.89543 19 10 19C11.1046 19 12 19.8954 12 21C12 22.1046 11.1046 23 10 23Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$83a7b588193cc8e1(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 17.4185C3.06817 16.2317 1 13.3574 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.0176 21.3085 17.14 19 17.793V15.6632C20.1825 15.1015 21 13.8962 21 12.5C21 10.567 19.433 9 17.5 9C16.5205 9 15.6351 9.40232 14.9998 10.0507C14.9999 10.0338 15 10.0169 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10C3 12.2208 4.2066 14.1599 6 15.1973V17.4185ZM10 17C8.89543 17 8 16.1046 8 15C8 13.8954 8.89543 13 10 13C11.1046 13 12 13.8954 12 15C12 16.1046 11.1046 17 10 17ZM15 20C13.8954 20 13 19.1046 13 18C13 16.8954 13.8954 16 15 16C16.1046 16 17 16.8954 17 18C17 19.1046 16.1046 20 15 20ZM10 23C8.89543 23 8 22.1046 8 21C8 19.8954 8.89543 19 10 19C11.1046 19 12 19.8954 12 21C12 22.1046 11.1046 23 10 23Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b48a5664be1d17da(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19C12.8284 19 13.5 19.6716 13.5 20.5C13.5 21.3284 12.8284 22 12 22C11.1716 22 10.5 21.3284 10.5 20.5C10.5 19.6716 11.1716 19 12 19ZM19.5 19C20.3284 19 21 19.6716 21 20.5C21 21.3284 20.3284 22 19.5 22C18.6716 22 18 21.3284 18 20.5C18 19.6716 18.6716 19 19.5 19ZM4.5 19C5.32843 19 6 19.6716 6 20.5C6 21.3284 5.32843 22 4.5 22C3.67157 22 3 21.3284 3 20.5C3 19.6716 3.67157 19 4.5 19ZM17 7C19.7614 7 22 9.23858 22 12C22 14.7614 19.7614 17 17 17C15.1564 17 13.4896 15.9595 11.9997 13.8785C10.5104 15.9595 8.84364 17 7 17C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7C8.84364 7 10.5104 8.04052 12.0003 10.1215C13.4896 8.04052 15.1564 7 17 7ZM12 2C12.8284 2 13.5 2.67157 13.5 3.5C13.5 4.32843 12.8284 5 12 5C11.1716 5 10.5 4.32843 10.5 3.5C10.5 2.67157 11.1716 2 12 2ZM4.5 2C5.32843 2 6 2.67157 6 3.5C6 4.32843 5.32843 5 4.5 5C3.67157 5 3 4.32843 3 3.5C3 2.67157 3.67157 2 4.5 2ZM19.5 2C20.3284 2 21 2.67157 21 3.5C21 4.32843 20.3284 5 19.5 5C18.6716 5 18 4.32843 18 3.5C18 2.67157 18.6716 2 19.5 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8cfcf9e8b1c9d142(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19C12.8284 19 13.5 19.6716 13.5 20.5C13.5 21.3284 12.8284 22 12 22C11.1716 22 10.5 21.3284 10.5 20.5C10.5 19.6716 11.1716 19 12 19ZM19.5 19C20.3284 19 21 19.6716 21 20.5C21 21.3284 20.3284 22 19.5 22C18.6716 22 18 21.3284 18 20.5C18 19.6716 18.6716 19 19.5 19ZM4.5 19C5.32843 19 6 19.6716 6 20.5C6 21.3284 5.32843 22 4.5 22C3.67157 22 3 21.3284 3 20.5C3 19.6716 3.67157 19 4.5 19ZM17 7C19.7614 7 22 9.23858 22 12C22 14.7614 19.7614 17 17 17C15.1564 17 13.4896 15.9595 11.9997 13.8785C10.5104 15.9595 8.84364 17 7 17C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7C8.84364 7 10.5104 8.04052 12.0003 10.1215C13.4896 8.04052 15.1564 7 17 7ZM7 9C5.34315 9 4 10.3431 4 12C4 13.6569 5.34315 15 7 15C8.25368 15 9.50923 14.1248 10.7587 12.1459L10.848 11.999L10.7587 11.8541C9.56129 9.95762 8.3583 9.07485 7.15672 9.00457L7 9ZM17 9C15.7463 9 14.4908 9.87517 13.2413 11.8541L13.151 12L13.2413 12.1459C14.4387 14.0424 15.6417 14.9252 16.8433 14.9954L17 15C18.6569 15 20 13.6569 20 12C20 10.3431 18.6569 9 17 9ZM12 2C12.8284 2 13.5 2.67157 13.5 3.5C13.5 4.32843 12.8284 5 12 5C11.1716 5 10.5 4.32843 10.5 3.5C10.5 2.67157 11.1716 2 12 2ZM4.5 2C5.32843 2 6 2.67157 6 3.5C6 4.32843 5.32843 5 4.5 5C3.67157 5 3 4.32843 3 3.5C3 2.67157 3.67157 2 4.5 2ZM19.5 2C20.3284 2 21 2.67157 21 3.5C21 4.32843 20.3284 5 19.5 5C18.6716 5 18 4.32843 18 3.5C18 2.67157 18.6716 2 19.5 2Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$df7f17719a3f03c3(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.08296 13C6.0284 12.6748 6 12.3407 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 12.3407 17.9716 12.6748 17.917 13H6.08296ZM2 15H12V17H2V15ZM14 15H22V17H14V15ZM16 19H20V21H16V19ZM4 19H14V21H4V19ZM11 1H13V4H11V1ZM3.51472 4.92893L4.92893 3.51472L7.05025 5.63604L5.63604 7.05025L3.51472 4.92893ZM19.0711 3.51472L20.4853 4.92893L18.364 7.05025L16.9497 5.63604L19.0711 3.51472ZM23 11V13H20V11H23ZM4 11V13H1V11H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$34cf8557822b681a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.08296 13C6.0284 12.6748 6 12.3407 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 12.3407 17.9716 12.6748 17.917 13H15.874C15.9562 12.6804 16 12.3453 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 12.3453 8.04375 12.6804 8.12602 13H6.08296ZM2 15H12V17H2V15ZM14 15H22V17H14V15ZM16 19H20V21H16V19ZM4 19H14V21H4V19ZM11 1H13V4H11V1ZM3.51472 4.92893L4.92893 3.51472L7.05025 5.63604L5.63604 7.05025L3.51472 4.92893ZM19.0711 3.51472L20.4853 4.92893L18.364 7.05025L16.9497 5.63604L19.0711 3.51472ZM23 11V13H20V11H23ZM4 11V13H1V11H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$87cfc70b5930790c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18V23H11V18H9V21H7V17.748C3.54955 16.8599 1 13.7277 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.5376 20.5376 18 17.5 18H17V21H15V18H13Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d4f110795f9a7ab8(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16.9297C2.60879 15.5465 1 12.9611 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.0176 21.3085 17.14 19 17.793V15.6632C20.1825 15.1015 21 13.8962 21 12.5C21 10.567 19.433 9 17.5 9C16.5205 9 15.6351 9.40232 14.9998 10.0507C14.9999 10.0338 15 10.0169 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10C3 11.777 3.7725 13.3736 5 14.4722V16.9297ZM7 14H9V20H7V14ZM15 14H17V20H15V14ZM11 17H13V23H11V17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$132524bf7460cdc9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 9.72064 4.75393 6.85093 7.37488 5.27777L14 1.453V4.223L21 1ZM12 8C9.23858 8 7 10.2386 7 13C7 15.7614 9.23858 18 12 18C14.7614 18 17 15.7614 17 13C17 10.2386 14.7614 8 12 8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f3fb518b575c5867(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 9.72064 4.75393 6.85093 7.37488 5.27777L14 1.453V4.223L21 1ZM19 4.122L12 7.34567V4.916L8.59717 6.88088C6.47212 8.06588 5.10056 10.2673 5.00531 12.7258L5 13C5 16.866 8.13401 20 12 20C15.7855 20 18.8691 16.9952 18.9959 13.2407L19 13V4.122ZM12 8C14.7614 8 17 10.2386 17 13C17 15.7614 14.7614 18 12 18C9.23858 18 7 15.7614 7 13C7 10.2386 9.23858 8 12 8ZM12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$dcdbcb1b4910d2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4H8V6H4V4ZM16 19H20V21H16V19ZM2 9H12V11H2V9ZM14 9H20V11H14V9ZM4 14H10V16H4V14ZM12 14H22V16H12V14ZM10 4H22V6H10V4ZM2 19H14V21H2V19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$bce5e2433f135caf(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4H8V6H4V4ZM16 19H20V21H16V19ZM2 9H7V11H2V9ZM9 9H12V11H9V9ZM14 9H20V11H14V9ZM4 14H10V16H4V14ZM12 14H15V16H12V14ZM17 14H22V16H17V14ZM10 4H22V6H10V4ZM2 19H14V21H2V19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c0e2a9951ccd6028(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.8216 2.23796C9.29417 3.38265 9 4.65697 9 6C9 10.9706 13.0294 15 18 15C19.343 15 20.6174 14.7058 21.762 14.1784C20.7678 18.6537 16.7747 22 12 22C6.47715 22 2 17.5228 2 12C2 7.22532 5.3463 3.23221 9.8216 2.23796ZM18.1642 2.29104L19 2.5V3.5L18.1642 3.70896C17.4476 3.8881 16.8881 4.4476 16.709 5.16417L16.5 6H15.5L15.291 5.16417C15.1119 4.4476 14.5524 3.8881 13.8358 3.70896L13 3.5V2.5L13.8358 2.29104C14.5524 2.1119 15.1119 1.5524 15.291 0.835829L15.5 0H16.5L16.709 0.835829C16.8881 1.5524 17.4476 2.1119 18.1642 2.29104ZM23.1642 7.29104L24 7.5V8.5L23.1642 8.70896C22.4476 8.8881 21.8881 9.4476 21.709 10.1642L21.5 11H20.5L20.291 10.1642C20.1119 9.4476 19.5524 8.8881 18.8358 8.70896L18 8.5V7.5L18.8358 7.29104C19.5524 7.1119 20.1119 6.5524 20.291 5.83583L20.5 5H21.5L21.709 5.83583C21.8881 6.5524 22.4476 7.1119 23.1642 7.29104Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$735fa8f74a301af7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6C10 10.4183 13.5817 14 18 14C19.4386 14 20.7885 13.6203 21.9549 12.9556C21.4738 18.0302 17.2005 22 12 22C6.47715 22 2 17.5228 2 12C2 6.79948 5.9698 2.52616 11.0444 2.04507C10.3797 3.21152 10 4.56142 10 6ZM4 12C4 16.4183 7.58172 20 12 20C14.9654 20 17.5757 18.3788 18.9571 15.9546C18.6407 15.9848 18.3214 16 18 16C12.4772 16 8 11.5228 8 6C8 5.67863 8.01524 5.35933 8.04536 5.04293C5.62119 6.42426 4 9.03458 4 12ZM18.1642 2.29104L19 2.5V3.5L18.1642 3.70896C17.4476 3.8881 16.8881 4.4476 16.709 5.16417L16.5 6H15.5L15.291 5.16417C15.1119 4.4476 14.5524 3.8881 13.8358 3.70896L13 3.5V2.5L13.8358 2.29104C14.5524 2.1119 15.1119 1.5524 15.291 0.835829L15.5 0H16.5L16.709 0.835829C16.8881 1.5524 17.4476 2.1119 18.1642 2.29104ZM23.1642 7.29104L24 7.5V8.5L23.1642 8.70896C22.4476 8.8881 21.8881 9.4476 21.709 10.1642L21.5 11H20.5L20.291 10.1642C20.1119 9.4476 19.5524 8.8881 18.8358 8.70896L18 8.5V7.5L18.8358 7.29104C19.5524 7.1119 20.1119 6.5524 20.291 5.83583L20.5 5H21.5L21.709 5.83583C21.8881 6.5524 22.4476 7.1119 23.1642 7.29104Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$f4d99aee095d8ec9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.67047 5.00666C9.79257 2.63812 12.205 1 15 1C15.4162 1 15.8239 1.03632 16.2201 1.10596C16.0772 1.54488 16 2.01342 16 2.5C16 4.98528 18.0147 7 20.5 7C20.9866 7 21.4551 6.92277 21.894 6.77991C21.9637 7.17612 22 7.58382 22 8C22 9.2228 21.6865 10.3724 21.1354 11.3727C22.2787 12.3806 23 13.856 23 15.5C23 18.5376 20.5376 21 17.5 21H9C4.58172 21 1 17.4183 1 13C1 8.6921 4.405 5.17948 8.67047 5.00666ZM10.8473 5.21433C13.4205 5.82257 15.5135 7.67351 16.4576 10.0986C16.7951 10.0339 17.1436 10 17.5 10C18.1745 10 18.8207 10.1214 19.4179 10.3436C19.6433 9.91944 19.8095 9.45894 19.9054 8.97316C16.79 8.69062 14.3094 6.20996 14.0268 3.09465C12.7061 3.35519 11.5722 4.13582 10.8473 5.21433Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9a7f1235cd631b78(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.67047 5.00666C9.79257 2.63812 12.205 1 15 1C15.4162 1 15.8239 1.03632 16.2201 1.10596C16.0772 1.54488 16 2.01342 16 2.5C16 4.98528 18.0147 7 20.5 7C20.9866 7 21.4551 6.92277 21.894 6.77991C21.9637 7.17612 22 7.58382 22 8C22 9.2228 21.6865 10.3724 21.1354 11.3727C22.2787 12.3806 23 13.856 23 15.5C23 18.5376 20.5376 21 17.5 21H9C4.58172 21 1 17.4183 1 13C1 8.6921 4.405 5.17948 8.67047 5.00666ZM10.8473 5.21433C13.4205 5.82257 15.5135 7.67351 16.4576 10.0986C16.7951 10.0339 17.1436 10 17.5 10C18.1745 10 18.8207 10.1214 19.4179 10.3436C19.6433 9.91944 19.8095 9.45894 19.9054 8.97316C16.79 8.69062 14.3094 6.20996 14.0268 3.09465C12.7061 3.35519 11.5722 4.13582 10.8473 5.21433ZM17.5 19C19.433 19 21 17.433 21 15.5C21 13.567 19.433 12 17.5 12C16.5205 12 15.6351 12.4023 14.9998 13.0507C14.9999 13.0338 15 13.0169 15 13C15 9.68629 12.3137 7 9 7C5.68629 7 3 9.68629 3 13C3 16.3137 5.68629 19 9 19H17.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2a18431cca056885(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.3807 2.01904C9.91573 3.38786 9 5.33708 9 7.50018C9 11.6423 12.3579 15.0002 16.5 15.0002C18.6631 15.0002 20.6123 14.0844 21.9811 12.6195C21.6613 17.8539 17.3149 22.0002 12 22.0002C6.47715 22.0002 2 17.523 2 12.0002C2 6.68532 6.14629 2.33888 11.3807 2.01904Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$9b93cd40fad13aef(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 20.3344V18H14V14H3.33238C3.11567 13.2034 3 12.3652 3 11.5C3 6.93948 6.21346 3.12954 10.4996 2.21094C10.1765 3.07935 10 4.01903 10 4.99995C10 9.41823 13.5817 13 18 13C19.4531 13 20.8157 12.6125 21.9902 11.9354C21.8178 15.7576 19.3867 18.9916 16 20.3344ZM7 20H14V22H7V20ZM2 16H12V18H2V16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d0fc34bcbb04db01(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 20.3346V18.1351C17.6993 17.2368 19.012 15.7048 19.6233 13.8538C19.0927 13.9506 18.5498 14.0001 18 14.0001C13.0294 14.0001 9 9.97071 9 5.00015C9 4.95455 9.00034 4.909 9.00102 4.86349C7.04146 5.89887 5.60285 7.77593 5.15045 10.0001H3.11775C3.79375 5.73838 7.30375 2.42018 11.6562 2.03711C11.2352 2.93693 11 3.94108 11 5.00015C11 8.86614 14.134 12.0001 18 12.0001C19.475 12.0001 20.8435 11.5439 21.972 10.7649C21.9905 11.0076 22 11.2527 22 11.5001C22 15.5108 19.5146 18.9411 16 20.3346ZM7 20.0001H14V22.0001H7V20.0001ZM4 12.0001H10V14.0001H4V12.0001ZM2 16.0001H12V18.0001H2V16.0001Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$662b13380d628593(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7C10 10.866 13.134 14 17 14C18.9584 14 20.729 13.1957 21.9995 11.8995C22 11.933 22 11.9665 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.0335 2 12.067 2 12.1005 2.00049C10.8043 3.27098 10 5.04157 10 7ZM4 12C4 16.4183 7.58172 20 12 20C15.0583 20 17.7158 18.2839 19.062 15.7621C18.3945 15.9187 17.7035 16 17 16C12.0294 16 8 11.9706 8 7C8 6.29648 8.08133 5.60547 8.2379 4.938C5.71611 6.28423 4 8.9417 4 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$3d8f0426f8c4a8aa(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C18.0751 4 23 8.92487 23 15V20H20V15C20 10.6651 16.5522 7.13546 12.2492 7.00381L12 7C7.66509 7 4.13546 10.4478 4.00381 14.7508L4 15V20H1V15C1 8.92487 5.92487 4 12 4ZM12 8C15.866 8 19 11.134 19 15V20H16V15C16 12.8578 14.316 11.1089 12.1996 11.0049L12 11C9.8578 11 8.10892 12.684 8.0049 14.8004L8 15V20H5V15C5 11.134 8.13401 8 12 8ZM12 12C13.6569 12 15 13.3431 15 15V20H9V15C9 13.3431 10.3431 12 12 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1ccf9681e3caa29e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C18.0751 4 23 8.92487 23 15V20H21V15C21 10.1182 17.1132 6.14421 12.2654 6.00384L12 6C7.1182 6 3.14421 9.88681 3.00384 14.7346L3 15V20H1V15C1 8.92487 5.92487 4 12 4ZM12 8C15.866 8 19 11.134 19 15V20H17V15C17 12.3112 14.8777 10.1182 12.2169 10.0046L12 10C9.31124 10 7.11818 12.1223 7.00462 14.7831L7 15V20H5V15C5 11.134 8.13401 8 12 8ZM12 12C13.6569 12 15 13.3431 15 15V20H13V15C13 14.4872 12.614 14.0645 12.1166 14.0067L12 14C11.4872 14 11.0645 14.386 11.0067 14.8834L11 15V20H9V15C9 13.3431 10.3431 12 12 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$32d74c5212dd688a(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.86 18L12.7071 14.8471C12.3166 14.4566 11.6834 14.4566 11.2929 14.8471L8.18137 17.9586C4.14765 17.5486 1 14.1419 1 10C1 5.58172 4.58172 2 9 2C11.9967 2 14.6086 3.64768 15.9791 6.08651C16.3109 6.02963 16.652 6 17 6C20.3137 6 23 8.68629 23 12C23 15.3137 20.3137 18 17 18H15.86ZM10.2322 18.7322L12 16.9645L13.7678 18.7322C14.7441 19.7085 14.7441 21.2915 13.7678 22.2678C12.7915 23.2441 11.2085 23.2441 10.2322 22.2678C9.25592 21.2915 9.25592 19.7085 10.2322 18.7322Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a1a600fb77ad4921(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18V16H17C19.2091 16 21 14.2091 21 12C21 9.79086 19.2091 8 17 8C16.2057 8 15.4654 8.23153 14.8431 8.63079C14.2236 5.97685 11.8427 4 9 4C5.68629 4 3 6.68629 3 10C3 12.973 5.16229 15.441 8 15.917V17.9381C4.05369 17.446 1 14.0796 1 10C1 5.58172 4.58172 2 9 2C11.9967 2 14.6086 3.64768 15.9791 6.08651C16.3109 6.02963 16.652 6 17 6C20.3137 6 23 8.68629 23 12C23 15.3137 20.3137 18 17 18H16ZM10.2322 18.7322L12 16.9645L13.7678 18.7322C14.7441 19.7085 14.7441 21.2915 13.7678 22.2678C12.7915 23.2441 11.2085 23.2441 10.2322 22.2678C9.25592 21.2915 9.25592 19.7085 10.2322 18.7322Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$546ce252d400fdac(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0.5L16 8L23.5 12L16 16L12 23.5L8 16L0.5 12L8 8L12 0.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1bad4c58d6552609(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8L23.5 12L16 16L12 23.5L8 16L0.5 12L8 8L12 0.5L16 8ZM19.25 12L14.5217 9.47826L12 4.75L9.47826 9.47826L4.75 12L9.47826 14.5217L12 19.25L14.5217 14.5217L19.25 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$af1ae3951408c5ea(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11C6.52285 11 11 6.52285 11 1H13C13 6.52285 17.4772 11 23 11V13C17.4772 13 13 17.4772 13 23H11C11 17.4772 6.52285 13 1 13V11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c1855dbb56f66787(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11C6.52285 11 11 6.52285 11 1H13C13 6.52285 17.4772 11 23 11V13C17.4772 13 13 17.4772 13 23H11C11 17.4772 6.52285 13 1 13V11ZM5.80342 12C8.56895 13.2093 10.7907 15.431 12 18.1966C13.2093 15.431 15.431 13.2093 18.1966 12C15.431 10.7907 13.2093 8.56895 12 5.80342C10.7907 8.56895 8.56895 10.7907 5.80342 12Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8eb2e1b8fe00512e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 18H9V21H7V17.748C3.54955 16.8599 1 13.7277 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.5376 20.5376 18 17.5 18H17V21H15V18ZM11 20H13V23H11V20Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$85ad7932792fd9c7(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16.9297C2.60879 15.5465 1 12.9611 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.0176 21.3085 17.14 19 17.793V15.6632C20.1825 15.1015 21 13.8962 21 12.5C21 10.567 19.433 9 17.5 9C16.5205 9 15.6351 9.40232 14.9998 10.0507C14.9999 10.0338 15 10.0169 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10C3 11.777 3.7725 13.3736 5 14.4722V16.9297ZM7 16H9V20H7V16ZM15 16H17V20H15V16ZM11 19H13V23H11V19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$81fc2d5514d2ce8c(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.02679 17.4293C3.08078 16.2492 1 13.3676 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.369 20.8032 17.725 18 17.9776C17.9879 14.6742 15.3062 12 12 12C8.87879 12 6.31421 14.3833 6.02679 17.4293ZM13 16.268L14.9641 15.134L15.9641 16.866L14 18L15.9641 19.134L14.9641 20.866L13 19.732V22H11V19.732L9.0359 20.866L8.0359 19.134L10 18L8.0359 16.866L9.0359 15.134L11 16.268V14H13V16.268Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e3ac3026222a2bf2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16.268L14.9641 15.134L15.9641 16.866L14 18L15.9641 19.134L14.9641 20.866L13 19.732V22H11V19.732L9.0359 20.866L8.0359 19.134L10 18L8.0359 16.866L9.0359 15.134L11 16.268V14H13V16.268ZM17 18V16H17.5C19.433 16 21 14.433 21 12.5C21 10.567 19.433 9 17.5 9C16.5205 9 15.6351 9.40232 14.9998 10.0507C14.9999 10.0338 15 10.0169 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10C3 12.6124 4.66962 14.8349 7 15.6586V17.748C3.54955 16.8599 1 13.7277 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.5376 20.5376 18 17.5 18H17Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$10be1b1b176b1b88(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0007 1.20801 18.3195 3.68083 20.7923 4.99968 18.3195 6.31852 17.0007 8.79134 15.6818 6.31852 13.209 4.99968 15.6818 3.68083 17.0007 1.20801ZM8.00065 4.33301 10.6673 9.33301 15.6673 11.9997 10.6673 14.6663 8.00065 19.6663 5.33398 14.6663.333984 11.9997 5.33398 9.33301 8.00065 4.33301ZM19.6673 16.333 18.0007 13.208 16.334 16.333 13.209 17.9997 16.334 19.6663 18.0007 22.7913 19.6673 19.6663 22.7923 17.9997 19.6673 16.333Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$5f5df1d919bc4a73(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0007 1.20801 18.3195 3.68083 20.7923 4.99968 18.3195 6.31852 17.0007 8.79134 15.6818 6.31852 13.209 4.99968 15.6818 3.68083 17.0007 1.20801ZM10.6673 9.33301 15.6673 11.9997 10.6673 14.6663 8.00065 19.6663 5.33398 14.6663.333984 11.9997 5.33398 9.33301 8.00065 4.33301 10.6673 9.33301ZM11.4173 11.9997 9.18905 10.8113 8.00065 8.58301 6.81224 10.8113 4.58398 11.9997 6.81224 13.1881 8.00065 15.4163 9.18905 13.1881 11.4173 11.9997ZM19.6673 16.333 18.0007 13.208 16.334 16.333 13.209 17.9997 16.334 19.6663 18.0007 22.7913 19.6673 19.6663 22.7923 17.9997 19.6673 16.333Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$d03271b2b04da2ec(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.4375C15.3462 4.4375 16.4375 3.34619 16.4375 2H17.5625C17.5625 3.34619 18.6538 4.4375 20 4.4375V5.5625C18.6538 5.5625 17.5625 6.65381 17.5625 8H16.4375C16.4375 6.65381 15.3462 5.5625 14 5.5625V4.4375ZM1 11C4.31371 11 7 8.31371 7 5H9C9 8.31371 11.6863 11 15 11V13C11.6863 13 9 15.6863 9 19H7C7 15.6863 4.31371 13 1 13V11ZM17.25 14C17.25 15.7949 15.7949 17.25 14 17.25V18.75C15.7949 18.75 17.25 20.2051 17.25 22H18.75C18.75 20.2051 20.2051 18.75 22 18.75V17.25C20.2051 17.25 18.75 15.7949 18.75 14H17.25Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c66693dbd71d2439(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.4375C15.3462 4.4375 16.4375 3.34619 16.4375 2H17.5625C17.5625 3.34619 18.6538 4.4375 20 4.4375V5.5625C18.6538 5.5625 17.5625 6.65381 17.5625 8H16.4375C16.4375 6.65381 15.3462 5.5625 14 5.5625V4.4375ZM1 11C4.31371 11 7 8.31371 7 5H9C9 8.31371 11.6863 11 15 11V13C11.6863 13 9 15.6863 9 19H7C7 15.6863 4.31371 13 1 13V11ZM4.87601 12C6.18717 12.7276 7.27243 13.8128 8 15.124 8.72757 13.8128 9.81283 12.7276 11.124 12 9.81283 11.2724 8.72757 10.1872 8 8.87601 7.27243 10.1872 6.18717 11.2724 4.87601 12ZM17.25 14C17.25 15.7949 15.7949 17.25 14 17.25V18.75C15.7949 18.75 17.25 20.2051 17.25 22H18.75C18.75 20.2051 20.2051 18.75 22 18.75V17.25C20.2051 17.25 18.75 15.7949 18.75 14H17.25Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2362d5036ee0b80e(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.98392 5.05991C11.1323 3.22236 13.1734 2 15.5 2C19.0899 2 22 4.91015 22 8.5C22 9.58031 21.7365 10.5991 21.2701 11.4955C22.3351 12.4985 23 13.9216 23 15.5C23 18.5376 20.5376 21 17.5 21H9C4.58172 21 1 17.4183 1 13C1 8.58172 4.58172 5 9 5C9.33312 5 9.66149 5.02036 9.98392 5.05991ZM12.0554 5.60419C14.0675 6.43637 15.6662 8.06578 16.4576 10.0986C16.7951 10.0339 17.1436 10 17.5 10C18.2351 10 18.9366 10.1442 19.5776 10.4059C19.8486 9.82719 20 9.18128 20 8.5C20 6.01472 17.9853 4 15.5 4C14.1177 4 12.8809 4.6233 12.0554 5.60419Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7d36402872919496(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.98392 5.05991C11.1323 3.22236 13.1734 2 15.5 2C19.0899 2 22 4.91015 22 8.5C22 9.58031 21.7365 10.5991 21.2701 11.4955C22.3351 12.4985 23 13.9216 23 15.5C23 18.5376 20.5376 21 17.5 21H9C4.58172 21 1 17.4183 1 13C1 8.58172 4.58172 5 9 5C9.33312 5 9.66149 5.02036 9.98392 5.05991ZM12.0554 5.60419C14.0675 6.43637 15.6662 8.06578 16.4576 10.0986C16.7951 10.0339 17.1436 10 17.5 10C18.2351 10 18.9366 10.1442 19.5776 10.4059C19.8486 9.82719 20 9.18128 20 8.5C20 6.01472 17.9853 4 15.5 4C14.1177 4 12.8809 4.6233 12.0554 5.60419ZM17.5 19C19.433 19 21 17.433 21 15.5C21 13.567 19.433 12 17.5 12C16.5205 12 15.6351 12.4023 14.9998 13.0507C14.9999 13.0338 15 13.0169 15 13C15 9.68629 12.3137 7 9 7C5.68629 7 3 9.68629 3 13C3 16.3137 5.68629 19 9 19H17.5Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1d049670da3b09e2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18ZM11 1H13V4H11V1ZM11 20H13V23H11V20ZM3.51472 4.92893L4.92893 3.51472L7.05025 5.63604L5.63604 7.05025L3.51472 4.92893ZM16.9497 18.364L18.364 16.9497L20.4853 19.0711L19.0711 20.4853L16.9497 18.364ZM19.0711 3.51472L20.4853 4.92893L18.364 7.05025L16.9497 5.63604L19.0711 3.51472ZM5.63604 16.9497L7.05025 18.364L4.92893 20.4853L3.51472 19.0711L5.63604 16.9497ZM23 11V13H20V11H23ZM4 11V13H1V11H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$738625c4e5d4ea01(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.34141 14C6.12031 13.3744 6 12.7013 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18V14H6.34141ZM6 20H15V22H6V20ZM1 11H4V13H1V11ZM2 16H10V18H2V16ZM11 1H13V4H11V1ZM3.51472 4.92893L4.92893 3.51472L7.05025 5.63604L5.63604 7.05025L3.51472 4.92893ZM16.9497 18.364L18.364 16.9497L20.4853 19.0711L19.0711 20.4853L16.9497 18.364ZM19.0711 3.51472L20.4853 4.92893L18.364 7.05025L16.9497 5.63604L19.0711 3.51472ZM23 11V13H20V11H23Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$1640b873a4f99ee4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12H10V14H4V12H6C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18V16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12ZM6 20H15V22H6V20ZM2 16H10V18H2V16ZM11 1H13V4H11V1ZM3.51472 4.92893L4.92893 3.51472L7.05025 5.63604L5.63604 7.05025L3.51472 4.92893ZM16.9497 18.364L18.364 16.9497L20.4853 19.0711L19.0711 20.4853L16.9497 18.364ZM19.0711 3.51472L20.4853 4.92893L18.364 7.05025L16.9497 5.63604L19.0711 3.51472ZM23 11V13H20V11H23Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$342df07497025c56(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16ZM11 1H13V4H11V1ZM11 20H13V23H11V20ZM3.51472 4.92893L4.92893 3.51472L7.05025 5.63604L5.63604 7.05025L3.51472 4.92893ZM16.9497 18.364L18.364 16.9497L20.4853 19.0711L19.0711 20.4853L16.9497 18.364ZM19.0711 3.51472L20.4853 4.92893L18.364 7.05025L16.9497 5.63604L19.0711 3.51472ZM5.63604 16.9497L7.05025 18.364L4.92893 20.4853L3.51472 19.0711L5.63604 16.9497ZM23 11V13H20V11H23ZM4 11V13H1V11H4Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$c733e952fe1205d2(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10.2547V5C8 2.79086 9.79086 1 12 1C14.2091 1 16 2.79086 16 5V10.2547C17.8135 11.5196 19 13.6213 19 16C19 19.866 15.866 23 12 23C8.13401 23 5 19.866 5 16C5 13.6213 6.18652 11.5196 8 10.2547ZM8 16C8 18.2091 9.79086 20 12 20C14.2091 20 16 18.2091 16 16H8Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e801bff27b01dda9(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5C8 2.79086 9.79086 1 12 1C14.2091 1 16 2.79086 16 5V10.2547C17.8135 11.5196 19 13.6213 19 16C19 19.866 15.866 23 12 23C8.13401 23 5 19.866 5 16C5 13.6213 6.18652 11.5196 8 10.2547V5ZM9.1442 11.8951C7.80943 12.8261 7 14.3432 7 16C7 18.7614 9.23858 21 12 21C14.7614 21 17 18.7614 17 16C17 14.3432 16.1906 12.8261 14.8558 11.8951L14 11.2981V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V11.2981L9.1442 11.8951ZM8 16H16C16 18.2091 14.2091 20 12 20C9.79086 20 8 18.2091 8 16Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$7ed19099577a1dbb(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10.2547V5C8 2.79086 9.79086 1 12 1C14.2091 1 16 2.79086 16 5V10.2547C17.8135 11.5196 19 13.6213 19 16C19 19.866 15.866 23 12 23C8.13401 23 5 19.866 5 16C5 13.6213 6.18652 11.5196 8 10.2547ZM11 12.126C9.27477 12.5701 8 14.1362 8 16C8 18.2091 9.79086 20 12 20C14.2091 20 16 18.2091 16 16C16 14.1362 14.7252 12.5701 13 12.126V5H11V12.126Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8ddf5f41ac037db0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5C8 2.79086 9.79086 1 12 1C14.2091 1 16 2.79086 16 5V10.2547C17.8135 11.5196 19 13.6213 19 16C19 19.866 15.866 23 12 23C8.13401 23 5 19.866 5 16C5 13.6213 6.18652 11.5196 8 10.2547V5ZM9.1442 11.8951C7.80943 12.8261 7 14.3432 7 16C7 18.7614 9.23858 21 12 21C14.7614 21 17 18.7614 17 16C17 14.3432 16.1906 12.8261 14.8558 11.8951L14 11.2981V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V11.2981L9.1442 11.8951ZM11 12.126V5H13V12.126C14.7252 12.5701 16 14.1362 16 16C16 18.2091 14.2091 20 12 20C9.79086 20 8 18.2091 8 16C8 14.1362 9.27477 12.5701 11 12.126ZM12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$8a5b52929586ea25(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9885 18L18.2044 16.4194C18.4061 16.1572 18.5154 15.8356 18.5154 15.5048C18.5154 14.6764 17.8439 14.0048 17.0154 14.0048H15V10.0291C15 9.56319 14.7835 9.12374 14.4141 8.83982C13.7573 8.33495 12.8156 8.45813 12.3107 9.11494L5.9453 17.3961C3.04248 16.1959 1 13.3365 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.5376 20.5376 18 17.5 18H16.9885ZM13 16.0048H16L11 22.5048V18.0048H8L13 11.5V16.0048Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2ec6f84c93c584f4(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18V16H17.5C19.433 16 21 14.433 21 12.5C21 10.567 19.433 9 17.5 9C16.5205 9 15.6351 9.40232 14.9998 10.0507C14.9999 10.0338 15 10.0169 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10C3 12.6124 4.66962 14.8349 7 15.6586V17.748C3.54955 16.8599 1 13.7277 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.5376 20.5376 18 17.5 18H17ZM13 16.0048H16L11 22.5048V18.0048H8L13 11.5V16.0048Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$aa932a4d83a95679(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3H22V5H2V3ZM4 7H20V9H4V7ZM8 11H22V13H8V11ZM10 15H18V17H10V15ZM8 19H14V21H8V19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$b66c5b87f6fb2add(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3H22V5H2V3ZM4 7H20V9H4V7ZM8 11H22V13H8V11ZM10 15H18V17H10V15ZM8 19H14V21H8V19Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$e01b0494f498da61(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6544 1.7002L14.8716 4.23333C16.147 4.62349 17.3453 5.2812 18.3612 6.20645C21.8744 9.40625 21.8744 14.5941 18.3612 17.7939C15.7696 20.1544 11.7644 21.6564 6.3456 22.3002L9.12838 19.7671C7.85304 19.3769 6.65466 18.7192 5.6388 17.7939C2.1256 14.5941 2.1048 9.4252 5.6388 6.20645C8.2304 3.84603 12.2356 2.34395 17.6544 1.7002ZM12 8.0002C9.51472 8.0002 7.5 9.79106 7.5 12.0002C7.5 14.2093 9.51472 16.0002 12 16.0002C14.4853 16.0002 16.5 14.2093 16.5 12.0002C16.5 9.79106 14.4853 8.0002 12 8.0002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$cf7f8addbee40345(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6544 1.7002L14.8716 4.23333C16.147 4.62349 17.3453 5.2812 18.3612 6.20645C21.8744 9.40625 21.8744 14.5941 18.3612 17.7939C15.7696 20.1544 11.7644 21.6564 6.3456 22.3002L9.12838 19.7671C7.85304 19.3769 6.65466 18.7192 5.6388 17.7939C2.1256 14.5941 2.1048 9.4252 5.6388 6.20645C8.2304 3.84603 12.2356 2.34395 17.6544 1.7002ZM12 6.0002C8.13401 6.0002 5 8.68649 5 12.0002C5 15.3139 8.13401 18.0002 12 18.0002C15.866 18.0002 19 15.3139 19 12.0002C19 8.68649 15.866 6.0002 12 6.0002ZM12 8.3002C14.2091 8.3002 16 9.95674 16 12.0002C16 14.0436 14.2091 15.7002 12 15.7002C9.79086 15.7002 8 14.0436 8 12.0002C8 9.95674 9.79086 8.3002 12 8.3002ZM12 10.3002C10.8621 10.3002 10 11.0976 10 12.0002C10 12.9027 10.8621 13.7002 12 13.7002C13.1379 13.7002 14 12.9027 14 12.0002C14 11.0976 13.1379 10.3002 12 10.3002Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$2068ad60314bf6f0(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0.269043L5.63604 6.633C2.12132 10.1477 2.12132 15.8462 5.63604 19.3609C9.15076 22.8756 14.8492 22.8756 18.364 19.3609C21.8787 15.8462 21.8787 10.1477 18.364 6.633L12 0.269043ZM16.2427 10.1714L9.17161 17.2425L7.7574 15.8282L14.8285 8.75718L16.2427 10.1714ZM8.11095 9.11073C8.69674 8.52494 9.64648 8.52494 10.2323 9.11073C10.8181 9.69652 10.8181 10.6463 10.2323 11.232C9.64648 11.8178 8.69674 11.8178 8.11095 11.232C7.52516 10.6463 7.52516 9.69652 8.11095 9.11073ZM15.8891 16.8889C15.3033 17.4747 14.3536 17.4747 13.7678 16.8889C13.182 16.3031 13.182 15.3534 13.7678 14.7676C14.3536 14.1818 15.3033 14.1818 15.8891 14.7676C16.4749 15.3534 16.4749 16.3031 15.8891 16.8889Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a9b21c8796801378(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.05025 8.04673L12 3.09698L16.9497 8.04673C19.6834 10.7804 19.6834 15.2126 16.9497 17.9462C14.2161 20.6799 9.78392 20.6799 7.05025 17.9462C4.31658 15.2126 4.31658 10.7804 7.05025 8.04673ZM18.364 6.63252L12 0.268555L5.63604 6.63252C2.12132 10.1472 2.12132 15.8457 5.63604 19.3604C9.15076 22.8752 14.8492 22.8752 18.364 19.3604C21.8787 15.8457 21.8787 10.1472 18.364 6.63252ZM16.2427 10.1714L14.8285 8.75718L7.7574 15.8282L9.17161 17.2425L16.2427 10.1714ZM8.11095 11.232C8.69674 11.8178 9.64648 11.8178 10.2323 11.232C10.8181 10.6463 10.8181 9.69652 10.2323 9.11073C9.64648 8.52494 8.69674 8.52494 8.11095 9.11073C7.52516 9.69652 7.52516 10.6463 8.11095 11.232ZM15.8891 16.8889C15.3033 17.4747 14.3536 17.4747 13.7678 16.8889C13.182 16.3031 13.182 15.3534 13.7678 14.7676C14.3536 14.1818 15.3033 14.1818 15.8891 14.7676C16.4749 15.3534 16.4749 16.3031 15.8891 16.8889Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$a1d88655fc64ca14(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 17H4V15H10.5C12.433 15 14 16.567 14 18.5C14 20.433 12.433 22 10.5 22C8.99957 22 7.71966 21.0559 7.22196 19.7293L9.09513 19.0268C9.30843 19.5954 9.85696 20 10.5 20C11.3284 20 12 19.3284 12 18.5C12 17.6716 11.3284 17 10.5 17ZM5 11H18.5C20.433 11 22 12.567 22 14.5C22 16.433 20.433 18 18.5 18C16.9996 18 15.7197 17.0559 15.222 15.7293L17.0951 15.0268C17.3084 15.5954 17.857 16 18.5 16C19.3284 16 20 15.3284 20 14.5C20 13.6716 19.3284 13 18.5 13H5C3.34315 13 2 11.6569 2 10C2 8.34315 3.34315 7 5 7H13.5C14.3284 7 15 6.32843 15 5.5C15 4.67157 14.3284 4 13.5 4C12.857 4 12.3084 4.40463 12.0951 4.97317L10.222 4.27073C10.7197 2.94414 11.9996 2 13.5 2C15.433 2 17 3.567 17 5.5C17 7.433 15.433 9 13.5 9H5C4.44772 9 4 9.44772 4 10C4 10.5523 4.44772 11 5 11Z"
                }
            }
        ]
    })(props);
}
function $0d9043722344d99e$export$39bbedaeefa5572b(props) {
    return (0, $88a9a4518753b77c$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 17H4V15H10.5C12.433 15 14 16.567 14 18.5C14 20.433 12.433 22 10.5 22C8.99957 22 7.71966 21.0559 7.22196 19.7293L9.09513 19.0268C9.30843 19.5954 9.85696 20 10.5 20C11.3284 20 12 19.3284 12 18.5C12 17.6716 11.3284 17 10.5 17ZM5 11H18.5C20.433 11 22 12.567 22 14.5C22 16.433 20.433 18 18.5 18C16.9996 18 15.7197 17.0559 15.222 15.7293L17.0951 15.0268C17.3084 15.5954 17.857 16 18.5 16C19.3284 16 20 15.3284 20 14.5C20 13.6716 19.3284 13 18.5 13H5C3.34315 13 2 11.6569 2 10C2 8.34315 3.34315 7 5 7H13.5C14.3284 7 15 6.32843 15 5.5C15 4.67157 14.3284 4 13.5 4C12.857 4 12.3084 4.40463 12.0951 4.97317L10.222 4.27073C10.7197 2.94414 11.9996 2 13.5 2C15.433 2 17 3.567 17 5.5C17 7.433 15.433 9 13.5 9H5C4.44772 9 4 9.44772 4 10C4 10.5523 4.44772 11 5 11Z"
                }
            }
        ]
    })(props);
}





const $807e1b15401998c2$export$d07517a676ce386f = Object.freeze([
    "base",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl"
]);
function $807e1b15401998c2$export$eca1915781c2aaca(prop, mapper) {
    if (Array.isArray(prop)) return prop.map((item)=>item === null ? null : mapper(item));
    if ((0, $ee96c6227c318ff4$export$a6cdc56e425d0d0a)(prop)) return Object.keys(prop).reduce((result, key)=>{
        result[key] = mapper(prop[key]);
        return result;
    }, {});
    if (prop != null) return mapper(prop);
    return null;
}
function $807e1b15401998c2$export$d9dcf045f3ec145e(obj, bps = $807e1b15401998c2$export$d07517a676ce386f) {
    const result = bps.map((br)=>obj[br] ?? null);
    const lastItem = result[result.length - 1];
    while(lastItem === null)result.pop();
    return result;
}
function $807e1b15401998c2$export$60476530468641e7(values, bps = $807e1b15401998c2$export$d07517a676ce386f) {
    const result = {};
    values.forEach((value, index)=>{
        const key = bps[index];
        if (value == null) return;
        result[key] = value;
    });
    return result;
}
function $807e1b15401998c2$export$2f4b3062f5f33794(obj, bps = $807e1b15401998c2$export$d07517a676ce386f) {
    const keys = Object.keys(obj);
    return keys.length > 0 && keys.every((key)=>bps.includes(key));
}
const $807e1b15401998c2$export$4cdfc817e07de39e = (v)=>Number.isNaN(Number(v));



var $acw62 = parcelRequire("acw62");


"use client";
const $7eb893aa48ec1adf$export$e840e8869344ca38 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)(function(props, ref) {
    const { ratio: ratio = 4 / 3, children: children, className: className, ...rest } = props;
    const child = (0, $acw62.Children).only(children);
    const _className = (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-aspect-ratio", className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
        ref: ref,
        position: "relative",
        className: _className,
        _before: {
            height: 0,
            content: `""`,
            display: "block",
            paddingBottom: (0, $807e1b15401998c2$export$eca1915781c2aaca)(ratio, (r)=>`${1 / r * 100}%`)
        },
        __css: {
            "& > *:not(style)": {
                overflow: "hidden",
                position: "absolute",
                top: "0",
                right: "0",
                bottom: "0",
                left: "0",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%"
            },
            "& > img, & > video": {
                objectFit: "cover"
            }
        },
        ...rest,
        children: child
    });
});
$7eb893aa48ec1adf$export$e840e8869344ca38.displayName = "AspectRatio";





function $0d379db27441c7a7$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(...args) {
        fns.forEach((fn)=>fn?.(...args));
    };
}
function $0d379db27441c7a7$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn?.(event);
            return event?.defaultPrevented;
        });
    };
}


var $4a7537e072260c10$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4a7537e072260c10$var$counterMap = new WeakMap();
var $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
var $4a7537e072260c10$var$markerMap = {};
var $4a7537e072260c10$var$lockCount = 0;
var $4a7537e072260c10$var$unwrapHost = function(node) {
    return node && (node.host || $4a7537e072260c10$var$unwrapHost(node.parentNode));
};
var $4a7537e072260c10$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4a7537e072260c10$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4a7537e072260c10$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4a7537e072260c10$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4a7537e072260c10$var$markerMap[markerName]) $4a7537e072260c10$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4a7537e072260c10$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($4a7537e072260c10$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4a7537e072260c10$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4a7537e072260c10$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4a7537e072260c10$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4a7537e072260c10$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4a7537e072260c10$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4a7537e072260c10$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4a7537e072260c10$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4a7537e072260c10$var$lockCount--;
        if (!$4a7537e072260c10$var$lockCount) {
            // clear
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
            $4a7537e072260c10$var$markerMap = {};
        }
    };
};
var $4a7537e072260c10$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $4a7537e072260c10$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $4a7537e072260c10$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4a7537e072260c10$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $4a7537e072260c10$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $4a7537e072260c10$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($4a7537e072260c10$export$cc95fea82d705fca() ? $4a7537e072260c10$export$59151cc8db999a24 : $4a7537e072260c10$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
var $45ceb2efab48c4b8$var$__defProp = Object.defineProperty;
var $45ceb2efab48c4b8$var$__defNormalProp = (obj, key, value)=>key in obj ? $45ceb2efab48c4b8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $45ceb2efab48c4b8$var$__publicField = (obj, key, value)=>{
    $45ceb2efab48c4b8$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
class $45ceb2efab48c4b8$var$ModalManager {
    constructor(){
        $45ceb2efab48c4b8$var$__publicField(this, "modals");
        this.modals = /* @__PURE__ */ new Set();
    }
    add(modal) {
        this.modals.add(modal);
        return this.modals.size;
    }
    remove(modal) {
        this.modals.delete(modal);
    }
    isTopModal(modal) {
        if (!modal) return false;
        const topModal = Array.from(this.modals)[this.modals.size - 1];
        return modal === topModal;
    }
}
const $45ceb2efab48c4b8$export$78d35f50a4fd5552 = new $45ceb2efab48c4b8$var$ModalManager();
function $45ceb2efab48c4b8$export$8557a94b9bb25060(ref, isOpen) {
    const [index, setIndex] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        const node = ref.current;
        if (!node) return;
        if (isOpen) {
            const index2 = $45ceb2efab48c4b8$export$78d35f50a4fd5552.add(node);
            setIndex(index2);
        }
        return ()=>{
            $45ceb2efab48c4b8$export$78d35f50a4fd5552.remove(node);
            setIndex(0);
        };
    }, [
        isOpen,
        ref
    ]);
    return index;
}


"use client";
function $8452b1e2f32848f3$export$33ffd74ebf07f060(props) {
    const { isOpen: isOpen, onClose: onClose, id: id, closeOnOverlayClick: closeOnOverlayClick = true, closeOnEsc: closeOnEsc = true, useInert: useInert = true, onOverlayClick: onOverlayClickProp, onEsc: onEsc } = props;
    const dialogRef = (0, $acw62.useRef)(null);
    const overlayRef = (0, $acw62.useRef)(null);
    const [dialogId, headerId, bodyId] = $8452b1e2f32848f3$var$useIds(id, `chakra-modal`, `chakra-modal--header`, `chakra-modal--body`);
    $8452b1e2f32848f3$export$bf01aaa71a18e30b(dialogRef, isOpen && useInert);
    const index = (0, $45ceb2efab48c4b8$export$8557a94b9bb25060)(dialogRef, isOpen);
    const mouseDownTarget = (0, $acw62.useRef)(null);
    const onMouseDown = (0, $acw62.useCallback)((event)=>{
        mouseDownTarget.current = event.target;
    }, []);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.key === "Escape") {
            event.stopPropagation();
            if (closeOnEsc) onClose?.();
            onEsc?.();
        }
    }, [
        closeOnEsc,
        onClose,
        onEsc
    ]);
    const [headerMounted, setHeaderMounted] = (0, $acw62.useState)(false);
    const [bodyMounted, setBodyMounted] = (0, $acw62.useState)(false);
    const getDialogProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            role: "dialog",
            ...props2,
            ref: (0, $6b244ebab8c02c76$export$c9058316764c140e)(ref, dialogRef),
            id: dialogId,
            tabIndex: -1,
            "aria-modal": true,
            "aria-labelledby": headerMounted ? headerId : void 0,
            "aria-describedby": bodyMounted ? bodyId : void 0,
            onClick: (0, $0d379db27441c7a7$export$5bdd3f730ec2c47e)(props2.onClick, (event)=>event.stopPropagation())
        }), [
        bodyId,
        bodyMounted,
        dialogId,
        headerId,
        headerMounted
    ]);
    const onOverlayClick = (0, $acw62.useCallback)((event)=>{
        event.stopPropagation();
        if (mouseDownTarget.current !== event.target) return;
        if (!(0, $45ceb2efab48c4b8$export$78d35f50a4fd5552).isTopModal(dialogRef.current)) return;
        if (closeOnOverlayClick) onClose?.();
        onOverlayClickProp?.();
    }, [
        onClose,
        closeOnOverlayClick,
        onOverlayClickProp
    ]);
    const getDialogContainerProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: (0, $6b244ebab8c02c76$export$c9058316764c140e)(ref, overlayRef),
            onClick: (0, $0d379db27441c7a7$export$5bdd3f730ec2c47e)(props2.onClick, onOverlayClick),
            onKeyDown: (0, $0d379db27441c7a7$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDown),
            onMouseDown: (0, $0d379db27441c7a7$export$5bdd3f730ec2c47e)(props2.onMouseDown, onMouseDown)
        }), [
        onKeyDown,
        onMouseDown,
        onOverlayClick
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        headerId: headerId,
        bodyId: bodyId,
        setBodyMounted: setBodyMounted,
        setHeaderMounted: setHeaderMounted,
        dialogRef: dialogRef,
        overlayRef: overlayRef,
        getDialogProps: getDialogProps,
        getDialogContainerProps: getDialogContainerProps,
        index: index
    };
}
function $8452b1e2f32848f3$export$bf01aaa71a18e30b(ref, shouldHide) {
    const currentElement = ref.current;
    (0, $acw62.useEffect)(()=>{
        if (!ref.current || !shouldHide) return void 0;
        return (0, $4a7537e072260c10$export$6e33d16126ed003c)(ref.current);
    }, [
        shouldHide,
        ref,
        currentElement
    ]);
}
function $8452b1e2f32848f3$var$useIds(idProp, ...prefixes) {
    const reactId = (0, $acw62.useId)();
    const id = idProp || reactId;
    return (0, $acw62.useMemo)(()=>{
        return prefixes.map((prefix)=>`${prefix}-${id}`);
    }, [
        id,
        prefixes
    ]);
}




"use client";
const [$8d5617b7cd68911b$var$ModalStylesProvider, $8d5617b7cd68911b$export$c540eec2ed4454a2] = (0, $f5f62380657c0122$export$fd42f52fd3ae1109)({
    name: `ModalStylesContext`,
    errorMessage: `useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Modal />" `
});
const [$8d5617b7cd68911b$export$7c9538f5f3c365e9, $8d5617b7cd68911b$export$4cc1699d46f42cae] = (0, $f5f62380657c0122$export$fd42f52fd3ae1109)({
    strict: true,
    name: "ModalContext",
    errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
});
const $8d5617b7cd68911b$export$2b77a92f1a5ad772 = (props)=>{
    const modalProps = {
        scrollBehavior: "outside",
        autoFocus: true,
        trapFocus: true,
        returnFocusOnClose: true,
        blockScrollOnMount: true,
        allowPinchZoom: false,
        preserveScrollBarGap: true,
        motionPreset: "scale",
        ...props,
        lockFocusAcrossFrames: props.lockFocusAcrossFrames || true
    };
    const { portalProps: portalProps, children: children, autoFocus: autoFocus, trapFocus: trapFocus, initialFocusRef: initialFocusRef, finalFocusRef: finalFocusRef, returnFocusOnClose: returnFocusOnClose, blockScrollOnMount: blockScrollOnMount, allowPinchZoom: allowPinchZoom, preserveScrollBarGap: preserveScrollBarGap, motionPreset: motionPreset, lockFocusAcrossFrames: lockFocusAcrossFrames, animatePresenceProps: animatePresenceProps, onCloseComplete: onCloseComplete } = modalProps;
    const styles = (0, $ec61beff530ee0ac$export$31cdfe60c085d76f)("Modal", modalProps);
    const modal = (0, $8452b1e2f32848f3$export$33ffd74ebf07f060)(modalProps);
    const context = {
        ...modal,
        autoFocus: autoFocus,
        trapFocus: trapFocus,
        initialFocusRef: initialFocusRef,
        finalFocusRef: finalFocusRef,
        returnFocusOnClose: returnFocusOnClose,
        blockScrollOnMount: blockScrollOnMount,
        allowPinchZoom: allowPinchZoom,
        preserveScrollBarGap: preserveScrollBarGap,
        motionPreset: motionPreset,
        lockFocusAcrossFrames: lockFocusAcrossFrames
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8d5617b7cd68911b$export$7c9538f5f3c365e9, {
        value: context,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8d5617b7cd68911b$var$ModalStylesProvider, {
            value: styles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                ...animatePresenceProps,
                onExitComplete: onCloseComplete,
                children: context.isOpen && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b1eb6dbc7c2eef5d$export$602eac185826482c), {
                    ...portalProps,
                    children: children
                })
            })
        })
    });
};
$8d5617b7cd68911b$export$2b77a92f1a5ad772.displayName = "Modal";




var $acw62 = parcelRequire("acw62");



"use client";
const $dee50d0250a4a081$export$cb540d8b0ef7906c = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, ...rest } = props;
    const { bodyId: bodyId, setBodyMounted: setBodyMounted } = (0, $8d5617b7cd68911b$export$4cc1699d46f42cae)();
    (0, $acw62.useEffect)(()=>{
        setBodyMounted(true);
        return ()=>setBodyMounted(false);
    }, [
        setBodyMounted
    ]);
    const _className = (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-modal__body", className);
    const styles = (0, $8d5617b7cd68911b$export$c540eec2ed4454a2)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
        ref: ref,
        className: _className,
        id: bodyId,
        ...rest,
        __css: styles.body
    });
});
$dee50d0250a4a081$export$cb540d8b0ef7906c.displayName = "ModalBody";






"use client";
const $d73afe5bfe6dcf52$export$edf9108895ba774f = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>{
    const { onClick: onClick, className: className, ...rest } = props;
    const { onClose: onClose } = (0, $8d5617b7cd68911b$export$4cc1699d46f42cae)();
    const _className = (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-modal__close-btn", className);
    const styles = (0, $8d5617b7cd68911b$export$c540eec2ed4454a2)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4de0b737b8d06ee0$export$de65de8213222d10), {
        ref: ref,
        __css: styles.closeButton,
        className: _className,
        onClick: (0, $0d379db27441c7a7$export$5bdd3f730ec2c47e)(onClick, (event)=>{
            event.stopPropagation();
            onClose();
        }),
        ...rest
    });
});
$d73afe5bfe6dcf52$export$edf9108895ba774f.displayName = "ModalCloseButton";








var $acw62 = parcelRequire("acw62");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";


/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $a98c5d9806f452ff$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $cf72c2f3484141be$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


function $bd3ba13f1d3e486a$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $cf72c2f3484141be$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $a98c5d9806f452ff$export$d734136a7b018efe)(ref, newValue);
        });
    });
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $c6c002fc8fc9c817$var$extendStatics = function(d, b) {
    $c6c002fc8fc9c817$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c6c002fc8fc9c817$var$extendStatics(d, b);
};
function $c6c002fc8fc9c817$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c6c002fc8fc9c817$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c6c002fc8fc9c817$export$18ce0697a983be9b = function() {
    $c6c002fc8fc9c817$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c6c002fc8fc9c817$export$18ce0697a983be9b.apply(this, arguments);
};
function $c6c002fc8fc9c817$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c6c002fc8fc9c817$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c6c002fc8fc9c817$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c6c002fc8fc9c817$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.push(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.push(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c6c002fc8fc9c817$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c6c002fc8fc9c817$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $c6c002fc8fc9c817$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c6c002fc8fc9c817$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c6c002fc8fc9c817$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c6c002fc8fc9c817$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c6c002fc8fc9c817$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c6c002fc8fc9c817$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c6c002fc8fc9c817$export$45d3717a4c69092e(o, m, p);
}
function $c6c002fc8fc9c817$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c6c002fc8fc9c817$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c6c002fc8fc9c817$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c6c002fc8fc9c817$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c6c002fc8fc9c817$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c6c002fc8fc9c817$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c6c002fc8fc9c817$export$10c90e4f7922046c(v) {
    return this instanceof $c6c002fc8fc9c817$export$10c90e4f7922046c ? (this.v = v, this) : new $c6c002fc8fc9c817$export$10c90e4f7922046c(v);
}
function $c6c002fc8fc9c817$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c6c002fc8fc9c817$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c6c002fc8fc9c817$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c6c002fc8fc9c817$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c6c002fc8fc9c817$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c6c002fc8fc9c817$export$19a8beecd37a4c45 === "function" ? $c6c002fc8fc9c817$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c6c002fc8fc9c817$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c6c002fc8fc9c817$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $c6c002fc8fc9c817$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c6c002fc8fc9c817$export$45d3717a4c69092e(result, mod, k);
    }
    $c6c002fc8fc9c817$var$__setModuleDefault(result, mod);
    return result;
}
function $c6c002fc8fc9c817$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c6c002fc8fc9c817$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c6c002fc8fc9c817$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c6c002fc8fc9c817$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $c6c002fc8fc9c817$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $bd3ba13f1d3e486a$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $f6d5b57f3512e73c$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};




var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $c6c002fc8fc9c817$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $acw62.createElement(Target, (0, $c6c002fc8fc9c817$export$18ce0697a983be9b)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $1334c25f36aeceaf$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $be1d9ed5bb532264$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $b5f767dd03f483e5$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $9f2b7a700f678519$var$Style = (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
var $9f2b7a700f678519$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $3f8d56f1a38c65c8$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    ").concat((0, $3f8d56f1a38c65c8$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($9f2b7a700f678519$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $9f2b7a700f678519$export$a1939b1f9f9b02dc = function() {
    $acw62.useEffect(function() {
        document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, ($9f2b7a700f678519$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $9f2b7a700f678519$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($9f2b7a700f678519$export$65254d5f26cb9564);
            else document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $9f2b7a700f678519$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $19c77eb414ad2a19$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;


var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowY");
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowX");
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState((0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2 || event.type === "wheel" && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $a7f277057d6643d0$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $f5f147098910888d$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}
function $f5f147098910888d$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $f6d5b57f3512e73c$export$e27363444bedfeac), (0, $f5f147098910888d$export$a09dbff87b5da2d));


var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $cac2578984d345ac$export$22940b497e769dee), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $0e88b28988758ab2$export$2e2bcd8739ae039)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $cac2578984d345ac$export$22940b497e769dee).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;





function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $34f6623b57e1a1c8$exports = {};

$parcel$export($34f6623b57e1a1c8$exports, "FOCUS_GROUP", () => $34f6623b57e1a1c8$export$4f9a06cb7441a087);
$parcel$export($34f6623b57e1a1c8$exports, "FOCUS_DISABLED", () => $34f6623b57e1a1c8$export$aeda8252e54b50f7);
$parcel$export($34f6623b57e1a1c8$exports, "FOCUS_ALLOW", () => $34f6623b57e1a1c8$export$54ecf528c58f9ef6);
$parcel$export($34f6623b57e1a1c8$exports, "FOCUS_AUTO", () => $34f6623b57e1a1c8$export$70e9b4a1820af101);
$parcel$export($34f6623b57e1a1c8$exports, "FOCUS_NO_AUTOFOCUS", () => $34f6623b57e1a1c8$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $34f6623b57e1a1c8$export$4f9a06cb7441a087 = "data-focus-lock";
var $34f6623b57e1a1c8$export$aeda8252e54b50f7 = "data-focus-lock-disabled";
var $34f6623b57e1a1c8$export$54ecf528c58f9ef6 = "data-no-focus-lock";
var $34f6623b57e1a1c8$export$70e9b4a1820af101 = "data-autofocus-inside";
var $34f6623b57e1a1c8$export$134ebef29fd94853 = "data-no-autofocus";



var $acw62 = parcelRequire("acw62");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



var $acw62 = parcelRequire("acw62");

var $119d56c93ccd46db$export$b8c7b07253306600 = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
};
var $119d56c93ccd46db$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $119d56c93ccd46db$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $acw62.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $119d56c93ccd46db$export$b8c7b07253306600
    }));
};
$119d56c93ccd46db$var$InFocusGuard.propTypes = {};
var $119d56c93ccd46db$export$2e2bcd8739ae039 = $119d56c93ccd46db$var$InFocusGuard;



var $292937b69072d1e6$export$5733e022b1d538cb = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $292937b69072d1e6$export$b3e9a9312f73723c = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)();
var $292937b69072d1e6$export$3a1d52767cbc07b8 = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)();
var $292937b69072d1e6$export$892cbf28e5518020 = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)({
    async: true,
    ssr: typeof document !== "undefined"
});



var $acw62 = parcelRequire("acw62");
var $8e648ed3a7dabece$export$f5272e9b1168239c = /*#__PURE__*/ (0, $acw62.createContext)(undefined);


var $e86725766b4cde33$var$emptyArray = [];
var $e86725766b4cde33$var$FocusLock = /*#__PURE__*/ $acw62.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $acw62.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $acw62.useRef();
    var isActive = $acw62.useRef(false);
    var originalFocusedElement = $acw62.useRef(null);
    var _React$useState2 = $acw62.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $e86725766b4cde33$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $acw62.useState({}), id = _React$useState3[0];
    var onActivation = $acw62.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $acw62.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $acw62.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === "function" ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $acw62.useCallback(function(event) {
        if (isActive.current) (0, $292937b69072d1e6$export$5733e022b1d538cb).useMedium(event);
    }, []);
    var onBlur = (0, $292937b69072d1e6$export$b3e9a9312f73723c).useMedium;
    var setObserveNode = $acw62.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[$34f6623b57e1a1c8$export$aeda8252e54b50f7] = disabled && "disabled", _extends2[$34f6623b57e1a1c8$export$4f9a06cb7441a087] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
    var mergedRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $acw62.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $acw62.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $acw62.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
        }) : null
    ], !disabled && /*#__PURE__*/ $acw62.createElement(SideCar, {
        id: id,
        sideCar: (0, $292937b69072d1e6$export$892cbf28e5518020),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ $acw62.createElement(Container, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $acw62.createElement((0, $8e648ed3a7dabece$export$f5272e9b1168239c).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $acw62.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
    }));
});
$e86725766b4cde33$var$FocusLock.propTypes = {};
var $e86725766b4cde33$export$2e2bcd8739ae039 = $e86725766b4cde33$var$FocusLock;



var $acw62 = parcelRequire("acw62");

function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}


function $b8f57191916382d3$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(obj);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(input, hint) {
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(arg) {
    var key = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(arg, "string");
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



var $acw62 = parcelRequire("acw62");
function $bec73a156e960f78$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $acw62.PureComponent));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $bec73a156e960f78$export$2e2bcd8739ae039 = $bec73a156e960f78$var$withSideEffect;


/*
IE11 support
 */ var $c2cb5aa387a37a50$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $c2cb5aa387a37a50$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $c2cb5aa387a37a50$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};



var $2cff22612808ae96$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
};
var $2cff22612808ae96$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $2cff22612808ae96$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $2cff22612808ae96$var$isInert = function(node) {
    return node.hasAttribute("inert");
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $2cff22612808ae96$var$isVisibleUncached = function(node, checkParent) {
    return !node || $2cff22612808ae96$var$isTopNode(node) || !$2cff22612808ae96$var$isElementHidden(node) && !$2cff22612808ae96$var$isInert(node) && checkParent($2cff22612808ae96$var$getParentNode(node));
};
var $2cff22612808ae96$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $2cff22612808ae96$var$isVisibleUncached(node, $2cff22612808ae96$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $2cff22612808ae96$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$2cff22612808ae96$var$isTopNode(node) ? $2cff22612808ae96$export$b8550e27de209d85(node) ? checkParent($2cff22612808ae96$var$getParentNode(node)) : false : true;
};
var $2cff22612808ae96$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $2cff22612808ae96$var$isAutoFocusAllowedUncached(node, $2cff22612808ae96$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $2cff22612808ae96$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $2cff22612808ae96$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === "BUTTON";
};
var $2cff22612808ae96$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === "INPUT";
};
var $2cff22612808ae96$export$9d74f6fbc6f469d0 = function(node) {
    return $2cff22612808ae96$export$88a6ceeed5737ba3(node) && node.type === "radio";
};
var $2cff22612808ae96$export$8197b0ea56b3b055 = function(node) {
    return !(($2cff22612808ae96$export$88a6ceeed5737ba3(node) || $2cff22612808ae96$export$65aad1b6bc934b11(node)) && (node.type === "hidden" || node.disabled));
};
var $2cff22612808ae96$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $34f6623b57e1a1c8$export$134ebef29fd94853));
    return ![
        true,
        "true",
        ""
    ].includes(attribute);
};
var $2cff22612808ae96$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $2cff22612808ae96$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $2cff22612808ae96$export$602e5a0d338d7750 = function(node) {
    return !$2cff22612808ae96$export$d94b8b58ec2f30eb(node);
};
var $2cff22612808ae96$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};



var $e6301f5798625d25$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $e6301f5798625d25$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute("tabindex")) return 0;
    }
    return node.tabIndex;
};
var $e6301f5798625d25$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(nodes).map(function(node, index) {
        var tabIndex = $e6301f5798625d25$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($e6301f5798625d25$export$350ee6c095d98996);
};




/**
 * list of the object to be considered as focusable
 */ var $9fc4580037f02fd3$export$8555f4622e95784 = [
    "button:enabled",
    "select:enabled",
    "textarea:enabled",
    "input:enabled",
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[tabindex]",
    "[contenteditable]",
    "[autofocus]"
];


var $c85a3cad3fc06f20$var$queryTabbables = (0, $9fc4580037f02fd3$export$8555f4622e95784).join(",");
var $c85a3cad3fc06f20$var$queryGuardTabbables = "".concat($c85a3cad3fc06f20$var$queryTabbables, ", [data-focus-guard]");
var $c85a3cad3fc06f20$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $c85a3cad3fc06f20$var$queryGuardTabbables : $c85a3cad3fc06f20$var$queryTabbables) ? [
            child
        ] : [], $c85a3cad3fc06f20$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $c85a3cad3fc06f20$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $c85a3cad3fc06f20$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $c85a3cad3fc06f20$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $c85a3cad3fc06f20$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $c85a3cad3fc06f20$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $c2cb5aa387a37a50$export$45b10814cc054894)(parent.parentNode.querySelectorAll($c85a3cad3fc06f20$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $c85a3cad3fc06f20$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $34f6623b57e1a1c8$export$70e9b4a1820af101), "]"));
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(parentFocus).map(function(node) {
        return $c85a3cad3fc06f20$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};


var $9b74641517b143d6$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $2cff22612808ae96$export$3c9dc299685ad160)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $2cff22612808ae96$export$8197b0ea56b3b055)(node);
    });
};
var $9b74641517b143d6$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $2cff22612808ae96$export$bcaa50628f6a736e)(cache, node);
    });
};
var $9b74641517b143d6$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $e6301f5798625d25$export$cb40ee071f0d5226)($9b74641517b143d6$export$6266a5cd5915dc33((0, $c85a3cad3fc06f20$export$f6768025e418420e)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $9b74641517b143d6$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $e6301f5798625d25$export$cb40ee071f0d5226)($9b74641517b143d6$export$6266a5cd5915dc33((0, $c85a3cad3fc06f20$export$f6768025e418420e)(topNodes), visibilityCache), false);
};
var $9b74641517b143d6$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $9b74641517b143d6$export$6266a5cd5915dc33((0, $c85a3cad3fc06f20$export$853fa94d922e78b9)(topNode), visibilityCache);
};
var $9b74641517b143d6$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $9b74641517b143d6$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $9b74641517b143d6$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $9b74641517b143d6$export$2344b14b097df817(child, element);
        });
    }
};


function $e8393b55a6e31e11$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === "undefined") return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $e8393b55a6e31e11$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $e8393b55a6e31e11$var$weakRef(currentElement),
            parent: $e8393b55a6e31e11$var$weakRef(currentElement.parentElement),
            left: $e8393b55a6e31e11$var$weakRef(currentElement.previousElementSibling),
            right: $e8393b55a6e31e11$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $e8393b55a6e31e11$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $e8393b55a6e31e11$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $9b74641517b143d6$export$3738e313571e2ad2)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $e8393b55a6e31e11$export$d357db6e554ff59a = function(targetElement) {
    var location = $e8393b55a6e31e11$export$5061a7725be48ff9(targetElement);
    return function() {
        return $e8393b55a6e31e11$var$restoreFocusTo(location);
    };
};



/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $7bf194f892d90e1b$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $7bf194f892d90e1b$var$getTopParent = function(node) {
    return node.parentNode ? $7bf194f892d90e1b$var$getTopParent(node.parentNode) : node;
};
var $7bf194f892d90e1b$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $34f6623b57e1a1c8$export$4f9a06cb7441a087));
        acc.push.apply(acc, group ? $7bf194f892d90e1b$var$filterNested((0, $c2cb5aa387a37a50$export$45b10814cc054894)($7bf194f892d90e1b$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $34f6623b57e1a1c8$export$4f9a06cb7441a087), '="').concat(group, '"]:not([').concat((0, $34f6623b57e1a1c8$export$aeda8252e54b50f7), '="disabled"])')))) : [
            currentNode
        ]);
        return acc;
    }, []);
};





var $51d90458d728fe34$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $51d90458d728fe34$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $51d90458d728fe34$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $51d90458d728fe34$var$getParents(nodeA);
    var parentsB = $51d90458d728fe34$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $51d90458d728fe34$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(baseActiveElement);
    var leftEntries = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $51d90458d728fe34$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $51d90458d728fe34$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $9b74641517b143d6$export$2344b14b097df817)(common, topCommon)) topCommon = common;
                else topCommon = $51d90458d728fe34$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $51d90458d728fe34$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $9b74641517b143d6$export$dc26309a71d1ce47)(node, visibilityCache));
    }, []);
};




var $3f73a80c2e676402$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $7bf194f892d90e1b$export$7e87c4720b9b279b)(topNode).filter((0, $2cff22612808ae96$export$602e5a0d338d7750));
    var commonParent = (0, $51d90458d728fe34$export$a9a7252b5f2e280e)(topNode, topNode, entries);
    var outerNodes = (0, $e6301f5798625d25$export$cb40ee071f0d5226)((0, $c85a3cad3fc06f20$export$f6768025e418420e)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $c85a3cad3fc06f20$export$f6768025e418420e)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $2cff22612808ae96$export$d94b8b58ec2f30eb)(node)
        };
    });
};

var $2bf5fb6846f8e2c5$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ("focus" in target) target.focus(focusOptions);
    if ("contentWindow" in target && target.contentWindow) target.contentWindow.focus();
};




var $b394242c3b6cfaf1$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error("no element or scope given");
        return {};
    }
    var shards = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(scope);
    if (shards.every(function(shard) {
        return !(0, $9b74641517b143d6$export$2344b14b097df817)(shard, element);
    })) {
        console.error("Active element is not contained in the scope");
        return {};
    }
    var focusables = useTabbables ? (0, $9b74641517b143d6$export$3738e313571e2ad2)(shards, new Map()) : (0, $9b74641517b143d6$export$493d05a3a8e6532d)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $b394242c3b6cfaf1$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $9b74641517b143d6$export$3738e313571e2ad2)((0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(shards), new Map()) : (0, $9b74641517b143d6$export$493d05a3a8e6532d)((0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $b394242c3b6cfaf1$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $b394242c3b6cfaf1$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $b394242c3b6cfaf1$var$defaultOptions(options);
    var solution = $b394242c3b6cfaf1$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $2bf5fb6846f8e2c5$export$c12b3da842c43a8)(target.node, newOptions.focusOptions);
};
var $b394242c3b6cfaf1$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $b394242c3b6cfaf1$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $b394242c3b6cfaf1$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $b394242c3b6cfaf1$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $b394242c3b6cfaf1$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $b394242c3b6cfaf1$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $2bf5fb6846f8e2c5$export$c12b3da842c43a8)(node.node, options.focusOptions);
};
var $b394242c3b6cfaf1$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $b394242c3b6cfaf1$var$pickBoundary(scope, options, "first");
};
var $b394242c3b6cfaf1$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $b394242c3b6cfaf1$var$pickBoundary(scope, options, "last");
};




/**
 * returns active element from document or from nested shadowdoms
 */ var $f296cb52f860ecc3$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};


var $b5783d59678393a3$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $b5783d59678393a3$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $f296cb52f860ecc3$export$78d20aae35adef88)(function() {
        return activeElement.contentWindow.document;
    }) ? $b5783d59678393a3$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};


var $eec3e0cab722c011$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $eec3e0cab722c011$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $c2cb5aa387a37a50$export$45b10814cc054894)(topNode.querySelectorAll("iframe")).some(function(node) {
        return $eec3e0cab722c011$var$focusInFrame(node, activeElement);
    }));
};
var $eec3e0cab722c011$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $b5783d59678393a3$export$cd4e5573fbe2b576)((0, $c2cb5aa387a37a50$export$bcd7afcd904dce14)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $7bf194f892d90e1b$export$7e87c4720b9b279b)(topNode).some(function(node) {
        return (0, $9b74641517b143d6$export$2344b14b097df817)(node, activeElement) || $eec3e0cab722c011$var$focusInsideIframe(node, activeElement);
    });
};





var $4a4957b2dfe49f02$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $b5783d59678393a3$export$cd4e5573fbe2b576)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(inDocument.querySelectorAll("[".concat((0, $34f6623b57e1a1c8$export$54ecf528c58f9ef6), "]"))).some(function(node) {
        return (0, $9b74641517b143d6$export$2344b14b097df817)(node, activeElement);
    });
};








var $3315685220e94b72$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $2cff22612808ae96$export$9d74f6fbc6f469d0)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $3315685220e94b72$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $2cff22612808ae96$export$9d74f6fbc6f469d0)(node) && node.name) return $3315685220e94b72$var$findSelectedRadio(node, nodes);
    return node;
};
var $3315685220e94b72$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($3315685220e94b72$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};



var $550b7510239b204f$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $3315685220e94b72$export$5261662167ad7ced)(nodes[0], nodes);
    return nodes[0];
};
var $550b7510239b204f$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $3315685220e94b72$export$5261662167ad7ced)(node, nodes));
};



var $5f30961e5fc5285a$export$85710b12cf912438 = "NEW_FOCUS";
var $5f30961e5fc5285a$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $2cff22612808ae96$export$d94b8b58ec2f30eb)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $5f30961e5fc5285a$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $5f30961e5fc5285a$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $3315685220e94b72$export$4a5a72a7124e45f9)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $550b7510239b204f$export$e06728ee87c96122)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $550b7510239b204f$export$e06728ee87c96122)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};








var $0a6fd98cd390fe5b$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $2cff22612808ae96$export$698b339b0c8edae3)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== "false" || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $0a6fd98cd390fe5b$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $9b74641517b143d6$export$2f70373d403a5d2b)(nodes.filter($0a6fd98cd390fe5b$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $550b7510239b204f$export$f4e86cfa0679b9cc)(autoFocusable);
    return (0, $550b7510239b204f$export$f4e86cfa0679b9cc)((0, $9b74641517b143d6$export$2f70373d403a5d2b)(orderedNodes));
};





var $d862fa039a3b3c25$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $2cff22612808ae96$export$4e62c701997796c1));
};
var $d862fa039a3b3c25$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $b5783d59678393a3$export$cd4e5573fbe2b576)((0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(topNode).length > 0 ? document : (0, $c2cb5aa387a37a50$export$bcd7afcd904dce14)(topNode).ownerDocument);
    var entries = (0, $7bf194f892d90e1b$export$7e87c4720b9b279b)(topNode).filter((0, $2cff22612808ae96$export$602e5a0d338d7750));
    var commonParent = (0, $51d90458d728fe34$export$a9a7252b5f2e280e)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $9b74641517b143d6$export$493d05a3a8e6532d)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $2cff22612808ae96$export$602e5a0d338d7750)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $9b74641517b143d6$export$493d05a3a8e6532d)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $d862fa039a3b3c25$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $5f30961e5fc5285a$export$65842178e9bb4205)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $5f30961e5fc5285a$export$85710b12cf912438)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $0a6fd98cd390fe5b$export$cfb742983e257555)(anyFocusable, innerTabbable, (0, $51d90458d728fe34$export$8f99714c70a37db1)(entries, visibilityCache)) || (0, $0a6fd98cd390fe5b$export$cfb742983e257555)(anyFocusable, innerFocusables, (0, $51d90458d728fe34$export$8f99714c70a37db1)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn("focus-lock: cannot find any node to move focus into");
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};


var $7698a7d35ed86651$var$guardCount = 0;
var $7698a7d35ed86651$var$lockDisabled = false;
var $7698a7d35ed86651$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $d862fa039a3b3c25$export$305758c744b57f6f)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($7698a7d35ed86651$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($7698a7d35ed86651$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $7698a7d35ed86651$var$lockDisabled = true;
            setTimeout(function() {
                $7698a7d35ed86651$var$lockDisabled = false;
            }, 1);
            return;
        }
        $7698a7d35ed86651$var$guardCount++;
        (0, $2bf5fb6846f8e2c5$export$c12b3da842c43a8)(focusable.node, options.focusOptions);
        $7698a7d35ed86651$var$guardCount--;
    }
};





/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $db815af593127be9$export$1a988e7317c65621 = $34f6623b57e1a1c8$exports;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $db815af593127be9$var$deprecated_default_moveFocusInside = (0, $7698a7d35ed86651$export$cd599851e879a025);
var $db815af593127be9$export$2e2bcd8739ae039 //
 = $db815af593127be9$var$deprecated_default_moveFocusInside;


function $de7ba2c6b170eb4f$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $de7ba2c6b170eb4f$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $de7ba2c6b170eb4f$export$c613fed06e332533 = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};



var $00df5dbe84bcea91$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $00df5dbe84bcea91$var$isFreeFocus = function isFreeFocus() {
    return $00df5dbe84bcea91$var$focusOnBody() || (0, $4a4957b2dfe49f02$export$be6b21806d3fd485)();
};
var $00df5dbe84bcea91$var$lastActiveTrap = null;
var $00df5dbe84bcea91$var$lastActiveFocus = null;
var $00df5dbe84bcea91$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $00df5dbe84bcea91$var$lastPortaledElement = null;
var $00df5dbe84bcea91$var$focusWasOutsideWindow = false;
var $00df5dbe84bcea91$var$windowFocused = false;
var $00df5dbe84bcea91$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $00df5dbe84bcea91$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($00df5dbe84bcea91$var$lastActiveTrap.whiteList || $00df5dbe84bcea91$var$defaultWhitelist)(activeElement);
};
var $00df5dbe84bcea91$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $00df5dbe84bcea91$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $00df5dbe84bcea91$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $00df5dbe84bcea91$var$lastPortaledElement && $00df5dbe84bcea91$var$lastPortaledElement.portaledElement === element;
};
function $00df5dbe84bcea91$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $00df5dbe84bcea91$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($00df5dbe84bcea91$var$focusWasOutsideWindow);
    return $00df5dbe84bcea91$var$focusWasOutsideWindow === "meanwhile";
};
var $00df5dbe84bcea91$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $00df5dbe84bcea91$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $00df5dbe84bcea91$var$checkInHost(activeElement, area, area);
    });
};
var $00df5dbe84bcea91$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $9b74641517b143d6$export$493d05a3a8e6532d)(nodes, new Map());
};
var $00df5dbe84bcea91$var$isNotFocusable = function isNotFocusable(node) {
    return !$00df5dbe84bcea91$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $00df5dbe84bcea91$var$activateTrap = function activateTrap() {
    var result = false;
    if ($00df5dbe84bcea91$var$lastActiveTrap) {
        var _lastActiveTrap = $00df5dbe84bcea91$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $00df5dbe84bcea91$var$lastPortaledElement && $00df5dbe84bcea91$var$lastPortaledElement.portaledElement;
        if ($00df5dbe84bcea91$var$focusOnBody() && $00df5dbe84bcea91$var$lastActiveFocus) {
            if (!document.body.contains($00df5dbe84bcea91$var$lastActiveFocus) || $00df5dbe84bcea91$var$isNotFocusable($00df5dbe84bcea91$var$lastActiveFocus)) {
                $00df5dbe84bcea91$var$lastActiveFocus = null;
                var newTarget = $00df5dbe84bcea91$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $de7ba2c6b170eb4f$export$c613fed06e332533)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$00df5dbe84bcea91$var$focusWasOutside(crossFrame) || !noFocusGuards || !$00df5dbe84bcea91$var$lastActiveFocus || $00df5dbe84bcea91$var$windowFocused) return false;
                var nodes = $00df5dbe84bcea91$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $00df5dbe84bcea91$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $00df5dbe84bcea91$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$00df5dbe84bcea91$var$isFreeFocus() || !$00df5dbe84bcea91$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $eec3e0cab722c011$export$20115f8da7baa6fa)(workingArea) || activeElement && $00df5dbe84bcea91$var$withinHost(activeElement, workingArea) || $00df5dbe84bcea91$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$00df5dbe84bcea91$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $7698a7d35ed86651$export$cd599851e879a025)(workingArea, $00df5dbe84bcea91$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $00df5dbe84bcea91$var$lastPortaledElement = {};
                        }
                    }
                    $00df5dbe84bcea91$var$focusWasOutsideWindow = false;
                    $00df5dbe84bcea91$var$lastActiveFocus = document && document.activeElement;
                    $00df5dbe84bcea91$var$tryRestoreFocus = (0, $e8393b55a6e31e11$export$d357db6e554ff59a)($00df5dbe84bcea91$var$lastActiveFocus);
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $3f73a80c2e676402$export$f89ac71e91767111)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute("tabIndex");
                    });
                    $00df5dbe84bcea91$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $00df5dbe84bcea91$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $00df5dbe84bcea91$var$onTrap = function onTrap(event) {
    if ($00df5dbe84bcea91$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $00df5dbe84bcea91$var$onBlur = function onBlur() {
    return (0, $de7ba2c6b170eb4f$export$6523025722806278)($00df5dbe84bcea91$var$activateTrap);
};
var $00df5dbe84bcea91$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $00df5dbe84bcea91$var$recordPortal(currentNode, source);
};
var $00df5dbe84bcea91$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $00df5dbe84bcea91$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ $acw62.createElement("div", {
        onBlur: $00df5dbe84bcea91$var$onBlur,
        onFocus: $00df5dbe84bcea91$var$onFocus
    }, children);
};
$00df5dbe84bcea91$var$FocusTrap.propTypes = {};
var $00df5dbe84bcea91$var$onWindowFocus = function onWindowFocus() {
    $00df5dbe84bcea91$var$windowFocused = true;
};
var $00df5dbe84bcea91$var$onWindowBlur = function onWindowBlur() {
    $00df5dbe84bcea91$var$windowFocused = false;
    $00df5dbe84bcea91$var$focusWasOutsideWindow = "just";
    (0, $de7ba2c6b170eb4f$export$6523025722806278)(function() {
        $00df5dbe84bcea91$var$focusWasOutsideWindow = "meanwhile";
    });
};
var $00df5dbe84bcea91$var$attachHandler = function attachHandler() {
    document.addEventListener("focusin", $00df5dbe84bcea91$var$onTrap);
    document.addEventListener("focusout", $00df5dbe84bcea91$var$onBlur);
    window.addEventListener("focus", $00df5dbe84bcea91$var$onWindowFocus);
    window.addEventListener("blur", $00df5dbe84bcea91$var$onWindowBlur);
};
var $00df5dbe84bcea91$var$detachHandler = function detachHandler() {
    document.removeEventListener("focusin", $00df5dbe84bcea91$var$onTrap);
    document.removeEventListener("focusout", $00df5dbe84bcea91$var$onBlur);
    window.removeEventListener("focus", $00df5dbe84bcea91$var$onWindowFocus);
    window.removeEventListener("blur", $00df5dbe84bcea91$var$onWindowBlur);
};
function $00df5dbe84bcea91$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $00df5dbe84bcea91$var$focusLockAPI = {
    moveFocusInside: (0, $7698a7d35ed86651$export$cd599851e879a025),
    focusInside: (0, $eec3e0cab722c011$export$20115f8da7baa6fa),
    focusNextElement: (0, $b394242c3b6cfaf1$export$3b0237e8566c8d65),
    focusPrevElement: (0, $b394242c3b6cfaf1$export$33b47db07a82b2fb),
    focusFirstElement: (0, $b394242c3b6cfaf1$export$2a791d8097a66406),
    focusLastElement: (0, $b394242c3b6cfaf1$export$6a79073ddabfd6c3),
    captureFocusRestore: (0, $e8393b55a6e31e11$export$d357db6e554ff59a)
};
function $00df5dbe84bcea91$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$00df5dbe84bcea91$var$lastActiveTrap) $00df5dbe84bcea91$var$attachHandler();
    var lastTrap = $00df5dbe84bcea91$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $00df5dbe84bcea91$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $00df5dbe84bcea91$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($00df5dbe84bcea91$var$focusLockAPI);
        $00df5dbe84bcea91$var$activateTrap(true);
        (0, $de7ba2c6b170eb4f$export$6523025722806278)($00df5dbe84bcea91$var$activateTrap);
    } else {
        $00df5dbe84bcea91$var$detachHandler();
        $00df5dbe84bcea91$var$lastActiveFocus = null;
    }
}
(0, $292937b69072d1e6$export$5733e022b1d538cb).assignSyncMedium($00df5dbe84bcea91$var$onFocus);
(0, $292937b69072d1e6$export$b3e9a9312f73723c).assignMedium($00df5dbe84bcea91$var$onBlur);
(0, $292937b69072d1e6$export$3a1d52767cbc07b8).assignMedium(function(cb) {
    return cb($00df5dbe84bcea91$var$focusLockAPI);
});
var $00df5dbe84bcea91$export$2e2bcd8739ae039 = (0, $bec73a156e960f78$export$2e2bcd8739ae039)($00df5dbe84bcea91$var$reducePropsToState, $00df5dbe84bcea91$var$handleStateChangeOnClient)($00df5dbe84bcea91$var$FocusWatcher);


var $afd3cd9c4d0274d7$var$FocusLockCombination = /*#__PURE__*/ $acw62.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $e86725766b4cde33$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        sideCar: (0, $00df5dbe84bcea91$export$2e2bcd8739ae039),
        ref: ref
    }, props));
});
var $afd3cd9c4d0274d7$var$_ref = (0, $e86725766b4cde33$export$2e2bcd8739ae039).propTypes || {}, $afd3cd9c4d0274d7$var$sideCar = $afd3cd9c4d0274d7$var$_ref.sideCar, $afd3cd9c4d0274d7$var$propTypes = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)($afd3cd9c4d0274d7$var$_ref, [
    "sideCar"
]);
$afd3cd9c4d0274d7$var$FocusLockCombination.propTypes = {};
var $afd3cd9c4d0274d7$export$2e2bcd8739ae039 = $afd3cd9c4d0274d7$var$FocusLockCombination;



var $9962412629625ccb$export$2e2bcd8739ae039 = (0, $afd3cd9c4d0274d7$export$2e2bcd8739ae039);



const $c12aa22390fc675a$export$f5f22eac728522fd = (element)=>window.getComputedStyle(element).display === "none";
const $c12aa22390fc675a$export$54209d29bacd2cb9 = (element)=>element.hasAttribute("tabindex");
const $c12aa22390fc675a$export$87df0ed37d24dd13 = (element)=>$c12aa22390fc675a$export$54209d29bacd2cb9(element) && element.tabIndex === -1;
function $c12aa22390fc675a$export$848589947316f680(element) {
    if (!document.activeElement) return false;
    return element.contains(document.activeElement);
}
function $c12aa22390fc675a$export$4c063cf1350e6fed(element) {
    if (!(0, $225a75bff56eb0c3$export$1b3bfaa9684536aa)(element) || (0, $225a75bff56eb0c3$export$ca1c506c57abefed)(element) || (0, $225a75bff56eb0c3$export$f1048a3bb039cd02)(element)) return false;
    const { localName: localName } = element;
    const focusableTags = [
        "input",
        "select",
        "textarea",
        "button"
    ];
    if (focusableTags.indexOf(localName) >= 0) return true;
    const others = {
        a: ()=>element.hasAttribute("href"),
        audio: ()=>element.hasAttribute("controls"),
        video: ()=>element.hasAttribute("controls")
    };
    if (localName in others) return others[localName]();
    if ((0, $225a75bff56eb0c3$export$de19eba357c4d80f)(element)) return true;
    return $c12aa22390fc675a$export$54209d29bacd2cb9(element);
}
function $c12aa22390fc675a$export$bebd5a1431fec25d(element) {
    if (!element) return false;
    return (0, $225a75bff56eb0c3$export$1b3bfaa9684536aa)(element) && $c12aa22390fc675a$export$4c063cf1350e6fed(element) && !$c12aa22390fc675a$export$87df0ed37d24dd13(element);
}


const $6e683993385b7e97$var$focusableElList = [
    "input:not(:disabled):not([disabled])",
    "select:not(:disabled):not([disabled])",
    "textarea:not(:disabled):not([disabled])",
    "embed",
    "iframe",
    "object",
    "a[href]",
    "area[href]",
    "button:not(:disabled):not([disabled])",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    "*[tabindex]:not([aria-disabled])",
    "*[contenteditable]"
];
const $6e683993385b7e97$var$focusableElSelector = $6e683993385b7e97$var$focusableElList.join();
const $6e683993385b7e97$var$isVisible = (el)=>el.offsetWidth > 0 && el.offsetHeight > 0;
function $6e683993385b7e97$export$4ae682d253b556eb(container) {
    const focusableEls = Array.from(container.querySelectorAll($6e683993385b7e97$var$focusableElSelector));
    focusableEls.unshift(container);
    return focusableEls.filter((el)=>(0, $c12aa22390fc675a$export$4c063cf1350e6fed)(el) && $6e683993385b7e97$var$isVisible(el));
}
function $6e683993385b7e97$export$748138f04a69bf21(container) {
    const allFocusable = $6e683993385b7e97$export$4ae682d253b556eb(container);
    return allFocusable.length ? allFocusable[0] : null;
}
function $6e683993385b7e97$export$f9ba66356f7359cf(container, fallbackToFocusable) {
    const allFocusable = Array.from(container.querySelectorAll($6e683993385b7e97$var$focusableElSelector));
    const allTabbable = allFocusable.filter((0, $c12aa22390fc675a$export$bebd5a1431fec25d));
    if ((0, $c12aa22390fc675a$export$bebd5a1431fec25d)(container)) allTabbable.unshift(container);
    if (!allTabbable.length && fallbackToFocusable) return allFocusable;
    return allTabbable;
}
function $6e683993385b7e97$export$168b663469d4c75e(container, fallbackToFocusable) {
    const [first] = $6e683993385b7e97$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return first || null;
}
function $6e683993385b7e97$export$a6fe3106a93f5f4b(container, fallbackToFocusable) {
    const allTabbable = $6e683993385b7e97$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return allTabbable[allTabbable.length - 1] || null;
}
function $6e683993385b7e97$export$28f33206776129a7(container, fallbackToFocusable) {
    const allFocusable = $6e683993385b7e97$export$4ae682d253b556eb(container);
    const index = allFocusable.indexOf(document.activeElement);
    const slice = allFocusable.slice(index + 1);
    return slice.find((0, $c12aa22390fc675a$export$bebd5a1431fec25d)) || allFocusable.find((0, $c12aa22390fc675a$export$bebd5a1431fec25d)) || (fallbackToFocusable ? slice[0] : null);
}
function $6e683993385b7e97$export$2e5518c3303f364a(container, fallbackToFocusable) {
    const allFocusable = $6e683993385b7e97$export$4ae682d253b556eb(container).reverse();
    const index = allFocusable.indexOf(document.activeElement);
    const slice = allFocusable.slice(index + 1);
    return slice.find((0, $c12aa22390fc675a$export$bebd5a1431fec25d)) || allFocusable.find((0, $c12aa22390fc675a$export$bebd5a1431fec25d)) || (fallbackToFocusable ? slice[0] : null);
}



var $acw62 = parcelRequire("acw62");
"use client";
const $b0ec087351311066$var$FocusTrap = (0, $9962412629625ccb$export$2e2bcd8739ae039).default ?? (0, $9962412629625ccb$export$2e2bcd8739ae039);
const $b0ec087351311066$export$ae70e1f3be7e1299 = (props)=>{
    const { initialFocusRef: initialFocusRef, finalFocusRef: finalFocusRef, contentRef: contentRef, restoreFocus: restoreFocus, children: children, isDisabled: isDisabled, autoFocus: autoFocus, persistentFocus: persistentFocus, lockFocusAcrossFrames: lockFocusAcrossFrames } = props;
    const onActivation = (0, $acw62.useCallback)(()=>{
        if (initialFocusRef?.current) initialFocusRef.current.focus();
        else if (contentRef?.current) {
            const focusables = (0, $6e683993385b7e97$export$4ae682d253b556eb)(contentRef.current);
            if (focusables.length === 0) requestAnimationFrame(()=>{
                contentRef.current?.focus();
            });
        }
    }, [
        initialFocusRef,
        contentRef
    ]);
    const onDeactivation = (0, $acw62.useCallback)(()=>{
        finalFocusRef?.current?.focus();
    }, [
        finalFocusRef
    ]);
    const returnFocus = restoreFocus && !finalFocusRef;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b0ec087351311066$var$FocusTrap, {
        crossFrame: lockFocusAcrossFrames,
        persistentFocus: persistentFocus,
        autoFocus: autoFocus,
        disabled: isDisabled,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        children: children
    });
};
$b0ec087351311066$export$ae70e1f3be7e1299.displayName = "FocusLock";


"use client";
function $55a05c5d9f866422$export$ffa1d90344e68399(props) {
    const { autoFocus: autoFocus, trapFocus: trapFocus, dialogRef: dialogRef, initialFocusRef: initialFocusRef, blockScrollOnMount: blockScrollOnMount, allowPinchZoom: allowPinchZoom, finalFocusRef: finalFocusRef, returnFocusOnClose: returnFocusOnClose, preserveScrollBarGap: preserveScrollBarGap, lockFocusAcrossFrames: lockFocusAcrossFrames, isOpen: isOpen } = (0, $8d5617b7cd68911b$export$4cc1699d46f42cae)();
    const [isPresent, safeToRemove] = (0, $bc77fac60b5d77cc$export$2a8c16d82a0a0e26)();
    (0, $acw62.useEffect)(()=>{
        if (!isPresent && safeToRemove) setTimeout(safeToRemove);
    }, [
        isPresent,
        safeToRemove
    ]);
    const index = (0, $45ceb2efab48c4b8$export$8557a94b9bb25060)(dialogRef, isOpen);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b0ec087351311066$export$ae70e1f3be7e1299), {
        autoFocus: autoFocus,
        isDisabled: !trapFocus,
        initialFocusRef: initialFocusRef,
        finalFocusRef: finalFocusRef,
        restoreFocus: returnFocusOnClose,
        contentRef: dialogRef,
        lockFocusAcrossFrames: lockFocusAcrossFrames,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
            removeScrollBar: !preserveScrollBarGap,
            allowPinchZoom: allowPinchZoom,
            enabled: index === 1 && blockScrollOnMount,
            forwardProps: true,
            children: props.children
        })
    });
}





var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
"use client";
const $cdf9b54298ebcd20$export$9ee1d08bb6db426f = {
    ease: [
        0.25,
        0.1,
        0.25,
        1
    ],
    easeIn: [
        0.4,
        0,
        1,
        1
    ],
    easeOut: [
        0,
        0,
        0.2,
        1
    ],
    easeInOut: [
        0.4,
        0,
        0.2,
        1
    ]
};
const $cdf9b54298ebcd20$export$55b7325ba41bb523 = {
    scale: {
        enter: {
            scale: 1
        },
        exit: {
            scale: 0.95
        }
    },
    fade: {
        enter: {
            opacity: 1
        },
        exit: {
            opacity: 0
        }
    },
    pushLeft: {
        enter: {
            x: "100%"
        },
        exit: {
            x: "-30%"
        }
    },
    pushRight: {
        enter: {
            x: "-100%"
        },
        exit: {
            x: "30%"
        }
    },
    pushUp: {
        enter: {
            y: "100%"
        },
        exit: {
            y: "-30%"
        }
    },
    pushDown: {
        enter: {
            y: "-100%"
        },
        exit: {
            y: "30%"
        }
    },
    slideLeft: {
        position: {
            left: 0,
            top: 0,
            bottom: 0,
            width: "100%"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: "-100%",
            y: 0
        }
    },
    slideRight: {
        position: {
            right: 0,
            top: 0,
            bottom: 0,
            width: "100%"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: "100%",
            y: 0
        }
    },
    slideUp: {
        position: {
            top: 0,
            left: 0,
            right: 0,
            maxWidth: "100vw"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: 0,
            y: "-100%"
        }
    },
    slideDown: {
        position: {
            bottom: 0,
            left: 0,
            right: 0,
            maxWidth: "100vw"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: 0,
            y: "100%"
        }
    }
};
function $cdf9b54298ebcd20$export$76af7f35258e628d(options) {
    const side = options?.direction ?? "right";
    switch(side){
        case "right":
            return $cdf9b54298ebcd20$export$55b7325ba41bb523.slideRight;
        case "left":
            return $cdf9b54298ebcd20$export$55b7325ba41bb523.slideLeft;
        case "bottom":
            return $cdf9b54298ebcd20$export$55b7325ba41bb523.slideDown;
        case "top":
            return $cdf9b54298ebcd20$export$55b7325ba41bb523.slideUp;
        default:
            return $cdf9b54298ebcd20$export$55b7325ba41bb523.slideRight;
    }
}
const $cdf9b54298ebcd20$export$f995eb860f745cb = {
    enter: {
        duration: 0.2,
        ease: $cdf9b54298ebcd20$export$9ee1d08bb6db426f.easeOut
    },
    exit: {
        duration: 0.1,
        ease: $cdf9b54298ebcd20$export$9ee1d08bb6db426f.easeIn
    }
};
const $cdf9b54298ebcd20$export$fc492bd0f1c91c = {
    enter: (transition, delay)=>({
            ...transition,
            delay: typeof delay === "number" ? delay : delay?.["enter"]
        }),
    exit: (transition, delay)=>({
            ...transition,
            delay: typeof delay === "number" ? delay : delay?.["exit"]
        })
};


"use client";
const $3426fe836f51f6a9$var$variants = {
    initial: ({ offsetX: offsetX, offsetY: offsetY, transition: transition, transitionEnd: transitionEnd, delay: delay })=>({
            opacity: 0,
            x: offsetX,
            y: offsetY,
            transition: transition?.exit ?? (0, $cdf9b54298ebcd20$export$fc492bd0f1c91c).exit((0, $cdf9b54298ebcd20$export$f995eb860f745cb).exit, delay),
            transitionEnd: transitionEnd?.exit
        }),
    enter: ({ transition: transition, transitionEnd: transitionEnd, delay: delay })=>({
            opacity: 1,
            x: 0,
            y: 0,
            transition: transition?.enter ?? (0, $cdf9b54298ebcd20$export$fc492bd0f1c91c).enter((0, $cdf9b54298ebcd20$export$f995eb860f745cb).enter, delay),
            transitionEnd: transitionEnd?.enter
        }),
    exit: ({ offsetY: offsetY, offsetX: offsetX, transition: transition, transitionEnd: transitionEnd, reverse: reverse, delay: delay })=>{
        const offset = {
            x: offsetX,
            y: offsetY
        };
        return {
            opacity: 0,
            transition: transition?.exit ?? (0, $cdf9b54298ebcd20$export$fc492bd0f1c91c).exit((0, $cdf9b54298ebcd20$export$f995eb860f745cb).exit, delay),
            ...reverse ? {
                ...offset,
                transitionEnd: transitionEnd?.exit
            } : {
                transitionEnd: {
                    ...offset,
                    ...transitionEnd?.exit
                }
            }
        };
    }
};
const $3426fe836f51f6a9$export$153404f46b1af630 = {
    initial: "initial",
    animate: "enter",
    exit: "exit",
    variants: $3426fe836f51f6a9$var$variants
};
const $3426fe836f51f6a9$export$2c57c541d078cf9c = (0, $acw62.forwardRef)(function SlideFade2(props, ref) {
    const { unmountOnExit: unmountOnExit, in: isOpen, reverse: reverse = true, className: className, offsetX: offsetX = 0, offsetY: offsetY = 8, transition: transition, transitionEnd: transitionEnd, delay: delay, animatePresenceProps: animatePresenceProps, ...rest } = props;
    const show = unmountOnExit ? isOpen && unmountOnExit : true;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    const custom = {
        offsetX: offsetX,
        offsetY: offsetY,
        reverse: reverse,
        transition: transition,
        transitionEnd: transitionEnd,
        delay: delay
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        ...animatePresenceProps,
        custom: custom,
        children: show && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            ref: ref,
            className: (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-offset-slide", className),
            custom: custom,
            ...$3426fe836f51f6a9$export$153404f46b1af630,
            animate: animate,
            ...rest
        })
    });
});
$3426fe836f51f6a9$export$2c57c541d078cf9c.displayName = "SlideFade";






var $acw62 = parcelRequire("acw62");

"use client";
const $57f1ecc8756aee4c$var$variants = {
    exit: ({ reverse: reverse, initialScale: initialScale, transition: transition, transitionEnd: transitionEnd, delay: delay })=>({
            opacity: 0,
            ...reverse ? {
                scale: initialScale,
                transitionEnd: transitionEnd?.exit
            } : {
                transitionEnd: {
                    scale: initialScale,
                    ...transitionEnd?.exit
                }
            },
            transition: transition?.exit ?? (0, $cdf9b54298ebcd20$export$fc492bd0f1c91c).exit((0, $cdf9b54298ebcd20$export$f995eb860f745cb).exit, delay)
        }),
    enter: ({ transitionEnd: transitionEnd, transition: transition, delay: delay })=>({
            opacity: 1,
            scale: 1,
            transition: transition?.enter ?? (0, $cdf9b54298ebcd20$export$fc492bd0f1c91c).enter((0, $cdf9b54298ebcd20$export$f995eb860f745cb).enter, delay),
            transitionEnd: transitionEnd?.enter
        })
};
const $57f1ecc8756aee4c$export$9f21bb05021be18d = {
    initial: "exit",
    animate: "enter",
    exit: "exit",
    variants: $57f1ecc8756aee4c$var$variants
};
const $57f1ecc8756aee4c$export$c9ef45b298456c94 = (0, $acw62.forwardRef)(function ScaleFade2(props, ref) {
    const { unmountOnExit: unmountOnExit, in: isOpen, reverse: reverse = true, initialScale: initialScale = 0.95, className: className, transition: transition, transitionEnd: transitionEnd, delay: delay, animatePresenceProps: animatePresenceProps, ...rest } = props;
    const show = unmountOnExit ? isOpen && unmountOnExit : true;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    const custom = {
        initialScale: initialScale,
        reverse: reverse,
        transition: transition,
        transitionEnd: transitionEnd,
        delay: delay
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        ...animatePresenceProps,
        custom: custom,
        children: show && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            ref: ref,
            className: (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-offset-slide", className),
            ...$57f1ecc8756aee4c$export$9f21bb05021be18d,
            animate: animate,
            custom: custom,
            ...rest
        })
    });
});
$57f1ecc8756aee4c$export$c9ef45b298456c94.displayName = "ScaleFade";



"use client";
const $59c4b8cf02523387$var$transitions = {
    slideInBottom: {
        ...(0, $3426fe836f51f6a9$export$153404f46b1af630),
        custom: {
            offsetY: 16,
            reverse: true
        }
    },
    slideInRight: {
        ...(0, $3426fe836f51f6a9$export$153404f46b1af630),
        custom: {
            offsetX: 16,
            reverse: true
        }
    },
    slideInTop: {
        ...(0, $3426fe836f51f6a9$export$153404f46b1af630),
        custom: {
            offsetY: -16,
            reverse: true
        }
    },
    slideInLeft: {
        ...(0, $3426fe836f51f6a9$export$153404f46b1af630),
        custom: {
            offsetX: -16,
            reverse: true
        }
    },
    scale: {
        ...(0, $57f1ecc8756aee4c$export$9f21bb05021be18d),
        custom: {
            initialScale: 0.95,
            reverse: true
        }
    },
    none: {}
};
const $59c4b8cf02523387$var$MotionSection = (0, $b03209b927263f16$export$7cd122d781af9fa4)((0, $a93b6401f922fd1e$export$e25e478948902b8b).section);
const $59c4b8cf02523387$var$getMotionProps = (preset)=>{
    return $59c4b8cf02523387$var$transitions[preset || "none"];
};
const $59c4b8cf02523387$export$f0a3ab1cc2e7e9a6 = (0, $acw62.forwardRef)((props, ref)=>{
    const { preset: preset, motionProps: motionProps = $59c4b8cf02523387$var$getMotionProps(preset), ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($59c4b8cf02523387$var$MotionSection, {
        ref: ref,
        ...motionProps,
        ...rest
    });
});
$59c4b8cf02523387$export$f0a3ab1cc2e7e9a6.displayName = "ModalTransition";




"use client";
const $f0d1c6b1bc80e74e$export$6da19a24bf249f17 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, children: children, containerProps: rootProps, motionProps: motionProps, ...rest } = props;
    const { getDialogProps: getDialogProps, getDialogContainerProps: getDialogContainerProps } = (0, $8d5617b7cd68911b$export$4cc1699d46f42cae)();
    const dialogProps = getDialogProps(rest, ref);
    const containerProps = getDialogContainerProps(rootProps);
    const _className = (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-modal__content", className);
    const styles = (0, $8d5617b7cd68911b$export$c540eec2ed4454a2)();
    const dialogStyles = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        display: "flex",
        flexDirection: "column",
        position: "relative",
        width: "100%",
        outline: 0,
        ...styles.dialog
    });
    const dialogContainerStyles = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        display: "flex",
        width: "100vw",
        height: "$100vh",
        position: "fixed",
        left: 0,
        top: 0,
        ...styles.dialogContainer
    });
    const { motionPreset: motionPreset } = (0, $8d5617b7cd68911b$export$4cc1699d46f42cae)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $55a05c5d9f866422$export$ffa1d90344e68399), {
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
            ...containerProps,
            className: "chakra-modal__content-container",
            tabIndex: -1,
            __css: dialogContainerStyles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $59c4b8cf02523387$export$f0a3ab1cc2e7e9a6), {
                preset: motionPreset,
                motionProps: motionProps,
                className: _className,
                ...dialogProps,
                __css: dialogStyles,
                children: children
            })
        })
    });
});
$f0d1c6b1bc80e74e$export$6da19a24bf249f17.displayName = "ModalContent";







"use client";
const $773bc06574a7fd0d$export$519437715052e656 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, ...rest } = props;
    const _className = (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-modal__footer", className);
    const styles = (0, $8d5617b7cd68911b$export$c540eec2ed4454a2)();
    const footerStyles = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        ...styles.footer
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).footer, {
        ref: ref,
        ...rest,
        __css: footerStyles,
        className: _className
    });
});
$773bc06574a7fd0d$export$519437715052e656.displayName = "ModalFooter";





var $acw62 = parcelRequire("acw62");



"use client";
const $bc83ddfa3740f22c$export$f50a68e3694789ee = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, ...rest } = props;
    const { headerId: headerId, setHeaderMounted: setHeaderMounted } = (0, $8d5617b7cd68911b$export$4cc1699d46f42cae)();
    (0, $acw62.useEffect)(()=>{
        setHeaderMounted(true);
        return ()=>setHeaderMounted(false);
    }, [
        setHeaderMounted
    ]);
    const _className = (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-modal__header", className);
    const styles = (0, $8d5617b7cd68911b$export$c540eec2ed4454a2)();
    const headerStyles = (0, $72fdfa583ecf837c$export$9a6b93c1c4f92839)({
        flex: 0,
        ...styles.header
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).header, {
        ref: ref,
        className: _className,
        id: headerId,
        ...rest,
        __css: headerStyles
    });
});
$bc83ddfa3740f22c$export$f50a68e3694789ee.displayName = "ModalHeader";









var $acw62 = parcelRequire("acw62");

"use client";
const $195976b136949929$var$variants = {
    enter: ({ transition: transition, transitionEnd: transitionEnd, delay: delay } = {})=>({
            opacity: 1,
            transition: transition?.enter ?? (0, $cdf9b54298ebcd20$export$fc492bd0f1c91c).enter((0, $cdf9b54298ebcd20$export$f995eb860f745cb).enter, delay),
            transitionEnd: transitionEnd?.enter
        }),
    exit: ({ transition: transition, transitionEnd: transitionEnd, delay: delay } = {})=>({
            opacity: 0,
            transition: transition?.exit ?? (0, $cdf9b54298ebcd20$export$fc492bd0f1c91c).exit((0, $cdf9b54298ebcd20$export$f995eb860f745cb).exit, delay),
            transitionEnd: transitionEnd?.exit
        })
};
const $195976b136949929$export$4342735ea5c231d = {
    initial: "exit",
    animate: "enter",
    exit: "exit",
    variants: $195976b136949929$var$variants
};
const $195976b136949929$export$c983850c6c9d8b0e = (0, $acw62.forwardRef)(function Fade2(props, ref) {
    const { unmountOnExit: unmountOnExit, in: isOpen, className: className, transition: transition, transitionEnd: transitionEnd, delay: delay, animatePresenceProps: animatePresenceProps, ...rest } = props;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    const show = unmountOnExit ? isOpen && unmountOnExit : true;
    const custom = {
        transition: transition,
        transitionEnd: transitionEnd,
        delay: delay
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        ...animatePresenceProps,
        custom: custom,
        children: show && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            ref: ref,
            className: (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-fade", className),
            custom: custom,
            ...$195976b136949929$export$4342735ea5c231d,
            animate: animate,
            ...rest
        })
    });
});
$195976b136949929$export$c983850c6c9d8b0e.displayName = "Fade";




"use client";
const $a4cea414d4965ce7$var$MotionDiv = (0, $b03209b927263f16$export$7cd122d781af9fa4)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div);
const $a4cea414d4965ce7$export$8948f78d83984c69 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, transition: transition, motionProps: _motionProps, ...rest } = props;
    const _className = (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-modal__overlay", className);
    const styles = (0, $8d5617b7cd68911b$export$c540eec2ed4454a2)();
    const overlayStyle = {
        pos: "fixed",
        left: "0",
        top: "0",
        w: "100vw",
        h: "100vh",
        ...styles.overlay
    };
    const { motionPreset: motionPreset } = (0, $8d5617b7cd68911b$export$4cc1699d46f42cae)();
    const defaultMotionProps = motionPreset === "none" ? {} : (0, $195976b136949929$export$4342735ea5c231d);
    const motionProps = _motionProps || defaultMotionProps;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a4cea414d4965ce7$var$MotionDiv, {
        ...motionProps,
        __css: overlayStyle,
        ref: ref,
        className: _className,
        ...rest
    });
});
$a4cea414d4965ce7$export$8948f78d83984c69.displayName = "ModalOverlay";







"use client";
const $b25b8f4dcda40b0b$export$5f1af8db9871e1d6 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)(function Text2(props, ref) {
    const styles = (0, $ec61beff530ee0ac$export$b863f77547fbcb03)("Text", props);
    const { className: className, align: align, decoration: decoration, casing: casing, ...rest } = (0, $30f8a8e85c908575$export$adfcf5a5e4d17785)(props);
    const aliasedProps = (0, $30752b4853cae067$export$8e16b83750b44988)({
        textAlign: props.align,
        textDecoration: props.decoration,
        textTransform: props.casing
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).p, {
        ref: ref,
        className: (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-text", props.className),
        ...aliasedProps,
        ...rest,
        __css: styles
    });
});
$b25b8f4dcda40b0b$export$5f1af8db9871e1d6.displayName = "Text";


function $66c3db43652eb3d3$export$9c891fa26ed4cf0d(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d5617b7cd68911b$export$2b77a92f1a5ad772), {
        size: "3xl",
        isOpen: props.visible,
        onClose: props.onClose,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a4cea414d4965ce7$export$8948f78d83984c69), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f0d1c6b1bc80e74e$export$6da19a24bf249f17), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc83ddfa3740f22c$export$f50a68e3694789ee), {
                        children: "\u57FA\u672C\u64CD\u4F5C"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d73afe5bfe6dcf52$export$edf9108895ba774f), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dee50d0250a4a081$export$cb540d8b0ef7906c), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                                mb: 3,
                                children: "\u4E0B\u306E\u52D5\u753B\u3092\u898B\u3066\u3001\u57FA\u672C\u64CD\u4F5C\u3092\u5B66\u7FD2\u3067\u304D\u307E\u3059\u3002"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7eb893aa48ec1adf$export$e840e8869344ca38), {
                                ratio: 16 / 9,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                    title: "unique",
                                    src: "https://www.youtube-nocookie.com/embed/iQXYZJ3R8pg",
                                    frameBorder: "0",
                                    allow: "autoplay; picture-in-picture",
                                    allowFullScreen: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $773bc06574a7fd0d$export$519437715052e656), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                            onClick: props.onClose,
                            colorScheme: "blue",
                            children: "OK"
                        })
                    })
                ]
            })
        ]
    });
}







"use client";
const $c34bb32055614f6e$export$1a94f80a613efc3a = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)(function NativeImage2(props, ref) {
    const { htmlWidth: htmlWidth, htmlHeight: htmlHeight, alt: alt, ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("img", {
        width: htmlWidth,
        height: htmlHeight,
        ref: ref,
        alt: alt,
        ...rest
    });
});
$c34bb32055614f6e$export$1a94f80a613efc3a.displayName = "NativeImage";




var $acw62 = parcelRequire("acw62");
"use client";
function $51e3506bf2330c3a$export$e4da99f09da8b739(props) {
    const { loading: loading, src: src, srcSet: srcSet, onLoad: onLoad, onError: onError, crossOrigin: crossOrigin, sizes: sizes, ignoreFallback: ignoreFallback } = props;
    const [status, setStatus] = (0, $acw62.useState)("pending");
    (0, $acw62.useEffect)(()=>{
        setStatus(src ? "loading" : "pending");
    }, [
        src
    ]);
    const imageRef = (0, $acw62.useRef)();
    const load = (0, $acw62.useCallback)(()=>{
        if (!src) return;
        flush();
        const img = new Image();
        img.src = src;
        if (crossOrigin) img.crossOrigin = crossOrigin;
        if (srcSet) img.srcset = srcSet;
        if (sizes) img.sizes = sizes;
        if (loading) img.loading = loading;
        img.onload = (event)=>{
            flush();
            setStatus("loaded");
            onLoad?.(event);
        };
        img.onerror = (error)=>{
            flush();
            setStatus("failed");
            onError?.(error);
        };
        imageRef.current = img;
    }, [
        src,
        crossOrigin,
        srcSet,
        sizes,
        onLoad,
        onError,
        loading
    ]);
    const flush = ()=>{
        if (imageRef.current) {
            imageRef.current.onload = null;
            imageRef.current.onerror = null;
            imageRef.current = null;
        }
    };
    (0, $2968f7a4ec8a3686$export$deebe11a338de063)(()=>{
        if (ignoreFallback) return void 0;
        if (status === "loading") load();
        return ()=>{
            flush();
        };
    }, [
        status,
        load,
        ignoreFallback
    ]);
    return ignoreFallback ? "loaded" : status;
}
const $51e3506bf2330c3a$export$b80814126d314dea = (status, fallbackStrategy)=>status !== "loaded" && fallbackStrategy === "beforeLoadOrError" || status === "failed" && fallbackStrategy === "onError";




"use client";
const $81eb050526b26d0d$export$3e431a229df88919 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)(function Image2(props, ref) {
    const { fallbackSrc: fallbackSrc, fallback: fallback, src: src, srcSet: srcSet, align: align, fit: fit, loading: loading, ignoreFallback: ignoreFallback, crossOrigin: crossOrigin, fallbackStrategy: fallbackStrategy = "beforeLoadOrError", referrerPolicy: referrerPolicy, ...rest } = props;
    const providedFallback = fallbackSrc !== void 0 || fallback !== void 0;
    const shouldIgnoreFallbackImage = loading != null || // use can opt out of fallback image
    ignoreFallback || // if the user doesn't provide any kind of fallback we should ignore it
    !providedFallback;
    const status = (0, $51e3506bf2330c3a$export$e4da99f09da8b739)({
        ...props,
        crossOrigin: crossOrigin,
        ignoreFallback: shouldIgnoreFallbackImage
    });
    const showFallbackImage = (0, $51e3506bf2330c3a$export$b80814126d314dea)(status, fallbackStrategy);
    const shared = {
        ref: ref,
        objectFit: fit,
        objectPosition: align,
        ...shouldIgnoreFallbackImage ? rest : (0, $900b7f4f02bde73c$export$30a06c8d3562193f)(rest, [
            "onError",
            "onLoad"
        ])
    };
    if (showFallbackImage) {
        if (fallback) return fallback;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).img, {
            as: (0, $c34bb32055614f6e$export$1a94f80a613efc3a),
            className: "chakra-image__placeholder",
            src: fallbackSrc,
            ...shared
        });
    }
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).img, {
        as: (0, $c34bb32055614f6e$export$1a94f80a613efc3a),
        src: src,
        srcSet: srcSet,
        crossOrigin: crossOrigin,
        loading: loading,
        referrerPolicy: referrerPolicy,
        className: "chakra-image",
        ...shared
    });
});
$81eb050526b26d0d$export$3e431a229df88919.displayName = "Image";


var $4fb51388915498c5$exports = {};
$4fb51388915498c5$exports = new URL("logo.0413d298.svg", import.meta.url).toString();


const $db8c69280955ddcb$var$logoSvg = new URL($4fb51388915498c5$exports).toString();
function $db8c69280955ddcb$export$e6ff31bff12b7ff4() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: "https://utcode.net/",
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81eb050526b26d0d$export$3e431a229df88919), {
            alt: "ut.code();\u306E\u30ED\u30B4",
            h: 8,
            src: $db8c69280955ddcb$var$logoSvg
        })
    });
}


var $051474e5c5a9c9ad$exports = {};
"use strict";
var $5fc7457900d13db1$exports = {};

$parcel$export($5fc7457900d13db1$exports, "atom", () => $5fc7457900d13db1$export$5fb5cc0d078610b, (v) => $5fc7457900d13db1$export$5fb5cc0d078610b = v);
$parcel$export($5fc7457900d13db1$exports, "createStore", () => $5fc7457900d13db1$export$f51a9068ac82ea43, (v) => $5fc7457900d13db1$export$f51a9068ac82ea43 = v);
$parcel$export($5fc7457900d13db1$exports, "getDefaultStore", () => $5fc7457900d13db1$export$39b2e4393dfcb8aa, (v) => $5fc7457900d13db1$export$39b2e4393dfcb8aa = v);
var $5fc7457900d13db1$export$5fb5cc0d078610b;
var $5fc7457900d13db1$export$f51a9068ac82ea43;
var $5fc7457900d13db1$export$39b2e4393dfcb8aa;
"use strict";
var $5fc7457900d13db1$var$keyCount = 0;
function $5fc7457900d13db1$var$atom(read, write) {
    var key = "atom" + ++$5fc7457900d13db1$var$keyCount;
    var config = {
        toString: function toString() {
            return key;
        }
    };
    if (typeof read === "function") config.read = read;
    else {
        config.init = read;
        config.read = $5fc7457900d13db1$var$defaultRead;
        config.write = $5fc7457900d13db1$var$defaultWrite;
    }
    if (write) config.write = write;
    return config;
}
function $5fc7457900d13db1$var$defaultRead(get) {
    return get(this);
}
function $5fc7457900d13db1$var$defaultWrite(get, set, arg) {
    return set(this, typeof arg === "function" ? arg(get(this)) : arg);
}
function $5fc7457900d13db1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5fc7457900d13db1$var$_createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = $5fc7457900d13db1$var$_unsupportedIterableToArray(r)) || e) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5fc7457900d13db1$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5fc7457900d13db1$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5fc7457900d13db1$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $5fc7457900d13db1$var$isSelfAtom = function isSelfAtom(atom, a) {
    return atom.unstable_is ? atom.unstable_is(a) : a === atom;
};
var $5fc7457900d13db1$var$hasInitialValue = function hasInitialValue(atom) {
    return "init" in atom;
};
var $5fc7457900d13db1$var$isActuallyWritableAtom = function isActuallyWritableAtom(atom) {
    return !!atom.write;
};
var $5fc7457900d13db1$var$cancelablePromiseMap = new WeakMap();
var $5fc7457900d13db1$var$isPendingPromise = function isPendingPromise(value) {
    var _cancelablePromiseMap;
    return $5fc7457900d13db1$var$isPromiseLike(value) && !((_cancelablePromiseMap = $5fc7457900d13db1$var$cancelablePromiseMap.get(value)) != null && _cancelablePromiseMap[1]);
};
var $5fc7457900d13db1$var$cancelPromise = function cancelPromise(promise, nextValue) {
    var promiseState = $5fc7457900d13db1$var$cancelablePromiseMap.get(promise);
    if (promiseState) {
        promiseState[1] = true;
        promiseState[0].forEach(function(fn) {
            return fn(nextValue);
        });
    }
};
var $5fc7457900d13db1$var$patchPromiseForCancelability = function patchPromiseForCancelability(promise) {
    if ($5fc7457900d13db1$var$cancelablePromiseMap.has(promise)) return;
    var promiseState = [
        new Set(),
        false
    ];
    $5fc7457900d13db1$var$cancelablePromiseMap.set(promise, promiseState);
    var settle = function settle() {
        promiseState[1] = true;
    };
    promise.then(settle, settle);
    promise.onCancel = function(fn) {
        promiseState[0].add(fn);
    };
};
var $5fc7457900d13db1$var$isPromiseLike = function isPromiseLike(x) {
    return typeof (x == null ? void 0 : x.then) === "function";
};
var $5fc7457900d13db1$var$isAtomStateInitialized = function isAtomStateInitialized(atomState) {
    return "v" in atomState || "e" in atomState;
};
var $5fc7457900d13db1$var$returnAtomValue = function returnAtomValue(atomState) {
    if ("e" in atomState) throw atomState.e;
    return atomState.v;
};
var $5fc7457900d13db1$var$addPendingPromiseToDependency = function addPendingPromiseToDependency(atom, promise, dependencyAtomState) {
    if (!dependencyAtomState.p.has(atom)) {
        dependencyAtomState.p.add(atom);
        promise.then(function() {
            dependencyAtomState.p.delete(atom);
        }, function() {
            dependencyAtomState.p.delete(atom);
        });
    }
};
var $5fc7457900d13db1$var$addDependency = function addDependency(pending, atom, atomState, a, aState) {
    var _aState$m;
    atomState.d.set(a, aState.n);
    if ($5fc7457900d13db1$var$isPendingPromise(atomState.v)) $5fc7457900d13db1$var$addPendingPromiseToDependency(atom, atomState.v, aState);
    (_aState$m = aState.m) == null || _aState$m.t.add(atom);
    if (pending) $5fc7457900d13db1$var$addPendingDependent(pending, a, atom);
};
var $5fc7457900d13db1$var$createPending = function createPending() {
    return [
        new Map(),
        new Map(),
        new Set()
    ];
};
var $5fc7457900d13db1$var$addPendingAtom = function addPendingAtom(pending, atom, atomState) {
    if (!pending[0].has(atom)) pending[0].set(atom, new Set());
    pending[1].set(atom, atomState);
};
var $5fc7457900d13db1$var$addPendingDependent = function addPendingDependent(pending, atom, dependent) {
    var dependents = pending[0].get(atom);
    if (dependents) dependents.add(dependent);
};
var $5fc7457900d13db1$var$getPendingDependents = function getPendingDependents(pending, atom) {
    return pending[0].get(atom);
};
var $5fc7457900d13db1$var$addPendingFunction = function addPendingFunction(pending, fn) {
    pending[2].add(fn);
};
var $5fc7457900d13db1$var$flushPending = function flushPending(pending) {
    while(pending[1].size || pending[2].size){
        pending[0].clear();
        var _atomStates = new Set(pending[1].values());
        pending[1].clear();
        var _functions = new Set(pending[2]);
        pending[2].clear();
        _atomStates.forEach(function(atomState) {
            var _atomState$m;
            return (_atomState$m = atomState.m) == null ? void 0 : _atomState$m.l.forEach(function(l) {
                return l();
            });
        });
        _functions.forEach(function(fn) {
            return fn();
        });
    }
};
var $5fc7457900d13db1$var$_buildStore = function buildStore() {
    for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
    var getAtomState = _ref[0], atomRead = _ref[1], atomWrite = _ref[2], atomOnMount = _ref[3];
    var debugMountedAtoms;
    var setAtomStateValueOrPromise = function setAtomStateValueOrPromise(atom, atomState, valueOrPromise) {
        var hasPrevValue = "v" in atomState;
        var prevValue = atomState.v;
        var pendingPromise = $5fc7457900d13db1$var$isPendingPromise(atomState.v) ? atomState.v : null;
        if ($5fc7457900d13db1$var$isPromiseLike(valueOrPromise)) {
            $5fc7457900d13db1$var$patchPromiseForCancelability(valueOrPromise);
            for(var _iterator = $5fc7457900d13db1$var$_createForOfIteratorHelperLoose(atomState.d.keys()), _step; !(_step = _iterator()).done;){
                var a = _step.value;
                $5fc7457900d13db1$var$addPendingPromiseToDependency(atom, valueOrPromise, getAtomState(a));
            }
            atomState.v = valueOrPromise;
            delete atomState.e;
        } else {
            atomState.v = valueOrPromise;
            delete atomState.e;
        }
        if (!hasPrevValue || !Object.is(prevValue, atomState.v)) {
            ++atomState.n;
            if (pendingPromise) $5fc7457900d13db1$var$cancelPromise(pendingPromise, valueOrPromise);
        }
    };
    var _readAtomState = function readAtomState(pending, atom, dirtyAtoms) {
        var atomState = getAtomState(atom);
        if ($5fc7457900d13db1$var$isAtomStateInitialized(atomState)) {
            if (atomState.m && !(dirtyAtoms != null && dirtyAtoms.has(atom))) return atomState;
            if (Array.from(atomState.d).every(function(_ref2) {
                var a = _ref2[0], n = _ref2[1];
                return _readAtomState(pending, a, dirtyAtoms).n === n;
            })) return atomState;
        }
        atomState.d.clear();
        var isSync = true;
        var getter = function getter(a) {
            if ($5fc7457900d13db1$var$isSelfAtom(atom, a)) {
                var _aState = getAtomState(a);
                if (!$5fc7457900d13db1$var$isAtomStateInitialized(_aState)) {
                    if ($5fc7457900d13db1$var$hasInitialValue(a)) setAtomStateValueOrPromise(a, _aState, a.init);
                    else throw new Error("no atom init");
                }
                return $5fc7457900d13db1$var$returnAtomValue(_aState);
            }
            var aState = _readAtomState(pending, a, dirtyAtoms);
            if (isSync) $5fc7457900d13db1$var$addDependency(pending, atom, atomState, a, aState);
            else {
                var _pending = $5fc7457900d13db1$var$createPending();
                $5fc7457900d13db1$var$addDependency(_pending, atom, atomState, a, aState);
                mountDependencies(_pending, atom, atomState);
                $5fc7457900d13db1$var$flushPending(_pending);
            }
            return $5fc7457900d13db1$var$returnAtomValue(aState);
        };
        var controller;
        var setSelf;
        var options = {
            get signal () {
                if (!controller) controller = new AbortController();
                return controller.signal;
            },
            get setSelf () {
                if (!setSelf && $5fc7457900d13db1$var$isActuallyWritableAtom(atom)) setSelf = function setSelf() {
                    if (!isSync) {
                        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                        return writeAtom.apply(void 0, [
                            atom
                        ].concat(args));
                    }
                };
                return setSelf;
            }
        };
        try {
            var valueOrPromise = atomRead(atom, getter, options);
            setAtomStateValueOrPromise(atom, atomState, valueOrPromise);
            if ($5fc7457900d13db1$var$isPromiseLike(valueOrPromise)) {
                valueOrPromise.onCancel == null || valueOrPromise.onCancel(function() {
                    var _controller;
                    return (_controller = controller) == null ? void 0 : _controller.abort();
                });
                var complete = function complete() {
                    if (atomState.m) {
                        var _pending2 = $5fc7457900d13db1$var$createPending();
                        mountDependencies(_pending2, atom, atomState);
                        $5fc7457900d13db1$var$flushPending(_pending2);
                    }
                };
                valueOrPromise.then(complete, complete);
            }
            return atomState;
        } catch (error) {
            delete atomState.v;
            atomState.e = error;
            ++atomState.n;
            return atomState;
        } finally{
            isSync = false;
        }
    };
    var readAtom = function readAtom(atom) {
        return $5fc7457900d13db1$var$returnAtomValue(_readAtomState(undefined, atom));
    };
    var getDependents = function getDependents(pending, atom, atomState) {
        var _getPendingDependents;
        var dependents = new Map();
        for(var _iterator2 = $5fc7457900d13db1$var$_createForOfIteratorHelperLoose(((_atomState$m2 = atomState.m) == null ? void 0 : _atomState$m2.t) || []), _step2; !(_step2 = _iterator2()).done;){
            var _atomState$m2;
            var a = _step2.value;
            dependents.set(a, getAtomState(a));
        }
        for(var _iterator3 = $5fc7457900d13db1$var$_createForOfIteratorHelperLoose(atomState.p), _step3; !(_step3 = _iterator3()).done;){
            var atomWithPendingPromise = _step3.value;
            dependents.set(atomWithPendingPromise, getAtomState(atomWithPendingPromise));
        }
        (_getPendingDependents = $5fc7457900d13db1$var$getPendingDependents(pending, atom)) == null || _getPendingDependents.forEach(function(dependent) {
            dependents.set(dependent, getAtomState(dependent));
        });
        return dependents;
    };
    var recomputeDependents = function recomputeDependents(pending, atom, atomState) {
        var topsortedAtoms = [];
        var markedAtoms = new Set();
        var _visit = function visit(a, aState) {
            if (markedAtoms.has(a)) return;
            markedAtoms.add(a);
            for(var _iterator4 = $5fc7457900d13db1$var$_createForOfIteratorHelperLoose(getDependents(pending, a, aState)), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, d = _step4$value[0], s = _step4$value[1];
                if (a !== d) _visit(d, s);
            }
            topsortedAtoms.push([
                a,
                aState,
                aState.n
            ]);
        };
        _visit(atom, atomState);
        var changedAtoms = new Set([
            atom
        ]);
        for(var i = topsortedAtoms.length - 1; i >= 0; --i){
            var _ref3 = topsortedAtoms[i], a = _ref3[0], aState = _ref3[1], prevEpochNumber = _ref3[2];
            var hasChangedDeps = false;
            for(var _iterator5 = $5fc7457900d13db1$var$_createForOfIteratorHelperLoose(aState.d.keys()), _step5; !(_step5 = _iterator5()).done;){
                var dep = _step5.value;
                if (dep !== a && changedAtoms.has(dep)) {
                    hasChangedDeps = true;
                    break;
                }
            }
            if (hasChangedDeps) {
                _readAtomState(pending, a, markedAtoms);
                mountDependencies(pending, a, aState);
                if (prevEpochNumber !== aState.n) {
                    $5fc7457900d13db1$var$addPendingAtom(pending, a, aState);
                    changedAtoms.add(a);
                }
            }
            markedAtoms.delete(a);
        }
    };
    var _writeAtomState = function writeAtomState(pending, atom) {
        var getter = function getter(a) {
            return $5fc7457900d13db1$var$returnAtomValue(_readAtomState(pending, a));
        };
        var setter = function setter(a) {
            var aState = getAtomState(a);
            var r;
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            if ($5fc7457900d13db1$var$isSelfAtom(atom, a)) {
                if (!$5fc7457900d13db1$var$hasInitialValue(a)) throw new Error("atom not writable");
                var hasPrevValue = "v" in aState;
                var prevValue = aState.v;
                var v = args[0];
                setAtomStateValueOrPromise(a, aState, v);
                mountDependencies(pending, a, aState);
                if (!hasPrevValue || !Object.is(prevValue, aState.v)) {
                    $5fc7457900d13db1$var$addPendingAtom(pending, a, aState);
                    recomputeDependents(pending, a, aState);
                }
            } else r = _writeAtomState.apply(void 0, [
                pending,
                a
            ].concat(args));
            $5fc7457900d13db1$var$flushPending(pending);
            return r;
        };
        for(var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)args[_key3 - 2] = arguments[_key3];
        var result = atomWrite.apply(void 0, [
            atom,
            getter,
            setter
        ].concat(args));
        return result;
    };
    var writeAtom = function writeAtom(atom) {
        var pending = $5fc7457900d13db1$var$createPending();
        for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
        var result = _writeAtomState.apply(void 0, [
            pending,
            atom
        ].concat(args));
        $5fc7457900d13db1$var$flushPending(pending);
        return result;
    };
    var mountDependencies = function mountDependencies(pending, atom, atomState) {
        if (atomState.m && !$5fc7457900d13db1$var$isPendingPromise(atomState.v)) {
            for(var _iterator6 = $5fc7457900d13db1$var$_createForOfIteratorHelperLoose(atomState.d.keys()), _step6; !(_step6 = _iterator6()).done;){
                var a = _step6.value;
                if (!atomState.m.d.has(a)) {
                    var aMounted = _mountAtom(pending, a, getAtomState(a));
                    aMounted.t.add(atom);
                    atomState.m.d.add(a);
                }
            }
            for(var _iterator7 = $5fc7457900d13db1$var$_createForOfIteratorHelperLoose(atomState.m.d || []), _step7; !(_step7 = _iterator7()).done;){
                var _a = _step7.value;
                if (!atomState.d.has(_a)) {
                    atomState.m.d.delete(_a);
                    var _aMounted = _unmountAtom(pending, _a, getAtomState(_a));
                    _aMounted == null || _aMounted.t.delete(atom);
                }
            }
        }
    };
    var _mountAtom = function mountAtom(pending, atom, atomState) {
        if (!atomState.m) {
            _readAtomState(pending, atom);
            for(var _iterator8 = $5fc7457900d13db1$var$_createForOfIteratorHelperLoose(atomState.d.keys()), _step8; !(_step8 = _iterator8()).done;){
                var a = _step8.value;
                var aMounted = _mountAtom(pending, a, getAtomState(a));
                aMounted.t.add(atom);
            }
            atomState.m = {
                l: new Set(),
                d: new Set(atomState.d.keys()),
                t: new Set()
            };
            if ($5fc7457900d13db1$var$isActuallyWritableAtom(atom)) {
                var mounted = atomState.m;
                $5fc7457900d13db1$var$addPendingFunction(pending, function() {
                    var onUnmount = atomOnMount(atom, function() {
                        for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
                        return _writeAtomState.apply(void 0, [
                            pending,
                            atom
                        ].concat(args));
                    });
                    if (onUnmount) mounted.u = onUnmount;
                });
            }
        }
        return atomState.m;
    };
    var _unmountAtom = function unmountAtom(pending, atom, atomState) {
        if (atomState.m && !atomState.m.l.size && !Array.from(atomState.m.t).some(function(a) {
            var _getAtomState$m;
            return (_getAtomState$m = getAtomState(a).m) == null ? void 0 : _getAtomState$m.d.has(atom);
        })) {
            var onUnmount = atomState.m.u;
            if (onUnmount) $5fc7457900d13db1$var$addPendingFunction(pending, onUnmount);
            delete atomState.m;
            for(var _iterator9 = $5fc7457900d13db1$var$_createForOfIteratorHelperLoose(atomState.d.keys()), _step9; !(_step9 = _iterator9()).done;){
                var a = _step9.value;
                var aMounted = _unmountAtom(pending, a, getAtomState(a));
                aMounted == null || aMounted.t.delete(atom);
            }
            return undefined;
        }
        return atomState.m;
    };
    var subscribeAtom = function subscribeAtom(atom, listener) {
        var pending = $5fc7457900d13db1$var$createPending();
        var atomState = getAtomState(atom);
        var mounted = _mountAtom(pending, atom, atomState);
        $5fc7457900d13db1$var$flushPending(pending);
        var listeners = mounted.l;
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
            var pending = $5fc7457900d13db1$var$createPending();
            _unmountAtom(pending, atom, atomState);
            $5fc7457900d13db1$var$flushPending(pending);
        };
    };
    var unstable_derive = function unstable_derive(fn) {
        return $5fc7457900d13db1$var$_buildStore.apply(void 0, fn(getAtomState, atomRead, atomWrite, atomOnMount));
    };
    var store = {
        get: readAtom,
        set: writeAtom,
        sub: subscribeAtom,
        unstable_derive: unstable_derive
    };
    var devStore;
    return store;
};
var $5fc7457900d13db1$var$createStore = function createStore() {
    var atomStateMap = new WeakMap();
    var getAtomState = function getAtomState(atom) {
        var atomState = atomStateMap.get(atom);
        if (!atomState) {
            atomState = {
                d: new Map(),
                p: new Set(),
                n: 0
            };
            atomStateMap.set(atom, atomState);
        }
        return atomState;
    };
    return $5fc7457900d13db1$var$_buildStore(getAtomState, function(atom) {
        for(var _len7 = arguments.length, params = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++)params[_key7 - 1] = arguments[_key7];
        return atom.read.apply(atom, params);
    }, function(atom) {
        for(var _len8 = arguments.length, params = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++)params[_key8 - 1] = arguments[_key8];
        return atom.write.apply(atom, params);
    }, function(atom) {
        for(var _len9 = arguments.length, params = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++)params[_key9 - 1] = arguments[_key9];
        return atom.onMount == null ? void 0 : atom.onMount.apply(atom, params);
    });
};
var $5fc7457900d13db1$var$defaultStore;
var $5fc7457900d13db1$var$getDefaultStore = function getDefaultStore() {
    if (!$5fc7457900d13db1$var$defaultStore) {
        $5fc7457900d13db1$var$defaultStore = $5fc7457900d13db1$var$createStore();
        var _ref4;
    }
    return $5fc7457900d13db1$var$defaultStore;
};
$5fc7457900d13db1$export$5fb5cc0d078610b = $5fc7457900d13db1$var$atom;
$5fc7457900d13db1$export$f51a9068ac82ea43 = $5fc7457900d13db1$var$createStore;
$5fc7457900d13db1$export$39b2e4393dfcb8aa = $5fc7457900d13db1$var$getDefaultStore;


var $0f1577dd80096b6b$exports = {};

$parcel$export($0f1577dd80096b6b$exports, "Provider", () => $0f1577dd80096b6b$export$2881499e37b75b9a, (v) => $0f1577dd80096b6b$export$2881499e37b75b9a = v);
$parcel$export($0f1577dd80096b6b$exports, "useAtom", () => $0f1577dd80096b6b$export$83cf7ae8bb57e7ed, (v) => $0f1577dd80096b6b$export$83cf7ae8bb57e7ed = v);
$parcel$export($0f1577dd80096b6b$exports, "useAtomValue", () => $0f1577dd80096b6b$export$89a40582f8c436cc, (v) => $0f1577dd80096b6b$export$89a40582f8c436cc = v);
$parcel$export($0f1577dd80096b6b$exports, "useSetAtom", () => $0f1577dd80096b6b$export$a247c952d39ea7ea, (v) => $0f1577dd80096b6b$export$a247c952d39ea7ea = v);
$parcel$export($0f1577dd80096b6b$exports, "useStore", () => $0f1577dd80096b6b$export$6ccbb43953eebf8, (v) => $0f1577dd80096b6b$export$6ccbb43953eebf8 = v);
var $0f1577dd80096b6b$export$2881499e37b75b9a;
var $0f1577dd80096b6b$export$83cf7ae8bb57e7ed;
var $0f1577dd80096b6b$export$89a40582f8c436cc;
var $0f1577dd80096b6b$export$a247c952d39ea7ea;
var $0f1577dd80096b6b$export$6ccbb43953eebf8;
"use client";
"use strict";

var $acw62 = parcelRequire("acw62");

var $0f1577dd80096b6b$var$StoreContext = $acw62.createContext(undefined);
var $0f1577dd80096b6b$var$useStore = function useStore(options) {
    var store = $acw62.useContext($0f1577dd80096b6b$var$StoreContext);
    return (options == null ? void 0 : options.store) || store || $5fc7457900d13db1$export$39b2e4393dfcb8aa();
};
var $0f1577dd80096b6b$var$Provider = function Provider(_ref) {
    var children = _ref.children, store = _ref.store;
    var storeRef = $acw62.useRef();
    if (!store && !storeRef.current) storeRef.current = $5fc7457900d13db1$export$f51a9068ac82ea43();
    return $acw62.createElement($0f1577dd80096b6b$var$StoreContext.Provider, {
        value: store || storeRef.current
    }, children);
};
var $0f1577dd80096b6b$var$isPromiseLike = function isPromiseLike(x) {
    return typeof (x == null ? void 0 : x.then) === "function";
};
var $0f1577dd80096b6b$var$attachPromiseMeta = function attachPromiseMeta(promise) {
    promise.status = "pending";
    promise.then(function(v) {
        promise.status = "fulfilled";
        promise.value = v;
    }, function(e) {
        promise.status = "rejected";
        promise.reason = e;
    });
};
var $0f1577dd80096b6b$var$use = $acw62.use || function(promise) {
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        $0f1577dd80096b6b$var$attachPromiseMeta(promise);
        throw promise;
    }
};
var $0f1577dd80096b6b$var$continuablePromiseMap = new WeakMap();
var $0f1577dd80096b6b$var$createContinuablePromise = function createContinuablePromise(promise) {
    var continuablePromise = $0f1577dd80096b6b$var$continuablePromiseMap.get(promise);
    if (!continuablePromise) {
        continuablePromise = new Promise(function(resolve, reject) {
            var curr = promise;
            var onFulfilled = function onFulfilled(me) {
                return function(v) {
                    if (curr === me) resolve(v);
                };
            };
            var onRejected = function onRejected(me) {
                return function(e) {
                    if (curr === me) reject(e);
                };
            };
            var _registerCancelHandler = function registerCancelHandler(p) {
                if ("onCancel" in p && typeof p.onCancel === "function") p.onCancel(function(nextValue) {
                    if ($0f1577dd80096b6b$var$isPromiseLike(nextValue)) {
                        $0f1577dd80096b6b$var$continuablePromiseMap.set(nextValue, continuablePromise);
                        curr = nextValue;
                        nextValue.then(onFulfilled(nextValue), onRejected(nextValue));
                        _registerCancelHandler(nextValue);
                    } else resolve(nextValue);
                });
            };
            promise.then(onFulfilled(promise), onRejected(promise));
            _registerCancelHandler(promise);
        });
        $0f1577dd80096b6b$var$continuablePromiseMap.set(promise, continuablePromise);
    }
    return continuablePromise;
};
function $0f1577dd80096b6b$var$useAtomValue(atom, options) {
    var store = $0f1577dd80096b6b$var$useStore(options);
    var _useReducer = $acw62.useReducer(function(prev) {
        var nextValue = store.get(atom);
        if (Object.is(prev[0], nextValue) && prev[1] === store && prev[2] === atom) return prev;
        return [
            nextValue,
            store,
            atom
        ];
    }, undefined, function() {
        return [
            store.get(atom),
            store,
            atom
        ];
    }), _useReducer$ = _useReducer[0], valueFromReducer = _useReducer$[0], storeFromReducer = _useReducer$[1], atomFromReducer = _useReducer$[2], rerender = _useReducer[1];
    var value = valueFromReducer;
    if (storeFromReducer !== store || atomFromReducer !== atom) {
        rerender();
        value = store.get(atom);
    }
    var delay = options == null ? void 0 : options.delay;
    $acw62.useEffect(function() {
        var unsub = store.sub(atom, function() {
            if (typeof delay === "number") {
                var _value = store.get(atom);
                if ($0f1577dd80096b6b$var$isPromiseLike(_value)) $0f1577dd80096b6b$var$attachPromiseMeta($0f1577dd80096b6b$var$createContinuablePromise(_value));
                setTimeout(rerender, delay);
                return;
            }
            rerender();
        });
        rerender();
        return unsub;
    }, [
        store,
        atom,
        delay
    ]);
    $acw62.useDebugValue(value);
    if ($0f1577dd80096b6b$var$isPromiseLike(value)) {
        var promise = $0f1577dd80096b6b$var$createContinuablePromise(value);
        return $0f1577dd80096b6b$var$use(promise);
    }
    return value;
}
function $0f1577dd80096b6b$var$useSetAtom(atom, options) {
    var store = $0f1577dd80096b6b$var$useStore(options);
    var setAtom = $acw62.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return store.set.apply(store, [
            atom
        ].concat(args));
    }, [
        store,
        atom
    ]);
    return setAtom;
}
function $0f1577dd80096b6b$var$useAtom(atom, options) {
    return [
        $0f1577dd80096b6b$var$useAtomValue(atom, options),
        $0f1577dd80096b6b$var$useSetAtom(atom, options)
    ];
}
$0f1577dd80096b6b$export$2881499e37b75b9a = $0f1577dd80096b6b$var$Provider;
$0f1577dd80096b6b$export$83cf7ae8bb57e7ed = $0f1577dd80096b6b$var$useAtom;
$0f1577dd80096b6b$export$89a40582f8c436cc = $0f1577dd80096b6b$var$useAtomValue;
$0f1577dd80096b6b$export$a247c952d39ea7ea = $0f1577dd80096b6b$var$useSetAtom;
$0f1577dd80096b6b$export$6ccbb43953eebf8 = $0f1577dd80096b6b$var$useStore;


Object.keys($5fc7457900d13db1$exports).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call($051474e5c5a9c9ad$exports, k)) Object.defineProperty($051474e5c5a9c9ad$exports, k, {
        enumerable: true,
        get: function() {
            return $5fc7457900d13db1$exports[k];
        }
    });
});
Object.keys($0f1577dd80096b6b$exports).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call($051474e5c5a9c9ad$exports, k)) Object.defineProperty($051474e5c5a9c9ad$exports, k, {
        enumerable: true,
        get: function() {
            return $0f1577dd80096b6b$exports[k];
        }
    });
});



const $ab97a3e9ca68f936$export$bd6c0303b4c07527 = (0, $051474e5c5a9c9ad$exports.atom)(false);


function $3c9c8e7d0f56fe42$export$8545e3c0243374bc({ Hint: Hint, children: children }) {
    const [showCommonHelp, setShowCommonHelp] = (0, $acw62.useState)(false);
    const [_, setShowHint] = (0, $051474e5c5a9c9ad$exports.useAtom)((0, $ab97a3e9ca68f936$export$bd6c0303b4c07527));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bda70ca026e698db$export$f51f4c4ede09e011), {
                direction: "column",
                height: "100%",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bda70ca026e698db$export$f51f4c4ede09e011), {
                        align: "center",
                        justify: "space-between",
                        shadow: "md",
                        backgroundColor: "gray.50",
                        px: 3,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db8c69280955ddcb$export$e6ff31bff12b7ff4), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7797ad21d1688bf5$export$e71c4d32a2263218), {
                                display: {
                                    base: "none",
                                    lg: "block"
                                },
                                fontSize: "xl",
                                children: "\u306F\u3058\u3081\u3066\u306E\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d49876b21d3f7aec$export$d7a54cba636a8cd6), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                px: 4,
                                type: "button",
                                transition: "color 0.2s",
                                colorScheme: "green",
                                onClick: ()=>{
                                    window.location.href = "https://festival.utcode.net";
                                },
                                children: "\u4E94\u6708\u796D\u30C8\u30C3\u30D7\u30DA\u30FC\u30B8\u3078"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                colorScheme: "blue",
                                variant: "outline",
                                onClick: ()=>setShowCommonHelp(true),
                                px: 3,
                                py: 2,
                                m: 3,
                                children: "\u57FA\u672C\u64CD\u4F5C"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                px: 4,
                                type: "button",
                                transition: "color 0.2s",
                                colorScheme: "blue",
                                onClick: ()=>{
                                    setShowHint(true);
                                },
                                children: "\u30D8\u30EB\u30D7"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7797ad21d1688bf5$export$e71c4d32a2263218), {
                                display: "flex",
                                alignItems: "stretch",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).button, {
                                        px: 2,
                                        type: "button",
                                        transition: "color 0.2s",
                                        _hover: {
                                            color: "blue.300"
                                        },
                                        onClick: ()=>{
                                            alert("what is this");
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20f456d5883a34dd$export$f04a61298a47a40f), {
                                            w: 6,
                                            h: 6,
                                            as: (0, $0d9043722344d99e$export$170481990ff4655d)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13ae9840661bf0be$export$a6c7ac8248d6e38a), {
                                        display: "flex",
                                        alignItems: "center",
                                        transition: "color 0.2s",
                                        _hover: {
                                            color: "blue.300"
                                        },
                                        px: 2,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        href: "https://github.com/ut-code/first-programming",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20f456d5883a34dd$export$f04a61298a47a40f), {
                                            w: 6,
                                            h: 6,
                                            as: (0, $0d9043722344d99e$export$935242d7a332dbd3)
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7797ad21d1688bf5$export$e71c4d32a2263218), {
                        position: "relative",
                        flexGrow: 1,
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66c3db43652eb3d3$export$9c891fa26ed4cf0d), {
                onClose: ()=>{
                    setShowCommonHelp(false);
                },
                visible: showCommonHelp
            }),
            Hint
        ]
    });
}






var $acw62 = parcelRequire("acw62");
function $16381d2ec147412c$export$b2c43d7d050b2e63(children) {
    return (0, $acw62.Children).toArray(children).filter((child)=>(0, $acw62.isValidElement)(child));
}



var $acw62 = parcelRequire("acw62");


"use client";
const $3b07e7eceb74ecbb$export$50d5391cd1a018c6 = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
        className: "chakra-stack__item",
        ...props,
        __css: {
            display: "inline-block",
            flex: "0 0 auto",
            minWidth: 0,
            ...props["__css"]
        }
    });
$3b07e7eceb74ecbb$export$50d5391cd1a018c6.displayName = "StackItem";



"use client";
function $b913065a146e920e$export$d4a6a5cc582519a5(options) {
    const { spacing: spacing, direction: direction } = options;
    const dividerStyles = {
        column: {
            my: spacing,
            mx: 0,
            borderLeftWidth: 0,
            borderBottomWidth: "1px"
        },
        "column-reverse": {
            my: spacing,
            mx: 0,
            borderLeftWidth: 0,
            borderBottomWidth: "1px"
        },
        row: {
            mx: spacing,
            my: 0,
            borderLeftWidth: "1px",
            borderBottomWidth: 0
        },
        "row-reverse": {
            mx: spacing,
            my: 0,
            borderLeftWidth: "1px",
            borderBottomWidth: 0
        }
    };
    return {
        "&": (0, $807e1b15401998c2$export$eca1915781c2aaca)(direction, (value)=>dividerStyles[value])
    };
}




"use client";
const $7a2c9ce50f6bfbd0$export$694e0d28c7ffc90c = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>{
    const { isInline: isInline, direction: directionProp, align: align, justify: justify, spacing: spacing = "0.5rem", wrap: wrap, children: children, divider: divider, className: className, shouldWrapChildren: shouldWrapChildren, ...rest } = props;
    const direction = isInline ? "row" : directionProp ?? "column";
    const dividerStyle = (0, $acw62.useMemo)(()=>(0, $b913065a146e920e$export$d4a6a5cc582519a5)({
            spacing: spacing,
            direction: direction
        }), [
        spacing,
        direction
    ]);
    const hasDivider = !!divider;
    const shouldUseChildren = !shouldWrapChildren && !hasDivider;
    const clones = (0, $acw62.useMemo)(()=>{
        const validChildren = (0, $16381d2ec147412c$export$b2c43d7d050b2e63)(children);
        return shouldUseChildren ? validChildren : validChildren.map((child, index)=>{
            const key = typeof child.key !== "undefined" ? child.key : index;
            const isLast = index + 1 === validChildren.length;
            const wrappedChild = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3b07e7eceb74ecbb$export$50d5391cd1a018c6), {
                children: child
            }, key);
            const _child = shouldWrapChildren ? wrappedChild : child;
            if (!hasDivider) return _child;
            const clonedDivider = (0, $acw62.cloneElement)(divider, {
                __css: dividerStyle
            });
            const _divider = isLast ? null : clonedDivider;
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                children: [
                    _child,
                    _divider
                ]
            }, key);
        });
    }, [
        divider,
        dividerStyle,
        hasDivider,
        shouldUseChildren,
        shouldWrapChildren,
        children
    ]);
    const _className = (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-stack", className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
        ref: ref,
        display: "flex",
        alignItems: align,
        justifyContent: justify,
        flexDirection: direction,
        flexWrap: wrap,
        gap: hasDivider ? void 0 : spacing,
        className: _className,
        ...rest,
        children: clones
    });
});
$7a2c9ce50f6bfbd0$export$694e0d28c7ffc90c.displayName = "Stack";



"use client";
const $6add547e9ee4228b$export$15e411dc07b9c834 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a2c9ce50f6bfbd0$export$694e0d28c7ffc90c), {
        align: "center",
        ...props,
        direction: "row",
        ref: ref
    }));
$6add547e9ee4228b$export$15e411dc07b9c834.displayName = "HStack";




var $acw62 = parcelRequire("acw62");


function $a815ea9477d173d2$export$9080f8affd01f933(props) {
    const [selectedIndex, setSelectedIndex] = (0, $acw62.useState)(0);
    const [isOpen, setIsOpen] = (0, $051474e5c5a9c9ad$exports.useAtom)((0, $ab97a3e9ca68f936$export$bd6c0303b4c07527));
    function onClose() {
        setIsOpen(false);
        setSelectedIndex(0);
        props.onClose();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d5617b7cd68911b$export$2b77a92f1a5ad772), {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a4cea414d4965ce7$export$8948f78d83984c69), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f0d1c6b1bc80e74e$export$6da19a24bf249f17), {
                maxW: "60vw",
                maxH: "80vh",
                margin: "auto",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc83ddfa3740f22c$export$f50a68e3694789ee), {
                        children: props.title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d73afe5bfe6dcf52$export$edf9108895ba774f), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dee50d0250a4a081$export$cb540d8b0ef7906c), {
                        display: "flex",
                        flexDirection: "column",
                        overflowY: "auto",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6add547e9ee4228b$export$15e411dc07b9c834), {
                                spacing: 4,
                                mb: 4,
                                wrap: "wrap",
                                children: props.steps.map((step, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                        children: [
                                            i > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20f456d5883a34dd$export$f04a61298a47a40f), {
                                                mx: 2,
                                                w: 5,
                                                h: 5,
                                                as: (0, $0d9043722344d99e$export$2e71b5c01b6ef3b9)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                                colorScheme: i === selectedIndex ? "blue" : undefined,
                                                variant: i === selectedIndex ? "solid" : "unstyled",
                                                // isDisabled={i === selectedIndex}
                                                onClick: ()=>{
                                                    setSelectedIndex(i);
                                                },
                                                children: step.title
                                            }, step.title)
                                        ]
                                    }, step.title))
                            }),
                            props.steps[selectedIndex].content
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $773bc06574a7fd0d$export$519437715052e656), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6add547e9ee4228b$export$15e411dc07b9c834), {
                            spacing: 2,
                            children: [
                                selectedIndex !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                    onClick: ()=>setSelectedIndex(selectedIndex - 1),
                                    variant: "outline",
                                    children: "\u524D\u3078"
                                }),
                                selectedIndex !== props.steps.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                    onClick: ()=>setSelectedIndex(selectedIndex + 1),
                                    colorScheme: props.isFirstView ? "blue" : undefined,
                                    variant: "outline",
                                    children: "\u6B21\u3078"
                                }),
                                (!props.isFirstView || selectedIndex === props.steps.length - 1) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                    onClick: onClose,
                                    variant: "solid",
                                    colorScheme: "blue",
                                    children: "\u306F\u3058\u3081\u308B"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");








"use client";
const $62e8dffda5e4bdb1$export$2e0a83ec2e27ecbb = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)(function Divider2(props, ref) {
    const { borderLeftWidth: borderLeftWidth, borderBottomWidth: borderBottomWidth, borderTopWidth: borderTopWidth, borderRightWidth: borderRightWidth, borderWidth: borderWidth, borderStyle: borderStyle, borderColor: borderColor, ...styles } = (0, $ec61beff530ee0ac$export$b863f77547fbcb03)("Divider", props);
    const { className: className, orientation: orientation = "horizontal", __css: __css, ...rest } = (0, $30f8a8e85c908575$export$adfcf5a5e4d17785)(props);
    const dividerStyles = {
        vertical: {
            borderLeftWidth: borderLeftWidth || borderRightWidth || borderWidth || "1px",
            height: "100%"
        },
        horizontal: {
            borderBottomWidth: borderBottomWidth || borderTopWidth || borderWidth || "1px",
            width: "100%"
        }
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).hr, {
        ref: ref,
        "aria-orientation": orientation,
        ...rest,
        __css: {
            ...styles,
            border: "0",
            borderColor: borderColor,
            borderStyle: borderStyle,
            ...dividerStyles[orientation],
            ...__css
        },
        className: (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-divider", className)
    });
});
$62e8dffda5e4bdb1$export$2e0a83ec2e27ecbb.displayName = "Divider";




"use client";
const $4d98417e5915b90f$export$ef2184bd89960b14 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)(function Grid2(props, ref) {
    const { templateAreas: templateAreas, gap: gap, rowGap: rowGap, columnGap: columnGap, column: column, row: row, autoFlow: autoFlow, autoRows: autoRows, templateRows: templateRows, autoColumns: autoColumns, templateColumns: templateColumns, ...rest } = props;
    const styles = {
        display: "grid",
        gridTemplateAreas: templateAreas,
        gridGap: gap,
        gridRowGap: rowGap,
        gridColumnGap: columnGap,
        gridAutoColumns: autoColumns,
        gridColumn: column,
        gridRow: row,
        gridAutoFlow: autoFlow,
        gridAutoRows: autoRows,
        gridTemplateRows: templateRows,
        gridTemplateColumns: templateColumns
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: styles,
        ...rest
    });
});
$4d98417e5915b90f$export$ef2184bd89960b14.displayName = "Grid";



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $ccf5a8ceb17487c0$var$updateReducer = function(num) {
    return (num + 1) % 1000000;
};
function $ccf5a8ceb17487c0$export$2e2bcd8739ae039() {
    var _a = (0, $acw62.useReducer)($ccf5a8ceb17487c0$var$updateReducer, 0), update = _a[1];
    return update;
}


function $d838a10745cf34aa$export$efbb6b4f12b20b5e(nextState, currentState) {
    if (typeof nextState === "function") return nextState.length ? nextState(currentState) : nextState();
    return nextState;
}


function $04226aa44b98d8e4$export$2e2bcd8739ae039(initialState) {
    var state = (0, $acw62.useRef)((0, $d838a10745cf34aa$export$efbb6b4f12b20b5e)(initialState));
    var update = (0, $ccf5a8ceb17487c0$export$2e2bcd8739ae039)();
    return (0, $acw62.useMemo)(function() {
        return [
            function() {
                return state.current;
            },
            function(newState) {
                state.current = (0, $d838a10745cf34aa$export$efbb6b4f12b20b5e)(newState, state.current);
                update();
            }
        ];
    }, []);
}




var $acw62 = parcelRequire("acw62");

//xml形式で左手法のテンプレートを作成できる
const $d67c8d19cbdb07d9$export$a8fc3402335b0b04 = [
    {
        name: "Template 1",
        blockxml: `
      <block type="custom_while_true">
        <statement name="STATEMENTS">
          <block type="custom_common_if_else">
            <value name="EXPRESSION">
              <block type="custom_maze_checkWall">
                <field name="DIRECTION">left</field>
              </block>
            </value>
            <statement name="TRUE_STATEMENTS">
              <block type="custom_common_if">
                <value name="EXPRESSION">
                  <block type="custom_maze_checkWall">
                    <field name="DIRECTION">top</field>
                  </block>
                </value>
                <statement name="TRUE_STATEMENTS">
                  <block type="custom_common_if_else">
                    <value name="EXPRESSION">
                      <block type="custom_maze_checkWall">
                        <field name="DIRECTION">right</field>
                      </block>
                    </value>
                    <statement name="TRUE_STATEMENTS">

                    </statement>
                    <statement name="FALSE_STATEMENTS">

                    </statement>
                  </block>
                </statement>
                <statement name="FALSE_STATEMENTS">

                </statement>
              </block>
            </statement>
            <statement name="FALSE_STATEMENTS">
            <block type="custom_maze_turn">
              <field name="DIRECTION">left</field>
            </block>
          </statement>
            <next>
              <block type="custom_maze_stepForward"></block>
            </next>
          </block>
        </statement>
      </block>
    `
    }
];


function $4bd570f5aeed71cd$export$c5f548d9c9fb836f({ toolboxDefinition: toolboxDefinition, onCodeChange: onCodeChange }) {
    const workspaceAreaRef = (0, $acw62.useRef)(null);
    const workspaceRef = (0, $acw62.useRef)();
    const highlightBlock = (0, $acw62.useCallback)((id)=>{
        workspaceRef.current?.highlightBlock(id);
    }, []);
    const getCode = (0, $acw62.useCallback)(()=>(0, $4dac3bd746fe0f69$export$d274976115d95baf).workspaceToCode(workspaceRef.current), []);
    (0, $acw62.useEffect)(()=>{
        const workspaceArea = workspaceAreaRef.current;
        if (!workspaceArea) return undefined;
        const toolbox = toolboxDefinition.type === "flyout" ? {
            kind: "flyoutToolbox",
            contents: [
                // 通常のブロックを追加
                ...toolboxDefinition.type === "flyout" ? toolboxDefinition.blockTypes.map((type)=>({
                        kind: "block",
                        type: type
                    })) : [],
                // テンプレートを追加
                ...(0, $d67c8d19cbdb07d9$export$a8fc3402335b0b04).map((template)=>({
                        kind: "block",
                        blockxml: template.blockxml
                    }))
            ]
        } : {
            kind: "categoryToolbox",
            contents: [
                ...toolboxDefinition.type === "category" ? toolboxDefinition.categories.map((category)=>({
                        kind: "category",
                        name: category.name,
                        contents: category.blockTypes.map((type)=>({
                                kind: "block",
                                type: type
                            }))
                    })) : [],
                ...toolboxDefinition.enableVariables ? [
                    {
                        kind: "category",
                        name: "\u5909\u6570",
                        custom: "VARIABLE"
                    }
                ] : []
            ]
        };
        const workspace = (0, (/*@__PURE__*/$parcel$interopDefault($ecab2ad3ed5a93ad$exports))).inject(workspaceArea, {
            toolbox: toolbox,
            grid: {
                spacing: 20,
                length: 3,
                colour: "#ccc",
                snap: true
            },
            trashcan: true,
            renderer: "thrasos",
            move: {
                drag: true,
                scrollbars: true,
                wheel: true
            }
        });
        return ()=>workspace.dispose();
    }, [
        toolboxDefinition,
        workspaceAreaRef
    ]);
    return {
        workspaceAreaRef: workspaceAreaRef,
        highlightBlock: highlightBlock,
        getCode: getCode
    };
}




var $acw62 = parcelRequire("acw62");


"use client";
function $5319fe3cc74f7025$export$5b03f73d5fd4425(position, dir) {
    const computedPosition = position ?? "bottom";
    const logicals = {
        "top-start": {
            ltr: "top-left",
            rtl: "top-right"
        },
        "top-end": {
            ltr: "top-right",
            rtl: "top-left"
        },
        "bottom-start": {
            ltr: "bottom-left",
            rtl: "bottom-right"
        },
        "bottom-end": {
            ltr: "bottom-right",
            rtl: "bottom-left"
        }
    };
    const logical = logicals[computedPosition];
    return logical?.[dir] ?? computedPosition;
}



"use client";
function $5bdf01f1afa4fd99$export$f3af62d19eb14261(dir, defaultOptions) {
    const normalizeToastOptions = (options)=>({
            ...defaultOptions,
            ...options,
            position: (0, $5319fe3cc74f7025$export$5b03f73d5fd4425)(options?.position ?? defaultOptions?.position, dir)
        });
    const toast = (options)=>{
        const normalizedToastOptions = normalizeToastOptions(options);
        const Message = (0, $063a7d66b4be71b9$export$d9d796c483697359)(normalizedToastOptions);
        return (0, $69ac468afa324d05$export$e80fa18a42ed98ef).notify(Message, normalizedToastOptions);
    };
    toast.update = (id, options)=>{
        (0, $69ac468afa324d05$export$e80fa18a42ed98ef).update(id, normalizeToastOptions(options));
    };
    toast.promise = (promise, options)=>{
        const id = toast({
            ...options.loading,
            status: "loading",
            duration: null
        });
        promise.then((data)=>toast.update(id, {
                status: "success",
                duration: 5e3,
                ...(0, $e02dbdd8eca189fb$export$624e501d81f5ffce)(options.success, data)
            })).catch((error)=>toast.update(id, {
                status: "error",
                duration: 5e3,
                ...(0, $e02dbdd8eca189fb$export$624e501d81f5ffce)(options.error, error)
            }));
    };
    toast.closeAll = (0, $69ac468afa324d05$export$e80fa18a42ed98ef).closeAll;
    toast.close = (0, $69ac468afa324d05$export$e80fa18a42ed98ef).close;
    toast.isActive = (0, $69ac468afa324d05$export$e80fa18a42ed98ef).isActive;
    return toast;
}




"use client";
function $4957fb6187c9a2f5$export$a407b657d3044108(options) {
    const { theme: theme } = (0, $dade0a7e101641ba$export$a513a93efd9ab8a7)();
    const defaultOptions = (0, $78a9c789cf0417da$export$7c4af276256dc908)();
    return (0, $acw62.useMemo)(()=>(0, $5bdf01f1afa4fd99$export$f3af62d19eb14261)(theme.direction, {
            ...defaultOptions,
            ...options
        }), [
        options,
        theme.direction,
        defaultOptions
    ]);
}


var $920a9dc6ef3f7a6b$exports = {};

(function webpackUniversalModuleDefinition(root, factory) {
    $920a9dc6ef3f7a6b$exports = factory();
})($920a9dc6ef3f7a6b$exports, ()=>{
    return /******/ (()=>{
        /******/ var __webpack_modules__ = {
            /***/ "./original-repo/interpreter.js": /*!**************************************!*\
  !*** ./original-repo/interpreter.js ***!
  \**************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /**
 * @license
 * Copyright 2013 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @fileoverview Interpreting JavaScript in JavaScript.
 * @author fraser@google.com (Neil Fraser)
 */ /**
 * Create a new interpreter.
 * @param {string|!Object} code Raw JavaScript text or AST.
 * @param {Function=} opt_initFunc Optional initialization function.  Used to
 *     define APIs.  When called it is passed the interpreter object and the
 *     global scope object.
 * @constructor
 */ var Interpreter = function(code, opt_initFunc) {
                    if (typeof code === "string") code = this.parse_(code, "code");
                    // Get a handle on Acorn's node_t object.
                    var nodeConstructor = code.constructor;
                    this.newNode = function() {
                        return new nodeConstructor({
                            "options": {}
                        });
                    };
                    // Clone the root 'Program' node so that the AST may be modified.
                    var ast = this.newNode();
                    for(var prop in code)ast[prop] = prop === "body" ? code[prop].slice() : code[prop];
                    this.ast = ast;
                    this.initFunc_ = opt_initFunc;
                    this.paused_ = false;
                    this.polyfills_ = [];
                    // Unique identifier for native functions.  Used in serialization.
                    this.functionCounter_ = 0;
                    // Map node types to our step function names; a property lookup is faster
                    // than string concatenation with "step" prefix.
                    this.stepFunctions_ = Object.create(null);
                    var stepMatch = /^step([A-Z]\w*)$/;
                    var m;
                    for(var methodName in this)if (typeof this[methodName] === "function" && (m = methodName.match(stepMatch))) this.stepFunctions_[m[1]] = this[methodName].bind(this);
                    // Create and initialize the global scope.
                    this.globalScope = this.createScope(this.ast, null);
                    this.globalObject = this.globalScope.object;
                    // Run the polyfills.
                    this.ast = this.parse_(this.polyfills_.join("\n"), "polyfills");
                    this.polyfills_ = undefined; // Allow polyfill strings to garbage collect.
                    Interpreter.stripLocations_(this.ast, undefined, undefined);
                    var state = new Interpreter.State(this.ast, this.globalScope);
                    state.done = false;
                    this.stateStack = [
                        state
                    ];
                    this.run();
                    this.value = undefined;
                    // Point at the main program.
                    this.ast = ast;
                    state = new Interpreter.State(this.ast, this.globalScope);
                    state.done = false;
                    this.stateStack.length = 0;
                    this.stateStack[0] = state;
                };
                /**
 * Completion Value Types.
 * @enum {number}
 */ Interpreter.Completion = {
                    NORMAL: 0,
                    BREAK: 1,
                    CONTINUE: 2,
                    RETURN: 3,
                    THROW: 4
                };
                /**
 * @const {!Object} Configuration used for all Acorn parsing.
 */ Interpreter.PARSE_OPTIONS = {
                    "locations": true,
                    "ecmaVersion": 5
                };
                /**
 * Property descriptor of readonly properties.
 */ Interpreter.READONLY_DESCRIPTOR = {
                    configurable: true,
                    enumerable: true,
                    writable: false
                };
                /**
 * Property descriptor of non-enumerable properties.
 */ Interpreter.NONENUMERABLE_DESCRIPTOR = {
                    configurable: true,
                    enumerable: false,
                    writable: true
                };
                /**
 * Property descriptor of readonly, non-enumerable properties.
 */ Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR = {
                    configurable: true,
                    enumerable: false,
                    writable: false
                };
                /**
 * Property descriptor of non-configurable, readonly, non-enumerable properties.
 * E.g. NaN, Infinity.
 */ Interpreter.NONCONFIGURABLE_READONLY_NONENUMERABLE_DESCRIPTOR = {
                    configurable: false,
                    enumerable: false,
                    writable: false
                };
                /**
 * Property descriptor of variables.
 */ Interpreter.VARIABLE_DESCRIPTOR = {
                    configurable: false,
                    enumerable: true,
                    writable: true
                };
                /**
 * Unique symbol for indicating that a step has encountered an error, has
 * added it to the stack, and will be thrown within the user's program.
 * When STEP_ERROR is thrown in the JS-Interpreter, the error can be ignored.
 */ Interpreter.STEP_ERROR = {
                    "STEP_ERROR": true
                };
                /**
 * Unique symbol for indicating that a reference is a variable on the scope,
 * not an object property.
 */ Interpreter.SCOPE_REFERENCE = {
                    "SCOPE_REFERENCE": true
                };
                /**
 * Unique symbol for indicating, when used as the value of the value
 * parameter in calls to setProperty and friends, that the value
 * should be taken from the property descriptor instead.
 */ Interpreter.VALUE_IN_DESCRIPTOR = {
                    "VALUE_IN_DESCRIPTOR": true
                };
                /**
 * Unique symbol for indicating that a RegExp timeout has occurred in a VM.
 */ Interpreter.REGEXP_TIMEOUT = {
                    "REGEXP_TIMEOUT": true
                };
                /**
 * For cycle detection in array to string and error conversion;
 * see spec bug github.com/tc39/ecma262/issues/289
 * Since this is for atomic actions only, it can be a class property.
 */ Interpreter.toStringCycles_ = [];
                /**
 * Node's vm module, if loaded and required.
 * @type {Object}
 */ Interpreter.vm = null;
                /**
 * Currently executing interpreter.  Needed so Interpreter.Object instances
 * can know their environment.
 * @type {Interpreter}
 */ Interpreter.currentInterpreter_ = null;
                /**
 * The global object (`window` in a browser, `global` in node.js) is usually
 * `globalThis`, but older systems use `this`.
 */ Interpreter.nativeGlobal = typeof globalThis === "undefined" ? this : globalThis;
                /**
 * Code for executing regular expressions in a thread.
 */ Interpreter.WORKER_CODE = [
                    "onmessage = function(e) {",
                    "var result;",
                    "var data = e.data;",
                    "switch (data[0]) {",
                    "case 'split':",
                    // ['split', string, separator, limit]
                    "result = data[1].split(data[2], data[3]);",
                    "break;",
                    "case 'match':",
                    // ['match', string, regexp]
                    "result = data[1].match(data[2]);",
                    "break;",
                    "case 'search':",
                    // ['search', string, regexp]
                    "result = data[1].search(data[2]);",
                    "break;",
                    "case 'replace':",
                    // ['replace', string, regexp, newSubstr]
                    "result = data[1].replace(data[2], data[3]);",
                    "break;",
                    "case 'exec':",
                    // ['exec', regexp, lastIndex, string]
                    "var regexp = data[1];",
                    "regexp.lastIndex = data[2];",
                    "result = [regexp.exec(data[3]), data[1].lastIndex];",
                    "break;",
                    "default:",
                    "throw Error('Unknown RegExp operation: ' + data[0]);",
                    "}",
                    "postMessage(result);",
                    "close();",
                    "};"
                ];
                /**
 * Is a value a legal integer for an array length?
 * @param {Interpreter.Value} x Value to check.
 * @return {number} Zero, or a positive integer if the value can be
 *     converted to such.  NaN otherwise.
 */ Interpreter.legalArrayLength = function(x) {
                    var n = x >>> 0;
                    // Array length must be between 0 and 2^32-1 (inclusive).
                    return n === Number(x) ? n : NaN;
                };
                /**
 * Is a value a legal integer for an array index?
 * @param {Interpreter.Value} x Value to check.
 * @return {number} Zero, or a positive integer if the value can be
 *     converted to such.  NaN otherwise.
 */ Interpreter.legalArrayIndex = function(x) {
                    var n = x >>> 0;
                    // Array index cannot be 2^32-1, otherwise length would be 2^32.
                    // 0xffffffff is 2^32-1.
                    return String(n) === String(x) && n !== 0xffffffff ? n : NaN;
                };
                /**
 * Remove start and end values from AST, or set start and end values to a
 * constant value.  Used to remove highlighting from polyfills and to set
 * highlighting in an eval to cover the entire eval expression.
 * @param {!Object} node AST node.
 * @param {number=} start Starting character of all nodes, or undefined.
 * @param {number=} end Ending character of all nodes, or undefined.
 * @private
 */ Interpreter.stripLocations_ = function(node, start, end) {
                    if (start) node["start"] = start;
                    else delete node["start"];
                    if (end) node["end"] = end;
                    else delete node["end"];
                    for(var name in node)if (name !== "loc" && node.hasOwnProperty(name)) {
                        var prop = node[name];
                        if (prop && typeof prop === "object") Interpreter.stripLocations_(prop, start, end);
                    }
                };
                /**
 * Some pathological regular expressions can take geometric time.
 * Regular expressions are handled in one of three ways:
 * 0 - throw as invalid.
 * 1 - execute natively (risk of unresponsive program).
 * 2 - execute in separate thread (not supported by IE 9).
 */ Interpreter.prototype["REGEXP_MODE"] = 2;
                /**
 * If REGEXP_MODE = 2, the length of time (in ms) to allow a RegExp
 * thread to execute before terminating it.
 */ Interpreter.prototype["REGEXP_THREAD_TIMEOUT"] = 1000;
                /**
 * Length of time (in ms) to allow a polyfill to run before ending step.
 * If set to 0, polyfills will execute step by step.
 * If set to 1000, polyfills will run for up to a second per step
 * (execution will resume in the polyfill in the next step).
 * If set to Infinity, polyfills will run to completion in a single step.
 */ Interpreter.prototype["POLYFILL_TIMEOUT"] = 1000;
                /**
 * Flag indicating that a getter function needs to be called immediately.
 * @private
 */ Interpreter.prototype.getterStep_ = false;
                /**
 * Flag indicating that a setter function needs to be called immediately.
 * @private
 */ Interpreter.prototype.setterStep_ = false;
                /**
 * Number of code chunks appended to the interpreter.
 * @private
 */ Interpreter.prototype.appendCodeNumber_ = 0;
                /**
 * Parse JavaScript code into an AST using Acorn.
 * @param {string} code Raw JavaScript text.
 * @param {string} sourceFile Name of filename (for stack trace).
 * @return {!Object} AST.
 * @private
 */ Interpreter.prototype.parse_ = function(code, sourceFile) {
                    // Create a new options object, since Acorn will modify this object.
                    var options = {};
                    for(var name in Interpreter.PARSE_OPTIONS)options[name] = Interpreter.PARSE_OPTIONS[name];
                    options["sourceFile"] = sourceFile;
                    return Interpreter.nativeGlobal["acorn"].parse(code, options);
                };
                /**
 * Add more code to the interpreter.
 * @param {string|!Object} code Raw JavaScript text or AST.
 */ Interpreter.prototype.appendCode = function(code) {
                    var state = this.stateStack[0];
                    if (!state || state.node["type"] !== "Program") throw Error("Expecting original AST to start with a Program node");
                    if (typeof code === "string") code = this.parse_(code, "appendCode" + this.appendCodeNumber_++);
                    if (!code || code["type"] !== "Program") throw Error("Expecting new AST to start with a Program node");
                    this.populateScope_(code, state.scope);
                    // Append the new program to the old one.
                    Array.prototype.push.apply(state.node["body"], code["body"]);
                    state.node["body"].variableCache_ = null;
                    state.done = false;
                };
                /**
 * Execute one step of the interpreter.
 * @return {boolean} True if a step was executed, false if no more instructions.
 */ Interpreter.prototype.step = function() {
                    var stack = this.stateStack;
                    do {
                        var state = stack[stack.length - 1];
                        if (!state) return false;
                        var node = state.node, type = node["type"];
                        if (type === "Program" && state.done) return false;
                        else if (this.paused_) return true;
                        // Record the interpreter in a global property so calls to toString/valueOf
                        // can execute in the proper context.
                        var oldInterpreterValue = Interpreter.currentInterpreter_;
                        Interpreter.currentInterpreter_ = this;
                        try {
                            var nextState = this.stepFunctions_[type](stack, state, node);
                        } catch (e) {
                            // Eat any step errors.  They have been thrown on the stack.
                            if (e !== Interpreter.STEP_ERROR) // Uh oh.  This is a real error in the JS-Interpreter.  Rethrow.
                            throw e;
                        } finally{
                            // Restore to previous value (probably null, maybe nested toString calls).
                            Interpreter.currentInterpreter_ = oldInterpreterValue;
                        }
                        if (nextState) stack.push(nextState);
                        if (this.getterStep_) // Getter from this step was not handled.
                        throw Error("Getter not supported in this context");
                        if (this.setterStep_) // Setter from this step was not handled.
                        throw Error("Setter not supported in this context");
                        // This may be polyfill code.  Keep executing until we arrive at user code.
                        if (!endTime && !node["end"]) // Ideally this would be defined at the top of the function, but that
                        // wastes time if the step isn't a polyfill.
                        var endTime = Date.now() + this["POLYFILL_TIMEOUT"];
                    }while (!node["end"] && endTime > Date.now());
                    return true;
                };
                /**
 * Execute the interpreter to program completion.  Vulnerable to infinite loops.
 * @return {boolean} True if a execution is asynchronously blocked,
 *     false if no more instructions.
 */ Interpreter.prototype.run = function() {
                    while(!this.paused_ && this.step());
                    return this.paused_;
                };
                /**
 * Initialize the global object with buitin properties and functions.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initGlobal = function(globalObject) {
                    // Initialize uneditable global properties.
                    this.setProperty(globalObject, "NaN", NaN, Interpreter.NONCONFIGURABLE_READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, "Infinity", Infinity, Interpreter.NONCONFIGURABLE_READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, "undefined", undefined, Interpreter.NONCONFIGURABLE_READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, "window", globalObject, Interpreter.READONLY_DESCRIPTOR);
                    this.setProperty(globalObject, "this", globalObject, Interpreter.NONCONFIGURABLE_READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, "self", globalObject); // Editable.
                    // Create the objects which will become Object.prototype and
                    // Function.prototype, which are needed to bootstrap everything else.
                    this.OBJECT_PROTO = new Interpreter.Object(null);
                    this.FUNCTION_PROTO = new Interpreter.Object(this.OBJECT_PROTO);
                    // Initialize global objects.
                    this.initFunction(globalObject);
                    this.initObject(globalObject);
                    // Unable to set globalObject's parent prior (OBJECT did not exist).
                    // Note that in a browser this would be `Window`, whereas in Node.js it would
                    // be `Object`.  This interpreter is closer to Node in that it has no DOM.
                    globalObject.proto = this.OBJECT_PROTO;
                    this.setProperty(globalObject, "constructor", this.OBJECT, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.initArray(globalObject);
                    this.initString(globalObject);
                    this.initBoolean(globalObject);
                    this.initNumber(globalObject);
                    this.initDate(globalObject);
                    this.initRegExp(globalObject);
                    this.initError(globalObject);
                    this.initMath(globalObject);
                    this.initJSON(globalObject);
                    // Initialize global functions.
                    var thisInterpreter = this;
                    var func = this.createNativeFunction(function(_x) {
                        throw EvalError("Can't happen");
                    }, false);
                    func.eval = true;
                    this.setProperty(globalObject, "eval", func, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, "parseInt", this.createNativeFunction(parseInt, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, "parseFloat", this.createNativeFunction(parseFloat, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, "isNaN", this.createNativeFunction(isNaN, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, "isFinite", this.createNativeFunction(isFinite, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    var strFunctions = [
                        [
                            escape,
                            "escape"
                        ],
                        [
                            unescape,
                            "unescape"
                        ],
                        [
                            decodeURI,
                            "decodeURI"
                        ],
                        [
                            decodeURIComponent,
                            "decodeURIComponent"
                        ],
                        [
                            encodeURI,
                            "encodeURI"
                        ],
                        [
                            encodeURIComponent,
                            "encodeURIComponent"
                        ]
                    ];
                    for(var i = 0; i < strFunctions.length; i++){
                        var wrapper = function(nativeFunc) {
                            return function(str) {
                                try {
                                    return nativeFunc(str);
                                } catch (e) {
                                    // decodeURI('%xy') will throw an error.  Catch and rethrow.
                                    thisInterpreter.throwException(thisInterpreter.URI_ERROR, e.message);
                                }
                            };
                        }(strFunctions[i][0]);
                        this.setProperty(globalObject, strFunctions[i][1], this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    }
                    // Preserve publicly properties from being pruned/renamed by JS compilers.
                    // Add others as needed.
                    this["OBJECT"] = this.OBJECT;
                    this["OBJECT_PROTO"] = this.OBJECT_PROTO;
                    this["FUNCTION"] = this.FUNCTION;
                    this["FUNCTION_PROTO"] = this.FUNCTION_PROTO;
                    this["ARRAY"] = this.ARRAY;
                    this["ARRAY_PROTO"] = this.ARRAY_PROTO;
                    this["REGEXP"] = this.REGEXP;
                    this["REGEXP_PROTO"] = this.REGEXP_PROTO;
                    this["DATE"] = this.DATE;
                    this["DATE_PROTO"] = this.DATE_PROTO;
                    // Run any user-provided initialization.
                    if (this.initFunc_) this.initFunc_(this, globalObject);
                };
                /**
 * Number of functions created by the interpreter.
 * @private
 */ Interpreter.prototype.functionCodeNumber_ = 0;
                /**
 * Initialize the Function class.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initFunction = function(globalObject) {
                    var thisInterpreter = this;
                    var wrapper;
                    var identifierRegexp = /^[A-Za-z_$][\w$]*$/;
                    // Function constructor.
                    wrapper = function Function1(var_args) {
                        if (arguments.length) var code = String(arguments[arguments.length - 1]);
                        else var code = "";
                        var argsStr = Array.prototype.slice.call(arguments, 0, -1).join(",").trim();
                        if (argsStr) {
                            var args = argsStr.split(/\s*,\s*/);
                            for(var i = 0; i < args.length; i++){
                                var name = args[i];
                                if (!identifierRegexp.test(name)) thisInterpreter.throwException(thisInterpreter.SYNTAX_ERROR, "Invalid function argument: " + name);
                            }
                            argsStr = args.join(", ");
                        }
                        // Acorn needs to parse code in the context of a function or else `return`
                        // statements will be syntax errors.
                        try {
                            var ast = thisInterpreter.parse_("(function(" + argsStr + ") {" + code + "})", "function" + thisInterpreter.functionCodeNumber_++);
                        } catch (e) {
                            // Acorn threw a SyntaxError.  Rethrow as a trappable error.
                            thisInterpreter.throwException(thisInterpreter.SYNTAX_ERROR, "Invalid code: " + e.message);
                        }
                        if (ast["body"].length !== 1) // Function('a', 'return a + 6;}; {alert(1);');
                        thisInterpreter.throwException(thisInterpreter.SYNTAX_ERROR, "Invalid code in function body.");
                        var node = ast["body"][0]["expression"];
                        // Note that if this constructor is called as `new Function()` the function
                        // object created by stepCallExpression and assigned to `this` is discarded.
                        // Interestingly, the scope for constructed functions is the global scope,
                        // even if they were constructed in some other scope.
                        return thisInterpreter.createFunction(node, thisInterpreter.globalScope, "anonymous");
                    };
                    this.FUNCTION = this.createNativeFunction(wrapper, true);
                    this.setProperty(globalObject, "Function", this.FUNCTION, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Throw away the created prototype and use the root prototype.
                    this.setProperty(this.FUNCTION, "prototype", this.FUNCTION_PROTO, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Configure Function.prototype.
                    this.setProperty(this.FUNCTION_PROTO, "constructor", this.FUNCTION, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.FUNCTION_PROTO.nativeFunc = function() {};
                    this.FUNCTION_PROTO.nativeFunc.id = this.functionCounter_++;
                    this.FUNCTION_PROTO.illegalConstructor = true;
                    this.setProperty(this.FUNCTION_PROTO, "length", 0, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.FUNCTION_PROTO.class = "Function";
                    wrapper = function apply(thisArg, args) {
                        var state = thisInterpreter.stateStack[thisInterpreter.stateStack.length - 1];
                        // Rewrite the current CallExpression state to apply a different function.
                        state.func_ = this;
                        // Assign the `this` object.
                        state.funcThis_ = thisArg;
                        // Bind any provided arguments.
                        state.arguments_ = [];
                        if (args !== null && args !== undefined) {
                            if (args instanceof Interpreter.Object) state.arguments_ = thisInterpreter.arrayPseudoToNative(args);
                            else thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, "CreateListFromArrayLike called on non-object");
                        }
                        state.doneExec_ = false;
                    };
                    this.setNativeFunctionPrototype(this.FUNCTION, "apply", wrapper);
                    wrapper = function call(thisArg /*, var_args */ ) {
                        var state = thisInterpreter.stateStack[thisInterpreter.stateStack.length - 1];
                        // Rewrite the current CallExpression state to call a different function.
                        state.func_ = this;
                        // Assign the `this` object.
                        state.funcThis_ = thisArg;
                        // Bind any provided arguments.
                        state.arguments_ = [];
                        for(var i = 1; i < arguments.length; i++)state.arguments_.push(arguments[i]);
                        state.doneExec_ = false;
                    };
                    this.setNativeFunctionPrototype(this.FUNCTION, "call", wrapper);
                    this.polyfills_.push(// Polyfill copied from:
                    // developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_objects/Function/bind
                    "Object.defineProperty(Function.prototype, 'bind',", "{configurable: true, writable: true, value:", "function bind(oThis) {", "if (typeof this !== 'function') {", "throw TypeError('What is trying to be bound is not callable');", "}", "var aArgs   = Array.prototype.slice.call(arguments, 1),", "fToBind = this,", "fNOP    = function() {},", "fBound  = function() {", "return fToBind.apply(this instanceof fNOP", "? this", ": oThis,", "aArgs.concat(Array.prototype.slice.call(arguments)));", "};", "if (this.prototype) {", "fNOP.prototype = this.prototype;", "}", "fBound.prototype = new fNOP();", "return fBound;", "}", "});", "");
                    // Function has no parent to inherit from, so it needs its own mandatory
                    // toString and valueOf functions.
                    wrapper = function toString() {
                        return String(this);
                    };
                    this.setNativeFunctionPrototype(this.FUNCTION, "toString", wrapper);
                    this.setProperty(this.FUNCTION, "toString", this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    wrapper = function valueOf() {
                        return this.valueOf();
                    };
                    this.setNativeFunctionPrototype(this.FUNCTION, "valueOf", wrapper);
                    this.setProperty(this.FUNCTION, "valueOf", this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                };
                /**
 * Initialize the Object class.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initObject = function(globalObject) {
                    var thisInterpreter = this;
                    var wrapper;
                    // Object constructor.
                    wrapper = function Object1(value) {
                        if (value === undefined || value === null) {
                            // Create a new object.
                            if (thisInterpreter.calledWithNew()) // Called as `new Object()`.
                            return this;
                            else // Called as `Object()`.
                            return thisInterpreter.createObjectProto(thisInterpreter.OBJECT_PROTO);
                        }
                        if (!(value instanceof Interpreter.Object)) {
                            // Wrap the value as an object.
                            var box = thisInterpreter.createObjectProto(thisInterpreter.getPrototype(value));
                            box.data = value;
                            return box;
                        }
                        // Return the provided object.
                        return value;
                    };
                    this.OBJECT = this.createNativeFunction(wrapper, true);
                    // Throw away the created prototype and use the root prototype.
                    this.setProperty(this.OBJECT, "prototype", this.OBJECT_PROTO, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.OBJECT_PROTO, "constructor", this.OBJECT, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, "Object", this.OBJECT, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    /**
   * Checks if the provided value is null or undefined.
   * If so, then throw an error in the call stack.
   * @param {Interpreter.Value} value Value to check.
   */ var throwIfNullUndefined = function(value) {
                        if (value === undefined || value === null) thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, "Cannot convert '" + value + "' to object");
                    };
                    // Static methods on Object.
                    wrapper = function getOwnPropertyNames(obj) {
                        throwIfNullUndefined(obj);
                        var props = obj instanceof Interpreter.Object ? obj.properties : obj;
                        return thisInterpreter.arrayNativeToPseudo(Object.getOwnPropertyNames(props));
                    };
                    this.setProperty(this.OBJECT, "getOwnPropertyNames", this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    wrapper = function keys(obj) {
                        throwIfNullUndefined(obj);
                        if (obj instanceof Interpreter.Object) obj = obj.properties;
                        return thisInterpreter.arrayNativeToPseudo(Object.keys(obj));
                    };
                    this.setProperty(this.OBJECT, "keys", this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    wrapper = function create_(proto) {
                        // Support for the second argument is the responsibility of a polyfill.
                        if (proto === null) return thisInterpreter.createObjectProto(null);
                        if (!(proto instanceof Interpreter.Object)) thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, "Object prototype may only be an Object or null");
                        return thisInterpreter.createObjectProto(proto);
                    };
                    this.setProperty(this.OBJECT, "create", this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Add a polyfill to handle create's second argument.
                    this.polyfills_.push("(function() {", "var create_ = Object.create;", "Object.create = function create(proto, props) {", "var obj = create_(proto);", "props && Object.defineProperties(obj, props);", "return obj;", "};", "})();", "");
                    wrapper = function defineProperty(obj, prop, descriptor) {
                        prop = String(prop);
                        if (!(obj instanceof Interpreter.Object)) thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, "Object.defineProperty called on non-object");
                        if (!(descriptor instanceof Interpreter.Object)) thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, "Property description must be an object");
                        if (!obj.properties[prop] && obj.preventExtensions) thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, "Can't define property '" + prop + "', object is not extensible");
                        // The polyfill guarantees no inheritance and no getter functions.
                        // Therefore the descriptor properties map is the native object needed.
                        thisInterpreter.setProperty(obj, prop, Interpreter.VALUE_IN_DESCRIPTOR, descriptor.properties);
                        return obj;
                    };
                    this.setProperty(this.OBJECT, "defineProperty", this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.polyfills_.push(// Flatten the descriptor to remove any inheritance or getter functions.
                    "(function() {", "var defineProperty_ = Object.defineProperty;", "Object.defineProperty = function defineProperty(obj, prop, d1) {", "var d2 = {};", "if ('configurable' in d1) d2.configurable = d1.configurable;", "if ('enumerable' in d1) d2.enumerable = d1.enumerable;", "if ('writable' in d1) d2.writable = d1.writable;", "if ('value' in d1) d2.value = d1.value;", "if ('get' in d1) d2.get = d1.get;", "if ('set' in d1) d2.set = d1.set;", "return defineProperty_(obj, prop, d2);", "};", "})();", "Object.defineProperty(Object, 'defineProperties',", "{configurable: true, writable: true, value:", "function defineProperties(obj, props) {", "var keys = Object.keys(props);", "for (var i = 0; i < keys.length; i++) {", "Object.defineProperty(obj, keys[i], props[keys[i]]);", "}", "return obj;", "}", "});", "");
                    wrapper = function getOwnPropertyDescriptor(obj, prop) {
                        if (!(obj instanceof Interpreter.Object)) thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, "Object.getOwnPropertyDescriptor called on non-object");
                        prop = String(prop);
                        if (!(prop in obj.properties)) return undefined;
                        var descriptor = Object.getOwnPropertyDescriptor(obj.properties, prop);
                        var getter = obj.getter[prop];
                        var setter = obj.setter[prop];
                        var pseudoDescriptor = thisInterpreter.createObjectProto(thisInterpreter.OBJECT_PROTO);
                        if (getter || setter) {
                            thisInterpreter.setProperty(pseudoDescriptor, "get", getter);
                            thisInterpreter.setProperty(pseudoDescriptor, "set", setter);
                        } else {
                            thisInterpreter.setProperty(pseudoDescriptor, "value", descriptor.value);
                            thisInterpreter.setProperty(pseudoDescriptor, "writable", descriptor.writable);
                        }
                        thisInterpreter.setProperty(pseudoDescriptor, "configurable", descriptor.configurable);
                        thisInterpreter.setProperty(pseudoDescriptor, "enumerable", descriptor.enumerable);
                        return pseudoDescriptor;
                    };
                    this.setProperty(this.OBJECT, "getOwnPropertyDescriptor", this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    wrapper = function getPrototypeOf(obj) {
                        throwIfNullUndefined(obj);
                        return thisInterpreter.getPrototype(obj);
                    };
                    this.setProperty(this.OBJECT, "getPrototypeOf", this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    wrapper = function isExtensible(obj) {
                        return Boolean(obj) && !obj.preventExtensions;
                    };
                    this.setProperty(this.OBJECT, "isExtensible", this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    wrapper = function preventExtensions(obj) {
                        if (obj instanceof Interpreter.Object) obj.preventExtensions = true;
                        return obj;
                    };
                    this.setProperty(this.OBJECT, "preventExtensions", this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Instance methods on Object.
                    this.setNativeFunctionPrototype(this.OBJECT, "toString", Interpreter.Object.prototype.toString);
                    this.setNativeFunctionPrototype(this.OBJECT, "toLocaleString", Interpreter.Object.prototype.toString);
                    this.setNativeFunctionPrototype(this.OBJECT, "valueOf", Interpreter.Object.prototype.valueOf);
                    wrapper = function hasOwnProperty(prop) {
                        throwIfNullUndefined(this);
                        if (this instanceof Interpreter.Object) return String(prop) in this.properties;
                        // Primitive.
                        return this.hasOwnProperty(prop);
                    };
                    this.setNativeFunctionPrototype(this.OBJECT, "hasOwnProperty", wrapper);
                    wrapper = function propertyIsEnumerable(prop) {
                        throwIfNullUndefined(this);
                        if (this instanceof Interpreter.Object) return Object.prototype.propertyIsEnumerable.call(this.properties, prop);
                        // Primitive.
                        return this.propertyIsEnumerable(prop);
                    };
                    this.setNativeFunctionPrototype(this.OBJECT, "propertyIsEnumerable", wrapper);
                    wrapper = function isPrototypeOf(obj) {
                        while(true){
                            // Note, circular loops shouldn't be possible.
                            obj = thisInterpreter.getPrototype(obj);
                            if (!obj) // No parent; reached the top.
                            return false;
                            if (obj === this) return true;
                        }
                    };
                    this.setNativeFunctionPrototype(this.OBJECT, "isPrototypeOf", wrapper);
                };
                /**
 * Initialize the Array class.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initArray = function(globalObject) {
                    var thisInterpreter = this;
                    var wrapper;
                    // Array constructor.
                    wrapper = function Array1(var_args) {
                        if (thisInterpreter.calledWithNew()) // Called as `new Array()`.
                        var newArray = this;
                        else // Called as `Array()`.
                        var newArray = thisInterpreter.createArray();
                        var first = arguments[0];
                        if (arguments.length === 1 && typeof first === "number") {
                            if (isNaN(Interpreter.legalArrayLength(first))) thisInterpreter.throwException(thisInterpreter.RANGE_ERROR, "Invalid array length");
                            newArray.properties.length = first;
                        } else {
                            for(var i = 0; i < arguments.length; i++)newArray.properties[i] = arguments[i];
                            newArray.properties.length = i;
                        }
                        return newArray;
                    };
                    this.ARRAY = this.createNativeFunction(wrapper, true);
                    this.ARRAY_PROTO = this.ARRAY.properties["prototype"];
                    this.setProperty(globalObject, "Array", this.ARRAY, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Static methods on Array.
                    wrapper = function isArray(obj) {
                        return obj && obj.class === "Array";
                    };
                    this.setProperty(this.ARRAY, "isArray", this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Instance methods on Array.
                    this.setProperty(this.ARRAY_PROTO, "length", 0, {
                        configurable: false,
                        enumerable: false,
                        writable: true
                    });
                    this.ARRAY_PROTO.class = "Array";
                    this.polyfills_.push("Object.defineProperty(Array.prototype, 'pop',", "{configurable: true, writable: true, value:", "function pop() {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "if (!len || len < 0) {", "o.length = 0;", "return undefined;", "}", "len--;", "var x = o[len];", "delete o[len];", "o.length = len;", "return x;", "}", "});", "Object.defineProperty(Array.prototype, 'push',", "{configurable: true, writable: true, value:", "function push(var_args) {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "for (var i = 0; i < arguments.length; i++) {", "o[len] = arguments[i];", "len++;", "}", "o.length = len;", "return len;", "}", "});", "Object.defineProperty(Array.prototype, 'shift',", "{configurable: true, writable: true, value:", "function shift() {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "if (!len || len < 0) {", "o.length = 0;", "return undefined;", "}", "var value = o[0];", "for (var i = 0; i < len - 1; i++) {", "if ((i + 1) in o) {", "o[i] = o[i + 1];", "} else {", "delete o[i];", "}", "}", "delete o[i];", "o.length = len - 1;", "return value;", "}", "});", "Object.defineProperty(Array.prototype, 'unshift',", "{configurable: true, writable: true, value:", "function unshift(var_args) {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "if (!len || len < 0) {", "len = 0;", "}", "for (var i = len - 1; i >= 0; i--) {", "if (i in o) {", "o[i + arguments.length] = o[i];", "} else {", "delete o[i + arguments.length];", "}", "}", "for (var i = 0; i < arguments.length; i++) {", "o[i] = arguments[i];", "}", "return (o.length = len + arguments.length);", "}", "});", "Object.defineProperty(Array.prototype, 'reverse',", "{configurable: true, writable: true, value:", "function reverse() {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "if (!len || len < 2) {", "return o;", "}", "for (var i = 0; i < len / 2 - 0.5; i++) {", "var x = o[i];", "var hasX = i in o;", "if ((len - i - 1) in o) {", "o[i] = o[len - i - 1];", "} else {", "delete o[i];", "}", "if (hasX) {", "o[len - i - 1] = x;", "} else {", "delete o[len - i - 1];", "}", "}", "return o;", "}", "});", "Object.defineProperty(Array.prototype, 'indexOf',", "{configurable: true, writable: true, value:", "function indexOf(searchElement, fromIndex) {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "var n = fromIndex | 0;", "if (!len || n >= len) {", "return -1;", "}", "var i = Math.max(n >= 0 ? n : len - Math.abs(n), 0);", "while (i < len) {", "if (i in o && o[i] === searchElement) {", "return i;", "}", "i++;", "}", "return -1;", "}", "});", "Object.defineProperty(Array.prototype, 'lastIndexOf',", "{configurable: true, writable: true, value:", "function lastIndexOf(searchElement, fromIndex) {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "if (!len) {", "return -1;", "}", "var n = len - 1;", "if (arguments.length > 1) {", "n = fromIndex | 0;", "if (n) {", "n = (n > 0 || -1) * Math.floor(Math.abs(n));", "}", "}", "var i = n >= 0 ? Math.min(n, len - 1) : len - Math.abs(n);", "while (i >= 0) {", "if (i in o && o[i] === searchElement) {", "return i;", "}", "i--;", "}", "return -1;", "}", "});", "Object.defineProperty(Array.prototype, 'slice',", "{configurable: true, writable: true, value:", "function slice(start, end) {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", // Handle negative value for "start"
                    "start |= 0;", "start = (start >= 0) ? start : Math.max(0, len + start);", // Handle negative value for "end"
                    "if (typeof end !== 'undefined') {", "if (end !== Infinity) {", "end |= 0;", "}", "if (end < 0) {", "end = len + end;", "} else {", "end = Math.min(end, len);", "}", "} else {", "end = len;", "}", "var size = end - start;", "var cloned = new Array(size);", "for (var i = 0; i < size; i++) {", "if ((start + i) in o) {", "cloned[i] = o[start + i];", "}", "}", "return cloned;", "}", "});", "Object.defineProperty(Array.prototype, 'splice',", "{configurable: true, writable: true, value:", "function splice(start, deleteCount, var_args) {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "start |= 0;", "if (start < 0) {", "start = Math.max(len + start, 0);", "} else {", "start = Math.min(start, len);", "}", "if (arguments.length < 1) {", "deleteCount = len - start;", "} else {", "deleteCount |= 0;", "deleteCount = Math.max(0, Math.min(deleteCount, len - start));", "}", "var removed = [];", // Remove specified elements.
                    "for (var i = start; i < start + deleteCount; i++) {", "if (i in o) {", "removed.push(o[i]);", "} else {", "removed.length++;", "}", "if ((i + deleteCount) in o) {", "o[i] = o[i + deleteCount];", "} else {", "delete o[i];", "}", "}", // Move other element to fill the gap.
                    "for (var i = start + deleteCount; i < len - deleteCount; i++) {", "if ((i + deleteCount) in o) {", "o[i] = o[i + deleteCount];", "} else {", "delete o[i];", "}", "}", // Delete superfluous properties.
                    "for (var i = len - deleteCount; i < len; i++) {", "delete o[i];", "}", "len -= deleteCount;", // Insert specified items.
                    "var arl = arguments.length - 2;", "for (var i = len - 1; i >= start; i--) {", "if (i in o) {", "o[i + arl] = o[i];", "} else {", "delete o[i + arl];", "}", "}", "len += arl;", "for (var i = 2; i < arguments.length; i++) {", "o[start + i - 2] = arguments[i];", "}", "o.length = len;", "return removed;", "}", "});", "Object.defineProperty(Array.prototype, 'concat',", "{configurable: true, writable: true, value:", "function concat(var_args) {", "if (!this) throw TypeError();", "var o = Object(this);", "var cloned = [];", "for (var i = -1; i < arguments.length; i++) {", "var value = (i === -1) ? o : arguments[i];", "if (Array.isArray(value)) {", "for (var j = 0, l = value.length; j < l; j++) {", "if (j in value) {", "cloned.push(value[j]);", "} else {", "cloned.length++;", "}", "}", "} else {", "cloned.push(value);", "}", "}", "return cloned;", "}", "});", "Object.defineProperty(Array.prototype, 'join',", "{configurable: true, writable: true, value:", "function join(opt_separator) {", "if (!this) throw TypeError();", "var o = Object(this);", "var sep = typeof opt_separator === 'undefined' ?", "',' : ('' + opt_separator);", "var str = '';", "for (var i = 0; i < o.length; i++) {", "if (i && sep) {", "str += sep;", "}", "str += (o[i] === null || o[i] === undefined) ? '' : o[i];", "}", "return str;", "}", "});", // Polyfill copied from:
                    // developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/every
                    "Object.defineProperty(Array.prototype, 'every',", "{configurable: true, writable: true, value:", "function every(callbackfn, thisArg) {", "if (!this || typeof callbackfn !== 'function') throw TypeError();", "var t, k;", "var o = Object(this);", "var len = o.length >>> 0;", "if (arguments.length > 1) t = thisArg;", "k = 0;", "while (k < len) {", "if (k in o && !callbackfn.call(t, o[k], k, o)) return false;", "k++;", "}", "return true;", "}", "});", // Polyfill copied from:
                    // developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
                    "Object.defineProperty(Array.prototype, 'filter',", "{configurable: true, writable: true, value:", "function filter(fun, var_args) {", "if (this === void 0 || this === null || typeof fun !== 'function') throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "var res = [];", "var thisArg = arguments.length >= 2 ? arguments[1] : void 0;", "for (var i = 0; i < len; i++) {", "if (i in o) {", "var val = o[i];", "if (fun.call(thisArg, val, i, o)) res.push(val);", "}", "}", "return res;", "}", "});", // Polyfill copied from:
                    // developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
                    "Object.defineProperty(Array.prototype, 'forEach',", "{configurable: true, writable: true, value:", "function forEach(callback, thisArg) {", "if (!this || typeof callback !== 'function') throw TypeError();", "var t, k;", "var o = Object(this);", "var len = o.length >>> 0;", "if (arguments.length > 1) t = thisArg;", "k = 0;", "while (k < len) {", "if (k in o) callback.call(t, o[k], k, o);", "k++;", "}", "}", "});", // Polyfill copied from:
                    // developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/map
                    "Object.defineProperty(Array.prototype, 'map',", "{configurable: true, writable: true, value:", "function map(callback, thisArg) {", "if (!this || typeof callback !== 'function') throw TypeError();", "var t, a, k;", "var o = Object(this);", "var len = o.length >>> 0;", "if (arguments.length > 1) t = thisArg;", "a = new Array(len);", "k = 0;", "while (k < len) {", "if (k in o) a[k] = callback.call(t, o[k], k, o);", "k++;", "}", "return a;", "}", "});", // Polyfill copied from:
                    // developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce
                    "Object.defineProperty(Array.prototype, 'reduce',", "{configurable: true, writable: true, value:", "function reduce(callback /*, initialValue*/) {", "if (!this || typeof callback !== 'function') throw TypeError();", "var o = Object(this), len = o.length >>> 0, k = 0, value;", "if (arguments.length === 2) {", "value = arguments[1];", "} else {", "while (k < len && !(k in o)) k++;", "if (k >= len) {", "throw TypeError('Reduce of empty array with no initial value');", "}", "value = o[k++];", "}", "for (; k < len; k++) {", "if (k in o) value = callback(value, o[k], k, o);", "}", "return value;", "}", "});", // Polyfill copied from:
                    // developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/ReduceRight
                    "Object.defineProperty(Array.prototype, 'reduceRight',", "{configurable: true, writable: true, value:", "function reduceRight(callback /*, initialValue*/) {", "if (null === this || 'undefined' === typeof this || 'function' !== typeof callback) throw TypeError();", "var o = Object(this), len = o.length >>> 0, k = len - 1, value;", "if (arguments.length >= 2) {", "value = arguments[1];", "} else {", "while (k >= 0 && !(k in o)) k--;", "if (k < 0) {", "throw TypeError('Reduce of empty array with no initial value');", "}", "value = o[k--];", "}", "for (; k >= 0; k--) {", "if (k in o) value = callback(value, o[k], k, o);", "}", "return value;", "}", "});", // Polyfill copied from:
                    // developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/some
                    "Object.defineProperty(Array.prototype, 'some',", "{configurable: true, writable: true, value:", "function some(fun/*, thisArg*/) {", "if (!this || typeof fun !== 'function') throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "var thisArg = arguments.length >= 2 ? arguments[1] : void 0;", "for (var i = 0; i < len; i++) {", "if (i in o && fun.call(thisArg, o[i], i, o)) {", "return true;", "}", "}", "return false;", "}", "});", "Object.defineProperty(Array.prototype, 'sort',", "{configurable: true, writable: true, value:", "function sort(opt_comp) {", "if (!this) throw TypeError();", "if (typeof opt_comp !== 'function') {", "opt_comp = undefined;", "}", "for (var i = 0; i < this.length; i++) {", "var changes = 0;", "for (var j = 0; j < this.length - i - 1; j++) {", "if (opt_comp ? (opt_comp(this[j], this[j + 1]) > 0) :", "(String(this[j]) > String(this[j + 1]))) {", "var swap = this[j];", "var hasSwap = j in this;", "if ((j + 1) in this) {", "this[j] = this[j + 1];", "} else {", "delete this[j];", "}", "if (hasSwap) {", "this[j + 1] = swap;", "} else {", "delete this[j + 1];", "}", "changes++;", "}", "}", "if (!changes) break;", "}", "return this;", "}", "});", "Object.defineProperty(Array.prototype, 'toLocaleString',", "{configurable: true, writable: true, value:", "function toLocaleString() {", "if (!this) throw TypeError();", "var o = Object(this);", "var out = [];", "for (var i = 0; i < o.length; i++) {", "out[i] = (o[i] === null || o[i] === undefined) ? '' : o[i].toLocaleString();", "}", "return out.join(',');", "}", "});", "");
                };
                /**
 * Initialize the String class.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initString = function(globalObject) {
                    var thisInterpreter = this;
                    var wrapper;
                    // String constructor.
                    wrapper = function String1(value) {
                        value = arguments.length ? Interpreter.nativeGlobal.String(value) : "";
                        if (thisInterpreter.calledWithNew()) {
                            // Called as `new String()`.
                            this.data = value;
                            return this;
                        } else // Called as `String()`.
                        return value;
                    };
                    this.STRING = this.createNativeFunction(wrapper, true);
                    this.setProperty(globalObject, "String", this.STRING, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Static methods on String.
                    this.setProperty(this.STRING, "fromCharCode", this.createNativeFunction(String.fromCharCode, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Instance methods on String.
                    // Methods with exclusively primitive arguments.
                    var functions = [
                        "charAt",
                        "charCodeAt",
                        "concat",
                        "indexOf",
                        "lastIndexOf",
                        "slice",
                        "substr",
                        "substring",
                        "toLocaleLowerCase",
                        "toLocaleUpperCase",
                        "toLowerCase",
                        "toUpperCase",
                        "trim"
                    ];
                    for(var i = 0; i < functions.length; i++)this.setNativeFunctionPrototype(this.STRING, functions[i], String.prototype[functions[i]]);
                    wrapper = function localeCompare(compareString, locales, options) {
                        locales = thisInterpreter.pseudoToNative(locales);
                        options = thisInterpreter.pseudoToNative(options);
                        try {
                            return String(this).localeCompare(compareString, locales, options);
                        } catch (e) {
                            thisInterpreter.throwException(thisInterpreter.ERROR, "localeCompare: " + e.message);
                        }
                    };
                    this.setNativeFunctionPrototype(this.STRING, "localeCompare", wrapper);
                    wrapper = function split(separator, limit, callback) {
                        var string = String(this);
                        limit = limit ? Number(limit) : undefined;
                        // Example of catastrophic split RegExp:
                        // 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaac'.split(/^(a+)+b/)
                        if (thisInterpreter.isa(separator, thisInterpreter.REGEXP)) {
                            separator = separator.data;
                            thisInterpreter.maybeThrowRegExp(separator, callback);
                            if (thisInterpreter["REGEXP_MODE"] === 2) {
                                if (Interpreter.vm) {
                                    // Run split in vm.
                                    var sandbox = {
                                        "string": string,
                                        "separator": separator,
                                        "limit": limit
                                    };
                                    var code = "string.split(separator, limit)";
                                    var jsList = thisInterpreter.vmCall(code, sandbox, separator, callback);
                                    if (jsList !== Interpreter.REGEXP_TIMEOUT) callback(thisInterpreter.arrayNativeToPseudo(jsList));
                                } else {
                                    // Run split in separate thread.
                                    var splitWorker = thisInterpreter.createWorker();
                                    var pid = thisInterpreter.regExpTimeout(separator, splitWorker, callback);
                                    splitWorker.onmessage = function(e) {
                                        clearTimeout(pid);
                                        callback(thisInterpreter.arrayNativeToPseudo(e.data));
                                    };
                                    splitWorker.postMessage([
                                        "split",
                                        string,
                                        separator,
                                        limit
                                    ]);
                                }
                                return;
                            }
                        }
                        // Run split natively.
                        var jsList = string.split(separator, limit);
                        callback(thisInterpreter.arrayNativeToPseudo(jsList));
                    };
                    this.setAsyncFunctionPrototype(this.STRING, "split", wrapper);
                    wrapper = function match(regexp, callback) {
                        var string = String(this);
                        if (thisInterpreter.isa(regexp, thisInterpreter.REGEXP)) regexp = regexp.data;
                        else regexp = new RegExp(regexp);
                        // Example of catastrophic match RegExp:
                        // 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaac'.match(/^(a+)+b/)
                        thisInterpreter.maybeThrowRegExp(regexp, callback);
                        if (thisInterpreter["REGEXP_MODE"] === 2) {
                            if (Interpreter.vm) {
                                // Run match in vm.
                                var sandbox = {
                                    "string": string,
                                    "regexp": regexp
                                };
                                var code = "string.match(regexp)";
                                var m = thisInterpreter.vmCall(code, sandbox, regexp, callback);
                                if (m !== Interpreter.REGEXP_TIMEOUT) callback(m && thisInterpreter.arrayNativeToPseudo(m));
                            } else {
                                // Run match in separate thread.
                                var matchWorker = thisInterpreter.createWorker();
                                var pid = thisInterpreter.regExpTimeout(regexp, matchWorker, callback);
                                matchWorker.onmessage = function(e) {
                                    clearTimeout(pid);
                                    callback(e.data && thisInterpreter.arrayNativeToPseudo(e.data));
                                };
                                matchWorker.postMessage([
                                    "match",
                                    string,
                                    regexp
                                ]);
                            }
                            return;
                        }
                        // Run match natively.
                        var m = string.match(regexp);
                        callback(m && thisInterpreter.arrayNativeToPseudo(m));
                    };
                    this.setAsyncFunctionPrototype(this.STRING, "match", wrapper);
                    wrapper = function search(regexp, callback) {
                        var string = String(this);
                        if (thisInterpreter.isa(regexp, thisInterpreter.REGEXP)) regexp = regexp.data;
                        else regexp = new RegExp(regexp);
                        // Example of catastrophic search RegExp:
                        // 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaac'.search(/^(a+)+b/)
                        thisInterpreter.maybeThrowRegExp(regexp, callback);
                        if (thisInterpreter["REGEXP_MODE"] === 2) {
                            if (Interpreter.vm) {
                                // Run search in vm.
                                var sandbox = {
                                    "string": string,
                                    "regexp": regexp
                                };
                                var code = "string.search(regexp)";
                                var n = thisInterpreter.vmCall(code, sandbox, regexp, callback);
                                if (n !== Interpreter.REGEXP_TIMEOUT) callback(n);
                            } else {
                                // Run search in separate thread.
                                var searchWorker = thisInterpreter.createWorker();
                                var pid = thisInterpreter.regExpTimeout(regexp, searchWorker, callback);
                                searchWorker.onmessage = function(e) {
                                    clearTimeout(pid);
                                    callback(e.data);
                                };
                                searchWorker.postMessage([
                                    "search",
                                    string,
                                    regexp
                                ]);
                            }
                            return;
                        }
                        // Run search natively.
                        callback(string.search(regexp));
                    };
                    this.setAsyncFunctionPrototype(this.STRING, "search", wrapper);
                    wrapper = function replace_(substr, newSubstr, callback) {
                        // Support for function replacements is the responsibility of a polyfill.
                        var string = String(this);
                        newSubstr = String(newSubstr);
                        // Example of catastrophic replace RegExp:
                        // 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaac'.replace(/^(a+)+b/, '')
                        if (thisInterpreter.isa(substr, thisInterpreter.REGEXP)) {
                            substr = substr.data;
                            thisInterpreter.maybeThrowRegExp(substr, callback);
                            if (thisInterpreter["REGEXP_MODE"] === 2) {
                                if (Interpreter.vm) {
                                    // Run replace in vm.
                                    var sandbox = {
                                        "string": string,
                                        "substr": substr,
                                        "newSubstr": newSubstr
                                    };
                                    var code = "string.replace(substr, newSubstr)";
                                    var str = thisInterpreter.vmCall(code, sandbox, substr, callback);
                                    if (str !== Interpreter.REGEXP_TIMEOUT) callback(str);
                                } else {
                                    // Run replace in separate thread.
                                    var replaceWorker = thisInterpreter.createWorker();
                                    var pid = thisInterpreter.regExpTimeout(substr, replaceWorker, callback);
                                    replaceWorker.onmessage = function(e) {
                                        clearTimeout(pid);
                                        callback(e.data);
                                    };
                                    replaceWorker.postMessage([
                                        "replace",
                                        string,
                                        substr,
                                        newSubstr
                                    ]);
                                }
                                return;
                            }
                        }
                        // Run replace natively.
                        callback(string.replace(substr, newSubstr));
                    };
                    this.setAsyncFunctionPrototype(this.STRING, "replace", wrapper);
                    // Add a polyfill to handle replace's second argument being a function.
                    this.polyfills_.push("(function() {", "var replace_ = String.prototype.replace;", "String.prototype.replace = function replace(substr, newSubstr) {", "if (typeof newSubstr !== 'function') {", // string.replace(string|regexp, string)
                    "return replace_.call(this, substr, newSubstr);", "}", "var str = this;", "if (substr instanceof RegExp) {", "var subs = [];", "var m = substr.exec(str);", "while (m) {", "m.push(m.index, str);", "var inject = newSubstr.apply(null, m);", "subs.push([m.index, m[0].length, inject]);", "m = substr.global ? substr.exec(str) : null;", "}", "for (var i = subs.length - 1; i >= 0; i--) {", "str = str.substring(0, subs[i][0]) + subs[i][2] + str.substring(subs[i][0] + subs[i][1]);", "}", "} else {", "var i = str.indexOf(substr);", "if (i !== -1) {", "var inject = newSubstr(str.substr(i, substr.length), i, str);", "str = str.substring(0, i) + inject + str.substring(i + substr.length);", "}", "}", "return str;", "};", "})();", "");
                };
                /**
 * Initialize the Boolean class.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initBoolean = function(globalObject) {
                    var thisInterpreter = this;
                    var wrapper;
                    // Boolean constructor.
                    wrapper = function Boolean1(value) {
                        value = Interpreter.nativeGlobal.Boolean(value);
                        if (thisInterpreter.calledWithNew()) {
                            // Called as `new Boolean()`.
                            this.data = value;
                            return this;
                        } else // Called as `Boolean()`.
                        return value;
                    };
                    this.BOOLEAN = this.createNativeFunction(wrapper, true);
                    this.setProperty(globalObject, "Boolean", this.BOOLEAN, Interpreter.NONENUMERABLE_DESCRIPTOR);
                };
                /**
 * Initialize the Number class.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initNumber = function(globalObject) {
                    var thisInterpreter = this;
                    var wrapper;
                    // Number constructor.
                    wrapper = function Number1(value) {
                        value = arguments.length ? Interpreter.nativeGlobal.Number(value) : 0;
                        if (thisInterpreter.calledWithNew()) {
                            // Called as `new Number()`.
                            this.data = value;
                            return this;
                        } else // Called as `Number()`.
                        return value;
                    };
                    this.NUMBER = this.createNativeFunction(wrapper, true);
                    this.setProperty(globalObject, "Number", this.NUMBER, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    var numConsts = [
                        "MAX_VALUE",
                        "MIN_VALUE",
                        "NaN",
                        "NEGATIVE_INFINITY",
                        "POSITIVE_INFINITY"
                    ];
                    for(var i = 0; i < numConsts.length; i++)this.setProperty(this.NUMBER, numConsts[i], Number[numConsts[i]], Interpreter.NONCONFIGURABLE_READONLY_NONENUMERABLE_DESCRIPTOR);
                    // Instance methods on Number.
                    wrapper = function toExponential(fractionDigits) {
                        try {
                            return Number(this).toExponential(fractionDigits);
                        } catch (e) {
                            // Throws if fractionDigits isn't within 0-20.
                            thisInterpreter.throwException(thisInterpreter.ERROR, e.message);
                        }
                    };
                    this.setNativeFunctionPrototype(this.NUMBER, "toExponential", wrapper);
                    wrapper = function toFixed(digits) {
                        try {
                            return Number(this).toFixed(digits);
                        } catch (e) {
                            // Throws if digits isn't within 0-20.
                            thisInterpreter.throwException(thisInterpreter.ERROR, e.message);
                        }
                    };
                    this.setNativeFunctionPrototype(this.NUMBER, "toFixed", wrapper);
                    wrapper = function toPrecision(precision) {
                        try {
                            return Number(this).toPrecision(precision);
                        } catch (e) {
                            // Throws if precision isn't within range (depends on implementation).
                            thisInterpreter.throwException(thisInterpreter.ERROR, e.message);
                        }
                    };
                    this.setNativeFunctionPrototype(this.NUMBER, "toPrecision", wrapper);
                    wrapper = function toString(radix) {
                        try {
                            return Number(this).toString(radix);
                        } catch (e) {
                            // Throws if radix isn't within 2-36.
                            thisInterpreter.throwException(thisInterpreter.ERROR, e.message);
                        }
                    };
                    this.setNativeFunctionPrototype(this.NUMBER, "toString", wrapper);
                    wrapper = function toLocaleString(locales, options) {
                        locales = locales ? thisInterpreter.pseudoToNative(locales) : undefined;
                        options = options ? thisInterpreter.pseudoToNative(options) : undefined;
                        return Number(this).toLocaleString(locales, options);
                    };
                    this.setNativeFunctionPrototype(this.NUMBER, "toLocaleString", wrapper);
                };
                /**
 * Initialize the Date class.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initDate = function(globalObject) {
                    var thisInterpreter = this;
                    var wrapper;
                    // Date constructor.
                    wrapper = function Date1(_value, var_args) {
                        if (!thisInterpreter.calledWithNew()) // Called as `Date()`.
                        // Calling Date() as a function returns a string, no arguments are heeded.
                        return Interpreter.nativeGlobal.Date();
                        // Called as `new Date(...)`.
                        var args = [
                            null
                        ].concat(Array.from(arguments));
                        this.data = new (Function.prototype.bind.apply(Interpreter.nativeGlobal.Date, args));
                        return this;
                    };
                    this.DATE = this.createNativeFunction(wrapper, true);
                    this.DATE_PROTO = this.DATE.properties["prototype"];
                    this.setProperty(globalObject, "Date", this.DATE, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Static methods on Date.
                    this.setProperty(this.DATE, "now", this.createNativeFunction(Date.now, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.DATE, "parse", this.createNativeFunction(Date.parse, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.DATE, "UTC", this.createNativeFunction(Date.UTC, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Instance methods on Date.
                    var functions = [
                        "getDate",
                        "getDay",
                        "getFullYear",
                        "getHours",
                        "getMilliseconds",
                        "getMinutes",
                        "getMonth",
                        "getSeconds",
                        "getTime",
                        "getTimezoneOffset",
                        "getUTCDate",
                        "getUTCDay",
                        "getUTCFullYear",
                        "getUTCHours",
                        "getUTCMilliseconds",
                        "getUTCMinutes",
                        "getUTCMonth",
                        "getUTCSeconds",
                        "getYear",
                        "setDate",
                        "setFullYear",
                        "setHours",
                        "setMilliseconds",
                        "setMinutes",
                        "setMonth",
                        "setSeconds",
                        "setTime",
                        "setUTCDate",
                        "setUTCFullYear",
                        "setUTCHours",
                        "setUTCMilliseconds",
                        "setUTCMinutes",
                        "setUTCMonth",
                        "setUTCSeconds",
                        "setYear",
                        "toDateString",
                        "toISOString",
                        "toJSON",
                        "toGMTString",
                        "toLocaleDateString",
                        "toLocaleString",
                        "toLocaleTimeString",
                        "toTimeString",
                        "toUTCString"
                    ];
                    for(var i = 0; i < functions.length; i++){
                        wrapper = function(nativeFunc) {
                            return function(var_args) {
                                var date = this.data;
                                if (!(date instanceof Date)) thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, nativeFunc + " not called on a Date");
                                var args = [];
                                for(var i = 0; i < arguments.length; i++)args[i] = thisInterpreter.pseudoToNative(arguments[i]);
                                return date[nativeFunc].apply(date, args);
                            };
                        }(functions[i]);
                        this.setNativeFunctionPrototype(this.DATE, functions[i], wrapper);
                    }
                };
                /**
 * Initialize Regular Expression object.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initRegExp = function(globalObject) {
                    var thisInterpreter = this;
                    var wrapper;
                    // RegExp constructor.
                    wrapper = function RegExp1(pattern, flags) {
                        if (thisInterpreter.calledWithNew()) // Called as `new RegExp()`.
                        var rgx = this;
                        else {
                            // Called as `RegExp()`.
                            if (flags === undefined && thisInterpreter.isa(pattern, thisInterpreter.REGEXP)) // Regexp(/foo/) returns the same obj.
                            return pattern;
                            var rgx = thisInterpreter.createObjectProto(thisInterpreter.REGEXP_PROTO);
                        }
                        pattern = pattern === undefined ? "" : String(pattern);
                        flags = flags ? String(flags) : "";
                        if (!/^[gmi]*$/.test(flags)) // Don't allow ES6 flags 'y' and 's' to pass through.
                        thisInterpreter.throwException(thisInterpreter.SYNTAX_ERROR, "Invalid regexp flag");
                        try {
                            var nativeRegExp = new Interpreter.nativeGlobal.RegExp(pattern, flags);
                        } catch (e) {
                            // Throws if flags are repeated.
                            thisInterpreter.throwException(thisInterpreter.SYNTAX_ERROR, e.message);
                        }
                        thisInterpreter.populateRegExp(rgx, nativeRegExp);
                        return rgx;
                    };
                    this.REGEXP = this.createNativeFunction(wrapper, true);
                    this.REGEXP_PROTO = this.REGEXP.properties["prototype"];
                    this.setProperty(globalObject, "RegExp", this.REGEXP, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.REGEXP.properties["prototype"], "global", undefined, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.REGEXP.properties["prototype"], "ignoreCase", undefined, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.REGEXP.properties["prototype"], "multiline", undefined, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.REGEXP.properties["prototype"], "source", "(?:)", Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    // Use polyfill to avoid complexity of regexp threads.
                    this.polyfills_.push("Object.defineProperty(RegExp.prototype, 'test',", "{configurable: true, writable: true, value:", "function test(str) {", "return !!this.exec(str);", "}", "});");
                    wrapper = function exec(string, callback) {
                        var regexp = this.data;
                        string = String(string);
                        // Get lastIndex from wrapped regexp, since this is settable.
                        regexp.lastIndex = Number(thisInterpreter.getProperty(this, "lastIndex"));
                        // Example of catastrophic exec RegExp:
                        // /^(a+)+b/.exec('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaac')
                        thisInterpreter.maybeThrowRegExp(regexp, callback);
                        if (thisInterpreter["REGEXP_MODE"] === 2) {
                            if (Interpreter.vm) {
                                // Run exec in vm.
                                var sandbox = {
                                    "string": string,
                                    "regexp": regexp
                                };
                                var code = "regexp.exec(string)";
                                var match = thisInterpreter.vmCall(code, sandbox, regexp, callback);
                                if (match !== Interpreter.REGEXP_TIMEOUT) {
                                    thisInterpreter.setProperty(this, "lastIndex", regexp.lastIndex);
                                    callback(matchToPseudo(match));
                                }
                            } else {
                                // Run exec in separate thread.
                                // Note that lastIndex is not preserved when a RegExp is passed to a
                                // Web Worker.  Thus it needs to be passed back and forth separately.
                                var execWorker = thisInterpreter.createWorker();
                                var pid = thisInterpreter.regExpTimeout(regexp, execWorker, callback);
                                var thisPseudoRegExp = this;
                                execWorker.onmessage = function(e) {
                                    clearTimeout(pid);
                                    // Return tuple: [result, lastIndex]
                                    thisInterpreter.setProperty(thisPseudoRegExp, "lastIndex", e.data[1]);
                                    callback(matchToPseudo(e.data[0]));
                                };
                                execWorker.postMessage([
                                    "exec",
                                    regexp,
                                    regexp.lastIndex,
                                    string
                                ]);
                            }
                            return;
                        }
                        // Run exec natively.
                        var match = regexp.exec(string);
                        thisInterpreter.setProperty(this, "lastIndex", regexp.lastIndex);
                        callback(matchToPseudo(match));
                        function matchToPseudo(match) {
                            if (match) {
                                var result = thisInterpreter.arrayNativeToPseudo(match);
                                // match has additional properties.
                                thisInterpreter.setProperty(result, "index", match.index);
                                thisInterpreter.setProperty(result, "input", match.input);
                                return result;
                            }
                            return null;
                        }
                    };
                    this.setAsyncFunctionPrototype(this.REGEXP, "exec", wrapper);
                };
                /**
 * Initialize the Error class.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initError = function(globalObject) {
                    var thisInterpreter = this;
                    // Error constructor.
                    this.ERROR = this.createNativeFunction(function Error1(opt_message) {
                        if (thisInterpreter.calledWithNew()) // Called as `new Error()`.
                        var newError = this;
                        else // Called as `Error()`.
                        var newError = thisInterpreter.createObject(thisInterpreter.ERROR);
                        thisInterpreter.populateError(newError, opt_message);
                        return newError;
                    }, true);
                    this.setProperty(globalObject, "Error", this.ERROR, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.ERROR.properties["prototype"], "message", "", Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.ERROR.properties["prototype"], "name", "Error", Interpreter.NONENUMERABLE_DESCRIPTOR);
                    var createErrorSubclass = function(name) {
                        var constructor = thisInterpreter.createNativeFunction(function(opt_message) {
                            if (thisInterpreter.calledWithNew()) // Called as `new XyzError()`.
                            var newError = this;
                            else // Called as `XyzError()`.
                            var newError = thisInterpreter.createObject(constructor);
                            thisInterpreter.populateError(newError, opt_message);
                            return newError;
                        }, true);
                        thisInterpreter.setProperty(constructor, "prototype", thisInterpreter.createObject(thisInterpreter.ERROR), Interpreter.NONENUMERABLE_DESCRIPTOR);
                        thisInterpreter.setProperty(constructor.properties["prototype"], "name", name, Interpreter.NONENUMERABLE_DESCRIPTOR);
                        thisInterpreter.setProperty(globalObject, name, constructor, Interpreter.NONENUMERABLE_DESCRIPTOR);
                        return constructor;
                    };
                    this.EVAL_ERROR = createErrorSubclass("EvalError");
                    this.RANGE_ERROR = createErrorSubclass("RangeError");
                    this.REFERENCE_ERROR = createErrorSubclass("ReferenceError");
                    this.SYNTAX_ERROR = createErrorSubclass("SyntaxError");
                    this.TYPE_ERROR = createErrorSubclass("TypeError");
                    this.URI_ERROR = createErrorSubclass("URIError");
                };
                /**
 * Initialize Math object.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initMath = function(globalObject) {
                    var myMath = this.createObjectProto(this.OBJECT_PROTO);
                    this.setProperty(globalObject, "Math", myMath, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    var mathConsts = [
                        "E",
                        "LN2",
                        "LN10",
                        "LOG2E",
                        "LOG10E",
                        "PI",
                        "SQRT1_2",
                        "SQRT2"
                    ];
                    for(var i = 0; i < mathConsts.length; i++)this.setProperty(myMath, mathConsts[i], Math[mathConsts[i]], Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    var numFunctions = [
                        "abs",
                        "acos",
                        "asin",
                        "atan",
                        "atan2",
                        "ceil",
                        "cos",
                        "exp",
                        "floor",
                        "log",
                        "max",
                        "min",
                        "pow",
                        "random",
                        "round",
                        "sin",
                        "sqrt",
                        "tan"
                    ];
                    for(var i = 0; i < numFunctions.length; i++)this.setProperty(myMath, numFunctions[i], this.createNativeFunction(Math[numFunctions[i]], false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                };
                /**
 * Initialize JSON object.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initJSON = function(globalObject) {
                    var thisInterpreter = this;
                    var myJSON = thisInterpreter.createObjectProto(this.OBJECT_PROTO);
                    this.setProperty(globalObject, "JSON", myJSON, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    var wrapper = function parse(text) {
                        try {
                            var nativeObj = JSON.parse(String(text));
                        } catch (e) {
                            thisInterpreter.throwException(thisInterpreter.SYNTAX_ERROR, e.message);
                        }
                        return thisInterpreter.nativeToPseudo(nativeObj);
                    };
                    this.setProperty(myJSON, "parse", this.createNativeFunction(wrapper, false));
                    wrapper = function stringify(value, replacer, space) {
                        if (replacer && replacer.class === "Function") thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, "Function replacer on JSON.stringify not supported");
                        else if (replacer && replacer.class === "Array") {
                            replacer = thisInterpreter.arrayPseudoToNative(replacer);
                            replacer = replacer.filter(function(word) {
                                // Spec says we should also support boxed primitives here.
                                return typeof word === "string" || typeof word === "number";
                            });
                        } else replacer = null;
                        // Spec says we should also support boxed primitives here.
                        if (typeof space !== "string" && typeof space !== "number") space = undefined;
                        var nativeObj = thisInterpreter.pseudoToNative(value);
                        try {
                            var str = JSON.stringify(nativeObj, replacer, space);
                        } catch (e) {
                            thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, e.message);
                        }
                        return str;
                    };
                    this.setProperty(myJSON, "stringify", this.createNativeFunction(wrapper, false));
                };
                /**
 * Is an object of a certain class?
 * @param {Interpreter.Value} child Object to check.
 * @param {Interpreter.Object} constructor Constructor of object.
 * @return {boolean} True if object is the class or inherits from it.
 *     False otherwise.
 */ Interpreter.prototype.isa = function(child, constructor) {
                    if (child === null || child === undefined || !constructor) return false;
                    var proto = constructor.properties["prototype"];
                    if (child === proto) return true;
                    // The first step up the prototype chain is harder since the child might be
                    // a primitive value.  Subsequent steps can just follow the .proto property.
                    child = this.getPrototype(child);
                    while(child){
                        if (child === proto) return true;
                        child = child.proto;
                    }
                    return false;
                };
                /**
 * Initialize a pseudo regular expression object based on a native regular
 * expression object.
 * @param {!Interpreter.Object} pseudoRegexp The existing object to set.
 * @param {!RegExp} nativeRegexp The native regular expression.
 */ Interpreter.prototype.populateRegExp = function(pseudoRegexp, nativeRegexp) {
                    pseudoRegexp.data = new RegExp(nativeRegexp.source, nativeRegexp.flags);
                    // lastIndex is settable, all others are read-only attributes
                    this.setProperty(pseudoRegexp, "lastIndex", nativeRegexp.lastIndex, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(pseudoRegexp, "source", nativeRegexp.source, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(pseudoRegexp, "global", nativeRegexp.global, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(pseudoRegexp, "ignoreCase", nativeRegexp.ignoreCase, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(pseudoRegexp, "multiline", nativeRegexp.multiline, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                };
                /**
 * Initialize a pseudo error object.
 * @param {!Interpreter.Object} pseudoError The existing object to set.
 * @param {string=} opt_message Error's message.
 */ Interpreter.prototype.populateError = function(pseudoError, opt_message) {
                    if (opt_message) this.setProperty(pseudoError, "message", String(opt_message), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    var tracebackData = [];
                    for(var i = this.stateStack.length - 1; i >= 0; i--){
                        var state = this.stateStack[i];
                        var node = state.node;
                        if (node["type"] === "CallExpression") {
                            var func = state.func_;
                            if (func && tracebackData.length) tracebackData[tracebackData.length - 1].datumName = this.getProperty(func, "name");
                        }
                        if (node["loc"] && (!tracebackData.length || node["type"] === "CallExpression")) tracebackData.push({
                            datumLoc: node["loc"]
                        });
                    }
                    var errorName = String(this.getProperty(pseudoError, "name"));
                    var errorMessage = String(this.getProperty(pseudoError, "message"));
                    var stackString = errorName + ": " + errorMessage + "\n";
                    for(var i = 0; i < tracebackData.length; i++){
                        var loc = tracebackData[i].datumLoc;
                        var name = tracebackData[i].datumName;
                        var locString = loc["source"] + ":" + loc["start"]["line"] + ":" + loc["start"]["column"];
                        if (name) stackString += "  at " + name + " (" + locString + ")\n";
                        else stackString += "  at " + locString + "\n";
                    }
                    this.setProperty(pseudoError, "stack", stackString.trim(), Interpreter.NONENUMERABLE_DESCRIPTOR);
                };
                /**
 * Create a Web Worker to execute regular expressions.
 * Using a separate file fails in Chrome when run locally on a file:// URI.
 * Using a data encoded URI fails in IE and Edge.
 * Using a blob works in IE11 and all other browsers.
 * @return {!Worker} Web Worker with regexp execution code loaded.
 */ Interpreter.prototype.createWorker = function() {
                    var blob = this.createWorker.blob_;
                    if (!blob) {
                        blob = new Blob([
                            Interpreter.WORKER_CODE.join("\n")
                        ], {
                            type: "application/javascript"
                        });
                        // Cache the blob, so it doesn't need to be created next time.
                        this.createWorker.blob_ = blob;
                    }
                    return new Worker(URL.createObjectURL(blob));
                };
                /**
 * Execute regular expressions in a node vm.
 * @param {string} code Code to execute.
 * @param {!Object} sandbox Global variables for new vm.
 * @param {!RegExp} nativeRegExp Regular expression.
 * @param {!Function} callback Asynchronous callback function.
 */ Interpreter.prototype.vmCall = function(code, sandbox, nativeRegExp, callback) {
                    var options = {
                        "timeout": this["REGEXP_THREAD_TIMEOUT"]
                    };
                    try {
                        return Interpreter.vm["runInNewContext"](code, sandbox, options);
                    } catch (_e) {
                        callback(null);
                        this.throwException(this.ERROR, "RegExp Timeout: " + nativeRegExp);
                    }
                    return Interpreter.REGEXP_TIMEOUT;
                };
                /**
 * If REGEXP_MODE is 0, then throw an error.
 * Also throw if REGEXP_MODE is 2 and JS doesn't support Web Workers or vm.
 * @param {!RegExp} nativeRegExp Regular expression.
 * @param {!Function} callback Asynchronous callback function.
 */ Interpreter.prototype.maybeThrowRegExp = function(nativeRegExp, callback) {
                    var ok;
                    if (this["REGEXP_MODE"] === 0) // Fail: No RegExp support.
                    ok = false;
                    else if (this["REGEXP_MODE"] === 1) // Ok: Native RegExp support.
                    ok = true;
                    else {
                        // Sandboxed RegExp handling.
                        if (Interpreter.vm) // Ok: Node's vm module already loaded.
                        ok = true;
                        else if (typeof Worker === "function" && typeof URL === "function") // Ok: Web Workers available.
                        ok = true;
                        else {
                            // Try to load Node's vm module.
                            try {
                                Interpreter.vm = __webpack_require__(/*! vm */ "vm");
                            } catch (_e) {}
                            ok = !!Interpreter.vm;
                        }
                    }
                    if (!ok) {
                        callback(null);
                        this.throwException(this.ERROR, "Regular expressions not supported: " + nativeRegExp);
                    }
                };
                /**
 * Set a timeout for regular expression threads.  Unless cancelled, this will
 * terminate the thread and throw an error.
 * @param {!RegExp} nativeRegExp Regular expression (used for error message).
 * @param {!Worker} worker Thread to terminate.
 * @param {!Function} callback Async callback function to continue execution.
 * @return {number} PID of timeout.  Used to cancel if thread completes.
 */ Interpreter.prototype.regExpTimeout = function(nativeRegExp, worker, callback) {
                    var thisInterpreter = this;
                    return setTimeout(function() {
                        worker.terminate();
                        callback(null);
                        try {
                            thisInterpreter.throwException(thisInterpreter.ERROR, "RegExp Timeout: " + nativeRegExp);
                        } catch (_e) {
                        // Eat the expected Interpreter.STEP_ERROR.
                        }
                    }, this["REGEXP_THREAD_TIMEOUT"]);
                };
                /**
 * Create a new data object based on a constructor's prototype.
 * @param {Interpreter.Object} constructor Parent constructor function,
 *     or null if scope object.
 * @return {!Interpreter.Object} New data object.
 */ Interpreter.prototype.createObject = function(constructor) {
                    return this.createObjectProto(constructor && constructor.properties["prototype"]);
                };
                /**
 * Create a new data object based on a prototype.
 * @param {Interpreter.Object} proto Prototype object.
 * @return {!Interpreter.Object} New data object.
 */ Interpreter.prototype.createObjectProto = function(proto) {
                    if (typeof proto !== "object") throw Error("Non object prototype");
                    var obj = new Interpreter.Object(proto);
                    if (this.isa(obj, this.ERROR)) // Record this object as being an error so that its toString function can
                    // process it correctly (toString has no access to the interpreter and could
                    // not otherwise determine that the object is an error).
                    obj.class = "Error";
                    return obj;
                };
                /**
 * Create a new array.
 * @return {!Interpreter.Object} New array.
 */ Interpreter.prototype.createArray = function() {
                    var array = this.createObjectProto(this.ARRAY_PROTO);
                    // Arrays have length.
                    this.setProperty(array, "length", 0, {
                        configurable: false,
                        enumerable: false,
                        writable: true
                    });
                    array.class = "Array";
                    return array;
                };
                /**
 * Create a new function object (could become interpreted or native or async).
 * @param {number} argumentLength Number of arguments.
 * @param {boolean} isConstructor True if function can be used with 'new'.
 * @return {!Interpreter.Object} New function.
 * @private
 */ Interpreter.prototype.createFunctionBase_ = function(argumentLength, isConstructor) {
                    var func = this.createObjectProto(this.FUNCTION_PROTO);
                    if (isConstructor) {
                        var proto = this.createObjectProto(this.OBJECT_PROTO);
                        this.setProperty(func, "prototype", proto, Interpreter.NONENUMERABLE_DESCRIPTOR);
                        this.setProperty(proto, "constructor", func, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    } else func.illegalConstructor = true;
                    this.setProperty(func, "length", argumentLength, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    func.class = "Function";
                    // When making changes to this function, check to see if those changes also
                    // need to be made to the creation of FUNCTION_PROTO in initFunction.
                    return func;
                };
                /**
 * Create a new interpreted function.
 * @param {!Object} node AST node defining the function.
 * @param {!Interpreter.Scope} scope Parent scope.
 * @param {string=} opt_name Optional name for function.
 * @return {!Interpreter.Object} New function.
 */ Interpreter.prototype.createFunction = function(node, scope, opt_name) {
                    var func = this.createFunctionBase_(node["params"].length, true);
                    func.parentScope = scope;
                    func.node = node;
                    // Choose a name for this function.
                    // function foo() {}             -> 'foo'
                    // var bar = function() {};      -> 'bar'
                    // var bar = function foo() {};  -> 'foo'
                    // foo.bar = function() {};      -> ''
                    // var bar = new Function('');   -> 'anonymous'
                    var name = node["id"] ? String(node["id"]["name"]) : opt_name || "";
                    this.setProperty(func, "name", name, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    return func;
                };
                /**
 * Create a new native function.
 * @param {!Function} nativeFunc JavaScript function.
 * @param {boolean} isConstructor True if function can be used with 'new'.
 * @return {!Interpreter.Object} New function.
 */ Interpreter.prototype.createNativeFunction = function(nativeFunc, isConstructor) {
                    var func = this.createFunctionBase_(nativeFunc.length, isConstructor);
                    func.nativeFunc = nativeFunc;
                    nativeFunc.id = this.functionCounter_++;
                    this.setProperty(func, "name", nativeFunc.name, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    return func;
                };
                /**
 * Create a new native asynchronous function.
 * @param {!Function} asyncFunc JavaScript function.
 * @return {!Interpreter.Object} New function.
 */ Interpreter.prototype.createAsyncFunction = function(asyncFunc) {
                    var func = this.createFunctionBase_(asyncFunc.length, true);
                    func.asyncFunc = asyncFunc;
                    asyncFunc.id = this.functionCounter_++;
                    this.setProperty(func, "name", asyncFunc.name, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    return func;
                };
                /**
 * Converts from a native JavaScript object or value to a JS-Interpreter object.
 * Can handle JSON-style values, regular expressions, dates and functions.
 * Does NOT handle cycles.
 * @param {*} nativeObj The native JavaScript object to be converted.
 * @return {Interpreter.Value} The equivalent JS-Interpreter object.
 */ Interpreter.prototype.nativeToPseudo = function(nativeObj) {
                    if (nativeObj instanceof Interpreter.Object) throw Error("Object is already pseudo");
                    if (typeof nativeObj !== "object" && typeof nativeObj !== "function" || nativeObj === null) return nativeObj;
                    if (nativeObj instanceof RegExp) {
                        var pseudoRegexp = this.createObjectProto(this.REGEXP_PROTO);
                        this.populateRegExp(pseudoRegexp, nativeObj);
                        return pseudoRegexp;
                    }
                    if (nativeObj instanceof Date) {
                        var pseudoDate = this.createObjectProto(this.DATE_PROTO);
                        pseudoDate.data = new Date(nativeObj.valueOf());
                        return pseudoDate;
                    }
                    if (typeof nativeObj === "function") {
                        var thisInterpreter = this;
                        var wrapper = function() {
                            var args = Array.prototype.slice.call(arguments).map(function(i) {
                                return thisInterpreter.pseudoToNative(i);
                            });
                            var value = nativeObj.apply(thisInterpreter, args);
                            return thisInterpreter.nativeToPseudo(value);
                        };
                        var prototype = Object.getOwnPropertyDescriptor(nativeObj, "prototype");
                        return this.createNativeFunction(wrapper, !!prototype);
                    }
                    if (Array.isArray(nativeObj)) {
                        var pseudoArray = this.createArray();
                        for(var i = 0; i < nativeObj.length; i++)if (i in nativeObj) this.setProperty(pseudoArray, i, this.nativeToPseudo(nativeObj[i]));
                        return pseudoArray;
                    }
                    // Object.
                    var pseudoObj = this.createObjectProto(this.OBJECT_PROTO);
                    for(var key in nativeObj)this.setProperty(pseudoObj, key, this.nativeToPseudo(nativeObj[key]));
                    return pseudoObj;
                };
                /**
 * Converts from a JS-Interpreter object to native JavaScript object.
 * Can handle JSON-style values, regular expressions, and dates.
 * Does handle cycles.
 * @param {Interpreter.Value} pseudoObj The JS-Interpreter object to be
 * converted.
 * @param {Object=} opt_cycles Cycle detection (used in recursive calls).
 * @return {*} The equivalent native JavaScript object or value.
 */ Interpreter.prototype.pseudoToNative = function(pseudoObj, opt_cycles) {
                    if (typeof pseudoObj !== "object" && typeof pseudoObj !== "function" || pseudoObj === null) return pseudoObj;
                    if (!(pseudoObj instanceof Interpreter.Object)) throw Error("Object is not pseudo");
                    if (this.isa(pseudoObj, this.REGEXP)) {
                        var nativeRegExp = new RegExp(pseudoObj.data.source, pseudoObj.data.flags);
                        nativeRegExp.lastIndex = pseudoObj.data.lastIndex;
                        return nativeRegExp;
                    }
                    if (this.isa(pseudoObj, this.DATE)) return new Date(pseudoObj.data.valueOf());
                    var cycles = opt_cycles || {
                        pseudo: [],
                        native: []
                    };
                    var index = cycles.pseudo.indexOf(pseudoObj);
                    if (index !== -1) return cycles.native[index];
                    cycles.pseudo.push(pseudoObj);
                    var nativeObj;
                    if (this.isa(pseudoObj, this.ARRAY)) {
                        nativeObj = [];
                        cycles.native.push(nativeObj);
                        var len = this.getProperty(pseudoObj, "length");
                        for(var i = 0; i < len; i++)if (this.hasProperty(pseudoObj, i)) nativeObj[i] = this.pseudoToNative(this.getProperty(pseudoObj, i), cycles);
                    } else {
                        nativeObj = {};
                        cycles.native.push(nativeObj);
                        var val;
                        for(var key in pseudoObj.properties){
                            val = this.pseudoToNative(pseudoObj.properties[key], cycles);
                            // Use defineProperty to avoid side effects if setting '__proto__'.
                            Object.defineProperty(nativeObj, key, {
                                value: val,
                                writable: true,
                                enumerable: true,
                                configurable: true
                            });
                        }
                    }
                    cycles.pseudo.pop();
                    cycles.native.pop();
                    return nativeObj;
                };
                /**
 * Converts from a native JavaScript array to a JS-Interpreter array.
 * Does handle non-numeric properties (like str.match's index prop).
 * Does NOT recurse into the array's contents.
 * @param {!Array} nativeArray The JavaScript array to be converted.
 * @return {!Interpreter.Object} The equivalent JS-Interpreter array.
 */ Interpreter.prototype.arrayNativeToPseudo = function(nativeArray) {
                    var pseudoArray = this.createArray();
                    var props = Object.getOwnPropertyNames(nativeArray);
                    for(var i = 0; i < props.length; i++)this.setProperty(pseudoArray, props[i], nativeArray[props[i]]);
                    return pseudoArray;
                };
                /**
 * Converts from a JS-Interpreter array to native JavaScript array.
 * Does handle non-numeric properties (like str.match's index prop).
 * Does NOT recurse into the array's contents.
 * @param {!Interpreter.Object} pseudoArray The JS-Interpreter array,
 *     or JS-Interpreter object pretending to be an array.
 * @return {!Array} The equivalent native JavaScript array.
 */ Interpreter.prototype.arrayPseudoToNative = function(pseudoArray) {
                    var nativeArray = [];
                    for(var key in pseudoArray.properties)nativeArray[key] = this.getProperty(pseudoArray, key);
                    // pseudoArray might be an object pretending to be an array.  In this case
                    // it's possible that length is non-existent, invalid, or smaller than the
                    // largest defined numeric property.  Set length explicitly here.
                    nativeArray.length = Interpreter.legalArrayLength(this.getProperty(pseudoArray, "length")) || 0;
                    return nativeArray;
                };
                /**
 * Look up the prototype for this value.
 * @param {Interpreter.Value} value Data object.
 * @return {Interpreter.Object} Prototype object, null if none.
 */ Interpreter.prototype.getPrototype = function(value) {
                    switch(typeof value){
                        case "number":
                            return this.NUMBER.properties["prototype"];
                        case "boolean":
                            return this.BOOLEAN.properties["prototype"];
                        case "string":
                            return this.STRING.properties["prototype"];
                    }
                    if (value) return value.proto;
                    return null;
                };
                /**
 * Fetch a property value from a data object.
 * @param {Interpreter.Value} obj Data object.
 * @param {Interpreter.Value} name Name of property.
 * @return {Interpreter.Value} Property value (may be undefined).
 */ Interpreter.prototype.getProperty = function(obj, name) {
                    if (this.getterStep_) throw Error("Getter not supported in that context");
                    name = String(name);
                    if (obj === undefined || obj === null) this.throwException(this.TYPE_ERROR, "Cannot read property '" + name + "' of " + obj);
                    if (typeof obj === "object" && !(obj instanceof Interpreter.Object)) throw TypeError("Expecting native value or pseudo object");
                    if (name === "length") {
                        // Special cases for magic length property.
                        if (this.isa(obj, this.STRING)) return String(obj).length;
                    } else if (name.charCodeAt(0) < 0x40) // Might have numbers in there?
                    // Special cases for string array indexing
                    {
                        if (this.isa(obj, this.STRING)) {
                            var n = Interpreter.legalArrayIndex(name);
                            if (!isNaN(n) && n < String(obj).length) return String(obj)[n];
                        }
                    }
                    do if (obj.properties && name in obj.properties) {
                        var getter = obj.getter[name];
                        if (getter) {
                            // Flag this function as being a getter and thus needing immediate
                            // execution (rather than being the value of the property).
                            this.getterStep_ = true;
                            return getter;
                        }
                        return obj.properties[name];
                    }
                    while (obj = this.getPrototype(obj));
                    return undefined;
                };
                /**
 * Does the named property exist on a data object.
 * @param {!Interpreter.Object} obj Data object.
 * @param {Interpreter.Value} name Name of property.
 * @return {boolean} True if property exists.
 */ Interpreter.prototype.hasProperty = function(obj, name) {
                    if (!(obj instanceof Interpreter.Object)) throw TypeError("Primitive data type has no properties");
                    name = String(name);
                    if (name === "length" && this.isa(obj, this.STRING)) return true;
                    if (this.isa(obj, this.STRING)) {
                        var n = Interpreter.legalArrayIndex(name);
                        if (!isNaN(n) && n < String(obj).length) return true;
                    }
                    do {
                        if (obj.properties && name in obj.properties) return true;
                    }while (obj = this.getPrototype(obj));
                    return false;
                };
                /**
 * Set a property value on a data object.
 * @param {Interpreter.Value} obj Data object.
 * @param {Interpreter.Value} name Name of property.
 * @param {Interpreter.Value} value New property value.
 *     Use Interpreter.VALUE_IN_DESCRIPTOR if value is handled by
 *     descriptor instead.
 * @param {Object=} opt_descriptor Optional descriptor object.
 * @return {!Interpreter.Object|undefined} Returns a setter function if one
 *     needs to be called, otherwise undefined.
 */ Interpreter.prototype.setProperty = function(obj, name, value, opt_descriptor) {
                    if (this.setterStep_) // Getter from previous call to setProperty was not handled.
                    throw Error("Setter not supported in that context");
                    name = String(name);
                    if (obj === undefined || obj === null) this.throwException(this.TYPE_ERROR, "Cannot set property '" + name + "' of " + obj);
                    if (typeof obj === "object" && !(obj instanceof Interpreter.Object)) throw TypeError("Expecting native value or pseudo object");
                    if (opt_descriptor && ("get" in opt_descriptor || "set" in opt_descriptor) && ("value" in opt_descriptor || "writable" in opt_descriptor)) this.throwException(this.TYPE_ERROR, "Invalid property descriptor. Cannot both specify accessors and a value or writable attribute");
                    var strict = !this.stateStack || this.getScope().strict;
                    if (!(obj instanceof Interpreter.Object)) {
                        if (strict) this.throwException(this.TYPE_ERROR, "Can't create property '" + name + "' on '" + obj + "'");
                        return;
                    }
                    if (this.isa(obj, this.STRING)) {
                        var n = Interpreter.legalArrayIndex(name);
                        if (name === "length" || !isNaN(n) && n < String(obj).length) {
                            // Can't set length or letters on String objects.
                            if (strict) this.throwException(this.TYPE_ERROR, "Cannot assign to read only property '" + name + "' of String '" + obj.data + "'");
                            return;
                        }
                    }
                    if (obj.class === "Array") {
                        // Arrays have a magic length variable that is bound to the elements.
                        var len = obj.properties.length;
                        var i;
                        if (name === "length") {
                            // Delete elements if length is smaller.
                            if (opt_descriptor) {
                                if (!("value" in opt_descriptor)) return;
                                value = opt_descriptor.value;
                            }
                            value = Interpreter.legalArrayLength(value);
                            if (isNaN(value)) this.throwException(this.RANGE_ERROR, "Invalid array length");
                            if (value < len) for(i in obj.properties){
                                i = Interpreter.legalArrayIndex(i);
                                if (!isNaN(i) && value <= i) delete obj.properties[i];
                            }
                        } else if (!isNaN(i = Interpreter.legalArrayIndex(name))) // Increase length if this index is larger.
                        obj.properties.length = Math.max(len, i + 1);
                    }
                    if (obj.preventExtensions && !(name in obj.properties)) {
                        if (strict) this.throwException(this.TYPE_ERROR, "Can't add property '" + name + "', object is not extensible");
                        return;
                    }
                    if (opt_descriptor) {
                        // Define the property.
                        var descriptor = {};
                        if ("get" in opt_descriptor && opt_descriptor.get) {
                            obj.getter[name] = opt_descriptor.get;
                            descriptor.get = this.setProperty.placeholderGet_;
                        }
                        if ("set" in opt_descriptor && opt_descriptor.set) {
                            obj.setter[name] = opt_descriptor.set;
                            descriptor.set = this.setProperty.placeholderSet_;
                        }
                        if ("configurable" in opt_descriptor) descriptor.configurable = opt_descriptor.configurable;
                        if ("enumerable" in opt_descriptor) descriptor.enumerable = opt_descriptor.enumerable;
                        if ("writable" in opt_descriptor) {
                            descriptor.writable = opt_descriptor.writable;
                            delete obj.getter[name];
                            delete obj.setter[name];
                        }
                        if ("value" in opt_descriptor) {
                            descriptor.value = opt_descriptor.value;
                            delete obj.getter[name];
                            delete obj.setter[name];
                        } else if (value !== Interpreter.VALUE_IN_DESCRIPTOR) {
                            descriptor.value = value;
                            delete obj.getter[name];
                            delete obj.setter[name];
                        }
                        try {
                            Object.defineProperty(obj.properties, name, descriptor);
                        } catch (e) {
                            this.throwException(this.TYPE_ERROR, "Cannot redefine property: " + name);
                        }
                        // Now that the definition has suceeded, clean up any obsolete get/set funcs.
                        if ("get" in opt_descriptor && !opt_descriptor.get) delete obj.getter[name];
                        if ("set" in opt_descriptor && !opt_descriptor.set) delete obj.setter[name];
                    } else {
                        // Set the property.
                        if (value === Interpreter.VALUE_IN_DESCRIPTOR) throw ReferenceError("Value not specified");
                        // Determine the parent (possibly self) where the property is defined.
                        var defObj = obj;
                        while(!(name in defObj.properties)){
                            defObj = this.getPrototype(defObj);
                            if (!defObj) {
                                // This is a new property.
                                defObj = obj;
                                break;
                            }
                        }
                        if (defObj.setter && defObj.setter[name]) {
                            this.setterStep_ = true;
                            return defObj.setter[name];
                        }
                        if (defObj.getter && defObj.getter[name]) {
                            if (strict) this.throwException(this.TYPE_ERROR, "Cannot set property '" + name + "' of object '" + obj + "' which only has a getter");
                        } else // No setter, simple assignment.
                        try {
                            obj.properties[name] = value;
                        } catch (_e) {
                            if (strict) this.throwException(this.TYPE_ERROR, "Cannot assign to read only property '" + name + "' of object '" + obj + "'");
                        }
                    }
                };
                Interpreter.prototype.setProperty.placeholderGet_ = function() {
                    throw Error("Placeholder getter");
                };
                Interpreter.prototype.setProperty.placeholderSet_ = function() {
                    throw Error("Placeholder setter");
                };
                /**
 * Convenience method for adding a native function as a non-enumerable property
 * onto an object's prototype.
 * @param {!Interpreter.Object} obj Data object.
 * @param {Interpreter.Value} name Name of property.
 * @param {!Function} wrapper Function object.
 */ Interpreter.prototype.setNativeFunctionPrototype = function(obj, name, wrapper) {
                    this.setProperty(obj.properties["prototype"], name, this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                };
                /**
 * Convenience method for adding an async function as a non-enumerable property
 * onto an object's prototype.
 * @param {!Interpreter.Object} obj Data object.
 * @param {Interpreter.Value} name Name of property.
 * @param {!Function} wrapper Function object.
 */ Interpreter.prototype.setAsyncFunctionPrototype = function(obj, name, wrapper) {
                    this.setProperty(obj.properties["prototype"], name, this.createAsyncFunction(wrapper), Interpreter.NONENUMERABLE_DESCRIPTOR);
                };
                /**
 * Returns the current scope from the stateStack.
 * @return {!Interpreter.Scope} Current scope.
 */ Interpreter.prototype.getScope = function() {
                    var scope = this.stateStack[this.stateStack.length - 1].scope;
                    if (!scope) throw Error("No scope found");
                    return scope;
                };
                /**
 * Create a new scope dictionary.
 * @param {!Object} node AST node defining the scope container
 *     (e.g. a function).
 * @param {Interpreter.Scope} parentScope Scope to link to.
 * @return {!Interpreter.Scope} New scope.
 */ Interpreter.prototype.createScope = function(node, parentScope) {
                    // Determine if this scope starts with `use strict`.
                    var strict = false;
                    if (parentScope && parentScope.strict) strict = true;
                    else {
                        var firstNode = node["body"] && node["body"][0];
                        if (firstNode && firstNode.expression && firstNode.expression["type"] === "Literal" && firstNode.expression.value === "use strict") strict = true;
                    }
                    var object = this.createObjectProto(null);
                    var scope = new Interpreter.Scope(parentScope, strict, object);
                    if (!parentScope) this.initGlobal(scope.object);
                    this.populateScope_(node, scope);
                    return scope;
                };
                /**
 * Create a new special scope dictionary. Similar to createScope(), but
 * doesn't assume that the scope is for a function body.
 * This is used for 'catch' clauses and 'with' statements.
 * @param {!Interpreter.Scope} parentScope Scope to link to.
 * @param {Interpreter.Object=} opt_object Optional object to transform into
 *     scope.
 * @return {!Interpreter.Scope} New scope.
 */ Interpreter.prototype.createSpecialScope = function(parentScope, opt_object) {
                    if (!parentScope) throw Error("parentScope required");
                    var object = opt_object || this.createObjectProto(null);
                    return new Interpreter.Scope(parentScope, parentScope.strict, object);
                };
                /**
 * Retrieves a value from the scope chain.
 * @param {string} name Name of variable.
 * @return {Interpreter.Value} Any value.
 *   May be flagged as being a getter and thus needing immediate execution
 *   (rather than being the value of the property).
 */ Interpreter.prototype.getValueFromScope = function(name) {
                    var scope = this.getScope();
                    while(scope && scope !== this.globalScope){
                        if (name in scope.object.properties) return scope.object.properties[name];
                        scope = scope.parentScope;
                    }
                    // The root scope is also an object which has inherited properties and
                    // could also have getters.
                    if (scope === this.globalScope && this.hasProperty(scope.object, name)) return this.getProperty(scope.object, name);
                    // Typeof operator is unique: it can safely look at non-defined variables.
                    var prevNode = this.stateStack[this.stateStack.length - 1].node;
                    if (prevNode["type"] === "UnaryExpression" && prevNode["operator"] === "typeof") return undefined;
                    this.throwException(this.REFERENCE_ERROR, name + " is not defined");
                };
                /**
 * Sets a value to the current scope.
 * @param {string} name Name of variable.
 * @param {Interpreter.Value} value Value.
 * @return {!Interpreter.Object|undefined} Returns a setter function if one
 *     needs to be called, otherwise undefined.
 */ Interpreter.prototype.setValueToScope = function(name, value) {
                    var scope = this.getScope();
                    var strict = scope.strict;
                    while(scope && scope !== this.globalScope){
                        if (name in scope.object.properties) {
                            scope.object.properties[name] = value;
                            return undefined;
                        }
                        scope = scope.parentScope;
                    }
                    // The root scope is also an object which has readonly properties and
                    // could also have setters.
                    if (scope === this.globalScope && (!strict || this.hasProperty(scope.object, name))) return this.setProperty(scope.object, name, value);
                    this.throwException(this.REFERENCE_ERROR, name + " is not defined");
                };
                /**
 * Create a new scope for the given node and populate it with all variables
 * and named functions.
 * @param {!Object} node AST node (usually a program or function when initally
 *   calling this function, though it recurses to scan many child nodes).
 * @param {!Interpreter.Scope} scope Scope dictionary to populate.
 * @return {!Object} Map of all variable and function names.
 * @private
 */ Interpreter.prototype.populateScope_ = function(node, scope) {
                    var variableCache;
                    if (!node.variableCache_) {
                        variableCache = Object.create(null);
                        switch(node["type"]){
                            case "VariableDeclaration":
                                for(var i = 0; i < node["declarations"].length; i++)variableCache[node["declarations"][i]["id"]["name"]] = true;
                                break;
                            case "FunctionDeclaration":
                                variableCache[node["id"]["name"]] = node;
                                break;
                            case "BlockStatement":
                            case "CatchClause":
                            case "DoWhileStatement":
                            case "ForInStatement":
                            case "ForStatement":
                            case "IfStatement":
                            case "LabeledStatement":
                            case "Program":
                            case "SwitchCase":
                            case "SwitchStatement":
                            case "TryStatement":
                            case "WithStatement":
                            case "WhileStatement":
                                // All the structures within which a variable or function could hide.
                                var nodeClass = node["constructor"];
                                for(var name in node){
                                    if (name === "loc") continue;
                                    var prop = node[name];
                                    if (prop && typeof prop === "object") {
                                        var childCache;
                                        if (Array.isArray(prop)) {
                                            for(var i = 0; i < prop.length; i++)if (prop[i] && prop[i].constructor === nodeClass) {
                                                childCache = this.populateScope_(prop[i], scope);
                                                for(var name in childCache)variableCache[name] = childCache[name];
                                            }
                                        } else if (prop.constructor === nodeClass) {
                                            childCache = this.populateScope_(prop, scope);
                                            for(var name in childCache)variableCache[name] = childCache[name];
                                        }
                                    }
                                }
                        }
                        node.variableCache_ = variableCache;
                    } else variableCache = node.variableCache_;
                    for(var name in variableCache)if (variableCache[name] === true) this.setProperty(scope.object, name, undefined, Interpreter.VARIABLE_DESCRIPTOR);
                    else this.setProperty(scope.object, name, this.createFunction(variableCache[name], scope), Interpreter.VARIABLE_DESCRIPTOR);
                    return variableCache;
                };
                /**
 * Is the current state directly being called with as a construction with 'new'.
 * @return {boolean} True if 'new foo()', false if 'foo()'.
 */ Interpreter.prototype.calledWithNew = function() {
                    return this.stateStack[this.stateStack.length - 1].isConstructor;
                };
                /**
 * Gets a value from the scope chain or from an object property.
 * @param {!Array} ref Name of variable or object/propname tuple.
 * @return {Interpreter.Value} Any value.
 *   May be flagged as being a getter and thus needing immediate execution
 *   (rather than being the value of the property).
 */ Interpreter.prototype.getValue = function(ref) {
                    if (ref[0] === Interpreter.SCOPE_REFERENCE) // A null/varname variable lookup.
                    return this.getValueFromScope(ref[1]);
                    else // An obj/prop components tuple (foo.bar).
                    return this.getProperty(ref[0], ref[1]);
                };
                /**
 * Sets a value to the scope chain or to an object property.
 * @param {!Array} ref Name of variable or object/propname tuple.
 * @param {Interpreter.Value} value Value.
 * @return {!Interpreter.Object|undefined} Returns a setter function if one
 *     needs to be called, otherwise undefined.
 */ Interpreter.prototype.setValue = function(ref, value) {
                    if (ref[0] === Interpreter.SCOPE_REFERENCE) // A null/varname variable lookup.
                    return this.setValueToScope(ref[1], value);
                    else // An obj/prop components tuple (foo.bar).
                    return this.setProperty(ref[0], ref[1], value);
                };
                /**
 * Throw an exception in the interpreter that can be handled by an
 * interpreter try/catch statement.  If unhandled, a real exception will
 * be thrown.  Can be called with either an error class and a message, or
 * with an actual object to be thrown.
 * @param {!Interpreter.Object|Interpreter.Value} errorClass Type of error
 *   (if message is provided) or the value to throw (if no message).
 * @param {string=} opt_message Message being thrown.
 */ Interpreter.prototype.throwException = function(errorClass, opt_message) {
                    if (!this.globalScope) // This is an error being thrown in the initialization, throw a real error.
                    throw opt_message === undefined ? errorClass : opt_message;
                    if (opt_message === undefined) var error = errorClass; // This is a value to throw, not an error class.
                    else {
                        var error = this.createObject(errorClass);
                        this.populateError(error, opt_message);
                    }
                    this.unwind(Interpreter.Completion.THROW, error, undefined);
                    // Abort anything related to the current step.
                    throw Interpreter.STEP_ERROR;
                };
                /**
 * Unwind the stack to the innermost relevant enclosing TryStatement,
 * For/ForIn/WhileStatement or Call/NewExpression.  If this results in
 * the stack being completely unwound the thread will be terminated
 * and the appropriate error being thrown.
 * @param {Interpreter.Completion} type Completion type.
 * @param {Interpreter.Value} value Value computed, returned or thrown.
 * @param {string|undefined} label Target label for break or return.
 */ Interpreter.prototype.unwind = function(type, value, label) {
                    if (type === Interpreter.Completion.NORMAL) throw TypeError("Should not unwind for NORMAL completions");
                    loop: for(var stack = this.stateStack; stack.length > 0; stack.pop()){
                        var state = stack[stack.length - 1];
                        switch(state.node["type"]){
                            case "TryStatement":
                                state.cv = {
                                    type: type,
                                    value: value,
                                    label: label
                                };
                                return;
                            case "CallExpression":
                            case "NewExpression":
                                if (type === Interpreter.Completion.RETURN) {
                                    state.value = value;
                                    return;
                                } else if (type !== Interpreter.Completion.THROW) throw Error("Unsynatctic break/continue not rejected by Acorn");
                                break;
                            case "Program":
                                // Don't pop the stateStack.
                                // Leave the root scope on the tree in case the program is appended to.
                                state.done = true;
                                break loop;
                        }
                        if (type === Interpreter.Completion.BREAK) {
                            if (label ? state.labels && state.labels.indexOf(label) !== -1 : state.isLoop || state.isSwitch) {
                                stack.pop();
                                return;
                            }
                        } else if (type === Interpreter.Completion.CONTINUE) {
                            if (label ? state.labels && state.labels.indexOf(label) !== -1 : state.isLoop) return;
                        }
                    }
                    // Unhandled completion.  Throw a real error.
                    var realError;
                    if (this.isa(value, this.ERROR)) {
                        var errorTable = {
                            "EvalError": EvalError,
                            "RangeError": RangeError,
                            "ReferenceError": ReferenceError,
                            "SyntaxError": SyntaxError,
                            "TypeError": TypeError,
                            "URIError": URIError
                        };
                        var name = String(this.getProperty(value, "name"));
                        var message = this.getProperty(value, "message").valueOf();
                        var errorConstructor = errorTable[name] || Error;
                        realError = errorConstructor(message);
                        realError.stack = String(this.getProperty(value, "stack"));
                    } else realError = String(value);
                    throw realError;
                };
                /**
 * Create a call to a getter function.
 * @param {!Interpreter.Object} func Function to execute.
 * @param {!Interpreter.Object|!Array} left
 *     Name of variable or object/propname tuple.
 * @private
 */ Interpreter.prototype.createGetter_ = function(func, left) {
                    if (!this.getterStep_) throw Error("Unexpected call to createGetter");
                    // Clear the getter flag.
                    this.getterStep_ = false;
                    // Normally `this` will be specified as the object component (o.x).
                    // Sometimes `this` is explicitly provided (o).
                    var funcThis = Array.isArray(left) ? left[0] : left;
                    var node = new this.newNode();
                    node["type"] = "CallExpression";
                    var state = new Interpreter.State(node, this.stateStack[this.stateStack.length - 1].scope);
                    state.doneCallee_ = 2;
                    state.funcThis_ = funcThis;
                    state.func_ = func;
                    state.doneArgs_ = true;
                    state.arguments_ = [];
                    return state;
                };
                /**
 * Create a call to a setter function.
 * @param {!Interpreter.Object} func Function to execute.
 * @param {!Interpreter.Object|!Array} left
 *     Name of variable or object/propname tuple.
 * @param {Interpreter.Value} value Value to set.
 * @private
 */ Interpreter.prototype.createSetter_ = function(func, left, value) {
                    if (!this.setterStep_) throw Error("Unexpected call to createSetter");
                    // Clear the setter flag.
                    this.setterStep_ = false;
                    // Normally `this` will be specified as the object component (o.x).
                    // Sometimes `this` is implicitly the global object (x).
                    var funcThis = Array.isArray(left) ? left[0] : this.globalObject;
                    var node = new this.newNode();
                    node["type"] = "CallExpression";
                    var state = new Interpreter.State(node, this.stateStack[this.stateStack.length - 1].scope);
                    state.doneCallee_ = 2;
                    state.funcThis_ = funcThis;
                    state.func_ = func;
                    state.doneArgs_ = true;
                    state.arguments_ = [
                        value
                    ];
                    return state;
                };
                /**
 * In non-strict mode `this` must be an object.
 * Must not be called in strict mode.
 * @param {Interpreter.Value} value Proposed value for `this`.
 * @return {!Interpreter.Object} Final value for `this`.
 * @private
 */ Interpreter.prototype.boxThis_ = function(value) {
                    if (value === undefined || value === null) // `Undefined` and `null` are changed to the global object.
                    return this.globalObject;
                    if (!(value instanceof Interpreter.Object)) {
                        // Primitives must be boxed.
                        var box = this.createObjectProto(this.getPrototype(value));
                        box.data = value;
                        return box;
                    }
                    return value;
                };
                /**
 * Return the global scope object.
 * @return {!Interpreter.Scope} Scope object.
 */ Interpreter.prototype.getGlobalScope = function() {
                    return this.globalScope;
                };
                /**
 * Return the state stack.
 * @return {!Array<!Interpreter.State>} State stack.
 */ Interpreter.prototype.getStateStack = function() {
                    return this.stateStack;
                };
                /**
 * Replace the state stack with a new one.
 * @param {!Array<!Interpreter.State>} newStack New state stack.
 */ Interpreter.prototype.setStateStack = function(newStack) {
                    this.stateStack = newStack;
                };
                /**
 * Typedef for JS values.
 * @typedef {!Interpreter.Object|boolean|number|string|undefined|null}
 */ Interpreter.Value;
                /**
 * Class for a state.
 * @param {!Object} node AST node for the state.
 * @param {!Interpreter.Scope} scope Scope object for the state.
 * @constructor
 */ Interpreter.State = function(node, scope) {
                    this.node = node;
                    this.scope = scope;
                };
                /**
 * Class for a scope.
 * @param {Interpreter.Scope} parentScope Parent scope.
 * @param {boolean} strict True if "use strict".
 * @param {!Interpreter.Object} object Object containing scope's variables.
 * @struct
 * @constructor
 */ Interpreter.Scope = function(parentScope, strict, object) {
                    this.parentScope = parentScope;
                    this.strict = strict;
                    this.object = object;
                };
                /**
 * Class for an object.
 * @param {Interpreter.Object} proto Prototype object or null.
 * @constructor
 */ Interpreter.Object = function(proto) {
                    this.getter = Object.create(null);
                    this.setter = Object.create(null);
                    this.properties = Object.create(null);
                    this.proto = proto;
                };
                /** @type {Interpreter.Object} */ Interpreter.Object.prototype.proto = null;
                /** @type {string} */ Interpreter.Object.prototype.class = "Object";
                /** @type {Date|RegExp|boolean|number|string|null} */ Interpreter.Object.prototype.data = null;
                /**
 * Convert this object into a string.
 * @return {string} String value.
 * @override
 */ Interpreter.Object.prototype.toString = function() {
                    if (!Interpreter.currentInterpreter_) // Called from outside an interpreter.
                    return "[object Interpreter.Object]";
                    if (!(this instanceof Interpreter.Object)) // Primitive value.
                    return String(this);
                    if (this.class === "Array") {
                        // Array contents must not have cycles.
                        var cycles = Interpreter.toStringCycles_;
                        cycles.push(this);
                        try {
                            var strs = [];
                            // Truncate very long strings.  This is not part of the spec,
                            // but it prevents hanging the interpreter for gigantic arrays.
                            var maxLength = this.properties.length;
                            var truncated = false;
                            if (maxLength > 1024) {
                                maxLength = 1000;
                                truncated = true;
                            }
                            for(var i = 0; i < maxLength; i++){
                                var value = this.properties[i];
                                strs[i] = value instanceof Interpreter.Object && cycles.indexOf(value) !== -1 ? "..." : value;
                            }
                            if (truncated) strs.push("...");
                        } finally{
                            cycles.pop();
                        }
                        return strs.join(",");
                    }
                    if (this.class === "Error") {
                        // Error name and message properties must not have cycles.
                        var cycles = Interpreter.toStringCycles_;
                        if (cycles.indexOf(this) !== -1) return "[object Error]";
                        var name, message;
                        // Bug: Does not support getters and setters for name or message.
                        var obj = this;
                        do if ("name" in obj.properties) {
                            name = obj.properties["name"];
                            break;
                        }
                        while (obj = obj.proto);
                        obj = this;
                        do if ("message" in obj.properties) {
                            message = obj.properties["message"];
                            break;
                        }
                        while (obj = obj.proto);
                        cycles.push(this);
                        try {
                            name = name && String(name);
                            message = message && String(message);
                        } finally{
                            cycles.pop();
                        }
                        return message ? name + ": " + message : String(name);
                    }
                    if (this.data !== null) // RegExp, Date, and boxed primitives.
                    return String(this.data);
                    return "[object " + this.class + "]";
                };
                /**
 * Return the object's value.
 * @return {Interpreter.Value} Value.
 * @override
 */ Interpreter.Object.prototype.valueOf = function() {
                    var callingInterpreter = Interpreter.currentInterpreter_;
                    if (!callingInterpreter) // Called from outside an interpreter.
                    return this;
                    if (this.data === undefined || this.data === null || this.data instanceof RegExp) return this; // An Object, RegExp, or primitive.
                    if (this.data instanceof Date) return this.data.valueOf(); // Milliseconds.
                    return /** @type {(boolean|number|string)} */ this.data; // Boxed primitive.
                };
                ///////////////////////////////////////////////////////////////////////////////
                // Functions to handle each node type.
                ///////////////////////////////////////////////////////////////////////////////
                Interpreter.prototype["stepArrayExpression"] = function(stack, state, node) {
                    var elements = node["elements"];
                    var n = state.n_ || 0;
                    if (!state.array_) {
                        state.array_ = this.createArray();
                        state.array_.properties.length = elements.length;
                    } else {
                        this.setProperty(state.array_, n, state.value);
                        n++;
                    }
                    while(n < elements.length){
                        // Skip missing elements - they're not defined, not undefined.
                        if (elements[n]) {
                            state.n_ = n;
                            return new Interpreter.State(elements[n], state.scope);
                        }
                        n++;
                    }
                    stack.pop();
                    stack[stack.length - 1].value = state.array_;
                };
                Interpreter.prototype["stepAssignmentExpression"] = function(stack, state, node) {
                    if (!state.doneLeft_) {
                        state.doneLeft_ = true;
                        var nextState = new Interpreter.State(node["left"], state.scope);
                        nextState.components = true;
                        return nextState;
                    }
                    if (!state.doneRight_) {
                        if (!state.leftReference_) state.leftReference_ = state.value;
                        if (state.doneGetter_) state.leftValue_ = state.value;
                        if (!state.doneGetter_ && node["operator"] !== "=") {
                            var leftValue = this.getValue(state.leftReference_);
                            state.leftValue_ = leftValue;
                            if (this.getterStep_) {
                                // Call the getter function.
                                state.doneGetter_ = true;
                                var func = /** @type {!Interpreter.Object} */ leftValue;
                                return this.createGetter_(func, state.leftReference_);
                            }
                        }
                        state.doneRight_ = true;
                        // When assigning an unnamed function to a variable, the function's name
                        // is set to the variable name.  Record the variable name in case the
                        // right side is a functionExpression.
                        // E.g. foo = function() {};
                        if (node["operator"] === "=" && node["left"]["type"] === "Identifier") state.destinationName = node["left"]["name"];
                        return new Interpreter.State(node["right"], state.scope);
                    }
                    if (state.doneSetter_) {
                        // Return if setter function.
                        // Setter method on property has completed.
                        // Ignore its return value, and use the original set value instead.
                        stack.pop();
                        stack[stack.length - 1].value = state.setterValue_;
                        return;
                    }
                    var value = state.leftValue_;
                    var rightValue = state.value;
                    switch(node["operator"]){
                        case "=":
                            value = rightValue;
                            break;
                        case "+=":
                            value += rightValue;
                            break;
                        case "-=":
                            value -= rightValue;
                            break;
                        case "*=":
                            value *= rightValue;
                            break;
                        case "/=":
                            value /= rightValue;
                            break;
                        case "%=":
                            value %= rightValue;
                            break;
                        case "<<=":
                            value <<= rightValue;
                            break;
                        case ">>=":
                            value >>= rightValue;
                            break;
                        case ">>>=":
                            value >>>= rightValue;
                            break;
                        case "&=":
                            value &= rightValue;
                            break;
                        case "^=":
                            value ^= rightValue;
                            break;
                        case "|=":
                            value |= rightValue;
                            break;
                        default:
                            throw SyntaxError("Unknown assignment expression: " + node["operator"]);
                    }
                    var setter = this.setValue(state.leftReference_, value);
                    if (setter) {
                        state.doneSetter_ = true;
                        state.setterValue_ = value;
                        return this.createSetter_(setter, state.leftReference_, value);
                    }
                    // Return if no setter function.
                    stack.pop();
                    stack[stack.length - 1].value = value;
                };
                Interpreter.prototype["stepBinaryExpression"] = function(stack, state, node) {
                    if (!state.doneLeft_) {
                        state.doneLeft_ = true;
                        return new Interpreter.State(node["left"], state.scope);
                    }
                    if (!state.doneRight_) {
                        state.doneRight_ = true;
                        state.leftValue_ = state.value;
                        return new Interpreter.State(node["right"], state.scope);
                    }
                    stack.pop();
                    var leftValue = state.leftValue_;
                    var rightValue = state.value;
                    var value;
                    switch(node["operator"]){
                        case "==":
                            value = leftValue == rightValue;
                            break;
                        case "!=":
                            value = leftValue != rightValue;
                            break;
                        case "===":
                            value = leftValue === rightValue;
                            break;
                        case "!==":
                            value = leftValue !== rightValue;
                            break;
                        case ">":
                            value = leftValue > rightValue;
                            break;
                        case ">=":
                            value = leftValue >= rightValue;
                            break;
                        case "<":
                            value = leftValue < rightValue;
                            break;
                        case "<=":
                            value = leftValue <= rightValue;
                            break;
                        case "+":
                            value = leftValue + rightValue;
                            break;
                        case "-":
                            value = leftValue - rightValue;
                            break;
                        case "*":
                            value = leftValue * rightValue;
                            break;
                        case "/":
                            value = leftValue / rightValue;
                            break;
                        case "%":
                            value = leftValue % rightValue;
                            break;
                        case "&":
                            value = leftValue & rightValue;
                            break;
                        case "|":
                            value = leftValue | rightValue;
                            break;
                        case "^":
                            value = leftValue ^ rightValue;
                            break;
                        case "<<":
                            value = leftValue << rightValue;
                            break;
                        case ">>":
                            value = leftValue >> rightValue;
                            break;
                        case ">>>":
                            value = leftValue >>> rightValue;
                            break;
                        case "in":
                            if (!(rightValue instanceof Interpreter.Object)) this.throwException(this.TYPE_ERROR, "'in' expects an object, not '" + rightValue + "'");
                            value = this.hasProperty(rightValue, leftValue);
                            break;
                        case "instanceof":
                            if (!this.isa(rightValue, this.FUNCTION)) this.throwException(this.TYPE_ERROR, "Right-hand side of instanceof is not an object");
                            value = leftValue instanceof Interpreter.Object ? this.isa(leftValue, rightValue) : false;
                            break;
                        default:
                            throw SyntaxError("Unknown binary operator: " + node["operator"]);
                    }
                    stack[stack.length - 1].value = value;
                };
                Interpreter.prototype["stepBlockStatement"] = function(stack, state, node) {
                    var n = state.n_ || 0;
                    var expression = node["body"][n];
                    if (expression) {
                        state.n_ = n + 1;
                        return new Interpreter.State(expression, state.scope);
                    }
                    stack.pop();
                };
                Interpreter.prototype["stepBreakStatement"] = function(stack, state, node) {
                    var label = node["label"] && node["label"]["name"];
                    this.unwind(Interpreter.Completion.BREAK, undefined, label);
                };
                /**
 * Number of evals called by the interpreter.
 * @private
 */ Interpreter.prototype.evalCodeNumber_ = 0;
                Interpreter.prototype["stepCallExpression"] = function(stack, state, node) {
                    // Handles both CallExpression and NewExpression.
                    if (!state.doneCallee_) {
                        state.doneCallee_ = 1;
                        // Components needed to determine value of `this`.
                        var nextState = new Interpreter.State(node["callee"], state.scope);
                        nextState.components = true;
                        return nextState;
                    }
                    if (state.doneCallee_ === 1) {
                        // Determine value of the function.
                        state.doneCallee_ = 2;
                        var func = state.value;
                        if (Array.isArray(func)) {
                            state.func_ = this.getValue(func);
                            if (func[0] === Interpreter.SCOPE_REFERENCE) // (Globally or locally) named function.  Is it named 'eval'?
                            state.directEval_ = func[1] === "eval";
                            else // Method function, `this` is object (ignored if invoked as `new`).
                            state.funcThis_ = func[0];
                            func = state.func_;
                            if (this.getterStep_) {
                                // Call the getter function.
                                state.doneCallee_ = 1;
                                return this.createGetter_(/** @type {!Interpreter.Object} */ func, state.value);
                            }
                        } else // Already evaluated function: (function(){...})();
                        state.func_ = func;
                        state.arguments_ = [];
                        state.n_ = 0;
                    }
                    var func = state.func_;
                    if (!state.doneArgs_) {
                        if (state.n_ !== 0) state.arguments_.push(state.value);
                        if (node["arguments"][state.n_]) return new Interpreter.State(node["arguments"][state.n_++], state.scope);
                        // Determine value of `this` in function.
                        if (node["type"] === "NewExpression") {
                            if (!(func instanceof Interpreter.Object) || func.illegalConstructor) // Illegal: new escape();
                            this.throwException(this.TYPE_ERROR, func + " is not a constructor");
                            // Constructor, `this` is new object.
                            if (func === this.ARRAY) state.funcThis_ = this.createArray();
                            else {
                                var proto = func.properties["prototype"];
                                if (typeof proto !== "object" || proto === null) // Non-object prototypes default to `Object.prototype`.
                                proto = this.OBJECT_PROTO;
                                state.funcThis_ = this.createObjectProto(proto);
                            }
                            state.isConstructor = true;
                        }
                        state.doneArgs_ = true;
                    }
                    if (!state.doneExec_) {
                        state.doneExec_ = true;
                        if (!(func instanceof Interpreter.Object)) this.throwException(this.TYPE_ERROR, func + " is not a function");
                        var funcNode = func.node;
                        if (funcNode) {
                            var scope = this.createScope(funcNode["body"], func.parentScope);
                            // Add all arguments.
                            for(var i = 0; i < funcNode["params"].length; i++){
                                var paramName = funcNode["params"][i]["name"];
                                var paramValue = state.arguments_.length > i ? state.arguments_[i] : undefined;
                                this.setProperty(scope.object, paramName, paramValue);
                            }
                            // Build arguments variable.
                            var argsList = this.createArray();
                            for(var i = 0; i < state.arguments_.length; i++)this.setProperty(argsList, i, state.arguments_[i]);
                            this.setProperty(scope.object, "arguments", argsList);
                            // Add the function's name (var x = function foo(){};)
                            var name = funcNode["id"] && funcNode["id"]["name"];
                            if (name) this.setProperty(scope.object, name, func);
                            if (!scope.strict) state.funcThis_ = this.boxThis_(state.funcThis_);
                            this.setProperty(scope.object, "this", state.funcThis_, Interpreter.READONLY_DESCRIPTOR);
                            state.value = undefined; // Default value if no explicit return.
                            return new Interpreter.State(funcNode["body"], scope);
                        } else if (func.eval) {
                            var code = state.arguments_[0];
                            if (typeof code !== "string") // JS does not parse String objects:
                            // eval(new String('1 + 1')) -> '1 + 1'
                            state.value = code;
                            else {
                                try {
                                    var ast = this.parse_(String(code), "eval" + this.evalCodeNumber_++);
                                } catch (e) {
                                    // Acorn threw a SyntaxError.  Rethrow as a trappable error.
                                    this.throwException(this.SYNTAX_ERROR, "Invalid code: " + e.message);
                                }
                                var evalNode = new this.newNode();
                                evalNode["type"] = "EvalProgram_";
                                evalNode["body"] = ast["body"];
                                Interpreter.stripLocations_(evalNode, node["start"], node["end"]);
                                // Create new scope and update it with definitions in eval().
                                var scope = state.directEval_ ? state.scope : this.globalScope;
                                if (scope.strict) // Strict mode get its own scope in eval.
                                scope = this.createScope(ast, scope);
                                else // Non-strict mode pollutes the current scope.
                                this.populateScope_(ast, scope);
                                this.value = undefined; // Default value if no code.
                                return new Interpreter.State(evalNode, scope);
                            }
                        } else if (func.nativeFunc) {
                            if (!state.scope.strict) state.funcThis_ = this.boxThis_(state.funcThis_);
                            state.value = func.nativeFunc.apply(state.funcThis_, state.arguments_);
                        } else if (func.asyncFunc) {
                            var thisInterpreter = this;
                            var callback = function(value) {
                                state.value = value;
                                thisInterpreter.paused_ = false;
                            };
                            // Force the argument lengths to match, then append the callback.
                            var argLength = func.asyncFunc.length - 1;
                            var argsWithCallback = state.arguments_.concat(new Array(argLength)).slice(0, argLength);
                            argsWithCallback.push(callback);
                            this.paused_ = true;
                            if (!state.scope.strict) state.funcThis_ = this.boxThis_(state.funcThis_);
                            func.asyncFunc.apply(state.funcThis_, argsWithCallback);
                            return;
                        } else /* A child of a function is a function but is not callable.  For example:
      var F = function() {};
      F.prototype = escape;
      var f = new F();
      f();
      */ this.throwException(this.TYPE_ERROR, func.class + " is not callable");
                    } else {
                        // Execution complete.  Put the return value on the stack.
                        stack.pop();
                        if (state.isConstructor && typeof state.value !== "object") // Normal case for a constructor is to use the `this` value.
                        stack[stack.length - 1].value = state.funcThis_;
                        else // Non-constructors or constructions explicitly returning objects use
                        // the return value.
                        stack[stack.length - 1].value = state.value;
                    }
                };
                Interpreter.prototype["stepCatchClause"] = function(stack, state, node) {
                    if (!state.done_) {
                        state.done_ = true;
                        // Create an empty scope.
                        var scope = this.createSpecialScope(state.scope);
                        // Add the argument.
                        this.setProperty(scope.object, node["param"]["name"], state.throwValue);
                        // Execute catch clause.
                        return new Interpreter.State(node["body"], scope);
                    } else stack.pop();
                };
                Interpreter.prototype["stepConditionalExpression"] = function(stack, state, node) {
                    // Handles both ConditionalExpression and IfStatement.
                    var mode = state.mode_ || 0;
                    if (mode === 0) {
                        state.mode_ = 1;
                        return new Interpreter.State(node["test"], state.scope);
                    }
                    if (mode === 1) {
                        state.mode_ = 2;
                        var value = Boolean(state.value);
                        if (value && node["consequent"]) // Execute `if` block.
                        return new Interpreter.State(node["consequent"], state.scope);
                        else if (!value && node["alternate"]) // Execute `else` block.
                        return new Interpreter.State(node["alternate"], state.scope);
                        // eval('1;if(false){2}') -> undefined
                        this.value = undefined;
                    }
                    stack.pop();
                    if (node["type"] === "ConditionalExpression") stack[stack.length - 1].value = state.value;
                };
                Interpreter.prototype["stepContinueStatement"] = function(stack, state, node) {
                    var label = node["label"] && node["label"]["name"];
                    this.unwind(Interpreter.Completion.CONTINUE, undefined, label);
                };
                Interpreter.prototype["stepDebuggerStatement"] = function(stack, state, node) {
                    // Do nothing.  May be overridden by developers.
                    stack.pop();
                };
                Interpreter.prototype["stepDoWhileStatement"] = function(stack, state, node) {
                    // Handles both DoWhileStatement and WhileStatement.
                    if (node["type"] === "DoWhileStatement" && state.test_ === undefined) {
                        // First iteration of do/while executes without checking test.
                        state.value = true;
                        state.test_ = true;
                    }
                    if (!state.test_) {
                        state.test_ = true;
                        return new Interpreter.State(node["test"], state.scope);
                    }
                    if (!state.value) stack.pop();
                    else if (node["body"]) {
                        state.test_ = false;
                        state.isLoop = true;
                        return new Interpreter.State(node["body"], state.scope);
                    }
                };
                Interpreter.prototype["stepEmptyStatement"] = function(stack, state, node) {
                    stack.pop();
                };
                Interpreter.prototype["stepEvalProgram_"] = function(stack, state, node) {
                    var n = state.n_ || 0;
                    var expression = node["body"][n];
                    if (expression) {
                        state.n_ = n + 1;
                        return new Interpreter.State(expression, state.scope);
                    }
                    stack.pop();
                    stack[stack.length - 1].value = this.value;
                };
                Interpreter.prototype["stepExpressionStatement"] = function(stack, state, node) {
                    if (!state.done_) {
                        state.done_ = true;
                        return new Interpreter.State(node["expression"], state.scope);
                    }
                    stack.pop();
                    // Save this value to interpreter.value for use as a return value if
                    // this code is inside an eval function.
                    this.value = state.value;
                };
                Interpreter.prototype["stepForInStatement"] = function(stack, state, node) {
                    // First, initialize a variable if exists.  Only do so once, ever.
                    if (!state.doneInit_) {
                        state.doneInit_ = true;
                        if (node["left"]["declarations"] && node["left"]["declarations"][0]["init"]) {
                            if (state.scope.strict) this.throwException(this.SYNTAX_ERROR, "for-in loop variable declaration may not have an initializer.");
                            // Variable initialization: for (var x = 4 in y)
                            return new Interpreter.State(node["left"], state.scope);
                        }
                    }
                    // Second, look up the object.  Only do so once, ever.
                    if (!state.doneObject_) {
                        state.doneObject_ = true;
                        if (!state.variable_) state.variable_ = state.value;
                        return new Interpreter.State(node["right"], state.scope);
                    }
                    if (!state.isLoop) {
                        // First iteration.
                        state.isLoop = true;
                        state.object_ = state.value;
                        state.visited_ = Object.create(null);
                    }
                    // Third, find the property name for this iteration.
                    if (state.name_ === undefined) gotPropName: while(true){
                        if (state.object_ instanceof Interpreter.Object) {
                            if (!state.props_) state.props_ = Object.getOwnPropertyNames(state.object_.properties);
                            while(true){
                                var prop = state.props_.shift();
                                if (prop === undefined) break; // Reached end of this object's properties.
                                if (!Object.prototype.hasOwnProperty.call(state.object_.properties, prop)) continue; // Property has been deleted in the loop.
                                if (state.visited_[prop]) continue; // Already seen this property on a child.
                                state.visited_[prop] = true;
                                if (!Object.prototype.propertyIsEnumerable.call(state.object_.properties, prop)) continue; // Skip non-enumerable property.
                                state.name_ = prop;
                                break gotPropName;
                            }
                        } else if (state.object_ !== null && state.object_ !== undefined) {
                            // Primitive value (other than null or undefined).
                            if (!state.props_) state.props_ = Object.getOwnPropertyNames(state.object_);
                            while(true){
                                var prop = state.props_.shift();
                                if (prop === undefined) break; // Reached end of this value's properties.
                                state.visited_[prop] = true;
                                if (!Object.prototype.propertyIsEnumerable.call(state.object_, prop)) continue; // Skip non-enumerable property.
                                state.name_ = prop;
                                break gotPropName;
                            }
                        }
                        state.object_ = this.getPrototype(state.object_);
                        state.props_ = null;
                        if (state.object_ === null) {
                            // Done, exit loop.
                            stack.pop();
                            return;
                        }
                    }
                    // Fourth, find the variable
                    if (!state.doneVariable_) {
                        state.doneVariable_ = true;
                        var left = node["left"];
                        if (left["type"] === "VariableDeclaration") // Inline variable declaration: for (var x in y)
                        state.variable_ = [
                            Interpreter.SCOPE_REFERENCE,
                            left["declarations"][0]["id"]["name"]
                        ];
                        else {
                            // Arbitrary left side: for (foo().bar in y)
                            state.variable_ = null;
                            var nextState = new Interpreter.State(left, state.scope);
                            nextState.components = true;
                            return nextState;
                        }
                    }
                    if (!state.variable_) state.variable_ = state.value;
                    // Fifth, set the variable.
                    if (!state.doneSetter_) {
                        state.doneSetter_ = true;
                        var value = state.name_;
                        var setter = this.setValue(state.variable_, value);
                        if (setter) return this.createSetter_(setter, state.variable_, value);
                    }
                    // Next step will be step three.
                    state.name_ = undefined;
                    // Reevaluate the variable since it could be a setter on the global object.
                    state.doneVariable_ = false;
                    state.doneSetter_ = false;
                    // Sixth and finally, execute the body if there was one.
                    if (node["body"]) return new Interpreter.State(node["body"], state.scope);
                };
                Interpreter.prototype["stepForStatement"] = function(stack, state, node) {
                    switch(state.mode_){
                        default:
                            state.mode_ = 1;
                            if (node["init"]) return new Interpreter.State(node["init"], state.scope);
                            break;
                        case 1:
                            state.mode_ = 2;
                            if (node["test"]) return new Interpreter.State(node["test"], state.scope);
                            break;
                        case 2:
                            state.mode_ = 3;
                            if (node["test"] && !state.value) // Done, exit loop.
                            stack.pop();
                            else {
                                state.isLoop = true;
                                return new Interpreter.State(node["body"], state.scope);
                            }
                            break;
                        case 3:
                            state.mode_ = 1;
                            if (node["update"]) return new Interpreter.State(node["update"], state.scope);
                            break;
                    }
                };
                Interpreter.prototype["stepFunctionDeclaration"] = function(stack, state, node) {
                    // This was found and handled when the scope was populated.
                    stack.pop();
                };
                Interpreter.prototype["stepFunctionExpression"] = function(stack, state, node) {
                    stack.pop();
                    state = stack[stack.length - 1];
                    state.value = this.createFunction(node, state.scope, state.destinationName);
                };
                Interpreter.prototype["stepIdentifier"] = function(stack, state, node) {
                    stack.pop();
                    if (state.components) {
                        stack[stack.length - 1].value = [
                            Interpreter.SCOPE_REFERENCE,
                            node["name"]
                        ];
                        return;
                    }
                    var value = this.getValueFromScope(node["name"]);
                    // An identifier could be a getter if it's a property on the global object.
                    if (this.getterStep_) {
                        // Call the getter function.
                        var func = /** @type {!Interpreter.Object} */ value;
                        return this.createGetter_(func, this.globalObject);
                    }
                    stack[stack.length - 1].value = value;
                };
                Interpreter.prototype["stepIfStatement"] = Interpreter.prototype["stepConditionalExpression"];
                Interpreter.prototype["stepLabeledStatement"] = function(stack, state, node) {
                    // No need to hit this node again on the way back up the stack.
                    stack.pop();
                    // Note that a statement might have multiple labels.
                    var labels = state.labels || [];
                    labels.push(node["label"]["name"]);
                    var nextState = new Interpreter.State(node["body"], state.scope);
                    nextState.labels = labels;
                    return nextState;
                };
                Interpreter.prototype["stepLiteral"] = function(stack, state, node) {
                    stack.pop();
                    var value = node["value"];
                    if (value instanceof RegExp) {
                        var pseudoRegexp = this.createObjectProto(this.REGEXP_PROTO);
                        this.populateRegExp(pseudoRegexp, value);
                        value = pseudoRegexp;
                    }
                    stack[stack.length - 1].value = value;
                };
                Interpreter.prototype["stepLogicalExpression"] = function(stack, state, node) {
                    if (node["operator"] !== "&&" && node["operator"] !== "||") throw SyntaxError("Unknown logical operator: " + node["operator"]);
                    if (!state.doneLeft_) {
                        state.doneLeft_ = true;
                        return new Interpreter.State(node["left"], state.scope);
                    }
                    if (!state.doneRight_) {
                        if (node["operator"] === "&&" && !state.value || node["operator"] === "||" && state.value) {
                            // Shortcut evaluation.
                            stack.pop();
                            stack[stack.length - 1].value = state.value;
                        } else {
                            state.doneRight_ = true;
                            return new Interpreter.State(node["right"], state.scope);
                        }
                    } else {
                        stack.pop();
                        stack[stack.length - 1].value = state.value;
                    }
                };
                Interpreter.prototype["stepMemberExpression"] = function(stack, state, node) {
                    if (!state.doneObject_) {
                        state.doneObject_ = true;
                        return new Interpreter.State(node["object"], state.scope);
                    }
                    var propName;
                    if (!node["computed"]) {
                        state.object_ = state.value;
                        // obj.foo -- Just access `foo` directly.
                        propName = node["property"]["name"];
                    } else if (!state.doneProperty_) {
                        state.object_ = state.value;
                        // obj[foo] -- Compute value of `foo`.
                        state.doneProperty_ = true;
                        return new Interpreter.State(node["property"], state.scope);
                    } else propName = state.value;
                    stack.pop();
                    if (state.components) stack[stack.length - 1].value = [
                        state.object_,
                        propName
                    ];
                    else {
                        var value = this.getProperty(state.object_, propName);
                        if (this.getterStep_) {
                            // Call the getter function.
                            var func = /** @type {!Interpreter.Object} */ value;
                            return this.createGetter_(func, state.object_);
                        }
                        stack[stack.length - 1].value = value;
                    }
                };
                Interpreter.prototype["stepNewExpression"] = Interpreter.prototype["stepCallExpression"];
                Interpreter.prototype["stepObjectExpression"] = function(stack, state, node) {
                    var n = state.n_ || 0;
                    var property = node["properties"][n];
                    if (!state.object_) {
                        // First execution.
                        state.object_ = this.createObjectProto(this.OBJECT_PROTO);
                        state.properties_ = Object.create(null);
                    } else {
                        // Set the property computed in the previous execution.
                        var propName = state.destinationName;
                        if (!state.properties_[propName]) // Create temp object to collect value, getter, and/or setter.
                        state.properties_[propName] = {};
                        state.properties_[propName][property["kind"]] = state.value;
                        state.n_ = ++n;
                        property = node["properties"][n];
                    }
                    if (property) {
                        // Determine property name.
                        var key = property["key"];
                        if (key["type"] === "Identifier") var propName = key["name"];
                        else if (key["type"] === "Literal") var propName = key["value"];
                        else throw SyntaxError("Unknown object structure: " + key["type"]);
                        // When assigning an unnamed function to a property, the function's name
                        // is set to the property name.  Record the property name in case the
                        // value is a functionExpression.
                        // E.g. {foo: function() {}}
                        state.destinationName = propName;
                        return new Interpreter.State(property["value"], state.scope);
                    }
                    for(var key in state.properties_){
                        var kinds = state.properties_[key];
                        if ("get" in kinds || "set" in kinds) {
                            // Set a property with a getter or setter.
                            var descriptor = {
                                configurable: true,
                                enumerable: true,
                                get: kinds["get"],
                                set: kinds["set"]
                            };
                            this.setProperty(state.object_, key, Interpreter.VALUE_IN_DESCRIPTOR, descriptor);
                        } else // Set a normal property with a value.
                        this.setProperty(state.object_, key, kinds["init"]);
                    }
                    stack.pop();
                    stack[stack.length - 1].value = state.object_;
                };
                Interpreter.prototype["stepProgram"] = function(stack, state, node) {
                    var expression = node["body"].shift();
                    if (expression) {
                        state.done = false;
                        return new Interpreter.State(expression, state.scope);
                    }
                    state.done = true;
                // Don't pop the stateStack.
                // Leave the root scope on the tree in case the program is appended to.
                };
                Interpreter.prototype["stepReturnStatement"] = function(stack, state, node) {
                    if (node["argument"] && !state.done_) {
                        state.done_ = true;
                        return new Interpreter.State(node["argument"], state.scope);
                    }
                    this.unwind(Interpreter.Completion.RETURN, state.value, undefined);
                };
                Interpreter.prototype["stepSequenceExpression"] = function(stack, state, node) {
                    var n = state.n_ || 0;
                    var expression = node["expressions"][n];
                    if (expression) {
                        state.n_ = n + 1;
                        return new Interpreter.State(expression, state.scope);
                    }
                    stack.pop();
                    stack[stack.length - 1].value = state.value;
                };
                Interpreter.prototype["stepSwitchStatement"] = function(stack, state, node) {
                    if (!state.test_) {
                        state.test_ = 1;
                        return new Interpreter.State(node["discriminant"], state.scope);
                    }
                    if (state.test_ === 1) {
                        state.test_ = 2;
                        // Preserve switch value between case tests.
                        state.switchValue_ = state.value;
                        state.defaultCase_ = -1;
                    }
                    while(true){
                        var index = state.index_ || 0;
                        var switchCase = node["cases"][index];
                        if (!state.matched_ && switchCase && !switchCase["test"]) {
                            // Test on the default case is null.
                            // Bypass (but store) the default case, and get back to it later.
                            state.defaultCase_ = index;
                            state.index_ = index + 1;
                            continue;
                        }
                        if (!switchCase && !state.matched_ && state.defaultCase_ !== -1) {
                            // Ran through all cases, no match.  Jump to the default.
                            state.matched_ = true;
                            state.index_ = state.defaultCase_;
                            continue;
                        }
                        if (switchCase) {
                            if (!state.matched_ && !state.tested_ && switchCase["test"]) {
                                state.tested_ = true;
                                return new Interpreter.State(switchCase["test"], state.scope);
                            }
                            if (state.matched_ || state.value === state.switchValue_) {
                                state.matched_ = true;
                                var n = state.n_ || 0;
                                if (switchCase["consequent"][n]) {
                                    state.isSwitch = true;
                                    state.n_ = n + 1;
                                    return new Interpreter.State(switchCase["consequent"][n], state.scope);
                                }
                            }
                            // Move on to next case.
                            state.tested_ = false;
                            state.n_ = 0;
                            state.index_ = index + 1;
                        } else {
                            stack.pop();
                            return;
                        }
                    }
                };
                Interpreter.prototype["stepThisExpression"] = function(stack, state, node) {
                    stack.pop();
                    stack[stack.length - 1].value = this.getValueFromScope("this");
                };
                Interpreter.prototype["stepThrowStatement"] = function(stack, state, node) {
                    if (!state.done_) {
                        state.done_ = true;
                        return new Interpreter.State(node["argument"], state.scope);
                    } else this.throwException(state.value);
                };
                Interpreter.prototype["stepTryStatement"] = function(stack, state, node) {
                    if (!state.doneBlock_) {
                        state.doneBlock_ = true;
                        return new Interpreter.State(node["block"], state.scope);
                    }
                    if (state.cv && state.cv.type === Interpreter.Completion.THROW && !state.doneHandler_ && node["handler"]) {
                        state.doneHandler_ = true;
                        var nextState = new Interpreter.State(node["handler"], state.scope);
                        nextState.throwValue = state.cv.value;
                        state.cv = undefined; // This error has been handled, don't rethrow.
                        return nextState;
                    }
                    if (!state.doneFinalizer_ && node["finalizer"]) {
                        state.doneFinalizer_ = true;
                        return new Interpreter.State(node["finalizer"], state.scope);
                    }
                    stack.pop();
                    if (state.cv) // There was no catch handler, or the catch/finally threw an error.
                    // Throw the error up to a higher try.
                    this.unwind(state.cv.type, state.cv.value, state.cv.label);
                };
                Interpreter.prototype["stepUnaryExpression"] = function(stack, state, node) {
                    if (!state.done_) {
                        state.done_ = true;
                        var nextState = new Interpreter.State(node["argument"], state.scope);
                        nextState.components = node["operator"] === "delete";
                        return nextState;
                    }
                    stack.pop();
                    var value = state.value;
                    switch(node["operator"]){
                        case "-":
                            value = -value;
                            break;
                        case "+":
                            value = +value;
                            break;
                        case "!":
                            value = !value;
                            break;
                        case "~":
                            value = ~value;
                            break;
                        case "delete":
                            var result = true;
                            // If value is not an array, then it is a primitive, or some other value.
                            // If so, skip the delete and return true.
                            if (Array.isArray(value)) {
                                var obj = value[0];
                                if (obj === Interpreter.SCOPE_REFERENCE) // `delete foo;` is the same as `delete window.foo;`.
                                obj = state.scope;
                                var name = String(value[1]);
                                try {
                                    delete obj.properties[name];
                                } catch (_e) {
                                    if (state.scope.strict) this.throwException(this.TYPE_ERROR, "Cannot delete property '" + name + "' of '" + obj + "'");
                                    else result = false;
                                }
                            }
                            value = result;
                            break;
                        case "typeof":
                            value = value && value.class === "Function" ? "function" : typeof value;
                            break;
                        case "void":
                            value = undefined;
                            break;
                        default:
                            throw SyntaxError("Unknown unary operator: " + node["operator"]);
                    }
                    stack[stack.length - 1].value = value;
                };
                Interpreter.prototype["stepUpdateExpression"] = function(stack, state, node) {
                    if (!state.doneLeft_) {
                        state.doneLeft_ = true;
                        var nextState = new Interpreter.State(node["argument"], state.scope);
                        nextState.components = true;
                        return nextState;
                    }
                    if (!state.leftSide_) state.leftSide_ = state.value;
                    if (state.doneGetter_) state.leftValue_ = state.value;
                    if (!state.doneGetter_) {
                        var leftValue = this.getValue(state.leftSide_);
                        state.leftValue_ = leftValue;
                        if (this.getterStep_) {
                            // Call the getter function.
                            state.doneGetter_ = true;
                            var func = /** @type {!Interpreter.Object} */ leftValue;
                            return this.createGetter_(func, state.leftSide_);
                        }
                    }
                    if (state.doneSetter_) {
                        // Return if setter function.
                        // Setter method on property has completed.
                        // Ignore its return value, and use the original set value instead.
                        stack.pop();
                        stack[stack.length - 1].value = state.setterValue_;
                        return;
                    }
                    var leftValue = Number(state.leftValue_);
                    var changeValue;
                    if (node["operator"] === "++") changeValue = leftValue + 1;
                    else if (node["operator"] === "--") changeValue = leftValue - 1;
                    else throw SyntaxError("Unknown update expression: " + node["operator"]);
                    var returnValue = node["prefix"] ? changeValue : leftValue;
                    var setter = this.setValue(state.leftSide_, changeValue);
                    if (setter) {
                        state.doneSetter_ = true;
                        state.setterValue_ = returnValue;
                        return this.createSetter_(setter, state.leftSide_, changeValue);
                    }
                    // Return if no setter function.
                    stack.pop();
                    stack[stack.length - 1].value = returnValue;
                };
                Interpreter.prototype["stepVariableDeclaration"] = function(stack, state, node) {
                    var declarations = node["declarations"];
                    var n = state.n_ || 0;
                    var declarationNode = declarations[n];
                    if (state.init_ && declarationNode) {
                        // This setValue call never needs to deal with calling a setter function.
                        // Note that this is setting the init value, not defining the variable.
                        // Variable definition is done when scope is populated.
                        this.setValueToScope(declarationNode["id"]["name"], state.value);
                        state.init_ = false;
                        declarationNode = declarations[++n];
                    }
                    while(declarationNode){
                        // Skip any declarations that are not initialized.  They have already
                        // been defined as undefined in populateScope_.
                        if (declarationNode["init"]) {
                            state.n_ = n;
                            state.init_ = true;
                            // When assigning an unnamed function to a variable, the function's name
                            // is set to the variable name.  Record the variable name in case the
                            // right side is a functionExpression.
                            // E.g. var foo = function() {};
                            state.destinationName = declarationNode["id"]["name"];
                            return new Interpreter.State(declarationNode["init"], state.scope);
                        }
                        declarationNode = declarations[++n];
                    }
                    stack.pop();
                };
                Interpreter.prototype["stepWithStatement"] = function(stack, state, node) {
                    if (!state.doneObject_) {
                        state.doneObject_ = true;
                        return new Interpreter.State(node["object"], state.scope);
                    } else if (!state.doneBody_) {
                        state.doneBody_ = true;
                        var scope = this.createSpecialScope(state.scope, state.value);
                        return new Interpreter.State(node["body"], scope);
                    } else stack.pop();
                };
                Interpreter.prototype["stepWhileStatement"] = Interpreter.prototype["stepDoWhileStatement"];
                // Preserve top-level API functions from being pruned/renamed by JS compilers.
                // Add others as needed.
                Interpreter.nativeGlobal["Interpreter"] = Interpreter;
                Interpreter.prototype["step"] = Interpreter.prototype.step;
                Interpreter.prototype["run"] = Interpreter.prototype.run;
                Interpreter.prototype["appendCode"] = Interpreter.prototype.appendCode;
                Interpreter.prototype["createObject"] = Interpreter.prototype.createObject;
                Interpreter.prototype["createObjectProto"] = Interpreter.prototype.createObjectProto;
                Interpreter.prototype["createAsyncFunction"] = Interpreter.prototype.createAsyncFunction;
                Interpreter.prototype["createNativeFunction"] = Interpreter.prototype.createNativeFunction;
                Interpreter.prototype["getProperty"] = Interpreter.prototype.getProperty;
                Interpreter.prototype["setProperty"] = Interpreter.prototype.setProperty;
                Interpreter.prototype["nativeToPseudo"] = Interpreter.prototype.nativeToPseudo;
                Interpreter.prototype["pseudoToNative"] = Interpreter.prototype.pseudoToNative;
                Interpreter.prototype["getGlobalScope"] = Interpreter.prototype.getGlobalScope;
                Interpreter.prototype["getStateStack"] = Interpreter.prototype.getStateStack;
                Interpreter.prototype["setStateStack"] = Interpreter.prototype.setStateStack;
                Interpreter["VALUE_IN_DESCRIPTOR"] = Interpreter.VALUE_IN_DESCRIPTOR;
                /*** EXPORTS FROM exports-loader ***/ module1.exports = {
                    Interpreter: Interpreter
                };
            /***/ },
            /***/ "./original-repo/acorn.js": /*!********************************!*\
  !*** ./original-repo/acorn.js ***!
  \********************************/ /***/ function(module1, exports) {
                var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // Acorn is a tiny, fast JavaScript parser written in JavaScript.
                //
                // Acorn was written by Marijn Haverbeke and released under an MIT
                // license. The Unicode regexps (for identifiers and whitespace) were
                // taken from [Esprima](http://esprima.org) by Ariya Hidayat.
                //
                // Git repositories for Acorn are available at
                //
                //     http://marijnhaverbeke.nl/git/acorn
                //     https://github.com/marijnh/acorn.git
                //
                // Please use the [github bug tracker][ghbt] to report issues.
                //
                // [ghbt]: https://github.com/marijnh/acorn/issues
                //
                // This file defines the main parser interface. The library also comes
                // with a [error-tolerant parser][dammit] and an
                // [abstract syntax tree walker][walk], defined in other files.
                //
                // [dammit]: acorn_loose.js
                // [walk]: util/walk.js
                (function(root, mod) {
                    return mod(exports); // CommonJS
                })(this, function(exports) {
                    "use strict";
                    exports.version = "0.5.0";
                    // Plus additional edits marked with 'JS-Interpreter change' comments.
                    // The main exported interface (under `self.acorn` when in the
                    // browser) is a `parse` function that takes a code string and
                    // returns an abstract syntax tree as specified by [Mozilla parser
                    // API][api], with the caveat that the SpiderMonkey-specific syntax
                    // (`let`, `yield`, inline XML, etc) is not recognized.
                    //
                    // [api]: https://developer.mozilla.org/en-US/docs/SpiderMonkey/Parser_API
                    var options, input, inputLen, sourceFile;
                    exports.parse = function(inpt, opts) {
                        input = String(inpt);
                        inputLen = input.length;
                        setOptions(opts);
                        initTokenState();
                        return parseTopLevel(options.program);
                    };
                    // A second optional argument can be given to further configure
                    // the parser process. These options are recognized:
                    var defaultOptions = exports.defaultOptions = {
                        // JS-Interpreter change:
                        // `ecmaVersion` option has been removed along with all cases where
                        // it is checked.  In this version of Acorn it was limited to 3 or 5,
                        // and there's no use case for 3 with JS-Interpreter.
                        // Turn on `strictSemicolons` to prevent the parser from doing
                        // automatic semicolon insertion.
                        strictSemicolons: false,
                        // When `allowTrailingCommas` is false, the parser will not allow
                        // trailing commas in array and object literals.
                        allowTrailingCommas: true,
                        // By default, reserved words are not enforced. Enable
                        // `forbidReserved` to enforce them. When this option has the
                        // value "everywhere", reserved words and keywords can also not be
                        // used as property names.
                        forbidReserved: false,
                        // When enabled, a return at the top level is not considered an
                        // error.
                        allowReturnOutsideFunction: false,
                        // When `locations` is on, `loc` properties holding objects with
                        // `start` and `end` properties in `{line, column}` form (with
                        // line being 1-based and column 0-based) will be attached to the
                        // nodes.
                        locations: false,
                        // A function can be passed as `onComment` option, which will
                        // cause Acorn to call that function with `(block, text, start,
                        // end)` parameters whenever a comment is skipped. `block` is a
                        // boolean indicating whether this is a block (`/* */`) comment,
                        // `text` is the content of the comment, and `start` and `end` are
                        // character offsets that denote the start and end of the comment.
                        // When the `locations` option is on, two more parameters are
                        // passed, the full `{line, column}` locations of the start and
                        // end of the comments. Note that you are not allowed to call the
                        // parser from the callback—that will corrupt its internal state.
                        onComment: null,
                        // Nodes have their start and end characters offsets recorded in
                        // `start` and `end` properties (directly on the node, rather than
                        // the `loc` object, which holds line/column data. To also add a
                        // [semi-standardized][range] `range` property holding a `[start,
                        // end]` array with the same numbers, set the `ranges` option to
                        // `true`.
                        //
                        // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
                        ranges: false,
                        // It is possible to parse multiple files into a single AST by
                        // passing the tree produced by parsing the first file as
                        // `program` option in subsequent parses. This will add the
                        // toplevel forms of the parsed file to the `Program` (top) node
                        // of an existing parse tree.
                        program: null,
                        // When `locations` is on, you can pass this to record the source
                        // file in every node's `loc` object.
                        sourceFile: null,
                        // This value, if given, is stored in every node, whether
                        // `locations` is on or off.
                        directSourceFile: null
                    };
                    function setOptions(opts) {
                        options = opts || {};
                        for(var opt in defaultOptions)if (!Object.prototype.hasOwnProperty.call(options, opt)) options[opt] = defaultOptions[opt];
                        sourceFile = options.sourceFile || null;
                    }
                    // The `getLineInfo` function is mostly useful when the
                    // `locations` option is off (for performance reasons) and you
                    // want to find the line/column position for a given character
                    // offset. `input` should be the code string that the offset refers
                    // into.
                    var getLineInfo = exports.getLineInfo = function(input, offset) {
                        for(var line = 1, cur = 0;;){
                            lineBreak.lastIndex = cur;
                            var match = lineBreak.exec(input);
                            if (match && match.index < offset) {
                                ++line;
                                cur = match.index + match[0].length;
                            } else break;
                        }
                        return {
                            line: line,
                            column: offset - cur
                        };
                    };
                    // Acorn is organized as a tokenizer and a recursive-descent parser.
                    // The `tokenize` export provides an interface to the tokenizer.
                    // Because the tokenizer is optimized for being efficiently used by
                    // the Acorn parser itself, this interface is somewhat crude and not
                    // very modular. Performing another parse or call to `tokenize` will
                    // reset the internal state, and invalidate existing tokenizers.
                    exports.tokenize = function(inpt, opts) {
                        input = String(inpt);
                        inputLen = input.length;
                        setOptions(opts);
                        initTokenState();
                        var t = {};
                        function getToken(forceRegexp) {
                            lastEnd = tokEnd;
                            readToken(forceRegexp);
                            t.start = tokStart;
                            t.end = tokEnd;
                            t.startLoc = tokStartLoc;
                            t.endLoc = tokEndLoc;
                            t.type = tokType;
                            t.value = tokVal;
                            return t;
                        }
                        getToken.jumpTo = function(pos, reAllowed) {
                            tokPos = pos;
                            if (options.locations) {
                                tokCurLine = 1;
                                tokLineStart = lineBreak.lastIndex = 0;
                                var match;
                                while((match = lineBreak.exec(input)) && match.index < pos){
                                    ++tokCurLine;
                                    tokLineStart = match.index + match[0].length;
                                }
                            }
                            tokRegexpAllowed = reAllowed;
                            skipSpace();
                        };
                        return getToken;
                    };
                    // State is kept in (closure-)global variables. We already saw the
                    // `options`, `input`, and `inputLen` variables above.
                    // The current position of the tokenizer in the input.
                    var tokPos;
                    // The start and end offsets of the current token.
                    var tokStart, tokEnd;
                    // When `options.locations` is true, these hold objects
                    // containing the tokens start and end line/column pairs.
                    var tokStartLoc, tokEndLoc;
                    // The type and value of the current token. Token types are objects,
                    // named by variables against which they can be compared, and
                    // holding properties that describe them (indicating, for example,
                    // the precedence of an infix operator, and the original name of a
                    // keyword token). The kind of value that's held in `tokVal` depends
                    // on the type of the token. For literals, it is the literal value,
                    // for operators, the operator name, and so on.
                    var tokType, tokVal;
                    // Interal state for the tokenizer. To distinguish between division
                    // operators and regular expressions, it remembers whether the last
                    // token was one that is allowed to be followed by an expression.
                    // (If it is, a slash is probably a regexp, if it isn't it's a
                    // division operator. See the `parseStatement` function for a
                    // caveat.)
                    var tokRegexpAllowed;
                    // When `options.locations` is true, these are used to keep
                    // track of the current line, and know when a new line has been
                    // entered.
                    var tokCurLine, tokLineStart;
                    // These store the position of the previous token, which is useful
                    // when finishing a node and assigning its `end` position.
                    var lastStart, lastEnd, lastEndLoc;
                    // This is the parser's state. `inFunction` is used to reject
                    // `return` statements outside of functions, `labels` to verify that
                    // `break` and `continue` have somewhere to jump to, and `strict`
                    // indicates whether strict mode is on.
                    var inFunction, labels, strict;
                    // This function is used to raise exceptions on parse errors. It
                    // takes an offset integer (into the current `input`) to indicate
                    // the location of the error, attaches the position to the end
                    // of the error message, and then raises a `SyntaxError` with that
                    // message.
                    function raise(pos, message) {
                        var loc = getLineInfo(input, pos);
                        message += " (" + loc.line + ":" + loc.column + ")";
                        var err = new SyntaxError(message);
                        err.pos = pos;
                        err.loc = loc;
                        err.raisedAt = tokPos;
                        throw err;
                    }
                    // Reused empty array added for node fields that are always empty.
                    var empty = [];
                    // ## Token types
                    // The assignment of fine-grained, information-carrying type objects
                    // allows the tokenizer to store the information it has about a
                    // token in a way that is very cheap for the parser to look up.
                    // All token type variables start with an underscore, to make them
                    // easy to recognize.
                    // These are the general types. The `type` property is only used to
                    // make them recognizeable when debugging.
                    var _num = {
                        type: "num"
                    }, _regexp = {
                        type: "regexp"
                    }, _string = {
                        type: "string"
                    };
                    var _name = {
                        type: "name"
                    }, _eof = {
                        type: "eof"
                    };
                    // Keyword tokens. The `keyword` property (also used in keyword-like
                    // operators) indicates that the token originated from an
                    // identifier-like word, which is used when parsing property names.
                    //
                    // The `beforeExpr` property is used to disambiguate between regular
                    // expressions and divisions. It is set on all token types that can
                    // be followed by an expression (thus, a slash after them would be a
                    // regular expression).
                    //
                    // `isLoop` marks a keyword as starting a loop, which is important
                    // to know when parsing a label, in order to allow or disallow
                    // continue jumps to that label.
                    var _break = {
                        keyword: "break"
                    }, _case = {
                        keyword: "case",
                        beforeExpr: true
                    }, _catch = {
                        keyword: "catch"
                    };
                    var _continue = {
                        keyword: "continue"
                    }, _debugger = {
                        keyword: "debugger"
                    }, _default = {
                        keyword: "default"
                    };
                    var _do = {
                        keyword: "do",
                        isLoop: true
                    }, _else = {
                        keyword: "else",
                        beforeExpr: true
                    };
                    var _finally = {
                        keyword: "finally"
                    }, _for = {
                        keyword: "for",
                        isLoop: true
                    }, _function = {
                        keyword: "function"
                    };
                    var _if = {
                        keyword: "if"
                    }, _return = {
                        keyword: "return",
                        beforeExpr: true
                    }, _switch = {
                        keyword: "switch"
                    };
                    var _throw = {
                        keyword: "throw",
                        beforeExpr: true
                    }, _try = {
                        keyword: "try"
                    }, _var = {
                        keyword: "var"
                    };
                    var _while = {
                        keyword: "while",
                        isLoop: true
                    }, _with = {
                        keyword: "with"
                    }, _new = {
                        keyword: "new",
                        beforeExpr: true
                    };
                    var _this = {
                        keyword: "this"
                    };
                    // The keywords that denote values.
                    var _null = {
                        keyword: "null",
                        atomValue: null
                    }, _true = {
                        keyword: "true",
                        atomValue: true
                    };
                    var _false = {
                        keyword: "false",
                        atomValue: false
                    };
                    // Some keywords are treated as regular operators. `in` sometimes
                    // (when parsing `for`) needs to be tested against specifically, so
                    // we assign a variable name to it for quick comparing.
                    var _in = {
                        keyword: "in",
                        binop: 7,
                        beforeExpr: true
                    };
                    // Map keyword names to token types.
                    var keywordTypes = {
                        "break": _break,
                        "case": _case,
                        "catch": _catch,
                        "continue": _continue,
                        "debugger": _debugger,
                        "default": _default,
                        "do": _do,
                        "else": _else,
                        "finally": _finally,
                        "for": _for,
                        "function": _function,
                        "if": _if,
                        "return": _return,
                        "switch": _switch,
                        "throw": _throw,
                        "try": _try,
                        "var": _var,
                        "while": _while,
                        "with": _with,
                        "null": _null,
                        "true": _true,
                        "false": _false,
                        "new": _new,
                        "in": _in,
                        "instanceof": {
                            keyword: "instanceof",
                            binop: 7,
                            beforeExpr: true
                        },
                        "this": _this,
                        "typeof": {
                            keyword: "typeof",
                            prefix: true,
                            beforeExpr: true
                        },
                        "void": {
                            keyword: "void",
                            prefix: true,
                            beforeExpr: true
                        },
                        "delete": {
                            keyword: "delete",
                            prefix: true,
                            beforeExpr: true
                        }
                    };
                    // Punctuation token types. Again, the `type` property is purely for debugging.
                    var _bracketL = {
                        type: "[",
                        beforeExpr: true
                    }, _bracketR = {
                        type: "]"
                    }, _braceL = {
                        type: "{",
                        beforeExpr: true
                    };
                    var _braceR = {
                        type: "}"
                    }, _parenL = {
                        type: "(",
                        beforeExpr: true
                    }, _parenR = {
                        type: ")"
                    };
                    var _comma = {
                        type: ",",
                        beforeExpr: true
                    }, _semi = {
                        type: ";",
                        beforeExpr: true
                    };
                    var _colon = {
                        type: ":",
                        beforeExpr: true
                    }, _dot = {
                        type: "."
                    }, _question = {
                        type: "?",
                        beforeExpr: true
                    };
                    // Operators. These carry several kinds of properties to help the
                    // parser use them properly (the presence of these properties is
                    // what categorizes them as operators).
                    //
                    // `binop`, when present, specifies that this operator is a binary
                    // operator, and will refer to its precedence.
                    //
                    // `prefix` and `postfix` mark the operator as a prefix or postfix
                    // unary operator. `isUpdate` specifies that the node produced by
                    // the operator should be of type UpdateExpression rather than
                    // simply UnaryExpression (`++` and `--`).
                    //
                    // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
                    // binary operators with a very low precedence, that should result
                    // in AssignmentExpression nodes.
                    var _slash = {
                        binop: 10,
                        beforeExpr: true
                    }, _eq = {
                        isAssign: true,
                        beforeExpr: true
                    };
                    var _assign = {
                        isAssign: true,
                        beforeExpr: true
                    };
                    var _incDec = {
                        postfix: true,
                        prefix: true,
                        isUpdate: true
                    }, _prefix = {
                        prefix: true,
                        beforeExpr: true
                    };
                    var _logicalOR = {
                        binop: 1,
                        beforeExpr: true
                    };
                    var _logicalAND = {
                        binop: 2,
                        beforeExpr: true
                    };
                    var _bitwiseOR = {
                        binop: 3,
                        beforeExpr: true
                    };
                    var _bitwiseXOR = {
                        binop: 4,
                        beforeExpr: true
                    };
                    var _bitwiseAND = {
                        binop: 5,
                        beforeExpr: true
                    };
                    var _equality = {
                        binop: 6,
                        beforeExpr: true
                    };
                    var _relational = {
                        binop: 7,
                        beforeExpr: true
                    };
                    var _bitShift = {
                        binop: 8,
                        beforeExpr: true
                    };
                    var _plusMin = {
                        binop: 9,
                        prefix: true,
                        beforeExpr: true
                    };
                    var _multiplyModulo = {
                        binop: 10,
                        beforeExpr: true
                    };
                    // Provide access to the token types for external users of the
                    // tokenizer.
                    exports.tokTypes = {
                        bracketL: _bracketL,
                        bracketR: _bracketR,
                        braceL: _braceL,
                        braceR: _braceR,
                        parenL: _parenL,
                        parenR: _parenR,
                        comma: _comma,
                        semi: _semi,
                        colon: _colon,
                        dot: _dot,
                        question: _question,
                        slash: _slash,
                        eq: _eq,
                        name: _name,
                        eof: _eof,
                        num: _num,
                        regexp: _regexp,
                        string: _string
                    };
                    for(var kw in keywordTypes)exports.tokTypes["_" + kw] = keywordTypes[kw];
                    // JS-Interpreter change:
                    // Acorn's original code built up functions using strings for maximum efficiency.
                    // However, this triggered a CSP unsafe-eval requirement.  Here's a slower, but
                    // simpler approach.  -- Neil Fraser, January 2022.
                    // https://github.com/NeilFraser/JS-Interpreter/issues/228
                    function makePredicate(words) {
                        words = words.split(" ");
                        var set = Object.create(null);
                        for(var i = 0; i < words.length; i++)set[words[i]] = true;
                        return function(str) {
                            return set[str] || false;
                        };
                    }
                    // ECMAScript 5 reserved words.
                    var isReservedWord5 = makePredicate("class enum extends super const export import");
                    // The additional reserved words in strict mode.
                    var isStrictReservedWord = makePredicate("implements interface let package private protected public static yield");
                    // The forbidden variable names in strict mode.
                    var isStrictBadIdWord = makePredicate("eval arguments");
                    // And the keywords.
                    var isKeyword = makePredicate("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this");
                    // ## Character categories
                    // Big ugly regular expressions that match characters in the
                    // whitespace, identifier, and identifier-start categories. These
                    // are only applied when a character is found to actually have a
                    // code point above 128.
                    var nonASCIIwhitespace = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/;
                    var nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F0\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
                    var nonASCIIidentifierChars = "\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u0620-\u0649\u0672-\u06D3\u06E7-\u06E8\u06FB-\u06FC\u0730-\u074A\u0800-\u0814\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0840-\u0857\u08E4-\u08FE\u0900-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962-\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09D7\u09DF-\u09E0\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2-\u0AE3\u0AE6-\u0AEF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5F-\u0B60\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C01-\u0C03\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62-\u0C63\u0C66-\u0C6F\u0C82\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2-\u0CE3\u0CE6-\u0CEF\u0D02\u0D03\u0D46-\u0D48\u0D57\u0D62-\u0D63\u0D66-\u0D6F\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E34-\u0E3A\u0E40-\u0E45\u0E50-\u0E59\u0EB4-\u0EB9\u0EC8-\u0ECD\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F41-\u0F47\u0F71-\u0F84\u0F86-\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1029\u1040-\u1049\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u170E-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17B2\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1920-\u192B\u1930-\u193B\u1951-\u196D\u19B0-\u19C0\u19C8-\u19C9\u19D0-\u19D9\u1A00-\u1A15\u1A20-\u1A53\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1B46-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C00-\u1C22\u1C40-\u1C49\u1C5B-\u1C7D\u1CD0-\u1CD2\u1D00-\u1DBE\u1E01-\u1F15\u200C\u200D\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2D81-\u2D96\u2DE0-\u2DFF\u3021-\u3028\u3099\u309A\uA640-\uA66D\uA674-\uA67D\uA69F\uA6F0-\uA6F1\uA7F8-\uA800\uA806\uA80B\uA823-\uA827\uA880-\uA881\uA8B4-\uA8C4\uA8D0-\uA8D9\uA8F3-\uA8F7\uA900-\uA909\uA926-\uA92D\uA930-\uA945\uA980-\uA983\uA9B3-\uA9C0\uAA00-\uAA27\uAA40-\uAA41\uAA4C-\uAA4D\uAA50-\uAA59\uAA7B\uAAE0-\uAAE9\uAAF2-\uAAF3\uABC0-\uABE1\uABEC\uABED\uABF0-\uABF9\uFB20-\uFB28\uFE00-\uFE0F\uFE20-\uFE26\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F";
                    var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
                    var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
                    // Whether a single character denotes a newline.
                    var newline = /[\n\r\u2028\u2029]/;
                    // Matches a whole line break (where CRLF is considered a single
                    // line break). Used to count lines.
                    var lineBreak = /\r\n|[\n\r\u2028\u2029]/g;
                    // Test whether a given character code starts an identifier.
                    var isIdentifierStart = exports.isIdentifierStart = function(code) {
                        if (code < 65) return code === 36;
                        if (code < 91) return true;
                        if (code < 97) return code === 95;
                        if (code < 123) return true;
                        return code >= 0xaa && nonASCIIidentifierStart.test(String.fromCharCode(code));
                    };
                    // Test whether a given character is part of an identifier.
                    var isIdentifierChar = exports.isIdentifierChar = function(code) {
                        if (code < 48) return code === 36;
                        if (code < 58) return true;
                        if (code < 65) return false;
                        if (code < 91) return true;
                        if (code < 97) return code === 95;
                        if (code < 123) return true;
                        return code >= 0xaa && nonASCIIidentifier.test(String.fromCharCode(code));
                    };
                    // ## Tokenizer
                    // These are used when `options.locations` is on, for the
                    // `tokStartLoc` and `tokEndLoc` properties.
                    function line_loc_t() {
                        this.line = tokCurLine;
                        this.column = tokPos - tokLineStart;
                    }
                    // Reset the token state. Used at the start of a parse.
                    function initTokenState() {
                        tokCurLine = 1;
                        tokPos = tokLineStart = 0;
                        tokRegexpAllowed = true;
                        skipSpace();
                    }
                    // Called at the end of every token. Sets `tokEnd`, `tokVal`, and
                    // `tokRegexpAllowed`, and skips the space after the token, so that
                    // the next one's `tokStart` will point at the right position.
                    function finishToken(type, val) {
                        tokEnd = tokPos;
                        if (options.locations) tokEndLoc = new line_loc_t;
                        tokType = type;
                        skipSpace();
                        tokVal = val;
                        tokRegexpAllowed = type.beforeExpr;
                    }
                    function skipBlockComment() {
                        var startLoc = options.onComment && options.locations && new line_loc_t;
                        var start = tokPos, end = input.indexOf("*/", tokPos += 2);
                        if (end === -1) raise(tokPos - 2, "Unterminated comment");
                        tokPos = end + 2;
                        if (options.locations) {
                            lineBreak.lastIndex = start;
                            var match;
                            while((match = lineBreak.exec(input)) && match.index < tokPos){
                                ++tokCurLine;
                                tokLineStart = match.index + match[0].length;
                            }
                        }
                        if (options.onComment) options.onComment(true, input.slice(start + 2, end), start, tokPos, startLoc, options.locations && new line_loc_t);
                    }
                    function skipLineComment() {
                        var start = tokPos;
                        var startLoc = options.onComment && options.locations && new line_loc_t;
                        var ch = input.charCodeAt(tokPos += 2);
                        while(tokPos < inputLen && ch !== 10 && ch !== 13 && ch !== 8232 && ch !== 8233){
                            ++tokPos;
                            ch = input.charCodeAt(tokPos);
                        }
                        if (options.onComment) options.onComment(false, input.slice(start + 2, tokPos), start, tokPos, startLoc, options.locations && new line_loc_t);
                    }
                    // Called at the start of the parse and after every token. Skips
                    // whitespace and comments, and.
                    function skipSpace() {
                        while(tokPos < inputLen){
                            var ch = input.charCodeAt(tokPos);
                            if (ch === 32) ++tokPos;
                            else if (ch === 13) {
                                ++tokPos;
                                var next = input.charCodeAt(tokPos);
                                if (next === 10) ++tokPos;
                                if (options.locations) {
                                    ++tokCurLine;
                                    tokLineStart = tokPos;
                                }
                            } else if (ch === 10 || ch === 8232 || ch === 8233) {
                                ++tokPos;
                                if (options.locations) {
                                    ++tokCurLine;
                                    tokLineStart = tokPos;
                                }
                            } else if (ch > 8 && ch < 14) ++tokPos;
                            else if (ch === 47) {
                                var next = input.charCodeAt(tokPos + 1);
                                if (next === 42) skipBlockComment();
                                else if (next === 47) skipLineComment();
                                else break;
                            } else if (ch === 160) ++tokPos;
                            else if (ch >= 5760 && nonASCIIwhitespace.test(String.fromCharCode(ch))) ++tokPos;
                            else break;
                        }
                    }
                    // ### Token reading
                    // This is the function that is called to fetch the next token. It
                    // is somewhat obscure, because it works in character codes rather
                    // than characters, and because operator parsing has been inlined
                    // into it.
                    //
                    // All in the name of speed.
                    //
                    // The `forceRegexp` parameter is used in the one case where the
                    // `tokRegexpAllowed` trick does not work. See `parseStatement`.
                    function readToken_dot() {
                        var next = input.charCodeAt(tokPos + 1);
                        if (next >= 48 && next <= 57) return readNumber(true);
                        ++tokPos;
                        return finishToken(_dot);
                    }
                    function readToken_slash() {
                        var next = input.charCodeAt(tokPos + 1);
                        if (tokRegexpAllowed) {
                            ++tokPos;
                            return readRegexp();
                        }
                        if (next === 61) return finishOp(_assign, 2);
                        return finishOp(_slash, 1);
                    }
                    function readToken_mult_modulo() {
                        var next = input.charCodeAt(tokPos + 1);
                        if (next === 61) return finishOp(_assign, 2);
                        return finishOp(_multiplyModulo, 1);
                    }
                    function readToken_pipe_amp(code) {
                        var next = input.charCodeAt(tokPos + 1);
                        if (next === code) return finishOp(code === 124 ? _logicalOR : _logicalAND, 2);
                        if (next === 61) return finishOp(_assign, 2);
                        return finishOp(code === 124 ? _bitwiseOR : _bitwiseAND, 1);
                    }
                    function readToken_caret() {
                        var next = input.charCodeAt(tokPos + 1);
                        if (next === 61) return finishOp(_assign, 2);
                        return finishOp(_bitwiseXOR, 1);
                    }
                    function readToken_plus_min(code) {
                        var next = input.charCodeAt(tokPos + 1);
                        if (next === code) {
                            if (next == 45 && input.charCodeAt(tokPos + 2) == 62 && newline.test(input.slice(lastEnd, tokPos))) {
                                // A `-->` line comment
                                tokPos += 3;
                                skipLineComment();
                                skipSpace();
                                return readToken();
                            }
                            return finishOp(_incDec, 2);
                        }
                        if (next === 61) return finishOp(_assign, 2);
                        return finishOp(_plusMin, 1);
                    }
                    function readToken_lt_gt(code) {
                        var next = input.charCodeAt(tokPos + 1);
                        var size = 1;
                        if (next === code) {
                            size = code === 62 && input.charCodeAt(tokPos + 2) === 62 ? 3 : 2;
                            if (input.charCodeAt(tokPos + size) === 61) return finishOp(_assign, size + 1);
                            return finishOp(_bitShift, size);
                        }
                        if (next == 33 && code == 60 && input.charCodeAt(tokPos + 2) == 45 && input.charCodeAt(tokPos + 3) == 45) {
                            // `<!--`, an XML-style comment that should be interpreted as a line comment
                            tokPos += 4;
                            skipLineComment();
                            skipSpace();
                            return readToken();
                        }
                        if (next === 61) size = input.charCodeAt(tokPos + 2) === 61 ? 3 : 2;
                        return finishOp(_relational, size);
                    }
                    function readToken_eq_excl(code) {
                        var next = input.charCodeAt(tokPos + 1);
                        if (next === 61) return finishOp(_equality, input.charCodeAt(tokPos + 2) === 61 ? 3 : 2);
                        return finishOp(code === 61 ? _eq : _prefix, 1);
                    }
                    function getTokenFromCode(code) {
                        switch(code){
                            // The interpretation of a dot depends on whether it is followed
                            // by a digit.
                            case 46:
                                return readToken_dot();
                            // Punctuation tokens.
                            case 40:
                                ++tokPos;
                                return finishToken(_parenL);
                            case 41:
                                ++tokPos;
                                return finishToken(_parenR);
                            case 59:
                                ++tokPos;
                                return finishToken(_semi);
                            case 44:
                                ++tokPos;
                                return finishToken(_comma);
                            case 91:
                                ++tokPos;
                                return finishToken(_bracketL);
                            case 93:
                                ++tokPos;
                                return finishToken(_bracketR);
                            case 123:
                                ++tokPos;
                                return finishToken(_braceL);
                            case 125:
                                ++tokPos;
                                return finishToken(_braceR);
                            case 58:
                                ++tokPos;
                                return finishToken(_colon);
                            case 63:
                                ++tokPos;
                                return finishToken(_question);
                            // '0x' is a hexadecimal number.
                            case 48:
                                var next = input.charCodeAt(tokPos + 1);
                                if (next === 120 || next === 88) return readHexNumber();
                            // Anything else beginning with a digit is an integer, octal
                            // number, or float.
                            case 49:
                            case 50:
                            case 51:
                            case 52:
                            case 53:
                            case 54:
                            case 55:
                            case 56:
                            case 57:
                                return readNumber(false);
                            // Quotes produce strings.
                            case 34:
                            case 39:
                                return readString(code);
                            // Operators are parsed inline in tiny state machines. '=' (61) is
                            // often referred to. `finishOp` simply skips the amount of
                            // characters it is given as second argument, and returns a token
                            // of the type given by its first argument.
                            case 47:
                                return readToken_slash(code);
                            case 37:
                            case 42:
                                return readToken_mult_modulo();
                            case 124:
                            case 38:
                                return readToken_pipe_amp(code);
                            case 94:
                                return readToken_caret();
                            case 43:
                            case 45:
                                return readToken_plus_min(code);
                            case 60:
                            case 62:
                                return readToken_lt_gt(code);
                            case 61:
                            case 33:
                                return readToken_eq_excl(code);
                            case 126:
                                return finishOp(_prefix, 1);
                        }
                        return false;
                    }
                    function readToken(forceRegexp) {
                        if (!forceRegexp) tokStart = tokPos;
                        else tokPos = tokStart + 1;
                        if (options.locations) tokStartLoc = new line_loc_t;
                        if (forceRegexp) return readRegexp();
                        if (tokPos >= inputLen) return finishToken(_eof);
                        var code = input.charCodeAt(tokPos);
                        // Identifier or keyword. '\uXXXX' sequences are allowed in
                        // identifiers, so '\' also dispatches to that.
                        if (isIdentifierStart(code) || code === 92 /* '\' */ ) return readWord();
                        var tok = getTokenFromCode(code);
                        if (tok === false) {
                            // If we are here, we either found a non-ASCII identifier
                            // character, or something that's entirely disallowed.
                            var ch = String.fromCharCode(code);
                            if (ch === "\\" || nonASCIIidentifierStart.test(ch)) return readWord();
                            raise(tokPos, "Unexpected character '" + ch + "'");
                        }
                        return tok;
                    }
                    function finishOp(type, size) {
                        var str = input.slice(tokPos, tokPos + size);
                        tokPos += size;
                        finishToken(type, str);
                    }
                    // Parse a regular expression. Some context-awareness is necessary,
                    // since a '/' inside a '[]' set does not end the expression.
                    function readRegexp() {
                        // JS-Interpreter change:
                        // Removed redundant declaration of 'content' here.  Caused lint errors.
                        // -- Neil Fraser, June 2022.
                        var escaped, inClass, start = tokPos;
                        for(;;){
                            if (tokPos >= inputLen) raise(start, "Unterminated regular expression");
                            var ch = input.charAt(tokPos);
                            if (newline.test(ch)) raise(start, "Unterminated regular expression");
                            if (!escaped) {
                                if (ch === "[") inClass = true;
                                else if (ch === "]" && inClass) inClass = false;
                                else if (ch === "/" && !inClass) break;
                                escaped = ch === "\\";
                            } else escaped = false;
                            ++tokPos;
                        }
                        var content = input.slice(start, tokPos);
                        ++tokPos;
                        // Need to use `readWord1` because '\uXXXX' sequences are allowed
                        // here (don't ask).
                        var mods = readWord1();
                        // JS-Interpreter change:
                        // Acorn used to use 'gmsiy' to check for flags.  But 's' and 'y' are ES6.
                        // -- Neil Fraser, December 2022.
                        // https://github.com/acornjs/acorn/issues/1163
                        if (mods && !/^[gmi]*$/.test(mods)) raise(start, "Invalid regexp flag");
                        try {
                            var value = new RegExp(content, mods);
                        } catch (e) {
                            if (e instanceof SyntaxError) raise(start, e.message);
                            raise(e);
                        }
                        return finishToken(_regexp, value);
                    }
                    // Read an integer in the given radix. Return null if zero digits
                    // were read, the integer value otherwise. When `len` is given, this
                    // will return `null` unless the integer has exactly `len` digits.
                    function readInt(radix, len) {
                        var start = tokPos, total = 0;
                        for(var i = 0, e = len == null ? Infinity : len; i < e; ++i){
                            var code = input.charCodeAt(tokPos), val;
                            if (code >= 97) val = code - 97 + 10; // a
                            else if (code >= 65) val = code - 65 + 10; // A
                            else if (code >= 48 && code <= 57) val = code - 48; // 0-9
                            else val = Infinity;
                            if (val >= radix) break;
                            ++tokPos;
                            total = total * radix + val;
                        }
                        if (tokPos === start || len != null && tokPos - start !== len) return null;
                        return total;
                    }
                    function readHexNumber() {
                        tokPos += 2; // 0x
                        var val = readInt(16);
                        if (val == null) raise(tokStart + 2, "Expected hexadecimal number");
                        if (isIdentifierStart(input.charCodeAt(tokPos))) raise(tokPos, "Identifier directly after number");
                        return finishToken(_num, val);
                    }
                    // Read an integer, octal integer, or floating-point number.
                    function readNumber(startsWithDot) {
                        var start = tokPos, isFloat = false, octal = input.charCodeAt(tokPos) === 48;
                        if (!startsWithDot && readInt(10) === null) raise(start, "Invalid number");
                        if (input.charCodeAt(tokPos) === 46) {
                            ++tokPos;
                            readInt(10);
                            isFloat = true;
                        }
                        var next = input.charCodeAt(tokPos);
                        if (next === 69 || next === 101) {
                            next = input.charCodeAt(++tokPos);
                            if (next === 43 || next === 45) ++tokPos; // '+-'
                            if (readInt(10) === null) raise(start, "Invalid number");
                            isFloat = true;
                        }
                        if (isIdentifierStart(input.charCodeAt(tokPos))) raise(tokPos, "Identifier directly after number");
                        var str = input.slice(start, tokPos), val;
                        if (isFloat) val = parseFloat(str);
                        else if (!octal || str.length === 1) val = parseInt(str, 10);
                        else if (/[89]/.test(str) || strict) raise(start, "Invalid number");
                        else val = parseInt(str, 8);
                        return finishToken(_num, val);
                    }
                    // Read a string value, interpreting backslash-escapes.
                    function readString(quote) {
                        tokPos++;
                        var out = "";
                        for(;;){
                            if (tokPos >= inputLen) raise(tokStart, "Unterminated string constant");
                            var ch = input.charCodeAt(tokPos);
                            if (ch === quote) {
                                ++tokPos;
                                return finishToken(_string, out);
                            }
                            if (ch === 92) {
                                ch = input.charCodeAt(++tokPos);
                                var octal = /^[0-7]+/.exec(input.slice(tokPos, tokPos + 3));
                                if (octal) octal = octal[0];
                                while(octal && parseInt(octal, 8) > 255)octal = octal.slice(0, -1);
                                if (octal === "0") octal = null;
                                ++tokPos;
                                if (octal) {
                                    if (strict) raise(tokPos - 2, "Octal literal in strict mode");
                                    out += String.fromCharCode(parseInt(octal, 8));
                                    tokPos += octal.length - 1;
                                } else switch(ch){
                                    case 110:
                                        out += "\n";
                                        break; // 'n' -> '\n'
                                    case 114:
                                        out += "\r";
                                        break; // 'r' -> '\r'
                                    case 120:
                                        out += String.fromCharCode(readHexChar(2));
                                        break; // 'x'
                                    case 117:
                                        out += String.fromCharCode(readHexChar(4));
                                        break; // 'u'
                                    case 85:
                                        out += String.fromCharCode(readHexChar(8));
                                        break; // 'U'
                                    case 116:
                                        out += "	";
                                        break; // 't' -> '\t'
                                    case 98:
                                        out += "\b";
                                        break; // 'b' -> '\b'
                                    case 118:
                                        out += "\v";
                                        break; // 'v' -> '\u000b'
                                    case 102:
                                        out += "\f";
                                        break; // 'f' -> '\f'
                                    case 48:
                                        out += "\0";
                                        break; // 0 -> '\0'
                                    case 13:
                                        if (input.charCodeAt(tokPos) === 10) ++tokPos; // '\r\n'
                                    case 10:
                                        if (options.locations) {
                                            tokLineStart = tokPos;
                                            ++tokCurLine;
                                        }
                                        break;
                                    default:
                                        out += String.fromCharCode(ch);
                                        break;
                                }
                            } else {
                                if (ch === 13 || ch === 10 || ch === 8232 || ch === 8233) raise(tokStart, "Unterminated string constant");
                                out += String.fromCharCode(ch); // '\'
                                ++tokPos;
                            }
                        }
                    }
                    // Used to read character escape sequences ('\x', '\u', '\U').
                    function readHexChar(len) {
                        var n = readInt(16, len);
                        if (n === null) raise(tokStart, "Bad character escape sequence");
                        return n;
                    }
                    // Used to signal to callers of `readWord1` whether the word
                    // contained any escape sequences. This is needed because words with
                    // escape sequences must not be interpreted as keywords.
                    var containsEsc;
                    // Read an identifier, and return it as a string. Sets `containsEsc`
                    // to whether the word contained a '\u' escape.
                    //
                    // Only builds up the word character-by-character when it actually
                    // containeds an escape, as a micro-optimization.
                    function readWord1() {
                        containsEsc = false;
                        var word, first = true, start = tokPos;
                        for(;;){
                            var ch = input.charCodeAt(tokPos);
                            if (isIdentifierChar(ch)) {
                                if (containsEsc) word += input.charAt(tokPos);
                                ++tokPos;
                            } else if (ch === 92) {
                                if (!containsEsc) word = input.slice(start, tokPos);
                                containsEsc = true;
                                if (input.charCodeAt(++tokPos) != 117) raise(tokPos, "Expecting Unicode escape sequence \\uXXXX");
                                ++tokPos;
                                var esc = readHexChar(4);
                                var escStr = String.fromCharCode(esc);
                                if (!escStr) raise(tokPos - 1, "Invalid Unicode escape");
                                if (!(first ? isIdentifierStart(esc) : isIdentifierChar(esc))) raise(tokPos - 4, "Invalid Unicode escape");
                                word += escStr;
                            } else break;
                            first = false;
                        }
                        return containsEsc ? word : input.slice(start, tokPos);
                    }
                    // Read an identifier or keyword token. Will check for reserved
                    // words when necessary.
                    function readWord() {
                        var word = readWord1();
                        var type = _name;
                        if (!containsEsc && isKeyword(word)) type = keywordTypes[word];
                        return finishToken(type, word);
                    }
                    // ## Parser
                    // A recursive descent parser operates by defining functions for all
                    // syntactic elements, and recursively calling those, each function
                    // advancing the input stream and returning an AST node. Precedence
                    // of constructs (for example, the fact that `!x[1]` means `!(x[1])`
                    // instead of `(!x)[1]` is handled by the fact that the parser
                    // function that parses unary prefix operators is called first, and
                    // in turn calls the function that parses `[]` subscripts — that
                    // way, it'll receive the node for `x[1]` already parsed, and wraps
                    // *that* in the unary operator node.
                    //
                    // Acorn uses an [operator precedence parser][opp] to handle binary
                    // operator precedence, because it is much more compact than using
                    // the technique outlined above, which uses different, nesting
                    // functions to specify precedence, for all of the ten binary
                    // precedence levels that JavaScript defines.
                    //
                    // [opp]: http://en.wikipedia.org/wiki/Operator-precedence_parser
                    // ### Parser utilities
                    // Continue to the next token.
                    function next() {
                        lastStart = tokStart;
                        lastEnd = tokEnd;
                        lastEndLoc = tokEndLoc;
                        readToken();
                    }
                    // Enter strict mode. Re-reads the next token to please pedantic
                    // tests ("use strict"; 010; -- should fail).
                    function setStrict(strct) {
                        strict = strct;
                        tokPos = tokStart;
                        if (options.locations) while(tokPos < tokLineStart){
                            tokLineStart = input.lastIndexOf("\n", tokLineStart - 2) + 1;
                            --tokCurLine;
                        }
                        skipSpace();
                        readToken();
                    }
                    // Start an AST node, attaching a start offset.
                    function node_t() {
                        this.type = null;
                        this.start = tokStart;
                        this.end = null;
                    }
                    function node_loc_t() {
                        this.start = tokStartLoc;
                        this.end = null;
                        if (sourceFile !== null) this.source = sourceFile;
                    }
                    function startNode() {
                        var node = new node_t();
                        if (options.locations) node.loc = new node_loc_t();
                        if (options.directSourceFile) node.sourceFile = options.directSourceFile;
                        if (options.ranges) node.range = [
                            tokStart,
                            0
                        ];
                        return node;
                    }
                    // Start a node whose start offset information should be based on
                    // the start of another node. For example, a binary operator node is
                    // only started after its left-hand side has already been parsed.
                    function startNodeFrom(other) {
                        var node = new node_t();
                        node.start = other.start;
                        if (options.locations) {
                            node.loc = new node_loc_t();
                            node.loc.start = other.loc.start;
                        }
                        if (options.ranges) node.range = [
                            other.range[0],
                            0
                        ];
                        return node;
                    }
                    // Finish an AST node, adding `type` and `end` properties.
                    function finishNode(node, type) {
                        node.type = type;
                        node.end = lastEnd;
                        if (options.locations) node.loc.end = lastEndLoc;
                        if (options.ranges) node.range[1] = lastEnd;
                        return node;
                    }
                    // Test whether a statement node is the string literal `"use strict"`.
                    function isUseStrict(stmt) {
                        return stmt.type === "ExpressionStatement" && stmt.expression.type === "Literal" && stmt.expression.value === "use strict";
                    }
                    // Predicate that tests whether the next token is of the given
                    // type, and if yes, consumes it as a side effect.
                    function eat(type) {
                        if (tokType === type) {
                            next();
                            return true;
                        }
                    }
                    // Test whether a semicolon can be inserted at the current position.
                    function canInsertSemicolon() {
                        return !options.strictSemicolons && (tokType === _eof || tokType === _braceR || newline.test(input.slice(lastEnd, tokStart)));
                    }
                    // Consume a semicolon, or, failing that, see if we are allowed to
                    // pretend that there is a semicolon at this position.
                    function semicolon() {
                        if (!eat(_semi) && !canInsertSemicolon()) unexpected();
                    }
                    // Expect a token of a given type. If found, consume it, otherwise,
                    // raise an unexpected token error.
                    function expect(type) {
                        if (tokType === type) next();
                        else unexpected();
                    }
                    // Raise an unexpected token error.
                    function unexpected() {
                        raise(tokStart, "Unexpected token");
                    }
                    // Verify that a node is an lval — something that can be assigned
                    // to.
                    function checkLVal(expr) {
                        if (expr.type !== "Identifier" && expr.type !== "MemberExpression") raise(expr.start, "Assigning to rvalue");
                        if (strict && expr.type === "Identifier" && isStrictBadIdWord(expr.name)) raise(expr.start, "Assigning to " + expr.name + " in strict mode");
                    }
                    // ### Statement parsing
                    // Parse a program. Initializes the parser, reads any number of
                    // statements, and wraps them in a Program node.  Optionally takes a
                    // `program` argument.  If present, the statements will be appended
                    // to its body instead of creating a new node.
                    function parseTopLevel(program) {
                        lastStart = lastEnd = tokPos;
                        if (options.locations) lastEndLoc = new line_loc_t;
                        inFunction = strict = null;
                        labels = [];
                        readToken();
                        var node = program || startNode(), first = true;
                        if (!program) node.body = [];
                        while(tokType !== _eof){
                            var stmt = parseStatement();
                            node.body.push(stmt);
                            if (first && isUseStrict(stmt)) setStrict(true);
                            first = false;
                        }
                        return finishNode(node, "Program");
                    }
                    var loopLabel = {
                        kind: "loop"
                    }, switchLabel = {
                        kind: "switch"
                    };
                    // Parse a single statement.
                    //
                    // If expecting a statement and finding a slash operator, parse a
                    // regular expression literal. This is to handle cases like
                    // `if (foo) /blah/.exec(foo);`, where looking at the previous token
                    // does not help.
                    function parseStatement() {
                        if (tokType === _slash || tokType === _assign && tokVal == "/=") readToken(true);
                        var starttype = tokType, node = startNode();
                        // Most types of statements are recognized by the keyword they
                        // start with. Many are trivial to parse, some require a bit of
                        // complexity.
                        switch(starttype){
                            case _break:
                            case _continue:
                                next();
                                var isBreak = starttype === _break;
                                if (eat(_semi) || canInsertSemicolon()) node.label = null;
                                else if (tokType !== _name) unexpected();
                                else {
                                    node.label = parseIdent();
                                    semicolon();
                                }
                                // Verify that there is an actual destination to break or
                                // continue to.
                                for(var i = 0; i < labels.length; ++i){
                                    var lab = labels[i];
                                    if (node.label == null || lab.name === node.label.name) {
                                        if (lab.kind != null && (isBreak || lab.kind === "loop")) break;
                                        if (node.label && isBreak) break;
                                    }
                                }
                                if (i === labels.length) raise(node.start, "Unsyntactic " + starttype.keyword);
                                return finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement");
                            case _debugger:
                                next();
                                semicolon();
                                return finishNode(node, "DebuggerStatement");
                            case _do:
                                next();
                                labels.push(loopLabel);
                                node.body = parseStatement();
                                labels.pop();
                                expect(_while);
                                node.test = parseParenExpression();
                                semicolon();
                                return finishNode(node, "DoWhileStatement");
                            // Disambiguating between a `for` and a `for`/`in` loop is
                            // non-trivial. Basically, we have to parse the init `var`
                            // statement or expression, disallowing the `in` operator (see
                            // the second parameter to `parseExpression`), and then check
                            // whether the next token is `in`. When there is no init part
                            // (semicolon immediately after the opening parenthesis), it is
                            // a regular `for` loop.
                            case _for:
                                next();
                                labels.push(loopLabel);
                                expect(_parenL);
                                if (tokType === _semi) return parseFor(node, null);
                                if (tokType === _var) {
                                    var init = startNode();
                                    next();
                                    parseVar(init, true);
                                    finishNode(init, "VariableDeclaration");
                                    if (init.declarations.length === 1 && eat(_in)) return parseForIn(node, init);
                                    return parseFor(node, init);
                                }
                                var init = parseExpression(false, true);
                                if (eat(_in)) {
                                    checkLVal(init);
                                    return parseForIn(node, init);
                                }
                                return parseFor(node, init);
                            case _function:
                                next();
                                return parseFunction(node, true);
                            case _if:
                                next();
                                node.test = parseParenExpression();
                                node.consequent = parseStatement();
                                node.alternate = eat(_else) ? parseStatement() : null;
                                return finishNode(node, "IfStatement");
                            case _return:
                                if (!inFunction && !options.allowReturnOutsideFunction) raise(tokStart, "'return' outside of function");
                                next();
                                // In `return` (and `break`/`continue`), the keywords with
                                // optional arguments, we eagerly look for a semicolon or the
                                // possibility to insert one.
                                if (eat(_semi) || canInsertSemicolon()) node.argument = null;
                                else {
                                    node.argument = parseExpression();
                                    semicolon();
                                }
                                return finishNode(node, "ReturnStatement");
                            case _switch:
                                next();
                                node.discriminant = parseParenExpression();
                                node.cases = [];
                                expect(_braceL);
                                labels.push(switchLabel);
                                // Statements under must be grouped (by label) in SwitchCase
                                // nodes. `cur` is used to keep the node that we are currently
                                // adding statements to.
                                for(var cur, sawDefault; tokType != _braceR;)if (tokType === _case || tokType === _default) {
                                    var isCase = tokType === _case;
                                    if (cur) finishNode(cur, "SwitchCase");
                                    node.cases.push(cur = startNode());
                                    cur.consequent = [];
                                    next();
                                    if (isCase) cur.test = parseExpression();
                                    else {
                                        if (sawDefault) raise(lastStart, "Multiple default clauses");
                                        sawDefault = true;
                                        cur.test = null;
                                    }
                                    expect(_colon);
                                } else {
                                    if (!cur) unexpected();
                                    cur.consequent.push(parseStatement());
                                }
                                if (cur) finishNode(cur, "SwitchCase");
                                next(); // Closing brace
                                labels.pop();
                                return finishNode(node, "SwitchStatement");
                            case _throw:
                                next();
                                if (newline.test(input.slice(lastEnd, tokStart))) raise(lastEnd, "Illegal newline after throw");
                                node.argument = parseExpression();
                                semicolon();
                                return finishNode(node, "ThrowStatement");
                            case _try:
                                next();
                                node.block = parseBlock();
                                node.handler = null;
                                if (tokType === _catch) {
                                    var clause = startNode();
                                    next();
                                    expect(_parenL);
                                    clause.param = parseIdent();
                                    if (strict && isStrictBadIdWord(clause.param.name)) raise(clause.param.start, "Binding " + clause.param.name + " in strict mode");
                                    expect(_parenR);
                                    clause.guard = null;
                                    clause.body = parseBlock();
                                    node.handler = finishNode(clause, "CatchClause");
                                }
                                node.guardedHandlers = empty;
                                node.finalizer = eat(_finally) ? parseBlock() : null;
                                if (!node.handler && !node.finalizer) raise(node.start, "Missing catch or finally clause");
                                return finishNode(node, "TryStatement");
                            case _var:
                                next();
                                parseVar(node);
                                semicolon();
                                return finishNode(node, "VariableDeclaration");
                            case _while:
                                next();
                                node.test = parseParenExpression();
                                labels.push(loopLabel);
                                node.body = parseStatement();
                                labels.pop();
                                return finishNode(node, "WhileStatement");
                            case _with:
                                if (strict) raise(tokStart, "'with' in strict mode");
                                next();
                                node.object = parseParenExpression();
                                node.body = parseStatement();
                                return finishNode(node, "WithStatement");
                            case _braceL:
                                return parseBlock();
                            case _semi:
                                next();
                                return finishNode(node, "EmptyStatement");
                            // If the statement does not start with a statement keyword or a
                            // brace, it's an ExpressionStatement or LabeledStatement. We
                            // simply start parsing an expression, and afterwards, if the
                            // next token is a colon and the expression was a simple
                            // Identifier node, we switch to interpreting it as a label.
                            default:
                                var maybeName = tokVal, expr = parseExpression();
                                if (starttype === _name && expr.type === "Identifier" && eat(_colon)) {
                                    for(var i = 0; i < labels.length; ++i)if (labels[i].name === maybeName) raise(expr.start, "Label '" + maybeName + "' is already declared");
                                    var kind = tokType.isLoop ? "loop" : tokType === _switch ? "switch" : null;
                                    labels.push({
                                        name: maybeName,
                                        kind: kind
                                    });
                                    node.body = parseStatement();
                                    labels.pop();
                                    node.label = expr;
                                    return finishNode(node, "LabeledStatement");
                                } else {
                                    node.expression = expr;
                                    semicolon();
                                    return finishNode(node, "ExpressionStatement");
                                }
                        }
                    }
                    // Used for constructs like `switch` and `if` that insist on
                    // parentheses around their expression.
                    function parseParenExpression() {
                        expect(_parenL);
                        var val = parseExpression();
                        expect(_parenR);
                        return val;
                    }
                    // Parse a semicolon-enclosed block of statements, handling `"use
                    // strict"` declarations when `allowStrict` is true (used for
                    // function bodies).
                    function parseBlock(allowStrict) {
                        var node = startNode(), first = true, strict = false, oldStrict;
                        node.body = [];
                        expect(_braceL);
                        while(!eat(_braceR)){
                            var stmt = parseStatement();
                            node.body.push(stmt);
                            if (first && allowStrict && isUseStrict(stmt)) {
                                oldStrict = strict;
                                setStrict(strict = true);
                            }
                            first = false;
                        }
                        if (strict && !oldStrict) setStrict(false);
                        return finishNode(node, "BlockStatement");
                    }
                    // Parse a regular `for` loop. The disambiguation code in
                    // `parseStatement` will already have parsed the init statement or
                    // expression.
                    function parseFor(node, init) {
                        node.init = init;
                        expect(_semi);
                        node.test = tokType === _semi ? null : parseExpression();
                        expect(_semi);
                        node.update = tokType === _parenR ? null : parseExpression();
                        expect(_parenR);
                        node.body = parseStatement();
                        labels.pop();
                        return finishNode(node, "ForStatement");
                    }
                    // Parse a `for`/`in` loop.
                    function parseForIn(node, init) {
                        node.left = init;
                        node.right = parseExpression();
                        expect(_parenR);
                        node.body = parseStatement();
                        labels.pop();
                        return finishNode(node, "ForInStatement");
                    }
                    // Parse a list of variable declarations.
                    function parseVar(node, noIn) {
                        node.declarations = [];
                        node.kind = "var";
                        for(;;){
                            var decl = startNode();
                            decl.id = parseIdent();
                            if (strict && isStrictBadIdWord(decl.id.name)) raise(decl.id.start, "Binding " + decl.id.name + " in strict mode");
                            decl.init = eat(_eq) ? parseExpression(true, noIn) : null;
                            node.declarations.push(finishNode(decl, "VariableDeclarator"));
                            if (!eat(_comma)) break;
                        }
                        return node;
                    }
                    // ### Expression parsing
                    // These nest, from the most general expression type at the top to
                    // 'atomic', nondivisible expression types at the bottom. Most of
                    // the functions will simply let the function(s) below them parse,
                    // and, *if* the syntactic construct they handle is present, wrap
                    // the AST node that the inner parser gave them in another node.
                    // Parse a full expression. The arguments are used to forbid comma
                    // sequences (in argument lists, array literals, or object literals)
                    // or the `in` operator (in for loops initalization expressions).
                    function parseExpression(noComma, noIn) {
                        var expr = parseMaybeAssign(noIn);
                        if (!noComma && tokType === _comma) {
                            var node = startNodeFrom(expr);
                            node.expressions = [
                                expr
                            ];
                            while(eat(_comma))node.expressions.push(parseMaybeAssign(noIn));
                            return finishNode(node, "SequenceExpression");
                        }
                        return expr;
                    }
                    // Parse an assignment expression. This includes applications of
                    // operators like `+=`.
                    function parseMaybeAssign(noIn) {
                        var left = parseMaybeConditional(noIn);
                        if (tokType.isAssign) {
                            var node = startNodeFrom(left);
                            node.operator = tokVal;
                            node.left = left;
                            next();
                            node.right = parseMaybeAssign(noIn);
                            checkLVal(left);
                            return finishNode(node, "AssignmentExpression");
                        }
                        return left;
                    }
                    // Parse a ternary conditional (`?:`) operator.
                    function parseMaybeConditional(noIn) {
                        var expr = parseExprOps(noIn);
                        if (eat(_question)) {
                            var node = startNodeFrom(expr);
                            node.test = expr;
                            node.consequent = parseExpression(true);
                            expect(_colon);
                            node.alternate = parseExpression(true, noIn);
                            return finishNode(node, "ConditionalExpression");
                        }
                        return expr;
                    }
                    // Start the precedence parser.
                    function parseExprOps(noIn) {
                        return parseExprOp(parseMaybeUnary(), -1, noIn);
                    }
                    // Parse binary operators with the operator precedence parsing
                    // algorithm. `left` is the left-hand side of the operator.
                    // `minPrec` provides context that allows the function to stop and
                    // defer further parser to one of its callers when it encounters an
                    // operator that has a lower precedence than the set it is parsing.
                    function parseExprOp(left, minPrec, noIn) {
                        var prec = tokType.binop;
                        if (prec != null && (!noIn || tokType !== _in)) {
                            if (prec > minPrec) {
                                var node = startNodeFrom(left);
                                node.left = left;
                                node.operator = tokVal;
                                var op = tokType;
                                next();
                                node.right = parseExprOp(parseMaybeUnary(), prec, noIn);
                                var exprNode = finishNode(node, op === _logicalOR || op === _logicalAND ? "LogicalExpression" : "BinaryExpression");
                                return parseExprOp(exprNode, minPrec, noIn);
                            }
                        }
                        return left;
                    }
                    // Parse unary operators, both prefix and postfix.
                    function parseMaybeUnary() {
                        if (tokType.prefix) {
                            var node = startNode(), update = tokType.isUpdate;
                            node.operator = tokVal;
                            node.prefix = true;
                            tokRegexpAllowed = true;
                            next();
                            node.argument = parseMaybeUnary();
                            if (update) checkLVal(node.argument);
                            else if (strict && node.operator === "delete" && node.argument.type === "Identifier") raise(node.start, "Deleting local variable in strict mode");
                            return finishNode(node, update ? "UpdateExpression" : "UnaryExpression");
                        }
                        var expr = parseExprSubscripts();
                        while(tokType.postfix && !canInsertSemicolon()){
                            var node = startNodeFrom(expr);
                            node.operator = tokVal;
                            node.prefix = false;
                            node.argument = expr;
                            checkLVal(expr);
                            next();
                            expr = finishNode(node, "UpdateExpression");
                        }
                        return expr;
                    }
                    // Parse call, dot, and `[]`-subscript expressions.
                    function parseExprSubscripts() {
                        return parseSubscripts(parseExprAtom());
                    }
                    function parseSubscripts(base, noCalls) {
                        if (eat(_dot)) {
                            var node = startNodeFrom(base);
                            node.object = base;
                            node.property = parseIdent(true);
                            node.computed = false;
                            return parseSubscripts(finishNode(node, "MemberExpression"), noCalls);
                        } else if (eat(_bracketL)) {
                            var node = startNodeFrom(base);
                            node.object = base;
                            node.property = parseExpression();
                            node.computed = true;
                            expect(_bracketR);
                            return parseSubscripts(finishNode(node, "MemberExpression"), noCalls);
                        } else if (!noCalls && eat(_parenL)) {
                            var node = startNodeFrom(base);
                            node.callee = base;
                            node.arguments = parseExprList(_parenR, false);
                            return parseSubscripts(finishNode(node, "CallExpression"), noCalls);
                        } else return base;
                    }
                    // Parse an atomic expression — either a single token that is an
                    // expression, an expression started by a keyword like `function` or
                    // `new`, or an expression wrapped in punctuation like `()`, `[]`,
                    // or `{}`.
                    function parseExprAtom() {
                        switch(tokType){
                            case _this:
                                var node = startNode();
                                next();
                                return finishNode(node, "ThisExpression");
                            case _name:
                                return parseIdent();
                            case _num:
                            case _string:
                            case _regexp:
                                var node = startNode();
                                node.value = tokVal;
                                node.raw = input.slice(tokStart, tokEnd);
                                next();
                                return finishNode(node, "Literal");
                            case _null:
                            case _true:
                            case _false:
                                var node = startNode();
                                node.value = tokType.atomValue;
                                node.raw = tokType.keyword;
                                next();
                                return finishNode(node, "Literal");
                            case _parenL:
                                var tokStartLoc1 = tokStartLoc, tokStart1 = tokStart;
                                next();
                                var val = parseExpression();
                                val.start = tokStart1;
                                val.end = tokEnd;
                                if (options.locations) {
                                    val.loc.start = tokStartLoc1;
                                    val.loc.end = tokEndLoc;
                                }
                                if (options.ranges) val.range = [
                                    tokStart1,
                                    tokEnd
                                ];
                                expect(_parenR);
                                return val;
                            case _bracketL:
                                var node = startNode();
                                next();
                                node.elements = parseExprList(_bracketR, true, true);
                                return finishNode(node, "ArrayExpression");
                            case _braceL:
                                return parseObj();
                            case _function:
                                var node = startNode();
                                next();
                                return parseFunction(node, false);
                            case _new:
                                return parseNew();
                            default:
                                unexpected();
                        }
                    }
                    // New's precedence is slightly tricky. It must allow its argument
                    // to be a `[]` or dot subscript expression, but not a call — at
                    // least, not without wrapping it in parentheses. Thus, it uses the
                    function parseNew() {
                        var node = startNode();
                        next();
                        node.callee = parseSubscripts(parseExprAtom(), true);
                        if (eat(_parenL)) node.arguments = parseExprList(_parenR, false);
                        else node.arguments = empty;
                        return finishNode(node, "NewExpression");
                    }
                    // Parse an object literal.
                    function parseObj() {
                        var node = startNode(), first = true, sawGetSet = false;
                        node.properties = [];
                        next();
                        while(!eat(_braceR)){
                            if (!first) {
                                expect(_comma);
                                if (options.allowTrailingCommas && eat(_braceR)) break;
                            } else first = false;
                            var prop = {
                                key: parsePropertyName()
                            }, isGetSet = false, kind;
                            if (eat(_colon)) {
                                prop.value = parseExpression(true);
                                kind = prop.kind = "init";
                            } else if (prop.key.type === "Identifier" && (prop.key.name === "get" || prop.key.name === "set")) {
                                isGetSet = sawGetSet = true;
                                kind = prop.kind = prop.key.name;
                                prop.key = parsePropertyName();
                                if (tokType !== _parenL) unexpected();
                                prop.value = parseFunction(startNode(), false);
                            } else unexpected();
                            // getters and setters are not allowed to clash — either with
                            // each other or with an init property — and in strict mode,
                            // init properties are also not allowed to be repeated.
                            if (prop.key.type === "Identifier" && (strict || sawGetSet)) for(var i = 0; i < node.properties.length; ++i){
                                var other = node.properties[i];
                                if (other.key.name === prop.key.name) {
                                    var conflict = kind == other.kind || isGetSet && other.kind === "init" || kind === "init" && (other.kind === "get" || other.kind === "set");
                                    if (conflict && !strict && kind === "init" && other.kind === "init") conflict = false;
                                    if (conflict) raise(prop.key.start, "Redefinition of property");
                                }
                            }
                            node.properties.push(prop);
                        }
                        return finishNode(node, "ObjectExpression");
                    }
                    function parsePropertyName() {
                        if (tokType === _num || tokType === _string) return parseExprAtom();
                        return parseIdent(true);
                    }
                    // Parse a function declaration or literal (depending on the
                    // `isStatement` parameter).
                    function parseFunction(node, isStatement) {
                        if (tokType === _name) node.id = parseIdent();
                        else if (isStatement) unexpected();
                        else node.id = null;
                        node.params = [];
                        var first = true;
                        expect(_parenL);
                        while(!eat(_parenR)){
                            if (!first) expect(_comma);
                            else first = false;
                            node.params.push(parseIdent());
                        }
                        // Start a new scope with regard to labels and the `inFunction`
                        // flag (restore them to their old value afterwards).
                        var oldInFunc = inFunction, oldLabels = labels;
                        inFunction = true;
                        labels = [];
                        node.body = parseBlock(true);
                        inFunction = oldInFunc;
                        labels = oldLabels;
                        // If this is a strict mode function, verify that argument names
                        // are not repeated, and it does not try to bind the words `eval`
                        // or `arguments`.
                        if (strict || node.body.body.length && isUseStrict(node.body.body[0])) for(var i = node.id ? -1 : 0; i < node.params.length; ++i){
                            var id = i < 0 ? node.id : node.params[i];
                            if (isStrictReservedWord(id.name) || isStrictBadIdWord(id.name)) raise(id.start, "Defining '" + id.name + "' in strict mode");
                            if (i >= 0) {
                                for(var j = 0; j < i; ++j)if (id.name === node.params[j].name) raise(id.start, "Argument name clash in strict mode");
                            }
                        }
                        return finishNode(node, isStatement ? "FunctionDeclaration" : "FunctionExpression");
                    }
                    // Parses a comma-separated list of expressions, and returns them as
                    // an array. `close` is the token type that ends the list, and
                    // `allowEmpty` can be turned on to allow subsequent commas with
                    // nothing in between them to be parsed as `null` (which is needed
                    // for array literals).
                    function parseExprList(close, allowTrailingComma, allowEmpty) {
                        var elts = [], first = true;
                        while(!eat(close)){
                            if (!first) {
                                expect(_comma);
                                if (allowTrailingComma && options.allowTrailingCommas && eat(close)) break;
                            } else first = false;
                            if (allowEmpty && tokType === _comma) elts.push(null);
                            else elts.push(parseExpression(true));
                        }
                        return elts;
                    }
                    // Parse the next token as an identifier. If `liberal` is true (used
                    // when parsing properties), it will also convert keywords into
                    // identifiers.
                    function parseIdent(liberal) {
                        var node = startNode();
                        if (liberal && options.forbidReserved == "everywhere") liberal = false;
                        if (tokType === _name) {
                            if (!liberal && (options.forbidReserved && isReservedWord5(tokVal) || strict && isStrictReservedWord(tokVal)) && input.slice(tokStart, tokEnd).indexOf("\\") == -1) raise(tokStart, "The keyword '" + tokVal + "' is reserved");
                            node.name = tokVal;
                        } else if (liberal && tokType.keyword) node.name = tokType.keyword;
                        else unexpected();
                        tokRegexpAllowed = false;
                        next();
                        return finishNode(node, "Identifier");
                    }
                });
            /***/ },
            /***/ "vm": /*!*********************!*\
  !*** external "vm" ***!
  \*********************/ /***/ (module1)=>{
                "use strict";
                module1.exports = (parcelRequire("aeJDW"));
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = (exports, definition)=>{
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
            /******/ __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        /******/ })();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ (()=>{
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = (exports)=>{
                /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
                /******/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be in strict mode.
        (()=>{
            "use strict";
            /*!*******************************!*\
  !*** ./src/js-interpreter.js ***!
  \*******************************/ __webpack_require__.r(__webpack_exports__);
            /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                /* harmony export */ "default": ()=>__WEBPACK_DEFAULT_EXPORT__
            });
            const acorn = __webpack_require__(/*! ../original-repo/acorn */ "./original-repo/acorn.js");
            globalThis.acorn = acorn;
            const { Interpreter: Interpreter } = __webpack_require__(/*! ../original-repo/interpreter */ "./original-repo/interpreter.js");
            /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = Interpreter;
        })();
        __webpack_exports__ = __webpack_exports__["default"];
        /******/ return __webpack_exports__;
    /******/ })();
});


var $be4a4d061f6e4fbb$exports = {};
"use strict";
function $be4a4d061f6e4fbb$var$nullthrows(x, message) {
    if (x != null) return x;
    var error = new Error(message !== undefined ? message : "Got unexpected " + x);
    error.framesToPop = 1; // Skip nullthrows's own stack frame.
    throw error;
}
$be4a4d061f6e4fbb$exports = $be4a4d061f6e4fbb$var$nullthrows;
$be4a4d061f6e4fbb$exports.default = $be4a4d061f6e4fbb$var$nullthrows;
Object.defineProperty($be4a4d061f6e4fbb$exports, "__esModule", {
    value: true
});



var $acw62 = parcelRequire("acw62");

class $f94cb1d9064fd995$export$1760ba21304ed9c4 {
    message;
    constructor(message){
        this.message = message;
    }
}
function $f94cb1d9064fd995$export$9e1c2a6f2489e8ee({ globalFunctions: globalFunctions, executionInterval: executionInterval, onStep: onStep }) {
    const toast = (0, $4957fb6187c9a2f5$export$a407b657d3044108)();
    const jsInterpreterRef = (0, $acw62.useRef)();
    /**
   * Blockly から {@link STATEMENT_PREFIX_FUNCTION} 関数の呼び出しが各ステートメントの前に挿入される。
   * このときのブロック ID を格納する。
   */ const highlightedBlockIdRef = (0, $acw62.useRef)();
    const [executionState, setExecutionState] = (0, $acw62.useState)("stopped");
    const prepareExecution = (0, $acw62.useCallback)((code)=>{
        jsInterpreterRef.current = new (0, (/*@__PURE__*/$parcel$interopDefault($920a9dc6ef3f7a6b$exports)))(code, (newInterpreter, globalScope)=>{
            Object.entries(globalFunctions).forEach(([functionName, globalFunction])=>{
                newInterpreter.setProperty(globalScope, functionName, newInterpreter.createNativeFunction(globalFunction));
            });
            newInterpreter.setProperty(globalScope, (0, $4dac3bd746fe0f69$export$c8c2787436d1a72f), newInterpreter.createNativeFunction((blockId)=>{
                highlightedBlockIdRef.current = blockId;
                onStep?.(blockId);
            }));
        });
    }, [
        globalFunctions,
        onStep
    ]);
    const startExecution = (0, $acw62.useCallback)((code)=>{
        prepareExecution(code);
        setExecutionState("running");
    }, [
        prepareExecution
    ]);
    const pauseExecution = (0, $acw62.useCallback)(()=>{
        setExecutionState("paused");
    }, []);
    const resumeExecution = (0, $acw62.useCallback)(()=>{
        setExecutionState("running");
    }, []);
    const finishExecution = (0, $acw62.useCallback)(()=>{
        onStep?.(null);
        highlightedBlockIdRef.current = undefined;
        setExecutionState("finished");
    }, [
        onStep
    ]);
    const stopExecution = (0, $acw62.useCallback)(()=>{
        onStep?.(null);
        highlightedBlockIdRef.current = undefined;
        setExecutionState("stopped");
    }, [
        onStep
    ]);
    const getVariable = (0, $acw62.useCallback)((name)=>{
        const jsInterpreter = (0, (/*@__PURE__*/$parcel$interopDefault($be4a4d061f6e4fbb$exports)))(jsInterpreterRef.current);
        return jsInterpreter.getValueFromScope(name);
    }, []);
    const listenersRef = (0, $acw62.useRef)({
        step: new Set()
    });
    const addListener = (0, $acw62.useCallback)((type, listener)=>{
        listenersRef.current[type].add(listener);
    }, []);
    const removeListener = (0, $acw62.useCallback)((type, listener)=>{
        listenersRef.current[type].delete(listener);
    }, []);
    const stepExecution = (0, $acw62.useCallback)(()=>{
        const jsInterpreter = jsInterpreterRef.current;
        if (!jsInterpreter) return;
        try {
            let loopTrap = 0;
            // eslint-disable-next-line no-constant-condition
            while(true){
                if (!jsInterpreter.step()) {
                    finishExecution();
                    return;
                }
                // ステップが正常に終了すれば highlightedBlockIdRef.current にはブロック ID が格納されている。
                if (highlightedBlockIdRef.current) {
                    highlightedBlockIdRef.current = undefined;
                    loopTrap = 0;
                    listenersRef.current.step.forEach((listener)=>listener());
                    return;
                }
                loopTrap += 1;
                if (loopTrap > 10000) throw new Error("\u7121\u9650\u30EB\u30FC\u30D7\u306B\u5165\u3063\u3066\u3057\u307E\u3063\u305F\u3088\u3046\u3067\u3059\u3002");
            }
        } catch (e) {
            if (e instanceof Error) {
                toast({
                    title: "\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
                    status: "error",
                    description: e.message
                });
                finishExecution();
                return;
            }
            if (e instanceof $f94cb1d9064fd995$export$1760ba21304ed9c4) {
                toast({
                    title: "\u30E1\u30C3\u30BB\u30FC\u30B8",
                    status: "info",
                    description: e.message
                });
                finishExecution();
                return;
            }
            toast({
                title: "\u539F\u56E0\u4E0D\u660E\u306E\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
                status: "error"
            });
            finishExecution();
        }
    }, [
        toast,
        finishExecution
    ]);
    (0, $acw62.useEffect)(()=>{
        if (executionState !== "running") return undefined;
        let timerId = Number.NaN;
        const loopFunction = ()=>{
            stepExecution();
            timerId = window.setTimeout(loopFunction, executionInterval);
        };
        timerId = window.setTimeout(loopFunction, executionInterval);
        return ()=>{
            clearTimeout(timerId);
        };
    }, [
        executionInterval,
        executionState,
        stepExecution
    ]);
    return {
        state: executionState,
        start: startExecution,
        step: stepExecution,
        pause: pauseExecution,
        resume: resumeExecution,
        stop: stopExecution,
        getVariable: getVariable,
        addListener: addListener,
        removeListener: removeListener
    };
}







var $acw62 = parcelRequire("acw62");

"use client";
function $e8899b8ecf9820a0$export$7301e09313e4cf1b(prop, state) {
    const controlled = typeof prop !== "undefined";
    const value = controlled ? prop : state;
    return (0, $acw62.useMemo)(()=>[
            controlled,
            value
        ], [
        controlled,
        value
    ]);
}
function $e8899b8ecf9820a0$export$6f32135080cb4c3(props) {
    const { value: valueProp, defaultValue: defaultValue, onChange: onChange, shouldUpdate: shouldUpdate = (prev, next)=>prev !== next } = props;
    const onChangeProp = (0, $5aeabd701a2e12e7$export$25bec8c6f54ee79a)(onChange);
    const shouldUpdateProp = (0, $5aeabd701a2e12e7$export$25bec8c6f54ee79a)(shouldUpdate);
    const [uncontrolledState, setUncontrolledState] = (0, $acw62.useState)(defaultValue);
    const controlled = valueProp !== void 0;
    const value = controlled ? valueProp : uncontrolledState;
    const setValue = (0, $5aeabd701a2e12e7$export$25bec8c6f54ee79a)((next)=>{
        const setter = next;
        const nextValue = typeof next === "function" ? setter(value) : next;
        if (!shouldUpdateProp(value, nextValue)) return;
        if (!controlled) setUncontrolledState(nextValue);
        onChangeProp(nextValue);
    }, [
        controlled,
        onChangeProp,
        value,
        shouldUpdateProp
    ]);
    return [
        value,
        setValue
    ];
}


var $acw62 = parcelRequire("acw62");
"use client";
function $f828771078a53118$export$bcd07ba85a740103(value) {
    const ref = (0, $acw62.useRef)(null);
    ref.current = value;
    return ref;
}

function $caa5be63617d4d4a$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return ()=>{
        target.removeEventListener(eventName, handler, options);
    };
}



function $69ccfed70194f13c$export$f21a1ffae260145a(node) {
    return $69ccfed70194f13c$export$b204af158042fbac(node)?.defaultView ?? window;
}
function $69ccfed70194f13c$export$b204af158042fbac(node) {
    return (0, $225a75bff56eb0c3$export$1b3bfaa9684536aa)(node) ? node.ownerDocument : document;
}
function $69ccfed70194f13c$export$8d16348623687f6(event) {
    return event.view ?? window;
}
function $69ccfed70194f13c$export$cd4e5573fbe2b576(node) {
    return $69ccfed70194f13c$export$b204af158042fbac(node).activeElement;
}


function $f889b9c519e501cc$export$764db16956f554f8(event) {
    const win = (0, $69ccfed70194f13c$export$8d16348623687f6)(event);
    if (typeof win.PointerEvent !== "undefined" && event instanceof win.PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof win.MouseEvent;
}
function $f889b9c519e501cc$export$c4dfce035d43d1e0(event) {
    const hasTouches = !!event.touches;
    return hasTouches;
}
function $f889b9c519e501cc$export$d06464d6b74eedc4(event) {
    return $f889b9c519e501cc$export$c4dfce035d43d1e0(event) && event.touches.length > 1;
}



function $866b63cd48bf27b5$var$pointFromTouch(e, type = "page") {
    const point = e.touches[0] || e.changedTouches[0];
    return {
        x: point[`${type}X`],
        y: point[`${type}Y`]
    };
}
function $866b63cd48bf27b5$var$pointFromMouse(point, type = "page") {
    return {
        x: point[`${type}X`],
        y: point[`${type}Y`]
    };
}
function $866b63cd48bf27b5$export$a8637644cbd23a7b(event, type = "page") {
    return (0, $f889b9c519e501cc$export$c4dfce035d43d1e0)(event) ? $866b63cd48bf27b5$var$pointFromTouch(event, type) : $866b63cd48bf27b5$var$pointFromMouse(event, type);
}


function $9efa4efc2b7cd6d5$var$filter(cb) {
    return (event)=>{
        const isMouse = (0, $f889b9c519e501cc$export$764db16956f554f8)(event);
        if (!isMouse || isMouse && event.button === 0) cb(event);
    };
}
function $9efa4efc2b7cd6d5$var$wrap(cb, filterPrimary = false) {
    function listener(event) {
        cb(event, {
            point: (0, $866b63cd48bf27b5$export$a8637644cbd23a7b)(event)
        });
    }
    const fn = filterPrimary ? $9efa4efc2b7cd6d5$var$filter(listener) : listener;
    return fn;
}
function $9efa4efc2b7cd6d5$export$fcff2e64e6676b81(target, type, cb, options) {
    return (0, $caa5be63617d4d4a$export$b1d829ddf82884aa)(target, type, $9efa4efc2b7cd6d5$var$wrap(cb, type === "pointerdown"), options);
}



var $acw62 = parcelRequire("acw62");


const $1c49e3de0f86bd12$export$f8caf8121275292d = 1 / 60 * 1000;
const $1c49e3de0f86bd12$var$getCurrentTime = typeof performance !== "undefined" ? ()=>performance.now() : ()=>Date.now();
const $1c49e3de0f86bd12$export$4fdea63ab5513fd5 = typeof window !== "undefined" ? (callback)=>window.requestAnimationFrame(callback) : (callback)=>setTimeout(()=>callback($1c49e3de0f86bd12$var$getCurrentTime()), $1c49e3de0f86bd12$export$f8caf8121275292d);


function $56b75657d7530209$export$b995e5e85f5c8289(runNextFrame) {
    let toRun = [];
    let toRunNextFrame = [];
    let numToRun = 0;
    let isProcessing = false;
    let flushNextFrame = false;
    const toKeepAlive = new WeakSet();
    const step = {
        schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        cancel: (callback)=>{
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: (frameData)=>{
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [
                toRunNextFrame,
                toRun
            ];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $741aad569b766a4c$var$maxElapsed = 40;
let $741aad569b766a4c$var$useDefaultElapsed = true;
let $741aad569b766a4c$var$runNextFrame = false;
let $741aad569b766a4c$var$isProcessing = false;
const $741aad569b766a4c$var$frame = {
    delta: 0,
    timestamp: 0
};
const $741aad569b766a4c$var$stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $741aad569b766a4c$var$steps = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = (0, $56b75657d7530209$export$b995e5e85f5c8289)(()=>$741aad569b766a4c$var$runNextFrame = true);
    return acc;
}, {});
const $741aad569b766a4c$var$sync = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    const step = $741aad569b766a4c$var$steps[key];
    acc[key] = (process, keepAlive = false, immediate = false)=>{
        if (!$741aad569b766a4c$var$runNextFrame) $741aad569b766a4c$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const $741aad569b766a4c$export$d93e9c1fe0553512 = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = $741aad569b766a4c$var$steps[key].cancel;
    return acc;
}, {});
const $741aad569b766a4c$export$cd75ccfd720a3cd4 = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = ()=>$741aad569b766a4c$var$steps[key].process($741aad569b766a4c$var$frame);
    return acc;
}, {});
const $741aad569b766a4c$var$processStep = (stepId)=>$741aad569b766a4c$var$steps[stepId].process($741aad569b766a4c$var$frame);
const $741aad569b766a4c$var$processFrame = (timestamp)=>{
    $741aad569b766a4c$var$runNextFrame = false;
    $741aad569b766a4c$var$frame.delta = $741aad569b766a4c$var$useDefaultElapsed ? (0, $1c49e3de0f86bd12$export$f8caf8121275292d) : Math.max(Math.min(timestamp - $741aad569b766a4c$var$frame.timestamp, $741aad569b766a4c$var$maxElapsed), 1);
    $741aad569b766a4c$var$frame.timestamp = timestamp;
    $741aad569b766a4c$var$isProcessing = true;
    $741aad569b766a4c$var$stepsOrder.forEach($741aad569b766a4c$var$processStep);
    $741aad569b766a4c$var$isProcessing = false;
    if ($741aad569b766a4c$var$runNextFrame) {
        $741aad569b766a4c$var$useDefaultElapsed = false;
        (0, $1c49e3de0f86bd12$export$4fdea63ab5513fd5)($741aad569b766a4c$var$processFrame);
    }
};
const $741aad569b766a4c$var$startLoop = ()=>{
    $741aad569b766a4c$var$runNextFrame = true;
    $741aad569b766a4c$var$useDefaultElapsed = true;
    if (!$741aad569b766a4c$var$isProcessing) (0, $1c49e3de0f86bd12$export$4fdea63ab5513fd5)($741aad569b766a4c$var$processFrame);
};
const $741aad569b766a4c$export$7244445918e670ed = ()=>$741aad569b766a4c$var$frame;
var $741aad569b766a4c$export$2e2bcd8739ae039 = $741aad569b766a4c$var$sync;


"use client";
var $a7bd3f1d4e2f0217$var$__defProp = Object.defineProperty;
var $a7bd3f1d4e2f0217$var$__defNormalProp = (obj, key, value)=>key in obj ? $a7bd3f1d4e2f0217$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a7bd3f1d4e2f0217$var$__publicField = (obj, key, value)=>{
    $a7bd3f1d4e2f0217$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
class $a7bd3f1d4e2f0217$export$3a7c8887437719ed {
    constructor(event, handlers, threshold){
        /**
     * We use this to keep track of the `x` and `y` pan session history
     * as the pan event happens. It helps to calculate the `offset` and `delta`
     */ $a7bd3f1d4e2f0217$var$__publicField(this, "history", []);
        // The pointer event that started the pan session
        $a7bd3f1d4e2f0217$var$__publicField(this, "startEvent", null);
        // The current pointer event for the pan session
        $a7bd3f1d4e2f0217$var$__publicField(this, "lastEvent", null);
        // The current pointer event info for the pan session
        $a7bd3f1d4e2f0217$var$__publicField(this, "lastEventInfo", null);
        $a7bd3f1d4e2f0217$var$__publicField(this, "handlers", {});
        $a7bd3f1d4e2f0217$var$__publicField(this, "removeListeners", ()=>{});
        /**
     * Minimal pan distance required before recognizing the pan.
     * @default "3px"
     */ $a7bd3f1d4e2f0217$var$__publicField(this, "threshold", 3);
        $a7bd3f1d4e2f0217$var$__publicField(this, "win");
        $a7bd3f1d4e2f0217$var$__publicField(this, "updatePoint", ()=>{
            if (!(this.lastEvent && this.lastEventInfo)) return;
            const info = $a7bd3f1d4e2f0217$var$getPanInfo(this.lastEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            const isDistancePastThreshold = $a7bd3f1d4e2f0217$export$9f17032d917177de(info.offset, {
                x: 0,
                y: 0
            }) >= this.threshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { timestamp: timestamp } = (0, $741aad569b766a4c$export$7244445918e670ed)();
            this.history.push({
                ...info.point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart?.(this.lastEvent, info);
                this.startEvent = this.lastEvent;
            }
            onMove?.(this.lastEvent, info);
        });
        $a7bd3f1d4e2f0217$var$__publicField(this, "onPointerMove", (event, info)=>{
            this.lastEvent = event;
            this.lastEventInfo = info;
            (0, $741aad569b766a4c$export$2e2bcd8739ae039).update(this.updatePoint, true);
        });
        $a7bd3f1d4e2f0217$var$__publicField(this, "onPointerUp", (event, info)=>{
            const panInfo = $a7bd3f1d4e2f0217$var$getPanInfo(info, this.history);
            const { onEnd: onEnd, onSessionEnd: onSessionEnd } = this.handlers;
            onSessionEnd?.(event, panInfo);
            this.end();
            if (!onEnd || !this.startEvent) return;
            onEnd?.(event, panInfo);
        });
        this.win = event.view ?? window;
        if ((0, $f889b9c519e501cc$export$d06464d6b74eedc4)(event)) return;
        this.handlers = handlers;
        if (threshold) this.threshold = threshold;
        event.stopPropagation();
        event.preventDefault();
        const info = {
            point: (0, $866b63cd48bf27b5$export$a8637644cbd23a7b)(event)
        };
        const { timestamp: timestamp } = (0, $741aad569b766a4c$export$7244445918e670ed)();
        this.history = [
            {
                ...info.point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart?.(event, $a7bd3f1d4e2f0217$var$getPanInfo(info, this.history));
        this.removeListeners = $a7bd3f1d4e2f0217$var$pipe((0, $9efa4efc2b7cd6d5$export$fcff2e64e6676b81)(this.win, "pointermove", this.onPointerMove), (0, $9efa4efc2b7cd6d5$export$fcff2e64e6676b81)(this.win, "pointerup", this.onPointerUp), (0, $9efa4efc2b7cd6d5$export$fcff2e64e6676b81)(this.win, "pointercancel", this.onPointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners?.();
        (0, $741aad569b766a4c$export$d93e9c1fe0553512).update(this.updatePoint);
    }
}
function $a7bd3f1d4e2f0217$var$subtract(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $a7bd3f1d4e2f0217$var$getPanInfo(info, history) {
    return {
        point: info.point,
        delta: $a7bd3f1d4e2f0217$var$subtract(info.point, history[history.length - 1]),
        offset: $a7bd3f1d4e2f0217$var$subtract(info.point, history[0]),
        velocity: $a7bd3f1d4e2f0217$var$getVelocity(history, 0.1)
    };
}
const $a7bd3f1d4e2f0217$var$toMilliseconds = (v)=>v * 1e3;
function $a7bd3f1d4e2f0217$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = history[history.length - 1];
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > $a7bd3f1d4e2f0217$var$toMilliseconds(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1e3;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}
function $a7bd3f1d4e2f0217$var$pipe(...fns) {
    return (v)=>fns.reduce((a, b)=>b(a), v);
}
function $a7bd3f1d4e2f0217$var$distance1D(a, b) {
    return Math.abs(a - b);
}
function $a7bd3f1d4e2f0217$var$isPoint(point) {
    return "x" in point && "y" in point;
}
function $a7bd3f1d4e2f0217$export$9f17032d917177de(a, b) {
    if (typeof a === "number" && typeof b === "number") return $a7bd3f1d4e2f0217$var$distance1D(a, b);
    if ($a7bd3f1d4e2f0217$var$isPoint(a) && $a7bd3f1d4e2f0217$var$isPoint(b)) {
        const xDelta = $a7bd3f1d4e2f0217$var$distance1D(a.x, b.x);
        const yDelta = $a7bd3f1d4e2f0217$var$distance1D(a.y, b.y);
        return Math.sqrt(xDelta ** 2 + yDelta ** 2);
    }
    return 0;
}


"use client";
function $a05802077a261c0d$export$9ad22d853bfe2640(ref, options) {
    const { onPan: onPan, onPanStart: onPanStart, onPanEnd: onPanEnd, onPanSessionStart: onPanSessionStart, onPanSessionEnd: onPanSessionEnd, threshold: threshold } = options;
    const hasPanEvents = Boolean(onPan || onPanStart || onPanEnd || onPanSessionStart || onPanSessionEnd);
    const panSession = (0, $acw62.useRef)(null);
    const handlersRef = (0, $f828771078a53118$export$bcd07ba85a740103)({
        onSessionStart: onPanSessionStart,
        onSessionEnd: onPanSessionEnd,
        onStart: onPanStart,
        onMove: onPan,
        onEnd (event, info) {
            panSession.current = null;
            onPanEnd?.(event, info);
        }
    });
    (0, $acw62.useEffect)(()=>{
        panSession.current?.updateHandlers(handlersRef.current);
    });
    (0, $acw62.useEffect)(()=>{
        const node = ref.current;
        if (!node || !hasPanEvents) return;
        function onPointerDown(event) {
            panSession.current = new (0, $a7bd3f1d4e2f0217$export$3a7c8887437719ed)(event, handlersRef.current, threshold);
        }
        return (0, $9efa4efc2b7cd6d5$export$fcff2e64e6676b81)(node, "pointerdown", onPointerDown);
    }, [
        ref,
        hasPanEvents,
        handlersRef,
        threshold
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            panSession.current?.end();
            panSession.current = null;
        };
    }, []);
}


function $e577be22a2655901$var$toNumber(value) {
    const num = parseFloat(value);
    return typeof num !== "number" || Number.isNaN(num) ? 0 : num;
}
function $e577be22a2655901$export$3e91a10e66078270(value, precision) {
    let nextValue = $e577be22a2655901$var$toNumber(value);
    const scaleFactor = 10 ** (precision ?? 10);
    nextValue = Math.round(nextValue * scaleFactor) / scaleFactor;
    return precision ? nextValue.toFixed(precision) : nextValue.toString();
}
function $e577be22a2655901$export$a42544f265f8403(value) {
    if (!Number.isFinite(value)) return 0;
    let e = 1;
    let p = 0;
    while(Math.round(value * e) / e !== value){
        e *= 10;
        p += 1;
    }
    return p;
}
function $e577be22a2655901$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $e577be22a2655901$export$7a6e99933c50b5b2(percent, min, max) {
    return (max - min) * percent + min;
}
function $e577be22a2655901$export$3e1fe053092824a3(value, from, step) {
    const nextValue = Math.round((value - from) / step) * step + from;
    const precision = $e577be22a2655901$export$a42544f265f8403(step);
    return $e577be22a2655901$export$3e91a10e66078270(nextValue, precision);
}
function $e577be22a2655901$export$31ee16100cde6ce2(value, min, max) {
    if (value == null) return value;
    if (max < min) console.warn("clamp: max cannot be less than min");
    return Math.min(Math.max(value, min), max);
}



var $acw62 = parcelRequire("acw62");
"use client";
function $7dfe46c8fe1db33e$export$24b60fe7179439bc(id) {
    return {
        root: `slider-root-${id}`,
        getThumb: (i)=>`slider-thumb-${id}-${i}`,
        getInput: (i)=>`slider-input-${id}-${i}`,
        track: `slider-track-${id}`,
        innerTrack: `slider-filled-track-${id}`,
        getMarker: (i)=>`slider-marker-${id}-${i}`,
        output: `slider-output-${id}`
    };
}
function $7dfe46c8fe1db33e$export$f3eec17ee6065eee(options) {
    const { orientation: orientation, vertical: vertical, horizontal: horizontal } = options;
    return orientation === "vertical" ? vertical : horizontal;
}
function $7dfe46c8fe1db33e$export$ffd58b7f6f099a57(options) {
    const { orientation: orientation, thumbPercents: thumbPercents, isReversed: isReversed } = options;
    const getThumbStyle = (i)=>{
        return {
            position: "absolute",
            userSelect: "none",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
            touchAction: "none",
            ...$7dfe46c8fe1db33e$export$f3eec17ee6065eee({
                orientation: orientation,
                vertical: {
                    bottom: `${thumbPercents[i]}%`
                },
                horizontal: {
                    left: `${thumbPercents[i]}%`
                }
            })
        };
    };
    const rootStyle = {
        position: "relative",
        touchAction: "none",
        WebkitTapHighlightColor: "rgba(0,0,0,0)",
        userSelect: "none",
        outline: 0
    };
    const trackStyle = {
        position: "absolute",
        ...$7dfe46c8fe1db33e$export$f3eec17ee6065eee({
            orientation: orientation,
            vertical: {
                left: "50%",
                transform: "translateX(-50%)",
                height: "100%"
            },
            horizontal: {
                top: "50%",
                transform: "translateY(-50%)",
                width: "100%"
            }
        })
    };
    const isSingleThumb = thumbPercents.length === 1;
    const fallback = [
        0,
        isReversed ? 100 - thumbPercents[0] : thumbPercents[0]
    ];
    const range = isSingleThumb ? fallback : thumbPercents;
    let start = range[0];
    if (!isSingleThumb && isReversed) start = 100 - start;
    const percent = Math.abs(range[range.length - 1] - range[0]);
    const innerTrackStyle = {
        ...trackStyle,
        ...$7dfe46c8fe1db33e$export$f3eec17ee6065eee({
            orientation: orientation,
            vertical: isReversed ? {
                height: `${percent}%`,
                top: `${start}%`
            } : {
                height: `${percent}%`,
                bottom: `${start}%`
            },
            horizontal: isReversed ? {
                width: `${percent}%`,
                right: `${start}%`
            } : {
                width: `${percent}%`,
                left: `${start}%`
            }
        })
    };
    return {
        trackStyle: trackStyle,
        innerTrackStyle: innerTrackStyle,
        rootStyle: rootStyle,
        getThumbStyle: getThumbStyle
    };
}
function $7dfe46c8fe1db33e$export$4cb40dd77883f9(options) {
    const { isReversed: isReversed, direction: direction, orientation: orientation } = options;
    if (direction === "ltr" || orientation === "vertical") return isReversed;
    return !isReversed;
}


"use client";
function $c801dbbd86ec72a4$export$56b2c08e277f365(props) {
    const { min: min = 0, max: max = 100, onChange: onChange, value: valueProp, defaultValue: defaultValue, isReversed: isReversedProp, direction: direction = "ltr", orientation: orientation = "horizontal", id: idProp, isDisabled: isDisabled, isReadOnly: isReadOnly, onChangeStart: onChangeStartProp, onChangeEnd: onChangeEndProp, step: step = 1, getAriaValueText: getAriaValueTextProp, "aria-valuetext": ariaValueText, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, name: name, focusThumbOnChange: focusThumbOnChange = true, ...htmlProps } = props;
    const onChangeStart = (0, $5aeabd701a2e12e7$export$25bec8c6f54ee79a)(onChangeStartProp);
    const onChangeEnd = (0, $5aeabd701a2e12e7$export$25bec8c6f54ee79a)(onChangeEndProp);
    const getAriaValueText = (0, $5aeabd701a2e12e7$export$25bec8c6f54ee79a)(getAriaValueTextProp);
    const isReversed = (0, $7dfe46c8fe1db33e$export$4cb40dd77883f9)({
        isReversed: isReversedProp,
        direction: direction,
        orientation: orientation
    });
    const [computedValue, setValue] = (0, $e8899b8ecf9820a0$export$6f32135080cb4c3)({
        value: valueProp,
        defaultValue: defaultValue ?? $c801dbbd86ec72a4$var$getDefaultValue(min, max),
        onChange: onChange
    });
    const [isDragging, setDragging] = (0, $acw62.useState)(false);
    const [isFocused, setFocused] = (0, $acw62.useState)(false);
    const isInteractive = !(isDisabled || isReadOnly);
    const tenSteps = (max - min) / 10;
    const oneStep = step || (max - min) / 100;
    const value = (0, $e577be22a2655901$export$31ee16100cde6ce2)(computedValue, min, max);
    const reversedValue = max - value + min;
    const trackValue = isReversed ? reversedValue : value;
    const thumbPercent = (0, $e577be22a2655901$export$83ce4bc8280540e6)(trackValue, min, max);
    const isVertical = orientation === "vertical";
    const stateRef = (0, $f828771078a53118$export$bcd07ba85a740103)({
        min: min,
        max: max,
        step: step,
        isDisabled: isDisabled,
        value: value,
        isInteractive: isInteractive,
        isReversed: isReversed,
        isVertical: isVertical,
        eventSource: null,
        focusThumbOnChange: focusThumbOnChange,
        orientation: orientation
    });
    const trackRef = (0, $acw62.useRef)(null);
    const thumbRef = (0, $acw62.useRef)(null);
    const rootRef = (0, $acw62.useRef)(null);
    const reactId = (0, $acw62.useId)();
    const uuid = idProp ?? reactId;
    const [thumbId, trackId] = [
        `slider-thumb-${uuid}`,
        `slider-track-${uuid}`
    ];
    const getValueFromPointer = (0, $acw62.useCallback)((event)=>{
        if (!trackRef.current) return;
        const state2 = stateRef.current;
        state2.eventSource = "pointer";
        const trackRect = trackRef.current.getBoundingClientRect();
        const { clientX: clientX, clientY: clientY } = event.touches?.[0] ?? event;
        const diff = isVertical ? trackRect.bottom - clientY : clientX - trackRect.left;
        const length = isVertical ? trackRect.height : trackRect.width;
        let percent = diff / length;
        if (isReversed) percent = 1 - percent;
        let nextValue = (0, $e577be22a2655901$export$7a6e99933c50b5b2)(percent, state2.min, state2.max);
        if (state2.step) nextValue = parseFloat((0, $e577be22a2655901$export$3e1fe053092824a3)(nextValue, state2.min, state2.step));
        nextValue = (0, $e577be22a2655901$export$31ee16100cde6ce2)(nextValue, state2.min, state2.max);
        return nextValue;
    }, [
        isVertical,
        isReversed,
        stateRef
    ]);
    const constrain = (0, $acw62.useCallback)((value2)=>{
        const state2 = stateRef.current;
        if (!state2.isInteractive) return;
        value2 = parseFloat((0, $e577be22a2655901$export$3e1fe053092824a3)(value2, state2.min, oneStep));
        value2 = (0, $e577be22a2655901$export$31ee16100cde6ce2)(value2, state2.min, state2.max);
        setValue(value2);
    }, [
        oneStep,
        setValue,
        stateRef
    ]);
    const actions = (0, $acw62.useMemo)(()=>({
            stepUp (step2 = oneStep) {
                const next = isReversed ? value - step2 : value + step2;
                constrain(next);
            },
            stepDown (step2 = oneStep) {
                const next = isReversed ? value + step2 : value - step2;
                constrain(next);
            },
            reset () {
                constrain(defaultValue || 0);
            },
            stepTo (value2) {
                constrain(value2);
            }
        }), [
        constrain,
        isReversed,
        value,
        oneStep,
        defaultValue
    ]);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        const state2 = stateRef.current;
        const keyMap = {
            ArrowRight: ()=>actions.stepUp(),
            ArrowUp: ()=>actions.stepUp(),
            ArrowLeft: ()=>actions.stepDown(),
            ArrowDown: ()=>actions.stepDown(),
            PageUp: ()=>actions.stepUp(tenSteps),
            PageDown: ()=>actions.stepDown(tenSteps),
            Home: ()=>constrain(state2.min),
            End: ()=>constrain(state2.max)
        };
        const action = keyMap[event.key];
        if (action) {
            event.preventDefault();
            event.stopPropagation();
            action(event);
            state2.eventSource = "keyboard";
        }
    }, [
        actions,
        constrain,
        tenSteps,
        stateRef
    ]);
    const valueText = getAriaValueText?.(value) ?? ariaValueText;
    const { getThumbStyle: getThumbStyle, rootStyle: rootStyle, trackStyle: trackStyle, innerTrackStyle: innerTrackStyle } = (0, $acw62.useMemo)(()=>{
        const state2 = stateRef.current;
        return (0, $7dfe46c8fe1db33e$export$ffd58b7f6f099a57)({
            isReversed: isReversed,
            orientation: state2.orientation,
            thumbPercents: [
                thumbPercent
            ]
        });
    }, [
        isReversed,
        thumbPercent,
        stateRef
    ]);
    const focusThumb = (0, $acw62.useCallback)(()=>{
        const state2 = stateRef.current;
        if (state2.focusThumbOnChange) setTimeout(()=>thumbRef.current?.focus());
    }, [
        stateRef
    ]);
    (0, $b9c7bec3faa3a5b6$export$496315a1608d9602)(()=>{
        const state2 = stateRef.current;
        focusThumb();
        if (state2.eventSource === "keyboard") onChangeEnd?.(state2.value);
    }, [
        value,
        onChangeEnd
    ]);
    function setValueFromPointer(event) {
        const nextValue = getValueFromPointer(event);
        if (nextValue != null && nextValue !== stateRef.current.value) setValue(nextValue);
    }
    (0, $a05802077a261c0d$export$9ad22d853bfe2640)(rootRef, {
        onPanSessionStart (event) {
            const state2 = stateRef.current;
            if (!state2.isInteractive) return;
            setDragging(true);
            focusThumb();
            setValueFromPointer(event);
            onChangeStart?.(state2.value);
        },
        onPanSessionEnd () {
            const state2 = stateRef.current;
            if (!state2.isInteractive) return;
            setDragging(false);
            onChangeEnd?.(state2.value);
        },
        onPan (event) {
            const state2 = stateRef.current;
            if (!state2.isInteractive) return;
            setValueFromPointer(event);
        }
    });
    const getRootProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ...htmlProps,
            ref: (0, $6b244ebab8c02c76$export$c9058316764c140e)(ref, rootRef),
            tabIndex: -1,
            "aria-disabled": (0, $b0e804a3cb579fb7$export$91a6105db3d4be7b)(isDisabled),
            "data-focused": (0, $b0e804a3cb579fb7$export$5cc3b7b83e34ade7)(isFocused),
            style: {
                ...props2.style,
                ...rootStyle
            }
        };
    }, [
        htmlProps,
        isDisabled,
        isFocused,
        rootStyle
    ]);
    const getTrackProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ref: (0, $6b244ebab8c02c76$export$c9058316764c140e)(ref, trackRef),
            id: trackId,
            "data-disabled": (0, $b0e804a3cb579fb7$export$5cc3b7b83e34ade7)(isDisabled),
            style: {
                ...props2.style,
                ...trackStyle
            }
        };
    }, [
        isDisabled,
        trackId,
        trackStyle
    ]);
    const getInnerTrackProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ref: ref,
            style: {
                ...props2.style,
                ...innerTrackStyle
            }
        };
    }, [
        innerTrackStyle
    ]);
    const getThumbProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ref: (0, $6b244ebab8c02c76$export$c9058316764c140e)(ref, thumbRef),
            role: "slider",
            tabIndex: isInteractive ? 0 : void 0,
            id: thumbId,
            "data-active": (0, $b0e804a3cb579fb7$export$5cc3b7b83e34ade7)(isDragging),
            "aria-valuetext": valueText,
            "aria-valuemin": min,
            "aria-valuemax": max,
            "aria-valuenow": value,
            "aria-orientation": orientation,
            "aria-disabled": (0, $b0e804a3cb579fb7$export$91a6105db3d4be7b)(isDisabled),
            "aria-readonly": (0, $b0e804a3cb579fb7$export$91a6105db3d4be7b)(isReadOnly),
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabel ? void 0 : ariaLabelledBy,
            style: {
                ...props2.style,
                ...getThumbStyle(0)
            },
            onKeyDown: (0, $0d379db27441c7a7$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDown),
            onFocus: (0, $0d379db27441c7a7$export$5bdd3f730ec2c47e)(props2.onFocus, ()=>setFocused(true)),
            onBlur: (0, $0d379db27441c7a7$export$5bdd3f730ec2c47e)(props2.onBlur, ()=>setFocused(false))
        };
    }, [
        isInteractive,
        thumbId,
        isDragging,
        valueText,
        min,
        max,
        value,
        orientation,
        isDisabled,
        isReadOnly,
        ariaLabel,
        ariaLabelledBy,
        getThumbStyle,
        onKeyDown
    ]);
    const getMarkerProps = (0, $acw62.useCallback)((props2, ref = null)=>{
        const isInRange = !(props2.value < min || props2.value > max);
        const isHighlighted = value >= props2.value;
        const markerPercent = (0, $e577be22a2655901$export$83ce4bc8280540e6)(props2.value, min, max);
        const markerStyle = {
            position: "absolute",
            pointerEvents: "none",
            ...$c801dbbd86ec72a4$var$orient({
                orientation: orientation,
                vertical: {
                    bottom: isReversed ? `${100 - markerPercent}%` : `${markerPercent}%`
                },
                horizontal: {
                    left: isReversed ? `${100 - markerPercent}%` : `${markerPercent}%`
                }
            })
        };
        return {
            ...props2,
            ref: ref,
            role: "presentation",
            "aria-hidden": true,
            "data-disabled": (0, $b0e804a3cb579fb7$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $b0e804a3cb579fb7$export$5cc3b7b83e34ade7)(!isInRange),
            "data-highlighted": (0, $b0e804a3cb579fb7$export$5cc3b7b83e34ade7)(isHighlighted),
            style: {
                ...props2.style,
                ...markerStyle
            }
        };
    }, [
        isDisabled,
        isReversed,
        max,
        min,
        orientation,
        value
    ]);
    const getInputProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ref: ref,
            type: "hidden",
            value: value,
            name: name
        };
    }, [
        name,
        value
    ]);
    const state = {
        value: value,
        isFocused: isFocused,
        isDragging: isDragging
    };
    return {
        state: state,
        actions: actions,
        getRootProps: getRootProps,
        getTrackProps: getTrackProps,
        getInnerTrackProps: getInnerTrackProps,
        getThumbProps: getThumbProps,
        getMarkerProps: getMarkerProps,
        getInputProps: getInputProps
    };
}
function $c801dbbd86ec72a4$var$orient(options) {
    const { orientation: orientation, vertical: vertical, horizontal: horizontal } = options;
    return orientation === "vertical" ? vertical : horizontal;
}
function $c801dbbd86ec72a4$var$getDefaultValue(min, max) {
    return max < min ? min : min + (max - min) / 2;
}






"use client";
const [$00a3c44bf30da35b$export$d1709061ba4d965f, $00a3c44bf30da35b$export$65ed0685dbd65652] = (0, $f5f62380657c0122$export$fd42f52fd3ae1109)({
    name: "SliderContext",
    hookName: "useSliderContext",
    providerName: "<Slider />"
});
const [$00a3c44bf30da35b$var$SliderStylesProvider, $00a3c44bf30da35b$export$8db8bb766e6e05f9] = (0, $f5f62380657c0122$export$fd42f52fd3ae1109)({
    name: `SliderStylesContext`,
    hookName: `useSliderStyles`,
    providerName: "<Slider />"
});
const $00a3c44bf30da35b$export$472062a354075cee = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>{
    const sliderProps = {
        ...props,
        orientation: props?.orientation ?? "horizontal"
    };
    const styles = (0, $ec61beff530ee0ac$export$31cdfe60c085d76f)("Slider", sliderProps);
    const ownProps = (0, $30f8a8e85c908575$export$adfcf5a5e4d17785)(sliderProps);
    const { direction: direction } = (0, $438cb0f953004812$export$93d4e7f90805808f)();
    ownProps.direction = direction;
    const { getInputProps: getInputProps, getRootProps: getRootProps, ...context } = (0, $c801dbbd86ec72a4$export$56b2c08e277f365)(ownProps);
    const rootProps = getRootProps();
    const inputProps = getInputProps({}, ref);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($00a3c44bf30da35b$export$d1709061ba4d965f, {
        value: context,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($00a3c44bf30da35b$var$SliderStylesProvider, {
            value: styles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
                ...rootProps,
                className: (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-slider", sliderProps.className),
                __css: styles.container,
                children: [
                    sliderProps.children,
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                        ...inputProps
                    })
                ]
            })
        })
    });
});
$00a3c44bf30da35b$export$472062a354075cee.displayName = "Slider";
const $00a3c44bf30da35b$export$2c1b491743890dec = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>{
    const { getThumbProps: getThumbProps } = $00a3c44bf30da35b$export$65ed0685dbd65652();
    const styles = $00a3c44bf30da35b$export$8db8bb766e6e05f9();
    const thumbProps = getThumbProps(props, ref);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
        ...thumbProps,
        className: (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-slider__thumb", props.className),
        __css: styles.thumb
    });
});
$00a3c44bf30da35b$export$2c1b491743890dec.displayName = "SliderThumb";
const $00a3c44bf30da35b$export$105594979f116971 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>{
    const { getTrackProps: getTrackProps } = $00a3c44bf30da35b$export$65ed0685dbd65652();
    const styles = $00a3c44bf30da35b$export$8db8bb766e6e05f9();
    const trackProps = getTrackProps(props, ref);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
        ...trackProps,
        className: (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-slider__track", props.className),
        __css: styles.track
    });
});
$00a3c44bf30da35b$export$105594979f116971.displayName = "SliderTrack";
const $00a3c44bf30da35b$export$73137d74280e0c3e = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>{
    const { getInnerTrackProps: getInnerTrackProps } = $00a3c44bf30da35b$export$65ed0685dbd65652();
    const styles = $00a3c44bf30da35b$export$8db8bb766e6e05f9();
    const trackProps = getInnerTrackProps(props, ref);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
        ...trackProps,
        className: (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-slider__filled-track", props.className),
        __css: styles.filledTrack
    });
});
$00a3c44bf30da35b$export$73137d74280e0c3e.displayName = "SliderFilledTrack";
const $00a3c44bf30da35b$export$6f85f6a3c5da6f62 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>{
    const { getMarkerProps: getMarkerProps } = $00a3c44bf30da35b$export$65ed0685dbd65652();
    const styles = $00a3c44bf30da35b$export$8db8bb766e6e05f9();
    const markProps = getMarkerProps(props, ref);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b03209b927263f16$export$7cd122d781af9fa4).div, {
        ...markProps,
        className: (0, $c206e257e9c6c2b1$export$a274e22fb40f762e)("chakra-slider__marker", props.className),
        __css: styles.mark
    });
});
$00a3c44bf30da35b$export$6f85f6a3c5da6f62.displayName = "SliderMark";




"use client";
const $71f5c509a3d79da6$export$e6c02a6dccfa2120 = (0, $bef38e2b541bb56e$export$257a8862b851cb5b)((props, ref)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a2c9ce50f6bfbd0$export$694e0d28c7ffc90c), {
        align: "center",
        ...props,
        direction: "column",
        ref: ref
    }));
$71f5c509a3d79da6$export$e6c02a6dccfa2120.displayName = "VStack";



function $e250d4ac614c0cc4$export$d0d83eb3b3405895(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $71f5c509a3d79da6$export$e6c02a6dccfa2120), {
        align: "stretch",
        spacing: 3,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7797ad21d1688bf5$export$e71c4d32a2263218), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                        fontSize: "xl",
                        mb: 2,
                        children: "\u5B9F\u884C"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4d98417e5915b90f$export$ef2184bd89960b14), {
                        autoFlow: "column",
                        autoColumns: "1fr",
                        gap: 2,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                colorScheme: "blue",
                                variant: "outline",
                                isDisabled: props.interpreter.state !== "stopped",
                                leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20f456d5883a34dd$export$f04a61298a47a40f), {
                                    as: (0, $0d9043722344d99e$export$c94de331c2527d4a)
                                }),
                                onClick: props.onStart,
                                children: "\u5B9F\u884C"
                            }),
                            props.interpreter.state !== "paused" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                variant: "outline",
                                isDisabled: props.interpreter.state !== "running",
                                leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20f456d5883a34dd$export$f04a61298a47a40f), {
                                    as: (0, $0d9043722344d99e$export$7e96c5a02ccc8cb)
                                }),
                                onClick: props.interpreter.pause,
                                children: "\u4E00\u6642\u505C\u6B62"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                variant: "outline",
                                leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20f456d5883a34dd$export$f04a61298a47a40f), {
                                    as: (0, $0d9043722344d99e$export$2fb37f7187c91f24)
                                }),
                                onClick: props.interpreter.resume,
                                children: "\u518D\u958B"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                variant: "solid",
                                leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20f456d5883a34dd$export$f04a61298a47a40f), {
                                    as: (0, $0d9043722344d99e$export$7e96c5a02ccc8cb)
                                }),
                                isDisabled: props.interpreter.state === "stopped",
                                colorScheme: "blue",
                                onClick: ()=>{
                                    props.onReset();
                                    props.interpreter.stop();
                                },
                                children: "\u30EA\u30BB\u30C3\u30C8"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7797ad21d1688bf5$export$e71c4d32a2263218), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                        fontSize: "xl",
                        mb: 2,
                        children: "\u5B9F\u884C\u901F\u5EA6"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bda70ca026e698db$export$f51f4c4ede09e011), {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                                children: "\u9045\u3044"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7797ad21d1688bf5$export$e71c4d32a2263218), {
                                flexGrow: 1,
                                px: 4,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $00a3c44bf30da35b$export$472062a354075cee), {
                                    min: 0,
                                    max: 1000,
                                    value: 1000 - Math.log((props.interval + 100) / 100) / Math.log(20) * 1000,
                                    onChange: (value)=>{
                                        props.setInterval(20 ** ((1000 - value) / 1000) * 100 - 100);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a3c44bf30da35b$export$105594979f116971), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a3c44bf30da35b$export$73137d74280e0c3e), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a3c44bf30da35b$export$2c1b491743890dec), {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                                children: "\u901F\u3044"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




function $537449a9172ac6d5$export$a85cdcada2f6e6d0(maxExcluded, minIncluded = 0) {
    return Math.floor(Math.random() * (maxExcluded - minIncluded) + minIncluded);
}


const $3a4b4e5eb02e247c$export$4f18afb4fdd3830a = {
    TOP: "top",
    RIGHT: "right",
    BOTTOM: "bottom",
    LEFT: "left"
};
const $3a4b4e5eb02e247c$export$672101e51de8f88d = Object.values($3a4b4e5eb02e247c$export$4f18afb4fdd3830a);
const $3a4b4e5eb02e247c$export$963380220eec99b9 = {
    [$3a4b4e5eb02e247c$export$4f18afb4fdd3830a.TOP]: {
        x: 0,
        y: -1
    },
    [$3a4b4e5eb02e247c$export$4f18afb4fdd3830a.RIGHT]: {
        x: 1,
        y: 0
    },
    [$3a4b4e5eb02e247c$export$4f18afb4fdd3830a.BOTTOM]: {
        x: 0,
        y: 1
    },
    [$3a4b4e5eb02e247c$export$4f18afb4fdd3830a.LEFT]: {
        x: -1,
        y: 0
    }
};
const $3a4b4e5eb02e247c$export$3537ea02d0032473 = {
    [$3a4b4e5eb02e247c$export$4f18afb4fdd3830a.TOP]: $3a4b4e5eb02e247c$export$4f18afb4fdd3830a.BOTTOM,
    [$3a4b4e5eb02e247c$export$4f18afb4fdd3830a.RIGHT]: $3a4b4e5eb02e247c$export$4f18afb4fdd3830a.LEFT,
    [$3a4b4e5eb02e247c$export$4f18afb4fdd3830a.BOTTOM]: $3a4b4e5eb02e247c$export$4f18afb4fdd3830a.TOP,
    [$3a4b4e5eb02e247c$export$4f18afb4fdd3830a.LEFT]: $3a4b4e5eb02e247c$export$4f18afb4fdd3830a.RIGHT
};
function $3a4b4e5eb02e247c$export$fd3894fbe13374c(maze, cell, direction) {
    return maze[cell.location.y + $3a4b4e5eb02e247c$export$963380220eec99b9[direction].y]?.[cell.location.x + $3a4b4e5eb02e247c$export$963380220eec99b9[direction].x];
}
function $3a4b4e5eb02e247c$export$e383eb2094048976(direction1, direction2) {
    return $3a4b4e5eb02e247c$export$672101e51de8f88d[($3a4b4e5eb02e247c$export$672101e51de8f88d.indexOf(direction1) + $3a4b4e5eb02e247c$export$672101e51de8f88d.indexOf(direction2)) % $3a4b4e5eb02e247c$export$672101e51de8f88d.length];
}
function $3a4b4e5eb02e247c$export$57e2965237936094(width, height) {
    const maze = Array.from(Array(height), (_y, y)=>Array.from(Array(width), (_x, x)=>({
                location: {
                    x: x,
                    y: y
                },
                visited: false,
                walls: Object.fromEntries($3a4b4e5eb02e247c$export$672101e51de8f88d.map((direction)=>[
                        direction,
                        true
                    ]))
            })));
    const visitedCells = new Set();
    while(visitedCells.size < width * height){
        const firstCellOptions = Array.from(visitedCells.values()).filter((cell)=>$3a4b4e5eb02e247c$export$672101e51de8f88d.some((direction)=>{
                const nextCell = $3a4b4e5eb02e247c$export$fd3894fbe13374c(maze, cell, direction);
                return nextCell && !visitedCells.has(nextCell);
            }));
        let currentCell = firstCellOptions[(0, $537449a9172ac6d5$export$a85cdcada2f6e6d0)(firstCellOptions.length)] ?? maze[(0, $537449a9172ac6d5$export$a85cdcada2f6e6d0)(height)][(0, $537449a9172ac6d5$export$a85cdcada2f6e6d0)(width)];
        // eslint-disable-next-line no-constant-condition
        while(true){
            visitedCells.add(currentCell);
            const nextOptions = $3a4b4e5eb02e247c$export$672101e51de8f88d.flatMap(// eslint-disable-next-line no-loop-func
            (direction)=>{
                const nextCell = $3a4b4e5eb02e247c$export$fd3894fbe13374c(maze, currentCell, direction);
                return nextCell && !visitedCells.has(nextCell) ? {
                    nextCell: nextCell,
                    direction: direction
                } : [];
            });
            if (!nextOptions.length) break;
            const nextOption = nextOptions[(0, $537449a9172ac6d5$export$a85cdcada2f6e6d0)(nextOptions.length)];
            currentCell.walls[nextOption.direction] = false;
            nextOption.nextCell.walls[$3a4b4e5eb02e247c$export$3537ea02d0032473[nextOption.direction]] = false;
            currentCell = nextOption.nextCell;
        }
    }
    return maze;
}


const $2feae68b8aa93f1b$export$417acab26efb42c7 = "custom_maze_stepForward";
(0, (/*@__PURE__*/$parcel$interopDefault($ecab2ad3ed5a93ad$exports))).Blocks[$2feae68b8aa93f1b$export$417acab26efb42c7] = {
    init () {
        this.appendDummyInput().appendField("\u524D\u3078\u9032\u3080");
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(0);
    }
};
(0, $4dac3bd746fe0f69$export$d274976115d95baf)[$2feae68b8aa93f1b$export$417acab26efb42c7] = ()=>`${$2feae68b8aa93f1b$export$417acab26efb42c7}();`;
const $2feae68b8aa93f1b$export$441456d754d206b4 = "custom_maze_turn";
const $2feae68b8aa93f1b$export$a39e12f197ba00af = "DIRECTION";
(0, (/*@__PURE__*/$parcel$interopDefault($ecab2ad3ed5a93ad$exports))).Blocks[$2feae68b8aa93f1b$export$441456d754d206b4] = {
    init () {
        this.appendDummyInput().appendField(new (0, (/*@__PURE__*/$parcel$interopDefault($ecab2ad3ed5a93ad$exports))).FieldDropdown([
            [
                "\u5DE6",
                (0, $3a4b4e5eb02e247c$export$4f18afb4fdd3830a).LEFT
            ],
            [
                "\u53F3",
                (0, $3a4b4e5eb02e247c$export$4f18afb4fdd3830a).RIGHT
            ]
        ]), $2feae68b8aa93f1b$export$a39e12f197ba00af).appendField("\u3092\u5411\u304F");
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(0);
        this.setTooltip("\u8FF7\u8DEF\u5185\u306E\u81EA\u6A5F\u3092\u6307\u5B9A\u3057\u305F\u65B9\u5411\u306B\u56DE\u8EE2\u3055\u305B\u307E\u3059\u3002");
    }
};
(0, $4dac3bd746fe0f69$export$d274976115d95baf)[$2feae68b8aa93f1b$export$441456d754d206b4] = (block)=>`${$2feae68b8aa93f1b$export$441456d754d206b4}('${block.getFieldValue($2feae68b8aa93f1b$export$a39e12f197ba00af)}');`;
const $2feae68b8aa93f1b$export$db53633f9be615e6 = "custom_maze_checkWall";
(0, (/*@__PURE__*/$parcel$interopDefault($ecab2ad3ed5a93ad$exports))).Blocks[$2feae68b8aa93f1b$export$db53633f9be615e6] = {
    init () {
        this.appendDummyInput().appendField(new (0, (/*@__PURE__*/$parcel$interopDefault($ecab2ad3ed5a93ad$exports))).FieldDropdown([
            [
                "\u524D",
                (0, $3a4b4e5eb02e247c$export$4f18afb4fdd3830a).TOP
            ],
            [
                "\u5DE6",
                (0, $3a4b4e5eb02e247c$export$4f18afb4fdd3830a).LEFT
            ],
            [
                "\u53F3",
                (0, $3a4b4e5eb02e247c$export$4f18afb4fdd3830a).RIGHT
            ],
            [
                "\u5F8C",
                (0, $3a4b4e5eb02e247c$export$4f18afb4fdd3830a).BOTTOM
            ]
        ]), $2feae68b8aa93f1b$export$a39e12f197ba00af).appendField("\u306B\u58C1\u304C\u3042\u308B");
        this.setOutput(true, "Boolean");
        this.setColour(0);
        this.setTooltip("\u81EA\u6A5F\u306E\u6307\u5B9A\u3055\u308C\u305F\u65B9\u5411\u306B\u58C1\u304C\u3042\u308B\u304B\u3069\u3046\u304B\u78BA\u8A8D\u3057\u307E\u3059\u3002");
    }
};
(0, $4dac3bd746fe0f69$export$d274976115d95baf)[$2feae68b8aa93f1b$export$db53633f9be615e6] = (block)=>[
        `${$2feae68b8aa93f1b$export$db53633f9be615e6}('${block.getFieldValue($2feae68b8aa93f1b$export$a39e12f197ba00af)}')`,
        0
    ];




var $acw62 = parcelRequire("acw62");

const $f97c2b2f10b48128$var$MAZE_CELL_SIZE = 10;
const $f97c2b2f10b48128$var$MAZE_PADDING = 1;
function $f97c2b2f10b48128$export$956c3254a6ef7791(props) {
    const mazeWidth = props.maze[0].length;
    const mazeHeight = props.maze.length;
    const [rotation, setRotation] = (0, $acw62.useState)((0, $3a4b4e5eb02e247c$export$672101e51de8f88d).indexOf(props.direction));
    (0, $acw62.useEffect)(()=>{
        const rotationDiff = ((0, $3a4b4e5eb02e247c$export$672101e51de8f88d).indexOf(props.direction) - rotation) % 4;
        setRotation(rotation + [
            rotationDiff - (0, $3a4b4e5eb02e247c$export$672101e51de8f88d).length,
            rotationDiff,
            rotationDiff + (0, $3a4b4e5eb02e247c$export$672101e51de8f88d).length
        ].reduce((previous, current)=>Math.abs(previous) > Math.abs(current) ? current : previous));
    }, [
        props.direction,
        rotation
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "100%",
        viewBox: [
            -$f97c2b2f10b48128$var$MAZE_PADDING,
            -$f97c2b2f10b48128$var$MAZE_PADDING,
            $f97c2b2f10b48128$var$MAZE_CELL_SIZE * mazeWidth + $f97c2b2f10b48128$var$MAZE_PADDING * 2,
            $f97c2b2f10b48128$var$MAZE_CELL_SIZE * mazeHeight + $f97c2b2f10b48128$var$MAZE_PADDING * 2
        ].join(" "),
        children: [
            props.maze.map((row, y)=>row.map((cell, x)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        stroke: "#000",
                        strokeWidth: 0.6,
                        strokeLinecap: "round",
                        transform: `translate(${x * $f97c2b2f10b48128$var$MAZE_CELL_SIZE}, ${y * $f97c2b2f10b48128$var$MAZE_CELL_SIZE})`,
                        children: [
                            cell.walls[(0, $3a4b4e5eb02e247c$export$4f18afb4fdd3830a).TOP] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                x1: 0,
                                y1: 0,
                                x2: $f97c2b2f10b48128$var$MAZE_CELL_SIZE,
                                y2: 0
                            }),
                            cell.walls[(0, $3a4b4e5eb02e247c$export$4f18afb4fdd3830a).RIGHT] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                x1: $f97c2b2f10b48128$var$MAZE_CELL_SIZE,
                                y1: 0,
                                x2: $f97c2b2f10b48128$var$MAZE_CELL_SIZE,
                                y2: $f97c2b2f10b48128$var$MAZE_CELL_SIZE
                            }),
                            cell.walls[(0, $3a4b4e5eb02e247c$export$4f18afb4fdd3830a).BOTTOM] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                x1: 0,
                                y1: $f97c2b2f10b48128$var$MAZE_CELL_SIZE,
                                x2: $f97c2b2f10b48128$var$MAZE_CELL_SIZE,
                                y2: $f97c2b2f10b48128$var$MAZE_CELL_SIZE
                            }),
                            cell.walls[(0, $3a4b4e5eb02e247c$export$4f18afb4fdd3830a).LEFT] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: $f97c2b2f10b48128$var$MAZE_CELL_SIZE
                            })
                        ]
                    }, `${cell.location.x},${cell.location.y}`))),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                transform: [
                    "translate(",
                    $f97c2b2f10b48128$var$MAZE_CELL_SIZE * (mazeWidth - 1),
                    ",",
                    $f97c2b2f10b48128$var$MAZE_CELL_SIZE * (mazeHeight - 1),
                    ")"
                ].join(""),
                d: [
                    `M ${$f97c2b2f10b48128$var$MAZE_CELL_SIZE * 0.35},${$f97c2b2f10b48128$var$MAZE_CELL_SIZE * 0.2}`,
                    `V ${$f97c2b2f10b48128$var$MAZE_CELL_SIZE * 0.8}`,
                    `H ${$f97c2b2f10b48128$var$MAZE_CELL_SIZE * 0.4}`,
                    `V ${$f97c2b2f10b48128$var$MAZE_CELL_SIZE * 0.5}`,
                    `L ${$f97c2b2f10b48128$var$MAZE_CELL_SIZE * 0.7},${$f97c2b2f10b48128$var$MAZE_CELL_SIZE * 0.35}`,
                    "Z"
                ].join(" "),
                fill: "#ccc"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                style: {
                    transition: "0.1s ease"
                },
                transform: [
                    "translate(",
                    (props.location.x + 0.5) * $f97c2b2f10b48128$var$MAZE_CELL_SIZE,
                    ",",
                    (props.location.y + 0.5) * $f97c2b2f10b48128$var$MAZE_CELL_SIZE,
                    ")",
                    `rotate(${rotation * 90})`
                ].join(""),
                d: [
                    `M 0,-${$f97c2b2f10b48128$var$MAZE_CELL_SIZE * 0.3}`,
                    `L ${$f97c2b2f10b48128$var$MAZE_CELL_SIZE * 0.2},${$f97c2b2f10b48128$var$MAZE_CELL_SIZE * 0.3}`,
                    `L 0,${$f97c2b2f10b48128$var$MAZE_CELL_SIZE * 0.15}`,
                    `L -${$f97c2b2f10b48128$var$MAZE_CELL_SIZE * 0.2},${$f97c2b2f10b48128$var$MAZE_CELL_SIZE * 0.3}`,
                    "Z"
                ].join(" "),
                fill: "#f00"
            })
        ]
    });
}





function $478074afe49969f1$export$f2b4b2283d43c1ca(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d5617b7cd68911b$export$2b77a92f1a5ad772), {
        size: "3xl",
        isOpen: props.visible,
        onClose: props.onClose,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a4cea414d4965ce7$export$8948f78d83984c69), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f0d1c6b1bc80e74e$export$6da19a24bf249f17), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc83ddfa3740f22c$export$f50a68e3694789ee), {
                        children: props.next !== null ? "\u30AF\u30EA\u30A2\u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01" : "\u5168\u30B9\u30C6\u30FC\u30B8\u30AF\u30EA\u30A2\u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d73afe5bfe6dcf52$export$edf9108895ba774f), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dee50d0250a4a081$export$cb540d8b0ef7906c), {
                        children: props.next !== null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                            mb: 3,
                            children: "\u30AF\u30EA\u30A2\u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01\u53F3\u4E0B\u306E\u300C\u6B21\u306E\u30B9\u30C6\u30FC\u30B8\u3078\u300D\u3092\u62BC\u3057\u3066\u3001\u6B21\u306E\u30B9\u30C6\u30C3\u30D7\u306B\u9032\u307F\u307E\u3057\u3087\u3046\uFF01 \u3053\u306E\u30B9\u30C6\u30C3\u30D7\u3092\u3082\u3046\u4E00\u5EA6\u904A\u3073\u305F\u3044\u5834\u5408\u306F\u3001\u300C\u30AD\u30E3\u30F3\u30BB\u30EB\u300D\u3092\u304A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                            mb: 3,
                            children: "\u304A\u75B2\u308C\u69D8\u3067\u3057\u305F\uFF01\u3053\u308C\u3067\u3053\u306E\u4F01\u753B\u306F\u7D42\u308F\u308A\u3068\u306A\u308A\u307E\u3059\u3002 \u4E94\u6708\u796D\u30C8\u30C3\u30D7\u30DA\u30FC\u30B8\u306B\u623B\u308B\u5834\u5408\u306F\u300C\u623B\u308B\u300D\u30DC\u30BF\u30F3\u3092\u304A\u3057\u3066\u304F\u3060\u3055\u3044\uFF01 \u3082\u3046\u4E00\u5EA6\u904A\u3073\u305F\u3044\u5834\u5408\u3001\u4ED6\u306E\u8FF7\u8DEF\u3082\u8A66\u3057\u3066\u307F\u305F\u3044\u5834\u5408\u306F\u3001\u300C\u30AD\u30E3\u30F3\u30BB\u30EB\u300D\u3092\u304A\u3057\u3066\u304F\u3060\u3055\u3044\u3002 \u904A\u3093\u3067\u304F\u3060\u3055\u308A\u3001\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\uFF01"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $773bc06574a7fd0d$export$519437715052e656), {
                        children: props.next !== null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                    onClick: props.onClose,
                                    colorScheme: "white",
                                    textColor: "black",
                                    children: "\u30AD\u30E3\u30F3\u30BB\u30EB"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                    onClick: props.next,
                                    colorScheme: "blue",
                                    children: "\u6B21\u306E\u30B9\u30C6\u30FC\u30B8\u3078"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                    onClick: props.onClose,
                                    colorScheme: "white",
                                    textColor: "black",
                                    children: "\u30AD\u30E3\u30F3\u30BB\u30EB"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                    onClick: props.home,
                                    colorScheme: "green",
                                    children: "\u30C8\u30C3\u30D7\u30DA\u30FC\u30B8\u306B\u623B\u308B"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}


const $9d87f333937ff966$var$defaultSelf = {
    location: {
        x: 0,
        y: 0
    },
    direction: (0, $3a4b4e5eb02e247c$export$4f18afb4fdd3830a).BOTTOM
};
function $9d87f333937ff966$var$createDefaultState(w, h) {
    return {
        maze: (0, $3a4b4e5eb02e247c$export$57e2965237936094)(w, h),
        self: $9d87f333937ff966$var$defaultSelf
    };
}
const $9d87f333937ff966$var$toolboxDefinition = {
    type: "flyout",
    blockTypes: [
        (0, $2feae68b8aa93f1b$export$417acab26efb42c7),
        (0, $2feae68b8aa93f1b$export$441456d754d206b4),
        (0, $2feae68b8aa93f1b$export$db53633f9be615e6),
        (0, $b480c861dade9b3d$export$5ed6ef3067e4d0c1),
        (0, $b480c861dade9b3d$export$2559b0f93d9e1295),
        (0, $b480c861dade9b3d$export$363e4bccfe48d30a),
        (0, $b480c861dade9b3d$export$815f12e287fce685),
        (0, $b480c861dade9b3d$export$ca676e339c3b41b5)
    ]
};
function $9d87f333937ff966$export$a048efcd1ba3d9f1({ width: w, height: h, description: desc = "\u8FF7\u8DEF\u306E\u4E2D\u306E\u30A2\u30A4\u30B3\u30F3\u3092\u3001\u30B4\u30FC\u30EB\u307E\u3067\u5C0E\u304D\u307E\u3057\u3087\u3046\u3002", allowReset: allowReset = true, prev: prev, next: next }) {
    const [getState, setState] = (0, $04226aa44b98d8e4$export$2e2bcd8739ae039)(()=>$9d87f333937ff966$var$createDefaultState(w, h));
    const goal = {
        x: w - 1,
        y: h - 1
    };
    const [cleared, setCleared] = (0, $acw62.useState)(false);
    const [showClearDialog, setShowClearDialog] = (0, $acw62.useState)(false);
    const globalFunctions = (0, $acw62.useRef)({
        [(0, $2feae68b8aa93f1b$export$417acab26efb42c7)]: ()=>{
            const state = getState();
            const currentCell = state.maze[state.self.location.y][state.self.location.x];
            const nextCell = (0, $3a4b4e5eb02e247c$export$fd3894fbe13374c)(state.maze, currentCell, state.self.direction);
            if (!nextCell || currentCell.walls[state.self.direction]) throw new Error("\u58C1\u304C\u3042\u308B\u305F\u3081\u3001\u9032\u3080\u3053\u3068\u304C\u3067\u304D\u307E\u305B\u3093\u3002");
            setState({
                ...state,
                self: {
                    ...state.self,
                    location: nextCell.location
                }
            });
            if (nextCell.location.x === goal.x && nextCell.location.y === goal.y) {
                setCleared(true);
                setShowClearDialog(true);
                throw new (0, $f94cb1d9064fd995$export$1760ba21304ed9c4)("\u8FF7\u8DEF\u3092\u30AF\u30EA\u30A2\u3057\u307E\u3057\u305F\uFF01");
            }
        },
        [(0, $2feae68b8aa93f1b$export$db53633f9be615e6)]: (direction)=>{
            const state = getState();
            return state.maze[state.self.location.y][state.self.location.x].walls[(0, $3a4b4e5eb02e247c$export$e383eb2094048976)(state.self.direction, direction)];
        },
        [(0, $2feae68b8aa93f1b$export$441456d754d206b4)]: (to)=>{
            const state = getState();
            setState({
                ...state,
                self: {
                    ...state.self,
                    direction: (0, $3a4b4e5eb02e247c$export$e383eb2094048976)(state.self.direction, to)
                }
            });
        }
    }).current;
    const [interval, setInterval] = (0, $acw62.useState)(100);
    const { workspaceAreaRef: workspaceAreaRef, highlightBlock: highlightBlock, getCode: getCode } = (0, $4bd570f5aeed71cd$export$c5f548d9c9fb836f)({
        toolboxDefinition: $9d87f333937ff966$var$toolboxDefinition
    });
    const interpreter = (0, $f94cb1d9064fd995$export$9e1c2a6f2489e8ee)({
        globalFunctions: globalFunctions,
        executionInterval: interval,
        onStep: highlightBlock
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4d98417e5915b90f$export$ef2184bd89960b14), {
                h: "100%",
                templateColumns: "1fr 25rem",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        ref: workspaceAreaRef
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7797ad21d1688bf5$export$e71c4d32a2263218), {
                        overflow: "auto",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7797ad21d1688bf5$export$e71c4d32a2263218), {
                                p: 4,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e250d4ac614c0cc4$export$d0d83eb3b3405895), {
                                    interpreter: interpreter,
                                    interval: interval,
                                    setInterval: setInterval,
                                    onStart: ()=>{
                                        interpreter.start(getCode());
                                    },
                                    onReset: ()=>{
                                        setState({
                                            ...getState(),
                                            self: $9d87f333937ff966$var$defaultSelf
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62e8dffda5e4bdb1$export$2e0a83ec2e27ecbb), {
                                my: 3
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7797ad21d1688bf5$export$e71c4d32a2263218), {
                                p: 4,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $27563f2a1a40a57c$export$caec2af78bcc877f), {
                                        mb: 5,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04559f41f2b32b9$export$4a143c8822a09fb4), {}),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd6b48874092fec3$export$d4feae172fccda11), {
                                                children: desc
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7797ad21d1688bf5$export$e71c4d32a2263218), {
                                        mb: 5,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f97c2b2f10b48128$export$956c3254a6ef7791), {
                                            maze: getState().maze,
                                            location: getState().self.location,
                                            direction: getState().self.direction
                                        })
                                    }),
                                    allowReset && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                        leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20f456d5883a34dd$export$f04a61298a47a40f), {
                                            as: (0, $0d9043722344d99e$export$6e5105d16c28709c)
                                        }),
                                        onClick: ()=>{
                                            setState($9d87f333937ff966$var$createDefaultState(w, h));
                                        },
                                        children: "\u65B0\u3057\u3044\u8FF7\u8DEF\u306B\u3059\u308B"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7797ad21d1688bf5$export$e71c4d32a2263218), {
                                pl: 4,
                                children: [
                                    prev && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                        onClick: prev,
                                        children: "\u524D\u306E\u30B9\u30C6\u30FC\u30B8\u3078"
                                    }),
                                    next && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc53aedf0bdeff61$export$353f5b6fc5456de1), {
                                        variant: cleared ? "solid" : "unstyled",
                                        onClick: next,
                                        px: 4,
                                        type: "button",
                                        transition: "color 0.2s, opacity 0.2s",
                                        colorScheme: "blue",
                                        children: "\u6B21\u306E\u30B9\u30C6\u30FC\u30B8\u3078"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $478074afe49969f1$export$f2b4b2283d43c1ca), {
                visible: showClearDialog,
                next: next ? ()=>{
                    setShowClearDialog(false);
                    next();
                } : null,
                onClose: ()=>setShowClearDialog(false),
                home: ()=>{
                    window.location.href = "https://festival.utcode.net";
                }
            })
        ]
    });
}


function $1ac9944b890fc1d2$export$2e2bcd8739ae039({ next: next }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d87f333937ff966$export$a048efcd1ba3d9f1), {
        height: 2,
        width: 3,
        description: "step1: \u77E2\u5370\u3092\u30B4\u30FC\u30EB\u307E\u3067\u79FB\u52D5\u3055\u305B\u3088\u3046",
        allowReset: false,
        prev: null,
        next: next
    });
}





function $ec93a477200d763c$export$ae01dedf5c052bb(props) {
    const { src: src, width: width = "80%", muted: muted = true, autoPlay: autoPlay = true, loop: loop = true } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("video", {
        src: src,
        muted: muted,
        autoPlay: autoPlay,
        loop: loop,
        width: typeof width === "number" ? `${width}px` : width
    });
}


var $fb248a482d54ffa0$exports = {};
$fb248a482d54ffa0$exports = new URL("maze-block.18afdd57.mp4", import.meta.url).toString();


var $bc8d6f27fbe09853$exports = {};
$bc8d6f27fbe09853$exports = new URL("maze-step1.5ff8de14.mp4", import.meta.url).toString();


const $d5591d08f77b81e0$export$1788037590f456a4 = [
    {
        title: "\u30D6\u30ED\u30C3\u30AF\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u306B\u3064\u3044\u3066",
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                    my: 2,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "\u300C\u521D\u3081\u3066\u306E\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0 \u8FF7\u8DEF\u300D\u306B\u3088\u3046\u3053\u305D\uFF01"
                        }),
                        "\u3053\u308C\u304B\u3089\u7686\u3055\u3093\u306B\u306F\u30D6\u30ED\u30C3\u30AF\u3092\u7D44\u307F\u5408\u308F\u305B\u3066\u3001\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u7D44\u3093\u3067\u3082\u3089\u3044\u307E\u3059\u3002 \u30D6\u30ED\u30C3\u30AF\u306F\u30DB\u30FC\u30EB\u30C9\u3057\u3066\u81EA\u7531\u306B\u914D\u7F6E\u3067\u304D\u3001\u5DE6\u5074\u306E\u30E1\u30CB\u30E5\u30FC\u306B\u306F\u3001\u69D8\u3005\u306A\u30D6\u30ED\u30C3\u30AF\u304C\u3042\u308A\u307E\u3059\u3002 \u30D6\u30ED\u30C3\u30AF\u3092\u99C6\u4F7F\u3057\u3066\u3001\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u3092\u4F53\u9A13\u3057\u3066\u307F\u307E\u3057\u3087\u3046\uFF01 \u3067\u306F\u3001\u53F3\u4E0B\u306E\u300C\u6B21\u3078\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3057\u3087\u3046\u3002"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec93a477200d763c$export$ae01dedf5c052bb), {
                    src: new URL($fb248a482d54ffa0$exports).toString()
                })
            ]
        })
    },
    {
        title: "\u30B4\u30FC\u30EB\u307E\u3067\u5230\u9054\u3057\u3088\u3046",
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                    my: 2,
                    children: "\u3055\u3063\u305D\u304F\u30D6\u30ED\u30C3\u30AF\u3092\u4E26\u3079\u3066\u3001\u8FF7\u8DEF\u5185\u306B\u3044\u308B\u8D64\u3044\u30A2\u30A4\u30B3\u30F3\u3092\u53F3\u4E0B\u306E\u65D7\u5370\u306E\u5834\u6240\u307E\u3067\u79FB\u52D5\u3055\u305B\u307E\u3057\u3087\u3046\u3002 \u306A\u304A\u3001\u3053\u306E\u6587\u7AE0\u304C\u66F8\u304B\u308C\u3066\u3044\u308B\u30DD\u30C3\u30D7\u30A2\u30C3\u30D7\u306F\u3001\u53F3\u4E0A\u306E\u300C\u30D8\u30EB\u30D7\u300D\u304B\u3089\u3044\u3064\u3067\u3082\u958B\u304F\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002 \u3044\u3064\u3067\u3082\u898B\u8FD4\u3057\u3066\u304F\u3060\u3055\u3044\u306D\u3002\u3067\u306F\u3001\u53F3\u4E0B\u306E\u300C\u306F\u3058\u3081\u308B\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\uFF01"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec93a477200d763c$export$ae01dedf5c052bb), {
                    src: new URL($bc8d6f27fbe09853$exports).toString()
                })
            ]
        })
    }
];
var $135eb419fc1af315$exports = {};
$135eb419fc1af315$exports = new URL("maze-step2.9f1df139.mp4", import.meta.url).toString();


const $d5591d08f77b81e0$export$30c608c84dc34af7 = [
    {
        title: "\u3044\u308D\u3093\u306A\u30D6\u30ED\u30C3\u30AF\u306B\u89E6\u308C\u3066\u307F\u307E\u3057\u3087\u3046\uFF01",
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                    my: 2,
                    children: "\u30B9\u30C6\u30FC\u30B8 1 \u306E\u30AF\u30EA\u30A2\u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01\u30D6\u30ED\u30C3\u30AF\u306E\u7D44\u307F\u65B9\u306F\u308F\u304B\u3063\u305F\u3067\u3057\u3087\u3046\u304B\uFF1F\u30B9\u30C6\u30FC\u30B8 2 \u3067\u306F\u8D64\u8272\u306E\u30D6\u30ED\u30C3\u30AF\u4EE5\u5916\u3082\u4F7F\u3063\u3066\u307F\u307E\u3057\u3087\u3046\uFF01\u4E00\u76F4\u7DDA\u306E\u8FF7\u8DEF\u3067\u3059\u304C\u3001\u30D6\u30ED\u30C3\u30AF\u3092\u7D44\u307F\u5408\u308F\u305B\u3066\u8272\u3005\u306A\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u7D44\u3080\u3053\u3068\u304C\u3067\u304D\u307E\u3059\uFF01\u3044\u308D\u3093\u306A\u30D6\u30ED\u30C3\u30AF\u306B\u89E6\u308C\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u306D"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec93a477200d763c$export$ae01dedf5c052bb), {
                    src: new URL($135eb419fc1af315$exports).toString()
                })
            ]
        })
    }
];
var $d6c97a6c958a5620$exports = {};
$d6c97a6c958a5620$exports = new URL("maze-advanced.8c3ae1b6.mp4", import.meta.url).toString();


var $5f57890c2d6bedd6$exports = {};
$5f57890c2d6bedd6$exports = new URL("maze-step3-2.e1b2a787.mp4", import.meta.url).toString();


var $bd7266a7ebca2ad9$exports = {};
$bd7266a7ebca2ad9$exports = new URL("maze-method.fb9e06a1.svg", import.meta.url).toString();


var $1f42f66a2472fadc$exports = {};
$1f42f66a2472fadc$exports = new URL("maze-step3-4.c05d6c5b.mp4", import.meta.url).toString();


const $d5591d08f77b81e0$export$f6e200dd188a5475 = [
    {
        title: "\u5C11\u3057\u96E3\u3057\u3044\u304B\u3082\uFF1F",
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                    my: 2,
                    children: "\u30B9\u30C6\u30FC\u30B8 2 \u306E\u30AF\u30EA\u30A2\u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u306E\u96F0\u56F2\u6C17\u304C\u3064\u304B\u3081\u3066\u304D\u305F\u3067\u3057\u3087\u3046\u304B\uFF1F\u30B9\u30C6\u30FC\u30B8 3 \u3067\u306F\u672C\u683C\u7684\u306A\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u3092\u8003\u3048\u308B\u3053\u3068\u306B\u306A\u308A\u307E\u3059\u3002\u3061\u3087\u3063\u3068\u96E3\u3057\u304F\u306A\u308A\u307E\u3059\u304C\u3001\u9811\u5F35\u3063\u3066\u3064\u3044\u3066\u304D\u3066\u304F\u3060\u3055\u3044\uFF01"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec93a477200d763c$export$ae01dedf5c052bb), {
                    src: new URL($d6c97a6c958a5620$exports).toString()
                })
            ]
        })
    },
    {
        title: "\u3069\u3093\u306A\u8FF7\u8DEF\u3067\u3082",
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                    my: 2,
                    children: [
                        "\u300C\u65B0\u3057\u3044\u8FF7\u8DEF\u306B\u3059\u308B\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u5168\u304F\u7570\u306A\u308B\u8FF7\u8DEF\u304C\u751F\u6210\u3055\u308C\u307E\u3059\u3002\u30B9\u30C6\u30FC\u30B8 3 \u3067\u306F\u7E70\u308A\u8FD4\u3057\u3084\u6761\u4EF6\u5206\u5C90\u3092\u3046\u307E\u304F\u4F7F\u7528\u3057\u3001",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "\u3069\u3093\u306A\u8FF7\u8DEF\u306B\u3082\u5BFE\u5FDC\u3067\u304D\u308B"
                        }),
                        "\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u4F5C\u308A\u307E\u3057\u3087\u3046\u3002"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec93a477200d763c$export$ae01dedf5c052bb), {
                    src: new URL($5f57890c2d6bedd6$exports).toString()
                })
            ]
        })
    },
    {
        title: "\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0",
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4d98417e5915b90f$export$ef2184bd89960b14), {
            templateColumns: "3fr 4fr",
            gap: 3,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7797ad21d1688bf5$export$e71c4d32a2263218), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                            my: 2,
                            children: "\u53E4\u6765\u304B\u3089\u77E5\u3089\u308C\u3066\u3044\u308B\u8FF7\u8DEF\u306E\u89E3\u6CD5\u306B\u3001\u300C\u5DE6\u624B\u6CD5\u300D\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u65B9\u6CD5\u3067\u306F\u3001\u30D7\u30EC\u30FC\u30E4\u30FC\u306F\u8FF7\u8DEF\u5185\u3067\u81EA\u5206\u306E\u624B\u3092\u5DE6\u306E\u58C1\u306B\u5F53\u3066\u3001\u305D\u306E\u307E\u307E\u96E2\u3055\u306A\u3044\u3088\u3046\u306B\u9032\u307F\u307E\u3059\u3002"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                            my: 2,
                            children: "\u30B7\u30F3\u30D7\u30EB\u306A\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u3067\u3059\u304C\u3001\u5CF6\u304C\u5B58\u5728\u3057\u306A\u3044\u5358\u7D14\u306A\u8FF7\u8DEF\u306F\u5FC5\u305A\u65B9\u6CD5\u3067\u89E3\u304F\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u7528\u610F\u3055\u308C\u305F\u30D6\u30ED\u30C3\u30AF\u306E\u307F\u3092\u7528\u3044\u3066\u300C\u5DE6\u624B\u6CD5\u300D\u306F\u3069\u306E\u3088\u3046\u306B\u8868\u73FE\u3055\u308C\u308B\u3067\u3057\u3087\u3046\u304B\u3002"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    width: "100%",
                    src: new URL($bd7266a7ebca2ad9$exports).toString(),
                    alt: "\u5DE6\u624B\u6CD5"
                })
            ]
        })
    },
    {
        title: "\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8",
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                    my: 2,
                    children: [
                        "\u30D6\u30ED\u30C3\u30AF\u306E\u4E00\u756A\u4E0B\u306B\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u304C\u7528\u610F\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u3053\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u306B",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "\u8D64\u8272\u306E\u30D6\u30ED\u30C3\u30AF\u3092 3 \u3064\u52A0\u3048\u308B"
                        }),
                        "\u3053\u3068\u3067\u3001\u3069\u3093\u306A\u8FF7\u8DEF\u306B\u3082\u5BFE\u5FDC\u3067\u304D\u308B\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u4F5C\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u5DE6\u624B\u6CD5\u3092\u610F\u8B58\u3057\u3066\u3001\u3044\u308D\u3044\u308D\u306A\u8FF7\u8DEF\u3092\u30AF\u30EA\u30A2\u3057\u3066\u307F\u307E\u3057\u3087\u3046\uFF01"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec93a477200d763c$export$ae01dedf5c052bb), {
                    src: new URL($1f42f66a2472fadc$exports).toString()
                })
            ]
        })
    }
];
var $8a3867cb0661ca81$exports = {};
$8a3867cb0661ca81$exports = new URL("maze-step4-1.ec0270e0.mp4", import.meta.url).toString();



var $7aa20195a720d42c$exports = {};
$7aa20195a720d42c$exports = new URL("maze-hint.419115dd.svg", import.meta.url).toString();


const $d5591d08f77b81e0$export$83074df8efeb4d46 = [
    {
        title: "\u6700\u7D42\u30B9\u30C6\u30FC\u30B8\uFF01",
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                    my: 2,
                    children: [
                        "\u30B9\u30C6\u30FC\u30B8 3 \u306E\u30AF\u30EA\u30A2\u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01\u6C4E\u7528\u7684\u306A\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u306F\u7D44\u3081\u305F\u3067\u3057\u3087\u3046\u304B\uFF1F\u6700\u7D42\u30B9\u30C6\u30FC\u30B8\u3067\u306F\u3001",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "\u81EA\u5206\u306E\u529B\u3067"
                        }),
                        "\u6C4E\u7528\u7684\u306A\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u3092\u4F5C\u3063\u3066\u3082\u3089\u3044\u307E\u3059\u3002\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3088\u308A\u3082\u5C11\u306A\u3044\u30D6\u30ED\u30C3\u30AF\u6570\u3067\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u3092\u4F5C\u3063\u3066\u307F\u307E\u3057\u3087\u3046\uFF01\u5B9F\u306F 6 \u500B\u306E\u30D6\u30ED\u30C3\u30AF\u3060\u3051\u3067\u3001\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u3092\u7D44\u3080\u3053\u3068\u3082\u3067\u304D\u308B\u3093\u3067\u3059\u3002\u305C\u3072\u6311\u6226\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u306D\uFF01"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec93a477200d763c$export$ae01dedf5c052bb), {
                    src: new URL($8a3867cb0661ca81$exports).toString()
                })
            ]
        })
    },
    {
        title: "\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0(\u518D\u63B2)",
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4d98417e5915b90f$export$ef2184bd89960b14), {
            templateColumns: "3fr 4fr",
            gap: 3,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7797ad21d1688bf5$export$e71c4d32a2263218), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                            my: 2,
                            children: "\u53E4\u6765\u304B\u3089\u77E5\u3089\u308C\u3066\u3044\u308B\u8FF7\u8DEF\u306E\u89E3\u6CD5\u306B\u3001\u300C\u5DE6\u624B\u6CD5\u300D\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u65B9\u6CD5\u3067\u306F\u3001\u30D7\u30EC\u30FC\u30E4\u30FC\u306F\u8FF7\u8DEF\u5185\u3067\u81EA\u5206\u306E\u624B\u3092\u5DE6\u306E\u58C1\u306B\u5F53\u3066\u3001\u305D\u306E\u307E\u307E\u96E2\u3055\u306A\u3044\u3088\u3046\u306B\u9032\u307F\u307E\u3059\u3002"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                            my: 2,
                            children: "\u30B7\u30F3\u30D7\u30EB\u306A\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u3067\u3059\u304C\u3001\u5CF6\u304C\u5B58\u5728\u3057\u306A\u3044\u5358\u7D14\u306A\u8FF7\u8DEF\u306F\u5FC5\u305A\u65B9\u6CD5\u3067\u89E3\u304F\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u7528\u610F\u3055\u308C\u305F\u30D6\u30ED\u30C3\u30AF\u306E\u307F\u3092\u7528\u3044\u3066\u300C\u5DE6\u624B\u6CD5\u300D\u306F\u3069\u306E\u3088\u3046\u306B\u8868\u73FE\u3055\u308C\u308B\u3067\u3057\u3087\u3046\u304B\u3002"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    width: "100%",
                    src: new URL($bd7266a7ebca2ad9$exports).toString(),
                    alt: "\u5DE6\u624B\u6CD5"
                })
            ]
        })
    },
    {
        title: "\u30D2\u30F3\u30C8",
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4d98417e5915b90f$export$ef2184bd89960b14), {
            templateColumns: "4fr 3fr",
            gap: 3,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    width: "100%",
                    src: new URL($7aa20195a720d42c$exports).toString(),
                    alt: "\u30D2\u30F3\u30C8"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7797ad21d1688bf5$export$e71c4d32a2263218), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                            my: 2,
                            children: "\u8FF7\u8DEF\u306B\u304A\u3044\u3066\u30D7\u30EC\u30FC\u30E4\u30FC\u304C\u6B69\u304B\u306A\u3051\u308C\u3070\u306A\u3089\u306A\u3044\u8DDD\u96E2\u306F\u975E\u5E38\u306B\u9577\u3044\u3067\u3059\u304C\u3001\u5B9F\u969B\u306F\u4E00\u6B69\u4E00\u6B69\u306E\u7A4D\u307F\u91CD\u306D\u306B\u3059\u304E\u307E\u305B\u3093\u3002\u3053\u306E\u4E00\u6B69\u3092\u3082\u3046\u5C11\u3057\u8A73\u3057\u304F\u898B\u3066\u307F\u307E\u3057\u3087\u3046\u3002"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                            my: 2,
                            children: "\u3044\u307E\u3001\u30D7\u30EC\u30FC\u30E4\u30FC\u306F\u5341\u5B57\u8DEF\u306B\u7ACB\u3063\u3066\u304A\u308A\u3001\u524D\u3001\u5F8C\u308D\u3001\u5DE6\u53F3\u306E\u3059\u3079\u3066\u306E\u65B9\u5411\u306B\u9032\u3080\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u3053\u306E\u3068\u304D\u3001\u5DE6\u624B\u6CD5\u306B\u5F93\u3046\u306E\u3067\u3042\u308C\u3070\u3001\u30D7\u30EC\u30FC\u30E4\u30FC\u306F\u3069\u3061\u3089\u306B\u9032\u3081\u3070\u3088\u3044\u3067\u3057\u3087\u3046\u304B\u3002"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                            my: 2,
                            children: "\u5DE6\u306E\u58C1\u306B\u6CBF\u3063\u3066\u9032\u3080\u306E\u3067\u3001\u5DE6\u65B9\u5411\u306B\u9032\u3080\u306E\u304C\u6B63\u89E3\u3067\u3059\u306D\u3002\u305D\u308C\u3067\u306F\u3001\u5DE6\u306B\u3082\u3057\u58C1\u304C\u3042\u3063\u305F\u3068\u3057\u305F\u3089\uFF1F\u305D\u306E\u5834\u5408\u306F\u307E\u3063\u3059\u3050\u9032\u3081\u3070\u826F\u3044\u306F\u305A\u3067\u3059\u3002"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b25b8f4dcda40b0b$export$5f1af8db9871e1d6), {
                            my: 2,
                            children: "\u540C\u3058\u3088\u3046\u306B\u8003\u3048\u3066\u3001\uFF14\u3064\u306E\u65B9\u5411\u306B\u300C\u512A\u5148\u9806\u4F4D\u300D\u3092\u3064\u3051\u3066\u307F\u307E\u3057\u3087\u3046\u3002\u58C1\u304C\u306A\u3044\u65B9\u5411\u306E\u3046\u3061\u3001\u6700\u3082\u512A\u5148\u9806\u4F4D\u304C\u9AD8\u3044\u65B9\u5411\u304C\u3001\u30D7\u30EC\u30FC\u30E4\u30FC\u304C\u9032\u3080\u3079\u304D\u9053\u3067\u3059\u3002"
                        })
                    ]
                })
            ]
        })
    }
];




function $6ee88ee9a1229d33$export$2e2bcd8739ae039({ prev: prev }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d87f333937ff966$export$a048efcd1ba3d9f1), {
        width: 8,
        height: 8,
        description: "\u81EA\u5206\u306E\u529B\u3067\u6C4E\u7528\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u3092\u4F5C\u3063\u3066\u307F\u3088\u3046",
        allowReset: true,
        prev: prev,
        next: null
    });
}




function $ef402d4e4a29470b$export$2e2bcd8739ae039({ prev: prev, next: next }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d87f333937ff966$export$a048efcd1ba3d9f1), {
        width: 5,
        height: 5,
        description: "\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u4F7F\u3063\u3066\u3001\u6C4E\u7528\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u3092\u69CB\u7BC9\u3057\u3088\u3046",
        allowReset: true,
        prev: prev,
        next: next
    });
}




function $45ccad0696c11a7a$export$2e2bcd8739ae039({ prev: prev, next: next }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d87f333937ff966$export$a048efcd1ba3d9f1), {
        height: 1,
        width: 5,
        description: "step2: \u3044\u308D\u3093\u306A\u30D6\u30ED\u30C3\u30AF\u3092\u4F7F\u3063\u3066\u307F\u3088\u3046",
        allowReset: false,
        prev: prev,
        next: next
    });
}


function $898f07d8c337fd8c$export$6c05c5050be0f1f7({ setHint: setHint }) {
    // TODO: consider using path based routing
    const [step, setStep] = (0, $acw62.useState)(1);
    (0, $acw62.useEffect)(()=>{
        if (!setHint) return;
        switch(step){
            case 1:
                return setHint((0, $d5591d08f77b81e0$export$1788037590f456a4));
            case 2:
                return setHint((0, $d5591d08f77b81e0$export$30c608c84dc34af7));
            case 3:
                return setHint((0, $d5591d08f77b81e0$export$f6e200dd188a5475));
            case 4:
                return setHint((0, $d5591d08f77b81e0$export$83074df8efeb4d46));
            default:
                step;
        }
    }, [
        step,
        setHint
    ]);
    switch(step){
        case 1:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ac9944b890fc1d2$export$2e2bcd8739ae039), {
                next: ()=>setStep(2)
            });
        case 2:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45ccad0696c11a7a$export$2e2bcd8739ae039), {
                prev: ()=>setStep(1),
                next: ()=>setStep(3)
            });
        case 3:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef402d4e4a29470b$export$2e2bcd8739ae039), {
                prev: ()=>setStep(2),
                next: ()=>setStep(4)
            });
        case 4:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ee88ee9a1229d33$export$2e2bcd8739ae039), {
                prev: ()=>setStep(3)
            });
        default:
            step;
    }
}




function $cd93687958c8007e$export$86fbec116b87613f() {
    const [hint, setHint] = (0, $acw62.useState)(null);
    const [isHintFirstView, setIsHintFirstView] = (0, $acw62.useState)(true);
    const [_, setHintVisible] = (0, $051474e5c5a9c9ad$exports.useAtom)((0, $ab97a3e9ca68f936$export$bd6c0303b4c07527));
    (0, $acw62.useEffect)(()=>{
        hint;
        setIsHintFirstView(true);
        setHintVisible(true);
    }, [
        hint,
        setHintVisible
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c9c8e7d0f56fe42$export$8545e3c0243374bc), {
        Hint: hint ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a815ea9477d173d2$export$9080f8affd01f933), {
            isFirstView: isHintFirstView,
            title: "\u8FF7\u8DEF",
            steps: hint,
            onClose: ()=>{
                setIsHintFirstView(false);
            }
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            children: "\u30D2\u30F3\u30C8\u306F\u3042\u308A\u307E\u305B\u3093"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $898f07d8c337fd8c$export$6c05c5050be0f1f7), {
            setHint: setHint
        })
    });
}


const $70fc9a727fa662ae$var$root = document.getElementById("root");
if (!$70fc9a727fa662ae$var$root) throw new Error("root \u8981\u7D20\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093");
(0, $7e96a608cb33bf79$export$882461b6382ed46c)($70fc9a727fa662ae$var$root).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f5c55c63aeaff4b$export$80dbe0482bcbd25a), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {})
        })
    })
}));


//# sourceMappingURL=index.c47db437.js.map
